var _slicedToArray = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toConsumableArray = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _assertThisInitialized = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _get = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/get");

var _possibleConstructorReturn = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var _defineProperty = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _classCallCheck = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Workspaces_2019\\NI\\NI\\NI\\react\\node_modules\\@babel\\runtime/helpers/createClass");

/* Smart HTML Elements v5.1.0 (2019-November) 
Copyright (c) 2011-2019 jQWidgets. 
License: https://htmlelements.com/license/ */
(function () {
  "use strict";

  function e(e, t) {
    var i = t.properties;
    t._properties = [];

    var a = function a(n, o) {
      var r = Object.keys(n);

      var _loop = function _loop(_l) {
        var i = r[_l],
            s = n[i];

        if (t._properties[o + i] = s, Array.isArray(s)) {
          t._properties[o + i] = new ObservableArray(s, function (t) {
            var a = i + "." + t.path,
                n = t.newValue,
                o = document.querySelector(e);

            if (o) {
              var _e = a.split(".");

              var _t = o;

              for (var _a = 0; _a < _e.length; _a++) {
                var _i = _e[_a];
                _t = _t[_i];
              }

              _t = n;
            }
          });
          return "continue";
        }

        (Object.defineProperty(n, i, {
          configurable: !1,
          enumerable: !0,
          get: function get() {
            return t._properties[o + i];
          },
          set: function set(e) {
            t._properties[o + i] = e;
          }
        }), !(s && "DataAdapter" === s.constructor.name)) && (s && "object" == typeof s && Smart.DataAdapter && s instanceof Smart.DataAdapter || "object" == typeof s && s && 0 < Object.keys(s).length && a(s, o + i + "."));
      };

      for (var _l = 0; _l < r.length; _l++) {
        var _ret = _loop(_l);

        if (_ret === "continue") continue;
      }
    };

    a(i, ""), Object.defineProperty(t, "properties", {
      configurable: !1,
      enumerable: !0,
      get: function get() {
        return i;
      }
    });
    var n = document.querySelector(e);
    if (n && n.isReady) for (var _e2 in i) {
      n[_e2] = i[_e2];
    }
  }

  var t = Math.floor,
      i = Math.asin,
      n = Math.abs,
      a = Math.sqrt,
      o = Math.pow,
      r = Math.sin,
      l = Math.cos,
      m = Math.PI,
      s = Math.max;
  var d = "5.1.0",
      c = [];
  var u = "Smart";

  if (window[u] && window[u].Version) {
    if (window[u].Version === d) return;
    if (window[u].Version !== d) u += d;else for (var _e3 = 2; window[u];) {
      u += _e3.toString(), _e3++;
    }
  }

  var p = -1 < navigator.userAgent.indexOf("Edge") && -1 < navigator.appVersion.indexOf("Edge");
  document.elementsFromPoint || (document.elementsFromPoint = document.msElementsFromPoint);

  var LocalizationModule =
  /*#__PURE__*/
  function () {
    function LocalizationModule() {
      _classCallCheck(this, LocalizationModule);
    }

    _createClass(LocalizationModule, [{
      key: "addMessages",
      value: function addMessages(e, t) {
        var i = this;
        Object.assign(i.messages[e], t);
      }
    }, {
      key: "localize",
      value: function localize(e, t) {
        var i = this;
        if (!i.messages || !i.messages[i.locale]) return;
        var a = i.messages[i.locale][e];
        if ("" === a) return "";

        if (a) {
          var _e4 = a;

          for (var _e5 in t) {
            var _i2 = t[_e5];
            a = a.replace(new RegExp("{{" + _e5 + "}}", "g"), _i2);
          }

          return i.localizeFormatFunction && i.localizeFormatFunction(_e4, a, t), a;
        }
      }
    }], [{
      key: "moduleName",
      get: function get() {
        return "LocalizationModule";
      }
    }, {
      key: "properties",
      get: function get() {
        return {
          messages: {
            value: {
              en: {}
            },
            type: "object",
            inherit: !0,
            reflectToAttribute: !1
          },
          locale: {
            value: "en",
            type: "string",
            reflectToAttribute: !1
          },
          localizeFormatFunction: {
            value: void 0,
            type: "function",
            reflectToAttribute: !1
          }
        };
      }
    }]);

    return LocalizationModule;
  }();

  var ErrorModule =
  /*#__PURE__*/
  function () {
    function ErrorModule() {
      _classCallCheck(this, ErrorModule);
    }

    _createClass(ErrorModule, [{
      key: "log",
      value: function log(e) {
        var t = this;

        t._logger("log", e);
      }
    }, {
      key: "warn",
      value: function warn(e) {
        var t = this;

        t._logger("warn", e);
      }
    }, {
      key: "error",
      value: function error(e) {
        var t = this;

        t._logger("error", e);
      }
    }, {
      key: "_logger",
      value: function _logger(e, t) {
        var i = this;

        if (i.debugMode) {
          var _i3 = t instanceof Error ? t.message : t.toString();

          console[e](_i3);
        }

        if (i.rethrowError && "error" === e) throw t;
      }
    }], [{
      key: "moduleName",
      get: function get() {
        return "ErrorModule";
      }
    }, {
      key: "properties",
      get: function get() {
        return {
          rethrowError: {
            value: !0,
            type: "boolean",
            reflectToAttribute: !1
          },
          debugMode: {
            value: !0,
            type: "boolean",
            reflectToAttribute: !1
          }
        };
      }
    }]);

    return ErrorModule;
  }();

  var BindingModule =
  /*#__PURE__*/
  function () {
    function BindingModule() {
      _classCallCheck(this, BindingModule);
    }

    _createClass(BindingModule, [{
      key: "getBindings",
      value: function getBindings(e, t) {
        var i = this;

        var a = 0,
            n = {},
            o = function (e) {
          if (e instanceof HTMLElement) return i.parseAttributes(e);else {
            var _t2 = i.parseProperty(e.data ? e.data.trim() : null, "textContent", e);

            if (_t2) return i.ownerElement && e.parentNode === i.ownerElement.$.content && (_t2.value = "" === i.ownerElement.$.html ? void 0 : i.ownerElement.$.html, i.ownerElement.innerHTML = ""), {
              textContent: _t2
            };
          }
        }(e);

        o && (n.data = o), t || (n.mapping = [], t = n), e.getAttribute && (n.nodeId = e.getAttribute("smart-id"), t && o && (t.mapping[n.nodeId] = o)), n.node = e, e.firstChild && (n.children = {});

        for (var _o = e.firstChild; _o; _o = _o.nextSibling) {
          n.children[a++] = i.getBindings(_o, t);
        }

        return n;
      }
    }, {
      key: "_addRemovePropertyBinding",
      value: function _addRemovePropertyBinding(e, t, i, a, n) {
        if (!e || !t || !i) return;
        var o = this,
            r = o.ownerElement.bindings,
            l = i.getAttribute("smart-id"),
            s = 0 <= e.indexOf("{{");
        e = e.replace("{{", "").replace("}}", "").replace("[[", "").replace("]]", "");
        var d = !1;
        0 <= e.indexOf("!") && (e = e.replace("!", ""), d = !0);
        var c = o.ownerElement._properties[e],
            m = {
          name: e,
          reflectToAttribute: c.reflectToAttribute,
          twoWay: s,
          type: c.type,
          not: d
        };

        if (n && !a) {
          var _i4 = {},
              _a2 = {
            name: e,
            targetPropertyName: t,
            reflectToAttribute: c.reflectToAttribute,
            twoWay: s,
            type: c.type,
            not: d
          };
          _i4[e] = _a2, r.mapping[l] = _i4;
        }

        var u = function u(e) {
          for (var _n in e) {
            var _r = e[_n];

            if (_r.nodeId === l) {
              _r.data || (_r.data = {}), a ? (_r.data[t] = null, delete _r.data[t]) : _r.data[t] = m;
              break;
            }

            if (_r.children) u(_r.children);else if (_r.node && _r.node.children && _r.node === i.parentElement) {
              var _e6 = _r.node;
              if (_e6.firstChild) _r.children = {};else continue;
              var _t3 = 0;

              for (var _i5 = _e6.firstChild; _i5; _i5 = _i5.nextSibling) {
                _r.children[_t3++] = o.getBindings(_i5);
              }

              u(_r.children);
            }
          }
        };

        u(r.children), a ? delete o.ownerElement.boundProperties[e] : o.ownerElement.boundProperties[e] = !0, o.updateBoundNodes(e);
      }
    }, {
      key: "addPropertyBinding",
      value: function addPropertyBinding(e, t, i, a) {
        var n = this;

        n._addRemovePropertyBinding(e, t, i, !1, a);
      }
    }, {
      key: "removePropertyBinding",
      value: function removePropertyBinding(e, t, i, a) {
        var n = this;

        n._addRemovePropertyBinding(e, t, i, !0, a);
      }
    }, {
      key: "parseAttributes",
      value: function parseAttributes(e) {
        var t = this;
        var a;

        for (var _n2 = 0; _n2 < e.attributes.length; _n2++) {
          var _i6 = e.attributes[_n2],
              _o2 = _i6.name,
              _r2 = _i6.value;
          BindingModule.cache["toCamelCase" + _o2] || (BindingModule.cache["toCamelCase" + _o2] = Utilities.Core.toCamelCase(_o2));
          var _l2 = BindingModule.cache["toCamelCase" + _o2];

          if (0 <= _o2.indexOf("(")) {
            var _i7 = _o2.substring(1, _o2.length - 1);

            if (t.ownerElement && !t.ownerElement.dataContext) {
              t.ownerElement.templateListeners[e.getAttribute("smart-id") + "." + _i7] = _r2, e.removeAttribute(_o2);
              continue;
            } else {
              a || (a = {});

              var _e7 = _r2.substring(0, _r2.indexOf("("));

              a[_l2] = {
                isEvent: !0,
                name: _i7,
                value: _e7
              };
              continue;
            }
          }

          var _s = t.parseProperty(_r2, _o2, e);

          _s && (a || (a = {}), a[_l2] = _s);
        }

        return a;
      }
    }, {
      key: "parseProperty",
      value: function parseProperty(e, t) {
        if (!e || !e.length) return;
        var i = this;
        var a = e.length,
            n = 0,
            o = 0,
            r = 0,
            l = !0,
            s;

        for (; o < a;) {
          n = e.indexOf("{{", o);

          var _t4 = e.indexOf("[[", o),
              _i8 = "}}";

          if (0 <= _t4 && (0 > n || _t4 < n) && (n = _t4, l = !1, _i8 = "]]"), r = 0 > n ? -1 : e.indexOf(_i8, n + 2), 0 > r) return;
          s = s || {};

          var _a3 = e.slice(n + 2, r).trim();

          s.name = _a3, o = r + 2;
        }

        var d = s.name,
            c = i.ownerElement ? i.ownerElement._properties[d] : null;
        if (s.twoWay = l, s.ready = !1, i.ownerElement && (0 <= d.indexOf("::") ? i.ownerElement.boundProperties[d.substring(0, d.indexOf("::"))] = !0 : i.ownerElement.boundProperties[d] = !0), c) s.type = c.type, s.reflectToAttribute = c.reflectToAttribute;else {
          s.type = 0 <= ["checked", "selected", "async", "autofocus", "autoplay", "controls", "defer", "disabled", "hidden", "ismap", "loop", "multiple", "open", "readonly", "required", "scoped"].indexOf(t) ? "boolean" : "string", s.reflectToAttribute = !0;
        }
        return s;
      }
    }, {
      key: "updateTextNodes",
      value: function updateTextNodes() {
        var e = this;
        e.updateTextNode(e.ownerElement.shadowRoot || e.ownerElement, e.ownerElement.bindings, e.ownerElement);
      }
    }, {
      key: "updateTextNode",
      value: function updateTextNode(e, t, i) {
        var a = this;
        if (!t) return;
        var n = 0;

        for (var _o3 = e.firstChild; _o3 && !!t.children; _o3 = _o3.nextSibling) {
          a.updateTextNode(_o3, t.children[n++], i);
        }

        if (t && t.data) for (var _e8 in t.data) {
          var _a4 = t.data[_e8],
              _n3 = _a4.name;
          "textContent" == _e8 && _a4.twoWay && !_a4.updating && void 0 !== _a4.value && (i[_n3] = _a4.value);
        }
      }
    }, {
      key: "updateBoundProperty",
      value: function updateBoundProperty(e, t) {
        if (t.updating) return;
        var i = this,
            a = i.ownerElement;
        t.updating = !0, a[e] = t.value, t.updating = !1;
      }
    }, {
      key: "updateBoundNodes",
      value: function updateBoundNodes(e) {
        var t = this;

        if (t.updateBoundNode(t.ownerElement.shadowRoot || t.ownerElement, t.ownerElement.bindings, t.ownerElement, e), 0 < t.ownerElement.detachedChildren.length) {
          var _loop2 = function _loop2(_a5) {
            var i = t.ownerElement.detachedChildren[_a5],
                n = i.getAttribute("smart-id"),
                o = function o(e) {
              if (e.nodeId === n) return e;

              for (var _t5 in e.children) {
                var _i9 = e.children[_t5],
                    _a6 = _i9.getAttribute ? _i9.getAttribute("smart-id") : "";

                if (_a6 === n) return e;

                if (_i9.children) {
                  var _e9 = o(_i9);

                  if (_e9) return _e9;
                }
              }

              return null;
            },
                r = o(t.ownerElement.bindings);

            if (r) t.updateBoundNode(i, r, t.ownerElement, e, !0);else if (i.getAttribute && t.ownerElement.bindings.mapping) {
              var _i10 = t.ownerElement,
                  _a7 = t.ownerElement.bindings;
              if (_a7) for (var _n4 in _a7.mapping) {
                var _o4 = _i10.querySelector("[smart-id=\"" + _n4 + "\"]");

                if (_o4) {
                  var _r3 = _a7.mapping[_n4];
                  t.updateBoundData(_o4, _r3, _i10, e);
                }
              }
            }
          };

          for (var _a5 = 0; _a5 < t.ownerElement.detachedChildren.length; _a5++) {
            _loop2(_a5);
          }
        }
      }
    }, {
      key: "updateBoundMappedNodes",
      value: function updateBoundMappedNodes() {
        var e = this,
            t = e.ownerElement.bindings,
            i = e.ownerElement;
        if (t.mapping) for (var _a8 in t.mapping) {
          var _n5 = i.querySelector("[smart-id=\"" + _a8 + "\"]");

          if (i.shadowRoot && (_n5 = i.querySelector("[id=\"" + _a8 + "\"]"), !_n5 && (_n5 = i.shadowRoot.querySelector("[id=\"" + _a8 + "\"]") || i.shadowRoot.querySelector("[smart-id=\"" + _a8 + "\"]"))), _n5) {
            var _o5 = t.mapping[_a8];
            e.updateBoundData(_n5, _o5, i);
          } else if (i.getAttribute("aria-controls")) {
            var _o6 = document.getElementById(i.getAttribute("aria-controls"));

            if (!_o6 && i.shadowRoot && (_o6 = i.shadowRoot.getElementById(i.getAttribute("aria-controls"))), _n5 = _o6.querySelector("[smart-id=\"" + _a8 + "\"]"), _n5) {
              var _o7 = t.mapping[_a8];
              e.updateBoundData(_n5, _o7, i);
            }
          }
        }
      }
    }, {
      key: "updateBoundNode",
      value: function updateBoundNode(e, t, i, a, n) {
        var o = this;
        if (!t) return;
        var r = 0;

        if (!n) {
          for (var _n6 = e.firstChild; _n6 && !!t.children; _n6 = _n6.nextSibling) {
            if (_n6.getAttribute) {
              (function () {
                var e = _n6.getAttribute("smart-id"),
                    l = function () {
                  for (var _i11 in t.children) {
                    if (t.children[_i11].nodeId === e) return t.children[_i11];
                  }
                }();

                o.updateBoundNode(_n6, l, i, a), r++;
              })();
            } else o.updateBoundNode(_n6, t.children[r++], i, a);
          }
        } else if (n && !t.data) for (var _l3 = e.firstChild; _l3 && !!t.children; _l3 = _l3.nextSibling) {
          if (_l3.getAttribute) {
            (function () {
              var e = _l3.getAttribute("smart-id"),
                  n = function () {
                for (var _i12 in t.children) {
                  if (t.children[_i12].nodeId === e) return t.children[_i12];
                }
              }();

              o.updateBoundNode(_l3, n, i, a), r++;
            })();
          } else o.updateBoundNode(_l3, t.children[r++], i, a, n);
        }

        if (t && t.data) {
          var _n7 = t.data;
          o.updateBoundData(e, _n7, i, a);
        }
      }
    }, {
      key: "updateBoundData",
      value: function updateBoundData(e, t, a, i) {
        var n = this;

        var _loop3 = function _loop3(_o8) {
          var r = t[_o8];
          var l = r.name;

          if (!r.updating && (0 <= l.indexOf("::") && (l = l.substring(0, l.indexOf("::"))), void 0 === i || i === l)) {
            if (0 <= l.indexOf("(")) {
              var _e10 = l.substring(l.indexOf("("));

              var _t6 = l.substring(0, l.indexOf("("));

              if (_e10 = _e10.substring(1, _e10.length - 1), _e10 = _e10.replace(/ /ig, ""), _e10 = _e10.split(","), 0 < _e10.length && "" !== _e10[0]) {
                var _n8 = [];

                for (var _t7 = 0; _t7 < _e10.length; _t7++) {
                  _n8.push(a[_e10[_t7]]);
                }

                r.value = a[_t6].apply(a, _n8);
              } else r.value = a[_t6]();

              r.type = typeof r.value;
            } else r.value = a[l];

            if ("innerHTML" === l ? e[_o8].toString().trim() !== a[l].toString().trim() && (r.ready ? e[_o8] = r.value.toString().trim() : a._properties[l].defaultValue !== r.value && (e[_o8] = r.value.toString().trim())) : r.not ? (e[_o8] = !r.value, r.targetPropertyName && (e[r.targetPropertyName] = !r.value)) : (e[_o8] = r.value, r.targetPropertyName && (e[r.targetPropertyName] = r.value)), e.$ && e.$.isNativeElement) {
              BindingModule.cache["toDash" + _o8] || (BindingModule.cache["toDash" + _o8] = Utilities.Core.toDash(_o8));

              var _t8 = BindingModule.cache["toDash" + _o8],
                  _i13 = e.$.getAttributeValue(_t8, r.type);

              r.reflectToAttribute && (_i13 !== r.value || !r.ready) && e.$.setAttributeValue(_t8, r.value, r.type), r.reflectToAttribute || e.$.setAttributeValue(_t8, null, r.type);
            }

            if (!r.ready) {
              if (e.$ && e.$.isCustomElement) {
                BindingModule.cache["toDash" + _o8] || (BindingModule.cache["toDash" + _o8] = Utilities.Core.toDash(_o8));
                var _t9 = BindingModule.cache["toDash" + _o8];
                e._properties || (e._beforeCreatedProperties = e._properties = e.propertyByAttributeName = []), e._properties[_o8] || (e._properties[_o8] = {
                  attributeName: _t9
                }, e._beforeCreatedProperties && (e._beforeCreatedProperties[_o8] = e._properties[_o8]), e.propertyByAttributeName[_t9] = e._properties[_o8]);
                var _i14 = e._properties[_o8];
                _i14.isUpdating = !0, r.reflectToAttribute && (r.not ? e.$.setAttributeValue(_i14.attributeName, !r.value, r.type) : e.$.setAttributeValue(_i14.attributeName, r.value, r.type)), r.reflectToAttribute || e.$.setAttributeValue(_i14.attributeName, null, r.type), _i14.isUpdating = !1;
              }

              if (r.twoWay) {
                var _t10 = function _t10(t) {
                  if (r.value = t, e.$ && e.$.isNativeElement) {
                    BindingModule.cache["toDash" + _o8] || (BindingModule.cache["toDash" + _o8] = Utilities.Core.toDash(_o8));

                    var _t11 = BindingModule.cache["toDash" + _o8],
                        _i15 = e.$.getAttributeValue(_t11, r.type);

                    r.reflectToAttribute && _i15 !== r.value && e.$.setAttributeValue(_t11, r.value, r.type), r.reflectToAttribute || e.$.setAttributeValue(_t11, null, r.type);
                  }
                };

                if (0 <= r.name.indexOf("::")) {
                  var _i16 = r.name.indexOf("::"),
                      _a9 = r.name.substring(_i16 + 2);

                  n.ownerElement["$" + e.getAttribute("smart-id")].listen(_a9, function () {
                    _t10(e[_o8]);

                    var i = r.name.substring(0, r.name.indexOf("::"));
                    n.updateBoundProperty(i, r);
                  });
                }

                if (e.$ && e.$.isCustomElement) {
                  e._properties[_o8] && (e._properties[_o8].notify = !0), BindingModule.cache["toDash" + _o8] || (BindingModule.cache["toDash" + _o8] = Utilities.Core.toDash(_o8));
                  var _i17 = BindingModule.cache["toDash" + _o8];
                  n.ownerElement["$" + e.getAttribute("smart-id")].listen(_i17 + "-changed", function (e) {
                    var i = e.detail;

                    _t10(i.value);

                    var a = n.ownerElement.context;
                    e.context !== document && (n.ownerElement.context = n.ownerElement), n.updateBoundProperty(r.name, r), n.ownerElement.context = a;
                  });
                }
              }
            }

            r.ready = !0;
          }
        };

        for (var _o8 in t) {
          _loop3(_o8);
        }
      }
    }], [{
      key: "clearCache",
      value: function clearCache() {
        var e = this;
        e.cache = {};
      }
    }, {
      key: "moduleName",
      get: function get() {
        return "BindingModule";
      }
    }]);

    return BindingModule;
  }();

  var Types =
  /*#__PURE__*/
  function () {
    function Types() {
      _classCallCheck(this, Types);
    }

    _createClass(Types, null, [{
      key: "isBoolean",
      value: function isBoolean(e) {
        return "boolean" == typeof e;
      }
    }, {
      key: "isFunction",
      value: function isFunction(e) {
        return !!(e && e.constructor && e.call && e.apply);
      }
    }, {
      key: "isArray",
      value: function isArray(e) {
        return Array.isArray(e);
      }
    }, {
      key: "isObject",
      value: function isObject(e) {
        var t = this;
        return e && ("object" == typeof e || t.isFunction(e)) || !1;
      }
    }, {
      key: "isDate",
      value: function isDate(e) {
        return e instanceof Date;
      }
    }, {
      key: "isString",
      value: function isString(e) {
        return "string" == typeof e;
      }
    }, {
      key: "isNumber",
      value: function isNumber(e) {
        return "number" == typeof e;
      }
    }, {
      key: "getType",
      value: function getType(e) {
        var t = this,
            i = ["Boolean", "Number", "String", "Function", "Array", "Date", "Object"].find(function (i) {
          if (t["is" + i](e)) return i;
        });
        return i ? i.toLowerCase() : void 0;
      }
    }]);

    return Types;
  }();

  var Ripple =
  /*#__PURE__*/
  function () {
    function Ripple() {
      _classCallCheck(this, Ripple);
    }

    _createClass(Ripple, null, [{
      key: "animate",
      value: function animate(e, t, i, a) {
        var n = e;
        if (!n || !1 == n instanceof HTMLElement) return;

        if (0 === n.getElementsByClassName("smart-ripple").length) {
          var _e11 = document.createElement("span");

          _e11.classList.add("smart-ripple"), _e11.setAttribute("role", "presentation");

          var _t12 = !0,
              _a10 = null;

          if (window[u].EnableShadowDOM && n.enableShadowDOM && !0 !== n.isInShadowDOM) {
            for (var _e12 = 0; _e12 < n.shadowRoot.host.shadowRoot.children.length; _e12++) {
              "link" !== n.shadowRoot.host.shadowRoot.children[_e12].tagName.toLowerCase() && (_a10 = n.shadowRoot.host.shadowRoot.children[_e12]);
            }

            n.shadowRoot.host.shadowRoot.querySelector(".smart-ripple") && (_t12 = !1);
          } else _a10 = n.firstElementChild;

          _t12 && (_a10 && !_a10.noRipple && 0 < _a10.offsetHeight ? _a10.appendChild(_e11) : n.appendChild(_e11));
        }

        var o = null;

        if (o = window[u].EnableShadowDOM && n.shadowRoot ? n.shadowRoot.host.shadowRoot.querySelector(".smart-ripple") : n.getElementsByClassName("smart-ripple")[0], !!o) {
          o.innerHTML = "", o.classList.remove("smart-animate"), o.style.height = o.style.width = s(n.offsetHeight, n.offsetWidth) + "px";

          var _e13 = window.getComputedStyle(o.parentElement),
              _r4 = parseInt(_e13.borderLeftWidth) || 0,
              _l4 = parseInt(_e13.borderTopWidth) || 0,
              _d = n.getBoundingClientRect(),
              _c = t - (_d.left + window.pageXOffset) - o.offsetWidth / 2 - _r4,
              _m = i - (_d.top + window.pageYOffset) - o.offsetHeight / 2 - _l4;

          o.style.left = _c + "px", o.style.top = _m + "px", o.classList.add("smart-animate"), o.addEventListener("animationend", function e() {
            o.parentElement && o.parentElement.removeChild(o), a && a(), o.removeEventListener("animationend", e), o.removeEventListener("animationcancel", e);
          }), o.addEventListener("animationcancel", function e() {
            o.parentElement && o.parentElement.removeChild(o), a && a(), o.removeEventListener("animationcancel", e), o.removeEventListener("animationend", e);
          });
        }
      }
    }]);

    return Ripple;
  }();

  var Easings =
  /*#__PURE__*/
  function () {
    function Easings() {
      _classCallCheck(this, Easings);
    }

    _createClass(Easings, null, [{
      key: "easeInQuad",
      value: function easeInQuad(e, i, a, n) {
        return a * (e /= n) * e + i;
      }
    }, {
      key: "easeOutQuad",
      value: function easeOutQuad(e, i, a, n) {
        return -a * (e /= n) * (e - 2) + i;
      }
    }, {
      key: "easeInOutQuad",
      value: function easeInOutQuad(e, i, a, n) {
        return 1 > (e /= n / 2) ? a / 2 * e * e + i : -a / 2 * (--e * (e - 2) - 1) + i;
      }
    }, {
      key: "easeInCubic",
      value: function easeInCubic(e, i, a, n) {
        return a * (e /= n) * e * e + i;
      }
    }, {
      key: "easeOutCubic",
      value: function easeOutCubic(e, i, a, n) {
        return a * ((e = e / n - 1) * e * e + 1) + i;
      }
    }, {
      key: "easeInOutCubic",
      value: function easeInOutCubic(e, i, a, n) {
        return 1 > (e /= n / 2) ? a / 2 * e * e * e + i : a / 2 * ((e -= 2) * e * e + 2) + i;
      }
    }, {
      key: "easeInQuart",
      value: function easeInQuart(e, i, a, n) {
        return a * (e /= n) * e * e * e + i;
      }
    }, {
      key: "easeOutQuart",
      value: function easeOutQuart(e, i, a, n) {
        return -a * ((e = e / n - 1) * e * e * e - 1) + i;
      }
    }, {
      key: "easeInOutQuart",
      value: function easeInOutQuart(e, i, a, n) {
        return 1 > (e /= n / 2) ? a / 2 * e * e * e * e + i : -a / 2 * ((e -= 2) * e * e * e - 2) + i;
      }
    }, {
      key: "easeInQuint",
      value: function easeInQuint(e, i, a, n) {
        return a * (e /= n) * e * e * e * e + i;
      }
    }, {
      key: "easeOutQuint",
      value: function easeOutQuint(e, i, a, n) {
        return a * ((e = e / n - 1) * e * e * e * e + 1) + i;
      }
    }, {
      key: "easeInOutQuint",
      value: function easeInOutQuint(e, i, a, n) {
        return 1 > (e /= n / 2) ? a / 2 * e * e * e * e * e + i : a / 2 * ((e -= 2) * e * e * e * e + 2) + i;
      }
    }, {
      key: "easeInSine",
      value: function easeInSine(e, t, i, a) {
        return -i * l(e / a * (m / 2)) + i + t;
      }
    }, {
      key: "easeOutSine",
      value: function easeOutSine(e, t, i, a) {
        return i * r(e / a * (m / 2)) + t;
      }
    }, {
      key: "easeInOutSine",
      value: function easeInOutSine(e, t, i, a) {
        return -i / 2 * (l(m * e / a) - 1) + t;
      }
    }, {
      key: "easeInExpo",
      value: function easeInExpo(e, t, i, a) {
        return 0 === e ? t : i * o(2, 10 * (e / a - 1)) + t;
      }
    }, {
      key: "easeOutExpo",
      value: function easeOutExpo(e, t, i, a) {
        return e === a ? t + i : i * (-o(2, -10 * e / a) + 1) + t;
      }
    }, {
      key: "easeInOutExpo",
      value: function easeInOutExpo(e, i, a, n) {
        return 0 === e ? i : e === n ? i + a : 1 > (e /= n / 2) ? a / 2 * o(2, 10 * (e - 1)) + i : a / 2 * (-o(2, -10 * --e) + 2) + i;
      }
    }, {
      key: "easeInCirc",
      value: function easeInCirc(e, i, n, o) {
        return -n * (a(1 - (e /= o) * e) - 1) + i;
      }
    }, {
      key: "easeOutCirc",
      value: function easeOutCirc(e, i, n, o) {
        return n * a(1 - (e = e / o - 1) * e) + i;
      }
    }, {
      key: "easeInOutCirc",
      value: function easeInOutCirc(e, i, n, o) {
        return 1 > (e /= o / 2) ? -n / 2 * (a(1 - e * e) - 1) + i : n / 2 * (a(1 - (e -= 2) * e) + 1) + i;
      }
    }, {
      key: "easeInElastic",
      value: function easeInElastic(e, l, u, c) {
        var d = 1.70158,
            g = 0,
            h = u;
        return 0 === e ? l : 1 === (e /= c) ? l + u : (g || (g = .3 * c), h < n(u) ? (h = u, d = g / 4) : d = g / (2 * m) * i(u / h), -(h * o(2, 10 * (e -= 1)) * r((e * c - d) * (2 * m) / g)) + l);
      }
    }, {
      key: "easeOutElastic",
      value: function easeOutElastic(e, l, u, c) {
        var d = 1.70158,
            g = 0,
            h = u;
        return 0 === e ? l : 1 === (e /= c) ? l + u : (g || (g = .3 * c), h < n(u) ? (h = u, d = g / 4) : d = g / (2 * m) * i(u / h), h * o(2, -10 * e) * r((e * c - d) * (2 * m) / g) + u + l);
      }
    }, {
      key: "easeInOutElastic",
      value: function easeInOutElastic(e, l, u, c) {
        var d = 1.70158,
            g = 0,
            h = u;
        return 0 === e ? l : 2 == (e /= c / 2) ? l + u : (g || (g = c * (1.5 * .3)), h < n(u) ? (h = u, d = g / 4) : d = g / (2 * m) * i(u / h), 1 > e ? -.5 * (h * o(2, 10 * (e -= 1)) * r((e * c - d) * (2 * m) / g)) + l : .5 * (h * o(2, -10 * (e -= 1)) * r((e * c - d) * (2 * m) / g)) + u + l);
      }
    }, {
      key: "easeInBack",
      value: function easeInBack(e, i, a, n, o) {
        return void 0 === o && (o = 1.70158), a * (e /= n) * e * ((o + 1) * e - o) + i;
      }
    }, {
      key: "easeOutBack",
      value: function easeOutBack(e, i, a, n, o) {
        return void 0 === o && (o = 1.70158), a * ((e = e / n - 1) * e * ((o + 1) * e + o) + 1) + i;
      }
    }, {
      key: "easeInOutBack",
      value: function easeInOutBack(e, i, a, n, o) {
        return void 0 === o && (o = 1.70158), 1 > (e /= n / 2) ? a / 2 * (e * e * (((o *= 1.525) + 1) * e - o)) + i : a / 2 * ((e -= 2) * e * (((o *= 1.525) + 1) * e + o) + 2) + i;
      }
    }, {
      key: "easeInBounce",
      value: function easeInBounce(e, t, i, a) {
        return i - this.easeOutBounce(a - e, 0, i, a) + t;
      }
    }, {
      key: "easeOutBounce",
      value: function easeOutBounce(e, i, a, n) {
        return (e /= n) < 1 / 2.75 ? a * (7.5625 * e * e) + i : e < 2 / 2.75 ? a * (7.5625 * (e -= 1.5 / 2.75) * e + .75) + i : e < 2.5 / 2.75 ? a * (7.5625 * (e -= 2.25 / 2.75) * e + .9375) + i : a * (7.5625 * (e -= 2.625 / 2.75) * e + .984375) + i;
      }
    }, {
      key: "easeInOutBounce",
      value: function easeInOutBounce(e, t, i, a) {
        return e < a / 2 ? .5 * this.easeInBounce(2 * e, 0, i, a) + t : .5 * this.easeOutBounce(2 * e - a, 0, i, a) + .5 * i + t;
      }
    }]);

    return Easings;
  }();

  var Core =
  /*#__PURE__*/
  function () {
    function Core() {
      _classCallCheck(this, Core);
    }

    _createClass(Core, null, [{
      key: "toCamelCase",
      value: function toCamelCase(e) {
        return e.replace(/-([a-z])/g, function (e) {
          return e[1].toUpperCase();
        });
      }
    }, {
      key: "toDash",
      value: function toDash(e) {
        return e.split(/(?=[A-Z])/).join("-").toLowerCase();
      }
    }, {
      key: "unescapeHTML",
      value: function unescapeHTML(e) {
        var t = new DOMParser().parseFromString(e, "text/html");
        return t.documentElement.textContent;
      }
    }, {
      key: "escapeHTML",
      value: function escapeHTML(e) {
        var t = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
          "/": "&#x2F;",
          "`": "&#x60;",
          "=": "&#x3D;"
        };
        return (e + "").replace(/[&<>"'`=\/]/g, function (e) {
          return t[e];
        });
      }
    }, {
      key: "createGUID",
      value: function createGUID() {
        function e() {
          return t(65536 * (1 + Math.random())).toString(16).substring(1);
        }

        return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
      }
    }, {
      key: "getScriptLocation",
      value: function getScriptLocation() {
        if ("./" !== window[u].BaseUrl) return window[u].BaseUrl;

        var e = function () {
          if (document.currentScript) {
            var _e14 = document.currentScript.src,
                _t13 = _e14.lastIndexOf("/");

            return _e14 = _e14.substring(0, _t13), _e14;
          }

          var e = new Error();
          var t = "(",
              i = ")";
          if (Smart.Utilities.Core.Browser.Safari && (t = "@", i = "\n"), e.fileName) return e.fileName.replace("/smart.element.js", "");
          var a = e.stack.split(t);
          return a = a[1], a = a.split(i)[0], a = a.split(":"), a.splice(-2, 2), a = a.join(":"), a.replace("/smart.element.js", "");
        }();

        return e;
      }
    }, {
      key: "CSSVariablesSupport",
      value: function CSSVariablesSupport() {
        return window.CSS && window.CSS.supports && window.CSS.supports("(--fake-var: 0)");
      }
    }, {
      key: "assign",
      value: function assign(e, t) {
        var _this = this;

        var i = function i(e) {
          return e && "object" == typeof e && !Array.isArray(e) && null !== e;
        };

        var a = Object.assign({}, e);
        return i(e) && i(t) && Object.keys(t).forEach(function (n) {
          i(t[n]) ? n in e ? a[n] = _this.assign(e[n], t[n]) : Object.assign(a, _defineProperty({}, n, t[n])) : Object.assign(a, _defineProperty({}, n, t[n]));
        }), a;
      }
    }, {
      key: "html",
      value: function html(e, t) {
        var i = this;
        var a = "",
            n = e.childNodes;

        if (t) {
          var _i18 = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi;
          return void (e.innerHTML = t.replace(_i18, "<$1></$2>"));
        }

        for (var _o9 = 0, _r5 = n.length, _l5; _o9 < _r5 && (_l5 = n[_o9]); _o9++) {
          if (_l5 instanceof HTMLElement || _l5.tagName && 0 <= ["strong"].indexOf(_l5.tagName.toLowerCase())) {
            var _e15 = _l5.tagName.toLowerCase(),
                _t14 = _l5.attributes;

            var _n9 = "<" + _e15;

            for (var _e16 = 0, _i19; _i19 = _t14[_e16]; _e16++) {
              _n9 += " " + _i19.name + "=\"" + _i19.value.replace(/[&\u00A0"]/g, Utilities.Core.escapeHTML) + "\"";
            }

            _n9 += ">";
            ["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"][_e15] && (a += _n9), a = a + _n9 + i.html(_l5) + "</" + _e15 + ">";
          } else a += _l5.textContent.replace(/[&\u00A0<>]/g, Utilities.Core.escapeHTML);
        }

        return a;
      }
    }, {
      key: "isMobile",
      get: function get() {
        var e = /(iphone|ipod|ipad|android|iemobile|blackberry|bada)/.test(window.navigator.userAgent.toLowerCase());
        return e;
      }
    }, {
      key: "Browser",
      get: function get() {
        var e;

        var t = function t(_t15) {
          var i = _t15.indexOf(e);

          if (-1 !== i) {
            var _a11 = _t15.indexOf("rv:");

            return "Trident" === e && -1 !== _a11 ? parseFloat(_t15.substring(_a11 + 3)) : parseFloat(_t15.substring(i + e.length + 1));
          }
        };

        var i = {};
        return i[function () {
          var t = [{
            string: navigator.userAgent,
            subString: "Edge",
            identity: "Edge"
          }, {
            string: navigator.userAgent,
            subString: "MSIE",
            identity: "IE"
          }, {
            string: navigator.userAgent,
            subString: "Trident",
            identity: "IE"
          }, {
            string: navigator.userAgent,
            subString: "Firefox",
            identity: "Firefox"
          }, {
            string: navigator.userAgent,
            subString: "Opera",
            identity: "Opera"
          }, {
            string: navigator.userAgent,
            subString: "OPR",
            identity: "Opera"
          }, {
            string: navigator.userAgent,
            subString: "Chrome",
            identity: "Chrome"
          }, {
            string: navigator.userAgent,
            subString: "Safari",
            identity: "Safari"
          }];

          for (var _a12 = 0, _i20; _a12 < t.length; _a12++) {
            if (_i20 = t[_a12].string, e = t[_a12].subString, -1 !== _i20.indexOf(t[_a12].subString)) return t[_a12].identity;
          }

          return "Other";
        }()] = !0, i.version = t(navigator.userAgent) || t(navigator.appVersion) || "Unknown", i;
      }
    }]);

    return Core;
  }();

  var g = [];

  var StyleObserver =
  /*#__PURE__*/
  function () {
    function StyleObserver() {
      _classCallCheck(this, StyleObserver);
    }

    _createClass(StyleObserver, null, [{
      key: "watch",
      value: function watch(e) {
        g.push(e), StyleObserver.interval && clearInterval(StyleObserver.interval), StyleObserver.interval = setInterval(function () {
          StyleObserver.observe();
        }, 100);
      }
    }, {
      key: "observeElement",
      value: function observeElement(e) {
        var t = e;
        var a = e._computedStyle || "resize" !== t.hasStyleObserver ? document.defaultView.getComputedStyle(t, null) : {},
            i = !0,
            n = "resize" === t.hasStyleObserver ? [] : ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth", "display", "visibility", "font-size", "font-family", "font-style", "font-weight", "max-height", "min-height", "max-width", "min-width", "overflow", "overflow-x", "overflow-y"];

        if (e.styleProperties && (n = n.concat(e.styleProperties)), e.observableStyleProperties && (n = e.observableStyleProperties), !t._styleInfo) {
          t._styleInfo = [];

          for (var _e17 = 0; _e17 < n.length; _e17++) {
            var _i21 = n[_e17];
            t._styleInfo[_i21] = a[_i21];
          }

          return;
        }

        if (e.isHidden || "none" === a.display || 0 !== e.offsetWidth && 0 !== e.offsetHeight || (e.isHidden = !0), e.isHidden) if (e.visibilityChangedHandler(), !e.isHidden) i = !1;else return;
        var o = [];

        for (var _r6 = 0; _r6 < n.length; _r6++) {
          var _e18 = n[_r6];
          t._styleInfo[_e18] !== a[_e18] && (o[_e18] = {
            oldValue: t._styleInfo[_e18],
            value: a[_e18]
          }, o.length++), t._styleInfo[_e18] = a[_e18];
        }

        0 < o.length && (t.$.fireEvent("styleChanged", {
          styleProperties: o
        }, {
          bubbles: !1,
          cancelable: !0
        }), o.display && i && t.$.fireEvent("resize", t, {
          bubbles: !1,
          cancelable: !0
        }));
      }
    }, {
      key: "observe",
      value: function observe() {
        for (var _e19 = 0; _e19 < g.length; _e19++) {
          var _t16 = g[_e19];
          this.observeElement(_t16);
        }
      }
    }, {
      key: "unwatch",
      value: function unwatch(e) {
        StyleObserver.interval && clearInterval(StyleObserver.interval);
        var t = g.indexOf(e);
        -1 !== t && g.splice(t, 1), 0 < g.length && (StyleObserver.interval = setInterval(function () {
          StyleObserver.observe();
        }, 100));
      }
    }]);

    return StyleObserver;
  }();

  var h = [];
  var _ = [],
      f = ["resize", "down", "up", "move", "tap", "taphold", "swipeleft", "swiperight", "swipetop", "swipebottom"];

  var InputEvents =
  /*#__PURE__*/
  function () {
    function InputEvents(e) {
      _classCallCheck(this, InputEvents);

      var t = this;
      t.target = e, t.$target = new _Extend(e), t.$document = e.$document ? e.$document : new _Extend(document), t.id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
      var i = {
        handlers: {},
        boundEventTypes: [],
        listen: t.listen.bind(t),
        unlisten: t.unlisten.bind(t)
      };
      return t.tapHoldDelay = 750, t.swipeMin = 10, t.swipeMax = 5e3, t.swipeDelay = 1e3, t.tapHoldDelay = 750, t.inputEventProperties = ["clientX", "clientY", "pageX", "pageY", "screenX", "screenY"], f.forEach(function (e) {
        i[e] = function (t) {
          i.handlers[e] = t;
        }, t[e] = function (e) {
          if (!i.handlers[e.type]) {
            if (("mousemove" === e.type || "pointermove" === e.type || "touchmove" === e.type) && i.handlers.move) {
              var _a13 = t.createEvent(e, "move");

              i.handlers.move(_a13);
            }

            return !0;
          }

          return i.handlers[e.type](e);
        };
      }), t.listen(), t.handlers = i.handlers, i;
    }

    _createClass(InputEvents, [{
      key: "listen",
      value: function listen(e) {
        var t = this;

        if ("resize" === e && !t.target.resizeTrigger && t.target !== document && t.target !== window && !1 !== t.target.hasResizeObserver) {
          var _e20 = document.createElement("div");

          _e20.className = "smart-resize-trigger-container", _e20.innerHTML = "<div class=\"smart-resize-trigger-container\"><div class=\"smart-resize-trigger\"></div></div><div class=\"smart-resize-trigger-container\"><div class=\"smart-resize-trigger-shrink\"></div></div>", _e20.setAttribute("aria-hidden", !0), window[u].EnableShadowDOM && t.target.shadowRoot ? t.target.shadowRoot.appendChild(_e20) : t.target.appendChild(_e20), t.target.resizeTrigger = _e20;

          var _i22 = _e20.childNodes[0],
              _a14 = _i22.childNodes[0],
              _n10 = _e20.childNodes[1],
              _o10 = function _o10() {
            _a14.style.width = "100000px", _a14.style.height = "100000px", _i22.scrollLeft = 1e5, _i22.scrollTop = 1e5, _n10.scrollLeft = 1e5, _n10.scrollTop = 1e5;
          };

          var _r7 = t.target.offsetWidth,
              _l6 = t.target.offsetHeight,
              _s2,
              _d2,
              _c2,
              _m2;

          if (0 === _r7 || 0 === _l6) {
            var _e21 = function _e21() {
              _o10(), t.target.removeEventListener("resize", _e21);
            };

            t.target.addEventListener("resize", _e21), _o10();
          } else _o10();

          t.target.resizeHandler = function () {
            _d2 || (_d2 = requestAnimationFrame(function () {
              if (_d2 = 0, _c2 = t.target.offsetWidth, _m2 = t.target.offsetHeight, _s2 = _c2 !== _r7 || _m2 !== _l6, t.target.requiresLayout && (_s2 = !0), !!_s2) {
                _r7 = _c2, _l6 = _m2;

                var _e22 = new CustomEvent("resize", {
                  bubbles: !1,
                  cancelable: !0
                });

                t.resize(_e22), t.target.requiresLayout = !1;
              }
            })), _o10();
          }, _i22.addEventListener("scroll", t.target.resizeHandler), _n10.addEventListener("scroll", t.target.resizeHandler);
        }

        if (!t.isListening) {
          if (t.isListening = !0, t.isPressed = !1, t.isReleased = !1, t.isInBounds = !1, window.PointerEvent) t.$target.listen("pointerdown.inputEvents" + t.id, t.pointerDown.bind(t)), t.$target.listen("pointerup.inputEvents" + t.id, t.pointerUp.bind(t)), t.$target.listen("pointermove.inputEvents" + t.id, t.pointerMove.bind(t)), t.$target.listen("pointercancel.inputEvents" + t.id, t.pointerCancel.bind(t));else {
            var _e23 = "ontouchstart" in window;

            _e23 && (t.$target.listen("touchmove.inputEvents" + t.id, t.touchMove.bind(t)), t.$target.listen("touchstart.inputEvents" + t.id, t.touchStart.bind(t)), t.$target.listen("touchend.inputEvents" + t.id, t.touchEnd.bind(t)), t.$target.listen("touchcancel.inputEvents" + t.id, t.touchCancel.bind(t))), t.$target.listen("mousedown.inputEvents" + t.id, t.mouseDown.bind(t)), t.$target.listen("mouseup.inputEvents" + t.id, t.mouseUp.bind(t)), t.$target.listen("mousemove.inputEvents" + t.id, t.mouseMove.bind(t)), t.$target.listen("mouseleave.inputEvents" + t.id, t.mouseLeave.bind(t));
          }
          t.target._handleDocumentUp || (t.target._handleDocumentUp = t.handleDocumentUp.bind(t), t.target._handleDocumentUpId = t.id, t.$document.listen("mouseup.inputEvents" + t.target._handleDocumentUpId, t.target._handleDocumentUp));
        }
      }
    }, {
      key: "unlisten",
      value: function unlisten(e) {
        var t = this;
        if (t.isListening = !1, window.PointerEvent) t.$target.unlisten("pointerdown.inputEvents" + t.id), t.$target.unlisten("pointerup.inputEvents" + t.id), t.$target.unlisten("pointermove.inputEvents" + t.id), t.$target.unlisten("pointercancel.inputEvents" + t.id);else {
          var _e24 = "ontouchstart" in window;

          _e24 && (t.$target.unlisten("touchstart.inputEvents" + t.id), t.$target.unlisten("touchmove.inputEvents" + t.id), t.$target.unlisten("touchend.inputEvents" + t.id), t.$target.unlisten("touchcancel.inputEvents" + t.id)), t.$target.unlisten("mousedown.inputEvents" + t.id), t.$target.unlisten("mouseup.inputEvents" + t.id), t.$target.unlisten("mousemove.inputEvents" + t.id), t.$target.unlisten("mouseleave.inputEvents" + t.id);
        }

        if (t.target._handleDocumentUp && (t.$document.unlisten("mouseup.inputEvents" + t.target._handleDocumentUpId, t.target._handleDocumentUp), delete t.target._handleDocumentUp, delete t.target._handleDocumentUpId), "resize" === e && t.target.resizeTrigger) {
          var _e25 = t.target.resizeTrigger,
              _i23 = _e25.childNodes[0],
              _a15 = _e25.childNodes[1];
          _i23.removeEventListener("scroll", t.target.resizeHandler), _a15.removeEventListener("scroll", t.target.resizeHandler), t.target.resizeHandler = null, _e25.parentNode.removeChild(_e25), delete t.target.resizeTrigger;
        }
      }
    }, {
      key: "handleDocumentUp",
      value: function handleDocumentUp(e) {
        var t = this;
        t.isPressed = !1, t.isReleased = !1, t.resetSwipe(e);
      }
    }, {
      key: "createEvent",
      value: function createEvent(e, t) {
        var i = this,
            a = e.touches,
            n = e.changedTouches,
            o = a && a.length ? a[0] : n && n.length ? n[0] : void 0,
            r = new CustomEvent(t, {
          bubbles: !0,
          cancelable: !0,
          composed: void 0 !== i.$target.element.getRootNode().host
        });

        if (r.originalEvent = e, o) {
          for (var _e26 = 0; _e26 < i.inputEventProperties.length; _e26++) {
            var _t17 = i.inputEventProperties[_e26];
            r[_t17] = o[_t17];
          }

          return r;
        }

        for (var _i24 in e) {
          _i24 in r || (r[_i24] = e[_i24]);
        }

        return r;
      }
    }, {
      key: "fireTap",
      value: function fireTap(e) {
        var t = this;

        if (clearTimeout(this.tapHoldTimeout), !this.tapHoldFired && this.isInBounds) {
          var _i25 = t.createEvent(e, "tap");

          t.tap(_i25);
        }
      }
    }, {
      key: "initTap",
      value: function initTap(e) {
        var t = this;
        t.isInBounds = !0, t.tapHoldFired = !1, t.tapHoldTimeout = setTimeout(function () {
          if (t.isInBounds) {
            t.tapHoldFired = !0;

            var _i26 = t.createEvent(e, "taphold");

            t.taphold(_i26);
          }
        }, t.tapHoldDelay);
      }
    }, {
      key: "pointerDown",
      value: function pointerDown(e) {
        var t = this;
        return t.handleDown(e);
      }
    }, {
      key: "mouseDown",
      value: function mouseDown(e) {
        var t = this;
        return t.isPressed || t.touchStartTime && 500 > new Date() - t.touchStartTime ? void 0 : t.handleDown(e);
      }
    }, {
      key: "touchStart",
      value: function touchStart(e) {
        var t = this;
        return t.touchStartTime = new Date(), t.isTouchMoved = !0, t.handleDown(e);
      }
    }, {
      key: "mouseUp",
      value: function mouseUp(e) {
        var t = this;
        return t.isReleased || t.touchEndTime && 500 > new Date() - t.touchEndTime ? void 0 : t.handleUp(e);
      }
    }, {
      key: "handleDown",
      value: function handleDown(e) {
        var t = this;
        t.isReleased = !1, t.isPressed = !0;
        var i = t.createEvent(e, "down");
        return (t.handlers.tap || t.handlers.taphold) && t.initTap(i), (t.handlers.swipeleft || t.handlers.swiperight || t.handlers.swipetop || t.handlers.swipebottom) && t.initSwipe(i), t.down(i);
      }
    }, {
      key: "handleUp",
      value: function handleUp(e) {
        var t = this;
        t.isReleased = !0, t.isPressed = !1;
        var i = t.createEvent(e, "up"),
            a = t.up(i);
        return (t.handlers.tap || t.handlers.taphold) && t.fireTap(i), t.resetSwipe(i), a;
      }
    }, {
      key: "handleMove",
      value: function handleMove(e) {
        var t = this;
        var i = t.move(e);
        return t.isPressed && (t._maxSwipeVerticalDistance = s(t._maxSwipeVerticalDistance, n(t._startY - e.pageY)), t._maxSwipeHorizontalDistance = s(t._maxSwipeHorizontalDistance, n(t._startX - e.pageX)), i = t.handleSwipeEvents(e)), i;
      }
    }, {
      key: "touchEnd",
      value: function touchEnd(e) {
        var t = this;
        return t.touchEndTime = new Date(), t.handleUp(e);
      }
    }, {
      key: "pointerUp",
      value: function pointerUp(e) {
        var t = this;
        return t.handleUp(e);
      }
    }, {
      key: "pointerCancel",
      value: function pointerCancel(e) {
        var t = this;
        t.pointerUp(e);
      }
    }, {
      key: "touchCancel",
      value: function touchCancel(e) {
        var t = this;
        t.touchEnd(e);
      }
    }, {
      key: "mouseLeave",
      value: function mouseLeave() {
        var e = this;
        e.isInBounds = !1;
      }
    }, {
      key: "mouseMove",
      value: function mouseMove(e) {
        var t = this;
        return t.isTouchMoved ? void 0 : t.handleMove(e);
      }
    }, {
      key: "pointerMove",
      value: function pointerMove(e) {
        var t = this;
        return t.handleMove(e);
      }
    }, {
      key: "touchMove",
      value: function touchMove(e) {
        var t = this,
            i = e.touches,
            a = e.changedTouches,
            n = i && i.length ? i[0] : a && a.length ? a[0] : void 0;

        for (var _i27 = 0; _i27 < t.inputEventProperties.length; _i27++) {
          var _a16 = t.inputEventProperties[_i27];
          void 0 === e[_a16] && (e[_a16] = n[_a16]);
        }

        return t.isTouchMoved = !0, t.handleMove(e);
      }
    }, {
      key: "handleSwipeEvents",
      value: function handleSwipeEvents(e) {
        var t = this;
        var i = !0;
        return ((t.handlers.swipetop || t.handlers.swipebottom) && (i = this.handleVerticalSwipeEvents(e)), !1 === i) ? i : ((t.handlers.swipeleft || t.handlers.swiperight) && (i = this.handleHorizontalSwipeEvents(e)), i);
      }
    }, {
      key: "handleVerticalSwipeEvents",
      value: function handleVerticalSwipeEvents(e) {
        var t, i;
        return t = e.pageY, i = t - this._startY, this.swiped(e, i, "vertical");
      }
    }, {
      key: "handleHorizontalSwipeEvents",
      value: function handleHorizontalSwipeEvents(e) {
        var t, i;
        return t = e.pageX, i = t - this._startX, this.swiped(e, i, "horizontal");
      }
    }, {
      key: "swiped",
      value: function swiped(e, t, i) {
        var a = this;

        if (i = i || 0, n(t) >= a.swipeMin && !a._swipeEvent && !a._swipeLocked) {
          var _o11 = 0 > t ? "swipeleft" : "swiperight";

          if ("horizontal" === i ? a._swipeEvent = a.createEvent(e, _o11) : (_o11 = 0 > t ? "swipetop" : "swipebottom", a._swipeEvent = a.createEvent(e, 0 > t ? "swipetop" : "swipebottom")), a[_o11] && (a[_o11](this._swipeEvent), n(t) <= this.swipeMax)) return e.stopImmediatePropagation(), !1;
        }

        return !0;
      }
    }, {
      key: "resetSwipe",
      value: function resetSwipe() {
        var e = this;
        e._swipeEvent = null, clearTimeout(this._swipeTimeout);
      }
    }, {
      key: "initSwipe",
      value: function initSwipe(e) {
        var t = this;
        t._maxSwipeVerticalDistance = 0, t._maxSwipeHorizontalDistance = 0, t._startX = e.pageX, t._startY = e.pageY, t._swipeLocked = !1, t._swipeEvent = null, t._swipeTimeout = setTimeout(function () {
          t._swipeLocked = !0;
        }, t.swipeDelay);
      }
    }]);

    return InputEvents;
  }();

  var Scroll =
  /*#__PURE__*/
  function () {
    _createClass(Scroll, [{
      key: "scrollWidth",
      get: function get() {
        var e = this;
        return e.horizontalScrollBar ? e.horizontalScrollBar.max : -1;
      },
      set: function set(e) {
        var t = this;
        0 > e && (e = 0), t.horizontalScrollBar && (t.horizontalScrollBar.max = e);
      }
    }, {
      key: "scrollHeight",
      get: function get() {
        var e = this;
        return e.verticalScrollBar ? e.verticalScrollBar.max : -1;
      },
      set: function set(e) {
        var t = this;
        0 > e && (e = 0), t.verticalScrollBar && (t.verticalScrollBar.max = e);
      }
    }, {
      key: "scrollLeft",
      get: function get() {
        var e = this;
        return e.horizontalScrollBar ? e.horizontalScrollBar.value : -1;
      },
      set: function set(e) {
        var t = this;
        0 > e && (e = 0), t.horizontalScrollBar && (t.horizontalScrollBar.value = e);
      }
    }, {
      key: "scrollTop",
      get: function get() {
        var e = this;
        return e.verticalScrollBar ? e.verticalScrollBar.value : -1;
      },
      set: function set(e) {
        var t = this;
        0 > e && (e = 0), t.verticalScrollBar && (t.verticalScrollBar.value = e);
      }
    }, {
      key: "vScrollBar",
      get: function get() {
        var e = this;
        return e.verticalScrollBar;
      }
    }, {
      key: "hScrollBar",
      get: function get() {
        var e = this;
        return e.horizontalScrollBar;
      }
    }]);

    function Scroll(e, t, i) {
      _classCallCheck(this, Scroll);

      var a = this;
      a.container = e, a.horizontalScrollBar = t, a.verticalScrollBar = i, a.disableSwipeScroll = !1, a.listen();
    }

    _createClass(Scroll, [{
      key: "listen",
      value: function listen() {
        function e() {
          var a, n;
          h.amplitude && (i.container.$.fireEvent("kineticScroll"), a = Date.now() - m, n = -h.amplitude * t(-a / l), 5 < n || -5 > n ? (v(h.targetValue + n), cancelAnimationFrame(d), d = 0, d = requestAnimationFrame(e)) : v(h.targetValue));
        }

        var t = Math.exp;
        var i = this,
            a = Core.isMobile,
            o = i.horizontalScrollBar,
            r = i.verticalScrollBar;
        i.inputEvents = new InputEvents(i.container);
        var l = 500,
            s,
            d,
            c,
            m,
            u,
            p,
            g,
            h;

        var _ = function _(e) {
          return {
            amplitude: 0,
            delta: 0,
            initialValue: 0,
            min: 0,
            max: e.max,
            previousValue: 0,
            pointerPosition: 0,
            targetValue: 0,
            scrollBar: e,
            value: 0,
            velocity: 0
          };
        },
            f = _(o),
            b = _(r),
            y = function y() {
          p = Date.now(), g = p - m, m = p;

          var e = function e(_e27) {
            _e27.delta = _e27.value - _e27.previousValue, _e27.previousValue = _e27.value;
            var t = 1e3 * _e27.delta / (1 + g);
            _e27.velocity = .8 * t + .2 * _e27.velocity;
          };

          e(b), e(f);
        },
            v = function v(e) {
          return h.value = e > h.max ? h.max : e < h.min ? h.min : e, h.scrollBar.value = h.value, e > h.max ? "max" : e < h.min ? "min" : "value";
        };

        i.inputEvents.down(function (e) {
          if (a) {
            var _t18 = e.originalEvent.target,
                _a17 = _t18 && _t18.closest ? _t18.closest("smart-scroll-bar") : void 0;

            if (_a17 !== i.horizontalScrollBar && _a17 !== i.verticalScrollBar) {
              c = !0, s = !1;

              var _t19 = function _t19(e, t) {
                e.amplitude = 0, e.pointerPosition = t, e.previousValue = e.value, e.value = e.scrollBar.value, e.initialValue = e.value, e.max = e.scrollBar.max;
              };

              _t19(b, e.clientY), _t19(f, e.clientX), m = Date.now(), clearInterval(u), u = setInterval(y, l);
            }
          }
        }), i.inputEvents.up(function () {
          if (!c) return !0;
          if (clearInterval(u), i.disableSwipeScroll) return void (c = !1);

          var t = function t(_t20) {
            h = _t20, _t20.amplitude = .8 * _t20.velocity, _t20.targetValue = Math.round(_t20.value + _t20.amplitude), m = Date.now(), cancelAnimationFrame(d), d = requestAnimationFrame(e), _t20.velocity = 0;
          };

          10 < b.velocity || -10 > b.velocity ? t(b) : (10 < f.velocity || -10 > f.velocity) && t(f), c = !1;
        }), i.inputEvents.move(function (e) {
          if (!c) return !0;
          if (i.disableSwipeScroll) return;
          if (s && (e.originalEvent.preventDefault(), e.originalEvent.stopPropagation()), f.visible = 0 < o.offsetHeight, b.visible = 0 < r.offsetWidth, !c || !f.visible && !b.visible) return;
          b.ratio = -b.max / b.scrollBar.offsetHeight, b.delta = (e.clientY - b.pointerPosition) * b.ratio, f.ratio = -f.max / f.scrollBar.offsetWidth, f.delta = (e.clientX - f.pointerPosition) * f.ratio;
          var t = "value";

          var a = function a(e, _a18, n) {
            return 5 < e.delta || -5 > e.delta ? (h = e, t = e.initialValue + e.delta > h.max ? "max" : e.initialValue + e.delta < h.min ? "min" : "value", "min" == t && 0 === e.initialValue) || "max" == t && e.initialValue === e.max || !e.visible || (i.container.$.fireEvent("kineticScroll"), v(e.initialValue + e.delta), y(), n.originalEvent.preventDefault(), n.originalEvent.stopPropagation(), s = !0, !1) : null;
          };

          var n = a(b, e.clientY, e);

          if (null === n) {
            var _t21 = a(f, e.clientX, e);

            if (null !== _t21) return _t21;
          } else return n;
        });
        var w;
        i.scrollTo = function (e, a) {
          var o = !1 === a ? f : b;
          var r = !1;
          m || (m = Date.now()), w || (w = Date.now()), 375 < n(Date.now() - w) ? m = Date.now() : r = !0, w = Date.now(), o.value = o.scrollBar.value, o.delta = e - o.value, o.max = o.scrollBar.max, e <= o.min && (e = o.min), e >= o.max && (e = o.max), o.targetValue = e;
          var l = e;
          var s = o.value;
          o.velocity = 100 * o.delta / (1 + o.max), o.from = s;

          var c = function c(e) {
            return o.value = e > o.max ? o.max : e < o.min ? o.min : e, o.scrollBar.value = o.value, e > o.max ? "max" : e < o.min ? "min" : "value";
          },
              u = function u() {
            var a = 175,
                n = Date.now() - w,
                p = Math.min(1e3, Date.now() - m),
                g = o.velocity * t(p / a),
                h;
            if (r) 0 > g && o.value <= e ? g = 0 : 0 < g && o.value >= e && (g = 0), (o.value + g <= o.min || o.value + g >= o.max) && (g = 0), .5 < g || -.5 > g ? (c(o.value + g), cancelAnimationFrame(d), d = 0, d = requestAnimationFrame(u)) : c(o.targetValue);else {
              if (n >= a) return cancelAnimationFrame(d), i.container.$.fireEvent("kineticScroll"), void (d = 0);
              h = Utilities.Animation.Easings.easeInSine(n, s, l - s, a), c(h), cancelAnimationFrame(d), d = 0, d = requestAnimationFrame(u);
            }
          };

          cancelAnimationFrame(d), d = requestAnimationFrame(u);
        }, i.inputEvents.listen();
      }
    }, {
      key: "unlisten",
      value: function unlisten() {
        var e = this;
        e.inputEvents && e.inputEvents.unlisten(), delete e.inputEvents;
      }
    }]);

    return Scroll;
  }();

  var _Extend =
  /*#__PURE__*/
  function () {
    function Extend(e) {
      _classCallCheck(this, Extend);

      this.events = {}, this.handlers = {}, this.element = e;
    }

    _createClass(Extend, [{
      key: "hasClass",
      value: function hasClass(e) {
        var t = this,
            a = e.split(" ");

        for (var _n11 = 0; _n11 < a.length; _n11++) {
          var _e28 = t.element.classList.contains(a[_n11]);

          if (!_e28) return !1;
        }

        return !0;
      }
    }, {
      key: "addClass",
      value: function addClass(e) {
        var t = this;

        if (!t.hasClass(e)) {
          var _a19 = e.split(" ");

          for (var _e29 = 0; _e29 < _a19.length; _e29++) {
            t.element.classList.add(_a19[_e29]);
          }

          t.isNativeElement || StyleObserver.observeElement(t.element);
        }
      }
    }, {
      key: "removeClass",
      value: function removeClass(e) {
        var t = this;
        if (0 === arguments.length) return void t.element.removeAttribute("class");
        var a = e.split(" ");

        for (var _n12 = 0; _n12 < a.length; _n12++) {
          t.element.classList.remove(a[_n12]);
        }

        "" === t.element.className && t.element.removeAttribute("class"), t.isNativeElement || StyleObserver.observeElement(t.element);
      }
    }, {
      key: "dispatch",
      value: function dispatch(e) {
        var t = this,
            a = t.events[e.type];
        var i = !1;
        if (1 < a.length) for (var _e30 = 0; _e30 < a.length; _e30++) {
          var _t22 = a[_e30];

          if (_t22.namespace && 0 <= _t22.namespace.indexOf("_")) {
            i = !0;
            break;
          }
        }
        i && a.sort(function (e, t) {
          var i = e.namespace,
              a = t.namespace;
          return i = -1 === i.indexOf("_") ? 0 : parseInt(i.substring(i.indexOf("_") + 1)), a = -1 === a.indexOf("_") ? 0 : parseInt(a.substring(a.indexOf("_") + 1)), i < a ? -1 : i > a ? 1 : 0;
        });

        for (var _n13 = 0; _n13 < a.length; _n13++) {
          var _i28 = a[_n13];
          if (e.namespace = _i28.namespace, e.context = _i28.context, e.defaultPrevented) break;

          var _o12 = _i28.handler.apply(t.element, [e]);

          if (void 0 !== _o12 && (e.result = _o12, !1 === _o12)) {
            e.preventDefault(), e.stopPropagation();
            break;
          }
        }

        return e.result;
      }
    }, {
      key: "fireEvent",
      value: function fireEvent(e, t, i) {
        var a = this;
        i || (i = {
          bubbles: !0,
          cancelable: !0,
          composed: a.isInShadowDOM
        }), i.detail = t || {};
        var n = new CustomEvent(e, i);
        return n.originalStopPropagation = n.stopPropagation, n.stopPropagation = function () {
          return n.isPropagationStopped = !0, n.originalStopPropagation();
        }, a.dispatchEvent(n), n;
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(e) {
        var t = this,
            i = e.type,
            a = t.element.context;
        t.element.context = document, t.element["on" + i] ? t.element["on" + i](e) : t.element.dispatchEvent(e), t.element.context = a;
      }
    }, {
      key: "listen",
      value: function listen(e, t) {
        var i = this,
            a = e.split("."),
            n = a.slice(1).join("."),
            o = a[0];
        i.events[o] || (i.events[o] = []);
        var r = {
          type: o,
          handler: t,
          context: i.element,
          namespace: n
        };
        0 <= f.indexOf(o) && (!i.inputEvents && (i.inputEvents = new InputEvents(i.element)), i.inputEvents[o](function (e) {
          i.dispatchEvent(e);
        }), i.inputEvents.boundEventTypes.push(o), i.inputEvents.listen(o)), 0 === i.events[o].length && (i.handlers[o] = i.dispatch.bind(i), "wheel" === o ? i.element.addEventListener("wheel", i.handlers[o], !!i.isPassiveSupported && {
          passive: !1
        }) : i.element.addEventListener(o, i.handlers[o], !1)), i.events[o].push(r);
      }
    }, {
      key: "unlisten",
      value: function unlisten(e) {
        var t = this,
            i = e.split("."),
            a = i.slice(1).join("."),
            n = i[0];
        var o = t.events[n];

        if (t.inputEvents && 0 <= t.inputEvents.boundEventTypes.indexOf(n) && (t.inputEvents.boundEventTypes.splice(t.inputEvents.boundEventTypes.indexOf(n), 1), 0 === t.inputEvents.boundEventTypes.length && t.inputEvents.unlisten(n)), !!o) {
          for (var _e31 = 0; _e31 < o.length; _e31++) {
            if ("" !== a) {
              var _e32 = o.findIndex(function (e) {
                return e.namespace === a;
              });

              o.splice(_e32, 1);
              break;
            } else o = [];
          }

          0 === o.length && (t.element.removeEventListener(n, t.handlers[n]), t.events[n] = [], delete t.handlers[n]);
        }
      }
    }, {
      key: "getAttributeValue",
      value: function getAttributeValue(e, t) {
        var i = this,
            a = i.element.getAttribute(e);
        if (i.isNativeElement) return i.deserialize(a, t);
        var n = i.element.propertyByAttributeName[e],
            o = n.deserialize === void 0 ? i.deserialize(a, t, n.nullable) : i.element[n.deserialize](a);
        return o;
      }
    }, {
      key: "setAttributeValue",
      value: function setAttributeValue(e, t, i) {
        var a = this;
        var n = !1,
            o;

        if (!a.isNativeElement) {
          var _r8 = a.element.propertyByAttributeName[e];
          n = !_r8 || _r8.nullable, o = _r8 && _r8.serialize ? a.element[_r8.serialize](t) : a.serialize(t, i, n);
        } else if (o = a.serialize(t, i), "boolean" === i) {
          if (0 <= ["checked", "selected", "async", "autofocus", "autoplay", "controls", "defer", "disabled", "hidden", "ismap", "loop", "multiple", "open", "readonly", "required", "scoped"].indexOf(e)) return void (t ? a.element.setAttribute(e, "") : a.element.removeAttribute(e));
        }

        return ("array" === i || "object" === i) && ("[]" === o || "{}" === o) ? void a.element.removeAttribute(e) : void (void 0 === o ? (a.element.removeAttribute(e), a.element.shadowRoot && a.element.$.root && a.element.$.root.removeAttribute(e)) : (a.element.setAttribute(e, o), a.element.shadowRoot && a.element.$.root && a.element.$.root.setAttribute(e, o)));
      }
    }, {
      key: "serialize",
      value: function serialize(e, t, i) {
        if (void 0 === t && (t = Utilities.Types.getType(e)), void 0 !== e && (i || null !== e)) {
          if (i && null === e) return "null";
          if ("string" === t) return e;

          if ("boolean" === t || "bool" === t) {
            if (!0 === e || "true" === e || 1 === e || "1" === e) return "";
            if (!1 === e || "false" === e || 0 === e || "0" === e) return;
          }

          if ("array" === t) return JSON.stringify(e);
          return 0 <= ["string", "number", "int", "integer", "float", "date", "any", "function"].indexOf(t) ? e.toString() : "object" === t ? JSON.stringify(e) : void 0;
        }
      }
    }, {
      key: "deserialize",
      value: function deserialize(e, t, i) {
        var a = "null" === e;

        if (void 0 !== e && (!a || i)) {
          if (a && i) return null;
          if ("boolean" === t || "bool" === t) return null !== e;
          if ("number" === t || "float" === t) return "NaN" === e ? NaN : "Infinity" === e ? 1 / 0 : "-Infinity" === e ? -Infinity : parseFloat(e);
          if ("int" === t || "integer" === t) return "NaN" === e ? NaN : "Infinity" === e ? 1 / 0 : "-Infinity" === e ? -Infinity : parseInt(e);
          if ("string" === t) return e;
          if ("any" === t) return e;
          if ("date" === t) return new Date(e);

          if ("function" === t) {
            if ("function" == typeof window[e]) return window[e];
          } else if ("array" === t || "object" === t) try {
            var _t23 = JSON.parse(e);

            if (_t23) return _t23;
          } catch (i) {
            if (window[e] && "object" == typeof window[e]) return window[e];

            if ("array" === t && 0 <= e.indexOf("[")) {
              if (0 <= e.indexOf("{")) {
                var _t25 = e.replace(/{/ig, "").replace("[", "").replace("]", "").replace(/'/ig, "").replace(/"/ig, "").trim();

                _t25 = _t25.split("},");

                for (var _e33 = 0; _e33 < _t25.length; _e33++) {
                  var _i29 = {},
                      _a20 = _t25[_e33].trim().split(",");

                  for (var _e34 = 0; _e34 < _a20.length; _e34++) {
                    var _t26 = _a20[_e34].split(":")[0].trim(),
                        _n14 = _a20[_e34].split(":")[1].trim();

                    _i29[_t26] = _n14;
                  }

                  _t25[_e33] = _i29;
                }

                return _t25;
              }

              var _t24 = e.replace("[", "").replace("]", "").replace(/'/ig, "").replace(/"/ig, "").trim().split(",");

              return _t24;
            }
          }
        }
      }
    }, {
      key: "isCustomElement",
      get: function get() {
        var e = this;
        return !(!0 != e.element instanceof window[u].BaseElement) || "DIV" !== e.element.tagName && "SPAN" !== e.element.tagName && "BUTTON" !== e.element.tagName && "INPUT" !== e.element.tagName && "UL" !== e.element.tagName && "LI" !== e.element.tagName && !(!0 != document.createElement(e.element.nodeName) instanceof window[u].BaseElement);
      }
    }, {
      key: "isNativeElement",
      get: function get() {
        var e = this;
        return !e.isCustomElement;
      }
    }, {
      key: "isPassiveSupported",
      get: function get() {
        var e = this;
        if (e.supportsPassive !== void 0) return e.supportsPassive;
        e.supportsPassive = !1;

        try {
          var _t27 = Object.defineProperty({}, "passive", {
            get: function get() {
              e.supportsPassive = !0;
            }
          });

          window.addEventListener("testPassive", null, _t27), window.removeEventListener("testPassive", null, _t27);
        } catch (t) {}

        return e.supportsPassive;
      }
    }]);

    return Extend;
  }();

  var Animation =
  /*#__PURE__*/
  function () {
    function Animation() {
      _classCallCheck(this, Animation);
    }

    _createClass(Animation, null, [{
      key: "Ripple",
      get: function get() {
        return Ripple;
      }
    }, {
      key: "Easings",
      get: function get() {
        return Easings;
      }
    }]);

    return Animation;
  }();

  var Utilities =
  /*#__PURE__*/
  function () {
    function Utilities() {
      _classCallCheck(this, Utilities);
    }

    _createClass(Utilities, null, [{
      key: "Extend",
      value: function Extend(e) {
        return new _Extend(e);
      }
    }, {
      key: "Assign",
      value: function Assign(e, t) {
        if (0 <= e.indexOf(".")) {
          var _i30 = e.split(".");

          return Utilities[_i30[0]] || (Utilities[_i30[0]] = {}), void (Utilities[_i30[0]][_i30[1]] = t);
        }

        Utilities[e] = t;
      }
    }, {
      key: "Types",
      get: function get() {
        return Types;
      }
    }, {
      key: "Core",
      get: function get() {
        return Core;
      }
    }, {
      key: "Animation",
      get: function get() {
        return Animation;
      }
    }, {
      key: "Scroll",
      get: function get() {
        return Scroll;
      }
    }, {
      key: "InputEvents",
      get: function get() {
        return InputEvents;
      }
    }]);

    return Utilities;
  }();

  var b = Utilities.Extend(document);
  BindingModule.cache = {};

  var BaseElement =
  /*#__PURE__*/
  function (_HTMLElement) {
    _inherits(BaseElement, _HTMLElement);

    function BaseElement() {
      _classCallCheck(this, BaseElement);

      return _possibleConstructorReturn(this, _getPrototypeOf(BaseElement).apply(this, arguments));
    }

    _createClass(BaseElement, [{
      key: "template",
      value: function template() {
        return "<div></div>";
      }
    }, {
      key: "registered",
      value: function registered() {
        var e = this;
        e.onRegistered && e.onRegistered();
      }
    }, {
      key: "created",
      value: function created() {
        var e = this;
        e.isReady = !1, e._initElement(e), e._setModuleState("created"), e.onCreated && e.onCreated();
      }
    }, {
      key: "completed",
      value: function completed() {
        var e = this;
        e.isCompleted = !0, e._onCompleted && e._onCompleted(), e.onCompleted && e.onCompleted();
      }
    }, {
      key: "whenReady",
      value: function whenReady(e) {
        var t = this;
        return t.isCompleted ? void e() : void (!t.whenReadyCallbacks && (t.whenReadyCallbacks = []), t.whenReadyCallbacks.push(e));
      }
    }, {
      key: "whenRendered",
      value: function whenRendered(e) {
        var t = this;
        return t.isRendered ? void e() : void (!t.whenRenderedCallbacks && (t.whenRenderedCallbacks = []), t.whenRenderedCallbacks.push(e));
      }
    }, {
      key: "addThemeClass",
      value: function addThemeClass() {
        var e = this;
        "" !== e.theme && e.classList.add("smart-" + e.theme);
      }
    }, {
      key: "addDefaultClass",
      value: function addDefaultClass() {
        var e = this;
        e.classList.add(u.toLowerCase() + "-element"), e.classList.add(e.nodeName.toLowerCase());
      }
    }, {
      key: "_renderShadowRoot",
      value: function _renderShadowRoot() {
        var e = this;

        if (e.shadowRoot) {
          e.$.root.classList.add(e.nodeName.toLowerCase());

          for (var _t28 = 0; _t28 < e.attributes.length; _t28++) {
            var _i31 = e.attributes[_t28];
            "class" === _i31.name || "id" === _i31.name || "style" === _i31.name || "tabindex" === _i31.name || 0 <= _i31.name.indexOf("aria") || e.$.root.setAttribute(_i31.name, _i31.value);
          }

          for (var _t29 = 0; _t29 < e.classList.length; _t29++) {
            var _i32 = e.classList[_t29];
            "smart-element-init" !== _i32 && "smart-element" !== _i32 && "smart-hidden" !== _i32 && "smart-visibility-hidden" !== _i32 && e.$.root.classList.add(_i32);
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        var e = this;

        if (!e.isRendered && (e.isRendered = !0, e.isRendering = !1, e.context = document, e._renderShadowRoot(), e.whenRenderedCallbacks)) {
          for (var _t30 = 0; _t30 < e.whenRenderedCallbacks.length; _t30++) {
            e.whenRenderedCallbacks[_t30]();
          }

          e.whenRenderedCallbacks = [];
        }

        e.onRender && e.onRender(), e.disabled && e.setAttribute("aria-disabled", !0), e.readonly && e.setAttribute("aria-readonly", !0);
      }
    }, {
      key: "ready",
      value: function ready() {
        var e = this;

        if (e._setId(), e.addThemeClass(), e.addDefaultClass(), "collapsed" === e.visibility ? e.classList.add("smart-hidden") : "hidden" === e.visibility && e.classList.add("smart-visibility-hidden"), e.dataContext && e.applyDataContext(), e.onReady && e.onReady(), e.shadowRoot && Smart(e._selector)) {
          if (Smart(e._selector).styleUrls) {
            var _t31 = Smart(e._selector).styleUrls;

            for (var _a21 = 0; _a21 < _t31.length; _a21++) {
              e.importStyle(_t31[_a21]);
            }
          }

          if (Smart(e._selector).styles) {
            var _t32 = document.createElement("style");

            _t32.innerHTML = Smart(e._selector).styles, e.shadowRoot.insertBefore(_t32, e.shadowRoot.firstChild);
          }
        }

        Smart(e._selector) && Smart(e._selector).ready && Smart(e._selector).ready();
      }
    }, {
      key: "_setId",
      value: function _setId() {
        var e = this;

        if (!e.id) {
          var _i33 = e.elementName;
          e.id = _i33.slice(0, 1).toLowerCase() + _i33.slice(1) + t(65536 * (1 + Math.random())).toString(16).substring(1);
        }
      }
    }, {
      key: "checkLicense",
      value: function checkLicense() {
        var e = this;
        "Evaluation" === window[u].License && -1 === window.location.hostname.indexOf("htmlelements") && -1 === window.location.hostname.indexOf("localhost") && -1 === window.location.protocol.indexOf("file") && (e.logWatermark(), e.logLicense(), "" === window[u].License);
      }
    }, {
      key: "logWatermark",
      value: function logWatermark() {
        var e = document.createElement("a");
        e.href = "https://www.htmlelements.com/", e.innerHTML = "https://www.htmlelements.com/", e.style.position = "absolute", e.style.right = "5px", e.style.bottom = "5px", e.style.color = "#fff", e.style.padding = "20px", e.style.borderRadius = "5px", e.style.background = "#20C933", e.style.cursor = "pointer", e.style.zIndex = "999999", e.style.display = "block", e.style.fontSize = "24px", e.style.textDecoration = "none", e.style.fontWeight = "bold", e.style.opacity = 0, e.style.transition = "opacity .35s ease-in-out", e.id = "watermark";
        document.getElementById("watermark") || setTimeout(function () {
          document.getElementById("watermark") || (document.body.appendChild(e), setTimeout(function () {
            e.style.opacity = 1;
          }), setTimeout(function () {
            e.style.opacity = 0, setTimeout(function () {
              e.parentNode.removeChild(e);
            }, 350);
          }, 6e3));
        }, 1e3);
      }
    }, {
      key: "logLicense",
      value: function logLicense() {
        console.log("****************************************************************************************************************"), console.log("****************************************************************************************************************"), console.log("****************************************************************************************************************"), console.log("*Smart HTML Elements License Key Not Found."), console.log("*This is an evaluation only version, it is not licensed for development projects intended for production."), console.log("*if you want to hide the watermark, please send an email to: info@htmlelements.com for a license."), console.log("****************************************************************************************************************"), console.log("****************************************************************************************************************"), console.log("****************************************************************************************************************");
      }
    }, {
      key: "applyDataContext",
      value: function applyDataContext(e) {
        var t = this;
        var i = "string" == typeof t.dataContext ? window[t.dataContext] || document[t.dataContext] : t.dataContext;

        if (e && (i = e, t.dataContext = e), !i) {
          t.dataContextProperties = null;

          var _e35 = function _e35() {
            var i = "string" == typeof t.dataContext ? window[t.dataContext] || document[t.dataContext] : t.dataContext;
            i && (t.applyDataContext(), window.removeEventListener("load", _e35));
          };

          return void window.addEventListener("load", _e35);
        }

        if (!i._uid) {
          var _loop4 = function _loop4(_e36) {
            var a = i[_e36];
            "function" != typeof a && "_properties" != _e36 && "_uid" != _e36 && (i._properties[_e36] = a, Object.defineProperty(i, _e36, {
              configurable: !1,
              enumerable: !0,
              get: function get() {
                return i._properties[_e36];
              },
              set: function set(a) {
                var n = i._properties[_e36];
                i._properties[_e36] = a;
                var o = [];
                o[_e36] = {
                  oldValue: n,
                  value: a
                }, o.length++, t.updatingDataContext = !0, b.fireEvent("dataContextPropertyChanged", {
                  dataContext: i,
                  properties: o
                }, {
                  bubbles: !1,
                  cancelable: !0
                }), t.updatingDataContext = !1;
              }
            }));
          };

          for (var _e36 in i._uid = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase(), i._properties = [], i) {
            _loop4(_e36);
          }
        }

        if (t.dataContextProperties = t.parseAttributes(t), t.dataContextPropertiesMap = {}, t.dataContextListeners = {}, !t.dataContextProperties) return void (t.dataContextProperties = null);

        for (var _a22 in t.updatingDataContext = !0, t.dataContextProperties) {
          var _e37 = t.dataContextProperties[_a22],
              _n15 = _e37.name;

          if (_e37.propertyName = _a22, t.dataContextPropertiesMap[_n15] = _a22, BindingModule.cache["toDash" + _a22] || (BindingModule.cache["toDash" + _a22] = Utilities.Core.toDash(_n15)), _e37.isEvent) {
            (function () {
              var a = _e37.value;
              t.dataContextListeners[_n15] && t.removeEventListener(_n15, t.dataContextListeners[_n15]), t.dataContextListeners[_n15] = function (e) {
                i[a](e);
              }, t.addEventListener(_n15, t.dataContextListeners[_n15]);
            })();
          }

          if (0 <= _n15.indexOf(".")) {
            var _e38 = _n15.split(".");

            var _o13 = i[_e38[0]];

            for (var _t33 = 1; _t33 < _e38.length; _t33++) {
              _o13 = _o13[_e38[_t33]];
            }

            void 0 !== _o13 && (t[_a22] = _o13);
          } else t[_a22] = i[_n15];
        }

        t.dataContextPropertyChangedHandler = function (e) {
          var i = e.detail.properties,
              a = e.detail.dataContext,
              n = "string" == typeof t.dataContext ? window[t.dataContext] || document[t.dataContext] : t.dataContext;
          if (a === n) for (var _e39 in i) {
            var _a23 = t.dataContextPropertiesMap[_e39],
                _n16 = t.context;
            _a23 && (t.context = document, t[_a23] = i[_e39].value, t.context = _n16);
          }
        }, b.listen("dataContextPropertyChanged", t.dataContextPropertyChangedHandler), t.updatingDataContext = !1;
      }
    }, {
      key: "updateDataContextProperty",
      value: function updateDataContextProperty(e) {
        var t = this,
            i = "string" == typeof t.dataContext ? window[t.dataContext] || document[t.dataContext] : t.dataContext,
            a = t.dataContextProperties[e];

        if (!t.updatingDataContext && a.twoWay) {
          var _n17 = a.name;

          if (0 <= _n17.indexOf(".")) {
            var _a24 = _n17.split(".");

            var _o14 = i[_a24[0]];

            for (var _e40 = 1; _e40 < _a24.length; _e40++) {
              _o14 = _o14[_a24[_e40]];
            }

            void 0 !== _o14 && (_o14 = t[e], h[i._uid] && (h[i._uid][e] = _o14));
          } else i[_n17] = t[e], h[i._uid] && (h[i._uid][e] = i[_n17]);
        }
      }
    }, {
      key: "initProperties",
      value: function initProperties() {
        var e = this;

        if (Smart(e._selector) && Smart(e._selector).properties && (e._initProperties = Smart(e._selector).properties), e.hasAttribute("props") && !e.props ? e._initProperties = window[e.getAttribute("props")] : e.props && (e._initProperties = e.props), e._initProperties) {
          var _t34 = Object.keys(e._initProperties);

          for (var _a25 = 0; _a25 < _t34.length; _a25++) {
            var _i34 = _t34[_a25],
                _n18 = e._initProperties[_i34];

            if (_n18.constructor === Smart.ObservableArray || _n18 instanceof Smart.ObservableArray) {
              e[_i34] = _n18.toArray();
              continue;
            }

            if (_n18.constructor === Smart.DataAdapter || "smartDataAdapter" === _n18.constructor.name || "object" == typeof _n18 && Smart.DataAdapter && _n18 instanceof Smart.DataAdapter || _n18 instanceof Smart.Observable || _n18.constructor === Smart.Observable || "object" != typeof _n18 || Utilities.Types.isArray(_n18)) {
              if (void 0 === e[_i34] && -1 === ["onReady", "onAttached", "onDetached", "onCreated", "onCompleted"].indexOf(_i34)) {
                var _t35 = e.localize("propertyUnknownName", {
                  name: _i34
                });

                e.log(_t35);
              }

              e[_i34] = _n18;
              continue;
            }

            if ("messages" === _i34) {
              e[_i34] = _n18;
              continue;
            }

            if ("object" == typeof _n18) {
              (function () {
                var t = function t(a, n) {
                  var o = Object.keys(a);

                  for (var _r9 = 0; _r9 < o.length; _r9++) {
                    var _i35 = o[_r9],
                        _l7 = a[_i35],
                        _s3 = e._properties[n + "_" + _i35];

                    if (_s3 && null === _s3.value) {
                      if (void 0 === e[n + "_" + _i35]) {
                        var _t36 = e.localize("propertyUnknownName", {
                          name: n + "_" + _i35
                        });

                        e.log(_t36);
                      }

                      e[n + "_" + _i35] = _l7;
                      continue;
                    }

                    if ("object" == typeof _l7 && !Utilities.Types.isArray(_l7) && _l7 && _l7.constructor !== Date) t(_l7, n + "_" + _i35);else {
                      if (void 0 === e[n + "_" + _i35]) {
                        var _t37 = e.localize("propertyUnknownName", {
                          name: n + "_" + _i35
                        });

                        e.log(_t37);
                      }

                      e[n + "_" + _i35] = _l7;
                    }
                  }
                };

                t(_n18, _i34);
              })();
            }
          }
        }
      }
    }, {
      key: "setup",
      value: function setup() {
        var e = this;
        if (e.context = this, e.isReady && !e.isCompleted) return;
        if (e.isReady) return e._setModuleState("attached"), e.isAttached = !0, e.attached(), e._handleListeners("listen"), void (e.context = document);
        e.ownerElement && 0 <= e.ownerElement.detachedChildren.indexOf(e) && e.ownerElement.detachedChildren.splice(e.ownerElement.detachedChildren.indexOf(e), 1), e.isReady = !0, e.methods = e.getStaticMember("methods"), e.initProperties();
        var t = Core.isMobile;
        t && e.classList.add("smart-mobile");

        for (var _t38 = 0; _t38 < e.attributes.length; _t38 += 1) {
          var _i36 = e.propertyByAttributeName[e.attributes[_t38].name];
          if (!_i36) continue;

          var _a26 = e.$.getAttributeValue(_i36.attributeName, _i36.type);

          var _n19 = _a26 ? _a26.toString() : "";

          if (!(0 <= _n19.indexOf("{{") || 0 <= _n19.indexOf("[[")) && !("object" !== _i36.type && "array" !== _i36.type && (0 <= e.attributes[_t38].value.indexOf("{{") || 0 <= e.attributes[_t38].value.indexOf("[["))) && void 0 !== _a26 && _i36.value !== _a26) {
            var _n20 = Utilities.Types.getType(_a26),
                _o15 = e.attributes[_t38].value;

            if (("any" === _i36.type || "object" === _i36.type) && "" + e[_i36.name] === _a26) continue;
            if ("array" === _i36.type && e[_i36.name] && JSON.stringify(e[_i36.name]) === _a26) continue;

            if ("number" === _n20 && isNaN(_a26) && "NaN" !== _o15 && "Infinity" !== _o15 && "-Infinity" !== _o15) {
              var _t39 = e.localize("propertyInvalidValueType", {
                name: _i36.name,
                actualType: "string",
                type: _i36.type
              });

              e.log(_t39);
            }

            _i36.isUpdatingFromAttribute = !0, e[_i36.name] = _a26, _i36.isUpdatingFromAttribute = !1;
          }
        }

        for (var _t40 in e._properties) {
          var _a27 = e._properties[_t40];

          if ("innerHTML" == _t40 && _a27.value === _a27.defaultValue && (_a27.value = _a27.defaultValue = Utilities.Core.html(e)), ("boolean" === _a27.type || "bool" === _a27.type) && "false" === e.getAttribute(_a27.attributeName) && (_a27.isUpdating = !0, e.setAttribute(_a27.attributeName, ""), _a27.isUpdating = !1), _a27.defaultReflectToAttribute && _a27.reflectToAttribute) {
            if (_a27.defaultReflectToAttribute && _a27.defaultReflectToAttributeConditions) {
              var _t41 = !0;

              for (var _n21 = 0; _n21 < _a27.defaultReflectToAttributeConditions.length; _n21++) {
                var _i37 = _a27.defaultReflectToAttributeConditions[_n21];

                var _o16 = void 0,
                    _r10 = void 0;

                for (var _e41 in _i37) {
                  _o16 = _e41, _r10 = _i37[_e41];
                }

                e._properties[_o16] && e._properties[_o16].value !== _r10 && (_t41 = !1);
              }

              if (!_t41) continue;
            }

            _a27.isUpdating = !0, e.$.setAttributeValue(_a27.attributeName, _a27.value, _a27.type), _a27.isUpdating = !1;
          }
        }

        var a = [];
        if (0 < e.children.length) for (var _t42 = 0; _t42 < e.children.length; _t42++) {
          var _i38 = e.children[_t42];
          Utilities.Extend(_i38).isCustomElement && a.push(_i38);
        }
        e.applyTemplate(), e.complete = function () {
          if (!e.templateBindingsReady) {
            var _t43 = function _t43(e) {
              e.templateBindingsReady || (e.templateBindingsReady = !0, e.updateTextNodes(), e.updateBoundNodes());
            };

            if (!e.ownerElement) _t43(e);else {
              var _i39 = e.ownerElement,
                  _a28 = [];

              for (; _i39;) {
                _a28.push(_i39), _i39 = _i39.ownerElement;
              }

              for (var _e42 = _a28.length - 1; 0 <= _e42; _e42--) {
                _t43(_a28[_e42]);
              }

              _t43(e);
            }
          }

          var t = function t() {
            if (e._setModuleState("ready"), e.ready(), "auto" !== e.renderMode || e.isRendered || e.render(), e.isAttached = !0, e._setModuleState("attached"), e.attached(), e._handleListeners("listen"), e.isHidden || 0 !== e.offsetWidth && 0 !== e.offsetHeight || (e.isHidden = !0), e.completed(), e.isRendered && (e.context = document), e.whenReadyCallbacks) {
              for (var _t44 = 0; _t44 < e.whenReadyCallbacks.length; _t44++) {
                e.whenReadyCallbacks[_t44]();
              }

              e.whenReadyCallbacks = [];
            }
          };

          if (!!e.wait) e.classList.add("smart-visibility-hidden");else if (!e.classList.contains("smart-async")) {
            var _i40 = e.shadowParent;
            e.shadowParent = null;
            var _a29 = e.parents;
            if (e.shadowParent = _i40, 0 === _a29.length) return;

            var _n22 = function _n22() {
              var t = e.ownerElement,
                  a = [];

              for (; t;) {
                a.push(t), t = t.ownerElement;
              }

              for (var _e43 = a.length - 1; 0 <= _e43; _e43--) {
                a[_e43].updateBoundMappedNodes();
              }
            };

            e.ownerElement && "HTML" !== _a29[_a29.length - 1].nodeName ? e.ownerElement && "HTML" === e.ownerElement.parents[e.ownerElement.parents.length - 1].nodeName ? (_n22(), t()) : e.checkIsInDomInterval = setInterval(function () {
              var i = e.parents;
              "HTML" === i[i.length - 1].nodeName && (clearInterval(e.checkIsInDomInterval), _n22(), t());
            }, 100) : t();
          } else requestAnimationFrame(function () {
            t();
          });
        };
        var n = [].slice.call(e.querySelectorAll("[smart-id]")).concat(a);
        if (e.enableShadowDOM && !0 !== e.isInShadowDOM && (n = [].slice.call(e.shadowRoot.querySelectorAll("[smart-id]")).concat(a)), 0 === n.length) e.complete();else {
          e._completeListeners = 0;

          var _loop5 = function _loop5(_t45) {
            var a = n[_t45];

            if (Utilities.Extend(a).isCustomElement) {
              var _t46 = function () {
                e._completeListeners--, 0 === e._completeListeners && (e.complete(), delete e._completeListeners);
              }.bind(e);

              a.isCompleted || a.isUtilityElement || !1 !== a.wait || (e._completeListeners++, !a._onCompleted && (a.completeHandlers = [], a._onCompleted = function () {
                for (var _e44 = 0; _e44 < a.completeHandlers.length; _e44++) {
                  a.completeHandlers[_e44]();
                }
              }), a.completeHandlers.push(_t46));
            }
          };

          for (var _t45 = 0; _t45 < n.length; _t45++) {
            _loop5(_t45);
          }

          0 === e._completeListeners && e.complete();
        }
      }
    }, {
      key: "visibilityChangedHandler",
      value: function visibilityChangedHandler() {
        var e = this;
        e.isReady && requestAnimationFrame(function () {
          0 === e.offsetWidth || 0 === e.offsetHeight ? e.isHidden = !0 : (e.isHidden = !1, e.$.fireEvent("resize", e, {
            bubbles: !1,
            cancelable: !0
          }));
        });
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(e, t, i) {
        var a = this,
            n = a.propertyByAttributeName[e];

        if (("class" === e || "style" === e) && a.visibilityChangedHandler(), n || a.attributeChanged(e, t, i), !(!n || n && n.isUpdating)) {
          var _e45 = a.$.getAttributeValue(n.attributeName, n.type);

          void 0 !== i && a[n.name] !== _e45 && (n.isUpdatingFromAttribute = !0, a[n.name] = void 0 === _e45 ? a._properties[n.name].defaultValue : _e45, n.isUpdatingFromAttribute = !1);
        }
      }
    }, {
      key: "attributeChanged",
      value: function attributeChanged(e, t, i) {}
    }, {
      key: "attached",
      value: function attached() {
        var e = this;
        e.hasStyleObserver && StyleObserver.watch(e), e.onAttached && e.onAttached(), Smart(e._selector) && Smart(e._selector).attached && Smart(e._selector).attached();
      }
    }, {
      key: "detached",
      value: function detached() {
        var e = this;
        e.hasStyleObserver && StyleObserver.unwatch(e), e._setModuleState("detached"), e.isAttached = !1, e.ownerElement && -1 === e.ownerElement.detachedChildren.indexOf(e) && e.ownerElement.detachedChildren.push(e), e._handleListeners("unlisten"), e.onDetached && e.onDetached(), Smart(e._selector) && Smart(e._selector).detached && Smart(e._selector).detached();
      }
    }, {
      key: "propertyChangedHandler",
      value: function propertyChangedHandler(e, t, i) {
        var a = this;
        t === i || ("theme" === e && ("" !== t && a.classList.remove("smart-" + t), "" !== i && a.classList.add("smart-" + i)), "visibility" === e ? ("collapsed" === t ? a.classList.remove("smart-hidden") : "hidden" == t && a.classList.remove("smart-visibility-hidden"), "collapsed" === i ? a.classList.add("smart-hidden") : "hidden" == i && a.classList.add("smart-visibility-hidden")) : ("disabled" == e || "readonly" == e) && (i ? a.setAttribute("aria-" + e, !0) : a.removeAttribute("aria-" + e)), a.propertyChanged && a.propertyChanged(e, t, i));
      }
    }, {
      key: "_handleListeners",
      value: function _handleListeners(e) {
        var t = this,
            i = t.tagName.toLowerCase(),
            a = t.getStaticMember("listeners"),
            n = function n(a) {
          var _loop6 = function _loop6(_n23) {
            var o = _n23.split(".");

            var r = o[0],
                l = t.$;
            if (!o[1]) t.smartId && (r = r + "." + t.smartId);else if (r = o[1], l = t["$" + o[0]], "document" === o[0]) {
              var _e46 = t.smartId;
              "" === _e46 && (_e46 = Utilities.Core.toCamelCase(i)), r = r + "." + _e46;
            } else t.smartId && (r = r + "." + t.smartId + "_" + t.parents.length);
            var s = a[_n23];
            l && l[e](r, function (e) {
              var i = t.context;
              t.context = t, t[s] && t[s].apply(t, [e]), t.context = i;
            });
          };

          for (var _n23 in a) {
            _loop6(_n23);
          }
        };

        n(a), n(t.templateListeners), Smart(t._selector) && Smart(t._selector).properties && n(Smart(t._selector).listeners);
      }
    }, {
      key: "parseTemplate",
      value: function parseTemplate() {
        var e = this,
            t = e.template(),
            a = document.createDocumentFragment();
        if (c[e.nodeName] && !p) return c[e.nodeName].cloneNode(!0);
        if ("" === t) return null;
        var i = document.createElement("div");
        a.appendChild(i), i.innerHTML = t;
        var n = i.childNodes;
        i.parentNode.removeChild(i);

        for (var _e47 = 0; _e47 < n.length; _e47++) {
          a.appendChild(n[_e47]);
        }

        return c[e.nodeName] = a, p ? a : a.cloneNode(!0);
      }
    }, {
      key: "applyTemplate",
      value: function applyTemplate() {
        var e = this,
            t = e.parseTemplate();
        if (!t) return;
        if (!t.hasChildNodes) return;

        var i = t.childNodes[0],
            a = function a(t, i) {
          e["$" + t] = i.$ = Utilities.Extend(i), e.$[t] = i, i.ownerElement = e;
        };

        var n = i;

        if (0 < i.getElementsByTagName("content").length) {
          var _e48 = i.getElementsByTagName("content")[0];
          n = _e48.parentNode, n.removeChild(_e48);
        } else {
          var _e49 = t.querySelectorAll("[inner-h-t-m-l]");

          _e49 && 0 < _e49.length && (n = _e49[0]);
        }

        e.$.template = "template" === i.nodeName.toLowerCase() ? i : i.querySelector("template");
        var o = t.querySelectorAll("[id]");
        0 === o.length && (o = t.querySelectorAll("*")), a("root", i), a("content", n), e.$.html = e.innerHTML.toString().trim();

        for (var _t47 = 0, _i41; _t47 < o.length; _t47 += 1) {
          _i41 = o[_t47], "" === _i41.id && (_i41.id = "child" + _t47), a(_i41.id, _i41), _i41.setAttribute("smart-id", _i41.id), e.shadowRoot ? _i41.shadowParent = e : _i41.removeAttribute("id");
        }

        for (e.bindings = !1 === e.hasTemplateBindings ? [] : e.getBindings(t), e.$root.addClass("smart-container"); e.childNodes.length;) {
          n.appendChild(e.firstChild);
        }

        if (e.appendTemplate(t), e.$.template) {
          var _t48 = document.createElement("div");

          _t48.classList.add("smart-template-container"), e.$.templateContainer = _t48, e.$.template.parentNode.insertBefore(_t48, e.$.template), e.refreshTemplate();
        }
      }
    }, {
      key: "refreshTemplate",
      value: function refreshTemplate() {
        var e = this;
        if (!e.$.templateContainer) return;
        e.templateDetached(e.$.templateContainer);
        var t = e.$.template.content.cloneNode(!0);
        e.templateBindings = e.getBindings(t), e.templateProperties = [];
        var i = document.createDocumentFragment();

        var a = function a(t, i, n) {
          for (var _o17 in t) {
            var _r11 = t[_o17],
                _l8 = _r11.node.cloneNode();

            i.appendChild(_l8);

            var _s4 = [],
                _d3 = !1;

            if (_r11.data) for (var _t49 in _r11.data) {
              var _a30 = _r11.data[_t49],
                  _o18 = _a30.name;
              if (e.templateProperties[_o18] = !0, _l8.removeAttribute(Utilities.Core.toDash(_t49)), "*items" == _t49) _s4 = e[_o18], _d3 = !0;else if (0 <= _o18.indexOf("item.") && void 0 !== n) _a30.value = n[_o18.substring(5)], _l8[_t49] = _a30.value;else if (0 <= _o18.indexOf("item") && void 0 !== n) _a30.value = n, _l8[_t49] = _a30.value;else if ("*if" != _t49) e.updateBoundNode(_l8, _r11, e, _o18);else if (0 <= _o18.indexOf("(")) {
                var _t50 = _o18.substring(_o18.indexOf("(")),
                    _a31 = void 0;

                var _n24 = _o18.substring(0, _o18.indexOf("("));

                if (_t50 = _t50.substring(1, _t50.length - 1), _t50 = _t50.replace(/ /ig, ""), _t50 = _t50.split(","), 0 < _t50.length && "" !== _t50[0]) {
                  var _o19 = [];

                  for (var _a32 = 0; _a32 < _t50.length; _a32++) {
                    _o19.push(e[_t50[_a32]]);
                  }

                  _a31 = e[_n24].apply(e, _o19);
                } else _a31 = e[_n24]();

                !1 === _a31 && i.removeChild(_l8);
              } else e[_o18] || i.removeChild(_l8);
            }

            if (0 < _s4.length || _d3) {
              for (var _e50 = 0; _e50 < _s4.length; _e50++) {
                _r11.children && a(_r11.children, _l8, _s4[_e50]);
              }

              if ("number" == typeof _s4) for (var _e51 = 0; _e51 < _s4; _e51++) {
                _r11.children && a(_r11.children, _l8, _e51);
              }
            } else _r11.children && a(_r11.children, _l8, n);
          }
        };

        a(e.templateBindings.children, i), e.$.templateContainer.innerHTML = "", e.$.templateContainer.appendChild(i), e.templateAttached(e.$.templateContainer);
      }
    }, {
      key: "templateAttached",
      value: function templateAttached() {}
    }, {
      key: "templateDetached",
      value: function templateDetached() {}
    }, {
      key: "appendTemplate",
      value: function appendTemplate(e) {
        var t = this;
        t.appendChild(e);
      }
    }, {
      key: "defineElementModules",
      value: function defineElementModules() {
        var e = this,
            t = e.constructor.prototype;

        if ("BaseElement" === t.elementName) {
          t.modules = e.constructor.modules;
          var _a33 = t.modules;

          for (var _t51 = 0; _t51 < _a33.length; _t51 += 1) {
            e.addModule(_a33[_t51]);
          }
        } else {
          var _a34 = t.modules;

          for (var _t52 = 0; _t52 < _a34.length; _t52 += 1) {
            var _i42 = _a34[_t52],
                _n25 = _i42.prototype;
            e.defineElementMethods(_n25.methodNames, _n25), e.defineElementProperties(_i42.properties);
          }
        }
      }
    }, {
      key: "watch",
      value: function watch(e, t) {
        var i = this;
        return null === e || null === t ? void (i._watch = null) : void (i._watch = {
          properties: e,
          propertyChangedCallback: t
        });
      }
    }, {
      key: "unwatch",
      value: function unwatch() {
        var e = this;
        e._watch = null;
      }
    }, {
      key: "set",
      value: function set(e, t, i) {
        var a = this,
            n = a.context;
        a.context = !0 === i ? document : a, a[e] = t, a.context = n;
      }
    }, {
      key: "get",
      value: function get(e) {
        var t = this;
        return t[e];
      }
    }, {
      key: "_setModuleState",
      value: function _setModuleState(e, t) {
        var a = this,
            n = "is" + e.substring(0, 1).toUpperCase() + e.substring(1),
            o = "on" + e.substring(0, 1).toUpperCase() + e.substring(1);

        for (var _r12 = 0; _r12 < a.modulesList.length; _r12++) {
          var _i43 = a.modulesList[_r12];
          _i43[n] = !0, _i43[e] && _i43[e](t), _i43[o] && _i43[o](t);
        }
      }
    }, {
      key: "addModule",
      value: function addModule(e, t) {
        var i = this;
        if (!e) return;
        var a = i.modules.slice(0),
            n = e.prototype,
            o = Object.getPrototypeOf(e);
        o.name && o.name !== e.name && i.addModule(o), !e.moduleName && e.name && (e.moduleName = e.name), -1 === a.findIndex(function (t) {
          return e.moduleName === t.moduleName;
        }) && a.push(e), i.defineModule(e), i.defineElementMethods(n.methodNames, n), i.defineElementProperties(e.properties);
        var r = i.constructor.prototype;
        if (r.modules = a, t) for (var _t53 in Smart.Elements.tagNames) {
          var _a35 = Smart.Elements.tagNames[_t53];

          var _n26 = Object.getPrototypeOf(_a35),
              _o20 = [];

          for (; _n26 !== HTMLElement;) {
            _o20.push(_n26.prototype), _n26 = Object.getPrototypeOf(_n26);
          }

          0 <= _o20.indexOf(i) && _a35 !== i && _a35.prototype.addModule(e);
        }
      }
    }, {
      key: "defineModule",
      value: function defineModule(e) {
        if (e.isDefined) return;

        e.prototype._initModule = function (e) {
          var t = this;
          t.ownerElement = e;
        };

        var t = e.properties || {},
            i = Object.keys(t),
            a = Object.getOwnPropertyNames(e.prototype);
        e.prototype.methodNames = a;

        var _loop7 = function _loop7(_a36) {
          var n = i[_a36],
              o = t[n];
          Object.defineProperty(e.prototype, n, {
            configurable: !1,
            enumerable: !0,
            get: function get() {
              var e = this;
              return e.ownerElement ? e.ownerElement[n] : o.value;
            },
            set: function set(e) {
              var t = this;
              t.ownerElement[n] = e;
            }
          });
        };

        for (var _a36 = 0; _a36 < i.length; _a36 += 1) {
          _loop7(_a36);
        }

        e.isDefined = !0;
      }
    }, {
      key: "getStaticMember",
      value: function getStaticMember(e, t) {
        var i = this,
            a = window[u][i.elementName],
            n = a[e];
        t || (t = "");
        var o = "array" === t ? [] : "string" === t ? "" : {},
            r = Object.getPrototypeOf(a),
            l = [];

        for (; r[e];) {
          l.push(r[e]), r = Object.getPrototypeOf(r);
        }

        for (var _a37 = l.length - 1; 0 <= _a37; _a37--) {
          if ("array" === t) for (var _e52 = 0; _e52 < l[_a37].length; _e52++) {
            -1 === o.indexOf(l[_a37][_e52]) && o.push(l[_a37][_e52]);
          } else "string" === t ? -1 === o.indexOf(l[_a37]) && (o += l[_a37]) : o = Utilities.Core.assign(o, l[_a37]);
        }

        if ("array" === t) {
          for (var _e53 = 0; _e53 < n.length; _e53++) {
            -1 === o.indexOf(n[_e53]) && o.push(n[_e53]);
          }

          return o;
        }

        return "string" === t ? (-1 === o.indexOf(n) && (o += n), o) : Utilities.Core.assign(o, n);
      }
    }, {
      key: "defineElementHierarchicalProperties",
      value: function defineElementHierarchicalProperties(e, t) {
        var i = this,
            a = [];
        (function (e) {
          var n = Object.keys(e);

          for (var _o21 = 0; _o21 < n.length; _o21++) {
            var _i44 = n[_o21];
            if ("messages" === _i44) continue;

            var _r13 = e[_i44],
                _l9 = Object.keys(_r13),
                _s5 = 0 <= _l9.indexOf("value") && 0 <= _l9.indexOf("type") && "object" == typeof _r13.value;

            if ("propertyObject" === _r13.type || _s5) {
              (function () {
                var e = function e(i, n) {
                  if (i.value) {
                    var _o22 = Object.keys(i.value);

                    var _loop9 = function _loop9(_r14) {
                      var l = _o22[_r14],
                          s = i.value[l],
                          d = n + "_" + l;
                      if ("object" != typeof s || null === s) return "break";
                      var c = Object.keys(s),
                          m = 0 <= c.indexOf("value") && 0 <= c.indexOf("type");
                      if (!m) return "break";

                      if ("array" !== i.type && (i.isHierarchicalProperty = !0), s.parentPropertyName = n, t) {
                        var _e54 = t._properties[d];
                        if (i.value.hasOwnProperty(l)) if (!_e54.isDefined) delete i.value[l];else return "continue";
                        _e54.isDefined = !0, Object.defineProperty(i.value, l, {
                          configurable: !1,
                          enumerable: !0,
                          get: function get() {
                            return t._properties[d].value;
                          },
                          set: function set(e) {
                            t.updateProperty(t, t._properties[d], e);
                          }
                        });
                      }

                      a[d] || (a[d] = s, a.length++), ("propertyObject" === s.type || "object" == typeof s.value && "array" !== s.type) && (t ? e(t._properties[d], d) : e(s, d));
                    };

                    _loop8: for (var _r14 = 0; _r14 < _o22.length; _r14++) {
                      var _ret2 = _loop9(_r14);

                      switch (_ret2) {
                        case "break":
                          break _loop8;

                        case "continue":
                          continue;
                      }
                    }
                  }
                };

                e(_r13, _i44);
              })();
            }
          }
        })(e), 0 < a.length && !t && i.defineElementProperties(a);
      }
    }, {
      key: "defineElement",
      value: function defineElement() {
        var e = this,
            t = e.constructor.prototype,
            i = e.getStaticMember("properties"),
            a = Object.getOwnPropertyNames(t);
        t.extendedProperties = {}, t.boundProperties = {}, t.templateListeners = {}, e.defineElementModules(), e.defineElementMethods(a, t), e.defineElementProperties(i), e.defineElementHierarchicalProperties(e.extendedProperties), t._initElement = function () {
          var e = this,
              a = t.extendedProperties,
              n = Object.keys(a),
              o = e.modules;
          e.$ = Utilities.Extend(e), e.$document = b, e.smartId = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase(), e.isCreated || (e.modulesList = [], e._properties = [], e._beforeCreatedProperties && (e._properties = e._beforeCreatedProperties, delete e._beforeCreatedProperties), e.detachedChildren = [], e.propertyByAttributeName = []);

          for (var _t54 = 0; _t54 < o.length; _t54 += 1) {
            var _i45 = o[_t54];

            var _a38 = new _i45();

            _a38._initModule(e), e.modulesList.push(_a38);
          }

          var _loop10 = function _loop10(_t55) {
            var i = n[_t55],
                o = a[i];
            var r = o.value;
            if (e._properties[i]) if (void 0 !== e._properties[i].notify) return "continue";else delete e._properties[i];

            if (C && "innerHTML" === i && delete e[i], -1 === window.navigator.userAgent.indexOf("PhantomJS") && e.hasOwnProperty(i) && (r = e[i], delete e[i]), "array" === o.type && void 0 !== r && null !== r && (r = r.slice(0)), "object" === o.type && void 0 !== r && null !== r && (Array.isArray(r) ? r = r.slice(0) : r = Object.assign({}, r)), e._properties[i] = {
              name: i,
              notify: o.notify,
              allowedValues: o.allowedValues,
              type: o.type,
              nullable: o.nullable,
              reflectToAttribute: o.reflectToAttribute,
              defaultReflectToAttribute: o.defaultReflectToAttribute,
              defaultReflectToAttributeConditions: o.defaultReflectToAttributeConditions,
              value: r,
              readOnly: o.readOnly,
              defaultValue: r,
              attributeName: o.attributeName,
              observer: o.observer,
              inherit: o.inherit,
              extend: o.extend,
              validator: o.validator
            }, e.propertyByAttributeName[o.attributeName] = e._properties[i], !o.hasOwnProperty("type")) {
              var _t56 = e.localize("propertyUnknownType", {
                name: i
              });

              e.log(_t56);
            }

            if ("any" === o.type || "propertyObject" === o.type) return "continue";
            var l = Utilities.Types.getType(r);

            if (void 0 !== r && null !== r && o.type !== l && !o.validator) {
              if ("object" === o.type && "array" === l) return "continue";

              if ("number" === l) {
                var _e55 = ["integer", "int", "float"].findIndex(function (e) {
                  return e === o.type;
                });

                if (0 <= _e55) return "continue";
              }

              var _t57 = e.localize("propertyInvalidValueType", {
                name: i,
                actualType: l,
                type: o.type
              });

              e.log(_t57);
            }
          };

          for (var _t55 = 0; _t55 < n.length; _t55 += 1) {
            var _ret3 = _loop10(_t55);

            if (_ret3 === "continue") continue;
          }

          e.defineElementHierarchicalProperties(e._properties, e), e.isCreated = !0;
        }, t.registered();
      }
    }, {
      key: "defineElementMethods",
      value: function defineElementMethods(e, t) {
        var i = this,
            a = i.constructor.prototype,
            n = function n(e, t) {
          var i = Array.prototype.slice.call(arguments, 2),
              a = function a() {
            if (!this.isReady && "localize" !== t && "localize" !== t && "cloneNode" !== t && "importStyle" !== t && "log" !== t && "parseAttributes" !== t) {
              var _e56 = this.localize("elementNotInDOM");

              this.log(_e56);
            }

            var a = this;

            for (var _e57 = 0, _i46; _e57 < this.modulesList.length; _e57++) {
              if (_i46 = this.modulesList[_e57], t in _i46) {
                a = _i46;
                break;
              }
            }

            var n = this.context,
                o = i.concat(Array.prototype.slice.call(arguments));
            var r = null;

            var l = function l(e, t) {
              return e === t || "number" === e && ("int" === t || "integer" === t || "float" === t) || "bool" === e && "boolean" === t || "boolean" === e && "bool" === t || "object" === e && "any" === t || void 0;
            };

            if (this.methods) {
              var _e58 = this.methods[t];

              if (_e58) {
                var _i47 = _e58.split(":");

                r = _i47[_i47.length - 1].trim();

                var _a39 = _e58.substring(1 + _e58.indexOf("("), _e58.lastIndexOf(")")),
                    _n27 = [],
                    _s6 = _a39.split(",");

                var _d4 = "";

                for (var _e59 = 0; _e59 < _s6.length; _e59++) {
                  var _t58 = _s6[_e59];
                  _d4 += _t58, 0 <= _t58.indexOf(":") ? (_n27.push(_d4), _d4 = "") : _d4 += ",";
                }

                var _c3 = _n27.length;

                for (var _e60 = 0; _e60 < _n27.length; _e60++) {
                  var _i48 = _n27[_e60].trim(),
                      _a40 = _i48.split(":"),
                      _r15 = _a40[0].split("=")[0].trim(),
                      _s7 = 0 <= _r15.indexOf("?"),
                      _d5 = 0 <= _a40[1].indexOf("?"),
                      _m3 = _a40[1].replace(/\?/ig, "").trim(),
                      _u = _m3.split("|");

                  var _p = _a40[0].split("=")[1];

                  var _g = Utilities.Types.getType(o[_e60]);

                  if (void 0 === o[_e60] && _p) {
                    switch (_p = _p.trim(), _m3[0]) {
                      case "date":
                        {
                          var _e61 = _p.substring(_p.indexOf("(") + 1, _p.lastIndexOf(")"));

                          _e61 = 0 < _e61.length ? _e61.split(",").map(function (e) {
                            return parseInt(e);
                          }) : [], _p = 0 === _e61.length ? new Date() : new Date(_e61[0], _e61[1], _e61[2]);
                          break;
                        }

                      case "bool":
                      case "boolean":
                        _p = "true" === _p || "1" === _p;
                        break;

                      case "int":
                      case "integer":
                        _p = parseInt(_p);
                        break;

                      case "float":
                      case "number":
                        _p = parseFloat(_p);
                        break;

                      case "any":
                      case "object":
                        _p = 0 <= _p.indexOf("{") ? JSON.parse(_p) : _p;
                    }

                    o.push(_p);
                  } else _s7 && _c3--;

                  if (_m3 !== _g && _g) {
                    var _i49 = !0;

                    for (var _e62 = 0; _e62 < _u.length; _e62++) {
                      if (l(_g, _u[_e62])) {
                        _i49 = !1;
                        break;
                      }
                    }

                    if (_i49 && !(null === o[_e60] && _d5)) {
                      var _i50 = this.localize("methodInvalidValueType", {
                        name: t,
                        actualType: _g,
                        type: _m3,
                        argumentIndex: _e60
                      });

                      this.log(_i50);
                    }
                  }

                  if (o.length < _c3) {
                    var _e63 = this.localize("methodInvalidArgumentsCount", {
                      name: t,
                      actualArgumentsCount: o.length,
                      argumentsCount: _c3
                    });

                    this.log(_e63);
                  }
                }
              }
            }

            this.context = this;
            var s = e.apply(a, o);

            if (r) {
              var _e64 = void 0 === Utilities.Types.getType(s) ? "void" : Utilities.Types.getType(s);

              if (!l(_e64, r)) {
                var _i51 = this.localize("methodInvalidReturnType", {
                  name: t,
                  actualType: _e64,
                  type: r
                });

                this.log(_i51);
              }
            }

            return this.context = n, s;
          };

          return a;
        },
            o = ["constructor", "ready", "created", "render", "attached", "detached", "appendChild", "insertBefore", "removeChild", "connect", "disconnectedCallback", "connectedCallback", "attributeChangedCallback", "propertyChangedHandler", "enableShadowDOM", "isInShadowDOM"];

        var _loop11 = function _loop11(_i52) {
          var r = e[_i52];
          r.startsWith("_") || void 0 !== o.find(function (e) {
            return e === r;
          }) || !a.extendedProperties[r] && Utilities.Types.isFunction(t[r]) && (a[r] = n(t[r], r));
        };

        for (var _i52 in e) {
          _loop11(_i52);
        }
      }
    }, {
      key: "defineElementProperties",
      value: function defineElementProperties(e) {
        if (!e) return;
        var t = this,
            a = t.constructor.prototype,
            n = Object.keys(e),
            o = t.getStaticMember("properties");
        Object.assign(a.extendedProperties, e), t.updateProperty = function (e, t, a) {
          var n = e;
          if (!t || t.readOnly) return;

          if (t.allowedValues) {
            var _e65 = !1;

            for (var _n28 = 0; _n28 < t.allowedValues.length; _n28++) {
              if (t.allowedValues[_n28] === a) {
                _e65 = !0;
                break;
              }
            }

            if (!_e65) {
              var _e66 = JSON.stringify(t.allowedValues).replace(/\[|\]/gi, "").replace(",", ", ").replace(/"/gi, "'"),
                  _i53 = "'" + a + "'",
                  _o23 = n.localize("propertyInvalidValue", {
                name: t.name,
                actualValue: _i53,
                value: _e66
              });

              return void n.log(_o23);
            }
          }

          var i = t.name,
              o = n._properties[i].value;

          if (t.validator && n[t.validator]) {
            var _e67 = n.context;
            n.context = n;

            var _i54 = n[t.validator](o, a);

            void 0 !== _i54 && (a = _i54), n.context = _e67;
          }

          if (o !== a) {
            if (n.propertyChanging) {
              var _e68 = n.propertyChanging(i, o, a);

              if (!1 === _e68 || null === _e68) return;
            }

            if (!t.hasOwnProperty("type")) {
              var _e69 = n.localize("propertyUnknownType", {
                name: i
              });

              n.log(_e69);
            }

            if ("array" !== t.type || JSON.stringify(o) !== JSON.stringify(a)) {
              if (void 0 !== a && null !== a && "any" !== t.type && "propertyObject" !== t.type && t.type !== Utilities.Types.getType(a) && !t.validator || null === a && !t.nullable) {
                var _e71 = !0;

                if ("object" === t.type && "array" === Utilities.Types.getType(a) && (_e71 = !1), "number" === Utilities.Types.getType(a)) {
                  var _i55 = ["integer", "int", "float"].findIndex(function (e) {
                    return e === t.type;
                  });

                  0 <= _i55 && (_e71 = !1);
                }

                if (_e71) {
                  var _e72 = n.localize("propertyInvalidValueType", {
                    name: i,
                    actualType: Utilities.Types.getType(a),
                    type: t.type
                  });

                  return void n.error(_e72);
                }
              }

              if (t.isUpdating = !0, t.isHierarchicalProperty) {
                var _e73 = function _e73(t, a) {
                  var o = Object.keys(t);

                  for (var _r16 = 0; _r16 < o.length; _r16++) {
                    var _i56 = o[_r16],
                        _l10 = t[_i56];
                    "object" == typeof _l10 && !Utilities.Types.isArray(_l10) && _l10 && _l10.constructor !== Date ? _e73(_l10, a + "_" + _i56) : n[a + "_" + _i56] = _l10;
                  }
                };

                _e73(a, i);
              } else n._properties[i].value = a;

              !t.isUpdatingFromAttribute && t.reflectToAttribute && n.$.setAttributeValue(t.attributeName, a, t.type);

              var _e70 = n.isReady && (!n.ownerElement || n.ownerElement && n.ownerElement.isReady);

              if (_e70) {
                if ("wait" !== i || a || !o || n.isCompleted || (n.classList.remove("smart-visibility-hidden"), n.ownerElement && n.ownerElement.updateBoundMappedNodes(), n.updateBoundMappedNodes(), n.complete()), "renderMode" === i) return;

                if (n.context !== n && !n.wait) {
                  var _e75 = n.context;
                  n.context = n, n.propertyChangedHandler(i, o, a), n.context = _e75, t.observer && n[t.observer] && (n.context = n, n[t.observer](o, a), n.context = document), n._watch && 0 <= n._watch.properties.indexOf(i) && n._watch.propertyChangedCallback(i, o, a);
                }

                var _e74 = t.notify || n.boundProperties[i];

                _e74 && (n.$.fireEvent(t.attributeName + "-changed", {
                  context: n.context,
                  oldValue: o,
                  value: n[i]
                }), n.boundProperties[i] && n.updateBoundNodes(i)), _e74 && n.templateProperties && n.templateProperties[i] && n.refreshTemplate(), n.dataContextProperties && ("dataContext" === i ? n.applyDataContext() : n.dataContextProperties[i] && n.updateDataContextProperty(i));
              }

              t.isUpdating = !1;
            }
          }
        };

        var _loop12 = function _loop12(_t59) {
          var i = n[_t59],
              r = e[i],
              l = Utilities.Core.toDash(i),
              s = r.type || "any",
              d = 0 <= s.indexOf("?") || "any" === s;
          (d && "any" !== s && (r.type = s.substring(0, s.length - 1)), r.nullable = d, r.attributeName = l.toLowerCase(), r.name = i, r.reflectToAttribute = void 0 === r.reflectToAttribute || r.reflectToAttribute, r.inherit && o[i] && (r.value = o[i].value), r.extend && o[i] && Utilities.Core.assign(r.value, o[i].value), !a.hasOwnProperty(i)) && Object.defineProperty(a, i, {
            configurable: !1,
            enumerable: !0,
            get: function get() {
              var e = this;
              return e._properties[i] ? e._properties[i].value : void 0;
            },
            set: function set(e) {
              var t = this;
              t.updateProperty(t, t._properties[i], e);
            }
          });
        };

        for (var _t59 = 0; _t59 < n.length; _t59 += 1) {
          _loop12(_t59);
        }
      }
    }, {
      key: "classNamesMap",
      get: function get() {
        return {
          animation: "smart-animate",
          rippleAnimation: "smart-ripple"
        };
      }
    }, {
      key: "hasAnimation",
      get: function get() {
        var e = this;
        return "none" !== e.animation;
      }
    }, {
      key: "hasRippleAnimation",
      get: function get() {
        var e = this;
        return "none" !== e.animation && !("advanced" !== e.animation);
      }
    }, {
      key: "properties",
      get: function get() {
        var e = this;
        return e._properties || (e._properties = []), e._properties;
      }
    }, {
      key: "parents",
      get: function get() {
        var e = this;
        var t = [],
            i = e.parentNode;

        for (; i && 9 !== i.nodeType;) {
          !0 == i instanceof HTMLElement && t.push(i), i = i.parentNode;
        }

        return window[u].EnableShadowDOM && e.isInShadowDOM && e.shadowParent && (t = t.concat(e.shadowParent.parents)), t;
      }
    }, {
      key: "focused",
      get: function get() {
        return this.contains(document.activeElement);
      }
    }, {
      key: "_selector",
      get: function get() {
        var e = this;
        return e.id ? "#" + e.id : 0 < e.classList.length ? "." + e.classList[0] : void 0;
      }
    }, {
      key: "hasStyleObserver",
      set: function set(e) {
        var t = this;
        t._hasStyleObserver === void 0 && (t._hasStyleObserver = e), e ? StyleObserver.watch(t) : StyleObserver.unwatch(t);
      },
      get: function get() {
        var e = this;
        return !(void 0 !== e._hasStyleObserver) || e._hasStyleObserver;
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          animation: {
            value: "advanced",
            type: "string",
            allowedValues: ["none", "simple", "advanced"]
          },
          unfocusable: {
            value: !1,
            type: "boolean"
          },
          disabled: {
            value: !1,
            type: "boolean"
          },
          dataContext: {
            value: null,
            reflectToAttribute: !1,
            type: "any"
          },
          messages: {
            value: {
              en: {
                propertyUnknownName: "Invalid property name: '{{name}}'!",
                propertyUnknownType: "'{{name}}' property is with undefined 'type' member!",
                propertyInvalidValue: "Invalid '{{name}}' property value! Actual value: '{{actualValue}}', Expected value: '{{value}}'!",
                propertyInvalidValueType: "Invalid '{{name}}' property value type! Actual type: '{{actualType}}', Expected type: '{{type}}'!",
                methodInvalidValueType: "Invalid '{{name}}' method argument value type! Actual type: '{{actualType}}', Expected type: '{{type}}' for argument with index: '{{argumentIndex}}'!",
                methodInvalidArgumentsCount: "Invalid '{{name}}' method arguments count! Actual arguments count: '{{actualArgumentsCount}}', Expected at least: '{{argumentsCount}}' argument(s)!",
                methodInvalidReturnType: "Invalid '{{name}}' method return type! Actual type: '{{actualType}}', Expected type: '{{type}}'!",
                elementNotInDOM: "Element does not exist in DOM! Please, add the element to the DOM, before invoking a method.",
                moduleUndefined: "Module is undefined.",
                missingReference: "{{elementType}}: Missing reference to '{{files}}'.",
                htmlTemplateNotSuported: "{{elementType}}: Web Browser doesn't support HTMLTemplate elements.",
                invalidTemplate: "{{elementType}}: '{{property}}' property accepts a string that must match the id of an HTMLTemplate element from the DOM."
              }
            },
            reflectToAttribute: !1,
            type: "object"
          },
          props: {
            value: null,
            reflectToAttribute: !1,
            isHierarchicalProperty: !0,
            type: "any"
          },
          readonly: {
            value: !1,
            type: "boolean"
          },
          renderMode: {
            value: "auto",
            type: "string",
            reflectToAttribute: !1,
            allowedValues: ["auto", "manual"]
          },
          rightToLeft: {
            value: !1,
            type: "boolean"
          },
          theme: {
            value: window[u].Theme,
            type: "string"
          },
          visibility: {
            value: "visible",
            allowedValues: ["visible", "collapsed", "hidden"],
            type: "string"
          },
          wait: {
            value: !1,
            type: "boolean"
          }
        };
      }
    }, {
      key: "requires",
      get: function get() {
        return {};
      }
    }, {
      key: "listeners",
      get: function get() {
        return {
          "theme-changed": function themeChanged(e) {
            this.theme = e.detail.newValue;
          }
        };
      }
    }, {
      key: "methods",
      get: function get() {
        return {};
      }
    }, {
      key: "modules",
      get: function get() {
        return window[u].Modules;
      }
    }, {
      key: "version",
      get: function get() {
        return window[u].Version;
      }
    }]);

    return BaseElement;
  }(_wrapNativeSuper(HTMLElement));

  var y = [],
      v = [],
      w = [],
      C = !1;
  var x = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

  if (x) {
    var _e76 = parseInt(x[2], 10);

    50 >= _e76 && (C = !0);
  }

  var S = function S() {
    if ("complete" === document.readyState) {
      w.sort(function (e, t) {
        var i = e.element.parents.length,
            a = t.element.parents.length;
        return i < a ? -1 : i > a ? 1 : 0;
      });

      for (var _e77 = 0; _e77 < w.length; _e77++) {
        w[_e77].element.isLoading = !1, w[_e77].callback();
      }

      w = [], document.removeEventListener("readystatechange", S);
    }
  };

  document.addEventListener("readystatechange", S);

  var BaseCustomElement =
  /*#__PURE__*/
  function (_BaseElement) {
    _inherits(BaseCustomElement, _BaseElement);

    _createClass(BaseCustomElement, [{
      key: "importStyle",
      value: function importStyle(e, t) {
        var i = this;

        i._importStyle(e, t);
      }
    }, {
      key: "_importStyle",
      value: function _importStyle(e, t) {
        var i = this;
        if (!i.shadowRoot || !e) return;

        var a = function a(e) {
          var a = i.shadowRoot.children;

          for (var _n29 = 0; _n29 < a.length; _n29++) {
            var _i57 = a[_n29];
            if (_i57 instanceof HTMLLinkElement && _i57.href === e) return t && t(), null;
          }

          var n = document.createElement("link");
          return n.rel = "stylesheet", n.type = "text/css", n.href = e, n.onload = t, n;
        },
            n = function () {
          var e = i.shadowRoot.children;
          var t = null;

          for (var _a41 = 0; _a41 < e.length; _a41++) {
            var _i58 = e[_a41];
            _i58 instanceof HTMLLinkElement && (t = _i58);
          }

          return t;
        }(),
            o = function o(e, t) {
          t.parentNode.insertBefore(e, t.nextSibling);
        };

        if (Array.isArray(e)) {
          var _t60 = document.createDocumentFragment();

          for (var _n30 = 0; _n30 < e.length; _n30++) {
            var _i59 = a(e[_n30]);

            _i59 && _t60.appendChild(_i59);
          }

          n ? o(_t60, n) : i.shadowRoot.insertBefore(_t60, i.shadowRoot.firstChild);
        } else {
          var _t61 = a(e);

          if (!_t61) return;
          n ? o(_t61, n) : i.shadowRoot.insertBefore(_t61, i.shadowRoot.firstChild);
        }
      }
    }, {
      key: "attributeChanged",
      value: function attributeChanged(e, t, i) {
        "style-url" === e && (this.styleUrl = i);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(e, t, i) {
        var a = this;
        a.isReady && _get(_getPrototypeOf(BaseCustomElement.prototype), "attributeChangedCallback", this).call(this, e, t, i);
      }
    }, {
      key: "styleUrl",
      get: function get() {
        return this._styleUrl;
      },
      set: function set(e) {
        this._styleUrl = e;
      }
    }, {
      key: "isInShadowDOM",
      get: function get() {
        var e = this;
        if (e.shadowParent) return !0;
        var t = !1;
        return void 0 !== e.enableShadowDOM && (t = function (t) {
          for (; t; t = t.parentNode) {
            if (t.host || t.enableShadowDOM || t.shadowRoot) return e.shadowParent = t.host ? t.host : t, !0;
          }

          return !1;
        }(e.parentNode)), t;
      }
    }, {
      key: "enableShadowDOM",
      get: function get() {
        var e = window[u].EnableShadowDOM;
        return e;
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        var e = this,
            t = ["external-style"];

        for (var _i60 in e.prototype.extendedProperties) {
          var _a42 = e.prototype.extendedProperties[_i60];
          t.push(_a42.attributeName);
        }

        return t;
      }
    }, {
      key: "styleUrls",
      get: function get() {
        return [];
      }
    }, {
      key: "styles",
      get: function get() {
        return "";
      }
    }]);

    function BaseCustomElement(e, t) {
      var _this2;

      _classCallCheck(this, BaseCustomElement);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(BaseCustomElement).call(this));

      var i = _assertThisInitialized(_this2);

      if (e) {
        t && (i._initProperties = t);

        var _a43 = function _a43(e) {
          if ("string" == typeof e ? document.querySelector(e) : e) {
            var _a44 = "string" == typeof e ? document.querySelector(e) : e;

            if (_a44 instanceof HTMLDivElement) {
              var _n31 = document.createElement(i.tagName);

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = _a44.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _e78 = _step.value;

                  _n31.setAttribute(_e78.name, _a44.getAttribute(_e78.name));
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              for (; _a44.childNodes.length;) {
                _n31.appendChild(_a44.firstChild);
              }

              return "string" == typeof e && (_n31.id = e.substring(1)), _n31._initProperties = t, _a44.parentNode && _a44.parentNode.replaceChild(_n31, _a44), _n31;
            }

            if (t) {
              var _e79 = _a44.context;

              if (_a44._initProperties = t, _a44.isReady) {
                _a44.context = _a44;
                var _i61 = {},
                    _n32 = {};

                for (var _e80 in t) {
                  _i61[_e80] = _a44[_e80], _n32[_e80] = t[_e80];
                }

                0 < Object.getOwnPropertyNames(t).length && (_a44.initProperties(), _a44.propertyChangedHandler(t, _i61, _n32)), _a44.context = _e79;
              }
            }

            return _a44;
          }
        };

        if ("string" == typeof e) {
          var _t62 = document.querySelectorAll(e),
              _n33 = [];

          if (1 < _t62.length) {
            for (var _e81 = 0; _e81 < _t62.length; _e81++) {
              var _i62 = _a43(_t62[_e81]);

              _n33.push(_i62);
            }

            return _possibleConstructorReturn(_this2, _n33);
          }
        } else if (e && 0 < e.length) {
          var _t63 = e;

          if (1 < _t63.length) {
            for (var _e82 = 0; _e82 < _t63.length; _e82++) {
              var _i63 = _a43(_t63[_e82]);

              y.push(_i63);
            }

            return _possibleConstructorReturn(_this2, y);
          }
        }

        return _possibleConstructorReturn(_this2, _a43(e));
      }

      i._styleUrl = "";
      i.isUtilityElement || i.created();
      return _this2;
    }

    _createClass(BaseCustomElement, [{
      key: "_getRootShadowParent",
      value: function _getRootShadowParent() {
        var e = this;
        var t = e.shadowParent;

        for (; t;) {
          if (!t.shadowParent) return t;
          t = t.shadowParent;
        }

        return t || e.shadowParent;
      }
    }, {
      key: "_getStyleUrl",
      value: function _getStyleUrl(e) {
        var t = this;
        var i = Utilities.Core.getScriptLocation() + window[u].StyleBaseUrl + e;
        return t.shadowParent && (i = i.replace("scoped/", "")), i;
      }
    }, {
      key: "_getStyleUrls",
      value: function _getStyleUrls() {
        var e = this;
        e.nodeName.startsWith(u);
        var t = e.getStaticMember("styleUrls", "array"),
            a = [];

        for (var _n34 = 0; _n34 < t.length; _n34++) {
          var _i64 = t[_n34],
              _o24 = e._getStyleUrl(_i64);

          a.push(_o24);
        }

        return a;
      }
    }, {
      key: "_getShadowDomStyleUrls",
      value: function _getShadowDomStyleUrls() {
        var e = this;
        var t = [].slice.call(e.querySelectorAll("[smart-id]")).concat(e.children);
        e.enableShadowDOM && !0 !== e.isInShadowDOM && (t = [].slice.call(e.shadowRoot.querySelectorAll("[smart-id]")).concat(t), t = [].slice.call(e.shadowRoot.querySelectorAll(".smart-element-init")).concat(t));

        var a = function a(e, n) {
          for (var _o25 = 0; _o25 < e.length; _o25++) {
            var _i65 = e[_o25];
            _i65.$ && _i65.$.isCustomElement && -1 === t.indexOf(_i65) && n.push(_i65), a(_i65.children, n);
          }
        };

        a(e.shadowRoot.children, t);
        var i = [],
            n = [];
        e.nodeName.startsWith(u) && (i = [e._getStyleUrl("smart.common.css")], n = [e._getStyleUrl("smart.misc.css")]);

        var o = e._getStyleUrls();

        for (var _e83 = 0; _e83 < t.length; _e83++) {
          var _i66 = t[_e83];

          if (_i66._getStyleUrls) {
            var _e84 = _i66._getStyleUrls();

            for (var _t64 = 0; _t64 < _e84.length; _t64++) {
              var _i67 = _e84[_t64];
              -1 === o.indexOf(_i67) && o.push(_i67);
            }
          }
        }

        return i.concat(o).concat(n);
      }
    }, {
      key: "_whenStylesReady",
      value: function _whenStylesReady(e) {
        var t = this;
        return t._stylesReady ? void e() : void (!t.whenStylesReady && (t.whenStylesReady = []), t.whenStylesReady.push(e));
      }
    }, {
      key: "_importShadowRootStyles",
      value: function _importShadowRootStyles() {
        var e = this,
            t = e._getShadowDomStyleUrls();

        e._styleUrls = t, e._styleUrlsReadyCount = 0;

        var i = function i() {
          if (e._stylesReady = !0, e.whenStylesReady) {
            for (var _t65 = 0; _t65 < e.whenStylesReady.length; _t65++) {
              e.whenStylesReady[_t65]();
            }

            e.whenStylesReady = [];
          }

          if (!e.isRendered && !e.hasAttribute("wait") && !e.isRendering) {
            if (e.resizeTrigger) {
              var _t66 = e.resizeTrigger.childNodes[0],
                  _i68 = e.resizeTrigger.childNodes[1];
              _t66.scrollLeft = 1e5, _t66.scrollTop = 1e5, _i68.scrollLeft = 1e5, _i68.scrollTop = 1e5;
            }

            e.isRendering = !0, e.context = e, e._renderShadowRoot(), e.render(), e.renderMode = "auto";
          }

          e.classList.remove("smart-element-init");
        };

        if (!document.adoptedStyleSheets) for (var _a45 = 0; _a45 < t.length; _a45++) {
          var _n35 = t[_a45];

          e._importStyle(_n35, function () {
            e._styleUrlsReadyCount++, e._styleUrlsReadyCount === e._styleUrls.length && (e._stylesReady = !0, i());
          });
        } else if (!window[u].AdoptedStyleSheets) {
          var _t67 = new CSSStyleSheet();

          var _a46 = Utilities.Core.getScriptLocation() + "/styles/smart.default.css";

          _t67.replace("@import url(\"" + _a46 + "\")").then(function () {
            i();
          }).catch(function (e) {
            console.error("Failed to load:", e);
          }), window[u].AdoptedStyleSheets = [_t67], e.shadowRoot.adoptedStyleSheets = window[u].AdoptedStyleSheets;
        } else e.shadowRoot.adoptedStyleSheets = window[u].AdoptedStyleSheets, i();
      }
    }, {
      key: "_setupShadowRoot",
      value: function _setupShadowRoot() {
        var e = this;
        e.isRendered || e.wait || (e.renderMode = "manual"), e.classList.add("smart-element-init"), e.setup(), e._importShadowRootStyles();
      }
    }, {
      key: "connect",
      value: function connect() {
        var e = this;
        if (e.enableShadowDOM && !e.shadowRoot && !0 !== e.isInShadowDOM && (e.attachShadow({
          mode: "open"
        }), e.shadowRoot && e.$.root && (e.shadowRoot.appendChild(e.$.root), e.$.root.classList.add(e.nodeName.toLowerCase()))), !e.shadowRoot && !e.shadowParent) e.setup();else if (e.shadowRoot) e._setupShadowRoot();else if (e.shadowParent && e.enableShadowDOM) {
          var _t68 = e._getRootShadowParent();

          if (e.isRendered || e.hasAttribute("wait") || (e.renderMode = "manual"), e.classList.add("smart-element-init"), e.setup(), _t68._styleUrls) {
            var _e85 = _t68._getShadowDomStyleUrls();

            _e85.length !== _t68._styleUrls.length && _t68._importShadowRootStyles();
          }

          _t68._whenStylesReady(function () {
            e.isRendered || e.wait || e.isRendering || (e.isRendering = !0, e.context = e, e.render(), e.renderMode = "auto"), e.classList.remove("smart-element-init");
          });
        } else e.setup();
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var e = this;
        if (e.isLoading || e.isUtilityElement) return;
        e.classList.add("smart-element-init");

        var t = function t() {
          e.classList.remove("smart-element-init");
        };

        if ("complete" === document.readyState) {
          var _i69 = e.parents;
          _i69.length && "HTML" === _i69[_i69.length - 1].nodeName ? (e.checkIsInDomTimer && clearInterval(e.checkIsInDomTimer), t(), e.connect()) : (e.checkIsInDomTimer && clearInterval(e.checkIsInDomTimer), 0 < _i69.length && (e.checkIsInDomTimer = setInterval(function () {
            var i = e.parents;
            0 === i.length && clearInterval(e.checkIsInDomTimer), 0 < i.length && "HTML" === i[i.length - 1].nodeName && (clearInterval(e.checkIsInDomTimer), t(), e.connect());
          }, 100)));
        } else e.isLoading = !0, w.push({
          element: this,
          callback: function () {
            this.isReady || (t(), this.connect());
          }.bind(e)
        });
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        var e = this;
        return e.isAttached ? void (e.shadowParent = null, e.detached()) : void e._resetShadowParent();
      }
    }, {
      key: "adoptedCallback",
      value: function adoptedCallback() {
        var e = this;
        e.setup();
      }
    }, {
      key: "appendTemplate",
      value: function appendTemplate(e) {
        var t = this;
        t.shadowRoot ? t.shadowRoot.appendChild(e) : t.appendChild(e);
      }
    }, {
      key: "_resetShadowParent",
      value: function _resetShadowParent() {
        var e = this;

        if (e.enableShadowDOM && null !== e.shadowParent) {
          var _t69 = [];

          for (var _i70 = e.parentNode; _i70 && 9 !== _i70.nodeType;) {
            if (!0 == _i70 instanceof HTMLElement) _t69.push(_i70);else if (11 === _i70.nodeType && _i70.host) {
              _i70 = _i70.host;
              continue;
            }
            _i70 = _i70.parentNode;
          }

          for (var _a47 = 0; _a47 < _t69.length; _a47++) {
            if (_t69[_a47] === e.shadowParent) return;
          }

          0 < _t69.length && "HTML" === _t69[_t69.length - 1].nodeName && (e.shadowParent = null);
        }
      }
    }]);

    return BaseCustomElement;
  }(BaseElement);

  var ElementRegistry =
  /*#__PURE__*/
  function () {
    function ElementRegistry() {
      _classCallCheck(this, ElementRegistry);
    }

    _createClass(ElementRegistry, null, [{
      key: "register",
      value: function register(e, t) {
        var i = t.prototype;
        var a = Core.toCamelCase(e).replace(/[a-z]+/, ""),
            n = t.version || window[u].Version;

        if (!(window.customElements.get(e) && window.customElements.get(e).version === n)) {
          var _o26 = e;

          for (n = n.split("."); window.customElements.get(e);) {
            e = _o26 + "-" + n.join("."), n[2] = parseInt(n[2]) + 1;
          }

          if (!y[e]) {
            if (e.startsWith(u.toLowerCase())) y[e] = window[u][a] = window[u.toLowerCase() + a] = t;else {
              var _i71 = e.split("-")[0];
              _i71 = _i71.substring(0, 1).toUpperCase() + _i71.substring(1), window[u][_i71] || (window[u][_i71] = {}), y[e] = window[u][_i71][a] = window[_i71.toLowerCase() + a] = t, window[u][a] && (a = Core.toCamelCase(e)), window[u][a] = t;
            }
            i.elementName = a, i.defineElement(), v[e] && v[e](i), window.customElements.define(e, t);
          }
        }
      }
    }, {
      key: "registerElements",
      value: function registerElements() {
        var e = this;

        if (e.toRegister) {
          e.isRegistering = !0;

          for (var _t70 = 0; _t70 < e.toRegister.length; _t70++) {
            var _i72 = e.toRegister[_t70];
            e.register(_i72.tagName, _i72.element);
          }

          e.isRegistering = !1;
        }
      }
    }, {
      key: "get",
      value: function get(e) {
        return y[e] ? y[e] : void 0;
      }
    }, {
      key: "whenRegistered",
      value: function whenRegistered(e, t) {
        if (!e) throw new Error("Syntax Error: Invalid tag name");
        var i = this,
            a = v[e],
            n = i.get(e),
            o = n ? n.modules.length : 3;

        try {
          a || n ? !a && n ? (t(n.prototype), v[e] = void 0) : a && !n ? v[e] = function (e) {
            a(e), t(e);
          } : a && n && (n.proto && (a(n.proto), t(n.proto)), v[e] = void 0) : v[e] = function (e) {
            try {
              t(e);
            } catch (e) {
              var _t71 = e instanceof Error ? e.message : e.toString();

              console.log(_t71);
            }
          };
        } catch (e) {
          var _t72 = e instanceof Error ? e.message : e.toString();

          console.log(_t72);
        }

        if (n && o !== n.prototype.modules.length) {
          var _t73 = document.querySelectorAll(e);

          for (var _e86 = 0; _e86 < _t73.length; _e86++) {
            var _i73 = _t73[_e86];
            _i73.isCreated && _i73._initElement();
          }
        }
      }
    }]);

    return ElementRegistry;
  }();

  ElementRegistry.lazyRegister = !1, ElementRegistry.tagNames = [];

  var Observable =
  /*#__PURE__*/
  function () {
    function Observable(e, t) {
      _classCallCheck(this, Observable);

      var i = this;
      this.name = "observable", e && Object.assign(i, e);

      (function (e) {
        Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach(function (t) {
          return "constructor" === t || !!t.startsWith("_") || void (i[t] = e[t]);
        });
      })(e);

      var a = new Proxy(i, {
        deleteProperty: function deleteProperty(e, t) {
          return delete e[t], !0;
        },
        get: function get(e, t) {
          return e[t];
        },
        set: function set(e, a, n) {
          var o = e[a];
          return !(o !== n) || !(e[a] = n, !("notifyFn" === a || a.startsWith("_") || "canNotify" === a)) || !!(t && -1 === t.indexOf(a)) || !i.canNotify || (i._notify({
            target: e,
            propertyName: a,
            oldValue: o,
            newValue: n
          }), !0);
        }
      });
      return a;
    }

    _createClass(Observable, [{
      key: "_notify",
      value: function _notify(e) {
        var t = this;
        if (t.canNotify && t.notifyFn) for (var _a48 = 0; _a48 < t.notifyFn.length; _a48++) {
          t.notifyFn[_a48](e);
        }
      }
    }, {
      key: "notify",
      value: function notify(e) {
        var t = this;
        e && (!t.notifyFn && (t.notifyFn = []), t.notifyFn.push(e));
      }
    }, {
      key: "canNotify",
      get: function get() {
        var e = this;
        return void 0 === e._canNotify && (e._canNotify = !0), e._canNotify;
      },
      set: function set(e) {
        var t = this;
        t._canNotify = e;
      }
    }]);

    return Observable;
  }();

  var ObservableArray =
  /*#__PURE__*/
  function () {
    function ObservableArray() {
      _classCallCheck(this, ObservableArray);

      var e = this;
      e.name = "observableArray", e.observables = 3 > arguments.length ? null : arguments[2];
      var t = new Proxy(e, {
        deleteProperty: function deleteProperty(e, t) {
          return delete e[t], !0;
        },
        apply: function apply(e, t, i) {
          return e.apply(t, i);
        },
        get: function get(t, i) {
          return t[i] || isNaN(parseInt(i)) ? t[i] : e.getItem(parseInt(i));
        },
        set: function set(t, i, a) {
          return t[i] || isNaN(parseInt(i)) ? (t[i] = a, !0) : (e.setItem(parseInt(i), a), !0);
        }
      });

      if (e._addArgs = {
        eventName: "change",
        object: t,
        action: "add",
        index: null,
        removed: [],
        addedCount: 1
      }, e._removeArgs = {
        eventName: "change",
        object: t,
        action: "remove",
        index: null,
        removed: null,
        addedCount: 0
      }, 1 <= arguments.length && Array.isArray(arguments[0])) {
        e._array = [];
        var _t74 = arguments[0];

        for (var _a49 = 0, _i74 = _t74.length; _a49 < _i74; _a49++) {
          var _i75 = e._getItem(e._array.length, _t74[_a49]);

          e._array.push(_i75);
        }
      } else e._array = Array.apply(null, arguments);

      return 2 === arguments.length && (e.notifyFn = arguments[1]), t;
    }

    _createClass(ObservableArray, [{
      key: "_notify",
      value: function _notify(e) {
        var t = this;
        !t.canNotify || t.notifyFn && t.notifyFn(e);
      }
    }, {
      key: "notify",
      value: function notify(e) {
        var t = this;
        e && (t.notifyFn = e);
      }
    }, {
      key: "toArray",
      value: function toArray() {
        var e = this;
        return e._array;
      }
    }, {
      key: "_getItem",
      value: function _getItem(e, t) {
        var i = this;
        if ("string" == typeof t) return t;
        if ("number" == typeof t) return t;
        if (void 0 === t) return t;
        var a = new Proxy(t, {
          deleteProperty: function deleteProperty(e, t) {
            delete e[t];
          },
          set: function set(t, a, n) {
            var o = t[a];
            return !(t[a] = n, i._canNotify && !1 !== t.canNotify) || !(!i.observables || i.observables[a]) || (i._notify({
              eventName: "change",
              object: i,
              target: t,
              action: "update",
              index: e,
              path: e + "." + a,
              oldValue: o,
              newValue: n,
              propertyName: a
            }), !0);
          }
        });
        return a;
      }
    }, {
      key: "getItem",
      value: function getItem(e) {
        return this._array[e];
      }
    }, {
      key: "setItem",
      value: function setItem(e, t) {
        var i = this,
            a = i._array[e];
        i._array[e] = i._getItem(e, t), i._notify({
          eventName: "change",
          object: i._array,
          action: "update",
          index: e,
          removed: [a],
          addedCount: 1
        });
      }
    }, {
      key: "toString",
      value: function toString() {
        var e = this;
        return e._array.toString();
      }
    }, {
      key: "toLocaleString",
      value: function toLocaleString() {
        var e = this;
        return e._array.toLocaleString();
      }
    }, {
      key: "concat",
      value: function concat() {
        var e = this;
        e._addArgs.index = e._array.length;

        var t = e._array.concat.apply(e._array, arguments);

        return new Smart.ObservableArray(t);
      }
    }, {
      key: "join",
      value: function join(e) {
        var t = this;
        return t._array.join(e);
      }
    }, {
      key: "pop",
      value: function pop() {
        var e = this;
        e._removeArgs.index = e._array.length - 1, delete e[e._array.length - 1];

        var t = e._array.pop();

        return e._removeArgs.removed = [t], e._notify(e._removeArgs), e._notifyLengthChange(), t;
      }
    }, {
      key: "push",
      value: function push() {
        var e = this;

        if (e._addArgs.index = e._array.length, 1 === arguments.length && Array.isArray(arguments[0])) {
          var _t75 = arguments[0];

          for (var _a50 = 0, _i76 = _t75.length; _a50 < _i76; _a50++) {
            var _i77 = e._getItem(e._array.length, _t75[_a50]);

            e._array.push(_i77);
          }
        } else {
          var _t76 = e._getItem(e._addArgs.index, arguments[0]);

          e._array.push.apply(e._array, [_t76]);
        }

        return e._addArgs.addedCount = e._array.length - e._addArgs.index, e._notify(e._addArgs), e._notifyLengthChange(), e._array.length;
      }
    }, {
      key: "_notifyLengthChange",
      value: function _notifyLengthChange() {
        var e = this;

        if (e.canNotify) {
          var _t77 = e._createPropertyChangeData("length", e._array.length);

          e._notify(_t77);
        }
      }
    }, {
      key: "_createPropertyChangeData",
      value: function _createPropertyChangeData(e, t, i) {
        return {
          eventName: "change",
          object: this,
          action: e,
          value: t,
          oldValue: i
        };
      }
    }, {
      key: "reverse",
      value: function reverse() {
        var e = this;
        return e._array.reverse();
      }
    }, {
      key: "shift",
      value: function shift() {
        var e = this,
            t = e._array.shift();

        return e._removeArgs.index = 0, e._removeArgs.removed = [t], e._notify(e._removeArgs), e._notifyLengthChange(), t;
      }
    }, {
      key: "slice",
      value: function slice(e, t) {
        var i = this;
        return i._array.slice(e, t);
      }
    }, {
      key: "sort",
      value: function sort(e) {
        var t = this;
        return t._array.sort(e);
      }
    }, {
      key: "splice",
      value: function splice(e, t, a) {
        var n = this,
            i = n._array.length;
        var o;
        if (a && a.length) for (var _r17 = 0; _r17 < a.length; _r17++) {
          o = n._array.splice(e + _r17, t, a[_r17]);
        } else o = n._array.splice.apply(n._array, arguments);
        if (!a) n._notify({
          eventName: "change",
          object: this,
          action: "remove",
          index: e,
          removed: o,
          addedCount: n._array.length > i ? n._array.length - i : 0
        });else {
          var _t78 = n.canNotify;
          if (n.canNotify = !1, a.length) for (var _t79 = 0; _t79 < a.length; _t79++) {
            n.setItem(e + _t79, a[_t79]);
          } else n.setItem(e, a);
          n.canNotify = _t78, n._notify({
            eventName: "change",
            object: this,
            action: "add",
            index: e,
            added: o,
            addedCount: n._array.length > i ? n._array.length - i : 0
          });
        }
        return n._array.length !== i && n._notifyLengthChange(), o;
      }
    }, {
      key: "unshift",
      value: function unshift() {
        var e = this,
            t = e._array.length,
            i = e._array.unshift.apply(e._array, arguments);

        return e._addArgs.index = 0, e._addArgs.addedCount = i - t, e._notify(this._addArgs), e._notifyLengthChange(), i;
      }
    }, {
      key: "indexOf",
      value: function indexOf(e, t) {
        var a = this,
            n = t ? t : 0;

        for (var _o27 = n, _i78 = a._array.length; _o27 < _i78; _o27++) {
          if (a._array[_o27] === e) return _o27;
        }

        return -1;
      }
    }, {
      key: "lastIndexOf",
      value: function lastIndexOf(e, t) {
        var a = this,
            n = t ? t : a._array.length - 1;

        for (var _o28 = n; 0 <= _o28; _o28--) {
          if (a._array[_o28] === e) return _o28;
        }

        return -1;
      }
    }, {
      key: "find",
      value: function find(e, t) {
        var i = this;
        return i._array.find(e, t);
      }
    }, {
      key: "findIndex",
      value: function findIndex(e, t) {
        var i = this;
        return i._array.findIndex(e, t);
      }
    }, {
      key: "every",
      value: function every(e, t) {
        var i = this;
        return i._array.every(e, t);
      }
    }, {
      key: "some",
      value: function some(e, t) {
        var i = this;
        return i._array.some(e, t);
      }
    }, {
      key: "forEach",
      value: function forEach(e, t) {
        var i = this;

        i._array.forEach(e, t);
      }
    }, {
      key: "map",
      value: function map(e, t) {
        var i = this;
        return i._array.map(e, t);
      }
    }, {
      key: "filter",
      value: function filter(e, t) {
        var i = this,
            a = i._array.filter(e, t);

        return a;
      }
    }, {
      key: "reduce",
      value: function reduce(e, t) {
        var i = this;
        return t === void 0 ? i._array.reduce(e) : i._array.reduce(e, t);
      }
    }, {
      key: "reduceRight",
      value: function reduceRight(e, t) {
        var i = this;
        return t === void 0 ? i._array.reduceRight(e) : i._array.reduceRight(e, t);
      }
    }, {
      key: "canNotify",
      get: function get() {
        var e = this;
        return void 0 === e._canNotify && (e._canNotify = !0), e._canNotify;
      },
      set: function set(e) {
        var t = this;
        t._canNotify = e;
      }
    }, {
      key: "length",
      get: function get() {
        return this._array.length;
      },
      set: function set(e) {
        var t = this;
        Types.isNumber(e) && t._array && t._array.length !== e && t.splice(e, t._array.length - e);
      }
    }]);

    return ObservableArray;
  }();

  var D = {};
  window[u] && (D = window[u]), window[u] = function (t, i) {
    var a = t;

    if (t) {
      if (0 <= t.indexOf("#") || 0 <= t.indexOf(".")) return _[t] ? _[t] : i ? (_[t] = new i(), e(t, _[t]), _[t]) : void 0;

      if (i) {
        if (ElementRegistry.tagNames[t] = i, ElementRegistry.lazyRegister) {
          ElementRegistry.toRegister || (ElementRegistry.toRegister = []);

          var _e87 = Core.toCamelCase(a).replace(/[a-z]+/, "");

          return window[u][_e87] = i, void ElementRegistry.toRegister.push({
            tagName: a,
            element: i
          });
        }

        ElementRegistry.register(a, i);
      }
    }
  }, window.addEventListener("load", function () {
    var e = window[u].Elements.tagNames;
    var t = [];

    for (var _i79 in e) {
      var _a51 = e[_i79];

      var _n36 = document.querySelectorAll("[" + _i79 + "]");

      for (var _e88 = 0; _e88 < _n36.length; _e88++) {
        var _t80 = _n36[_e88];
        _t80 instanceof HTMLDivElement && (_t80.__proto__ = _a51.prototype, _t80.created(), _t80.connectedCallback()), _t80.classList.add("smart-element-ready");
      }

      var _o29 = _a51.name;
      "Item" === _o29 && (_o29 = "ListItem"), _n36 = document.querySelectorAll("[is=\"" + u.toLocaleLowerCase() + _o29 + "\"]");

      for (var _e89 = 0; _e89 < _n36.length; _e89++) {
        t.push(_n36[_e89]);
      }
    }

    if (0 < t.length) {
      var _e90 = function _e90(e) {
        var t = [],
            i = e.parentNode;

        for (; i && 9 !== i.nodeType;) {
          !0 == i instanceof HTMLElement && t.push(i), i = i.parentNode;
        }

        return t;
      };

      t.sort(function (t, i) {
        var a = _e90(t).length,
            n = _e90(i).length;

        return a < n ? 1 : a > n ? -1 : 0;
      });

      for (var _e91 = 0; _e91 < t.length; _e91++) {
        var _i80 = t[_e91],
            _a52 = _i80.getAttribute("is");

        var _n37 = void 0;

        _n37 = "smartItem" === _a52 ? new window.smartListItem(_i80) : new window[_a52](_i80), _n37.removeAttribute("is");
      }
    }
  });

  var Component =
  /*#__PURE__*/
  function () {
    function Component(e, t) {
      _classCallCheck(this, Component);

      var i = this,
          a = this.name;
      var n = null;
      return e ? n = new window[a](e, t) : (n = new window[a](), n._initProperties = t), i._element = n, n;
    }

    _createClass(Component, [{
      key: "name",
      get: function get() {
        return "Component";
      }
    }, {
      key: "element",
      get: function get() {
        return this._element;
      }
    }]);

    return Component;
  }();

  var App =
  /*#__PURE__*/
  function () {
    function App(e) {
      _classCallCheck(this, App);

      var t = this;
      t._id = e.id, e.id ? t._appRoot = document.getElementById(t._id) : t._id = window[u].Utilities.Core.createGUID(), e.selector && (t._id = window[u].Utilities.Core.createGUID(), t._appRoot = document.querySelector(e.selector)), t._appRoot || (t._appRoot = document.body), t._appRoot.classList.add("smart-visibility-hidden");
      var i = {};

      if (e.render) {
        var _t81 = e.render(),
            _a53 = e.components,
            _n38 = function _n38() {
          var n = document.createDocumentFragment(),
              o = document.implementation.createDocument("http://www.w3.org/1999/xhtml", "html", null),
              r = document.createElementNS("http://www.w3.org/1999/xhtml", "body"),
              l = document.createElement("div");
          o.documentElement.appendChild(r), r.appendChild(l), l.innerHTML = _t81;

          for (var _e92 = 0; _e92 < _a53.length; _e92++) {
            var _t82 = _a53[_e92],
                _n39 = _t82.name,
                _r18 = Utilities.Core.toDash(_n39),
                _s8 = o.querySelectorAll(_n39);

            _t82.tagName = _r18;

            for (var _e93 = 0; _e93 < _s8.length; _e93++) {
              var _t83 = _s8[_e93],
                  _a54 = _t83.getAttribute("id") || window[u].Utilities.Core.createGUID(),
                  _o30 = document.createElement("div");

              _o30.id = _a54, l.insertBefore(_o30, _t83), i["#" + _a54] = {
                name: _n39,
                properties: [],
                rendered: !1
              }, _t83.parentNode.removeChild(_t83);
            }
          }

          n.appendChild(l);
          var s = document.querySelector(e.selector);
          s && s.appendChild(n);
        };

        _n38();
      }

      t._template = e.template || {}, t._data = e.data || {}, t._components = i;

      var a = function a() {
        t._addAttributeBindings(), t._renderForBindings(), t._addModelBindings(), t._observeData(), t.render(), t._appRoot.classList.remove("smart-visibility-hidden");
      };

      "complete" === document.readyState ? a() : window.addEventListener("load", a);
    }

    _createClass(App, [{
      key: "_addAttributeBindings",
      value: function _addAttributeBindings(e, i) {
        var a = this,
            n = new BindingModule(),
            o = e ? n.getBindings(e) : n.getBindings(a._appRoot);
        i || (i = "");

        var r = function r() {
          return t(65536 * (1 + Math.random())).toString(16).substring(1);
        },
            l = function l(e) {
          var t = function t(e) {
            if (e.data) {
              var _t84 = e.node.id;

              for (var _n40 in _t84 || (e.node.id = _t84 = "id" + r()), e.data) {
                var _o31 = e.data[_n40];

                if ("textContent" == _n40 && (e.node.parentNode.id ? _t84 = e.node.parentNode.id : (e.node.id = "", e.node.parentNode.id = _t84)), _o31.isEvent) {
                  var _e94 = {};
                  _e94[_o31.name] = _o31.value, a._addListenerBinding(_t84, _e94);
                } else {
                  var _e95 = {};
                  _e95[_n40] = i + _o31.name, a._addTemplateBinding(_t84, _e95);
                }
              }
            }
          };

          for (var _i81 in t(e), e.children) {
            var _a55 = e.children[_i81];
            _a55.node && _a55.node.getAttribute && _a55.node.getAttribute("smart-for") && null === _a55.node.getAttribute("smart-for-rendered") || (t(_a55), _a55.children && l(_a55));
          }
        };

        l(o);
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var e = this,
            t = function t(e, i) {
          for (var _a56 in e) {
            if (_a56.startsWith("_") || "notifyFn" == _a56 || "canNotify" == _a56 || "name" == _a56) continue;
            if ("propertyName" == _a56 || "toString" == _a56 || "propertyIsEnumerable" == _a56 || "valueOf" == _a56 || "toLocaleString" == _a56) continue;
            if ("hasOwnProperty" == _a56 || "isPrototypeOf" == _a56) continue;
            var _n41 = e[_a56];

            if ("observableArray" === _n41.name) {
              i[_a56] = _n41.toArray();
              continue;
            }

            if ("observable" === _n41.name) {
              var _e96 = {};

              for (var _i82 in _n41) {
                if (!(_i82.startsWith("_") || "propertyIsEnumerable" == _i82 || "notifyFn" == _i82 || "canNotify" == _i82 || "name" == _i82) && !(_i82.startsWith("_") || "notifyFn" == _i82 || "canNotify" == _i82 || "name" == _i82) && "propertyName" != _i82 && "toString" != _i82 && "valueOf" != _i82 && "toLocaleString" != _i82 && "hasOwnProperty" != _i82 && "isPrototypeOf" != _i82) {
                  if ("object" == typeof _n41 && "object" == typeof _n41[_i82] && !Utilities.Types.isFunction(_n41)) {
                    var _o32 = t(_n41[_i82], {}, _a56 + "." + _i82);

                    _e96[_i82] = _o32;
                    continue;
                  }

                  _e96[_i82] = _n41[_i82];
                }
              }

              i[_a56] = _e96;
              continue;
            }

            if ("object" == typeof _n41 && !Utilities.Types.isFunction(_n41)) {
              var _e97 = t(_n41, {}, _a56);

              i[_a56] = _e97;
              continue;
            }

            i[_a56] = _n41;
          }

          return i;
        },
            i = t(e._data, {}, "");

        return i;
      }
    }, {
      key: "_addTemplateBinding",
      value: function _addTemplateBinding(e, t) {
        var i = this;
        i.template["#" + e] ? i.template["#" + e].bind ? Object.assign(i.template["#" + e].bind, t) : i.template["#" + e].bind = t : i.template["#" + e] = {
          bind: t
        };
      }
    }, {
      key: "_addListenerBinding",
      value: function _addListenerBinding(e, t) {
        var i = this;
        i.template["#" + e] ? i.template["#" + e].listeners ? Object.assign(i.template["#" + e].listeners, t) : i.template["#" + e].listeners = t : i.template["#" + e] = {
          listeners: t
        };
      }
    }, {
      key: "_updateDataFromBooleanElement",
      value: function _updateDataFromBooleanElement(e, t) {
        var i = this,
            a = t.checked,
            n = i._data[a];
        if (!(e.value && "on" !== e.value)) i._data[a] = e.checked;else if (!(Array.isArray(n) || "observableArray" === n.name)) "radio" === e.type ? e.checked && (i._data[a] = e.value) : e.checked ? i._data[a] = e.value : i._data[a] = "";else if (e.checked) n.push(e.value);else {
          var _t85 = n.indexOf(e.value);

          0 <= _t85 && n.splice(_t85, 1);
        }
      }
    }, {
      key: "_updateDataFromNativeElement",
      value: function _updateDataFromNativeElement(e, t) {
        var i = this;

        if ("SELECT" === e.tagName && e.addEventListener("change", function () {
          var a = t.value;
          var n = i._data[a];

          if (e.__updating = !0, Array.isArray(n) || "observableArray" === n.name) {
            if (n = new ObservableArray(), e.selectedOptions) for (var _t86 = 0; _t86 < e.selectedOptions.length; _t86++) {
              var _i83 = e.selectedOptions[_t86];
              n.push(_i83.value);
            }
            i._data[a] = n;
          } else i._data[a] = e.value;

          e.__updating = !1;
        }), "INPUT" === e.tagName || "TEXTAREA" === e.tagName) {
          e.addEventListener("change", function () {
            e.__updating = !0, _a57 ? i._updateDataFromBooleanElement(e, t) : i._data.value = e.value, e.__updating = !1;
          });

          var _a57 = "checkbox" === e.type || "radio" === e.type;

          _a57 || e.addEventListener("keyup", function () {
            var a = t.value;
            i._data[a] = e.value;
          });
        }
      }
    }, {
      key: "_addModelBindings",
      value: function _addModelBindings(e) {
        var t = this,
            a = e ? e.querySelectorAll("[smart-model]") : t._appRoot.querySelectorAll("[smart-model]");

        for (var _n42 = 0; _n42 < a.length; _n42++) {
          var _e98 = a[_n42];
          var _i84 = {
            value: _e98.getAttribute("smart-model")
          };
          "list" === _e98.type && (_i84 = {
            selectedValues: _e98.getAttribute("smart-model")
          }), ("checkbox" === _e98.type || "radio" === _e98.type) && (_i84 = {
            checked: _e98.getAttribute("smart-model")
          }), _e98.id || (_e98.id = "id" + Smart.Utilities.Core.createGUID().replace(/-/ig, "")), t._updateDataFromNativeElement(_e98, _i84), t._addTemplateBinding(_e98.id, _i84);
        }
      }
    }, {
      key: "_renderForBindings",
      value: function _renderForBindings(e) {
        var t = this,
            a = t._appRoot.querySelectorAll("[smart-for]");

        for (var _n43 = 0; _n43 < a.length; _n43++) {
          var _e99 = a[_n43],
              _i85 = _e99.getAttribute("smart-for"),
              _o33 = t._data[_i85];

          _e99.id || (_e99.id = "id" + Smart.Utilities.Core.createGUID().replace(/-/ig, "")), _e99.setAttribute("smart-for-rendered", "");

          var _r19 = null !== _e99.getAttribute("smart-for-self"),
              _l11 = _r19 ? _e99.parentNode.querySelectorAll(".smart-for-item-" + _e99.id) : _e99.querySelectorAll(".smart-for-item-" + _e99.id);

          for (var _e100 = 0; _e100 < _l11.length; _e100++) {
            t.template[_l11[_e100].id] && delete t.template[_l11[_e100].id], _l11[_e100].remove();
          }

          var _s9 = _r19 ? _e99 : _e99.firstElementChild,
              _d6 = document.createDocumentFragment();

          for (var _t87 = 0; _t87 < _o33.length; _t87++) {
            var _i86 = _s9.cloneNode(!0);

            _i86.style.display = "", _i86.id = _e99.id + "_" + _t87, _i86.classList.add("smart-for-item"), _i86.classList.add("smart-for-item-" + _e99.id), _i86.removeAttribute("smart-for"), _d6.appendChild(_i86);
          }

          _s9.style.display = "none", _r19 ? _e99.parentNode.insertBefore(_d6, _e99.nextSibling) : _e99.appendChild(_d6);

          var _c4 = t._appRoot.querySelectorAll(".smart-for-item-" + _e99.id);

          for (var _e101 = 0; _e101 < _c4.length; _e101++) {
            var _a58 = _c4[_e101];

            t._addAttributeBindings(_a58, _i85 + "." + _e101 + ".");
          }
        }

        e && 0 < a.length && t.render();
      }
    }, {
      key: "notify",
      value: function notify(e) {
        var t = this;

        t.notifyFn = function (i) {
          i.owner = t, e(i);
        };
      }
    }, {
      key: "_notify",
      value: function _notify(e) {
        var t = this;
        if ("length" === e.propertyName) return;
        t.notifyFn && t.notifyFn(e);
        var i = e.propertyName;

        for (var _a59 in e.object && (i = e.object.propertyName), t.template) {
          var _e102 = t.template[_a59];
          var _n44 = null;

          for (var _t88 in _e102.bind) {
            if ("function" != typeof _e102.bind[_t88] && 0 <= _e102.bind[_t88].indexOf(i)) {
              _n44 = _t88;
              break;
            }
          }

          _n44 && t._setPropertyFromData(_e102, _n44);
        }

        t._renderForBindings(!0);
      }
    }, {
      key: "_observeData",
      value: function _observeData() {
        var e = this;
        e._data = new window[u].Observable(e._data), e._data.canNotify = !1, e._data.notify(e._notify.bind(e));

        var t = function t(i) {
          for (var _a60 in i.canNotify = !1, i) {
            if ("function" == typeof i[_a60]) {
              i[_a60] = i[_a60].bind(i);
              continue;
            }

            if (_a60.startsWith("_") || "notifyFn" == _a60 || "canNotify" == _a60 || "name" == _a60) continue;
            var _n45 = i[_a60];
            Array.isArray(_n45) ? (i[_a60] = new Smart.ObservableArray(i[_a60]), i[_a60].canNotify = !1, i[_a60].notify(e._notify.bind(e)), i[_a60].canNotify = !0, i[_a60].propertyName = _a60) : _n45 && "object" == typeof _n45 && _n45.constructor === Smart.DataAdapter ? i[_a60].propertyName = _a60 : _n45 && "object" == typeof _n45 && _n45 instanceof Date ? i[_a60].propertyName = _a60 : _n45 && "object" == typeof _n45 && (i[_a60] = new Smart.Observable(i[_a60]), i[_a60].canNotify = !1, i[_a60].notify(e._notify.bind(e)), i[_a60].canNotify = !0, i[_a60].propertyName = _a60, t(i[_a60]));
          }

          i.canNotify = !0;
        };

        for (var _i87 in e._data) {
          if ("function" == typeof e._data[_i87]) {
            e._data[_i87] = e._data[_i87].bind(e._data);
            continue;
          }

          if (_i87.startsWith("_") || "notifyFn" == _i87 || "canNotify" == _i87 || "name" == _i87) continue;
          var _a61 = e._data[_i87];
          Array.isArray(_a61) ? (e._data[_i87] = new Smart.ObservableArray(e._data[_i87]), e._data[_i87].canNotify = !1, e._data[_i87].notify(e._notify.bind(e)), e._data[_i87].canNotify = !0, e._data[_i87].propertyName = _i87) : "object" == typeof _a61 && _a61.constructor === Smart.DataAdapter ? e._data[_i87].propertyName = _i87 : "object" == typeof _a61 && _a61 instanceof Date ? e._data[_i87].propertyName = _i87 : "object" == typeof _a61 && (e._data[_i87] = new Smart.Observable(e._data[_i87]), e._data[_i87].canNotify = !1, e._data[_i87].notify(e._notify.bind(e)), e._data[_i87].canNotify = !0, e._data[_i87].propertyName = _i87, t(e._data[_i87]));
        }

        e._data.canNotify = !0;
      }
    }, {
      key: "_setPropertyFromData",
      value: function _setPropertyFromData(e, t) {
        var i = this;
        if (e.element.__updating || !e.bind) return;
        var a = e.bind[t];
        if ("function" == typeof a) return;
        var n = a ? a.split(".") : [];
        var o = i._data;

        for (var _a62 = 0; _a62 < n.length; _a62++) {
          var _e103 = n[_a62];
          if ("string" == typeof o) break;

          if (void 0 === o[_e103]) {
            o = void 0;
            break;
          }

          o = o[_e103];
        }

        if (e.bind.computed) {
          var _t89 = {
            item: e,
            name: a,
            value: o
          };
          e.bind.computed(_t89), _t89.value !== o && (o = _t89.value);
        }

        if (e.element.__updatingProperties = !0, a && void 0 !== o) {
          if ("observableArray" === o.name) e.element[t] = "checkbox" === e.element.type ? 0 <= o.indexOf(e.element.value) : o.toArray().slice(0);else if ("observable" === o.name) {
            var _i88 = function _i88(e) {
              var t = null;

              for (var _n47 in e) {
                if ("function" == typeof e[_n47]) continue;
                if (_n47.startsWith("_") || "notifyFn" == _n47 || "canNotify" == _n47 || "name" == _n47) continue;
                var _o34 = e[_n47];

                if (void 0 !== _o34) {
                  if (_o34 && Array.isArray(_o34)) continue;else if (_o34 && "object" == typeof _o34 && _o34.constructor === Smart.DataAdapter) continue;else _o34 && "object" == typeof _o34 && (t = _i88(e[_n47]));

                  if (_n47 === a) {
                    t = _o34;
                    break;
                  }

                  if (t) return t;
                }
              }

              return t;
            },
                _n46 = _i88(o);

            e.element[t] = _n46 ? _n46 : o;
          } else e.element[t] = "radio" === e.element.type ? e.element.value === o : o;
          i._components[e.selector] && !i._components[e.selector].rendered && (i._components[e.selector].properties[t] = o);
        } else e.properties && (e.element[t] = e.properties[t], i._components[e.selector] && !i._components[e.selector].rendered && (i._components[e.selector].properties[t] = e.properties[t]));

        e.element.__updatingProperties = !1;
      }
    }, {
      key: "render",
      value: function render() {
        var e = this;

        var _loop13 = function _loop13(_t90) {
          var i = e.template[_t90],
              a = i.element ? i.element : document.querySelector(_t90),
              n = i.properties,
              o = i.listeners,
              r = i.bind;
          if (!a) return "continue";

          for (var _o35 in i.selector = _t90, i.element = a, a._properties || (a._properties = []), n) {
            var _t91 = a._properties ? a._properties[_o35] : null;

            _t91 && (_t91.notify = !0), e._setPropertyFromData(i, _o35);
          }

          for (var _t92 in r) {
            var _n48 = a._properties ? a._properties[_t92] : null;

            _n48 && (_n48.notify = !0), e._setPropertyFromData(i, _t92);
          }

          if (e._components && e._components[_t90] && !1 === e._components[_t90].rendered) {
            var _a63 = e._components[_t90];
            i.element = _a63.instance = new window[_a63.name](_t90, _a63.properties), _a63.rendered = !0;
          }

          var l = function l(t) {
            var a = i.element;

            var _loop14 = function _loop14(_i89) {
              a.$ || (a.$ = Smart.Utilities.Extend(a)), a.$[t](_i89, function (t) {
                var a = o[_i89];

                if (0 <= a.indexOf(".")) {
                  var _n49 = a.split(".");

                  var _o36 = e._data[_n49[0]];

                  for (var _e104 = 1; _e104 < _n49.length; _e104++) {
                    _o36 = _o36[_n49[_e104]];
                  }

                  void 0 !== _o36 && _o36(t);
                } else e._data[a] && e._data[a](t);
              });
            };

            for (var _i89 in o) {
              _loop14(_i89);
            }

            var _loop15 = function _loop15(_i90) {
              var n = a._properties ? a._properties[_i90] : null;

              if (n) {
                var _o37 = function _o37(t) {
                  if (!a.__updatingProperties) {
                    a.__updating = !0;

                    var _n50 = function _n50(e) {
                      if ("radio" === a.type) {
                        var _t93 = a.parentNode.querySelectorAll("[type=\"radio\"]");

                        for (var _a64 = 0; _a64 < _t93.length; _a64++) {
                          _t93[_a64].__updating = e;
                        }
                      }
                    };

                    _n50(!0);

                    var _o38 = r[_i90];
                    if ("radio" === a.type || "toggle" === a.type || "checkbox" === a.type) e._updateDataFromBooleanElement(a, r);else {
                      (function (e, t, a) {
                        var n;

                        for (n = 0; n < t.length - 1; n++) {
                          e = e[t[n]];
                        }

                        e[t[n]] = a;
                      })(e._data, _o38.split("."), t.detail.value);
                    }
                    a.__updating = !1, _n50(!1);
                  }
                };

                "textarea" === a.type && a.$[t]("input.keyup", function (e) {
                  var t = new CustomEvent("keyup", {
                    detail: {
                      originalEvent: e,
                      value: a.$.input.value
                    }
                  });

                  _o37(t);
                }), a.$[t](n.attributeName + "-changed", function (e) {
                  _o37(e);
                });
              } else ;
            };

            for (var _i90 in r) {
              _loop15(_i90);
            }
          };

          l("unlisten"), l("listen"), a.onAttached = function () {
            l("listen");
          }, a.onDetached = function () {
            l("unlisten");
          };
        };

        for (var _t90 in e.template) {
          var _ret4 = _loop13(_t90);

          if (_ret4 === "continue") continue;
        }
      }
    }, {
      key: "template",
      get: function get() {
        return this._template;
      },
      set: function set(e) {
        this._template = e, this.render();
      }
    }, {
      key: "id",
      get: function get() {
        return this._id;
      },
      set: function set(e) {
        this._id = e;
      }
    }, {
      key: "jsonData",
      get: function get() {
        var e = this;
        return e.toJSON();
      }
    }, {
      key: "formData",
      get: function get() {
        var e = this,
            t = new FormData(),
            i = e.toJSON(),
            a = function a(e, i) {
          for (var _n51 in e) {
            var _o39 = e[_n51];
            if (Utilities.Types.isFunction(_o39)) continue;else "object" != typeof _o39 || Array.isArray(_o39) || a(_o39, _n51);
            ("object" != typeof _o39 || Array.isArray(_o39)) && ("" === i ? t.append(_n51, _o39) : t.append(i + "." + _n51, _o39));
          }
        };

        return a(i, ""), t;
      }
    }, {
      key: "data",
      get: function get() {
        var e = this;
        return e._data || (e._data = {}), e._data;
      },
      set: function set(e) {
        var t = this;
        t._data = e, t._observeData(), t.render();
      }
    }]);

    return App;
  }();

  Object.assign(window[u], {
    Elements: ElementRegistry,
    Modules: [ErrorModule, LocalizationModule, BindingModule],
    BaseElement: BaseCustomElement,
    Utilities: Utilities,
    Import: function Import(e, t) {
      var i = 0;

      var a = function a(e, t) {
        return new Promise(function (i) {
          var a = document.createElement("script");
          a.src = e, a.onload = i;

          for (var _e105 = 0; _e105 < document.head.children.length; _e105++) {
            var _a65 = document.head.children[_e105];
            if (_a65.src && 0 <= _a65.src.toString().indexOf(t)) return void i();
          }

          document.head.appendChild(a);
        });
      };

      return new Promise(function (n) {
        var o = Utilities.Core.getScriptLocation(),
            r = function r(t) {
          if (e[t]) {
            var _l12 = o + "/" + e[t];

            a(_l12, e[t]).then(function () {
              i++, i === e.length && n(), r(t + 1);
            });
          }
        };

        if (t) for (var _t94 = 0; _t94 < e.length; _t94++) {
          var _r20 = o + "/" + e[_t94];

          a(_r20, e[_t94]).then(function () {
            i++, i === e.length && n();
          });
        } else r(0);
      });
    },
    ObservableArray: ObservableArray,
    Observable: Observable,
    App: App,
    Component: Component,
    Theme: D.Theme || "",
    EnableShadowDOM: !1,
    BaseUrl: "./",
    StyleBaseUrl: "/styles/default/",
    Version: "5.1.0",
    License: "Evaluation"
  });
  var T = window[u].Theme;
  Object.defineProperty(window[u], "Theme", {
    configurable: !1,
    enumerable: !0,
    get: function get() {
      return T;
    },
    set: function set(e) {
      var t = T;
      T = e, b.fireEvent("theme-changed", {
        oldValue: t,
        newValue: e
      }, {
        bubbles: !0,
        cancelable: !0
      });
    }
  }), window[u]("smart-base-element", window[u].BaseElement), window[u]("smart-content-element",
  /*#__PURE__*/
  function (_window$u$BaseElement) {
    _inherits(_class, _window$u$BaseElement);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
    }

    _createClass(_class, [{
      key: "template",
      value: function template() {
        return "<div inner-h-t-m-l='[[innerHTML]]'></div>";
      }
    }, {
      key: "ready",
      value: function ready() {
        _get(_getPrototypeOf(_class.prototype), "ready", this).call(this);

        var e = this;
        e.applyContent();
      }
    }, {
      key: "clearContent",
      value: function clearContent() {
        for (var _e106 = this; _e106.$.content.firstChild;) {
          _e106.$.content.removeChild(_e106.$.content.firstChild);
        }
      }
    }, {
      key: "applyContent",
      value: function applyContent() {
        var e = this;
        if (void 0 === e.content) return void (e.content = e.$.content);
        if ("" === e.content || null === e.content) return void e.clearContent();
        if (e.content instanceof HTMLElement) return e.clearContent(), void e.$.content.appendChild(e.content);
        var t = document.createDocumentFragment();
        var i = document.createElement("div");
        t.appendChild(i), e.content instanceof HTMLElement ? i.appendChild(e.content) : i.innerHTML = e.content;
        var a = Array.from(i.childNodes);
        i.parentNode.removeChild(i);

        for (var _e107 = 0; _e107 < a.length; _e107++) {
          t.appendChild(a[_e107]);
        }

        e.clearContent(), e.$.content.appendChild(t);
      }
    }, {
      key: "propertyChangedHandler",
      value: function propertyChangedHandler(e, t, i) {
        _get(_getPrototypeOf(_class.prototype), "propertyChangedHandler", this).call(this, e, t, i);

        var a = this;
        t === i || ("innerHTML" === e && (a.content = i, a.applyContent(), a.innerHTML = a.content = Utilities.Core.html(a.$.content)), "content" === e && a.applyContent());
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          content: {
            type: "any",
            reflectToAttribute: !1
          },
          innerHTML: {
            type: "string",
            reflectToAttribute: !1
          }
        };
      }
    }]);

    return _class;
  }(window[u].BaseElement)), window[u]("smart-scroll-viewer",
  /*#__PURE__*/
  function (_window$u$ContentElem) {
    _inherits(_class2, _window$u$ContentElem);

    function _class2() {
      _classCallCheck(this, _class2);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
    }

    _createClass(_class2, [{
      key: "template",
      value: function template() {
        return "<div id=\"container\" class=\"smart-container\" role=\"presentation\">\n                        <div id=\"scrollViewerContainer\" class=\"smart-scroll-viewer-container\" role=\"presentation\">\n                            <div id=\"scrollViewerContentContainer\" inner-h-t-m-l='[[innerHTML]]' class=\"smart-scroll-viewer-content-container\" role=\"presentation\">\n                                <content></content>\n                            </div>\n                        </div>\n                        <smart-scroll-bar id=\"verticalScrollBar\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" right-to-left=\"[[rightToLeft]]\" orientation=\"vertical\"></smart-scroll-bar>\n                        <smart-scroll-bar id=\"horizontalScrollBar\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" right-to-left=\"[[rightToLeft]]\"></smart-scroll-bar>\n                    </div>";
      }
    }, {
      key: "appendChild",
      value: function appendChild(e) {
        var t = this;

        if (e) {
          if (!t.isCompleted || e.classList && e.classList.contains("smart-resize-trigger-container")) {
            var _e108 = Array.prototype.slice.call(arguments, 2);

            return HTMLElement.prototype.appendChild.apply(t, _e108.concat(Array.prototype.slice.call(arguments)));
          }

          t.$.scrollViewerContentContainer.appendChild(e);
        }
      }
    }, {
      key: "removeChild",
      value: function removeChild(e) {
        var t = this;

        if (e) {
          if (!t.isCompleted || e.classList && e.classList.contains("smart-resize-trigger-container")) {
            var _e109 = Array.prototype.slice.call(arguments, 2);

            return HTMLElement.prototype.removeChild.apply(t, _e109.concat(Array.prototype.slice.call(arguments)));
          }

          t.$.scrollViewerContentContainer.removeChild(e);
        }
      }
    }, {
      key: "removeAll",
      value: function removeAll() {
        var e = this;
        e.isCompleted && (e.$.scrollViewerContentContainer.innerHTML = "");
      }
    }, {
      key: "_horizontalScrollbarHandler",
      value: function _horizontalScrollbarHandler(e) {
        var t = this;
        t.$.scrollViewerContentContainer.style.left = (t.rightToLeft ? 1 : -1) * t.scrollLeft + "px", e.stopPropagation(), t.onHorizontalChange && t.onHorizontalChange(e);
      }
    }, {
      key: "_verticalScrollbarHandler",
      value: function _verticalScrollbarHandler(e) {
        var t = this;
        t.$.scrollViewerContentContainer.style.top = -t.scrollTop + "px", e.stopPropagation(), t.onVerticalChange && t.onVerticalChange(e);
      }
    }, {
      key: "_mouseWheelHandler",
      value: function _mouseWheelHandler(e) {
        var t = this;
        !t.disabled && (t.computedHorizontalScrollBarVisibility || t.computedVerticalScrollBarVisibility) && (t.computedVerticalScrollBarVisibility ? (e.stopPropagation(), e.preventDefault(), 0 < t.scrollHeight && t.scrollTo(t.scrollTop + t._getScrollCoefficient(e, t.offsetHeight))) : t.computedHorizontalScrollBarVisibility && (e.stopPropagation(), e.preventDefault(), 0 < t.scrollWidth && t.scrollTo(void 0, t.scrollLeft + t._getScrollCoefficient(e, t.offsetWidth))));
      }
    }, {
      key: "_getScrollCoefficient",
      value: function _getScrollCoefficient(e, t) {
        var i = e.deltaMode,
            a = n(e.deltaY);
        var o;
        return 0 === i ? a < 100 / 3 ? o = a : o = t : 1 === i ? 1 > a ? o = a * (100 / 3) : o = t : 2 === i && (o = t), 0 > e.deltaY ? -o : o;
      }
    }, {
      key: "applyContent",
      value: function applyContent() {
        var e = this;
        _get(_getPrototypeOf(_class2.prototype), "applyContent", this).call(this), e.refresh();
      }
    }, {
      key: "scrollTo",
      value: function scrollTo(e, t) {
        var i = this;
        i._scrollView && (e !== void 0 && i._scrollView.scrollTo(e), t !== void 0 && i._scrollView.scrollTo(t, !1));
      }
    }, {
      key: "refreshScrollBarsVisibility",
      value: function refreshScrollBarsVisibility() {
        var e = this;
        e._scrollView && (e._scrollView.hScrollBar.disabled = e.disabled, e._scrollView.vScrollBar.disabled = e.disabled, "disabled" === e.horizontalScrollBarVisibility && (e._scrollView.hScrollBar.disabled = !0), "disabled" === e.verticalScrollBarVisibility && (e._scrollView.vScrollBar.disabled = !0), 0 < e.scrollWidth ? e._scrollView.hScrollBar.$.removeClass("smart-hidden") : "visible" !== e.horizontalScrollBarVisibility && e._scrollView.hScrollBar.$.addClass("smart-hidden"), 0 < e.scrollHeight ? e._scrollView.vScrollBar.$.removeClass("smart-hidden") : "visible" !== e.verticalScrollBarVisibility && e._scrollView.vScrollBar.$.addClass("smart-hidden"), "hidden" === e.horizontalScrollBarVisibility && e._scrollView.hScrollBar.$.addClass("smart-hidden"), "hidden" === e.verticalScrollBarVisibility && e._scrollView.vScrollBar.$.addClass("smart-hidden"), "visible" === e.horizontalScrollBarVisibility && e._scrollView.hScrollBar.$.removeClass("smart-hidden"), "visible" === e.verticalScrollBarVisibility && (e._scrollView.vScrollBar.$.removeClass("smart-hidden"), !e.disabled && (e._scrollView.vScrollBar.disabled = 0 >= e.scrollHeight)), e.computedHorizontalScrollBarVisibility && e.computedVerticalScrollBarVisibility ? (e._scrollView.hScrollBar.$.addClass("bottom-corner"), e._scrollView.vScrollBar.$.addClass("bottom-corner")) : (e._scrollView.hScrollBar.$.removeClass("bottom-corner"), e._scrollView.vScrollBar.$.removeClass("bottom-corner")));
      }
    }, {
      key: "ready",
      value: function ready() {
        _get(_getPrototypeOf(_class2.prototype), "ready", this).call(this);

        var e = this;
        e.$.verticalScrollBar.setAttribute("aria-controls", e.id), e.$.horizontalScrollBar.setAttribute("aria-controls", e.id), e._scrollView = new Smart.Utilities.Scroll(e, e.$.horizontalScrollBar, e.$.verticalScrollBar), e.refresh();
      }
    }, {
      key: "refresh",
      value: function refresh() {
        function e() {
          var e = i.$.scrollViewerContentContainer.offsetWidth - i.$.scrollViewerContainer.offsetWidth;
          return 0 < e && "hidden" !== i.horizontalScrollBarVisibility || "visible" === i.horizontalScrollBarVisibility ? i.$.scrollViewerContainer.classList.add("hscroll") : i.$.scrollViewerContainer.classList.remove("hscroll"), e;
        }

        function t() {
          var e;

          if (Smart.Utilities.Core.Browser.Safari) {
            var _t95 = i.$.scrollViewerContentContainer.getBoundingClientRect().height,
                _a66 = i.$.scrollViewerContainer.getBoundingClientRect().height;
            e = _t95 && _a66 ? parseInt(_t95) - parseInt(_a66) : i.$.scrollViewerContentContainer.offsetHeight - i.$.scrollViewerContainer.offsetHeight;
          } else e = i.$.scrollViewerContentContainer.offsetHeight - i.$.scrollViewerContainer.offsetHeight;

          return 0 < e && "hidden" !== i.verticalScrollBarVisibility || "visible" === i.verticalScrollBarVisibility ? i.$.scrollViewerContainer.classList.add("vscroll") : i.$.scrollViewerContainer.classList.remove("vscroll"), e;
        }

        var i = this;

        if (i.$.scrollViewerContentContainer) {
          var _a67 = i.scrollWidth,
              _n52 = i.scrollHeight;
          i.scrollWidth = e(), i.scrollHeight = t(), i.scrollHeight && _n52 === i.scrollHeight || (i.scrollWidth = e()), i.scrollWidth && _a67 === i.scrollWidth || (i.scrollHeight = t()), i.computedVerticalScrollBarVisibility && (i.scrollHeight += i._scrollView.hScrollBar.offsetHeight), i.computedHorizontalScrollBarVisibility && (i.scrollWidth += i._scrollView.vScrollBar.offsetWidth);
        }
      }
    }, {
      key: "attached",
      value: function attached() {
        var e = this;
        _get(_getPrototypeOf(_class2.prototype), "attached", this).call(this), e._scrollView || (e._scrollView = new Smart.Utilities.Scroll(e, e.$.horizontalScrollBar, e.$.verticalScrollBar));
      }
    }, {
      key: "detached",
      value: function detached() {
        var e = this;
        _get(_getPrototypeOf(_class2.prototype), "detached", this).call(this), e._scrollView && (e._scrollView.unlisten(), delete e._scrollView);
      }
    }, {
      key: "propertyChangedHandler",
      value: function propertyChangedHandler(e, t, i) {
        var a = this;
        _get(_getPrototypeOf(_class2.prototype), "propertyChangedHandler", this).call(this, e, t, i), "animation" !== e && "theme" !== e && a.refresh();
      }
    }, {
      key: "computedHorizontalScrollBarVisibility",
      get: function get() {
        var e = this;
        return e._scrollView && e._scrollView.hScrollBar ? !e._scrollView.hScrollBar.$.hasClass("smart-hidden") : null;
      }
    }, {
      key: "computedVerticalScrollBarVisibility",
      get: function get() {
        var e = this;
        return e._scrollView && e._scrollView.vScrollBar ? !e._scrollView.vScrollBar.$.hasClass("smart-hidden") : null;
      }
    }, {
      key: "scrollWidth",
      get: function get() {
        var e = this;
        return e._scrollView && e._scrollView.hScrollBar ? 1 === e._scrollView.hScrollBar.max && "visible" === e.horizontalScrollBarVisibility ? 0 : e._scrollView.hScrollBar.max : -1;
      },
      set: function set(e) {
        var t = this;
        0 > e && (e = 0), t._scrollView && t._scrollView.hScrollBar && (t._scrollView.hScrollBar.max = 0 === e && "visible" === t.horizontalScrollBarVisibility ? 0 : e, t.refreshScrollBarsVisibility());
      }
    }, {
      key: "scrollHeight",
      get: function get() {
        var e = this;
        return e._scrollView && e._scrollView.vScrollBar ? 1 === e._scrollView.vScrollBar.max && "visible" === e.verticalScrollBarVisibility ? 0 : e._scrollView.vScrollBar.max : 0;
      },
      set: function set(e) {
        var t = this;
        0 > e && (e = 0), t._scrollView && t._scrollView.vScrollBar && (t._scrollView.vScrollBar.max = 0 === e && "visible" === t.verticalScrollBarVisibility ? 1 : e, t.refreshScrollBarsVisibility());
      }
    }, {
      key: "scrollLeft",
      get: function get() {
        var e = this;
        return e._scrollView && e._scrollView.hScrollBar ? e._scrollView.hScrollBar.value : 0;
      },
      set: function set(e) {
        var t = this;
        0 > e && (e = 0), t._scrollView && t._scrollView.hScrollBar && (t._scrollView.hScrollBar.value = e);
      }
    }, {
      key: "scrollTop",
      get: function get() {
        var e = this;
        return e._scrollView && e._scrollView.vScrollBar ? e._scrollView.vScrollBar.value : 0;
      },
      set: function set(e) {
        var t = this;
        0 > e && (e = 0), t._scrollView && t._scrollView.vScrollBar && (t._scrollView.vScrollBar.value = e);
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          horizontalScrollBarVisibility: {
            type: "string",
            value: "auto",
            allowedValues: ["auto", "disabled", "hidden", "visible"]
          },
          verticalScrollBarVisibility: {
            type: "string",
            value: "auto",
            allowedValues: ["auto", "disabled", "hidden", "visible"]
          }
        };
      }
    }, {
      key: "listeners",
      get: function get() {
        return {
          "horizontalScrollBar.change": "_horizontalScrollbarHandler",
          "verticalScrollBar.change": "_verticalScrollbarHandler",
          wheel: "_mouseWheelHandler"
        };
      }
    }, {
      key: "styleUrls",
      get: function get() {
        return ["smart.scrollviewer.css"];
      }
    }]);

    return _class2;
  }(window[u].ContentElement)), window[u].Utilities.Assign("PositionDetection",
  /*#__PURE__*/
  function () {
    function _class3(e, i, a, n) {
      _classCallCheck(this, _class3);

      var o = this;

      if (i) {
        var _a68 = "dropDown" + t(65536 * (1 + Math.random())).toString(16).substring(1);

        i.id = _a68, e.setAttribute("aria-controls", _a68);
      }

      o.context = e, o.dropDown = i, o.defaultParent = a, o.closeMethod = n;
    }

    _createClass(_class3, [{
      key: "handleAutoPositioning",
      value: function handleAutoPositioning() {
        function e() {
          o = a(e), ("auto" !== i.dropDownPosition || i.disabled || null === i.parentElement) && cancelAnimationFrame(o);
          var r = Date.now();
          200 <= r - n && (t.scrollHandler(), n = Date.now());
        }

        var t = this,
            i = t.context;
        if ("auto" !== i.dropDownPosition || i.disabled) return;

        var a = function () {
          return window.requestAnimationFrame;
        }();

        var n = Date.now(),
            o;
        return o = a(e);
      }
    }, {
      key: "checkBrowserBounds",
      value: function checkBrowserBounds(e) {
        var t = this.context;
        "auto" !== t.dropDownPosition || t.disabled || ("vertically" === e ? this.checkBrowserBoundsVertically() : "horizontally" === e ? this.checkBrowserBoundsHorizontally() : (this.checkBrowserBoundsVertically(), this.checkBrowserBoundsHorizontally()));
      }
    }, {
      key: "checkBrowserBoundsHorizontally",
      value: function checkBrowserBoundsHorizontally() {
        var e = this.context,
            t = this.dropDown;
        var i = 0,
            a;
        Core.isMobile || window.innerWidth === document.documentElement.clientWidth || (i = window.innerWidth - document.documentElement.clientWidth), null === e._dropDownParent ? t.style.left = "" : a = !0;
        var o = window.innerWidth - i;
        var r = e.getBoundingClientRect().left;

        if (0 > r && (t.style.left = (a ? 0 : n(r)) + "px", r = parseFloat(t.style.left)), r + t.offsetWidth > o) {
          var _e110 = r - n(o - r - t.offsetWidth);

          a && (_e110 += window.pageXOffset), t.style.left = (a ? _e110 : _e110 - r) + "px", window.innerWidth === document.documentElement.clientWidth && (t.style.left = parseFloat(t.style.left) + i + "px"), a && window.innerHeight === document.documentElement.clientHeight && this.positionDropDown(!0);
        }
      }
    }, {
      key: "checkBrowserBoundsVertically",
      value: function checkBrowserBoundsVertically(e) {
        var t = this.context,
            i = this.dropDown,
            a = t._dropDownListPosition;
        e || (e = t.getBoundingClientRect());
        0 === e.height || (t._dropDownListPosition = 0 <= document.documentElement.clientHeight - n(e.top + e.height + i.offsetHeight) ? "bottom" : 0 <= e.top - i.offsetHeight ? "top" : "overlay-center", this.updatePositionAttribute(a, t._dropDownListPosition));
      }
    }, {
      key: "scrollHandler",
      value: function scrollHandler() {
        var e = this.context;

        if (e.parentElement) {
          var _t96 = e.getBoundingClientRect();

          if (_t96.top !== e._positionTop) {
            var _i91 = e._dropDownListPosition;
            this.checkBrowserBoundsVertically(_t96), e._dropDownListPosition !== _i91 && this.positionDropDown(), e._positionTop = _t96.top;
          }
        }
      }
    }, {
      key: "getDropDownParent",
      value: function getDropDownParent(e) {
        var t = this.context,
            i = this.dropDown;
        var a = t.dropDownAppendTo;
        t._positionedParent = null, null === a ? t._dropDownParent = null : "body" === a || a === document.body ? t._dropDownParent = document.body : a instanceof HTMLElement ? t._dropDownParent = a : "string" == typeof a ? (a = document.getElementById(a), a instanceof HTMLElement ? t._dropDownParent = a : (t.dropDownAppendTo = null, t._dropDownParent = null)) : (t.dropDownAppendTo = null, t._dropDownParent = null);
        var n = t._dropDownParent;

        if (null !== n) {
          for (; n && "static" === window.getComputedStyle(n).position && n !== document.body;) {
            n = n.parentElement;
          }

          t._positionedParent = n === document.body ? null : n, i && (i.setAttribute("animation", t.animation), "" !== t.theme && i.$.addClass(t.theme), e && (t._dropDownParent.appendChild(i), i.$.addClass("smart-drop-down-repositioned")), -1 === t.detachedChildren.indexOf(i) && t.detachedChildren.push(i));
        }
      }
    }, {
      key: "dropDownAppendToChangedHandler",
      value: function dropDownAppendToChangedHandler() {
        var e = this.context,
            t = this.dropDown,
            i = e._dropDownParent;
        this.getDropDownParent();
        e._dropDownParent === i || (e[this.closeMethod](), ["left", "top", "font-size", "font-family", "font-style", "font-weight"].forEach(function (e) {
          return t.style[e] = null;
        }), null === e._dropDownParent ? (this.defaultParent.appendChild(t), t.$.removeClass("smart-drop-down-repositioned")) : (e._dropDownParent.appendChild(t), t.$.addClass("smart-drop-down-repositioned")));
      }
    }, {
      key: "dropDownPositionChangedHandler",
      value: function dropDownPositionChangedHandler() {
        var e = this;
        e.dropDown.style.transition = "none", e.context[e.closeMethod](), e.setDropDownPosition(), e.handleAutoPositioning();
      }
    }, {
      key: "dropDownAttached",
      value: function dropDownAttached(e) {
        var t = this.context;
        null === t._dropDownParent || (t._dropDownParent.appendChild(this.dropDown), this.handleAutoPositioning(), e && t[e]());
      }
    }, {
      key: "dropDownDetached",
      value: function dropDownDetached() {
        var e = this.context;
        null !== e._dropDownParent && document.body.contains(this.dropDown) && document.body.contains(e._dropDownParent) && e._dropDownParent.removeChild(this.dropDown);
      }
    }, {
      key: "setDropDownPosition",
      value: function setDropDownPosition() {
        var e = this.context,
            t = e.dropDownPosition,
            i = e._dropDownListPosition;
        "auto" === t ? this.checkBrowserBounds() : e._dropDownListPosition = t, this.updatePositionAttribute(i, e._dropDownListPosition);
      }
    }, {
      key: "updatePositionAttribute",
      value: function updatePositionAttribute(e, t) {
        var i = this.context,
            a = this.dropDown;
        i.$.dropDownButton && !i.$.dropDownButton.hasAttribute(t) && (i.$.dropDownButton.removeAttribute(e), i.$.dropDownButton.setAttribute(t, "")), a.hasAttribute(t) || (a.style.transition = "none", a.removeAttribute(e), a.setAttribute(t, ""), requestAnimationFrame(function () {
          a.style.transition = null;
        }));
      }
    }, {
      key: "positionDropDown",
      value: function positionDropDown(e) {
        var t = this.context,
            i = this.dropDown;
        if (!t.opened || null === t._dropDownParent) return;
        var a = t.getBoundingClientRect();
        var n, o;

        if (this.customPositionDropDown) {
          var _e111 = this.customPositionDropDown(a);

          n = _e111.left, o = _e111.top;
        } else switch (n = a.left, o = a.top, t._dropDownListPosition) {
          case "bottom":
            o += t.$.container.offsetHeight - 1;
            break;

          case "center-bottom":
            o += t.$.container.offsetHeight - 1, n += t.offsetWidth - i.offsetWidth / 2;
            break;

          case "center-top":
            o -= i.offsetHeight - 1, n += t.offsetWidth - i.offsetWidth / 2;
            break;

          case "top":
            o -= i.offsetHeight - 1;
            break;

          case "overlay-bottom":
            break;

          case "overlay-center":
            o -= i.offsetHeight / 2 - t.offsetHeight / 2;
            break;

          case "overlay-top":
            o -= i.offsetHeight - t.offsetHeight;
        }

        var r = this.getDropDownOffset();
        i.style.top = o + r.y + "px";
        e || (i.style.left = n + r.x + "px");
      }
    }, {
      key: "getDropDownOffset",
      value: function getDropDownOffset() {
        var e = this.context._positionedParent;
        var t, i;

        if (e) {
          var _a69 = e.getBoundingClientRect();

          t = -_a69.left, i = -_a69.top;
        } else t = window.pageXOffset, i = window.pageYOffset;

        return {
          x: t,
          y: i
        };
      }
    }, {
      key: "placeOverlay",
      value: function placeOverlay() {
        var e = this.context;

        if (e.dropDownOverlay && !e._overlay) {
          var _t97 = document.createElement("div");

          _t97.classList.add("smart-drop-down-overlay"), _t97.style.width = document.documentElement.scrollWidth + "px", _t97.style.height = document.documentElement.scrollHeight + "px", document.body.appendChild(_t97), e._overlay = _t97;
        }
      }
    }, {
      key: "removeOverlay",
      value: function removeOverlay(e) {
        function t() {
          0 < i.dropDown.getBoundingClientRect().height ? requestAnimationFrame(t) : (document.body.removeChild(a._overlay), delete a._overlay);
        }

        var i = this,
            a = i.context;
        a._overlay && (a.hasAnimation && e ? requestAnimationFrame(t) : (document.body.removeChild(a._overlay), delete a._overlay));
      }
    }]);

    return _class3;
  }());
})(), Smart.Utilities.Assign("Complex",
/*#__PURE__*/
function () {
  "use strict";

  function _class4(e, t) {
    _classCallCheck(this, _class4);

    if ("string" == typeof e) this.complexNumber = this.parseComplexNumber(e), this.realPart = this.complexNumber.realPart, this.imaginaryPart = this.complexNumber.imaginaryPart;else if ("number" == typeof e) {
      if (this.realPart = e, "number" == typeof t) this.imaginaryPart = t;else if ("undefined" == typeof t) this.imaginaryPart = 0;else throw new Error("Can't create complex number: invalid imaginary part");
      this.complexNumber = this.parseComplexNumber(this.realPart, this.imaginaryPart);
    } else throw new Error("Can't create complex number");
  }

  _createClass(_class4, [{
    key: "valueOf",
    value: function valueOf() {
      return 0 === this.imaginaryPart ? this.realPart : null;
    }
  }, {
    key: "isNaN",
    value: function (_isNaN) {
      function isNaN() {
        return _isNaN.apply(this, arguments);
      }

      isNaN.toString = function () {
        return _isNaN.toString();
      };

      return isNaN;
    }(function () {
      return isNaN(this.realPart) || isNaN(this.imaginaryPart);
    })
  }, {
    key: "isZero",
    value: function isZero() {
      return (0 === this.realPart || -0 === this.realPart) && (0 === this.imaginaryPart || -0 === this.imaginaryPart);
    }
  }, {
    key: "isFinite",
    value: function (_isFinite) {
      function isFinite() {
        return _isFinite.apply(this, arguments);
      }

      isFinite.toString = function () {
        return _isFinite.toString();
      };

      return isFinite;
    }(function () {
      return isFinite(this.realPart) && isFinite(this.imaginaryPart);
    })
  }, {
    key: "isInfinite",
    value: function isInfinite() {
      return !(this.isNaN() || this.isFinite());
    }
  }, {
    key: "parseComplexNumber",
    value: function parseComplexNumber(e, t) {
      var a = {
        realPart: 0,
        imaginaryPart: 0
      };
      if (e === void 0 || null === e) a.realPart = a.imaginaryPart = 0;else if (t !== void 0) a.realPart = e, a.imaginaryPart = t;else switch (typeof e) {
        case "object":
          if ("imaginaryPart" in e && "realPart" in e) a.realPart = e.realPart, a.imaginaryPart = e.imaginaryPart;else if (2 === e.length) a.realPart = e[0], a.imaginaryPart = e[1];else throw SyntaxError("Invalid Complex Number Parameter");
          break;

        case "string":
          {
            a.imaginaryPart = a.realPart = 0;

            var _t98 = e.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);

            var n = 1,
                o = 0;
            if (null === _t98) throw SyntaxError("Invalid Complex Number Parameter");

            for (var _e112 = 0; _e112 < _t98.length; _e112++) {
              var i = _t98[_e112];
              if (" " === i || "\t" === i || "\n" === i) ;else if ("+" === i) n++;else if ("-" === i) o++;else if ("i" === i || "I" === i) {
                if (0 === n + o) throw SyntaxError("Invalid Complex Number Parameter");
                " " === _t98[_e112 + 1] || isNaN(_t98[_e112 + 1]) ? a.imaginaryPart += parseFloat((o % 2 ? "-" : "") + "1") : (a.imaginaryPart += parseFloat((o % 2 ? "-" : "") + _t98[_e112 + 1]), _e112++), n = o = 0;
              } else {
                if (0 === n + o || isNaN(i)) throw SyntaxError("Invalid Complex Number Parameter");
                "i" === _t98[_e112 + 1] || "I" === _t98[_e112 + 1] ? (a.imaginaryPart += parseFloat((o % 2 ? "-" : "") + i), _e112++) : a.realPart += parseFloat((o % 2 ? "-" : "") + i), n = o = 0;
              }
            }

            if (0 < n + o) throw SyntaxError("Invalid Complex Number Parameter");
            break;
          }

        case "number":
          a.imaginaryPart = 0, a.realPart = e;
          break;

        default:
          throw SyntaxError("Invalid Complex Number Parameter");
      }
      return a;
    }
  }, {
    key: "compare",
    value: function compare(e, t) {
      var i = Math.abs;
      var a = this.parseComplexNumber(e, t),
          n = this.parseComplexNumber("1e-16");
      return i(a.realPart - this.realPart) <= n && i(a.imaginaryPart - this.imaginaryPart) <= n;
    }
  }, {
    key: "toString",
    value: function toString() {
      var e = this.realPart,
          t = this.imaginaryPart,
          i = "";
      return this.isNaN() ? "NaN" : this.isZero() ? "0" : this.isInfinite() ? "Infinity" : (0 !== e && (i += e), 0 !== t && (0 === e ? 0 > t && (i += "-") : i += 0 > t ? " - " : " + ", t = Math.abs(t), 1 !== t && (i += t), i += "i"), i ? i : "0");
    }
  }]);

  return _class4;
}());

var DataAdapter =
/*#__PURE__*/
function () {
  "use strict";

  function DataAdapter(e) {
    _classCallCheck(this, DataAdapter);

    e || (e = {});
    var t = Object.assign(this, e);
    t.key = function () {
      return function () {
        return (0 | 65536 * (1 + Math.random())).toString(16).substring(1);
      }();
    }(), t.$document = Smart.Utilities.Extend(document), t.boundSource = !1 === t.observable ? [] : new Smart.ObservableArray(), t.dataItemById = [], t.allowAdd === void 0 && (t.allowAdd = !0), t.allowRemove === void 0 && (t.allowRemove = !0), t.allowUpdate === void 0 && (t.allowUpdate = !0), e.observable === void 0 && (t.observable = !0), e.dataSource || (t.dataSource = []), e.dataFields || (t.dataFields = []), e.dataSourceType || (t.dataSourceType = "array"), e.id || (t.id = null), e.autoFetch || (t.autoFetch = !0), e.dataFields && (t.dataFields = e.dataFields), e && !1 !== e.autoBind && t.dataBind(), t.isInitialized = !0;
  }

  _createClass(DataAdapter, [{
    key: "_getDataFieldObjects",
    value: function _getDataFieldObjects(e) {
      var t = [];

      if ("number" == typeof e) {
        var i = "",
            a = 0;

        for (var n = 0; n < e; n++) {
          var _e113 = String.fromCharCode(65 + a);

          a++;

          var _n53 = i + _e113;

          t.push({
            name: _n53,
            dataType: "string"
          }), 26 <= a && (a = 0, i += "A");
        }
      } else if (0 < e.length) for (var _a70 = 0; _a70 < e.length; _a70++) {
        var _i92 = e[_a70];

        if ("string" == typeof _i92) {
          var _e114 = _i92.split(":"),
              _a71 = _e114[0].trim(),
              _n54 = 1 < _e114.length ? _e114[1].trim() : "string";

          t.push({
            name: _a71,
            dataType: _n54
          });
        } else t.push(_i92);
      }

      return t;
    }
  }, {
    key: "_notify",
    value: function _notify(e) {
      var t = this;
      !t.canNotify || t.notifyFn && t.notifyFn(e);
    }
  }, {
    key: "notify",
    value: function notify(e) {
      var t = this;
      e && (t.notifyFn = e);
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var e = this;
      return e.boundSource.toArray();
    }
  }, {
    key: "dataBind",
    value: function dataBind() {
      var e = this;
      e.clear();

      var t = function t() {
        e.observable && e.boundSource.notify(function (t) {
          if ("update" === t.action && t.path && 0 <= t.path.indexOf(".") && -1 === t.path.indexOf("children") && -1 === t.path.indexOf("loaded") && -1 === t.path.indexOf("level") && -1 === t.path.indexOf("leaf") && -1 === t.path.indexOf("expanded")) {
            var a = !1;

            for (var n = 0; n < e.dataFields.length; n++) {
              var i = e.dataFields[n].name;
              0 <= t.path.indexOf(i) && (a = !0);
            }

            e._notify && a && e._notify({
              action: "update",
              data: t.target,
              index: t.index
            });
          }
        }), e.groupBy ? e.groupBy.toArray && (e.groupBy = e.groupBy.toArray()) : e.groupBy = [], e.groupBy = new Smart.ObservableArray(e.groupBy), e.groupBy.notify(function () {
          e.boundHierarchy = null, e.refreshHierarchy(), e.onGroup && e.onGroup();
        }), e._onBindingComplete();
      };

      "string" == typeof e.dataSource && 0 <= e.dataSource.indexOf(".json") ? (e.url = e.dataSource, e.dataSourceType = "json", new Ajax(e, function (t) {
        e.dataSource = t, e._bindToJSON();
      })) : "string" == typeof e.dataSource && 0 <= e.dataSource.indexOf(".xlsx") ? (e.url = e.dataSource, e.dataSourceType = "xlsx", new Ajax(e, function (a) {
        if (!a[0]) return a = [], e._bindToArray(), void t();
        var i = Object.keys(a[0]),
            n = {},
            o = [];

        if (!1 !== e.exportHeader) {
          var _t99 = 0;

          for (var _a72 in i) {
            var _o40 = i[_a72];
            n[_o40] = e.dataFields[_t99++].name;
          }

          for (var _e115 = 1; _e115 < a.length; _e115++) {
            var _t100 = a[_e115],
                r = {};

            for (var _e116 in i) {
              var _a73 = i[_e116];
              r[n[_a73]] = _t100[_a73];
            }

            o.push(r);
          }

          e.dataSource = o;
        }

        e._bindToArray(), t();
      })) : "string" == typeof e.dataSource && 0 <= e.dataSource.indexOf(".csv") ? (e.dataSourceType = "csv", new Ajax(e, function () {
        e._bindToArray();
      })) : "string" == typeof e.dataSource && 0 <= e.dataSource.indexOf(".tsv") ? (e.dataSourceType = "tsv", new Ajax(e, function () {})) : "array" === e.dataSourceType ? (e._bindToArray(), t()) : "json" === e.dataSourceType && (e._bindToJSON(), t());
    }
  }, {
    key: "_onBindingComplete",
    value: function _onBindingComplete() {
      var e = this;
      e._buildHierarchy(), e.onBindingComplete && e.onBindingComplete({
        data: e.boundSource
      }), e._notify && e._notify({
        action: "bindingComplete",
        data: e.boundSource
      }), e.bindingCompleted = !0;
    }
  }, {
    key: "refreshHierarchy",
    value: function refreshHierarchy() {
      var e = this;

      e._buildHierarchy();
    }
  }, {
    key: "find",
    value: function find() {
      var e = this;
      return e.boundSource.find.apply(e.boundSource, arguments);
    }
  }, {
    key: "onVirtualDataSourceRequested",
    value: function onVirtualDataSourceRequested(e, t) {
      var a = this;
      var n = t ? t.first : 1 / 0,
          o = t ? t.last : 1 / 0,
          i = t ? t.row : null;

      if (void 0 === n && (n = 1 / 0), void 0 === o && (o = 1 / 0), a.virtualFirstIndex = n, a.virtualLastIndex = o, a.virtualDataSource) {
        var r = function r(_r22) {
          void 0 !== _r22.virtualDataSourceLength && (a.virtualDataSourceLength = _r22.virtualDataSourceLength), new Smart.DataAdapter({
            dataSource: _r22.dataSource,
            dataFields: _r22.dataFields || a.dataFields,
            data: t,
            onBindingComplete: function onBindingComplete(t) {
              if (a.virtualDataSourceOnExpand && i) return t.data && 0 < t.data.length ? a.add(t.data, i.$.id) : i.leaf = !0, a.onFilter && a.onFilter(), void e();
              if (n === 1 / 0) a.add(t.data);else {
                var _e117 = [],
                    _r21 = [];

                for (var _a74 = 0; _a74 < t.data.length; _a74++) {
                  var _i93 = t.data[_a74];
                  n + _a74 <= o && (_e117.push(_i93), _r21.push(n + _a74));
                }

                a.update(_r21, _e117);
              }
              a.onFilter && a.onFilter(), e();
            }
          });
        };

        var l = !1;

        var s = function s(e) {
          return 0 === Object.entries(e).length && (e.constructor === Object || e.constructor === Array);
        },
            d = s(t.sorting) && s(t.filtering) && s(t.grouping) && !t.row && "filter" !== t.action && "sort" !== t.action && "group" !== t.action;

        if (a.virtualDataSourceCache && n !== 1 / 0 && d) {
          var _e118 = 0;

          for (var _t101 = n; _t101 < o; _t101++) {
            a[_t101].isEmpty || _e118++;
          }

          _e118 == o - n && (l = !0);
        }

        l ? e() : "expand" === t.action ? a.virtualDataSourceOnExpand(r, {
          first: n,
          last: o,
          row: t.row,
          sorting: t.sorting,
          filtering: t.filtering,
          grouping: t.grouping,
          action: t.action
        }) : a.virtualDataSource(r, {
          first: n,
          last: o,
          sorting: t.sorting,
          filtering: t.filtering,
          grouping: t.grouping,
          action: t.action
        });
      } else e();
    }
  }, {
    key: "add",
    value: function add(e, t) {
      var i = this;
      if (!e) return;
      var a = !0;

      var n = function n(e) {
        var n = i._getDataItem(e, i.boundSource.length);

        i[i.boundSource.length] = n, i.dataItemById[n.$.id] = n;
        var o = i.boundSource.push(n);
        return void 0 !== t && (n.$.parentId = t), o || (a = !1), n;
      };

      if (e.length) {
        var _t102 = [];

        for (var _a75 = 0; _a75 < e.length; _a75++) {
          var _i94 = n(e[_a75]);

          _t102.push(_i94);
        }

        i._notify({
          action: "add",
          data: _t102
        });
      } else {
        var _t103 = n(e);

        i._notify({
          action: "add",
          data: _t103
        });
      }

      return i.refreshHierarchy(), a;
    }
  }, {
    key: "refreshIndexes",
    value: function refreshIndexes() {
      var e = this;

      for (var t = 0; t < e.boundSource.length; t++) {
        e[t] = e.boundSource[t], e[t].$.index = t, e.dataItemById[e[t].$.id] = e[t];
      }
    }
  }, {
    key: "removeLast",
    value: function removeLast() {
      var e = this;
      delete e[e.boundSource.length - 1];
      var t = e.boundSource.pop();
      return e._notify({
        action: "removeLast",
        data: t
      }), e.refreshHierarchy(), t;
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this,
          i = t.boundSource[e];
      if (!i) throw new Error("Invalid Item Index");
      t.boundSource.splice(e, 1), t.refreshIndexes(), t._notify({
        action: "remove",
        index: e,
        data: i
      }), t.refreshHierarchy();
    }
  }, {
    key: "update",
    value: function update(e, t) {
      var a = this;
      if (Smart.Utilities.Types.isArray(e) && Smart.Utilities.Types.isArray(t) && 0 === e.length && 0 === t.length) return void a.refreshHierarchy();

      if (t.length && e.length) {
        var n = [];

        for (var o = 0; o < e.length; o++) {
          var _i95 = a._getDataItem(t[o], e[o]),
              r = e[o];

          n.push(_i95), a.boundSource[r] = _i95, a[r] = a.boundSource[r], a.dataItemById[_i95.$.id] = a[r];
        }

        return a._notify({
          action: "update",
          index: e,
          data: n
        }), void a.refreshHierarchy();
      }

      var i = a._getDataItem(t, e);

      return a.boundSource[e] = i, a[e] = a.boundSource[e], a.dataItemById[i.$.id] = a[e], a._notify({
        action: "update",
        index: e,
        data: i
      }), a.refreshHierarchy(), i;
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var i = this;
      t = i._getDataItem(t, e);
      var a = i.boundSource.splice(e, 0, t);
      return i.refreshIndexes(), i._notify({
        action: "insert",
        index: e,
        data: t
      }), i.refreshHierarchy(), a;
    }
  }, {
    key: "move",
    value: function move(e, t) {
      if (!(t > e && 1 == t - e || e === t)) {
        var i = this,
            a = i.boundSource.splice(e, 1)[0];
        t > e ? (t--, i.boundSource.splice(t, 0, a)) : i.boundSource.splice(t, 0, a), i.refreshIndexes(), i._notify({
          action: "move",
          index: t,
          data: i.boundSource[t]
        }), i.refreshHierarchy();
      }
    }
  }, {
    key: "indexOf",
    value: function indexOf(e) {
      var t = this,
          i = t.boundSource.indexOf(e);
      return i;
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = this;
      if (!e.isInitialized) return e._cachedValues = [], void (e.dataItemById = []);

      for (var t = 0; t < e.boundSource.length; t++) {
        delete e[t];
      }

      e._cachedValues = [], e.boundSource = e.observable ? new Smart.ObservableArray() : [], e.dataItemById = [], e.refreshHierarchy();
    }
  }, {
    key: "_getId",
    value: function _getId(e, t, i) {
      if (null !== e && e.name !== void 0 && e.name && t.getAttribute) {
        var a = t.getAttribute(e.name);
        if (null !== a && 0 < a.toString().length) return a;
        if (e.map) try {
          var _i96 = t.getAttribute(e.map);

          if (null !== _i96 && 0 < _i96.toString().length) return _i96;
        } catch (e) {
          return i;
        }
        return;
      }

      if (e && 0 < e.toString().length && t.getAttribute) {
        var _i97 = t.getAttribute(e);

        if (null !== _i97 && 0 < _i97.toString().length) return _i97.trim().split(" ").join("").replace(/([ #;?%&,.+*~\':'!^$[\]()=>|\/@])/g, "");else {
          var _i98 = e.split(this.mapChar);

          if (1 < _i98.length) {
            var _e119 = t;

            for (var _t104 = 0; _t104 < _i98.length; _t104++) {
              void 0 !== _e119 && (_e119 = _e119[_i98[_t104]]);
            }

            if (void 0 !== _e119) return _e119;
          } else if (void 0 !== t[e]) return t[e];
        }
      }

      return i;
    }
  }, {
    key: "_buildHierarchy",
    value: function _buildHierarchy() {
      var e = this;
      if (!e.reservedNames) e.reservedNames = {
        leaf: "leaf",
        parent: "parent",
        expanded: "expanded",
        checked: "checked",
        selected: "selected",
        level: "level",
        icon: "icon",
        data: "data"
      };else {
        var _t105 = e.reservedNames;
        _t105.leaf || (_t105.leaf = "leaf"), _t105.parent || (_t105.parent = "parent"), _t105.expanded || (_t105.expanded = "expanded"), _t105.checked || (_t105.checked = "checked"), _t105.selected || (_t105.selected = "selected"), _t105.level || (_t105.level = "level"), _t105.data || (_t105.data = "data");
      }
      var t = e.reservedNames;

      if (e.childrenDataField) {
        var a = [];

        var _loop16 = function _loop16(n) {
          var i = Object.assign({}, e.boundSource[n]);
          if (!i) return "continue";
          a.push(i);

          var o = function o(i) {
            var a = e.childrenDataField.split(e.mapChar);
            var n = null;

            if (1 < a.length) {
              var _e121 = i;

              for (var _t107 = 0; _t107 < a.length; _t107++) {
                void 0 !== _e121 && (_e121 = _e121[a[_t107]]);
              }

              n = _e121;
            } else n = i.children;

            i.children = n, (null === i.children || void 0 === i.children || i.children && 0 === i.children.length) && (i[t.leaf] = !0);
          };

          o(i), i[t.level] = 0, i.$ || (i.$ = {}), i[t.parent] = null, i[t.data] = i, void 0 === i[t.expanded] && (i[t.expanded] = !1);

          var r = function r(a, n) {
            if (!n) return void (a.children = []);

            for (var l = 0, _i100; l < n.length; l++) {
              (_i100 = e._getDataItem(n[l], l), !!_i100) && (o(_i100), _i100[t.level] = a[t.level] + 1, _i100[t.parent] = a, _i100[t.data] = _i100, a && (a.children[l] = _i100), void 0 === _i100[t.expanded] && (_i100[t.expanded] = !1), r(_i100, _i100.children));
            }
          };

          r(i, i.children);
        };

        for (var n = 0; n < e.boundSource.length; n++) {
          var _ret5 = _loop16(n);

          if (_ret5 === "continue") continue;
        }

        if (e.boundHierarchy = a, !e._boundSourceUpdate) {
          for (var _t106 = 0; _t106 < e.boundHierarchy.length; _t106++) {
            var i = e.boundHierarchy[_t106];

            if (i.children) {
              (function () {
                var t = function t(a) {
                  if (e.dataItemById[a.$.id] || (e.boundSource.canNotify = !1, e.dataItemById[a.$.id] = a, e[e.boundSource.length] = a, e.boundSource.push(a), e.boundSource.canNotify = !0), a.children) for (var _e120 = 0; _e120 < a.children.length; _e120++) {
                    var _i99 = a.children[_e120];
                    _i99.children && t(_i99);
                  }
                };

                t(i);
              })();
            }
          }

          e._boundSourceUpdate = !0;
        }
      }

      e.xmlRoot && "xml" === e.dataSourceType && (e.boundHierarchy = this._getHierarchy("uid", "_parentuid", "children", null, e.boundSource)), e.keyDataField && e.parentDataField && (e.boundHierarchy = this._getHierarchy(e.keyDataField, e.parentDataField, "children", null, e.boundSource)), e.groupBy && 0 < e.groupBy.length && (e.boundHierarchy = this._getGroupHierarchy(e.groupBy, "children", "label", null, "data", null, "parent", e.boundSource)), e.virtualDataSourceOnExpand && (e.boundHierarchy = this._getHierarchy("id", "parentId", "children", null, e.boundSource));
    }
  }, {
    key: "_getGroupHierarchy",
    value: function _getGroupHierarchy(e, t, i, a, n, o, r, l, s) {
      var d = this;
      s || (s = 0);
      var c = d.reservedNames;

      var m = function m() {
        function e() {
          return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
        }

        return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
      };

      var u = [];

      for (var _d7 = 0; _d7 < e.length; _d7++) {
        u[_d7] = m();
      }

      t || (t = "children"), i || (i = "group"), n || (n = "item"), r || (r = "parent"), void 0 === o && (o = "value");
      var p = [],
          g = [];
      var h = 0;

      var _ = function _(e) {
        var t = e;
        if (a) for (var _e122 in a) {
          var _i101 = a[_e122];
          _i101.name && _i101.map && (t[_i101.map] = t[_i101.name]);
        }
        return t;
      };

      for (var _d8 = 0, f; _d8 < l.length; _d8++) {
        f = Object.assign({}, _(l[_d8])), f[c.leaf] = !1;
        var _a76 = [],
            b = 0;

        for (var _t108 = 0; _t108 < e.length; _t108++) {
          var _i102 = e[_t108],
              _n55 = f[_i102];
          null !== _n55 && (_a76[b++] = {
            value: _n55,
            group: _i102,
            hash: u[_t108]
          });
        }

        if (_a76.length !== e.length) break;
        var y = null,
            v = "";

        for (var _e123 = 0; _e123 < _a76.length; _e123++) {
          var _l13 = _a76[_e123].value,
              _d9 = _a76[_e123].group,
              _m4 = _a76[_e123].hash;

          if (v = v + "_" + _m4 + "_" + _l13, void 0 !== g[v] && null !== g[v]) {
            y = g[v];
            continue;
          }

          if (null === y) {
            y = {
              $: {}
            }, y[c.level] = 0, y[c.leaf] = !1, y[r] = null, y[i] = _l13, y[n] = f, y.groupDataField = _d9, y[c.expanded] = void 0 !== f[c.expanded] && f[c.expanded], o && (y[o] = f[o]), y[t] = [];

            var _e124 = p.length + s;

            (!this.id || "number" == typeof f.$.id || isFinite(f.$.id)) && (_e124 = "Item" + _e124), void 0 === y.$.id && (y.$.id = _e124), p[h++] = y;
          } else {
            var _e125 = {
              $: {}
            };
            _e125[c.level] = y[c.level] + 1, _e125[r] = y, _e125[i] = _l13, _e125[t] = [], _e125[n] = f, _e125.groupDataField = _d9, _e125[c.leaf] = !1, _e125[c.expanded] = void 0 !== f[c.expanded] && f[c.expanded], o && (_e125[o] = f[o]), void 0 === _e125.$.id && (_e125.$.id = y.$.id + "_" + y[t].length), y[t][y[t].length] = _e125, y = _e125;
          }

          g[v] = y;
        }

        f && (f[c.leaf] = !0), null === y ? void 0 === f.$.id && (f.$.id = m()) : (null === this.id ? void 0 === f.$.id && (f.$.id = y.$.id + "_" + y[t].length) : void 0 === f.$.id && -1 === f.$.id.toString().indexOf(y.$.id) && (f.$.id = y.$.id + "_" + f.$.id), f[r] = y, f[c.level] = y[c.level] + 1, y[t][y[t].length] = f);
      }

      return p;
    }
  }, {
    key: "_getHierarchy",
    value: function _getHierarchy(e, t, i, a, n) {
      var o = this,
          r = [];
      var l = this.boundSource;
      if (n && (l = n), 0 === this.boundSource.length) return null;
      var s = null === i ? "children" : i;
      var d = [],
          c = l,
          m = c.length,
          u = o.reservedNames;

      var p = function p(e) {
        var t = e;
        if (a) for (var _e126 in a) {
          var _i103 = a[_e126];
          _i103.name && _i103.map && (t[_i103.map] = t[_i103.name]);
        }
        return t;
      };

      for (var _o41 = 0; _o41 < m; _o41++) {
        var _i104 = c[_o41],
            _a77 = _i104[t],
            _n56 = _i104[e];
        "parentId" === t && (_a77 = _i104.$.parentId), "id" === e && (_n56 = _i104.$.id), _i104[s] = [], d[_n56] = {
          parentId: _a77,
          item: _i104
        };
      }

      for (var _o42 = 0; _o42 < m; _o42++) {
        var _i105 = c[_o42];
        var _a78 = _i105[t],
            _n57 = _i105[e];

        if ("parentId" === t && (_a78 = _i105.$.parentId), "id" === e && (_n57 = _i105.$.id), void 0 !== d[_a78]) {
          var _e127 = {
            parentId: _a78,
            item: d[_n57].item
          },
              _t109 = d[_a78].item;
          _t109[s] || (_t109[s] = []);
          var _i106 = _t109[s].length;
          _e127 = _e127.item, u ? void 0 === _e127[u.parent] && (_e127[u.parent] = _t109) : void 0 === _e127.parent && (_e127.parent = _t109);

          var _o43 = p(_e127);

          _t109[s][_i106] = _o43, d[_a78].item = _t109, d[_n57].item = _e127;
        } else {
          var _e128 = d[_n57].item;
          u ? void 0 === _e128[u.parent] && (_e128[u.parent] = null) : void 0 === _e128.parent && (_e128.parent = null);

          var _t110 = p(_e128);

          u ? _t110[u.level] = 0 : _t110.level = 0, r[r.length] = _t110;
        }
      }

      if (0 !== r.length) {
        var _e129 = function _e129(t, a) {
          for (var _n58 = 0; _n58 < a.length; _n58++) {
            var _i107 = a[_n58];
            u ? _i107[u.level] = t : _i107.level = t;
            var _r23 = _i107[s];
            _r23 ? 0 < _r23.length ? _e129(t + 1, _r23) : o.virtualDataSourceOnExpand ? void 0 === _i107.leaf && (_i107.leaf = !1) : u ? _i107[u.leaf] = !0 : _i107.leaf = !0 : o.virtualDataSourceOnExpand ? void 0 === _i107.leaf && (_i107.leaf = !1) : u ? _i107[u.leaf] = !0 : _i107.leaf = !0;
          }
        };

        _e129(0, r);
      }

      return r;
    }
  }, {
    key: "summarize",
    value: function summarize(e, t) {
      var i = this;
      Array.isArray(e) || (e = [e]);
      var a = [];

      for (var _n59 = 0; _n59 < e.length; _n59++) {
        var _t111 = e[_n59];

        for (var _e130 in _t111) {
          var _i108 = _t111[_e130];
          a.push({
            dataField: _e130,
            functions: _i108
          });
        }
      }

      e = a;
      var n = {},
          o = [];
      t || (t = i.boundSource);
      var r = t.length;

      if (0 !== r && void 0 !== r) {
        var _loop17 = function _loop17(_a79, _i110) {
          _i110 = t[_a79];

          var _loop19 = function _loop19(_t112) {
            var r = e[_t112];
            var l = _i110[r.dataField];

            if (r.functions) {
              n[r.dataField] = n[r.dataField] || {}, o[r.dataField] = o[r.dataField] || 0, o[r.dataField]++;

              var _e131 = function _e131(e) {
                for (var _t114 in e) {
                  var _a80 = n[r.dataField][_t114];
                  (null === _a80 || void 0 === _a80) && (n[r.dataField][_t114] = 0, _a80 = 0), "function" == typeof e[_t114] && (_a80 = e[_t114](_a80, l, r.dataField, _i110)), n[r.dataField][_t114] = _a80;
                }
              };

              var _t113 = parseFloat(l);

              _t113 = !isNaN(_t113), _t113 && (l = parseFloat(l)), "number" == typeof l && isFinite(l) ? r.functions.forEach(function (t) {
                var i = n[r.dataField][t];
                if ((null === i || void 0 === i) && (i = 0, "min" === this && (i = 9999999999999), "max" === this && (i = -9999999999999)), "sum" === t || "avg" === t || "stdev" === t || "stdevp" === t || "var" === t || "varp" === t) i += parseFloat(l);else if ("product" === t) 0 == _a79 ? i = parseFloat(l) : i *= parseFloat(l);else if ("min" === t) i = Math.min(i, parseFloat(l));else if ("max" === t) i = Math.max(i, parseFloat(l));else if ("count" === t) i++;else if ("object" == typeof t) {
                  _i109 = _i110;
                  return void _e131(t);
                }
                n[r.dataField][t] = i;
              }) : r.functions.forEach(function (t) {
                if ("min" === t || "max" === t || "count" === t || "product" === t || "sum" === t || "avg" === t || "stdev" === t || "stdevp" === t || "var" === t || "varp" === t) {
                  if (null === l) {
                    _i109 = _i110;
                    return !0;
                  }

                  var _e132 = n[r.dataField][t];
                  _i109 = _i110;
                  return (null === _e132 || void 0 === _e132) && (_e132 = 0), n[r.dataField][t] = _e132, !0;
                }

                "object" == typeof t && _e131(t);
              });
            }
          };

          for (var _t112 = 0; _t112 < e.length; _t112++) {
            _loop19(_t112);
          }

          _i109 = _i110;
        };

        for (var _a79 = 0, _i109; _a79 < r; _a79++) {
          _loop17(_a79, _i109);
        }

        var _loop18 = function _loop18(_i111) {
          var a = e[_i111];

          if (a.functions) {
            if (n[a.dataField] || (n[a.dataField] = {}, a.functions.forEach(function (e) {
              n[a.dataField][e] = 0;
            })), void 0 !== n[a.dataField].avg) {
              var _e133 = n[a.dataField].avg,
                  _t115 = o[a.dataField];
              n[a.dataField].avg = 0 === _t115 || void 0 === _t115 ? 0 : _e133 / _t115;
            } else void 0 !== n[a.dataField].count && (n[a.dataField].count = r);

            (n[a.dataField].stdev || n[a.dataField].stdevp || n[a.dataField]["var"] || n[a.dataField].varp) && a.functions.forEach(function (e) {
              if ("stdev" === e || "var" === e || "varp" === e || "stdevp" === e) {
                var _i112 = n[a.dataField][e],
                    _o44 = r,
                    l = _i112 / r;
                var s = 0;

                for (var _e134 = 0; _e134 < r; _e134++) {
                  var _i113 = t[_e134],
                      _n60 = _i113[a.dataField];
                  s += (_n60 - l) * (_n60 - l);
                }

                var d = "stdevp" === e || "varp" === e ? _o44 : _o44 - 1;
                0 === d && (d = 1), "var" === e || "varp" === e ? n[a.dataField][e] = s / d : ("stdevp" === e || "stdev" === e) && (n[a.dataField][e] = Math.sqrt(s / d));
              }
            });
          }
        };

        for (var _i111 = 0; _i111 < e.length; _i111++) {
          _loop18(_i111);
        }

        return n;
      }
    }
  }, {
    key: "_getDataItem",
    value: function _getDataItem(e, t) {
      var a = this,
          i = {},
          n = "number" == typeof a.dataSource || a.dataSourceLength;
      if (!e) return {
        $: {
          id: t
        },
        isEmpty: !0,
        index: t
      };

      if ("string" == typeof e && (e = {
        "": e
      }), n) {
        for (var _e135 = 0; _e135 < a.dataFields.length; _e135++) {
          var _t116 = a.dataFields ? a.dataFields[_e135] : {};

          i[_t116.name] = "";
        }

        return i.$ = {}, i.$.id = t, i.$.index = t, i;
      }

      var o = e;

      if (void 0 !== o.expanded && (i.expanded = o.expanded, i.expanded = "true" === o.expanded || !0 === o.expanded || 1 === o.expanded), a.childrenDataField ? void 0 !== o[a.childrenDataField] && (i.children = o[a.childrenDataField]) : void 0 === o.children ? void 0 !== o.items && (i.children = o.items) : i.children = o.children, void 0 !== o.leaf && (i.leaf = o.leaf), void 0 !== o.level && (i.level = o.level), a.keyDataField && void 0 !== o[a.keyDataField] && (i[a.keyDataField] = o[a.keyDataField]), a.parentDataField && void 0 !== o[a.parentDataField] && (i[a.parentDataField] = o[a.parentDataField]), 0 === a.dataFields.length) {
        var _t117 = Object.getOwnPropertyNames(e);

        for (var _e136 = 0; _e136 < _t117.length; _e136++) {
          a.dataFields.push({
            name: _t117[_e136],
            dataType: "string"
          });
        }
      }

      for (var _n61 = 0; _n61 < a.dataFields.length; _n61++) {
        var _t118 = a.dataFields ? a.dataFields[_n61] : {};

        var _r24 = "";
        if (void 0 === _t118 || null === _t118) continue;

        if (e.length && (_r24 = e[_n61]), _t118.map) {
          var _e137 = _t118.map.split(a.mapChar);

          if (0 < _e137.length) {
            var _t119 = o;

            for (var _i114 = 0; _i114 < _e137.length; _i114++) {
              o && (_t119 = _t119[_e137[_i114]]);
            }

            _r24 = _t119;
          } else _r24 = o[_t118.map];
        }

        void 0 !== _r24 && null !== _r24 ? _r24 = _r24.toString() : void 0 === _r24 && null !== _r24 && (_r24 = "");
        var l = !1;
        "" === _r24 && (l = !0, _r24 = e[_t118.name], void 0 !== _r24 && null !== _r24 ? "array" !== _t118.dataType && "date" !== _t118.dataType && (_r24 = _r24.toString()) : _r24 = ""), "[object Object]" === _r24 && _t118.map && l && (_r24 = ""), a._cachedValues["" + _r24 + "_" + _t118.dataType] ? _r24 = a._cachedValues["" + _r24 + "_" + _t118.dataType] : ("bool" === _t118.dataType || "boolean" === _t118.dataType ? "true" === _r24 || "1" === _r24 ? _r24 = !0 : ("false" === _r24 || "0" === _r24) && (_r24 = !1) : _r24 = a.$document.deserialize("" + _r24, _t118.dataType, !0), a._cachedValues[_r24 + "_" + _t118.dataType] = _r24), "string" !== _t118.dataType && "boolean" !== _t118.dataType && "bool" !== _t118.dataType && (isNaN(_r24) || _r24 === -Infinity || _r24 === 1 / 0) && (_r24 = 0), i[_t118.name] = _r24;
      }

      var r = t;
      return a.id ? (r = o[a.id], "object" == typeof r && (r = t)) : a.dataItemById && a.dataItemById[r] && (r = a.length), i.$ || (i.$ = {}), i.$.id = r, i.$.index = t, Object(i);
    }
  }, {
    key: "_bindToArray",
    value: function _bindToArray() {
      var e = this,
          t = "number" == typeof e.dataSource || e.dataSourceLength,
          a = [];
      e.boundSource.canNotify = !1;

      for (var n = 0; n < e.length; n++) {
        var i = t ? {} : e.dataSource[n],
            o = e._getDataItem(i, n);

        a.push(o);
      }

      if (t && e.dataSourceLength && 0 < e.dataSource.length) for (var _t120 = 0; _t120 < e.dataSource.length; _t120++) {
        var _i115 = e.dataSource[_t120].cell,
            _n62 = e.dataSource[_t120].value,
            _o45 = _i115.replace(/[^0-9]/g, ""),
            r = _i115.replace(/[0-9]/g, "");

        a[_o45 - 1][r] = _n62;
      }
      e.boundSource = !1 === e.observable ? a : new Smart.ObservableArray(a);

      for (var _t121 = 0; _t121 < e.length; _t121++) {
        e[_t121] = e.boundSource[_t121], e.dataItemById[e[_t121].$.id] = e[_t121];
      }

      e.boundSource.canNotify = !0;
    }
  }, {
    key: "_bindToJSON",
    value: function _bindToJSON() {
      var e = this,
          t = [],
          a = Object.entries(e.dataSource);
      e.boundSource.canNotify = !1;

      for (var n = 0; n < a.length; n++) {
        var i = a[n],
            o = e._getDataItem(i, n);

        t.push(o);
      }

      e.boundSource = !1 === e.observable ? t : new Smart.ObservableArray(t);

      for (var _t122 = 0; _t122 < e.length; _t122++) {
        e[_t122] = e.boundSource[_t122], e.dataItemById[e[_t122].$.id] = e[_t122];
      }

      e.boundSource.canNotify = !0;
    }
  }, {
    key: "sortBy",
    value: function sortBy(e, t, a) {
      var n = this;
      if (!t) for (var _a81 = 0; _a81 < n.dataFields.length; _a81++) {
        var i = n.dataFields[_a81];

        if (i.name === e) {
          t = i.dataType;
          break;
        }
      }

      if (n.boundHierarchy) {
        var o = function o(r) {
          n._sort(r, e, a, t);

          for (var _n63 = 0; _n63 < r.length; _n63++) {
            var _i116 = r[_n63];
            _i116.children && o(_i116.children, e, a, t);
          }
        };

        o(n.boundHierarchy);
      } else n._sort(n.boundSource, e, a, t);
    }
  }, {
    key: "_createFilter",
    value: function _createFilter(e, t) {
      var i = {
        "=": "EQUAL",
        "<>": "NOT_EQUAL",
        "<": "LESS_THAN",
        ">": "GREATER_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">=": "GREATER_THAN_OR_EQUAL",
        equal: "EQUAL",
        "not equal": "NOT_EQUAL",
        "less than": "LESS_THAN",
        "greater than": "GREATER_THAN",
        "greater than or equal": "GREATER_THAN_OR_EQUAL",
        "less than or equal": "LESS_THAN_OR_EQUAL",
        "starts with": "STARTS_WITH",
        "ends with": "ENDS_WITH",
        null: "null",
        "": "EMPTY",
        isblank: "EMPTY",
        isnotblank: "NOT_EMPTY",
        contains: "CONTAINS",
        notcontains: "DOES_NOT_CONTAIN",
        startswith: "STARTS_WITH",
        endswith: "ENDS_WITH",
        NULL: "NULL",
        NOT_NULL: "NOT_NULL"
      };
      var a = [];

      for (var _n64 = 0; _n64 < t.length; _n64++) {
        var _e138 = t[_n64],
            _i117 = -1 === _e138.indexOf("\"") ? _e138.split(" ") : _e138.split("\"");

        var _o46 = [];

        for (var _e139 = 0; _e139 < _i117.length; _e139++) {
          var _t123 = _i117[_e139];
          "" !== _t123 && _o46.push(_t123.trim());
        }

        a.push(_o46);
      }

      var n = new Smart.FilterGroup(),
          o = [],
          r = [];

      for (var _n65 = 0; _n65 < a.length; _n65++) {
        var _t124 = a[_n65];

        if (1 < _t124.length) {
          var _a82 = new Smart.FilterGroup();

          var _n66 = "and",
              _o47 = 0;

          for (var _r25 = 0; _r25 < _t124.length; _r25++) {
            var _l14 = _t124[_r25];

            if ("and" === _l14 || "or" === _l14) {
              _n66 = _l14;
              continue;
            }

            if (_o47++, 2 === _o47) {
              var s = _a82.createFilter(e, _l14, i[_t124[_r25 - 1]]);

              _o47 = 0, _n66 && _a82.addFilter(_n66, s);
            }
          }

          r.push(_a82);
        } else {
          var _e140 = _t124[0];
          if ("and" !== _e140 && "or" !== _e140) throw new Error("Filter Exprresion expects \"AND\" or \"OR\", but the token is: " + _e140);
          o.push(_e140);
        }
      }

      var l = 0;
      if (1 === r.length) return r[0];

      for (var _a83 = 0, _i118; _a83 < r.length; _a83++) {
        _i118 = o[l], 0 == (_a83 + 1) % 2 && l++, _i118 || (_i118 = "and"), n.addFilter(_i118, r[_a83]);
      }

      return n;
    }
  }, {
    key: "filterBy",
    value: function filterBy(e) {
      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }

      var a = this,
          i = function () {
        for (var _t125 = 0; _t125 < a.dataFields.length; _t125++) {
          var _i119 = a.dataFields[_t125];
          if (_i119.name === e) return _i119.dataType;
        }
      }(),
          n = a._createFilter(i, t);

      var o = a.boundSource.filter(function (t) {
        var i = n.evaluate(t[e]);
        return i;
      });
      return o;
    }
  }, {
    key: "_filter",
    value: function _filter(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "and";
      var a = this,
          n = [],
          o = [];
      if (0 === e.length) return void a.clearFilter();

      var r = function r(e) {
        for (var _t126 = 0; _t126 < a.dataFields.length; _t126++) {
          var _i120 = a.dataFields[_t126];
          if (_i120.name === e) return _i120.dataType;
        }
      };

      var l, i;
      "and" === t ? (l = !0, i = function i(e, t, _i121) {
        return e && t.evaluate(_i121[t.dataField]);
      }) : (l = !1, i = function i(e, t, _i122) {
        return e || t.evaluate(_i122[t.dataField]);
      });

      for (var _l15 = 0; _l15 < e.length; _l15++) {
        var _t127 = e[_l15],
            _i123 = _t127[0];
        var s = null;
        s = _t127[1] instanceof Smart.FilterGroup ? _t127[1] : a._createFilter(r(_i123), _t127.splice(1)), s && (o.push(_i123), s.dataField = _i123, n.push(s));
      }

      if (a.boundHierarchy) {
        var _e141 = function _e141(e) {
          var t = l;

          for (var _a84 = 0; _a84 < n.length; _a84++) {
            var _o48 = n[_a84];
            t = i(t, _o48, e);
          }

          return e.$.filtered = t, t;
        },
            _t128 = function _t128(n, o, i) {
          var r = 0;

          for (var _a85 = 0; _a85 < n.length; _a85++) {
            var _i124 = n[_a85];
            _e141(_i124), _i124.$.filtered && r++, _i124.children && _t128(_i124.children, _i124, o);
          }

          0 < r && 0 < a.groupBy.length && o ? (o.$.filtered = !0, i && !i.$.filtered && (i.$.filtered = !0)) : 0 < r && r !== n.length && o && (o.$.filtered = null, i && !i.$.filtered && (i.$.filtered = null));
        };

        _t128(a.boundHierarchy, null, null);
      } else for (var _e142 = 0; _e142 < a.boundSource.length; _e142++) {
        var _t129 = a.boundSource[_e142];
        var _o49 = l;

        for (var _e143 = 0; _e143 < n.length; _e143++) {
          var _a86 = n[_e143];
          _o49 = i(_o49, _a86, _t129);
        }

        _t129.$.filtered = _o49;
      }

      a.onFilter && a.onFilter();
    }
  }, {
    key: "clearGroup",
    value: function clearGroup() {
      var e = this;
      e.groupBy = [], e.boundHierarchy = null, e.refreshHierarchy(), e.onGroup && e.onGroup();
    }
  }, {
    key: "clearFilter",
    value: function clearFilter() {
      var e = this;

      for (var t = 0; t < e.boundSource.length; t++) {
        var i = e.boundSource[t];
        i.$.filtered = !0;
      }

      if (e.boundHierarchy) {
        var _t130 = function _t130(e, a, i) {
          for (var n = 0; n < e.length; n++) {
            var _i125 = e[n];
            _i125.$.filtered = !0, _i125.$.filtered, _i125.children && _t130(_i125.children, _i125, a);
          }

          a && (a.$.filtered = !0, i && !i.$.filtered && (i.$.filtered = !0));
        };

        _t130(e.boundHierarchy, null, null);
      }

      e.onFilter && e.onFilter();
    }
  }, {
    key: "clearSort",
    value: function clearSort() {
      var e = this;

      e._sort(e.boundSource, [], [], []);
    }
  }, {
    key: "_sort",
    value: function _sort(e, t, a, n, i) {
      var o = this;
      var r = !1;
      if (0 === e.length) return;
      if (e && e.constructor && e instanceof Smart.ObservableArray && (r = !0), (!e || !Array.isArray(e) || 0 === e.length || !t || Array.isArray(t) && 0 === t.length) && !r && !o.boundHierarchy) throw new Error("sort: Missing or Invalid arguments!");
      "string" == typeof t && (t = [t]);
      var l = [],
          s = [];
      void 0 === a && (a = []);

      var d = function d(e, t) {
        var i;

        switch (t || typeof e) {
          case "string":
            i = new Intl.Collator().compare;
            break;

          case "number":
            i = function i(e, t) {
              return e - t;
            };

            break;

          case "boolean":
          case "bool":
            i = function i(e, t) {
              return e === t ? 0 : !1 === e ? -1 : 1;
            };

            break;

          case "date":
          case "time":
          case "dateTime":
            e instanceof Date ? i = function i(e, t) {
              return e.getTime() - t.getTime();
            } : (e instanceof Smart.Utilities.DateTime || e instanceof Smart.Utilities.BigNumber) && (i = function i(e, t) {
              return e.compare(t);
            });
            break;

          case "object":
            if (e instanceof Date) i = function i(e, t) {
              return e.getTime() - t.getTime();
            };else if (e instanceof Smart.Utilities.DateTime || e instanceof Smart.Utilities.BigNumber) i = function i(e, t) {
              return e.compare(t);
            };else if (e instanceof Smart.Utilities.Complex || window.NIComplex && e instanceof window.NIComplex) {
              var _e144 = new Smart.Utilities.ComplexNumericProcessor();

              i = function i(t, _i126) {
                return _e144.compareComplexNumbers(t, _i126);
              };
            }
        }

        return i;
      };

      for (var _o50 = 0; _o50 < t.length; _o50++) {
        l[_o50] = void 0 === a[_o50] || "asc" === a[_o50] || "ascending" === a[_o50] ? 1 : -1;
        var _i127 = e[0][t[_o50]];
        s[_o50] = d(_i127, n[_o50]);
      }

      if (i) return void i(e, t, a, s);
      e.sort(function (e, a) {
        for (var _n67 = 0; _n67 < t.length; _n67++) {
          var _i128 = s[_n67](e[t[_n67]], a[t[_n67]]);

          if (0 === _i128) {
            if (t[_n67 + 1]) continue;else if (void 0 !== e._index) return (e._index - a._index) * l[_n67];
            return 0;
          }

          return _i128 * l[_n67];
        }

        if (0 === t.length) return e.$.index < a.$.index ? -1 : e.$.index > a.$.index ? 1 : 0;
      });

      for (var _r26 = 0; _r26 < e.length; _r26++) {
        o[_r26] = e[_r26];
      }
    }
  }, {
    key: "filter",
    value: function filter(e, t, i) {
      Smart.DataAdapter.Filter(this.boundSource, e, t, i);
    }
  }, {
    key: "sort",
    value: function sort(e, t, i) {
      Smart.DataAdapter.Sort(this.boundSource, e, t, i);
    }
  }, {
    key: "dataFields",
    get: function get() {
      var e = this;
      return e._dataFields;
    },
    set: function set(e) {
      var t = this;
      return t._dataFields = t._getDataFieldObjects(e), t._dataFields;
    }
  }, {
    key: "dataSource",
    get: function get() {
      var e = this;
      return e._dataSource || (e._dataSource = []), e._dataSource;
    },
    set: function set(e) {
      var t = this;
      t._dataSource = e, t.isInitialized && (t.boundSource = !1 === t.observable ? [] : new Smart.ObservableArray(), t.dataItemById = [], t.bindingCompleted = !1, t.dataBind());
    }
  }, {
    key: "canNotify",
    get: function get() {
      var e = this;
      return void 0 === e._canNotify && (e._canNotify = !0), e._canNotify;
    },
    set: function set(e) {
      var t = this;
      t._canNotify = e;
    }
  }, {
    key: "length",
    get: function get() {
      var e = this;
      return void 0 === e.virtualDataSourceLength ? e.dataSourceLength ? e.dataSourceLength : "number" == typeof e.dataSource ? e.dataSource : e.bindingCompleted ? e.boundSource.length : e.dataSource && "string" != typeof e.dataSource && e.dataSource.length ? e.dataSource.length : e.boundSource.length : e.virtualDataSourceLength;
    }
  }], [{
    key: "Filter",
    value: function Filter(e, t, a, n) {
      var i = e.filter(function (e) {
        var o = !0;

        for (var r = 0; r < a.length; r++) {
          var _i129 = a[r],
              l = t[r];
          o = n ? o && n(e, l, _i129) : o && _i129.evaluate(e[l]);
        }

        return o;
      });
      return i;
    }
  }, {
    key: "Sort",
    value: function Sort(e, t, a, i) {
      var n = function n(e) {
        var t;

        switch (typeof e) {
          case "string":
            t = new Intl.Collator().compare;
            break;

          case "number":
            t = function t(e, _t131) {
              return e - _t131;
            };

            break;

          case "boolean":
            t = function t(e, _t132) {
              return e === _t132 ? 0 : !1 === e ? -1 : 1;
            };

            break;

          case "object":
            if (e instanceof Date) t = function t(e, _t133) {
              return e.getTime() - _t133.getTime();
            };else if (e instanceof Smart.Utilities.DateTime || e instanceof BigNumberNG) t = function t(e, _t134) {
              return e.compare(_t134);
            };else if (e instanceof Smart.Utilities.Complex || window.NIComplex && e instanceof window.NIComplex) {
              var _e145 = new Smart.Utilities.ComplexNumericProcessor();

              t = function t(_t135, i) {
                return _e145.compareComplexNumbers(_t135, i);
              };
            }
        }

        return t;
      };

      if (!e || !Array.isArray(e) || 0 === e.length || !t || Array.isArray(t) && 0 === t.length) return;
      "string" == typeof t && (t = [t]);
      var o = [],
          r = [];
      void 0 === a && (a = []);

      for (var _l16 = 0; _l16 < t.length; _l16++) {
        o[_l16] = void 0 === a[_l16] || "asc" === a[_l16] || "ascending" === a[_l16] ? 1 : -1, r[_l16] = n(e[0][t[_l16]]);
      }

      if (i) return void i(e, t, a, r);
      var l = e.slice(0);
      return l.sort(function (e, a) {
        for (var _n68 = 0; _n68 < t.length; _n68++) {
          var _i130 = r[_n68](e[t[_n68]], a[t[_n68]]);

          if (0 === _i130) {
            if (t[_n68 + 1]) continue;else if (void 0 !== e._index) return (e._index - a._index) * o[_n68];
            return 0;
          }

          return _i130 * o[_n68];
        }
      }), l;
    }
  }]);

  return DataAdapter;
}();

Smart.DataAdapter = DataAdapter;

var Ajax =
/*#__PURE__*/
function () {
  "use strict";

  function Ajax(e, t) {
    _classCallCheck(this, Ajax);

    var i = this;
    i.config = e, i.callback = t;
    !1 === e.autoFetch || i.call(e);
  }

  _createClass(Ajax, [{
    key: "call",
    value: function call(e) {
      var t = this;
      e || (e = t.config);
      var i = "GET",
          a = e.url,
          n = null,
          o = !0;
      if (e.type && (i = e.type), e.data) if ("GET" === i) {
        for (var _t136 in a += "?", e.data) {
          e.data.hasOwnProperty(_t136) && (a += encodeURI(_t136 + "=" + e.data[_t136] + "&"));
        }

        "&" === a.charAt(a.length - 1) && (a = a.slice(0, a.length - 1));
      } else "POST" === i && (n = JSON.stringify(e.data));
      e && !1 === e.async && "xlsx" !== e.dataSourceType && (o = !1), void 0 !== window.fetch && o ? t.ajaxFetch(e, i, a, n) : t.ajaxXMLHttpRequest(e, i, a, n, o);
    }
  }, {
    key: "ajaxFetch",
    value: function ajaxFetch(e, t, i, a) {
      var n = this,
          o = {
        method: t
      };
      var r;

      switch (e.dataSourceType) {
        case "json":
          r = "json";
          break;

        case "xlsx":
          r = "arrayBuffer";
          break;

        default:
          r = "text";
      }

      e && e.contentType && (o.headers = new Headers({
        "Content-Type": e.contentType
      })), null !== a && (o.body = a);
      var l, s, d;

      if (e.timeout && (s = setTimeout(function () {
        d = !0;
      }, e.timeout)), e.beforeSend) {
        var _t137 = e.beforeSend(o, e);

        if (!1 === _t137) return;
      }

      fetch(i, o).then(function (e) {
        if (d) throw l = 408, new Error("timeout");
        if (s && clearTimeout(s), l = e.status, !e.ok) throw new Error(e.statusText);
        return e[r]();
      }).then(function (t) {
        return "arrayBuffer" === r ? JSZip.loadAsync(t).then(function (t) {
          return t.files["xl/worksheets/sheet1.xml"].async("text").then(function (i) {
            return t.files["xl/sharedStrings.xml"].async("text").then(function (t) {
              var a = n.parseXLSXData(i, t);
              n.ajaxComplete(e, a, l);
            });
          });
        }) : void n.ajaxComplete(e, t, l);
      }).catch(function (t) {
        "JSZip is not defined" === t.message && (t.message = "JSZip is not defined. Please include a reference to JSZip to be able to load data from XLSX files."), e && e.loadError && e.loadError(l, t), n.callback && n.callback(t, l);
      });
    }
  }, {
    key: "ajaxXMLHttpRequest",
    value: function ajaxXMLHttpRequest(e, t, i, a, n) {
      var o = new XMLHttpRequest(),
          r = this;

      if (o.open(t, i, n), o.ontimeout = function () {
        e && e.loadError && e.loadError(408, "timeout");
      }, o.onload = function () {
        if (4 === o.readyState) {
          var _t138 = o.status;
          var _i131 = o.response;
          200 <= _t138 && 299 >= _t138 ? ("json" === e.dataSourceType && (_i131 = JSON.parse(_i131)), r.ajaxComplete(e, _i131, _t138)) : e && e.loadError && e.loadError(_t138, _i131);
        }
      }, o.onerror = function () {
        e && e.loadError && e.loadError(o.status, o.response);
      }, e && e.contentType && o.setRequestHeader("Content-Type", e.contentType), n && e.timeout && (o.timeout = e.timeout), e.beforeSend) {
        var _t139 = e.beforeSend(o, e);

        if (!1 === _t139) return;
      }

      o.send(a);
    }
  }, {
    key: "ajaxComplete",
    value: function ajaxComplete(e, t, i) {
      if (e) {
        if (e.beforeLoadComplete) {
          var _i132 = e.beforeLoadComplete(t);

          _i132 && (t = _i132);
        }

        e.loadComplete && e.loadComplete(t, i), this.callback && this.callback(t, i);
      }
    }
  }, {
    key: "parseXLSXData",
    value: function parseXLSXData(e, t) {
      var i = new DOMParser(),
          a = i.parseFromString(t, "text/xml"),
          n = Array.from(a.getElementsByTagName("si")),
          o = [],
          r = i.parseFromString(e, "text/xml"),
          l = Array.from(r.getElementsByTagName("row")),
          s = [];
      return n.forEach(function (e) {
        var t = e.getElementsByTagName("t");
        if (1 === t.length) o.push(t[0].innerHTML);else {
          var _e146 = "";
          t = Array.from(t), t.forEach(function (i) {
            _e146 += i.innerHTML;
          }), o.push(_e146);
        }
      }), l.forEach(function (e) {
        var t = {},
            i = Array.from(e.getElementsByTagName("c"));
        i.forEach(function (e) {
          var i = e.getAttribute("r").match(/\D+/)[0],
              a = e.getAttribute("t"),
              n = e.getElementsByTagName("v")[0].innerHTML;
          var r;
          r = "s" === a ? o[parseFloat(n)] : "b" === a ? 1 === parseFloat(n) : parseFloat(n), t[i] = r;
        }), s.push(t);
      }), s;
    }
  }]);

  return Ajax;
}();

var localTimezoneOffset = -1 * new Date().getTimezoneOffset(),
    __timeZones = [{
  id: "Local",
  offset: localTimezoneOffset,
  offsetHours: localTimezoneOffset / 60,
  displayName: "",
  supportsDaylightSavingTime: !1
}, {
  id: "Dateline Standard Time",
  offset: -720,
  offsetHours: -12,
  displayName: "(UTC-12:00) International Date Line West",
  supportsDaylightSavingTime: !1
}, {
  id: "UTC-11",
  offset: -660,
  offsetHours: -11,
  displayName: "(UTC-11:00) Coordinated Universal Time-11",
  supportsDaylightSavingTime: !1
}, {
  id: "Hawaiteratoran Standard Time",
  offset: -600,
  offsetHours: -10,
  displayName: "(UTC-10:00) Hawaiterator",
  supportsDaylightSavingTime: !1
}, {
  id: "Alaskan Standard Time",
  offset: -540,
  offsetHours: -9,
  displayName: "(UTC-09:00) Alaska",
  supportsDaylightSavingTime: !0
}, {
  id: "Pacific Standard Time (Mexico)",
  offset: -480,
  offsetHours: -8,
  displayName: "(UTC-08:00) Baja California",
  supportsDaylightSavingTime: !0
}, {
  id: "Pacific Standard Time",
  offset: -480,
  offsetHours: -8,
  displayName: "(UTC-08:00) Pacific Time (US & Canada)",
  supportsDaylightSavingTime: !0
}, {
  id: "US Mountain Standard Time",
  offset: -420,
  offsetHours: -7,
  displayName: "(UTC-07:00) Arizona",
  supportsDaylightSavingTime: !1
}, {
  id: "Mountain Standard Time (Mexico)",
  offset: -420,
  offsetHours: -7,
  displayName: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
  supportsDaylightSavingTime: !0
}, {
  id: "Mountain Standard Time",
  offset: -420,
  offsetHours: -7,
  displayName: "(UTC-07:00) Mountain Time (US & Canada)",
  supportsDaylightSavingTime: !0
}, {
  id: "Central Standard Time",
  offset: -360,
  offsetHours: -6,
  displayName: "(UTC-06:00) Central Time (US & Canada)",
  supportsDaylightSavingTime: !0
}, {
  id: "Central America Standard Time",
  offset: -360,
  offsetHours: -6,
  displayName: "(UTC-06:00) Central America",
  supportsDaylightSavingTime: !1
}, {
  id: "Canada Central Standard Time",
  offset: -360,
  offsetHours: -6,
  displayName: "(UTC-06:00) Saskatchewan",
  supportsDaylightSavingTime: !1
}, {
  id: "Central Standard Time (Mexico)",
  offset: -360,
  offsetHours: -6,
  displayName: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  supportsDaylightSavingTime: !0
}, {
  id: "SA Pacific Standard Time",
  offset: -300,
  offsetHours: -5,
  displayName: "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
  supportsDaylightSavingTime: !1
}, {
  id: "Eastern Standard Time",
  offset: -300,
  offsetHours: -5,
  displayName: "(UTC-05:00) Eastern Time (US & Canada)",
  supportsDaylightSavingTime: !0
}, {
  id: "US Eastern Standard Time",
  offset: -300,
  offsetHours: -5,
  displayName: "(UTC-05:00) Indiana (East)",
  supportsDaylightSavingTime: !0
}, {
  id: "Venezuela Standard Time",
  offset: -270,
  offsetHours: -4.5,
  displayName: "(UTC-04:30) Caracas",
  supportsDaylightSavingTime: !1
}, {
  id: "Atlantic Standard Time",
  offset: -240,
  offsetHours: -4,
  displayName: "(UTC-04:00) Atlantic Time (Canada)",
  supportsDaylightSavingTime: !0
}, {
  id: "Paraguay Standard Time",
  offset: -240,
  offsetHours: -4,
  displayName: "(UTC-04:00) Asuncion",
  supportsDaylightSavingTime: !0
}, {
  id: "Central Brazilian Standard Time",
  offset: -240,
  offsetHours: -4,
  displayName: "(UTC-04:00) Cuiaba",
  supportsDaylightSavingTime: !0
}, {
  id: "Pacific SA Standard Time",
  offset: -240,
  offsetHours: -4,
  displayName: "(UTC-04:00) Santiago",
  supportsDaylightSavingTime: !0
}, {
  id: "SA Western Standard Time",
  offset: -240,
  offsetHours: -4,
  displayName: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  supportsDaylightSavingTime: !1
}, {
  id: "Newfoundland Standard Time",
  offset: -210,
  offsetHours: -3.5,
  displayName: "(UTC-03:30) Newfoundland",
  supportsDaylightSavingTime: !0
}, {
  id: "SA Eastern Standard Time",
  offset: -180,
  offsetHours: -3,
  displayName: "(UTC-03:00) Cayenne, Fortaleza",
  supportsDaylightSavingTime: !1
}, {
  id: "Argentina Standard Time",
  offset: -180,
  offsetHours: -3,
  displayName: "(UTC-03:00) Buenos Aires",
  supportsDaylightSavingTime: !0
}, {
  id: "E. South America Standard Time",
  offset: -180,
  offsetHours: -3,
  displayName: "(UTC-03:00) Brasilia",
  supportsDaylightSavingTime: !0
}, {
  id: "Bahia Standard Time",
  offset: -180,
  offsetHours: -3,
  displayName: "(UTC-03:00) Salvador",
  supportsDaylightSavingTime: !0
}, {
  id: "Montevideo Standard Time",
  offset: -180,
  offsetHours: -3,
  displayName: "(UTC-03:00) Montevideo",
  supportsDaylightSavingTime: !0
}, {
  id: "Greenland Standard Time",
  offset: -180,
  offsetHours: -3,
  displayName: "(UTC-03:00) Greenland",
  supportsDaylightSavingTime: !0
}, {
  id: "UTC-02",
  offset: -120,
  offsetHours: -2,
  displayName: "(UTC-02:00) Coordinated Universal Time-02",
  supportsDaylightSavingTime: !1
}, {
  id: "Mid-Atlantic Standard Time",
  offset: -120,
  offsetHours: -2,
  displayName: "(UTC-02:00) Mid-Atlantic - Old",
  supportsDaylightSavingTime: !0
}, {
  id: "Azores Standard Time",
  offset: -60,
  offsetHours: -1,
  displayName: "(UTC-01:00) Azores",
  supportsDaylightSavingTime: !0
}, {
  id: "Cape Verde Standard Time",
  offset: -60,
  offsetHours: -1,
  displayName: "(UTC-01:00) Cape Verde Is.",
  supportsDaylightSavingTime: !1
}, {
  id: "Morocco Standard Time",
  offset: 0,
  offsetHours: 0,
  displayName: "(UTC) Casablanca",
  supportsDaylightSavingTime: !0
}, {
  id: "UTC",
  offset: 0,
  offsetHours: 0,
  displayName: "(UTC) Coordinated Universal Time",
  supportsDaylightSavingTime: !1
}, {
  id: "GMT Standard Time",
  offset: 0,
  offsetHours: 0,
  displayName: "(UTC) Dublin, Edinburgh, Lisbon, London",
  supportsDaylightSavingTime: !0
}, {
  id: "Greenwich Standard Time",
  offset: 0,
  offsetHours: 0,
  displayName: "(UTC) Monrovia, Reykjavik",
  supportsDaylightSavingTime: !1
}, {
  id: "Central European Standard Time",
  offset: 60,
  offsetHours: 1,
  displayName: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  supportsDaylightSavingTime: !0
}, {
  id: "Namibia Standard Time",
  offset: 60,
  offsetHours: 1,
  displayName: "(UTC+01:00) Windhoek",
  supportsDaylightSavingTime: !0
}, {
  id: "W. Central Africa Standard Time",
  offset: 60,
  offsetHours: 1,
  displayName: "(UTC+01:00) West Central Africa",
  supportsDaylightSavingTime: !1
}, {
  id: "W. Europe Standard Time",
  offset: 60,
  offsetHours: 1,
  displayName: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  supportsDaylightSavingTime: !0
}, {
  id: "Central Europe Standard Time",
  offset: 60,
  offsetHours: 1,
  displayName: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  supportsDaylightSavingTime: !0
}, {
  id: "Romance Standard Time",
  offset: 60,
  offsetHours: 1,
  displayName: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
  supportsDaylightSavingTime: !0
}, {
  id: "FLE Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  supportsDaylightSavingTime: !0
}, {
  id: "South Africa Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Harare, Pretoria",
  supportsDaylightSavingTime: !1
}, {
  id: "Turkey Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Istanbul",
  supportsDaylightSavingTime: !0
}, {
  id: "GTB Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Athens, Bucharest",
  supportsDaylightSavingTime: !0
}, {
  id: "Libya Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Tripoli",
  supportsDaylightSavingTime: !0
}, {
  id: "E. Europe Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) E. Europe",
  supportsDaylightSavingTime: !0
}, {
  id: "Jordan Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Amman",
  supportsDaylightSavingTime: !0
}, {
  id: "Middle East Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Beirut",
  supportsDaylightSavingTime: !0
}, {
  id: "Egypt Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Cairo",
  supportsDaylightSavingTime: !0
}, {
  id: "Syria Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Damascus",
  supportsDaylightSavingTime: !0
}, {
  id: "Israel Standard Time",
  offset: 120,
  offsetHours: 2,
  displayName: "(UTC+02:00) Jerusalem",
  supportsDaylightSavingTime: !0
}, {
  id: "Arab Standard Time",
  offset: 180,
  offsetHours: 3,
  displayName: "(UTC+03:00) Kuwait, Riyadh",
  supportsDaylightSavingTime: !1
}, {
  id: "E. Africa Standard Time",
  offset: 180,
  offsetHours: 3,
  displayName: "(UTC+03:00) Nairobi",
  supportsDaylightSavingTime: !1
}, {
  id: "Arabic Standard Time",
  offset: 180,
  offsetHours: 3,
  displayName: "(UTC+03:00) Baghdad",
  supportsDaylightSavingTime: !0
}, {
  id: "Kaliningrad Standard Time",
  offset: 180,
  offsetHours: 3,
  displayName: "(UTC+03:00) Kaliningrad, Minsk",
  supportsDaylightSavingTime: !0
}, {
  id: "Iran Standard Time",
  offset: 210,
  offsetHours: 3.5,
  displayName: "(UTC+03:30) Tehran",
  supportsDaylightSavingTime: !0
}, {
  id: "Mauritius Standard Time",
  offset: 240,
  offsetHours: 4,
  displayName: "(UTC+04:00) Port Louis",
  supportsDaylightSavingTime: !0
}, {
  id: "Georgian Standard Time",
  offset: 240,
  offsetHours: 4,
  displayName: "(UTC+04:00) Tbilisi",
  supportsDaylightSavingTime: !1
}, {
  id: "Caucasus Standard Time",
  offset: 240,
  offsetHours: 4,
  displayName: "(UTC+04:00) Yerevan",
  supportsDaylightSavingTime: !0
}, {
  id: "Arabian Standard Time",
  offset: 240,
  offsetHours: 4,
  displayName: "(UTC+04:00) Abu Dhabi, Muscat",
  supportsDaylightSavingTime: !1
}, {
  id: "Azerbaijan Standard Time",
  offset: 240,
  offsetHours: 4,
  displayName: "(UTC+04:00) Baku",
  supportsDaylightSavingTime: !0
}, {
  id: "Russian Standard Time",
  offset: 240,
  offsetHours: 4,
  displayName: "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
  supportsDaylightSavingTime: !0
}, {
  id: "Afghanistan Standard Time",
  offset: 270,
  offsetHours: 4.5,
  displayName: "(UTC+04:30) Kabul",
  supportsDaylightSavingTime: !1
}, {
  id: "Pakistan Standard Time",
  offset: 300,
  offsetHours: 5,
  displayName: "(UTC+05:00) Islamabad, Karachi",
  supportsDaylightSavingTime: !0
}, {
  id: "West Asia Standard Time",
  offset: 300,
  offsetHours: 5,
  displayName: "(UTC+05:00) Ashgabat, Tashkent",
  supportsDaylightSavingTime: !1
}, {
  id: "India Standard Time",
  offset: 330,
  offsetHours: 5.5,
  displayName: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  supportsDaylightSavingTime: !1
}, {
  id: "Sri Lanka Standard Time",
  offset: 330,
  offsetHours: 5.5,
  displayName: "(UTC+05:30) Sri Jayawardenepura",
  supportsDaylightSavingTime: !1
}, {
  id: "Nepal Standard Time",
  offset: 345,
  offsetHours: 5.75,
  displayName: "(UTC+05:45) Kathmandu",
  supportsDaylightSavingTime: !1
}, {
  id: "Central Asia Standard Time",
  offset: 360,
  offsetHours: 6,
  displayName: "(UTC+06:00) Astana",
  supportsDaylightSavingTime: !1
}, {
  id: "Bangladesh Standard Time",
  offset: 360,
  offsetHours: 6,
  displayName: "(UTC+06:00) Dhaka",
  supportsDaylightSavingTime: !0
}, {
  id: "Ekaterinburg Standard Time",
  offset: 360,
  offsetHours: 6,
  displayName: "(UTC+06:00) Ekaterinburg",
  supportsDaylightSavingTime: !0
}, {
  id: "Myanmar Standard Time",
  offset: 390,
  offsetHours: 6.5,
  displayName: "(UTC+06:30) Yangon (Rangoon)",
  supportsDaylightSavingTime: !1
}, {
  id: "SE Asia Standard Time",
  offset: 420,
  offsetHours: 7,
  displayName: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  supportsDaylightSavingTime: !1
}, {
  id: "N. Central Asia Standard Time",
  offset: 420,
  offsetHours: 7,
  displayName: "(UTC+07:00) Novosibirsk",
  supportsDaylightSavingTime: !0
}, {
  id: "Ulaanbaatar Standard Time",
  offset: 480,
  offsetHours: 8,
  displayName: "(UTC+08:00) Ulaanbaatar",
  supportsDaylightSavingTime: !1
}, {
  id: "China Standard Time",
  offset: 480,
  offsetHours: 8,
  displayName: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  supportsDaylightSavingTime: !1
}, {
  id: "Singapore Standard Time",
  offset: 480,
  offsetHours: 8,
  displayName: "(UTC+08:00) Kuala Lumpur, Singapore",
  supportsDaylightSavingTime: !1
}, {
  id: "North Asia Standard Time",
  offset: 480,
  offsetHours: 8,
  displayName: "(UTC+08:00) Krasnoyarsk",
  supportsDaylightSavingTime: !0
}, {
  id: "Taipei Standard Time",
  offset: 480,
  offsetHours: 8,
  displayName: "(UTC+08:00) Taipei",
  supportsDaylightSavingTime: !1
}, {
  id: "W. Australia Standard Time",
  offset: 480,
  offsetHours: 8,
  displayName: "(UTC+08:00) Perth",
  supportsDaylightSavingTime: !0
}, {
  id: "Korea Standard Time",
  offset: 540,
  offsetHours: 9,
  displayName: "(UTC+09:00) Seoul",
  supportsDaylightSavingTime: !1
}, {
  id: "North Asia East Standard Time",
  offset: 540,
  offsetHours: 9,
  displayName: "(UTC+09:00) Irkutsk",
  supportsDaylightSavingTime: !0
}, {
  id: "Tokyo Standard Time",
  offset: 540,
  offsetHours: 9,
  displayName: "(UTC+09:00) Osaka, Sapporo, Tokyo",
  supportsDaylightSavingTime: !1
}, {
  id: "AUS Central Standard Time",
  offset: 570,
  offsetHours: 9.5,
  displayName: "(UTC+09:30) Darwin",
  supportsDaylightSavingTime: !1
}, {
  id: "Cen. Australia Standard Time",
  offset: 570,
  offsetHours: 9.5,
  displayName: "(UTC+09:30) Adelaide",
  supportsDaylightSavingTime: !0
}, {
  id: "West Pacific Standard Time",
  offset: 600,
  offsetHours: 10,
  displayName: "(UTC+10:00) Guam, Port Moresby",
  supportsDaylightSavingTime: !1
}, {
  id: "Tasmania Standard Time",
  offset: 600,
  offsetHours: 10,
  displayName: "(UTC+10:00) Hobart",
  supportsDaylightSavingTime: !0
}, {
  id: "E. Australia Standard Time",
  offset: 600,
  offsetHours: 10,
  displayName: "(UTC+10:00) Brisbane",
  supportsDaylightSavingTime: !1
}, {
  id: "AUS Eastern Standard Time",
  offset: 600,
  offsetHours: 10,
  displayName: "(UTC+10:00) Canberra, Melbourne, Sydney",
  supportsDaylightSavingTime: !0
}, {
  id: "Yakutsk Standard Time",
  offset: 600,
  offsetHours: 10,
  displayName: "(UTC+10:00) Yakutsk",
  supportsDaylightSavingTime: !0
}, {
  id: "Vladivostok Standard Time",
  offset: 660,
  offsetHours: 11,
  displayName: "(UTC+11:00) Vladivostok",
  supportsDaylightSavingTime: !0
}, {
  id: "Central Pacific Standard Time",
  offset: 660,
  offsetHours: 11,
  displayName: "(UTC+11:00) Solomon Is., New Caledonia",
  supportsDaylightSavingTime: !1
}, {
  id: "Magadan Standard Time",
  offset: 720,
  offsetHours: 12,
  displayName: "(UTC+12:00) Magadan",
  supportsDaylightSavingTime: !0
}, {
  id: "Kamchatka Standard Time",
  offset: 720,
  offsetHours: 12,
  displayName: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
  supportsDaylightSavingTime: !0
}, {
  id: "Fiji Standard Time",
  offset: 720,
  offsetHours: 12,
  displayName: "(UTC+12:00) Fiji",
  supportsDaylightSavingTime: !0
}, {
  id: "New Zealand Standard Time",
  offset: 720,
  offsetHours: 12,
  displayName: "(UTC+12:00) Auckland, Wellington",
  supportsDaylightSavingTime: !0
}, {
  id: "UTC+12",
  offset: 720,
  offsetHours: 12,
  displayName: "(UTC+12:00) Coordinated Universal Time+12",
  supportsDaylightSavingTime: !1
}, {
  id: "Tonga Standard Time",
  offset: 780,
  offsetHours: 13,
  displayName: "(UTC+13:00) Nuku'alofa",
  supportsDaylightSavingTime: !1
}, {
  id: "Samoa Standard Time",
  offset: 780,
  offsetHours: 13,
  displayName: "(UTC+13:00) Samoa",
  supportsDaylightSavingTime: !0
}],
    __daysToMonth365 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365],
    __daysToMonth366 = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366],
    __daysPer4Years = 1461,
    __daysPer100Years = 36524,
    __daysPer400Years = 146097,
    __daysTo1601 = 584388,
    __daysTo1899 = 693593,
    __daysTo10000 = 3652059,
    __minTicks = 0,
    __maxTicks = 3155378976000000000,
    __maxMillis = 315537897600000;
Smart.Utilities.Assign("TimeSpan",
/*#__PURE__*/
function () {
  "use strict";

  function _class5() {
    _classCallCheck(this, _class5);

    var e = this;

    if (e.ticksPerMillisecond = 1e4, e.millisecondsPerTick = 1 / 1e4, e.ticksPerSecond = 10000000, e.secondsPerTick = 1 / 10000000, e.ticksPerMinute = 600000000, e.minutesPerTick = 1 / 600000000, e.ticksPerHour = 36000000000, e.hoursPerTick = 1 / 36000000000, e.ticksPerDay = 864000000000, e.daysPerTick = 1 / 864000000000, e.millisPerSecond = 1e3, e.millisPerMinute = 60000, e.millisPerHour = 3600000, e.millisPerDay = 86400000, e._ticks = 0, 1 === arguments.length) {
      if (isNaN(arguments[0])) throw new Error("Argument must be a number.");
      e._ticks = arguments[0];
    } else if (3 === arguments.length) e._ticks = e.timeToMS(arguments[0], arguments[1], arguments[2], 0);else if (4 === arguments.length) {
      var t = arguments[0],
          i = arguments[1],
          a = arguments[2],
          n = arguments[3];
      e._ticks = (1e3 * (24 * (3600 * t) + 3600 * i + 60 * a + n) + 0) * e.ticksPerMillisecond;
    } else if (5 === arguments.length) {
      var _t140 = arguments[0],
          _i133 = arguments[1],
          _a87 = arguments[2],
          _n69 = arguments[3],
          o = arguments[4];
      e._ticks = (1e3 * (24 * (3600 * _t140) + 3600 * _i133 + 60 * _a87 + _n69) + o) * e.ticksPerMillisecond;
    }
  }

  _createClass(_class5, [{
    key: "ticks",
    value: function ticks() {
      return this._ticks;
    }
  }, {
    key: "days",
    value: function days() {
      var e = this;
      return parseInt(e._ticks / e.ticksPerDay);
    }
  }, {
    key: "timeToMS",
    value: function timeToMS(e, t, i, a) {
      return parseInt((3600 * e + 60 * t + i + a / 1e3) * this.ticksPerSecond);
    }
  }, {
    key: "hours",
    value: function hours() {
      var e = this;
      return parseInt(e._ticks / e.ticksPerHour) % 24;
    }
  }, {
    key: "milliseconds",
    value: function milliseconds() {
      var e = this;
      return parseInt(e._ticks / e.ticksPerMillisecond) % 1e3;
    }
  }, {
    key: "minutes",
    value: function minutes() {
      var e = this;
      return parseInt(e._ticks / e.ticksPerMinute) % 60;
    }
  }, {
    key: "seconds",
    value: function seconds() {
      var e = this;
      return parseInt(e._ticks / e.ticksPerSecond) % 60;
    }
  }, {
    key: "totalDays",
    value: function totalDays() {
      var e = this;
      return parseInt(e._ticks * e.daysPerTick);
    }
  }, {
    key: "totalHours",
    value: function totalHours() {
      var e = this;
      return parseInt(e._ticks * e.hoursPerTick);
    }
  }, {
    key: "totalMilliseconds",
    value: function totalMilliseconds() {
      var e = this,
          t = e._ticks * e.millisecondsPerTick;
      return parseInt(t);
    }
  }, {
    key: "totalMinutes",
    value: function totalMinutes() {
      var e = this;
      return parseInt(e._ticks * e.minutesPerTick);
    }
  }, {
    key: "totalSeconds",
    value: function totalSeconds() {
      var e = this;
      return parseInt(e._ticks * e.secondsPerTick);
    }
  }, {
    key: "add",
    value: function add(e) {
      var t = this._ticks + e._ticks,
          i = new Smart.Utilities.TimeSpan(t);
      return i;
    }
  }, {
    key: "subtract",
    value: function subtract(e) {
      var t = this._ticks - e._ticks;
      return new Smart.Utilities.TimeSpan(t);
    }
  }, {
    key: "duration",
    value: function duration() {
      var e = this;
      return 0 <= e._ticks ? new Smart.Utilities.TimeSpan(e._ticks) : new Smart.Utilities.TimeSpan(-e._ticks);
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return this._ticks === e._ticks;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      return this._ticks;
    }
  }, {
    key: "compare",
    value: function compare(e, t) {
      return e._ticks > t._ticks ? 1 : e._ticks < t._ticks ? -1 : 0;
    }
  }, {
    key: "interval",
    value: function interval(e, t) {
      var i = e * t + (0 <= e ? .5 : -.5);
      return new Smart.Utilities.TimeSpan(i * this.ticksPerMillisecond);
    }
  }, {
    key: "fromDays",
    value: function fromDays(e) {
      var t = this;
      return t.interval(e, t.millisPerDay);
    }
  }, {
    key: "fromHours",
    value: function fromHours(e) {
      var t = this;
      return t.interval(e, t.millisPerHour);
    }
  }, {
    key: "fromMilliseconds",
    value: function fromMilliseconds(e) {
      return this.interval(e, 1);
    }
  }, {
    key: "fromMinutes",
    value: function fromMinutes(e) {
      var t = this;
      return t.interval(e, t.millisPerMinute);
    }
  }, {
    key: "fromSeconds",
    value: function fromSeconds(e) {
      var t = this;
      return t.interval(e, t.millisPerSecond);
    }
  }, {
    key: "fromTicks",
    value: function fromTicks(e) {
      return new Smart.Utilities.TimeSpan(e);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.totalMilliseconds().toString();
    }
  }, {
    key: "negate",
    value: function negate() {
      return new Smart.Utilities.TimeSpan(-this._ticks);
    }
  }]);

  return _class5;
}()), Smart.Utilities.Assign("DateTime",
/*#__PURE__*/
function () {
  "use strict";

  function _class6() {
    _classCallCheck(this, _class6);

    function e(e) {
      var a = t.regexISOString.exec(e);
      i = new Smart.Utilities.DateTime(parseFloat(a[1]), parseFloat(a[2]), parseFloat(a[3]), parseFloat(a[4]), parseFloat(a[5]), parseFloat(a[6]), parseFloat(a[7]), 0, 0, 0, 0, 0, 0, 0, "UTC");
    }

    var t = this;
    var i;

    if (t.ticksPerMillisecond = 1e4, t.millisecondsPerTick = 1 / 1e4, t.ticksPerSecond = 10000000, t.secondsPerTick = 1 / 10000000, t.ticksPerMinute = 600000000, t.minutesPerTick = 1 / 600000000, t.ticksPerHour = 36000000000, t.hoursPerTick = 1 / 36000000000, t.ticksPerDay = 864000000000, t.daysPerTick = 1 / 864000000000, t.millisPerSecond = 1e3, t.millisPerMinute = 60000, t.millisPerHour = 3600000, t.millisPerDay = 86400000, t.daysPerYear = 365, t.daysPer4Years = __daysPer4Years, t.daysPer100Years = __daysPer100Years, t.daysPer400Years = __daysPer400Years, t.daysTo1601 = __daysTo1601, t.daysTo1899 = __daysTo1899, t.daysTo10000 = __daysTo10000, t.minTicks = 0, t.maxTicks = __maxTicks, t.maxMillis = __maxMillis, t.datePartYear = 0, t.datePartDayOfYear = 1, t.datePartMonth = 2, t.datePartDay = 3, t.daysToMonth365 = __daysToMonth365, t.daysToMonth366 = __daysToMonth366, t.minValue = new Date(0), t.maxValue = new Date(3155378976000000000), t.ticksMask = 0x3FFFFFFFFFFFFFFF, t.flagsMask = 0xC000000000000000, t.localMask = 0x8000000000000000, t.ticksCeiling = 0x4000000000000000, t.kindUnspecified = 0, t.kindUtc = 0x4000000000000000, t.kindLocal = 0x8000000000000000, t.kindLocalAmbiguousDst = 0xC000000000000000, t.kindShift = 62, t.regexTrim = /^\s+|\s+$/g, t.regexInfinity = /^[+-]?infinity$/i, t.regexHex = /^0x[a-f0-9]+$/i, t.regexParseFloat = /^[+-]?\d*\.?\d*(e[+-]?\d+)?$/, t.regexISOString = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).(\d{3})Z$/, t.calendar = {
      "/": "/",
      ":": ":",
      firstDay: 0,
      days: {
        names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
      },
      months: {
        names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""],
        namesAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", ""]
      },
      AM: ["AM", "am", "AM"],
      PM: ["PM", "pm", "PM"],
      eras: [{
        name: "A.D.",
        start: null,
        offset: 0
      }],
      twoDigitYearMax: 2029,
      patterns: {
        d: "M/d/yyyy",
        D: "dddd, MMMM dd, yyyy",
        t: "h:mm tt",
        T: "h:mm:ss tt",
        f: "dddd, MMMM dd, yyyy h:mm tt",
        F: "dddd, MMMM dd, yyyy h:mm:ss tt",
        M: "MMMM dd",
        Y: "yyyy MMMM",
        S: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
        ISO: "yyyy-MM-dd hh:mm:ss",
        ISO2: "yyyy-MM-dd HH:mm:ss",
        d1: "dd.MM.yyyy",
        d2: "dd-MM-yyyy",
        zone1: "yyyy-MM-ddTHH:mm:ss-HH:mm",
        zone2: "yyyy-MM-ddTHH:mm:ss+HH:mm",
        custom: "yyyy-MM-ddTHH:mm:ss.fff",
        custom2: "yyyy-MM-dd HH:mm:ss.fff",
        FP: "yyyy-MM-dd HH:mm:ss:fff:uu:nn:pp:ee:aa:xx:oo",
        FPA: "yyyy/MM/dd HH:mm:ss:fffuunnppeeaaxxoo",
        FPA2: "yyyy-MM-dd HH:mm:ss:fffuunnppeeaaxxoo",
        FT: "HH:mm:ss:fff:uu:nn:pp:ee:aa:xx:oo",
        PP: "yyyy-MM-dd HH:mm:ss:fff:uu:nn:pp",
        PT: "HH:mm:ss:fff:uu:nn:pp"
      },
      percentsymbol: "%",
      currencysymbol: "$",
      currencysymbolposition: "before",
      decimalseparator: ".",
      thousandsseparator: ","
    }, t.dateData = 0, t.timeZone = null, t.timeZones = __timeZones, t._codeToUnit = {
      u: "_microsecond",
      uu: "_microsecond",
      n: "_nanosecond",
      nn: "_nanosecond",
      p: "_picosecond",
      pp: "_picosecond",
      e: "_femtosecond",
      ee: "_femtosecond",
      a: "_attosecond",
      aa: "_attosecond",
      x: "_zeptosecond",
      xx: "_zeptosecond",
      o: "_yoctosecond",
      oo: "_yoctosecond"
    }, t._smallUnits = ["_microsecond", "_nanosecond", "_picosecond", "_femtosecond", "_attosecond", "_zeptosecond", "_yoctosecond"], t._microsecond = 0, t._nanosecond = 0, t._picosecond = 0, t._femtosecond = 0, t._attosecond = 0, t._zeptosecond = 0, t._yoctosecond = 0, 0 === arguments.length) {
      var _e147 = new Date();

      t.dateData = t.dateToMS(_e147.getFullYear(), _e147.getMonth() + 1, _e147.getDate()) + t.timeToMS(_e147.getHours(), _e147.getMinutes(), _e147.getSeconds(), _e147.getMilliseconds());
    } else if (1 === arguments.length) {
      void 0 === arguments[0] && (arguments[0] = "todayDate");

      var _i134 = "number" == typeof arguments[0] && isFinite(arguments[0]);

      if (!_i134 && "string" == typeof arguments[0]) {
        var _i135;

        "today" === arguments[0] ? _i135 = new Date() : "todayDate" === arguments[0] ? (_i135 = new Date(), _i135.setHours(0, 0, 0, 0)) : t.regexISOString.test(arguments[0]) ? e(arguments[0]) : _i135 = t.tryparseDate(arguments[0]), _i135 && (t.dateData = t.dateToMS(_i135.getFullYear(), _i135.getMonth() + 1, _i135.getDate()) + t.timeToMS(_i135.getHours(), _i135.getMinutes(), _i135.getSeconds(), _i135.getMilliseconds()));
      } else if ("number" == typeof arguments[0]) t.dateData = arguments[0];else if (arguments[0] instanceof Date) {
        var _e148 = arguments[0];
        t.dateData = t.dateToMS(_e148.getFullYear(), _e148.getMonth() + 1, _e148.getDate()) + t.timeToMS(_e148.getHours(), _e148.getMinutes(), _e148.getSeconds(), _e148.getMilliseconds());
      } else t.dateData = arguments[0];
    } else if (2 === arguments.length) {
      void 0 === arguments[0] && (arguments[0] = "todayDate");

      var _i136 = "number" == typeof arguments[0] && isFinite(arguments[0]);

      if (!_i136 && "string" == typeof arguments[0]) {
        var _i137;

        "today" === arguments[0] ? _i137 = new Date() : "todayDate" === arguments[0] ? (_i137 = new Date(), _i137.setHours(0, 0, 0, 0)) : t.regexISOString.test(arguments[0]) ? e(arguments[0]) : _i137 = t.tryparseDate(arguments[0]), _i137 && (t.dateData = t.dateToMS(_i137.getFullYear(), _i137.getMonth() + 1, _i137.getDate()) + t.timeToMS(_i137.getHours(), _i137.getMinutes(), _i137.getSeconds(), _i137.getMilliseconds()));
      } else if ("number" == typeof arguments[0]) t.dateData = arguments[0];else if (arguments[0] instanceof Date) {
        var _e149 = arguments[0];
        t.dateData = t.dateToMS(_e149.getFullYear(), _e149.getMonth() + 1, _e149.getDate()) + t.timeToMS(_e149.getHours(), _e149.getMinutes(), _e149.getSeconds(), _e149.getMilliseconds());
      } else t.dateData = arguments[0];

      t.validateTimeZone(arguments[1]);
    } else if (2 < arguments.length) if ("string" == typeof arguments[0]) {
      var _e150 = t.tryparseDate(arguments[0], arguments[2], arguments[1]);

      t.dateData = t.dateToMS(_e150.getFullYear(), _e150.getMonth() + 1, _e150.getDate()) + t.timeToMS(_e150.getHours(), _e150.getMinutes(), _e150.getSeconds(), _e150.getMilliseconds());
    } else {
      var _e151 = arguments[0],
          _i138 = arguments[1] - 1,
          a = arguments[2],
          n = arguments[3] || 0,
          o = arguments[4] || 0,
          r = arguments[5] || 0,
          l = arguments[6] || 0,
          s = arguments[7] || 0,
          d = arguments[8] || 0,
          c = arguments[9] || 0,
          m = arguments[10] || 0,
          u = arguments[11] || 0,
          p = arguments[12] || 0,
          g = arguments[13] || 0,
          h = new Date(_e151, _i138, a, n, o, r, l);

      1970 > _e151 && h.setFullYear(_e151), t.dateData = t.dateToMS(h.getFullYear(), h.getMonth() + 1, h.getDate()) + t.timeToMS(h.getHours(), h.getMinutes(), h.getSeconds(), h.getMilliseconds()), t._microsecond = s, t._nanosecond = d, t._picosecond = c, t._femtosecond = m, t._attosecond = u, t._zeptosecond = p, t._yoctosecond = g, arguments[14] && t.validateTimeZone(arguments[14]);
    }

    if (t.timeZone || t.validateTimeZone("Local"), i) {
      var _e152 = i.toTimeZone(t.timeZone);

      t.dateData = _e152.dateData;
    }
  }

  _createClass(_class6, [{
    key: "internalMS",
    value: function internalMS() {
      return this.dateData;
    }
  }, {
    key: "getDatePart",
    value: function getDatePart(e) {
      var t = this,
          i = t.internalMS();
      var a = parseInt(i / t.millisPerDay);
      var o = parseInt(a / t.daysPer400Years);
      a -= o * t.daysPer400Years;
      var r = parseInt(a / t.daysPer100Years);
      4 === r && (r = 3), a -= r * t.daysPer100Years;
      var l = parseInt(a / t.daysPer4Years);
      a -= l * t.daysPer4Years;
      var s = parseInt(a / t.daysPerYear);
      if (4 === s && (s = 3), e === t.datePartYear) return parseInt(400 * o + 100 * r + 4 * l + s + 1);
      if (a -= s * t.daysPerYear, e === t.datePartDayOfYear) return parseInt(a + 1);
      var d = 3 === s && (24 !== l || 3 === r),
          c = d ? t.daysToMonth366 : t.daysToMonth365;
      var u = a >> 6;

      for (; a >= c[u];) {
        u++;
      }

      return e === t.datePartMonth ? parseInt(u) : parseInt(a - c[u - 1] + 1);
    }
  }, {
    key: "dayOfWeek",
    value: function dayOfWeek() {
      var e = this,
          t = e.dateData,
          i = parseInt(t / e.millisPerDay + 1) % 7;
      return i;
    }
  }, {
    key: "dayOfYear",
    value: function dayOfYear() {
      var e = this;
      return e.getDatePart(e.datePartDayOfYear);
    }
  }, {
    key: "weekOfYear",
    value: function weekOfYear(e) {
      var t = Math.floor;
      var i = this,
          a = i.toDate(),
          n = e || i.calendar.firstDay,
          o = new Date(a.getFullYear(), 0, 1),
          r = t((a.getTime() - o.getTime() - 6e4 * (a.getTimezoneOffset() - o.getTimezoneOffset())) / 864e5) + 1;
      var l = o.getDay() - n;
      l = 0 <= l ? l : l + 7;
      var s;
      if (!(4 > l)) s = t((r + l - 1) / 7);else if (s = t((r + l - 1) / 7) + 1, 52 < s) {
        var _e153 = new Date(a.getFullYear() + 1, 0, 1);

        var _t141 = _e153.getDay() - n;

        _t141 = 0 <= _t141 ? _t141 : _t141 + 7, s = 4 > _t141 ? 1 : 53;
      }
      return s;
    }
  }, {
    key: "subtract",
    value: function subtract(e) {
      var t = this;
      return new Smart.Utilities.TimeSpan(t.dateData * t.ticksPerMillisecond - e.dateData * t.ticksPerMillisecond);
    }
  }, {
    key: "dateToMS",
    value: function dateToMS(e, t, i) {
      var a = this;

      if (1 <= e && 9999 >= e && 1 <= t && 12 >= t) {
        e = parseInt(e);
        var o = a.isLeapYear(e) ? a.daysToMonth366 : a.daysToMonth365;

        if (1 <= i && i <= o[t] - o[t - 1]) {
          var r = e - 1,
              l = 365 * r + parseInt(r / 4) - parseInt(r / 100) + parseInt(r / 400) + o[t - 1] + i - 1;
          return l * a.millisPerDay;
        }
      }
    }
  }, {
    key: "isLeapYear",
    value: function isLeapYear(e) {
      if (1 > e || 9999 < e) throw new Error("Year out of Range");
      return 0 == e % 4 && (0 != e % 100 || 0 == e % 400);
    }
  }, {
    key: "timeToMS",
    value: function timeToMS(e, t, i, a) {
      var n = this;

      if (0 <= e && 24 > e && 0 <= t && 60 > t && 0 <= i && 60 > i) {
        var o = parseInt(3600 * e + 60 * t + i);
        return 0 < a && 1e3 > a ? o * n.millisPerSecond + a : o * n.millisPerSecond;
      }
    }
  }, {
    key: "daysInMonth",
    value: function daysInMonth(e, t) {
      if (1 > t || 12 < t) throw new Error("Month out of Range");
      var i = this,
          a = i.isLeapYear(e) ? i.daysToMonth366 : i.daysToMonth365;
      return a[t] - a[t - 1];
    }
  }, {
    key: "arrayIndexOf",
    value: function arrayIndexOf(e, t) {
      return e.indexOf(t);
    }
  }, {
    key: "startsWith",
    value: function startsWith(e, t) {
      return 0 === e.indexOf(t);
    }
  }, {
    key: "endsWith",
    value: function endsWith(e, t) {
      return e.substr(e.length - t.length) === t;
    }
  }, {
    key: "trim",
    value: function trim(e) {
      return (e + "").replace(this.regexTrim, "");
    }
  }, {
    key: "expandFormat",
    value: function expandFormat(e, t) {
      t = t || "F";
      var i = e.patterns,
          a = t.length,
          n;
      if (i[t]) return i[t];

      if (1 === a) {
        if (n = i[t], !n) throw "Invalid date format string '" + t + "'.";
        t = n;
      } else 2 === a && "%" === t.charAt(0) && (t = t.charAt(1));

      return t;
    }
  }, {
    key: "getEra",
    value: function getEra(e, t) {
      if (!t) return 0;
      if ("string" == typeof e) return 0;
      var a = e.getTime(),
          n;

      for (var o = 0, _i139 = t.length; o < _i139; o++) {
        if (n = t[o].start, null === n || a >= n) return o;
      }

      return 0;
    }
  }, {
    key: "toUpper",
    value: function toUpper(e) {
      return e.split("\xA0").join(" ").toUpperCase();
    }
  }, {
    key: "toUpperArray",
    value: function toUpperArray(e) {
      var t = [];

      for (var a = 0, _i140 = e.length; a < _i140; a++) {
        t[a] = this.toUpper(e[a]);
      }

      return t;
    }
  }, {
    key: "getEraYear",
    value: function getEraYear(e, t, i, a) {
      var n = e.getFullYear();
      return !a && t.eras && (n -= t.eras[i].offset), n;
    }
  }, {
    key: "getDayIndex",
    value: function getDayIndex(e, t, i) {
      var a = this,
          n = e.days;
      var o = e._upperDays,
          r;
      return o || (e._upperDays = o = [a.toUpperArray(n.names), a.toUpperArray(n.namesAbbr), a.toUpperArray(n.namesShort)]), t = t.toUpperCase(), i ? (r = a.arrayIndexOf(o[1], t), -1 === r && (r = a.arrayIndexOf(o[2], t))) : r = a.arrayIndexOf(o[0], t), r;
    }
  }, {
    key: "getMonthIndex",
    value: function getMonthIndex(e, t, a) {
      var n = this;
      var o = e.months,
          r = e.monthsGenitive || e.months,
          l = e._upperMonths,
          s = e._upperMonthsGen;
      l || (e._upperMonths = l = [n.toUpperArray(o.names), n.toUpperArray(o.namesAbbr)], e._upperMonthsGen = s = [n.toUpperArray(r.names), n.toUpperArray(r.namesAbbr)]), t = n.toUpper(t);
      var d = n.arrayIndexOf(a ? l[1] : l[0], t);
      return 0 > d && (d = n.arrayIndexOf(a ? s[1] : s[0], t)), d;
    }
  }, {
    key: "appendPreOrPostMatch",
    value: function appendPreOrPostMatch(e, t) {
      var i = 0,
          a = !1;

      for (var n = 0, o = e.length; n < o; n++) {
        var _o51 = e.charAt(n);

        switch (_o51) {
          case "'":
            a ? t.push("'") : i++, a = !1;
            break;

          case "\\":
            a && t.push("\\"), a = !a;
            break;

          default:
            t.push(_o51), a = !1;
        }
      }

      return i;
    }
  }, {
    key: "getTokenRegExp",
    value: function getTokenRegExp() {
      return /\/|dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyyy|yyyy|yy|y|hh|h|HH|H|mm|m|ss|s|tt|t|fff|ff|f|uu|u|nn|n|pp|p|ee|e|aa|a|xx|x|oo|o|i{1,24}|zzz|zz|z|gg|g/g;
    }
  }, {
    key: "tryparseDate",
    value: function tryparseDate(e, t, a) {
      var n = this;

      if ((void 0 === t || null === t) && (t = n.calendar), void 0 !== a) {
        if (Array.isArray(a)) for (var _o52 = 0; _o52 < a.length; _o52++) {
          var _i142 = n.parseDate(e, a[_o52], t);

          if (_i142) return _i142;
        }

        var _i141 = n.parseDate(e, a, t);

        if (_i141) return _i141;
      }

      if ("" === e) return null;

      if (null === e || void 0 === e || e.substring || (e = e.toString()), null !== e && void 0 !== e && "/Date(" === e.substring(0, 6)) {
        var _t142 = /^\/Date\((-?\d+)(\+|-)?(\d+)?\)\/$/;

        var _i143 = new Date(+e.replace(/\/Date\((\d+)\)\//, "$1"));

        if ("Invalid Date" === _i143) {
          var _t143 = e.match(/^\/Date\((\d+)([-+]\d\d)(\d\d)\)\/$/);

          _i143 = null, _t143 && (_i143 = new Date(1 * _t143[1] + 36e5 * _t143[2] + 6e4 * _t143[3]));
        }

        if (null === _i143 || void 0 === _i143 || "Invalid Date" === _i143 || isNaN(_i143)) {
          var _i144 = _t142.exec(e);

          if (_i144) {
            var _e154 = new Date(parseInt(_i144[1]));

            if (_i144[2]) {
              var _t144 = parseInt(_i144[3]);

              "-" === _i144[2] && (_t144 = -_t144);

              var _a88 = _e154.getUTCMinutes();

              _e154.setUTCMinutes(_a88 - _t144);
            }

            if (!isNaN(_e154.valueOf())) return _e154;
          }
        }

        return _i143;
      }

      var i = {
        smartdate: "yyyy-MM-dd HH:mm:ss",
        d: "M/d/yyyy",
        D: "dddd, MMMM dd, yyyy",
        t: "h:mm tt",
        T: "h:mm:ss tt",
        f: "dddd, MMMM dd, yyyy h:mm tt",
        F: "dddd, MMMM dd, yyyy h:mm:ss tt",
        M: "MMMM dd",
        Y: "yyyy MMMM",
        S: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
        ISO: "yyyy-MM-dd hh:mm:ss",
        ISO2: "yyyy-MM-dd HH:mm:ss",
        ISO8601: "yyyy-MM-ddTHH:mm:ss.sssZ",
        d1: "dd.MM.yyyy",
        d2: "dd-MM-yyyy",
        d3: "MM-dd-yyyy",
        d4: "MM.dd.yyyy",
        zone1: "yyyy-MM-ddTHH:mm:ss-HH:mm",
        zone2: "yyyy-MM-ddTHH:mm:ss+HH:mm",
        custom: "yyyy-MM-ddTHH:mm:ss.fff",
        custom2: "yyyy-MM-dd HH:mm:ss.fff",
        iso: "yyyy-MM-ddTHH:mm:ssZ",
        iso_date1: "yyyy-MM-dd",
        iso_date2: "yyyy-MM-dd",
        iso_date3: "yyyy-ddd",
        iso_date4: "yyyy-MM-dd HH:mm",
        iso_date5: "yyyy-MM-dd HH:mm Z",
        iso_date6: "yyyy-MMM-dd",
        iso_date7: "yyyy-MM",
        iso_date8: "yyyy-MMM",
        iso_date9: "yyyy-MMMM",
        iso_date10: "yyyy-MMMM-dd",
        iso_time1: "HH:mm:ss.tttt",
        iso_time2: "HH:mm:ss",
        iso_time3: "HH:mm",
        iso_time4: "HH",
        iso_time5: "yyyyyy-MM-dd",
        iso_time6: "yyyyyy-MM-dd"
      };

      for (var _o53 in i) {
        var _a89 = n.parseDate(e, i[_o53], t);

        if (_a89) return _a89;
      }

      var o = t.patterns;

      for (var _i145 in o) {
        var _a90 = n.parseDate(e, o[_i145], t);

        if (_a90) {
          if ("ISO" == _i145) {
            var _i146 = n.parseDate(e, o.ISO2, t);

            if (_i146) return _i146;
          }

          return _a90;
        }
      }

      var r;

      if ("string" == typeof e) {
        e = n.trim(e);
        var _a91 = [":", "/", "-", " ", ","];

        e = function (e, t, i) {
          return i.replace(new RegExp(e, "g"), t);
        }(", ", ",", e);

        var _i147 = "",
            _o54 = e;
        0 <= e.indexOf(":") ? (_i147 = e.substring(e.indexOf(":") - 2), _i147 = n.trim(_i147), _o54 = e.substring(0, e.indexOf(":") - 2)) : 0 <= e.toUpperCase().indexOf("AM") ? (_i147 = e.substring(e.toUpperCase().indexOf("AM") - 2), _i147 = n.trim(_i147), _o54 = e.substring(0, e.toUpperCase().indexOf("AM") - 2)) : 0 <= e.toUpperCase().indexOf("PM") && (_i147 = e.substring(e.toUpperCase().indexOf("PM") - 2), _i147 = n.trim(_i147), _o54 = e.substring(0, e.toUpperCase().indexOf("PM") - 2));
        var l = new Date(),
            s = !1;

        if (_o54) {
          for (var _e156 = 0; _e156 < _a91.length; _e156++) {
            if (0 <= _o54.indexOf(_a91[_e156])) {
              r = _o54.split(_a91[_e156]);
              break;
            }
          }

          if (!r) return null;
          var _e155 = [],
              c = [],
              u = [],
              d = null,
              m = null;

          for (var _a92 = 0; _a92 < r.length; _a92++) {
            var _i149 = r[_a92],
                _o55 = n.parseDate(_i149, "d", t) || n.parseDate(_i149, "dd", t) || n.parseDate(_i149, "ddd", t) || n.parseDate(_i149, "dddd", t);

            if (_o55 && (_e155.push(_o55.getDate()), 2 < _i149.length)) {
              d = _a92;
              break;
            }
          }

          for (var _e157 = 0; _e157 < r.length; _e157++) {
            var _i150 = r[_e157],
                _a93 = n.parseDate(_i150, "M", t) || n.parseDate(_i150, "MM", t) || n.parseDate(_i150, "MMM", t) || n.parseDate(_i150, "MMMM", t);

            if (_a93) {
              if (null !== d && void 0 !== d && d === _e157) continue;

              if (c.push(_a93.getMonth()), 2 < _i150.length) {
                m = _e157;
                break;
              }
            }
          }

          for (var _e158 = 0; _e158 < r.length; _e158++) {
            var _i151 = r[_e158],
                _a94 = n.parseDate(_i151, "yyyy", t);

            if (_a94) {
              if (null !== d && void 0 !== d && d === _e158) continue;
              if (null !== m && void 0 !== m && m === _e158) continue;
              u.push(_a94.getFullYear());
            }
          }

          var _i148 = [];

          for (var _t145 = _e155.length - 1; 0 <= _t145; _t145--) {
            for (var _a95 = 0; _a95 < c.length; _a95++) {
              for (var _n70 = 0; _n70 < u.length; _n70++) {
                var _o56 = new Date(u[_n70], c[_a95], _e155[_t145]);

                1970 > u[_n70] && _o56.setFullYear(u[_n70]), isNaN(_o56.getTime()) || _i148.push(_o56);
              }
            }
          }

          0 < _i148.length && (l = _i148[0], s = !0);
        }

        if (_i147) {
          var _e159 = 0 <= _i147.indexOf(":") ? _i147.split(":") : _i147,
              _a96 = n.parseDate(_i147, "h:mm tt", t) || n.parseDate(_i147, "HH:mm:ss.fff", t) || n.parseDate(_i147, "HH:mm:ss.ff", t) || n.parseDate(_i147, "h:mm:ss tt", t) || n.parseDate(_i147, "HH:mm:ss.tttt", t) || n.parseDate(_i147, "HH:mm:ss", t) || n.parseDate(_i147, "HH:mm", t) || n.parseDate(_i147, "HH", t);

          var _o57 = 0,
              _r27 = 0,
              _d10 = 0,
              _c5 = 0;
          _a96 && !isNaN(_a96.getTime()) ? (_o57 = _a96.getHours(), _r27 = _a96.getMinutes(), _d10 = _a96.getSeconds(), _c5 = _a96.getMilliseconds()) : (1 === _e159.length && (_o57 = parseInt(_e159[0])), 2 === _e159.length && (_o57 = parseInt(_e159[0]), _r27 = parseInt(_e159[1])), 3 === _e159.length && (_o57 = parseInt(_e159[0]), _r27 = parseInt(_e159[1]), 0 <= _e159[2].indexOf(".") ? (_d10 = parseInt(_e159[2].toString().split(".")[0]), _c5 = parseInt(_e159[2].toString().split(".")[1])) : _d10 = parseInt(_e159[2])), 4 === _e159.length && (_o57 = parseInt(_e159[0]), _r27 = parseInt(_e159[1]), _d10 = parseInt(_e159[2]), _c5 = parseInt(_e159[3]))), !l || isNaN(_o57) || isNaN(_r27) || isNaN(_d10) || isNaN(_c5) || (l.setHours(_o57, _r27, _d10, _c5), s = !0);
        }

        if (s) return l;
      }

      if (null !== e && void 0 !== e) {
        r = [":", "/", "-"];

        var _t146 = !0;

        for (var _i152 = 0; _i152 < r.length; _i152++) {
          -1 !== e.indexOf(r[_i152]) && (_t146 = !1);
        }

        if (_t146) {
          var _t147 = new Number(e);

          if (!isNaN(_t147)) return new Date(_t147);
        }
      }

      return null;
    }
  }, {
    key: "getParseRegExp",
    value: function getParseRegExp(e, t) {
      var i = this;
      var a = e._parseRegExp;
      if (!a) e._parseRegExp = a = {};else {
        var _e160 = a[t];
        if (_e160) return _e160;
      }
      var n = i.expandFormat(e, t).replace(/([\^\$\.\*\+\?\|\[\]\(\)\{\}])/g, "\\\\$1"),
          o = ["^"],
          r = [],
          l = 0,
          s = 0,
          d = i.getTokenRegExp(),
          c;

      for (; null !== (c = d.exec(n));) {
        var _e161 = n.slice(l, c.index);

        if (l = d.lastIndex, s += i.appendPreOrPostMatch(_e161, o), s % 2) {
          o.push(c[0]);
          continue;
        }

        var _t148 = c[0],
            _a97 = _t148.length,
            _m5 = void 0;

        switch (_t148) {
          case "dddd":
          case "ddd":
          case "MMMM":
          case "MMM":
          case "gg":
          case "g":
            _m5 = "(\\D+)";
            break;

          case "tt":
          case "t":
            _m5 = "(\\D*)";
            break;

          case "yyyyy":
            _m5 = "(\\d{1,4})";
            break;

          case "yyyy":
            _m5 = "(\\d{" + _a97 + "})";
            break;

          case "fff":
          case "ff":
          case "f":
            _m5 = "(\\d{1," + _a97 + "})";
            break;

          case "dd":
          case "d":
          case "MM":
          case "M":
          case "yy":
          case "y":
          case "HH":
          case "H":
          case "hh":
          case "h":
          case "mm":
          case "m":
          case "ss":
          case "s":
            _m5 = "(\\d\\d?)";
            break;

          case "uu":
          case "nn":
          case "pp":
          case "ee":
          case "aa":
          case "xx":
          case "oo":
            _m5 = "(\\d{1,3})";
            break;

          case "zzz":
            _m5 = "([+-]?\\d\\d?:\\d{2})";
            break;

          case "zz":
          case "z":
            _m5 = "([+-]?\\d\\d?)";
            break;

          case "/":
            _m5 = "/";
            break;

          default:
            if (/i{1,24}/.test(_t148)) _m5 = "(\\d{" + _t148.length + "})";else throw "Invalid date format pattern '" + _t148 + "'.";
        }

        (_m5 && o.push(_m5), "/" !== _t148) && r.push(c[0]);
      }

      i.appendPreOrPostMatch(n.slice(l), o), o.push("$");
      var m = o.join("").replace(/\s+/g, "\\s+");
      return a[t] = {
        regExp: m,
        groups: r
      };
    }
  }, {
    key: "outOfRange",
    value: function outOfRange(e, t, i) {
      return e < t || e > i;
    }
  }, {
    key: "expandYear",
    value: function expandYear(e, t) {
      var i = this,
          a = new Date(),
          n = i.getEra(a);

      if (100 > t) {
        var o = e.twoDigitYearMax;
        o = "string" == typeof o ? new Date().getFullYear() % 100 + parseInt(o, 10) : o;
        var r = i.getEraYear(a, e, n);
        t += r - r % 100, t > o && (t -= 100);
      }

      return t;
    }
  }, {
    key: "padZeros",
    value: function padZeros(e, t) {
      var i = e + "",
          a;
      return 1 < t && i.length < t ? (a = ["0", "00", "000"][t - 2] + i, a.substr(a.length - t, t)) : (a = i, a);
    }
  }, {
    key: "parseDate",
    value: function parseDate(e, t, i) {
      var a = this;
      (void 0 === i || null === i) && (i = a.calendar), e = a.trim(e);
      var n = i,
          o = a.getParseRegExp(n, t),
          r = new RegExp(o.regExp).exec(e);
      if (null === r) return null;
      var l = o.groups,
          s = null,
          d = null,
          c = null,
          m = null,
          u = null,
          p = 0,
          g = 0,
          h = 0,
          _ = 0,
          f = null,
          b = !1,
          y;

      for (var _o58 = 0, _v = l.length; _o58 < _v; _o58++) {
        var _e162 = r[_o58 + 1];

        if (_e162) {
          var _t149 = l[_o58],
              _i153 = _t149.length,
              _r28 = parseInt(_e162, 10);

          switch (_t149) {
            case "dd":
            case "d":
              if (m = _r28, a.outOfRange(m, 1, 31)) return null;
              break;

            case "MMM":
            case "MMMM":
            case "MMMMM":
            case "MMMMMM":
            case "MMMMMMM":
            case "MMMMMMMM":
              if (c = a.getMonthIndex(n, _e162, 3 === _i153), a.outOfRange(c, 0, 11)) return null;
              break;

            case "M":
            case "MM":
              if (c = _r28 - 1, a.outOfRange(c, 0, 11)) return null;
              break;

            case "y":
            case "yy":
            case "yyyy":
              if (d = 4 > _i153 ? a.expandYear(n, _r28) : _r28, a.outOfRange(d, 0, 9999)) return null;
              break;

            case "h":
            case "hh":
              if (p = _r28, 12 === p && (p = 0), a.outOfRange(p, 0, 11)) return null;
              break;

            case "H":
            case "HH":
              if (p = _r28, a.outOfRange(p, 0, 23)) return null;
              break;

            case "m":
            case "mm":
              if (g = _r28, a.outOfRange(g, 0, 59)) return null;
              break;

            case "s":
            case "ss":
              if (h = _r28, a.outOfRange(h, 0, 59)) return null;
              break;

            case "tt":
            case "t":
              if (b = n.PM && (_e162 === n.PM[0] || _e162 === n.PM[1] || _e162 === n.PM[2]), !b && (!n.AM || _e162 !== n.AM[0] && _e162 !== n.AM[1] && _e162 !== n.AM[2])) return null;
              break;

            case "f":
            case "ff":
            case "fff":
              if (_ = _r28 * Math.pow(10, 3 - _i153), a.outOfRange(_, 0, 999)) return null;
              break;

            case "uu":
            case "nn":
            case "pp":
            case "ee":
            case "aa":
            case "xx":
            case "oo":
              if (a.outOfRange(_r28, 0, 1e3)) return null;
              a[a._codeToUnit[_t149]] = _r28;
              break;

            case "ddd":
            case "dddd":
              if (u = a.getDayIndex(n, _e162, 3 === _i153), a.outOfRange(u, 0, 6)) return null;
              break;

            case "zzz":
              {
                var _t150 = _e162.split(/:/);

                if (2 !== _t150.length) return null;
                if (y = parseInt(_t150[0], 10), a.outOfRange(y, -12, 13)) return null;

                var _i154 = parseInt(_t150[1], 10);

                if (a.outOfRange(_i154, 0, 59)) return null;
                f = 60 * y + (a.startsWith(_e162, "-") ? -_i154 : _i154);
                break;
              }

            case "z":
            case "zz":
              if (y = _r28, a.outOfRange(y, -12, 13)) return null;
              f = 60 * y;
              break;

            case "g":
            case "gg":
              {
                var _t151 = _e162;
                if (!_t151 || !n.eras) return null;
                _t151 = this.trim(_t151.toLowerCase());

                for (var _e163 = 0, _i155 = n.eras.length; _e163 < _i155; _e163++) {
                  if (_t151 === n.eras[_e163].nathat.toLowerCase()) {
                    s = _e163;
                    break;
                  }
                }

                if (null === s) return null;
                break;
              }

            default:
              {
                var _t152 = _e162;
                1 == _t152.length % 3 ? _t152 += "00" : 2 == _t152.length % 3 && (_t152 += "0"), _ = parseInt(_t152.slice(0, 3), 10), _t152 = _t152.slice(3);

                for (var _e164 = 0; 0 < _t152.length;) {
                  a[a._smallUnits[_e164]] = parseInt(_t152.slice(0, 3), 10), _t152 = _t152.slice(3), _e164++;
                }
              }
          }
        }
      }

      var v = new Date(),
          w = n.convert,
          C;

      if (C = v.getFullYear(), null === d ? d = C : n.eras && (d += n.eras[s || 0].offset), null === c && (c = 0), null === m && (m = 1), !w) {
        if (v.setFullYear(d, c, m), v.getDate() !== m) return null;
        if (null !== u && v.getDay() !== u) return null;
      } else if (v = w.toGregorian(d, c, m), null === v) return null;

      if (b && 12 > p && (p += 12), v.setHours(p, g, h, _), null !== f) {
        var _e165 = v.getMinutes() - (f + v.getTimezoneOffset());

        v.setHours(v.getHours() + parseInt(_e165 / 60, 10), _e165 % 60);
      }

      return v;
    }
  }, {
    key: "toString",
    value: function toString(e, t) {
      function i(e, t) {
        if (g) return g[t];
        if (void 0 !== e.getMonth) switch (t) {
          case 0:
            return e.getFullYear();

          case 1:
            return e.getMonth();

          case 2:
            return e.getDate();
        }
      }

      var a = Math.floor,
          n = Math.abs;
      var o = this;
      void 0 === e && (e = "yyyy-MM-dd HH:mm:ss");
      var r = o.dateData.toString() + o.getFractionsOfSecondStamp() + e + (o.timeZone || "");
      if (Smart.Utilities.DateTime.cache && Smart.Utilities.DateTime.cache[r]) return Smart.Utilities.DateTime.cache[r];
      var l = o.toDate();
      if ((void 0 === t || null === t) && (t = o.calendar), "string" == typeof l) return l;

      if (!e || !e.length || "i" === e) {
        var _e166;

        return _e166 = o.formatDate(l, t.patterns.F, t), _e166;
      }

      var s = t.eras,
          d = "s" === e;
      e = o.expandFormat(t, e);
      var c = [];
      var m = 0,
          u = o.getTokenRegExp(),
          p,
          g;

      for (;;) {
        var _r29 = u.lastIndex,
            _g2 = u.exec(e),
            _h = e.slice(_r29, _g2 ? _g2.index : e.length);

        if (m += o.appendPreOrPostMatch(_h, c), !_g2) break;

        if (m % 2) {
          c.push(_g2[0]);
          continue;
        }

        var _ = _g2[0],
            f = _.length;
        var b = void 0;

        if (/i{1,24}/.test(_)) {
          c.push(o.getFirstNDigitsOfPrecision(_.length));
          continue;
        }

        switch (_) {
          case "ddd":
          case "dddd":
            {
              var _e167 = 3 === f ? t.days.namesAbbr : t.days.names;

              c.push(_e167[l.getDay()]);
              break;
            }

          case "d":
          case "dd":
            c.push(o.padZeros(i(l, 2), f));
            break;

          case "MMM":
          case "MMMM":
            b = i(l, 1), c.push(t.months[3 === f ? "namesAbbr" : "names"][b]);
            break;

          case "M":
          case "MM":
            c.push(o.padZeros(i(l, 1) + 1, f));
            break;

          case "y":
          case "yy":
          case "yyyy":
            b = o.getEraYear(l, t, o.getEra(l, s), d), 4 > f && (b %= 100), c.push(o.padZeros(b, f));
            break;

          case "h":
          case "hh":
            p = l.getHours() % 12, 0 === p && (p = 12), c.push(o.padZeros(p, f));
            break;

          case "H":
          case "HH":
            c.push(o.padZeros(l.getHours(), f));
            break;

          case "m":
          case "mm":
            c.push(o.padZeros(l.getMinutes(), f));
            break;

          case "s":
          case "ss":
            c.push(o.padZeros(l.getSeconds(), f));
            break;

          case "t":
          case "tt":
            b = 12 > l.getHours() ? t.AM ? t.AM[0] : " " : t.PM ? t.PM[0] : " ", c.push(1 === f ? b.charAt(0) : b);
            break;

          case "f":
          case "ff":
          case "fff":
            c.push(o.padZeros(l.getMilliseconds(), 3).substr(0, f));
            break;

          case "u":
          case "n":
          case "p":
          case "e":
          case "a":
          case "x":
          case "o":
            c.push(o[o._codeToUnit[_]]);
            break;

          case "uu":
          case "nn":
          case "pp":
          case "ee":
          case "aa":
          case "xx":
          case "oo":
            c.push(o.padZeros(o[o._codeToUnit[_]], 3));
            break;

          case "z":
          case "zz":
            c.push((0 <= o.timeZoneOffsetHours ? "+" : "-") + o.padZeros(a(n(o.timeZoneOffsetHours)), f));
            break;

          case "zzz":
            c.push((0 <= o.timeZoneOffsetHours ? "+" : "-") + o.padZeros(a(n(o.timeZoneOffsetHours)), 2) + ":" + o.padZeros(60 * n(o.timeZoneOffsetHours % 1), 2));
            break;

          case "g":
          case "gg":
            t.eras && c.push(t.eras[o.getEra(l, s)].name);
            break;

          case "/":
            c.push(t["/"]);
            break;

          default:
            throw "Invalid date format pattern '" + _ + "'.";
        }
      }

      var h = c.join("");
      return Smart.Utilities.DateTime.cache || (Smart.Utilities.DateTime.cache = []), Smart.Utilities.DateTime.cache[r] = h, h;
    }
  }, {
    key: "getFractionsOfSecondStamp",
    value: function getFractionsOfSecondStamp() {
      var e = this;
      return e._microsecond.toString() + e._nanosecond + e._picosecond + e._femtosecond + e._attosecond + e._zeptosecond + e._yoctosecond;
    }
  }, {
    key: "getFirstNDigitsOfPrecision",
    value: function getFirstNDigitsOfPrecision(e, t) {
      var i = this,
          a = "" + (!0 === t ? "" : i.padZeros(i.millisecond(), 3)) + i.padZeros(i._microsecond, 3) + i.padZeros(i._nanosecond, 3) + i.padZeros(i._picosecond, 3) + i.padZeros(i._femtosecond, 3) + i.padZeros(i._attosecond, 3) + i.padZeros(i._zeptosecond, 3) + i.padZeros(i._yoctosecond, 3);
      return a.slice(0, e);
    }
  }, {
    key: "copySmallTimePartValues",
    value: function copySmallTimePartValues(e) {
      var t = this;
      e._microsecond = t._microsecond, e._nanosecond = t._nanosecond, e._picosecond = t._picosecond, e._femtosecond = t._femtosecond, e._attosecond = t._attosecond, e._zeptosecond = t._zeptosecond, e._yoctosecond = t._yoctosecond;
    }
  }, {
    key: "add",
    value: function add(e, t, i) {
      var a = this,
          n = a.internalMS();

      if (void 0 === t) {
        if (!1 === i) return a.dateData = n + parseInt(e._ticks / a.ticksPerMillisecond), a;

        var _t153 = new Smart.Utilities.DateTime(n + parseInt(e._ticks / a.ticksPerMillisecond));

        return a.copyTimeZone(_t153), a.copySmallTimePartValues(_t153), _t153;
      }

      var o = e * t;
      if (o <= -a.maxMillis || o >= a.maxMillis) throw new Error("Out of Range");
      if (!1 === i) return a.dateData = n + o, a;
      var r = new Smart.Utilities.DateTime(n + o);
      return a.copyTimeZone(r), a.copySmallTimePartValues(r), r;
    }
  }, {
    key: "addDays",
    value: function addDays(e, t) {
      var i = this;
      return i.add(e, i.millisPerDay, t);
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = this,
          t = new Smart.Utilities.DateTime(e.dateData);
      return e.copyTimeZone(t), e.copySmallTimePartValues(t), t;
    }
  }, {
    key: "clearTime",
    value: function clearTime() {
      var e = this,
          t = e.month(),
          i = e.year(),
          a = e.day(),
          n = new Smart.Utilities.DateTime(i, t, a, 0, 0, 0, 0);
      return e.copyTimeZone(n), n;
    }
  }, {
    key: "addHours",
    value: function addHours(e, t) {
      var i = this;
      return i.add(e, i.millisPerHour, t);
    }
  }, {
    key: "addDeciseconds",
    value: function addDeciseconds(e, t) {
      return this.add(100 * e, 1, t);
    }
  }, {
    key: "addCentiseconds",
    value: function addCentiseconds(e, t) {
      return this.add(10 * e, 1, t);
    }
  }, {
    key: "addMilliseconds",
    value: function addMilliseconds(e, t) {
      return this.add(e, 1, t);
    }
  }, {
    key: "addMinutes",
    value: function addMinutes(e, t) {
      var i = this;
      return i.add(e, i.millisPerMinute, t);
    }
  }, {
    key: "addMonths",
    value: function addMonths(e, t) {
      var i = this;
      if (-12e4 > e || 12e4 < e) throw new Error("Invalid Months Value");
      var a = parseInt(i.getDatePart(i.datePartYear)),
          n = parseInt(i.getDatePart(i.datePartMonth)),
          o = parseInt(i.getDatePart(i.datePartDay));
      if (0 == e % 12) a += e / 12;else {
        var _t154 = n - 1 + e;

        0 <= _t154 ? (n = _t154 % 12 + 1, a += _t154 / 12) : (n = 12 + (_t154 + 1) % 12, a += (_t154 - 11) / 12), a = parseInt(a);
      }
      if (1 > a || 9999 < a) throw new Error("Year out of range");
      var r = i.daysInMonth(a, n);
      if (o > r && (o = r), !1 === t) return i.dateData = i.dateToMS(a, n, o) + i.internalMS() % i.millisPerDay, i;
      var l = new Smart.Utilities.DateTime(i.dateToMS(a, n, o) + i.internalMS() % i.millisPerDay);
      return i.copyTimeZone(l), i.copySmallTimePartValues(l), l;
    }
  }, {
    key: "addSeconds",
    value: function addSeconds(e, t) {
      var i = this;
      return i.add(e, i.millisPerSecond, t);
    }
  }, {
    key: "addYears",
    value: function addYears(e, t) {
      return this.addMonths(12 * e, t);
    }
  }, {
    key: "addMicroseconds",
    value: function addMicroseconds(e, t) {
      if (0 === e) return;
      var i = this;
      var a, n;
      0 > e && 0 === i.hour() && 0 === i.minute() && 0 === i.second() && 0 === i.millisecond() && 0 === i._microsecond && (a = parseInt(e / 1e3, 10) - 1, n = 1e3 + e % 1e3);

      var o = 1e3 * i.timeToMS(i.hour(), i.minute(), i.second(), i.millisecond()) + i._microsecond,
          r = o + e;

      void 0 == a && (a = parseInt(r / 1e3, 10) - parseInt(o / 1e3, 10)), void 0 === n && (n = parseInt(r % 1e3, 10));
      var l;
      return 0 !== a && (l = i.addMilliseconds(a, t)), !1 === t ? void (i._microsecond = n) : (l || (l = i.clone()), l._microsecond = n, l);
    }
  }, {
    key: "addFractionsOfSecond",
    value: function addFractionsOfSecond(e, t, i, a, n) {
      if (0 === e) return;
      var o = this,
          r = 1e3 * o[a] + o[i],
          l = e + r;
      var s = parseInt(l / 1e3, 10) - parseInt(r / 1e3, 10),
          d = parseInt(l % 1e3, 10),
          c;
      return 0 > e && 0 > l && 0 > d && (s--, d = 1e3 + d), 0 != s && (c = o[n](s, t)), !1 === t ? void (o[i] = d) : (c || (c = o.clone()), c[i] = d, c);
    }
  }, {
    key: "addNanoseconds",
    value: function addNanoseconds(e, t) {
      return this.addFractionsOfSecond(e, t, "_nanosecond", "_microsecond", "addMicroseconds");
    }
  }, {
    key: "addPicoseconds",
    value: function addPicoseconds(e, t) {
      return this.addFractionsOfSecond(e, t, "_picosecond", "_nanosecond", "addNanoseconds");
    }
  }, {
    key: "addFemtoseconds",
    value: function addFemtoseconds(e, t) {
      return this.addFractionsOfSecond(e, t, "_femtosecond", "_picosecond", "addPicoseconds");
    }
  }, {
    key: "addAttoseconds",
    value: function addAttoseconds(e, t) {
      return this.addFractionsOfSecond(e, t, "_attosecond", "_femtosecond", "addFemtoseconds");
    }
  }, {
    key: "addZeptoseconds",
    value: function addZeptoseconds(e, t) {
      return this.addFractionsOfSecond(e, t, "_zeptosecond", "_attosecond", "addAttoseconds");
    }
  }, {
    key: "addYoctoseconds",
    value: function addYoctoseconds(e, t) {
      return this.addFractionsOfSecond(e, t, "_yoctosecond", "_zeptosecond", "addZeptoseconds");
    }
  }, {
    key: "getTimeZoneOffset",
    value: function getTimeZoneOffset() {
      var e = new Date(),
          t = new Date(e.getFullYear(), 0, 1),
          i = new Date(e.getFullYear(), 6, 1),
          a = e.getTimezoneOffset() < Math.max(t.getTimezoneOffset(), i.getTimezoneOffset());
      return {
        offset: -(e.getTimezoneOffset() / 60),
        dst: +a
      };
    }
  }, {
    key: "isInDaylightSavingTime",
    value: function isInDaylightSavingTime() {
      var e = new Date(),
          t = new Date(e.getFullYear(), 0, 1),
          i = new Date(e.getFullYear(), 6, 1);
      return this.date().getTimezoneOffset() < Math.max(t.getTimezoneOffset(), i.getTimezoneOffset());
    }
  }, {
    key: "supportsDaylightSavingTime",
    value: function supportsDaylightSavingTime() {
      var e = new Date(),
          t = new Date(e.getFullYear(), 0, 1),
          i = new Date(e.getFullYear(), 6, 1);
      return t.getTimezoneOffset() !== i.getTimezoneOffset();
    }
  }, {
    key: "date",
    value: function date() {
      var e = this,
          t = e.month(),
          i = e.year(),
          a = e.day(),
          n = new Smart.Utilities.DateTime(i, t, a);
      return e.copyTimeZone(n), n;
    }
  }, {
    key: "isWeekend",
    value: function isWeekend() {
      var e = this;
      return 0 === e.dayOfWeek() || 6 === e.dayOfWeek();
    }
  }, {
    key: "toDate",
    value: function toDate(e) {
      var t = this,
          i = t.month(),
          a = t.year(),
          n = t.day(),
          o = t.hour(),
          r = t.minute(),
          l = t.second(),
          s = t.millisecond();
      var d = new Date(a, i - 1, n);

      if (1970 > a && d.setFullYear(a), d.setHours(o, r, l, s), e) {
        var _i156 = t.timeZones.filter(function (t) {
          return t.id === e;
        });

        if (_i156.length) {
          var _e168 = _i156[0].offset;

          var _a98 = d.getTime();

          var _n71 = 1e3 * (60 * d.getTimezoneOffset());

          if (t.timeZone) {
            var _e169 = t.timeZones.filter(function (e) {
              return e.id === t.timeZone;
            });

            _e169.length && (_n71 = 1e3 * (60 * -_e169[0].offset));
          }

          var _o59 = _a98 + _n71;

          d = new Date(_o59 + 60000 * _e168);
        }
      }

      return d;
    }
  }, {
    key: "toTimeZone",
    value: function toTimeZone(e) {
      var t = this;
      var i = e;
      if ((null === i || void 0 === i) && (i = "Local"), t.timeZone === i) return t.clone();
      var a = t.timeZones.filter(function (e) {
        return e.id === i;
      });
      if (0 === a.length) return t.clone();
      var n = this.toDate(i),
          o = new Smart.Utilities.DateTime(n);
      return o.timeZone = i, o.timeZoneOffset = a[0].offset, o.timeZoneOffsetHours = a[0].offsetHours, t.copySmallTimePartValues(o), o;
    }
  }, {
    key: "day",
    value: function day() {
      var e = this;
      return e.getDatePart(e.datePartDay);
    }
  }, {
    key: "month",
    value: function month() {
      var e = this;
      return e.getDatePart(e.datePartMonth);
    }
  }, {
    key: "year",
    value: function year() {
      var e = this;
      return e.getDatePart(e.datePartYear);
    }
  }, {
    key: "millisecond",
    value: function millisecond() {
      return parseInt(this.internalMS() % 1e3);
    }
  }, {
    key: "hour",
    value: function hour() {
      var e = this;
      return parseInt(Math.floor(e.internalMS() / e.millisPerHour) % 24);
    }
  }, {
    key: "minute",
    value: function minute() {
      var e = this;
      return parseInt(e.internalMS() / e.millisPerMinute % 60);
    }
  }, {
    key: "second",
    value: function second() {
      var e = this;
      return parseInt(e.internalMS() / e.millisPerSecond % 60);
    }
  }, {
    key: "microsecond",
    value: function microsecond() {
      return this._microsecond;
    }
  }, {
    key: "nanosecond",
    value: function nanosecond() {
      return this._nanosecond;
    }
  }, {
    key: "picosecond",
    value: function picosecond() {
      return this._picosecond;
    }
  }, {
    key: "femtosecond",
    value: function femtosecond() {
      return this._femtosecond;
    }
  }, {
    key: "attosecond",
    value: function attosecond() {
      return this._attosecond;
    }
  }, {
    key: "zeptosecond",
    value: function zeptosecond() {
      return this._zeptosecond;
    }
  }, {
    key: "yoctosecond",
    value: function yoctosecond() {
      return this._yoctosecond;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      return this.dateData;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      var t = this;
      return t.dateData === e.dateData && t._microsecond === e._microsecond && t._nanosecond === e._nanosecond && t._picosecond === e._picosecond && t._femtosecond === e._femtosecond && t._attosecond === e._attosecond && t._zeptosecond === e._zeptosecond && t._yoctosecond === e._yoctosecond;
    }
  }, {
    key: "equalDateParts",
    value: function equalDateParts(e) {
      var t = this;
      return !(t.year() !== e.year() || t.month() !== e.month() || t.day() !== e.day());
    }
  }, {
    key: "compare",
    value: function compare(e) {
      var t = this;
      if (t.equals(e)) return 0;
      var a = ["dateData", "_microsecond", "_nanosecond", "_picosecond", "_femtosecond", "_attosecond", "_zeptosecond", "_yoctosecond"];

      for (var n = 0; n < a.length; n++) {
        var _i157 = a[n];
        if (t[_i157] > e[_i157]) return 1;
        if (t[_i157] < e[_i157]) return -1;
      }

      return 0;
    }
  }, {
    key: "toDateString",
    value: function toDateString() {
      return this.toDate().toDateString();
    }
  }, {
    key: "toLocaleDateString",
    value: function toLocaleDateString() {
      var e = this;
      return e.toDate().toLocaleDateString(e.calendar.locale);
    }
  }, {
    key: "toLocaleString",
    value: function toLocaleString() {
      var e = this;
      return e.toDate().toLocaleString(e.calendar.locale);
    }
  }, {
    key: "toLocaleTimeString",
    value: function toLocaleTimeString() {
      var e = this;
      return e.toDate().toLocaleTimeString(e.calendar.locale);
    }
  }, {
    key: "validateTimeZone",
    value: function validateTimeZone(e) {
      var t = this;

      if ("string" == typeof e) {
        var _i158 = t.timeZones.filter(function (t) {
          return t.id === e;
        });

        0 === _i158.length || (t.timeZone = e, t.timeZoneOffset = _i158[0].offset, t.timeZoneOffsetHours = _i158[0].offsetHours);
      }
    }
  }, {
    key: "copyTimeZone",
    value: function copyTimeZone(e) {
      var t = this;
      e.timeZone = t.timeZone, e.timeZoneOffset = t.timeZoneOffset, e.timeZoneOffsetHours = t.timeZoneOffsetHours;
    }
  }, {
    key: "getTimeStamp",
    value: function getTimeStamp() {
      var e = this,
          t = new Smart.Utilities.BigNumber(e.dateData.toString() + e.getFirstNDigitsOfPrecision(void 0, !0));
      return t;
    }
  }], [{
    key: "validateDate",
    value: function validateDate(e, t, i) {
      if (e instanceof Smart.Utilities.DateTime) return e;
      if (e instanceof Date) return new Smart.Utilities.DateTime(e);

      try {
        if (new RegExp(/^\d{1,2}\/\d{1,2}\/\d{4}(, \d{1,2}:\d{2}:\d{1,2} [A|P]M)?$/).test(e)) {
          var _t155 = new Date(e);

          if (!isNaN(_t155.getTime())) return new Smart.Utilities.DateTime(_t155);
        }

        if ("string" == typeof e) return this.parseDateString(e, t, i);
        if ("number" == typeof e) return new Smart.Utilities.DateTime(new Date(e));
      } catch (e) {}

      return t;
    }
  }, {
    key: "parseDateString",
    value: function parseDateString(e, t, i) {
      var a = new Date(e);
      if (!isNaN(a.getTime())) return new Smart.Utilities.DateTime(a);
      var n = e.indexOf("Date("),
          o = e.indexOf("DateTime("),
          r = e.lastIndexOf(")");
      var l = e;

      if ((-1 !== n || -1 !== o) && -1 !== r) {
        if (l = -1 === n ? e.slice(o + 9, r) : e.slice(n + 5, r), l = l.replace(/'/g, "").replace(/"/g, "").replace(/^\s+|\s+$|\s+(?=\s)/g, ""), "" === l.trim()) return new Smart.Utilities.DateTime();
        if (new RegExp(/(^(\d+)(\s*,\s*\d+)+(\s*,\s*[a-zA-Z ]+)?$)/g).test(l)) return l = l.split(","), l.map(function (e, t) {
          l[t] = isNaN(l[t]) ? e.trim() : parseInt(e);
        }), -1 !== n && l[1]++, l.unshift(null), l = new (Function.prototype.bind.apply(Smart.Utilities.DateTime, l))(), l;
      } else {
        var _t156 = new Smart.Utilities.DateTime(),
            _a99 = _t156.parseDate(e, i);

        if (_a99) return l = new Smart.Utilities.DateTime(_a99), _t156.copySmallTimePartValues(l), l;
      }

      if ("" === l.trim()) return t;
      if (!isNaN(l)) return l = new Date(parseInt(l, 10)), new Smart.Utilities.DateTime(l);

      try {
        var _e170 = l.split(",");

        2 === _e170.length ? (_e170[1] = _e170[1].trim(), _e170.unshift(null), l = new (Function.prototype.bind.apply(Smart.Utilities.DateTime, _e170))()) : l = new Smart.Utilities.DateTime(l);
      } catch (e) {
        l = t;
      }

      return l;
    }
  }, {
    key: "fromFullTimeStamp",
    value: function fromFullTimeStamp(e) {
      e = e.toString();
      var t = new Smart.Utilities.DateTime(parseFloat(e.slice(0, e.length - 21)));

      for (var _i159 = e.slice(e.length - 21), a = 0; 0 < _i159.length;) {
        t[t._smallUnits[a]] = parseInt(_i159.slice(0, 3), 10), _i159 = _i159.slice(3), a++;
      }

      return t;
    }
  }, {
    key: "getConstructorParameters",
    value: function getConstructorParameters(e) {
      return [e.year(), e.month(), e.day(), e.hour(), e.minute(), e.second(), e.millisecond(), e._microsecond, e._nanosecond, e._picosecond, e._femtosecond, e._attosecond, e._zeptosecond, e._yoctosecond, e.timeZone];
    }
  }, {
    key: "detectDisplayMode",
    value: function detectDisplayMode(e, t, i) {
      if (e.calendar.patterns[t]) return -1 === ["d", "D", "M", "Y", "d1", "d2"].indexOf(t) ? -1 === ["t", "T", "FT", "PT"].indexOf(t) ? "default" : "timePicker" : "calendar";
      var a = ["d", "M", "y"],
          n = ["h", "H", "m", "s", "t", "f", "u", "n", "p", "e", "a", "x", "o"],
          o = i.groups;
      var r = !1,
          l = !1;

      for (var s = 0; s < o.length; s++) {
        var _e171 = o[s].charAt(0);

        if (-1 === a.indexOf(_e171) ? -1 !== n.indexOf(_e171) && (l = !0) : r = !0, r && l) break;
      }

      return r == l ? "default" : r ? "calendar" : "timePicker";
    }
  }, {
    key: "getLocalizedNames",
    value: function getLocalizedNames(e) {
      var t = {
        names: [],
        namesAbbr: [],
        namesShort: []
      },
          a = {
        names: [],
        namesAbbr: []
      };
      if (this[e]) return this[e];

      for (var _a100 = 23; 30 > _a100; _a100++) {
        var _i160 = new Date(2017, 6, _a100),
            n = _i160.toLocaleString(e, {
          weekday: "long"
        });

        t.names.push(n), t.namesAbbr.push(_i160.toLocaleString(e, {
          weekday: "short"
        })), t.namesShort.push(n.substring(0, 2));
      }

      for (var _t157 = 0; 12 > _t157; _t157++) {
        var _i161 = new Date(2017, _t157, 1),
            _n72 = _i161.toLocaleString(e, {
          month: "long"
        });

        a.names.push(_n72), a.namesAbbr.push(_n72.substring(0, 3));
      }

      return a.names.push(""), a.namesAbbr.push(""), this[e] = {
        days: t,
        months: a
      }, this[e];
    }
  }]);

  return _class6;
}()), Smart.Utilities.Assign("Draw",
/*#__PURE__*/
function () {
  "use strict";

  function _class7(e, t) {
    _classCallCheck(this, _class7);

    var a = this;
    a.host = e, a.renderEngine = t || "", a.refresh();
    var n = ["clear", "removeElement", "attr", "getAttr", "line", "circle", "rect", "path", "pieslice", "pieSlicePath", "text", "measureText"];

    for (var o in n) {
      a._addFn(Smart.Utilities.Draw.prototype, n[o]);
    }
  }

  _createClass(_class7, [{
    key: "_addFn",
    value: function _addFn(e, t) {
      e[t] || (e[t] = function () {
        return this.renderer[t].apply(this.renderer, arguments);
      });
    }
  }, {
    key: "_initRenderer",
    value: function _initRenderer(e) {
      return this.createRenderer(this, e);
    }
  }, {
    key: "_internalRefresh",
    value: function _internalRefresh() {
      var e = this;

      if (e.renderer || (e.host.innerHTML = "", e._initRenderer(e.host)), "none" !== window.getComputedStyle(e.host).display) {
        var _t158 = e.renderer;

        if (_t158) {
          var _i162 = _t158.getRect();

          e._render({
            x: 1,
            y: 1,
            width: _i162.width,
            height: _i162.height
          });
        }
      }
    }
  }, {
    key: "_render",
    value: function _render(e) {
      this._plotRect = e;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this._internalRefresh();
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var e = this._plotRect;
      return {
        width: e.width,
        height: e.height
      };
    }
  }, {
    key: "toGreyScale",
    value: function toGreyScale(e) {
      if (-1 === e.indexOf("#")) return e;
      var t = this.cssToRgb(e);
      t[0] = t[1] = t[2] = Math.round(.3 * t[0] + .59 * t[1] + .11 * t[2]);
      var i = this.rgbToHex(t[0], t[1], t[2]);
      return "#" + i[0] + i[1] + i[2];
    }
  }, {
    key: "decToHex",
    value: function decToHex(e) {
      return e.toString(16);
    }
  }, {
    key: "hexToDec",
    value: function hexToDec(e) {
      return parseInt(e, 16);
    }
  }, {
    key: "rgbToHex",
    value: function rgbToHex(e, t, i) {
      return [this.decToHex(e), this.decToHex(t), this.decToHex(i)];
    }
  }, {
    key: "hexToRgb",
    value: function hexToRgb(t, i, e) {
      return [this.hexToDec(t), this.hexToDec(i), this.hexToDec(e)];
    }
  }, {
    key: "cssToRgb",
    value: function cssToRgb(e) {
      return -1 >= e.indexOf("rgb") ? this.hexToRgb(e.substring(1, 3), e.substring(3, 5), e.substring(5, 7)) : e.substring(4, e.length - 1).split(",");
    }
  }, {
    key: "hslToRgb",
    value: function hslToRgb(e) {
      var t, i, a;
      var n = parseFloat(e[0]),
          o = parseFloat(e[1]),
          s = parseFloat(e[2]);
      if (0 === o) t = i = a = s;else {
        var _e172 = .5 > s ? s * (1 + o) : s + o - s * o,
            r = 2 * s - _e172;

        t = this.hueToRgb(r, _e172, n + 1 / 3), i = this.hueToRgb(r, _e172, n), a = this.hueToRgb(r, _e172, n - 1 / 3);
      }
      return [255 * t, 255 * i, 255 * a];
    }
  }, {
    key: "hueToRgb",
    value: function hueToRgb(e, i, a) {
      return (0 > a && (a += 1), 1 < a && (a -= 1), a < 1 / 6) ? e + 6 * (i - e) * a : a < 1 / 2 ? i : a < 2 / 3 ? e + 6 * ((i - e) * (2 / 3 - a)) : e;
    }
  }, {
    key: "rgbToHsl",
    value: function rgbToHsl(e) {
      var t = parseFloat(e[0]) / 255,
          i = parseFloat(e[1]) / 255,
          a = parseFloat(e[2]) / 255,
          n = Math.max(t, i, a),
          o = Math.min(t, i, a);
      var r = (n + o) / 2,
          l,
          d;
      if (n === o) l = d = 0;else {
        var _e173 = n - o;

        d = .5 < r ? _e173 / (2 - n - o) : _e173 / (n + o);
        n === t ? l = (i - a) / _e173 + (i < a ? 6 : 0) : n === i ? l = (a - t) / _e173 + 2 : n === a ? l = (t - i) / _e173 + 4 : void 0;
        l /= 6;
      }
      return [l, d, r];
    }
  }, {
    key: "swap",
    value: function swap(e, t) {
      var i = e;
      e = t, t = i;
    }
  }, {
    key: "getNum",
    value: function getNum(e) {
      if (!(e.constructor !== Array)) {
        for (var _t159 = 0; _t159 < e.length; _t159++) {
          if (!isNaN(e[_t159])) return e[_t159];
        }
      } else if (isNaN(e)) return 0;

      return 0;
    }
  }, {
    key: "_ptRotate",
    value: function _ptRotate(e, t, i, a, n) {
      var o = Math.abs,
          r = Math.pow;
      var l = Math.sqrt(r(o(e - i), 2) + r(o(t - a), 2)),
          s = Math.asin((e - i) / l),
          d = s + n;
      return e = i + Math.cos(d) * l, t = a + Math.sin(d) * l, {
        x: e,
        y: t
      };
    }
  }, {
    key: "log",
    value: function log(e, t) {
      var i = Math.log;
      return i(e) / (t ? i(t) : 1);
    }
  }, {
    key: "_mod",
    value: function _mod(e, t) {
      var i = Math.abs(e > t ? t : e);
      var n = 1;
      if (0 !== i) for (; 100 > i * n;) {
        n *= 10;
      }
      return e *= n, t *= n, e % t / n;
    }
  }, {
    key: "createRenderer",
    value: function createRenderer(e, t) {
      var i = e;
      var a = i.renderer = null;
      return document.createElementNS && "HTML5" !== i.renderEngine && (a = new Smart.Utilities.SvgRenderer(this)), null === a && ("HTML5" === i.renderEngine || void 0 === i.renderEngine) && (a = new Smart.Utilities.HTML5Renderer(this)), a.init(t), i.renderer = a, a;
    }
  }, {
    key: "getByPriority",
    value: function getByPriority(e) {
      var t;

      for (var _a101 = 0; _a101 < e.length; _a101++) {
        var _i163 = e[_a101];

        if (_i163 !== void 0 && null !== _i163 && "" !== _i163) {
          t = _i163;
          break;
        }
      }

      return t;
    }
  }, {
    key: "get",
    value: function get(e, t, i) {
      return i === void 0 ? e[t] : e[t][i];
    }
  }, {
    key: "min",
    value: function min(e, t) {
      var a = NaN;

      for (var _n73 = 0; _n73 < e.length; _n73++) {
        var _i164 = this.get(e, _n73, t);

        (isNaN(a) || _i164 < a) && (a = _i164);
      }

      return a;
    }
  }, {
    key: "max",
    value: function max(e, t) {
      var a = NaN;

      for (var _n74 = 0; _n74 < e.length; _n74++) {
        var _i165 = this.get(e, _n74, t);

        (isNaN(a) || _i165 > a) && (a = _i165);
      }

      return a;
    }
  }, {
    key: "sum",
    value: function sum(e, t) {
      var a = 0;

      for (var _n75 = 0; _n75 < e.length; _n75++) {
        var _i166 = this.get(e, _n75, t);

        isNaN(_i166) || (a += _i166);
      }

      return a;
    }
  }, {
    key: "count",
    value: function count(e, t) {
      var a = 0;

      for (var _n76 = 0; _n76 < e.length; _n76++) {
        var _i167 = this.get(e, _n76, t);

        isNaN(_i167) || a++;
      }

      return a;
    }
  }, {
    key: "avg",
    value: function avg(e, t) {
      return this.sum(e, t) / Math.max(1, this.count(e, t));
    }
  }, {
    key: "filter",
    value: function filter(e, t) {
      if (!t) return e;
      var a = [];

      for (var _n77 = 0; _n77 < e.length; _n77++) {
        t(e[_n77]) && a.push(e[_n77]);
      }

      return a;
    }
  }, {
    key: "scale",
    value: function scale(e, t, i, a) {
      var n = Math.min,
          o = Math.abs,
          r = Math.pow,
          l = Math.max;
      if (isNaN(e)) return NaN;
      if ((e < n(t.min, t.max) || e > l(t.min, t.max)) && (!a || !0 !== a.ignore_range)) return NaN;
      var s = NaN,
          d = 1;

      if (t.type === void 0 || "logarithmic" !== t.type) {
        var _i168 = o(t.max - t.min);

        _i168 || (_i168 = 1), d = o(e - n(t.min, t.max)) / _i168;
      } else if ("logarithmic" === t.type) {
        var _i169 = t.base;
        isNaN(_i169) && (_i169 = 10);

        var _a102 = n(t.min, t.max);

        0 >= _a102 && (_a102 = 1);

        var _s10 = l(t.min, t.max);

        0 >= _s10 && (_s10 = 1);
        var c = this.log(_s10, _i169);
        _s10 = r(_i169, c);
        var m = this.log(_a102, _i169);
        _a102 = r(_i169, m);
        var u = this.log(e, _i169);
        d = o(u - m) / (c - m);
      }

      if ("logarithmic" === i.type) {
        var _e174 = i.base;
        isNaN(_e174) && (_e174 = 10);

        var _t160 = this.log(i.max, _e174),
            _a103 = this.log(i.min, _e174);

        i.flip && (d = 1 - d);

        var _l17 = n(_a103, _t160) + d * o(_t160 - _a103);

        s = r(_e174, _l17);
      } else s = n(i.min, i.max) + d * o(i.max - i.min), i.flip && (s = l(i.min, i.max) - s + i.min);

      return s;
    }
  }, {
    key: "axis",
    value: function axis(e, t, a) {
      var n = Math.round,
          o = Math.floor,
          r = Math.pow;
      if (1 >= a) return [t, e];
      (isNaN(a) || 2 > a) && (a = 2);
      var l = 0;

      for (; n(e) !== e && n(t) !== t && 10 > l;) {
        e *= 10, t *= 10, l++;
      }

      var s = (t - e) / a;

      for (; 10 > l && n(s) !== s;) {
        e *= 10, t *= 10, s *= 10, l++;
      }

      var d = [1, 2, 5];
      var c = 0,
          m;

      for (;;) {
        var _e175 = c % d.length,
            _t161 = o(c / d.length),
            _i170 = r(10, _t161) * d[_e175];

        if (_e175 = (c + 1) % d.length, _t161 = o((c + 1) / d.length), m = r(10, _t161) * d[_e175], s >= _i170 && s < m) break;
        c++;
      }

      var u = m,
          p = [];

      var g = this.renderer._rnd(e, u, !1);

      for (var _i171 = 0 >= l ? 1 : r(10, l); g < t + u;) {
        p.push(g / _i171), g += u;
      }

      return p;
    }
  }, {
    key: "_widgetToImage",
    value: function _widgetToImage(e, t, i, a, n) {
      var o = e;
      if (!o) return !1;
      (void 0 === i || "" === i) && (i = "image." + t);
      var r = o.renderEngine,
          l = o.animation;
      if (o.animation = "none", o.renderEngine = "HTML5", o.renderEngine !== r) try {
        o.refresh();
      } catch (t) {
        return o.renderEngine = r, o.refresh(), o.animation = l, !1;
      }
      var s = o.renderer.getContainer().firstElementChild,
          d = !0;
      "function" == typeof a && (d = a(e, s));
      var c = !0;
      return d && (c = this.exportImage(e, s, t, i, n)), o.renderEngine !== r && (o.renderEngine = r, o.refresh(), o.animation = l), c;
    }
  }, {
    key: "_saveAsImage",
    value: function _saveAsImage(e, t) {
      return this._widgetToImage(this, e, t);
    }
  }, {
    key: "saveAsPNG",
    value: function saveAsPNG(e) {
      return this._saveAsImage("png", e);
    }
  }, {
    key: "saveAsJPEG",
    value: function saveAsJPEG(e) {
      return this._saveAsImage("jpeg", e);
    }
  }, {
    key: "exportImage",
    value: function exportImage(e, t, i, a, n) {
      if (!t) return !1;
      var o = "pdf" === i.toLowerCase();
      o && (i = "jpeg"), (a === void 0 || "" === a) && (a = "image." + i);
      var r = !0;

      if ("print" === i) {
        var _e176 = window.open("", "", "width=800,height=500"),
            _i172 = _e176.document.open(),
            _a104 = "<!DOCTYPE html><html><head><meta charset=\"utf-8\" /><title>jQWidgets Chart</title></head><body><img src=\"" + t.toDataURL() + "\" /></html>";

        try {
          _i172.write(_a104), _i172.close(), setTimeout(function () {
            _e176.print(), _e176.close();
          }, 100);
        } catch (e) {}

        return;
      }

      try {
        if (t) if (o) {
          n = n || "portrait";

          var _o60 = t.toDataURL("image/" + i),
              _r30 = {
            content: {
              image: _o60,
              width: Math.min(t.width / 1.35, "portrait" === n ? 515 : 762)
            },
            pageOrientation: n
          };

          try {
            pdfMake.createPdf(_r30).download(a);
          } catch (t) {
            e.error(e.localize("missingReference", {
              files: "pdfmake.min.js"
            }));
          }
        } else {
          Smart.Utilities.DataExporter || e.error(e.localize("missingReference", {
            files: "smart.export.js"
          }));

          var _n78 = new Smart.Utilities.DataExporter();

          t.toBlob(function (e) {
            _n78.downloadFile(e, i, a);
          });
        }
      } catch (t) {
        r = !1;
      }

      return r;
    }
  }]);

  return _class7;
}()), Smart.Utilities.Assign("Renderer",
/*#__PURE__*/
function () {
  "use strict";

  function _class8(e) {
    _classCallCheck(this, _class8);

    var t = this;
    t.draw = e, t._gradients = {}, t._toRadiansCoefficient = 2 * Math.PI / 360;
  }

  _createClass(_class8, [{
    key: "pieSlicePath",
    value: function pieSlicePath(e, t, i, a, n, o, r) {
      var l = Math.abs,
          s = Math.sin,
          d = Math.cos;
      a || (a = 1);
      var c = l(n - o),
          m = 180 < c ? 1 : 0;
      360 <= c && (o = n + 359.99);
      var u = n * this._toRadiansCoefficient,
          p = o * this._toRadiansCoefficient;
      var g = e,
          h = e,
          _ = t,
          f = t;
      var b = !isNaN(i) && 0 < i;
      b && (r = 0);
      var v = d(u),
          w = s(u),
          C = d(p),
          S = s(p);

      if (0 < r + i) {
        if (0 < r) {
          var _i173 = (c / 2 + n) * this._toRadiansCoefficient;

          e += r * d(_i173), t -= r * s(_i173);
        }

        b && (g = e + i * v, _ = t - i * w, h = e + i * C, f = t - i * S);
      }

      var D = e + a * v,
          T = e + a * C,
          $ = t - a * w,
          I = t - a * S;
      var A = "";
      var E = .02 < l(l(o - n) - 360);
      return b ? (A = "M " + h + "," + f, A += " a" + i + "," + i, A += " 0 " + m + ",1 " + (g - h) + "," + (_ - f), A += E ? " L" + D + "," + $ : " M" + D + "," + $, A += " a" + a + "," + a, A += " 0 " + m + ",0 " + (T - D) + "," + (I - $), E && (A += " Z")) : (A = "M " + T + "," + I, A += " a" + a + "," + a, A += " 0 " + m + ",1 " + (D - T) + "," + ($ - I), E && (A += " L" + e + "," + t, A += " Z")), A;
    }
  }, {
    key: "measureText",
    value: function measureText(e, t, i, a) {
      var n = Math.abs;

      var o = this._getTextParts(e, t, i),
          r = o.width;

      var l = o.height;
      !1 === a && (l /= .6);
      var s = {};
      if (isNaN(t) && (t = 0), 0 === t) s = {
        width: this._rup(r),
        height: this._rup(l)
      };else {
        var _e177 = 2 * (t * Math.PI) / 360,
            _i174 = n(Math.sin(_e177)),
            _a105 = n(Math.cos(_e177)),
            _o61 = n(r * _i174 + l * _a105),
            d = n(r * _a105 + l * _i174);

        s = {
          width: this._rup(d),
          height: this._rup(_o61)
        };
      }
      return a && (s.textPartsInfo = o), s;
    }
  }, {
    key: "alignTextInRect",
    value: function alignTextInRect(e, t, i, a, n, o, r, l, s, d) {
      var c = 2 * (s * Math.PI) / 360,
          m = Math.sin(c),
          u = Math.cos(c),
          p = n * m,
          g = n * u;
      "center" === r || "" === r || "undefined" === r ? e += i / 2 : "right" === r && (e += i), "center" === l || "middle" === l || "" === l || "undefined" === l ? t += a / 2 : "bottom" === l ? t += a - o / 2 : "top" == l && (t += o / 2), d = d || "";
      var h = "middle";
      -1 === d.indexOf("top") ? -1 !== d.indexOf("bottom") && (h = "bottom") : h = "top";
      var _ = "center";
      return -1 === d.indexOf("left") ? -1 !== d.indexOf("right") && (_ = "right") : _ = "left", "center" == _ ? (e -= g / 2, t -= p / 2) : "right" == _ && (e -= g, t -= p), "top" == h ? (e -= o * m, t += o * u) : "middle" == h && (e -= o * m / 2, t += o * u / 2), e = this._rup(e), t = this._rup(t), {
        x: e,
        y: t
      };
    }
  }, {
    key: "adjustColor",
    value: function adjustColor(e, t) {
      var i = Math.min;
      if ("string" != typeof e) return "#000000";
      if (-1 === e.indexOf("#")) return e;
      var a = this.draw;
      var n = a.cssToRgb(e);
      var o = a.rgbToHsl(n);
      o[2] = i(1, o[2] * t), o[1] = i(1, 1.1 * (o[1] * t)), n = a.hslToRgb(o), e = "#";

      for (var _o62 = 0, _i175; 3 > _o62; _o62++) {
        _i175 = Math.round(n[_o62]), _i175 = a.decToHex(_i175), 1 === _i175.toString().length && (e += "0"), e += _i175;
      }

      return e.toUpperCase();
    }
  }, {
    key: "_rup",
    value: function _rup(e) {
      var t = Math.round(e);
      return e > t && t++, t;
    }
  }, {
    key: "_ptdist",
    value: function _ptdist(e, t, i, a) {
      return Math.sqrt((i - e) * (i - e) + (a - t) * (a - t));
    }
  }, {
    key: "_rnd",
    value: function _rnd(e, t, i, n) {
      if (isNaN(e)) return e;
      void 0 === n && (n = !0);
      var o = e - (!0 === n ? e % t : this._mod(e, t));
      return e === o ? o : (i ? e > o && (o += t) : o > e && (o -= t), 1 === t ? Math.round(o) : o);
    }
  }, {
    key: "_ptrnd",
    value: function _ptrnd(e) {
      var t = Math.round;
      if (!document.createElementNS) return t(e) === e ? e : this._rnd(e, 1, !1, !0);

      var i = this._rnd(e, .5, !1, !0);

      return .5 === Math.abs(i - t(i)) ? i : i > e ? i - .5 : i + .5;
    }
  }, {
    key: "_getContrastColor",
    value: function _getContrastColor(e) {
      if (void 0 !== e) {
        var _t162 = this.draw.hexToRgb(e.slice(1, 3), e.slice(3, 5), e.slice(5, 7)),
            _i176 = (.299 * _t162[0] + .61 * _t162[1] + .114 * _t162[2]) / 255;

        return .6 < _i176 ? "#000000" : "#FFFFFF";
      }
    }
  }]);

  return _class8;
}()), Smart.Utilities.Assign("SvgRenderer",
/*#__PURE__*/
function (_Smart$Utilities$Rend) {
  "use strict";

  _inherits(_class9, _Smart$Utilities$Rend);

  function _class9(e) {
    var _this3;

    _classCallCheck(this, _class9);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(_class9).call(this, e));

    var t = _assertThisInitialized(_this3);

    t._svgns = "http://www.w3.org/2000/svg", t._openGroups = [], t._clipId = 0;
    return _this3;
  }

  _createClass(_class9, [{
    key: "init",
    value: function init(e) {
      var t = document.createElement("div");
      t.className = "drawContainer", t.onselectstart = function () {
        return !1;
      }, e.appendChild(t), this.host = e, this.container = t;

      try {
        var _e178 = document.createElementNS(this._svgns, "svg");

        _e178.setAttribute("version", "1.1"), _e178.setAttribute("width", "100%"), _e178.setAttribute("height", "100%"), _e178.setAttribute("overflow", "hidden"), t.appendChild(_e178), this.canvas = _e178;
      } catch (t) {
        return !1;
      }

      return this._id = new Date().getTime(), this.clear(), !0;
    }
  }, {
    key: "getType",
    value: function getType() {
      return "SVG";
    }
  }, {
    key: "refresh",
    value: function refresh() {}
  }, {
    key: "getRect",
    value: function getRect() {
      var e = Math.max;
      return {
        x: 0,
        y: 0,
        width: e(this._rup(this.host.offsetWidth) - 1, 0),
        height: e(this._rup(this.host.offsetHeight) - 1, 0)
      };
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this.container;
    }
  }, {
    key: "clear",
    value: function clear() {
      for (; 0 < this.canvas.childNodes.length;) {
        this.removeElement(this.canvas.firstElementChild);
      }

      this._defaultParent = void 0, this._defs = document.createElementNS(this._svgns, "defs"), this._gradients = {}, this.canvas.appendChild(this._defs);
    }
  }, {
    key: "removeElement",
    value: function removeElement(e) {
      if (void 0 !== e) try {
        for (; e.firstChild;) {
          this.removeElement(e.firstChild);
        }

        e.parentNode ? e.parentNode.removeChild(e) : this.canvas.removeChild(e);
      } catch (e) {}
    }
  }, {
    key: "beginGroup",
    value: function beginGroup() {
      var e = this._activeParent(),
          t = document.createElementNS(this._svgns, "g");

      return e.appendChild(t), this._openGroups.push(t), t;
    }
  }, {
    key: "endGroup",
    value: function endGroup() {
      0 === this._openGroups.length || this._openGroups.pop();
    }
  }, {
    key: "_activeParent",
    value: function _activeParent() {
      return 0 === this._openGroups.length ? this.canvas : this._openGroups[this._openGroups.length - 1];
    }
  }, {
    key: "createClipRect",
    value: function createClipRect(e) {
      var t = document.createElementNS(this._svgns, "clipPath"),
          i = document.createElementNS(this._svgns, "rect");
      return this.attr(i, {
        x: e.x,
        y: e.y,
        width: e.width,
        height: e.height,
        fill: "none"
      }), this._clipId = this._clipId || 0, t.id = "cl" + this._id + "_" + (++this._clipId).toString(), t.appendChild(i), this._defs.appendChild(t), t;
    }
  }, {
    key: "getWindowHref",
    value: function getWindowHref() {
      var e = window.location.href;
      return e ? (e = e.replace(/([\('\)])/g, "\\$1"), e = e.replace(/#.*$/, ""), e) : e;
    }
  }, {
    key: "setClip",
    value: function setClip(e, t) {
      var i = "url(" + this.getWindowHref() + "#" + t.id + ")";
      return this.attr(e, {
        "clip-path": i
      });
    }
  }, {
    key: "addHandler",
    value: function addHandler(e, t, i) {
      e.addEventListener(t, i);
    }
  }, {
    key: "removeHandler",
    value: function removeHandler() {}
  }, {
    key: "on",
    value: function on(e, t, i) {
      this.addHandler(e, t, i);
    }
  }, {
    key: "off",
    value: function off(e, t, i) {
      this.removeHandler(e, t, i);
    }
  }, {
    key: "shape",
    value: function shape(e, t) {
      var i = document.createElementNS(this._svgns, e);

      if (i) {
        for (var _e179 in t) {
          i.setAttribute(_e179, t[_e179]);
        }

        return this._activeParent().appendChild(i), i;
      }
    }
  }, {
    key: "_getTextParts",
    value: function _getTextParts(e, t, i) {
      var a = {
        width: 0,
        height: 0,
        parts: []
      };
      if (void 0 === e) return a;

      var n = e.toString().split("<br>"),
          o = this._activeParent(),
          r = document.createElementNS(this._svgns, "text");

      this.attr(r, i);

      for (var l = 0; l < n.length; l++) {
        var _e180 = n[l],
            _t163 = r.ownerDocument.createTextNode(_e180);

        r.appendChild(_t163), o.appendChild(r);

        var _i177 = void 0;

        try {
          _i177 = r.getBBox();
        } catch (t) {}

        var s = this._rup(_i177.width),
            d = this._rup(_i177.height * .6);

        r.removeChild(_t163), a.width = Math.max(a.width, s), a.height += d + (0 < l ? 4 : 0), a.parts.push({
          width: s,
          height: d,
          text: _e180
        });
      }

      return o.removeChild(r), a;
    }
  }, {
    key: "_measureText",
    value: function _measureText(e, t, i, a) {
      return _get(_getPrototypeOf(_class9.prototype), "measureText", this).call(this, e, t, i, a);
    }
  }, {
    key: "measureText",
    value: function measureText(e, t, i) {
      return this._measureText(e, t, i, !1);
    }
  }, {
    key: "text",
    value: function text(e, t, a, i, n, o, r, l, s, d, c) {
      var m = this._measureText(e, o, r, !0, this),
          u = m.textPartsInfo,
          p = u.parts,
          g = this._getContrastColor(arguments[11]);

      var _;

      if (s || (s = "center"), d || (d = "center"), (1 < p.length || l) && (_ = this.beginGroup()), l) {
        var _e181 = this.createClipRect({
          x: this._rup(t) - 1,
          y: this._rup(a) - 1,
          width: this._rup(i) + 2,
          height: this._rup(n) + 2
        });

        this.setClip(_, _e181);
      }

      var f = this._activeParent(),
          b = 0,
          v = 0;

      b = u.width, v = u.height, (isNaN(i) || 0 >= i) && (i = b), (isNaN(n) || 0 >= n) && (n = v);
      var C = i || 0,
          w = n || 0;
      var h = 0;

      if (!o || 0 === o) {
        a += v, "center" === d || "middle" === d ? a += (w - v) / 2 : "bottom" === d && (a += w - v), i || (i = b), n || (n = v), f = this._activeParent();

        var _e182;

        for (var _n79 = p.length - 1; 0 <= _n79; _n79--) {
          _e182 = document.createElementNS(this._svgns, "text"), this.attr(_e182, r), this.attr(_e182, {
            cursor: "default"
          });

          var _i178 = _e182.ownerDocument.createTextNode(p[_n79].text);

          _e182.appendChild(_i178);

          var _o63 = t;
          var _l18 = p[_n79].width,
              _d11 = p[_n79].height;
          "center" === s ? _o63 += (C - _l18) / 2 : "right" == s && (_o63 += C - _l18), this.attr(_e182, {
            x: this._rup(_o63),
            y: this._rup(a + h),
            width: this._rup(_l18),
            height: this._rup(_d11)
          }), void 0 !== g && (_e182.style.fill = g), f.appendChild(_e182), h -= p[_n79].height + 4;
        }

        return _ ? (this.endGroup(), _) : _e182;
      }

      var S = this.alignTextInRect(t, a, i, n, b, v, s, d, o, c);
      t = S.x, a = S.y;
      var D = this.shape("g", {
        transform: "translate(" + t + "," + a + ")"
      }),
          T = this.shape("g", {
        transform: "rotate(" + o + ")"
      });
      D.appendChild(T), h = 0;

      for (var _m6 = p.length - 1; 0 <= _m6; _m6--) {
        var _e183 = document.createElementNS(this._svgns, "text");

        this.attr(_e183, r), this.attr(_e183, {
          cursor: "default"
        });

        var _t164 = _e183.ownerDocument.createTextNode(p[_m6].text);

        _e183.appendChild(_t164);

        var _i179 = 0;
        var _a106 = p[_m6].width,
            _n80 = p[_m6].height;
        "center" === s ? _i179 += (u.width - _a106) / 2 : "right" == s && (_i179 += u.width - _a106), this.attr(_e183, {
          x: this._rup(_i179),
          y: this._rup(h),
          width: this._rup(_a106),
          height: this._rup(_n80)
        }), T.appendChild(_e183), h -= _n80 + 4;
      }

      return f.appendChild(D), _ && this.endGroup(), D;
    }
  }, {
    key: "line",
    value: function line(e, t, i, a, n) {
      var o = this.shape("line", {
        x1: e,
        y1: t,
        x2: i,
        y2: a
      });
      return this.attr(o, n), o;
    }
  }, {
    key: "path",
    value: function path(e, t) {
      var i = this.shape("path");
      return i.setAttribute("d", e), t && this.attr(i, t), i;
    }
  }, {
    key: "rect",
    value: function rect(e, t, i, a, n) {
      var o = Math.max;
      e = this._ptrnd(e), t = this._ptrnd(t), i = o(1, this._rnd(i, 1, !1)), a = o(1, this._rnd(a, 1, !1));
      var r = this.shape("rect", {
        x: e,
        y: t,
        width: i,
        height: a
      });
      return n && this.attr(r, n), r;
    }
  }, {
    key: "circle",
    value: function circle(e, t, i, a) {
      var n = this.shape("circle", {
        cx: e,
        cy: t,
        r: i
      });
      return a && this.attr(n, a), n;
    }
  }, {
    key: "pieslice",
    value: function pieslice(e, t, i, a, n, o, r, l) {
      var d = this.pieSlicePath(e, t, i, a, n, o, r),
          c = this.shape("path");
      return c.setAttribute("d", d), l && this.attr(c, l), c;
    }
  }, {
    key: "attr",
    value: function attr(e, t) {
      if (e && t) for (var _i180 in t) {
        "textContent" == _i180 ? e.textContent = t[_i180] : e.setAttribute(_i180, t[_i180]);
      }
    }
  }, {
    key: "removeAttr",
    value: function removeAttr(e, t) {
      if (e && t) for (var _i181 in t) {
        "textContent" == _i181 ? e.textContent = "" : e.removeAttribute(t[_i181]);
      }
    }
  }, {
    key: "getAttr",
    value: function getAttr(e, t) {
      return e.getAttribute(t);
    }
  }, {
    key: "_toLinearGradient",
    value: function _toLinearGradient(e, t, a) {
      var i = "grd" + this._id + e.replace("#", "") + (t ? "v" : "h"),
          n = "url(" + this.getWindowHref() + "#" + i + ")";
      if (this._gradients[n]) return n;
      var o = document.createElementNS(this._svgns, "linearGradient");
      this.attr(o, {
        x1: "0%",
        y1: "0%",
        x2: t ? "0%" : "100%",
        y2: t ? "100%" : "0%",
        id: i
      });

      for (var _n81 = 0; _n81 < a.length; _n81++) {
        var _t165 = a[_n81],
            _i182 = document.createElementNS(this._svgns, "stop"),
            r = "stop-color:" + this.adjustColor(e, _t165[1]);

        this.attr(_i182, {
          offset: _t165[0] + "%",
          style: r
        }), o.appendChild(_i182);
      }

      return this._defs.appendChild(o), this._gradients[n] = !0, n;
    }
  }, {
    key: "_toRadialGradient",
    value: function _toRadialGradient(e, t, i) {
      var a = "grd" + this._id + e.replace("#", "") + "r" + (void 0 === i ? "" : i.key),
          n = "url(" + this.getWindowHref() + "#" + a + ")";
      if (this._gradients[n]) return n;
      var o = document.createElementNS(this._svgns, "radialGradient");
      void 0 === i ? this.attr(o, {
        cx: "50%",
        cy: "50%",
        r: "100%",
        fx: "50%",
        fy: "50%",
        id: a
      }) : this.attr(o, {
        cx: i.x,
        cy: i.y,
        r: i.outerRadius,
        id: a,
        gradientUnits: "userSpaceOnUse"
      });

      for (var _a107 = 0; _a107 < t.length; _a107++) {
        var _i183 = t[_a107],
            _n82 = document.createElementNS(this._svgns, "stop"),
            r = "stop-color:" + this.adjustColor(e, _i183[1]);

        this.attr(_n82, {
          offset: _i183[0] + "%",
          style: r
        }), o.appendChild(_n82);
      }

      return this._defs.appendChild(o), this._gradients[n] = !0, n;
    }
  }]);

  return _class9;
}(Smart.Utilities.Renderer)), Smart.Utilities.Assign("HTML5Renderer",
/*#__PURE__*/
function (_Smart$Utilities$Rend2) {
  "use strict";

  _inherits(_class10, _Smart$Utilities$Rend2);

  function _class10(e) {
    var _this4;

    _classCallCheck(this, _class10);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(_class10).call(this, e));

    var t = _assertThisInitialized(_this4);

    t._renderers = new Smart.Utilities.HTML5RenderHelpers(t);
    return _this4;
  }

  _createClass(_class10, [{
    key: "init",
    value: function init(e) {
      try {
        this.host = e;

        var _t166 = document.createElement("div"),
            _i184 = document.createElement("canvas");

        _t166.className = "chartContainer", _t166.style.position = "relative", _t166.onselectstart = function () {
          return !1;
        }, _i184.id = "__smartCanvasWrap", _i184.style.width = "100%", _i184.style.height = "100%", _t166.appendChild(_i184), e.appendChild(_t166), this.canvas = _i184, _i184.width = e.offsetWidth, _i184.height = e.offsetHeight, this.ctx = _i184.getContext("2d"), this._elements = {}, this._maxId = 0, this._gradientId = 0, this._gradients = {}, this._currentPoint = {
          x: 0,
          y: 0
        }, this._lastCmd = "", this._pos = 0;
      } catch (t) {
        return !1;
      }

      return !0;
    }
  }, {
    key: "getType",
    value: function getType() {
      return "HTML5";
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      var e = this.host.getElementsByClassName("chartContainer")[0];
      return e;
    }
  }, {
    key: "getRect",
    value: function getRect() {
      return {
        x: 0,
        y: 0,
        width: this.canvas.width - 1,
        height: this.canvas.height - 1
      };
    }
  }, {
    key: "beginGroup",
    value: function beginGroup() {}
  }, {
    key: "endGroup",
    value: function endGroup() {}
  }, {
    key: "setClip",
    value: function setClip() {}
  }, {
    key: "createClipRect",
    value: function createClipRect() {}
  }, {
    key: "addHandler",
    value: function addHandler() {}
  }, {
    key: "removeHandler",
    value: function removeHandler() {}
  }, {
    key: "on",
    value: function on(e, t, i) {
      this.addHandler(e, t, i);
    }
  }, {
    key: "off",
    value: function off(e, t, i) {
      this.removeHandler(e, t, i);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._elements = {}, this._maxId = 0, this._renderers._gradients = {}, this._gradientId = 0;
    }
  }, {
    key: "removeElement",
    value: function removeElement(e) {
      void 0 === e || this._elements[e.id] && delete this._elements[e.id];
    }
  }, {
    key: "shape",
    value: function shape(e, t) {
      var i = {
        type: e,
        id: this._maxId++
      };

      for (var _a108 in t) {
        i[_a108] = t[_a108];
      }

      return this._elements[i.id] = i, i;
    }
  }, {
    key: "attr",
    value: function attr(e, t) {
      for (var _i185 in t) {
        e[_i185] = t[_i185];
      }
    }
  }, {
    key: "removeAttr",
    value: function removeAttr(e, t) {
      for (var _i186 in t) {
        delete e[t[_i186]];
      }
    }
  }, {
    key: "rect",
    value: function rect(e, t, i, a, n) {
      if (isNaN(e)) throw "Invalid value for \"x\"";
      if (isNaN(t)) throw "Invalid value for \"y\"";
      if (isNaN(i)) throw "Invalid value for \"width\"";
      if (isNaN(a)) throw "Invalid value for \"height\"";
      var o = this.shape("rect", {
        x: e,
        y: t,
        width: i,
        height: a
      });
      return n && this.attr(o, n), o;
    }
  }, {
    key: "path",
    value: function path(e, t) {
      var i = this.shape("path", t);
      return this.attr(i, {
        d: e
      }), i;
    }
  }, {
    key: "line",
    value: function line(e, t, i, a, n) {
      return this.path("M " + e + "," + t + " L " + i + "," + a, n);
    }
  }, {
    key: "circle",
    value: function circle(e, t, i, a) {
      var n = this.shape("circle", {
        x: e,
        y: t,
        r: i
      });
      return a && this.attr(n, a), n;
    }
  }, {
    key: "pieslice",
    value: function pieslice(e, t, i, a, n, o, r, l) {
      var s = this.path(this.pieSlicePath(e, t, i, a, n, o, r), l);
      return this.attr(s, {
        x: e,
        y: t,
        innerRadius: i,
        outerRadius: a,
        angleFrom: n,
        angleTo: o
      }), s;
    }
  }, {
    key: "_getCSSStyle",
    value: function _getCSSStyle(e) {
      var t = document.createElement("div");
      t.className = e, t.style.position = "absolute", t.style.visibility = "hidden", this.host.appendChild(t);
      var i = window.getComputedStyle(t);
      return i = {
        color: i.color,
        fontFamily: i.fontFamily,
        fontSize: i.fontSize,
        fontWeight: i.fontWeight
      }, this.host.removeChild(t), i;
    }
  }, {
    key: "_getTextParts",
    value: function _getTextParts(e, t, i) {
      var a = "Arial",
          n = "10pt",
          o = "";

      if (i && i["class"]) {
        var _e184 = this._getCSSStyle(i["class"]);

        _e184.fontSize && (n = _e184.fontSize), _e184.fontFamily && (a = _e184.fontFamily), _e184.fontWeight && (o = _e184.fontWeight);
      }

      this.ctx.font = o + " " + n + " " + a;
      var r = {
        width: 0,
        height: 0,
        parts: []
      },
          l = e.toString().split("<br>");

      for (var _a109 = 0; _a109 < l.length; _a109++) {
        var _e185 = l[_a109],
            _t167 = this.ctx.measureText(_e185).width,
            _i187 = document.createElement("span");

        _i187.className = "smartchart", _i187.font = this.ctx.font, _i187.textContent = _e185, this.host.appendChild(_i187);

        var _n83 = _i187.offsetHeight * .6;

        this.host.removeChild(_i187), r.width = Math.max(r.width, this._rup(_t167)), r.height += _n83 + (0 < _a109 ? 4 : 0), r.parts.push({
          width: _t167,
          height: _n83,
          text: _e185
        });
      }

      return r;
    }
  }, {
    key: "_measureText",
    value: function _measureText(e, t, i, a) {
      return _get(_getPrototypeOf(_class10.prototype), "measureText", this).call(this, e, t, i, a);
    }
  }, {
    key: "measureText",
    value: function measureText(e, t, i) {
      return this._measureText(e, t, i, !1);
    }
  }, {
    key: "text",
    value: function text(e, i, a, n, o, r, l, s, d, c, m) {
      var u = this.shape("text", {
        text: e,
        x: i,
        y: a,
        width: n,
        height: o,
        angle: r,
        clip: s,
        halign: d,
        valign: c,
        rotateAround: m
      });

      if (l && this.attr(u, l), u.fontFamily = "Arial", u.fontSize = "10pt", u.fontWeight = "", u.color = this._getContrastColor(arguments[11]), l && l["class"]) {
        var _e186 = this._getCSSStyle(l["class"]);

        u.fontFamily = _e186.fontFamily || u.fontFamily, u.fontSize = _e186.fontSize || u.fontSize, u.fontWeight = _e186.fontWeight || u.fontWeight, u.color = u.color || _e186.color;
      }

      u.color = u.color || "#000000";

      var t = this._measureText(e, 0, l, !0);

      return this.attr(u, {
        textPartsInfo: t.textPartsInfo,
        textWidth: t.width,
        textHeight: t.height
      }), (0 >= n || isNaN(n)) && this.attr(u, {
        width: t.width
      }), (0 >= o || isNaN(o)) && this.attr(u, {
        height: t.height
      }), u;
    }
  }, {
    key: "_toLinearGradient",
    value: function _toLinearGradient(e, t, a) {
      if (this._renderers._gradients[e]) return e;
      var n = [];

      for (var o = 0; o < a.length; o++) {
        n.push({
          percent: a[o][0] / 100,
          color: this.adjustColor(e, a[o][1])
        });
      }

      var i = "gr" + this._gradientId++;
      return this.createGradient(i, t ? "vertical" : "horizontal", n), i;
    }
  }, {
    key: "_toRadialGradient",
    value: function _toRadialGradient(e, t) {
      if (this._renderers._gradients[e]) return e;
      var a = [];

      for (var _n84 = 0; _n84 < t.length; _n84++) {
        a.push({
          percent: t[_n84][0] / 100,
          color: this.adjustColor(e, t[_n84][1])
        });
      }

      var i = "gr" + this._gradientId++;
      return this.createGradient(i, "radial", a), i;
    }
  }, {
    key: "createGradient",
    value: function createGradient(e, t, i) {
      this._renderers.createGradient(this, e, t, i);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      for (var e in this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height), this._elements) {
        var _t168 = this._elements[e];
        this._renderers.setFillStyle(this, _t168), this._renderers.setStroke(this, _t168), this._renderers[this._elements[e].type](this.ctx, _t168);
      }
    }
  }]);

  return _class10;
}(Smart.Utilities.Renderer)), Smart.Utilities.Assign("HTML5RenderHelpers",
/*#__PURE__*/
function () {
  "use strict";

  function _class11(e) {
    _classCallCheck(this, _class11);

    this.HTML5Renderer = e, this._cmds = "mlcazq";
  }

  _createClass(_class11, [{
    key: "ptrnd",
    value: function ptrnd(e) {
      var t = Math.round;
      if (.5 === Math.abs(t(e) - e)) return e;
      var i = t(e);
      return i < e && --i, i + .5;
    }
  }, {
    key: "createGradient",
    value: function createGradient(e, t, i, a) {
      e._gradients[t] = {
        orientation: i,
        colorStops: a
      };
    }
  }, {
    key: "setStroke",
    value: function setStroke(e, t) {
      var i = e.ctx,
          a = t["stroke-width"];
      i.strokeStyle = t.stroke || "transparent", i.lineWidth = 0 === a ? .01 : void 0 === a ? 1 : a, i.globalAlpha = void 0 === t["fill-opacity"] ? void 0 === t.opacity ? 1 : t.opacity : t["fill-opacity"], i.setLineDash && (t["stroke-dasharray"] ? i.setLineDash(t["stroke-dasharray"].split(",")) : i.setLineDash([]));
    }
  }, {
    key: "setFillStyle",
    value: function setFillStyle(e, t) {
      var i = e.ctx;

      if (i.fillStyle = "transparent", i.globalAlpha = void 0 === t["fill-opacity"] ? void 0 === t.opacity ? 1 : t.opacity : t["fill-opacity"], t.fill && -1 === t.fill.indexOf("#") && e._gradients[t.fill]) {
        var _a110 = "horizontal" !== e._gradients[t.fill].orientation,
            _n85 = "radial" === e._gradients[t.fill].orientation,
            o = this.ptrnd(t.x),
            r = this.ptrnd(t.y),
            l = this.ptrnd(t.x + (_a110 ? 0 : t.width)),
            s = this.ptrnd(t.y + (_a110 ? t.height : 0)),
            d;

        if (("circle" === t.type || "path" === t.type || "rect" === t.type) && _n85) {
          var _e187 = this.ptrnd(t.x),
              _a111 = this.ptrnd(t.y);

          var _n86 = t.innerRadius || 0,
              _o64 = t.outerRadius || t.r || 0;

          "rect" === t.type && (_e187 += t.width / 2, _a111 += t.height / 2), d = i.createRadialGradient(_e187, _a111, _n86, _e187, _a111, _o64);
        }

        _n85 || ((isNaN(o) || isNaN(l) || isNaN(r) || isNaN(s)) && (o = 0, r = 0, l = _a110 ? 0 : i.canvas.width, s = _a110 ? i.canvas.height : 0), d = i.createLinearGradient(o, r, l, s));
        var c = e._gradients[t.fill].colorStops;

        for (var _e188 = 0; _e188 < c.length; _e188++) {
          d.addColorStop(c[_e188].percent, c[_e188].color);
        }

        i.fillStyle = d;
      } else t.fill && (i.fillStyle = t.fill);
    }
  }, {
    key: "rect",
    value: function rect(e, t) {
      0 === t.width || 0 === t.height || (e.fillRect(this.ptrnd(t.x), this.ptrnd(t.y), t.width, t.height), e.strokeRect(this.ptrnd(t.x), this.ptrnd(t.y), t.width, t.height));
    }
  }, {
    key: "circle",
    value: function circle(e, t) {
      0 === t.r || (e.beginPath(), e.arc(this.ptrnd(t.x), this.ptrnd(t.y), t.r, 0, 2 * Math.PI, !1), e.closePath(), e.fill(), e.stroke());
    }
  }, {
    key: "_parsePoint",
    value: function _parsePoint(e) {
      var t = this._parseNumber(e),
          i = this._parseNumber(e);

      return {
        x: t,
        y: i
      };
    }
  }, {
    key: "_parseNumber",
    value: function _parseNumber(e) {
      var t = !1,
          a;

      for (a = this._pos; a < e.length; a++) {
        if ("0" <= e[a] && "9" >= e[a] || "." === e[a] || "e" === e[a] || "-" === e[a] && !t || "-" === e[a] && 1 <= a && "e" === e[a - 1]) {
          t = !0;
          continue;
        }

        if (!t && (" " === e[a] || "," === e[a])) {
          this._pos++;
          continue;
        }

        break;
      }

      var n = parseFloat(e.substring(this._pos, a));
      if (!isNaN(n)) return this._pos = a, n;
    }
  }, {
    key: "_isRelativeCmd",
    value: function _isRelativeCmd(e) {
      return -1 !== this._cmds.indexOf(e);
    }
  }, {
    key: "_parseCmd",
    value: function _parseCmd(e) {
      for (var _t169 = this._pos; _t169 < e.length; _t169++) {
        if (-1 !== this._cmds.toLowerCase().indexOf(e[_t169].toLowerCase())) return this._pos = _t169 + 1, this._lastCmd = e[_t169], this._lastCmd;

        if (" " === e[_t169]) {
          this._pos++;
          continue;
        }

        if ("0" <= e[_t169] && "9" >= e[_t169]) if (this._pos = _t169, "" === this._lastCmd) break;else return this._lastCmd;
      }
    }
  }, {
    key: "_toAbsolutePoint",
    value: function _toAbsolutePoint(e) {
      return {
        x: this._currentPoint.x + e.x,
        y: this._currentPoint.y + e.y
      };
    }
  }, {
    key: "path",
    value: function path(e, t) {
      var _this5 = this;

      var i = Math.sqrt,
          n = Math.pow,
          o = Math.sin,
          l = Math.cos,
          d = Math.PI;
      var c = t.d;
      this._pos = 0, this._lastCmd = "";
      var a;

      for (this._currentPoint = {
        x: 0,
        y: 0
      }, e.beginPath(); this._pos < c.length;) {
        var _t170 = this._parseCmd(c);

        if (_t170 === void 0) break;

        if ("M" === _t170 || "m" === _t170) {
          var _t171 = this._parsePoint(c);

          if (void 0 === _t171) break;
          e.moveTo(_t171.x, _t171.y), this._currentPoint = _t171, void 0 === a && (a = _t171);
          continue;
        }

        if ("L" === _t170 || "l" === _t170) {
          var _t172 = this._parsePoint(c);

          if (void 0 === _t172) break;
          e.lineTo(_t172.x, _t172.y), this._currentPoint = _t172;
          continue;
        }

        if ("A" === _t170 || "a" === _t170) {
          var _ret6 = function () {
            var p = _this5._parseNumber(c),
                g = _this5._parseNumber(c),
                h = _this5._parseNumber(c) * (d / 180),
                _ = _this5._parseNumber(c),
                f = _this5._parseNumber(c),
                b = _this5._parsePoint(c);

            if (_this5._isRelativeCmd(_t170) && (b = _this5._toAbsolutePoint(b)), 0 === p || 0 === g) return "continue";
            var y = _this5._currentPoint,
                w = {
              x: l(h) * (y.x - b.x) / 2 + o(h) * (y.y - b.y) / 2,
              y: -o(h) * (y.x - b.x) / 2 + l(h) * (y.y - b.y) / 2
            },
                C = n(w.x, 2) / n(p, 2) + n(w.y, 2) / n(g, 2);
            1 < C && (p *= i(C), g *= i(C));
            var x = (_ === f ? -1 : 1) * i((n(p, 2) * n(g, 2) - n(p, 2) * n(w.y, 2) - n(g, 2) * n(w.x, 2)) / (n(p, 2) * n(w.y, 2) + n(g, 2) * n(w.x, 2)));
            isNaN(x) && (x = 0);

            var s = {
              x: x * p * w.y / g,
              y: x * -g * w.x / p
            },
                S = {
              x: (y.x + b.x) / 2 + l(h) * s.x - o(h) * s.y,
              y: (y.y + b.y) / 2 + o(h) * s.x + l(h) * s.y
            },
                D = function D(e) {
              return i(n(e[0], 2) + n(e[1], 2));
            },
                m = function m(e, t) {
              return (e[0] * t[0] + e[1] * t[1]) / (D(e) * D(t));
            },
                r = function r(e, t) {
              return (e[0] * t[1] < e[1] * t[0] ? -1 : 1) * Math.acos(m(e, t));
            },
                a = r([1, 0], [(w.x - s.x) / p, (w.y - s.y) / g]),
                T = [(w.x - s.x) / p, (w.y - s.y) / g],
                u = [(-w.x - s.x) / p, (-w.y - s.y) / g],
                v = r(T, u);

            -1 >= m(T, u) && (v = d), 1 <= m(T, u) && (v = 0), 0 === f && 0 < v && (v -= 2 * d), 1 === f && 0 > v && (v += 2 * d);
            var $ = p > g ? p : g,
                I = p > g ? 1 : p / g,
                A = p > g ? g / p : 1;
            e.translate(S.x, S.y), e.rotate(h), e.scale(I, A), e.arc(0, 0, $, a, a + v, 1 - f), e.scale(1 / I, 1 / A), e.rotate(-h), e.translate(-S.x, -S.y);
            return "continue";
          }();

          if (_ret6 === "continue") continue;
        }

        if (("Z" === _t170 || "z" === _t170) && void 0 !== a) {
          e.lineTo(a.x, a.y), this._currentPoint = a;
          continue;
        }

        if ("C" === _t170 || "c" === _t170) {
          var _t173 = this._parsePoint(c),
              _i188 = this._parsePoint(c),
              _a112 = this._parsePoint(c);

          e.bezierCurveTo(_t173.x, _t173.y, _i188.x, _i188.y, _a112.x, _a112.y), this._currentPoint = _a112;
          continue;
        }

        if ("Q" === _t170 || "q" === _t170) {
          var _t174 = this._parsePoint(c),
              _i189 = this._parsePoint(c);

          e.quadraticCurveTo(_t174.x, _t174.y, _i189.x, _i189.y), this._currentPoint = _i189;
          continue;
        }
      }

      e.fill(), e.stroke(), e.closePath();
    }
  }, {
    key: "text",
    value: function text(e, t) {
      var a = this.ptrnd(t.x),
          n = this.ptrnd(t.y),
          i = this.ptrnd(t.width),
          o = this.ptrnd(t.height),
          r = t.halign,
          l = t.valign,
          s = t.angle,
          d = t.rotateAround,
          c = t.textPartsInfo,
          m = c.parts,
          u = t.clip;
      void 0 === u && (u = !0), e.save(), r || (r = "center"), l || (l = "center"), u && (e.rect(a, n, i, o), e.clip());

      var p = t.textWidth,
          g = t.textHeight,
          _ = i || 0,
          f = o || 0;

      if (e.fillStyle = t.color, e.font = t.fontWeight + " " + t.fontSize + " " + t.fontFamily, !s || 0 === s) {
        n += g, "center" === l || "middle" === l ? n += (f - g) / 2 : "bottom" === l && (n += f - g), i || (i = p), o || (o = g);
        var _t175 = 0;

        for (var _o65 = m.length - 1; 0 <= _o65; _o65--) {
          var _i190 = m[_o65],
              _l19 = a,
              _s11 = m[_o65].width;
          "center" === r ? _l19 += (_ - _s11) / 2 : "right" === r && (_l19 += _ - _s11), e.fillText(_i190.text, _l19, n + _t175), _t175 -= _i190.height + (0 < _o65 ? 4 : 0);
        }

        return void e.restore();
      }

      var h = this.HTML5Renderer.alignTextInRect(a, n, i, o, p, g, r, l, s, d);
      a = h.x, n = h.y;
      var b = 2 * (s * Math.PI) / 360;
      e.translate(a, n), e.rotate(b);
      var v = 0,
          w = c.width;

      for (var _a113 = m.length - 1, _i191; 0 <= _a113; _a113--) {
        _i191 = 0, "center" === r ? _i191 += (w - m[_a113].width) / 2 : "right" === r && (_i191 += w - m[_a113].width), e.fillText(m[_a113].text, _i191, v), v -= m[_a113].height + 4;
      }

      e.restore();
    }
  }]);

  return _class11;
}()), Smart.Utilities.Assign("Plot",
/*#__PURE__*/
function () {
  "use strict";

  function _class12(e) {
    _classCallCheck(this, _class12);

    this.renderer = e;
  }

  _createClass(_class12, [{
    key: "get",
    value: function get(e, t, i) {
      return i === void 0 ? e[t] : e[t][i];
    }
  }, {
    key: "min",
    value: function min(e, t) {
      var a = NaN;

      for (var _n87 = 0, _i192; _n87 < e.length; _n87++) {
        _i192 = this.get(e, _n87, t), (isNaN(a) || _i192 < a) && (a = _i192);
      }

      return a;
    }
  }, {
    key: "max",
    value: function max(e, t) {
      var a = NaN;

      for (var _n88 = 0, _i193; _n88 < e.length; _n88++) {
        _i193 = this.get(e, _n88, t), (isNaN(a) || _i193 > a) && (a = _i193);
      }

      return a;
    }
  }, {
    key: "sum",
    value: function sum(e, t) {
      var a = 0;

      for (var _n89 = 0, _i194; _n89 < e.length; _n89++) {
        _i194 = this.get(e, _n89, t), isNaN(_i194) || (a += _i194);
      }

      return a;
    }
  }, {
    key: "count",
    value: function count(e, t) {
      var a = 0;

      for (var _n90 = 0, _i195; _n90 < e.length; _n90++) {
        _i195 = this.get(e, _n90, t), isNaN(_i195) || a++;
      }

      return a;
    }
  }, {
    key: "avg",
    value: function avg(e, t) {
      return this.sum(e, t) / Math.max(1, this.count(e, t));
    }
  }, {
    key: "filter",
    value: function filter(e, t) {
      if (!t) return e;
      var a = [];

      for (var _n91 = 0; _n91 < e.length; _n91++) {
        t(e[_n91]) && a.push(e[_n91]);
      }

      return a;
    }
  }, {
    key: "scale",
    value: function scale(e, t, i, a) {
      var n = Math.log,
          o = Math.min,
          r = Math.abs,
          l = Math.pow,
          s = Math.max;
      if (isNaN(e)) return NaN;
      if ((e < o(t.min, t.max) || e > s(t.min, t.max)) && (!a || !0 !== a.ignore_range)) return NaN;
      var d = NaN,
          c = 1;

      if (t.type === void 0 || "logarithmic" !== t.type) {
        var _i196 = r(t.max - t.min);

        _i196 || (_i196 = 1), c = r(e - o(t.min, t.max)) / _i196;
      } else if ("logarithmic" === t.type) {
        var _i197 = t.base;
        isNaN(_i197) && (_i197 = 10);

        var _a114 = o(t.min, t.max);

        0 >= _a114 && (_a114 = 1);

        var _d12 = s(t.min, t.max);

        0 >= _d12 && (_d12 = 1);
        var m = n(_d12) / n(_i197);
        _d12 = l(_i197, m);
        var u = n(_a114) / n(_i197);
        _a114 = l(_i197, u);
        var p = n(e) / n(_i197);
        c = r(p - u) / (m - u);
      }

      if ("logarithmic" === i.type) {
        var _e189 = i.base;
        isNaN(_e189) && (_e189 = 10);

        var _t176 = n(i.max) / n(_e189),
            _a115 = n(i.min) / n(_e189);

        i.flip && (c = 1 - c);

        var _s12 = o(_a115, _t176) + c * r(_t176 - _a115);

        d = l(_e189, _s12);
      } else d = o(i.min, i.max) + c * r(i.max - i.min), i.flip && (d = s(i.min, i.max) - d + i.min);

      return d;
    }
  }, {
    key: "axis",
    value: function axis(e, t, a) {
      var n = Math.round,
          o = Math.floor,
          r = Math.pow;
      if (1 >= a) return [t, e];
      (isNaN(a) || 2 > a) && (a = 2);
      var l = 0;

      for (; n(e) !== e && n(t) !== t && 10 > l;) {
        e *= 10, t *= 10, l++;
      }

      var s = (t - e) / a;

      for (; 10 > l && n(s) !== s;) {
        e *= 10, t *= 10, s *= 10, l++;
      }

      var d = [1, 2, 5],
          c = 0,
          m;

      for (;;) {
        var _e190 = c % d.length,
            _t177 = o(c / d.length),
            _i198 = r(10, _t177) * d[_e190];

        if (_e190 = (c + 1) % d.length, _t177 = o((c + 1) / d.length), m = r(10, _t177) * d[_e190], s >= _i198 && s < m) break;
        c++;
      }

      var u = m,
          p = [],
          g = this.renderer._rnd(e, u, !1),
          h = 0 >= l ? 1 : r(10, l);

      for (; g < t + u;) {
        p.push(g / h), g += u;
      }

      return p;
    }
  }]);

  return _class12;
}()), Smart.Utilities.Assign("DataExporter",
/*#__PURE__*/
function () {
  "use strict";

  function _class13(e, t, i, a) {
    _classCallCheck(this, _class13);

    var n = this;
    e || (e = {}), n.style = e.style, n.header = e.header, n.exportHeader = e.exportHeader || !0, n.hierarchical = e.hierarchical, n.expandChar = e.expandChar || "+", n.collapseChar = e.collapseChar || "-", n.pageOrientation = e.pageOrientation, !n.hierarchical && t && 0 < t.length ? n.groupBy = t : n.mergedCells = e.mergedCells, !n.groupBy && i && 0 < Object.keys(i).length && (n.filterBy = i), a && (n.conditionalFormatting = a), n.timeBetween1900And1970 = new Date(1970, 0, 1).getTime() - new Date(1900, 0, 1).getTime();
  }

  _createClass(_class13, [{
    key: "downloadFile",
    value: function downloadFile(e, t, i) {
      var n;
      if (!i) return e;
      if (n = e instanceof Blob ? e : new Blob([e], {
        type: t
      }), window.navigator.msSaveOrOpenBlob) window.navigator.msSaveOrOpenBlob(n, i);else {
        var _e191 = document.createElement("a"),
            _t178 = URL.createObjectURL(n);

        _e191.href = _t178, _e191.download = i, _e191.style.position = "absolute", _e191.style.visibility = "hidden", document.body.appendChild(_e191), _e191.click(), setTimeout(function () {
          document.body.removeChild(_e191), window.URL.revokeObjectURL(_t178);
        }, 0);
      }
    }
  }, {
    key: "exportData",
    value: function exportData(e, t, i, a) {
      var n = this;
      if (n.actualHierarchy = n.hierarchical, t = t.toLowerCase(), n.exportHeader && (n.header ? (e = e.slice(0), 0 === e.length && (n.actualHierarchy = !1), n.processComplexHeader(n.header, e, t)) : 1 === e.length && (n.actualHierarchy = !1)), 0 === e.length) return void console.warn("No data to export.");
      "xlsx" === t && (n.xlsxStartIndex = n.complexHeader ? n.complexHeader.length : +n.exportHeader), n.actualHierarchy && (e = n.processHierarchicalData(e, t)), n.getDatafields(e), i && i.slice(i.length - t.length - 1, i.length) !== "." + t && (i += "." + t);
      var o = null;
      return "csv" === t ? o = n.exportToCSVAndTSV(e, {
        delimiter: ", ",
        MIME: "text/csv",
        toRemove: 2
      }, i) : "html" === t ? o = n.exportToHTML(e, i) : "jpeg" === t || "png" === t ? n.exportToImage(e, i, t, a) : "json" === t ? o = n.exportToJSON(e, i) : "pdf" === t ? o = n.exportToPDF(e, i) : "tsv" === t ? o = n.exportToCSVAndTSV(e, {
        delimiter: "\t",
        MIME: "text/tab-separated-values",
        toRemove: 1
      }, i) : "xlsx" === t ? o = n.exportToXLSX(e, i) : "xml" === t ? o = n.exportToXML(e, i) : void 0, a && o && a(o), delete n.complexHeader, o;
    }
  }, {
    key: "exportToCSVAndTSV",
    value: function exportToCSVAndTSV(e, t, i) {
      var a = this,
          n = a.datafields;
      var o = "";

      for (var r = 0; r < e.length; r++) {
        var _i199 = e[r];
        var l = "";

        for (var _e192 = 0; _e192 < n.length; _e192++) {
          if (a.actualHierarchy && 0 == _e192) {
            l += ("\"\"" + t.delimiter).repeat(_i199._level - 1) + "\"" + _i199[n[_e192]] + "\"" + t.delimiter + ("\"\"" + t.delimiter).repeat(a.maxLevel - _i199._level);
            continue;
          }

          l += "\"" + _i199[n[_e192]] + "\"" + t.delimiter;
        }

        l = l.slice(0, l.length - t.toRemove) + "\n", o += l;
      }

      return this.downloadFile(o, t.MIME, i);
    }
  }, {
    key: "exportToHTML",
    value: function exportToHTML(e, t) {
      var a = this,
          i = a.datafields,
          n = a.style;
      var o = "",
          r = 0,
          l = "";

      if (e = a.processGroupingInformation(e), a.data = e, a.exportHeader && (o = a.getHTMLHeader(i, e), r = 1), arguments[2]) {
        var _e193 = Array.from(document.getElementsByTagName("script")),
            _t179 = _e193.find(function (e) {
          return -1 !== e.src.indexOf("html2canvas");
        });

        l = "<script type=\"text/javascript\" src=\"".concat(_t179.src, "\"></script>");
      }

      var s = "<!DOCTYPE html>\n<html>\n<head>\n    <meta charset=\"UTF-8\">\n    <style type=\"text/css\">\n".concat(a.getRowStyle()).concat(a.getColumnStyle(), "\n    </style>").concat(l).concat(a.toggleableFunctionality(), "\n</head>\n<body>\n    <table").concat(a.getTableStyle(), ">").concat(o, "\n        <tbody>\n");
      var d = {},
          c = {},
          m = [];
      a.getMergedCellsInfo(d, c);

      mainLoop: for (var _o66 = r; _o66 < e.length; _o66++) {
        var _l20 = e[_o66],
            u = _o66 - r;
        var p = a.getAlternationIndex(u, " rowN"),
            g = "",
            h = "",
            _ = "",
            f = 0;
        if (a.actualHierarchy) _l20._collapsed && (g = " collapsed"), h = " level=\"".concat(_l20._level, "\"");else if (a.groupBy) for (var _e194 = 0; _e194 < a.groupBy.length; _e194++) {
          var _t180 = a.groupBy[_e194],
              _i200 = _l20[_t180],
              _n92 = a.groups[_t180][_i200];

          if (_ += _i200, -1 === m.indexOf(_)) {
            s += "            <tr class=\"row\">\n                <td class=\"column group\" style=\"padding-left: ".concat(25 * f, "px;\" colspan=\"").concat(a.datafields.length, "\">").concat(_n92, "</td>\n            </tr>"), m.push(_), _o66--;
            continue mainLoop;
          }

          f++;
        }
        var b = "            <tr class=\"row row".concat(u).concat(p).concat(g, "\"").concat(h);
        t || (b += " style=\"page-break-inside: avoid;\""), b += ">\n";

        for (var _e195 = 0; _e195 < i.length; _e195++) {
          var _t181 = _e195 + "," + u;

          var _o67 = 1,
              _r31 = 1;
          if (d[_t181]) _o67 = d[_t181].colspan, _r31 = d[_t181].rowspan;else if (c[_t181]) continue;
          var _s13 = i[_e195];
          var _m7 = _l20[_s13],
              _p2 = "";

          if (a.actualHierarchy && 0 == _e195) {
            var _e196 = "";
            _l20._expanded ? _e196 = a.collapseChar : !1 === _l20._expanded && (_e196 = a.expandChar), _p2 = "<div class=\"toggle-element\" style=\"margin-left: ".concat(25 * (_l20._level - 1) + 5, "px;\" expanded>").concat(_e196, "</div>");
          }

          _m7 = a.getFormattedValue(_m7, _s13);
          var _g3 = "";

          if (n && n.columns && n.columns[_s13] && n.columns[_s13][u]) {
            var _e197 = n.columns[_s13][u];
            _g3 += "border-color: ".concat(_e197.border, "; background-color: ").concat(_e197.background, "; color: ").concat(_e197.color, ";\"");
          }

          0 == _e195 && 1 < f && (_g3 += "padding-left: ".concat(25 * (f - 1), "px;\"")), _g3 && (_g3 = " style=\"".concat(_g3, "\"")), b += "                <td class=\"column column".concat(_s13, "\"").concat(_g3, " colspan=\"").concat(_o67, "\" rowspan=\"").concat(_r31, "\">").concat(_p2 + _m7, "</td>\n");
        }

        s += b + "            </tr>\n";
      }

      return s += "        </tbody>\n    </table>\n</body>\n</html>", arguments[2] ? s : this.downloadFile(s, "text/html", t);
    }
  }, {
    key: "exportToImage",
    value: function exportToImage(e, t, i, a) {
      function n() {
        s.contentDocument.body && s.contentDocument.body.firstElementChild ? s.contentWindow.html2canvas(s.contentDocument.body.firstElementChild).then(function (e) {
          var n = new Smart.Utilities.Draw(document.createElement("div"));
          r = e.toDataURL("image/png"), a ? a(r) : (document.body.appendChild(e), n.exportImage(void 0, e, i, t)), s.remove(), e.remove();
        }) : requestAnimationFrame(n);
      }

      var o = this;

      try {
        html2canvas;
      } catch (e) {
        throw new Error("smart-grid: Missing reference to 'html2canvas.min.js'.");
      }

      var r = null;
      var l = o.exportToHTML(e, t, !0),
          s = document.createElement("iframe");
      return s.style.position = "absolute", s.style.top = 0, s.style.left = 0, s.style.border = "none", s.style.width = "100%", s.style.height = "100%", s.style.opacity = 0, document.body.appendChild(s), s.contentDocument.write(l), n(), r;
    }
  }, {
    key: "getMergedCellsInfo",
    value: function getMergedCellsInfo(e, t, i) {
      var a = this;

      if (a.mergedCells) {
        var _n93 = i && 0 !== i[a.datafields.length - 1];

        a.mergedCellsPDF = a.mergedCells.slice(0);

        for (var o = 0; o < a.mergedCellsPDF.length; o++) {
          var r = a.mergedCellsPDF[o];
          var l = r.colspan,
              s = r.rowspan;
          if (2 > s && 2 > l) continue;
          var d = r.cell[1];
          var c = r.cell[0];

          if (_n93 && 1 < l) {
            var _e198 = i[c],
                _t182 = i[c + l - 1],
                _n94 = [];

            if (_t182 > _e198) {
              var _o68 = _e198,
                  _r32 = c,
                  m = 0;

              mainLoop: for (var _a116 = _e198; _a116 <= _t182; _a116++) {
                var _e199 = _r32,
                    _t183 = 0;

                for (; i[_r32] === _o68;) {
                  if (_r32++, m++, _t183++, m === l) {
                    _n94.push({
                      start: _e199,
                      span: _t183
                    });

                    break mainLoop;
                  }
                }

                _n94.push({
                  start: _e199,
                  span: _t183
                }), _o68 = i[_r32];
              }

              l = _n94[0].span;

              for (var _e200 = 1; _e200 < _n94.length; _e200++) {
                a.mergedCellsPDF.push({
                  cell: [_n94[_e200].start, d],
                  colspan: _n94[_e200].span,
                  rowspan: s,
                  originalCell: c
                });
              }
            }
          }

          for (var _i201 = c; _i201 < c + l; _i201++) {
            for (var _a117 = d; _a117 < d + s; _a117++) {
              var _n95 = _i201 + "," + _a117;

              if (_i201 === c && _a117 === d) {
                e[_n95] = {
                  colspan: l,
                  rowspan: s,
                  originalCell: r.originalCell
                };
                continue;
              }

              t[_n95] = !0;
            }
          }
        }
      }
    }
  }, {
    key: "getAlternationIndex",
    value: function getAlternationIndex(e, t) {
      var i = this;
      if (!i.style) return "";
      var a = i.style.rows,
          n = a && a.alternationCount;
      return n && ((void 0 === a.alternationStart || e >= a.alternationStart) && (void 0 === a.alternationEnd || e <= a.alternationEnd) || a.alternationStart === a.alternationEnd) ? t + e % a.alternationCount : "";
    }
  }, {
    key: "getFormattedValue",
    value: function getFormattedValue(e, t) {
      var i = this,
          a = i.style;

      if (t && a && a.columns && a.columns[t] && a.columns[t].format) {
        if ("number" == typeof e) return i.formatNumber(e, a.columns[t].format);
        if (e instanceof Date) return i.formatDate(e, a.columns[t].format);
      } else if (e instanceof Date) return i.formatDate(e, "d");

      return e;
    }
  }, {
    key: "exportToJSON",
    value: function exportToJSON(e, t) {
      return this.downloadFile(JSON.stringify(e, this.datafields.concat("rows")), "application/json", t);
    }
  }, {
    key: "exportToPDF",
    value: function exportToPDF(e, t) {
      function a() {
        var e = [];

        for (var _t184 = 0; _t184 < g.length; _t184++) {
          e.push([]);
        }

        return e;
      }

      var o = this,
          i = o.datafields,
          r = +o.exportHeader,
          n = [],
          l = {},
          s = {},
          d = {},
          c = r ? o.complexHeader ? o.complexHeader.length : 1 : 0,
          m = {
        pageOrientation: o.pageOrientation || "portrait"
      };
      var u = [],
          p = [],
          g;
      e = o.processGroupingInformation(e), o.data = e, o.headerRows = c, o.getPDFStyle();
      var h = o.styleInfo;
      g = h ? o.wrapPDFColumns(m, d) : [{
        body: u,
        datafields: i
      }], r && (u = o.getPDFHeader(i, g, d)), o.getMergedCellsInfo(l, s, d);

      mainLoop: for (var _t185 = r; _t185 < e.length; _t185++) {
        var _c6 = e[_t185];
        var _m8 = "",
            _u2 = 0;
        if (o.groupBy) for (var _e201 = 0; _e201 < o.groupBy.length; _e201++) {
          var _i202 = o.groupBy[_e201],
              _a118 = _c6[_i202],
              _r33 = o.groups[_i202][_a118];

          if (_m8 += _a118, -1 === n.indexOf(_m8)) {
            o.createGroupHeaderRow(g, {
              text: _r33,
              style: ["row", "cell", "group"],
              marginLeft: 7.5 * _u2
            }), n.push(_m8), _t185--;
            continue mainLoop;
          }

          _u2++;
        }

        var _p3 = a(),
            _h2 = _t185 - r;

        var _ = o.getAlternationIndex(_h2, "");

        for (var _e202 = 0; _e202 < i.length; _e202++) {
          var _t186 = i[_e202],
              _a119 = {
            style: ["row", "row" + _h2, "cell", "cell" + _t186]
          },
              _n96 = d[_e202] || 0;

          if (void 0 !== _ && _a119.style.splice(1, 0, "rowN" + _), o.mergedCellsPDF) {
            var _t187 = _e202 + "," + _h2,
                _o69 = l[_t187];

            if (_o69) {
              if (_a119.colSpan = _o69.colspan, _a119.rowSpan = _o69.rowspan, void 0 !== _o69.originalCell) {
                _a119.text = "", _a119.style[_a119.style.length - 1] = "cell" + i[_o69.originalCell], _p3[_n96].push(_a119);
                continue;
              }
            } else if (s[_t187]) {
              _p3[_n96].push({});

              continue;
            }
          }

          var _r34 = o.getFormattedValue(_c6[_t186], _t186);

          _a119.text = _r34.toString(), o.getUniqueStylePDF(_a119, _t186, _h2), o.setIndentation(_a119, {
            j: _e202,
            currentRecord: _c6,
            value: _r34,
            outlineLevel: _u2
          }), _p3[_n96].push(_a119);
        }

        for (var _e203 = 0; _e203 < g.length; _e203++) {
          g[_e203].body.push(_p3[_e203]);
        }
      }

      if (h) {
        for (var _e204 = 0; _e204 < g.length; _e204++) {
          var _t188 = g[_e204].body;

          for (var _i203 = c - 1; 0 <= _i203; _i203--) {
            _t188.unshift(u[_e204][_i203]);
          }

          p.push({
            table: {
              headerRows: c,
              widths: g[_e204].widths,
              heights: function heights(e) {
                return h.heights[e] ? h.heights[e] : h.defaultHeight ? h.defaultHeight : void 0;
              },
              body: _t188
            },
            pageBreak: "after"
          });
        }

        delete p[g.length - 1].pageBreak, m.styles = h.styles;
      } else {
        var _e205 = g[0].body;

        for (var _t189 = c - 1; 0 <= _t189; _t189--) {
          _e205.unshift(u[0][_t189]);
        }

        p = [{
          table: {
            headerRows: c,
            body: _e205
          }
        }], m.styles = {
          header: {
            bold: !0
          },
          group: {
            bold: !0
          }
        };
      }

      m.content = p, pdfMake.createPdf(m).download(t), delete o.mergedCellsPDF, delete o.styleInfo;
    }
  }, {
    key: "getPDFStyle",
    value: function getPDFStyle() {
      function e(e, i) {
        if (e) for (var _n97 in e) {
          if (e.hasOwnProperty(_n97)) if (void 0 !== a[_n97]) for (var _a120 in e[_n97]) {
            if (!isNaN(_a120) || !e[_n97].hasOwnProperty(_a120)) continue;

            var _o70 = e[_n97][_a120],
                _r35 = t.datafields.indexOf(_n97);

            "width" == _a120 && "*" === l.widths[_r35] ? l.widths[_r35] = parseFloat(_o70) : t.storePDFStyle({
              prop: _a120,
              value: _o70,
              toUpdate: i + _n97
            });
          } else if ("height" == _n97 && "header" === i) for (var _a121 = 0; _a121 < t.headerRows; _a121++) {
            l.heights[_a121] = parseInt(e[_n97], 10) / t.headerRows / 1.57;
          } else t.storePDFStyle({
            prop: _n97,
            value: e[_n97],
            toUpdate: i
          });
        }
      }

      var t = this,
          i = t.style;
      if (!i) return "";
      var a = t.data[0],
          n = i.header,
          o = i.columns,
          r = i.rows,
          l = {
        heights: [],
        widths: Array(t.datafields.length).fill("*"),
        styles: {
          header: {},
          row: {},
          cell: {},
          group: {
            fillColor: "#FFFFFF",
            color: "#000000",
            bold: !0
          }
        }
      };

      if (t.styleInfo = l, e(n, "header"), e(o, "cell"), !!r) {
        for (var _e206 in r) {
          if (!r.hasOwnProperty(_e206) || -1 !== _e206.indexOf("alt")) continue;
          var _i204 = r[_e206];

          if (!isNaN(_e206)) {
            for (var _a122 in _i204) {
              _i204.hasOwnProperty(_a122) && ("height" == _a122 ? l.heights[parseFloat(_e206) + t.headerRows] = parseFloat(_i204[_a122]) / 1.57 : t.storePDFStyle({
                prop: _a122,
                value: _i204[_a122],
                toUpdate: "row" + _e206
              }));
            }

            continue;
          }

          "height" == _e206 ? l.defaultHeight = parseFloat(_i204) / 1.57 : t.storePDFStyle({
            prop: _e206,
            value: _i204,
            toUpdate: "row"
          });
        }

        if (r.alternationCount) for (var _e207 = 0; _e207 < r.alternationCount; _e207++) {
          var _t190 = {};
          r["alternationIndex".concat(_e207, "Color")] && (_t190.color = r["alternationIndex".concat(_e207, "Color")]), r["alternationIndex".concat(_e207, "BackgroundColor")] && (_t190.fillColor = r["alternationIndex".concat(_e207, "BackgroundColor")]), l.styles["rowN" + _e207] = _t190;
        }
      }
    }
  }, {
    key: "storePDFStyle",
    value: function storePDFStyle(e) {
      var t = this;
      var i = t.styleInfo.styles[e.toUpdate];
      i || (i = {}, t.styleInfo.styles[e.toUpdate] = i);
      var a = e.value;

      switch (e.prop) {
        case "backgroundColor":
          i.fillColor = a;
          break;

        case "color":
          i.color = a;
          break;

        case "fontSize":
          i.fontSize = parseFloat(a);
          break;

        case "fontStyle":
          "italic" === a && (i.italics = !0);
          break;

        case "fontWeight":
          "bold" === a && (i.bold = !0);
          break;

        case "textAlign":
          i.alignment = a;
      }
    }
  }, {
    key: "wrapPDFColumns",
    value: function wrapPDFColumns(e, t) {
      var a = this,
          n = this.styleInfo,
          o = "portrait" === e.pageOrientation ? 775 : 1155,
          r = [];
      var l = 0;

      for (var s = 0; s < n.widths.length; s++) {
        var _e208 = n.widths[s],
            _i205 = _e208;

        if ("*" === _e208 ? _i205 = 150 : _e208 >= o ? (_i205 = o, _e208 = "*") : _e208 /= 1.57, void 0 === r[l]) {
          r[l] = {
            body: [],
            width: _i205,
            widths: [_e208],
            datafields: [a.datafields[s]]
          }, t[s] = l;
          continue;
        }

        var d = r[l];

        if (d.width + _i205 > o) {
          l++, s--;
          continue;
        }

        t[s] = l, d.width += _i205, d.widths.push(_e208), d.datafields.push(a.datafields[s]);
      }

      return r;
    }
  }, {
    key: "getPDFHeader",
    value: function getPDFHeader(e, t, a) {
      function n(e, t, i) {
        for (var _a123 = 0; _a123 < r; _a123++) {
          var _n98 = e[_a123],
              _o71 = [];

          for (var _t191 = 0; _t191 < _n98.length; _t191++) {
            var _l21 = _n98[_t191];
            var _s14 = 1,
                _d13 = 1;

            if (_n98[_t191 - 1] && _n98[_t191 - 1] === _l21 || e[_a123 - 1] && e[_a123 - 1][_t191] === _l21) {
              _o71.push({});

              continue;
            }

            var c = _t191 + 1;

            for (; _n98[c] && _n98[c] === _n98[c - 1];) {
              _s14++, c++;
            }

            for (c = _a123 + 1; e[c] && e[c][_t191] === _l21;) {
              _d13++, c++;
            }

            var m = _a123 == r - 1 || _d13 + _a123 === r ? i.datafields[_t191] : null,
                u = {
              text: _l21,
              colSpan: _s14,
              rowSpan: _d13
            };
            m ? u.style = ["header", "header" + m] : (u.alignment = "center", u.style = "header"), _o71.push(u);
          }

          t.push(_o71);
        }
      }

      var i = this,
          o = [],
          r = i.headerRows,
          l = i.complexHeader ? i.complexHeader : [Object.values(i.data[0])],
          s = [];
      var d = [];

      for (var _n99 = 0; _n99 < r; _n99++) {
        var _e209 = l[_n99];

        for (var _t192 = 0, _i206; _t192 < _e209.length; _t192++) {
          _i206 = a[_t192] || 0, s[_i206] || (s[_i206] = []), s[_i206][_n99] || (s[_i206][_n99] = []), s[_i206][_n99].push(_e209[_t192]);
        }
      }

      for (var _r36 = 0; _r36 < t.length; _r36++) {
        d = [], n(s[_r36], d, t[_r36]), o.push(d);
      }

      return o;
    }
  }, {
    key: "createGroupHeaderRow",
    value: function createGroupHeaderRow(e, t) {
      for (var _a124 = 0; _a124 < e.length; _a124++) {
        var _i207 = Object.assign({}, t),
            _n100 = e[_a124].datafields.length,
            o = [_i207];

        _i207.colSpan = _n100, o.length = _n100, o.fill({}, 1, _n100 - 1), e[_a124].body.push(o);
      }
    }
  }, {
    key: "getUniqueStylePDF",
    value: function getUniqueStylePDF(e, t, i) {
      function a(e) {
        var t = /rgba\((\d+),(\d+),(\d+)\,(\d*.\d+|\d+)\)/gi.exec(e.replace(/\s/g, "")),
            i = parseFloat(t[1]).toString(16).toUpperCase(),
            a = parseFloat(t[2]).toString(16).toUpperCase(),
            n = parseFloat(t[3]).toString(16).toUpperCase();
        return "#" + "0".repeat(2 - i.length) + i + "0".repeat(2 - a.length) + a + "0".repeat(2 - n.length) + n;
      }

      var n = this.style;

      if (n && n.columns && n.columns[t]) {
        var o = n.columns[t][i];
        o && (e.fillColor = a(o.background), e.color = o.color.toLowerCase());
      }
    }
  }, {
    key: "setIndentation",
    value: function setIndentation(e, t) {
      if (0 === t.j) {
        var _i208 = this;

        if (_i208.actualHierarchy) {
          var _a125 = t.currentRecord;
          void 0 === _a125._expanded ? e.marginLeft = 25 * (_a125._level - 1) + 6 : (e.marginLeft = 25 * (_a125._level - 1), e.text = _i208.collapseChar + " " + t.value);
        } else 1 < t.outlineLevel && (e.marginLeft = 7.5 * (t.outlineLevel - 1));
      }
    }
  }, {
    key: "exportToXLSX",
    value: function exportToXLSX(e, t) {
      var i = this;
      var a = i.style;
      if (e = i.processGroupingInformation(e, !0), i.data = e, i.getColumnsArray(), i.complexHeaderMergedCells = [], i.complexHeaderMergeInfo) for (var _e210 in i.complexHeaderMergeInfo) {
        if (i.complexHeaderMergeInfo.hasOwnProperty(_e210)) {
          var _t193 = i.complexHeaderMergeInfo[_e210];
          if (_t193.from[0] === _t193.to[0] && _t193.from[1] === _t193.to[1]) continue;
          i.complexHeaderMergedCells.push({
            from: i.columnsArray[_t193.from[1]] + (_t193.from[0] + 1),
            to: i.columnsArray[_t193.to[1]] + (_t193.to[0] + 1)
          });
        }
      }
      i.getConditionalFormatting(), a || (a = i.generateDefaultStyle(e));

      var n = i.generateSharedStrings(e),
          o = n.collection,
          r = n.xml,
          l = i.generateStyles(a),
          s = i.groupBy ? i.generateSheet1WithGrouping(e, o) : i.generateSheet1(e, o),
          d = i.generateAuxiliaryFiles(),
          c = new JSZip(),
          m = c.folder("_rels"),
          u = c.folder("docProps"),
          p = c.folder("xl"),
          g = p.folder("_rels"),
          h = p.folder("theme"),
          _ = p.folder("worksheets");

      m.file(".rels", d._relsRels), u.file("app.xml", d.docPropsAppXml), u.file("core.xml", d.docPropsCoreXml), g.file("workbook.xml.rels", d.xl_relsWorkbookXmlRels), h.file("theme1.xml", d.xlThemeTheme1Xml), _.file("sheet1.xml", s), p.file("sharedStrings.xml", r), p.file("styles.xml", l), p.file("workbook.xml", d.xlWorkbookXml), c.file("[Content_Types].xml", d.Content_TypesXml), c.generateAsync({
        type: "blob",
        mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }).then(function (e) {
        return i.downloadFile(e, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", t);
      }), delete i.conditionalFormattingXLSX, delete i.complexHeaderMergeInfo, delete i.defaultRowHeight, delete i.rowHeight;
    }
  }, {
    key: "processGroupingInformation",
    value: function processGroupingInformation(e, t) {
      var i = this;
      if (!i.groupBy) return e;
      var a;

      if (e = e.slice(0), i.exportHeader && (t && i.complexHeader ? (a = e.slice(0, i.complexHeader.length), e.splice(0, i.complexHeader.length)) : (a = [e[0]], e.splice(0, 1))), 1 < e.length) {
        var _t194 = function _t194(e, t) {
          var i;

          switch (t || typeof e) {
            case "string":
              i = new Intl.Collator().compare;
              break;

            case "number":
              i = function i(e, t) {
                return e - t;
              };

              break;

            case "boolean":
            case "bool":
              i = function i(e, t) {
                return e === t ? 0 : !1 === e ? -1 : 1;
              };

              break;

            case "date":
            case "time":
            case "dateTime":
              e instanceof Date ? i = function i(e, t) {
                return e.getTime() - t.getTime();
              } : (e instanceof Smart.Utilities.DateTime || e instanceof Smart.Utilities.BigNumber) && (i = function i(e, t) {
                return e.compare(t);
              });
              break;

            case "object":
              if (e instanceof Date) i = function i(e, t) {
                return e.getTime() - t.getTime();
              };else if (e instanceof Smart.Utilities.DateTime || e instanceof Smart.Utilities.BigNumber) i = function i(e, t) {
                return e.compare(t);
              };else if (e instanceof Smart.Utilities.Complex || window.NIComplex && e instanceof window.NIComplex) {
                var _e211 = new Smart.Utilities.ComplexNumericProcessor();

                i = function (_i209) {
                  function i(_x, _x2) {
                    return _i209.apply(this, arguments);
                  }

                  i.toString = function () {
                    return _i209.toString();
                  };

                  return i;
                }(function (t, i) {
                  return _e211.compareComplexNumbers(t, i);
                });
              }
          }

          return i;
        };

        (function (e, n, a, i) {
          if (!e || !Array.isArray(e) || 0 === e.length || !n || Array.isArray(n) && 0 === n.length) return;
          "string" == typeof n && (n = [n]);
          var o = [],
              r = [];
          void 0 === a && (a = []);

          for (var l = 0; l < n.length; l++) {
            o[l] = void 0 === a[l] || "asc" === a[l] || "ascending" === a[l] ? 1 : -1, r[l] = _t194(e[0][n[l]]);
          }

          return i ? void i(e, n, a, r) : void e.sort(function (e, t) {
            for (var _a126 = 0; _a126 < n.length; _a126++) {
              var _i210 = r[_a126](e[n[_a126]], t[n[_a126]]);

              if (0 === _i210) {
                if (n[_a126 + 1]) continue;else if (void 0 !== e._index) return (e._index - t._index) * o[_a126];
                return 0;
              }

              return _i210 * o[_a126];
            }
          });
        })(e, i.groupBy);
      }

      return a && (e = a.concat(e)), i.getGroupLabels(e), e;
    }
  }, {
    key: "exportToXML",
    value: function exportToXML(e, t) {
      function i(e, t) {
        var n = "";

        for (var o = 0; o < e.length; o++) {
          var r = e[o];
          n += t + "<row>\n";

          for (var _e212 = 0; _e212 < a.length; _e212++) {
            var _o72 = a[_e212];

            if ("rows" === _o72) {
              if (!r.rows) continue;
              n += "".concat(t, "    <rows>\n").concat(i(r.rows, t + "        ")).concat(t, "    </rows>\n");
              continue;
            }

            n += t + "    <".concat(_o72, ">").concat(r[_o72], "</").concat(_o72, ">\n");
          }

          n += t + "</row>\n";
        }

        return n;
      }

      var a = this.datafields.slice(0);
      var n = "<?xml version=\"1.0\" encoding=\"UTF-8\" ?>\n<table>\n";
      return -1 === a.indexOf("rows") && a.push("rows"), n += i(e, "    ") + "</table>", this.downloadFile(n, "application/xml", t);
    }
  }, {
    key: "formatDate",
    value: function formatDate(t, e) {
      if (!Smart.Utilities.DateTime) return t;

      try {
        return new Smart.Utilities.DateTime(t).toString(e);
      } catch (i) {
        return t;
      }
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(e, t) {
      if (!Smart.Utilities.NumberRenderer) return e;
      var i = new Smart.Utilities.NumberRenderer(),
          a = i.formatNumber(e, t);
      return void 0 === a ? e : a;
    }
  }, {
    key: "generateAuxiliaryFiles",
    value: function generateAuxiliaryFiles() {
      var e = new Date().toISOString();
      return {
        _relsRels: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\"><Relationship Id=\"rId3\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties\" Target=\"docProps/app.xml\"/><Relationship Id=\"rId2\" Type=\"http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties\" Target=\"docProps/core.xml\"/><Relationship Id=\"rId1\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument\" Target=\"xl/workbook.xml\"/></Relationships>",
        docPropsAppXml: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<Properties xmlns=\"http://schemas.openxmlformats.org/officeDocument/2006/extended-properties\" xmlns:vt=\"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes\"><Application>Microsoft Excel</Application><DocSecurity>0</DocSecurity><ScaleCrop>false</ScaleCrop><HeadingPairs><vt:vector size=\"2\" baseType=\"variant\"><vt:variant><vt:lpstr>Worksheets</vt:lpstr></vt:variant><vt:variant><vt:i4>1</vt:i4></vt:variant></vt:vector></HeadingPairs><TitlesOfParts><vt:vector size=\"1\" baseType=\"lpstr\"><vt:lpstr>Sheet1</vt:lpstr></vt:vector></TitlesOfParts><Company></Company><LinksUpToDate>false</LinksUpToDate><SharedDoc>false</SharedDoc><HyperlinksChanged>false</HyperlinksChanged><AppVersion>16.0300</AppVersion></Properties>",
        docPropsCoreXml: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<cp:coreProperties xmlns:cp=\"http://schemas.openxmlformats.org/package/2006/metadata/core-properties\" xmlns:dc=\"http://purl.org/dc/elements/1.1/\" xmlns:dcterms=\"http://purl.org/dc/terms/\" xmlns:dcmitype=\"http://purl.org/dc/dcmitype/\" xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\"><dc:creator>Smart HTML Elements</dc:creator><cp:lastModifiedBy>Smart HTML Elements</cp:lastModifiedBy><dcterms:created xsi:type=\"dcterms:W3CDTF\">".concat(e, "</dcterms:created><dcterms:modified xsi:type=\"dcterms:W3CDTF\">").concat(e, "</dcterms:modified></cp:coreProperties>"),
        xl_relsWorkbookXmlRels: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\"><Relationship Id=\"rId3\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles\" Target=\"styles.xml\"/><Relationship Id=\"rId2\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme\" Target=\"theme/theme1.xml\"/><Relationship Id=\"rId1\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet\" Target=\"worksheets/sheet1.xml\"/><Relationship Id=\"rId4\" Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings\" Target=\"sharedStrings.xml\"/></Relationships>",
        xlThemeTheme1Xml: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<a:theme xmlns:a=\"http://schemas.openxmlformats.org/drawingml/2006/main\" name=\"Office Theme\"><a:themeElements><a:clrScheme name=\"Office\"><a:dk1><a:sysClr val=\"windowText\" lastClr=\"000000\"/></a:dk1><a:lt1><a:sysClr val=\"window\" lastClr=\"FFFFFF\"/></a:lt1><a:dk2><a:srgbClr val=\"44546A\"/></a:dk2><a:lt2><a:srgbClr val=\"E7E6E6\"/></a:lt2><a:accent1><a:srgbClr val=\"4472C4\"/></a:accent1><a:accent2><a:srgbClr val=\"ED7D31\"/></a:accent2><a:accent3><a:srgbClr val=\"A5A5A5\"/></a:accent3><a:accent4><a:srgbClr val=\"FFC000\"/></a:accent4><a:accent5><a:srgbClr val=\"5B9BD5\"/></a:accent5><a:accent6><a:srgbClr val=\"70AD47\"/></a:accent6><a:hlink><a:srgbClr val=\"0563C1\"/></a:hlink><a:folHlink><a:srgbClr val=\"954F72\"/></a:folHlink></a:clrScheme><a:fontScheme name=\"Office\"><a:majorFont><a:latin typeface=\"Calibri Light\" panose=\"020F0302020204030204\"/><a:ea typeface=\"\"/><a:cs typeface=\"\"/><a:font script=\"Jpan\" typeface=\"\u6E38\u30B4\u30B7\u30C3\u30AF Light\"/><a:font script=\"Hang\" typeface=\"\uB9D1\uC740 \uACE0\uB515\"/><a:font script=\"Hans\" typeface=\"\u7B49\u7EBF Light\"/><a:font script=\"Hant\" typeface=\"\u65B0\u7D30\u660E\u9AD4\"/><a:font script=\"Arab\" typeface=\"Times New Roman\"/><a:font script=\"Hebr\" typeface=\"Times New Roman\"/><a:font script=\"Thai\" typeface=\"Tahoma\"/><a:font script=\"Ethi\" typeface=\"Nyala\"/><a:font script=\"Beng\" typeface=\"Vrinda\"/><a:font script=\"Gujr\" typeface=\"Shruti\"/><a:font script=\"Khmr\" typeface=\"MoolBoran\"/><a:font script=\"Knda\" typeface=\"Tunga\"/><a:font script=\"Guru\" typeface=\"Raavi\"/><a:font script=\"Cans\" typeface=\"Euphemia\"/><a:font script=\"Cher\" typeface=\"Plantagenet Cherokee\"/><a:font script=\"Yiii\" typeface=\"Microsoft Yi Baiti\"/><a:font script=\"Tibt\" typeface=\"Microsoft Himalaya\"/><a:font script=\"Thaa\" typeface=\"MV Boli\"/><a:font script=\"Deva\" typeface=\"Mangal\"/><a:font script=\"Telu\" typeface=\"Gautami\"/><a:font script=\"Taml\" typeface=\"Latha\"/><a:font script=\"Syrc\" typeface=\"Estrangelo Edessa\"/><a:font script=\"Orya\" typeface=\"Kalinga\"/><a:font script=\"Mlym\" typeface=\"Kartika\"/><a:font script=\"Laoo\" typeface=\"DokChampa\"/><a:font script=\"Sinh\" typeface=\"Iskoola Pota\"/><a:font script=\"Mong\" typeface=\"Mongolian Baiti\"/><a:font script=\"Viet\" typeface=\"Times New Roman\"/><a:font script=\"Uigh\" typeface=\"Microsoft Uighur\"/><a:font script=\"Geor\" typeface=\"Sylfaen\"/><a:font script=\"Armn\" typeface=\"Arial\"/><a:font script=\"Bugi\" typeface=\"Leelawadee UI\"/><a:font script=\"Bopo\" typeface=\"Microsoft JhengHei\"/><a:font script=\"Java\" typeface=\"Javanese Text\"/><a:font script=\"Lisu\" typeface=\"Segoe UI\"/><a:font script=\"Mymr\" typeface=\"Myanmar Text\"/><a:font script=\"Nkoo\" typeface=\"Ebrima\"/><a:font script=\"Olck\" typeface=\"Nirmala UI\"/><a:font script=\"Osma\" typeface=\"Ebrima\"/><a:font script=\"Phag\" typeface=\"Phagspa\"/><a:font script=\"Syrn\" typeface=\"Estrangelo Edessa\"/><a:font script=\"Syrj\" typeface=\"Estrangelo Edessa\"/><a:font script=\"Syre\" typeface=\"Estrangelo Edessa\"/><a:font script=\"Sora\" typeface=\"Nirmala UI\"/><a:font script=\"Tale\" typeface=\"Microsoft Tai Le\"/><a:font script=\"Talu\" typeface=\"Microsoft New Tai Lue\"/><a:font script=\"Tfng\" typeface=\"Ebrima\"/></a:majorFont><a:minorFont><a:latin typeface=\"Calibri\" panose=\"020F0502020204030204\"/><a:ea typeface=\"\"/><a:cs typeface=\"\"/><a:font script=\"Jpan\" typeface=\"\u6E38\u30B4\u30B7\u30C3\u30AF\"/><a:font script=\"Hang\" typeface=\"\uB9D1\uC740 \uACE0\uB515\"/><a:font script=\"Hans\" typeface=\"\u7B49\u7EBF\"/><a:font script=\"Hant\" typeface=\"\u65B0\u7D30\u660E\u9AD4\"/><a:font script=\"Arab\" typeface=\"Arial\"/><a:font script=\"Hebr\" typeface=\"Arial\"/><a:font script=\"Thai\" typeface=\"Tahoma\"/><a:font script=\"Ethi\" typeface=\"Nyala\"/><a:font script=\"Beng\" typeface=\"Vrinda\"/><a:font script=\"Gujr\" typeface=\"Shruti\"/><a:font script=\"Khmr\" typeface=\"DaunPenh\"/><a:font script=\"Knda\" typeface=\"Tunga\"/><a:font script=\"Guru\" typeface=\"Raavi\"/><a:font script=\"Cans\" typeface=\"Euphemia\"/><a:font script=\"Cher\" typeface=\"Plantagenet Cherokee\"/><a:font script=\"Yiii\" typeface=\"Microsoft Yi Baiti\"/><a:font script=\"Tibt\" typeface=\"Microsoft Himalaya\"/><a:font script=\"Thaa\" typeface=\"MV Boli\"/><a:font script=\"Deva\" typeface=\"Mangal\"/><a:font script=\"Telu\" typeface=\"Gautami\"/><a:font script=\"Taml\" typeface=\"Latha\"/><a:font script=\"Syrc\" typeface=\"Estrangelo Edessa\"/><a:font script=\"Orya\" typeface=\"Kalinga\"/><a:font script=\"Mlym\" typeface=\"Kartika\"/><a:font script=\"Laoo\" typeface=\"DokChampa\"/><a:font script=\"Sinh\" typeface=\"Iskoola Pota\"/><a:font script=\"Mong\" typeface=\"Mongolian Baiti\"/><a:font script=\"Viet\" typeface=\"Arial\"/><a:font script=\"Uigh\" typeface=\"Microsoft Uighur\"/><a:font script=\"Geor\" typeface=\"Sylfaen\"/><a:font script=\"Armn\" typeface=\"Arial\"/><a:font script=\"Bugi\" typeface=\"Leelawadee UI\"/><a:font script=\"Bopo\" typeface=\"Microsoft JhengHei\"/><a:font script=\"Java\" typeface=\"Javanese Text\"/><a:font script=\"Lisu\" typeface=\"Segoe UI\"/><a:font script=\"Mymr\" typeface=\"Myanmar Text\"/><a:font script=\"Nkoo\" typeface=\"Ebrima\"/><a:font script=\"Olck\" typeface=\"Nirmala UI\"/><a:font script=\"Osma\" typeface=\"Ebrima\"/><a:font script=\"Phag\" typeface=\"Phagspa\"/><a:font script=\"Syrn\" typeface=\"Estrangelo Edessa\"/><a:font script=\"Syrj\" typeface=\"Estrangelo Edessa\"/><a:font script=\"Syre\" typeface=\"Estrangelo Edessa\"/><a:font script=\"Sora\" typeface=\"Nirmala UI\"/><a:font script=\"Tale\" typeface=\"Microsoft Tai Le\"/><a:font script=\"Talu\" typeface=\"Microsoft New Tai Lue\"/><a:font script=\"Tfng\" typeface=\"Ebrima\"/></a:minorFont></a:fontScheme><a:fmtScheme name=\"Office\"><a:fillStyleLst><a:solidFill><a:schemeClr val=\"phClr\"/></a:solidFill><a:gradFill rotWithShape=\"1\"><a:gsLst><a:gs pos=\"0\"><a:schemeClr val=\"phClr\"><a:lumMod val=\"110000\"/><a:satMod val=\"105000\"/><a:tint val=\"67000\"/></a:schemeClr></a:gs><a:gs pos=\"50000\"><a:schemeClr val=\"phClr\"><a:lumMod val=\"105000\"/><a:satMod val=\"103000\"/><a:tint val=\"73000\"/></a:schemeClr></a:gs><a:gs pos=\"100000\"><a:schemeClr val=\"phClr\"><a:lumMod val=\"105000\"/><a:satMod val=\"109000\"/><a:tint val=\"81000\"/></a:schemeClr></a:gs></a:gsLst><a:lin ang=\"5400000\" scaled=\"0\"/></a:gradFill><a:gradFill rotWithShape=\"1\"><a:gsLst><a:gs pos=\"0\"><a:schemeClr val=\"phClr\"><a:satMod val=\"103000\"/><a:lumMod val=\"102000\"/><a:tint val=\"94000\"/></a:schemeClr></a:gs><a:gs pos=\"50000\"><a:schemeClr val=\"phClr\"><a:satMod val=\"110000\"/><a:lumMod val=\"100000\"/><a:shade val=\"100000\"/></a:schemeClr></a:gs><a:gs pos=\"100000\"><a:schemeClr val=\"phClr\"><a:lumMod val=\"99000\"/><a:satMod val=\"120000\"/><a:shade val=\"78000\"/></a:schemeClr></a:gs></a:gsLst><a:lin ang=\"5400000\" scaled=\"0\"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w=\"6350\" cap=\"flat\" cmpd=\"sng\" algn=\"ctr\"><a:solidFill><a:schemeClr val=\"phClr\"/></a:solidFill><a:prstDash val=\"solid\"/><a:miter lim=\"800000\"/></a:ln><a:ln w=\"12700\" cap=\"flat\" cmpd=\"sng\" algn=\"ctr\"><a:solidFill><a:schemeClr val=\"phClr\"/></a:solidFill><a:prstDash val=\"solid\"/><a:miter lim=\"800000\"/></a:ln><a:ln w=\"19050\" cap=\"flat\" cmpd=\"sng\" algn=\"ctr\"><a:solidFill><a:schemeClr val=\"phClr\"/></a:solidFill><a:prstDash val=\"solid\"/><a:miter lim=\"800000\"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst/></a:effectStyle><a:effectStyle><a:effectLst/></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad=\"57150\" dist=\"19050\" dir=\"5400000\" algn=\"ctr\" rotWithShape=\"0\"><a:srgbClr val=\"000000\"><a:alpha val=\"63000\"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val=\"phClr\"/></a:solidFill><a:solidFill><a:schemeClr val=\"phClr\"><a:tint val=\"95000\"/><a:satMod val=\"170000\"/></a:schemeClr></a:solidFill><a:gradFill rotWithShape=\"1\"><a:gsLst><a:gs pos=\"0\"><a:schemeClr val=\"phClr\"><a:tint val=\"93000\"/><a:satMod val=\"150000\"/><a:shade val=\"98000\"/><a:lumMod val=\"102000\"/></a:schemeClr></a:gs><a:gs pos=\"50000\"><a:schemeClr val=\"phClr\"><a:tint val=\"98000\"/><a:satMod val=\"130000\"/><a:shade val=\"90000\"/><a:lumMod val=\"103000\"/></a:schemeClr></a:gs><a:gs pos=\"100000\"><a:schemeClr val=\"phClr\"><a:shade val=\"63000\"/><a:satMod val=\"120000\"/></a:schemeClr></a:gs></a:gsLst><a:lin ang=\"5400000\" scaled=\"0\"/></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults/><a:extraClrSchemeLst/><a:extLst><a:ext uri=\"{05A4C25C-085E-4340-85A3-A5531E510DB2}\"><thm15:themeFamily xmlns:thm15=\"http://schemas.microsoft.com/office/thememl/2012/main\" name=\"Office Theme\" id=\"{62F939B6-93AF-4DB8-9C6B-D6C7DFDC589F}\" vid=\"{4A3C46E8-61CC-4603-A589-7422A47A8E4A}\"/></a:ext></a:extLst></a:theme>",
        xlWorkbookXml: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<workbook xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:r=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\" xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\" mc:Ignorable=\"x15 xr xr6 xr10 xr2\" xmlns:x15=\"http://schemas.microsoft.com/office/spreadsheetml/2010/11/main\" xmlns:xr=\"http://schemas.microsoft.com/office/spreadsheetml/2014/revision\" xmlns:xr6=\"http://schemas.microsoft.com/office/spreadsheetml/2016/revision6\" xmlns:xr10=\"http://schemas.microsoft.com/office/spreadsheetml/2016/revision10\" xmlns:xr2=\"http://schemas.microsoft.com/office/spreadsheetml/2015/revision2\"><fileVersion appName=\"xl\" lastEdited=\"7\" lowestEdited=\"7\" rupBuild=\"20325\"/><workbookPr defaultThemeVersion=\"166925\"/><mc:AlternateContent xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\"><mc:Choice Requires=\"x15\"><x15ac:absPath url=\"C:UsersjqwidgetsDesktop\" xmlns:x15ac=\"http://schemas.microsoft.com/office/spreadsheetml/2010/11/ac\"/></mc:Choice></mc:AlternateContent><xr:revisionPtr revIDLastSave=\"0\" documentId=\"13_ncr:1_{0DEDCB6D-5403-4CD8-AAA5-59B6D238A8B6}\" xr6:coauthVersionLast=\"34\" xr6:coauthVersionMax=\"34\" xr10:uidLastSave=\"{00000000-0000-0000-0000-000000000000}\"/><bookViews><workbookView xWindow=\"0\" yWindow=\"0\" windowWidth=\"19200\" windowHeight=\"6950\" xr2:uid=\"{0CB664E6-3800-4A88-B158-B46A682E7484}\"/></bookViews><sheets><sheet name=\"Sheet1\" sheetId=\"1\" r:id=\"rId1\"/></sheets><calcPr calcId=\"179021\"/><extLst><ext uri=\"{140A7094-0E35-4892-8432-C4D2E57EDEB5}\" xmlns:x15=\"http://schemas.microsoft.com/office/spreadsheetml/2010/11/main\"><x15:workbookPr chartTrackingRefBase=\"1\"/></ext></extLst></workbook>",
        Content_TypesXml: "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<Types xmlns=\"http://schemas.openxmlformats.org/package/2006/content-types\"><Default Extension=\"bin\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings\"/><Default Extension=\"rels\" ContentType=\"application/vnd.openxmlformats-package.relationships+xml\"/><Default Extension=\"xml\" ContentType=\"application/xml\"/><Override PartName=\"/xl/workbook.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml\"/><Override PartName=\"/xl/worksheets/sheet1.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml\"/><Override PartName=\"/xl/theme/theme1.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.theme+xml\"/><Override PartName=\"/xl/styles.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml\"/><Override PartName=\"/xl/sharedStrings.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml\"/><Override PartName=\"/docProps/core.xml\" ContentType=\"application/vnd.openxmlformats-package.core-properties+xml\"/><Override PartName=\"/docProps/app.xml\" ContentType=\"application/vnd.openxmlformats-officedocument.extended-properties+xml\"/></Types>"
      };
    }
  }, {
    key: "generateDefaultStyle",
    value: function generateDefaultStyle(e) {
      var t = this,
          a = {},
          n = t.datafields,
          o = t.complexHeader ? e[t.complexHeader.length] : e[+t.exportHeader];
      if (!o) return a;

      for (var _t195 = 0; _t195 < n.length; _t195++) {
        var _e213 = o[n[_t195]];
        _e213 instanceof Date && (!a.columns && (a.columns = []), a.columns[n[_t195]] = {
          format: "d"
        });
      }

      return a;
    }
  }, {
    key: "generateGroupRow",
    value: function generateGroupRow(e) {
      var t = e.rowNumber,
          i = "A" + t,
          a = "        <row r=\"".concat(t, "\" outlineLevel=\"").concat(e.outlineLevel, "\" spans=\"1:").concat(e.numberOfColumns, "\"").concat(this.getCustomRowHeight(t - 1), " x14ac:dyDescent=\"0.45\">\n            <c r=\"").concat(i, "\" t=\"s\" s=\"0\">\n                <v>").concat(e.sharedStringIndex, "</v>\n            </c>\n        </row>\n");
      return e.mergedCells.push({
        from: i,
        to: this.columnsArray[e.numberOfColumns - 1] + t
      }), a;
    }
  }, {
    key: "generateSharedStrings",
    value: function generateSharedStrings(e) {
      function t(e) {
        r++, -1 === n.indexOf(e) && (l++, n.push(e), o += "<si><t>".concat(e, "</t></si>"));
      }

      var a = this,
          i = a.datafields,
          n = [];
      var o = "",
          r = 0,
          l = 0;

      for (var _a127 = 0; _a127 < e.length; _a127++) {
        var _n101 = e[_a127];

        for (var _e214 = 0, _a128; _e214 < i.length; _e214++) {
          (_a128 = _n101[i[_e214]], "string" == typeof _a128) && t(_a128);
        }
      }

      if (a.groupLabels) for (var _e215 = 0; _e215 < a.groupLabels.length; _e215++) {
        t(a.groupLabels[_e215]);
      }
      return o = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<sst xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" count=\"".concat(r, "\" uniqueCount=\"").concat(l, "\">").concat(o, "</sst>"), {
        collection: n,
        xml: o
      };
    }
  }, {
    key: "generateSheet1",
    value: function generateSheet1(e, t) {
      function i(e, t) {
        return a.columnsArray[e] + t;
      }

      var a = this,
          n = a.columnsArray.length,
          o = e.length,
          r = a.columnsArray[n - 1] + o,
          l = a.datafields,
          s = a.getFilters(),
          d = [].concat(a.complexHeaderMergedCells);
      var c = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<worksheet xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:r=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\" xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\" mc:Ignorable=\"x14ac xr xr2 xr3\" xmlns:x14ac=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\" xmlns:xr=\"http://schemas.microsoft.com/office/spreadsheetml/2014/revision\" xmlns:xr2=\"http://schemas.microsoft.com/office/spreadsheetml/2015/revision2\" xmlns:xr3=\"http://schemas.microsoft.com/office/spreadsheetml/2016/revision3\" xr:uid=\"{7F25248B-C640-4C64-AD47-C0EA0E5D90D0}\">\n    <sheetPr filterMode=\"".concat("" !== s, "\" />\n    <dimension ref=\"A1:").concat(r, "\" />\n    <sheetViews>\n        <sheetView tabSelected=\"1\" workbookViewId=\"0\" />\n    </sheetViews>\n    <sheetFormatPr defaultRowHeight=\"14.5\" x14ac:dyDescent=\"0.35\" />").concat(a.getCustomColumnWidths(), "\n    <sheetData>\n");

      for (var _o73 = 0; _o73 <= e.length; _o73++) {
        var _r37 = e[_o73],
            _d14 = _o73 + 1;

        var _s15 = "";

        if (a.actualHierarchy) {
          var _t196 = e[_o73 - 1];
          _t196 && _t196._collapsed && (!_r37 || _t196._level > _r37._level) && (_s15 = " collapsed=\"true\"");
        }

        if (_o73 === e.length) {
          _s15 && (c += "        <row r=\"".concat(_d14, "\" outlineLevel=\"").concat(Math.max(e[_o73 - 1]._level - 2, 0), "\" hidden=\"false\" collapsed=\"true\" />\n"));
          break;
        }

        var m = "        <row r=\"".concat(_d14, "\"").concat(a.getOutlineLevel(_r37), " hidden=\"").concat(_r37._hidden || _r37._collapsed || !1, "\"").concat(_s15, " spans=\"1:").concat(n, "\"").concat(a.getCustomRowHeight(_d14 - 1), " x14ac:dyDescent=\"0.45\">\n");

        for (var _e216 = 0; _e216 < l.length; _e216++) {
          var _n102 = a.getXLSXCellStyle(i(_e216, _d14));

          m += a.getActualCellData(_r37[l[_e216]], {
            r: i(_e216, _d14),
            s: _n102
          }, t);
        }

        m += "        </row>\n", c += m;
      }

      return c += "    </sheetData>".concat(a.conditionalFormattingXLSX.conditions).concat(s).concat(a.getMergedCells(d), "\n    <pageMargins left=\"0.7\" right=\"0.7\" top=\"0.75\" bottom=\"0.75\" header=\"0.3\" footer=\"0.3\" />\n    <pageSetup paperSize=\"9\" orientation=\"portrait\" r:id=\"rId1\" />\n</worksheet>"), c;
    }
  }, {
    key: "generateSheet1WithGrouping",
    value: function generateSheet1WithGrouping(e, t) {
      function a(e, t) {
        return n.columnsArray[e] + t;
      }

      var n = this,
          o = n.columnsArray.length,
          i = e.length,
          r = n.columnsArray[o - 1] + i,
          l = n.datafields,
          s = [].concat(n.complexHeaderMergedCells);
      var d = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<worksheet xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:r=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships\" xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\" mc:Ignorable=\"x14ac xr xr2 xr3\" xmlns:x14ac=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\" xmlns:xr=\"http://schemas.microsoft.com/office/spreadsheetml/2014/revision\" xmlns:xr2=\"http://schemas.microsoft.com/office/spreadsheetml/2015/revision2\" xmlns:xr3=\"http://schemas.microsoft.com/office/spreadsheetml/2016/revision3\" xr:uid=\"{7F25248B-C640-4C64-AD47-C0EA0E5D90D0}\">\n    <dimension ref=\"A1:".concat(r, "\" />\n    <sheetViews>\n        <sheetView tabSelected=\"1\" workbookViewId=\"0\" />\n    </sheetViews>\n    <sheetFormatPr defaultRowHeight=\"14.5\" x14ac:dyDescent=\"0.35\" />").concat(n.getCustomColumnWidths(), "\n    <sheetData>\n"),
          c = 0,
          m = [];

      mainLoop: for (var _r38 = 0; _r38 < e.length; _r38++) {
        var _i211 = e[_r38],
            u = _r38 + 1 + c;
        var p = 0,
            g = "";

        if (!n.exportHeader || !n.complexHeader && 0 != _r38 || n.complexHeader && _r38 >= n.complexHeader.length) {
          var _e217 = "";

          for (var _a129 = 0; _a129 < n.groupBy.length; _a129++) {
            var _l22 = n.groupBy[_a129],
                _g4 = _i211[_l22],
                _h3 = n.groups[_l22][_g4];

            if (_e217 += _g4, -1 === m.indexOf(_e217)) {
              var _i212 = t.indexOf(_h3);

              d += n.generateGroupRow({
                rowNumber: u,
                outlineLevel: p,
                numberOfColumns: o,
                sharedStringIndex: _i212,
                mergedCells: s
              }), m.push(_e217), _r38--, c++;
              continue mainLoop;
            }

            p++;
          }

          g = " outlineLevel=\"".concat(p, "\"");
        }

        var h = "        <row r=\"".concat(u, "\"").concat(g, " spans=\"1:").concat(o, "\"").concat(n.getCustomRowHeight(u - 1), " x14ac:dyDescent=\"0.45\">\n");

        for (var _e218 = 0; _e218 < l.length; _e218++) {
          var _o74 = n.getXLSXCellStyle(a(_e218, _r38 + 1));

          h += n.getActualCellData(_i211[l[_e218]], {
            r: a(_e218, u),
            s: _o74
          }, t);
        }

        h += "        </row>\n", d += h;
      }

      return d += "    </sheetData>".concat(n.getMergedCells(s), "\n    <pageMargins left=\"0.7\" right=\"0.7\" top=\"0.75\" bottom=\"0.75\" header=\"0.3\" footer=\"0.3\" />\n    <pageSetup paperSize=\"9\" orientation=\"portrait\" r:id=\"rId1\" />\n</worksheet>"), d;
    }
  }, {
    key: "getActualCellData",
    value: function getActualCellData(e, t, i) {
      var a = t.r,
          n = t.s || " s=\"0\"";
      if ("string" == typeof e) return "            <c r=\"".concat(a, "\" t=\"s\"").concat(n, ">\n                <v>").concat(i.indexOf(e), "</v>\n            </c>\n");
      if ("boolean" == typeof e) return "            <c r=\"".concat(a, "\" t=\"b\"").concat(n, ">\n                <v>").concat(+e, "</v>\n            </c>\n");

      if (e instanceof Date) {
        var _t197 = (e.getTime() + this.timeBetween1900And1970) / 864e5 + 2;

        return "            <c r=\"".concat(a, "\"").concat(n, ">\n                <v>").concat(_t197, "</v>\n            </c>\n");
      }

      return "            <c r=\"".concat(a, "\"").concat(n, ">\n                <v>").concat(e, "</v>\n            </c>\n");
    }
  }, {
    key: "getColumnsArray",
    value: function getColumnsArray() {
      function e(e) {
        return 26 > e ? "" : t(64 + Math.floor(e / 26));
      }

      var t = String.fromCharCode;
      var i = this,
          a = i.datafields.length,
          n = [];

      for (var o = 0; o < a; o++) {
        n.push(e(o) + t(65 + (26 > o ? o : o % 26)));
      }

      i.columnsArray = n;
    }
  }, {
    key: "getColumnStyle",
    value: function getColumnStyle() {
      var e = this,
          t = e.style;
      if (!t) return "        .header { border: 1px solid black; padding: 5px; }\n        .column { border: 1px solid black; padding: 5px; }\n        .group { background-color: #FFFFFF; color: #000000; font-weight: bold; }";
      var i = {
        header: "border: 1px solid black; padding: 5px; ",
        column: "white-space: nowrap; overflow: hidden; border: 1px solid black; padding: 5px; ",
        group: "background-color: #FFFFFF; color: #000000; font-weight: bold; "
      },
          a = e.data[0];
      var n = "";
      var o = t.header || {};

      for (var _t198 in o) {
        if (!o.hasOwnProperty(_t198)) continue;
        var _n103 = o[_t198];

        if (a[_t198]) {
          for (var _e219 in i["header" + _t198] || (i["header" + _t198] = ""), _n103) {
            if (_n103.hasOwnProperty(_e219)) {
              var _a130 = Smart.Utilities.Core.toDash(_e219) + ": " + _n103[_e219] + "; ";

              i["header" + _t198] += _a130, "width" == _e219 && (!i["column" + _t198] && (i["column" + _t198] = ""), i["column" + _t198] += _a130);
            }
          }

          continue;
        }

        i.header += "height" == _t198 && e.complexHeader ? "height: " + parseInt(o[_t198], 10) / e.complexHeader.length + "px; " : Smart.Utilities.Core.toDash(_t198) + ": " + o[_t198] + "; ";
      }

      var r = t.columns || {};

      for (var _e220 in r) {
        if (!r.hasOwnProperty(_e220)) continue;
        var _t199 = r[_e220];

        if (a[_e220]) {
          for (var _a131 in i["column" + _e220] || (i["column" + _e220] = ""), _t199) {
            isNaN(_a131) && _t199.hasOwnProperty(_a131) && "format" != _a131 && (i["column" + _e220] += Smart.Utilities.Core.toDash(_a131) + ": " + _t199[_a131] + "; ");
          }

          continue;
        }

        i.column += Smart.Utilities.Core.toDash(_e220) + ": " + _t199 + "; ";
      }

      for (var _e221 in i) {
        i.hasOwnProperty(_e221) && (n += "        .".concat(_e221, " { ").concat(i[_e221], "}\n"));
      }

      return n;
    }
  }, {
    key: "getCustomColumnWidths",
    value: function getCustomColumnWidths() {
      var e = this;
      if (!e.style || !e.columnWidth || 0 === e.columnWidth.length) return "";
      var t = "\n    <cols>\n";

      for (var _a132 = 0, _i213; _a132 < e.columnWidth.length; _a132++) {
        _i213 = e.columnWidth[_a132], void 0 !== _i213 && (_i213 = Math.round(parseFloat(_i213)) / 11, t += "        <col min=\"".concat(_a132 + 1, "\" max=\"").concat(_a132 + 1, "\" width=\"").concat(_i213, "\" customWidth=\"1\" />\n"));
      }

      return t += "    </cols>", t;
    }
  }, {
    key: "getCustomFilter",
    value: function getCustomFilter(e, t) {
      var i = "equal",
          a;
      return e instanceof Date && (e = (e.getTime() + this.timeBetween1900And1970) / 864e5 + 2), t = t.toUpperCase(), ("EMPTY" === t ? a = "" : "NOT_EMPTY" === t ? (a = "", i = "notEqual") : "CONTAINS" === t || "CONTAINS_CASE_SENSITIVE" === t ? a = "*".concat(e, "*") : "DOES_NOT_CONTAIN" === t || "DOES_NOT_CONTAIN_CASE_SENSITIVE" === t ? (a = "*".concat(e, "*"), i = "notEqual") : "STARTS_WITH" === t || "STARTS_WITH_CASE_SENSITIVE" === t ? a = "".concat(e, "*") : "ENDS_WITH" === t || "ENDS_WITH_CASE_SENSITIVE" === t ? a = "*".concat(e) : "EQUAL" === t || "EQUAL_CASE_SENSITIVE" === t ? a = e : "NULL" === t ? a = null : "NOT_NULL" === t ? (a = null, i = "notEqual") : "NOT_EQUAL" === t ? (a = e, i = "notEqual") : "LESS_THAN" === t ? (a = e, i = "lessThan") : "LESS_THAN_OR_EQUAL" === t ? (a = e, i = "lessThanOrEqual") : "GREATER_THAN" === t ? (a = e, i = "greaterThan") : "GREATER_THAN_OR_EQUAL" === t ? (a = e, i = "greaterThanOrEqual") : void 0, "                <customFilter val=\"".concat(a, "\" operator=\"").concat(i, "\"/>\n"));
    }
  }, {
    key: "getCustomRowHeight",
    value: function getCustomRowHeight(e) {
      var t = this;
      return t.style ? t.rowHeight[e] || t.defaultRowHeight || "" : "";
    }
  }, {
    key: "getDatafields",
    value: function getDatafields(e) {
      var t = this,
          i = e[0],
          a = [];

      for (var _t200 in i) {
        i.hasOwnProperty(_t200) && "_" !== _t200.charAt(0) && a.push(_t200);
      }

      t.datafields = a;
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      var e = this,
          t = e.filterBy;
      if (!t) return "";
      var a = "";

      for (var _i214 in t) {
        if (t.hasOwnProperty(_i214)) {
          var _n104 = e.datafields.indexOf(_i214);

          if (-1 === _n104) continue;
          var o = t[_i214],
              r = o.filters;
          a += "        <filterColumn colId=\"".concat(_n104, "\">\n            <customFilters and=\"").concat(!o.operator, "\">\n");

          for (var _t201 = 0; _t201 < r.length; _t201++) {
            a += e.getCustomFilter(r[_t201].value, r[_t201].condition);
          }

          a += "            </customFilters>\n        </filterColumn>";
        }
      }

      return a ? (a = "\n    <autoFilter ref=\"A1:".concat(e.columnsArray[e.columnsArray.length - 1] + e.data.length, "\">\n").concat(a, "\n    </autoFilter>"), a) : "";
    }
  }, {
    key: "getGroupLabels",
    value: function getGroupLabels(e) {
      var t = this,
          a = t.xlsxStartIndex === void 0 ? +t.exportHeader : t.xlsxStartIndex,
          i = {},
          n = [];

      for (var o = a; o < e.length; o++) {
        var r = e[o];

        for (var _o75 = 0; _o75 < t.groupBy.length; _o75++) {
          var l = t.groupBy[_o75],
              s = r[l];
          var d = i[l];
          d === void 0 && (i[l] = {}, d = i[l]), d[s] === void 0 && (d[s] = (t.exportHeader ? e[a - 1][l] : l) + ": " + s, n.push(d[s]));
        }
      }

      t.groups = i, t.groupLabels = n;
    }
  }, {
    key: "getHTMLHeader",
    value: function getHTMLHeader(e, t) {
      var i = this;
      var a = "\n        <thead>\n";

      if (!i.complexHeader) {
        a += "            <tr>\n";

        for (var _i215 = 0; _i215 < e.length; _i215++) {
          var _n105 = e[_i215];
          a += "                <th class=\"header header".concat(_n105, "\">").concat(t[0][_n105], "</th>\n");
        }

        return a += "            </tr>\n        </thead>", a;
      }

      for (var _n106 = 0; _n106 < i.complexHeader.length; _n106++) {
        var _t202 = i.complexHeader[_n106];
        a += "            <tr>\n";

        for (var o = 0; o < _t202.length; o++) {
          var r = _t202[o];
          var l = 1,
              s = 1;
          if (_t202[o - 1] && _t202[o - 1] === r || i.complexHeader[_n106 - 1] && i.complexHeader[_n106 - 1][o] === r) continue;
          var d = o + 1;

          for (; _t202[d] && _t202[d] === _t202[d - 1];) {
            l++, d++;
          }

          for (d = _n106 + 1; i.complexHeader[d] && i.complexHeader[d][o] === r;) {
            s++, d++;
          }

          var c = _n106 == i.complexHeader.length - 1 || s + _n106 === i.complexHeader.length ? " header" + e[o] : "";
          a += "                <th class=\"header".concat(c, "\" colspan=\"").concat(l, "\" rowspan=\"").concat(s, "\">").concat(r, "</th>\n");
        }

        a += "            </tr>\n";
      }

      return a += "        </thead>", a;
    }
  }, {
    key: "getConditionalFormatting",
    value: function getConditionalFormatting() {
      var e = this,
          t = e.conditionalFormatting;
      if (!t) return void (e.conditionalFormattingXLSX = {
        conditions: "",
        styles: ""
      });
      var a = [];
      var n = "",
          i = "";

      for (var o = t.length - 1; 0 <= o; o--) {
        var r = t[o],
            l = e.columnsArray[e.datafields.indexOf(r.column)],
            s = l + (e.xlsxStartIndex + 1),
            d = s + ":" + l + e.data.length,
            c = r.background + r.color,
            m = e.getConditionalAttributes(r, s);
        var u = a.indexOf(c);

        if (-1 === u) {
          var _t203 = "        <dxf>\n            <font>\n                <b val=\"0\"/>\n                <i val=\"0\"/>\n                <color rgb=\"".concat("White" === r.color ? "FFFFFFFF" : "FF000000", "\"/>\n                <sz val=\"10\"/>\n            </font>\n            <fill>\n                <patternFill>\n                    <bgColor rgb=\"").concat(e.toARGB(r.background), "\"/>\n                </patternFill>\n            </fill>\n        </dxf>\n");

          i += _t203, u = a.length, a.push(c);
        }

        n += "    <conditionalFormatting sqref=\"".concat(d, "\">\n        <cfRule dxfId=\"").concat(u, "\" text=\"").concat(m.text, "\" rank=\"").concat(m.rank, "\" percent=\"").concat(m.percent, "\" bottom=\"").concat(m.bottom, "\" equalAverage=\"").concat(m.equalAverage, "\" aboveAverage=\"").concat(m.aboveAverage, "\"").concat(m.operator).concat(m.timePeriod, " priority=\"").concat(o + 2, "\" type=\"").concat(m.type, "\">\n").concat(m.formula, "        </cfRule>\n    </conditionalFormatting>\n");
      }

      i = "    <dxfs count=\"".concat(a.length, "\">\n").concat(i, "    </dxfs>"), e.conditionalFormattingXLSX = {
        conditions: n,
        styles: i
      };
    }
  }, {
    key: "getConditionalAttributes",
    value: function getConditionalAttributes(e, t) {
      var i = e.condition,
          a = e.comparator,
          n = "",
          o = 0,
          r = 0,
          l = 0,
          s = 0,
          d = "",
          c = "",
          m = "",
          u = "";
      return "equal" === i ? (d = "equal", m = "cellIs", u = "            <formula>".concat(a, "</formula>\n")) : "lessThan" === i ? (d = "lessThan", m = "cellIs", u = "            <formula>".concat(a, "</formula>\n")) : "greaterThan" === i ? (d = "greaterThan", m = "cellIs", u = "            <formula>".concat(a, "</formula>\n")) : "notEqual" === i ? (d = "notEqual", m = "cellIs", u = "            <formula>".concat(a, "</formula>\n")) : "between" === i ? (d = "between", m = "cellIs", u = "            <formula>".concat(e.min, "</formula>\n            <formula>").concat(e.max, "</formula>\n")) : "duplicate" === i ? (m = "duplicateValues", u = "            <formula>0</formula>\n") : "topNItems" === i ? (o = a, m = "top10") : "bottomNItems" === i ? (o = a, l = 1, m = "top10") : "topNPercent" === i ? (o = a, r = 1, m = "top10") : "bottomNPercent" === i ? (o = a, r = 1, l = 1, m = "top10") : "aboveAverage" === i ? (s = 1, m = "aboveAverage", u = "            <formula>0</formula>\n") : "belowAverage" === i ? (m = "aboveAverage", u = "            <formula>0</formula>\n") : "contains" === i ? (n = a, d = "containsText", m = "containsText", u = "            <formula>NOT(ISERROR(SEARCH(\"".concat(a, "\",").concat(t, ")))</formula>\n")) : "doesNotContain" === i ? (n = a, d = "notContains", m = "notContainsText", u = "            <formula>ISERROR(SEARCH(\"".concat(a, "\",").concat(t, "))</formula>\n")) : "dateOccur" === i ? (c = " timePeriod=\"".concat(a, "\""), m = "timePeriod") : void 0, d && (d = " operator=\"".concat(d, "\" ")), {
        text: n,
        rank: o,
        percent: r,
        bottom: l,
        equalAverage: 0,
        aboveAverage: s,
        operator: d,
        timePeriod: c,
        type: m,
        formula: u
      };
    }
  }, {
    key: "getMergedCells",
    value: function getMergedCells(e) {
      var t = this;
      var a = "";

      for (var _t204 = 0; _t204 < e.length; _t204++) {
        e[_t204].from !== e[_t204].to && (a += "\n        <mergeCell ref=\"".concat(e[_t204].from, ":").concat(e[_t204].to, "\" />\n"));
      }

      if (t.mergedCells) for (var _e222 = 0; _e222 < t.mergedCells.length; _e222++) {
        var _i216 = t.mergedCells[_e222];
        if (2 > _i216.rowspan && 2 > _i216.colspan) continue;

        var _n107 = t.columnsArray[_i216.cell[0]] + (_i216.cell[1] + t.xlsxStartIndex + 1),
            o = t.columnsArray[_i216.cell[0] + _i216.colspan - 1] + (_i216.cell[1] + t.xlsxStartIndex + _i216.rowspan);

        a += "\n        <mergeCell ref=\"".concat(_n107, ":").concat(o, "\" />\n");
      }
      return a && (a = "\n    <mergeCells count=\"".concat(e.length, "\">").concat(a, "    </mergeCells>")), a;
    }
  }, {
    key: "getNumFmtIndex",
    value: function getNumFmtIndex(e, t) {
      var i = t.collection.indexOf(e);
      return -1 === i ? (i = t.collection.length + 100, t.collection.push(e), t.xml += "<numFmt numFmtId=\"".concat(i, "\" formatCode=\"").concat(e, "\"/>")) : i += 100, i;
    }
  }, {
    key: "getOutlineLevel",
    value: function getOutlineLevel(e) {
      return this.actualHierarchy && 1 !== e._level ? " outlineLevel=\"".concat(e._level - 1, "\"") : "";
    }
  }, {
    key: "getRowStyle",
    value: function getRowStyle() {
      var e = this,
          t = e.style;
      if (!t) return "";
      var i = t.rows;
      if (!i) return "";
      var a = {
        row: ""
      };
      var n = "";

      for (var _e223 in i) {
        if (!i.hasOwnProperty(_e223) || "alternationCount" == _e223 || "alternationStart" == _e223 || "alternationEnd" == _e223) continue;
        var _t205 = i[_e223];

        if (-1 !== _e223.indexOf("alt")) {
          var _n108 = _e223.slice(16, 17),
              _i217 = _e223.slice(17);

          a["rowN" + _n108] || (a["rowN" + _n108] = ""), a["rowN" + _n108] += "Color" === _i217 ? "color : " + _t205 + "; " : "BorderColor" === _i217 ? "border-color : " + _t205 + "; " : "background-color : " + _t205 + "; ";
          continue;
        }

        if (!isNaN(_e223)) {
          for (var _i218 in a["row" + _e223] || (a["row" + _e223] = ""), _t205) {
            _t205.hasOwnProperty(_i218) && (a["row" + _e223] += Smart.Utilities.Core.toDash(_i218) + ": " + _t205[_i218] + "; ");
          }

          continue;
        }

        a.row += Smart.Utilities.Core.toDash(_e223) + ": " + i[_e223] + "; ";
      }

      var o = Object.keys(a);
      o.sort(function (e, t) {
        if ("row" === e) return -1;
        if ("row" === t) return 1;
        var i = !isNaN(e.slice(3)),
            a = !isNaN(t.slice(3));
        return i && !a ? 1 : !i && a ? -1 : +(e < t);
      });

      for (var _e224 = 0; _e224 < o.length; _e224++) {
        n += "        .".concat(o[_e224], " { ").concat(a[o[_e224]], "}\n");
      }

      return n;
    }
  }, {
    key: "getTableStyle",
    value: function getTableStyle() {
      var e = this,
          t = e.style;
      if (!t) return " style=\"table-layout: fixed; border: 1px solid black; border-collapse: collapse;\"";
      var i = "table-layout: fixed; ";

      for (var _e225 in t) {
        t.hasOwnProperty(_e225) && -1 === ["header", "columns", "rows"].indexOf(_e225) && (i += Smart.Utilities.Core.toDash(_e225) + ": " + t[_e225] + "; ");
      }

      return i && (i = " style=\"" + i + "\""), i;
    }
  }, {
    key: "getXLSXCellStyle",
    value: function getXLSXCellStyle(e) {
      var t = this;
      return void 0 === t.cellStyleMapping[e] ? "" : " s=\"".concat(t.cellStyleMapping[e], "\"");
    }
  }, {
    key: "getXLSXFormat",
    value: function getXLSXFormat(e, t) {
      if ("number" == typeof t) {
        var _t206 = parseFloat(e.slice(1)) || 0,
            _i219 = 0 < _t206 ? "." + "0".repeat(_t206) : "";

        return e = e.slice(0, 1), "C" === e || "c" === e ? "$#,0" + _i219 : "D" === e || "d" === e ? _t206 ? "0".repeat(_t206) : "0" : "E" === e || "e" === e ? "0" + _i219 + e + "000" : "F" === e || "f" === e ? "0" + _i219 : "N" === e || "n" === e ? "#,0" + _i219 : "P" === e || "p" === e ? "#,0" + _i219 + " %" : void 0;
      }

      return t instanceof Date ? "d" === e ? "m/d/yyyy" : "D" === e ? "nnnnmmmm dd, yyyy" : "t" === e ? "h:m AM/PM" : "T" === e ? "h:mm:ss AM/PM" : "f" === e ? "nnnnmmmm dd, yyyy h:m AM/PM" : "F" === e ? "nnnnmmmm dd, yyyy h:mm:ss AM/PM" : "M" === e ? "mmmm d" : "Y" === e ? "yyyy mmmm" : "FP" === e || "PP" === e ? "yyyy-mm-dd hh:mm:ss" : "FT" === e || "PT" === e ? "hh:mm:ss" : (e = e.replace(/f|u|n|p|e|a|x|o/gi, ""), e = e.replace(/tt/gi, "AM/PM"), e = e.replace(/:{2,}|:\s|:$|\.$/g, ""), e = e.trim(), e) : void 0;
    }
  }, {
    key: "processColumnStyle",
    value: function processColumnStyle(e) {
      var t = this,
          a = e.header,
          n = e.columns,
          i = t.data[0],
          o = t.xlsxStartIndex;
      if (t.columnWidth = [], o && a) for (var _e226 = 0; _e226 < t.columnsArray.length; _e226++) {
        var _n109 = t.columnsArray[_e226],
            r = _n109 + o,
            l = a[t.datafields[_e226]];

        for (var _e227 in a) {
          if (a.hasOwnProperty(_e227) && void 0 === i[_e227]) if (t.complexHeader) {
            for (var _i220 = 0; _i220 < t.complexHeader.length; _i220++) {
              if ("height" == _e227) {
                t.rowHeight[_i220] = " ht=\"".concat(parseFloat(a.height) / t.complexHeader.length / 2, "\"");
                continue;
              } else t.storeCellStyle(_n109 + (_i220 + 1), _e227, a[_e227]);
            }
          } else {
            if ("height" == _e227) {
              t.rowHeight[0] = " ht=\"".concat(parseFloat(a.height) / 2, "\"");
              continue;
            }

            t.storeCellStyle(r, _e227, a[_e227]);
          }
        }

        if (l) for (var _i221 in l) {
          if (l.hasOwnProperty(_i221)) {
            if ("width" == _i221) {
              t.columnWidth[_e226] = l.width;
              continue;
            }

            t.storeCellStyle(r, _i221, l[_i221]);
          }
        }
      } else if (a) for (var _e228 = 0; _e228 < t.columnsArray.length; _e228++) {
        var _i222 = a[t.datafields[_e228]];
        _i222 && void 0 !== _i222.width && (t.columnWidth[_e228] = _i222.width);
      }
      if (!n) return "";

      for (var _a133 = o; _a133 < t.data.length; _a133++) {
        for (var _e229 = 0; _e229 < t.columnsArray.length; _e229++) {
          var _o76 = t.columnsArray[_e229],
              _r39 = _o76 + (_a133 + 1),
              _l23 = t.datafields[_e229],
              s = n[_l23];

          for (var _e230 in n) {
            n.hasOwnProperty(_e230) && void 0 === i[_e230] && t.storeCellStyle(_r39, _e230, n[_e230]);
          }

          if (s) for (var _e231 in s) {
            isNaN(_e231) && s.hasOwnProperty(_e231) && t.storeCellStyle(_r39, _e231, s[_e231], t.data[_a133][_l23]);
          }
        }
      }
    }
  }, {
    key: "processComplexHeader",
    value: function processComplexHeader(e, t, a) {
      function i(t) {
        for (var _a134 = 0; _a134 < e.columngroups.length; _a134++) {
          var _i223 = e.columngroups[_a134];
          if (_i223.name === t) return _i223;
        }
      }

      function n(e) {
        for (var _t207 = []; e;) {
          if (_t207.unshift(e.label), e.parentGroup) e = i(e.parentGroup);else return _t207;
        }
      }

      var o = this,
          r = {},
          l = -1 !== ["html", "jpeg", "pdf", "png", "xlsx"].indexOf(a) && e.columngroups,
          s = [],
          d = {},
          c = [];
      var m = 0;

      if (l) {
        for (var _t208 = 0; _t208 < e.columngroups.length; _t208++) {
          var _i224 = e.columngroups[_t208],
              _a135 = n(_i224);

          d[_i224.name] = _a135, m = Math.max(m, _a135.length);
        }

        m++;

        for (var _e232 = 0; _e232 < m; _e232++) {
          c[_e232] = [];
        }
      }

      for (var _n110 = 0; _n110 < e.columns.length; _n110++) {
        var _t209 = e.columns[_n110];
        if (r[_t209.dataField] = _t209.label, !l) continue;
        if (s[_n110] = _t209.dataField, c[m - 1][_n110] = _t209.label, !_t209.columnGroup) continue;
        var _i225 = d[_t209.columnGroup];

        for (var _e233 = 0; _e233 < _i225.length; _e233++) {
          c[_e233][_n110] = _i225[_e233];
        }
      }

      if (1 < c.length) {
        var _e234 = Object.keys(r).length;

        for (var _n111 = 0; _n111 < m - 1; _n111++) {
          var _i226 = {};

          for (var _t210 = 0; _t210 < _e234; _t210++) {
            if (void 0 === c[_n111][_t210]) {
              var _e235 = _n111 + 1;

              for (; void 0 === c[_e235][_t210];) {
                _e235++;
              }

              c[_n111][_t210] = c[_e235][_t210];
            }

            _i226[s[_t210]] = c[_n111][_t210];
          }

          "xlsx" === a && t.splice(_n111, 0, _i226);
        }

        if (o.complexHeader = c, "xlsx" !== a) t.unshift(r);else {
          t.splice(m - 1, 0, r);
          var _a136 = {};

          for (var _t211 = 0; _t211 < m; _t211++) {
            for (var _i227 = 0; _i227 < _e234; _i227++) {
              var _e236 = c[_t211][_i227];
              _a136[_e236] ? _a136[_e236].to = [_t211, _i227] : (_a136[_e236] = {
                from: [_t211, _i227]
              }, _a136[_e236].to = _a136[_e236].from);
            }
          }

          o.complexHeaderMergeInfo = _a136;
        }
      } else t.unshift(r);
    }
  }, {
    key: "processHierarchicalData",
    value: function processHierarchicalData(e, t) {
      function a(e, t, n) {
        var o = l[e];
        if (d = i(d, t), void 0 !== o) for (var _e237 = 0; _e237 < o.length; _e237++) {
          var _i228 = o[_e237],
              _r40 = _i228._keyDataField;
          _i228._collapsed = n, _i228._level = t, s.push(_i228), l[_r40] && (c = !0, _i228._expanded = void 0 === _i228._expanded || _i228._expanded, a(_r40, t + 1, n || !_i228._expanded));
        }
      }

      function n(e, a, o) {
        var r = l[e];
        if (d = i(d, a), void 0 !== r) for (var _e238 = 0; _e238 < r.length; _e238++) {
          var _i229 = r[_e238],
              _s16 = _i229._keyDataField;

          var _d15 = void 0;

          if ("json" === t) for (var _e239 in _d15 = {}, _i229) {
            _i229.hasOwnProperty(_e239) && "_" !== _e239.charAt(0) && (_d15[_e239] = _i229[_e239]);
          } else _d15 = Object.assign({}, _i229);
          o.push(_d15), l[_s16] && (c = !0, _d15.rows = [], n(_s16, a + 1, _d15.rows));
        }
      }

      var i = Math.max;
      var o = this,
          r = "xlsx" === t ? o.xlsxStartIndex : +o.exportHeader,
          l = {},
          s = [];
      var d = 0,
          c = !1;
      if (void 0 === e[r]._keyDataField) return o.processNestedData(e, t, r);

      for (var _a137 = r; _a137 < e.length; _a137++) {
        var _t212 = Object.assign({}, e[_a137]),
            _i230 = _t212._parentDataField;

        void 0 === l[_i230] ? l[_i230] = [_t212] : l[_i230].push(_t212);
      }

      if (r) for (var _a138 = 0; _a138 < r; _a138++) {
        s.push(Object.assign({}, e[_a138])), -1 === ["json", "pdf", "xml"].indexOf(t) && (s[_a138]._level = 1);
      }
      return "json" !== t && "xml" !== t ? a(null, 1, !1) : n(null, 1, s), c || (o.actualHierarchy = !1), o.maxLevel = d, s;
    }
  }, {
    key: "processNestedData",
    value: function processNestedData(e, t, a) {
      function n(e, t, a, o) {
        s = i(s, a);

        for (var _r41 = e; _r41 < t.length; _r41++) {
          var _e240 = Object.assign({}, t[_r41]);

          _e240._collapsed = o, _e240._level = a, l.push(_e240), _e240.children && 0 < _e240.children.length && (d = !0, _e240._expanded = void 0 === _e240._expanded || _e240._expanded, n(0, _e240.children, a + 1, o || !_e240._expanded)), delete _e240.children;
        }
      }

      function o(e, t, a, n) {
        s = i(s, n);

        for (var _r42 = e; _r42 < t.length; _r42++) {
          var _e241 = Object.assign({}, t[_r42]);

          1 === n ? l[_r42] = _e241 : a[_r42] = _e241, _e241.children && 0 < _e241.children.length && (d = !0, _e241.rows = [], o(0, _e241.children, _e241.rows, n + 1)), delete _e241.children;
        }
      }

      var i = Math.max;
      var r = this,
          l = [];
      var s = 0,
          d = !1;
      if (a) for (var _n112 = 0; _n112 < a; _n112++) {
        l.push(Object.assign({}, e[_n112])), -1 === ["json", "pdf", "xml"].indexOf(t) && (l[_n112]._level = 1);
      }
      return "json" !== t && "xml" !== t ? n(a, e, 1, !1) : o(a, e, void 0, 1), d || (r.actualHierarchy = !1), r.maxLevel = s, l;
    }
  }, {
    key: "processRowStyle",
    value: function processRowStyle(e) {
      function t(e, t, i) {
        for (var _n113 = 0; _n113 < a.columnsArray.length; _n113++) {
          var r = a.columnsArray[_n113] + (e + 1 + o);
          a.storeCellStyle(r, t, i);
        }
      }

      var a = this,
          n = e.rows;
      if (a.rowHeight = [], !n) return;
      var o = a.xlsxStartIndex;
      n.height && (a.defaultRowHeight = " ht=\"".concat(parseFloat(n.height) / 2, "\""));

      for (var r = o; r < a.data.length; r++) {
        var _e242 = r - o;

        for (var _i231 in n) {
          n.hasOwnProperty(_i231) && -1 === _i231.indexOf("alt") && isNaN(_i231) && "height" != _i231 && t(_e242, _i231, n[_i231]);
        }

        if (n.alternationCount && ((void 0 === n.alternationStart || _e242 >= n.alternationStart) && (void 0 === n.alternationEnd || _e242 <= n.alternationEnd) || n.alternationStart === n.alternationEnd)) {
          var _a139 = n.alternationStart || 0,
              _o77 = (_e242 - _a139) % n.alternationCount;

          n["alternationIndex".concat(_o77, "Color")] && t(_e242, "color", n["alternationIndex".concat(_o77, "Color")]), n["alternationIndex".concat(_o77, "BorderColor")] && t(_e242, "borderColor", n["alternationIndex".concat(_o77, "BorderColor")]), n["alternationIndex".concat(_o77, "BackgroundColor")] && t(_e242, "backgroundColor", n["alternationIndex".concat(_o77, "BackgroundColor")]);
        }

        if (n[_e242]) for (var _i232 in n[_e242]) {
          if (n[_e242].hasOwnProperty(_i232)) {
            if ("height" == _i232) {
              a.rowHeight[r] = " ht=\"".concat(parseFloat(n[_e242].height) / 2, "\"");
              continue;
            }

            t(_e242, _i232, n[_e242][_i232]);
          }
        }
      }
    }
  }, {
    key: "storeCellStyle",
    value: function storeCellStyle(e, t, i) {
      var a = this,
          n = a.styleMap[e];

      switch (t) {
        case "backgroundColor":
          n.fills.fgColor = i;
          break;

        case "color":
          n.fonts.color = i;
          break;

        case "fontFamily":
          n.fonts.name = i.replace(/"/g, "'");
          break;

        case "fontSize":
          n.fonts.sz = parseFloat(i);
          break;

        case "fontStyle":
          "italic" === i ? n.fonts.i = !0 : delete n.fonts.i;
          break;

        case "fontWeight":
          "bold" === i ? n.fonts.b = !0 : delete n.fonts.b;
          break;

        case "numFmt":
          {
            n.numFmt = i;
            break;
          }

        case "textAlign":
          n.alignment.horizontal = i;
          break;

        case "textDecoration":
          "underline" === i ? n.fonts.u = !0 : delete n.fonts.u;
          break;

        case "verticalAlign":
          "middle" === i && (i = "center"), n.alignment.vertical = i;
      }
    }
  }, {
    key: "toARGB",
    value: function toARGB(e) {
      e = e.replace(/\s/g, "");
      var t = /rgb\((\d+),(\d+),(\d+)\)/gi.exec(e);

      if (null !== t) {
        var _e243 = parseFloat(t[1]).toString(16).toUpperCase(),
            _i233 = parseFloat(t[2]).toString(16).toUpperCase(),
            _a140 = parseFloat(t[3]).toString(16).toUpperCase();

        return "FF" + "0".repeat(2 - _e243.length) + _e243 + "0".repeat(2 - _i233.length) + _i233 + "0".repeat(2 - _a140.length) + _a140;
      }

      var i = /rgba\((\d+),(\d+),(\d+)\,(\d*.\d+|\d+)\)/gi.exec(e);

      if (null !== i) {
        var _e244 = Math.round(255 * parseFloat(i[4])).toString(16).toUpperCase(),
            _t213 = parseFloat(i[1]).toString(16).toUpperCase(),
            _a141 = parseFloat(i[2]).toString(16).toUpperCase(),
            _n114 = parseFloat(i[3]).toString(16).toUpperCase();

        return "0".repeat(2 - _e244.length) + _e244 + "0".repeat(2 - _t213.length) + _t213 + "0".repeat(2 - _a141.length) + _a141 + "0".repeat(2 - _n114.length) + _n114;
      }

      var a = /^#(.)(.)(.)$/gi.exec(e);

      if (null !== a) {
        var _e245 = a[1].toUpperCase(),
            _t214 = a[2].toUpperCase(),
            _i234 = a[3].toUpperCase();

        return "FF" + _e245 + _e245 + _t214 + _t214 + _i234 + _i234;
      }

      return "FF" + e.toUpperCase().slice(1);
    }
  }, {
    key: "toggleableFunctionality",
    value: function toggleableFunctionality() {
      var e = this;
      return e.actualHierarchy ? "\n    <style type=\"text/css\">\n        .toggle-element {\n            width: 5px;\n            height: 1px;\n            padding-right: 5px;\n            float: left;\n            text-align: right;\n            cursor: pointer;\n            user-select: none;\n        }\n\n        .collapsed {\n            display: none;\n        }\n    </style>\n    <script type=\"text/javascript\">\n        window.onload = function () {\n            var expandChar = '".concat(e.expandChar, "',\n                collapseChar = '").concat(e.collapseChar, "',\n                toggleElements = document.getElementsByClassName('toggle-element');\n\n            function getParent(child) {\n                var prevSibling = child.previousElementSibling;\n\n                while (prevSibling) {\n                    if (child.getAttribute('level') > prevSibling.getAttribute('level')) {\n                        return prevSibling;\n                    }\n\n                    prevSibling = prevSibling.previousElementSibling;\n                }\n\n            }\n\n            function getFirstCollapsedAncestor(child) {\n                var parent = getParent(child);\n\n                while (parent) {\n                    if (parent.firstElementChild.firstElementChild.innerHTML === expandChar) {\n                        return parent;\n                    }\n\n                    parent = getParent(parent);\n                }\n            }\n\n            for (var i = 0; i < toggleElements.length; i++) {\n                toggleElements[i].addEventListener('click', function (event) {\n                    var expanded = this.innerHTML === collapseChar,\n                        row = this.parentElement.parentElement,\n                        sibling = row.nextElementSibling;\n\n                    if (expanded) {\n                        this.innerHTML = expandChar;\n                    }\n                    else {\n                        this.innerHTML = collapseChar;\n                    }\n\n                    while (sibling && row.getAttribute('level') < sibling.getAttribute('level')) {\n                        if (expanded) {\n                            sibling.style.display = 'none';\n                        }\n                        else {\n                            var firstCollapsedAncestor = getFirstCollapsedAncestor(sibling);\n\n                            if (!firstCollapsedAncestor || firstCollapsedAncestor === row) {\n                                sibling.classList.remove('collapsed');\n                                sibling.style.display = null;\n                            }\n\n                        }\n\n                        sibling = sibling.nextElementSibling;\n                    }\n                });\n            }\n        }\n    </script>") : "";
    }
  }, {
    key: "generateStyles",
    value: function generateStyles(e) {
      var t = this;
      if (t.cellStyleMapping = {}, 0 === Object.keys(e).length && !t.complexHeader) return "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<styleSheet xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\" mc:Ignorable=\"x14ac x16r2 xr\" xmlns:x14ac=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\" xmlns:x16r2=\"http://schemas.microsoft.com/office/spreadsheetml/2015/02/main\" xmlns:xr=\"http://schemas.microsoft.com/office/spreadsheetml/2014/revision\"><fonts count=\"1\" x14ac:knownFonts=\"1\"><font><sz val=\"11\"/><color theme=\"1\"/><name val=\"Calibri\"/><family val=\"2\"/><charset val=\"204\"/><scheme val=\"minor\"/></font></fonts><fills count=\"2\"><fill><patternFill patternType=\"none\"/></fill><fill><patternFill patternType=\"gray125\"/></fill></fills><borders count=\"1\"><border><left/><right/><top/><bottom/><diagonal/></border></borders><cellStyleXfs count=\"1\"><xf numFmtId=\"0\" fontId=\"0\" fillId=\"0\" borderId=\"0\"/></cellStyleXfs><cellXfs count=\"1\"><xf numFmtId=\"0\" fontId=\"0\" fillId=\"0\" borderId=\"0\" xfId=\"0\"/></cellXfs><cellStyles count=\"1\"><cellStyle name=\"Normal\" xfId=\"0\" builtinId=\"0\"/></cellStyles>".concat(t.conditionalFormattingXLSX.styles || "<dxfs count=\"0\"/>", "<tableStyles count=\"0\" defaultTableStyle=\"TableStyleMedium2\" defaultPivotStyle=\"PivotStyleLight16\"/><extLst><ext uri=\"{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}\" xmlns:x14=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/main\"><x14:slicerStyles defaultSlicerStyle=\"SlicerStyleLight1\"/></ext><ext uri=\"{9260A510-F301-46a8-8635-F512D64BE5F5}\" xmlns:x15=\"http://schemas.microsoft.com/office/spreadsheetml/2010/11/main\"><x15:timelineStyles defaultTimelineStyle=\"TimeSlicerStyleLight1\"/></ext></extLst></styleSheet>");
      t.styleMap = {};

      for (var _a142 = 0; _a142 < t.data.length; _a142++) {
        for (var _e246 = 0; _e246 < t.columnsArray.length; _e246++) {
          t.styleMap[t.columnsArray[_e246] + (_a142 + 1)] = {
            numFmts: {},
            fonts: {},
            fills: {},
            borders: {},
            alignment: {}
          };
        }
      }

      if (e && e.columns) for (var _a143 = 0; _a143 < t.columnsArray.length; _a143++) {
        var _i235 = t.datafields[_a143];
        if (!e.columns[_i235] || !e.columns[_i235].format) continue;

        var _n115 = t.getXLSXFormat(e.columns[_i235].format, t.data[t.data.length - 1][_i235]);

        _n115 && (e.columns[_i235].numFmt = _n115);
      }
      t.processRowStyle(e), t.processColumnStyle(e);
      var i = {};

      for (var _a144 = 0; _a144 < t.complexHeaderMergedCells.length; _a144++) {
        var _e247 = t.complexHeaderMergedCells[_a144];

        if (parseFloat(_e247.to[1]) === t.complexHeader.length) {
          i[_e247.to] = _e247.from;
          continue;
        }

        t.styleMap[_e247.from].alignment.horizontal = "center", t.styleMap[_e247.from].alignment.vertical = "center";
      }

      var a = {
        xml: "<font><sz val=\"11\" /><color theme=\"1\" /><name val=\"Calibri\" /><family val=\"2\" /><charset val=\"204\" /><scheme val=\"minor\" /></font>",
        collection: ["default"]
      },
          n = {
        xml: "<fill><patternFill patternType=\"none\" /></fill><fill><patternFill patternType=\"gray125\" /></fill>",
        collection: ["default", "gray125"]
      },
          o = {
        xml: "",
        collection: []
      },
          r = {
        xml: "<xf fontId=\"0\" fillId=\"0\" borderId=\"1\"/>",
        collection: ["default"]
      };

      for (var l = 0; l < t.data.length; l++) {
        for (var _e248 = 0; _e248 < t.columnsArray.length; _e248++) {
          var s = t.columnsArray[_e248] + (l + 1),
              d = t.styleMap[s];
          var c = "",
              m = "",
              u = "",
              p = [],
              g = [],
              h = [],
              _ = [];

          for (var _e249 in d.fonts) {
            if (d.fonts.hasOwnProperty(_e249)) {
              var _i236 = d.fonts[_e249];
              "color" == _e249 ? (p[0] = _i236, c += "<color rgb=\"".concat(t.toARGB(_i236), "\" />")) : "name" == _e249 ? (p[1] = _i236, c += "<name val=\"".concat(_i236, "\" />")) : "sz" == _e249 ? (p[2] = _i236, c += "<sz val=\"".concat(_i236, "\" />")) : "i" == _e249 ? (p[3] = _i236, c += "<i />") : "b" == _e249 ? (p[4] = _i236, c += "<b />") : "u" == _e249 ? (p[5] = _i236, c += "<u />") : void 0;
            }
          }

          for (var _e250 in d.fills) {
            if (d.fills.hasOwnProperty(_e250)) {
              var _i237 = d.fills[_e250];
              "fgColor" == _e250 ? (g[0] = _i237, m += "<fgColor rgb=\"".concat(t.toARGB(_i237), "\" />")) : void 0;
            }
          }

          for (var _e251 in d.alignment) {
            if (d.alignment.hasOwnProperty(_e251)) {
              var _t215 = d.alignment[_e251];
              "horizontal" == _e251 ? (h[0] = _t215, u += "horizontal=\"".concat(_t215, "\" ")) : "vertical" == _e251 ? (h[1] = _t215, u += "vertical=\"".concat(_t215, "\" ")) : void 0;
            }
          }

          if (p = p.toString(), g = g.toString(), "" != c) {
            var _e252 = a.collection.indexOf(p);

            -1 === _e252 && (_e252 = a.collection.length, a.xml += "<font>" + c + "</font>", a.collection.push(p)), _[0] = _e252;
          }

          if ("" != m) {
            var _e253 = n.collection.indexOf(g);

            -1 === _e253 && (_e253 = n.collection.length, n.xml += "<fill><patternFill patternType=\"solid\">" + m + "</patternFill></fill>", n.collection.push(g)), _[1] = _e253;
          }

          0 < h.length && (_[2] = u), void 0 !== d.numFmt && (_[3] = t.getNumFmtIndex(d.numFmt, o));

          var f = _.toString();

          if ("" !== f) {
            var _e254 = r.collection.indexOf(f);

            if (-1 === _e254) {
              var _t216 = "<xf ";
              _e254 = r.collection.length, void 0 !== _[0] && (_t216 += "fontId=\"".concat(_[0], "\" ")), void 0 !== _[1] && (_t216 += "fillId=\"".concat(_[1], "\" ")), void 0 !== _[3] && (_t216 += "numFmtId=\"".concat(_[3], "\" ")), _t216 += void 0 === _[2] ? " borderId=\"1\"/>" : "applyAlignment=\"1\" borderId=\"1\"><alignment ".concat(u, "/></xf>"), r.xml += _t216, r.collection.push(f);
            }

            t.cellStyleMapping[i[s] || s] = _e254;
          }
        }
      }

      return o.collection.length && (o.xml = "<numFmts count=\"".concat(o.collection.length, "\">").concat(o.xml, "</numFmts>")), "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<styleSheet xmlns=\"http://schemas.openxmlformats.org/spreadsheetml/2006/main\" xmlns:mc=\"http://schemas.openxmlformats.org/markup-compatibility/2006\" mc:Ignorable=\"x14ac x16r2 xr\" xmlns:x14ac=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac\" xmlns:x16r2=\"http://schemas.microsoft.com/office/spreadsheetml/2015/02/main\" xmlns:xr=\"http://schemas.microsoft.com/office/spreadsheetml/2014/revision\">".concat(o.xml, "<fonts count=\"").concat(a.collection.length, "\" x14ac:knownFonts=\"1\">").concat(a.xml, "</fonts><fills count=\"").concat(n.collection.length, "\">").concat(n.xml, "</fills><borders count=\"2\"><border><left/><right/><top/><bottom/></border><border><left style=\"hair\"/><right style=\"hair\"/><top style=\"hair\"/><bottom style=\"hair\"/><diagonal/></border></borders><cellStyleXfs count=\"1\"><xf numFmtId=\"0\" fontId=\"0\" fillId=\"0\" borderId=\"0\"/></cellStyleXfs><cellXfs count=\"").concat(r.collection.length, "\">").concat(r.xml, "</cellXfs><cellStyles count=\"1\"><cellStyle name=\"Normal\" xfId=\"0\" builtinId=\"0\"/></cellStyles>").concat(t.conditionalFormattingXLSX.styles, "<dxfs count=\"0\"/><tableStyles count=\"0\" defaultTableStyle=\"TableStyleMedium2\" defaultPivotStyle=\"PivotStyleLight16\"/><extLst><ext uri=\"{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}\" xmlns:x14=\"http://schemas.microsoft.com/office/spreadsheetml/2009/9/main\"><x14:slicerStyles defaultSlicerStyle=\"SlicerStyleLight1\"/></ext><ext uri=\"{9260A510-F301-46a8-8635-F512D64BE5F5}\" xmlns:x15=\"http://schemas.microsoft.com/office/spreadsheetml/2010/11/main\"><x15:timelineStyles defaultTimelineStyle=\"TimeSlicerStyleLight1\"/></ext></extLst></styleSheet>");
    }
  }]);

  return _class13;
}()), Smart.Utilities.Assign("FilterGroup",
/*#__PURE__*/
function () {
  "use strict";

  function FilterGroup() {
    _classCallCheck(this, FilterGroup);

    var e = this;
    e.stringConditions = ["EMPTY", "NOT_EMPTY", "CONTAINS", "CONTAINS_CASE_SENSITIVE", "DOES_NOT_CONTAIN", "DOES_NOT_CONTAIN_CASE_SENSITIVE", "STARTS_WITH", "STARTS_WITH_CASE_SENSITIVE", "ENDS_WITH", "ENDS_WITH_CASE_SENSITIVE", "EQUAL", "EQUAL_CASE_SENSITIVE", "NULL", "NOT_NULL"], e.numericConditions = ["EQUAL", "NOT_EQUAL", "LESS_THAN", "LESS_THAN_OR_EQUAL", "GREATER_THAN", "GREATER_THAN_OR_EQUAL", "NULL", "NOT_NULL"], e.dateConditions = ["EQUAL", "NOT_EQUAL", "LESS_THAN", "LESS_THAN_OR_EQUAL", "GREATER_THAN", "GREATER_THAN_OR_EQUAL", "NULL", "NOT_NULL"], e.booleanConditions = ["EQUAL", "NOT_EQUAL", "NULL", "NOT_NULL"], e.filters = [], e.logicalOperators = [];
  }

  _createClass(FilterGroup, [{
    key: "evaluate",
    value: function evaluate(e) {
      var t = this;
      var a = !0;

      for (var _n116 = 0, _i238; _n116 < t.filters.length; _n116++) {
        _i238 = t.filters[_n116].evaluate(e), a = 0 == _n116 ? _i238 : 1 === t.logicalOperators[_n116] || "or" === t.logicalOperators[_n116] ? a || _i238 : a && _i238;
      }

      return a;
    }
  }, {
    key: "getFiltersCount",
    value: function getFiltersCount() {
      return this.filters.length;
    }
  }, {
    key: "setConditions",
    value: function setConditions(e, t) {
      var i = this;
      "numeric" === e ? i.numericConditions = t : "string" === e ? i.stringConditions = t : "date" === e || "time" === e ? i.dateConditions = t : "bool" === e || "boolean" === e ? i.booleanConditions = t : void 0;
    }
  }, {
    key: "getConditions",
    value: function getConditions(e) {
      var t = this;
      var i = [];
      return "numeric" === e ? i = t.numericConditions.slice(0) : "string" === e ? i = t.stringConditions.slice(0) : "date" === e || "time" === e ? i = t.dateConditions.slice(0) : "bool" === e || "boolean" === e ? i = t.booleanConditions.slice(0) : void 0, i;
    }
  }, {
    key: "generateFilterKey",
    value: function generateFilterKey() {
      var e = function e() {
        return (0 | 65536 * (1 + Math.random())).toString(16).substring(1);
      };

      return e() + "-" + e() + "-" + e();
    }
  }, {
    key: "createFilter",
    value: function createFilter(e, t, i, a, n, o, r) {
      if (null === e || e === void 0) return null;

      switch (e) {
        case "int":
        case "float":
        case "int64":
        case "double":
        case "numeric":
        case "number":
        case "numericFilter":
          return new Smart.Utilities.NumericFilter(t, i.toUpperCase());

        case "string":
        case "stringFilter":
          return new Smart.Utilities.StringFilter(t, i.toUpperCase(), o);

        case "date":
        case "time":
        case "dateFilter":
          return new Smart.Utilities.DateFilter(t, i.toUpperCase(), n, o, r);

        case "bool":
        case "boolean":
        case "booleanFilter":
          return new Smart.Utilities.BooleanFilter(t, i.toUpperCase());

        case "custom":
          return new Smart.Utilities.CustomFilter(t, i.toUpperCase(), a);
      }

      throw new Error("smartGrid: There is no such filter type. The available filter types are: \"numericFilter\", \"stringFilter\", \"dateFilter\" and \"booleanFilter\"");
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      var e = this;
      var t = [];

      for (var _a145 = 0; _a145 < e.filters.length; _a145++) {
        var _i239 = e.filters[_a145];

        if (_i239 instanceof FilterGroup) {
          var _n117 = _i239.getFilters();

          t.push({
            value: _n117,
            logicalOperator: e.logicalOperators[_a145],
            type: "FilterGroup"
          });
        } else {
          var _n118 = {
            value: _i239.value,
            condition: _i239.condition,
            logicalOperator: e.logicalOperators[_a145],
            type: _i239.type
          };
          _i239.data && (_n118.id = _i239.data), t.push(_n118);
        }
      }

      return t;
    }
  }, {
    key: "addFilter",
    value: function addFilter(e, t) {
      var i = this;
      i.filters[i.filters.length] = t, t.key = i.generateFilterKey(), i.logicalOperators[i.logicalOperators.length] = e;
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(e) {
      var t = this;

      for (var _a146 = 0; _a146 < t.filters.length; _a146++) {
        if (t.filters[_a146].key === e.key) {
          t.filters.splice(_a146, 1), t.logicalOperators.splice(_a146, 1);
          break;
        }
      }
    }
  }, {
    key: "getOperatorAt",
    value: function getOperatorAt(e) {
      var t = this;
      return void 0 === e || null === e ? null : 0 > e || e > t.filters.length ? null : t.logicalOperators[e];
    }
  }, {
    key: "setOperatorAt",
    value: function setOperatorAt(e, t) {
      var i = this;
      return void 0 === e || null === e ? null : 0 > e || e > i.filters.length ? null : void (i.logicalOperators[t] = t);
    }
  }, {
    key: "getFilterAt",
    value: function getFilterAt(e) {
      var t = this;
      return void 0 === e || null === e ? null : 0 > e || e > t.filters.length ? null : t.filters[e];
    }
  }, {
    key: "setFilterAt",
    value: function setFilterAt(e, t) {
      var i = this;
      return void 0 === e || null === e ? null : 0 > e || e > i.filters.length ? null : void (t.key = i.generateFilterKey(), i.filters[e] = t);
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = this;
      e.filters = [], e.logicalOperators = [];
    }
  }, {
    key: "getUniqueValues",
    value: function getUniqueValues(e, t) {
      var a = e.data,
          n = [],
          o = [],
          r = "dateFilter" === e.filterType && "timePicker" === e.displayMode;
      var i = !1,
          l;

      for (var _l24 = 0, s; _l24 < a.length; _l24++) {
        if (s = a[_l24][e.dataField], "" === s || null === s || void 0 === s) {
          i = !0;
          continue;
        }

        var _t217 = void 0;

        _t217 = r ? new Smart.Utilities.DateTime(s).toString(e.formatString) : s.toString(), -1 === n.indexOf(_t217) && (n.push(_t217), o.push({
          label: _t217,
          value: s,
          customAttribute: "default-item"
        }));
      }

      switch (e.filterType) {
        case "numericFilter":
        case "booleanFilter":
          l = function l(e, t) {
            return e.value - t.value;
          };

          break;

        case "stringFilter":
          l = function l(e, t) {
            return new Intl.Collator().compare(e.value, t.value);
          };

          break;

        case "dateFilter":
          l = r ? function (e, t) {
            try {
              var _i240 = e.value.getHours(),
                  _a147 = t.value.getHours();

              if (_i240 !== _a147) return _i240 - _a147;

              var _n119 = e.value.getMinutes(),
                  _o78 = t.value.getMinutes();

              if (_n119 !== _o78) return _n119 - _o78;

              var _r43 = e.value.getSeconds(),
                  _l25 = t.value.getSeconds();

              return _r43 === _l25 ? 0 : _r43 - _l25;
            } catch (e) {
              return -1;
            }
          } : function (e, t) {
            try {
              return e.value.getTime() - t.value.getTime();
            } catch (e) {
              return -1;
            }
          };
      }

      return o.sort(l), "booleanFilter" === e.filterType && o.map(function (e) {
        e.label = e.label.toUpperCase();
      }), i && o.push({
        label: t.localize("blanks"),
        value: "",
        customAttribute: "default-item"
      }), o;
    }
  }]);

  return FilterGroup;
}()), Smart.Utilities.Assign("StringFilter",
/*#__PURE__*/
function () {
  "use strict";

  function _class14(e, t, i) {
    _classCallCheck(this, _class14);

    var a = this;
    a.value = e, a.condition = t, a.locale = i || "en", a.type = "stringFilter";
  }

  _createClass(_class14, [{
    key: "evaluate",
    value: function evaluate(e) {
      var t = this,
          i = t.value,
          a = t.condition;

      if (null === e || e === void 0 || "" === e) {
        if ("NULL" === a) return !0;
        if ("EQUAL" === a && e === i) return !0;
        if ("NOT_EQUAL" === a && e !== i) return !0;
        if ("EMPTY" !== a) return !1;
        if ("" === e) return !0;
      }

      var n = "";

      try {
        n = e.toString();
      } catch (e) {
        return !0;
      }

      var o = function o(e, i) {
        var n = t.locale;
        return "EQUAL" === a ? 0 === e.localeCompare(i, n, {
          sensitivity: "accent"
        }) : "EQUAL_CASE_SENSITIVE" === a ? 0 === e.localeCompare(i, n, {
          sensitivity: "variant"
        }) : "NOT_EQUAL" === a ? 0 !== e.localeCompare(i, n, {
          sensitivity: "accent"
        }) : "NOT_EQUAL_CASE_SENSITIVE" === a ? 0 !== e.localeCompare(i, n, {
          sensitivity: "variant"
        }) : "CONTAINS" === a ? -1 !== e.toLowerCase().indexOf(i.toLowerCase()) : "CONTAINS_CASE_SENSITIVE" === a ? -1 !== e.indexOf(i) : "DOES_NOT_CONTAIN" === a ? -1 === e.toLowerCase().indexOf(i.toLowerCase()) : "DOES_NOT_CONTAIN_CASE_SENSITIVE" === a ? -1 === e.indexOf(i) : "EMPTY" === a ? "" === e : "NOT_EMPTY" === a ? "" !== e : "NOT_NULL" === a ? null !== e : "STARTS_WITH" === a ? (e = e.substring(0, i.length), 0 === e.localeCompare(i, n, {
          sensitivity: "accent"
        })) : "ENDS_WITH" === a ? (e = e.substring(e.length - i.length, e.length), 0 === e.localeCompare(i, n, {
          sensitivity: "accent"
        })) : "ENDS_WITH_CASE_SENSITIVE" === a ? (e = e.substring(e.length - i.length, e.length), 0 === e.localeCompare(i, n, {
          sensitivity: "variant"
        })) : !("STARTS_WITH_CASE_SENSITIVE" !== a) && (e = e.substring(0, i.length), 0 === e.localeCompare(i, n, {
          sensitivity: "variant"
        }));
      },
          r = [];

      if (i && i.indexOf && (0 <= i.indexOf("|") || 0 <= i.indexOf(" AND ") || 0 <= i.indexOf(" OR ") || 0 <= i.indexOf(" and ") || 0 <= i.indexOf(" or "))) {
        var _e255 = o(n, i);

        if (_e255) return _e255;

        var _t218 = 0 <= i.indexOf(" and ") ? i.split(" and ") : [],
            _a148 = 0 <= i.indexOf(" or ") ? i.split(" or ") : [],
            l = 0 <= i.indexOf("|") ? i.split("|") : [];

        var s = 0 <= i.indexOf(" AND ") ? i.split(" AND ") : [],
            d = 0 <= i.indexOf(" OR ") ? i.split(" OR ") : [];
        if (0 < l.length) for (var _e256 = 0; _e256 < l.length; _e256++) {
          l[_e256] = l[_e256].trim;
        }
        var c = 0 <= i.indexOf(" ") ? i.split(" ") : [];
        if (0 < c.length) for (var _e257 = 0; _e257 < c.length; _e257++) {
          c[_e257] = c[_e257].trim;
        }
        if (s = s.concat(c), s = s.concat(_t218), d = d.concat(l), d = d.concat(_a148), 0 < s.length) for (var _e258 = 0; _e258 < s.length; _e258++) {
          0 <= !s[_e258].indexOf(" OR ") && r.push(s[_e258]);
        }
        if (0 < d.length) for (var _e259 = 0; _e259 < d.length; _e259++) {
          0 <= !d[_e259].indexOf(" AND ") && r.push(d[_e259]);
        }
        var m;

        for (var _e260 = 0; _e260 < r.length; _e260++) {
          var _t219 = r[_e260],
              _i241 = o(n, _t219),
              _a149 = _e260 < s.length ? "and" : "or";

          m = void 0 === m ? _i241 : "or" == _a149 ? m || _i241 : m && _i241;
        }

        return m;
      }

      return o(n, i);
    }
  }]);

  return _class14;
}()), Smart.Utilities.Assign("BooleanFilter",
/*#__PURE__*/
function () {
  "use strict";

  function _class15(e, t) {
    _classCallCheck(this, _class15);

    var i = this;
    i.value = e, i.condition = t, i.type = "booleanFilter";
  }

  _createClass(_class15, [{
    key: "evaluate",
    value: function evaluate(e) {
      var t = this,
          i = t.value,
          a = t.condition,
          n = e;
      return "EQUAL" === a ? n === i : "NOT_EQUAL" === a ? n !== i : "NULL" === a ? null === e || void 0 === e || "" === e : !("NOT_NULL" !== a) && null !== e && void 0 !== e && "" !== e;
    }
  }]);

  return _class15;
}()), Smart.Utilities.Assign("NumericFilter",
/*#__PURE__*/
function () {
  "use strict";

  function _class16(e, t) {
    _classCallCheck(this, _class16);

    var i = this;
    i.value = e, i.condition = t, i.type = "numericFilter";
  }

  _createClass(_class16, [{
    key: "evaluate",
    value: function evaluate(e) {
      var t = this;
      var i = t.value,
          a = t.condition;
      if (null === e || e === void 0 || "" === e) return "NOT_NULL" !== a && ("NULL" === a || ("EQUAL" === a ? e === i : "NOT_EQUAL" === a && e !== i));
      if ("NULL" === a) return !1;
      if ("NOT_NULL" === a) return !0;
      var n = e;

      try {
        n = parseFloat(n);
      } catch (t) {
        if ("" !== e.toString()) return !1;
      }

      var o = function o(e, t) {
        return "number" == typeof e && "number" != typeof t && (t = parseFloat(t)), "EQUAL" === a ? e === t : "NOT_EQUAL" === a ? e !== t : "GREATER_THAN" === a ? e > t : "GREATER_THAN_OR_EQUAL" === a ? e >= t : "LESS_THAN" === a ? e < t : "LESS_THAN_OR_EQUAL" === a ? e <= t : "STARTS_WITH" === a ? (t = t.toString().toLowerCase(), e.toString().toLowerCase().substring(0, t.length) === t) : "ENDS_WITH" === a ? (e = e.toString().toLowerCase(), t = t.toString().toLowerCase(), e.substring(e.length - t.length, e.length) === t) : "ENDS_WITH_CASE_SENSITIVE" === a ? (e = e.toString(), t = t.toString(), e.substring(e.length - t.length, e.length) === t) : "STARTS_WITH_CASE_SENSITIVE" === a ? (t = t.toString(), e.toString().substring(0, t.length) === t) : "CONTAINS" === a ? -1 !== e.toString().toLowerCase().indexOf(t.toString().toLowerCase()) : "CONTAINS_CASE_SENSITIVE" === a ? -1 !== e.toString().indexOf(t.toString()) : "DOES_NOT_CONTAIN" === a ? -1 === e.toString().toLowerCase().indexOf(t.toString().toLowerCase()) : "DOES_NOT_CONTAIN_CASE_SENSITIVE" !== a || -1 === e.toString().indexOf(t.toString());
      };

      var r = [];

      if (i && i.indexOf && (0 <= i.indexOf("|") || 0 <= i.indexOf(" AND ") || 0 <= i.indexOf(" OR ") || 0 <= i.indexOf(" and ") || 0 <= i.indexOf(" or "))) {
        var _e261 = o(n, i);

        if (_e261) return _e261;
        i = i.toString();

        var _t220 = 0 <= i.indexOf(" and ") ? i.split(" and ") : [],
            _a150 = 0 <= i.indexOf(" or ") ? i.split(" or ") : [],
            l = 0 <= i.indexOf("|") ? i.split("|") : [];

        var s = 0 <= i.indexOf(" AND ") ? i.split(" AND ") : [],
            d = 0 <= i.indexOf(" OR ") ? i.split(" OR ") : [];
        if (s = s.concat(_t220), d = d.concat(_a150), 0 < l.length) for (var _e262 = 0; _e262 < l.length; _e262++) {
          l[_e262] = l[_e262].trim;
        }
        if (d = d.concat(l), 0 < s.length) for (var _e263 = 0; _e263 < s.length; _e263++) {
          0 <= !s[_e263].indexOf(" OR ") && r.push(s[_e263]);
        }
        if (0 < d.length) for (var _e264 = 0; _e264 < d.length; _e264++) {
          0 <= !d[_e264].indexOf(" AND ") && r.push(d[_e264]);
        }
        var c;

        for (var _t221 = 0; _t221 < r.length; _t221++) {
          var _i242 = r[_t221];

          if (_i242 && _i242.indexOf && 0 <= _i242.indexOf("..")) {
            var _t222 = _i242.toString().split("..");

            2 === _t222.length && (_e261 = n >= _t222[0] && n <= _t222[1]);
          } else _e261 = o(n, _i242);

          var _a151 = _t221 < s.length ? "and" : "or";

          c = void 0 === c ? _e261 : "or" == _a151 ? c || _e261 : c && _e261;
        }

        return c;
      }

      return i && i.indexOf && 0 <= i.indexOf("..") && (r = i.toString().split(".."), 2 === r.length) ? n >= r[0] && n <= r[1] : o(n, i);
    }
  }]);

  return _class16;
}()), Smart.Utilities.Assign("DateFilter",
/*#__PURE__*/
function () {
  "use strict";

  function _class17(e, t, i, a, n) {
    _classCallCheck(this, _class17);

    var o = this,
        r = new Smart.Utilities.DateTime();

    if (o.value = e, o.type = "dateFilter", void 0 !== i) {
      var _t223 = r.parseDate(e, i);

      if (null !== _t223) o.filterdate = _t223;else {
        var _t224 = r.tryparseDate(e);

        null !== _t224 && (o.filterdate = _t224);
      }
    } else {
      var _t225 = new Date(e);

      o.filterdate = "NaN" === _t225.toString() || "Invalid Date" === _t225.toString() ? r.tryparseDate(e) : _t225;
    }

    if (!o.filterdate) {
      var _t226 = new Date(e);

      o.filterdate = "NaN" === _t226.toString() || "Invalid Date" === _t226.toString() ? r.tryparseDate(e) : _t226;
    }

    o.condition = t, o.formatString = i, o.timeOnly = n;
  }

  _createClass(_class17, [{
    key: "evaluate",
    value: function evaluate(e) {
      var t = this,
          i = t.condition,
          a = t.formatString;
      var n = t.value;
      if (t.timeOnly) return t.evaluateTimeOnly(e);
      if (null === e || void 0 === e || "" === e) return "NOT_NULL" !== i && ("NULL" === i || ("EQUAL" === i ? e === n : "NOT_EQUAL" === i && e !== n));
      if ("NULL" === i) return !1;
      if ("NOT_NULL" === i) return !0;
      var o = new Date(),
          r;
      o.setFullYear(1900, 0, 1), o.setHours(12, 0, 0, 0);

      try {
        var _i243 = new Smart.Utilities.DateTime(),
            _l26 = new Date(e);

        if (e = "NaN" === _l26.toString() || "Invalid Date" === _l26.toString() ? _i243.tryparseDate(e) : _l26, o = e, r = !1, void 0 !== a && (0 <= a.indexOf("t") || 0 <= a.indexOf("T") || 0 <= a.indexOf(":") || 0 <= a.indexOf("f")) && (r = !0, n && -1 === n.toString().indexOf(":"))) {
          var _e265 = _i243.tryparseDate(n.toString() + ":00");

          null !== _e265 && (t.filterdate = _e265);
        }

        r || (o.setHours(0), o.setMinutes(0), o.setSeconds(0));
      } catch (t) {
        if ("" !== e.toString()) return !1;
      }

      if (null !== t.filterdate) n = t.filterdate;else if (n && n.indexOf && (-1 !== n.indexOf(":") || !isNaN(parseInt(n)))) {
        var _e266 = new Date(o);

        _e266.setHours(12, 0, 0, 0);

        var _t227 = n.split(":");

        for (var _a152 = 0; _a152 < _t227.length; _a152++) {
          0 == _a152 && _e266.setHours(_t227[_a152]), 1 == _a152 && _e266.setMinutes(_t227[_a152]), 2 == _a152 && _e266.setSeconds(_t227[_a152]);
        }

        n = _e266;
      }
      r && n && n.setFullYear && o && o.getFullYear && -1 === a.indexOf("d") && -1 === a.indexOf("M") && -1 === a.indexOf("y") && n.setFullYear(o.getFullYear(), o.getMonth(), o.getDate());

      var l = function l(e, t) {
        return null === e && (e = ""), "EQUAL" === i ? e.toString() === t.toString() : "NOT_EQUAL" === i ? e.toString() !== t.toString() : "GREATER_THAN" === i ? e > t : "GREATER_THAN_OR_EQUAL" === i ? e >= t : "LESS_THAN" === i ? e < t : "LESS_THAN_OR_EQUAL" === i ? e <= t : "STARTS_WITH" === i ? (t = t.toString().toLowerCase(), e.toString().toLowerCase().substring(0, t.length) === t) : "ENDS_WITH" === i ? (e = e.toString().toLowerCase(), t = t.toString().toLowerCase(), e.substring(e.length - t.length, e.length) === t) : "ENDS_WITH_CASE_SENSITIVE" === i ? (e = e.toString(), t = t.toString(), e.substring(e.length - t.length, e.length) === t) : "STARTS_WITH_CASE_SENSITIVE" === i ? (t = t.toString(), e.toString().substring(0, t.length) === t) : "CONTAINS" === i ? -1 !== e.toString().toLowerCase().indexOf(t.toString().toLowerCase()) : "CONTAINS_CASE_SENSITIVE" === i ? -1 !== e.toString().indexOf(t.toString()) : "DOES_NOT_CONTAIN" === i ? -1 === e.toString().toLowerCase().indexOf(t.toString().toLowerCase()) : "DOES_NOT_CONTAIN_CASE_SENSITIVE" !== i || -1 === e.toString().indexOf(t.toString());
      };

      var s = [];

      if (n && n.indexOf && (0 <= n.indexOf("|") || 0 <= n.indexOf(" AND ") || 0 <= n.indexOf(" OR ") || 0 <= n.indexOf(" and ") || 0 <= n.indexOf(" or "))) {
        var _e267 = l(o, n);

        if (_e267) return _e267;

        var _t228 = 0 <= n.indexOf(" and ") ? n.split(" and ") : [],
            _i244 = 0 <= n.indexOf(" or ") ? n.split(" or ") : [],
            _a153 = 0 <= n.indexOf("|") ? n.split("|") : [];

        var _r44 = 0 <= n.indexOf(" AND ") ? n.split(" AND ") : [],
            d = 0 <= n.indexOf(" OR ") ? n.split(" OR ") : [];

        if (_r44 = _r44.concat(_t228), d = d.concat(_i244), 0 < _a153.length) for (var _e268 = 0; _e268 < _a153.length; _e268++) {
          _a153[_e268] = _a153[_e268].trim;
        }
        if (d = d.concat(_a153), 0 < _r44.length) for (var _e269 = 0; _e269 < _r44.length; _e269++) {
          0 <= !_r44[_e269].indexOf(" OR ") && s.push(_r44[_e269]);
        }
        if (0 < d.length) for (var _e270 = 0; _e270 < d.length; _e270++) {
          0 <= !d[_e270].indexOf(" AND ") && s.push(d[_e270]);
        }
        var c;

        for (var _t229 = 0; _t229 < s.length; _t229++) {
          var _i245 = s[_t229];

          if (_i245 && _i245.indexOf && 0 <= _i245.indexOf("..")) {
            var _t230 = _i245.toString().split("..");

            2 === _t230.length && (_e267 = o >= _t230[0] && o <= _t230[1]);
          } else _e267 = l(o, _i245);

          var _a154 = _t229 < _r44.length ? "and" : "or";

          c = void 0 === c ? _e267 : "or" == _a154 ? c || _e267 : c && _e267;
        }

        return c;
      }

      return n && n.indexOf && 0 <= n.indexOf("..") && (s = n.toString().split(".."), 2 === s.length) ? o >= s[0] && o <= s[1] : l(o, n);
    }
  }, {
    key: "evaluateTimeOnly",
    value: function evaluateTimeOnly(e) {
      var t = this,
          i = t.value;
      if (!i) return !e;
      if (!e || !(e instanceof Date)) return !1;
      var a = e.getHours(),
          n = i.getHours();
      if (a !== n) return !1;
      var o = e.getMinutes(),
          r = i.getMinutes();
      if (o !== r) return !1;
      var l = e.getSeconds(),
          s = i.getSeconds();
      return !(l !== s);
    }
  }]);

  return _class17;
}()), Smart.Utilities.Assign("CustomFilter",
/*#__PURE__*/
function () {
  "use strict";

  function _class18(e, t, i) {
    _classCallCheck(this, _class18);

    var a = this;
    a.value = e, a.condition = t, a.customfilter = i;
  }

  _createClass(_class18, [{
    key: "evaluate",
    value: function evaluate(e) {
      var t = this;
      return t.customfilter(t.value, e, t.condition);
    }
  }]);

  return _class18;
}()), Smart.FilterGroup = Smart.Utilities.FilterGroup, Smart.StringFilter = Smart.Utilities.StringFilter, Smart.NumericFilter = Smart.Utilities.NumericFilter, Smart.DateFilter = Smart.Utilities.DateFilter, Smart.CustomFilter = Smart.Utilities.CustomFilter;
var bigIntNativeSupport;

try {
  BigInt, bigIntNativeSupport = !0;
} catch (e) {
  bigIntNativeSupport = !1;
}

Smart.Utilities.Assign("BigNumber",
/*#__PURE__*/
function () {
  "use strict";

  function _class19(e, t, a) {
    _classCallCheck(this, _class19);

    var l = Math.abs,
        s = this,
        o;

    if (Smart.Utilities.BigNumber.bigIntSupport) {
      if (e instanceof Smart.Utilities.BigNumber) if (Array.isArray(e._d)) e = (e._s ? "-" : "") + (e._d.slice(0, e._f).join("") || "0") + (e._f == e._d.length ? "" : "." + e._d.slice(e._f).join(""));else return new Smart.Utilities.BigNumber(e._d);

      try {
        s._d = null === e ? BigInt(0) : "string" == typeof e && -1 !== e.toLowerCase().indexOf("e") ? BigInt(parseFloat(e)) : BigInt(e);
      } catch (t) {
        try {
          var _t231 = e.toString().split(".");

          var _i246 = BigInt(_t231[0]),
              _a155 = parseInt(_t231[1].charAt(0));

          if (0 < _i246 && 5 <= _a155) _i246 += BigInt(1);else if (0 > _i246) if (5 < _a155) _i246 -= BigInt(1);else if (5 === _a155) {
            var _e271 = 1,
                _a156 = _t231[1].charAt(_e271),
                _n120 = !1;

            for (; "" !== _a156;) {
              if (_e271++, _a156 = _t231[1].charAt(_e271), "0" !== _a156) {
                _n120 = !0;
                break;
              }
            }

            _n120 && (_i246 -= BigInt(1));
          }
          s._d = _i246;
        } catch (e) {
          s._d = BigInt(0);
        }
      }

      return s._f = s._d.toString().replace("-", "").length, void (s._s = 0 > s._d);
    }

    if (e instanceof Smart.Utilities.BigNumber) {
      if ("bigint" == typeof e._d) return new Smart.Utilities.BigNumber(e._d.toString());

      for (o in {
        precision: 0,
        roundType: 0,
        _s: 0,
        _f: 0
      }) {
        s[o] = e[o];
      }

      return s._d = e._d.slice(), void (e._s && 1 === e._d.length && 0 === e._d[0] && (s._s = !1));
    }

    if (void 0 !== e && ("-0" === e && (e = "0"), new RegExp(/e/i).test(e))) {
      var d = e.toString().toLowerCase(),
          c = d.indexOf("e"),
          m = new Smart.Utilities.BigNumber(d.slice(0, c)),
          u = d.slice(c + 2),
          g = d.slice(c + 1, c + 2),
          h = new Smart.Utilities.BigNumber(10),
          _ = h.pow(g + u),
          f = m.multiply(_);

      e = f.toString();
    }

    for (s.precision = isNaN(t = l(t)) ? Smart.Utilities.BigNumber.defaultPrecision : t, s.roundType = isNaN(a = l(a)) ? Smart.Utilities.BigNumber.defaultRoundType : a, s._s = "-" == (e += "").charAt(0), s._f = ((e = e.replace(/[^\d.]/g, "").split(".", 2))[0] = e[0].replace(/^0+/, "") || "0").length, o = (e = s._d = (e.join("") || "0").split("")).length; o; e[--o] = +e[o]) {
      ;
    }

    s.round();
  }

  _createClass(_class19, [{
    key: "add",
    value: function add(e) {
      if (Smart.Utilities.BigNumber.bigIntSupport) return new Smart.Utilities.BigNumber(this._d + new Smart.Utilities.BigNumber(e)._d);
      var t = this.normalizeOperand(this);
      if (e = t.normalizeOperand(e), t.isZero() && t._s && (t._s = !1), 0 === e || e.constructor === Smart.Utilities.BigNumber && 1 === e._d.length && 0 === e._d[0]) return new Smart.Utilities.BigNumber(t);
      if (t._s != (e = new Smart.Utilities.BigNumber(e))._s) return e._s ^= 1, t.subtract(e);
      var l = new Smart.Utilities.BigNumber(t),
          o = l._d,
          a = e._d,
          s = l._f,
          d = e._f,
          c,
          m;

      for (e = Math.max(s, d), s != d && (0 < (d = s - d) ? l._zeroes(a, d, 1) : l._zeroes(o, -d, 1)), c = (s = o.length) == (d = a.length) ? o.length : (0 < (d = s - d) ? l._zeroes(a, d) : l._zeroes(o, -d)).length, m = 0; c; m = (o[--c] = o[c] + a[c] + m) / 10 >>> 0, o[c] %= 10) {
        ;
      }

      return m && ++e && o.unshift(m), l._f = e, l.round();
    }
  }, {
    key: "subtract",
    value: function subtract(e) {
      if (Smart.Utilities.BigNumber.bigIntSupport) return new Smart.Utilities.BigNumber(this._d - new Smart.Utilities.BigNumber(e)._d);
      var t = this.normalizeOperand(this);
      if (e = t.normalizeOperand(e), t.isZero() && t._s && (t._s = !1), 0 === e || e.constructor === Smart.Utilities.BigNumber && 1 === e._d.length && 0 === e._d[0]) return new Smart.Utilities.BigNumber(t);
      if (t._s != (e = new Smart.Utilities.BigNumber(e))._s) return e._s ^= 1, t.add(e);
      var r = new Smart.Utilities.BigNumber(t),
          o = r.abs().compare(e.abs()) + 1,
          l = o ? r : e,
          s = o ? e : r,
          c = l._f,
          m = s._f,
          u = c,
          d,
          p;

      for (l = l._d, s = s._d, c != m && (0 < (m = c - m) ? r._zeroes(s, m, 1) : r._zeroes(l, -m, 1)), d = (c = l.length) == (m = s.length) ? l.length : (0 < (m = c - m) ? r._zeroes(s, m) : r._zeroes(l, -m)).length; d;) {
        if (l[--d] < s[d]) {
          for (p = d; p && !l[--p]; l[p] = 9) {
            ;
          }

          --l[p], l[d] += 10;
        }

        s[d] = l[d] - s[d];
      }

      return o || (r._s ^= 1), r._f = u, r._d = s, r.round();
    }
  }, {
    key: "multiply",
    value: function multiply(e) {
      if (Smart.Utilities.BigNumber.bigIntSupport) return new Smart.Utilities.BigNumber(this._d * new Smart.Utilities.BigNumber(e)._d);
      var t = this.normalizeOperand(this);
      e = t.normalizeOperand(e);
      var l = new Smart.Utilities.BigNumber(t),
          o = l._d.length >= (e = new Smart.Utilities.BigNumber(e))._d.length,
          d = (o ? l : e)._d,
          a = (o ? e : l)._d,
          c = d.length,
          m = a.length,
          u = new Smart.Utilities.BigNumber(),
          p,
          g,
          h;

      for (p = m; p; o && h.unshift(o), u.set(u.add(new Smart.Utilities.BigNumber(h.join(""))))) {
        for (h = Array(m - --p).join("0").split(""), o = 0, g = c; g; o += d[--g] * a[p], h.unshift(o % 10), o = o / 10 >>> 0) {
          ;
        }
      }

      return l._s = l._s != e._s, l._f = ((o = c + m - l._f - e._f) >= (g = (l._d = u._d).length) ? t._zeroes(l._d, o - g + 1, 1).length : g) - o, l.round();
    }
  }, {
    key: "divide",
    value: function divide(t) {
      if (Smart.Utilities.BigNumber.bigIntSupport) return new Smart.Utilities.BigNumber(this._d / new Smart.Utilities.BigNumber(t)._d);
      var d = this.normalizeOperand(this);
      if (t = d.normalizeOperand(t), "0" == (t = new Smart.Utilities.BigNumber(t))) throw new Error("Division by 0");else if ("0" == d) return new Smart.Utilities.BigNumber();
      var m = new Smart.Utilities.BigNumber(d),
          o = m._d,
          a = t._d,
          u = o.length - m._f,
          p = a.length - t._f,
          g = new Smart.Utilities.BigNumber(),
          r = 0,
          h = 1,
          _ = 0,
          v = 0,
          w,
          C,
          x;

      for (g._s = m._s != t._s, g.precision = Math.max(m.precision, t.precision), g._f = +g._d.pop(), u != p && m._zeroes(u > p ? a : o, Math.abs(u - p)), t._f = a.length, a = t, a._s = !1, a = a.round(), t = new Smart.Utilities.BigNumber(); "0" == o[0]; o.shift()) {
        ;
      }

      out: do {
        for (x = _ = 0, "0" == t && (t._d = [], t._f = 0); r < o.length && -1 == t.compare(a); ++r) {
          if ((x = r + 1 == o.length, !h && 1 < ++_ || (v = x && "0" == t && "0" == o[r])) && (g._f == g._d.length && ++g._f, g._d.push(0)), "0" == o[r] && "0" == t || (t._d.push(o[r]), ++t._f), v) break out;
          if (x && -1 == t.compare(a) && (g._f == g._d.length && ++g._f, 1) || (x = 0)) for (; g._d.push(0), t._d.push(0), ++t._f, -1 == t.compare(a);) {
            ;
          }
        }

        if (h = 0, -1 == t.compare(a) && !(x = 0)) for (; x ? g._d.push(0) : x = 1, t._d.push(0), ++t._f, -1 == t.compare(a);) {
          ;
        }
        var S;

        for (C = new Smart.Utilities.BigNumber(), w = 0; t.compare(S = C.add(a)) + 1 && ++w; C.set(S)) {
          ;
        }

        t.set(t.subtract(C)), x || g._f != g._d.length || ++g._f, g._d.push(w);
      } while ((r < o.length || "0" != t) && g._d.length - g._f <= g.precision);

      return g.round();
    }
  }, {
    key: "mod",
    value: function mod(e) {
      if (Smart.Utilities.BigNumber.bigIntSupport) return new Smart.Utilities.BigNumber(this._d % new Smart.Utilities.BigNumber(e)._d);
      var t = this.normalizeOperand(this);
      e = t.normalizeOperand(e);
      var i = t.subtract(t.divide(e).intPart().multiply(e));
      return i.isZero() && i._s && (i._s = !i._s), i;
    }
  }, {
    key: "pow",
    value: function pow(e) {
      if (Smart.Utilities.BigNumber.bigIntSupport) {
        var _t232 = BigInt(1);

        for (var _a157 = BigInt(0); _a157 < new Smart.Utilities.BigNumber(e)._d; _a157 += BigInt(1)) {
          _t232 *= this._d;
        }

        return new Smart.Utilities.BigNumber(_t232);
      }

      var t = this.normalizeOperand(this);
      e = t.normalizeOperand(e);
      var a = new Smart.Utilities.BigNumber(t),
          o;
      if (0 == (e = new Smart.Utilities.BigNumber(e).intPart())) return a.set(1);

      for (o = Math.abs(e); --o; a.set(a.multiply(t))) {
        ;
      }

      return 0 > e ? a.set(new Smart.Utilities.BigNumber(1).divide(a)) : a;
    }
  }, {
    key: "set",
    value: function set(e) {
      return e = new Smart.Utilities.BigNumber(e), this._d = e._d, this._f = e._f, this._s = e._s, this;
    }
  }, {
    key: "compare",
    value: function compare(e) {
      if (Smart.Utilities.BigNumber.bigIntSupport) {
        var _t233 = new Smart.Utilities.BigNumber(e)._d;
        return this._d === _t233 ? 0 : this._d > _t233 ? 1 : -1;
      }

      var t = this.normalizeOperand(this);
      e = t.normalizeOperand(e);
      var o = t,
          a = t._f,
          s = new Smart.Utilities.BigNumber(e),
          d = s._f,
          c = [-1, 1],
          r,
          m,
          u;
      if (o.isZero() && s.isZero()) return 0;
      if (o._s != s._s) return o._s ? -1 : 1;
      if (a != d) return c[a > d ^ o._s];

      for (a = (u = o._d).length, d = (s = s._d).length, r = -1, m = Math.min(a, d); ++r < m;) {
        if (u[r] != s[r]) return c[u[r] > s[r] ^ o._s];
      }

      return a == d ? 0 : c[a > d ^ o._s];
    }
  }, {
    key: "negate",
    value: function negate() {
      if (Smart.Utilities.BigNumber.bigIntSupport) return new Smart.Utilities.BigNumber(this._d * BigInt(-1));
      var e = this.normalizeOperand(this);
      var t = new Smart.Utilities.BigNumber(e);
      return t._s ^= 1, t;
    }
  }, {
    key: "abs",
    value: function abs() {
      if (Smart.Utilities.BigNumber.bigIntSupport) return new Smart.Utilities.BigNumber(0 > this._d ? this._d * BigInt(-1) : this._d);
      var e = this.normalizeOperand(this);
      var t = new Smart.Utilities.BigNumber(e);
      return t._s = 0, t;
    }
  }, {
    key: "intPart",
    value: function intPart() {
      if (Smart.Utilities.BigNumber.bigIntSupport) return new Smart.Utilities.BigNumber(this._d);
      var e = this.normalizeOperand(this);
      return new Smart.Utilities.BigNumber((e._s ? "-" : "") + (e._d.slice(0, e._f).join("") || "0"));
    }
  }, {
    key: "valueOf",
    value: function valueOf(e, t) {
      var i = this.normalizeOperand(this);
      return i.toString(e, t);
    }
  }, {
    key: "toString",
    value: function toString(e, t, i) {
      function a(e, t, i) {
        var a = "";

        if (String.prototype.repeat) {
          var n = "0".repeat(i - e.length);
          e = n + e;
        }

        for (; e.length < i;) {
          e = "0" + e;
        }

        a = e.replace(/0/g, "a"), a = a.replace(/1/g, "b"), a = a.replace(/a/g, "1"), a = a.replace(/b/g, "0");

        for (var o = !0, r = "", s = a.length - 1; 0 <= s; s--) {
          var d = a.charAt(s),
              c;
          "0" === d ? !0 === o ? (c = "1", o = !1) : c = "0" : !0 === o ? c = "0" : c = "1", r = c + "" + r;
        }

        switch (t) {
          case 2:
            return r;

          case 8:
            var m, u;
            8 === i ? (m = 3, u = "0") : 16 === i ? (m = 6, u = "00") : 32 === i ? (m = 11, u = "0") : 64 === i ? (m = 22, u = "00") : void 0, r = u + r;

            for (var p = "", g = m, h; 1 <= g; g--) {
              h = r[3 * g - 3] + "" + r[3 * g - 2] + "" + r[3 * g - 1], p = parseInt(h, 2).toString(8) + "" + p;
            }

            return p;

          case 16:
            var _;

            8 === i ? _ = 2 : 16 === i ? _ = 4 : 32 === i ? _ = 8 : 64 === i ? _ = 16 : void 0;

            for (var f = "", b = _, y; 1 <= b; b--) {
              y = r[4 * b - 4] + "" + r[4 * b - 3] + "" + r[4 * b - 2] + "" + r[4 * b - 1], f = parseInt(y, 2).toString(16) + "" + f;
            }

            return f.toUpperCase();
        }
      }

      function n(e) {
        var t = new Smart.Utilities.BigNumber(2),
            i = [],
            a,
            n;
        n = void 0 === e ? s : e;

        do {
          a = n.mod(t), i.push(a.toString()), n = n.subtract(a).divide(t).intPart();
        } while (1 === n.compare(new Smart.Utilities.BigNumber(0)));

        return i.reverse().join("");
      }

      function r(e) {
        for (var t = ""; 0 != e.length % 3;) {
          e = "0" + e;
        }

        for (var i = e.length / 3, a; 1 <= i; i--) {
          a = e[3 * i - 3] + "" + e[3 * i - 2] + "" + e[3 * i - 1], t = parseInt(a, 2).toString(8) + "" + t;
        }

        return t;
      }

      function l(e) {
        for (var t = ""; 0 != e.length % 4;) {
          e = "0" + e;
        }

        for (var i = e.length / 4, a; 1 <= i; i--) {
          a = e[4 * i - 4] + "" + e[4 * i - 3] + "" + e[4 * i - 2] + "" + e[4 * i - 1], t = parseInt(a, 2).toString(16) + "" + t;
        }

        return t;
      }

      var s, d;
      if (Smart.Utilities.BigNumber.bigIntSupport ? (s = this, d = Array.isArray(s._d) ? (s._s ? "-" : "") + (s._d.slice(0, s._f).join("") || "0") + (s._f == s._d.length ? "" : "." + s._d.slice(s._f).join("")) : this._d.toString()) : (s = this.normalizeOperand(this), d = (s._s ? "-" : "") + (s._d.slice(0, s._f).join("") || "0") + (s._f == s._d.length ? "" : "." + s._d.slice(s._f).join(""))), void 0 === e || 10 === e) return d;
      var c;
      if (-1 < s.compare(0)) 2 === e ? (c = n(), i && (c = c.padStart(t, "0"))) : 8 === e ? c = r(n()) : 16 === e ? (c = l(n()).toUpperCase(), i && (c = c.padStart(t / 4, "0"))) : void 0;else {
        var m = s.negate(),
            u = n(m);
        c = a(u, e, t);
      }
      return c;
    }
  }, {
    key: "_zeroes",
    value: function _zeroes(e, i, a) {
      var t = ["push", "unshift"][a || 0];

      for (++i; --i; e[t](0)) {
        ;
      }

      return e;
    }
  }, {
    key: "round",
    value: function round() {
      if ("_rounding" in this) return this;
      var e = Smart.Utilities.BigNumber,
          t = this.roundType,
          i = this._d,
          a,
          o,
          r,
          l;

      for (this._rounding = !0; 1 < this._f && !i[0]; --this._f, i.shift()) {
        ;
      }

      for (a = this._f, o = this.precision + a, r = i[o]; i.length > a && !i[i.length - 1]; i.pop()) {
        ;
      }

      return l = (this._s ? "-" : "") + (o - a ? "0." + this._zeroes([], o - a - 1).join("") : "") + 1, i.length > o && (r && t != e.DOWN && (t == e.UP || (t == e.CEIL ? !this._s : t == e.FLOOR ? this._s : t == e.HALF_UP ? 5 <= r : t == e.HALF_DOWN ? 5 < r : t == e.HALF_EVEN && 5 <= r && 1 & i[o - 1])) && this.add(l), i.splice(o, i.length - o)), (delete this._rounding, this);
    }
  }, {
    key: "isZero",
    value: function isZero() {
      return 1 === this._d.length && 0 === this._d[0];
    }
  }, {
    key: "normalizeOperand",
    value: function normalizeOperand(e) {
      return e instanceof Smart.Utilities.BigNumber && "bigint" == typeof e._d ? new Smart.Utilities.BigNumber(e._d.toString()) : e;
    }
  }], [{
    key: "defaultPrecision",
    get: function get() {
      return 40;
    }
  }, {
    key: "defaultRoundType",
    get: function get() {
      return 4;
    }
  }, {
    key: "bigIntSupport",
    get: function get() {
      return bigIntNativeSupport && !0 !== Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
    }
  }]);

  return _class19;
}()), Smart("smart-input",
/*#__PURE__*/
function (_Smart$BaseElement) {
  "use strict";

  _inherits(_class20, _Smart$BaseElement);

  function _class20() {
    _classCallCheck(this, _class20);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class20).apply(this, arguments));
  }

  _createClass(_class20, [{
    key: "template",
    value: function template() {
      return "<div id=\"inputContainer\"><input class=\"smart-input\" id='input' readonly='[[readonly]]' placeholder='[[placeholder]]' type='[[type]]' name='[[name]]' value='{{value::keyup}}' disabled='[[disabled]]' role='input'/><div id=\"dropDownButton\" tabindex=-1 class=\"smart-drop-down-button\"><div id=\"arrow\" class=\"arrow\"></div></div></div>";
    }
  }, {
    key: "focus",
    value: function focus() {
      var e = this;
      e.$.input.focus();
    }
  }, {
    key: "select",
    value: function select() {
      var e = this;
      e.readonly ? e.$.input.focus() : e.$.input.select();
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      return i === t || i === t.$.dropDownButton || i === t.$.input || i === t.$.arrow ? void 0 : t.$.scrollView.contains(i.shadowParent || i) ? void (t._isPointerDown && (t._isPointerDown = !1, t.opened && (t._preventLookup = !0), t.$.input.focus())) : void (t.opened && (t._preventLookup = !0), t._isPointerDown = !1, t.close());
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler() {
      var e = this;
      return e.setAttribute("focus", ""), e.readonly || 0 !== e.minLength || 0 !== e.$.input.value.length || e._preventLookup ? void delete e._preventLookup : void e._lookup();
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      var e = this;
      e.opened || e.removeAttribute("focus"), delete e._preventLookup;
    }
  }, {
    key: "_refreshMenu",
    value: function _refreshMenu() {
      var e = this;
      e.$.menu.classList.remove("scroll"), e.$.scrollView.computedVerticalScrollBarVisibility && e.$.menu.classList.add("scroll");
    }
  }, {
    key: "_performSelect",
    value: function _performSelect() {
      var e = this,
          t = e.$.menu.querySelector(".active"),
          i = t.getAttribute("data-label"),
          a = t.getAttribute("value"),
          n = e.value,
          o = e.$.input.dataValue;
      e.value = i, e.$.input.dataValue = a, (i !== n || a !== o) && e.$.fireEvent("change", {
        value: a,
        label: i,
        oldValue: o,
        oldLabel: n
      }), e.close();
    }
  }, {
    key: "_offsetTop",
    value: function _offsetTop(e) {
      var t = this;
      return e ? e.offsetTop + t._offsetTop(e.offsetParent) - (e.offsetParent ? e.offsetParent.verticalScrollBarVisibility ? 0 : e.offsetParent.scrollTop : 0) : 0;
    }
  }, {
    key: "_offsetLeft",
    value: function _offsetLeft(e) {
      var t = this;
      return e ? e.offsetLeft + t._offsetLeft(e.offsetParent) - (e.offsetParent ? e.offsetParent.horizontalScrollBarVisibility ? 0 : e.offsetParent.scrollLeft : 0) : 0;
    }
  }, {
    key: "_offset",
    value: function _offset(e) {
      return {
        left: this._offsetLeft(e),
        top: this._offsetTop(e)
      };
    }
  }, {
    key: "_open",
    value: function _open() {
      var e = Math.max;

      var t = this,
          i = t._offset(t);

      this.opened || (t.timer && clearTimeout(t.timer), document.body.appendChild(t.$.scrollView), t.$.scrollView.enableShadowDOM && !t._importedStyle && (t.$.scrollView.importStyle(t._getStyleUrl("smart.textbox.css")), t._importedStyle = !0), t.$.scrollView.style.setProperty("--smart-input-drop-down-menu-width", ""), t.$.scrollView.style.left = -3 + i.left + "px", t.$.scrollView.style.top = i.top + t.offsetHeight + 1 + "px", t.$.scrollView.classList.remove("open"), t.$.scrollView.onpointerdown = function () {
        t._isPointerDown = !0;
      }, requestAnimationFrame(function () {
        var i = t.dropDownWidth;

        if (t.$.scrollView.refresh(), t._refreshMenu(), t.$.scrollView.setAttribute("open", ""), t.setAttribute("open", ""), t.$.dropDownButton.setAttribute("open", ""), t.$.input.setAttribute("open", ""), i && "string" == typeof i && -1 !== i.indexOf("%")) {
          var _e272 = parseFloat(i) / 100;

          t.$.scrollView.style.setProperty("--smart-input-drop-down-menu-width", t.offsetWidth * _e272 + "px");
        } else if ("auto" !== i && i) t.$.scrollView.style.setProperty("--smart-input-drop-down-menu-width", parseFloat(i) + "px");else if ("auto" === i) t.$.scrollView.style.setProperty("--smart-input-drop-down-menu-width", "");else {
          t.$.menu.style.width = "auto";
          var _i247 = t.$.menu.offsetWidth;

          var _a158 = t.$.menu.querySelectorAll("li");

          for (var _n121 = 0; _n121 < _a158.length; _n121++) {
            t._maxDropDownWidth = e(_a158[_n121].firstElementChild.offsetWidth, t._maxDropDownWidth);
          }

          t.$.scrollView.computedVerticalScrollBarVisibility && (_i247 += t.$.scrollView.$ && t.$.scrollView.$.verticalScrollBar ? t.$.scrollView.$.verticalScrollBar.offsetWidth : 30), t.$.scrollView.style.setProperty("--smart-input-drop-down-menu-width", e(_i247, t.offsetWidth - 8) + "px"), t.$.menu.style.width = "";
        }

        (t.shadowRoot || t.isInShadowDOM) && t.$.scrollView._scrollView && Smart.ScrollBar && requestAnimationFrame(function () {
          return t.$.scrollView._scrollView.vScrollBar.refresh();
        });
      }), t.$.scrollView.refresh(), t._refreshMenu(), this.opened = !0);
    }
  }, {
    key: "close",
    value: function close() {
      var e = this;
      return !!e.opened && (e.timer && clearTimeout(e.timer), e.timer = setTimeout(function () {
        e.$.scrollView.parentNode && !e.opened && document.body.removeChild(e.$.scrollView);
      }, 1e3), e.$.scrollView.removeAttribute("open"), e.$.dropDownButton.removeAttribute("open"), e.$.input.removeAttribute("open"), e.removeAttribute("open"), e.opened = !1, e.$.input.focus(), !0);
    }
  }, {
    key: "_lookup",
    value: function _lookup(e) {
      var t = this;
      var i = [];
      return t.query = t.$.input.value, t.$.input.readonly && (!t._incrementalSearchQuery && (t._incrementalSearchQuery = ""), t._incrementalSearchQuery += e.key, t._incrementalSearchTimer && clearTimeout(t._incrementalSearchTimer), t.query = t._incrementalSearchQuery, t._incrementalSearchTimer = setTimeout(function () {
        t._incrementalSearchQuery = "";
      }, 700)), t.query.length < t.minLength ? void t.close() : void (i = "function" == typeof t.dataSource ? t.dataSource(t.query) : t.dataSource, clearTimeout(t._autoCompleteTimeout), t._autoCompleteTimeout = setTimeout(function () {
        var e = t.context;
        t.context = t, t._process(i), t.context = e;
      }, t.autoCompleteDelay));
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;
      t.readonly && t._dropDownButtonDownHandler(e);
    }
  }, {
    key: "_dropDownButtonDownHandler",
    value: function _dropDownButtonDownHandler(e) {
      var t = this;
      return t._toggle(), e.preventDefault(), e.stopPropagation(), e.originalEvent.preventDefault(), e.originalEvent.stopPropagation(), !1;
    }
  }, {
    key: "_toggle",
    value: function _toggle() {
      var e = this;
      e.opened ? e.close() : e.open();
    }
  }, {
    key: "open",
    value: function open() {
      var e = this;
      var t;
      e.dropDownDataSource ? (e.query = "", t = "function" == typeof e.dataSource ? e.dataSource(e.query) : e.dataSource) : t = "function" == typeof e.dropDownDataSource ? e.dropDownDataSource(e.query) : e.dropDownDataSource, e._process(t);
      var i = e.$.menu.querySelector(".active");

      if (i) {
        var _t234 = e.$.input.dataValue;

        for (var _a159 = 0; _a159 < e.$.menu.children.length; _a159++) {
          var _n122 = e.$.menu.children[_a159],
              _o79 = _n122.getAttribute("data-label"),
              r = _n122.getAttribute("value");

          if (_t234 !== void 0 && r === _t234 || _t234 === void 0 && _o79 === e.$.input.value) {
            i.classList.remove("active"), _n122.classList.add("active"), e.$.input.dataValue = r;
            break;
          }
        }
      }

      e.ensureVisible(), e.$.input.focus(), setTimeout(function () {
        e.$.input.focus();
      }, 25);
    }
  }, {
    key: "_process",
    value: function _process(e) {
      var t = this;
      "string" == typeof e && (e = t.$.deserialize(e, "array")), e = e.filter(function (e) {
        return t.matcher ? t.matcher(e) : t._matcher(e);
      }), e = t._sorter(e), t.sorted && (e.sort(function (e, t) {
        return void 0 === e.label ? e.localeCompare(t) : e.label.localeCompare(t.label);
      }), "desc" === t.sortDirection && e.reverse()), !e.length && t.opened && t.close();
      0 === e.length || (0 < t.query.length ? t._render(e.slice(0, t.items)) : t._render(e), t._open(), t.$.scrollView.refresh(), t._refreshMenu(), t.ensureVisible());
    }
  }, {
    key: "_matcher",
    value: function _matcher(e) {
      var t = this,
          i = t.query;

      switch (e = e.label || e, t.queryMode) {
        case "startsWith":
          return e.startsWith(i);

        case "startsWithIgnoreCase":
          return e.toLowerCase().startsWith(i.toLowerCase());

        case "doesNotContain":
          return 0 > e.indexOf(i);

        case "doesNotContainIgnoreCase":
          return 0 > e.toLowerCase().indexOf(i.toLowerCase());

        case "contains":
          return -1 < e.indexOf(i);

        default:
        case "containsIgnoreCase":
          return ~e.toLowerCase().indexOf(i.toLowerCase());

        case "equals":
          return 0 === e.localeCompare(i);

        case "equalsIgnoreCase":
          return 0 === e.toLowerCase().localeCompare(i.toLowerCase());

        case "endsWith":
          return e.endsWith(i);

        case "endsWithIgnoreCase":
          return e.toLowerCase().endsWith(i.toLowerCase());
      }
    }
  }, {
    key: "_sorter",
    value: function _sorter(e) {
      var t = this;
      var i = [],
          a = [],
          n = [],
          o;

      for (; o = e.shift();) {
        var _e273 = o.label || o;

        _e273.toLowerCase().indexOf(t.query.toLowerCase()) ? ~_e273.indexOf(t.query) ? a.push(o) : n.push(o) : i.push(o);
      }

      return i.concat(a, n);
    }
  }, {
    key: "_highlighter",
    value: function _highlighter(e) {
      var t = this,
          i = t.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
      return e.replace(new RegExp("(" + i + ")", "ig"), function (e, t) {
        return "<strong>" + t + "</strong>";
      });
    }
  }, {
    key: "_render",
    value: function _render(e) {
      function t() {
        var e = a.$.menu.getElementsByClassName("active");
        e[0] && e[0].classList.remove("active"), this.classList.add("active");
      }

      var a = this,
          n = e.map(function (e) {
        var t = e,
            i = e;
        "object" == typeof e && (t = e.label, i = e.value || t);
        var n = document.createElement("li"),
            o = document.createElement("a");
        return o.href = "#", n.setAttribute("data-label", t), n.setAttribute("value", i), o.innerHTML = a.highlighter ? a.highlighter(t) : a._highlighter(t), e.icon && (o.classList.add("icon"), o.classList.add(e.icon)), n.appendChild(o), n;
      });
      0 < n.length && n[0].classList.add("active"), a.$.menu.innerHTML = "";

      for (var _o80 = 0; _o80 < n.length; _o80++) {
        var _e274 = n[_o80];
        a.$.menu.appendChild(_e274), _e274.onmouseenter = t, _e274.onmouseleave = function () {
          this.classList.remove("active");
        }, _e274.onclick = t;
      }
    }
  }, {
    key: "ensureVisible",
    value: function ensureVisible() {
      var e = this,
          t = e.$.menu.querySelector(".active");
      t && (t.offsetTop + t.offsetHeight >= e.$.scrollView.scrollTop + e.$.scrollView.offsetHeight && (e.$.scrollView.scrollTop = t.offsetTop + t.offsetHeight), (t.offsetTop <= e.$.scrollView.scrollTop || t.offsetTop >= e.$.scrollView.scrollTop + e.$.scrollView.offsetHeight) && (e.$.scrollView.scrollTop = t.offsetTop), 0 === _toConsumableArray(e.$.menu.children).indexOf(t) ? e.$.scrollView.scrollTop = 0 : _toConsumableArray(e.$.menu.children).indexOf(t) === e.$.menu.children.length - 1 && (e.$.scrollView.scrollTop = e.$.scrollView.scrollHeight));
    }
  }, {
    key: "_next",
    value: function _next() {
      var e = this,
          t = e.$.menu.querySelector(".active");
      if (!t) return void e.$.menu.firstElementChild.classList.add("active");
      t.classList.remove("active");
      var i = t.nextElementSibling;
      i || (i = e.$.menu.firstElementChild), i.classList.add("active"), e.ensureVisible();
    }
  }, {
    key: "_prev",
    value: function _prev() {
      var e = this,
          t = e.$.menu.querySelector(".active");
      if (!t) return void e.$.menu.firstElementChild.classList.add("active");
      t.classList.remove("active");
      var i = t.previousElementSibling;
      i || (i = e.$.menu.lastElementChild), i.classList.add("active"), e.ensureVisible();
    }
  }, {
    key: "_move",
    value: function _move(e) {
      var t = this;

      if (t.opened) {
        switch (e.keyCode) {
          case 9:
          case 13:
          case 27:
            e.preventDefault();
            break;

          case 38:
            e.preventDefault(), t._prev();
            break;

          case 40:
            e.preventDefault(), t._next();
        }

        e.stopPropagation();
      }
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this;
      t._suppressKeyPressRepeat = ![40, 38, 9, 13, 27, 16, 17, 18].includes(e.keyCode);
      e.shiftKey || e.altKey || e.ctrlKey || t._move(e);
    }
  }, {
    key: "_keyPressHandler",
    value: function _keyPressHandler(e) {
      var t = this;
      t._suppressKeyPressRepeat || e.shiftKey || e.altKey || e.ctrlKey || t._move(e);
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this;
      if (!(e.shiftKey || e.altKey || e.ctrlKey)) switch (e.keyCode) {
        case 40:
        case 38:
        case 16:
        case 17:
        case 18:
          40 === e.keyCode && e.altKey && t.open(), 38 === e.keyCode && e.altKey && t.close();
          break;

        case 9:
        case 13:
          if (!t.opened) return;
          t._performSelect(), e.stopPropagation(), e.preventDefault();
          break;

        case 27:
          if (!t.opened) return;
          t.close(), e.stopPropagation(), e.preventDefault();
          break;

        default:
          t._lookup(e), !t.opened || e.ctrlKey || e.shiftKey || (e.stopPropagation(), e.preventDefault()), t.$.input.dataValue = t.$.input.value;
      }
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class20.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      "dropDownHeight" === e && a.$.scrollView.style.setProperty("--smart-input-drop-down-menu-height", a.dropDownHeight + "px"), "opened" === e && (i ? a.open() : a.close()), ("theme" === e || "rightToLeft" === e) && (a.$.scrollView[e] = i);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this,
          t = document.createElement("ul"),
          i = document.createElement("smart-scroll-viewer");
      i.rightToLeft = e.rightToLeft, i.theme = e.theme, i.horizontalScrollBarVisibility = "hidden", i.appendChild(t), i.style.setProperty("--smart-input-drop-down-menu-height", e.dropDownHeight + "px"), i.classList.add("smart-input-drop-down-menu"), i.id = e.id + "_" + e.tagName.toLowerCase() + "_menu_" + Math.floor(65536 * (1 + Math.random())).toString(16).substring(1), e.setAttribute("aria-controls", i.id), i.ownerElement = e, e.$.scrollView = i, e.$.menu = t, e.opened && e.open(), e.opened = !1, e.$.menu.onclick = function (t) {
        t.stopPropagation(), t.preventDefault(), e._performSelect(), e.$.input.focus();
      }, _get(_getPrototypeOf(_class20.prototype), "render", this).call(this);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoCompleteDelay: {
          value: 100,
          type: "number"
        },
        dataSource: {
          type: "any",
          value: []
        },
        dropDownDataSource: {
          type: "any",
          value: []
        },
        dropDownHeight: {
          type: "any",
          value: 200
        },
        dropDownWidth: {
          type: "any",
          value: null
        },
        dropDownButtonPosition: {
          allowedValues: ["none", "left", "right"],
          value: "none",
          type: "string"
        },
        items: {
          type: "number",
          value: 8
        },
        minLength: {
          type: "number",
          value: 1
        },
        name: {
          value: "",
          type: "string"
        },
        opened: {
          value: !1,
          type: "boolean"
        },
        query: {
          type: "string",
          value: ""
        },
        queryMode: {
          allowedValues: ["contains", "containsIgnoreCase", "doesNotContain", "doesNotContainIgnoreCase", "equals", "equalsIgnoreCase", "startsWith", "startsWithIgnoreCase", "endsWith", "endsWithIgnoreCase"],
          type: "string",
          value: "containsIgnoreCase"
        },
        placeholder: {
          value: "",
          type: "string"
        },
        readonly: {
          type: "boolean",
          value: !1
        },
        sorted: {
          value: !1,
          type: "boolean"
        },
        sortDirection: {
          value: "asc",
          type: "string"
        },
        type: {
          type: "string"
        },
        value: {
          type: "string",
          value: ""
        }
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.textbox.css"];
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "input.focus": "_focusHandler",
        "input.blur": "_blurHandler",
        "input.keydown": "_keyDownHandler",
        "input.keyup": "_keyUpHandler",
        "input.keypress": "_keyPressHandler",
        "dropDownButton.down": "_dropDownButtonDownHandler",
        "inputContainer.down": "_downHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }]);

  return _class20;
}(Smart.BaseElement)), Smart("smart-breadcrumb",
/*#__PURE__*/
function (_Smart$BaseElement2) {
  "use strict";

  _inherits(_class21, _Smart$BaseElement2);

  function _class21() {
    _classCallCheck(this, _class21);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class21).apply(this, arguments));
  }

  _createClass(_class21, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div id=\"minimizedHeader\" class=\"smart-header smart-minimized-header smart-hidden\" role=\"presentation\">\n                        <div id=\"hamburgerIcon\" class=\"smart-hamburger-icon\" role=\"button\" aria-label=\"Toggle\" aria-haspopup=\"dialog\" aria-expanded=\"false\">\n                            <div id=\"hamburgerIconLineTop\" class=\"smart-hamburger-icon-line smart-hamburger-icon-line-top\" role=\"presentation\"></div>\n                            <div id=\"hamburgerIconLineCenter\" class=\"smart-hamburger-icon-line smart-hamburger-icon-line-center\" role=\"presentation\"></div>\n                            <div id=\"hamburgerIconLineBottom\" class=\"smart-hamburger-icon-line smart-hamburger-icon-line-bottom\" role=\"presentation\"></div>\n                        </div>\n                    </div>\n                    <template>\n                        <div class=\"smart-breadcrumb-items\" *items={{dataSource}} role=\"list\">\n                            <div class=\"smart-breadcrumb-item\" role=\"listitem\" aria-label={{item.label}}>\n                                <div class=\"smart-breadcrumb-item-label\" inner-H-T-M-L={{item.label}} role=\"presentation\"></div>\n                                <div class=\"smart-close-button\" role=\"button\" aria-label=\"Close\">&#xe81f</div>\n                            </div>\n                        </div>\n                    </template>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class21.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      switch (e) {
        case "addNewItem":
          i ? a._appendNewItemButton() : (a.$.templateContainer.firstElementChild.removeChild(a._addNewItemButton), delete a._addNewItemButton), a._setIndentation();
          break;

        case "animation":
        case "disabled":
        case "unfocusable":
          a.addNewItem && (a._addNewItemButton[e] = i), "disabled" === e && a._minimizedDropDownOpened && a._hamburgerIconClickHandler();
          break;

        case "itemTemplate":
          for (var _e275 = 0; _e275 < a._items.length; _e275++) {
            a._items[_e275].firstElementChild.innerHTML = a.dataSource[_e275].label;
          }

          i && a._applyTemplate();
          break;

        case "minimizeWidth":
          null !== i && a.offsetWidth <= i ? a.minimize() : a.maximize();
          break;

        case "closeButtons":
          a._minimized || a._setIndentation();
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class21.prototype), "ready", this).call(this);

      var e = this;
      e.setAttribute("role", "navigation"), e.$.container.children[1].setAttribute("id", e.id + "TemplateContainer"), e.$.container.children[1].setAttribute("role", "presentation"), e.$.hamburgerIcon.setAttribute("aria-controls", e.id + "TemplateContainer"), e._edgeMacFF = Smart.Utilities.Core.Browser.Edge || Smart.Utilities.Core.Browser.Firefox && -1 !== navigator.platform.toLowerCase().indexOf("mac"), e.templateContainer = e.$.container.children[1], null !== e.minimizeWidth && e.offsetWidth <= e.minimizeWidth && e.minimize();
    }
  }, {
    key: "templateAttached",
    value: function templateAttached() {
      this._handleDataSourceRefresh();
    }
  }, {
    key: "addItem",
    value: function addItem(e) {
      var t = this,
          i = t.dataSource.slice(0);
      !e || "object" != typeof e || isNaN(e.index) || 0 > e.index || (i.splice(e.index, 0, {
        label: e.label,
        value: e.value
      }), t.dataSource = i);
    }
  }, {
    key: "maximize",
    value: function maximize() {
      var e = this;
      e._minimized && (e.$minimizedHeader.addClass("smart-hidden"), e.templateContainer.classList.remove("smart-visibility-hidden"), e._edgeMacFF && e.templateContainer.classList.remove("not-in-view"), e.$hamburgerIcon.removeClass("smart-close-button"), e.removeAttribute("minimized"), e.$.container.children[1].setAttribute("role", "presentation"), e._minimizedDropDownOpened = !1, e._minimized = !1, e._setIndentation());
    }
  }, {
    key: "minimize",
    value: function minimize() {
      var e = this;
      if (e._minimized) return;
      var t = e.animation,
          i = e.hasAnimation;
      i && (e.animation = "none"), e.$minimizedHeader.removeClass("smart-hidden"), e.templateContainer.classList.add("smart-visibility-hidden"), e._edgeMacFF && e.templateContainer.classList.add("not-in-view"), i && setTimeout(function () {
        e.animation = t;
      }, 0), e.setAttribute("minimized", ""), e.$.container.children[1].setAttribute("role", "dialog"), e._minimized = !0, e._setIndentation();
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      var t = this,
          i = t._items.indexOf(e),
          a = t.dataSource.slice(0);

      -1 === i || (a.splice(i, 1), t.dataSource = a);
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      null !== e.minimizeWidth && e.offsetWidth <= e.minimizeWidth ? e.minimize() : e._minimized ? e.maximize() : e._setIndentation();
    }
  }, {
    key: "_containerClickHandler",
    value: function _containerClickHandler(e) {
      var t = this;

      if (!t.disabled && t.templateContainer.contains(e.target)) {
        var _i248 = e.target.closest(".smart-close-button");

        if (_i248) {
          var _e276 = _i248.closest(".smart-breadcrumb-item"),
              _a160 = t.$.fireEvent("closing", {
            item: _e276
          });

          if (!_a160.defaultPrevented) {
            var _i249 = t.dataSource.slice(0);

            _i249.splice(t._items.indexOf(_e276), 1), t.dataSource = _i249, t.$.fireEvent("close", {
              item: _e276
            });
          }
        }
      }
    }
  }, {
    key: "_containerDownHandler",
    value: function _containerDownHandler(e) {
      var t = this,
          i = e.originalEvent.target;

      if (!(!t.allowDrag || t.disabled || i.classList.contains("smart-close-button"))) {
        var _a161 = i.closest(".smart-breadcrumb-item");

        _a161 && (t._dragDetails = {
          item: _a161,
          x: e.pageX,
          y: e.pageY
        });
      }
    }
  }, {
    key: "_containerTransitionendHandler",
    value: function _containerTransitionendHandler(e) {
      var t = this;
      t._edgeMacFF && e.target === t.templateContainer && !t._minimizedDropDownOpened && t.hasAnimation && t.templateContainer.classList.add("not-in-view");
    }
  }, {
    key: "_hamburgerIconClickHandler",
    value: function _hamburgerIconClickHandler() {
      var e = this;
      e._minimizedDropDownOpened ? (e.$hamburgerIcon.removeClass("smart-close-button"), e.templateContainer.classList.add("smart-visibility-hidden"), e.$.hamburgerIcon.setAttribute("aria-expanded", !1), e._minimizedDropDownOpened = !1) : (e.$hamburgerIcon.addClass("smart-close-button"), e._edgeMacFF && e.templateContainer.classList.remove("not-in-view"), e.templateContainer.classList.remove("smart-visibility-hidden"), e.$.hamburgerIcon.setAttribute("aria-expanded", !0), e._minimizedDropDownOpened = !0);
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = Math.abs;
      var a = this,
          i = a._dragDetails;
      if (!i) return;
      var n = i.feedback;
      if (e.originalEvent.preventDefault(), !n) if (5 < t(i.x - e.pageX) || 5 < t(i.y - e.pageY)) n = document.createElement("div"), n.className = "smart-breadcrumb-feedback", n.style.height = a._dragDetails.item.offsetHeight + "px", n.innerHTML = a._dragDetails.item.firstElementChild.innerHTML, document.body.appendChild(n), i.feedback = n, a._getItemCoordinates();else return;
      a.rightToLeft ? n.setAttribute("right-to-left", !0) : n.removeAttribute("right-to-left");
      var o = Smart.Utilities.Core.isMobile ? document.elementFromPoint(e.clientX, e.clientY) : a.shadowRoot || a.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      if (n.style.left = e.pageX + 10 + "px", n.style.top = e.pageY + 10 + "px", !a.allowDrop) return n.classList.add("error"), void a.$.fireEvent("dragging", {
        item: i.item,
        target: o,
        originalEvent: e.originalEvent
      });
      if (delete i.target, a._clearItemDragClass(), !(a.shadowRoot || a).contains(o)) return n.classList.add("error"), void a.$.fireEvent("dragging", {
        item: i.item,
        target: o,
        originalEvent: e.originalEvent
      });
      var r = o.closest(".smart-breadcrumb-item");
      if (r) return void a._applyItemDragClass(r, r.getBoundingClientRect(), e);
      if (a._minimized) return n.classList.add("error"), void a.$.fireEvent("dragging", {
        item: i.item,
        target: o,
        originalEvent: e.originalEvent
      });

      if ((a.shadowRoot || a).contains(o)) {
        var _t235 = a._itemCoordinates.rows,
            _n123 = a._itemCoordinates.coordinates,
            _r45 = parseFloat(window.getComputedStyle(a).getPropertyValue("--smart-breadcrumb-padding")) / 2;

        var _l27;

        for (var _a162 = 0; _a162 < _t235.length; _a162++) {
          if (e.clientY < _t235[_a162].bottom + _r45) {
            _l27 = _a162;
            break;
          }
        }

        if (void 0 === _l27) return i.feedback.classList.add("error"), void a.$.fireEvent("dragging", {
          item: i.item,
          target: o,
          originalEvent: e.originalEvent
        });
        var _s17 = a._items[_n123[_l27][_n123[_l27].length - 1].index],
            d;

        for (var _t236 = 0; _t236 < _n123[_l27].length; _t236++) {
          if (d = _n123[_l27][_t236].rect, e.clientX < d.right + _r45) {
            _s17 = a._items[_n123[_l27][_t236].index];
            break;
          }
        }

        return void a._applyItemDragClass(_s17, d, e);
      }
    }
  }, {
    key: "_getItemCoordinates",
    value: function _getItemCoordinates() {
      var e = this,
          t = e._items,
          a = [[]],
          n = [];
      var o = t[0].offsetTop,
          r = 0;
      a[0].push({
        index: 0,
        rect: t[0].getBoundingClientRect()
      }), n[0] = {
        top: a[0][0].rect.top,
        bottom: a[0][0].rect.bottom
      };

      for (var _e277 = 1; _e277 < t.length; _e277++) {
        var _i250 = t[_e277],
            _l28 = _i250.getBoundingClientRect(),
            _s18 = t[_e277].offsetTop;

        _s18 > o && (o = _s18, r++, a[r] = [], n[r] = {
          top: _l28.top,
          bottom: _l28.bottom
        }), a[r].push({
          index: _e277,
          rect: _l28
        });
      }

      e._itemCoordinates = {
        coordinates: a,
        rows: n
      };
    }
  }, {
    key: "_applyItemDragClass",
    value: function _applyItemDragClass(e, t, i) {
      var a = this,
          n = a._dragDetails;
      var o, r, l;
      n.target = e, n.feedback.classList.remove("error"), n.before = !1, a._minimized ? (o = i.clientY, r = "top", l = "height") : (o = i.clientX, r = "left", l = "width");
      var s = e[(a.rightToLeft ? "previous" : "next") + "ElementSibling"];
      o <= t[r] + t[l] / 2 ? (e.classList.add("target"), n.before = !0) : s ? s.classList.add("target") : e.classList.add("afterTarget"), a.rightToLeft && (n.before = !n.before), a.$.fireEvent("dragging", {
        item: n.item,
        target: e,
        originalEvent: i.originalEvent
      });
    }
  }, {
    key: "_clearItemDragClass",
    value: function _clearItemDragClass() {
      var e = (this.shadowRoot || this).querySelector(".target, .afterTarget");
      e && (e.classList.remove("target"), e.classList.remove("afterTarget"));
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = t._dragDetails;

      if (i && (delete t._dragDetails, i.feedback)) {
        if (document.body.removeChild(i.feedback), t._clearItemDragClass(), !t.allowDrop) return;
        if (!i.target || i.item === i.target) return void t.$.fireEvent("dragEnd", {
          item: i.item,
          target: i.target || !Smart.Utilities.Core.isMobile ? t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target : document.elementFromPoint(e.clientX, e.clientY),
          originalEvent: e.originalEvent
        });

        var _a163 = t._items.slice(0),
            _n124 = _a163.indexOf(i.item),
            _o81 = t.dataSource.slice(0),
            r = _o81.splice(_n124, 1);

        _a163.splice(_n124, 1);

        var _l29 = _a163.indexOf(i.target) + (i.before ? 0 : 1);

        _n124 !== _l29 && (_o81.splice(_l29, 0, r[0]), t.dataSource = _o81), t.$.fireEvent("dragEnd", {
          item: i.item,
          target: i.target,
          droppedBeforeTarget: i.before,
          originalEvent: e.originalEvent
        });
      }
    }
  }, {
    key: "_handleDataSourceRefresh",
    value: function _handleDataSourceRefresh() {
      var e = this;
      e._items = Array.from(e.$.templateContainer.firstElementChild.children), e.addNewItem && e._appendNewItemButton(), e._applyTemplate(), e._setIndentation();
    }
  }, {
    key: "_appendNewItemButton",
    value: function _appendNewItemButton() {
      var e = this,
          t = document.createElement("smart-button");
      t.innerHTML = "+", t.animation = e.animation, t.disabled = e.disabled, t.unfocusable = e.unfocusable, t.setAttribute("aria-label", "Add"), t.addEventListener("click", function () {
        e.$.fireEvent("addNewItem");
      }), e.$.templateContainer.firstElementChild.appendChild(t), e._addNewItemButton = t;
    }
  }, {
    key: "_setIndentation",
    value: function _setIndentation() {
      var e = this,
          t = e._items.slice(0);

      if (e._addNewItemButton && t.push(e._addNewItemButton), 0 === t.length) return;
      var a = t[0].offsetTop,
          n = 0;
      if (t.forEach(function (e) {
        e.style.marginLeft = e.style.marginRight = null;
      }), !e._minimized) for (var _o82 = 1; _o82 < t.length; _o82++) {
        var _i251 = t[_o82],
            r = t[_o82].offsetTop;
        r > a && (a = r, n++, _i251.style["margin" + (e.rightToLeft ? "Right" : "Left")] = 10 * n + "px");
      }
    }
  }, {
    key: "_applyTemplate",
    value: function _applyTemplate() {
      var e = this,
          t = e.itemTemplate;
      if (null === t) return;
      var i;

      if (i = t instanceof HTMLTemplateElement ? t : document.getElementById(t), null !== i && i instanceof HTMLTemplateElement) {
        var _t237 = document.importNode(i.content, !0),
            _a164 = document.createElement("div");

        _a164.appendChild(_t237);

        var _n125 = _a164.innerHTML;

        for (var _t238 = 0; _t238 < e._items.length; _t238++) {
          var _i252 = e.dataSource,
              _a165 = _i252[_t238].label,
              _o83 = _i252[_t238].value,
              r = e._items[_t238].firstElementChild;
          r.innerHTML = _n125.replace(/{{label}}/g, _a165).replace(/{{value}}/g, _o83);
        }
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        addNewItem: {
          value: !1,
          type: "boolean"
        },
        allowDrag: {
          value: !1,
          type: "boolean"
        },
        allowDrop: {
          value: !1,
          type: "boolean"
        },
        closeButtons: {
          value: !1,
          type: "boolean"
        },
        dataSource: {
          value: [],
          type: "array",
          reflectToAttribute: !1
        },
        itemTemplate: {
          value: null,
          type: "any"
        },
        minimizeWidth: {
          value: 150,
          type: "number?"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        move: "_moveHandler",
        resize: "_resizeHandler",
        "container.click": "_containerClickHandler",
        "container.down": "_containerDownHandler",
        "container.transitionend": "_containerTransitionendHandler",
        "hamburgerIcon.click": "_hamburgerIconClickHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.breadcrumb.css"];
    }
  }]);

  return _class21;
}(Smart.BaseElement)), Smart.Utilities.Assign("NumericProcessor",
/*#__PURE__*/
function () {
  "use strict";

  function _class22(e, t) {
    _classCallCheck(this, _class22);

    switch (e[t]) {
      case "integer":
        return new Smart.Utilities.IntegerNumericProcessor(e, t);

      case "floatingPoint":
        return new Smart.Utilities.DecimalNumericProcessor(e, t);

      case "complex":
        return new Smart.Utilities.ComplexNumericProcessor(e, t);
    }
  }

  return _class22;
}()), Smart.Utilities.Assign("BaseNumericProcessor",
/*#__PURE__*/
function () {
  "use strict";

  function _class23(e, t) {
    _classCallCheck(this, _class23);

    var i = this;
    i.context = e, i._longestLabelSize = 0, i.numericFormatProperty = t, i.regexScientificNotation = new RegExp(/^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)(Y|Z|E|P|T|G|M|k|c|m|u|n|p|f|a|z|y){1}$/), i.regexNoLeadingZero = new RegExp(/^(-)?[.]\d+$/), i.regexLeadingZero = new RegExp(/^[+\-]?(0+)[1-9]+|^[+\-]?(0{2,})[.]|^(0{2,})$/), i.prefixesToPowers = {
      Y: 24,
      Z: 21,
      E: 18,
      P: 15,
      T: 12,
      G: 9,
      M: 6,
      k: 3,
      c: -2,
      m: -3,
      u: -6,
      n: -9,
      p: -12,
      f: -15,
      a: -18,
      z: -21,
      y: -24
    }, i.complexConstructor = window.NIComplex ? window.NIComplex : Smart.Utilities.Complex;
  }

  _createClass(_class23, [{
    key: "prepareForValidation",
    value: function prepareForValidation(e, t, i) {
      var a = this.context,
          n = e || void 0 !== t;

      if (i = i.toString(), i = i.replace(/\s/g, ""), i = a._discardDecimalSeparator(i), this.regexLeadingZero.test(i)) {
        var _e278 = this.regexLeadingZero.exec(i);

        i = _e278[1] ? i.replace(_e278[1], "") : _e278[2] ? i.replace(_e278[2], "0") : i.replace(_e278[3], "0");
      }

      this.regexNoLeadingZero.test(i) ? "-" === i.charAt(0) ? i = "-0" + i.slice(1) : i = "0" + i : ("integer" === a[this.numericFormatProperty] && (10 === a._radixNumber || n) || "floatingPoint" === a[this.numericFormatProperty]) && this.regexScientificNotation.test(i) && (i = this.scientificToDecimal(i));
      var o = !1,
          r;
      if ("complex" === a[this.numericFormatProperty] && !1 === a._regexSpecial.nonNumericValue.test(i)) try {
        if (a._regexSpecial.exaValue.test(i)) {
          var _e279 = i.indexOf("E"),
              _t239 = 1000000000000000000 * parseFloat(i.slice(0, _e279)),
              _a166 = parseFloat(i.slice(_e279 + 1, -1));

          r = new this.complexConstructor(_t239, _a166);
        } else r = new this.complexConstructor(i);

        o = !0;
      } catch (e) {
        o = !1;
      }
      return !1 == o && (!n && !1 === a._regex[a._radixNumber].test(i) || n && !1 === a._regex[10].test(i)) ? void a._handleNonNumericValue(e, t, i) : {
        value: i,
        enteredComplexNumber: r
      };
    }
  }, {
    key: "isENotation",
    value: function isENotation(e) {
      var t = new RegExp(/e/i);
      return t.test(e.toString());
    }
  }, {
    key: "scientificToDecimal",
    value: function scientificToDecimal(e) {
      var t = this.regexScientificNotation.exec(e),
          i = t[1],
          a = t[2],
          n = parseFloat(i) * Math.pow(10, this.prefixesToPowers[a]);
      return n;
    }
  }, {
    key: "_createMeasureLabel",
    value: function _createMeasureLabel() {
      var e = this.context,
          t = document.createElement("div");
      return t.className = "smart-label", t.style.position = "absolute", t.style.visibility = "hidden", e._measureLabelScale = "far" === e.scalePosition ? e.$.scaleFar : e.$.scaleNear, e._measureLabelScale.appendChild(t), t;
    }
  }, {
    key: "_addMajorTickAndLabel",
    value: function _addMajorTickAndLabel(e, t, i, a, n) {
      var o = this.context,
          r = o._settings.leftOrTop,
          l = this.valueToPx(a);
      var s = "",
          d = "";
      if (parseInt(l) > parseInt(o._measurements.trackLength)) return {
        tick: s,
        label: d
      };

      if (o.logarithmicScale && (e = o._formatLabel(Math.pow(10, a))), "smart-tank" === o.nodeName.toLowerCase() || o._intervalHasChanged) {
        var _t240 = o._tickIntervalHandler.labelsSize;

        if (n) {
          o._labelDummy.innerHTML = e;

          var _n126 = this.valueToPx(a),
              _r46 = this.valueToPx(o._drawMax),
              _l30 = this.valueToPx(o._drawMin),
              _s19 = o._labelDummy[o._settings.size],
              _d16 = "vertical" === o.orientation ? o._labelDummy.offsetWidth : o._labelDummy.offsetHeight,
              c = (_s19 + _t240.minLabelSize) / 2,
              m = (_s19 + _t240.maxLabelSize) / 2;

          i = o._normalLayout ? _n126 + m < _r46 && _n126 - c > _l30 : _n126 - m > _r46 && _n126 + c < _l30, _d16 > this._longestLabelSize && (this._longestLabelSize = _d16);
        } else this._longestLabelSize = Math.max(_t240.minLabelOtherSize, _t240.maxLabelOtherSize, this._longestLabelSize);
      }

      if (o._tickValues.push(a), s = "<div style=\"" + r + ": " + l + "px;\" class=\"smart-tick\"></div>", !1 !== i) {
        void 0 === t && (o._labelDummy.innerHTML = e, t = o._labelDummy[o._settings.size]);

        var _i253 = l - t / 2;

        d += "<div class=\"smart-label" + (n ? " smart-label-middle" : "") + "\" style=\"" + r + ": " + _i253 + "px;\">" + e + "</div>";
      }

      return {
        tick: s,
        label: d
      };
    }
  }, {
    key: "getWordLength",
    value: function getWordLength(e) {
      return this.context._unsigned = "u" === e.charAt(0), "int8" === e || "uint8" === e ? 8 : "int16" === e || "uint16" === e ? 16 : "int32" === e || "uint32" === e ? 32 : "int64" === e || "uint64" === e ? 64 : void 0;
    }
  }, {
    key: "getAngleByValue",
    value: function getAngleByValue(e, t, i) {
      var a = Math.PI;
      var n = this.context;
      !1 !== t && n.logarithmicScale && (e = Math.log10(e));
      var o = (e - n._drawMin) * n._angleRangeCoefficient;
      var r;
      return r = void 0 === n.inverted || !n.inverted && !n.rightToLeft || n.rightToLeft && n.inverted ? n.endAngle - o : n.startAngle + o, i ? r : r * a / 180 + a / 2;
    }
  }, {
    key: "getValueByAngle",
    value: function getValueByAngle(e, t) {
      var i = Math.pow;
      var a = this.context;
      var n, o, r;

      for (void 0 === a.inverted || !a.inverted && !a.rightToLeft || a.rightToLeft && a.inverted ? (n = a.endAngle, o = e) : (n = e, o = a._normalizedStartAngle); n < o;) {
        n += 360;
      }

      if (r = (n - o) / a._angleDifference * a._range + parseFloat(a._drawMin), a.logarithmicScale) {
        if (a.customInterval) return parseFloat(i(10, this.getCoercedValue(r, !0)).toFixed(12));
        r = i(10, r);
      }

      return t && !a.coerce ? Math.round(r) : (r = this.createDescriptor(r, void 0, !0, !0), this.getCoercedValue(r, !1));
    }
  }, {
    key: "updateGaugeValue",
    value: function updateGaugeValue(e) {
      var t = this.context,
          i = t.value;
      t.value = e, t._drawValue = t.logarithmicScale ? Math.log10(e).toString() : e, t._number = this.createDescriptor(t.value), t.$.digitalDisplay.value = e, t.$.fireEvent("change", {
        value: e,
        oldValue: i
      }), t.setAttribute("aria-valuenow", e), delete t._valueBeforeCoercion;
    }
  }, {
    key: "validateColorRange",
    value: function validateColorRange(e) {
      var t = this.context;
      return Math.min(Math.max(e, t.min), t.max);
    }
  }, {
    key: "getActualValue",
    value: function getActualValue(e) {
      return this.context.logarithmicScale ? Math.pow(10, e) : e;
    }
  }, {
    key: "drawGaugeLogarithmicScaleMinorTicks",
    value: function drawGaugeLogarithmicScaleMinorTicks(e, t, a) {
      var n = Math.pow;
      var o = this.context;
      var r;

      for (var _n127 in t instanceof Smart.Utilities.BigNumber && (t = parseFloat(t.toString())), e) {
        if (r = _n127, 0 <= _n127 && 0 == _n127 % 1) break;
      }

      for (var _l31 = parseFloat(r); _l31 < o._drawMax; _l31 += t) {
        for (var _e280 = 2; 9 >= _e280; _e280++) {
          var _i254 = _e280 * n(10, _l31 + t - 1);

          _i254 < o.max && a(_i254);
        }
      }

      for (var _l32 = parseFloat(r); _l32 > o._drawMin; _l32 -= t) {
        for (var _e281 = 2; 9 >= _e281; _e281++) {
          var _t241 = _e281 * n(10, _l32 - 1);

          _t241 > o.min && a(_t241);
        }
      }
    }
  }, {
    key: "_getAngleDifference",
    value: function _getAngleDifference(e, t) {
      var i = Math.abs(t - e) % 360,
          a = 180 < i ? 360 - i : i;
      return a;
    }
  }, {
    key: "addCustomTicks",
    value: function addCustomTicks() {
      function e(e) {
        var i = a.customTicks[e],
            l = n ? t.createDescriptor(i) : Math.log10(i),
            s = 0 < e && e < a.customTicks.length - 1,
            d = t._addMajorTickAndLabel(a._formatLabel(i), void 0, !0, l, s);

        o += d.tick, r += d.label;
      }

      var t = this,
          a = t.context,
          n = !a.logarithmicScale;
      var o = "",
          r = "";
      if (t._longestLabelSize = 0, a._tickValues = [], a._labelDummy = t._createMeasureLabel(), !a._normalLayout) for (var _t242 = a.customTicks.length - 1; 0 <= _t242; _t242--) {
        e(_t242);
      } else for (var _t243 = 0; _t243 < a.customTicks.length; _t243++) {
        e(_t243);
      }
      "smart-tank" === a.nodeName.toLowerCase() && a._updateScaleWidth(t._longestLabelSize), a._appendTicksAndLabelsToScales(o, r);
    }
  }, {
    key: "addGaugeCustomTicks",
    value: function addGaugeCustomTicks() {
      function e(e) {
        var i = a.customTicks[e],
            n = t.createDescriptor(i),
            l = t.getAngleByValue(n, !0),
            s = 0 < e && e < a.customTicks.length - 1;
        o(l), r(l, i, s);
      }

      var t = this,
          a = t.context,
          i = a._distance,
          n = a._measurements.radius - i.majorTickDistance;
      var o, r;
      o = "none" !== a.ticksVisibility && !1 !== a._plotTicks ? function (e) {
        a._drawTick(e, n, "major");
      } : function () {}, r = "none" !== a.labelsVisibility && !1 !== a._plotLabels ? function (e, t, n) {
        a._drawLabel(e, t, i.labelDistance, n);
      } : function () {};

      for (var _t244 = a.customTicks.length - 1; 0 <= _t244; _t244--) {
        e(_t244);
      }
    }
  }]);

  return _class23;
}()), Smart.Utilities.Assign("IntegerNumericProcessor",
/*#__PURE__*/
function (_Smart$Utilities$Base) {
  "use strict";

  _inherits(_class24, _Smart$Utilities$Base);

  function _class24(e, t) {
    var _this6;

    _classCallCheck(this, _class24);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(_class24).call(this, e, t));

    var i = _assertThisInitialized(_this6);

    i.context = e, i.defaultMins = {
      int8: "-128",
      uint8: "0",
      int16: "-32768",
      uint16: "0",
      int32: "-2147483648",
      uint32: "0",
      int64: "-9223372036854775808",
      uint64: "0"
    }, i.defaultMaxs = {
      int8: "127",
      uint8: "255",
      int16: "32767",
      uint16: "65535",
      int32: "2147483647",
      uint32: "4294967295",
      int64: "9223372036854775807",
      uint64: "18446744073709551615"
    };
    return _this6;
  }

  _createClass(_class24, [{
    key: "createDescriptor",
    value: function createDescriptor(e, t, i, a, n) {
      var o = this.context;
      var r;

      if (e.constructor !== Smart.Utilities.BigNumber) {
        var _i255 = !n && o._radixNumber ? o._radixNumber : 10;

        10 === _i255 && t && e.constructor !== Smart.Utilities.BigNumber && this.isENotation(e) && (Smart.Utilities.BigNumber.bigIntSupport ? e = new Smart.Utilities.BigNumber(Math.round(e)) : e = new Smart.Utilities.NumberRenderer(e).largeExponentialToDecimal()), r = o._toBigNumberDecimal ? o._toBigNumberDecimal(e.toString(_i255, o._wordLengthNumber), _i255) : new Smart.Utilities.BigNumber(e);
      } else r = new Smart.Utilities.BigNumber(e);

      return i && (o._unsigned && -1 === r.compare(0) && (r = r.set(0)), a && (r = this.validate(r, o._minObject, o._maxObject)), r = this.round(r)), r;
    }
  }, {
    key: "round",
    value: function round(e) {
      var t = this.context;
      if (e instanceof window.Smart.Utilities.BigNumber && "bigint" == typeof e._d) return e;
      if (!1 == e instanceof window.Smart.Utilities.BigNumber || !t._wordLengthNumber || 64 > t._wordLengthNumber) return new Smart.Utilities.BigNumber(Math.round(e.toString()));
      var i = e.mod(1);
      return 1 === i._d.length && 0 === i._d[0] || (e = e.intPart(), e._s ? (5 < i._d[1] || 5 === i._d[1] && i._d[2]) && (e = e.add(-1)) : 4 < i._d[1] && (e = e.add(1))), e;
    }
  }, {
    key: "validate",
    value: function validate(e, t, i) {
      var a;
      return a = -1 === e.compare(t) ? t : 1 === e.compare(i) ? i : e, a;
    }
  }, {
    key: "validateMinMax",
    value: function validateMinMax(e, t) {
      var i = this.context;
      var a = this.defaultMins[i.wordLength],
          n = new Smart.Utilities.BigNumber(a),
          o = this.defaultMaxs[i.wordLength],
          r = new Smart.Utilities.BigNumber(o),
          l = "date" !== i.mode;

      if (void 0 === i._numberRenderer && (i._numberRenderer = new Smart.Utilities.NumberRenderer()), e && l) {
        null !== i.min && (i.min = i.min.toString().replace(/\s/g, ""), this.regexScientificNotation.test(i.min) && (i.min = this.scientificToDecimal(i.min)));

        var _e282 = this.round(new Smart.Utilities.BigNumber(i.min));

        null === i.min || i._minIsNull && i._initialized || !(0 <= _e282.compare(n)) ? (i._minIsNull = !0, i.min = a, i._minObject = n) : i._minObject = _e282;
      }

      if (t && l) {
        null !== i.max && (i.max = i.max.toString().replace(/\s/g, ""), this.regexScientificNotation.test(i.max) && (i.max = this.scientificToDecimal(i.max)));

        var _e283 = this.round(new Smart.Utilities.BigNumber(i.max));

        null === i.max || i._maxIsNull && i._initialized || !(0 >= _e283.compare(r)) ? (i._maxIsNull = !0, i.max = o, i._maxObject = r) : i._maxObject = _e283;
      }

      l || (i._minObject = new Smart.Utilities.BigNumber(i.min), i._maxObject = new Smart.Utilities.BigNumber(i.max)), this.compare(i._minObject, i._maxObject) || (i._minObject = n, i._maxObject = r, i._drawMin = i.logarithmicScale ? 0 : a, i._drawMax = i.logarithmicScale ? 10 : o, i.min = a, i.max = o), l || (i._minDate = Smart.Utilities.DateTime.fromFullTimeStamp(i.min), i._maxDate = Smart.Utilities.DateTime.fromFullTimeStamp(i.max));
    }
  }, {
    key: "valueToPx",
    value: function valueToPx(e) {
      var t = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
      Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0;
      var i = this.context,
          a = new Smart.Utilities.BigNumber(i._measurements.trackLength).divide(new Smart.Utilities.BigNumber(i._range));
      var n;

      if (i._normalLayout) {
        var _t245 = i._drawMin instanceof Smart.Utilities.BigNumber ? i._drawMin : new Smart.Utilities.BigNumber(i._drawMin);

        e = new Smart.Utilities.BigNumber(e), n = parseFloat(a.multiply(e.subtract(_t245)).toString());
      } else {
        var _t246 = i._drawMax instanceof Smart.Utilities.BigNumber ? i._drawMax : new Smart.Utilities.BigNumber(i._drawMax);

        n = parseFloat(this.round(_t246.subtract(e).multiply(a)).toString());
      }

      return Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = t, n;
    }
  }, {
    key: "pxToValue",
    value: function pxToValue(e) {
      var t = this.context,
          i = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
      var a;

      if (Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0, a = t._normalLayout ? t._valuePerPx.multiply(e - t._trackStart) : t._valuePerPx.multiply(t._trackEnd - e), a = this.round(a).toString(), Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = i, t.logarithmicScale) {
        var _e284 = parseFloat(a) + parseFloat(t._drawMin);

        return new Smart.Utilities.BigNumber(Math.round(Math.pow(10, _e284)));
      }

      var n = this.createDescriptor(t._minObject.add(a), !1, !0, !0);
      return n;
    }
  }, {
    key: "compare",
    value: function compare(e, t, i) {
      if ((null === e || null === t) && e !== t) return !0;
      e.constructor !== Smart.Utilities.BigNumber && (e = new Smart.Utilities.BigNumber(e));
      var a = e.compare(t);
      return !0 === i ? a : 0 !== a;
    }
  }, {
    key: "incrementDecrement",
    value: function incrementDecrement(e, t, i) {
      var a = this.context;
      var n;

      if (e.constructor !== Smart.Utilities.BigNumber && (e = new Smart.Utilities.BigNumber(e)), "add" === t) {
        if (n = e.add(i), void 0 !== a._drawMax) return 0 < n.compare(a._drawMax) ? new Smart.Utilities.BigNumber(a._drawMax) : n;
      } else if (n = e.subtract(i), void 0 !== a._drawMin) return 0 > n.compare(a._drawMin) ? new Smart.Utilities.BigNumber(a._drawMin) : n;

      return n;
    }
  }, {
    key: "render",
    value: function render(e, t) {
      var i = this.context;
      if (!i.scientificNotation && !0 === t) return new Smart.Utilities.NumberRenderer(new Smart.Utilities.BigNumber(e)).bigNumberToExponent(i.significantDigits);
      var a = e;
      return i.scientificNotation && !0 === t ? a = new Smart.Utilities.NumberRenderer(a).toScientific(i.significantDigits, i.precisionDigits) : "string" != typeof e && (a = e.toString(i._radixNumber, i._wordLengthNumber, i.leadingZeros)), a;
    }
  }, {
    key: "addTicksAndLabels",
    value: function addTicksAndLabels() {
      var e = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
      Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0;
      var t = this.context,
          i = t._measurements.trackLength,
          a = t._normalLayout,
          n = t._majorTicksInterval,
          o = this.round(new Smart.Utilities.BigNumber(t._range).divide(n)),
          r = i / o,
          l = new Smart.Utilities.BigNumber(t._drawMin),
          s = new Smart.Utilities.BigNumber(t._drawMax);

      var d = "",
          c = "",
          m,
          u,
          p,
          g,
          h,
          _,
          f,
          b,
          y;

      t._tickValues = [], this._longestLabelSize = 0, a ? (m = l, u = n.add(m.subtract(m.mod(n))), p = u.subtract(m), h = t._formatLabel(l), _ = t._tickIntervalHandler.labelsSize.minLabelSize, g = s, f = t._formatLabel(s), b = t._tickIntervalHandler.labelsSize.maxLabelSize) : (m = s, u = m.subtract(m.mod(n)), p = m.subtract(u), h = t._formatLabel(s), _ = t._tickIntervalHandler.labelsSize.maxLabelSize, g = l, f = t._formatLabel(l), b = t._tickIntervalHandler.labelsSize.minLabelSize), t._labelDummy = this._createMeasureLabel(), y = this._addMajorTickAndLabel(h, _, !0, m), d += y.tick, c += y.label;
      var v = p.divide(n).multiply(r);

      if (0 !== u.compare(t.max) && 0 > v.compare(i)) {
        var _e285 = t._formatLabel(u.toString()),
            _i256 = 0 < v.compare(_);

        y = this._addMajorTickAndLabel(_e285, void 0, _i256, u, !0), d += y.tick, c += y.label;
      }

      y = this.addMiddleMajorTicks(o, r, v, p, a, n), d += y.tick, c += y.label, y = this._addMajorTickAndLabel(f, b, !0, g), d += y.tick, c += y.label, "date" !== t.mode && (d += this.addMinorTicks(a)), t._measureLabelScale.removeChild(t._labelDummy), delete t._labelDummy, delete t._measureLabelScale, "smart-tank" === t.nodeName.toLowerCase() && t._updateScaleWidth(this._longestLabelSize), t._appendTicksAndLabelsToScales(d, c), Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = e;
    }
  }, {
    key: "addMiddleMajorTicks",
    value: function addMiddleMajorTicks(e, t, a, n, o, r) {
      var l = this.context;
      var i = "",
          s = "",
          d;

      for (var c = 1; c < e; c++) {
        var m = a.add(c * t),
            u = void 0;

        if (o ? u = r.multiply(c).add(n.add(new Smart.Utilities.BigNumber(l._drawMin))) : (u = new Smart.Utilities.BigNumber(l._drawMax).subtract(n).subtract(r.multiply(c)), c == e - 1 && 0 === u.compare(0) && (l._numberRenderer.numericValue = l._tickIntervalHandler.nearestPowerOfTen, d = l._numberRenderer.bigNumberToExponent(1))), 0 !== u.compare(l._drawMax)) {
          var _a167 = l._formatLabel(u.toString()),
              _n128 = !0;

          l._labelDummy.innerHTML = d ? d : _a167;
          var _o84 = l._labelDummy[l._settings.size];
          0 <= m.add(_o84).compare(e * t) && (_n128 = !1);

          var _r47 = this._addMajorTickAndLabel(_a167, void 0, _n128, u, !0);

          i += _r47.tick, s += _r47.label;
        }
      }

      return {
        tick: i,
        label: s
      };
    }
  }, {
    key: "addMinorTicks",
    value: function addMinorTicks(e) {
      function t(e) {
        -1 === o.indexOf(e) && 0 == e % l && (d += "<div style=\"" + s + ": " + n._numericProcessor.valueToPx(e) + "px;\" class=\"smart-tick smart-tick-minor\"></div>");
      }

      function i() {
        var e = n._measurements.trackLength,
            t = e / o.length,
            i = .1;
        20 > t ? i = 1 : 20 <= t && 40 > t ? i = 1 < m - c ? 1 : .5 : 40 <= t && 80 > t && (i = .2);
        var r = Math.floor(n._drawMax),
            l = n._drawMax - r,
            u = n._drawMax - n._drawMin > o.length;

        for (var _e286 = n._drawMax; 0 < _e286; --_e286) {
          var _t247 = 0 < l ? a(10, _e286 - l + 1) : a(10, _e286),
              _o85 = _t247 * i;

          for (var _e287 = _t247; 0 < _e287; _e287 -= _o85) {
            if (_e287 < n.max && _e287 > n.min) {
              var _t248 = new Smart.Utilities.BigNumber(Math.log10(_e287));

              (0 == _t248 % 1 && u || !u) && (d += "<div style=\"" + s + ": " + n._numericProcessor.valueToPx(_t248) + "px;\" class=\"smart-tick smart-tick-minor\"></div>");
            }
          }
        }
      }

      var a = Math.pow;
      var n = this.context,
          o = n._tickValues,
          r = n._tickIntervalHandler.nearestPowerOfTen,
          l = n._minorTicksInterval,
          s = n._settings.leftOrTop;
      var d = "",
          c,
          m,
          u;
      if (e ? (c = o[0], m = o[1], u = o[o.length - 1]) : (c = o[o.length - 1], m = o[o.length - 2], u = o[0]), n.logarithmicScale) i();else {
        for (var _e288 = m; 0 > c.compare(_e288); _e288 = _e288.subtract(r)) {
          t(_e288);
        }

        for (var _e289 = m.add(r); 0 < u.compare(_e289); _e289 = _e289.add(r)) {
          t(_e289);
        }
      }
      return d;
    }
  }, {
    key: "validateCustomTicks",
    value: function validateCustomTicks() {
      var e = this.context,
          t = "date" !== e.mode;
      var a = [];

      for (var _n129 = 0, _i257; _n129 < e.customTicks.length; _n129++) {
        _i257 = e.customTicks[_n129], t ? _i257 = this.createDescriptor(_i257, !1, !0) : void 0 === _i257._d && (_i257 = Smart.Utilities.DateTime.validateDate(_i257).getTimeStamp()), 0 <= _i257.compare(e._minObject) && 0 >= _i257.compare(e._maxObject) && a.push(_i257);
      }

      if (a.sort(function (e, t) {
        return e.compare(t);
      }), t) {
        for (var _e290 = 0; _e290 < a.length; _e290++) {
          a[_e290] = a[_e290].toString();
        }

        a = a.filter(function (e, t, i) {
          return !t || e !== i[t - 1];
        });
      }

      e.customTicks = a.slice(0);
    }
  }, {
    key: "addGaugeTicksAndLabels",
    value: function addGaugeTicksAndLabels() {
      var e = Math.PI;
      var t = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
      Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0;
      var a = this.context,
          n = this,
          o = Math.max(a._tickIntervalHandler.labelsSize.minLabelSize, a._tickIntervalHandler.labelsSize.maxLabelSize),
          r = a._majorTicksInterval,
          l = a._minorTicksInterval,
          s = {},
          d = a._distance,
          c = a._measurements.radius,
          m = c - d.majorTickDistance,
          u = c - d.minorTickDistance,
          p = new Smart.Utilities.BigNumber(a._drawMin),
          g = new Smart.Utilities.BigNumber(a._drawMax);

      var h, _, f, b, y, v;

      "none" !== a.ticksVisibility && !1 !== a._plotTicks ? (h = function h(e) {
        a._drawTick(e, m, "major");
      }, _ = function _(e) {
        a._drawTick(n.getAngleByValue(e, !0), u, "minor");
      }) : (h = function h() {}, _ = function _() {}), f = "none" !== a.labelsVisibility && !1 !== a._plotLabels ? function (e, t, i) {
        a._drawLabel(e, t, d.labelDistance, i);
      } : function () {}, void 0 === a.inverted || !a.inverted && !a.rightToLeft || a.rightToLeft && a.inverted ? (y = a.endAngle, v = a.startAngle) : (y = a.startAngle, v = a.endAngle), b = n.getAngleByValue(p, !1), h(b), s[a._drawMin.toString()] = !0, f(b, a.min, !1);
      var w = p.subtract(p.mod(r)),
          C;
      -1 !== p.compare(0) && (w = w.add(r));

      for (var _e291 = new Smart.Utilities.BigNumber(w); -1 !== _e291.compare(p); _e291 = _e291.subtract(l)) {
        C = _e291;
      }

      b = n.getAngleByValue(w, !1), h(b), s[w.toString()] = !0, 2 * e * a._measurements.innerRadius * (this._getAngleDifference(y, n.getAngleByValue(w, !1, !0)) / 360) > o && f(b, this.getActualValue(w), -1 === w.compare(g));
      var x;

      for (x = w.add(r); -1 === x.compare(g.subtract(r)); x = x.add(r)) {
        b = n.getAngleByValue(x, !1), h(b), s[x.toString()] = !0, f(b, this.getActualValue(x), !0);
      }

      if (void 0 === s[x.toString()] && 1 !== x.compare(g) && (b = n.getAngleByValue(x, !1), h(b), s[x.toString()] = !0, 2 * e * a._measurements.innerRadius * (this._getAngleDifference(v, n.getAngleByValue(x, !1, !0)) / 360) >= o && f(b, this.getActualValue(x), !0), a._normalizedStartAngle !== a.endAngle && (b = n.getAngleByValue(g, !1), h(b), 2 * e * a._measurements.innerRadius * (this._getAngleDifference(v, y) / 360) >= o && f(b, a.max, !1))), "date" === a.mode) return void (Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = t);
      if (!a.logarithmicScale) for (var _e292 = C; -1 === _e292.compare(g); _e292 = _e292.add(l)) {
        s[_e292.toString()] || _(_e292);
      } else this.drawGaugeLogarithmicScaleMinorTicks(s, r, _);
      Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = t;
    }
  }, {
    key: "updateToolTipAndValue",
    value: function updateToolTipAndValue(e, t, i) {
      var a = this.context,
          n = a.logarithmicScale;
      a._updateTooltipValue(e.toString()), n && (e = parseFloat(Math.pow(10, parseFloat(e)).toFixed(11))), e = e instanceof Smart.Utilities.BigNumber ? e : new Smart.Utilities.BigNumber(e);
      var o = e.toString();
      a._number = e, a._drawValue = n ? Math.log10(o) : e, 0 !== e.compare(t) && i && ("numeric" === a.mode ? (a.value = o, e = o) : (t = a._valueDate, a._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(o), a.value = e, e = a._valueDate), !a._programmaticValueIsSet && a.$.fireEvent("change", {
        value: e,
        oldValue: t
      }), a.$.hiddenInput && (a.$.hiddenInput.value = e), a.setAttribute("aria-valuenow", a._getEventValue(!0)));
    }
  }, {
    key: "validateInterval",
    value: function validateInterval(e) {
      var t = this.context,
          i = t._maxObject.subtract(t._minObject);

      t._validInterval = new Smart.Utilities.BigNumber(e), t._validInterval = this.round(t._validInterval), 1 === t._validInterval.compare(i) && (t._validInterval = i), t.interval = t._validInterval.toString();
    }
  }, {
    key: "getCoercedValue",
    value: function getCoercedValue(e, t, i) {
      var a = Math.abs;
      var n = this.context;
      if (!n.coerce) return e;
      var o = !n.logarithmicScale;
      e = e instanceof Smart.Utilities.BigNumber ? e : new Smart.Utilities.BigNumber(e);
      var r, l;

      if (n.customInterval) {
        var _t249 = n.customTicks;
        if (0 === _t249.length) return e;

        var _l33, _s20;

        if (o || i) {
          r = n._minObject, _l33 = r.subtract(e).abs(), _s20 = r;

          for (var _a168 = 0; _a168 < _t249.length; _a168++) {
            var _i258 = this.createDescriptor(_t249[_a168]),
                _n130 = _i258.subtract(e).abs();

            -1 === _n130.compare(_l33) && (_l33 = _n130, _s20 = _i258);
          }
        } else {
          r = n._drawMin, _l33 = a(r - parseFloat(e.toString())), _s20 = r;

          for (var _n131 = 0; _n131 < _t249.length; _n131++) {
            var _i259 = Math.log10(_t249[_n131]),
                _o86 = a(_i259 - e);

            _o86 < _l33 && (_l33 = _o86, _s20 = _i259);
          }

          _s20 = new Smart.Utilities.BigNumber(_s20);
        }

        return _s20;
      }

      var s = n._validInterval;

      if ("date" === n.mode) {
        if ("addYears" === n._dateIncrementMethod) return this.coerceYear(e);
        if ("addMonths" === n._dateIncrementMethod) return this.coerceMonth(e);
        s = new Smart.Utilities.BigNumber(n._dateIntervalNumber).multiply(s);
      }

      !1 === t ? (r = new Smart.Utilities.BigNumber(n.min), l = new Smart.Utilities.BigNumber(n.max)) : (r = new Smart.Utilities.BigNumber(n._drawMin), l = new Smart.Utilities.BigNumber(n._drawMax));
      var d = e.subtract(r),
          c = d.mod(s);
      if (0 === c.compare(0)) return e;
      var m = d.subtract(c),
          u = m.add(s);
      if (0 > d.subtract(m).abs().compare(d.subtract(u).abs())) return m.add(r);else {
        var _e293 = u.add(r);

        return 0 >= _e293.compare(l) ? _e293 : m.add(r);
      }
    }
  }, {
    key: "coerceMonth",
    value: function coerceMonth(e) {
      var t = this.context,
          i = parseFloat(t._validInterval),
          a = Smart.Utilities.DateTime.fromFullTimeStamp(e),
          n = a.year(),
          o = a.month(),
          r = a.day(),
          l = t._minDate.year(),
          s = t._minDate.month(),
          d = 12 * (t._maxDate.year() - l - 1) + 12 - s + t._maxDate.month();

      var c = 12 * (n - 1 - l) + (12 - s) + o;
      1 === i && (-1 === [1, 3, 5, 7, 8, 10, 12].indexOf(o) ? 2 === o ? a.isLeapYear(n) ? (15 < r || 15 === r && 11 < a.hour()) && c++ : 14 < r && c++ : 15 < r && c++ : (16 < r || 16 === r && 11 < a.hour()) && c++), c = this.getCoercedTimePart(0, d, c, i);

      var m = t._minDate.addMonths(c, !0);

      return 1 === m.compare(t._maxDate) && (m = t._minDate.addMonths(c - i, !0)), t._drawValue = new Smart.Utilities.BigNumber(m.getTimeStamp()), t._drawValue;
    }
  }, {
    key: "coerceYear",
    value: function coerceYear(e) {
      var t = this.context,
          i = parseFloat(t._validInterval),
          a = Smart.Utilities.DateTime.fromFullTimeStamp(e),
          n = t._maxDate.year(),
          o = Smart.Utilities.DateTime.getConstructorParameters(t._minDate);

      var r = a.year();
      6 < a.month() && r++;
      var l = this.getCoercedTimePart(t._minDate.year(), n, r, i);
      l > n && (l -= i), o[0] = l, o.unshift(null);
      var s = new (Function.prototype.bind.apply(Smart.Utilities.DateTime, o))();
      return t._drawValue = new Smart.Utilities.BigNumber(s.getTimeStamp()), t._drawValue;
    }
  }, {
    key: "getCoercedTimePart",
    value: function getCoercedTimePart(e, t, i, a) {
      var n = Math.abs;
      var o = i - e,
          r = o % a;
      if (0 == r) return i;
      var l = parseFloat((o - r).toFixed(12)),
          s = l + a;
      if (t - e <= a) return i >= e + (t - e) / 2 ? t : e;
      if (n(o - l) < n(o - s)) return l + e;else {
        var _i260 = s + e;

        return _i260 > t ? l + e : _i260;
      }
    }
  }, {
    key: "updateValue",
    value: function updateValue(e) {
      var t = this.context;
      e = e instanceof Smart.Utilities.BigNumber ? e : new Smart.Utilities.BigNumber(e);
      var i = this.validate(e, t._minObject, t._maxObject);
      var a = t.value,
          n,
          o;
      t._number = i, t._drawValue = t.logarithmicScale ? Math.log10(i) : i, "numeric" === t.mode ? (n = e.toString(), t.value = n, o = this.compare(e, a)) : (a = Smart.Utilities.DateTime.fromFullTimeStamp(a), t._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(e), t.value = e, e = t._valueDate, n = e, o = 0 !== e.compare(a)), !t._programmaticValueIsSet && (o || t._scaleTypeChangedFlag) && t.$.fireEvent("change", {
        value: n,
        oldValue: a
      }), t.$.hiddenInput && (t.$.hiddenInput.value = e), t.setAttribute("aria-valuenow", t._getEventValue(!0)), t._moveThumbBasedOnValue(t._drawValue);
    }
  }, {
    key: "getValuePerPx",
    value: function getValuePerPx(e, t) {
      var i = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
      Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0;
      var a = new Smart.Utilities.BigNumber(e).divide(t);
      return Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = i, a;
    }
  }, {
    key: "restrictValue",
    value: function restrictValue(e) {
      e[1].constructor === Smart.Utilities.BigNumber ? -1 === e[1].compare(e[0]) && e[1].set(e[0]) : e[1] < e[0] && (e[1] = e[0]);
    }
  }, {
    key: "getAngleByValue",
    value: function getAngleByValue(e, t, i) {
      var a = Math.PI;
      var n = this.context,
          o = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
      if (Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0, 64 > n._wordLengthNumber) return Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = o, _get(_getPrototypeOf(_class24.prototype), "getAngleByValue", this).call(this, parseFloat(e.toString()), t, i);
      !1 == e instanceof Smart.Utilities.BigNumber && (e = new Smart.Utilities.BigNumber(e)), !1 !== t && n.logarithmicScale && (e = new Smart.Utilities.BigNumber(Math.log10(e.toString())));
      var r = e.subtract(n._drawMin).multiply(n._angleRangeCoefficient);
      var l;
      return l = void 0 === n.inverted || !n.inverted && !n.rightToLeft || n.rightToLeft && n.inverted ? r.multiply(-1).add(n.endAngle) : r.add(n.startAngle), l = parseFloat(l.toString()), Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = o, i ? l : l * a / 180 + a / 2;
    }
  }, {
    key: "getValueByAngle",
    value: function getValueByAngle(e) {
      var t = this.context;
      if (64 > t._wordLengthNumber) return _get(_getPrototypeOf(_class24.prototype), "getValueByAngle", this).call(this, e, !0);
      var i = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
      var a, n, o;

      for (Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0, void 0 === t.inverted || !t.inverted && !t.rightToLeft || t.rightToLeft && t.inverted ? (a = t.endAngle, n = e) : (a = e, n = t._normalizedStartAngle); a < n;) {
        a += 360;
      }

      o = new Smart.Utilities.BigNumber((a - n) / t._angleDifference).multiply(t._range).add(t._drawMin), t.logarithmicScale && (o = new Smart.Utilities.BigNumber(Math.pow(10, o.toString())));
      var r;
      return r = t.coerce ? this.getCoercedValue(o, !1) : this.round(o), Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = i, new Smart.Utilities.BigNumber(r);
    }
  }, {
    key: "updateGaugeValue",
    value: function updateGaugeValue(e) {
      if (!1 == e instanceof Smart.Utilities.BigNumber) return _get(_getPrototypeOf(_class24.prototype), "updateGaugeValue", this).call(this, e);

      var t = this.context,
          i = t._getEventValue();

      "numeric" === t.mode ? (t.value = e.toString(), t.$.digitalDisplay.value = t.value) : (t._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(e), t.value = e), t._drawValue = t.logarithmicScale ? Math.log10(t.value).toString() : t.value, t._number = e, t.$.fireEvent("change", {
        value: t._getEventValue(),
        oldValue: i
      }), t.setAttribute("aria-valuenow", t._getEventValue(!0));
    }
  }, {
    key: "validateColorRange",
    value: function validateColorRange(e) {
      var t = this.context;
      if (64 > t._wordLengthNumber) return _get(_getPrototypeOf(_class24.prototype), "validateColorRange", this).call(this, e);
      "numeric" === t.mode ? e = new Smart.Utilities.BigNumber(e) : (e = Smart.Utilities.DateTime.validateDate(e), e = e.getTimeStamp());
      var i = new Smart.Utilities.BigNumber(t.min),
          a = new Smart.Utilities.BigNumber(t.max);
      return -1 === e.compare(i) && (e = i), 1 === e.compare(a) && (e = a), e;
    }
  }, {
    key: "lockRotation",
    value: function lockRotation(e, t) {
      var i = this.context;

      if (!1 == t instanceof Smart.Utilities.BigNumber && (t = new Smart.Utilities.BigNumber(t)), e && -1 === t.compare(i._number)) {
        if (i._lockCW = !0, -1 === t.compare(i._maxObject)) return new Smart.Utilities.BigNumber(i._maxObject);
      } else if (!e && 1 === t.compare(i._number) && (i._lockCCW = !0, 1 === t.compare(i._minObject))) return new Smart.Utilities.BigNumber(i._minObject);
    }
  }, {
    key: "getAngleRangeCoefficient",
    value: function getAngleRangeCoefficient() {
      var e = this.context,
          t = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
      Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0, e._angleRangeCoefficient = new Smart.Utilities.BigNumber(e._angleDifference).divide(e._range), Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = t;
    }
  }]);

  return _class24;
}(Smart.Utilities.BaseNumericProcessor)), Smart.Utilities.Assign("DecimalNumericProcessor",
/*#__PURE__*/
function (_Smart$Utilities$Base2) {
  "use strict";

  _inherits(_class25, _Smart$Utilities$Base2);

  function _class25(e, t) {
    var _this7;

    _classCallCheck(this, _class25);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(_class25).call(this, e, t)), _this7.context = e;
    return _this7;
  }

  _createClass(_class25, [{
    key: "getPreciseModulo",
    value: function getPreciseModulo(e, t, i) {
      var a = Math.round,
          n = Math.abs;
      var o = 0 <= e ? 1 : -1;

      if (e = n(e), t = n(t), "undefined" == typeof i) {
        var _i261 = e.toExponential(),
            _a169 = t.toExponential(),
            r = parseInt(_i261.slice(_i261.indexOf("e") + 1), 10),
            _l34 = parseInt(_a169.slice(_a169.indexOf("e") + 1), 10),
            _s21 = 0 > r ? n(r) : 0,
            d = 0 > _l34 ? n(_l34) : 0,
            c = Math.max(_s21, d);

        if (this.roundCoefficient = c, e < t) return o * e;
        if (e === t) return 0;
        if ((-1 > e || 1 < e) && (-1 > t || 1 < t || 1 === t)) if (0 == e % 1 && 0 == t % 1) return o * (e % t);else {
          var _i262 = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
          Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0;

          var _a170 = o * parseFloat(new Smart.Utilities.BigNumber(e).mod(t).toString());

          return Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = _i262, _a170;
        }
        var m = Math.pow(10, c);
        return o * (e * m % (t * m) / m);
      }

      return o * (a(e * i) % a(t * i));
    }
  }, {
    key: "createDescriptor",
    value: function createDescriptor(e, t, i, a) {
      var n = parseFloat(e);
      return a && (n = this.validate(n, this.context._minObject, this.context._maxObject)), n;
    }
  }, {
    key: "round",
    value: function round(e) {
      return Math.round(e);
    }
  }, {
    key: "validate",
    value: function validate(e, t, i) {
      var a;
      return a = e < t ? t : e > i ? i : e, a;
    }
  }, {
    key: "validateMinMax",
    value: function validateMinMax(e, t) {
      var i = this.context,
          a = "undefined" != typeof i._regexSpecial && i._regexSpecial.inf.test(i.min),
          n = "undefined" != typeof i._regexSpecial && i._regexSpecial.inf.test(i.max);

      e && (null === i.min || a ? (i.min = -Infinity, i._minObject = -Infinity) : (i.min = i.min.toString().replace(/\s/g, ""), this.regexScientificNotation.test(i.min) && (i.min = this.scientificToDecimal(i.min)), i._minObject = i._discardDecimalSeparator(i.min))), t && (null === i.max || n ? (i.max = 1 / 0, i._maxObject = 1 / 0) : (i.max = i.max.toString().replace(/\s/g, ""), this.regexScientificNotation.test(i.max) && (i.max = this.scientificToDecimal(i.max)), i._maxObject = i._discardDecimalSeparator(i.max))), this.compare(i._minObject, i._maxObject) || (i._maxObject = parseFloat(i._maxObject) + 1, i.max = i._maxObject);
    }
  }, {
    key: "valueToPx",
    value: function valueToPx(e) {
      var t = this.context,
          i = t._measurements.trackLength / t._range;
      var a;
      return a = t._normalLayout ? i * (e - t._drawMin) : i * (t._drawMax - e), Math.round(a);
    }
  }, {
    key: "pxToValue",
    value: function pxToValue(e) {
      var t = this.context;
      var i;

      if (i = t._normalLayout ? (e - t._trackStart) * t._valuePerPx : (t._trackEnd - e) * t._valuePerPx, t.logarithmicScale) {
        var _e294 = i + parseFloat(t._drawMin);

        return Math.pow(10, _e294);
      }

      return this.validate(i + t._minObject, t._minObject, t._maxObject);
    }
  }, {
    key: "compare",
    value: function compare(e, t, i) {
      return e = parseFloat(e), t = parseFloat(t), !0 === i ? e < t ? -1 : e > t ? 1 : 0 : e !== t;
    }
  }, {
    key: "incrementDecrement",
    value: function incrementDecrement(e, t, i) {
      var a = this.context;
      var n;

      if ("add" === t) {
        if (n = parseFloat(e) + parseFloat(i), void 0 !== a._drawMax) return n > parseFloat(a._drawMax) ? a._drawMax : n;
      } else if (n = parseFloat(e) - parseFloat(i), void 0 !== a._drawMin) return n < parseFloat(a._drawMin) ? a._drawMin : n;

      return n;
    }
  }, {
    key: "render",
    value: function render(e) {
      var t = this.context,
          i = "undefined" != typeof t._regexSpecial && t._regexSpecial.nonNumericValue.test(e);

      if (i) return e;else {
        var _i263 = new Smart.Utilities.NumberRenderer(e);

        return t.scientificNotation ? _i263.toScientific(t.significantDigits, t.precisionDigits) : _i263.toDigits(t.significantDigits, t.precisionDigits);
      }
    }
  }, {
    key: "addTicksAndLabels",
    value: function addTicksAndLabels() {
      var e = this.context,
          t = e._measurements.trackLength,
          i = e._normalLayout,
          a = e._majorTicksInterval,
          n = Math.round(e._range / parseFloat(a.toString())),
          o = t / n,
          r = parseFloat(e._drawMin),
          l = parseFloat(e._drawMax);

      var s = "",
          d = "",
          c,
          m,
          u,
          p,
          g,
          h,
          _,
          f,
          b;

      e._tickValues = [], this._longestLabelSize = 0, i ? (c = r, m = e.logarithmicScale && 0 > r && -1 !== r ? parseFloat(c - this.getPreciseModulo(c, a)) : parseFloat(c - this.getPreciseModulo(c, a) + parseFloat(a)), u = m - c, g = e._formatLabel(r), h = e._tickIntervalHandler.labelsSize.minLabelSize, p = l, _ = e._formatLabel(l), f = e._tickIntervalHandler.labelsSize.maxLabelSize) : (c = l, m = parseFloat(c - this.getPreciseModulo(c, a)), u = c - m, g = e._formatLabel(l), h = e._tickIntervalHandler.labelsSize.maxLabelSize, p = r, _ = e._formatLabel(r), f = e._tickIntervalHandler.labelsSize.minLabelSize), e._labelDummy = this._createMeasureLabel(), b = this._addMajorTickAndLabel(g, h, !0, c), s += b.tick, d += b.label;
      var y = u / a * o;

      if (m.toString() !== e._drawMax.toString() && y < t) {
        var _t250 = e._formatLabel(m.toString()),
            _i264 = h < y;

        b = this._addMajorTickAndLabel(_t250, void 0, _i264, m, !0), s += b.tick, d += b.label;
      }

      b = this.addMiddleMajorTicks(n, o, y, u, i, a), s += b.tick, d += b.label, b = this._addMajorTickAndLabel(_, f, !0, p), s += b.tick, d += b.label, s += this.addMinorTicks(i), e._measureLabelScale.removeChild(e._labelDummy), delete e._labelDummy, delete e._measureLabelScale, "smart-tank" === e.nodeName.toLowerCase() && e._updateScaleWidth(this._longestLabelSize), e._appendTicksAndLabelsToScales(s, d);
    }
  }, {
    key: "addMiddleMajorTicks",
    value: function addMiddleMajorTicks(e, t, a, n, o, r) {
      var l = this.context;
      var i = "",
          s = "";

      for (var d = 1; d < e; d++) {
        var c = d * t + a,
            m = void 0;

        if (m = o ? parseFloat(l._drawMin) + r * d + n : parseFloat(l._drawMax) - r * d - n, m.toString() !== l._drawMax.toString()) {
          var _a171 = l._formatLabel(m.toString()),
              _n132 = !0;

          l._labelDummy.innerHTML = _a171;
          var _o87 = l._labelDummy[l._settings.size];
          c + _o87 >= e * t && (_n132 = !1);

          var _r48 = this._addMajorTickAndLabel(_a171, void 0, _n132, m, !0);

          i += _r48.tick, s += _r48.label;
        }
      }

      return {
        tick: i,
        label: s
      };
    }
  }, {
    key: "addMinorTicks",
    value: function addMinorTicks(e) {
      function t(e) {
        return parseFloat(e.toFixed(c));
      }

      function a(e) {
        -1 === l.indexOf(e) && 0 === r._numericProcessor.getPreciseModulo(e, d, m) && (p += "<div style=\"" + u + ": " + r._numericProcessor.valueToPx(e) + "px;\" class=\"smart-tick smart-tick-minor\"></div>");
      }

      function i() {
        var e = r._measurements.trackLength,
            t = e / l.length,
            i = .1;
        20 > t ? i = 1 : 20 <= t && 40 > t ? i = 1 < h - g ? 1 : .5 : 40 <= t && 80 > t && (i = .2);
        var a = Math.floor(r._drawMax),
            s = r._drawMax - a,
            d = r._drawMax - r._drawMin > l.length;

        for (var _e295 = r._drawMax; _e295 > r._drawMin - 1; --_e295) {
          var _t251 = 0 < s ? o(10, _e295 - s + 1) : o(10, _e295),
              _a172 = _t251 * i;

          for (var _e296 = _t251; 0 < _e296; _e296 -= _a172) {
            if (_e296 < r.max && _e296 > r.min) {
              var _t252 = new Smart.Utilities.BigNumber(n(_e296));

              (0 == _t252 % 1 && d || !d) && (p += "<div style=\"" + u + ": " + r._numericProcessor.valueToPx(_t252) + "px;\" class=\"smart-tick smart-tick-minor\"></div>");
            }
          }
        }
      }

      var n = Math.log10,
          o = Math.pow;
      var r = this.context,
          l = r._tickValues,
          s = r._tickIntervalHandler.nearestPowerOfTen,
          d = r._minorTicksInterval,
          c = 0 > n(s) ? Math.round(Math.abs(n(s))) : 0,
          m = o(10, c),
          u = r._settings.leftOrTop;

      var p = "",
          g,
          h,
          _;

      if (e ? (g = l[0], h = l[1], _ = l[l.length - 1]) : (g = l[l.length - 1], h = l[l.length - 2], _ = l[0]), r.logarithmicScale) i();else {
        for (var _e297 = h; _e297 > g; _e297 = t(_e297 - s)) {
          a(_e297);
        }

        for (var _e298 = t(h + s); _e298 < _; _e298 = t(_e298 + s)) {
          a(_e298);
        }
      }
      return p;
    }
  }, {
    key: "validateCustomTicks",
    value: function validateCustomTicks() {
      var e = this.context;
      var t = [];

      for (var _a173 = 0; _a173 < e.customTicks.length; _a173++) {
        var _i265 = e.customTicks[_a173],
            _n133 = this.createDescriptor(_i265);

        _n133 >= e._minObject && _n133 <= e._maxObject && t.push(_n133.toString());
      }

      t.sort(function (e, t) {
        return e - t;
      }), t = t.filter(function (e, t, i) {
        return !t || e !== i[t - 1];
      }), e.customTicks = t.slice(0);
    }
  }, {
    key: "addGaugeTicksAndLabels",
    value: function addGaugeTicksAndLabels() {
      var e = Math.PI;
      var t = this.context,
          a = this,
          n = Math.max(t._tickIntervalHandler.labelsSize.minLabelSize, t._tickIntervalHandler.labelsSize.maxLabelSize),
          o = t._majorTicksInterval,
          r = t._minorTicksInterval,
          l = {},
          s = t._distance,
          d = t._measurements.radius,
          c = d - s.majorTickDistance,
          m = d - s.minorTickDistance;

      var u, p, g, h, _, f;

      "none" !== t.ticksVisibility && !1 !== t._plotTicks ? (u = function u(e) {
        t._drawTick(e, c, "major");
      }, p = function p(e) {
        t._drawTick(a.getAngleByValue(e, !0), m, "minor");
      }) : (u = function u() {}, p = function p() {}), g = "none" !== t.labelsVisibility && !1 !== t._plotLabels ? function (e, i, a) {
        t._drawLabel(e, i, s.labelDistance, a);
      } : function () {}, void 0 === t.inverted || !t.inverted && !t.rightToLeft || t.rightToLeft && t.inverted ? (_ = t.endAngle, f = t.startAngle) : (_ = t.startAngle, f = t.endAngle), h = a.getAngleByValue(t._drawMin, !1), u(h), l[t._drawMin] = !0, g(h, t.min, !1);
      var b = t._drawMin - a.getPreciseModulo(t._drawMin, o),
          y;
      0 <= t._drawMin && (b += o);

      for (var _e299 = b; _e299 >= t._drawMin; _e299 -= r) {
        y = _e299;
      }

      h = a.getAngleByValue(b, !1), u(h), l[b] = !0, 2 * e * t._measurements.innerRadius * (this._getAngleDifference(_, a.getAngleByValue(b, !1, !0)) / 360) > n && g(h, this.getActualValue(b), b < t._drawMax);
      var v;

      for (v = b + o; v < t._drawMax - o; v += o) {
        h = a.getAngleByValue(v, !1), u(h), l[v] = !0, g(h, this.getActualValue(v), !0);
      }

      if (void 0 === l[v] && v <= t._drawMax && (h = a.getAngleByValue(v, !1), u(h), l[v] = !0, 2 * e * t._measurements.innerRadius * (this._getAngleDifference(f, a.getAngleByValue(v, !1, !0)) / 360) >= n && g(h, this.getActualValue(v), !0), t._normalizedStartAngle !== t.endAngle && (h = a.getAngleByValue(t._drawMax, !1), u(h), l[t._drawMax] = !0, 2 * e * t._measurements.innerRadius * (this._getAngleDifference(f, _) / 360) >= n && g(h, t.max, !1))), !t.logarithmicScale) for (var _e300 = y; _e300 < t._drawMax; _e300 += r) {
        l[_e300] || p(_e300);
      } else this.drawGaugeLogarithmicScaleMinorTicks(l, o, p);
    }
  }, {
    key: "updateToolTipAndValue",
    value: function updateToolTipAndValue(e, t, i) {
      var a = this.context,
          n = a.logarithmicScale;
      a._updateTooltipValue(e), n && (e = parseFloat(Math.pow(10, parseFloat(e)).toFixed(11)));
      var o = e.toString();
      a._number = e, a._drawValue = n ? Math.log10(o) : e, o !== t && i && (a.value = a._discardDecimalSeparator(o), !a._programmaticValueIsSet && a.$.fireEvent("change", {
        value: a.value,
        oldValue: t
      }), a.$.hiddenInput && (a.$.hiddenInput.value = a.value), a.setAttribute("aria-valuenow", a._getEventValue(!0)));
    }
  }, {
    key: "validateInterval",
    value: function validateInterval(e) {
      var t = this.context,
          i = t._maxObject - t._minObject;
      t._validInterval = Math.min(parseFloat(e), i), t.interval = t._validInterval;
    }
  }, {
    key: "getCoercedValue",
    value: function getCoercedValue(e, t, i) {
      var a = Math.abs;
      var n = this.context;
      if (!n.coerce) return e;
      var o = !n.logarithmicScale,
          r,
          l;

      if (n.customInterval) {
        var _l35 = n.customTicks;
        if (0 === _l35.length) return e;
        o = o || i, r = !1 === t ? n._minObject : parseFloat(n._drawMin);

        var _s22 = a(r - e),
            _d17 = r;

        for (var _t253 = 0; _t253 < _l35.length; _t253++) {
          var _i266 = this.createDescriptor(_l35[_t253]),
              _n134 = o ? _i266 : Math.log10(_i266),
              _r49 = a(_n134 - e);

          _r49 < _s22 && (_s22 = _r49, _d17 = _n134);
        }

        return _d17;
      }

      !1 === t ? (r = parseFloat(n.min), l = parseFloat(n.max)) : (r = parseFloat(n._drawMin), l = parseFloat(n._drawMax));
      var s = e - r,
          d = this.getPreciseModulo(s, parseFloat(n.interval)),
          c = this.roundCoefficient;
      if (0 === d) return e;
      0 === this.roundCoefficient && (c = 12);
      var m = parseFloat((s - d).toFixed(c)),
          u = m + parseFloat(n.interval);

      if (n.max - n.min <= parseFloat(n.interval) && o) {
        var _t254 = r,
            _i267 = l;
        return e >= _t254 + (_i267 - _t254) / 2 ? _i267 : _t254;
      }

      if (a(s - m) < a(s - u)) return m + r;else {
        var _e301 = u + r;

        return _e301 > l ? m + r : _e301;
      }
    }
  }, {
    key: "updateValue",
    value: function updateValue(e) {
      var t = this.context,
          i = this.validate(e, t._minObject, t._maxObject),
          a = t.value;
      e.toString() !== a.toString() || t._scaleTypeChangedFlag ? (t.value = e.toString(), t._number = i, !t._programmaticValueIsSet && t.$.fireEvent("change", {
        value: t.value,
        oldValue: a
      })) : t.value = "string" == typeof e ? e : e.toString(), t._drawValue = t.logarithmicScale ? Math.log10(i).toString() : i.toString(), t._moveThumbBasedOnValue(t._drawValue), t.$.hiddenInput && (t.$.hiddenInput.value = t.value), t.setAttribute("aria-valuenow", t._getEventValue(!0));
    }
  }, {
    key: "getValuePerPx",
    value: function getValuePerPx(e, t) {
      return parseFloat(e) / t;
    }
  }, {
    key: "restrictValue",
    value: function restrictValue(e) {
      e[1] < e[0] && (e[1] = e[0]);
    }
  }, {
    key: "lockRotation",
    value: function lockRotation(e, t) {
      var i = this.context;

      if (e && t < i._number) {
        if (i._lockCW = !0, t < i._maxObject) return i._maxObject;
      } else if (!e && t > i._number && (i._lockCCW = !0, t > i._minObject)) return i._minObject;
    }
  }, {
    key: "getAngleRangeCoefficient",
    value: function getAngleRangeCoefficient() {
      var e = this.context;
      e._angleRangeCoefficient = e._angleDifference / e._range;
    }
  }]);

  return _class25;
}(Smart.Utilities.BaseNumericProcessor)), Smart.Utilities.Assign("ComplexNumericProcessor",
/*#__PURE__*/
function (_Smart$Utilities$Base3) {
  "use strict";

  _inherits(_class26, _Smart$Utilities$Base3);

  function _class26(e, t) {
    var _this8;

    _classCallCheck(this, _class26);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(_class26).call(this, e, t)), _this8.context = e;
    return _this8;
  }

  _createClass(_class26, [{
    key: "createDescriptor",
    value: function createDescriptor(e, t, i, a, n, o) {
      var r;
      return r = o ? o : e.constructor === this.complexConstructor ? new this.complexConstructor(e.realPart, e.imaginaryPart) : new this.complexConstructor(e), a && (r = this.validate(r, this.context._minObject, this.context._maxObject)), r;
    }
  }, {
    key: "validate",
    value: function validate(e, t, i) {
      var a = e;
      return t === -Infinity ? i !== 1 / 0 && 1 === this.compareComplexNumbers(e, i) && (a = new this.complexConstructor(i.realPart, i.imaginaryPart)) : -1 === this.compareComplexNumbers(e, t) && (a = new this.complexConstructor(t.realPart, t.imaginaryPart)), a;
    }
  }, {
    key: "compare",
    value: function compare(e, t, i) {
      return !0 === i ? this.compareComplexNumbers(e, t) : 0 !== this.compareComplexNumbers(e, t);
    }
  }, {
    key: "validateMinMax",
    value: function validateMinMax(e, t) {
      var i = this.context;
      e && (null === i.min || i._regexSpecial.inf.test(i.min) ? (i.min = -Infinity, i._minObject = -Infinity) : i._minObject = new this.complexConstructor(i.min)), t && (null === i.max || i._regexSpecial.inf.test(i.max) ? (i.max = 1 / 0, i._maxObject = 1 / 0) : i._maxObject = new this.complexConstructor(i.max));
    }
  }, {
    key: "incrementDecrement",
    value: function incrementDecrement(e, t) {
      var i = new this.complexConstructor(e.realPart, e.imaginaryPart),
          a = this.context._spinButtonsStepObject;
      return "add" === t ? (i.realPart += a.realPart, i.imaginaryPart += a.imaginaryPart) : (i.realPart -= a.realPart, i.imaginaryPart -= a.imaginaryPart), i;
    }
  }, {
    key: "render",
    value: function render(e) {
      var t = e;

      if (!1 === this.context._regexSpecial.nonNumericValue.test(e)) {
        var _e302 = t.realPart,
            _i268 = t.imaginaryPart,
            _a174 = this.context.significantDigits,
            _n135 = this.context.precisionDigits,
            _o88;

        0 <= _i268 ? _o88 = "+" : (_o88 = "-", _i268 = Math.abs(_i268));

        var r = new Smart.Utilities.NumberRenderer(_e302),
            _l36 = new Smart.Utilities.NumberRenderer(_i268);

        this.context.scientificNotation ? (_e302 = r.toScientific(_a174, _n135), _i268 = _l36.toScientific(_a174, _n135)) : (_e302 = r.toDigits(_a174, _n135), _i268 = _l36.toDigits(_a174, _n135)), t = "".concat(_e302, " ").concat(_o88, " ").concat(_i268, "i");
      }

      return t;
    }
  }, {
    key: "compareComplexNumbers",
    value: function compareComplexNumbers(e, t) {
      if (!1 == e instanceof this.complexConstructor || !1 == t instanceof this.complexConstructor) return -1;
      var i = e.realPart,
          a = t.realPart;
      if (i < a) return -1;
      if (i > a) return 1;else {
        var _i269 = e.imaginaryPart,
            _a175 = t.imaginaryPart;
        return _i269 < _a175 ? -1 : _i269 > _a175 ? 1 : 0;
      }
    }
  }]);

  return _class26;
}(Smart.Utilities.BaseNumericProcessor)), Smart.Utilities.Assign("NumberRenderer",
/*#__PURE__*/
function () {
  "use strict";

  function _class27(e) {
    _classCallCheck(this, _class27);

    var t = this;
    t.numericValue = e, t.powersToPrefixes = {
      24: "Y",
      21: "Z",
      18: "E",
      15: "P",
      12: "T",
      9: "G",
      6: "M",
      3: "k",
      0: "",
      "-2": "c",
      "-3": "m",
      "-6": "u",
      "-9": "n",
      "-12": "p",
      "-15": "f",
      "-18": "a",
      "-21": "z",
      "-24": "y"
    }, t.localizationObject = {
      currencysymbol: "$",
      currencysymbolposition: "before",
      decimalseparator: ".",
      thousandsseparator: ",",
      defaultPrecision: 2
    };
  }

  _createClass(_class27, [{
    key: "isENotation",
    value: function isENotation(e) {
      return new RegExp(/e/i).test(e);
    }
  }, {
    key: "largeExponentialToDecimal",
    value: function largeExponentialToDecimal(e) {
      var t;
      e === void 0 && (e = this.numericValue, t = !0);
      var i = e.toString().toLowerCase(),
          a = i.indexOf("e"),
          n = new Smart.Utilities.BigNumber(i.slice(0, a)),
          o = i.slice(a + 1, a + 2);
      "+" !== o && "-" !== o && (i = i.slice(0, a) + "e+" + i.slice(a + 1), o = "+");
      var r = i.slice(a + 2),
          l = new Smart.Utilities.BigNumber(10),
          s = l.pow(o + (t ? Math.min(20, r) : r)),
          d = n.multiply(s);
      return d.toString();
    }
  }, {
    key: "bigNumberToExponent",
    value: function bigNumberToExponent(e, t) {
      var i = this.numericValue;
      i.constructor !== Smart.Utilities.BigNumber && (i = new Smart.Utilities.BigNumber(i));
      var a = i._f;
      var n = i.toString();
      if (10 >= a) return t ? parseFloat(n).toExponential(null === e ? void 0 : e - 1) : new Smart.Utilities.NumberRenderer(parseFloat(n)).toDigits(e);
      if (e >= a && !t) return n;else {
        var _o89;

        !1 === i._s ? _o89 = "" : (_o89 = "-", n = n.slice(1));
        var r = parseFloat(n.slice(e, e + 1));
        5 <= r && (n = new Smart.Utilities.BigNumber(n.slice(0, e)).add(1).toString());

        var _l37 = n.slice(1, e);

        if (t) e--, 0 < _l37.length && e > _l37.length ? _l37 += "0".repeat(e - _l37.length) : 0 === _l37.length && (_l37 = "0".repeat(e));else for (; 0 < _l37.length && "0" === _l37.charAt(_l37.length - 1);) {
          _l37 = _l37.slice(0, _l37.length - 1);
        }

        var _s23 = 0 < _l37.length ? "." : "";

        return _o89 + n.slice(0, 1) + _s23 + _l37 + "E+" + (a - 1);
      }
    }
  }, {
    key: "toScientific",
    value: function toScientific() {
      var e = this;
      var t;
      if (t = e.numericValue._d ? e.bigNumberToExponent(null === arguments[0] ? arguments[1] + 1 : arguments[0], !0).toLowerCase() : (+e.numericValue.toString()).toExponential(), isNaN(t)) return t;
      var i = t.indexOf("e"),
          a = t.slice(i + 1);
      var n = parseFloat(t.slice(0, i));
      if ("-2" === a) return new Smart.Utilities.NumberRenderer(n).toDigits(arguments[0], arguments[1]) + "c";
      var o = parseInt(a, 10) % 3;
      if (0 < o) for (var _e303 = 0; _e303 < o; _e303++) {
        n *= 10;
      } else if (0 > o) {
        var _e304 = Smart.Utilities.BigNumber.ignoreBigIntNativeSupport;
        Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = !0, n = parseFloat(new Smart.Utilities.BigNumber(n).multiply(Math.pow(10, o)).toString()), Smart.Utilities.BigNumber.ignoreBigIntNativeSupport = _e304;
      }

      if (0 < a) {
        var _e305 = 0 <= n ? 0 : 1,
            _a176 = t.slice(_e305, i).length - o - 2;

        0 <= _a176 && (n = n.toFixed(_a176));
      }

      var r = new Smart.Utilities.NumberRenderer(n);
      n = r.toDigits(arguments[0], arguments[1]);
      var l = parseInt(a, 10) - o,
          s = n + e.powersToPrefixes[l.toString()];
      return s;
    }
  }, {
    key: "bigNumberToScientific",
    value: function bigNumberToScientific() {
      var e = this,
          t = e.numericValue._f - 1,
          i = parseInt(t, 10) % 3,
          a = parseInt(t, 10) - i;
      var n = e.numericValue.toString(),
          o,
          r;
      if ("-" === n.charAt(0) ? (o = "-", n = n.slice(1)) : o = "", null !== arguments[0]) for (r = n.slice(0, arguments[0]), 5 <= parseFloat(n.slice(arguments[0], arguments[0] + 1)) && (r = new Smart.Utilities.BigNumber(r).add(1).toString()); r.length > 1 + i && "0" === r.charAt(r.length - 1);) {
        r = r.slice(0, r.length - 1);
      } else null !== arguments[1] && (r = n.slice(0, arguments[1] + 1), 5 <= parseFloat(n.slice(arguments[1] + 1, arguments[1] + 2)) && (r = new Smart.Utilities.BigNumber(r).add(1).toString()), arguments[1] + i > r.length - 1 && (r += "0".repeat(arguments[1] + i - r.length + 1)));
      return r.length > 1 + i && (r = r.slice(0, 1 + i) + "." + r.slice(1 + i)), o + r + e.powersToPrefixes[a.toString()];
    }
  }, {
    key: "toDigits",
    value: function toDigits(e, t) {
      var i = this;
      var a;
      return a = null === e ? null === t ? i.applySignificantDigits(8) : i.applyPrecisionDigits(t) : i.applySignificantDigits(e), a;
    }
  }, {
    key: "applySignificantDigits",
    value: function applySignificantDigits(e) {
      function t(e) {
        for (; "0" === e.charAt(e.length - 1);) {
          e = e.slice(0, -1);
        }

        return "." === e.charAt(e.length - 1) && (e = e.slice(0, -1)), e;
      }

      var i = this;
      e = Math.max(1, Math.min(e, 21));
      var a = parseFloat(i.numericValue).toPrecision(e).toUpperCase();
      if (-1 !== a.indexOf(".")) if (i.isENotation(a)) {
        var _e306 = a.indexOf("."),
            _i270 = a.indexOf("E");

        var _n136 = a.slice(_e306, _i270);

        _n136 = t(_n136), a = a.slice(0, _e306) + _n136 + a.slice(_i270);
      } else a = t(a);
      return a;
    }
  }, {
    key: "applyPrecisionDigits",
    value: function applyPrecisionDigits(e) {
      var t = this;
      e = Math.max(0, Math.min(e, 20));
      var i = parseFloat(t.numericValue).toFixed(e);
      return t.isENotation(i) && (i = t.largeExponentialToDecimal(i) + "." + "0".repeat(e)), i;
    }
  }, {
    key: "getLogarithm",
    value: function getLogarithm(e) {
      var t = Math.log;
      var i = this.numericValue;
      var a;
      if (void 0 === e && (e = 10), 10 === e) try {
        a = Math.log10(i);
      } catch (e) {
        a = t(i) / 2.302585092994046;
      } else a = t(i) / t(e);
      return a;
    }
  }, {
    key: "applySeparators",
    value: function applySeparators(e, t) {
      var i = this;
      e = e.toString();
      var a = e.indexOf(".");

      if (-1 !== a) {
        var _n137 = e.slice(0, a),
            _o90 = e.slice(a + 1);

        return i.applyThousandsSeparator(_n137, t) + i.localizationObject.decimalseparator + _o90;
      }

      return i.applyThousandsSeparator(e, t);
    }
  }, {
    key: "applyThousandsSeparator",
    value: function applyThousandsSeparator(e, t) {
      if (t) return e;
      var i = "";
      e = e.toString(), "-" === e.charAt(0) && (i = "-", e = e.slice(1));
      var a = e.split("").reverse();

      for (var _n138 = 2; _n138 < a.length - 1; _n138 += 3) {
        a[_n138] = this.localizationObject.thousandsseparator + a[_n138];
      }

      return a.reverse(), a = a.join(""), i + a;
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(e, t, i) {
      var a = Math.round;
      var n = this;
      if (void 0 === arguments[3] && delete n._ignoreMinus, delete n._wordLengthNumber, !/^([a-zA-Z]\d*)$/g.test(t)) try {
        var _i271 = n.applyCustomFormat(e, t);

        return _i271;
      } catch (t) {
        return e.toString();
      }
      var o = t.slice(0, 1);
      var r = t.slice(1);
      if ("" !== r && (isNaN(parseFloat(r)) || 0 > parseFloat(r) || 99 < parseFloat(r) ? r = "" : 0 != parseFloat(r) % 1 && (r = a(r))), e._d) n.inputFormat = "integer";else {
        if (e.imaginaryPart) return n.formatComplexNumber(e, t, o, r);
        n.inputFormat = "floatingPoint";
      }
      var l = new Smart.Utilities.NumericProcessor(n, "inputFormat"),
          s = l.createDescriptor(e),
          d;

      switch (n._wordLengthNumber = l.getWordLength(i ? i : "int32"), "integer" === n.inputFormat && (s = l.round(s)), n.numericValue = s, o) {
        case "C":
        case "c":
          return "" === r && (r = n.localizationObject.defaultPrecision), r = parseFloat(r), d = "floatingPoint" === n.inputFormat ? n.applyPrecisionDigits(r) : s.toString() + (0 < r ? "." + "0".repeat(r) : ""), d = n.applySeparators(d), "before" === n.localizationObject.currencysymbolposition ? "-" === d.charAt(0) ? "-" + n.localizationObject.currencysymbol + d.slice(1) : n.localizationObject.currencysymbol + d : d + " " + n.localizationObject.currencysymbol;

        case "D":
        case "d":
          {
            if (d = s, "floatingPoint" === n.inputFormat && (d = a(s)), d = d.toString(), "" === r) return d;
            var _e307 = "";
            "-" === d.charAt(0) && (_e307 = "-", d = d.slice(1));

            var _t255 = r - d.length;

            return 0 < _t255 && (d = "0".repeat(_t255) + d), _e307 + d;
          }

        case "E":
        case "e":
        case "U":
        case "u":
          {
            "" === r && (r = 6), d = "floatingPoint" === n.inputFormat ? s.toExponential(r) : n.bigNumberToExponent(parseFloat(r) + 1, !0).toLowerCase();

            var _e308 = d.indexOf("e"),
                _t256 = d.slice(_e308 + 2).length;

            return (3 > _t256 && (d = d.slice(0, _e308 + 2) + "0".repeat(3 - _t256) + d.slice(_e308 + 2)), "u" === o.toLowerCase()) ? n.exponentialToSuperscript(n.applySeparators(d, !0)) : ("E" === o && (d = d.toUpperCase()), n.applySeparators(d, !0));
          }

        case "F":
        case "f":
        case "N":
        case "n":
          return "" === r && (r = n.localizationObject.defaultPrecision), r = parseFloat(r), d = "floatingPoint" === n.inputFormat ? n.applyPrecisionDigits(r) : s.toString() + (0 < r ? "." + "0".repeat(r) : ""), n.applySeparators(d, "f" === o.toLowerCase());

        case "G":
        case "g":
          {
            ("" === r || "0" === r) && (r = "floatingPoint" === n.inputFormat ? 15 : "int8" === i || "uint8" === i ? 3 : "int16" === i || "uint16" === i ? 5 : "int64" === i ? 19 : "uint64" === i ? 20 : 10), r = parseFloat(r);

            var _t257 = n.formatNumber(e, "E" + r, i),
                _a177 = _t257.indexOf("E");

            var _l38 = parseInt(_t257.slice(_a177 + 1), 10);

            if (-5 < _l38 && _l38 < r) return "floatingPoint" === n.inputFormat ? n.applySeparators(n.applySignificantDigits(r), !0) : s.toString();

            if (-100 < _l38 && 100 > _l38 && (_t257 = _t257.slice(0, _a177 + 2) + _t257.slice(_a177 + 3)), -1 !== _t257.indexOf(n.localizationObject.decimalseparator)) {
              for (; "0" === _t257.charAt(_a177 - 1);) {
                _t257 = _t257.slice(0, _a177 - 1) + _t257.slice(_a177), _a177 = _t257.indexOf("E");
              }

              _t257.charAt(_a177 - 1) === n.localizationObject.decimalseparator && (_t257 = _t257.slice(0, _a177 - 1) + _t257.slice(_a177));
            }

            return "g" === o && (_t257 = _t257.toLowerCase()), _t257;
          }

        case "P":
        case "p":
          return "" === r && (r = n.localizationObject.defaultPrecision), r = parseFloat(r), "floatingPoint" === n.inputFormat ? (n.numericValue = 100 * s, d = n.applyPrecisionDigits(r)) : d = s.multiply(100).toString() + (0 < r ? "." + "0".repeat(r) : ""), n.applySeparators(d) + " %";

        case "B":
        case "b":
        case "O":
        case "o":
        case "X":
        case "x":
          {
            "integer" !== n.inputFormat && (n.inputFormat = "integer", l = new Smart.Utilities.NumericProcessor(n, "inputFormat"), s = l.round(l.createDescriptor(e)));

            var _t258;

            if (_t258 = "B" === o || "b" === o ? 2 : "O" === o || "o" === o ? 8 : 16, d = s.toString(_t258, n._wordLengthNumber), "" !== r) {
              var _e309 = parseFloat(r) - d.length;

              0 < _e309 && (d = "0".repeat(_e309) + d);
            }

            return "x" === o && (d = d.toLowerCase()), d;
          }

        case "S":
        case "s":
          return "" === r && (r = n.localizationObject.defaultPrecision), r = parseFloat(r), n.toScientific(null, r).replace(".", n.localizationObject.decimalseparator);

        default:
          return e.toString();
      }
    }
  }, {
    key: "formatComplexNumber",
    value: function formatComplexNumber(e, t, i) {
      var a = this;
      return "E" === i || "e" === i || "U" === i || "u" === i || "F" === i || "f" === i || "G" === i || "g" === i || "N" === i || "n" === i || "S" === i || "s" === i ? 0 <= e.imaginaryPart ? a.formatNumber(e.realPart, t) + " + " + a.formatNumber(e.imaginaryPart, t) + "i" : a.formatNumber(e.realPart, t) + " - " + a.formatNumber(Math.abs(e.imaginaryPart), t) + "i" : e.toString();
    }
  }, {
    key: "toString",
    value: function toString(e, t, i) {
      return t ? this.formatNumber(e, t, i) : e.toString();
    }
  }, {
    key: "applyCustomFormat",
    value: function applyCustomFormat(e, t) {
      var i = this;
      t = t.replace(/_.|\[\w*\]|\*/g, ""), t = t.replace(/\?/g, "#");
      var a = t.split(";");
      if ("string" == typeof e && isNaN(e)) return a[a.length - 1].replace(/"/g, "").replace(/@/g, e.toString());
      if (e._d) i.inputFormat = "integer";else {
        if (e.imaginaryPart) return e.toString();
        e = parseFloat(e), i.inputFormat = "floatingPoint";
      }
      var n = new Smart.Utilities.NumericProcessor(i, "inputFormat"),
          o = n.createDescriptor(e);
      "integer" === i.inputFormat && (o = n.round(o)), i.numericProcessor = n;
      var r = i.getRelevantFormatSection(a, o);
      if (void 0 === r) return e.toString();
      if (-1 !== r.indexOf("@")) return a[a.length - 1].replace(/"/g, "").replace(/@/g, e.toString());
      var l = -1 !== r.replace(/".*"/g, "").indexOf("%"),
          s = i.getTextParts(r);
      if (-1 !== s.main.toLowerCase().indexOf("e")) return i.applyCustomExponentialFormat(o, s, n);
      if (-1 !== s.main.indexOf("/")) return i.applyCustomFractionalFormat(o, s, n);

      if (l && ("integer" === i.inputFormat ? o = o.multiply(100) : o *= 100), "" === s.main) {
        if (!l) return s.suffix;

        var _e310 = o.toString();

        return i._ignoreMinus && "-" === _e310.charAt(0) && (_e310 = _e310.slice(1)), _e310 + s.suffix;
      }

      var d = s.main.replace(/[^0#,. \/]/g, ""),
          c = d.indexOf(".");

      for (-1 !== c && (d = d.substring(0, c + 1) + d.substring(c + 1).replace(/\./g, ""), "." === d.charAt(d.length - 1) && (d = d.slice(0, d.length - 1)), 0 === c && (d = "#" + d)); "," === d.charAt(d.length - 1);) {
        d = d.slice(0, d.length - 1), "floatingPoint" === i.inputFormat ? o /= 1e3 : o = o.multiply(.001);
      }

      "integer" === i.inputFormat && (o = n.round(o));
      var m = -1 !== d.indexOf(",");
      d = d.replace(/,/g, "");
      var u = d.split("."),
          p = u[0];
      var g = u[1],
          h = "";
      if (1 === u.length) return "floatingPoint" === i.inputFormat && (o = n.round(o)), h = o.toString(), i.setTextParts(i.formatWholeNumber(h, p, m), s);
      h = o.toString();

      var _ = h.split("."),
          f = i.formatWholeNumber(_[0], p, m),
          b = _[1] || "";

      if (g.length <= b.length && (h = parseFloat(o.toFixed(g.length)).toString(), _ = h.split("."), f = i.formatWholeNumber(_[0], p, m), b = _[1] || "", b)) return i.setTextParts(f + i.localizationObject.decimalseparator + b.slice(0, g.length), s);
      g = g.slice(b.length - g.length);
      var y = g.lastIndexOf("0");
      return -1 === y ? "" === b ? i.setTextParts(f, s) : i.setTextParts(f + i.localizationObject.decimalseparator + b, s) : i.setTextParts(f + i.localizationObject.decimalseparator + b + "0".repeat(y + 1), s);
    }
  }, {
    key: "getRelevantFormatSection",
    value: function getRelevantFormatSection(e, t) {
      var i = this,
          a = i.numericProcessor.compare(t, 0, !0);
      if (1 === a) return e[0];
      var n, o;
      return 3 <= e.length ? (i._ignoreMinus = !0, n = 1, o = 2) : 2 === e.length ? (i._ignoreMinus = !0, o = 0, n = 1) : 1 === e.length && (o = 0, n = 0), 0 === a ? e[o] : -1 === a ? e[n] : void 0;
    }
  }, {
    key: "getTextParts",
    value: function getTextParts(e) {
      var t = e.replace(/"[^"]*"/g, ""),
          a = e.match(/"[^"]*"/g),
          i = t.search(/0|#|\./g),
          n = Math.max(t.lastIndexOf("0"), t.lastIndexOf("#"), t.lastIndexOf("."), t.lastIndexOf(",")),
          o = t.slice(i, n + 1);
      if ("" === o) return {
        prefix: "",
        main: "",
        suffix: e.replace(/"/g, "")
      };
      var r = e.indexOf(o),
          l = r + o.length;
      if (a) for (var _t259 = 0; _t259 < a.length; _t259++) {
        var _i272 = e.indexOf(a[_t259]);

        r >= _i272 && l <= _i272 + a[_t259].length && (r = e.indexOf(o, _i272 + a[_t259].length), l = r + o.length);
      }
      var s = e.slice(0, r).replace(/"/g, ""),
          d = e.slice(l).replace(/"/g, "");
      return {
        prefix: s,
        main: o,
        suffix: d
      };
    }
  }, {
    key: "applyCustomExponentialFormat",
    value: function applyCustomExponentialFormat(e, t, i) {
      var a = Math.pow;
      var n = this;
      var o = t.main,
          r;
      var l = -1 !== o.indexOf(",");
      o = o.replace(/[^0#.eE+-]/g, "");
      var s = o.toLowerCase().indexOf("e");
      o = o.substring(0, s + 1) + o.substring(s + 1).replace(/[eE\.]/g, "");
      var d = o.charAt(s),
          c = o.indexOf(".");
      -1 !== c && (o = o.substring(0, c + 1) + o.substring(c + 1).replace(/\./g, "")), "." === o.charAt(o.length - 1) && (o = o.slice(0, o.length - 1));
      var m = o.split(d);
      var u = m[0];
      var p = u.split("."),
          g = p[0],
          h = p[1],
          _ = m[1];
      var f = e.toString().split(".")[0].replace(/-/, ""),
          b = 0;

      if ("0" === f && i.compare(e, 0)) {
        var _t260 = g.length - 1;

        for (; 0 === parseInt(e);) {
          b++, e *= 10;
        }

        f = e.toString().split(".")[0].replace(/-/, ""), b += _t260, e *= a(10, _t260);
      }

      if (l && (u = u.slice(0, 1) + "," + u.slice(1)), f.length <= g.length) r = n.formatNumber(e, u, void 0, !0) + d + n.formatExponent(0 - b, _);else {
        var _t261 = f.length - g.length;

        var _o91 = "floatingPoint" === n.inputFormat ? e / a(10, _t261) : e.divide(a(10, _t261));

        if (!h) {
          var _e311 = n.applyThousandsSeparator(i.round(_o91).toString(), !l);

          r = _e311 + d + n.formatExponent(_t261 - b, _);
        }

        var _s24 = _o91.toString().split(".")[1] || "";

        _s24.length === h.length ? r = n.applySeparators(_o91, !l) + d + n.formatExponent(_t261 - b, _) : _s24.length < h.length ? r = n.formatNumber(_o91, u, void 0, !0) + d + n.formatExponent(_t261 - b, _) : (_o91 = "floatingPoint" === n.inputFormat ? _o91.toFixed(h.length) : _o91 = i.round(e.divide(a(10, _t261 - h.length))).divide(a(10, h.length)), r = n.formatNumber(parseFloat(_o91), u, void 0, !0) + d + n.formatExponent(_t261 - b, _));
      }
      return n.setTextParts(r, t);
    }
  }, {
    key: "formatExponent",
    value: function formatExponent(e, t) {
      var i;
      return -1 !== ["+", "-"].indexOf(t.charAt(0)) && (i = t.charAt(0), (0 < e && "-" === i || 0 > e && "+" === i) && (i = void 0)), 0 > e && (e = Math.abs(e), i = "-"), t = t.replace(/[+-]/g, ""), e = this.formatNumber(e, t, void 0, !0), (i ? i : "") + e;
    }
  }, {
    key: "formatWholeNumber",
    value: function formatWholeNumber(e, t, i) {
      var a = this;
      var n = "";

      if ("-" === e.charAt(0) && (!a._ignoreMinus && (n = "-"), e = e.slice(1)), "0" === e) {
        if (t === "#".repeat(t.length)) return n;
        e = "";
      }

      if (t.length <= e.length) return n + a.applyThousandsSeparator(e, !i);
      t = t.slice(0, t.length - e.length);

      for (var _a178 = t.length - 1; 0 <= _a178; _a178--) {
        "0" === t.charAt(_a178) && (e = "0" + e);
      }

      return n + a.applyThousandsSeparator(e, !i);
    }
  }, {
    key: "setTextParts",
    value: function setTextParts(e, t) {
      return t.prefix + e + t.suffix;
    }
  }, {
    key: "applyCustomFractionalFormat",
    value: function applyCustomFractionalFormat(e, t, i) {
      var a = Math.abs;
      var n = this,
          o = /^([0#,]+[ ]+)?([0#,]+\/[0#,]+)$/;
      var r = t.main.trim(),
          l;
      if (!o.test(r)) return e.toString();
      var s = o.exec(r);

      if (s[2] = s[2].replace(/,/g, ""), "integer" === n.inputFormat) {
        var _i273 = s[2].split("/");

        return void 0 === s[1] ? l = n.formatNumber(e, _i273[0], void 0, !0) + "/" + n.formatNumber(1, _i273[1], void 0, !0) : (l = n.formatNumber(e, s[1].trim(), void 0, !0), -1 !== s[2].indexOf("0") && (l += " " + n.formatNumber(0, _i273[0], void 0, !0) + "/" + n.formatNumber(1, _i273[1], void 0, !0))), n.setTextParts(l, t);
      }

      if (void 0 === s[1]) l = (0 > e ? "-" : "") + n.formatAsFraction(a(e), s[2]);else {
        var _t262 = s[1].trim(),
            _o92 = s[2];

        l = n.formatNumber(parseInt(e, 10), _t262, void 0, !0) + " " + n.formatAsFraction(i.getPreciseModulo(a(e), 1), _o92);
      }
      return n.setTextParts(l.trim(), t);
    }
  }, {
    key: "formatAsFraction",
    value: function formatAsFraction(e, t) {
      var i = this,
          a = t.split("/");
      if (0 === e) return -1 === t.indexOf("0") ? "" : i.formatNumber(0, a[0], void 0, !0) + "/" + i.formatNumber(1, a[1], void 0, !0);
      if (0 == e % 1) return i.formatNumber(e, a[0], void 0, !0) + "/" + i.formatNumber(1, a[1], void 0, !0);
      var n = [];
      i.approximateFractions(e, n);
      var o = 2 <= a[1].length ? 2 : 1;
      var r = [],
          l = [];
      n.forEach(function (t, i) {
        var a = t.denominator.toString().length,
            n = Math.abs(e - t.numerator / t.denominator);
        return void 0 === r[a] ? (l[a] = i, void (r[a] = n)) : void (n < r[a] && (l[a] = i, r[a] = n));
      });
      var s = l[o] ? n[l[o]] : n[l[1]];
      return i.formatNumber(s.numerator, a[0], void 0, !0) + "/" + i.formatNumber(s.denominator, a[1], void 0, !0);
    }
  }, {
    key: "approximateFractions",
    value: function approximateFractions(e, t) {
      var a = [0, 1],
          n = [1, 0],
          o = this.getMaxNumerator(e);
      var r = e,
          l = NaN,
          s;

      for (var d = 2; 1e3 > d; d++) {
        var _i274 = Math.floor(r);

        if (a[d] = _i274 * a[d - 1] + a[d - 2], Math.abs(a[d]) > o) return;
        if (n[d] = _i274 * n[d - 1] + n[d - 2], s = a[d] / n[d], s === l) return;
        if (t.push({
          numerator: a[d],
          denominator: n[d]
        }), s === e) return;
        l = s, r = 1 / (r - _i274);
      }
    }
  }, {
    key: "getMaxNumerator",
    value: function getMaxNumerator(e) {
      var t = null,
          i = e.toString().indexOf("E");
      -1 === i && (i = e.toString().indexOf("e")), t = -1 === i ? e.toString() : e.toString().substring(0, i);
      var a = null;
      var n = t.toString().indexOf(".");
      -1 === n ? a = t : 0 === n ? a = t.substring(1, t.length) : n < t.length && (a = t.substring(0, n) + t.substring(n + 1, t.length));
      var o = a;
      var r = o.toString().length,
          l = e;
      var s = l.toString().length;
      0 === l && (s = 0);
      var d = r - s;

      for (var _t263 = d; 0 < _t263 && 0 == o % 2; _t263--) {
        o /= 2;
      }

      for (var _t264 = d; 0 < _t264 && 0 == o % 5; _t264--) {
        o /= 5;
      }

      return o;
    }
  }, {
    key: "exponentialToSuperscript",
    value: function exponentialToSuperscript(e) {
      var t = e.indexOf("e"),
          i = e.slice(t + 1).replace(/0{1,2}/, "");
      var a = e.slice(0, t + 1);
      return a = a.replace("e", "\xD710"), a += this.toSuperscript(i), a = a.replace("+", ""), a;
    }
  }, {
    key: "toSuperscript",
    value: function toSuperscript(e, t) {
      var a = "-0123456789",
          o = "\u207B\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079";
      var r = "";

      for (var _l39 = 0; _l39 < e.length; _l39++) {
        if (!0 === t) {
          var _t265 = o.indexOf(e.charAt(_l39));

          r += -1 === _t265 ? e[_l39] : a[_t265];
        } else {
          var _t266 = a.indexOf(e.charAt(_l39));

          r += -1 === _t266 ? e[_l39] : o[_t266];
        }
      }

      return r;
    }
  }]);

  return _class27;
}()), Smart.Utilities.Assign("TickIntervalHandler",
/*#__PURE__*/
function () {
  "use strict";

  function _class28(e, t, i, a, n, o, r) {
    _classCallCheck(this, _class28);

    var l = this;
    l.context = e, l.minLabel = t, l.maxLabel = i, l.labelClass = a, l.dimension = n, l.logarithmic = r, l.labelsSize = e.customInterval ? 0 < e.customTicks.length ? l.getCustomTicksLabelSize() : {
      minLabelSize: 0,
      minLabelOtherSize: 0,
      maxLabelSize: 0,
      maxLabelOtherSize: 0
    } : l.getMinAndMaxLabelSize(), o ? (l.getNiceInterval = l.getNiceIntervalInteger, l.getPossibleBiggerLabel = l.getPossibleBiggerLabelInteger) : (l.getNiceInterval = l.getNiceIntervalFloatingPoint, l.getPossibleBiggerLabel = l.getPossibleBiggerLabelFloatingPoint);
  }

  _createClass(_class28, [{
    key: "getInterval",
    value: function getInterval(e, t, i, a) {
      var n = Math.max;
      var o = this.context,
          r = o._measurements.innerRadius;
      var l = 1,
          s;
      "radial" === e ? (s = n(this.labelsSize.minLabelSize, this.labelsSize.minLabelOtherSize, this.labelsSize.maxLabelSize, this.labelsSize.maxLabelOtherSize), l = 1.35) : (s = n(this.labelsSize.minLabelSize, this.labelsSize.maxLabelSize), l = 1.45), s *= l;
      var d;
      d = "radial" === e ? function () {
        var e = 2 * Math.PI * r * (Math.abs(o.startAngle - o.endAngle) / 360);
        return Math.round(e);
      }() : o[this.dimension] - this.labelsSize.minLabelSize / 2 - this.labelsSize.maxLabelSize / 2, d = n(10, d);
      var c = Math.ceil(d / s),
          m = "radial" === e ? 4 * c : 3 * c;
      var u = this.getNiceInterval(t, i, c, !0),
          p = this.getNiceInterval(t, i, m);

      if (o._cachedLabelsSize = this.labelsSize, 2 < c && !o.customInterval) {
        var _r50 = this.getPossibleBiggerLabel(c, u);

        if (_r50.length > n(this.minLabel.length, this.maxLabel.length)) {
          var _n139 = this.minLabel;
          this.minLabel = _r50, this.labelsSize = this.getMinAndMaxLabelSize(), o._cachedLabelsSize = this.labelsSize;

          var _l40 = this.getInterval(e, t, i, a);

          return this.minLabel = _n139, this.labelsSize = this.getMinAndMaxLabelSize(), _l40;
        }
      }

      return {
        major: u,
        minor: p
      };
    }
  }, {
    key: "getNiceIntervalFloatingPoint",
    value: function getNiceIntervalFloatingPoint(e, t, i, a) {
      var n = Math.log10;
      var o = t - e,
          r = Math.floor(n(o) - n(i));
      var l = Math.pow(10, r),
          s = i * l,
          d;
      d = o < 2 * s ? 1 : o < 3 * s ? 2 : o < 7 * s ? 5 : 10;
      var c = d * l;
      return a && this.context._range / c > i && (5 === d ? d = 10 : 2 === d ? d = 5 : 1 === d ? d = 2 : void 0, c = d * l), this.nearestPowerOfTen = l, this.logarithmic && a ? Math.max(1, c) : c;
    }
  }, {
    key: "getPossibleBiggerLabelFloatingPoint",
    value: function getPossibleBiggerLabelFloatingPoint(e, t) {
      var a = Math.pow;
      var n = this.context;
      var i = parseFloat(n.min - n._numericProcessor.getPreciseModulo(parseFloat(n.min), t) + parseFloat(t)),
          o = i,
          r,
          l;
      this.logarithmic && (i = a(10, i)), r = n._formatLabel(i);

      for (var _s25 = 1; _s25 < e && (o += t, !(o >= n._drawMax)); _s25++) {
        l = this.logarithmic ? a(10, o) : o, l = n._formatLabel(l), l.length > r.length && (r = l);
      }

      return r;
    }
  }, {
    key: "getNiceIntervalInteger",
    value: function getNiceIntervalInteger(e, t, i, a) {
      var n = Math.log10;
      var o = new Smart.Utilities.BigNumber(t).subtract(new Smart.Utilities.BigNumber(e)),
          r = Math.floor(n(o.toString()) - n(i)),
          l = new Smart.Utilities.BigNumber(10).pow(new Smart.Utilities.BigNumber(r)),
          s = new Smart.Utilities.BigNumber(i).multiply(l);
      var d = -1 === o.compare(new Smart.Utilities.BigNumber(2 * s)) ? 1 : -1 === o.compare(new Smart.Utilities.BigNumber(3 * s)) ? 2 : -1 === o.compare(new Smart.Utilities.BigNumber(7 * s)) ? 5 : 10;
      var c = new Smart.Utilities.BigNumber(d).multiply(l);
      return a && 1 === new Smart.Utilities.BigNumber(this.context._range).divide(c).compare(i) && (5 === d ? d = 10 : 2 === d ? d = 5 : 1 === d ? d = 2 : void 0, c = new Smart.Utilities.BigNumber(d).multiply(l)), -1 === c.compare(1) && (c = new Smart.Utilities.BigNumber(1)), this.nearestPowerOfTen = l, c;
    }
  }, {
    key: "getPossibleBiggerLabelInteger",
    value: function getPossibleBiggerLabelInteger(e, t) {
      var a = this.context,
          n = new Smart.Utilities.BigNumber(10);
      var i = new Smart.Utilities.BigNumber(a.min).subtract(new Smart.Utilities.BigNumber(a.min).mod(t)).add(t),
          o = i,
          r,
          l;
      this.logarithmic && (i = n.pow(i)), r = a._formatLabel(i);

      for (var _s26 = 1; _s26 < e && (o = o.add(t), -1 === o.compare(a._drawMax)); _s26++) {
        l = this.logarithmic ? n.pow(o) : o, l = a._formatLabel(l), l.length > r.length && (r = l);
      }

      return r;
    }
  }, {
    key: "getMinAndMaxLabelSize",
    value: function getMinAndMaxLabelSize() {
      var e = this,
          t = e.context,
          i = t.$.container,
          a = document.createElement("span");
      a.className = e.labelClass, a.style.position = "absolute", a.style.visibility = "hidden", i.appendChild(a), a.innerHTML = e.minLabel;
      var n = a[e.dimension],
          o = a[t._settings.otherSize];
      a.innerHTML = e.maxLabel;
      var r = a[e.dimension],
          l = a[t._settings.otherSize];
      return i.removeChild(a), {
        minLabelSize: n,
        minLabelOtherSize: o,
        maxLabelSize: r,
        maxLabelOtherSize: l
      };
    }
  }, {
    key: "getCustomTicksLabelSize",
    value: function getCustomTicksLabelSize() {
      var e = this,
          t = e.context,
          i = t.$.container,
          a = document.createElement("span"),
          n = t.customTicks;
      a.className = e.labelClass, a.style.position = "absolute", a.style.visibility = "hidden", i.appendChild(a), a.innerHTML = t._formatLabel(n[0]);
      var o = a[e.dimension],
          r = a[t._settings.otherSize];

      for (var _n140 = 1; _n140 < t.customTicks.length; _n140++) {
        a.innerHTML = t._formatLabel(t.customTicks[_n140]);
        var _i275 = a[e.dimension],
            _l41 = a[t._settings.otherSize];
        _i275 > o && (o = _i275), _l41 > r && (r = _l41);
      }

      return i.removeChild(a), {
        minLabelSize: o,
        minLabelOtherSize: r,
        maxLabelSize: o,
        maxLabelOtherSize: r
      };
    }
  }]);

  return _class28;
}()), Smart("smart-button",
/*#__PURE__*/
function (_Smart$ContentElement) {
  "use strict";

  _inherits(_class29, _Smart$ContentElement);

  function _class29() {
    _classCallCheck(this, _class29);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class29).apply(this, arguments));
  }

  _createClass(_class29, [{
    key: "template",
    value: function template() {
      return "<button class=\"smart-button\" inner-h-t-m-l='[[innerHTML]]' id='button' type='[[type]]' name='[[name]]' value='[[value]]' disabled='[[disabled]]' role=\"presentation\"></button>";
    }
  }, {
    key: "focus",
    value: function focus() {
      var e = this;
      return e.$.button ? void e.$.button.focus() : void HTMLElement.prototype.focus.call(e);
    }
  }, {
    key: "blur",
    value: function blur() {
      var e = this;
      return e.$.button ? void e.$.button.blur() : void HTMLElement.prototype.blur.call(e);
    }
  }, {
    key: "_upHandler",
    value: function _upHandler(e) {
      var t = this;
      e.stopPropagation(), t.$.setAttributeValue("active", !1);
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler() {
      var e = this;
      e.$.setAttributeValue("focus", !0);
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      var e = this;
      e.$.setAttributeValue("focus", !1);
    }
  }, {
    key: "_clickHandler",
    value: function _clickHandler(e) {
      var t = this;
      ("release" !== t.clickMode && "pressAndRelease" !== t.clickMode || t.readonly) && (e.preventDefault(), e.stopPropagation());
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;

      if (!t.disabled && (t.hasRippleAnimation && Smart.Utilities.Animation.Ripple.animate(t, e.pageX, e.pageY), t.$.setAttributeValue("active", !0), ("press" === t.clickMode || "pressAndRelease" === t.clickMode) && !t.readonly)) {
        var _i276 = "buttons" in e ? e.buttons : e.which;

        t.$.fireEvent("click", {
          buttons: _i276,
          clientX: e.clientX,
          clientY: e.clientY,
          pageX: e.pageX,
          pageY: e.pageY,
          screenX: e.screenX,
          screenY: e.screenY
        });
      }
    }
  }, {
    key: "_mouseEnterHandler",
    value: function _mouseEnterHandler(e) {
      var t = this;

      if (!t.readonly && (t.$button.setAttributeValue("hover", !0), t.$.setAttributeValue("hover", !0), "hover" === t.clickMode)) {
        var _i277 = "buttons" in e ? e.buttons : e.which;

        t.$.fireEvent("click", {
          buttons: _i277,
          clientX: e.clientX,
          clientY: e.clientY,
          pageX: e.pageX,
          pageY: e.pageY,
          screenX: e.screenX,
          screenY: e.screenY
        });
      }
    }
  }, {
    key: "_touchEndHandler",
    value: function _touchEndHandler() {
      var e = this;
      setTimeout(function () {
        e.$button.setAttributeValue("hover", !1), e.$.setAttributeValue("hover", !1);
      }, 300);
    }
  }, {
    key: "_mouseLeaveHandler",
    value: function _mouseLeaveHandler() {
      var e = this;
      e.$button.setAttributeValue("hover", !1), e.$.setAttributeValue("hover", !1);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class29.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      "disabled" === e ? (a._setFocusable(), a.$button && a.$button.setAttributeValue("hover", !1), a.$.setAttributeValue("hover", !1), a instanceof Smart.RepeatButton && a._stopRepeat()) : "unfocusable" == e && a._setFocusable();
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this,
          t = e.$.button ? e.$.button : e;
      return e.disabled || e.unfocusable ? (t.removeAttribute("tabindex"), void (t.tabIndex = -1)) : void (t.tabIndex = 0 < e.tabIndex ? e.tabIndex : 0);
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      _get(_getPrototypeOf(_class29.prototype), "ready", this).call(this), e.setAttribute("role", "button"), e._setFocusable(), e.enableShadowDOM && e.$.hiddenInput && e.appendChild(e.$.hiddenInput);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        value: {
          type: "string"
        },
        name: {
          type: "string"
        },
        type: {
          value: "button",
          type: "string"
        },
        clickMode: {
          allowedValues: ["hover", "press", "release", "pressAndRelease"],
          type: "string",
          value: "release"
        }
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.button.css"];
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "button.down": "_downHandler",
        "button.mouseenter": "_mouseEnterHandler",
        "button.mouseleave": "_mouseLeaveHandler",
        "button.touchend": "_touchEndHandler",
        "button.click": "_clickHandler",
        "button.up": "_upHandler",
        up: "_upHandler",
        "button.focus": "_focusHandler",
        "button.blur": "_blurHandler"
      };
    }
  }]);

  return _class29;
}(Smart.ContentElement)), Smart("smart-repeat-button",
/*#__PURE__*/
function (_Smart$Button) {
  "use strict";

  _inherits(_class30, _Smart$Button);

  function _class30() {
    _classCallCheck(this, _class30);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class30).apply(this, arguments));
  }

  _createClass(_class30, [{
    key: "_clickHandler",
    value: function _clickHandler(e) {
      var t = this;
      ("release" !== t.clickMode || t.preventDefaultClick || t.readonly || t.disabled) && (e.preventDefault(), e.stopPropagation(), t.preventDefaultClick = !1);
    }
  }, {
    key: "_updateInBoundsFlag",
    value: function _updateInBoundsFlag(e) {
      var t = this;
      t._isPointerInBounds = !0, "mouseleave" === e.type ? (t._isPointerInBounds = !1, t.$button.setAttributeValue("hover", !1), t.$.setAttributeValue("hover", !1)) : (t.$button.setAttributeValue("hover", !0), t.$.setAttributeValue("hover", !0));
      var i = "buttons" in e ? e.buttons : e.which;
      1 !== i && t._stopRepeat(e);
    }
  }, {
    key: "_startRepeat",
    value: function _startRepeat(e) {
      var t = this;
      t._initialTimer || t.readonly || (t._initialTimer = setTimeout(function () {
        t._repeatTimer = setInterval(function () {
          if (t._isPointerInBounds) {
            var _i278 = "buttons" in e ? e.buttons : e.which;

            t.$.fireEvent("click", {
              buttons: _i278,
              clientX: e.clientX,
              clientY: e.clientY,
              pageX: e.pageX,
              pageY: e.pageY,
              screenX: e.screenX,
              screenY: e.screenY
            }), t.preventDefaultClick = !0;
          }
        }, t.delay);
      }, t.initialDelay));
    }
  }, {
    key: "_stopRepeat",
    value: function _stopRepeat() {
      var e = this;
      e.readonly || (e.$.setAttributeValue("active", !1), e._repeatTimer && (clearInterval(e._repeatTimer), e._repeatTimer = null), e._initialTimer && (clearTimeout(e._initialTimer), e._initialTimer = null));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        delay: {
          value: 50,
          type: "number"
        },
        initialDelay: {
          value: 150,
          type: "number"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "button.mousedown": "_startRepeat",
        "button.mouseenter": "_updateInBoundsFlag",
        "button.mouseleave": "_updateInBoundsFlag",
        "document.mouseup": "_stopRepeat"
      };
    }
  }]);

  return _class30;
}(Smart.Button)), Smart("smart-toggle-button",
/*#__PURE__*/
function (_Smart$Button2) {
  "use strict";

  _inherits(_class31, _Smart$Button2);

  function _class31() {
    _classCallCheck(this, _class31);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class31).apply(this, arguments));
  }

  _createClass(_class31, [{
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class31.prototype), "ready", this).call(this), this._setAriaState();
    }
  }, {
    key: "_setAriaState",
    value: function _setAriaState() {
      var e = this,
          t = e.checked;
      return null === t ? void e.setAttribute("aria-pressed", "mixed") : void e.setAttribute("aria-pressed", t);
    }
  }, {
    key: "_buttonClickHandler",
    value: function _buttonClickHandler() {}
  }, {
    key: "_buttonMouseLeaveHandler",
    value: function _buttonMouseLeaveHandler() {
      var e = this;
      e.removeAttribute("hover");
    }
  }, {
    key: "_buttonMouseEnterHandler",
    value: function _buttonMouseEnterHandler() {
      var e = this;
      e.setAttribute("hover", "");
      e.disabled || e.readonly || "hover" !== e.clickMode || (e._changeCheckState("pointer"), e.focus(), e._updateHidenInputNameAndValue());
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler() {
      var e = this;
      e._pressed && (e._pressed = !1, e.disabled || e.readonly || "press" === e.clickMode || (e._changeCheckState("pointer"), e.focus(), e._updateHidenInputNameAndValue()));
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;
      t.disabled || t.readonly || (t.hasRippleAnimation && Smart.Utilities.Animation.Ripple.animate(t, e.pageX, e.pageY), t._pressed = !0, ("press" === t.clickMode || "pressAndRelease" === t.clickMode) && (t._changeCheckState("pointer"), t.$.fireEvent("click"), t._updateHidenInputNameAndValue()), "press" === t.clickMode && (e.preventDefault(), e.stopPropagation()));
    }
  }, {
    key: "_dragStartHandler",
    value: function _dragStartHandler(e) {
      e.preventDefault();
    }
  }, {
    key: "_keyHandler",
    value: function _keyHandler(e) {
      var t = this;

      if (!0 !== t.disabled && !t.readonly && 32 === e.keyCode) {
        if ("keydown" === e.type) return void e.preventDefault();
        if ("none" === t.switchMode) return;
        t._changeCheckState("keyboard"), t._updateHidenInputNameAndValue();
      }
    }
  }, {
    key: "_changeCheckState",
    value: function _changeCheckState(e) {
      var t = this;
      var i = null;
      null === t.checked ? t.checked = !0 : (i = t.checked, t.checked = !t.checked), t._handleTextSelection(), t.$.fireEvent("change", {
        value: t.checked,
        oldValue: i,
        changeType: e
      }), t._setAriaState();
    }
  }, {
    key: "_handleTextSelection",
    value: function _handleTextSelection() {
      var e = this;
      e.$.addClass("smart-unselectable"), e.timer && clearTimeout(e.timer), e.timer = setTimeout(function () {
        return e.$.removeClass("smart-unselectable");
      }, 500);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class31.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      if ("checked" === e) return a.$.fireEvent("change", {
        value: i,
        oldValue: t,
        changeType: "api"
      }), void a._setAriaState();
      "trueTemplate" === e ? a._handleTemplate(!0) : "falseTemplate" === e ? a._handleTemplate(!1) : "indeterminateTemplate" === e ? a._handleTemplate() : void 0;
    }
  }, {
    key: "_htmlBindOnInitialization",
    value: function _htmlBindOnInitialization() {
      var e = this;
      e._bindContentProperty("trueContent", "smart-true-content"), e._bindContentProperty("falseContent", "smart-false-content"), e._bindContentProperty("indeterminateContent", "smart-indeterminate-content");
    }
  }, {
    key: "_bindContentProperty",
    value: function _bindContentProperty(e, t) {
      var i = this;
      if (!i.$[e + "Container"]) return;
      var a = document.createElement("div");
      a.innerHTML = i.innerHTML;
      var n = a.getElementsByClassName(t),
          o;
      if (0 < n.length) for (var _e312 = 0; _e312 < n.length; _e312++) {
        o = n[_e312];
      }
      "" === i[e] && (i[e] = o === void 0 ? "" : o.outerHTML), i.$[e + "Container"].innerHTML = i[e];
    }
  }, {
    key: "_updateContentProperties",
    value: function _updateContentProperties() {
      function e(e) {
        t.$[e + "Container"] && (t[e] = t.$[e + "Container"].innerHTML);
      }

      var t = this;
      e("trueContent"), e("falseContent"), e("indeterminateContent");
    }
  }, {
    key: "_updateHidenInputValue",
    value: function _updateHidenInputValue() {
      var e = this;
      if (!e.$.hiddenInput) return;
      var t;
      t = null === e.checked ? "null" : !1 === e.checked ? "off" : e.value || "on", e.$.hiddenInput.setAttribute("value", t);
    }
  }, {
    key: "_updateHidenInputName",
    value: function _updateHidenInputName() {
      var e = this;

      if (e.$.hiddenInput) {
        var _t267 = !1 === e.checked ? "" : e.name || "";

        e.$.hiddenInput.setAttribute("name", _t267);
      }
    }
  }, {
    key: "_updateHidenInputNameAndValue",
    value: function _updateHidenInputNameAndValue() {
      var e = this;
      e._updateHidenInputName(), e._updateHidenInputValue();
    }
  }, {
    key: "_handleTemplate",
    value: function _handleTemplate(e, t) {
      var i = this;
      var a, n, o;
      if (!0 === e ? (a = i.trueTemplate, n = i.$.trueContentContainer, o = i.trueContent) : !1 === e ? (a = i.falseTemplate, n = i.$.falseContentContainer, o = i.falseContent) : (a = i.indeterminateTemplate, n = i.$.indeterminateContentContainer, o = i.indeterminateContent), t && (n.innerHTML = o ? o : ""), null === a || !a) return;
      if ("function" == typeof a) return void a(n, {
        value: o
      });
      if (!("content" in document.createElement("template"))) return void i.error(i.localize("htmlTemplateNotSuported", {
        elementType: i.nodeName.toLowerCase()
      }));
      if (a = document.getElementById(a), null === a || !("content" in a)) return void i.error(i.localize("invalidTemplate", {
        elementType: i.nodeName.toLowerCase(),
        property: "template"
      }));
      var r = a.content,
          l = r.childNodes.length,
          s = /{{\w+}}/g;
      var d = [],
          c;

      for (var _a179 = 0; _a179 < l; _a179++) {
        for (c = s.exec(r.childNodes[_a179].innerHTML); c;) {
          d.push({
            childNodeIndex: _a179,
            bindingString: c[0]
          }), c = s.exec(r.childNodes[_a179].innerHTML);
        }
      }

      var m = d.length;
      var u = document.importNode(a.content, !0),
          p,
          g;

      for (var _a180 = 0; _a180 < m; _a180++) {
        p = u.childNodes[d[_a180].childNodeIndex], g = d.length;

        for (var _e313 = 0; _e313 < g; _e313++) {
          p.innerHTML = p.innerHTML.replace(d[_a180].bindingString, o);
        }
      }

      n.innerHTML = "";

      for (var _a181 = 0; _a181 < u.childNodes.length; _a181++) {
        u.childNodes[_a181].outerHTML && (n.innerHTML += u.childNodes[_a181].outerHTML);
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        checked: {
          value: !1,
          type: "boolean?"
        },
        falseContent: {
          value: "",
          reflectToAttribute: !1,
          type: "string"
        },
        indeterminateContent: {
          value: "",
          reflectToAttribute: !1,
          type: "string"
        },
        indeterminate: {
          value: !1,
          type: "boolean"
        },
        trueContent: {
          value: "",
          reflectToAttribute: !1,
          type: "string"
        },
        indeterminateTemplate: {
          value: null,
          type: "any"
        },
        trueTemplate: {
          value: null,
          type: "any"
        },
        falseTemplate: {
          value: null,
          type: "any"
        },
        type: {
          value: "toggle",
          type: "string",
          defaultReflectToAttribute: !0,
          readonly: !0
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        keydown: "_keyHandler",
        keyup: "_keyHandler",
        dragstart: "_dragStartHandler",
        "button.click": "_buttonClickHandler",
        "button.mouseenter": "_buttonMouseEnterHandler",
        "button.mouseleave": "_buttonMouseLeaveHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }]);

  return _class31;
}(Smart.Button)), Smart("smart-check-box",
/*#__PURE__*/
function (_Smart$ToggleButton) {
  "use strict";

  _inherits(_class32, _Smart$ToggleButton);

  function _class32() {
    _classCallCheck(this, _class32);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class32).apply(this, arguments));
  }

  _createClass(_class32, [{
    key: "template",
    value: function template() {
      return "<div id='container' class='smart-container' role=\"presentation\">\n                    <div class='smart-overlay' role=\"presentation\"></div>\n                    <span id='checkBoxInput' class='smart-input' aria-hidden=\"true\"></span>\n                    <span id='checkBoxLabel' inner-h-t-m-l='[[innerHTML]]' class='smart-label'><content></content></span>\n                    <input id='hiddenInput' class='smart-hidden-input' type='hidden'>\n                </div>";
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler() {
      var e = this;
      e.$.setAttributeValue("focus", !0);
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      var e = this;
      e.$.setAttributeValue("focus", !1);
    }
  }, {
    key: "_mouseEnterHandler",
    value: function _mouseEnterHandler() {
      var e = this;
      e.$.setAttributeValue("hover", !0);
    }
  }, {
    key: "_mouseLeaveHandler",
    value: function _mouseLeaveHandler() {
      var e = this;
      e.$.setAttributeValue("hover", !1);
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      _get(_getPrototypeOf(_class32.prototype), "ready", this).call(this), e.setAttribute("role", "checkbox"), e.indeterminate && (e._valueCache = e.checked, e.checked = null, e._setAriaState()), e.classList.add("smart-toggle-box"), e._updateHidenInputNameAndValue();
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class32.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      a._updateContentProperties();

      "indeterminate" === e ? (i ? (a._valueCache = a.checked, a.checked = null) : a.checked = a._valueCache, a._setAriaState(), a._updateHidenInputNameAndValue()) : "value" === e ? a._updateHidenInputNameAndValue() : "checked" === e ? a._updateHidenInputNameAndValue() : "name" === e ? a._updateHidenInputName() : void 0;
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      if (t._pressed) return t._pressed = !1, t.$.setAttributeValue("active", !1), t.disabled || t.readonly || "input" === t.checkMode && i !== t.$.checkBoxInput || "label" === t.checkMode && i !== t.$.checkBoxLabel ? void 0 : "press" === t.clickMode ? (e.preventDefault(), void e.stopPropagation()) : void (t._changeCheckState("pointer"), t.focus(), t._handleTextSelection(), t._updateHidenInputNameAndValue());
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;

      if (!(t.disabled || t.readonly || "input" === t.checkMode && i !== t.$.checkBoxInput || "label" === t.checkMode && i !== t.$.checkBoxLabel)) {
        if (t.$.setAttributeValue("active", !0), t.hasRippleAnimation) {
          var _e314 = t.$.checkBoxInput.getBoundingClientRect(),
              _i279 = window.scrollX || window.pageXOffset,
              _a182 = window.scrollY || window.pageYOffset;

          Smart.Utilities.Animation.Ripple.animate(t.$.checkBoxInput, _e314.left + _e314.width / 2 + _i279, _e314.top + _e314.height / 2 + _a182);
        }

        t._pressed = !0, ("press" === t.clickMode || "pressAndRelease" === t.clickMode) && (t._changeCheckState("pointer"), t.$.fireEvent("click"), t.focus(), t._updateHidenInputNameAndValue());
      }
    }
  }, {
    key: "_setAriaState",
    value: function _setAriaState() {
      var e = this,
          t = e.checked;
      return null === t ? void e.setAttribute("aria-checked", "mixed") : void e.setAttribute("aria-checked", t);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        checkMode: {
          value: "both",
          allowedValues: ["both", "input", "label"],
          type: "string"
        },
        type: {
          value: "checkbox",
          type: "string",
          defaultReflectToAttribute: !0,
          readonly: !0
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        down: "_downHandler",
        "document.up": "_documentUpHandler",
        "checkBoxInput.mouseenter": "_mouseEnterHandler",
        "checkBoxInput.mouseleave": "_mouseLeaveHandler",
        focus: "_focusHandler",
        blur: "_blurHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.toggle.css"];
    }
  }]);

  return _class32;
}(Smart.ToggleButton)), Smart("smart-led",
/*#__PURE__*/
function (_Smart$ToggleButton2) {
  "use strict";

  _inherits(_class33, _Smart$ToggleButton2);

  function _class33() {
    _classCallCheck(this, _class33);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class33).apply(this, arguments));
  }

  _createClass(_class33, [{
    key: "template",
    value: function template() {
      return "<div id='container' class='smart-container' role=\"presentation\">\n                    <div id='ledAnimation' class='smart-animation' role=\"presentation\"></div>\n                    <div id='button' class='smart-input' role=\"presentation\">\n                        <span id='falseContentContainer' inner-h-t-m-l='[[falseContent]]' class='smart-false-content-container'></span>\n                        <span id='indeterminateContentContainer' inner-h-t-m-l='[[indeterminateContent]]' class='smart-indeterminate-content-container'></span>\n                        <span id='trueContentContainer' inner-h-t-m-l='[[trueContent]]' class='smart-true-content-container'></span>\n                    </div>\n                    <input id='hiddenInput' class='smart-hidden-input' type='hidden'>\n                </div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      _get(_getPrototypeOf(_class33.prototype), "ready", this).call(this), e._htmlBindOnInitialization(), e.indeterminate && (e._valueCashe = e.checked, e.checked = null), e._handleTemplate(!0), e._handleTemplate(!1), e._handleTemplate(), e._updateHidenInputNameAndValue();
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class33.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      "indeterminate" === e ? (i ? (a._valueCashe = a.checked, a.checked = null) : a.checked = a._valueCashe, a._updateHidenInputNameAndValue()) : "trueContent" === e ? (a.trueContent = i, a._handleTemplate(!0)) : "falseContent" === e ? (a.falseContent = i, a._handleTemplate(!1)) : "indeterminateContent" === e ? (a.indeterminateContent = i, a._handleTemplate()) : "value" === e ? a._updateHidenInputNameAndValue() : "checked" === e ? a._updateHidenInputNameAndValue() : "name" === e ? a._updateHidenInputName() : void 0;
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;
      return !t._pressed || t.readonly ? void 0 : "press" === t.clickMode ? (e.preventDefault(), e.stopPropagation(), void (t._pressed = !1)) : void (_get(_getPrototypeOf(_class33.prototype), "_documentUpHandler", this).call(this, e), t.indeterminate = !1, t._updateHidenInputNameAndValue(), t._pressed = !1);
    }
  }, {
    key: "_mouseDownHandler",
    value: function _mouseDownHandler() {
      var e = this;
      e.readonly || e.disabled || (e._pressed = !0, ("press" === e.clickMode || "pressAndRelease" === e.clickMode) && (e._changeCheckState("pointer"), e.$.fireEvent("click"), e.indeterminate = !1, e._updateHidenInputNameAndValue()));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        shape: {
          value: "round",
          allowedValues: ["round", "square"],
          type: "string"
        }
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.led.css"];
    }
  }]);

  return _class33;
}(Smart.ToggleButton)), Smart("smart-power-button",
/*#__PURE__*/
function (_Smart$ToggleButton3) {
  "use strict";

  _inherits(_class34, _Smart$ToggleButton3);

  function _class34() {
    _classCallCheck(this, _class34);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class34).apply(this, arguments));
  }

  _createClass(_class34, [{
    key: "template",
    value: function template() {
      return "<div id='container' class='smart-container'>\n                    <div id='powerButtonAnimation' class='smart-animation'></div>\n                    <span id='button' class='smart-input' aria-hidden=\"true\"></span>\n                    <input id='hiddenInput' class='smart-hidden-input' type='hidden'>\n                </div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      _get(_getPrototypeOf(_class34.prototype), "ready", this).call(this), e._updateHidenInputNameAndValue();
    }
  }], [{
    key: "styleUrls",
    get: function get() {
      return ["smart.powerbutton.css"];
    }
  }]);

  return _class34;
}(Smart.ToggleButton)), Smart("smart-radio-button",
/*#__PURE__*/
function (_Smart$ToggleButton4) {
  "use strict";

  _inherits(_class35, _Smart$ToggleButton4);

  function _class35() {
    _classCallCheck(this, _class35);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class35).apply(this, arguments));
  }

  _createClass(_class35, [{
    key: "template",
    value: function template() {
      return "<div  id='container' class='smart-container'>\n                 <div class ='smart-overlay'></div>\n                 <span id='radioButtonInput' class ='smart-input'></span>\n                 <span id='radioButtonLabel' inner-h-t-m-l='[[innerHTML]]' class ='smart-label'><content></content></span>\n                 <input id='hiddenInput' class ='smart-hidden-input' type='hidden'>\n               </div>";
    }
  }, {
    key: "_radioMouseEnterHandler",
    value: function _radioMouseEnterHandler() {
      var e = this;
      e.$.setAttributeValue("hover", !0);
    }
  }, {
    key: "_radioMouseLeaveHandler",
    value: function _radioMouseLeaveHandler() {
      var e = this;
      e.$.setAttributeValue("hover", !1);
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler() {
      var e = this;
      e.$.setAttributeValue("focus", !0);
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      var e = this;
      e.$.setAttributeValue("focus", !1);
    }
  }, {
    key: "_mouseEnterHandler",
    value: function _mouseEnterHandler() {
      var e = this;
      e.$.setAttributeValue("hover", !0);
    }
  }, {
    key: "_mouseLeaveHandler",
    value: function _mouseLeaveHandler() {
      var e = this;
      e.$.setAttributeValue("hover", !1);
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      _get(_getPrototypeOf(_class35.prototype), "ready", this).call(this), e.classList.add("smart-toggle-box"), e._handleMultipleCheckedInstances(), e._updateHidenInputNameAndValue();
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;

      if (!(t.disabled || t.readonly || "input" === t.checkMode && i !== t.$.radioButtonInput || "label" === t.checkMode && i !== t.$.radioButtonLabel)) {
        if (t.$.setAttributeValue("active", !0), t.hasRippleAnimation) {
          var _e315 = t.$.radioButtonInput.getBoundingClientRect(),
              _i280 = window.scrollX || window.pageXOffset,
              _a183 = window.scrollY || window.pageYOffset;

          Smart.Utilities.Animation.Ripple.animate(t.$.radioButtonInput, _e315.left + _e315.width / 2 + _i280, _e315.top + _e315.height / 2 + _a183);
        }

        return t._preventAction ? void (t._preventAction = !1) : void (("release" === t.clickMode || "pressAndRelease" === t.clickMode) && (t._pressed = !0), ("press" === t.clickMode || "pressAndRelease" === t.clickMode) && ("pressAndRelease" === t.clickMode && ("" === t.groupName ? t._checkedBeforeChange = t.parentNode.querySelector("smart-radio-button[checked]") : t._checkedBeforeChange = document.querySelector("smart-radio-button[group-name=\"" + t.groupName + "\"][checked]")), t._handleMouseInteraction()));
      }
    }
  }, {
    key: "_elementMouseEnterHandler",
    value: function _elementMouseEnterHandler() {
      var e = this;
      "hover" !== e.clickMode || e.disabled || e.readonly || e._handleMouseInteraction();
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      !t._pressed || t.disabled || t.readonly || "input" === t.checkMode && i !== t.$.radioButtonInput || "label" === t.checkMode && i !== t.$.radioButtonLabel || ("release" === t.clickMode ? t._handleMouseInteraction() : (null === t._checkedBeforeChange ? (t.$.fireEvent("change", {
        value: !1,
        oldValue: !0,
        changeType: "pointer"
      }), t.checked = !1) : t._checkedBeforeChange._changeCheckState("pointer"), t.focus(), t._updateHidenInputNameAndValue()), t.$.setAttributeValue("active", !1), t._pressed = !1);
    }
  }, {
    key: "_handleMouseInteraction",
    value: function _handleMouseInteraction() {
      var e = this;
      e._handleTextSelection(), e._changeCheckState("pointer"), e.focus(), e._updateHidenInputNameAndValue();
    }
  }, {
    key: "_handleMultipleCheckedInstances",
    value: function _handleMultipleCheckedInstances() {
      var e = this,
          t = Array.from(document.querySelectorAll("smart-radio-button[group-name=\"" + e.groupName + "\"][checked]")),
          a = t.length;
      2 > a || t.forEach(function (e, t) {
        return t < a - 1 && (e.checked = !1);
      });
    }
  }, {
    key: "_changeCheckState",
    value: function _changeCheckState(e) {
      var t = this;
      var i = document.querySelectorAll("smart-radio-button[group-name=\"" + t.groupName + "\"]");
      if (!0 === t.checked && "api" === e || !1 === t.checked) if (0 < i.length) t._changeCheckStateInGroup(i, e);else {
        var _a184 = t.parentNode;
        i = _a184.querySelectorAll("smart-radio-button:not([group-name])"), t._changeCheckStateInGroup(i, e);
      }
    }
  }, {
    key: "_changeCheckStateInGroup",
    value: function _changeCheckStateInGroup(e, t) {
      var a = this;

      for (var _n141 = 0; _n141 < e.length; _n141++) {
        e[_n141]._isUpdating = !0, e[_n141] === a ? (a.checked = !0, a.$.fireEvent("change", {
          value: !0,
          oldValue: !1,
          changeType: t
        })) : e[_n141].checked && (e[_n141].checked = !1), e[_n141]._isUpdating = !1;
      }
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "value":
          a._updateHidenInputNameAndValue();

          break;

        case "checked":
          a._isUpdating || a._changeCheckState("api"), a._updateHidenInputNameAndValue();
          break;

        case "name":
          a._updateHidenInputName();

          break;

        default:
          _get(_getPrototypeOf(_class35.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        checkMode: {
          value: "both",
          allowedValues: ["both", "input", "label"],
          type: "string"
        },
        type: {
          value: "radio",
          type: "string",
          defaultReflectToAttribute: !0,
          readonly: !0
        },
        groupName: {
          value: "",
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        down: "_downHandler",
        "document.up": "_documentUpHandler",
        mouseenter: "_elementMouseEnterHandler",
        "radioButtonInput.mouseenter": "_radioMouseEnterHandler",
        "radioButtonInput.mouseleave": "_radioMouseLeaveHandler",
        focus: "_focusHandler",
        blur: "_blurHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.toggle.css"];
    }
  }]);

  return _class35;
}(Smart.ToggleButton)), Smart("smart-switch-button",
/*#__PURE__*/
function (_Smart$ToggleButton5) {
  "use strict";

  _inherits(_class36, _Smart$ToggleButton5);

  function _class36() {
    _classCallCheck(this, _class36);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class36).apply(this, arguments));
  }

  _createClass(_class36, [{
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;
      _get(_getPrototypeOf(_class36.prototype), "propertyChangedHandler", this).call(this, e, t, i), a._updateContentProperties();
      "indeterminate" === e ? (i ? (a._valueCache = a.checked, a.checked = null) : a.checked = a._valueCache, a._setAriaState()) : "trueContent" === e ? a.trueContent = i : "falseContent" === e ? a.falseContent = i : "orientation" === e ? a._resizeHandler() : void 0;
      a._getContainersSizeAndBreakPoint(), a._removeDragStyles(), a._resizeHandler();
    }
  }, {
    key: "template",
    value: function template() {
      return "<div  id='container' class='smart-container' role=\"presentation\">\n                    <div id='innerContainer' class='smart-inner-container' role=\"presentation\">\n                        <span id='falseContentContainer' inner-h-t-m-l='[[falseContent]]' class='smart-false-content-container'></span>\n                        <span id='switchThumb' class='smart-thumb' role=\"presentation\"></span>\n                        <span id='trueContentContainer' inner-h-t-m-l='[[trueContent]]' class='smart-true-content-container'></span>\n                    </div>\n                    <input id='hiddenInput' class='smart-hidden-input' type='hidden'>\n                </div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      _get(_getPrototypeOf(_class36.prototype), "ready", this).call(this), e.setAttribute("role", "switch");
      var t = e.animation;
      e.hasAnimation && (e.animation = "none"), e._supportCSSVariables = Smart.Utilities.Core.CSSVariablesSupport() && !!window.getComputedStyle(e.$.container).getPropertyValue("--smart-switch-button-default-width"), e._htmlBindOnInitialization(), e._resizeHandler(), e._initializePrivateVariables(), e._getContainersSizeAndBreakPoint(), e.indeterminate && (e._valueCache = e.checked, e.checked = null), e._setAriaState(), e._handleTemplate(!0), e._handleTemplate(!1), e._handleTemplate(), e._updateHidenInputNameAndValue(), e._updateThumbPosition(), e.animation = t;
    }
  }, {
    key: "_mouseDownHandler",
    value: function _mouseDownHandler(e) {
      var t = this;
      t.disabled || t.readonly || "none" === t.switchMode || (e.originalEvent.target.closest(".smart-thumb") === t.$.switchThumb && ("default" === t.switchMode || "drag" === t.switchMode) && t._switchThumbDragStartHandler(e), t._isSwitchClicked = t, t._updateContentProperties(), "release" !== t.clickMode && "click" === t.switchMode && (t._updateStateOnClick(), t.$.fireEvent("click"), t.indeterminate = !1, t._updateHidenInputNameAndValue()));
    }
  }, {
    key: "_updateStateOnClick",
    value: function _updateStateOnClick() {
      var e = this;
      e._changeCheckState(), e.focus();
    }
  }, {
    key: "_drag",
    value: function _drag(e) {
      var t = this;
      t._mouseDown && (Smart.Utilities.Core.isMobile && e.originalEvent.preventDefault(), t._switchThumbDragHandler(e));
    }
  }, {
    key: "_switchThumbDragStartHandler",
    value: function _switchThumbDragStartHandler(e) {
      var t = this;
      t.disabled || ("click" === t.switchMode && "release" !== t.clickMode && (e.preventDefault(), e.stopPropagation()), t._isInactiveOn("drag") || (t._mouseDown = !0, t._getContainersSizeAndBreakPoint(), t._pointerPosition = "vertical" === t.orientation ? e.pageY : e.pageX, e.preventDefault()));
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      var t = this;
      t._mouseDown && e.preventDefault();
    }
  }, {
    key: "_switchThumbDragHandler",
    value: function _switchThumbDragHandler(e) {
      var t = Math.max;
      var i = this;

      if (!i._isInactiveOn("drag")) {
        if (!1 === i._mouseDown) return void i._removeDragStyles();

        if (!i.hasAttribute("dragged")) {
          if (1.5 >= Math.abs(("vertical" === i.orientation ? e.pageY : e.pageX) - i._pointerPosition)) return;
          i.setAttribute("dragged", "");
        }

        var _a185 = i.$.innerContainer,
            _n142 = i.$.container.getBoundingClientRect(),
            _o93 = "vertical" === i.orientation ? document.body.scrollTop || document.documentElement.scrollTop : document.body.scrollLeft || document.documentElement.scrollLeft,
            r = "vertical" === i.orientation ? _n142.top + _o93 : _n142.left + _o93,
            _l42 = "vertical" === i.orientation ? i._pointerPosition - _a185.offsetTop : i._pointerPosition - _a185.offsetLeft,
            _s27 = i._pointerPosition >= r && i._pointerPosition <= r + i._switchContainerSize;

        var d = -1 * (i.offsetWidth - i.$.switchThumb.offsetWidth),
            c = -1 * (i.offsetHeight - i.$.switchThumb.offsetHeight);

        if (i._pointerPosition = "vertical" === i.orientation ? e.pageY : e.pageX, _s27) {
          var _e316 = i._pointerPosition - _l42;

          _e316 < -i._switchTrackLength && (_e316 = -i._switchTrackLength), 0 < _e316 && (_e316 = 0), "vertical" === i.orientation ? i.$.innerContainer.style.top = t(c, _e316) + "px" : i.$.innerContainer.style.left = t(d, _e316) + "px";
        }
      }
    }
  }, {
    key: "_switchThumbDropHandler",
    value: function _switchThumbDropHandler() {
      var e = this;
      e.hasAttribute("dragged") ? e._endDrag() : e._isSwitchClicked && e._endClick(), e._mouseDown = !1, delete e._isSwitchClicked;
    }
  }, {
    key: "_endDrag",
    value: function _endDrag() {
      var e = this;

      if (e.indeterminate = !1, e._updateHidenInputNameAndValue(), !e._isInactiveOn("drag") && e._mouseDown) {
        e.removeAttribute("dragged"), delete e._pointerPosition;

        var _t268 = "vertical" === e.orientation ? e.$.innerContainer.offsetTop + e.$.switchThumb.offsetTop + e.$.switchThumb.clientHeight / 2 : e.$.innerContainer.offsetLeft + e.$.switchThumb.offsetLeft + e.$.switchThumb.clientWidth / 2;

        var _i281 = _t268 > e._switchBreakPoint;

        null === e.checked ? _i281 ? e._changeCheckState(e.inverted) : e._changeCheckState(!e.inverted) : !e.inverted == (_i281 === e.checked) && e._changeCheckState(!e.checked), e._removeDragStyles(), e._updateThumbPosition();
      }
    }
  }, {
    key: "_endClick",
    value: function _endClick() {
      var e = this;

      e._resizeHandler();

      e.disabled || e.readonly || e._isInactiveOn("click") || ("release" !== e.clickMode && "pressAndRelease" !== e.clickMode || e._updateStateOnClick(), e.indeterminate = !1, e._updateHidenInputNameAndValue());
    }
  }, {
    key: "_switchButtonOnMouseEnter",
    value: function _switchButtonOnMouseEnter() {
      var e = this;
      e.disabled || e.readonly || e.$.addClass("hovered");
    }
  }, {
    key: "_switchButtonOnMouseLeave",
    value: function _switchButtonOnMouseLeave() {
      var e = this;
      e.disabled || e.readonly || e.$.removeClass("hovered");
    }
  }, {
    key: "_isInactiveOn",
    value: function _isInactiveOn(e) {
      var t = this,
          i = t.disabled || t.readonly || t.switchMode !== e;
      return "default" !== t.switchMode && i;
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this;
      t.disabled || t.readonly || 32 !== e.keyCode || "none" === t.switchMode || (t._getContainersSizeAndBreakPoint(), t._changeCheckState());
    }
  }, {
    key: "_initializePrivateVariables",
    value: function _initializePrivateVariables() {
      var e = this;
      e._switchContainerSize = e._switchTrackLength = e._switchBreakPoint = e._pointerPosition = 0, e._mouseDown = !1;
    }
  }, {
    key: "_changeCheckState",
    value: function _changeCheckState(e) {
      var t = this;
      var i = t.checked;
      return null === i && void 0 !== e ? (t.$.fireEvent("change", {
        value: e,
        oldValue: null
      }), t.checked = !1, void t._updateThumbPosition()) : void (t.checked = !(null !== t.checked) || !t.checked, t._setAriaState(), t._updateThumbPosition(), t.$.fireEvent("change", {
        value: t.checked,
        oldValue: i
      }), t._updateHidenInputNameAndValue());
    }
  }, {
    key: "_getContainersSizeAndBreakPoint",
    value: function _getContainersSizeAndBreakPoint() {
      var e = this;
      e._switchContainerSize = "vertical" === e.orientation ? e.$.container.clientHeight : e.$.container.clientWidth, e._switchTrackLength = "vertical" === e.orientation ? e._switchContainerSize - e.$.switchThumb.clientHeight : e._switchContainerSize - e.$.switchThumb.clientWidth, e._switchBreakPoint = e._switchContainerSize / 2;
    }
  }, {
    key: "_removeDragStyles",
    value: function _removeDragStyles() {
      var e = this;
      e._supportCSSVariables ? e.$.innerContainer.removeAttribute("style") : e.$.innerContainer.style.left = "", e._supportCSSVariables ? e.$.innerContainer.removeAttribute("style") : e.$.innerContainer.style.top = "", e._mouseDown = !1;
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;

      if (document.body.contains(e)) {
        var _t269 = window.getComputedStyle(e, null),
            _i282 = parseInt(_t269.getPropertyValue("border-top-width")),
            _a186 = parseInt(_t269.getPropertyValue("border-right-width")),
            _n143 = parseInt(_t269.getPropertyValue("border-bottom-width")),
            _o94 = parseInt(_t269.getPropertyValue("border-left-width")),
            r = "vertical" === e.orientation ? e.offsetHeight - (_i282 + _n143) : e.offsetWidth - (_o94 + _a186);

        e._getContainersSizeAndBreakPoint(), e._supportCSSVariables ? e.$.container.style.setProperty("--smart-switch-button-default-width", r + "px") : (e._innerContainerSize = r, e.$.innerContainer.style.height = e.$.innerContainer.style.width = "", e.$.trueContentContainer.style.height = e.$.trueContentContainer.style.width = "", e.$.falseContentContainer.style.height = e.$.falseContentContainer.style.width = "", "horizontal" === e.orientation ? (e.$.innerContainer.style.setProperty("width", 2 * r - e.$.switchThumb.clientWidth + "px"), e.$.trueContentContainer.style.setProperty("width", e._switchTrackLength + "px"), e.$.falseContentContainer.style.setProperty("width", e._switchTrackLength + "px")) : (e.$.innerContainer.style.setProperty("height", 2 * r - e.$.switchThumb.clientHeight + "px"), e.$.trueContentContainer.style.setProperty("height", e._switchTrackLength + "px"), e.$.falseContentContainer.style.setProperty("height", e._switchTrackLength + "px")), e._updateThumbPosition());
      }
    }
  }, {
    key: "_updateThumbPosition",
    value: function _updateThumbPosition() {
      var e = this;
      return e._supportCSSVariables || (e.inverted ? !0 === e.checked : !1 === e.checked) || !e._innerContainerSize ? void (e.$.innerContainer.style.left = e.$.innerContainer.style.top = "") : void ((e.inverted ? !1 === e.checked : e.checked) && ("horizontal" === e.orientation ? (e.$.innerContainer.style.left = -1 * (e._innerContainerSize - e.$.switchThumb.offsetWidth) + "px", e.$.innerContainer.style.top = "") : (e.$.innerContainer.style.top = -1 * (e._innerContainerSize - e.$.switchThumb.offsetHeight) + "px", e.$.innerContainer.style.left = "")), null === e.checked && ("horizontal" === e.orientation ? (e.$.innerContainer.style.left = -1 * (e._innerContainerSize / 2 - e.$.switchThumb.offsetWidth / 2) + "px", e.$.innerContainer.style.top = "") : (e.$.innerContainer.style.top = -1 * (e._innerContainerSize / 2 - e.$.switchThumb.offsetHeight / 2) + "px", e.$.innerContainer.style.left = "")));
    }
  }, {
    key: "_setAriaState",
    value: function _setAriaState() {
      var e = this,
          t = !!e.checked;
      e.setAttribute("aria-checked", t), t ? (e.$.falseContentContainer.setAttribute("aria-hidden", !0), e.$.trueContentContainer.removeAttribute("aria-hidden")) : (e.$.trueContentContainer.setAttribute("aria-hidden", !0), e.$.falseContentContainer.removeAttribute("aria-hidden"));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        inverted: {
          value: !1,
          type: "boolean"
        },
        orientation: {
          value: "horizontal",
          allowedValues: ["horizontal", "vertical"],
          type: "string"
        },
        switchMode: {
          value: "default",
          allowedValues: ["default", "click", "drag", "none"],
          type: "string"
        },
        clickMode: {
          value: "release",
          allowedValues: ["press", "release", "pressAndRelease"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "container.down": "_mouseDownHandler",
        "document.move": "_drag",
        "container.move": "_moveHandler",
        "document.up": "_switchThumbDropHandler",
        mouseenter: "_switchButtonOnMouseEnter",
        mouseleave: "_switchButtonOnMouseLeave",
        resize: "_resizeHandler",
        "container.resize": "_resizeHandler",
        "document.selectstart": "_selectStartHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.switchbutton.css"];
    }
  }]);

  return _class36;
}(Smart.ToggleButton)), Smart("smart-chart",
/*#__PURE__*/
function (_Smart$BaseElement3) {
  "use strict";

  _inherits(_class37, _Smart$BaseElement3);

  function _class37() {
    _classCallCheck(this, _class37);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class37).apply(this, arguments));
  }

  _createClass(_class37, [{
    key: "_getFormatSettings",
    value: function _getFormatSettings(e, t) {
      if (!e) return null;
      var i = e[t ? t : "formatSettings"];
      return i ? i.dateFormat || null !== i.decimalPlaces || i.decimalSeparator || i.negativeWithBrackets || i.prefix || i.sufix || i.thousandsSeparator ? i : null : null;
    }
  }, {
    key: "template",
    value: function template() {
      return "<div role=\"presentation\"></div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class37.prototype), "ready", this).call(this), this.checkLicense();
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e._observeSeriesGroups(), e._isTouchDevice = Smart.Utilities.Core.isMobile, e._setDefaults(), e._createColorsCache(), e.refresh(), e._setAriaProperties(), _get(_getPrototypeOf(_class37.prototype), "render", this).call(this);
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;
      _get(_getPrototypeOf(_class37.prototype), "detached", this).call(this), e._ttEl && e._ttEl.box && e._ttEl.box.remove(), delete e._ttEl;
    }
  }, {
    key: "_setAriaProperties",
    value: function _setAriaProperties() {}
  }, {
    key: "_observeSeriesGroups",
    value: function _observeSeriesGroups() {
      function e(e) {
        t.context !== t && e.newValue !== e.oldValue && t.update();
      }

      var t = this;
      t._validateSeriesGroups(), t.seriesGroups = new Smart.ObservableArray(t.seriesGroups), t.seriesGroups.canNotify = !0;

      for (var _a187 = 0; _a187 < t.seriesGroups.length; _a187++) {
        t.seriesGroups[_a187].series = new Smart.ObservableArray(t.seriesGroups[_a187].series), t.seriesGroups[_a187].series.canNotify = !0, t.seriesGroups[_a187].series.notify(e);
      }

      t.seriesGroups.notify(e);
    }
  }, {
    key: "_downMoveHandler",
    value: function _downMoveHandler(e) {
      var t = this;
      var i = e.originalEvent.target;
      t.shadowRoot && i === t && (i = e.originalEvent.composedPath()[0]);
      var a = i.closest(".smart-chart-range-selector");

      if (a) {
        var _i283 = a.firstElementChild,
            _n144 = _i283.parentChart;
        t !== _i283 && t !== _n144 || _n144["_onSliderMouse" + e.type.slice(0, 1).toUpperCase() + e.type.slice(1)](e);
      }
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;
      t._draggingRangeSelector && t._onSliderMouseUp(e);
    }
  }, {
    key: "_setDefaults",
    value: function _setDefaults() {
      var e = this;
      e.axisPadding = 5, e.enableEvents = !0, e.enableSampling = !0, e._itemsToggleState = [], e._isToggleRefresh = !1, e._isSelectorRefresh = !1, e._sliders = [], e._selectorRange = [], e._rangeSelectorInstances = {}, e._resizeState = {}, e._isRangeSelectorInstance = e._isRangeSelectorInstance || !1, e._renderData = {}, e._smartPlot = null, e._animTickInt = 50, e._seriesTypes = ["line", "stackedline", "stackedline100", "spline", "stackedspline", "stackedspline100", "stepline", "stackedstepline", "stackedstepline100", "area", "stackedarea", "stackedarea100", "splinearea", "stackedsplinearea", "stackedsplinearea100", "steparea", "stackedsteparea", "stackedsteparea100", "rangearea", "splinerangearea", "steprangearea", "column", "stackedcolumn", "stackedcolumn100", "rangecolumn", "scatter", "stackedscatter", "stackedscatter100", "bubble", "stackedbubble", "stackedbubble100", "pie", "donut", "candlestick", "ohlc", "waterfall", "stackedwaterfall"], e.colorSchemes = [{
        name: "scheme01",
        colors: ["#307DD7", "#AA4643", "#89A54E", "#71588F", "#4198AF"]
      }, {
        name: "scheme02",
        colors: ["#7FD13B", "#EA157A", "#FEB80A", "#00ADDC", "#738AC8"]
      }, {
        name: "scheme03",
        colors: ["#E8601A", "#FF9639", "#F5BD6A", "#599994", "#115D6E"]
      }, {
        name: "scheme04",
        colors: ["#D02841", "#FF7C41", "#FFC051", "#5B5F4D", "#364651"]
      }, {
        name: "scheme05",
        colors: ["#25A0DA", "#309B46", "#8EBC00", "#FF7515", "#FFAE00"]
      }, {
        name: "scheme06",
        colors: ["#0A3A4A", "#196674", "#33A6B2", "#9AC836", "#D0E64B"]
      }, {
        name: "scheme07",
        colors: ["#CC6B32", "#FFAB48", "#FFE7AD", "#A7C9AE", "#888A63"]
      }, {
        name: "scheme08",
        colors: ["#3F3943", "#01A2A6", "#29D9C2", "#BDF271", "#FFFFA6"]
      }, {
        name: "scheme09",
        colors: ["#1B2B32", "#37646F", "#A3ABAF", "#E1E7E8", "#B22E2F"]
      }, {
        name: "scheme10",
        colors: ["#5A4B53", "#9C3C58", "#DE2B5B", "#D86A41", "#D2A825"]
      }, {
        name: "scheme11",
        colors: ["#993144", "#FFA257", "#CCA56A", "#ADA072", "#949681"]
      }, {
        name: "scheme12",
        colors: ["#105B63", "#EEEAC5", "#FFD34E", "#DB9E36", "#BD4932"]
      }, {
        name: "scheme13",
        colors: ["#BBEBBC", "#F0EE94", "#F5C465", "#FA7642", "#FF1E54"]
      }, {
        name: "scheme14",
        colors: ["#60573E", "#F2EEAC", "#BFA575", "#A63841", "#BFB8A3"]
      }, {
        name: "scheme15",
        colors: ["#444546", "#FFBB6E", "#F28D00", "#D94F00", "#7F203B"]
      }, {
        name: "scheme16",
        colors: ["#583C39", "#674E49", "#948658", "#F0E99A", "#564E49"]
      }, {
        name: "scheme17",
        colors: ["#142D58", "#447F6E", "#E1B65B", "#C8782A", "#9E3E17"]
      }, {
        name: "scheme18",
        colors: ["#4D2B1F", "#635D61", "#7992A2", "#97BFD5", "#BFDCF5"]
      }, {
        name: "scheme19",
        colors: ["#844341", "#D5CC92", "#BBA146", "#897B26", "#55591C"]
      }, {
        name: "scheme20",
        colors: ["#56626B", "#6C9380", "#C0CA55", "#F07C6C", "#AD5472"]
      }, {
        name: "scheme21",
        colors: ["#96003A", "#FF7347", "#FFBC7B", "#FF4154", "#642223"]
      }, {
        name: "scheme22",
        colors: ["#5D7359", "#E0D697", "#D6AA5C", "#8C5430", "#661C0E"]
      }, {
        name: "scheme23",
        colors: ["#16193B", "#35478C", "#4E7AC7", "#7FB2F0", "#ADD5F7"]
      }, {
        name: "scheme24",
        colors: ["#7B1A25", "#BF5322", "#9DA860", "#CEA457", "#B67818"]
      }, {
        name: "scheme25",
        colors: ["#0081DA", "#3AAFFF", "#99C900", "#FFEB3D", "#309B46"]
      }, {
        name: "scheme26",
        colors: ["#0069A5", "#0098EE", "#7BD2F6", "#FFB800", "#FF6800"]
      }, {
        name: "scheme27",
        colors: ["#FF6800", "#A0A700", "#FF8D00", "#678900", "#0069A5"]
      }, {
        name: "scheme28",
        colors: ["#3A43BA", "#281E5D", "#48AAAD", "#0492C2", "#1E456E", "#59788D", "#52B2C0", "#82EDFD"]
      }, {
        name: "scheme29",
        colors: ["#003F5C", "#BC5090", "#58508D", "#FF6361", "#FFA600"]
      }, {
        name: "scheme30",
        colors: ["#16736F", "#A2D56A", "#1C515C", "#62B773", "#EEEF63", "#1F313F", "#309577"]
      }, {
        name: "scheme31",
        colors: ["#74CC66", "#191A4D", "#2D867A", "#EEE3CD", "#224D19", "#0D261B", "#5771C7", "#B6D7E7", "#206052", "#6B5724", "#C3AF4B", "#603620", "#536722", "#B6E7B9", "#34819D", "#94ACDB"]
      }, {
        name: "scheme32",
        colors: ["#87C5FF", "#5B5B60", "#9BE076", "#F7A384", "#7479D3", "#F13A80", "#E4D388", "#2BC6B2", "#F45B14"]
      }];
    }
  }, {
    key: "_clickHandler",
    value: function _clickHandler(e) {
      var t = this;
      if (t.disabled || t._isRangeSelectorInstance) return;
      var i = e.pageX || e.clientX || e.screenX,
          a = e.pageY || e.clientY || e.screenY;
      var n = t.getBoundingClientRect();
      t._isTouchDevice && (i = e.pageX, a = e.pageY), i -= n.left, a -= n.top, t._mouseX = i, t._mouseY = a;
      !isNaN(t._lastClickTs) && 100 > new Date().valueOf() - t._lastClickTs || (this._hostClickTimer = setTimeout(function () {
        if (t._isTouchDevice || (t._cancelTooltipTimer(), t._hideToolTip(), t._unselect()), t._pointMarker && t._pointMarker.element) {
          var _i284 = t.seriesGroups[t._pointMarker.gidx],
              _a188 = _i284.series[t._pointMarker.sidx];
          e.stopImmediatePropagation(), t._raiseItemEvent("click", _i284, _a188, t._pointMarker.iidx);
        }
      }, 100), "HTML5" === t.renderEngine && t._canvasClickHandler(i, a));
    }
  }, {
    key: "_canvasClickHandler",
    value: function _canvasClickHandler(e, t) {
      var i = this,
          a = i.renderer._elements;
      var n;

      for (var _i285 in a) {
        if (a.hasOwnProperty(_i285) && "0" != _i285) {
          var _o95 = a[_i285];

          if (t > _o95.y && t < _o95.y + _o95.height && e > _o95.x && e < _o95.x + _o95.width) {
            n = _o95;
            break;
          }
        }
      }

      if (n && n.purpose && "legend-toggle" === n.purpose) {
        var _e317 = n.data;

        i._toggleSerie(_e317.groupIndex, _e317.seriesIndex, _e317.itemIndex);
      }
    }
  }, {
    key: "_mouseleaveHandler",
    value: function _mouseleaveHandler() {
      var e = this;
      if (e.disabled || e._isRangeSelectorInstance) return;
      var t = e._mouseX,
          i = e._mouseY,
          a = e._plotRect;
      a && t >= a.x && t <= a.x + a.width && i >= a.y && i <= a.y + a.height || (e._cancelTooltipTimer(), e._hideToolTip(0), e._unselect());
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      var t = this;
      if (t.disabled) return;

      if ("touchmove" === e.originalEvent.type && e.originalEvent.preventDefault(), t._isRangeSelectorInstance) {
        var _e318 = t.parentChart;
        null === _e318.xAxis.rangeSelector.renderTo && (_e318._unselect(), _e318._hideToolTip());
      } else t.style.cursor = "default";

      var i = e.pageX || e.clientX || e.screenX,
          a = e.pageY || e.clientY || e.screenY;
      var n = t.getBoundingClientRect();
      t._isTouchDevice && (i = e.pageX, a = e.pageY), i -= n.left, a -= n.top, t.onmousemove(i, a);
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this,
          t = e.animation;
      e._isRangeSelectorInstance || (e.animation = "none", e.refresh(), e.animation = t);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "animation":
        case "theme":
          a._ttEl && a._ttEl.box.setAttribute(e, i);
          break;

        case "seriesGroups":
          a._observeSeriesGroups();

          break;

        case "xAxis_rangeSelector_renderTo":
          if (null === i) {
            var _e319 = t.getElementsByClassName("smart-chart-range-selector")[0];

            _e319.parentElement.removeChild(_e319);
          }

      }

      this.refresh();
    }
  }, {
    key: "_initRenderer",
    value: function _initRenderer() {
      var e = this;
      e._draw = new Smart.Utilities.Draw(e.$.content, e.renderEngine), e.renderer = e._draw.renderer, e._smartPlot || (e._smartPlot = new Smart.Utilities.Plot(e.renderer)), e.$.content.firstElementChild.setAttribute("role", "presentation");
    }
  }, {
    key: "_internalRefresh",
    value: function _internalRefresh() {
      var e = this;

      if (e.offsetWidth || e.offsetHeight || e.getClientRects().length) {
        e._stopAnimations(), e.renderer && (e._isToggleRefresh || e._isUpdate) || (e._hideToolTip(0), e.$.content.innerHTML = "", e._initRenderer());
        var _t270 = e.renderer;

        if (_t270) {
          var _i286 = _t270.getRect();

          e._render({
            x: 1,
            y: 1,
            width: _i286.width,
            height: _i286.height
          }), this.$.fireEvent("refreshBegin", {
            instance: this
          }), _t270 instanceof Smart.Utilities.HTML5Renderer && _t270.refresh(), e._isUpdate = !1, this.$.fireEvent("refreshEnd", {
            instance: this
          });
        }
      }
    }
  }, {
    key: "saveAsPNG",
    value: function saveAsPNG(e) {
      return this._saveAsImage("png", e);
    }
  }, {
    key: "saveAsJPEG",
    value: function saveAsJPEG(e) {
      return this._saveAsImage("jpeg", e);
    }
  }, {
    key: "saveAsPDF",
    value: function saveAsPDF(e, t) {
      return this._saveAsImage("pdf", e, t);
    }
  }, {
    key: "print",
    value: function print() {
      return this._saveAsImage("print");
    }
  }, {
    key: "_saveAsImage",
    value: function _saveAsImage(e, t, i) {
      var a = this;
      return a._draw._widgetToImage(a, e, t, a._hasRangeSelector ? a._selectorSaveAsImageCallback : void 0, i);
    }
  }, {
    key: "_selectorSaveAsImageCallback",
    value: function _selectorSaveAsImageCallback(e, t) {
      var a = e;

      for (var _n145 = 0, _i287; _n145 < a.seriesGroups.length; _n145++) {
        if (_i287 = a._getXAxis(_n145), !_i287 || !_i287.rangeSelector || !_i287.rangeSelector.visible || _i287.rangeSelector.renderTo) continue;
        var _e320 = a._rangeSelectorInstances[_n145];
        if (!_e320) continue;

        var _o96 = _e320.renderer.getRect(),
            r = _e320.renderer.getContainer().getElementsByTagName("canvas")[0],
            _l43 = r.getContext("2d"),
            _s28 = a._sliders[_n145],
            d = "horizontal" === a.seriesGroups[_n145].orientation,
            c = d ? "height" : "width",
            m = d ? "width" : "height",
            u = d ? "y" : "x",
            p = d ? "x" : "y",
            g = {};

        g[u] = _s28.startOffset + _s28.rect[u], g[p] = _s28.rect[p], g[c] = _s28.endOffset - _s28.startOffset, g[m] = _s28.rect[m];

        var h = _i287.rangeSelector.colorSelectedRange || "blue",
            _ = _i287.rangeSelector.colorRangeLine || "grey",
            f = [];

        f.push(_e320.renderer.rect(g.x, g.y, g.width, g.height, {
          fill: h,
          opacity: .1
        }));
        var b = a.renderer;
        d ? (f.push(_e320.renderer.line(b._ptrnd(_s28.rect.x + _s28.rect.width), b._ptrnd(_s28.rect.y), b._ptrnd(_s28.rect.x + _s28.rect.width), b._ptrnd(g.y), {
          stroke: _,
          opacity: .5
        })), f.push(_e320.renderer.line(b._ptrnd(_s28.rect.x + _s28.rect.width), b._ptrnd(g.y + g.height), b._ptrnd(_s28.rect.x + _s28.rect.width), b._ptrnd(_s28.rect.y + _s28.rect.height), {
          stroke: _,
          opacity: .5
        })), f.push(_e320.renderer.line(b._ptrnd(_s28.rect.x), b._ptrnd(g.y), b._ptrnd(_s28.rect.x + _s28.rect.width), b._ptrnd(g.y), {
          stroke: _,
          opacity: .5
        })), f.push(_e320.renderer.line(b._ptrnd(_s28.rect.x), b._ptrnd(g.y + g.height), b._ptrnd(_s28.rect.x + _s28.rect.width), b._ptrnd(g.y + g.height), {
          stroke: _,
          opacity: .5
        }))) : (f.push(_e320.renderer.line(b._ptrnd(_s28.rect.x), b._ptrnd(_s28.rect.y), b._ptrnd(g.x), b._ptrnd(_s28.rect.y), {
          stroke: _,
          opacity: .5
        })), f.push(_e320.renderer.line(b._ptrnd(g.x + g.width), b._ptrnd(_s28.rect.y), b._ptrnd(_s28.rect.x + _s28.rect.width), b._ptrnd(_s28.rect.y), {
          stroke: _,
          opacity: .5
        })), f.push(_e320.renderer.line(b._ptrnd(g.x), b._ptrnd(_s28.rect.y), b._ptrnd(g.x), b._ptrnd(_s28.rect.y + _s28.rect.height), {
          stroke: _,
          opacity: .5
        })), f.push(_e320.renderer.line(b._ptrnd(g.x + g.width), b._ptrnd(_s28.rect.y), b._ptrnd(g.x + g.width), b._ptrnd(_s28.rect.y + _s28.rect.height), {
          stroke: _,
          opacity: .5
        }))), _e320.renderer.refresh();

        var y = _l43.getImageData(_o96.x, _o96.y, _o96.width, _o96.height);

        var v = t.getContext("2d"),
            w = a.getBoundingClientRect(),
            C = _e320.getBoundingClientRect();

        v.putImageData(y, C.left - w.left, C.top - w.top, 1, 1, _o96.width, _o96.height);

        for (var _t271 = 0; _t271 < f.length; _t271++) {
          _e320.renderer.removeElement(f[_t271]);
        }

        _e320.renderer.refresh();
      }

      return !0;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this._internalRefresh();
    }
  }, {
    key: "update",
    value: function update() {
      this._isUpdate = !0, this._internalRefresh();
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = this;
      e.caption = "", e.description = "", e.refresh();
    }
  }, {
    key: "_validateSeriesGroups",
    value: function _validateSeriesGroups() {
      var e = this;
      Array.isArray(this.seriesGroups) || e.seriesGroups instanceof Smart.ObservableArray || e.error(e.localize("invalidSeriesGroups"));

      for (var _t272 = 0; _t272 < this.seriesGroups.length; _t272++) {
        var _i288 = this.seriesGroups[_t272];
        _i288.type || e.error(e.localize("missingType")), Array.isArray(_i288.series) || _i288.series instanceof Smart.ObservableArray || e.error(e.localize("invalidSeries"));
      }
    }
  }, {
    key: "_render",
    value: function _render(e) {
      var t = Math.max,
          a = this,
          n = a.renderer;
      a._colorsCache.clear(), !a._isToggleRefresh && a._isUpdate && a._renderData && a._renderDataClone(), a._renderData = [], n.clear(), a._unselect(), a._hideToolTip(0);
      var i = a.backgroundImage;
      a.style.backgroundImage = void 0 === i || null === i || "" === i ? "" : -1 === i.indexOf("(") ? "url(\"" + i + "\")" : i, a._rect = e;
      var o = a.padding || {
        left: 5,
        top: 5,
        right: 5,
        bottom: 5
      },
          r = n.createClipRect(e),
          l = n.beginGroup();
      n.setClip(l, r);
      var s = n.rect(e.x, e.y, e.width - 2, e.height - 2);

      if (void 0 === i || null === i || "" === i ? n.attr(s, {
        fill: a.backgroundColor || a._getThemeColor("background")
      }) : n.attr(s, {
        fill: "transparent"
      }), !1 !== a.showBorderLine) {
        var d = this.borderLineWidth;
        (isNaN(d) || 0 > d || 10 < d) && (d = 1), n.attr(s, {
          "stroke-width": d,
          stroke: a.borderLineColor || a._getThemeColor("line")
        });
      }

      "function" == typeof a.drawBefore && a.drawBefore(n, e);
      var c = {
        x: o.left,
        y: o.top,
        width: e.width - o.left - o.right,
        height: e.height - o.top - o.bottom
      };
      a._paddedRect = c;
      var m = a.titlePadding || {
        left: 2,
        top: 2,
        right: 2,
        bottom: 2
      },
          u;
      a.caption && 0 < a.caption.length && (u = n.measureText(a.caption, 0, {
        class: "smart-chart-title-text"
      }), n.text(a.caption, c.x + m.left, c.y + m.top, c.width - (m.left + m.right), u.height, 0, {
        class: "smart-chart-title-text"
      }, !0, "center", "center"), c.y += u.height, c.height -= u.height), a.description && 0 < a.description.length && (u = n.measureText(a.description, 0, {
        class: "smart-chart-title-description"
      }), n.text(a.description, c.x + m.left, c.y + m.top, c.width - (m.left + m.right), u.height, 0, {
        class: "smart-chart-title-description"
      }, !0, "center", "center"), c.y += u.height, c.height -= u.height), (a.caption || a.description) && (c.y += m.bottom + m.top, c.height -= m.bottom + m.top);
      var p = {
        x: c.x,
        y: c.y,
        width: c.width,
        height: c.height
      };
      a._plotRect = p, a._buildStats(p);

      var g = a._isPieOnlySeries(),
          _ = a.seriesGroups,
          f = {
        xAxis: {},
        valueAxis: {}
      },
          b;

      for (var _t273 = 0; _t273 < _.length && !g; _t273++) {
        if ("pie" === _[_t273].type || "donut" === _[_t273].type) continue;

        var v = a._getXAxis(_t273);

        v || a.error(a.localize("missingAxis", {
          index: _t273,
          axis: "xAxis"
        }));

        var _e321 = v === a._getXAxis() ? -1 : _t273;

        f.xAxis[_e321] = 0;
      }

      var C = a.axisPadding;
      isNaN(C) && (C = 5);
      var h = {
        left: 0,
        right: 0,
        leftCount: 0,
        rightCount: 0
      },
          S = [];

      for (var _t274 = 0; _t274 < _.length; _t274++) {
        var _e322 = _[_t274];

        if ("pie" === _e322.type || "donut" === _e322.type || !0 === _e322.spider || !0 === _e322.polar) {
          S.push({
            width: 0,
            position: 0,
            xRel: 0
          });
          continue;
        }

        b = "horizontal" === _e322.orientation;

        var v = a._getXAxis(_t274);

        var _i289 = v === a._getXAxis() ? -1 : _t274;

        var D = a._getValueAxis(_t274),
            T = D === a._getValueAxis() ? -1 : _t274,
            $ = b ? v.axisSize : D.axisSize,
            I = {
          x: 0,
          y: p.y,
          width: p.width,
          height: p.height
        },
            A = b ? a._getXAxis(_t274).position : D.position;

        $ && "auto" !== $ || (b ? ($ = this._renderXAxis(_t274, I, !0, p).width, 1 == (1 & f.xAxis[_i289]) ? $ = 0 : 0 < $ && (f.xAxis[_i289] |= 1)) : ($ = a._renderValueAxis(_t274, I, !0, p).width, 1 == (1 & f.valueAxis[T]) ? $ = 0 : 0 < $ && (f.valueAxis[T] |= 1))), "left" !== A && !0 === a.rightToLeft && (A = "right"), "right" !== A && (A = "left"), 0 < h[A + "Count"] && 0 < h[A] && 0 < $ && (h[A] += C), S.push({
          width: $,
          position: A,
          xRel: h[A]
        }), h[A] += $, h[A + "Count"]++;
      }

      var E = t(1, t(e.width, e.height)),
          B = {
        top: 0,
        bottom: 0,
        topCount: 0,
        bottomCount: 0
      },
          L = [];

      for (var _t275 = 0; _t275 < _.length; _t275++) {
        var _e323 = _[_t275];

        if ("pie" === _e323.type || "donut" === _e323.type || !0 === _e323.spider || !0 === _e323.polar) {
          L.push({
            height: 0,
            position: 0,
            yRel: 0
          });
          continue;
        }

        b = "horizontal" === _e323.orientation;

        var D = this._getValueAxis(_t275),
            T = D === a._getValueAxis() ? -1 : _t275,
            v = a._getXAxis(_t275);

        var _i290 = v === a._getXAxis() ? -1 : _t275,
            _n146 = b ? D.axisSize : v.axisSize;

        var A = b ? D.position : v.position;
        _n146 && "auto" !== _n146 || (b ? (_n146 = a._renderValueAxis(_t275, {
          x: 0,
          y: 0,
          width: E,
          height: 0
        }, !0, p).height, 2 == (2 & f.valueAxis[T]) ? _n146 = 0 : 0 < _n146 && (f.valueAxis[T] |= 2)) : (_n146 = a._renderXAxis(_t275, {
          x: 0,
          y: 0,
          width: E,
          height: 0
        }, !0).height, 2 == (2 & f.xAxis[_i290]) ? _n146 = 0 : 0 < _n146 && (f.xAxis[_i290] |= 2))), "top" !== A && (A = "bottom"), 0 < B[A + "Count"] && 0 < B[A] && 0 < _n146 && (B[A] += C), L.push({
          height: _n146,
          position: A,
          yRel: B[A]
        }), B[A] += _n146, B[A + "Count"]++;
      }

      a._createAnimationGroup("series");

      var M = !1 !== a.showLegend,
          H = a._legendLayout;
      var k = M ? a._renderLegend(H ? a._rect : c, !0) : {
        width: 0,
        height: 0
      };
      if (!H || isNaN(this.legendLayout.left) && isNaN(this.legendLayout.top) || (k = {
        width: 0,
        height: 0
      }), c.height < B.top + B.bottom + k.height || c.width < h.left + h.right) return void n.endGroup();
      p.height -= B.top + B.bottom + k.height, p.x += h.left, p.width -= h.left + h.right, p.y += B.top;
      var z = [];
      if (!g) for (var _e324 = 0; _e324 < _.length; _e324++) {
        var _t276 = _[_e324];
        if (!0 === _t276.polar || !0 === _t276.spider || "pie" === _t276.type || "donut" === _t276.type) continue;
        b = "horizontal" === _t276.orientation;
        var P = a._getXAxis(_e324) === a._getXAxis() ? -1 : _e324,
            T = a._getValueAxis(_e324) === a._getValueAxis() ? -1 : _e324;
        var _i291 = {
          x: p.x,
          y: 0,
          width: p.width,
          height: L[_e324].height
        };

        if (_i291.y = "top" === L[_e324].position ? p.y - L[_e324].yRel - L[_e324].height : p.y + p.height + L[_e324].yRel, b) {
          if (4 == (4 & f.valueAxis[T])) continue;
          if (!a._isGroupVisible(_e324)) continue;
          a._renderValueAxis(_e324, _i291, !1, p), f.valueAxis[T] |= 4;
        } else {
          if (z.push(_i291), 4 == (4 & f.xAxis[P])) continue;
          if (!a._isGroupVisible(_e324)) continue;
          a._renderXAxis(_e324, _i291, !1, p), f.xAxis[P] |= 4;
        }
      }

      if (M) {
        var _e325 = a._legendLayout,
            _t277 = _e325 ? a._rect : c;

        var F = c.x + this.renderer._ptrnd((c.width - k.width) / 2),
            O = p.y + p.height + B.bottom,
            $ = c.width;

        var _i292 = k.height;
        _e325 && (!isNaN(a.legendLayout.left) && (F = a.legendLayout.left), !isNaN(a.legendLayout.top) && (O = a.legendLayout.top), !isNaN(a.legendLayout.width) && ($ = a.legendLayout.width), !isNaN(a.legendLayout.height) && (_i292 = a.legendLayout.height)), F + $ > _t277.x + _t277.width && ($ = _t277.x + _t277.width - F), O + _i292 > _t277.y + _t277.height && (_i292 = _t277.y + _t277.height - O), a._renderLegend({
          x: F,
          y: O,
          width: $,
          height: _i292
        });
      }

      if (a._hasHorizontalLines = !1, !g) for (var _e326 = 0; _e326 < _.length; _e326++) {
        var _t278 = _[_e326];
        if (!0 === _t278.polar || !0 === _t278.spider || "pie" === _t278.type || "donut" === _t278.type) continue;
        b = "horizontal" === _[_e326].orientation;
        var _i293 = {
          x: p.x - S[_e326].xRel - S[_e326].width,
          y: p.y,
          width: S[_e326].width,
          height: p.height
        };
        "left" !== S[_e326].position && (_i293.x = p.x + p.width + S[_e326].xRel);
        var P = a._getXAxis(_e326) === a._getXAxis() ? -1 : _e326,
            T = a._getValueAxis(_e326) === a._getValueAxis() ? -1 : _e326;

        if (b) {
          if (z.push(_i293), 8 == (8 & f.xAxis[P])) continue;
          if (!a._isGroupVisible(_e326)) continue;
          a._renderXAxis(_e326, _i293, !1, p), f.xAxis[P] |= 8;
        } else {
          if (8 == (8 & f.valueAxis[T])) continue;
          if (!a._isGroupVisible(_e326)) continue;
          a._renderValueAxis(_e326, _i293, !1, p), f.valueAxis[T] |= 8;
        }
      }

      if (!(0 >= p.width || 0 >= p.height)) {
        a._plotRect = {
          x: p.x,
          y: p.y,
          width: p.width,
          height: p.height
        };

        for (var _e327 = 0; _e327 < _.length; _e327++) {
          this._drawPlotAreaLines(_e327, !0, {
            gridLines: !1,
            tickMarks: !1,
            alternatingBackground: !0
          }), this._drawPlotAreaLines(_e327, !1, {
            gridLines: !1,
            tickMarks: !1,
            alternatingBackground: !0
          });
        }

        for (var _e328 = 0; _e328 < _.length; _e328++) {
          this._drawPlotAreaLines(_e328, !0, {
            gridLines: !0,
            tickMarks: !0,
            alternatingBackground: !1
          }), this._drawPlotAreaLines(_e328, !1, {
            gridLines: !0,
            tickMarks: !0,
            alternatingBackground: !1
          });
        }

        var N = !1;

        for (var _e329 = 0; _e329 < _.length && !N; _e329++) {
          var _t279 = _[_e329];

          if (void 0 !== _t279.annotations || "function" == typeof _t279.draw || "function" == typeof _t279.drawBefore) {
            N = !0;
            break;
          }
        }

        var R = n.beginGroup();

        if (a.clip && !N) {
          var V = n.createClipRect({
            x: p.x - 2,
            y: p.y,
            width: p.width + 4,
            height: p.height
          });
          n.setClip(R, V);
        }

        for (var _t280 = 0; _t280 < _.length; _t280++) {
          var _i294 = _[_t280];
          var U = !1;

          for (var W in a._seriesTypes) {
            if (a._seriesTypes[W] === _i294.type) {
              U = !0;
              break;
            }
          }

          U || a.error(a.localize("invalidType", {
            type: _i294.type
          })), "function" == typeof _i294.drawBefore && _i294.drawBefore(n, e, _t280, this), (!0 === _i294.polar || !0 === _i294.spider) && -1 === _i294.type.indexOf("pie") && -1 === _i294.type.indexOf("donut") && a._renderSpiderAxis(_t280, p), a._renderAxisBands(_t280, p, !0), a._renderAxisBands(_t280, p, !1);
        }

        for (var _t281 = 0; _t281 < _.length; _t281++) {
          var _i295 = _[_t281];

          if (a._isColumnType(_i295.type) ? a._renderColumnSeries(_t281, p) : -1 !== _i295.type.indexOf("pie") || -1 !== _i295.type.indexOf("donut") ? a._renderPieSeries(_t281, p) : -1 !== _i295.type.indexOf("line") || -1 !== _i295.type.indexOf("area") ? a._renderLineSeries(_t281, p) : -1 !== _i295.type.indexOf("scatter") || -1 !== _i295.type.indexOf("bubble") ? a._renderScatterSeries(_t281, p) : (-1 !== _i295.type.indexOf("candlestick") || -1 !== _i295.type.indexOf("ohlc")) && a._renderCandleStickSeries(_t281, p, -1 !== _i295.type.indexOf("ohlc")), _i295.annotations) {
            this._moduleAnnotations || a.error(a.localize("missingReference", {
              files: "smartchart.annotations.js"
            }));

            for (var _e330 = 0; _e330 < _i295.annotations.length; _e330++) {
              a._renderAnnotation(_t281, _i295.annotations[_e330], p);
            }
          }

          "function" == typeof _i295.draw && _i295.draw(n, e, _t281, this);
        }

        if (n.endGroup(), a.disabled) {
          var G = n.rect(e.x, e.y, e.width, e.height);
          n.attr(G, {
            fill: "#777777",
            opacity: .5,
            stroke: "#00FFFFFF"
          });
        }

        "function" == typeof a.draw && a.draw(n, e), n.endGroup(), a._startAnimation("series"), a._credits && a._credits();
        var j = !1;

        for (var _e331 = 0; _e331 < a.seriesGroups.length && !j; _e331++) {
          var v = a._getXAxis(_e331);

          v && v.rangeSelector && v.rangeSelector.visible && (j = !0, a._hasRangeSelector = !0);
        }

        if (j) {
          this._moduleRangeSelector || a.error(a.localize("missingReference", {
            files: "smartchart.rangeselector.js"
          }));
          var Y = [];
          a._isSelectorRefresh || (a._rangeSelectorInstances = {});

          for (var _e332 = 0; _e332 < a.seriesGroups.length; _e332++) {
            var q = this._getXAxis(_e332);

            -1 === Y.indexOf(q) && this._renderXAxisRangeSelector(_e332, z[_e332]) && Y.push(q);
          }
        }
      }
    }
  }, {
    key: "_credits",
    value: function _credits() {}
  }, {
    key: "_isPieOnlySeries",
    value: function _isPieOnlySeries() {
      var e = this.seriesGroups;
      if (0 === e.length) return !1;

      for (var _t282 = 0; _t282 < e.length; _t282++) {
        if ("pie" !== e[_t282].type && "donut" !== e[_t282].type) return !1;
      }

      return !0;
    }
  }, {
    key: "_renderChartLegend",
    value: function _renderChartLegend(e, t, a, n) {
      var o = this,
          l = o.renderer,
          s = {
        x: t.x,
        y: t.y,
        width: t.width,
        height: t.height
      },
          i = 3;
      s.width >= 2 * i && (s.x += i, s.width -= 2 * i), s.height >= 2 * i && (s.y += i, s.height -= 2 * i);
      var r = {
        width: s.width,
        height: 0
      },
          d = 0,
          c = 0,
          m = 20,
          u = 0,
          p = 10,
          h = 10,
          _ = 0;

      for (var y = 0; y < e.length; y++) {
        var f = e[y].css;
        f || (f = "smart-chart-legend-text"), m = 20;
        var b = e[y].text,
            v = l.measureText(b, 0, {
          class: f
        });
        v.height > m && (m = v.height), v.width > _ && (_ = v.width), n ? (0 != y && (c += m), c > s.height && (c = 0, d += _ + 2 * h + p, _ = v.width, r.width = d + _)) : (0 !== d && (d += h), d + 2 * p + v.width > s.width && v.width < s.width && (d = 0, c += m, m = 20, u = s.width, r.height = c + m));
        var w = !1;

        if (v.width > s.width) {
          w = !0;
          var C = s.width,
              S = b,
              D = S.split(/\s+/);
          var _e333 = [],
              _t283 = "";

          for (var _i296 = 0; _i296 < D.length; _i296++) {
            var T = _t283 + (0 < _t283.length ? " " : "") + D[_i296],
                $ = o.renderer.measureText(T, 0, {
              class: f
            });
            $.width > C && 0 < T.length && 0 < _t283.length ? (_e333.push({
              text: _t283
            }), _t283 = D[_i296]) : _t283 = T, _i296 + 1 === D.length && _e333.push({
              text: _t283
            });
          }

          v.width = 0;
          var I = 0;

          for (var _i297 = 0; _i297 < _e333.length; _i297++) {
            var A = _e333[_i297].text,
                $ = o.renderer.measureText(A, 0, {
              class: f
            });
            v.width = Math.max(v.width, $.width), I += v.height;
          }

          v.height = I;
        }

        var E = d + v.width < s.width && c + v.height < t.height;
        if (o._legendLayout) var E = s.x + d + v.width < o._rect.x + o._rect.width && s.y + c + v.height < o._rect.y + o._rect.height;

        if (!a && E) {
          var B = e[y].seriesIndex,
              L = e[y].groupIndex,
              M = e[y].itemIndex,
              H = e[y].fillColor,
              k = e[y].lineColor,
              z = o._isSerieVisible(L, B, M),
              P = l.beginGroup(),
              g = z ? e[y].opacity : .1;

          if (w) {
            var S = b,
                C = s.width,
                D = S.split(/\s+/),
                F = 0;
            var _i298 = [],
                _t284 = "";

            for (var _e334 = 0; _e334 < D.length; _e334++) {
              var T = _t284 + (0 < _t284.length ? " " : "") + D[_e334],
                  $ = o.renderer.measureText(T, 0, {
                class: f
              });
              $.width > C && 0 < T.length && 0 < _t284.length ? (_i298.push({
                text: _t284,
                dy: F
              }), F += $.height, _t284 = D[_e334]) : _t284 = T, _e334 + 1 === D.length && _i298.push({
                text: _t284,
                dy: F
              });
            }

            for (var _e335 = 0; _e335 < _i298.length; _e335++) {
              var A = _i298[_e335].text;
              F = _i298[_e335].dy;
              var $ = o.renderer.measureText(A, 0, {
                class: f
              });
              n ? o.renderer.text(A, s.x + d + 1.5 * p, s.y + c + F, v.width, m, 0, {
                class: f
              }, !1, "left", "center") : o.renderer.text(A, s.x + d + 1.5 * p, s.y + c + F, v.width, m, 0, {
                class: f
              }, !1, "center", "center");
            }

            var _a189 = l.rect(s.x + d, s.y + c + p / 2 + F / 2, p, p);

            n && (c += F), o.renderer.attr(_a189, {
              fill: H,
              "fill-opacity": g,
              stroke: k,
              "stroke-width": 1,
              "stroke-opacity": e[y].opacity
            });
          } else {
            var _t285 = l.rect(s.x + d, s.y + c + p / 2, p, p);

            o.renderer.attr(_t285, {
              fill: H,
              "fill-opacity": g,
              stroke: k,
              "stroke-width": 1,
              "stroke-opacity": e[y].opacity,
              purpose: "legend-toggle",
              data: e[y]
            });

            var _i299 = void 0;

            _i299 = n ? o.renderer.text(b, s.x + d + 1.5 * p, s.y + c, v.width, v.height + p / 2, 0, {
              class: f
            }, !1, "left", "center") : o.renderer.text(b, s.x + d + 1.5 * p, s.y + c, v.width, m, 0, {
              class: f
            }, !1, "center", "center"), l.attr(_i299, {
              purpose: "legend-toggle",
              data: e[y]
            });
          }

          o.renderer.endGroup(), o._setLegendToggleHandler(L, B, M, P);
        }

        n || (d += v.width + 2 * p, u < d && (u = d));
      }

      if (a) return r.height = this.renderer._ptrnd(c + m + 5), r.width = this.renderer._ptrnd(u), r;
    }
  }, {
    key: "isSerieVisible",
    value: function isSerieVisible(e, t, i) {
      return this._isSerieVisible(e, t, i);
    }
  }, {
    key: "_isSerieVisible",
    value: function _isSerieVisible(e, t, i) {
      for (; this._itemsToggleState.length < e + 1;) {
        this._itemsToggleState.push([]);
      }

      var a = this._itemsToggleState[e];

      for (; a.length < t + 1;) {
        a.push(!!isNaN(i) || []);
      }

      var n = a[t];
      if (isNaN(i)) return n;

      for (Array.isArray(n) || (a[t] = n = []); n.length < i + 1;) {
        n.push(!0);
      }

      return n[i];
    }
  }, {
    key: "isGroupVisible",
    value: function isGroupVisible(e) {
      return this._isGroupVisible(e);
    }
  }, {
    key: "_isGroupVisible",
    value: function _isGroupVisible(e) {
      var t = !1,
          a = this.seriesGroups[e].series;
      if (!a) return t;

      for (var _n147 = 0; _n147 < a.length; _n147++) {
        if (this._isSerieVisible(e, _n147)) {
          t = !0;
          break;
        }
      }

      return t;
    }
  }, {
    key: "_toggleSerie",
    value: function _toggleSerie(e, t, i, a) {
      var n = !this._isSerieVisible(e, t, i);
      void 0 !== a && (n = a);
      var o = this.seriesGroups[e],
          r = o.series[t];
      if (this.$.fireEvent("toggle", {
        state: n,
        seriesGroup: o,
        serie: r,
        elementIndex: i
      }), isNaN(i)) this._itemsToggleState[e][t] = n;else {
        var _a190 = this._itemsToggleState[e][t];

        for (Array.isArray(_a190) || (_a190 = []); _a190.length < i;) {
          _a190.push(!0);
        }

        _a190[i] = n;
      }
      this._isToggleRefresh = !0, this.update(), this._isToggleRefresh = !1;
    }
  }, {
    key: "showSerie",
    value: function showSerie(e, t, i) {
      this._toggleSerie(e, t, i, !0);
    }
  }, {
    key: "hideSerie",
    value: function hideSerie(e, t, i) {
      this._toggleSerie(e, t, i, !1);
    }
  }, {
    key: "_setLegendToggleHandler",
    value: function _setLegendToggleHandler(e, t, i, a) {
      var n = this.seriesGroups[e],
          o = n.series[t],
          r = o.enableSeriesToggle;

      if ((void 0 === r || null === r) && (r = !1 !== n.enableSeriesToggle), r) {
        var _n148 = this;

        this.renderer.addHandler(a, "click", function () {
          _n148._toggleSerie(e, t, i);
        });
      }
    }
  }, {
    key: "_renderLegend",
    value: function _renderLegend(e, t) {
      var a = this,
          n = [];

      for (var _o97 = 0, _i300; _o97 < a.seriesGroups.length; _o97++) {
        if (_i300 = a.seriesGroups[_o97], !1 !== _i300.showLegend) for (var _e336 = 0, _t286; _e336 < _i300.series.length; _e336++) {
          if (_t286 = _i300.series[_e336], !1 === _t286.showLegend) continue;

          var r = a._getSerieSettings(_o97, _e336),
              _l44 = void 0;

          if ("pie" === _i300.type || "donut" === _i300.type) {
            var _s30 = a._getXAxis(_o97);

            var _d18 = _t286.legendFormatSettings || _i300.legendFormatSettings || a._getFormatSettings(_s30) || a._getFormatSettings(_t286) || a._getFormatSettings(_i300);

            var _c7 = _t286.legendFormatFunction || _i300.legendFormatFunction || _s30.formatFunction || _t286.formatFunction || _i300.formatFunction,
                _m9 = a._getDataLen(_o97);

            for (var _s31 = 0; _s31 < _m9; _s31++) {
              _l44 = a._getDataValue(_s31, _t286.displayText, _o97), _l44 = a._formatValue(_l44, _d18, _c7, _o97, _e336, _s31);

              var _i301 = a._getColors(_o97, _e336, _s31);

              n.push({
                groupIndex: _o97,
                seriesIndex: _e336,
                itemIndex: _s31,
                text: _l44,
                css: _t286.displayTextClass,
                fillColor: _i301.fillColor,
                lineColor: _i301.lineColor,
                opacity: r.opacity
              });
            }

            continue;
          }

          var _s29 = _t286.legendFormatSettings || _i300.legendFormatSettings;

          var d = _t286.legendFormatFunction || _i300.legendFormatFunction;
          _l44 = a._formatValue(_t286.displayText || _t286.dataField || "", _s29, d, _o97, _e336, NaN);

          var c = a._getSeriesColors(_o97, _e336),
              m = this._get([_t286.legendFillColor, _t286.legendColor, c.fillColor]),
              u = this._get([_t286.legendLineColor, _t286.legendColor, c.lineColor]);

          n.push({
            groupIndex: _o97,
            seriesIndex: _e336,
            text: _l44,
            css: _t286.displayTextClass,
            fillColor: m,
            lineColor: u,
            opacity: r.opacity
          });
        }
      }

      return a._renderChartLegend(n, e, t, a._legendLayout && "vertical" === a.legendLayout.flow);
    }
  }, {
    key: "_getInterval",
    value: function _getInterval(e, t) {
      if (!e) return t;

      var i = this._get([e.unitInterval, t]);

      return isNaN(e.step) || null === e.step || (i = e.step * t), i;
    }
  }, {
    key: "_getOffsets",
    value: function _getOffsets(e, t, i, a, n, o, r, l, s) {
      var d = this._getInterval(n[e], l),
          c = [];

      ("" === e || n[e].visible && "custom" !== n[e].visible) && (c = this._generateIntervalValues(a, d, l, r, s));
      var m;

      if ("labels" !== e) {
        var _e337 = r ? o.left : 0;

        if (!r && 1 < l && (_e337 = o.left * (l + 1)), 1 === c.length && (_e337 *= 2), m = this._valuesToOffsets(c, t, a, i, o, !1, _e337), !r) {
          var _e338 = (o.left + o.right) * d / l;

          t.flip ? m.unshift(m[0] + _e338) : m.push(m[m.length - 1] + _e338);
        }
      } else {
        var _e339 = o.left;
        1 === c.length && (_e339 *= 2), m = this._valuesToOffsets(c, t, a, i, o, r, _e339);
      }

      var u = this._arraysToObjectsArray([c, m], ["value", "offset"]);

      if (t[e] && t[e].custom) {
        var _n149 = this._objectsArraysToArray(t[e].custom, "value"),
            _l45 = this._objectsArraysToArray(t[e].custom, "offset"),
            _s32 = this._valuesToOffsets(_n149, t, a, i, o, r, o.left);

        for (var _a191 = 0; _a191 < t[e].custom.length; _a191++) {
          u.push({
            value: _n149[_a191],
            offset: isNaN(_l45[_a191]) ? _s32[_a191] : _l45[_a191]
          });
        }
      }

      return u;
    }
  }, {
    key: "_renderXAxis",
    value: function _renderXAxis(e, t, i, a) {
      var n = this,
          o = n._getXAxis(e),
          r = n.seriesGroups[e],
          l = "horizontal" === r.orientation,
          s = {
        width: 0,
        height: 0
      },
          d = n._getAxisSettings(o);

      if (!o || !d.visible || "spider" === r.type) return s;
      if (!n._isGroupVisible(e) || this._isPieGroup(e)) return s;

      var c = n._alignValuesWithTicks(e);

      for (; n._renderData.length < e + 1;) {
        n._renderData.push({});
      }

      n.rightToLeft && (o.flip = !0);

      var m = l ? t.height : t.width,
          u = n._calculateXOffsets(e, m),
          p = u.axisStats,
          g = o.rangeSelector && o.rangeSelector.visible,
          h = 0;

      g && (!this._moduleRangeSelector && n.error(n.localize("missingReference", {
        files: "smartchart.rangeselector.js"
      })), h = this._selectorGetSize(o));

      var _ = l && "right" === o.position || !l && "top" === o.position;

      !i && g && (l ? (t.width -= h, "right" !== o.position && (t.x += h)) : (t.height -= h, "top" === o.position && (t.y += h)));
      var f = {
        rangeLength: u.rangeLength,
        itemWidth: u.itemWidth,
        intervalWidth: u.intervalWidth,
        data: u,
        settings: d,
        isMirror: _,
        rect: t
      };
      n._renderData[e].xAxis = f;
      var b = p.interval;
      if (isNaN(b)) return s;
      l && (d.title.angle -= 90, d.labels.angle -= 90);

      var y = this._getInterval(d.gridLines, b),
          v = this._getInterval(d.tickMarks, b),
          w = this._getInterval(d.labels, b),
          C = p.min,
          x = p.max,
          S = u.padding,
          D = !0 === o.flip || n.rightToLeft,
          T = {
        min: C,
        max: x
      },
          $;

      p.logAxis.enabled && (T.min = p.logAxis.minPow, T.max = p.logAxis.maxPow), "date" === o.type ? (d.gridLines.offsets = this._generateDTOffsets(C, x, m, S, y, b, p.dateTimeUnit, c, NaN, !1, D), d.tickMarks.offsets = this._generateDTOffsets(C, x, m, S, v, b, p.dateTimeUnit, c, NaN, !1, D), $ = this._generateDTOffsets(C, x, m, S, w, b, p.dateTimeUnit, c, NaN, !0, D)) : (d.gridLines.offsets = this._getOffsets("gridLines", o, m, p, d, S, c, b), d.tickMarks.offsets = this._getOffsets("tickMarks", o, m, p, d, S, c, b), $ = this._getOffsets("labels", o, m, p, d, S, c, b));
      var I;
      n._elementRenderInfo && n._elementRenderInfo.length > e && (I = n._elementRenderInfo[e].xAxis);
      var A = [],
          E;
      d.labels.formatFunction && (E = d.labels.formatFunction);

      var B = n._getFormatSettings(d.labels);

      var L;
      B && (L = Object.assign({}, B)), "date" === o.type && (o.dateFormat && !E ? L ? L.dateFormat = L.dateFormat || o.dateFormat : L = {
        dateFormat: o.dateFormat
      } : !E && (!L || L && !L.dateFormat) && (E = this._getDefaultDTFormatFn(o.baseUnit || "day")));

      for (var _r51 = 0; _r51 < $.length; _r51++) {
        var _t287 = $[_r51].value,
            _i302 = $[_r51].offset;
        if (isNaN(_i302)) continue;

        var _a192 = void 0;

        "date" !== o.type && p.useIndeces && o.dataField && (_a192 = Math.round(_t287), _t287 = n._getDataValue(_a192, o.dataField, e), (void 0 === _t287 || null === _t287) && (_t287 = ""));

        var _l46 = n._formatValue(_t287, L, E, e, void 0, _a192);

        (void 0 === _l46 || null === _l46 || "" === _l46.toString()) && (isNaN(_a192) && (_a192 = _r51), _a192 >= p.filterRange.min && _a192 <= p.filterRange.max && (_l46 = p.useIndeces ? (p.min + _a192).toString() : void 0 === _t287 ? "" : _t287.toString()));
        var _s33 = {
          key: _t287,
          text: _l46,
          targetX: _i302,
          x: _i302
        };
        I && I.itemOffsets[_t287] && (_s33.x = I.itemOffsets[_t287].x, _s33.y = I.itemOffsets[_t287].y), A.push(_s33);
      }

      var M = n._getAnimProps(e),
          H = M.enabled && 500 > A.length ? M.duration : 0;

      !1 === n.enableAxisTextAnimation && (H = 0);

      var k = n._renderAxis(l, _, d, {
        x: t.x,
        y: t.y,
        width: t.width,
        height: t.height
      }, a, b, !1, !0, {
        items: A,
        renderData: f
      }, i, H);

      return l ? k.width += h : k.height += h, k;
    }
  }, {
    key: "_animateAxisText",
    value: function _animateAxisText(e, t) {
      var a = e.items,
          n = e.textSettings;

      for (var _o98 = 0, _i303; _o98 < a.length; _o98++) {
        if (_i303 = a[_o98], !_i303) continue;
        if (!_i303.visible) continue;
        var _e340 = _i303.targetX,
            r = _i303.targetY;
        isNaN(_i303.x) || isNaN(_i303.y) || (_e340 = _i303.x + (_e340 - _i303.x) * t, r = _i303.y + (r - _i303.y) * t), _i303.element && (this.renderer.removeElement(_i303.element), _i303.element = void 0), _i303.element = this.renderer.text(_i303.text, _e340, r, _i303.width, _i303.height, n.angle, {
          class: n.style
        }, !1, n.halign, n.valign, n.textRotationPoint);
      }
    }
  }, {
    key: "_getPolarAxisCoords",
    value: function _getPolarAxisCoords(e, t) {
      var i = Math.abs,
          a = Math.PI;

      var n = this.seriesGroups[e],
          o = t.x + this._draw.getNum([n.offsetX, t.width / 2]),
          r = t.y + this._draw.getNum([n.offsetY, t.height / 2]),
          l = Math.min(t.width, t.height),
          s = n.radius;

      this._isPercent(s) && (s = parseFloat(s) / 100 * l / 2), isNaN(s) && (s = .6 * (l / 2));

      var d = this._alignValuesWithTicks(e),
          c = this._get([n.startAngle, n.minAngle, 0]) - 90;

      c = isNaN(c) ? 0 : 2 * a * c / 360;
      var m = this._get([n.endAngle, n.maxAngle, 360]) - 90;

      if (m = isNaN(m) ? 2 * a : 2 * a * m / 360, c > m) {
        var _e341 = c;
        c = m, m = _e341;
      }

      var u = this.renderer._rnd(i(c - m) / (2 * a), .001, !0),
          p = 2 * a * s * u,
          g = this._calcGroupOffsets(e, t).xoffsets;

      if (!g) return;

      var h = !(1e-5 < i(i(m - c) - 2 * a)),
          _;

      if (n.spider) {
        var _t288 = this._getXAxisStats(e, this._getXAxis(e), p);

        var _a193 = _t288.interval;
        (isNaN(_a193) || 0 === _a193) && (_a193 = 1);

        var _n150 = (_t288.max - _t288.min) / _a193 + (h ? 1 : 0);

        if (_n150 = Math.round(_n150), 2 < _n150) {
          var _e342 = Math.cos(i(m - c) / 2 / _n150);

          _e342 = this.renderer._rnd(_e342, .01), 0 === _e342 && (_e342 = 1), _ = s / _e342, _ > s && d && (s = _);
        }
      }

      return s = this.renderer._ptrnd(s), {
        x: o,
        y: r,
        r: s,
        adjR: this._get([_, s]),
        itemWidth: g.itemWidth,
        rangeLength: g.rangeLength,
        valuesOnTicks: d,
        startAngle: c,
        endAngle: m,
        isClosedCircle: h,
        axisSize: p
      };
    }
  }, {
    key: "_toPolarCoord",
    value: function _toPolarCoord(e, t, i, a) {
      var n = Math.PI,
          o = Math.max;
      var r = Math.abs(e.startAngle - e.endAngle) / (2 * n),
          l = 2 * (i - t.x) * n * r / o(1, t.width) + e.startAngle,
          s = (t.height + t.y - a) * e.r / o(1, t.height),
          d = e.x + s * Math.cos(l),
          c = e.y + s * Math.sin(l);
      return {
        x: this.renderer._ptrnd(d),
        y: this.renderer._ptrnd(c)
      };
    }
  }, {
    key: "_renderSpiderAxis",
    value: function _renderSpiderAxis(e, t) {
      var i = Math.min,
          a = Math.abs,
          n = Math.sin,
          o = Math.cos,
          r = Math.PI,
          l = Math.max;

      var s = this,
          d = s._getXAxis(e),
          c = this._getAxisSettings(d);

      if (!d || !c.visible) return;

      var m = s.seriesGroups[e],
          u = s._getPolarAxisCoords(e, t);

      if (!u) return;

      var p = this.renderer._ptrnd(u.x),
          g = this.renderer._ptrnd(u.y),
          h = u.adjR,
          _ = u.startAngle,
          f = u.endAngle;

      if (1 > h) return;

      var b = this.renderer._rnd(a(_ - f) / (2 * r), .001, !0),
          y = 2 * r * h * b,
          v = u.isClosedCircle,
          w = this._renderData[e].xoffsets;

      if (!w.rangeLength) return;
      var C = w.axisStats.interval;

      for ((isNaN(C) || 1 > C) && (C = 1); s._renderData.length < e + 1;) {
        s._renderData.push({});
      }

      var x = {
        rangeLength: w.rangeLength,
        itemWidth: w.itemWidth,
        data: w,
        rect: t,
        settings: c
      };
      s._renderData[e].xAxis = x, s._renderData[e].polarCoords = u;
      var S = !0;

      for (var _a194 = 0; _a194 < e; _a194++) {
        var _e343 = s._renderData[_a194].polarCoords,
            _t289 = s._getXAxis(_a194),
            _i304 = !1;

        for (var _t290 in u) {
          if (u[_t290] !== _e343[_t290]) {
            _i304 = !0;
            break;
          }
        }

        _i304 && _t289 === d || (S = !1);
      }

      var D = c.gridLines,
          T = c.tickMarks,
          $ = c.labels,
          I = this._getInterval(D, C),
          A = this._getInterval(T, C),
          E = this._getInterval($, C),
          B = s._alignValuesWithTicks(e),
          L = s.renderer,
          M = w.axisStats,
          H = M.min,
          k = M.max,
          z = this._getPaddingSize(w.axisStats, d, B, y, !0, v, !1),
          P = !0 === d.flip || s.rightToLeft,
          F;

      "date" === d.type ? (D.offsets = this._generateDTOffsets(H, k, y, z, I, C, d.baseUnit, !0, 0, !1, P), T.offsets = this._generateDTOffsets(H, k, y, z, A, C, d.baseUnit, !0, 0, !1, P), F = this._generateDTOffsets(H, k, y, z, E, C, d.baseUnit, !0, 0, !0, P)) : (c.gridLines.offsets = this._getOffsets("gridLines", d, y, M, c, z, !0, C), c.tickMarks.offsets = this._getOffsets("tickMarks", d, y, M, c, z, !0, C), F = this._getOffsets("labels", d, y, M, c, z, !0, C));
      var O;
      s._elementRenderInfo && s._elementRenderInfo.length > e && (O = s._elementRenderInfo[e].xAxis);

      var N = [],
          R = this._getDataLen(e);

      for (var _a195 = 0; _a195 < F.length; _a195++) {
        var _t291 = F[_a195].offset,
            _i305 = F[_a195].value,
            _n151 = void 0;

        if ("date" !== d.type && M.useIndeces && d.dataField) {
          if (_n151 = Math.round(_i305), _n151 >= R) continue;
          _i305 = s._getDataValue(_n151, d.dataField), (void 0 === _i305 || null === _i305) && (_i305 = "");
        }

        var _o99 = s._formatValue(_i305, s._getFormatSettings($.formatSettings), $.formatFunction, e, void 0, _n151);

        (void 0 === _o99 || null === _o99 || "" === _o99.toString()) && (_o99 = M.useIndeces ? (M.min + _a195).toString() : void 0 === _i305 || null === _i305 ? "" : _i305.toString());
        var _r52 = {
          key: _i305,
          text: _o99,
          targetX: _t291,
          x: _t291
        };
        O && O.itemOffsets[_i305] && (_r52.x = O.itemOffsets[_i305].x, _r52.y = O.itemOffsets[_i305].y), N.push(_r52);
      }

      var V = {
        stroke: D.color || s._getThemeColor("line"),
        fill: "none",
        "stroke-width": D.width,
        "stroke-dasharray": D.dashStyle || ""
      };
      if (!m.spider) if (1 === b) L.circle(p, g, h, V);else {
        var _e344 = 180 * (-_ / r),
            _t292 = 180 * (-f / r);

        this.renderer.pieslice(p, g, 0, h, i(_e344, _t292), l(_e344, _t292), void 0, V);
      }
      var U = _;

      if (D.visible && S) {
        B || v || D.offsets.unshift({
          offset: -z.right
        });

        for (var _e345 = 0, _t293; _e345 < D.offsets.length; _e345++) {
          _t293 = D.offsets[_e345].offset, B || (v ? _t293 += z.right / 2 : _t293 += z.right);

          var _i306 = U + 2 * _t293 * r * b / l(1, y);

          if (.01 < _i306 - f) continue;

          var _a196 = this.renderer._ptrnd(p + h * o(_i306)),
              _s34 = this.renderer._ptrnd(g + h * n(_i306));

          L.line(p, g, _a196, _s34, V);
        }
      }

      if (T.visible && S) {
        var _e346 = 5,
            _t294 = {
          stroke: T.color || s._getThemeColor("line"),
          fill: "none",
          "stroke-width": T.width,
          "stroke-dasharray": T.dashStyle || ""
        };
        B || v || T.offsets.unshift({
          offset: -z.right
        });

        for (var _a197 = 0, _i307; _a197 < T.offsets.length; _a197++) {
          _i307 = T.offsets[_a197].offset, B || (v ? _i307 += z.right / 2 : _i307 += z.right);

          var _s35 = U + 2 * _i307 * r * b / l(1, y);

          if (.01 < _s35 - f) continue;
          var _d19 = {
            x: p + h * o(_s35),
            y: g + h * n(_s35)
          },
              _c8 = {
            x: p + (h + _e346) * o(_s35),
            y: g + (h + _e346) * n(_s35)
          };
          L.line(this.renderer._ptrnd(_d19.x), this.renderer._ptrnd(_d19.y), this.renderer._ptrnd(_c8.x), this.renderer._ptrnd(_c8.y), _t294);
        }
      }

      var W = [];

      if (m.spider) {
        var _e347 = [];
        _e347 = "date" === d.type ? this._generateDTOffsets(H, k, y, z, C, C, d.baseUnit, !0, 0, !1, P) : this._getOffsets("", d, y, M, c, z, !0, C), B || v || _e347.unshift({
          offset: -z.right
        });

        for (var _t295 = 0, _i308; _t295 < _e347.length; _t295++) {
          _i308 = _e347[_t295].offset, B || (v ? _i308 += z.right / 2 : _i308 += z.right);

          var _a198 = U + 2 * _i308 * r * b / l(1, y);

          .01 < _a198 - f || W.push(_a198);
        }

        x.offsetAngles = W;
      }

      var G = s._renderSpiderValueAxis(e, t, B ? u.adjR : u.r, W);

      if (G || (G = []), m.spider) {
        if (!B) for (var _e348 = 0; _e348 < G.length; _e348++) {
          G[_e348] = G[_e348] * u.adjR / u.r;
        }
        G.push(h), this._renderSpiderLines(p, g, G, u, W, V);
      }

      if (S && $.visible) {
        x.polarLabels = [];

        for (var _e349 = 0; _e349 < N.length; _e349++) {
          var _t296 = N[_e349].x,
              _n152 = U + 2 * _t296 * r * b / l(1, y);

          _n152 = (360 - 360 * (_n152 / (2 * r))) % 360, 0 > _n152 && (_n152 = 360 + _n152);

          var _o100 = L.measureText(N[_e349].text, 0, {
            class: c.labels.style
          }),
              _s36 = (B ? u.adjR : u.r) + (T.visible ? 7 : 2),
              _d20 = c.labels,
              _m10 = void 0;

          if (_d20.autoRotate) {
            var _e350 = this._draw._ptRotate(p - _o100.width / 2, g - _s36 - _o100.height, p, g, -_n152 / 180 * r),
                _t297 = this._draw._ptRotate(p + _o100.width / 2, g - _s36, p, g, -_n152 / 180 * r);

            _o100.width = a(_e350.x - _t297.x), _o100.height = a(_e350.y - _t297.y), _m10 = {
              x: i(_e350.x, _t297.x),
              y: i(_e350.y, _t297.y)
            };
          } else _m10 = this._adjustTextBoxPosition(p, g, _o100, _s36, _n152, !1, !1, !1);

          x.polarLabels.push({
            x: _m10.x,
            y: _m10.y,
            value: N[_e349].text
          }), L.text(N[_e349].text, _m10.x, _m10.y, _o100.width, _o100.height, _d20.autoRotate ? 90 - _n152 : _d20.angle, {
            class: _d20.style
          }, !1, _d20.halign, _d20.valign);
        }
      }
    }
  }, {
    key: "_renderSpiderLines",
    value: function _renderSpiderLines(e, t, i, a, n, o) {
      var r = this.renderer,
          l = a.isClosedCircle;

      for (var _s37 = 0; _s37 < i.length; _s37++) {
        var _a199 = i[_s37],
            d = void 0,
            c = void 0;

        for (var _l47 = 0; _l47 < n.length; _l47++) {
          var _i309 = n[_l47],
              _s38 = this.renderer._ptrnd(e + _a199 * Math.cos(_i309)),
              m = this.renderer._ptrnd(t + _a199 * Math.sin(_i309));

          d && r.line(d.x, d.y, _s38, m, o), d = {
            x: _s38,
            y: m
          }, c || (c = {
            x: _s38,
            y: m
          });
        }

        c && l && r.line(d.x, d.y, c.x, c.y, o);
      }
    }
  }, {
    key: "_renderSpiderValueAxis",
    value: function _renderSpiderValueAxis(e, t, a, i) {
      var n = Math.min,
          o = Math.abs,
          r = Math.sin,
          l = Math.cos,
          s = Math.PI,
          d = Math.max,
          c = this,
          m = this.seriesGroups[e],
          u = this._getPolarAxisCoords(e, t);

      if (u) {
        var p = this.renderer._ptrnd(u.x),
            g = this.renderer._ptrnd(u.y);

        a = a || u.r;

        var h = u.startAngle,
            _ = u.endAngle,
            f = this.renderer._rnd(o(h - _) / (2 * s), .001, !0);

        if (!(1 > a)) {
          a = this.renderer._ptrnd(a);

          var b = this._getValueAxis(e);

          var _t298 = this._getAxisSettings(b);

          if (b && !1 !== _t298.visible) {
            var y = this._stats.seriesGroups[e].mu,
                v = _t298.labels,
                w = c._getFormatSettings(v),
                C = -1 !== m.type.indexOf("stacked") && -1 !== m.type.indexOf("100");

            C && !w && (w = {
              sufix: "%"
            });

            var S = this._get([v.step, v.unitInterval / y]);

            isNaN(S) && (S = 1), S = d(1, Math.round(S)), this._calcValueAxisItems(e, a, S);
            var D = _t298.gridLines,
                T = _t298.tickMarks,
                $ = _t298.labels,
                I = {
              stroke: D.color || c._getThemeColor("line"),
              fill: "none",
              "stroke-width": 1,
              "stroke-dasharray": D.dashStyle || ""
            },
                A = this._renderData[e].valueAxis,
                E = A.items,
                B = h;

            if (E.length && _t298.line.visible) {
              isNaN(_t298.line.angle) || (B = 2 * s * _t298.line.angle / 360);
              var L = p + l(B) * a,
                  M = g + r(B) * a;

              if (-1 === i.indexOf(B)) {
                var H = Object.assign({}, I);
                H["stroke-width"] = _t298.line.lineWidth, H.stroke = _t298.line.color || c._getThemeColor("line"), H["stroke-dasharray"] = _t298.line.dashStyle, this.renderer.line(p, g, L, M, H);
              }
            }

            E = E.reverse();
            var k = this.renderer;
            A.polarLabels = [];

            for (var _e351 = 0; _e351 < E.length - 1; _e351++) {
              var z = E[_e351];
              if (isNaN(z)) continue;
              var P = $.formatFunction ? $.formatFunction(z) : this._formatNumber(z, w),
                  F = k.measureText(P, 0, {
                class: $.style
              }),
                  O = p + (!1 === b.showTickMarks ? 2 : 3);

              var _i310 = g - A.itemWidth * _e351 - F.height / 2;

              {
                var N = this._draw._ptRotate(O, _i310, p, g, B),
                    R = this._draw._ptRotate(O + F.width, _i310 + F.height, p, g, B);

                O = n(N.x, R.x), _i310 = n(N.y, R.y), F.width = o(N.x - R.x), F.height = o(N.y - R.y);
              }
              O += _t298.labels.textOffset.x, _i310 += _t298.labels.textOffset.y, A.polarLabels.push({
                x: O,
                y: _i310,
                value: P
              }), k.text(P, O, _i310, F.width, F.height, $.autoRotate ? 90 + 180 * h / s : $.angle, {
                class: $.style
              }, !1, $.halign, $.valign);
            }

            var V = !1 !== b.valuesOnTicks,
                U = this._stats.seriesGroups[e],
                W = U.mu,
                G = !0 === b.logarithmicScale;
            G && (W = 1);
            var j = {
              min: U.min,
              max: U.max,
              logAxis: {
                enabled: !0 === G,
                base: b.logarithmicScaleBase,
                minPow: U.minPow,
                maxPow: U.maxPow
              }
            };
            (D.visible || m.spider || b.alternatingBackgroundColor || b.alternatingBackgroundColor2) && (D.offsets = this._getOffsets("gridLines", b, a, j, _t298, {
              left: 0,
              right: 0
            }, V, W));
            var Y = [];

            if (D.visible || m.spider) {
              var _e352 = {
                stroke: D.color || c._getThemeColor("line"),
                fill: "none",
                "stroke-width": 1,
                "stroke-dasharray": D.dashStyle || ""
              };

              for (var _t299 = 0, _i311; _t299 < D.offsets.length; _t299++) {
                if (_i311 = this.renderer._ptrnd(D.offsets[_t299].offset), _i311 !== a) {
                  if (m.spider) {
                    Y.push(_i311);
                    continue;
                  }

                  if (1 !== f) {
                    var q = 180 * (-h / s),
                        X = 180 * (-_ / s);
                    this.renderer.pieslice(p, g, 0, _i311, n(q, X), d(q, X), void 0, _e352);
                  } else k.circle(p, g, _i311, _e352);
                }
              }
            }

            if (b.tickMarks && (b.tickMarks.visible || b.showTickMarks) || (T.visible = !1), T.visible) {
              T.offsets = this._getOffsets("tickMarks", b, a, j, _t298, {
                left: 0,
                right: 0
              }, V, W);

              var _e353 = 2 * T.size;

              var _n153 = {
                stroke: T.color || c._getThemeColor("line"),
                fill: "none",
                "stroke-width": 1,
                "stroke-dasharray": T.dashStyle || ""
              };

              for (var _t300 = 0; _t300 < T.offsets.length; _t300++) {
                var K = T.offsets[_t300].offset,
                    N = {
                  x: p + K * l(B) - _e353 / 2 * r(B + s / 2),
                  y: g + K * r(B) - _e353 / 2 * l(B + s / 2)
                },
                    R = {
                  x: p + K * l(B) + _e353 / 2 * r(B + s / 2),
                  y: g + K * r(B) + _e353 / 2 * l(B + s / 2)
                };
                k.line(this.renderer._ptrnd(N.x), this.renderer._ptrnd(N.y), this.renderer._ptrnd(R.x), this.renderer._ptrnd(R.y), _n153);
              }
            }

            return Y;
          }
        }
      }
    }
  }, {
    key: "_renderAxis",
    value: function _renderAxis(e, t, i, a, n, o, r, l, s, d, c) {
      if (i.customDraw && !d) return {
        width: NaN,
        height: NaN
      };

      var m = i.title,
          u = i.labels,
          p = i.tickMarks,
          g = i.padding,
          _ = p.visible ? p.size : 0,
          f = 2,
          b = {
        width: 0,
        height: 0
      },
          v = {
        width: 0,
        height: 0
      };

      e ? b.height = v.height = a.height : b.width = v.width = a.width, !d && t && e && (a.x -= a.width);
      var C = s.renderData,
          S = C.itemWidth;

      if (m.visible && void 0 !== m.text && null !== m.text && "" !== m) {
        var _i312 = m.angle,
            _n154 = this.renderer.measureText(m.text, _i312, {
          class: m.style
        });

        v.width = _n154.width, v.height = _n154.height, d || this.renderer.text(m.text, a.x + m.offset.x + (e ? t ? -g.right - f + 2 * a.width - v.width : f + g.left : 0), a.y + m.offset.y + (e ? 0 : t ? g.top + f : a.height - f - v.height - g.bottom), e ? v.width : a.width, e ? a.height : v.height, _i312, {
          class: m.style
        }, !0, m.halign, m.valign, m.rotationPoint);
      }

      var D = 0,
          y = l ? -S / 2 : 0;
      l && !e && (u.halign = "center");
      var T = a.x,
          $ = a.y,
          x = u.textOffset;
      x && (!isNaN(x.x) && (T += x.x), !isNaN(x.y) && ($ += x.y)), e ? (T += g.left + f + (0 < v.width ? v.width + f : 0) + (t ? a.width - v.width : 0), $ += y) : (T += y, t ? ($ += 0 < v.height ? v.height + 3 * f : 2 * f, $ += _ - (l ? _ : _ / 4)) : $ += l ? _ : _ / 4, $ += g.top);
      var I = 0,
          A = 0,
          E = s.items;
      C.itemOffsets = {}, (this._isToggleRefresh || !this._isUpdate) && (c = 0);
      var B = !1,
          L = 0;

      for (var _m11 = 0; _m11 < E.length && u.visible; _m11++, D += S) {
        if (!E[_m11] || isNaN(S)) continue;
        var _i313 = E[_m11].text;
        isNaN(E[_m11].targetX) || (D = E[_m11].targetX);

        var _n155 = this.renderer.measureText(_i313, u.angle, {
          class: u.style
        });

        if (_n155.width > A && (A = _n155.width), _n155.height > I && (I = _n155.height), L += e ? I : A, !d) {
          if (e && D > a.height + 2 || !e && D > a.width + 2) continue;

          var _i314 = e ? T + (t ? 0 === v.width ? _ : _ - f : 0) : T + D;

          var _n156 = e ? $ + D : $;

          C.itemOffsets[E[_m11].key] = {
            x: _i314,
            y: _n156
          }, B || isNaN(E[_m11].x) && (isNaN(E[_m11].y) || !c) || (B = !0), E[_m11].targetX = _i314, E[_m11].targetY = _n156, E[_m11].width = e ? a.width - g.left - g.right - 2 * f - _ - (0 < v.width ? v.width + f : 0) : S, E[_m11].height = e ? S : a.height - g.top - g.bottom - 2 * f - _ - (0 < v.height ? v.height + f : 0), E[_m11].visible = !0;
        }
      }

      if (C.avgWidth = 0 === E.length ? 0 : L / E.length, !d) {
        var _e354 = {
          items: E,
          textSettings: u
        };

        if ((isNaN(c) || !B) && (c = 0), this._animateAxisText(_e354, 0 === c ? 1 : 0), 0 !== c) {
          var _t301 = this;

          this._enqueueAnimation("series", void 0, void 0, c, function (e, i, a) {
            _t301._animateAxisText(i, a);
          }, _e354);
        }
      }

      if (b.width += 2 * f + _ + v.width + A + (e && 0 < v.width ? f : 0), b.height += 2 * f + _ + v.height + I + (!e && 0 < v.height ? f : 0), e ? b.width += g.left + g.right : b.height += g.top + g.bottom, !d && i.line.visible) {
        var _n157 = {
          stroke: i.line.color || self._getThemeColor("line"),
          "stroke-width": i.line.width,
          "stroke-dasharray": i.line.dashStyle || ""
        };

        if (e) {
          var _e355 = a.x + a.width + (t ? g.left : -g.right);

          _e355 = this.renderer._ptrnd(_e355), this.renderer.line(_e355, a.y, _e355, a.y + a.height, _n157);
        } else {
          var _e356 = this.renderer._ptrnd(a.y + (t ? a.height - g.bottom : g.top));

          this.renderer.line(this.renderer._ptrnd(a.x), _e356, this.renderer._ptrnd(a.x + a.width + 1), _e356, _n157);
        }
      }

      return b.width = this.renderer._rup(b.width), b.height = this.renderer._rup(b.height), b;
    }
  }, {
    key: "_drawPlotAreaLines",
    value: function _drawPlotAreaLines(e, t, a) {
      var n = Math.abs,
          i = this.seriesGroups[e],
          o = "horizontal" !== i.orientation;
      if (!this._renderData || this._renderData.length <= e) return;
      var r = t ? "valueAxis" : "xAxis",
          l = this._renderData[e][r];
      if (!l) return;
      var s = this._renderData.axisDrawState;
      s || (s = this._renderData.axisDrawState = {});
      var d = "",
          c;
      t ? (d = "valueAxis_" + (i.valueAxis ? e : "") + (o ? "swap" : ""), c = this._getValueAxis(e)) : (d = "xAxis_" + (i.xAxis ? e : "") + (o ? "swap" : ""), c = this._getXAxis(e)), s = s[d] ? s[d] : s[d] = {}, t || (o = !o);
      var m = l.settings;
      if (!m) return;
      if (m.customDraw) return;
      var u = m.gridLines,
          p = m.tickMarks,
          g = m.padding,
          h = l.rect,
          _ = this._plotRect;
      if (!u || !p) return;
      var f = .5,
          b = {};
      var v = {
        stroke: u.color || self._getThemeColor("line"),
        "stroke-width": u.width,
        "stroke-dasharray": u.dashStyle || ""
      };
      var w = t ? h.y + h.height : h.x,
          C = u.offsets;
      t && !c.flip && (C = C.slice(0), C = C.reverse());
      var S;

      if (C && 0 < C.length) {
        var D = NaN;

        for (var _e357 = 0; _e357 < C.length; _e357++) {
          if (o ? (S = this.renderer._ptrnd(h.y + C[_e357].offset), S < h.y - f && (S = this.renderer._ptrnd(h.y)), S > h.y + h.height && (S = h.y + h.height)) : (S = this.renderer._ptrnd(h.x + C[_e357].offset), S > h.x + h.width + f && (S = this.renderer._ptrnd(h.x + h.width))), !isNaN(S) && (isNaN(D) || !(2 > n(S - D)))) {
            if (D = S, a.gridLines && !1 !== u.visible && !0 !== s.gridLines && (o ? this.renderer.line(this.renderer._ptrnd(_.x), S, this.renderer._ptrnd(_.x + _.width), S, v) : this.renderer.line(S, this.renderer._ptrnd(_.y), S, this.renderer._ptrnd(_.y + _.height), v)), b[S] = !0, a.alternatingBackground && (u.alternatingBackgroundColor || u.alternatingBackgroundColor2) && !0 !== s.alternatingBackground) {
              var T = 0 == _e357 % 2 ? u.alternatingBackgroundColor2 : u.alternatingBackgroundColor;

              if (0 < _e357 && T) {
                var $;
                $ = o ? this.renderer.rect(this.renderer._ptrnd(_.x), w, this.renderer._ptrnd(_.width - 1), S - w, v) : this.renderer.rect(w, this.renderer._ptrnd(_.y), S - w, this.renderer._ptrnd(_.height), v), this.renderer.attr($, {
                  "stroke-width": 0,
                  fill: T,
                  opacity: u.alternatingBackgroundOpacity || 1
                });
              }
            }

            w = S;
          }
        }
      }

      if (v = {
        stroke: p.color || self._getThemeColor("line"),
        "stroke-width": p.width,
        "stroke-dasharray": p.dashStyle || ""
      }, a.tickMarks && p.visible && !0 !== s.tickMarks) {
        var I = p.size;
        var _e358 = p.offsets;
        var D = NaN;

        for (var _a200 = 0; _a200 < _e358.length; _a200++) {
          if (o ? (S = this.renderer._ptrnd(h.y + _e358[_a200].offset), S < h.y - f && (S = this.renderer._ptrnd(h.y)), S > h.y + h.height && (S = h.y + h.height)) : (S = this.renderer._ptrnd(h.x + _e358[_a200].offset), S > h.x + h.width + f && (S = this.renderer._ptrnd(h.x + h.width))), !isNaN(S) && (isNaN(D) || !(2 > n(S - D)))) {
            if (b[S - 1] ? S-- : b[S + 1] && S++, o) {
              if (S > h.y + h.height + f) break;
            } else if (S > h.x + h.width + f) break;

            D = S;
            var A = l.isMirror ? I : -I;

            if (o) {
              var E = h.x + h.width + ("right" === c.position ? g.left : -g.right);
              t || (E = h.x + (l.isMirror ? g.left : -g.right + h.width)), this.renderer.line(E, S, E + A, S, v);
            } else {
              var B = h.y + (l.isMirror ? h.height : 0);
              B += l.isMirror ? -g.bottom : g.top, B = this.renderer._ptrnd(B), this.renderer.line(S, B, S, B - A, v);
            }
          }
        }
      }

      s.tickMarks = s.tickMarks || a.tickMarks, s.gridLines = s.gridLines || a.gridLines, s.alternatingBackground = s.alternatingBackground || a.alternatingBackground;
    }
  }, {
    key: "_calcValueAxisItems",
    value: function _calcValueAxisItems(e, t, a) {
      var n = Math.pow;
      var o = this._stats.seriesGroups[e];
      if (!o || !o.isValid) return !1;

      var i = this.seriesGroups[e],
          r = this._getValueAxis(e),
          l = !1 !== r.valuesOnTicks,
          s = o.intervals,
          d = t / s,
          c = o.min,
          m = o.mu,
          u = !0 === r.logarithmicScale,
          p = r.logarithmicScaleBase || 10,
          g = -1 !== i.type.indexOf("stacked") && -1 !== i.type.indexOf("100");

      for (u && (m = isNaN(r.unitInterval) ? 1 : r.unitInterval), l || (s = Math.max(s - 1, 1)); this._renderData.length < e + 1;) {
        this._renderData.push({});
      }

      this._renderData[e].valueAxis = {};
      var h = this._renderData[e].valueAxis;
      h.itemWidth = h.intervalWidth = d, h.items = [];
      var _ = h.items;

      for (var _r53 = 0, _i315; _r53 <= s; _r53++) {
        if (_i315 = 0, _i315 = u ? g ? o.max / n(p, s - _r53) : c * n(p, _r53) : l ? c + _r53 * m : c + (_r53 + .5) * m, 0 != _r53 % a) {
          _.push(NaN);

          continue;
        }

        _.push(_i315);
      }

      return h.rangeLength = u && !g ? o.intervals : o.intervals * m, !0 !== r.flip && (_ = _.reverse()), !0;
    }
  }, {
    key: "_getDecimalPlaces",
    value: function _getDecimalPlaces(e, t, i) {
      var a = 0;
      isNaN(i) && (i = 10);

      for (var _n158 = 0, _o101; _n158 < e.length; _n158++) {
        if (_o101 = void 0 === t ? e[_n158] : e[_n158][t], isNaN(_o101)) continue;

        var r = _o101.toString();

        for (var _e359 = 0; _e359 < r.length; _e359++) {
          if (("0" > r[_e359] || "9" < r[_e359]) && (a = r.length - (_e359 + 1), 0 <= a)) return Math.min(a, i);
        }

        for (0 < a && (_o101 *= Math.pow(10, a)); Math.round(_o101) !== _o101 && a < i;) {
          a++, _o101 *= 10;
        }
      }

      return a;
    }
  }, {
    key: "_renderValueAxis",
    value: function _renderValueAxis(e, t, i, a) {
      var n = this.seriesGroups[e],
          o = "horizontal" === n.orientation,
          r = this._getValueAxis(e);

      r || this.error(this.localize("missingAxis", {
        index: e,
        axis: "valueAxis"
      }));
      var l = {
        width: 0,
        height: 0
      };
      if (!this._isGroupVisible(e) || this._isPieOnlySeries() || "spider" === n.type) return l;
      var s = !1 !== r.valuesOnTicks,
          d = this._stats.seriesGroups[e],
          c = d.mu,
          m = !0 === r.logarithmicScale,
          u = r.logarithmicScaleBase || 10;
      if (m && (c = isNaN(r.unitInterval) ? 1 : r.unitInterval), 0 === c && (c = 1), isNaN(c)) return l;

      var p = this._getAxisSettings(r),
          g = p.title,
          h = p.labels,
          _ = r.labels || {},
          f = this._get([r.horizontalTextAlignment, _.horizontalAlignment]);

      f || 0 !== h.angle || (h.halign = o ? "center" : "right" === r.position ? "left" : "right");

      var b = this._get([h.step, h.unitInterval / c]);

      if (isNaN(b) && (b = 1), b = Math.max(1, Math.round(b)), !this._calcValueAxisItems(e, o ? t.width : t.height, b) || !p.visible) return l;
      o || (g.angle = this.rightToLeft ? 90 : -90, "centercenter" === g.rotationPoint && ("top" === g.valign ? g.rotationPoint = "rightcenter" : "bottom" === g.valign && (g.rotationPoint = "leftcenter")));

      var y = this._renderData[e].valueAxis,
          v = this._getFormatSettings(h),
          w = -1 !== n.type.indexOf("stacked") && -1 !== n.type.indexOf("100");

      w && !v && (v = {
        sufix: "%"
      }), h.formatFunction || v && null !== v.decimalPlaces && void 0 !== v.decimalPlaces || (v = v || {}, v.decimalPlaces = this._getDecimalPlaces([d.min, d.max, c], void 0, 3));
      var C = p.gridLines,
          x = o ? t.width : t.height,
          S = !0 === r.flip;
      r.flip = !S;
      var D = {
        min: d.min,
        max: d.max,
        logAxis: {
          enabled: !0 === m,
          base: u,
          minPow: d.minPow,
          maxPow: d.maxPow
        }
      };
      (C.visible || r.alternatingBackgroundColor || r.alternatingBackgroundColor2) && (C.offsets = this._getOffsets("gridLines", r, x, D, p, {
        left: 0,
        right: 0
      }, s, c));
      var T = p.tickMarks;
      T.visible && (T.offsets = this._getOffsets("tickMarks", r, x, D, p, {
        left: 0,
        right: 0
      }, s, c));

      var $ = this._getOffsets("labels", r, x, D, p, {
        left: 0,
        right: 0
      }, s, c, !s);

      r.flip = S;
      var I = [],
          A;
      this._elementRenderInfo && this._elementRenderInfo.length > e && (A = this._elementRenderInfo[e].valueAxis);

      for (var _n159 = 0, _o102; _n159 < $.length; _n159++) {
        if (_o102 = $[_n159].value, isNaN($[_n159].offset)) {
          I.push(void 0);
          continue;
        }

        var _e360 = h.formatFunction ? h.formatFunction(_o102) : isNaN(_o102) ? _o102 : this._formatNumber(_o102, v),
            _t302 = {
          key: _o102,
          text: _e360
        };

        A && A.itemOffsets[_o102] && (_t302.x = A.itemOffsets[_o102].x, _t302.y = A.itemOffsets[_o102].y), _t302.targetX = $[_n159].offset, isNaN(_t302.targetX) || I.push(_t302);
      }

      var E = o && "top" === r.position || !o && "right" === r.position || !o && this.rightToLeft && "left" !== r.position,
          B = this._getAnimProps(e),
          L = B.enabled && 500 > I.length ? B.duration : 0;

      return !1 === this.enableAxisTextAnimation && (L = 0), y.settings = p, y.isMirror = E, y.rect = t, this._renderAxis(!o, E, p, t, a, c, m, !0, {
        items: I,
        renderData: y
      }, i, L);
    }
  }, {
    key: "_objectsArraysToArray",
    value: function _objectsArraysToArray(e, t) {
      var a = [];
      if (!Array.isArray(e)) return a;

      for (var _n160 = 0; _n160 < e.length; _n160++) {
        a.push(e[_n160][t]);
      }

      return a;
    }
  }, {
    key: "_arraysToObjectsArray",
    value: function _arraysToObjectsArray(e, t) {
      var a = [];
      if (e.length !== t.length) return a;

      for (var _n161 = 0; _n161 < e.length; _n161++) {
        for (var _i316 = 0; _i316 < e[_n161].length; _i316++) {
          a.length <= _i316 && a.push({}), a[_i316][t[_n161]] = e[_n161][_i316];
        }
      }

      return a;
    }
  }, {
    key: "_valuesToOffsets",
    value: function _valuesToOffsets(e, t, a, n, i, o, r) {
      var l = [];
      if (!t || !Array.isArray(e)) return l;
      var s = a.logAxis.base,
          d = a.logAxis.enabled ? "logarithmic" : "linear",
          c = t.flip,
          m = n,
          u = 0,
          p = 0;
      i && !isNaN(i.left) && (u = i.left), i && !isNaN(i.right) && (p = i.right), m = n - u - p, n = m;

      for (var g = 0, h; g < e.length; g++) {
        h = this._smartPlot.scale(e[g], {
          min: a.min.valueOf(),
          max: a.max.valueOf(),
          type: d,
          base: s
        }, {
          min: 0,
          max: o ? n : m,
          flip: c
        }, {}), isNaN(h) ? l.push(NaN) : (!isNaN(r) && (h += r), h <= n + u + p + 1 ? l.push(this.renderer._ptrnd(h)) : l.push(NaN));
      }

      return l;
    }
  }, {
    key: "_generateIntervalValues",
    value: function _generateIntervalValues(e, t, a, i, n) {
      var o = Math.pow;
      var r = [],
          l = e.min,
          s = e.max;
      if (e.logAxis && e.logAxis.enabled && (l = e.logAxis.minPow, s = e.logAxis.maxPow), void 0 === l || null === l || void 0 === s || null === s) return r;
      if (l === s) return e.logAxis && e.logAxis.enabled ? [o(e.logAxis.base, l)] : [l];
      var d = 1;
      1 > a && (d = 1e6, l *= d, s *= d, a *= d);

      for (var _o103 = l; _o103 <= s; _o103 += a) {
        r.push(_o103 / d + (n ? a / 2 : 0));
      }

      if (t > a) {
        var _e361 = [],
            _n162 = Math.round(t / a);

        for (var _t303 = 0; _t303 < r.length; _t303++) {
          0 == _t303 % _n162 && _e361.push(r[_t303]);
        }

        r = _e361;
      }

      if (e.logAxis && e.logAxis.enabled) for (var _t304 = 0; _t304 < r.length; _t304++) {
        r[_t304] = o(e.logAxis.base, r[_t304]);
      }
      return r;
    }
  }, {
    key: "_generateDTOffsets",
    value: function _generateDTOffsets(e, t, a, i, n, o, r, l, s, d, c) {
      r || (r = "day");
      var m = [];
      if (e > t) return m;
      if (e === t) return d ? m.push({
        offset: l ? a / 2 : i.left,
        value: e
      }) : l && m.push({
        offset: a / 2,
        value: e
      }), m;
      var u = a - i.left - i.right,
          p = e,
          g = i.left,
          h = g;
      o = Math.max(o, 1);
      var _ = o,
          f = Math.min(1, o);

      for (1 < o && "millisecond" !== r && (o = 1); this.renderer._ptrnd(h) <= this.renderer._ptrnd(i.left + u + (l ? 0 : i.right));) {
        m.push({
          offset: h,
          value: p
        });
        var b = new Date(p.valueOf());
        if ("millisecond" === r) b.setMilliseconds(p.getMilliseconds() + o);else if ("second" === r) b.setSeconds(p.getSeconds() + o);else if ("minute" === r) b.setMinutes(p.getMinutes() + o);else if ("hour" === r) {
          var y = b.valueOf();
          b.setHours(p.getHours() + o), y === b.valueOf() && b.setHours(p.getHours() + o + 1);
        } else "day" === r ? b.setDate(p.getDate() + o) : "month" === r ? b.setMonth(p.getMonth() + o) : "year" === r && b.setFullYear(p.getFullYear() + o);
        p = b, h = g + (p.valueOf() - e.valueOf()) * f / (t.valueOf() - e.valueOf()) * u;
      }

      if (c) for (var _e362 = 0; _e362 < m.length; _e362++) {
        m[_e362].offset = a - m[_e362].offset;
      }

      if (1 < _ && "millisecond" !== r) {
        var v = [];

        for (var _e363 = 0; _e363 < m.length; _e363 += _) {
          v.push({
            offset: m[_e363].offset,
            value: m[_e363].value
          });
        }

        m = v;
      }

      if (!l && !d && 1 < m.length) {
        var v = [{
          offset: 0,
          value: void 0
        }];

        for (var _e364 = 1; _e364 < m.length; _e364++) {
          v.push({
            offset: m[_e364 - 1].offset + (m[_e364].offset - m[_e364 - 1].offset) / 2,
            value: void 0
          });
        }

        var w = v.length;
        1 < w ? v.push({
          offset: v[w - 1].offset + (v[w - 1].offset - v[w - 2].offset)
        }) : v.push({
          offset: a,
          value: void 0
        }), m = v;
      }

      if (n > o) {
        var v = [],
            C = Math.round(n / _);

        for (var _e365 = 0; _e365 < m.length; _e365++) {
          0 == _e365 % C && v.push({
            offset: m[_e365].offset,
            value: m[_e365].value
          });
        }

        m = v;
      }

      return m;
    }
  }, {
    key: "_hasStackValueReversal",
    value: function _hasStackValueReversal(e, t) {
      var a = this.seriesGroups[e],
          i = -1 !== a.type.indexOf("stacked");
      if (!i) return !1;

      var n = -1 !== a.type.indexOf("waterfall"),
          o = this._getDataLen(e),
          r = 0,
          l = !1,
          s = [];

      for (var _i317 = 0; _i317 < a.series.length; _i317++) {
        s[_i317] = this._isSerieVisible(e, _i317);
      }

      for (var d = 0, _i318; d < o; d++) {
        _i318 = void 0, n || (l = !1);

        for (var _n163 = 0; _n163 < a.series.length; _n163++) {
          if (!s[_n163]) continue;

          var _o104 = this._getDataValueAsNumber(d, a.series[_n163].dataField, e);

          if (isNaN(_o104)) continue;

          if (a.series[_n163].summary) {
            var _t305 = this._getDataValue(d, a.series[_n163].summary, e);

            if (void 0 !== _t305) continue;
          }

          var c = l ? 0 > _o104 : _o104 < t;
          if (l = !0, void 0 === _i318 && (_i318 = c), c !== _i318) return !0;
          _i318 = c, r += _o104;
        }
      }

      return !1;
    }
  }, {
    key: "_getValueAxis",
    value: function _getValueAxis(e) {
      var t = void 0 === e || null === e ? this.valueAxis : this.seriesGroups[e].valueAxis || this.valueAxis;
      return t || (t = this.valueAxis = {}), t;
    }
  }, {
    key: "_buildStats",
    value: function _buildStats(e) {
      var t = Math.min,
          a = Math.max,
          n = {
        seriesGroups: []
      };
      this._stats = n;

      for (var _U = 0; _U < this.seriesGroups.length; _U++) {
        var o = this.seriesGroups[_U];
        n.seriesGroups[_U] = {};

        var r = this._getXAxis(_U),
            l = this._getValueAxis(_U),
            s = this._getXAxisStats(_U, r, "horizontal" === o.orientation ? e.height : e.width);

        var W = n.seriesGroups[_U];
        W.isValid = !0;
        var i = "horizontal" === o.orientation ? e.width : e.height,
            d = !0 === l.logarithmicScale,
            c = l.logarithmicScaleBase;
        isNaN(c) && (c = 10);
        var m = -1 !== o.type.indexOf("stacked"),
            u = m && -1 !== o.type.indexOf("100"),
            g = -1 !== o.type.indexOf("range"),
            h = -1 !== o.type.indexOf("waterfall");
        h && !this._moduleWaterfall && self.error(self.localize("missingReference", {
          files: "smartchart.waterfall.js"
        })), u && (W.psums = [], W.nsums = []);
        var _ = NaN,
            f = NaN,
            b = NaN,
            y = NaN,
            v = l ? l.baselineValue : NaN;
        isNaN(v) && (v = d && !u ? 1 : 0);
        var w = !1;
        0 !== v && m && (w = this._hasStackValueReversal(_U, v), w && (v = 0)), m && h && (w = this._hasStackValueReversal(_U, v));

        var C = this._getDataLen(_U),
            x = 0,
            S = NaN,
            D = [];

        if (h) for (var _e366 = 0; _e366 < o.series.length; _e366++) {
          D.push(NaN);
        }
        var T = NaN;

        for (var _e367 = 0; _e367 < C && W.isValid; _e367++) {
          if (r.rangeSelector && r.rangeSelector.visible) {
            var $ = r.dataField ? this._getDataValue(_e367, r.dataField, _U) : _e367;
            if ($ && s.isDateTime && ($ = this._castAsDate($, r.dateFormat)), s.useIndeces && ($ = _e367), $ && ($.valueOf() < s.min.valueOf() || $.valueOf() > s.max.valueOf())) continue;
          }

          var I = l.minValue,
              A = l.maxValue;
          l.baselineValue && (I = isNaN(I) ? v : t(v, I), A = isNaN(A) ? v : a(v, A));
          var E = 0,
              B = 0;

          for (var _i319 = 0; o.series && _i319 < o.series.length; _i319++) {
            if (this._isSerieVisible(_U, _i319)) {
              var L = NaN,
                  M = NaN,
                  H = NaN;

              if (-1 !== o.type.indexOf("candle") || -1 !== o.type.indexOf("ohlc")) {
                var k = ["Open", "Low", "Close", "High"];

                for (var z in k) {
                  var P = this._getDataValueAsNumber(_e367, o.series[_i319]["dataField" + k[z]], _U);

                  isNaN(P) || (H = isNaN(M) ? P : t(H, P), M = isNaN(M) ? P : a(M, P));
                }
              } else if (g) {
                var F = this._getDataValueAsNumber(_e367, o.series[_i319].dataFieldFrom, _U),
                    O = this._getDataValueAsNumber(_e367, o.series[_i319].dataFieldTo, _U);

                M = a(F, O), H = t(F, O);
              } else {
                if (L = this._getDataValueAsNumber(_e367, o.series[_i319].dataField, _U), h) {
                  if (this._isSummary(_U, _e367)) {
                    var N = this._getDataValue(_e367, o.series[_i319].summary, _U);

                    if (void 0 !== N) continue;
                  }

                  m ? (!isNaN(T) && (L += T), T = L) : (isNaN(D[_i319]) ? D[_i319] = L : L += D[_i319], D[_i319] = L);
                }

                if (isNaN(L) || d && 0 >= L) continue;
                H = M = L;
              }

              (isNaN(A) || M > A) && (!!isNaN(l.maxValue) || M <= l.maxValue) && (A = M), (isNaN(I) || H < I) && (!!isNaN(l.minValue) || H >= l.minValue) && (I = H), isNaN(L) || !m || h || (L > v ? E += L : L < v && (B += L));
            }
          }

          if (u || (!isNaN(l.maxValue) && (E = t(l.maxValue, E)), !isNaN(l.minValue) && (B = a(l.minValue, B))), d && u) for (var _t306 = 0; _t306 < o.series.length; _t306++) {
            if (!this._isSerieVisible(_U, _t306)) {
              S = .01;
              continue;
            }

            var L = this._getDataValueAsNumber(_e367, o.series[_t306].dataField, _U);

            if (isNaN(L) || 0 >= L) {
              S = .01;
              continue;
            }

            var R = 0 === E ? 0 : L / E;
            (isNaN(S) || R < S) && (S = R);
          }
          var p = E - B;
          x < p && (x = p), u && (W.psums[_e367] = E, W.nsums[_e367] = B), (A > f || isNaN(f)) && (f = A), (I < _ || isNaN(_)) && (_ = I), (E > b || isNaN(b)) && (b = E), (B < y || isNaN(y)) && (y = B);
        }

        u && (b = 0 === b ? 0 : a(b, -y), y = 0 === y ? 0 : t(y, -b)), _ === f && (!isNaN(l.minValue) && isNaN(l.maxValue) ? (_ = l.minValue, f = d ? _ * c : _ + 1) : isNaN(l.minValue) && !isNaN(l.maxValue) && (f = l.maxValue, _ = d ? f / c : f - 1)), _ === f && (0 === _ ? (_ = -1, f = 1) : 0 > _ ? f = 0 : d ? 1 === _ && (_ /= c, f *= c) : _ = 0);
        var V = {
          gmin: _,
          gmax: f,
          gsumP: b,
          gsumN: y,
          gbase: v,
          isLogAxis: d,
          logBase: c,
          minPercent: S,
          gMaxRange: x,
          isStacked: m,
          isStacked100: u,
          isWaterfall: h,
          hasStackValueReversal: w,
          valueAxis: l,
          valueAxisSize: i
        };
        V.isStacked && (0 > V.gsumN && (V.gmin = t(V.gmin, V.gbase + V.gsumN)), 0 < V.gsumP && (V.gmax = a(V.gmax, V.gbase + V.gsumP))), W.context = V;
      }

      this._mergeCommonValueAxisStats();

      for (var _t307 = 0, _i320; _t307 < n.seriesGroups.length; _t307++) {
        if (_i320 = n.seriesGroups[_t307], _i320.isValid) {
          var U = this._calcOutputGroupStats(_i320.context);

          for (var _e368 in U) {
            _i320[_e368] = U[_e368];
          }

          delete _i320.context;
        }
      }
    }
  }, {
    key: "_mergeCommonValueAxisStats",
    value: function _mergeCommonValueAxisStats() {
      var e = {};

      for (var _t308 = 0; _t308 < this.seriesGroups.length; _t308++) {
        if (!this._isGroupVisible(_t308)) continue;
        if (this.seriesGroups[_t308].valueAxis) continue;
        var _i321 = this._stats.seriesGroups[_t308].context;
        e.gbase = _i321.gbase, (isNaN(e.gmin) || _i321.gmin < e.gmin) && (e.gmin = _i321.gmin), (isNaN(e.gmax) || _i321.gmax > e.gmax) && (e.gmax = _i321.gmax), (isNaN(e.gsumP) || _i321.gsumP > e.gsumP) && (e.gsumP = _i321.gsumP), (isNaN(e.gsumN) || _i321.gsumN < e.gsumN) && (e.gsumN = _i321.gsumN), (isNaN(e.logBase) || _i321.logBase < e.logBase) && (e.logBase = _i321.logBase), (isNaN(e.minPercent) || _i321.minPercent < e.minPercent) && (e.minPercent = _i321.minPercent), 0 < e.gsumN && (e.gmin = Math.min(e.gmin, e.gbase + e.gsumN)), 0 < e.gsumP && (e.gmax = Math.max(e.gmax, e.gbase + e.gsumP));
      }

      for (var _t309 = 0; _t309 < this.seriesGroups.length; _t309++) {
        if (this.seriesGroups[_t309].valueAxis) continue;
        var _i322 = this._stats.seriesGroups[_t309].context;

        for (var _t310 in e) {
          _i322[_t310] = e[_t310];
        }
      }
    }
  }, {
    key: "_calcOutputGroupStats",
    value: function _calcOutputGroupStats(e) {
      var t = Math.pow,
          i = Math.max;
      var a = e.gmin,
          n = e.gmax,
          o = e.gsumP,
          r = e.gsumN,
          l = e.gbase,
          s = e.isLogAxis,
          d = e.logBase,
          c = e.minPercent,
          m = e.gMaxRange,
          u = e.isStacked,
          p = e.isStacked100,
          g = e.isWaterfall,
          h = e.hasStackValueReversal,
          _ = e.valueAxis,
          f = e.valueAxisSize,
          b = e.valueAxis.unitInterval;
      b || (b = this._calcInterval(a, n, i(f / 80, 2))), a === n && (a = l, n = 2 * n);
      var y = NaN,
          v = 0,
          w = 0;

      if (s) {
        if (p) {
          y = 0;
          var _e369 = 1;

          for (v = w = this._draw.log(100, d); _e369 > c;) {
            _e369 /= d, v--, y++;
          }

          a = t(d, v);
        } else u && !g && (n = i(n, o)), w = this.renderer._rnd(this._draw.log(n, d), 1, !0), n = t(d, w), v = this.renderer._rnd(this._draw.log(a, d), 1, !1), a = t(d, v);

        b = d;
      }

      a < r && (r = a), n > o && (o = n);
      var C = a,
          x = n;
      if (s || 0 == Math.abs(x - C) % b || (C = this.renderer._rnd(a, b, !1), x = this.renderer._rnd(n, b, !0)), p && 100 < x && (x = 100), p && !s && (x = 0 < x ? 100 : 0, C = 0 > C ? -100 : 0, b = _.unitInterval, (isNaN(b) || 0 >= b || 100 <= b) && (b = 10), 0 != 100 % b)) for (; 1 <= b && 0 != 100 % b; b--) {
        ;
      }
      if (isNaN(x) || isNaN(C) || isNaN(b)) return {};
      if (isNaN(y) && (y = parseInt(((x - C) / (0 === b ? 1 : b)).toFixed())), s && !p && (y = w - v, m = t(d, y)), 1 > y) return {};
      var S = {
        min: C,
        max: x,
        logarithmic: s,
        logBase: d,
        base: s ? C : l,
        minPow: v,
        maxPow: w,
        sumP: o,
        sumN: r,
        mu: b,
        maxRange: m,
        intervals: y,
        hasStackValueReversal: h
      };
      return S;
    }
  }, {
    key: "_getDataLen",
    value: function _getDataLen(e) {
      var t = this.dataSource;
      return void 0 !== e && null !== e && -1 !== e && this.seriesGroups[e].dataSource && (t = this.seriesGroups[e].dataSource), t ? t.length : 0;
    }
  }, {
    key: "_getDataValue",
    value: function _getDataValue(e, t, i) {
      var a = this.dataSource;
      return void 0 !== i && null !== i && -1 !== i && (a = this.seriesGroups[i].dataSource || a), !a || 0 > e || e > a.length - 1 ? void 0 : "function" == typeof t ? t(e, a) : t && "" !== t ? a[e][t] : a[e];
    }
  }, {
    key: "_getDataValueAsNumber",
    value: function _getDataValueAsNumber(e, t, i) {
      var a = this._getDataValue(e, t, i);

      return this._isDate(a) ? a.valueOf() : ("number" != typeof a && (a = parseFloat(a)), "number" != typeof a && (a = void 0), a);
    }
  }, {
    key: "_isPieGroup",
    value: function _isPieGroup(e) {
      var t = this.seriesGroups[e];
      return !!(t && t.type) && (-1 !== t.type.indexOf("pie") || -1 !== t.type.indexOf("donut"));
    }
  }, {
    key: "_renderPieSeries",
    value: function _renderPieSeries(e, t) {
      var _this9 = this;

      var a = this._getDataLen(e),
          i = this.seriesGroups[e],
          n = this._calcGroupOffsets(e, t).offsets;

      var _loop20 = function _loop20(_r54, _o105) {
        if (_r54 = i.series[_o105], _r54.customDraw) {
          r = _r54;
          return "continue";
        }

        var l = _this9._getSerieSettings(e, _o105),
            s = _this9._getAnimProps(e, _o105),
            d = s.enabled && 5e3 > a && !_this9._isToggleRefresh && s.duration;

        _this9._isTouchDevice && _this9.renderer instanceof Smart.Utilities.HTML5Renderer && (d = 0);

        var c = _this9._get([_r54.minAngle, _r54.startAngle]);

        (isNaN(c) || 0 > c || 360 < c) && (c = 0);

        var m = _this9._get([_r54.maxAngle, _r54.endAngle]);

        (isNaN(m) || 0 > m || 360 < m) && (m = 360);
        var u = {
          rect: t,
          minAngle: c,
          maxAngle: m,
          groupIndex: e,
          serieIndex: _o105,
          settings: l,
          items: []
        };

        for (var _t311 = 0, _i323; _t311 < a; _t311++) {
          if (_i323 = n[_o105][_t311], !_i323.visible) continue;

          var _a201 = _i323.fromAngle,
              _r55 = _i323.toAngle,
              _l48 = _this9.renderer.pieslice(_i323.x, _i323.y, _i323.innerRadius, _i323.outerRadius, _a201, 0 === d ? _r55 : _a201, _i323.centerOffset);

          _this9._setRenderInfo(e, _o105, _t311, {
            element: _l48
          });

          var _s39 = {
            displayValue: _i323.displayValue,
            itemIndex: _t311,
            visible: _i323.visible,
            x: _i323.x,
            y: _i323.y,
            innerRadius: _i323.innerRadius,
            outerRadius: _i323.outerRadius,
            fromAngle: _a201,
            toAngle: _r55,
            centerOffset: _i323.centerOffset
          };
          u.items.push(_s39);
        }

        _this9._animatePieSlices(u, 0);

        var p = _this9;

        _this9._enqueueAnimation("series", void 0, void 0, d, function (e, t, i) {
          p._animatePieSlices(t, i);
        }, u);

        r = _r54;
      };

      for (var _o105 = 0, r; _o105 < i.series.length; _o105++) {
        var _ret7 = _loop20(r, _o105);

        if (_ret7 === "continue") continue;
      }
    }
  }, {
    key: "_sliceSortFunction",
    value: function _sliceSortFunction(e, t) {
      return e.fromAngle - t.fromAngle;
    }
  }, {
    key: "_animatePieSlices",
    value: function _animatePieSlices(e, t) {
      var a;
      this._elementRenderInfo && this._elementRenderInfo.length > e.groupIndex && this._elementRenderInfo[e.groupIndex].series && this._elementRenderInfo[e.groupIndex].series.length > e.serieIndex && (a = this._elementRenderInfo[e.groupIndex].series[e.serieIndex]);

      var n = this._getLabelsSettings(e.groupIndex, e.serieIndex, NaN),
          o = n.visible,
          r = [];

      for (var _n164 = 0; _n164 < e.items.length; _n164++) {
        var _o106 = e.items[_n164];
        if (!_o106.visible) continue;
        var _d21 = _o106.fromAngle;
        var l = _o106.fromAngle + t * (_o106.toAngle - _o106.fromAngle);

        if (a && a[_o106.displayValue]) {
          var i = a[_o106.displayValue].fromAngle,
              s = a[_o106.displayValue].toAngle;
          _d21 = i + (_d21 - i) * t, l = s + (l - s) * t;
        }

        r.push({
          index: _n164,
          from: _d21,
          to: l
        });
      }

      a && r.sort(this._sliceSortFunction);
      var d = NaN;

      for (var _s40 = 0; _s40 < r.length; _s40++) {
        var _i324 = e.items[r[_s40].index];

        var c = this._getRenderInfo(e.groupIndex, e.serieIndex, _i324.itemIndex);

        var g = r[_s40].from;
        var l = r[_s40].to;
        a && (!isNaN(d) && g > d && (g = d), d = l, _s40 == r.length - 1 && l !== r[0].from && (l = e.maxAngle + r[0].from));
        var m = this.renderer.pieSlicePath(_i324.x, _i324.y, _i324.innerRadius, _i324.outerRadius, g, l, _i324.centerOffset);
        this.renderer.attr(c.element, {
          d: m
        });

        var u = this._getColors(e.groupIndex, e.serieIndex, _i324.itemIndex, "radialGradient", _i324.outerRadius),
            p = e.settings;

        c.colors = u, c.settings = p, this.renderer.attr(c.element, {
          fill: u.fillColor,
          stroke: u.lineColor,
          "stroke-width": p.stroke,
          "fill-opacity": p.opacity,
          "stroke-opacity": p.opacity,
          "stroke-dasharray": "none"
        }), o && this._showPieLabel(e.groupIndex, e.serieIndex, _i324.itemIndex, n, void 0, c.colors.lineColor), 1 === t && this._installHandlers(c.element, "pieslice", e.groupIndex, e.serieIndex, _i324.itemIndex);
      }
    }
  }, {
    key: "_showPieLabel",
    value: function _showPieLabel(e, t, i, a, n) {
      var o = Math.pow;
      var r = this._renderData[e].offsets[t][i];
      if (r.elementInfo.labelElement && this.renderer.removeElement(r.elementInfo.labelElement), a || (a = this._getLabelsSettings(e, t, NaN)), !a.visible) return;
      var l = r.fromAngle,
          d = r.toAngle,
          c = Math.abs(l - d);
      360 < c && (l = 0, d = 360);
      var m = c / 2 + l;
      m %= 360;
      var u = 2 * (m * Math.PI) / 360,
          p;
      !0 === a.autoRotate && (p = 90 > m || 270 < m ? 360 - m : 180 - m);

      var h = a.linesEnabled,
          _ = this._showLabel(e, t, i, {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, "center", "center", !0, !1, !1, p),
          f = a.radius || r.outerRadius + Math.max(_.width, _.height);

      this._isPercent(f) && (f = parseFloat(f) / 100 * Math.min(this._plotRect.width, this._plotRect.height) / 2), f += r.centerOffset, isNaN(n) && (n = 0), f += n;

      var b = this.seriesGroups[e],
          g = b.series[t],
          s = this._draw.getNum([g.offsetX, b.offsetX, this._plotRect.width / 2]),
          y = this._draw.getNum([g.offsetY, b.offsetY, this._plotRect.height / 2]),
          v = this._plotRect.x + s,
          w = this._plotRect.y + y,
          C = this._adjustTextBoxPosition(v, w, _, f, m, r.outerRadius > f, !1 !== a.linesAngles, !0 === a.autoRotate);

      var x = {},
          S = C.x < v ? 0 : _.width / 2,
          D = Math.sqrt(o(C.x - v, 2) + o(C.y - w, 2)) + S < r.outerRadius ? arguments[5] : void 0;

      if (r.elementInfo.labelElement = this._showLabel(e, t, i, {
        x: C.x,
        y: C.y,
        width: _.width,
        height: _.height
      }, "left", "top", !1, !1, !1, p, x, D), f > r.outerRadius + n + 5 && !1 !== h) {
        var _e370 = {
          lineColor: r.elementInfo.colors.lineColor,
          stroke: r.elementInfo.settings.stroke,
          opacity: r.elementInfo.settings.opacity,
          dashStyle: r.elementInfo.settings.dashStyle
        };
        r.elementInfo.labelArrowPath = this._updateLebelArrowPath(r.elementInfo.labelArrowPath, v, w, f, r.outerRadius + n, u, !1 !== a.linesAngles, _e370, x);
      }
    }
  }, {
    key: "_updateLebelArrowPath",
    value: function _updateLebelArrowPath(e, t, i, a, n, o, r, l, s) {
      var d = Math.abs,
          c = Math.sin,
          m = Math.cos;
      var u = this.renderer;

      var p = u._ptrnd(t + (a - 0) * m(o)),
          g = u._ptrnd(i - (a - 0) * c(o)),
          h = u._ptrnd(t + (n + 2) * m(o)),
          _ = u._ptrnd(i - (n + 2) * c(o)),
          f = [];

      f.push({
        x: s.x + s.width / 2,
        y: s.y
      }), f.push({
        x: s.x + s.width / 2,
        y: s.y + s.height
      }), f.push({
        x: s.x,
        y: s.y + s.height / 2
      }), f.push({
        x: s.x + s.width,
        y: s.y + s.height / 2
      }), r || (f.push({
        x: s.x,
        y: s.y
      }), f.push({
        x: s.x + s.width,
        y: s.y
      }), f.push({
        x: s.x + s.width,
        y: s.y + s.height
      }), f.push({
        x: s.x,
        y: s.y + s.height
      })), f = f.sort(function (e, a) {
        return u._ptdist(e.x, e.y, t, i) - u._ptdist(a.x, a.y, t, i);
      }), f = f.sort(function (e, a) {
        return d(e.x - t) + d(e.y - i) - (d(a.x - t) + d(a.y - i));
      });

      for (var _d22 = 0; _d22 < f.length; _d22++) {
        f[_d22].x = u._ptrnd(f[_d22].x), f[_d22].y = u._ptrnd(f[_d22].y);
      }

      p = f[0].x, g = f[0].y;
      var b = "M " + p + "," + g + " L" + h + "," + _;
      return r && (b = "M " + p + "," + g + " L" + h + "," + g + " L" + h + "," + _), e ? u.attr(e, {
        d: b
      }) : e = u.path(b, {}), u.attr(e, {
        fill: "none",
        stroke: l.lineColor,
        "stroke-width": l.stroke,
        "stroke-opacity": l.opacity,
        "stroke-dasharray": "none"
      }), e;
    }
  }, {
    key: "_adjustTextBoxPosition",
    value: function _adjustTextBoxPosition(e, t, i, n, a, o, r, l) {
      var s = Math.sin,
          d = Math.cos,
          c = Math.PI;

      var m = 2 * (a * c) / 360,
          u = this.renderer._ptrnd(e + n * d(m)),
          p = this.renderer._ptrnd(t - n * s(m));

      if (l) {
        var _o107 = i.width,
            _r56 = i.height,
            _l49 = Math.atan(_r56 / _o107) % (2 * c),
            _u3 = m % (2 * c),
            _a202 = 0;

        _u3 <= _l49 ? _a202 = _o107 / 2 * d(m) : _u3 >= _l49 && _u3 < c - _l49 ? _a202 = _r56 / 2 * s(m) : _u3 >= c - _l49 && _u3 < c + _l49 ? _a202 = _o107 / 2 * d(m) : _u3 >= c + _l49 && _u3 < 2 * c - _l49 ? _a202 = _r56 / 2 * s(m) : _u3 >= 2 * c - _l49 && _u3 < 2 * c && (_a202 = _o107 / 2 * d(m)), n += Math.abs(_a202) + 3;

        var _p4 = this.renderer._ptrnd(e + n * d(m)),
            g = this.renderer._ptrnd(t - n * s(m));

        return _p4 -= i.width / 2, g -= i.height / 2, {
          x: _p4,
          y: g
        };
      }

      return o ? (u -= i.width / 2, p -= i.height / 2) : r ? 90 <= a && 270 > a ? (p -= i.height / 2, u -= i.width) : p -= i.height / 2 : 0 <= a && 45 > a || 315 <= a && 360 > a ? p -= i.height / 2 : 45 <= a && 135 > a ? (p -= i.height, u -= i.width / 2) : 135 <= a && 225 > a ? (p -= i.height / 2, u -= i.width) : 225 <= a && 315 > a && (u -= i.width / 2), {
        x: u,
        y: p
      };
    }
  }, {
    key: "_isColumnType",
    value: function _isColumnType(e) {
      return -1 !== e.indexOf("column") || -1 !== e.indexOf("waterfall");
    }
  }, {
    key: "_getColumnGroupsCount",
    value: function _getColumnGroupsCount(e) {
      var t = 0;
      e = e || "vertical";
      var a = this.seriesGroups;

      for (var _n165 = 0, _i325; _n165 < a.length; _n165++) {
        _i325 = a[_n165].orientation || "vertical", this._isColumnType(a[_n165].type) && _i325 === e && t++;
      }

      return this.columnSeriesOverlap && (t = 1), t;
    }
  }, {
    key: "_getColumnGroupIndex",
    value: function _getColumnGroupIndex(e) {
      var t = 0,
          a = this.seriesGroups[e].orientation || "vertical";

      for (var _n166 = 0; _n166 < e; _n166++) {
        var _e371 = this.seriesGroups[_n166],
            _i326 = _e371.orientation || "vertical";

        this._isColumnType(_e371.type) && _i326 === a && t++;
      }

      return t;
    }
  }, {
    key: "_renderAxisBands",
    value: function _renderAxisBands(e, t, a) {
      var i = Math.min,
          n = Math.round,
          o = Math.sin,
          r = Math.cos,
          l = Math.PI,
          s = a ? this._getXAxis(e) : this._getValueAxis(e),
          d = this.seriesGroups[e],
          c = a ? void 0 : d.bands;

      if (!c) {
        for (var _t312 = 0; _t312 < e; _t312++) {
          var m = a ? this._getXAxis(_t312) : this._getValueAxis(_t312);
          if (m === s) return;
        }

        c = s.bands;
      }

      if (Array.isArray(c)) {
        var u = t,
            p = "horizontal" === d.orientation;
        p && (u = {
          x: t.y,
          y: t.x,
          width: t.height,
          height: t.width
        }), this._calcGroupOffsets(e, u);

        for (var _s41 = 0; _s41 < c.length; _s41++) {
          var g = c[_s41],
              h = g.minValue,
              _ = g.maxValue,
              f = a ? this.getXAxisDataPointOffset(h, e) : this.getValueAxisDataPointOffset(h, e),
              b = a ? this.getXAxisDataPointOffset(_, e) : this.getValueAxisDataPointOffset(_, e);

          if (!(isNaN(f) || isNaN(b))) {
            var y = Math.abs(f - b),
                v;

            if (d.polar || d.spider) {
              var w = this._renderData[e],
                  C = w.polarCoords;

              if (!a) {
                var x = this._toPolarCoord(C, t, t.x, w.baseOffset),
                    S = this._toPolarCoord(C, t, t.x, f),
                    D = this._toPolarCoord(C, t, t.x, b),
                    T = this.renderer._ptdist(x.x, x.y, S.x, S.y),
                    $ = this.renderer._ptdist(x.x, x.y, D.x, D.y),
                    I = n(360 * -C.startAngle / (2 * l)),
                    A = n(360 * -C.endAngle / (2 * l));

                if (I > A) {
                  var _e372 = I;
                  I = A, A = _e372;
                }

                if (d.spider) {
                  var E = w.xAxis.offsetAngles;
                  var _e373 = "";
                  var B = [$, T],
                      L = E;

                  for (var M in C.isClosedCircle && (L = E.slice(0), L.push(L[0])), B) {
                    for (var _t313 = 0; _t313 < L.length; _t313++) {
                      var H = 0 === M ? _t313 : E.length - _t313 - 1,
                          k = C.x + B[M] * r(L[H]),
                          z = C.y + B[M] * o(L[H]);
                      _e373 += "" == _e373 ? "M " : " L", _e373 += this.renderer._ptrnd(k) + "," + this.renderer._ptrnd(z);
                    }

                    if (0 === M) {
                      var k = C.x + B[1] * r(L[H]),
                          z = C.y + B[1] * o(L[H]);
                      _e373 += " L" + this.renderer._ptrnd(k) + "," + this.renderer._ptrnd(z);
                    }
                  }

                  _e373 += " Z", v = this.renderer.path(_e373);
                } else v = this.renderer.pieslice(C.x, C.y, T, $, I, A);
              } else if (d.spider) {
                var _t314 = this.getPolarDataPointOffset(h, this._stats.seriesGroups[e].max, e),
                    _i327 = this.getPolarDataPointOffset(_, this._stats.seriesGroups[e].max, e);

                var _a203 = "M " + C.x + "," + C.y;

                _a203 += " L " + _t314.x + "," + _t314.y, _a203 += " L " + _i327.x + "," + _i327.y, v = this.renderer.path(_a203);
              } else {
                var P = {},
                    F = {
                  x: i(f, b),
                  y: t.y,
                  width: y,
                  height: t.height
                };
                this._columnAsPieSlice(P, t, C, F), v = P.element;
              }
            } else {
              var O = {
                x: i(f, b),
                y: u.y,
                width: y,
                height: u.height
              };

              if (a || (O = {
                x: u.x,
                y: i(f, b),
                width: u.width,
                height: y
              }), p) {
                var _e374 = O.x;
                O.x = O.y, O.y = _e374, _e374 = O.width, O.width = O.height, O.height = _e374;
              }

              v = 0 === y || 1 === y ? this.renderer.line(this.renderer._ptrnd(O.x), this.renderer._ptrnd(O.y), this.renderer._ptrnd(O.x + (p ? 0 : O.width)), this.renderer._ptrnd(O.y + (p ? O.height : 0))) : this.renderer.rect(O.x, O.y, O.width, O.height);
            }

            var N = g.color || this._getThemeColor("band"),
                R = g.lineColor || N,
                V = g.lineWidth;

            isNaN(V) && (V = 1);
            var U = g.opacity;
            (isNaN(U) || 0 > U || 1 < U) && (U = 1), this.renderer.attr(v, {
              fill: N,
              "fill-opacity": U,
              stroke: R,
              "stroke-opacity": U,
              "stroke-width": V,
              "stroke-dasharray": g.dashStyle
            });
          }
        }
      }
    }
  }, {
    key: "_getColumnGroupWidth",
    value: function _getColumnGroupWidth(e, t, i) {
      var a = Math.max;

      var n = this.seriesGroups[e],
          o = -1 !== n.type.indexOf("stacked"),
          r = this._getColumnGroupsCount(n.orientation);

      (isNaN(r) || 0 === r) && (r = 1);
      var l = 1 <= t.rangeLength ? t.itemWidth : .9 * i,
          s = n.columnsMinWidth;
      isNaN(s) && (s = 1), isNaN(n.columnsMaxWidth) || (s = Math.min(n.columnsMaxWidth, s)), s > l && 0 < t.length && (l = a(l, .9 * i / t.length));
      var d = s;

      if (!o) {
        var _e375 = n.seriesGapPercent;
        (isNaN(_e375) || 0 > _e375) && (_e375 = 10), _e375 /= 100;
        var _t315 = s;
        _t315 *= 1 + _e375, d += n.series.length * _t315;
      }

      var c = a(l / r, d);
      return {
        requiredWidth: d,
        availableWidth: l,
        targetWidth: c
      };
    }
  }, {
    key: "_getColumnSerieWidthAndOffset",
    value: function _getColumnSerieWidthAndOffset(e, t) {
      var i = Math.round,
          a = Math.max;
      var n = this.seriesGroups[e],
          o = "horizontal" === n.orientation,
          r = this._plotRect;
      o && (r = {
        x: r.y,
        y: r.x,
        width: r.height,
        height: r.width
      });

      var l = this._calcGroupOffsets(e, r);

      if (!l || 0 === l.xoffsets.length) return;

      var s = this._getColumnGroupsCount(n.orientation);

      ("candlestick" === n.type || "ohlc" === n.type) && (s = 1);

      var d = this._getColumnGroupIndex(e),
          c = this._getColumnGroupWidth(e, l.xoffsets, o ? r.height : r.width),
          m = 0,
          u = c.targetWidth;

      (!0 === this.columnSeriesOverlap || i(u) > i(c.availableWidth / s)) && (s = 1, d = 0), m -= u * s / 2, m += u * d;
      var p = n.columnsGapPercent;
      0 >= p && (p = 0), (isNaN(p) || 100 <= p) && (p = 25), p /= 100;
      var g = u * p;
      g + c.requiredWidth > c.targetWidth && (g = a(0, c.targetWidth - c.requiredWidth)), i(u) > i(c.availableWidth) && (g = 0), u -= g, m += g / 2;
      var h = n.seriesGapPercent;
      (isNaN(h) || 0 > h) && (h = 10);

      var _ = -1 !== n.type.indexOf("stacked"),
          f = u;

      _ || (f /= n.series.length);

      var b = this._get([n.seriesGap, u * h / 100 / (n.series.length - 1)]);

      (!0 === n.polar || !0 === n.spider || _ || 1 >= n.series.length) && (b = 0);
      var y = b * (n.series.length - 1);
      1 < n.series.length && y > u - 1 * n.series.length && (y = u - 1 * n.series.length, b = y / a(1, n.series.length - 1));
      var v = f - y / n.series.length,
          w = 0,
          C = n.columnsMaxWidth;
      !isNaN(C) && v > C && (w = v - C, v = C);
      var x = 0;

      if (!_) {
        var _e376 = (u - v * n.series.length - y) / 2,
            _i328 = a(0, t);

        x = _e376 + v * t + _i328 * b;
      } else x = w / 2;

      return {
        width: v,
        offset: m + x
      };
    }
  }, {
    key: "_renderColumnSeries",
    value: function _renderColumnSeries(e, t) {
      var i = this.seriesGroups[e];
      if (!i.series || 0 === i.series.length) return;
      var a = "horizontal" === i.orientation,
          n = t;
      a && (n = {
        x: t.y,
        y: t.x,
        width: t.height,
        height: t.width
      });

      var o = this._calcGroupOffsets(e, n);

      if (!o || 0 === o.xoffsets.length) return;
      var r;
      (!0 === i.polar || !0 === i.spider) && (r = this._getPolarAxisCoords(e, n));

      var l = {
        groupIndex: e,
        rect: t,
        vertical: !a,
        seriesCtx: [],
        renderData: o,
        polarAxisCoords: r,
        columnGroupWidth: this._getColumnGroupWidth(e, o.xoffsets, a ? n.height : n.width)
      },
          s = this._getGroupGradientType(e),
          d;

      for (var _a204 = 0, _n167; _a204 < i.series.length; _a204++) {
        if (_n167 = i.series[_a204], _n167.customDraw) continue;

        var _t316 = this._getAnimProps(e, _a204);

        d = _t316.enabled && !this._isToggleRefresh && 100 > o.xoffsets.length ? _t316.duration : 0;

        var _s42 = this._getColumnSerieWidthAndOffset(e, _a204),
            _c9 = this._isSerieVisible(e, _a204),
            m = this._getSerieSettings(e, _a204),
            u = this._getColors(e, _a204, NaN, this._getGroupGradientType(e), 4),
            p = [];

        if ("function" == typeof _n167.colorFunction && !r) for (var _t317 = o.xoffsets.first; _t317 <= o.xoffsets.last; _t317++) {
          p.push(this._getColors(e, _a204, _t317, _s42, 4));
        }
        var g = {
          seriesIndex: _a204,
          serieColors: u,
          itemsColors: p,
          settings: m,
          columnWidth: _s42.width,
          xAdjust: _s42.offset,
          isVisible: _c9
        };
        l.seriesCtx.push(g);
      }

      this._animColumns(l, 0 === d ? 1 : 0);

      var c = this;

      this._enqueueAnimation("series", void 0, void 0, d, function (e, t, i) {
        c._animColumns(t, i);
      }, l);
    }
  }, {
    key: "_getPercent",
    value: function _getPercent(e, t, i, a) {
      return isNaN(e) && (e = t), isNaN(i) || isNaN(e) || !(e < i) || (e = i), isNaN(a) || isNaN(e) || !(e > a) || (e = a), isNaN(e) ? NaN : e;
    }
  }, {
    key: "_getColumnVOffsets",
    value: function _getColumnVOffsets(e, t, a, i, n, o) {
      var r = Math.min,
          l = Math.abs,
          s = Math.max,
          d = this.seriesGroups[t],
          c = this._getPercent(d.columnsTopWidthPercent, 100, 0, 100),
          m = this._getPercent(d.columnsBottomWidthPercent, 100, 0, 100);

      0 === c && 0 === m && (m = 100);
      var u = this._getPercent(d.columnsNeckHeightPercent, NaN, 0, 100) / 100,
          p = this._getPercent(d.columnsNeckWidthPercent, 100, 0, 100) / 100,
          g = [],
          h = NaN;

      for (var _r57 = 0; _r57 < a.length; _r57++) {
        var _ = a[_r57],
            f = _.seriesIndex,
            b = e.offsets[f][i].from,
            y = e.offsets[f][i].to,
            v = e.xoffsets.data[i],
            w = _.isVisible,
            C;
        w || (y = b);
        var x = this._elementRenderInfo;

        if (w && x && x.length > t && x[t].series.length > f) {
          var S = e.xoffsets.xvalues[i];
          C = x[t].series[f][S], !C || isNaN(C.from) || isNaN(C.to) || (b = C.from + (b - C.from) * o, y = C.to + (y - C.to) * o, v = C.xoffset + (v - C.xoffset) * o);
        }

        C || (y = b + (y - b) * (n ? 1 : o)), isNaN(b) && (b = isNaN(h) ? e.baseOffset : h), h = !isNaN(y) && n ? y : b, isNaN(y) && (y = b);
        var D = {
          from: b,
          to: y,
          xOffset: v
        };
        (100 !== c || 100 !== m) && (D.funnel = !0, D.toWidthPercent = c, D.fromWidthPercent = m), g.push(D);
      }

      if (n && 1 < g.length && !(this._elementRenderInfo && this._elementRenderInfo.length > t)) {
        var T = 0,
            $ = 0,
            I = -Infinity,
            A = 1 / 0,
            E = 1 / 0,
            B = -Infinity;

        for (var _e377 = 0; _e377 < g.length; _e377++) {
          var _ = a[_e377];
          _.isVisible && (g[_e377].to >= g[_e377].from ? ($ += g[_e377].to - g[_e377].from, E = r(E, g[_e377].from), B = s(B, g[_e377].to)) : (T += g[_e377].from - g[_e377].to, I = s(I, g[_e377].from), A = r(A, g[_e377].to)));
        }

        var L = T,
            M = $;
        T *= o, $ *= o;
        var H = 0,
            k = 0;

        for (var _e378 = 0; _e378 < g.length; _e378++) {
          if (g[_e378].to >= g[_e378].from) {
            var _t318 = g[_e378].to - g[_e378].from;

            _t318 + k > $ && (_t318 = s(0, $ - k), g[_e378].to = g[_e378].from + _t318), (100 !== c || 100 !== m) && (g[_e378].funnel = !0, g[_e378].fromWidthPercent = !isNaN(u) && M * u >= k ? 100 * p : l(g[_e378].from - E) / M * (c - m) + m, g[_e378].toWidthPercent = !isNaN(u) && M * u >= 0 + (k + _t318) ? 100 * p : l(g[_e378].to - E) / M * (c - m) + m), k += _t318;
          } else {
            var _t319 = g[_e378].from - g[_e378].to;

            _t319 + H > T && (_t319 = s(0, T - H), g[_e378].to = g[_e378].from - _t319), (100 !== c || 100 !== m) && (g[_e378].funnel = !0, g[_e378].fromWidthPercent = !isNaN(u) && L * u >= H ? 100 * p : l(g[_e378].from - I) / L * (c - m) + m, g[_e378].toWidthPercent = !isNaN(u) && L * u >= 0 + (H + _t319) ? 100 * p : l(g[_e378].to - I) / L * (c - m) + m), H += _t319;
          }
        }
      }

      return g;
    }
  }, {
    key: "_columnAsPieSlice",
    value: function _columnAsPieSlice(e, t, i, a) {
      var n = Math.PI;

      var o = this._toPolarCoord(i, t, a.x, a.y),
          r = this._toPolarCoord(i, t, a.x, a.y + a.height),
          l = this.renderer._ptdist(i.x, i.y, r.x, r.y),
          s = this.renderer._ptdist(i.x, i.y, o.x, o.y),
          d = t.width,
          c = 180 * Math.abs(i.startAngle - i.endAngle) / n,
          m = -((a.x - t.x) * c) / d,
          u = -((a.x + a.width - t.x) * c) / d,
          p = i.startAngle;

      if (p = 360 * p / (2 * n), m -= p, u -= p, e) if (void 0 !== e.element && null !== e.element) {
        var _t320 = this.renderer.pieSlicePath(i.x, i.y, l, s, u, m, 0);

        _t320 += " Z", this.renderer.attr(e.element, {
          d: _t320
        });
      } else e.element = this.renderer.pieslice(i.x, i.y, l, s, u, m, 0);
      return {
        fromAngle: u,
        toAngle: m,
        innerRadius: l,
        outerRadius: s
      };
    }
  }, {
    key: "_setRenderInfo",
    value: function _setRenderInfo(e, t, i, a) {
      this._renderData[e].offsets[t][i].elementInfo = a;
    }
  }, {
    key: "_getRenderInfo",
    value: function _getRenderInfo(e, t, i) {
      return this._renderData[e].offsets[t][i].elementInfo || {};
    }
  }, {
    key: "_animColumns",
    value: function _animColumns(e, t) {
      var a = Math.abs,
          n = this,
          o = e.groupIndex,
          r = this.seriesGroups[o],
          l = e.renderData,
          s = -1 !== r.type.indexOf("waterfall"),
          i = this._getXAxis(o),
          d = -1 !== r.type.indexOf("stacked"),
          c = e.polarAxisCoords,
          m = -1;

      for (var _i329 = 0; _i329 < r.series.length; _i329++) {
        if (this._isSerieVisible(o, _i329)) {
          m = _i329;
          break;
        }
      }

      var u = NaN,
          p = NaN;

      for (var _i330 = 0; _i330 < e.seriesCtx.length; _i330++) {
        var g = e.seriesCtx[_i330];
        (isNaN(u) || u > g.xAdjust) && (u = g.xAdjust), (isNaN(p) || p < g.xAdjust + g.columnWidth) && (p = g.xAdjust + g.columnWidth);
      }

      var h = a(p - u),
          _ = this._get([r.columnsGapPercent, 25]) / 100;

      (0 > isNaN(_) || 1 <= _) && (_ = .25);
      var f = _ * h,
          b = e.renderData.xoffsets,
          y = -1,
          v = {},
          w = !0 === r.skipOverlappingPoints;

      for (var _u4 = b.first; _u4 <= b.last; _u4++) {
        var C = b.data[_u4];

        if (!isNaN(C)) {
          if (-1 !== y && a(C - y) < h - 1 + f && w) continue;else y = C;

          var S = this._getColumnVOffsets(l, o, e.seriesCtx, _u4, d, t),
              D = !1;

          if (s) for (var _e379 = 0; _e379 < r.series.length; _e379++) {
            r.series[_e379].summary && b.xvalues[_u4][r.series[_e379].summary] && (D = !0);
          }

          for (var _p5 = 0; _p5 < e.seriesCtx.length; _p5++) {
            var g = e.seriesCtx[_p5],
                T = g.seriesIndex,
                $ = r.series[T],
                I = S[_p5].from,
                A = S[_p5].to,
                E = S[_p5].xOffset,
                B = (e.vertical ? e.rect.x : e.rect.y) + g.xAdjust,
                L = g.settings;

            var _h4 = 0 === g.itemsColors.length ? g.serieColors : g.itemsColors[_u4 - l.xoffsets.first];

            var M = this._isSerieVisible(o, T);

            if (M) {
              var C = this.renderer._ptrnd(B + E),
                  H = {
                x: C,
                width: g.columnWidth
              };

              S[_p5].funnel && (H.fromWidthPercent = S[_p5].fromWidthPercent, H.toWidthPercent = S[_p5].toWidthPercent);
              var k = !0;
              e.vertical ? (H.y = I, H.height = A - I, 0 > H.height && (H.y += H.height, H.height = -H.height, k = !1)) : (H.x = I < A ? I : A, H.width = a(I - A), k = 0 > I - A, H.y = C, H.height = g.columnWidth);
              var z = I - A;

              if (!isNaN(z)) {
                z = a(z);

                var P = void 0,
                    F = n._getRenderInfo(o, T, _u4),
                    O = F.element,
                    N = F.labelElement,
                    R = void 0 === O || null === O;

                if (N && (n.renderer.removeElement(N), N = void 0), !!c) {
                  var V = {
                    element: O
                  };
                  P = this._columnAsPieSlice(V, e.rect, c, H), O = V.element, _h4 = this._getColors(o, T, void 0, "radialGradient", P.outerRadius);
                } else if (S[_p5].funnel) {
                  var U = this._getTrapezoidPath(Object.assign({}, H), e.vertical, k);

                  R ? O = this.renderer.path(U, {}) : this.renderer.attr(O, {
                    d: U
                  });
                } else R ? O = this.renderer.rect(H.x, H.y, e.vertical ? H.width : 0, e.vertical ? 0 : H.height) : !0 === e.vertical ? this.renderer.attr(O, {
                  x: H.x,
                  y: H.y,
                  height: z
                }) : this.renderer.attr(O, {
                  x: H.x,
                  y: H.y,
                  width: z
                });

                if (1 > z && (1 !== t || c) ? this.renderer.attr(O, {
                  display: "none"
                }) : this.renderer.attr(O, {
                  display: "block"
                }), R && this.renderer.attr(O, {
                  fill: _h4.fillColor,
                  "fill-opacity": L.opacity,
                  "stroke-opacity": L.opacity,
                  stroke: _h4.lineColor,
                  "stroke-width": L.stroke,
                  "stroke-dasharray": L.dashStyle
                }), N && this.renderer.removeElement(N), !M || 0 === z && 1 > t) {
                  F = {
                    element: O,
                    labelElement: N
                  }, n._setRenderInfo(o, T, _u4, F);
                  continue;
                }

                if (s && !1 !== this._get([$.showWaterfallLines, r.showWaterfallLines])) {
                  if (!d || d && _p5 === m) {
                    var W = d ? -1 : _p5;

                    if (1 === t && !isNaN(l.offsets[_p5][_u4].from) && !isNaN(l.offsets[_p5][_u4].to)) {
                      var G = v[W];

                      if (void 0 !== G && null !== G) {
                        var j = {
                          x: G.x,
                          y: this.renderer._ptrnd(G.y)
                        },
                            Y = {
                          x: C,
                          y: j.y
                        },
                            q = r.columnsTopWidthPercent / 100;
                        isNaN(q) ? q = 1 : (1 < q || 0 > q) && (q = 1);
                        var X = r.columnsBottomWidthPercent / 100;
                        isNaN(X) ? X = 1 : (1 < X || 0 > X) && (X = 1);
                        var K = e.vertical ? H.width : H.height;

                        if (j.x = j.x - K / 2 + K / 2 * q, D) {
                          var _e380 = K * q / 2;

                          Y.x = Y.x + K / 2 - (i.flip ? -_e380 : _e380);
                        } else {
                          var _e381 = K * X / 2;

                          Y.x = Y.x + K / 2 - (i.flip ? -_e381 : _e381);
                        }

                        e.vertical || (this._swapXY([j]), this._swapXY([Y])), this.renderer.line(j.x, j.y, Y.x, Y.y, {
                          stroke: G.color,
                          "stroke-width": L.stroke,
                          "stroke-opacity": L.opacity,
                          "fill-opacity": L.opacity,
                          "stroke-dasharray": L.dashStyle
                        });
                      }
                    }
                  }

                  1 === t && 0 !== z && (v[d ? -1 : _p5] = {
                    y: A,
                    x: e.vertical ? H.x + H.width : H.y + H.height,
                    color: _h4.lineColor
                  });
                }

                if (c) {
                  var K = this._showLabel(o, T, _u4, H, void 0, void 0, !0),
                      Z = P.outerRadius + 10;

                  var _e382 = this._adjustTextBoxPosition(c.x, c.y, K, Z, (P.fromAngle + P.toAngle) / 2, !0, !1, !1);

                  N = this._showLabel(o, T, _u4, {
                    x: _e382.x,
                    y: _e382.y
                  }, void 0, void 0, !1, !1, !1);
                } else N = this._showLabel(o, T, _u4, H, void 0, void 0, !1, !1, k);

                F = {
                  element: O,
                  labelElement: N
                }, n._setRenderInfo(o, T, _u4, F), 1 === t && this._installHandlers(O, "column", o, T, _u4);
              }
            }
          }
        }
      }
    }
  }, {
    key: "_getTrapezoidPath",
    value: function _getTrapezoidPath(e, t, i) {
      var a = "",
          n = e.fromWidthPercent / 100,
          o = e.toWidthPercent / 100;

      if (!t) {
        var _t321 = e.width;
        e.width = e.height, e.height = _t321, _t321 = e.x, e.x = e.y, e.y = _t321;
      }

      var r = e.x + e.width / 2,
          l = [{
        x: r - e.width * (i ? o : n) / 2,
        y: e.y + e.height
      }, {
        x: r - e.width * (i ? n : o) / 2,
        y: e.y
      }, {
        x: r + e.width * (i ? n : o) / 2,
        y: e.y
      }, {
        x: r + e.width * (i ? o : n) / 2,
        y: e.y + e.height
      }];
      t || this._swapXY(l), a += "M " + this.renderer._ptrnd(l[0].x) + "," + this.renderer._ptrnd(l[0].y);

      for (var _n168 = 1; _n168 < l.length; _n168++) {
        a += " L " + this.renderer._ptrnd(l[_n168].x) + "," + this.renderer._ptrnd(l[_n168].y);
      }

      return a += " Z", a;
    }
  }, {
    key: "_swapXY",
    value: function _swapXY(e) {
      for (var _t322 = 0, _i331; _t322 < e.length; _t322++) {
        _i331 = e[_t322].x, e[_t322].x = e[_t322].y, e[_t322].y = _i331;
      }
    }
  }, {
    key: "_renderCandleStickSeries",
    value: function _renderCandleStickSeries(e, t, i) {
      var a = this,
          n = a.seriesGroups[e];
      if (!n.series || 0 === n.series.length) return;
      var o = "horizontal" === n.orientation,
          r = t;
      o && (r = {
        x: t.y,
        y: t.x,
        width: t.height,
        height: t.width
      });

      var l = a._calcGroupOffsets(e, r);

      if (!l || 0 === l.xoffsets.length) return;
      var d;
      (n.polar || n.spider) && (d = a._getPolarAxisCoords(e, r));

      var c = a._getGroupGradientType(e),
          m = [];

      for (var _o108 = 0; _o108 < n.series.length; _o108++) {
        m[_o108] = a._getColumnSerieWidthAndOffset(e, _o108);
      }

      for (var _r58 = 0; _r58 < n.series.length; _r58++) {
        if (!this._isSerieVisible(e, _r58)) continue;

        var u = a._getSerieSettings(e, _r58),
            p = n.series[_r58];

        if (p.customDraw) continue;

        var _s43 = "function" == typeof p.colorFunction ? void 0 : a._getColors(e, _r58, NaN, c),
            g = {
          rect: t,
          inverse: o,
          groupIndex: e,
          seriesIndex: _r58,
          symbolType: p.symbolType,
          symbolSize: p.symbolSize,
          "fill-opacity": u.opacity,
          "stroke-opacity": u.opacity,
          "stroke-width": u.stroke,
          "stroke-dasharray": u.dashStyle,
          gradientType: c,
          colors: _s43,
          renderData: l,
          polarAxisCoords: d,
          columnsInfo: m,
          isOHLC: i,
          items: [],
          self: a
        },
            h = a._getAnimProps(e, _r58),
            _ = h.enabled && !a._isToggleRefresh && 5e3 > l.xoffsets.length ? h.duration : 0;

        a._animCandleStick(g, 0), a._enqueueAnimation("series", void 0, void 0, _, function (e, t, i) {
          a._animCandleStick(t, i);
        }, g);
      }
    }
  }, {
    key: "_animCandleStick",
    value: function _animCandleStick(e, t) {
      var i = Math.min,
          a = Math.abs,
          n = ["Open", "Low", "Close", "High"],
          o = e.columnsInfo[e.seriesIndex].width,
          r = e.self.seriesGroups[e.groupIndex],
          l = e.renderData.xoffsets,
          s = -1,
          d = a(l.data[l.last] - l.data[l.first]);
      d *= t;
      var c = NaN,
          m = NaN;

      for (var _i332 = 0; _i332 < e.columnsInfo.length; _i332++) {
        var u = e.columnsInfo[_i332];
        (isNaN(c) || c > u.offset) && (c = u.offset), (isNaN(m) || m < u.offset + u.width) && (m = u.offset + u.width);
      }

      var p = a(m - c),
          g = !1 !== r.skipOverlappingPoints;

      for (var _c10 = l.first; _c10 <= l.last; _c10++) {
        var h = l.data[_c10];

        if (!isNaN(h) && !(-1 !== s && a(h - s) < p && g)) {
          var _ = a(l.data[_c10] - l.data[l.first]);

          if (_ > d) break;
          s = h;
          var f = e.items[_c10] = e.items[_c10] || {};

          for (var _t323 in n) {
            var b = e.self._getDataValueAsNumber(_c10, r.series[e.seriesIndex]["dataField" + n[_t323]], e.groupIndex);

            if (isNaN(b)) break;
            var v = e.renderData.offsets[e.seriesIndex][_c10][n[_t323]];
            if (isNaN(v)) break;
            f[n[_t323]] = v;
          }

          if (h += e.inverse ? e.rect.y : e.rect.x, e.polarAxisCoords) {
            var w = this._toPolarCoord(e.polarAxisCoords, this._plotRect, h, v);

            h = w.x, v = w.y;
          }

          for (var C in h = this.renderer._ptrnd(h), n) {
            f[C] = this.renderer._ptrnd(f[C]);
          }

          var S = e.colors;

          if (S || (S = e.self._getColors(e.groupIndex, e.seriesIndex, _c10, e.gradientType)), !e.isOHLC) {
            var D = f.lineElement;
            D || (D = e.inverse ? this.renderer.line(f.Low, h, f.High, h) : this.renderer.line(h, f.Low, h, f.High), this.renderer.attr(D, {
              fill: S.fillColor,
              "fill-opacity": e["fill-opacity"],
              "stroke-opacity": e["fill-opacity"],
              stroke: S.lineColor,
              "stroke-width": e["stroke-width"],
              "stroke-dasharray": e["stroke-dasharray"]
            }), f.lineElement = D);
            var T = f.stickElement;

            if (h -= o / 2, !T) {
              var $ = S.fillColor;
              f.Close <= f.Open && S.fillColorAlt && ($ = S.fillColorAlt), T = e.inverse ? this.renderer.rect(i(f.Open, f.Close), h, a(f.Close - f.Open), o) : this.renderer.rect(h, i(f.Open, f.Close), o, a(f.Close - f.Open)), this.renderer.attr(T, {
                fill: $,
                "fill-opacity": e["fill-opacity"],
                "stroke-opacity": e["fill-opacity"],
                stroke: S.lineColor,
                "stroke-width": e["stroke-width"],
                "stroke-dasharray": e["stroke-dasharray"]
              }), f.stickElement = T;
            }

            1 === t && this._installHandlers(T, "column", e.groupIndex, e.seriesIndex, _c10);
          } else {
            var I = "M" + h + "," + f.Low + " L" + h + "," + f.High + " M" + (h - o / 2) + "," + f.Open + " L" + h + "," + f.Open + " M" + (h + o / 2) + "," + f.Close + " L" + h + "," + f.Close;
            e.inverse && (I = "M" + f.Low + "," + h + " L" + f.High + "," + h + " M" + f.Open + "," + (h - o / 2) + " L" + f.Open + "," + h + " M" + f.Close + "," + h + " L" + f.Close + "," + (h + o / 2));
            var D = f.lineElement;
            D || (D = this.renderer.path(I, {}), this.renderer.attr(D, {
              fill: S.fillColor,
              "fill-opacity": e["fill-opacity"],
              "stroke-opacity": e["fill-opacity"],
              stroke: S.lineColor,
              "stroke-width": e["stroke-width"],
              "stroke-dasharray": e["stroke-dasharray"]
            }), f.lineElement = D), 1 === t && this._installHandlers(D, "column", e.groupIndex, e.seriesIndex, _c10);
          }
        }
      }
    }
  }, {
    key: "_renderScatterSeries",
    value: function _renderScatterSeries(e, t, a) {
      var n = Math.max,
          i = this.seriesGroups[e];

      if (i.series && 0 !== i.series.length) {
        var o = -1 !== i.type.indexOf("bubble"),
            l = "horizontal" === i.orientation,
            d = t;
        l && (d = {
          x: t.y,
          y: t.x,
          width: t.height,
          height: t.width
        });

        var c = this._calcGroupOffsets(e, d);

        if (c && 0 !== c.xoffsets.length) {
          var m = d.width,
              u;
          (i.polar || i.spider) && (u = this._getPolarAxisCoords(e, d), m = 2 * u.r);

          var p = this._getGroupGradientType(e);

          a || (a = "to");

          for (var _r59 = 0; _r59 < i.series.length; _r59++) {
            var g = this._getSerieSettings(e, _r59),
                h = i.series[_r59];

            if (!h.customDraw) {
              var s = h.dataField,
                  _ = "function" == typeof h.colorFunction,
                  f = this._getColors(e, _r59, NaN, p),
                  b = NaN,
                  v = NaN;

              if (o) for (var _t324 = c.xoffsets.first; _t324 <= c.xoffsets.last; _t324++) {
                var w = this._getDataValueAsNumber(_t324, h.radiusDataField || h.sizeDataField, e);

                "number" != typeof w && this.error(this.localize("invalidRadiusDataField", {
                  index: _t324
                })), isNaN(w) || ((isNaN(b) || w < b) && (b = w), (isNaN(v) || w > v) && (v = w));
              }
              var C = h.minRadius || h.minSymbolSize;
              isNaN(C) && (C = m / 50);
              var S = h.maxRadius || h.maxSymbolSize;
              isNaN(S) && (S = m / 25), C > S && (S = C);
              var D = h.radius;
              D = isNaN(D) && !isNaN(h.symbolSize) ? "circle" === h.symbolType ? h.symbolSize / 2 : h.symbolSize : 5;

              var T = this._getAnimProps(e, _r59),
                  $ = T.enabled && !this._isToggleRefresh && 5e3 > c.xoffsets.length ? T.duration : 0,
                  I = {
                groupIndex: e,
                seriesIndex: _r59,
                symbolType: h.symbolType,
                symbolSize: h.symbolSize,
                "fill-opacity": g.opacity,
                "stroke-opacity": g.opacity,
                "stroke-width": g.stroke,
                "stroke-width-symbol": g.strokeSymbol,
                "stroke-dasharray": g.dashStyle,
                items: [],
                polarAxisCoords: u
              },
                  A = void 0;

              for (var _m12 = c.xoffsets.first; _m12 <= c.xoffsets.last; _m12++) {
                var w = this._getDataValueAsNumber(_m12, s, e);

                if ("number" == typeof w) {
                  var E = c.xoffsets.data[_m12],
                      B = c.xoffsets.xvalues[_m12],
                      L = c.offsets[_r59][_m12][a];

                  if (!(L < d.y || L > d.y + d.height) && !(isNaN(E) || isNaN(L))) {
                    if (l) {
                      var M = E;
                      E = L, L = M + t.y;
                    } else E += t.x;

                    if (!(!_ && A && this.enableSampling && 1 > this.renderer._ptdist(A.x, A.y, E, L))) {
                      A = {
                        x: E,
                        y: L
                      };
                      var H = D;

                      if (o) {
                        var k = this._getDataValueAsNumber(_m12, h.radiusDataField || h.sizeDataField, e);

                        if ("number" != typeof k) continue;
                        H = C + (S - C) * (k - b) / n(1, v - b), isNaN(H) && (H = C);
                      }

                      c.offsets[_r59][_m12].radius = H;
                      var z = NaN,
                          P = NaN,
                          F = 0,
                          O = this._elementRenderInfo;

                      if (void 0 !== B && null !== B && O && O.length > e && O[e].series.length > _r59) {
                        var N = O[e].series[_r59][B];

                        if (N && !isNaN(N.to)) {
                          if (z = N.to, P = N.xoffset, F = D, l) {
                            var M = P;
                            P = z, z = M + t.y;
                          } else P += t.x;

                          o && (F = C + (S - C) * (N.valueRadius - b) / n(1, v - b), isNaN(F) && (F = C));
                        }
                      }

                      _ && (f = this._getColors(e, _r59, _m12, p)), I.items.push({
                        from: F,
                        to: H,
                        itemIndex: _m12,
                        fill: f.fillColor,
                        stroke: f.lineColor,
                        x: E,
                        y: L,
                        xFrom: P,
                        yFrom: z
                      });
                    }
                  }
                }
              }

              this._animR(I, 0);

              var R = this;

              this._enqueueAnimation("series", void 0, void 0, $, function (e, t, i) {
                R._animR(t, i);
              }, I);
            }
          }
        }
      }
    }
  }, {
    key: "_animR",
    value: function _animR(e, t) {
      var a = e.items,
          n = e.symbolType || "circle",
          o = e.symbolSize;

      for (var _l50 = 0; _l50 < a.length; _l50++) {
        var _i333 = a[_l50],
            _s44 = _i333.x,
            d = _i333.y,
            c = Math.round((_i333.to - _i333.from) * t + _i333.from);

        if (isNaN(_i333.yFrom) || (d = _i333.yFrom + (d - _i333.yFrom) * t), isNaN(_i333.xFrom) || (_s44 = _i333.xFrom + (_s44 - _i333.xFrom) * t), e.polarAxisCoords) {
          var _t325 = this._toPolarCoord(e.polarAxisCoords, this._plotRect, _s44, d);

          _s44 = _t325.x, d = _t325.y;
        }

        _s44 = this.renderer._ptrnd(_s44), d = this.renderer._ptrnd(d), c = this.renderer._ptrnd(c);

        var _r60 = this._getRenderInfo(e.groupIndex, e.seriesIndex, a[_l50].itemIndex),
            m = _r60.element,
            u = _r60.labelElement;

        "circle" === n ? (!m && (m = this.renderer.circle(_s44, d, c), this.renderer.attr(m, {
          fill: _i333.fill,
          "fill-opacity": e["fill-opacity"],
          "stroke-opacity": e["fill-opacity"],
          stroke: _i333.stroke,
          "stroke-width": e["stroke-width"],
          "stroke-dasharray": e["stroke-dasharray"]
        })), this.renderer.attr(m, {
          r: c,
          cy: d,
          cx: _s44
        })) : (m && this.renderer.removeElement(m), m = this._drawSymbol(n, _s44, d, _i333.fill, e["fill-opacity"], _i333.stroke, e["stroke-opacity"] || e["fill-opacity"], e["stroke-width-symbol"], e["stroke-dasharray"], o || c)), u && this.renderer.removeElement(u), u = this._showLabel(e.groupIndex, e.seriesIndex, _i333.itemIndex, {
          x: _s44 - c,
          y: d - c,
          width: 2 * c,
          height: 2 * c
        }), 1 <= t && this._installHandlers(m, "circle", e.groupIndex, e.seriesIndex, _i333.itemIndex), this._setRenderInfo(e.groupIndex, e.seriesIndex, a[_l50].itemIndex, {
          element: m,
          labelElement: u
        });
      }
    }
  }, {
    key: "_showMultiSeriesToolTip",
    value: function _showMultiSeriesToolTip(e) {
      var t = this,
          i = "<div style='text-align:left'>",
          a = "";

      for (var _n169 = 0; _n169 < t.seriesGroups.length; _n169++) {
        if (t._isPieGroup(_n169)) continue;

        var _o109 = t._getXAxis(_n169),
            _r61 = t._getValueAxis(_n169),
            _l51 = t.seriesGroups[_n169],
            _s45 = this._getAxisSettings(_o109),
            d = this._getFormatSettings(_s45, "toolTipFormatSettings"),
            c = _s45.toolTipFormatFunction,
            m = t._getDataValue(e, _o109.dataField, _n169);

        (_o109.dataField === void 0 || null === _o109.dataField || "" === _o109.dataField) && (m = e), "date" === _o109.type && (m = t._castAsDate(m, (d ? d.dateFormat : void 0) || _o109.dateFormat)), c || d || "date" !== _o109.type || (c = this._getDefaultDTFormatFn(_o109.baseUnit || "day"));
        var u = _o109.displayText || _o109.dataField || "";
        "" !== u && (u += ": ");

        var p = u + t._formatValue(m, d, c, _n169, void 0, e);

        a !== p && ("" !== a && (i += "<br />"), i += p + "<br /><br />", a = p);

        for (var _a205 = 0, _o110; _a205 < _l51.series.length; _a205++) {
          if (_o110 = _l51.series[_a205], !1 === _l51.showToolTips || !1 === _o110.showToolTips) continue;
          if (!t._isSerieVisible(_n169, _a205)) continue;

          var _s46 = t._get([t._getFormatSettings(_o110, "toolTipFormatSettings"), t._getFormatSettings(_l51, "toolTipFormatSettings"), t._getFormatSettings(_r61, "toolTipFormatSettings"), t._getFormatSettings(t, "toolTipFormatSettings")]),
              _d23 = t._get([_o110.toolTipFormatFunction, _l51.toolTipFormatFunction, _r61.toolTipFormatFunction, t.toolTipFormatFunction]),
              _c11 = t._getFormattedValue(_n169, _a205, e, _s46, _d23),
              _m13 = t._getColors(_n169, _a205, e);

          i += "<span style=\"color:" + _m13.lineColor + ";\">" + _c11 + "</span><br />\n";
        }
      }

      var n = this._get([t.toolTipClass, "smart-chart-tooltip-text"]),
          o = this._get([t.toolTipBackground, t._getThemeColor("background")]),
          r = this._get([t.toolTipLineColor, t._getThemeColor("line")]),
          l = this._get([t.toolTipOpacity, 1]);

      i += "</div>";
      var s = this.getItemCoord(t._ttEl.gidx, t._ttEl.sidx, t._ttEl.iidx);
      s.x += window.pageXOffset, s.y += window.pageYOffset, t._createTooltip(s, t.seriesGroups[t._ttEl.gidx], i, {
        css: n,
        fill: o,
        stroke: r,
        fillOpacity: l,
        symbolSize: 3
      });
    }
  }, {
    key: "_showToolTip",
    value: function _showToolTip(e, t, i, a, n) {
      var o = this,
          r = o._getXAxis(i),
          l = o._getValueAxis(i);

      if (o._ttEl && i === o._ttEl.gidx && a === o._ttEl.sidx && n === o._ttEl.iidx) return;
      var s = o.seriesGroups[i],
          d = s.series[a],
          c = o.enableCrosshairs;
      o._pointMarker ? (e = parseInt(o._pointMarker.x + 5), t = parseInt(o._pointMarker.y - 5)) : c = !1;
      var m = c && !1 === o.showToolTips;
      if (e = this.renderer._ptrnd(e), t = this.renderer._ptrnd(t), !1 === s.showToolTips || !1 === d.showToolTips) return;
      o._ttEl || (o._ttEl = {}), o._ttEl.sidx = a, o._ttEl.gidx = i, o._ttEl.iidx = n;
      var u = 0;

      for (var _r62 = 0; _r62 < o.seriesGroups.length; _r62++) {
        for (var _e383 = 0; _e383 < o.seriesGroups[_r62].series.length; _e383++) {
          u++;
        }
      }

      if (c) {
        var _e384 = this.renderer._ptrnd(o._pointMarker.x),
            _t326 = this.renderer._ptrnd(o._pointMarker.y),
            _a206 = o.crosshairsColor || o._getThemeColor("line");

        if (s.polar || s.spider) {
          var _n170 = this._getPolarAxisCoords(i, this._plotRect),
              _r63 = this.renderer._ptdist(_e384, _t326, _n170.x, _n170.y);

          if (_r63 > _n170.r) return;

          var _l52 = Math.atan2(_t326 - _n170.y, _e384 - _n170.x),
              _s47 = Math.cos(_l52) * _n170.r + _n170.x,
              _d24 = Math.sin(_l52) * _n170.r + _n170.y;

          o._ttEl.vLine ? o.renderer.attr(o._ttEl.vLine, {
            x1: _n170.x,
            y1: _n170.y,
            x2: _s47,
            y2: _d24
          }) : o._ttEl.vLine = o.renderer.line(_n170.x, _n170.y, _s47, _d24, {
            stroke: _a206,
            "stroke-width": o.crosshairsLineWidth || 1,
            "stroke-dasharray": o.crosshairsDashStyle || ""
          });
        } else o._ttEl.vLine && o._ttEl.hLine ? (o.renderer.attr(o._ttEl.vLine, {
          x1: _e384,
          x2: _e384
        }), o.renderer.attr(o._ttEl.hLine, {
          y1: _t326,
          y2: _t326
        })) : (o._ttEl.vLine = o.renderer.line(_e384, o._plotRect.y, _e384, o._plotRect.y + o._plotRect.height, {
          stroke: _a206,
          "stroke-width": o.crosshairsLineWidth || 1,
          "stroke-dasharray": o.crosshairsDashStyle || ""
        }), o._ttEl.hLine = o.renderer.line(o._plotRect.x, _t326, o._plotRect.x + o._plotRect.width, _t326, {
          stroke: _a206,
          "stroke-width": o.crosshairsLineWidth || 1,
          "stroke-dasharray": o.crosshairsDashStyle || ""
        }));
      }

      if (o.showToolTipsOnAllSeries && !o._isPieGroup(i) && 1 < u) return void o._showMultiSeriesToolTip(n);

      var p = o._get([o._getFormatSettings(d, "toolTipFormatSettings"), o._getFormatSettings(s, "toolTipFormatSettings"), o._getFormatSettings(l, "toolTipFormatSettings"), o._getFormatSettings(o, "toolTipFormatSettings")]),
          g = o._get([d.toolTipFormatFunction, s.toolTipFormatFunction, l.toolTipFormatFunction, o.toolTipFormatFunction]),
          h = o._getColors(i, a, n),
          _ = o._getDataValue(n, r.dataField, i);

      (void 0 === r.dataField || null === r.dataField || "" === r.dataField) && (_ = n), "date" === r.type && (_ = o._castAsDate(_, (p ? p.dateFormat : void 0) || r.dateFormat));
      var f = "";

      if ("function" == typeof g) {
        var _e385 = {},
            _t327 = 0;

        for (var _a207 in d) {
          0 === _a207.indexOf("dataField") && (_e385[_a207.substring(9, _a207.length).toLowerCase()] = o._getDataValue(n, d[_a207], i), _t327++);
        }

        0 === _t327 ? _e385 = o._getDataValue(n, void 0, i) : 1 === _t327 && (_e385 = _e385[""]), f = g(_e385, n, d, s, _, r);
      } else {
        f = o._getFormattedValue(i, a, n, p, g);

        var _e386 = this._getAxisSettings(r),
            _t328 = o._getFormatSettings(_e386, "toolTipFormatSettings"),
            _l53 = _e386.toolTipFormatFunction;

        _l53 || _t328 || "date" !== r.type || (_l53 = this._getDefaultDTFormatFn(r.baseUnit || "day"));

        var _s48 = o._formatValue(_, _t328, _l53, i, a, n);

        if (!o._isPieGroup(i)) {
          var _e387 = r.displayText || r.dataField || "";

          f = 0 < _e387.length ? _e387 + ": " + _s48 + "<br>" + f : _s48 + "<br>" + f;
        } else _ = o._getDataValue(n, d.displayText || d.dataField, i), _s48 = o._formatValue(_, _t328, _l53, i, a, n), f = _s48 + ": " + f;
      }

      if (!m && !1 !== o.showToolTips) {
        var _e388 = this._get([d.toolTipClass, s.toolTipClass, o.toolTipClass, "smart-chart-tooltip-text"]),
            _t329 = this._get([d.toolTipBackground, s.toolTipBackground, o.toolTipBackground, o._getThemeColor("background")]),
            _r64 = this._get([d.toolTipLineColor, s.toolTipLineColor, o.toolTipLineColor, h.lineColor, o._getThemeColor("line")]),
            _l54 = this._get([d.toolTipOpacity, s.toolTipOpacity, o.toolTipOpacity, 1]),
            _c12 = this.getItemCoord(i, a, n);

        _c12.y = Math.min(Math.max(_c12.y, this._plotRect.y), this._plotRect.y + this._plotRect.y + this._plotRect.height);
        var _m14 = 0;
        o._pointMarker && o._pointMarker.element && (_m14 = d.symbolSizeSelected, isNaN(_m14) && (_m14 = d.symbolSize), (isNaN(_m14) || 50 < _m14 || 0 > _m14) && (_m14 = s.symbolSize), (isNaN(_m14) || 50 < _m14 || 0 > _m14) && (_m14 = 8)), o._createTooltip(_c12, s, f, {
          css: _e388,
          fill: _t329,
          stroke: _r64,
          fillOpacity: _l54,
          symbolSize: _m14
        });
      }
    }
  }, {
    key: "_fitTooltip",
    value: function _fitTooltip(e, t, i, a, n) {
      var o = {},
          r = 2 + n / 2,
          l = 7;

      if (t.x - i.width - l - r > e.x && t.y + t.height / 2 - i.height / 2 > e.y && t.y + t.height / 2 + i.height / 2 < e.y + e.height && (o.left = {
        arrowLocation: "right",
        x: t.x - i.width - l - r,
        y: t.y + t.height / 2 - i.height / 2,
        width: i.width + l,
        height: i.height
      }), t.x + t.width + i.width + l + r < e.x + e.width && t.y + t.height / 2 - i.height / 2 > e.y && t.y + t.height / 2 + i.height / 2 < e.y + e.height && (o.right = {
        arrowLocation: "left",
        x: t.x + t.width + r,
        y: t.y + t.height / 2 - i.height / 2,
        width: i.width + l,
        height: i.height
      }), t.y - i.height - r - l > e.y && t.x + t.width / 2 - i.width / 2 > e.x && t.x + t.width / 2 + i.width / 2 < e.x + e.width && (o.top = {
        arrowLocation: "bottom",
        x: t.x + t.width / 2 - i.width / 2,
        y: t.y - i.height - r - l,
        width: i.width,
        height: i.height + l
      }), t.y + t.height + i.height + l + r < e.y + e.height && t.x + t.width / 2 - i.width / 2 > e.x && t.x + t.width / 2 + i.width / 2 < e.x + e.width && (o.bottom = {
        arrowLocation: "top",
        x: t.x + t.width / 2 - i.width / 2,
        y: t.y + t.height + r,
        width: i.width,
        height: i.height + l
      }), t.width > t.height || (-1 !== a.type.indexOf("stackedcolumn") || -1 !== a.type.indexOf("stackedwaterfall")) && "horizontal" !== a.orientation) {
        if (o.left) return o.left;
        if (o.right) return o.right;
      } else {
        if (o.top) return o.top;
        if (o.bottom) return o.bottom;
      }

      for (var _r65 in o) {
        if (o[_r65]) return o[_r65];
      }

      return {
        arrowLocation: ""
      };
    }
  }, {
    key: "_createTooltip",
    value: function _createTooltip(e, t, i, a) {
      var n = Math.max;
      var o = this,
          r = t.type;
      var l = o._ttEl.box;

      if (!l) {
        l = o._ttEl.box = document.createElement("div"), l.className = "smart-chart-tooltip", l.setAttribute("animation", o.animation), l.setAttribute("theme", o.theme);

        var _e389 = document.createElement("div"),
            _t330 = document.createElement("div"),
            _i334 = document.createElement("div");

        _e389.id = "arrowOuterDiv", _e389.className = "smart-chart-tooltip-arrow-outer", _t330.id = "arrowInnerDiv", _t330.className = "smart-chart-tooltip-arrow-inner", _i334.id = "contentDiv", _i334.className = "smart-chart-tooltip-content", l.appendChild(_i334), l.appendChild(_e389), l.appendChild(_t330), document.body.appendChild(l);
      }

      if (!i || 0 === i.length) return void l.classList.add("smart-visibility-hidden");
      l.classList.add("smart-visibility-hidden");
      var s = l.firstElementChild,
          d = l.children[1],
          c = l.children[2];
      c.style.opacity = d.style.opacity = a.fillOpacity, s.style.backgroundColor = a.fill, s.style.borderColor = a.stroke, s.style.opacity = a.fillOpacity;
      var m = "<span class=\"" + a.css + "\">" + i + "</span>";
      s.innerHTML = m;

      var u = o._measureHtml(m),
          p = o._plotRect;

      if (u.width > p.width || u.height > p.height) return;

      var g = {
        width: u.width,
        height: u.height
      },
          h = "",
          _ = 7,
          f = o._isColumnType(r),
          b = n(e.x, p.x),
          v = n(e.y, p.y);

      if (-1 !== r.indexOf("pie") || -1 !== r.indexOf("donut")) {
        var _t331 = (e.fromAngle + e.toAngle) / 2;

        _t331 *= Math.PI / 180;

        var _i335 = !isNaN(e.innerRadius) && 0 < e.innerRadius ? (e.innerRadius + e.outerRadius) / 2 : .75 * e.outerRadius;

        b = e.x = e.center.x + Math.cos(_t331) * _i335, v = e.y = e.center.y - Math.sin(_t331) * _i335, e.width = e.height = 1;
      } else f && (t.polar || t.spider) && (e.width = e.height = 1);

      var w = this._fitTooltip(this._plotRect, e, g, t, a.symbolSize);

      "" !== w.arrowLocation && (h = w.arrowLocation, b = w.x, v = w.y, g.width = w.width, g.height = w.height), "top" === h || "bottom" === h ? (g.height += _, b -= _ / 2, "bottom" === h && (v -= _)) : ("left" === h || "right" === h) && (g.width += _, v -= _ / 2, "right" === h && (b -= _)), b + g.width > p.x + p.width && (h = "", b = p.x + p.width - g.width), v + g.height > p.y + p.height && (h = "", v = p.y + p.height - g.height);
      var C = {
        x: 0,
        y: 0
      },
          S = {
        x: 0,
        y: 0
      };
      s.style.width = u.width + "px", s.style.height = u.height + "px", d.style["margin-top"] = d.style["margin-left"] = 0, c.style["margin-top"] = c.style["margin-left"] = 0, s.style["margin-top"] = s.style["margin-left"] = 0;
      var D = _ + "px solid",
          T = _ + "px solid transparent";
      "left" === h ? (C = {
        x: 0,
        y: (u.height - _) / 2
      }, S = {
        x: _,
        y: 0
      }, s.style["margin-left"] = _ + "px", d.style["margin-left"] = "0px", d.style["margin-top"] = C.y + "px", d.style["border-left"] = "", d.style["border-right"] = D + " " + a.stroke, d.style["border-top"] = T, d.style["border-bottom"] = T, c.style["margin-left"] = "1px", c.style["margin-top"] = C.y + "px", c.style["border-left"] = "", c.style["border-right"] = D + " " + a.fill, c.style["border-top"] = T, c.style["border-bottom"] = T) : "right" === h ? (C = {
        x: g.width - _,
        y: (u.height - _) / 2
      }, S = {
        x: 0,
        y: 0
      }, d.style["margin-left"] = C.x + "px", d.style["margin-top"] = C.y + "px", d.style["border-left"] = D + " " + a.stroke, d.style["border-right"] = "", d.style["border-top"] = T, d.style["border-bottom"] = T, c.style["margin-left"] = C.x - 1 + "px", c.style["margin-top"] = C.y + "px", c.style["border-left"] = D + " " + a.fill, c.style["border-right"] = "", c.style["border-top"] = T, c.style["border-bottom"] = T) : "top" === h ? (C = {
        x: g.width / 2 - _ / 2,
        y: 0
      }, S = {
        x: 0,
        y: _
      }, s.style["margin-top"] = S.y + "px", d.style["margin-left"] = C.x + "px", d.style["border-top"] = "", d.style["border-bottom"] = D + " " + a.stroke, d.style["border-left"] = T, d.style["border-right"] = T, c.style["margin-left"] = C.x + "px", c.style["margin-top"] = "1px", c.style["border-top"] = "", c.style["border-bottom"] = D + " " + a.fill, c.style["border-left"] = T, c.style["border-right"] = T) : "bottom" === h ? (C = {
        x: g.width / 2 - _ / 2,
        y: g.height - _
      }, S = {
        x: 0,
        y: 0
      }, d.style["margin-left"] = C.x + "px", d.style["margin-top"] = C.y + "px", d.style["border-top"] = D + " " + a.stroke, d.style["border-bottom"] = "", d.style["border-left"] = T, d.style["border-right"] = T, c.style["margin-left"] = C.x + "px", c.style["margin-top"] = C.y - 1 + "px", c.style["border-top"] = D + " " + a.fill, c.style["border-bottom"] = "", c.style["border-left"] = T, c.style["border-right"] = T) : void 0;
      "" === h ? (d.classList.add("smart-hidden"), c.classList.add("smart-hidden")) : (d.classList.remove("smart-hidden"), c.classList.remove("smart-hidden")), l.style.width = g.width + "px", l.style.height = g.height + "px";
      var $ = o.getBoundingClientRect();
      l.style.left = b + $.left + window.pageXOffset + "px", l.style.top = v + $.top + window.pageYOffset + "px", l.classList.remove("smart-visibility-hidden");
    }
  }, {
    key: "_measureHtml",
    value: function _measureHtml(e) {
      var t = this;
      var i = t._measureDiv;
      i || (t._measureDiv = i = document.createElement("div"), i.className = "smart-chart-tooltip", i.style.position = "absolute", i.style.visibility = "hidden", i.style.left = 0, i.style.top = 0, (t.shadowRoot || t).appendChild(i)), i.innerHTML = e;
      var a = {
        width: i.offsetWidth + 2,
        height: i.offsetHeight + 2
      };
      return Smart.Utilities.Core.Browser.Firefox && (a.height += 3), a;
    }
  }, {
    key: "_hideToolTip",
    value: function _hideToolTip() {
      this._ttEl && (this._ttEl.box && this._ttEl.box.classList.add("smart-visibility-hidden"), this._hideCrosshairs(), this._ttEl.gidx = void 0);
    }
  }, {
    key: "_hideCrosshairs",
    value: function _hideCrosshairs() {
      this._ttEl && (this._ttEl.vLine && (this.renderer.removeElement(this._ttEl.vLine), this._ttEl.vLine = void 0), this._ttEl.hLine && (this.renderer.removeElement(this._ttEl.hLine), this._ttEl.hLine = void 0));
    }
  }, {
    key: "_get",
    value: function _get(e) {
      return this._draw.getByPriority(e);
    }
  }, {
    key: "_getAxisSettings",
    value: function _getAxisSettings(e) {
      if (!e) return {};
      var t = this,
          i = e.gridLines || {},
          a = {
        visible: t._get([i.visible, !0]),
        color: t._get([i.color, t._getThemeColor("line")]),
        unitInterval: i.unitInterval,
        step: i.step,
        dashStyle: i.dashStyle,
        width: t._get([i.lineWidth, 1]),
        offsets: [],
        alternatingBackgroundColor: e.alternatingBackgroundColor,
        alternatingBackgroundColor2: e.alternatingBackgroundColor2,
        alternatingBackgroundOpacity: e.alternatingBackgroundOpacity
      },
          n = e.tickMarks || {},
          o = {
        visible: t._get([n.visible, e.showTickMarks, !0]),
        color: t._get([n.color, e.tickMarksColor, t._getThemeColor("line")]),
        unitInterval: t._get([n.unitInterval, n.interval, e.tickMarksInterval]),
        step: t._get([n.step, e.tickMarksStep]),
        dashStyle: t._get([n.dashStyle, e.tickMarksDashStyle]),
        width: t._get([n.lineWidth, 1]),
        size: t._get([n.size, 4]),
        offsets: []
      },
          r = e.title || {},
          l = {
        visible: t._get([r.visible, !0]),
        text: t._get([e.description, r.text]),
        style: t._get([e.descriptionClass, r["class"], "smart-chart-axis-description"]),
        halign: t._get([e.horizontalDescriptionAlignment, r.horizontalAlignment, "center"]),
        valign: t._get([e.verticalDescriptionAlignment, r.verticalAlignment, "center"]),
        angle: 0,
        rotationPoint: t._get([r.rotationPoint, "centercenter"]),
        offset: t._get([r.offset, {
          x: 0,
          y: 0
        }])
      },
          s = e.line || {},
          d = {
        visible: t._get([s.visible, !0]),
        color: t._get([s.color, a.color, t._getThemeColor("line")]),
        dashStyle: t._get([s.dashStyle, a.dashStyle, ""]),
        width: t._get([s.lineWidth, 1]),
        angle: t._get([s.angle, NaN])
      },
          c = e.padding || {};
      c = {
        left: c.left || 0,
        right: c.right || 0,
        top: c.top || 0,
        bottom: c.bottom || 0
      };

      var m = this._getAxisLabelsSettings(e),
          u = {
        visible: this._get([e.visible, !0]),
        customDraw: this._get([e.customDraw, !1]),
        gridLines: a,
        tickMarks: o,
        line: d,
        title: l,
        labels: m,
        padding: c,
        toolTipFormatFunction: this._get([e.toolTipFormatFunction, e.formatFunction, m.formatFunction]),
        toolTipFormatSettings: this._get([t._getFormatSettings(e, "toolTipFormatSettings"), t._getFormatSettings(e), t._getFormatSettings(m)])
      };

      return u;
    }
  }, {
    key: "_getAxisLabelsSettings",
    value: function _getAxisLabelsSettings(e) {
      var t = this,
          i = e.labels || {},
          a = {
        visible: t._get([e.showLabels, i.visible, !0]),
        unitInterval: t._get([i.unitInterval, i.interval, e.labelsInterval]),
        step: t._get([i.step, e.labelsStep]),
        angle: t._get([e.textRotationAngle, i.angle, 0]),
        style: t._get([e["class"], i["class"], "smart-chart-axis-text"]),
        halign: t._get([e.horizontalTextAlignment, i.horizontalAlignment, "center"]),
        valign: t._get([e.verticalTextAlignment, i.verticalAlignment, "center"]),
        textRotationPoint: t._get([e.textRotationPoint, i.rotationPoint, "auto"]),
        textOffset: t._get([e.textOffset, i.offset, {
          x: 0,
          y: 0
        }]),
        autoRotate: t._get([e.labelsAutoRotate, i.autoRotate, !1]),
        formatSettings: t._get([t._getFormatSettings(e), t._getFormatSettings(i), void 0]),
        formatFunction: t._get([e.formatFunction, i.formatFunction, void 0])
      };
      return a;
    }
  }, {
    key: "_getLabelsSettings",
    value: function _getLabelsSettings(e, t, a, i) {
      var n = this.seriesGroups[e],
          o = n.series[t],
          r = isNaN(a) ? void 0 : this._getDataValue(a, o.dataField, e),
          l = i || ["Visible", "Offset", "Angle", "HorizontalAlignment", "VerticalAlignment", "Class", "BackgroundColor", "BorderColor", "BorderOpacity", "Padding", "Opacity", "BackgroundOpacity", "LinesAngles", "LinesEnabled", "AutoRotate", "Radius"],
          s = {};

      for (var _d25 = 0; _d25 < l.length; _d25++) {
        var _e390 = l[_d25],
            _t332 = "labels" + _e390,
            _i336 = "label" + _e390,
            c = _e390.substring(0, 1).toLowerCase() + _e390.substring(1),
            m = void 0;

        n.labels && "object" == typeof n.labels && (m = n.labels[c]), o.labels && "object" == typeof o.labels && void 0 !== o.labels[c] && null !== o.labels[c] && (m = o.labels[c]), m = this._get([o[_t332], o[_i336], m, n[_t332], n[_i336]]), s[c] = "function" == typeof m ? m(r, a, o, n) : m;
      }

      s["class"] = s["class"] || "smart-chart-label-text", s.visible = this._get([s.visible, o.showLabels, n.showLabels, void 0 !== o.labels && null !== o.labels || void 0, void 0 !== n.labels && null !== n.labels || void 0]);
      var d = s.padding || 1;
      return s.padding = {
        left: this._get([d.left, isNaN(d) ? 1 : d]),
        right: this._get([d.right, isNaN(d) ? 1 : d]),
        top: this._get([d.top, isNaN(d) ? 1 : d]),
        bottom: this._get([d.bottom, isNaN(d) ? 1 : d])
      }, s;
    }
  }, {
    key: "_showLabel",
    value: function _showLabel(e, t, i, a, n, o, r, l, s, d, c) {
      var m = Math.max;
      var u = {
        width: 0,
        height: 0
      },
          p;
      if (isNaN(i)) return;

      var g = this._getLabelsSettings(e, t, i);

      if (!g.visible) return r ? u : void 0;
      if (0 > a.width || 0 > a.height) return r ? u : void 0;
      var _ = g.angle;
      isNaN(d) || (_ = d);
      var f = g.offset || {},
          b = {
        x: f.x,
        y: f.y
      };
      isNaN(b.x) && (b.x = 0), isNaN(b.y) && (b.y = 0), n = n || g.horizontalAlignment || "center", o = o || g.verticalAlignment || "center";

      var v = this._getFormattedValue(e, t, i, void 0, void 0, !0),
          C = a.width,
          w = a.height;

      if (!0 === l && "center" !== n && (n = "right" === n ? "left" : "right"), !0 === s && "center" !== o && "middle" !== o && (o = "top" === o ? "bottom" : "top", b.y *= -1), u = this.renderer.measureText(v, _, {
        class: g["class"]
      }), r) return u;
      var h = 0,
          S = 0;
      0 < C && ("" === n || "center" === n ? h += (C - u.width) / 2 : "right" === n && (h += C - u.width)), 0 < w && ("" === o || "center" === o ? S += (w - u.height) / 2 : "bottom" === o && (S += w - u.height)), h += a.x + b.x, S += a.y + b.y;
      var D = this._plotRect;
      h <= D.x && (h = D.x + 2), S <= D.y && (S = D.y + 2);
      var T = {
        width: m(u.width, 1),
        height: m(u.height, 1)
      };
      S + T.height >= D.y + D.height && (S = D.y + D.height - (p ? (T.height + p.height) / 2 : T.height) - 2), h + T.width >= D.x + D.width && (h = D.x + D.width - T.width - 2);
      var $ = g.backgroundColor,
          I = g.borderColor,
          A = g.padding,
          E;
      ($ || I) && (E = this.renderer.beginGroup(), this.renderer.rect(h - A.left, S - A.top, u.width + A.left + A.right, u.height + A.bottom + A.bottom, {
        fill: $ || "transparent",
        "fill-opacity": g.backgroundOpacity || 1,
        stroke: I || "transparent",
        "stroke-opacity": g.borderOpacity,
        "stroke-width": 1
      }));
      var B = this.renderer.text(v, h, S, u.width, u.height, _, {
        class: g["class"],
        opacity: g.opacity || 1
      }, !1, "center", "center", void 0, arguments[11]);
      return c && (c.x = h - A.left, c.y = S - A.top, c.width = u.width + A.left + A.right, c.height = u.height + A.bottom + A.bottom), E && this.renderer.endGroup(), E || B;
    }
  }, {
    key: "_getAnimProps",
    value: function _getAnimProps(e, t) {
      var i = this.seriesGroups[e],
          a = isNaN(t) ? void 0 : i.series[t],
          n = this.hasAnimation;
      i.animation && (n = "none" !== i.animation), a && a.animation && (n = "none" !== a.animation);
      var o = this.animationDuration;
      isNaN(o) && (o = 1e3);
      var r = i.animationDuration;

      if (isNaN(r) || (o = r), a) {
        var _e391 = a.animationDuration;
        isNaN(_e391) || (o = _e391);
      }

      return 5e3 < o && (o = 1e3), {
        enabled: n,
        duration: o
      };
    }
  }, {
    key: "_isColorTransition",
    value: function _isColorTransition(e, t, i, a) {
      if (a - 1 < i.xoffsets.first) return !1;

      var n = this._getColors(e, t, a, this._getGroupGradientType(e)),
          o = this._getColors(e, t, a - 1, this._getGroupGradientType(e));

      return n.fillColor !== o.fillColor;
    }
  }, {
    key: "_renderLineSeries",
    value: function _renderLineSeries(e, t) {
      var a = Math.max,
          n = this.seriesGroups[e];

      if (n.series && 0 !== n.series.length) {
        var o = -1 !== n.type.indexOf("area"),
            i = -1 !== n.type.indexOf("stacked"),
            r = i && -1 !== n.type.indexOf("100"),
            l = -1 !== n.type.indexOf("spline"),
            s = -1 !== n.type.indexOf("step"),
            d = -1 !== n.type.indexOf("range"),
            c = !0 === n.polar || !0 === n.spider;

        if (c && (s = !1), !(s && l)) {
          var m = "horizontal" === n.orientation,
              u = !0 === this._getXAxis(e).flip,
              p = t;

          m && (p = {
            x: t.y,
            y: t.x,
            width: t.height,
            height: t.width
          });

          var g = this._calcGroupOffsets(e, p);

          if (g && 0 !== g.xoffsets.length) {
            this._linesRenderInfo || (this._linesRenderInfo = {}), this._linesRenderInfo[e] = {};

            for (var _t333 = n.series.length - 1; 0 <= _t333; _t333--) {
              var h = this._getSerieSettings(e, _t333),
                  _ = {
                groupIndex: e,
                rect: p,
                serieIndex: _t333,
                swapXY: m,
                isArea: o,
                isSpline: l,
                isRange: d,
                isPolar: c,
                settings: h,
                segments: [],
                pointsLength: 0
              },
                  f = this._isSerieVisible(e, _t333);

              if (!f) {
                this._linesRenderInfo[e][_t333] = _;
                continue;
              }

              var b = n.series[_t333];

              if (!b.customDraw) {
                var y = "function" == typeof b.colorFunction,
                    v = g.xoffsets.first,
                    w = v,
                    C = this._getColors(e, _t333, NaN, this._getGroupGradientType(e)),
                    S;

                do {
                  var D = [],
                      T = [],
                      $ = [],
                      I = 0,
                      A = 0,
                      E = NaN,
                      B = NaN,
                      L = NaN;
                  if (1 > g.xoffsets.length) continue;

                  var M = this._getAnimProps(e, _t333),
                      H = M.enabled && !this._isToggleRefresh && 1e4 > g.xoffsets.length && M.duration,
                      k = v;

                  S = !1;
                  var z = void 0;

                  for (var _l55 = v; _l55 <= g.xoffsets.last; _l55++) {
                    v = _l55;
                    var P = g.xoffsets.data[_l55],
                        F = g.xoffsets.xvalues[_l55];

                    if (!isNaN(P) && (P = a(P, 1), I = P, A = g.offsets[_t333][_l55].to, !(!y && z && this.enableSampling && 1 > this.renderer._ptdist(z.x, z.y, I, A)))) {
                      z = {
                        x: I,
                        y: A
                      };
                      var O = g.offsets[_t333][_l55].from;
                      if (isNaN(A) || isNaN(O)) if ("connect" === b.emptyPointsDisplay) continue;else if ("zero" === b.emptyPointsDisplay) isNaN(A) && (A = g.baseOffset), isNaN(O) && (O = g.baseOffset);else {
                        S = !0;
                        break;
                      }

                      if (y && this._isColorTransition(e, _t333, g, v) && 1 < D.length) {
                        v--;
                        break;
                      }

                      var N = this._elementRenderInfo;

                      if (N && N.length > e && N[e].series.length > _t333) {
                        var R = N[e].series[_t333][F],
                            L = this.renderer._ptrnd(R ? R.to : void 0),
                            V = this.renderer._ptrnd(p.x + (R ? R.xoffset : void 0));

                        $.push(m ? {
                          y: V,
                          x: L,
                          index: _l55
                        } : {
                          x: V,
                          y: L,
                          index: _l55
                        });
                      }

                      w = _l55, 2 > h.stroke && (1 >= A - p.y && (A = p.y + 1), 1 >= O - p.y && (O = p.y + 1), 1 >= p.y + p.height - A && (A = p.y + p.height - 1), 1 >= p.y + p.height - O && (O = p.y + p.height - 1)), !o && r && (A <= p.y && (A = p.y + 1), A >= p.y + p.height && (A = p.y + p.height - 1), O <= p.y && (O = p.y + 1), O >= p.y + p.height && (O = p.y + p.height - 1)), P = a(P, 1), I = P + p.x, !0 === n.skipOverlappingPoints && !isNaN(E) && 1 >= Math.abs(E - I) || (s && !isNaN(E) && !isNaN(B) && B !== A && D.push(m ? {
                        y: I,
                        x: this.renderer._ptrnd(B)
                      } : {
                        x: I,
                        y: this.renderer._ptrnd(B)
                      }), D.push(m ? {
                        y: I,
                        x: this.renderer._ptrnd(A),
                        index: _l55
                      } : {
                        x: I,
                        y: this.renderer._ptrnd(A),
                        index: _l55
                      }), T.push(m ? {
                        y: I,
                        x: this.renderer._ptrnd(O),
                        index: _l55
                      } : {
                        x: I,
                        y: this.renderer._ptrnd(O),
                        index: _l55
                      }), E = I, B = A, isNaN(L) && (L = A));
                    }
                  }

                  if (0 === D.length) {
                    v++;
                    continue;
                  }

                  var U = D[D.length - 1].index;
                  y && (C = this._getColors(e, _t333, U, this._getGroupGradientType(e)));
                  var W = p.x + g.xoffsets.data[k],
                      G = p.x + g.xoffsets.data[w];

                  if (o && !0 === n.alignEndPointsWithIntervals && (W > p.x && (W = p.x), G < p.x + p.width && (G = p.x + p.width), u)) {
                    var j = W;
                    W = G, G = j;
                  }

                  G = this.renderer._ptrnd(G), W = this.renderer._ptrnd(W);
                  var Y = g.baseOffset;
                  L = this.renderer._ptrnd(L);
                  var q = this.renderer._ptrnd(A) || Y;
                  d && (D = D.concat(T.reverse())), _.pointsLength += D.length;
                  var X = {
                    lastItemIndex: U,
                    colorSettings: C,
                    pointsArray: D,
                    pointsStart: $,
                    left: W,
                    right: G,
                    pyStart: L,
                    pyEnd: q,
                    yBase: Y,
                    labelElements: [],
                    symbolElements: []
                  };

                  _.segments.push(X);
                } while (v < g.xoffsets.first + g.xoffsets.length - 1 || S);

                this._linesRenderInfo[e][_t333] = _;
              }
            }

            var K = this._linesRenderInfo[e],
                Z = [];

            for (var _e392 in K) {
              Z.push(K[_e392]);
            }

            Z = Z.sort(function (e, t) {
              return e.serieIndex - t.serieIndex;
            }), o && i && Z.reverse();

            for (var _e393 = 0; _e393 < Z.length; _e393++) {
              var _ = Z[_e393];

              this._animateLine(_, 0 === H ? 1 : 0);

              var Q = this;

              this._enqueueAnimation("series", void 0, void 0, H, function (e, t, i) {
                Q._animateLine(t, i);
              }, _);
            }
          }
        }
      }
    }
  }, {
    key: "_animateLine",
    value: function _animateLine(e, t) {
      var a = e.settings,
          n = e.groupIndex,
          o = e.serieIndex,
          i = this.seriesGroups[n],
          r = i.series[o],
          l = this._getSymbol(n, o),
          s = this._getLabelsSettings(n, o, NaN, ["Visible"]).visible,
          d = !0;

      e.isPolar && !isNaN(i.endAngle) && 360 !== Math.round(Math.abs((isNaN(i.startAngle) ? 0 : i.startAngle) - i.endAngle)) && (d = !1), !1 === r.endPointsConnect && (d = !1);
      var c = 0;

      for (var _i337 = 0; _i337 < e.segments.length; _i337++) {
        var m = e.segments[_i337],
            u = this._calculateLine(n, e.pointsLength, c, m.pointsArray, m.pointsStart, m.yBase, t, e.isArea, e.swapXY);

        if (c += m.pointsArray.length, "" === u) continue;
        var p = u.split(" "),
            g = u;
        g = "" === g ? "M 0 0" : this._buildLineCmd(u, e.isRange, m.left, m.right, m.pyStart, m.pyEnd, m.yBase, e.isArea, e.isPolar, d, e.isSpline, e.swapXY);
        var h = m.colorSettings;

        if (m.pathElement ? this.renderer.attr(m.pathElement, {
          d: g
        }) : (m.pathElement = this.renderer.path(g, {
          "stroke-width": a.stroke,
          stroke: h.lineColor,
          "stroke-opacity": a.opacity,
          "fill-opacity": a.opacity,
          "stroke-dasharray": a.dashStyle,
          fill: e.isArea ? h.fillColor : "none"
        }), this._installHandlers(m.pathElement, "path", n, o, m.lastItemIndex)), m.labelElements) {
          for (var _e394 = 0; _e394 < m.labelElements.length; _e394++) {
            this.renderer.removeElement(m.labelElements[_e394]);
          }

          m.labelElements = [];
        }

        if (m.symbolElements) {
          for (var _e395 = 0; _e395 < m.symbolElements.length; _e395++) {
            this.renderer.removeElement(m.symbolElements[_e395]);
          }

          m.symbolElements = [];
        }

        if (m.pointsArray.length === p.length && ("none" !== l || s)) {
          var _e396 = r.symbolSize,
              _t334 = this._plotRect;

          for (var _r66 = 0, _i338; _r66 < p.length; _r66++) {
            if (_i338 = p[_r66].split(","), _i338 = {
              x: parseFloat(_i338[0]),
              y: parseFloat(_i338[1])
            }, !(_i338.x < _t334.x || _i338.x > _t334.x + _t334.width || _i338.y < _t334.y || _i338.y > _t334.y + _t334.height)) {
              if ("none" !== l) {
                var _t335 = this._getColors(n, o, m.pointsArray[_r66].index, this._getGroupGradientType(n)),
                    _s49 = this._drawSymbol(l, _i338.x, _i338.y, _t335.fillColorSymbol, a.opacity, _t335.lineColorSymbol, a.opacity, a.strokeSymbol, void 0, _e396);

                m.symbolElements.push(_s49);
              }

              if (s && (_i338 = this._adjustLineLabelPosition(n, o, m.pointsArray[_r66].index, _i338), _i338)) {
                var _e397 = this._showLabel(n, o, m.pointsArray[_r66].index, {
                  x: _i338.x,
                  y: _i338.y,
                  width: 0,
                  height: 0
                });

                m.labelElements.push(_e397);
              }
            }
          }
        }

        if (1 === t && "none" !== l) for (var _e398 = 0; _e398 < m.symbolElements.length; _e398++) {
          isNaN(m.pointsArray[_e398].index) || this._installHandlers(m.symbolElements[_e398], "symbol", n, o, m.pointsArray[_e398].index);
        }
      }
    }
  }, {
    key: "_adjustLineLabelPosition",
    value: function _adjustLineLabelPosition(e, t, i, a) {
      var n = this._showLabel(e, t, i, {
        width: 0,
        height: 0
      }, "", "", !0);

      if (n) {
        var _e399 = _defineProperty({
          x: a.x - n.width / 2,
          y: 0
        }, "y", a.y - 1.5 * n.height);

        return _e399;
      }
    }
  }, {
    key: "_calculateLine",
    value: function _calculateLine(e, t, i, a, n, o, r, l, s) {
      var d = this.seriesGroups[e],
          c;
      (!0 === d.polar || !0 === d.spider) && (c = this._getPolarAxisCoords(e, this._plotRect));
      var m = "",
          u = a.length;

      if (!l && 0 === n.length) {
        u = t * r - i;
      }

      for (var _d26 = 0; _d26 < u + 1 && _d26 < a.length; _d26++) {
        0 < _d26 && (m += " ");

        var _e401 = a[_d26].y,
            _t336 = a[_d26].x,
            _i339 = l ? o : _e401,
            p = _t336;

        if (n && n.length > _d26 && (_i339 = n[_d26].y, p = n[_d26].x, (isNaN(_i339) || isNaN(p)) && (_i339 = _e401, p = _t336)), u <= a.length && 0 < _d26 && _d26 === u && (p = a[_d26 - 1].x, _i339 = a[_d26 - 1].y), s ? (_t336 = this.renderer._ptrnd((_t336 - _i339) * (l ? r : 1) + _i339), _e401 = this.renderer._ptrnd(_e401)) : (_t336 = this.renderer._ptrnd((_t336 - p) * r + p), _e401 = this.renderer._ptrnd((_e401 - _i339) * r + _i339)), c) {
          var _i340 = this._toPolarCoord(c, this._plotRect, _t336, _e401);

          _t336 = _i340.x, _e401 = _i340.y;
        }

        m += _t336 + "," + _e401;
      }

      return m;
    }
  }, {
    key: "_buildLineCmd",
    value: function _buildLineCmd(e, t, i, a, n, o, r, l, s, d, c, m) {
      var u = e,
          p = m ? r + "," + i : i + "," + r,
          g = m ? r + "," + a : a + "," + r;
      !l || s || t || (u = p + " " + e + " " + g), c && (u = this._getBezierPoints(u));
      var h = u.split(" ");
      if (0 === h.length) return "";

      if (1 === h.length) {
        var _e402 = h[0].split(",");

        return "M " + h[0] + " L" + (parseFloat(_e402[0]) + 1) + "," + (parseFloat(_e402[1]) + 1);
      }

      var _ = h[0].replace("M", "");

      return l && !s ? t ? u = "M " + _ + " L " + _ + (c ? "" : " L " + _ + " ") + u : u = "M " + p + " L " + _ + " " + u : !c && (u = "M " + _ + " L " + _ + " " + u), (s && d || t) && (u += " Z"), u;
    }
  }, {
    key: "_getSerieSettings",
    value: function _getSerieSettings(e, t) {
      var i = this.seriesGroups[e],
          a = -1 !== i.type.indexOf("area"),
          n = -1 !== i.type.indexOf("line"),
          o = i.series[t],
          r = o.dashStyle || i.dashStyle || "",
          l = o.opacity || i.opacity;
      (isNaN(l) || 0 > l || 1 < l) && (l = 1);
      var s = o.lineWidth;
      isNaN(s) && "auto" !== s && (s = i.lineWidth), ("auto" === s || isNaN(s) || 0 > s || 15 < s) && (a ? s = 2 : n ? s = 3 : s = 1);
      var d = o.lineWidthSymbol;
      return isNaN(d) && (d = 1), {
        stroke: s,
        strokeSymbol: d,
        opacity: l,
        dashStyle: r
      };
    }
  }, {
    key: "_getColors",
    value: function _getColors(e, t, i, a, n) {
      var o = this.seriesGroups[e],
          r = o.series[t],
          l = this._get([r.useGradientColors, o.useGradientColors, !1]),
          s = this._getSeriesColors(e, t, i),
          d = [[0, 1.4], [100, 1]],
          c = [[0, 1], [25, 1.1], [50, 1.4], [100, 1]],
          m = NaN;

      if (isNaN(n) || (m = 2 === n ? d : c), l) {
        var _n171 = {};

        for (var _e403 in s) {
          _n171[_e403] = s[_e403];
        }

        if (s = _n171, "verticalLinearGradient" === a || "horizontalLinearGradient" === a) {
          var _e404 = "verticalLinearGradient" === a ? m || d : m || c,
              _t337 = ["fillColor", "fillColorSelected", "fillColorAlt", "fillColorAltSelected"];

          for (var _i341 in _t337) {
            var _n172 = s[_t337[_i341]];
            _n172 && (s[_t337[_i341]] = this.renderer._toLinearGradient(_n172, "verticalLinearGradient" === a, _e404));
          }
        } else if ("radialGradient" === a) {
          var _a208 = d,
              _n173;

          ("pie" === o.type || "donut" === o.type || o.polar) && void 0 !== i && null !== i && this._renderData[e] && this._renderData[e].offsets[t] && (_n173 = this._renderData[e].offsets[t][i], _a208 = [[0, 1.3], [90, 1.2], [100, 1]]), s.fillColor = this.renderer._toRadialGradient(s.fillColor, _a208, _n173), s.fillColorSelected = this.renderer._toRadialGradient(s.fillColorSelected, _a208, _n173);
        }
      }

      return s;
    }
  }, {
    key: "_installHandlers",
    value: function _installHandlers(e, t, i, a, n) {
      if (!this.enableEvents) return !1;
      var o = this,
          r = this.seriesGroups[i],
          l = this.seriesGroups[i].series[a],
          s = -1 !== r.type.indexOf("line") || -1 !== r.type.indexOf("area");
      s || !1 === r.enableSelection || !1 === l.enableSelection || this.renderer.addHandler(e, "mousemove", function () {
        var e = o._selected;
        e && e.isLineType && "click" === e.linesUnselectMode && (e.group !== i || e.series !== a) || o._ttEl && o._ttEl.gidx === i && o._ttEl.sidx === a && o._ttEl.iidx === n || o._startTooltipTimer(i, a, n);
      }), !1 === r.enableSelection || !1 === l.enableSelection || this.renderer.addHandler(e, "mouseover", function () {
        var r = o._selected;
        r && r.isLineType && "click" === r.linesUnselectMode && (r.group !== i || r.series !== a) || o._select(e, t, i, a, n, n);
      }), this.renderer.addHandler(e, "click", function (i) {
        (clearTimeout(o._hostClickTimer), o._lastClickTs = new Date().valueOf(), !(s && "symbol" !== t && "pointMarker" !== t)) && (o._isColumnType(r.type) && o._unselect(), isNaN(n) || (i.stopImmediatePropagation(), o._raiseItemEvent("click", r, l, n)));
      });
    }
  }, {
    key: "_getHorizontalOffset",
    value: function _getHorizontalOffset(e, t, i, a) {
      var n = this._plotRect,
          o = this._getDataLen(e);

      if (0 === o) return {
        index: void 0,
        value: i
      };

      var r = this._calcGroupOffsets(e, this._plotRect);

      if (0 === r.xoffsets.length) return {
        index: void 0,
        value: void 0
      };
      var l = i,
          s = a,
          d = this.seriesGroups[e],
          c;
      (d.polar || d.spider) && (c = this._getPolarAxisCoords(e, n));
      var m, u, p, g;

      for (var _o111 = r.xoffsets.first; _o111 <= r.xoffsets.last; _o111++) {
        var _e405 = r.xoffsets.data[_o111],
            _i342 = r.offsets[t][_o111].to,
            _a209 = 0;

        if (c) {
          var _t338 = this._toPolarCoord(c, n, _e405 + n.x, _i342);

          _e405 = _t338.x, _i342 = _t338.y, _a209 = this.renderer._ptdist(l, s, _e405, _i342);
        } else if ("horizontal" === d.orientation) {
          _e405 += n.y;
          var _t339 = _i342;
          _i342 = _e405, _e405 = _t339, _a209 = this.renderer._ptdist(l, s, _e405, _i342);
        } else _e405 += n.x, _a209 = Math.abs(l - _e405);

        (isNaN(m) || m > _a209) && (m = _a209, u = _o111, p = _e405, g = _i342);
      }

      return {
        index: u,
        value: r.xoffsets.data[u],
        polarAxisCoords: c,
        x: p,
        y: g
      };
    }
  }, {
    key: "onmousemove",
    value: function onmousemove(e, t) {
      var a = Math.abs;
      if (this._mouseX === e && this._mouseY === t) return;
      if (this._mouseX = e, this._mouseY = t, !this._selected) return;
      var n = this._selected.group,
          o = this._selected.series,
          r = this.seriesGroups[n],
          l = r.series[o],
          s = this._plotRect;
      if (this.renderer && (s = this.renderer.getRect(), s.x += 5, s.y += 5, s.width -= 10, s.height -= 10), e < s.x + window.scrollX || e > s.x + s.width + window.scrollX || t < s.y + window.scrollY || t > s.y + s.height + window.scrollY) return this._hideToolTip(), void this._unselect();
      var d = "horizontal" === r.orientation;

      if (s = this._plotRect, -1 !== r.type.indexOf("line") || -1 !== r.type.indexOf("area")) {
        var c = this._getHorizontalOffset(n, this._selected.series, e, t),
            m = c.index;

        if (void 0 === m || null === m) return;

        if (this._selected.item !== m) {
          var _e406 = this._linesRenderInfo[n][o].segments,
              _t340 = 0;

          for (; m > _e406[_t340].lastItemIndex;) {
            if (_t340++, _t340 >= _e406.length) return;
          }

          var _i344 = _e406[_t340].pathElement,
              _a210 = _e406[_t340].lastItemIndex;
          this._unselect(!1), this._select(_i344, "path", n, o, m, _a210);
        }

        var _i343 = this._getSymbol(this._selected.group, this._selected.series);

        "none" === _i343 && (_i343 = "circle");

        var u = this._calcGroupOffsets(n, s),
            p = u.offsets[this._selected.series][m].to,
            g = p;

        -1 !== r.type.indexOf("range") && (g = u.offsets[this._selected.series][m].from);
        var h = d ? e : t;
        if (t = !isNaN(g) && a(h - g) < a(h - p) ? g : p, isNaN(t)) return;

        if (e = c.value, d) {
          var _i345 = e;
          e = t, t = _i345 + s.y;
        } else e += s.x;

        if (c.polarAxisCoords && (e = c.x, t = c.y), t = this.renderer._ptrnd(t), e = this.renderer._ptrnd(e), this._pointMarker && this._pointMarker.element && (this.renderer.removeElement(this._pointMarker.element), this._pointMarker.element = void 0), isNaN(e) || isNaN(t)) return;

        var _ = this._getSeriesColors(n, o, m),
            f = this._getSerieSettings(n, o),
            b = l.symbolSizeSelected;

        isNaN(b) && (b = l.symbolSize), (isNaN(b) || 50 < b || 0 > b) && (b = r.symbolSize), (isNaN(b) || 50 < b || 0 > b) && (b = 8), (this.showToolTips || this.enableCrosshairs) && (this._pointMarker = {
          type: _i343,
          x: e,
          y: t,
          gidx: n,
          sidx: o,
          iidx: m
        }, this._pointMarker.element = this._drawSymbol(_i343, e, t, _.fillColorSymbolSelected, f.opacity, _.lineColorSymbolSelected, f.opacity, f.strokeSymbol, f.dashStyle, b), this._installHandlers(this._pointMarker.element, "pointMarker", n, o, m)), this._startTooltipTimer(n, this._selected.series, m);
      }
    }
  }, {
    key: "_drawSymbol",
    value: function _drawSymbol(e, t, i, a, n, o, r, l, s, d) {
      var c = d || 6,
          m = c / 2,
          u,
          p;

      switch (e) {
        case "none":
          return;

        case "circle":
          u = this.renderer.circle(t, i, c / 2);
          break;

        case "square":
          --c, m = c / 2, u = this.renderer.rect(t - m, i - m, c, c);
          break;

        case "diamond":
          p = "M " + (t - m) + "," + i + " L" + t + "," + (i - m) + " L" + (t + m) + "," + i + " L" + t + "," + (i + m) + " Z", u = this.renderer.path(p);
          break;

        case "triangle_up":
        case "triangle":
          p = "M " + (t - m) + "," + (i + m) + " L " + (t + m) + "," + (i + m) + " L " + t + "," + (i - m) + " Z", u = this.renderer.path(p);
          break;

        case "triangle_down":
          p = "M " + (t - m) + "," + (i - m) + " L " + t + "," + (i + m) + " L " + (t + m) + "," + (i - m) + " Z", u = this.renderer.path(p);
          break;

        case "triangle_left":
          p = "M " + (t - m) + "," + i + " L " + (t + m) + "," + (i + m) + " L " + (t + m) + "," + (i - m) + " Z", u = this.renderer.path(p);
          break;

        case "triangle_right":
          p = "M " + (t - m) + "," + (i - m) + " L " + (t - m) + "," + (i + m) + " L " + (t + m) + "," + i + " Z", u = this.renderer.path(p);
          break;

        default:
          u = this.renderer.circle(t, i, c);
      }

      return this.renderer.attr(u, {
        fill: a,
        "fill-opacity": n,
        stroke: o,
        "stroke-width": l,
        "stroke-opacity": r,
        "stroke-dasharray": s || ""
      }), "circle" !== e && (this.renderer.attr(u, {
        r: c / 2
      }), "square" !== e && this.renderer.attr(u, {
        x: t,
        y: i
      })), u;
    }
  }, {
    key: "_getSymbol",
    value: function _getSymbol(e, t) {
      var i = ["circle", "square", "diamond", "triangle_up", "triangle_down", "triangle_left", "triangle_right"],
          a = this.seriesGroups[e],
          n = a.series[t],
          o;
      return (void 0 !== n.symbolType && null !== n.symbolType && (o = n.symbolType), (void 0 === o || null === o) && (o = a.symbolType), "default" === o) ? i[t % i.length] : void 0 !== o && null !== o ? o : "none";
    }
  }, {
    key: "_startTooltipTimer",
    value: function _startTooltipTimer(e, t, i, a, n, o, r) {
      this._cancelTooltipTimer();

      var l = this,
          s = this.toolTipShowDelay;
      (isNaN(s) || 1e4 < s || 0 > s) && (s = 500), (this._ttEl || !0 === this.enableCrosshairs && !1 === this.showToolTips) && (s = 0), isNaN(o) || (s = o), clearTimeout(this._tttimerHide), isNaN(a) && (a = l._mouseX), isNaN(n) && (n = l._mouseY - 3), 0 === s && l._showToolTip(a, n, e, t, i), this._tttimer = setTimeout(function () {
        0 !== s && l._showToolTip(a, n, e, t, i);
        var o = l.toolTipHideDelay;
        isNaN(r) || (o = r), isNaN(o) && (o = 4e3), l._tttimerHide = setTimeout(function () {
          l._hideToolTip(), l._unselect();
        }, o);
      }, s);
    }
  }, {
    key: "_cancelTooltipTimer",
    value: function _cancelTooltipTimer() {
      clearTimeout(this._tttimer);
    }
  }, {
    key: "_getGroupGradientType",
    value: function _getGroupGradientType(e) {
      var t = this.seriesGroups[e];
      if (-1 !== t.type.indexOf("area")) return "horizontal" === t.orientation ? "horizontalLinearGradient" : "verticalLinearGradient";
      return this._isColumnType(t.type) || -1 !== t.type.indexOf("candle") ? t.polar ? "radialGradient" : "horizontal" === t.orientation ? "verticalLinearGradient" : "horizontalLinearGradient" : -1 !== t.type.indexOf("scatter") || -1 !== t.type.indexOf("bubble") || this._isPieGroup(e) ? "radialGradient" : void 0;
    }
  }, {
    key: "_select",
    value: function _select(e, t, i, a, n, o) {
      if (this._selected) if (this._selected.item !== n || this._selected.series !== a || this._selected.group !== i) this._unselect();else return;
      var r = this.seriesGroups[i],
          l = r.series[a];
      if (!1 === r.enableSelection || !1 === l.enableSelection) return;
      var s = -1 !== r.type.indexOf("line") && -1 === r.type.indexOf("area");
      this._selected = {
        element: e,
        type: t,
        group: i,
        series: a,
        item: n,
        iidxBase: o,
        isLineType: s,
        linesUnselectMode: l.linesUnselectMode || r.linesUnselectMode
      };

      var d = this._getColors(i, a, o || n, this._getGroupGradientType(i)),
          c = d.fillColorSelected;

      s && (c = "none");

      var m = this._getSerieSettings(i, a),
          u = "symbol" === t ? d.lineColorSymbolSelected : d.lineColorSelected;

      c = "symbol" === t ? d.fillColorSymbolSelected : c;
      var p = "symbol" === t ? 1 : m.stroke;
      this.renderer.getAttr(e, "fill") === d.fillColorAlt && (c = d.fillColorAltSelected), this.renderer.attr(e, {
        stroke: u,
        fill: c,
        "stroke-width": p
      }), (-1 !== r.type.indexOf("pie") || -1 !== r.type.indexOf("donut")) && this._applyPieSelect(), this._raiseItemEvent("mouseover", r, l, n);
    }
  }, {
    key: "_applyPieSelect",
    value: function _applyPieSelect() {
      var e = this;

      e._createAnimationGroup("animPieSlice");

      var t = this._selected;

      if (t) {
        var i = this.getItemCoord(t.group, t.series, t.item);

        if (i) {
          var a = this._getRenderInfo(t.group, t.series, t.item);

          this._enqueueAnimation("animPieSlice", void 0, void 0, 300, function (i, a, n) {
            var o = a.coord,
                r = o.selectedRadiusChange * n,
                l = e.renderer.pieSlicePath(o.center.x, o.center.y, 0 === o.innerRadius ? 0 : o.innerRadius + r, o.outerRadius + r, o.fromAngle, o.toAngle, o.centerOffset);
            e.renderer.attr(a.element.element, {
              d: l
            }), e._showPieLabel(t.group, t.series, t.item, void 0, r, a.element.colors.lineColor);
          }, {
            element: a,
            coord: i
          }), e._startAnimation("animPieSlice");
        }
      }
    }
  }, {
    key: "_applyPieUnselect",
    value: function _applyPieUnselect() {
      this._stopAnimations();

      var e = this._selected;

      if (e) {
        var _t341 = this.getItemCoord(e.group, e.series, e.item);

        if (_t341 && _t341.center) {
          var _i346 = this.renderer.pieSlicePath(_t341.center.x, _t341.center.y, _t341.innerRadius, _t341.outerRadius, _t341.fromAngle, _t341.toAngle, _t341.centerOffset);

          this.renderer.attr(e.element, {
            d: _i346
          }), this._showPieLabel(e.group, e.series, e.item, void 0, 0, this._getRenderInfo(e.group, e.series, e.item).colors.lineColor);
        }
      }
    }
  }, {
    key: "_unselect",
    value: function _unselect() {
      var e = this;

      if (e._selected) {
        var _t342 = e._selected.group,
            _i347 = e._selected.series,
            _a211 = e._selected.item,
            _n174 = e._selected.iidxBase,
            _o112 = e._selected.type,
            _r67 = e.seriesGroups[_t342],
            _l56 = _r67.series[_i347],
            _s50 = -1 !== _r67.type.indexOf("line") && -1 === _r67.type.indexOf("area"),
            d = e._getColors(_t342, _i347, _n174 || _a211, e._getGroupGradientType(_t342)),
            c = d.fillColor;

        _s50 && (c = "none");

        var m = e._getSerieSettings(_t342, _i347),
            u = "symbol" === _o112 ? d.lineColorSymbol : d.lineColor;

        c = "symbol" === _o112 ? d.fillColorSymbol : c, this.renderer.getAttr(e._selected.element, "fill") === d.fillColorAltSelected && (c = d.fillColorAlt);
        var p = "symbol" === _o112 ? 1 : m.stroke;
        e.renderer.attr(e._selected.element, {
          stroke: u,
          fill: c,
          "stroke-width": p
        }), (-1 !== _r67.type.indexOf("pie") || -1 !== _r67.type.indexOf("donut")) && this._applyPieUnselect(), e._selected = void 0, isNaN(_a211) || e._raiseItemEvent("mouseout", _r67, _l56, _a211);
      }

      e._pointMarker && (e._pointMarker.element && (e.renderer.removeElement(e._pointMarker.element), e._pointMarker.element = void 0), e._pointMarker = void 0, e._hideCrosshairs());
    }
  }, {
    key: "_raiseItemEvent",
    value: function _raiseItemEvent(e, t, i, a) {
      var n = i[e] || t[e],
          o = 0;

      for (; o < this.seriesGroups.length && !(this.seriesGroups[o] === t); o++) {
        ;
      }

      if (o !== this.seriesGroups.length) {
        var _r68 = {
          event: e,
          seriesGroup: t,
          serie: i,
          elementIndex: a,
          elementValue: this._getDataValue(a, i.dataField, o)
        };
        n && "function" == typeof n && n(_r68), this.$.fireEvent(e, _r68);
      }
    }
  }, {
    key: "_calcInterval",
    value: function _calcInterval(e, t, i) {
      var a = Math.abs;
      var n = a(t - e),
          o = n / i,
          r = .1,
          l = [1, 2, 3, 4, 5, 10, 15, 20, 25, 50, 100];
      1 > o && (l = [.5, .25, .125, .1], r = 10);
      var s = 0;

      do {
        s = 0, 1 <= o ? r *= 10 : r /= 10;

        for (var _e407 = 1; _e407 < l.length && a(l[s] * r - o) > a(l[_e407] * r - o); _e407++) {
          s = _e407;
        }
      } while (s == l.length - 1);

      return l[s] * r;
    }
  }, {
    key: "_renderDataClone",
    value: function _renderDataClone() {
      if (this._renderData && !this._isToggleRefresh) {
        var e = this._elementRenderInfo = [];
        if (!this._isSelectorRefresh) for (var _t343 = 0; _t343 < this._renderData.length; _t343++) {
          for (; e.length <= _t343;) {
            e.push({});
          }

          var _i348 = e[_t343],
              _a212 = this._renderData[_t343];
          if (!_a212.offsets) continue;
          if (_a212.valueAxis) for (var _e408 in _i348.valueAxis = {
            itemOffsets: {}
          }, _a212.valueAxis.itemOffsets) {
            _i348.valueAxis.itemOffsets[_e408] = _a212.valueAxis.itemOffsets[_e408];
          }
          if (_a212.xAxis) for (var _e409 in _i348.xAxis = {
            itemOffsets: {}
          }, _a212.xAxis.itemOffsets) {
            _i348.xAxis.itemOffsets[_e409] = _a212.xAxis.itemOffsets[_e409];
          }
          _i348.series = [];

          var _n175 = _i348.series,
              _o113 = this._isPieGroup(_t343);

          for (var _e410 = 0; _e410 < _a212.offsets.length; _e410++) {
            _n175.push({});

            for (var _t344 = 0; _t344 < _a212.offsets[_e410].length; _t344++) {
              if (!_o113) _n175[_e410][_a212.xoffsets.xvalues[_t344]] = {
                value: _a212.offsets[_e410][_t344].value,
                valueRadius: _a212.offsets[_e410][_t344].valueRadius,
                xoffset: _a212.xoffsets.data[_t344],
                from: _a212.offsets[_e410][_t344].from,
                to: _a212.offsets[_e410][_t344].to
              };else {
                var _i349 = _a212.offsets[_e410][_t344];
                _n175[_e410][_i349.displayValue] = {
                  value: _i349.value,
                  x: _i349.x,
                  y: _i349.y,
                  fromAngle: _i349.fromAngle,
                  toAngle: _i349.toAngle
                };
              }
            }
          }
        }
      }
    }
  }, {
    key: "getPolarDataPointOffset",
    value: function getPolarDataPointOffset(e, t, i) {
      var a = this._renderData[i];
      if (!a) return {
        x: NaN,
        y: NaN
      };

      var n = this.getValueAxisDataPointOffset(t, i),
          o = this.getXAxisDataPointOffset(e, i),
          r = this._toPolarCoord(a.polarCoords, a.xAxis.rect, o, n);

      return {
        x: r.x,
        y: r.y
      };
    }
  }, {
    key: "_getDataPointOffsetDiff",
    value: function _getDataPointOffsetDiff(e, t, i, a, n, o, r) {
      var l = this._getDataPointOffset(e, i, a, n, o, r),
          s = this._getDataPointOffset(t, i, a, n, o, r);

      return Math.abs(l - s);
    }
  }, {
    key: "_getXAxisRenderData",
    value: function _getXAxisRenderData(e) {
      if (e >= this._renderData.length) return;
      var t = this.seriesGroups[e],
          a = this._renderData[e].xAxis;

      if (a) {
        if (void 0 === t.xAxis || null === t.xAxis) for (var _t345 = 0; _t345 <= e; _t345++) {
          if (void 0 === this.seriesGroups[_t345].xAxis || null === this.seriesGroups[_t345].xAxis) {
            a = this._renderData[_t345].xAxis;
            break;
          }
        }
        return a;
      }
    }
  }, {
    key: "getXAxisDataPointOffset",
    value: function getXAxisDataPointOffset(e, t) {
      var i = this.seriesGroups[t];
      if (isNaN(e)) return NaN;

      var a = this._getXAxisRenderData(t);

      if (!a) return NaN;
      var n = a.data.axisStats,
          o = n.min.valueOf(),
          r = n.max.valueOf(),
          l = r - o;
      if (0 === l && (l = 1), e.valueOf() > r || e.valueOf() < o) return NaN;

      var s = this._getXAxis(t),
          d = "horizontal" === i.orientation ? "height" : "width",
          c = "horizontal" === i.orientation ? "y" : "x",
          m = (e.valueOf() - o) / l,
          u = a.rect[d] - a.data.padding.left - a.data.padding.right;

      if (i.polar || i.spider) {
        var _e411 = this._renderData[t].polarCoords;
        _e411.isClosedCircle && (u = a.data.axisSize);
      }

      return this._plotRect[c] + a.data.padding.left + u * (s.flip ? 1 - m : m);
    }
  }, {
    key: "getValueAxisDataPointOffset",
    value: function getValueAxisDataPointOffset(e, t) {
      var i = this._getValueAxis(t);

      if (!i) return NaN;
      var a = this._renderData[t];
      if (!a) return NaN;
      var n = !0 === i.flip,
          o = a.logBase,
          r = a.scale,
          l = a.gbase,
          s = a.baseOffset;
      return this._getDataPointOffset(e, l, o, r, s, n);
    }
  }, {
    key: "_getDataPointOffset",
    value: function _getDataPointOffset(e, t, i, a, n, o) {
      var r;
      return isNaN(e) && (e = t), r = isNaN(i) ? (e - t) * a : (this._draw.log(e, i) - this._draw.log(t, i)) * a, r = o ? n + r : n - r, r;
    }
  }, {
    key: "_calcGroupOffsets",
    value: function _calcGroupOffsets(e, t) {
      var a = Math.abs;
      var n = this.seriesGroups[e];

      for (; this._renderData.length < e + 1;) {
        this._renderData.push({});
      }

      if (null !== this._renderData[e] && void 0 !== this._renderData[e].offsets) return this._renderData[e];
      if (this._isPieGroup(e)) return this._calcPieSeriesGroupOffsets(e, t);

      var i = this._getValueAxis(e);

      if (!i || !n.series || 0 === n.series.length) return this._renderData[e];

      var o = !0 === i.flip,
          r = !0 === i.logarithmicScale,
          l = i.logarithmicScaleBase || 10,
          s = [],
          d = -1 !== n.type.indexOf("stacked"),
          c = d && -1 !== n.type.indexOf("100"),
          m = -1 !== n.type.indexOf("range"),
          u = this._isColumnType(n.type),
          p = -1 !== n.type.indexOf("waterfall"),
          g = this._getDataLen(e),
          _ = n.baselineValue || i.baselineValue || 0;

      c && (_ = 0);
      var f = this._stats.seriesGroups[e];
      if (!f || !f.isValid) return;
      var h = f.hasStackValueReversal;

      if (h && (_ = 0), p && d) {
        if (h) return;
        _ = f.base;
      }

      _ > f.max && (_ = f.max), _ < f.min && (_ = f.min);
      var b = c || r ? f.maxRange : f.max - f.min,
          y = f.min,
          v = f.max,
          w = t.height / (r ? f.intervals : b),
          C = 0;
      c ? 0 > y * v ? (b /= 2, C = -(b + _) * w) : C = -_ * w : C = -(_ - y) * w, o ? C = t.y - C : C += t.y + t.height;
      var x = [],
          S = [],
          D = [],
          T;
      r && (T = this._draw.log(v, l) - this._draw.log(_, l), d && (T = f.intervals, _ = c ? 0 : y), !o && (C = t.y + T / f.intervals * t.height)), C = this.renderer._ptrnd(C);
      var $ = 0 > y * v ? t.height / 2 : t.height,
          I = [],
          A = [],
          E = d && (u || r),
          B = [];
      s = Array(n.series.length);

      for (var _i350 = 0; _i350 < n.series.length; _i350++) {
        s[_i350] = Array(g);
      }

      for (var _u5 = 0; _u5 < g; _u5++) {
        !p && d && (A = []);

        for (var _t346 = 0; _t346 < n.series.length; _t346++) {
          !d && r && (I = []);

          var _i351 = n.series[_t346],
              _p6 = _i351.dataField,
              _g5 = _i351.dataFieldFrom,
              _b = _i351.dataFieldTo,
              _v2 = _i351.radiusDataField || _i351.sizeDataField;

          s[_t346][_u5] = {};

          var _T = this._isSerieVisible(e, _t346);

          if (-1 !== n.type.indexOf("candle") || -1 !== n.type.indexOf("ohlc")) {
            var _a213 = ["Open", "Close", "High", "Low"];

            for (var _n176 in _a213) {
              var _d27 = "dataField" + _a213[_n176];

              _i351[_d27] && (s[_t346][_u5][_a213[_n176]] = this._getDataPointOffset(this._getDataValueAsNumber(_u5, _i351[_d27], e), _, r ? l : NaN, w, C, o));
            }

            continue;
          }

          if (d) for (; A.length <= _u5;) {
            A.push(0);
          }
          var _L = NaN;
          m && (_L = this._getDataValueAsNumber(_u5, _g5, e), isNaN(_L) && (_L = _));
          var M = NaN;
          M = m ? this._getDataValueAsNumber(_u5, _b, e) : this._getDataValueAsNumber(_u5, _p6, e);

          var H = this._getDataValueAsNumber(_u5, _v2, e);

          if (d && (A[_u5] += _T ? M : 0), _T || (M = NaN), isNaN(M) || r && 0 >= M) {
            s[_t346][_u5] = {
              from: void 0,
              to: void 0
            };
            continue;
          }

          var k = void 0;
          d && (E ? k = M >= _ ? x : S : M = A[_u5]);
          var z = w * (M - _);

          if (m && (z = w * (M - _L)), d && E && (B[_u5] ? z = w * M : (B[_u5] = !0, z = w * (M - _))), r) {
            for (; I.length <= _u5;) {
              I.push({
                p: {
                  value: 0,
                  height: 0
                },
                n: {
                  value: 0,
                  height: 0
                }
              });
            }

            var _e412 = m || m ? _L : _,
                _t347 = M > _e412 ? I[_u5].p : I[_u5].n;

            _t347.value += M, c ? (M = 100 * (_t347.value / (f.psums[_u5] + f.nsums[_u5])), z = (this._draw.log(M, l) - f.minPow) * w) : (z = this._draw.log(_t347.value, l) - this._draw.log(_e412, l), z *= w), z -= _t347.height, _t347.height += z;
          }

          var _h5 = C;

          if (m) {
            var _e413 = 0;
            _e413 = r ? (this._draw.log(_L, l) - this._draw.log(_, l)) * w : (_L - _) * w, _h5 += o ? _e413 : -_e413;
          }

          if (d) {
            if (c && !r) {
              var _e414 = f.psums[_u5] - f.nsums[_u5];

              M > _ ? (z = f.psums[_u5] / _e414 * $, 0 !== f.psums[_u5] && (z *= M / f.psums[_u5])) : (z = f.nsums[_u5] / _e414 * $, 0 !== f.nsums[_u5] && (z *= M / f.nsums[_u5]));
            }

            E && (isNaN(k[_u5]) && (k[_u5] = _h5), _h5 = k[_u5]);
          }

          isNaN(D[_u5]) && (D[_u5] = 0);
          var _y = D[_u5];
          z = a(z);
          var P = z;

          if (1 <= z) {
            var _e415 = this.renderer._ptrnd(z) - 1;

            z = .5 < a(z - _e415) ? Math.round(z) : _e415;
          }

          if (_y += z - P, d || (_y = 0), .5 < a(_y) && (0 < _y ? (z -= 1, _y -= 1) : (z += 1, _y += 1)), D[_u5] = _y, _t346 == n.series.length - 1 && c) {
            var _e416 = 0;

            for (var _i352 = 0; _i352 < _t346; _i352++) {
              _e416 += a(s[_i352][_u5].to - s[_i352][_u5].from);
            }

            if (_e416 += z, _e416 < $) if (.5 < z) z = this.renderer._ptrnd(z + $ - _e416);else for (var _i353 = _t346 - 1, _n177; 0 <= _i353;) {
              if (_n177 = a(s[_i353][_u5].to - s[_i353][_u5].from), 1 < _n177) {
                s[_i353][_u5].from > s[_i353][_u5].to && (s[_i353][_u5].from += $ - _e416);
                break;
              }

              _i353--;
            }
          }

          o && (z *= -1);
          var F = M < _;
          m && (F = _L > M);
          var O = isNaN(_L) ? M : {
            from: _L,
            to: M
          };
          F ? (E && (k[_u5] += z), s[_t346][_u5] = {
            from: _h5,
            to: _h5 + z,
            value: O,
            valueRadius: H
          }) : (E && (k[_u5] -= z), s[_t346][_u5] = {
            from: _h5,
            to: _h5 - z,
            value: O,
            valueRadius: H
          });
        }
      }

      var L = this._renderData[e];
      return L.baseOffset = C, L.gbase = _, L.logBase = r ? l : NaN, L.scale = w, L.offsets = p ? this._applyWaterfall(s, g, e, C, _, r ? l : NaN, w, o, d) : s, L.xoffsets = this._calculateXOffsets(e, t.width), this._renderData[e];
    }
  }, {
    key: "_isPercent",
    value: function _isPercent(e) {
      return "string" == typeof e && 0 < e.length && e.indexOf("%") === e.length - 1;
    }
  }, {
    key: "_calcPieSeriesGroupOffsets",
    value: function _calcPieSeriesGroupOffsets(e, t) {
      var i = this,
          a = this._getDataLen(e),
          n = this.seriesGroups[e],
          o = this._renderData[e] = {},
          r = o.offsets = [];

      for (var _o114 = 0; _o114 < n.series.length; _o114++) {
        var l = n.series[_o114],
            s = this._get([l.minAngle, l.startAngle]);

        (isNaN(s) || 0 > s || 360 < s) && (s = 0);

        var d = this._get([l.maxAngle, l.endAngle]);

        (isNaN(d) || 0 > d || 360 < d) && (d = 360);
        var c = d - s,
            m = l.initialAngle || 0;
        m < s && (m = s), m > d && (m = d);

        var u = l.centerOffset || 0,
            p = this._draw.getNum([l.offsetX, n.offsetX, t.width / 2]),
            g = this._draw.getNum([l.offsetY, n.offsetY, t.height / 2]),
            h = Math.min(t.width, t.height) / 2,
            _ = m,
            f = l.radius;

        i._isPercent(f) && (f = parseFloat(f) / 100 * h), isNaN(f) && (f = .4 * h);
        var b = l.innerRadius;
        i._isPercent(b) && (b = parseFloat(b) / 100 * h), (isNaN(b) || b >= f) && (b = 0);
        var v = l.selectedRadiusChange;
        i._isPercent(v) && (v = parseFloat(v) / 100 * (f - b)), isNaN(v) && (v = .1 * (f - b)), r.push([]);
        var w = 0,
            C = 0;

        for (var _t348 = 0; _t348 < a; _t348++) {
          var S = this._getDataValueAsNumber(_t348, l.dataField, e);

          isNaN(S) || !this._isSerieVisible(e, _o114, _t348) && !0 !== l.hiddenPointsDisplay || (0 < S ? w += S : C += S);
        }

        var D = w - C;
        0 == D && (D = 1);

        for (var _n178 = 0; _n178 < a; _n178++) {
          var S = this._getDataValueAsNumber(_n178, l.dataField, e);

          if (isNaN(S)) {
            r[_o114].push({});

            continue;
          }

          var T = l.displayText || l.displayField,
              $ = this._getDataValue(_n178, T, e);

          ($ === void 0 || null === $) && ($ = _n178);

          var I = 0,
              A = this._isSerieVisible(e, _o114, _n178);

          (A || !0 === l.hiddenPointsDisplay) && (I = Math.abs(S) / D * c);
          var E = t.x + p,
              x = t.y + g,
              y = u;
          "function" == typeof u && (y = u({
            seriesIndex: _o114,
            seriesGroupIndex: e,
            itemIndex: _n178
          })), isNaN(y) && (y = 0);
          var B = {
            key: e + "_" + _o114 + "_" + _n178,
            value: S,
            displayValue: $,
            x: E,
            y: x,
            fromAngle: _,
            toAngle: _ + I,
            centerOffset: y,
            innerRadius: b,
            outerRadius: f,
            selectedRadiusChange: v,
            visible: A
          };
          r[_o114].push(B), _ += I;
        }
      }

      return o;
    }
  }, {
    key: "_isPointSeriesOnly",
    value: function _isPointSeriesOnly() {
      for (var e = 0, _t349; e < this.seriesGroups.length; e++) {
        if (_t349 = this.seriesGroups[e], -1 === _t349.type.indexOf("line") && -1 === _t349.type.indexOf("area") && -1 === _t349.type.indexOf("scatter") && -1 === _t349.type.indexOf("bubble")) return !1;
      }

      return !0;
    }
  }, {
    key: "_hasColumnSeries",
    value: function _hasColumnSeries() {
      var e = ["column", "ohlc", "candlestick", "waterfall"];

      for (var _t350 = 0, _i354; _t350 < this.seriesGroups.length; _t350++) {
        for (var _a214 in _i354 = this.seriesGroups[_t350], e) {
          if (-1 !== _i354.type.indexOf(e[_a214])) return !0;
        }
      }

      return !1;
    }
  }, {
    key: "_alignValuesWithTicks",
    value: function _alignValuesWithTicks(e) {
      var t = this._isPointSeriesOnly(),
          i = this.seriesGroups[e],
          a = this._getXAxis(e),
          n = void 0 === a.valuesOnTicks || null === a.valuesOnTicks ? t : !1 !== a.valuesOnTicks;

      return a.logarithmicScale && (n = !0), void 0 === e || null === e ? n : void 0 === i.valuesOnTicks || null === i.valuesOnTicks ? n : i.valuesOnTicks;
    }
  }, {
    key: "_getYearsDiff",
    value: function _getYearsDiff(e, t) {
      return t.getFullYear() - e.getFullYear();
    }
  }, {
    key: "_getMonthsDiff",
    value: function _getMonthsDiff(e, t) {
      return 12 * (t.getFullYear() - e.getFullYear()) + t.getMonth() - e.getMonth();
    }
  }, {
    key: "_getDateDiff",
    value: function _getDateDiff(e, t, i, a) {
      var n = 0;

      switch ("year" !== i && "month" !== i && (n = t.valueOf() - e.valueOf()), i) {
        case "year":
          n = this._getYearsDiff(e, t);
          break;

        case "month":
          n = this._getMonthsDiff(e, t);
          break;

        case "day":
          n /= 86400000;
          break;

        case "hour":
          n /= 3600000;
          break;

        case "minute":
          n /= 60000;
          break;

        case "second":
          n /= 1e3;
          break;

        case "millisecond":
      }

      return "year" !== i && "month" !== i && !1 !== a && (n = this.renderer._rnd(n, 1, !0)), n;
    }
  }, {
    key: "_getBestDTUnit",
    value: function _getBestDTUnit(e, t, a, n, o) {
      var r = "day",
          l = t.valueOf() - e.valueOf();
      r = 1e3 > l ? "second" : 36e5 > l ? "minute" : 864e5 > l ? "hour" : 2592e6 > l ? "day" : 31104e6 > l ? "month" : "year";
      var s = [{
        key: "year",
        cnt: l / 31536000000
      }, {
        key: "month",
        cnt: l / 2592000000
      }, {
        key: "day",
        cnt: l / 86400000
      }, {
        key: "hour",
        cnt: l / 3600000
      }, {
        key: "minute",
        cnt: l / 60000
      }, {
        key: "second",
        cnt: l / 1e3
      }, {
        key: "millisecond",
        cnt: l
      }],
          d = -1;

      for (var _i355 = 0; _i355 < s.length; _i355++) {
        if (s[_i355].key === r) {
          d = _i355;
          break;
        }
      }

      var c = -1,
          m = -1;

      for (; d < s.length && !(s[d].cnt / 100 > n); d++) {
        var _i356 = this._estAxisInterval(e, t, a, n, s[d].key, o),
            _r69 = this._getDTIntCnt(e, t, _i356, s[d].key);

        (-1 === c || c < _r69) && (c = _r69, m = d);
      }

      return r = s[m].key, r;
    }
  }, {
    key: "_getXAxisStats",
    value: function _getXAxisStats(e, t, i) {
      var a = Math.pow,
          n = Math.max;

      var o = this._getDataLen(e),
          r = "date" === t.type || "time" === t.type;

      if (r && !this._autoDateFormats) {
        this._autoDateFormats || (this._autoDateFormats = []);

        var _e417 = this._testXAxisDateFormat();

        _e417 && this._autoDateFormats.push(_e417);
      }

      var l = r ? this._castAsDate(t.minValue, t.dateFormat) : this._castAsNumber(t.minValue),
          s = r ? this._castAsDate(t.maxValue, t.dateFormat) : this._castAsNumber(t.maxValue);

      if (this._selectorRange && this._selectorRange[e]) {
        var _i357 = this._selectorRange[e].min;
        isNaN(_i357) || (l = r ? this._castAsDate(_i357, t.dateFormat) : this._castAsNumber(_i357));
        var _a215 = this._selectorRange[e].max;
        isNaN(_a215) || (s = r ? this._castAsDate(_a215, t.dateFormat) : this._castAsNumber(_a215));
      }

      var d = l,
          c = s,
          m = void 0 === t.type || null === t.type || "auto" === t.type,
          u = m || "basic" === t.type,
          p = 0,
          g = 0,
          h,
          _;

      for (var _a216 = 0, _n179; _a216 < o && t.dataField; _a216++) {
        _n179 = this._getDataValue(_a216, t.dataField, e), _n179 = r ? this._castAsDate(_n179, t.dateFormat) : this._castAsNumber(_n179), isNaN(_n179) || (r ? p++ : g++, (isNaN(h) || _n179 < h) && (h = _n179), (isNaN(_) || _n179 >= _) && (_ = _n179));
      }

      m && (!r && g === o || r && p === o) && (u = !1), u && (h = 0, _ = n(0, o - 1)), isNaN(d) && (d = h), isNaN(c) && (c = _), r ? (!this._isDate(d) && (d = this._isDate(c) ? c : new Date()), !this._isDate(c) && (c = this._isDate(d) ? d : new Date())) : (isNaN(d) && (d = 0), isNaN(c) && (c = u ? n(0, o - 1) : d)), (void 0 === h || null === h) && (h = d), (void 0 === _ || null === _) && (_ = c);
      var f = t.rangeSelector && t.rangeSelector.visible;

      if (f) {
        var _e418 = f.minValue || d;

        _e418 && r && (_e418 = this._castAsDate(_e418, f.dateFormat || t.dateFormat));

        var _i358 = f.maxValue || c;

        _i358 && r && (_i358 = this._castAsDate(_i358, f.dateFormat || t.rangeSelector)), d < _e418 && (d = _e418), c < _e418 && (c = _i358), d > _i358 && (d = _e418), c > _i358 && (c = _i358);
      }

      var b, y;
      r && (b = t.baseUnit, !b && (b = this._getBestDTUnit(d, c, e, i)), y = "hour" === b || "minute" === b || "second" === b || "millisecond" === b);
      var v = !0 === t.logarithmicScale,
          w = t.logarithmicScaleBase;
      (isNaN(w) || 1 >= w) && (w = 10);
      var C = t.unitInterval;
      v ? C = 1 : (isNaN(C) || 0 >= C) && (C = this._estAxisInterval(d, c, e, i, b));
      var x = {
        min: d,
        max: c
      },
          S = this.seriesGroups[e],
          D,
          T;
      return v ? (!d && (d = 1, c && d > c && (d = c)), !c && (c = d), x = {
        min: d,
        max: c
      }, D = this.renderer._rnd(this._draw.log(d, w), 1, !1), T = this.renderer._rnd(this._draw.log(c, w), 1, !0), c = a(w, T), d = a(w, D)) : !r && (S.polar || S.spider) && (d = this.renderer._rnd(d, C, !1), c = this.renderer._rnd(c, C, !0)), {
        min: d,
        max: c,
        logAxis: {
          enabled: v,
          base: w,
          minPow: D,
          maxPow: T
        },
        dsRange: {
          min: h,
          max: _
        },
        filterRange: x,
        useIndeces: u,
        isDateTime: r,
        isTimeUnit: y,
        dateTimeUnit: b,
        interval: C
      };
    }
  }, {
    key: "_getDefaultDTFormatFn",
    value: function _getDefaultDTFormatFn(e) {
      var t = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          i;
      return i = "year" === e || "month" === e || "day" === e ? function (e) {
        return e.getDate() + "-" + t[e.getMonth()] + "-" + e.getFullYear();
      } : function (e) {
        return e.getDate() + "-" + t[e.getMonth()] + "-" + e.getFullYear() + "<br>" + e.getHours() + ":" + e.getMinutes() + ":" + e.getSeconds();
      }, i;
    }
  }, {
    key: "_getDTIntCnt",
    value: function _getDTIntCnt(e, t, i, a) {
      var n = 0,
          o = new Date(e),
          r = new Date(t);
      if (r = r.valueOf(), 0 >= i) return 1;

      for (; o.valueOf() < r;) {
        "millisecond" === a ? o = new Date(o.valueOf() + i) : "second" === a ? o = new Date(o.valueOf() + 1e3 * i) : "minute" === a ? o = new Date(o.valueOf() + 6e4 * i) : "hour" === a ? o = new Date(o.valueOf() + 24 * (6e4 * i)) : "day" === a ? o.setDate(o.getDate() + i) : "month" === a ? o.setMonth(o.getMonth() + i) : "year" == a && o.setFullYear(o.getFullYear() + i), n++;
      }

      return n;
    }
  }, {
    key: "_estAxisInterval",
    value: function _estAxisInterval(e, t, a, n, o, r) {
      if (isNaN(e) || isNaN(t)) return NaN;
      var l = [1, 2, 5, 10, 15, 20, 50, 100, 200, 500],
          s = 0,
          d = n / (!isNaN(r) && 0 < r ? r : 50);

      if (this._renderData && this._renderData.length > a && this._renderData[a].xAxis && !isNaN(this._renderData[a].xAxis.avgWidth)) {
        var _e419 = Math.max(1, this._renderData[a].xAxis.avgWidth);

        0 !== _e419 && isNaN(r) && (d = .9 * n / _e419);
      }

      if (1 >= d) return Math.abs(t - e);
      var c = 0,
          m;

      for (; m = s >= l.length ? Math.pow(10, 3 + s - l.length) : l[s], c = this._isDate(e) && this._isDate(t) ? this._getDTIntCnt(e, t, m, o) : (t - e) / m, !(c <= d);) {
        s++;
      }

      var u = this.seriesGroups[a];
      return (u.spider || u.polar) && 2 * m > t - e && (m = t - e), m;
    }
  }, {
    key: "_getPaddingSize",
    value: function _getPaddingSize(e, t, i, a, n, o, r) {
      var l = Math.max,
          s = e.min,
          d = e.max;
      e.logAxis.enabled && (s = e.logAxis.minPow, d = e.logAxis.maxPow);
      var c = e.interval,
          m = e.dateTimeUnit;

      if (n) {
        var u = a / l(1, d - s + c) * c;
        return o ? {
          left: 0,
          right: u
        } : i ? {
          left: 0,
          right: 0
        } : {
          left: u / 2,
          right: u / 2
        };
      }

      if (i && !r) return {
        left: 0,
        right: 0
      };

      if (this._isDate(s) && this._isDate(d)) {
        var p = this._getDTIntCnt(s, d, Math.min(c, d - s), m),
            g = a / l(2, p);

        return {
          left: g / 2,
          right: g / 2
        };
      }

      var p = l(1, d - s);

      if (1 === p) {
        var _e420 = a / 4;

        return {
          left: _e420,
          right: _e420
        };
      }

      var g = a / (p + 1);
      return {
        left: g / 2,
        right: g / 2
      };
    }
  }, {
    key: "_calculateXOffsets",
    value: function _calculateXOffsets(e, t) {
      var i = Math.abs,
          a = this.seriesGroups[e],
          n = this._getXAxis(e),
          o = [],
          r = [],
          l = this._getDataLen(e),
          s = this._getXAxisStats(e, n, t),
          d = s.min,
          c = s.max,
          m = s.isDateTime,
          u = s.isTimeUnit,
          p = this._hasColumnSeries(),
          g = a.polar || a.spider,
          h = this._get([a.startAngle, a.minAngle, 0]),
          _ = this._get([a.endAngle, a.maxAngle, 360]),
          f = g && !(1e-4 < i(i(_ - h) - 360)),
          b = this._alignValuesWithTicks(e),
          y = this._getPaddingSize(s, n, b, t, g, f, p),
          v = c - d,
          w = s.filterRange;

      0 === v && (v = 1);
      var C = t - y.left - y.right;
      g && b && !f && (y.left = y.right = 0);
      var S = -1,
          D = -1;

      for (var _a217 = 0; _a217 < l; _a217++) {
        var T = void 0 === n.dataField ? _a217 : this._getDataValue(_a217, n.dataField, e);

        if (s.useIndeces) {
          if (_a217 < w.min || _a217 > w.max) {
            o.push(NaN), r.push(void 0);
            continue;
          }

          if (I = y.left + (_a217 - d) / v * C, !0 === s.logAxis.enabled) {
            var $ = s.logAxis.base;
            I = this._smartPlot.scale(T, {
              min: d.valueOf(),
              max: c.valueOf(),
              type: "logarithmic",
              base: $
            }, {
              min: 0,
              max: C,
              flip: !1
            });
          }

          o.push(this.renderer._ptrnd(I)), r.push(T), -1 == S && (S = _a217), (-1 == D || D < _a217) && (D = _a217);
          continue;
        }

        if (T = m ? this._castAsDate(T, n.dateFormat) : this._castAsNumber(T), isNaN(T) || T < w.min || T > w.max) {
          o.push(NaN), r.push(void 0);
          continue;
        }

        var I = 0;

        if (!0 === s.logAxis.enabled) {
          var $ = s.logAxis.base;
          I = this._smartPlot.scale(T, {
            min: d.valueOf(),
            max: c.valueOf(),
            type: "logarithmic",
            base: $
          }, {
            min: 0,
            max: C,
            flip: !1
          });
        } else I = !m || m && u ? (T - d) * C / v : (T.valueOf() - d.valueOf()) / (c.valueOf() - d.valueOf()) * C;

        I = this.renderer._ptrnd(y.left + I), o.push(I), r.push(T), -1 == S && (S = _a217), (-1 == D || D < _a217) && (D = _a217);
      }

      if (!0 === n.flip) for (var _e421 = 0; _e421 < o.length; _e421++) {
        isNaN(o[_e421]) || (o[_e421] = t - o[_e421]);
      }
      (u || m) && (v = this._getDateDiff(d, c, n.baseUnit), v = this.renderer._rnd(v, 1, !1));
      var A = Math.max(1, v),
          E = C / A;
      return S == D && 1 === A && (o[S] = y.left + C / 2), {
        axisStats: s,
        data: o,
        xvalues: r,
        first: S,
        last: D,
        length: -1 == D ? 0 : D - S + 1,
        itemWidth: E,
        intervalWidth: E * s.interval,
        rangeLength: v,
        useIndeces: s.useIndeces,
        padding: y,
        axisSize: C
      };
    }
  }, {
    key: "_getXAxis",
    value: function _getXAxis(e) {
      return void 0 === e || null === e || this.seriesGroups.length <= e ? this.xAxis : this.seriesGroups[e].xAxis || this.xAxis;
    }
  }, {
    key: "_isGreyScale",
    value: function _isGreyScale(e, t) {
      var i = this.seriesGroups[e],
          a = i.series[t];
      if (!0 === a.greyScale) return !0;
      return !1 !== a.greyScale && (!0 === i.greyScale || !1 !== i.greyScale && !0 === this.greyScale);
    }
  }, {
    key: "_getSeriesColors",
    value: function _getSeriesColors(e, t, i) {
      var a = this._getSeriesColorsInternal(e, t, i);

      if (this._isGreyScale(e, t)) for (var _e422 in a) {
        a[_e422] = this._draw.toGreyScale(a[_e422]);
      }
      return a;
    }
  }, {
    key: "_getColorFromScheme",
    value: function _getColorFromScheme(e, t, i) {
      var a = "#000000",
          n = this.seriesGroups[e],
          o = n.series[t];

      if (this._isPieGroup(e)) {
        var _r70 = this._getDataLen(e);

        a = this._getItemColorFromScheme(o.colorScheme || n.colorScheme || this.colorScheme, t * _r70 + i, e, t);
      } else {
        var _o115 = 0;

        for (var _a218 = 0; _a218 <= e; _a218++) {
          for (var _i359 = 0; _i359 < this.seriesGroups[_a218].series.length && (_a218 !== e || parseInt(_i359) !== t); _i359++) {
            _o115++;
          }
        }

        var _r71 = this.colorScheme;
        if (n.colorScheme && (_r71 = n.colorScheme), (void 0 === _r71 || null === _r71 || "" === _r71) && (_r71 = this.colorSchemes[0].name), !_r71) return a;

        for (var _e423 = 0, _t351; _e423 < this.colorSchemes.length; _e423++) {
          if (_t351 = this.colorSchemes[_e423], _t351.name === _r71) {
            for (; _o115 > _t351.colors.length;) {
              _o115 -= _t351.colors.length, ++_e423 >= this.colorSchemes.length && (_e423 = 0), _t351 = this.colorSchemes[_e423];
            }

            a = _t351.colors[_o115 % _t351.colors.length];
          }
        }
      }

      return a;
    }
  }, {
    key: "_createColorsCache",
    value: function _createColorsCache() {
      this._colorsCache = {
        get: function get(e) {
          if (this._store[e]) return this._store[e];
        },
        set: function set(e, t) {
          1e4 > this._size && (this._store[e] = t, this._size++);
        },
        clear: function clear() {
          this._store = {}, this._size = 0;
        },
        _size: 0,
        _store: {}
      };
    }
  }, {
    key: "_getSeriesColorsInternal",
    value: function _getSeriesColorsInternal(e, t, i) {
      var a = this.seriesGroups[e],
          n = a.series[t];
      "function" === !typeof n.colorFunction && "pie" !== a.type && "donut" !== a.type && (i = NaN);
      var o = e + "_" + t + "_" + (isNaN(i) ? "NaN" : i);
      if (this._colorsCache.get(o)) return this._colorsCache.get(o);
      var r = {
        lineColor: "#222222",
        lineColorSelected: "#151515",
        lineColorSymbol: "#222222",
        lineColorSymbolSelected: "#151515",
        fillColor: "#222222",
        fillColorSelected: "#333333",
        fillColorSymbol: "#222222",
        fillColorSymbolSelected: "#333333",
        fillColorAlt: "#222222",
        fillColorAltSelected: "#333333"
      },
          l;

      if ("function" == typeof n.colorFunction) {
        var _t352 = isNaN(i) ? NaN : this._getDataValue(i, n.dataField, e);

        if (-1 !== a.type.indexOf("range") && !isNaN(i)) {
          var _a219 = this._getDataValue(i, n.dataFieldFrom, e),
              _o116 = this._getDataValue(i, n.dataFieldTo, e);

          _t352 = {
            from: _a219,
            to: _o116
          };
        }

        if (l = n.colorFunction(_t352, i, n, a), "object" == typeof l) for (var _e424 in l) {
          r[_e424] = l[_e424];
        } else r.fillColor = l;
      } else {
        for (var _e425 in r) {
          n[_e425] && (r[_e425] = n[_e425]);
        }

        n.fillColor || n.color ? n.fillColor = n.fillColor || n.color : r.fillColor = this._getColorFromScheme(e, t, i);
      }

      var s = {
        fillColor: {
          baseColor: "fillColor",
          adjust: 1
        },
        fillColorSelected: {
          baseColor: "fillColor",
          adjust: 1.1
        },
        fillColorSymbol: {
          baseColor: "fillColor",
          adjust: 1
        },
        fillColorSymbolSelected: {
          baseColor: "fillColorSymbol",
          adjust: 2
        },
        fillColorAlt: {
          baseColor: "fillColor",
          adjust: 4
        },
        fillColorAltSelected: {
          baseColor: "fillColor",
          adjust: 3
        },
        lineColor: {
          baseColor: "fillColor",
          adjust: .95
        },
        lineColorSelected: {
          baseColor: "lineColor",
          adjust: .95
        },
        lineColorSymbol: {
          baseColor: "lineColor",
          adjust: 1
        },
        lineColorSymbolSelected: {
          baseColor: "lineColorSelected",
          adjust: 1
        }
      };

      for (var _a220 in r) {
        ("object" != typeof l || !l[_a220]) && n[_a220] && (r[_a220] = n[_a220]);
      }

      for (var _a221 in r) {
        ("object" != typeof l || !l[_a221]) && (n[_a221] || (r[_a221] = this.renderer.adjustColor(r[s[_a221].baseColor], s[_a221].adjust)));
      }

      return this._colorsCache.set(o, r), r;
    }
  }, {
    key: "_getItemColorFromScheme",
    value: function _getItemColorFromScheme(e, t, a, n) {
      var o;

      for ((void 0 === e || "" === e) && (e = this.colorSchemes[0].name), o = 0; o < this.colorSchemes.length && !(e === this.colorSchemes[o].name); o++) {
        ;
      }

      for (var _i360 = 0; _i360 <= t;) {
        o === this.colorSchemes.length && (o = 0);
        var _e426 = this.colorSchemes[o].colors.length;
        if (_i360 + _e426 <= t) _i360 += _e426, o++;else {
          var _e427 = this.colorSchemes[o].colors[t - _i360];
          return this._isGreyScale(a, n) && 0 === _e427.indexOf("#") && (_e427 = this._draw.toGreyScale(_e427)), _e427;
        }
      }
    }
  }, {
    key: "getColorScheme",
    value: function getColorScheme(e) {
      for (var _t353 = 0; _t353 < this.colorSchemes.length; _t353++) {
        if (this.colorSchemes[_t353].name === e) return this.colorSchemes[_t353].colors;
      }
    }
  }, {
    key: "addColorScheme",
    value: function addColorScheme(e, t) {
      for (var _a222 = 0; _a222 < this.colorSchemes.length; _a222++) {
        if (this.colorSchemes[_a222].name === e) return void (this.colorSchemes[_a222].colors = t);
      }

      this.colorSchemes.push({
        name: e,
        colors: t
      });
    }
  }, {
    key: "removeColorScheme",
    value: function removeColorScheme(e) {
      for (var _t354 = 0; _t354 < this.colorSchemes.length; _t354++) {
        if (this.colorSchemes[_t354].name === e) {
          this.colorSchemes.splice(_t354, 1);
          break;
        }
      }
    }
  }, {
    key: "_formatValue",
    value: function _formatValue(e, t, i, a, n, o) {
      if (e === void 0 || null === e) return "";
      if (this._isObject(e) && !this._isDate(e) && !i) return "";

      if (i) {
        if ("function" != typeof i) return e.toString();

        try {
          return i(e, o, n, a);
        } catch (t) {
          return t.message;
        }
      }

      return this._isNumber(e) ? this._formatNumber(e, t) : this._isDate(e) ? this._formatDate(e, t) : t ? (t.prefix || "") + e.toString() + (t.sufix || "") : e.toString();
    }
  }, {
    key: "_getFormattedValue",
    value: function _getFormattedValue(e, t, a, i, n, o) {
      var r = this.seriesGroups[e],
          l = r.series[t],
          s = "",
          d = i,
          c = n;
      l.labels && (d = d || this._getFormatSettings(l.labels), c = c || l.labels.formatFunction), d || c || (d = this._getFormatSettings(l), c = l.formatFunction, !d && !c && (d = this._getFormatSettings(r), c = r.formatFunction));
      var m = {},
          u = 0;

      for (var _r72 in l) {
        0 === _r72.indexOf("dataField") && (m[_r72.substring(9).toLowerCase()] = this._getDataValue(a, l[_r72], e), u++);
      }

      if (0 == u && (m = this._getDataValue(a, void 0, e)), -1 !== r.type.indexOf("waterfall") && this._isSummary(e, a) && (m = this._renderData[e].offsets[t][a].value, u = 0), c && "function" == typeof c) try {
        return c(1 == u ? m[""] : m, a, l, r);
      } catch (t) {
        return t.message;
      }
      if (1 == u && this._isPieGroup(e)) return this._formatValue(m[""], d, c, e, t, a);

      if (0 < u) {
        var _n180 = 0;

        for (var _i361 in m) {
          0 < _n180 && "" !== s && (s += "<br>");

          var _r73 = "dataField" + (0 < _i361.length ? _i361.substring(0, 1).toUpperCase() + _i361.substring(1) : ""),
              _u6 = "displayText" + (0 < _i361.length ? _i361.substring(0, 1).toUpperCase() + _i361.substring(1) : ""),
              p = l[_u6] || l[_r73],
              g = m[_i361];

          if (void 0 !== g) g = this._formatValue(g, d, c, e, t, a);else continue;
          s += !0 === o ? g : p + ": " + g, _n180++;
        }
      } else void 0 !== m && null !== m && (s = this._formatValue(m, d, c, e, t, a));

      return s || "";
    }
  }, {
    key: "_isNumberAsString",
    value: function _isNumberAsString(e) {
      if ("string" != typeof e) return !1;
      e = e.trim();

      for (var _t355 = 0, _i362; _t355 < e.length; _t355++) {
        if (_i362 = e.charAt(_t355), !("0" <= _i362 && "9" >= _i362 || "," === _i362 || "." === _i362) && ("-" !== _i362 || 0 != _t355) && ("(" !== _i362 || 0 != _t355) && (")" !== _i362 || _t355 != e.length - 1)) return !1;
      }

      return !0;
    }
  }, {
    key: "_castAsDate",
    value: function _castAsDate(e, t) {
      if (e instanceof Date && !isNaN(e)) return e;

      if ("string" == typeof e) {
        var _a223 = new Date(e);

        if (this._isDate(_a223)) return -1 === e.indexOf(":") && _a223.setHours(0, 0, 0, 0), _a223;

        try {
          if (t && (_a223 = Smart.Utilities.DateTime.parseDateString(e, void 0, t).toDate(), this._isDate(_a223))) return _a223;
          if (this._autoDateFormats) for (var _t356 = 0; _t356 < this._autoDateFormats.length; _t356++) {
            if (_a223 = Smart.Utilities.DateTime.parseDateString(e, void 0, this._autoDateFormats[_t356]).toDate(), this._isDate(_a223)) return _a223;
          }

          var _i363 = this._detectDateFormat(e);

          if (_i363 && (_a223 = Smart.Utilities.DateTime.parseDateString(e, void 0, _i363).toDate(), this._isDate(_a223))) return this._autoDateFormats.push(_i363), _a223;
        } catch (e) {}
      }
    }
  }, {
    key: "_castAsNumber",
    value: function _castAsNumber(e) {
      if (e instanceof Date && !isNaN(e)) return e.valueOf();
      if ("string" == typeof e) if (this._isNumber(e)) e = parseFloat(e);else if (!/[a-zA-Z]/.test(e)) {
        var _t357 = new Date(e);

        void 0 !== _t357 && null !== _t357 && (e = _t357.valueOf());
      }
      return isNaN(e) ? void 0 : e;
    }
  }, {
    key: "_isNumber",
    value: function _isNumber(e) {
      return "string" == typeof e && this._isNumberAsString(e) && (e = parseFloat(e)), "number" == typeof e && isFinite(e);
    }
  }, {
    key: "_isDate",
    value: function _isDate(e) {
      return e instanceof Date && !isNaN(e.getDate());
    }
  }, {
    key: "_isBoolean",
    value: function _isBoolean(e) {
      return "boolean" == typeof e;
    }
  }, {
    key: "_isObject",
    value: function _isObject(e) {
      return e && ("object" == typeof e || "function" == typeof e) || !1;
    }
  }, {
    key: "_formatDate",
    value: function _formatDate(e, t) {
      var i = e.toString();
      return t && (t.dateFormat && (i = new Smart.Utilities.DateTime(e).toString(t.dateFormat)), i = (t.prefix || "") + i + (t.sufix || "")), i;
    }
  }, {
    key: "_formatNumber",
    value: function _formatNumber(e, t) {
      if (!this._isNumber(e)) return e;
      t = t || {};
      var i = this;
      var a = i.localization.decimalSeparator,
          n = i.localization.thousandsSeparator;
      t.decimalSeparator && (a = t.decimalSeparator), t.thousandsSeparator && (n = t.thousandsSeparator);
      var o = t.prefix || "",
          r = t.sufix || "",
          l = t.decimalPlaces;
      isNaN(l) && (l = this._getDecimalPlaces([e], void 0, 3));
      var s = t.negativeWithBrackets || !1,
          d = 0 > e;
      d && s && (e *= -1);
      var c = e.toString(),
          m = Math.pow(10, l),
          u;
      if (c = (Math.round(e * m) / m).toString(), isNaN(c) && (c = ""), u = c.lastIndexOf("."), 0 < l) for (0 > u ? (c += a, u = c.length - 1) : "." !== a && (c = c.replace(".", a)); c.length - 1 - u < l;) {
        c += "0";
      }
      u = c.lastIndexOf(a), u = -1 < u ? u : c.length;
      var p = c.substring(u),
          g = 0;

      for (var _a224 = u; 0 < _a224; _a224--, g++) {
        0 == g % 3 && _a224 !== u && (!d || 1 < _a224 || d && s) && (p = n + p), p = c.charAt(_a224 - 1) + p;
      }

      return c = p, d && s && (c = "(" + c + ")"), o + c + r;
    }
  }, {
    key: "_calculateControlPoints",
    value: function _calculateControlPoints(e, t) {
      var i = Math.sqrt,
          a = Math.pow;
      var n = e[t],
          o = e[t + 1],
          r = e[t + 2],
          l = e[t + 3],
          s = e[t + 4],
          d = e[t + 5],
          c = .4,
          m = i(a(r - n, 2) + a(l - o, 2)),
          u = i(a(s - r, 2) + a(d - l, 2)),
          p = m + u;
      0 === p && (p = 1);
      var g = c * m / p,
          h = c - g;
      return [r + g * (n - s), l + g * (o - d), r - h * (n - s), l - h * (o - d)];
    }
  }, {
    key: "_getBezierPoints",
    value: function _getBezierPoints(e) {
      var t = Math.abs;
      var a = "",
          n = [],
          o = [],
          r = e.split(" ");

      for (var _t358 = 0, _i364; _t358 < r.length; _t358++) {
        _i364 = r[_t358].split(","), n.push(parseFloat(_i364[0])), n.push(parseFloat(_i364[1])), isNaN(n[n.length - 1]) || isNaN(n[n.length - 2]);
      }

      var l = n.length;
      if (1 >= l) return "";
      if (2 === l) return a = "M" + this.renderer._ptrnd(n[0]) + "," + this.renderer._ptrnd(n[1]) + " L" + this.renderer._ptrnd(n[0] + 1) + "," + this.renderer._ptrnd(n[1] + 1) + " ", a;

      for (var _t359 = 0; _t359 < l - 4; _t359 += 2) {
        o = o.concat(this._calculateControlPoints(n, _t359));
      }

      for (var _t360 = 2; _t360 < l - 5; _t360 += 2) {
        a += " C" + this.renderer._ptrnd(o[2 * _t360 - 2]) + "," + this.renderer._ptrnd(o[2 * _t360 - 1]) + " " + this.renderer._ptrnd(o[2 * _t360]) + "," + this.renderer._ptrnd(o[2 * _t360 + 1]) + " " + this.renderer._ptrnd(n[_t360 + 2]) + "," + this.renderer._ptrnd(n[_t360 + 3]) + " ";
      }

      return a = 4 >= l || 3 > t(n[0] - n[2]) || 3 > t(n[1] - n[3]) ? "M" + this.renderer._ptrnd(n[0]) + "," + this.renderer._ptrnd(n[1]) + " L" + this.renderer._ptrnd(n[2]) + "," + this.renderer._ptrnd(n[3]) + " " + a : "M" + this.renderer._ptrnd(n[0]) + "," + this.renderer._ptrnd(n[1]) + " Q" + this.renderer._ptrnd(o[0]) + "," + this.renderer._ptrnd(o[1]) + " " + this.renderer._ptrnd(n[2]) + "," + this.renderer._ptrnd(n[3]) + " " + a, 4 <= l && (3 > t(n[l - 2] - n[l - 4]) || 3 > t(n[l - 1] - n[l - 3])) ? a += " L" + this.renderer._ptrnd(n[l - 2]) + "," + this.renderer._ptrnd(n[l - 1]) + " " : 5 <= l && (a += " Q" + this.renderer._ptrnd(o[2 * l - 10]) + "," + this.renderer._ptrnd(o[2 * l - 9]) + " " + this.renderer._ptrnd(n[l - 2]) + "," + this.renderer._ptrnd(n[l - 1]) + " "), a;
    }
  }, {
    key: "_createAnimationGroup",
    value: function _createAnimationGroup(e) {
      this._animGroups || (this._animGroups = {}), this._animGroups[e] = {
        animations: [],
        startTick: NaN
      };
    }
  }, {
    key: "_startAnimation",
    value: function _startAnimation(e) {
      var t = new Date(),
          i = t.getTime();
      this._animGroups[e].startTick = i, this._runAnimation(), this._enableAnimTimer();
    }
  }, {
    key: "_enqueueAnimation",
    value: function _enqueueAnimation(e, t, i, a, n, o, r) {
      0 > a && (a = 0), r === void 0 && (r = "easeInOutSine"), this._animGroups[e].animations.push({
        key: t,
        properties: i,
        duration: a,
        fn: n,
        context: o,
        easing: r
      });
    }
  }, {
    key: "_stopAnimations",
    value: function _stopAnimations() {
      clearTimeout(this._animtimer), this._animtimer = void 0, this._animGroups = void 0;
    }
  }, {
    key: "_enableAnimTimer",
    value: function _enableAnimTimer() {
      if (!this._animtimer) {
        var e = this;
        this._animtimer = setTimeout(function () {
          e._runAnimation();
        }, this._animTickInt);
      }
    }
  }, {
    key: "_runAnimation",
    value: function _runAnimation() {
      if (this._animGroups) {
        var e = new Date(),
            _t361 = e.getTime(),
            _i365 = {};

        for (var _e428 in this._animGroups) {
          var _a225 = this._animGroups[_e428].animations,
              _n181 = this._animGroups[_e428].startTick,
              _o117 = 0;

          for (var _e429 = 0; _e429 < _a225.length; _e429++) {
            var _i366 = _a225[_e429],
                _r74 = _t361 - _n181;

            _i366.duration > _o117 && (_o117 = _i366.duration);

            var _l57 = 0 < _i366.duration ? _r74 / _i366.duration : 1,
                _s51 = _l57;

            if (_i366.easing && 0 !== _i366.duration && !1 !== _i366.duration && (_s51 = Smart.Utilities.Animation.Easings[_i366.easing](_r74, 0, 1, _i366.duration)), 1 < _l57 && (_l57 = 1, _s51 = 1), _i366.fn) {
              _i366.fn(_i366.key, _i366.context, _s51);

              continue;
            }

            var d = {};

            for (var _e430 = 0; _e430 < _i366.properties.length; _e430++) {
              var _t362 = _i366.properties[_e430],
                  _a226 = 0;
              _a226 = 1 == _l57 ? _t362.to : _s51 * (_t362.to - _t362.from) + _t362.from, d[_t362.key] = _a226;
            }

            this.renderer.attr(_i366.key, d);
          }

          _n181 + _o117 > _t361 && (_i365[_e428] = {
            startTick: _n181,
            animations: _a225
          });
        }

        this._animGroups = _i365, this.renderer instanceof Smart.Utilities.HTML5Renderer && this.renderer.refresh();
      }

      this._animtimer = null, 0 < Object.values(this._animGroups).length && this._enableAnimTimer();
    }
  }, {
    key: "_fixCoords",
    value: function _fixCoords(e, t) {
      var i = "horizontal" === this.seriesGroups[t].orientation;
      if (!i) return e;
      var a = e.x;
      e.x = e.y, e.y = a + this._plotRect.y - this._plotRect.x;
      var a = e.width;
      return e.width = e.height, e.height = a, e;
    }
  }, {
    key: "getItemCoord",
    value: function getItemCoord(e, t, i) {
      var a = Math.min,
          n = Math.abs,
          o = Math.sin,
          r = Math.cos,
          l = Math.PI,
          d = this;
      if (d._isPieGroup(e) && (!d._isSerieVisible(e, t, i) || !d._renderData || d._renderData.length <= e)) return {
        x: NaN,
        y: NaN
      };
      if (!d._isSerieVisible(e, t) || !d._renderData || d._renderData.length <= e) return {
        x: NaN,
        y: NaN
      };

      var c = d.seriesGroups[e],
          m = c.series[t],
          s = d._getItemCoord(e, t, i);

      if (d._isPieGroup(e)) {
        if (isNaN(s.x) || isNaN(s.y) || isNaN(s.fromAngle) || isNaN(s.toAngle)) return {
          x: NaN,
          y: NaN
        };
        var u = this._plotRect,
            p = s.fromAngle * (l / 180),
            g = s.toAngle * (l / 180);

        var _e431 = u.x + s.center.x + r(p) * s.outerRadius,
            _t363 = u.x + s.center.x + r(g) * s.outerRadius,
            _i367 = u.y + s.center.y - o(p) * s.outerRadius,
            _d28 = u.y + s.center.y - o(g) * s.outerRadius;

        var h = a(_e431, _t363),
            _ = n(_t363 - _e431);

        var _c13 = a(_i367, _d28);

        var f = n(_d28 - _i367);
        return s = {
          x: h,
          y: _c13,
          width: _,
          height: f,
          center: s.center,
          centerOffset: s.centerOffset,
          innerRadius: s.innerRadius,
          outerRadius: s.outerRadius,
          selectedRadiusChange: s.selectedRadiusChange,
          fromAngle: s.fromAngle,
          toAngle: s.toAngle
        }, s;
      }

      if (-1 !== c.type.indexOf("column") || -1 !== c.type.indexOf("waterfall")) {
        var b = this._getColumnSerieWidthAndOffset(e, t);

        s.height = n(s.y.to - s.y.from), s.y = a(s.y.to, s.y.from), s.x += b.offset, s.width = b.width;
      } else if (-1 !== c.type.indexOf("ohlc") || -1 !== c.type.indexOf("candlestick")) {
        var b = this._getColumnSerieWidthAndOffset(e, t);

        var _i368 = s.y;
        var v = a(_i368.Open, _i368.Close, _i368.Low, _i368.High),
            w = Math.max(_i368.Open, _i368.Close, _i368.Low, _i368.High);
        s.height = n(w - v), s.y = v, s.x += b.offset, s.width = b.width;
      } else if (-1 !== c.type.indexOf("line") || -1 !== c.type.indexOf("area")) s.width = s.height = 0, s.y = s.y.to;else if (-1 !== c.type.indexOf("bubble") || -1 !== c.type.indexOf("scatter")) {
        s.center = {
          x: s.x,
          y: s.y.to
        };
        var y = s.y.radius;
        "circle" !== m.symbolType && void 0 !== m.symbolType && null !== m.symbolType && (y /= 2), s.y = s.y.to, s.radius = y, s.width = 2 * y, s.height = 2 * y;
      }

      if (s = this._fixCoords(s, e), c.polar || c.spider) {
        var C = this._toPolarCoord(this._renderData[e].polarCoords, this._plotRect, s.x, s.y);

        s.x = C.x, s.y = C.y, s.center && (s.center = this._toPolarCoord(this._renderData[e].polarCoords, this._plotRect, s.center.x, s.center.y));
      }

      return (-1 !== c.type.indexOf("bubble") || -1 !== c.type.indexOf("scatter")) && (s.x -= y, s.y -= y), s;
    }
  }, {
    key: "_getItemCoord",
    value: function _getItemCoord(e, t, i) {
      var a = this.seriesGroups[e],
          n,
          o;
      if (!a || !this._renderData) return {
        x: NaN,
        y: NaN
      };
      var r = a.series[t];
      if (!r) return {
        x: NaN,
        y: NaN
      };
      var l = this._plotRect;

      if (this._isPieGroup(e)) {
        var _a227 = this._renderData[e].offsets[t][i];
        if (!_a227) return {
          x: NaN,
          y: NaN
        };

        var _r75 = (_a227.fromAngle + _a227.toAngle) / 2 * (Math.PI / 180);

        return n = l.x + _a227.x + Math.cos(_r75) * _a227.outerRadius, o = l.y + _a227.y - Math.sin(_r75) * _a227.outerRadius, {
          x: n,
          y: o,
          center: {
            x: _a227.x,
            y: _a227.y
          },
          centerOffset: _a227.centerOffset,
          innerRadius: _a227.innerRadius,
          outerRadius: _a227.outerRadius,
          selectedRadiusChange: _a227.selectedRadiusChange,
          fromAngle: _a227.fromAngle,
          toAngle: _a227.toAngle
        };
      }

      if (n = l.x + this._renderData[e].xoffsets.data[i], o = this._renderData[e].offsets[t][i], isNaN(n) || !o) return {
        x: NaN,
        y: NaN
      };
      var s = {};

      for (var _a228 in o) {
        s[_a228] = o[_a228];
      }

      return {
        x: n,
        y: s
      };
    }
  }, {
    key: "getXAxisValue",
    value: function getXAxisValue(e, t) {
      var i = Math.PI,
          a = this.seriesGroups[t];

      if (a) {
        var n = this._getXAxis(t),
            o = this._plotRect,
            r = 0,
            l = NaN,
            s = this._renderData[0].xoffsets.axisStats,
            d = 0,
            c = 0;

        if (a.polar || a.spider) {
          if (isNaN(e.x) || isNaN(e.y)) return NaN;

          var m = this._getPolarAxisCoords(t, o),
              u = this.renderer._ptdist(e.x, e.y, m.x, m.y);

          if (u > m.r) return NaN;
          var p = Math.atan2(m.y - e.y, e.x - m.x);
          p = i / 2 - p, 0 > p && (p = 2 * i + p), l = p * m.r;
          var g = m.startAngle + i / 2,
              h = m.endAngle + i / 2;
          d = g * m.r, c = h * m.r, r = (h - g) * m.r;

          var _ = this._getPaddingSize(s, n, n.valuesOnTicks, r, !0, m.isClosedCircle, this._hasColumnSeries());

          m.isClosedCircle ? (r -= _.left + _.right, c -= _.left + _.right) : !n.valuesOnTicks && (d += _.left, c -= _.right);
        } else {
          if ("horizontal" !== a.orientation) {
            if (e < o.x || e > o.x + o.width) return NaN;
            l = e - o.x, r = o.width;
          } else {
            if (e < o.y || e > o.y + o.height) return NaN;
            l = e - o.y, r = o.height;
          }

          if (this._renderData[t] && this._renderData[t].xoffsets) {
            var _ = this._renderData[t].xoffsets.padding;
            r -= _.left + _.right, l -= _.left;
          }

          c = r;
        }

        var f = this._smartPlot.scale(l, {
          min: d,
          max: c
        }, {
          min: s.min.valueOf(),
          max: s.max.valueOf(),
          type: s.logAxis.enabled ? "logarithmic" : "linear",
          base: s.logAxis.base,
          flip: n.flip
        });

        return f;
      }
    }
  }, {
    key: "getValueAxisValue",
    value: function getValueAxisValue(e, t) {
      var i = this.seriesGroups[t];
      if (!i) return;

      var a = this._getValueAxis(t),
          n = this._plotRect,
          o = 0,
          r = NaN;

      if (i.polar || i.spider) {
        if (isNaN(e.x) || isNaN(e.y)) return NaN;

        var _i369 = this._getPolarAxisCoords(t, n);

        r = this.renderer._ptdist(e.x, e.y, _i369.x, _i369.y), o = _i369.r, r = o - r;
      } else if ("horizontal" === i.orientation) {
        if (e < n.x || e > n.x + n.width) return NaN;
        r = e - n.x, o = n.width;
      } else {
        if (e < n.y || e > n.y + n.height) return NaN;
        r = e - n.y, o = n.height;
      }

      var l = this._stats.seriesGroups[t],
          s = this._smartPlot.scale(r, {
        min: 0,
        max: o
      }, {
        min: l.min.valueOf(),
        max: l.max.valueOf(),
        type: l.logarithmic ? "logarithmic" : "linear",
        base: l.logBase,
        flip: !a.flip
      });

      return s;
    }
  }, {
    key: "_detectDateFormat",
    value: function _detectDateFormat(e, t) {
      var i = {
        en_US_d: "M/d/yyyy",
        en_US_D: "dddd, MMMM dd, yyyy",
        en_US_t: "h:mm tt",
        en_US_T: "h:mm:ss tt",
        en_US_f: "dddd, MMMM dd, yyyy h:mm tt",
        en_US_F: "dddd, MMMM dd, yyyy h:mm:ss tt",
        en_US_M: "MMMM dd",
        en_US_Y: "yyyy MMMM",
        en_US_S: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
        en_CA_d: "dd/MM/yyyy",
        en_CA_D: "MMMM-dd-yy",
        en_CA_f: "MMMM-dd-yy h:mm tt",
        en_CA_F: "MMMM-dd-yy h:mm:ss tt",
        ISO: "yyyy-MM-dd hh:mm:ss",
        ISO2: "yyyy-MM-dd HH:mm:ss",
        d1: "dd.MM.yyyy",
        d2: "dd-MM-yyyy",
        zone1: "yyyy-MM-ddTHH:mm:ss-HH:mm",
        zone2: "yyyy-MM-ddTHH:mm:ss+HH:mm",
        custom: "yyyy-MM-ddTHH:mm:ss.fff",
        custom2: "yyyy-MM-dd HH:mm:ss.fff",
        de_DE_d: "dd.MM.yyyy",
        de_DE_D: "dddd, d. MMMM yyyy",
        de_DE_t: "HH:mm",
        de_DE_T: "HH:mm:ss",
        de_DE_f: "dddd, d. MMMM yyyy HH:mm",
        de_DE_F: "dddd, d. MMMM yyyy HH:mm:ss",
        de_DE_M: "dd MMMM",
        de_DE_Y: "MMMM yyyy",
        fr_FR_d: "dd/MM/yyyy",
        fr_FR_D: "dddd d MMMM yyyy",
        fr_FR_t: "HH:mm",
        fr_FR_T: "HH:mm:ss",
        fr_FR_f: "dddd d MMMM yyyy HH:mm",
        fr_FR_F: "dddd d MMMM yyyy HH:mm:ss",
        fr_FR_M: "d MMMM",
        fr_FR_Y: "MMMM yyyy",
        it_IT_d: "dd/MM/yyyy",
        it_IT_D: "dddd d MMMM yyyy",
        it_IT_t: "HH:mm",
        it_IT_T: "HH:mm:ss",
        it_IT_f: "dddd d MMMM yyyy HH:mm",
        it_IT_F: "dddd d MMMM yyyy HH:mm:ss",
        it_IT_M: "dd MMMM",
        it_IT_Y: "MMMM yyyy",
        ru_RU_d: "dd.MM.yyyy",
        ru_RU_D: "d MMMM yyyy '?.'",
        ru_RU_t: "H:mm",
        ru_RU_T: "H:mm:ss",
        ru_RU_f: "d MMMM yyyy '?.' H:mm",
        ru_RU_F: "d MMMM yyyy '?.' H:mm:ss",
        ru_RU_Y: "MMMM yyyy",
        cs_CZ_d: "d.M.yyyy",
        cs_CZ_D: "d. MMMM yyyy",
        cs_CZ_t: "H:mm",
        cs_CZ_T: "H:mm:ss",
        cs_CZ_f: "d. MMMM yyyy H:mm",
        cs_CZ_F: "d. MMMM yyyy H:mm:ss",
        cs_CZ_M: "dd MMMM",
        cs_CZ_Y: "MMMM yyyy",
        he_IL_d: "dd MMMM yyyy",
        he_IL_D: "dddd dd MMMM yyyy",
        he_IL_t: "HH:mm",
        he_IL_T: "HH:mm:ss",
        he_IL_f: "dddd dd MMMM yyyy HH:mm",
        he_IL_F: "dddd dd MMMM yyyy HH:mm:ss",
        he_IL_M: "dd MMMM",
        he_IL_Y: "MMMM yyyy",
        hr_HR_d: "d.M.yyyy.",
        hr_HR_D: "d. MMMM yyyy.",
        hr_HR_t: "H:mm",
        hr_HR_T: "H:mm:ss",
        hr_HR_f: "d. MMMM yyyy. H:mm",
        hr_HR_F: "d. MMMM yyyy. H:mm:ss",
        hr_HR_M: "d. MMMM",
        hu_HU_d: "yyyy.MM.dd.",
        hu_HU_D: "yyyy. MMMM d.",
        hu_HU_t: "H:mm",
        hu_HU_T: "H:mm:ss",
        hu_HU_f: "yyyy. MMMM d. H:mm",
        hu_HU_F: "yyyy. MMMM d. H:mm:ss",
        hu_HU_M: "MMMM d.",
        hu_HU_Y: "yyyy. MMMM",
        jp_JP_d: "gg y/M/d",
        jp_JP_D: "gg y'?'M'?'d'?'",
        jp_JP_t: "H:mm",
        jp_JP_T: "H:mm:ss",
        jp_JP_f: "gg y'?'M'?'d'?' H:mm",
        jp_JP_F: "gg y'?'M'?'d'?' H:mm:ss",
        jp_JP_M: "M'?'d'?'",
        jp_JP_Y: "gg y'?'M'?'",
        lt_LT_d: "yyyy.MM.dd",
        lt_LT_D: "yyyy 'm.' MMMM d 'd.'",
        lt_LT_t: "HH:mm",
        lt_LT_T: "HH:mm:ss",
        lt_LT_f: "yyyy 'm.' MMMM d 'd.' HH:mm",
        lt_LT_F: "yyyy 'm.' MMMM d 'd.' HH:mm:ss",
        lt_LT_M: "MMMM d 'd.'",
        lt_LT_Y: "yyyy 'm.' MMMM",
        sa_IN_d: "dd-MM-yyyy",
        sa_IN_D: "dd MMMM yyyy dddd",
        sa_IN_t: "HH:mm",
        sa_IN_T: "HH:mm:ss",
        sa_IN_f: "dd MMMM yyyy dddd HH:mm",
        sa_IN_F: "dd MMMM yyyy dddd HH:mm:ss",
        sa_IN_M: "dd MMMM",
        basic_y: "yyyy",
        basic_ym: "yyyy-MM",
        basic_d: "yyyy-MM-dd",
        basic_dhm: "yyyy-MM-dd hh:mm",
        basic_bhms: "yyyy-MM-dd hh:mm:ss",
        basic2_ym: "MM-yyyy",
        basic2_d: "MM-dd-yyyy",
        basic2_dhm: "MM-dd-yyyy hh:mm",
        basic2_dhms: "MM-dd-yyyy hh:mm:ss",
        basic3_ym: "yyyy/MM",
        basic3_d: "yyyy/MM/dd",
        basic3_dhm: "yyyy/MM/dd hh:mm",
        basic3_bhms: "yyyy/MM/dd hh:mm:ss",
        basic4_ym: "MM/yyyy",
        basic4_d: "MM/dd/yyyy",
        basic4_dhm: "MM/dd/yyyy hh:mm",
        basic4_dhms: "MM/dd/yyyy hh:mm:ss"
      };
      t && (i = Object.assign({}, i, t));
      var a = [];

      for (var _n182 in Array.isArray(e) ? a = e : a.push(e), i) {
        i[_n182] = {
          format: i[_n182],
          count: 0
        };
      }

      for (var _n183 = 0; _n183 < a.length; _n183++) {
        var _e432 = a[_n183];
        if (null !== _e432 && void 0 !== _e432) for (var _t364 in i) {
          try {
            var _a229 = _e432 instanceof Date || Smart.Utilities.DateTime.parseDateString(_e432, void 0, i[_t364].format);

            _a229 && i[_t364].count++;
          } catch (e) {}
        }
      }

      var n = {
        key: void 0,
        count: 0
      };

      for (var _a230 in i) {
        i[_a230].count > n.count && (n.key = _a230, n.count = i[_a230].count);
      }

      return n.key ? i[n.key].format : "";
    }
  }, {
    key: "_testXAxisDateFormat",
    value: function _testXAxisDateFormat(e) {
      var t = this,
          a = t._getXAxis(e),
          n = t._getDataLen(e),
          i = {};

      if (t.localization.patterns) for (var _e433 in t.localization.patterns) {
        i["local_" + _e433] = t.localization.patterns[_e433];
      }
      var o = [];

      for (var _r76 = 0; _r76 < n && 10 > _r76; _r76++) {
        var _i370 = t._getDataValue(_r76, a.dataField, e);

        null === _i370 || _i370 === void 0 || o.push(_i370);
      }

      var r = t._detectDateFormat(o, i);

      return r;
    }
  }, {
    key: "_getThemeColor",
    value: function _getThemeColor(e) {
      if ("light" === this.theme) switch (e) {
        case "background":
          return "#FFFFFF";

        case "line":
          return "#BCBCBC";

        case "band":
          return "#AAAAAA";
      }
      return "background" === e ? "#2E2E2E" : "line" === e ? "#707070" : "band" === e ? "#565656" : void 0;
    }
  }, {
    key: "_legendLayout",
    get: function get() {
      var e = this.legendLayout;
      return null !== e.height || null !== e.left || null !== e.top || null !== e.width || "vertical" === e.flow;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        animationDuration: {
          value: 300,
          type: "number"
        },
        backgroundColor: {
          value: null,
          type: "string?"
        },
        backgroundImage: {
          value: "",
          type: "string"
        },
        borderLineColor: {
          value: null,
          type: "string?"
        },
        borderLineWidth: {
          value: 1,
          type: "number"
        },
        caption: {
          value: "Caption",
          type: "string"
        },
        clip: {
          value: !0,
          type: "boolean"
        },
        colorScheme: {
          value: "scheme01",
          type: "string"
        },
        columnSeriesOverlap: {
          value: !1,
          type: "boolean"
        },
        crosshairsColor: {
          value: null,
          type: "string?"
        },
        crosshairsDashStyle: {
          value: "2,2",
          type: "string"
        },
        crosshairsLineWidth: {
          value: 1,
          type: "number"
        },
        dataSource: {
          value: [],
          type: "object",
          reflectToAttribute: !1
        },
        description: {
          value: "Description",
          type: "string"
        },
        draw: {
          value: null,
          type: "function?"
        },
        drawBefore: {
          value: null,
          type: "function?"
        },
        enableAxisTextAnimation: {
          value: !1,
          type: "boolean"
        },
        enableCrosshairs: {
          value: !1,
          type: "boolean"
        },
        greyScale: {
          value: !1,
          type: "boolean"
        },
        legendLayout: {
          value: {
            flow: {
              value: "horizontal",
              allowedValues: ["horizontal", "vertical"],
              type: "string"
            },
            height: {
              value: null,
              type: "number?"
            },
            left: {
              value: null,
              type: "number?"
            },
            top: {
              value: null,
              type: "number?"
            },
            width: {
              value: null,
              type: "number?"
            }
          },
          type: "object?"
        },
        localization: {
          value: {
            decimalSeparator: {
              value: ".",
              type: "string"
            },
            patterns: {
              value: null,
              type: "object?"
            },
            thousandsSeparator: {
              value: "",
              type: "string"
            }
          },
          type: "object"
        },
        messages: {
          value: {
            en: {
              invalidRadiusDataField: "smart-chart: Invalid radiusDataField value at [{{index}}]",
              invalidSeries: "smart-chart: Invalid property: each series group must have a 'series' property which must be a valid array.",
              invalidSeriesGroups: "smart-chart: Invalid property: 'seriesGroups' property is required and must be a valid array.",
              invalidType: "smart-chart: Invalid serie type \"{{type}}\".",
              missingAxis: "smart-chart: seriesGroup[{{index}}] is missing {{axis}} definition.",
              missingReference: "smart-chart: Missing reference to {{files}}.",
              missingType: "smart-chart: Invalid property: each series group must have a valid 'type' property."
            }
          },
          type: "object",
          extend: !0
        },
        padding: {
          value: {
            bottom: {
              value: 5,
              type: "number"
            },
            left: {
              value: 5,
              type: "number"
            },
            right: {
              value: 5,
              type: "number"
            },
            top: {
              value: 5,
              type: "number"
            }
          },
          type: "object"
        },
        renderEngine: {
          value: "",
          allowedValues: ["", "SVG", "HTML5"],
          type: "string"
        },
        rightToLeft: {
          value: !1,
          type: "boolean"
        },
        seriesGroups: {
          value: [],
          type: "any"
        },
        showBorderLine: {
          value: !0,
          type: "boolean"
        },
        showLegend: {
          value: !0,
          type: "boolean"
        },
        showToolTips: {
          value: !0,
          type: "boolean"
        },
        showToolTipsOnAllSeries: {
          value: !1,
          type: "boolean"
        },
        theme: {
          value: "light",
          allowedValues: ["light", "dark"],
          type: "string"
        },
        titlePadding: {
          value: {
            bottom: {
              value: 10,
              type: "number"
            },
            left: {
              value: 5,
              type: "number"
            },
            right: {
              value: 5,
              type: "number"
            },
            top: {
              value: 5,
              type: "number"
            }
          },
          type: "object"
        },
        toolTipBackground: {
          value: null,
          type: "string?"
        },
        toolTipFormatFunction: {
          value: null,
          type: "function?"
        },
        toolTipHideDelay: {
          value: 4e3,
          type: "number"
        },
        toolTipLineColor: {
          value: null,
          type: "string?"
        },
        toolTipShowDelay: {
          value: 300,
          type: "number"
        },
        valueAxis: {
          value: {
            alternatingBackgroundColor: {
              value: "",
              type: "string"
            },
            alternatingBackgroundColor2: {
              value: "",
              type: "string"
            },
            alternatingBackgroundOpacity: {
              value: 1,
              type: "number"
            },
            axisSize: {
              value: null,
              type: "any"
            },
            bands: {
              value: null,
              type: "array?"
            },
            baselineValue: {
              value: 0,
              type: "any"
            },
            customDraw: {
              value: !1,
              type: "boolean"
            },
            flip: {
              value: !1,
              type: "boolean"
            },
            formatFunction: {
              value: null,
              type: "function?"
            },
            formatSettings: {
              value: {
                dateFormat: {
                  value: null,
                  type: "string?"
                },
                decimalPlaces: {
                  value: null,
                  type: "number?"
                },
                decimalSeparator: {
                  value: null,
                  type: "string?"
                },
                negativeWithBrackets: {
                  value: !1,
                  type: "boolean"
                },
                prefix: {
                  value: "",
                  type: "string"
                },
                sufix: {
                  value: "",
                  type: "string"
                },
                thousandsSeparator: {
                  value: null,
                  type: "string?"
                }
              },
              type: "object"
            },
            gridLines: {
              value: {
                color: {
                  value: "",
                  type: "string"
                },
                custom: {
                  value: null,
                  type: "array?"
                },
                dashStyle: {
                  value: "",
                  type: "string"
                },
                lineWidth: {
                  value: 1,
                  type: "number"
                },
                step: {
                  value: null,
                  type: "number?"
                },
                unitInterval: {
                  value: null,
                  type: "number?"
                },
                visible: {
                  value: !0,
                  type: "any"
                }
              },
              type: "object"
            },
            labels: {
              value: {
                angle: {
                  value: 0,
                  type: "number"
                },
                autoRotate: {
                  value: !1,
                  type: "boolean"
                },
                class: {
                  value: null,
                  type: "string?"
                },
                custom: {
                  value: null,
                  type: "array?"
                },
                formatFunction: {
                  value: null,
                  type: "function?"
                },
                formatSettings: {
                  value: {
                    dateFormat: {
                      value: null,
                      type: "string?"
                    },
                    decimalPlaces: {
                      value: null,
                      type: "number?"
                    },
                    decimalSeparator: {
                      value: null,
                      type: "string?"
                    },
                    negativeWithBrackets: {
                      value: !1,
                      type: "boolean"
                    },
                    prefix: {
                      value: "",
                      type: "string"
                    },
                    sufix: {
                      value: "",
                      type: "string"
                    },
                    thousandsSeparator: {
                      value: null,
                      type: "string?"
                    }
                  },
                  type: "object"
                },
                horizontalAlignment: {
                  value: "center",
                  allowedValues: ["left", "center", "right"],
                  type: "string"
                },
                offset: {
                  value: {
                    x: {
                      value: 0,
                      type: "number"
                    },
                    y: {
                      value: 0,
                      type: "number"
                    }
                  },
                  type: "object"
                },
                rotationPoint: {
                  value: "auto",
                  allowedValues: ["auto", "left", "center", "right", "topleft", "topcenter", "topright", "bottomleft", "bottomcenter", "bottomright", "centermiddle"],
                  type: "string"
                },
                step: {
                  value: null,
                  type: "number?"
                },
                unitInterval: {
                  value: null,
                  type: "number?"
                },
                verticalAlignment: {
                  value: "center",
                  allowedValues: ["top", "center", "bottom"],
                  type: "string"
                },
                visible: {
                  value: !0,
                  type: "any"
                }
              },
              type: "object"
            },
            line: {
              value: {
                color: {
                  value: "",
                  type: "string"
                },
                dashStyle: {
                  value: "",
                  type: "string"
                },
                lineWidth: {
                  value: 1,
                  type: "number"
                },
                visible: {
                  value: !0,
                  type: "any"
                }
              },
              type: "object"
            },
            logarithmicScale: {
              value: !1,
              type: "boolean"
            },
            logarithmicScaleBase: {
              value: 10,
              type: "number"
            },
            maxValue: {
              value: NaN,
              type: "any"
            },
            minValue: {
              value: NaN,
              type: "any"
            },
            padding: {
              value: {
                bottom: {
                  value: 0,
                  type: "number"
                },
                left: {
                  value: 0,
                  type: "number"
                },
                right: {
                  value: 0,
                  type: "number"
                },
                top: {
                  value: 0,
                  type: "number"
                }
              },
              type: "object"
            },
            position: {
              value: "left",
              allowedValues: ["left", "right", "top", "bottom"],
              type: "string"
            },
            textRotationAngle: {
              value: null,
              type: "number?"
            },
            textRotationPoint: {
              value: "auto",
              allowedValues: ["auto", "left", "center", "right", "topleft", "topcenter", "topright", "bottomleft", "bottomcenter", "bottomright", "centermiddle"],
              type: "string"
            },
            tickMarks: {
              value: {
                color: {
                  value: "",
                  type: "string"
                },
                custom: {
                  value: null,
                  type: "array?"
                },
                dashStyle: {
                  value: "",
                  type: "string"
                },
                lineWidth: {
                  value: 1,
                  type: "number"
                },
                size: {
                  value: 4,
                  type: "number"
                },
                step: {
                  value: null,
                  type: "number?"
                },
                unitInterval: {
                  value: null,
                  type: "number?"
                },
                visible: {
                  value: !0,
                  type: "any"
                }
              },
              type: "object"
            },
            title: {
              value: {
                class: {
                  value: null,
                  type: "string?"
                },
                horizontalAlignment: {
                  value: "center",
                  allowedValues: ["left", "center", "right"],
                  type: "string"
                },
                text: {
                  value: "",
                  type: "string"
                },
                verticalAlignment: {
                  value: "center",
                  allowedValues: ["top", "center", "bottom"],
                  type: "string"
                },
                visible: {
                  value: !0,
                  type: "boolean"
                }
              },
              type: "object"
            },
            unitInterval: {
              value: null,
              type: "number?"
            },
            valuesOnTicks: {
              value: !0,
              type: "boolean"
            },
            visible: {
              value: !0,
              type: "boolean"
            }
          },
          type: "object"
        },
        xAxis: {
          value: {
            alternatingBackgroundColor: {
              value: "",
              type: "string"
            },
            alternatingBackgroundColor2: {
              value: "",
              type: "string"
            },
            alternatingBackgroundOpacity: {
              value: 1,
              type: "number"
            },
            axisSize: {
              value: null,
              type: "any"
            },
            bands: {
              value: null,
              type: "array?"
            },
            baseUnit: {
              value: null,
              allowedValues: ["year", "month", "day", "hour", "minute", "second", "millisecond", null],
              type: "string?"
            },
            customDraw: {
              value: !1,
              type: "boolean"
            },
            dataField: {
              value: "",
              type: "string"
            },
            dateFormat: {
              value: null,
              type: "string?"
            },
            displayText: {
              value: null,
              type: "string?"
            },
            flip: {
              value: !1,
              type: "boolean"
            },
            formatFunction: {
              value: null,
              type: "function?"
            },
            formatSettings: {
              value: {
                dateFormat: {
                  value: null,
                  type: "string?"
                },
                decimalPlaces: {
                  value: null,
                  type: "number?"
                },
                decimalSeparator: {
                  value: null,
                  type: "string?"
                },
                negativeWithBrackets: {
                  value: !1,
                  type: "boolean"
                },
                prefix: {
                  value: "",
                  type: "string"
                },
                sufix: {
                  value: "",
                  type: "string"
                },
                thousandsSeparator: {
                  value: null,
                  type: "string?"
                }
              },
              type: "object"
            },
            gridLines: {
              value: {
                color: {
                  value: "",
                  type: "string"
                },
                custom: {
                  value: null,
                  type: "array?"
                },
                dashStyle: {
                  value: "",
                  type: "string"
                },
                lineWidth: {
                  value: 1,
                  type: "number"
                },
                step: {
                  value: null,
                  type: "number?"
                },
                unitInterval: {
                  value: null,
                  type: "number?"
                },
                visible: {
                  value: !0,
                  type: "any"
                }
              },
              type: "object"
            },
            labels: {
              value: {
                angle: {
                  value: 0,
                  type: "number"
                },
                autoRotate: {
                  value: !1,
                  type: "boolean"
                },
                class: {
                  value: null,
                  type: "string?"
                },
                custom: {
                  value: null,
                  type: "array?"
                },
                formatFunction: {
                  value: null,
                  type: "function?"
                },
                formatSettings: {
                  value: {
                    dateFormat: {
                      value: null,
                      type: "string?"
                    },
                    decimalPlaces: {
                      value: null,
                      type: "number?"
                    },
                    decimalSeparator: {
                      value: null,
                      type: "string?"
                    },
                    negativeWithBrackets: {
                      value: !1,
                      type: "boolean"
                    },
                    prefix: {
                      value: "",
                      type: "string"
                    },
                    sufix: {
                      value: "",
                      type: "string"
                    },
                    thousandsSeparator: {
                      value: null,
                      type: "string?"
                    }
                  },
                  type: "object"
                },
                horizontalAlignment: {
                  value: "center",
                  allowedValues: ["left", "center", "right"],
                  type: "string"
                },
                offset: {
                  value: {
                    x: {
                      value: 0,
                      type: "number"
                    },
                    y: {
                      value: 0,
                      type: "number"
                    }
                  },
                  type: "object"
                },
                rotationPoint: {
                  value: "auto",
                  allowedValues: ["auto", "left", "center", "right", "topleft", "topcenter", "topright", "bottomleft", "bottomcenter", "bottomright", "centermiddle"],
                  type: "string"
                },
                step: {
                  value: null,
                  type: "number?"
                },
                unitInterval: {
                  value: null,
                  type: "number?"
                },
                verticalAlignment: {
                  value: "center",
                  allowedValues: ["top", "center", "bottom"],
                  type: "string"
                },
                visible: {
                  value: !0,
                  type: "any"
                }
              },
              type: "object"
            },
            line: {
              value: {
                color: {
                  value: "",
                  type: "string"
                },
                dashStyle: {
                  value: "",
                  type: "string"
                },
                lineWidth: {
                  value: 1,
                  type: "number"
                },
                visible: {
                  value: !0,
                  type: "any"
                }
              },
              type: "object"
            },
            logarithmicScale: {
              value: !1,
              type: "boolean"
            },
            logarithmicScaleBase: {
              value: 10,
              type: "number"
            },
            maxValue: {
              value: NaN,
              type: "any"
            },
            minValue: {
              value: NaN,
              type: "any"
            },
            padding: {
              value: {
                bottom: {
                  value: 0,
                  type: "number"
                },
                left: {
                  value: 0,
                  type: "number"
                },
                right: {
                  value: 0,
                  type: "number"
                },
                top: {
                  value: 0,
                  type: "number"
                }
              },
              type: "object"
            },
            position: {
              value: "bottom",
              allowedValues: ["bottom", "top", "left", "right"],
              type: "string"
            },
            rangeSelector: {
              value: {
                backgroundColor: {
                  value: null,
                  type: "string?"
                },
                backgroundImage: {
                  value: "",
                  type: "string"
                },
                baseUnit: {
                  value: null,
                  allowedValues: ["year", "month", "day", "hour", "minute", "second", "millisecond", null],
                  type: "string?"
                },
                borderLineColor: {
                  value: null,
                  type: "string?"
                },
                borderLineWidth: {
                  value: null,
                  type: "number?"
                },
                caption: {
                  value: "",
                  type: "string"
                },
                colorScheme: {
                  value: null,
                  type: "string?"
                },
                columnSeriesOverlap: {
                  value: !1,
                  type: "boolean"
                },
                columnsGapPercent: {
                  value: 25,
                  type: "number"
                },
                dataField: {
                  value: null,
                  type: "string?"
                },
                description: {
                  value: "",
                  type: "string"
                },
                greyScale: {
                  value: null,
                  type: "boolean?"
                },
                gridLines: {
                  value: {
                    color: {
                      value: "",
                      type: "string"
                    },
                    custom: {
                      value: null,
                      type: "array?"
                    },
                    dashStyle: {
                      value: "",
                      type: "string"
                    },
                    lineWidth: {
                      value: 1,
                      type: "number"
                    },
                    step: {
                      value: null,
                      type: "number?"
                    },
                    unitInterval: {
                      value: null,
                      type: "number?"
                    },
                    visible: {
                      value: !0,
                      type: "any"
                    }
                  },
                  type: "object"
                },
                labels: {
                  value: {
                    angle: {
                      value: 0,
                      type: "number"
                    },
                    autoRotate: {
                      value: !1,
                      type: "boolean"
                    },
                    class: {
                      value: null,
                      type: "string?"
                    },
                    custom: {
                      value: null,
                      type: "array?"
                    },
                    formatFunction: {
                      value: null,
                      type: "function?"
                    },
                    formatSettings: {
                      value: {
                        dateFormat: {
                          value: null,
                          type: "string?"
                        },
                        decimalPlaces: {
                          value: null,
                          type: "number?"
                        },
                        decimalSeparator: {
                          value: null,
                          type: "string?"
                        },
                        negativeWithBrackets: {
                          value: !1,
                          type: "boolean"
                        },
                        prefix: {
                          value: "",
                          type: "string"
                        },
                        sufix: {
                          value: "",
                          type: "string"
                        },
                        thousandsSeparator: {
                          value: null,
                          type: "string?"
                        }
                      },
                      type: "object"
                    },
                    horizontalAlignment: {
                      value: "center",
                      allowedValues: ["left", "center", "right"],
                      type: "string"
                    },
                    offset: {
                      value: {
                        x: {
                          value: 0,
                          type: "number"
                        },
                        y: {
                          value: 0,
                          type: "number"
                        }
                      },
                      type: "object"
                    },
                    rotationPoint: {
                      value: "auto",
                      allowedValues: ["auto", "left", "center", "right", "topleft", "topcenter", "topright", "bottomleft", "bottomcenter", "bottomright", "centermiddle"],
                      type: "string"
                    },
                    step: {
                      value: null,
                      type: "number?"
                    },
                    unitInterval: {
                      value: null,
                      type: "number?"
                    },
                    verticalAlignment: {
                      value: "center",
                      allowedValues: ["top", "center", "bottom"],
                      type: "string"
                    },
                    visible: {
                      value: !0,
                      type: "any"
                    }
                  },
                  type: "object"
                },
                maxValue: {
                  value: NaN,
                  type: "any"
                },
                minValue: {
                  value: NaN,
                  type: "any"
                },
                padding: {
                  value: {
                    bottom: {
                      value: 0,
                      type: "number"
                    },
                    left: {
                      value: 0,
                      type: "number"
                    },
                    right: {
                      value: 0,
                      type: "number"
                    },
                    top: {
                      value: 0,
                      type: "number"
                    }
                  },
                  type: "object"
                },
                position: {
                  value: null,
                  allowedValues: ["bottom", "top", "left", "right"],
                  type: "string?"
                },
                renderTo: {
                  value: null,
                  type: "any"
                },
                rightToLeft: {
                  value: null,
                  type: "boolean?"
                },
                seriesGapPercent: {
                  value: 10,
                  type: "number"
                },
                seriesGroups: {
                  value: null,
                  type: "array?"
                },
                serieType: {
                  value: "area",
                  type: "string"
                },
                showBorderLine: {
                  value: null,
                  type: "boolean?"
                },
                size: {
                  value: null,
                  type: "number?"
                },
                skipOverlappingPoints: {
                  value: !0,
                  type: "boolean"
                },
                titlePadding: {
                  value: {
                    bottom: {
                      value: 10,
                      type: "number"
                    },
                    left: {
                      value: 5,
                      type: "number"
                    },
                    right: {
                      value: 5,
                      type: "number"
                    },
                    top: {
                      value: 5,
                      type: "number"
                    }
                  },
                  type: "object"
                },
                unitInterval: {
                  value: null,
                  type: "number?"
                },
                valueAxis: {
                  value: {
                    alternatingBackgroundColor: {
                      value: "",
                      type: "string"
                    },
                    alternatingBackgroundColor2: {
                      value: "",
                      type: "string"
                    },
                    alternatingBackgroundOpacity: {
                      value: 1,
                      type: "number"
                    },
                    axisSize: {
                      value: null,
                      type: "any"
                    },
                    bands: {
                      value: null,
                      type: "array?"
                    },
                    baselineValue: {
                      value: 0,
                      type: "any"
                    },
                    customDraw: {
                      value: !1,
                      type: "boolean"
                    },
                    flip: {
                      value: !1,
                      type: "boolean"
                    },
                    formatFunction: {
                      value: null,
                      type: "function?"
                    },
                    formatSettings: {
                      value: {
                        dateFormat: {
                          value: null,
                          type: "string?"
                        },
                        decimalPlaces: {
                          value: null,
                          type: "number?"
                        },
                        decimalSeparator: {
                          value: null,
                          type: "string?"
                        },
                        negativeWithBrackets: {
                          value: !1,
                          type: "boolean"
                        },
                        prefix: {
                          value: "",
                          type: "string"
                        },
                        sufix: {
                          value: "",
                          type: "string"
                        },
                        thousandsSeparator: {
                          value: null,
                          type: "string?"
                        }
                      },
                      type: "object"
                    },
                    gridLines: {
                      value: {
                        color: {
                          value: "",
                          type: "string"
                        },
                        custom: {
                          value: null,
                          type: "array?"
                        },
                        dashStyle: {
                          value: "",
                          type: "string"
                        },
                        lineWidth: {
                          value: 1,
                          type: "number"
                        },
                        step: {
                          value: null,
                          type: "number?"
                        },
                        unitInterval: {
                          value: null,
                          type: "number?"
                        },
                        visible: {
                          value: !0,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    labels: {
                      value: {
                        angle: {
                          value: 0,
                          type: "number"
                        },
                        autoRotate: {
                          value: !1,
                          type: "boolean"
                        },
                        class: {
                          value: null,
                          type: "string?"
                        },
                        custom: {
                          value: null,
                          type: "array?"
                        },
                        formatFunction: {
                          value: null,
                          type: "function?"
                        },
                        formatSettings: {
                          value: {
                            dateFormat: {
                              value: null,
                              type: "string?"
                            },
                            decimalPlaces: {
                              value: null,
                              type: "number?"
                            },
                            decimalSeparator: {
                              value: null,
                              type: "string?"
                            },
                            negativeWithBrackets: {
                              value: !1,
                              type: "boolean"
                            },
                            prefix: {
                              value: "",
                              type: "string"
                            },
                            sufix: {
                              value: "",
                              type: "string"
                            },
                            thousandsSeparator: {
                              value: null,
                              type: "string?"
                            }
                          },
                          type: "object"
                        },
                        horizontalAlignment: {
                          value: "center",
                          allowedValues: ["left", "center", "right"],
                          type: "string"
                        },
                        offset: {
                          value: {
                            x: {
                              value: 0,
                              type: "number"
                            },
                            y: {
                              value: 0,
                              type: "number"
                            }
                          },
                          type: "object"
                        },
                        rotationPoint: {
                          value: "auto",
                          allowedValues: ["auto", "left", "center", "right", "topleft", "topcenter", "topright", "bottomleft", "bottomcenter", "bottomright", "centermiddle"],
                          type: "string"
                        },
                        step: {
                          value: null,
                          type: "number?"
                        },
                        unitInterval: {
                          value: null,
                          type: "number?"
                        },
                        verticalAlignment: {
                          value: "center",
                          allowedValues: ["top", "center", "bottom"],
                          type: "string"
                        },
                        visible: {
                          value: !0,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    line: {
                      value: {
                        color: {
                          value: "",
                          type: "string"
                        },
                        dashStyle: {
                          value: "",
                          type: "string"
                        },
                        lineWidth: {
                          value: 1,
                          type: "number"
                        },
                        visible: {
                          value: !0,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    logarithmicScale: {
                      value: !1,
                      type: "boolean"
                    },
                    logarithmicScaleBase: {
                      value: 10,
                      type: "number"
                    },
                    maxValue: {
                      value: NaN,
                      type: "any"
                    },
                    minValue: {
                      value: NaN,
                      type: "any"
                    },
                    padding: {
                      value: {
                        bottom: {
                          value: 0,
                          type: "number"
                        },
                        left: {
                          value: 0,
                          type: "number"
                        },
                        right: {
                          value: 0,
                          type: "number"
                        },
                        top: {
                          value: 0,
                          type: "number"
                        }
                      },
                      type: "object"
                    },
                    position: {
                      value: "left",
                      allowedValues: ["left", "right", "top", "bottom"],
                      type: "string"
                    },
                    textRotationAngle: {
                      value: null,
                      type: "number?"
                    },
                    textRotationPoint: {
                      value: "auto",
                      allowedValues: ["auto", "left", "center", "right", "topleft", "topcenter", "topright", "bottomleft", "bottomcenter", "bottomright", "centermiddle"],
                      type: "string"
                    },
                    tickMarks: {
                      value: {
                        color: {
                          value: "",
                          type: "string"
                        },
                        custom: {
                          value: null,
                          type: "array?"
                        },
                        dashStyle: {
                          value: "",
                          type: "string"
                        },
                        lineWidth: {
                          value: 1,
                          type: "number"
                        },
                        size: {
                          value: 4,
                          type: "number"
                        },
                        step: {
                          value: null,
                          type: "number?"
                        },
                        unitInterval: {
                          value: null,
                          type: "number?"
                        },
                        visible: {
                          value: !0,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    title: {
                      value: {
                        class: {
                          value: null,
                          type: "string?"
                        },
                        horizontalAlignment: {
                          value: "center",
                          allowedValues: ["left", "center", "right"],
                          type: "string"
                        },
                        text: {
                          value: "",
                          type: "string"
                        },
                        verticalAlignment: {
                          value: "center",
                          allowedValues: ["top", "center", "bottom"],
                          type: "string"
                        },
                        visible: {
                          value: !0,
                          type: "boolean"
                        }
                      },
                      type: "object"
                    },
                    unitInterval: {
                      value: null,
                      type: "number?"
                    },
                    valuesOnTicks: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: !1,
                      type: "boolean"
                    }
                  },
                  type: "object"
                },
                visible: {
                  value: !1,
                  type: "boolean"
                }
              },
              type: "object"
            },
            textRotationAngle: {
              value: null,
              type: "number?"
            },
            textRotationPoint: {
              value: "auto",
              allowedValues: ["auto", "left", "center", "right", "topleft", "topcenter", "topright", "bottomleft", "bottomcenter", "bottomright", "centermiddle"],
              type: "string"
            },
            tickMarks: {
              value: {
                color: {
                  value: "",
                  type: "string"
                },
                custom: {
                  value: null,
                  type: "array?"
                },
                dashStyle: {
                  value: "",
                  type: "string"
                },
                lineWidth: {
                  value: 1,
                  type: "number"
                },
                size: {
                  value: 4,
                  type: "number"
                },
                step: {
                  value: null,
                  type: "number?"
                },
                unitInterval: {
                  value: null,
                  type: "number?"
                },
                visible: {
                  value: !0,
                  type: "any"
                }
              },
              type: "object"
            },
            title: {
              value: {
                class: {
                  value: null,
                  type: "string?"
                },
                horizontalAlignment: {
                  value: "center",
                  allowedValues: ["left", "center", "right"],
                  type: "string"
                },
                text: {
                  value: "",
                  type: "string"
                },
                verticalAlignment: {
                  value: "center",
                  allowedValues: ["top", "center", "bottom"],
                  type: "string"
                },
                visible: {
                  value: !0,
                  type: "boolean"
                }
              },
              type: "object"
            },
            toolTipFormatFunction: {
              value: null,
              type: "function?"
            },
            toolTipFormatSettings: {
              value: {
                dateFormat: {
                  value: null,
                  type: "string?"
                },
                decimalPlaces: {
                  value: null,
                  type: "number?"
                },
                decimalSeparator: {
                  value: null,
                  type: "string?"
                },
                negativeWithBrackets: {
                  value: !1,
                  type: "boolean"
                },
                prefix: {
                  value: "",
                  type: "string"
                },
                sufix: {
                  value: "",
                  type: "string"
                },
                thousandsSeparator: {
                  value: null,
                  type: "string?"
                }
              },
              type: "object"
            },
            type: {
              value: "auto",
              allowedValues: ["auto", "date", "basic", "linear"],
              type: "string"
            },
            unitInterval: {
              value: null,
              type: "number?"
            },
            valuesOnTicks: {
              value: !0,
              type: "boolean"
            },
            visible: {
              value: !0,
              type: "boolean"
            }
          },
          type: "object"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        click: "_clickHandler",
        down: "_downMoveHandler",
        mouseleave: "_mouseleaveHandler",
        move: "_moveHandler",
        resize: "_resizeHandler",
        "document.move": "_downMoveHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Utilities.Draw": "smart.draw.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.chart.css"];
    }
  }]);

  return _class37;
}(Smart.BaseElement)), function () {
  "use strict";

  Smart.Chart && (Smart.Chart.prototype._moduleAnnotations = !0, Smart.Chart.prototype._renderAnnotation = function (e, t) {
    var _this10 = this;

    var i = this.seriesGroups[e],
        a = this.renderer;
    if (isNaN(e)) return;

    var n = this._get([this.getXAxisDataPointOffset(t.xValue, e), t.x]),
        o = this._get([this.getValueAxisDataPointOffset(t.yValue, e), t.y]),
        r = this._get([this.getXAxisDataPointOffset(t.xValue2, e), t.x2]),
        l = this._get([this.getValueAxisDataPointOffset(t.yValue2, e), t.y2]);

    if (i.polar || i.spider) {
      var _i371 = this.getPolarDataPointOffset(t.xValue, t.yValue, e);

      !_i371 || isNaN(_i371.x) || isNaN(_i371.y) ? (n = t.x, o = t.y) : (n = _i371.x, o = _i371.y);
    }

    if (isNaN(o) || isNaN(n)) return !1;

    if ("horizontal" === i.orientation) {
      var _e434 = n;
      n = o, o = _e434, _e434 = r, r = l, l = _e434;
    }

    t.offset && (!isNaN(t.offset.x) && (n += t.offset.x, r += t.offset.x), !isNaN(t.offset.y) && (o += t.offset.y, l += t.offset.y));

    var s = this._get([t.width, r - n]),
        d = this._get([t.height, l - o]);

    var c;

    switch (t.type) {
      case "rect":
        c = a.rect(n, o, s, d);
        break;

      case "circle":
        c = a.rect(n, o, t.radius);
        break;

      case "line":
        c = a.rect(n, o, r, l);
        break;

      case "path":
        c = a.path(t.path);
    }

    c && a.attr(c, {
      fill: t.fillColor,
      stroke: t.lineColor,
      opacity: this._get([t.fillOpacity, t.opacity]),
      "stroke-opacity": this._get([t.lineOpacity, t.opacity]),
      "stroke-width": t.lineWidth,
      "stroke-dasharray": t.dashStyle || "none"
    });
    var m;

    if (t.text) {
      var _e435 = t.text;
      var _i372 = 0,
          _r77 = 0;
      _e435.offset && (!isNaN(_e435.offset.x) && (_i372 += _e435.offset.x), !isNaN(_e435.offset.y) && (_r77 += _e435.offset.y)), m = a.text(_e435.value, n + _i372, o + _r77, NaN, NaN, _e435.angle, {}, !0 === _e435.clip, _e435.horizontalAlignment || "center", _e435.verticalAlignment || "center", _e435.rotationPoint || "centermiddle"), a.attr(m, {
        fill: _e435.fillColor,
        stroke: _e435.lineColor,
        class: "smart-chart-annotation-text " + (_e435["class"] || "")
      });
    }

    var u = ["click", "mouseenter", "mouseleave"],
        p = this;

    var _loop21 = function _loop21(_a231) {
      var e = u[_a231];
      c && _this10.renderer.addHandler(c, e, function () {
        p._raiseAnnotationEvent(t, e);
      }), m && _this10.renderer.addHandler(m, e, function () {
        p._raiseAnnotationEvent(t, e);
      });
    };

    for (var _a231 = 0; _a231 < u.length; _a231++) {
      _loop21(_a231);
    }
  }, Smart.Chart.prototype._raiseAnnotationEvent = function (e, t) {
    this.$.fireEvent("annotation" + t.charAt(0).toUpperCase() + t.slice(1), {
      annotation: e
    });
  });
}(), function () {
  "use strict";

  Smart.Chart && (Smart.Chart.prototype._moduleApi = !0, Smart.Chart.prototype.getItemsCount = function (e, t) {
    var i = this.seriesGroups[e];
    if (!this._isSerieVisible(e, t)) return 0;
    var a = this._renderData;
    if (!i || !a || a.length <= e) return 0;
    var n = i.series[t];
    return n ? a[e].offsets[t].length : 0;
  }, Smart.Chart.prototype.getXAxisRect = function (e) {
    var t = this._renderData;
    return !t || t.length <= e ? void 0 : t[e].xAxis ? t[e].xAxis.rect : void 0;
  }, Smart.Chart.prototype.getXAxisLabels = function (e) {
    var t = [];
    var a = this._renderData;
    if (!a || a.length <= e) return t;
    if (a = a[e].xAxis, !a) return t;
    var i = this.seriesGroups[e];

    if (i.polar || i.spider) {
      for (var _e436 = 0; _e436 < a.polarLabels.length; _e436++) {
        var _i373 = a.polarLabels[_e436];
        t.push({
          offset: {
            x: _i373.x,
            y: _i373.y
          },
          value: _i373.value
        });
      }

      return t;
    }

    var n = this._getXAxis(e),
        o = this.getXAxisRect(e),
        r = "top" === n.position || "right" === n.position,
        l = "horizontal" === i.orientation;

    for (var _n184 = 0; _n184 < a.data.length; _n184++) {
      l ? t.push({
        offset: {
          x: o.x + (r ? 0 : o.width),
          y: o.y + a.data.data[_n184]
        },
        value: a.data.xvalues[_n184]
      }) : t.push({
        offset: {
          x: o.x + a.data.data[_n184],
          y: o.y + (r ? o.height : 0)
        },
        value: a.data.xvalues[_n184]
      });
    }

    return t;
  }, Smart.Chart.prototype.getValueAxisRect = function (e) {
    var t = this._renderData;
    return !t || t.length <= e ? void 0 : t[e].valueAxis ? t[e].valueAxis.rect : void 0;
  }, Smart.Chart.prototype.getValueAxisLabels = function (e) {
    var t = [];
    var a = this._renderData;
    if (!a || a.length <= e) return t;
    if (a = a[e].valueAxis, !a) return t;

    var i = this._getValueAxis(e),
        n = "top" === i.position || "right" === i.position,
        o = this.seriesGroups[e],
        r = "horizontal" === o.orientation;

    if (o.polar || o.spider) {
      for (var _e437 = 0; _e437 < a.polarLabels.length; _e437++) {
        var _i374 = a.polarLabels[_e437];
        t.push({
          offset: {
            x: _i374.x,
            y: _i374.y
          },
          value: _i374.value
        });
      }

      return t;
    }

    for (var _o118 = 0; _o118 < a.items.length; _o118++) {
      r ? t.push({
        offset: {
          x: a.itemOffsets[a.items[_o118]].x + a.itemWidth / 2,
          y: a.rect.y + (n ? a.rect.height : 0)
        },
        value: a.items[_o118]
      }) : t.push({
        offset: {
          x: a.rect.x + a.rect.width,
          y: a.itemOffsets[a.items[_o118]].y + a.itemWidth / 2
        },
        value: a.items[_o118]
      });
    }

    return t;
  }, Smart.Chart.prototype.getPlotAreaRect = function () {
    return this._plotRect;
  }, Smart.Chart.prototype.getRect = function () {
    return this._rect;
  }, Smart.Chart.prototype.showToolTip = function (e, t, i, a, n) {
    var o = this.getItemCoord(e, t, i);
    isNaN(o.x) || isNaN(o.y) || this._startTooltipTimer(e, t, i, o.x, o.y, a, n);
  }, Smart.Chart.prototype.hideToolTip = function (e) {
    isNaN(e) && (e = 0);
    var t = this;
    t._cancelTooltipTimer(), setTimeout(function () {
      t._hideToolTip(0);
    }, e);
  });
}(), function () {
  "use strict";

  var e = Math.round,
      t = Math.abs,
      i = Math.max;
  Smart.Chart && (Smart.Chart.prototype._moduleRangeSelector = !0, Smart.Chart.prototype._renderXAxisRangeSelector = function (e, t) {
    var i = this,
        a = i.seriesGroups[e],
        n = i._getXAxis(e),
        o = n ? n.rangeSelector : void 0;

    if (!i._isSelectorRefresh) {
      var _e438 = o && o.renderTo ? o.renderTo : i,
          _t365 = _e438.getElementsByClassName("smart-chart-range-selector")[0];

      _t365 && _t365.parentElement.removeChild(_t365);
    }

    if (!n || !1 === n.visible || "spider" === a.type) return !1;
    if (!i._isGroupVisible(e)) return !1;
    if (!o) return !1;
    var r = "horizontal" === a.orientation;
    o.renderTo && (r = !1), i.rightToLeft && (n.flip = !0);
    var l = r ? i.offsetHeight : i.offsetWidth;
    l -= 4;

    var s = this._getXAxisStats(e, n, l);

    var d = n.position;

    if (o.renderTo && o.position && (d = o.position), !this._isSelectorRefresh) {
      var _i375 = o.renderTo,
          _a232 = document.createElement("div");

      if (_a232.className = "smart-chart-range-selector smart-unselectable", _a232.style.position = "absolute", _a232.style.backgroundColor = "transparent", _a232.style.onselectstart = function () {
        return !1;
      }, !_i375) {
        this.renderer.getContainer().appendChild(_a232);

        var _e439 = this._selectorGetSize(n);

        r ? (_a232.style.left = 1 + t.x + ("right" === d ? t.width : -_e439) + "px", _a232.style.top = "0", _a232.style.height = l + "px", _a232.style.width = _e439 + "px", t.height = _e439) : (_a232.style.left = "1px", _a232.style.top = t.y + ("top" === d ? -_e439 : t.height) + "px", _a232.style.height = _e439 + "px", _a232.style.width = l + "px");
      } else _i375.appendChild(_a232), _a232.style.width = _i375.offsetWidth + "px", _a232.style.height = _i375.offsetHeight + "px", t.width = _i375.offsetWidth, t.height = _i375.offsetHeight;

      this._refreshSelector(e, n, s, _a232, t, r);
    }

    return this._isSelectorRefresh = !1, !0;
  }, Smart.Chart.prototype._refreshSelector = function (e, t, a, n, o, r) {
    var l = this,
        s = {},
        d = t.rangeSelector;

    for (var _l58 in d) {
      s[_l58] = d[_l58];
    }

    delete s.padding;
    var c = s.minValue,
        m = s.maxValue;
    isNaN(c) && (c = Math.min(a.min.valueOf(), a.dsRange.min.valueOf())), isNaN(m) && (m = i(a.max.valueOf(), a.dsRange.max.valueOf())), this._isDate(a.min) && (c = new Date(c)), this._isDate(a.max) && (m = new Date(m));
    var u = t.position;
    d.renderTo && d.position && (u = d.position), s.dataField = t.dataField, delete s.rangeSelector, s.type = t.type, s.baseUnit = null === d.baseUnit ? t.baseUnit : d.baseUnit, s.minValue = c, s.maxValue = m, s.flip = t.flip, s.position = u;
    var p = 2,
        g = 2,
        h = 2,
        _ = 2;
    d.renderTo || (p = r ? 0 : o.x, g = r ? 0 : this._rect.width - o.x - o.width, h = r ? o.y : 5, _ = r ? this._paddedRect.height - this._plotRect.height : 5);
    var f = d.padding;
    f = void 0 !== f && null !== f || d.renderTo ? {
      left: f && f.left ? f.left : p,
      top: f && f.top ? f.top : h,
      right: f && f.right ? f.right : g,
      bottom: f && f.bottom ? f.bottom : _
    } : {
      left: p,
      top: h,
      right: g,
      bottom: _
    };
    var b = d.dataField;

    for (var _l59 = 0; (b === void 0 || null === b) && _l59 < this.seriesGroups.length; _l59++) {
      for (var _e440 = 0; (b === void 0 || null === b) && _e440 < this.seriesGroups[_l59].series.length; _e440++) {
        b = this.seriesGroups[_l59].series[_e440].dataField;
      }
    }

    var y = {
      parentChart: this,
      padding: f,
      _isRangeSelectorInstance: !0,
      theme: this.theme,
      caption: d.caption,
      description: d.description,
      titlePadding: d.titlePadding,
      colorScheme: d.colorScheme || this.colorScheme,
      backgroundColor: d.backgroundColor || this.backgroundColor || l._getThemeColor("background"),
      backgroundImage: d.backgroundImage,
      showBorderLine: null === d.showBorderLine ? !!d.renderTo : d.showBorderLine,
      borderLineWidth: d.borderLineWidth || this.borderLineWidth,
      borderLineColor: d.borderLineColor || this.borderLineColor || l._getThemeColor("line"),
      rightToLeft: null === d.rightToLeft ? this.rightToLeft : d.rightToLeft,
      greyScale: null === d.greyScale ? this.greyScale : d.greyScale,
      renderEngine: this.renderEngine,
      showLegend: !1,
      animation: "none",
      enableEvents: !1,
      showToolTips: !1,
      dataSource: this.dataSource,
      xAxis: s,
      seriesGroups: [{
        orientation: r ? "horizontal" : "vertical",
        valueAxis: {
          visible: !1
        },
        type: d.serieType,
        skipOverlappingPoints: d.skipOverlappingPoints,
        columnSeriesOverlap: d.columnSeriesOverlap,
        columnsGapPercent: d.columnsGapPercent,
        seriesGapPercent: d.seriesGapPercent,
        series: [{
          dataField: b,
          opacity: .8,
          lineWidth: 1
        }]
      }]
    };
    d.seriesGroups && (y.seriesGroups = d.seriesGroups), d.valueAxis.visible && (y.valueAxis = d.valueAxis), y.showBorderLine || (y.borderLineWidth = 1, y.borderLineColor = l._get([this.backgroundColor, this.background, l._getThemeColor("background")]), y.showBorderLine = !0), l._supressBindingRefresh = !0, n.innerHTML = "";
    var v = document.createElement("smart-chart");

    for (var _i376 in y) {
      v[_i376] = y[_i376];
    }

    n.appendChild(v), l._rangeSelectorInstances[e] = v, l._supressBindingRefresh = !1;

    var w = function w() {
      if (v._plotRect) {
        var _t366 = v._paddedRect;
        if (_t366.height = v._plotRect.height, !r && "top" === u) _t366.y += v._renderData[0].xAxis.rect.height;else if (r) {
          var _e441 = v._renderData[0].xAxis.rect.width;
          _t366.width -= _e441, "right" !== u && (_t366.x += _e441);
        }
        l._createSliderElements(e, n, _t366, d), l._rangeSelectorEventData = {
          groupIndex: e,
          renderTo: n,
          swapXY: r
        };
      }
    };

    v.isRendered ? w() : v.whenRendered(function () {
      w();
    });
  }, Smart.Chart.prototype._createSliderElements = function (t, i, a, n) {
    function o(e, t) {
      var i = document.createElement("div");
      return i.className = "slider", i.style.position = "absolute", i.style.background = e, i.style.opacity = t, i;
    }

    function r() {
      var e = document.createElement("div");
      return e.className = "slider", e.style.position = "absolute", e.style.background = "#FFFFFF", e.style.borderStyle = "solid", e.style.borderWidth = "1px", e.style.borderRadius = "3px", e.style.borderColor = p, e;
    }

    var l = this,
        s = i.getElementsByClassName("slider")[0];
    s && s.parentElement.removeChild(s);

    var d = n.selectedRangeColor || "blue",
        c = l._get([n.selectedRangeOpacity, .1]),
        m = l._get([n.unselectedRangeOpacity, .5]),
        u = n.unselectedRangeColor || "white",
        p = n.rangeLineColor || "grey",
        g = document.createElement("div");

    for (g.className = "slider", g.style.position = "absolute", g.style.background = d, g.style.opacity = c, g.style.left = a.x + "px", g.style.top = a.y + "px", g.style.width = a.width + "px", g.style.height = a.height + "px", i.appendChild(g); this._sliders.length < t + 1;) {
      this._sliders.push({});
    }

    var h = g.getBoundingClientRect(),
        _ = i.getBoundingClientRect(),
        f = this;

    this._sliders[t] = {
      element: g,
      host: i.firstElementChild,
      _sliderInitialAbsoluteRect: {
        x: h.left,
        y: h.top,
        width: a.width,
        height: a.height
      },
      _hostInitialAbsolutePos: {
        x: _.left,
        y: _.top
      },
      getRect: function getRect() {
        var e = i.getBoundingClientRect();
        return {
          x: e.left - this._hostInitialAbsolutePos.x + this._sliderInitialAbsoluteRect.x,
          y: e.top - this._hostInitialAbsolutePos.y + this._sliderInitialAbsoluteRect.y,
          width: this._sliderInitialAbsoluteRect.width,
          height: this._sliderInitialAbsoluteRect.height
        };
      },
      rect: a,
      left: o(u, m),
      right: o(u, m),
      leftTop: o(p, m),
      rightTop: o(p, m),
      leftBorder: o(p, m),
      leftBar: r(),
      rightBorder: o(p, m),
      rightBar: r()
    };
    var b = this._sliders[t];
    i.appendChild(b.left), i.appendChild(b.right), i.appendChild(b.leftTop), i.appendChild(b.rightTop), i.appendChild(b.leftBorder), i.appendChild(b.rightBorder), i.appendChild(b.leftBar), i.appendChild(b.rightBar);
    var y = this._renderData[t].xAxis,
        v = y.data.axisStats,
        w = v.min.valueOf(),
        C = v.max.valueOf();

    var x = this._valueToOffset(t, w),
        S = this._valueToOffset(t, C);

    if (x > S) {
      var _e442 = S;
      S = x, x = _e442;
    }

    "horizontal" === this.seriesGroups[t].orientation ? (g.style.left = a.x + "px", g.style.top = e(a.y + x) + "px", g.style.width = a.width + "px", g.style.height = e(S - x) + "px") : (g.style.left = e(a.x + x) + "px", g.style.top = a.y + "px", g.style.width = e(S - x) + "px", g.style.height = a.height + "px"), this._setSliderPositions(t, x, S);
  }, Smart.Chart.prototype._setSliderPositions = function (e, t, i) {
    var a = this.seriesGroups[e],
        n = this._getXAxis(e),
        o = n.rangeSelector;

    var r = "horizontal" === a.orientation;
    n.rangeSelector.renderTo && (r = !1);
    var l = n.position;
    o.renderTo && o.position && (l = o.position);
    var s = this._sliders[e],
        d = r ? "top" : "left",
        c = r ? "left" : "top",
        m = r ? "height" : "width",
        u = r ? "width" : "height",
        p = r ? "y" : "x",
        g = r ? "x" : "y",
        h = s.rect;
    s.startOffset = t, s.endOffset = i, s.left.style[d] = h[p] + "px", s.left.style[c] = h[g] + "px", s.left.style[m] = t + "px", s.left.style[u] = h[u] + "px", s.right.style[d] = h[p] + i + "px", s.right.style[c] = h[g] + "px", s.right.style[m] = h[m] - i + 1 + "px", s.right.style[u] = h[u] + "px", s.leftTop.style[d] = h[p] + "px", s.leftTop.style[c] = h[g] + (r && "right" === l || !r && "top" !== l ? 0 : h[u]) + "px", s.leftTop.style[m] = t + "px", s.leftTop.style[u] = "1px", s.rightTop.style[d] = h[p] + i + "px", s.rightTop.style[c] = h[g] + (r && "right" === l || !r && "top" !== l ? 0 : h[u]) + "px", s.rightTop.style[m] = h[m] - i + 1 + "px", s.rightTop.style[u] = "1px", s.leftBorder.style[d] = h[p] + t + "px", s.leftBorder.style[c] = h[g] + "px", s.leftBorder.style[m] = "1px", s.leftBorder.style[u] = h[u] + "px";

    var _ = h[u] / 4;

    20 < _ && (_ = 20), 3 > _ && (_ = 3), s.leftBar.style[d] = h[p] + t - 3 + "px", s.leftBar.style[c] = h[g] + h[u] / 2 - _ / 2 + "px", s.leftBar.style[m] = "5px", s.leftBar.style[u] = _ + "px", s.rightBorder.style[d] = h[p] + i + "px", s.rightBorder.style[c] = h[g] + "px", s.rightBorder.style[m] = "1px", s.rightBorder.style[u] = h[u] + "px", s.rightBar.style[d] = h[p] + i - 3 + "px", s.rightBar.style[c] = h[g] + h[u] / 2 - _ / 2 + "px", s.rightBar.style[m] = "5px", s.rightBar.style[u] = _ + "px";
  }, Smart.Chart.prototype._resizeState = {}, Smart.Chart.prototype._onSliderMouseDown = function (e) {
    e.stopImmediatePropagation(), e.stopPropagation();
    var t = this,
        i = t._sliders[t._rangeSelectorEventData.groupIndex];
    i && ((void 0 === t._resizeState.state || null === t._resizeState.state) && t._testAndSetReadyResize(e), "ready" !== t._resizeState.state || (t._draggingRangeSelector = !0, t._resizeState.state = "resizing"));
  }, Smart.Chart.prototype._valueToOffset = function (e, t) {
    var i = this.seriesGroups[e],
        a = this._sliders[e],
        n = a.host,
        o = n._renderData[0].xAxis,
        r = o.data.axisStats,
        l = r.min.valueOf(),
        s = r.max.valueOf();
    var d = s - l;
    0 == d && (d = 1);

    var c = this._getXAxis(e),
        m = "horizontal" === i.orientation ? "height" : "width",
        u = (t.valueOf() - l) / d;

    return a.getRect()[m] * (c.flip ? 1 - u : u);
  }, Smart.Chart.prototype._offsetToValue = function (t, i) {
    var a = this._sliders[t],
        n = this.seriesGroups[t],
        o = this._getXAxis(t),
        r = "horizontal" === n.orientation ? "height" : "width";

    var l = a.getRect()[r];
    0 === l && (l = 1);
    var s = a.host,
        d = s._renderData[0].xAxis,
        c = d.data.axisStats,
        m = c.min.valueOf(),
        u = c.max.valueOf();
    var p = i / l * (u - m) + m;
    return !0 === o.flip && (p = u - i / l * (u - m)), this._isDate(c.min) || this._isDate(c.max) ? p = new Date(p) : ((void 0 === o.dataField || null === o.dataField || c.useIndeces) && (p = e(p)), p < c.min && (p = c.min), p > c.max && (p = c.max)), p;
  }, Smart.Chart.prototype._onSliderMouseUp = function (e) {
    var t = this,
        i = t._rangeSelectorEventData.groupIndex,
        a = t._rangeSelectorEventData.swapXY,
        n = t._sliders[i];
    if (delete t._draggingRangeSelector, !n) return;
    if ("resizing" !== t._resizeState.state) return;
    e.stopImmediatePropagation(), e.stopPropagation(), t._resizeState = {}, t.style.cursor = "default";
    var o = a ? "top" : "left",
        r = a ? "y" : "x",
        l = n.element.getBoundingClientRect()[o],
        s = l + (a ? n.element.offsetHeight : n.element.offsetWidth),
        d = n.getRect();

    var c = t._offsetToValue(i, l - d[r]),
        m = t._offsetToValue(i, s - d[r]);

    var u = n.host,
        p = u._renderData[0].xAxis,
        g = p.data.axisStats;
    !g.isTimeUnit && 864e5 < m.valueOf() - c.valueOf() && (c.setHours(0, 0, 0, 0), m.setDate(m.getDate() + 1), m.setHours(0, 0, 0, 0));

    var h = t._getXAxis(i);

    if (h.flip) {
      var _e443 = c;
      c = m, m = _e443;
    }

    for (var _a233 = 0; _a233 < t.seriesGroups.length; _a233++) {
      var _e444 = t._getXAxis(_a233);

      _e444 === h && (t._selectorRange[_a233] = {
        min: c,
        max: m
      });
    }

    t._isSelectorRefresh = !0;
    var _ = t.animation;
    t.$.fireEvent("rangeSelectionChanging", {
      instance: t,
      minValue: c,
      maxValue: m
    }), t.animation = "none", t.update(), t.animation = _, t.$.fireEvent("rangeSelectionChanged", {
      instance: t,
      minValue: c,
      maxValue: m
    });
  }, Smart.Chart.prototype._onSliderMouseMove = function (t) {
    var a = this,
        n = a._rangeSelectorEventData.groupIndex,
        o = a._sliders[n],
        r = a._rangeSelectorEventData.swapXY;
    if (!o) return;
    var l = o.getRect(),
        s = o.element,
        d = {
      left: t.clientX,
      top: t.clientY
    },
        c = s.getBoundingClientRect(),
        m = r ? "top" : "left",
        u = parseFloat(getComputedStyle(s)[m]),
        p = r ? "height" : "width",
        g = r ? "y" : "x";

    if ("resizing" === a._resizeState.state) {
      if (t.stopImmediatePropagation(), t.stopPropagation(), "left" === a._resizeState.side) {
        var _t367 = e(d[m] - c[m]),
            _a234 = l[g];

        if (c[m] + _t367 >= _a234 && c[m] + _t367 <= _a234 + l[p]) {
          var _e445 = parseInt(u),
              _a235 = i(2, (r ? s.offsetHeight : s.offsetWidth) - _t367);

          s.style[p] = _a235 + "px", s.style[m] = _e445 + _t367 + "px";
        }
      } else if ("right" === a._resizeState.side) {
        var _t368 = r ? s.offsetHeight : s.offsetWidth,
            _a236 = e(d[m] - c[m] - _t368),
            _n185 = l[g];

        if (c[m] + _t368 + _a236 >= _n185 && c[m] + _a236 + _t368 <= _n185 + l[p]) {
          var _e446 = i(2, _t368 + _a236);

          s.style[p] = _e446 + "px";
        }
      } else if ("move" === a._resizeState.side) {
        var _t369 = r ? s.offsetHeight : s.offsetWidth,
            _i377 = parseInt(u),
            _n186 = e(d[m] - a._resizeState.startPos);

        c[m] + _n186 >= l[g] && c[m] + _n186 + _t369 <= l[g] + l[p] && (a._resizeState.startPos = d[m], s.style[m] = _i377 + _n186 + "px");
      }

      var h = parseInt(u) - o.rect[g],
          _ = h + (r ? s.offsetHeight : s.offsetWidth);

      a._setSliderPositions(n, h, _);
    } else a._testAndSetReadyResize(t);
  }, Smart.Chart.prototype._testAndSetReadyResize = function (e) {
    var i = this,
        a = i._rangeSelectorEventData,
        n = a.renderTo,
        o = a.groupIndex,
        r = i._sliders[o],
        l = a.swapXY,
        s = r.getRect(),
        d = r.element,
        c = {
      left: e.clientX,
      top: e.clientY
    },
        m = d.getBoundingClientRect(),
        u = l ? "left" : "top",
        p = l ? "top" : "left",
        g = l ? "width" : "height",
        h = i._isTouchDevice ? 30 : 5;
    c[u] >= m[u] && c[u] <= m[u] + s[g] ? t(c[p] - m[p]) <= h ? (n.style.cursor = l ? "row-resize" : "col-resize", i._resizeState = {
      state: "ready",
      side: "left"
    }) : t(c[p] - m[p] - (l ? d.offsetHeight : d.offsetWidth)) <= h ? (n.style.cursor = l ? "row-resize" : "col-resize", i._resizeState = {
      state: "ready",
      side: "right"
    }) : c[p] + h > m[p] && c[p] - h < m[p] + (l ? d.offsetHeight : d.offsetWidth) ? (n.style.cursor = "pointer", i._resizeState = {
      state: "ready",
      side: "move",
      startPos: c[p]
    }) : (n.style.cursor = "default", i._resizeState = {}) : (n.style.cursor = "default", i._resizeState = {});
  }, Smart.Chart.prototype._selectorGetSize = function (e) {
    return e.rangeSelector.renderTo ? 0 : e.rangeSelector.size || this._paddedRect.height / 3;
  });
}(), function () {
  "use strict";

  Smart.Chart && (Smart.Chart.prototype._moduleWaterfall = !0, Smart.Chart.prototype._isSummary = function (e, t) {
    var i = this.seriesGroups[e];

    for (var _a237 = 0; _a237 < i.series.length; _a237++) {
      if (void 0 === i.series[_a237].summary) continue;

      var _n187 = this._getDataValue(t, i.series[_a237].summary, e);

      if (void 0 !== _n187) return !0;
    }

    return !1;
  }, Smart.Chart.prototype._applyWaterfall = function (e, t, a, n, o, r, l, s, d) {
    var i = this.seriesGroups[a];
    if (0 === e.length) return e;
    var c = n;
    var m = {},
        u = [];
    var p;
    var g = [];

    for (var _c14 = 0; _c14 < i.series.length; _c14++) {
      g.push(this._isSerieVisible(a, _c14));
    }

    var h = {};

    for (var _ = 0; _ < t; _++) {
      var _t370 = n,
          _i378 = 0;

      var f = this._isSummary(a, _);

      for (var _a238 = 0; _a238 < e.length; _a238++) {
        if (!g[_a238]) continue;
        var b = 0;

        if (f) {
          b = _t370 === n ? o : 0, e[_a238][_].value = m[_a238], e[_a238][_].summary = !0, p = e[_a238][_].value < b, s && (p = !p);
          var _c15 = 0;
          _c15 = isNaN(r) ? this._getDataPointOffsetDiff(e[_a238][_].value, b, b, NaN, l, n, s) : this._getDataPointOffsetDiff(e[_a238][_].value + _i378, 0 === _i378 ? o : _i378, b || o, r, l, n, s), e[_a238][_].to = _t370 + (p ? _c15 : -_c15), e[_a238][_].from = _t370, d && (_i378 += e[_a238][_].value, _t370 = e[_a238][_].to);
          continue;
        }

        var v = d ? -1 : _a238;
        if (isNaN(e[_a238][_].value)) continue;
        void 0 === h[v] && (b = o, h[v] = !0), p = e[_a238][_].value < b, s && (p = !p);
        var w = NaN;
        w = d ? c : 0 == _ ? n : e[_a238][u[_a238]].to;
        var y = 0;
        y = isNaN(r) ? this._getDataPointOffsetDiff(e[_a238][_].value, b, b, NaN, l, n, s) : this._getDataPointOffsetDiff(e[_a238][_].value + (isNaN(m[v]) ? 0 : m[v]), isNaN(m[v]) ? o : m[v], b || o, r, l, w, s), e[_a238][_].to = c = w + (p ? y : -y), e[_a238][_].from = w, isNaN(m[v]) ? m[v] = e[_a238][_].value : m[v] += e[_a238][_].value, -1 == v && (isNaN(m[_a238]) ? m[_a238] = e[_a238][_].value : m[_a238] += e[_a238][_].value), d || (u[_a238] = _);
      }
    }

    return e;
  });
}(), Smart("smart-drop-down-list",
/*#__PURE__*/
function (_Smart$ContentElement2) {
  "use strict";

  _inherits(_class38, _Smart$ContentElement2);

  function _class38() {
    _classCallCheck(this, _class38);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class38).apply(this, arguments));
  }

  _createClass(_class38, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <span class=\"smart-label\" id=\"label\">[[label]]</span>\n                    <div id=\"content\" class=\"smart-content\" role=\"presentation\">\n                        <div class=\"smart-buttons-container\" id=\"buttonsContainer\" role=\"presentation\">\n                            <span id=\"actionButton\" class =\"smart-action-button\" role=\"presentation\">[[placeholder]]</span>\n                            <span id=\"dropDownButton\" class=\"smart-drop-down-button\">\n                                <span class =\"smart-drop-down-button-icon\" id=\"arrow\" aria-hidden=\"true\"></span>\n                            </span>\n                        </div>\n                        <div id=\"dropDownContainer\" class=\"smart-drop-down smart-drop-down-container smart-visibility-hidden\" role=\"presentation\">\n                            <smart-list-box id=\"listBox\" unfocusable\n                                    animation=\"[[animation]]\"\n                                    data-source=\"[[dataSource]]\"\n                                    disabled=\"[[disabled]]\"\n                                    display-loading-indicator=\"[[displayLoadingIndicator]]\"\n                                    display-member=\"[[displayMember]]\"\n                                    filterable=\"[[filterable]]\"\n                                    filter-callback=\"[[filterCallback]]\"\n                                    filter-mode=\"[[filterMode]]\"\n                                    filter-input-placeholder=\"[[filterInputPlaceholder]]\"\n                                    grouped=\"[[grouped]]\"\n                                    group-member=\"[[groupMember]]\"\n                                    item-height=\"[[itemHeight]]\"\n                                    item-template=\"[[itemTemplate]]\"\n                                    incremental-search-delay=\"[[incrementalSearchDelay]]\"\n                                    incremental-search-mode=\"[[incrementalSearchMode]]\"\n                                    loading-indicator-placeholder=\"[[loadingIndicatorPlaceholder]]\"\n                                    loading-indicator-position=\"[[loadingIndicatorPosition]]\"\n                                    name=\"[[name]]\"\n                                    placeholder=\"[[dropDownPlaceholder]]\"\n                                    right-to-left=\"[[rightToLeft]]\"\n                                    readonly=\"[[readonly]]\"\n                                    selected-indexes=\"{{selectedIndexes}}\"\n                                    selection-mode=\"[[selectionMode]]\"\n                                    selected-values=\"{{selectedValues}}\"\n                                    sorted=\"[[sorted]]\"\n                                    sort-direction=\"[[sortDirection]]\"\n                                    theme=\"[[theme]]\"\n                                    value-member=\"[[valueMember]]\"\n                                    horizontal-scroll-bar-visibility=\"[[horizontalScrollBarVisibility]]\"\n                                    vertical-scroll-bar-visibility=\"[[verticalScrollBarVisibility]]\"\n                                    virtualized=\"[[virtualized]]\">\n                                <content></content>\n                            </smart-list-box>\n                            <div id=\"resizeBar\" class=\"smart-drop-down-resize-bar\" aria-label=\"Resize\">\n                                <div></div>\n                            </div>\n                         </div>\n                    </div>\n                    <span class=\"smart-hint\" id=\"hint\">[[hint]]</span>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class38.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      switch (e) {
        case "animation":
          a.$.dropDownContainer.setAttribute("animation", a.animation);
          break;

        case "disabled":
          a._setFocusable(), a.close(), a._positionDetection.handleAutoPositioning();
          break;

        case "dataSource":
        case "displayMember":
        case "inputMember":
          a.$.actionButton && (a.$.actionButton.innerHTML = a.placeholder), a._setDropDownSize(), a._positionDetection.checkBrowserBounds("vertically"), a._positionDetection.positionDropDown(), a._positionDetection.checkBrowserBounds("horizontally");
          break;

        case "dropDownAppendTo":
          a._positionDetection.dropDownAppendToChangedHandler();

          break;

        case "dropDownOpenMode":
          a._setFocusable(), a.$dropDownContainer.addClass("smart-visibility-hidden"), a.$.dropDownButton.removeAttribute("selected"), a.removeAttribute("drop-down-button-focus"), a.removeAttribute("action-button-focus"), a.opened = !1, a._ariaButton.removeAttribute("aria-expanded"), a._setAriaRelations();
          break;

        case "dropDownOverlay":
          i || a._positionDetection.removeOverlay();
          break;

        case "dropDownPosition":
          a._positionDetection.dropDownPositionChangedHandler();

          break;

        case "dropDownMinWidth":
        case "dropDownWidth":
        case "dropDownMaxWidth":
        case "dropDownHeight":
        case "dropDownMinHeight":
        case "dropDownMaxHeight":
          a._setDropDownSize();

          break;

        case "filterable":
          a.$.listBox.filterable = i, a._dropDownSize && "auto" === a._dropDownSize.height && a._setDropDownSize();
          break;

        case "opened":
          if (a.disabled || a.readonly) return;
          i ? a.open() : a.close();
          break;

        case "placeholder":
          a._applySelection();

          break;

        case "readonly":
          a.close();
          break;

        case "resizeIndicator":
          i ? a.$.dropDownContainer.setAttribute("resize-indicator", "") : a.$.dropDownContainer.removeAttribute("resize-indicator");
          break;

        case "resizeMode":
          a.$.dropDownContainer.setAttribute("resize-mode", a.resizeMode);
          break;

        case "selectedValues":
        case "selectedIndexes":
          0 === i.length ? a.$.actionButton.innerHTML = a.placeholder : a._applySelection();
          break;

        case "selectionDisplayMode":
          a._applySelection();

          break;

        case "tokenTemplate":
          a._tokenTemplate = a._validateTemplate(a.tokenTemplate), a._applySelection();
          break;

        case "unfocusable":
          a._setFocusable();

      }
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e447 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e447.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? void (t.$.listBox.appendChild(e), t._dropDownSize && "auto" === t._dropDownSize.height && t._setDropDownSize()) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "appendChild",
        node: "node"
      }));
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;

      _get(_getPrototypeOf(_class38.prototype), "attached", this).call(this);

      e.isCompleted && e.$.dropDownContainer && (e._positionDetection.dropDownAttached("_setDropDownSize"), e._positionDetection.checkBrowserBounds());
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;

      _get(_getPrototypeOf(_class38.prototype), "detached", this).call(this);

      e.$.dropDownContainer && (e.close(), e._positionDetection && e._positionDetection.dropDownDetached());
    }
  }, {
    key: "clearItems",
    value: function clearItems() {
      var e = this;
      e.$.listBox && (e.$.listBox.clearItems(), e.$.actionButton.innerHTML = e.placeholder);
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      var e = this;
      e.$.listBox && (e.$.listBox.clearSelection(), e.$.actionButton.innerHTML = e.placeholder);
    }
  }, {
    key: "close",
    value: function close() {
      var e = this;

      if (!e.$dropDownContainer.hasClass("smart-visibility-hidden")) {
        var _t371 = e.$.fireEvent("closing").defaultPrevented;
        _t371 || (e.$dropDownContainer.addClass("smart-visibility-hidden"), e.$.fireEvent("close"), e.$.dropDownButton && e.$.dropDownButton.removeAttribute("selected"), e.opened = !1, e._ariaButton.removeAttribute("aria-expanded"), e._preventDropDownClose = !1, e._positionDetection.removeOverlay(!0), e.$.listBox.removeAttribute("focus"), e._edgeMacFF && !e.hasAnimation && e.$.dropDownContainer && (e.$.dropDownContainer.style.top = e.$.dropDownContainer.style.left = "", e.$dropDownContainer.addClass("not-in-view")));
      }
    }
  }, {
    key: "cloneNode",
    value: function cloneNode() {
      var e = this;

      if (e.$.listBox) {
        var _t372 = HTMLElement.prototype.cloneNode.apply(e, Array.prototype.slice.call(arguments, 0, 1));

        return _t372.dataSource = e.dataSource, _t372;
      }
    }
  }, {
    key: "ensureVisible",
    value: function ensureVisible(e) {
      var t = this;
      t.$.listBox && t.$.listBox.ensureVisible(e);
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      var t = this;
      return t.$.listBox ? t.$.listBox.getItem(e) : void 0;
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var i = this;
      i.$.listBox && (i.$.listBox.insert(e, t), i._applySelection(), i._dropDownSize && "auto" === i._dropDownSize.height && i._setDropDownSize());
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      var i = this;

      if (!i.isCompleted) {
        var _e448 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(i, _e448.concat(Array.prototype.slice.call(arguments)));
      }

      return e && t ? void (!i.$.listBox || (i.$.listBox.insertBefore(e, t), i._dropDownSize && "auto" === i._dropDownSize.height && i._setDropDownSize())) : void i.error(i.localize("invalidNode", {
        elementType: i.nodeName.toLowerCase(),
        method: "insertBefore",
        node: "newNode/referenceNode"
      }));
    }
  }, {
    key: "open",
    value: function open() {
      var e = this,
          t = function t() {
        for (var _t373 = 0; _t373 < e.items.length; _t373++) {
          if (!e.items[_t373].disabled) return e.items[_t373];
        }
      };

      if (!e.disabled && e.offsetHeight && e.$dropDownContainer.hasClass("smart-visibility-hidden")) {
        if (e.$dropDownContainer.hasClass("not-in-view") && e.$dropDownContainer.removeClass("not-in-view"), e.$.dropDownContainer.style.transition = null, e.dropDownAppendTo && 0 < e.dropDownAppendTo.length) {
          var _t374 = e.getBoundingClientRect();

          if (e.$.container.contains(e.$.dropDownContainer)) {
            var _t375 = 0;

            var _i380 = setInterval(function () {
              var a = e.getBoundingClientRect();
              _t375++, a.top === e._positionTop && 10 > _t375 || (e.open(), clearInterval(_i380), e._positionTop = a.top);
            }, 100);

            return;
          }

          _t374.top !== e._positionTop && (e._positionTop = _t374.top);
        }

        var _i379 = e.$.fireEvent("opening").defaultPrevented;
        _i379 || (e._shadowDOMStylesDelay && (e._setDropDownSize(), delete e._shadowDOMStylesDelay), e.opened = !0, e._ariaButton.setAttribute("aria-expanded", !0), e.$.listBox.setAttribute("focus", ""), e._positionDetection.placeOverlay(), e._positionDetection.checkBrowserBounds("vertically"), e._positionDetection.positionDropDown(), e._positionDetection.checkBrowserBounds("horizontally"), e.$dropDownContainer.removeClass("smart-visibility-hidden"), e.$.fireEvent("open"), e.$.dropDownButton && ("dropDownButton" === e.dropDownOpenMode ? e.$.dropDownButton.setAttribute("selected", "") : e.$.dropDownButton.removeAttribute("selected")), (e.$.listBox && !e._focusedItem || e._focusedItem && !e._focusedItem._focused) && (0 < e.selectedIndexes.length ? e._focus(e.items[e.selectedIndexes[0]]) : e._focus(t)), e.$.input && !Smart.Utilities.Core.isMobile && e.$.input.focus());
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class38.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.classList.add("smart-drop-down-box"), e.$.dropDownContainer && (e._positionDetection = new Smart.Utilities.PositionDetection(e, e.$.dropDownContainer, e.$.container, "close"), e._positionDetection.getDropDownParent(!0), e._positionDetection.setDropDownPosition(), e._calculateDropDownSize(), e.$.dropDownContainer.setAttribute("resize-mode", e.resizeMode), e.resizeIndicator && e.$.dropDownContainer.setAttribute("resize-indicator", ""), e._positionDetection.handleAutoPositioning()), e.opened && e.open(), e._positionTop = e.getBoundingClientRect().top, e._edgeMacFF = Smart.Utilities.Core.Browser.Edge || Smart.Utilities.Core.Browser.Firefox && -1 !== navigator.platform.toLowerCase().indexOf("mac"), e._edgeMacFF && e.hasAnimation && e.$.dropDownContainer && e.$dropDownContainer.addClass("not-in-view"), e.$.label && !e.$.label.id && (e.$.label.id = e.id + "Label"), e.$.hint && !e.$.hint.id && (e.$.hint.id = e.id + "Hint"), e._createElement(), _get(_getPrototypeOf(_class38.prototype), "render", this).call(this);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this;
      t.$.listBox && (t.$.listBox.remove(e), t._applySelection(), t._dropDownSize && "auto" === t._dropDownSize.height && t._setDropDownSize());
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e449 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e449.concat(Array.prototype.slice.call(arguments)));
      }

      return e && e instanceof Smart.ListItem ? void (t.$.listBox.removeChild(e), t._dropDownSize && "auto" === t._dropDownSize.height && t._setDropDownSize()) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "removeChild",
        node: "node"
      }));
    }
  }, {
    key: "select",
    value: function select(e) {
      var t = this;
      t.$.listBox && t.$.listBox.select(e);
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      if (e.disabled || e.unfocusable) return e.removeAttribute("tabindex"), e.$.actionButton.removeAttribute("tabindex"), void e.$.dropDownButton.removeAttribute("tabindex");
      var t = 0 < e.tabIndex ? e.tabIndex : 0;
      "dropDownButton" === e.dropDownOpenMode ? (e.removeAttribute("tabindex"), e.$.actionButton.setAttribute("tabindex", t), e.$.dropDownButton.setAttribute("tabindex", t)) : (e.$.actionButton.removeAttribute("tabindex"), e.$.dropDownButton.removeAttribute("tabindex"), e.tabIndex = t);
    }
  }, {
    key: "unselect",
    value: function unselect(e) {
      var t = this;
      t.$.listBox && t.$.listBox.unselect(e);
    }
  }, {
    key: "update",
    value: function update(e, t) {
      var i = this;
      i.$.listBox && (i.$.listBox.update(e, t), i._applySelection());
    }
  }, {
    key: "_resizeBarMoveHandler",
    value: function _resizeBarMoveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_createToken",
    value: function _createToken() {
      var e = this;
      var t;
      var a = document.createDocumentFragment(),
          n = e.selectedIndexes[e.selectedIndexes.length - 1];
      t = "plain" === e.selectionDisplayMode && ("one" === e.selectionMode || "zeroOrOne" === e.selectionMode || "radioButton" === e.selectionMode) ? "" : "tokens" === e.selectionDisplayMode ? 1 === e.selectedIndexes.length && -1 < ["oneOrManyExtended", "oneOrMany", "one", "radioButton"].indexOf(e.selectionMode) ? "" : "&#10006" : 1 === e.selectedIndexes.length ? "" : ",";
      var o = e.selectedIndexes,
          r = e.$.listBox._items;

      for (var _l60 = 0; _l60 < o.length; _l60++) {
        var _i381 = o[_l60];
        r[_i381] && a.appendChild(e._applyTokenTemplate(r[_i381][e.inputMember], "tokens" !== e.selectionDisplayMode && _i381 === n ? "" : t));
      }

      return a;
    }
  }, {
    key: "_applySelection",
    value: function _applySelection() {
      var e = this;
      return "placeholder" === e.selectionDisplayMode || 0 === e.selectedIndexes.length ? void (e.$.actionButton.innerHTML = e.placeholder) : void (!e.$.listBox._items || 0 === e.$.listBox._items.length || (e.$.actionButton.innerHTML = "", e.$.actionButton.appendChild(e._createToken())));
    }
  }, {
    key: "_applyTokenTemplate",
    value: function _applyTokenTemplate(e, t) {
      var i = this,
          a = document.createElement("span"),
          n = function n() {
        return "<span class='smart-drop-down-list-selection-label'>" + e + "</span><span class='smart-drop-down-list-unselect-button'>" + t + "</span>";
      };

      if (a.classList.add("smart-token"), i._tokenTemplate) {
        var _e450 = document.importNode(i._tokenTemplate.content, !0);

        var _t376 = _e450.childNodes.length,
            _o119 = /{{\w+}}/g;

        var _r78;

        for (var _l61 = 0; _l61 < _t376; _l61++) {
          _r78 = _o119.exec(_e450.childNodes[_l61].innerHTML), _r78 && (_e450.childNodes[_l61].innerHTML = _e450.childNodes[_l61].innerHTML.replace(_r78[0], n())), _e450.childNodes[_l61].outerHTML && (a.innerHTML += _e450.childNodes[_l61].outerHTML);
        }
      } else "function" == typeof i.tokenTemplate ? i.tokenTemplate(a, {
        label: e,
        iconSeparator: t
      }) : a.innerHTML = n();

      return a;
    }
  }, {
    key: "_bindingCompleteHandler",
    value: function _bindingCompleteHandler() {
      var e = this;
      e.$.listBox && requestAnimationFrame(function () {
        e._setDropDownSize(), e._positionDetection.checkBrowserBounds();
      });
    }
  }, {
    key: "_buttonsDownHandler",
    value: function _buttonsDownHandler(e) {
      var t = this;

      if (!t.disabled) {
        if (t.hasRippleAnimation) if (!t.$.buttonsContainer || "dropDownButton" === t.dropDownOpenMode) Smart.Utilities.Animation.Ripple.animate(e.target, e.pageX, e.pageY);else {
          var _i382 = t.$.buttonsContainer;
          _i382.firstElementChild.noRipple = !0, Smart.Utilities.Animation.Ripple.animate(_i382, e.pageX, e.pageY), _i382.firstElementChild.noRipple = !1;
        }
        t._preventsSelectStart = !0, "dropDownButton" === t.dropDownOpenMode && e.target === t.$.actionButton && t.$.actionButton.setAttribute("active", ""), t.opened && (t._preventDropDownClose = !0);
      }
    }
  }, {
    key: "_buttonsMouseEventsHandler",
    value: function _buttonsMouseEventsHandler(e) {
      var t = this;
      t.disabled || ("mouseenter" === e.type ? (t.setAttribute("hover", ""), e.target.setAttribute("hover", "")) : (t.removeAttribute("hover"), e.target.removeAttribute("hover")));
    }
  }, {
    key: "_calculateDropDownSize",
    value: function _calculateDropDownSize() {
      var e = this;
      e._dropDownSize = {};
      var t = window.getComputedStyle(e.$.dropDownContainer),
          i = parseFloat(t.getPropertyValue("border-top-width").trim()),
          a = parseFloat(t.getPropertyValue("border-bottom-width").trim()),
          n = parseFloat(t.getPropertyValue("margin-top").trim()),
          o = parseFloat(t.getPropertyValue("margin-bottom").trim()),
          r = parseFloat(t.getPropertyValue("padding-top").trim()),
          l = parseFloat(t.getPropertyValue("padding-bottom").trim());
      Smart.Utilities.Core.CSSVariablesSupport() && (e._dropDownSize.width = t.getPropertyValue("--smart-drop-down-list-drop-down-width").trim(), e._dropDownSize.height = t.getPropertyValue("--smart-drop-down-list-drop-down-height").trim()), (!e._dropDownSize.width || -1 < e._dropDownSize.width.indexOf("initial")) && (e._dropDownSize.width = e.offsetWidth), e._dropDownSize.height || (e._dropDownSize.height = "auto"), e._dropDownSize.minHeight = parseFloat(t.getPropertyValue("min-height").trim()), e._dropDownSize.maxHeight = parseFloat(t.getPropertyValue("max-height").trim()), e._dropDownSize.borderWidth = (isNaN(i) ? 0 : i) + (isNaN(a) ? 0 : a), e._dropDownSize.paddingWidth = (isNaN(r) ? 0 : r) + (isNaN(l) ? 0 : l), e._dropDownSize.marginWidth = (isNaN(n) ? 0 : n) + (isNaN(o) ? 0 : o);
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e._tokenTemplate = e._validateTemplate(e.tokenTemplate), e._applySelection(), e._setDropDownSize(), e._setFocusable(), e.$.arrow.noRipple = !0, e._shadowDOMStylesDelay = e.shadowRoot, e._setAriaRelations(!0);
    }
  }, {
    key: "_documentDownHandler",
    value: function _documentDownHandler(e) {
      var t = this;
      if (t.disabled || t.readonly) return;
      var i = e.originalEvent.target;

      if (i === t._overlay && (t._overlayDown = !0), t.shadowRoot) {
        i = e.originalEvent.composedPath()[0];

        for (var _e451 = i.getRootNode().host; _e451;) {
          _e451.closest(".smart-drop-down-container") === t.$.dropDownContainer && (t._isDropDownClicked = !0), _e451 = _e451.getRootNode().host;
        }
      } else t.isInShadowDOM && (i = e.originalEvent.composedPath()[0]), t._isDropDownClicked = i.closest(".smart-drop-down-container") === t.$.dropDownContainer;

      if (t._buttonClicked = i.closest(".smart-action-button") || i.closest(".smart-drop-down-button"), t.$.listBox) {
        var _a239 = i.closest("smart-list-item");

        t.$.listBox.contains(_a239) || (_a239 = void 0), t.hasRippleAnimation && _a239 && Smart.Utilities.Animation.Ripple.animate(_a239, e.pageX, e.pageY), (_a239 || i === t.$.listBox.$.filterInput || i.closest(".smart-token")) && (t._preventDropDownClose = !0);
      }

      if (t._isDropDownClicked && (t._preventDropDownClose = !0), i === t.$.resizeBar && "none" !== t.resizeMode) {
        t._resizeDetails || (t._resizeDetails = {});

        var _i383 = t.$.dropDownContainer.getBoundingClientRect();

        t._resizeDetails.started = !0, t._resizeDetails.x = e.pageX, t._resizeDetails.y = e.pageY, t._resizeDetails.width = t.$.dropDownContainer.offsetWidth, t._resizeDetails.height = t.$.dropDownContainer.offsetHeight, t._resizeDetails.offsetXL = e.clientX - _i383.left, t._resizeDetails.offsetXR = _i383.left + t.$.dropDownContainer.offsetWidth - e.clientX, t._resizeDetails.offsetY = _i383.top + t.$.dropDownContainer.offsetHeight - e.clientY, t._resizeDetails.offsetYtop = e.clientY - _i383.top, t._preventDropDownClose = !0;
      }
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      function t() {
        if (m = e.pageY - o._resizeDetails.y, "bottom" === c) o._resizeDetails.height = a(l.clientHeight - s.top - 6, n(0, o._resizeDetails.height + m)), o._resizeDetails.y = n(s.top + l.scrollTop - o._resizeDetails.offsetY, a(l.clientHeight + l.scrollTop - 1.5 * o._resizeDetails.offsetY, e.pageY));else {
          if (o._resizeDetails.height = a(o._dropDownSize.maxHeight, n(0, a(d.top, o._resizeDetails.height - m))), m = n(0, s.top + (s.height - n(o._dropDownSize.minHeight, o._resizeDetails.height))), o.dropDownAppendTo && 0 < o.dropDownAppendTo.length) {
            var _e452 = Math.abs(parseFloat(getComputedStyle(o.$.dropDownContainer).getPropertyValue("margin-bottom"))) || 0;

            o.$.dropDownContainer.style.top = o.dropDownAppendTo && 0 < o.dropDownAppendTo.length ? _e452 + m + "px" : "";
          }

          var _t377 = d.top + l.scrollTop + o._resizeDetails.offsetYtop;

          o._resizeDetails.y = n(o._resizeDetails.offsetYtop, a(_t377, n(_t377 - o._dropDownSize.maxHeight, e.pageY)));
        }
        o.$.dropDownContainer.style.height = o._resizeDetails.height + "px";
      }

      function i() {
        m = e.pageX - o._resizeDetails.x, o._resizeDetails.width = a(l.clientWidth - s.left - 6, n(0, o._resizeDetails.width + m)), o.$.dropDownContainer.style.width = o._resizeDetails.width + "px", o._resizeDetails.x = n(s.left + l.scrollLeft - o._resizeDetails.offsetXR, a(l.clientWidth + l.scrollLeft - 1.5 * o._resizeDetails.offsetXR, e.pageX));
      }

      var a = Math.min,
          n = Math.max;
      var o = this,
          r = o.shadowRoot || o.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      if ("auto" === o.dropDownOpenMode && null !== o.dropDownAppendTo && (o.contains(r) || o.$.dropDownContainer.contains(r) ? o._isElementHovered = !0 : (o._isElementHovered = !1, o._autoClose())), !o._resizeDetails || o._resizeDetails && !o._resizeDetails.started) return;
      o.setAttribute("resizing", ""), o._resizeDetails.resizeEventFired || (o.$.fireEvent("resizeStart", {
        position: {
          left: e.pageX,
          top: e.pageY
        }
      }), o._resizeDetails.resizeEventFired = !0);
      var l = document.documentElement,
          s = o.$.dropDownContainer.getBoundingClientRect(),
          d = o.getBoundingClientRect(),
          c = o.$.dropDownContainer.hasAttribute("top") ? "top" : "bottom";
      var m;

      switch (o.resizeMode) {
        case "vertical":
          t();
          break;

        case "horizontal":
          i();
          break;

        case "both":
          i(), t();
      }
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;
      if (t.$.actionButton.removeAttribute("active"), t._resizeDetails && t._resizeDetails.started) return t._resizeDetails.started = t._resizeDetails.resizeEventFired = !1, t.removeAttribute("resizing"), t._preventDropDownClose = !1, t.focus(), void t.$.fireEvent("resizeEnd", {
        position: {
          left: e.pageX,
          top: e.pageY
        }
      });
      if (t.disabled || t._isDropDownClicked || t.readonly) return void delete t._isDropDownClicked;
      if (t._overlayDown) return t.close(), void delete t._overlayDown;
      var i = e.originalEvent.target,
          a = i.closest ? i.closest("smart-drop-down-list") : void 0;

      if ((t.enableShadowDOM || t.isInShadowDOM) && (i = e.originalEvent.composedPath()[0], a = i.getRootNode().host), t._preventsSelectStart = !1, "undefined" != typeof i && i !== t.$.resizeBar) {
        if ("tokens" === t.selectionDisplayMode && i.classList.contains("smart-drop-down-list-selection-label") && a === t) {
          "none" !== t.dropDownOpenMode && t.open();

          var _e454 = t.$.listBox._items.filter(function (e) {
            return e[t.inputMember].toString() === i.textContent;
          })[0];

          return t.$.listBox._scrollView.scrollTop = _e454.offsetTop, void t._focus(_e454);
        }

        if ("tokens" === t.selectionDisplayMode && i.classList.contains("smart-drop-down-list-unselect-button") && a === t) return 1 === t.selectedIndexes.length && 0 > ["zeroOrMany", "zeroOrOne", "checkBox"].indexOf(t.selectionMode) ? void 0 : void t.unselect(t.$.listBox._items.filter(function (e) {
          return e[t.inputMember].toString() === i.previousElementSibling.textContent;
        })[0]);

        var _e453 = i.closest(".smart-action-button");

        if (t._buttonClicked && ("dropDownButton" === t.dropDownOpenMode && _e453 && t._buttonClicked === t.$.actionButton ? t.$.fireEvent("actionButtonClick") : (i.closest(".smart-drop-down-button") === t._buttonClicked || _e453 === t._buttonClicked) && t.$.fireEvent("dropDownButtonClick")), t._buttonClicked = void 0, _e453 === t.$.actionButton || i.closest(".smart-drop-down-button") === t.$.dropDownButton) return "dropDownButton" === t.dropDownOpenMode && _e453 === t.$.actionButton ? void t.close() : void (t.$dropDownContainer.hasClass("smart-visibility-hidden") && "none" !== t.dropDownOpenMode ? t.open() : t.close());
        i = t._getUpEventTarget(i), void 0 === i || ("dropDownContainer" !== i && "item" !== i || "item" === i && "checkBox" !== t.selectionMode && 0 > t.selectionMode.indexOf("Many")) && t.close();
      }
    }
  }, {
    key: "_dragStartHandler",
    value: function _dragStartHandler(e) {
      var t = this;
      t._resizeDetails && t._resizeDetails.started && e.preventDefault();
    }
  }, {
    key: "_dropDownTransitionendHandler",
    value: function _dropDownTransitionendHandler() {
      var e = this;
      e._edgeMacFF && !e.opened && e.hasAnimation && (e.$.dropDownContainer.style.top = e.$.dropDownContainer.style.left = "", e.$dropDownContainer.addClass("not-in-view"));
    }
  }, {
    key: "_focus",
    value: function _focus(e) {
      this.$.listBox._focus(e);
    }
  }, {
    key: "_blurEventHandler",
    value: function _blurEventHandler() {
      var e = this;
      e.$.dropDownButton && (e.removeAttribute("focus"), e.$.dropDownButton.removeAttribute("focus")), e.$.actionButton && (e.removeAttribute("focus"), e.$.actionButton.removeAttribute("focus")), e.nodeName && "smart-drop-down-list" === e.nodeName.toLowerCase() && !e._preventDropDownClose && e.close();
    }
  }, {
    key: "_focusEventHandler",
    value: function _focusEventHandler() {
      var e = this;
      e.$.dropDownButton && (e.setAttribute("focus", ""), e.$.dropDownButton.setAttribute("focus", "")), e.$.actionButton && (e.setAttribute("focus", ""), e.$.actionButton.setAttribute("focus", "")), e.removeAttribute("drop-down-button-focus"), e.removeAttribute("action-button-focus");
    }
  }, {
    key: "_buttonsFocusHandler",
    value: function _buttonsFocusHandler(e) {
      var t = this;
      e.target === t.$.dropDownButton ? "focus" === e.type ? t.setAttribute("drop-down-button-focus", "") : (t.removeAttribute("drop-down-button-focus"), t.nodeName && "smart-drop-down-list" === t.nodeName.toLowerCase() && !t._preventDropDownClose && t.close()) : "focus" === e.type ? t.setAttribute("action-button-focus", "") : t.removeAttribute("action-button-focus");
    }
  }, {
    key: "_getUpEventTarget",
    value: function _getUpEventTarget(e) {
      var t = this;
      var i = e;

      for (i = void 0 === i.parentElement ? i.getRootNode().host : i.parentElement; i;) {
        if (i === t.$.dropDownContainer) {
          i = "dropDownContainer";
          break;
        }

        i = i.parentElement === void 0 ? i.getRootNode().host : i.parentElement;
      }

      return i;
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? t.shadowRoot.activeElement || document.activeElement : document.activeElement,
          a = t.enableShadowDOM ? e.composedPath()[0] : e.target;
      if (!(t.$.listBox && a === t.$.listBox.$.filterInput || i !== t && i !== t.$.dropDownButton && i !== t.$.actionButton)) switch (e.key) {
        case "Enter":
        case " ":
          a.setAttribute("active", ""), e.preventDefault(), a !== t.$.actionButton && (t._keyPressed = !0, t.opened ? (t._focusedItem && t.select(t._focusedItem), ("Enter" === e.key && 0 > ["none"].indexOf(t.selectionMode) || " " === e.key && -1 < ["none", "one", "radioButton"].indexOf(t.selectionMode)) && t.close()) : !t.opened && !t.readonly && "none" !== t.dropDownOpenMode && t.open());
          break;

        case "End":
        case "Home":
        case "PageUp":
        case "PageDown":
        case "ArrowUp":
        case "ArrowDown":
          if (t.readonly) return;
          if (e.altKey) return t._keyPressed = !1, void (t.$dropDownContainer.hasClass("smart-visibility-hidden") ? t.open() : t.close());
          e.preventDefault(), t.$.listBox._handleKeyStrokes(e.key);
          break;

        case "Escape":
          e.preventDefault(), t.close();
          break;

        default:
          if (t.readonly) return;
          "oneOrManyExtended" === t.selectionMode && (t.$.listBox._keysPressed[e.key] = !0), t.$.listBox._applyIncrementalSearch(e.key);
      }
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.composedPath()[0] : e.target;
      t.$.listBox && i === t.$.listBox.$.filterInput || (("Enter" === e.key || " " === e.key) && (i.removeAttribute("active"), !t.$dropDownContainer.hasClass("smart-visibility-hidden") && (t._keyPressed = !1)), t.$.listBox && "oneOrManyExtended" === t.selectionMode && (t.$.listBox._keysPressed[e.key] = !1));
    }
  }, {
    key: "_listBoxChangeHandler",
    value: function _listBoxChangeHandler(e) {
      var t = this;

      if ((t.dropDownAppendTo && 0 < t.dropDownAppendTo.length || t.enableShadowDOM) && t.$.fireEvent("change", e.detail), "list" === t.autoComplete && e.detail) {
        var _i384 = t.$.listBox._items[e.detail.index];
        t._lastSelectedItem = _i384 && _i384.selected ? _i384 : void 0;
      }

      t._applySelection(t.selectionMode, e.detail);
    }
  }, {
    key: "_listBoxItemClickHandler",
    value: function _listBoxItemClickHandler(e) {
      var t = this;
      (t.dropDownAppendTo && 0 < t.dropDownAppendTo.length || t.enableShadowDOM) && t.$.fireEvent(e.type, e.detail), "checkBox" !== t.selectionMode && 0 > t.selectionMode.indexOf("Many") && t.close(), "smart-combo-box" !== t.nodeName.toLowerCase() || Smart.Utilities.Core.isMobile || t.$.input.focus(), delete t._isDropDownClicked;
    }
  }, {
    key: "_listBoxKeyDownHandler",
    value: function _listBoxKeyDownHandler(e) {
      var t = this;
      return "Enter" === e.key ? (t.close(), "dropDownButton" === t.dropDownOpenMode ? t.$.dropDownButton.focus() : t.focus(), void e.stopPropagation()) : "Escape" === e.key ? void t.close() : void 0;
    }
  }, {
    key: "_mouseEnterHandler",
    value: function _mouseEnterHandler() {
      var e = this;
      e._isElementHovered = !0, !(-1 < e.tagName.toLowerCase().indexOf("smart-drop-down-")) || "auto" !== e.dropDownOpenMode || e.disabled || e.readonly || e.open();
    }
  }, {
    key: "_mouseLeaveHandler",
    value: function _mouseLeaveHandler() {
      var e = this;
      e.removeAttribute("hover"), e._isElementHovered = !1, "auto" !== e.dropDownOpenMode || e.disabled || e.readonly || e._autoClose();
    }
  }, {
    key: "_mouseWheelHandler",
    value: function _mouseWheelHandler(e) {
      var t = this;
      t.disabled || t.readonly || t.items && 0 === t.items.length || t.$dropDownContainer && !t.$dropDownContainer.hasClass("smart-visibility-hidden") || t.$.listBox && (e.preventDefault(), t.$.listBox._handleKeyStrokes(0 < e.deltaY ? "ArrowDown" : "ArrowUp"));
    }
  }, {
    key: "_autoClose",
    value: function _autoClose() {
      var e = this;
      e._autoCloseTimeout = setTimeout(function () {
        e._isElementHovered || e.close(), clearTimeout(e._autoCloseTimeout);
      }.bind(e), e.autoCloseDelay);
    }
  }, {
    key: "_propertyValidator",
    value: function _propertyValidator(e, t) {
      return "number" != typeof t && "string" != typeof t ? e : t;
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      "none" === e.resizeMode && (e._calculateDropDownSize(), e._setDropDownSize());
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      this._preventsSelectStart && e.preventDefault();
    }
  }, {
    key: "_setAriaRelations",
    value: function _setAriaRelations(e) {
      var t = this;
      var i, a;
      "dropDownButton" === t.dropDownOpenMode ? (i = t, a = t.$.dropDownButton, a.removeAttribute("aria-hidden"), t.$.actionButton.setAttribute("role", "button")) : (i = t.$.dropDownButton, i.setAttribute("aria-hidden", !0), a = t, t.$.actionButton.removeAttribute("role")), t._ariaButton = a, a.setAttribute("role", "button"), a.setAttribute("aria-haspopup", "listbox"), a.setAttribute("aria-owns", t.$.dropDownContainer.id), a.setAttribute("aria-describedby", t.$.hint.id), a.setAttribute("aria-labelledby", t.$.label.id), i.setAttribute("role", "presentation"), e ? t.opened && a.setAttribute("aria-expanded", !0) : (i.removeAttribute("aria-haspopup"), i.removeAttribute("aria-owns"), i.removeAttribute("aria-describedby"), i.removeAttribute("aria-labelledby"));
    }
  }, {
    key: "_setDropDownSize",
    value: function _setDropDownSize() {
      var e = this;
      if (e._dropDownSize || e._calculateDropDownSize(), ["dropDownMinWidth", "dropDownMinHeight", "dropDownMaxWidth", "dropDownMaxHeight"].forEach(function (t) {
        e.$.dropDownContainer.style[t.replace("dropDown", "").replace(/^./, "m")] = e[t] ? e[t] + (e[t].toString().endsWith("%") ? "%" : "px") : null;
      }), !e.dropDownWidth) e.$.dropDownContainer.style.width = "auto" === e._dropDownSize.width ? "auto" : (parseFloat(e._dropDownSize.width) || 0) + "px";else if ("auto" !== e.dropDownWidth) e.$.dropDownContainer.style.width = ("initial" === e.dropDownWidth ? e.offsetWidth : parseFloat(e.dropDownWidth)) + "px";else if (e.$.dropDownContainer.style.width = "auto", e.$.listBox) {
        var _t378 = 2 + 2 * parseInt(window.getComputedStyle(e.$.listBox.$.itemsContainer).getPropertyValue("--smart-list-item-horizontal-offset"));

        e.$.dropDownContainer.style.width = _t378 + e.$.listBox._scrollWidth + "px";
      }
      if (e.dropDownHeight && "auto" !== e.dropDownHeight) e.$.dropDownContainer.style.height = parseFloat(e.dropDownHeight) + (-1 < (e.dropDownHeight + "").indexOf("%") ? "%" : "px");else if (e.$.listBox && ("auto" === e._dropDownSize.height || "auto" === e.dropDownHeight)) {
        e.$.dropDownContainer.style.height = "";

        var _t379 = 2 * parseInt(window.getComputedStyle(e.$.listBox.$.itemsContainer).getPropertyValue("--smart-list-item-vertical-offset"));

        isNaN(_t379) && (_t379 = 6);
        var _i385 = _t379;

        if (0 < e.$.listBox.items.length && e.$.listBox.items.map(function (e) {
          return _i385 += e.height || e.offsetHeight;
        }), e.filterable) {
          var _t380 = e.$.listBox.$.filterInputContainer;
          _i385 += _t380.offsetHeight + _t380.offsetTop;
        }

        _i385 = _i385 + e._dropDownSize.paddingWidth + e._dropDownSize.borderWidth, e.$.dropDownContainer.style.height = _i385 + "px";
      } else e.$.dropDownContainer.style.height = e._dropDownSize.height;
      e.$.listBox && e.$.listBox._refreshLayout();
    }
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler(e) {
      var t = this;

      if (t.dropDownAppendTo && 0 < t.dropDownAppendTo.length) {
        var _i386 = e.detail.styleProperties,
            _a240 = ["font-size", "font-family", "font-style", "font-weight"];

        for (var _e455 = 0; _e455 < _a240.length; _e455++) {
          _i386[_a240[_e455]] && (t.$.dropDownContainer.style[_a240[_e455]] = _i386[_a240[_e455]].value);
        }
      }

      "auto" === t._dropDownSize.height && t._setDropDownSize();
    }
  }, {
    key: "_validateTemplate",
    value: function _validateTemplate(e) {
      var t = this;
      if (e) return "function" == typeof e ? void 0 : "content" in document.createElement("template") ? (e instanceof HTMLTemplateElement || (e = document.getElementById(e)), null !== e && "content" in e ? e : void t.error(t.localize("invalidTemplate", {
        elementType: t.nodeName.toLowerCase(),
        property: "tokenTemplate"
      }))) : void t.error(t.localize("htmlTemplateNotSuported", {
        elementType: t.nodeName.toLowerCase()
      }));
    }
  }, {
    key: "items",
    get: function get() {
      var e = this;
      return e.$ && e.$.listBox ? e.$.listBox.items : void 0;
    }
  }, {
    key: "_focusedItem",
    get: function get() {
      var e = this;
      return e.$ && e.$.listBox ? e.$.listBox._focusedItem : void 0;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoCloseDelay: {
          value: 100,
          type: "number"
        },
        dataSource: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        displayLoadingIndicator: {
          value: !1,
          type: "boolean"
        },
        displayMember: {
          value: "",
          type: "string"
        },
        displayMode: {
          allowedValues: ["outlined", "filled", "underlined"],
          value: "outlined",
          type: "string"
        },
        dropDownAppendTo: {
          value: null,
          type: "any"
        },
        dropDownButtonPosition: {
          allowedValues: ["none", "left", "right", "top", "bottom"],
          value: "right",
          defaultReflectToAttribute: !0,
          type: "string"
        },
        dropDownMinHeight: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownHeight: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownMaxHeight: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownOpenMode: {
          allowedValues: ["none", "default", "dropDownButton", "auto"],
          value: "default",
          type: "string"
        },
        dropDownOverlay: {
          value: !1,
          type: "boolean"
        },
        dropDownPlaceholder: {
          value: "No Items",
          type: "string"
        },
        dropDownPosition: {
          allowedValues: ["auto", "top", "bottom", "overlay-top", "overlay-center", "overlay-bottom", "center-bottom", "center-top"],
          value: "auto",
          type: "string"
        },
        dropDownMinWidth: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownWidth: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownMaxWidth: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        filterable: {
          value: !1,
          type: "boolean"
        },
        filterInputPlaceholder: {
          value: "",
          type: "string"
        },
        filterCallback: {
          value: null,
          type: "function?"
        },
        filterMode: {
          value: "startsWithIgnoreCase",
          allowedValues: ["contains", "containsIgnoreCase", "doesNotContain", "doesNotContainIgnoreCase", "equals", "equalsIgnoreCase", "startsWith", "startsWithIgnoreCase", "endsWith", "endsWithIgnoreCase", "custom"],
          type: "string"
        },
        grouped: {
          value: !1,
          type: "boolean"
        },
        groupMember: {
          value: "",
          type: "string"
        },
        hint: {
          value: "",
          type: "string"
        },
        horizontalScrollBarVisibility: {
          type: "string",
          value: "auto",
          allowedValues: ["auto", "disabled", "hidden", "visible"]
        },
        incrementalSearchDelay: {
          value: 700,
          type: "number?"
        },
        incrementalSearchMode: {
          value: "startsWithIgnoreCase",
          allowedValues: ["contains", "containsIgnoreCase", "doesNotContain", "doesNotContainIgnoreCase", "equals", "equalsIgnoreCase", "startsWith", "startsWithIgnoreCase", "endsWith", "endsWithIgnoreCase"],
          type: "string"
        },
        inputMember: {
          value: "label",
          type: "string"
        },
        itemTemplate: {
          value: null,
          type: "any"
        },
        itemHeight: {
          value: null,
          type: "number?"
        },
        label: {
          value: "",
          type: "string"
        },
        loadingIndicatorPlaceholder: {
          value: "Loading...",
          type: "string"
        },
        loadingIndicatorPosition: {
          value: "center",
          allowedValues: ["bottom", "center", "top"],
          type: "string"
        },
        messages: {
          extend: !0,
          value: {
            en: {
              invalidNode: "{{elementType}}: Invalid parameter \"{{node}}\" when calling {{method}}."
            }
          },
          type: "object"
        },
        name: {
          value: "",
          type: "string"
        },
        opened: {
          value: !1,
          type: "boolean"
        },
        placeholder: {
          value: "",
          type: "string"
        },
        resizeMode: {
          value: "none",
          allowedValues: ["none", "horizontal", "vertical", "both"],
          type: "string"
        },
        resizeIndicator: {
          value: !1,
          type: "boolean"
        },
        selectionDisplayMode: {
          value: "plain",
          allowedValues: ["plain", "placeholder", "tokens"],
          type: "string"
        },
        selectionMode: {
          value: "one",
          allowedValues: ["none", "oneOrManyExtended", "zeroOrMany", "oneOrMany", "zeroOrOne", "one", "checkBox", "radioButton"],
          type: "string"
        },
        selectedIndexes: {
          value: [],
          type: "array"
        },
        selectedValues: {
          value: [],
          type: "array"
        },
        sorted: {
          value: !1,
          type: "boolean"
        },
        sortDirection: {
          value: "asc",
          type: "string"
        },
        tokenTemplate: {
          value: null,
          type: "any"
        },
        type: {
          value: "list",
          type: "string",
          defaultReflectToAttribute: !0,
          readonly: !0
        },
        valueMember: {
          value: "",
          type: "string"
        },
        virtualized: {
          value: !1,
          type: "boolean"
        },
        verticalScrollBarVisibility: {
          type: "string",
          value: "auto",
          allowedValues: ["auto", "disabled", "hidden", "visible"]
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "actionButton.down": "_buttonsDownHandler",
        "actionButton.mouseenter": "_buttonsMouseEventsHandler",
        "actionButton.mouseleave": "_buttonsMouseEventsHandler",
        "actionButton.focus": "_buttonsFocusHandler",
        "actionButton.blur": "_buttonsFocusHandler",
        "document.selectstart": "_selectStartHandler",
        "document.dragstart": "_dragStartHandler",
        "document.down": "_documentDownHandler",
        "document.up": "_documentUpHandler",
        "document.move": "_documentMoveHandler",
        "dropDownButton.down": "_buttonsDownHandler",
        "dropDownButton.mouseenter": "_buttonsMouseEventsHandler",
        "dropDownButton.mouseleave": "_buttonsMouseEventsHandler",
        keydown: "_keyDownHandler",
        keyup: "_keyUpHandler",
        focus: "_focusEventHandler",
        blur: "_blurEventHandler",
        "dropDownButton.focus": "_buttonsFocusHandler",
        "dropDownButton.blur": "_buttonsFocusHandler",
        "dropDownContainer.transitionend": "_dropDownTransitionendHandler",
        "listBox.change": "_listBoxChangeHandler",
        "listBox.itemClick": "_listBoxItemClickHandler",
        "listBox.keydown": "_listBoxKeyDownHandler",
        "listBox.bindingComplete": "_bindingCompleteHandler",
        mouseenter: "_mouseEnterHandler",
        mouseleave: "_mouseLeaveHandler",
        resize: "_resizeHandler",
        "resizeBar.move": "_resizeBarMoveHandler",
        styleChanged: "_styleChangedHandler",
        wheel: "_mouseWheelHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.dropdownlist.css", "smart.dropdown.css"];
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.ListBox": "smart.listbox.js"
      };
    }
  }]);

  return _class38;
}(Smart.ContentElement)), Smart("smart-combo-box",
/*#__PURE__*/
function (_Smart$DropDownList) {
  "use strict";

  _inherits(_class39, _Smart$DropDownList);

  function _class39() {
    _classCallCheck(this, _class39);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class39).apply(this, arguments));
  }

  _createClass(_class39, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <span class=\"smart-label\" id=\"label\">[[label]]</span>\n                    <div id=\"content\" class=\"smart-content\">\n                        <div class =\"smart-buttons-container\" id=\"buttonsContainer\">\n                            <span id=\"actionButton\" class =\"smart-action-button\">\n                               <input class=\"smart-input\" id=\"input\" placeholder=\"[[placeholder]]\" autocomplete=\"off\"/>\n                               <div class =\"smart-combo-box-auto-complete-string\" id=\"autoCompleteString\"></div>\n                            </span>\n                            <span id=\"dropDownButton\" class =\"smart-drop-down-button\">\n                                <span class =\"smart-drop-down-button-icon\" id=\"arrow\"></span>\n                            </span>\n                        </div>\n                         <div id=\"dropDownContainer\" class=\"smart-drop-down smart-drop-down-container smart-visibility-hidden\">\n                            <smart-list-box id=\"listBox\" unfocusable\n                                    animation=\"[[animation]]\"\n                                    data-source=\"[[dataSource]]\"\n                                    disabled=\"[[disabled]]\"\n                                    display-loading-indicator=\"[[displayLoadingIndicator]]\"\n                                    display-member=\"[[displayMember]]\"\n                                    filterable=\"[[filterable]]\"\n                                    filter-callback=\"[[filterCallback]]\"\n                                    filter-mode=\"[[filterMode]]\"\n                                    filter-input-placeholder=\"[[filterInputPlaceholder]]\"\n                                    grouped=\"[[grouped]]\"\n                                    group-member=\"[[groupMember]]\"\n                                    item-height=\"[[itemHeight]]\"\n                                    item-template=\"[[itemTemplate]]\"\n                                    incremental-search-delay=\"[[incrementalSearchDelay]]\"\n                                    incremental-search-mode=\"[[incrementalSearchMode]]\"\n                                    loading-indicator-placeholder=\"[[loadingIndicatorPlaceholder]]\"\n                                    loading-indicator-position=\"[[loadingIndicatorPosition]]\"\n                                    name=\"[[name]]\"\n                                    placeholder=\"[[dropDownPlaceholder]]\"\n                                    readonly=\"[[readonly]]\"\n                                    right-to-left=\"[[rightToLeft]]\"\n                                    selected-indexes=\"{{selectedIndexes}}\"\n                                    selection-mode=\"[[selectionMode]]\"\n                                    selected-values=\"{{selectedValues}}\"\n                                    sorted=\"[[sorted]]\"\n                                    theme=\"[[theme]]\"\n                                    value-member=\"[[valueMember]]\"\n                                    horizontal-scroll-bar-visibility=\"[[horizontalScrollBarVisibility]]\"\n                                    vertical-scroll-bar-visibility=\"[[verticalScrollBarVisibility]]\"\n                                    virtualized=\"[[virtualized]]\">\n                                <content></content>\n                            </smart-list-box>\n                            <div id=\"resizeBar\" class=\"smart-drop-down-resize-bar\">\n                                <div></div>\n                            </div>\n                         </div>\n                    </div>\n                    <span class=\"smart-hint\" id=\"hint\">[[hint]]</span>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "autoComplete":
          if ("list" === i) {
            a.$.listBox.$.filterInput.value = "";
            var _e456 = a.$.listBox.context;
            a.$.listBox.context = a.$.listBox, a.$.listBox._filterItems(!0), a.$.listBox.context = _e456, a._setDropDownSize();
          }

          a._autoComplete(!0);

          break;

        case "dataSource":
        case "displayMember":
          a._clearSelection(!0), a._setDropDownSize(), a._positionDetection.checkBrowserBounds("vertically"), a._positionDetection.positionDropDown(), a._positionDetection.checkBrowserBounds("horizontally");
          break;

        case "disabled":
          a.$.input.disabled = i, a._setFocusable(), a.close(), a._positionDetection && a._positionDetection.handleAutoPositioning();
          break;

        case "readonly":
          a.$.input.readOnly = i, a.close();
          break;

        case "selectedValues":
        case "selectedIndexes":
          a._clearSelection(!0), a._applySelection(a.selectionMode);
          break;

        case "selectionMode":
        case "selectionDisplayMode":
          a._clearSelection(), a._applySelectionDisplayMode(), "tokens" === a.selectionDisplayMode && (a._currentSelection = void 0), a._applySelection(a.selectionMode);
          break;

        case "tokenTemplate":
          if (a.$.selectionField) for (; "SPAN" === a.$.selectionField.firstElementChild.nodeName;) {
            a.$.selectionField.removeChild(a.$.selectionField.firstElementChild);
          }
          a._tokenTemplate = a._validateTemplate(a.tokenTemplate), a._applySelection();
          break;

        case "value":
          a._queryItems(!0);

          break;

        default:
          _get(_getPrototypeOf(_class39.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "clearItems",
    value: function clearItems() {
      var e = this;
      e.$.listBox.clearItems(), e._clearSelection(!0);
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      var e = this;
      e.$.listBox.clearSelection(), e._clearSelection(!arguments[0]);
    }
  }, {
    key: "blur",
    value: function blur() {
      this.$.input.blur();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.$.input.focus();
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;

      if (!e.disabled && !e.unfocusable) {
        var _t381 = 0 < e.tabIndex ? e.tabIndex : 0;

        return e.$.input.tabIndex = _t381, void ("dropDownButton" === e.dropDownOpenMode ? e.$.dropDownButton.setAttribute("tabindex", _t381) : e.$.dropDownButton.removeAttribute("tabindex"));
      }

      e.$.input.tabIndex = -1, e.$.dropDownButton.removeAttribute("tabindex");
    }
  }, {
    key: "_autoComplete",
    value: function _autoComplete(e) {
      var t = this;
      if ("list" === t.autoComplete) return;
      if (0 === t.$.listBox._items.length && "function" != typeof t.dataSource) return void t.close();

      var i = t.$.input.value.length < t.minLength ? "" : "escaped" === t.displayMode ? t._toDefaultDisplayMode(t.$.input.value) : t.$.input.value,
          a = function a(e) {
        for (var _t382 = 0; _t382 < e.length; _t382++) {
          if (e[_t382]._focused && e[_t382].hasAttribute("focus")) return !0;
        }
      };

      var n;
      1 === t.$.listBox.selectedValues.length && (n = t.$.listBox.getItem(t.$.listBox.selectedValues[0])), t.$.autoCompleteString.textContent = "", t.$.listBox.$.filterInput.value = "none" === t.autoComplete || t.$.input.value.length < t.minLength ? "" : i;

      var o = function o() {
        if (t.$.listBox.isAttached && t.$.input) {
          var _e457 = t.enableShadowDOM ? t.shadowRoot.activeElement : document.activeElement;

          if (t._setDropDownSize(), t.opened && (t._positionDetection.positionDropDown(), t._positionDetection.checkBrowserBounds()), t.$.listBox._filteredItems && 0 < t.$.listBox._filteredItems.length) {
            if (t.$.listBox._scrollView.scrollTop = t.$.listBox._filteredItems[0].offsetTop, "none" !== t.autoComplete && t.$.input.value.length >= t.minLength && !a(t.$.listBox._filteredItems) && t._focus(t.$.listBox._filteredItems[0]), _e457 === t.$.input && "inline" === t.autoComplete && t.$.input.value.length >= t.minLength && t._updateAutoCompleteHelper(), n && n[t.inputMember] === t.$.listBox._filteredItems[0][t.inputMember] && n.value === t.$.listBox._filteredItems[0].value && (t.$.listBox.context = t.$.listBox, t.$.listBox._select(t.$.listBox._filteredItems[0], !0), t.$.listBox.context = r), i !== t.$.listBox._filteredItems[0][t.inputMember] || Smart.TextBox && t instanceof Smart.TextBox && "auto" === t.dropDownOpenMode) {
              if (t._closedFromKeyCombination) return void (t._closedFromKeyCombination = !1);
              if (i.length < t.minLength && !(Smart.TextBox && t instanceof Smart.TextBox && "auto" === t.dropDownOpenMode)) return void t.close();
              t.isCompleted && "none" !== t.dropDownOpenMode && _e457 === t.$.input && t.open();
            }

            return;
          }

          t["function" == typeof t.dataSource ? "open" : "close"]();
        }
      };

      var r = t.$.listBox.context;
      t.$.listBox.context = t.$.listBox, t.$.listBox._filterItems(!!e, o, Smart.TextBox && t instanceof Smart.TextBox && "auto" === t.dropDownOpenMode), t.$.listBox.context = r;
    }
  }, {
    key: "_updateAutoCompleteHelper",
    value: function _updateAutoCompleteHelper() {
      var e = this,
          t = e.$.autoCompleteString;
      if (t.style.width = e.$.input.offsetWidth + "px", t.style.height = e.$.input.offsetHeight + "px", t.style.left = e.$.input.offsetLeft + "px", t.style.top = e.$.input.offsetTop + "px", t.style.paddingLeft = 0 < e.selectedIndexes.length ? 0 : null, !e._focusedItem) return void (t.textContent = "");
      var i = e.$.input.value,
          a = e._focusedItem[e.inputMember];
      a.length !== i.length && 0 === a.toLowerCase().indexOf(i.toLowerCase()) && (t.textContent = e.$.input.value + a.slice(i.length));
    }
  }, {
    key: "_applySelection",
    value: function _applySelection(e, i) {
      function t() {
        for (; "SPAN" === a.$.selectionField.firstElementChild.nodeName;) {
          a.$.selectionField.removeChild(a.$.selectionField.firstElementChild);
        }

        var e = document.createDocumentFragment(),
            t,
            i;
        i = "tokens" === a.selectionDisplayMode ? 1 === a.selectedIndexes.length && ("oneOrManyExtended" === a.selectionMode || "oneOrMany" === a.selectionMode) ? "" : "&#10006" : ",", a.selectedIndexes.map(function (n) {
          t = a._applyTokenTemplate(a.$.listBox._items[n][a.inputMember], i), t._value = a.$.listBox._items[n].value, e.appendChild(t);
        }), a.$.selectionField.insertBefore(e, a.$.input), a._currentSelection = a.selectedIndexes.map(function (e) {
          return a.$.listBox._items[e][a.inputMember];
        }), a.$.container.setAttribute("has-value", ""), a._oldValue = a.value = a._currentSelection.toString(), a._positionDetection.positionDropDown();
      }

      var a = this;
      if (a.$.autoCompleteString.textContent = "", 0 === a.selectedIndexes.length) return void a._clearSelection(i && -1 < i.index && a.$.input.value === a.$.listBox._items[i.index][a.inputMember]);
      if (a.$.listBox._items && 0 !== a.$.listBox._items.length) if ("one" === a.selectionMode || "zeroOrOne" === a.selectionMode || "radioButton" === a.selectionMode) {
        if (a._currentSelection && a._currentSelection.length > a.selectedIndexes.length) return a._currentSelection = a.selectedIndexes.map(function (e) {
          return a.$.listBox._items[e][a.inputMember];
        }), a.$.input.value = a._currentSelection.toString(), void (a._oldValue = a.value = a._currentSelection.toString());
        a._clearSelection(), a._currentSelection = a.selectedIndexes.map(function (e) {
          return a.$.listBox._items[e][a.inputMember];
        }), a.$.input.value = a._currentSelection.toString(), a._oldValue = a.value = a._currentSelection.toString(), a.$.container.setAttribute("has-value", ""), "none" !== a.autoComplete && "function" != typeof a.dataSource && (a._autoComplete(!0), !a._keyboardNavigation && a.close());
      } else {
        if (a.$.input.value = "", a.$.input.placeholder = "", a.$.container.setAttribute("has-value", ""), !a._currentSelection || "oneOrManyExtended" === a.selectionMode || "radioButton" === a.selectionMode && !a.grouped) return void t();

        var _e458 = a.$.selectionField.getElementsByClassName("smart-token");

        if (a._currentSelection.length < a.selectedIndexes.length) {
          var _e459 = a.selectedIndexes.map(function (e) {
            return a.$.listBox._items[e][a.inputMember];
          });

          for (var _t383 = 0; _t383 < _e459.length; _t383++) {
            if (0 > a._currentSelection.indexOf(_e459[_t383])) {
              var _e460 = a.$.listBox._items[a.selectedIndexes[_t383]];

              var _i387 = void 0,
                  _n188 = void 0;

              _n188 = "tokens" === a.selectionDisplayMode ? 1 === a.selectedIndexes.length && ("oneOrManyExtended" === a.selectionMode || "oneOrMany" === a.selectionMode) ? "" : "&#10006" : ",", 1 === a.selectedIndexes.length && ("oneOrManyExtended" === a.selectionMode || "oneOrMany" === a.selectionMode) && (_n188 = ""), _i387 = a._applyTokenTemplate(_e460[a.inputMember], _n188), _i387._value = _e460.value, a.$.selectionField.insertBefore(_i387, a.$.input);
            }
          }

          "none" !== a.autoComplete && a.$.listBox._filteredItems && a.$.listBox._filteredItems.length !== a.$.listBox._items.length && a._autoComplete(!0), a._positionDetection.positionDropDown();
        } else {
          if (0 < a._currentSelection.length && 0 === _e458.length || a._currentSelection.length === a.selectedIndexes.length && a._currentSelection.toString() !== a.selectedValues.toString()) return void t();
          if (!i) return;

          for (var _n189 = 0; _n189 < _e458.length; _n189++) {
            if (_e458[_n189]._value === i.value) {
              a.$.selectionField.removeChild(_e458[_n189]);
              break;
            }
          }
        }

        a._currentSelection = a.selectedIndexes.map(function (e) {
          return a.$.listBox._items[e][a.inputMember];
        }), a._oldValue = a.value = a._currentSelection.toString();
      }
    }
  }, {
    key: "_applySelectionDisplayMode",
    value: function _applySelectionDisplayMode() {
      var e = this;
      "one" === e.selectionMode || "zeroOrOne" === e.selectionMode || "radioButton" === e.selectionMode ? e.$.removeClass("auto-height") : e.$.addClass("auto-height");
    }
  }, {
    key: "_bindingCompleteHandler",
    value: function _bindingCompleteHandler() {
      var e = this;
      e._queryItems(), e._setDropDownSize();
    }
  }, {
    key: "_buttonsMouseEventsHandler",
    value: function _buttonsMouseEventsHandler(e) {
      var t = this;
      t.disabled || t.readonly || ("mouseenter" === e.type ? (e.target.setAttribute("hover", ""), t.setAttribute("hover", ""), "auto" === t.dropDownOpenMode && !(Smart.TextBox && t instanceof Smart.TextBox) && (e.target === t.$.dropDownButton ? (t.open(), t.$.input.focus()) : t.close())) : (e.target.removeAttribute("hover"), t.removeAttribute("hover")));
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.classList.add("smart-drop-down-box"), e._tokenTemplate = e._validateTemplate(e.tokenTemplate), e._applySelectionDisplayMode(), e._applySelection(e.selectionMode), "none" !== e.autoComplete && (e._autoComplete(!0), e.$.input.autocomplete = "off"), e._setDropDownSize(), e.$.input.disabled = e.disabled, e.$.input.readOnly = e.readonly, e._setFocusable(), 0 < e.$.input.value.length && 0 === e.selectedIndexes.length && (e.$.container.setAttribute("has-value", ""), e._oldValue = e.value = e.$.input.value), e.$.arrow.noRipple = !0, e.checkLicense(), e._setAriaRelations(!0);
    }
  }, {
    key: "_clearSelection",
    value: function _clearSelection(e) {
      var t = this;
      if (e && (t.$.input.value = "", t.value = ""), t.$.input.placeholder = t.placeholder, t.$.autoCompleteString.textContent = "", t._currentSelection = [], t.$.selectionField) for (; "SPAN" === t.$.selectionField.firstElementChild.nodeName;) {
        t.$.selectionField.removeChild(t.$.selectionField.firstElementChild);
      }
      "none" !== t.autoComplete && "list" !== t.autoComplete && 0 < t.$.input.value.length && (t._autoCompleteTimer && clearTimeout(t._autoCompleteTimer), "function" != typeof t.dataSource && (t._autoCompleteTimer = setTimeout(function () {
        t._autoComplete(!0);
      }, t.autoCompleteDelay))), t.$.input.value.length || t.$.container.removeAttribute("has-value");
    }
  }, {
    key: "_documentDownHandler",
    value: function _documentDownHandler(e) {
      var t = this;

      _get(_getPrototypeOf(_class39.prototype), "_documentDownHandler", this).call(this, e);

      var i = e.originalEvent.target;
      (t.shadowRoot || t.isInShadowDOM) && (i = e.originalEvent.composedPath()[0]), i !== t.$.dropDownButton || "none" === t.dropDownOpenMode || Smart.Utilities.Core.isMobile || requestAnimationFrame(function () {
        return t.$.input.focus();
      });
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;
      var i = e.originalEvent.target,
          a = i.closest ? i.closest("smart-combo-box") : void 0;
      (t.shadowRoot || t.isInShadowDOM) && (i = e.originalEvent.composedPath()[0], a = i.getRootNode().host);
      var n = i;
      if (t._resizeDetails && t._resizeDetails.started) return t._resizeDetails.started = t._resizeDetails.resizeEventFired = !1, t.removeAttribute("resizing"), t._dropDownResized = !0, void t.$.fireEvent("resizeEnd", {
        position: {
          left: e.pageX,
          top: e.pageY
        }
      });
      if (t.disabled || t._isDropDownClicked || t.readonly) return void delete t._isDropDownClicked;
      if (t._overlayDown) return t.close(), void delete t._overlayDown;

      if (i !== t.$.input && "undefined" != typeof i && i !== t.$.resizeBar) {
        if (i === t.$.selectionField) return void t.$.input.focus();
        if (i === t.$.dropDownButton && "none" !== t.dropDownOpenMode) return t._preventDropDownClose = !0, t.$dropDownContainer.hasClass("smart-visibility-hidden") ? t.open() : t.close(), void (Smart.Utilities.Core.isMobile || requestAnimationFrame(function () {
          return t.$.input.focus();
        }));

        if (i.classList.contains("smart-drop-down-list-selection-label") && a === t && "none" !== t.dropDownOpenMode) {
          t.open();

          var _e461 = t.$.listBox._items.filter(function (e) {
            return e[t.inputMember].toString() === i.textContent;
          })[0];

          return t.$.input.focus(), t.$.listBox._scrollView.scrollTop = _e461.offsetTop, void t._focus(_e461);
        }

        return "tokens" === t.selectionDisplayMode && i.classList.contains("smart-drop-down-list-unselect-button") && a === t ? 1 === t.selectedIndexes.length && 0 > ["zeroOrMany", "zeroOrOne", "checkBox"].indexOf(t.selectionMode) ? void 0 : (t.unselect(t.$.listBox._items.filter(function (e) {
          return e[t.inputMember].toString() === i.previousElementSibling.textContent;
        })[0]), void t.$.input.focus()) : (i = t._getUpEventTarget(i), void 0 === i ? void t.$.input.focus() : void ((!t.$dropDownContainer.hasClass("smart-visibility-hidden") && "dropDownContainer" !== i && "item" !== i || "item" === i && 0 > t.selectionMode.indexOf("Many") && "checkBox" !== t.selectionMode) && t.close(), ("item" === i || "dropDownContainer" === i && n !== t.$.listBox.$.filterInput) && t.$.input.focus()));
      }
    }
  }, {
    key: "_dropDownButtonFocusHandler",
    value: function _dropDownButtonFocusHandler(e) {
      var t = this;
      "focus" === e.type ? ("dropDownButton" !== t.dropDownOpenMode && t.$.input.focus(), t.setAttribute("focus", "")) : t.removeAttribute("focus");
    }
  }, {
    key: "_inputFocusHandler",
    value: function _inputFocusHandler(e) {
      var t = this;
      if (!t.disabled) if ("focus" === e.type) t.setAttribute("focus", ""), t._buttonClicked || (t._oldValue = t.$.input.value);else {
        if (t.removeAttribute("focus"), "" !== e.target.value || 0 !== t.selectedIndexes.length && "" === e.target.value ? t.$.container.setAttribute("has-value", "") : t.$.container.removeAttribute("has-value"), t._preventDropDownClose || (t.opened && ("auto" === t.autoComplete || "inline" === t.autoComplete) && 0 < t.$.input.value.length && t._focusedItem && !t._focusedItem.selected && t.select(t._focusedItem), t.close()), !t._handleAutoCompleteModeList()) return;
        "previousValue" === t.escKeyMode && (t.value = t.$.input.value);
      }
    }
  }, {
    key: "_handleAutoCompleteModeList",
    value: function _handleAutoCompleteModeList() {
      var e = this;

      if ("list" === e.autoComplete && !e._buttonClicked) {
        if (e.opened && e._isDropDownClicked) return !1;
        if (e.$.autoCompleteString.textContent = "", e._lastSelectedItem) e._lastSelectedItem.selected || e.select(e._lastSelectedItem);else if (e.$.input.value.length && e._oldValue) {
          var _t384 = e.$.listBox._queryItems(e._oldValue, e.incrementalSearchMode);

          for (var _a241 = 0; _a241 < _t384.length; _a241++) {
            if (!_t384[_a241].hidden) {
              _t384[_a241].selected || e.select(_t384[_a241]), e._focus(_t384[_a241]);
              break;
            }
          }

          e.value = e.$.input.value = e._oldValue;
        } else e.value = e.$.input.value = "";
      }
    }
  }, {
    key: "_inputChangeEventHandler",
    value: function _inputChangeEventHandler(e) {
      var t = this;
      return e.stopPropagation(), t._preventInputChangeEvent ? void delete t._preventInputChangeEvent : void (t._isDropDownClicked || t._oldValue === t.$.input.value || t.$.fireEvent("change", {
        oldValue: t._oldValue,
        value: t.$.input.value,
        addedItems: [],
        removedItems: [],
        selected: [],
        disabled: [],
        index: [],
        label: []
      }));
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.composedPath()[0] : e.target;

      if (!(t.disabled || t.readonly || i === t.$.listBox.$.filterInput)) {
        var _a242 = "function" == typeof t._focusedItem ? t._focusedItem() : t._focusedItem;

        switch (e.key) {
          case "Enter":
            if (delete t._preventInputChangeEvent, i === t.$.input && _a242 && t.opened) {
              if (_a242.selected && "list" === t.autoComplete) return t.close(), t._unfocus(), void t._handleAutoCompleteModeList();
              _a242.disabled || (t.select(_a242), t._preventInputChangeEvent = !0), !t.$dropDownContainer.hasClass("smart-visibility-hidden") && -1 < t.selectionMode.indexOf("one") && (t.close(), t._unfocus());
            } else i === t.$.dropDownButton ? (t.$.dropDownButton.setAttribute("active", ""), t.$dropDownContainer.hasClass("smart-visibility-hidden") && "none" !== t.dropDownOpenMode ? t.open() : t.close(), t.$.input.focus()) : t.close();

            return void t._handleAutoCompleteModeList();

          case "Escape":
            switch (t.escKeyMode) {
              case "none":
                t.$dropDownContainer.hasClass("smart-visibility-hidden") || (t.close(), t._unfocus());
                break;

              case "clearValue":
                t.value = t.$.input.value = "", t.close();
                break;

              case "previousValue":
                t.$.input.value = t._oldValue;
                break;

              case "firstPossibleValue":
                {
                  var _e462 = t.$.listBox._items.find(function (e) {
                    return !e.disabled && !e.hidden && !e.readonly;
                  });

                  if (_e462) {
                    var _i388 = _e462[t.inputMember];
                    t.$.input.value === _i388 && t.close(), t.$.input.value = _i388;
                  }

                  t.close();
                  break;
                }
            }

            break;

          case "End":
          case "Home":
          case "PageUp":
          case "PageDown":
          case "ArrowUp":
          case "ArrowDown":
            if (!0 === t._autoOpenOnKeyDown(e)) return;

            if (e.altKey) {
              if (t._closedFromKeyCombination = !0, t.$dropDownContainer.hasClass("smart-visibility-hidden") && "none" !== t.dropDownOpenMode) {
                if (t.open(), 0 === t.items.length) return;
                0 === t.selectedIndexes.length ? t._focus(t.items[0]) : 0 < t.selectedIndexes.length && !t.$.listBox._items[t.selectedIndexes[t.selectedIndexes.length - 1]].hidden && t._focus(t.items[t.selectedIndexes[t.selectedIndexes.length - 1]]);
              } else t.close();

              return;
            }

            if (i === t.$.input && t.$dropDownContainer.hasClass("smart-visibility-hidden")) return void (e.ctrlKey && (e.preventDefault(), t._handleKeyStroke(e.key)));
            if (("PageUp" === e.key || "PageDown" === e.key) && !_a242 || i === t.$.listBox.$.filterInput) return;
            if (e.preventDefault(), !_a242 || _a242 && !_a242._focused) return void t._focus(t.items[0]);
            t._handleKeyStroke(e.key), ("inline" === t.autoComplete || "list" === t.autoComplete) && t._updateAutoCompleteHelper();
            break;

          case "Backspace":
            if (t.$.input.previousElementSibling) {
              if (0 === t.$.input.value.length) {
                if (1 === t.selectedIndexes.length && 0 > ["zeroOrMany", "zeroOrOne", "checkBox"].indexOf(t.selectionMode)) return;

                var _e463 = t.$.listBox.getItem(t.$.input.previousElementSibling._value);

                _e463 ? t.unselect(_e463) : t.$.selectionField.firstElementChild && "SPAN" === t.$.selectionField.firstElementChild.nodeName && t.$.selectionField.removeChild(t.$.selectionField.firstElementChild);
              }

              return;
            }

            1 < t.selectedIndexes.length && t.clearSelection(!0);
            break;

          default:
            if (i === t.$.input && "oneOrManyExtended" === t.selectionMode && (t.$.listBox._keysPressed[e.key] = !0), !0 === t._autoOpenOnKeyDown(e)) return;
        }
      }
    }
  }, {
    key: "_handleKeyStroke",
    value: function _handleKeyStroke(e) {
      var t = this,
          i = t.$.listBox;
      if ("none" === t.autoComplete) return void i._handleKeyStrokes(e);
      var a = t.items;

      switch (e) {
        case "ArrowLeft":
        case "ArrowUp":
          t._handleArrowKeys(!0);

          break;

        case "ArrowRight":
        case "ArrowDown":
          t._handleArrowKeys(!1);

          break;

        case "Home":
        case "End":
          {
            if (0 === a.length) return;

            var _n190 = "Home" === e;

            t._focus(_n190 ? a[0] : a[a.length - 1]), i.scrollTop = _n190 ? 0 : i.scrollHeight;
            break;
          }

        case "PageUp":
          {
            t._pageUpKeyHandler(a);

            break;
          }

        case "PageDown":
          {
            t._pageDownKeyHandler(a);

            break;
          }
      }

      i._recycle();
    }
  }, {
    key: "_handleArrowKeys",
    value: function _handleArrowKeys(e) {
      var t = this,
          i = t.$.listBox;
      var a;
      if (t._focusedItem) a = t.$.listBox._indexOf(t._focusedItem), t._focusedItem._focused = !1;else if (0 !== t.selectedIndexes.length) a = t.selectedIndexes[t.selectedIndexes.length - 1];else return;
      var n = e ? i._getPreviousItem(a) : i._getNextItem(a);
      t._focus(n), "list" === t.autoComplete && i._items[a] !== n && (t._keyboardNavigation = !0, i.clearSelection(), i.select(n), delete t._keyboardNavigation), t.ensureVisible(n);
    }
  }, {
    key: "_pageDownKeyHandler",
    value: function _pageDownKeyHandler(e) {
      var t = this,
          i = t.$.listBox;
      var a = i._items[t.selectedIndexes[t.selectedIndexes.length - 1]];
      i._focusedItem && (a = i._focusedItem);
      var n;

      var o = i._indexOf(a);

      var r = a.top + i.$.itemsContainer.offsetHeight - a.height;

      for (var _t385 = o; _t385 < e.length; _t385++) {
        if (e[_t385].top >= r) {
          n = e[_t385];
          break;
        }
      }

      n || (n = e[e.length - 1]), t._focus(n), (n.height + n.top > i.$.itemsContainer.scrollTop + i.$.itemsContainer.offsetHeight || n.top < i.$.itemsContainer.scrollTop) && (i.scrollTop = n.top - i.$.itemsContainer.offsetHeight + n.height);
    }
  }, {
    key: "_pageUpKeyHandler",
    value: function _pageUpKeyHandler(e) {
      var t = this,
          i = t.$.listBox;
      var a = i._items[t.selectedIndexes[t.selectedIndexes.length - 1]];
      i._focusedItem && (a = i._focusedItem);

      var n = a.top - i.$.itemsContainer.offsetHeight,
          o = i._indexOf(a);

      var r;

      for (var _t386 = o; 0 < _t386; _t386--) {
        if (e[_t386].top <= n) {
          r = e[_t386];
          break;
        }
      }

      r || (r = e[0]), i._focus(r), i.scrollTop = r.top, 0 === i._indexOf(r) && (i.scrollTop = 0);
    }
  }, {
    key: "_autoOpenOnKeyDown",
    value: function _autoOpenOnKeyDown(e) {
      var t = this;

      if (!(t.opened || !t.opened && 0 > t.autoOpenShortcutKey.indexOf(e.key))) {
        t.selectedIndexes.length && t._focus(t.items[t.selectedIndexes[t.selectedIndexes.length - 1]]);

        var _i389 = "function" == typeof t._focusedItem ? t._focusedItem() : t._focusedItem;

        return t.open(), _i389 && (!_i389 || _i389._focused) || ("ArrowDown" === e.key ? t._focus(t.items[0]) : "ArrowUp" === e.key && t._focus(t.items[t.items.length - 1]), t.ensureVisible(t._focusedItem)), !0;
      }
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.composedPath()[0] : e.target;

      if (!(t.disabled || "none" === t.escKeyMode && "Escape" === e.key || i === t.$.listBox.$.filterInput)) {
        if (i === t.$.input && "oneOrManyExtended" === t.selectionMode && (t.$.listBox._keysPressed[e.key] = !1), -1 < ["one", "radioButton", "zeroOrOne"].indexOf(t.selectionMode) && 1 === t.selectedIndexes.length && t.$.input.value !== (t._currentSelection ? t._currentSelection[0] : void 0) && t.unselect(t.$.listBox._items[t.selectedIndexes[0]]), "Enter" === e.key) return void t.$.dropDownButton.removeAttribute("active");

        if (i === t.$.input && 0 > e.key.indexOf("Arrow") && 0 > ["Control", "Shift"].indexOf(e.key)) {
          if (t.value === t.$.input.value) return;
          if (t.value = t._currentSelection ? t._currentSelection.toString() + (0 < t._currentSelection.length ? "," : "") + t.$.input.value : t.$.input.value, t.$.autoCompleteString.textContent = "", t._closedFromKeyCombination) return void (t._closedFromKeyCombination = !1);
          if ("none" !== t.autoComplete && "list" !== t.autoComplete ? (t.$.input.value !== (t._currentSelection ? t._currentSelection.toString() : void 0) || t.$.listBox._filteredItems && t.$.listBox._filteredItems.length !== t.$.listBox._items.length) && (t._autoCompleteTimer && clearTimeout(t._autoCompleteTimer), t._autoCompleteTimer = setTimeout(function () {
            t._autoComplete(!0);
          }, t.autoCompleteDelay)) : (0 < t.$.input.value.length && t._queryItems(), t._focusedItem && ("Escape" !== e.key || "firstPossibleValue" !== t.escKeyMode) && (t.open(), " " !== e.key && (t.$.listBox._scrollView.scrollTop = t._focusedItem.offsetTop))), "none" !== t.autoComplete && "list" !== t.autoComplete && t.$.listBox._filteredItems && t.$.listBox._filteredItems.length === t.$.listBox._items.length) return void t.close();
        }
      }
    }
  }, {
    key: "_queryItems",
    value: function _queryItems(e) {
      var t = this;
      if (!t.value || !t.$.input) return void t.close();

      var a = t.$.listBox._queryItems(t.$.input.previousElementSibling ? t.$.input.value : t.value, t.incrementalSearchMode);

      0 === a.length && t._unfocus();

      for (var _n191 = 0; _n191 < a.length; _n191++) {
        if (!a[_n191].hidden) {
          e && !a[_n191].selected && t.select(a[_n191]), t._focus(a[_n191]);
          break;
        }
      }

      "list" === t.autoComplete && (t.enableShadowDOM ? t.shadowRoot.activeElement : document.activeElement) === t.$.input && t.$.input.value.length >= t.minLength ? (t._lastSelectedItem = t._focusedItem, t._updateAutoCompleteHelper()) : t._lastSelectedItem = void 0;
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      var t = this;
      t._resizeDetails && t._resizeDetails.started && e.preventDefault();
    }
  }, {
    key: "_unfocus",
    value: function _unfocus() {
      var e = this;
      e._focusedItem && (e._focusedItem._focused = !1, e.$.listBox._focusedItem = void 0);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoComplete: {
          allowedValues: ["none", "manual", "auto", "inline", "list"],
          type: "string",
          value: "none"
        },
        autoCompleteDelay: {
          value: 100,
          type: "number"
        },
        autoOpenShortcutKey: {
          value: [],
          type: "array"
        },
        dropDownOpenMode: {
          allowedValues: ["none", "default", "dropDownButton", "auto"],
          value: "dropDownButton",
          defaultReflectToAttribute: !0,
          type: "string"
        },
        escKeyMode: {
          allowedValues: ["clearValue", "firstPossibleValue", "none", "previousValue"],
          type: "string",
          value: "none"
        },
        minLength: {
          type: "number",
          value: 2
        },
        value: {
          value: "",
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "input.focus": "_inputFocusHandler",
        "input.blur": "_inputFocusHandler",
        "dropDownButton.focus": "_dropDownButtonFocusHandler",
        "dropDownButton.blur": "_dropDownButtonFocusHandler",
        "input.change": "_inputChangeEventHandler",
        "input.mouseenter": "_buttonsMouseEventsHandler",
        "input.mouseleave": "_buttonsMouseEventsHandler",
        "document.down": "_documentDownHandler",
        "document.up": "_documentUpHandler",
        "document.selectstart": "_selectStartHandler",
        "dropDownButton.down": "_buttonsDownHandler",
        "dropDownButton.mouseenter": "_buttonsMouseEventsHandler",
        "dropDownButton.mouseleave": "_buttonsMouseEventsHandler",
        keydown: "_keyDownHandler",
        keyup: "_keyUpHandler",
        "listBox.change": "_listBoxChangeHandler",
        "listBox.itemClick": "_listBoxItemClickHandler",
        "listBox.keydown": "_listBoxKeyDownHandler",
        wheel: "_mouseWheelHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.combobox.css"];
    }
  }]);

  return _class39;
}(Smart.DropDownList)), Smart("smart-drop-down-button",
/*#__PURE__*/
function (_Smart$ContentElement3) {
  "use strict";

  _inherits(_class40, _Smart$ContentElement3);

  function _class40() {
    _classCallCheck(this, _class40);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class40).apply(this, arguments));
  }

  _createClass(_class40, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <span class=\"smart-label\" id=\"label\">[[label]]</span>\n                    <div id=\"content\" class=\"smart-content\" role=\"presentation\">\n                        <div id=\"buttonsContainer\" class=\"smart-buttons-container\" role=\"presentation\">\n                            <span id=\"actionButton\" class=\"smart-action-button\">[[placeholder]]</span>\n                            <span id=\"dropDownButton\" class=\"smart-drop-down-button\">\n                                <span class=\"smart-drop-down-button-icon\" id=\"arrow\" aria-hidden=\"true\"></span>\n                            </span>\n                        </div>\n                        <div id=\"dropDownContainer\" class=\"smart-drop-down smart-drop-down-container smart-visibility-hidden\" role=\"dialog\">\n                            <smart-scroll-viewer id=\"scrollViewer\"\n                                right-to-left=\"[[rightToLeft]]\"\n                                horizontal-scroll-bar-visibility=\"[[horizontalScrollBarVisibility]]\"\n                                vertical-scroll-bar-visibility=\"[[verticalScrollBarVisibility]]\">\n                                <content></content>\n                            </smart-scroll-viewer>\n                            <div id=\"resizeBar\" class=\"smart-drop-down-resize-bar\" aria-label=\"Resize\">\n                                <div></div>\n                            </div>\n                         </div>\n                    </div>\n                    <span class=\"smart-hint\" id=\"hint\">[[hint]]</span>\n                </div>";
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;

      _get(_getPrototypeOf(_class40.prototype), "attached", this).call(this);

      e.isCompleted && e.$.dropDownContainer && (e._positionDetection.dropDownAttached("_setDropDownSize"), e._positionDetection.checkBrowserBounds());
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;

      _get(_getPrototypeOf(_class40.prototype), "detached", this).call(this);

      e.$.dropDownContainer && (e.close(), e._positionDetection.dropDownDetached());
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;
      "disabled" === e || "unfocusable" === e ? a._setFocusable() : "dropDownAppendTo" === e ? a._positionDetection.dropDownAppendToChangedHandler() : "dropDownHeight" === e || "dropDownMaxHeight" === e || "dropDownMaxWidth" === e || "dropDownMinHeight" === e || "dropDownMinWidth" === e || "dropDownWidth" === e ? a._setDropDownSize() : "dropDownOpenMode" === e ? (a._setFocusable(), a.close(), a._setAriaRelations()) : "dropDownOverlay" === e ? i || a._positionDetection.removeOverlay() : "dropDownPlaceholder" === e ? a.$.dropDownContainer.hasAttribute("empty") && (a.$.scrollViewer.$.scrollViewerContentContainer.innerHTML = i, a.opened && a.$.scrollViewer.refresh()) : "dropDownPosition" === e ? a._positionDetection.dropDownPositionChangedHandler() : "innerHTML" === e ? ("" === i.trim() ? (a.$.dropDownContainer.setAttribute("empty", ""), requestAnimationFrame(function () {
        return a.$.scrollViewer.$.scrollViewerContentContainer.innerHTML = a.dropDownPlaceholder;
      })) : (a.$.dropDownContainer.removeAttribute("empty"), a.$.scrollViewer.$.scrollViewerContentContainer.innerHTML = i), a.opened && a.$.scrollViewer.refresh()) : "opened" === e ? i ? a.open() : a.close() : "placeholder" === e ? ("" === t || "" === i) && a._setFocusable() : "resizeIndicator" === e ? i ? a.$.dropDownContainer.setAttribute("resize-indicator", "") : a.$.dropDownContainer.removeAttribute("resize-indicator") : "resizeMode" === e ? (a.$.dropDownContainer.setAttribute("resize-mode", a.resizeMode), a.opened && a.$.scrollViewer.refresh()) : "label" === e ? i ? a._ariaButton.setAttribute("aria-labelledby", a.$.label.id) : "DropDownButton" === a.elementName && a._ariaButton.setAttribute("aria-labelledby", a.$.actionButton.id) : void 0;
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e464 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e464.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? void (t.$.scrollViewer.appendChild(e), t.opened && t.$.scrollViewer.refresh()) : void t.error(t.localize("invalidNode", {
        method: "removeChild",
        node: "node"
      }));
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e465 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e465.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? void (!t.$.dropDownContainer.contains(e) || (t.$.scrollViewer.removeChild(e), t.opened && t.$.scrollViewer.refresh())) : void t.error(t.localize("invalidNode", {
        method: "removeChild",
        node: "node"
      }));
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      var e = this;
      e.isCompleted && e.$.scrollViewer.removeAll();
    }
  }, {
    key: "_open",
    value: function _open() {
      var e = this;

      if (!e.disabled && e.offsetHeight && e.$dropDownContainer.hasClass("smart-visibility-hidden")) {
        if (e.$dropDownContainer.hasClass("not-in-view") && e.$dropDownContainer.removeClass("not-in-view"), e.$.dropDownContainer.style.transition = null, e.dropDownAppendTo && 0 < e.dropDownAppendTo.length) {
          var _t388 = e.getBoundingClientRect();

          if (e.$.container.contains(e.$.dropDownContainer)) {
            var _t389 = 0;

            var _i390 = setInterval(function () {
              var a = e.getBoundingClientRect();
              _t389++, a.top === e._positionTop && 10 > _t389 || (e.open(), clearInterval(_i390), e._positionTop = a.top);
            }, 100);

            return;
          }

          _t388.top !== e._positionTop && (e._positionTop = _t388.top);
        }

        var _t387 = e.$.fireEvent("opening").defaultPrevented;
        _t387 || (e.opened = !0, e._ariaButton.setAttribute("aria-expanded", !0), e._positionDetection.placeOverlay(), e._positionDetection.checkBrowserBounds("vertically"), e._positionDetection.positionDropDown(), e._positionDetection.checkBrowserBounds("horizontally"), e.$dropDownContainer.removeClass("smart-visibility-hidden"), e.$.fireEvent("open"), e.$.dropDownButton && ("dropDownButton" === e.dropDownOpenMode ? e.$.dropDownButton.setAttribute("selected", "") : e.$.dropDownButton.removeAttribute("selected")), e.$.input && e.$.input.focus());
      }
    }
  }, {
    key: "open",
    value: function open() {
      var e = this,
          t = document.querySelectorAll("smart-drop-down-button, smart-color-picker");

      for (var _a243 = 0; _a243 < t.length; _a243++) {
        t[_a243] !== e && t[_a243].opened && t[_a243].close();
      }

      e._open(), e.$.scrollViewer.refresh();
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(e, t) {
      var i = this;
      i.isCompleted && i.$.scrollViewer.scrollTo(e, t);
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class40.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.classList.add("smart-drop-down-box"), e._edgeMacFF = Smart.Utilities.Core.Browser.Edge || Smart.Utilities.Core.Browser.Firefox && -1 !== navigator.platform.toLowerCase().indexOf("mac"), e._positionDetection = new Smart.Utilities.PositionDetection(e, e.$.dropDownContainer, e.$.container, "close"), e._positionDetection.getDropDownParent(!0), e._positionDetection.setDropDownPosition(), e._calculateDropDownSize(), e.$.dropDownContainer.setAttribute("resize-mode", e.resizeMode), e.resizeIndicator && e.$.dropDownContainer.setAttribute("resize-indicator", ""), e._positionDetection.handleAutoPositioning(), e.$.label && !e.$.label.id && (e.$.label.id = e.id + "Label"), e.$.actionButton && !e.$.actionButton.id && (e.$.actionButton.id = e.id + "ActionButton"), e.$.hint && !e.$.hint.id && (e.$.hint.id = e.id + "Hint"), e._createElement(), e.opened ? e.open() : e.hasAnimation && e._edgeMacFF && e.$dropDownContainer.addClass("not-in-view"), e._positionTop = e.getBoundingClientRect().top, _get(_getPrototypeOf(_class40.prototype), "render", this).call(this);
    }
  }, {
    key: "_setAriaRelations",
    value: function _setAriaRelations(e) {
      var t = this;
      var i, a;
      "dropDownButton" === t.dropDownOpenMode ? (i = t, a = t.$.dropDownButton, a.removeAttribute("aria-hidden"), t.$.actionButton.setAttribute("role", "button")) : (i = t.$.dropDownButton, i.setAttribute("aria-hidden", !0), a = t, t.$.actionButton.removeAttribute("role")), t._ariaButton = a, a.setAttribute("role", "button"), a.setAttribute("aria-haspopup", "dialog"), a.setAttribute("aria-owns", t.$.dropDownContainer.id), a.setAttribute("aria-describedby", t.$.hint.id), t.label ? a.setAttribute("aria-labelledby", t.$.label.id) : "DropDownButton" === t.elementName && a.setAttribute("aria-labelledby", t.$.actionButton.id), i.setAttribute("role", "presentation"), e ? t.opened && a.setAttribute("aria-expanded", !0) : (i.removeAttribute("aria-haspopup"), i.removeAttribute("aria-owns"), i.removeAttribute("aria-describedby"), i.removeAttribute("aria-labelledby"));
    }
  }, {
    key: "_setDropDownSize",
    value: function _setDropDownSize() {
      var e = this;
      e._dropDownSize || e._calculateDropDownSize(), ["dropDownMinWidth", "dropDownMinHeight", "dropDownMaxWidth", "dropDownMaxHeight"].forEach(function (t) {
        e.$.dropDownContainer.style[t.replace("dropDown", "").replace(/^./, "m")] = e[t] ? e[t] + (e[t].toString().endsWith("%") ? "%" : "px") : null;
      }), e.$.dropDownContainer.style.width = e.dropDownWidth ? "auto" === e.dropDownWidth ? "auto" : ("initial" === e.dropDownWidth ? e.offsetWidth : parseFloat(e.dropDownWidth)) + "px" : "auto" === e._dropDownSize.width ? "auto" : (parseFloat(e._dropDownSize.width) || 0) + "px", e.$.dropDownContainer.style.height = e.dropDownHeight && "auto" !== e.dropDownHeight ? parseFloat(e.dropDownHeight) + (-1 < (e.dropDownHeight + "").indexOf("%") ? "%" : "px") : e._dropDownSize.height;
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      if (e.disabled || e.unfocusable) return e.removeAttribute("tabindex"), e.$.actionButton.removeAttribute("tabindex"), void e.$.dropDownButton.removeAttribute("tabindex");
      var t = 0 < e.tabIndex ? e.tabIndex : 0;
      e.$.actionButton.removeAttribute("tabindex"), e.$.dropDownButton.removeAttribute("tabindex"), e.tabIndex = t;
    }
  }, {
    key: "_calculateDropDownSize",
    value: function _calculateDropDownSize() {
      var e = this;
      e._dropDownSize = {};
      var t = window.getComputedStyle(e.$.dropDownContainer),
          i = parseFloat(t.getPropertyValue("border-top-width").trim()),
          a = parseFloat(t.getPropertyValue("border-bottom-width").trim()),
          n = parseFloat(t.getPropertyValue("margin-top").trim()),
          o = parseFloat(t.getPropertyValue("margin-bottom").trim()),
          r = parseFloat(t.getPropertyValue("padding-top").trim()),
          l = parseFloat(t.getPropertyValue("padding-bottom").trim());
      Smart.Utilities.Core.CSSVariablesSupport() && (e._dropDownSize.width = t.getPropertyValue("--smart-drop-down-list-drop-down-width").trim(), e._dropDownSize.height = t.getPropertyValue("--smart-drop-down-list-drop-down-height").trim()), (!e._dropDownSize.width || -1 < e._dropDownSize.width.indexOf("initial")) && (e._dropDownSize.width = e.offsetWidth), e._dropDownSize.height || (e._dropDownSize.height = "auto"), e._dropDownSize.minHeight = parseFloat(t.getPropertyValue("min-height").trim()), e._dropDownSize.maxHeight = parseFloat(t.getPropertyValue("max-height").trim()), e._dropDownSize.borderWidth = (isNaN(i) ? 0 : i) + (isNaN(a) ? 0 : a), e._dropDownSize.paddingWidth = (isNaN(r) ? 0 : r) + (isNaN(l) ? 0 : l), e._dropDownSize.marginWidth = (isNaN(n) ? 0 : n) + (isNaN(o) ? 0 : o);
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      "" === e.innerHTML.trim() && (e.$.dropDownContainer.setAttribute("empty", ""), e.$.scrollViewer.$.scrollViewerContentContainer.innerHTML = e.dropDownPlaceholder), e._setDropDownSize(), e._setFocusable(), e._setAriaRelations(!0), e.$.arrow.noRipple = !0;
    }
  }, {
    key: "_dragStartHandler",
    value: function _dragStartHandler(e) {
      var t = this;
      t._resizeDetails && t._resizeDetails.started && e.preventDefault();
    }
  }, {
    key: "_dropDownTransitionendHandler",
    value: function _dropDownTransitionendHandler() {
      var e = this;
      e._edgeMacFF && !e.opened && e.hasAnimation && (e.$.dropDownContainer.style.top = e.$.dropDownContainer.style.left = "", e.$dropDownContainer.addClass("not-in-view"));
    }
  }, {
    key: "_blurEventHandler",
    value: function _blurEventHandler() {
      var e = this;
      e.$.dropDownButton && (e.removeAttribute("focus"), e.$.dropDownButton.removeAttribute("focus")), e.$.actionButton && (e.removeAttribute("focus"), e.$.actionButton.removeAttribute("focus"));
    }
  }, {
    key: "_focusEventHandler",
    value: function _focusEventHandler() {
      var e = this;
      e.$.dropDownButton && (e.setAttribute("focus", ""), e.$.dropDownButton.setAttribute("focus", "")), e.$.actionButton && (e.setAttribute("focus", ""), e.$.actionButton.setAttribute("focus", ""));
    }
  }, {
    key: "_getUpEventTarget",
    value: function _getUpEventTarget(e) {
      var t = this;
      var i = e;
      if (i === t.$.dropDownContainer) return "dropDownContainer";

      for (i = void 0 === i.parentElement ? i.getRootNode().host : i.parentElement; i;) {
        if (i === t.$.dropDownContainer) {
          i = "dropDownContainer";
          break;
        }

        i = i.parentElement === void 0 ? i.getRootNode().host : i.parentElement;
      }

      return i;
    }
  }, {
    key: "close",
    value: function close() {
      var e = this;

      if (!e.$dropDownContainer.hasClass("smart-visibility-hidden")) {
        var _t390 = e.$.fireEvent("closing").defaultPrevented;
        _t390 || (e.$dropDownContainer.addClass("smart-visibility-hidden"), e.$.fireEvent("close"), e.$.dropDownButton && e.$.dropDownButton.removeAttribute("selected"), e.opened = !1, e._ariaButton.removeAttribute("aria-expanded"), e._preventDropDownClose = !1, e._positionDetection.removeOverlay(!0), e._edgeMacFF && !e.hasAnimation && (e.$.dropDownContainer.style.top = e.$.dropDownContainer.style.left = "", e.$dropDownContainer.addClass("not-in-view")));
      }
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = t.hasAttribute("resizing");
      if (t.$.actionButton.removeAttribute("active"), t._resizeDetails && t._resizeDetails.started) return t._resizeDetails.started = t._resizeDetails.resizeEventFired = !1, t.removeAttribute("resizing"), t._preventDropDownClose = !1, t.focus(), void t.$.fireEvent("resizeEnd", {
        position: {
          left: e.pageX,
          top: e.pageY
        }
      });
      if (t.disabled || t._isDropDownClicked || t.readonly) return void delete t._isDropDownClicked;
      if (t._overlayDown) return t.close(), void delete t._overlayDown;
      var a = e.originalEvent.target;

      if (t.enableShadowDOM && (a = e.originalEvent.composedPath()[0]), t._preventsSelectStart = !1, "undefined" != typeof a && a !== t.$.resizeBar) {
        var _e466 = a.closest(".smart-action-button");

        if (t._buttonClicked && ("dropDownButton" === t.dropDownOpenMode && _e466 && t._buttonClicked === t.$.actionButton ? t.$.fireEvent("actionButtonClick") : (a.closest(".smart-drop-down-button") === t._buttonClicked || _e466 === t._buttonClicked) && t.$.fireEvent("dropDownButtonClick")), t._buttonClicked = void 0, !t.editable && _e466 === t.$.actionButton || a.closest(".smart-drop-down-button") === t.$.dropDownButton) return "dropDownButton" === t.dropDownOpenMode && _e466 === t.$.actionButton ? void t.close() : void (t.$dropDownContainer.hasClass("smart-visibility-hidden") && "none" !== t.dropDownOpenMode ? t.open() : t.close());
        a = t._getUpEventTarget(a), void 0 === a || (("dropDownContainer" !== a && "item" !== a || "item" === a && "checkBox" !== t.selectionMode && 0 > t.selectionMode.indexOf("Many")) && t.close(), i && t.$.scrollViewer && t.$.scrollViewer.refresh());
      }
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this,
          i = (t.shadowRoot || t.getRootNode()).activeElement || document.activeElement;
      if (!(t.disabled || t.readonly || i !== t && i !== t.$.dropDownButton && i !== t.$.actionButton)) switch (e.key) {
        case "Enter":
        case " ":
          e.preventDefault(), e.target !== t.$.actionButton && (t.opened && "Enter" === e.key ? t.close() : !t.opened && !t.readonly && "none" !== t.dropDownOpenMode && t.open());
          break;

        case "End":
          t.$.scrollViewer.scrollTop = t.$.scrollViewer.scrollHeight;
          break;

        case "Home":
          t.$.scrollViewer.scrollTop = 0;
          break;

        case "PageUp":
        case "PageDown":
          t.$.scrollViewer.scrollTop += (-1 < e.key.indexOf("Down") ? 1 : -1) * t.$.dropDownContainer.offsetHeight;
          break;

        case "ArrowUp":
        case "ArrowDown":
          if (e.altKey) return void (t.disabled || t.readonly || "none" === t.dropDownOpenMode || (t.$dropDownContainer.hasClass("smart-visibility-hidden") ? t.open() : t.close()));
          e.preventDefault(), t.$.scrollViewer.scrollTop += 10 * (-1 < e.key.indexOf("Down") ? 1 : -1);
          break;

        case "Escape":
          e.preventDefault(), t.close();
      }
    }
  }, {
    key: "_propertyValidator",
    value: function _propertyValidator(e, t) {
      return "number" != typeof t && "string" != typeof t ? e : t;
    }
  }, {
    key: "_mouseEnterHandler",
    value: function _mouseEnterHandler() {
      var e = this;
      e._isElementHovered = !0, "auto" !== e.dropDownOpenMode || e.disabled || e.readonly || e.open();
    }
  }, {
    key: "_mouseLeaveHandler",
    value: function _mouseLeaveHandler() {
      var e = this;
      e.removeAttribute("hover"), e._isElementHovered = !1, "auto" !== e.dropDownOpenMode || e.disabled || e.readonly || e._autoClose();
    }
  }, {
    key: "_autoClose",
    value: function _autoClose() {
      var e = this;
      e._autoCloseTimeout = setTimeout(function () {
        e._isElementHovered || e.close(), clearTimeout(e._autoCloseTimeout);
      }.bind(e), e.autoCloseDelay);
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      function t() {
        if (m = e.pageY - o._resizeDetails.y, "bottom" === c) o._resizeDetails.height = a(l.clientHeight - s.top - 6, n(0, o._resizeDetails.height + m)), o._resizeDetails.y = n(s.top + l.scrollTop - o._resizeDetails.offsetY, a(l.clientHeight + l.scrollTop - 1.5 * o._resizeDetails.offsetY, e.pageY));else {
          if (o._resizeDetails.height = a(o._dropDownSize.maxHeight, n(0, a(d.top, o._resizeDetails.height - m))), m = n(0, s.top + (s.height - n(o._dropDownSize.minHeight, o._resizeDetails.height))), o.dropDownAppendTo && 0 < o.dropDownAppendTo.length) {
            var _e467 = Math.abs(parseFloat(getComputedStyle(o.$.dropDownContainer).getPropertyValue("margin-bottom"))) || 0;

            o.$.dropDownContainer.style.top = o.dropDownAppendTo && 0 < o.dropDownAppendTo.length ? _e467 + m + "px" : "";
          }

          var _t391 = d.top + l.scrollTop + o._resizeDetails.offsetYtop;

          o._resizeDetails.y = n(o._resizeDetails.offsetYtop, a(_t391, n(_t391 - o._dropDownSize.maxHeight, e.pageY)));
        }
        o.$.dropDownContainer.style.height = o._resizeDetails.height + "px";
      }

      function i() {
        m = e.pageX - o._resizeDetails.x, o._resizeDetails.width = a(l.clientWidth - s.left - 6, n(0, o._resizeDetails.width + m)), o.$.dropDownContainer.style.width = o._resizeDetails.width + "px", o._resizeDetails.x = n(s.left + l.scrollLeft - o._resizeDetails.offsetXR, a(l.clientWidth + l.scrollLeft - 1.5 * o._resizeDetails.offsetXR, e.pageX));
      }

      var a = Math.min,
          n = Math.max;
      var o = this,
          r = o.enableShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      if ("auto" === o.dropDownOpenMode && null !== o.dropDownAppendTo && (o.contains(r) || o.$.dropDownContainer.contains(r) ? o._isElementHovered = !0 : (o._isElementHovered = !1, o._autoClose())), !o._resizeDetails || o._resizeDetails && !o._resizeDetails.started) return;
      o.setAttribute("resizing", ""), o._resizeDetails.resizeEventFired || (o.$.fireEvent("resizeStart", {
        position: {
          left: e.pageX,
          top: e.pageY
        }
      }), o._resizeDetails.resizeEventFired = !0);
      var l = document.documentElement,
          s = o.$.dropDownContainer.getBoundingClientRect(),
          d = o.getBoundingClientRect(),
          c = o.$.dropDownContainer.hasAttribute("top") ? "top" : "bottom";
      var m;

      switch (o.resizeMode) {
        case "vertical":
          t();
          break;

        case "horizontal":
          i();
          break;

        case "both":
          i(), t();
      }
    }
  }, {
    key: "_documentDownHandler",
    value: function _documentDownHandler(e) {
      var t = this;
      if (t.disabled || t.readonly) return;
      var i = e.originalEvent.target;

      if (i === t._overlay && (t._overlayDown = !0), t.enableShadowDOM) {
        i = e.originalEvent.composedPath()[0];

        for (var _e468 = i; _e468;) {
          if (_e468.closest(".smart-drop-down-container") === t.$.dropDownContainer) {
            t._isDropDownClicked = !0;
            break;
          }

          _e468 = _e468.getRootNode().host;
        }
      } else t._isDropDownClicked = i.closest(".smart-drop-down-container") === t.$.dropDownContainer;

      if (t._buttonClicked = i.closest(".smart-action-button") || i.closest(".smart-drop-down-button"), t._isDropDownClicked && (t._preventDropDownClose = !0), i === t.$.resizeBar && "none" !== t.resizeMode) {
        t._resizeDetails || (t._resizeDetails = {});

        var _i391 = t.$.dropDownContainer.getBoundingClientRect();

        t._resizeDetails.started = !0, t._resizeDetails.x = e.pageX, t._resizeDetails.y = e.pageY, t._resizeDetails.width = t.$.dropDownContainer.offsetWidth, t._resizeDetails.height = t.$.dropDownContainer.offsetHeight, t._resizeDetails.offsetXL = e.clientX - _i391.left, t._resizeDetails.offsetXR = _i391.left + t.$.dropDownContainer.offsetWidth - e.clientX, t._resizeDetails.offsetY = _i391.top + t.$.dropDownContainer.offsetHeight - e.clientY, t._resizeDetails.offsetYtop = e.clientY - _i391.top, t._preventDropDownClose = !0;
      }
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      "none" === e.resizeMode && (e._calculateDropDownSize(), e._setDropDownSize());
    }
  }, {
    key: "_resizeBarMoveHandler",
    value: function _resizeBarMoveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler(e) {
      var t = this;

      if (t.dropDownAppendTo && 0 < t.dropDownAppendTo.length) {
        var _i392 = e.detail.styleProperties,
            _a244 = ["font-size", "font-family", "font-style", "font-weight"];

        for (var _e469 = 0; _e469 < _a244.length; _e469++) {
          _i392[_a244[_e469]] && (t.$.dropDownContainer.style[_a244[_e469]] = _i392[_a244[_e469]].value);
        }
      }

      t._dropDownSize && "auto" === t._dropDownSize.height && t._setDropDownSize();
    }
  }, {
    key: "_buttonsDownHandler",
    value: function _buttonsDownHandler(e) {
      var t = this;

      if (!t.disabled) {
        if (t.hasRippleAnimation) if ("dropDownButton" === t.dropDownOpenMode) Smart.Utilities.Animation.Ripple.animate(e.target, e.pageX, e.pageY);else if (e.target === t.$.dropDownButton || !t.editable) {
          var _i393 = t.$.buttonsContainer;
          _i393.firstElementChild.noRipple = !0, Smart.Utilities.Animation.Ripple.animate(_i393, e.pageX, e.pageY), _i393.firstElementChild.noRipple = !1;
        }
        t._preventsSelectStart = !0, "dropDownButton" === t.dropDownOpenMode && e.target === t.$.actionButton && t.$.actionButton.setAttribute("active", ""), t.opened && (t._preventDropDownClose = !0);
      }
    }
  }, {
    key: "_buttonsMouseEventsHandler",
    value: function _buttonsMouseEventsHandler(e) {
      var t = this;
      t.disabled || ("mouseenter" === e.type ? (t.setAttribute("hover", ""), e.target.setAttribute("hover", "")) : (t.removeAttribute("hover"), e.target.removeAttribute("hover")));
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      this._preventsSelectStart && e.preventDefault();
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoCloseDelay: {
          value: 100,
          type: "number"
        },
        dropDownAppendTo: {
          value: null,
          type: "any"
        },
        dropDownButtonPosition: {
          allowedValues: ["none", "left", "right", "top", "bottom"],
          value: "right",
          type: "string"
        },
        dropDownHeight: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownMaxHeight: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownMaxWidth: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownMinHeight: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownMinWidth: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        dropDownOpenMode: {
          allowedValues: ["none", "default", "dropDownButton", "auto"],
          value: "default",
          type: "string"
        },
        dropDownOverlay: {
          value: !1,
          type: "boolean"
        },
        dropDownPlaceholder: {
          value: "No Items",
          type: "string"
        },
        dropDownPosition: {
          allowedValues: ["auto", "top", "bottom", "overlay-top", "overlay-center", "overlay-bottom", "center-bottom", "center-top"],
          value: "auto",
          type: "string"
        },
        dropDownWidth: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        hint: {
          value: "",
          type: "string"
        },
        horizontalScrollBarVisibility: {
          type: "string",
          value: "auto",
          allowedValues: ["auto", "disabled", "hidden", "visible"]
        },
        label: {
          value: "",
          type: "string"
        },
        messages: {
          extend: !0,
          value: {
            en: {
              invalidNode: "smart-drop-down-button: Invalid parameter \"{{node}}\" when calling {{method}}."
            }
          },
          type: "object"
        },
        opened: {
          value: !1,
          type: "boolean"
        },
        placeholder: {
          value: "",
          type: "string"
        },
        resizeIndicator: {
          value: !1,
          type: "boolean"
        },
        resizeMode: {
          value: "none",
          allowedValues: ["none", "horizontal", "vertical", "both"],
          type: "string"
        },
        verticalScrollBarVisibility: {
          type: "string",
          value: "auto",
          allowedValues: ["auto", "disabled", "hidden", "visible"]
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "actionButton.down": "_buttonsDownHandler",
        "actionButton.mouseenter": "_buttonsMouseEventsHandler",
        "actionButton.mouseleave": "_buttonsMouseEventsHandler",
        "document.selectstart": "_selectStartHandler",
        "document.dragstart": "_dragStartHandler",
        "document.down": "_documentDownHandler",
        "document.up": "_documentUpHandler",
        "document.move": "_documentMoveHandler",
        "dropDownButton.down": "_buttonsDownHandler",
        "dropDownButton.mouseenter": "_buttonsMouseEventsHandler",
        "dropDownButton.mouseleave": "_buttonsMouseEventsHandler",
        keydown: "_keyDownHandler",
        focus: "_focusEventHandler",
        blur: "_blurEventHandler",
        "dropDownContainer.transitionend": "_dropDownTransitionendHandler",
        mouseenter: "_mouseEnterHandler",
        mouseleave: "_mouseLeaveHandler",
        resize: "_resizeHandler",
        "resizeBar.move": "_resizeBarMoveHandler",
        styleChanged: "_styleChangedHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.scrollviewer.css", "smart.dropdown.css", "smart.dropdownbutton.css"];
    }
  }]);

  return _class40;
}(Smart.ContentElement)), Smart("smart-multi-split-button",
/*#__PURE__*/
function (_Smart$DropDownList2) {
  "use strict";

  _inherits(_class41, _Smart$DropDownList2);

  function _class41() {
    _classCallCheck(this, _class41);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class41).apply(this, arguments));
  }

  _createClass(_class41, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <span class=\"smart-label\" id=\"label\">[[label]]</span>\n                    <div id=\"content\" class=\"smart-content\">\n                        <div id=\"actionButton\" class =\"smart-input smart-action-button\">\n                         <template>\n                                 <div class=\"smart-multi-split-button-buttons\" *items={{buttonsDataSource}}><span class=\"smart-action-split-button\" inner-H-T-M-L={{item}}></span></div>\n                          </template>\n                        </div>\n                        <span id=\"dropDownButton\" class=\"smart-drop-down-button\">\n                            <span class =\"smart-drop-down-button-icon\" id=\"arrow\"></span>\n                        </span>\n                        <div id=\"dropDownContainer\" class=\"smart-drop-down smart-drop-down-container smart-visibility-hidden\">\n                            <smart-list-box id=\"listBox\" unfocusable\n                                    animation=\"[[animation]]\"\n                                    data-source=\"[[dataSource]]\"\n                                    disabled=\"[[disabled]]\"\n                                    display-loading-indicator=\"[[displayLoadingIndicator]]\"\n                                    display-member=\"[[displayMember]]\"\n                                    filterable=\"[[filterable]]\"\n                                    filter-mode=\"[[filterMode]]\"\n                                    filter-input-placeholder=\"[[filterInputPlaceholder]]\"\n                                    grouped=\"[[grouped]]\"\n                                    group-member=\"[[groupMember]]\"\n                                    item-height=\"[[itemHeight]]\"\n                                    item-template=\"[[itemTemplate]]\"\n                                    incremental-search-delay=\"[[incrementalSearchDelay]]\"\n                                    incremental-search-mode=\"[[incrementalSearchMode]]\"\n                                    loading-indicator-placeholder=\"[[loadingIndicatorPlaceholder]]\"\n                                    loading-indicator-position=\"[[loadingIndicatorPosition]]\"\n                                    name=\"[[name]]\"\n                                    placeholder=\"[[dropDownPlaceholder]]\"\n                                    readonly=\"[[readonly]]\"\n                                    right-to-left=\"[[rightToLeft]]\"\n                                    selected-indexes=\"{{selectedIndexes}}\"\n                                    selection-mode=\"[[selectionMode]]\"\n                                    selected-values=\"{{selectedValues}}\"\n                                    sorted=\"[[sorted]]\"\n                                    theme=\"[[theme]]\"\n                                    value-member=\"[[valueMember]]\"\n                                    horizontal-scroll-bar-visibility=\"[[horizontalScrollBarVisibility]]\"\n                                    vertical-scroll-bar-visibility=\"[[verticalScrollBarVisibility]]\"\n                                    virtualized=\"[[virtualized]]\">\n                                <content></content>\n                            </smart-list-box>\n                            <div id=\"resizeBar\" class=\"smart-drop-down-resize-bar\">\n                                <div></div>\n                            </div>\n                         </div>\n                    </div>\n                    <span class=\"smart-hint\" id=\"hint\">[[hint]]</span>\n                </div>";
    }
  }, {
    key: "_blurEventHandler",
    value: function _blurEventHandler() {
      var e = this;
      e.removeAttribute("focus"), e._preventDropDownClose || e.close();
    }
  }, {
    key: "_focusEventHandler",
    value: function _focusEventHandler() {
      this.setAttribute("focus", "");
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;

      _get(_getPrototypeOf(_class41.prototype), "_documentUpHandler", this).call(this, e);

      var a = (t.shadowRoot || t).querySelectorAll(".smart-action-split-button");

      for (var _t392 = 0; _t392 < a.length; _t392++) {
        var _e470 = a[_t392];

        _e470.removeAttribute("active");
      }

      t.removeAttribute("active");
    }
  }, {
    key: "_dropDownButtonMouseEventsHandler",
    value: function _dropDownButtonMouseEventsHandler(e) {
      var t = this;
      "mouseleave" === e.type ? (t.$.dropDownButton.removeAttribute("hover"), t.removeAttribute("hover")) : (t.$.dropDownButton.setAttribute("hover", ""), t.setAttribute("hover", ""));
    }
  }, {
    key: "_buttonsDownHandler",
    value: function _buttonsDownHandler(e) {
      var t = this,
          a = (t.shadowRoot || t).querySelectorAll(".smart-action-split-button");

      for (var _n192 = 0; _n192 < a.length; _n192++) {
        var _i394 = a[_n192],
            _o120 = _i394.getBoundingClientRect();

        "mouseleave" === e.type ? (a[_n192].removeAttribute("active"), t.removeAttribute("active", "")) : (t.setAttribute("active", ""), a[_n192].removeAttribute("active"), _o120.left <= e.pageX && e.pageX <= _o120.width + _o120.left && (a[_n192].setAttribute("active", ""), t.$.fireEvent("buttonClick", {
          index: _n192,
          label: t.buttonsDataSource[_n192]
        })));
      }
    }
  }, {
    key: "_buttonsMouseEventsHandler",
    value: function _buttonsMouseEventsHandler(e) {
      var t = this,
          a = (t.shadowRoot || t).querySelectorAll(".smart-action-split-button");

      for (var _n193 = 0; _n193 < a.length; _n193++) {
        var _i395 = a[_n193],
            _o121 = _i395.getBoundingClientRect();

        "mouseleave" === e.type ? (a[_n193].removeAttribute("hover"), t.removeAttribute("hover", "")) : (t.setAttribute("hover", ""), a[_n193].removeAttribute("hover"), _o121.left <= e.pageX && e.pageX <= _o121.width + _o121.left && a[_n193].setAttribute("hover", ""));
      }
    }
  }, {
    key: "_applySelection",
    value: function _applySelection() {
      var e = this;

      if (0 === e.buttonsDataSource.length) {
        if ("placeholder" === e.selectionDisplayMode || 0 === e.selectedIndexes.length) return void ((e.shadowRoot || e).querySelector(".smart-template-container").innerHTML = e.placeholder);
        if (!e.$.listBox._items || 0 === e.$.listBox._items.length) return;
        (e.shadowRoot || e).querySelector(".smart-template-container").innerHTML = "<div class=\"smart-multi-split-button-buttons\"><span class=\"smart-action-split-button\"></span></div>", e.$.actionButton.querySelector(".smart-action-split-button").appendChild(e._createToken());
      }
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;
      "dataSource" === e || "displayMember" === e ? (a._setDropDownSize(), a._positionDetection.checkBrowserBounds("vertically"), a._positionDetection.positionDropDown(), a._positionDetection.checkBrowserBounds("horizontally")) : _get(_getPrototypeOf(_class41.prototype), "propertyChangedHandler", this).call(this, e, t, i);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        buttonsDataSource: {
          value: [],
          type: "array"
        },
        dropDownOpenMode: {
          allowedValues: ["none", "dropDownButton", "auto"],
          value: "dropDownButton",
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "actionButton.down": "_buttonsDownHandler",
        "actionButton.mouseenter": "_buttonsMouseEventsHandler",
        "actionButton.move": "_buttonsMouseEventsHandler",
        "actionButton.mouseleave": "_buttonsMouseEventsHandler",
        "dropDownButton.mouseenter": "_dropDownButtonMouseEventsHandler",
        "dropDownButton.mouseleave": "_dropDownButtonMouseEventsHandler",
        "actionButton.focus": "_focusEventHandler",
        "actionButton.blur": "_blurEventHandler",
        "dropDownButton.focus": "_focusEventHandler",
        "dropDownButton.blur": "_blurEventHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.dropdown.css", "smart.multisplitbutton.css"];
    }
  }]);

  return _class41;
}(Smart.DropDownList)), Smart("smart-text-box",
/*#__PURE__*/
function (_Smart$ComboBox) {
  "use strict";

  _inherits(_class42, _Smart$ComboBox);

  function _class42() {
    _classCallCheck(this, _class42);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class42).apply(this, arguments));
  }

  _createClass(_class42, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <span id=\"label\" inner-h-t-m-l=\"[[label]]\" class=\"smart-label\"></span>\n                    <div id=\"content\" class=\"smart-content\">\n                        <input class=\"smart-input\" type=\"text\" id=\"input\"\n                            disabled=\"[[disabled]]\"\n                            maxlength=\"[[maxLength]]\"\n                            name=\"[[name]]\"\n                            placeholder=\"[[placeholder]]\"\n                            readonly=\"[[readonly]]\">\n                        <div id=\"autoCompleteString\"></div>\n                        <div id=\"dropDownContainer\" class=\"smart-drop-down smart-drop-down-container smart-visibility-hidden\">\n                           <smart-list-box id=\"listBox\"\n                               data-source=\"[[dataSource]]\"\n                               unfocusable=\"true\"\n                               disabled=\"[[disabled]]\"\n                               display-loading-indicator=\"[[displayLoadingIndicator]]\"\n                               display-member=\"[[displayMember]]\"\n                               item-height=\"[[itemHeight]]\"\n                               item-template=\"[[itemTemplate]]\"\n                               filter-callback=\"[[filterCallback]]\"\n                               filter-mode=\"[[filterMode]]\"\n                               loading-indicator-placeholder=\"[[loadingIndicatorPlaceholder]]\"\n                               loading-indicator-position=\"[[loadingIndicatorPosition]]\"\n                               placeholder=\"[[dropDownPlaceholder]]\"\n                               readonly=\"[[readonly]]\"\n                               right-to-left=\"[[rightToLeft]]\"\n                               selection-mode=\"[[selectionMode]]\"\n                               value-member=\"[[valueMember]]\">\n                                <content></content>\n                            </smart-list-box>\n                         </div>\n                    </div>\n                    <span id=\"hint\" class =\"smart-hint\"></span>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "autoComplete":
          a.$.listBox._filteredItems && a.$.listBox._filteredItems.length !== a.$.listBox._items.length && _get(_getPrototypeOf(_class42.prototype), "_autoComplete", this).call(this, !0), a.$.input.autocomplete = "none" === i ? "on" : "off";
          break;

        case "dataSource":
        case "valueMember":
          a._clearSelection(), a._setDropDownSize(), a._positionDetection.checkBrowserBounds("vertically"), a._positionDetection.positionDropDown(), a._positionDetection.checkBrowserBounds("horizontally");
          break;

        case "displayMember":
        case "inputMember":
          {
            var _e471 = a.$.listBox;

            if (_e471.selectedIndexes.length) {
              var _t393 = _e471._items[_e471.selectedIndexes[0]][a.inputMember];
              a.$.listBox.$.filterInput.value = _t393, a.$.input.value = "escaped" === a.displayMode ? a._toEscapedDisplayMode(_t393) : a._toDefaultDisplayMode(_t393), a.set("value", a._toDefaultDisplayMode(a.$.input.value));
            }

            break;
          }

        case "displayMode":
          a.$.input.value = "escaped" === i ? a._toEscapedDisplayMode(a.value) : a.value = a._toDefaultDisplayMode(a.$.input.value);
          break;

        case "dropDownOpenMode":
          a._setFocusable(), a.$dropDownContainer.addClass("smart-visibility-hidden"), a.opened = !1;
          break;

        case "value":
          (a.$.input !== document.activeElement || a.$.input === document.activeElement && a.$.input.value === a._oldValue) && (a.$.input.value = "escaped" === a.displayMode ? a._toEscapedDisplayMode(a.value) : a.value, a._oldValue = t), a.value || a.clearSelection(), 0 < i.length ? a.$.addClass("has-value") : a.$.removeClass("has-value");
          break;

        case "hint":
          if (null === i) return a.$.hint.innerHTML = "", void a.$.removeClass("invalid");

          a._handleHintContainer();

          break;

        default:
          _get(_getPrototypeOf(_class42.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "open",
    value: function open() {
      var e = this;
      return 0 === e.$.listBox.items.length && "function" != typeof e.dataSource || "none" === e.autoComplete ? void 0 : 0 === e.$.input.value.length && e.$.listBox._filteredItems && e.$.listBox._filteredItems.length !== e.$.listBox._items.length ? void _get(_getPrototypeOf(_class42.prototype), "_autoComplete", this).call(this, !0) : void _get(_getPrototypeOf(_class42.prototype), "open", this).call(this);
    }
  }, {
    key: "close",
    value: function close() {
      var e = this;
      _get(_getPrototypeOf(_class42.prototype), "close", this).call(this), e.$.autoCompleteString.textContent = "", e.$.listBox._focusedItem && (e.$.listBox._focusedItem._focused = !1);
      "none" === e.autoComplete || e.$.input._filteredItems && e.$.input._filteredItems[0] && e.$.input._filteredItems[0] !== e.$.input.value && _get(_getPrototypeOf(_class42.prototype), "_autoComplete", this).call(this, !0);
    }
  }, {
    key: "cloneNode",
    value: function cloneNode() {
      var e = this;
      var t = HTMLElement.prototype.cloneNode.apply(e, Array.prototype.slice.call(arguments, 0, 1));
      return e.$.listBox && (t.dataSource = e.dataSource), t;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.$.input.focus();
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void (e.$.input.tabIndex = -1) : void e.$.input.removeAttribute("tabindex");
    }
  }, {
    key: "reset",
    value: function reset() {
      var e = this;
      "escaped" === e.displayMode ? (e.value = e._initializationValue, e.$.input.value = e._toEscapedDisplayMode(e._initializationValue)) : e.$.input.value = e.value = e._initializationValue, !e.value && e.$.listBox && e.clearSelection();
    }
  }, {
    key: "_bindingCompleteHandler",
    value: function _bindingCompleteHandler() {
      var e = this;
      !e.$.listBox || e.isRendered && (e._setDropDownSize(), e._positionDetection.checkBrowserBounds());
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e._browserIsIEorEdge = Smart.Utilities.Core.Browser.IE || Smart.Utilities.Core.Browser.Edge, e.autoFocus && e.$.input.focus(), e.value && (e.$.input.value = "escaped" === e.displayMode ? e._toEscapedDisplayMode(e.value) : e.value), "none" !== e.autoComplete && (e.$.input.autocomplete = "off"), e._setDropDownSize(), e._handleSelectedText(), e._setFocusable(), e._initializationValue = e._oldValue = e.value, 0 < e.value.length ? e.$.addClass("has-value") : e.$.removeClass("has-value"), e._handleHintContainer();
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler(e) {
      var t = this;
      return "blur" === e.type ? t._isDropDownClicked ? void 0 : (t.removeAttribute("focus"), t.$.autoCompleteString.textContent = "", 0 < t.value.length ? t.$.addClass("has-value") : t.$.removeClass("has-value"), ("auto" === t.autoComplete || "inline" === t.autoComplete) && 0 < t.$.input.value.length && t.$.listBox._focusedItem && t.$.listBox._focusedItem._focused && (t.$.input.value = t.$.listBox._focusedItem[t.inputMember]), t._preventDropDownClose || t.close(), void (t._oldValue !== t.value && t.$.fireEvent("change", {
        oldValue: t._oldValue,
        value: t.value
      }))) : void (t.disabled || (t.setAttribute("focus", ""), t._oldValue = t.value, t.selectAllOnFocus && t.$.input.select()));
    }
  }, {
    key: "_handlePointerInEscapedSymbol",
    value: function _handlePointerInEscapedSymbol(e) {
      var t = this;

      if ("escaped" === t.displayMode) {
        var _i396 = t.$.input.selectionStart,
            _a245 = t.$.input.selectionEnd,
            _n194 = t.$.input.value;

        if ("\\" === _n194[_i396 - 1] && _n194[_i396].match(/n|r|s|t|f/g)) {
          if (_i396 === _a245) {
            var _a246 = "next" === e ? 1 : -1;

            return t.$.input.selectionStart = _i396 + _a246, void (t.$.input.selectionEnd = _i396 + _a246);
          }

          t.$.input.selectionStart = _i396 - 1, "\\" === _n194[_a245 - 1] && _n194[_a245].match(/n|r|s|t|f/g) && (t.$.input.selectionEnd = _a245 + 1);
        }
      }
    }
  }, {
    key: "_handleSelectedText",
    value: function _handleSelectedText() {
      var e = this;
      null === e.selectionStart || null === e.selectionEnd || e.selectionStart === e.selectionEnd || e.selectAllOnFocus || (e.selectionStart = 0 > e.selectionStart ? 0 : e.selectionStart, e.selectionEnd = e.selectionEnd > e.value.length ? e.value.length : e.selectionEnd, e.$.input.setSelectionRange(e.selectionStart, e.selectionEnd));
    }
  }, {
    key: "_handleHintContainer",
    value: function _handleHintContainer() {
      var e = this;

      if (e.hint) {
        var _t394 = e.$.hint;

        if ("function" == typeof e.hint) {
          var _i397 = e.value,
              _a247 = e.hint(_i397, _t394);

          _a247 ? e.$.addClass("invalid") : e.$.removeClass("invalid");
        } else "string" == typeof e.hint && (_t394.innerHTML = e.hint, e.$.removeClass("invalid"));
      }
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      function t(t) {
        var a = i.$.input.selectionStart,
            n = i.$.input.selectionEnd,
            o = i.$.input.value;
        e.preventDefault(), o = o.substring(0, a) + t + o.substring(n, o.length), i.value = i._toDefaultDisplayMode(o), i.$.input.value = o, i.$.input.selectionStart = i.$.input.selectionEnd = a + 2;
      }

      var i = this;

      switch (i._showAutoCompleteHighlighter = !1, e.key) {
        case "ArrowUp":
        case "ArrowDown":
          if (e.altKey) return e.preventDefault(), void ("ArrowDown" === e.key ? i.open() : i.close());

          if (i.opened) {
            if (e.preventDefault(), i.$.listBox._handleKeyStrokes(e.key), "inline" !== i.autoComplete) break;
            i._showAutoCompleteHighlighter = !0, _get(_getPrototypeOf(_class42.prototype), "_updateAutoCompleteHelper", this).call(this);
          }

          break;

        case "PageUp":
        case "PageDown":
          e.preventDefault(), i.$.input.selectionStart = i.$.input.selectionEnd = "PageUp" === e.key ? 0 : i.$.input.value.length;
          break;

        case "Enter":
          if (i.opened && i.$.listBox._focusedItem && i.$.listBox._focusedItem._focused && (i.$.listBox.$.filterInput.value = i.$.listBox._focusedItem[i.inputMember], i.$.input.value = "escaped" === i.displayMode ? i._toEscapedDisplayMode(i.$.listBox._focusedItem[i.inputMember]) : i._toDefaultDisplayMode(i.$.listBox._focusedItem[i.inputMember]), i.select(i.$.listBox._focusedItem), i.close()), "default" !== i.enterKeyBehavior) {
            var _t395 = i.$.input.value;
            i._oldValue !== _t395 && (e.preventDefault(), i.$.fireEvent("change", {
              oldValue: i._oldValue,
              value: _t395,
              type: "submit"
            }), "clearOnSubmit" === i.enterKeyBehavior && (Smart.MaskedTextBox && i instanceof Smart.MaskedTextBox ? (i._cleanMask(), i._setMaskToInput(), i.$.input.selectionStart = i.$.input.selectionEnd = 0) : i.$.input.value = ""), i._oldValue = i.value = i._toDefaultDisplayMode(i.$.input.value)), i._submitted = !0;
          }

          break;

        case "Escape":
          if (i.$.dropDownContainer && i.close(), i._closedFromKeyCombination = !0, "none" === i.escKeyMode) return;

          switch (i.escKeyMode) {
            case "none":
              break;

            case "clearValue":
              i.value = i.$.input.value = "";
              break;

            case "previousValue":
              i.$.input.value = "escaped" === i.displayMode ? i._toEscapedDisplayMode(i._oldValue) : i._oldValue;
          }

          break;

        case " ":
          "escaped" === i.displayMode && t("\\s");
          break;

        case "Backspace":
          if ("escaped" === i.displayMode && i.$.input.selectionStart === i.$.input.selectionEnd) {
            var _e472 = i.$.input.selectionStart;
            "\\" === i.$.input.value[_e472 - 2] && ("s" === i.$.input.value[_e472 - 1] || "n" === i.$.input.value[_e472 - 1]) && (i.$.input.value = i.$.input.value.substring(0, _e472 - 2) + i.$.input.value.substring(_e472 - 2, i.$.input.value.length), i.$.input.selectionStart = _e472 - 2);
          }

      }
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this;
      t.disabled || "Escape" === e.key || e.target === t.$.listBox.$.filterInput || e.target === t.$.input && "oneOrManyExtended" === t.selectionMode && (t.$.listBox._keysPressed[e.key] = !1);
    }
  }, {
    key: "_listBoxItemClickHandler",
    value: function _listBoxItemClickHandler(e) {
      var t = this,
          i = e.detail;

      if (_get(_getPrototypeOf(_class42.prototype), "_listBoxItemClickHandler", this).call(this, e), i.selected) {
        if ("escaped" === t.displayMode) {
          var _e473 = t.$.input.value;
          t.value = t._toDefaultDisplayMode(_e473), t.$.input.value = _e473;
        } else t.value = t.$.input.value;

        t._oldValue !== t.value && (t.$.fireEvent("change", {
          oldValue: t._oldValue,
          value: t.value
        }), t.$.input.focus());
      }
    }
  }, {
    key: "_submitKeyUpHandler",
    value: function _submitKeyUpHandler() {
      var e = this;
      e._submitted && ("clearOnSubmit" === e.enterKeyBehavior && (e.$.input.selectionStart = e.$.input.selectionEnd = 0), e._submitted = !1);
    }
  }, {
    key: "_textBoxKeyUpHandler",
    value: function _textBoxKeyUpHandler(e) {
      var t = this;
      if (t.disabled || e.altKey || e.ctrlKey) return;

      if ("escaped" === t.displayMode) {
        var _e474 = t.$.input.value;
        t.value = t._toDefaultDisplayMode(t.$.input.value), t.$.input.value = _e474;
      } else t.value = t.$.input.value;

      var i;
      if (1 === t.$.listBox.selectedIndexes.length && (i = t.$.listBox.getItem(t.$.listBox.selectedValues[0]), t.value !== i[t.inputMember] && t.unselect(i)), t._showAutoCompleteHighlighter || (t.$.autoCompleteString.textContent = ""), "Alt" === e.key || "Control" === e.key || !t.opened && "Escape" === e.key || "Enter" === e.key) return void (t._closedFromKeyCombination = !1);
      if (e.key && -1 < e.key.indexOf("Arrow")) return void t._handlePointerInEscapedSymbol("ArrowRight" === e.key ? "next" : void 0);

      if ("none" !== t.autoComplete && (0 < t.$.input.value.length || "auto" === t.dropDownOpenMode)) {
        var _e475 = _get(_getPrototypeOf(_class42.prototype), "_autoComplete", this).bind(t);

        if (t._autoCompleteTimer && clearTimeout(t._autoCompleteTimer), 0 === t.$.listBox._items.length && "function" != typeof t.dataSource) return void t.close();
        t._autoCompleteTimer = setTimeout(function () {
          _e475(!0);
        }, t.autoCompleteDelay);
      } else t.close();

      "Enter" === e.key && t.value !== t.value && t._browserIsIEorEdge && (t.value = t.$.input.value, t.$.fireEvent("change", {
        oldValue: t._oldValue,
        value: t.value
      }));
    }
  }, {
    key: "_listBoxChangeHandler",
    value: function _listBoxChangeHandler(e) {
      var t = this;

      if (e.stopPropagation(), e.detail.selected) {
        var _i398 = t.$.listBox._items[e.detail.index][t.inputMember];
        t.$.listBox.$.filterInput.value = _i398, t.$.input.value = "escaped" === t.displayMode ? t._toEscapedDisplayMode(_i398) : t._toDefaultDisplayMode(_i398), t.set("value", t._toDefaultDisplayMode(t.$.input.value));
      }

      "none" !== t.autoComplete && "function" != typeof t.dataSource && t._autoComplete(!0);
    }
  }, {
    key: "_mouseEventsHandler",
    value: function _mouseEventsHandler(e) {
      var t = this;
      "mouseenter" === e.type ? t.setAttribute("hover", "") : t.removeAttribute("hover");
    }
  }, {
    key: "_textBoxChangeHandler",
    value: function _textBoxChangeHandler(e) {
      var t = this;

      if (e.stopPropagation(), "escaped" === t.displayMode) {
        var _i399 = t.$.input.value,
            _a248 = t.$.input.selectionStart,
            _n195 = t.$.input.selectionEnd,
            _o122 = e.clipboardData || e.originalEvent && e.originalEvent.clipboardData || window.clipboardData;

        if (_o122) {
          var _i400 = _o122.getData("text"),
              _r79 = t.$.input.value;

          e.preventDefault(), _i400 = t._toEscapedDisplayMode(_i400), t.$.input.value = _r79.substring(0, _a248) + _i400 + _r79.substring(_n195, _r79.length);
        }

        t.value = t._toDefaultDisplayMode(t.$.input.value), t.$.input.value = _i399;
      } else t.value = t.$.input.value;

      t._handleHintContainer();
    }
  }, {
    key: "_textBoxSelectHandler",
    value: function _textBoxSelectHandler() {
      var e = this;
      e.disabled || (e.selectionStart = e.$.input.selectionStart, e.selectionEnd = e.$.input.selectionEnd);
    }
  }, {
    key: "_toEscapedDisplayMode",
    value: function _toEscapedDisplayMode(e) {
      var t = [{
        key: /\r\n|\n\r|\n|\r/g,
        value: "\\n"
      }, {
        key: /\s/g,
        value: "\\s"
      }, {
        key: /\n/g,
        value: "\\n"
      }, {
        key: /\t/g,
        value: "\\t"
      }, {
        key: /\f/g,
        value: "\\f"
      }, {
        key: /\r/g,
        value: "\\r"
      }];

      for (var _a249 = 0; _a249 < t.length; _a249++) {
        e = e.replace(t[_a249].key, t[_a249].value);
      }

      return e;
    }
  }, {
    key: "_toDefaultDisplayMode",
    value: function _toDefaultDisplayMode(e) {
      e || (e = "");
      var t = [{
        key: /\\s/g,
        value: " "
      }, {
        key: /\\n/g,
        value: "\n"
      }, {
        key: /\\t/g,
        value: "\t"
      }, {
        key: /\\f/g,
        value: "\f"
      }, {
        key: /\\r/g,
        value: "\r"
      }];

      for (var _a250 = 0; _a250 < t.length; _a250++) {
        e = e.replace(t[_a250].key, t[_a250].value);
      }

      return e;
    }
  }, {
    key: "_documentDownHandler",
    value: function _documentDownHandler(e) {
      var t = this;
      if (t.disabled || t.readonly) return;
      var i = e.originalEvent.target;
      if (!t.enableShadowDOM) t._isDropDownClicked = i.closest(".smart-drop-down-container") === t.$.dropDownContainer;else if (i = e.originalEvent.composedPath()[0], null === t._dropDownParent) t._isDropDownClicked = i.closest(".smart-drop-down-container") === t.$.dropDownContainer;else {
        var _e476 = i.getRootNode().host;
        _e476 && _e476.closest(".smart-drop-down-container") === t.$.dropDownContainer && (t._isDropDownClicked = !0);
      }
      var a = e.originalEvent.target.closest("smart-list-item");
      (a || t._isDropDownClicked) && (t._preventDropDownClose = !0);
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler() {}
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;
      if (t.disabled) return;
      var i = t.enableShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;

      if (i) {
        if ("escaped" === t.displayMode && i === t.$.input && t._handlePointerInEscapedSymbol(), t._isDropDownClicked || t.readonly) return void delete t._isDropDownClicked;
        if (i === t.$.input && "auto" === t.dropDownOpenMode) return void _get(_getPrototypeOf(_class42.prototype), "_autoComplete", this).call(this, !0);

        for (; i;) {
          if (i instanceof Smart.ListItem && i.ownerListBox === t.$.listBox) return i.unselectable || i.disabled ? void 0 : ("escaped" === t.displayMode ? (t.value = i[t.inputMember], t.$.input.value = t._toEscapedDisplayMode(i[t.inputMember])) : t.$.input.value = t.value = i[t.inputMember], t.$.fireEvent("change", {
            oldValue: t._oldValue,
            value: t.value,
            type: "submit"
          }), t._oldValue = t.value, "clearOnSubmit" === t.enterKeyBehavior && (t.$.input.value = t.value = ""), _get(_getPrototypeOf(_class42.prototype), "_autoComplete", this).call(this, !0), t.close(), i = "item", void t.$.input.focus());
          if (i === t.$.listBox) return void (i = "listBox");
          i = i.parentElement;
        }

        if ("listBox" !== i && "item" !== i) return void t.close();
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoFocus: {
          value: !1,
          type: "boolean"
        },
        autoComplete: {
          allowedValues: ["none", "manual", "auto", "inline"],
          type: "string",
          value: "manual"
        },
        displayMode: {
          value: "default",
          allowedValues: ["default", "escaped"],
          type: "string"
        },
        dropDownOpenMode: {
          allowedValues: ["none", "default", "auto"],
          value: "default",
          type: "string"
        },
        enterKeyBehavior: {
          value: "submit",
          allowedValues: ["submit", "clearOnSubmit"],
          type: "string"
        },
        form: {
          value: "",
          type: "string"
        },
        hint: {
          value: null,
          reflectToAttribute: !1,
          type: "any"
        },
        maxLength: {
          value: null,
          type: "number?"
        },
        minLength: {
          value: 2,
          type: "number"
        },
        messages: {
          extend: !0,
          value: {
            en: {
              missingReference: "{{elementType}}: Missing reference to {{files}}."
            }
          },
          type: "object"
        },
        required: {
          value: !1,
          type: "boolean"
        },
        requiredMessage: {
          value: "",
          type: "string"
        },
        selectAllOnFocus: {
          value: !1,
          type: "boolean"
        },
        selectionMode: {
          value: "zeroOrOne",
          allowedValues: ["none", "oneOrManyExtended", "zeroOrMany", "oneOrMany", "zeroOrOne", "one", "checkBox", "radioButton"],
          type: "string"
        },
        type: {
          value: "input",
          type: "string",
          defaultReflectToAttribute: !0,
          readonly: !0
        },
        value: {
          value: "",
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "document.up": "_documentUpHandler",
        focus: "_focusHandler",
        keydown: "_keyDownHandler",
        mouseenter: "_mouseEventsHandler",
        mouseleave: "_mouseEventsHandler",
        "input.blur": "_focusHandler",
        "input.change": "_textBoxChangeHandler",
        "input.focus": "_focusHandler",
        "input.keyup": "_textBoxKeyUpHandler",
        "input.paste": "_textBoxChangeHandler",
        "input.select": "_textBoxSelectHandler",
        "listBox.bindingComplete": "_bindingCompleteHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.ComboBox": "smart.combobox.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.textbox.css"];
    }
  }]);

  return _class42;
}(Smart.ComboBox)), Smart("smart-masked-text-box",
/*#__PURE__*/
function (_Smart$BaseElement4) {
  "use strict";

  _inherits(_class43, _Smart$BaseElement4);

  function _class43() {
    _classCallCheck(this, _class43);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class43).apply(this, arguments));
  }

  _createClass(_class43, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <span id=\"label\" inner-h-t-m-l=\"[[label]]\" class =\"smart-label\"></span>\n                    <input class=\"smart-input\" type=\"text\" id=\"input\"\n                        autocomplete=\"off\"\n                        autocorrect=\"off\"\n                        autocapitalize=\"off\"\n                        disabled=\"[[disabled]]\"\n                        maxlength=\"[[maxLength]]\"\n                        minlength=\"[[minLength]]\"\n                        name=\"[[name]]\"\n                        placeholder=\"[[placeholder]]\"\n                        readonly=\"[[readonly]]\">\n                    <span id=\"hint\" inner-h-t-m-l=\"[[hint]]\" class =\"smart-hint\"></span>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;
      var n;

      switch (e) {
        case "hidePromptOnLeave":
          i && !a._focused ? a._hidePrompt() : a._promptHidden && a._showPrompt();
          break;

        case "maxLength":
          0 < a.mask.length && (a.maxLength = t);
          break;

        case "maskCompleted":
        case "maskFull":
          a[e] = t;
          break;

        case "promptChar":
          a._updatePromptChar();

          break;

        case "placeholder":
          a._isPlaceholderRequired() ? (a.$.input.value = "", a.$.removeClass("has-value")) : a._updatePromptChar(), a._updatePromptChar();
          break;

        case "mask":
          n = a._getValueWithTextMaskFormat({
            start: 0,
            end: a._mask.length
          }, "excludePromptAndLiterals"), a._isPlaceholderRequired() ? (a.$.input.value = "", a.$.removeClass("has-value")) : (a._initializeMask(), a._setValueToMask(n), a._setMaskToInput(), a.maxLength = a._mask.length, a._promptHidden && a._hidePrompt());
          break;

        case "value":
          a._overwrite = !0, a._setValueToMask(i), a._overwrite = !1, a._setMaskToInput(), a._promptHidden && a._hidePrompt();
          break;

        case "disabled":
          a._setFocusable();

          break;

        case "readonly":
          break;

        default:
          _get(_getPrototypeOf(_class43.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }

      a.value = a._getValueWithTextMaskFormat({
        start: 0,
        end: a._mask.length
      }, a.textMaskFormat);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e._createElement(), _get(_getPrototypeOf(_class43.prototype), "render", this).call(this);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.$.input.focus();
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void (e.$.input.tabIndex = -1) : void e.$.input.removeAttribute("tabindex");
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.autoFocus && e.$.input.focus(), e._setFocusable(), e._initializeMask(), e._updateMaxLength(), e._isPlaceholderRequired() ? (e.$.input.value = "", e.$.removeClass("has-value")) : (e._setValueToMask(e.value), e._setMaskToInput(), e._updateMaskFullAndCompleted(), e.$.addClass("has-value")), e.$.input.selectionStart = e.$.input.selectionEnd = 0, e._initializationValue = e._value = e.value, e._rejectInput = !1;
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      var e = this,
          t = e._isPlaceholderRequired();

      e.disabled || (e._valueBeforeChange !== e.value && (e.$.fireEvent("change", {
        newValue: e.value,
        oldValue: e._valueBeforeChange
      }), e._valueBeforeChange = ""), e._hidePrompt(), e._focused = !1, e._validateMaskValue(), e.removeAttribute("focus"), 0 < e.$.input.value.length ? e.$.addClass("has-value") : e.$.removeClass("has-value"), t && (e.$.input.value = "", e.$.removeClass("has-value")));
    }
  }, {
    key: "_updateMaskFullAndCompleted",
    value: function _updateMaskFullAndCompleted() {
      var e = this;
      var t = !0,
          a = !0,
          n = !1;

      for (var _o123 = 0; _o123 < e._mask.length; _o123++) {
        var _i401 = e._mask[_o123];
        "mask" === _i401.type && (_i401.required && (n = !0), "" === _i401.character && (_i401.required && (a = !1), t = !1));
      }

      t || !a || n || (a = !1), e.maskFull = t, e.maskCompleted = a;
    }
  }, {
    key: "_isPlaceholderRequired",
    value: function _isPlaceholderRequired() {
      var e = this,
          t = e.value && 0 < e.value.length,
          i = 0 < e.placeholder.length,
          a = !t && (i || e.autoShowMask);
      return a;
    }
  }, {
    key: "_cleanMask",
    value: function _cleanMask(e, t) {
      var a = this;
      e = e ? e : 0, t = t ? t : a._mask.length;

      for (var _n196 = e, _i402; _n196 < t; _n196++) {
        _i402 = a._mask[_n196], "mask" === _i402.type && (a._mask[_n196].character = "");
      }
    }
  }, {
    key: "_cutCopyHandler",
    value: function _cutCopyHandler(e, t) {
      var i = this,
          a = parseInt(i.$.input.selectionStart, 10),
          n = parseInt(i.$.input.selectionEnd, 10),
          o = i._getValueWithTextMaskFormat({
        start: a,
        end: n
      });

      return (window.clipboardData && (window.clipboardData.setData("text/plain", o), window.clipboardData.setData("text/html", o)), e && i._preventDefault(e), "Copy" === t) ? o : (i._cleanMask(a, n), i.value = i._getValueWithTextMaskFormat({
        start: 0,
        end: i._mask.length
      }, i.textMaskFormat), i._setMaskToInput(), i.$.input.selectionStart = i.$.input.selectionEnd = a, i.maskFull = i.maskCompleted = !1, o);
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler() {}
  }, {
    key: "_deleteHandler",
    value: function _deleteHandler(e) {
      var t = this,
          a = t.$.input.selectionStart,
          i = t.$.input.selectionEnd,
          n = e.key;
      var o = a;
      if (t._preventDefault(e), a !== i) t._cleanMask(a, i), "Delete" === n && (o = i);else if ("Backspace" === n) for (var _e477 = a; 0 < _e477; _e477--) {
        var _i403 = t._mask[_e477 - 1];

        if ("mask" === _i403.type) {
          o = _e477 - 1, _i403.character = "";
          break;
        } else {
          o = a - 1;
          break;
        }
      } else for (var _e478 = a; _e478 < t._mask.length; _e478++) {
        var _i404 = t._mask[_e478];

        if ("mask" === _i404.type) {
          o = _e478 + 1, _i404.character = "";
          break;
        } else {
          o = a + 1;
          break;
        }
      }
      t._setMaskToInput(), t._updateMaskFullAndCompleted(), t.value = t._getValueWithTextMaskFormat({
        start: 0,
        end: t._mask.length
      }, t.textMaskFormat), t.$.input.selectionStart = t.$.input.selectionEnd = o;
    }
  }, {
    key: "_findNextOccupiedPosition",
    value: function _findNextOccupiedPosition(e) {
      var t = this,
          a = t._mask.length;
      var n = e;

      for (var _o124 = e, _i405; _o124 < a && (_i405 = t._mask[_o124], "mask" === _i405.type && "" === _i405.character); _o124++) {
        n++;
      }

      return n;
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler(e) {
      var t = this;
      if ("INPUT" !== e.context.nodeName.toUpperCase()) return void t.$.input.focus();

      if (!t.disabled && (t.setAttribute("focus", ""), t.selectAllOnFocus && t.$.input.select(), t._showPrompt(), t._focused = !0, t._isPlaceholderRequired())) {
        t._initializeMask(), t._setValueToMask(t.value), t._setMaskToInput();

        var _e479 = t._getEditableSelectionStart(0);

        t.$.input.selectionStart = t.$.input.selectionEnd = _e479;
      }
    }
  }, {
    key: "_setMaskToInput",
    value: function _setMaskToInput() {
      var e = this;
      var t = "";

      for (var _a251 = 0; _a251 < e._mask.length; _a251++) {
        var _i406 = e._mask[_a251];

        var _n197 = void 0;

        if ("literal" === _i406.type || "separator" === _i406.type || "placeholder" === _i406.type || "currency" === _i406.type) _n197 = _i406.character;else if ("mask" === _i406.type && "" !== _i406.character) switch (_i406.escapeSymbol) {
          case ">":
            _n197 = _i406.character.toUpperCase();
            break;

          case "<":
            _n197 = _i406.character.toLowerCase();
            break;

          case "|":
            _n197 = _i406.character;
            break;

          case "\\":
            _n197 = _i406.character;
            break;

          default:
            _n197 = _i406.character;
        } else _n197 = _i406.defaultCharacter;
        t += _n197;
      }

      e.$.input.value = t;
    }
  }, {
    key: "_getEditableSelectionStart",
    value: function _getEditableSelectionStart(e, t) {
      var a = this;

      for (var _n198 = e; _n198 < a._mask.length; _n198++) {
        var _e480 = a._mask[_n198];
        if ("mask" === _e480.type && ("" === _e480.character || a.isOverwriteMode || " " === t && a.resetOnSpace || t === a.promptChar && a.resetOnPrompt)) return _n198;
      }

      return -1;
    }
  }, {
    key: "_getNonEditableSelectionStart",
    value: function _getNonEditableSelectionStart(e, t) {
      var a = this;

      for (var _n199 = e; _n199 < a._mask.length; _n199++) {
        var _e481 = a._mask[_n199];
        if ("mask" !== _e481.type && _e481.character === t) return _n199;
      }

      return -1;
    }
  }, {
    key: "_getValueWithTextMaskFormat",
    value: function _getValueWithTextMaskFormat(e, t) {
      var a = this,
          n = e ? e.start : 0,
          o = e ? e.end : a._mask.length || a.$.input.value.length;
      var i = "";
      if (t = t ? t : a.cutCopyMaskFormat, "includePromptAndLiterals" === t) return a.$.input.value.substring(n, o);

      for (var _r80 = n; _r80 < o; _r80++) {
        var _e482 = a._mask[_r80];

        switch (t) {
          case "excludePromptAndLiterals":
            if ("mask" !== _e482.type) continue;
            i = "" === _e482.character ? i + " " : i + _e482.character;
            break;

          case "includePrompt":
            if ("mask" !== _e482.type) continue;
            i = "" === _e482.character ? i + _e482.defaultCharacter : i + _e482.character;
            break;

          case "includeLiterals":
            if ("mask" === _e482.type && "" === _e482.character) continue;
            i += _e482.character;
        }
      }

      return i.trim();
    }
  }, {
    key: "_hidePrompt",
    value: function _hidePrompt() {
      var e = this,
          t = new RegExp(e.promptChar, "g");
      e.disabled || !e.hidePromptOnLeave || 0 === e.mask.length || (e.$.input.value = e.$.input.value.replace(t, " "), e._promptHidden = !0);
    }
  }, {
    key: "_initializeMask",
    value: function _initializeMask() {
      var e = this;
      var t = e.mask.length,
          a;
      if (e._mask = [], void 0 !== e.mask && null !== e.mask && 0 !== e.mask.length) for (var _n200 = 0; _n200 < t; _n200++) {
        var _t396 = e.mask.charAt(_n200);

        var _i407 = {
          defaultCharacter: e.promptChar
        };
        "0" === _t396 ? (_i407.editable = !0, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "0", _i407.regex = "\\d", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "9" === _t396 ? (_i407.editable = !0, _i407.required = !1, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "9", _i407.regex = "(\\d|\\s)", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "#" === _t396 ? (_i407.editable = !0, _i407.required = !1, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "#", _i407.regex = "(\\d|\\s|[+]|[-])", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "L" === _t396 ? (_i407.editable = !0, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "L", _i407.regex = "([a-zA-Z\u0430-\u044F\u0410-\u042F])", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "?" === _t396 ? (_i407.editable = !0, _i407.required = !1, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "?", _i407.regex = "[a-zA-Z\u0430-\u044F\u0410-\u042F]?", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "&" === _t396 ? (_i407.editable = !0, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "&", _i407.regex = "[^\\s]", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "C" === _t396 ? (_i407.editable = !0, _i407.required = !1, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "C", _i407.regex = ".", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "A" === _t396 ? (_i407.editable = !0, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "A", _i407.regex = "[a-zA-Z\u0430-\u044F\u0410-\u042F0-9]", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "a" === _t396 ? (_i407.editable = !0, _i407.required = !1, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "a", _i407.regex = "[a-zA-Z\u0430-\u044F\u0410-\u042F0-9]?", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "Z" === _t396 ? (_i407.editable = !0, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "Z", _i407.regex = "[a-zA-Z0-9]", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "z" === _t396 ? (_i407.editable = !0, _i407.required = !1, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "z", _i407.regex = "[a-zA-Z0-9]?", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "Y" === _t396 ? (_i407.editable = !0, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "Y", _i407.regex = "[a-zA-Z]", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "y" === _t396 ? (_i407.editable = !0, _i407.required = !1, _i407.escapeSymbol = a, _i407.type = "\\" === _i407.escapeSymbol ? "literal" : "mask", _i407.maskCharacter = "y", _i407.regex = "[a-zA-Z]?", _i407.character = "\\" === _i407.escapeSymbol ? _i407.maskCharacter : "", _i407.defaultCharacter = e.promptChar, a = null) : "." === _t396 ? (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "placeholder", _i407.maskCharacter = ".", _i407.regex = null, _i407.character = ".", _i407.defaultCharacter = e.promptChar, a = null) : "," === _t396 ? (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "placeholder", _i407.maskCharacter = ",", _i407.regex = null, _i407.character = ",", _i407.defaultCharacter = e.promptChar, a = null) : ":" === _t396 ? (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "separator", _i407.maskCharacter = ":", _i407.regex = null, _i407.character = ":", _i407.defaultCharacter = e.promptChar, a = null) : "/" === _t396 ? (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "separator", _i407.maskCharacter = "/", _i407.regex = null, _i407.character = "/", _i407.defaultCharacter = e.promptChar, a = null) : "$" === _t396 ? (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "currency", _i407.maskCharacter = "$", _i407.regex = null, _i407.character = "$", _i407.defaultCharacter = e.promptChar, a = null) : "<" === _t396 ? a ? "|" === a ? a = null : "\\" === a ? (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "literal", _i407.maskCharacter = "<", _i407.regex = "<", _i407.character = "<", _i407.defaultCharacter = e.promptChar, a = null) : a = "<" : a = "<" : ">" === _t396 ? a ? "|" === a ? a = null : "\\" === a ? (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "literal", _i407.maskCharacter = ">", _i407.regex = ">", _i407.character = ">", _i407.defaultCharacter = e.promptChar, a = null) : a = ">" : a = ">" : "|" === _t396 ? a ? "\\" === a ? (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "literal", _i407.maskCharacter = "|", _i407.regex = "|", _i407.character = "|", _i407.defaultCharacter = e.promptChar, a = null) : a = "|" : a = "|" : "\\" === _t396 ? a ? "\\" === a ? (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "literal", _i407.maskCharacter = "\\", _i407.regex = "\\", _i407.character = "\\", _i407.defaultCharacter = e.promptChar, a = null) : a = "\\" : a = "\\" : (_i407.editable = !1, _i407.required = !0, _i407.escapeSymbol = a, _i407.type = "literal", _i407.maskCharacter = _t396, _i407.regex = null, _i407.character = _t396, _i407.defaultCharacter = _t396, a = null), a || _i407.type && e._mask.push(_i407);
      }
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler() {}
  }, {
    key: "_validateInput",
    value: function _validateInput(e, t) {
      var i = this,
          a = i._mask[t],
          n = new RegExp(a.regex);
      return n.test(e);
    }
  }, {
    key: "_setValueToMask",
    value: function _setValueToMask(e, t) {
      var a = this,
          i = e || "",
          n = i.length,
          o = t && t.start ? t.start : 0,
          r = t && t.end ? t.end : a._mask.length;
      var l = o,
          s = 0;

      for (; l < r && s < n;) {
        "mask" === a._mask[l].type && s++, (a._setCharAtPosition(i.charAt(s - 1), l) || "mask" !== a._mask[l].type) && l++;
      }

      if (l < r) for (var _e483 = l; _e483 < r; _e483++) {
        "mask" === a._mask[_e483].type && (a._mask[_e483].character = "");
      }
      t && (t.start = l);
    }
  }, {
    key: "_preventDefault",
    value: function _preventDefault(e) {
      e.preventDefault && e.preventDefault(), e.stopPropagation && e.stopPropagation();
    }
  }, {
    key: "_showPrompt",
    value: function _showPrompt() {
      var e = this;
      e.disabled || !e._promptHidden || e._setMaskToInput();
    }
  }, {
    key: "_textBoxChangeHandler",
    value: function _textBoxChangeHandler() {
      var e = this;
      e.disabled || e.readonly || (e.value = e._getValueWithTextMaskFormat({
        start: 0,
        end: e._mask.length
      }, e.textMaskFormat), e._valueBeforeChange !== e.value && (e.$.fireEvent("change", {
        newValue: e.value,
        oldValue: e._valueBeforeChange
      }), e._valueBeforeChange = "", e._validateMaskValue()));
    }
  }, {
    key: "_textBoxKeyDownHandler",
    value: function _textBoxKeyDownHandler(e) {
      var t = this,
          i = e.key,
          a = e.ctrlKey,
          n = t.$.input.selectionEnd,
          o = /xxx[\0-]+xxx/,
          r = /^[a-zA-ZÀ-ÿа-яА-Я0-9.!@?#"$%&:';()*\+,\/;\-=[\\\]\^_{|}<>~` ]+$/;
      var l = t.$.input.selectionStart;

      if (a && -1 < ["KeyA", "KeyC", "KeyV", "KeyX"].indexOf(e.code)) {
        var _i408 = function _i408(e, i) {
          var a = document.createElement("textarea");
          a.style.position = "absolute", a.style.left = "-1000px", a.style.top = "-1000px", document.body.appendChild(a), a.focus(), "Paste" === e ? setTimeout(function () {
            var e = a.value;
            0 === e.length && window.clipboardData && (a.value = window.clipboardData.getData("Text"), e = a.value), a.parentNode.removeChild(a), t.$.input.focus(), i(e);
          }, 25) : (a.value = t._cutCopyHandler(null, e), a.focus(), a.setSelectionRange(0, a.value.length), setTimeout(function () {
            document.designMode = "off", a.focus(), a.parentNode.removeChild(a), t.$.input.focus();
          }, 25), window.clipboardData && window.clipboardData.setData("Text", a.value));
        };

        switch (e.code) {
          case "KeyA":
            t.$.input.setSelectionRange(0, t.$.input.value.length);
            break;

          case "KeyC":
            _i408("Copy");

            break;

          case "KeyV":
            _i408("Paste", function (e) {
              var i = t.context;
              t.context = t, t._textBoxPasteHandler(null, e), t.context = i;
            });

            break;

          case "KeyX":
            _i408("Cut");

        }

        return;
      }

      if ("Backspace" === i) return t._deleteHandler(e), void t._updateMaskFullAndCompleted();
      if ("Delete" === i) return t._deleteHandler(e), void t._updateMaskFullAndCompleted();
      if (!t.allowPromptAsInput && i === t.promptChar) return void t._preventDefault(e);

      if (!(t.disabled || t.readonly || t.asciiOnly && !o.test(i) || !r.test(i) || 1 < i.length) && (t._preventDefault(e), l !== n || l !== t.$.input.value.length) && (" " !== i || t.resetOnSpace)) {
        l = t._getEditableSelectionStart(l, i);

        var _e484 = function _e484() {
          l = t._getNonEditableSelectionStart(t.$.input.selectionStart, i), -1 !== l && (t.$.input.selectionStart = t.$.input.selectionEnd = l + 1);
        };

        if (-1 === l) return void _e484();

        var _a252 = t._setCharAtPosition(i, l);

        _a252 ? (t._setMaskToInput(), t._updateMaskFullAndCompleted(), t.$.input.selectionStart = t.$.input.selectionEnd = l + 1) : _e484();
      }
    }
  }, {
    key: "_textBoxKeyUpHandler",
    value: function _textBoxKeyUpHandler() {
      var e = this;
      e.value = e._getValueWithTextMaskFormat({
        start: 0,
        end: e._mask.length
      }, e.textMaskFormat);
    }
  }, {
    key: "_textBoxPasteHandler",
    value: function _textBoxPasteHandler(e, t) {
      var a = this,
          i = a.$.input.value,
          n = a.$.input.selectionStart;
      var o = a.$.input.selectionEnd,
          r;

      if (e && a._preventDefault(e), window.clipboardData && window.clipboardData.getData ? r = window.clipboardData.getData("Text") : e && e.clipboardData && e.clipboardData.getData ? r = e.clipboardData.getData("text/plain") : t && (r = t), o - n !== i.length) {
        if (n === o && (a.$.input.selectionEnd = o = a._mask.length), a.rejectInputOnFirstFailure) {
          var _e486 = 0;

          for (var _t397 = n; _t397 < o; _t397++) {
            if ("mask" === a._mask[_t397].type) {
              if (!a._validateInput(r.charAt(_e486), _t397)) return void (a.$.input.selectionStart = a.$.input.selectionEnd = n);
              if (_e486++, _e486 > r.length) break;
            }
          }
        }

        var _e485 = {
          start: n,
          end: o
        };
        a._overwrite = !0, a._setValueToMask(r, _e485), a._setMaskToInput(), a._updateMaskFullAndCompleted(), a.$.input.selectionStart = a.$.input.selectionEnd = _e485.start, a.value = a._getValueWithTextMaskFormat({
          start: 0,
          end: a._mask.length
        }, a.textMaskFormat);
      }
    }
  }, {
    key: "_setCharAtPosition",
    value: function _setCharAtPosition(e, t) {
      var i = this,
          a = i._mask[t];
      if (" " === e && i.resetOnSpace && (e = ""), "mask" !== a.type || i.readonly || i.disabled || !a.editable) return !1;
      if ("" === e && !i.resetOnSpace) return !1;
      if (e === i.promptChar && !i.resetOnPrompt && i.allowPromptAsInput) return !1;
      if (!i.isOverwriteMode && "" !== e && e !== i.promptChar && "" !== a.character && !i._overwrite) return !1;
      var n = a.regex;

      if (n) {
        var _o125 = new RegExp(n, "i");

        if (_o125.test(e)) {
          switch (a.escapeSymbol) {
            case ">":
              e = e.toUpperCase();
              break;

            case "<":
              e = e.toLowerCase();
          }

          return i._mask[t].character = e, !0;
        }

        return i.resetOnSpace && "" === e ? (i._mask[t].character = e, !0) : !!(i.resetOnPrompt && e === i.promptChar && i.allowPromptAsInput) && (i._mask[t].character = "", !0);
      }

      return !1;
    }
  }, {
    key: "_updateMaxLength",
    value: function _updateMaxLength() {
      var e = this;
      0 < e._mask.length && (e.maxLength = e._mask.length);
    }
  }, {
    key: "_updatePromptChar",
    value: function _updatePromptChar() {
      var e = this;

      for (var _t398 = 0, _i409; _t398 < e._mask.length; _t398++) {
        _i409 = e._mask[_t398], _i409.defaultCharacter = e.promptChar;
      }

      e._setMaskToInput();
    }
  }, {
    key: "_validateMaskValue",
    value: function _validateMaskValue() {
      var e = this;
      if (e.readonly || e.disabled || !e.validation || "function" != typeof e.validation) return;
      var t = e.value,
          i = e.validation(t);
      i ? e.removeAttribute("error") : e.setAttribute("error", ""), e.$.fireEvent("validation", {
        success: i
      });
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler() {}
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {}
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler() {}
  }, {
    key: "_mouseWheelHandler",
    value: function _mouseWheelHandler() {}
  }, {
    key: "_applySelection",
    value: function _applySelection() {}
  }, {
    key: "_setDropDownSize",
    value: function _setDropDownSize() {}
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler() {}
  }], [{
    key: "properties",
    get: function get() {
      return {
        allowPromptAsInput: {
          value: !1,
          type: "boolean"
        },
        asciiOnly: {
          value: !1,
          type: "boolean"
        },
        autoShowMask: {
          value: !1,
          type: "boolean"
        },
        cutCopyMaskFormat: {
          value: "excludePromptAndLiterals",
          allowedValues: ["excludePromptAndLiterals", "includePrompt", "includeLiterals", "includePromptAndLiterals"],
          type: "string"
        },
        hidePromptOnLeave: {
          value: !1,
          type: "boolean"
        },
        hint: {
          value: "",
          reflectToAttribute: !0,
          type: "string"
        },
        isOverwriteMode: {
          value: !1,
          type: "boolean"
        },
        label: {
          value: "",
          reflectToAttribute: !0,
          type: "string"
        },
        mask: {
          value: "#####",
          type: "string"
        },
        maskCompleted: {
          value: !1,
          type: "boolean"
        },
        maskFull: {
          value: !1,
          type: "boolean"
        },
        placeholder: {
          value: "",
          type: "string"
        },
        promptChar: {
          value: "_",
          type: "string"
        },
        rejectInputOnFirstFailure: {
          value: !1,
          type: "boolean"
        },
        resetOnPrompt: {
          value: !1,
          type: "boolean"
        },
        resetOnSpace: {
          value: !1,
          type: "boolean"
        },
        textMaskFormat: {
          value: "excludePromptAndLiterals",
          allowedValues: ["excludePromptAndLiterals", "includePrompt", "includeLiterals", "includePromptAndLiterals"],
          type: "string"
        },
        validation: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        value: {
          value: null,
          reflectToAttribute: !0,
          type: "string?"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        mouseenter: "_mouseEventsHandler",
        mouseleave: "_mouseEventsHandler",
        "input.copy": "_cutCopyHandler",
        "input.change": "_textBoxChangeHandler",
        "input.cut": "_cutCopyHandler",
        "input.paste": "_textBoxPasteHandler",
        "input.keydown": "_textBoxKeyDownHandler",
        "input.keyup": "_textBoxKeyUpHandler",
        "input.blur": "_blurHandler",
        "input.focus": "_focusHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.textbox.css", "smart.maskedtextbox.css"];
    }
  }]);

  return _class43;
}(Smart.BaseElement)), Smart("smart-multiline-text-box",
/*#__PURE__*/
function (_Smart$TextBox) {
  "use strict";

  _inherits(_class44, _Smart$TextBox);

  function _class44() {
    _classCallCheck(this, _class44);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class44).apply(this, arguments));
  }

  _createClass(_class44, [{
    key: "attached",
    value: function attached() {
      var e = this;
      _get(_getPrototypeOf(_class44.prototype), "attached", this).call(this), e._scrollView || (e._scrollView = new Smart.Utilities.Scroll(e.$.input, e.$.horizontalScrollBar, e.$.verticalScrollBar));
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;
      _get(_getPrototypeOf(_class44.prototype), "detached", this).call(this), e._scrollView && (e._scrollView.unlisten(), delete e._scrollView);
    }
  }, {
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <span id=\"label\" inner-h-t-m-l=\"[[label]]\" class=\"smart-label\"></span>\n                    <div id=\"innerContainer\" class=\"smart-inner-container\">\n                            <textarea class=\"smart-input\" id=\"input\"\n                                autocapitalize=\"[[autoCapitalize]]\"\n                                autocomplete=\"off\"\n                                cols=\"[[cols]]\"\n                                disabled=\"[[disabled]]\"\n                                maxlength=\"[[maxLength]]\"\n                                minlength=\"[[minLength]]\"\n                                name=\"[[name]]\"\n                                placeholder=\"[[placeholder]]\"\n                                readonly=\"[[readonly]]\"\n                                required=\"[[required]]\"\n                                rows=\"[[rows]]\"\n                                spellcheck=\"[[spellCheck]]\"\n                                wrap=\"[[wrap]]\"></textarea>\n                            <smart-scroll-bar id=\"verticalScrollBar\" right-to-left=\"[[rightToLeft]]\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" orientation=\"vertical\"></smart-scroll-bar>\n                            <smart-scroll-bar id=\"horizontalScrollBar\" right-to-left=\"[[rightToLeft]]\" animation=\"[[animation]]\" disabled=\"[[disabled]]\"></smart-scroll-bar>\n                            <div id=\"resizeElement\" class=\"smart-resize-element\"></div>\n                    </div>\n                            <textarea id=\"textBoxHidden\"\n                                class=\"smart-text-box-hidden\"\n                                autocapitalize=\"[[autoCapitalize]]\"\n                                autocomplete=\"off\"\n                                cols=\"[[cols]]\"\n                                disabled=\"[[disabled]]\"\n                                inner-h-t-m-l=\"[[value]]\"\n                                maxlength=\"[[maxLength]]\"\n                                minlength=\"[[minLength]]\"\n                                name=\"[[name]]\"\n                                placeholder=\"[[placeholder]]\"\n                                readonly=\"[[readonly]]\"\n                                required=\"[[required]]\"\n                                rows=\"[[rows]]\"\n                                spellcheck=\"[[spellCheck]]\"\n                                wrap=\"[[wrap]]\"></textarea>\n                    <span id=\"hint\" class=\"smart-hint\"></span>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "displayMode":
          a.$.input.value = "escaped" === i ? a._toEscapedDisplayMode(a.value) : a.value = a._toDefaultDisplayMode(a.$.input.value);
          a._autoExpandUpdate(), a._handleScrollbarsDisplay();
          break;

        case "value":
          switch (a._preventProgramaticValueChange ? (a._userValue = "escaped" === a.displayMode ? a._toDefaultDisplayMode(a.$.input.value) : a.$.input.value, a._programmaticValue = i) : a._userValue = a._programmaticValue = i, a.displayMode) {
            case "escaped":
              a.$.input.value = a._toEscapedDisplayMode(a._userValue);
              break;

            default:
              a.$.input.value = a._userValue;
          }

          a._oldValue = t, a._autoExpandUpdate(), a._handleScrollbarsDisplay();
          break;

        case "horizontalScrollBarVisibility":
        case "verticalScrollBarVisibility":
        case "singleLine":
        case "wrap":
        case "resizable":
        case "placeholder":
          a._autoExpandUpdate(), a._handleScrollbarsDisplay();
          break;

        case "selectionEnd":
        case "selectionStart":
          a._handleSelectedText();

          break;

        case "rows":
        case "cols":
          a._updateSizeRowsCols();

          break;

        case "disabled":
          a._setFocusable();

          break;

        case "animation":
        case "readonly":
          break;

        default:
          _get(_getPrototypeOf(_class44.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "selection",
    value: function selection(e) {
      var t = this;
      var i = t.$.input.selectionStart,
          a = t.$.input.selectionEnd,
          n = t.value;
      return "escaped" === t.displayMode ? (n = t.$.input.value.substring(i, a), "escaped" === e ? n : t._toDefaultDisplayMode(n)) : "escaped" === e ? (n = n.substring(i, a), t._toEscapedDisplayMode(n)) : (n = n.substring(i, a), n);
    }
  }, {
    key: "select",
    value: function select(e, t) {
      var i = this,
          a = Array.from(arguments).slice(0, 2);
      var n, o;

      for (var _n201 in a) {
        a[_n201] = parseInt(a[_n201]) || 0;
      }

      return (2 === a.length ? (n = Math.min([e, t]), o = Math.max([e, t])) : n = a[0], 2 === a.length) ? (n = parseInt(n), n = 0 < n ? n < i.$.input.length ? i.$.input.length : n : 0, o < n ? o = n : o > i.$.input.length && (n = 0), i.$.input.focus(), void i.$.input.setSelectionRange(n, o)) : 1 === a.length ? (i.$.input.focus(), void i.$.input.setSelectionRange(n, n + 1)) : void i.$.input.select();
    }
  }, {
    key: "_autoExpandUpdate",
    value: function _autoExpandUpdate() {
      var e = this;
      e.autoExpand && (e.$.textBoxHidden.value = e.$.input.value, e.$.textBoxHidden.style.cssText = "height:0px", e.$.input.style.cssText = "height:" + e.$.textBoxHidden.scrollHeight + "px");
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      var e = this;
      e._outsideAutoScroll && clearInterval(e._outsideAutoScroll), e.removeAttribute("focus"), e._preventProgramaticValueChange = !1, e._oldValue = e.value, e.value = e._userValue || e.value;
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.autoFocus && (navigator.userAgent.match(/Edge/) ? setTimeout(function () {
        e.$.input.focus(), e.setAttribute("focus", "");
      }, 10) : (e.$.input.focus(), e.setAttribute("focus", "")));
      var t = e.$.input.innerHTML;
      e.value ? e.$.input.innerHTML = "escaped" === e.displayMode ? e._toEscapedDisplayMode(e.value) : e.value : 0 < t.length && "escaped" === e.displayMode ? (e.value = t, e.$.input.innerHTML = e._toEscapedDisplayMode(t)) : 0 < t.length && (e.value = t), e._setFocusable(), e._syncTextBoxContentOnInitialization(), e._scrollView = new Smart.Utilities.Scroll(e.$.input, e.$.horizontalScrollBar, e.$.verticalScrollBar), e._autoExpandUpdate(), e._handleScrollbarsDisplay(), e._initializationValue = e._oldValue = e.value, 0 < e.value.length ? e.$.addClass("has-value") : e.$.removeClass("has-value"), e._handleHintContainer();
    }
  }, {
    key: "_handleScrollbarsDisplay",
    value: function _handleScrollbarsDisplay(e) {
      var t = this,
          i = t.$.input;
      setTimeout(function () {
        switch (t.horizontalScrollBarVisibility) {
          case "disabled":
            t.$container.addClass("hscroll"), t.$.horizontalScrollBar.disabled = !0;
            break;

          case "hidden":
            t.$container.removeClass("hscroll");
            break;

          case "visible":
            t.$container.addClass("hscroll"), t._scrollView.scrollWidth = i.scrollWidth - i.clientWidth, t._scrollView.scrollTo(t.$.input.scrollLeft, !0), t.$.horizontalScrollBar.disabled = !1;
            break;

          default:
            i.scrollWidth > i.clientWidth ? (t.$container.addClass("hscroll"), t._scrollView.scrollWidth = i.scrollWidth - i.clientWidth, e && "resize" === e.type ? t.$.input.scrollLeft = t._scrollView.scrollLeft : t._scrollView.scrollTo(t.$.input.scrollLeft, !0)) : t.$container.removeClass("hscroll"), t.$.horizontalScrollBar.disabled = !1;
        }

        switch (t.verticalScrollBarVisibility) {
          case "disabled":
            t.$container.addClass("vscroll"), t.$.verticalScrollBar.disabled = !0;
            break;

          case "hidden":
            t.$container.removeClass("vscroll");
            break;

          case "visible":
            t.$container.addClass("vscroll"), t._scrollView.scrollHeight = i.scrollHeight - i.clientHeight, t._scrollView.scrollTo(t.$.input.scrollTop), t.$.verticalScrollBar.disabled = !1;
            break;

          default:
            i.scrollHeight > i.clientHeight ? (t.$container.addClass("vscroll"), t._scrollView.scrollHeight = i.scrollHeight - i.clientHeight, e && "resize" === e.type ? t.$.input.scrollTop = t._scrollView.scrollTop : t._scrollView.scrollTo(t.$.input.scrollTop)) : t.$container.removeClass("vscroll"), t.$.verticalScrollBar.disabled = !1;
        }
      }, 0);
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler(e) {
      var t = this;

      if (!t.disabled) {
        if (e.target === t) return t.$.input.focus(), void (t._edgeSelect = !1);
        if (t.setAttribute("focus", ""), t.selectAllOnFocus) if (navigator.userAgent.match(/Edge/)) {
          var _e487 = t.$.input.scrollTop;
          if (t._edgeSelect) return void (t._edgeSelect = !1);
          setTimeout(function () {
            t._edgeSelect = !0, t.$.input.select(), t.$.input.scrollTop = _e487;
          }, 5);
        } else t.$.input.select();
      }
    }
  }, {
    key: "_getScrollLeft",
    value: function _getScrollLeft(e, t) {
      var i = this;
      return i.rightToLeft ? (Smart.Utilities.Core.Browser.Chrome ? (!t && (t = i.$.input.scrollWidth - i.$.input.offsetWidth), e = t - e) : e *= -1, e) : e;
    }
  }, {
    key: "_horizontalScrollbarHandler",
    value: function _horizontalScrollbarHandler(e) {
      var t = this;
      t.disabled || "hidden" === t.horizontalScrollBarVisibility || "disabled" === t.horizontalScrollBarVisibility || (e.stopPropagation(), t.$.input.scrollLeft = t._getScrollLeft(e.detail.value));
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      function t(t) {
        var a = i.$.input.selectionStart,
            n = i.$.input.selectionEnd,
            o = i.$.input.value;
        e.preventDefault(), i.$.input.value = o.substring(0, a) + t + o.substring(n, o.length), i.value = i._toDefaultDisplayMode(i.$.input.value), i.$.input.selectionStart = a + 2, i.$.input.selectionEnd = a + 2;
      }

      var i = this,
          a = e.key,
          n = e.shiftKey,
          o = e.ctrlKey,
          r = i.$.input.value;
      if (i.allowVerticalScrollbar && i.$.input.selectionEnd > i.$.input.value.length - 5 && i._scrollView.scrollTo(i._scrollView.scrollTop + (0 > e.deltaY ? -i.offsetHeight : i.offsetHeight)), -1 < a.indexOf("Arrow")) return void e.stopPropagation();

      switch (a) {
        case "Enter":
          {
            if ("newLine" === i.enterKeyBehavior && !o && !n || "newLine" !== i.enterKeyBehavior && (o || n)) {
              "escaped" === i.displayMode && t("\\n");
              break;
            }

            e.preventDefault(), i._userValue = "escaped" === i.displayMode ? i._toDefaultDisplayMode(i.$.input.value) : i.$.input.value, i.value = i._userValue, ("submit" === i.enterKeyBehavior || "clearOnSubmit" === i.enterKeyBehavior || "" !== r && i._userValue !== i._oldValue) && i.$.fireEvent("change", {
              oldValue: i._oldValue,
              value: r,
              type: "submit"
            }), "clearOnSubmit" === i.enterKeyBehavior && (i.$.input.value = ""), i._oldValue = i.value = i._toDefaultDisplayMode(i.$.input.value), i._submitted = !0, "escaped" !== i.displayMode || !(0 > i.enterKeyBehavior.toLowerCase().indexOf("submit")) || o || n || t("\\n"), ("submit" === i.enterKeyBehavior || "newLine" === i.enterKeyBehavior && o) && i.$.input.blur();
            break;
          }

        case "Escape":
          if ("none" === i.escKeyMode) return;

          switch (i.escKeyMode) {
            case "none":
              break;

            case "clearValue":
              i.value = i.$.input.value = "";
              break;

            case "previousValue":
              i.$.input.value = "escaped" === i.displayMode ? i._toEscapedDisplayMode(i._oldValue) : i._oldValue;
          }

          break;

        case " ":
          "escaped" === i.displayMode && t("\\s");
          break;

        case "Backspace":
          if ("escaped" === i.displayMode && i.$.input.selectionStart === i.$.input.selectionEnd) {
            var _e488 = i.$.input.selectionStart;
            "\\" === r[_e488 - 2] && ("s" === r[_e488 - 1] || "n" === r[_e488 - 1]) && (i.$.input.value = i.$.input.value.substring(0, _e488 - 2) + i.$.input.value.substring(_e488 - 2, i.$.input.value.length), i.$.input.selectionStart = _e488 - 2);
          }

          i._scrollView && i._handleScrollbarsDisplay();
      }
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this,
          i = e.key;
      "ArrowLeft" === i || "ArrowUp" === i || "ArrowDown" === i ? t._handlePointerInEscapedSymbol() : "ArrowRight" === i ? t._handlePointerInEscapedSymbol("next") : void 0;
      t._autoExpandUpdate(), t._userValue = "escaped" === t.displayMode ? t._toDefaultDisplayMode(t.$.input.value) : t.$.input.value, t._submitKeyUpHandler();
    }
  }, {
    key: "_textBoxKeyDownHandler",
    value: function _textBoxKeyDownHandler(e) {
      var t = this,
          i = e.key;
      t._scrollView && t._handleScrollbarsDisplay(), t._autoExpandUpdate(), t.value && 0 < t.value.length ? t.$.addClass("has-value") : t.$.removeClass("has-value"), -1 === ["Enter", "Escape"].indexOf(i) && (t._preventProgramaticValueChange = !0), -1 < ["ArrowLeft", "ArrowUp", "ArrowDown", "ArrowRight"].indexOf(i) && t._scrollView.scrollTo(t.$.input.scrollTop), -1 < ["PageUp", "PageDown"].indexOf(i) && Smart.Utilities.Core.Browser.Chrome && ("PageUp" === e.key && (t.$.input.setSelectionRange(0, 0), t.$.input.scrollTop = 0), "PageDown" === e.key && (t.$.input.setSelectionRange(t.$.input.value.length, t.$.input.value.length), t.$.input.scrollTop = t._scrollView.verticalScrollBar.max), e.preventDefault());
    }
  }, {
    key: "_mouseWheelHandler",
    value: function _mouseWheelHandler(e) {
      var t = this;
      t.disabled || t.$.verticalScrollBar.disabled || (t._scrollView.scrollTo(t._scrollView.scrollTop + (0 > e.deltaY ? -t.offsetHeight : t.offsetHeight)), t.$.input.scrollTop += 0 > e.deltaY ? -t.offsetHeight : t.offsetHeight, 0 < t.$.input.scrollTop && e.preventDefault());
    }
  }, {
    key: "_syncTextBoxContentOnInitialization",
    value: function _syncTextBoxContentOnInitialization() {
      var e = this;
      var t;
      return t = "" === e.value ? e.innerHTML : e.value, "escaped" === e.displayMode ? void (t.match(/\r\n|\n\r|\n|\r|\s|\t|\f|\r/g) ? (e.value = e._initializationValue = t, e.$.input.value = e._toEscapedDisplayMode(t)) : (e.value = e._initializationValue = e._toDefaultDisplayMode(t), e.$.input.value = t)) : void (e.$.input.value = e.value = e._initializationValue = t);
    }
  }, {
    key: "_textBoxChangeHandler",
    value: function _textBoxChangeHandler(e) {
      var t = this,
          i = e.clipboardData || e.originalEvent && e.originalEvent.clipboardData || window.clipboardData,
          a = t.value;

      if ("escaped" === t.displayMode) {
        var _a253 = t.$.input.selectionStart,
            _n202 = t.$.input.selectionEnd;

        if (i) {
          var _o126 = i.getData("text"),
              _r81 = t.$.input.value;

          e.preventDefault(), _o126 = t._toEscapedDisplayMode(_o126), t.$.input.value = _r81.substring(0, _a253) + _o126 + _r81.substring(_n202, _r81.length);
        }

        t.value = t._toDefaultDisplayMode(t.$.input.value);
      } else t.value = t.$.input.value;

      t._handleScrollbarsDisplay(), 0 < t.value.length ? t.$.addClass("has-value") : t.$.removeClass("has-value"), i || t.$.fireEvent("change", {
        value: t.value,
        oldValue: a,
        type: "blur"
      }), t._handleHintContainer();
    }
  }, {
    key: "_resizeDownHandler",
    value: function _resizeDownHandler() {
      var e = this;
      e.disabled || !e.resizable || (e._resizeStarted = !0, e.$container.addClass("smart-resize"), !e.readonly && e.$.input.setAttribute("readonly", ""));
    }
  }, {
    key: "_resizeMoveHandler",
    value: function _resizeMoveHandler(e) {
      var t = this;

      if (!t.disabled && t.resizable && t._resizeStarted) {
        var _i410 = t.getBoundingClientRect(),
            _a254 = {
          width: 50,
          height: 50
        },
            _n203 = t.rightToLeft ? _i410.width + _i410.left - e.clientX : e.clientX - _i410.left,
            _o127 = e.clientY - _i410.top;

        _n203 > _a254.width && (t.style.width = _n203 + "px"), _o127 > _a254.height && (t.style.height = _o127 + "px");
      }
    }
  }, {
    key: "_updateSizeRowsCols",
    value: function _updateSizeRowsCols() {
      var e = this;
      e.$.container.removeAttribute("style"), setTimeout(function () {
        if ("disabled" !== e.horizontalScrollBarVisibility && "hidden" !== e.horizontalScrollBarVisibility || "disabled" !== e.verticalScrollBarVisibility && "hidden" !== e.verticalScrollBarVisibility) {
          var _t399 = e.getBoundingClientRect();

          e.$.container.style.width = _t399.width + "px", e.$.container.style.height = _t399.height + "px";
        }
      }, 0);
    }
  }, {
    key: "_upHandler",
    value: function _upHandler(e) {
      var t = this;
      return t._selectionStarted = !1, t.disabled ? void 0 : e.originalEvent.target === t.$.input ? void t._handlePointerInEscapedSymbol() : void (t.$container.removeClass("smart-resize"), !t.readonly && t.$.input.removeAttribute("readonly"), t._resizeStarted && t.$.input.focus(), t._resizeStarted = !1);
    }
  }, {
    key: "_verticalScrollbarHandler",
    value: function _verticalScrollbarHandler(e) {
      var t = this;
      t.disabled || "disabled" === t.verticalScrollBarVisibility || "hidden" === t.verticalScrollBarVisibility || (e.stopPropagation(), t.$.input.scrollTop = e.detail.value);
    }
  }, {
    key: "_documentDownHandler",
    value: function _documentDownHandler(e) {
      var t = this;
      t._selectionStarted = !1;
      e.originalEvent && t.$.input.contains(e.originalEvent.target) && (t._selectionStarted = !0, t._selectionStartTime = new Date(), t._pointerDown = {
        pageX: e.pageX,
        pageY: e.pageY
      }, t._edgeSelect = !1);
    }
  }, {
    key: "_documentSelectionOutsideHandler",
    value: function _documentSelectionOutsideHandler(e) {
      function t(t) {
        var i = a.getBoundingClientRect(),
            n = document.documentElement,
            o = t ? i.left + n.scrollLeft - e.pageX : i.top + n.scrollTop - e.pageY,
            r = t ? "Left" : "Top";
        0 < o ? (a.$.input["scroll" + r] -= 10, a._scrollView["scroll" + r] -= 10) : (a.$.input["scroll" + r] += 10, a._scrollView["scroll" + r] += 10);
      }

      var i = Math.abs;
      var a = this;
      if (clearInterval(a._outsideAutoScroll), !a._selectionStarted) return;
      var n = a.$.input.getBoundingClientRect(),
          o = n.y + 10,
          r = n.y + n.height - 10;
      if (e.pageY > o && e.pageY < r) return;
      var l = 300 > new Date() - a._selectionStartTime,
          s = !l && (3 <= i(a._pointerDown.pageX - e.pageX) || 3 <= i(a._pointerDown.pageY - e.pageY));
      s && (a._outsideAutoScroll = setInterval(function () {
        t(), t(!0);
      }, 10));
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler() {}
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler() {}
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoCapitalize: {
          value: "none",
          allowedValues: ["none", "words", "characters"],
          type: "string"
        },
        autoComplete: {
          value: "off",
          allowedValues: ["on", "off"],
          type: "string"
        },
        autoExpand: {
          value: !1,
          type: "boolean"
        },
        cols: {
          value: 20,
          type: "number?"
        },
        enterKeyBehavior: {
          value: "newLine",
          allowedValues: ["submit", "clearOnSubmit", "newLine"],
          type: "string"
        },
        horizontalScrollBarVisibility: {
          type: "string",
          value: "auto",
          allowedValues: ["auto", "disabled", "hidden", "visible"]
        },
        minLength: {
          value: 0,
          type: "number"
        },
        resizable: {
          value: !1,
          type: "boolean"
        },
        rows: {
          value: 5,
          type: "number?"
        },
        selectionDirection: {
          value: "none",
          allowedValues: ["forward", "backward", "none"],
          type: "string"
        },
        selectionEnd: {
          value: 0,
          reflectToAttribute: !1,
          type: "number"
        },
        selectionStart: {
          value: 0,
          reflectToAttribute: !1,
          type: "number"
        },
        spellCheck: {
          value: !1,
          type: "boolean"
        },
        type: {
          value: "textarea",
          type: "string",
          defaultReflectToAttribute: !0,
          readonly: !0
        },
        verticalScrollBarVisibility: {
          type: "string",
          value: "auto",
          allowedValues: ["auto", "disabled", "hidden", "visible"]
        },
        wrap: {
          value: "soft",
          allowedValues: ["hard", "soft", "off"],
          type: "string"
        }
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.textbox.css", "smart.multilinetextbox.css"];
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "document.mousemove": "_documentSelectionOutsideHandler",
        "container.resize": "_handleScrollbarsDisplay",
        "document.move": "_resizeMoveHandler",
        "document.up": "_upHandler",
        focus: "_focusHandler",
        "horizontalScrollBar.change": "_horizontalScrollbarHandler",
        keydown: "_keyDownHandler",
        mouseenter: "_mouseEventsHandler",
        mouseleave: "_mouseEventsHandler",
        resize: "_handleScrollbarsDisplay",
        "resizeElement.down": "_resizeDownHandler",
        styleChanged: "_handleScrollbarsDisplay",
        "input.change": "_textBoxChangeHandler",
        "input.focus": "_focusHandler",
        "input.blur": "_blurHandler",
        "input.keydown": "_textBoxKeyDownHandler",
        "input.keyup": "_keyUpHandler",
        "input.paste": "_textBoxChangeHandler",
        "input.select": "_textBoxSelectHandler",
        wheel: "_mouseWheelHandler",
        "verticalScrollBar.change": "_verticalScrollbarHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.ScrollBar": "smart.scrollbar.js"
      };
    }
  }]);

  return _class44;
}(Smart.TextBox)), Smart("smart-password-text-box",
/*#__PURE__*/
function (_Smart$BaseElement5) {
  "use strict";

  _inherits(_class45, _Smart$BaseElement5);

  function _class45() {
    _classCallCheck(this, _class45);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class45).apply(this, arguments));
  }

  _createClass(_class45, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <span id=\"label\" inner-h-t-m-l=\"[[label]]\" class =\"smart-label\"></span>\n                    <div id=\"innerContainer\" class=\"smart-inner-container\">\n                            <input class =\"smart-input\" type=\"password\" id=\"input\"\n                                disabled=\"[[disabled]]\"\n                                maxlength=\"[[maxLength]]\"\n                                minlength=\"[[minLength]]\"\n                                name=\"[[name]]\"\n                                placeholder=\"[[placeholder]]\"\n                                readonly=\"[[readonly]]\"\n                                value=\"[[value]]\">\n                            <span id=\"passwordIcon\" title=\"Show Password\" class =\"smart-password-icon smart-hidden\"></span>\n                    </div>\n                    <span id=\"hint\" class =\"smart-hint\"></span>\n                    <smart-tooltip id=\"tooltip\"\n                        open-mode=\"manual\"\n                        arrow=\"[[tooltipArrow]]\"\n                        right-to-left=\"[[rightToLeft]]\"\n                        tooltip-template=\"[[tooltipTemplate]]\"\n                        position=\"[[tooltipPosition]]\"\n                        delay=\"[[tooltipDelay]]\">\n                     </smart-tooltip>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;
      var n;

      switch (e) {
        case "locale":
        case "messages":
        case "passwordStrength":
          n = a._evaluatePasswordStrength(), a._updateTooltipString(n), a.$.passwordIcon.setAttribute("title", a.localize("showPassword")), a._updatePasswordStrengthStyles(n);
          break;

        case "tooltipPosition":
          a.$.tooltip.position = a.tooltipPosition;
          break;

        case "tooltipTemplate":
          a.$.tooltip.tooltipTemplate = a.tooltipTemplate;
          break;

        case "value":
          n = a._evaluatePasswordStrength(), a._updateTooltipString(n), a._updatePasswordStrengthStyles(n);
          break;

        case "disabled":
          a._setFocusable();

          break;

        case "readonly":
          break;

        default:
          _get(_getPrototypeOf(_class45.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void (e.$.input.tabIndex = -1) : void e.$.input.removeAttribute("tabindex");
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e._createElement(), _get(_getPrototypeOf(_class45.prototype), "render", this).call(this);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.$.input.focus();
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.autoFocus && e.$.input.focus(), e._setFocusable(), e.$.tooltip.selector = e.$.innerContainer, e.$.passwordIcon.setAttribute("title", e.localize("showPassword")), e._updateTooltipString("short"), e._updatePasswordStrengthStyles(), e._initializationValue = e.value, 0 < e.value.length ? e.$.addClass("has-value") : e.$.removeClass("has-value"), e._handleHintContainer(), e.shadowRoot && (e.$.tooltip.style.display = "none", requestAnimationFrame(function () {
        return e.$.tooltip.style.display = "";
      }));
    }
  }, {
    key: "_handleHintContainer",
    value: function _handleHintContainer() {
      var e = this;

      if (e.hint) {
        var _t400 = e.$.hint;

        if ("function" == typeof e.hint) {
          var _i411 = e.value,
              _a255 = e.hint(_i411, _t400);

          _a255 ? e.$.addClass("invalid") : e.$.removeClass("invalid");
        } else "string" == typeof e.hint && (_t400.innerHTML = e.hint, e.$.removeClass("invalid"));
      }
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler() {
      var e = this;
      e.disabled || (e.selectAllOnFocus && e.$.input.select(), e.showPasswordIcon && e.$passwordIcon.removeClass("smart-hidden"), e.setAttribute("focus", ""), e._valueBeforeChange = e.value, e.showPasswordStrength && (e._tooltipOpened || (e.$.tooltip.open(), e._tooltipOpened = !0)));
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      var e = this;
      e.disabled || e._passwordIconPressed || (e._valueBeforeChange !== e.value && (e.$.fireEvent("change", {
        newValue: e.value,
        oldValue: e._valueBeforeChange
      }), e._valueBeforeChange = ""), e.showPasswordIcon && e.$passwordIcon.addClass("smart-hidden"), e.removeAttribute("focus"), 0 < e.value.length ? e.$.addClass("has-value") : e.$.removeClass("has-value"), e._tooltipOpened && (e.$.tooltip.close(), e._tooltipOpened = !1));
    }
  }, {
    key: "_showPassword",
    value: function _showPassword() {
      var e = this;
      e.disabled || !e.showPasswordIcon || (e.$.input.type = "text", e._passwordIconPressed = !0);
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler() {
      var e = this;
      !e.disabled && e.showPasswordIcon && e._passwordIconPressed && (e.$.input.type = "password", e._passwordIconPressed = !1, e.$.input.focus());
    }
  }, {
    key: "_textBoxChangeHandler",
    value: function _textBoxChangeHandler() {
      var e = this;

      if (!(e.disabled || e.readonly)) {
        e.value = e.$.input.value;

        var _t401 = e._evaluatePasswordStrength();

        e._updateTooltipString(_t401), e._updatePasswordStrengthStyles(_t401);
      }
    }
  }, {
    key: "_updatePasswordStrengthStyles",
    value: function _updatePasswordStrengthStyles(e) {
      var t = this,
          a = ["short", "weak", "far", "good", "strong"];
      e = e || "short";

      for (var _n204 = 0; _n204 < a.length; _n204++) {
        t.$container.removeClass("smart-password-" + a[_n204]);
      }

      t.disabled || t.$container.addClass("smart-password-" + e);
    }
  }, {
    key: "_evaluatePasswordStrength",
    value: function _evaluatePasswordStrength() {
      var e = this,
          t = e.$.input.value,
          a = t.length;
      if (e.disabled) return;
      if (e.passwordStrength) return e.passwordStrength(t, "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=");
      var n = 0,
          o = 0,
          r = 0,
          l = 0;

      for (var s = 0; s < a; s++) {
        var _e489 = t.charAt(s),
            _i412 = t.charCodeAt(s);

        if (64 < _i412 && 91 > _i412 || 96 < _i412 && 123 > _i412 || 127 < _i412 && 155 > _i412 || 159 < _i412 && 166 > _i412) {
          n += 1;
          continue;
        }

        if (!1 === isNaN(_e489)) {
          o += 1;
          continue;
        }

        if (-1 !== "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=".indexOf(_e489)) {
          r += 1;
          continue;
        }
      }

      return l = n + o + 2 * r + n * o / 2 + a, 8 > a ? "short" : 20 > l ? "weak" : 30 > l ? "far" : 40 > l ? "good" : "strong";
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler() {}
  }, {
    key: "_mouseWheelHandler",
    value: function _mouseWheelHandler() {}
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {}
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler() {}
  }, {
    key: "_setDropDownSize",
    value: function _setDropDownSize() {}
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler() {}
  }, {
    key: "_mouseEventsHandler",
    value: function _mouseEventsHandler(e) {
      var t = this;
      "mouseenter" === e.type ? t.setAttribute("hover", "") : t.removeAttribute("hover");
    }
  }, {
    key: "_updateTooltipString",
    value: function _updateTooltipString(e) {
      var t = this;
      t.$.tooltip.value = "<span class=\"password-strength-label\">" + t.localize("passwordStrength") + ":</span><span class=\"password-strength-value\">" + t.localize(e) + "</span>";
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        hint: {
          value: "",
          reflectToAttribute: !0,
          type: "string"
        },
        label: {
          value: "",
          reflectToAttribute: !0,
          type: "string"
        },
        messages: {
          value: {
            en: {
              passwordStrength: "Password strength",
              short: "Short",
              weak: "Weak",
              far: "Far",
              good: "Good",
              strong: "Strong",
              showPassword: "Show password"
            }
          },
          type: "object",
          extend: !0
        },
        passwordStrength: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        showPasswordIcon: {
          value: !1,
          type: "boolean"
        },
        showPasswordStrength: {
          value: !1,
          type: "boolean"
        },
        tooltipArrow: {
          value: !1,
          type: "boolean"
        },
        tooltipDelay: {
          value: 0,
          type: "number"
        },
        tooltipPosition: {
          allowedValues: ["bottom", "top", "left", "right", "absolute"],
          value: "top",
          type: "string"
        },
        tooltipTemplate: {
          value: null,
          type: "string?"
        },
        type: {
          value: "password",
          type: "string",
          defaultReflectToAttribute: !0,
          readonly: !0
        },
        value: {
          value: "",
          reflectToAttribute: !1,
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "document.up": "_documentUpHandler",
        blur: "_blurHandler",
        focus: "_focusHandler",
        mouseenter: "_mouseEventsHandler",
        mouseleave: "_mouseEventsHandler",
        "passwordIcon.down": "_showPassword",
        "input.change": "_textBoxChangeHandler",
        "input.paste": "_textBoxChangeHandler",
        "input.keyup": "_textBoxChangeHandler",
        "input.blur": "_blurHandler",
        "input.focus": "_focusHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Tooltip": "smart.tooltip.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.textbox.css", "smart.passwordtextbox.css"];
    }
  }]);

  return _class45;
}(Smart.BaseElement)), Smart.Utilities.Assign("Grid.Column",
/*#__PURE__*/
function () {
  "use strict";

  function _class46(e) {
    _classCallCheck(this, _class46);

    var t = this;
    "string" == typeof e ? (t.label = e, t.dataField = e) : Object.assign(t, e), t.dataType || (t.dataType = "string"), t.columnGroup || (t.columnGroup = ""), t.canNotify = !0;
    var i = "left";

    switch (t.dataType) {
      case "string":
      case "date":
        i = "left";
        break;

      case "number":
        i = "right";
        break;

      case "boolean":
        i = "center";
    }

    t.index === void 0 && (t.index = -1), t.visibleIndex === void 0 && (t.visibleIndex = -1), t.selected === void 0 && (t.selected = !1), t.label || (t.label = ""), t.menuItems || (t.menuItems = null), t.icon || (t.icon = "smart-icon-user"), t.displayField || (t.displayField = t.dataField), t.template || (t.template = ""), t.editor || (t.editor = "input"), "string" == typeof t.editor ? t.editor = {
      template: t.editor,
      autoFocus: !0
    } : void 0 === t.editor.autoFocus && (t.editor.autoFocus = !0), t.menu = null, t.allowActionButtonAnimation === void 0 && (t.grid ? t.allowActionButtonAnimation = t.grid.appearance.allowColumnActionButtonAnimation : t.allowActionButtonAnimation = !1), t.allowSortButtonAnimation === void 0 && (t.grid ? t.allowSortButtonAnimation = t.grid.appearance.allowColumnSortButtonAnimation : t.allowSortButtonAnimation = !1), t.autoShowActionButton === void 0 && (t.grid ? t.autoShowActionButton = t.grid.appearance.autoShowColumnActionButton : t.autoShowActionButton = !1), t.autoShowSortButton === void 0 && (t.grid ? t.autoShowSortButton = t.grid.appearance.autoShowColumnSortButton : t.autoShowSortButton = !0), t.showSortButton === void 0 && (t.grid ? t.showSortButton = t.grid.appearance.showColumnSortButton : t.showSortButton = !1), t.showIcon === void 0 && (t.grid ? t.showIcon = t.grid.appearance.showColumnIcon : t.showIcon = !1), t.showDescriptionButton === void 0 && (t.grid ? t.showDescriptionButton = t.grid.appearance.showColumnDescriptionButton : t.showDescriptionButton = !1), t.showCustomButton === void 0 && (t.grid ? t.showCustomButton = t.grid.appearance.showColumnCustomButton : t.showCustomButton = !1), t.showActionButton === void 0 && (t.grid ? t.showActionButton = t.grid.appearance.showColumnActionButton : t.showActionButton = !1), t.allowLabelAnimation === void 0 && (t.grid ? t.allowLabelAnimation = t.grid.appearance.allowColumnLabelAnimation : t.allowLabelAnimation = !1), t.autoShowFilterButton === void 0 && (t.grid ? t.autoShowFilterButton = t.grid.appearance.autoShowColumnFilterButton : t.autoShowFilterButton = !1), t.showFilterButton === void 0 && (t.grid ? t.showFilterButton = t.grid.appearance.showColumnFilterButton : t.showFilterButton = !1), t.autoCloseMenu === void 0 && (t.grid ? t.autoCloseMenu = t.grid.columnMenu.autoClose : t.autoCloseMenu = !0), t.formatFunction || (t.formatFunction = null), t.sortOrder || (t.sortOrder = null), t.sortIndex || (t.sortIndex = null), t.filter || (t.filter = null), t.filterMenuMode || (t.filterMenuMode = "default"), t.align || (t.align = i), t.cellsAlign || (t.cellsAlign = i), t.cellsWrap || (t.cellsWrap = !1, t.grid && t.grid.layout.allowCellsWrap && (t.cellsWrap = t.grid.layout.allowCellsWrap)), t.minWidth || (t.minWidth = 30), t.width || (t.width = null), t.grid && t.grid.columnWidth && (t.width = t.grid.columnWidth), t.visible === void 0 && (t.visible = !0), t.allowResize === void 0 && (t.allowResize = !0), t.allowReorder === void 0 && (t.allowReorder = !0), t.allowHide === void 0 && (t.allowHide = !0), t.allowSort === void 0 && (t.allowSort = !0), t.allowSelect === void 0 && (t.allowSelect = !0), t.allowSortToggleOnClick === void 0 && (t.allowSortToggleOnClick = !0), t.allowGroup === void 0 && (t.allowGroup = !0), t.allowFilter === void 0 && (t.allowFilter = !0), t.allowEdit === void 0 && (t.allowEdit = !0), t.allowHeaderEdit === void 0 && (t.allowHeaderEdit = !0), t.allowExport === void 0 && (t.allowExport = !0), t.description === void 0 && (t.description = ""), void 0 === t.group && (t.group = !1), t.summary || (t.summary = []), t.formatSettings || (t.formatSettings = {
      decimalPlaces: null,
      decimalSeparator: null,
      negativeWithBrackets: null,
      prefix: null,
      sufix: null,
      thousandsSeparator: null,
      dateFormat: "d"
    }), t.selected = !1, t.sorted = !1, t.filtered = !1, t.parent = null, t.children = [];
  }

  _createClass(_class46, [{
    key: "refresh",
    value: function refresh() {
      var e = this;
      e.element && e.element._refresh();
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.element.column = e, e.element && e.element._render();
    }
  }, {
    key: "setProperty",
    value: function setProperty(e, t) {
      var i = this,
          a = i.getProperty(e);
      a !== t && (i.canNotify = !1, i[e] = t, i.propertyChanged(e, a, t), i.canNotify = !0);
    }
  }, {
    key: "getProperty",
    value: function getProperty(e) {
      var t = this;

      if ("selected" === e) {
        var _i413 = !1;

        return t.grid._selection.cells["column" + t.dataField] && (_i413 = null), t.grid && t.grid._selection.columns[t.dataField] && (_i413 = !0), t.grid.columns.canNotify = !1, t[e] = _i413, t.grid.columns.canNotify = !0, _i413;
      }

      return "group" === e ? !!(t.dataSource && t.dataSource.groupBy) && 0 <= t.dataSource.groupBy.indexOf(t.dataField) : t[e];
    }
  }, {
    key: "propertyChanged",
    value: function propertyChanged(e, t, i) {
      var a = this;
      if ("allowSort" === e || "allowFilter" === e) return void a.refresh();
      if ("showIcon" === e) return void a.refresh();
      if ("visible" === e) return void a.grid.refresh(a.grid.grouping.enabled);
      if ("showCustomButton" === e && (i ? a.element._showCustomButton() : a.element._hideCustomButton()), "showDescriptionButton" === e && (i ? a.element._showDescriptionButton() : a.element._hideDescriptionButton()), "filter" === e && (a.filter ? (a.grid.addFilter(a.dataField, a.filter), a.filtered = !0) : (a.grid.removeFilter(a.dataField), a.filtered = !1), (a.autoShowFilterButton || a.showFilterButton) && (i ? a.element._showFilterButton() : a.element._hideFilterButton())), "sortIndex" === e) return void ("many" === a.grid.sorting.mode && a.grid.context === document && a.grid.sortBy(a.dataField, a.sortOrder));
      if ("selected" === e && (a.selectionColumn && a.refresh(), i ? !a.grid._selection.columns[a.dataField] && (a.grid._selection.columns[a.dataField] = !0) : !1 === i && a.grid._selection.columns[a.dataField] && delete a.grid._selection.columns[a.dataField], a.grid._recycle(!1)), "formatSettings" === e && a.grid._recycle(!1), "sortOrder" === e) return a.sorted = !1, null === i ? a.element._hideSortButton() : (a.element._showSortButton(), a.sorted = !0), void (a.grid.context === document && a.grid.sortBy(a.dataField, a.sortOrder));
      if ("group" === e) return void (a.grid.context === document && (i ? a.grid.addGroup(a.dataField) : a.grid.removeGroup(a.dataField)));

      if ("showActionButton" === e && (a.element.allowAnimations = !1, i ? a.element._showActionButton() : a.element._hideActionButton(), a.element.allowAnimations = !0), "autoShowActionButton" === e && (a.element.allowAnimations = !1, i ? a.element._hideActionButton() : a.element._showActionButton(), a.element.allowAnimations = !0), "showFilterButton" === e && (a.element.allowAnimations = !1, void 0 === a._autoShowFilterButton && (a._autoShowFilterButton = a.autoShowFilterButton), i ? (a.autoShowFilterButton = !1, a.element._showFilterButton()) : (a.element._hideFilterButton(), a.autoShowFilterButton = a._autoShowFilterButton), a.element.allowAnimations = !0), "showSortButton" === e && (a.element.allowAnimations = !1, void 0 === a._autoShowSortButton && (a._autoShowSortButton = a.autoShowSortButton), i ? (a.autoShowSortButton = !1, a.element._showSortButton()) : (a.element._hideSortButton(), a.autoShowSortButton = a._autoShowSortButton), a.element.allowAnimations = !0), "autoShowSortButton" === e && (a.element.allowAnimations = !1, a._autoShowSortButton = a.autoShowSortButton, i ? a.element._hideSortButton() : a.element._showSortButton(), a.element.allowAnimations = !0), "menu" === e && (i ? a.element.setAttribute("aria-controls", a.menu.id) : (a.element.removeAttribute("aria-controls"), a.autoShowActionButton && a.element._hideActionButton())), ("label" === e || "width" === e || "minWidth" === e) && a.grid.refresh(), "freeze" === e) {
        if (!!i) a.element.setAttribute("freeze", ""), a.freeze && (!0 === a.freeze || "near" === a.freeze ? a.grid._frozenNearColumns.push(a) : a.grid._frozenFarColumns.push(a));else if (!0 === a.freeze || "near" === a.freeze) {
          a.element.removeAttribute("freeze");

          var _e490 = a.grid._frozenNearColumns.indexOf(a);

          0 <= _e490 && a.grid._frozenNearColumns.splice(_e490, 0, 0);
        } else if ("far" === a.freeze) {
          var _e491 = a.grid._frozenFarColumns.indexOf(a);

          0 <= _e491 && a.grid._frozenFarColumns.splice(_e491, 0, 0);
        }
        a.grid._createColumnHeaderCellElements(), a.grid.refresh();
      }
    }
  }, {
    key: "_measureSize",
    value: function _measureSize(e) {
      var t = this,
          i = t.grid,
          a = function () {
        var t = [],
            a = document.createElement("div"),
            n = document.createElement("div"),
            o = Array.isArray(e) ? e : [e];
        n.classList.add("smart-label"), a.appendChild(n), a.style.width = "auto", a.style.position = "static", i.$.columnHeader.appendChild(a);

        for (var _e492 = 0; _e492 < o.length; _e492++) {
          n.innerHTML = "<span>" + o[_e492] + "</span>";

          var _i414 = 20 + n.firstChild.offsetWidth,
              _a256 = Math.max(30, _i414);

          t.push(_a256);
        }

        return i.$.columnHeader.removeChild(a), t;
      }();

      return 1 === a.length ? a[0] : a;
    }
  }, {
    key: "_autoSize",
    value: function _autoSize(e) {
      var t = this,
          i = t.grid;
      var a = t.label.toString();

      if (!e) {
        var _e493 = i.isInitialized ? i._recyclingRows : [];

        for (var _n205 = 0; _n205 < _e493.length; _n205++) {
          var _i415 = _e493[_n205],
              _o128 = "" + _i415.data[t.dataField];

          _o128 && _o128.length > a.length && (a = _o128);
        }
      }

      var n = t._measureSize(a);

      return n;
    }
  }, {
    key: "autoSize",
    value: function autoSize(e) {
      var t = this,
          i = t._autoSize(e);

      t.width = i;
    }
  }, {
    key: "createElement",
    value: function createElement() {
      var e = this,
          t = document.createElement("smart-grid-column");
      return t._initialize(e), e.element = t, e.grid.notify(function (t, i, a) {
        "appearance_allowColumnLabelAnimation" === t ? e.setProperty("allowLabelAnimation", a) : "appearance_allowColumnSortAnimation" === t ? e.setProperty("allowSortAnimation", a) : "appearance_allowColumnSortButtonAnimation" === t ? e.setProperty("allowSortButtonAnimation", a) : "appearance_allowColumnActionButtonAnimation" === t ? e.setProperty("allowActionButtonAnimation", a) : "appearance_allowColumnFilterButtonAnimation" === t ? e.setProperty("allowFilterButtonAnimation", a) : "appearance_autoShowColumnActionButton" === t ? e.setProperty("autoShowActionButton", a) : "appearance_autoShowColumnSortButton" === t ? e.setProperty("autoShowSortButton", a) : "appearance_autoShowColumnFilterButton" === t ? e.setProperty("autoShowFilterButton", a) : "appearance_showColumnActionButton" === t ? e.setProperty("showActionButton", a) : "appearance_showColumnFilterButton" === t ? e.setProperty("showFilterButton", a) : "appearance_showColumnCustomButton" === t ? e.setProperty("showCustomButton", a) : "appearance_showColumnDescriptionButton" === t ? e.setProperty("showDescriptionButton", a) : "appearance_showColumnSortButton" === t ? e.setProperty("showSortButton", a) : "appearance_showFrozenColumnBackground" === t || "appearance_showSortColumnBackground" === t || "appearance_showFilterColumnBackground" === t ? e.grid._recycle(!1) : void 0;
      }), t;
    }
  }, {
    key: "properties",
    get: function get() {
      return ["allowExport", "allowGroup", "allowSelect", "verticalAlign", "columnGroup", "cellsVerticalAlign", "autoCloseMenu", "autoShowActionButton", "autoShowSortButton", "autoShowFilterButton", "allowLabelAnimation", "allowActionButtonAnimation", "allowSortButtonAnimation", "allowHide", "allowEdit", "allowHeaderEdit", "allowFilter", "allowSort", "allowSortToggleOnClick", "allowResize", "allowReorder", "canNotify", "description", "grid", "icon", "menuItems", "menu", "summary", "cellsFormat", "formatSettings", "formatFunction", "index", "sortIndex", "sortOrder", "sorted", "groups", "element", "level", "group", "filtered", "filter", "filterMenuMode", "dataField", "displayField", "label", "dataType", "align", "cellsWrap", "cellsAlign", "minWidth", "width", "visible", "freeze", "showActionButton", "selected", "showIcon", "showDescriptionButton", "treeColumn", "computedWidth", "computedHeight", "overflowWidth", "parent", "children", "onAction", "left", "top", "showCustomButton", "showFilterButton", "showSortButton", "editor", "template", "visibleIndex"];
    }
  }]);

  return _class46;
}()), Smart("smart-grid-column",
/*#__PURE__*/
function (_Smart$BaseElement6) {
  "use strict";

  _inherits(_class47, _Smart$BaseElement6);

  function _class47() {
    _classCallCheck(this, _class47);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class47).apply(this, arguments));
  }

  _createClass(_class47, [{
    key: "_showSortButton",
    value: function _showSortButton(e) {
      var t = this;
      !t.column || t.column.autoGenerated || (t.sortButton.classList.remove("asc"), t.sortButton.classList.remove("desc"), !t.column.autoShowSortButton && t.column.allowSort && t.sortButton.classList.add("smart-icon-sort", "smart-grid-icon"), "asc" === t.column.sortOrder ? t.sortButton.classList.add("asc") : "desc" === t.column.sortOrder && t.sortButton.classList.add("desc"), t.column.showSortButton && (t.sortButton.classList.add("show"), !1 !== e && t._refresh()));
    }
  }, {
    key: "_hideSortButton",
    value: function _hideSortButton(e) {
      var t = this;
      t.column && (t.sortButton.classList.remove("asc"), t.sortButton.classList.remove("desc"), (!t.column.showSortButton || t.column.autoShowSortButton) && (t.sortButton.classList.remove("show"), t.sortButton.classList.remove("smart-icon-sort"), !1 !== e && t._refresh()));
    }
  }, {
    key: "_showFilterButton",
    value: function _showFilterButton() {
      var e = this;
      !e.column || e.column.autoGenerated || (e.filterButton.classList.add("show"), e._refresh());
    }
  }, {
    key: "_hideFilterButton",
    value: function _hideFilterButton() {
      var e = this;
      e.column && (e.filterButton.classList.remove("show"), e._refresh());
    }
  }, {
    key: "_showDescriptionButton",
    value: function _showDescriptionButton() {
      var e = this;
      !e.column || e.column.autoGenerated || (e.descriptionButton.setAttribute("title", e.column.description), e.descriptionButton.classList.add("show"), e._refresh());
    }
  }, {
    key: "_hideDescriptionButton",
    value: function _hideDescriptionButton() {
      var e = this;
      e.column && (e.descriptionButton.classList.remove("show"), e._refresh());
    }
  }, {
    key: "_showIcon",
    value: function _showIcon() {
      var e = this;
      !e.column || e.column.autoGenerated || (e.icon.classList.add("show"), e._refresh());
    }
  }, {
    key: "_hideIcon",
    value: function _hideIcon() {
      var e = this;
      e.icon.classList.remove("show"), e._refresh();
    }
  }, {
    key: "_showCustomButton",
    value: function _showCustomButton() {
      var e = this;
      !e.column || e.column.autoGenerated || (e.customButton.classList.add("show"), e._refresh());
    }
  }, {
    key: "_hideCustomButton",
    value: function _hideCustomButton() {
      var e = this;
      e.column && (e.customButton.classList.remove("show"), e._refresh());
    }
  }, {
    key: "_showActionButton",
    value: function _showActionButton() {
      var e = this;
      !e.column || e.column.showActionButton && e.column.grid.hasColumnMenu(e.column) && !e.column.autoGenerated && e.actionButton && (e.actionButton.classList.add("show"), e._refresh());
    }
  }, {
    key: "_hideActionButton",
    value: function _hideActionButton() {
      var e = this;
      !e.column || e.column.showActionButton && e.actionButton && !e.hasAttribute("aria-controls") && (e.actionButton.classList.remove("show"), e._refresh());
    }
  }, {
    key: "_rotate",
    value: function _rotate() {
      var e = this,
          t = document.createElement("span");
      return e.label.innerHTML = "", t.innerHTML = e.column.label, e.label.appendChild(t), t.className = "rotate", t.style.transform = "rotate(" + e.column.rotationAngle + "deg)", e.column.grid._recycleRotate(e.label, t, e.column.align, e.column.verticalAlign, e.column.label);
    }
  }, {
    key: "_align",
    value: function _align() {
      var e = this;

      switch (e.column.align) {
        case "left":
          e.label.classList.add("align-left");
          break;

        case "center":
          e.label.classList.add("align-center");
          break;

        case "right":
          e.label.classList.add("align-right");
      }

      switch (e.column.verticalAlign) {
        case "top":
          e.label.classList.add("align-top");
          break;

        case "middle":
          e.label.classList.add("align-middle");
          break;

        case "bottom":
          e.label.classList.add("align-bottom");
      }
    }
  }, {
    key: "_refresh",
    value: function _refresh() {
      var e = this;

      if (e.sortButton.classList.remove("filter"), e.sortButton.classList.remove("action"), e.label.className = "smart-label", e.column.visible && "_checkBoxColumn" === e.column.dataField) {
        var _t402 = e.column.grid;

        var _i416 = _t402.getVisibleRows();

        _t402.paging.enabled && "page" === _t402.selection.checkBoxes.selectAllMode && (_i416 = _i416.slice(_t402.paging.pageIndex * _t402.paging.pageSize, (_t402.paging.pageIndex + 1) * _t402.paging.pageSize));

        var _a257 = _t402.paging.enabled && "page" === _t402.selection.checkBoxes.selectAllMode ? _t402._getSelectedRows(!0, !0) : _t402._getSelectedRows(!0, !1);

        return _t402.selection.checkBoxes.autoShow ? e.setAttribute("auto-show", "") : e.removeAttribute("auto-show"), _a257.length === _i416.length ? e.setAttribute("selected", "") : 0 < _a257.length && _a257.length < _i416.length ? e.setAttribute("selected", "indeterminate") : (0 === _a257.length || 0 === _i416.length) && e.removeAttribute("selected"), e.removeAttribute("checkbox"), e.label.classList.remove("smart-input"), void ("none" !== _t402.selection.checkBoxes.selectAllMode && (e.setAttribute("checkbox", ""), e.label.classList.add("smart-input")));
      }

      if ("_commandColumn" === e.column.dataField) {
        var _t403 = e.column.grid,
            _i417 = "icon" !== _t403.editing.commandColumn.displayMode,
            _a258 = "label" !== _t403.editing.commandColumn.displayMode,
            _n206 = _t403.editing.commandColumn.dataSource.commandColumnMenu;

        var _o129 = "<div class=\"smart-grid-command-item\">";

        var _r82 = "{{messages}}" === _n206.label ? _t403.localize("commandColumnMenu") : _n206.label,
            _l62 = _n206.icon;

        _a258 && _i417 ? (_o129 += "<span class=\"smart-grid-icon " + _l62 + "\"></span>", _o129 += "<span class=\"smart-grid-label\">" + _r82 + "</span>") : _a258 && !_i417 ? _o129 += "<span class=\"smart-grid-icon " + _l62 + "\"></span>" : _i417 && !_a258 && (_o129 += "<span class=\"smart-grid-label\">" + _r82 + "</span>"), _o129 += "</div>", _n206.visible && (e.label.innerHTML = _o129);
      }

      var t = e.column.getProperty("selected");
      !1 === t && e.hasAttribute("selected") ? e.removeAttribute("selected") : !0 === t ? e.setAttribute("selected", "") : null === t && e.setAttribute("selected", "indeterminate"), e.column.allowSortButtonAnimation ? e.sortButton.classList.add("smart-animate") : e.sortButton.classList.remove("smart-animate"), e.column.sorted ? e._showSortButton(!1) : e._hideSortButton(!1), e.column.allowFilterButtonAnimation ? e.filterButton.classList.add("smart-animate") : e.filterButton.classList.remove("smart-animate"), e.column.allowActionButtonAnimation && !1 !== e.allowAnimations ? e.buttonsGroup.classList.add("smart-animate") : e.buttonsGroup.classList.remove("smart-animate"), e.column.allowLabelAnimation && !1 !== e.allowAnimations ? e.label.classList.add("smart-animate") : e.label.classList.remove("smart-animate"), e.buttonsGroup.classList.remove("action"), e.actionButton.classList.contains("show") && e.buttonsGroup.classList.add("action"), e.column.showIcon ? e.icon.classList.add("show") : e.icon.classList.remove("show"), e.icon.classList.contains("show") && e.icon.classList.add(e.column.icon);
      var a = e.column.showIcon ? 1 : 0;

      for (var _t404 = 0; _t404 < e.buttonsGroup.children.length; _t404++) {
        e.buttonsGroup.children[_t404].classList.contains("show") && a++;
      }

      if (1 == a ? e.label.classList.add("one") : 2 == a ? e.label.classList.add("two") : 3 == a ? e.label.classList.add("three") : 4 == a ? e.label.classList.add("four") : 5 == a ? e.label.classList.add("five") : 6 == a ? e.label.classList.add("six") : void 0, e.classList.remove("smart-visibility-hidden"), 0 < e.column.grid._columnGap ? e.classList.add("smart-grid-column-border") : e.classList.remove("smart-grid-column-border"), e.column.grid.appearance.showColumnHeaderLines ? e.classList.remove("smart-grid-vertical-border-collapse") : e.classList.add("smart-grid-vertical-border-collapse"), e.column.rotationAngle) {
        var _t405 = e._rotate();

        if (!_t405) return;
      }

      e._align();
    }
  }, {
    key: "_render",
    value: function _render() {
      var e = this,
          t = e.column.dataField ? e.column.dataField : "",
          i = e.column === e.column.grid._lastVisibleColumn;
      e.label.firstChild ? e.label.firstChild.textContent !== e.column.label && (e.label.firstChild.textContent = e.column.label) : e.label.innerHTML = "<span>" + e.column.label + "</span>", e._refresh(), e.style.width = e.column.autoGenerated || i ? e.column.computedWidth + "px" : e.column.computedWidth - e.column.grid._columnGap + "px", e.style.height !== e.column.computedHeight + "px" && (e.style.height = e.column.computedHeight + "px"), e.style.lineHeight !== e.column.computedHeight + "px" && (e.style.lineHeight = e.column.computedHeight + "px"), e.style.left !== e.column.left + "px" && (e.style.left = e.column.left + "px"), e.style.top !== e.column.top + "px" && (e.style.top = e.column.top + "px"), e.getAttribute("data-field") !== t && e.setAttribute("data-field", t), e.setAttribute("header", ""), e.column.freeze && e.setAttribute("freeze", ""), 0 < e.column.level && (e.style.top = e.column.top + "px");
    }
  }, {
    key: "addThemeClass",
    value: function addThemeClass() {}
  }, {
    key: "addDefaultClass",
    value: function addDefaultClass() {}
  }, {
    key: "_initialize",
    value: function _initialize(e) {
      var t = this,
          i = document.createElement("div"),
          a = document.createElement("div"),
          n = document.createElement("div"),
          o = document.createElement("div"),
          r = document.createElement("div"),
          l = document.createElement("div"),
          s = document.createElement("div"),
          d = document.createElement("div");
      t.column = e, t.classList.add("smart-visibility-hidden"), s.classList.add("smart-icon", "smart-grid-icon"), i.classList.add("smart-label"), a.classList.add("smart-sort-button", "smart-grid-icon"), n.classList.add("smart-filter-button", "smart-icon-filter", "smart-grid-icon"), o.classList.add("smart-action-button", "smart-grid-icon"), o.setAttribute("aria-haspopup", ""), r.classList.add("smart-description-button", "smart-icon-info-circled", "smart-grid-icon"), l.classList.add("smart-custom-button", e.customButtonIcon ? e.customButtonIcon : "smart-icon-tools", "smart-grid-icon"), d.classList.add("smart-buttons-group"), o.innerHTML = "<div></div>", t.style.width = t.column.computedWidth + "px", t.appendChild(s), t.appendChild(i), t.appendChild(d), d.appendChild(a), d.appendChild(n), d.appendChild(r), d.appendChild(l), d.appendChild(o), t.icon = s, t.label = i, t.sortButton = a, t.filterButton = n, t.actionButton = o, t.descriptionButton = r, t.customButton = l, t.buttonsGroup = d;
      var c = window.PointerEvent ? "pointerdown" : "mousedown",
          m = window.PointerEvent ? "pointerup" : "mouseup";
      t.filterButton.addEventListener(c, function (e) {
        e.preventDefault(), e.stopPropagation(), t.column.onAction && t.column.onAction(e);
      }.bind(t)), t.filterButton.addEventListener(m, function (e) {
        e.preventDefault(), e.stopPropagation();
      }), t.actionButton.addEventListener(m, function (e) {
        e.preventDefault(), e.stopPropagation();
      }), t.actionButton.addEventListener(c, function (e) {
        e.preventDefault(), e.stopPropagation(), t.column.onAction && t.column.onAction(e);
      }.bind(t)), !t.column.autoShowActionButton && t.column.showActionButton && t._showActionButton(), !t.column.autoShowSortButton && t.column.showSortButton && t._showSortButton(), !t.column.autoShowFilterButton && t.column.showFilterButton && t._showFilterButton(), t.column.showDescriptionButton && t._showDescriptionButton(), t.column.showCustomButton && t._showCustomButton(), t.column.showIcon && t._showIcon(), "_rowHeaderColumn" === t.column.dataField && t.classList.add("top-near-corner"), t.customButton.onclick = function (e) {
        t.column.onCustomButtonClick && t.column.onCustomButtonClick(e);
      }.bind(t);
    }
  }, {
    key: "template",
    value: function template() {
      return "";
    }
  }, {
    key: "hasStyleObserver",
    get: function get() {
      return !1;
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }, {
    key: "isUtilityElement",
    get: function get() {
      return !0;
    }
  }]);

  return _class47;
}(Smart.BaseElement)), Smart.Utilities.Assign("Grid.Row",
/*#__PURE__*/
function () {
  "use strict";

  function _class48(e) {
    _classCallCheck(this, _class48);

    var t = this;

    if (e || (e = {}), Object.assign(t, e), !!e) {
      if (void 0 === t.data) {
        var _i418 = {
          $: {}
        };

        if (e.grid && e.grid.dataSource) {
          var _t406 = e.grid.dataSource;

          for (var _e494 = 0; _e494 < _t406.dataFields.length; _e494++) {
            var _a259 = _t406.dataFields ? _t406.dataFields[_e494] : {};

            _i418[_a259.name] = "";
          }
        }

        e.id && (_i418.$.id = e.id), t.data = _i418;
      }

      (void 0 === e.$ || e.$ && void 0 === e.$.id) && (e.data ? (e.data.$ && e.data.$.id && (t.id = e.data.$.id), !t.id && (t.id = e.index)) : void 0 === t.id && (t.id = e.index), void 0 === t.id && (t.id = Smart.Utilities.Core.createGUID())), void 0 === t.detailHeight && (t.grid ? t.detailHeight = t.grid.rowDetail.height : t.detailHeight = 200), void 0 === t.height && t.grid && (t.height = t.grid.layout.rowMinHeight, t.grid.__autoRowHeight && (t.height = t.grid.__autoRowHeight), t.grid.layout.rowHeight && (t.height = t.grid.layout.rowHeight)), void 0 === t.cellHeight && (t.cellHeight = t.height), void 0 === t.showDetail && (t.showDetail = !1), void 0 === t.index && (t.index = -1), void 0 === t.visibleIndex && (t.visibleIndex = -1), void 0 === t.freeze && (t.freeze = !1), void 0 === t.height && (t.height = null), void 0 === t.minHeight && (t.minHeight = 25, t.grid && (t.minHeight = t.grid.layout.rowMinHeight)), void 0 === t.checked && (t.checked = !1), void 0 === t.selected ? (t.selected = !1, t.grid && t.grid._selection.rows[t.id] && (t.selected = !0)) : t.selected && t.grid && (t.grid._selection.rows[t.id] = !0), void 0 === t.enabled && (t.enabled = !0), void 0 === t.visible && (t.visible = !0), void 0 === t.allowCheck && (t.allowCheck = !0), void 0 === t.filtered && (t.filtered = !0), void 0 === t.allowResize && (t.allowResize = !0), void 0 === t.allowToggle && (t.allowToggle = !0), void 0 === t.allowSelect && (t.allowSelect = !0), void 0 === t.expanded && (e.data && void 0 !== e.data.expanded ? t.expanded = e.data.expanded : t.expanded = !1), t.headerCell = null, t._cells = [];
    }
  }

  _createClass(_class48, [{
    key: "createElement",
    value: function createElement() {
      var e = this,
          t = document.createElement("smart-grid-row");
      return e.element = t, t._initialize(e), t;
    }
  }, {
    key: "_autoSize",
    value: function _autoSize(e) {
      var t = this,
          i = t.grid;
      var a = i.layout.rowMinHeight;
      var n = t.element;
      if (e || (e = t), e && (t.data = e.data), !n) return t.height;
      i.__autoHeightRows || (i.__autoHeightRows = []);

      var o = function o(e, t, n) {
        if (!n || t.autoGenerated) return 0;

        var o = function o() {
          n.style.height = "auto", t.cellsWrap ? n.content.classList.add("wrap") : n.content.classList.add("nowrap"), e && t && (n.content.textContent = e.data[t.dataField]);
          var i = n.offsetHeight;
          return n.style.height = "", n.content.classList.remove("wrap"), n.content.classList.remove("nowrap"), i;
        };

        i.__autoHeightRows[t.dataField] || (i.__autoHeightRows[t.dataField] = []);
        var r = e.data[t.dataField].length,
            l = i.__autoHeightRows[t.dataField][r],
            s = l ? l : o();
        a = Math.max(a, s), l || (i.__autoHeightRows[t.dataField][r] = s);
      };

      for (var _t407 = 0; _t407 < i._frozenNearColumns.length; _t407++) {
        var _a260 = i._frozenNearColumns[_t407],
            _r83 = n.children[0].children[_t407];
        o(e, _a260, _r83);
      }

      for (var _t408 = 0; _t408 < i._frozenFarColumns.length; _t408++) {
        var _a261 = i._frozenFarColumns[_t408],
            _r84 = n.children[2].children[_t408];
        o(e, _a261, _r84);
      }

      for (var _t409 = 0; _t409 < n.children[1].children.length; _t409++) {
        var _a262 = i._columnElements[_t409],
            _r85 = _a262.column,
            _l63 = n.children[1].children[_t409];
        o(e, _r85, _l63);
      }

      return a;
    }
  }, {
    key: "autoSize",
    value: function autoSize() {
      var e = this,
          t = e._autoSize();

      e.height = t;
    }
  }, {
    key: "getCell",
    value: function getCell(e) {
      var t = this,
          i = t.grid;
      if (("string" == typeof e || "number" == typeof e) && (e = i.columnByDataField[e]), !e) return null;

      if (!t["column_" + e.dataField]) {
        var _a263 = new Smart.Grid.Cell(t, e, i);

        return t["column_" + e.dataField] = _a263, _a263;
      } else {
        var _i419 = t["column_" + e.dataField];
        return _i419.column = e, _i419;
      }
    }
  }, {
    key: "createCells",
    value: function createCells() {
      var e = this,
          t = e.grid;
      e._cells = [];

      for (var _a264 = 0; _a264 < t.viewColumns.length; _a264++) {
        var _i420 = t.viewColumns[_a264];
        if (!_i420.autoGenerated) if (!e["column_" + _i420.dataField]) {
          var _a265 = new Smart.Grid.Cell(e, _i420, t);

          e["column_" + _i420.dataField] = _a265, e._cells.push(_a265);
        } else {
          var _t410 = e["column_" + _i420.dataField];

          e._cells.push(_t410);
        }
      }
    }
  }, {
    key: "toggle",
    value: function toggle(e) {
      var t = this;

      t.element._handleExpandCollapse(!t.expanded, e);
    }
  }, {
    key: "expand",
    value: function expand() {
      var e = this;

      e.element._handleExpandCollapse(!0);
    }
  }, {
    key: "collapse",
    value: function collapse() {
      var e = this;

      e.element._handleExpandCollapse(!1);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.element.row = e, e.element._render();
    }
  }, {
    key: "setProperty",
    value: function setProperty(e, t) {
      var i = this,
          a = i.getProperty(e);
      i[e] = t, a !== t && (i.canNotify = !1, i.propertyChanged(e, a, t), i.canNotify = !0);
    }
  }, {
    key: "getProperty",
    value: function getProperty(e) {
      var t = this;

      if ("selected" === e) {
        var _i421 = !1;

        return t.grid._selection.cells["row" + t.id] && (_i421 = null), t.grid && t.grid._selection.rows[t.id] && (_i421 = !0), t.grid.rows.canNotify = !1, t[e] = _i421, t.grid.rows.canNotify = !0, _i421;
      }

      return t[e];
    }
  }, {
    key: "propertyChanged",
    value: function propertyChanged(e, t, i) {
      var a = this;

      if ("showDetail" === e) {
        a.height = 0;
        var _e495 = a.element.rowDetail;

        if (a.grid.appearance.allowRowDetailToggleAnimation && !a.grid.rowDetail.dialog.enabled) {
          var _t411 = function _t411(e) {
            var t = a.grid._toggledRow;
            t && ("transform" === e.propertyName || "height" === e.propertyName) && _n207(t);
          },
              _n207 = function _n207(e) {
            e.grid.$.content.style.transition = "", e.element.rowDetail.removeEventListener("transitionend", _t411), e.element.rowDetail.removeEventListener("transitioncancel", _t411), e.grid._toggledRow = null, e.element.removeAttribute("has-detail"), a.grid._refresh();
          };

          a.grid._toggledRow = a, _e495.addEventListener("transitionend", _t411), _e495.addEventListener("transitioncancel", _t411), i ? (a.element.setAttribute("has-detail", ""), a.element.toggleDetailButton.removeAttribute("toggled"), a.element.toggleDetailButton.classList.remove("smart-animate"), setTimeout(function () {
            a.element.toggleDetailButton.classList.add("smart-animate"), a.element.toggleDetailButton.setAttribute("toggled", ""), a.element.setAttribute("show-detail", "");
          }), a.element.style.height = a.cellHeight + a.detailHeight + "px", a.grid._autoHeight && (a.grid.$.content.style.transition = "0.25s height ease-in-out", a.grid.$.content.style.height = parseInt(a.grid.$.content.style.height) + a.detailHeight + "px", a.grid.$.scrollView.style.height = "auto"), _e495.classList.remove("smart-hidden"), _e495.style.height !== a.detailHeight + "px" && (_e495.style.height = a.detailHeight + "px"), _e495.style.lineHeight !== a.detailHeight + "px" && (_e495.style.lineHeight = a.detailHeight + "px"), _e495.style.top !== a.cellHeight + "px" && (_e495.style.top = a.cellHeight + "px")) : (a.element.setAttribute("has-detail", ""), a.element.toggleDetailButton.removeAttribute("toggled"), a.grid._autoHeight && (a.grid.$.content.style.transition = "0.25s height ease-in-out", a.grid.$.content.style.height = parseInt(a.grid.$.content.style.height) - a.detailHeight + "px", a.grid.$.scrollView.style.height = "auto"), setTimeout(function () {
            a.element.style.height = a.cellHeight + "px", a.element.removeAttribute("show-detail");
          }));
        } else a.grid._refresh();
      }

      if ("allowCheck" === e && a.grid._recycle(), "checked" === e && (a.grid.checkBoxes.hasThreeStates && a.grid._hasThreeStates(a, a), a.grid._recycle()), "selected" === e) {
        if (i ? a.grid._selection.rows[a.id] = !0 : !1 === i && a.grid._selection.rows[a.id] && delete a.grid._selection.rows[a.id], !a.element) return;

        a.grid._recycle();
      }

      "visible" === e && a.grid.refresh(), "expanded" !== e || a.expandHeight || a.grid.refresh(), "height" !== e || a.expandHeight || a.cellHeight === i || (a.cellHeight = i, a.grid.refresh()), "freeze" === e && (!0 === i || "near" === i ? a.grid._frozenNearRows.push(a) : "far" === i ? a.grid._frozenFarRows.push(a) : (a.grid._frozenNearRows.splice(a.grid._frozenNearRows.indexOf(a), 1), a.grid._frozenFarRows.splice(a.grid._frozenFarRows.indexOf(a), 1)), a.grid._recycle());
    }
  }, {
    key: "properties",
    get: function get() {
      return ["allowToggle", "allowResize", "allowSelect", "allowCheck", "canNotify", "children", "checked", "cells", "detailHeight", "detailTemplate", "cellHeight", "expandHeight", "data", "enabled", "expanded", "filtered", "freeze", "grid", "headerCell", "height", "index", "id", "minHeight", "unbound", "selected", "showDetail", "visible", "parent", "leaf", "visibleIndex"];
    }
  }, {
    key: "cells",
    get: function get() {
      var e = this;
      return e._cells && e.grid && e._cells.length === e.grid.columns.length ? e._cells : (e.createCells(), e._cells);
    }
  }, {
    key: "viewCells",
    get: function get() {
      var e = this,
          t = [];

      for (var _a266 = 0; _a266 < e.grid.viewColumns.length; _a266++) {
        var _i422 = e.grid.viewColumns[_a266];

        if (!e["column_" + _i422.dataField]) {
          var _a267 = new Smart.Grid.Cell(e, _i422, e.grid);

          e["column_" + _i422.dataField] = _a267, t.push(_a267);
        } else {
          var _a268 = e["column_" + _i422.dataField];
          t.push(_a268);
        }
      }

      return e._viewCells = t, t;
    }
  }]);

  return _class48;
}()), Smart("smart-grid-row",
/*#__PURE__*/
function (_Smart$BaseElement7) {
  "use strict";

  _inherits(_class49, _Smart$BaseElement7);

  function _class49() {
    _classCallCheck(this, _class49);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class49).apply(this, arguments));
  }

  _createClass(_class49, [{
    key: "addThemeClass",
    value: function addThemeClass() {}
  }, {
    key: "addDefaultClass",
    value: function addDefaultClass() {}
  }, {
    key: "_initialize",
    value: function _initialize(e) {
      var t = this,
          i = e.grid,
          a = i._columnElements,
          n = i._frozenNearColumns,
          o = i._frozenFarColumns,
          r = document.createElement("div"),
          l = document.createElement("div"),
          s = document.createElement("div"),
          d = document.createDocumentFragment(),
          c = document.createDocumentFragment(),
          m = document.createDocumentFragment();
      l.classList.add("near", "smart-grid-cell-container"), r.classList.add("center", "smart-grid-cell-container"), s.classList.add("far", "smart-grid-cell-container"), t.row = e, e.createCells(), t.addEventListener("mouseenter", function () {
        if (!(i.isScrolling || i.editing.isEditing) && (t.commandBar && (t.commandBar.parentNode.removeChild(t.commandBar), t.commandBar = null), i.editing.enabled && i.editing.commandColumn.visible && i.editing.commandColumn.inline && !t.commandBar)) {
          var _e496 = document.createElement("div"),
              _a269 = i._getCommandColumnCommandsTemplate();

          _e496.classList.add("smart-grid-command-bar"), _e496.innerHTML = _a269, r.appendChild(_e496), requestAnimationFrame(function () {
            _e496.classList.add("show");
          }), i._updateCommandColumnCommandsVisibility(_e496, t.row), _e496.onmousedown = function (e) {
            var a = e.path;
            var n = null;

            for (var _t412 = 0; _t412 < a.length; _t412++) {
              if (a[_t412].classList.contains("smart-grid-command-item")) {
                n = a[_t412];
                break;
              }
            }

            if (!n, n) {
              var _a270 = n.getAttribute("command");

              i._applyCommand(_a270, [t.row]), t.commandBar && (t.commandBar.parentNode.removeChild(t.commandBar), t.commandBar = null), t.removeAttribute("hover"), e.stopPropagation(), e.preventDefault();
            }
          }, t.commandBar = _e496;
        }
      }), t.addEventListener("mouseleave", function () {
        i.isScrolling || i.editing.isEditing || t.commandBar && (t.commandBar.classList.remove("show"), t.commandBar.addEventListener("transitionend", function () {
          t.commandBar && (t.commandBar.parentNode.removeChild(t.commandBar), t.commandBar = null);
        }), t.commandBar.addEventListener("transitioncancel", function () {
          t.commandBar && (t.commandBar.parentNode.removeChild(t.commandBar), t.commandBar = null);
        }));
      });

      for (var _t413 = 0; _t413 < n.length; _t413++) {
        var _i423 = n[_t413],
            _a271 = e.getCell(_i423),
            _o130 = _a271.createElement();

        c.appendChild(_o130);
      }

      for (var _t414 = 0; _t414 < o.length; _t414++) {
        var _i424 = o[_t414],
            _a272 = e.getCell(_i424),
            _n208 = _a272.createElement();

        m.appendChild(_n208);
      }

      for (var _n209 = 0; _n209 < a.length; _n209++) {
        var _i425 = a[_n209],
            _o131 = _i425.column;
        if (!_i425.parentNode || !_o131) break;

        var _r86 = e.getCell(_o131),
            _l64 = _r86.createElement();

        _o131 && _o131._treeColumn && (t.toggleButton = _l64.toggleButton), d.appendChild(_l64);
      }

      l.appendChild(c), r.appendChild(d), s.appendChild(m);
      var u = document.createElement("div");
      u.classList.add("smart-grid-row-detail", "smart-hidden", "smart-animate");
      var p = document.createElement("div");
      p.classList.add("smart-grid-row-sub-container", "smart-hidden"), t._rowFragment = document.createDocumentFragment(), t._rowFragment.appendChild(l), t._rowFragment.appendChild(r), t._rowFragment.appendChild(s), t._rowFragment.appendChild(u), t._rowFragment.appendChild(p), t.appendChild(t._rowFragment), t.cellsNearContainerElement = t.children[0], t.cellsContainerElement = t.children[1], t.cellsFarContainerElement = t.children[2], t.rowDetail = t.children[3], t.rowContainer = t.children[4], i.layout.rowHeight && "auto" !== i.layout.rowHeight && (t.style.height = i.layout.rowHeight + "px");
    }
  }, {
    key: "_handleExpandCollapse",
    value: function _handleExpandCollapse(e, t) {
      var i = this,
          a = i.row,
          n = a.grid;
      if (!a.allowToggle) return null;
      n._toggledRow = a;
      var o = {
        row: a
      };
      t && (o.originalEvent = t.originalEvent), n.$.fireEvent(e ? "rowExpand" : "rowCollapse", o);

      var r = function r() {
        var e = n._toggledRow;
        n._refresh(), n._refreshRowHierarchy();
        var t = 0;

        for (var _e497 = 0; _e497 < n.rowHierarchy.length; _e497++) {
          var _i426 = n.rowHierarchy[_e497];

          for (var _e498 = _i426.parent; _e498;) {
            _e498.id === n._toggledRow.id && (t += _i426.height), _e498 = _e498.parent;
          }
        }

        var i = n._scrollView.scrollTop,
            a = n._contentHeight - (e.cellHeight + e.top - i);
        e.expandHeight = Math.min(a, t), e.height = e.cellHeight + e.expandHeight;
      },
          l = n.dataSource.virtualDataSourceOnExpand && e && !0 !== a.data._loaded;

      if (!n.appearance.allowRowToggleAnimation || l) n.rows.canNotify = !1, a.expanded = e, n.rows.canNotify = !0, l && (a.data._loaded = !0, a.data.expanded = e, n._virtualDataRequest("expand")), n._toggledRow = null, n._refresh(), l && n.appearance.allowRowToggleAnimation && (i.toggleButton.removeAttribute("toggled"), i.toggleButton.classList.remove("smart-animate"), setTimeout(function () {
        i.toggleButton.classList.add("smart-animate"), i.toggleButton.setAttribute("toggled", "");
      }, 50));else {
        var _t415 = function _t415(e) {
          e.height = e.cellHeight, n.$.content.style.transition = "", e.element.rowContainer.innerHTML = "", e.element.rowContainer.classList.add("smart-hidden"), e.element.rowContainer.removeEventListener("transitionend", _o132), e.element.rowContainer.removeEventListener("transitioncancel", _o132), e.element.rowContainer.style.height = "", e.element.rowContainer.style.transform = "", e.element.rowContainer.style.transition = "", e.element.rowContainer.classList.remove("smart-animate"), e.element.toggleButton.classList.remove("smart-animate"), n._refresh();
        },
            _o132 = function _o132(e) {
          var a = n._toggledRow;
          i._toggleTimer = null, n._toggledRow = null, a && ("transform" === e.propertyName || "height" === e.propertyName) && setTimeout(function () {
            _t415(a);
          }, 50);
        };

        if (i._toggleTimer) {
          clearTimeout(i._toggleTimer);
          var _e499 = n._toggledRow;
          n._toggledRow = null, _t415(_e499);
        }

        i._toggleTimer = setTimeout(function () {
          var t = function t() {
            r(), n._recycle(!1), i.style.overflow = "hidden", i.style.height = "auto", i.style.lineHeight = a.cellHeight + "px";
          };

          e ? (a.expanded = !0, t(), i.rowContainer.style.transform = "scaleY(0)", i.rowContainer.style.height = "0px", i.toggleButton.removeAttribute("toggled"), n._autoHeight && (n.$.content.style.height = parseInt(n.$.content.style.height) - a.expandHeight + "px"), setTimeout(function () {
            i.toggleButton.classList.add("smart-animate"), i.toggleButton.setAttribute("toggled", ""), i.rowContainer.addEventListener("transitionend", _o132), i.rowContainer.addEventListener("transitioncancel", _o132), n._autoHeight && (n.$.content.style.transition = "0.25s height ease-in-out", n.$.content.style.height = parseInt(n.$.content.style.height) + a.expandHeight + "px"), i.rowContainer.classList.add("smart-animate"), i.rowContainer.style.height = a.expandHeight + "px", i.rowContainer.style.transform = "scaleY(1)";
          })) : (t(), a.expanded = !1, i.rowContainer.style.transform = "scaleY(0)", i.rowContainer.style.height = "0px", n._autoHeight && (n.$.content.style.height = parseInt(n.$.content.style.height) - a.expandHeight + "px", n.$.content.style.transition = "", n.$.content.style.height = parseInt(n.$.content.style.height) + a.expandHeight + "px"), i.rowContainer.style.height = a.expandHeight + "px", i.rowContainer.style.transform = "scaleY(1)", i.toggleButton.setAttribute("toggled", ""), i.toggleButton.classList.add("smart-animate"), setTimeout(function () {
            i.toggleButton.removeAttribute("toggled", ""), n._autoHeight && (n.$.content.style.transition = "0.25s height ease-in-out", n.$.content.style.height = parseInt(n.$.content.style.height) - a.expandHeight + "px"), i.rowContainer.addEventListener("transitionend", _o132), i.rowContainer.addEventListener("transitioncancel", _o132), i.rowContainer.classList.add("smart-animate"), i.rowContainer.style.transform = "scaleY(0)", i.rowContainer.style.height = "0px";
          }, 0));
        }, 50);
      }
    }
  }, {
    key: "_renderAddNewRow",
    value: function _renderAddNewRow() {
      var e = this,
          t = e.row,
          i = t.grid,
          a = t.element,
          n = new Smart.Grid.Cell(t, i.columns[0], i);
      t.visible ? a.classList.remove("smart-hidden") : a.classList.add("smart-hidden"), a.innerHTML = "<smart-grid-cell><div>" + i.localize("addNewRow") + "</div></smart-grid-cell>", a.firstChild.firstChild.classList.add("align-center"), a.firstChild.classList.add("smart-grid-column-border-collapse"), a.firstChild.setAttribute("freeze", ""), a.firstChild.setAttribute("addNewRow", ""), a.firstChild.style.width = "100%", 0 < i._scrollView.vScrollBar.offsetWidth && (a.firstChild.style.width = "calc(100% - " + (-1 + i._scrollView.vScrollBar.offsetWidth) + "px)"), a.firstChild.cell = n, 0 < i._rowGap && t !== i.rows[i.rows.length - 1] ? (e.style.marginBottom = i._rowGap + "px", parseInt(e.style.height) - i._rowGap !== t.height && (e.style.height = t.height - i._rowGap + "px"), parseInt(e.style.lineHeight) - i._rowGap !== t.height && (e.style.lineHeight = t.height - i._rowGap + "px")) : (e.style.marginBottom = "", parseInt(e.style.height) !== t.height && (e.style.height = t.height + "px"), parseInt(e.style.lineHeight) !== t.height && (e.style.lineHeight = t.height + "px"));
    }
  }, {
    key: "_renderEmpty",
    value: function _renderEmpty() {
      var e = this;
      e.classList.add("smart-hidden");
    }
  }, {
    key: "_renderCell",
    value: function _renderCell(e, t, i) {
      if (!t) return void i.classList.add("smart-hidden");
      var a = e.getCell(t);
      a.element !== i && (a._styleChanged = !0), i.cell !== a && (i.cell.background !== a.background || i.cell.borderColor !== a.borderColor || i.cell.color !== a.color || i.cell.fontSize !== a.fontSize || i.cell.fontFamily !== a.fontFamily || i.cell.fontWeight !== a.fontWeight || i.cell.fontStyle !== a.fontStyle) && (a._styleChanged = !0), a.element = i, i.cell = a, a.render(), t && t.rowHeaderColumn && (e.header = i, i.setAttribute("data-id", e.id));
    }
  }, {
    key: "_alternate",
    value: function _alternate() {
      var e = this,
          t = e.row,
          i = t.grid,
          a = i.appearance.alternationStart,
          n = 0 < i.appearance.alternationEnd ? i.appearance.alternationEnd : 1 / 0;

      if (!(0 >= i.appearance.alternationCount) && (e.removeAttribute("alternation-index"), t.visibleIndex >= a && t.visibleIndex <= n)) {
        var _n210 = (t.visibleIndex - a) % i.appearance.alternationCount;

        e.setAttribute("alternation-index", _n210);
      }
    }
  }, {
    key: "_openRowDetailDialog",
    value: function _openRowDetailDialog(e) {
      var t = this,
          i = t.row.grid,
          a = t.row;
      if (!i.rowDetail.dialog.enabled || !a.showDetail) return !1;

      var n = i._dialogRowDetail || i._createDialog(i.rowDetail.dialog);

      if (i.rowDetail.dialog.visible && n.row !== a) return void (a.showDetail = !1);
      var o = "{{message}}" === i.rowDetail.dialog.header ? i.localize("dialogRowDetailHeader", {
        value: a.visibleIndex + 1
      }) : i.rowDetail.dialog.header;
      return i.rowDetail.dialog.visible && i.rowDetail.dialog.row === a && !a.showDetail ? void n.close() : void (n.header.innerHTML = o, n.content.innerHTML = "", n.content.style.width = "100%", n.content.style.height = "100%", n.row = a, n.querySelector(".smart-footer").classList.add("smart-hidden"), !i._dialogRowDetail && (n.setAttribute("tabindex", 0), n.modal = !0, n.btnConfirm.innerHTML = i.localize("dialogRowDetailButtonConfirm"), n.btnCancel.innerHTML = i.localize("dialogRowDetailButtonCancel"), n.btnCancel.classList.add("smart-hidden"), n.onOpen = function () {
        i.rowDetail.dialog.visible = !0;
      }, n.onClose = function () {
        i.rowDetail.dialog.visible = !1, n.row.showDetail = !1;
      }, n.btnCancel.onclick = function () {
        n.close();
      }, n.btnClose.onclick = function () {
        n.close();
      }, n.btnConfirm.onclick = function () {
        n.close();
      }, n.onkeydown = function (e) {
        "Escape" === e.key && n.close();
      }, i._dialogRowDetail = n), n.open(), setTimeout(function () {
        n.focus();
      }, 100), n.content.appendChild(e));
    }
  }, {
    key: "_renderDetail",
    value: function _renderDetail(e) {
      var t = this,
          i = t.row.grid,
          a = t.row;
      var n = a.id,
          o = a.detailTemplate || i.rowDetail.template;
      if (o.startsWith("#") && (o = document.querySelector(o)), a._detail) return e.firstChild === a._detail ? void (i.onRowDetailUpdated && i.onRowDetailUpdated(a.index, a, e.firstChild)) : (e.firstChild && e.removeChild(e.firstChild), e.appendChild(a._detail), void (i.onRowDetailUpdated && i.onRowDetailUpdated(a.index, a, e.firstChild)));

      if (o instanceof HTMLTemplateElement) {
        var _t416 = o.content.cloneNode(!0).firstElementChild;
        n = n.toString(), n = n.replace(/'/ig, "\\'"), n = n.replace(/"/ig, "\\\"");

        var _i427 = _t416.outerHTML.replace(/{{value}}/ig, n).replace(/{{id}}/ig, a.id);

        for (var _e500 in 0 <= _i427.indexOf("{{value=") && (n ? (_i427 = _i427.substring(0, _i427.indexOf("{{value=")) + n + _i427.substring(_i427.indexOf("}")), _i427 = _i427.replace(/}/ig, ""), _i427 = _i427.replace(/{/ig, "")) : (_i427 = _i427.replace(/{{value=/ig, ""), _i427 = _i427.replace(/}}/ig, ""))), _i427 = "<div>" + _i427 + "</div>", a.data) {
          _i427 = _i427.replace("{{" + _e500 + "}}", a.data[_e500]);
        }

        e.innerHTML !== _i427 && (e.innerHTML = _i427);
      } else {
        var _t417 = "<div>" + o.replace(/{{value}}/ig, n).replace(/{{id}}/ig, a.id) + "</div>";

        for (var _e501 in a.data) {
          _t417 = _t417.replace("{{" + _e501 + "}}", a.data[_e501]);
        }

        e.innerHTML !== _t417 && (e.innerHTML = _t417);
      }

      i.onRowDetailInit && i.onRowDetailInit(a.index, a, e.firstChild), i.rowDetail.dialog.enabled ? t._openRowDetailDialog(e.firstChild.firstElementChild) : a._detail = e.firstChild;
    }
  }, {
    key: "_render",
    value: function _render() {
      var e = this;
      var t = e.row,
          a = t.grid,
          i = t.getProperty("selected");
      if (!1 === i && e.hasAttribute("selected") ? e.removeAttribute("selected") : !0 === i ? e.setAttribute("selected", "") : null === i && e.setAttribute("selected", "indeterminate"), e.hasAttribute("unbound") && e.removeAttribute("unbound"), t.unbound && e.setAttribute("unbound", ""), e.removeAttribute("focus"), !a._toggledRow && e.classList.contains("smart-animate")) return e.classList.remove("smart-animate"), e.rowContainer.innerHTML = "", e.rowContainer.classList.add("smart-hidden"), a._refreshLayout(), void a._recycle();
      if (0 === a.columns.length) return void e._renderEmpty();
      if (t.addNewRow) return void e._renderAddNewRow();

      if (a._toggledRow && (t.id === a._toggledRow.id ? e.setAttribute("toggle", "") : e.hasAttribute("toggle") && e.removeAttribute("toggle")), a._toggledRow && a.appearance.allowRowToggleAnimation) {
        var _i428 = t.parent;

        if (!a._toggledRow.expanded && a._toggledRow.id === t.id) {
          var _t418 = e.rowContainer;

          for (var _e502 = 0; _e502 < _t418.children.length; _e502++) {
            var _i429 = _t418.children[_e502],
                _n211 = _i429.getAttribute("data-id"),
                _o133 = a.rowById[_n211];

            _i429.getAttribute("data-rendered") || (_i429.setAttribute("data-rendered", !0), _o133.element = _i429, _o133.render());
          }
        }

        for (; _i428;) {
          if (_i428.id === a._toggledRow.id) {
            var _n212 = _i428.element.rowContainer;

            if (a._toggledRow.expanded) {
              e.classList.add("smart-hidden");

              var _o134 = t.createElement(a);

              for (var _e503 = 0; _e503 < _n212.children.length; _e503++) {
                var _i430 = _n212.children[_e503];
                if (_i430.getAttribute("data-id") === t.id.toString()) return void (_o134 = _i430);
              }

              t.element = _o134, _n212.appendChild(_o134), _n212.classList.remove("smart-hidden"), _o134.row = t, e = _o134;
            }

            break;
          }

          _i428 = _i428.parent;
        }
      }

      e._alternate();

      var n = parseFloat(a.$.columnNearContainer.style.width),
          o = parseFloat(a.$.columnContainer.style.width),
          r = parseFloat(a.$.columnFarContainer.style.width),
          l = e.children[1],
          s = e.children[0],
          d = e.children[2];

      if (d.classList.remove("vscroll"), a.computedVerticalScrollBarVisibility && d.classList.add("vscroll"), e.hasAttribute("group") && e.removeAttribute("group"), e.hasAttribute("tree") && e.removeAttribute("tree"), e.hasAttribute("level") && e.removeAttribute("level"), e.hasAttribute("leaf") && e.removeAttribute("leaf"), e.hasAttribute("expanded") && e.removeAttribute("expanded"), e.hasAttribute("summary") && e.removeAttribute("summary"), e.hasAttribute("filter") && e.removeAttribute("filter"), null === t.filtered && e.setAttribute("filter", "indeterminate"), a.dataSource.groupBy && 0 < a.dataSource.groupBy.length ? (e.setAttribute("level", t.level), t.expanded && e.setAttribute("expanded", ""), void 0 !== t.label && t.level === a.dataSource.groupBy.length - 1 && e.setAttribute("leaf", ""), void 0 === t.label ? e.setAttribute("leaf", "") : e.setAttribute("group", ""), t.summaryRow && e.setAttribute("summary", ""), e.toggleButton && e.toggleButton.classList.remove("smart-hidden")) : a.dataSource.boundHierarchy ? (e.setAttribute("level", t.level), t.expanded && e.setAttribute("expanded", ""), t.leaf && e.setAttribute("leaf", ""), t.summaryRow && e.setAttribute("summary", ""), e.toggleButton && e.toggleButton.classList.remove("smart-hidden")) : (t.canNotify = !1, t.leaf = !0, t.expanded = !1, t.summaryRow = !1, t.level = 0, e.toggleButton && e.toggleButton.classList.add("smart-hidden"), t.canNotify = !0), e.setAttribute("data-id", t.id), e.visible = t.visible, e.cellsNearContainerElement.classList.remove("smart-visibility-hidden"), e.cellsContainerElement.classList.remove("smart-visibility-hidden"), e.cellsFarContainerElement.classList.remove("smart-visibility-hidden"), e.removeAttribute("rowspan"), 0 < a._rowGap && t !== a.rows[a.rows.length - 1] ? (e.style.marginBottom = a._rowGap + "px", parseInt(e.style.height) - a._rowGap !== t.height && (e.style.height = t.height - a._rowGap + "px"), parseInt(e.style.lineHeight) - a._rowGap !== t.height && (e.style.lineHeight = t.height - a._rowGap + "px")) : (e.style.marginBottom = "", parseInt(e.style.height) !== t.height && (e.style.height = t.height + "px"), parseInt(e.style.lineHeight) !== t.height && (e.style.lineHeight = t.height + "px")), l.style.left !== -a._scrollView.scrollLeft + "px" && (l.style.left = -a._scrollView.scrollLeft + "px"), a.rowDetail.enabled) {
        var _i431 = e.rowDetail;
        e.removeAttribute("show-detail"), t.showDetail ? (_i431.classList.remove("smart-hidden"), e.setAttribute("show-detail", ""), a.rowDetail.dialog.enabled ? _i431.classList.add("smart-hidden") : (_i431.style.height !== t.detailHeight + "px" && (_i431.style.height = t.detailHeight + "px"), _i431.style.lineHeight !== t.detailHeight + "px" && (_i431.style.lineHeight = t.detailHeight + "px"), _i431.style.top !== t.cellHeight + "px" && (_i431.style.top = t.cellHeight + "px")), e._renderDetail(_i431)) : _i431.classList.add("smart-hidden");
      } else if (e.rowDetail) {
        var _t419 = e.rowDetail;

        _t419.classList.add("smart-hidden");
      }

      s.classList.remove("smart-hidden"), d.classList.remove("smart-hidden"), s.style.width !== n + "px" && (s.style.width = n + "px"), l.style.width !== o + "px" && (l.style.width = o + "px"), d.style.width !== r + "px" && (d.style.width = r + "px"), s.style.height = t.cellHeight + "px", l.style.height = t.cellHeight + "px", d.style.height = t.cellHeight + "px", 0 === r && d.classList.add("smart-hidden"), 0 === n && s.classList.add("smart-hidden"), 0 < n && parseInt(n) === parseInt(a._autoGeneratedColumnsNearWidth), 0 < r && parseInt(r) === parseInt(a._autoGeneratedColumnsFarWidth) && d.classList.add("border-collapse");

      for (var _i432 = 0; _i432 < a._frozenNearColumns.length; _i432++) {
        var _n213 = a._frozenNearColumns[_i432];
        var _o135 = e.children[0].children[_i432];

        if (!_o135) {
          var _i433 = t.getCell(_n213);

          _o135 = _i433.createElement(), e.children[0].appendChild(_o135);
        }

        e._renderCell(t, _n213, _o135);
      }

      for (var _i434 = 0; _i434 < a._frozenFarColumns.length; _i434++) {
        var _n214 = a._frozenFarColumns[_i434];
        var _o136 = e.children[2].children[_i434];

        if (!_o136) {
          var _i435 = t.getCell(_n214);

          _o136 = _i435.createElement(), e.children[2].appendChild(_o136);
        }

        e._renderCell(t, _n214, _o136);
      }

      for (var _i436 = 0; _i436 < l.children.length; _i436++) {
        var _n215 = a._columnElements[_i436 + a._frozenNearColumns.length];

        if (!_n215) {
          var _a273 = e.children[1].children[_i436];

          e._renderCell(t, null, _a273);
        }
      }

      for (var _i437 = 0; _i437 < a._columnElements.length; _i437++) {
        var _n216 = a._columnElements[_i437],
            _o137 = _n216.column;

        if (!_n216.parentNode || !_o137) {
          if (_n216 && !_o137) {
            var _t420 = e.children[1].children[_i437];
            _t420 && _t420.classList.add("smart-visibility-hidden");
          }

          continue;
        }

        var _r87 = e.children[1].children[_i437];

        if (!_r87) {
          _n216.column || (_n216.column = _o137);

          var _i438 = t.getCell(_o137);

          _r87 = _i438.createElement(), e.children[1].appendChild(_r87);
        }

        if (_n216.classList.contains("smart-visibility-hidden")) {
          _r87.classList.add("smart-visibility-hidden");

          continue;
        } else _r87.classList.remove("smart-visibility-hidden");

        e._renderCell(t, _o137, _r87);
      }

      e.visible ? e.classList.remove("smart-hidden") : e.classList.add("smart-hidden");
    }
  }, {
    key: "template",
    value: function template() {
      return "";
    }
  }, {
    key: "isUtilityElement",
    get: function get() {
      return !0;
    }
  }, {
    key: "hasStyleObserver",
    get: function get() {
      return !1;
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {};
    }
  }]);

  return _class49;
}(Smart.BaseElement)), Smart.Utilities.Assign("Grid.Cell",
/*#__PURE__*/
function () {
  "use strict";

  function _class50(e, t) {
    _classCallCheck(this, _class50);

    var i = this;
    i.row = e, i.column = t, i.grid = e.grid, i.rowSpan = 1, i.colSpan = 1, i.value = void 0, i.fontSize = null, i.fontWeight = null, i.fontFamily = null, i.fontStyle = null, i.color = null, i.background = null, i.borderColor = null, i.tooltip = null, i.align = null, i.verticalAlign = null, i.readonly = !1, i.oldValue = void 0, i._updating = !1, i.styleChanged = !0, i.editor = null, i.template = null, i.isEditing = !1, i.canNotify = !0, i.selected = !1, i.focused = !1;
    var a = new Proxy(i, {
      deleteProperty: function deleteProperty(e, t) {
        return delete e[t], !0;
      },
      get: function get(e, t) {
        if ("value" === t) {
          var _e504 = i.column.displayField ? i.row.data[i.column.displayField] : i.row.data[i.column.dataField];

          return _e504;
        }

        if ("editor" === t || "template" === t) return e[t] || i.column[t];

        if ("focused" === t) {
          if (i.grid.selection.allowCellSelection && i.grid._selection.focusedCell && i.grid._selection.focusedCell.row.id === i.row.id && i.grid._selection.focusedCell.column.dataField === i.column.dataField) return !0;
          if (i.grid.selection.allowRowSelection && i.grid._selection.focusedCell && i.grid._selection.focusedCell.row.id === i.row.id && i.grid._selection.focusedCell.column.dataField === i.column.dataField) return !0;

          var _e505 = i.parent();

          return !!(_e505 && i.grid.selection.allowCellSelection && i.grid._selection.focusedCell && i.grid._selection.focusedCell.row.id === _e505.row.id && i.grid._selection.focusedCell.column.dataField === _e505.column.dataField);
        }

        if ("selected" === t) return !0 === i.row.getProperty("selected") || !0 === i.column.getProperty("selected") || !!i.grid._selection.cells["row" + i.row.id] && i.grid._selection.cells["row" + i.row.id][i.column.dataField];

        if ("modifiedValue" === t) {
          var _t421 = i.grid._cellsUpdatedValues[i.row.id + "_" + i.column.dataField];
          return void 0 === _t421 ? e.value : _t421;
        }

        return e[t];
      },
      set: function set(e, t, a) {
        var n = this.get(e, t);
        if (n === a) return !0;
        if (e[t] = a, "element" === t || "isEditing" === t || "oldValue" === t || "_updating" === t || "notifyFn" === t || t.startsWith("_") || "canNotify" === t) return !0;
        if ("focused" === t && (i.grid._selection.focusedCell = i), ("colSpan" === t || "rowSpan" === t) && 0 <= a && -1 === i.grid._cellsMerge.indexOf(i) && i.grid._cellsMerge.push(i), "row" === t || "column" === t || "grid" === t || "styleChanged" === t) return !0;

        if (("background" === t || "fontSize" === t || "fontWeight" === t || "fontFamily" === t || "color" === t || "borderColor" === t || "fontStyle" === t) && (i._styleChanged = !0), "value" === t) {
          void 0 === i.oldValue && (i.oldValue = n);

          (function () {
            i.grid.dataSource.boundSource.canNotify = !1, null !== a && a.label && a.value ? (i.row.data[i.column.displayField] = a.label, i.row.data[i.column.dataField] = a.value) : (i.column.valueField && (i.row.data[i.column.valueField] = a), i.row.data[i.column.dataField] = a);
            var e = i.grid.dataSource.dataItemById[i.row.id];

            if (e) {
              var _t422 = e.$.index;
              a !== i.grid.dataSource[_t422][i.column.dataField] && (i.grid.dataSource[_t422][i.column.dataField] = a);
            }

            i.grid.dataSource.boundSource.canNotify = !0;
          })();
        }

        return ("selected" === t && (i.grid._selection.cells["row" + i.row.id] && (delete i.grid._selection.cells["row" + i.row.id][i.column.dataField], 1 === Object.getOwnPropertyNames(i.grid._selection.cells["row" + i.row.id]).length && delete i.grid._selection.cells["row" + i.row.id]), i.grid._selection.cells["column" + i.column.dataField] && (delete i.grid._selection.cells["column" + i.column.dataField][i.row.id], 1 === Object.getOwnPropertyNames(i.grid._selection.cells["column" + i.column.dataField]).length && delete i.grid._selection.cells["column" + i.column.dataField]), a && (!i.grid._selection.cells["row" + i.row.id] && (i.grid._selection.cells["row" + i.row.id] = []), !i.grid._selection.cells["column" + i.column.dataField] && (i.grid._selection.cells["column" + i.column.dataField] = []), i.grid._selection.cells["row" + i.row.id][i.column.dataField] = !0, i.grid._selection.cells["column" + i.column.dataField][i.row.id] = !0)), i._updating || !i.canNotify) || !i.row.canNotify || (i.grid._recycle(), i.propertyChanged && i.propertyChanged(name.substring(1), n), !0);
      }
    });
    return a;
  }

  _createClass(_class50, [{
    key: "setStyle",
    value: function setStyle(e) {
      var t = this;
      t._styleChanged && (e.style.background = t.background, e.style.borderColor = t.borderColor, e.style.color = t.color, e.style.fontSize = t.fontSize, e.style.fontFamily = t.fontFamily, e.style.fontWeight = t.fontWeight, e.style.fontStyle = t.fontStyle, e.style.paddingBottom = "", t._styleChanged = !1);
    }
  }, {
    key: "getFormattedValue",
    value: function getFormattedValue(e, t) {
      var i = this;
      return void 0 === e || null === e || "" === e ? e : "date" === i.column.dataType || "datetime" === i.column.dataType || "time" === i.column.dataType ? i.formatDate(e, t) : "int" === i.column.dataType || "int64" === i.column.dataType || "float" === i.column.dataType || "number" === i.column.dataType ? i.formatNumber(e, t) : e;
    }
  }, {
    key: "formatDate",
    value: function formatDate(t, e) {
      if (!Smart.Utilities.DateTime) return t;
      var i = this,
          a = i.grid;

      if (i.column.formatSettings.Intl && i.column.formatSettings.Intl.DateTimeFormat) {
        var _e506 = new Intl.DateTimeFormat(this.grid.locale, i.column.formatSettings.Intl.DateTimeFormat).format(t);

        return _e506;
      }

      !e && i.column.formatSettings.dateFormat && (e = i.column.formatSettings.dateFormat);

      try {
        var _i439 = new Smart.Utilities.DateTime(t);

        return _i439.calendar.locale = a.locale, a.messages[a.locale] && a.messages[a.locale].calendar && (a.messages[a.locale].calendar.months && (_i439.calendar.months = a.messages[a.locale].calendar.months), a.messages[a.locale].calendar.days && (_i439.calendar.days = a.messages[a.locale].calendar.days), void 0 !== a.messages[a.locale].calendar.firstDay && (_i439.calendar.firstDay = a.messages[a.locale].calendar.firstDay), void 0 !== a.messages[a.locale].calendar.eras && (_i439.calendar.eras = a.messages[a.locale].calendar.eras), void 0 !== a.messages[a.locale].calendar.AM && (_i439.calendar.AM = a.messages[a.locale].calendar.AM), void 0 !== a.messages[a.locale].calendar.PM && (_i439.calendar.PM = a.messages[a.locale].calendar.PM), void 0 !== a.messages[a.locale].calendar["/"] && (_i439.calendar["/"] = a.messages[a.locale].calendar["/"]), void 0 !== a.messages[a.locale].calendar[":"] && (_i439.calendar[":"] = a.messages[a.locale].calendar[":"])), _i439.toString(e);
      } catch (i) {
        return t;
      }
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(e, t) {
      if (!Smart.Utilities.NumberRenderer) return e;
      var i = this,
          a = i.grid;

      if (i.column.formatSettings.Intl && i.column.formatSettings.Intl.NumberFormat) {
        var _t423 = new Intl.NumberFormat(this.grid.locale, i.column.formatSettings.Intl.NumberFormat).format(e);

        return _t423;
      }

      var n = new Smart.Utilities.NumberRenderer();

      if (n.localizationObject) {
        var _e507 = i.column.formatSettings,
            _t424 = a.messages[a.locale] ? a.messages[a.locale].calendar : {};

        _e507.decimalPlaces && (n.localizationObject.decimalPlaces = _e507.decimalPlaces), (_e507.decimalSeparator || _t424.decimalSeparator) && (n.localizationObject.decimalSeparator = _e507.decimalSeparator || _t424.decimalSeparator), (_e507.thousandsSeparator || _t424.thousandsSeparator) && (n.localizationObject.thousandsSeparator = _e507.thousandsSeparator || _t424.thousandsSeparator), n.localizationObject.currencysymbol = _t424.currencySymbol, n.localizationObject.currencysymbolposition = _t424.currencySymbolPosition, _e507.prefix && (n.localizationObject.currencysymbol = _e507.prefix), _e507.sufix && (n.localizationObject.currencysymbol = _e507.sufix, n.localizationObject.currencysymbolposition = "after");
      }

      var o = n.formatNumber(e, t);
      return void 0 === o ? e : 0 > e && a.appearance.formatSettings.negativeWithBrackets ? "(" + o + ")" : o;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var e = this;

      if (e.element) {
        var _t425 = e.element.firstChild;
        e.setStyle(_t425);
      }
    }
  }, {
    key: "setProperties",
    value: function setProperties(e) {
      var t = this;

      for (var _i440 in t._updating = !0, e) {
        t[_i440] = e[_i440];
      }

      t._updating = !1, t.grid._recycle();
    }
  }, {
    key: "createElement",
    value: function createElement() {
      var e = this,
          t = document.createElement("smart-grid-cell");
      return e.element = t, t._initialize(e), t;
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.element && e.element._render();
    }
  }, {
    key: "parent",
    value: function parent(e) {
      var t = this,
          a = t.row,
          n = t.column.dataField,
          o = t.grid;
      if (!o._cellsMerge.length) return null;
      if (t.__parentCells && void 0 !== t.__parentCells["row" + a.id + "_column_" + n]) return t.__parentCells["row" + a.id + "_column_" + n];
      var i = o.getVisibleRows();
      o.paging.enabled && "page" === o.selection.selectAllMode && (i = i.slice(o.paging.pageIndex * o.paging.pageSize, (o.paging.pageIndex + 1) * o.paging.pageSize)), t.__parentCells || (t.__parentCells = []);

      for (var _r88 = 0; _r88 < o._cellsMerge.length; _r88++) {
        var _l65 = o._cellsMerge[_r88];
        var _s52 = [],
            d = [];

        if (_s52.push(_l65.row), 1 < _l65.rowSpan) {
          var _e508 = i.indexOf(_l65.row);

          if (0 <= _e508) for (var _t426 = _e508; _t426 < _e508 + _l65.rowSpan; _t426++) {
            i[_t426] && -1 === _s52.indexOf(i[_t426]) && _s52.push(i[_t426]);
          }
        }

        if (d.push(_l65.column.dataField), 1 < _l65.colSpan) {
          var _e509 = o.columns.indexOf(o.columnByDataField[_l65.column.dataField]);

          for (var _t427 = _e509; _t427 < _e509 + _l65.colSpan; _t427++) {
            o.columns[_t427] && -1 === d.indexOf(o.columns[_t427].dataField) && d.push(o.columns[_t427].dataField);
          }
        }

        if (0 <= _s52.indexOf(a) && 0 <= d.indexOf(n)) {
          if (e) {
            var _e510 = {
              cell: _l65.row.getCell(_l65.column.dataField),
              rows: _s52,
              columns: d,
              row: _l65.row,
              column: _l65.column,
              endRow: _s52[_s52.length - 1],
              endColumn: o.columnByDataField[d[d.length - 1]]
            };
            return t.__parentCells["row" + a.id + "_column_" + n] = _e510, _e510;
          }

          var _i441 = _l65.row.getCell(_l65.column.dataField);

          return t.__parentCells["row" + a.id + "_column_" + n] = _i441, _i441;
        }
      }

      return t.__parentCells["row" + a.id + "_column_" + n] = null, null;
    }
  }]);

  return _class50;
}()), Smart("smart-grid-cell",
/*#__PURE__*/
function (_Smart$BaseElement8) {
  "use strict";

  _inherits(_class51, _Smart$BaseElement8);

  function _class51() {
    _classCallCheck(this, _class51);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class51).apply(this, arguments));
  }

  _createClass(_class51, [{
    key: "addThemeClass",
    value: function addThemeClass() {}
  }, {
    key: "addDefaultClass",
    value: function addDefaultClass() {}
  }, {
    key: "_initialize",
    value: function _initialize(e) {
      var t = this,
          i = document.createElement("div"),
          a = e.column,
          n = e.row,
          o = e.grid;
      t.cell = e, t.appendChild(i);
      var r = !1;

      if (a && a._treeColumn && o.dataSource.boundHierarchy && (r = !0, !o.grouping.enabled && o.dataSource.groupBy && 0 < o.dataSource.groupBy.length && (r = !1)), r) {
        var _e511 = document.createElement("div"),
            _a274 = document.createElement("button"),
            _r89 = document.createElement("div"),
            _l66 = document.createElement("div"),
            _s53 = document.createElement("div"),
            d = document.createElement("span");

        return n.expanded ? _a274.setAttribute("toggled", "") : _a274.removeAttribute("toggled", ""), t.toggleButton = _a274, t.checkbox = _s53, i.appendChild(_e511), i.appendChild(_l66), _l66.setAttribute("content", ""), _e511.setAttribute("indent", ""), _r89.setAttribute("label", ""), _a274.setAttribute("toggle-button", ""), _s53.setAttribute("checkbox", ""), t.setAttribute("has-toggle-button", ""), _l66.appendChild(_a274), _l66.appendChild(_s53), d.classList.add("smart-input"), _s53.appendChild(d), o.checkBoxes.visible ? d.classList.remove("smart-hidden") : d.classList.add("smart-hidden"), _l66.appendChild(_r89), void (t.content = _r89);
      } else {
        var _e512 = document.createElement("div");

        i.appendChild(_e512);
      }

      t.content = i;
    }
  }, {
    key: "_renderCommands",
    value: function _renderCommands() {
      var e = this,
          t = e.cell.grid;
      if (t.__cellsCommandTemplate) return e.firstChild.innerHTML = t.__cellsCommandTemplate, void t._updateCommandColumnCommandsVisibility(e.firstChild, e.cell.row);

      var i = t._getCommandColumnCommandsTemplate();

      e.firstChild.innerHTML = i, t._updateCommandColumnCommandsVisibility(e.firstChild, e.cell.row), t.__cellsCommandTemplate = i;
    }
  }, {
    key: "_renderGroupCell",
    value: function _renderGroupCell() {
      var e = this,
          t = e.cell.grid,
          a = e.cell.column,
          n = e.cell.row;
      _toConsumableArray(e.attributes).forEach(function (t) {
        return e.removeAttribute(t.name);
      }), e.style.width !== a.computedWidth + "px" && (e.style.width = a.computedWidth + "px"), e.style.left !== a.left + "px" && (e.style.left = a.left + "px"), e.classList.contains("smart-hidden") && e.classList.remove("smart-hidden");
      var i = n.label;

      if (void 0 !== n.label) {
        var _o138 = "";

        if (t.grouping.summaryRow.visible) {
          var _e513 = function _e513(t, a, n) {
            for (var _o139 = 0; _o139 < a.length; _o139++) {
              var _i443 = a[_o139];
              (void 0 !== _i443[t] && n.push(_i443), !_i443.summaryRow) && (_i443.children ? _e513(t, _i443.children, n) : _i443.data && _i443.data.children && _e513(t, _i443.children, n));
            }

            return n;
          },
              _i442 = _e513(a.dataField, n.summaryRow ? n.parent.data.children : n.data.children, []),
              _r90 = {},
              _l67 = a._treeColumn ? 0 < a.summary.length ? a.summary : ["count"] : a.summary;

          _r90[a.dataField] = _l67;

          var _s54 = 0 < _l67.length ? t.dataSource.summarize([_r90], _i442) : null;

          if (_s54) for (var _e514 = 0; _e514 < _l67.length; _e514++) {
            var _i444 = _l67[_e514];
            _o138 += "<span summary>" + t.localize(_i444, {
              value: _s54[a.dataField][_i444]
            }), +"</span>";
          }
        }

        a._treeColumn ? (i = n.summaryRow ? "<div header><span group></span><span value></span></div>" : "<div header><span group>" + t.columnByDataField[n.groupDataField].label + "</span><span value>" + n.label + "</span></div>", _o138 && (i += "<div summary>", i += _o138, i += "</div>"), e.setAttribute("has-toggle-button", "")) : (i = "<div content><div label><div header><span group></span><span value></span></div>", _o138 && (i += "<div summary>", i += _o138, i += "</div>"), i += "</div></div>");
      }

      var o = e.firstChild;

      if (t.dataSource.boundHierarchy && e.toggleButton) {
        var _r91 = o.children[0],
            _l68 = o.children[1].children[0],
            _s55 = o.children[1].children[1].firstChild,
            d = o.children[1].children[2];
        _r91.setAttribute("indent", ""), n.checked ? _s55.setAttribute("checked", "") : !1 === n.checked ? _s55.removeAttribute("checked") : null === n.checked && _s55.setAttribute("checked", "indeterminate"), n.leaf ? _l68.classList.add("smart-visibility-hidden") : (_l68.classList.remove("smart-visibility-hidden"), n.expanded ? _l68.setAttribute("toggled", "") : _l68.removeAttribute("toggled", ""));
        var c = "";
        if (a._treeColumn ? e.toggleButton.classList.remove("smart-hidden") : e.toggleButton.classList.add("smart-hidden"), a._treeColumn) if (t.grouping.enabled && 0 < t.dataSource.groupBy.length) {
          var _e515 = n.level;
          void 0 === n.label && _e515--, c += "<div style=\"width: " + (1 + _e515) * t.grouping.groupIndent + "px;\"></div>";
        } else for (var _e516 = 0; _e516 < n.level; _e516++) {
          c += "<div class='smart-indent'></div>";
        }
        void 0 === n.label ? _l68.classList.add("smart-hidden") : (_l68.classList.remove("smart-hidden"), _l68.style.marginLeft = "", a._treeColumn && t.grouping.enabled && 0 < t.grouping.toggleButtonIndent && (_l68.style.marginLeft = n.level * (t.grouping.toggleButtonIndent - t.grouping.groupIndent) + "px")), _r91.innerHTML = c, d.innerHTML = i, t.appearance.showTooltips ? d.setAttribute("title", n.label ? n.label : i) : d.hasAttribute("title") && d.removeAttribute("title");
      } else void 0 !== n.label && t.grouping.enabled && !e.toggleButton && (o.innerHTML = i);

      if (t.grouping.enabled && t.dataSource.groupBy && 0 < t.dataSource.groupBy.length) {
        var _i445 = t.grouping.groupIndent * (1 + n.level);

        a.dataField === t.columns[t.columns.length - 1].dataField && (e.style.width = a.computedWidth - _i445 + "px", t.appearance.showColumnLines && o.firstChild.classList.add("smart-grid-column-border"));
      }

      if ("smart-label" !== o.className && (o.className = "smart-label"), a.formatFunction) {
        var _t428 = {
          row: n,
          column: a,
          cell: e.cell,
          value: null,
          template: null,
          group: {
            value: i,
            template: null
          }
        };
        a.formatFunction(_t428), _t428.group.value !== i && (o.innerHTML = _t428.group.value), null !== _t428.group.template && (o.innerHTML = _t428.group.template);
      }
    }
  }, {
    key: "_render",
    value: function _render() {
      var e = this,
          t = e.cell.grid,
          i = e.cell.column,
          a = e.cell.row,
          n = a.data,
          o = a._isMeasureRow ? null : i.cellsFormat;
      if (t.grouping.enabled && 0 < t.dataSource.groupBy.length && void 0 !== a.label) return void e._renderGroupCell();
      if (t.grouping.enabled && 0 < t.dataSource.groupBy.length && e.toggleButton && (e.toggleButton.classList.remove("smart-hidden"), e.toggleButton.classList.remove("smart-visibility-hidden"), e.toggleButton.style.marginLeft = "", i._treeColumn && t.grouping.enabled && 0 < t.grouping.toggleButtonIndent && (e.toggleButton.style.marginLeft = a.level * (t.grouping.toggleButtonIndent - t.grouping.groupIndent) + "px")), !i.visible) return void (e.style.width = "0px");
      t.appearance.showSortColumnBackground ? i.sorted ? e.setAttribute("sort", "") : e.removeAttribute("sort") : i.sorted && e.hasAttribute("sort") && e.removeAttribute("sort"), t.appearance.showFilterColumnBackground ? i.filtered ? e.setAttribute("filter", "") : e.removeAttribute("filter") : i.filtered && e.hasAttribute("filter") && e.removeAttribute("filter");
      var r = i.displayField ? n[i.displayField] : n[i.dataField];

      if (t.editing.batch) {
        if (t._cellsUpdatedValues) {
          e.removeAttribute("update");
          var _n217 = t._cellsUpdatedValues[a.id + "_" + i.dataField];
          void 0 !== _n217 && (e.setAttribute("update", ""), r = _n217);
        }

        t._rowsDeleted && (0 <= t._rowsDeleted.indexOf(a) ? e.setAttribute("delete", "") : e.removeAttribute("delete")), t._rowsAdded && (0 <= t._rowsAdded.indexOf(a.id) ? e.setAttribute("add", "") : e.removeAttribute("add"));
      }

      t.onCellValue && !(i.rowHeaderColumn || i.selectionColumn) && (e.cell._updating = !0, t.onCellValue(e.cell), e.cell._updating = !1, r = e.cell.value), void 0 === r && (r = "");
      var l = r;
      o && (l = e.cell.getFormattedValue(r, o));
      var s = e.firstChild;
      (t.onCellRender || i.onCellRender) && requestAnimationFrame(function () {
        if (i._cellsCachedValues || (i._cellsCachedValues = []), i._cellsCachedValues[a.index]) {
          var _e517 = i._cellsCachedValues[a.index];
          s.firstChild && s.removeChild(s.firstChild), s.appendChild(_e517);
        } else if (t.onCellRender ? t.onCellRender(e.cell) : i.onCellRender(e.cell), e.cell.template !== i.template) {
          var _t429 = document.createElement("div");

          return s.firstChild && s.removeChild(s.firstChild), e.cell.template instanceof HTMLTemplateElement ? _t429.appendChild(e.cell.template.cloneNode(!0)) : _t429.appendChild(e.cell.template), s.appendChild(_t429), void (i._cellsCachedValues[a.index] = _t429);
        }
      }), i.autoGenerated || e.setAttribute("data-field", i.dataField), e.cell.focused ? (t.selection.allowCellSelection && e.setAttribute("focus", ""), a.element.setAttribute("focus", "")) : e.removeAttribute("focus"), e.cell.selected ? e.setAttribute("selected", "") : e.removeAttribute("selected"), t.rowDetail.enabled && a.showDetail && (e.style.height = a.cellHeight + "px", e.style.lineHeight = a.cellHeight + "px"), a.expanded && 0 < a.expandHeight && (e.style.height = a.cellHeight + "px", e.style.lineHeight = a.cellHeight + "px");

      var d = e._getCellAlignment(a, i),
          c = "" !== e.cell.template && t.isInitialized;

      var m = "";

      if (d.align && (m += d.align + " "), d.verticalAlign && (m += d.verticalAlign + " "), i.cellsWrap && (m += "wrap "), m += "smart-label", e.style.width !== i.computedWidth + "px") {
        var _a275 = t._isLastVisibleColumn(i);

        e.style.width = i.autoGenerated || _a275 ? i.computedWidth + "px" : i.computedWidth - t._columnGap + "px";
      }

      if (t.grouping.enabled && t.dataSource.groupBy && 0 < t.dataSource.groupBy.length) {
        var _n218 = t.grouping.groupIndent * (1 + a.level);

        i.dataField === t.columns[t.columns.length - 1].dataField && (e.style.width = i.computedWidth - _n218 + t.grouping.groupIndent + "px", t.appearance.showColumnLines && e.classList.add("smart-grid-column-border"));
      }

      i === t._firstVisibleColumn ? e.classList.add("smart-grid-column-border-collapse") : e.classList.remove("smart-grid-column-border-collapse"), 0 < t._columnGap && t.appearance.showColumnLines && e.classList.add("smart-grid-column-border"), 0 < t._rowGap && e.classList.add("smart-grid-row-border"), t.appearance.showColumnLines ? e.classList.remove("smart-grid-vertical-border-collapse") : e.classList.add("smart-grid-vertical-border-collapse"), t.appearance.showRowLines ? e.classList.remove("smart-grid-horizontal-border-collapse") : e.classList.add("smart-grid-horizontal-border-collapse");
      var u = i.left;

      if (e.style.left !== u + "px" && (e.style.left = u + "px"), e.classList.contains("smart-hidden") && e.classList.remove("smart-hidden"), e.hasAttribute("template") && e.removeAttribute("template"), e.hasAttribute("freeze") && e.removeAttribute("freeze"), e.hasAttribute("detail") && e.removeAttribute("detail"), a.filterRow ? e.classList.add("smart-grid-filter-row-cell") : a.summaryRow ? e.classList.add("smart-grid-summary-row-cell") : (i.freeze || a.freeze) && (i.selectionColumn && (e.setAttribute("checkbox", ""), m += " smart-input", i.grid.selection.checkBoxes.enabled && i.grid.selection.checkBoxes.autoShow ? e.setAttribute("auto-show", "") : e.removeAttribute("auto-show")), (i.rowHeaderColumn || i.selectionColumn) && e.setAttribute("header", ""), i.rowDetailColumn && (e.setAttribute("header", ""), e.setAttribute("detail", ""), e.setAttribute("has-toggle-button", "")), i.commandColumn && e.setAttribute("command", ""), t.appearance.showFrozenColumnBackground && i.freeze && e.setAttribute("freeze", ""), t.appearance.showFrozenRowBackground && a.freeze && e.setAttribute("freeze", "")), i.cellsRotationAngle) {
        var _t430 = e._rotateCellContent(s, i, r);

        if (!_t430) return;
      } else if (a.filterRow) i.toggleColumn || i.rowHeaderColumn ? s.innerHTML = "" : !i.filterEditorInitialized && (i.filterEditorInitialized = !0);else if (a.summaryRow) {
        if (i.toggleColumn || i.rowHeaderColumn) s.innerHTML = "";else if (0 < i.summary.length && t._summaryItems) {
          var _e518 = t._summaryItems[i.dataField];
          var _n219 = 0;

          for (var _i446 in _e518) {
            _n219 === a.summaryRowIndex && (s.innerHTML = t.localize(_i446, {
              value: _e518[_i446]
            })), _n219++;
          }
        }
      } else if (t.rowDetail.enabled && i.rowDetailColumn) "" !== s.innerHTML && (s.innerHTML = a.showDetail ? "<button class=\"smart-animate\" toggled toggle-button></button>" : "<button class=\"smart-animate\" toggle-button></button>", a.element.toggleDetailButton = e.querySelector("button"));else if (i.commandColumn) e._renderCommands();else if (t.appearance.showRowHeaderNumber && i.rowHeaderColumn) {
        if (a.addNewRow) s.textContent = "";else {
          var _i447 = function _i447(i) {
            if (e.cell.value) return e.cell.value;
            if ("number" === t.appearance.autoGenerateRowLabelMode) return i.visibleIndex + 1;else {
              var _e519 = i.visibleIndex % 26,
                  _t431 = Math.floor(i.visibleIndex / 26),
                  _a276 = String.fromCharCode(65 + _e519);

              var _n220 = "";

              for (var _e520 = 0; _e520 < _t431; _e520++) {
                _n220 += "A";
              }

              var _o140 = _n220 + _a276;

              return _o140;
            }
          };

          s.textContent = t._rowsAdded ? 0 <= t._rowsAdded.indexOf(a.id) ? "" : _i447(a) : _i447(a);
        }
      } else if (c) switch (e.removeAttribute("readonly"), e.cell.template) {
        case "checkBox":
        case "switchButton":
        case "radioButton":
          "" !== s.textContent && (s.textContent = ""), (!t.editing.enabled || !i.allowEdit || e.cell.readonly || t.editing.enabled && t.editing.commandColumn.visible && t.editing.editRow !== e.cell.row) && e.setAttribute("readonly", ""), "<span class=\"smart-input\"></span>" !== s.innerHTML && (s.innerHTML = "<span class=\"smart-input\"></span>"), r ? s.firstChild.setAttribute("checked", "") : null === r ? s.firstChild.setAttribute("checked", "indeterminate") : s.firstChild.removeAttribute("checked"), e.setAttribute("template", e.cell.template);
          break;

        default:
          {
            var _t432 = null;

            if (e.setAttribute("template", ""), "function" == typeof e.cell.template) {
              var _t433 = {
                row: a,
                column: i,
                cell: e.cell,
                oldValue: e.cell.oldValue,
                value: r,
                template: null
              };

              var _n221 = s.querySelector(".smart-grid-cell-template");

              if (_n221 && _n221.getAttribute("column") === i.dataField ? _t433.template = _n221.firstElementChild : _n221 = null, e.formattedValue !== l && (_n221 = null), _n221 || e.cell.template(_t433), _n221 || !_t433.template) _n221 || null !== _t433.template || (s.innerHTML = r);else if (_t433.template instanceof HTMLElement) {
                var _e521 = document.createElement("div");

                _e521.classList.add("smart-grid-cell-template"), _e521.setAttribute("column", i.dataField), s.appendChild(_e521), _e521.appendChild(_t433.template);
              } else s.innerHTML = "<div column=\"" + i.dataField + "\" class=\"smart-grid-cell-template\">" + _t433.template + "</div>";
              e.cell._styleChanged && e.cell.setStyle(s), void 0 === e.cell.oldValue && (e.cell.oldValue = r), e.formattedValue = l;
            } else if ("" !== s.textContent && (s.textContent = ""), e.cell.template.startsWith("#") && (_t432 = document.querySelector(e.cell.template)), _t432) {
              var _e522 = _t432.content.cloneNode(!0).firstElementChild;

              r = r.toString(), r = r.replace(/'/ig, "\\'"), r = r.replace(/"/ig, "\\\"");

              var _i448 = _e522.outerHTML.replace(/{{value}}/ig, r).replace(/{{id}}/ig, a.id);

              0 <= _i448.indexOf("{{value=") && (r ? (_i448 = _i448.substring(0, _i448.indexOf("{{value=")) + r + _i448.substring(_i448.indexOf("}")), _i448 = _i448.replace(/}/ig, ""), _i448 = _i448.replace(/{/ig, "")) : (_i448 = _i448.replace(/{{value=/ig, ""), _i448 = _i448.replace(/}}/ig, ""))), s.innerHTML !== _i448 && (s.innerHTML = _i448);
            } else {
              var _t434 = e.cell.template.replace(/{{value}}/ig, r).replace(/{{id}}/ig, a.id);

              s.innerHTML !== _t434 && (s.innerHTML = _t434);
            }
          }
      } else if (i.selectionColumn) "checkBox" === t.selectionMode && (a.getProperty("selected") ? e.setAttribute("selected", "") : e.getAttribute("selected") && e.removeAttribute("selected"));else {
        var _n222 = s.firstChild;

        if (_n222 && _n222.classList && e.toggleButton) {
          var _e523 = s.children[0],
              _n223 = s.children[1].children[0],
              _o141 = s.children[1].children[1].firstChild,
              _r92 = s.children[1].children[2];
          var _d29 = "";

          if (i._treeColumn) {
            if (t.grouping.enabled) {
              var _e524 = a.level - 1;

              _d29 += "<div style=\"width: " + (1 + _e524) * t.grouping.groupIndent + "px;\"></div>";
            } else for (var _e525 = 0; _e525 < a.level; _e525++) {
              _d29 += "<div class='smart-indent'></div>";
            }

            a.checked ? _o141.setAttribute("checked", "") : !1 === a.checked ? _o141.removeAttribute("checked") : null === a.checked && _o141.setAttribute("checked", "indeterminate"), a.leaf ? a.allowCheck ? _o141.classList.remove("smart-visibility-hidden") : _o141.classList.add("smart-visibility-hidden") : a.allowCheck ? _o141.classList.remove("smart-hidden") : _o141.classList.add("smart-hidden");
          }

          a.allowCheck ? t.checkBoxes.visible ? _o141.classList.remove("smart-hidden") : _o141.classList.add("smart-hidden") : !t.checkBoxes.visible && _o141.classList.add("smart-hidden"), _e523.innerHTML = _d29, _n223.classList.add("smart-visibility-hidden"), a.leaf ? _n223.classList.add("smart-visibility-hidden") : (_n223.classList.remove("smart-visibility-hidden"), a.expanded ? _n223.setAttribute("toggled", "") : _n223.removeAttribute("toggled", "")), a.data.isEmpty && _n223.classList.add("smart-visibility-hidden"), _r92.innerHTML = l, t.appearance.showTooltips ? _r92.setAttribute("title", l) : _r92.hasAttribute("title") && _r92.removeAttribute("title");
        } else {
          var _n224 = a["column_" + i.dataField];

          if (e.getAttribute("rowspan") && (e.removeAttribute("rowspan"), e.style.height = ""), e.getAttribute("colspan") && e.removeAttribute("colspan"), _n224) {
            if (1 < _n224.colSpan) {
              var _a277 = t.columns.indexOf(i);

              var _o142 = 0;

              for (var _e526 = _a277; _e526 < _a277 + _n224.colSpan; _e526++) {
                var _i449 = t.columns[_e526];
                _i449 && _i449.visible && (_o142 += _i449.computedWidth);
              }

              e.style.width = _o142 + "px", e.setAttribute("colspan", ""), _n224._styleChanged = !0;
            }

            if (1 < _n224.rowSpan) {
              var _i450 = t.rows.indexOf(a);

              var _o143 = 0;
              a.element.setAttribute("rowspan", "");

              for (var _e527 = _i450; _e527 <= _i450 + _n224.rowSpan - 1; _e527++) {
                var _i451 = t.rows[_e527];
                _i451 && _i451.visible && _i451.filtered && (_o143 += _i451.cellHeight);
              }

              e.style.height = _o143 + "px", e.setAttribute("rowspan", ""), _n224._styleChanged = !0;
            }

            (1 === _n224.colSpan && e.hasAttribute("colspan") || e.hasAttribute("rowspan") && 1 === _n224.rowSpan) && (e.style.height = "", e.style.width = "", e.removeAttribute("colspan"), e.removeAttribute("rowspan"), _n224._styleChanged = !0), s.textContent === l || i.formatFunction || (s.textContent = l), _n224.setStyle(s), t.appearance.showTooltips ? s.setAttribute("title", _n224.tooltip || l) : s.hasAttribute("title") && s.removeAttribute("title");
          } else s.textContent = l;
        }
      }

      if (s.className !== m && (s.className = m), i.formatFunction && !a.data.isEmpty && t.isInitialized) {
        var _t435 = {
          row: a,
          column: i,
          cell: e.cell,
          oldValue: e.cell.oldValue,
          value: r,
          formattedValue: l,
          template: null
        };
        e.cell.canNotify = !1, a.canNotify = !1;

        var _n225 = Object.assign({}, {
          background: e.cell.background,
          borderColor: e.cell.borderColor,
          color: e.cell.color,
          fontSize: e.cell.fontSize,
          fontFamily: e.cell.fontFamily,
          fontWeight: e.cell.fontWeight,
          fontStyle: e.cell.fontStyle
        });

        i.formatFunction(_t435), (s.style.background !== _n225.background || s.style.borderColor !== _n225.borderColor || s.style.color !== _n225.color || s.style.fontSize !== _n225.fontSize || s.style.fontWeight !== _n225.fontWeight || s.style.fontStyle !== _n225.fontStyle) && (e.cell._styleChanged = !0, e.cell.setStyle(s)), (e.cell.background !== _n225.background || e.cell.borderColor !== _n225.borderColor || e.cell.color !== _n225.color || e.cell.fontSize !== _n225.fontSize || e.cell.fontWeight !== _n225.fontWeight || e.cell.fontStyle !== _n225.fontStyle) && (e.cell._styleChanged = !0, e.cell.setStyle(s));

        var _o144 = !0;

        if (_t435.value !== r) {
          if (e.toggleButton) {
            var _e528 = s.children[1].children[2];
            _e528.innerHTML = _t435.value;
          } else s.innerHTML = _t435.value;

          _o144 = !1;
        }

        if (null !== _t435.template) {
          if (e.toggleButton) {
            var _e529 = s.children[1].children[2];
            _e529.innerHTML !== _t435.template && (_e529.innerHTML = _t435.template);
          } else if (s.innerHTML !== _t435.template) {
            var _e530 = document.createElement("div");

            _e530.innerHTML = _t435.template, _e530.innerHTML !== s.innerHTML && (s.innerHTML = _t435.template);
          }

          _o144 = !1;
        }

        _o144 && (s.textContent = r), e.cell.canNotify = !0, a.canNotify = !0;
      }
    }
  }, {
    key: "_rotateCellContent",
    value: function _rotateCellContent(e, t, i) {
      var a = this,
          n = document.createElement("span");
      return e.innerHTML = "", n.innerHTML = i, e.appendChild(n), n.className = "rotate", n.style.transform = "rotate(" + t.cellsRotationAngle + "deg)", a.grid._recycleRotate(e, n, t.cellsAlign, t.cellsVerticalAlign, i);
    }
  }, {
    key: "_getCellAlignment",
    value: function _getCellAlignment(e, t) {
      var i = e["column_" + t.dataField],
          a = i ? i.align || t.cellsAlign : t.cellsAlign,
          n = i ? i.verticalAlign || t.cellsVerticalAlign : t.cellsVerticalAlign,
          o = {
        align: "",
        verticalAlign: ""
      };
      return "left" === a ? o.align = "align-left" : "center" === a || "middle" === a ? o.align = "align-center" : "right" === a ? o.align = "align-right" : void 0, "top" === n ? o.verticalAlign = "align-top" : "center" === n || "middle" === n ? o.verticalAlign = "align-middle" : "bottom" === n ? o.verticalAlign = "align-bottom" : void 0, o;
    }
  }, {
    key: "template",
    value: function template() {
      return "";
    }
  }, {
    key: "hasStyleObserver",
    get: function get() {
      return !1;
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }, {
    key: "isUtilityElement",
    get: function get() {
      return !0;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {};
    }
  }]);

  return _class51;
}(Smart.BaseElement)), Smart.Utilities.Assign("Grid.Resize",
/*#__PURE__*/
function () {
  "use strict";

  function _class52() {
    _classCallCheck(this, _class52);
  }

  _createClass(_class52, [{
    key: "autoSizeRows",
    value: function autoSizeRows(e) {
      var t = this,
          a = e ? e : t._recyclingRows;
      t.rows.canNotify = !1;

      for (var _n226 = 0; _n226 < a.length; _n226++) {
        var _e531 = a[_n226];
        _e531.element = t._rowElements[1], _e531.grid = t;

        var _i452 = _e531._autoSize(_e531);

        _e531.cellHeight !== _i452 && (_e531.cellHeight = _i452), _e531.height = _i452;
      }

      t.rows.canNotify = !0, t.refresh();
    }
  }, {
    key: "autoSizeColumns",
    value: function autoSizeColumns(e, t) {
      var i = this,
          a = t ? t : i.columns;
      var n = [];

      if (!e) {
        var _e532 = i._recyclingRows;

        for (var _t436 = 0; _t436 < _e532.length; _t436++) {
          var _i453 = _e532[_t436];

          for (var _e533 = 0; _e533 < a.length; _e533++) {
            var _t437 = a[_e533],
                _o145 = _i453.getCell(_t437.dataField);

            n[_t437.dataField] || (n[_t437.dataField] = _t437.label), _o145.value && _o145.value.toString().length > n[_t437.dataField].length && (n[_t437.dataField] = _o145.value);
          }
        }
      }

      var o = [];

      for (var _i454 = 0; _i454 < a.length; _i454++) {
        var _e534 = a[_i454],
            _t438 = n[_e534.dataField] ? n[_e534.dataField] : _e534.label;

        o.push(_t438);
      }

      var r = a[0]._measureSize(o);

      i.columns.canNotify = !1;

      for (var _i455 = 0; _i455 < a.length; _i455++) {
        var _e535 = a[_i455];
        _e535.width = r[_i455];
      }

      i.columns.canNotify = !0, i.refresh();
    }
  }, {
    key: "_doubleClickHandler",
    value: function _doubleClickHandler(e) {
      var t = this;

      if ("none" !== t.behavior.rowResizeMode || "none" !== t.behavior.columnResizeMode) {
        var _i456 = !!t._downTime && 300 > new Date() - t._downTime;

        if (_i456) {
          var _a278 = (t.enableShadowDOM ? t.shadowRoot : t.getRootNode()).elementsFromPoint(e.clientX, e.clientY);

          var _i457 = null,
              _n227 = null,
              _o146 = null,
              _r93 = null;

          for (var _e536 = 0; _e536 < _a278.length; _e536++) {
            var _t439 = _a278[_e536];

            if (_t439.getAttribute("data-field")) {
              _i457 = _t439.getAttribute("data-field"), _n227 = _t439;
              break;
            }

            if (_t439.getAttribute("data-id")) {
              _o146 = _t439.getAttribute("data-id"), _r93 = _t439;
              break;
            }
          }

          var _l69 = t.columnByDataField[_i457],
              _s56 = t.rowById[_o146];

          if (t.appearance.allowColumnAutoSizeOnDoubleClick && _l69 && _l69.allowResize && "none" !== t.behavior.columnResizeMode) {
            var _t440 = _n227.getBoundingClientRect().right;

            _t440 - 10 <= e.clientX && e.clientX <= _t440 + 10 && _l69.autoSize();
          }

          if (t.appearance.allowRowAutoSizeOnDoubleClick && _s56 && _s56.allowResize && "none" !== t.behavior.rowResizeMode) {
            var _t441 = _r93.getBoundingClientRect().bottom;

            _t441 - 10 <= e.clientY && e.clientY <= _t441 + 10 && (_s56.computedHeight = null, _s56.autoSize());
          }
        }

        t._downTime = new Date();
      }
    }
  }, {
    key: "_endResize",
    value: function _endResize() {
      var e = this;
      e._overlay && (e._overlay.parentNode.removeChild(e._overlay), e._overlay = null);
      var t = e.getBoundingRect(e);

      if (e.classList.remove("smart-grid-resize-mode"), e.$.root.classList.remove("smart-grid-resize-mode"), e.classList.remove("smart-grid-row-resize-mode"), e.classList.remove("smart-grid-column-resize-mode"), e._rowToResize && e._rowResizeStartLine && e._rowResizeLine) {
        var _t442 = e.rowById[e._rowToResizeId],
            _i458 = _t442.cellHeight + parseFloat(e._rowResizeLine.style.top) - parseFloat(e._rowResizeStartLine.style.top),
            _a279 = _t442.cellHeight;

        if (e.rows.canNotify = !1, _t442.height = null, "split" === e.behavior.rowResizeMode) {
          var _a280 = e._nextRow(_t442),
              _n228 = parseInt(_t442.height - _i458 + _t442.cellHeight);

          _t442.computedHeight = _i458, _a280.computedHeight = parseInt(_a280.height) + _n228, _a280.height = null;
        } else _t442.computedHeight = _i458;

        return e.rows.canNotify = !0, e._rowResizeStartLine.parentNode.removeChild(e._rowResizeStartLine), e._rowResizeLine.parentNode.removeChild(e._rowResizeLine), e.appearance.showResizeTooltips && e._rowResizeTooltip.parentNode.removeChild(e._rowResizeTooltip), e._rowToResize.header && (e._rowToResize.header.style.cursor = ""), e._rowResizeLine = null, e._rowToResize = null, e._rowToResizeId = null, e.refresh(), void e.$.fireEvent("rowResize", {
          row: _t442,
          oldHeight: _a279,
          height: _i458
        });
      }

      if (!e._columnToResizeElement || !e._columnResizeLine) return;
      var i = e.columnByDataField[e._columnToResizeDataField],
          a = e._columnToResizeRect,
          n = t.left + parseInt(e._columnResizeLine.style.left) - a.left + e.scrollLeft,
          o = i.width;

      if (e.columns.canNotify = !1, "split" === e.behavior.columnResizeMode) {
        var _t443 = e._nextColumn(i),
            _a281 = parseInt(i.computedWidth - n);

        i.width = n, _t443.width = parseInt(_t443.computedWidth) + _a281;
      } else i.width = n;

      e.columns.canNotify = !0, e._columnResizeLine.parentNode.removeChild(e._columnResizeLine), e._columnResizeLine = null, e._columnResizeStartLine.parentNode.removeChild(e._columnResizeStartLine), e._columnResizeTooltip.parentNode && e._columnResizeTooltip.parentNode.removeChild(e._columnResizeTooltip), e._columnResizeStartLine = null, e._columnToResizeElement.style.cursor = "", e._columnToResizeElement.sortButton.style.cursor = "", e._columnToResizeElement.filterButton.style.cursor = "", e._columnToResizeElement = null, e._columnToResizeRect = null, e._columnToResizeDataField = null, e._columnResizeTooltip = null, e.refresh(), e.$.fireEvent("columnResize", {
        column: i,
        oldWidth: o,
        width: n
      });
    }
  }, {
    key: "_columnDownResizeHandler",
    value: function _columnDownResizeHandler() {
      var e = this,
          t = e._columnToResizeRect,
          i = e.getBoundingRect(e.$.columnHeader),
          a = function a() {
        var e = document.createElement("div");
        return e.classList.add("smart-grid-resize-line"), e.style.left = -i.left + t.right + "px", e.style.top = -i.top + t.top + "px", e.style.height = "calc(100% - " + e.style.top + ")", e.style.cursor = "col-resize", e;
      },
          n = document.createElement("div");

      n.classList.add("smart-grid-resize-tooltip"), e._columnResizeTooltip = n, e._columnResizeTooltip.style.left = -i.left + t.right + "px", e._columnResizeTooltip.innerHTML = e.localize("columnResizeTooltip", {
        value: t.width
      }), e._columnResizeLine = a(), e._columnResizeStartLine = a(), "growAndShrink" === e.behavior.columnResizeMode && (e.classList.add("smart-grid-resize-mode"), e.classList.add("smart-grid-column-resize-mode"), e.$.root.classList.add("smart-grid-resize-mode")), e.appearance.showResizeTooltips && e.$.root.appendChild(e._columnResizeTooltip), e.$.root.appendChild(e._columnResizeLine), e.$.root.appendChild(e._columnResizeStartLine), e._overlay = document.createElement("div"), e._overlay.classList.add("smart-grid-overlay"), e._overlay.style.cursor = "col-resize", e.$.root.appendChild(e._overlay);
    }
  }, {
    key: "_columnMoveResizeHandler",
    value: function _columnMoveResizeHandler(e) {
      var t = this,
          i = 5,
          a = function a(e) {
        var i = t._columnToResizeRect,
            a = e.left + parseFloat(t._columnResizeLine.style.left) - i.left + t.scrollLeft;
        t.appearance.showResizeTooltips && (t._columnResizeTooltip.innerHTML = t.localize("columnResizeTooltip", {
          value: parseInt(a)
        }));
      };

      if (t._columnResizeLine) {
        var _i459 = t.columnByDataField[t._columnToResizeDataField],
            _n229 = t._columnToResizeRect,
            _o147 = _i459.minWidth,
            _r94 = _i459.maxWidth,
            _l70 = t._nextColumn(_i459),
            _s57 = t.getBoundingRect(t);

        if (e.pageX < _s57.left) return;
        if ("split" === t.behavior.columnResizeMode && _l70 && e.pageX >= _s57.left + _l70.left + _l70.computedWidth - _l70.minWidth - t.scrollLeft) return t._columnResizeLine.style.left = -_s57.left + _s57.left + _l70.computedWidth + _l70.left - _l70.minWidth - t.scrollLeft + "px", void a(_s57);
        if (_n229.left + _o147 - t.scrollLeft >= e.pageX) return t._columnResizeLine.style.left = -_s57.left + _n229.left + _o147 - t.scrollLeft + "px", void a(_s57);
        if (_n229.left + _r94 - t.scrollLeft <= e.pageX) return t._columnResizeLine.style.left = -_s57.left + _n229.left + _r94 - t.scrollLeft + "px", void a(_s57);
        t._columnResizeLine.style.left = -_s57.left + e.pageX + "px", a(_s57);
      } else {
        var _t444 = this,
            _a282 = (_t444.enableShadowDOM ? _t444.shadowRoot : _t444.getRootNode()).elementsFromPoint(e.clientX, e.clientY);

        var _n230 = null,
            _o148 = null;
        if (_t444._columnResizeLine) return;

        for (var _e537 = 0; _e537 < _a282.length; _e537++) {
          var _t445 = _a282[_e537];

          if (_t445.hasAttribute("data-field") && _t445.hasAttribute("header")) {
            _n230 = _t445.getAttribute("data-field"), _o148 = _t445;
            break;
          }
        }

        if (_t444._columnToResizeElement && (_t444._columnToResizeElement.style.cursor = "", _t444._columnToResizeElement.sortButton.style.cursor = "", _t444._columnToResizeElement.filterButton.style.cursor = "", _t444._columnToResizeElement = null), _n230) {
          var _a283 = _o148.getBoundingClientRect().right;

          if (_o148.style.cursor = "", _o148.sortButton.style.cursor = "", _o148.filterButton.style.cursor = "", _a283 - i <= e.clientX && e.clientX <= _a283 + i) {
            var _e538 = _t444.columnByDataField[_n230];
            if (!_e538 || _e538 && !_e538.allowResize) return;

            var _i460 = _t444._isLastVisibleColumn(_e538);

            if ("split" === _t444.behavior.columnResizeMode && _i460) return;
            _o148.style.cursor = "col-resize", _o148.sortButton.style.cursor = "col-resize", _o148.filterButton.style.cursor = "col-resize", _t444._columnToResizeRect = _t444.getBoundingRect(_o148), _t444._columnToResizeElement = _o148, _t444._columnToResizeDataField = _n230;
          }
        }
      }
    }
  }, {
    key: "_rowMoveResizeHandler",
    value: function _rowMoveResizeHandler(e) {
      var t = this,
          a = (t.enableShadowDOM ? t.shadowRoot : t.getRootNode()).elementsFromPoint(e.clientX, e.clientY),
          i = 5;
      var n = null,
          o = null;

      if (t._rowResizeLine) {
        var _a284 = t._offsetTop(t.$.scrollView),
            _n231 = {
          top: _a284,
          bottom: t.$.scrollView.offsetHeight + _a284
        };

        if (e.pageY <= _n231.top) return;
        if (e.pageY >= _n231.bottom) return;

        var _o149 = function _o149() {
          var e = _r95.cellHeight + parseFloat(t._rowResizeLine.style.top) - parseFloat(t._rowResizeStartLine.style.top);
          t.appearance.showResizeTooltips && (t._rowResizeTooltip.innerHTML = t.localize("rowResizeTooltip", {
            value: parseInt(e)
          }));
        },
            _r95 = t.rowById[t._rowToResizeId],
            _l71 = t._nextRow(_r95),
            _s58 = t._rowToResizeBounds,
            d = _r95.minHeight,
            c = _r95.maxHeight;

        return "split" === t.behavior.rowResizeMode && _l71 && _s58.bottom + _l71.height - _l71.minHeight <= e.pageY ? (t._rowResizeLine.style.top = _s58.bottom + _l71.height - _l71.minHeight - _a284 + "px", void _o149()) : _s58.top + d + i >= e.pageY ? (t._rowResizeLine.style.top = _s58.top + d + i - _a284 + "px", void _o149()) : _s58.top + c >= e.pageY - _a284 ? (t._rowResizeLine.style.top = _s58.top + c + i - _a284 + "px", void _o149()) : (t._rowResizeLine.style.top = -_a284 + e.pageY - 1 + "px", void _o149());
      }

      for (var _t446 = 0; _t446 < a.length; _t446++) {
        var _e539 = a[_t446];

        if (_e539.hasAttribute("data-id") && _e539.hasAttribute("header")) {
          o = _e539, n = _e539.getAttribute("data-id");
          break;
        }
      }

      if (t._rowToResize && (t._rowToResize.style.cursor = "", t._rowToResize = null), null !== n) {
        var _a285 = t._offsetTop(o) + o.offsetHeight;

        if (o.style.cursor = "", _a285 - i <= e.clientY && e.clientY <= _a285 + i) {
          var _e540 = t.rowById[n];
          if (!_e540 || _e540 && !_e540.allowResize) return;
          _e540.header && (_e540.header.style.cursor = "row-resize");

          var _i461 = t._offsetTop(o);

          t._rowToResizeBounds = {
            top: _i461,
            bottom: o.offsetHeight + _i461,
            height: o.offsetHeight
          }, t._rowToResize = o, t._rowToResizeId = n;
        }
      }
    }
  }, {
    key: "_rowDownResizeHandler",
    value: function _rowDownResizeHandler() {
      var e = this,
          t = e._rowToResizeBounds,
          i = function i() {
        var i = document.createElement("div");
        return i.classList.add("smart-grid-resize-line", "row"), i.style.width = e.$.scrollView.offsetWidth - e._rowToResize.offsetLeft + "px", i.style.left = "0px", i.style.top = -e._offsetTop(e.$.scrollView) + t.bottom + "px", i.style.cursor = "row-resize", i;
      },
          a = document.createElement("div");

      a.classList.add("smart-grid-resize-tooltip"), e._rowResizeTooltip = a, e._rowResizeTooltip.style.top = -e._offsetTop(e.$.scrollView) + t.bottom + "px", e._rowResizeTooltip.innerHTML = e.localize("rowResizeTooltip", {
        value: t.height
      }), e._rowResizeTooltip.style.right = "20px", e._rowResizeTooltip.style.bottom = "initial", "growAndShrink" === e.behavior.rowResizeMode && (e.classList.add("smart-grid-resize-mode"), e.classList.add("smart-grid-row-resize-mode"), e.$.root.classList.add("smart-grid-resize-mode")), e._rowResizeLine = i(), e._rowResizeStartLine = i(), e._overlay = document.createElement("div"), e._overlay.classList.add("smart-grid-overlay"), e._overlay.style.cursor = "row-resize", e.$.root.appendChild(e._overlay), e.$.scrollView.appendChild(e._rowResizeLine), e.$.scrollView.appendChild(e._rowResizeStartLine), e.appearance.showResizeTooltips && e.$.scrollView.appendChild(e._rowResizeTooltip);
    }
  }, {
    key: "_rowResizeHandler",
    value: function _rowResizeHandler(e) {
      var t = this;
      var i = e.clientX,
          a = e.clientY;
      (i === void 0 || a === void 0) && (i = e.touches[0].clientX, a = e.touches[0].clientY);
      var n = (t.enableShadowDOM ? t.shadowRoot : t.getRootNode()).elementsFromPoint(i, a);
      var o = null;

      for (var _t447 = 0; _t447 < n.length; _t447++) {
        var _e541 = n[_t447];
        _e541.getAttribute("data-id") && (o = _e541.getAttribute("data-id"));
      }

      if (null !== o && t._rowToResize && !t._rowResizeLine) return void t._rowDownResizeHandler(e);
    }
  }]);

  return _class52;
}()), Smart.Utilities.Assign("Grid.Menu",
/*#__PURE__*/
function () {
  "use strict";

  function _class53() {
    _classCallCheck(this, _class53);
  }

  _createClass(_class53, [{
    key: "_openColumnChooserMenu",
    value: function _openColumnChooserMenu(e) {
      var t = this;
      if (e || (e = t._commandColumn), !e || t.menu && t.menu.column === e && e.element.hasAttribute("aria-controls")) return void t.closeMenu();
      t.menu || (t.menu = document.createElement("div"), t.menu.classList.add("smart-grid-column-menu"), t.menu.id = t.id + "_" + t.tagName.toLowerCase() + "_menu_" + Math.floor(65536 * (1 + Math.random())).toString(16).substring(1)), t.appearance.allowColumnMenuAnimation ? t.menu.classList.add("smart-animate") : t.menu.classList.remove("smart-animate"), t._createColumnChooserMenuItems(e), t.menu.style.height = t.columnMenu.height ? t.columnMenu.height + "px" : "auto", t.menu.column && t.menu.column !== e && (t.menu.column.setProperty("menu", null), t.menu.column = null), document.body.appendChild(t.menu), e.setProperty("menu", t.menu);
      var i = e.element.getBoundingClientRect();
      t.menu.column = e;
      var a = i.right - e.element.actionButton.getBoundingClientRect().width + window.pageXOffset,
          n = i.bottom + window.pageYOffset;
      a + t.menu.offsetWidth > window.innerWidth && (a = i.right + window.pageXOffset - t.menu.offsetWidth, a + t.menu.offsetWidth > window.innerWidth && (a = window.innerWidth - t.menu.offsetWidth)), t.menu.style.left = a + "px", t.menu.style.top = n + "px", t.menu.classList.remove("smart-hidden"), t.menu.classList.add("open");
    }
  }, {
    key: "_openMenu",
    value: function _openMenu(e) {
      var t = this;
      if (!e || t.menu && t.menu.column === e && e.element.hasAttribute("aria-controls") || !1 === t.columnMenu.enabled) return void t.closeMenu();
      t.menu || (t.menu = document.createElement("div"), t.menu.classList.add("smart-grid-column-menu"), t.menu.id = t.id + "_" + t.tagName.toLowerCase() + "_menu_" + Math.floor(65536 * (1 + Math.random())).toString(16).substring(1)), t.appearance.allowColumnMenuAnimation ? t.menu.classList.add("smart-animate") : t.menu.classList.remove("smart-animate"), t._createMenuItems(e), t._createFilterPanel(e), t._filterMenuItemsVisibility(e), t.menu.style.height = t.columnMenu.height ? t.columnMenu.height + "px" : "auto", t.menu.column && t.menu.column !== e && (t.menu.column.setProperty("menu", null), t.menu.column = null), document.body.appendChild(t.menu), e.setProperty("menu", t.menu);
      var i = e.element.getBoundingClientRect();
      t.menu.column = e;
      var a = i.right - e.element.actionButton.getBoundingClientRect().width + window.pageXOffset,
          n = i.bottom + window.pageYOffset;
      a + t.menu.offsetWidth > window.innerWidth && (a = i.right + window.pageXOffset - t.menu.offsetWidth, a + t.menu.offsetWidth > window.innerWidth && (a = window.innerWidth - t.menu.offsetWidth)), t.menu.style.left = a + "px", t.menu.style.top = n + "px", t.hasColumnMenu(e) ? t.menu.classList.remove("smart-hidden") : t.closeMenu(), t.menu.classList.add("open");
    }
  }, {
    key: "_menuItemClick",
    value: function _menuItemClick(e) {
      var t = this,
          i = e.detail,
          a = i.value;

      if (a && a.properties) {
        var _e542 = a.properties.command;
        "function" == typeof _e542 ? _e542.apply(t, [a.column]) : t[_e542] && t[_e542].apply(t, [a.column]), a.column.autoCloseMenu && t.closeMenu();
      }
    }
  }, {
    key: "removeGroupByCommand",
    value: function removeGroupByCommand(e) {
      var t = this;
      t.removeGroup(e.dataField);
    }
  }, {
    key: "groupByCommand",
    value: function groupByCommand(e) {
      var t = this;
      t.dataSource && t.addGroup(e.dataField);
    }
  }, {
    key: "sortAscCommand",
    value: function sortAscCommand(e) {
      var t = this;
      t.sortBy(e.dataField, "asc");
    }
  }, {
    key: "sortDescCommand",
    value: function sortDescCommand(e) {
      var t = this;
      t.sortBy(e.dataField, "desc");
    }
  }, {
    key: "removeSortCommand",
    value: function removeSortCommand(e) {
      var t = this;
      t.sortBy(e.dataField, null);
    }
  }, {
    key: "_removeMenu",
    value: function _removeMenu() {
      var e = this,
          t = e.menu.querySelector("smart-menu");
      t && e.menu.removeChild(t);
    }
  }, {
    key: "_createColumnChooserMenuItems",
    value: function _createColumnChooserMenuItems() {
      var e = this;

      e._removeMenu();

      var t = document.createElement("smart-menu"),
          a = document.createDocumentFragment();
      t.mode = "vertical", t.dropDownAppendTo = "body", t.checkboxes = !0, t.checkable = !0, t.classList.add("smart-grid-column-chooser-menu");

      for (var _t448 = 0; _t448 < e.columns.length; _t448++) {
        var _i462 = e.columns[_t448],
            _n232 = document.createElement("smart-menu-item"),
            _o150 = _i462.showIcon ? _i462.icon : _i462.visible ? "smart-icon-eye" : "smart-icon-eye-off";

        (_n232.checked = _i462.visible, !!_i462.allowHide) && (_i462.command = function (e) {
          e.visible = !e.visible;
        }, _n232.label = e.localize(_i462.label) || _i462.label || _i462.dataField, _n232.value = {
          column: _i462,
          properties: _i462
        }, _o150 && (_n232.label = "<span class=\"smart-grid-icon " + _o150 + "\"></span>" + _n232.label), a.appendChild(_n232));
      }

      t.appendChild(a), e.menu.appendChild(t), e.menu.itemCheckChange = e._menuItemClick.bind(e), e.menu.addEventListener("itemCheckChange", e.menu.itemCheckChange), e.menu.addEventListener("keydown", e._keyDownHandler.bind(e));
    }
  }, {
    key: "_createMenuItems",
    value: function _createMenuItems(e) {
      var t = this;

      t._removeMenu();

      var i = document.createElement("smart-menu"),
          a = document.createDocumentFragment(),
          n = e.menuItems || t.columnMenu.dataSource;

      for (var _o151 in i.mode = "vertical", i.dropDownAppendTo = "body", n) {
        var _i463 = n[_o151],
            _r96 = document.createElement("smart-menu-item");

        var _l72 = _i463.icon;
        _r96.label = t.localize(_o151), _r96.value = {
          column: e,
          properties: _i463
        };

        var _s59 = function _s59(t) {
          if (t) {
            if ("string" === e.dataType) return "A \u2192 Z";
            if ("number" === e.dataType || "date" === e.dataType || "time" === e.dataType) return "1 \u2192 9";
            if ("bool" === e.dataType || "boolean" === e.dataType) return "0 \u2192 1";
          } else {
            if ("string" === e.dataType) return "Z \u2192 A";
            if ("number" === e.dataType || "date" === e.dataType || "time" === e.dataType) return "9 \u2192 1";
            if ("bool" === e.dataType || "boolean" === e.dataType) return "1 \u2192 0";
          }
        };

        "columnMenuItemSortAsc" == _o151 ? (_r96.label = t.localize(_o151, {
          mode: _s59(!0)
        }), "string" !== e.dataType && _i463.iconAlt && (_l72 = _i463.iconAlt)) : "columnMenuItemSortDesc" == _o151 && (_r96.label = t.localize(_o151, {
          mode: _s59(!1)
        }), "string" !== e.dataType && _i463.iconAlt && (_l72 = _i463.iconAlt)), _l72 && (_r96.label = "<span class=\"smart-grid-icon " + _l72 + "\"></span>" + _r96.label), a.appendChild(_r96);
      }

      i.appendChild(a), t._filterContainer ? t.menu.insertBefore(i, t._filterContainer) : t.menu.appendChild(i), t.menu.itemClick = t._menuItemClick.bind(t), t.menu.addEventListener("itemClick", t.menu.itemClick), t.menu.addEventListener("keydown", t._keyDownHandler.bind(t));
    }
  }, {
    key: "_getFilterType",
    value: function _getFilterType(e) {
      var t = e.dataType.endsWith("?") ? e.dataType.substring(0, e.dataType.length - 1) : e.dataType;
      var i = "string";
      return "number" === t || "int" === t || "float" === t || "int64" === t ? i = "numeric" : "bool" === t || "boolean" === t ? i = "bool" : "date" === t || "time" === t || "datetime" === t ? i = "date" : "any" === t ? i = "any" : void 0, i;
    }
  }, {
    key: "_createFilterPanel",
    value: function _createFilterPanel(e) {
      var t = this;
      if (Smart.FilterPanel) if (t.filtering.enabled && t.filtering.filterMenu.visible && e.allowFilter) {
        var _i464 = t._getFilterType(e);

        if (t._filterPanel && t._filterPanel.parentNode.removeChild(t._filterPanel), t._filterPanel = t._filterPanels[_i464], t._filterPanel.dataField = e.dataField, !t._filterContainer) {
          var _e543 = document.createElement("div");

          _e543.classList.add("smart-filter-container"), t._filterContainer = _e543, requestAnimationFrame(function () {
            t.menu.appendChild(_e543);
          }), t._applyFilterHandler = function () {
            t.addFilter(t._filterPanel.dataField, t._filterPanel.getFilter());
            var e = t.columnByDataField[t._filterPanel.dataField];
            e._filterState = t._filterPanel.getState();
          }, t._clearFilterHandler = function () {
            requestAnimationFrame(function () {
              t.removeFilter(t._filterPanel.dataField);
              var e = t.columnByDataField[t._filterPanel.dataField];
              e._filterState = null;
            });
          };
        }

        if (t._filterContainer.appendChild(t._filterPanel), t._filterPanel.classList.remove("smart-hidden"), t._filterPanel.removeEventListener("filter", t._applyFilterHandler), t._filterPanel.removeEventListener("clear", t._clearFilterHandler), t._filterPanel.addEventListener("filter", t._applyFilterHandler), t._filterPanel.addEventListener("clear", t._clearFilterHandler), "none" !== e.filterMenuMode && t.filtering.filterMenu.visible && Smart.FilterPanel ? t._filterContainer.classList.remove("smart-hidden") : t._filterContainer.classList.add("smart-hidden"), t._filterPanel.reset(), e._filterState) t._filterPanel.loadState(e._filterState);else if (e.filter) {
          var _i465 = e.filter,
              _a286 = t._getFilterType(e);

          var _n233 = _i465.getFilters();

          for (; 0 < _n233.length && "FilterGroup" === _n233[0].type;) {
            _n233 = _n233[0].value;
          }

          var _o152 = _i465.getConditions(_a286),
              _r97 = 0 < _n233.length ? _o152.indexOf(_n233[0].condition) : -1,
              _l73 = 1 < _n233.length ? _o152.indexOf(_n233[1].condition) : -1,
              _s60 = 0 < _n233.length ? _n233[0].value : "",
              d = 1 < _n233.length ? _n233[1].value : "",
              c = 1 < _n233.length ? ["and", "or"].indexOf(_n233[1].logicalOperator) : 0;

          e._filterState = {
            firstFilterComparison: _r97,
            firstFilterValue: _s60,
            logicalOperator: c,
            secondFilterComparison: _l73,
            secondFilterValue: d
          }, t._filterPanel.loadState(e._filterState);
        }
      } else t._filterPanel && (t._filterPanel.parentNode.removeChild(t._filterPanel), e._filterState = null);
    }
  }, {
    key: "hasColumnMenu",
    value: function hasColumnMenu(e) {
      var t = this;
      if (!1 === t.columnMenu.enabled) return !1;
      var i = e.menuItems || t.columnMenu.dataSource;
      var a = 0,
          n = 0;

      for (var _o153 in i) {
        var _r98 = i[_o153];
        n++, !1 === _r98.visible ? a++ : "auto" === _r98.visible && (("columnMenuItemFilter" == _o153 || "columnMenuItemRemoveFilter" == _o153) && (t.filtering.filterMenu.visible || t.filtering.filterBuilder.visible) && a++, ("columnMenuItemGroupBy" == _o153 || "columnMenuItemRemoveGroupBy" == _o153) && (!e.allowGroup || !t.grouping.enabled) && a++, "columnMenuItemFilter" == _o153 && !e.allowFilter && a++, "columnMenuItemRemoveFilter" == _o153 && !e.allowFilter && a++, "columnMenuItemGroupBy" == _o153 && !e.allowGroup && a++, ("columnMenuItemSortAsc" == _o153 || "columnMenuItemSortDesc" == _o153 || "columnMenuItemRemoveSort" == _o153) && (!e.allowSort || !t.sorting.enabled) && a++);
      }

      var o = t.filtering.enabled && t.filtering.filterMenu.visible && "none" !== e.filterMenuMode;
      return !!(o && Smart.FilterPanel || Smart.Menu && !(a >= n));
    }
  }, {
    key: "_filterMenuItemsVisibility",
    value: function _filterMenuItemsVisibility(e) {
      var t = this,
          i = (t.menu.parentElement && (t.enableShadowDOM || t.isInShadowDOM) ? t.menu.firstElementChild.shadowRoot : t.menu).querySelectorAll("smart-menu-item"),
          a = e.menuItems || t.columnMenu.dataSource;
      var n = 0;

      for (var _o154 in a) {
        var _r99 = i[n++],
            _l74 = a[_o154];
        if (_r99.disabled = !_l74.enabled, _r99.classList.remove("smart-hidden"), "columnMenuItemRemoveSort" == _o154 && (e.sortOrder ? _r99.disabled = !1 : _r99.disabled = !0), "columnMenuItemSortAsc" == _o154 && "asc" === e.sortOrder ? _r99.disabled = !0 : "columnMenuItemSortDesc" == _o154 && "desc" === e.sortOrder && (_r99.disabled = !0), !0 === _l74.visible) _r99.classList.remove("smart-hidden");else if (!1 === _l74.visible) _r99.classList.add("smart-hidden");else if ("auto" === _l74.visible) {
          if (("columnMenuItemFilter" == _o154 || "columnMenuItemRemoveFilter" == _o154) && (!1 === t.filtering.enabled ? _r99.classList.add("smart-hidden") : t.filtering.filterMenu.visible || t.filtering.filterBuilder.visible ? _r99.classList.add("smart-hidden") : t.filtering.filterBuilder.visible && _r99.classList.remove("smart-hidden")), "columnMenuItemGroupBy" == _o154) {
            t.grouping.enabled && e.allowGroup ? _r99.classList.remove("smart-hidden") : _r99.classList.add("smart-hidden");

            var _i466 = t.dataSource.groupBy.indexOf(e.dataField);

            _r99.disabled = !!(0 <= _i466);
          }

          if ("columnMenuItemRemoveGroupBy" == _o154) {
            t.grouping.enabled && e.allowGroup ? _r99.classList.remove("smart-hidden") : _r99.classList.add("smart-hidden");

            var _i467 = t.dataSource.groupBy.indexOf(e.dataField);

            _r99.disabled = !!(0 > _i467);
          }

          "columnMenuItemFilter" != _o154 || e.allowFilter || _r99.classList.add("smart-hidden"), "columnMenuItemRemoveFilter" != _o154 || e.allowFilter || _r99.classList.add("smart-hidden"), ("columnMenuItemSortAsc" == _o154 || "columnMenuItemSortDesc" == _o154 || "columnMenuItemRemoveSort" == _o154) && (e.allowSort && t.sorting.enabled ? _r99.classList.remove("smart-hidden") : _r99.classList.add("smart-hidden"));
        }
      }
    }
  }, {
    key: "openMenu",
    value: function openMenu(e) {
      var t = this,
          i = t.columnByDataField[e];
      i && t._openMenu(i);
    }
  }, {
    key: "hasMenu",
    value: function hasMenu() {
      var e = this;
      return !!(e.menu && e.menu.column && e.menu.parentNode);
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      var e = this;
      e.menu && e.menu.column && (e.menu.column && (e.menu.column.setProperty("menu", null), e.menu.column = null), e.menu.parentNode && (e.menu.classList.remove("open"), !e.appearance.allowColumnMenuAnimation && e.menu.parentNode.removeChild(e.menu)), e.menu.removeEventListener("keydown", e._keyDownHandler.bind(e)), e.menu.removeEventListener("itemClick", e.menu.itemClick), e.menu.removeEventListener("itemCheckChange", e.menu.itemCheckChange), e.focus());
    }
  }]);

  return _class53;
}()), Smart.Utilities.Assign("Grid.Pager",
/*#__PURE__*/
function () {
  "use strict";

  function _class54() {
    _classCallCheck(this, _class54);
  }

  _createClass(_class54, [{
    key: "_refreshPaging",
    value: function _refreshPaging(e) {
      var t = this;
      requestAnimationFrame(function () {
        t._refreshLayout(), t._refreshSelection(), e || (t._initializeRowElements(), t._refreshLayout()), t.dataSource && t.dataSource.virtualDataSource ? t._virtualDataRequest(e ? "pageIndexChange" : "pageSizeChange") : t._recycle(!1);
        var i = t.paging.pageIndex * t.paging.pageSize,
            a = i + t.paging.pageSize;
        t.$.fireEvent("page", {
          data: {
            first: i,
            last: a,
            size: a - i
          }
        });
      });
    }
  }, {
    key: "_refreshPagesCount",
    value: function _refreshPagesCount() {
      var e = this,
          t = e.$.headerPager.querySelector("smart-pager"),
          i = function () {
        var t = e.getVisibleRows();
        var a = t.length;

        if (e.rowHierarchy) {
          a = 0;

          for (var _e544 = 0; _e544 < t.length; _e544++) {
            var _i468 = t[_e544];
            0 !== _i468.level || _i468.parent || a++;
          }

          e.dataSource.virtualDataSourceLength !== void 0 && (a = e.dataSource.virtualDataSourceLength);
        }

        return Math.ceil(a / e.paging.pageSize);
      }();

      t && (t.pagesCount = i);
      var a = e.$.footerPager.querySelector("smart-pager");
      t && (a.pagesCount = i), e.paging.pageIndex > i && (e.paging.pageIndex = i - 1, e._refreshPaging(e.paging.pageIndex));
    }
  }, {
    key: "_renderPagers",
    value: function _renderPagers() {
      var e = this;
      e.pager.visible && requestAnimationFrame(function () {
        var t = document.createElement("smart-pager"),
            i = document.createElement("smart-pager");
        e.$.headerPager.innerHTML = "", e.$.footerPager.innerHTML = "", e.$.headerPager.appendChild(t), e.$.footerPager.appendChild(i);

        var a = function a(t) {
          var i = t.messages[e.locale];
          i || (t.messages[e.locale] = {}), Object.assign(t.messages[e.locale], {
            firstButton: e.localize("pagerFirstButton"),
            lastButton: e.localize("pagerLastButton"),
            previousButton: e.localize("pagerPreviousButton"),
            nextButton: e.localize("pagerNextButton"),
            navigateToLabel: e.localize("pagerNavigateToLabel"),
            pageSizeLabel: e.localize("pagerPageSizeLabel"),
            navigateToInputPlaceholder: e.localize("pagerNavigateToInputPlaceholder"),
            ellipsis: e.localize("pagerEllipsis"),
            summaryString: e.localize("pagerSummaryString"),
            summaryPrefix: e.localize("pagerSummaryPrefix"),
            summarySuffix: e.localize("pagerSummarySuffix")
          });
        },
            n = function n() {
          var t = e.getVisibleRows();
          var a = t.length;

          if (e.rowHierarchy) {
            a = 0;

            for (var _e545 = 0; _e545 < t.length; _e545++) {
              var _i469 = t[_e545];
              0 !== _i469.level || _i469.parent || a++;
            }

            e.dataSource.virtualDataSourceLength !== void 0 && (a = e.dataSource.virtualDataSourceLength);
          }

          return Math.ceil(a / e.paging.pageSize);
        },
            o = function (_o155) {
          function o(_x3, _x4) {
            return _o155.apply(this, arguments);
          }

          o.toString = function () {
            return _o155.toString();
          };

          return o;
        }(function (a, o) {
          var r = o + "GridPager";
          a.setAttribute("smart-id", r), e.$[r] = a, e["$" + r] = Smart.Utilities.Extend(a), a.beginUpdate(), e.addPropertyBinding("[[pager_navigationButtons_position]]", "navigationButtonsPosition", a), e.addPropertyBinding("[[pager_navigationButtons_firstLastButtons_visible]]", "showFirstLastNavigationButtons", a), e.addPropertyBinding("[[pager_navigationButtons_prevNextButtons_visible]]", "showPrevNextNavigationButtons", a), e.addPropertyBinding("[[pager_navigationButtons_labels_visible]]", "showNavigationButtonLabels", a), e.addPropertyBinding("[[pager_pageIndexSelectors_visible]]", "showPageIndexSelectors", a), e.addPropertyBinding("[[pager_pageIndexSelectors_dataSource]]", "pageIndexSelectors", a), e.addPropertyBinding("[[pager_summary_visible]]", "showSummary", a), e.addPropertyBinding("[[pager_summary_position]]", "summaryPosition", a), e.addPropertyBinding("[[pager_navigationInput_visible]]", "showNavigationInput", a), e.addPropertyBinding("[[pager_navigationInput_position]]", "navigationInputPosition", a), e.addPropertyBinding("[[pager_pageSizeSelector_visible]]", "showPageSizeSelector", a), e.addPropertyBinding("[[pager_pageSizeSelector_dataSource]]", "pageSizeSelectorDataSource", a), e.addPropertyBinding("[[pager_pageSizeSelector_position]]", "pageSizeSelectorPosition", a), e.addPropertyBinding("[[pager_autoEllipsis]]", "autoEllipsis", a), e.addPropertyBinding("[[!paging_enabled]]", "disabled", a), e.addPropertyBinding("{{paging_pageIndex}}", "pageIndex", a), e.addPropertyBinding("{{paging_pageSize}}", "pageSize", a), a.pagesCount = n(), a.$.pageSizeSelector.dropDownAppendTo = "body", a.$.pageSizeSelector.selectedIndexes = [0], e["$" + r].listen("change", function (o) {
            a.pagesCount = n(), e.paging.pageIndex > a.pagesCount && (e.paging.pageIndex = a.pagesCount - 1), t.refresh(), i.refresh();
            var r = o.detail && o.detail.index !== void 0 || o.target.value !== void 0;

            e._refreshPaging(r);
          }), a.endUpdate();
        });

        o(t, "header"), o(i, "footer"), a(t), a(i);
      });
    }
  }]);

  return _class54;
}()), Smart.Utilities.Assign("Grid.Filter",
/*#__PURE__*/
function () {
  "use strict";

  function _class55() {
    _classCallCheck(this, _class55);
  }

  _createClass(_class55, [{
    key: "addFilter",
    value: function addFilter(e, t, i) {
      var a = this,
          n = a.columnByDataField[e];
      "string" == typeof t && (t = a.dataSource._createFilter(n.dataType, [t])), n && n.canNotify && (n.setProperty("filter", t), !1 !== i && a.refreshFilters());
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(e, t) {
      var i = this,
          a = i.columnByDataField[e];
      a && a.canNotify && (a.setProperty("filter", null), !1 !== t && i.refreshFilters());
    }
  }, {
    key: "clearFilter",
    value: function clearFilter() {
      var e = this;

      for (var _t449 = 0; _t449 < e.columns.length; _t449++) {
        var _i470 = e.columns[_t449];

        _i470.setProperty("filter", null);
      }

      e.refreshFilters();
    }
  }, {
    key: "getFilteredColumns",
    value: function getFilteredColumns() {
      var e = this;

      if (e._filters) {
        var _t450 = [];

        for (var _a287 = 0; _a287 < e._filters.length; _a287++) {
          var _i471 = e._filters[_a287];
          _t450[_i471[0]] = _i471[1], _t450.length++;
        }

        return _t450;
      }

      return [];
    }
  }, {
    key: "getVisibleRows",
    value: function getVisibleRows() {
      var e = this;
      if (e._visibleRows) return e._visibleRows;
      var t = [],
          a = e._viewRows,
          n = e.editing.addNewRow.visible && "far" !== e.editing.addNewRow.position ? 1 : 0;

      for (var _e546 = 0; _e546 < a.length; _e546++) {
        var _i472 = a[_e546];
        _i472.canNotify = !1, _i472.visibleIndex = -1, _i472.visible && (!1 !== _i472.filtered || void 0 === _i472.filtered) && (_i472.visibleIndex = t.length - n, t.push(_i472)), _i472.canNotify = !0;
      }

      return e._visibleRows = t, t;
    }
  }, {
    key: "refreshFilters",
    value: function refreshFilters() {
      var e = this,
          t = [];

      for (var _a288 = 0; _a288 < e.columns.length; _a288++) {
        var _i473 = e.columns[_a288];
        _i473.filter && t.push([_i473.dataField, _i473.filter]);
      }

      e.scrollTop = 0, e.closeMenu(), e.dataSource && !e.dataSource.onFilter && (e.dataSource.onFilter = function () {
        var t = e._viewRows;

        for (var _e547 = 0; _e547 < t.length; _e547++) {
          var _i474 = t[_e547];
          _i474.data && !_i474.addNewRow && (_i474.filtered = !(_i474.data.$.filtered !== void 0) || _i474.data.$.filtered);
        }

        e.refresh();
      }), e._filters = t, e._visibleRows = null, e.dataSource && e.dataSource.virtualDataSource ? (e.closeMenu(), e._virtualDataRequest("filter")) : e.dataSource._filter(t), e.paging.enabled && e.dataSource && !e.dataSource.virtualDataSource && e._refreshPagesCount();
      var a = [];

      for (var _t451 = 0; _t451 < e.columns.length; _t451++) {
        var _i475 = e.columns[_t451];
        _i475.filter && a.push(_i475);
      }

      var n = [];
      if (e._filters) for (var _t452 = 0; _t452 < e._filters.length; _t452++) {
        var _i476 = e._filters[_t452];
        n.push({
          dataField: _i476[0],
          filter: _i476[1]
        });
      }
      e.$.fireEvent("filter", {
        columns: a,
        data: n
      });
    }
  }]);

  return _class55;
}()), Smart.Utilities.Assign("Grid.Sort",
/*#__PURE__*/
function () {
  "use strict";

  function _class56() {
    _classCallCheck(this, _class56);
  }

  _createClass(_class56, [{
    key: "clearSort",
    value: function clearSort() {
      var e = this;

      if (!e._isSorting && e.dataSource) {
        e._isSorting = !0, e.dataSource.clearSort(), e._sortedColumns || (e._sortedColumns = []);

        for (var _t453 = 0; _t453 < e._sortedColumns.length; _t453++) {
          var _i477 = e._sortedColumns[_t453],
              _a289 = e.columnByDataField[_i477.dataField];
          _a289 && (_a289.setProperty("sortOrder", null), _a289.setProperty("sortIndex", null));
        }

        e._sortedColumns = [];

        for (var _t454 = 0; _t454 < e.dataSource.length; _t454++) {
          var _i478 = e.rows[_t454],
              _a290 = e.dataSource[_t454];
          _i478 && (_i478.data = _a290, _i478.boundIndex = _a290.boundIndex);
        }

        e._recycle(), e._isSorting = !1;
      }
    }
  }, {
    key: "getSortedColumns",
    value: function getSortedColumns() {
      var e = this,
          t = [];
      if (e._sortedColumns) for (var _a291 = 0; _a291 < e._sortedColumns.length; _a291++) {
        var _i479 = e._sortedColumns[_a291];
        t[_i479.dataField] = {
          sortOrder: _i479.sortOrder,
          sortIndex: _i479.sortIndex
        }, t.length++;
      }
      return t;
    }
  }, {
    key: "addSort",
    value: function addSort(e, t) {
      var i = this;
      i.sortBy(e, t);
    }
  }, {
    key: "removeSort",
    value: function removeSort(e) {
      var t = this;
      t.sortBy(e, null);
    }
  }, {
    key: "_refreshSort",
    value: function _refreshSort(e) {
      var t = this;
      if (t._isSorting || !e) return;
      var a = [],
          n = [],
          o = [];
      t._isSorting = !0;

      for (var _r100 = 0; _r100 < e.length; _r100++) {
        var _i480 = e[_r100],
            _l75 = t.columnByDataField[_i480.dataField];
        _l75 && (_l75.setProperty("sortOrder", _i480.sortOrder), a.push(_i480.dataField), n.push(_i480.sortOrder), o.push(_i480.dataType));
      }

      (function () {
        if (t.dataSource && t.dataSource.virtualDataSource) t._virtualDataRequest("sort");else {
          if (t.dataSource.sortBy(a, o, n), t.dataSource.boundHierarchy) t._refreshRowHierarchy();else for (var _e548 = 0; _e548 < t.dataSource.length; _e548++) {
            var _i481 = t.rows[_e548],
                _a292 = t.dataSource[_e548];
            _i481.data = _a292, _i481.boundIndex = _a292.boundIndex;
          }

          t._recycle();
        }
      })(), t._isSorting = !1, t._sortedColumns = e;
    }
  }, {
    key: "sortBy",
    value: function sortBy(e, t) {
      var a = Math.floor;
      var n = this,
          o = n.columnByDataField[e],
          r = [],
          l = [],
          s = [],
          d = !(t !== void 0);
      if (n._isSorting || !o) return;
      n._isSorting = !0, void 0 === t && (t = "asc");

      var c = function c(e) {
        e && e.setProperty("sortOrder", null);
      },
          i = function i() {
        if (0 < n._sortedColumns.length) for (var _e549 = 0; _e549 < n._sortedColumns.length; _e549++) {
          var _t455 = n._sortedColumns[_e549],
              _i482 = n.columnByDataField[_t455.dataField];
          c(_i482);
        }
        n._sortedColumns = [];
      };

      if (null === o) return i(), void (n._isSorting = !1);
      if (!n.sorting.enabled || !n.dataSource || !o.allowSort || n._sortAnimation) return void (n._isSorting = !1);
      c(o), n._sortedColumns || (n._sortedColumns = []);
      var m = "string";

      for (var _a293 = 0; _a293 < n.dataSource.dataFields.length; _a293++) {
        var _t456 = n.dataSource.dataFields[_a293];

        if (_t456.name === e) {
          m = _t456.dataType;
          break;
        }
      }

      var u = !0;

      for (var _a294 = 0; _a294 < n._sortedColumns.length; _a294++) {
        var _i483 = n._sortedColumns[_a294];
        if (_i483.dataField === e) if (u = !1, _i483.sortIndex = o.sortIndex, !d) _i483.sortOrder = t, null === t && (n._sortedColumns.splice(_a294, 1), c(o));else if ("asc" === _i483.sortOrder) _i483.sortOrder = "desc", t = "desc";else if ("desc" === _i483.sortOrder) {
          n.sorting.sortToggleThreeStates ? (n._sortedColumns.splice(_a294, 1), c(o), t = null) : (_i483.sortOrder = "asc", t = "asc");
          break;
        }
      }

      u && ("one" === n.sorting.mode && i(), null !== t && n._sortedColumns.push({
        dataField: e,
        sortOrder: t,
        sortIndex: o.sortIndex,
        dataType: m
      })), o.setProperty("sortOrder", t), n._sortedColumns.sort(function (e, t) {
        return "string" == typeof e.sortIndex && "string" == typeof t.sortIndex ? 0 : "number" == typeof e.sortIndex && "string" == typeof t.sortIndex ? -1 : "string" == typeof e.sortIndex && "number" == typeof t.sortIndex ? 1 : "number" == typeof e.sortIndex && "number" == typeof t.sortIndex ? e.sortIndex - t.sortIndex : void 0;
      });

      for (var _a295 = 0; _a295 < n._sortedColumns.length; _a295++) {
        var _e550 = n._sortedColumns[_a295];
        r.push(_e550.dataField), l.push(_e550.sortOrder), s.push(_e550.dataType);
      }

      var p = function p() {
        if (n.dataSource && n.dataSource.virtualDataSource) n._virtualDataRequest("sort");else {
          if (n.dataSource.sortBy(r, s, l), n.dataSource.boundHierarchy) n._refreshRowHierarchy();else for (var _e551 = 0; _e551 < n.dataSource.length; _e551++) {
            var _t457 = n.rows[_e551],
                _i484 = n.dataSource[_e551];
            _t457.data = _i484, _t457.boundIndex = _i484.boundIndex;
          }

          n._recycle();
        }
        var e = [];

        for (var _t458 = 0; _t458 < n._sortedColumns.length; _t458++) {
          var _i485 = n.columnByDataField[n._sortedColumns[_t458].dataField];
          _i485 && e.push(_i485);
        }

        n.$.fireEvent("sort", {
          columns: e,
          data: n._sortedColumns
        });
      };

      if (n.appearance.allowSortAnimation) {
        var _e552 = [],
            _t459 = [];
        n.rows.canNotify = !1, n._sortAnimation = !0;

        var _i486 = function _i486() {
          for (var _t460 = 0; _t460 < n._rowElements.length; _t460++) {
            var _i487 = n._rowElements[_t460];
            _i487.classList.remove("smart-grid-sort-animation"), n.removeTransformMoveStyle(_i487), 0 < _i487.offsetHeight && _e552.push(_i487.offsetTop);
          }
        };

        _i486(), n._sortTimer = setTimeout(function () {
          _i486(), n._sortAnimation = !1, n.rows.canNotify = !0;
        }, n.appearance.sortAnimationDuration), n._sortTimer2 = setTimeout(function () {
          p();
        }, n.appearance.sortAnimationDuration / 2);

        var _loop22 = function _loop22(_o156) {
          var i = n._rowElements[_o156];
          i.classList.remove("smart-grid-sort-animation"), n.removeTransformMoveStyle(i);
          var r = a(Math.random() * _e552.length - 1 + 1);

          for (; _t459[r];) {
            r = a(Math.random() * _e552.length - 1 + 1);
          }

          _t459[r] = !0, n.addTransformMoveStyle(i, "0ms", 0, -i.offsetTop + _e552[r], 0, .5), i.classList.add("smart-grid-sort-animation"), setTimeout(function () {
            n.addTransformMoveStyle(i, n.appearance.sortAnimationDuration + "ms", 0, 0, 0, 1);
          }), setTimeout(function () {
            i.classList.remove("smart-grid-sort-animation");
          }, n.appearance.sortAnimationDuration);
        };

        for (var _o156 = 0; _o156 < _e552.length; _o156++) {
          _loop22(_o156);
        }
      } else p();

      n._isSorting = !1;
    }
  }]);

  return _class56;
}()), Smart.Utilities.Assign("Grid.Group",
/*#__PURE__*/
function () {
  "use strict";

  function _class57() {
    _classCallCheck(this, _class57);
  }

  _createClass(_class57, [{
    key: "addGroup",
    value: function addGroup(e) {
      var t = this;

      if (t.dataSource && t.grouping.enabled) {
        var _i488 = t.dataSource.groupBy.indexOf(e);

        -1 === _i488 && (t.dataSource.groupBy.push(e), t.refresh(!0), t.refreshFilters());
      }
    }
  }, {
    key: "removeGroup",
    value: function removeGroup(e) {
      var t = this;

      if (t.dataSource && t.grouping.enabled) {
        var _i489 = t.dataSource.groupBy.indexOf(e);

        0 <= _i489 && (t.dataSource.groupBy.splice(_i489, 1), t.refresh(!0), t.refreshFilters());
      }
    }
  }, {
    key: "clearGroups",
    value: function clearGroups() {
      var e = this;
      e.dataSource && e.grouping.enabled && (e.dataSource.clearGroup(), e.refresh(!0), e.refreshFilters());
    }
  }]);

  return _class57;
}()), Smart.Utilities.Assign("Grid.Select",
/*#__PURE__*/
function () {
  "use strict";

  function _class58() {
    _classCallCheck(this, _class58);
  }

  _createClass(_class58, [{
    key: "_refreshSelection",
    value: function _refreshSelection() {
      var e = this;

      if (e.selection.enabled) {
        var _t461 = e._selectionColumn;

        _t461.refresh();
      }

      e._refreshCellSelectionRect();
    }
  }, {
    key: "_toggleColumnSelection",
    value: function _toggleColumnSelection(e) {
      var t = this;
      if (!t.selection.enabled || "none" === t.selection.checkBoxes.selectAllMode) return void (t._inputOverlay && t._inputOverlay.parentNode && t._inputOverlay.parentNode.removeChild(t._inputOverlay));
      var a = e.element.getAttribute("selected");
      a = "indeterminate" === a || "" !== a;
      var n = t._recyclingRows;
      t._selectionColumn._selecting = !0, t.beginUpdate();

      for (var _t462 = 0; _t462 < n.length; _t462++) {
        var _e553 = n[_t462];
        _e553.selected = a;
      }

      if (t._selectionColumn._selecting = !1, t.endUpdate(!1), t._recycle(!1), t.selection.enabled && t.selection.checkBoxes.enabled && "none" !== t.selection.checkBoxes.selectAllMode) {
        var _i490 = e.element,
            _a296 = _i490.querySelector(".smart-input");

        t._inputOverlay ? t._inputOverlay.parentNode !== t.$.columnHeader && (t._inputOverlay.parentNode && t._inputOverlay.parentNode.removeChild(t._inputOverlay), t._inputOverlay = document.createElement("div"), t.$.columnHeader.appendChild(t._inputOverlay)) : (t._inputOverlay = document.createElement("div"), t.$.columnHeader.appendChild(t._inputOverlay)), t._inputOverlay.column = e, t._inputOverlay.onpointerdown = function () {
          t._inputOverlay || (t._inputOverlay.onpointerdown = null);
          var e = t._inputOverlay.column;
          t._inputOverlay.classList.remove("smart-animate"), t._selectionColumn._selecting = !0, t.beginUpdate();
          var a = e.element.hasAttribute("selected"),
              n = t._recyclingRows;

          for (var _e554 = 0; _e554 < n.length; _e554++) {
            var _t463 = n[_e554];
            _t463.selected = !a;
          }

          t._selectionColumn._selecting = !1;
          var i = t._inputOverlay;
          return t.endUpdate(!1), t._recycle(), t.$.columnHeader.appendChild(i), t._inputOverlay = i, t._inputOverlay.classList.add("smart-animate"), !1;
        }, t._inputOverlay.classList.add("smart-input-overlay"), t._inputOverlay.classList.add("smart-input-overlay-column"), t.appearance.allowCheckBoxesSelectionAnimation && t._inputOverlay.classList.add("smart-animate"), t._inputOverlay.style.top = (_i490.offsetHeight - _a296.offsetHeight) / 4 + 1 + "px";

        var _n234 = t._selectionColumn.element.parentElement.offsetLeft + t._selectionColumn.element.offsetLeft;

        t._inputOverlay.style.left = _n234 + "px", t._inputOverlay.style.height = _i490.offsetWidth + "px", t._inputOverlay.style.width = _i490.offsetWidth + "px", t._inputOverlay.onmousedown = null, t._inputOverlay.classList.add("smart-input-overlay-on"), t._selectionColumn.refresh();
      }
    }
  }, {
    key: "_refreshCheckBoxColumnSelection",
    value: function _refreshCheckBoxColumnSelection() {
      var e = this;

      if (e.selection.enabled && e.selection.checkBoxes.enabled) {
        var _t464 = e._selectionColumn.element;
        "none" === e.selection.checkBoxes.selectAllMode ? (_t464.removeAttribute("checkbox"), _t464.label.classList.remove("smart-input")) : (_t464.setAttribute("checkbox", ""), _t464.label.classList.add("smart-input")), e._selectionColumn.refresh();
      }
    }
  }, {
    key: "_handleExtendedRowSelection",
    value: function _handleExtendedRowSelection(e, t) {
      var i = this;
      if (!e) return;
      var a = i._recyclingRows;

      if (i.paging.enabled && "page" === i.selection.selectAllMode && (a = a.slice(i.paging.pageIndex * i.paging.pageSize, (i.paging.pageIndex + 1) * i.paging.pageSize)), t && !t.ctrlKey && (i._selection.rows = []), t && !t.shiftKey && (i._rangeSelectionStartRow = e, i._rangeSelectionEndRow = e), t && t.shiftKey) {
        i._rangeSelectionEndRow = e;

        var _t465 = a.indexOf(i._rangeSelectionStartRow),
            _n235 = a.indexOf(i._rangeSelectionEndRow),
            _o157 = Math.min(_t465, _n235),
            _r101 = Math.max(_t465, _n235);

        if (-1 === _t465 || -1 === _n235) return;

        for (var _e555 = _o157; _e555 <= _r101; _e555++) {
          var _t466 = a[_e555];

          _t466.setProperty("selected", !0);
        }
      } else t && t.ctrlKey ? null === e.selected ? e.setProperty("selected", !0) : e.setProperty("selected", !e.selected) : e.setProperty("selected", !0);
    }
  }, {
    key: "_setSelection",
    value: function _setSelection(e, t, i) {
      var a = this;

      if (a.selection.enabled) {
        if (a._lastColumnSelectionRange = null, a._lastRowSelectionRange = null, a.closeMenu(), null === e && null === t) return void a.clearSelection();

        var _n236 = function _n236() {
          if (i && !i.ctrlKey && !i.shiftKey || "one" === a.selection.mode) {
            if ("many" !== a.selection.mode) {
              for (var _e556 in a._selection.rows) {
                var _t467 = a.rowById[_e556];
                _t467.canNotify = !1, _t467.selected = !1, _t467.canNotify = !0;
              }

              a._selection.rows = [], a._selection.columns = [], a._selection.cells = [];
            }

            a._selection.focusedCell = null;
          }

          if (a._selection.selectionRect) {
            var _e557 = a._selection.selectionRect;

            _e557.parentNode.removeChild(_e557);

            var _t468 = {
              down: "pointerdown",
              move: "pointermove",
              up: "pointerup"
            };
            Smart.Utilities.Core.isMobile && (_t468.down = "touchstart", _t468.move = "touchmove", _t468.up = "touchend"), document.removeEventListener(_t468.move, _e557.onMove), document.removeEventListener(_t468.up, _e557.onUp), document.removeEventListener(_t468.down, _e557.onDown), a._selection.selectionRect = null;
          }
        };

        a.beginUpdate();
        var _o158 = a.columnByDataField[t];

        if (a.selection.allowCellSelection && void 0 !== e && null !== e && _o158 && !_o158.autoGenerated) {
          var _o159 = a.rowById[e];

          var _r102 = _o159.getCell(t);

          var _l76 = a._getParentCell(_o159, t);

          _l76 && (_r102 = _l76.row.getCell(_l76.column.dataField)), _n236(), i && !i.ctrlKey && (a._selection.rows = [], a._selection.columns = [], "many" !== a.selection.mode && (a._selection.cells = [])), _r102.selected = "extended" === a.selection.mode ? !(i && i.ctrlKey) || !_r102.selected : "one" === a.selection.mode || !_r102.selected, (!i || i.shiftKey) && a._selection.focusedCell || (a._selection.focusedCell = _r102), i && (i.shiftKey || a._selection.focusedCell === _r102) && "extended" === a.selection.mode && (_l76 ? a._renderCellSelectionRect(_r102.row, _r102.column, _l76.endRow, _l76.endColumn) : a._renderCellSelectionRect(_r102.row, _r102.column, _r102.row, _r102.column));
        } else a.selection.allowRowHeaderSelection && void 0 !== e && null !== e && void 0 === a.columnByDataField[t] ? (_n236(), a._selectRow(e, i)) : a.selection.checkBoxes.enabled && void 0 !== e && null !== e && "_checkBoxColumn" === t && void 0 === a.columnByDataField[t] ? (_n236(), a._selectRow(e, i)) : void 0 !== e && null !== e && (void 0 === t || void 0 !== a.columnByDataField[t]) && a.selection.allowRowSelection ? (_n236(), a._selectRow(e, i)) : a.selection.allowColumnHeaderSelection && _o158 && (_n236(), a._selectColumn(t, i));

        a.endUpdate(!1), a._recycle(), void 0 === e || null === e || _o158 || a._renderInputOverlay(e, i), a.__selectionStarted = new Date();
      }
    }
  }, {
    key: "_renderCellSelectionRect",
    value: function _renderCellSelectionRect(e, t, i, a) {
      var n = Math.abs;
      var o = this;
      var r = o._recyclingRows;
      var l = r.indexOf(e),
          s = r.indexOf(i);

      if (0 <= l && 0 <= s) {
        if (!o._selection.selectionRect) {
          var _e559 = o._selection.selectionRect = function (e) {
            var t = document.createElement("div"),
                i = document.createElement("div"),
                a = document.createElement("div");
            return a.classList.add("smart-selection-overlay"), a.appendChild(i), i.appendChild(t), t.classList.add("smart-selection-overlay-content"), i.classList.add("smart-selection-overlay-border-content"), o.selection.allowCellDragSelectionHandle && e && i.classList.add("handle"), o.$.scrollView.appendChild(a), a;
          }(!0);

          if (o.selection.allowCellDragSelectionHandle) {
            var _t469 = null,
                _i491 = null,
                _a297 = null;
            _e559.onMove = function (e) {
              var l = o._selection.selectionRect;
              var s = e.clientX,
                  d = e.clientY;
              e.touches && (s = e.touches[0].clientX, d = e.touches[0].clientY);

              var c = function c(e) {
                var t = (o.enableShadowDOM ? o.shadowRoot : o.getRootNode()).elementsFromPoint(e.clientX, e.clientY);
                var i = null;

                for (var _a298 = 0; _a298 < t.length; _a298++) {
                  var _e560 = t[_a298];

                  if (_e560.getAttribute("data-field")) {
                    i = _e560.getAttribute("data-field");
                    break;
                  }
                }

                var a = null;

                for (var _n237 = 0; _n237 < t.length; _n237++) {
                  var _e561 = t[_n237];

                  if (_e561.getAttribute("data-id")) {
                    a = _e561.row;
                    break;
                  }
                }

                return {
                  column: o.columnByDataField[i],
                  row: a
                };
              };

              if (l.capturedDrag) {
                var _t470 = {
                  clientX: s,
                  clientY: d
                };

                var _i492 = c(_t470),
                    _a299 = c({
                  clientX: s,
                  clientY: d + l.top
                }).row,
                    _n238 = c({
                  clientX: s + l.left,
                  clientY: d
                }).column;

                _a299 || (_a299 = r[r.length - 1]), _n238 || (_n238 = _i492.column), _a299 && _n238 && _i492.row && _i492.column && (l.row = _i492.row, l.column = _i492.column, l.endDragRow = l.endRow = _a299, l.endDragColumn = l.endColumn = _n238, o._dragSelectionStartDataField = l.column.dataField, o._dragSelectionStartRow = l.row, o._selection.focusedCell = l.row.getCell(l.column.dataField)), o._resizeSelectionRect(), e.preventDefault();
              } else if (l.captured) if (o._dragSelectionStartDataField = o._selection.focusedCell.column.dataField, o._dragSelectionStartRow = o._selection.focusedCell.row, null === _i491 && null === _a297 && (30 <= n(s - _t469.left) ? _i491 = !0 : 30 <= n(d - _t469.top) && (_a297 = !0)), l.lastPoint && 40 <= n(l.lastPoint.top - d) ? (_i491 = null, _a297 = !0) : l.lastPoint && 40 <= n(l.lastPoint.left - s) && (_a297 = null, _i491 = !0), _i491) {
                var _e562 = l.endDragColumn.dataField,
                    _i493 = {
                  clientX: s,
                  clientY: _t469.top - 5
                },
                    _a300 = c(_i493);

                _a300.row && _a300.column && (l.endDragRow = l.endRow, l.endDragColumn = _a300.column, l.endDragColumn.dataField !== _e562 && (l.lastPoint = {
                  left: s,
                  top: d
                }), o._resizeSelectionRect());
              } else if (_a297) {
                var _e563 = l.endDragRow,
                    _i494 = {
                  clientX: _t469.left - 5,
                  clientY: d
                },
                    _a301 = c(_i494);

                _a301.row && _a301.column && (l.endDragRow = _a301.row, l.endDragColumn = l.endColumn, l.endDragRow.id && l.endDragRow.id !== _e563.id && (l.lastPoint = {
                  left: s,
                  top: d
                }), o._resizeSelectionRect());
              }

              l.captured && o.selection.allowDragSelectionAutoScroll && (o._autoScrollSelectionDragInterval && clearInterval(o._autoScrollSelectionDragInterval), o.selection.isDragging = !0, o._autoScrollSelectionDragInterval = setInterval(function () {
                var e = o.$.scrollView.getBoundingClientRect();
                s <= e.left + 20 ? (o.scrollLeft -= 15, o._resizeSelectionRect()) : s >= e.left + e.width - 20 && (o.scrollLeft += 15, o._resizeSelectionRect()), d <= e.top + 20 ? (o.scrollTop -= 15, o._resizeSelectionRect()) : d >= e.top + e.height - 20 && (o.scrollTop += 15, o._resizeSelectionRect());
              }, 5));
            }, _e559.onUp = function () {
              if (_e559.captured) {
                o._autoScrollSelectionDragInterval && clearInterval(o._autoScrollSelectionDragInterval), o.editing.editCell || o.editing.editRow || o.focus(), _e559.capturedDrag = !1, _e559.captured = !1, _i491 = null, _a297 = null, _t469 = null, _e559.lastPoint = null;
                var _n239 = _e559.cellValues;
                _e559.minRow && _e559.maxRow && _e559.maxRow && _e559.maxColumn && (o._selectCellsRange(_e559.minRow, _e559.maxRow, _e559.minColumn.dataField, _e559.maxColumn.dataField), _e559.row = _e559.minRow, _e559.column = _e559.minColumn, _e559.endColumn = _e559.maxColumn, _e559.endRow = _e559.maxRow, _e559.cellValues = _n239, o._resizeSelectionRect(), o.selection.allowCellDragSelectionAutoFill && o._pasteSelectedCells({
                  row: _e559.row,
                  endRow: _e559.endDragRow,
                  column: _e559.column,
                  endColumn: _e559.endColumn
                }, _n239)), _e559.endDragColumn = null, _e559.endDragRow = null, _e559.minColumn = null, _e559.minRow = null, _e559.maxColumn = null, _e559.maxRow = null;
              }
            }, _e559.onDown = function (i) {
              if (_e559.captured && !_t469) {
                var _e564 = i.clientX,
                    _a302 = i.clientY;
                i.touches && (_e564 = i.touches[0].clientX, _a302 = i.touches[0].clientY), _t469 = {
                  left: _e564,
                  top: _a302
                };
              }
            };
            var _l77 = {
              down: "pointerdown",
              move: "pointermove",
              up: "pointerup"
            };
            Smart.Utilities.Core.isMobile && (_l77.down = "touchstart", _l77.move = "touchmove", _l77.up = "touchend"), _e559["on" + _l77.down] = function (t) {
              var i = _e559.getBoundingClientRect();

              var a = t.clientX,
                  n = t.clientY;
              t.touches && (a = t.touches[0].clientX, n = t.touches[0].clientY), a >= i.right - 5 && n >= i.bottom - 5 ? (_e559.captured = !0, _e559.endDragRow = _e559.endRow, _e559.endDragColumn = _e559.endColumn) : o.selection.allowCellDragDropSelectionHandle && n >= i.bottom - 5 ? (_e559.captured = !0, _e559.capturedDrag = !0, _e559.endDragRow = _e559.endRow, _e559.endDragColumn = _e559.endColumn, _e559.left = _e559.endColumn.left - _e559.column.left, _e559.top = _e559.endRow.top - _e559.row.top) : !_e559.captured && o._rowDownHandler(t);
            }, document.addEventListener(_l77.move, _e559.onMove, {
              passive: !1
            }), document.addEventListener(_l77.up, _e559.onUp, {
              passive: !1
            }), document.addEventListener(_l77.down, _e559.onDown, {
              passive: !1
            });
          }
        }

        var _e558 = o._selection.selectionRect;
        _e558.row = o._selection.focusedCell.row, _e558.column = o._selection.focusedCell.column, _e558.endRow = i, _e558.endDragRow = i, _e558.endColumn = a, _e558.endDragColumn = a, o._refreshCellSelectionRect();
      }
    }
  }, {
    key: "_resizeSelectionRect",
    value: function _resizeSelectionRect() {
      var e = Math.min,
          t = Math.max;
      var i = this,
          a = i._selection.selectionRect;
      if (!a) return;
      var n = i._recyclingRows,
          o = a.row,
          r = a.endDragRow,
          l = a.column,
          s = a.endDragColumn;

      var d = n.indexOf(o),
          c = n.indexOf(r),
          m = n.indexOf(a.endRow),
          u = i.columns.indexOf(l),
          p = i.columns.indexOf(s),
          g = i.columns.indexOf(a.endColumn),
          h = e(m, e(d, c)),
          _ = t(m, t(d, c)),
          f = e(g, e(u, p)),
          b = t(g, t(u, p));

      a.minRow = m <= e(d, c) ? a.endRow : d <= c ? o : r, a.maxRow = m >= t(d, c) ? a.endRow : d >= c ? o : r, a.minColumn = g <= e(u, p) ? a.endColumn : u <= p ? l : s, a.maxColumn = g >= t(u, p) ? a.endColumn : u >= p ? l : s;
      var y = 0,
          v = 0,
          w = 0,
          C = 0;

      for (var _e565 = h; _e565 <= _; _e565++) {
        var _t471 = n[_e565];
        _e565 === h && (y = _t471.top), _e565 === _ && (v = _t471.top + _t471.height - y);

        for (var _e566 = f; _e566 <= b; _e566++) {
          var _a303 = i.columns[_e566].dataField,
              _n240 = _t471.getCell(_a303);

          _e566 === f && (w = _n240.column.left), _e566 === b && (C = _n240.column.left + _n240.column.computedWidth - w);
        }
      }

      a.style.top = y - i.scrollTop - 1 + "px", a.style.left = w - i.scrollLeft + "px", a.style.height = v + 1 + "px", a.style.width = C + 1 + "px";
    }
  }, {
    key: "_getPatternValue",
    value: function _getPatternValue(e, t, i) {
      var a = [],
          n = 0,
          o = [],
          r = [],
          l = [],
          s = [];

      var d = {
        names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
      },
          c = {
        names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""],
        namesAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", ""]
      },
          m = function m(e) {
        if (void 0 !== e && !(0 <= e.toString().indexOf("GMT+") || 0 <= e.toString().indexOf("GMT-"))) {
          if (isNaN(parseFloat(e))) {
            if (0 <= d.names.indexOf(e)) return s = d.names, d.names.indexOf(e);
            if (0 <= d.namesAbbr.indexOf(e)) return s = d.namesAbbr, d.namesAbbr.indexOf(e);
            if (0 <= d.namesShort.indexOf(e)) return s = d.namesShort, d.namesShort.indexOf(e);
            if (0 <= c.names.indexOf(e)) return s = c.names, c.names.indexOf(e);
            if (0 <= c.namesAbbr.indexOf(e)) return s = c.namesAbbr, c.namesAbbr.indexOf(e);

            if (void 0 !== e) {
              null === e && (e = "");

              var _t473 = /\d+/.test(e.toString());

              if (_t473) {
                l.push(e.toString().replace(/[0-9]/, "#")), l[l.length - 1] = l[l.length - 1].replace(/[0-9]/g, "");

                var _t474 = parseFloat(e.toString().replace(/\D/g, ""));

                return isNaN(_t474) ? 0 : _t474;
              }
            }

            return;
          }

          var _t472 = /[A-Za-z]/.test(e.toString());

          return _t472 ? void 0 : parseFloat(e);
        }
      };

      var u = 0;

      for (var _r103 in i) {
        var _e567 = i[_r103];

        for (var _t476 in a[n] = [], u = 0, _e567) {
          var _i495 = m(_e567[_t476]);

          void 0 !== _i495 && (a[n].push(_i495), u++);
        }

        if (0 === a[n].length) continue;
        var _t475 = a[n][0],
            _d30 = 0;

        for (var _e568 = 0; _e568 < a[n].length; _e568++) {
          var _i496 = m(a[n][_e568 - 1]),
              _o160 = m(a[n][_e568]);

          0 == _e568 && (_i496 = _o160), _t475 += _o160, _d30 += _o160 - _i496;
        }

        _t475 /= a[n].length, _t475 -= a[n][0], _t475 += a[n][a[n].length - 1], 0 !== _d30 && (_d30 /= a[n].length - 1), (0 < s.length || 0 < l.length) && (_d30 = 1, _t475 = a[n][0]), 2 >= a[n].length && (_t475 = a[n][a[n].length - 1] + _d30), o.push({
          step: _d30,
          stepStart: _t475
        }), n++;
      }

      for (var _n241 = 0; _n241 < u; _n241++) {
        var _e569 = a[0][_n241],
            _t477 = 0;

        for (var _i497 = 1; _i497 < a.length; _i497++) {
          var _o161 = m(a[_i497 - 1][_n241]),
              _r104 = m(a[_i497][_n241]);

          _e569 += _r104, _t477 += _r104 - _o161;
        }

        _e569 /= a.length, _e569 -= a[0][_n241], _e569 += a[a.length - 1][_n241], 0 !== _t477 && (_t477 /= a.length - 1), (0 < s.length || 0 < l.length) && (_t477 = 1, _e569 = a[0][_n241]), 2 >= a.length && (_e569 = a[a.length - 1][_n241] + _t477), r.push({
          step: _t477,
          stepStart: _e569
        });
      }

      if (!a[e]) {
        var _n242 = a.length;

        for (var _o162 = _n242; _o162 <= e; _o162++) {
          a[_o162] = [];

          for (var _e570 = 0; _e570 <= t; _e570++) {
            (r[_e570] || (r[_e570] = r[_e570 - 1]), !!r[_e570]) && (_o162 === _n242 ? a[_o162][_e570] = r[_e570].stepStart : (a[_o162][_e570] = a[_o162 - 1][_e570] + r[_e570].step, 1 < s.length && a[_o162][_e570] >= s.length && (a[_o162][_e570] = 0)));
          }
        }

        if (0 < s.length) return s[a[e][t]];
        return 0 < l.length ? l[e % l.length].replace("#", a[e][t]) : a[e][t];
      }

      if (!a[e][t]) {
        var _n243 = u;

        for (var _r105 = _n243; _r105 <= t; _r105++) {
          o[e] && (_r105 == _n243 ? a[e].push(o[e].stepStart) : (a[e][_r105] = a[e][_r105 - 1] + o[e].step, 1 < s.length && a[e][_r105] >= s.length && (a[e][_r105] = 0)));
        }

        return 0 < s.length ? s[a[e][t]] : 0 < l.length ? l[e % l.length].replace("#", a[e][t]) : a[e][t];
      }

      return a[e] && a[e][t] ? 0 < l.length ? l[e % l.length].replace("#", a[e][t]) : a[e][t] : 0;
    }
  }, {
    key: "_pasteDataType",
    value: function _pasteDataType(e) {
      var t = this,
          i = t.dataSource && "number" == typeof t.dataSource.dataSource,
          a = e.cell,
          n = e.value;
      var o = a.column.dataType;
      return (!o || i) && (isNaN(parseFloat(n)) ? o = "string" : n instanceof Date ? o = "date" : "true" === n || "false" === n ? o = "boolean" : o = "number"), o;
    }
  }, {
    key: "_pasteModeCopy",
    value: function _pasteModeCopy(e) {
      var t = this,
          i = t.dataSource && "number" == typeof t.dataSource.dataSource,
          a = t._pasteDataType(e),
          n = e.cell,
          o = e.value,
          r = e.dataField;

      if ("string" === a) n.value = o;else if ("bool" === a || "boolean" === a) (1 === o || "1" === o || !0 === o || "true" === o || "TRUE" === o || "True" === o) && (n.value = !0);else if ("date" === a || "time" === a || "dateTime" === a) {
        var _e571 = t.columnByDataField[r];
        n.value = i ? o : _e571 && _e571.dataType !== a ? null : o;
      } else if ("number" === a || "float" === a || "int" === a) {
        var _e572 = t.columnByDataField[r];
        n.value = i ? o : _e572 && _e572.dataType !== a ? null : null === o ? null : "int" === a || "integer" === a ? parseInt(o) : parseFloat(o);
      }
    }
  }, {
    key: "_pasteModeFill",
    value: function _pasteModeFill(e) {
      var t = this,
          i = t.dataSource && "number" == typeof t.dataSource.dataSource,
          a = t._pasteDataType(e),
          n = e.cell,
          o = e.selectedValues,
          r = e.minRowIndex,
          l = e.minColumnIndex,
          s = e.currentRowIndex,
          d = e.currentColumnIndex,
          c = e.dataField;

      var m = e.value;

      if ("string" === a) {
        var _i498 = /\d+/.test(m.toString());

        _i498 ? (m = t._getPatternValue(s - r, d - l, o), m === void 0 && o[s - r] && o[s - r][d - l] && (m = o[s - r][d - l])) : (m = t._getPatternValue(s - r, d - l, o), m = void 0 === m ? o[s - r] ? o[s - r][d - l] : e.value : e.value), m !== void 0 && (n.value = m);
      } else if ("bool" === a || "boolean" === a) (1 === m || "1" === m || !0 === m || "true" === m || "TRUE" === m || "True" === m) && (n.value = !0);else if ("date" === a || "time" === a || "dateTime" === a) {
        var _e573 = t.columnByDataField[c];
        i ? n.value = m : _e573 && _e573.dataType !== a && (n.value = null), o[s - r] && (m = o[s - r][d - l], m !== void 0 && (n.value = m));
      } else if ("number" === a || "float" === a || "int" === a) {
        m = t._getPatternValue(s - r, d - l, o);
        var _e574 = t.columnByDataField[c];
        n.value = i ? m : _e574 && _e574.dataType !== a ? null : null === m ? null : "int" === a || "integer" === a ? parseInt(m) : parseFloat(m);
      }
    }
  }, {
    key: "_pasteSelectedCells",
    value: function _pasteSelectedCells(e, t) {
      var i = Math.min,
          a = Math.max;
      var n = this;
      n.beginUpdate();
      var o = n._recyclingRows,
          r = e.row,
          l = e.endRow,
          s = e.column,
          d = e.endColumn;

      var c = o.indexOf(r),
          m = o.indexOf(l),
          u = o.indexOf(e.endRow),
          p = n.columns.indexOf(s),
          g = n.columns.indexOf(d),
          h = n.columns.indexOf(e.endColumn),
          _ = i(u, i(c, m)),
          f = a(u, a(c, m)),
          b = i(h, i(p, g)),
          y = a(h, a(p, g));

      var v = 0,
          w = 0,
          C = 0,
          x = 0;

      for (var _i499 in t) {
        0 == v && (w += Object.keys(t[_i499]).length), v++;
      }

      for (var _a304 = _; _a304 <= f; _a304++) {
        var _e575 = o[_a304];
        C = 0;

        for (var _i500 = b; _i500 <= y; _i500++) {
          var _o163 = n.columns[_i500].dataField,
              _r106 = _e575.getCell(_o163);

          var _l78 = 0;

          for (var _s61 in t) {
            if (_l78 === x) {
              var _l79 = 0,
                  _d31 = t[_s61];

              for (var _c16 in _d31) {
                if (C === _l79) {
                  var _l80 = _d31[_c16],
                      _m15 = !0;

                  if (t[_e575.id] && t[_e575.id][_o163] && (_m15 = !1), _m15 && "none" !== n.clipboard.autoFillMode) {
                    var _e576 = {
                      value: _l80,
                      oldValue: _r106.value,
                      dataField: _c16,
                      id: _s61
                    };
                    n.clipboard.onPasteValue ? (n.clipboard.onPasteValue(_e576), _r106.value = _e576.value) : (_e576.cell = _r106, _e576.selectedValues = t, _e576.minRowIndex = _, _e576.maxRowIndex = f, _e576.minColumnIndex = b, _e576.maxColumnIndex = y, _e576.currentColumnIndex = _i500, _e576.currentRowIndex = _a304, "copy" === n.clipboard.autoFillMode ? n._pasteModeCopy(_e576) : "fillSeries" === n.clipboard.autoFillMode && n._pasteModeFill(_e576));
                  }
                }

                _l79++;
              }
            }

            _l78++;
          }

          C++, C >= w && (C = 0);
        }

        x++, x >= v && (x = 0);
      }

      n.endUpdate(!1), n._recycle(!1);
    }
  }, {
    key: "_refreshCellSelectionRect",
    value: function _refreshCellSelectionRect() {
      var e = Math.min,
          t = Math.max;
      var a = this,
          n = a._selection.selectionRect;
      if (!n || n && n.captured) return;
      var o = a._recyclingRows,
          i = n.row,
          r = n.endRow,
          l = n.column,
          s = n.endColumn;
      var d = o.indexOf(i),
          c = o.indexOf(r),
          m = a.columns.indexOf(l),
          u = a.columns.indexOf(s);

      var p = e(d, c),
          g = t(d, c),
          h = e(m, u),
          _ = t(m, u);

      h = t(0, h), p = t(0, p);

      var f = function f(i) {
        var n = o.indexOf(i.row),
            r = o.indexOf(i.endRow),
            l = a.columns.indexOf(i.column),
            s = a.columns.indexOf(i.endColumn);
        p = e(p, n), p = e(p, r), p = t(0, p), g = t(g, n), g = t(g, r), h = e(h, l), h = e(h, s), h = t(0, h), _ = t(_, l), _ = t(_, s);
      },
          b = a._getParentCell(i, l.dataField),
          y = a._getParentCell(i, s.dataField),
          v = a._getParentCell(r, s.dataField),
          w = a._getParentCell(r, l.dataField);

      b && f(b), y && f(y), v && f(v), w && f(w);
      var C = 0,
          x = 0,
          S = 0,
          D = 0;
      n.cellValues = [];

      for (var _e577 = p; _e577 <= g; _e577++) {
        var _t478 = o[_e577];

        if (_e577 === p && (C = _t478.top, !0 !== _t478.freeze && "near" !== _t478.freeze && (C += a.__frozenNearHeight), "far" === _t478.freeze && (C = _t478.top + a.__scrollHeight + a.scrollTop - a._scrollView.hScrollBar.offsetHeight)), _e577 === g) {
          var _e578 = _t478.top;
          "far" === _t478.freeze && (_e578 = _t478.top + a.__scrollHeight + a.scrollTop - a._scrollView.hScrollBar.offsetHeight), x = _e578 + _t478.height - C, !0 !== _t478.freeze && "near" !== _t478.freeze && (x += a.__frozenNearHeight);
        }

        n.cellValues[_t478.id] = [];

        for (var _e579 = h; _e579 <= _; _e579++) {
          var _i501 = a.columns[_e579].dataField,
              _o164 = _t478.getCell(_i501);

          if (n.cellValues[_t478.id][_i501] = _o164.value, _e579 === h && (S = _o164.column.left, _o164.column.freeze && "far" === _o164.column.freeze && (S = a.__clientSize.width - a.__frozenFarWidth + S + a.scrollLeft - a._scrollView.vScrollBar.offsetWidth)), _e579 === _) {
            var _e580 = _o164.column.left;
            _o164.column.freeze && "far" === _o164.column.freeze && (_e580 = a.__clientSize.width - a.__frozenFarWidth + _e580 + a.scrollLeft - a._scrollView.vScrollBar.offsetWidth), D = _e580 + _o164.column.computedWidth - S;
          }

          _o164.selected = !0;
        }
      }

      n.style.top = C - a.scrollTop - 1 + "px", n.style.left = S - a.scrollLeft + "px", n.style.height = x + 1 + "px", n.style.width = D + 1 + "px";
    }
  }, {
    key: "_renderInputOverlay",
    value: function _renderInputOverlay(e, t, i) {
      var a = this,
          n = a.rowById[e];

      if (n && n.allowSelect && !n.label && t && a.selection.checkBoxes.enabled) {
        a._inputOverlay && a._inputOverlay.classList.contains("smart-input-overlay-column") && (a._inputOverlay.parentNode && a._inputOverlay.parentNode.removeChild(a._inputOverlay), a._inputOverlay = null), a._inputOverlay || (a._inputOverlay = document.createElement("div"), a.$.scrollView.appendChild(a._inputOverlay), a._inputOverlay.classList.add("smart-input-overlay"));

        var _e581 = n.freeze ? n.top : a.__frozenNearHeight + n.top;

        var _o165 = Math.round((n.cellHeight - a._selectionColumn.computedWidth) / 2),
            _r107 = a._selectionColumn.element.parentElement.offsetLeft + a._selectionColumn.element.offsetLeft;

        a._inputOverlay.style.left = _r107 + "px", a._inputOverlay.style.height = a._selectionColumn.computedWidth + "px", a._inputOverlay.style.width = a._selectionColumn.computedWidth + "px", a._inputOverlay.style.top = _e581 + _o165 - a.scrollTop + "px", a._inputOverlay.row = n, a._inputOverlay.onpointerdown = function () {
          a._inputOverlay || (a._inputOverlay.onpointerdown = null);
          var e = a._inputOverlay.row;
          a.beginUpdate(), e.selected = !e.selected, a.endUpdate(!1), a._recycle(), a._renderInputOverlay(e.id, t, !0);
        }, a.appearance.allowCheckBoxesSelectionAnimation && void 0 === i && a._inputOverlay.classList.add("smart-animate"), requestAnimationFrame(function () {
          a._inputOverlay && a._inputOverlay.classList.add("smart-input-overlay-on");
        });
      }
    }
  }, {
    key: "_selectRow",
    value: function _selectRow(e, t) {
      var i = this,
          a = i.rowById[e];
      a && i.selection.enabled && (!a.header || "row-resize" !== a.header.style.cursor) && (t && (!t.shiftKey || !i._selection.focusedCell) && (i._selection.focusedCell = a.getCell(i.columns[0].dataField)), i._lastRowsSelectionRange = null, "extended" === i.selection.mode ? i._handleExtendedRowSelection(a, t) : "one" === i.selection.mode ? a.selected = !0 : a.selected = !a.selected);
    }
  }, {
    key: "_getParentCell",
    value: function _getParentCell(e, t) {
      var a = this;
      var i = a._recyclingRows;

      for (var _n244 = 0; _n244 < a._cellsMerge.length; _n244++) {
        var _o166 = a._cellsMerge[_n244];
        var _l81 = [],
            _s62 = [];

        if (_l81.push(_o166.row), 1 < _o166.rowSpan) {
          var _e582 = i.indexOf(_o166.row);

          if (0 <= _e582) for (var _t479 = _e582; _t479 < _e582 + _o166.rowSpan; _t479++) {
            i[_t479] && -1 === _l81.indexOf(i[_t479]) && _l81.push(i[_t479]);
          }
        }

        if (_s62.push(_o166.column.dataField), 1 < _o166.colSpan) {
          var _e583 = a.columns.indexOf(a.columnByDataField[_o166.column.dataField]);

          for (var _t480 = _e583; _t480 < _e583 + _o166.colSpan; _t480++) {
            a.columns[_t480] && -1 === _s62.indexOf(a.columns[_t480].dataField) && _s62.push(a.columns[_t480].dataField);
          }
        }

        if (0 <= _l81.indexOf(e) && 0 <= _s62.indexOf(t)) return {
          row: _o166.row,
          column: _o166.column,
          endRow: _l81[_l81.length - 1],
          endColumn: a.columnByDataField[_s62[_s62.length - 1]]
        };
      }

      return null;
    }
  }, {
    key: "_selectCellsRange",
    value: function _selectCellsRange(e, t, a, n) {
      var i = Math.min,
          o = Math.max;
      var r = this,
          l = r._selection.selectionRect;
      if (r._lastRowsSelectionRange && r._lastRowsSelectionRange.id === e.id && r._lastRowsSelectionRange.endId === t.id && r._lastColumnSelectionRange && r._lastColumnSelectionRange.dataField === a && r._lastColumnSelectionRange.endDataField === n) return;
      r.beginUpdate(), r._clearSelection(), r._lastRowsSelectionRange = {
        id: e.id,
        endId: t.id
      }, r._lastColumnSelectionRange = {
        dataField: a,
        endDataField: n
      }, (!l || l && !l.captured) && r._selection.focusedCell && r._renderCellSelectionRect(r._selection.focusedCell.row, r._selection.focusedCell.column, r.rowById[r._lastRowsSelectionRange.endId], r.columnByDataField[r._lastColumnSelectionRange.endDataField]);
      var s = r._recyclingRows,
          d = -1,
          c = r.columns.length,
          m = s.indexOf(e),
          u = s.indexOf(t);

      for (var _o167 = 0; _o167 < r.columns.length; _o167++) {
        var _e584 = r.columns[_o167];
        _e584.allowSelect && (_e584.dataField === a && (d = _o167), _e584.dataField === n && (c = _o167));
      }

      var p = i(m, u),
          g = o(m, u),
          h = i(d, c),
          _ = o(d, c);

      var f = function f(e) {
        var t = s.indexOf(e.row),
            a = s.indexOf(e.endRow),
            n = r.columns.indexOf(e.column),
            l = r.columns.indexOf(e.endColumn);
        p = i(p, t), p = i(p, a), g = o(g, t), g = o(g, a), h = i(h, n), h = i(h, l), _ = o(_, n), _ = o(_, l);
      },
          b = r._getParentCell(e, a),
          y = r._getParentCell(t, n);

      if (b && f(b), y && f(y), 0 > g || 0 > p) return r.endUpdate(!1), void r._recycle();

      for (var _o168 = p; _o168 <= g; _o168++) {
        var _e585 = s[_o168];
        if (_e585.allowSelect) for (var _t481 = 0; _t481 < r.columns.length; _t481++) {
          var _i502 = r.columns[_t481];

          if (_i502.allowSelect && _t481 >= h && _t481 <= _) {
            var _t482 = _e585.getCell(_i502.dataField);

            _t482.selected = !0;
          }
        }
      }

      r.endUpdate(!1), r._recycle();
    }
  }, {
    key: "_selectRowsRange",
    value: function _selectRowsRange(e, t) {
      var i = this;
      if (i._lastRowsSelectionRange && i._lastRowsSelectionRange.id === e.id && i._lastRowsSelectionRange.endId === t.id) return;
      i.beginUpdate(), i._clearSelection(), i._lastRowsSelectionRange = {
        id: e.id,
        endId: t.id
      };
      var a = i._recyclingRows;
      var n = a.indexOf(e),
          o = a.indexOf(t),
          r = Math.min(n, o),
          l = Math.max(n, o);
      if (0 > l) return i.endUpdate(!1), void i._recycle();

      for (var _n245 = r; _n245 <= l; _n245++) {
        var _e586 = a[_n245];
        _e586 && _e586.allowSelect && (_e586.selected = !0);
      }

      i.endUpdate(!1), i._recycle();
    }
  }, {
    key: "_selectColumnsRange",
    value: function _selectColumnsRange(e, t) {
      var a = this;
      if (a._lastColumnSelectionRange && a._lastColumnSelectionRange.dataField === e && a._lastColumnSelectionRange.endDataField === t) return;
      a.beginUpdate(), a._clearSelection(), a._lastColumnSelectionRange = {
        dataField: e,
        endDataField: t
      };
      var n = -1,
          o = a.columns.length;

      for (var _r108 = 0; _r108 < a.columns.length; _r108++) {
        var _i503 = a.columns[_r108];
        _i503.allowSelect && (_i503.dataField === e && (n = _r108), _i503.dataField === t && (o = _r108));
      }

      var r = Math.min(n, o),
          l = Math.max(n, o);

      for (var _n246 = 0; _n246 < a.columns.length; _n246++) {
        var _e587 = a.columns[_n246];
        _e587.allowSelect && _n246 >= r && _n246 <= l && (_e587.selected = !0);
      }

      a.endUpdate(!1), a._recycle();
    }
  }, {
    key: "_selectColumn",
    value: function _selectColumn(e, t) {
      var a = this,
          i = a.columnByDataField[e];
      if (i && a.selection.enabled && i.allowSelect && a.selection.allowColumnHeaderSelection && !(i && "col-resize" === i.element.style.cursor) && t) if ("extended" !== a.selection.mode) i.selected = "one" === a.selection.mode || null === i.selected || !i.selected;else if (t.ctrlKey || t.shiftKey || (a._rangeSelectionStartColumn = i, a._rangeSelectionEndColumn = i), i.selected = !0, t && t.shiftKey) {
        a._rangeSelectionStartColumn || (a._rangeSelectionStartColumn = i), a._rangeSelectionEndColumn = i, a._selection.columns = [];

        var _e588 = a.columns.indexOf(a._rangeSelectionStartColumn),
            _t483 = a.columns.indexOf(a._rangeSelectionEndColumn),
            _n247 = Math.min(_e588, _t483),
            _o169 = Math.max(_e588, _t483);

        for (var _e589 = _n247; _e589 <= _o169; _e589++) {
          var _t484 = a.columns[_e589];
          _t484.selected = !0;
        }
      }
    }
  }, {
    key: "_getSelectedRows",
    value: function _getSelectedRows(e, t) {
      var i = this,
          a = [];
      var n = i.rows;
      i.rows.canNotify = !1, e && (n = i.getVisibleRows()), i.paging.enabled && t && (n = n.slice(i.paging.pageIndex * i.paging.pageSize, (i.paging.pageIndex + 1) * i.paging.pageSize));

      for (var _o170 = 0; _o170 < n.length; _o170++) {
        var _e590 = n[_o170];
        _e590.getProperty("selected") ? a.push(_e590) : (_e590.canNotify = !1, _e590.selected = !1, _e590.canNotify = !0);
      }

      return i.rows.canNotify = !0, a;
    }
  }, {
    key: "_dragSelectionEnd",
    value: function _dragSelectionEnd(e) {
      var t = this;
      t._dragSelectionStartDataField = null, t._dragSelectionStartRow = null, t.__selectionStarted && (t.$.fireEvent("change", {
        started: !1,
        finished: !0,
        originalEvent: e
      }), delete t.__selectionStarted, delete t.__selectionStartedFired);
      t.selection.allowDragSelection && t.selection.isDragging && (t.selection.isDragging = !1, t._autoScrollSelectionDragInterval && (clearInterval(t._autoScrollSelectionDragInterval), !t.editing.isEditing && t._recycle()));
    }
  }, {
    key: "_dragSelection",
    value: function _dragSelection(e) {
      var t = this;

      if ("extended" === t.selection.mode && !1 !== t.selection.allowDragSelection && (t._dragSelectionStartDataField || t._dragSelectionStartRow)) {
        var _i504 = function _i504() {
          t.__selectionStarted && !t.__selectionStartedFired && (t.$.fireEvent("change", {
            started: !0,
            finished: !1,
            originalEvent: e
          }), t.__selectionStartedFired = !0), t.$.fireEvent("change", {
            started: !1,
            finished: !1,
            originalEvent: e
          });
        };

        if (t.selection.allowCellSelection && t._dragSelectionStartDataField && !t._columnResizeLine && !t._dragSelectionStartDataField.startsWith("_") && t._dragSelectionStartRow && !t._rowResizeLine) {
          var _a305 = (t.enableShadowDOM ? t.shadowRoot : t.getRootNode()).elementsFromPoint(e.clientX, e.clientY);

          var _n248 = null;

          for (var _e591 = 0; _e591 < _a305.length; _e591++) {
            var _t485 = _a305[_e591];

            if (_t485.getAttribute("data-field")) {
              _n248 = _t485.getAttribute("data-field");
              break;
            }
          }

          var _o171 = null;

          for (var _e592 = 0; _e592 < _a305.length; _e592++) {
            var _t486 = _a305[_e592];

            if (_t486.getAttribute("data-id")) {
              _o171 = _t486.row;
              break;
            }
          }

          if (_n248 && _o171) {
            if (_o171.id === t._dragSelectionStartRow.id && t._dragSelectionStartDataField === _n248) return;

            var _e593 = !0;

            t._lastRowsSelectionRange && t._lastRowsSelectionRange.id === t._dragSelectionStartRow.id && t._lastRowsSelectionRange.endId === _o171.id && t._lastColumnSelectionRange && t._lastColumnSelectionRange.dataField === t._dragSelectionStartDataField && t._lastColumnSelectionRange.endDataField === _n248 && (_e593 = !1), t._selectCellsRange(t._dragSelectionStartRow, _o171, t._dragSelectionStartDataField, _n248), _e593 && _i504();
          }

          return void (t.selection.allowDragSelectionAutoScroll && (t._autoScrollSelectionDragInterval && clearInterval(t._autoScrollSelectionDragInterval), t.selection.isDragging = !0, t._autoScrollSelectionDragInterval = setInterval(function () {
            var i = t.$.scrollView.getBoundingClientRect();
            e.clientX <= i.left + 20 ? t.scrollLeft -= 15 : e.clientX >= i.left + i.width - 20 && (t.scrollLeft += 15), e.clientY <= i.top + 20 ? t.scrollTop -= 15 : e.clientY >= i.top + i.height - 20 && (t.scrollTop += 15);
          }, 5)));
        }

        if (t._dragSelectionStartRow && !t._rowResizeLine && (t.selection.allowRowSelection && !t._dragSelectionStartDataField.startsWith("_") || t.selection.allowRowHeaderSelection && t._dragSelectionStartDataField.startsWith("_"))) {
          var _a306 = (t.enableShadowDOM ? t.shadowRoot : t.getRootNode()).elementsFromPoint(e.clientX, e.clientY);

          var _n249 = null;

          for (var _e594 = 0; _e594 < _a306.length; _e594++) {
            var _t487 = _a306[_e594];

            if (_t487.getAttribute("data-id")) {
              _n249 = _t487.row, !_n249 && _t487.cell && (_n249 = _t487.cell.row);
              break;
            }
          }

          var _o172 = !0;

          t._lastRowsSelectionRange && t._lastRowsSelectionRange.id === t._dragSelectionStartRow.id && t._lastRowsSelectionRange.endId === _n249.id && (_o172 = !1), _n249 && t._selectRowsRange(t._dragSelectionStartRow, _n249), t._autoScrollSelectionDragInterval && clearInterval(t._autoScrollSelectionDragInterval), t.selection.isDragging = !0, _o172 && _i504(), t._autoScrollSelectionDragInterval = setInterval(function () {
            var i = t.$.scrollView.getBoundingClientRect();
            e.clientY <= i.top + 20 ? t.scrollTop -= 15 : e.clientY >= i.top + i.height - 20 && (t.scrollTop += 15);
          }, 5);
        } else if (t._dragSelectionStartDataField && !t._columnResizeLine && !t._dragSelectionStartDataField.startsWith("_") && t.selection.allowColumnHeaderSelection) {
          var _a307 = (t.enableShadowDOM ? t.shadowRoot : t.getRootNode()).elementsFromPoint(e.clientX, e.clientY);

          var _n250 = null;

          for (var _e595 = 0; _e595 < _a307.length; _e595++) {
            var _t488 = _a307[_e595];

            if (_t488.getAttribute("data-field")) {
              _n250 = _t488.getAttribute("data-field");
              break;
            }
          }

          _n250 && t._selectColumnsRange(t._dragSelectionStartDataField, _n250), t._autoScrollSelectionDragInterval && clearInterval(t._autoScrollSelectionDragInterval);

          var _o173 = !0;

          t._lastColumnSelectionRange && t._lastColumnSelectionRange.dataField === t._dragSelectionStartDataField && t._lastColumnSelectionRange.endDataField === _n250 && (_o173 = !1), _o173 && _i504(), t.selection.isDragging = !0, t._autoScrollSelectionDragInterval = setInterval(function () {
            var i = t.$.scrollView.getBoundingClientRect();
            e.clientX <= i.left + 20 ? t.scrollLeft -= 15 : e.clientX >= i.left + i.width - 20 && (t.scrollLeft += 15);
          }, 5);
        }
      }
    }
  }, {
    key: "select",
    value: function select(e, t) {
      var i = this;
      i._setSelection(e, t), i.$.fireEvent("change", {
        started: !1,
        finished: !0
      });
    }
  }, {
    key: "selectRange",
    value: function selectRange(e, t, i, a) {
      var n = this;
      (function () {
        var o = new KeyboardEvent("keydown", {
          shiftKey: !0
        });
        requestAnimationFrame(function () {
          "extended" !== n.selection.mode && n._clearSelection(), n.beginUpdate(), n._setSelection(e, t), n._setSelection(i, a, o), n.ensureVisible(e, t), n.endUpdate(!1), n._recycle();
        });
      })(), n.$.fireEvent("change", {
        started: !1,
        finished: !0
      });
    }
  }, {
    key: "unselect",
    value: function unselect(e, t) {
      var i = this;
      i._selection && (i._selection.rows && i._selection.rows[e] && delete i._selection.rows[e], i._selection.columns && i._selection.columns[t] && delete i._selection.columns[t], i._selection.cells && (i._selection.cells["row" + e] && (delete i._selection.cells["row" + e][t], 1 === Object.getOwnPropertyNames(i._selection.cells["row" + e]).length && delete i._selection.cells["row" + e]), i._selection.cells["column" + t] && (delete i._selection.cells["column" + t][e], 1 === Object.getOwnPropertyNames(i._selection.cells["column" + t]).length && delete i._selection.cells["column" + t])), i.$.fireEvent("change", {
        started: !1,
        finished: !0
      }));
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      var e = this;
      var t = null,
          a = null,
          i = null,
          n = null;

      if (e._selection.rows && 0 < Object.keys(e._selection.rows).length) {
        var _a308 = Object.keys(e._selection.rows);

        t = [];

        for (var _n251 = 0; _n251 < _a308.length; _n251++) {
          var _i505 = _a308[_n251];
          t.push({
            id: _i505,
            row: e.rowById[_i505]
          });
        }
      }

      if (e._selection.columns && 0 < Object.keys(e._selection.columns).length) {
        var _t489 = Object.keys(e._selection.columns);

        a = [];

        for (var _n252 = 0; _n252 < _t489.length; _n252++) {
          var _i506 = _t489[_n252];
          a.push({
            dataField: _i506,
            column: e.columnByDataField[_i506]
          });
        }
      }

      if (e._selection.cells) for (var _t490 in e._selection.cells) {
        if (_t490.startsWith("row")) {
          var _a309 = _t490.replace("row", ""),
              _n253 = null;

          for (var _o174 in e._selection.cells[_t490]) {
            _n253 = _o174.replace("column", ""), i || (i = []), i.push({
              id: _a309,
              dataField: _n253,
              column: e.columnByDataField[_n253],
              row: e.rowById[_a309]
            });
          }
        }
      }
      return e._selection.focusedCell && (n = {
        id: e._selection.focusedCell.row.id,
        dataField: e._selection.focusedCell.column.dataField
      }), {
        rows: t,
        columns: a,
        cells: i,
        focused: n
      };
    }
  }, {
    key: "_clearSelection",
    value: function _clearSelection(e) {
      var t = this;

      if (t._selection.rows = [], t._selection.columns = [], t._selection.cells = [], e && (t._selection.focusedCell = null, t._selection.selectionRect)) {
        var _e596 = t._selection.selectionRect;

        _e596.parentNode.removeChild(_e596);

        var _i507 = {
          down: "pointerdown",
          move: "pointermove",
          up: "pointerup"
        };
        Smart.Utilities.Core.isMobile && (_i507.down = "touchstart", _i507.move = "touchmove", _i507.up = "touchend"), document.removeEventListener(_i507.move, _e596.onMove), document.removeEventListener(_i507.up, _e596.onUp), document.removeEventListener(_i507.down, _e596.onDown), t._selection.selectionRect = null;
      }

      t._recycle();

      var i = t._selectionColumn;
      i.refresh();
    }
  }, {
    key: "_getSelectionCellValues",
    value: function _getSelectionCellValues() {
      var e = this;
      if (e._selection.selectionRect) return e._selection.selectionRect.cellValues;

      if (0 < e._selection.rows.length) {
        var _t491 = [];

        for (var _i508 in e._selection.rows) {
          var _a310 = e.rowById[_i508];

          for (var _n254 = 0; _n254 < e.columns.length; _n254++) {
            var _o175 = e.columns[_n254];
            _o175 && (_t491[_i508] || (_t491[_i508] = []), _t491[_i508][_o175.dataField] = _a310.data[_o175.dataField]);
          }
        }

        return _t491;
      }

      if (0 < e._selection.columns.length) {
        var _t492 = [];

        for (var _i509 in e._selection.columns) {
          var _a311 = e.columnByDataField[_i509];
          if (_a311) for (var _i510 = 0; _i510 < e._recyclingRows.length; _i510++) {
            var _n255 = e._recyclingRows[_i510];
            _n255 && (_t492[_n255.id] || (_t492[_n255.id] = []), _t492[_n255.id][_a311.dataField] = _n255.data[_a311.dataField]);
          }
        }

        return _t492;
      }
    }
  }, {
    key: "_clipboardHandler",
    value: function _clipboardHandler(e, t) {
      var i = this;

      if (i.clipboard.enabled) {
        if (t.ctrlKey && ("c" === e || "x" === e)) {
          var _t493 = i._getSelectionCellValues();

          var _a312 = "",
              _n256 = Object.keys(_t493).length,
              _o176 = 0;

          for (var _i511 in _t493) {
            var _r109 = "",
                _l82 = Object.keys(_t493[_i511]).length,
                _s63 = 0;

            for (var _e597 in _t493[_i511]) {
              var _a313 = _t493[_i511][_e597];
              _r109 += _a313, _s63++, _s63 < _l82 && (_r109 += "\t");
            }

            _a312 += _r109, _o176++, _o176 < _n256 && (_a312 += "\r\n"), "x" === e;
          }

          navigator.clipboard.writeText(_a312).then(function () {}, function () {});
        }

        t.ctrlKey && "v" === e && navigator.clipboard.readText().then(function (e) {
          var t = [],
              a = e.split("\r");

          for (var _n257 = 0; _n257 < a.length; _n257++) {
            var _e598 = a[_n257],
                _i512 = _e598.split("\t");

            var _o177 = {};

            for (var _e599 = 0; _e599 < _i512.length; _e599++) {
              _o177[_e599] = _i512[_e599].trim();
            }

            t[_n257] = _o177;
          }

          var n = i._selection.selectionRect;
          if (n) i._pasteSelectedCells({
            row: n.row,
            endRow: n.endDragRow,
            column: n.column,
            endColumn: n.endColumn
          }, t);else {
            var _e600 = null,
                _a314 = null;

            for (var _t494 in i._selection.rows) {
              var _n258 = i.rowById[_t494];
              _e600 || (_e600 = _n258), _a314 || (_a314 = _n258), _e600.visibleIndex > _n258.visibleIndex && (_e600 = _n258), _a314.visibleIndex < _n258.visibleIndex && (_a314 = _n258);
            }

            _e600 && _a314 && i._pasteSelectedCells({
              row: _e600,
              endRow: _a314,
              column: i.columns[0],
              endColumn: i.columns[i.columns.length - 1]
            }, t);
          }
        });
      }
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this;
      if (t.onKey && (t.onKey(e), e.defaultPrevented)) return;
      var i = e.key;
      if (t.disabled) return;
      if (0 === t.dataSource.length || t.disabled || t.displayLoadingIndicator) return;
      if (t.editing.editRow || t.editing.editCell) return;

      t._refreshCellSelectionRect();

      var a = t.getSelection();
      var n = a.focused;

      if (!a.focused) {
        if (t.editing.enabled && !0 !== t.editing.isEditing && ("F2" === i || "Enter" === i) && a.columns && 0 < a.columns.length) {
          var _e601 = a.columns[a.columns.length - 1];
          _e601.column.allowHeaderEdit && t._beginColumnEdit(_e601.column);
        }

        return;
      }

      var o = t._getParentCell(t.rowById[n.id], n.dataField);

      if (o && ("ArrowLeft" === i ? (n.id = o.row.id, n.dataField = o.column.dataField) : "ArrowRight" === i ? (n.id = o.row.id, n.dataField = o.endColumn.dataField) : "ArrowUp" === i ? (n.id = o.row.id, n.dataField = o.column.dataField) : "ArrowDown" === i && (n.id = o.endRow.id, n.dataField = o.column.dataField)), t._selection.selectionRect && e.shiftKey && !e.ctrlKey ? (t._selection.selectionRect.endRow && (n.id = t._selection.selectionRect.endRow.id), t._selection.selectionRect.endColumn && (n.dataField = t._selection.selectionRect.endColumn.dataField)) : t.selection.allowRowSelection && !t.selection.allowCellSelection && void 0 !== t._rangeSelectionEndRow && (n.id = t._rangeSelectionEndRow.id), t._clipboardHandler(i, e), (e.ctrlKey && "x" !== i && "c" !== i && "v" !== i && "Control" !== i || "Tab" === i) && (t._selection.rows = [], t._selection.columns = [], t._selection.cells = []), "Escape" === i) return t.closeMenu(), t.cancelEdit(), void t._setSelection(n.id, n.dataField, e);

      if (!t.hasMenu()) {
        if (e.altKey) {
          if ("ArrowDown" === i) {
            var _i513 = t.columnByDataField[n.dataField];
            _i513 && t.hasColumnMenu(_i513) && (_i513.showActionButton = !0, _i513.onAction(), t.menu && (t.menu.querySelector("smart-menu").focus(), t.menu.querySelector("smart-menu").$.dispatch(e)));
          } else "ArrowUp" === i && t.closeMenu();

          if ("s" === i.toLowerCase()) {
            var _e602 = t.columnByDataField[n.dataField];
            _e602 && (_e602.sorted ? "asc" === _e602.sortOrder ? t.sortBy(_e602.dataField, "desc") : t.sortBy(_e602.dataField, null) : t.sortBy(_e602.dataField, "asc"));
          }

          if ("g" === i.toLowerCase()) {
            var _e603 = t.columnByDataField[n.dataField];
            _e603 && (_e603.group = !_e603.group);
          }

          return;
        }

        var _o178 = function _o178(i, a) {
          requestAnimationFrame(function () {
            "extended" !== t.selection.mode && t._clearSelection(), t.beginUpdate(), t._setSelection(i, a, e), t.ensureVisible(i, a), t.endUpdate(!1), t._recycle();
          }), e.stopPropagation(), e.preventDefault();
        };

        switch (i) {
          case "Tab":
            {
              var _i514 = e.shiftKey ? t.prevColumn(n.dataField) : t.nextColumn(n.dataField);

              if (_i514) t._selection.focusedCell = t.rowById[n.id].getCell(_i514.dataField), t._setSelection(n.id, _i514.dataField, e), t.focus(), e.stopPropagation(), e.preventDefault();else {
                var _i515 = e.shiftKey ? t.prevRow(n.id) : t.nextRow(n.id),
                    _a315 = e.shiftKey ? t.lastColumn().dataField : t.firstColumn().dataField;

                if (t.editing.addNewRow.autoCreate && !e.shiftKey && n.id === t.lastRow().id && (t.addUnboundRow(1), _i515 = t.lastRow()), !_i515) return;
                e.shiftKey && (t._selection.focusedCell = null), _o178(_i515.id, _a315);
              }
              break;
            }

          case " ":
          case "F2":
            {
              var _e604 = t.rowById[n.id];
              if (!_e604 || t.editing.editCell) return;
              " " === i && t.dataSource.boundHierarchy && (_e604.checked = !_e604.checked), t.editing.enabled && (t._beginEdit(_e604, n.dataField), setTimeout(function () {
                if (t.editing.editCell && 0 <= t.editing.editCell.column.dataType.indexOf("bool")) {
                  var _e605 = t.editing.editCell.editor.instance,
                      _i516 = _e605.getValue();

                  _e605.setValue(!_i516);
                }
              }, 50));
              break;
            }

          case "Delete":
          case "Backspace":
            {
              var _e606 = t.rowById[n.id];
              if (!_e606 || t.editing.editCell) return;

              var _o179 = _e606.getCell(n.dataField),
                  _r110 = _o179.value;

              if (a.cells) {
                t.beginUpdate();

                for (var _e607 = 0; _e607 < a.cells.length; _e607++) {
                  var _i517 = a.cells[_e607],
                      _n259 = t.rowById[_i517.id];

                  if (_n259) {
                    var _e608 = _n259.getCell(_i517.dataField);

                    _e608.value = null;
                  }
                }

                t.endUpdate(!1), t._recycle();
              }

              "Backspace" === i && (t._beginEdit(_e606, n.dataField), _o179.canNotify = !1, _o179.value = _r110, _o179.canNotify = !0);
              break;
            }

          default:
            {
              if (t.editing.enabled && !t.editing.editCell && !e.ctrlKey && !e.altKey && !t.editing.editRow) {
                var _e609 = t.rowById[n.id];
                if (!_e609) return;
                if (0 <= ["F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "Shift", "Up", "Down", "Left", "Right", "Control", "F2", "Esc", " ", "Home", "End", "PageUp", "PageDown"].indexOf(i)) return;
                t._beginEdit(_e609, n.dataField), setTimeout(function () {
                  if (t.editing.editCell) t.editing.editCell.editor.instance.setValue(i);else if (t.editing.editRow) {
                    var _e610 = t.editing.editRow.getCell(n.dataField);

                    if (!_e610) return;

                    _e610.editor.instance.setValue(i);
                  }
                }, 50);
              }

              break;
            }

          case "Home":
            {
              var _e611 = t.firstRow();

              if (!_e611) return;

              _o178(_e611.id, n.dataField);

              break;
            }

          case "End":
            {
              var _e612 = t.lastRow();

              if (!_e612) return;

              _o178(_e612.id, n.dataField);

              break;
            }

          case "PageUp":
            {
              var _e613 = t._recyclingRows,
                  _a316 = t.rowById[n.id],
                  _r111 = _e613.indexOf(_a316);

              for (var _l83 = _r111; 0 <= _l83; _l83--) {
                var _i518 = _e613[_l83];
                if (_a316.top - _i518.top >= t.$.scrollView.offsetHeight) return void _o178(_i518.id, n.dataField);
              }

              _o178(t.firstRow().id, n.dataField);

              break;
            }

          case "PageDown":
            {
              var _e614 = t._recyclingRows,
                  _a317 = t.rowById[n.id],
                  _r112 = _e614.indexOf(_a317);

              for (var _l84 = _r112; _l84 < _e614.length; _l84++) {
                var _i519 = _e614[_l84];
                if (_i519.top - _a317.top >= t.$.scrollView.offsetHeight) return void _o178(_i519.id, n.dataField);
              }

              _o178(t.lastRow().id, n.dataField);

              break;
            }

          case "ArrowDown":
          case "Enter":
            {
              var _a318 = e.ctrlKey ? t.lastRow() : t.nextRow(n.id);

              if (t.editing.addNewRow.autoCreate && "Enter" === i && n.id === t.lastRow().id && (t.addUnboundRow(1), _a318 = t.lastRow()), !_a318) return;

              _o178(_a318.id, n.dataField);

              break;
            }

          case "ArrowUp":
            {
              var _i520 = e.ctrlKey ? t.firstRow() : t.prevRow(n.id);

              if (!_i520) return;

              _o178(_i520.id, n.dataField);

              break;
            }

          case "ArrowRight":
            {
              var _i521 = t.rowById[n.id];
              if (!1 === _i521.leaf) if (!_i521.expanded) return void _i521.expand();else {
                var _e615 = t.nextRow(n.id);

                if (_e615) return void _o178(_e615.id, n.dataField);
              }

              var _a319 = e.ctrlKey ? t.lastColumn() : t.nextColumn(n.dataField);

              if (!_a319) return;

              _o178(n.id, _a319.dataField);

              break;
            }

          case "ArrowLeft":
            {
              var _i522 = t.rowById[n.id];
              if (!1 === _i522.leaf) return void (_i522.expanded ? _i522.collapse() : _i522.parent && _o178(_i522.parent.id, n.dataField));
              if (!0 === _i522.leaf && _i522.parent) return void _o178(_i522.parent.id, n.dataField);

              var _a320 = e.ctrlKey ? t.firstColumn() : t.prevColumn(n.dataField);

              if (!_a320) return;

              _o178(n.id, _a320.dataField);

              break;
            }
        }

        0 > ["Shift", "Up", "Down", "Left", "Right", "Control", "F2", "Esc", " ", "Home", "End", "PageUp", "PageDown"].indexOf(i) || (e.stopPropagation(), e.preventDefault());
      }
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler() {
      var e = this;
      !e._focused;
    }
  }, {
    key: "firstRow",
    value: function firstRow() {
      var e = this,
          t = e._recyclingRows;

      if (t && 0 < t.length) {
        if (!t[0].autoGenerated) return t[0];

        for (var _e616 = 0; _e616 < t.length; _e616++) {
          if (!t[_e616].autoGenerated) return t[_e616];
        }
      }

      return null;
    }
  }, {
    key: "lastRow",
    value: function lastRow() {
      var e = this,
          t = e._recyclingRows;

      if (t && 0 < t.length) {
        var _e617 = t[t.length - 1];
        if (!_e617.autoGenerated) return _e617;

        for (var _e618 = t.length - 1; 0 <= _e618; _e618--) {
          if (!t[_e618].autoGenerated) return t[_e618];
        }
      }

      return null;
    }
  }, {
    key: "nextRow",
    value: function nextRow(e) {
      var t = this,
          i = t._recyclingRows,
          a = t.rowById[e],
          n = i.indexOf(a);
      return 0 <= n && i[n + 1] && !i[n + 1].autoGenerated ? i[n + 1] : null;
    }
  }, {
    key: "prevRow",
    value: function prevRow(e) {
      var t = this,
          i = t._recyclingRows,
          a = t.rowById[e],
          n = i.indexOf(a);
      return 0 <= n && i[n - 1] && !i[n - 1].autoGenerated ? i[n - 1] : null;
    }
  }, {
    key: "firstColumn",
    value: function firstColumn() {
      var e = this,
          t = e.columns;
      return t && 0 < t.length ? t[0] : null;
    }
  }, {
    key: "lastColumn",
    value: function lastColumn() {
      var e = this,
          t = e.columns;
      return t && 0 < t.length ? t[t.length - 1] : null;
    }
  }, {
    key: "nextColumn",
    value: function nextColumn(e) {
      var t = this,
          i = t.columns,
          a = t.columnByDataField[e],
          n = i.indexOf(a);
      return i[n + 1] ? i[n + 1] : null;
    }
  }, {
    key: "prevColumn",
    value: function prevColumn(e) {
      var t = this,
          i = t.columns,
          a = t.columnByDataField[e],
          n = i.indexOf(a);
      return i[n - 1] ? i[n - 1] : null;
    }
  }, {
    key: "isVisible",
    value: function isVisible(e, t) {
      var i = this,
          a = i._scrollView.vScrollBar,
          n = i._scrollView.hScrollBar,
          o = i.rowById[e],
          r = i.columnByDataField[t],
          l = function (e) {
        if (!e) return !1;
        var t = e.visibleIndex;
        return -1 !== t && !(e.top + e.height + n.offsetHeight + i.__frozenNearHeight >= i._scrollView.scrollTop + i.$.scrollView.offsetHeight - i.__frozenFarHeight) && !(e.top <= i._scrollView.scrollTop);
      }(o),
          s = function (e) {
        if (!t) return !1;
        var n = e.visibleIndex;
        return -1 !== n && !(e.left + e.computedWidth + a.offsetWidth >= i._scrollView.scrollLeft + i._clientSize.width) && !(e.left <= i._scrollView.scrollLeft);
      }(r);

      return {
        row: l,
        column: s
      };
    }
  }, {
    key: "ensureVisible",
    value: function ensureVisible(e, t) {
      var i = this,
          a = i._scrollView.vScrollBar,
          n = i._scrollView.hScrollBar,
          o = i.rowById[e],
          r = i.columnByDataField[t];

      (function (e) {
        if (e) {
          var _t495 = e.visibleIndex;
          -1 === _t495 || (e.top + e.height + n.offsetHeight + i.__frozenNearHeight >= i._scrollView.scrollTop + i.$.scrollView.offsetHeight - i.__frozenFarHeight && (i._scrollView.scrollTop = e.top + e.height), e.top <= i._scrollView.scrollTop && (i._scrollView.scrollTop = e.top), 0 === _t495 ? i._scrollView.scrollTop = 0 : _t495 === i.dataSource.length - 1 && (i._scrollView.scrollTop = i._scrollView.scrollHeight));
        }
      })(o);

      (function (e) {
        if (t) {
          var _t496 = e.visibleIndex;
          -1 === _t496 || (e.left + e.computedWidth + a.offsetWidth >= i._scrollView.scrollLeft + i._clientSize.width && (i._scrollView.scrollLeft += e.computedWidth), e.left <= i._scrollView.scrollLeft && (i._scrollView.scrollLeft = e.left), 0 === _t496 ? i._scrollView.scrollLeft = 0 : _t496 === i.columns.length - 1 && (i._scrollView.scrollLeft = i._scrollView.scrollWidth));
        }
      })(r);
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      var e = this;
      e._clearSelection(!0), e.$.fireEvent("change", {
        started: !1,
        finished: !0
      });
    }
  }]);

  return _class58;
}()), Smart.Utilities.Assign("Grid.Edit",
/*#__PURE__*/
function () {
  "use strict";

  function _class59() {
    _classCallCheck(this, _class59);
  }

  _createClass(_class59, [{
    key: "_renderCommandBar",
    value: function _renderCommandBar() {
      var e = this,
          t = e.editing.commandBar.dataSource,
          i = function (_i523) {
        function i(_x5) {
          return _i523.apply(this, arguments);
        }

        i.toString = function () {
          return _i523.toString();
        };

        return i;
      }(function (i) {
        var _loop23 = function _loop23(_a321) {
          var n = t[_a321],
              o = document.createElement("div");
          o.classList.add("smart-grid-command-item"), o.label = e.localize(_a321), n.icon && (o.innerHTML = "<span class=\"smart-grid-icon " + n.icon + "\"></span><span class=\"smart-grid-label\">" + o.label + "</span>"), n.visible || o.classList.add("smart-hidden"), o.command = n.command, o.onclick = function () {
            var t = o.command;

            e._applyCommand(t, []);
          }, i.appendChild(o);
        };

        for (var _a321 in t) {
          _loop23(_a321);
        }
      });

      e.editing.enabled && e.editing.commandBar.visible && (e.$.headerCommandBar.innerHTML = "", e.$.footerCommandBar.innerHTML = "", "far" !== e.editing.commandBar.position && i(e.$.headerCommandBar), "near" !== e.editing.commandBar.position && i(e.$.footerCommandBar));
    }
  }, {
    key: "commandKeyEditCommand",
    value: function commandKeyEditCommand() {
      var e = this;

      if (e._selection && e._selection.focusedCell && e._selection.focusedCell.row) {
        var _t497 = e._selection.focusedCell.row;
        e.beginEdit(_t497.id);
      }
    }
  }, {
    key: "commandKeyCancelCommand",
    value: function commandKeyCancelCommand() {
      var e = this;
      e.cancelEdit();
    }
  }, {
    key: "commandKeyUpdateCommand",
    value: function commandKeyUpdateCommand() {
      var e = this;
      e.endEdit();
    }
  }, {
    key: "commandColumnMenuCommand",
    value: function commandColumnMenuCommand() {
      var e = this;

      e._openColumnChooserMenu(e._commandColumn);
    }
  }, {
    key: "commandColumnEditCommand",
    value: function commandColumnEditCommand(e) {
      var t = this;
      t.beginEdit(e.id);
    }
  }, {
    key: "commandColumnUpdateCommand",
    value: function commandColumnUpdateCommand() {
      var e = this;
      e.endEdit();
    }
  }, {
    key: "commandColumnRowMenuCommand",
    value: function commandColumnRowMenuCommand() {}
  }, {
    key: "commandColumnCancelCommand",
    value: function commandColumnCancelCommand(e) {
      var t = this;

      if (t.editing.batch) {
        var _i524 = t._rowsDeleted ? t._rowsDeleted.indexOf(e) : -1;

        0 <= _i524 && t._rowsDeleted.splice(_i524, 1);

        for (var _a322 = 0; _a322 < t.columns.length; _a322++) {
          var _i525 = t.columns[_a322].dataField;
          t._cellsUpdatedValues && t._cellsUpdatedValues[e.id + "_" + _i525] && (delete t._cellsUpdatedValues[e.id + "_" + _i525], t._cellsUpdatedValues.length--);
        }

        t._recycle(!1);
      }

      t.cancelEdit();
    }
  }, {
    key: "commandColumnDeleteCommand",
    value: function commandColumnDeleteCommand(e) {
      var t = this;
      t.deleteRow(e.id);
    }
  }, {
    key: "_renderAddNewRow",
    value: function _renderAddNewRow() {
      var e = this;
      e._frozenNearDefaultRows = [], e._frozenFarDefaultRows = [];
      var t = new Smart.Grid.Row({
        data: {},
        index: -1,
        grid: e,
        freeze: "near",
        visible: "far" !== e.editing.addNewRow.position,
        autoGenerated: !0,
        addNewRow: !0
      }),
          i = new Smart.Grid.Row({
        data: {},
        index: -2,
        grid: e,
        freeze: "far",
        visible: "near" !== e.editing.addNewRow.position,
        autoGenerated: !0,
        addNewRow: !0
      });

      if (e._newNearRow) {
        var _t498 = e._frozenNearRows.indexOf(e._newNearRow);

        if (0 <= _t498 && (e._frozenNearRows.splice(_t498, 1), 0 < e.$.rowNearContainer.children.length)) {
          var _t499 = e.$.rowNearContainer.children[0];

          _t499.parentNode.removeChild(_t499);
        }
      }

      if (e._newFarRow) {
        var _t500 = e._frozenFarRows.indexOf(e._newFarRow);

        if (0 <= _t500 && (e._frozenFarRows.splice(_t500, 1), 0 < e.$.rowFarContainer.children.length)) {
          var _t501 = e.$.rowFarContainer.children[e.$.rowFarContainer.children.length - 1];

          _t501.parentNode.removeChild(_t501);
        }
      }

      if (e.editing.addNewRow.visible && (e._frozenNearDefaultRows.push(t), e._frozenFarDefaultRows.push(i), e._frozenNearRows.splice(0, 0, t), e._frozenFarRows.push(i)), e._scrollView.vScrollBar.$.farButton.addEventListener("click", function () {
        e.editing.addNewRow.autoCreate && e._scrollView.vScrollBar.value === e._scrollView.vScrollBar.max && (e.addUnboundRow(1), e._scrollView.vScrollBar.value = e._scrollView.vScrollBar.max);
      }), e._newNearRow = t, e._newFarRow = i, e.editing.addNewRow.visible) {
        if (!e._newNearRow.element) {
          var _t502 = e._newNearRow,
              _i526 = _t502.createElement();

          _t502.visible = "far" !== e.editing.addNewRow.position, _t502.element = _i526, 0 < e.$.rowNearContainer.children.length ? e.$.rowNearContainer.insertBefore(_i526, e.$.rowNearContainer.children[0]) : e.$.rowNearContainer.appendChild(_i526);
        }

        if (!e._newFarRow.element) {
          var _t503 = e._newFarRow,
              _i527 = _t503.createElement();

          _t503.visible = "near" !== e.editing.addNewRow.position, _t503.element = _i527, 0 < e.$.rowFarContainer.children.length ? e.$.rowFarContainer.insertBefore(_i527, e.$.rowFarContainer.children[0]) : e.$.rowFarContainer.appendChild(_i527);
        }
      }
    }
  }, {
    key: "_insertNewRowAfter",
    value: function _insertNewRowAfter(e) {
      var t = this;
      return t._insertNewRowBefore(e, !0);
    }
  }, {
    key: "_insertNewRowBefore",
    value: function _insertNewRowBefore(e, t) {
      var i = this,
          a = new Smart.Grid.Row({
        index: t ? 0 : -1,
        id: Smart.Utilities.Core.createGUID(),
        grid: i
      }),
          n = function (t, a) {
        !0 === i.editing.batch || i.editing.batch && 0 <= i.editing.batch.indexOf("add") ? i._batchAddRow(t, a ? i.rows.length : 0) : (t.index = i.rows.length, i._add(t, a ? i.rows.length : 0)), i.scrollTop = a ? i.scrollHeight : 0, i.editing.addDialog.enabled || setTimeout(function () {
          i.editing.enabled && i._beginEdit(t);
        }, 100), e && e(t);
      }.bind(this);

      return i.editing.addDialog.enabled ? i._openAddRowDialog(a, n) : n(a, t), !0;
    }
  }, {
    key: "commandBarBatchSaveCommand",
    value: function commandBarBatchSaveCommand() {
      var e = this;

      e._saveBatchEdit();
    }
  }, {
    key: "commandBarAddRowCommand",
    value: function commandBarAddRowCommand() {
      var e = this;

      e._insertNewRowAfter();
    }
  }, {
    key: "commandBarAddTopRowCommand",
    value: function commandBarAddTopRowCommand() {
      var e = this;

      e._insertNewRowBefore();
    }
  }, {
    key: "commandBarDeleteRowCommand",
    value: function commandBarDeleteRowCommand() {
      var e = this;
      var t = 1,
          i = e.rows[e.rows.length - t];

      for (e._rowsDeleted || (e._rowsDeleted = []); 0 <= e._rowsDeleted.indexOf(e.rows[e.rows.length - t]);) {
        t++;
      }

      i = e.rows[e.rows.length - t], i && e.commandColumnDeleteCommand(i);
    }
  }, {
    key: "commandBarBatchRevertCommand",
    value: function commandBarBatchRevertCommand() {
      var e = this;
      e.revertBatchEdit();
    }
  }, {
    key: "_beginEdit",
    value: function _beginEdit(e, t) {
      var i = this;
      t || (t = i.columns[0].dataField);
      var a = i.columnByDataField[t];
      if (i.editing.allowColumnHeaderEdit && !e && a) return void i._beginColumnEdit(a);
      if (!e || !a || a && a.autoGenerated) return !1;
      var n = e.getCell(t);
      return !!n && void ("cell" === i.editing.mode ? i._beginCellEdit(n) : "row" === i.editing.mode && i._beginRowEdit(e, n), i.$.fireEvent("beginEdit", {
        row: e,
        column: a,
        cell: n
      }));
    }
  }, {
    key: "_saveUnboundRows",
    value: function _saveUnboundRows(e) {
      var t = this;

      if (t._unboundRows && 0 < t._unboundRows.length && t.editing.addNewRow.autoSave) {
        var _i528 = t.rowById[e];
        if (!_i528.unbound) return;

        var _a323 = t._unboundRows.indexOf(_i528);

        if (0 > _a323) return;

        var _n260 = _a323 + 1;

        t.beginUpdate();

        for (var _e619 = 0; _e619 < _n260; _e619++) {
          var _i529 = t._unboundRows[_e619];
          if (!_i529) continue;
          delete t.rowById[_i529.id], _i529.unbound = !1;

          var _a324 = !1;

          t._selection.focusedCell && t._selection.focusedCell.row.id === _i529.id && (_a324 = !0), t._nearRowsAdded && 0 <= t._nearRowsAdded.indexOf(_i529) ? (t._nearRowsAdded.splice(t._nearRowsAdded.indexOf(_i529), 1), t._add(0, _i529.data), _a324 && (t._selection.focusedCell.row = t.rows[0])) : t._farRowsAdded && 0 <= t._farRowsAdded.indexOf(_i529) && (t._farRowsAdded.splice(t._farRowsAdded.indexOf(_i529), 1), t._add(_i529.data), _a324 && (t._selection.focusedCell.row = t.rows[t.rows.length - 1]));
        }

        t._unboundRows.splice(0, _n260), t.endUpdate();
      }
    }
  }, {
    key: "_endCellEdit",
    value: function _endCellEdit(e) {
      var t = this,
          i = e || t.editing.editCell;
      if (!i || i && !i.isEditing) return null;

      var a = t._getEditorValue(i);

      if ("invalid value" === a) return i.setAttribute("error", ""), !1;

      var n = function n() {
        var e = t._getEditorId(i),
            n = t._cellEditors[e];

        n.detach(), i.row.element.removeAttribute("edit"), i.element.removeAttribute("editor"), i.element.removeAttribute("error"), i.isEditing = !1, i.element.content.innerHTML = "";

        var o = function o() {
          t.editing.editRow || t._recycle(!1);
        },
            r = t._cellsUpdatedValues ? t._cellsUpdatedValues[i.row.id + "_" + i.column.dataField] : void 0,
            l = void 0 === r ? i.value : r;

        if (!function (e, t) {
          return "date" === i.column.dataType ? e.valueOf() === t.valueOf() : e === t;
        }(a, l)) {
          var _e620 = function _e620() {
            t.editing.editCell = null, t.editing.editRow || (t.editing.isEditing = !1);
          };

          if (!0 === t.editing.batch || t.editing.batch && 0 <= t.editing.batch.indexOf("update")) _e620(), t._batchUpdateCell(i.row, i.column, a, i.value), o();else {
            (function () {
              _e620(), i._updating = !0, i.value = a, i._updating = !1, o();
            })();
          }
        } else t.editing.editCell = null, t.editing.editRow || (t.editing.isEditing = !1, o());

        return t.editing.commandColumn.visible && !t.editing.commandColumn.width && "cell" === t.editing.mode && t.refresh(), t.focus(), !0;
      };

      if (t.onCellUpdate) {
        t.beginUpdate(), t.appearance.displayLoadingIndicator = !0, t._setLoadingIndicatorVisibility();

        var _e621 = t._createOverlay();

        t.$.root.appendChild(_e621), t.onCellUpdate(i, t.oldValue, a, function (i) {
          i ? n() : t.cancelEdit(), t.appearance.displayLoadingIndicator = !1, t._setLoadingIndicatorVisibility(), _e621.parentNode.removeChild(_e621), t.endUpdate();
        });
      } else n();
    }
  }, {
    key: "_endRowEdit",
    value: function _endRowEdit() {
      var e = this,
          t = e.editing.editRow;
      if (!t) return !1;
      var a = !0;
      var n = t.cells;
      var o = {},
          r = {};

      for (var _t504 = 0; _t504 < n.length; _t504++) {
        var _i530 = n[_t504],
            _l85 = e._getEditorValue(_i530);

        o[_i530.column.dataField] = _i530.value, r[_i530.column.dataField] = _l85, "invalid value" === _l85 && (_i530.setAttribute("error", ""), a = !1);
      }

      if (a) {
        var _i531 = function _i531() {
          for (var _t505 = 0; _t505 < n.length; _t505++) {
            var _i532 = n[_t505];

            e._endCellEdit(_i532);
          }

          e.editing.isEditing = !1, e.editing.editRow = null, e.editing.commandColumn.visible && !e.editing.commandColumn.width ? e.refresh() : e._recycle(!1);
        };

        if (e.onRowUpdate) {
          e.beginUpdate(), e.appearance.displayLoadingIndicator = !0, e._setLoadingIndicatorVisibility();

          var _a325 = e._createOverlay();

          e.$.root.appendChild(_a325), e.onRowUpdate(t, o, r, function (t) {
            t ? _i531() : e.cancelEdit(), e.appearance.displayLoadingIndicator = !1, e._setLoadingIndicatorVisibility(), _a325.parentNode.removeChild(_a325), e.endUpdate();
          });
        } else _i531();

        return !0;
      }

      return e.focus(), !1;
    }
  }, {
    key: "_batchDeleteRow",
    value: function _batchDeleteRow(e) {
      var t = this;
      t._rowsDeleted || (t._rowsDeleted = []), t._rowsDeleted.push(e), t._recycle(!1);
    }
  }, {
    key: "_batchAddRow",
    value: function _batchAddRow(e, t) {
      var i = this;
      i._rowsAdded || (i._rowsAdded = []), i._rowsAdded.push(e.id), i.rowById[e.id] = e, e.index = i.rows.length + (i._rowsAdded ? i._rowsAdded.length : 0), 0 === t ? i._nearRowsAdded.splice(0, 0, e) : i._farRowsAdded.push(e);
      var a = i.isInitialized && i._rowElements && i._rowElements.length < i.rows.length + i._rowsAdded.length;
      a && i._initializeRowElements(), i.refresh();
    }
  }, {
    key: "_batchUpdateCell",
    value: function _batchUpdateCell(e, t, i, a) {
      var n = this;
      n._cellsUpdatedValues || (n._cellsUpdatedValues = []);
      (function (e, i) {
        return "date" === t.dataType ? e.valueOf() === i.valueOf() : e === i;
      })(i, a) ? delete n._cellsUpdatedValues[e.id + "_" + t.dataField] : n._cellsUpdatedValues[e.id + "_" + t.dataField] = i, n._cellsUpdatedValues.length++;
    }
  }, {
    key: "_saveBatchEdit",
    value: function _saveBatchEdit() {
      var e = this;

      for (var _t506 in e._cellsUpdatedValues) {
        var _i533 = e._cellsUpdatedValues[_t506],
            _a326 = _t506.substring(0, _t506.indexOf("_")),
            _n261 = _t506.substring(_t506.indexOf("_") + 1),
            _o180 = e.rowById[_a326],
            _r113 = _o180.getCell(_n261);

        _r113._updating = !0, _r113.value = _i533, _r113._updating = !1;
      }

      var t = e._rowsDeleted && 0 < e._rowsDeleted.length || e._rowsAdded && 0 < e._rowsAdded.length;
      if (t && e.beginUpdate(), e._rowsAdded && 0 < e._rowsAdded.length) for (var _t507 in e._rowsAdded) {
        var _i534 = e._rowsAdded[_t507],
            _a327 = e.rowById[_i534];
        _a327 && (0 <= e._nearRowsAdded.indexOf(_a327) ? e.rows.splice(0, 0, _a327) : 0 <= e._farRowsAdded.indexOf(_a327) && e.rows.push(_a327));
      }
      if (e._rowsDeleted && 0 < e._rowsDeleted.length) for (var _t508 = 0; _t508 < e._rowsDeleted.length; _t508++) {
        var _i535 = e._rowsDeleted[_t508],
            _a328 = e.rows.indexOf(_i535);

        0 > _a328 || e.rows.splice(_a328, 1);
      }
      t && e.endUpdate(), e._clearBatchEdit(!1);
    }
  }, {
    key: "_clearBatchEdit",
    value: function _clearBatchEdit() {
      var e = this;
      var t = !1;
      e._rowsAdded && 0 < e._rowsAdded.length && (t = !0), e._cellsUpdatedValues = [], e._rowsAdded = [], e._rowsDeleted = [], e._nearRowsAdded = [], e._farRowsAdded = [], t ? e.refresh() : e._recycle(!1);
    }
  }, {
    key: "_getEditorId",
    value: function _getEditorId(e) {
      return e.editor === e.column.editor ? e.editor.template + "_" + e.column.dataField : e.editor.template + "_" + e.column.dataField + "_" + e.row.id;
    }
  }, {
    key: "_applyCommand",
    value: function _applyCommand(e, t) {
      var i = this;
      t || (t = []);

      var a = function a() {
        "function" == typeof e ? e.apply(i, t) : i[e] ? i[e].apply(i, t) : Smart[e] ? Smart[e].apply(i, t) : window[e] && window[e].apply(i, t);
      };

      if (i.onCommand) {
        t || (t = []), t[1] || (t[1] = null);
        var _n262 = {
          name: e,
          command: a,
          details: t[0],
          event: t[1],
          handled: !1
        };
        setTimeout(function () {
          i.onCommand.apply(i, [_n262]);
          _n262.handled || a();
        }, 200);
      } else a();
    }
  }, {
    key: "_getCommandColumnCommandsTemplate",
    value: function _getCommandColumnCommandsTemplate() {
      var e = this,
          t = e.editing.commandColumn.dataSource,
          i = "icon" !== e.editing.commandColumn.displayMode,
          a = "label" !== e.editing.commandColumn.displayMode;
      var n = "";

      for (var _o181 in t) {
        var _r114 = t[_o181];

        var _l86 = "<div",
            _s64 = !1;

        if ("commandColumnMenu" == _o181) continue;
        _s64 || (_l86 += " item=\"" + _o181 + "\" command=\"" + _r114.command + "\" class=\"smart-grid-command-item\">", _s64 = !0);
        var d = "{{messages}}" === _r114.label ? e.localize(_o181) : _r114.label;
        a && i ? (_l86 += "<span class=\"smart-grid-icon " + _r114.icon + "\"></span>", _l86 += "<span class=\"smart-grid-label\">" + d + "</span>") : a && !i ? _l86 += "<span class=\"smart-grid-icon " + _r114.icon + "\"></span>" : i && !a && (_l86 += "<span class=\"smart-grid-label\">" + d + "</span>"), _l86 += "</div>", n += _l86;
      }

      return n;
    }
  }, {
    key: "_updateCommandColumnCommandsVisibility",
    value: function _updateCommandColumnCommandsVisibility(e, t) {
      var a = this,
          n = e.children,
          o = a.editing.commandColumn.dataSource;

      for (var _r115 = 0; _r115 < n.length; _r115++) {
        var _e622 = n[_r115],
            _i536 = _e622.getAttribute("item"),
            _l87 = o[_i536].visible;

        !0 === _l87 ? _e622.classList.remove("smart-hidden") : !1 === _l87 ? _e622.classList.add("smart-hidden") : "auto" === _l87 && (!a.editing.dialog.enabled && (a.editing.editRow === t || a.editing.editCell && a.editing.editCell.row === t) ? "commandColumnEdit" === _i536 ? _e622.classList.add("smart-hidden") : ("commandColumnUpdate" === _i536 || "commandColumnCancel" === _i536) && n[_r115].classList.remove("smart-hidden") : "commandColumnEdit" === _i536 ? _e622.classList.remove("smart-hidden") : ("commandColumnUpdate" === _i536 || "commandColumnCancel" === _i536) && n[_r115].classList.add("smart-hidden"));
      }
    }
  }, {
    key: "_handleEditKeyDown",
    value: function _handleEditKeyDown(e) {
      var t = this,
          i = e.key,
          a = t.editing.commandKeys;
      if (!t.editing.dialog.enabled) for (var _e623 in a) {
        var _n263 = a[_e623],
            _o182 = _n263.key.replace(/ /ig, "").split("|");

        if (!("Tab" === i && t.editing.editRow) && 0 <= _o182.indexOf(i)) {
          t._applyCommand(_n263.command);

          break;
        }
      }
    }
  }, {
    key: "_getCustomCellEditor",
    value: function _getCustomCellEditor(e) {
      var t = this;
      e.editor.selector = e.editor.template, e.editor.template = "custom";

      var i = t._getEditorId(e);

      if (!t._cellEditors[i]) {
        var _a329 = document.createElement("div");

        t._applyCellEditorUserSettings(_a329, e), _a329.classList.add("smart-grid-cell-editor");

        var _n264 = function _n264(e) {
          if ("keydown" === e.type) return void t._handleEditKeyDown(e);
        };

        var _o183 = null;
        if ((e.editor.selector.startsWith("#") || e.editor.selector.startsWith(".")) && (_o183 = document.querySelector(e.editor.selector)), _o183) _a329.appendChild(_o183.content.cloneNode(!0).firstElementChild);else {
          var _t509 = function _t509(e) {
            var t = document.createElement("template");
            return e = e.trim(), t.innerHTML = e, t.content.firstChild;
          },
              _i537 = _t509(e.editor.selector);

          _i537 && _a329.appendChild(_i537);
        }
        t._cellEditors[i] = {
          element: _a329,
          focus: function focus() {
            var t = e.editor.instance.element.firstElementChild;
            e.editor.focus ? setTimeout(function () {
              e.editor.focus.apply(e.editor.instance.element, []);
            }, 50) : setTimeout(function () {
              t.focus();
            }, 50);
          },
          blur: function blur(t) {
            var i = e.editor.instance.element.firstElementChild;
            e.editor.blur ? e.editor.blur.apply(e.editor.instance.element, [t]) : i.blur();
          },
          getValue: function getValue() {
            var t = e.editor.instance.element.firstElementChild;
            if (e.editor.getValue) return e.editor.getValue.apply(e.editor.instance.element, []);
            var i = t.value;
            return i || "";
          },
          setValue: function setValue(t) {
            var i = e.editor.instance.element.firstElementChild;
            if (e.editor.setValue) e.editor.setValue.apply(e.editor.instance.element, [t]);else {
              if (0 <= i.innerHTML.indexOf("{{")) {
                var _a330 = i.innerHTML.replace(/{{value}}/ig, t).replace(/{{id}}/ig, e.row.id);

                i.innerHTML = _a330;
              }

              i.value = t, t instanceof Date && (i.value = t.toISOString().split("T")[0]), e.editor.instance.element.value = i.value;
            }
          },
          attach: function attach() {
            _a329.addEventListener("keydown", _n264), e.editor.attach && e.editor.attach.apply(_a329, []);
          },
          detach: function detach() {
            _a329.removeEventListener("keydown", _n264), e.editor.detach && e.editor.detach.apply(_a329, []);
          }
        };
      }

      return t._cellEditors[i];
    }
  }, {
    key: "_getTextAreaCellEditor",
    value: function _getTextAreaCellEditor(e) {
      var t = this,
          i = t._getEditorId(e),
          a = document.createElement("div"),
          n = document.createElement("textarea"),
          o = document.createElement("div");

      t._applyCellEditorUserSettings(a, e), n.classList.add("smart-input"), a.classList.add("smart-grid-cell-editor"), a.classList.add("smart-grid-text-area-cell-editor"), o.classList.add("nav"), o.classList.add("smart-icon-resize-full", "smart-grid-icon");

      var r = function r(e) {
        var i = e.key;
        if ("keydown" === e.type) return t._handleEditKeyDown(e), void (e.shiftKey && " " === i && (o.click(), e.preventDefault()));
      };

      o.onclick = function () {
        var i = document.createElement("div"),
            a = document.createElement("span"),
            r = document.createElement("textarea"),
            l = e.editor.instance.element,
            s = document.createElement("div"),
            d = document.createElement("smart-scroll-bar");
        d.orientation = "vertical", i.setAttribute("theme", t.theme), s.appendChild(r), s.classList.add("smart-grid-text-area-container"), s.appendChild(d), r.value = n.value, r.classList.add("smart-input"), o.textAreaEditorDialog = i, o.popupTextArea = r, a.classList.add("close-button"), a.classList.add("smart-grid-icon"), a.classList.add("smart-icon-cancel-circled");

        var c = function c() {
          d.value = r.scrollTop, d.max = r.scrollHeight - r.offsetHeight, d.onChange = null, r.offsetHeight >= r.scrollHeight ? d.classList.add("smart-hidden") : d.classList.remove("smart-hidden"), d.onChange = function () {
            r.scrollTop = d.value;
          };
        };

        r.onscroll = function () {
          c();
        }, r.onkeydown = function (e) {
          "Escape" === e.key && i.parentNode.removeChild(i), "Enter" === e.key && e.shiftKey && a.click();
        }, a.onclick = function () {
          o.textAreaEditorDialog.parentNode.removeChild(o.textAreaEditorDialog), setTimeout(function () {
            n.value = r.value, n.select();
          }, 50);
        }, i.classList.add("smart-grid-text-area-dialog"), i.appendChild(s), i.appendChild(a), document.body.appendChild(i), setTimeout(function () {
          r.select(), c();
        }, 50), c(), i.style.top = t._offsetTop(l) + "px", i.style.left = t._offsetLeft(l) + "px", i.style.width = l.offsetWidth + "px";
      }, a.appendChild(n), a.appendChild(o);
      return t._cellEditors[i] = {
        element: a,
        focus: function focus() {
          setTimeout(function () {
            n.select();
          }, 50);
        },
        blur: function blur() {},
        setValue: function setValue(e) {
          n.value = e;
        },
        getValue: function getValue() {
          var e = n.value;
          return o.textAreaEditorDialog && o.textAreaEditorDialog.parentNode ? (n.value = o.popupTextArea.value, n.value) : e;
        },
        attach: function attach() {
          n.addEventListener("keydown", r);
        },
        detach: function detach() {
          n.removeEventListener("keydown", r), o.textAreaEditorDialog && o.textAreaEditorDialog.parentNode && (n.value = o.popupTextArea.value, o.textAreaEditorDialog.parentNode.removeChild(o.textAreaEditorDialog));
        }
      }, t._cellEditors[i];
    }
  }, {
    key: "_getInputCellEditor",
    value: function _getInputCellEditor(e) {
      var t = this,
          i = t._getEditorId(e);

      if (!t._cellEditors[i]) {
        var _a331 = document.createElement("input");

        t._applyCellEditorUserSettings(_a331, e), _a331.classList.add("smart-input"), _a331.classList.add("smart-grid-cell-editor"), _a331.classList.add("smart-grid-input-cell-editor");

        var _n265 = function _n265(i) {
          if ("keydown" === i.type) return "number" !== e.column.dataType && "int" !== e.column.dataType && "float" !== e.column.dataType || t.editing.editColumn || i.key.match(/[0-9]/) || "-" === i.key || 1 !== i.key.length ? void t._handleEditKeyDown(i) : (i.preventDefault(), void i.stopPropagation());
        };

        t._cellEditors[i] = {
          element: _a331,
          focus: function focus() {
            setTimeout(function () {
              _a331.select();
            }, 50);
          },
          blur: function blur() {},
          getValue: function getValue() {
            return _a331.value;
          },
          setValue: function setValue(t) {
            if (e.column.rowHeaderColumn && !t) return void (_a331.value = e.editor.row.visibleIndex + 1);

            if ("number" === e.column.dataType || "int" === e.column.dataType || "float" === e.column.dataType) {
              if ("" === t) return;
              if (t && !t.toString().match(/[0-9]/) && "-" !== t) return;
            }

            _a331.value = t;
          },
          attach: function attach() {
            _a331.addEventListener("keydown", _n265);
          },
          detach: function detach() {
            _a331.removeEventListener("keydown", _n265);
          }
        };
      }

      return t._cellEditors[i];
    }
  }, {
    key: "_applyCellEditorUserSettings",
    value: function _applyCellEditorUserSettings(e, t) {
      for (var _i538 in t.editor) {
        if ("template" != _i538) {
          if ("list" == _i538) {
            e.setAttribute(_i538, t.editor[_i538]);
            continue;
          }

          e[_i538] = t.editor[_i538];
        }
      }
    }
  }, {
    key: "_getAutoCompleteCellEditor",
    value: function _getAutoCompleteCellEditor(e) {
      var t = this,
          i = t._getEditorId(e);

      if (!t._cellEditors[i]) {
        var _a332 = document.createElement("smart-input");

        t._applyCellEditorUserSettings(_a332, e), _a332.readonly && (_a332.dropDownButtonPosition = "right");

        var _n266 = function _n266(e) {
          return _a332.opened ? void 0 : "keydown" === e.type ? void t._handleEditKeyDown(e) : void 0;
        };

        _a332.classList.add("smart-grid-cell-editor"), _a332.classList.add("smart-grid-auto-complete-cell-editor");
        t._cellEditors[i] = {
          element: _a332,
          focus: function focus() {
            setTimeout(function () {
              _a332 && _a332.select && _a332.select();
            }, 50);
          },
          blur: function blur() {},
          setValue: function setValue(e) {
            _a332.value = e;
          },
          getValue: function getValue() {
            return _a332.value;
          },
          attach: function attach() {
            _a332.addEventListener("keydown", _n266);
          },
          detach: function detach() {
            _a332 && _a332.close && (_a332.value = "", _a332.close(), _a332.removeEventListener("keydown", _n266));
          }
        };
      }

      var a = t.getVisibleRows(),
          n = [];

      for (var _o184 = 0, _i539; _o184 < a.length; _o184++) {
        _i539 = t.dataSource[a[_o184].index], _i539 && (_i539 = _i539[e.column.dataField], -1 === n.indexOf(_i539) && n.push(_i539));
      }

      return t._cellEditors[i].element.dataSource = n, t._cellEditors[i];
    }
  }, {
    key: "_getDateTimePickerCellEditor",
    value: function _getDateTimePickerCellEditor(e) {
      var t = this,
          i = t._getEditorId(e);

      if (!t._cellEditors[i]) {
        var _a333 = document.createElement("smart-date-time-picker");

        _a333.calendarButton = !0, _a333.dropDownAppendTo = "body", _a333.autoClose = !0, _a333.dropDownDisplayMode = "calendar", t._applyCellEditorUserSettings(_a333, e);

        var _n267 = function _n267(e) {
          return _a333.opened ? void 0 : "keydown" === e.type ? void t._handleEditKeyDown(e) : void 0;
        };

        _a333.classList.add("smart-grid-cell-editor"), _a333.classList.add("smart-grid-date-time-picker-cell-editor");
        t._cellEditors[i] = {
          element: _a333,
          focus: function focus() {
            setTimeout(function () {
              _a333.select();
            }, 50);
          },
          blur: function blur(e) {
            var i = _a333.getAttribute("aria-controls");

            if (i && _a333.opened) {
              var _a334 = t.getBoundingRect(document.getElementById(i));

              e.pageX < _a334.left || e.pageX > _a334.right || e.pageY < _a334.top || e.pageY > _a334.bottom || e.preventDefault();
            }
          },
          setValue: function setValue(e) {
            _a333.value = e;
          },
          getValue: function getValue() {
            return _a333.value;
          },
          attach: function attach() {
            _a333.addEventListener("keydown", _n267);
          },
          detach: function detach() {
            _a333.value = "", _a333.close(), _a333.removeEventListener("keydown", _n267);
          }
        };
      }

      return t._cellEditors[i];
    }
  }, {
    key: "_getNumberInputCellEditor",
    value: function _getNumberInputCellEditor(e) {
      var t = this,
          i = t._getEditorId(e);

      if (!t._cellEditors[i]) {
        var _a335 = document.createElement("div"),
            _n268 = document.createElement("input"),
            _o185 = document.createElement("div"),
            _r116 = document.createElement("div"),
            _l88 = document.createElement("div");

        t._applyCellEditorUserSettings(_a335, e), _r116.tabIndex = _l88.tabIndex = -1, _n268.classList.add("smart-input"), _a335.classList.add("smart-grid-cell-editor"), _a335.classList.add("smart-grid-number-input-cell-editor"), _o185.classList.add("nav"), _r116.classList.add("up"), _l88.classList.add("down");

        var _s65 = function _s65(e) {
          if ("keydown" === e.type) return void t._handleEditKeyDown(e);
        };

        _n268.type = "number", _o185.appendChild(_r116), _o185.appendChild(_l88), _a335.appendChild(_n268), _a335.appendChild(_o185);
        t._cellEditors[i] = {
          element: _a335,
          focus: function focus() {
            setTimeout(function () {
              _n268.select();
            }, 50);
          },
          blur: function blur() {},
          setValue: function setValue(e) {
            _n268.value = e;
          },
          getValue: function getValue() {
            var e = parseFloat(_n268.value);
            return isNaN(e) || e === 1 / 0 || e === -Infinity ? 0 : e;
          },
          attach: function attach() {
            _n268.addEventListener("keydown", _s65), _r116.onkeydown = _s65, _l88.onkeydown = _s65, _r116.onclick = function () {
              var e = parseFloat(_n268.value);
              isNaN(e) || (e < _n268.max || "" === _n268.max) && (_n268.value = e + 1);
            }, _l88.onclick = function () {
              var e = parseFloat(_n268.value);
              isNaN(e) || (e > _n268.min || "" === _n268.min) && (_n268.value = e - 1);
            };
          },
          detach: function detach() {
            _n268.removeEventListener("keydown", _s65), _r116.onclick = _l88.onclick = null, _r116.onkeydown = _l88.onkeydown = null;
          }
        };
      }

      return t._cellEditors[i];
    }
  }, {
    key: "_getCheckBoxCellEditor",
    value: function _getCheckBoxCellEditor(e) {
      var t = this,
          i = t._getEditorId(e);

      if (!t._cellEditors[i]) {
        var _e624 = document.createElement("div");

        _e624.classList.add("smart-input"), _e624.classList.add("smart-grid-cell-editor"), _e624.classList.add("smart-grid-check-box-cell-editor"), _e624.tabIndex = 0;

        var _a336 = function _a336() {
          !0 !== _e624.value && !1 !== _e624.value && null !== _e624.value && (_e624.value = !1), _e624.value = null !== _e624.value && !_e624.value, !1 === _e624.value ? _e624.removeAttribute("checked") : _e624.setAttribute("checked", _e624.value ? "" : "indeterminate");
        },
            _n269 = function _n269(e) {
          return " " === e.key ? void _a336() : void t._handleEditKeyDown(e);
        };

        t._cellEditors[i] = {
          getValue: function getValue() {
            return _e624.value;
          },
          setValue: function setValue(t) {
            _e624.value = t, !1 === _e624.value ? _e624.removeAttribute("checked") : _e624.setAttribute("checked", _e624.value ? "" : "indeterminate");
          },
          focus: function focus() {
            _e624.focus(), setTimeout(function () {
              _e624.focus();
            }, 25);
          },
          blur: function blur() {},
          element: _e624,
          detach: function detach() {
            _e624.value = !1, _e624.removeEventListener("click", _a336), _e624.removeEventListener("keydown", _n269);
          },
          attach: function attach() {
            _e624.addEventListener("keydown", _n269), _e624.addEventListener("click", _a336);
          }
        };
      }

      return t._cellEditors[i];
    }
  }, {
    key: "_getEditorValue",
    value: function _getEditorValue(e) {
      var t = this,
          i = t._getEditorId(e);

      if (!t._cellEditors) return;
      var a = t._cellEditors[i];
      if (!a) return;

      var n = function n(t) {
        switch (e.column.dataType) {
          case "float":
          case "int":
          case "number":
            t = "int" === e.column.dataType ? parseInt(t) : parseFloat(t), isNaN(t) && (t = 0);
            break;

          case "bool":
          case "boolean":
            ("true" === t || "1" === t) && (t = !0), ("false" === t || "0" === t) && (t = !1);
            break;

          case "date":
            t = new Smart.Utilities.DateTime(t), t = t.toDate();
            break;

          case "dateTime":
            t = new Smart.Utilities.DateTime(t);
        }

        return t;
      };

      var o = null;

      switch (e.editor.template) {
        case "input":
        case "autoComplete":
        case "numberInput":
        case "deteTimePicker":
        case "checkBox":
          {
            try {
              o = n(a.getValue());
            } catch (t) {
              o = e.value;
            }

            if (e.editor.getValue) {
              var _t510 = e.editor.getValue(e, o);

              void 0 !== _t510 && (o = _t510);
            }

            break;
          }

        default:
          o = n(a.getValue());
      }

      var r = !0;
      return e.column.validator && (r = e.column.validator.evaluate(o)), r ? o : "invalid value";
    }
  }, {
    key: "_beginRowEdit",
    value: function _beginRowEdit(e, t) {
      var a = this;
      if (e === a.editing.editRow) return !1;

      if (a.editing.editRow) {
        var _e625 = a.endEdit();

        if (!_e625) return !1;
      }

      var n = e.cells;
      a.editing.editRow = e, a.editing.commandColumn.visible && (a.editing.isEditing = !1, a.refresh(), a.editing.isEditing = !0), e.isEditing = !0;
      var o = !1;

      for (var _r117 = 0; _r117 < n.length; _r117++) {
        var _e626 = n[_r117],
            _i540 = a._beginCellEdit(_e626);

        t ? _e626 === t && _e626.editor.instance.focus() : _i540 && !o && (o = !0, _e626.editor.instance.focus()), a.editing.commandColumn.visible && _e626.column.commandColumn && _e626.render();
      }

      return !0;
    }
  }, {
    key: "_createOverlay",
    value: function _createOverlay() {
      var e = document.createElement("div");
      return e.onpointerdown = function () {
        return !1;
      }, e.onmousedown = function () {
        return !1;
      }, e.onclick = function () {}, e.classList.add("smart-grid-dialog-overlay"), e;
    }
  }, {
    key: "_createDialog",
    value: function _createDialog(e) {
      var t = this,
          i = document.createElement("div");
      e || (e = t.editing.dialog), i.setAttribute("animation", "none"), i.classList.add("smart-window", "smart-grid-dialog"), i.style.width = "auto" === e.width ? e.width : e.width + "px", i.style.height = "auto" === e.height ? e.height : e.height + "px", i.style.left = "", i.style.top = "", i.innerHTML = "<div class=\"smart-container\">\n                        <div id=\"headerSection\" class=\"smart-header-section\">\n                            <div class=\"smart-header\"></div>\n                            <div class=\"smart-buttons-container\">\n                                <smart-button unfocusable class=\"smart-close-button\"></smart-button>\n                            </div>\n                        </div>\n                        <div class=\"smart-content\"><div></div></div>\n                        <div class =\"smart-footer\">\n                            <div class =\"smart-stack-layout right spacing\">\n                                <smart-button class =\"smart-confirm-button item primary\">Ok</smart-button>\n                                <smart-button class =\"smart-cancel-button item\">Cancel</smart-button>\n                            </div>\n                        </div>\n                    </div>", i.content = i.querySelector(".smart-content").firstChild, i.footer = i.querySelector(".smart-footer"), i.header = i.querySelector(".smart-header"), i.btnConfirm = i.querySelector(".smart-confirm-button"), i.btnCancel = i.querySelector(".smart-cancel-button"), i.btnClose = i.querySelector(".smart-close-button");
      var a = document.createElement("div");
      return a.classList.add("smart-grid-dialog-overlay"), a.onclick = function () {}, i.overlay = a, i.remove = function () {
        i.parentNode && i.parentNode.removeChild(i);
      }, i.close = function () {
        i.classList.remove("open"), i.addEventListener("transitionend", i.remove), i.addEventListener("transitioncancel", i.remove), i.modal && i.overlay.parentNode && i.overlay.parentNode.removeChild(i.overlay), i.onClose && i.onClose();
      }, i.open = function (a, n) {
        i.removeEventListener("transitionend", i.remove), i.removeEventListener("transitioncancel", i.remove), document.body.appendChild(i), a || (a = e.left), n || (n = e.top), requestAnimationFrame(function () {
          i.classList.add("open");

          var e = function e(_e627, a) {
            var n = t.offset(t);

            switch ("center" === _e627 && "horizontal" === a && (_e627 = "middle"), _e627) {
              case "top":
                return n.top;

              case "bottom":
                return n.top + t.offsetHeight - i.offsetHeight;

              case "center":
                return n.top + t.offsetHeight / 2 - i.offsetHeight / 2;

              case "left":
                return n.left;

              case "middle":
                return n.left + t.offsetWidth / 2 - i.offsetWidth / 2;

              case "right":
                return n.left + t.offsetWidth - i.offsetWidth;
            }

            return "horizontal" === a ? parseInt(_e627) + n.left : "vertical" === a ? parseInt(_e627) + n.top : "number" == typeof _e627 ? _e627 : parseInt(_e627);
          };

          i.style.left = e(a, "horizontal") + "px", i.style.top = e(n, "vertical") + "px";
        }), i.modal && t.appendChild(i.overlay), i.onOpen && i.onOpen();
      }, i;
    }
  }, {
    key: "_openAddRowDialog",
    value: function _openAddRowDialog(e, t) {
      var a = this;
      if (!a.editing.addDialog.enabled) return !1;

      var n = a._dialogAddRow || a._createDialog(),
          i = "{{message}}" === a.editing.dialog.header ? a.localize("dialogAddHeader") : a.editing.dialog.header,
          o = n.content;

      n.header.innerHTML = i, e.grid = a, void 0 === e.index && (e.index = a.rows.length, a._rowsAdded && (e.index += a._rowsAdded.length));
      var r = e.cells;
      var l = null,
          s = 0;

      if (a._cellEditors || (a._cellEditors = []), !a._dialogAddRow) {
        n.modal = !0, n.btnConfirm.innerHTML = a.localize("dialogAddButtonConfirm"), n.btnCancel.innerHTML = a.localize("dialogAddButtonCancel"), n.onOpen = function () {
          a.editing.dialog.visible = !0;
        }, n.onClose = function () {
          a.editing.dialog.visible = !1;
        }, n.btnCancel.onclick = function () {
          n.close();
        }, n.btnClose.onclick = function () {
          n.close();
        }, n.btnConfirm.onclick = function () {
          var e = {};

          for (var _t511 = 0; _t511 < r.length; _t511++) {
            var _i541 = r[_t511],
                _n270 = a._getEditorValue(_i541),
                _o186 = a._getEditorId(_i541),
                _l89 = a._cellEditors[_o186];

            e[_i541.column.dataField] = _n270, _l89.detach();
          }

          var i = a._rowsAdded ? a._rowsAdded.length : 0,
              o = new Smart.Grid.Row({
            index: a.rows.length + i,
            grid: a,
            data: e
          });
          n.close(), t(o, 0 === n.index);
        }, n.onkeydown = function (e) {
          var t = e.key;
          "Enter" === t ? n.btnConfirm.onclick() : "Escape" === t && n.close();
        }, o.classList.add("smart-grid-layout");

        for (var _e628 = 0; _e628 < a.columns.length; _e628++) {
          var _t512 = a.columns[_e628];
          if (!_t512.allowEdit) continue;
          0 == s % 2 && (l = document.createElement("div"), l.classList.add("row"), o.appendChild(l));

          var _i542 = document.createElement("div");

          _i542.classList.add("col-sm-6");

          var _n271 = document.createElement("div");

          _n271.classList.add("column");

          var _r118 = document.createElement("label");

          _r118.innerHTML = a.columns[_e628].label;
          var d = document.createElement("div");
          d.classList.add("smart-grid-dialog-editor"), d.setAttribute("editor", _t512.dataField), d.setAttribute("template", _t512.editor.template), _i542.appendChild(_n271), l.appendChild(_i542), _n271.appendChild(_r118), _n271.appendChild(d), s++;
        }
      }

      n.open(), n.index = e.index;

      for (var _o187 = 0; _o187 < r.length; _o187++) {
        var _e629 = r[_o187],
            _t513 = _e629.column,
            _i543 = _t513.dataField,
            _l90 = n.querySelector("[editor=" + _i543 + "]");

        _l90.innerHTML = "";
        var _s66 = "";
        void 0 === _e629.value ? (("int64" === _t513.dataType || "number" === _t513.dataType || "int" === _t513.dataType || "float" === _t513.dataType) && (_s66 = 0), "date" === _t513.dataType && (_s66 = new Date()), ("bool" === _t513.dataType || "boolean" === _t513.dataType) && (_s66 = !1)) : _s66 = _e629.value;
        var _d32 = null;

        switch (_e629.editor.template) {
          default:
          case "custom":
            {
              _d32 = a._getCustomCellEditor(_e629);
              break;
            }

          case "checkBox":
            {
              _d32 = a._getCheckBoxCellEditor(_e629);
              break;
            }

          case "autoComplete":
            {
              _d32 = a._getAutoCompleteCellEditor(_e629);
              break;
            }

          case "dateTimePicker":
            _d32 = a._getDateTimePickerCellEditor(_e629);
            break;

          case "textArea":
          case "textarea":
            {
              _d32 = a._getTextAreaCellEditor(_e629);
              break;
            }

          case "numberInput":
          case "input":
            {
              _d32 = "numberInput" === _e629.editor.template ? a._getNumberInputCellEditor(_e629) : a._getInputCellEditor(_e629);
              break;
            }
        }

        _d32.attach(), _e629.editor.instance = _d32, _d32.setValue(_s66), 0 == _o187 && _d32.focus(), _e629.editor.isInitialized || (_e629.editor.isInitialized = !0, _e629.editor.onInit && _e629.editor.onInit(_e629.row.index, _e629.column.dataField, _e629.editor.instance.element)), _e629.editor.onRender && _e629.editor.onRender(_e629.row.index, _e629.column.dataField, _e629.editor.instance.element), _l90.appendChild(_d32.element);
      }

      a._dialogAddRow = n;
    }
  }, {
    key: "_openEditDialog",
    value: function _openEditDialog(e, t) {
      var a = this;
      if (!a.editing.dialog.enabled) return !1;

      var i = a._dialogEdit || a._createDialog(),
          n = "{{message}}" === a.editing.dialog.header ? a.localize("dialogEditHeader", {
        value: a.editing.editRow ? e.row.visibleIndex + 1 : e.column.label
      }) : a.editing.dialog.header,
          o = i.content;

      i.header.innerHTML = n;
      var r = null,
          l = 0;
      if (!a._dialogEdit) if (i.modal = !0, i.btnConfirm.innerHTML = a.localize("dialogEditButtonConfirm"), i.btnCancel.innerHTML = a.localize("dialogEditButtonCancel"), i.onOpen = function () {
        a.editing.dialog.visible = !0;
      }, i.onClose = function () {
        a.editing.dialog.visible = !1;
      }, i.btnCancel.onclick = function () {
        a.cancelEdit();
      }, i.btnClose.onclick = function () {
        a.cancelEdit();
      }, i.btnConfirm.onclick = function () {
        a.endEdit();
      }, i.onkeydown = function (e) {
        var t = e.key,
            i = a.editing.commandKeys;

        for (var _n272 in i) {
          var _e630 = i[_n272];

          if (t === _e630.key) {
            a._applyCommand(_e630.command);

            break;
          }
        }
      }, a.editing.editRow) {
        o.classList.add("smart-grid-layout");

        for (var _e631 = 0; _e631 < a.columns.length; _e631++) {
          var _t514 = a.columns[_e631];
          if (!_t514.allowEdit) continue;
          0 == l % 2 && (r = document.createElement("div"), r.classList.add("row"), o.appendChild(r));

          var _i544 = document.createElement("div");

          _i544.classList.add("col-sm-6");

          var _n273 = document.createElement("div");

          _n273.classList.add("column");

          var _s67 = document.createElement("label");

          _s67.innerHTML = a.columns[_e631].label;
          var d = document.createElement("div");
          d.classList.add("smart-grid-dialog-editor"), d.setAttribute("editor", _t514.dataField), d.setAttribute("template", _t514.editor.template), _i544.appendChild(_n273), r.appendChild(_i544), _n273.appendChild(_s67), _n273.appendChild(d), l++;
        }
      } else {
        var _t515 = e.column,
            _i545 = document.createElement("div");

        _i545.classList.add("smart-grid-dialog-editor"), _i545.setAttribute("editor", ""), _i545.setAttribute("template", _t515.editor.template), o.appendChild(_i545);
      }

      if (i.open(), a.editing.editRow) {
        var _a337 = i.querySelector("[editor=" + e.column.dataField + "]");

        _a337.innerHTML = "", _a337.appendChild(t.element);
      } else {
        var _a338 = e.column,
            _n274 = i.querySelector("[editor]");

        _n274.innerHTML = "", _n274.setAttribute("template", _a338.editor.template), _n274.appendChild(t.element);
      }

      a._dialogEdit = i;
    }
  }, {
    key: "_openDeleteRowDialog",
    value: function _openDeleteRowDialog(e, t) {
      var i = this;
      if (!i.editing.deleteDialog.enabled) return !1;

      var a = i._dialogDelete || i._createDialog(),
          n = "{{message}}" === i.editing.dialog.header ? i.localize("dialogDeleteHeader", {
        value: e.visibleIndex + 1
      }) : i.editing.dialog.header;

      a.header.innerHTML = n, a.content.innerHTML = i.localize("dialogDeleteContent"), a.row = e, i._dialogDelete || (a.modal = !0, a.btnConfirm.innerHTML = i.localize("dialogDeleteButtonConfirm"), a.btnCancel.innerHTML = i.localize("dialogDeleteButtonCancel"), a.onOpen = function () {
        i.editing.dialog.visible = !0;
      }, a.onClose = function () {
        i.editing.dialog.visible = !1;
      }, a.btnCancel.onclick = function () {
        a.close();
      }, a.btnClose.onclick = function () {
        a.close();
      }, a.btnConfirm.onclick = function () {
        t(a.row), a.close();
      }, a.onkeydown = function (e) {
        "Escape" === e.key && a.close();
      }, i._dialogDelete = a), a.open(), setTimeout(function () {
        a.btnConfirm.focus();
      }, 100);
    }
  }, {
    key: "_beginCellEdit",
    value: function _beginCellEdit(e, t) {
      var i = this;
      if (e.isEditing) return !1;
      var a = !1;
      if (e.column.autoGenerated && e.column.rowHeaderColumn && i.editing.allowRowHeaderEdit && new Date() - i._clickTime < i.behavior.doubleClickTimingDelay && i._clickedCell === e.element && (a = !0), (!e.column.allowEdit || e.column.autoGenerated || e.readonly) && !a) return !1;

      if (i.editing.editCell && !i.editing.editRow) {
        var _e632 = i._endCellEdit();

        if (!1 === _e632) return !1;
      }

      i._cellEditors || (i._cellEditors = []), i.editing.editRow || (i.editing.editCell = e), i.editing.commandColumn.visible && !i.editing.editRow && (i.editing.isEditing = !1, i.refresh(), i.editing.isEditing = !0), e.row.element.setAttribute("edit", ""), i.editing.isEditing = !0, i._selection.selectionRect && i._selection.selectionRect.classList.add("smart-visibility-hidden");

      var n = function n(t) {
        var a = t.element;
        i.editing.dialog.enabled ? i._openEditDialog(e, t) : (!e.element && e.createElement(), e.element.setAttribute("editor", "string" == typeof e.editor.template ? e.editor.template : "template"), e.element.content.innerHTML = "", e.element.content.appendChild(a), i.editing.editRow && e.element.setAttribute("row-editor", "")), t.attach(), e.editor.row = e.row, e.editor.column = e.column, e.editor.cell = e, e.editor.instance = t, e.isEditing = !0;
      },
          o = i._cellsUpdatedValues ? i._cellsUpdatedValues[e.row.id + "_" + e.column.dataField] : void 0;

      var r = void 0 === o ? e.value : o;

      if (void 0 === r) {
        r = "";
        var _t516 = e.column;
        "number" === _t516.dataType || "int" === _t516.dataType || "float" === _t516.dataType ? r = 0 : "date" === _t516.dataType && (r = new Date(), r.setTime(0, 0, 0));
      }

      switch (e.editor || (e.editor = "input"), "string" == typeof e.editor && (e.canNotify = !1, e.editor = {
        template: e.editor,
        autoFocus: !0
      }, e.canNotify = !0), e.editor.template) {
        default:
        case "custom":
          {
            var _t517 = i._getCustomCellEditor(e);

            n(_t517), _t517.setValue(r);
            break;
          }

        case "checkBox":
          {
            var _a339 = i._getCheckBoxCellEditor(e);

            n(_a339);

            var _o188 = !0 === r || 1 === r;

            if ("checkBox" === e.template && t) {
              var _e633 = (i.enableShadowDOM ? i.shadowRoot : i.getRootNode()).elementsFromPoint(t.clientX, t.clientY);

              _e633[0].classList.contains("smart-input") ? _a339.setValue(!_o188) : _a339.setValue(_o188);
            } else _a339.setValue(_o188);

            break;
          }

        case "autoComplete":
          {
            var _t518 = i._getAutoCompleteCellEditor(e);

            n(_t518), _t518.setValue(r), e.editor.autoOpen && _t518.element.open();
            break;
          }

        case "dateTimePicker":
          {
            var _t519 = i._getDateTimePickerCellEditor(e);

            n(_t519), _t519.setValue(r), e.editor.autoOpen && _t519.element.open();
            break;
          }

        case "textArea":
          {
            var _t520 = i._getTextAreaCellEditor(e);

            n(_t520), _t520.setValue(r);
            break;
          }

        case "numberInput":
        case "input":
          {
            var _t521 = "numberInput" === e.editor.template ? i._getNumberInputCellEditor(e) : i._getInputCellEditor(e);

            n(_t521), _t521.setValue(r);
            break;
          }
      }

      return e.editor.isInitialized || (e.editor.isInitialized = !0, e.editor.onInit && e.editor.onInit(e.row.index, e.column.dataField, e.editor.instance.element)), e.editor.onRender && e.editor.onRender(e.row.index, e.column.dataField, e.editor.instance.element), i.editing.editCell && e.editor.instance.focus(), !0;
    }
  }, {
    key: "_onColumnDoubleClick",
    value: function _onColumnDoubleClick(e) {
      var t = this;

      t._beginColumnEdit(e);
    }
  }, {
    key: "_beginColumnEdit",
    value: function _beginColumnEdit(e) {
      var t = this;

      if (t.editing.enabled && t.editing.allowColumnHeaderEdit && e.allowHeaderEdit) {
        t.editing.isEditing && t.endEdit(), t.editing.editColumn = e, t._cellEditors || (t._cellEditors = []);

        var _i546 = t._getInputCellEditor({
          column: e,
          row: t.rows[0],
          editor: {
            template: "input"
          }
        });

        _i546.element.value = e.label, _i546.focus(), e.headerEditor = _i546, e.element.setAttribute("edit", ""), e.element.label.appendChild(_i546.element), _i546.attach(), t.editing.isEditing = !0, t.$.fireEvent("beginEdit", {
          row: null,
          column: e,
          cell: null
        });
      }
    }
  }, {
    key: "_endColumnEdit",
    value: function _endColumnEdit(e) {
      var t = this;
      if (!1 === t.editing.isEditing || t.editing.isEditing && null === t.editing.editColumn) return !1;
      var i = t.editing.editColumn;
      return i.canNotify = !1, i.headerEditor.detach(), i.headerEditor.element.parentNode.removeChild(i.headerEditor.element), !0 !== e && (i.label = i.headerEditor.getValue()), i.headerEditor = null, t.editing.isEditing = !1, i.element.removeAttribute("edit"), i.element.scrollLeft = 0, t.editing.editColumn = null, i.canNotify = !0, i.refresh(), t._recycle(), !0;
    }
  }, {
    key: "_cancelColumnEdit",
    value: function _cancelColumnEdit() {
      var e = this;

      e._endColumnEdit(!0);
    }
  }, {
    key: "_onCellClick",
    value: function _onCellClick(e, t) {
      var i = this;
      if (e.row.addNewRow) return void ("far" === e.row.freeze ? i._insertNewRowAfter() : i._insertNewRowBefore());

      if (i.editing.enabled) {
        if (i.editing.editColumn) return void i.endEdit();
        if (i.editing.commandColumn.visible) if (e.column.commandColumn) {
          var _a340 = (i.enableShadowDOM ? i.shadowRoot : i.getRootNode()).elementsFromPoint(t.pageX, t.pageY);

          var _n275 = null;

          for (var _e634 = 0; _e634 < _a340.length; _e634++) {
            if (_a340[_e634].classList.contains("smart-grid-command-item")) {
              _n275 = _a340[_e634];
              break;
            }
          }

          if (_n275 || (_n275 = e.element.querySelector(".smart-grid-command-item")), _n275 && !_n275.classList.contains("smart-hidden")) {
            var _a341 = _n275.getAttribute("command");

            return void i._applyCommand(_a341, [e.row, t]);
          }
        } else if (i.editing.commandColumn.inline) {
          var _e635 = (i.enableShadowDOM ? i.shadowRoot : i.getRootNode()).elementsFromPoint(t.pageX, t.pageY);

          for (var _t522 = 0; _t522 < _e635.length; _t522++) {
            if (_e635[_t522].classList.contains("smart-grid-command-item")) return;
          }
        }

        if ("none" === i.editing.action && i.editing.isEditing) {
          var _t523 = !1;

          i.editing.editCell && i.editing.editCell.row !== e.row && (_t523 = !0), i.editing.editRow && i.editing.editRow !== e.row && (_t523 = !0), i.editing.editColumn && (_t523 = !0), _t523 && i.endEdit();
        }

        if (e.column.autoGenerated) return void (i.editing.allowRowHeaderEdit && e.column.rowHeaderColumn && (i.editing.isEditing && i.endEdit(), i._beginCellEdit(e, t)));
        if ("click" === i.editing.action && (!i.selection.enabled || e.selected || "extended" !== i.selection.mode)) if ("cell" === i.editing.mode) {
          var _a342 = e.parent();

          i.ensureVisible(e.row.id, e.column.dataField), setTimeout(function () {
            _a342 ? i._beginCellEdit(_a342, t) : i._beginCellEdit(e, t);
          }, 25);
        } else "row" === i.editing.mode && i._beginRowEdit(e.row, e, t);
      }
    }
  }, {
    key: "_onCellDoubleClick",
    value: function _onCellDoubleClick(e, t) {
      var i = this;
      !i.editing.enabled || "doubleClick" !== i.editing.action || i.editing.isEditing || e.column.autoGenerated || ("cell" === i.editing.mode ? i._beginCellEdit(e, t) : "row" === i.editing.mode && i._beginRowEdit(e.row, e, t));
    }
  }, {
    key: "_onRowClick",
    value: function _onRowClick() {}
  }, {
    key: "_onRowDoubleClick",
    value: function _onRowDoubleClick() {}
  }, {
    key: "beginEdit",
    value: function beginEdit(e, t) {
      var i = this,
          a = i.rowById[e];
      a && i._beginEdit(a, t);
    }
  }, {
    key: "cancelEdit",
    value: function cancelEdit() {
      var e = this;

      if (e.editing.editRow) {
        var _t524 = e.editing.editRow.cells;

        for (var _e636 = 0; _e636 < _t524.length; _e636++) {
          var _i547 = _t524[_e636],
              _a343 = _i547.element;
          0 == _e636 && _i547.row.element.removeAttribute("edit"), _a343 && (_a343.removeAttribute("editor"), _a343.removeAttribute("error"), _a343.content.innerHTML = ""), _i547.isEditing = !1;
        }

        e.editing.editRow = null;
      } else e.editing.editCell ? (e.editing.editCell.row.element.removeAttribute("edit"), e.editing.editCell.element.removeAttribute("editor"), e.editing.editCell.element.removeAttribute("error"), e.editing.editCell.element.content.innerHTML = "", e.editing.editCell.isEditing = !1, e.editing.editCell = null) : e.editing.editColumn && e._cancelColumnEdit();

      e.editing.dialog.visible && e.editing.dialog.enabled && e._dialogEdit.close(), e.editing.isEditing = !1, e._recycle(!1), e.editing.commandColumn.visible && e.refresh(), e.focus();
    }
  }, {
    key: "deleteRow",
    value: function deleteRow(e, t) {
      var i = this,
          a = i.rowById[e];
      if (!a) return !1;

      var n = function n(e) {
        if (!0 === i.editing.batch || i.editing.batch && 0 <= i.editing.batch.indexOf("delete")) i._batchDeleteRow(e);else {
          var _t525 = i.rows.indexOf(e);

          i.rows.splice(_t525, 1);
        }
        t && t(e);
      };

      return i.editing.deleteDialog.enabled ? i._openDeleteRowDialog(a, n) : n(a), !0;
    }
  }, {
    key: "addUnboundRow",
    value: function addUnboundRow(e, t) {
      var i = this;
      void 0 === e && (e = 1), void 0 === t && (t = "far"), i._nearRowsAdded || (i._nearRowsAdded = [], i._farRowsAdded = []), i._unboundRows || (i._unboundRows = []), i.beginUpdate();

      for (var _a344 = 0; _a344 < e; _a344++) {
        var _e637 = Smart.Utilities.Core.createGUID().replace(/-/ig, ""),
            _a345 = new Smart.Grid.Row({
          index: -1,
          unbound: !0,
          id: _e637,
          grid: i
        });

        i.rowById[_a345.id] = _a345, "far" === t ? i._farRowsAdded.push(_a345) : i._nearRowsAdded.push(_a345), i._unboundRows.push(_a345);
      }

      i.endUpdate();
    }
  }, {
    key: "addNewRow",
    value: function addNewRow(e) {
      var t = this;
      "near" === e ? t._insertNewRowBefore() : t._insertNewRowAfter();
    }
  }, {
    key: "endEdit",
    value: function endEdit() {
      var e = this;
      var t = !1,
          i = null;
      e.editing.dialog.enabled && e.editing.dialog.visible && e._dialogEdit && e._dialogEdit.close();
      var a = null,
          n = null,
          o = null;
      return e.editing.editRow ? (n = e.editing.editRow, i = e.editing.editRow.id, t = e._endRowEdit()) : e.editing.editCell ? (n = e.editing.editCell.row, o = e.editing.editCell.column, a = e.editing.editCell, i = e.editing.editCell.row.id, t = e._endCellEdit()) : e.editing.editColumn && (i = null, o = e.editing.editColumn, t = e._endColumnEdit()), e._saveUnboundRows(i), e._selection.selectionRect && e._selection.selectionRect.classList.remove("smart-visibility-hidden"), e.$.scrollView.scrollTop = 0, e.$.fireEvent("endEdit", {
        row: n,
        column: o,
        cell: a
      }), t;
    }
  }, {
    key: "getBatchEditChanges",
    value: function getBatchEditChanges() {
      var e = this,
          t = [],
          a = [],
          n = [];

      for (var _i548 in e._cellsUpdatedValues) {
        var _a346 = e._cellsUpdatedValues[_i548],
            _n276 = _i548.substring(0, _i548.indexOf("_")),
            _o189 = _i548.substring(_i548.indexOf("_") + 1),
            _r119 = e.rowById[_n276],
            _l91 = _r119.getCell(_o189);

        t.push({
          id: _n276,
          dataField: _o189,
          oldValue: _l91.value,
          newValue: _a346
        });
      }

      if (e._rowsDeleted && 0 < e._rowsDeleted.length) for (var _t526 = 0; _t526 < e._rowsDeleted.length; _t526++) {
        var _i549 = e._rowsDeleted[_t526];
        a.push({
          id: _i549.id,
          data: _i549
        });
      }
      if (e._rowsAdded && 0 < e._rowsAdded.length) for (var _t527 = 0; _t527 < e._rowsAdded.length; _t527++) {
        var _i550 = e._rowsAdded[_t527];
        n.push({
          id: _i550.id,
          data: _i550
        });
      }
      return {
        updated: t,
        deleted: a,
        added: n
      };
    }
  }, {
    key: "saveBatchEdit",
    value: function saveBatchEdit() {
      var e = this;

      e._saveBatchEdit();
    }
  }, {
    key: "revertBatchEdit",
    value: function revertBatchEdit() {
      var e = this;

      e._clearBatchEdit(!0);
    }
  }]);

  return _class59;
}()), Smart.Utilities.Assign("Grid.Tree",
/*#__PURE__*/
function () {
  "use strict";

  function _class60() {
    _classCallCheck(this, _class60);
  }

  _createClass(_class60, [{
    key: "_setRowProperty",
    value: function _setRowProperty(e, t, i) {
      var a = this,
          n = a.rowById[e];
      n && (n[t] = i);
    }
  }, {
    key: "_setRowsProperty",
    value: function _setRowsProperty(e, t) {
      var i = this,
          a = i._recyclingRows;
      i.rows.canNotify = !1;

      for (var _n277 = 0; _n277 < a.length; _n277++) {
        var _i551 = a[_n277];
        _i551[e] = t;
      }

      i.rows.canNotify = !0, i.refresh();
    }
  }, {
    key: "_applyThreeStates",
    value: function _applyThreeStates(e) {
      var t = this,
          a = e !== t.rowHierarchy,
          n = a ? e.children : t.rowHierarchy.filter(function (e) {
        if (0 === e.level) return e;
      });
      var o = 0,
          r = 0;

      for (var _l92 = 0; _l92 < n.length; _l92++) {
        var _i552 = n[_l92];
        e.checked && (_i552.checked = !0), !1 === _i552.leaf && t._applyThreeStates(_i552), a && (_i552.checked ? o++ : null === _i552.checked && r++);
      }

      a && (o === e.children.length ? e.checked = !0 : 0 == o && 0 == r ? e.checked = !1 : t.checkBoxes.hasThreeStates ? e.checked = null : e.checked = !1);
    }
  }, {
    key: "_hasThreeStates",
    value: function _hasThreeStates(e, t) {
      function a(e, t) {
        var n = e.children;

        for (var _o190 = 0; _o190 < n.length; _o190++) {
          var _e638 = n[_o190];
          _e638.checked = t, !1 === _e638.leaf && a(_e638, t);
        }
      }

      var n = this;
      var i = e;

      for (e !== t && (e.checked ? e.checked = !1 : e.checked = !0); i.parent;) {
        var _e639 = i.parent,
            _t528 = _e639.children;
        var _a347 = 0,
            _o191 = 0;

        for (var _e640 = 0; _e640 < _t528.length; _e640++) {
          _t528[_e640].checked ? _a347++ : n.checkBoxes.hasThreeStates && null === _t528[_e640].checked && _o191++;
        }

        _e639.checked = !(_a347 !== _e639.children.length) || (0 != _a347 || 0 != _o191) && !!n.checkBoxes.hasThreeStates && null, i = _e639;
      }

      e.leaf || a(e, e.checked);
    }
  }, {
    key: "expandRow",
    value: function expandRow(e) {
      var t = this;

      t._setRowProperty(e, "expanded", !0);
    }
  }, {
    key: "expandAllRows",
    value: function expandAllRows() {
      var e = this;

      e._setRowsProperty("expanded", !0);
    }
  }, {
    key: "collapseAllRows",
    value: function collapseAllRows() {
      var e = this;

      e._setRowsProperty("expanded", !1);
    }
  }, {
    key: "toggleRow",
    value: function toggleRow(e) {
      var t = this,
          i = t.rowById[e];
      i && (i.expanded ? i.expanded = !1 : i.expanded = !0);
    }
  }, {
    key: "collapseRow",
    value: function collapseRow(e) {
      var t = this;

      t._setRowProperty(e, "expanded", !1);
    }
  }, {
    key: "checkRow",
    value: function checkRow(e) {
      var t = this;

      t._setRowProperty(e, "checked", !0);
    }
  }, {
    key: "uncheckRow",
    value: function uncheckRow(e) {
      var t = this;

      t._setRowProperty(e, "checked", !1);
    }
  }, {
    key: "checkAllRows",
    value: function checkAllRows() {
      var e = this;

      e._setRowsProperty("checked", !0);
    }
  }, {
    key: "uncheckAllRows",
    value: function uncheckAllRows() {
      var e = this;

      e._setRowsProperty("checked", !1);
    }
  }]);

  return _class60;
}()), Smart.Utilities.Assign("Grid.Export",
/*#__PURE__*/
function () {
  "use strict";

  function _class61() {
    _classCallCheck(this, _class61);
  }

  _createClass(_class61, [{
    key: "exportData",
    value: function exportData(e, t) {
      var a = this,
          i = new Smart.Utilities.DataExporter({
        exportHeader: a.dataExport.header
      }),
          n = [];

      if (i.expandChar = a.dataExport.expandChar, i.collapseChar = a.dataExport.collapseChar, i.pageOrientation = a.dataExport.pageOrientation, i.style = a.dataExport.style, i.filterBy = a.dataExport.filterBy, i.groupBy = a.dataExport.groupBy, i.header = {
        columns: a.columns.toArray().slice(0),
        columngroups: a.columnGroups.slice(0)
      }, !a.dataExport.style) {
        var _t529 = window.getComputedStyle(a),
            _o192 = window.getComputedStyle(0 < a.columns.length && a.columns[0].element ? a.columns[0].element : a.$.columnHeader),
            _r120 = window.getComputedStyle(a.$.columnHeader),
            _l93 = 0 === a.offsetWidth || 0 === a.offsetHeight;

        if (!_l93) {
          var _l94 = function _l94(e) {
            function t(e) {
              return e = e.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/), e ? "#" + i(e[1]) + i(e[2]) + i(e[3]).toUpperCase() : "#ffffff";
            }

            function i(e) {
              return isNaN(e) ? "00" : l[(e - e % 16) / 16] + l[e % 16];
            }

            var a = e.fontSize,
                n = e.borderRightColor,
                o = e.backgroundColor,
                r = e.color,
                l = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
            return {
              borderColor: t(n),
              fontSize: a,
              fontFamily: "Helvetica",
              color: t(r),
              backgroundColor: t(o)
            };
          },
              _s68 = _l94(_t529),
              d = _l94(_o192),
              c = _l94(_r120),
              m = {
            height: a.$.columnHeader.offsetHeight + "px",
            border: "1px solid " + _s68.borderColor,
            fontFamily: c.fontFamily,
            fontSize: c.fontSize,
            color: c.color,
            backgroundColor: d.backgroundColor,
            fontWeight: "400"
          },
              u = {
            border: "1px solid " + _s68.borderColor,
            fontFamily: _s68.fontFamily,
            fontSize: _s68.fontSize
          },
              p = {
            height: a.rowMinHeight + "px"
          };

          for (var _t530 = 0; _t530 < a.columns.length; _t530++) {
            var _o193 = a.columns[_t530];
            if (!_o193.allowExport) continue;
            if (!_o193.visible) continue;
            m[_o193.dataField] = {
              textAlign: _o193.align,
              width: _o193.computedWidth + "px",
              format: _o193.cellsFormat || ""
            };

            var _i553 = _o193.cellsFormat || "";

            "date" === _o193.dataType ? _i553 = "d" : "dateTime" === _o193.dataType ? _i553 = "D" : "time" === _o193.dataType && (_i553 = "t");
            var _r121 = {
              textAlign: _o193.cellsAlign,
              format: _i553
            };
            if (u[_o193.dataField] = _r121, a.dataExport.view && -1 !== ["html", "jpeg", "pdf", "png"].indexOf(e) && (_o193.template || _o193.formatFunction)) for (var _e641 = 0; _e641 < a.rows.length; _e641++) {
              var _t531 = a.rows[_e641];
              var _i554 = a.rows[_e641]["column_" + _o193.dataField];
              if (a.dataExport.viewStart && _e641 < a.dataExport.viewStart || a.dataExport.viewEnd && _e641 > a.dataExport.viewEnd) continue;

              if (!_i554 || _t531 && _t531.element && _t531.element.classList.contains("smart-hidden")) {
                var _e642 = a._rowElements[0];
                if (!_e642) continue;
                if (_t531.element = _e642, _t531.grid = a, _t531.render(), _i554 = _t531["column_" + _o193.dataField], !_i554) continue;
              }

              var _l95 = {
                border: _i554.borderColor,
                background: _i554.background,
                color: _i554.color
              },
                  _s69 = void 0 === a.dataExport.viewStart ? _e641 : _e641 - a.dataExport.viewStart;

              n[_e641] = Object.assign({}, _t531.data), n[_e641][_o193.dataField] = _i554.element.textContent, _r121[_s69] = _l95;
            }
          }

          0 < a.appearance.alternationCount && (p.alternationCount = a.appearance.alternationCount, p.alternationStart = a.appearance.alternationStart, p.alternationEnd = a.appearance.alternationEnd, p.alternationIndex0Color = _s68.color, p.alternationIndex0BackgroundColor = _s68.backgroundColor, p.alternationIndex1Color = _s68.color, p.alternationIndex1BackgroundColor = "#F5F5F5"), i.style = {
            border: "1px solid " + _s68.borderColor,
            borderCollapse: "collapse",
            header: m,
            columns: u,
            rows: p
          };
        }
      }

      var o = !a.rowHierarchy || a.grouping.enabled ? a.rows.toArray() : a.rowHierarchy;
      var r = [];
      if (a.dataExport.view) a._recyclingRows.forEach(function (e, t) {
        return !!(a.dataExport.viewStart && t < a.dataExport.viewStart || a.dataExport.viewEnd && t > a.dataExport.viewEnd) || void (n[t] ? r.push(n[t]) : r.push(e.data));
      });else {
        for (var _e643 = 0; _e643 < o.length; _e643++) {
          var _t532 = o[_e643];
          _t532.visible && (!1 !== _t532.filtered || void 0 === _t532.filtered) && r.push(_t532.data);
        }

        o === a.rowHierarchy && (r = a.dataSource.boundHierarchy, i.hierarchical = !0);
      }
      !a.dataExport.groupBy && a.grouping.enabled && a.dataSource && a.dataSource.groupBy && (i.groupBy = a.dataSource.groupBy && a.dataSource.groupBy.toArray ? a.dataSource.groupBy.toArray() : null), a.checkLicense(!0);
      var l = i.exportData(r, e, a.dataExport.fileName, t);
      return a.dataExport.view && a._recycle(!1), l;
    }
  }, {
    key: "print",
    value: function print() {
      var e = this,
          t = e.dataExport.fileName;
      e.dataExport.fileName = null;
      var i = e.exportData("html"),
          a = window.open("", "", "width=800,height=500"),
          n = a.document.open();

      try {
        n.write("<!DOCTYPE html><html><head><meta charset=\"utf-8\" /><title>" + t + "</title></head><body>" + i + "</body></html>"), n.close(), setTimeout(function () {
          a.print(), a.close();
        }, 100);
      } catch (e) {}

      e.dataExport.fileName = t;
    }
  }]);

  return _class61;
}()), Smart.Utilities.Assign("Grid.Chart",
/*#__PURE__*/
function () {
  "use strict";

  function _class62() {
    _classCallCheck(this, _class62);
  }

  _createClass(_class62, [{
    key: "_getChartDataFields",
    value: function _getChartDataFields(e) {
      var t = this,
          i = e[0];
      var a = !0,
          n = [],
          o;

      var _loop24 = function _loop24(_r122) {
        if ("$" == _r122) return "continue";
        var e = t.dataSource.dataFields.find(function (e) {
          return e.name === _r122;
        }).dataType;

        if ("string" === e) {
          var _e644 = t.columns.findIndex(function (e) {
            return e.dataField === _r122;
          });

          0 === _e644 && (o = _r122);
        } else a = !1, n.push({
          dataField: _r122,
          displayText: _r122
        });
      };

      for (var _r122 in i) {
        var _ret8 = _loop24(_r122);

        if (_ret8 === "continue") continue;
      }

      return {
        xAxisDataField: o,
        series: n,
        stringOnly: a
      };
    }
  }, {
    key: "createChart",
    value: function createChart(e, t) {
      var a = this,
          i = a.getSelection(),
          n = i.rows,
          o = i.columns,
          r = i.cells,
          l = document.createElement("smart-chart"),
          s = [],
          d = {};
      var c = [],
          m = [],
          u;
      if (r && 1 < r.length && r.forEach(function (e) {
        -1 === c.indexOf(e.row.index) && c.push(e.row.index), -1 === m.indexOf(e.dataField) && m.push(e.dataField);
      }), t) s.concat(t);else {
        var _loop25 = function _loop25(_e645) {
          var t = {};

          if (n) {
            if (!n.find(function (t) {
              return t.row.index === _e645;
            })) return "continue";
          } else if (o) {
            o.forEach(function (i) {
              t[i.dataField] = a.dataSource[_e645][i.dataField];
            }), s.push(t);
            return "continue";
          } else if (r && 1 < r.length) {
            if (-1 === c.indexOf(_e645)) return "continue";
            m.forEach(function (i) {
              t[i] = a.dataSource[_e645][i];
            }), s.push(t);
            return "continue";
          }

          a.columns.forEach(function (i) {
            return t[i.dataField] = a.dataSource[_e645][i.dataField];
          }), s.push(t);
        };

        for (var _e645 = 0; _e645 < a.dataSource.length; _e645++) {
          var _ret9 = _loop25(_e645);

          if (_ret9 === "continue") continue;
        }
      }

      var p = a._getChartDataFields(s);

      if (p.stringOnly) {
        if (a.header.visible && a.$.header.firstElementChild) {
          var _t533 = a.enableShadowDOM ? a.shadowRoot.getElementById(e) : a.querySelector("#" + e);

          a.$.header.firstElementChild.classList.add("warning"), _t533 && _t533.classList.add("warning"), setTimeout(function () {
            a.$.header.firstElementChild.classList.remove("warning"), _t533 && _t533.classList.remove("warning");
          }, 1e3);
        }

        return;
      }

      if (u = p.series, l.caption = "", l.description = "", l.clip = !1, l.showLegend = !0, l.showBorderLine = !1, l.padding = {
        left: 5,
        top: 10,
        right: 5,
        bottom: 5
      }, l.dataSource = s, l.xAxis = {
        dataField: p.xAxisDataField,
        gridLines: {
          visible: !0
        }
      }, l.valueAxis = {
        displayValueAxis: !0,
        description: a.charting.description,
        axisSize: "auto",
        formatSettings: a.charting.formatSettings
      }, l.colorScheme = a.charting.colorScheme, l.seriesGroups = [d], d.formatSettings = a.charting.formatSettings, d.series = u, "line" === e) u.forEach(function (e) {
        e.symbolSize = 8, e.symbolType = "square";
      });else if ("pie" === e) {
        var _e646 = u[0].dataField;
        delete d.formatSettings, d.formatFunction = function (e, t) {
          return isNaN(e) ? "object" == typeof e ? t : e : e;
        }, d.showLabels = !0, u.length = 0, u.push({
          dataField: _e646,
          displayText: p.xAxisDataField,
          initialAngle: 0
        });
      } else if ("bar" === e) e = "column", d.orientation = "horizontal", l.xAxis.textRotationAngle = 90, l.valueAxis.textRotationAngle = 30, l.valueAxis.flip = !0;else if ("area" === e) {
        var _e647 = 1;

        for (var _t534 = 0; _t534 < u.length; _t534++) {
          u[_t534].opacity = _e647, _e647 -= .2, _e647 = Math.max(.3, _e647);
        }
      }

      if (d.type = e, a.onChartInit && a.onChartInit(l), a.charting.appendTo) {
        var _e648 = "string" === a.charting.appendTo ? document.querySelector(a.charting.appendTo) : a.charting.appendTo;

        _e648 && _e648.appendChild(l);
      } else a._openChartDialog(l, e);
    }
  }, {
    key: "_openChartDialog",
    value: function _openChartDialog(e, t) {
      var i = this;
      if (!i.charting.dialog.enabled) return !1;

      var a = i._dialogChart || i._createDialog(i.charting.dialog),
          n = t.substring(0, 1).toUpperCase() + t.substring(1),
          o = "{{message}}" === i.charting.dialog.header ? i.localize("dialogChartHeader", {
        value: n
      }) : i.charting.dialog.header;

      e.style.width = "100%", e.style.height = "100%", a.header.innerHTML = o, a.content.innerHTML = "", a.content.style.width = "100%", a.content.style.height = "100%", a.btnCancel.classList.add("smart-hidden"), i._dialogChart || (a.modal = !0, a.onOpen = function () {
        i.charting.dialog.visible = !0;
      }, a.onClose = function () {
        i.charting.dialog.visible = !1;
      }, a.btnConfirm.onclick = function () {
        a.close();
      }, a.btnClose.onclick = function () {
        a.close();
      }, a.onkeydown = function (e) {
        "Escape" === e.key && a.close();
      }, i._dialogChart = a), a.open(), setTimeout(function () {
        a.btnConfirm.focus(), a.content.appendChild(e);
      }, 100);
    }
  }]);

  return _class62;
}()), Smart("smart-grid",
/*#__PURE__*/
function (_Smart$ScrollViewer) {
  "use strict";

  _inherits(_class63, _Smart$ScrollViewer);

  function _class63() {
    _classCallCheck(this, _class63);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class63).apply(this, arguments));
  }

  _createClass(_class63, [{
    key: "template",
    value: function template() {
      return "<div class='smart-container'id='container' disabled='[[disabled]]' role='grid'>\n                <div id='header' class='smart-grid-header smart-hidden' ></div>\n                <div id='groupHeader' class='smart-grid-group-header smart-hidden'></div>\n                <div id='headerPager' top class='smart-grid-pager smart-hidden'></div>\n                <div id='headerCommandBar' header top class='smart-grid-header smart-grid-command-bar smart-hidden'></div>\n                 <div id='content' class='smart-grid-content'>\n                    <div id='placeholder' class ='smart-hidden smart-placeholder smart-grid-placeholder'></div>\n                    <div id='columnHeader' class='smart-grid-column-header'>\n                        <div id='columnNearContainer' class='near smart-hidden smart-grid-column-header-cell-container'>\n                       </div>\n                       <div id='columnContainer' class='center smart-grid-column-header-cell-container'>\n                       </div>\n                        <div id='columnFarContainer' class='far smart-hidden smart-grid-column-header-cell-container'>\n                       </div>\n                    </div>\n                    <div id='scrollView' class ='smart-grid-scroll-view'>\n                        <div id='rowNearContainer' class='near smart-hidden smart-grid-row-container'>\n                        </div>\n                         <div id='rowContainer' class='center smart-grid-row-container'>\n                        </div>\n                        <div id='rowFarContainer' class='far smart-hidden smart-grid-row-container'>\n                        </div>\n                        <smart-scroll-bar id='verticalScrollBar' class='smart-grid-scroll-bar' wait disabled='[[disabled]]' orientation='vertical'></smart-scroll-bar>\n                        <smart-scroll-bar id='horizontalScrollBar' class='smart-grid-scroll-bar' wait disabled='[[disabled]]'></smart-scroll-bar>\n                    </div>\n                  <div id='filterFooter' class='smart-grid-filter-footer smart-hidden'></div>\n                </div>\n                <div id='loadingIndicatorContainer' class='smart-loader-container'>\n                    <span id='loadingIndicator' class='smart-grid-loader smart-loader'></span>\n                    <span id='loadingIndicatorPlaceholder' class ='smart-loader-label smart-hidden'></span>\n                </div>\n                <div id='footerCommandBar' footer class='smart-grid-footer smart-grid-command-bar smart-hidden'></div>\n                <div id='footerPager' class='smart-grid-pager smart-hidden'></div>\n                <div id='footer' class='smart-grid-footer smart-hidden'></div>\n            </div>";
    }
  }, {
    key: "pageSizeValidator",
    value: function pageSizeValidator(e, t) {
      var i = this;
      return 0 > t ? 0 : i.dataSource && t > i.dataSource.length ? i.dataSource.length : void 0;
    }
  }, {
    key: "pageIndexValidator",
    value: function pageIndexValidator(e, t) {
      var i = this;
      if (0 > t) return 0;

      if (i.dataSource) {
        var _e649 = Math.ceil(i.dataSource.length / i.paging.pageSize);

        if (t > _e649 - 1) return _e649 - 1;
      }
    }
  }, {
    key: "_offsetTop",
    value: function _offsetTop(e) {
      var t = this;
      return e ? e.offsetTop + t._offsetTop(e.offsetParent) : 0;
    }
  }, {
    key: "_offsetLeft",
    value: function _offsetLeft(e) {
      var t = this;
      return e ? e.offsetLeft + t._offsetLeft(e.offsetParent) : 0;
    }
  }, {
    key: "offset",
    value: function offset(e) {
      return {
        left: this._offsetLeft(e),
        top: this._offsetTop(e)
      };
    }
  }, {
    key: "getBoundingRect",
    value: function getBoundingRect(e) {
      var t = this;
      var i = window.pageXOffset,
          a = window.pageYOffset,
          n = e.getBoundingClientRect();
      if (e !== document.body) for (var _n278 = e.parentNode; _n278 !== document.body;) {
        i += _n278.scrollLeft, a += _n278.scrollTop, _n278 = _n278.parentNode, t.enableShadowDOM && _n278 === t.shadowRoot ? _n278 = t : t.isInShadowDOM && _n278 === t.getRootNode() && (_n278 = t.getRootNode().host);
      }
      return {
        bottom: n.bottom + a,
        height: n.height,
        left: n.left + i,
        right: n.right + i,
        top: n.top + a,
        width: n.width
      };
    }
  }, {
    key: "_upHandler",
    value: function _upHandler(e) {
      var t = this,
          i = t.getBoundingRect(t);

      if (t._tapTimer && clearTimeout(t._tapTimer), (e.pageX < i.left || e.pageX > i.right || e.pageY < i.top || e.pageY > i.bottom) && (t._inputOverlay && (t._inputOverlay.classList.remove("smart-input-overlay-on"), setTimeout(function () {
        t._inputOverlay && (t._inputOverlay.parentNode && t._inputOverlay.parentNode.removeChild(t._inputOverlay), t._inputOverlay = null);
      }, t.behavior.doubleClickTimingDelay)), t.editing.isEditing && !t.editing.dialog.enabled && setTimeout(function () {
        e.defaultPrevented || t.editing.editCell && t.editing.editCell.editor.instance && (t.editing.editCell.editor.instance.blur(e), e.defaultPrevented) || t.endEdit();
      }, 50), t.menu)) {
        var _a348, _i555, _n279, _o194;

        if (t.enableShadowDOM || t.isInShadowDOM ? (_a348 = e.originalEvent.composedPath()[0], _i555 = function () {
          for (var _e650 = _a348.getRootNode().host; _e650;) {
            if (_e650 === t) return _e650;
            _e650 = _e650.getRootNode().host;
          }
        }(), _n279 = t.menu.contains(_a348) || t.menu.firstElementChild.shadowRoot.contains(_a348), _o194 = t.menu.firstElementChild.shadowRoot) : (_a348 = e.originalEvent.target, _i555 = t.contains(_a348), _n279 = t.menu.contains(_a348), _o194 = t.menu), !_i555 && !_n279) {
          var _e651 = _o194.querySelectorAll("smart-drop-down-list"),
              _n280 = _o194.querySelectorAll("smart-date-time-picker");

          for (var _t535 = 0; _t535 < _e651.length; _t535++) {
            var _i556 = _e651[_t535],
                _n281 = _i556.$.dropDownContainer;
            if (_n281.contains(_a348)) return;
          }

          for (var _e652 = 0; _e652 < _n280.length; _e652++) {
            var _t536 = _n280[_e652],
                _i557 = _t536.$.dropDownContainer;
            if (_i557.contains(_a348)) return;
          }

          return void t.closeMenu();
        }
      }

      t._dragSelectionEnd(e), t._endResize();
    }
  }, {
    key: "_nextColumn",
    value: function _nextColumn(e) {
      var t = this;

      for (var _a349 = 0; _a349 < t.viewColumns.length; _a349++) {
        var _i558 = t.viewColumns[_a349];
        if (_i558.visibleIndex === e.visibleIndex + 1) return _i558;
      }

      return null;
    }
  }, {
    key: "_nextRow",
    value: function _nextRow(e) {
      var t = this,
          i = t._recyclingRows,
          a = i.indexOf(e);
      return 0 <= a ? i[a + 1] : null;
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      var t = this;

      if (t.isInitialized && t._selection) {
        if (t.selection.enabled && t.selection.allowDragSelection && !t.editing.isEditing && (!t._selection.selectionRect || t._selection.selectionRect && !t._selection.selectionRect.captured)) {
          t._dragSelection(e);

          var _i559 = e.originalEvent.target.closest ? e.originalEvent.target : void 0;

          Smart.Utilities.Core.isMobile && _i559 && _i559.closest("smart-grid") === t && e.originalEvent.preventDefault();
        }

        t.isScrolling || ("none" !== t.behavior.columnResizeMode && !t.classList.contains("smart-grid-row-resize-mode") && t._columnMoveResizeHandler(e), "none" !== t.behavior.rowResizeMode && !t.classList.contains("smart-grid-column-resize-mode") && t._rowMoveResizeHandler(e));
      }
    }
  }, {
    key: "_columnMouseLeaveHandler",
    value: function _columnMouseLeaveHandler() {
      var e = this;

      for (var _t537 = 0; _t537 < e._columnElements.length; _t537++) {
        var _i560 = e._columnElements[_t537],
            _a350 = _i560.column;
        _a350 && _a350.autoShowActionButton && _i560._hideActionButton();
      }
    }
  }, {
    key: "_columnMoveHandler",
    value: function _columnMoveHandler(e) {
      var t = this;
      if (t.isInitialized && !(t._columnResizeStartLine || t._rowResizeStartLine)) for (var _a351 = 0; _a351 < t._columnElements.length; _a351++) {
        var _i561 = t._columnElements[_a351],
            _n282 = _i561.column;

        if (_n282 && _n282.autoShowActionButton) {
          var _a352 = _i561.getBoundingClientRect(),
              _o195 = t.offset(_i561);

          if (!(_o195.left <= e.pageX && _o195.left + _a352.width - 6 >= e.pageX)) _i561._hideActionButton();else if (_o195.top <= e.pageY && _o195.top + _a352.height >= e.pageY) {
            if (!t.hasColumnMenu(_n282)) continue;

            _i561._showActionButton();
          } else _i561._hideActionButton();
        }
      }
    }
  }, {
    key: "_columnDownHandler",
    value: function _columnDownHandler(e) {
      var t = this,
          a = (t.enableShadowDOM ? t.shadowRoot : t.getRootNode()).elementsFromPoint(e.clientX, e.clientY);
      var i = null,
          n = null;
      var o = new Date() - t._clickTime < t.behavior.doubleClickTimingDelay;

      t._doubleClickHandler(e);

      for (var _t538 = 0; _t538 < a.length; _t538++) {
        var _e653 = a[_t538];
        if (_e653.classList.contains("smart-action-button")) return;

        if (_e653.getAttribute("data-field")) {
          i = _e653.getAttribute("data-field"), n = _e653;
          break;
        }
      }

      if (i) {
        var _a353 = n.column;
        if (!_a353) return;
        if ("_commandColumn" === i) return void t._applyCommand(t.editing.commandColumn.dataSource.commandColumnMenu.command);

        var _r123 = function _r123(n) {
          var o = _a353.selectionColumn ? t.selection.checkBoxes.action === n && t.selection.enabled : t.selection.action === n && t.selection.enabled;

          if (o) {
            if (t.editing.enabled && t.editing.editColumn === _a353) return;
            if (t._dragSelectionStartDataField = e.shiftKey || e.ctrlKey ? null : i, "_checkBoxColumn" === i) return void t._toggleColumnSelection(_a353);

            t._setSelection(null, _a353.dataField, e);
          }
        };

        if (t.editing.isEditing && t.endEdit(), t.$.fireEvent("columnClick", {
          column: _a353
        }), _r123("click"), o && (t.$.fireEvent("columnDoubleClick", {
          column: _a353
        }), _r123("doubleClick"), t._onColumnDoubleClick(_a353, e)), t._columnToResizeElement && !t._columnResizeLine) return void t._columnDownResizeHandler(e);
        Smart.Utilities.Core.isMobile ? (o && _a353.allowSortToggleOnClick && t.sorting.enabled && t.sortBy(i), t._columnMoveHandler(e), e.originalEvent.preventDefault()) : _a353.allowSortToggleOnClick && t.sorting.enabled && t.sortBy(i);
      }

      t.closeMenu(), t._clickTime = new Date();
    }
  }, {
    key: "addTransformMoveStyle",
    value: function addTransformMoveStyle(e, t, i, a, n, o) {
      e.style.opacity = o, e.style["transition-duration"] = t, e.style.transform = "translate3d(" + i + "px," + a + "px," + n + "px)";
    }
  }, {
    key: "removeTransformMoveStyle",
    value: function removeTransformMoveStyle(e) {
      e.style.opacity = "", e.style["transition-duration"] = "", e.style.transform = "";
    }
  }, {
    key: "_rowDownHandler",
    value: function _rowDownHandler(e) {
      var t = this;
      if (t._inputOverlay && t._inputOverlay.classList.remove("smart-input-overlay-on"), t._doubleClickHandler(e), t.closeMenu(), t._rowResizeHandler(e), t._toggledRow && t.appearance.allowRowToggleAnimation) return;
      var i = e.clientX,
          a = e.clientY;
      e.touches && (i = e.touches[0].clientX, a = e.touches[0].clientY);
      var n = (t.enableShadowDOM ? t.shadowRoot : t.getRootNode()).elementsFromPoint(i, a);
      var o = null,
          r = null,
          l = null,
          s = null;
      t._lastPointerDownTime = new Date();

      for (var _t539 = 0; _t539 < n.length; _t539++) {
        var _e654 = n[_t539];

        if (_e654.hasAttribute("toggle-button") && (r = _e654), _e654.hasAttribute("checkbox") && (l = _e654), s || "smart-grid-cell" !== _e654.nodeName.toLowerCase() || (s = _e654), !o && "smart-grid-row" === _e654.nodeName.toLowerCase()) {
          o = _e654;
          break;
        }
      }

      if (o && s) {
        var _i562 = s ? s.cell : null;

        if (r && _i562 && !_i562.column.rowDetailColumn) {
          var _t540 = o.row;

          _t540.toggle(e);
        } else if (t.rowDetail.enabled && t.rowDetail.visible && r && _i562 && _i562.column.rowDetailColumn) {
          var _e655 = o.row;
          _e655.showDetail ? t.hideDetail(_e655.id) : t.showDetail(_e655.id);
        } else {
          var _i563 = o.row,
              _a354 = s ? s.cell : null;

          _a354.column._treeColumn && l && (_i563.checked = !_i563.checked), t.$.fireEvent("rowClick", {
            row: _i563,
            originalEvent: e.originalEvent
          }), t.$.fireEvent("cellClick", {
            cell: _a354,
            originalEvent: e.originalEvent
          }), t._tapTimer && clearTimeout(t._tapTimer), t._tapTimer = setTimeout(function () {
            t._clickedRow === o && t.$.fireEvent("rowTap", {
              row: _i563,
              originalEvent: e.originalEvent
            }), t._clickedCell === s && t.$.fireEvent("cellTap", {
              cell: _a354,
              originalEvent: e.originalEvent
            });
          }, t.behavior.doubleClickTimingDelay);

          var _n283 = function _n283(n) {
            if (t.selection.enabled && !_i563.autoGenerated) {
              var _r125 = t.editing.isEditing;
              if (!(_r125 && t.editing.editCell && t.editing.editCell.row.id === _i563.id && t.editing.editCell.column.dataField === _a354.column.dataField) && !(_r125 && t.editing.editRow && t.editing.editRow.id === _i563.id)) if (t.selection.action === n) {
                if (t._dragSelectionStartRow = e.shiftKey || e.ctrlKey ? null : !t.selection.allowRowHeaderSelection && _a354.column.autoGenerated ? null : o.row, t._dragSelectionStartDataField = e.shiftKey || e.ctrlKey ? null : _a354.column.dataField, _a354.column.rowHeaderColumn && !t.selection.allowRowHeaderSelection) return void (t._dragSelectionStartRow = null);

                t._setSelection(_i563.id, _a354.column.dataField, e);
              } else _a354.column.selectionColumn && t.selection.checkBoxes.enabled && t.selection.checkBoxes.action === n && t._setSelection(_i563.id, _a354.column.dataField, e);
            }
          },
              _r124 = _a354.selected,
              d = t._clickedCell === s && new Date() - t._clickTime < t.behavior.doubleClickTimingDelay;

          _n283("click"), _i563.autoGenerated || _a354.column.autoGenerated || _a354.template ? (t._onRowClick(_i563.index, _i563, e), t._onCellClick(_a354, e)) : t.selection.enabled ? t.selection.allowCellSelection ? "extended" === t.selection.mode ? !0 === _r124 && _r124 === _a354.selected && !t.selection.isDragging && d && (t._onRowClick(_i563.index, _i563, e), t._onCellClick(_a354, e)) : d && (t._onRowClick(_i563.index, _i563, e), t._onCellClick(_a354, e)) : t.selection.allowRowSelection ? "extended" === t.selection.mode ? !0 === _r124 && _r124 === _a354.selected && !t.selection.isDragging && d && (t._onRowClick(_i563.index, _i563, e), t._onCellClick(_a354, e)) : d && (t._onRowClick(_i563.index, _i563, e), t._onCellClick(_a354, e)) : (t._onRowClick(_i563.index, _i563, e), t._onCellClick(_a354, e)) : (t._onRowClick(_i563.index, _i563, e), t._onCellClick(_a354, e)), new Date() - t._clickTime < t.behavior.doubleClickTimingDelay && (t._clickedRow === o && (t._onRowDoubleClick(_i563.index, _i563, e, e), t.$.fireEvent("rowDoubleClick", {
            row: _i563,
            originalEvent: e.originalEvent
          }), _n283("doubleClick")), t._clickedCell === s && (t._onCellDoubleClick(_a354, e), t.$.fireEvent("cellDoubleClick", {
            cell: _a354,
            originalEvent: e.originalEvent
          }))), t._clickedRow = o, t._clickedCell = s, t._clickTime = new Date();
        }
      }
    }
  }, {
    key: "showDetail",
    value: function showDetail(e) {
      var t = this,
          i = t.rowById[e];
      i && (i.showDetail = !0);
    }
  }, {
    key: "hideDetail",
    value: function hideDetail(e) {
      var t = this,
          i = t.rowById[e];
      i && (i.showDetail = !1);
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler() {
      var e = this;
      e._focused = !0;
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      var e = this;
      e._focused = !1;
    }
  }, {
    key: "_notify",
    value: function _notify(e, t, a) {
      var n = this;
      if (n.notifyFn) for (var _o196 = 0; _o196 < n.notifyFn.length; _o196++) {
        n.notifyFn[_o196](e, t, a);
      }
    }
  }, {
    key: "notify",
    value: function notify(e) {
      var t = this;
      e && (!t.notifyFn && (t.notifyFn = []), t.notifyFn.push(e));
    }
  }, {
    key: "_applyTemplate",
    value: function _applyTemplate(e, t) {
      var i = null;
      if (null === e || "" === e) return void (t.innerHTML = "");
      if ((e.startsWith("#") || e.startsWith(".")) && (i = document.querySelector(e)), i) t.innerHTML = "", t.appendChild(i.content.cloneNode(!0).firstElementChild);else {
        var _i564 = function _i564(e) {
          var t = document.createElement("template");
          return e = e.trim(), t.innerHTML = e, t.content.firstChild;
        },
            _a355 = _i564(e);

        _a355 && (t.innerHTML = "", t.appendChild(_a355));
      }
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      if (a.isInitialized) {
        switch (a._notify(e, t, i), e) {
          case "appearance_displayLoadingIndicator":
            return;

          case "appearance_placeholder":
            return void (a.$.placeholder.innerHTML = i);

          case "appearance_showColumnHeaderLines":
          case "appearance_showColumnLines":
          case "appearance_showRowLines":
            return void a._recycle();

          case "appearance_allowColumnStickyPosition":
            {
              i ? a._stickHeader() : a._unstickHeader();
              break;
            }

          case "appearance_showColumnIcon":
            {
              for (var _e656 = 0; _e656 < a.columns.length; _e656++) {
                var _t541 = a.columns[_e656];

                _t541.setProperty("showIcon", a.appearance.showColumnIcon);
              }

              a._recycle();

              break;
            }

          case "appearance_showRowHeaderNumber":
          case "appearance_showRowHeader":
            {
              a._initializeRowNumberColumn();

              var _e657 = a._frozenNearColumns[0];
              _e657.rowHeaderColumn && _e657.element && !_e657.element.parentNode && a.$.columnNearContainer.appendChild(_e657.element), a.refresh();
              break;
            }

          case "header_template":
            {
              a._applyTemplate(i, a.$.header);

              break;
            }

          case "footer_template":
            {
              a._applyTemplate(i, a.$.footer);

              break;
            }

          case "columnWidth":
            {
              a.columns.canNotify = !1;

              var _e658 = parseInt(i);

              if (isNaN(_e658) && (_e658 = null), 30 <= _e658 || null === _e658) for (var _t542 = 0; _t542 < a.columns.length; _t542++) {
                var _i565 = a.columns[_t542];
                _i565.width = _e658;
              }
              a.columns.canNotify = !0, a.refresh();
              break;
            }

          case "checkBoxes_visible":
            return void a._recycle();

          case "checkBoxes_hasThreeStates":
            return a.rows.canNotify = !1, a._applyThreeStates(a.rowHierarchy), a.rows.canNotify = !0, void a._recycle();

          case "columnHeader_visible":
            {
              a.__columnHeaderHeight = null, a.refresh();
              break;
            }

          case "selection_checkBoxes_enabled":
            {
              a._selectionColumn.visible = i;
              break;
            }

          case "selection_checkBoxes_autoShow":
            {
              a._selectionColumn.element && (i ? a._selectionColumn.element.setAttribute("auto-show", "") : a._selectionColumn.element.removeAttribute("auto-show"));
              break;
            }

          case "selection_checkBoxes_position":
            {
              var _e659 = a.viewColumns.indexOf(a._selectionColumn);

              a.viewColumns.canNotify = !1, a.viewColumns.splice(_e659, 1);

              var _t543 = a._frozenNearColumns.indexOf(a._selectionColumn),
                  _n284 = a._frozenFarColumns.indexOf(a._selectionColumn);

              if (0 <= _t543 && a._frozenNearColumns.splice(_t543, 1), 0 <= _n284 && a._frozenFarColumns.splice(_n284, 1), "far" === i) a._selectionColumn.canNotify = !1, a._selectionColumn.freeze = "far", a._selectionColumn.canNotify = !0, a._frozenFarColumns.splice(0, 0, a._selectionColumn), a.viewColumns.push(a._selectionColumn), a.$.columnFarContainer.appendChild(a._selectionColumn.element);else {
                var _e660 = 0,
                    _t544 = 0;

                for (var _n285 = 0; _n285 < a.viewColumns.length && (a.viewColumns[_n285].autoGenerated || a.viewColumns[_n285].dataField !== a.columns[_t544++].dataField); _n285++) {
                  a.viewColumns[_n285].autoGenerated && _e660++;
                }

                a._selectionColumn.canNotify = !1, a._selectionColumn.freeze = "near", a._selectionColumn.canNotify = !0, a._frozenNearColumns.splice(_e660, 0, a._selectionColumn), a.viewColumns.splice(_e660, 0, a._selectionColumn), a.$.columnNearContainer.appendChild(a._selectionColumn.element);
              }
              a.viewColumns.canNotify = !0;
              break;
            }

          case "filtering_enabled":
            return void (i && a._createFilterPanels());

          case "filtering_filter":
            for (var _e661 = 0; _e661 < a.columns.length; _e661++) {
              var _t545 = a.columns[_e661];
              _t545.canNotify = !1, _t545.setProperty("filter", null), _t545.canNotify = !0;
            }

            for (var _e662 = 0; _e662 < a.filtering.filter.length; _e662++) {
              var _t546 = a.filtering.filter[_e662];

              if (_t546) {
                var _e663 = _t546[0],
                    _i566 = _t546.splice(1);

                var _n286 = null;
                if (_i566 instanceof Smart.FilterGroup) _n286 = _i566;else {
                  var _t547 = a.columnByDataField[_e663];
                  _t547 && (_n286 = a.dataSource._createFilter(_t547.dataType, _i566));
                }
                _n286 && a.addFilter(_e663, _n286, !1);
              }
            }

            return void a.refreshFilters();

          case "messages":
          case "locale":
            {
              a._dialogEdit && (a._dialogEdit.close(), a._dialogEdit = null), a._dialogDelete && (a._dialogDelete.close(), a._dialogDelete = null), a._dialogAddRow && (a._dialogAddRow.close(), a._dialogAddRow = null), a._recycle();
              break;
            }

          case "paging_spinner_enabled":
            {
              a._refresh();

              break;
            }

          case "pager_visible":
            return a._renderPagers(), void a._refreshPaging(!1);

          case "paging_pageIndex":
          case "pager_position":
          case "paging_enabled":
            return void a._refreshPaging(!0);

          case "paging_pageSize":
            return void a._refreshPaging(!1);

          case "columns":
            return void a._renderColumns();

          case "dataSource":
            return void a.dataBind();

          case "rowDetail_dialog_width":
          case "rowDetail_dialog_height":
          case "rowDetail_dialog_enabled":
          case "rowDetail_dialog_visible":
            return;

          case "rowDetail_height":
          case "rowDetail_enabled":
            {
              a.beginUpdate(), a.rows.canNotify = !1;
              var _e664 = a.appearance.allowRowDetailToggleAnimation;
              a.appearance.allowRowDetailToggleAnimation = !1;

              for (var _e665 = 0; _e665 < a._recyclingRows.length; _e665++) {
                var _t548 = a._recyclingRows[_e665];
                _t548.height = null, _t548.setProperty("showDetail", !1), _t548.detailHeight = a.rowDetail.height;
              }

              if (a.rows.canNotify = !0, !a.rowDetail.enabled) for (var _e666 = 0; _e666 < a.viewColumns.length; _e666++) {
                var _t549 = a.viewColumns[_e666];

                if (_t549.rowDetailColumn) {
                  _t549.visible = !1;
                  break;
                }
              }
              return a.appearance.allowRowDetailToggleAnimation = _e664, void a.endUpdate();
            }

          case "rowDetail_visible":
            {
              for (var _e667 = 0; _e667 < a.viewColumns.length; _e667++) {
                var _t550 = a.viewColumns[_e667];

                if (_t550.rowDetailColumn) {
                  _t550.visible = i;
                  break;
                }
              }

              return;
            }

          case "displayLoadingIndicator":
            return void a._setLoadingIndicatorVisibility();

          case "filterable":
            return void a._refreshLayout();

          case "selectionMode":
            return;

          case "editing_addNewRow_visible":
            {
              a._renderAddNewRow(), a.refresh();
              break;
            }

          case "editing_addNewRow_position":
            return a._renderAddNewRow(), void a.refresh();

          case "editing_dialog_visible":
            return;

          case "editing_commandColumn_visible":
            return void a.refresh(!0);
        }

        a.refresh();
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class63.prototype), "ready", this).call(this);

      var e = this,
          t = e._scrollView.vScrollBar,
          i = e._scrollView.hScrollBar;
      t.hasStyleObserver = !1, i.hasStyleObserver = !1, t.hasResizeObserver = !1, i.hasResizeObserver = !1, t.wait = !1, i.wait = !1, t.onChange = e._verticalScrollbarHandler.bind(e), i.onChange = e._horizontalScrollbarHandler.bind(e), e.setFocusable(!0), e.$.loadingIndicatorPlaceholder.innerHTML = e.appearance.loadingIndicatorPlaceholder, e.$.placeholder.innerHTML = e.appearance.placeholder, e._setLoadingIndicatorVisibility(), e._cellsMerge = [], e.checkLicense();
    }
  }, {
    key: "checkLicense",
    value: function checkLicense(e) {
      var t = this;
      (t.grouping.enabled || t.selection.enabled && t.selection.allowCellSelection || t.rowDetail.enabled || t.charting.enabled || t.editing.enabled && t.editing.batch || t.editing.enabled && "row" === t.editing.mode || t.editing.enabled && t.editing.addNewRow.visible || t.editing.enabled && t.editing.commandColumn.visible || "virtual" === t.scrolling || t.sorting.enabled && "many" === t.sorting.mode || !0 === e) && _get(_getPrototypeOf(_class63.prototype), "checkLicense", this).call(this);
    }
  }, {
    key: "_createFilterPanels",
    value: function _createFilterPanels() {
      var e = this;
      if (!e._filterPanels) e._filterPanels = [];else if (0 < e._filterPanels.length) return;
      e.filtering.enabled && 0 === e._filterPanels.length && requestAnimationFrame(function () {
        var t = document.createElement("smart-filter-panel"),
            i = document.createElement("smart-filter-panel"),
            a = document.createElement("smart-filter-panel"),
            n = document.createElement("smart-filter-panel");

        for (var _o197 in i.filterType = "boolean", a.filterType = "numeric", n.filterType = "date", e._filterPanels.bool = i, e._filterPanels.date = n, e._filterPanels.numeric = a, e._filterPanels.string = t, e._filterPanels) {
          var _t551 = e._filterPanels[_o197];
          _t551.classList.add("smart-hidden"), e.$.content.appendChild(_t551), _t551.parentNode.removeChild(_t551);
        }
      });
    }
  }, {
    key: "_applyScrolling",
    value: function _applyScrolling() {
      var e = this,
          t = e._scrollView.vScrollBar;
      requestAnimationFrame(function () {
        switch (t.largeStep = e.$.scrollView.offsetHeight, e.scrolling) {
          case "physical":
          case "infinite":
          case "virtual":
            t.step = 10, t.mechanicalAction = "switchWhileDragging";
            break;

          case "deferred":
            t.step = 10, t.mechanicalAction = "switchWhenReleased";
            break;

          case "logical":
            t.step = e.layout.rowMinHeight, t.mechanicalAction = "switchWhileDragging";
        }
      });
    }
  }, {
    key: "_measureColumnHeight",
    value: function _measureColumnHeight() {
      var e = this;
      if (e.__measuredColumnHeight) return e.__measuredColumnHeight;
      var t = document.createElement("smart-grid-column");
      t.style.height = "auto", t.style.position = "static";
      var i = document.createElement("div");
      i.classList.add("smart-label"), i.innerHTML = "aAbBcCdDeEfFgGhHiIjJkKlLmMnNoOpPqQrRwWxXyYzZ1234567890", t.appendChild(i), e.$.columnHeader.appendChild(t);
      var a = e.$.columnHeader.offsetHeight;
      return e.$.columnHeader.removeChild(t), e._columnHeights && 1 < e._columnHeights.length && (a = e._columnHeights[0]), a < e.columnMinHeight && (a = e.columnMinHeight), e.__measuredColumnHeight = a, a;
    }
  }, {
    key: "_initializeColumnGroupsHierarchy",
    value: function _initializeColumnGroupsHierarchy() {
      var e = this;
      var t = 0;

      if (e.$.columnContainer.innerHTML = "", 0 < e.columnGroups.length) {
        for (var _t552 = 0; _t552 < e.columnGroups.length; _t552++) {
          e.columnGroups[_t552].parent = null, e.columnGroups[_t552].groups = null;
        }

        for (var _t553 = 0; _t553 < e.viewColumns.length; _t553++) {
          e.viewColumns[_t553].parent = null, e.viewColumns[_t553].groups = null;
        }

        var _i567 = function _i567(t) {
          for (var _a357 = 0, _i568; _a357 < e.columnGroups.length; _a357++) {
            if (_i568 = e.columnGroups[_a357], _i568.name === t) return _i568;
          }

          return null;
        },
            _a356 = function _a356(e) {
          var t = [];
          if (e.columnGroup && t.push(e), e.groups) for (var _n287 = 0; _n287 < e.groups.length; _n287++) {
            if (e.groups[_n287].columnGroup) t.push(e.groups[_n287]);else if (e.groups[_n287].groups) {
              var _i569 = _a356(e.groups[_n287]);

              for (var _e668 = 0; _e668 < _i569.length; _e668++) {
                t.push(_i569[_e668]);
              }
            }
          }
          return t;
        };

        for (var _t554 = 0, _a358; _t554 < e.columnGroups.length; _t554++) {
          if (_a358 = e.columnGroups[_t554], _a358.groups || (_a358.groups = null), _a358.parentGroup) {
            var _e669 = _i567(_a358.parentGroup);

            _e669 && (_a358.parent = _e669, !_e669.groups && (_e669.groups = []), -1 === _e669.groups.indexOf(_a358) && _e669.groups.push(_a358));
          }
        }

        for (var _t555 = 0, _a359; _t555 < e.viewColumns.length; _t555++) {
          if (_a359 = e.viewColumns[_t555], _a359.columnGroup) {
            var _e670 = _i567(_a359.columnGroup);

            _e670 && (!_e670.groups && (_e670.groups = []), _a359.parent = _e670, -1 === _e670.groups.indexOf(_a359) && _e670.groups.push(_a359));
          }
        }

        for (var _a360 = 0; _a360 < e.viewColumns.length; _a360++) {
          var _i570 = e.viewColumns[_a360];
          var _n288 = _i570;

          for (_i570.level = 0; _n288.parent;) {
            _n288 = _n288.parent, _i570.level++;
          }

          _n288 = _i570;
          var _o198 = _i570.level;

          for (t = Math.max(t, _i570.level); _n288.parent;) {
            _n288 = _n288.parent, _n288 && (_n288.level = --_o198);
          }
        }

        for (var _t556 = 0; _t556 < e.columnGroups.length; _t556++) {
          var _i571 = e.columnGroups[_t556],
              _n289 = _a356(_i571);

          _i571.columns = _n289;
          var _o199 = [],
              _r126 = 0,
              _l96 = "near";
          0 === _n289.length && (_r126 = -1, _i571.visible = !1);

          for (var _t557 = 0; _t557 < _n289.length; _t557++) {
            _o199.push(e.viewColumns.indexOf(_n289[_t557])), _n289[_t557].freeze && ("far" === _n289[_t557].freeze && (_l96 = "far"), _r126++);
          }

          _r126 === _n289.length ? _i571.freeze = _l96 : 0 < _r126 && _r126 < _n289.length && e.error(e.localize("frozenColumns", {
            elementType: "Grid"
          })), _o199.sort(function (e, t) {
            return e = parseInt(e), t = parseInt(t), e < t ? -1 : e > t ? 1 : 0;
          });

          for (var _t558 = 1; _t558 < _o199.length; _t558++) {
            _o199[_t558] !== _o199[_t558 - 1] + 1 && e.error(e.localize("columnGroups", {
              elementType: "Grid"
            }));
          }
        }
      }

      e._columnGroupsLevel = 1 + t;
    }
  }, {
    key: "_refreshColumnHeights",
    value: function _refreshColumnHeights() {
      var e = this;
      e.$.columnHeader.style.height = "", e._viewColumnsHeight = e._measureColumnHeight(), e._columnHeights = [];
      var t = 0;

      for (var _a361 = 0, _i572; _a361 < e._columnGroupsLevel; _a361++) {
        _i572 = e._viewColumnsHeight, e.columnHeight && ("number" == typeof e.columnHeight ? _i572 = e.columnHeight ? e.columnHeight : e._viewColumnsHeight : _i572 = e.columnHeight ? e.columnHeight(_a361) : e._viewColumnsHeight), _i572 < e.columnMinHeight && (_i572 = e.columnMinHeight), _i572 ? (e._columnHeights.push(_i572), t += _i572) : (t += e._viewColumnsHeight, e._columnHeights.push(e._viewColumnsHeight));
      }

      e._columnHeaderHeight = e._columnGroupsLevel * e._viewColumnsHeight, e._columnHeaderHeight = t, e.$.columnHeader.style.height = e._columnHeaderHeight + "px";

      var a = function a(t) {
        var a = 0;

        for (var _n290 = 0; _n290 < t.level; _n290++) {
          a += e._columnHeights[_n290];
        }

        return a;
      },
          n = function n(t) {
        var i = a(t),
            n = e._columnHeaderHeight - i;

        for (var _a362 = t.level + 1; _a362 < e._columnHeights.length; _a362++) {
          var _i573 = _a362;

          for (var _a363 = 0; _a363 < e.viewColumns.length; _a363++) {
            var _o200 = e.viewColumns[_a363];

            var _r127 = !1;

            if (_o200.level === _i573) {
              for (var _a364 = _o200; _a364.parent;) {
                if (_a364.parent === t) {
                  n = e._columnHeights[_i573], _r127 = !0;
                  break;
                }

                _a364 = _a364.parent;
              }

              if (_r127) break;
            }
          }
        }

        return n;
      };

      for (var _t559 = 0; _t559 < e.viewColumns.length; _t559++) {
        var _i574 = e.viewColumns[_t559],
            _o201 = n(_i574);

        _i574.computedHeight = _o201, _i574.top = a(_i574);
      }

      for (var _t560 = 0; _t560 < e._columnGroupsLevel - 1; _t560++) {
        for (var _o202 = 0; _o202 < e.columnGroups.length; _o202++) {
          var _i575 = e.columnGroups[_o202],
              _r128 = _i575.level;
          if (_r128 !== _t560) continue;

          if (_i575.groups) {
            var _e671 = n(_i575),
                _t561 = a(_i575);

            _i575.top = _t561, _i575.computedHeight = _e671;
          }

          var _l97 = _i575.element;
          _l97 && (_l97.style.width = _i575.computedWidth + "px", _l97.style.left = _i575.left + "px", _l97.style.top = _i575.top + "px", _l97.style.height = _i575.computedHeight + "px", _l97.style.lineHeight = _i575.computedHeight + "px");
        }
      }
    }
  }, {
    key: "_refreshColumnWidths",
    value: function _refreshColumnWidths() {
      var e = this;
      e.__clientSize = null;
      var t = 0 < e.$.verticalScrollBar.offsetWidth ? e.$.verticalScrollBar.offsetWidth : 0,
          i = e.dataSource.groupBy || [];
      var a = e.grouping.enabled ? e.grouping.groupIndent * (1 + i.length) : 0,
          n = 0;
      e.selection.checkBoxes.enabled && (n = e._selectionColumn.computedWidth ? e._selectionColumn.computedWidth : e._selectionColumn.minWidth);
      var o = e._clientSize.width - t - a;
      var r = 0,
          l = [],
          s = 0,
          d = 0,
          c = 0;

      if (e.editing.enabled && !e.editing.commandColumn.inline) {
        var _t562 = function _t562() {
          var t = document.createElement("div"),
              i = document.createElement("div"),
              a = e.editing.commandColumn.dataSource;
          var n = 0,
              o = "",
              r = 0;

          for (var _t563 in i.classList.add("smart-label"), a) {
            var _i576 = a[_t563];

            var _n291 = !1;

            if ("commandColumnMenu" == _t563) continue;

            var _l98 = !1;

            if (_n291 || (!0 === _i576.visible ? (r++, _l98 = !0) : "auto" === _i576.visible && ((e.editing.editRow || e.editing.editCell) && !e.editing.dialog.enabled || "commandColumnEdit" != _t563 ? (e.editing.editRow || e.editing.editCell) && !e.editing.dialog.enabled && ("commandColumnUpdate" == _t563 ? (r++, _l98 = !0) : "commandColumnCancel" == _t563 && (r++, _l98 = !0)) : (r++, _l98 = !0)), _n291 = !0), _l98 && "icon" !== e.editing.commandColumn.displayMode) {
              var _a365 = "{{messages}}" === _i576.label ? e.localize(_t563) : _i576.label;

              o += "<span>" + _a365 + "</span>";
            }
          }

          return i.innerHTML = "<span>" + o + "</span>", t.appendChild(i), t.style.width = "auto", t.style.position = "static", e.$.columnHeader.appendChild(t), n = 10 + i.firstChild.offsetWidth, e.$.columnHeader.removeChild(t), "icon" === e.editing.commandColumn.displayMode ? n = 20 + 20 * r : "labelAndIcon" === e.editing.commandColumn.displayMode ? n += 25 * r : n += 10 * r, n;
        };

        if (e._commandColumn.visible = e.editing.commandColumn.visible, e.editing.commandColumn.visible) {
          var _i577 = e.editing.commandColumn.width ? e.editing.commandColumn.width : _t562();

          e.columns.canNotify = !1, e._commandColumn.width = _i577, e.columns.canNotify = !0;
        }
      }

      for (var _t564 = 0; _t564 < e.viewColumns.length; _t564++) {
        var _i578 = e.viewColumns[_t564],
            _a366 = _i578;

        var _s70 = void 0;

        "number" == typeof _a366.width ? _s70 = _a366.width : _a366.width && 0 <= _a366.width.toString().indexOf("%") ? (_s70 = parseFloat(_a366.width) / 100, _s70 *= o - n) : _a366.width && (0 <= _a366.width.toString().indexOf("em") || 0 <= _a366.width.toString().indexOf("pt") || 0 <= _a366.width.toString().indexOf("fr")) ? (_s70 = parseFloat(_a366.width), _s70 *= 16) : "auto" === _a366.width ? _s70 = _a366._autoSize() : _a366.visible && (l.push(_a366), _s70 = 0), _a366.overflowWidth && (_s70 -= _a366.overflowWidth), _a366.visible && (r += _s70), _s70 < _a366.minWidth && (_s70 = _a366.minWidth), _a366.computedWidth = _s70;
      }

      if (l) {
        var _e672 = o - r,
            _t565 = 0;

        0 > _e672 && (_e672 = 60 * l.length);

        for (var _a367 = 0; _a367 < l.length; _a367++) {
          var _i579 = l[_a367];

          var _n292 = void 0;

          _n292 = _e672 / l.length, _a367 == l.length - 1 && (_n292 = _e672 - _t565), _i579.overflowWidth && (_n292 -= _i579.overflowWidth), _n292 < _i579.minWidth && (_n292 = _i579.minWidth), _i579.computedWidth = _n292, _t565 += _n292;
        }
      }

      for (var _t566 = 0; _t566 < e.viewColumns.length; _t566++) {
        var _i580 = e.viewColumns[_t566];
        var _n293 = _i580;
        _n293.visible && (0 < a && !_n293.autoGenerated && (_n293.computedWidth += a, a = 0), _n293.freeze ? !0 === _n293.freeze || "near" === _n293.freeze ? (_n293.left = s, c += _n293.computedWidth, s += _n293.computedWidth) : "far" === _n293.freeze && (_n293.left = d, d += _n293.computedWidth) : (_n293.left = c, c += _n293.computedWidth));
      }

      for (var _t567 = 0; _t567 < e._columnGroupsLevel - 1; _t567++) {
        var _loop26 = function _loop26(_a368) {
          var i = e.columnGroups[_a368],
              n = i.level;
          if (n !== _t567) return "continue";
          var o = 99999;

          if (i.groups) {
            var _e673 = function _e673(t) {
              var i = 0;

              for (var _a369 = 0, _n294; _a369 < t.groups.length; _a369++) {
                _n294 = t.groups[_a369], _n294.groups ? i += _e673(_n294) : !_n294.hidden && (o = Math.min(_n294.left, o), i += _n294.computedWidth);
              }

              return i;
            };

            i.computedWidth = _e673(i), i.left = o;
          }
        };

        for (var _a368 = 0; _a368 < e.columnGroups.length; _a368++) {
          var _ret10 = _loop26(_a368);

          if (_ret10 === "continue") continue;
        }
      }
    }
  }, {
    key: "_createColumnHeaderCellElements",
    value: function _createColumnHeaderCellElements() {
      var e = this,
          t = e.$.columnContainer,
          a = document.createDocumentFragment();
      var n = 0;
      e._columnElements = [], e.$.columnContainer.innerHTML = "", e.$.columnNearContainer.innerHTML = "", e.$.columnFarContainer.innerHTML = "";

      for (var _t568 = 0; _t568 < e._frozenNearColumns.length; _t568++) {
        var _i581 = e._frozenNearColumns[_t568];

        _i581.createElement();
      }

      for (var _t569 = 0; _t569 < e._frozenFarColumns.length; _t569++) {
        var _i582 = e._frozenFarColumns[_t569];

        _i582.createElement();
      }

      for (var _t570 = 0; _t570 < e.viewColumns.length; _t570++) {
        var _i583 = e.viewColumns[_t570];
        if (_i583.freeze) continue;

        var _o203 = _i583.createElement();

        if (_i583.computedWidth === void 0) {
          e._columnElements.push(_o203), a.appendChild(_o203);
          continue;
        }

        n += _i583.computedWidth, e._columnElements.push(_o203), n < 2 * e._clientSize.width && a.appendChild(_o203);
      }

      for (var _t571 = 0; _t571 < e.columnGroups.length; _t571++) {
        var _i584 = e.columnGroups[_t571],
            _n295 = new Smart.Grid.Column({
          visible: !(_i584.visible !== void 0) || _i584.visible,
          allowSelect: !1,
          grid: e,
          dataField: _i584.name,
          label: _i584.label,
          align: _i584.align,
          verticalAlign: _i584.verticalAlign
        });

        _i584.column = _n295;

        var _o204 = _n295.createElement();

        _o204.style.width = _i584.computedWidth + "px", _o204.style.left = _i584.left + "px", _o204.style.top = _i584.top + "px", _o204.style.height = _i584.computedHeight + "px", _o204.style.lineHeight = _i584.computedHeight + "px", a.appendChild(_o204), _i584.element = _o204, _i584.grid = this;
      }

      e.htmlColumnLastChild || (e.htmlColumnLastChild = document.createElement("smart-grid-column"), e.htmlColumnLastChild.classList.add("top-far-corner"), e.htmlColumnLastChild.onpointerdown = function (e) {
        e.stopPropagation(), e.preventDefault();
      }, e.$.columnHeader.appendChild(e.htmlColumnLastChild)), t.appendChild(a), t.style.width = e._computedColumnsWidth + "px", e._refreshFrozenColumns();
    }
  }, {
    key: "_refreshFrozenColumns",
    value: function _refreshFrozenColumns() {
      var e = this;
      e.$.columnNearContainer.style.width = e._frozenColumnsNearWidth + "px", e.$.columnFarContainer.style.width = e._frozenColumnsFarWidth + "px";

      for (var _t572 = 0; _t572 < e.columnGroups.length; _t572++) {
        var _i585 = e.columnGroups[_t572];
        _i585.freeze && _i585.element && (!0 === _i585.freeze || "near" === _i585.freeze ? e.$.columnNearContainer.appendChild(_i585.element) : "far" === _i585.freeze && e.$.columnFarContainer.appendChild(_i585.element));
      }

      for (var _t573 = 0; _t573 < e.viewColumns.length; _t573++) {
        var _i586 = e.viewColumns[_t573];
        _i586.freeze && _i586.element && (!0 === _i586.freeze || "near" === _i586.freeze ? e.$.columnNearContainer.appendChild(_i586.element) : "far" === _i586.freeze && e.$.columnFarContainer.appendChild(_i586.element));
      }
    }
  }, {
    key: "_initializeRowElements",
    value: function _initializeRowElements() {
      var e = this;
      if (!e.rows) return;
      e.rows.canNotify = !1;
      var t = 0,
          a = e._clientSize.height;
      e.$.rowNearContainer.innerHTML = "", e.$.rowFarContainer.innerHTML = "", e.$.rowContainer.innerHTML = "", e._rowElements = [], e._overflowOffset = Math.max(a, 300);
      var i = e.offsetHeight;
      e.$.container.classList.add("smart-hidden");
      var n = e.offsetHeight;
      e.$.container.classList.remove("smart-hidden"), ("hidden" === e.verticalScrollBarVisibility || i !== n) && (a = e._scrollHeight);

      var o = function o() {
        var n = document.createDocumentFragment();

        if (!(e.rows && 0 === e.rows.length)) {
          for (var _o206 = 0; _o206 < e.rows.length; _o206++) {
            var _i587 = e.rows[_o206];
            if (_i587.freeze) continue;

            var _r129 = _i587.createElement();

            if (n.appendChild(_r129), t += e.layout.rowMinHeight, t > e._overflowOffset + a) break;
          }

          e.$.rowContainer.appendChild(n);
          var _o205 = e.$.rowContainer.children;

          for (var _t574 = 0; _t574 < _o205.length; _t574++) {
            var _i588 = _o205[_t574];
            e.rows[_t574] && (e.rows[_t574].element = _i588), e._rowElements[_t574] = _i588;
          }
        }
      };

      for (var _t575 = 0; _t575 < e._frozenNearRows.length; _t575++) {
        var _i589 = e._frozenNearRows[_t575],
            _a370 = _i589.createElement();

        _i589.element = _a370, e.$.rowNearContainer.appendChild(_a370);
      }

      for (var _t576 = 0; _t576 < e._frozenFarRows.length; _t576++) {
        var _i590 = e._frozenFarRows[_t576],
            _a371 = _i590.createElement();

        _i590.element = _a371, e.$.rowFarContainer.appendChild(_a371);
      }

      o();

      for (var _e674 = 0; t < 1.5 * a && 50 > ++_e674;) {
        o();
      }

      e.rows.canNotify = !0;
    }
  }, {
    key: "_initializeRows",
    value: function _initializeRows() {
      var e = Math.ceil;
      var t = this;
      var i = 0;
      t._frozenNearDefaultRows = [], t._frozenFarDefaultRows = [], t.rows = [], t.rowById = [], t._frozenFarRows = [], t._frozenNearRows = [];

      var a = function a() {
        var e = [],
            a = !1;

        for (var _n296 = 0; _n296 < t.columns.length; _n296++) {
          var _i591 = t.columns[_n296];
          var _o207 = {};
          _i591.summary && 0 < _i591.summary.length && (a = !0), _o207[_i591.dataField] = _i591.summary, e.push(_o207);
        }

        return a ? void (t._summaryItems = t.dataSource.summarize(e)) : void (t._summaryItems = []);
      },
          n = function n(e, a) {
        var n = e.grid ? e : new Smart.Grid.Row({
          data: e,
          index: a,
          grid: t
        });
        if (t.onRowInit) for (var _e675 in t.onRowInit(a, n), n) {
          -1 !== n.properties.indexOf(_e675) || _e675.startsWith("_") || t.error(t.localize("invalidRowProperty", {
            elementType: "Grid",
            propertyName: _e675
          }));
        }
        if (n.selected && (t._selection.rows[n.id] = !0), !n.freeze) t.rows[a] ? t.rows.splice(a, 0, n) : t.rows.push(n);else if (!0 === n.freeze || "near" === n.freeze) {
          t.rows.splice(i++, 0, n);
          var _e676 = t.rows[i - 1];
          -1 === t._frozenNearRows.indexOf(_e676) && t._frozenNearRows.push(_e676);
        } else if ("far" === n.freeze) {
          t.rows.push(n);
          var _e677 = t.rows[t.rows.length - 1];
          -1 === t._frozenFarRows.indexOf(_e677) && t._frozenFarRows.push(_e677);
        }
        "virtual" === t.scrolling || t.paging.enabled && t.dataSource && t.dataSource.virtualDataSource || t.onRowInserted && t.onRowInserted(a, n);
      },
          o = function o() {
        var e = t.rows[t.rows.length - 1];
        t.rows.pop(), t.onRowRemoved && t.onRowRemoved(t.rows.length, e);
      },
          r = function r(e) {
        var i = t.rows[e];
        t.rows.splice(e, 1), t.onRowRemoved && t.onRowRemoved(e, i);
      };

      t._add = n, t._removeLastRow = o, t._removeAt = r, t._rowHeight = t._autoRowHeight;
      var l = t.dataSource.length;

      for (var _e678 = 0; _e678 < t.dataSource.length; _e678++) {
        var _i592 = t.dataSource[_e678];
        n(_i592, _e678);
      }

      for (var _e679 = 0; _e679 < t._frozenFarRows.length; _e679++) {
        var _i593 = t._frozenFarRows[_e679];
        t.rows.splice(t.rows.indexOf(_i593), 1), t.rows.push(_i593);
      }

      if (a(), t.dataSource.notify(function (s) {
        if (!t.dataSource._updating) {
          var d = s.data;

          switch (t.rows.canNotify = !1, s.action) {
            case "add":
              if (d.length) for (var _e680 = 0; _e680 < d.length; _e680++) {
                n(d[_e680], t.dataSource.length - d.length + _e680);
              } else n(d, t.dataSource.length - 1);
              break;

            case "update":
              if (d.length) for (var _e681 = 0; _e681 < d.length; _e681++) {
                var _i594 = s.index[_e681];

                if (!t.rows[_i594]) {
                  n(d[_e681], t.dataSource.length - 1);
                  continue;
                }

                t.rows[_i594].data = d[_e681], t.onRowUpdated && t.onRowUpdated(_i594, t.rows[_i594]);
              } else {
                var _e682 = s.index;
                t.rows[_e682] ? t.rows[_e682].data = d : n(d, t.dataSource.length - 1), t.onRowUpdated && t.onRowUpdated(_e682, t.rows[_e682]);
              }
              break;

            case "insert":
              n(d, s.index);

              for (var _e683 = 0; _e683 < t.rows.length; _e683++) {
                var _i595 = t.rows[_e683];
                _i595.index = _e683;
              }

              break;

            case "remove":
              r(s.index);
              break;

            case "removeLast":
              o();
              break;

            case "bindingComplete":
              if (t.dataSource && t.dataSource.url || t.dataSource && !t.dataSource.virtualDataSource) {
                if (t.appearance.displayLoadingIndicator = !1, t._setLoadingIndicatorVisibility(), t._toggledRow = null, t.dataSource.length !== l) {
                  if (t.paging.enabled) {
                    var _i596 = t.$.headerPager.querySelector("smart-pager"),
                        _a372 = t.$.footerPager.querySelector("smart-pager");

                    _i596 && (_i596.pagesCount = e(t.dataSource.length / t.paging.pageSize)), _a372 && (_a372.pagesCount = e(t.dataSource.length / t.paging.pageSize));
                  }

                  t._initializeRows(), t._initializeRowElements(), t.refresh();
                }

                t._recycle();
              }

          }

          a(), "update" !== s.action && t._refreshLayout(), t._recycle(), t.rows.canNotify = !0;
        }
      }), t._observeRows(), t.summaryRow.visible) for (var _e684 = 0; _e684 < t._summaryRowCount; _e684++) {
        var _i597 = new Smart.Grid.Row({
          freeze: "near",
          visible: "near" === t.summaryRow.position,
          summaryRowIndex: _e684,
          summaryRow: !0
        }),
            _a373 = new Smart.Grid.Row({
          freeze: "far",
          visible: "far" === t.summaryRow.position,
          summaryRowIndex: _e684,
          summaryRow: !0
        });

        t._frozenNearRows.splice(0, 0, _i597), t._frozenFarRows.push(_a373);
      }

      if (t.filtering.enabled && t.filtering.filterRow.visible) {
        var _e685 = new Smart.Grid.Row({
          freeze: "near",
          filterRow: !0
        });

        t._frozenNearRows.splice(0, 0, _e685);
      }

      t._renderAddNewRow();
    }
  }, {
    key: "_observeRows",
    value: function _observeRows() {
      var e = this;
      e._frozenNearRows = [], e._frozenFarRows = [], e.rows = new Smart.ObservableArray(e.rows, null, {
        allowToggle: !0,
        allowResize: !0,
        allowCheck: !0,
        expanded: !0,
        selected: !0,
        checked: !0,
        visible: !0,
        enabled: !0,
        minHeight: !0,
        height: !0,
        freeze: !0,
        showDetail: !0,
        data: !0,
        visibleIndex: !0,
        index: !0
      });

      for (var _t577 = 0; _t577 < e.rows.length; _t577++) {
        var _i598 = e.rows[_t577];
        !0 === _i598.freeze || "near" === _i598.freeze ? e._frozenNearRows.push(_i598) : "far" === _i598.freeze && e._frozenFarRows.push(_i598), e.rowById[e.rows[_t577].id] = _i598;
      }

      var t = function (_t578) {
        function t(_x6, _x7, _x8, _x9) {
          return _t578.apply(this, arguments);
        }

        t.toString = function () {
          return _t578.toString();
        };

        return t;
      }(function (e, t, i, a) {
        e.propertyChanged(t, i, a);
      });

      e.rows.notify(function (a) {
        if (e.rows.canNotify) {
          var _i599 = a.action;

          if ("length" !== _i599) {
            if (a.path) return e.rows.canNotify = !1, t(e.rows[a.index], a.propertyName, a.oldValue, a.newValue), void (e.rows.canNotify = !0);

            if (e.rows.canNotify = !1, !!e.dataSource) {
              switch (e.dataSource.canNotify = !1, _i599) {
                case "add":
                  {
                    var _t579 = function _t579(t) {
                      var i = e.rows[t];

                      if (!1 == i instanceof Smart.Grid.Row) {
                        i = new Smart.Grid.Row(i);
                        var _n297 = e.rows.canNotify;
                        e.rows.canNotify = !1, a.object[t] = i, i = a.object[t], e.rows.canNotify = _n297;
                      }

                      t < e.dataSource.length ? e.dataSource.insert(t, e.rows[t].data) : e.dataSource.add(e.rows[t].data), i.grid = e, i.data = e.dataSource[t], e.rowById[i.id] = i, i.selected && (e._selection.rows[i.id] = !0), i.freeze && (!0 === i.freeze || "near" === i.freeze ? e._frozenNearRows.push(i) : "far" === i.freeze && e._frozenFarRows.push(i));
                    };

                    for (var _e686 = 0; _e686 < a.addedCount; _e686++) {
                      _t579(a.index + _e686);
                    }

                    break;
                  }

                case "update":
                  {
                    e.dataSource.update(a.index, e.rows[a.index]);
                    break;
                  }

                case "remove":
                  {
                    var _t580 = a.removed;
                    delete e.rowById[_t580.id], e.dataSource.remove(a.index);
                    break;
                  }
              }

              if (e.dataSource.canNotify = !0, e.rows.canNotify = !0, !!_i599) {
                var _t581 = e.isInitialized && e._rowElements && e._rowElements.length < e.rows.length;

                _t581 && e._initializeRowElements(), e.refresh(), e._refreshPagesCount();
              }
            }
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var e = this,
          t = function t() {
        return 0 === e.offsetWidth || 0 === e.offsetHeight;
      };

      return t() ? void requestAnimationFrame(function () {
        e.isInitialized || t() || e._render();
      }) : void (e._render(), _get(_getPrototypeOf(_class63.prototype), "render", this).call(this));
    }
  }, {
    key: "_renderColumns",
    value: function _renderColumns(e) {
      var t = this;
      t._initializeColumns(), t._initializeColumnGroupsHierarchy(), t._refreshColumnsResponsiveVisibility(), t._createColumnHeaderCellElements(), t._renderColumnGroupHeaders(), !1 !== e && t._refresh();
    }
  }, {
    key: "_renderRows",
    value: function _renderRows(e) {
      var t = this;
      t._initializeRows(), t._initializeRowElements(), !1 !== e && t._refresh();
    }
  }, {
    key: "_render",
    value: function _render() {
      var e = this;

      if (e.isInitialized || (e.onBeforeInit && e.onBeforeInit(), e.$.fireEvent("beforeInit", {
        grid: e
      })), null === e.dataSource ? e.dataSource = new Smart.DataAdapter() : Array.isArray(e.dataSource) && (e.dataSource = new Smart.DataAdapter({
        dataSource: e.dataSource
      })), e._selection = {
        rows: [],
        columns: [],
        cells: []
      }, e.dataSource && e.dataSource.url && (e.appearance.displayLoadingIndicator = !0, e._setLoadingIndicatorVisibility(), e.dataSource.data = {
        sorting: e.getSortedColumns(),
        filtering: e.getFilteredColumns(),
        grouping: []
      }), e._renderColumns(!1), e._renderRows(!1), e._renderPagers(), e._renderCommandBar(), e.appearance.allowColumnStickyPosition && e._stickHeader(), !e.isInitialized) {
        for (var _t582 = 0; _t582 < e.viewColumns.length; _t582++) {
          var _i600 = e.viewColumns[_t582];
          if (!_i600.allowSort || !_i600.sortOrder) continue;
          var _a374 = e.appearance.allowSortAnimation;
          e.appearance.allowSortAnimation = !1, e.sortBy(_i600.dataField, _i600.sortOrder), e.appearance.allowSortAnimation = _a374;
        }

        if (0 < e.filtering.filter.length) {
          for (var _t583 = 0; _t583 < e.filtering.filter.length; _t583++) {
            var _i601 = e.filtering.filter[_t583];

            if (_i601) {
              var _t584 = _i601[0],
                  _a375 = _i601.splice(1);

              var _n298 = null;
              if (_a375 instanceof Smart.FilterGroup) _n298 = _a375;else {
                var _i602 = e.columnByDataField[_t584];
                _i602 && (_n298 = e.dataSource._createFilter(_i602.dataType, _a375));
              }
              _n298 && e.addFilter(_t584, _n298, !1);
            }
          }

          e.refreshFilters();
        }
      } else e.refreshFilters();

      e.viewColumns.canNotify = !0;
      var t = !e.isInitialized;
      t && (e.onInit && e.onInit(), e.$.fireEvent("init", {
        grid: e
      })), e.isInitialized = !0, "virtual" === e.scrolling || e.paging.enabled && e.dataSource && e.dataSource.virtualDataSource ? e._virtualDataRequest("dataBind") : e.dataSource && e.dataSource.virtualDataSource && e._virtualDataRequest("dataBind"), "" !== e.header.template && e._applyTemplate(e.header.template, e.$.header), "" !== e.footer.template && e._applyTemplate(e.footer.template, e.$.footer), e._createFilterPanels(), e._refresh(), e._applyScrolling(), e.onRender && e.onRender(), e.isRendered = !0, "auto" === e.layout.rowHeight && (e._refreshLayout(), e._recycle()), t && (e.onAfterInit && e.onAfterInit(), e.$.fireEvent("afterInit", {
        grid: e
      }));
    }
  }, {
    key: "_stickHeader",
    value: function _stickHeader() {
      var e = this;
      e._stickyHeaderHandler = function () {
        e._handleStickyHeader();
      }, e.$.columnHeader.style.top = "", e.$.columnHeader.classList.remove("smart-columns-sticky");
      var t = e.parentNode;

      for (e.isInShadowDOM && t === e.getRootNode() && (t = e.getRootNode().host); t !== document && t;) {
        t.addEventListener("scroll", e._stickyHeaderHandler), t = t.parentNode, e.isInShadowDOM && t === e.getRootNode() && (t = e.getRootNode().host);
      }

      try {
        null !== window.top && window.top !== window.self && window.top.document.addEventListener("scroll", e._stickyHeaderHandler);
      } catch (e) {}

      e._handleStickyHeader();
    }
  }, {
    key: "_unstickHeader",
    value: function _unstickHeader() {
      var e = this;
      e.$.columnHeader.style.top = "", e.$.columnHeader.classList.remove("smart-columns-sticky");

      for (var _t585 = e.parentNode; _t585 !== document.body;) {
        _t585.removeEventListener("scroll", e._stickyHeaderHandler), _t585 = _t585.parentNode, e.isInShadowDOM && _t585 === e.getRootNode() && (_t585 = e.getRootNode().host);
      }

      try {
        ("" !== document.referrer || window.frameElement) && null !== window.top && window.top !== window.self && window.top.document.removeEventListener("scroll", e._stickyHeaderHandler);
      } catch (e) {}
    }
  }, {
    key: "_handleStickyHeader",
    value: function _handleStickyHeader() {
      var e = this;
      if (e.appearance.allowColumnStickyPosition) if (e.$.columnHeader.classList.add("smart-columns-sticky"), 0 === document.scrollTop && 0 === e.parentElement.scrollTop) e.$.columnHeader.style.top = "";else {
        var _t586 = e.parentNode,
            _i603 = 0;

        for (; _t586 !== document.body;) {
          _i603 += parseInt(_t586.scrollTop), _t586 = _t586.parentNode, e.isInShadowDOM && _t586 === e.getRootNode() && (_t586 = e.getRootNode().host);
        }

        var _a376 = parseInt(e.clientTop + _i603);

        e.$.columnHeader.style.top = _a376 + "px";
        var _n299 = 0;
        window.top !== window.self && parseInt(window.top.scrollY) > parseInt(e._offsetTop(window.frameElement)) && (_n299 = parseInt(window.top.scrollY) - parseInt(e._offsetTop(window.frameElement))), window.scrollY + _n299 > e.offsetTop && (e.$.columnHeader.style.top = parseInt(window.scrollY) - parseInt(e.offsetTop) + _a376 + _n299 + "px");
      }
    }
  }, {
    key: "_scrollHandler",
    value: function _scrollHandler() {
      var e = this;

      e._handleStickyHeader();
    }
  }, {
    key: "_initializeRowNumberColumn",
    value: function _initializeRowNumberColumn() {
      var e = this;
      if (e._frozenNearColumns && 0 < e._frozenNearColumns.length && e._frozenNearColumns[0].rowHeaderColumn) return void (e._frozenNearColumns[0].visible = e.appearance.showRowHeaderNumber || e.appearance.showRowHeader);
      var t = new Smart.Grid.Column({
        dataField: "_rowHeaderColumn",
        label: "",
        allowSelect: !1,
        freeze: !0,
        visible: !0,
        grid: e,
        autoGenerated: !0,
        rowHeaderColumn: !0,
        cellsAlign: "center"
      }),
          i = e.rows ? e.rows.length : e.dataSource ? e.dataSource.length : 0;
      var a = e.appearance.showRowHeaderNumber ? t._measureSize(i) : 30;
      e.appearance.autoGenerateColumnWidth && (a = e.appearance.autoGenerateColumnWidth), t.width = a, t.createElement();
      var n = new Smart.Observable(t, t.observables);
      e.viewColumns.splice(0, 0, n), e._frozenNearColumns.splice(0, 0, n);
    }
  }, {
    key: "_initializeColumns",
    value: function _initializeColumns() {
      var e = this;

      if ("number" == typeof e.columns) {
        var _t587 = [];
        var _a377 = "",
            _n300 = 0;

        for (var _o208 = 0, _i604; _o208 < e.columns; _o208++) {
          _i604 = _o208 + 1;

          var _r130 = String.fromCharCode(65 + _n300);

          _n300++;

          var _l99 = _a377 + _r130;

          "number" !== e.appearance.autoGenerateColumnLabelMode && (_i604 = _a377 + _r130), _t587.push({
            align: "center",
            label: _i604,
            dataField: _l99,
            width: 100
          }), 26 <= _n300 && (_n300 = 0, _a377 += "A");
        }

        e._boundColumns = _t587;
      } else e._boundColumns = Array.isArray(e.columns) ? e.columns.splice(0) : e.columns.toArray().splice(0);

      e._initColumns = e.columns, e.columnByDataField = [], e.viewColumns = [], e.columns = new Smart.ObservableArray(), e._frozenFarColumns = [], e._frozenNearColumns = [], e._summaryRowCount = 0;
      var t = 0;

      var a = function a(t) {
        if (e.dataSource.dataFields) {
          var _i605 = e.dataSource.dataFields.find(function (e) {
            if (e.name === t.dataField) return e;
          }),
              _a378 = _i605 ? _i605.dataType || "string" : "string";

          t.dataType = _a378;
        }
      };

      if (0 === e._boundColumns.length && e.dataSource && e.dataSource[0]) {
        var _t588 = e.dataSource[0];

        for (var _i606 in _t588) {
          if (_i606.startsWith("_") || "$" == _i606) continue;
          var _t589 = e._boundColumns.length,
              _n301 = {
            index: _t589,
            visibleIndex: _t589,
            label: _i606,
            dataField: _i606
          };
          a(_n301), e._boundColumns.push(_n301);
        }
      }

      var _loop27 = function _loop27(_n302, _i608) {
        if (_i608 = e._boundColumns[_n302], "string" != typeof _i608) a(_i608);else if (e.dataSource.dataFields) {
          var _t591 = e.dataSource.dataFields.find(function (e) {
            if (e.name === _i608) {
              _i607 = _i608;
              return e;
            }
          });

          _i608 = {
            label: _i608,
            dataField: _i608,
            dataType: _t591 ? _t591.dataType || "string" : "string"
          };
        }
        _i608.visibleIndex = _n302, _i608.index = _n302, _i608.grid = e;
        var o = new Smart.Grid.Column(_i608);

        for (var _t592 in e.onColumnInit && e.onColumnInit(_n302, o), o) {
          -1 !== o.properties.indexOf(_t592) || _t592.startsWith("_") || e.error(e.localize("invalidColumnProperty", {
            elementType: "Grid",
            propertyName: _t592,
            type: o.dataField || "Column"
          }));
        }

        o.grid = e, e.columns.push(o);
        var r = e.columns[e.columns.length - 1];
        e._summaryRowCount = Math.max(e._summaryRowCount, o.summary.length), o.freeze ? !0 === o.freeze || "near" === o.freeze ? (e.viewColumns.splice(t++, 0, r), e._frozenNearColumns.push(r)) : "far" === o.freeze && e._frozenFarColumns.push(r) : e.viewColumns.push(r), e.columnByDataField[o.dataField] ? (r.parent = e.columnByDataField[o.dataField], !e.columnByDataField[o.dataField].children && (e.columnByDataField[o.dataField].children = []), e.columnByDataField[o.dataField].children.push(r)) : e.columnByDataField[o.dataField] = r, e.onColumnInserted && e.onColumnInserted(_n302, o);
        _i607 = _i608;
      };

      for (var _n302 = 0, _i607; _n302 < e._boundColumns.length; _n302++) {
        _loop27(_n302, _i607);
      }

      e.viewColumns = e.viewColumns.concat(e._frozenFarColumns);
      var i = 0;

      if ((e.appearance.showRowHeaderNumber || e.appearance.showRowHeader) && (e._initializeRowNumberColumn(), i++), e.rowDetail.enabled) {
        var _t590 = new Smart.Grid.Column({
          dataField: "_rowDetailColumn",
          allowSelect: !1,
          visible: e.rowDetail.visible,
          label: "",
          grid: e,
          freeze: !0,
          rowDetailColumn: !0,
          autoGenerated: !0,
          cellsAlign: "center",
          width: 30
        }),
            _a379 = new Smart.Observable(_t590, _t590.observables);

        "near" === e.rowDetail.position ? (_t590.freeze = "near", _a379.freeze = "near", e.viewColumns.splice(i, 0, _a379), e._frozenNearColumns.splice(i, 0, _a379)) : (e.viewColumns.push(_a379), e._frozenFarColumns.splice(0, 0, _a379)), i++;
      }

      var n = new Smart.Grid.Column({
        dataField: "_adaptiveColumn",
        allowSelect: !1,
        visible: !1,
        label: "",
        grid: e,
        freeze: "far",
        adaptiveColumn: !0,
        autoGenerated: !0,
        cellsAlign: "center",
        width: 30
      }),
          o = new Smart.Observable(n, n.observables);
      o.canNotify = !1, e.viewColumns.push(o), e._frozenFarColumns.splice(0, 0, o);
      var r = new Smart.Grid.Column({
        dataField: "_commandColumn",
        allowSelect: !1,
        visible: e.editing.enabled && e.editing.commandColumn.visible && !e.editing.commandColumn.inline,
        label: "",
        grid: e,
        freeze: "far",
        commandColumn: !0,
        autoGenerated: !0,
        align: "center",
        cellsAlign: "center",
        width: ""
      }),
          l = new Smart.Observable(r, r.observables);
      l.canNotify = !1, "near" === e.editing.commandColumn.position ? (r.freeze = "near", l.freeze = "near", e.viewColumns.splice(i, 0, l), e._frozenNearColumns.splice(i, 0, l)) : (e.viewColumns.push(l), e._frozenFarColumns.splice(0, 0, l)), e._commandColumn = l;
      var s = new Smart.Grid.Column({
        allowSelect: !1,
        visible: e.selection.enabled && e.selection.checkBoxes.enabled,
        dataField: "_checkBoxColumn",
        label: "",
        freeze: e.selection.checkBoxes.position,
        grid: e,
        selectionColumn: !0,
        autoGenerated: !0,
        cellsAlign: "center",
        width: 32
      }),
          d = new Smart.Observable(s, s.observables);
      "near" === s.freeze ? (e.viewColumns.splice(i, 0, d), e._frozenNearColumns.splice(i, 0, d)) : (e.viewColumns.push(d), e._frozenFarColumns.splice(0, 0, d)), e._selectionColumn = d, e._selectionColumn.canNotify = !1, e._observeColumns(), e._templateColumns();
    }
  }, {
    key: "_templateColumns",
    value: function _templateColumns() {
      var e = this,
          t = getComputedStyle(e),
          i = t.getPropertyValue("--smart-grid-template-columns").trim(),
          a = t.getPropertyValue("--smart-grid-column-gap").trim(),
          n = t.getPropertyValue("--smart-grid-row-gap").trim();

      if (e._rowGap = parseInt(n), e._columnGap = parseInt(a), e._maxHeight = parseInt(t.maxHeight), e._minHeight = parseInt(t.minHeight), "none" !== i) {
        var _t593 = 0;

        for (var _a381 = 0; _a381 < e.viewColumns.length; _a381++) {
          e.viewColumns[_a381].autoGenerated && (_t593 += e.viewColumns[_a381].visible ? e.viewColumns[_a381].width : 0);
        }

        var _a380 = [];

        var _n303 = document.createElement("div");

        _n303.style.display = "grid", _n303.style.gridTemplateColumns = i;

        for (var _t594 = 0; _t594 < e.columns.length; _t594++) {
          _n303.innerHTML += "<div></div>";
        }

        _n303.style.width = e.clientWidth - _t593 + "px", e.$.root.appendChild(_n303);

        var _o209 = i.split(" ");

        for (var _t595 = 0; _t595 < e.columns.length; _t595++) {
          _a380[_t595] = _n303.children[_t595].offsetWidth, "auto" === _o209[_t595] && (_a380[_t595] = null);
        }

        _n303.parentNode.removeChild(_n303);

        var _r131 = 0;

        for (var _t596 = 0; _t596 < e.viewColumns.length; _t596++) {
          var _i609 = e.viewColumns[_t596];
          _i609.autoGenerated || _a380[_r131] && (_i609.width = _i609.templateWidth = _a380[_r131++]);
        }
      } else for (var _t597 = 0; _t597 < e.viewColumns.length; _t597++) {
        var _i610 = e.viewColumns[_t597];
        _i610.autoGenerated || _i610.templateWidth && (_i610.width = _i610.templateWidth = null);
      }
    }
  }, {
    key: "onDetached",
    value: function onDetached() {
      var e = this;
      e._dialogRowDetail && (e._dialogRowDetail.close(), e._dialogRowDetail = null);
    }
  }, {
    key: "_observeColumns",
    value: function _observeColumns() {
      var e = this,
          t = function (_t598) {
        function t(_x10, _x11, _x12, _x13) {
          return _t598.apply(this, arguments);
        }

        t.toString = function () {
          return _t598.toString();
        };

        return t;
      }(function (e, t, i, a) {
        e.propertyChanged(t, i, a);
      });

      var _loop28 = function _loop28(_a382) {
        var i = e.viewColumns[_a382];
        i.onAction = function () {
          e._openMenu(this);
        }, i.autoGenerated && i.notify(function (e) {
          i.canNotify = !1, t(i, e.propertyName, e.oldValue, e.newValue), i.canNotify = !0;
        });
      };

      for (var _a382 = 0; _a382 < e.viewColumns.length; _a382++) {
        _loop28(_a382);
      }

      e.columns.notify(function (a) {
        var i = null;
        if (a.path) return e.columns.canNotify = !1, t(a.target, a.propertyName, a.oldValue, a.newValue), void (e.columns.canNotify = !0);
        e.columns.canNotify = !1;
        var n = a.action;
        var o = 0;

        switch (n) {
          case "length":
            return void (e.columns.canNotify = !0);

          case "add":
            {
              var _t599 = function _t599(t) {
                if (i = a.object[t], !1 == i instanceof Smart.Grid.Column) {
                  i = new Smart.Grid.Column(i);
                  var _n304 = e.columns.canNotify;
                  e.columns.canNotify = !1, a.object[t] = i, i = a.object[t], e.columns.canNotify = _n304;
                }

                i.grid = e, i.freeze ? e._frozenNearColumns.push(i) : "far" === i.freeze && e._frozenFarColumns.push(i);
                var n = e.viewColumns.length - e._frozenFarColumns.length;
                if (t < e.columns.length ? e.viewColumns.splice(t + e._frozenNearColumns.length, 0, i) : e.viewColumns.splice(n, 0, i), !e.columnByDataField[i.dataField]) e.columnByDataField[i.dataField] = i;else {
                  e.columnByDataField[i.dataField].children.push(i), i.parent = e.columnByDataField[i.dataField], i.valueField = i.dataField;

                  var _t600 = i.dataField + "_" + i.parent.children.length;

                  e.columnByDataField[_t600] = i, i.dataField = _t600;
                }
                e.onColumnInserted && e.onColumnInserted(t, i);
              };

              for (var _e687 = 0; _e687 < a.addedCount; _e687++) {
                _t599(a.index + _e687);
              }

              break;
            }

          case "update":
            {
              i = a.object[a.index], !1 == i instanceof Smart.Grid.Column && (i = new Smart.Grid.Column(i)), i.grid = e;

              for (var _t601 = 0; _t601 < a.index; _t601++) {
                e.viewColumns[_t601].autoGenerated && o++;
              }

              e.viewColumns[o + a.index] = i, e.columnByDataField[i.dataField] = i, e.onColumnUpdated && e.onColumnUpdated(a.index, i);
              break;
            }

          case "remove":
            {
              i = a.removed[0];
              var _t602 = a.index;

              for (var _a383 = 0; _a383 <= _t602; _a383++) {
                e.viewColumns[_a383].autoGenerated && o++;
              }

              e.viewColumns.splice(o + _t602, 1), delete e.columnByDataField[i.dataField], e.onColumnRemoved && e.onColumnRemoved(a.index, i);
              break;
            }
        }

        e._initializeColumnGroupsHierarchy(), e._refreshColumnsResponsiveVisibility(), e._createColumnHeaderCellElements(), e._templateColumns(), e.refresh(), e.columns.canNotify = !0;
      });
    }
  }, {
    key: "_horizontalScrollbarHandler",
    value: function _horizontalScrollbarHandler() {
      var e = this;
      e.closeMenu(), e.isScrolling = !0, requestAnimationFrame(function () {
        e._recycle(), e.isScrolling = !1;
      });
    }
  }, {
    key: "_mouseWheelHandler",
    value: function _mouseWheelHandler(e) {
      var t = this;
      t._scrollView.hScrollBar.$.hasClass("smart-hidden") && t._scrollView.vScrollBar.$.hasClass("smart-hidden") || !t.disabled && !t._scrollView.vScrollBar.$.hasClass("smart-hidden") && (e.stopPropagation(), e.preventDefault(), t._scrollView.scrollTo(t._scrollView.scrollTop + t._getScrollCoefficient(e, t._clientSize.height)));
    }
  }, {
    key: "_refresh",
    value: function _refresh() {
      var e = this;
      if (e._isUpdating) return;
      var t = e.$.verticalScrollBar.offsetWidth;
      e.removeAttribute("grouped"), e.removeAttribute("tree");
      var i = !0;
      e.__autoHeightRows && (e.__autoHeightRows = null, e._refreshColumnsResponsiveVisibility(), e._recycle(), i = !1), e.grouping.enabled && e.dataSource.groupBy && 0 < e.dataSource.groupBy.length ? e.setAttribute("grouped", "") : e.dataSource.boundHierarchy && e.setAttribute("tree", ""), (e.isInitialized || i) && e._refreshColumnsResponsiveVisibility(), e._refreshLayout(), t !== e.$.verticalScrollBar.offsetWidth && (e.__scrollWidth = null, e._refreshColumnsResponsiveVisibility(), e._refreshScrollBars()), e._refreshSelection(), e._recycle(), requestAnimationFrame(function () {
        e._width = e.offsetWidth, e._height = e.offsetHeight;
      });
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.composedPath()[0] : e.target;

      if (i === t && !t._isUpdatingScrollBars) {
        if (!t.isInitialized) return void t._render();
        t._isUpdatingScrollBars = !0, t._autoHeight = !1, t.$.content && t.$.content.classList.remove("auto-height"), t.refresh(), t._isUpdatingScrollBars = !1;
      }
    }
  }, {
    key: "_refreshColumnsResponsiveVisibility",
    value: function _refreshColumnsResponsiveVisibility() {
      var e = this,
          t = e.$.columnContainer,
          i = e.$.columnNearContainer,
          a = e.$.columnFarContainer;
      var n = 0,
          o = 0,
          r = 0,
          l = !1;

      for (var _t603 = 0; _t603 < e.viewColumns.length; _t603++) {
        var _i611 = e.viewColumns[_t603];
        _i611._treeColumn = !1, !_i611.visible || _i611.autoGenerated || l || (_i611._treeColumn = !0, l = !0);
      }

      e._refreshColumnWidths();

      var s = 0,
          d = 0;

      for (var _t604 = 0; _t604 < e.viewColumns.length; _t604++) {
        var _i612 = e.viewColumns[_t604];
        _i612.visible && (_i612.freeze && (!0 === _i612.freeze || "near" === _i612.freeze ? (n += _i612.computedWidth, _i612.autoGenerated && (s += _i612.computedWidth)) : "far" === _i612.freeze && (o += _i612.computedWidth, _i612.autoGenerated && (d += _i612.computedWidth))), r += _i612.computedWidth);
      }

      t.style.width = r + "px", i.style.width = n + "px", a.style.width = o + "px", a.classList.remove("smart-hidden"), i.classList.remove("smart-hidden"), 0 === o && a.classList.add("smart-hidden"), 0 === n && i.classList.add("smart-hidden"), a.classList.remove("border-collapse"), o === d && a.classList.add("border-collapse"), e._autoGeneratedColumnsNearWidth = s, e._autoGeneratedColumnsFarWidth = d, e._computedColumnsWidth = r, e._frozenColumnsNearWidth = n, e._frozenColumnsFarWidth = o;
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      var t = this;
      t.isScrolling || t.editing.isEditing || e.preventDefault();
    }
  }, {
    key: "setFocusable",
    value: function setFocusable(e) {
      var t = this;
      return t.disabled || !e ? void t.removeAttribute("tabindex") : void (t.tabIndex = 0);
    }
  }, {
    key: "_setLoadingIndicatorVisibility",
    value: function _setLoadingIndicatorVisibility() {
      var e = this;
      return e.appearance.displayLoadingIndicator ? void e.$.loadingIndicatorContainer.classList.remove("smart-visibility-hidden") : void e.$.loadingIndicatorContainer.classList.add("smart-visibility-hidden");
    }
  }, {
    key: "_refreshElementsVisibility",
    value: function _refreshElementsVisibility() {
      var e = this,
          t = function (_t605) {
        function t(_x14, _x15) {
          return _t605.apply(this, arguments);
        }

        t.toString = function () {
          return _t605.toString();
        };

        return t;
      }(function (e, t) {
        t ? e.classList.remove("smart-hidden") : e.classList.add("smart-hidden");
      });

      if (t(e.$.placeholder, !e.rows || e.rows && 0 === e.rows.length || 0 === e.columns.length), t(e.$.footer, e.footer.visible), t(e.$.header, e.header.visible), t(e.$.groupHeader, e.groupHeader.visible), t(e.$.columnHeader, e.columnHeader.visible && 0 < e.columns.length), t(e.$.headerCommandBar, e.editing.commandBar.visible && e.editing.enabled && "far" !== e.editing.commandBar.position), t(e.$.footerCommandBar, e.editing.commandBar.visible && e.editing.enabled && "near" !== e.editing.commandBar.position), e.htmlColumnLastChild.classList.add("smart-visibility-hidden"), e.pager && e.pager.visible && e.paging.enabled) switch (e.pager.position) {
        case "near":
          t(e.$.headerPager, !0), t(e.$.footerPager, !1);
          break;

        case "far":
          t(e.$.headerPager, !1), t(e.$.footerPager, !0);
          break;

        case "both":
          t(e.$.headerPager, !0), t(e.$.footerPager, !0);
      } else t(e.$.footerPager, !1), t(e.$.headerPager, !1);

      e._refreshRowHierarchy();
    }
  }, {
    key: "_refreshRowHierarchy",
    value: function _refreshRowHierarchy() {
      var e = this;

      if ((e.rowHierarchy = null, !(!e.grouping.enabled && e.dataSource.groupBy && 0 < e.dataSource.groupBy.length)) && e.dataSource.boundHierarchy) {
        var _t606 = e.dataSource.reservedNames,
            _a384 = function _a384(t) {
          var i = new Smart.Grid.Row({
            data: t,
            index: e.rows.length
          });
          return e.rowById[i.id] = i, i;
        },
            _i613 = function _i613(n, o) {
          for (var _r132 = 0; _r132 < n.length; _r132++) {
            var _l100 = n[_r132];
            var _s71 = e.rowById[_l100.$.id];
            _s71 || (_s71 = _a384(_l100)), _s71.data = _l100, _s71.leaf = _l100[_t606.leaf] || !1, _s71.level = _l100[_t606.level], _s71.groupDataField = _l100.groupDataField, _s71.label = _l100.label, _s71.children = [], _s71.data && (_s71.filtered = void 0 === _s71.data.$.filtered || _s71.data.$.filtered), _l100.summaryRow && (_s71.summaryRow = !0), (null === e._toggledRow || e._toggledRow && e._toggledRow.id !== _s71.id) && (_s71.expandHeight = 0), _l100.parent ? (_s71.parent = e.rowById[_l100.parent.$.id], _s71.parentId = _l100.parent.$.id) : (_s71.parent = null, _s71.parentId = null);
            var d = _s71.expanded;
            if (!0 === _s71.visible && !1 !== _s71.filtered) if (d || _l100[_t606.leaf]) {
              if (o.push(_s71), _l100.children && 0 < _l100.children.length) {
                var _e688 = _i613(_l100.children, []);

                0 === _e688.length && (_s71.leaf = !0);

                for (var _i614 = 0; _i614 < _e688.length; _i614++) {
                  o.push(_e688[_i614]);
                }

                _s71.children = _e688;
              }
            } else if (o.push(_s71), _l100.children && 0 < _l100.children.length) {
              var _e689 = _i613(_l100.children, []);

              0 === _e689.length && (_s71.leaf = !0), _s71.children = _e689;
            }
          }

          return o;
        };

        var _n305 = e.dataSource.boundHierarchy;

        if (e.paging.enabled && (_n305 = _n305.slice(e.paging.pageIndex * e.paging.pageSize, (e.paging.pageIndex + 1) * e.paging.pageSize)), e.rowHierarchy = _i613(_n305, []), e._rowElements.length < e.rowHierarchy.length && !e._toggledRow && e._initializeRowElements(), e.grouping.summaryRow.visible && !e.grouping.summaryRow.inline) {
          var _t607 = function _t607(e, a, i, n) {
            if (0 !== e && 0 < a.length && a[a.length - 1] && !a[a.length - 1].summaryRow) {
              var _t608 = {
                label: " ",
                boundSource: [],
                groupDataField: i.data.groupDataField,
                $: {},
                summaryRow: !0,
                leaf: !0,
                level: e,
                expandHeight: 0,
                siblings: a
              };
              _t608.$.id = "SubRow" + n + "_" + i.data.$.id, i && (_t608.parent = i.data, _t608.parentId = i.data.$.id), _t608.data = Object.assign(_t608), a.push(_t608);
            }

            for (var _o210 = 0; _o210 < a.length; _o210++) {
              a[_o210] && a[_o210].data && a[_o210].data.children && _t607(e + 1, a[_o210].data.children, a[_o210], _o210);
            }
          };

          _t607(0, e.rowHierarchy, null, 0);
        }
      }
    }
  }, {
    key: "applyContent",
    value: function applyContent() {}
  }, {
    key: "_refreshContentHeight",
    value: function _refreshContentHeight() {
      var e = this;
      var t = e._clientSize.height;
      var i = window.scrollY,
          a = e.offsetHeight;
      e.$.container.classList.add("smart-hidden");
      var n = e.offsetHeight;
      return e.$.container.classList.remove("smart-hidden"), window.scrollY !== i && window.scrollTo(window.scrollX, i), "hidden" === e.verticalScrollBarVisibility || a !== n || e._minHeight && e._minHeight === a ? (t = e._scrollHeight + e.$.columnHeader.offsetHeight + e.$.filterFooter.offsetHeight, e.$.content.style.height = t + "px", e._contentHeight = t, void (e._maxHeight < t ? (e._autoHeight = !1, e.$.content.classList.remove("auto-height"), e.$.content.style.height = e._maxHeight + "px", e._contentHeight = e._maxHeight) : (e._autoHeight = !0, e.$.content.classList.add("auto-height")))) : void (e.header.visible && (t -= e.$.header.offsetHeight), e.groupHeader.visible && (t -= e.$.groupHeader.offsetHeight), e.footer.visible && (t -= e.$.footer.offsetHeight), e.pager.visible && (t -= e.$.headerPager.offsetHeight, t -= e.$.footerPager.offsetHeight), e.editing.enabled && e.editing.commandBar.visible && (t -= e.$.headerCommandBar.offsetHeight, t -= e.$.footerCommandBar.offsetHeight), e.$.content.style.height = t + "px", e._contentHeight = t);
    }
  }, {
    key: "appendChild",
    value: function appendChild() {
      var e = Array.prototype.slice.call(arguments, 2);
      return HTMLElement.prototype.appendChild.apply(this, e.concat(Array.prototype.slice.call(arguments)));
    }
  }, {
    key: "removeChild",
    value: function removeChild() {
      var e = Array.prototype.slice.call(arguments, 2);
      return HTMLElement.prototype.removeChild.apply(this, e.concat(Array.prototype.slice.call(arguments)));
    }
  }, {
    key: "_refreshLayout",
    value: function _refreshLayout() {
      var e = this,
          t = e.rows;

      if (!e._layoutSuspended) {
        if (e._visibleRows = null, e.__viewRows = null, e.__clientSize = null, e.__scrollHeight = null, e.__scrollWidth = null, e.__parentCells = null, e.$.columnFarContainer.classList.remove("vscroll"), e.$.scrollView.classList.remove("hscroll"), e.$.scrollView.classList.remove("vscroll"), e._refreshElementsVisibility(), e._refreshColumnHeights(), e._refreshContentHeight(), !(t && t.url) && (!t || null === t || 0 === t.length || 0 === e.columns.length)) return e.$.placeholder.classList.remove("smart-hidden"), e.scrollWidth = 0, void (e.scrollHeight = 0);
        e.__columnHeaderHeight || (e.__columnHeaderHeight = e.$.columnHeader.offsetHeight), e.__filterFooterOffsetHeight || (e.__filterFooterOffsetHeight = e.$.filterFooter.classList.contains("smart-hidden") ? 0 : e.$.filterFooter.offsetHeight);

        var _i615 = e._contentHeight - e.__filterFooterOffsetHeight - e.__columnHeaderHeight;

        if (e.$.scrollView.style.height = _i615 + "px", e.htmlColumnLastChild.style.height = e.__columnHeaderHeight + "px", e.paging.spinner.enabled && e.paging.enabled) {
          if (!e.pageScroll) {
            var _t609 = document.createElement("smart-scroll-bar");

            _t609.orientation = "vertical", _t609.style.height = "100%", _t609.style.width = "100%", _t609.max = Math.ceil(e.dataSource.length / e.paging.pageSize), _t609.step = e.paging.spinner.step, _t609.largeStep = e.paging.spinner.step, _t609.setAttribute("spinner", ""), _t609.setAttribute("smart-id", "spinner"), _t609.ownerElement = e, e.addPropertyBinding("[[paging_spinner_step]]", "step", _t609, e.$.columnHeader), _t609.addEventListener("change", function (t) {
              e.paging.pageIndex = t.detail.value;
            }), e.pageScroll = _t609;
          }

          e.htmlColumnLastChild.appendChild(e.pageScroll);
        } else e.htmlColumnLastChild.innerHTML = "";

        e._refreshScrollBars();
      }
    }
  }, {
    key: "_refreshScrollBars",
    value: function _refreshScrollBars() {
      var e = this,
          t = e._scrollView.vScrollBar,
          i = e._scrollView.hScrollBar,
          a = e._contentHeight - e.__filterFooterOffsetHeight - e.__columnHeaderHeight,
          n = e.$.scrollView.offsetWidth,
          o = e._scrollWidth - n - e._contentBorder.left,
          r = e._scrollHeight - a - e._contentBorder.top,
          l = e._columnNearContainerComputedStyle ? e._columnNearContainerComputedStyle : getComputedStyle(e.$.columnNearContainer),
          s = e._columnFarContainerComputedStyle ? e._columnFarContainerComputedStyle : getComputedStyle(e.$.columnFarContainer),
          d = parseInt(e.$.columnNearContainer.style.width) + parseInt(l.borderRightWidth),
          c = parseInt(e.$.columnFarContainer.style.width) + parseInt(s.borderLeftWidth);

      if (e.__frozenNearWidth = d, e.__frozenFarWidth = c, e._columnNearContainerComputedStyle = l, e._columnFarContainerComputedStyle = s, e._refreshHorizontalScrollBarVisibility(o), e._refreshVerticalScrollBarVisibility(r), t.style.height = a + "px", e.computedVerticalScrollBarVisibility && (!e.__scrollBarSize && (e.__scrollBarSize = t.offsetWidth), e.__scrollWidth += e.__scrollBarSize, e._refreshHorizontalScrollBarVisibility(e._scrollWidth - n - 1), e.$.columnFarContainer.classList.add("vscroll"), e.htmlColumnLastChild.classList.remove("smart-visibility-hidden")), i.style.width = n + "px", i.style.left = "0px", e.computedVerticalScrollBarVisibility && e.computedHorizontalScrollBarVisibility && (i.style.width = n - t.offsetWidth + "px", t.style.height = a - i.offsetHeight + "px"), e.computedHorizontalScrollBarVisibility ? (e.$.scrollView.classList.add("hscroll"), e._autoHeight ? (e.$.content.style.height = "auto", e.$.scrollView.style.height = "auto", e.$.scrollView.style.paddingBottom = i.offsetHeight + "px") : e.$.scrollView.style.paddingBottom = "") : e.$.scrollView.classList.remove("hscroll"), (0 < e.__frozenNearHeight || e._frozenNearRows && 0 < e._frozenNearRows.length) && !e.appearance.showVerticalScrollBarOnFixedColumns) {
        var _i616 = getComputedStyle(e.$.rowNearContainer),
            _a385 = e.__frozenNearHeight + parseInt(_i616.borderBottomWidth);

        t.style.height = parseInt(t.style.height) - _a385 + "px", t.style.top = _a385 + "px", t.style.setProperty("--smart-scroll-bar-near-size", _a385 + "px");
      } else e.appearance.showVerticalScrollBarOnFixedColumns && (t.style.top = "0px");

      if ((0 < e.__frozenFarHeight || e._frozenFarRows && 0 < e._frozenFarRows.length) && !e.appearance.showVerticalScrollBarOnFixedColumns) {
        var _i617 = getComputedStyle(e.$.rowFarContainer),
            _a386 = -2 + e.__frozenFarHeight + parseInt(_i617.borderTopWidth);

        t.style.height = parseInt(t.style.height) - _a386 + "px", t.style.setProperty("--smart-scroll-bar-far-size", _a386 + "px"), 0 === e.__frozenNearHeight && (t.style.top = "0px");
      }

      (0 < d || 0 < c) && !e.appearance.showHorizontalScrollBarOnFixedColumns && (i.style.width = parseInt(i.style.width) - d - c + "px", i.style.left = d + "px", i.style.setProperty("--smart-scroll-bar-near-size", d + parseInt(l.borderRightWidth) + "px"), i.style.setProperty("--smart-scroll-bar-far-size", c + parseInt(l.borderLeftWidth) + "px"), e.computedVerticalScrollBarVisibility && (!e.__scrollBarSize && (e.__scrollBarSize = t.offsetWidth), i.style.setProperty("--smart-scroll-bar-far-size", c + e.__scrollBarSize + "px"))), t.refresh(), i.refresh();
    }
  }, {
    key: "_refreshHorizontalScrollBarVisibility",
    value: function _refreshHorizontalScrollBarVisibility(e) {
      var t = this;
      t.scrollWidth = e, t.computedHorizontalScrollBarVisibility || (t.scrollLeft = 0);
    }
  }, {
    key: "_refreshVerticalScrollBarVisibility",
    value: function _refreshVerticalScrollBarVisibility(e) {
      var t = this;
      return t._autoHeight ? (t.scrollTop = 0, void (t.scrollHeight = 0)) : void (t.computedHorizontalScrollBarVisibility && (e += t.$.horizontalScrollBar.offsetHeight), t.scrollHeight = e, t.paging.enabled && t.paging.spinner.visible && t.$.verticalScrollBarVisibility.classList.remove("smart-hidden"), !t.computedVerticalScrollBarVisibility && (t.scrollTop = 0));
    }
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler(e) {
      var t = this;
      return e.detail.styleProperties.overflow || t.classList.contains("smart-grid-resize-mode") ? void 0 : e.detail.styleProperties["grid-template-columns"] ? (t._templateColumns(), void t.refresh()) : void (t.offsetWidth && 0 < t.offsetHeight && (t._resetCachedLayout(), t._refreshLayout(), t._recycle()));
    }
  }, {
    key: "_resetCachedLayout",
    value: function _resetCachedLayout() {
      var e = this;
      e.__cellsCommandTemplate = null, e.__autoRowHeight = null, e.__autoHeightRows = null, e.__measuredColumnHeight = null, e.__columnHeaderHeight = null, e.__filterFooterOffsetHeight = null;
    }
  }, {
    key: "_swipeLeftHandler",
    value: function _swipeLeftHandler() {}
  }, {
    key: "_swipeRightHandler",
    value: function _swipeRightHandler() {}
  }, {
    key: "_getRowIndexByPosition",
    value: function _getRowIndexByPosition(e) {
      var t = this,
          i = function (i) {
        var a = 0,
            n = i.length - 1;
        if (0 >= e) return 0;
        var o = i[i.length - 1];
        if (-1 !== o.top && o.top <= e) return i.length - 1;

        for (; !0;) {
          var _o211 = Math.floor((a + n) / 2),
              _r133 = i[_o211];

          if (t._isRowInPosition(_r133, e)) return _o211;
          _r133.top < e ? a = _o211 + 1 : _r133.top > e ? n = _o211 - 1 : a = _o211 + 1;
        }
      }(t._recyclingRows);

      return i;
    }
  }, {
    key: "getViewRows",
    value: function getViewRows() {
      var e = this;
      if (e.rowHierarchy) return e.rowHierarchy;
      var t = e.getVisibleRows();
      return t;
    }
  }, {
    key: "_isRowInPosition",
    value: function _isRowInPosition(e, t) {
      var i = e.top,
          a = e.top + e.height;
      return 0 !== e.height && i <= t && a > t;
    }
  }, {
    key: "_renderColumnGroupHeaders",
    value: function _renderColumnGroupHeaders() {
      var e = this;

      for (var _t610 = 0; _t610 < e.columnGroups.length; _t610++) {
        var _i618 = e.columnGroups[_t610];

        _i618.column.render();
      }
    }
  }, {
    key: "_isLastVisibleColumn",
    value: function _isLastVisibleColumn(e) {
      var t = this;

      for (var _a387 = t.viewColumns.length - 1; 0 <= _a387; _a387--) {
        var _i619 = t.viewColumns[_a387];
        if (_i619.visible) return _i619 === e;
      }

      return !1;
    }
  }, {
    key: "_recycle",
    value: function _recycle(e, t) {
      var a = Math.max;
      var n = this;
      if (n._layoutSuspended) return;
      if (n._isUpdating) return;
      if (n.editing.isEditing && (n.endEdit(), n._isUpdating)) return;
      n._inputOverlay && (n._inputOverlay.parentNode && n._inputOverlay.parentNode.removeChild(n._inputOverlay), n._inputOverlay = null), n._selection.selectionRect && n._refreshCellSelectionRect();
      var o = n._scrollView.scrollTop;

      var r = n._getRowIndexByPosition(o),
          l = n._recyclingRows,
          s = l[r],
          d = s ? s.top : 0,
          c = 0,
          m = 0,
          u = 0,
          p = 0,
          i;

      for (var _m16 = 0; _m16 < n._cellsMerge.length; _m16++) {
        var _e690 = n._cellsMerge[_m16],
            _t611 = l.indexOf(_e690.row);

        if (r > _t611 && r <= _t611 + _e690.rowSpan && (r = _t611, s = _e690.row, u = a(u, d - s.top), d = s.top, n.$.rowContainer.style.top = n.__frozenNearHeight - o + d + "px"), 1 < _e690.colSpan) for (var _t612 = 0; _t612 < n.viewColumns.length; _t612++) {
          var _i620 = n.viewColumns[_t612];

          var _o212 = _i620.autoGenerated ? _i620 : n.columnByDataField[_i620.dataField];

          if (_o212.visible && _o212.left + _o212.computedWidth - n._scrollView.scrollLeft >= c && _o212.left - _o212.computedWidth - n._scrollView.scrollLeft < n._clientSize.width) {
            var _t613 = n.columnByDataField[_e690.column.dataField];
            p = a(p, _o212.left - _t613.left + _o212.computedWidth);
            break;
          }
        }
      }

      if (!1 !== e || 0 < n._cellsMerge.length) {
        for (var _e691 = 0; _e691 < n._columnElements.length; _e691++) {
          var _t614 = n._columnElements[_e691];
          if (!_t614.parentNode) break;
          _t614.set("column", null, !1), _t614.classList.add("smart-visibility-hidden");
        }

        for (var _e692 = 0; _e692 < n.columnGroups.length; _e692++) {
          var _t615 = n.columnGroups[_e692],
              _i621 = _t615.element;
          _i621.style.left = _t615.left + "px", _i621.style.width = _t615.computedWidth + "px";
        }

        n._firstVisibleColumn = null, n._lastVisibleColumn = null;

        for (var _e693 = 0; _e693 < n.viewColumns.length; _e693++) {
          var _t616 = n.viewColumns[_e693];
          var _a388 = _t616;

          if (_a388.visible && (!n._firstVisibleColumn && (n._firstVisibleColumn = _a388), n._lastVisibleColumn = _a388), _a388.element && (_a388 === n._firstVisibleColumn ? _a388.element.classList.add("smart-grid-column-border-collapse") : _a388.element.classList.remove("smart-grid-column-border-collapse")), _a388.freeze) {
            (!0 === _a388.freeze || "near" === _a388.freeze) && _a388.visible && (c += _a388.computedWidth), _a388.visible ? (_a388.element.classList.remove("smart-visibility-hidden"), _a388.render()) : _a388.element.classList.add("smart-visibility-hidden");
            continue;
          }

          if (_a388.visible && _a388.left + _a388.computedWidth - n._scrollView.scrollLeft >= c - p && _a388.left - _a388.computedWidth - n._scrollView.scrollLeft < n._clientSize.width) {
            var _e694 = n._columnElements[m++];
            _e694.set("column", _a388, !1), _e694.parentNode || n.$.columnContainer.appendChild(_e694), _a388.element = _e694, _a388.render(), void 0 === i && (i = _a388.left);
          }
        }
      }

      if ((void 0 === i && (i = 0), n.$.columnContainer.style.left = -n._scrollView.scrollLeft + "px", n.$.rowContainer.style.top = n.__frozenNearHeight - o + d + "px", !1 !== t) && n._rowElements) {
        if (0 <= r) {
          m = 0;

          var _e695 = a(n._clientSize.height, n._overflowOffset);

          for (var _t617 = r; _t617 < l.length; _t617++) {
            var _i622 = l[_t617];
            if (0 === _i622.height || !_i622.visible || !1 === _i622.filtered || _i622.freeze) continue;
            var _a389 = _i622.height;

            if (_i622.expandHeight && (_e695 += n.offsetHeight + _i622.expandHeight), d + _a389 >= o - u && d <= o + _e695 || n._autoHeight) {
              var _e696 = n._rowElements[m++];
              if (!_e696) break;
              _i622.element = _e696, _i622.grid = n, _i622.render();
            } else break;

            d += _a389;
          }
        }

        if (n._renderFrozenRows(), m < n._rowElements.length) for (var _e697 = m; _e697 < n._rowElements.length; _e697++) {
          var _e698 = n._rowElements[m++];

          _e698.classList.add("smart-hidden");
        }
      }
    }
  }, {
    key: "_renderFrozenRows",
    value: function _renderFrozenRows() {
      var e = this;
      var t = !1,
          a = !1;
      0 === e._frozenNearRows.length ? e.$.rowNearContainer.classList.add("smart-hidden") : e.$.rowNearContainer.classList.remove("smart-hidden");

      for (var _a390 = 0; _a390 < e._frozenNearRows.length; _a390++) {
        var _i623 = e._frozenNearRows[_a390];
        _i623.visible && _i623.filtered && (t = !0, _i623.element = e.$.rowNearContainer.children[_a390], !_i623.element && (_i623.element = _i623.createElement(), e.$.rowNearContainer.appendChild(_i623.element)), _i623.render());
      }

      t || e.$.rowNearContainer.classList.add("smart-hidden"), 0 === e._frozenFarRows.length ? e.$.rowFarContainer.classList.add("smart-hidden") : e.$.rowFarContainer.classList.remove("smart-hidden");

      for (var _t618 = 0; _t618 < e._frozenFarRows.length; _t618++) {
        var _i624 = e._frozenFarRows[_t618];
        _i624.visible && (a = !0), _i624.element = e.$.rowFarContainer.children[_t618], _i624.element || (_i624.element = _i624.createElement(), e.$.rowFarContainer.appendChild(_i624.element)), _i624.render();
      }

      a || e.$.rowFarContainer.classList.add("smart-hidden");
    }
  }, {
    key: "_recycleRotate",
    value: function _recycleRotate(e, t, i, a, n) {
      var o = t.getBoundingClientRect(),
          r = e.getBoundingClientRect(),
          l = 4;
      var s = 0,
          d = 0;
      return 0 === r.width ? (e.innerHTML = n, !1) : (o.left > r.left && (s = r.left - o.left), o.top < r.top && (d = r.top - o.top), ("left" === i || "" === i) && (s = l), "center" === i && (s += r.width / 2 - o.width / 2), "right" === i && (s += r.width - o.width - l), ("top" === a || "" === a) && (d = l), ("center" === a || "middle" === a) && (d += r.height / 2 - o.height / 2), "bottom" === a && (d += r.height - o.height - l), t.style.left = s + "px", t.style.top = d + "px", !0);
    }
  }, {
    key: "_virtualDataRequest",
    value: function _virtualDataRequest(e) {
      var t = Math.ceil;
      var a = this;
      var n = -1,
          o = -1;
      if (!a._rowElements && "infinite" !== a.scrolling) return;
      if ("virtual" === a.scrolling) for (var _e699 = 0; _e699 < a._rowElements.length; _e699++) {
        var _t619 = a._rowElements[_e699],
            _i625 = _t619.row,
            _r134 = 0 == _e699 ? _i625.visibleIndex : n + _e699;

        _t619.classList.contains("smart-hidden") || (-1 === n && (n = _r134), -1 !== _r134) && (o = 1 + _r134);
      } else "infinite" === a.scrolling ? (n = 1 / 0, o = 1 / 0) : (n = 0, o = a.dataSource.length);
      a.paging.enabled && (n = a.paging.pageIndex * a.paging.pageSize, o = n + a.paging.pageSize), o !== 1 / 0 && (o = Math.min(o, a.dataSource.length)), a.appearance.displayLoadingIndicator = !0, a._setLoadingIndicatorVisibility();
      var i = {
        first: n,
        last: o,
        sorting: a.getSortedColumns(),
        filtering: a.getFilteredColumns(),
        grouping: [],
        row: a._toggledRow ? a._toggledRow.data : null,
        action: e
      },
          r = a.dataSource.length;
      a.dataSource.onVirtualDataSourceRequested(function () {
        a.appearance.displayLoadingIndicator = !1, a._setLoadingIndicatorVisibility(), a._toggledRow = null, a.dataSource.length === r ? a.dataSource.virtualDataSourceOnExpand && a.refresh() : (a.paging.enabled && (a.$.headerPager.querySelector("smart-pager").pagesCount = t(a.dataSource.length / a.paging.pageSize), a.$.footerPager.querySelector("smart-pager").pagesCount = t(a.dataSource.length / a.paging.pageSize)), a._initializeRows(), a._initializeRowElements(), a.refresh(), a._refreshPagesCount()), a._recycle();
      }, i);
    }
  }, {
    key: "_verticalScrollbarHandler",
    value: function _verticalScrollbarHandler(e) {
      var t = this;
      t.menu && t.menu.column && t.closeMenu(), t.isScrolling = !0, t._scrollTimer && clearTimeout(t._scrollTimer);
      t._layoutSuspended || (t._scrollTimer = setTimeout(function () {
        return t._recycle(!1), t.isScrolling = !1, e.max === e.value && (t.$.fireEvent("scrollBottomReached"), "infinite" === t.scrolling) ? void t._virtualDataRequest("scroll") : void ("virtual" === t.scrolling && t._virtualDataRequest("scroll"), e.min === e.value && t.$.fireEvent("scrollTopReached"));
      }));
    }
  }, {
    key: "clearRows",
    value: function clearRows() {
      var e = this;
      e.dataSource = new Smart.DataAdapter({
        dataSource: []
      }), e.clearSelection();
    }
  }, {
    key: "dataBind",
    value: function dataBind() {
      var e = this;
      delete e.__autoRowHeight, null === e.dataSource ? e.clearRows() : Array.isArray(e.dataSource) && (e.dataSource = new Smart.DataAdapter({
        dataSource: e.dataSource
      }));
      var t = e._sortedColumns;
      e.clearSort(), e._initColumns && 0 === e._initColumns.length && (e.columns = [], e._renderColumns(!0)), e._renderRows(), "virtual" === e.scrolling || e.paging.enabled && e.dataSource && e.dataSource.virtualDataSource ? e._virtualDataRequest("dataBind") : e.dataSource && e.dataSource.virtualDataSource ? e._virtualDataRequest("dataBind") : e.paging.enabled && (!e.dataSource || e.dataSource && !e.dataSource.url) && e._refreshPagesCount(), t && e._refreshSort(t);
    }
  }, {
    key: "refresh",
    value: function refresh(e) {
      var t = this;
      t.isInitialized && (e && (t._initializeRows(), t._initializeRowElements()), t._refresh());
    }
  }, {
    key: "refreshView",
    value: function refreshView() {
      var e = this;

      e._recycle();
    }
  }, {
    key: "beginUpdate",
    value: function beginUpdate() {
      var e = this;
      e._isUpdating || (e._isUpdating = 0), e._isUpdating++;
    }
  }, {
    key: "endUpdate",
    value: function endUpdate(e) {
      var t = this;
      t._isUpdating--, 0 > t._isUpdating && (t._isUpdating = 0), !1 === e ? t.refreshView() : t.refresh();
    }
  }, {
    key: "_autoRowHeight",
    get: function get() {
      var e = Math.max;
      var t = this;
      if (t.__autoRowHeight) return t.__autoRowHeight;
      var a = new Smart.Grid.Row({
        index: 0,
        grid: t
      }),
          n = a.createElement();
      var o = t.layout.rowMinHeight;
      t.$.scrollView.appendChild(n), t.removeAttribute("grouped"), t.removeAttribute("tree"), t.grouping.enabled && t.dataSource.groupBy && 0 < t.dataSource.groupBy.length ? t.setAttribute("grouped", "") : t.dataSource.boundHierarchy && t.setAttribute("tree", "");
      var r = {};

      for (var _e700 = 0; _e700 < t.dataSource.dataFields.length; _e700++) {
        var _i626 = t.dataSource.dataFields[_e700];
        r[_i626.name] = "ABCDEFHIJLMNOPQRSTUVWXYZ1234567910|";
      }

      a.data = r, a._isMeasureRow = !0, a.render(), n.style.height = "", n.style.lineHeight = "", o = e(n.offsetHeight, o);

      for (var _e701 = 0; _e701 < n.children.length; _e701++) {
        n.children[_e701].style.height = "";
      }

      for (var _r135 = 0; _r135 < n.children[1].children.length; _r135++) {
        n.children[1].children[_r135].style.height = "auto";

        var _i627 = a.getCell(t.columns[0].dataField);

        _i627.render(), o = e(o, 8 + n.children[1].children[_r135].offsetHeight);
        break;
      }

      return t.$.scrollView.removeChild(n), t.__autoRowHeight = o, o;
    }
  }, {
    key: "_scrollHeight",
    get: function get() {
      var e = this;
      var t = e._recyclingRows,
          a = 0,
          n = e._autoRowHeight,
          o = 0,
          r = 0;
      if (e.__scrollHeight) return e.__scrollHeight;
      if (0 === t.length || 0 === e.columns.length) return 0;
      e.rows.canNotify = !1;
      var l = t.length;

      for (var _s72 = 0, _i628; _s72 < l; _s72++) {
        if (_i628 = t[_s72], !_i628.visible || !1 === _i628.filtered) {
          _i628.height = 0, _i628.cellHeight = 0, _i628.top = a;
          continue;
        }

        var _l101 = !_i628.height || !_i628.cellHeight || _i628.showDetail || "auto" === _i628.height || "auto" === _i628._height || "auto" === e.layout.rowHeight;

        if (_l101 && !_i628.expandHeight) {
          if (_i628.detailHeight || (_i628.detailHeight = 200), !e.layout.rowHeight) {
            if ("auto" === _i628.height || "auto" === _i628._height) {
              _i628.element = e._rowElements[1];

              var _t620 = _i628.data && e.isRendered ? _i628._autoSize(_i628) : n;

              _i628.height = _t620, _i628._height = "auto";
            } else _i628.height = n;

            void 0 === _i628.label || _i628.summaryRow || (_i628.height = e.grouping.groupRowHeight), _i628.computedHeight && (_i628.height = _i628.computedHeight), _i628.cellHeight = _i628.height, e.rowDetail.enabled && _i628.showDetail && !e.rowDetail.dialog.enabled && (_i628.height += _i628.detailHeight);
          } else if (e.layout.rowHeight) if ("number" == typeof e.layout.rowHeight) e.layout.rowHeight < e.layout.rowMinHeight && (e.layout.rowHeight = e.layout.rowMinHeight), _i628.height = e.layout.rowHeight, _i628.computedHeight && (_i628.height = _i628.computedHeight), void 0 !== _i628.label && (_i628.height = e.grouping.groupRowHeight), _i628.cellHeight = _i628.height, e.rowDetail.enabled && _i628.showDetail && !e.rowDetail.dialog.enabled && (_i628.height += _i628.detailHeight);else if ("auto" === e.layout.rowHeight) {
            e.layout.rowHeight < e.layout.rowMinHeight && (e.layout.rowHeight = e.layout.rowMinHeight), _i628.element = e._rowElements[1];

            var _t621 = _i628.data && e.isRendered ? _i628._autoSize(_i628) : n;

            _i628.height = _t621, _i628.computedHeight && (_i628.height = _i628.computedHeight), void 0 !== _i628.label && (_i628.height = e.grouping.groupRowHeight), _i628.cellHeight = _i628.height, e.rowDetail.enabled && _i628.showDetail && !e.rowDetail.dialog.enabled && (_i628.height += _i628.detailHeight);
          } else e.layout.rowHeight(_s72, _i628), _i628.height || (_i628.height = n), _i628.cellHeight = _i628.height, e.rowDetail.enabled && _i628.showDetail && !e.rowDetail.dialog.enabled && (_i628.height += _i628.detailHeight);

          e._rowGap && _s72 < e.rows.length - 1 && (_i628.height += e._rowGap);
        }

        if (!0 === _i628.freeze || "near" === _i628.freeze ? o += _i628.height : "far" === _i628.freeze && (r += _i628.height), _i628.freeze) {
          _i628.top = a;
          continue;
        }

        _i628.top !== a && (_i628.top = a), a += _i628.expandHeight ? _i628.cellHeight : _i628.height;
      }

      return e.__scrollHeight = a, e.__frozenNearHeight = o, e.__frozenFarHeight = r, e._scrollView.scrollHeight = a - e.$.scrollView.offsetHeight + o + r, a = e.__scrollHeight + o + r - 1, e.grouping.enabled && 0 < e.dataSource.groupBy.length && 0 < e.grouping.groupIndent && (a += parseInt(e.grouping.groupIndent / 2)), e.__scrollHeight = a, e.rows.canNotify = !0, a;
    }
  }, {
    key: "_clientSize",
    get: function get() {
      var e = this;
      if (e.__clientSize) return e.__clientSize;
      var t = getComputedStyle(e.$.container),
          i = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight),
          a = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom),
          n = parseFloat(t.borderLeftWidth) + parseFloat(t.borderRightWidth),
          o = parseFloat(t.borderTopWidth) + parseFloat(t.borderBottomWidth);
      return e.__clientSize = {
        width: e.$.container.offsetWidth - i - n,
        height: e.$.container.offsetHeight - a - o
      }, e.__clientSize;
    }
  }, {
    key: "_viewRows",
    get: function get() {
      var e = this;
      if (e.__viewRows) return e.__viewRows;
      e._nearRowsAdded || (e._nearRowsAdded = [], e._farRowsAdded = []);
      var t = e.rowHierarchy ? e.rowHierarchy : e.rows.toArray(),
          i = [].concat(e._frozenNearDefaultRows, e._nearRowsAdded, t, e._farRowsAdded, e._frozenFarDefaultRows);
      return e.__viewRows = i, i;
    }
  }, {
    key: "styleProperties",
    get: function get() {
      return ["grid-template-columns"];
    }
  }, {
    key: "_scrollWidth",
    get: function get() {
      var e = this;
      if (e.__scrollWidth) return e.__scrollWidth;
      var t = 0;

      for (var _a391 = 0; _a391 < e.viewColumns.length; _a391++) {
        var _i629 = e.viewColumns[_a391];
        _i629.visible && (t += _i629.computedWidth);
      }

      return t = parseInt(t), e.__scrollWidth = t, e._scrollView.scrollWidth = t - e._clientSize.width, e.__scrollWidth;
    }
  }, {
    key: "_contentBorder",
    get: function get() {
      var e = this;
      if (e.__contentBorder) return e.__contentBorder;
      var t = getComputedStyle(e.$.content),
          i = parseFloat(t.borderLeftWidth) + parseFloat(t.borderRightWidth),
          a = parseFloat(t.borderTopWidth) + parseFloat(t.borderBottomWidth),
          n = {
        left: i,
        top: a
      };
      return e.__contentBorder = n, n;
    }
  }, {
    key: "_recyclingRows",
    get: function get() {
      var e = this;
      if (e.rowHierarchy) return e.rowHierarchy;
      var t = e.getVisibleRows();
      return e.paging.enabled && (t = t.slice(e.paging.pageIndex * e.paging.pageSize, (e.paging.pageIndex + 1) * e.paging.pageSize)), t;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        appearance: {
          value: {
            allowColumnFixing: {
              value: !1,
              type: "boolean"
            },
            alternationStart: {
              value: 0,
              type: "int"
            },
            alternationEnd: {
              value: 0,
              type: "int"
            },
            alternationCount: {
              value: 0,
              type: "int"
            },
            allowHover: {
              value: !1,
              type: "boolean",
              defaultReflectToAttribute: !0
            },
            allowHeaderHover: {
              value: !0,
              type: "boolean",
              defaultReflectToAttribute: !0
            },
            allowRowToggleAnimation: {
              value: !1,
              type: "boolean"
            },
            allowRowDetailToggleAnimation: {
              value: !1,
              type: "boolean"
            },
            allowSortAnimation: {
              value: !1,
              type: "boolean"
            },
            allowColumnLabelAnimation: {
              value: !0,
              type: "boolean"
            },
            allowCheckBoxesSelectionAnimation: {
              value: !0,
              type: "boolean"
            },
            allowColumnMenuAnimation: {
              value: !0,
              type: "boolean"
            },
            allowColumnSortButtonAnimation: {
              value: !0,
              type: "boolean"
            },
            allowColumnActionButtonAnimation: {
              value: !0,
              type: "boolean"
            },
            allowColumnFilterButtonAnimation: {
              value: !0,
              type: "boolean"
            },
            allowColumnStickyPosition: {
              value: !1,
              type: "boolean"
            },
            autoShowColumnSortButton: {
              value: !0,
              type: "boolean"
            },
            autoShowColumnActionButton: {
              value: !0,
              type: "boolean"
            },
            autoGenerateRowLabelMode: {
              value: "number",
              type: "string"
            },
            autoGenerateColumnLabelMode: {
              value: "letter",
              type: "string"
            },
            autoShowColumnFilterButton: {
              value: !0,
              type: "boolean"
            },
            displayLoadingIndicator: {
              value: !1,
              type: "boolean"
            },
            loadingIndicatorPlaceholder: {
              value: "Loading...",
              type: "string"
            },
            placeholder: {
              value: "No Rows",
              type: "string"
            },
            sortAnimationDuration: {
              value: 500,
              type: "number"
            },
            showRowHeader: {
              value: !1,
              type: "boolean"
            },
            showRowHeaderNumber: {
              value: !1,
              type: "boolean"
            },
            showRowHeaderEditIcon: {
              value: !0,
              type: "boolean",
              defaultReflectToAttribute: !0
            },
            showRowHeaderSelectIcon: {
              value: !1,
              type: "boolean"
            },
            showRowHeaderFocusIcon: {
              value: !1,
              type: "boolean"
            },
            showColumnHeaderLines: {
              value: !0,
              type: "boolean",
              defaultReflectToAttribute: !0
            },
            showColumnLines: {
              value: !0,
              type: "boolean",
              defaultReflectToAttribute: !0
            },
            showRowLines: {
              value: !0,
              type: "boolean",
              defaultReflectToAttribute: !0
            },
            showFilterColumnBackground: {
              value: !0,
              type: "boolean"
            },
            showSortColumnBackground: {
              value: !0,
              type: "boolean"
            },
            showFrozenColumnBackground: {
              value: !0,
              type: "boolean"
            },
            showFrozenRowBackground: {
              value: !0,
              type: "boolean"
            },
            showColumnSortButton: {
              value: !0,
              type: "boolean"
            },
            showColumnFilterButton: {
              value: !0,
              type: "boolean"
            },
            showColumnDescriptionButton: {
              value: !1,
              type: "boolean"
            },
            showColumnIcon: {
              value: !1,
              type: "boolean"
            },
            showColumnCustomButton: {
              value: !1,
              type: "boolean"
            },
            showColumnActionButton: {
              value: !0,
              type: "boolean"
            },
            showTooltips: {
              value: !1,
              type: "boolean"
            },
            showResizeTooltips: {
              value: !0,
              type: "boolean"
            },
            showHorizontalScrollBarOnFixedColumns: {
              value: !1,
              type: "boolean"
            },
            showVerticalScrollBarOnFixedColumns: {
              value: !1,
              type: "boolean"
            }
          },
          type: "object"
        },
        behavior: {
          value: {
            allowColumnAutoSizeOnDoubleClick: {
              value: !0,
              type: "boolean"
            },
            allowRowAutoSizeOnDoubleClick: {
              value: !0,
              type: "boolean"
            },
            allowColumnReorder: {
              value: !1,
              type: "boolean"
            },
            allowRowReorder: {
              value: !1,
              type: "boolean"
            },
            doubleClickTimingDelay: {
              value: 300,
              type: "number"
            },
            columnResizeMode: {
              value: "none",
              type: "string",
              allowedValues: ["none", "split", "growAndShrink"]
            },
            rowResizeMode: {
              value: "none",
              type: "string",
              allowedValues: ["none", "split", "growAndShrink"]
            }
          },
          type: "object"
        },
        layout: {
          value: {
            allowCellsWrap: {
              value: !1,
              type: "boolean"
            },
            autoGenerateColumnWidth: {
              value: null,
              type: "number?"
            },
            columnWidth: {
              value: null,
              type: "any",
              reflectToAttribute: !1
            },
            columnHeight: {
              value: null,
              type: "any",
              reflectToAttribute: !1
            },
            columnMinHeight: {
              value: 30,
              type: "any",
              reflectToAttribute: !1
            },
            loadingIndicatorPosition: {
              value: "center",
              allowedValues: ["bottom", "center", "top"],
              type: "string"
            },
            rowMinHeight: {
              value: 30,
              type: "number"
            },
            rowHeight: {
              value: null,
              type: "any",
              reflectToAttribute: !1
            }
          },
          type: "object"
        },
        dataExport: {
          value: {
            header: {
              value: !0,
              type: "boolean"
            },
            filterBy: {
              value: null,
              type: "object"
            },
            groupBy: {
              value: null,
              type: "object"
            },
            style: {
              value: null,
              type: "object"
            },
            fileName: {
              value: "smartGrid",
              type: "string?"
            },
            pageOrientation: {
              value: "portrait",
              type: "string"
            },
            expandChar: {
              value: "+",
              type: "string"
            },
            collapseChar: {
              value: "-",
              type: "string"
            },
            view: {
              value: !1,
              type: "boolean"
            },
            viewStart: {
              value: null,
              type: "number?"
            },
            viewEnd: {
              value: null,
              type: "number?"
            }
          },
          type: "object"
        },
        clipboard: {
          value: {
            enabled: {
              value: !0,
              type: "boolean"
            },
            autoFillMode: {
              value: "copy",
              allowedValues: ["none", "copy", "fillSeries"],
              type: "string"
            },
            onPasteValue: {
              value: null,
              type: "any"
            }
          },
          type: "object"
        },
        columns: {
          value: [],
          type: "any",
          reflectToAttribute: !1
        },
        columnChooser: {
          value: {
            allowSearch: {
              value: !1,
              type: "boolean"
            },
            visible: {
              value: !1,
              type: "boolean"
            },
            label: {
              value: "Column Chooser",
              type: "string"
            },
            mode: {
              value: "dragAndDrop",
              type: "string",
              allowedValues: ["select", "dragAndDrop"]
            },
            placeholder: {
              value: "Drag a column here to hide it",
              type: "string"
            },
            width: {
              value: 250,
              type: "number"
            },
            height: {
              value: 200,
              type: "number"
            }
          },
          type: "object"
        },
        columnMenu: {
          value: {
            autoClose: {
              value: !0,
              type: "boolean"
            },
            dataSource: {
              value: {
                columnMenuCustomizeType: {
                  value: {
                    command: {
                      value: "customizeTypeCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: !1,
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-ellipsis-vert",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemRename: {
                  value: {
                    command: {
                      value: "renameCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: !1,
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-rename",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemEditDescription: {
                  value: {
                    command: {
                      value: "editDescriptionCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: !1,
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-circled",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemDuplicate: {
                  value: {
                    command: {
                      value: "duplicateCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: !1,
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-duplicate",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemInsertLeft: {
                  value: {
                    command: {
                      value: "insertLeftCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: !1,
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-insert-left",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemInsertRight: {
                  value: {
                    command: {
                      value: "insertRightCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: !1,
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-insert-right",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemSortAsc: {
                  value: {
                    command: {
                      value: "sortAscCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: "auto",
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-sort-name-up",
                      type: "string"
                    },
                    iconAlt: {
                      value: "smart-icon-sort-number-up",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemSortDesc: {
                  value: {
                    command: {
                      value: "sortDescCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: "auto",
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-sort-name-down",
                      type: "string"
                    },
                    iconAlt: {
                      value: "smart-icon-sort-number-down",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemRemoveSort: {
                  value: {
                    command: {
                      value: "removeSortCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: "auto",
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-cancel-circled",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemFilter: {
                  value: {
                    command: {
                      value: "addFilterCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: "auto",
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-add-filter",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemRemoveFilter: {
                  value: {
                    command: {
                      value: "addFilterCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: "auto",
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-cancel-circled",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemGroupBy: {
                  value: {
                    command: {
                      value: "groupByCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: "auto",
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-group",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemRemoveGroupBy: {
                  value: {
                    command: {
                      value: "removeGroupByCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: "auto",
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-ungroup",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemHide: {
                  value: {
                    command: {
                      value: "hideColumnCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: !1,
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-visibility-off",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                },
                columnMenuItemDelete: {
                  value: {
                    command: {
                      value: "deleteColumnCommand",
                      type: "any"
                    },
                    enabled: {
                      value: !0,
                      type: "boolean"
                    },
                    visible: {
                      value: !1,
                      type: "any"
                    },
                    icon: {
                      value: "smart-icon-delete",
                      type: "string"
                    },
                    label: {
                      value: "{{messages}}",
                      type: "string"
                    }
                  },
                  type: "object",
                  reflectToAttribute: !1
                }
              },
              type: "object",
              reflectToAttribute: !1
            },
            visible: {
              value: !1,
              type: "boolean"
            },
            enabled: {
              value: !0,
              type: "boolean"
            },
            width: {
              value: 250,
              type: "number"
            },
            height: {
              value: null,
              type: "number?"
            }
          },
          type: "object",
          reflectToAttribute: !1
        },
        columnGroups: {
          value: [],
          type: "array",
          reflectToAttribute: !1
        },
        charting: {
          value: {
            appendTo: {
              value: null,
              type: "any"
            },
            enabled: {
              value: !1,
              type: "boolean"
            },
            colorScheme: {
              value: "scheme01",
              type: "string"
            },
            description: {
              value: "",
              type: "string"
            },
            dialog: {
              value: {
                header: {
                  value: "{{message}}",
                  type: "string"
                },
                height: {
                  value: 400,
                  type: "any"
                },
                width: {
                  value: 400,
                  type: "any"
                },
                left: {
                  value: "center",
                  type: "any"
                },
                top: {
                  value: "center",
                  type: "any"
                },
                enabled: {
                  value: !0,
                  type: "boolean"
                },
                visible: {
                  value: !1,
                  type: "boolean"
                }
              },
              type: "object"
            },
            formatSettings: {
              value: {},
              type: "object"
            }
          },
          type: "object"
        },
        dataSource: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        grouping: {
          value: {
            enabled: {
              value: !1,
              type: "boolean",
              reflectToAttribute: !1
            },
            allowCollapse: {
              value: !1,
              type: "boolean",
              reflectToAttribute: !1
            },
            autoExpandAll: {
              value: !1,
              type: "boolean",
              reflectToAttribute: !1
            },
            expandMode: {
              value: "buttonClick",
              type: "string",
              allowedValues: ["buttonClick", "rowClick"],
              reflectToAttribute: !1
            },
            groupRowHeight: {
              value: 50,
              type: "any",
              reflectToAttribute: !1
            },
            toggleButtonIndent: {
              value: 16,
              type: "number",
              reflectToAttribute: !1
            },
            groupIndent: {
              value: 16,
              type: "number",
              reflectToAttribute: !1
            },
            groupBar: {
              value: {
                visible: {
                  value: !1,
                  type: "boolean",
                  reflectToAttribute: !1
                },
                allowColumnDragDrop: {
                  value: !1,
                  type: "boolean",
                  reflectToAttribute: !1
                },
                allowColumnCloseButtons: {
                  value: !0,
                  type: "boolean",
                  reflectToAttribute: !1
                }
              },
              type: "object"
            },
            groupPanel: {
              value: {
                visible: {
                  value: !1,
                  type: "boolean",
                  reflectToAttribute: !1
                }
              },
              type: "object"
            },
            summaryRow: {
              value: {
                inline: {
                  value: !0,
                  type: "boolean"
                },
                visible: {
                  value: !0,
                  type: "boolean"
                }
              },
              type: "object"
            }
          },
          type: "object"
        },
        messages: {
          extend: !0,
          value: {
            en: {
              invalidColumnProperty: "{{elementType}}: Invalid property name \"{{propertyName}}\" set for Column: \"{{type}}\"",
              invalidRowProperty: "{{elementType}}: Invalid property name \"{{propertyName}}\" set for Row\"",
              frozenColumns: "{{elementType}}: To Pin/Freeze a column group, all columns within it should be frozen.",
              frozenRows: "{{elementType}}: To Pin/Freeze a special cell, all rows within it should be frozen.",
              columnGroups: "{{elementType}}: Please, check the initialization of the smartGrid's columns array. The columns in a column group are expected to be siblings in the columns array.",
              min: "Min: {{value}}",
              max: "Max: {{value}} ",
              sum: "Sum: {{value}} ",
              avg: "Avg: {{value}} ",
              count: "Count: {{value}} ",
              pagerFirstButton: "First",
              pagerLastButton: "Last",
              pagerPreviousButton: "Previous",
              pagerNextButton: "Next",
              pagerNavigateToLabel: "Go to:",
              pagerPageSizeLabel: "Show:",
              pagerNavigateToInputPlaceholder: "",
              pagerEllipsis: "...",
              pagerSummaryString: "of",
              pagerSummaryPrefix: "of",
              pagerSummarySuffix: "",
              columnMenuCustomizeType: "Customize type",
              columnMenuItemRename: "Rename",
              columnMenuItemEditDescription: "Edit description",
              columnMenuItemDuplicate: "Duplicate",
              columnMenuItemInsertLeft: "Insert left",
              columnMenuItemInsertRight: "Insert right",
              columnMenuItemSortAsc: "Sort {{mode}}",
              columnMenuItemSortDesc: "Sort {{mode}}",
              columnMenuItemRemoveSort: "Remove Sort",
              columnMenuItemFilter: "Filter",
              columnMenuItemRemoveFilter: "Remove Filter",
              columnMenuItemGroupBy: "Group by this column",
              columnMenuItemRemoveGroupBy: "Remove Group",
              columnMenuItemHide: "Hide",
              columnMenuItemDelete: "Delete",
              columnResizeTooltip: "width: {{value}}px",
              rowResizeTooltip: "height: {{value}}px",
              commandBarAddRow: "Add",
              commandBarDeleteRow: "Delete",
              commandBarBatchRevert: "Revert",
              commandBarBatchSave: "Save",
              commandColumnEdit: "Edit",
              commandColumnDelete: "Delete",
              commandColumnCancel: "Cancel",
              commandColumnUpdate: "Update",
              commandColumnMenu: "",
              addNewRow: "Click here to add a new row",
              dialogChartHeader: "{{value}} Chart",
              dialogRowDetailHeader: "Row Id: {{value}}",
              dialogRowDetailButtonConfirm: "OK",
              dialogRowDetailButtonCancel: "CANCEL",
              dialogEditHeader: "Edit {{value}}",
              dialogAddButtonConfirm: "ADD",
              dialogAddButtonCancel: "CANCEL",
              dialogEditButtonConfirm: "OK",
              dialogEditButtonCancel: "CANCEL",
              dialogDeleteButtonConfirm: "DELETE",
              dialogDeleteButtonCancel: "CANCEL",
              dialogAddHeader: "Add Row",
              dialogDeleteHeader: "Delete Row",
              dialogDeleteContent: "Are you sure you want to delete this row?",
              calendar: {
                "/": "/",
                ":": ":",
                firstDay: 0,
                days: {
                  names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                  namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                  namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
                },
                months: {
                  names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ""],
                  namesAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", ""]
                },
                AM: ["AM", "am", "AM"],
                PM: ["PM", "pm", "PM"],
                eras: [{
                  name: "A.D.",
                  start: null,
                  offset: 0
                }],
                currencySymbol: "$",
                currencySymbolPosition: "before",
                decimalSeparator: ".",
                thousandsSeparator: ","
              }
            }
          },
          type: "object"
        },
        onCellValue: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onCellUpdate: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onBeforeInit: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onInit: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onAfterInit: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onKey: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onRender: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onChartInit: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onRowInit: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onRowDetailInit: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onRowDetailUpdated: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onRowInserted: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onRowRemoved: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onRowUpdate: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onRowUpdated: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onColumnInit: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onColumnInserted: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onColumnRemoved: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onColumnUpdated: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        onCommand: {
          value: null,
          reflectToAttribute: !1,
          type: "any"
        },
        filtering: {
          value: {
            enabled: {
              value: !1,
              type: "boolean"
            },
            filter: {
              value: [],
              type: "array",
              reflectToAttribute: !1
            },
            filterRow: {
              value: {
                visible: {
                  value: !1,
                  type: "boolean"
                },
                menuVisible: {
                  value: !1,
                  type: "boolean"
                },
                applyMode: {
                  value: "auto",
                  type: "string",
                  allowedValues: ["auto", "click"]
                },
                autoApplyModeDelay: {
                  value: 300,
                  type: "number"
                }
              },
              type: "object"
            },
            filterMenu: {
              value: {
                visible: {
                  value: !0,
                  type: "boolean"
                },
                buttons: {
                  value: ["cancel", "clear", "filter"],
                  type: "array"
                },
                dataSource: {
                  value: null,
                  type: "any"
                },
                width: {
                  value: 250,
                  type: "number"
                },
                height: {
                  value: 200,
                  type: "number"
                }
              },
              type: "object"
            },
            filterBuilder: {
              value: {
                visible: {
                  value: !1,
                  type: "boolean"
                },
                height: {
                  value: null,
                  type: "number?"
                }
              },
              type: "object"
            }
          },
          type: "object"
        },
        editing: {
          value: {
            allowRowHeaderEdit: {
              value: !1,
              type: "any"
            },
            allowColumnHeaderEdit: {
              value: !1,
              type: "any"
            },
            active: {
              value: !1,
              readonly: !0,
              type: "boolean"
            },
            enabled: {
              value: !1,
              type: "boolean"
            },
            batch: {
              value: !1,
              type: "any"
            },
            action: {
              value: "click",
              type: "string",
              allowedValues: ["none", "click", "doubleClick"]
            },
            commandKeys: {
              value: {
                commandKeyEdit: {
                  value: {
                    command: "commandKeyEditCommand",
                    key: "F2"
                  },
                  type: "object"
                },
                commandKeyCancel: {
                  value: {
                    command: "commandKeyCancelCommand",
                    key: "Escape"
                  },
                  type: "object"
                },
                commandKeyUpdate: {
                  value: {
                    command: "commandKeyUpdateCommand",
                    key: "Enter | Tab"
                  },
                  type: "object"
                }
              },
              type: "object"
            },
            commandBar: {
              value: {
                visible: {
                  value: !1,
                  type: "boolean"
                },
                position: {
                  value: "near",
                  allowedValues: ["near", "far", "both"],
                  type: "string"
                },
                displayMode: {
                  value: "labelAndIcon",
                  allowedValues: ["label", "icon", "labelAndIcon"],
                  type: "string"
                },
                dataSource: {
                  value: {
                    commandBarAddRow: {
                      value: {
                        command: {
                          value: "commandBarAddRowCommand",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-plus",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: !1,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    commandBarDeleteRow: {
                      value: {
                        command: {
                          value: "commandBarDeleteRowCommand",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-delete",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: !1,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    commandBarBatchSave: {
                      value: {
                        command: {
                          value: "commandBarBatchSaveCommand",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-ok-squared",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: !0,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    commandBarBatchRevert: {
                      value: {
                        command: {
                          value: "commandBarBatchRevertCommand",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-reload",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: !0,
                          type: "any"
                        }
                      },
                      type: "object"
                    }
                  },
                  type: "object"
                }
              },
              type: "object"
            },
            commandColumn: {
              value: {
                visible: {
                  value: !1,
                  type: "boolean"
                },
                inline: {
                  value: !1,
                  type: "boolean"
                },
                position: {
                  value: "far",
                  allowedValues: ["near", "far"],
                  type: "string"
                },
                displayMode: {
                  value: "icon",
                  allowedValues: ["label", "icon", "labelAndIcon"],
                  type: "string"
                },
                dataSource: {
                  value: {
                    commandColumnMenu: {
                      value: {
                        command: {
                          value: "commandColumnMenuCommand",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-menu",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: !1,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    commandColumnEdit: {
                      value: {
                        command: {
                          value: "commandColumnEditCommand",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-mode-edit",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: "auto",
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    commandColumnDelete: {
                      value: {
                        command: {
                          value: "commandColumnDeleteCommand",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-delete",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: !0,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    commandColumnUpdate: {
                      value: {
                        command: {
                          value: "commandColumnUpdateCommand",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-ok-squared",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: "auto",
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    commandColumnCancel: {
                      value: {
                        command: {
                          value: "commandColumnCancelCommand",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-cancel-circled",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: "auto",
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    commandColumnRowMenu: {
                      value: {
                        command: {
                          value: "commandColumnRowMenuCommand",
                          type: "any",
                          reflectToAttribute: !1
                        },
                        icon: {
                          value: "smart-icon-ellipsis-vert",
                          type: "string"
                        },
                        label: {
                          value: "{{messages}}",
                          type: "string"
                        },
                        visible: {
                          value: !1,
                          type: "any"
                        }
                      },
                      type: "object"
                    },
                    commandColumnCustom: {
                      value: {
                        command: {
                          value: "",
                          type: "any"
                        },
                        icon: {
                          value: "smart-icon-ellipsis-vert",
                          type: "string"
                        },
                        label: {
                          value: "",
                          type: "string"
                        },
                        visible: {
                          value: !1,
                          type: "any"
                        }
                      },
                      type: "object"
                    }
                  },
                  type: "object"
                },
                width: {
                  value: null,
                  type: "number?"
                }
              },
              reflectToAttribute: !1,
              type: "object"
            },
            mode: {
              value: "cell",
              allowedValues: ["cell", "row"],
              type: "string"
            },
            addNewRow: {
              value: {
                position: {
                  value: "both",
                  allowedValues: ["near", "far", "both"],
                  type: "string"
                },
                visible: {
                  value: !1,
                  type: "boolean"
                },
                autoCreate: {
                  value: !1,
                  type: "boolean"
                },
                autoSave: {
                  value: !0,
                  type: "boolean"
                },
                label: {
                  value: "{{message}}",
                  type: "string"
                },
                displayMode: {
                  value: "row",
                  allowedValues: ["row", "button"],
                  type: "string"
                }
              },
              type: "object"
            },
            dialog: {
              value: {
                header: {
                  value: "{{message}}",
                  type: "string"
                },
                height: {
                  value: "auto",
                  type: "any"
                },
                width: {
                  value: "auto",
                  type: "any"
                },
                left: {
                  value: "center",
                  type: "any"
                },
                top: {
                  value: "center",
                  type: "any"
                },
                enabled: {
                  value: !1,
                  type: "boolean"
                },
                visible: {
                  value: !1,
                  type: "boolean"
                }
              },
              type: "object"
            },
            addDialog: {
              value: {
                header: {
                  value: "{{message}}",
                  type: "string"
                },
                height: {
                  value: "auto",
                  type: "any"
                },
                width: {
                  value: "auto",
                  type: "any"
                },
                left: {
                  value: "center",
                  type: "any"
                },
                top: {
                  value: "center",
                  type: "any"
                },
                enabled: {
                  value: !1,
                  type: "boolean"
                },
                visible: {
                  value: !1,
                  type: "boolean"
                }
              },
              type: "object"
            },
            deleteDialog: {
              value: {
                header: {
                  value: "{{message}}",
                  type: "string"
                },
                height: {
                  value: "auto",
                  type: "any"
                },
                width: {
                  value: "auto",
                  type: "any"
                },
                left: {
                  value: "center",
                  type: "any"
                },
                top: {
                  value: "center",
                  type: "any"
                },
                enabled: {
                  value: !1,
                  type: "boolean"
                },
                visible: {
                  value: !1,
                  type: "boolean"
                }
              },
              type: "object"
            }
          },
          type: "object"
        },
        paging: {
          value: {
            enabled: {
              value: !1,
              type: "boolean"
            },
            spinner: {
              value: {
                enabled: {
                  value: !1,
                  type: "boolean"
                },
                step: {
                  value: 1,
                  type: "number"
                }
              },
              type: "object"
            },
            pageSize: {
              value: 10,
              type: "int",
              validator: "pageSizeValidator"
            },
            pageIndex: {
              value: 0,
              type: "int",
              validator: "pageIndexValidator"
            }
          },
          type: "object"
        },
        pager: {
          value: {
            autoEllipsis: {
              value: "both",
              allowedValues: ["none", "before", "after", "both"],
              type: "string"
            },
            position: {
              value: "far",
              allowedValues: ["near", "far", "both"],
              type: "string"
            },
            template: {
              value: "",
              type: "string"
            },
            pageSizeSelector: {
              value: {
                visible: {
                  value: !1,
                  type: "boolean"
                },
                dataSource: {
                  value: [10, 20, 50],
                  type: "object"
                },
                position: {
                  value: "far",
                  allowedValues: ["near", "far"],
                  type: "string"
                }
              },
              type: "object"
            },
            summary: {
              value: {
                position: {
                  value: "far",
                  allowedValues: ["near", "far"],
                  type: "string"
                },
                visible: {
                  value: !1,
                  type: "boolean"
                }
              },
              type: "object"
            },
            navigationButtons: {
              value: {
                position: {
                  value: "both",
                  allowedValues: ["near", "far", "both"],
                  type: "string"
                },
                prevNextButtons: {
                  value: {
                    visible: {
                      value: !0,
                      type: "boolean"
                    }
                  },
                  type: "object"
                },
                firstLastButtons: {
                  value: {
                    visible: {
                      value: !0,
                      type: "boolean"
                    }
                  },
                  type: "object"
                },
                labels: {
                  value: {
                    visible: {
                      value: !1,
                      type: "boolean"
                    }
                  },
                  type: "object"
                }
              },
              type: "object"
            },
            navigationInput: {
              value: {
                position: {
                  value: "far",
                  allowedValues: ["near", "far"],
                  type: "string"
                },
                visible: {
                  value: !1,
                  type: "boolean"
                }
              },
              type: "object"
            },
            pageIndexSelectors: {
              value: {
                visible: {
                  value: !0,
                  type: "boolean"
                },
                dataSource: {
                  value: 10,
                  type: "any"
                }
              },
              type: "object"
            },
            visible: {
              value: !1,
              type: "boolean"
            }
          },
          type: "object",
          reflectToAttribute: !1
        },
        rowDetail: {
          value: {
            enabled: {
              value: !1,
              type: "boolean"
            },
            height: {
              value: 200,
              type: "number"
            },
            position: {
              value: "near",
              allowedValues: ["near", "far"],
              type: "string"
            },
            template: {
              value: "",
              type: "any",
              reflectToAttribute: !1
            },
            visible: {
              value: !0,
              type: "boolean"
            },
            dialog: {
              value: {
                header: {
                  value: "{{message}}",
                  type: "string"
                },
                height: {
                  value: 300,
                  type: "any"
                },
                width: {
                  value: 360,
                  type: "any"
                },
                left: {
                  value: "center",
                  type: "any"
                },
                top: {
                  value: "center",
                  type: "any"
                },
                enabled: {
                  value: !1,
                  type: "boolean"
                },
                visible: {
                  value: !1,
                  type: "boolean"
                }
              },
              type: "object"
            }
          },
          type: "object"
        },
        summaryRow: {
          value: {
            position: {
              value: "far",
              allowedValues: ["near", "far"],
              type: "string"
            },
            visible: {
              value: !1,
              type: "boolean"
            },
            template: {
              value: "",
              type: "string"
            }
          },
          type: "object"
        },
        scrolling: {
          value: "physical",
          allowedValues: ["physical", "virtual", "infinite", "deferred"],
          type: "string"
        },
        columnHeader: {
          value: {
            visible: {
              value: !0,
              type: "boolean"
            }
          },
          type: "object"
        },
        groupHeader: {
          value: {
            visible: {
              value: !1,
              type: "boolean"
            },
            template: {
              value: "",
              type: "string"
            }
          },
          type: "object"
        },
        header: {
          value: {
            visible: {
              value: !1,
              type: "boolean"
            },
            template: {
              value: "",
              type: "string"
            }
          },
          type: "object"
        },
        footer: {
          value: {
            visible: {
              value: !1,
              type: "boolean"
            },
            template: {
              value: "",
              type: "string"
            }
          },
          type: "object"
        },
        checkBoxes: {
          value: {
            visible: {
              value: !1,
              type: "boolean"
            },
            hasThreeStates: {
              value: !1,
              type: "boolean"
            }
          },
          type: "object"
        },
        selection: {
          value: {
            enabled: {
              value: !1,
              type: "boolean"
            },
            allowRowHeaderSelection: {
              value: !1,
              type: "boolean"
            },
            allowColumnHeaderSelection: {
              value: !1,
              type: "boolean"
            },
            allowRowSelection: {
              value: !0,
              type: "boolean"
            },
            allowCellSelection: {
              value: !1,
              type: "boolean"
            },
            allowDragSelection: {
              value: !0,
              type: "boolean"
            },
            allowDragSelectionAutoScroll: {
              value: !0,
              type: "boolean"
            },
            allowCellDragSelectionHandle: {
              value: !0,
              type: "boolean"
            },
            allowCellDragDropSelectionHandle: {
              value: !0,
              type: "boolean"
            },
            allowCellDragSelectionAutoFill: {
              value: !0,
              type: "boolean"
            },
            selectAllMode: {
              value: "page",
              allowedValues: ["none", "page", "all"],
              type: "string"
            },
            mode: {
              value: "many",
              type: "string",
              allowedValues: ["one", "many", "extended"]
            },
            action: {
              value: "click",
              type: "string",
              allowedValues: ["none", "click", "doubleClick"]
            },
            checkBoxes: {
              value: {
                enabled: {
                  value: !1,
                  type: "boolean"
                },
                autoShow: {
                  value: !1,
                  type: "boolean"
                },
                action: {
                  value: "click",
                  type: "string",
                  allowedValues: ["none", "click", "doubleClick"]
                },
                selectAllMode: {
                  value: "page",
                  allowedValues: ["none", "page", "all"],
                  type: "string"
                },
                position: {
                  value: "near",
                  allowedValues: ["near", "far"],
                  type: "string"
                }
              },
              type: "object"
            },
            selected: {
              value: "",
              type: "string"
            }
          },
          type: "object"
        },
        sorting: {
          value: {
            enabled: {
              value: !1,
              type: "boolean"
            },
            sort: {
              value: [],
              type: "array"
            },
            mode: {
              value: "one",
              allowedValues: ["one", "many"],
              type: "string"
            },
            sortToggleThreeStates: {
              value: !0,
              type: "boolean"
            }
          },
          type: "object"
        }
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {};
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.menu.css", "smart.filterpanel.css", "smart.pager.css", "smart.grid.css", "smart.textbox.css"];
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        focus: "_focusHandler",
        blur: "_blurHandler",
        wheel: "_mouseWheelHandler",
        "document.up": "_upHandler",
        "document.move": "_moveHandler",
        "document.scroll": "_scrollHandler",
        keydown: "_keyDownHandler",
        keyup: "_keyUpHandler",
        resize: "_resizeHandler",
        "columnHeader.down": "_columnDownHandler",
        "columnHeader.move": "_columnMoveHandler",
        "columnHeader.mouseleave": "_columnMouseLeaveHandler",
        "rowNearContainer.down": "_rowDownHandler",
        "rowContainer.down": "_rowDownHandler",
        "rowFarContainer.down": "_rowDownHandler",
        "container.selectstart": "_selectStartHandler",
        styleChanged: "_styleChangedHandler",
        swipeleft: "_swipeLeftHandler",
        swiperight: "_swipeRightHandler"
      };
    }
  }]);

  return _class63;
}(Smart.ScrollViewer)), function () {
  "use strict";

  Smart.Grid.Extend = function (e) {
    if (e) {
      var _t622 = Object.getOwnPropertyNames(e.prototype);

      for (var _i630 in _t622) {
        var _a392 = _t622[_i630];
        "constructor" !== _a392 && (Smart.Grid.prototype[_a392] = e.prototype[_a392]);
      }
    }
  }, Smart.Grid.Extend(Smart.Utilities.Grid.Resize), Smart.Grid.Extend(Smart.Utilities.Grid.Pager), Smart.Grid.Extend(Smart.Utilities.Grid.Filter), Smart.Grid.Extend(Smart.Utilities.Grid.Sort), Smart.Grid.Extend(Smart.Utilities.Grid.Menu), Smart.Grid.Extend(Smart.Utilities.Grid.Select), Smart.Grid.Extend(Smart.Utilities.Grid.Edit), Smart.Grid.Extend(Smart.Utilities.Grid.Group), Smart.Grid.Extend(Smart.Utilities.Grid.Tree), Smart.Grid.Extend(Smart.Utilities.Grid.Export), Smart.Grid.Extend(Smart.Utilities.Grid.Chart), Smart.Grid.Cell = Smart.Utilities.Grid.Cell, Smart.Grid.Row = Smart.Utilities.Grid.Row, Smart.Grid.Column = Smart.Utilities.Grid.Column;
}(), Smart("smart-menu-item",
/*#__PURE__*/
function (_Smart$BaseElement9) {
  "use strict";

  _inherits(_class64, _Smart$BaseElement9);

  function _class64() {
    _classCallCheck(this, _class64);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class64).apply(this, arguments));
  }

  _createClass(_class64, [{
    key: "template",
    value: function template() {
      return "";
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      _get(_getPrototypeOf(_class64.prototype), "ready", this).call(this), e.$.addClass("smart-unselectable"), e.setAttribute("role", "menuitem"), e.checked && e.setAttribute("aria-checked", !0), e.disabled && e.setAttribute("aria-disabled", !0);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      if ("disabled" === e && (i ? a.setAttribute("aria-disabled", !0) : a.removeAttribute("aria-disabled")), "disabled" === e && !1 !== i && a.checked) {
        var _n306 = a.menu;

        if (_n306) {
          _get(_getPrototypeOf(_class64.prototype), "propertyChangedHandler", this).call(this, e, t, i), a.checked = !1;

          var _o213 = a.parentItem,
              _r136 = _o213 ? _o213.checkMode : _n306.checkMode;

          "radioButton" === _r136 && _n306._validateRadioButtonSelection(_o213, a.level, []);
        }
      }
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        checked: {
          value: !1,
          type: "boolean"
        },
        label: {
          value: "",
          type: "any"
        },
        level: {
          value: null,
          type: "number?"
        },
        separator: {
          value: !1,
          type: "boolean"
        },
        shortcut: {
          value: "",
          type: "string"
        },
        value: {
          value: null,
          type: "any"
        }
      };
    }
  }]);

  return _class64;
}(Smart.BaseElement)), Smart("smart-menu-items-group",
/*#__PURE__*/
function (_Smart$BaseElement10) {
  "use strict";

  _inherits(_class65, _Smart$BaseElement10);

  function _class65() {
    _classCallCheck(this, _class65);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class65).apply(this, arguments));
  }

  _createClass(_class65, [{
    key: "template",
    value: function template() {
      return "";
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      _get(_getPrototypeOf(_class65.prototype), "ready", this).call(this), e.$.addClass("smart-unselectable"), e.setAttribute("role", "menuitem"), e.setAttribute("aria-haspopup", !0), e.setAttribute("aria-expanded", e.expanded), e.checked && e.setAttribute("aria-checked", !0), e.disabled && e.setAttribute("aria-disabled", !0);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      if ("disabled" === e && (i ? a.setAttribute("aria-disabled", !0) : a.removeAttribute("aria-disabled")), -1 !== ["checkable", "checkMode", "disabled"].indexOf(e)) {
        var _n307 = a.menu;
        if (_n307) switch (_get(_getPrototypeOf(_class65.prototype), "propertyChangedHandler", this).call(this, e, t, i), e) {
          case "checkable":
            i ? a.itemContainer.setAttribute("checkable", "") : a.itemContainer.removeAttribute("checkable"), _n307._isContainerOpened(a.container.level, a.container) && "tree" !== _n307.mode && !_n307._minimized && _n307._closeSubContainers(a.level + 2), _n307._updateItemRoles();
            break;

          case "checkMode":
            a.itemContainer.setAttribute("check-mode", i), _n307._changeToRadioButtonMode(i, a.itemContainer, a), _n307._updateItemRoles();
            break;

          case "disabled":
            {
              if (!(Smart.ListMenu && _n307 instanceof Smart.ListMenu)) _n307._isContainerOpened(a.container.level, a.container) && _n307._closeSubContainers(a.level + 1, a.container);else if (_n307._view) for (; a.contains(_n307._view);) {
                _n307._backButtonClickHandler();
              }
              if (!a.checked) return;
              a.checked = !1;

              var _e702 = a.parentItem,
                  _t623 = _e702 ? _e702.checkMode : _n307.checkMode;

              "radioButton" === _t623 && _n307._validateRadioButtonSelection(_e702, a.level, []);
              break;
            }
        }
      }
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        checkable: {
          value: !1,
          type: "boolean"
        },
        checked: {
          value: !1,
          type: "boolean"
        },
        checkMode: {
          value: "checkbox",
          allowedValues: ["checkbox", "radioButton"],
          type: "string"
        },
        dropDownHeight: {
          value: null,
          type: "number?"
        },
        expanded: {
          value: !1,
          type: "boolean"
        },
        label: {
          value: "",
          type: "any"
        },
        level: {
          value: null,
          type: "number?"
        },
        separator: {
          value: !1,
          type: "boolean"
        },
        value: {
          value: null,
          type: "any"
        }
      };
    }
  }]);

  return _class65;
}(Smart.BaseElement)), Smart("smart-menu",
/*#__PURE__*/
function (_Smart$BaseElement11) {
  "use strict";

  _inherits(_class66, _Smart$BaseElement11);

  function _class66() {
    _classCallCheck(this, _class66);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class66).apply(this, arguments));
  }

  _createClass(_class66, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"minimizedHeader\" class=\"smart-header smart-minimized-header smart-hidden\">\n                        <div id=\"hamburgerIcon\" class=\"smart-hamburger-icon smart-hidden\" role=\"button\" aria-label=\"Toggle minimized menu\" aria-haspopup=\"true\">\n                            <div id=\"hamburgerIconLineTop\" class=\"smart-hamburger-icon-line smart-hamburger-icon-line-top\" role=\"presentation\"></div>\n                            <div id=\"hamburgerIconLineCenter\" class=\"smart-hamburger-icon-line smart-hamburger-icon-line-center\" role=\"presentation\"></div>\n                            <div id=\"hamburgerIconLineBottom\" class=\"smart-hamburger-icon-line smart-hamburger-icon-line-bottom\" role=\"presentation\"></div>\n                            <div id=\"customIconContainer\" class=\"smart-hamburger-icon-custom-container smart-hidden\" role=\"presentation\"></div>\n                        </div>\n                    </div>\n                    <smart-repeat-button id=\"scrollButtonNear\" class=\"smart-menu-scroll-button smart-spin-button smart-scroll-button-near smart-hidden\" animation=\"[[animation]]\" unfocusable right-to-left=\"[[rightToLeft]]\">\n                        <div id=\"arrowNear\" class=\"smart-arrow\"></div>\n                    </smart-repeat-button>\n                    <div id=\"mainContainer\" class=\"smart-menu-main-container\">\n                        <content></content>\n                    </div>\n                    <smart-repeat-button id=\"scrollButtonFar\" class=\"smart-menu-scroll-button smart-spin-button smart-scroll-button-far smart-hidden\" animation=\"[[animation]]\" unfocusable right-to-left=\"[[rightToLeft]]\">\n                        <div id=\"arrowFar\" class=\"smart-arrow\"></div>\n                    </smart-repeat-button>\n                </div>";
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;

      if ((_get(_getPrototypeOf(_class66.prototype), "attached", this).call(this), !("tree" === e._element || Smart.ListMenu && e instanceof Smart.ListMenu)) && e.isCompleted && e.isRendered && null !== e.dropDownAppendTo) {
        if (e._minimized) e._dropDownParent.appendChild(e.$.mainContainer);else for (var _t624 = 0; _t624 < e._containersInBody.length; _t624++) {
          e._dropDownParent.appendChild(e._containersInBody[_t624]);
        }
        "dropDown" === e.mode && (e._dropDownParent === e.parentElement ? e._dynamicallyReparented ? delete e._dynamicallyReparented : e._positionRelativeTo = null : (e._positionRelativeTo = e.parentElement, e._dynamicallyReparented = !0, setTimeout(function () {
          e._dropDownParent.appendChild(e);
        }, 0)));
      }
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;

      _get(_getPrototypeOf(_class66.prototype), "detached", this).call(this);

      "tree" === e._element || Smart.ListMenu && e instanceof Smart.ListMenu || (e._close(), null !== e.dropDownAppendTo && (e._minimized ? e._dropDownParent.removeChild(e.$.mainContainer) : e._removeContainersInBody()));
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class66.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e._element = "menu", e._edgeMacFF = Smart.Utilities.Core.Browser.Edge || Smart.Utilities.Core.Browser.Firefox && -1 !== navigator.platform.toLowerCase().indexOf("mac"), e._containers = [], e._containersInBody = [], e._openedContainers = [], e._containersFixedHeight = [], e._menuItemsGroupsToExpand = [], e._additionalScrollButtons = [], e._createElement(), _get(_getPrototypeOf(_class66.prototype), "render", this).call(this);
    }
  }, {
    key: "addItem",
    value: function addItem(e, t) {
      var i = this;
      if (!(e instanceof Smart.MenuItem || e instanceof Smart.MenuItemsGroup)) return;
      var a, n;
      if (void 0 === t) t = i.$.mainContainer, a = 1, n = t;else {
        if (t = i.getItem(t), !1 == t instanceof Smart.MenuItemsGroup) return;
        a = t.level + 1, n = t.itemContainer;
      }

      if (i._createItemHTMLStructure(e, a, t, n.childElementCount, 0), e instanceof Smart.MenuItemsGroup && (i._processHTML(e, a + 1), i._checkContainersLength()), n.appendChild(e), i._checkOverflowAddRemove(e.level, n), e instanceof Smart.MenuItemsGroup && ("tree" === i.mode || i._minimized)) {
        var _t625 = e.getElementsByClassName("smart-menu-items-group-arrow");

        for (var _e703 = 0; _e703 < _t625.length; _e703++) {
          _t625[_e703].className = "smart-menu-items-group-arrow down smart-arrow-down";
        }

        i._expandItemsByDefault();
      }
    }
  }, {
    key: "checkItem",
    value: function checkItem(e) {
      var t = this;
      e = t.getItem(e);
      void 0 === e || e.checked || e.disabled || e.templateApplied || t._toggleItem(e);
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = this;
      e.$.mainContainer.innerHTML = "", e._removeContainersInBody(), e._menuItems = {}, e._containers = [], e._containersInBody = [], e._openedContainers = [], e._containersFixedHeight = [], e._menuItemsGroupsToExpand = [], e._additionalScrollButtons = [];
    }
  }, {
    key: "close",
    value: function close() {
      var e = this;

      if (!("dropDown" !== e.mode || !1 === e.opened && e.$.hasClass("smart-visibility-hidden"))) {
        var _t626 = e.$.fireEvent("closing", arguments[0] || {
          trigger: "programmatic"
        });

        _t626.defaultPrevented ? e.opened = !0 : (e.opened = !1, e.$.addClass("smart-visibility-hidden"), e._close(), e.$.fireEvent("close"));
      }
    }
  }, {
    key: "collapseItem",
    value: function collapseItem(e, t) {
      var i = this,
          a = i.animation,
          n = !1 === t && i.hasAnimation;
      if (void 0 === e) return n && (i.animation = "none"), i._close(), void (n && setTimeout(function () {
        i.animation = a;
      }, 0));

      if (e = i.getItem(e), !(void 0 === e || e instanceof Smart.MenuItem)) {
        var _t627 = e.level;

        if (i._openedContainers[_t627 + 1] && i._isContainerOpened(_t627 + 1, e.container)) {
          var _o214 = i.mode;
          n && (i.animation = "none"), i._closeSubContainers(_t627 + 1, e.container, void 0, !1 !== arguments[2]), (1 === _t627 || "tree" === _o214) && i._checkOverflow(i.$.mainContainer, "horizontal" === _o214, [i.$.scrollButtonNear, i.$.scrollButtonFar]), n && (i.animation = a);
        }
      }
    }
  }, {
    key: "expandItem",
    value: function expandItem(e, t) {
      var a = this;
      if (e = a.getItem(e), void 0 === e || e instanceof Smart.MenuItemsGroup && a._isContainerOpened(e.level + 1, e.container) && a._isBranchExpanded(e)) return;
      var n = [e],
          i = a.animation,
          o = !1 === t && a.hasAnimation;
      var r = e.parentItem;

      for (o && (a.animation = "none"), a._discardKeyboardHover(); r;) {
        n.unshift(r), r = r.parentItem;
      }

      for (var _o215 = 0; _o215 < n.length; _o215++) {
        var _e704 = n[_o215];

        if (_o215 == n.length - 1 && _e704 instanceof Smart.MenuItem) {
          _e704.disabled || _e704.templateApplied || a._hoverViaKeyboard(_e704);
          break;
        }

        a._isContainerOpened(_e704.container.level, _e704.container) || a._menuItemsGroupSelectionHandler(_e704, {
          target: _e704,
          type: "expand",
          isTrusted: !0
        }, arguments[2]);
      }

      o && (a.animation = i);
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      var t = this;
      var i;

      if ("string" == typeof e) {
        if (/^[0-9]*([.]?[0-9]*)*$/gm.test(e)) return t._menuItems[e];
        if (i = t.$.mainContainer.querySelector("[id=\"" + e + "\""), null === i) return t._menuItems[e];
      } else {
        if (!isNaN(e)) return t._menuItems[e.toString()];
        i = e;
      }

      return (i instanceof Smart.MenuItem || i instanceof Smart.MenuItemsGroup) && (t.contains(i) || t.$.mainContainer.contains(i) || i.parentElement.parentElement.ownerElement === t) ? i : void 0;
    }
  }, {
    key: "maximize",
    value: function maximize() {
      var e = this;
      if (!e._minimized) return;
      var t = e.animation;

      if (e.$.mainContainer.style.marginTop = "", e.$.mainContainer.style.marginLeft = "", e.enableShadowDOM && !e.$.mainContainer.id && (e.$.mainContainer.id = e.$.mainContainer.getAttribute("smart-id")), "none" !== t && (e.animation = "none"), e._positionDetection.removeOverlay(), e._closeSubContainers(2), e.$minimizedHeader.addClass("smart-hidden"), e._minimized = !1, e._minimizedDropDownOpened && (e.$hamburgerIcon.removeClass("smart-close-button"), e._minimizedDropDownOpened = !1), null !== e.dropDownAppendTo && e._appendMinimizedContainerToMenu(e.$.mainContainer, e.$.scrollButtonFar), "tree" !== e.mode) {
        e.$mainContainer.addClass("smart-menu-main-container"), e.$mainContainer.removeClass("smart-menu-minimized-items-container");

        var _t628 = e.$.mainContainer.getElementsByClassName("smart-menu-items-group-arrow");

        for (var _a393 = 0; _a393 < _t628.length; _a393++) {
          e._setArrowDirection(_t628[_a393], _t628[_a393].parentElement.parentElement.level + 1);
        }

        null !== e.dropDownAppendTo && e._moveDropDownsToExternalContainer(), e._applyContainerFixedHeight();
      }

      e.$mainContainer.removeClass("smart-visibility-hidden"), e.$hamburgerIcon.addClass("smart-hidden"), e.removeAttribute("minimized"), e._checkOverflow(e.$.mainContainer, "horizontal" === e.mode, [e.$.scrollButtonNear, e.$.scrollButtonFar]), "none" !== t && setTimeout(function () {
        e.animation = t;
      }, 0), e.$.mainContainer.removeAttribute("drop-down"), e.$.hamburgerIcon.removeAttribute("aria-expanded"), e.$.mainContainer.removeAttribute("role"), e.$.mainContainer.removeAttribute("aria-orientation"), e.setAttribute("role", "menu"), e.setAttribute("aria-orientation", "horizontal" === e.mode ? "horizontal" : "vertical");
    }
  }, {
    key: "minimize",
    value: function minimize() {
      var e = this;
      if (e._minimized || "dropDown" === e.mode) return;
      e.$minimizedHeader.removeClass("smart-hidden");
      var t = null !== e.dropDownAppendTo,
          i = e.animation,
          a = e.hasAnimation;
      if (a && (e.animation = "none"), e._positionDetection.removeOverlay(), e._closeSubContainers(2), a && t && (e.animation = i), "tree" !== e.mode && (t && e._moveDropDownsToMenu(), e._removeContainerFixedHeight()), e._hideMainContainerScrollButtons(), e.$mainContainer.removeClass("smart-menu-main-container"), e.$mainContainer.addClass("smart-visibility-hidden"), e.enableShadowDOM && e.$.mainContainer.removeAttribute("id"), e._edgeMacFF && (e.$.mainContainer.style.left = "", e.$.mainContainer.style.top = "", e.$mainContainer.addClass("not-in-view")), e.$hamburgerIcon.removeClass("smart-hidden"), t && e._appendMinimizedContainerToExternalElement(e.$.mainContainer), setTimeout(function () {
        e.$mainContainer.addClass("smart-menu-minimized-items-container"), a && !t && (e.animation = i);
      }, 0), e._minimized = !0, e.setAttribute("minimized", ""), "tree" !== e.mode) for (var _t629 = 0; _t629 < e._containers.length; _t629++) {
        var _i631 = e._containers[_t629];
        2 < _i631.level && e._setArrowDirection(_i631.menuItemsGroup.children[0].children[1], _i631.level);
      }
      e.$.mainContainer.setAttribute("drop-down", ""), e.removeAttribute("role"), e.removeAttribute("aria-orientation"), e.$.mainContainer.setAttribute("role", "menu"), e.$.mainContainer.setAttribute("aria-orientation", "vertical");
    }
  }, {
    key: "open",
    value: function open(e, t) {
      var i = Math.max;
      var a = this;
      if ("dropDown" !== a.mode) return;
      var n = a.$.fireEvent("opening");
      if (n.defaultPrevented) return void (a.opened = !1);
      var o;

      if (a.opened = !0, a._positionRelativeTo) {
        var _i632 = a._positionRelativeTo.getBoundingClientRect();

        e += _i632.left, t += _i632.top, a._positionedParent ? (o = a._positionedParent.getBoundingClientRect(), e -= o.left, t -= o.top) : (e += window.pageXOffset, t += window.pageYOffset);
      }

      var r = e + a.offsetWidth - document.documentElement.clientWidth,
          l = t + a.offsetHeight - document.documentElement.clientHeight;
      o ? (r += o.left, l += o.top) : (r -= window.pageXOffset, l -= window.pageYOffset), 0 < r ? e -= r : o ? e = i(e, -o.left) : e = i(e, window.pageXOffset), 0 < l ? t -= l : o ? t = i(t, -o.top) : t = i(t, window.pageYOffset), a.style.right = "", isNaN(e) || (a.rightToLeft && (a.style.right = "initial"), a.style.left = e + "px"), isNaN(t) || (a.style.top = t + "px"), a.$.removeClass("smart-visibility-hidden"), a.$.fireEvent("open"), a.hasAnimation || a._noAutoFocus || a.focus();
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      var t = this;

      if (e = t.getItem(e), void 0 !== e) {
        var _i633 = e.parentElement;

        if (e instanceof Smart.MenuItemsGroup) {
          var _i634 = e.container;

          if (t._isContainerOpened(_i634.level, _i634) && t._closeSubContainers(_i634.level, _i634), 1 === e.level) {
            var _e705 = t._containersInBody.indexOf(_i634);

            -1 !== _e705 && (t._containersInBody.splice(_e705, 1), null !== t.dropDownAppendTo && "tree" !== t.mode && !t._minimized && t._dropDownParent.removeChild(_i634));
          }
        }

        _i633.removeChild(e), t._refreshContainersArrays(), t._menuItems = {}, t._refreshItemPaths(t.$.mainContainer, !0), t._checkOverflowAddRemove(e.level, _i633);
      }
    }
  }, {
    key: "uncheckItem",
    value: function uncheckItem(e) {
      var t = this;
      e = t.getItem(e);
      void 0 === e || !e.checked || e.disabled || e.templateApplied || t._toggleItem(e);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, a) {
      function i() {
        (null !== o.dropDownAppendTo || "tree" === o.mode) && o._checkOverflow(o.$.mainContainer, "horizontal" === o.mode, [o.$.scrollButtonNear, o.$.scrollButtonFar]);
      }

      function n(e, t, i) {
        i ? t.setAttribute(e, "") : t.removeAttribute(e);
      }

      _get(_getPrototypeOf(_class66.prototype), "propertyChangedHandler", this).call(this, e, t, a);

      var o = this;

      switch (e) {
        case "animation":
          o.$.mainContainer.setAttribute("animation", a), o._additionalScrollButtons.forEach(function (e) {
            e[0].animation = a, e[1].animation = a;
          }), null !== o._dropDownParent && o._containers.forEach(function (e) {
            e.setAttribute("animation", a);
          });
          break;

        case "checkable":
          "tree" === o.mode || o._minimized ? o._minimized && null !== o.dropDownAppendTo && n("checkable", o.$.mainContainer, a) : o._closeSubContainers(2), o._updateItemRoles();
          break;

        case "checkboxes":
          if (o._close(), null !== o.dropDownAppendTo) {
            for (var _e706 = 0; _e706 < o._containers.length; _e706++) {
              var _t630 = o._containers[_e706];
              n("checkboxes", _t630, a);
            }

            o._minimized && n("checkboxes", o.$.mainContainer, a);
          }

          o._updateItemRoles();

          break;

        case "checkMode":
          o._changeToRadioButtonMode(a, o.$.mainContainer), o._minimized && null !== o.dropDownAppendTo && o.$.mainContainer.setAttribute("check-mode", a), o._updateItemRoles();
          break;

        case "dataSource":
          {
            var _e707 = !1;

            o._minimized && (o.maximize(), _e707 = !0), o._removeContainersInBody(), o._containersInBody = [], o._menuItems = {}, o._processDataSource(), o._checkContainersLength(), _e707 ? o.minimize() : i(), o._expandItemsByDefault(), o._suppressResizeHandler = !0, setTimeout(function () {
              return delete o._suppressResizeHandler;
            }, 500);
            break;
          }

        case "dropDownAppendTo":
          {
            var _e708 = o._dropDownParent;
            if (o._positionDetection.getDropDownParent(), o._dropDownParent === _e708 || "tree" === o.mode && !o._minimized) return;
            if (o._close(), o._minimized) return void (null === a ? o._appendMinimizedContainerToMenu(o.$.mainContainer, o.$.scrollButtonFar) : o._appendMinimizedContainerToExternalElement(o.$.mainContainer));
            if (null !== o._dropDownParent && null === _e708) o._moveDropDownsToExternalContainer();else if (null === o._dropDownParent && null !== _e708) o._moveDropDownsToMenu();else if (null !== o._dropDownParent && null !== _e708) for (var _e709 = 0; _e709 < o._containersInBody.length; _e709++) {
              o._dropDownParent.appendChild(o._containersInBody[_e709]);
            }
            null !== a || o.$mainContainer.hasClass("simple") ? o._checkOverflow(o.$.mainContainer, "horizontal" === o.mode, [o.$.scrollButtonNear, o.$.scrollButtonFar]) : o._hideMainContainerScrollButtons();

            for (var _e710 = 0; _e710 < o._containersFixedHeight.length; _e710++) {
              o._containersFixedHeight[_e710].itemContainer.checkOverflow = !0;
            }

            "dropDown" === o.mode && (o.close({
              trigger: "internal"
            }), o._reparentMenu(!0, _e708));
            break;
          }

        case "dropDownOverlay":
          a || o._positionDetection.removeOverlay();
          break;

        case "disabled":
          a && o._close(), o._setFocusable(), o.$.scrollButtonNear.disabled = a, o.$.scrollButtonFar.disabled = a, !a && (null !== o.dropDownAppendTo || o.$mainContainer.hasClass("simple") || "tree" === o.mode) && o._updateScrollButtonVisibility(o.$.mainContainer, "horizontal" === o.mode, [o.$.scrollButtonNear, o.$.scrollButtonFar]);
          break;

        case "dropDownPosition":
        case "mode":
          {
            if ("mode" === e) {
              if (delete o._dynamicallyReparented, "tree" === t || o._minimized ? (o._closeSubContainersTreeMode(2, void 0, void 0, void 0, !0), o._openedContainers = []) : o._closeSubContainersDefaultMode(2), o._discardKeyboardHover(!0), o._minimized && o._minimizedDropDownOpened && (o.$mainContainer.addClass("smart-visibility-hidden"), o.$hamburgerIcon.removeClass("smart-close-button"), o.$.hamburgerIcon.removeAttribute("aria-expanded"), o._minimizedDropDownOpened = !1), ("horizontal" === a || "horizontal" === t) && o._changeScrollButtonsArrows(), o._minimized) return void ("dropDown" === a && (o.mode = t));
              o.setAttribute("aria-orientation", "horizontal" === o.mode ? "horizontal" : "vertical"), !1 === o.opened && ("dropDown" === a ? o.$.addClass("smart-visibility-hidden") : "dropDown" === t && o.$.removeClass("smart-visibility-hidden")), "tree" === t ? (null !== o.dropDownAppendTo && o._moveDropDownsToExternalContainer(), o.$mainContainer.addClass("smart-menu-main-container"), o.$mainContainer.removeClass("smart-menu-minimized-items-container"), o._applyContainerFixedHeight()) : "tree" === a && (null !== o.dropDownAppendTo && o._moveDropDownsToMenu(), o._applyTreeMode()), "auto" === o.overflow && o._hideMainContainerScrollButtons(), i();
            }

            if ("tree" === o.mode || o._minimized) return o._minimizedDropDownOpened && o._close(), void (o._minimized && null !== o.dropDownAppendTo && o.$.mainContainer.setAttribute(o.properties[e].attributeName, a));
            "dropDownPosition" === e && o._close();

            var _n308 = o.enableShadowDOM ? o.shadowRoot.querySelectorAll("smart-menu-items-group") : o.getElementsByTagName("smart-menu-items-group");

            for (var _e711 = 0; _e711 < _n308.length; _e711++) {
              var _t631 = _n308[_e711];

              o._setArrowDirection(_t631.children[0].children[1], _t631.level + 1);
            }

            if (null !== o.dropDownAppendTo) for (var _t632 = 0; _t632 < o._containers.length; _t632++) {
              var _i635 = o._containers[_t632];
              _i635.setAttribute(Smart.Utilities.Core.toDash(e), a), 2 < _i635.level && o._setArrowDirection(_i635.menuItemsGroup.children[0].children[1], _i635.level);
            }
            break;
          }

        case "minimizeIconTemplate":
          o._applyMinimizeIconTemplate(a, t);

          break;

        case "minimizeWidth":
          o._resizeHandler();

          break;

        case "opened":
          a ? o.open() : o.close({
            trigger: "internal"
          });
          break;

        case "overflow":
          o._handleOverflowChange();

          break;

        case "rightToLeft":
          {
            if ("tree" !== o.mode) {
              var _e712 = o.enableShadowDOM ? o.shadowRoot.querySelectorAll("smart-menu-items-group") : o.getElementsByTagName("smart-menu-items-group");

              for (var _t633 = 0; _t633 < _e712.length; _t633++) {
                var _i636 = _e712[_t633];

                o._setArrowDirection(_i636.children[0].children[1], _i636.level + 1);
              }

              if (null !== o.dropDownAppendTo) {
                a ? o.$.mainContainer.setAttribute("right-to-left", "") : o.$.mainContainer.removeAttribute("right-to-left");

                for (var _e713 = 0; _e713 < o._containers.length; _e713++) {
                  var _t634 = o._containers[_e713];
                  a ? _t634.setAttribute("right-to-left", "") : _t634.removeAttribute("right-to-left"), 2 < _t634.level && o._setArrowDirection(_t634.menuItemsGroup.children[0].children[1], _t634.level);
                }
              }
            }

            break;
          }

        case "theme":
          if (null === o.dropDownAppendTo || Smart.ListMenu && o instanceof Smart.ListMenu) return;
          if (o._minimized) "" !== t && o.$mainContainer.removeClass(t), "" !== a && o.$mainContainer.addClass(a);else for (var _e714 = 0; _e714 < o._containers.length; _e714++) {
            var _i637 = o._containers[_e714];
            "" !== t && _i637.classList.remove(t), "" !== a && _i637.classList.add(a);
          }
          break;

        case "unfocusable":
          o._setFocusable();

      }
    }
  }, {
    key: "_addOpenedContainer",
    value: function _addOpenedContainer(e, t) {
      var i = this;

      if ("tree" === i.mode || i._minimized) {
        i._openedContainers[e] || (i._openedContainers[e] = []);
        var _a394 = t.menuItemsGroup;
        return _a394.set("expanded", !0), _a394.setAttribute("aria-expanded", !0), i._updateState && i._updateState("expanded", _a394.id, !0), i._openedContainers[e].push(t);
      }

      i._openedContainers[e] = t;
    }
  }, {
    key: "_appendMinimizedContainerToExternalElement",
    value: function _appendMinimizedContainerToExternalElement(e) {
      var t = this;
      e.ownerElement = t, t._dropDownParent.appendChild(e), e.setAttribute("animation", t.animation), "" !== t.theme && e.$.addClass(t.theme), e.$.addClass("smart-menu-drop-down smart-drop-down"), e.$.addClass("smart-drop-down-repositioned"), e.setAttribute("check-mode", t.checkMode), e.setAttribute("drop-down-position", t.dropDownPosition), e.setAttribute("mode", t.mode), e.setAttribute("loading-indicator-position", t.loadingIndicatorPosition), t.rightToLeft && e.setAttribute("right-to-left", ""), t.checkable && e.setAttribute("checkable", ""), t.checkboxes && e.setAttribute("checkboxes", ""), t.$.view && t.detachedChildren.indexOf(t.$.view) && t.detachedChildren.push(t.$.view);
    }
  }, {
    key: "_appendMinimizedContainerToMenu",
    value: function _appendMinimizedContainerToMenu(e, t) {
      var i = this;
      delete e.ownerElement, i.$.container.insertBefore(e, t), e.removeAttribute("animation"), "" !== i.theme && e.$.removeClass(i.theme), e.$.removeClass("smart-menu-drop-down smart-drop-down"), e.$.removeClass("smart-drop-down-repositioned"), e.removeAttribute("checkable"), e.removeAttribute("checkboxes"), e.removeAttribute("check-mode"), e.removeAttribute("drop-down-position"), e.removeAttribute("mode"), e.removeAttribute("loading-indicator-position"), e.removeAttribute("style"), e.removeAttribute("right-to-left");
    }
  }, {
    key: "_applyContainerFixedHeight",
    value: function _applyContainerFixedHeight() {
      var e = this;

      for (var _t635 = 0; _t635 < e._containers.length; _t635++) {
        var _i638 = e._containers[_t635];
        -1 === e._containersFixedHeight.indexOf(_i638) ? _i638.style.height = "" : (_i638.style.height = _i638.menuItemsGroup.dropDownHeight + "px", _i638.itemContainer.checkOverflow = !0);
      }
    }
  }, {
    key: "_applyGrouping",
    value: function _applyGrouping(e, t) {
      var a = this;
      var n = e === a.$.mainContainer ? Array.from(e.children) : Array.from(e.container.firstElementChild.children);

      for (var _o216 = 0; _o216 < n.length; _o216++) {
        var _e715 = n[_o216];
        _e715.originalIndex = _o216, _e715 instanceof Smart.MenuItemsGroup && t === void 0 && a._applyGrouping(_e715);
      }

      a._sortItems(e);
    }
  }, {
    key: "_applyMinimizeIconTemplate",
    value: function _applyMinimizeIconTemplate(e, t) {
      var i = this;

      if (null === e) {
        if (null === t) return;
        i.$customIconContainer.addClass("smart-hidden"), i.$.customIconContainer.innerHTML = "", i.$hamburgerIconLineTop.removeClass("smart-hidden"), i.$hamburgerIconLineCenter.removeClass("smart-hidden"), i.$hamburgerIconLineBottom.removeClass("smart-hidden");
      } else {
        var _a395 = document.getElementById(e);

        if (null !== _a395 && "template" === _a395.tagName.toLowerCase()) {
          var _e716 = document.importNode(_a395.content, !0);

          i.$hamburgerIconLineTop.addClass("smart-hidden"), i.$hamburgerIconLineCenter.addClass("smart-hidden"), i.$hamburgerIconLineBottom.addClass("smart-hidden"), i.$.customIconContainer.innerHTML = "", i.$.customIconContainer.appendChild(_e716), i.$customIconContainer.removeClass("smart-hidden");
        } else i.minimizeIconTemplate = t;
      }
    }
  }, {
    key: "_applyTreeMode",
    value: function _applyTreeMode() {
      var e = this,
          t = e.$.mainContainer.getElementsByClassName("smart-menu-items-group-arrow");
      if (e.$mainContainer.removeClass("smart-menu-main-container"), e.$mainContainer.addClass("smart-menu-minimized-items-container"), e.isCompleted && e.isRendered) for (var _e717 = 0; _e717 < t.length; _e717++) {
        t[_e717].className = "smart-menu-items-group-arrow down";
      }

      e._removeContainerFixedHeight();
    }
  }, {
    key: "_arrowLeftHandler",
    value: function _arrowLeftHandler(e, t, i, a) {
      var n = this;
      1 === e ? "horizontal" === t && n._levelOneNavigate("_getLastEnabledChild", i, a) : 2 === e ? n._levelOneNavigateFromLowerLevel("_getPreviousEnabledChild", i) : n._escapeHandler(i, e, a);
    }
  }, {
    key: "_arrowRightHandler",
    value: function _arrowRightHandler(e, t, i, a) {
      var n = this;
      1 === e ? "horizontal" === t ? n._levelOneNavigate("_getFirstEnabledChild", i, a) : n._levelOneOpenDropDown(i) : i instanceof Smart.MenuItemsGroup ? n._selectionHandler({
        target: i,
        isTrusted: !0
      }) : n._levelOneNavigateFromLowerLevel("_getNextEnabledChild", i);
    }
  }, {
    key: "_browserBoundsDetection",
    value: function _browserBoundsDetection(e) {
      var t = Math.min;
      var i = this;

      if (("tree" !== i.mode || i._minimized) && (e.style.marginTop = "", e.style.marginLeft = "", "auto" === i.dropDownPosition)) {
        var _i639 = 1 === window.devicePixelRatio ? document.documentElement.clientWidth : window.innerWidth,
            _a396 = 1 === window.devicePixelRatio ? document.documentElement.clientHeight : window.innerHeight,
            _n309 = e.getBoundingClientRect(),
            _o217 = _i639 - _n309.left - e.offsetWidth,
            _r137 = _a396 - _n309.top - e.offsetHeight;

        10 > _o217 && (e.style.marginLeft = t(_o217 - 10, -10) + "px"), 10 > _r137 && (e.style.marginTop = t(_r137 - 10, -10) + "px");
      }
    }
  }, {
    key: "_changeScrollButtonsArrows",
    value: function _changeScrollButtonsArrows() {
      var e = this;
      "horizontal" === e.mode ? (e.$arrowNear.removeClass("smart-arrow-up"), e.$arrowFar.removeClass("smart-arrow-down"), e.$arrowNear.addClass("smart-arrow-left"), e.$arrowFar.addClass("smart-arrow-right")) : (e.$arrowNear.removeClass("smart-arrow-left"), e.$arrowFar.removeClass("smart-arrow-right"), e.$arrowNear.addClass("smart-arrow-up"), e.$arrowFar.addClass("smart-arrow-down"));
    }
  }, {
    key: "_changeToRadioButtonMode",
    value: function _changeToRadioButtonMode(e, t, i) {
      if ("radioButton" === e) {
        var _e718 = [];

        for (var _a397 = 0; _a397 < t.childElementCount; _a397++) {
          var _i640 = t.children[_a397];
          !_i640.checked || _i640.disabled || _i640.templateApplied || _e718.push(_i640);
        }

        this._validateRadioButtonSelection(i, i ? i.level + 1 : 1, _e718);
      }
    }
  }, {
    key: "_checkContainersLength",
    value: function _checkContainersLength(e) {
      var t = this;
      0 === t._containers.length ? (t.$mainContainer.addClass("simple"), !e && t._checkOverflow(t.$.mainContainer, "horizontal" === t.mode, [t.$.scrollButtonNear, t.$.scrollButtonFar])) : !e && (t.$mainContainer.removeClass("simple"), null === t.dropDownAppendTo && "tree" !== t.mode && t.$mainContainer.removeClass("scroll-buttons-shown one-button-shown"));
    }
  }, {
    key: "_checkOverflow",
    value: function _checkOverflow(e, t, i) {
      var a = Math.round;
      var n = this,
          o = e === n.$.mainContainer ? n.overflow : "auto";
      if (n._minimized || "hidden" === o || null === n.dropDownAppendTo && "tree" !== n.mode && e === n.$.mainContainer && !n.$mainContainer.hasClass("simple")) return;
      var r = e.scrollTop;
      "auto" === o && (e.classList.remove("scroll-buttons-shown"), e.classList.remove("one-button-shown"), i[0].$.addClass("smart-hidden"), i[1].$.addClass("smart-hidden"));
      var l, s, d;
      t ? (l = a(e.scrollWidth) > a(e.offsetWidth), s = 0 < a(e.scrollLeft), d = a(e.offsetWidth + e.scrollLeft) < a(e.scrollWidth)) : (l = a(e.scrollHeight) > a(e.offsetHeight), s = 0 < a(e.scrollTop), d = a(e.offsetHeight + e.scrollTop) < a(e.scrollHeight)), l ? "auto" === o ? (e.classList.add("scroll-buttons-shown"), s && i[0].$.removeClass("smart-hidden"), d && i[1].$.removeClass("smart-hidden"), !1 === (s && d) && e.classList.add("one-button-shown"), !n.disabled && (i[0].disabled = !1, i[1].disabled = !1), e.scrollTop = r) : (i[0].$.removeClass("smart-hidden"), i[1].$.removeClass("smart-hidden"), n.disabled ? (i[0].disabled = !0, i[1].disabled = !0) : (i[0].disabled = !s, i[1].disabled = !d)) : "scroll" === o && (i[0].disabled = !0, i[1].disabled = !0), e === n.$.mainContainer && "tree" !== n.mode && n._close();
    }
  }, {
    key: "_checkOverflowAddRemove",
    value: function _checkOverflowAddRemove(e, t) {
      var i = this;
      1 === e && null !== i.dropDownAppendTo || "tree" === i.mode ? i._checkOverflow(i.$.mainContainer, "horizontal" === i.mode, [i.$.scrollButtonNear, i.$.scrollButtonFar]) : 1 < e && t.dropDownHeightSet && (i._isContainerOpened(e, t.container) ? i._checkOverflow(t, !1, [t.container.children[0], t.container.children[2]]) : t.checkOverflow = !0);
    }
  }, {
    key: "_close",
    value: function _close() {
      var e = this;
      e._positionDetection.removeOverlay(), e._closeSubContainers(2), e._discardKeyboardHover(!0), e._minimized && e._minimizedDropDownOpened && (e.$mainContainer.addClass("smart-visibility-hidden"), e._edgeMacFF && (e.$.mainContainer.style.left = "", e.$.mainContainer.style.top = "", e.$mainContainer.addClass("not-in-view")), e.$hamburgerIcon.removeClass("smart-close-button"), e.$.hamburgerIcon.removeAttribute("aria-expanded"), e._minimizedDropDownOpened = !1);
    }
  }, {
    key: "_closeSubContainers",
    value: function _closeSubContainers(e, t, i, a) {
      var n = this;
      "tree" === n.mode || n._minimized ? n._closeSubContainersTreeMode(e, t, i, a) : n._closeSubContainersDefaultMode(e, t, i);
    }
  }, {
    key: "_closeSubContainersDefaultMode",
    value: function _closeSubContainersDefaultMode(e, t, a) {
      function n(t) {
        var i = r[t].menuItemsGroup;
        a && t === e || (i.$.removeClass("focus"), i.removeAttribute("focus"), i.$.removeClass("hover"), i.removeAttribute("hover")), i.$.removeClass("smart-menu-items-group-opened"), i.$.removeClass("smart-menu-items-group-expanded"), i.setAttribute("aria-expanded", !1), r[t].$.addClass("smart-visibility-hidden"), o._edgeMacFF && 2 === t && !o.hasAnimation && (r[t].style.left = "", r[t].style.top = "", r[t].$.addClass("not-in-view")), o._minimized && o._browserBoundsDetection(o.$.mainContainer), o.$.fireEvent("collapse", {
          item: i,
          label: i.label,
          path: i.path,
          value: i.value,
          children: i.itemContainer.children
        }), r[t] = void 0;
      }

      var o = this,
          r = o._openedContainers;

      for (var _o218 = r.length - 1; _o218 >= e; _o218--) {
        void 0 !== r[_o218] && n(_o218, !0);
      }
    }
  }, {
    key: "_closeSubContainersTreeMode",
    value: function _closeSubContainersTreeMode(e, t, i, a, n) {
      var o = this;

      if (a) {
        var _e719 = t.menuItemsGroup,
            _i641 = o.$.fireEvent("collapsing", {
          item: _e719,
          label: _e719.label,
          path: _e719.path,
          value: _e719.value,
          children: t.itemContainer.children
        });

        if (_i641.defaultPrevented) return;
      }

      if (void 0 === t) return void o._collapseAll(!1, n);
      var r = t.menuItemsGroup;
      if (r.set("expanded", !1), r.setAttribute("aria-expanded", !1), "menu" !== o._element) o._updateState("expanded", r.id, !1);else if (i) {
        var _e720 = o.$.mainContainer.getElementsByClassName("focus")[0];
        _e720 && (_e720.$.removeClass("focus"), _e720.removeAttribute("focus")), r.$.addClass("focus"), r.setAttribute("focus", ""), o._focusedViaKeyboard = r;
      } else r.$.removeClass("focus"), r.removeAttribute("focus");

      if (r.$.removeClass("smart-" + o._element + "-items-group-opened"), n || !o.hasAnimation ? (r.$.removeClass("smart-" + o._element + "-items-group-expanded"), r.setAttribute("aria-expanded", !1), t.$.addClass("smart-visibility-hidden"), o._minimized && o._browserBoundsDetection(o.$.mainContainer)) : o._collapseSection(t), a) {
        var _e721 = {
          item: r,
          label: r.label,
          path: r.path,
          value: r.value,
          children: r.itemContainer.children
        };
        o.toggleCallback ? (_e721.type = "collapse", o.toggleCallback(_e721)) : o.$.fireEvent("collapse", _e721);
      }

      if (o._openedContainers[e]) {
        var _i642 = o._openedContainers[e].indexOf(t);

        -1 !== _i642 && o._openedContainers[e].splice(_i642, 1);
      }
    }
  }, {
    key: "_collapseAll",
    value: function _collapseAll(e, t) {
      var a = this;

      for (var _n310 = a._openedContainers.length - 1; 2 <= _n310 && !(a._openedContainers[_n310] === void 0); _n310--) {
        for (var _i643 = a._openedContainers[_n310].length - 1; 0 <= _i643; _i643--) {
          a._closeSubContainersTreeMode(_n310, a._openedContainers[_n310][_i643], void 0, e, t);
        }
      }

      a.hasAnimation || a._checkOverflow(a.$.mainContainer, !1, [a.$.scrollButtonNear, a.$.scrollButtonFar]);

      for (var _n311 = a._openedContainers.length - 1; 2 <= _n311; _n311--) {
        var _e722 = a._openedContainers[_n311];
        if (_e722 === void 0 || 0 === _e722.length) a._openedContainers.splice(_n311, 1);else break;
      }

      2 === a._openedContainers.length && (a._openedContainers = []);
    }
  }, {
    key: "_collapseSection",
    value: function _collapseSection(e) {
      var t = this,
          i = e.scrollHeight + "px";
      t._treeAnimationInProgress = e, e.style.transition = "none", requestAnimationFrame(function () {
        return "tree" === t.mode || t._minimized ? void (e.style.height = i, e.style.transition = "", requestAnimationFrame(function () {
          e.style.height = "0px", "smart-tree" === t.tagName.toLowerCase() && e.$.addClass("smart-visibility-hidden"), "0px" == i && t._transitionendHandlerCollapse(t, e);
        })) : void (e.style.transition = "");
      }), e.addEventListener("transitionend", t._transitionendHandlerCollapse);
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this,
          t = e.mode;
      e.setAttribute("role", "menu"), e.setAttribute("aria-orientation", "horizontal" === e.mode ? "horizontal" : "vertical"), e._positionDetection = new Smart.Utilities.PositionDetection(e), e._positionDetection.getDropDownParent(), e._reparentMenu(), e.disabled && (e.$.scrollButtonNear.disabled = !0, e.$.scrollButtonFar.disabled = !0), null === e.dataSource && e.$.mainContainer.firstElementChild instanceof HTMLUListElement && e._processUList();

      var i = (e.shadowRoot || e).querySelectorAll("smart-menu-item, smart-menu-items-group"),
          a = function a() {
        var i = e.animation;
        e._changeScrollButtonsArrows(), e._setFocusable(), "dropDown" === t && !1 === e.opened && (e.hasAnimation ? (e.animation = "none", e.$.addClass("smart-visibility-hidden"), e.animation = i) : e.$.addClass("smart-visibility-hidden")), e._menuItems = {}, e.$.mainContainer.setAttribute("animation", i), null === e.dataSource ? e._processHTML(e.$.mainContainer, 1) : e._processDataSource(), e._checkContainersLength(!0), (null !== e.dropDownAppendTo || e.$mainContainer.hasClass("simple") || "tree" === e.mode) && "scroll" === e.overflow && (e.$mainContainer.addClass("scroll-buttons-shown"), e.$scrollButtonNear.removeClass("smart-hidden"), e.$scrollButtonFar.removeClass("smart-hidden"), e._updateScrollButtonVisibility(e.$.mainContainer, "horizontal" === t, [e.$.scrollButtonNear, e.$.scrollButtonFar])), e._applyMinimizeIconTemplate(e.minimizeIconTemplate, null), "tree" === t && e._applyTreeMode(), null !== e.minimizeWidth && e.offsetWidth <= e.minimizeWidth ? e.minimize() : e._checkOverflow(e.$.mainContainer, "horizontal" === t, [e.$.scrollButtonNear, e.$.scrollButtonFar]), e._expandItemsByDefault(), e.__onCompleted && (e._onCompleted = e.__onCompleted, e.__onCompleted = null, e._onCompleted());
      };

      0 === i.length || e.enableShadowDOM || e.isInShadowDOM ? a() : (e._onCompleted && (e.__onCompleted = e._onCompleted, e._onCompleted = null), e._ensureItemsReady(i, a));
    }
  }, {
    key: "_ensureItemsReady",
    value: function _ensureItemsReady(e, t) {
      var a = this,
          i = function i() {
        var i = function i(t) {
          for (var _a398 = 0; _a398 < e.length; _a398++) {
            e[_a398].context = "node" === t ? e[_a398] : document;
          }
        };

        i("node"), t(), i();
      };

      if (0 === e.length) i();else {
        a._nodesReadyListeners = 0;

        for (var _t636 = 0; _t636 < e.length; _t636++) {
          var _n312 = e[_t636],
              _o219 = function () {
            var e = a.context;
            a.context = a, a._nodesReadyListeners--, 0 === a._nodesReadyListeners && (i(), delete a._nodesReadyListeners), a.context = e;
          }.bind(a);

          _n312.isCompleted || (a._nodesReadyListeners++, _n312.completeHandlers = [], _n312._onCompleted = _o219);
        }

        0 === a._nodesReadyListeners && i();
      }
    }
  }, {
    key: "_createItemHTMLStructure",
    value: function _createItemHTMLStructure(e, t, i, a) {
      var n = this,
          o = document.createElement("div"),
          r = document.createElement("div"),
          l = document.createDocumentFragment();
      var s;
      e.menu = n, 1 < t ? (e.originalIndex = a, s = i.path + "." + e.originalIndex, e.parentItem = i, n.checkboxes && i.checkable && ("checkbox" === i.checkMode ? e.setAttribute("role", "menuitemcheckbox") : e.setAttribute("role", "menuitemradio"))) : (e.originalIndex = a, s = "" + a, n.checkboxes && n.checkable && ("checkbox" === n.checkMode ? e.setAttribute("role", "menuitemcheckbox") : e.setAttribute("role", "menuitemradio"))), e.path = s, n._menuItems[s] = e, o.className = "smart-" + n._element + "-item-label-container", r.className = "smart-" + n._element + "-item-label-element", "tree" === n._element && n._setIndentation(o, t, n.rightToLeft ? "paddingRight" : "paddingLeft");
      var d = Array.from(e.childNodes);

      for (var _n313 = 0; _n313 < d.length; _n313++) {
        var _e723 = d[_n313];
        if (_e723 instanceof Smart.MenuItem || _e723 instanceof Smart.MenuItemsGroup) break;
        r.appendChild(_e723);
      }

      if ("" === r.innerHTML.trim()) {
        var _t637 = e.label || e.getAttribute("label");

        _t637 && "" !== _t637 ? n._setLabel(_t637, r, e, !0) : (e.set("label", "Item " + a), r.innerHTML = "Item " + a);
      } else e.set("label", r.innerHTML.trim());

      if (e instanceof Smart.MenuItemsGroup && void 0 === e.titleLabel && (e.titleLabel = e.label), r.innerHTML = "<span>" + r.innerHTML + "</span>", l.appendChild(r), e.set("level", t), e.set("shortcut", e.shortcut || e.getAttribute("shortcut") || ""), e.shortcut && e instanceof Smart.MenuItem) {
        var _t638 = document.createElement("div");

        _t638.className = "smart-" + n._element + "-item-shortcut", _t638.innerHTML = e.shortcut, l.appendChild(_t638);
      }

      o.appendChild(l), e.insertBefore(o, e.children[0]), e.id || (e.id = n.id + "ItemP" + e.path.replace(/\./g, "_") + "L" + e.label.replace(/[^a-zA-Z0-9\-\_]/g, ""));
    }
  }, {
    key: "_createMenuItemsGroupContainer",
    value: function _createMenuItemsGroupContainer(e, t) {
      var i = this,
          a = document.createElement("div"),
          n = document.createElement("div");

      if (a.className = "smart-" + i._element + "-drop-down smart-visibility-hidden", i._edgeMacFF && 2 === t && "tree" !== i.mode && (a.className += " not-in-view"), a.$ = Smart.Utilities.Extend(a), a.level = t, a.setAttribute("level", t), "menu" === i._element ? a.setAttribute("role", "menu") : a.setAttribute("role", "group"), a.menuItemsGroup = e, n.className = "smart-" + i._element + "-item-container", n.$ = Smart.Utilities.Extend(n), n.container = a, n.menuItemsGroup = e, e.checkable && n.setAttribute("checkable", ""), n.setAttribute("check-mode", e.checkMode), a.itemContainer = n, a.appendChild(n), null !== e.dropDownHeight) {
        var _t639 = document.createElement("smart-repeat-button"),
            _o220 = document.createElement("smart-repeat-button");

        _t639.className = "smart-menu-scroll-button smart-spin-button smart-scroll-button-near smart-hidden", _t639.innerHTML = "<div id=\"arrowNear\" class=\"smart-arrow smart-arrow-up\"></div>", _t639.animation = i.animation, _t639.unfocusable = !0, _t639.rightToLeft = i.rightToLeft, _o220.className = "smart-menu-scroll-button smart-spin-button smart-scroll-button-far smart-hidden", _o220.innerHTML = "<div id=\"arrowNear\" class=\"smart-arrow smart-arrow-down\"></div>", _o220.animation = i.animation, _o220.unfocusable = !0, _o220.rightToLeft = i.rightToLeft, a.insertBefore(_t639, n), a.appendChild(_o220), a.$.addClass("drop-down-height-set"), n.dropDownHeightSet = !0, n.checkOverflow = !0, a.style.height = e.dropDownHeight + "px", i._containersFixedHeight.push(a), i._additionalScrollButtons.push([_t639, _o220]);
      }

      return a;
    }
  }, {
    key: "_discardKeyboardHover",
    value: function _discardKeyboardHover(e) {
      var t = this;
      !t._focusedViaKeyboard || !e && t._focusedViaKeyboard instanceof Smart.MenuItemsGroup && t._isContainerOpened(t._focusedViaKeyboard.level + 1, t._focusedViaKeyboard.container) || (t._focusedViaKeyboard.$.removeClass("focus"), t._focusedViaKeyboard.removeAttribute("focus"), t._focusedViaKeyboard.$.removeClass("hover"), t._focusedViaKeyboard.removeAttribute("hover"), t._focusedViaKeyboard = void 0);
    }
  }, {
    key: "_documentDownHandler",
    value: function _documentDownHandler(e) {
      var t = this;
      "down" === t.closeAction && t._closeOnDocumentInteraction(e.originalEvent);
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = e.originalEvent.target;
      if (t.disabled || t.displayLoadingIndicator || !i.closest) return;

      var a = "up" === t.closeAction && t._closeOnDocumentInteraction(e.originalEvent);

      if (a) return;
      var n, o;

      if (Smart.EnableShadowDOM ? (n = t.isInShadowDOM ? t.getRootNode().activeElement : t.shadowRoot ? t.shadowRoot.activeElement || document.activeElement : document.activeElement, o = t.$.container.contains(e.originalEvent.composedPath()[0])) : (n = document.activeElement, o = t.contains(i)), !a && t !== n && null === n.closest("[template-applied]")) {
        if (o || i.closest(".smart-list-menu-view") === t.$.view) return void t.focus();

        var _e724 = i.closest(".smart-drop-down-repositioned");

        _e724 && _e724.ownerElement === t && t.focus();
      }
    }
  }, {
    key: "_closeOnDocumentInteraction",
    value: function _closeOnDocumentInteraction(e) {
      var t = this,
          i = e.target;
      var a, n;

      if (Smart.EnableShadowDOM ? (a = e.composedPath()[0], n = t.$.container.contains(a)) : n = t.contains(i), "dropDown" === t.mode && t.opened) {
        var _e725 = i.closest(".smart-drop-down-repositioned");

        if (!n && (!_e725 || _e725.ownerElement !== t)) return t.close({
          trigger: "interaction",
          target: Smart.EnableShadowDOM ? a : i
        }), !0;
      }

      return !n && null === i.closest(".smart-menu-drop-down") || a && a === t.$.mainContainer || i === t.$.mainContainer ? "tree" === t.mode || (t._close(), !0) : void 0;
    }
  }, {
    key: "_endSwiping",
    value: function _endSwiping(e, t, i) {
      var a = Math.abs;
      var n = this;
      if (!n._dragStartDetails) return;
      var o = n.$.mainContainer,
          r = a(n._dragStartDetails.startTime - t),
          l = 300 / r,
          s = (n._dragStartDetails.startY - e.pageY) * l;
      var d = a(s);

      var c = function c() {
        return !(0 < s && o.scrollTop === o.scrollHeight - o.offsetHeight || 0 > s && 0 === o.scrollTop);
      };

      var m = .03 * a(s) * l;

      var u = function u() {
        if (5 < m) {
          var _e726 = (d - m) / a(s);

          .1 > _e726 ? m /= 1.25 : .15 > _e726 ? m /= 1.2 : .2 > _e726 ? m /= 1.15 : .25 > _e726 ? m /= 1.1 : .3 > _e726 && (m /= 1.05);
        }

        var e = o.scrollTop;
        o.scrollTop = 0 < s ? Math.min(e + m, o.scrollHeight - o.offsetHeight) : Math.max(e - m, 0), d -= m, n._updateScrollButtonVisibility(n.$.mainContainer, "horizontal" === n.mode, [n.$.scrollButtonNear, n.$.scrollButtonFar]);
        var t = c();
        if (0 < d && t) n._scrollingAnimationFrame = window.requestAnimationFrame(u);else if (n._wheelInProgress = !1, !t && (n._fireScrollBottomReachedEvent && n._fireScrollBottomReachedEvent(e), !0 !== i)) {
          var _e727 = n.$.mainContainer.scrollTop;
          0 === _e727 ? n._bounceTop() : n._bounceBottom(_e727);
        }
      };

      n._scrollingAnimationFrame && cancelAnimationFrame(n._scrollingAnimationFrame), 1e3 > r && c() ? n._scrollingAnimationFrame = window.requestAnimationFrame(u) : n._wheelInProgress = !1, delete n._dragStartDetails;
    }
  }, {
    key: "_ensureVisible",
    value: function _ensureVisible(e) {
      function t(t, i, a) {
        var n = e.firstElementChild[a] + t - o[a];
        0 > n && (n = t), o["scroll" + i] = n;
      }

      function i(i, n) {
        var l = e["offset" + i],
            s = o[n];
        "Top" !== i || o === a.$.mainContainer || r[0].$.hasClass("smart-hidden") || (l -= r[0][n]), t(l, i, n), a._updateScrollButtonVisibility(o, "Left" === i, r), s !== o[n] && t(l, i, n);
      }

      var a = this;
      if (a._minimized) return;
      var n = a.mode;
      var o, r;

      if ("tree" !== n && e.parentElement !== a.$.mainContainer) {
        if (null === e.dropDownHeight) return;
        o = e.parentElement, r = [o.container.children[0], o.container.children[2]];
      } else o = a.$.mainContainer, r = [a.$.scrollButtonNear, a.$.scrollButtonFar];

      if (o !== a.$.mainContainer || (null !== a.dropDownAppendTo || "tree" === a.mode || a.$mainContainer.hasClass("simple")) && (o.$.hasClass("scroll-buttons-shown") || "hidden" === a.overflow)) {
        var _t640 = o.getBoundingClientRect(),
            _r138 = e.getBoundingClientRect();

        return "tree" === n ? void a._ensureVisibleTreeMode(e, _r138, o, _t640, 0) : void (o === a.$.mainContainer && "horizontal" === n && (_t640.left > _r138.left || _t640.right < _r138.right) ? i("Left", "offsetWidth") : (_t640.top > _r138.top || _t640.bottom < _r138.bottom) && i("Top", "offsetHeight"));
      }
    }
  }, {
    key: "_ensureVisibleTreeMode",
    value: function _ensureVisibleTreeMode(e, t, i, a, n) {
      var o = this;
      if (("menu" === o._element || "scrollButtons" === o.scrollMode) && !i.$.hasClass("scroll-buttons-shown") && "hidden" !== o.overflow) return;
      var r = i.offsetHeight,
          l = o.$scrollButtonNear.hasClass("smart-hidden");
      var s;
      if (a.top > t.top) s = o._getOffsetTop(e);else {
        var _i644 = e.expanded ? e.firstElementChild.offsetHeight + parseInt(window.getComputedStyle(e.children[1]).marginTop, 10) : e.offsetHeight;

        if ("tree" === o._element && (_i644 += parseFloat(getComputedStyle(o).getPropertyValue("--smart-tree-item-vertical-offset")) || 0), a.bottom < t.top + _i644) s = o._getOffsetTop(e) - r + _i644 + n;else return;
      }
      i.scrollTop = s, ("menu" === o._element || "scrollButtons" === o.scrollMode) && o._updateScrollButtonVisibility(i, !1, [o.$.scrollButtonNear, o.$.scrollButtonFar]), "auto" === o.overflow && l && !o.$scrollButtonNear.hasClass("smart-hidden") && (i.scrollTop += r - i.offsetHeight);
    }
  }, {
    key: "_escapeHandler",
    value: function _escapeHandler(e, t, i) {
      var a = this;
      e && (e.$.removeClass("focus"), e.removeAttribute("focus")), a._closeSubContainers(t, void 0, void 0, !0), a._hoverViaKeyboard(i.menuItemsGroup);
    }
  }, {
    key: "_expandItemsByDefault",
    value: function _expandItemsByDefault(e) {
      var t = this;

      if ((0 !== t._menuItemsGroupsToExpand.length || e) && ("tree" === t.mode || t._minimized)) {
        var _i645 = t.hasAnimation,
            _a399 = t.animation;
        _i645 && (t.animation = "none"), e && t._collapseAll(!1);

        for (var _e728 = 0; _e728 < t._menuItemsGroupsToExpand.length; _e728++) {
          t.expandItem(t._menuItemsGroupsToExpand[_e728].path, void 0, !1);
        }

        _i645 && (t.animation = _a399), t._menuItemsGroupsToExpand = [];
      }
    }
  }, {
    key: "_expandSection",
    value: function _expandSection(e) {
      var t = this,
          i = e.style.height,
          a = e.scrollHeight + "px";
      return e.style.height = a, t._treeAnimationInProgress = e, i !== a && (parseFloat(i) || parseFloat(a)) ? void e.addEventListener("transitionend", t._transitionendHandlerExpand) : void t._transitionendHandlerExpand(t, e);
    }
  }, {
    key: "_filterInputKeyupHandler",
    value: function _filterInputKeyupHandler() {
      var e = this;
      e._filterTimer && clearTimeout(e._filterTimer), e._filterTimer = setTimeout(function () {
        var t = e.context;
        e.context = e, e._applyFilter(e.$.filterInput.value, e._view), e._checkOverflow(), e.context = t;
      }, 300);
    }
  }, {
    key: "_findItem",
    value: function _findItem(e, t) {
      if ("" === t) return e;
      var i = this;

      switch (i.filterMode) {
        case "startsWith":
          if (0 === e.label.indexOf(t)) return e;
          break;

        case "startsWithIgnoreCase":
          if (0 === e.label.toLowerCase().indexOf(t.toLowerCase())) return e;
          break;

        case "doesNotContain":
          if (0 > e.label.indexOf(t)) return e;
          break;

        case "doesNotContainIgnoreCase":
          if (0 > e.label.toLowerCase().indexOf(t.toLowerCase())) return e;
          break;

        case "contains":
          if (-1 < e.label.indexOf(t)) return e;
          break;

        case "containsIgnoreCase":
          if (-1 < e.label.toLowerCase().indexOf(t.toLowerCase())) return e;
          break;

        case "equals":
          if (0 === e.label.localeCompare(t)) return e;
          break;

        case "equalsIgnoreCase":
          if (0 === e.label.toLowerCase().localeCompare(t.toLowerCase())) return e;
          break;

        case "endsWith":
          if (e.label.endsWith(t)) return e;
          break;

        case "endsWithIgnoreCase":
          if (e.label.toLowerCase().endsWith(t.toLowerCase())) return e;
      }

      return null;
    }
  }, {
    key: "_getFirstEnabledChild",
    value: function _getFirstEnabledChild(e) {
      var t = e.children;

      for (var _a400 = 0; _a400 < t.length; _a400++) {
        if (this._isChildEnabled(t[_a400])) return t[_a400];
      }
    }
  }, {
    key: "_getLastEnabledChild",
    value: function _getLastEnabledChild(e) {
      var t = e.children;

      for (var _a401 = t.length - 1; 0 <= _a401; _a401--) {
        if (this._isChildEnabled(t[_a401])) return t[_a401];
      }
    }
  }, {
    key: "_getNextEnabledChild",
    value: function _getNextEnabledChild(e) {
      if (e) for (; e.nextElementSibling;) {
        var _t641 = e.nextElementSibling;
        if (this._isChildEnabled(_t641)) return _t641;
        e = _t641;
      }
    }
  }, {
    key: "_getOffsetTop",
    value: function _getOffsetTop(e) {
      var t = e.offsetTop;

      for (; e.offsetParent !== this.$.mainContainer;) {
        e = e.offsetParent, t += e.offsetTop;
      }

      return t;
    }
  }, {
    key: "_getPreviousEnabledChild",
    value: function _getPreviousEnabledChild(e) {
      if (e) for (; e.previousElementSibling;) {
        var _t642 = e.previousElementSibling;
        if (this._isChildEnabled(_t642)) return _t642;
        e = _t642;
      }
    }
  }, {
    key: "_hamburgerIconClickHandler",
    value: function _hamburgerIconClickHandler(e, t) {
      e && e.stopPropagation();
      var i = this;
      if (void 0 === t && (Smart.ListMenu && i instanceof Smart.ListMenu ? t = i.$.view : t = i.$.mainContainer), !i.disabled) if (!i._minimizedDropDownOpened) {
        if (i._positionDetection.placeOverlay(), null !== i.dropDownAppendTo) {
          var _e729 = i.dropDownPosition,
              _a402 = i.getBoundingClientRect(),
              _n314 = i._positionDetection.getDropDownOffset();

          -1 !== _e729.indexOf("right") || "auto" === _e729 ? i.rightToLeft ? (t.style.right = "initial", t.style.left = _a402.left + _a402.width - t.offsetWidth - _n314.x + "px") : (t.style.left = _a402.left + _n314.x + "px", t.style.right = "initial") : -1 !== _e729.indexOf("left") && (t.style.left = _a402.right - t.offsetWidth + _n314.x + "px", t.style.right = "initial"), -1 !== _e729.indexOf("bottom") || -1 !== _e729.indexOf("overlay") || "auto" === _e729 ? t.style.top = _a402.bottom + _n314.y + "px" : -1 !== _e729.indexOf("top") && (t.style.top = _a402.top + _n314.y + "px");
        } else t.style.right = "";

        i._edgeMacFF && t.$.removeClass("not-in-view"), t.$.removeClass("smart-visibility-hidden"), i.$hamburgerIcon.addClass("smart-close-button"), i.$.hamburgerIcon.setAttribute("aria-expanded", !0), i._minimizedDropDownOpened = !0, i._browserBoundsDetection(t);
      } else i._close();
    }
  }, {
    key: "_handleOverflowChange",
    value: function _handleOverflowChange() {
      var e = this;
      if ((e._minimized || null === e.dropDownAppendTo && !e.$mainContainer.hasClass("simple") && "tree" !== e.mode) && !(Smart.ListMenu && e instanceof Smart.ListMenu)) return;
      var t = e.overflow;
      var i;
      "horizontal" === e.mode ? (i = !0, e.$.mainContainer.scrollLeft = 0) : (i = !1, e.$.mainContainer.scrollTop = 0), "hidden" === t ? (e.$mainContainer.removeClass("scroll-buttons-shown"), e.$scrollButtonNear.addClass("smart-hidden"), e.$scrollButtonFar.addClass("smart-hidden")) : (e.$.scrollButtonNear.disabled = e.disabled, e.$.scrollButtonFar.disabled = e.disabled, "auto" === t ? (e.$scrollButtonNear.addClass("smart-hidden"), e.$scrollButtonFar.addClass("smart-hidden"), e._checkOverflow(e.$.mainContainer, i, [e.$.scrollButtonNear, e.$.scrollButtonFar])) : (e.$mainContainer.addClass("scroll-buttons-shown"), e.$mainContainer.removeClass("one-button-shown"), e.$scrollButtonNear.removeClass("smart-hidden"), e.$scrollButtonFar.removeClass("smart-hidden"), e._updateScrollButtonVisibility(e.$.mainContainer, i, [e.$.scrollButtonNear, e.$.scrollButtonFar])));
    }
  }, {
    key: "_hideMainContainerScrollButtons",
    value: function _hideMainContainerScrollButtons() {
      var e = this;
      e.$scrollButtonNear.addClass("smart-hidden"), e.$scrollButtonFar.addClass("smart-hidden"), e.$mainContainer.removeClass("scroll-buttons-shown"), e.$mainContainer.removeClass("one-button-shown");
    }
  }, {
    key: "_hoverViaKeyboard",
    value: function _hoverViaKeyboard(e) {
      if (e) {
        var _t643 = this;

        e.$.addClass("focus"), e.setAttribute("focus", ""), _t643._focusedViaKeyboard = e, _t643._ensureVisible(e);
      }
    }
  }, {
    key: "_isBranchExpanded",
    value: function _isBranchExpanded(e) {
      var t = this;
      if ("tree" !== t.mode) return !0;
      var i = !0;

      for (; e.parentItem;) {
        i = i && e.parentItem.expanded, e = e.parentItem;
      }

      return i;
    }
  }, {
    key: "_isChildEnabled",
    value: function _isChildEnabled(e) {
      return !(e.disabled || e.templateApplied || e.hidden || e instanceof HTMLDivElement || 0 === e.offsetHeight);
    }
  }, {
    key: "_isContainerOpened",
    value: function _isContainerOpened(e, t) {
      var i = this;
      return "tree" === i.mode || i._minimized ? (i._openedContainers[e] || (i._openedContainers[e] = []), -1 !== i._openedContainers[e].indexOf(t)) : i._openedContainers[e] === t;
    }
  }, {
    key: "_keydownHandler",
    value: function _keydownHandler(e) {
      var t = this;
      var i = e.key;
      if (t.getRootNode().activeElement !== t || -1 === ["ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp", "End", "Enter", "Escape", "Home", " "].indexOf(i) || t.disabled) return;
      e.preventDefault();
      var a = t.mode;
      if ("tree" === a || t._minimized) return void t._keydownHandlerTreeMode(i);
      var n = t.dropDownPosition,
          o = -1 !== n.indexOf("left"),
          r = "top-left" === n || "top-right" === n,
          l = t._openedContainers;
      var s = t.$.mainContainer,
          d = 1,
          c;

      for (var _t644 = l.length - 1; 0 <= _t644; _t644--) {
        if (void 0 !== l[_t644]) {
          s = l[_t644], d = s.level, s = s.itemContainer;
          break;
        }
      }

      switch (c = s.querySelector("[focus][level=\"" + d + "\"]"), t.rightToLeft && ("ArrowLeft" === i ? i = "ArrowRight" : "ArrowRight" == i && (i = "ArrowLeft")), i) {
        case "ArrowDown":
          1 === d ? "horizontal" !== a || r ? "horizontal" !== a && t._levelOneNavigate("_getFirstEnabledChild", c, s) : t._levelOneOpenDropDown(c) : t._navigate("_getNextEnabledChild", c, s);
          break;

        case "ArrowLeft":
          o ? 1 === d ? "horizontal" === a ? t._levelOneNavigate("_getLastEnabledChild", c, s) : t._levelOneOpenDropDown(c) : c instanceof Smart.MenuItemsGroup ? t._selectionHandler({
            target: c,
            isTrusted: !0
          }) : t._levelOneNavigateFromLowerLevel("_getPreviousEnabledChild", c) : t._arrowLeftHandler(d, a, c, s);
          break;

        case "ArrowRight":
          o ? 1 === d ? "horizontal" === a && t._levelOneNavigate("_getFirstEnabledChild", c, s) : 2 === d ? t._levelOneNavigateFromLowerLevel("_getNextEnabledChild", c) : t._escapeHandler(c, d, s) : t._arrowRightHandler(d, a, c, s);
          break;

        case "ArrowUp":
          1 === d ? "horizontal" === a && r ? t._levelOneOpenDropDown(c) : "horizontal" !== a && t._levelOneNavigate("_getLastEnabledChild", c, s) : t._navigate("_getPreviousEnabledChild", c, s);
          break;

        case "End":
        case "Home":
          {
            var _e730 = "End" === i ? t._getLastEnabledChild(s) : t._getFirstEnabledChild(s);

            if (!_e730 || c === _e730) return;
            c && (c.$.removeClass("focus"), c.removeAttribute("focus")), t._hoverViaKeyboard(_e730);
            break;
          }

        case "Enter":
          c && t._selectionHandler({
            target: c,
            isTrusted: !0
          });
          break;

        case "Escape":
          1 < d ? (2 === d && t._positionDetection.removeOverlay(), t._escapeHandler(c, d, s)) : "dropDown" === a && t.opened && t.close({
            trigger: "interaction",
            target: "Escape"
          });
          break;

        case " ":
          c && t._toggleItem(c);
      }
    }
  }, {
    key: "_keydownHandlerTreeMode",
    value: function _keydownHandlerTreeMode(e) {
      function t(e) {
        var t = e.level;
        return !1 === e.disabled && !0 !== e.templateApplied && (1 === t || 1 < t && o._isContainerOpened(t, e.parentElement.container) && 0 < e.getBoundingClientRect().height);
      }

      function i(e) {
        for (var _a403 = e; _a403 < r.length; _a403++) {
          var _e731 = r[_a403];

          if (t(_e731)) {
            if (l) {
              if (l === _e731) break;
              l.$.removeClass("focus"), l.removeAttribute("focus");
            }

            o._hoverViaKeyboard(_e731);

            break;
          }
        }
      }

      function a(e) {
        for (var _a404 = e; 0 <= _a404; _a404--) {
          var _e732 = r[_a404];

          if (t(_e732)) {
            if (l) {
              if (l === _e732) break;
              l.$.removeClass("focus"), l.removeAttribute("focus");
            }

            o._hoverViaKeyboard(_e732);

            break;
          }
        }
      }

      function n() {
        1 < l.level && (l.$.removeClass("focus"), l.removeAttribute("focus"), o._hoverViaKeyboard(l.parentItem));
      }

      var o = this,
          r = Array.from(o.$.mainContainer.querySelectorAll("smart-menu-item, smart-menu-items-group")),
          l = o.$.mainContainer.getElementsByClassName("focus")[0];
      var s;

      switch (e) {
        case "ArrowDown":
          s = l ? r.indexOf(l) + 1 : 0, i(s);
          break;

        case "ArrowLeft":
          if (!l) return;
          if (l instanceof Smart.MenuItem) n();else {
            if (o._isContainerOpened(l.level + 1, l.container)) return void o._closeSubContainers(l.level + 1, l.container, !0, !0);
            n();
          }
          break;

        case "ArrowRight":
          if (!l || l instanceof Smart.MenuItem) return;
          o._isContainerOpened(l.level + 1, l.container) ? (l.$.removeClass("focus"), l.removeAttribute("focus"), o._hoverViaKeyboard(o._getFirstEnabledChild(l.itemContainer))) : o._selectionHandler({
            target: l,
            type: "keydown",
            isTrusted: !0
          }, l);
          break;

        case "ArrowUp":
          s = l ? r.indexOf(l) - 1 : r.length - 1, a(s);
          break;

        case "End":
          a(r.length - 1);
          break;

        case "Enter":
          o._minimized && !o._minimizedDropDownOpened ? o._hamburgerIconClickHandler(void 0, o.$.mainContainer) : l && o._selectionHandler({
            target: l,
            type: "keydown",
            isTrusted: !0
          });
          break;

        case "Escape":
          o._minimized && o._minimizedDropDownOpened && o._close();
          break;

        case "Home":
          i(0);
          break;

        case " ":
          l && o._toggleItem(l);
      }
    }
  }, {
    key: "_levelOneNavigate",
    value: function _levelOneNavigate(e, t, i) {
      var a = this;

      if (!t) {
        var _t645 = a[e](i);

        _t645 && a._hoverViaKeyboard(_t645);
      } else "_getLastEnabledChild" === e ? a._navigate("_getPreviousEnabledChild", t, i) : a._navigate("_getNextEnabledChild", t, i);
    }
  }, {
    key: "_levelOneNavigateFromLowerLevel",
    value: function _levelOneNavigateFromLowerLevel(e, t) {
      var i = this,
          a = i[e](i._openedContainers[2].menuItemsGroup);
      a && (t && (t.$.removeClass("focus"), t.removeAttribute("focus")), i._closeSubContainers(2), a instanceof Smart.MenuItemsGroup ? i._selectionHandler({
        target: a,
        isTrusted: !0
      }) : i._hoverViaKeyboard(a));
    }
  }, {
    key: "_levelOneOpenDropDown",
    value: function _levelOneOpenDropDown(e) {
      e && e instanceof Smart.MenuItemsGroup && this._selectionHandler({
        target: e,
        isTrusted: !0
      });
    }
  }, {
    key: "_mainContainerHandler",
    value: function _mainContainerHandler(e) {
      var t = this;
      if (t._minimized && null !== t.dropDownAppendTo) switch (e.type) {
        case "click":
          t._selectionHandler(e);

          break;

        case "mouseleave":
          t._mouseleaveHandler(e);

          break;

        case "mouseout":
          t._mouseoutMouseoverHandler(e);

          break;

        case "mouseover":
          t._mouseoutMouseoverHandler(e);

      }
    }
  }, {
    key: "_menuItemSelectionHandler",
    value: function _menuItemSelectionHandler(e, t) {
      function i() {
        a.enableShadowDOM && (a.shadowRoot.activeElement || document.activeElement) !== a && null !== a.dropDownAppendTo && "click" === t.type && !a.shadowRoot.contains(e) ? a.focus() : document.activeElement !== a && null !== a.dropDownAppendTo && "click" === t.type && !a.contains(e) && a.focus();
      }

      var a = this;
      return e.disabled || e.templateApplied ? void i() : !a._toggleItem(e) && (a.$.fireEvent("itemClick", {
        item: e,
        label: e.label,
        value: e.value
      }), "tree" !== a.mode && (a._close(), "dropDown" === a.mode)) ? (a._ripple(e, t), void a.close({
        trigger: "interaction",
        target: e
      })) : void (a._ripple(e, t), i());
    }
  }, {
    key: "_menuItemsGroupSelectionHandler",
    value: function _menuItemsGroupSelectionHandler(e, t, i) {
      var a = this,
          n = a.mode,
          o = e.container,
          r = o.level,
          l = "tree" !== n && !a._minimized;

      if (a._treeAnimationInProgress !== o && (a._discardKeyboardHover(), a.getRootNode().activeElement === a || null === a.dropDownAppendTo || "click" !== t.type || a.contains(t.target) || a.focus(), "click" !== t.type || (t.target.classList.contains("smart-" + a._element + "-items-group-arrow") || !a._toggleItem(e)) && ("mouseenter" !== a.selectionMode || "tree" === n || a._minimized))) {
        var _s73 = a.hasAnimation;
        if (a._isContainerOpened(r, o)) a._closeSubContainers(r, o, !0, !1 !== i), l && e.hasAttribute("focus") && (a._focusedViaKeyboard = e);else {
          var d = a.$.fireEvent("expanding", {
            item: e,
            label: e.label,
            path: e.path,
            value: e.value,
            children: e.itemContainer.children
          });
          if (d.defaultPrevented) return;

          if (a._positionDetection.placeOverlay(), l && a._closeSubContainers(r), _s73 && !l && ("expand" !== t.type && (a._ensureVisibleOnTransitionend = e), a._expandSection(o)), a._edgeMacFF && 2 === r && l && o.$.removeClass("not-in-view"), o.$.removeClass("smart-visibility-hidden"), l || "expand" !== t.type) {
            if (!l) {
              var _t646 = a.$.mainContainer.getElementsByClassName("focus")[0];
              _t646 && (_t646.$.removeClass("focus"), _t646.removeAttribute("focus")), a._focusedViaKeyboard = e;
            } else "keydown" === t.type && (a._focusedViaKeyboard = e);

            e.$.addClass("focus"), e.setAttribute("focus", "");
          }

          if (e.$.addClass("smart-" + a._element + "-items-group-opened"), e.$.addClass("smart-" + a._element + "-items-group-expanded"), e.setAttribute("aria-expanded", !0), a._addOpenedContainer(r, o), l) {
            if (a._ensureVisible(e), 1 < e.level && e.parentElement.dropDownHeightSet) {
              var _t647 = a.dropDownPosition,
                  _i646 = e.getBoundingClientRect().top - e.parentElement.container.getBoundingClientRect().top;

              o.style.top = -1 !== _t647.indexOf("bottom") || "auto" === _t647 ? _i646 + "px" : -1 === _t647.indexOf("top") ? _i646 + e.offsetHeight / 2 + "px" : _i646 + e.offsetHeight + "px";
            }

            o.itemContainer.checkOverflow && o.itemContainer.dropDownHeightSet && (a._checkOverflow(o.itemContainer, !1, [o.children[0], o.children[2]]), delete o.itemContainer.checkOverflow);
          }

          a._positionExternalContainer(o, e), "tree" === n || a._minimized ? !_s73 && a._browserBoundsDetection(a.$.mainContainer) : a._browserBoundsDetection(o), void 0 === t.type && a._hoverViaKeyboard(a._getFirstEnabledChild(e.itemContainer)), !1 !== i && a.$.fireEvent("expand", {
            item: e,
            label: e.label,
            path: e.path,
            value: e.value,
            children: e.itemContainer.children
          });
        }
        l ? a._ripple(e, t) : "tree" === n && !_s73 && (a._checkOverflow(a.$.mainContainer, !1, [a.$.scrollButtonNear, a.$.scrollButtonFar]), !a._minimized && "expand" !== t.type && a._ensureVisible(e));
      }
    }
  }, {
    key: "_mouseenterHandler",
    value: function _mouseenterHandler() {
      var e = this;
      e.autoFocusOnMouseenter && e.getRootNode().activeElement !== e && e.focus();
    }
  }, {
    key: "_mouseleaveHandler",
    value: function _mouseleaveHandler(e) {
      var t = this;

      if ("mouseenter" === t.selectionMode && "tree" !== t.mode && !t._minimized) {
        if (null !== t.dropDownAppendTo && e.relatedTarget) if (t.contains(e.target)) {
          var _i647 = e.relatedTarget.closest(".smart-menu-drop-down");

          if (_i647 && _i647.ownerElement === t) return;
        } else if (t.contains(e.relatedTarget)) return;
        t._isElementHovered = !1, t._autoCloseTimeout = setTimeout(function () {
          var e = t.context;
          clearTimeout(t._autoCloseTimeout), t._isElementHovered || (t.context = t, t._close(), t.context = e);
        }, t.autoCloseDelay);
      }
    }
  }, {
    key: "_mouseoutMouseoverHandler",
    value: function _mouseoutMouseoverHandler(e) {
      var t = this;
      if (t.disabled || t.displayLoadingIndicator) return;
      var i = e.target.closest("smart-menu-item") || e.target.closest("smart-menu-items-group");
      if ((t.enableShadowDOM && (i = e.composedPath()[0].closest("smart-menu-item") || e.composedPath()[0].closest("smart-menu-items-group") || i), "mouseover" === e.type && (t._isElementHovered = !0), !(null === i || i.disabled || i.templateApplied)) && !(("tree" === t.mode || t._minimized) && i.hasAttribute("focus") && e.relatedTarget && (e.target.parentElement === e.relatedTarget || e.relatedTarget.parentElement === e.target))) if (t._discardKeyboardHover(!1), "mouseover" === e.type) {
        "mouseenter" !== t.selectionMode || "tree" === t.mode || t._minimized || (i instanceof Smart.MenuItemsGroup && !i.hasAttribute("hover") ? t._selectionHandler(e, i) : i instanceof Smart.MenuItem && t._closeSubContainers(i.level + 1));

        var _a405 = e.target.closest(".smart-menu-drop-down");

        _a405 && (!_a405 || i.contains(_a405)) || (i.$.addClass("hover"), i.setAttribute("hover", ""), t._discardKeyboardHover(!0));
      } else {
        if ("tree" !== t.mode && !t._minimized && ("mouseenter" === t.selectionMode && e.relatedTarget === t.$.mainContainer && t._close(), i instanceof Smart.MenuItemsGroup && i.container && !i.container.$.hasClass("smart-visibility-hidden"))) return;
        i.$.removeClass("hover"), i.removeAttribute("hover");
      }
    }
  }, {
    key: "_moveDropDownsToExternalContainer",
    value: function _moveDropDownsToExternalContainer() {
      var e = this;

      for (var _t648 = 0; _t648 < e._containersInBody.length; _t648++) {
        var _i648 = e._containersInBody[_t648];
        e._dropDownParent.appendChild(_i648), _i648.$.listen("click", e._selectionHandler.bind(e)), _i648.$.listen("mouseleave", e._mouseleaveHandler.bind(e)), _i648.$.listen("mouseout", e._mouseoutMouseoverHandler.bind(e)), _i648.$.listen("mouseover", e._mouseoutMouseoverHandler.bind(e));
      }

      for (var _t649 = 0; _t649 < e._containers.length; _t649++) {
        var _i649 = e._containers[_t649];
        _i649.ownerElement = e, "" !== e.theme && _i649.classList.add(e.theme), e.rightToLeft && _i649.setAttribute("right-to-left", ""), _i649.classList.add("smart-drop-down-repositioned"), _i649.setAttribute("mode", e.mode), _i649.setAttribute("drop-down-position", e.dropDownPosition), e.checkboxes && _i649.setAttribute("checkboxes", "");
      }
    }
  }, {
    key: "_moveDropDownsToMenu",
    value: function _moveDropDownsToMenu() {
      var e = this;

      for (var _t650 = 0; _t650 < e._containersInBody.length; _t650++) {
        var _i650 = e._containersInBody[_t650];
        _i650.$.unlisten("click"), _i650.$.unlisten("mouseleave"), _i650.$.unlisten("mouseout"), _i650.$.unlisten("mouseover"), _i650.style.left = "", _i650.style.right = "", _i650.style.top = "", _i650.style.marginLeft = "", _i650.style.marginTop = "", _i650.menuItemsGroup.appendChild(_i650);
      }

      for (var _t651 = 0; _t651 < e._containers.length; _t651++) {
        var _i651 = e._containers[_t651];
        "" !== e.theme && _i651.classList.remove(e.theme), _i651.classList.remove("smart-drop-down-repositioned"), _i651.removeAttribute("mode"), _i651.removeAttribute("drop-down-position"), _i651.removeAttribute("checkboxes"), _i651.removeAttribute("right-to-left");
      }
    }
  }, {
    key: "_navigate",
    value: function _navigate(e, t, i) {
      var a = this;
      if (!t) return void ("_getNextEnabledChild" === e ? a._hoverViaKeyboard(a._getFirstEnabledChild(i)) : a._hoverViaKeyboard(a._getLastEnabledChild(i)));
      var n = a[e](t);
      n && (t.$.removeClass("focus"), t.removeAttribute("focus"), a._hoverViaKeyboard(n));
    }
  }, {
    key: "_positionExternalContainer",
    value: function _positionExternalContainer(e, t) {
      var i = this;
      if (null === i.dropDownAppendTo || 2 !== e.level) return;

      var a = i.dropDownPosition,
          n = i.mode,
          o = t.getBoundingClientRect(),
          r = i._positionDetection.getDropDownOffset(),
          l = o.top + r.y,
          s = o.bottom + r.y;

      var d = o.left + r.x,
          c = o.right + r.x;
      e.style.top = e.style.left = e.style.right = "", i.rightToLeft && (e.style.right = "initial"), -1 === a.indexOf("left") ? "horizontal" === n || "overlay-right" === a ? e.style.left = d + "px" : i.rightToLeft ? e.style.left = c - e.offsetWidth + "px" : e.style.left = d + o.width + "px" : (d -= e.offsetWidth, ("horizontal" === n || "overlay-left" === a) && (d += o.width), e.style.left = d + "px", e.style.right = "initial");
      "bottom-right" === a || "bottom-left" === a || "auto" === a ? e.style.top = "horizontal" === n ? s + "px" : l + "px" : "top-right" === a || "top-left" === a ? e.style.top = "horizontal" === n ? l - e.offsetHeight + "px" : s - e.offsetHeight + "px" : "overlay-right" === a || "overlay-left" === a ? e.style.top = l + o.height / 2 + "px" : void 0;
    }
  }, {
    key: "_processDataSource",
    value: function _processDataSource() {
      function e(a, r) {
        var l;

        if (Array.isArray(a[n]) && 0 < a[n].length) {
          l = document.createElement("smart-" + t._element + "-items-group"), !0 === a.checkable && l.set("checkable", !0), ("checkbox" === a.checkMode || "radioButton" === a.checkMode) && l.set("checkMode", a.checkMode), a.dropDownHeight && l.set("dropDownHeight", a.dropDownHeight), !0 === a.expanded && "tree" === t.mode && (l.set("expanded", !0), l.setAttribute("aria-expanded", !0));

          for (var _t652 = 0; _t652 < a[n].length; _t652++) {
            e(a[n][_t652], l);
          }
        } else l = document.createElement("smart-" + t._element + "-item"), void 0 !== a.shortcut && l.set("shortcut", a.shortcut), a.customAttribute && l.setAttribute(a.customAttribute, "");

        !0 === a.checked && (l.set("checked", !0), l.setAttribute("aria-checked", !0)), !0 === a.disabled && l.set("disabled", !0), a[i] !== void 0 && l.set("label", a[i]), !0 === a.selected && l.set("selected", !0), !0 === a.separator && l.set("separator", !0), a[o] !== void 0 && l.set("value", a[o]), r.appendChild(l);
      }

      var t = this,
          a = t.dataSource,
          i = t.displayMember,
          n = t.itemsMember,
          o = t.valueMember;
      t.$.mainContainer.innerHTML = "";

      for (var _n315 = 0; _n315 < a.length; _n315++) {
        var _i652 = a[_n315];
        e(_i652, t.$.mainContainer);
      }

      t._processHTML(t.$.mainContainer, 1);
    }
  }, {
    key: "_processHTML",
    value: function _processHTML(e, t, i) {
      var a = this;
      var n, o;
      1 < t && (n = a._createMenuItemsGroupContainer(e, t), o = n.itemContainer, (e.expanded || e.hasAttribute("expanded")) && "tree" === a.mode ? a._menuItemsGroupsToExpand.push(e) : (e.set("expanded", !1), e.removeAttribute("expanded"), e.setAttribute("aria-expanded", !1)));
      var r = Array.from(e.children),
          l = [],
          s = document.createDocumentFragment();
      var d = 0;

      for (var _n316 = 0; _n316 < r.length; _n316++) {
        if (1 < t && 0 == _n316) {
          d++;
          continue;
        }

        var _i653 = r[_n316];

        if (!(_i653 instanceof Smart.MenuItem || _i653 instanceof Smart.MenuItemsGroup)) {
          _i653.parentElement.removeChild(_i653), d++;
          continue;
        }

        a._createItemHTMLStructure(_i653, t, e, _n316 - d), (_i653.checked || _i653.hasAttribute("checked")) && (_i653.disabled || _i653.hasAttribute("disabled") || _i653.templateApplied ? (_i653.set("checked", !1), _i653.removeAttribute("checked"), _i653.removeAttribute("aria-checked")) : l.push(_i653)), 1 < t && s.appendChild(_i653), _i653 instanceof Smart.MenuItemsGroup && a._processHTML(_i653, t + 1);
      }

      if (1 < t) {
        if (o.appendChild(s), e.container = n, e.itemContainer = o, e instanceof Smart.MenuItemsGroup) {
          var _i654 = document.createElement("div");

          _i654.className = "smart-" + a._element + "-items-group-arrow", "menu" === a._element ? _i654.setAttribute("role", "presentation") : (_i654.setAttribute("role", "button"), _i654.setAttribute("aria-label", "Toggle")), a._setArrowDirection(_i654, t), e.firstElementChild.appendChild(_i654);
        }

        a._containers.push(n), 2 == t && (a._containersInBody.push(n), a._edgeMacFF && n.addEventListener("transitionend", function (e) {
          e.target === this && this.$.hasClass("smart-visibility-hidden") && (this.style.left = "", this.style.top = "", this.$.addClass("not-in-view"));
        })), null === a.dropDownAppendTo || "tree" === a.mode || a._minimized ? e.appendChild(n) : (n.ownerElement = a, a.rightToLeft ? n.setAttribute("right-to-left", "") : n.removeAttribute("right-to-left"), n.classList.add("smart-drop-down-repositioned"), n.setAttribute("mode", a.mode), n.setAttribute("drop-down-position", a.dropDownPosition), a.checkboxes && n.setAttribute("checkboxes", ""), "" !== a.theme && n.$.addClass(a.theme), n.setAttribute("animation", a.animation), 2 === t ? (a._dropDownParent.appendChild(n), n.$.listen("click", a._selectionHandler.bind(a)), n.$.listen("mouseleave", a._mouseleaveHandler.bind(a)), n.$.listen("mouseout", a._mouseoutMouseoverHandler.bind(a)), n.$.listen("mouseover", a._mouseoutMouseoverHandler.bind(a))) : e.appendChild(n));
      }

      a._validateRadioButtonSelection(e, t, l), a._sortItems && !1 !== i && a._sortItems(e);
    }
  }, {
    key: "_processUList",
    value: function _processUList() {
      var e = this,
          t = new RegExp(/<li>(.(?!<\/li>)|\n)*?<ul>/),
          i = new RegExp(/<\/ul>(.|\n)*?<\/li>/);
      var a = e.$.mainContainer.firstElementChild.innerHTML;

      for (a = a.replace(/\r?\n|\r/g, ""), a = a.replace(/<li(.|\n)*?>/g, "<li>"), a = a.replace(/<li><\/li>/g, "<li> </li>"), a = a.replace(/<ul(.|\n)*?>/g, "<ul>"); t.test(a);) {
        var _i655 = t.exec(a),
            _n317 = "<smart-" + e._element + "-items-group>" + _i655[0].slice(4, _i655[0].length - 4);

        a = a.replace(_i655[0], _n317);
      }

      for (; i.test(a);) {
        var _t653 = i.exec(a),
            _n318 = "</smart-" + e._element + "-items-group>";

        a = a.replace(_t653[0], _n318);
      }

      a = a.replace(/li>/g, "smart-" + e._element + "-item>"), e.$.mainContainer.innerHTML = a;
    }
  }, {
    key: "_refreshContainersArrays",
    value: function _refreshContainersArrays() {
      var e = this;

      for (var _t654 = e._containers.length - 1; 0 <= _t654; _t654--) {
        var _i656 = e._containers[_t654];

        if (!document.body.contains(_i656)) {
          e._containers.splice(_t654, 1);

          var _a406 = e._containersFixedHeight.indexOf(_i656);

          -1 < _a406 && (e._containersFixedHeight.splice(_a406, 1), e._additionalScrollButtons.splice(_a406, 1));
        }
      }

      e._checkContainersLength();
    }
  }, {
    key: "_refreshItemPaths",
    value: function _refreshItemPaths(e, t, a, n) {
      var o = this;
      var i = t ? e : e.container.itemContainer;
      var r = a ? a(e) : i.children;

      for (var _l102 = 0; _l102 < r.length; _l102++) {
        var _i657 = r[_l102];

        var _s74 = void 0;

        n && (_i657.originalIndex = _l102), _s74 = t ? "" + _l102 : e.path + "." + _l102, _i657.path = _s74, o._menuItems[_s74] = _i657, _i657 instanceof Smart.MenuItemsGroup && o._refreshItemPaths(_i657, void 0, a, n);
      }
    }
  }, {
    key: "_removeContainerFixedHeight",
    value: function _removeContainerFixedHeight() {
      var e = this;

      for (var _t655 = 0; _t655 < e._containersFixedHeight.length; _t655++) {
        var _i658 = e._containersFixedHeight[_t655];
        _i658.style.height = "", _i658.itemContainer.$.removeClass("scroll-buttons-shown"), _i658.itemContainer.$.removeClass("one-button-shown"), _i658.children[0].$.addClass("smart-hidden"), _i658.children[2].$.addClass("smart-hidden"), _i658.itemContainer.checkOverflow = !0;
      }
    }
  }, {
    key: "_removeContainersInBody",
    value: function _removeContainersInBody() {
      var e = this;
      if (null !== e.dropDownAppendTo && !e._minimized) for (var _t656 = 0; _t656 < e._containersInBody.length; _t656++) {
        e._dropDownParent.removeChild(e._containersInBody[_t656]);
      }
    }
  }, {
    key: "_reparentMenu",
    value: function _reparentMenu(e, t) {
      var i = this;

      if ("dropDown" === i.mode && (null !== i._dropDownParent || e) && i._dropDownParent !== i.parentElement) {
        if (!e || null === t) i._positionRelativeTo = i.parentElement;else if (null === i._dropDownParent) return i._positionRelativeTo.appendChild(i), void (i._positionRelativeTo = null);

        i._dropDownParent.appendChild(i);
      }
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      if (e._suppressResizeHandler) return void delete e._suppressResizeHandler;
      var t = e.minimizeWidth,
          i = e.mode;

      if (null !== t && "dropDown" !== i) {
        if (e.offsetWidth <= t && !e._minimized) return void e.minimize();
        e.offsetWidth > t && e.maximize();
      }

      (null !== e.dropDownAppendTo || "tree" === i) && e._checkOverflow(e.$.mainContainer, "horizontal" === i, [e.$.scrollButtonNear, e.$.scrollButtonFar]);
    }
  }, {
    key: "_ripple",
    value: function _ripple(e, t) {
      var i = this;
      if (i.hasRippleAnimation && "click" === t.type) return Smart.Utilities.Animation.Ripple.animate(e, t.pageX, t.pageY), !0;
    }
  }, {
    key: "_scroll",
    value: function _scroll(e) {
      if (!e.closest("[template-applied]")) {
        var _t657 = this,
            _i659 = _t657.mode,
            _a407 = e.classList.contains("smart-scroll-button-near") ? -1 : 1;

        if (e.parentElement === _t657.$.container) {
          var _e733 = _t657.$.mainContainer;
          "tree" !== _i659 && _t657._closeSubContainers(2), "horizontal" === _t657.mode ? (_e733.scrollLeft += 10 * _a407, _t657._updateScrollButtonVisibility(_e733, !0, [_t657.$.scrollButtonNear, _t657.$.scrollButtonFar])) : (_e733.scrollTop += 10 * _a407, _t657._updateScrollButtonVisibility(_e733, !1, [_t657.$.scrollButtonNear, _t657.$.scrollButtonFar]));
        } else {
          var _i660 = e.parentElement,
              _n319 = _i660.itemContainer;
          _t657._closeSubContainers(_i660.level + 1), _n319.scrollTop += 10 * _a407, _t657._updateScrollButtonVisibility(_n319, !1, [_i660.children[0], _i660.children[2]]);
        }
      }
    }
  }, {
    key: "_selectionHandler",
    value: function _selectionHandler(e, t) {
      var i = this,
          a = e.target;

      if (a.closest("[template-applied]") && e.stopPropagation(), !(i.disabled || i.displayLoadingIndicator)) {
        if (void 0 === t) {
          if ("click" === e.type) {
            var _t658 = a.closest("smart-repeat-button");

            if (_t658) return void i._scroll(_t658, e);
          }

          if (!e.isTrusted) return;

          var _n320 = a.closest("smart-" + i._element + "-item");

          if (_n320) return void i._menuItemSelectionHandler(_n320, e);
          if (t = a.closest("smart-" + i._element + "-items-group"), t && (a === t.container || a === t.container.firstElementChild)) return;
        }

        t && !t.disabled && i._menuItemsGroupSelectionHandler(t, e);
      }
    }
  }, {
    key: "_setArrowDirection",
    value: function _setArrowDirection(e, t) {
      var i = this,
          a = i.mode;
      return "tree" === a || i._minimized ? void (e.className = "smart-" + i._element + "-items-group-arrow down smart-arrow-down") : void ("overlay" === i.dropDownPosition.slice(0, 7) ? e.className = "smart-menu-items-group-arrow minus" : 2 === t && "horizontal" === a ? "top" === i.dropDownPosition.slice(0, 3) ? e.className = "smart-menu-items-group-arrow up smart-arrow-up" : e.className = "smart-menu-items-group-arrow down smart-arrow-down" : e.className = "smart-menu-items-group-arrow" + (i.rightToLeft ? "left smart-arrow-left" : "right smart-arrow-right"));
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      if (e.disabled || e.unfocusable) return void e.removeAttribute("tabindex");
      var t = e.getAttribute("tabindex");
      (null === t || 0 > t) && e.setAttribute("tabindex", 0);
    }
  }, {
    key: "_setLabel",
    value: function _setLabel(e, t, a, i) {
      var n = document.getElementById(e);

      if (null !== n && "template" === n.tagName.toLowerCase()) {
        var _o221 = document.importNode(n.content, !0);

        if (a instanceof Smart.MenuItem) t.appendChild(_o221), i && (a.setAttribute("template-applied", ""), a.templateApplied = !0);else if (Smart.ListMenu && this instanceof Smart.ListMenu) {
          var _e734 = new RegExp(/{{title="(.*)"}}/);

          for (var _t659 = 0; _t659 < _o221.childNodes.length; _t659++) {
            _e734.test(_o221.childNodes[_t659].innerHTML) ? (a.titleLabel = _e734.exec(_o221.childNodes[_t659].innerHTML)[1], _o221.childNodes[_t659].innerHTML = _o221.childNodes[_t659].innerHTML.replace(_e734, "")) : _e734.test(_o221.childNodes[_t659].textContent) && (a.titleLabel = _e734.exec(_o221.childNodes[_t659].textContent)[1], _o221.childNodes[_t659].textContent = _o221.childNodes[_t659].textContent.replace(_e734, ""));
          }

          a.titleLabel === void 0 && (a.titleLabel = _o221.textContent), t.appendChild(_o221);
        } else t.innerHTML = e, a.titleLabel = e;
      } else t.innerHTML = e, a instanceof Smart.MenuItemsGroup && (a.titleLabel = e);
    }
  }, {
    key: "_toggleItem",
    value: function _toggleItem(e) {
      var t = this;

      if (t.checkboxes) {
        var _i661 = 1 === e.level ? t : e.parentItem;

        if (_i661.checkable) {
          var _a408 = !1;

          return "checkbox" === _i661.checkMode ? (_a408 = !0, e.set("checked", !e.checked), e.checked ? e.setAttribute("aria-checked", !0) : e.removeAttribute("aria-checked"), t.$.fireEvent("itemCheckChange", {
            item: e,
            label: e.label,
            value: e.value,
            checked: e.checked
          })) : !e.checked && (_a408 = !0, e.set("checked", !0), e.setAttribute("aria-checked", !0), t._uncheckSiblings(e), t.$.fireEvent("itemCheckChange", {
            item: e,
            label: e.label,
            value: e.value,
            checked: !0
          })), e instanceof Smart.MenuItem && _a408 && t.$.fireEvent("itemClick", {
            item: e,
            label: e.label,
            value: e.value
          }), "tree" !== t.mode && "ListMenu" !== t.elementName && (t._close(), t.close()), !0;
        }
      }

      return !1;
    }
  }, {
    key: "_transitionendHandler",
    value: function _transitionendHandler(e) {
      var t = this;
      "dropDown" === t.mode && t.opened && e.target === t && t.getRootNode().activeElement !== t && !t._noAutoFocus && t.focus();
    }
  }, {
    key: "_transitionendHandlerCollapse",
    value: function _transitionendHandlerCollapse() {
      var e, t;

      if (1 === arguments.length) {
        if ("visibility" === arguments[0].propertyName) return;
        t = this, e = t.menuItemsGroup.menu;
      } else e = arguments[0], t = arguments[1];

      t.menuItemsGroup.$.removeClass("smart-" + e._element + "-items-group-expanded"), t.menuItemsGroup.setAttribute("aria-expanded", !1), t.removeEventListener("transitionend", e._transitionendHandlerCollapse), t.style.height = null, t.$.addClass("smart-visibility-hidden"), e._checkOverflow(e.$.mainContainer, !1, [e.$.scrollButtonNear, e.$.scrollButtonFar]), e._minimized && e._browserBoundsDetection(e.$.mainContainer), delete e._treeAnimationInProgress;
    }
  }, {
    key: "_transitionendHandlerExpand",
    value: function _transitionendHandlerExpand() {
      var e, t;

      if (1 === arguments.length) {
        if ("visibility" === arguments[0].propertyName) return;
        t = this, e = t.menuItemsGroup.menu;
      } else e = arguments[0], t = arguments[1];

      t.removeEventListener("transitionend", e._transitionendHandlerExpand), t.style.height = null, e._checkOverflow(e.$.mainContainer, !1, [e.$.scrollButtonNear, e.$.scrollButtonFar]), e._minimized && e._browserBoundsDetection(e.$.mainContainer), e._ensureVisibleOnTransitionend && (e._ensureVisible(e._ensureVisibleOnTransitionend), delete e._ensureVisibleOnTransitionend), delete e._treeAnimationInProgress;
    }
  }, {
    key: "_uncheckSiblings",
    value: function _uncheckSiblings(e) {
      for (var _t660 = 0; _t660 < e.parentElement.childElementCount; _t660++) {
        var _i662 = e.parentElement.children[_t660];
        _i662 !== e && _i662.checked && (_i662.set("checked", !1), _i662.removeAttribute("aria-checked"), this.$.fireEvent("itemCheckChange", {
          item: _i662,
          label: _i662.label,
          value: _i662.value,
          checked: !1
        }));
      }
    }
  }, {
    key: "_unsortItems",
    value: function _unsortItems(e, t) {
      var a = this;
      var n = [],
          o,
          r;
      e === a.$.mainContainer ? (r = e, o = e.children) : (r = e.container.firstElementChild, o = r.children);

      for (var _r139 = 0; _r139 < o.length; _r139++) {
        var _e735 = o[_r139];
        n[_e735.originalIndex] = _e735, _e735 instanceof Smart.MenuItemsGroup && t === void 0 && a._unsortItems(_e735);
      }

      if (!(2 > n.length)) for (var _e736 = 0; _e736 < n.length; _e736++) {
        r.appendChild(n[_e736]);
      }
    }
  }, {
    key: "_updateItemRoles",
    value: function _updateItemRoles() {
      var e = this;

      for (var _t661 in e._menuItems) {
        var _i663 = e._menuItems[_t661];

        if (e.checkboxes) {
          var _t662 = 1 === _i663.level ? e : _i663.parentItem;

          _t662.checkable ? _i663.setAttribute("role", "checkbox" === _t662.checkMode ? "menuitemcheckbox" : "menuitemradio") : _i663.setAttribute("role", "menuitem");
        } else _i663.setAttribute("role", "menuitem");
      }
    }
  }, {
    key: "_updateScrollButtonVisibility",
    value: function _updateScrollButtonVisibility(e, t, i) {
      var a = Math.round;
      var n = this,
          o = n.overflow,
          r = e === n.$.mainContainer;
      if (r && "hidden" === o) return;
      var l = !0,
          s = !0,
          d,
          c,
          m;

      if (t ? (d = "scrollLeft", c = "offsetWidth", m = "scrollWidth") : (d = "scrollTop", c = "offsetHeight", m = "scrollHeight"), 0 === a(e[d]) && (l = !1), a(e[c] + e[d]) >= a(e[m]) && (s = !1), !r || "auto" === o) {
        if (l && s) return i[0].$.removeClass("smart-hidden"), i[1].$.removeClass("smart-hidden"), void e.classList.remove("one-button-shown");
        l ? i[0].$.removeClass("smart-hidden") : i[0].$.addClass("smart-hidden"), s ? i[1].$.removeClass("smart-hidden") : i[1].$.addClass("smart-hidden"), e.classList.add("one-button-shown");
      } else "scroll" !== o || n.disabled || (i[0].disabled = !l, i[1].disabled = !s);
    }
  }, {
    key: "_validateRadioButtonSelection",
    value: function _validateRadioButtonSelection(e, t, a) {
      var i = this;

      if (i.checkboxes) {
        var _n321, _o222;

        if (1 === t ? (_n321 = i, _o222 = i.$.mainContainer) : (_n321 = e, _o222 = e.itemContainer), "radioButton" === _n321.checkMode && _n321.checkable) if (1 < a.length) for (var _e737 = a.length - 2; 0 <= _e737; _e737--) {
          a[_e737].set("checked", !1), a[_e737].removeAttribute("aria-checked");
        } else if (0 === a.length) {
          var _e738 = i._getFirstEnabledChild(_o222);

          _e738 && (_e738.set("checked", !0), _e738.setAttribute("aria-checked", !0));
        }
      }
    }
  }, {
    key: "_wheelHandler",
    value: function _wheelHandler(e) {
      var t = this;
      if (!t.enableMouseWheelAction || t._wheelInProgress || t.disabled || t.displayLoadingIndicator || t.$.mainContainer.offsetHeight === t.$.mainContainer.scrollHeight) return void (t._wheelInProgress && e.preventDefault());
      e.preventDefault(), t._dragStartDetails = {
        startY: e.pageY,
        x: e.pageX,
        y: e.pageY,
        startTime: Date.now(),
        target: e.target
      }, t._wheelInProgress = !0;
      var i = {
        pageY: e.pageY + 50 * (0 < e.deltaY ? -1 : 1)
      };

      t._endSwiping(i, t._dragStartDetails.startTime + 100, !0);
    }
  }, {
    key: "items",
    get: function get() {
      return this._menuItems;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoCloseDelay: {
          value: 100,
          type: "number"
        },
        autoFocusOnMouseenter: {
          value: !1,
          type: "boolean"
        },
        checkable: {
          value: !1,
          type: "boolean"
        },
        checkboxes: {
          value: !1,
          type: "boolean"
        },
        checkMode: {
          value: "checkbox",
          allowedValues: ["checkbox", "radioButton"],
          type: "string"
        },
        closeAction: {
          value: "up",
          allowedValues: ["up", "down", "none"],
          type: "string"
        },
        dataSource: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        displayMember: {
          value: "label",
          type: "string"
        },
        dropDownAppendTo: {
          value: null,
          type: "any?"
        },
        dropDownOverlay: {
          value: !1,
          type: "boolean"
        },
        dropDownPosition: {
          value: "auto",
          allowedValues: ["top-left", "top-right", "bottom-left", "bottom-right", "overlay-left", "overlay-right", "auto"],
          type: "string"
        },
        enableMouseWheelAction: {
          value: !1,
          type: "boolean"
        },
        itemsMember: {
          value: "items",
          type: "string"
        },
        minimizeIconTemplate: {
          value: null,
          type: "string?"
        },
        minimizeWidth: {
          value: null,
          type: "number?"
        },
        mode: {
          value: "horizontal",
          allowedValues: ["horizontal", "vertical", "dropDown", "tree"],
          type: "string"
        },
        opened: {
          value: !1,
          type: "boolean"
        },
        overflow: {
          value: "auto",
          allowedValues: ["auto", "hidden", "scroll"],
          type: "string"
        },
        selectionMode: {
          value: "click",
          allowedValues: ["click", "mouseenter"],
          type: "string"
        },
        valueMember: {
          value: "value",
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "container.click": "_selectionHandler",
        keydown: "_keydownHandler",
        mouseenter: "_mouseenterHandler",
        mouseleave: "_mouseleaveHandler",
        "container.mouseout": "_mouseoutMouseoverHandler",
        "container.mouseover": "_mouseoutMouseoverHandler",
        resize: "_resizeHandler",
        transitionend: "_transitionendHandler",
        "hamburgerIcon.click": "_hamburgerIconClickHandler",
        "mainContainer.click": "_mainContainerHandler",
        "mainContainer.mouseleave": "_mainContainerHandler",
        "mainContainer.mouseout": "_mainContainerHandler",
        "mainContainer.mouseover": "_mainContainerHandler",
        "document.down": "_documentDownHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.RepeatButton": "smart.button.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.button.css", "smart.menu.css"];
    }
  }]);

  return _class66;
}(Smart.BaseElement)), Smart("smart-list-menu",
/*#__PURE__*/
function (_Smart$Menu) {
  "use strict";

  _inherits(_class67, _Smart$Menu);

  function _class67() {
    _classCallCheck(this, _class67);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class67).apply(this, arguments));
  }

  _createClass(_class67, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"hamburgerIcon\" class=\"smart-hamburger-icon smart-hidden\">\n                        <div id=\"hamburgerIconLineTop\" class=\"smart-hamburger-icon-line smart-hamburger-icon-line-top\"></div>\n                        <div id=\"hamburgerIconLineCenter\" class=\"smart-hamburger-icon-line smart-hamburger-icon-line-center\"></div>\n                        <div id=\"hamburgerIconLineBottom\" class=\"smart-hamburger-icon-line smart-hamburger-icon-line-bottom\"></div>\n                        <div id=\"customIconContainer\" class=\"smart-hamburger-icon-custom-container smart-hidden\"></div>\n                    </div>\n                    <div id=\"view\" class=\"smart-list-menu-view\">\n                        <div id=\"header\" class=\"smart-header smart-hidden\">\n                            <smart-button id=\"backButton\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" unfocusable right-to-left=\"[[rightToLeft]]\">\n                                <div id=\"backButtonArrow\" class=\"smart-arrow ".concat(this.rightToLeft ? "smart-arrow-right" : "smart-arrow-left", "\"></div>\n                            </smart-button>\n                            <div id=\"title\" class=\"smart-title\"></div>\n                        </div>\n                        <div class=\"smart-list-menu-filter-input-container smart-hidden\" id=\"filterInputContainer\">\n                            <input id=\"filterInput\" class=\"smart-filter-input\" disabled=\"[[disabled]]\" placeholder=\"[[filterInputPlaceholder]]\" type=\"text\" />\n                        </div>\n                        <smart-repeat-button id=\"scrollButtonNear\" class=\"smart-menu-scroll-button smart-spin-button smart-scroll-button-near smart-hidden\" animation=\"[[animation]]\" unfocusable>\n                            <div id=\"arrowNear\" class=\"smart-arrow smart-arrow-up\" right-to-left=\"[[rightToLeft]]\"></div>\n                        </smart-repeat-button>\n                        <div id=\"mainContainer\" class=\"smart-menu-main-container\">\n                            <content></content>\n                        </div>\n                        <smart-repeat-button id=\"scrollButtonFar\" class=\"smart-menu-scroll-button smart-spin-button smart-scroll-button-far smart-hidden\" animation=\"[[animation]]\" unfocusable right-to-left=\"[[rightToLeft]]\">\n                            <div id=\"arrowFar\" class=\"smart-arrow smart-arrow-down\"></div>\n                        </smart-repeat-button>\n                        <div id=\"loadingIndicatorContainer\" class=\"smart-loader-container smart-hidden\">\n                            <span id=\"loadingIndicator\" class=\"smart-loader\"></span>\n                            <span id=\"loadingIndicatorPlaceHolder\" class=\"smart-loader-label smart-hidden\">[[loadingIndicatorPlaceholder]]</span>\n                        </div>\n                    </div>\n                </div>");
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;
      _get(_getPrototypeOf(_class67.prototype), "attached", this).call(this), e.isCompleted && null !== e.dropDownAppendTo && e._minimized && e._dropDownParent.appendChild(e.$.view);
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;
      _get(_getPrototypeOf(_class67.prototype), "detached", this).call(this), e._close(), null !== e.dropDownAppendTo && e._minimized && e._dropDownParent.removeChild(e.$.view);
    }
  }, {
    key: "addItem",
    value: function addItem(e, t) {
      var i = this;
      if (!(e instanceof Smart.MenuItem || e instanceof Smart.MenuItemsGroup)) return;
      var a, n, o, r;
      if (void 0 === t) t = i.$.mainContainer, a = void 0, n = 1, o = t, r = i._topLevelFilter;else {
        if ("string" == typeof t && (t = i.getItem(t)), void 0 === t || !(t instanceof Smart.MenuItemsGroup && (i.contains(t) || t.closest(".smart-list-menu-view") === i.$.view))) return;
        a = t, n = t.level + 1, o = t.itemContainer, r = t.filter;
      }

      if (i._createItemHTMLStructure(e, n, t, i._getCurrentViewItems(a).length, 0), e instanceof Smart.MenuItemsGroup && i._processHTML(e, n + 1), i._view === t || t.$.hasClass("smart-hidden") || !(0 < t.offsetHeight) || !(0 < t.offsetWidth) || (i._view || i.$.mainContainer.contains(t)) && (!i._view || i._view.contains(t)) || e.$.addClass("smart-hidden"), i.grouped) {
        var _e739 = Array.from(o.children);

        for (var _t663 = _e739.length - 1; 0 <= _t663; _t663--) {
          _e739[_t663].$.hasClass("smart-list-menu-group-label") && o.removeChild(_e739[_t663]);
        }

        i._unsortItems(t, !0);
      }

      if (o.appendChild(e), i.grouped) {
        var _e740 = i._view;
        i._applyGrouping(t, !0), i._home(), _e740 && i.changePage(_e740.path);
      }

      i.filterable && void 0 !== r && "" !== r && null === i._findItem(e, r) && (e.$.addClass("smart-hidden"), e.hidden = !0), i._toggleFilterInputGroupLabelVisibility(), i._checkOverflow();
    }
  }, {
    key: "back",
    value: function back(e) {
      var t = this,
          i = t.animation,
          a = !1 === e && "none" !== i;
      a && (t.animation = "none"), t._backButtonClickHandler(), a && (t.animation = i);
    }
  }, {
    key: "changePage",
    value: function changePage(e) {
      var t = this,
          i = t.getItem(e);
      if (void 0 === i || i instanceof Smart.MenuItem || i.hidden) return;
      var a = [i];
      var n = i.parentItem,
          o = 0;

      for (t._discardKeyboardHover(); n;) {
        a.unshift(n), n = n.parentItem;
      }

      if (t._view) {
        var _e741 = a.indexOf(t._view);

        -1 === _e741 ? t._home() : o = _e741 + 1;
      }

      for (var _n322 = o; _n322 < a.length && !(a[_n322].disabled || a[_n322].hidden); _n322++) {
        t._menuItemsGroupSelectionHandler(a[_n322], {
          type: "expand"
        }, !0);
      }
    }
  }, {
    key: "maximize",
    value: function maximize() {
      var e = this;

      if (e._minimized) {
        if (e._positionDetection.removeOverlay(), e._minimized = !1, e._minimizedDropDownOpened && (e.$hamburgerIcon.removeClass("smart-close-button"), e._minimizedDropDownOpened = !1), null !== e.dropDownAppendTo && e._appendMinimizedContainerToMenu(e.$.view, null), e.$view.removeClass("smart-visibility-hidden"), e.$view.removeClass("smart-list-menu-view-minimized"), e.$hamburgerIcon.addClass("smart-hidden"), e.removeAttribute("minimized"), e.enableShadowDOM) {
          e.$.view.id = e.$.view.getAttribute("smart-id");

          var _t664 = e.$.view.querySelectorAll("[smart-id]");

          for (var _e742 = 0; _e742 < _t664.length; _e742++) {
            _t664[_e742].id = _t664[_e742].getAttribute("smart-id");
          }
        }

        e.$.mainContainer.scrollTop = 0, e._checkOverflow();
      }
    }
  }, {
    key: "minimize",
    value: function minimize() {
      var e = this;

      if (!e._minimized) {
        if (e.$view.addClass("smart-visibility-hidden"), e.enableShadowDOM) {
          e.$.view.removeAttribute("id");

          var _t665 = e.$.view.querySelectorAll("[smart-id]");

          for (var _e743 = 0; _e743 < _t665.length; _e743++) {
            _t665[_e743].removeAttribute("id");
          }
        }

        e._edgeMacFF && e.$view.addClass("not-in-view"), e.$hamburgerIcon.removeClass("smart-hidden"), setTimeout(function () {
          null !== e.dropDownAppendTo && e._appendMinimizedContainerToExternalElement(e.$.view), e.$view.addClass("smart-list-menu-view-minimized"), e.$.mainContainer.scrollTop = 0, e._checkOverflow();
        }, 0), e._minimized = !0, e.setAttribute("minimized", "");
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      var t = this;

      if ("string" == typeof e && (e = t.getItem(e)), void 0 !== e && (e instanceof Smart.MenuItem || e instanceof Smart.MenuItemsGroup) && (t.contains(e) || e.closest(".smart-list-menu-view") === t.$.view)) {
        var _i664 = e.parentElement;

        for (; e.contains(t._view);) {
          t._backButtonClickHandler(void 0, !0);
        }

        var _a409 = t._view;
        t.grouped && (t._home(), t._discardGrouping()), _i664.removeChild(e), t._menuItems = {}, t._refreshItemPaths(t.$.mainContainer, !0, function (e) {
          return t._getCurrentViewItems(e === t.$.mainContainer ? void 0 : e);
        }), t.grouped && (t._applyGrouping(t.$.mainContainer), _a409 && t.changePage(_a409.path)), t._toggleFilterInputGroupLabelVisibility(), t._checkOverflow();
      }
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      if ("disabled" === e || "dropDownOverlay" === e || "minimizeIconTemplate" === e || "minimizeWidth" === e || "overflow" === e || "unfocusable" === e) return void _get(_getPrototypeOf(_class67.prototype), "propertyChangedHandler", this).call(this, e, t, i);
      var a = this;

      switch (e) {
        case "animation":
          a.$.view.setAttribute("animation", i);
          break;

        case "checkable":
        case "checkboxes":
          a._minimized && null !== a.dropDownAppendTo && (i ? a.$.view.setAttribute(e, "") : a.$.view.removeAttribute(e));
          break;

        case "checkMode":
          a._changeToRadioButtonMode(i, a.$.mainContainer), a._minimized && null !== a.dropDownAppendTo && a.$.view.setAttribute("check-mode", i);
          break;

        case "dataSource":
          a.$header.addClass("smart-hidden"), a.$mainContainer.removeClass("header-shown"), a._view = void 0, a._menuItems = {}, a._topLevelFilter = "", a._processDataSource(), a._toggleFilterInputGroupLabelVisibility(), a._checkOverflow();
          break;

        case "displayLoadingIndicator":
          if (i) {
            var _e744 = a.$.mainContainer.querySelector("[hover]");

            _e744 && _e744.removeAttribute("hover"), a._discardKeyboardHover(), a.$loadingIndicatorContainer.removeClass("smart-hidden");
          } else a.$loadingIndicatorContainer.addClass("smart-hidden");

          break;

        case "dropDownAppendTo":
          {
            var _e745 = a._dropDownParent;
            if (a._positionDetection.getDropDownParent(), a._dropDownParent === _e745 || !a._minimized) return;
            a._close(), null === i ? a._appendMinimizedContainerToMenu(a.$.view, null) : a._appendMinimizedContainerToExternalElement(a.$.view), a.$.mainContainer.scrollTop = 0, a._checkOverflow();
            break;
          }

        case "dropDownPosition":
          {
            a._close(), a._minimized && null !== a.dropDownAppendTo && a.$.view.setAttribute("drop-down-position", i);
            break;
          }

        case "filterable":
          if (a._toggleFilterInputGroupLabelVisibility(!0), !1 === i) {
            "" !== a._topLevelFilter && a._applyFilter("");

            for (var _e746 = a._filteredLowerLevelGroups.length - 1; 0 <= _e746; _e746--) {
              a._applyFilter("", a._filteredLowerLevelGroups[_e746]);
            }
          }

          a._checkOverflow();

          break;

        case "filterMode":
          if (!a.filterable) return;
          "" !== a._topLevelFilter && a._applyFilter(a._topLevelFilter);

          for (var _e747 = a._filteredLowerLevelGroups.length - 1; 0 <= _e747; _e747--) {
            a._applyFilter(a._filteredLowerLevelGroups[_e747].filter, a._filteredLowerLevelGroups[_e747]);
          }

          break;

        case "grouped":
          a._home(), i ? a._applyGrouping(a.$.mainContainer) : a._discardGrouping(), a._toggleFilterInputGroupLabelVisibility(!1, !0), a._checkOverflow();
          break;

        case "loadingIndicatorPosition":
          null !== a.dropDownAppendTo && a._minimized && a.$.view.setAttribute("loading-indicator-position", i), "center" === i ? a.$loadingIndicatorPlaceHolder.addClass("smart-hidden") : a.$loadingIndicatorPlaceHolder.removeClass("smart-hidden");
          break;

        case "rightToLeft":
          i ? (a.$backButtonArrow.removeClass("smart-arrow-left"), a.$backButtonArrow.addClass("smart-arrow-right")) : (a.$backButtonArrow.removeClass("smart-arrow-right"), a.$backButtonArrow.addClass("smart-arrow-left")), i ? a.$.view.setAttribute("right-to-left", "") : a.$.view.removeAttribute("right-to-left"), Array.prototype.forEach.call(a.$.mainContainer.querySelectorAll(".smart-menu-items-group-arrow"), function (e) {
            return e.className = "smart-menu-items-group-arrow " + (a.rightToLeft ? "smart-arrow-left left" : "smart-arrow-right right");
          });
          break;

        case "theme":
          _get(_getPrototypeOf(_class67.prototype), "propertyChangedHandler", this).call(this, e, t, i), null !== a.dropDownAppendTo && a._minimized && ("" !== t && a.$view.removeClass(t), i && a.$view.addClass(i));
      }
    }
  }, {
    key: "_appendGroupLabels",
    value: function _appendGroupLabels(e, t) {
      for (var _a410 = 0; _a410 < e.length; _a410++) {
        var _i665 = document.createElement("div");

        _i665.$ = Smart.Utilities.Extend(_i665), _i665.className = "smart-list-menu-group-label", _i665.innerHTML = e[_a410], _i665.groupChildren = t[_a410], t[_a410][0].parentElement.insertBefore(_i665, t[_a410][0]);

        for (var _e748 = 0; _e748 < t[_a410].length; _e748++) {
          t[_a410][_e748].groupLabel = _i665;
        }
      }
    }
  }, {
    key: "_applyFilter",
    value: function _applyFilter(e, t) {
      var a = this,
          n = a._getCurrentViewItems(t);

      for (var _o223 = 0; _o223 < n.length; _o223++) {
        var _i666 = a._findItem(n[_o223], e);

        _i666 && _i666.hidden ? (_i666.hidden = !1, (t === a._view || a._view !== void 0 && t !== void 0 && !t.contains(a._view) || a._view === void 0) && _i666.$.removeClass("smart-hidden")) : !_i666 && (n[_o223].hidden = !0, n[_o223].$.addClass("smart-hidden"));
      }

      if (t) {
        t.filter = e;

        var _i667 = a._filteredLowerLevelGroups.indexOf(t);

        "" === e ? -1 !== _i667 && a._filteredLowerLevelGroups.splice(_i667, 1) : -1 === _i667 && a._filteredLowerLevelGroups.push(t);
      } else a._topLevelFilter = e;
    }
  }, {
    key: "_backButtonClickHandler",
    value: function _backButtonClickHandler(e, t) {
      var i = this,
          a = i._view;
      if (e && e.stopPropagation(), !a || i.disabled && e || i.displayLoadingIndicator || i._inTransition) return;
      var n = i.hasAnimation,
          o = i.animation,
          r = !1;
      n && t && (n = !1, r = !0, i.animation = "none"), i._discardKeyboardHover(), i.$scrollButtonNear.addClass("smart-hidden"), i.$scrollButtonFar.addClass("smart-hidden"), i.$mainContainer.removeClass("scroll-buttons-shown"), a.firstElementChild.classList.remove("smart-hidden"), n ? (i._inTransition = !0, a.container.$.addClass("no-transition"), a.container.$.addClass("smart-hidden"), a.$.addClass("right"), a.$.removeClass("right"), a.container.$.removeClass("no-transition")) : (a.$.removeClass("smart-menu-items-group-opened"), a.container.$.addClass("smart-hidden")), i._showHideMenuItemsGroupSiblings(a, "removeClass", n), n ? setTimeout(function () {
        a.container.style.top = a.parentElement.getBoundingClientRect().top - a.getBoundingClientRect().top + "px";
      }, 0) : r && (i.animation = o), 1 === a.level ? (i.$header.addClass("smart-hidden"), i.$mainContainer.removeClass("header-shown"), i._view = void 0) : (i.$.title.innerHTML = a.parentItem.titleLabel, i._view = a.parentItem), i._toggleFilterInputGroupLabelVisibility(), i.$.mainContainer.scrollTop = 0, n || i._checkOverflow(), e && i.focus();
    }
  }, {
    key: "_bounceBottom",
    value: function _bounceBottom(e) {
      function t() {
        n.scrollTop -= 5, n.scrollTop > e ? window.requestAnimationFrame(t) : a.$mainContainer.removeClass("bounce-bottom");
      }

      function i() {
        n.scrollTop += 5, n.scrollTop === n.scrollHeight - n.offsetHeight ? window.requestAnimationFrame(t) : window.requestAnimationFrame(i);
      }

      var a = this,
          n = a.$.mainContainer;
      a.$mainContainer.addClass("bounce-bottom"), window.requestAnimationFrame(i);
    }
  }, {
    key: "_bounceTop",
    value: function _bounceTop() {
      function e() {
        a.scrollTop -= 5, 0 < a.scrollTop ? window.requestAnimationFrame(e) : window.requestAnimationFrame(t);
      }

      function t() {
        a.scrollTop += 5, 50 === a.scrollTop ? (a.scrollTop = 0, i.$mainContainer.removeClass("bounce-top")) : window.requestAnimationFrame(t);
      }

      var i = this,
          a = i.$.mainContainer;
      i.$mainContainer.addClass("bounce-top"), window.requestAnimationFrame(e);
    }
  }, {
    key: "_checkOverflow",
    value: function _checkOverflow() {
      var e = Math.round;
      var t = this,
          i = t.overflow;

      if ("hidden" !== i) {
        var _a411 = e(t.$.mainContainer.scrollHeight) > e(t.$.mainContainer.offsetHeight),
            _n323 = 0 < e(t.$.mainContainer.scrollTop),
            _o224 = e(t.$.mainContainer.offsetHeight + t.$.mainContainer.scrollTop) < e(t.$.mainContainer.scrollHeight);

        _a411 ? "auto" === i ? (!t.$mainContainer.hasClass("scroll-buttons-shown") && t.$mainContainer.addClass("scroll-buttons-shown"), _n323 ? t.$scrollButtonNear.removeClass("smart-hidden") : t.$scrollButtonNear.addClass("smart-hidden"), _o224 ? t.$scrollButtonFar.removeClass("smart-hidden") : t.$scrollButtonFar.addClass("smart-hidden"), !1 == (_n323 && _o224) ? t.$mainContainer.addClass("one-button-shown") : t.$mainContainer.removeClass("one-button-shown"), !t.disabled && (t.$.scrollButtonNear.disabled = !1, t.$.scrollButtonFar.disabled = !1)) : (t.$scrollButtonNear.removeClass("smart-hidden"), t.$scrollButtonFar.removeClass("smart-hidden"), t.disabled ? (t.$.scrollButtonNear.disabled = !0, t.$.scrollButtonFar.disabled = !0) : (t.$.scrollButtonNear.disabled = !_n323, t.$.scrollButtonFar.disabled = !_o224)) : !_a411 && "auto" === i && t.$mainContainer.hasClass("scroll-buttons-shown") ? (t.$mainContainer.removeClass("scroll-buttons-shown"), t.$mainContainer.removeClass("one-button-shown"), t.$scrollButtonNear.addClass("smart-hidden"), t.$scrollButtonFar.addClass("smart-hidden")) : !_a411 && "scroll" === i && (t.$.scrollButtonNear.disabled = !0, t.$.scrollButtonFar.disabled = !0);
      }
    }
  }, {
    key: "_close",
    value: function _close() {
      var e = this;
      e._discardKeyboardHover(!0), e._minimized && e._minimizedDropDownOpened && (e._positionDetection.removeOverlay(), e.$view.addClass("smart-visibility-hidden"), e._edgeMacFF && (e.$.view.style.left = "", e.$.view.style.top = "", e.$view.addClass("not-in-view")), e.$hamburgerIcon.removeClass("smart-close-button"), e._minimizedDropDownOpened = !1);
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.mode = "vertical", e._positionDetection = new Smart.Utilities.PositionDetection(e), e._positionDetection.getDropDownParent(), null === e.dataSource && e.$.mainContainer.firstElementChild instanceof HTMLUListElement && e._processUList();

      var t = e.getElementsByTagName("smart-menu-item"),
          i = function i() {
        e._setFocusable(), e._menuItems = {}, e._topLevelFilter = "", e._filteredLowerLevelGroups = [], e.$.view.setAttribute("animation", e.animation), null === e.dataSource ? e._processHTML(void 0, 1) : e._processDataSource(), e._toggleFilterInputGroupLabelVisibility(), "scroll" === e.overflow && (e.$mainContainer.addClass("scroll-buttons-shown"), e.$scrollButtonNear.removeClass("smart-hidden"), e.$scrollButtonFar.removeClass("smart-hidden"), e._updateScrollButtonVisibility(e.$.mainContainer, !1, [e.$.scrollButtonNear, e.$.scrollButtonFar])), e._applyMinimizeIconTemplate(e.minimizeIconTemplate, null), null !== e.minimizeWidth && e.offsetWidth <= e.minimizeWidth ? e.minimize() : e._checkOverflow(), e.displayLoadingIndicator && e.$loadingIndicatorContainer.removeClass("smart-hidden"), "center" !== e.loadingIndicatorPosition && e.$loadingIndicatorPlaceHolder.removeClass("smart-hidden"), e.__onCompleted && (e._onCompleted = e.__onCompleted, e.__onCompleted = null, e._onCompleted());
      };

      0 === t.length ? i() : (e._onCompleted && (e.__onCompleted = e._onCompleted, e._onCompleted = null), e._ensureItemsReady(t, i));
    }
  }, {
    key: "_createMenuItemsGroupContainer",
    value: function _createMenuItemsGroupContainer(e, t) {
      var i = document.createElement("div"),
          a = document.createElement("div");
      return i.className = "smart-menu-drop-down smart-hidden", i.$ = Smart.Utilities.Extend(i), i.level = t, i.setAttribute("level", t), i.menuItemsGroup = e, a.className = "smart-menu-item-container", a.$ = Smart.Utilities.Extend(a), a.container = i, a.menuItemsGroup = e, e.checkable && a.setAttribute("checkable", ""), a.setAttribute("check-mode", e.checkMode), i.itemContainer = a, i.appendChild(a), i;
    }
  }, {
    key: "_discardGrouping",
    value: function _discardGrouping() {
      var e = this,
          t = Array.from(e.$.view.getElementsByClassName("smart-list-menu-group-label"));

      for (var _e749 = 0, _i668; _e749 < t.length; _e749++) {
        _i668 = t[_e749], _i668.parentElement.removeChild(_i668);
      }

      e._unsortItems(e.$.mainContainer);
    }
  }, {
    key: "_discardKeyboardHover",
    value: function _discardKeyboardHover() {
      var e = this;
      e._focusedViaKeyboard && (e._focusedViaKeyboard === e.$.backButton ? (e.$.backButton.removeAttribute("hover"), e.$.backButton.$.button.removeAttribute("hover")) : (e._focusedViaKeyboard.removeAttribute("focus"), e._focusedViaKeyboard.removeAttribute("hover")), e._focusedViaKeyboard = void 0);
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = e.originalEvent.target,
          a = function a(e) {
        "right" === e && !t.rightToLeft || "left" === e && t.rightToLeft ? t._backButtonClickHandler() : t._swipeDetails.target && t._selectionHandler({
          target: t._swipeDetails.target
        }, t._swipeDetails.target, !0);
      };

      return t._endSwiping(e, Date.now()), t._swipeDetails ? ("left" === t._swipeDetails.direction ? t._swipeDetails.start > e.pageX && t._swipeDetails.start - e.pageX > t.offsetWidth / 4 && a(t._swipeDetails.direction) : t._swipeDetails.start < e.pageX && e.pageX - t._swipeDetails.start > t.offsetWidth / 4 && a(t._swipeDetails.direction), void delete t._swipeDetails) : void (i === t.$.filterInput || t.disabled || t.displayLoadingIndicator || !i.closest || (t.contains(i) || i.closest(".smart-list-menu-view") === t.$.view ? (t.contains(i) || i.closest(".smart-list-menu-view") === t.$.view) && t !== document.activeElement && t.focus() : (t._close(), t._scrolling && delete t._scrolling)));
    }
  }, {
    key: "_ensureVisible",
    value: function _ensureVisible(e) {
      var t = this,
          i = t.$.mainContainer;

      if (i.$.hasClass("scroll-buttons-shown") || "hidden" === t.overflow) {
        var _a412 = i.getBoundingClientRect(),
            _n324 = e.getBoundingClientRect(),
            _o225 = [t.$.scrollButtonNear, t.$.scrollButtonFar],
            _r140 = i.scrollTop;

        (_a412.top > _n324.top || _a412.bottom < _n324.bottom) && (i.scrollTop = e.offsetTop, t._updateScrollButtonVisibility(i, !1, _o225)), t._fireScrollBottomReachedEvent(_r140);
      }
    }
  }, {
    key: "_fireScrollBottomReachedEvent",
    value: function _fireScrollBottomReachedEvent(e) {
      var t = this,
          i = t.$.mainContainer,
          a = i.scrollTop;
      e === a || a !== i.scrollHeight - i.offsetHeight || t.$.fireEvent("scrollBottomReached");
    }
  }, {
    key: "_getCurrentViewItems",
    value: function _getCurrentViewItems(e) {
      var t = this;
      if (!t.grouped) return void 0 === e ? t.$.mainContainer.children : e.container.firstElementChild.children;
      if (void 0 === e) return t.$.view.querySelectorAll(".smart-menu-main-container > smart-menu-item, .smart-menu-main-container > smart-menu-items-group");else {
        var _t666 = e.container.firstElementChild.children,
            _a413 = [];

        for (var _e750 = 0, _i669; _e750 < _t666.length; _e750++) {
          _i669 = _t666[_e750], (_i669 instanceof Smart.MenuItem || _i669 instanceof Smart.MenuItemsGroup) && _a413.push(_i669);
        }

        return _a413;
      }
    }
  }, {
    key: "_sortItems",
    value: function _sortItems(e) {
      var t = this;
      if (!t.grouped) return;
      var a = [],
          n = [];
      var o;
      e instanceof Smart.MenuItemsGroup ? o = e.container.firstElementChild : e === t.$.mainContainer && (o = e);
      var r = Array.from(o.children);
      r.sort(function (e, t) {
        return e.label.localeCompare(t.label);
      });

      for (var _t667 = r.length - 1; 0 <= _t667; _t667--) {
        o.insertBefore(r[_t667], o.firstElementChild);
      }

      for (var _t668 = 0; _t668 < r.length; _t668++) {
        var _e751 = r[_t668],
            _i670 = _e751.label.charAt(0),
            _o226 = a.indexOf(_i670.toUpperCase());

        -1 === _o226 ? (a.push(_i670.toUpperCase()), n.push([_e751])) : n[_o226].push(_e751);
      }

      t._appendGroupLabels(a, n);
    }
  }, {
    key: "_home",
    value: function _home() {
      for (var e = this; e._view;) {
        e._backButtonClickHandler(void 0, !0);
      }
    }
  }, {
    key: "_keydownHandler",
    value: function _keydownHandler(e) {
      var t = this,
          i = e.key,
          a = (t.shadowRoot || t.getRootNode()).activeElement || document.activeElement;

      if (!(a !== t || -1 === ["ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp", "End", "Enter", "Escape", "Home", " "].indexOf(i) || t.disabled || t.displayLoadingIndicator)) {
        e.preventDefault();

        var _a414 = t._view,
            _n325 = _a414 ? _a414.itemContainer : t.$.mainContainer,
            _o227 = t.$.backButton.hasAttribute("hover") ? t.$.backButton : _n325.querySelector("[focus]");

        switch (i) {
          case "ArrowDown":
            t._navigate("_getNextEnabledChild", _o227, _n325);

            break;

          case "ArrowLeft":
          case "ArrowRight":
            if ("ArrowLeft" === i && !t.rightToLeft || "ArrowRight" === i && t.rightToLeft) {
              t._backButtonClickHandler();

              break;
            }

            ("ArrowRight" === i && !t.rightToLeft || "ArrowLeft" === i && t.rightToLeft) && _o227 && _o227 instanceof Smart.MenuItemsGroup && t._menuItemsGroupSelectionHandler(_o227, {
              type: "keydown"
            });
            break;

          case "ArrowUp":
            t._navigate("_getPreviousEnabledChild", _o227, _n325);

            break;

          case "End":
          case "Home":
            {
              if (_a414 && "Home" === i) return t.$.mainContainer.scrollTop = 0, t._checkOverflow(), t.$.backButton.setAttribute("hover", ""), t.$.backButton.$.button.setAttribute("hover", ""), t._focusedViaKeyboard = t.$.backButton, void (_o227 && _o227.removeAttribute("focus"));

              var _e752 = "End" === i ? t._getLastEnabledChild(_n325) : t._getFirstEnabledChild(_n325);

              if (!_e752 || _o227 === _e752) return;
              _o227 && (_o227 === t.$.backButton ? (t.$.backButton.removeAttribute("hover"), t.$.backButton.$.button.removeAttribute("hover")) : _o227.removeAttribute("focus")), t._hoverViaKeyboard(_e752);
              break;
            }

          case "Enter":
            t._minimized && !t._minimizedDropDownOpened ? t._hamburgerIconClickHandler(void 0, t.$.view) : _o227 && (_o227 === t.$.backButton ? t._backButtonClickHandler() : t._selectionHandler({
              target: _o227
            }));
            break;

          case "Escape":
            t._minimized && t._minimizedDropDownOpened && !t._view ? t._close() : t._backButtonClickHandler();
            break;

          case " ":
            _o227 && (_o227 === t.$.backButton ? t._backButtonClickHandler() : t._toggleItem(_o227));
        }
      }
    }
  }, {
    key: "_mainContainerDownHandler",
    value: function _mainContainerDownHandler(e) {
      var t = this;
      !Smart.Utilities.Core.isMobile || t.disabled || t.displayLoadingIndicator || (t._dragStartDetails = {
        startY: e.pageY,
        x: e.pageX,
        y: e.pageY,
        startTime: Date.now(),
        target: e.originalEvent.target
      });
    }
  }, {
    key: "_mainContainerHandler",
    value: function _mainContainerHandler() {}
  }, {
    key: "_mainContainerMoveHandler",
    value: function _mainContainerMoveHandler(e) {
      var t = this;

      if (t._dragStartDetails) {
        var _i671 = e.pageY,
            _a415 = t._dragStartDetails.y - _i671,
            _n326 = t.$.mainContainer.scrollTop;

        t.$.mainContainer.scrollTop += _a415, _n326 !== t.$.mainContainer.scrollTop && (t._checkOverflow(), t._fireScrollBottomReachedEvent(_n326)), t._dragStartDetails = {
          startY: t._dragStartDetails.startY,
          x: e.pageX,
          y: _i671,
          startTime: t._dragStartDetails.startTime,
          target: e.originalEvent.target
        }, t._scrolling = !0;
      }
    }
  }, {
    key: "_mainContainerSwipeHandler",
    value: function _mainContainerSwipeHandler(e) {
      var t = this;

      if (!(!Smart.Utilities.Core.isMobile || t.disabled || t.displayLoadingIndicator)) {
        var _i672 = e.originalEvent.target,
            _a416 = _i672.closest("smart-menu-item"),
            _n327 = _i672.closest("smart-menu-items-group");

        if ("swiperight" === e.type && !t.rightToLeft || "swipeleft" === e.type && t.rightToLeft) {
          var _i673 = _a416 || _n327;

          _i673 && (delete t._dragStartDetails, delete t._scrolling, t._swipeDetails = {
            direction: e.type.replace("swipe", ""),
            start: e.pageX,
            target: _i673
          });
        } else ("swipeleft" === e.type && !t.rightToLeft || "swiperight" === e.type && t.rightToLeft && _n327 && null === _a416) && (delete t._dragStartDetails, delete t._scrolling, t._swipeDetails = {
          direction: e.type.replace("swipe", ""),
          start: e.pageX,
          target: _n327
        });
      }
    }
  }, {
    key: "_getRootDetails",
    value: function _getRootDetails(e, t) {
      var i = this;
      if (!e) return;
      if (!i.enableShadowDOM) return {
        activeElement: e.activeElement,
        isInsideElement: i.contains(t.target)
      };
      var a, n;

      for (; e && (!a && e.activeElement && (a = e.activeElement), e.host === i && (n = !0), e !== document);) {
        e = e.host ? e.host.getRootNode() : e.getRootNode();
      }

      return {
        activeElement: a,
        isInsideElement: n
      };
    }
  }, {
    key: "_menuItemsGroupSelectionHandler",
    value: function _menuItemsGroupSelectionHandler(e, t, i) {
      var a = this,
          n = e.container,
          o = n.level,
          r = a._getRootDetails(t.target ? t.target.getRootNode() : null, t);

      if (a._view === e) return;
      if (a._discardKeyboardHover(), r && r.activeElement !== a && null !== a.dropDownAppendTo && "click" === t.type && !r.isInsideElement && a.focus(), a._inTransition) return;
      if ("click" === t.type && !t.target.classList.contains("smart-menu-items-group-arrow") && a._toggleItem(e)) return void a._ripple(e, t);
      var l = a.hasAnimation,
          s = a.animation,
          d = !1;
      l && i && (l = !1, d = !0, a.animation = "none"), 2 === o && (a.$header.removeClass("smart-hidden"), a.$mainContainer.addClass("header-shown")), a.$.title.innerHTML = e.titleLabel, a._view = e, a._toggleFilterInputGroupLabelVisibility(), e.removeAttribute("hover"), e.removeAttribute("focus"), e.$.addClass("smart-menu-items-group-opened"), a._showHideMenuItemsGroupSiblings(e, "addClass", l), l ? (a._inTransition = !0, e.firstElementChild.classList.add("animate"), setTimeout(function () {
        n.style.top = e.parentElement.getBoundingClientRect().top - e.getBoundingClientRect().top + "px";
      }, 0)) : e.firstElementChild.classList.add("smart-hidden"), n.$.removeClass("smart-hidden"), d && (a.animation = s), a.$.mainContainer.scrollTop = 0, l || a._checkOverflow(), a.$.fireEvent("expand", {
        item: e,
        label: e.label,
        path: e.path,
        value: e.value
      });
    }
  }, {
    key: "_mouseoutMouseoverHandler",
    value: function _mouseoutMouseoverHandler(e) {
      var t = this;

      if (!(t.disabled || t.displayLoadingIndicator)) {
        var _i674 = e.target.closest("smart-menu-item") || e.target.closest("smart-menu-items-group");

        null === _i674 || t._view && _i674.level <= t._view.level || _i674.disabled || _i674.templateApplied || (t._discardKeyboardHover(), "mouseover" === e.type ? (_i674.setAttribute("hover", ""), t._discardKeyboardHover(!0)) : _i674.removeAttribute("hover"));
      }
    }
  }, {
    key: "_navigate",
    value: function _navigate(e, t, i) {
      var a = this;
      if (!t) return void ("_getNextEnabledChild" === e ? a._view ? (a.$.backButton.setAttribute("hover", ""), a.$.backButton.$.button.setAttribute("hover", ""), a._focusedViaKeyboard = a.$.backButton) : a._hoverViaKeyboard(a._getFirstEnabledChild(i)) : a._hoverViaKeyboard(a._getLastEnabledChild(i)));
      var n;

      if ("_getNextEnabledChild" !== e || t !== a.$.backButton) {
        if ("_getPreviousEnabledChild" === e && a._view && t === a._getFirstEnabledChild(i)) return a.$.backButton.setAttribute("hover", ""), a.$.backButton.$.button.setAttribute("hover", ""), a._focusedViaKeyboard = a.$.backButton, void t.removeAttribute("focus");
        n = a[e](t);
      } else if (n = a._getFirstEnabledChild(i), n) a.$.backButton.removeAttribute("hover"), a.$.backButton.$.button.removeAttribute("hover");else return;

      n && (t.removeAttribute("focus"), a._hoverViaKeyboard(n));
    }
  }, {
    key: "_processHTML",
    value: function _processHTML(e, t) {
      var a = this;
      var i, n;
      e === void 0 && (e = a.$.mainContainer), 1 < t && (i = a._createMenuItemsGroupContainer(e, t), n = i.itemContainer);
      var o = Array.from(e.children),
          r = [];
      var l = 0;

      for (var _s75 = 0; _s75 < o.length; _s75++) {
        if (1 < t && 0 == _s75) {
          l++;
          continue;
        }

        var _i675 = o[_s75];

        if (!(_i675 instanceof Smart.MenuItem || _i675 instanceof Smart.MenuItemsGroup)) {
          _i675.parentElement.removeChild(_i675), l++;
          continue;
        }

        a._createItemHTMLStructure(_i675, t, e, _s75 - l), _i675.checked && (_i675.disabled || _i675.templateApplied ? _i675.checked = !1 : r.push(_i675)), 1 < t && n.appendChild(_i675), _i675 instanceof Smart.MenuItemsGroup && a._processHTML(_i675, t + 1);
      }

      if (1 < t) {
        if (e.container = i, e.itemContainer = n, e instanceof Smart.MenuItemsGroup) {
          var _t669 = document.createElement("div");

          _t669.className = "smart-menu-items-group-arrow " + (a.rightToLeft ? "smart-arrow-left left" : "smart-arrow-right right"), e.children[0].appendChild(_t669);
        }

        e.appendChild(i);
      }

      a._validateRadioButtonSelection(e, t, r), a._sortItems(e);
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this,
          t = e.minimizeWidth;

      if (null !== t) {
        if (!e._minimized && e.offsetWidth <= t) return void e.minimize();
        if (e._minimized && e.offsetWidth > t) return void e.maximize();
      }

      e._checkOverflow();
    }
  }, {
    key: "_scroll",
    value: function _scroll(e) {
      var t = this,
          i = t.$.mainContainer,
          a = e.classList.contains("smart-scroll-button-near") ? -1 : 1,
          n = i.scrollTop;
      i.scrollTop += 10 * a, n !== i.scrollTop && (t._updateScrollButtonVisibility(i, !1, [t.$.scrollButtonNear, t.$.scrollButtonFar]), t._fireScrollBottomReachedEvent(n));
    }
  }, {
    key: "_selectionHandler",
    value: function _selectionHandler(e, t, i) {
      function a() {
        var t = n._getRootDetails(o.getRootNode(), e);

        t && t.activeElement !== n && null !== n.dropDownAppendTo && "click" === e.type && !t.isInsideElement && n.focus();
      }

      var n = this,
          o = e.target;

      if (!(n.disabled || n.displayLoadingIndicator)) {
        if (n._scrolling || n._swipeDetails && !i) return delete n._dragStartDetails, delete n._scrolling, void delete n._swipeDetails;

        if (void 0 === t) {
          if ("click" === e.type) {
            var _t670 = o.closest("smart-repeat-button");

            if (_t670) return void n._scroll(_t670, e);
          }

          var _i676 = o.closest("smart-menu-item");

          if (_i676) return _i676.disabled || _i676.templateApplied ? void a() : (n._toggleItem(_i676) || n.$.fireEvent("itemClick", {
            item: _i676,
            label: _i676.label,
            value: _i676.value
          }), n._ensureVisible(_i676), n._ripple(_i676, e), void a());
          if (t = o.closest("smart-menu-items-group"), t && (o === t.container || o === t.container.firstElementChild)) return;
        }

        t && !t.disabled && n._menuItemsGroupSelectionHandler(t, e);
      }
    }
  }, {
    key: "_showHideMenuItemsGroupSiblings",
    value: function _showHideMenuItemsGroupSiblings(e, t, a) {
      var i = e.parentElement,
          n = i.children;

      var _loop29 = function _loop29(_o228) {
        var i = n[_o228];
        i !== e && (i.hidden || (a ? "addClass" === t ? i.$.addClass("animate") : (i.$.removeClass("smart-hidden"), i.$.addClass("right"), setTimeout(function () {
          i.$.removeClass("right");
        }, 0)) : i.$[t]("smart-hidden")));
      };

      for (var _o228 = 0; _o228 < n.length; _o228++) {
        _loop29(_o228);
      }
    }
  }, {
    key: "_toggleFilterInputGroupLabelVisibility",
    value: function _toggleFilterInputGroupLabelVisibility(e, t) {
      var i = this,
          a = i._getCurrentViewItems(i._view).length;

      if (!0 !== t) {
        var _e753 = !i.$filterInputContainer.hasClass("smart-hidden");

        i.filterable && 1 < a ? (!_e753 && (i.$mainContainer.addClass("filter-input-shown"), i.$filterInputContainer.removeClass("smart-hidden")), i.$.filterInput.value = i._view ? i._view.filter || "" : i._topLevelFilter) : _e753 && (i.$mainContainer.removeClass("filter-input-shown"), i.$filterInputContainer.addClass("smart-hidden"));
      }

      if (!e && i.grouped && 0 < a) {
        var _e754 = i._view ? i._view.container.firstElementChild.firstElementChild.$ : i.$.mainContainer.firstElementChild.$;

        1 === a ? _e754.addClass("smart-hidden") : _e754.removeClass("smart-hidden");
      }
    }
  }, {
    key: "_viewHandler",
    value: function _viewHandler(e) {
      var t = this;

      if ("transitionend" === e.type) {
        var _i677 = e.target;
        return _i677 === t.$.view || t.$.backButton.contains(_i677) ? void 0 : (_i677.classList.contains("animate") && (_i677.classList.remove("animate"), _i677.classList.add("smart-hidden")), _i677.classList.contains("smart-menu-drop-down") && (_i677.style.top = ""), _i677.classList.contains("smart-menu-items-group-opened") && _i677.classList.remove("smart-menu-items-group-opened"), t._checkOverflow(), void (t._inTransition = !1));
      }

      if (t._minimized && null !== t.dropDownAppendTo) switch (e.type) {
        case "click":
          t._selectionHandler(e);

          break;

        case "mouseout":
          t._mouseoutMouseoverHandler(e);

          break;

        case "mouseover":
          t._mouseoutMouseoverHandler(e);

      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        displayLoadingIndicator: {
          value: !1,
          type: "boolean"
        },
        dropDownPosition: {
          value: "auto",
          allowedValues: ["top-left", "top-right", "bottom-left", "bottom-right", "auto"],
          type: "string"
        },
        filterable: {
          value: !1,
          type: "boolean"
        },
        filterInputPlaceholder: {
          value: "",
          type: "string"
        },
        filterMode: {
          value: "containsIgnoreCase",
          allowedValues: ["contains", "containsIgnoreCase", "doesNotContain", "doesNotContainIgnoreCase", "equals", "equalsIgnoreCase", "startsWith", "startsWithIgnoreCase", "endsWith", "endsWithIgnoreCase"],
          type: "string"
        },
        grouped: {
          value: !1,
          type: "boolean"
        },
        loadingIndicatorPlaceholder: {
          value: "Loading...",
          type: "string"
        },
        loadingIndicatorPosition: {
          value: "center",
          allowedValues: ["bottom", "center", "top"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        resize: "_resizeHandler",
        "backButton.click": "_backButtonClickHandler",
        "filterInput.keyup": "_filterInputKeyupHandler",
        "mainContainer.down": "_mainContainerDownHandler",
        "mainContainer.move": "_mainContainerMoveHandler",
        "mainContainer.swipeleft": "_mainContainerSwipeHandler",
        "mainContainer.swiperight": "_mainContainerSwipeHandler",
        "view.click": "_viewHandler",
        "view.mouseout": "_viewHandler",
        "view.mouseover": "_viewHandler",
        "view.transitionend": "_viewHandler",
        "view.wheel": "_wheelHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.listmenu.css"];
    }
  }]);

  return _class67;
}(Smart.Menu)), Smart("smart-tank",
/*#__PURE__*/
function (_Smart$BaseElement12) {
  "use strict";

  _inherits(_class68, _Smart$BaseElement12);

  function _class68() {
    _classCallCheck(this, _class68);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class68).apply(this, arguments));
  }

  _createClass(_class68, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" class=\"smart-container\" role=\"presentation\">\n                    <div id=\"scaleNear\" class=\"smart-scale smart-scale-near\" role=\"presentation\" aria-hidden=\"true\"></div>\n                    <div id=\"track\" class=\"smart-track\" role=\"presentation\">\n                        <div id=\"fill\" class=\"smart-value\" role=\"presentation\">\n                            <div id=\"bubbleContainer\" class=\"smart-bubble-container\" role=\"presentation\"></div>\n                            <div id=\"tooltip\" class=\"smart-tooltip\" role=\"tooltip\"><div id=\"tooltipContent\" class=\"smart-tooltip-content smart-unselectable\" role=\"presentation\"></div></div>\n                            <div id=\"thumb\" class=\"smart-thumb\">\n                                <div class=\"smart-thumb-label-container\">\n                                    <span id=\"thumbLabel\" class=\"smart-thumb-label\"></span>\n                                </div>\n                            </div>\n                        </div>\n                        <div id=\"trackTicksContainer\" class=\"smart-track-ticks-container smart-hidden\" role=\"presentation\"></div>\n                    </div>\n                    <div id=\"scaleFar\" class=\"smart-scale smart-scale-far\" role=\"presentation\" aria-hidden=\"true\"></div>\n                    <input id=\"hiddenInput\" type=\"hidden\" name=\"[[name]]\">\n                </div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class68.prototype), "ready", this).call(this);

      var e = this;
      e._redefineProperty("customTicks"), e.checkLicense();
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.setAttribute("role", "slider"), this._createElement(), e.enableShadowDOM && e.$.hiddenInput && e.appendChild(e.$.hiddenInput), _get(_getPrototypeOf(_class68.prototype), "render", this).call(this);
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      return e.$.tooltip.id || (e.$.tooltip.id = e.id + "Tooltip"), e.setAttribute("aria-describedby", e.$.tooltip.id), e.$.fill.style.transition = "none", "numeric" === e.mode ? e._getEventValue = function () {
        return e.value;
      } : e._handleDateScale(), e._setSettingsObject(), e._setDrawVariables(), e._getLayoutType(), e._numericProcessor = new Smart.Utilities.NumericProcessor(e, "scaleType"), e._numberRenderer = new Smart.Utilities.NumberRenderer(), e._isVisible() ? void (e._renderingSuspended = !1, e._setInitialComponentDisplay(), e._measurements = {}, e._wordLengthNumber = e._numericProcessor.getWordLength(e.wordLength), e._validateInitialPropertyValues(), e._setTicksAndInterval(), e._validate(!0), e._updateTooltipValue(e._drawValue), e._setFocusable(), e._setTrackSize(), e._setBubbles(), e.$.fill.style.transition = "", e.$.hiddenInput.value = e._getEventValue(), e.setAttribute("aria-orientation", e.orientation), e.setAttribute("aria-valuenow", e._getEventValue(!0))) : void (e._renderingSuspended = !0);
    }
  }, {
    key: "val",
    value: function val(e) {
      var t = this;

      if (e !== void 0) {
        if ("date" === t.mode) {
          var _i678 = Smart.Utilities.DateTime.validateDate(e);

          return _i678 = _i678.getTimeStamp(), 0 === _i678.compare(t.value) ? t._valueDate : void t._validate(!1, _i678, void 0, !0);
        }

        if (t.value.toString().toUpperCase() !== e.toString().toUpperCase()) {
          e = e.toString().replace(/\s/g, ""), t._numericProcessor.regexScientificNotation.test(e) && (e = t._numericProcessor.scientificToDecimal(e));

          var _i679 = t._discardDecimalSeparator(e.toString());

          t._validate(!1, _i679, void 0, !0), delete t._valueBeforeCoercion;
        } else return t.value = "string" == typeof e ? e : e.toString();
      } else return t._getEventValue();
    }
  }, {
    key: "_setBubbles",
    value: function _setBubbles() {
      var e = this;
      if (!e.hasAnimation) return;
      var t = document.createDocumentFragment(),
          i;

      for (var _e755 = 0; 5 > _e755; _e755++) {
        i = document.createElement("div"), i.classList.add("bubble"), i.classList.add("bubble" + (_e755 + 1)), t.appendChild(i);
      }

      e.$.bubbleContainer.appendChild(t);
    }
  }, {
    key: "_setTrackSize",
    value: function _setTrackSize() {
      var e = this;
      e._trackSize = "vertical" === e.orientation ? e.$.track.offsetWidth : e.$.track.offsetHeight;
    }
  }, {
    key: "getOptimalSize",
    value: function getOptimalSize() {
      var e = this;
      if (e._renderingSuspended) return {
        width: 0,
        height: 0
      };
      var t, i, a;

      switch (e.labelsVisibility) {
        case "all":
          i = e._numericProcessor._longestLabelSize;
          break;

        case "endPoints":
          i = Math.max(e._tickIntervalHandler.labelsSize.minLabelOtherSize, e._tickIntervalHandler.labelsSize.maxLabelOtherSize);
          break;

        case "none":
          i = 0;
      }

      switch (e.orientation) {
        case "horizontal":
          return t = {
            marginA: "marginBottom",
            marginB: "marginTop",
            nearScaleDistance: "bottom",
            farScaleDistance: "top",
            paddingA: "paddingBottom",
            paddingB: "paddingTop",
            offset: "offsetWidth",
            distance: "left"
          }, e._orientationChanged && (t.offset = "offsetHeight", e._trackChanged = !0), a = e._getSize(i, t), {
            width: a.optimalOtherSize,
            height: a.optimalSize
          };

        case "vertical":
          return t = {
            marginA: "marginLeft",
            marginB: "marginRight",
            nearScaleDistance: "right",
            farScaleDistance: "left",
            paddingA: "paddingLeft",
            paddingB: "paddingRight",
            offset: "offsetHeight",
            distance: "top"
          }, e._orientationChanged && (t.offset = "offsetWidth", e._trackChanged = !0), a = e._getSize(i, t), {
            width: a.optimalSize,
            height: a.optimalOtherSize
          };
      }
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = Math.log10,
          n = Math.pow;

      _get(_getPrototypeOf(_class68.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var o = this;
      if (!o._isVisible() || o._renderingSuspended) return void (o._renderingSuspended = !0);
      if (i == t) return void (o[e] = t);

      switch (e) {
        case "labelsVisibility":
        case "ticksVisibility":
          return void o._updateScaleWidth(o._numericProcessor._longestLabelSize);

        case "coerce":
          if (i) {
            var _e756 = o.value,
                _t671 = i = o.logarithmicScale ? n(10, o._numericProcessor.getCoercedValue(a(_e756))) : o._numericProcessor.getCoercedValue(_e756);

            o._validate(!1, _t671, !0, !0), o._valueBeforeCoercion = _e756;
          } else void 0 !== o._valueBeforeCoercion && o._validate(!1, o._valueBeforeCoercion, !1, !0);

          return;

        case "interval":
          {
            o._numericProcessor.validateInterval(i);

            var _e757 = i = o.logarithmicScale ? n(10, o._numericProcessor.getCoercedValue(a(o.value))) : o._numericProcessor.getCoercedValue(o.value);

            o._validate(!1, _e757, o.coerce, !0);

            break;
          }

        case "min":
        case "max":
          {
            "date" === o.mode && (delete o._dateInterval, o[e] = Smart.Utilities.DateTime.validateDate(i).getTimeStamp()), o._validateMinMax(e, !1, t);

            var _a417 = o._numericProcessor.createDescriptor(o._discardDecimalSeparator(o.value, o.decimalSeparator), void 0, !0, "strict" === o.validation);

            o._setTicksAndInterval(), o._numericProcessor.updateValue(_a417);

            var _n328 = o.getOptimalSize(),
                _r141 = o.getBoundingClientRect(),
                _l103 = o.$.track.getBoundingClientRect();

            _n328.width > _r141.width && 20 > _l103.width && (o.style.width = _n328.width + "px", o.style.height = _n328.height + "px");
            break;
          }

        case "inverted":
        case "rightToLeft":
          {
            o._getLayoutType(), o._normalLayout && (o.$.fill.style[o._settings.margin] = "0px");

            var _e758 = o._numericProcessor.createDescriptor(o.value),
                _t672 = o._numericProcessor.validate(_e758, o._minObject, o._maxObject);

            o._setTicksAndInterval(), o._numericProcessor.updateValue(_t672);
            break;
          }

        case "orientation":
          {
            var _e759 = o.$.fill.style,
                _t673 = o.$.container.style;

            switch (!0 !== o._orientationChanged && (o._orientationChanged = !0), o._tankSizeBeforeOrientation = {
              width: o.offsetWidth,
              height: o.offsetHeight
            }, o._setSettingsObject(), o._getLayoutType(), o.rightToLeft && (_e759.marginLeft = "0"), o.inverted && (_e759.marginTop = "0", _e759.marginLeft = "0"), o.orientation) {
              case "vertical":
                o.inverted || (_e759.marginTop = "auto", _e759.marginLeft = "0"), _e759.width = "100%", _t673.paddingLeft = "0", _t673.paddingRight = "0";
                break;

              case "horizontal":
                o.inverted && (o.inverted || o.rightToLeft) && (!o.rightToLeft || !o.inverted) || (_e759.marginTop = "0", _e759.marginLeft = "auto"), _e759.height = "100%", _t673.paddingTop = "0", _t673.paddingBottom = "0";
            }

            o._validateMinMax("both");

            var _a418 = o._numericProcessor.createDescriptor(o.value),
                _n329 = o._numericProcessor.validate(_a418, o._minObject, o._maxObject);

            o._setTicksAndInterval(), o._setTicksAndInterval(), o._numericProcessor.updateValue(_n329), o._trackChanged = !0, o.setAttribute("aria-orientation", i);
            break;
          }

        case "significantDigits":
        case "precisionDigits":
          {
            if ("date" === o.mode) return;

            if ("precisionDigits" === e && "integer" === o.scaleType && o.error(o.localize("noInteger", {
              elementType: o.nodeName.toLowerCase(),
              property: e
            })), "significantDigits" === e && null !== o.precisionDigits ? o.precisionDigits = null : "precisionDigits" == e && null !== o.significantDigits && (o.significantDigits = null), o._validateInitialPropertyValues(), o._setTicksAndInterval(), "horizontal" === o.orientation && (o.inverted || o.rightToLeft)) {
              var _e760 = o._numericProcessor.valueToPx(o._numericProcessor.getCoercedValue(o._drawValue));

              o.updateFillSizeAndPosition(_e760, o._settings.margin, i, !1);
            }

            break;
          }

        case "decimalSeparator":
          {
            if ("integer" === o.scaleType || "date" === o.mode) return;

            var _e761 = o._discardDecimalSeparator(o.value, t),
                _i680 = o._applyDecimalSeparator(_e761);

            o.value = _e761, delete o._valueBeforeCoercion, o._numericProcessor.addTicksAndLabels(), o._updateTooltipValue(_i680);
            break;
          }

        case "value":
          {
            if (o.value = t, null === i) return;

            if ("date" === o.mode) {
              var _e762 = Smart.Utilities.DateTime.validateDate(i);

              return _e762 = _e762.getTimeStamp(), void (0 !== _e762.compare(t) && o._validate(!1, _e762, void 0, !0));
            }

            if (i.toString().toUpperCase() !== t.toString().toUpperCase()) {
              var _e763 = void 0 === i ? t.toString().replace(/\s/g, "") : i.toString().replace(/\s/g, "");

              o._numericProcessor.regexScientificNotation.test(_e763) && (_e763 = o._numericProcessor.scientificToDecimal(_e763)), o._validate(!1, _e763, void 0, !0), delete o._valueBeforeCoercion;
            } else o.value = "string" == typeof i ? i : i.toString();

            break;
          }

        case "scaleType":
          if ("date" === o.mode) return void (o.scaleType = "integer");

          o._changeScaleType(t, i);

          break;

        case "disabled":
        case "unfocusable":
          o._setFocusable();

          break;

        case "showUnit":
        case "unit":
          {
            o._setTicksAndInterval(), o._moveThumbBasedOnValue(o._drawValue);
            break;
          }

        case "tooltipPosition":
          break;

        case "wordLength":
          {
            if ("date" === o.mode) return void (o.wordLength = "uint64");
            o._wordLengthNumber = o._numericProcessor.getWordLength(i), o._validateMinMax("both");

            var _e764 = o._numericProcessor.createDescriptor(o.value),
                _t674 = o._numericProcessor.validate(_e764, o._minObject, o._maxObject);

            o._setTicksAndInterval(), o._numericProcessor.updateValue(_t674);
            break;
          }

        case "scalePosition":
          {
            o._setInitialComponentDisplay(), o._setTicksAndInterval(), o._moveThumbBasedOnValue(o._drawValue);
            break;
          }

        case "labelFormatFunction":
        case "scientificNotation":
          {
            if ("date" === o.mode && "scientificNotation" === e) return;

            var _t675 = o._discardDecimalSeparator(o.value, o.decimalSeparator);

            o._setTicksAndInterval(), o._updateTooltipValue(_t675);
            break;
          }

        case "logarithmicScale":
          if ("date" === o.mode) return void (o.logarithmicScale = !1);
          o._validateMinMax("both"), o._setTicksAndInterval(), o._validate(!1, o.value, void 0, !0);
          break;

        case "ticksPosition":
          "scale" === i ? (o.$trackTicksContainer.addClass("smart-hidden"), o.$.trackTicksContainer.innerHTML = "") : o.$trackTicksContainer.removeClass("smart-hidden"), o._numericProcessor.addTicksAndLabels();
          break;

        case "customInterval":
          i ? (o._customTicks && (o.customTicks = o._customTicks), o._numericProcessor.validateCustomTicks()) : "date" === o.mode && (o._customTicks = o.customTicks), o._setTicksAndInterval(), o._coerceCustomInterval();
          break;

        case "customTicks":
          if ("date" === o.mode && !o.customInterval) return o._customTicks = i, void (o.customTicks = t);
          o._numericProcessor.validateCustomTicks(), o.customInterval && (o._setTicksAndInterval(), o._coerceCustomInterval());
          break;

        case "dateLabelFormatString":
          "date" === o.mode && o._setTicksAndInterval();
          break;

        case "mode":
          o.mode = t;
          break;

        case "showThumbLabel":
          i && o.showTooltip && (o.showTooltip = !1);
          break;

        case "showTooltip":
          i && o.showThumbLabel && (o.showThumbLabel = !1);
          break;

        case "validation":
          "strict" === i && o._validate(!1, o.value);
      }
    }
  }, {
    key: "_setSettingsObject",
    value: function _setSettingsObject() {
      var e = this;
      e._settings = "horizontal" === e.orientation ? {
        clientSize: "clientWidth",
        dimension: "width",
        leftOrTop: "left",
        margin: "marginLeft",
        offset: "offsetLeft",
        otherSize: "offsetHeight",
        size: "offsetWidth",
        page: "pageX"
      } : {
        clientSize: "clientHeight",
        dimension: "height",
        leftOrTop: "top",
        margin: "marginTop",
        offset: "offsetTop",
        otherSize: "offsetWidth",
        size: "offsetHeight",
        page: "pageY"
      };
    }
  }, {
    key: "_setInitialComponentDisplay",
    value: function _setInitialComponentDisplay() {
      var e = this;

      switch (e.scalePosition) {
        case "near":
          e.$scaleNear.removeClass("smart-hidden"), e.$scaleFar.addClass("smart-hidden");
          break;

        case "far":
          e.$scaleNear.addClass("smart-hidden"), e.$scaleFar.removeClass("smart-hidden");
          break;

        case "both":
          e.$scaleFar.removeClass("smart-hidden"), e.$scaleNear.removeClass("smart-hidden");
          break;

        case "none":
          e.$scaleFar.addClass("smart-hidden"), e.$scaleNear.addClass("smart-hidden");
      }

      e.$tooltip.addClass("smart-hidden"), "track" === e.ticksPosition && e.$trackTicksContainer.removeClass("smart-hidden");
    }
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler() {
      var e = this;
      return e._isVisible() ? e._renderingSuspended ? void e._createElement() : void (e._renderingSuspended || (e._setTicksAndInterval(), e._moveThumbBasedOnValue(e._drawValue))) : void (e._renderingSuspended = !0);
    }
  }, {
    key: "_validateInitialPropertyValues",
    value: function _validateInitialPropertyValues() {
      var e = this,
          t = typeof e.value === String ? e.value.replace(/\s/g, "") : e.value.toString().replace(/\s/g, "");
      "numeric" === e.mode && e._numericProcessor.regexScientificNotation.test(t) && (e.value = e._numericProcessor.scientificToDecimal(t), delete e._valueBeforeCoercion), e.significantDigits = null === e.significantDigits ? null : Math.min(Math.max(e.significantDigits, 1), 21), null === e.significantDigits && null === e.precisionDigits ? e.significantDigits = 8 : null !== e.significantDigits && null !== e.precisionDigits && e.error(e.localize("significantPrecisionDigits", {
        elementType: e.nodeName.toLowerCase()
      })), e._validateMinMax("both", !0), e.showTooltip && e.showThumbLabel && (e.showTooltip = !1);
    }
  }, {
    key: "_validateMinMax",
    value: function _validateMinMax(e, t, i) {
      function a(e, i) {
        n._numericProcessor.validateMinMax("min" === e || t, "max" === e || t);

        var a = n["_" + e + "Object"];
        var l = "min" === e ? 0 >= n._numericProcessor.compare(n.max, a, !0) : 0 < n._numericProcessor.compare(n.min, a, !0);
        l ? i ? (n._numberRenderer = new Smart.Utilities.NumberRenderer(i), "min" === e ? o = !1 : r = !1, n[e] = i, n["_" + e + "Object"] = i) : n.error(n.localize("invalidMinOrMax", {
          elementType: n.nodeName.toLowerCase(),
          property: e
        })) : (n._numberRenderer = new Smart.Utilities.NumberRenderer(a), n[e] = n["_" + e + "Object"]);
      }

      var n = this;
      var o = "min" === e || "both" === e,
          r = "max" === e || "both" === e;
      typeof t === void 0 && (t = !1), "both" === e ? (a("min", i), a("max", i)) : a(e, i), n.logarithmicScale ? n._validateOnLogarithmicScale(o, r, i) : (n._drawMin = n.min, n._drawMax = n.max), n.min = n.min.toString(), n.max = n.max.toString(), n._minObject = n._numericProcessor.createDescriptor(n.min), n._maxObject = n._numericProcessor.createDescriptor(n.max), "date" === n.mode && (n._minDate = Smart.Utilities.DateTime.fromFullTimeStamp(n.min), n._maxDate = Smart.Utilities.DateTime.fromFullTimeStamp(n.max)), n._numericProcessor.validateInterval(n.interval), n.customInterval && n._numericProcessor.validateCustomTicks(), "numeric" === n.mode ? (n.setAttribute("aria-valuemin", n.min), n.setAttribute("aria-valuemax", n.max)) : (n.setAttribute("aria-valuemin", n._minDate.toString("f")), n.setAttribute("aria-valuemax", n._maxDate.toString("f")));
    }
  }, {
    key: "_calculateTickInterval",
    value: function _calculateTickInterval() {
      var e = this;

      var t = e._tickIntervalHandler.getInterval("linear", e._drawMin, e._drawMax, e.$.track, e.logarithmicScale);

      t.major === e._majorTicksInterval ? e._intervalHasChanged = !0 : (e._intervalHasChanged = !0, e._majorTicksInterval = t.major), e._minorTicksInterval = t.minor, "date" === e.mode && e._calculateDateInterval(t.major);
    }
  }, {
    key: "_calculateDateInterval",
    value: function _calculateDateInterval(e) {
      var t = this,
          i = {
        month: "2628000000000000000000000000000",
        day: "86400000000000000000000000000",
        hour: "3600000000000000000000000000",
        minute: "60000000000000000000000000",
        second: "1000000000000000000000000"
      };
      var a = "year",
          n = new Smart.Utilities.BigNumber("31536000000000000000000000000000"),
          o = n.subtract(e).abs(),
          r = new Smart.Utilities.BigNumber(t.min).subtract(t.max).abs(),
          l = r.divide(e).toString();

      for (var _t676 in 2 > l && (e = r.divide(3)), i) {
        if (i.hasOwnProperty(_t676)) {
          var _r142 = new Smart.Utilities.BigNumber(i[_t676]),
              _l104 = _r142.subtract(e).abs();

          if (-1 === _l104.compare(o)) a = _t676, n = _r142, o = _l104;else break;
        }
      }

      if ("second" == a) {
        if (t._numberRenderer.numericValue = parseFloat(e), 1e3 > t._numberRenderer.numericValue) return t._dateIncrementMethod = "addYoctoseconds", void (t._dateIntervalNumber = 1);

        var _i681 = t._numberRenderer.toScientific(10);

        return _i681 = _i681.charAt(_i681.length - 1), t._dateIncrementMethod = t._unitToMethod[_i681], void (t._dateIntervalNumber = Math.pow(10, t._numericProcessor.prefixesToPowers[_i681]));
      }

      t._dateInterval = !0;
      var s = !t.customInterval;
      var d, c, m;

      switch (s && (d = [new Smart.Utilities.BigNumber(t.min)], c = r.divide(n).toString(), m = Math.max(1, Math.floor(c / l))), a) {
        case "year":
          if (s) for (var _e765 = t._minDate.year() + m; _e765 < t._maxDate.year(); _e765 += m) {
            d.push(new Smart.Utilities.BigNumber(new Smart.Utilities.DateTime(_e765, 1, 1).getTimeStamp()));
          }
          t._dateIncrementMethod = "addYears";
          break;

        case "month":
          if (s) for (var _e766 = new Smart.Utilities.DateTime(t._minDate.year(), t._minDate.month() + m, 1); -1 === _e766.compare(t._maxDate); _e766.addMonths(m, !1)) {
            d.push(new Smart.Utilities.BigNumber(_e766.getTimeStamp()));
          }
          t._dateIncrementMethod = "addMonths";
          break;

        case "day":
          if (s) for (var _e767 = new Smart.Utilities.DateTime(t._minDate.year(), t._minDate.month(), t._minDate.day() + m); -1 === _e767.compare(t._maxDate); _e767.addDays(m, !1)) {
            d.push(new Smart.Utilities.BigNumber(_e767.getTimeStamp()));
          }
          t._dateIncrementMethod = "addDays", t._dateIntervalNumber = 864e26;
          break;

        case "hour":
          if (s) for (var _e768 = new Smart.Utilities.DateTime(t._minDate.year(), t._minDate.month(), t._minDate.day(), t._minDate.hour() + m); -1 === _e768.compare(t._maxDate); _e768.addHours(m, !1)) {
            d.push(new Smart.Utilities.BigNumber(_e768.getTimeStamp()));
          }
          t._dateIncrementMethod = "addHours", t._dateIntervalNumber = 36e26;
          break;

        case "minute":
          if (s) for (var _e769 = new Smart.Utilities.DateTime(t._minDate.year(), t._minDate.month(), t._minDate.day(), t._minDate.hour(), t._minDate.minute() + m); -1 === _e769.compare(t._maxDate); _e769.addMinutes(m, !1)) {
            d.push(new Smart.Utilities.BigNumber(_e769.getTimeStamp()));
          }
          t._dateIncrementMethod = "addMinutes", t._dateIntervalNumber = 6e25;
      }

      s && (-1 === d[d.length - 1].compare(t.max) && d.push(new Smart.Utilities.BigNumber(t.max)), t.customTicks = d);
    }
  }, {
    key: "_formatNumber",
    value: function _formatNumber(e) {
      var t = Math.round;
      var i = this;

      if ("date" === i.mode) {
        var _t677 = Smart.Utilities.DateTime.fromFullTimeStamp(e);

        return _t677.toString(i.dateLabelFormatString);
      }

      var a = i._numberRenderer;
      var n = parseFloat(e);
      if (a.numericValue = e, i.scientificNotation) n = i._numberRenderer.toScientific(i.significantDigits, i.precisionDigits);else switch (i.scaleType) {
        case "floatingPoint":
          n = i._applyDecimalSeparator(a.toDigits(i.significantDigits, i.precisionDigits));
          break;

        case "integer":
          n = a.isENotation(n) ? t(a.largeExponentialToDecimal(n)) : t(n), n = a.toDigits(i.significantDigits, 0);
      }
      return n;
    }
  }, {
    key: "_formatLabel",
    value: function _formatLabel(e, t) {
      var i = this;
      var a;
      return i.labelFormatFunction && ("date" === i.mode && (e = Smart.Utilities.DateTime.fromFullTimeStamp(e)), a = i.labelFormatFunction(e), void 0 !== a && "" !== a) ? a : (a = i._formatNumber(e), i._numberRenderer = new Smart.Utilities.NumberRenderer(a), i.showUnit && (!1 === t ? a += " " + i.unit : a += " <span class=\"smart-unselectable\">" + i.unit + "</span>"), a);
    }
  }, {
    key: "_layout",
    value: function _layout() {
      var e = this,
          t = e.$.container.style,
          i = e._tickIntervalHandler.labelsSize.minLabelSize / 2 + "px",
          a = e._tickIntervalHandler.labelsSize.maxLabelSize / 2 + "px";

      switch (e.orientation) {
        case "horizontal":
          if ("none" === e.scalePosition) {
            t.paddingLeft = "", t.paddingRight = "";
            break;
          }

          !e.inverted && !e.rightToLeft || e.rightToLeft && e.inverted ? (t.paddingLeft = i, t.paddingRight = a) : (t.paddingLeft = a, t.paddingRight = i);
          break;

        case "vertical":
          if ("none" === e.scalePosition) {
            t.paddingTop = "", t.paddingBottom = "";
            break;
          }

          e.inverted ? (t.paddingBottom = a, t.paddingTop = i) : (t.paddingBottom = i, t.paddingTop = a);
      }

      e._measurements.trackLength = e.$.track[this._settings.clientSize];
    }
  }, {
    key: "_trackDownHandler",
    value: function _trackDownHandler(e) {
      var t = this;
      t.disabled || t.readonly || !Smart.Utilities.Core.isMobile && 0 !== e.button || ("switchUntilReleased" === t.mechanicalAction && (t._cachedValue = {}, t._cachedValue._number = t._number, t._cachedValue._drawValue = t._drawValue, t._cachedValue.value = t.value, t._valueDate && (t._cachedValue._valueDate = t._valueDate)), t._getTrackStartAndEnd(), t._moveThumbBasedOnCoordinates(e, !0, "switchWhenReleased" !== t.mechanicalAction), t._thumbDragged = !0, t.$track.addClass("smart-dragged"), t.showTooltip && t.$tooltip.removeClass("smart-hidden"));
    }
  }, {
    key: "_trackMoveHandler",
    value: function _trackMoveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = this;
      t._thumbDragged && (e.originalEvent.preventDefault(), t._moveThumbBasedOnCoordinates(e, !0, "switchWhenReleased" !== t.mechanicalAction), t.$fill.addClass("disable-animation"));
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;

      if (t._thumbDragged) {
        if ("switchWhenReleased" === t.mechanicalAction) t._moveThumbBasedOnCoordinates(e, !0, !0);else if ("switchUntilReleased" === t.mechanicalAction && t._numericProcessor.compare(t._number, t._cachedValue._number)) {
          var _e770 = t._getEventValue();

          t._number = t._cachedValue._number, t._drawValue = t._cachedValue._drawValue, t._cachedValue._valueDate && (t._valueDate = t._cachedValue._valueDate), t.value = t._cachedValue.value, t._moveThumbBasedOnValue(t._drawValue);

          var _i682 = t._getEventValue();

          t.$.fireEvent("change", {
            value: _i682,
            oldValue: _e770
          }), t.$.hiddenInput.value = _i682, t.setAttribute("aria-valuenow", t._getEventValue(!0));
        }
        t.showTooltip && t.$tooltip.addClass("smart-hidden"), t._thumbDragged = !1, t.$track.removeClass("smart-dragged"), t.$fill.removeClass("disable-animation");
      }
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      var t = this;
      t._thumbDragged && e.preventDefault();
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      return e._isVisible() ? e._renderingSuspended ? void e._createElement() : void (e._renderingSuspended || (!0 !== e._orientationChanged && (e._setTicksAndInterval(), e._moveThumbBasedOnValue(e._drawValue)), e._trackChanged && (e._measurements.trackLength = e.$.track[this._settings.clientSize], e._setTicksAndInterval(), e._moveThumbBasedOnValue(e._drawValue)), e._setTrackSize(), delete e._orientationChanged, delete e._trackChanged)) : void (e._renderingSuspended = !0);
    }
  }, {
    key: "_moveThumbBasedOnCoordinates",
    value: function _moveThumbBasedOnCoordinates(e, t, i) {
      var a = Math.min,
          n = Math.max;
      var o = this;

      var r = t ? a(n(e[o._settings.page], o._trackStart), o._trackEnd) : e[o._settings.page],
          l = o._numericProcessor.pxToValue(r);

      o.logarithmicScale ? (o._drawValue = Math.log10(l), l = o._numericProcessor.getCoercedValue(o._drawValue)) : (o._drawValue = l, l = o._numericProcessor.getCoercedValue(l)), r = a(n(o._numericProcessor.valueToPx(l) + o._trackStart, o._trackStart), o._trackEnd);
      var s = r - o._trackStart;
      o.updateFillSizeAndPosition(s, o._settings.margin, l, !0, i), e.originalEvent && e.originalEvent.stopPropagation();
    }
  }, {
    key: "_moveThumbBasedOnValue",
    value: function _moveThumbBasedOnValue(e) {
      var t = this,
          i = t._numericProcessor.valueToPx(t._numericProcessor.getCoercedValue(e));

      t.updateFillSizeAndPosition(i, t._settings.margin, e, !0);
    }
  }, {
    key: "updateFillSizeAndPosition",
    value: function updateFillSizeAndPosition(e, t, i, a, n) {
      var o = this,
          r = o.$.fill.style;

      if (o._normalLayout ? r[o._settings.dimension] = e + "px" : (r[o._settings.dimension] = Math.min(o._measurements.trackLength, Math.max(0, o._measurements.trackLength - e)) + "px", r[t] = e + "px"), a) {
        var _e771 = o.value;
        delete o._valueBeforeCoercion, o._numericProcessor.updateToolTipAndValue(i, _e771, n);
      }
    }
  }, {
    key: "_updateTooltipValue",
    value: function _updateTooltipValue(e) {
      var t = this;
      e === void 0 && (e = t.value), t.logarithmicScale && (e = Math.pow(10, e.toString())), e = t._formatLabel(e), t.$.tooltipContent.innerHTML = e, t.$.thumbLabel.innerHTML = e;
    }
  }, {
    key: "_getSize",
    value: function _getSize(e, t) {
      function i(e, t) {
        var i = e.getElementsByClassName("smart-label");
        l = i[0], s = i[i.length - 1];
        var a = window.getComputedStyle(i[0])[t];
        d += parseFloat(a);
      }

      var a = this,
          n = window.getComputedStyle(a),
          o = window.getComputedStyle(a.$.track),
          r = a._trackSize + parseFloat(o[t.marginA]) + parseFloat(o[t.marginB]);
      var l, s, d, c;

      switch (d = r, a.scalePosition) {
        case "none":
          return d += parseFloat(n[t.paddingA]) + parseFloat(n[t.paddingB]), c = "undefined" == typeof a._tankSizeBeforeOrientation ? "horizontal" === a.orientation ? parseFloat(o.width) : parseFloat(o.height) : "horizontal" === a.orientation ? a._tankSizeBeforeOrientation.height : a._tankSizeBeforeOrientation.width, !0 !== a._trackChanged && (a._trackChanged = !0), {
            optimalSize: d,
            optimalOtherSize: c
          };

        case "near":
          d += e, i(a.$.scaleNear, t.nearScaleDistance);
          break;

        case "far":
          d += e, i(a.$.scaleFar, t.farScaleDistance);
          break;

        case "both":
          d += 2 * e, i(a.$.scaleNear, t.nearScaleDistance), i(a.$.scaleFar, t.farScaleDistance);
      }

      var m, u, p;
      return d += parseFloat(n[t.paddingA]) + parseFloat(n[t.paddingB]), m = l.getBoundingClientRect(), u = s.getBoundingClientRect(), c = a[t.offset], p = m[t.distance] + l[t.offset] - u[t.distance], 0 < p && (c = l[t.offset] + s[t.offset]), {
        optimalSize: d,
        optimalOtherSize: c
      };
    }
  }, {
    key: "_getRange",
    value: function _getRange() {
      var e = this;
      return e.logarithmicScale ? void (e._range = e._drawMax - e._drawMin) : void ("floatingPoint" === e.scaleType ? e._range = (e._drawMax - e._drawMin).toString() : e._range = new Smart.Utilities.BigNumber(e._drawMax).subtract(e._drawMin).toString());
    }
  }, {
    key: "_getTrackStartAndEnd",
    value: function _getTrackStartAndEnd() {
      var e = this;
      var t = e.$.track.getBoundingClientRect(),
          i;

      if ("horizontal" === e.orientation) {
        var _e772 = document.body.scrollLeft || document.documentElement.scrollLeft;

        i = t.left + _e772;
      } else {
        var _e773 = document.body.scrollTop || document.documentElement.scrollTop;

        i = t.top + _e773;
      }

      var a = i + e._measurements.trackLength,
          n = a - i;
      e._trackStart = i, e._trackEnd = a, e._valuePerPx = e._numericProcessor.getValuePerPx(e._range, n);
    }
  }, {
    key: "_updateScaleWidth",
    value: function _updateScaleWidth(e) {
      var t = Math.max;
      var i = this;
      var a = "track" === i.ticksPosition ? 4 : 12;

      switch (i.labelsVisibility) {
        case "all":
          e = i._numericProcessor._longestLabelSize;
          break;

        case "endPoints":
          e = t(i._tickIntervalHandler.labelsSize.minLabelOtherSize, i._tickIntervalHandler.labelsSize.maxLabelOtherSize);
          break;

        case "none":
          e = 0;
      }

      var n = a + e,
          o = window.getComputedStyle(i.$.track),
          r = !!o.getPropertyValue("--smart-tank-scale-size");
      if (r) i.$.container.style.setProperty("--smart-tank-scale-size", n + "px");else {
        var _e774 = window.getComputedStyle(i),
            _a419 = i.$.scaleNear.style,
            _r143 = i.$.scaleFar.style,
            _l105 = i.$.track.style,
            _s76 = parseFloat(o.getPropertyValue("min-width"));

        var d = parseFloat(o.getPropertyValue("outline-width")) || 0,
            c = parseFloat(o.getPropertyValue("outline-offset")) || 0,
            m = d + c,
            u,
            p,
            g,
            h,
            _;

        switch (i.orientation) {
          case "horizontal":
            u = "height", p = "width", g = i.offsetHeight, _ = parseFloat(_e774.getPropertyValue("padding-top")) + parseFloat(_e774.getPropertyValue("padding-bottom")), h = parseFloat(o.getPropertyValue("margin-top")) + parseFloat(o.getPropertyValue("margin-bottom"));
            break;

          case "vertical":
            u = "width", p = "height", g = i.offsetWidth, _ = parseFloat(_e774.getPropertyValue("padding-left")) + parseFloat(_e774.getPropertyValue("padding-right")), h = parseFloat(o.getPropertyValue("margin-left")) + parseFloat(o.getPropertyValue("margin-right"));
        }

        switch (i.scalePosition) {
          case "near":
            _a419.setProperty(u, n + "px"), _l105.setProperty(u, t(isNaN ? 0 : _s76, g - _ - n - 4 - h - m) + "px");
            break;

          case "far":
            _r143.setProperty(u, n + "px"), _l105.setProperty(u, t(isNaN ? 0 : _s76, g - _ - n - 4 - h - m) + "px");
            break;

          case "both":
            _a419.setProperty(u, n + "px"), _r143.setProperty(u, n + "px"), _l105.setProperty(u, t(isNaN ? 0 : _s76, g - _ - 2 * n - 4 - h - m) + "px");
            break;

          case "none":
            _l105.setProperty(u, "");

        }

        _l105.setProperty(p, "100%"), _a419.setProperty(p, "100%"), _r143.setProperty(p, "100%");
      }
    }
  }, {
    key: "_appendTicksAndLabelsToScales",
    value: function _appendTicksAndLabelsToScales(e, t) {
      function i(i) {
        i.innerHTML = t, "scale" === a.ticksPosition && (i.innerHTML += e);
      }

      var a = this;

      switch (a.scalePosition) {
        case "near":
          i(a.$.scaleNear);
          break;

        case "far":
          i(a.$.scaleFar);
          break;

        case "both":
          i(a.$.scaleNear), i(a.$.scaleFar);
      }

      "track" === a.ticksPosition && (a.$.trackTicksContainer.innerHTML = e);
    }
  }, {
    key: "_discardDecimalSeparator",
    value: function _discardDecimalSeparator(e, t) {
      var i = this;

      if (void 0 === t && (t = i.decimalSeparator), "." !== t) {
        var _i683 = new RegExp(t, "g");

        return "string" == typeof e ? e.replace(_i683, ".") : e.toString().replace(_i683, ".");
      }

      return e;
    }
  }, {
    key: "_applyDecimalSeparator",
    value: function _applyDecimalSeparator(e) {
      var t = this;
      return "string" != typeof e && (e = e.toString()), "." !== t.decimalSeparator && (e = e.replace(/\./g, t.decimalSeparator)), e;
    }
  }, {
    key: "_validate",
    value: function _validate(e, t, i, a) {
      var n = Math.log10;
      var o = this;
      var r;
      o._programmaticValueIsSet = a && "interaction" === o.validation, r = e ? o.value : t;
      var l, s;
      !0 !== i && o.coerce ? (l = o._numericProcessor.createDescriptor(r, !0, !0, !0), l = o.logarithmicScale ? Math.pow(10, o._numericProcessor.getCoercedValue(n(l))) : o._numericProcessor.getCoercedValue(l), s = l) : "strict" !== o.validation && (e || o._programmaticValueIsSet) ? (l = o._numericProcessor.createDescriptor(r, !0, !0, !1), s = o._numericProcessor.validate(l, o._minObject, o._maxObject)) : (l = o._numericProcessor.createDescriptor(r, !0, !0, !0), s = l), o._numericProcessor.regexScientificNotation.test(s) && (s = o._numericProcessor.scientificToDecimal(s)), s = o._discardDecimalSeparator(s, o.decimalSeparator), e ? (o._number = s, o._drawValue = o.logarithmicScale ? n(s) : s, "numeric" === o.mode ? o.value = l.toString() : (o._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(l), o.value = l), delete o._valueBeforeCoercion, o._moveThumbBasedOnValue(o._drawValue)) : o._numericProcessor.updateValue(l), o._programmaticValueIsSet = !1;
    }
  }, {
    key: "_changeScaleType",
    value: function _changeScaleType() {
      var e = this;
      e._numericProcessor = new Smart.Utilities.NumericProcessor(e, "scaleType"), e._validateMinMax("both"), e._setTicksAndInterval(), e._scaleTypeChangedFlag = !0, e._validate(!0, e._number.toString()), e._scaleTypeChangedFlag = !1;
    }
  }, {
    key: "_setTicksAndInterval",
    value: function _setTicksAndInterval() {
      var e = this;
      if (!e._isVisible() || e._renderingSuspended) return void (e._renderingSuspended = !0);

      var t = e._formatLabel(e.min),
          i = e._formatLabel(e.max);

      e._getRange(), e._tickIntervalHandler = new Smart.Utilities.TickIntervalHandler(e, t, i, "smart-label", e._settings.size, "integer" === e.scaleType, e.logarithmicScale), e._layout(), e.customInterval ? ("date" === e.mode && e._calculateTickInterval(), e._intervalHasChanged = !0, e._numericProcessor.addCustomTicks()) : (e._calculateTickInterval(), e._dateInterval ? (e._intervalHasChanged = !0, e._numericProcessor.addCustomTicks()) : e._numericProcessor.addTicksAndLabels());
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void e.removeAttribute("tabindex") : void (e.tabIndex = 0 < e.tabIndex ? e.tabIndex : 0);
    }
  }, {
    key: "_keyIncrementDecrement",
    value: function _keyIncrementDecrement(e, t) {
      var i = this,
          a = "add" === e ? 1 : -1,
          n = void 0 === t;

      if (n && (t = i.logarithmicScale ? new Smart.Utilities.BigNumber(i._drawValue) : i._drawValue), i.customInterval && i.coerce) {
        n && (i.logarithmicScale && (t = i.value), "numeric" === i.mode && (t = t.toString()));

        var _o229, _r144;

        "numeric" === i.mode ? (_o229 = -1 === i.customTicks.indexOf(i.min) ? [i.min].concat(i.customTicks) : i.customTicks.slice(0), _r144 = _o229.indexOf(t)) : (_o229 = -1 === i.customTicks.findIndex(function (e) {
          return 0 === e.compare(i._drawMin);
        }) ? [i._drawMin].concat(i.customTicks) : i.customTicks.slice(0), _r144 = _o229.findIndex(function (e) {
          return 0 === e.compare(t);
        }));
        var _l106 = _o229[_r144 + 1 * a];
        return void 0 === _l106 ? t === i.max && "subtract" === e ? _o229[_o229.length - 2] : t : _l106;
      }

      if ("numeric" === i.mode) {
        var _a420 = i._numericProcessor.incrementDecrement(t, e, i._validInterval);

        return i.logarithmicScale && (i._drawValue = _a420, _a420 = Math.pow(10, Math.round(_a420))), _a420;
      }

      return "interaction" === i.validation && (-1 === i._valueDate.compare(i._minDate) || 1 === i._valueDate.compare(i._maxDate)) && (i._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(i._drawValue)), i._valueDate[i._dateIncrementMethod](a * parseFloat(i.interval), !1), i._drawValue = new Smart.Utilities.BigNumber(i._valueDate.getTimeStamp()), -1 === i._drawValue.compare(i._drawMin) && (i._drawValue = new Smart.Utilities.BigNumber(i._drawMin), i._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(i._drawValue)), 1 === i._drawValue.compare(i._drawMax) && (i._drawValue = new Smart.Utilities.BigNumber(i._drawMax), i._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(i._drawValue)), i._drawValue;
    }
  }, {
    key: "_keydownHandler",
    value: function _keydownHandler(e) {
      var t = this;
      if (t.disabled || t.readonly) return;
      var i = e.charCode ? e.charCode : e.which;
      if (-1 === [35, 36, 37, 38, 39, 40].indexOf(i)) return;
      var a = -1 < [35, 38, 39].indexOf(i),
          n = -1 < [36, 37, 40].indexOf(i);

      if (e.preventDefault(), "floatingPoint" !== t.scaleType) {
        var _e775 = new Smart.Utilities.BigNumber(t._drawValue);

        if (1 !== _e775.compare(t._drawMin) && n || -1 !== _e775.compare(t._drawMax) && a) return;
      } else if (parseFloat(t.value) <= parseFloat(t.min) && n || parseFloat(t.value) >= parseFloat(t.max) && a) return;

      var o;
      return 40 === i || 37 === i ? o = t._keyIncrementDecrement("subtract") : 38 === i || 39 === i ? o = t._keyIncrementDecrement("add") : 36 === i ? (t._drawValue = t._drawMin, o = t.min) : 35 === i ? (t._drawValue = t._drawMax, o = t.max) : void 0, t._validate(!1, o, i), !1;
    }
  }, {
    key: "_setDrawVariables",
    value: function _setDrawVariables() {
      var e = Math.log10;
      var t = this;
      t.logarithmicScale ? (t._drawValue = e(t.value), t._drawMin = e(t.min), t._drawMax = e(t.max)) : (t._drawValue = t.value, t._drawMin = t.min, t._drawMax = t.max);
    }
  }, {
    key: "_validateOnLogarithmicScale",
    value: function _validateOnLogarithmicScale(e, t) {
      function i(e) {
        return Math.pow(10, Math.round(a(e) - 0.7403626894942439 + .5));
      }

      var a = Math.log10;
      var n = this;
      if (e) if (0 >= n.min) n.min = 1, n._drawMin = 0;else if (0 != a(n.min) % 1) {
        var _e776 = i(parseFloat(n.min));

        _e776 > n.min && (_e776 /= 10), n._drawMin = a(n.min);
      } else n._drawMin = a(n.min);
      if (t) if (0 >= n.max) n.max = 1, n._drawMax = 0;else if (0 != a(n.max) % 1) {
        var _e777 = i(parseFloat(n.max));

        _e777 < n.max && (_e777 *= 10), n._drawMax = a(n.max);
      } else n._drawMax = a(n.max);
      "integer" === n.scaleType && (0 > n._drawMin && (n._drawMin = 0, n.min = 1), 0 > n._drawMax && (n._drawMax = 1, n.max = 10)), n._drawMax === n._drawMin && (n._drawMax = n._drawMin + 1);
    }
  }, {
    key: "_getLayoutType",
    value: function _getLayoutType() {
      var e = this,
          t = e.orientation,
          i = e.inverted,
          a = e.rightToLeft;
      e._normalLayout = "horizontal" === t && (!i && !a || a && i) || "vertical" === t && i;
    }
  }, {
    key: "_trackOnMouseEnterHandler",
    value: function _trackOnMouseEnterHandler() {
      var e = this;
      e.readonly || e.disabled || (e.$track.addClass("track-hovered"), e.$.track.setAttribute("hover", ""));
    }
  }, {
    key: "_trackOnMouseLeaveHandler",
    value: function _trackOnMouseLeaveHandler() {
      var e = this;
      e.readonly || e.disabled || (e.$track.removeClass("track-hovered"), e.$.track.removeAttribute("hover"));
    }
  }, {
    key: "_isVisible",
    value: function _isVisible() {
      var e = this;
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }
  }, {
    key: "_coerceCustomInterval",
    value: function _coerceCustomInterval() {
      var e = this;

      if (e.coerce) {
        var _t678 = e._valueBeforeCoercion,
            _i684 = e.logarithmicScale ? Math.pow(10, e._numericProcessor.getCoercedValue(Math.log10(e.value))) : e._numericProcessor.getCoercedValue(e.value);

        e._validate(!1, _i684, !0, !0), e._valueBeforeCoercion = _t678;
      }
    }
  }, {
    key: "_handleDateScale",
    value: function _handleDateScale() {
      var e = this,
          t = Smart.Utilities.DateTime;
      t || e.error(e.localize("missingReference", {
        elementType: e.nodeName.toLowerCase(),
        files: "smart.date.js"
      })), e._customTicks = e.customTicks, e._unitToMethod = {
        Y: "addSeconds",
        Z: "addMilliseconds",
        E: "addMicroseconds",
        P: "addNanoseconds",
        T: "addPicoseconds",
        G: "addFemtoseconds",
        M: "addAttoseconds",
        k: "addZeptoseconds"
      }, e._minDate = t.validateDate(e.min), e.min = e._minDate.getTimeStamp(), e._maxDate = t.validateDate(e.max), e.max = e._maxDate.getTimeStamp(), e.rangeSlider || (e._valueDate = t.validateDate(e.value), e.value = e._valueDate.getTimeStamp()), e._properties.min.serialize = "_serializeMin", e._properties.max.serialize = "_serializeMax", e._properties.value.serialize = "_serializeValue", e.scaleType = "integer", e.logarithmicScale = !1, e.wordLength = "uint64";
      var a = ["min", "max", "value"];

      var _loop30 = function _loop30(_t679) {
        var i = a[_t679];
        Object.defineProperty(e, i, {
          get: function get() {
            return e.context === e ? e.properties[i].value : e["_" + i + "Date"];
          },
          set: function set(t) {
            e.updateProperty(e, e._properties[i], t);
          }
        });
      };

      for (var _t679 = 0; _t679 < a.length; _t679++) {
        _loop30(_t679);
      }

      e._getEventValue = function (t) {
        return t ? e._valueDate.toString("f") : e._valueDate.clone();
      };
    }
  }, {
    key: "_serializeMin",
    value: function _serializeMin() {
      return this._minDate.toString();
    }
  }, {
    key: "_serializeMax",
    value: function _serializeMax() {
      return this._maxDate.toString();
    }
  }, {
    key: "_serializeValue",
    value: function _serializeValue() {
      return this._valueDate.toString();
    }
  }, {
    key: "_redefineProperty",
    value: function _redefineProperty(e) {
      var t = this;
      Object.defineProperty(t, e, {
        get: function get() {
          return t.properties[e].value;
        },
        set: function set(i) {
          function a(e, t) {
            return t instanceof Smart.Utilities.BigNumber ? t.toString() : t;
          }

          var n = t.properties[e].value,
              o = JSON.stringify(n, a),
              r = JSON.stringify(i, a);

          if (o !== r && (t.properties[e].value = i, t.isReady && (!t.ownerElement || t.ownerElement && t.ownerElement.isReady) && t.context !== t)) {
            var _a421 = t.context;
            t.context = t, t.propertyChangedHandler(e, n, i), t.context = _a421;
          }
        }
      });
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        coerce: {
          value: !1,
          type: "boolean"
        },
        customInterval: {
          value: !1,
          type: "boolean"
        },
        customTicks: {
          reflectToAttribute: !1,
          value: ["0", "50", "100"],
          type: "array"
        },
        dateLabelFormatString: {
          value: "d",
          type: "string"
        },
        decimalSeparator: {
          value: ".",
          type: "string"
        },
        interval: {
          value: "1",
          type: "any"
        },
        inverted: {
          value: !1,
          type: "boolean"
        },
        labelFormatFunction: {
          value: null,
          type: "function?"
        },
        labelsVisibility: {
          value: "all",
          allowedValues: ["all", "endPoints", "none"],
          type: "string"
        },
        logarithmicScale: {
          value: !1,
          type: "boolean"
        },
        max: {
          value: "100",
          type: "any"
        },
        mechanicalAction: {
          value: "switchWhileDragging",
          allowedValues: ["switchUntilReleased", "switchWhenReleased", "switchWhileDragging"],
          type: "string"
        },
        messages: {
          value: {
            en: {
              missingReference: "{{elementType}}: Missing reference to {{files}}.",
              significantPrecisionDigits: "{{elementType}}: the properties significantDigits and precisionDigits cannot be set at the same time.",
              invalidMinOrMax: "{{elementType}}: Invalid {{property}} value. Max cannot be lower than Min.",
              noInteger: "{{elementType}}: precisionDigits could be set only on \"floatingPoint\" scaleType."
            }
          },
          type: "object",
          extend: !0
        },
        min: {
          value: "0",
          type: "any"
        },
        mode: {
          value: "numeric",
          allowedValues: ["numeric", "date"],
          type: "string"
        },
        name: {
          value: "",
          type: "string"
        },
        orientation: {
          value: "vertical",
          allowedValues: ["horizontal", "vertical"],
          type: "string"
        },
        precisionDigits: {
          value: null,
          type: "number?"
        },
        scalePosition: {
          value: "near",
          allowedValues: ["near", "far", "both", "none"],
          type: "string"
        },
        scaleType: {
          value: "floatingPoint",
          allowedValues: ["floatingPoint", "integer"],
          type: "string"
        },
        scientificNotation: {
          value: !1,
          type: "boolean"
        },
        showThumbLabel: {
          value: !1,
          type: "boolean"
        },
        showTooltip: {
          value: !1,
          type: "boolean"
        },
        showUnit: {
          value: !1,
          type: "boolean"
        },
        significantDigits: {
          value: null,
          type: "number?"
        },
        thumbLabelPosition: {
          value: "near",
          allowedValues: ["near", "far"],
          type: "string"
        },
        ticksPosition: {
          value: "scale",
          allowedValues: ["scale", "track"],
          type: "string"
        },
        ticksVisibility: {
          value: "minor",
          allowedValues: ["major", "minor", "none"],
          type: "string"
        },
        tooltipPosition: {
          value: "near",
          allowedValues: ["near", "far"],
          type: "string"
        },
        unit: {
          value: "kg",
          type: "string"
        },
        validation: {
          value: "strict",
          allowedValues: ["strict", "interaction"],
          type: "string"
        },
        value: {
          value: "0",
          type: "any"
        },
        wordLength: {
          value: "int32",
          allowedValues: ["int8", "uint8", "int16", "uint16", "int32", "uint32", "int64", "uint64"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "track.down": "_trackDownHandler",
        "track.move": "_trackMoveHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler",
        keydown: "_keydownHandler",
        resize: "_resizeHandler",
        styleChanged: "_styleChangedHandler",
        "document.selectstart": "_selectStartHandler",
        "track.mouseenter": "_trackOnMouseEnterHandler",
        "track.mouseleave": "_trackOnMouseLeaveHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Utilities.BigNumber": "smart.math.js",
        "Smart.Utilities.NumericProcessor": "smart.numeric.js",
        "Smart.Utilities.TickIntervalHandler": "smart.tickintervalhandler.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.tank.css"];
    }
  }]);

  return _class68;
}(Smart.BaseElement)), Smart("smart-gauge",
/*#__PURE__*/
function (_Smart$Tank) {
  "use strict";

  _inherits(_class69, _Smart$Tank);

  function _class69() {
    _classCallCheck(this, _class69);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class69).apply(this, arguments));
  }

  _createClass(_class69, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                <div id=\"svgContainer\" class=\"smart-svg-container\" role=\"presentation\" aria-hidden=\"true\"></div>\n                <div class=\"smart-digital-display-container\" role=\"presentation\">\n                    <smart-numeric-text-box id=\"digitalDisplay\"\n                                            class=\"smart-digital-display\"\n                                            decimal-separator=\"[[decimalSeparator]]\"\n                                            max=\"[[max]]\"\n                                            min=\"[[min]]\"\n                                            name=\"[[name]]\"\n                                            readonly\n                                            right-to-left=\"[[rightToLeft]]\"\n                                            input-format=\"[[scaleType]]\"\n                                            scientific-notation=\"[[scientificNotation]]\"\n                                            show-unit=\"[[showUnit]]\"\n                                            unit=\"[[unit]]\"\n                                            unfocusable\n                                            validation=\"interaction\"\n                                            word-length=\"[[wordLength]]\"\n                                            role=\"tooltip\">\n                    </smart-numeric-text-box>\n                </div>\n            </div>";
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;

      _get(_getPrototypeOf(_class69.prototype), "attached", this).call(this);

      e.isCompleted && (e._trackListener && (e._trackListener = new Smart.Utilities.InputEvents(e._track), e._trackListener.down(function (t) {
        e._SVGElementDownHandler(t);
      })), e._fillListener && (e._fillListener = new Smart.Utilities.InputEvents(e._fill), e._fillListener.down(function (t) {
        e._SVGElementDownHandler(t);
      })), e._lineListener && (e._lineListener = new Smart.Utilities.InputEvents(e._line), e._lineListener.down(function (t) {
        e._SVGElementDownHandler(t);
      })));
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;
      _get(_getPrototypeOf(_class69.prototype), "detached", this).call(this), e._unlisten();
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class69.prototype), "ready", this).call(this);
    }
  }, {
    key: "getOptimalSize",
    value: function getOptimalSize() {
      var e = this;
      return e._renderingSuspended ? {
        width: 0,
        height: 0
      } : "circle" === e.sizeMode ? {
        width: e.offsetWidth,
        height: e._updateSize(!0)
      } : {
        width: e.offsetWidth,
        height: e.offsetHeight
      };
    }
  }, {
    key: "val",
    value: function val(e) {
      var t = this;
      if (void 0 === e) return t._getEventValue();

      if ("date" === t.mode && (e = Smart.Utilities.DateTime.validateDate(e), e = e.getTimeStamp()), t._numericProcessor.compare(e, t.value)) {
        var _i685 = t.value;
        if (t._validateValue(e, t.value), !t._isVisible() || t._renderingSuspended) return void (t._renderingSuspended = !0);

        t._animate(_i685);
      }
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      return e.$.digitalDisplay.id || (e.$.digitalDisplay.id = e.id + "DigitalDisplay"), e.setAttribute("aria-describedby", e.$.digitalDisplay.id), "numeric" === e.mode ? e._getEventValue = function () {
        return e.value;
      } : (e._handleDateScale(), e.digitalDisplay = !1), e._numericProcessor = new Smart.Utilities.NumericProcessor(e, "scaleType"), e._numberRenderer = new Smart.Utilities.NumberRenderer(), e._draw = new Smart.Utilities.Draw(e.$.svgContainer), e._isVisible() ? void (e._renderingSuspended = !1, e._setSettingsObject(), e._wordLengthNumber = e._numericProcessor.getWordLength(e.wordLength), e._measurements = {}, e._validateInitialPropertyValues(), e._getMeasurements(), e._setDrawVariables(), e._getRange(), e._numericProcessor.getAngleRangeCoefficient(), "numeric" !== e.mode && e.coerce ? e._coerceInitialDateValue = !0 : e._validateValue(), e._initTickIntervalHandler(), e._renderAnalogItems(), delete e._preventResizeHandler, e._setFocusable(), e._setUpdatePointerMethod()) : void (e._renderingSuspended = !0);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      function a(i, a, o, r) {
        var l = i && a ? "both" : e;

        n._validateMinMax(l, !1, t);

        "logarithmicScale" !== e && "scaleType" !== e && ("wordLength" !== e && n[e] === t || "wordLength" === e && n.min === o && n.max === r) || (n._setDrawVariables(), n._getRange(), n._numericProcessor.getAngleRangeCoefficient(), n._initTickIntervalHandler(), n._renderAnalogItems(), n._validateValue(n.value, n.value), n._updatePointer());
      }

      var n = this;
      if (!n._isVisible() || n._renderingSuspended) return void (n._renderingSuspended = !0);

      switch (e) {
        case "analogDisplayType":
          delete n._customSVGElements, n._getMeasurements(), "needle" === i && "center" === n.digitalDisplayPosition ? n.digitalDisplayPosition = "bottom" : "needle" === t && "bottom" === n.digitalDisplayPosition && (n.digitalDisplayPosition = "center"), n._renderAnalogItems(), n._setUpdatePointerMethod();
          break;

        case "coerce":
          if (i) {
            var _e778 = n.value;
            n._validateValue(_e778), n._updatePointer(), n._valueBeforeCoercion = _e778;
          } else void 0 !== n._valueBeforeCoercion && (n._validateValue(n._valueBeforeCoercion), n._updatePointer());

          break;

        case "customInterval":
          i ? (n._customTicks && (n.customTicks = n._customTicks), n._numericProcessor.validateCustomTicks()) : "date" === n.mode && (n._customTicks = n.customTicks), n._initTickIntervalHandler(), n._renderAnalogItems(), n._coerceCustomInterval();
          break;

        case "customTicks":
          if ("date" === n.mode && !n.customInterval) return n._customTicks = i, void (n.customTicks = t);
          n._numericProcessor.validateCustomTicks(), n.customInterval && (n._initTickIntervalHandler(), n._renderAnalogItems(), n._coerceCustomInterval());
          break;

        case "dateLabelFormatString":
        case "showUnit":
        case "unit":
          n._initTickIntervalHandler(), n._renderAnalogItems();
          break;

        case "decimalSeparator":
        case "scientificNotation":
          if ("date" === n.mode) return;
          n._initTickIntervalHandler(), n._renderAnalogItems();
          break;

        case "digitalDisplay":
        case "digitalDisplayPosition":
          if ("date" === n.mode) return void ("digitalDisplay" === e && (n.digitalDisplay = !1));

          n._updateSize();

          break;

        case "mechanicalAction":
        case "messages":
        case "readonly":
          break;

        case "disabled":
        case "unfocusable":
          n._setFocusable();

          break;

        case "drawNeedle":
          if ("needle" !== n.analogDisplayType) return;
          null === t && n._draw.removeElement(n._needle), null === i ? (n._renderAnalogItems(), delete n._customSVGElements) : n._updatePointer();
          break;

        case "endAngle":
        case "startAngle":
          n._validateAngles(), n._numericProcessor.getAngleRangeCoefficient(), n._renderAnalogItems();
          break;

        case "interval":
          n._numericProcessor.validateInterval(n.interval), n._validateValue(), n._updatePointer();
          break;

        case "inverted":
        case "labelFormatFunction":
        case "rightToLeft":
        case "showRanges":
          n._renderAnalogItems();

          break;

        case "labelsVisibility":
          if ("all" === t && "endPoints" === i || "endPoints" === t && "all" === i) return;
          n._getMeasurements(), n._renderAnalogItems();
          break;

        case "logarithmicScale":
          if ("date" === n.mode) return void (n.logarithmicScale = !1);
          n._initTickIntervalHandler(), a(!0, !0);
          break;

        case "max":
        case "min":
          "date" === n.mode && (delete n._dateInterval, n[e] = Smart.Utilities.DateTime.validateDate(i).getTimeStamp()), a("min" === e, "max" === e);
          break;

        case "mode":
          n.mode = t;
          break;

        case "needlePosition":
          "needle" === n.analogDisplayType && n._updatePointer();
          break;

        case "precisionDigits":
        case "significantDigits":
          if ("date" === n.mode) return;
          "precisionDigits" === e && "integer" === n.scaleType && n.error(n.localize("noInteger", {
            elementType: n.nodeName.toLowerCase(),
            property: e
          })), "significantDigits" === e && null !== n.precisionDigits ? n.precisionDigits = null : "precisionDigits" == e && null !== n.significantDigits && (n.significantDigits = null), null !== i && (n.$.digitalDisplay.precisionDigits = n.precisionDigits, n.$.digitalDisplay.significantDigits = n.significantDigits), n._initTickIntervalHandler(), n._renderAnalogItems();
          break;

        case "ranges":
          if (!n.showRanges) return;

          n._renderAnalogItems();

          break;

        case "scaleType":
          if ("date" === n.mode) return void (n.scaleType = "integer");
          n._numericProcessor = new Smart.Utilities.NumericProcessor(n, "scaleType"), a(!0, !0);
          break;

        case "scalePosition":
        case "ticksPosition":
          n._getMeasurements(), n._renderAnalogItems();
          break;

        case "sizeMode":
          n._preventResizeHandler = !0, "circle" === i ? (n.$.container.removeAttribute("style"), n.style.height = n.offsetWidth + "px", n._measurements.cachedHeight = n.offsetHeight) : (n.$.container.style.height = n.offsetWidth + "px", n._updateSize());
          break;

        case "theme":
          _get(_getPrototypeOf(_class69.prototype), "propertyChangedHandler", this).call(this, e, t, i), n._getMeasurements(), n._renderAnalogItems();
          break;

        case "ticksVisibility":
          if ("minor" === t && "major" === i || "major" === t && "minor" === i) return;
          n._getMeasurements(), n._renderAnalogItems();
          break;

        case "validation":
          "strict" === i && n._validateValue(n.value, n.value);
          break;

        case "value":
          {
            "date" === n.mode && (i = Smart.Utilities.DateTime.validateDate(i), i = i.getTimeStamp()), n._validateValue(i, t);

            var _e779 = i.toString();

            n.value.toString() === _e779 && (n._drawValue = n.logarithmicScale ? Math.log10(_e779).toString() : _e779), n._animate(t);
            break;
          }

        case "wordLength":
          if ("date" === n.mode) return void (n.wordLength = "uint64");
          n._wordLengthNumber = n._numericProcessor.getWordLength(n.wordLength), "integer" === n.scaleType && a(!0, !0, n.min, n.max);
      }
    }
  }, {
    key: "_addAnalogDisplay",
    value: function _addAnalogDisplay() {
      var e = this,
          t = e._measurements,
          i = t.radius,
          a = e._draw;

      if ("needle" === e.analogDisplayType) {
        e._drawNeedle(!1);

        var _n330 = (t.needleWidth + 5) / 2;

        e._centralCircle = a.circle(i, i, _n330, {
          class: "smart-needle-central-circle"
        }), e._minCoordinates.push(i - _n330), e._maxCoordinates.push(i + _n330);
      } else {
        var _n331 = i - e._distance.trackDistance - t.trackBorderWidth / 2 - 1;

        e._track = a.pieslice(i, i, _n331 - t.trackWidth, _n331, e.startAngle, e.endAngle, 0, {
          class: "smart-track"
        }), e._trackListener = new Smart.Utilities.InputEvents(e._track), e._trackListener.down(function (t) {
          e._SVGElementDownHandler(t);
        });
      }
    }
  }, {
    key: "_calculateTickAndLabelDistance",
    value: function _calculateTickAndLabelDistance() {
      var e = this,
          t = e._measurements;
      if ("none" === e.scalePosition) return e._plotLabels = !1, e._plotTicks = !1, t.innerRadius = t.radius, {
        majorTickDistance: 0,
        minorTickDistance: 0,
        labelDistance: 0,
        needleDistance: 0,
        trackDistance: 0
      };
      var i = e._tickIntervalHandler.labelsSize,
          a = e._largestLabelSize || Math.max(i.minLabelSize, i.minLabelOtherSize, i.maxLabelSize, i.maxLabelOtherSize);
      var n = 1,
          o = 0,
          r,
          l,
          s;
      return e._largestLabelSize = a, "outside" === e.scalePosition && (n = a, r = n + t.majorTickSize - t.minorTickSize, l = 0), "needle" === e.analogDisplayType ? (s = "outside" === e.scalePosition ? n + t.majorTickSize : n + t.majorTickSize + a, "none" === e.ticksVisibility && (l = 0, s -= t.majorTickSize), "none" === e.labelsVisibility && (s -= a, "outside" === e.scalePosition && (n -= a, r -= a))) : "none" === e.labelsVisibility && "none" === e.ticksVisibility ? o = 0 : "outside" === e.scalePosition ? "scale" === e.ticksPosition ? ("none" === e.labelsVisibility && (n = 1, r = 1 + t.majorTickSize - t.minorTickSize), o = "none" === e.ticksVisibility ? a : n + t.majorTickSize + 2) : "none" === e.labelsVisibility ? (n = 1, r = (t.trackWidth + t.trackBorderWidth) / 4 + 1, o = 0) : (r -= (t.trackWidth + t.trackBorderWidth) / 4, o = n - 1) : "scale" === e.ticksPosition ? (n = t.trackWidth + 1.5 * t.trackBorderWidth + 2, "none" === e.ticksVisibility && (l = n)) : r = (t.trackWidth + t.trackBorderWidth) / 4 + 1, void 0 === r && (r = n), void 0 === l && (l = n + t.majorTickSize), t.innerRadius = t.radius - l, delete e._plotLabels, delete e._plotTicks, delete e._equalToHalfRadius, "inside" === e.scalePosition ? t.innerRadius < a && (e._plotLabels = !1, "scale" === e.ticksPosition ? "needle" !== e.analogDisplayType && t.innerRadius < t.majorTickSize && (e._plotTicks = !1) : (e._equalToHalfRadius = !0, t.innerRadius = t.radius / 2)) : t.radius - o - t.trackBorderWidth < t.trackWidth && (t.trackWidth = t.radius - o - t.trackBorderWidth, t.lineSize = t.trackWidth + t.trackBorderWidth, "track" === e.ticksPosition && (t.majorTickSize = t.lineSize, t.minorTickSize = t.majorTickSize / 2, r = n + (t.majorTickSize - t.minorTickSize) / 2)), {
        majorTickDistance: n,
        minorTickDistance: r,
        labelDistance: l,
        needleDistance: s,
        trackDistance: o
      };
    }
  }, {
    key: "_calculateTickInterval",
    value: function _calculateTickInterval() {
      var e = this,
          t = e._tickIntervalHandler.getInterval("radial", e._drawMin, e._drawMax, e.$.container, e.logarithmicScale);

      t.major === e._majorTicksInterval ? e._intervalHasChanged = !0 : (e._intervalHasChanged = !0, e._majorTicksInterval = t.major), e._minorTicksInterval = t.minor, "date" === e.mode && e._calculateDateInterval(t.major);
    }
  }, {
    key: "_computeNeedlePointsCenter",
    value: function _computeNeedlePointsCenter(e, t) {
      var i = this,
          a = i._measurements,
          n = a.innerRadius,
          o = a.radius,
          r = Math.sin(t),
          l = Math.cos(t);
      var s = "inside" === i.scalePosition ? .9 * (n - i._largestLabelSize) : .9 * (n - i._distance.needleDistance);
      var d = o + s * r,
          c = o + s * l;
      return "M " + (o + e * l) + "," + (o - e * r) + " L " + (o - e * l) + "," + (o + e * r) + " L " + d + "," + c + " Z";
    }
  }, {
    key: "_computeNeedlePointsEdge",
    value: function _computeNeedlePointsEdge(e, t, i) {
      var a = this,
          n = a._measurements.radius,
          o = n - a._distance.needleDistance,
          r = o - i,
          l = Math.sin(t),
          s = Math.cos(t),
          d = n + r * l,
          c = n + r * s;
      return "M " + (d + e * s) + "," + (c - e * l) + " L " + (d - e * s) + "," + (c + e * l) + " L " + (n + o * l) + "," + (n + o * s) + " Z";
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      if (!this._dragging) return;

      var t = this,
          i = t._getAngleByCoordinate(e.pageX, e.pageY),
          a = t._getQuadrant(i),
          n = t._getRotationDirection();

      if (t._normalizedStartAngle === t.endAngle) {
        var _e780;

        !t.inverted && !t.rightToLeft || t.rightToLeft && t.inverted ? t._lockCW && "ccw" === n ? (_e780 = t.endAngle, t._unlockRotation("_lockCW", i, a, _e780, {
          firstCondition: i > _e780,
          secondCondition: i < _e780
        })) : t._lockCCW && "cw" === n && (_e780 = t._normalizedStartAngle, t._unlockRotation("_lockCCW", i, a, _e780, {
          firstCondition: i < _e780,
          secondCondition: i > _e780
        })) : t._lockCW && "cw" === n ? (_e780 = t._normalizedStartAngle, t._unlockRotation("_lockCW", i, a, _e780, {
          firstCondition: i < _e780,
          secondCondition: i > _e780
        })) : t._lockCCW && "ccw" === n && (_e780 = t.endAngle, t._unlockRotation("_lockCCW", i, a, _e780, {
          firstCondition: i > _e780,
          secondCondition: i < _e780
        }));
      } else t._lockCW && "ccw" === n && !t._outsideRange && 10 > t._numericProcessor._getAngleDifference(i, t._normalizedStartAngle) ? t._lockCW = !1 : t._lockCCW && "cw" === n && !t._outsideRange && 10 > t._numericProcessor._getAngleDifference(i, t.endAngle) && (t._lockCCW = !1);

      if (t._angle = i, t._quadrant = a, e.originalEvent && (e.originalEvent.stopPropagation(), e.originalEvent.preventDefault()), t._lockCW || t._lockCCW) return;

      var o = t._numericProcessor.getValueByAngle(i);

      if (t._normalizedStartAngle === t.endAngle) {
        var _e781 = t._numericProcessor.lockRotation("cw" === n && !t.inverted && !t.rightToLeft || t.rightToLeft && t.inverted || "ccw" === n && (t.inverted || t.rightToLeft && !t.inverted), o);

        void 0 !== _e781 && (o = _e781);
      } else "ccw" === n && t._outsideEnd ? t._lockCCW = !0 : "cw" === n && t._outsideStart && (t._lockCW = !0);

      void 0 !== o && t._numericProcessor.compare(o, t.value) && (cancelAnimationFrame(t._animationFrameId), t._updatePointer(o), "switchWhenReleased" === t.mechanicalAction ? t._valueAtMoveEnd = o : t._numericProcessor.updateGaugeValue(o));
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler() {
      var e = this;

      if (e._dragging && (e._lockCW = !1, e._lockCCW = !1, e._dragging = !1, e.removeAttribute("dragged"), "switchWhileDragging" !== e.mechanicalAction)) {
        var _t680 = "switchUntilReleased" === e.mechanicalAction ? e._valueAtDragStart : e._valueAtMoveEnd;

        e._numericProcessor.compare(_t680, e.value) && ("switchUntilReleased" === e.mechanicalAction && e._animate(e.value, _t680), e._numericProcessor.updateGaugeValue(_t680));
      }
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e, t) {
      var i = Math.pow;
      var a = this,
          n = a.enableShadowDOM || a.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      if ("needle" !== a.analogDisplayType && !t || a.disabled || a.readonly || a.$.digitalDisplay.contains(n) || !Smart.Utilities.Core.isMobile && ("buttons" in e && 1 !== e.buttons || 1 !== e.which)) return void e.stopPropagation();
      var o = e.pageX,
          r = e.pageY;

      if (a._measurements.center = a._getCenterCoordinates(), "needle" === a.analogDisplayType) {
        var _t681 = Math.sqrt(i(a._measurements.center.x - o, 2) + i(a._measurements.center.y - r, 2));

        if (_t681 > a._measurements.radius) return void e.stopPropagation();
      }

      "switchUntilReleased" === a.mechanicalAction && (a._valueAtDragStart = a.value), a._angle = a._getAngleByCoordinate(o, r), a._quadrant = a._getQuadrant(a._angle);

      var l = a._numericProcessor.getValueByAngle(a._angle);

      void 0 !== l && a._numericProcessor.compare(l, a.value) && (a._animate(a.value, l), "switchWhenReleased" === a.mechanicalAction ? a._valueAtMoveEnd = l : a._numericProcessor.updateGaugeValue(l)), a._dragging = !0, a.setAttribute("dragged", "");
    }
  }, {
    key: "_animate",
    value: function _animate(e, t) {
      function a() {
        u = p(), s && (u = Math.pow(10, u));
      }

      function n() {
        return m++, m === d ? (u = t, void l._updatePointer(u)) : void (l._updatePointer(u), a(), l._animationFrameId = requestAnimationFrame(n));
      }

      var o = Math.log10,
          r = Math.max;
      var l = this,
          s = l.logarithmicScale,
          d = r(1, Math.round(l.animationDuration / 15));
      if (cancelAnimationFrame(l._animationFrameId), !l.hasAnimation || 1 === d) return void l._updatePointer(t);
      var c = l._numericProcessor;
      var m = 1,
          u,
          p,
          g,
          h;
      void 0 === t && (t = l.value), e = parseFloat(c.validate(c.createDescriptor(e), l._minObject, l._maxObject)), t = parseFloat(c.validate(c.createDescriptor(t), l._minObject, l._maxObject)), s ? (g = o(e), h = o(t)) : (g = e, h = t);

      var _ = Math.abs(h - g);

      p = t > e ? function () {
        return Math.min(Smart.Utilities.Animation.Easings.easeInOutSine(m, g, _, d), h);
      } : function () {
        return r(2 * g - Smart.Utilities.Animation.Easings.easeInOutSine(m, g, _, d), h);
      }, a(), l._animationFrameId = requestAnimationFrame(n);
    }
  }, {
    key: "_drawFill",
    value: function _drawFill(e, t) {
      var i = this;

      if ("needle" !== i.analogDisplayType) {
        void 0 === t && (t = i._number);

        var _a422 = i._measurements,
            _n332 = _a422.radius,
            _o230 = _n332 - i._distance.trackDistance - _a422.trackBorderWidth / 2 - 1;

        if ("fill" === i.analogDisplayType) {
          var _r145 = i._numericProcessor.getAngleByValue(t, !0, !0);

          var _l107, _s77;

          !i.inverted && !i.rightToLeft || i.rightToLeft && i.inverted ? (_l107 = _r145, _s77 = i.endAngle) : (_l107 = i.startAngle, _s77 = _r145), e ? i._fill.setAttribute("d", i._draw.pieSlicePath(_n332, _n332, _o230 - _a422.trackWidth, _o230, _l107, _s77, 0)) : (i._fill = i._draw.pieslice(_n332, _n332, _o230 - _a422.trackWidth, _o230, _l107, _s77, 0, {
            class: "smart-value"
          }), i._fillListener = new Smart.Utilities.InputEvents(i._fill), i._fillListener.down(function (e) {
            i._SVGElementDownHandler(e);
          }));
        } else {
          var _r146 = _o230 + _a422.trackBorderWidth / 2,
              _l108 = _r146 - _a422.lineSize,
              _s78 = i._numericProcessor.getAngleByValue(t),
              d = Math.sin(_s78),
              c = Math.cos(_s78),
              m = _n332 + _r146 * d,
              u = _n332 + _r146 * c,
              p = _n332 + _l108 * d,
              g = _n332 + _l108 * c;

          e ? (i._line.setAttribute("x1", m), i._line.setAttribute("y1", u), i._line.setAttribute("x2", p), i._line.setAttribute("y2", g)) : (i._line = i._draw.line(m, u, p, g, {
            class: "smart-line"
          }), i._lineListener = new Smart.Utilities.InputEvents(i._line), i._lineListener.down(function (e) {
            i._SVGElementDownHandler(e);
          }));
        }
      }
    }
  }, {
    key: "_drawLabel",
    value: function _drawLabel(e, t, i, a) {
      var n = Math.round;
      var o = this,
          l = o._measurements,
          s = l.radius,
          r = {
        class: "smart-label" + (!1 === a ? "" : " smart-label-middle"),
        "font-size": l.fontSize,
        "font-family": l.fontFamily,
        "font-weight": l.fontWeight,
        "font-style": l.fontStyle
      };
      t = o._formatLabel(t.toString(), !1);

      var d = o._draw.measureText(t, 0, r),
          c = s - i - o._largestLabelSize / 2,
          m = n(s + c * Math.sin(e)) - d.width / 2,
          u = n(s + c * Math.cos(e)) - d.height / 2,
          p = o._draw.text(t, m, u, d.width, d.height, 0, r);

      o._minCoordinates.push(u), o._maxCoordinates.push(u + p.getBBox().height);
    }
  }, {
    key: "_drawNeedle",
    value: function _drawNeedle(e, t) {
      var a = this,
          i = a._measurements;
      t === void 0 && (t = a._number);

      var n = a._numericProcessor.getAngleByValue(t);

      if (!a.drawNeedle) {
        var _t682;

        _t682 = "center" === a.needlePosition ? a._computeNeedlePointsCenter(i.needleWidth / 2, n) : a._computeNeedlePointsEdge(i.needleWidth / 2, n, i.needleLength), e ? a._needle.setAttribute("d", _t682) : a._needle = a._draw.path(_t682, {
          class: "smart-needle"
        });
      } else if (a._customSVGElements = a.drawNeedle(a, a._draw, i.radius, n, a._distance.needleDistance), a._customSVGElements) {
        var _e782 = a._customSVGElements[0].parentElement || a._customSVGElements[0].parentNode;

        for (var _t683 = 0; _t683 < a._customSVGElements.length; _t683++) {
          _e782.insertBefore(a._customSVGElements[_t683], a._centralCircle);
        }
      }
    }
  }, {
    key: "_drawRanges",
    value: function _drawRanges() {
      var e = this,
          t = e._numericProcessor,
          a = e.ranges;
      if (!e.showRanges || 0 === a.length) return;
      var i = e._measurements,
          n = i.radius;
      var o, r, l, s;
      "needle" === e.analogDisplayType ? (r = i.rangeSize, "inside" === e.scalePosition ? o = n - 1 : (o = n - e._distance.needleDistance - 2, "none" === e.labelsVisibility && "none" === e.ticksVisibility && (o += 1))) : (o = n - e._distance.trackDistance - i.trackBorderWidth / 2 - 1, r = i.trackWidth), !e.inverted && !e.rightToLeft || e.rightToLeft && e.inverted ? (l = "startValue", s = "endValue") : (l = "endValue", s = "startValue");

      for (var d = 0; d < a.length; d += 1) {
        var _i686 = a[d],
            c = t.validateColorRange(_i686[l]),
            m = t.validateColorRange(_i686[s]);

        var u = e._draw.pieslice(n, n, o - r, o, t.getAngleByValue(m, !0, !0), t.getAngleByValue(c, !0, !0), 0, {
          class: "smart-range " + _i686.className
        });

        e._ranges.push(u);
      }
    }
  }, {
    key: "_drawTick",
    value: function _drawTick(e, t, i) {
      var a = Math.sin,
          n = Math.cos;
      var o = this,
          l = o._measurements,
          s = l.radius;
      var r = "smart-tick",
          d;
      "major" === i ? d = l.majorTickSize : (d = l.minorTickSize, r += " smart-tick-minor");
      var c = t - d,
          m = s + t * a(e),
          u = s + t * n(e),
          p = s + c * a(e),
          g = s + c * n(e);
      o._draw.line(m, u, p, g, {
        class: r
      }), o._minCoordinates.push(Math.min(u, g)), o._maxCoordinates.push(Math.max(u, g));
    }
  }, {
    key: "_getAngleByCoordinate",
    value: function _getAngleByCoordinate(e, t) {
      var i = this,
          a = i._measurements.center,
          n = Math.atan2(t - a.y, e - a.x);
      var o = 180 * (-1 * n) / Math.PI;
      return 0 > o && (o += 360), i._actualAngle = o, i._normalizedStartAngle === i.endAngle || function (e, t, i) {
        for (; t < e;) {
          t += 360;
        }

        for (; i < e;) {
          i += 360;
        }

        return i >= e && i <= t;
      }(i._normalizedStartAngle, i.endAngle, o) ? (i._outsideRange = !1, i._outsideStart = !1, i._outsideEnd = !1) : (i._numericProcessor._getAngleDifference(o, i._normalizedStartAngle) <= i._numericProcessor._getAngleDifference(o, i.endAngle) ? (o = i._normalizedStartAngle, i._outsideStart = !0, i._outsideEnd = !1) : (o = i.endAngle, i._outsideEnd = !0, i._outsideStart = !1), i._outsideRange = !0), o;
    }
  }, {
    key: "_getCenterCoordinates",
    value: function _getCenterCoordinates() {
      var e = this,
          t = e.$.container.getBoundingClientRect(),
          i = e._measurements.radius,
          a = document.body.scrollLeft || document.documentElement.scrollLeft,
          n = document.body.scrollTop || document.documentElement.scrollTop;
      return {
        x: t.left + a + i,
        y: t.top + n + i
      };
    }
  }, {
    key: "_getInlineColors",
    value: function _getInlineColors() {
      var e = this;
      var t = "",
          i = "",
          a = "";
      return e._track && (t = e._track.style.fill), e._fill && (i = e._fill.style.fill), e._line && (a = e._line.style.stroke), [t, i, a];
    }
  }, {
    key: "_getMeasurements",
    value: function _getMeasurements() {
      var e = this;
      if (!e._isVisible() || e._renderingSuspended) return void (e._renderingSuspended = !0);
      var t = e._measurements;
      t.cachedWidth = e.offsetWidth, t.cachedHeight = e.offsetHeight, t.radius = t.cachedWidth / 2;
      var i = document.createElement("div");
      e.shadowRoot ? e.shadowRoot.appendChild(i) : e.appendChild(i), i.className = "smart-tick", t.majorTickSize = i.offsetWidth, i.className += " smart-tick-minor", t.minorTickSize = i.offsetWidth, i.className = "smart-label";
      var a = window.getComputedStyle(i);
      t.fontSize = a.fontSize, t.fontFamily = a.fontFamily, t.fontWeight = a.fontWeight, t.fontStyle = a.fontStyle, t.trackWidth = 0, t.trackBorderWidth = 0, "needle" === e.analogDisplayType ? (i.className = "smart-needle", t.needleWidth = i.offsetWidth, t.needleLength = i.offsetHeight, i.className = "smart-range", t.rangeSize = i.offsetWidth) : (i.className = "smart-track", t.trackBorderWidth = parseFloat(a.strokeWidth), t.trackWidth = Math.min(i.offsetWidth, t.radius - t.trackBorderWidth), t.lineSize = t.trackWidth + t.trackBorderWidth, "track" === e.ticksPosition && (t.majorTickSize = t.lineSize, t.minorTickSize = t.majorTickSize / 2)), e.shadowRoot ? e.shadowRoot.removeChild(i) : e.removeChild(i);
    }
  }, {
    key: "_getQuadrant",
    value: function _getQuadrant(e) {
      return 270 < e ? 4 : 180 < e ? 3 : 90 < e ? 2 : 1;
    }
  }, {
    key: "_getRotationDirection",
    value: function _getRotationDirection() {
      var e = this,
          t = e._getQuadrant(e._actualAngle);

      return e._actualAngle < e._angle && (1 !== t || 4 !== e._quadrant) || e._actualAngle > e._angle && 4 === t && 1 === e._quadrant ? "cw" : "ccw";
    }
  }, {
    key: "_initTickIntervalHandler",
    value: function _initTickIntervalHandler() {
      var e = this;
      if (!e._isVisible() || e._renderingSuspended) return void (e._renderingSuspended = !0);

      var t = e._formatLabel(e.min, !1),
          i = e._formatLabel(e.max, !1);

      e._tickIntervalHandler = new Smart.Utilities.TickIntervalHandler(e, t, i, "smart-label", e._settings.size, "integer" === e.scaleType, e.logarithmicScale);
    }
  }, {
    key: "_keydownHandler",
    value: function _keydownHandler(e) {
      var t = this,
          i = t._getEventValue(),
          a = t._number.toString();

      "numeric" === t.mode ? (t.value.toString() !== a && (t.value = a, t.$.digitalDisplay.value = a), _get(_getPrototypeOf(_class69.prototype), "_keydownHandler", this).call(this, e), t.value.toString() !== i && t.$.fireEvent("change", {
        value: t.value,
        oldValue: i
      })) : (t.value.toString() !== a && (t._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(a), t.value = t._number), _get(_getPrototypeOf(_class69.prototype), "_keydownHandler", this).call(this, e), 0 !== t._valueDate.compare(i) && t.$.fireEvent("change", {
        value: t._getEventValue(),
        oldValue: i
      })), t.setAttribute("aria-valuenow", t._getEventValue(!0));
    }
  }, {
    key: "_normalizeAngle",
    value: function _normalizeAngle(e) {
      return e %= 360, 0 > e && (e += 360), e;
    }
  }, {
    key: "_renderAnalogItems",
    value: function _renderAnalogItems(e) {
      var t = this;
      if (!t._isVisible() || t._renderingSuspended) return void (t._renderingSuspended = !0);

      var i = t._getInlineColors();

      if (t._unlisten(), t._draw.clear(), delete t._needle, delete t._centralCircle, delete t._track, delete t._trackListener, delete t._fill, delete t._fillListener, delete t._line, delete t._lineListener, t._ranges = [], t._minCoordinates = [], t._maxCoordinates = [], !1 !== e && (delete t._largestLabelSize, t._distance = t._calculateTickAndLabelDistance()), !1 !== t._plotTicks || !1 !== t._plotLabels) {
        t._calculateTickInterval();

        var _i687 = t._cachedLabelsSize,
            _a423 = Math.max(_i687.minLabelSize, _i687.minLabelOtherSize, _i687.maxLabelSize, _i687.maxLabelOtherSize);

        !1 !== e && t._largestLabelSize !== _a423 && (t._largestLabelSize = _a423, t._distance = t._calculateTickAndLabelDistance(), t._calculateTickInterval());
      }

      t._coerceInitialDateValue && (t._validateValue(), delete t._coerceInitialDateValue), t._drawRanges(), t._addAnalogDisplay(), ("none" !== t.ticksVisibility && !1 !== t._plotTicks || "none" !== t.labelsVisibility && !1 !== t._plotLabels) && (t.customInterval || t._dateInterval ? t._numericProcessor.addGaugeCustomTicks() : t._numericProcessor.addGaugeTicksAndLabels()), t._drawFill(!1), t._updateSize(), t._restoreInlineColors(i[0], i[1], i[2]);
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      if (e._preventResizeHandler) return void delete e._preventResizeHandler;
      if (!e._isVisible()) return void (e._renderingSuspended = !0);
      if (e._renderingSuspended) return void e._createElement();
      var t = e._measurements;

      if (!(e._renderingSuspended || t.cachedWidth === e.offsetWidth && t.cachedHeight === e.offsetHeight)) {
        if ("circle" === e.sizeMode) e.offsetWidth !== e.offsetHeight && (t.cachedWidth === e.offsetWidth ? t.cachedHeight !== e.offsetHeight && (e.style.width = e.offsetHeight + "px", e._preventResizeHandler = !0) : (e.style.height = e.offsetWidth + "px", e._preventResizeHandler = !0));else {
          if (t.cachedHeight !== e.offsetHeight && t.cachedWidth === e.offsetWidth) return e.style.height = t.cachedHeight + "px", void (e._preventResizeHandler = !0);
          e.$.container.style.height = e.offsetWidth + "px";
        }
        t.cachedWidth = e.offsetWidth, t.cachedHeight = e.offsetHeight, t.radius = t.cachedWidth / 2, t.innerRadius = e._equalToHalfRadius ? t.radius / 2 : t.radius - e._distance.labelDistance, e._renderAnalogItems(!1);
      }
    }
  }, {
    key: "_restoreInlineColors",
    value: function _restoreInlineColors(e, t, i) {
      var a = this;
      a._track && "" !== e && (a._track.style.fill = e), a._fill && "" !== t && (a._fill.style.fill = t), a._line && "" !== i && (a._line.style.stroke = i);
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      this._dragging && e.preventDefault();
    }
  }, {
    key: "_setUpdatePointerMethod",
    value: function _setUpdatePointerMethod() {
      var e = this;
      e._updatePointer = "needle" === e.analogDisplayType ? function (t) {
        if (e._customSVGElements) for (var _t684 = 0; _t684 < e._customSVGElements.length; _t684++) {
          e._draw.removeElement(e._customSVGElements[_t684]);
        }

        e._drawNeedle(!0, t);
      } : function (t) {
        e._drawFill(!0, t);
      };
    }
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler(e) {
      var t = this;
      return e.detail.styleProperties && e.detail.styleProperties["min-height"] ? void 0 : t._isVisible() ? t._renderingSuspended ? void t._createElement() : void (t._getMeasurements(), t._initTickIntervalHandler(), t._renderAnalogItems()) : void (t._renderingSuspended = !0);
    }
  }, {
    key: "_SVGElementDownHandler",
    value: function _SVGElementDownHandler(e) {
      var t = this,
          i = t.context;
      t.context = t, t._downHandler(e, !0), t.context = i;
    }
  }, {
    key: "_unlockRotation",
    value: function _unlockRotation(e, t, i, a, n) {
      var o = this,
          r = n.firstCondition,
          l = n.secondCondition,
          s = o._getQuadrant(a);

      (r && (4 !== i || 1 !== s) || l && 4 === i && 1 === s) && 10 > o._numericProcessor._getAngleDifference(t, a) && (o[e] = !1);
    }
  }, {
    key: "_updateSize",
    value: function _updateSize(e) {
      var t = Math.min,
          a = Math.max;
      var n = this;
      if ("circle" === n.sizeMode && void 0 === e) return;
      var o = n._minCoordinates,
          r = n._maxCoordinates;
      var l = o[0],
          s = r[0];

      for (var _a424 = 1; _a424 < o.length; _a424++) {
        l = t(l, o[_a424]);
      }

      for (var _t685 = 1; _t685 < r.length; _t685++) {
        s = a(s, r[_t685]);
      }

      var d = n.getBoundingClientRect();

      if (n.digitalDisplay) {
        var _e783 = n.$.digitalDisplay.getBoundingClientRect();

        l = t(l, _e783.top - d.top), s = a(s, _e783.bottom - d.top);
      }

      if ("needle" !== n.analogDisplayType) {
        var _e784 = n._track.getBBox();

        l = t(l, _e784.y), s = a(s, _e784.y + _e784.height);
      }

      for (var _o231 = 0; _o231 < n._ranges.length; _o231++) {
        var _e785 = n._ranges[_o231].getBBox();

        l = t(l, _e785.y - d.top), s = a(s, _e785.y + _e785.height - d.top);
      }

      l -= 2;
      var i = s - l;
      return void 0 === e ? void (n._preventResizeHandler = !0, n.style.height = i + "px", n.$.container.style.marginTop = -1 * l + "px", n._measurements.cachedHeight = i) : Math.round(i);
    }
  }, {
    key: "_updateValue",
    value: function _updateValue(e) {
      this._numericProcessor.updateGaugeValue(e);
    }
  }, {
    key: "_validate",
    value: function _validate(e, t, i) {
      var a = this,
          n = a.value;
      a._validateValue(t), i && (35 === i || 36 === i) ? a._animate(n) : a._updatePointer();
    }
  }, {
    key: "_validateAngles",
    value: function _validateAngles() {
      var e = this;
      e._normalizedStartAngle = e._normalizeAngle(e.startAngle), e.endAngle = e._normalizeAngle(e.endAngle), e.startAngle = e._normalizedStartAngle < e.endAngle ? e._normalizedStartAngle : e._normalizedStartAngle - 360, e._angleDifference = e.endAngle - e.startAngle;
    }
  }, {
    key: "_validateInitialPropertyValues",
    value: function _validateInitialPropertyValues() {
      _get(_getPrototypeOf(_class69.prototype), "_validateInitialPropertyValues", this).call(this);

      var e = this;
      "circle" === e.sizeMode ? e.offsetWidth < e.offsetHeight ? e.style.height = e.offsetWidth + "px" : e.offsetWidth > e.offsetHeight && (e.style.width = e.offsetHeight + "px") : (e.offsetHeight !== e.offsetWidth && (e.style.height = e.offsetWidth + "px"), e.$.container.style.height = e.offsetWidth + "px"), e._validateAngles(), null === e.significantDigits ? null !== e.precisionDigits && (e.$.digitalDisplay.precisionDigits = e.precisionDigits) : e.$.digitalDisplay.significantDigits = e.significantDigits;
    }
  }, {
    key: "_validateValue",
    value: function _validateValue(e, t) {
      var i = this,
          a = i._numericProcessor,
          n = i.logarithmicScale,
          o = "strict" === i.validation;
      var r = o && t !== void 0;
      e === void 0 ? (r = !1, e = i.value) : e = e.toString(), a.regexScientificNotation.test(e) && (e = a.scientificToDecimal(e)), isNaN(e) && (e = t || 0);
      var l, s, d;
      i.coerce ? (l = a.getCoercedValue(a.createDescriptor(e, !0, !0, !0), !1, n), i._number = l, s = l.toString(), d = s) : o ? (l = a.getCoercedValue(a.createDescriptor(e, !0, !0, !0), !1, n), i._number = l, s = l.toString(), d = s) : (r = !1, l = a.getCoercedValue(a.createDescriptor(e, !0, !0, !1), !1, n), i._number = a.validate(l, a.createDescriptor(i._minObject), a.createDescriptor(i._maxObject)), s = l.toString(), d = i._number.toString());
      var c, m;
      "numeric" === i.mode ? (c = t, m = s, i.value = s, i.$.digitalDisplay.value = s) : (c = i._valueDate, i._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(s), m = i._valueDate, i.value = l), i._drawValue = n ? Math.log10(d).toString() : d, r && a.compare(i._number, t) && i.$.fireEvent("change", {
        value: m,
        oldValue: c
      }), i.setAttribute("aria-valuenow", i._getEventValue(!0)), delete i._valueBeforeCoercion;
    }
  }, {
    key: "_unlisten",
    value: function _unlisten() {
      var e = this;
      e._trackListener && e._trackListener.unlisten(), e._fillListener && e._fillListener.unlisten(), e._lineListener && e._lineListener.unlisten();
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        analogDisplayType: {
          value: "needle",
          allowedValues: ["needle", "fill", "line"],
          type: "string"
        },
        animationDuration: {
          value: 300,
          type: "number"
        },
        digitalDisplay: {
          value: !1,
          type: "boolean"
        },
        digitalDisplayPosition: {
          value: "bottom",
          allowedValues: ["top", "bottom", "right", "left", "center"],
          type: "string"
        },
        drawNeedle: {
          value: null,
          type: "function?"
        },
        endAngle: {
          value: 210,
          type: "number"
        },
        needlePosition: {
          value: "center",
          allowedValues: ["center", "edge"],
          type: "string"
        },
        ranges: {
          value: [],
          type: "array"
        },
        scalePosition: {
          value: "inside",
          allowedValues: ["outside", "inside", "none"],
          type: "string"
        },
        showRanges: {
          value: !1,
          type: "boolean"
        },
        sizeMode: {
          value: "circle",
          allowedValues: ["circle", "auto"],
          type: "string"
        },
        startAngle: {
          value: -30,
          type: "number"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        down: "_downHandler",
        resize: "_resizeHandler",
        styleChanged: "_styleChangedHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler",
        "document.selectstart": "_selectStartHandler",
        keydown: "_keydownHandler",
        move: "_trackMoveHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Utilities.Draw": "smart.draw.js",
        "Smart.NumericTextBox": "smart.numerictextbox.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.numerictextbox.css", "smart.gauge.css"];
    }
  }]);

  return _class69;
}(Smart.Tank)), Smart("smart-slider",
/*#__PURE__*/
function (_Smart$Tank2) {
  "use strict";

  _inherits(_class70, _Smart$Tank2);

  function _class70() {
    _classCallCheck(this, _class70);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class70).apply(this, arguments));
  }

  _createClass(_class70, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" class=\"smart-container\" role=\"presentation\">\n                <div id=\"scaleNear\" class=\"smart-scale smart-scale-near\" role=\"presentation\" aria-hidden=\"true\"></div>\n                <div id=\"trackContainer\" class=\"smart-track-container\" role=\"presentation\">\n                    <smart-repeat-button id=\"leftButton\" class=\"smart-spin-button\" animation=\"[[animation]]\" unfocusable>\n                        <div id=\"leftArrow\" class=\"smart-arrow\" role=\"presentation\" aria-hidden=\"true\"></div>\n                    </smart-repeat-button>\n                    <div id=\"track\" class=\"smart-track\" role=\"presentation\">\n                        <div id=\"fill\" class=\"smart-value\" role=\"presentation\"></div>\n                        <div id=\"trackTicksContainer\" class=\"smart-track-ticks-container smart-hidden\" role=\"presentation\"></div>\n                        <div id=\"thumb\" class=\"smart-thumb\" role=\"presentation\">\n                            <span id=\"thumbLabel\" class=\"smart-thumb-label\" role=\"presentation\"></span>\n                            <div id=\"tooltip\" class=\"smart-tooltip\" role=\"tooltip\">\n                                <div id=\"tooltipContent\" class=\"smart-tooltip-content smart-unselectable\" role=\"presentation\"></div>\n                            </div>\n                        </div>\n                        <div id=\"secondThumb\" class=\"smart-thumb\" role=\"presentation\">\n                            <span id=\"secondThumbLabel\" class=\"smart-thumb-label\" role=\"presentation\"></span>\n                            <div id=\"secondTooltip\" class=\"smart-tooltip\" role=\"tooltip\">\n                                <div id=\"secondTooltipContent\" class=\"smart-tooltip-content smart-unselectable\" role=\"presentation\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <smart-repeat-button id=\"rightButton\" class=\"smart-spin-button\" animation=\"[[animation]]\" unfocusable>\n                        <div id=\"rightArrow\" class=\"smart-arrow\" role=\"presentation\" aria-hidden=\"true\"></div>\n                    </smart-repeat-button>\n                </div>\n                <div id=\"scaleFar\" class=\"smart-scale smart-scale-far\" role=\"presentation\" aria-hidden=\"true\"></div>\n                <input id=\"hiddenInput\" type=\"hidden\" name=\"[[name]]\">\n            </div>";
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this,
          t = "numeric" === e.mode;
      if (e.$.tooltip.id || (e.$.tooltip.id = e.id + "Tooltip", e.$.secondTooltip.id = e.id + "SecondTooltip"), e.setAttribute("aria-describedby", e.$.tooltip.id + " " + e.$.secondTooltip.id), e._renderingSuspended || (t ? e._redefineProperty("values") : !t && e._handleDateScale()), e._setSettingsObject(), e._setDrawVariables(), e._getLayoutType(), e._numericProcessor = new Smart.Utilities.NumericProcessor(e, "scaleType"), e._numberRenderer = new Smart.Utilities.NumberRenderer(), !e._isVisible()) return void (e._renderingSuspended = !0);
      e._renderingSuspended = !1, e._setInitialComponentDisplay(), e._measurements = {}, e._getMeasurements(), e._wordLengthNumber = e._numericProcessor.getWordLength(e.wordLength);
      var i = e._valuesHandler = e.rangeSlider ? new Smart.Utilities.SliderMultipleValueHandler(e) : new Smart.Utilities.SliderSingleValueHandler(e);
      t && (e._getEventValue = function (t) {
        return e._valuesHandler.getValue(t);
      }), e._validateInitialPropertyValues(), e._setTicksAndInterval(), i.validate(!0), i.updateTooltipValue(), window.requestAnimationFrame(function () {
        e.$thumb.addClass("enable-animation"), e.$secondThumb.addClass("enable-animation"), e.$fill.addClass("enable-animation");
      }), e._setFocusable(), e._makeThumbAccessible(), e.$.hiddenInput.value = e._getEventValue(), e.setAttribute("aria-orientation", e.orientation), e.setAttribute("aria-valuenow", e._getEventValue(!0));
    }
  }, {
    key: "val",
    value: function val(e) {
      var t = this,
          i = t._valuesHandler;
      return void 0 === e ? t._getEventValue() : void ("date" === t.mode && (t.rangeSlider ? (e[0] = Smart.Utilities.DateTime.validateDate(e[0]), e[1] = Smart.Utilities.DateTime.validateDate(e[1]), e[0] = e[0].getTimeStamp(), e[1] = e[1].getTimeStamp()) : (e = Smart.Utilities.DateTime.validateDate(e), e = e.getTimeStamp())), i.areDifferent(e) && i.validate(!1, e, !0));
    }
  }, {
    key: "getOptimalSize",
    value: function getOptimalSize() {
      var e = Math.max;
      var t = this;
      if (t._renderingSuspended) return {
        width: 0,
        height: 0
      };
      var i = window.getComputedStyle(t),
          a = window.getComputedStyle(t.$.trackContainer);
      var n = 0,
          o,
          r,
          l,
          s,
          d,
          c,
          m,
          u;
      return o = "all" === t.labelsVisibility ? t._numericProcessor._longestLabelSize : "endPoints" === t.labelsVisibility ? e(t._tickIntervalHandler.labelsSize.minLabelOtherSize, t._tickIntervalHandler.labelsSize.maxLabelOtherSize) : 0, "horizontal" === t.orientation ? (n += parseFloat(a.marginTop) + parseFloat(a.marginBottom) + t.$.track.offsetHeight, ("near" === t.scalePosition || "both" === t.scalePosition) && (n += o, l = t.$.scaleNear.getElementsByClassName("smart-label"), s = l[0], d = l[l.length - 1], n += parseFloat(window.getComputedStyle(s).bottom)), ("far" === t.scalePosition || "both" === t.scalePosition) && (n += o, l = t.$.scaleFar.getElementsByClassName("smart-label"), s = l[0], d = l[l.length - 1], n += parseFloat(window.getComputedStyle(s).top)), n += parseFloat(i.paddingTop) + parseFloat(i.paddingBottom), r = t.offsetWidth, "none" !== t.scalePosition && (c = s.getBoundingClientRect(), m = d.getBoundingClientRect(), u = c.left + s.offsetWidth - m.left, 0 < u && (r = s.offsetWidth + d.offsetWidth + e(10, t.$.thumb.offsetWidth))), {
        width: r,
        height: n
      }) : (n += parseFloat(a.marginLeft) + parseFloat(a.marginRight) + t.$.track.offsetWidth, ("near" === t.scalePosition || "both" === t.scalePosition) && (n += o, l = t.$.scaleNear.getElementsByClassName("smart-label"), s = l[0], d = l[l.length - 1], n += parseFloat(window.getComputedStyle(s).right)), ("far" === t.scalePosition || "both" === t.scalePosition) && (n += o, l = t.$.scaleFar.getElementsByClassName("smart-label"), s = l[0], d = l[l.length - 1], n += parseFloat(window.getComputedStyle(s).left)), n += parseFloat(i.paddingLeft) + parseFloat(i.paddingRight), r = t.offsetHeight, "none" !== t.scalePosition && (c = s.getBoundingClientRect(), m = d.getBoundingClientRect(), u = c.top + s.offsetHeight - m.top, 0 < u && (r = s.offsetHeight + d.offsetHeight + e(10, t.$.thumb.offsetHeight))), {
        width: n,
        height: r
      });
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      function a() {
        n._setTicksAndInterval(), o.validate(!1, o.getValue(), !0);
      }

      var n = this;
      if (!n._isVisible() || n._renderingSuspended) return void (n._renderingSuspended = !0);
      if (-1 !== ["disabled", "mode", "readonly", "showThumbLabel", "tooltipPosition", "unfocusable", "validation"].indexOf(e)) return void _get(_getPrototypeOf(_class70.prototype), "propertyChangedHandler", this).call(this, e, t, i);
      var o = n._valuesHandler;
      if ("values" !== e && i != t || "values" === e && (i[0] != t[0] || i[1] !== t[1])) switch (e) {
        case "coerce":
          if (i) {
            var _e786 = o.getValue();

            o.validate(!1, _e786.slice(0), !0), n._valueBeforeCoercion = _e786;
          } else void 0 !== n._valueBeforeCoercion && o.validate(!1, n._valueBeforeCoercion.slice(0), !0);

          break;

        case "customInterval":
        case "customTicks":
          _get(_getPrototypeOf(_class70.prototype), "propertyChangedHandler", this).call(this, e, t, i), n.customInterval && o.validate(!1, o.getValue(), !0);
          break;

        case "dateLabelFormatString":
          "date" === n.mode && a();
          break;

        case "decimalSeparator":
        case "scientificNotation":
          if ("date" === n.mode) return;
          a();
          break;

        case "interval":
          n._numericProcessor.validateInterval(i), o.validate(!1, o.getValue(), !0);
          break;

        case "inverted":
        case "rightToLeft":
          n._getLayoutType(), n._normalLayout && (n.$.fill.style[n._settings.margin] = "0px"), a();
          break;

        case "labelFormatFunction":
        case "showUnit":
        case "unit":
          a();
          break;

        case "labelsVisibility":
        case "ticksVisibility":
          return;

        case "logarithmicScale":
          if ("date" === n.mode) return void (n.logarithmicScale = !1);
          n._validateMinMax("both"), a();
          break;

        case "min":
        case "max":
          "date" === n.mode && (delete n._dateInterval, n[e] = Smart.Utilities.DateTime.validateDate(i).getTimeStamp()), n._validateMinMax(e, !1, t), a();
          break;

        case "orientation":
          n.$.container.removeAttribute("style"), n.$.trackContainer.removeAttribute("style"), n.$.fill.removeAttribute("style"), n.$.thumb.removeAttribute("style"), n.$.secondThumb.removeAttribute("style"), n._setSettingsObject(), n._getLayoutType(), n._getMeasurements(), a(), "horizontal" === i ? (n.$leftArrow.removeClass("smart-arrow-up"), n.$rightArrow.removeClass("smart-arrow-down"), n.$leftArrow.addClass("smart-arrow-left"), n.$rightArrow.addClass("smart-arrow-right")) : (n.$leftArrow.removeClass("smart-arrow-left"), n.$rightArrow.removeClass("smart-arrow-right"), n.$leftArrow.addClass("smart-arrow-up"), n.$rightArrow.addClass("smart-arrow-down")), n.setAttribute("aria-orientation", i);
          break;

        case "precisionDigits":
        case "significantDigits":
          if ("date" === n.mode) return;
          "precisionDigits" === e && "integer" === n.scaleType && n.error(n.localize("noInteger", {
            elementType: n.nodeName.toLowerCase(),
            property: e
          })), "significantDigits" === e && null !== n.precisionDigits ? n.precisionDigits = null : "precisionDigits" == e && null !== n.significantDigits && (n.significantDigits = null), a();
          break;

        case "rangeSlider":
          i ? (n.values = [n.min, n.value], n._drawValues = [n._drawMin, n._drawValue], "date" === n.mode && (n._valueDate = [n._minDate.clone(), n._valueDate]), void 0 !== n._valueBeforeCoercion && (n._valueBeforeCoercion = [n.min, n._valueBeforeCoercion]), o = n._valuesHandler = new Smart.Utilities.SliderMultipleValueHandler(n)) : (n.value = n.values[1], n._drawValue = n._drawValues[1], "date" === n.mode && (n._valueDate = n._valueDate[1]), void 0 !== n._valueBeforeCoercion && (n._valueBeforeCoercion = n._valueBeforeCoercion[1]), o = n._valuesHandler = new Smart.Utilities.SliderSingleValueHandler(n), n.$.fill.style.marginTop = 0, n.$.fill.style.marginLeft = 0), o.validate(!1, o.getValue(), !0);
          break;

        case "scalePosition":
          n._setInitialComponentDisplay(), a();
          break;

        case "scaleType":
          if ("date" === n.mode) return void (n.scaleType = "integer");
          n._numericProcessor = new Smart.Utilities.NumericProcessor(n, "scaleType"), n._validateMinMax("both"), n._setTicksAndInterval(), o.validate(!0);
          break;

        case "showButtons":
          i ? (n.$leftButton.removeClass("smart-hidden"), n.$rightButton.removeClass("smart-hidden")) : (n.$leftButton.addClass("smart-hidden"), n.$rightButton.addClass("smart-hidden")), n._setTicksAndInterval(), o.moveThumbBasedOnValue(o.getDrawValue(), void 0, !0);
          break;

        case "showTooltip":
          _get(_getPrototypeOf(_class70.prototype), "propertyChangedHandler", this).call(this, e, t, i), i || (n.$tooltip.addClass("smart-hidden"), n.$secondTooltip.addClass("smart-hidden"));
          break;

        case "theme":
          _get(_getPrototypeOf(_class70.prototype), "propertyChangedHandler", this).call(this, e, t, i), a();
          break;

        case "ticksPosition":
          "scale" === i ? (n.$trackTicksContainer.addClass("smart-hidden"), n.$.trackTicksContainer.innerHTML = "") : n.$trackTicksContainer.removeClass("smart-hidden"), n._setTicksAndInterval();
          break;

        case "value":
        case "values":
          if ("value" === e && n.rangeSlider || "values" === e && !n.rangeSlider) return;
          if (n[e] = t, "date" === n.mode) if ("value" === e) {
            if (i = Smart.Utilities.DateTime.validateDate(i), i = i.getTimeStamp(), n.value = i, 0 === i.compare(t)) return;
          } else if (i[0] = Smart.Utilities.DateTime.validateDate(i[0]), i[1] = Smart.Utilities.DateTime.validateDate(i[1]), i[0] = i[0].getTimeStamp(), i[1] = i[1].getTimeStamp(), n.values = i, 0 === i[0].compare(t[0]) && 0 === i[1].compare(t[1])) return;
          o.validate(!1, i, !0);
          break;

        case "wordLength":
          if ("date" === n.mode) return void (n.wordLength = "uint64");
          n._wordLengthNumber = n._numericProcessor.getWordLength(i), n._validateMinMax("both"), a();
      } else "string" != typeof i && "string" == typeof t && (n[e] = t);
    }
  }, {
    key: "_addMovedThumbClass",
    value: function _addMovedThumbClass() {
      var e = this;
      e.rangeSlider && (e._movedThumb.$.addClass("smart-moved-thumb"), e._movedThumb === e.$.thumb ? e.$secondThumb.removeClass("smart-moved-thumb") : e.$thumb.removeClass("smart-moved-thumb"));
    }
  }, {
    key: "_setInitialComponentDisplay",
    value: function _setInitialComponentDisplay() {
      _get(_getPrototypeOf(_class70.prototype), "_setInitialComponentDisplay", this).call(this);

      var e = this;
      e.$secondTooltip.addClass("smart-hidden"), e.showButtons || (e.$leftButton.addClass("smart-hidden"), e.$rightButton.addClass("smart-hidden"));
    }
  }, {
    key: "_getMeasurements",
    value: function _getMeasurements() {
      var e = this,
          t = e._measurements,
          i = e.$.track,
          a = e.$.thumb;
      return !e._isVisible() || e._renderingSuspended ? void (e._renderingSuspended = !0) : void ("horizontal" === e.orientation ? (t.trackWidth = i.offsetHeight, t.thumbSize = a.offsetWidth, t.borderWidth = parseFloat(window.getComputedStyle(e.$.track).borderLeftWidth)) : (t.trackWidth = i.offsetWidth, t.thumbSize = a.offsetHeight, t.borderWidth = parseFloat(window.getComputedStyle(e.$.track).borderTopWidth)), t.halfThumbSize = t.thumbSize / 2);
    }
  }, {
    key: "_layout",
    value: function _layout() {
      var e = Math.max;
      var t = this,
          i = t._measurements,
          a = t.$.container.style,
          n = i.halfThumbSize,
          o = t._tickIntervalHandler.labelsSize;
      var r, l, s, d;
      if ("none" === t.scalePosition ? (r = 0, l = 0) : (r = o.minLabelSize / 2, l = o.maxLabelSize / 2), !t.showButtons) s = e(n, r) + "px", d = e(n, l) + "px";else {
        var _i688 = t.$.leftButton[t._settings.size],
            _a425 = _i688 + n;

        s = e(r - _a425, 0) + "px", d = e(l - _a425, 0) + "px";
      }
      "horizontal" === t.orientation ? (!t.inverted && !t.rightToLeft || t.rightToLeft && t.inverted ? (a.paddingLeft = s, a.paddingRight = d) : (a.paddingLeft = d, a.paddingRight = s), i.trackLength = t.$.track.clientWidth, t.$leftArrow.addClass("smart-arrow-left"), t.$rightArrow.addClass("smart-arrow-right")) : (t.inverted ? (a.paddingBottom = d, a.paddingTop = s) : (a.paddingBottom = s, a.paddingTop = d), i.trackLength = t.$.track.clientHeight, t.$leftArrow.addClass("smart-arrow-up"), t.$rightArrow.addClass("smart-arrow-down"));
    }
  }, {
    key: "_trackDownHandler",
    value: function _trackDownHandler(e) {
      var t = this,
          i = t.mechanicalAction;
      return t.disabled || t.readonly || !t.rangeSlider && e.target === t.$.thumb ? void 0 : t._stopTrackDownHandler ? void (t._stopTrackDownHandler = !1) : void ("switchWhileDragging" !== i && (t._valueAtDragStart = t._valuesHandler.getValue()), t._getTrackStartAndEnd(), t._valuesHandler.setActiveThumbOnTrackClick(e), t._moveThumbBasedOnCoordinates(e, !0, "switchWhenReleased" !== i), t._thumbDragged = !0, t.setAttribute("dragged", ""), t.showTooltip && t._movedTooltip.removeClass("smart-hidden"));
    }
  }, {
    key: "_trackMoveHandler",
    value: function _trackMoveHandler() {}
  }, {
    key: "_thumbDownHandler",
    value: function _thumbDownHandler(e) {
      var t = this;
      t.disabled || t.readonly || (t._getTrackStartAndEnd(), (e[t._settings.page] < t._trackStart || e[t._settings.page] > t._trackEnd) && (t._stopTrackDownHandler = !0), "switchWhileDragging" !== t.mechanicalAction && (t._valueAtDragStart = t._valuesHandler.getValue()), window.getSelection().removeAllRanges(), t._thumbDragged = !0, t.setAttribute("dragged", ""), t.$track.addClass("smart-dragged"), t._movedThumb = e.target, t._addMovedThumbClass(), t._movedTooltip = t.$tooltip, t.rangeSlider && (t._movedThumb === t.$.thumb ? (t._staticThumb = t.$.secondThumb, t.$secondTooltip.addClass("smart-hidden")) : (t._staticThumb = t.$.thumb, t._movedTooltip = t.$secondTooltip, t.$tooltip.addClass("smart-hidden"))), t.showTooltip && t._movedTooltip.removeClass("smart-hidden"), e.stopPropagation());
    }
  }, {
    key: "_thumbMoveMouseleaveHandler",
    value: function _thumbMoveMouseleaveHandler(e) {
      var t = Math.pow;
      var i = this;

      if (!(i.disabled || i.readonly)) {
        var _i689 = e.target;

        if ("move" === e.type) {
          var _a426 = _i689.getBoundingClientRect(),
              _n333 = window.scrollX || window.pageXOffset,
              _o232 = window.scrollY || window.pageYOffset,
              _r147 = (_a426.left + _a426.right) / 2 + _n333,
              _l109 = (_a426.top + _a426.bottom) / 2 + _o232,
              _s79 = t(_a426.width / 2, 2);

          if (t(e.pageX - _r147, 2) + t(e.pageY - _l109, 2) > _s79) return;

          _i689.setAttribute("hover", "");
        } else _i689.removeAttribute("hover");
      }
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = this;
      t._thumbDragged && (t.$thumb.removeClass("enable-animation"), t.$secondThumb.removeClass("enable-animation"), t.$fill.removeClass("enable-animation"), t._moveThumbBasedOnCoordinates(e, !0, "switchWhenReleased" !== t.mechanicalAction));
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e, t) {
      var i = this;
      i._thumbDragged && (i.$thumb.addClass("enable-animation"), i.$secondThumb.addClass("enable-animation"), i.$fill.addClass("enable-animation"), !t && ("switchUntilReleased" === i.mechanicalAction ? i._valuesHandler.validate(!1, i._valueAtDragStart) : "switchWhenReleased" === i.mechanicalAction && i._moveThumbBasedOnCoordinates(e, !0, !0)), i.showTooltip && i._movedTooltip.addClass("smart-hidden"), i._thumbDragged = !1, i.removeAttribute("dragged"), i._makeThumbAccessible(), i._movedThumb = void 0, i.$track.removeClass("smart-dragged"));
    }
  }, {
    key: "_spinButtonClickHandler",
    value: function _spinButtonClickHandler(e) {
      var t = this;
      if (t.disabled || t.readonly) return;
      var i;
      i = t.$.leftButton.contains(e.target) === t._normalLayout ? "subtract" : "add", t._valuesHandler.incrementOrDecrement(i);
    }
  }, {
    key: "_keydownHandlerSlider",
    value: function _keydownHandlerSlider(e) {
      var t = this,
          i = e.key;
      return "Escape" === i && t._thumbDragged && "switchWhenReleased" === t.mechanicalAction ? (t._documentUpHandler(void 0, !0), void t._valuesHandler.validate(!1, t._valueAtDragStart)) : void (-1 !== ["ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp"].indexOf(i) && !t.coerce && (t.$thumb.removeClass("enable-animation"), t.$secondThumb.removeClass("enable-animation"), t.$fill.removeClass("enable-animation"), t._restoreAnimationClass = !0), this._valuesHandler.keydownHandler(e));
    }
  }, {
    key: "_keyupHandlerSlider",
    value: function _keyupHandlerSlider() {
      var e = this;
      e._restoreAnimationClass && (e.$thumb.addClass("enable-animation"), e.$secondThumb.addClass("enable-animation"), e.$fill.addClass("enable-animation"));
    }
  }, {
    key: "_resizeAndStyleChangedHandler",
    value: function _resizeAndStyleChangedHandler(e) {
      var t = this,
          i = t._valuesHandler;
      if (!t._isVisible()) return void (t._renderingSuspended = !0);
      if (t._renderingSuspended) return void t._createElement();

      if (!t._renderingSuspended && (t._getMeasurements(), t._setTicksAndInterval(), i.validate(!1, i.getValue(), !0), "styleChanged" === e.type)) {
        var _i690 = e.detail.styleProperties;

        if (_i690["font-size"] || _i690["font-family"] || _i690["font-style"] || _i690["font-weight"]) {
          var _e787 = t.getOptimalSize();

          t.style.width = _e787.width + "px", t.style.height = _e787.height + "px";
        }
      }
    }
  }, {
    key: "_moveThumbBasedOnCoordinates",
    value: function _moveThumbBasedOnCoordinates(e, t, i) {
      var a = this,
          n = a._numericProcessor,
          o = a._trackStart,
          r = a._settings.margin;
      var l = e[a._settings.page];
      t && (l = a._valuesHandler.restrictThumbCoordinates(l, o, a._trackEnd));
      var s = n.pxToValue(l);
      a.rangeSlider && a._movedThumb === a.$.thumb && 1 === n.compare(s, a.values[1], !0) && (s = n.createDescriptor(a.values[1]));
      var d = s;
      a.logarithmicScale ? (s = n.getCoercedValue(Math.log10(s)), d = parseFloat(Math.pow(10, s).toFixed(11))) : (s = n.getCoercedValue(s), d = s), l = n.valueToPx(s) + o;
      var c = l - o;
      a._movedThumb.style[r] = c - a._measurements.halfThumbSize + "px", a._valuesHandler.updateFillSizeAndPosition(c, r, d, !0, i), Smart.Utilities.Core.isMobile && e.originalEvent && (e.originalEvent.stopPropagation(), e.originalEvent.preventDefault());
    }
  }, {
    key: "_moveThumbBasedOnValue",
    value: function _moveThumbBasedOnValue(e, t, i, a) {
      var n = this,
          o = n._numericProcessor.valueToPx(t),
          r = n._settings.margin;

      e.style[r] = o - n._measurements.halfThumbSize + "px";

      var l = n._getSingleActualValue(t);

      a ? n.rangeSlider && (n._firstPassSize = o) : n._valuesHandler.updateFillSizeAndPosition(o, r, l, i, i);
    }
  }, {
    key: "_validate",
    value: function _validate(e, t, i, a) {
      this._valuesHandler.validate(e, t, a);
    }
  }, {
    key: "_updateValue",
    value: function _updateValue(e) {
      var t = this._valuesHandler;
      t.updateValue(t.getActualValue(e));
    }
  }, {
    key: "_makeThumbAccessible",
    value: function _makeThumbAccessible() {
      var e = this;
      e.rangeSlider && (e.$.thumb[e._settings.offset] === e.$.secondThumb[e._settings.offset] && !1 === e._numericProcessor.compare(e.values[1], e.max) ? e.$thumb.addClass("accessible") : e.$thumb.removeClass("accessible"));
    }
  }, {
    key: "_getSingleActualValue",
    value: function _getSingleActualValue(e) {
      return this.logarithmicScale ? parseFloat(Math.pow(10, e).toFixed(11)) : e.toString();
    }
  }, {
    key: "_coerceCustomInterval",
    value: function _coerceCustomInterval() {
      var e = this;

      if (e.coerce) {
        var _t686 = e._valueBeforeCoercion;
        e._valuesHandler.validate(!1, e._valuesHandler.getValue()), e._valueBeforeCoercion = _t686;
      }
    }
  }, {
    key: "_wheelHandler",
    value: function _wheelHandler(e) {
      var t = this;
      document.activeElement === t && t.enableMouseWheelAction && (e.stopPropagation(), e.preventDefault(), 0 < e.wheelDelta ? t._keydownHandlerSlider({
        key: "ArrowRight",
        which: 39,
        preventDefault: function preventDefault() {}
      }) : t._keydownHandlerSlider({
        key: "ArrowLeft",
        which: 37,
        preventDefault: function preventDefault() {}
      }));
    }
  }, {
    key: "_handleDateScale",
    value: function _handleDateScale() {
      var e = this,
          t = Smart.Utilities.DateTime;
      _get(_getPrototypeOf(_class70.prototype), "_handleDateScale", this).call(this), Object.defineProperty(e, "values", {
        get: function get() {
          return e.context === e ? e.properties.values.value : e._valueDate;
        },
        set: function set(t) {
          function i(e, t) {
            return t instanceof Smart.Utilities.BigNumber ? t.toString() : t;
          }

          var a = e.properties.values.value,
              n = JSON.stringify(a, i),
              o = JSON.stringify(t, i);

          if (n !== o && (e.properties.values.value = t, e.isReady && (!e.ownerElement || e.ownerElement && e.ownerElement.isReady) && e.context !== e)) {
            var _i691 = e.context;
            e.context = e, e.propertyChangedHandler("values", a, t), e.context = _i691;
          }
        }
      }), e.rangeSlider && (e._valueDate = [t.validateDate(e.values[0]), t.validateDate(e.values[1])], e.values = [e._valueDate[0].getTimeStamp(), e._valueDate[1].getTimeStamp()]), e._properties.values.serialize = "_serializeValue";
    }
  }, {
    key: "_setTicksAndInterval",
    value: function _setTicksAndInterval() {
      var e = this;
      e._skipTrackReset ? delete e._skipTrackReset : e.$.track.style[e._settings.dimension] = null, _get(_getPrototypeOf(_class70.prototype), "_setTicksAndInterval", this).call(this), 10 > e.$.track[e._settings.size] && (e._skipTrackReset = !0, e.$.track.style[e._settings.dimension] = e.getOptimalSize()[e._settings.dimension] + "px", e._getMeasurements(), e._setTicksAndInterval(), e._valuesHandler.validate(!1, e._valuesHandler.getValue()));
    }
  }, {
    key: "_getLayoutType",
    value: function _getLayoutType() {
      var e = this;
      _get(_getPrototypeOf(_class70.prototype), "_getLayoutType", this).call(this), e._normalLayout ? (e.$.leftButton.setAttribute("aria-label", "Decrement"), e.$.rightButton.setAttribute("aria-label", "Increment")) : (e.$.leftButton.setAttribute("aria-label", "Increment"), e.$.rightButton.setAttribute("aria-label", "Decrement"));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        enableMouseWheelAction: {
          value: !1,
          type: "boolean"
        },
        orientation: {
          value: "horizontal",
          allowedValues: ["horizontal", "vertical"],
          type: "string",
          defaultReflectToAttribute: !0
        },
        rangeSlider: {
          value: !1,
          type: "boolean"
        },
        showButtons: {
          value: !1,
          type: "boolean"
        },
        values: {
          value: ["0", "100"],
          type: "array"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "track.down": "_trackDownHandler",
        "thumb.down": "_thumbDownHandler",
        "secondThumb.down": "_thumbDownHandler",
        "thumb.mouseleave": "_thumbMoveMouseleaveHandler",
        "secondThumb.mouseleave": "_thumbMoveMouseleaveHandler",
        "thumb.move": "_thumbMoveMouseleaveHandler",
        "secondThumb.move": "_thumbMoveMouseleaveHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler",
        "leftButton.click": "_spinButtonClickHandler",
        "rightButton.click": "_spinButtonClickHandler",
        keydown: "_keydownHandlerSlider",
        keyup: "_keyupHandlerSlider",
        resize: "_resizeAndStyleChangedHandler",
        styleChanged: "_resizeAndStyleChangedHandler",
        "document.selectstart": "_selectStartHandler",
        wheel: "_wheelHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.RepeatButton": "smart.button.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.slider.css", "smart.button.css"];
    }
  }]);

  return _class70;
}(Smart.Tank)), Smart.Utilities.Assign("SliderSingleValueHandler",
/*#__PURE__*/
function () {
  "use strict";

  function _class71(e) {
    _classCallCheck(this, _class71);

    this.context = e, "date" === e.mode && (e._getEventValue = function (t, i) {
      var a;
      return void 0 !== i && (a = Smart.Utilities.DateTime.fromFullTimeStamp(i)), a = e._valueDate.clone(), t ? a.toString("f") : a;
    });
  }

  _createClass(_class71, [{
    key: "applyFunctionToValue",
    value: function applyFunctionToValue(e, t) {
      var i = this,
          a = i.context;
      t === void 0 && (t = a.value);
      var n = e.apply(a, [t]);
      return n;
    }
  }, {
    key: "areDifferent",
    value: function areDifferent(e) {
      return this.context.value !== e;
    }
  }, {
    key: "incrementOrDecrement",
    value: function incrementOrDecrement(e) {
      var t = this.context,
          i = t._keyIncrementDecrement(e);

      this.validate(!1, i);
    }
  }, {
    key: "setActiveThumbOnTrackClick",
    value: function setActiveThumbOnTrackClick() {
      var e = this.context;
      e._movedThumb = e.$.thumb, e._addMovedThumbClass(), e._movedTooltip = e.$tooltip;
    }
  }, {
    key: "getActualValue",
    value: function getActualValue(e) {
      return this.context._getSingleActualValue(e);
    }
  }, {
    key: "getCoercedLogarithmicValue",
    value: function getCoercedLogarithmicValue(e) {
      var t = this.context;

      if (t.logarithmicScale) {
        var _i692 = t._numericProcessor.getCoercedValue(Math.log10(e));

        return this.getActualValue(_i692);
      }

      return e;
    }
  }, {
    key: "getDrawValue",
    value: function getDrawValue() {
      return this.context._drawValue;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.context.value;
    }
  }, {
    key: "keydownHandler",
    value: function keydownHandler(e) {
      this.context._keydownHandler(e);
    }
  }, {
    key: "moveThumbBasedOnValue",
    value: function moveThumbBasedOnValue(e, t, i) {
      var a = this.context;

      if (void 0 === e && (e = a.value), a._moveThumbBasedOnValue(a.$.thumb, e, t), !0 !== i) {
        a._drawValue = e;

        var _t687 = this.getActualValue(e);

        var _i693;

        _i693 = void 0 === a._valueNoRangeValidation ? _t687.toString() : a._valueNoRangeValidation.toString(), "date" === a.mode && (a._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(_i693)), a.value = _i693, delete a._valueBeforeCoercion, this.updateTooltipValue(_t687);
      }
    }
  }, {
    key: "restrictThumbCoordinates",
    value: function restrictThumbCoordinates(e, t, i) {
      return e = Math.max(e, t), e = Math.min(e, i), e;
    }
  }, {
    key: "updateFillSizeAndPosition",
    value: function updateFillSizeAndPosition(e, t, i, a, n) {
      var o = this.context,
          r = o.$.fill.style,
          l = o._settings.dimension;

      if (o._normalLayout ? r[l] = e + "px" : (r[l] = o._measurements.trackLength - e + "px", r[t] = e + "px"), a) {
        var _e788 = o.value,
            _t688 = o._getEventValue(!1, _e788),
            _a427 = o._numericProcessor;

        if (_a427.compare(_a427.createDescriptor(i), _a427.createDescriptor(_e788)) && (this.updateTooltipValue(i), n)) {
          var _e789;

          if (o._drawValue = o.logarithmicScale ? Math.log10(i) : i, _e789 = void 0 === o._valueNoRangeValidation ? i.toString() : o._valueNoRangeValidation.toString(), "date" === o.mode && (o._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(_e789)), o.value = _e789, delete o._valueBeforeCoercion, !0 !== o._programmaticValueIsSet) {
            var _e790 = o._getEventValue();

            o.$.hiddenInput.value = _e790, o.$.fireEvent("change", {
              value: _e790,
              oldValue: _t688
            }), o.setAttribute("aria-valuenow", o._getEventValue(!0));
          }
        }
      }
    }
  }, {
    key: "updateTooltipValue",
    value: function updateTooltipValue(e) {
      var t = this.context;
      e === void 0 && (e = t.value);

      var i = t._formatLabel(e);

      t.$.tooltipContent.innerHTML !== i && (t.$.tooltipContent.innerHTML = i, t.$.thumbLabel.innerHTML = i);
    }
  }, {
    key: "updateValue",
    value: function updateValue(e) {
      var t = this.context,
          i = t._numericProcessor.createDescriptor(e, !0, !1);

      t._drawValue = t.logarithmicScale ? Math.log10(i) : i, this.moveThumbBasedOnValue(t._drawValue, !0);
    }
  }, {
    key: "validate",
    value: function validate(e, t, i) {
      var a = this.context,
          n = a._numericProcessor;
      var o;
      a._programmaticValueIsSet = i && "interaction" === a.validation, o = e ? a.value : t;
      var r;
      a.coerce && (o = a._numericProcessor.createDescriptor(o, !0, !0, !0)), o = a.logarithmicScale ? this.getCoercedLogarithmicValue(o) : n.getCoercedValue(o), "strict" === a.validation ? (a._valueNoRangeValidation = n.createDescriptor(o, !0, !0, !0), r = a._valueNoRangeValidation) : (a._valueNoRangeValidation = n.createDescriptor(o, !0, !0, !1), r = n.validate(a._valueNoRangeValidation, a._minObject, a._maxObject)), e ? (a._drawValue = a.logarithmicScale ? Math.log10(r) : r, o = a._valueNoRangeValidation.toString(), "date" === a.mode && (a._valueDate = Smart.Utilities.DateTime.fromFullTimeStamp(o)), a.value = o, this.moveThumbBasedOnValue(a._drawValue, void 0, !0)) : this.updateValue(r), delete a._valueNoRangeValidation, a._programmaticValueIsSet = !1;
    }
  }]);

  return _class71;
}()), Smart.Utilities.Assign("SliderMultipleValueHandler",
/*#__PURE__*/
function () {
  "use strict";

  function _class72(e) {
    _classCallCheck(this, _class72);

    this.context = e, "date" === e.mode && (e._getEventValue = function (t, i, a) {
      var n = [e._valueDate[0].clone(), e._valueDate[1].clone()];
      return void 0 !== i && (n[a] = Smart.Utilities.DateTime.fromFullTimeStamp(i)), t ? "From ".concat(n[0].toString("f"), " to ").concat(n[1].toString("f")) : n;
    });
  }

  _createClass(_class72, [{
    key: "applyFunctionToValue",
    value: function applyFunctionToValue(e, t) {
      var i = this,
          a = i.context,
          n = [];
      return void 0 === t && (t = a.values), n[0] = e.apply(a, [t[0]]), n[1] = e.apply(a, [t[1]]), n;
    }
  }, {
    key: "areDifferent",
    value: function areDifferent(e) {
      var t = this.context.values;
      return t[0] !== e[0] || t[1] !== e[1];
    }
  }, {
    key: "incrementOrDecrement",
    value: function incrementOrDecrement(e) {
      var t = this.context,
          i = t.values.slice(0);
      var a;
      a = "add" === e ? 1 : 0, i[a] = this.keyIncrementDecrement(e, a), this.validate(!1, i);
    }
  }, {
    key: "keydownHandler",
    value: function keydownHandler(e) {
      var t = this.context;

      if (!(t.disabled || t.readonly)) {
        var _i694 = e.charCode ? e.charCode : e.which;

        if (-1 !== [35, 36, 37, 38, 39, 40].indexOf(_i694)) {
          e.preventDefault();

          var _a428 = t.values.slice(0);

          var _n334;

          return 40 === _i694 || 37 === _i694 ? (_n334 = this.keyIncrementDecrement("subtract", 0), _a428[0] = _n334, t._movedThumb = t.$.thumb) : 38 === _i694 || 39 === _i694 ? (_n334 = this.keyIncrementDecrement("add", 1), _a428[1] = _n334, t._movedThumb = t.$.secondThumb) : 36 === _i694 ? (t._drawValues[0] = t._drawMin, _a428[0] = t.min, t._movedThumb = t.$.thumb) : 35 === _i694 ? (t._drawValues[1] = t._drawMax, _a428[1] = t.max, t._movedThumb = t.$.secondThumb) : void 0, this.validate(!1, _a428), !1;
        }
      }
    }
  }, {
    key: "keyIncrementDecrement",
    value: function keyIncrementDecrement(e, t) {
      var i = this.context;
      var a, n;
      if (i.customInterval && i.coerce) return a = this.getValue()[t], i._keyIncrementDecrement(e, a.toString());
      if ("date" === i.mode) return a = i._valueDate[t], n = a[i._dateIncrementMethod](("add" === e ? 1 : -1) * parseFloat(i.interval), !0), n = n.getTimeStamp(), -1 === n.compare(i._drawMin) ? new Smart.Utilities.BigNumber(i._drawMin) : 1 === n.compare(i._drawMax) ? new Smart.Utilities.BigNumber(i._drawMax) : n;
      var o = i._drawValues[t];
      return a = i._numericProcessor.createDescriptor(o), n = i._numericProcessor.incrementDecrement(a, e, i._validInterval), i.logarithmicScale && (i._drawValues[t] = n, n = parseFloat(Math.pow(10, Math.round(n)).toFixed(11))), n;
    }
  }, {
    key: "setActiveThumbOnTrackClick",
    value: function setActiveThumbOnTrackClick(e) {
      var t = this.context,
          i = t._trackStart + t._measurements.halfThumbSize,
          a = t._settings.offset,
          n = t.$.thumb,
          o = t.$.secondThumb,
          r = n[a],
          l = o[a],
          s = e[t._settings.page];
      var d = t._normalLayout ? i + r + (l - r) / 2 : i + l + (r - l) / 2;
      t._normalLayout && s <= d || !t._normalLayout && s > d ? (t._movedThumb = n, t._staticThumb = o, t._movedTooltip = t.$tooltip, t.$secondTooltip.addClass("smart-hidden")) : (t._movedThumb = o, t._staticThumb = n, t._movedTooltip = t.$secondTooltip, t.$tooltip.addClass("smart-hidden")), t._addMovedThumbClass();
    }
  }, {
    key: "getActualValue",
    value: function getActualValue(e) {
      var t = Math.pow;
      return this.context.logarithmicScale ? [parseFloat(t(10, e[0].toString()).toFixed(11)), parseFloat(t(10, e[1].toString()).toFixed(11))] : [e[0].toString(), e[1].toString()];
    }
  }, {
    key: "getCoercedLogarithmicValue",
    value: function getCoercedLogarithmicValue(e) {
      var t = Math.log10;
      var i = this.context;

      if (i.logarithmicScale) {
        var _a429 = [];
        return _a429[0] = i._numericProcessor.getCoercedValue(t(e[0])), _a429[1] = i._numericProcessor.getCoercedValue(t(e[1])), this.getActualValue(_a429);
      }

      return e;
    }
  }, {
    key: "getDrawValue",
    value: function getDrawValue() {
      return this.context._drawValues;
    }
  }, {
    key: "getValue",
    value: function getValue(e) {
      var t = this.context.values;
      return e ? "From ".concat(t[0], " to ").concat(t[1]) : t.slice(0);
    }
  }, {
    key: "moveThumbBasedOnValue",
    value: function moveThumbBasedOnValue(e, t, i) {
      var a = this.context,
          n = void 0 === t;

      if (void 0 === e && (e = a.values), a._numericProcessor.restrictValue(e), (n || 1 === t) && (a._movedThumb = a.$.secondThumb, a._moveThumbBasedOnValue(a.$.secondThumb, e[1], !0, n)), (n || 0 === t) && (a._movedThumb = a.$.thumb, a._moveThumbBasedOnValue(a.$.thumb, e[0], !0)), delete a._firstPassSize, !0 !== i) {
        a._drawValues = e;

        var _t689 = this.getActualValue(e);

        var _i695;

        _i695 = a._valuesNoRangeValidation ? [a._valuesNoRangeValidation[0].toString(), a._valuesNoRangeValidation[1].toString()] : _t689, "date" === a.mode && (a._valueDate = [Smart.Utilities.DateTime.fromFullTimeStamp(_t689[0]), Smart.Utilities.DateTime.fromFullTimeStamp(_t689[1])]), a.values = _i695, delete a._valueBeforeCoercion, this.updateTooltipValue();
      }
    }
  }, {
    key: "restrictThumbCoordinates",
    value: function restrictThumbCoordinates(e, t, i) {
      var a = Math.min,
          n = Math.max;
      var o = this.context,
          r = t + o._staticThumb[o._settings.offset] + o._measurements.halfThumbSize;
      return o._movedThumb === o.$.thumb && o._normalLayout || o._movedThumb === o.$.secondThumb && !o._normalLayout ? (e = n(e, t), e = a(e, i, r)) : (e = n(e, t, r), e = a(e, i)), e;
    }
  }, {
    key: "updateFillSizeAndPosition",
    value: function updateFillSizeAndPosition(e, t, i, a, n) {
      var o = Math.max;
      var r = this.context,
          l = r.$.fill.style,
          s = r._settings.dimension,
          d = r._settings.offset,
          c = r._measurements.halfThumbSize;
      var m, u;

      if (r._movedThumb === r.$.thumb ? (m = e - c, u = void 0 === r._firstPassSize ? r.$.secondThumb[d] : r._firstPassSize - c) : (m = void 0 === r._firstPassSize ? r.$.thumb[d] : r._firstPassSize - c, u = e - c), r._normalLayout ? (l[s] = o(0, u - m) + "px", l[t] = m + c + "px") : (l[s] = o(0, m - u) + "px", l[t] = u + c + "px"), a) {
        var _e791 = r._numericProcessor,
            _t690 = r._movedThumb === r.$.thumb ? 0 : 1,
            _a430 = r.values[_t690],
            _o233 = r._getEventValue(!1, _a430, _t690);

        if (_e791.compare(_e791.createDescriptor(i), _e791.createDescriptor(_a430))) {
          var _e792 = r.values.slice(0);

          if (_e792[_t690] = i.toString(), this.updateTooltipValue(i, _t690), n) {
            var _t691;

            if (this.updateDrawValues(_e792), _t691 = r._valuesNoRangeValidation ? [r._valuesNoRangeValidation[0].toString(), r._valuesNoRangeValidation[1].toString()] : _e792, "date" === r.mode && (r._valueDate = [Smart.Utilities.DateTime.fromFullTimeStamp(_e792[0]), Smart.Utilities.DateTime.fromFullTimeStamp(_e792[1])]), r.values = _t691, delete r._valueBeforeCoercion, !0 !== r._programmaticValueIsSet) {
              var _e793 = r._getEventValue();

              r.$.hiddenInput.value = _e793, r.$.fireEvent("change", {
                value: _e793,
                oldValue: _o233
              }), r.setAttribute("aria-valuenow", r._getEventValue(!0));
            }
          }
        }
      }
    }
  }, {
    key: "updateDrawValues",
    value: function updateDrawValues(e) {
      var t = Math.log10;
      var i = this.context;
      i.logarithmicScale ? (i._drawValues[0] = t(e[0]), i._drawValues[1] = t(e[1])) : i._drawValues = e.slice(0);
    }
  }, {
    key: "updateTooltipValue",
    value: function updateTooltipValue(e, t) {
      var i = this.context;

      if (e === void 0) {
        var _e794 = i.values,
            _t692 = i._formatLabel(_e794[0]),
            _a431 = i._formatLabel(_e794[1]);

        i.$.tooltipContent.innerHTML !== _t692 && (i.$.tooltipContent.innerHTML = _t692, i.$.thumbLabel.innerHTML = _t692), i.$.secondTooltipContent.innerHTML !== _a431 && (i.$.secondTooltipContent.innerHTML = _a431);
      } else {
        var _a432 = i._formatLabel(e);

        (0 === t && i.$.tooltipContent.innerHTML !== _a432 || t === void 0) && (i.$.tooltipContent.innerHTML = _a432, i.$.thumbLabel.innerHTML = _a432), (1 === t && i.$.secondTooltipContent.innerHTML !== _a432 || t === void 0) && (i.$.secondTooltipContent.innerHTML = _a432, i.$.secondThumbLabel.innerHTML = _a432);
      }
    }
  }, {
    key: "updateValue",
    value: function updateValue(e) {
      var t = this.context,
          i = [];
      var a;
      i[0] = t._numericProcessor.createDescriptor(e[0], !0, !1), i[1] = t._numericProcessor.createDescriptor(e[1], !0, !1), this.updateDrawValues(i), t._movedThumb === t.$.secondThumb && (a = 1), this.moveThumbBasedOnValue(t._drawValues.slice(0), a);
    }
  }, {
    key: "validate",
    value: function validate(e, t, i) {
      var a = this.context,
          n = a._numericProcessor;
      var o = [],
          r;
      a._programmaticValueIsSet = i && "interaction" === a.validation, r = e ? a.values.slice(0) : t, a.coerce && (r[0] = n.createDescriptor(r[0], !0, !0, !0), r[1] = n.createDescriptor(r[1], !0, !0, !0)), a.logarithmicScale ? r = this.getCoercedLogarithmicValue(r) : (r[0] = n.getCoercedValue(r[0]), r[1] = n.getCoercedValue(r[1])), a._valuesNoRangeValidation = [], a._valuesNoRangeValidation[0] = n.createDescriptor(r[0], !0, !0, !1), a._valuesNoRangeValidation[1] = n.createDescriptor(r[1], !0, !0, !1), a._numericProcessor.restrictValue(a._valuesNoRangeValidation), o[0] = n.validate(a._valuesNoRangeValidation[0], a._minObject, a._maxObject), o[1] = n.validate(a._valuesNoRangeValidation[1], a._minObject, a._maxObject), e ? (a._drawValues = [], this.updateDrawValues(o), r = [a._valuesNoRangeValidation[0].toString(), a._valuesNoRangeValidation[1].toString()], "date" === a.mode && (a._valueDate = [Smart.Utilities.DateTime.fromFullTimeStamp(o[0]), Smart.Utilities.DateTime.fromFullTimeStamp(o[1])]), a.values = r, this.moveThumbBasedOnValue(a._drawValues, void 0, !0)) : this.updateValue(o), delete a._valuesNoRangeValidation, a._programmaticValueIsSet = !1;
    }
  }]);

  return _class72;
}()), Smart("smart-accordion-item",
/*#__PURE__*/
function (_Smart$ContentElement4) {
  "use strict";

  _inherits(_class73, _Smart$ContentElement4);

  function _class73() {
    _classCallCheck(this, _class73);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class73).apply(this, arguments));
  }

  _createClass(_class73, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div id=\"accordionItemHeader\" class=\"smart-accordion-item-header smart-unselectable\" role=\"heading\" aria-level=\"1\">\n                        <span id=\"arrow\" class=\"smart-arrow\" role=\"presentation\" aria-hidden=\"true\"></span>\n                        <span id=\"label\" class=\"smart-label\" inner-h-t-m-l='[[label]]' role=\"button\"></span>\n                    </div>\n                    <div id=\"accordionItemContent\" class=\"smart-accordion-item-content\">\n                        <div id=\"contentContainer\" class=\"smart-content-container\" role=\"presentation\"><content></content></div>\n                    </div>\n                </div>";
    }
  }, {
    key: "render",
    value: function render() {
      var e = Math.floor;
      var t = this;
      var i;
      i = t.id ? t.id + "Content" : t.parentElement && t.parentElement.parentElement && t.parentElement.parentElement.id ? t.parentElement.parentElement.id + e(1e4 * Math.random()) + "Content" : "accordion" + e(1e4 * Math.random()) + "Content", t.$.accordionItemContent.id = i, t.$.label.setAttribute("aria-controls", i), _get(_getPrototypeOf(_class73.prototype), "render", this).call(this);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class73.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      if ("expanded" === e) {
        a.$.label.setAttribute("aria-expanded", i);

        var _e795 = a.parentElement && a.parentElement.parentElement ? a.parentElement.parentElement.expandMode : a.shadowParent.expandMode;

        return "multiple" === _e795 || "toggle" === _e795 ? void 0 : void (i ? a.$.label.setAttribute("aria-disabled", !0) : a.$.label.removeAttribute("aria-disabled"));
      }

      if (t = parseInt(t), i = parseInt(i), !("index" !== e || isNaN(t) || isNaN(i))) {
        var _e796 = a.parentElement.parentElement._items.length;
        0 > i ? i = 0 : i >= _e796 && (i = _e796 - 1), i !== t && a.$.fireEvent("indexChange", {
          newIndex: i,
          oldIndex: t
        }), a.index = i;
      }
    }
  }, {
    key: "_headerMouseEnterHandler",
    value: function _headerMouseEnterHandler() {
      var e = this;
      e.disabled || e.setAttribute("hover", "");
    }
  }, {
    key: "_headerMouseLeaveHandler",
    value: function _headerMouseLeaveHandler() {
      var e = this;
      e.disabled || e.removeAttribute("hover");
    }
  }, {
    key: "_ripple",
    value: function _ripple(e) {
      var t = this;
      t.disabled || t.hasRippleAnimation && Smart.Utilities.Animation.Ripple.animate(t.$.container, e.pageX, e.pageY);
    }
  }, {
    key: "_setIndex",
    value: function _setIndex(e) {
      var t = this,
          i = t.context;
      t.context = t, t.index = e, t.context = i;
    }
  }, {
    key: "focus",
    value: function focus() {
      var e = this;
      _get(_getPrototypeOf(_class73.prototype), "focus", this).call(this), e.setAttribute("focus", "");
    }
  }, {
    key: "blur",
    value: function blur() {
      var e = this;
      _get(_getPrototypeOf(_class73.prototype), "blur", this).call(this), e.removeAttribute("focus");
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        dragged: {
          value: !1,
          type: "boolean"
        },
        expanded: {
          value: !1,
          type: "boolean"
        },
        focused: {
          value: !1,
          type: "boolean"
        },
        index: {
          value: null,
          type: "number?"
        },
        label: {
          value: "",
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "accordionItemHeader.mouseenter": "_headerMouseEnterHandler",
        "accordionItemHeader.mouseleave": "_headerMouseLeaveHandler",
        "accordionItemHeader.down": "_ripple"
      };
    }
  }]);

  return _class73;
}(Smart.ContentElement)), Smart("smart-accordion",
/*#__PURE__*/
function (_Smart$BaseElement13) {
  "use strict";

  _inherits(_class74, _Smart$BaseElement13);

  function _class74() {
    _classCallCheck(this, _class74);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class74).apply(this, arguments));
  }

  _createClass(_class74, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <content></content>\n                </div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class74.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e._createElement(), _get(_getPrototypeOf(_class74.prototype), "render", this).call(this);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, a) {
      function i() {
        n._toggleItems("expand", [0]), n.expandedIndexes = [0];
      }

      var n = this;

      if ("expandedIndexes" === e) {
        if (t.toString() === a.toString()) return;
        var _e797 = [];
        if (0 < n._items.length) for (var _t693 = 0, _i697; _t693 < a.length; _t693++) {
          if (_i697 = parseInt(a[_t693]), !isNaN(_i697)) if (n._expandModeIs(["single", "singleFitHeight", "toggle"])) {
            1 > _e797.length && 0 <= _i697 && _i697 < n._items.length && _e797.push(_i697);
            break;
          } else 0 <= _i697 && _i697 <= n._items.length && -1 === _e797.indexOf(_i697) && _e797.push(_i697);
        }
        if (0 === _e797.length && n._expandModeIs(["single", "singleFitHeight"])) return a = t.slice(), void (n.expandedIndexes = a);
        a = _e797;

        var _i696 = n._compareExpandedIndexes(t, a);

        return n._toggleItems("collapse", _i696.collapse), n._toggleItems("expand", _i696.expand), void (n.expandedIndexes = a);
      }

      switch (_get(_getPrototypeOf(_class74.prototype), "propertyChangedHandler", this).call(this, e, t, a), e) {
        case "disabled":
          n._setFocusable(), n._enableDisableHandler();
          break;

        case "expandMode":
          if (0 === n._items.length) break;

          if ("multiple" === t && "none" !== a || "none" === t && "multiple" !== a) {
            var _e798 = n.expandedIndexes.slice(1);

            n._toggleItems("collapse", _e798), 0 === n.expandedIndexes.length && n._expandModeIs(["single", "singleFitHeight"]) && i();
          } else "toggle" === t && n._expandModeIs(["single", "singleFitHeight"]) && 0 === n.expandedIndexes.length && i();

          if (!n._supportCSSVariables || !n._usedCSSVariables) {
            var _e799 = n.expandedIndexes[0];
            "singleFitHeight" === t ? n._items[_e799].$.accordionItemContent.style.height = "" : "singleFitHeight" === a && (n._items[_e799].$.accordionItemContent.style.height = n._expandedItemsContainerHeight - 1 + "px");
          }

          "multiple" === a || "toggle" === a ? n._items[n.expandedIndexes[0]].$.label.removeAttribute("aria-disabled") : n._items[n.expandedIndexes[0]].$.label.setAttribute("aria-disabled", !0);
          break;

        case "unfocusable":
          n._setFocusable();

          break;

        default:
      }
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && (e.classList.contains("smart-resize-trigger-container") || e.classList.contains("smart-measure-element"))) {
        var _e800 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e800.concat(Array.prototype.slice.call(arguments)));
      }

      e instanceof Smart.AccordionItem || t.error(t.localize("accordionItemRequired", {
        method: "appendChild"
      })), t.insert(t._items.length, e);
    }
  }, {
    key: "collapse",
    value: function collapse(e, t) {
      var i = this;

      if (e = i._validateItemsIndex(e, "collapse"), !isNaN(e)) {
        var _a433 = i._items[e].expanded;
        !_a433 || i._expandModeIs(["single", "singleFitHeight"]) && -1 < i.expandedIndexes.indexOf(e) || i._collapseItem(e, t);
      }
    }
  }, {
    key: "expand",
    value: function expand(e, t) {
      var i = this;

      if (e = i._validateItemsIndex(e, "expand"), !isNaN(e)) {
        var _a434 = i._items[e].expanded;
        _a434 || (i._expandModeIs(["single", "singleFitHeight", "toggle"]) && i._toggleItems("collapse", i.expandedIndexes), i._expandItem(e, t));
      }
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var a = this,
          i = 0 === a._items.length;
      var n, o;
      if (t || ("number" == typeof e ? t = [{
        label: "",
        content: ""
      }] : (t = [{
        label: e ? e.toString() : "",
        content: e ? e.toString() : ""
      }], e = 0)), t instanceof HTMLElement) t instanceof Smart.AccordionItem ? n = t : a.error(a.localize("accordionItemRequired", {
        method: "insert"
      }));else if (Array.isArray(t)) {
        o = document.createDocumentFragment();

        for (var _e801 = 0; _e801 < t.length; _e801++) {
          var _i698 = a._createItem(t[_e801]);

          o.appendChild(_i698);
        }
      } else n = t instanceof Object ? a._createItem(t) : "string" == typeof t || "number" == typeof t ? a._createItem({
        label: t.toString(),
        content: t.toString()
      }) : a._createItem({
        label: "",
        content: ""
      });
      e > a._items.length ? n ? a.$.container.appendChild(n) : a.$.container.appendChild(o) : n ? a.$.container.insertBefore(n, a._items[e]) : a.$.container.insertBefore(o, a._items[e]), n && (n.tabIndex = a._tabIndex), a._storeItems(), i && a._expandModeIs(["single", "singleFitHeight"]) ? a._expandItem(0) : a.expandedIndexes = a._getExpandedIndexes(), a._updateExpanedContentHeight(), a._updateInlineHeight(), a._storeItemsCoordinates(), a._updateItemsIndexProperty();
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      var i = this;

      if (!i.isCompleted) {
        var _e802 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(i, _e802.concat(Array.prototype.slice.call(arguments)));
      }

      e !== void 0 && t !== void 0 && e instanceof Smart.AccordionItem && t instanceof Smart.AccordionItem || i.error(i.localize("accordionItemRequired", {
        method: "insertBefore"
      })), t !== void 0 && null !== t ? (!i.contains(t) && i.error(i.localize("referenceNodeNotChild", {
        argument: "referenceNode"
      })), i.insert(i._items.indexOf(t), e)) : i.insert(i._items.indexOf(t), e);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this;
      var i;
      if (e instanceof HTMLElement) e instanceof Smart.AccordionItem ? !t.contains(e) && t.error(t.localize("referenceNodeNotChild", {
        argument: "node"
      })) : t.error(t.localize("accordionItemRequired", {
        method: "remove"
      })), i = e, e = i.index;else {
        if (e = t._validateItemsIndex(e, "remove"), isNaN(e)) return;
        i = t._items[e];
      }
      i && (i.parentNode.removeChild(i), t._storeItems(), t._expandModeIs(["singleFitHeight"]) && (t._preventAnimation = !0), t._expandModeIs(["single", "singleFitHeight"]) && e === t.expandedIndexes[0] && 0 < t._items.length && (t._expandItem(0), t._selectedItem = t._items[0], t._selectedItemIndex = 0, t._itemIsFocussed = !0), t.expandedIndexes = t._getExpandedIndexes(), t._updateExpanedContentHeight(), t._updateInlineHeight(), t._storeItemsCoordinates(), t._updateItemsIndexProperty());
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e803 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e803.concat(Array.prototype.slice.call(arguments)));
      }

      return (e instanceof HTMLElement || t.error(t.localize("accordionItemRequired", {
        method: "removeChild"
      })), "smart-resize-trigger-container" === e.className) ? void _get(_getPrototypeOf(_class74.prototype), "removeChild", this).call(this, e) : void (e instanceof Smart.AccordionItem || t.error(t.localize("accordionItemRequired", {
        method: "removeChild"
      })), t.contains(e) || t.error(t.localize("referenceNodeNotChild", {
        argument: "node"
      })), t.remove(e));
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;

      if (e.disabled || e.unfocusable) {
        e.removeAttribute("tabindex");

        for (var _t694 = 0; _t694 < e._items.length; _t694++) {
          e._items[_t694].removeAttribute("tabindex");
        }

        return;
      }

      e.tabIndex = e._tabIndex;

      for (var _t695 = 0; _t695 < e._items.length; _t695++) {
        e._items[_t695].tabIndex = e._tabIndex;
      }
    }
  }, {
    key: "update",
    value: function update(e, t) {
      var i = this;

      if (e = i._validateItemsIndex(e, "update"), !isNaN(e)) {
        var _a435 = i._items[e];
        if (t || i.error(i.localize("invalidSettings", {
          elementType: i.nodeName.toLowerCase(),
          method: "update"
        })), _a435) if (Array.isArray(t) && (0 === t.length ? t = {
          label: "",
          content: ""
        } : t = t[0]), "string" == typeof t) _a435.content = t;else for (var _e804 in t) {
          _a435[_e804] = t[_e804];
        }

        var _n335 = i._getItemsHeights(e);

        i._updateExpanedContentLocalHeight(i._items[e], _n335), i._updateInlineHeight(), i._storeItemsCoordinates();
      }
    }
  }, {
    key: "_adjustHeightValue",
    value: function _adjustHeightValue(e) {
      var t = this,
          a = t._items.length;
      var n, o;

      for (var _r148 = 0; _r148 < a && (t._items[_r148].expanded ? n = t._items[_r148] : o = t._items[_r148], !(n && o)); _r148++) {
        ;
      }

      if (n || (n = t._items[0]), n || o) {
        var _t696 = n.expanded;
        n.expanded = !0;

        var _i699 = window.getComputedStyle(n, null),
            _r149 = !!o && window.getComputedStyle(o, null),
            _l110 = parseInt(_i699.getPropertyValue("margin-top")) + parseInt(_i699.getPropertyValue("margin-bottom")),
            _s80 = _r149 ? parseInt(_r149.getPropertyValue("margin-top")) + parseInt(_r149.getPropertyValue("margin-bottom")) : 0;

        return n.expanded = _t696, e - ((a - 1) * _s80 + _l110);
      }
    }
  }, {
    key: "_collapseItem",
    value: function _collapseItem(e, t) {
      var i = this;
      var a = i._items[e];

      if (a.expanded && !("none" === i.expandMode && t)) {
        if (a.expanded = !1, i.$.fireEvent("collapsing", {
          index: e,
          label: a.label,
          content: a.content.innerHTML
        }), -1 < i.expandedIndexes.indexOf(e)) {
          var _t697 = i.expandedIndexes.indexOf(e),
              _a436 = i.expandedIndexes.slice();

          _a436.splice(_t697, 1), i.expandedIndexes = _a436;
        }

        a.$.accordionItemContent.style.height = "", i._handleAnimationsDuration(a, e, "collapse");
      }
    }
  }, {
    key: "_compareExpandedIndexes",
    value: function _compareExpandedIndexes(e, t) {
      var a = [],
          n = [],
          o = [],
          r = e.length,
          l = t.length;

      for (var _o234 = 0; _o234 < r; _o234++) {
        -1 === t.indexOf(e[_o234]) ? -1 === a.indexOf(e[_o234]) && a.push(e[_o234]) : -1 === n.indexOf(e[_o234]) && n.push(e[_o234]);
      }

      for (var _a437 = 0; _a437 < l; _a437++) {
        -1 === n.indexOf(t[_a437]) && o.push(t[_a437]);
      }

      return {
        collapse: a,
        expand: o
      };
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e._reorderItemsByIndex(), e._usedCSSVariables = !!window.getComputedStyle(e.$.container).getPropertyValue("--smart-accordion-animation-duration"), e._supportCSSVariables = Smart.Utilities.Core.CSSVariablesSupport(), e._storeItems(), e._enableDisableHandler(), e._expandedIndexesHandler(), e._updateExpanedContentHeight(), e._tabIndex = 0 >= e.tabIndex ? 0 : e.tabIndex, e._setFocusable(), e._updateItemsIndexProperty(), e._updateInlineHeight();

      for (var _t698 = 0; _t698 < e._items.length; _t698++) {
        e._items[_t698].setAttribute("part", "smart-accordion-item"), e._items[_t698].$.arrow.classList.add("smart-animate-trigger");
      }
    }
  }, {
    key: "_createItem",
    value: function _createItem(e) {
      var t = this,
          i = document.createElement("smart-accordion-item");
      if (e) return (i.disabled = t.disabled, -1 < t._tabIndex && (i.tabIndex = t._tabIndex), "string" == typeof e || "number" == typeof e) ? (i.label = e + "", i.content = e + "", i) : (i.label = e.label || "", i.content = e.content || "", i);
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;
      if (t.disabled || t.readonly || "none" === t.expandMode || t._toggled) return;
      var i = t.enableShadowDOM && t.shadowRoot ? t.shadowRoot.elementFromPoint(e.pageX - window.pageXOffset, e.pageY - window.pageYOffset) : e.originalEvent.target,
          a = i.closest(".smart-accordion-item-header"),
          n = i.closest("smart-accordion-item");
      return a ? void (t._pointerPosition = e.pageY - window.pageYOffset, t._selectedItem = n, t._itemIsPressed = t._itemIsFocussed = !0, t._reorderedIndex = t._selectedItemIndex = t._items.indexOf(n), t._storeItemsCoordinates()) : void (n && (n.focused = !0));
    }
  }, {
    key: "_enableDisableHandler",
    value: function _enableDisableHandler() {
      var e = this;
      if (e.disabled) for (var _t699 = 0; _t699 < e._items.length; _t699++) {
        e._items[_t699].disabled = !0;
      } else for (var _t700 = 0; _t700 < e._items.length; _t700++) {
        e._items[_t700].disabled = !1;
      }
    }
  }, {
    key: "_expandedIndexesHandler",
    value: function _expandedIndexesHandler() {
      var e = this;

      var t = e._getExpandedIndexes("initial"),
          i = t.length,
          a = e.expandedIndexes.length;

      if (0 === e._items.length) return void (e._animationAfterInitialization = !0);
      if (0 === a && 0 < i && (e.expandedIndexes = t, a = i), e._expandModeIs(["multiple", "none"]) || 1 === a) return e._toggleItems("expand", e.expandedIndexes), void (e._animationAfterInitialization = !0);

      switch (e.expandMode) {
        case "single":
        case "singleFitHeight":
          0 === a ? e._toggleItems("expand", [0]) : 1 < a && (e._toggleItems("collapse", e.expandedIndexes.splice(0, 1)), e._toggleItems("expand", e.expandedIndexes));
          break;

        case "toggle":
          1 < a && (e._toggleItems("collapse", e.expandedIndexes.splice(0, 1)), e._toggleItems("expand", e.expandedIndexes));
          break;

        default:
      }

      e._animationAfterInitialization = !0;
    }
  }, {
    key: "_expandItem",
    value: function _expandItem(e, t) {
      var i = this;
      var a = i._items[e];

      if (!(a.expanded || "none" === i.expandMode && t)) {
        if (a.$.container.style.getPropertyValue("--smart-accordion-expanded-content-local-height") || (a.expanded = !0, a.$.container.style.setProperty("--smart-accordion-expanded-content-local-height", a.$.accordionItemContent.scrollHeight + "px"), a.expanded = !1), a.expanded = !0, i.$.fireEvent("expanding", {
          index: e,
          label: a.label,
          content: a.content.innerHTML
        }), -1 === i.expandedIndexes.indexOf(e)) {
          var _t701 = i.expandedIndexes.slice();

          _t701.push(e), i.expandedIndexes = _t701;
        }

        i._supportCSSVariables && i._usedCSSVariables || "singleFitHeight" !== i.expandMode || (a.$.accordionItemContent.style.height = i._expandedItemsContainerHeight - 1 + "px"), i._handleAnimationsDuration(a, e, "expand");
      }
    }
  }, {
    key: "_expandModeIs",
    value: function _expandModeIs(e) {
      var t = this;
      return -1 < e.indexOf(t.expandMode);
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler() {
      var e = this;
      e.disabled || 0 === e._items.length || (e._itemIsFocussed ? e._selectedItem.focused = !1 : e._items[0].focused = !1);
    }
  }, {
    key: "_getExpandedIndexes",
    value: function _getExpandedIndexes(e) {
      var t = this,
          a = [];

      for (var _n336 = 0; _n336 < t._items.length; _n336++) {
        "initial" === e ? t._items[_n336].hasAttribute("expanded") && (a.push(_n336), t._items[_n336].removeAttribute("expanded")) : t._items[_n336].expanded && a.push(_n336);
      }

      return a.slice();
    }
  }, {
    key: "_getItemsHeights",
    value: function _getItemsHeights(e) {
      var t = this,
          a = t._items,
          n = a.length;
      var o = [];

      if (0 !== n) {
        if (!isNaN(e) && 0 <= e && e < n) {
          var _t702 = a[e];
          var _i700 = 0;
          return _t702.expanded ? _i700 = _t702.$.accordionItemContent.scrollHeight : (_t702.expanded = !0, _i700 = _t702.$.accordionItemContent.scrollHeight, _t702.expanded = !1), _i700 + "px";
        }

        for (var _e805 = 0; _e805 < n; _e805++) {
          var _t703 = a[_e805];
          var _i701 = 0;
          _t703.expanded ? _i701 = _t703.$.accordionItemContent.scrollHeight : (_t703.expanded = !0, _i701 = _t703.$.accordionItemContent.scrollHeight, _t703.expanded = !1), o.push(_i701 + "px");
        }

        return t._heightCalcAfterInitialization = !0, o;
      }
    }
  }, {
    key: "_handleAnimationsDuration",
    value: function _handleAnimationsDuration(e, t, i) {
      var a = this;
      if (!a._animationAfterInitialization) return;
      if (1 === a._items.length && "singleFitHeight" === a.expandMode) return void a.$.fireEvent(i, {
        index: t,
        label: e.label,
        content: e.content.innerHTML
      });
      if (!1 === a.hasAnimation || !a._supportCSSVariables) return void a.$.fireEvent(i, {
        index: t,
        label: e.label,
        content: e.content.innerHTML
      });
      if (a._preventAnimation) return a.$.fireEvent(i, {
        index: t,
        label: e.label,
        content: e.content.innerHTML
      }), void (a._preventAnimation = !1);
      a._toggled = !0;
      var n = window.getComputedStyle(a).animationDuration,
          o;
      if (-1 < n.indexOf("ms")) n = parseFloat(n.substring(0, n.length - 2)), o = isNaN(n) || 0 > n ? 0 : n - 50;else if (-1 < n.indexOf("s")) n = parseFloat(n.substring(0, n.length - 1)), o = isNaN(n) || 0 > n ? 0 : 1e3 * n - 50;else return void a.$.fireEvent(i, {
        index: t,
        label: e.label,
        content: e.content.innerHTML
      });
      e instanceof Smart.AccordionItem && (e.$.addClass("smart-toggled-item"), a.$container.addClass("smart-toggling"), setTimeout(function () {
        e.$.removeClass("smart-toggled-item"), a.$container.removeClass("smart-toggling"), a.$.fireEvent(i, {
          index: t,
          label: e.label,
          content: e.content.innerHTML
        }), a._toggled = !1;
      }, o));
    }
  }, {
    key: "_indexChangeHandler",
    value: function _indexChangeHandler(e) {
      var t = this,
          i = t._items,
          a = i.length,
          n = e.detail;
      n.newIndex >= a ? t.$.container.appendChild(i[n.oldIndex]) : n.newIndex > n.oldIndex ? t.$.container.insertBefore(i[n.oldIndex], i[n.newIndex + 1]) : t.$.container.insertBefore(i[n.oldIndex], i[n.newIndex]);
      var o = t.enableShadowDOM && t.shadowRoot ? t.shadowRoot.querySelectorAll("smart-accordion-item") : t.getElementsByTagName("smart-accordion-item");
      t._items = Array.from(o), t._updateItemsIndexProperty();
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      function t(e) {
        e === d || isNaN(e) || (s.focused = !1, d = e, s = a._items[d], s.focused = !0);
      }

      function i(e) {
        return "up" === e ? void (0 > d - 1 ? t(0) : t(d - 1)) : void (d + 1 > l ? t(l) : t(d + 1));
      }

      var a = this,
          n = e.key;
      if ("none" === a.expandMode || a.disabled || a.readonly || a._toggled) return;
      var o = (a.shadowRoot ? a.shadowRoot.activeElement : document.activeElement) || document.activeElement;
      if (-1 === ["ArrowLeft", "ArrowDown", "ArrowRight", "ArrowUp", "End", "Home", " ", "Enter", "Tab"].indexOf(n) || !(o instanceof Smart.AccordionItem)) return;
      "Tab" !== n && e.preventDefault();
      var r = a._items.length,
          l = r - 1,
          s,
          d;

      for (var _t704 = 0, _i702; _t704 < r; _t704++) {
        _i702 = a._items[_t704], _i702.focused && (s = _i702, d = _t704);
      }

      switch (n) {
        case "Tab":
          e.shiftKey ? i("up") : i("down");
          break;

        case "ArrowLeft":
          a.collapse(d);
          break;

        case "ArrowDown":
          i("down");
          break;

        case "ArrowRight":
          a.expand(d);
          break;

        case "ArrowUp":
          i("up");
          break;

        case "End":
          t(l);
          break;

        case "Home":
          t(0);
          break;

        case " ":
        case "Enter":
          if (s.expanded) return void a.collapse(d);
          a.expand(d);
          break;

        default:
      }
    }
  }, {
    key: "_containerMoveHandler",
    value: function _containerMoveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      var t = Math.abs;
      var a = this;
      if (e.stopPropagation(), a._itemIsPressed && a.reorder && !a.readonly && !(2 > a._items.length) && (a.$container.hasClass("smart-reordering") || !(5 > t(e.pageY - a._pointerPosition)))) if (a._dragStart) {
        if (a.$container.hasClass("smart-reordering") || a.$container.addClass("smart-reordering"), !a._dragging) {
          var _t705 = a._selectedItem;
          a.$.fireEvent("dragStart", {
            position: {
              left: e.pageX,
              top: e.pageY
            },
            target: e.originalEvent.target,
            index: a._selectedItemIndex,
            label: _t705.label,
            content: _t705.content.innerHTML
          }), a._selectedItem.dragged = a._dragging = !0;
        }

        if (a.hasAnimation) {
          var _e806 = a._selectedItem.querySelector(".smart-ripple");

          _e806 && (_e806.style.height = 0);
        }

        var _n337 = e.clientY;

        var _o235 = !1;

        for (var _e807 = 0; _e807 < a._itemsCoordinates.length; _e807++) {
          var _t706 = a._itemsCoordinates[_e807];

          if (_n337 >= _t706.fromY && _n337 <= _t706.toY) {
            _o235 = _e807;
            break;
          }
        }

        var _i703 = a._items[_o235];

        if (!1 !== _o235 && _i703 !== a._selectedItem) {
          if (a._lastReorderedItem && _i703 === a._lastReorderedItem) return;

          if (a._lastReorderedItem = _i703, 1 < t(a._reorderedIndex - _o235)) {
            var _e808 = 0 > a._reorderedIndex - _o235 ? -1 : 1;

            a._swapItems(a._reorderedIndex, _o235 + _e808);
          }

          return a._swapItems(a._reorderedIndex, _o235), a._reorderedIndex = _o235, void a._storeItemsCoordinates();
        }

        a._lastReorderedItem = void 0;
      } else a._dragStart = !0;
    }
  }, {
    key: "_reorderItemsByIndex",
    value: function _reorderItemsByIndex() {
      var e = this;
      var t = e.enableShadowDOM && e.shadowRoot ? e.shadowRoot.querySelectorAll("smart-accordion-item") : e.getElementsByTagName("smart-accordion-item"),
          i = Array.from(t),
          a = !1,
          n = i.map(function (e) {
        return null === e.index ? e.index = 0 : a = !0, e.index;
      });

      if (a) {
        var _a438 = i.length;

        if (!(2 > _a438)) {
          var _o236 = n.slice();

          if (_o236.sort(function (e, t) {
            return parseInt(e) - parseInt(t);
          }), n.toString() !== _o236.toString()) for (var _n338 = 0; _n338 < _a438; _n338++) {
            var _i704 = void 0;

            for (var _e809 = 0; _e809 < _a438; _e809++) {
              t[_e809].index === _o236[_n338] && (_i704 = t[_e809]);
            }

            e.$.container.insertBefore(_i704, t[_n338]);
          }
        }
      }
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      e._updateExpanedContentHeight(), e._updateInlineHeight(), e._storeItemsCoordinates();
    }
  }, {
    key: "_storeItems",
    value: function _storeItems() {
      var e = this,
          t = e.enableShadowDOM && e.shadowRoot ? e.shadowRoot.querySelectorAll("smart-accordion-item") : e.getElementsByTagName("smart-accordion-item");
      if (e._items = Array.from(t), 0 === e._items.length) return void e.$container.addClass("smart-empty");
      e.$container.removeClass("smart-empty");

      var a = e._getItemsHeights();

      for (var _t707 = 0; _t707 < e._items.length; _t707++) {
        e._updateExpanedContentLocalHeight(e._items[_t707], a[_t707]);
      }
    }
  }, {
    key: "_storeItemsCoordinates",
    value: function _storeItemsCoordinates() {
      var e = this;

      if (!e.disabled && e.reorder) {
        var _t708 = [];

        for (var _a439 = 0; _a439 < e._items.length; _a439++) {
          var _i705 = e._items[_a439],
              _n339 = _i705.getBoundingClientRect();

          _t708.push({
            fromY: _n339.top + (window.scrollY || window.pageYOffset),
            toY: _n339.bottom + (window.scrollY || window.pageYOffset)
          });
        }

        e._itemsCoordinates = _t708;
      }
    }
  }, {
    key: "_swapItems",
    value: function _swapItems(e, t) {
      var i = this,
          a = Math.min(e, t),
          n = Math.max(e, t),
          o = i._items;
      var r = i.expandedIndexes.slice();

      if (i._items[e].expanded && !i._items[t].expanded) {
        var _a440 = r.indexOf(e);

        r[_a440] = t, i.expandedIndexes = r.slice();
      } else if (i._items[t].expanded && !i._items[e].expanded) {
        var _a441 = r.indexOf(t);

        r[_a441] = e, i.expandedIndexes = r.slice();
      }

      i.selectedIndex = i.selectedIndex === e ? t : e, i.$.container.insertBefore(o[n], o[a]), function (e, t, i) {
        var a = e[i];
        e[i] = e[t], e[t] = a;
      }(o, e, t), i._items[e].$.removeClass("hovered"), i._reorderedIndex = t;
    }
  }, {
    key: "_toggleItems",
    value: function _toggleItems(e, t) {
      var a = this,
          n = t.length;
      if (0 < n) for (var _o237 = 0; _o237 < n; _o237++) {
        a["_" + e + "Item"](t[_o237]);
      }
    }
  }, {
    key: "_updateExpanedContentHeight",
    value: function _updateExpanedContentHeight() {
      var e = this;
      e.$.container.style.setProperty("--smart-accordion-item-header-height", "");
      var t = e._items.length,
          a = e.$.container.offsetHeight,
          n = e._items[e.expandedIndexes[0]];
      var o = 0,
          r = 0,
          l = 0,
          s = 0;

      if (1 === t) {
        var _t709 = e._items[0],
            _i706 = _t709.expanded;
        _t709.expanded = !1, o = _t709.offsetHeight, r = _t709.$.accordionItemHeader.offsetHeight, _t709.expanded = _i706;
      } else for (; 0 === o && s < t;) {
        var _t710 = e._items[s];
        _t710 instanceof Smart.AccordionItem && !_t710.expanded && (o = _t710.offsetHeight, r = _t710.$.accordionItemHeader.offsetHeight), s++;
      }

      if (1 < t && n instanceof Smart.AccordionItem) {
        var _e810 = n.$.accordionItemHeader.offsetHeight;
        l = _e810 - r;
      }

      var d = getComputedStyle(e.$.root),
          c = o * t;
      var m = a - c - l - parseFloat(d.paddingBottom) - parseFloat(d.paddingTop);
      "singleFitHeight" === e.expandMode && (m = e._adjustHeightValue(m)), m = 0 <= m ? m : 0, e.$.container.style.setProperty("--smart-accordion-expanded-content-height", m + "px"), e.$.container.style.setProperty("--smart-accordion-item-header-height", r + "px"), e._expandedItemsContainerHeight = m;
    }
  }, {
    key: "_updateExpanedContentLocalHeight",
    value: function _updateExpanedContentLocalHeight(e, t) {
      var i = this;
      i._supportCSSVariables && i._usedCSSVariables && e.$.container.style.setProperty("--smart-accordion-expanded-content-local-height", t);
    }
  }, {
    key: "_updateInlineHeight",
    value: function _updateInlineHeight() {
      var e = this;
      e._supportCSSVariables && e._usedCSSVariables || "singleFitHeight" !== e.expandMode || 0 === e._items.length || (e._items[e.expandedIndexes[0]].$.accordionItemContent.style.height = e._expandedItemsContainerHeight - 1 + "px");
    }
  }, {
    key: "_updateItemsIndexProperty",
    value: function _updateItemsIndexProperty() {
      var e = this;
      var t = [];

      for (var _a442 = 0; _a442 < e._items.length; _a442++) {
        e._items[_a442]._setIndex(_a442), e._items[_a442].expanded && t.push(_a442);
      }

      e.expandedIndexes = t.slice();
    }
  }, {
    key: "_upHandler",
    value: function _upHandler(e) {
      var t = this;

      if (!(!t._itemIsPressed || t.disabled || t.readonly)) {
        for (var _e811 = 0; _e811 < t._items.length; _e811++) {
          _e811 !== t._selectedItemIndex && (t._items[_e811].focused = !1);
        }

        if (t._selectedItem.focused = !0, !t._dragging) t._selectedItem.expanded ? t.collapse(t._selectedItemIndex, !0) : t.expand(t._selectedItemIndex, !0);else {
          var _i707 = t._selectedItem;
          t.$container.removeClass("smart-reordering"), t.$.fireEvent("dragEnd", {
            position: {
              left: e.pageX,
              top: e.pageY
            },
            target: e.originalEvent.target,
            index: t._selectedItemIndex,
            label: _i707.label,
            content: _i707.content.innerHTML
          });
        }
        t._reorderedIndex = void 0, t._dragStart = !1, t._dragging = !1, t._itemIsPressed = !1, t._selectedItem.dragged = !1, t._updateItemsIndexProperty();
      }
    }
  }, {
    key: "_validateItemsIndex",
    value: function _validateItemsIndex(e, t) {
      var i = this;
      return isNaN(parseInt(e)) || 0 > e || e > i._items.length - 1 ? void i.log(i.localize("indexOutOfBound", {
        elementType: i.nodeName.toLowerCase(),
        method: t
      })) : parseInt(e);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        expandedIndexes: {
          value: [],
          type: "array"
        },
        expandMode: {
          allowedValues: ["single", "singleFitHeight", "multiple", "toggle", "none"],
          value: "singleFitHeight",
          type: "string"
        },
        messages: {
          extend: !0,
          value: {
            en: {
              accordionItemRequired: "{{elementType}}: \"{{method}}\" requires an item from type \"smart-accordion-item\".",
              indexOutOfBound: "{{elementType}}: Out of bound index/indexes in \"{{method}}\" method.",
              invalidSettings: "{{elementType}}: \"{{method}}\" method accepts a string or an object as it's second parameter.",
              missingReference: "{{elementType}}: Missing reference to {{files}}.",
              noItems: "{{elementType}}: No child elements found.",
              overridingProperties: "{{elementType}}: Overriding properties {{property1}} and {{property2}} applied. The \"{{property1}}\" property is used by default."
            }
          },
          type: "object"
        },
        reorder: {
          value: !1,
          type: "boolean"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        down: "_downHandler",
        focus: "_focusHandler",
        indexChange: "_indexChangeHandler",
        keydown: "_keyDownHandler",
        move: "_moveHandler",
        resize: "_resizeHandler",
        styleChanged: "_resizeHandler",
        "document.up": "_upHandler",
        "container.move": "_containerMoveHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.accordion.css"];
    }
  }]);

  return _class74;
}(Smart.BaseElement)), Smart("smart-rating",
/*#__PURE__*/
function (_Smart$BaseElement14) {
  "use strict";

  _inherits(_class75, _Smart$BaseElement14);

  function _class75() {
    _classCallCheck(this, _class75);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class75).apply(this, arguments));
  }

  _createClass(_class75, [{
    key: "attached",
    value: function attached() {
      this.value > this.max && (this.value = this.max), this._updateActiveStars(this.value);
    }
  }, {
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                <div id=\"stars\" class=\"smart-content\">\n                 <template>\n                     <div id=\"ratingStars\" *items={{max}}><span class=\"rating-star\" index={{item}}></span></div>\n                </template>\n                </div>\n                <input class=\"smart-hidden\" value=\"[[value]]\" name=\"[[max]]\"></input>\n            </div>";
    }
  }, {
    key: "_clickHandler",
    value: function _clickHandler(e) {
      if (e.target.className.includes("rating-star")) {
        var _t711 = e.target,
            _i708 = _t711.parentNode,
            _a443 = Array.prototype.indexOf.call(_i708.children, _t711);

        this.value = _a443 + 1, this._updateActiveStars(this.value), this._updateHoveredStars(0);
      }
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      var t = this,
          i = this.querySelector("#ratingStars"),
          a = function a(e) {
        var t = e.getBoundingClientRect();
        return {
          left: t.left + window.scrollX,
          top: t.top + window.scrollY
        };
      },
          n = function () {
        var n = t.querySelectorAll("#ratingStars .rating-star");

        for (var _t712 = 0; _t712 < n.length; _t712++) {
          var _i709 = a(n[_t712]);

          if (e.x >= _i709.left && e.x <= _i709.left + n[_t712].offsetWidth) return _t712;
        }
      }();

      t._updateHoveredStars(n + 1);
    }
  }, {
    key: "_mouseoutHandler",
    value: function _mouseoutHandler() {
      this._updateHoveredStars(0);
    }
  }, {
    key: "_updateActiveStars",
    value: function _updateActiveStars(e) {
      var t = this.getElementsByClassName("rating-star");

      for (var _a444 = 0; _a444 < t.length; _a444++) {
        _a444 < e ? t[_a444].classList.add("active") : t[_a444].classList.remove("active");
      }
    }
  }, {
    key: "_updateHoveredStars",
    value: function _updateHoveredStars(e) {
      var t = this.getElementsByClassName("rating-star");

      for (var _a445 = 0; _a445 < t.length; _a445++) {
        _a445 < e ? t[_a445].classList.add("hover") : t[_a445].classList.remove("hover");
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        max: {
          value: 5,
          type: "number"
        },
        name: {
          value: "rating",
          type: "string"
        },
        value: {
          value: 3,
          type: "number"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "stars.click": "_clickHandler",
        "stars.move": "_moveHandler",
        "stars.mouseout": "_mouseoutHandler"
      };
    }
  }]);

  return _class75;
}(Smart.BaseElement)), Smart("smart-calendar",
/*#__PURE__*/
function (_Smart$BaseElement15) {
  "use strict";

  _inherits(_class76, _Smart$BaseElement15);

  function _class76() {
    _classCallCheck(this, _class76);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class76).apply(this, arguments));
  }

  _createClass(_class76, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div id=\"title\" class=\"smart-calendar-title\" role=\"heading\" aria-level=\"1\">\n                        <div id=\"yearContainer\" class=\"smart-calendar-year-container\" role=\"button\"></div>\n                        <div id=\"dateContainer\" class=\"smart-calendar-date-container smart-calendar-selected\" role=\"button\"></div>\n                    </div>\n                    <div id=\"calendarContainer\" class=\"smart-calendar-container\">\n                        <div id=\"header\" class=\"smart-calendar-header\">\n                            <smart-repeat-button prev-month class=\"smart-calendar-button\" id=\"previousMonthButton\" animation=\"[[animation]]\" initial-delay=\"[[spinButtonsInitialDelay]]\" delay=\"[[spinButtonsDelay]]\" disabled=\"[[disabled]]\" readonly=\"[[readonly]]\" right-to-left=\"[[rightToLeft]]\" aria-label=\"Previous month\">\n                                <span aria-hidden=\"true\"></span>\n                            </smart-repeat-button>\n                            <div id=\"dateElement\" class=\"smart-calendar-date-element\" role=\"presentation\">\n                                <div id=\"defaultHeaderDate\" role=\"button\"></div>\n                                <div id=\"classicHeaderDate\">\n                                    <smart-drop-down-list class=\"smart-calendar-month-element\" id=\"monthElement\"\n                                        drop-down-position=\"bottom\"\n                                        selection-mode=\"one\"\n                                        disabled=\"[[disabled]]\"\n                                        right-to-left=\"[[rightToLeft]]\"\n                                        readonly=\"[[readonly]]\"\n                                        drop-down-width=\"[[dropDownWidth]]\"\n                                        drop-down-height=\"[[dropDownHeight]]\"\n                                        theme=\"[[theme]]\">\n                                    </smart-drop-down-list>\n                                    <input class=\"smart-calendar-year-element\" id=\"yearElement\" disabled=\"[[disabled]]\" readonly=\"[[readonly]]\" aria-label=\"Year\" />\n                                    <span class=\"smart-calendar-year-elements\">\n                                        <smart-repeat-button next-year class=\"smart-calendar-button\" id=\"nextYearButton\" animation=\"[[animation]]\" initial-delay=\"[[spinButtonsInitialDelay]]\" delay=\"[[spinButtonsDelay]]\" disabled=\"[[disabled]]\" readonly=\"[[readonly]]\" right-to-left=\"[[rightToLeft]]\" aria-label=\"Next year\">\n                                            <span aria-hidden=\"true\"></span>\n                                        </smart-repeat-button>\n                                        <smart-repeat-button prev-year class=\"smart-calendar-button\" id=\"previousYearButton\" animation=\"[[animation]]\" initial-delay=\"[[spinButtonsInitialDelay]]\" delay=\"[[spinButtonsDelay]]\" disabled=\"[[disabled]]\" readonly=\"[[readonly]]\" right-to-left=\"[[rightToLeft]]\" aria-label=\"Previous year\">\n                                            <span aria-hidden=\"true\"></span>\n                                        </smart-repeat-button>\n                                    </span>\n                                </div>\n                            </div>\n                            <smart-repeat-button next-month class=\"smart-calendar-button\" id=\"nextMonthButton\" animation=\"[[animation]]\" initial-delay=\"[[spinButtonsInitialDelay]]\" delay=\"[[spinButtonsDelay]]\" disabled=\"[[disabled]]\" readonly=\"[[readonly]]\" right-to-left=\"[[rightToLeft]]\" aria-label=\"Next month\">\n                                <span aria-hidden=\"true\"></span>\n                            </smart-repeat-button>\n                        </div>\n                        <div id=\"body\" class=\"smart-content smart-calendar-body\" role=\"presentation\">\n                            <div id=\"monthsContainer\" class=\"smart-calendar-months-container\" role=\"presentation\">\n                              <div id=\"month\" class=\"smart-calendar-month\" role=\"grid\">\n                                   <div id=\"monthName\" class=\"smart-calendar-month-name\"></div>\n                                   <div id=\"weekTitles\" class=\"smart-calendar-week-titles\" role=\"row\">\n                                       <div class=\"smart-calendar-week-title\" role=\"columnheader\"></div>\n                                       <div class=\"smart-calendar-week-title\" role=\"columnheader\"></div>\n                                       <div class=\"smart-calendar-week-title\" role=\"columnheader\"></div>\n                                       <div class=\"smart-calendar-week-title\" role=\"columnheader\"></div>\n                                       <div class=\"smart-calendar-week-title\" role=\"columnheader\"></div>\n                                       <div class=\"smart-calendar-week-title\" role=\"columnheader\"></div>\n                                       <div class=\"smart-calendar-week-title\" role=\"columnheader\"></div>\n                                       <div class=\"smart-calendar-week-title\" role=\"columnheader\"></div>\n                                   </div>\n                                   <div id=\"weeks\" class=\"smart-calendar-weeks\" role=\"rowgroup\">\n                                        <div class=\"smart-calendar-week\" role=\"row\">\n                                           <div class=\"smart-calendar-week-number\" role=\"rowheader\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                        </div>\n                                        <div class=\"smart-calendar-week\" role=\"row\">\n                                           <div class=\"smart-calendar-week-number\" role=\"rowheader\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                       </div>\n                                       <div class=\"smart-calendar-week\" role=\"row\">\n                                           <div class=\"smart-calendar-week-number\" role=\"rowheader\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                       </div>\n                                       <div class=\"smart-calendar-week\" role=\"row\">\n                                           <div class=\"smart-calendar-week-number\" role=\"rowheader\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                       </div>\n                                       <div class=\"smart-calendar-week\" role=\"row\">\n                                           <div class=\"smart-calendar-week-number\" role=\"rowheader\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                       </div>\n                                       <div class=\"smart-calendar-week\" role=\"row\">\n                                           <div class=\"smart-calendar-week-number\" role=\"rowheader\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"></div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                           <div class=\"smart-calendar-cell\" role=\"gridcell\"> </div>\n                                       </div>\n                                   </div>\n                                </div>\n                            </div>\n                            <div id=\"dateViewContainer\" class=\"smart-calendar-date-view-container smart-hidden\">\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                                    <div class=\"smart-calendar-cell\" role=\"button\"></div>\n                            </div>\n                            <div id=\"monthsSeparator\" class=\"smart-calendar-month-separator\"></div>\n                            <div id=\"nextMonthsContainer\" class=\"smart-calendar-next-months-container\" aria-hidden=\"true\"></div>\n                            <smart-list-box id=\"listViewContainer\" class=\"smart-calendar-list-view smart-hidden\"\n                                right-to-left=\"[[rightToLeft]]\"\n                                item-height=\"30\"\n                                unfocusable\n                                selection-mode=\"one\"\n                                animation=\"simple\">\n                            </smart-list-box>\n                            <div id=\"animationPanel\" class=\"smart-calendar-animation-panel smart-hidden\"></div>\n                        </div>\n                        <div id=\"footer\" class=\"smart-calendar-footer smart-hidden\">\n                            <div id=\"selectedDatesRange\"></div>\n                        </div>\n                        <smart-tooltip id=\"tooltip\" open-mode=\"manual\" right-to-left=\"[[rightToLeft]]\" arrow=\"[[tooltipArrow]]\"\n                                   tooltip-template=\"[[tooltipTemplate]]\"\n                                   arrow-direction=\"[[tooltipArrowDirection]]\"\n                                   offset=\"[[tooltipOffset]]\"\n                                   position=\"[[tooltipPosition]]\"\n                                   delay=\"[[tooltipDelay]]\"\n                                   disabled=\"[[disabled]]\">\n                         </smart-tooltip>\n                        <input id=\"hiddenInput\" type=\"hidden\" name=\"[[name]]\">\n                    </div>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, a) {
      _get(_getPrototypeOf(_class76.prototype), "propertyChangedHandler", this).call(this, e, t, a);

      var n = this;

      switch (e) {
        case "animationSettings":
          n._applyAnimationSettings();

          break;

        case "disabled":
        case "unfocusable":
          n._setFocusable();

          break;

        case "calendarMode":
          n.displayMode = "month", n._refreshCalendarMode(), n._setDisplayModeContent();
          break;

        case "dayNameFormat":
          n._refreshDayOfWeekTitles(n.$.month);

          break;

        case "dateFormatFunction":
          {
            var _e812 = n.$.monthsContainer.children;

            for (var _t713 = 0; _t713 < _e812.length; _t713++) {
              _e812[_t713].firstElementChild.innerHTML = a ? a(_e812[_t713]._date) : n._monthsNames[_e812[_t713]._date.getMonth()] + " " + _e812[_t713]._date.toLocaleDateString(n.locale, {
                year: n.yearFormat
              });
            }

            n._refreshHeaderTitle();

            break;
          }

        case "displayMode":
          if ("classic" === n.calendarMode && "month" !== a) {
            n[e] = "month";
            break;
          }

          n._setDisplayMode(t, a);

          break;

        case "displayModeView":
          n._applyAnimationSettings(!0), "month" !== n.displayMode && n._setDisplayModeContent();
          break;

        case "firstDayOfWeek":
          n._handleMonths(), n._refreshDayOfWeekTitles();
          break;

        case "hideTooltipArrow":
          n.$.tooltip.arrow = !a;
          break;

        case "titleTemplate":
        case "headerTemplate":
        case "footerTemplate":
          n._handleLayoutTemplate(n.$[e.split(/[T]/)[0]], a), "titleTemplate" === e ? n._refreshTitle() : "headerTemplate" === e ? n._refreshHeaderTitle() : n._refreshFooter();
          break;

        case "importantDates":
          n.importantDates = n._getValidDates(a), n._refreshImportantDates();
          break;

        case "importantDatesTemplate":
          n._handleImportantDateTemplate(), n._refreshImportantDates();
          break;

        case "locale":
          n._refreshMonthNames(), n._refreshDayOfWeekTitles(), n._refreshHeaderTitle(), n._refreshTitle(), n._refreshFooter(), n.displayMode && "month" !== n.displayMode && n._setDisplayModeContent();
          break;

        case "max":
        case "min":
          n._validateMinMax(e, a, t), n._validateSelectedDates(), n._noFocusingRequired = !1, n._refreshHeaderElements();
          break;

        case "months":
          n._handleMonths();

          break;

        case "monthNameFormat":
          n._refreshCalendarMode(), n._refreshHeaderTitle();
          break;

        case "restrictedDates":
          n._setRestrictedDates(n.restrictedDates = n._getValidDates(a));

          break;

        case "rightToLeft":
          n._refreshDayOfWeekTitles(), n._handleMonths();
          break;

        case "scrollButtonsNavigationMode":
          n._setScrollButtonsNavigationMode();

          break;

        case "selectedDates":
          if (n._clearSelection(!0), n._validateSelectedDates(n._getValidDates(a)), n._applySelectionMode(!0), n._viewDates) {
            var _e813 = n.selectedDates[n.selectedDates.length - 1];
            n._isDateInView(_e813) ? n.selectedDates.map(function (e) {
              return n._selectDate(e, !0, !0);
            }) : n._handleMonths(_e813);
          }

          n._refreshFooter(), n._setWeeksVisibility(n.$.monthsContainer), n.$.hiddenInput.value = n.selectedDates.toString(), n.$.fireEvent("change", {
            value: n.selectedDates
          }), n._refreshTitle(), "month" !== n.displayMode && n._setDisplayModeContent();
          break;

        case "selectionMode":
          n._applySelectionMode(!1, t), n._refreshTitle();
          break;

        case "view":
          n._refreshTitle();

          break;

        case "viewSections":
          -1 < a.indexOf("title") ? n.$title.removeClass("smart-hidden") : n.$title.addClass("smart-hidden"), n._refreshTitle(), -1 < a.indexOf("header") ? n.$header.removeClass("smart-hidden") : n.$header.addClass("smart-hidden"), n._refreshHeaderTitle(), -1 < a.indexOf("footer") ? n.$footer.removeClass("smart-hidden") : n.$footer.addClass("smart-hidden"), n._refreshFooter(), n._setFocusable();
          break;

        case "weeks":
          n._setWeeksVisibility(n.$.monthsContainer);

          break;

        case "yearFormat":
          if (n._refreshCalendarMode(), n._refreshFooter(), 1 < n.months && "month" === n.displayMode) {
            var _e814 = n._animationStarted ? n.$.nextMonthsContainer.children : n.$.monthsContainer.children;

            for (var _t714 = 0; _t714 < _e814.length; _t714++) {
              _e814[_t714].firstElementChild.innerHTML = n.dateFormatFunction ? n.dateFormatFunction(_e814[_t714]._date) : n._monthsNames[_e814[_t714]._date.getMonth()] + " " + _e814[_t714]._date.toLocaleDateString(n.locale, {
                year: a
              });
            }
          }

          n._refreshTitle(), n._refreshHeaderTitle();
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class76.prototype), "ready", this).call(this);

      var e = this;
      e._keysPressed = {}, e._applyAnimationSettings(), e.importantDates = e._getValidDates(e.importantDates), e.restrictedDates = e._getValidDates(e.restrictedDates);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.setAttribute("role", "dialog"), e._refreshMonthNames(), e._validateMinMax(), e._validateSelectedDates(e._getValidDates(e.selectedDates)), e._handleLayoutTemplate(e.$.title, e.titleTemplate), e._handleLayoutTemplate(e.$.header, e.headerTemplate), e._handleLayoutTemplate(e.$.footer, e.footerTemplate), e._handleImportantDateTemplate(), e._setFocusable(), e._refreshDayOfWeekTitles(), e._applySelectionMode(!0), e._handleMonths(0 === e.selectedDates.length ? new Date(new Date().setHours(0, 0, 0, 0)) : e.selectedDates[e.selectedDates.length - 1]), e._updateViewSectionsVisibility(), e._setScrollButtonsNavigationMode(), e._refreshCalendarMode(), e._setDisplayMode(), e._refreshTitle(), e._refreshFooter(), e._refreshImportantDates(), e.$.monthElement && e.$.monthElement._setDropDownSize(), e._changeEventFired = 0, e.$.hiddenInput.value = e.selectedDates.toString(), e.shadowRoot && e.appendChild(e.$.hiddenInput), _get(_getPrototypeOf(_class76.prototype), "render", this).call(this);
    }
  }, {
    key: "_updateViewSectionsVisibility",
    value: function _updateViewSectionsVisibility() {
      var e = this;
      -1 < e.viewSections.indexOf("title") ? e.$title.removeClass("smart-hidden") : e.$title.addClass("smart-hidden"), -1 < e.viewSections.indexOf("header") ? e.$header.removeClass("smart-hidden") : e.$header.addClass("smart-hidden"), -1 < e.viewSections.indexOf("footer") ? e.$footer.removeClass("smart-hidden") : e.$footer.addClass("smart-hidden");
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this._clearSelection();
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      function e(e, t) {
        return t ? e && e instanceof t ? ("function" == typeof e._setFocusable && e.isCompleted ? e.unfocusable = -1 >= i : e.setAttribute("tabindex", i), e) : void 0 : void 0;
      }

      var t = this;
      var i = 0 < t.tabIndex ? t.tabIndex : 0;
      (t.disabled || t.unfocusable) && (i = -1), t.$.previousMonthButton = e(t.$.previousMonthButton, Smart.Button), t.$.nextMonthButton = e(t.$.nextMonthButton, Smart.Button), t.$.nextYearButton = e(t.$.nextYearButton, Smart.Button), t.$.previousYearButton = e(t.$.previousYearButton, Smart.Button), t.$.monthElement = e(t.$.monthElement, Smart.DropDownList), t.$.yearElement = e(t.$.yearElement, HTMLInputElement), -1 < t.viewSections.indexOf("title") && (t.$.dateContainer.setAttribute("tabindex", i), t.$.yearContainer.setAttribute("tabindex", i)), t.$.body.setAttribute("tabindex", i), "default" === t.calendarMode ? t.$.dateElement.setAttribute("tabindex", i) : t.$.dateElement.removeAttribute("tabindex"), t.tabIndex = t.readonly && !t.disabled ? 0 < t.tabIndex ? t.tabIndex : 0 : i;
    }
  }, {
    key: "navigate",
    value: function navigate(e) {
      var t = this;
      var i, a, n;

      if (e) {
        if ("number" == typeof e) {
          if (e = parseInt(e), isNaN(e) || 0 === e) return !1;

          if (6 !== t.weeks && 0 !== t.weeks && "month" === t.displayMode) {
            t._focusedCell || t._focusCell();

            var _n340, _o238;

            var _r150 = [].slice.call(t._focusedCell.closest(".smart-calendar-weeks").children).filter(function (e) {
              return !e.classList.contains("smart-hidden");
            });

            0 > e ? (_o238 = _r150[0].querySelectorAll(".smart-calendar-cell"), _n340 = t.rightToLeft ? _o238[_o238.length - 1] : _o238[0]) : (_o238 = _r150[_r150.length - 1].querySelectorAll(".smart-calendar-cell"), _n340 = t.rightToLeft ? _o238[0] : _o238[_o238.length - 1]), a = new Date(_n340.value), a.setDate(a.getDate() + e), i = a;
          } else i = t._getNextDate(e);
        } else {
          if (i = e = t._getValidDate(e), n = !0, isNaN(i.getTime())) return !1;
          var _o239 = t._viewDates[0];
          if (_o239 && i.getMonth() === _o239.getMonth() && i.getFullYear() === _o239.getFullYear()) return !1;
          6 !== t.weeks && 0 !== t.weeks && "month" === t.displayMode && (a = i);
        }

        return !!i && ("month" === t.displayMode ? (t.hasAnimation ? (t._animateNavigation(i, e), t.$nextMonthsContainer.hasClass("smart-date-view-container") && t.$nextMonthsContainer.removeClass("smart-date-view-container")) : (t._handleMonths(i), t._refreshHeaderElements(), t._refreshHeaderTitle()), a && (t._focusCell(t._getCellByDate(a, t._animationStarted ? t.$.nextMonthsContainer : void 0), !0), t._updateWeeksVisibility(e)), !0) : (!n && t.hasAnimation ? (t.$nextMonthsContainer.addClass("smart-calendar-date-view-container"), "list" === t.displayModeView ? t._setDisplayModeContent(i) : (!t._navigationDate || t._navigationDate.getTime() !== i.getTime()) && t._animateNavigation(i, e)) : t._setDisplayModeContent(i), !0));
      }
    }
  }, {
    key: "select",
    value: function select(e) {
      var t = this;
      "undefined" != typeof t._viewDates[0] && "none" !== t.selectionMode && e && (e = t._getValidDate(e), !(e instanceof Date) || "one" === t.selectionMode && -1 < t.selectedDates.map(Number).indexOf(e.getTime()) || e.getTime() < t.min.getTime() || e.getTime() > t.max.getTime() || (("one" === t.selectionMode || "default" === t.selectionMode || "zeroOrOne" === t.selectionMode) && t._clearSelection(!0), t._selectDate(e), 1 === t.selectedDates.length && !t._isDateInView(t.selectedDates[0]) && t._handleMonths(t.selectedDates[0])));
    }
  }, {
    key: "today",
    value: function today() {
      var e = this;
      var t = new Date();
      return t.setHours(0, 0, 0, 0), t.getTime() < e.min.getTime() || t.getTime() > e.max.getTime() ? t = new Date(e.max) : e.selectedDates = [t], e._handleMonths(t), t;
    }
  }, {
    key: "_animateNavigation",
    value: function _animateNavigation(e, t, i) {
      function a() {
        var e = 0 < t ? r.$.body[r._animationSettings.scrollSize] >= s : 0 === r.$.body[r._animationSettings.scrollSize],
            i = r._scrollStep / 2;
        return e ? void r._animateNavigationCompleted() : void (0 < t && r.$.body[r._animationSettings.scrollSize] > s * r._animationSettings.easeThreshold ? (i = o(r.$.body[r._animationSettings.scrollSize] / r._animationSettings.stepEaseSize, n(i - (s - r.$.body[r._animationSettings.scrollSize]) * r._animationSettings.step)), r._scrollStep = r._scrollStep * r._animationSettings.step + i) : 0 > t && r.$.body[r._animationSettings.scrollSize] < s * r._animationSettings.easeThreshold && (i = o(r.$.body[r._animationSettings.scrollMax] / r._animationSettings.stepEaseSize, n(i - r.$.body[r._animationSettings.scrollSize] * r._animationSettings.step)), r._scrollStep = r._scrollStep * r._animationSettings.step + i), r.$.body[r._animationSettings.scrollSize] += 0 < t ? r._scrollStep : -r._scrollStep, r._animationId = requestAnimationFrame(a));
      }

      var n = Math.abs,
          o = Math.max;
      var r = this;
      r._navigationDate = e, r._animationSettings || r._applyAnimationSettings(), r.$animationPanel.addClass("smart-hidden"), r.$.dateViewContainer.style.transform = "", r.$.dateViewContainer.style.opacity = "", r.$.monthsContainer.style.transform = "", r.$.monthsContainer.style.opacity = "";
      var l = "month" === r.displayMode ? r.$.monthsContainer : r.$.dateViewContainer,
          s = r.$.body[r._animationSettings.scrollMax] - r.$.body[r._animationSettings.size];

      if (r._scrollStep = r.$.body[r._animationSettings.size] * r._animationSettings.startSpeed, r._animationStarted) {
        var _e815 = r._getMonthCells(r.$.monthsContainer, r.rightToLeft);

        _e815.map(function (e) {
          r._setCellState(e, "restricted", !1), r._setCellState(e, "selected", !1), r._setCellState(e, "otherMonth", !1), r._setCellState(e, "focus", !1), r._setCellState(e, "important", !1), r._setCellState(e, "today", !1), r._setCellState(e, "disabled", !1), r._setCellState(e, "hover", !1);
        });
      }

      r._animationStarted = !0, "month" === r.displayMode ? r._handleMonths(e, r.$.nextMonthsContainer) : (r._setCellState(r._focusedCell, "focus", !1), r._setDisplayModeContent(e, r.$.nextMonthsContainer)), r.rightToLeft && (t *= -1), i || (0 < t ? (l.style.order = 1, r.$.nextMonthsContainer.style.order = 3, (!r._animationStarted || r._animationStarted && r.$.body[r._animationSettings.scrollSize] > 2 * (r.$.body[r._animationSettings.scrollMax] * r._animationSettings.resetThreshold)) && (r.$.body[r._animationSettings.scrollSize] = 0)) : (l.style.order = 3, r.$.nextMonthsContainer.style.order = 1, (!r._animationStarted || r._animationStarted && r.$.body[r._animationSettings.scrollSize] < r.$.body[r._animationSettings.scrollMax] * r._animationSettings.resetThreshold) && (r.$.body[r._animationSettings.scrollSize] = r.$.body[r._animationSettings.scrollMax]))), cancelAnimationFrame(r._animationId), r._animationId = requestAnimationFrame(a);
    }
  }, {
    key: "_animateNavigationCompleted",
    value: function _animateNavigationCompleted() {
      var e = this;
      var t = "month" === e.displayMode ? e.$.monthsContainer : e.$.dateViewContainer,
          i,
          a,
          n;

      if (cancelAnimationFrame(e._animationId), "month" !== e.displayMode) {
        var _o240 = [].slice.call(t.children).indexOf(e._focusedCell);

        t.innerHTML = e.$.nextMonthsContainer.innerHTML;

        var _r151 = t.children[_o240],
            _l111;

        a = t.children, n = e.$.nextMonthsContainer.children;

        for (var _t715 = 0; _t715 < a.length; _t715++) {
          a[_t715].value = n[_t715].value, a[_t715].restricted = n[_t715].restricted, a[_t715].important = n[_t715].important, a[_t715].otherMonth = n[_t715].otherMonth, a[_t715].value.getTime() <= e.max.getTime() && (_l111 = a[_t715]);
        }

        i = _r151 && _r151.value.getTime() >= e.max.getTime() ? _l111.value : e._focusedCell ? e._focusedCell.value : void 0;
      } else {
        var _o241 = t.children,
            _r152 = e.$.nextMonthsContainer.children;

        for (var _t716 = 0; _t716 < _o241.length && !!_r152[_t716]._date; _t716++) {
          _o241[_t716]._date = _r152[_t716]._date, _o241[_t716].innerHTML = _r152[_t716].innerHTML, a = e._getMonthCells(_o241[_t716]), n = e._getMonthCells(_r152[_t716]);

          for (var _e816 = 0; _e816 < a.length; _e816++) {
            a[_e816].value = n[_e816].value, a[_e816].restricted = n[_e816].restricted, a[_e816].important = n[_e816].important, a[_e816].otherMonth = n[_e816].otherMonth, a[_e816].removeAttribute("focus");
          }
        }

        0 < e._selectedCells.length && (e._selectedCells = e._selectedCells.map(function (t) {
          return t = e._getCellByDate(t.value);
        }).filter(function (e) {
          return "undefined" != typeof e;
        }));
      }

      e._focusCell(e._getCellByDate(i)), t.style.order = 1, e.$.nextMonthsContainer.style.order = 3, e.$.body[e._animationSettings.scrollSize] = 0, e._animationStarted = !1, delete e._navigationDate;
    }
  }, {
    key: "_applyAnimationSettings",
    value: function _applyAnimationSettings(e) {
      var t = this;
      if (!t.hasAnimation) return void delete t._animationSettings;
      t._animationSettings = t.animationSettings ? t.animationSettings : t._animationSettings ? t._animationSettings : {}, "portrait" === t.scrollButtonsNavigationMode ? (t._animationSettings.scrollMax = "scrollHeight", t._animationSettings.size = "offsetHeight", t._animationSettings.scrollSize = "scrollTop") : (t._animationSettings.scrollMax = "scrollWidth", t._animationSettings.size = "offsetWidth", t._animationSettings.scrollSize = "scrollLeft");
      e || (t._animationSettings.startSpeed = t._animationSettings.startSpeed ? t._animationSettings.startSpeed : .2, t._animationSettings.easeThreshold = t._animationSettings.easeThreshold ? t._animationSettings.easeThreshold : .5, t._animationSettings.step = t._animationSettings.step ? t._animationSettings.step : .25, t._animationSettings.stepEaseSize = t._animationSettings.stepEaseSize ? t._animationSettings.stepEaseSize : 200, t._animationSettings.resetThreshold = t._animationSettings.resetThreshold ? t._animationSettings.resetThreshold : .2);
    }
  }, {
    key: "_applySelectionMode",
    value: function _applySelectionMode(e, t) {
      function i(e, t) {
        var i = o.$.monthsContainer.children;

        for (var _a446 = 0; _a446 < i.length; _a446++) {
          o._getMonthCells(i[_a446]).map(function (i) {
            o._setCellState(i, e, t);
          });
        }
      }

      var a = Math.min,
          n = Math.max;
      var o = this;
      var r = [],
          l = !!e,
          s = o.selectionMode;

      switch (("many" !== s || "range" !== s) && i("hover", !1), o._newRangeSelectionStarted = 0 < o.selectedDates.length && "range" === s, -1 === ["default", "many", "zeroOrMany", "oneOrMany", "week", "range"].indexOf(s) ? Array.from(o.getElementsByClassName("smart-calendar-month")).forEach(function (e) {
        return e.removeAttribute("aria-multiselectable");
      }) : Array.from(o.getElementsByClassName("smart-calendar-month")).forEach(function (e) {
        return e.setAttribute("aria-multiselectable", !0);
      }), ("none" === s || "none" === t) && i("selected", !1), s) {
        case "none":
          return void o._clearSelection(l);

        case "range":
          return void (1 < o.selectedDates.length && o._selectMultipleDates(o.selectedDates[0], o.selectedDates[o.selectedDates.length - 1]));

        case "many":
        case "default":
        case "oneOrMany":
          if (0 === o.selectedDates.length) {
            r.push(new Date(a(n(o.min.getTime(), new Date().setHours(0, 0, 0, 0)), o.max.getTime())));
            break;
          }

          return;

        case "one":
          if (1 === o.selectedDates.length) return;
          1 < o.selectedDates.length ? (r.push(o.selectedDates[o.selectedDates.length - 1]), o._clearSelection(l)) : r.push(new Date(a(n(o.min.getTime(), new Date().setHours(0, 0, 0, 0)), o.max.getTime())));
          break;

        case "zeroOrOne":
          if (1 < o.selectedDates.length) {
            r.push(o.selectedDates[o.selectedDates.length - 1]), o._clearSelection(l);
            break;
          }

          return;

        case "zeroOrMany":
          return;

        case "week":
          if (1 <= o.selectedDates.length) {
            var _e817 = o.selectedDates[o.selectedDates.length - 1];

            for (var _t717 = 0; 7 > _t717; _t717++) {
              r.push(new Date(_e817)), _e817.setDate(_e817.getDate() + 1);
            }

            o._clearSelection(l);
          }

      }

      if (o.selectedDates = [], e) return void (o.selectedDates = r);
      var c = r.length;

      for (var _i710 = 0; _i710 < c; _i710++) {
        o._selectDate(r[_i710], _i710 < c - 1);
      }
    }
  }, {
    key: "_clearSelection",
    value: function _clearSelection(e) {
      var t = this,
          i = t.selectionMode;

      if (t._selectedCells && t._selectedCells.map(function (e) {
        t._setCellState(e, "selected", !1);
      }), t.selectedDates = [], t._selectedCells = [], "many" === i || "range" === i) {
        var _e818 = t.$.monthsContainer.children;

        for (var _i711 = 0; _i711 < _e818.length; _i711++) {
          t._getMonthCells(_e818[_i711]).map(function (e) {
            t._setCellState(e, "hover", !1);
          });
        }
      }

      t._refreshFooter(), t.$.hiddenInput.value = t.selectedDates.toString(), e || t.$.fireEvent("change", {
        value: []
      }), t._refreshTitle();
    }
  }, {
    key: "_bodyBlurStateHandler",
    value: function _bodyBlurStateHandler(e) {
      var t = this;
      t._bodyStateHandler(e), delete t._newRangeSelectionStarted;
    }
  }, {
    key: "_bodyFocusStateHandler",
    value: function _bodyFocusStateHandler(e) {
      var t = this;

      t._bodyStateHandler(e);
    }
  }, {
    key: "_bodyStateHandler",
    value: function _bodyStateHandler(e) {
      var t = this;

      if (t._focusedCell) {
        if ("blur" === e.type || "focus" === e.type && t._noFocusingRequired) return t._noFocusingRequired = !1, void t._setCellState(t._focusedCell, "focus", !1);
        if ("month" !== t.displayMode) return void ("focus" !== e.type || t.$.dateViewContainer.querySelector("smart-calendar-cell[focus]") || t._setCellState(t._focusedCell || t.$.dateViewContainer.querySelector(".smart-calendar-cell"), "focus", !0));
      }

      "focus" === e.type && t._focusCell();
    }
  }, {
    key: "_containerWheelHandler",
    value: function _containerWheelHandler(e) {
      var t = this;
      if (t.disabled || t.readonly) return;
      var i, a;
      a = document.activeElement, t.shadowRoot ? a = t.shadowRoot.activeElement : t.isInShadowDOM && (a = t.getRootNode().activeElement), t.$.yearElement === a && (i = 12), (a && t.shadowRoot || a.closest("smart-calendar") === t) && (i = e.target === t.$.yearElement ? 12 : 1);
      i && (e.preventDefault(), i = 12 == i ? i : i * t.months, 0 < e.deltaY ? t.navigate(-i) : t.navigate(i));
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;
      var i = e.originalEvent.target;

      if (t._dragStartDetails = void 0, !(t.disabled || t.readonly)) {
        if (t.hasRippleAnimation && (i.value instanceof Date || i.parentElement && i.parentElement.classList.contains("smart-calendar-title") || i.parentElement === t.$.dateElement) && Smart.Utilities.Animation.Ripple.animate(i, e.pageX, e.pageY), i = e.originalEvent.target.closest(".smart-calendar-header"), e.originalEvent.target.closest(".smart-calendar-year-container") && "decade" !== t.displayMode) return "classic" === t.calendarMode ? void 0 : void t._showDateView("year");
        if (e.originalEvent.target.closest(".smart-calendar-date-container") && "month" !== t.displayMode) return "classic" === t.calendarMode ? void 0 : void t._displayModeHandler("list" === t.displayModeView ? t.$.listViewContainer.getItem(t.$.listViewContainer.selectedValues[0]) : t._focusedCell, "month");
        if (t._animationStarted && t._animateNavigationCompleted(), Smart.Utilities.Core.isMobile && !(i && i === t.$.header)) return void (t._dragStartDetails = {
          x: e.pageX,
          y: e.pageY,
          startTime: Date.now(),
          target: e.originalEvent.target
        });

        if (i = e.originalEvent.target, i.closest(".smart-calendar-week") || i.parentElement === t.$.dateViewContainer) {
          for (; i && !(i.value instanceof Date);) {
            i = i.parentElement;
          }

          return void (i && ("month" === t.displayMode ? t._weeksDownHandler(e, i) : t._displayModeHandler(i)));
        }

        if (!i.closest(".smart-calendar-month-element")) {
          if (e.originalEvent.stopPropagation(), "list" === t.displayModeView && "month" !== t.displayMode) return i = (t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target).closest("smart-list-item"), void (i && t._displayModeHandler(i));

          var _a447 = document.scrollingElement || document.documentElement,
              _n341 = _a447.scrollLeft,
              _o242 = _a447.scrollTop;

          t.focus(), window.scrollTo(_n341, _o242);
        }
      }
    }
  }, {
    key: "_displayModeHandler",
    value: function _displayModeHandler(e, t) {
      var i = this;

      if (i._animationStarted && i._animateNavigationCompleted(), e instanceof HTMLElement && e.parentElement.classList.contains("smart-calendar-week") && e.otherMonth) {
        if ("decade" === i.displayMode && (e.value.getFullYear() < i.min.getFullYear() || e.value.getFullYear() > i.max.getFullYear())) return;
        if ("year" === i.displayMode && (e.value.getFullYear() < i.min.getFullYear() || e.value.getFullYear() === i.min.getFullYear() && e.value.getMonth() < i.min.getMonth() || e.value.getFullYear() > i.max.getFullYear() || e.value.getFullYear() === i.max.getFullYear() && e.value.getMonth() > i.max.getMonth())) return;
      }

      if (t = t ? t : i.displayMode, "year" === t ? t = "month" : "decade" === t ? t = "year" : void 0, i.displayMode !== t) {
        var _a448 = i.$.fireEvent("displayModeChanging", {
          oldDisplayMode: i.displayMode,
          newDisplayMode: t
        }).defaultPrevented;
        _a448 || (i.displayMode = t, i.$nextMonthsContainer.removeClass("smart-calendar-date-view-container"), e.parentElement === i.$.dateViewContainer && !e.disabled && !e.restricted && i._focusCell(e), i.hasAnimation ? (e instanceof Smart.ListItem || e.ownerListBox === i.$.listViewContainer ? e.offsetHeight ? i.$.animationPanel.style.transformOrigin = e.offsetLeft + e.offsetWidth / 2 + "px " + (0 < e.dataItem.top ? e.offsetTop - e.offsetHeight / 2 : e.offsetTop + e.offsetHeight / 2) + "px" : i.$.animationPanel.style.transformOrigin = i.$.listViewContainer.offsetLeft + i.$.listViewContainer.offsetWidth / 2 + "px " + (i.$.listViewContainer.offsetTop + i.$.listViewContainer.offsetHeight / 2) + "px" : (i.$.dateViewContainer.style.order = 1, i.$.nextMonthsContainer.style.order = 3, e = i._focusedCell, i.$.animationPanel.style.transformOrigin = e.offsetLeft + e.offsetWidth / 2 + "px " + (e.offsetTop + e.offsetHeight / 2) + "px"), i._animateView(1, e)) : i._setDisplayModeContent(e.value instanceof Date ? e.value : new Date(e.value)));
      }
    }
  }, {
    key: "_animateView",
    value: function _animateView(e, t) {
      function i() {
        return (0 < e && 3.5 <= l || 0 > e && 0 >= l) && (r = !0), r ? (cancelAnimationFrame(n._animationId), n.$animationPanel.addClass("smart-hidden"), n.$.animationPanel.style.transform = "", n.$.animationPanel.style.opacity = "", d.style.order = 1, n.$.nextMonthsContainer.style.order = 3, n.$.body[n._animationSettings.scrollSize] = 0, c.style.transform = "", c.style.opacity = "", void ("month" === n.displayMode ? n.$.body.focus() : "list" === n.displayModeView && n.focus())) : void (n.$.animationPanel.style.opacity = s, c.style.opacity = 1 - s, s -= .05, 0 < e ? (n.$.animationPanel.style.transform = "scale(" + l + ")", c.style.transform = "scale(" + Math.min((l - 1) / 2, 1) + ")", l += .125) : (n.$.animationPanel.style.transform = "scale(" + a(l, 0) + ")", c.style.transform = "scale(" + a(1 + l, 1) + ")", l -= .06), n._animationId = requestAnimationFrame(i));
      }

      var a = Math.max;
      var n = this;
      var o = t instanceof Date ? t : new Date(t.value),
          r = !1,
          l = 1,
          s = 1,
          d,
          c;
      if ("list" === n.displayModeView ? (d = t instanceof Smart.ListItem || t.ownerListBox === n.$.listViewContainer ? n.$.listViewContainer : "month" === n.displayMode ? n.$.listViewContainer : n.$.monthsContainer, c = "month" === n.displayMode ? n.$.monthsContainer : n.$.listViewContainer) : !(t.value instanceof Date) && (t = n._focusedCell ? n._focusedCell : 0 < n._selectedCells.length ? n._selectedCells[n._selectedCells.length - 1] : n._getCellByDate(new Date())), d || (d = t.parentElement === n.$.dateViewContainer ? n.$.dateViewContainer : n.$.monthsContainer), c || (c = "month" === n.displayMode ? n.$.monthsContainer : n.$.dateViewContainer), c.style.transformOrigin = n.$.animationPanel.style.transformOrigin, d instanceof Smart.ListBox) for (n.$.animationPanel.innerHTML = "", n.$.animationPanel.appendChild(d.cloneNode(!1)); d.$.itemsInnerContainer.firstElementChild;) {
        n.$.animationPanel.children[0].appendChild(d.$.itemsInnerContainer.firstElementChild);
      } else n.$.animationPanel.innerHTML = d.innerHTML;

      if (n._setDisplayModeContent(o), d.style.order = 1, n.$.nextMonthsContainer.style.order = 3, n.$.body[n._animationSettings.scrollSize] = 0, n.$.animationPanel.style.width = n.$.body.offsetWidth + "px", n.$.animationPanel.style.height = n.$.body.offsetHeight + "px", n.$.animationPanel.style.transform = "scale(1)", n.$.animationPanel.style.opacity = 1, n.$animationPanel.removeClass("smart-hidden"), c.style.opacity = "0", c.style.transform = "scale(3.5)", d.$.hasClass("smart-calendar-date-view-container") ? n.$animationPanel.addClass("smart-calendar-date-view-container") : n.$animationPanel.removeClass("smart-calendar-date-view-container"), d instanceof Smart.ListBox) {
        var _e819 = n.$.animationPanel.children[0];

        _e819.whenReady(function () {
          _e819._refreshLayout(), _e819.ensureVisible(_e819.selectedValues[0]);
        });
      }

      cancelAnimationFrame(n._animationId), n._animationId = requestAnimationFrame(i);
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = Math.abs;
      var a = this;
      if (!Smart.Utilities.Core.isMobile || !a._dragStartDetails) return;
      delete a._previousIteration;
      var i = Date.now();
      var n = e.originalEvent.target,
          o = {};
      (a.isInShadowDOM || a.shadowRoot && n === a) && (n = e.originalEvent.composedPath()[0]), "portrait" === a.scrollButtonsNavigationMode ? (o.coordinate = "y", o.direction = "pageY") : (o.coordinate = "x", o.direction = "pageX");
      var r = a._dragStartDetails.step * (a.rightToLeft ? -1 : 1);

      if (10 >= t(a._dragStartDetails[o.coordinate] - e[o.direction])) {
        if (n = "list" === a.displayModeView && "month" !== a.displayMode ? n.closest("smart-list-item") : n, !n) return void (a._dragStartDetails = void 0);
        if ("month" !== a.displayMode) return a._displayModeHandler(n), "portrait" === a.scrollButtonsNavigationMode ? a.$.body.scrollTop = 0 : a.$.body.scrollLeft = 0, void (a._dragStartDetails = void 0);
        if (a._weeksDownHandler(e, n), !a.disableAutoNavigation && n.otherMonth) return;
      } else {
        var _n342 = t((e[o.direction] - a._dragStartDetails[o.coordinate]) / (i - a._dragStartDetails.startTime));

        if (1 < _n342) {
          var _e820 = parseInt(_n342);

          for (var _t718 = 0; _t718 < _e820; _t718++) {
            a.navigate(r);
          }

          return void (a._dragStartDetails = void 0);
        }
      }

      if (!a.hasAnimation) return void (a._dragStartDetails = void 0);
      var l = ("month" === a.displayMode ? a.$.monthsContainer[a._animationSettings.scrollMax] : a.$.dateViewContainer[a._animationSettings.scrollMax]) + a.$.monthsSeparator[a._animationSettings.size];
      return 0 < a._dragStartDetails.step && a.$.body[a._animationSettings.scrollSize] > l * a._animationSettings.easeThreshold || 0 > a._dragStartDetails.step && a.$.body[a._animationSettings.scrollSize] < l * a._animationSettings.easeThreshold ? (a._animateNavigation(a._dragStartDetails.navigationDate, r, !0), 6 !== a.weeks && 0 !== a.weeks && "month" === a.displayMode && a._updateWeeksVisibility(r, a._getCellByDate(a._dragStartDetails.navigationDate, a.$.nextMonthsContainer)), void (a._dragStartDetails = void 0)) : void (a._cancelAnimation(void 0, r || 1), a._dragStartDetails = void 0);
    }
  }, {
    key: "_cancelAnimation",
    value: function _cancelAnimation() {
      function e() {
        if (!a || 3.5 <= a) {
          cancelAnimationFrame(t._animationId), t.$animationPanel.addClass("smart-hidden"), t.$.animationPanel.style.transform = "", t.$.animationPanel.style.opacity = "";

          var _e821 = "month" === t.displayMode ? t.$.monthsContainer : t.$.listViewContainer;

          return _e821.style.transform = "", _e821.style.opacity = "", "month" === t.displayMode ? t.$.body.focus() : "list" === t.displayModeView && t.focus(), void (t._animationStarted = !1);
        }

        t.$.animationPanel.style.opacity = n -= .25, t.$.animationPanel.style.transform = "scale(" + (a += .5) + ")", t._animationId = requestAnimationFrame(e);
      }

      var t = this,
          i = "month" === t.displayMode ? t.$.monthsContainer : t.$.dateViewContainer;
      var a = t.$.animationPanel.style.transform,
          n = t.$.animationPanel.style.opacity;
      a && (a = parseFloat(a.substring(a.indexOf("(") + 1 || 0, a.indexOf(")")))), i.style.order = 1, t.$.nextMonthsContainer.style.order = 3, t.$.body[t._animationSettings.scrollSize] = 0, t._animationId = requestAnimationFrame(e);
    }
  }, {
    key: "_focusCell",
    value: function _focusCell(e, t) {
      var i = this;

      if (i._focusedCell && i._setCellState(i._focusedCell, "focus", !1), !(i.disabled || i.readonly)) {
        if (e) return "month" === i.displayMode ? e.disabled || e.restricted ? void 0 : (t || i._setCellState(e, "focus", !0), void (i._focusedCell = e)) : (i._setCellState(e, "focus", !0), void (i._focusedCell = e));

        if ("month" === i.displayMode || 0 !== i.$.monthsContainer.offsetHeight) {
          var _e822 = i._selectedCells[i._selectedCells.length - 1];
          if (_e822 && _e822.offsetHeight) i._setCellState(_e822, "focus", !0), i._focusedCell = _e822;else {
            var _e823 = i.$.monthsContainer.children;
            if (!_e823[0]._date || i.min.getTime < _e823[0]._date.getTime()) return;

            var _t719 = i._getMonthCells(_e823[0], i.rightToLeft);

            for (var _e824 = 0; _e824 < _t719.length; _e824++) {
              var _a449 = _t719[_e824];

              if (!_a449.otherMonth) {
                if (_a449.disabled || _a449.restricted || !_a449.offsetHeight) continue;
                i._focusedCell = _a449;
                break;
              }
            }
          }
          i._focusedCell && i._setCellState(i._focusedCell, "focus", !0);
        }
      }
    }
  }, {
    key: "_getDays",
    value: function _getDays(e, t) {
      var i = t.length;
      var a = [];
      if (0 < i) for (var _n343 = 0; _n343 < i; _n343++) {
        t[_n343].getFullYear() === e.getFullYear() && t[_n343].getMonth() === e.getMonth() && a.push(t[_n343].getDate());
      }
      return a;
    }
  }, {
    key: "_getCellByDate",
    value: function _getCellByDate(e, t) {
      var a = this;
      if (!(e instanceof Date)) return;

      if (t || (t = a.$.monthsContainer), "month" !== a.displayMode) {
        if ("list" === a.displayModeView) return;

        var _t720 = arguments[1] ? a.$.nextMonthsContainer.children : a.$.dateViewContainer.children;

        for (var _n344 = 0; _n344 < _t720.length; _n344++) {
          if ("year" === a.displayMode) {
            if (_t720[_n344].value.getMonth() === e.getMonth()) return _t720[_n344];
            continue;
          } else if (_t720[_n344].value.getFullYear() === e.getFullYear()) return _t720[_n344];
        }

        return;
      }

      var n = t.children,
          o,
          r;

      for (var _a450 = 0; _a450 < n.length; _a450++) {
        if (e.getFullYear() === n[_a450]._date.getFullYear() && e.getMonth() === n[_a450]._date.getMonth()) {
          o = n[_a450];
          break;
        }
      }

      if (o) {
        r = a._getMonthCells(o);

        for (var _t721 = 0; _t721 < r.length; _t721++) {
          if ((!r[_t721].otherMonth || r[_t721].hover) && r[_t721].value.getMonth() === e.getMonth() && r[_t721].value.getDate() === e.getDate()) return r[_t721];
        }
      }
    }
  }, {
    key: "_getMonthCells",
    value: function _getMonthCells(e, t) {
      var i = e.getElementsByClassName("smart-calendar-week");
      var a = [];
      if (t) for (var _e825 = 0, _t722; _e825 < i.length; _e825++) {
        _t722 = i[_e825].children;

        for (var _e826 = _t722.length - 1; 0 < _e826; _e826--) {
          _t722[_e826].classList.contains("smart-calendar-cell") && a.push(_t722[_e826]);
        }
      } else for (var _e827 = 0, _t723; _e827 < i.length; _e827++) {
        _t723 = i[_e827].children;

        for (var _e828 = 1; _e828 < _t723.length; _e828++) {
          _t723[_e828].classList.contains("smart-calendar-cell") && a.push(_t723[_e828]);
        }
      }
      return a;
    }
  }, {
    key: "_getWeekNumber",
    value: function _getWeekNumber(e) {
      var t = Math.round;
      var i = this;
      var a = new Date(e.getFullYear(), 0, 1),
          n = t((e.getTime() - a.getTime() - 6e4 * (e.getTimezoneOffset() - a.getTimezoneOffset())) / 864e5) + 1,
          o = a.getDay() - i.firstDayOfWeek,
          r;
      return o = 0 <= o ? o : o + 7, 4 > o ? (r = Math.floor((n + o - 1) / 7) + 1, 52 < r && (a = new Date(e.getFullYear() + 1, 0, 1), o = a.getDay() - i.firstDayOfWeek, o = 0 <= o ? o : o + 7, r = 4 > o ? 1 : 53)) : r = t((n + o - 1) / 7), r;
    }
  }, {
    key: "_handleDateSelection",
    value: function _handleDateSelection(e) {
      var t = this;
      if (!("undefined" == typeof e || e.disabled || e.restricted)) switch (t.selectionMode) {
        case "none":
          t._focusCell(e);

          break;

        case "one":
        case "default":
          if (t._keysPressed.Control) return 1 < t.selectedDates.length || 1 === t.selectedDates.length && !e.selected ? void t._selectDate(e.value) : void t._focusCell(e);
          if (t._keysPressed.Shift) return void t._selectMultipleDates(new Date(t.selectedDates[0]), e);
          t._clearSelection(!0), t._selectDate(e.value, !!(-1 < t._selectedCells.indexOf(e.value)));
          break;

        case "many":
          {
            if (0 === t.selectedDates.length) return void t._selectDate(e.value);
            var _i712 = t.selectedDates[t.selectedDates.length - 1];

            var _a451 = new Date(t.selectedDates[0]);

            if (e.value.getTime() === _a451.getTime() || e.value.getTime() === _i712.getTime()) return t._clearSelection(), void t._focusCell(e);
            0 < t.selectedDates.length && t._selectMultipleDates(_a451, e);
            break;
          }

        case "range":
          {
            if (!(1 < t.selectedDates.length) || t._keysPressed.Control || t._newRangeSelectionStarted || t._clearSelection(!0), 0 === t.selectedDates.length || t._keysPressed.Control && 1 < t.selectedDates.length && !t._newRangeSelectionStarted) return e.value && t.selectedDates.find(function (t) {
              return t.getTime() === e.value.getTime();
            }) ? void 0 : (t._newRangeSelectionStarted = !0, void t._selectDate(e.value));
            var _i713 = t.selectedDates[t.selectedDates.length - 1];

            var _a452 = t._keysPressed.Control || t._newRangeSelectionStarted ? _i713 : new Date(t.selectedDates[0]);

            0 < t.selectedDates.length && t._selectMultipleDates(_a452, e), delete t._newRangeSelectionStarted;
            break;
          }

        case "zeroOrMany":
          t._selectDate(e.value);

          break;

        case "oneOrMany":
          if (1 === t.selectedDates.length && e.selected) return void t._focusCell(e);

          t._selectDate(e.value);

          break;

        case "zeroOrOne":
          if (1 === t.selectedDates.length && e.selected) return void t._selectDate(e.value);
          t._clearSelection(!0), t._selectDate(e.value);
          break;

        case "week":
          {
            if (e.selected && (e.value.getTime() === t.selectedDates[0].getTime() || e.value.getTime() === t.selectedDates[t.selectedDates.length - 1].getTime())) return t._clearSelection(), void t._focusCell(e);

            t._clearSelection(!0);

            var _a453 = new Date(e.value);

            t._selectDate(_a453);

            for (var _e829 = 1; 7 > _e829; _e829++) {
              _a453.setDate(_a453.getDate() + 1), t._selectDate(_a453);
            }

            t._isDateInView(_a453) || t.navigate(1);
            break;
          }
      }
    }
  }, {
    key: "_handleImportantDateTemplate",
    value: function _handleImportantDateTemplate() {
      var e = this;
      if (e._importantDatesTemplate = e._validateTemplate("importantDatesTemplate", e.importantDatesTemplate), !e._importantDatesTemplate || !e._importantDatesTemplate.content) return;
      var t = e._importantDatesTemplate.content;
      var a = t.childNodes.length,
          n = /{{\w+}}/g;
      var o;
      e._bindingDetails = [];

      for (var _r153 = 0; _r153 < a; _r153++) {
        if (o = n.exec(t.childNodes[_r153].innerHTML), o) return void e._bindingDetails.push({
          childNodeIndex: _r153,
          bindingString: o[0]
        });
      }
    }
  }, {
    key: "_handleLayoutTemplate",
    value: function _handleLayoutTemplate(e, t) {
      var i = this,
          a = i._validateTemplate(e.$.hasClass("smart-header") ? "headerTemplate" : e.$.hasClass("smart-calendar-footer") ? "footerTemplate" : "titleTemplate", t);

      if (!a || !a.content) return void ("function" == typeof t && t(e, {}));
      i._layoutTemplates || (i._layoutTemplates = []);
      var n = document.importNode(a.content, !0);
      e.innerHTML = "";
      var o = n.childNodes.length,
          r = /{{\w+}}/g;
      var l = [],
          s;

      for (var _a454 = 0; _a454 < o; _a454++) {
        s = r.exec(n.childNodes[_a454].innerHTML), s && l.push({
          childNodeIndex: _a454,
          bindingString: s[0]
        });
      }

      return i._layoutTemplates = i._layoutTemplates.filter(function (t) {
        return t.selector !== e;
      }), i._layoutTemplates.push({
        selector: e,
        template: a,
        bindings: l
      }), i.shadowRoot ? (e.innerHTML = "<slot></slot>", void i.appendChild(n)) : void e.appendChild(n);
    }
  }, {
    key: "_handleCalendarCellHover",
    value: function _handleCalendarCellHover(e, t) {
      var i = this;

      if (!i._animationStarted) {
        if ("month" === i.displayMode) if ("mouseover" === e.type && ("many" === i.selectionMode || "range" === i.selectionMode && i._newRangeSelectionStarted) && 0 < i.selectedDates.length) {
          var _e830 = i.$.monthsContainer.children;

          for (var _t724 = 0; _t724 < _e830.length; _t724++) {
            i._getMonthCells(_e830[_t724]).map(function (e) {
              i._setCellState(e, "hover", !1);
            });
          }

          var _a455 = new Date("range" === i.selectionMode ? i.selectedDates[i.selectedDates.length - 1] : i.selectedDates[0]),
              _n345 = new Date(t.value),
              _o243 = t;

          var _r154 = _a455.getTime() > _n345.getTime() ? -1 : 1,
              _l112 = function _l112() {
            _o243 = i._getCellByDate(_a455), !_o243 || _o243.selected || _o243.restricted || i._setCellState(_o243, "hover", !0);
          };

          if (_a455.getTime() !== _n345.getTime()) {
            for (_a455.setDate(_a455.getDate() + _r154); _a455.getTime() !== _n345.getTime();) {
              _l112(), _a455.setDate(_a455.getDate() + _r154);
            }

            _l112();
          }
        } else i._setCellState(t, "hover", !1);
        "mouseover" !== e.type || t.otherMonth ? i._setCellState(t, "hover", !1) : i._setCellState(t, "hover", !0);
      }
    }
  }, {
    key: "_handleMonths",
    value: function _handleMonths(e, t) {
      function i(e) {
        var t = e.children.length,
            i = document.createDocumentFragment(),
            a;

        for (t; t < n.months; t++) {
          a = n.$.month.cloneNode(!1), a.innerHTML = n.$.month.innerHTML, i.appendChild(a);
        }

        return i;
      }

      function a(t) {
        var a = t.children;

        for (var _o244 = 0; _o244 < a.length; _o244++) {
          n._setMonth(e, a[_o244]), e.setMonth(e.getMonth() + 1);
        }

        n._setWeeksVisibility(t), n._refreshHeaderElements(), n._refreshHeaderTitle(), n.tooltip && n.$.tooltip.close(), n.$.body === document.activeElement && n._focusCell();
      }

      var n = this;
      var o;

      if (e || (e = n._viewDates && 0 < n._viewDates.length ? n._viewDates[0] : new Date()), e = new Date(Math.min(Math.max(n.min.getTime(), e.getTime()), n.max.getTime())), t || (t = n.$.monthsContainer), n._selectedCells = [], n.hasAnimation) {
        for (o = n.$.nextMonthsContainer.children, 0 < o.length && o[0].value instanceof Date && (n.$.nextMonthsContainer.innerHTML = ""); n.$.nextMonthsContainer.childElementCount < n.months;) {
          n.$.nextMonthsContainer.appendChild(i(n.$.nextMonthsContainer));
        }

        for (; n.$.nextMonthsContainer.childElementCount > n.months;) {
          n.$.nextMonthsContainer.removeChild(o[n.$.nextMonthsContainer.childElementCount - 1]);
        }

        if (arguments[1] === n.$.nextMonthsContainer) return void a(n.$.nextMonthsContainer);
      }

      if (o = n.$.monthsContainer.children, o.length > n.months) {
        for (; n.$.monthsContainer.childElementCount > n.months;) {
          n.$.monthsContainer.removeChild(o[n.$.monthsContainer.childElementCount - 1]), n._viewDates.pop();
        }

        return void a(n.$.monthsContainer);
      }

      return n.$.monthsContainer.children.length === n.months ? void a(n.$.monthsContainer) : void (n._viewDates = [], n.$.monthsContainer.appendChild(i(n.$.monthsContainer)), a(n.$.monthsContainer));
    }
  }, {
    key: "_headerChangeHandler",
    value: function _headerChangeHandler(e) {
      var t = this;

      if (e.stopPropagation(), !(t.disabled || t.readonly)) {
        if (e.target.ownerElement === t.$.monthElement && 0 !== t._changeEventFired) return void t._changeEventFired--;
        var _i714 = t.displayMode;
        e.target === t.$.yearElement && (t._viewDates[0].setFullYear(Math.min(Math.max(t.min.getFullYear(), isNaN(parseInt(t.$.yearElement.value)) ? 0 : parseInt(t.$.yearElement.value)), t.max.getFullYear())), t._handleMonths(t._viewDates[0])), t.$.monthElement && (e.target === t.$.monthElement || e.target.ownerElement === t.$.monthElement) && (t._handleMonths(new Date(t.$.monthsContainer.children[0]._date.getFullYear(), t.$.monthElement.selectedIndexes[0], 1)), "month" !== _i714 && t._setDisplayMode(t.displayMode, t.displayMode = "month"));
      }
    }
  }, {
    key: "_headerClickHandler",
    value: function _headerClickHandler(e) {
      var t = this;

      if (!(t.disabled || t.readonly)) {
        var _i715 = e.target.closest("smart-repeat-button");

        if (!(_i715 && _i715.disabled)) {
          switch (_i715) {
            case t.$.previousMonthButton:
              return t._isInteractiveNavigation = !0, void t.navigate(-1 * t.months * (t.rightToLeft ? -1 : 1));

            case t.$.nextMonthButton:
              return t._isInteractiveNavigation = !0, void t.navigate(1 * t.months * (t.rightToLeft ? -1 : 1));

            case t.$.previousYearButton:
              return void t.navigate(-12);

            case t.$.nextYearButton:
              return void t.navigate(12);
          }

          "classic" === t.calendarMode || e.target.closest(".smart-calendar-date-element") && (t._animationStarted && t._animateNavigationCompleted(), t._isInteractiveNavigation = !0, t._showDateView());
        }
      }
    }
  }, {
    key: "_selectMultipleDates",
    value: function _selectMultipleDates(e, t) {
      var i = this;

      if (t instanceof HTMLElement && (t = t.value), i._newRangeSelectionStarted ? i._selectDate(e, !0) : i._clearSelection(!0), "range" !== i.selectionMode || t.getTime() !== e.getTime()) {
        if (e.getTime() < t.getTime()) for (; e.getTime() <= t.getTime();) {
          i.selectedDates.find(function (t) {
            return t.getTime() === e.getTime();
          }) || i._selectDate(e, !0), e.setDate(e.getDate() + 1);
        } else if (e.getTime() > t.getTime()) for (; e.getTime() >= t.getTime();) {
          i.selectedDates.find(function (t) {
            return t.getTime() === e.getTime();
          }) || i._selectDate(e, !0), e.setDate(e.getDate() - 1);
        } else i._selectDate(t, !0);
        i.$.hiddenInput.value = i.selectedDates.toString(), i._refreshFooter(), i.$.fireEvent("change", {
          value: i.selectedDates
        }), i._refreshTitle();
      }
    }
  }, {
    key: "_setDisplayMode",
    value: function _setDisplayMode(e, t, i) {
      var a = this;
      if (a.$nextMonthsContainer.removeClass("smart-calendar-date-view-container"), 0 === arguments.length || !a.hasAnimation) return "classic" === a.calendarMode ? void (a.displayMode = "month") : ("month" !== a.displayMode && (a.$monthsContainer.addClass("smart-hidden"), a.$dateViewContainer.hasClass("smart-hidden") && a.$dateViewContainer.removeClass("smart-hidden")), !a.isCompleted && "month" === a.displayMode) ? void 0 : void a._setDisplayModeContent();
      if (a._animationStarted && (a.displayMode = e, a._animateNavigationCompleted(), a.displayMode = t), "month" === e && "year" === t || "year" === e && "decade" === t) a.displayMode = e, a._showDateView(i ? void 0 : a.displayMode);else if ("month" === e && "decade" === t) a._showDateView(a.displayMode = "year");else {
        var _e831;

        "list" === a.displayModeView ? (_e831 = (a.$.listViewContainer.shadowRoot ? a.$.listViewContainer.shadowRoot : a.$.listViewContainer).querySelector("smart-list-item[selected]"), a.$.animationPanel.style.transformOrigin = _e831.offsetLeft + _e831.offsetWidth / 2 + "px " + (0 < _e831.dataItem.top ? _e831.offsetTop - _e831.offsetHeight / 2 : _e831.offsetTop + _e831.offsetHeight / 2) + "px") : (a.$.dateViewContainer.style.order = 1, a.$.nextMonthsContainer.style.order = 3, _e831 = a._focusedCell, a.$.animationPanel.style.transformOrigin = _e831.offsetLeft + _e831.offsetWidth / 2 + "px " + (_e831.offsetTop + _e831.offsetHeight / 2) + "px"), a._animateView(1, _e831);
      }
    }
  }, {
    key: "_setDisplayModeContent",
    value: function _setDisplayModeContent(e, t) {
      var a = this;
      var n = e && "Invalid Date" !== e.toString() ? e : 0 < a.selectedDates.length ? a.selectedDates[a.selectedDates.length - 1] : new Date();
      n.setTime(Math.min(Math.max(n.getTime(), a.min.getTime()), a.max.getTime())), n.setHours(0, 0, 0, 0);

      var o = a._prepareView(n);

      if (!o) return;
      var i;
      t ? (a.$.nextMonthsContainer.innerHTML = a.$.dateViewContainer.innerHTML, i = a.$.nextMonthsContainer) : i = a.$.dateViewContainer;
      var r = i.children;
      var l;

      for (var _s81 = 0; _s81 < r.length; _s81++) {
        var _e832 = r[_s81];
        _e832.innerHTML = o.viewContent[_s81], _e832.value = o.dates[_s81], "year" === a.displayMode ? (_e832.value.getFullYear() < a.min.getFullYear() || _e832.value.getFullYear() === a.min.getFullYear() && _e832.value.getMonth() < a.min.getMonth() || _e832.value.getFullYear() > a.max.getFullYear() || _e832.value.getFullYear() === a.max.getFullYear() && _e832.value.getMonth() > a.max.getMonth() ? a._setCellState(_e832, "otherMonth", !0) : a._setCellState(_e832, "otherMonth", !1), n.getFullYear() === _e832.value.getFullYear() && n.getMonth() === _e832.value.getMonth() && (l = _e832)) : "decade" === a.displayMode && (0 == _s81 || _s81 == r.length - 1 || _e832.value.getFullYear() < a.min.getFullYear() || _e832.value.getFullYear() > a.max.getFullYear() ? a._setCellState(_e832, "otherMonth", !0) : a._setCellState(_e832, "otherMonth", !1), n.getFullYear() === _e832.value.getFullYear() && (l = _e832)), a._setCellState(_e832, "hover", !1), a._setCellState(_e832, "focus", !1);
      }

      if (l.otherMonth) for (var _e833 = 0; _e833 < r.length; _e833++) {
        if (!r[_e833].otherMonth) {
          l = r[_e833];
          break;
        }
      }
      return a._mobileScrolling ? void 0 : (a._focusedCell && a._setCellState(a._focusedCell, "focus", !1), a._focusedCell = l, a._focusCell(a._focusedCell), a._refreshHeaderTitle(), a._refreshHeaderElements(), a.$.fireEvent("displayModeChange"), a._isInteractiveNavigation ? void (a._isInteractiveNavigation = void 0) : void (a._setCellState(l, "focus", !0), setTimeout(function () {
        a.$.body.focus(), a._focusCell(a._focusedCell);
      }, 0)));
    }
  }, {
    key: "_prepareView",
    value: function _prepareView(e) {
      function t(e, t, i) {
        var a = new Date(e, t + 1, 0),
            n = a.getDate();
        return i > n ? a.setDate(n) : a.setDate(i), a;
      }

      var a = this;
      var n = [],
          o = [],
          r,
          i;
      if ("month" === a.displayMode) return a.$nextMonthsContainer.hasClass("smart-date-view-container") && a.$nextMonthsContainer.removeClass("smart-date-view-container"), a.$listViewContainer.addClass("smart-hidden"), a.$dateViewContainer.hasClass("smart-visibility-hidden") && a.$dateViewContainer.removeClass("smart-visibility-hidden"), a._isDateInView(e) || a._handleMonths(e), a.$header.hasClass("smart-hidden") && a.$header.removeClass("smart-hidden"), a.$body.hasClass("smart-calendar-list-view") && a.$body.removeClass("smart-calendar-list-view"), a.$dateContainer.addClass("smart-calendar-selected"), a.$yearContainer.removeClass("smart-calendar-selected"), a.$dateViewContainer.addClass("smart-hidden"), a.$monthsContainer.removeClass("smart-hidden"), a._refreshHeaderTitle(), a.$.body.setAttribute("tabindex", 0 < a.tabIndex ? a.tabIndex : 0), a._refreshHeaderElements(), a.$.body.focus(), a._focusCell(a._getCellByDate(e)), void a.$.fireEvent("displayModeChange");
      if ("list" === a.displayModeView) return a._setDisplayModeListContent(e), void a.$.fireEvent("displayModeChange");

      if (a.$header.hasClass("smart-hidden") && a.$header.removeClass("smart-hidden"), a.$dateViewContainer.hasClass("smart-visibility-hidden") && a.$dateViewContainer.removeClass("smart-visibility-hidden"), a.$listViewContainer.addClass("smart-hidden"), a.$.body.setAttribute("tabindex", 0 < a.tabIndex ? a.tabIndex : 0), "year" === a.displayMode) {
        var _r155 = new Date();

        for (var _l113 = 0; 12 > _l113; _l113++) {
          _r155 = t(_r155.getFullYear(), _l113, _r155.getDate()), n.push(_r155.toLocaleDateString(a.locale, {
            month: "short"
          })), o.push(t(e.getFullYear(), _l113, e.getDate()));
        }
      } else {
        r = e ? e.getFullYear() : a._viewDates[0].getFullYear(), i = r % 10, 0 !== i && (r -= i), r -= 1;

        for (var _t725 = 0; 12 > _t725; _t725++) {
          n.push(r + ""), o.push(new Date(r, e.getMonth(), e.getDate())), ++r;
        }
      }

      return {
        viewContent: n,
        dates: o
      };
    }
  }, {
    key: "_setDisplayModeListContent",
    value: function _setDisplayModeListContent(e) {
      function t(e, t, i) {
        var a = new Date(e, t + 1, 0),
            n = a.getDate();
        return i > n ? a.setDate(n) : a.setDate(i), a;
      }

      var a = this;
      var n = [];

      if (a.$dateViewContainer.addClass("smart-visibility-hidden"), a.$listViewContainer.hasClass("smart-hidden") && (a.$body.addClass("smart-calendar-list-view"), a.$listViewContainer.removeClass("smart-hidden"), a.$.listViewContainer._setFocusable(), a.$.body.removeAttribute("tabindex")), "year" === a.displayMode) {
        var _o245 = new Date();

        for (var _r156 = 0; 12 > _r156; _r156++) {
          _o245 = t(_o245.getFullYear(), _r156, _o245.getDate()), n.push({
            label: _o245.toLocaleDateString(a.locale, {
              month: "short"
            }),
            value: t(e.getFullYear(), _r156, e.getDate()).toDateString()
          });
        }

        a.$yearContainer.removeClass("smart-calendar-selected"), a.$dateContainer.addClass("smart-calendar-selected");
      } else {
        var _t726 = a.min.getFullYear(),
            _o246 = a.max.getFullYear();

        _o246 = Math.min(a.max.getFullYear(), e.getFullYear() + 10), _t726 = Math.max(a.min.getFullYear(), _o246 - 10);

        for (var _a456 = _t726; _a456 < _o246; _a456++) {
          n.push({
            label: _a456.toString(),
            value: new Date(_a456, e.getMonth(), e.getDate()).toDateString()
          });
        }

        a.$yearContainer.addClass("smart-calendar-selected"), a.$dateContainer.removeClass("smart-calendar-selected");
      }

      a.$.listViewContainer.dataSource = n, a.$.listViewContainer.selectedValues = [e.toDateString()], a.$.listViewContainer.ensureVisible(a.$.listViewContainer.selectedValues[0]), a._refreshHeaderTitle(), a._refreshHeaderElements(), a.focus();
    }
  }, {
    key: "_isDateInView",
    value: function _isDateInView(e) {
      var t = this;
      if (!e) return !1;

      for (var _i716 = 0; _i716 < t._viewDates.length; _i716++) {
        if (e.getFullYear() === t._viewDates[_i716].getFullYear() && e.getMonth() === t._viewDates[_i716].getMonth()) {
          var _i717 = t._getCellByDate(e, t._animationStarted ? t.$.nextMonthsContainer : void 0);

          return _i717 ? !(_i717.otherMonth || !_i717.offsetHeight || _i717.classList.contains("smart-visibility-hidden")) : void 0;
        }
      }

      return !1;
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this;

      if (!(t.disabled || t.readonly)) {
        var _i718 = (t.shadowRoot || t.getRootNode()).activeElement || document.activeElement;

        switch (_i718) {
          case t.$.yearElement:
            "Escape" === e.key && t._refreshHeaderElements();
            break;

          case t.$.dateElement:
            if ("default" === t.calendarMode && " " === e.key || "Enter" === e.key) return e.preventDefault(), t._isInteractiveNavigation = !0, void t._showDateView();
            t._focusedCell || t._focusCell(), -1 < e.key.indexOf("Arrow") && t.$.dateElement === _i718 && t.$.body.focus(), t._navigateDays(e);
            break;

          case t.$.body:
            " " === e.key && e.preventDefault(), t._navigateDays(e);
            break;

          case t.$.yearContainer:
            if ((" " === e.key || "Enter" === e.key) && "decade" !== t.displayMode && (e.preventDefault(), t._isInteractiveNavigation = !0, t._showDateView("year")), -1 < e.key.indexOf("Arrow")) {
              if (e.preventDefault(), t._focusedCell || t._focusCell(), "month" !== t.displayMode && "list" === t.displayModeView) return t.focus(), void t.$.listViewContainer._handleKeyStrokes(e.key);

              t._navigateDays(e);
            }

            break;

          case t.$.dateContainer:
            if ((" " === e.key || "Enter" === e.key) && "month" !== t.displayMode && (e.preventDefault(), t._displayModeHandler("list" === t.displayModeView ? t.$.listViewContainer.getItem(t.$.listViewContainer.selectedValues[0]) : t._focusedCell, "month")), -1 < e.key.indexOf("Arrow")) {
              if (t._focusedCell || t._focusCell(), "month" !== t.displayMode && "list" === t.displayModeView) return t.focus(), void t.$.listViewContainer._handleKeyStrokes(e.key);

              t._navigateDays(e);
            }

            break;

          default:
            if ("month" !== t.displayMode && "list" === t.displayModeView) return (["Arrow", "End", "Home", "Page"].indexOf(e.key) && e.preventDefault(), " " === e.key || "Enter" === e.key || e.ctrlKey && ("ArrowUp" === e.key || "ArrowDown" === e.key)) ? void t._navigateDays(e) : void t.$.listViewContainer._handleKeyStrokes(e.key);
            -1 < e.key.indexOf("Arrow") && (!t._focusedCell && t._focusCell(), t._navigateDays(e));
        }
      }
    }
  }, {
    key: "_listViewContainerItemClickHandler",
    value: function _listViewContainerItemClickHandler(e) {
      var t = this;
      Smart.Utilities.Core.isMobile && ("list" !== t.displayModeView || "month" === t.displayMode || t._displayModeHandler(e.target.items[e.detail.index]));
    }
  }, {
    key: "_listViewContainerChangeEventHandler",
    value: function _listViewContainerChangeEventHandler(e) {
      e.stopPropagation();
    }
  }, {
    key: "_listViewContainerKeyDownHandler",
    value: function _listViewContainerKeyDownHandler(e) {
      var t = this;
      "list" !== t.displayModeView || (" " === e.key || "Enter" === e.key) && t._navigateDays(e);
    }
  }, {
    key: "_showDateView",
    value: function _showDateView(e) {
      var t = this;
      if (e = e ? e : t.displayMode, "month" === e ? e = "year" : "year" === e ? e = "decade" : void 0, t.displayMode === e) return;
      var i = t.$.fireEvent("displayModeChanging", {
        oldDisplayMode: t.displayMode,
        newDisplayMode: e
      }).defaultPrevented;
      if (i) return;
      t.displayMode = e;
      var a;
      return "list" === t.displayModeView && "month" !== t.displayMode && 0 < t.$.listViewContainer.items.length ? (a = t.$.listViewContainer.getItem(t.$.listViewContainer.selectedValues[0]), t.$.animationPanel.style.transformOrigin = a.offsetHeight ? a.offsetLeft + a.offsetWidth / 2 + "px " + (0 < a.dataItem.top ? a.offsetTop - a.offsetHeight / 2 : a.offsetTop + a.offsetHeight / 2) + "px" : t.$.listViewContainer.offsetLeft + t.$.listViewContainer.offsetWidth / 2 + "px " + (0 < a.dataItem.top ? a.offsetTop - a.offsetHeight / 2 : t.$.listViewContainer.offsetTop + t.$.listViewContainer.offsetHeight / 2) + "px") : (!t._focusedCell && t._focusCell(), a = t._focusedCell, t.$.animationPanel.style.transformOrigin = a.offsetLeft + a.offsetWidth / 2 + "px " + (a.offsetTop + a.offsetHeight / 2) + "px"), t.$monthsContainer.addClass("smart-hidden"), t.$dateViewContainer.hasClass("smart-hidden") && t.$dateViewContainer.removeClass("smart-hidden"), "decade" === t.displayMode && (t.$yearContainer.addClass("smart-calendar-selected"), t.$dateContainer.removeClass("smart-calendar-selected")), t.hasAnimation ? void t._animateView(-1, a) : void t._setDisplayModeContent(t._focusedCell ? t._focusedCell.value : t._viewDates[0]);
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this;
      t.disabled || t.readonly || ("default" === t.selectionMode || "range" === t.selectionMode) && ("Shift" === e.key || "Control" === e.key) && (t._keysPressed[e.key] = !1);
    }
  }, {
    key: "_mouseEventsHandler",
    value: function _mouseEventsHandler(e) {
      var t = this;
      if (t.disabled || t.readonly) return;
      if ("mouseenter" === e.type) return void t.$.setAttributeValue("hover", !0);
      if ("mouseleave" === e.type) return t.$.setAttributeValue("hover", !1), void (t.tooltip && t.$.tooltip.close());
      var i = t.shadowRoot || t.isInShadowDOM ? e.composedPath()[0] : e.target;
      if (!i.closest(".smart-calendar-week")) return void (t.tooltip && t.$.tooltip.close());
      var a = i,
          n;

      for (; a && !(a.value instanceof Date);) {
        a = a.parentElement, n = !0;
      }

      if (a && (Smart.Utilities.Core.isMobile || t._handleCalendarCellHover(e, a), t.tooltip)) {
        if (a.hasAttribute("important") && "mouseover" === e.type) return t.$.tooltip.open(), t.tooltipTemplate ? t.$.tooltip.value = a.value + "" : t.$.tooltip.innerHTML = 0 === t.$.tooltip.innerHTML.trim().length ? "Important day!" : t.$.tooltip.innerHTML, t.$.tooltip.selector = a, void (t.$.tooltip.selector !== a && t.$.tooltip.close());
        if (n || t.$.tooltip.selector === a) return;
        t.$.tooltip.close();
      }
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      var t = Math.round;
      var a = this;
      if (!Smart.Utilities.Core.isMobile || !a._dragStartDetails || "list" === a.displayModeView && "month" !== a.displayMode) return;
      e.originalEvent.preventDefault(), e.preventDefault(), e.stopPropagation();
      var i = {
        x: t(e.pageX),
        y: t(e.pageY)
      };
      var n = "portrait" === a.scrollButtonsNavigationMode ? i.y > a._dragStartDetails.y ? -1 * a.months : 1 * a.months : i.x < a._dragStartDetails.x ? 1 * a.months : -1 * a.months;
      var o;
      if (a._previousIteration && n === a._previousIteration.step) o = a._previousIteration.date;else if (6 !== a.weeks && 0 !== a.weeks && "month" === a.displayMode) {
        var _e834;

        a._focusedCell || a._focusCell();

        var _t727;

        var _i719 = [].slice.call(a._focusedCell.closest(".smart-calendar-weeks").children).filter(function (e) {
          return !e.classList.contains("smart-hidden");
        });

        if (!_i719.length) o = a._getNextDate(n * (a.rightToLeft ? -1 : 1));else {
          var _r157;

          !a.rightToLeft && 0 > n || a.rightToLeft && 0 < n ? (_r157 = _i719[0].querySelectorAll(".smart-calendar-cell"), _t727 = a.rightToLeft ? _r157[_r157.length - 1] : _r157[0]) : (_r157 = _i719[_i719.length - 1].querySelectorAll(".smart-calendar-cell"), _t727 = a.rightToLeft ? _r157[0] : _r157[_r157.length - 1]), _e834 = new Date(_t727.value), _e834.setDate(_e834.getDate() + n * (a.rightToLeft ? -1 : 1)), o = _e834;
        }
      } else o = a._getNextDate(n * (a.rightToLeft ? -1 : 1));
      if (!o) return;
      if (a._dragStartDetails.step = n, a._dragStartDetails.navigationDate = new Date(o), !a.hasAnimation) return;
      a._previousIteration = {
        step: n,
        date: o
      }, a._mobileScrolling = !0;
      var r;
      if ("month" !== a.displayMode) a.$nextMonthsContainer.addClass("smart-calendar-date-view-container"), r = a.$.dateViewContainer, a.$.nextMonthsContainer.children[0].value instanceof Date && a.$.nextMonthsContainer.children[1].value.getFullYear() === o.getFullYear() || a._setDisplayModeContent(o, a.$.nextMonthsContainer);else if (a.$nextMonthsContainer.hasClass("smart-calendar-date-view-container") && a.$nextMonthsContainer.removeClass("smart-calendar-date-view-container"), r = a.$.monthsContainer, !a.$.nextMonthsContainer.children[0]._date || a.$.nextMonthsContainer.children[0]._date.getTime() !== o.getTime()) {
        var _e835 = a.$.nextMonthsContainer.children;

        for (var _t728 = 0; _t728 < _e835.length; _t728++) {
          o.setMonth(a._dragStartDetails.navigationDate.getMonth() + _t728 * (a.rightToLeft ? -1 : 1)), a._setMonth(new Date(o), _e835[_t728], !0);
        }
      }
      6 !== a.weeks && 0 !== a.weeks && "month" === a.displayMode && a._updateWeeksVisibility(n * (a.rightToLeft ? -1 : 1), a._getCellByDate(o, a.$.nextMonthsContainer)), delete a._mobileScrolling, 0 > n ? (r.style.order = 3, a.$.nextMonthsContainer.style.order = 1, a.$.body[a._animationSettings.scrollSize] = a.$.body[a._animationSettings.scrollMax]) : (r.style.order = 1, a.$.nextMonthsContainer.style.order = 3, a.$.body[a._animationSettings.scrollSize] = 0);
      var l = "portrait" === a.scrollButtonsNavigationMode ? "y" : "x";
      5 < Math.abs(a._dragStartDetails[l] - i[l]) && (a.$.body[a._animationSettings.scrollSize] += 2 * -(i[l] - a._dragStartDetails[l]));
    }
  }, {
    key: "_getNextDate",
    value: function _getNextDate(e) {
      var t = this;
      var i;

      if ("month" !== t.displayMode) {
        var _a457;

        var _n346 = t._focusedCell && t._focusedCell.value.getFullYear();

        if ("list" === t.displayModeView) i = new Date(t.$.listViewContainer.items[0].value);else {
          var _e836 = t._animationStarted ? t.$.nextMonthsContainer : t.$.dateViewContainer;

          i = new Date("year" === t.displayMode ? _e836.children[0].value : _e836.children[1].value);
        }

        if (_a457 = "year" === t.displayMode ? 1 : 0 === e ? 1 : 10, i.setFullYear(i.getFullYear() + (0 < e ? _a457 : -_a457)), i.getTime() < t.min.getTime() && (i = t.min), i.getTime() > t.max.getTime() && (i = t.max), "year" === t.displayMode) {
          if (i.getFullYear() < t.min.getFullYear() || i.getFullYear() > t.max.getFullYear() || _n346 === i.getFullYear()) return;
        } else if (i.getFullYear() < t.min.getFullYear() || i.getFullYear() > t.max.getFullYear() || _n346 === i.getFullYear()) return;
      } else {
        var _a458 = t._viewDates[0];
        if (i = new Date(_a458), i.setDate(1), i.setMonth(i.getMonth() + e), i.setTime(Math.min(Math.max(i.getTime(), t.min.getTime()), t.max.getTime())), _a458.getMonth() === i.getMonth() && _a458.getFullYear() === i.getFullYear()) return;
      }

      return i;
    }
  }, {
    key: "_navigateDays",
    value: function _navigateDays(e) {
      var t = this;
      var i = "ArrowUp" === e.key || "ArrowDown" === e.key ? 7 : 1,
          a = "ArrowUp" === e.key || "ArrowLeft" === e.key || "PageUp" === e.key ? -1 : 1;

      switch (e.key) {
        case "ArrowUp":
        case "ArrowLeft":
        case "ArrowDown":
        case "ArrowRight":
          if (!t._handleArrowKeys(e, i, a)) return;
          break;

        case " ":
        case "Enter":
          if ("month" !== t.displayMode) return void t._displayModeHandler("list" === t.displayModeView ? t.$.listViewContainer.getItem(t.$.listViewContainer.selectedValues[0]) : t._focusedCell);
          break;

        case "Control":
        case "Shift":
          return "default" === t.selectionMode && (t._keysPressed[e.key] = !0), void ("range" === t.selectionMode && (t._keysPressed[e.key] = "Control" === e.key));

        case "Home":
        case "End":
          {
            e.preventDefault();

            var _i720 = function _i720(t) {
              if ("Home" === e.key) {
                for (var _e837 = 0; _e837 < t.length; _e837++) {
                  if (!t[_e837].otherMonth && (!t[_e837].disabled || !t[_e837].restricted) && t[_e837].offsetHeight) return t[_e837];
                }
              } else for (var _e838 = t.length - 1; 0 <= _e838; _e838--) {
                if (!t[_e838].otherMonth && (!t[_e838].disabled || !t[_e838].restricted) && t[_e838].offsetHeight) return t[_e838];
              }
            },
                _a459;

            if (_a459 = "month" === t.displayMode ? _i720(t._getMonthCells(t._focusedCell.closest(".smart-calendar-month"), t.rightToLeft)) : _i720(t.$.dateViewContainer.children), !_a459) return;
            if (t._focusCell(_a459), "month" !== t.displayMode) return;
            break;
          }

        case "PageUp":
        case "PageDown":
          {
            if (!t._handlePageUpDownKeys(e, a)) return;
            break;
          }

        default:
          return;
      }

      t._focusedCell && t._handleDateSelection(t._focusedCell);
    }
  }, {
    key: "_handleArrowKeys",
    value: function _handleArrowKeys(e, t, i) {
      var a = this;
      var n;

      if ("month" !== a.displayMode || a._animationStarted || a.$.body.focus(), a._focusedCell || a._focusCell(a._getCellByDate(new Date())), !e.altKey) {
        if (e.ctrlKey) {
          if ("ArrowDown" === e.key || "ArrowUp" === e.key) {
            if ("classic" === a.calendarMode) return;

            var _t729;

            switch (a.displayMode) {
              case "month":
                _t729 = "ArrowDown" === e.key ? "month" : "year";
                break;

              case "year":
                _t729 = "ArrowDown" === e.key ? "month" : "decade";
                break;

              case "decade":
                _t729 = "ArrowDown" === e.key ? "year" : "decade";
            }

            if (_t729 !== a.displayMode) {
              var _e839 = a.displayMode;
              a.displayMode = _t729, a._setDisplayMode(_e839, _t729, "month" === _e839), a._keysPressed && delete a._keysPressed.Control;
            }
          }

          return;
        }

        if (e.preventDefault(), a.rightToLeft && ("ArrowLeft" === e.key || "ArrowRight" === e.key) && (i *= -1), "month" !== a.displayMode) {
          var _o248 = a._animationStarted ? a.$.nextMonthsContainer.children : a.$.dateViewContainer.children;

          if (t = "ArrowUp" === e.key || "ArrowDown" === e.key ? 4 : 1, "year" === a.displayMode) {
            var _e840 = a._focusedCell.value.getMonth() + i * t;

            var _o249 = new Date(a._focusedCell.value.getFullYear(), _e840 + 1, 0);

            a._focusedCell.value.getDate() <= _o249.getDate() && (_o249 = a._focusedCell.value), n = new Date(a._focusedCell.value.getFullYear(), _e840, _o249.getDate());
          } else n = new Date(a._focusedCell.value.getFullYear() + i * t, a._focusedCell.value.getMonth(), a._focusedCell.value.getDate());

          if ("year" === a.displayMode) {
            if (n.getFullYear() < a.min.getFullYear() || n.getFullYear() === a.min.getFullYear() && n.getMonth() < a.min.getMonth() || n.getFullYear() > a.max.getFullYear() || n.getFullYear() === a.max.getFullYear() && n.getMonth() > a.max.getMonth()) return;
            n.getTime() > _o248[_o248.length - 1].value.getTime() ? a.navigate(1) : n.getTime() < _o248[0].value.getTime() && a.navigate(-1);
          } else {
            if (n.getFullYear() < a.min.getFullYear() || n.getFullYear() > a.max.getFullYear()) return;

            if (n.getFullYear() < _o248[1].value.getFullYear() || n.getFullYear() > _o248[10].value.getFullYear()) {
              var _t730 = a._focusedCell;
              a.navigate(i), ("ArrowUp" === e.key || "ArrowDown" === e.key) && (_t730 === _o248[3] || _t730 === _o248[4] || _t730 === _o248[7] || _t730 === _o248[8] ? n.setFullYear(n.getFullYear() + 2 * i) : n.setFullYear(n.getFullYear() - 2 * i));
            }
          }

          return void a._focusCell(a._getCellByDate(n, a._animationStarted ? a.$.nextMonthsContainer : void 0));
        }

        var _o247 = a.restrictedDates.map(Number);

        for (n = new Date(a._focusedCell.value.getFullYear(), a._focusedCell.value.getMonth(), a._focusedCell.value.getDate() + i * t, 0, 0, 0, 0); -1 < _o247.indexOf(n.getTime());) {
          n.setDate(n.getDate() + i);
        }

        if (!(n.getTime() < a.min.getTime() || n.getTime() > a.max.getTime())) {
          a._isDateInView(n) || a.navigate(i * a.months);

          var _e841 = a._getCellByDate(n, a._animationStarted ? a.$.nextMonthsContainer : void 0);

          return a._focusCell(_e841), a._updateWeeksVisibility(i), !(-1 < ["zeroOrMany", "oneOrMany", "none", "many", "week", "range"].indexOf(a.selectionMode)) || void 0;
        }
      }
    }
  }, {
    key: "_handlePageUpDownKeys",
    value: function _handlePageUpDownKeys(e, t) {
      var i = this;
      e.preventDefault();
      var a;

      if ("month" !== i.displayMode) {
        if (a = i._focusedCell, !i.navigate(t)) return;

        for (; a && a.classList.contains("smart-visibility-hidden");) {
          a = null === a.previousElementSibling ? a.nextElementSibling : a.previousElementSibling;
        }

        return i._focusCell(a), void (i.hasAnimation && "decade" === i.displayMode && i._focusedCell.value.setFullYear(i._focusedCell.value.getFullYear() + 10 * t));
      }

      a = new Date(i._focusedCell.value.getFullYear(), i._focusedCell.value.getMonth() + t, 1, 0, 0, 0, 0);
      var n = new Date(a.getFullYear(), a.getMonth() + 1, 0).getDate();
      return i._focusedCell.value.getDate() > n ? a.setDate(n) : a.setDate(i._focusedCell.value.getDate()), i._isDateInView(a) || i.navigate(a), i._animationStarted ? i._focusCell(i._getCellByDate(a, i.$.nextMonthsContainer)) : i._focusCell(i._getCellByDate(a)), !0;
    }
  }, {
    key: "_selectDate",
    value: function _selectDate(e, t, i) {
      var a = this;
      if ("undefined" == typeof a._viewDates || "none" === a.selectionMode) return;

      var n = a.selectedDates.slice(0),
          o = a._getCellByDate(e, a._animationStarted ? a.$.nextMonthsContainer : void 0);

      o && a._selectCell(o);
      var r;
      e = new Date(e), e.setHours(0, 0, 0, 0), r = n.map(Number).indexOf(e.getTime());
      -1 < a.restrictedDates.map(Number).indexOf(e.getTime()) || e.getTime() < a.min.getTime() || e.getTime() > a.max.getTime() || (-1 < r ? n.splice(r, 1) : n.push(e), !i && (a.selectedDates = n), a._refreshFooter(), a.$.hiddenInput.value = a.selectedDates.toString(), !t && a.$.fireEvent("change", {
        value: [e]
      }), a._refreshTitle());
    }
  }, {
    key: "_selectCell",
    value: function _selectCell(e) {
      var t = this;

      if (!(!e || -1 < t.restrictedDates.map(Number).indexOf(e.value.getTime()) || t.disableAutoNavigation && !1 === e.otherMonth || e.value.getTime() < t.min.getTime() || e.value.getTime() > t.max.getTime())) {
        var _i721 = t._selectedCells.indexOf(e);

        -1 < _i721 ? (t._setCellState(e, "selected", !1), t._selectedCells.splice(_i721, 1)) : (t._setCellState(e, "selected", !0), t._selectedCells.push(e)), t._focusCell(e);
      }
    }
  }, {
    key: "_refreshDayOfWeekTitles",
    value: function _refreshDayOfWeekTitles() {
      function e(e) {
        var i;
        return "firstTwoLetters" === t.dayNameFormat ? (i = new Intl.DateTimeFormat(t.locale, {
          weekday: "long"
        }).format(e), i = 8206 === i.charCodeAt(0) ? i.substring(1, 3) : i.substring(0, 2)) : i = new Intl.DateTimeFormat(t.locale, {
          weekday: t.dayNameFormat
        }).format(e), i;
      }

      var t = this;
      var a = [],
          n = new Date(),
          o;

      for (var _t731 = 1; 8 > _t731; _t731++) {
        n.setDate(_t731), o = {
          number: n.getDay(),
          name: e(n)
        }, a.push(o);
      }

      a.sort(function (e, t) {
        return e.number > t.number ? 1 : -1;
      });
      var i = t.$.monthsContainer.children;
      var r, l;

      for (var _e842 = 0; _e842 < i.length; _e842++) {
        if (r = i[_e842].getElementsByClassName("smart-calendar-week-titles")[0].children, l = 6 < t.firstDayOfWeek ? 0 : t.firstDayOfWeek, t.rightToLeft) for (var _e843 = r.length - 1; 1 <= _e843; _e843--) {
          r[_e843].textContent = a[l++].name, l = 6 < l ? 0 : l;
        } else for (var _e844 = 1; _e844 < r.length; _e844++) {
          r[_e844].textContent = a[l++].name, l = 6 < l ? 0 : l;
        }
      }

      if (t.hasAnimation) {
        var _e845 = t.$.monthsContainer.getElementsByClassName("smart-calendar-week-titles")[0].innerHTML,
            _a460 = t.$.nextMonthsContainer.getElementsByClassName("smart-calendar-week-titles");

        for (var _t732 = 0; _t732 < _a460.length; _t732++) {
          _a460[_t732].innerHTML = _e845;
        }
      }
    }
  }, {
    key: "_refreshCalendarMode",
    value: function _refreshCalendarMode() {
      var e = this;
      if (!e.headerTemplate) if (e._refreshMonthNames(), "default" === e.calendarMode) {
        e.$classicHeaderDate.addClass("smart-hidden"), e.$defaultHeaderDate.removeClass("smart-hidden");

        var _t733 = e._viewDates.slice(0).sort(function (e, t) {
          return e.getTime() - t.getTime();
        }),
            _i722 = _t733[0],
            _a461 = _t733[_t733.length - 1];

        _i722.setDate(2);

        var _n347 = _i722.toLocaleDateString(e.locale, {
          year: e.yearFormat,
          month: e.monthNameFormat
        });

        1 < e.months && (_a461.setDate(2), _n347 += " - " + _a461.toLocaleDateString(e.locale, {
          year: e.yearFormat,
          month: e.monthNameFormat
        })), e.$.defaultHeaderDate.innerHTML = _n347, e.unfocusable || e.$.dateElement.setAttribute("tabindex", 0 < e.tabIndex ? e.tabIndex : 0);
      } else e.$defaultHeaderDate.addClass("smart-hidden"), e.$classicHeaderDate.removeClass("smart-hidden"), e.$.dateElement.removeAttribute("tabindex");
    }
  }, {
    key: "_refreshFooter",
    value: function _refreshFooter() {
      function e() {
        if (0 === t.selectedDates.length) return "";
        if (1 === t.selectedDates.length) return t.selectedDates[0].toLocaleDateString(t.locale, {
          year: t.yearFormat,
          weekday: "short",
          month: "short",
          day: "numeric"
        });else {
          var _e846 = t.selectedDates.slice(0).sort(function (e, t) {
            return e.getTime() - t.getTime();
          });

          return _e846[0].toLocaleDateString(t.locale, {
            year: t.yearFormat,
            weekday: "short",
            month: "short",
            day: "numeric"
          }) + " - " + _e846[_e846.length - 1].toLocaleDateString(t.locale, {
            year: t.yearFormat,
            weekday: "short",
            month: "short",
            day: "numeric"
          });
        }
      }

      var t = this;

      if (!(0 > t.viewSections.indexOf("footer") || 0 === t.$.footer.offsetHeight)) {
        if (t.footerTemplate) {
          if ("function" == typeof t.footerTemplate) return;

          var _i723 = t._layoutTemplates.filter(function (e) {
            return e.selector === t.$.footer;
          })[0],
              _a462 = document.importNode(_i723.template.content, !0);

          if (0 < _i723.bindings.length) {
            var _t734 = _a462.childNodes[_i723.bindings[0].childNodeIndex];
            _i723.selector.childNodes[_i723.bindings[0].childNodeIndex].innerHTML = _t734.innerHTML.replace(_i723.bindings[0].bindingString, e());
          }

          return;
        }

        t.$.selectedDatesRange.innerHTML = e();
      }
    }
  }, {
    key: "_refreshImportantDates",
    value: function _refreshImportantDates() {
      var e = this;

      if ("month" === e.displayMode) {
        e._clearImportantDates();

        for (var _t735 = 0; _t735 < e.importantDates.length; _t735++) {
          e._setImportantDate(e.importantDates[_t735]);
        }
      }
    }
  }, {
    key: "_clearImportantDates",
    value: function _clearImportantDates() {
      var e = this,
          t = e.$.monthsContainer.children;

      for (var _i724 = 0; _i724 < t.length; _i724++) {
        e._getMonthCells(t[_i724]).map(function (t) {
          e._setCellState(t, "important", !1);
        });
      }
    }
  }, {
    key: "_setImportantDate",
    value: function _setImportantDate(e, t) {
      var i = this,
          a = i._getCellByDate(e);

      t || (t = a), t && (i._setCellState(t, "important", !0), i._applyImportantDateTemplate(t));
    }
  }, {
    key: "_applyImportantDateTemplate",
    value: function _applyImportantDateTemplate(e) {
      var t = this;
      if (!t._importantDatesTemplate) return "function" == typeof t.importantDatesTemplate ? void t.importantDatesTemplate(e, {
        value: e.value
      }) : void (e.innerHTML = e.value.getDate() + "");
      var a = document.importNode(t._importantDatesTemplate.content, !0);

      if (t._bindingDetails && 0 < t._bindingDetails.length) {
        var _i725 = a.childNodes[t._bindingDetails[0].childNodeIndex];
        _i725.innerHTML = _i725.innerHTML.replace(t._bindingDetails[0].bindingString, e.value.getDate());
      }

      e.innerHTML = "";

      for (var _t736 = 0; _t736 < a.childNodes.length; _t736++) {
        a.childNodes[_t736].outerHTML && (e.innerHTML += a.childNodes[_t736].outerHTML);
      }
    }
  }, {
    key: "_setMonth",
    value: function _setMonth(e, t, i) {
      var a = this,
          n = a._getDays(e, a.selectedDates),
          o = a._getDays(e, a.importantDates),
          r = a._getDays(e, a.restrictedDates);

      e.setDate(1), t || (t = a.$.month), t._date = new Date(e), i || ((!a._viewDates || a._viewDates.length >= a.months) && (a._viewDates = []), a._viewDates.push(new Date(e))), e = new Date(e);
      var l = (e.getDay() - a.firstDayOfWeek + 7) % 7;
      e.setDate(0);
      var s = e.getDate();
      if (e.setDate(32), e.setDate(1), e.setDate(32), a._selectedCells) for (var _e847 = 0; _e847 < a._selectedCells.length; _e847++) {
        a._selectedCells[_e847].closest(".smart-calendar-month") === t && a._setCellState(a._selectedCells[_e847], "selected", !1);
      }

      a._setMonthContent(e, t, {
        previusMonthDays: s,
        firstDayOfWeek: l,
        selectedDates: n,
        importantDates: o,
        restrictedDates: r
      });
    }
  }, {
    key: "_setMonthContent",
    value: function _setMonthContent(e, t, i) {
      var a = this,
          n = 32 - e.getDate(),
          o = a._getMonthCells(t, a.rightToLeft),
          r = t._date.getMonth(),
          l = t._date.getFullYear(),
          s = new Date();

      var c = 1,
          m = 1,
          u;
      s.setHours(0, 0, 0, 0), o.map(function (e) {
        a._setCellState(e, "restricted", !1), a._setCellState(e, "selected", !1), a._setCellState(e, "otherMonth", !1), a._setCellState(e, "focus", !1), a._setCellState(e, "important", !1), a._setCellState(e, "today", !1), a._setCellState(e, "disabled", !1), a._setCellState(e, "hover", !1);
      });

      for (var p = 0; p < o.length; p++) {
        var _e848 = o[p];
        p === i.firstDayOfWeek && m <= n ? (_e848.className = "smart-calendar-cell", _e848.value = new Date(l, r, m), _e848.innerHTML = _e848.value.getDate().toString(), -1 < i.restrictedDates.indexOf(m) || _e848.value.getTime() < a.min.getTime() || _e848.value.getTime() > a.max.getTime() ? a._setCellState(_e848, "restricted", !0) : -1 < i.selectedDates.indexOf(m) && (a._setCellState(_e848, "selected", !0), 0 > a._selectedCells.indexOf(_e848) && a._selectedCells.push(_e848)), -1 < i.importantDates.indexOf(m) && (a._setImportantDate(_e848.value, _e848), i.importantDates.splice(i.importantDates.indexOf(m), 1)), _e848.value.getTime() === s.getTime() && a._setCellState(_e848, "today", !0), i.firstDayOfWeek++, m++) : (1 == m ? (_e848.value = new Date(l, r - 1, ++i.previusMonthDays - i.firstDayOfWeek), u = !!(_e848.value.getTime() < a.min.getTime() || t.previousElementSibling)) : (_e848.value = new Date(l, r + 1, c++), u = !!(_e848.value.getTime() > a.max.getTime() || t.nextElementSibling)), _e848.innerHTML = _e848.value.getDate().toString(), u ? _e848.classList.add("smart-visibility-hidden") : (a._setCellState(_e848, "otherMonth", !0), _e848.classList.remove("smart-visibility-hidden")));
      }

      1 < a.months && (t.firstElementChild.innerHTML = a.dateFormatFunction ? a.dateFormatFunction(t._date) : a._monthsNames[r] + " " + t._date.toLocaleDateString(a.locale, {
        year: a.yearFormat
      })), a._setMonthWeekNumbers(t);
    }
  }, {
    key: "_refreshMonthNames",
    value: function _refreshMonthNames() {
      function e(e) {
        var i = new Intl.DateTimeFormat(t.locale, {
          month: t.monthNameFormat
        }).format(e);
        return "firstTwoLetters" === t.monthNameFormat && (i = 8206 === i.charCodeAt(0) ? i.substring(0, 2) : i.substring(1, 3)), i;
      }

      var t = this;
      var i = new Date(),
          a;
      i.setDate(1), t._monthsNames = [];

      for (var _n348 = 0; 12 > _n348; _n348++) {
        i.setMonth(_n348), a = e(i), t._monthsNames.push(a);
      }

      if ("classic" === t.calendarMode && t.$.monthElement) {
        var _e849 = t.$.monthsContainer.children;

        if (t.$.monthElement.dataSource && (t._changeEventFired = 1), t.shadowRoot ? t._setMonthElementPropertyInShadowDOM("dataSource", t._monthsNames) : t.$.monthElement.dataSource = t._monthsNames, t._viewDates) {
          for (var _i726 = 0; _i726 < _e849.length; _i726++) {
            _e849[_i726].firstElementChild.textContent = t._monthsNames[_e849[_i726]._date.getMonth()] + " " + _e849[_i726]._date.getFullYear();
          }

          t._changeEventFired = 1, t.shadowRoot ? t._setMonthElementPropertyInShadowDOM("selectedIndexes", t._viewDates.map(function (e) {
            return e.getMonth();
          })) : t.$.monthElement.selectedIndexes = t._viewDates.map(function (e) {
            return e.getMonth();
          });
        }
      }
    }
  }, {
    key: "_setMonthWeekNumbers",
    value: function _setMonthWeekNumbers(e) {
      var t = this,
          i = function i(e) {
        for (var _t737 = 1; _t737 < e.children.length; _t737++) {
          if (!e.children[_t737].classList.contains("smart-visibility-hidden")) return !0;
        }
      };

      var a = e.getElementsByClassName("smart-calendar-week");
      a = [].slice.call(a);

      for (var _n349 = 0; _n349 < a.length; _n349++) {
        if (!i(a[_n349])) {
          a[_n349].children[0].innerHTML = "";
          continue;
        }

        var _o250 = a[_n349].children[1],
            _r158 = _o250.otherMonth ? _o250.value.getTime() > e._date.getTime() ? 1 : -1 : 0;

        a[_n349].children[0].innerHTML = t._getWeekNumber(new Date(e._date.getFullYear(), e._date.getMonth() + _r158, _o250.value.getDate()));
      }
    }
  }, {
    key: "_setRestrictedDates",
    value: function _setRestrictedDates(e) {
      var t = this,
          i = t.$.monthsContainer.children;

      for (var _a463 = 0; _a463 < i.length; _a463++) {
        t._getMonthCells(i[_a463]).map(function (e) {
          t._setCellState(e, "restricted", !1);
        });
      }

      if (t._viewDates) {
        var _a464 = function _a464(e) {
          for (var _a465 = 0; _a465 < t._viewDates.length; _a465++) {
            if (t._viewDates[_a465].getFullYear() === e.getFullYear() && t._viewDates[_a465].getMonth() === e.getMonth()) return !0;
          }
        };

        for (var _n350 = 0; _n350 < e.length; _n350++) {
          if (_a464(e[_n350])) {
            var _i727 = t._getCellByDate(e[_n350]);

            t._setCellState(_i727, "restricted", !0);
          }
        }
      }
    }
  }, {
    key: "_setScrollButtonsNavigationMode",
    value: function _setScrollButtonsNavigationMode() {
      var e = this;
      "landscape" === e.scrollButtonsNavigationMode ? (e.$.previousMonthButton && (e.$.previousMonthButton.$.button.firstElementChild.className = "smart-arrow-left smart-arrow"), e.$.nextMonthButton && (e.$.nextMonthButton.$.button.firstElementChild.className = "smart-arrow-right smart-arrow")) : (e.$.previousMonthButton && (e.$.previousMonthButton.$.button.firstElementChild.className = "smart-arrow-down smart-arrow"), e.$.nextMonthButton && (e.$.nextMonthButton.$.button.firstElementChild.className = "smart-arrow-up smart-arrow")), e._applyAnimationSettings(!0);
    }
  }, {
    key: "_refreshTitle",
    value: function _refreshTitle() {
      var e = this;
      var t = 0 < e.selectedDates.length ? e.selectedDates[e.selectedDates.length - 1] : new Date();

      if (e.titleTemplate) {
        if ("function" == typeof e.titleTemplate) return;

        var _i728 = e._layoutTemplates.filter(function (t) {
          return t.selector === e.$.title;
        })[0],
            _a466 = document.importNode(_i728.template.content, !0);

        if (0 < _i728.bindings.length) {
          var _n351 = _a466.childNodes[_i728.bindings[0].childNodeIndex];
          return t = t.toLocaleDateString(e.locale, {
            year: e.yearFormat,
            weekday: "short",
            month: "short",
            day: "numeric"
          }), void (_i728.selector.childNodes[_i728.bindings[0].childNodeIndex].innerHTML = _n351.innerHTML.replace(_i728.bindings[0].bindingString, t));
        }
      }

      e.$.title.children[0].innerHTML = t.toLocaleDateString(e.locale, {
        year: e.yearFormat
      }), e.$.title.children[1].innerHTML = "landscape" === e.view ? t.toLocaleDateString(e.locale, {
        weekday: "short"
      }) + ",</br>" + t.toLocaleDateString(e.locale, {
        month: "short",
        day: "numeric"
      }) : t.toLocaleDateString(e.locale, {
        weekday: "short"
      }) + ", " + t.toLocaleDateString(e.locale, {
        month: "short",
        day: "numeric"
      });
    }
  }, {
    key: "_setWeeksVisibility",
    value: function _setWeeksVisibility(e) {
      function t(e) {
        return function (e) {
          for (var _t738 = 1; _t738 < e.children.length; _t738++) {
            if (!e.children[_t738].classList.contains("smart-visibility-hidden")) return !1;
          }

          return !0;
        }(e) || n >= i.weeks ? void e.classList.add("smart-hidden") : void (n < i.weeks && (e.classList.remove("smart-hidden"), n++));
      }

      var i = this,
          a = e.children;
      var n;

      var _loop31 = function _loop31(_o251) {
        var e = a[_o251];
        var r = e.getElementsByClassName("smart-calendar-week");
        r = [].slice.call(r);

        var l = i._selectedCells.filter(function (e) {
          return e.closest(".smart-calendar-month") === a[_o251];
        });

        if (6 === i.weeks) {
          r.map(function (e) {
            return e.classList.remove("smart-hidden");
          });
          return "continue";
        }

        if (n = 0, 0 < l.length) {
          var _e850 = l[l.length - 1],
              _a467 = r.indexOf(_e850.parentElement);

          for (var _e851 = _a467; _e851 < r.length; _e851++) {
            t(r[_e851]);
          }

          for (var _e852 = _a467 - 1; 0 <= _e852; _e852--) {
            t(r[_e852]);
          }
        } else for (var _e853 = 0; _e853 < r.length; _e853++) {
          t(r[_e853]);
        }
      };

      for (var _o251 = 0; _o251 < a.length; _o251++) {
        var _ret11 = _loop31(_o251);

        if (_ret11 === "continue") continue;
      }
    }
  }, {
    key: "_refreshHeaderElements",
    value: function _refreshHeaderElements() {
      var e = this,
          t = document.activeElement.closest("smart-calendar") === e,
          i = e._animationStarted ? e.$.nextMonthsContainer : e.$.dateViewContainer;

      var a = e._viewDates[e._viewDates.length - 1],
          n = e._viewDates.map(function (e) {
        return e.getFullYear();
      }),
          o,
          r;

      if ("month" === e.displayMode || "list" !== e.displayModeView) {
        if (e.$.previousMonthButton && !e.disabled && ("month" !== e.displayMode && e.$.dateViewContainer.children[0].value ? r = "year" === e.displayMode ? i.children[0].value.getFullYear() - 1 : i.children[1].value.getFullYear() - 1 : 0 > e._viewDates[0].getMonth() - 1 ? (o = 11, r = e._viewDates[0].getFullYear() - 1) : (o = e._viewDates[0].getMonth() - 1, r = e._viewDates[0].getFullYear()), e.$.previousMonthButton.disabled = !!(r < e.min.getFullYear() || r === e.min.getFullYear() && o < e.min.getMonth()), e.$.previousMonthButton.disabled && t && e.$.body.focus()), e.$.nextMonthButton && !e.disabled && ("month" !== e.displayMode && e.$.dateViewContainer.children[0].value ? r = "year" === e.displayMode ? i.children[0].value.getFullYear() + 1 : i.children[1].value.getFullYear() + 11 : 11 < a.getMonth() + 1 ? (o = 0, r = a.getFullYear() + 1) : (o = a.getMonth() + 1, r = a.getFullYear()), e.$.nextMonthButton.disabled = !!(r > e.max.getFullYear() || r === e.max.getFullYear() && o > e.max.getMonth()), e.$.nextMonthButton.disabled && t && e.$.body.focus()), "classic" === e.calendarMode && e.$.monthElement) {
          var _t739 = e.$.monthElement.items;
          if (_t739.map(function (e) {
            return e.disabled = !1;
          }), -1 < n.indexOf(e.min.getFullYear())) for (var _a468 = 0; _a468 < e.min.getMonth(); _a468++) {
            _t739[_a468].disabled = !0;
          }
          if (-1 < n.indexOf(e.max.getFullYear())) for (var _a469 = e.max.getMonth() + 1; _a469 < _t739.length; _a469++) {
            _t739[_a469].disabled = !0;
          }
          e._changeEventFired = e.$.monthElement.selectedIndexes.length, e.shadowRoot ? e._setMonthElementPropertyInShadowDOM("selectedIndexes", [e._viewDates[0].getMonth()]) : e.$.monthElement.selectedIndexes = [e._viewDates[0].getMonth()], e._changeEventFired = 0;
        }

        e.$.previousYearButton && !e.disabled && (r = e._viewDates[0].getFullYear() - 1, e.$.previousYearButton.disabled = !!(r < e.min.getFullYear()), e.$.previousYearButton.disabled && t && e.$.body.focus()), e.$.nextYearButton && !e.disabled && (r = a.getFullYear() + 1, e.$.nextYearButton.disabled = !!(r > e.max.getFullYear()), e.$.nextYearButton.disabled && t && e.$.body.focus()), e.$.yearElement && (e.$.yearElement.value = n[0], e.$.yearElement.disabled = !!(a.getFullYear() + 1 > e.max.getFullYear() && e._viewDates[0].getFullYear() - 1 < e.min.getFullYear()));
      }
    }
  }, {
    key: "_setMonthElementPropertyInShadowDOM",
    value: function _setMonthElementPropertyInShadowDOM(e, t) {
      var i = this,
          a = i.$.monthElement,
          n = i.$.monthElement.$ ? i.$.monthElement.$.listBox : void 0,
          o = a.context;
      var r;
      a.context = document, n && (r = n.context, n.context = document), i.$.monthElement[e] = t, a.context = o, n && (n.context = r);
    }
  }, {
    key: "_refreshHeaderTitle",
    value: function _refreshHeaderTitle() {
      function e() {
        if ("month" !== t.displayMode) {
          if ("list" === t.displayModeView && t.$.listViewContainer.selectedValues[0]) {
            var _e854 = t.$.listViewContainer.items;
            i = "year" === t.displayMode ? new Date(t.$.listViewContainer.getItem(t.$.listViewContainer.selectedValues[0]).value).getFullYear() : new Date(_e854[0].value).getFullYear() + " - " + new Date(_e854[_e854.length - 1].value).getFullYear();
          } else if (t.$.dateViewContainer.children[0].value) {
            var _e855 = t._animationStarted ? t.$.nextMonthsContainer.children : t.$.dateViewContainer.children;

            i = "year" === t.displayMode ? _e855[0].value.getFullYear() : _e855[1].value.getFullYear() + " - " + _e855[_e855.length - 2].value.getFullYear();
          }

          if (i) return i;
        }

        var e = t._viewDates.slice(0).sort(function (e, t) {
          return e.getTime() - t.getTime();
        }),
            a = e[0],
            n = e[e.length - 1];

        return a.setDate(2), i = a.toLocaleDateString(t.locale, {
          year: t.yearFormat,
          month: t.monthNameFormat
        }), 1 < t.months && (n.setDate(2), i += " - " + n.toLocaleDateString(t.locale, {
          year: t.yearFormat,
          month: t.monthNameFormat
        })), i;
      }

      var t = this;
      var i;

      if ("default" === t.calendarMode && (t.$.defaultHeaderDate.innerHTML = e()), "function" != typeof t.headerTemplate && t._layoutTemplates) {
        var _i729 = t._layoutTemplates.filter(function (e) {
          return e.selector === t.$.header;
        })[0];

        if (_i729) {
          var _a470 = document.importNode(_i729.template.content, !0);

          if (0 < _i729.bindings.length) {
            var _n352 = _a470.childNodes[_i729.bindings[0].childNodeIndex];
            (t.shadowRoot ? t : _i729.selector).childNodes[_i729.bindings[0].childNodeIndex].innerHTML = _n352.innerHTML.replace(_i729.bindings[0].bindingString, t.dateFormatFunction ? t.dateFormatFunction(t._viewDates) : e());
          }
        }
      }
    }
  }, {
    key: "_updateWeeksVisibility",
    value: function _updateWeeksVisibility(e, t) {
      function i() {
        for (var _e856 = l; _e856 < r.length; _e856++) {
          if (r[_e856].classList.contains("smart-hidden") && !s(r[_e856]) && (r[_e856].classList.remove("smart-hidden"), d++, d === n.weeks)) return !0;
        }
      }

      function a() {
        for (var _e857 = l; 0 <= _e857; --_e857) {
          if (r[_e857].classList.contains("smart-hidden") && !s(r[_e857]) && (r[_e857].classList.remove("smart-hidden"), d++, d === n.weeks)) return !0;
        }
      }

      var n = this;
      var o = (t || n._focusedCell).parentElement;
      if (!t && !o.classList.contains("smart-hidden")) return;

      var r = [].slice.call(o.parentElement.children),
          l = r.indexOf(o),
          s = function s(e) {
        for (var _t740 = 1; _t740 < e.children.length; _t740++) {
          if (!e.children[_t740].classList.contains("smart-visibility-hidden")) return !1;
        }

        return !0;
      };

      var d = 0;

      if (r.map(function (e) {
        return e.classList.add("smart-hidden");
      }), 0 < e) {
        if (i()) return;
        a();
      } else {
        if (a()) return;
        i();
      }
    }
  }, {
    key: "_getValidDates",
    value: function _getValidDates(e) {
      function t(e) {
        if (e instanceof Date) return e;
        if (Smart.Utilities.DateTime && e instanceof Smart.Utilities.DateTime) return e.toDate();

        if ("string" == typeof e) {
          if ("new Date()" === e.trim() || "new Smart.Utilities.DateTime()" === e.trim()) return new Date();
          var _t741 = /(\d+[,-.\/]{1}\s*\d+[,-.\/]{1}\s*\d+)/;

          var _i730 = function _i730() {
            if (e = e.replace(/[,-.\/]/g, ",").split(","), 2 < e.length) e = new Date(parseInt(e[0]), parseInt(e[1]) - 1, parseInt(e[2]));else return new Date();
            return e;
          };

          return _t741.test(e) ? (e = _t741.exec(e)[0].replace(/[,-.\/]/g, ",").split(","), e ? new Date(parseInt(e[0]), parseInt(e[1]) - 1, parseInt(e[2])) : _i730()) : _i730();
        }
      }

      var a = [];
      if (void 0 === e) return null;
      if (Array.isArray(e)) for (var _n353 = 0; _n353 < e.length; _n353++) {
        a.push(t(e[_n353]));
      } else a.push(t(e));
      return a = a.filter(function (e) {
        return e && "Invalid Date" !== e.toDateString();
      }), a.map(function (e) {
        return e.setHours(0, 0, 0, 0);
      }), a;
    }
  }, {
    key: "_getValidDate",
    value: function _getValidDate(e) {
      var t = this,
          i = t._getValidDates(e);

      return 0 < i.length ? i[0] : null;
    }
  }, {
    key: "_validateSelectedDates",
    value: function _validateSelectedDates(e) {
      var t = this;
      var i = [];
      e || (e = t.selectedDates);

      var a = e.slice(0),
          n = function n(e) {
        for (var _i731 = 0; _i731 < t.restrictedDates.length; _i731++) {
          if (t.restrictedDates[_i731].getTime() === e.getTime()) return !0;
        }
      };

      t.selectedDates = a.filter(function (e) {
        return !!(e.getTime() >= t.min.getTime() && e.getTime() <= t.max.getTime() && !n(e)) || void i.push(e);
      }), t._viewDates && (i.map(function (e) {
        return t._selectDate(e);
      }), t._focusCell());
    }
  }, {
    key: "_validateMinMax",
    value: function _validateMinMax(e, t, i) {
      var a = this;

      switch (e) {
        case "min":
          t = a._getValidDate(a[e]), a.min = t ? t : i ? i : a.properties.min.defaultValue;
          break;

        case "max":
          t = a._getValidDate(a[e]), a.max = t ? t : i ? i : a.properties.max.defaultValue;
          break;

        default:
          t = a._getValidDate(a.min), a.min = t ? t : i ? i : a.properties.min.defaultValue, t = a._getValidDate(a.max), a.max = t ? t : i ? i : a.properties.max.defaultValue;
      }

      a.min = a.min.getTime() > a.max.getTime() ? a.max : a.min, a.min.setHours(0, 0, 0, 0), a.max.setHours(0, 0, 0, 0);
      var n = a.$.monthsContainer.children,
          o;

      if (a._viewDates) {
        if (a._viewDates[0].getTime() > a.max.getTime() || a._viewDates[0].getTime() < a.min.getTime()) return void a._handleMonths();

        for (var _e858 = 0; _e858 < n.length; _e858++) {
          o = a._getMonthCells(n[_e858]);

          for (var _t742 = 0; _t742 < o.length; _t742++) {
            var _i732 = o[_t742];
            if (_i732.value.getTime() >= a.min.getTime() && _i732.value.getTime() <= a.max.getTime()) a._setCellState(_i732, "restricted", !1), _i732.value.getMonth() === n[_e858]._date.getMonth() ? _i732.classList.remove("smart-visibility-hidden") : !a.hideOtherMonthDays && (a._setCellState(_i732, "otherMonth", !0), _i732.classList.remove("smart-visibility-hidden")), "month" !== a.displayMode && a._setCellState(_i732, "otherMonth", !1);else {
              if (!_i732.otherMonth) a._setCellState(_i732, "restricted", !0);else if (_i732.classList.contains("smart-visibility-hidden")) {
                a._setCellState(_i732, "restricted", !1);

                continue;
              }
              "month" !== a.displayMode && (_i732.classList.remove("smart-visibility-hidden"), a._setCellState(_i732, "otherMonth", !0));
            }
          }
        }
      }
    }
  }, {
    key: "_setCellState",
    value: function _setCellState(e, t, i) {
      e[t] = i;
      var a = Smart.Utilities.Core.toDash(t);
      i ? (e.setAttribute(a, ""), "selected" === t ? e.setAttribute("aria-selected", !0) : "today" === t ? e.setAttribute("aria-current", "date") : "restricted" === t ? e.removeAttribute("aria-selected") : "disabled" == t && (e.removeAttribute("aria-selected"), e.setAttribute("aria-disabled", !0))) : (e.removeAttribute(a), "selected" === t ? "none" === this.selectionMode || e.restricted || e.disabled ? e.removeAttribute("aria-selected") : e.setAttribute("aria-selected", !1) : "today" === t ? e.removeAttribute("aria-current") : "restricted" !== t || e.disabled ? "disabled" === t && (e.removeAttribute("aria-disabled"), !e.restricted && e.setAttribute("aria-selected", !1)) : e.setAttribute("aria-selected", !1));
    }
  }, {
    key: "_validateTemplate",
    value: function _validateTemplate(e, t) {
      if (null !== t && t && "function" != typeof t) {
        var _i733 = this;

        return "content" in document.createElement("template") ? ("string" == typeof t && (t = document.getElementById(t)), null !== t && "content" in t ? t : void _i733.error(_i733.localize("invalidTemplate", {
          elementType: _i733.nodeName.toLowerCase(),
          property: e
        }))) : void _i733.error(_i733.localize("htmlTemplateNotSuported", {
          elementType: _i733.nodeName.toLowerCase()
        }));
      }
    }
  }, {
    key: "_weeksDownHandler",
    value: function _weeksDownHandler(e, t) {
      var i = this,
          a = t.value;
      var n;
      return (t.otherMonth && (n = t.value.getTime() > t.closest(".smart-calendar-month")._date.getTime() ? 1 : -1), a && i.hasRippleAnimation && Smart.Utilities.Animation.Ripple.animate(t, e.pageX, e.pageY), n) ? i._isDateInView(a) ? void 0 : void (i.disableAutoNavigation || i.navigate(n * i.months)) : void (t = i._getCellByDate(a), t && (t.disabled || t.restricted) || i._handleDateSelection(t));
    }
  }, {
    key: "_firstDayOfWeekValidator",
    value: function _firstDayOfWeekValidator(e, t) {
      return Math.min(Math.max(0, isNaN(t) ? 6 : t), 6);
    }
  }, {
    key: "_weeksValidator",
    value: function _weeksValidator(e, t) {
      return Math.min(Math.max(1, isNaN(t) ? 6 : t), 6);
    }
  }, {
    key: "_monthsValidator",
    value: function _monthsValidator(e, t) {
      return Math.min(Math.max(1, isNaN(t) ? 1 : t), 12);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        animationSettings: {
          value: null,
          type: "object"
        },
        calendarMode: {
          value: "default",
          allowedValues: ["default", "classic"],
          type: "string"
        },
        dayNameFormat: {
          value: "firstTwoLetters",
          allowedValues: ["narrow", "firstTwoLetters", "long", "short"],
          type: "string"
        },
        dateFormatFunction: {
          value: null,
          type: "function"
        },
        disableAutoNavigation: {
          value: !1,
          type: "boolean"
        },
        displayMode: {
          value: "month",
          allowedValues: ["month", "year", "decade"],
          type: "string"
        },
        displayModeView: {
          value: "table",
          allowedValues: ["table", "list"],
          type: "string"
        },
        dropDownHeight: {
          value: "200",
          type: "string"
        },
        dropDownWidth: {
          value: "initial",
          type: "string"
        },
        firstDayOfWeek: {
          value: 0,
          type: "number",
          defaultValue: 0,
          validator: "_firstDayOfWeekValidator"
        },
        footerTemplate: {
          value: null,
          type: "any"
        },
        headerTemplate: {
          value: null,
          type: "any"
        },
        hideDayNames: {
          value: !1,
          type: "boolean"
        },
        hideOtherMonthDays: {
          value: !1,
          type: "boolean"
        },
        hideTooltipArrow: {
          value: !1,
          type: "boolean"
        },
        importantDates: {
          value: [],
          type: "array",
          defaultValue: []
        },
        importantDatesTemplate: {
          value: null,
          type: "any"
        },
        max: {
          value: new Date(2100, 1, 1),
          type: "any",
          defaultValue: new Date(2100, 1, 1)
        },
        min: {
          value: new Date(1900, 1, 1),
          type: "any",
          defaultValue: new Date(1900, 1, 1)
        },
        months: {
          value: 1,
          type: "number",
          defaultValue: 1,
          validator: "_monthsValidator"
        },
        monthNameFormat: {
          value: "long",
          allowedValues: ["narrow", "firstTwoLetters", "long", "short", "2-digit", "numeric"],
          type: "string"
        },
        name: {
          value: "",
          type: "string"
        },
        restrictedDates: {
          value: [],
          type: "array",
          defaultValue: []
        },
        scrollButtonsNavigationMode: {
          value: "landscape",
          allowedValues: ["portrait", "landscape"],
          type: "string"
        },
        scrollButtonsPosition: {
          value: "both",
          allowedValues: ["near", "far", "both"],
          type: "string"
        },
        selectedDates: {
          value: [],
          type: "array"
        },
        selectionMode: {
          value: "default",
          allowedValues: ["none", "default", "one", "many", "zeroOrMany", "oneOrMany", "zeroOrOne", "week", "range"],
          type: "string"
        },
        spinButtonsDelay: {
          value: 80,
          type: "number"
        },
        spinButtonsInitialDelay: {
          value: 0,
          type: "number"
        },
        titleTemplate: {
          value: null,
          type: "any"
        },
        tooltip: {
          value: !1,
          type: "boolean"
        },
        tooltipArrow: {
          value: !0,
          type: "boolean"
        },
        tooltipArrowDirection: {
          allowedValues: ["bottom", "top", "left", "right", "none"],
          value: "bottom",
          type: "string"
        },
        tooltipDelay: {
          value: 100,
          type: "number"
        },
        tooltipOffset: {
          value: [],
          type: "array"
        },
        tooltipPosition: {
          value: "auto",
          allowedValues: ["auto", "bottom", "top", "left", "right", "absolute"],
          type: "string"
        },
        tooltipTemplate: {
          value: null,
          type: "any"
        },
        view: {
          value: "portrait",
          allowedValues: ["landscape", "portrait"],
          type: "string"
        },
        viewSections: {
          value: ["header"],
          type: "array"
        },
        weekNumbers: {
          value: !1,
          type: "boolean"
        },
        weeks: {
          value: 6,
          type: "number",
          defaultValue: 6,
          validator: "_weeksValidator"
        },
        yearFormat: {
          value: "numeric",
          allowedValues: ["2-digit", "numeric"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "container.down": "_downHandler",
        "document.up": "_documentUpHandler",
        "container.move": "_moveHandler",
        "container.wheel": "_containerWheelHandler",
        "body.focus": "_bodyFocusStateHandler",
        "body.blur": "_bodyBlurStateHandler",
        "header.click": "_headerClickHandler",
        "header.change": "_headerChangeHandler",
        keydown: "_keyDownHandler",
        keyup: "_keyUpHandler",
        "listViewContainer.keydown": "_listViewContainerKeyDownHandler",
        "listViewContainer.change": "_listViewContainerChangeEventHandler",
        "listViewContainer.itemClick": "_listViewContainerItemClickHandler",
        mouseenter: "_mouseEventsHandler",
        mouseleave: "_mouseEventsHandler",
        "container.mouseover": "_mouseEventsHandler",
        "container.mouseout": "_mouseEventsHandler"
      };
    }
  }, {
    key: "methods",
    get: function get() {
      return {
        select: "select(date=new Date(): date|string): void",
        clearSelection: "clearSelection(): void",
        today: "today(): date",
        navigate: "navigate(step: date|string|int): bool"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.calendar.css"];
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.DropDownList": "smart.dropdownlist.js",
        "Smart.ListBox": "smart.listbox.js",
        "Smart.RepeatButton": "smart.button.js",
        "Smart.Tooltip": "smart.tooltip.js"
      };
    }
  }]);

  return _class76;
}(Smart.BaseElement)), Smart("smart-card",
/*#__PURE__*/
function (_Smart$ContentElement5) {
  "use strict";

  _inherits(_class77, _Smart$ContentElement5);

  function _class77() {
    _classCallCheck(this, _class77);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class77).apply(this, arguments));
  }

  _createClass(_class77, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" inner-h-t-m-l=\"[[innerHTML]]\" role=\"presentation\">\n                    <content></content>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class77.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      "itemTemplate" === e ? (a._template = a._handleTemplate(), a.innerHTML = a._processTemplate(), a.contentHandler && a.contentHandler(a)) : "dataSource" === e ? (a.innerHTML = a._processTemplate(), a.contentHandler && a.contentHandler(a)) : "contentHandler" === e ? a.contentHandler && a.contentHandler(a) : void 0;
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class77.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.setAttribute("role", "group"), e._template = e._handleTemplate(), e._template.hasBindings ? e.innerHTML = e._processTemplate() : e.itemTemplate && (e.innerHTML = e._template.content), e.contentHandler && e.contentHandler(e), _get(_getPrototypeOf(_class77.prototype), "render", this).call(this);
    }
  }, {
    key: "_handleTemplate",
    value: function _handleTemplate() {
      var e = this;
      var t = e.itemTemplate,
          i = "",
          a = !1,
          n = /{{\w+}}/g;
      return e.itemTemplate ? t instanceof HTMLElement ? i = t.innerHTML : (t = document.getElementById(t), i = t ? t.innerHTML : "") : i = e.innerHTML, n.exec(i) && (a = !0), {
        content: i,
        hasBindings: a
      };
    }
  }, {
    key: "_processTemplate",
    value: function _processTemplate() {
      var e = this,
          t = /{{\w+}}/g,
          i = e._template.content.match(t),
          a = e.dataSource || {};

      var n = e._template.content;
      return i && 0 !== i.length ? (i.forEach(function (e) {
        var t = e.replace("{{", "").replace("}}", "");
        var i = a[t];
        void 0 === i && (i = ""), n = n.replace(e, i);
      }), n) : n;
    }
  }, {
    key: "_swipeHandler",
    value: function _swipeHandler() {}
  }], [{
    key: "properties",
    get: function get() {
      return {
        dataSource: {
          value: null,
          type: "object?",
          reflectToAttribute: !1
        },
        itemTemplate: {
          value: null,
          type: "any?",
          reflectToAttribute: !1
        },
        contentHandler: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        mouseenter: "_mouseEnterHandler",
        mouseleave: "_mouseLeaveHandler",
        swipeleft: "_swipeHandler",
        swiperight: "_swipeHandler",
        swipetop: "_swipeHandler",
        swipebottom: "_swipeHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.card.css"];
    }
  }]);

  return _class77;
}(Smart.ContentElement)), Smart("smart-carousel",
/*#__PURE__*/
function (_Smart$ContentElement6) {
  "use strict";

  _inherits(_class78, _Smart$ContentElement6);

  function _class78() {
    _classCallCheck(this, _class78);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class78).apply(this, arguments));
  }

  _createClass(_class78, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div id=\"itemsContainer\" inner-h-t-m-l=\"[[innerHTML]]\" class=\"smart-items-container\" role=\"presentation\"><content></content></div>\n                    <smart-repeat-button initial-delay=\"0\" right-to-left=\"[[rightToLeft]]\" delay=\"[[delay]]\" id=\"arrowLeft\" animation=\"[[animation]]\" unfocusable class=\"smart-arrow smart-arrow-left\" aria-label=\"Previous slide\"></smart-repeat-button>\n                    <smart-repeat-button initial-delay=\"0\" right-to-left=\"[[rightToLeft]]\" delay=\"[[delay]]\" id=\"arrowRight\" animation=\"[[animation]]\" unfocusable class=\"smart-arrow smart-arrow-right\" aria-label=\"Next slide\"></smart-repeat-button>\n                    <div id=\"indicatorsContainer\" class=\"smart-indicators-container\" role=\"tablist\"></div>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (_get(_getPrototypeOf(_class78.prototype), "propertyChangedHandler", this).call(this, e, t, i), e) {
        case "disabled":
          a._setFocusable();

          break;

        case "dataSource":
          if (a._currentIndex = 0, a._generateIndicators(), a._generateItems(), a._handleIndicatorsState(0, 0), a._handleItemsState(0, 0), a._handle3dMode(0), !1 !== a.autoPlay) {
            var _e859 = parseInt(a.autoPlay);

            _e859 ? setTimeout(function () {
              a.play();
            }, _e859) : a.play();
          }

          a._animationTrigger(a._currentIndex);

          break;

        case "itemTemplate":
          a._generateItems(), a._handleItemsState(a._currentIndex, a._currentIndex + 1);
          break;

        case "indicatorTemplate":
          a._generateIndicators(), a._handleIndicatorsState(a._currentIndex, a._currentIndex + 1);
          break;

        case "interval":
          a.pause(), a.play();
          break;

        case "loop":
          a._handleArrowsActiveState(a._currentIndex, a._currentIndex);

          break;

        case "hideArrows":
          i || a._handleArrowsActiveState(a._currentIndex, a._currentIndex);
          break;

        case "displayMode":
          "multiple" === t && a.$.itemsContainer.removeAttribute("style");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;

      if (e.setAttribute("role", "region"), e.setAttribute("aria-roledescription", "carousel"), e._setInitialState(), e._generateIndicators(), e._generateItems(), e._handleIndicatorsState(0, 0), e._handleItemsState(0, 0), e._handle3dMode(0), !1 !== e.autoPlay) {
        var _t743 = parseInt(e.autoPlay);

        _t743 ? setTimeout(function () {
          e.play();
        }, _t743) : e.play();
      }

      e._setFocusable(), e._animationTrigger(e._currentIndex), e._handleArrowsActiveState(0, e._currentIndex), _get(_getPrototypeOf(_class78.prototype), "render", this).call(this);
    }
  }, {
    key: "next",
    value: function next() {
      var e = this,
          t = e.dataSource.length;
      if (e.disabled || 0 === t) return;
      var i = e._currentIndex;
      i = e.loop ? i >= t - 1 ? 0 : i + 1 : i >= t - 1 ? i : i + 1, e._goToItem(i);
    }
  }, {
    key: "pause",
    value: function pause() {
      var e = this;
      e._handleRotation(), e._rotate = !1;
    }
  }, {
    key: "slideTo",
    value: function slideTo(e) {
      var t = this;
      e = e ? parseInt(e) : 0;
      t.disabled || 0 > e || e > t._items.length || t._goToItem(e);
    }
  }, {
    key: "prev",
    value: function prev() {
      var e = this,
          t = e.dataSource.length;
      if (e.disabled || 0 === t) return;
      var i = e._currentIndex;
      i = e.loop ? 0 >= i ? t - 1 : i - 1 : 0 >= i ? 0 : i - 1, e._goToItem(i);
    }
  }, {
    key: "play",
    value: function play() {
      var e = this;
      e.disabled || !e.slideShow || (e._rotationInterval && clearInterval(e._rotationInterval), e._handleRotation(!0), e._rotate = !0);
    }
  }, {
    key: "_animationTrigger",
    value: function _animationTrigger(e) {
      var t = this;

      for (var _a471 = 0; _a471 < t._items.length; _a471++) {
        _a471 !== e && t._items[_a471].classList.add("smart-animate-trigger");
      }
    }
  }, {
    key: "_handle3dMode",
    value: function _handle3dMode(e) {
      var t = this,
          a = t.dataSource.length;

      if (!t.disabled && a && "3d" === t.displayMode) {
        e = e || 0;

        for (var _n354 = 0; _n354 < a; _n354++) {
          var _i734 = (_n354 - e) * (t.rightToLeft ? -1 : 1);

          _i734 ? t._items[_n354].setAttribute("position", _i734) : t._items[_n354].removeAttribute("position");
        }
      }
    }
  }, {
    key: "_handleArrowsActiveState",
    value: function _handleArrowsActiveState(e) {
      var t = this,
          i = t.dataSource.length;
      return t.loop ? void (t.$.arrowLeft.disabled = t.$.arrowRight.disabled = !1) : void (t.rightToLeft ? (t.$.arrowRight.disabled = 0 === e, t.$.arrowLeft.disabled = e === i - 1) : (t.$.arrowLeft.disabled = 0 === e, t.$.arrowRight.disabled = e === i - 1));
    }
  }, {
    key: "_handleArrowClick",
    value: function _handleArrowClick(e) {
      var t = this,
          i = t._currentIndex;
      t.disabled || (t.rightToLeft ? t.$.arrowLeft.contains(e.target) ? t.next() : t.prev() : t.$.arrowLeft.contains(e.target) ? t.prev() : t.next(), t._changeEvent(i, t._currentIndex));
    }
  }, {
    key: "_handleDefaultInnerHTML",
    value: function _handleDefaultInnerHTML() {
      var e = this;

      if (!(e.dataSource && 0 < e.dataSource.length) && 0 <= e.$.itemsContainer.innerHTML.indexOf("<ul")) {
        var _t744 = e.$.itemsContainer.getElementsByTagName("ul")[0],
            _a472 = _t744.getElementsByTagName("li");

        for (var _t745 = 0; _t745 < _a472.length; _t745++) {
          var _i735 = {
            HTMLcontent: _a472[_t745].innerHTML
          };
          e.dataSource.push(_i735);
        }
      }
    }
  }, {
    key: "_handleIndicatorsState",
    value: function _handleIndicatorsState(e, t) {
      var i = this;
      !i.disabled && 0 !== i._indicators.length && (e || 0 === e) && (t || 0 === t) && (e !== t && (i._indicators[e].classList.remove("smart-active"), i._indicators[e].setAttribute("aria-selected", !1)), i._indicators[t].classList.add("smart-active"), i._indicators[t].setAttribute("aria-selected", !0));
    }
  }, {
    key: "_handleItemClick",
    value: function _handleItemClick(e) {
      var t = this,
          i = e.target.closest(".smart-carousel-item");

      if (!(t.disabled || !i || "3d" !== t.displayMode || t.disableItemClick)) {
        var _e860 = parseInt(i.getAttribute("item-id")),
            _a473 = parseInt(i.getAttribute("position"));

        3 < Math.abs(_a473) || t._goToItem(_e860);
      }
    }
  }, {
    key: "_handleItemsState",
    value: function _handleItemsState(e, t) {
      var i = this;
      !i.disabled && 0 !== i._items.length && (e || 0 === e) && (t || 0 === t) && (e !== t && (i._items[e].classList.remove("smart-active"), i._items[e].classList.add("smart-out")), i._items[t].classList.add("smart-active"));
    }
  }, {
    key: "_handleIndicatorsContainerClick",
    value: function _handleIndicatorsContainerClick(e) {
      var t = this,
          i = e.target.closest(".smart-indicator"),
          a = t._currentIndex;

      if (!t.disabled && i) {
        var _e861 = parseInt(i.getAttribute("indicator-id"));

        a === _e861 || (t._goToItem(_e861), t._changeEvent(a, t._currentIndex));
      }
    }
  }, {
    key: "_handleMultipleMode",
    value: function _handleMultipleMode(e) {
      var t = this;
      if ("multiple" !== t.displayMode) return;
      var i = t._items[e],
          a = i.offsetWidth,
          n = t.$.container.offsetWidth,
          o = t.$.itemsContainer.offsetWidth;
      var r = 0;
      if (0 === e) return void (t.$.itemsContainer.style.marginLeft = "0px");
      if (e === t._items.length - 1) return void (t.$.itemsContainer.style.marginLeft = "-" + (o - n) + "px");

      for (var _a474 = 0; _a474 < e; _a474++) {
        r += t._items[e].offsetWidth;
      }

      r + a / 2 >= n / 2 && r + a < o && (t.$.itemsContainer.style.marginLeft = "-" + (r + a / 2 - n / 2) + "px");
    }
  }, {
    key: "_changeEvent",
    value: function _changeEvent(e, t) {
      if (e !== t) {
        var _i736 = this;

        return _i736.onIndexChange ? void _i736.onIndexChange(t) : void (_i736.$.fireEvent("changing", {
          index: t,
          previousIndex: e
        }), (!_i736.hasAnimation || "default" === _i736.displayMode) && _i736.$.fireEvent("change", {
          index: t,
          previousIndex: e
        }));
      }
    }
  }, {
    key: "_handleKeyDown",
    value: function _handleKeyDown(e) {
      var t = this,
          i = e.key,
          a = t._currentIndex;
      !t.disabled && t.keyboard && -1 !== ["ArrowLeft", "ArrowDown", "ArrowRight", "ArrowUp", "Home", "End", " ", "Enter"].indexOf(i) && ("ArrowLeft" === i || "ArrowDown" === i ? t.rightToLeft ? t.next() : t.prev() : "ArrowUp" === i || "ArrowRight" === i ? t.rightToLeft ? t.prev() : t.next() : "Home" === i ? t._goToItem(0) : "End" === i ? t._goToItem(t.dataSource.length - 1) : " " === i ? t._rotate ? t.pause() : t.play() : "Enter" === i ? t.play() : void 0, t._changeEvent(a, t._currentIndex));
    }
  }, {
    key: "_handleMouseWheel",
    value: function _handleMouseWheel(e) {
      var t = this,
          i = t._currentIndex;
      t.disabled || !t.wheel || document.activeElement !== t || (e.stopPropagation(), e.preventDefault(), 0 < e.deltaY ? t.next() : t.prev(), t._changeEvent(i, t._currentIndex));
    }
  }, {
    key: "_handleRotation",
    value: function _handleRotation(e) {
      var t = this;
      e ? t._rotationInterval = setInterval(function () {
        t.slideShow && t.next();
      }, t.interval) : clearInterval(t._rotationInterval);
    }
  }, {
    key: "_handleSwipe",
    value: function _handleSwipe(e) {
      var t = this;
      t.disabled || !t.swipe || (e.stopPropagation(), e.preventDefault(), "swipeleft" === e.type ? t.prev() : t.next());
    }
  }, {
    key: "_generateIndicator",
    value: function _generateIndicator(e) {
      var t = this,
          i = document.createElement("span"),
          a = e ? e : 0;

      if (t.indicatorTemplate) {
        var _e862 = t._validateTemplate(t.indicatorTemplate);

        i.innerHTML = t._processItemTemplate(_e862.content, t.dataSource[a]);
      }

      return i.setAttribute("role", "tab"), i.setAttribute("aria-selected", !1), i.classList.add("smart-indicator"), i.setAttribute("indicator-id", a), i;
    }
  }, {
    key: "_generateIndicators",
    value: function _generateIndicators() {
      var e = this,
          t = e.dataSource.length;
      var a = [],
          n = document.createDocumentFragment();

      for (var _o252 = 0; _o252 < t; _o252++) {
        var _t746 = e._generateIndicator(_o252);

        a.push(_t746), n.appendChild(_t746);
      }

      e._indicators = a;
      var i = e.$.indicatorsContainer;

      for (; i.firstChild;) {
        i.removeChild(i.firstChild);
      }

      i.appendChild(n);
    }
  }, {
    key: "_generateItem",
    value: function _generateItem(e) {
      var t = this,
          i = e ? e : 0,
          a = t.dataSource[i],
          n = document.createElement("div");

      if (n.id = t.id + "Slide" + e, t.itemTemplate) {
        var _e863 = t._validateTemplate(t.itemTemplate);

        n.innerHTML = t._processItemTemplate(_e863.content, t.dataSource[i]);
      } else "string" == typeof a ? n.style.backgroundImage = "url(\"" + a + "\")" : n.innerHTML = "<div class=\"smart-carousel-item-container\" style=\"background-image:url('".concat(a.image || "", "')\" role=\"presentation\">\n                        <h2 id=\"").concat(n.id + "Label", "\" class=\"smart-carousel-item-label\">").concat(a.label || "", "</h2 >\n                        <p class=\"smart-carousel-item-content\">").concat(a.content || "", "</p>\n                    </div>\n                    <div class=\"smart-carousel-html-content\">").concat(a.HTMLcontent || "", "</div>\n                </div>");

      return a.label ? (n.setAttribute("aria-labelledby", n.id + "Label"), t._indicators[e].setAttribute("aria-labelledby", n.id + "Label")) : (n.setAttribute("aria-label", "Slide " + e), t._indicators[e].setAttribute("aria-label", "Slide " + e)), t._indicators[e].setAttribute("aria-controls", n.id), n.setAttribute("role", "tabpanel"), n.classList.add("smart-carousel-item"), n.setAttribute("item-id", i), n;
    }
  }, {
    key: "_processItemTemplate",
    value: function _processItemTemplate(e, t) {
      var i = /{{\w+}}/g,
          a = e.match(i);
      var n = e;
      return a && 0 !== a.length ? (a.forEach(function (e) {
        var i = e.replace("{{", "").replace("}}", "");
        n = n.replace(e, t[i] || "");
      }), n) : n;
    }
  }, {
    key: "_generateItems",
    value: function _generateItems() {
      var e = this,
          t = e.dataSource.length;
      var a = [],
          n = document.createDocumentFragment();

      for (var _o253 = 0; _o253 < t; _o253++) {
        var _t747 = e._generateItem(_o253);

        a.push(_t747), n.appendChild(_t747);
      }

      e._items = a;
      var i = e.$.itemsContainer;

      for (; i.firstChild;) {
        i.removeChild(i.firstChild);
      }

      i.appendChild(n);
    }
  }, {
    key: "_goToItem",
    value: function _goToItem(e, t) {
      var i = this,
          a = i.dataSource.length,
          n = i._currentIndex;
      var o = e;
      0 > e ? o = 0 : e > a - 1 && (o = a - 1), i._removeFadeOut(), i._animationTrigger(), i._handleIndicatorsState(n, o), i._handleItemsState(n, o), i._currentIndex = o, t && i._changeEvent(n, o), i._handle3dMode(o), i._handleMultipleMode(o), i._handleArrowsActiveState(o, n);
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      if (e.disabled || e.unfocusable) return e.removeAttribute("tabindex"), void (e.tabIndex = -1);
      var t = 0 < e.tabIndex ? e.tabIndex : 0;
      e.setAttribute("tabindex", t), e.tabIndex = t;
    }
  }, {
    key: "_setInitialState",
    value: function _setInitialState() {
      var e = this;
      e._currentIndex = 0, e._indicators = [], e._items = [], e._rotate = !1, e._handleDefaultInnerHTML();
    }
  }, {
    key: "_validateTemplate",
    value: function _validateTemplate(e) {
      var t = this;
      var i = "",
          a = !1,
          n = /{{\w+}}/g;
      return ("function" == typeof e && (i = e()), !("content" in document.createElement("template"))) ? (t.error(t.localize("htmlTemplateNotSuported", {
        elementType: t.nodeName.toLowerCase()
      })), void (t.itemTemplate = null)) : (e instanceof HTMLElement ? i = e.innerHTML : (e = document.getElementById(e), i = e ? e.innerHTML : ""), n.exec(i) && (a = !0), {
        content: i,
        hasBindings: a
      });
    }
  }, {
    key: "_handleTransitionEnd",
    value: function _handleTransitionEnd(e) {
      if (e.target.classList.contains("smart-carousel-item") && !e.target.getAttribute("position")) {
        var _t748 = this,
            _i737 = e.target.getAttribute("item-id");

        _t748._lastTransitionEndId === _i737 || (_t748._removeFadeOut(), this.$.fireEvent("change", {
          index: _i737,
          previousIndex: _t748._lastTransitionEndId
        }), _t748._lastTransitionEndId = _i737);
      }
    }
  }, {
    key: "_removeFadeOut",
    value: function _removeFadeOut() {
      var e = this,
          t = e.$.itemsContainer.getElementsByClassName("smart-out");
      if (t.length) for (var _e864 = 0; _e864 < t.length; _e864++) {
        t[_e864].classList.remove("smart-out");
      }
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      var e = this,
          t = Smart.EnableShadowDOM;
      return e._isInShadowDOM ? !e._isInShadowDOM : e.isCompleted ? null !== e.shadowRoot : t;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoPlay: {
          value: !1,
          type: "any"
        },
        dataSource: {
          value: [],
          type: "array",
          reflectToAttribute: !1
        },
        delay: {
          value: 200,
          type: "number"
        },
        displayMode: {
          allowedValues: ["default", "multiple", "3d"],
          value: "default",
          type: "string"
        },
        disableItemClick: {
          value: !1,
          type: "boolean"
        },
        hideArrows: {
          value: !1,
          type: "boolean"
        },
        hideIndicators: {
          value: !1,
          type: "boolean"
        },
        indicatorTemplate: {
          value: null,
          type: "any"
        },
        interval: {
          value: 5e3,
          type: "number"
        },
        itemTemplate: {
          value: null,
          type: "any"
        },
        keyboard: {
          value: !1,
          type: "boolean"
        },
        loop: {
          value: !1,
          type: "boolean"
        },
        messages: {
          value: {
            en: {
              htmlTemplateNotSuported: "{{elementType}}:  Browser doesn't support HTMLTemplate elements."
            }
          },
          type: "object",
          extend: !0
        },
        slideShow: {
          value: !1,
          type: "boolean"
        },
        swipe: {
          value: !1,
          type: "boolean"
        },
        wheel: {
          value: !1,
          type: "boolean"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "arrowLeft.click": "_handleArrowClick",
        "arrowRight.click": "_handleArrowClick",
        "indicatorsContainer.click": "_handleIndicatorsContainerClick",
        keydown: "_handleKeyDown",
        swipeleft: "_handleSwipe",
        swiperight: "_handleSwipe",
        wheel: "_handleMouseWheel",
        "itemsContainer.click": "_handleItemClick",
        "itemsContainer.transitionend": "_handleTransitionEnd"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.RepeatButton": "smart.button.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.button.css", "smart.carousel.css"];
    }
  }]);

  return _class78;
}(Smart.ContentElement)), Smart("smart-chip",
/*#__PURE__*/
function (_Smart$ContentElement7) {
  "use strict";

  _inherits(_class79, _Smart$ContentElement7);

  function _class79() {
    _classCallCheck(this, _class79);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class79).apply(this, arguments));
  }

  _createClass(_class79, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <span id=\"avatar\" class=\"smart-avatar\">[[avatar]]</span><!--\n                --><span id=\"value\" class=\"smart-value\" inner-h-t-m-l=\"[[innerHTML]]\"><content></content></span><!--\n                --><span id=\"closeButton\" class=\"smart-close-button\" role=\"button\" aria-label=\"Close\"></span>\n            </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class79.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      "disabled" === e || "unfocusable" === e ? a._setFocusable() : "avatar" === e ? a.itemTemplate ? a._setAvatar(a._customAvatar) : a._setAvatar(a.$.avatar) : "itemTemplate" === e ? a._applyTemplate() : "value" === e ? a.itemTemplate ? a._applyTemplate() : a.$.value.innerHTML = i || "" : void 0;
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.value = e.value ? e.value : e.innerHTML, e._applyTemplate(), e._setFocusable(), _get(_getPrototypeOf(_class79.prototype), "render", this).call(this);
    }
  }, {
    key: "close",
    value: function close() {
      var e = this;
      e.$.fireEvent("close", {
        value: e.value
      }), e.parentElement.removeChild(e);
    }
  }, {
    key: "_applyTemplate",
    value: function _applyTemplate() {
      var e = this;
      var t = e.itemTemplate;
      if (!t) return e.$.value.innerHTML = e.value, void e._setAvatar(e.$.avatar);
      if (!("content" in document.createElement("template"))) return void e.error(e.localize("htmlTemplateNotSuported", {
        elementType: e.nodeName.toLowerCase()
      }));
      if (t instanceof HTMLTemplateElement || (t = document.getElementById(t)), null === t || !("content" in t)) return void e.error(e.localize("invalidTemplate", {
        elementType: e.nodeName.toLowerCase()
      }));
      var i = t.innerHTML;
      e.$.container.innerHTML = i.replace(/{{\s*value\s*}}/g, e.value), e._customAvatar = e.$.container.querySelector(".smart-avatar"), e._setAvatar(e._customAvatar);
    }
  }, {
    key: "_clickHandler",
    value: function _clickHandler(e) {
      var t = this;

      if (!t.disabled) {
        var _i738 = t.enableShadowDOM ? t.shadowRoot.elementFromPoint(e.pageX, e.pageY) : e.target;

        _i738.closest && _i738.closest(".smart-close-button") && t.close();
      }
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this;
      var i = e.key;
      t.disabled || t.readonly || "Delete" !== i || t.close();
    }
  }, {
    key: "_setAvatar",
    value: function _setAvatar(e) {
      if (e) {
        var _t749 = this,
            _i739 = /\.(gif|jpg|jpeg|tiff|png)$/i.test(_t749.avatar);

        e.innerHTML = _i739 ? "<img src=\"".concat(_t749.avatar, "\" aria-label=\"").concat(_t749.value ? "Avatar of " + _t749.value : "Avatar", "\" />") : _t749.avatar || "";
      }
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void e.removeAttribute("tabindex") : void (e.tabIndex = 0 < e.tabIndex ? e.tabIndex : 0);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        avatar: {
          value: null,
          type: "string?"
        },
        closeButton: {
          value: !1,
          type: "boolean"
        },
        itemTemplate: {
          value: null,
          type: "any?",
          reflectToAttribute: !1
        },
        value: {
          value: "",
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        click: "_clickHandler",
        keydown: "_keyDownHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.chip.css"];
    }
  }]);

  return _class79;
}(Smart.ContentElement)), Smart("smart-date-time-picker",
/*#__PURE__*/
function (_Smart$BaseElement16) {
  "use strict";

  _inherits(_class80, _Smart$BaseElement16);

  function _class80() {
    _classCallCheck(this, _class80);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class80).apply(this, arguments));
  }

  _createClass(_class80, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <span id=\"label\" class=\"smart-label\">[[label]]</span>\n                    <div id=\"content\" class=\"smart-content\">\n                        <input id=\"input\" class=\"smart-input smart-date-time-input\" type=\"text\" readonly=\"[[readonly]]\" disabled=\"[[disabled]]\" placeholder=\"[[placeholder]]\" name=\"[[name]]\">\n                        <div id=\"spinButtonsContainer\" class=\"smart-spin-buttons-container\" role=\"presentation\">\n                            <smart-repeat-button initial-delay=\"[[spinButtonsInitialDelay]]\" animation=\"[[animation]]\" delay=\"[[spinButtonsDelay]]\" readonly=\"[[readonly]]\"  unfocusable id=\"upButton\" right-to-left=\"[[rightToLeft]]\" class=\"smart-spin-button\" aria-label=\"Increment\">\n                                <div class=\"smart-arrow smart-arrow-up\" aria-hidden=\"true\"></div>\n                            </smart-repeat-button>\n                            <smart-repeat-button initial-delay=\"[[spinButtonsInitialDelay]]\" animation=\"[[animation]]\" delay=\"[[spinButtonsDelay]]\" readonly=\"[[readonly]]\" unfocusable id=\"downButton\" right-to-left=\"[[rightToLeft]]\" class=\"smart-spin-button\" aria-label=\"Decrement\">\n                                <div class=\"smart-arrow smart-arrow-down\" aria-hidden=\"true\"></div>\n                            </smart-repeat-button>\n                        </div>\n                        <div id=\"calendarButton\" class=\"smart-drop-down-button smart-calendar-button\" role=\"button\" aria-haspopup=\"dialog\" aria-label=\"Open drop down\"></div>\n                        <div id=\"dropDownContainer\" class=\"smart-drop-down smart-date-time-drop-down smart-visibility-hidden\" role=\"dialog\">\n                            <div id=\"dropDownHeader\" class=\"smart-drop-down-header smart-hidden\" role=\"heading\" aria-level=\"1\">\n                                <div id=\"selectDate\" class=\"smart-selected\" role=\"button\"></div>\n                                <div id=\"selectTime\" role=\"button\"></div>\n                            </div>\n                            <div id=\"dropDownContent\" class=\"smart-drop-down-content\" role=\"presentation\">\n                                <smart-calendar id=\"calendarDropDown\" class=\"smart-hidden\"\n                                              animation=\"[[animation]]\"\n                                              animation-settings=\"[[animationSettings]]\"\n                                              calendar-mode=\"[[calendarMode]]\"\n                                              day-name-format=\"[[dayNameFormat]]\"\n                                              disable-auto-navigation=\"[[disableAutoNavigation]]\"\n                                              display-mode-view=\"[[displayModeView]]\"\n                                              first-day-of-week=\"[[firstDayOfWeek]]\"\n                                              header-template=\"[[headerTemplate]]\"\n                                              hide-day-names=\"[[hideDayNames]]\"\n                                              hide-other-month-days=\"[[hideOtherMonthDays]]\"\n                                              hide-tooltip-arrow=\"[[hideTooltipArrow]]\"\n                                              important-dates=\"[[importantDates]]\"\n                                              important-dates-template=\"[[importantDatesTemplate]]\"\n                                              locale=\"[[locale]]\"\n                                              right-to-left=\"[[rightToLeft]]\"\n                                              selection-mode=\"one\"\n                                              spin-buttons-delay=\"[[spinButtonsDelay]]\"\n                                              spin-buttons-initial-delay=\"[[spinButtonsInitialDelay]]\"\n                                              theme=\"[[theme]]\"\n                                              tooltip=\"[[tooltip]]\"\n                                              tooltip-delay=\"[[tooltipDelay]]\"\n                                              tooltip-position=\"[[tooltipPosition]]\"\n                                              tooltip-template=\"[[tooltipTemplate]]\"\n                                              unfocusable=\"[[unfocusable]]\"\n                                              view-sections='[\"header\", \"footer\"]'\n                                              week-numbers=\"[[weekNumbers]]\"\n                                              weeks=\"[[weeks]]\"></smart-calendar>\n                            </div>\n                        </div>\n                    </div>\n                    <span id=\"hint\" class=\"smart-hint\">[[hint]]</span>\n                </div>";
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;

      _get(_getPrototypeOf(_class80.prototype), "attached", this).call(this);

      e.isCompleted && (e._defaultFooterTemplateApplied && e._addCalendarFooterListeners(), e.$.timePickerDropDown && e._addTimePickerListener(), e._positionDetection && e._positionDetection.dropDownAttached());
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;

      if (_get(_getPrototypeOf(_class80.prototype), "detached", this).call(this), e.close(), e._defaultFooterTemplateApplied) {
        var _t750 = e.$.calendarDropDown.$footer;
        _t750.unlisten("change"), _t750.unlisten("click"), _t750.unlisten("wheel");
      }

      e.$.timePickerDropDown && e.$.timePickerDropDown.$.unlisten("change"), e._positionDetection && e._positionDetection.dropDownDetached();
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class80.prototype), "ready", this).call(this);

      var e = this;
      e._edgeMacFF = Smart.Utilities.Core.Browser.Edge || Smart.Utilities.Core.Browser.Firefox && -1 !== navigator.platform.toLowerCase().indexOf("mac"), e._iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform), e._edgeMacFF && e.$dropDownContainer.addClass("not-in-view"), e._defaultFooterTemplate = document.createElement("template"), e._defaultFooterTemplate.innerHTML = "<div class=\"smart-date-time-picker-footer\">\n                <div class=\"smart-footer-component smart-footer-component-hour\" role=\"presentation\">\n                    <input type=\"text\" class=\"smart-hour-element\" aria-label=\"Hours\" />\n                    <span role=\"presentation\">\n                        <smart-repeat-button initial-delay=\"0\" delay=\"75\" aria-label=\"Increment hours\">\n                            <span class=\"smart-arrow smart-arrow-up\" aria-hidden=\"true\"></span>\n                        </smart-repeat-button>\n                        <smart-repeat-button  initial-delay=\"0\" delay=\"75\" aria-label=\"Decrement hours\">\n                            <span class=\"smart-arrow smart-arrow-down\" aria-hidden=\"true\"></span>\n                        </smart-repeat-button>\n                    </span>\n                </div>\n                <div class=\"smart-footer-component smart-footer-component-minute\" role=\"presentation\">\n                    <input class=\"smart-minute-element\" aria-label=\"Minutes\" />\n                    <span role=\"presentation\">\n                        <smart-repeat-button initial-delay=\"0\" delay=\"75\" aria-label=\"Increment minutes\">\n                            <span class=\"smart-arrow smart-arrow-up\" aria-hidden=\"true\"></span>\n                        </smart-repeat-button>\n                        <smart-repeat-button initial-delay=\"0\" delay=\"75\" aria-label=\"Decrement minutes\">\n                            <span class=\"smart-arrow smart-arrow-down\" aria-hidden=\"true\"></span>\n                        </smart-repeat-button>\n                    </span>\n                </div>\n                <div class=\"smart-footer-component smart-footer-component-ampm\" role=\"presentation\">\n                    <input type=\"text\" class=\"smart-am-pm-element\" aria-label=\"AM/PM\" />\n                </div>\n                <div class=\"smart-footer-component smart-footer-component-today\" role=\"presentation\">\n                    <div tabindex=\"-1\" class=\"smart-today-element\" role=\"button\" aria-label=\"Now\"></div>\n                </div>\n            </div>", e._codeToMethod = {
        y: "addYears",
        yy: "addYears",
        yyyy: "addYears",
        yyyyy: "addYears",
        M: "addMonths",
        MM: "addMonths",
        MMM: "addMonths",
        MMMM: "addMonths",
        d: "addDays",
        dd: "addDays",
        ddd: "addDays",
        dddd: "addDays",
        H: "addHours",
        HH: "addHours",
        h: "addHours",
        hh: "addHours",
        m: "addMinutes",
        mm: "addMinutes",
        s: "addSeconds",
        ss: "addSeconds",
        f: "addDeciseconds",
        ff: "addCentiseconds",
        fff: "addMilliseconds",
        u: "addMicroseconds",
        uu: "addMicroseconds",
        n: "addNanoseconds",
        nn: "addNanoseconds",
        p: "addPicoseconds",
        pp: "addPicoseconds",
        e: "addFemtoseconds",
        ee: "addFemtoseconds",
        a: "addAttoseconds",
        aa: "addAttoseconds",
        x: "addZeptoseconds",
        xx: "addZeptoseconds",
        o: "addYoctoseconds",
        oo: "addYoctoseconds"
      }, e._codeToIndex = {
        y: 0,
        yy: 0,
        yyyy: 0,
        yyyyy: 0,
        M: 1,
        MM: 1,
        MMM: 1,
        MMMM: 1,
        d: 2,
        dd: 2,
        ddd: 2,
        dddd: 2,
        H: 3,
        HH: 3,
        h: 3,
        hh: 3,
        m: 4,
        mm: 4,
        s: 5,
        ss: 5,
        f: 6,
        ff: 6,
        fff: 6,
        u: 7,
        uu: 7,
        n: 8,
        nn: 8,
        p: 9,
        pp: 9,
        e: 10,
        ee: 10,
        a: 11,
        aa: 11,
        x: 12,
        xx: 12,
        o: 13,
        oo: 13
      }, e._getLocalizedNames(), e.checkLicense();
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e._positionDetection = new Smart.Utilities.PositionDetection(e, e.$.dropDownContainer, e.$.content, "close"), e._positionDetection.customPositionDropDown = e._positionExternalDropDown, e._positionDetection.getDropDownParent(!0), e._positionDetection.setDropDownPosition(), e.$.dropDownContainer.style.left = null, e._positionDetection.handleAutoPositioning(), e._setIds(), e._validateInitialPropertyValues(), e._setFocusable(), e.setAttribute("role", "presentation"), e.$.input.setAttribute("aria-describedby", e.$.hint.id), e.$.input.setAttribute("aria-labelledby", e.$.label.id), e.$.calendarButton.setAttribute("aria-owns", e.$.dropDownContainer.id), e.$.dropDownContainer.setAttribute("animation", e.animation), e.$.dropDownContainer.setAttribute("drop-down-display-mode", e.dropDownDisplayMode), _get(_getPrototypeOf(_class80.prototype), "render", this).call(this);
    }
  }, {
    key: "close",
    value: function close() {
      var e = this;
      e.opened && e._close();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.$.input.focus();
    }
  }, {
    key: "select",
    value: function select() {
      this.$.input.select();
    }
  }, {
    key: "open",
    value: function open() {
      var e = this;
      e.opened || e._open();
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class80.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      switch (e) {
        case "animation":
        case "theme":
          a.$.timePickerDropDown && (a.$.timePickerDropDown[e] = i), "animation" === e && (a.$.dropDownContainer.setAttribute("animation", a.animation), a._defaultFooterTemplateApplied && Array.from(a.$.calendarDropDown.$.footer.getElementsByTagName("smart-repeat-button")).forEach(function (e) {
            e.animation = i;
          }));
          break;

        case "calendarButton":
          a.$.dropDownContainer.style.transition = "none", i || a.close();
          break;

        case "calendarButtonPosition":
          a.$.dropDownContainer.style.transition = "none", a.close(), "left" === i ? a.$.content.insertBefore(a.$.calendarButton, a.$.content.firstElementChild) : null === a._dropDownParent ? a.$.content.insertBefore(a.$.calendarButton, a.$.dropDownContainer) : a.$.content.appendChild(a.$.calendarButton);
          break;

        case "disabled":
          i ? (a.close(), a.$.upButton.disabled = !0, a.$.downButton.disabled = !0) : a._disableSpinButtons(), a._setFocusable(), a._positionDetection.handleAutoPositioning();
          break;

        case "displayKind":
          {
            var _e865 = a._outputTimeZone;
            if ("unspecified" === i ? a._outputTimeZone = a._inputTimeZone : "UTC" === i ? a._outputTimeZone = "UTC" : "local" === i ? a._outputTimeZone = "Local" : void 0, a._outputTimeZone === _e865) return;
            null !== a._value && (a.close(), a._toSync = !0, a._value = a._value.toTimeZone(a._outputTimeZone), a._applyFormatString()), a.min = a.min.toTimeZone(a._outputTimeZone), a.max = a.max.toTimeZone(a._outputTimeZone);

            for (var _e866 = 0, _t751; _e866 < a.restrictedDates.length; _e866++) {
              _t751 = a.restrictedDates[_e866], _t751 = _t751.toTimeZone(a._outputTimeZone);
            }

            break;
          }

        case "dropDownAppendTo":
          a._positionDetection.dropDownAppendToChangedHandler();

          break;

        case "dropDownDisplayMode":
          a._changeDropDownDisplayMode();

          break;

        case "dropDownOverlay":
          i || a._positionDetection.removeOverlay();
          break;

        case "dropDownPosition":
          a._positionDetection.dropDownPositionChangedHandler();

          break;

        case "footerTemplate":
          if (null !== i) {
            a._defaultFooterTemplateApplied = !1;
            var _e867 = a.$.calendarDropDown.$footer;
            _e867.unlisten("change"), _e867.unlisten("click"), _e867.unlisten("wheel"), a.$.calendarDropDown.footerTemplate = i;
          } else {
            a._setDefaultFooterTemplate();

            var _e868 = a._value;
            a._hourElement.value = _e868.toString("hh"), a._minuteElement.value = _e868.toString("mm"), a._ampmElement.value = _e868.toString("tt");
          }

          break;

        case "formatString":
          "" === i && (a.formatString = "dd-MMM-yy HH:mm:ss.fff"), a._getFormatStringRegExp(), a._applyFormatString(), "auto" === a.dropDownDisplayMode && a._changeDropDownDisplayMode();
          break;

        case "interval":
          a._validateInterval(t);

          break;

        case "locale":
        case "messages":
          if (a.$.selectDate.innerHTML = a.localize("dateTabLabel"), a.$.selectTime.innerHTML = a.localize("timeTabLabel"), a._defaultFooterTemplateApplied && (a._todayElement.title = a.localize("now")), "messages" === e) return;
          a._getLocalizedNames(), a.min.calendar.days = a._localizedDays, a.min.calendar.months = a._localizedMonths, a.min.calendar.locale = a.locale, a.max.calendar.days = a._localizedDays, a.max.calendar.months = a._localizedMonths, a.max.calendar.locale = a.locale, null !== a.value && (a._value.calendar.days = a._localizedDays, a._value.calendar.months = a._localizedMonths, a._value.calendar.locale = a.locale, a.value.calendar.days = a._localizedDays, a.value.calendar.months = a._localizedMonths, a.value.calendar.locale = a.locale), Smart.Utilities.DateTime.cache = [], a._applyFormatString();
          break;

        case "max":
        case "min":
          a._validateMinMax(e, t), "strict" === a.validation ? a._validateValue() : a._minMaxChanged = !0;
          break;

        case "nullable":
          !0 === t && null === a._value && a._validateValue(a._now(), null);
          break;

        case "opened":
          i ? a._open() : a._close();
          break;

        case "readonly":
        case "unfocusable":
          i && a.close(), "unfocusable" === e && a._setFocusable();
          break;

        case "restrictedDates":
          a._validateRestrictedDates(), a._validateValue();
          break;

        case "spinButtonsPosition":
          "right" === i ? a.$.content.insertBefore(a.$.spinButtonsContainer, a.$.input.nextElementSibling) : a.$.content.insertBefore(a.$.spinButtonsContainer, a.$.input);
          break;

        case "validation":
          "strict" === i && (delete a._minMaxChanged, a._validateValue());
          break;

        case "value":
          {
            var _e869;

            null === i ? _e869 = null : (_e869 = Smart.Utilities.DateTime.validateDate(i, a._now(), a.formatString), _e869 = _e869.toTimeZone(a._outputTimeZone)), a._validateValue(_e869, a._value, void 0, !0);
            break;
          }
      }
    }
  }, {
    key: "_addCalendarFooterListeners",
    value: function _addCalendarFooterListeners() {
      var e = this,
          t = e.$.calendarDropDown.$footer;
      t.listen("change", e._footerChangeHandler.bind(e)), t.listen("click", e._footerClickHandler.bind(e)), t.listen("wheel", e._footerWheelHandler.bind(e));
    }
  }, {
    key: "_addTimePickerListener",
    value: function _addTimePickerListener() {
      var e = this;
      e.$.timePickerDropDown.$.listen("change", function (t) {
        var i = e.context,
            a = t.detail.value,
            n = Smart.Utilities.DateTime.getConstructorParameters(null === e._value ? e._now() : e._value);
        e.context = e, n[3] = a.getHours(), n[4] = a.getMinutes(), e._timePickerInitiatedChange = !0, n.unshift(null), e._validateValue(new (Function.prototype.bind.apply(Smart.Utilities.DateTime, n))()), e._timePickerInitiatedChange = !1, e.context = i;
      });
    }
  }, {
    key: "_applyFormatString",
    value: function _applyFormatString() {
      var e = this;
      null !== e.value && (e.$.input.value = e._value.toString(e.formatString));
    }
  }, {
    key: "_calendarButtonMouseEnterHandler",
    value: function _calendarButtonMouseEnterHandler() {
      var e = this;
      e.$.calendarButton.setAttribute("hover", "");
    }
  }, {
    key: "_calendarButtonMouseLeaveHandler",
    value: function _calendarButtonMouseLeaveHandler() {
      var e = this;
      e.$.calendarButton.removeAttribute("hover");
    }
  }, {
    key: "_calendarButtonClickHandler",
    value: function _calendarButtonClickHandler(e) {
      var t = this;
      t._highlightedTimePart = void 0;
      t.disabled || t.readonly || (t.hasRippleAnimation && Smart.Utilities.Animation.Ripple.animate(t.$.calendarButton, e.pageX, e.pageY), t.opened ? t._close() : t._open());
    }
  }, {
    key: "_calendarDropDownChangeHandler",
    value: function _calendarDropDownChangeHandler(e) {
      var t = this;
      if (e.stopPropagation(), t._disregardCalendarChangeEvent) return void (t._disregardCalendarChangeEvent = !1);

      if (0 < this.$.calendarDropDown.selectedDates.length) {
        var _i740 = e.detail.value[0],
            _a475 = null === t._value ? t._now() : t._value,
            _n355 = Smart.Utilities.DateTime.getConstructorParameters(_a475);

        if (_n355[0] = _i740.getFullYear(), _n355[1] = _i740.getMonth() + 1, _n355[2] = _i740.getDate(), t._calendarInitiatedChange = !0, _n355.unshift(null), t._validateValue(new (Function.prototype.bind.apply(Smart.Utilities.DateTime, _n355))()), t._defaultFooterTemplateApplied) {
          var _e870 = t._value;
          "" === t._hourElement.value && (t._hourElement.value = _e870.toString("hh")), "" === t._ampmElement.value && (t._ampmElement.value = _e870.toString("tt")), "" === t._minuteElement.value && (t._minuteElement.value = _e870.toString("mm"));
        }

        t._calendarInitiatedChange = !1;
      } else t._setNullValue();
    }
  }, {
    key: "_calendarDropDownClickHandler",
    value: function _calendarDropDownClickHandler(e) {
      var t = this;
      t.autoClose && e.target.closest(".smart-calendar-cell") && (clearTimeout(t._autoCloseTimeout), t._autoCloseTimeout = setTimeout(function () {
        t.close();
      }, t.autoCloseDelay));
    }
  }, {
    key: "_changeDropDownDisplayMode",
    value: function _changeDropDownDisplayMode() {
      function e(e, i, a, n) {
        t.$dropDownHeader[e]("smart-hidden"), t.$calendarDropDown[i]("smart-hidden"), t._timePickerInitialized && t.$.timePickerDropDown.$[a]("smart-hidden"), n && (t.opened ? t.$.calendarDropDown._refreshTitle() : t._toSync = !0);
      }

      var t = this,
          i = t._dropDownDisplayMode;

      t._detectDisplayMode();

      t._dropDownDisplayMode === i || ("default" === t._dropDownDisplayMode ? (t.calendarMode = "default", t.$.calendarDropDown.viewSections = ["title", "header"], t.$selectDate.addClass("smart-selected"), t.$selectTime.removeClass("smart-selected"), e("removeClass", "removeClass", "addClass", !0)) : "classic" === t._dropDownDisplayMode ? (t.calendarMode = "classic", t.$.calendarDropDown.viewSections = ["header", "footer"], e("addClass", "removeClass", "addClass")) : "calendar" === t._dropDownDisplayMode ? (t.calendarMode = "default", t.$.calendarDropDown.viewSections = ["title", "header"], e("addClass", "removeClass", "addClass", !0)) : (t.calendarMode = "default", e("addClass", "addClass", "removeClass"), !t._timePickerInitialized && t._initializeTimePicker()), t.$.dropDownContainer.setAttribute("drop-down-display-mode", t.dropDownDisplayMode));
    }
  }, {
    key: "_cloneValue",
    value: function _cloneValue() {
      var e = this;
      return null === e._value ? null : e._value.clone();
    }
  }, {
    key: "_close",
    value: function _close() {
      var e = this,
          t = e.$.fireEvent("closing");

      if (!t.defaultPrevented) {
        e.$.calendarDropDown.disabled = !0, e.$calendarButton.removeClass("smart-calendar-button-pressed"), e.$.calendarButton.removeAttribute("active"), e.$dropDownContainer.addClass("smart-visibility-hidden");

        var _t752 = e.$.calendarDropDown.$.container.querySelector(".smart-calendar-cell[hover]");

        _t752 && _t752.removeAttribute("hover"), e.opened = !1, e._positionDetection.removeOverlay(!0), e.$.fireEvent("close"), e._edgeMacFF && !e.hasAnimation && (e.$.dropDownContainer.style.top = null, e.$.dropDownContainer.style.left = null, e.$dropDownContainer.addClass("not-in-view"));
      } else e.opened = !0;

      e.$.calendarButton.setAttribute("aria-expanded", e.opened);
    }
  }, {
    key: "_detectDisplayMode",
    value: function _detectDisplayMode() {
      var e = this;
      e._dropDownDisplayMode = "auto" === e.dropDownDisplayMode ? Smart.Utilities.DateTime.detectDisplayMode(e.value || e.min, e.formatString, e._formatStringRegExp) : e.dropDownDisplayMode, "timePicker" === e._dropDownDisplayMode ? (e.$calendarButton.addClass("time"), "Enter date" === e.placeholder && (e.placeholder = "Enter time")) : (e.$calendarButton.removeClass("time"), "Enter time" === e.placeholder && (e.placeholder = "Enter date")), "default" === e._dropDownDisplayMode ? e.$dropDownContent.removeClass("partial") : e.$dropDownContent.addClass("partial");
    }
  }, {
    key: "_disableSpinButtons",
    value: function _disableSpinButtons() {
      var e = this;

      if (!e.disabled) {
        var _t753 = null === e._value;

        e.$.upButton.disabled = _t753, e.$.downButton.disabled = _t753;
      }
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = (t.shadowRoot || t.getRootNode()).activeElement || document.activeElement,
          a = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      Smart.Utilities.Core.isMobile || i !== t.$.input || "partial" !== t.editMode || null === t._value || a === t.$.input && t.$.input.selectionStart !== t.$.input.selectionEnd ? a !== t.$.calendarButton && !t.$.dropDownContainer.contains(a) && !t.$.dropDownContainer.contains(t._getRootShadowHost(a)) && (t.close(), i !== t.$.input && !t.contains(a) && (t._highlightedTimePart = void 0)) : (t._highlightedTimePartEdit = !1, t._validateValue(t.$.input.value, t._cloneValue(), !1), t._highlightTimePartBasedOnCursor()), t._mouseFocus = !1;
    }
  }, {
    key: "_getRootShadowHost",
    value: function _getRootShadowHost(e) {
      var t = this;
      if (!t.shadowRoot && !t.isInShadowDOM) return;
      var i = e.getRootNode().host,
          a;

      for (; i && i !== t && i !== document;) {
        a = i, i = i.getRootNode().host;
      }

      return a;
    }
  }, {
    key: "_dropDownHeaderClickHandler",
    value: function _dropDownHeaderClickHandler(e) {
      var t = this;

      if (e.target === t.$.selectDate) {
        if (t.$selectDate.hasClass("smart-selected")) return;
        t.$selectDate.addClass("smart-selected"), t.$selectTime.removeClass("smart-selected"), t.$.timePickerDropDown.$.addClass("smart-hidden"), t.$calendarDropDown.removeClass("smart-hidden");
      } else {
        if (t.$selectTime.hasClass("smart-selected")) return;
        t.$selectDate.removeClass("smart-selected"), t.$selectTime.addClass("smart-selected"), t.$calendarDropDown.addClass("smart-hidden"), t._timePickerInitialized ? t.$.timePickerDropDown.$.removeClass("smart-hidden") : t._initializeTimePicker();
      }
    }
  }, {
    key: "_dropDownKeydownHandler",
    value: function _dropDownKeydownHandler(e) {
      var t = this,
          i = e.key,
          a = t.shadowRoot ? t.shadowRoot.activeElement : document.activeElement;
      t.$.dropDownHeader.contains(a) && ("Enter" === i || " " === i) ? (e.preventDefault(), t._dropDownHeaderClickHandler({
        target: a
      })) : "Escape" === i || e.altKey && "ArrowUp" === i ? (e.preventDefault(), t.close(), t.$.input.focus()) : ("Enter" === i || " " === i) && a.classList.contains("smart-footer-component-today") ? (e.preventDefault(), t._validateValue(t._now()), t.close()) : "Enter" === i && (a === t.$.calendarDropDown.$.body && 0 < t.$.calendarDropDown.querySelectorAll(".smart-calendar-cell[selected][focus]").length || t._timePickerInitialized && a === t.$.timePickerDropDown.$.picker) && (e.preventDefault(), t.close());
    }
  }, {
    key: "_dropDownTransitionendHandler",
    value: function _dropDownTransitionendHandler() {
      var e = this;
      return e.hasAnimation ? e.opened && e._toFocus ? (e._toFocus.focus(), delete e._toFocus, void (e._timePickerInitialized && !e.$.timePickerDropDown.classList.contains("smart-hidden") && requestAnimationFrame(function () {
        return e.$.timePickerDropDown._highlightLabel();
      }))) : e._edgeMacFF && !e.opened ? (e.$.dropDownContainer.style.top = null, e.$.dropDownContainer.style.left = null, void e.$dropDownContainer.addClass("not-in-view")) : void 0 : void 0;
    }
  }, {
    key: "_footerChangeHandler",
    value: function _footerChangeHandler(e) {
      var t = this,
          i = t.context,
          a = e.target,
          n = null === t._value ? t._now() : t._value;
      var o = a.value,
          r;

      if (t.context = t, e.stopPropagation(), a.classList.contains("smart-hour-element")) {
        if (o = parseInt(o, 10), isNaN(o) || 0 > o || 12 < o) return void (a.value = n.toString("hh"));
        0 < o && 12 > o && "PM" === n.toString("tt") && (o += 12), r = "hh";
      } else if (a.classList.contains("smart-minute-element")) {
        if (o = parseInt(o, 10), isNaN(o) || 0 > o || 59 < o) return void (a.value = n.toString("mm"));
        r = "mm";
      } else {
        if (null === t._value) return void (a.value = "");

        var _e871 = n.toString("tt");

        return o = o.toLowerCase(), void ("PM" === _e871 && ("a" === o || "am" === o) || "AM" === _e871 && ("p" === o || "pm" === o) ? (t._incrementDecrement(void 0, "tt"), a.value = t._value.toString("tt")) : a.value = _e871);
      }

      var l = Smart.Utilities.DateTime.getConstructorParameters(n);
      l[t._codeToIndex[r]] = o, l.unshift(null), t._validateValue(new (Function.prototype.bind.apply(Smart.Utilities.DateTime, l))()), a.value = t._value.toString(r), t.context = i;
    }
  }, {
    key: "_footerClickHandler",
    value: function _footerClickHandler(e) {
      var t = this,
          i = t.context,
          a = e.target;
      if (t.context = t, a.classList.contains("smart-today-element")) t._validateValue(t._now()), t.autoClose && (clearTimeout(t._autoCloseTimeout), t._autoCloseTimeout = setTimeout(function () {
        t.close();
      }, t.autoCloseDelay));else {
        var _e872 = a.closest("smart-repeat-button");

        if (null !== _e872) {
          var _i741 = _e872 === _e872.parentElement.children[1],
              _a476 = _e872.closest(".smart-footer-component").classList.contains("smart-footer-component-hour") ? "hh" : "mm";

          t._incrementDecrement(_i741, _a476);
        }
      }
      t.context = i;
    }
  }, {
    key: "_footerWheelHandler",
    value: function _footerWheelHandler(e) {
      var t = this,
          i = t.shadowRoot ? t.shadowRoot.activeElement : document.activeElement;

      if (t.enableMouseWheelAction && e.target instanceof HTMLInputElement && i === e.target) {
        var _i742 = t.context,
            _a477 = e.target;
        t.context = t, _a477.classList.contains("smart-hour-element") ? t._incrementDecrement(0 < e.deltaY, "hh") : _a477.classList.contains("smart-minute-element") ? t._incrementDecrement(0 < e.deltaY, "mm") : t._incrementDecrement(void 0, "tt"), t.context = _i742, e.stopPropagation();
      }
    }
  }, {
    key: "_getAndHighlightTimePart",
    value: function _getAndHighlightTimePart(e, t, i) {
      var a = this;
      a._programmaticSelection = !0, a.$.input.selectionStart !== e || a.$.input.selectionEnd !== t ? a.$.input.setSelectionRange(e, t) : setTimeout(function () {
        a.$.input.setSelectionRange(e, t);
      }, 200), a._highlightedTimePart = {
        code: a._formatStringRegExp.groups[i],
        index: i,
        from: e,
        to: t
      };
    }
  }, {
    key: "_getFormatStringRegExp",
    value: function _getFormatStringRegExp() {
      var e = this;
      e._formatStringRegExp = e.min.getParseRegExp(e.min.calendar, e.formatString.replace(/y+/g, "yyyyy")), e._formatStringRegExp.regExp = new RegExp(e._formatStringRegExp.regExp);
    }
  }, {
    key: "_getLocalizedNames",
    value: function _getLocalizedNames() {
      var e = this,
          t = Smart.Utilities.DateTime.getLocalizedNames(e.locale);
      e._localizedDays = t.days, e._localizedMonths = t.months, e.$.selectDate.innerHTML = e.localize("dateTabLabel"), e.$.selectTime.innerHTML = e.localize("timeTabLabel");
    }
  }, {
    key: "_handleManualTimePartEdit",
    value: function _handleManualTimePartEdit(e) {
      var t = this,
          i = Smart.Utilities.DateTime.getConstructorParameters(t._value);

      if (e = e[t._highlightedTimePart.index + 1], !isNaN(e)) {
        if ("f" === t._highlightedTimePart.code) e = 100 * parseInt(e, 10);else if ("ff" === t._highlightedTimePart.code) e = 10 * parseInt(e, 10);else if (-1 !== t._highlightedTimePart.code.indexOf("y") && 3 > e.length) {
          var _i743 = t.yearCutoff.toString(),
              _a478 = parseInt(_i743.slice(2), 10);

          var _n356 = parseInt(_i743.slice(0, 2), 10);

          e = parseInt(e, 10), e < _a478 && _n356++, e = e.toString(), e = _n356 + "" + "0".repeat(2 - e.length) + e;
        } else if (-1 !== t._highlightedTimePart.code.indexOf("h")) {
          var _i744 = t._value.hour();

          e = parseInt(e, 10), 11 < _i744 && 11 >= e && (e += 12);
        }
        i[t._codeToIndex[t._highlightedTimePart.code]] = parseInt(e, 10);
      } else if (1 === t._codeToIndex[t._highlightedTimePart.code]) {
        var _a479 = -1;

        if (1 < e.length && t._localizedMonths.names.some(function (t, n) {
          if (-1 !== t.toLowerCase().indexOf(e.toLowerCase())) return _a479 = n, !0;
        }), -1 !== _a479) i[1] = _a479 + 1;else return void t._applyFormatString();
      }

      try {
        i.unshift(null), t._validateValue(new (Function.prototype.bind.apply(Smart.Utilities.DateTime, i))());
      } catch (e) {
        t._applyFormatString();
      }
    }
  }, {
    key: "_highlightTimePartBasedOnCursor",
    value: function _highlightTimePartBasedOnCursor(e) {
      function t() {
        return void 0 === e ? a.$.input.selectionStart : e;
      }

      var a = this,
          n = a.$.input.value,
          o = a._formatStringRegExp.regExp.exec(n);

      if (null === o) return void (a._highlightedTimePart = void 0);
      a._iOS || e !== void 0 || (e = a.$.input.selectionStart);
      var r = o.index,
          l;

      for (var _s82 = 1; _s82 < o.length; _s82++) {
        var _e873 = o[_s82];

        if (l = n.indexOf(_e873, r), r = l + _e873.length, 1 == _s82 && t() < l) {
          a._getAndHighlightTimePart(l, r, 0);

          break;
        }

        if (t() >= l && t() <= r) {
          a._getAndHighlightTimePart(l, r, _s82 - 1);

          break;
        }

        var _i745 = o[_s82 + 1];

        if (_i745) {
          var _e874 = n.indexOf(_i745, r);

          if (t() > r && t() < _e874) {
            t() - r <= _e874 - t() ? a._getAndHighlightTimePart(l, r, _s82 - 1) : (a._formatStringRegExp.groups[_s82], a._programmaticSelection = !0, a.$.input.setSelectionRange(_e874, _e874 + _i745.length));
            break;
          }
        } else {
          a._programmaticSelection = !0, a.$.input.setSelectionRange(l, r), a._highlightedTimePart = {
            code: a._formatStringRegExp.groups[_s82 - 1],
            index: _s82 - 1,
            from: l,
            to: r
          };
          break;
        }
      }
    }
  }, {
    key: "_highlightTimePartBasedOnIndex",
    value: function _highlightTimePartBasedOnIndex(e) {
      var t = this,
          a = t.$.input.value,
          n = t._formatStringRegExp.regExp.exec(a);

      if (null === n) return t._validateValue(void 0, t._cloneValue(), !1), void t._highlightTimePartBasedOnIndex(e);
      var o = n.index,
          r;
      var i = t.shadowRoot ? t.shadowRoot.activeElement : document.activeElement;

      if (!(0 > e || e >= n.length)) {
        t.$.input !== i && t.$.input.focus();

        for (var _l114 = 1; _l114 < n.length; _l114++) {
          var _i746 = n[_l114];

          if (r = a.indexOf(_i746, o), o = r + _i746.length, e === _l114 - 1) {
            t._getAndHighlightTimePart(r, o, e);

            break;
          }
        }
      }
    }
  }, {
    key: "_incrementDecrement",
    value: function _incrementDecrement(e, t) {
      var i = this,
          a = i._cloneValue();

      if (i._minMaxChanged && (i._value = i._rangeValidation(i._value), delete i._minMaxChanged), void 0 === t && i._highlightedTimePart && (t = i._highlightedTimePart.code), void 0 !== t) {
        if ("z" === t || "zz" === t || "zzz" === t) return void i._highlightTimePartBasedOnIndex(i._highlightedTimePart.index);
        i._value = "t" === t || "tt" === t ? i._value.addHours(12 > i._value.hour() ? 12 : -12, !0) : i._value[i._codeToMethod[t]](e ? -1 : 1, !0), i._validateValue(void 0, a, !1), i._highlightedTimePart && i._highlightTimePartBasedOnIndex(i._highlightedTimePart.index);
      } else i._value = i._value.add(e ? i.interval.negate() : i.interval, void 0, !0), i._validateValue(void 0, a, !1);

      0 !== a.compare(i._value) && i.$.fireEvent("change", {
        oldValue: a.toTimeZone(i._inputTimeZone),
        value: i.value
      });
    }
  }, {
    key: "_initializeTimePicker",
    value: function _initializeTimePicker() {
      var e = this,
          t = document.createElement("smart-time-picker");
      t.rightToLeft = e.rightToLeft, t.animation = e.animation, t.theme = e.theme, t.value = null === e._value ? e._now() : e._value.toDate(), e.$.timePickerDropDown = t, t.$ = Smart.Utilities.Extend(t), e.$.dropDownContent.appendChild(t), e._timePickerInitialized = !0, e._addTimePickerListener();
    }
  }, {
    key: "_inputBlurHandler",
    value: function _inputBlurHandler() {
      var e = this;
      e.removeAttribute("focus"), e._fullEdit = !1, e._highlightedTimePartEdit = !1;
    }
  }, {
    key: "_inputChangeHandler",
    value: function _inputChangeHandler(e) {
      var t = this;
      if (e && e.stopPropagation(), "" === t.$.input.value) return void t._setNullValue();
      if (t._fullEdit || null === t._value) t._fullEdit = !1, t._validateValue(t.$.input.value), t._highlightTimePartBasedOnCursor();else if (t._highlightedTimePartEdit) {
        t._highlightedTimePartEdit = !1;

        var _e875 = t._formatStringRegExp.regExp.exec(t.$.input.value);

        null === _e875 ? t._applyFormatString() : t._handleManualTimePartEdit(_e875);
      }
    }
  }, {
    key: "_inputDragstartHandler",
    value: function _inputDragstartHandler(e) {
      e.preventDefault();
    }
  }, {
    key: "_inputFocusHandler",
    value: function _inputFocusHandler() {
      var e = this;

      if (e.setAttribute("focus", ""), "full" !== e.editMode) {
        var _t754 = Smart.Utilities.Core.isMobile ? 10 : 0;

        setTimeout(function () {
          e._iOS ? e._highlightTimePartBasedOnCursor() : !0 !== e._mouseFocus && (void 0 === e._highlightedTimePart ? e._highlightTimePartBasedOnCursor(e._iOS ? void 0 : 0) : e._highlightTimePartBasedOnIndex(e._highlightedTimePart.index));
        }, _t754);
      }
    }
  }, {
    key: "_inputKeydownHandler",
    value: function _inputKeydownHandler(e) {
      var t = this,
          i = t.editMode,
          a = e.key;

      if ("Tab" !== a) {
        if (e.altKey && "ArrowDown" === a) return e.preventDefault(), void t.open();
        if ("Escape" === a || e.altKey && "ArrowUp" === a) return e.preventDefault(), void t.close();
        if ("full" === i) return void (t._fullEdit = !0);

        if ("partial" === i) {
          if ("Delete" === a) return void (null !== t._value && (t._setNullValue(), e.preventDefault()));
          if (null === t._value && (t._validateValue(t._now(), null, !1), t._highlightTimePartBasedOnIndex(0)), -1 !== ["/", ".", "-", ",", " "].indexOf(a)) return t._inputChangeHandler(), t._navigateToNextTimePart(), void e.preventDefault();
          if ("Backspace" === a) return t._resetTimePart(), 0 < t._highlightedTimePart.index ? t._navigateToPreviousTimePart() : t._highlightTimePartBasedOnIndex(0), void e.preventDefault();
        } else if (t._fullEdit || t._highlightedTimePartEdit || t.readonly || -1 !== ["Alt", "Control", "Shift"].indexOf(a) || e.altKey || e.ctrlKey) return;

        if (-1 === ["End", "Home", "ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown"].indexOf(a)) {
          if (t._highlightedTimePart) {
            if ("partial" !== i && t._highlightedTimePart.to - t._highlightedTimePart.from != t.$.input.selectionEnd - t.$.input.selectionStart) return void (t._fullEdit = !0);
            var _n357 = t._highlightedTimePart.code;
            if ("ddd" === _n357 || "dddd" === _n357 || "z" === _n357 || "zz" === _n357 || "zzz" === _n357 || "t" === _n357 || "tt" === _n357) return void e.preventDefault();
            if ("partial" === i && "MMM" !== _n357 && "MMMM" !== _n357 && !1 === new RegExp(/^\d+$/).test(a)) return void ((2 > a.length || "F" !== a.charAt(0)) && e.preventDefault());
            t._highlightedTimePartEdit = !0;
          }

          return;
        }

        (e.preventDefault(), "partial" === i && t._highlightedTimePartEdit && t._inputChangeHandler(), null === t._value) || ("End" === a ? t._highlightTimePartBasedOnIndex(t._formatStringRegExp.groups.length - 1) : "Home" === a ? t._highlightTimePartBasedOnIndex(0) : "ArrowLeft" === a ? t._navigateToPreviousTimePart() : "ArrowUp" === a ? t._incrementDecrement() : "ArrowRight" === a ? t._navigateToNextTimePart() : "ArrowDown" === a ? t._incrementDecrement(!0) : void 0);
      }
    }
  }, {
    key: "_inputDownHandler",
    value: function _inputDownHandler() {
      var e = this;
      e._fullEdit || e._highlightedTimePartEdit || "full" === e.editMode || Smart.Utilities.Core.isMobile || setTimeout(function () {
        e._mouseFocus = !0, e._highlightTimePartBasedOnCursor();
      }, 0);
    }
  }, {
    key: "_inputPasteHandler",
    value: function _inputPasteHandler(e) {
      var t = this;
      "partial" === t.editMode ? e.preventDefault() : this._fullEdit = !0;
    }
  }, {
    key: "_inputSelectHandler",
    value: function _inputSelectHandler() {
      var e = this,
          t = e.shadowRoot ? e.shadowRoot.activeElement : document.activeElement;
      "partial" !== e.editMode || t !== e.$.input || (!0 === e._programmaticSelection ? e._programmaticSelection = !1 : e._highlightedTimePart ? e._highlightTimePartBasedOnIndex(e._highlightedTimePart.index) : e._highlightTimePartBasedOnIndex(0));
    }
  }, {
    key: "_inputUpHandler",
    value: function _inputUpHandler() {
      var e = this;
      Smart.Utilities.Core.isMobile && (e._iOS ? (e._mouseFocus = !0, setTimeout(function () {
        document.activeElement === e.$.input && e._highlightTimePartBasedOnCursor();
      }, 50)) : setTimeout(function () {
        e._mouseFocus = !0, e._highlightTimePartBasedOnCursor();
      }, 10));
    }
  }, {
    key: "_inputWheelHandler",
    value: function _inputWheelHandler(e) {
      var t = this,
          i = t.shadowRoot ? t.shadowRoot.activeElement : document.activeElement;
      i !== t.$.input || !t.enableMouseWheelAction || t.disabled || t.readonly || (e.preventDefault(), t._incrementDecrement(0 < e.deltaY));
    }
  }, {
    key: "_isRestricted",
    value: function _isRestricted(e) {
      var t = this.restrictedDates;
      var i = !1;

      for (var _a480 = 0; _a480 < t.length; _a480++) {
        if (e.equalDateParts(t[_a480])) {
          i = !0;
          break;
        }
      }

      return i;
    }
  }, {
    key: "_mouseoutHandler",
    value: function _mouseoutHandler(e) {
      var t = this,
          i = e.target;
      t.disabled || i !== t.$.input && i !== t.$.calendarButton || (i.removeAttribute("hover"), t.removeAttribute("hover"));
    }
  }, {
    key: "_mouseoverHandler",
    value: function _mouseoverHandler(e) {
      var t = this,
          i = e.target;
      t.disabled || i !== t.$.input && i !== t.$.calendarButton || (i.setAttribute("hover", ""), t.setAttribute("hover", ""));
    }
  }, {
    key: "_navigateToNextTimePart",
    value: function _navigateToNextTimePart() {
      var e = this;

      e._highlightTimePartBasedOnIndex(e._highlightedTimePart.index + 1);
    }
  }, {
    key: "_navigateToPreviousTimePart",
    value: function _navigateToPreviousTimePart() {
      var e = this;

      e._highlightTimePartBasedOnIndex(e._highlightedTimePart.index - 1);
    }
  }, {
    key: "_now",
    value: function _now() {
      var e = this,
          t = new Smart.Utilities.DateTime("today", "Local");
      return "Local" === e._outputTimeZone ? t : t.toTimeZone(e._outputTimeZone);
    }
  }, {
    key: "_open",
    value: function _open(e) {
      var t = this;
      if (t.disabled || t.readonly) return t.opened = !1, void t.$.calendarButton.setAttribute("aria-expanded", !1);
      var i = t.$.fireEvent("opening");
      if (i.defaultPrevented) return t.opened = !1, void t.$.calendarButton.setAttribute("aria-expanded", !1);
      t._edgeMacFF && t.$dropDownContainer.removeClass("not-in-view");
      var a = t.$.dropDownContainer;
      a.style.marginLeft = null, e || (a.style.transition = ""), t.$.calendarDropDown.disabled = !1, t.$calendarButton.addClass("smart-calendar-button-pressed"), t.$.calendarButton.setAttribute("active", ""), ("default" !== t._dropDownDisplayMode && "timePicker" !== t._dropDownDisplayMode || !t._timePickerInitialized || t._timePickerInitialized && t.$.timePickerDropDown.$.hasClass("smart-hidden")) && t.$calendarDropDown.removeClass("smart-hidden"), t.opened = !0, t.$.calendarButton.setAttribute("aria-expanded", !0), t._positionDetection.placeOverlay(), t._positionDetection.checkBrowserBounds("vertically"), t._positionDetection.positionDropDown();
      var n = 1 === window.devicePixelRatio ? document.documentElement.clientWidth : window.innerWidth,
          o = a.getBoundingClientRect();

      if (0 > o.left ? a.style.marginLeft = -1 * o.left + "px" : o.right > n && (a.style.marginLeft = n - o.right + "px"), t.$dropDownContainer.removeClass("smart-visibility-hidden"), t.$.fireEvent("open"), t._toSync) {
        var _e876 = t._value;
        if (null !== _e876) t._disregardCalendarChangeEvent = !0, t.$.calendarDropDown.selectedDates = [_e876.toDate()], t._defaultFooterTemplateApplied && (t._hourElement.value = _e876.toString("hh"), t._minuteElement.value = _e876.toString("mm"), t._ampmElement.value = _e876.toString("tt")), t._timePickerInitialized && (t.$.timePickerDropDown.value = _e876.toDate());else {
          var _e877 = t.$.calendarDropDown.context;
          t.$.calendarDropDown.context = t.$.calendarDropDown, t.$.calendarDropDown._clearSelection(!0), t.$.calendarDropDown.context = _e877, t._defaultFooterTemplateApplied && (t._hourElement.value = "", t._minuteElement.value = "", t._ampmElement.value = "");
        }
        t._toSync = !1;
      }

      var r;

      switch (t._dropDownDisplayMode) {
        case "default":
          r = t.$selectDate.hasClass("smart-selected") ? t.$.calendarDropDown : t.$.timePickerDropDown.$.picker;
          break;

        case "classic":
        case "calendar":
          r = t.$.calendarDropDown;
          break;

        case "timePicker":
          r = t.$.timePickerDropDown.$.picker;
      }

      t.hasAnimation ? t._toFocus = r : r.focus();
    }
  }, {
    key: "_positionExternalDropDown",
    value: function _positionExternalDropDown(e) {
      var t = this.context,
          i = !t.calendarButton || "right" === t.calendarButtonPosition,
          a = t._dropDownListPosition,
          n = t.$.dropDownContainer;
      var o = i ? e.right - n.offsetWidth : e.left,
          r;
      return "bottom" === a ? r = e.bottom : "overlay-top" === a ? r = e.bottom - n.offsetHeight : "overlay-center" === a ? r = e.top + e.height / 2 - n.offsetHeight / 2 : "overlay-bottom" === a ? r = e.top : "top" === a ? r = e.top - n.offsetHeight : "center-bottom" === a || "center-top" === a ? (r = "center-bottom" === a ? e.bottom + 5 : e.top - 5 - n.offsetHeight, o = i ? e.right - n.offsetWidth / 2 - t.$.calendarButton.offsetWidth / 2 : e.left - n.offsetWidth / 2 + t.$.calendarButton.offsetWidth / 2) : void 0, {
        left: o,
        top: r
      };
    }
  }, {
    key: "_rangeValidation",
    value: function _rangeValidation(e) {
      var t = this;
      return -1 === e.compare(t.min) ? t.min.clone() : 1 === e.compare(t.max) ? t.max.clone() : e;
    }
  }, {
    key: "_resetTimePart",
    value: function _resetTimePart() {
      var e = this,
          t = e._highlightedTimePart.code,
          i = e._codeToIndex[t],
          a = Smart.Utilities.DateTime.getConstructorParameters(e._value);
      var n;
      n = 2 < i ? 0 : 0 < i ? 1 : e.min.year(), a[i] = n, a.unshift(null), e._validateValue(new (Function.prototype.bind.apply(Smart.Utilities.DateTime, a))());
    }
  }, {
    key: "_setIds",
    value: function _setIds() {
      var e = this;
      e.$.label.id || (e.$.label.id = e.id + "Label"), e.$.input.id || (e.$.input.id = e.id + "Input"), e.$.calendarButton.id || (e.$.calendarButton.id = e.id + "CalendarButton"), e.$.dropDownContainer.id || (e.$.dropDownContainer.id = e.id + "DropDownContainer"), e.$.hint.id || (e.$.hint.id = e.id + "Hint");
    }
  }, {
    key: "_setDefaultFooterTemplate",
    value: function _setDefaultFooterTemplate(e) {
      var t = this;
      t.$.calendarDropDown.footerTemplate = t._defaultFooterTemplate, e && t.$.calendarDropDown._handleLayoutTemplate(t.$.calendarDropDown.$.footer, t._defaultFooterTemplate), t._hourElement = t.$.calendarDropDown.getElementsByClassName("smart-hour-element")[0], t._minuteElement = t.$.calendarDropDown.getElementsByClassName("smart-minute-element")[0], t._ampmElement = t.$.calendarDropDown.getElementsByClassName("smart-am-pm-element")[0], t._todayElement = t.$.calendarDropDown.getElementsByClassName("smart-today-element")[0], t._todayElement.title = t.localize("now"), Array.from(t.$.calendarDropDown.$.footer.getElementsByTagName("smart-repeat-button")).forEach(function (e) {
        e.animation = t.animation;
      }), t._addCalendarFooterListeners(), t._defaultFooterTemplateApplied = !0;
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      if (e.disabled || e.unfocusable) return e.$.input.tabIndex = -1, e.$.selectDate.removeAttribute("tabindex"), e.$.selectTime.removeAttribute("tabindex"), void (e._defaultFooterTemplateApplied && (e._hourElement.tabIndex = -1, e._ampmElement.tabIndex = -1, e._minuteElement.tabIndex = -1));
      var t = 0 < e.tabIndex ? e.tabIndex : 0;
      e.$.input.removeAttribute("tabindex"), e.$.selectDate.tabIndex = t, e.$.selectTime.tabIndex = t, e._defaultFooterTemplateApplied && (e._hourElement.removeAttribute("tabindex"), e._ampmElement.removeAttribute("tabindex"), e._minuteElement.removeAttribute("tabindex"), e.$.calendarDropDown.getElementsByClassName("smart-footer-component-today")[0].tabIndex = t);
    }
  }, {
    key: "_setNullValue",
    value: function _setNullValue(e) {
      var t = this;

      if (void 0 === e && (e = t._cloneValue()), t.nullable) {
        if (t._value = null, t.value = null, t._highlightedTimePart = void 0, t.$.input.value = "", null !== e) {
          if (t.opened) {
            if (!t._calendarInitiatedChange) {
              var _e878 = t.$.calendarDropDown.context;
              t.$.calendarDropDown.context = t.$.calendarDropDown, t.$.calendarDropDown._clearSelection(!0), t.$.calendarDropDown.context = _e878;
            }

            t._defaultFooterTemplateApplied && (t._hourElement.value = "", t._ampmElement.value = "", t._minuteElement.value = ""), t._toSync = !1;
          } else t._toSync = !0;

          t.$.fireEvent("change", {
            oldValue: e.toTimeZone(t._inputTimeZone),
            value: null
          });
        }

        t._disableSpinButtons();
      } else t._validateValue(t._now(), e);
    }
  }, {
    key: "_spinButtonsClickHandler",
    value: function _spinButtonsClickHandler(e) {
      var t = this;
      null === t._value || t.disabled || t.readonly || t._incrementDecrement(t.$.downButton.contains(e.target));
    }
  }, {
    key: "_validateInitialPropertyValues",
    value: function _validateInitialPropertyValues() {
      var e = this,
          t = e.$.calendarDropDown;
      "left" === e.calendarButtonPosition && e.$.content.insertBefore(e.$.calendarButton, e.$.input), "left" === e.spinButtonsPosition && e.$.content.insertBefore(e.$.spinButtonsContainer, e.$.input), e.disabled && (e.$.upButton.disabled = !0, e.$.downButton.disabled = !0), e.opened && (e.disabled || e.readonly ? e.opened = !1 : (e.$.dropDownContainer.style.transition = "none", e._open(!0))), e.$.calendarButton.setAttribute("aria-expanded", e.opened), null === e.footerTemplate ? e._setDefaultFooterTemplate(!0) : (t.footerTemplate = e.footerTemplate, t._handleLayoutTemplate(t.$.footer, e.footerTemplate)), "" === e.formatString && (e.formatString = "dd-MMM-yy HH:mm:ss.fff");
      var i = e.displayKind;
      "UTC" === i ? e._outputTimeZone = "UTC" : "local" === i && (e._outputTimeZone = "Local");
      var a;

      if (null === e.value ? (a = null, e._inputTimeZone = "Local") : (a = Smart.Utilities.DateTime.validateDate(e.value, new Smart.Utilities.DateTime(), e.formatString), e._inputTimeZone = a.timeZone, "unspecified" !== i && e._inputTimeZone !== e._outputTimeZone ? a = a.toTimeZone(e._outputTimeZone) : "unspecified" === i && (e._outputTimeZone = e._inputTimeZone)), e._validateRestrictedDates(), e._validateMinMax("both"), e._validateValue(a, e._now(), !1, !0), e._validateInterval(new Smart.Utilities.TimeSpan(0, 0, 1)), e._getFormatStringRegExp(), e._defaultFooterTemplateApplied && "" === e._hourElement.value && null !== e.value) {
        var _t755 = e.value;
        e._hourElement.value = _t755.toString("hh"), e._ampmElement.value = _t755.toString("tt"), e._minuteElement.value = _t755.toString("mm");
      }

      e._detectDisplayMode();

      var n = e._dropDownDisplayMode;
      "default" === n || "calendar" === n ? (t.viewSections = ["title", "header"], t.$title.hasClass("smart-hidden") && t.propertyChangedHandler("viewSections", ["header", "footer"], ["title", "header"]), "default" === n && e.$dropDownHeader.removeClass("smart-hidden")) : "timePicker" === n && (e.$calendarDropDown.addClass("smart-hidden"), e._initializeTimePicker());
    }
  }, {
    key: "_validateInterval",
    value: function _validateInterval(e) {
      var t = this,
          i = t.interval;
      var a = i;
      if (i instanceof Smart.Utilities.TimeSpan) a = i;else if ("string" == typeof i) {
        var _n358 = i.indexOf("TimeSpan("),
            _o254 = i.indexOf(")");

        if (-1 !== _n358 && -1 !== _o254 && (a = i.slice(_n358 + 9, _o254), a = a.replace(/'/g, "").replace(/"/g, "").replace(/^\s+|\s+$|\s+(?=\s)/g, ""), new RegExp(/(^(\d+)(,\s*\d+)*$)/g).test(a) && (a = a.replace(/\s/g, ""), a = a.split(","), a.map(function (e, t) {
          a[t] = parseInt(e);
        }), a.unshift(null), a = new (Function.prototype.bind.apply(Smart.Utilities.TimeSpan, a))())), !1 == a instanceof Smart.Utilities.TimeSpan) {
          if ("" === a.trim()) return void (t.interval = e);
          isNaN(a) || (a = 1e4 * parseInt(a, 10));

          try {
            a = new Smart.Utilities.TimeSpan(a);
          } catch (i) {
            return void (t.interval = e);
          }
        }
      } else if ("number" == typeof i) a = new Smart.Utilities.TimeSpan(i);else return void (t.interval = e);
      t.interval = 0 === a._ticks ? e : a;
    }
  }, {
    key: "_validateMinMax",
    value: function _validateMinMax(e, t) {
      var i = this;
      var a = !1;
      "max" !== e && (i.min = Smart.Utilities.DateTime.validateDate(i.min, t || new Smart.Utilities.DateTime(1600, 1, 1), i.formatString), i.min = i.min.toTimeZone(i._outputTimeZone), a = !0), "min" !== e && (i.max = Smart.Utilities.DateTime.validateDate(i.max, t || new Smart.Utilities.DateTime(3001, 1, 1), i.formatString), i.max = i.max.toTimeZone(i._outputTimeZone), i.max.calendar.days = i._localizedDays, i.max.calendar.months = i._localizedMonths, i.max.calendar.locale = i.locale, i.$.calendarDropDown.max = i.max.toDate()), 0 < i.min.compare(i.max) && (i.min = i.max.clone(), a = !0), a && (i.min.calendar.days = i._localizedDays, i.min.calendar.months = i._localizedMonths, i.min.calendar.locale = i.locale, i.$.calendarDropDown.min = i.min.toDate());
    }
  }, {
    key: "_validateRestrictedDates",
    value: function _validateRestrictedDates() {
      var e = this,
          t = [],
          a = [];

      for (var _n359 = 0; _n359 < e.restrictedDates.length; _n359++) {
        var _i747 = e.restrictedDates[_n359];

        var _o255 = Smart.Utilities.DateTime.validateDate(_i747, "invalid", e.formatString);

        "invalid" !== _o255 && (_o255 = _o255.toTimeZone(e._outputTimeZone), t.push(_o255), a.push(_o255.toDate()));
      }

      e.restrictedDates = t, e.$.calendarDropDown.restrictedDates = a;
    }
  }, {
    key: "_validateValue",
    value: function _validateValue(e, t, i, a) {
      var n = this,
          o = void 0 === t ? n._cloneValue() : t;
      if (null === e || "" === e) return void n._setNullValue(o);
      if (void 0 !== e && (n._value = Smart.Utilities.DateTime.validateDate(e, o, n.formatString)), null === n._value) return void n._setNullValue(o);
      var r = n._value;

      for (; !0 === n._isRestricted(r);) {
        r.addDays(1, !1);
      }

      var l = n._rangeValidation(r);

      a && "strict" !== n.validation ? !1 === r.equals(l) && (n._minMaxChanged = !0) : (n._value = l, delete n._minMaxChanged), n.value = n._value.toTimeZone(n._inputTimeZone);
      var s = n._value;

      if (s.calendar.days = n._localizedDays, s.calendar.months = n._localizedMonths, s.calendar.locale = n.locale, n._applyFormatString(), n._disableSpinButtons(), (null === o || null === s) && o !== s || null !== o && null !== s && 0 !== o.compare(s)) {
        if (!1 !== i && n.$.fireEvent("change", {
          oldValue: null === o ? null : o.toTimeZone(n._inputTimeZone),
          value: n.value
        }), n._calendarInitiatedChange) return;
        n.opened ? ((null === o || 0 === n.$.calendarDropDown.selectedDates.length || o.year() !== s.year() || o.month() !== s.month() || o.day() !== s.day() || !n.$.calendarDropDown._isDateInView(s.toDate())) && (n._disregardCalendarChangeEvent = !0, n.$.calendarDropDown.selectedDates = [s.toDate()]), n._defaultFooterTemplateApplied && ((null === o || o.hour() !== s.hour()) && (n._hourElement.value = s.toString("hh"), n._ampmElement.value = s.toString("tt")), (null === o || o.minute() !== s.minute()) && (n._minuteElement.value = s.toString("mm"))), n._timePickerInitialized && !n._timePickerInitiatedChange && (n.$.timePickerDropDown.value = s.toDate()), n._toSync = !1) : n._toSync = !0;
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        animationSettings: {
          value: null,
          type: "object"
        },
        autoClose: {
          value: !1,
          type: "boolean"
        },
        autoCloseDelay: {
          value: 0,
          type: "number"
        },
        calendarButton: {
          value: !1,
          type: "boolean"
        },
        calendarButtonPosition: {
          value: "right",
          allowedValues: ["left", "right"],
          type: "string"
        },
        calendarMode: {
          value: "default",
          allowedValues: ["default", "classic"],
          type: "string"
        },
        dayNameFormat: {
          value: "firstTwoLetters",
          allowedValues: ["narrow", "firstTwoLetters", "long", "short"],
          type: "string"
        },
        disableAutoNavigation: {
          value: !1,
          type: "boolean"
        },
        displayKind: {
          value: "unspecified",
          allowedValues: ["UTC", "local", "unspecified"],
          type: "string"
        },
        displayModeView: {
          value: "table",
          allowedValues: ["table", "list"],
          type: "string"
        },
        displayMode: {
          allowedValues: ["outlined", "filled", "underlined"],
          value: "outlined",
          type: "string"
        },
        dropDownAppendTo: {
          value: null,
          type: "any"
        },
        dropDownDisplayMode: {
          value: "default",
          allowedValues: ["default", "classic", "calendar", "timePicker", "auto"],
          type: "string"
        },
        dropDownOverlay: {
          value: !1,
          type: "boolean"
        },
        dropDownPosition: {
          value: "auto",
          allowedValues: ["auto", "bottom", "overlay-top", "overlay-center", "overlay-bottom", "top", "center-bottom", "center-top"],
          type: "string"
        },
        editMode: {
          value: "default",
          allowedValues: ["default", "full", "partial"],
          type: "string"
        },
        enableMouseWheelAction: {
          value: !1,
          type: "boolean"
        },
        firstDayOfWeek: {
          value: 0,
          type: "number"
        },
        footerTemplate: {
          value: null,
          type: "any"
        },
        formatString: {
          value: "dd-MMM-yy HH:mm:ss.fff",
          type: "string"
        },
        headerTemplate: {
          value: null,
          type: "any"
        },
        hideDayNames: {
          value: !1,
          type: "boolean"
        },
        hideOtherMonthDays: {
          value: !1,
          type: "boolean"
        },
        hideTooltipArrow: {
          value: !1,
          type: "boolean"
        },
        hint: {
          value: "",
          type: "string"
        },
        importantDates: {
          value: [],
          type: "array"
        },
        importantDatesTemplate: {
          value: null,
          type: "any"
        },
        interval: {
          value: new Smart.Utilities.TimeSpan(0, 0, 1),
          type: "any"
        },
        label: {
          value: "",
          type: "string"
        },
        max: {
          value: new Smart.Utilities.DateTime(3001, 1, 1),
          type: "any"
        },
        messages: {
          value: {
            en: {
              now: "Now",
              dateTabLabel: "DATE",
              timeTabLabel: "TIME"
            }
          },
          type: "object",
          extend: !0
        },
        min: {
          value: new Smart.Utilities.DateTime(1600, 1, 1),
          type: "any"
        },
        name: {
          value: "",
          type: "string"
        },
        nullable: {
          value: !1,
          type: "boolean"
        },
        opened: {
          value: !1,
          type: "boolean"
        },
        placeholder: {
          value: "Enter date",
          type: "string"
        },
        restrictedDates: {
          value: [],
          type: "array"
        },
        spinButtons: {
          value: !1,
          type: "boolean"
        },
        spinButtonsDelay: {
          value: 75,
          type: "number"
        },
        spinButtonsInitialDelay: {
          value: 0,
          type: "number"
        },
        spinButtonsPosition: {
          value: "right",
          allowedValues: ["left", "right"],
          type: "string"
        },
        tooltip: {
          value: !1,
          type: "boolean"
        },
        tooltipDelay: {
          value: 100,
          type: "number"
        },
        tooltipPosition: {
          value: "top",
          allowedValues: ["bottom", "top", "left", "right", "absolute"],
          type: "string"
        },
        tooltipTemplate: {
          value: null,
          type: "any"
        },
        validation: {
          value: "strict",
          allowedValues: ["strict", "interaction"],
          type: "string"
        },
        value: {
          defaultReflectToAttribute: !0,
          value: new Smart.Utilities.DateTime(),
          type: "any"
        },
        weekNumbers: {
          value: !1,
          type: "boolean"
        },
        weeks: {
          value: 6,
          type: "number"
        },
        yearCutoff: {
          value: 1926,
          type: "number"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "container.mouseout": "_mouseoutHandler",
        "container.mouseover": "_mouseoverHandler",
        "calendarButton.click": "_calendarButtonClickHandler",
        "calendarDropDown.change": "_calendarDropDownChangeHandler",
        "calendarDropDown.click": "_calendarDropDownClickHandler",
        "downButton.click": "_spinButtonsClickHandler",
        "input.blur": "_inputBlurHandler",
        "input.change": "_inputChangeHandler",
        "input.dragstart": "_inputDragstartHandler",
        "input.focus": "_inputFocusHandler",
        "input.keydown": "_inputKeydownHandler",
        "input.down": "_inputDownHandler",
        "input.paste": "_inputPasteHandler",
        "input.select": "_inputSelectHandler",
        "input.up": "_inputUpHandler",
        "input.wheel": "_inputWheelHandler",
        "dropDownContainer.keydown": "_dropDownKeydownHandler",
        "dropDownContainer.transitionend": "_dropDownTransitionendHandler",
        "dropDownHeader.click": "_dropDownHeaderClickHandler",
        "upButton.click": "_spinButtonsClickHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Utilities.DateTime": "smart.date.js",
        "Smart.Utilities.Draw": "smart.draw.js",
        "Smart.Utilities.BigNumber": "smart.math.js",
        "Smart.Utilities.NumericProcessor": "smart.numeric.js",
        "Smart.RepeatButton": "smart.button.js",
        "Smart.Calendar": "smart.calendar.js",
        "Smart.TimePicker": "smart.timepicker.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.datetimepicker.css"];
    }
  }]);

  return _class80;
}(Smart.BaseElement)), Smart("smart-docking-layout",
/*#__PURE__*/
function (_Smart$ContentElement8) {
  "use strict";

  _inherits(_class81, _Smart$ContentElement8);

  function _class81() {
    _classCallCheck(this, _class81);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class81).apply(this, arguments));
  }

  _createClass(_class81, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <smart-splitter id=\"horizontalHiddenItemsContainer\" class=\"smart-horizontal-hidden-items-container\" orientation=\"horizontal\">\n                        <smart-splitter-item class=\"smart-docking-layout-item-holder\">\n                            <smart-splitter id=\"verticalHiddenItemsContainer\" class=\"smart-vertical-hidden-items-container\">\n                                <smart-splitter-item class=\"smart-docking-layout-item-holder\">\n                                    <smart-splitter id=\"itemsContainer\" class=\"smart-items-container\">\n                                        <content></content>\n                                        <smart-splitter-item id=\"placeholderItem\" class=\"smart-placeholder\" pinned>\n                                            <smart-tabs-window tab-position=\"hidden\" opened header-buttons='[]'>\n                                                <smart-tab-item></smart-tab-item>\n                                            </smart-tabs-window>\n                                        </smart-splitter-item>\n                                    </smart-splitter>\n                                </smart-splitter-item>\n                            </smart-splitter>\n                        </smart-splitter-item>\n                    </smart-splitter>\n                    <smart-tabs-window id=\"tabsWindowFeedback\" class=\"smart-tabs-window-feedback smart-hidden\"></smart-tabs-window>\n                    <smart-tabs-window id=\"autoHideWindow\" class=\"smart-docking-layout-auto-hide-window\" pinned header-buttons='[\"close\", \"dock\"]' tab-position=\"hidden\">\n                        <smart-tab-item></smart-tab-item>\n                    </smart-tabs-window>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, a) {
      var i = this;

      switch (e) {
        case "autoSaveState":
          i._handleAutoSave();

          break;

        case "layout":
          i._handleLayout();

          break;

        case "liveResize":
        case "resizeStep":
          {
            var _t756 = i.getElementsByTagName("smart-splitter");

            for (var _n360 = 0; _n360 < _t756.length; _n360++) {
              _t756[_n360][e] = a;
            }

            "liveResize" === e && (i.$.autoHideWindow[e] = a);
            break;
          }

        case "snapMode":
          i._handleSnapping(), i._snapFeedback = void 0;
          break;

        case "hideSplitterBars":
          i._setSplitterBarVisibility();

          break;

        default:
          _get(_getPrototypeOf(_class81.prototype), "propertyChangedHandler", this).call(this, e, t, a);

      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class81.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;

      if (e.autoLoadState) {
        var _t757 = e.loadState();

        _t757 && (e.layout = _t757);
      }

      e.$.itemsContainer.liveResize = e.liveResize, e.$.itemsContainer.resizeStep = e.resizeStep, e._handleLayout(), e.$tabsWindowFeedback.removeClass("smart-hidden"), e._setFocusable(), e.checkLicense(), _get(_getPrototypeOf(_class81.prototype), "render", this).call(this);
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e879 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e879.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? e instanceof Smart.TabsWindow ? void t.insertBefore(e, null) : void t.error(t.localize("invalidNodeType", {
        elementType: t.nodeName.toLowerCase(),
        method: "appendChild"
      })) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "appendChild"
      }));
    }
  }, {
    key: "autoHideBottom",
    value: function autoHideBottom(e) {
      this._autoHide(e, "bottom");
    }
  }, {
    key: "autoHideLeft",
    value: function autoHideLeft(e) {
      this._autoHide(e, "left");
    }
  }, {
    key: "autoHideRight",
    value: function autoHideRight(e) {
      this._autoHide(e, "right");
    }
  }, {
    key: "autoHideTop",
    value: function autoHideTop(e) {
      this._autoHide(e, "top");
    }
  }, {
    key: "clearState",
    value: function clearState() {
      var e = this;
      return e.id ? void window.localStorage.removeItem("smartDockingLayout" + e.id) : void e.warn(e.localize("noId"));
    }
  }, {
    key: "dock",
    value: function dock(e) {
      this._dock(e);
    }
  }, {
    key: "undock",
    value: function undock(e) {
      var t = this;
      if ("number" == typeof e ? e = t._items[e] : "string" == typeof e && (e = t._getItemById(e)), !e) return;
      if (!(t.shadowRoot || t).contains(e) && t._getClosestDockingLayout(e) !== t) return;
      var i = e.getRootNode() && e.getRootNode().host ? e.getRootNode().host : void 0,
          a = e.closest("smart-splitter-item") || (i ? i.closest("smart-splitter-item") : void 0);
      if (!a) return;
      var n = a.getBoundingClientRect();
      var o;

      if (e instanceof Smart.TabsWindow) {
        e.autoHide ? (t.$.autoHideWindow.close(), e._autoHideWindow && (e.style.width = e._autoHideWindow.offsetWidth + "px", e.style.height = e._autoHideWindow.offsetHeight + "px"), "left" === e.tabPosition || "right" === e.tabPosition ? e.style.height = t.offsetHeight + "px" : e.style.width = t.offsetWidth + "px") : (e.style.width = e.offsetWidth + "px", e.style.height = e.offsetHeight + "px"), e.windowParent = "body", e.opened = !0, e.autoHide && (e.tabPosition = "top"), e.autoHide = e.allowToggle = e.pinned = !1, e.style.maxWidth = e.style.maxHeight = "", o = e;

        var _i748 = a.closest("smart-splitter");

        _i748.removeChild(a), t._removeUnneccessaryItems(_i748);
      } else if (e instanceof Smart.TabItem) {
        var _n361 = e.closest("smart-tabs-window") || (i ? i.closest("smart-tabs-window") : void 0);

        var _r159;

        1 === _n361.items.length ? (_r159 = _n361, a.closest("smart-splitter").removeChild(a)) : (_r159 = t._createTabsWindowFromObject({
          label: e.label
        }), _n361.removeChild(e), _r159.appendChild(e)), "body" !== _r159.windowParent && (_r159.windowParent = "body"), _r159.parentElement !== document.body && document.body.appendChild(_r159), _r159.allowToggle = _r159.autoHide = _r159.pinned = !1, _r159.label = e.label, _r159.opened = !0, _r159._parentInfo = {
          closestItem: _n361,
          position: e.index
        }, o = _r159, e = _n361;
      } else return;

      e._originalTabPosition ? o.tabPosition = e._originalTabPosition : e.autoHide && (o.tabPosition = "top"), o.tabTextOrientation = e._originalTextOrientation || "horizontal", o === e && (delete o._originalTabPosition, delete o._originalTextOrientation), t._setFloatingItemsHeaderButtons(o), o.style.left = n.left + "px", o.style.top = n.top + "px", o.resizeMode = "both";

      var r = t._items.indexOf(e);

      if (o.layout = t, -1 < r && (t._items.splice(r, 1), o.position && (o.style.top = o.position.top, o.style.left = o.position.left, delete o.position)), 0 !== t._items.filter(function (e) {
        return e.opened;
      }).length || t.$.placeholderItem.parentElement || t.$.itemsContainer.appendChild(t.$.placeholderItem), t._validateWindowPosition(o), t._setAutoHidePaddings(), t._noStateChangeFiring || (t._handleAutoSave(), t.$.fireEvent("stateChange", {
        type: "float",
        item: o
      })), document.activeElement !== o) {
        var _e880 = document.scrollingElement || document.documentElement,
            _t758 = _e880.scrollLeft,
            _i749 = _e880.scrollTop;

        o.focus(), o.bringToFront(), window.scrollTo(_t758, _i749);
      }
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t, i) {
      var a = this;

      if (!a.isCompleted) {
        var _e881 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(a, _e881.concat(Array.prototype.slice.call(arguments)));
      }

      var n = e;
      n instanceof Smart.TabsWindow ? (e = document.createElement("smart-splitter-item"), e.size = n.size || "", e.max = n.max || "", e.min = n.min || "", e.locked = n.locked || !1, e.collapsible = n.collapsible || !1, e.collapsed = n.collapsed || !1, e.appendChild(n)) : n instanceof Smart.SplitterItem ? n = n.querySelector("smart-tabs-window") : a.error(a.localize("invalidNodeType", {
        elementType: a.nodeName.toLowerCase(),
        method: "insertBefore"
      })), n.opened = n.pinned = !0, n.style.width = n.style.height = "", n.style.top = n.style.left = "", n.style.paddingTop = n.style.paddingBottom = "", n.style.paddingLeft = n.style.paddingRight = "", e.style.top = e.style.left = "";
      var o;

      if (t) {
        if (o = t.closest("smart-splitter"), o === a.$.verticalHiddenItemsContainer || o === a.$.horizontalHiddenItemsContainer ? (o = a.$.itemsContainer, t = 0 === a._items.length ? null : "top" === t.tabPosition || "left" === t.tabPosition ? a._items[0] : a._items[a._items.length - 1]) : i && (o = a.$.itemsContainer), !(t instanceof Smart.TabsWindow)) return void a.error(a.localize("invalidNodeType", {
          elementType: a.nodeName.toLowerCase(),
          method: "insertBefore"
        }));
        o.autoFitMode = "end", o.insertBefore(e, o._items.filter(function (e) {
          return e.contains(t);
        })[0]), a._items.splice(a._items.indexOf(t), 0, n);
      } else o = a.$.itemsContainer, a._dockingAutoHideTabItem && (o.autoFitMode = "end"), a._items.push(n), a.$.itemsContainer.insertBefore(e);

      if (o.autoFitMode = "proportional", n.autoHide) a._autoHide(n, n.autoHidePosition);else {
        n.autoHide = n.allowToggle = !1, n._originalTabPosition && (n.tabPosition = n._originalTabPosition, delete n._originalTabPosition), n._originalTextOrientation && (n.tabTextOrientation = n._originalTextOrientation, delete n._originalTextOrientation), a._setDockedItemsHeaderButtons(n);

        var _e882 = document.scrollingElement || document.documentElement,
            _t759 = _e882.scrollLeft,
            _i750 = _e882.scrollTop;

        n.focus(), window.scrollTo(_t759, _i750);
      }
      0 < a._items.filter(function (e) {
        return e.opened;
      }).length && a.$.placeholderItem.parentElement && a.$.itemsContainer.removeChild(a.$.placeholderItem), n.layout = a, n.minimized = !1, n.maximized = !1, n.locked = !1, n.resizeMode = "none", a._handleAutoHiddenSplitterBars(), a._setSplitterBarVisibility(), a._handleAutoSave(), a.$.fireEvent("stateChange", {
        type: "dock",
        item: n
      });
    }
  }, {
    key: "insertBeforeItem",
    value: function insertBeforeItem(e, t) {
      this._insert(e, t, "top", "insertBeforeItem");
    }
  }, {
    key: "insertAfterItem",
    value: function insertAfterItem(e, t) {
      this._insert(e, t, "bottom", "insertAfterItem");
    }
  }, {
    key: "insertIntoLeft",
    value: function insertIntoLeft(e, t) {
      this._insert(e, t, "inside-left", "insertIntoLeft");
    }
  }, {
    key: "insertIntoRight",
    value: function insertIntoRight(e, t) {
      this._insert(e, t, "inside-right", "insertIntoRight");
    }
  }, {
    key: "insertIntoTop",
    value: function insertIntoTop(e, t) {
      this._insert(e, t, "inside-top", "insertIntoTop");
    }
  }, {
    key: "insertIntoBottom",
    value: function insertIntoBottom(e, t) {
      this._insert(e, t, "inside-bottom", "insertIntoBottom");
    }
  }, {
    key: "insertLayoutTop",
    value: function insertLayoutTop(e) {
      this._insert(0, e, "layout-top", "insertLayoutTop");
    }
  }, {
    key: "insertLayoutBottom",
    value: function insertLayoutBottom(e) {
      this._insert(0, e, "layout-bottom", "insertLayoutBottom");
    }
  }, {
    key: "insertLayoutLeft",
    value: function insertLayoutLeft(e) {
      this._insert(0, e, "layout-left", "insertLayoutLeft");
    }
  }, {
    key: "insertLayoutRight",
    value: function insertLayoutRight(e) {
      this._insert(0, e, "layout-right", "insertLayoutRight");
    }
  }, {
    key: "insertOutsideTargetGroupTop",
    value: function insertOutsideTargetGroupTop(e, t) {
      this._insert(e, t, "outside-top", "insertOutsideTargetGroupTop");
    }
  }, {
    key: "insertOutsideTargetGroupBottom",
    value: function insertOutsideTargetGroupBottom(e, t) {
      this._insert(e, t, "outside-bottom", "insertOutsideTargetGroupBottom");
    }
  }, {
    key: "insertOutsideTargetGroupLeft",
    value: function insertOutsideTargetGroupLeft(e, t) {
      this._insert(e, t, "outside-left", "insertOutsideTargetGroupLeft");
    }
  }, {
    key: "insertOutsideTargetGroupRight",
    value: function insertOutsideTargetGroupRight(e, t) {
      this._insert(e, t, "outside-right", "insertOutsideTargetGroupRight");
    }
  }, {
    key: "getAutoHideItems",
    value: function getAutoHideItems(e) {
      function t(e) {
        var t = [];
        if (!e._items) return t;

        for (var _a481 = 0; _a481 < e._items.length; _a481++) {
          e._items[_a481].$.hasClass("smart-docking-layout-item-holder") || t.push(e._items[_a481].getElementsByTagName("smart-tabs-window")[0]);
        }

        return t;
      }

      var i = this;
      return e ? "horizontal" === e ? t(i.$.horizontalHiddenItemsContainer) : t(i.$.verticalHiddenItemsContainer) : t(i.$.horizontalHiddenItemsContainer).concat(t(i.$.verticalHiddenItemsContainer));
    }
  }, {
    key: "getIndex",
    value: function getIndex(e) {
      var t = this;
      return t.isReady ? t._items.length ? t._items.indexOf(e) : void 0 : void 0;
    }
  }, {
    key: "getItemGroupElement",
    value: function getItemGroupElement(e) {
      var t = this;
      return t.isReady && e && e instanceof Smart.TabsWindow && (t.shadowRoot || t).contains(e) ? e.closest("smart-splitter") : void 0;
    }
  }, {
    key: "getState",
    value: function getState(e) {
      var t = this,
          a = t.getAutoHideItems(),
          n = t.undockedItems,
          o = [];

      for (var _n362 = 0; _n362 < a.length; _n362++) {
        o.push(t._createTabsWindowStructure(a[_n362], e));
      }

      for (var _a482 = 0; _a482 < n.length; _a482++) {
        o.push(t._createTabsWindowStructure(n[_a482], e));
      }

      return [{
        type: "LayoutGroup",
        items: o.concat(t._createLayoutStructure(t.$.itemsContainer, e)),
        orientation: t.$.itemsContainer.orientation
      }];
    }
  }, {
    key: "getClosestSplitterBars",
    value: function getClosestSplitterBars(e) {
      var t = this;
      if (!t._items || !t._items.length) return;
      if ("string" == typeof e ? e = t._getItemById(e) : "number" == typeof e && (e = t._items[parseInt(e)]), !(e instanceof Smart.TabsWindow) || !t._items.find(function (t) {
        return t === e;
      })) return;
      var i = e.closest("smart-splitter");

      for (; i && !i.bars.length;) {
        i = i.closest("smart-splitter");
      }

      if (i) return i.bars;
    }
  }, {
    key: "getJSONStructure",
    value: function getJSONStructure() {
      return this.getState(!0);
    }
  }, {
    key: "loadState",
    value: function loadState(e) {
      var t = this;

      if (!e) {
        if (!t.id) return void t.warn(t.localize("noId"));
        e = JSON.parse(window.localStorage.getItem("smartDockingLayout" + t.id));
      }

      return e ? (t._loadState(e), e) : void 0;
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this;
      return "number" == typeof e ? e = t._items[e] : "string" == typeof e && (e = t._getItemById(e)), e instanceof Smart.TabsWindow ? e.closest("smart-docking-layout") !== t && t._getClosestDockingLayout(e) !== t ? void t.error(t.localize("invalidNodeRemove", {
        elementType: t.nodeName.toLowerCase(),
        method: "remove"
      })) : void t.removeChild(e) : void t.error(t.localize("invalidIndex", {
        elementType: t.nodeName.toLowerCase(),
        method: "remove"
      }));
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      this._removeAll();
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;
      if (!e) return void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "removeChild"
      }));
      if (!(e instanceof Smart.TabsWindow)) return void t.error(t.localize("invalidNodeType", {
        elementType: t.nodeName.toLowerCase(),
        method: "removeChild"
      }));

      if (!t.isCompleted) {
        var _e883 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e883.concat(Array.prototype.slice.call(arguments)));
      }

      var i = e.closest("smart-splitter-item");

      if (i) {
        var _a483 = i.closest("smart-splitter");

        _a483 && (i.closest("smart-splitter").removeChild(i), t._items.splice(t._items.indexOf(e), 1), t._removeUnneccessaryItems(_a483), 0 === t._items.filter(function (e) {
          return e.opened;
        }).length && !t.$.placeholderItem.parentElement && t.$.itemsContainer.appendChild(t.$.placeholderItem), e.layout = t, t._handleAutoSave(), t.$.fireEvent("stateChange", {
          type: "remove",
          item: e
        }));
      }
    }
  }, {
    key: "saveState",
    value: function saveState() {
      var e = this;
      return e.id ? void window.localStorage.setItem("smartDockingLayout" + e.id, JSON.stringify(e.getJSONStructure())) : void e.warn(e.localize("noId"));
    }
  }, {
    key: "update",
    value: function update(e, t) {
      var i = this;
      if ("number" == typeof e ? e = i._items[parseInt(e)] : "string" == typeof e && (e = i._getItemById(e)), !e || !(e instanceof Smart.TabsWindow)) return void i.error(i.localize("invalidNodeType", {
        elementType: i.nodeName.toLowerCase(),
        method: "update"
      }));

      if (((i.shadowRoot || i).contains(e) || i._getClosestDockingLayout(e) === i) && t && "object" == typeof t) {
        if (t.items) for (var _a485 = 0; _a485 < t.items.length; _a485++) {
          e.update(t.items[_a485].index, t.items[_a485].label, t.items[_a485].content);
        }
        t.id && (e.id = t.id), t.label && (e.label = t.label), e.tabCloseButtons = t.tabCloseButtons || !1, t.headerButtons && Array.isArray(t.headerButtons) && (e.headerButtons = 0 === t.headerButtons.length ? ["close", "autoHide"] : t.headerButtons);

        var _a484 = e.closest("smart-splitter-item");

        _a484 && (e.autoHide ? i._autoHide(e) : (_a484.size = void 0 === t.size ? _a484.size : t.size, _a484.min = void 0 === t.min ? _a484.min : t.min, _a484.max = void 0 === t.max ? _a484.max : t.max, _a484.locked = void 0 === t.locked ? _a484.locked : t.locked, _a484.collapsible = void 0 === t.collapsible ? _a484.collapsible : t.collapsible, _a484.collapsed = void 0 === t.collapsed ? _a484.collapsed : t.collapsed));
      }
    }
  }, {
    key: "_autoHide",
    value: function _autoHide(e, t) {
      var i = this;
      if ("number" == typeof e ? e = i._items[e] : "string" == typeof e && (e = i._getItemById(e)), !e) return;

      if (e instanceof Smart.TabItem) {
        var _a486 = e.closest("smart-tabs-window") || (e.getRootNode() && e.getRootNode().host ? e.getRootNode().host.closest("smart-tabs-window") : void 0);

        if (_a486 && 2 > _a486.items.length) e = _a486;else {
          var _n363 = e;

          if (_a486) {
            if (_a486.autoHide && _a486.tabPosition === t) return;

            _a486.removeChild(e);
          }

          e = i._createTabsWindowFromObject({
            label: e.label
          }), e.appendChild(_n363);
        }
      }

      if (!(e instanceof Smart.TabsWindow)) return void i.error(i.localize("invalidNodeType", {
        elementType: i.nodeName.toLowerCase(),
        method: "appendChild"
      }));
      var a = e.closest("smart-splitter-item"),
          n;

      var o = e.closest("smart-splitter") || (e.isInShadowDOM ? e.getRootNode().host : void 0) || i.$.itemsContainer,
          r = i._getAutoHidePositionDetails(t, e, a),
          l = r.autoHideSplitter;

      t = r.position, e.offsetHeight && (n = "left" === t || "right" === t ? e.offsetWidth : e.offsetHeight), a || (a = document.createElement("smart-splitter-item"), a.appendChild(e)), a.min = 30;
      var s = "auto-hide-" + t;

      if (!(e.autoHide && a.$.hasClass(s))) {
        var _r160 = i._items.indexOf(e);

        i._items.splice(_r160, -1 < _r160 ? 1 : 0), 0 !== i._items.filter(function (e) {
          return e.opened;
        }).length || i.$.placeholderItem.parentElement || ("left" === t ? i.$.itemsContainer.insert(1, i.$.placeholderItem) : i.$.itemsContainer.appendChild(i.$.placeholderItem)), i._handleAutoHideWindow({
          position: t,
          tabsWindow: e,
          splitterItem: a,
          autoHideName: s,
          splitterContainer: o,
          autoHideSplitter: l
        }), l.bars.map(function (e) {
          return e.hide();
        }), (!i.shadowRoot || i.shadowRoot && i.isCompleted) && i._setAutoHidePaddings();
        var d = e.items;
        if (d) for (var _e884 = 0; _e884 < d.length; _e884++) {
          d[_e884]._autoHideWindowSize || (d[_e884]._autoHideWindowSize = n);
        }
        i.$.autoHideWindow.opened && i.$.autoHideWindow._tabsWindow && i.$.autoHideWindow._tabsWindow._setAutoHideWindowSize(i.$.autoHideWindow._tabsWindow.selectedIndex), i.isCompleted && (i._handleAutoSave(), i.$.fireEvent("stateChange", {
          type: "autoHide",
          item: e
        }), i.shadowRoot && setTimeout(function () {
          "top" === t || "bottom" === t ? (i.$.horizontalHiddenItemsContainer.items.filter(function (e) {
            return -1 < e.className.indexOf("auto-hide-");
          }).forEach(function (e) {
            var t = e.querySelector("smart-tabs-window");
            e.style.height = "", t.refreshTabs();
          }), i.$.horizontalHiddenItemsContainer.refresh()) : (i.$.verticalHiddenItemsContainer.items.filter(function (e) {
            return -1 < e.className.indexOf("auto-hide-");
          }).forEach(function (e) {
            var t = e.querySelector("smart-tabs-window");
            e.style.width = "", t.refreshTabs();
          }), i.$.verticalHiddenItemsContainer.refresh()), i._setAutoHidePaddings();
        }, 150));
      }
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler() {
      this.hasAttribute("dragged") && "touchmove" === event.originalEvent.type && event.originalEvent.preventDefault();
    }
  }, {
    key: "_getAutoHidePositionDetails",
    value: function _getAutoHidePositionDetails(e, t, i) {
      var a = this,
          n = t.closest("smart-splitter") || a.$.itemsContainer,
          o = n ? n._items.indexOf(i) : 0;
      var r;

      switch (e) {
        case "top":
        case "bottom":
          r = a.$.horizontalHiddenItemsContainer;
          break;

        case "left":
        case "right":
          r = a.$.verticalHiddenItemsContainer;
          break;

        default:
          if ("vertical" === n.orientation) {
            r = a.$.verticalHiddenItemsContainer;

            var _t760 = r.items.filter(function (e) {
              return -1 < e.className.indexOf("auto-hide-");
            });

            e = 1 === _t760.length && 1 === a._items.length ? _t760[0].$.hasClass("auto-hide-right") ? "right" : "left" : o >= n.items.length / 2 ? "right" : "left";
          } else {
            r = a.$.horizontalHiddenItemsContainer;

            var _t761 = r.items.filter(function (e) {
              return -1 < e.className.indexOf("auto-hide-");
            });

            e = 1 === _t761.length && 1 === a._items.length ? _t761[0].$.hasClass("auto-hide-bottom") ? "bottom" : "top" : o >= n.items.length / 2 ? "bottom" : "top";
          }

      }

      return {
        autoHideSplitter: r,
        position: e
      };
    }
  }, {
    key: "_handleAutoHideWindow",
    value: function _handleAutoHideWindow(e) {
      var t = this,
          i = e.autoHideName,
          a = e.splitterItem,
          n = e.splitterContainer,
          o = e.position,
          r = e.autoHideSplitter;
      var l = e.tabsWindow,
          s = (t.shadowRoot || t).querySelector("." + i),
          d = "offset" + ("left" === o || "right" === o ? "Width" : "Height");

      if (l.locked = !1, s) {
        var _e885 = [].slice.call(l.isCompleted ? l.items : l.children),
            _o256 = s.querySelector("smart-tabs-window"),
            _r161 = _o256.items.length;

        for (var _t762 = 0; _t762 < _e885.length; _t762++) {
          _o256.insert(_r161, {
            node: _e885[_t762]
          }), _e885[_t762]._autoHideWindowSize = l[d];
        }

        a.parentElement && n.removeChild(a), t._removeUnneccessaryItems(n), l = _o256;
      } else {
        n && n.contains(a) && n.removeChild(a), (t._initializingItems || !l.autoHide) && (l._originalTabPosition = l.tabPosition, l._originalTextOrientation = l.tabTextOrientation, l._originalLocked = l.locked), l.autoHideWindow = t.$.autoHideWindow, l.autoHide = l.allowToggle = !0, l.selectedIndex = null, l.$.tabsElement && l.$.tabsElement.selectedIndex !== l.selectedIndex && (l.$.tabsElement.selectedIndex = l.selectedIndex), l.tabTextOrientation = "right" === o || "left" === o ? "vertical" : "horizontal", l.tabPosition = o, l.style.top = l.style.left = "", l.style.width = l.style.height = "", l.opened = !0, l.resizeMode = "none";

        for (var _e886 = 0; _e886 < a.classList.length; _e886++) {
          -1 < a.classList[_e886].indexOf("auto-hide-") && a.$.removeClass(a.classList[_e886]);
        }

        if (a.$.addClass(i), a.style.paddingLeft = a.style.paddingRight = a.style.paddingTop = a.style.paddingBottom = "", a.min && (a.min = ""), t._removeUnneccessaryItems(n), "top" === o || "left" === o ? r.insert(0, a) : r.appendChild(a), r.autoFitMode = "proportional", Smart.Utilities.Core.Browser.Safari && ("left" === o || "right" === o)) {
          var _e887 = l.querySelector(".smart-tab-strip");

          l.size = _e887.offsetWidth;
        } else {
          if (Smart.Utilities.Core.Browser.Firefox && ("top" === o || "bottom" === o)) {
            var _e888 = (l.shadowRoot || l).querySelector(".smart-tab-strip");

            _e888 && (l.size = _e888.offsetHeight);
          }

          l.size = "auto";
        }

        l.min && (l.min = ""), l.min = 30, l.locked = !0, r.autoFitMode = "end";
      }
    }
  }, {
    key: "_autoHideWindowCloseHandler",
    value: function _autoHideWindowCloseHandler() {
      var e = this,
          t = e.$.autoHideWindow._tabsWindow,
          i = document.scrollingElement || document.documentElement,
          a = i.scrollLeft,
          n = i.scrollTop;
      return t._moveContent(t._autoHideWindow.items[0], t._autoHideWindow._tab), e.$.autoHideWindow.opened ? void (!t.allowToggle || null !== t.$.tabsElement.selectedIndex && (t.select(t.$.tabsElement.selectedIndex), document.activeElement !== t.$.tabsElement && (t.$.tabsElement.focus(), window.scrollTo(a, n)))) : (t.selectedIndex = null, void (document.activeElement !== t.$.tabsElement && (t.$.tabsElement.focus(), window.scrollTo(a, n))));
    }
  }, {
    key: "_autoHideWindowResizeEndHandler",
    value: function _autoHideWindowResizeEndHandler(e) {
      var t = e.target,
          i = "left" === t.resizeMode || "right" === t.resizeMode ? "width" : "height";
      t._tab && (t._tab._autoHideWindowSize = e.detail[i]);
    }
  }, {
    key: "_cancelDragOperation",
    value: function _cancelDragOperation(e) {
      var t = this;
      t.removeAttribute("dragged"), t._dragDetails.windowFeedback.removeAttribute("tabs-window-dragged"), t._dragDetails.windowFeedback.removeAttribute("ontop"), t._returnItemToOrigin(t._dragDetails.windowFeedback), t._noStateChangeFiring = !0, e || t._endDrag();
    }
  }, {
    key: "_createTabsWindowFromObject",
    value: function _createTabsWindowFromObject(e, t) {
      var a = document.createElement("smart-tabs-window");
      var i = ["close", "autoHide"],
          n;
      if (a.layout = this, e.id && (a.id = e.id), e.disabled && (a.disabled = e.disabled), e.label && (a.label = e.label), e.headerPosition && (a.headerPosition = e.headerPosition), e.tabCloseButtons && (a.tabCloseButtons = e.tabCloseButtons), e.dropPosition && (a.dropPosition = e.dropPosition), e.resizeMode && (a.resizeMode = e.resizeMode), this.hasAnimation || (a.animation = "none"), a.draggable = void 0 === e.draggable || e.draggable, a.floatable = void 0 === e.floatable || e.floatable, a.tabCloseButtons = e.tabCloseButtons ? e.tabCloseButtons : a.tabCloseButtons, e.autoHide ? (a.autoHideWindow = this.$.autoHideWindow, a.autoHide = a.allowToggle = e.autoHide, a.autoHidePosition = e.autoHidePosition) : e.undocked && (i = ["close", "maximize", "minimize"], a.undocked = e.undocked, a.position = {
        top: e.top ? -1 < (e.top + "").indexOf("%") ? e.top : parseFloat(e.top) + "px" : void 0,
        left: e.left ? -1 < (e.left + "").indexOf("%") ? e.left : parseFloat(e.left) + "px" : void 0,
        width: e.width,
        height: e.height
      }), a.tabPosition = e.tabPosition || a.tabPosition, a.opened = a.pinned = !0, e.headerButtons && (i = e.headerButtons), (!e.headerButtons || Array.isArray(e.headerButtons) && 0 === e.headerButtons.length) && (i = ["close", "autoHide"]), a.headerButtons = i, a.size = e.size || "", a.max = e.max || "", a.min = e.min ? e.min : 30, a.locked = e.locked || !1, a.collapsible = e.collapsible || !1, a.collapsed = e.collapsed || !1, e.items && Array.isArray(e.items)) for (var _o257 = 0; _o257 < e.items.length; _o257++) {
        t && e.items[_o257].instance ? (n = e.items[_o257].instance, n.index = null, n.id = e.items[_o257].id || "") : (n = document.createElement("smart-tab-item"), n.label = e.items[_o257].label ? e.items[_o257].label : "", n.id = e.items[_o257].id || "", n.content = e.items[_o257].content ? e.items[_o257].content : "", n.selected = !!e.items[_o257].selected && e.items[_o257].selected, a._isItemSelected = !0), n.draggable = void 0 === e.items[_o257].draggable || e.items[_o257].draggable, n.floatable = void 0 === e.items[_o257].floatable || e.items[_o257].floatable, e.items[_o257].id && (n.id = e.items[_o257].id), a.appendChild(n);
      }
      return a;
    }
  }, {
    key: "_createItemsFromArray",
    value: function _createItemsFromArray(e, t) {
      var a = this;
      var n = e;
      var i = n.length;
      a._removeAll(!0), a._initializingItems = !0;
      var o = a.undockedItems;

      for (var _a487 = 0; _a487 < o.length; _a487++) {
        o[_a487].layout = null, o[_a487].parentElement.removeChild(o[_a487]);
      }

      1 === i && n[0].type && "layoutgroup" === n[0].type.toLowerCase() && (a.$.itemsContainer.orientation = n[0].orientation || a.$.itemsContainer.orientation, a.$.itemsContainer.liveResize = n[0].liveResize || a.$.itemsContainer.liveResize, a.$.itemsContainer.resizeMode = n[0].resizeMode || a.$.itemsContainer.resizeMode, n = n[0].items);
      var r;
      a.$.itemsContainer.autoFitMode = "end";

      for (var _o258 = 0; _o258 < n.length; _o258++) {
        r = a._createLayoutItem(n[_o258], t), r && (a.$.placeholderItem.parentElement && a.$.itemsContainer.removeChild(a.$.placeholderItem), a.$.itemsContainer.appendChild(r));
      }

      0 === a._items.filter(function (e) {
        return e.opened;
      }).length ? !a.$.placeholderItem.parentElement && a.$.itemsContainer.appendChild(a.$.placeholderItem) : a.$.placeholderItem.parentElement && a.$.itemsContainer.removeChild(a.$.placeholderItem), a.$.itemsContainer.autoFitMode = "proportional", delete a._initializingItems;
    }
  }, {
    key: "_createLayoutItem",
    value: function _createLayoutItem(e, t) {
      if (!e) return;
      var a = this,
          i = document.createElement("smart-splitter-item");
      var n;

      if (e.type && "layoutgroup" === e.type.toLowerCase()) {
        n = document.createElement("smart-splitter"), n._isInShadowDOM = a.shadowRoot, n.autoFitMode = "proportional", e.id && (n.id = e.id), e.orientation && (n.orientation = e.orientation), e.resizeMode && (n.resizeMode = e.resizeMode), n.liveResize = a.liveResize, n.resizeStep = a.resizeStep;

        var _o259;

        for (var _r162 = 0; _r162 < e.items.length; _r162++) {
          _o259 = a._createLayoutItem(e.items[_r162], t), _o259 && n.appendChild(_o259);
        }

        if (!n.querySelector("smart-splitter-item")) return;
      } else {
        if (n = a._createTabsWindowFromObject(e.type && "layoutgroup" === e.type.toLowerCase() ? e.items[0] : e, t), n.autoHide) return a._autoHide(n, n.autoHidePosition), void delete n.autoHidePosition;
        if (n.undocked) return a.undock(n), document.body.appendChild(n), n.opened = !0, n.pinned = !1, n.layout = a, n.position && (n.style.left = n.position.left, n.style.top = n.position.top, n.style.width = n.position.width, n.style.height = n.position.height, delete n.position), void (n.size && (n.style.left = n.position.left, n.style.top = n.position.top));

        a._items.push(n);
      }

      return i.size = e.size || "", i.max = e.max || "", i.min = e.min || 30, i.locked = e.locked || !1, i.collapsible = e.collapsible || !1, i.collapsed = e.collapsed || !1, i.appendChild(n), i;
    }
  }, {
    key: "_createLayoutStructure",
    value: function _createLayoutStructure(e, t) {
      function a(e) {
        for (var _t763 = e.firstElementChild; _t763;) {
          if (_t763 instanceof Smart.Splitter) return _t763;
          if (_t763 instanceof Smart.TabsWindow) return _t763;
          _t763 = _t763.nextElementSibling;
        }
      }

      var n = this,
          o = [];
      var r = e._items,
          l,
          s;
      var i = r[0].$.content.children[0];
      1 === r.length && i instanceof Smart.Splitter && (r = i._items, e === n.$.itemsContainer && (n.$.itemsContainer.orientation = i.orientation));

      for (var d = 0; d < r.length; d++) {
        if (r[d] !== n.$.placeholderItem) {
          if (s = a(r[d].$.content), s instanceof Smart.TabsWindow) l = n._createTabsWindowStructure(s, t);else if (s instanceof Smart.Splitter) {
            for (; 1 === s._items.length && s._items[0].$.content.children[0] instanceof Smart.Splitter;) {
              s = s._items[0].$.content.children[0];
            }

            l = 1 === s._items.length ? n._createTabsWindowStructure(s._items[0].$.content.children[0], t) : {
              type: "LayoutGroup",
              items: n._createLayoutStructure(s, t),
              orientation: s.orientation
            }, s.id && (l.id = s.id), "adjacent" !== s.resizeMode && (l.resizeMode = s.resizeMode), 5 !== s.resizeStep && (l.resizeStep = s.resizeStep), s.liveResize && (l.resizeStep = s.liveResize);
          }
          l.size = r[d][e._measurements.size], r[d].locked && (l.locked = !0), r[d].min && (l.min = r[d].min), r[d].max && (l.max = r[d].max), o.push(l);
        }
      }

      return o;
    }
  }, {
    key: "_createTabsWindowStructure",
    value: function _createTabsWindowStructure(e, t) {
      function a(e) {
        var i = {};
        return i.type = "LayoutPanelItem", i.label = e.label || "", e.selected && (i.selected = e.selected), e.disabled && (i.disabled = e.disabled), i.draggable = void 0 === e.draggable || e.draggable, i.floatable = void 0 === e.floatable || e.floatable, t || (i.instance = e), e.id && (i.id = e.id), i;
      }

      var n = {
        type: "LayoutPanel"
      };

      if (e.id && (n.id = e.id), e.disabled && (n.disabled = e.disabled), e.label && (n.label = e.label), e.autoHide ? (n.autoHide = e.autoHide, n.autoHidePosition = e.tabPosition) : "top" !== e.tabPosition && (n.tabPosition = e.tabPosition), e.closest("smart-docking-layout") || this._getClosestDockingLayout(e) || (n.undocked = !0, n.top = e.style.top, n.left = e.style.left, n.width = e.style.width, n.height = e.style.height), e.dropPosition && "all" !== e.dropPosition[0] && (n.dropPosition = e.dropPosition), n.draggable = void 0 === e.draggable || e.draggable, n.floatable = void 0 === e.floatable || e.floatable, void 0 !== e.floatable && (n.floatable = e.floatable), "none" !== e.resizeMode && (n.resizeMode = e.resizeMode), e.items) {
        n.items = [];

        for (var _t764 = 0; _t764 < e.items.length; _t764++) {
          n.items.push(a(e.items[_t764]));
        }
      }

      return n;
    }
  }, {
    key: "_containerTabStripResizeHandler",
    value: function _containerTabStripResizeHandler(e) {
      var t = this,
          i = e.target.closest("smart-splitter");
      (i === t.$.horizontalHiddenItemsContainer || i === t.$.verticalHiddenItemsContainer) && (i._resizeEventHandler(), t._setAutoHidePaddings());
    }
  }, {
    key: "_getItemById",
    value: function _getItemById(e) {
      var t = this,
          a = e;
      if (e = document.getElementById(a), e) return e;

      if (t.shadowRoot && (e = t.shadowRoot.querySelector("#" + a), !e)) {
        var _n364 = t.items;

        for (var _t765 = 0; _t765 < _n364.length; _t765++) {
          var _i751 = _n364[_t765];
          if (_i751.shadowRoot && (e = _i751.shadowRoot.querySelector("#" + a), e)) return e;
        }

        _n364 = document.querySelectorAll("smart-tabs-window");

        for (var _o260 = 0; _o260 < _n364.length; _o260++) {
          var _i752 = _n364[_o260];
          if (_i752.layout === t && _i752.shadowRoot && (e = _i752.shadowRoot.querySelector("#" + a), e)) return e;
        }
      }
    }
  }, {
    key: "_dock",
    value: function _dock(e, t) {
      var i = this;
      if ("number" == typeof e ? e = i._items[e] : "string" == typeof e && (e = i._getItemById(e)), !e) return;
      var a;

      if (e instanceof Smart.TabItem) {
        var _t766 = i._handleTabItemDocking(e);

        e = _t766.tabsWindow, a = _t766.newTabsWindow;
      } else "object" != typeof e || e instanceof HTMLElement || (e = i._createTabsWindowFromObject(e));

      if (!(e instanceof Smart.TabsWindow) || !e.autoHide) return void (0 > i._items.indexOf(e) && (a.autoHide = !1, 0 === e.items.length && "simple" === i.snapMode && e.parentElement.removeChild(e), t ? i._insert(-1, a, t ? "layout-" + t : void 0) : i.appendChild(a)));

      if ((i.shadowRoot || i).contains(e)) {
        var _n365 = e.closest("smart-splitter-item"),
            _o261 = e.closest("smart-splitter"),
            _r163 = !_n365.nextElementSibling;

        t || ("horizontal" === _o261.orientation ? t = _r163 ? "bottom" : "top" : t = _r163 ? "right" : "left"), 0 === e.items.length && _n365.closest("smart-splitter").removeChild(_n365), a && (e = a), e.autoHide && (i.$.verticalHiddenItemsContainer.contains(e) ? i.$.verticalHiddenItemsContainer.removeChild(e.closest("smart-splitter-item")) : i.$.horizontalHiddenItemsContainer.contains(e) && i.$.horizontalHiddenItemsContainer.removeChild(e.closest("smart-splitter-item")), e.tabPosition = e._originalTabPosition || "top", delete e._originalTabPosition), i._setDockedItemsHeaderButtons(e), e.autoHide = e.allowToggle = e.maximized = e.minimized = e.collapsed = e.locked = !1, e.tabTextOrientation = "horizontal", i.$.autoHideWindow.close(), i._insert(-1, e, "layout-" + t), i._setAutoHidePaddings(), delete i._dockingAutoHideTabItem;
      }
    }
  }, {
    key: "_handleTabItemDocking",
    value: function _handleTabItemDocking(e) {
      var t = this,
          i = (e.isInShadowDOM ? e.getRootNode().host : e).closest("smart-tabs-window");
      var a;

      if (i) {
        var _n366 = t.$.autoHideWindow;
        if (!i.autoHide) return {
          tabsWindow: i,
          newTabsWindow: i
        };
        t._dockingAutoHideTabItem = !0, a = 1 === i.items.length ? i : document.createElement("smart-tabs-window"), delete e._autoHideWindowSize, a.size = "left" === _n366.resizeMode || "right" === _n366.resizeMode ? _n366.offsetWidth : _n366.offsetHeight, i.removeChild(e), 0 !== i.items.length || a.id || (t.shadowRoot || t).contains(i) || i.parentElement.removeChild(i), a.tabCloseButtons = i.tabCloseButtons, a.dropPosition = i.dropPosition, a.draggable = e.draggable, a.floatable = e.floatable;
      }

      return a || (a = document.createElement("smart-tabs-window")), t.hasAnimation || (a.animation = "none"), a.min = 30, a.opened = a.pinned = a.autoHide = !0, a.style.maxWidth = a.style.maxHeight = "", a._originalTabPosition = i._originalTabPosition || void 0, a._originalTextOrientation = i._originalTextOrientation || void 0, a !== i && (delete i._originalTabPosition, delete i._originalTextOrientation), a.label = e.label, a.appendChild(e), e = i, {
        tabsWindow: e,
        newTabsWindow: a
      };
    }
  }, {
    key: "_dockEventHandler",
    value: function _dockEventHandler(e) {
      var t = this;
      var i = e.target;
      i._tabsWindow && (i = i._tabsWindow), i.autoHide ? t._dock(i.items[i.selectedIndex]) : t._autoHide(i, t._items.indexOf(i) < (t._items.length - 1) / 2);
    }
  }, {
    key: "_documentDownHandler",
    value: function _documentDownHandler(e) {
      var t = this;
      var i = e.originalEvent.target;
      if (i.shadowRoot) for (i = e.originalEvent.composedPath()[0]; i;) {
        if (i.closest(".smart-window")) {
          i = i.closest(".smart-window");
          break;
        }

        i = i.getRootNode().host;
      } else i = i.closest(".smart-window");
      if (t.$.autoHideWindow._tabsWindow && (!i || i !== t.$.autoHideWindow && i !== t.$.autoHideWindow._tabsWindow) && (t.$.autoHideWindow._tabsWindow.selectedIndex = null), t._dragDetails) return void t._cancelDragOperation();

      if (i instanceof Smart.TabsWindow && t.draggable && !t.disabled && !(t._dragDetails || i.maximized || i.minimized || !Smart.Utilities.Core.isMobile && 1 !== e.which || i._dragDetails && "resize" === i._dragDetails.type && i._dragDetails.started)) {
        var _a488 = e.originalEvent.target.shadowRoot ? e.originalEvent.composedPath()[0] : e.originalEvent.target;

        if (i = _a488.closest(".smart-header-section") || _a488.closest(".smart-tab-label-container"), t._dragDetails = {}, i && i.classList.contains("smart-header-section") && ("simple" === t.snapMode || _a488.closest(".smart-buttons-container")) && (i = void 0), t._dragDetails.windowFeedback = t.$.tabsWindowFeedback, i) {
          var _a489 = i.getRootNode() && i.getRootNode().host ? i.getRootNode().host : i;

          if (t._dragDetails.selectedTabsWindow = i.closest("smart-tabs-window") || (_a489 ? _a489.closest("smart-tabs-window") : void 0), t._dragDetails.selectedTabsWindow !== t.$.autoHideWindow) t._dragDetails.selectedItem = t._dragDetails.selectedTabsWindow.closest("smart-splitter-item");else if (t._dragDetails.selectedItem = t.$.autoHideWindow._tabsWindow.closest("smart-splitter-item"), !t.$.autoHideWindow._tabsWindow.draggable) return void (t._dragDetails = void 0);
          if (!t._dragDetails.selectedTabsWindow || !t._dragDetails.selectedTabsWindow.draggable || t._dragDetails.selectedTabsWindow.layout !== t) return void (t._dragDetails = void 0);

          if (t._dragDetails.offset = {
            x: 0,
            y: 0
          }, t._dragDetails.selectedTabLabel = i, t._dragDetails.x = e.pageX, t._dragDetails.y = e.pageY, t._dragDetails.selectedTabLabel.$.hasClass("smart-header-section")) {
            if (!t._dragDetails.selectedItem && t._dragDetails.selectedTabsWindow.pinned) return void (t._dragDetails = void 0);
            t._dragDetails.windowFeedback = t._dragDetails.selectedTabsWindow;

            var _a490 = i.getBoundingClientRect();

            t._dragDetails.offset.x = e.clientX - _a490.left, t._dragDetails.offset.y = e.clientY - _a490.top;
          } else {
            if (!t._dragDetails.selectedTabLabel.tab || void 0 !== t._dragDetails.selectedTabLabel.tab.draggable && !t._dragDetails.selectedTabLabel.tab.draggable) return void (t._dragDetails = void 0);
            1 === t._dragDetails.selectedTabsWindow.items.length && (t._dragDetails.windowFeedback = t._dragDetails.selectedTabsWindow, t._dragDetails.windowFeedback.floatable = t._dragDetails.selectedTabsWindow.items[0].floatable);
          }
        }

        t._items.map(function (e) {
          return e.removeAttribute("ontop");
        }), t._dragDetails.windowFeedback !== t.$.autoHideWindow && t._dragDetails.windowFeedback.setAttribute("ontop", "");
      }
    }
  }, {
    key: "_getClosestDockingLayout",
    value: function _getClosestDockingLayout(e) {
      return this._getClosestElement("smart-docking-layout", e);
    }
  }, {
    key: "_getClosestElement",
    value: function _getClosestElement(e, t) {
      var i = this;
      if (t && i.shadowRoot && t.getRootNode()) for (var _i753 = t.getRootNode().host; _i753;) {
        if (!_i753.closest) return;
        if (_i753.closest(e)) return _i753.closest(e);
        _i753 = _i753.getRootNode() ? _i753.getRootNode().host : void 0;
      }
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = Math.abs;
      var i = this,
          a = Smart.Utilities.Core.isMobile ? document.elementFromPoint(e.pageX - window.pageXOffset, e.pageY - window.pageYOffset) : e.originalEvent.target.shadowRoot ? e.originalEvent.composedPath()[0] : e.originalEvent.target;

      if (!i.disabled && i._dragDetails && (!i._dragDetails || i._dragDetails.selectedTabsWindow) && a && !(5 >= t(e.pageX - i._dragDetails.x) && 5 >= t(e.pageY - i._dragDetails.y))) {
        var _t767 = document.scrollingElement || document.documentElement,
            _n367 = _t767.scrollLeft,
            _o262 = _t767.scrollTop,
            _r164 = i._dragDetails.selectedTabsWindow;

        if (i._dragDetails.isInsideTheLayout = a.closest && a.closest("smart-docking-layout") === i, !i._dragDetails.isInsideTheLayout && i.shadowRoot && (i._dragDetails.isInsideTheLayout = i._getClosestDockingLayout(a)), i._dragDetails.started = !0, i._dragDetails.windowFeedback === i.$.autoHideWindow) {
          var _e889 = i._dragDetails.selectedTabsWindow.getBoundingClientRect();

          var _t768;

          1 === i.$.autoHideWindow._tabsWindow.items.length ? _t768 = i.$.autoHideWindow._tabsWindow : (_t768 = document.createElement("smart-tabs-window"), _t768.draggable = !0, _t768.min = 30, _t768.layout = i), _t768.style.width = _e889.width + "px", _t768.style.height = _e889.height + "px", _t768.style.left = _e889.left + "px", _t768.style.top = _e889.top + "px", _t768.setAttribute("ontop", ""), i._dragDetails.windowFeedback = _t768, i.$.autoHideWindow.$.addClass("no-transition"), i.$.autoHideWindow.close(), i.$.autoHideWindow.$.removeClass("no-transition");
        }

        if (i._setDragDetailsOnMove(a), i.$.autoHideWindow.close(), !i._dragDetails.windowFeedback.classList.contains("smart-tabs-window-feedback")) i._handleWindowOnDrag();else if (i._dragDetails._parentInfo || (i._dragDetails._parentInfo = {
          closestItem: _r164,
          position: i._originalTabIndex || i._dragDetails.selectedTabLabel.tab.index
        }, i._originalTabIndex = void 0), i._dragDetails.windowFeedback.parentElement !== document.body && document.body.appendChild(i._dragDetails.windowFeedback), i._dragDetails.selectedItem) {
          var _e890 = i._dragDetails.selectedItem.closest("smart-splitter");

          !i._dragDetails.windowFeedback.size && _e890 && (i._dragDetails.windowFeedback.size = i._dragDetails.selectedTabsWindow[_e890._measurements.size]);
        }
        i._dragDetails.selectedTabLabel.classList.contains("smart-header-section") || i._dragDetails.windowFeedback.setAttribute("tabs-window-dragged", ""), (i._dragDetails.windowFeedback.hasAttribute("tabs-window-dragged") || i._dragDetails.selectedTabsWindow === i.$.autoHideWindow || i._dragDetails._parentInfo && "string" == typeof i._dragDetails._parentInfo.position) && (i._dragDetails.windowFeedback.style.left = e.pageX - i._dragDetails.offset.x + "px", i._dragDetails.windowFeedback.style.top = e.pageY - i._dragDetails.offset.y + "px", i._setWindowFeedbackSize()), i._dragDetails.windowFeedback.opened = !0, document.activeElement !== i && (i.focus(), window.scrollTo(_n367, _o262));

        var _l115 = i._dragDetails.hoveredTabsWindow ? a.closest(".smart-tabs-header-section") : void 0;

        i._dragDetails.hoveredTabArea = _l115 ? _l115 : i._dragDetails.hoveredTabsWindow && a.closest(".smart-tabs-content-section") ? i._dragDetails.hoveredTabsWindow.$.tabsElement.$.tabContentSection : i._dragDetails.hoveredTabsWindow, i.shadowRoot && i._dragDetails.selectedTabsWindow === i._dragDetails.windowFeedback && requestAnimationFrame(function () {
          i._dragDetails && i._dragDetails.windowFeedback.refreshTabHeader();
        }), i._setSnappingMarkers(e, _l115);
      }
    }
  }, {
    key: "_setDragDetailsOnMove",
    value: function _setDragDetailsOnMove(e) {
      var t = this;
      var i;

      if (!t.hasAttribute("dragged")) {
        t._originalBodyOverflow = {
          overflowX: document.body.style.overflowX,
          overflowY: document.body.style.overflowY,
          overflow: document.body.style.overflow
        };

        var _e891 = (document.scrollingElement || document.documentElement).scrollHeight > document.documentElement.clientHeight,
            _a491 = (document.scrollingElement || document.documentElement).scrollWidth > document.documentElement.clientWidth;

        var _n368 = t._dragDetails.selectedTabsWindow;

        if (document.body.style.overflow = document.body.style.overflowX = document.body.style.overflowY = "", _e891 && !_a491 ? document.body.style.overflowX = "hidden" : _a491 && !_e891 ? document.body.style.overflowY = "hidden" : !_a491 && !_e891 && (document.body.style.overflow = "hidden"), t._dragDetails.windowFeedback.$.hasClass("smart-tabs-window-feedback") || _n368 === t.$.autoHideWindow) {
          var _e892 = t._dragDetails.selectedTabLabel.tab || t.$.autoHideWindow._tab;

          var _i754 = t.$.tabsWindowFeedback;
          _n368 === t.$.autoHideWindow && (_n368 = t.$.autoHideWindow._tabsWindow, _i754 = t._dragDetails.windowFeedback, _i754.label = _e892.label, _i754.floatable = _e892.draggable, _i754.floatable = _e892.floatable), Smart.Utilities.Core.isMobile && !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && (t._dragDetails.selectedTabLabel._lazyRemove = !0), _e892.parentElement && _n368.removeChild(_e892), t._originalTabIndex = _e892.index, _i754.appendChild(_e892);
          var _a492 = t._dragDetails.selectedTabsWindow;
          if (_a492 === t.$.autoHideWindow) 1 < _a492._tabsWindow.items.length && (_i754.tabPosition = _a492.tabPosition, _i754.tabTextOrientation = _a492._originalTextOrientation || _a492.tabTextOrientation);else {
            var _e893 = _a492.autoHide;
            _i754.tabPosition = _a492._originalTabPosition || (_e893 ? "top" : _a492.tabPosition), _i754.tabTextOrientation = _a492._originalTextOrientation || (_e893 ? "horizontal" : _a492.tabTextOrientation);
          }
          if (_e892._autoHideWindowSize) _i754.size = _e892._autoHideWindowSize;else if (_n368.autoHide) {
            var _e894 = "offset" + ("top" === _n368.tabPosition || "bottom" === _n368.tabPosition ? "Height" : "Width");

            _i754.size = (_n368._autoHideWindow || _n368)[_e894];
          }
        }

        i = t._dragDetails.selectedTabsWindow.closest("smart-docking-layout"), !i && t.shadowRoot && (i = t._getClosestDockingLayout(t._dragDetails.selectedTabsWindow)), i || t._dragDetails.windowFeedback._originalPinnedState || (t._dragDetails.windowFeedback._originalPinnedState = t._dragDetails.windowFeedback.pinned), t._dragDetails.windowFeedback.pinned = !1, t.setAttribute("dragged", "");
      }

      t._dragDetails.hoveredItem = e.closest("smart-splitter-item"), t.shadowRoot && !t._dragDetails.hoveredItem && (t._dragDetails.hoveredItem = t._getClosestElement("smart-splitter-item", e)), t._dragDetails.hoveredItem ? (i = t._dragDetails.hoveredItem.closest("smart-docking-layout"), !i && t.shadowRoot && (i = t._getClosestDockingLayout(t._dragDetails.hoveredItem)), i && i === t ? t._dragDetails.hoveredTabsWindow = t._dragDetails.hoveredItem.querySelector("smart-tabs-window") : t._dragDetails.hoveredItem = t._dragDetails.hoveredTabsWindow = void 0) : t._dragDetails.hoveredTabsWindow = e.closest("smart-tabs-window") || (e.getRootNode() && e.getRootNode().host ? e.getRootNode().host.closest("smart-tabs-window") : void 0), t._dragDetails.hoveredTabsWindow && (i = t._dragDetails.hoveredTabsWindow.closest("smart-docking-layout"), !i && t.shadowRoot && (i = t._getClosestDockingLayout(t._dragDetails.hoveredTabsWindow)), i && i !== t ? t._dragDetails.hoveredTabsWindow = void 0 : t._dragDetails.hoveredTabsWindow.bringToFront());
    }
  }, {
    key: "_documentDragStartHandler",
    value: function _documentDragStartHandler(e) {
      var t = this;
      t._dragDetails && e.preventDefault();
    }
  }, {
    key: "_documentSelectStartHandler",
    value: function _documentSelectStartHandler(e) {
      var t = this;
      t._dragDetails && t._dragDetails.started && e.preventDefault();
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = e.originalEvent || e,
          a = i.target.shadowRoot ? i.composedPath()[0] : i.target;
      if (!t._dragDetails || t._dragDetails && !t._dragDetails.started || t.disabled) return void delete t._dragDetails;
      t._noStateChangeFiring = !0, t.removeAttribute("dragged"), t._dragDetails.windowFeedback.removeAttribute("tabs-window-dragged"), t._dragDetails.windowFeedback.removeAttribute("ontop");
      var n = a.closest && a.closest("smart-docking-layout");
      !n && t.shadowRoot && (n = t._getClosestDockingLayout(a)), e.ctrlKey && (t._snapFeedback._position = n = void 0);
      var o = t._snapFeedback ? t._snapFeedback._position : void 0;
      if (!n && !o || n && !t._dragDetails.hoveredTabArea && !o) t._dropWindowOutsideLayout(e, o, n);else if (t._dragDetails.hoveredTabsWindow && o) {
        if (t._dragDetails.hoveredTabArea && t._dragDetails.hoveredTabArea.classList.contains("smart-tabs-header-section")) {
          var _e895 = t._dragDetails.hoveredTabsWindow.itemLabels.length,
              _n369 = a.closest(".smart-tab-label-container"),
              _o263;

          _n369 && !_n369.$.hasClass("smart-add-new-tab") && _n369.tab || (_n369 = t._dragDetails.hoveredTabsWindow.itemLabels[_e895 - 1], _o263 = !0);

          var _r165 = t._dragDetails.selectedTabLabel.$.hasClass("smart-tab-label-container") && t._dragDetails.windowFeedback.$.hasClass("smart-tabs-window-feedback") ? [t._dragDetails.selectedTabLabel.tab] : [].slice.call(t._dragDetails.windowFeedback.items);

          var _l116;

          if (t._dragDetails.hoveredTabsWindow.autoHide) {
            var _e896 = t._dragDetails.hoveredTabsWindow.tabPosition;
            _l116 = t._dragDetails.windowFeedback["offset" + ("top" === _e896 || "bottom" === _e896 ? "Height" : "Width")];
          }

          for (var _a493 = 0; _a493 < _r165.length; _a493++) {
            _r165[_a493]._autoHideWindowSize = _l116 || t._dragDetails.windowFeedback.size, t._dragDetails.windowFeedback.removeChild(_r165[_a493]), t._dragDetails.hoveredTabsWindow.insert(_o263 ? _e895 : _n369.tab.index, {
              node: _r165[_a493]
            }), _e895 = t._dragDetails.hoveredTabsWindow.items.length;
          }

          t._dragDetails.targetWindow = t._dragDetails.hoveredTabsWindow;
        } else t._dragDetails.targetWindow = t._handleItemNesting(), t._eventAlreadyFired = !0;

        t.$.autoHideWindow.close(), t._noStateChangeFiring = !1;
      }

      if (t.shadowRoot) {
        var _e897 = t._dragDetails.targetWindow;
        setTimeout(function () {
          return _e897.refreshTabHeader();
        }, 100);
      }

      t._endDrag();
    }
  }, {
    key: "_dropWindowOutsideLayout",
    value: function _dropWindowOutsideLayout(e, t, i) {
      var a = this;
      var n;
      if (!a.floatable || void 0 !== a._dragDetails.windowFeedback.floatable && !a._dragDetails.windowFeedback.floatable) return void a._cancelDragOperation(!0);

      if (a._dragDetails.windowFeedback.classList.contains("smart-tabs-window-feedback")) {
        var _t769 = a._dragDetails.windowFeedback.items[0];
        if (_t769 && void 0 !== _t769.floatable && !_t769.floatable) return void a._cancelDragOperation(!0);
        var _i755 = a._dragDetails.selectedTabLabel.tab;

        var _o264 = document.createElement("smart-tabs-window");

        a.hasAnimation || (_o264.animation = "none"), _o264.opened = !0, _o264.label = _i755.label, a._dragDetails.windowFeedback.removeChild(_i755), a._dragDetails.selectedTabLabel.tab.$.removeClass("smart-visibility-hidden"), _o264.appendChild(a._dragDetails.selectedTabLabel.tab), _o264.style.left = e.pageX + "px", _o264.style.top = e.pageY + "px", _o264.style.maxWidth = _o264.style.maxHeight = "", _o264.resizeMode = a._dragDetails.selectedTabsWindow.resizeMode, _o264.tabTextOrientation = a._dragDetails.windowFeedback.tabTextOrientation, _o264.tabPosition = a._dragDetails.windowFeedback.tabPosition, _o264.min = 30, _o264.style.width = a._dragDetails.windowFeedback.style.width, _o264.style.height = a._dragDetails.windowFeedback.style.height, _o264.draggable = void 0 === _i755.draggable || _i755.draggable, _o264.floatable = void 0 === _i755.floatable || _i755.floatable, document.body.appendChild(_o264), _o264.pinned = _o264.autoHide = _o264.allowToggle = !1, a._noStateChangeFiring = !1, n = _o264;
      } else a._dragDetails._parentInfo && a._dragDetails._parentInfo.closestItem ? (a._dragDetails.windowFeedback.parentElement !== document.body && (a._dragDetails.windowFeedback.windowParent = "body", document.body.appendChild(a._dragDetails.windowFeedback)), a._dragDetails.windowFeedback.style.maxWidth = a._dragDetails.windowFeedback.style.maxHeight = "", a._dragDetails.windowFeedback.pinned = a._dragDetails.windowFeedback.allowToggle = a._dragDetails.windowFeedback.autoHide = !1, a._dragDetails.selectedTabLabel.$.hasClass("smart-tab-label-container") && (a._dragDetails.windowFeedback.label = a._dragDetails.selectedTabLabel.tab.label)) : !t && !(a._dragDetails.selectedItem instanceof Smart.SplitterItem) && a._dragDetails.selectedTabLabel.$.hasClass("smart-tab-label-container") && a._returnItemToOrigin(a._dragDetails.windowFeedback), n = a._dragDetails.windowFeedback, n.locked = !1, a._dragDetails.selectedItem && (a._noStateChangeFiring = !1);

      a.$.autoHideWindow.close(), i || (a._dragDetails.windowFeedback.pinned = !1), a._validateWindowPosition(n), a._dragDetails._parentInfo && (n._parentInfo = {
        closestItem: a._dragDetails._parentInfo.closestItem,
        position: a._dragDetails._parentInfo.position
      }), n.layout = a, a._dragDetails.targetWindow = n, n.resizeMode = "both", a._setFloatingItemsHeaderButtons(n);
    }
  }, {
    key: "_endDrag",
    value: function _endDrag() {
      var e = this,
          t = e._dragDetails.windowFeedback;

      if (e.$.tabsWindowFeedback.close(), 0 === t.$.tabsElement._tabs.length && t.parentElement && !t.$.hasClass("smart-tabs-window-feedback") && t.parentElement.removeChild(t), (e.shadowRoot || e).contains(e._dragDetails.windowFeedback) || void 0 === e._dragDetails.windowFeedback._originalPinnedState || (e._dragDetails.windowFeedback.pinned = e._dragDetails.windowFeedback._originalPinnedState, delete e._dragDetails.windowFeedback._originalPinnedState), e._originalBodyOverflow && (document.body.style.overflow = e._originalBodyOverflow.overflow, document.body.style.eoverflowX = e._originalBodyOverflow.overflowX, document.body.style.overflowY = e._originalBodyOverflow.overflowY, delete e._originalBodyOverflow), e._dragDetails.targetWindow ? (e._dragDetails.targetWindow.focus(), e._dragDetails.selectedTabsWindow && e._dragDetails.selectedTabsWindow.removeAttribute("active")) : e._dragDetails.windowFeedback.bringToFront(), e._dragDetails.started = !1, e._dragDetails.hoveredItem = e._dragDetails.hoveredTabsWindow = e._dragDetails.isInsideTheLayout = void 0, t.removeAttribute("dragged"), e._handleSnapping(), e._dragDetails.selectedTabsWindow && delete e._dragDetails.selectedTabsWindow._ownerLayout, 0 === t.items.length && ((e.shadowRoot || e).contains(t) && (t.opened = !1), t.$.hasClass("smart-tabs-window-feedback") && e.$.container.appendChild(t)), !e._eventAlreadyFired && !e._noStateChangeFiring) {
        e._handleAutoSave();

        var _t770 = {
          item: e._dragDetails.targetWindow
        };
        _t770.type = -1 < e._items.indexOf(e._dragDetails.targetWindow) ? "dock" : "float", e.$.fireEvent("stateChange", _t770);
      }

      e._noStateChangeFiring = e._eventAlreadyFired = void 0, e._dragDetails._parentInfo && e._dragDetails._parentInfo.closestItem && e._removeUnneccessaryItems(e._dragDetails._parentInfo.closestItem.closest("smart-splitter"));

      var i = e._getClosestDockingLayout(t);

      return t.closest("smart-docking-layout") || i ? (t.style.top = t.style.left = "", void delete e._dragDetails) : void (t.top && (t.style.top = t.top), t.left && (t.style.left = t.left), e._dragDetails.selectedTabLabel && e._dragDetails.selectedTabLabel._lazyRemove && (e._dragDetails.selectedTabLabel.parentElement && e._dragDetails.selectedTabLabel.parentElement.removeChild(e._dragDetails.selectedTabLabel), delete e._dragDetails.selectedTabLabel._lazyRemove), t._cancelDragging(), delete e._dragDetails);
    }
  }, {
    key: "_getTabItemContent",
    value: function _getTabItemContent(e) {
      var t = e.isCompleted ? e.$.content : e,
          i = document.createDocumentFragment();

      for (; t.firstChild;) {
        i.appendChild(t.firstChild);
      }

      return i;
    }
  }, {
    key: "_getHeaderLabelDimensions",
    value: function _getHeaderLabelDimensions() {
      var e = Math.min,
          t = Math.max;
      var i = this;
      if (!i._dragDetails || !i._dragDetails.hoveredTabsWindow) return;
      var a = i._dragDetails.hoveredTabsWindow.$.tabsElement,
          n = "left" === a.tabPosition || "right" === a.tabPosition;
      var o = 0,
          r = 0,
          l,
          s;
      if (i._dragDetails.hoveredTabArea) l = i._dragDetails.hoveredTabArea.offsetWidth, s = i._dragDetails.hoveredTabArea.offsetHeight, o = i._dragDetails.hoveredTabArea.offsetLeft, r = i._dragDetails.hoveredTabArea.offsetTop;else if (0 < a.$.tabStrip.children.length) {
        var _e898 = a.$.tabStrip.children[a.$.tabStrip.children.length - 1];
        o = _e898.offsetLeft + (n ? 0 : _e898.offsetWidth), r = _e898.offsetTop + (n ? _e898.offsetHeight : 0), l = _e898.offsetWidth, s = _e898.offsetHeight;
      }
      i._dragDetails.hoveredTabArea = a.$.tabsHeaderSection;
      var d = 0,
          c = 0;
      "horizontal" === a.tabTextOrientation ? d = a.$.scrollButtonNear.offsetWidth : c = a.$.scrollButtonNear.offsetHeight;

      var m = i._dragDetails.hoveredTabArea.getBoundingClientRect(),
          u = i._dragDetails.hoveredTabsWindow.$.tabsElement.$.tabStrip,
          p = u.getBoundingClientRect(),
          g = p.left - m.left + m.left + o - u.scrollLeft - d,
          h = p.top - m.top + m.top + r - u.scrollTop - c,
          _ = e(o - u.scrollLeft - d, 0),
          f = e(r - u.scrollTop - c, 0);

      return {
        width: e(p.width, t(0, l + _), t(0, p.left + p.width - g)),
        height: e(p.height, t(0, s + f), t(0, p.top + p.height - h)),
        top: h + window.pageYOffset - f,
        left: g + window.pageXOffset - _
      };
    }
  }, {
    key: "_handleAutoSave",
    value: function _handleAutoSave() {
      var e = this;
      e.autoSaveState && e.saveState();
    }
  }, {
    key: "_handleAutoHiddenSplitterBars",
    value: function _handleAutoHiddenSplitterBars() {
      var e = this,
          t = e.$.itemsContainer.querySelectorAll(".auto-hide-left,.auto-hide-right, .auto-hide-top, .auto-hide-bottom");

      for (var _e899 = 0; _e899 < t.length; _e899++) {
        t[_e899].previousElementSibling instanceof Smart.SplitterBar ? t[_e899].previousElementSibling.hide() : t[_e899].nextElementSibling instanceof Smart.SplitterBar && t[_e899].nextElementSibling.hide();
      }
    }
  }, {
    key: "_handleItemPositionInserting",
    value: function _handleItemPositionInserting(e, t, i) {
      var a = this;
      e.autoHide || -1 < i.indexOf("layout") ? a._handleLayoutItemInserting(t, e, i) : -1 < i.indexOf("outside-") ? a._handleOutsideItemInserting(t, e, i) : (-1 < i.indexOf("inside-") ? a._handleInsideItemInserting(t, e, i) : a._handleNormalItemInserting(t, e, i), a._handleAutoSave(), a.$.fireEvent("stateChange", {
        type: "dock",
        item: e
      }), a._setSplitterBarVisibility());
    }
  }, {
    key: "_handleInsideItemInserting",
    value: function _handleInsideItemInserting(e, t, i) {
      var a = Math.min;
      var n = this,
          o = document.createElement("smart-splitter-item"),
          r = document.createElement("smart-splitter-item");

      var l = e.closest("smart-splitter-item"),
          s = e.closest("smart-splitter"),
          d = n._items.indexOf(e),
          c;

      c = s && 1 === s._items.length ? s : document.createElement("smart-splitter"), c._isInShadowDOM = n.shadowRoot, c.autoFitMode = "proportional", c.liveResize = n.liveResize, c.resizeStep = n.resizeStep, t.windowParent = null, o.appendChild(t), e.windowParent = null, i = i.replace("inside-", ""), c.orientation = "top" === i || "bottom" === i ? "horizontal" : "vertical";
      var m = l["horizontal" === c.orientation ? "offsetHeight" : "offsetWidth"] / 2;

      if (c.parentElement ? c.insertBefore(o, "top" === i || "left" === i ? l : null) : (r.appendChild(e), e.min && (r.min = e.min), "top" === i || "left" === i ? (c.appendChild(o), c.appendChild(r)) : (c.appendChild(r), c.appendChild(o)), l.appendChild(c)), t.size) {
        var _e900 = "string" == typeof t.size && -1 < t.size.indexOf("%");

        o.size = _e900 ? t.size : a(m, parseFloat(t.size));
      }

      o.max = t.max || "", o.min = t.min ? t.min : 30, o.locked = t.locked || !1, o.collapsible = t.collapsible || !1, o.collapsed = t.collapsed || !1, ("bottom" === i || "right" === i) && (d = a(d + 1, n._items.length)), t.pinned = !0, t.autoHide = t.allowToggle = t.maximized = t.minimized = t.collapsed = !1, t._originalTabPosition ? (t.tabPosition = t._originalTabPosition, delete t._originalTabPosition) : t.tabPosition = "top", t._originalTextOrientation ? (t.tabTextOrientation = t._originalTextOrientation, delete t._originalTextOrientation) : t.tabTextOrientation = "horizontal", n._items.splice(d, 0, t), n._handleAutoHiddenSplitterBars();
    }
  }, {
    key: "_handleLayoutItemInserting",
    value: function _handleLayoutItemInserting(e, t, i) {
      var a = this,
          n = document.createElement("smart-splitter-item"),
          o = "bottom" === i || "top" === i ? "offsetHeight" : "offsetWidth";

      if (t.size || (t.size = t[o]), i = i.replace("layout-", ""), n.size = t.size || "", n.max = t.max || "", n.min = t.min || "", n.locked = t.locked || !1, n.collapsible = t.collapsible || !1, n.collapsed = t.collapsed || !1, n.size && !a._dockingAutoHideTabItem && (n.size = Math.min(a[o] / 2, parseFloat(t.size))), "horizontal" === a.$.itemsContainer.orientation && ("right" === i || "left" === i) || "vertical" === a.$.itemsContainer.orientation && ("top" === i || "bottom" === i)) {
        var _e901 = a.$.itemsContainer.orientation,
            _o265;

        var _r166 = a.$.itemsContainer,
            _l117 = [].slice.call(_r166._items),
            _s83 = function _s83(e, t) {
          _r166.appendChild(e), _r166.insertBefore(t, "right" === i || "bottom" === i ? null : e);
        };

        t.windowParent = null, n.appendChild(t), _l117.map(function (e) {
          return e.size = e[_r166._measurements.size];
        });
        var d = "right" === i || "bottom" === i;
        d ? a._items.push(t) : a._items.splice(0, 0, t), _r166.removeAll(), _r166.orientation = "top" === i || "bottom" === i ? "horizontal" : "vertical";
        var c = _r166[_r166._measurements.size] - n.size;

        if (1 < _l117.length) {
          var _t771 = document.createElement("smart-splitter");

          _t771._isInShadowDOM = a.shadowRoot, _t771.autoFitMode = "end", _t771.orientation = _e901, _t771.liveResize = a.liveResize, _t771.resizeStep = a.resizeStep, _o265 = document.createElement("smart-splitter-item"), _o265.min = 30, _o265.appendChild(_t771), _o265.size = c, _s83(_o265, n);

          for (var _e902 = 0; _e902 < _l117.length; _e902++) {
            _t771.appendChild(_l117[_e902]);
          }

          _t771.autoFitMode = "proportional";
        } else _l117[0].size = c, a._dockingAutoHideTabItem && (_r166.autoFitMode = "end"), _s83(_l117[0], n), _r166.autoFitMode = "proportional";

        a._handleAutoHiddenSplitterBars(), a._handleAutoSave(), a.$.fireEvent("stateChange", {
          type: "dock",
          item: t
        }), a._setSplitterBarVisibility();
      } else {
        var _e903 = -1 < i.indexOf("left") || -1 < i.indexOf("top") ? a._items.filter(function (e) {
          return e.opened;
        })[0] : void 0;

        return t.windowParent = null, n.appendChild(t), a.insertBefore(n, _e903, a.$.itemsContainer), !0;
      }
    }
  }, {
    key: "_handleNormalItemInserting",
    value: function _handleNormalItemInserting(e, t, i) {
      var a = e.closest("smart-splitter-item");
      var n = this,
          o = e.closest("smart-splitter"),
          r = document.createElement("smart-splitter-item"),
          l = "right" === i || "bottom" === i ? o._items.indexOf(a) + 1 : o._items.indexOf(a);

      var s = n._items.indexOf(e);

      t.windowParent = null, r.appendChild(t), r.size = t.size || "", r.min = t.min || "", o.insert(l, r), ("bottom" === i || "right" === i) && (s = Math.min(s + 1, n._items.length)), t.pinned = !0, t.locked = !1, t.autoHide = t.allowToggle = t.maximized = t.minimized = t.collapsed = !1, t._originalTabPosition ? (t.tabPosition = t._originalTabPosition, delete n._originalTabPosition) : t.tabPosition = "top", t._originalTextOrientation ? (t.tabTextOrientation = t._originalTextOrientation, delete t._originalTextOrientation) : t.tabTextOrientation = "horizontal", n._items.splice(s, 0, t), n._handleAutoHiddenSplitterBars();
    }
  }, {
    key: "_handleOutsideItemInserting",
    value: function _handleOutsideItemInserting(e, t, i) {
      var a = this,
          n = document.createElement("smart-splitter-item");
      var o = e.closest("smart-splitter");

      if (o || (o = a.$.itemsContainer), n.size = t.size || "", n.max = t.max || "", n.min = t.min || "", n.locked = t.locked || !1, n.collapsible = t.collapsible || !1, n.collapsed = t.collapsed || !1, o !== a.$.itemsContainer) {
        var _r167 = o.closest("smart-splitter-item");

        var _l118 = document.createElement("smart-splitter"),
            _s84 = document.createElement("smart-splitter-item");

        if (_l118._isInShadowDOM = a.shadowRoot, i = i.replace("outside-", ""), _l118.autoFitMode = "proportional", _l118.liveResize = a.liveResize, _l118.resizeStep = a.resizeStep, t.windowParent = null, n.appendChild(t), _s84.min = 30, _s84.appendChild(o), _l118.orientation = "top" === i || "bottom" === i ? "horizontal" : "vertical", _r167.appendChild(_l118), "right" === i || "bottom" === i ? (_l118.appendChild(_s84), _l118.appendChild(n), a._items.splice(a._items.indexOf(e) + 1, 0, t)) : (_l118.appendChild(n), _l118.appendChild(_s84), a._items.splice(a._items.indexOf(e), 0, t)), !n.size) n.size = _l118[_l118._measurements.size] / 2;else {
          var _e904 = n.size;
          n.size = "", n.size = _e904;
        }
        a._handleAutoHiddenSplitterBars(), a._handleAutoSave(), a.$.fireEvent("stateChange", {
          type: "dock",
          item: t
        }), a._setSplitterBarVisibility();
      } else return t.windowParent = null, n.appendChild(t), a.insertBefore(n, -1 < i.indexOf("left") || -1 < i.indexOf("top") ? a._items[0] : void 0, a.$.itemsContainer), !0;
    }
  }, {
    key: "_handleLayout",
    value: function _handleLayout() {
      var e = this;
      if (e._items = [], "string" == typeof e.layout && (e.layout = JSON.parse(e.layout)), null !== e.layout && Array.isArray(e.layout)) return void e._createItemsFromArray(e.layout);
      var t = Array.from(e.$.itemsContainer.children);
      e.$.itemsContainer.innerHTML = "";

      for (var _a494 = 0; _a494 < t.length; _a494++) {
        "Smart-TABS-WINDOW" !== t[_a494].tagName && t[_a494].parentElement.removeChild(t[_a494]), t[_a494].layout = e;

        var _i756 = document.createElement("smart-splitter-item");

        _i756.appendChild(t[_a494]), e.$.itemsContainer.appendChild(_i756), e._items.push(t[_a494]);
      }
    }
  }, {
    key: "_handleSnapping",
    value: function _handleSnapping(e) {
      var t = this;
      "simple" === t.snapMode ? t._handleSimpleSnapping(e) : t._handleAdvancedSnapping();
    }
  }, {
    key: "_handleAdvancedSnapping",
    value: function _handleAdvancedSnapping() {
      var e = this;
      if (!e._dragDetails) return;

      if (e._snapFeedback && !e._dragDetails.hoveredTabsWindow && (e._snapFeedback._position = void 0, e._snapFeedback.areaHighlighter && e._snapFeedback.areaHighlighter.parentElement && e._snapFeedback.areaHighlighter.parentElement.removeChild(e._snapFeedback.areaHighlighter), e._snapFeedback.headerHighlighter && e._snapFeedback.headerHighlighter.parentElement && e._snapFeedback.headerHighlighter.parentElement.removeChild(e._snapFeedback.headerHighlighter), !e._dragDetails.hoveredItem)) {
        if (e._snapFeedback.innerSnapElement && e._snapFeedback.innerSnapElement.parentElement && e._snapFeedback.innerSnapElement.parentElement.removeChild(e._snapFeedback.innerSnapElement), e._snapFeedback.outherSnapElement && !e._dragDetails.isInsideTheLayout) {
          var _t772 = [].slice.call(e.$.container.children);

          for (var _a495 = 0; _a495 < _t772.length; _a495++) {
            -1 < _t772[_a495].className.indexOf("smart-docking-layout-snap") && e._snapFeedback.outherSnapElement.appendChild(_t772[_a495]);
          }
        }

        return;
      }

      if (e._snapFeedback || (e._snapFeedback = {
        innerSnapElement: document.createElement("div"),
        outherSnapElement: document.createElement("div"),
        areaHighlighter: document.createElement("div"),
        headerHighlighter: document.createElement("div")
      }, e._snapFeedback.innerSnapElement.classList.add("smart-docking-layout-snap"), e._snapFeedback.areaHighlighter.classList.add("smart-docking-layout-snap-highlighter"), e._snapFeedback.headerHighlighter.classList.add("smart-docking-layout-snap-highlighter-header"), e._snapFeedback.innerSnapElement.innerHTML = "\n                            <div>\n                                <div class=\"top\">\n                                    <div><div></div></div>\n                                </div>\n                            </div>\n                            <div>\n                                <div class=\"left\">\n                                    <div><div></div></div>\n                                </div>\n                                <div class=\"center\">\n                                    <div><div></div></div>\n                                </div>\n                                <div class=\"right\">\n                                    <div><div></div></div>\n                                </div>\n                            </div>\n                            <div>\n                                <div class=\"bottom\">\n                                    <div><div></div></div>\n                                </div>\n                            </div>", e._snapFeedback.outherSnapElement.innerHTML = "\n                            <div class=\"smart-docking-layout-snap layout-top\">\n                                <div><div></div></div>\n                            </div>\n                            <div class=\"smart-docking-layout-snap layout-left\">\n                                <div><div></div></div>\n                            </div>\n                            <div class=\"smart-docking-layout-snap layout-right\">\n                                <div><div></div></div>\n                            </div>\n                            <div class=\"smart-docking-layout-snap layout-bottom\">\n                                <div><div></div></div>\n                            </div>"), e._snapFeedback.areaHighlighter.parentElement && (e._snapFeedback.areaHighlighter.removeAttribute("position"), e._snapFeedback.areaHighlighter.classList.remove("smart-hidden")), e._snapFeedback.areaHighlighter.style.width = "", e._snapFeedback.areaHighlighter.style.height = "", e._snapFeedback._position = e._dragDetails.hoveredItem && !(e._dragDetails.hoveredItem instanceof Smart.SplitterItem) ? e._dragDetails.hoveredItem.className : "", e._dragDetails.hoveredItem && -1 < e._dragDetails.hoveredItem.className.indexOf("layout-")) {
        e._snapFeedback._position = e._snapFeedback._position.replace("smart-docking-layout-snap ", ""), e._snapFeedback.areaHighlighter.setAttribute("position", e._snapFeedback._position);
        var _t773 = e._dragDetails.selectedTabsWindow;
        return void (-1 < _t773.dropPosition.indexOf("all") || -1 < _t773.dropPosition.indexOf(e._snapFeedback._position) ? (e._dragDetails.hoveredItem.setAttribute("show", ""), e.$.container.appendChild(e._snapFeedback.areaHighlighter), e._dragDetails.hoveredTabsWindow = !0, -1 < ["layout-left", "layout-right"].indexOf(e._snapFeedback._position) ? e._snapFeedback.areaHighlighter.style.width = e._dragDetails.windowFeedback.style.width || e._dragDetails.windowFeedback.offsetWidth + "px" : -1 < ["layout-top", "layout-bottom"].indexOf(e._snapFeedback._position) && (e._snapFeedback.areaHighlighter.style.height = e._dragDetails.windowFeedback.style.height || e._dragDetails.windowFeedback.offsetHeight + "px")) : (e._dragDetails.hoveredItem.removeAttribute("show"), e._snapFeedback._position = void 0));
      }

      var t = e._dragDetails.hoveredTabsWindow ? e._dragDetails.hoveredTabsWindow.dropPosition : ["all"];

      if (0 === t.length && (t = ["all"]), e._dragDetails.hoveredTabsWindow instanceof Smart.TabsWindow && e._dragDetails.hoveredTabArea && e._dragDetails.hoveredTabArea.closest(".smart-tabs-header-section") && (-1 < t.indexOf("all") || -1 < t.indexOf("header"))) {
        e._dragDetails.hoveredTabArea = e._dragDetails.hoveredTabArea.classList.contains("smart-tab-label-container") ? e._dragDetails.hoveredTabArea : void 0;

        var _t774 = e._getHeaderLabelDimensions(),
            _i757 = e._snapFeedback.headerHighlighter;

        _i757.style.width = _t774.width + "px", _i757.style.height = _t774.height + "px", _i757.style.top = _t774.top + "px", _i757.style.left = _t774.left + "px", _i757.classList.remove("smart-hidden"), _i757.parentElement !== document.body && document.body.appendChild(_i757), e._snapFeedback._position = "header";
      } else e._snapFeedback.headerHighlighter.style.width = e._snapFeedback.headerHighlighter.style.height = 0;

      var i = e._snapFeedback.innerSnapElement.closest("smart-splitter-item");

      if (e._dragDetails.hoveredItem instanceof Smart.SplitterItem) {
        if (i && e._dragDetails.hoveredItem !== i && i.removeChild(e._snapFeedback.innerSnapElement), 0 > e._dragDetails.hoveredItem.className.indexOf("auto-hide")) {
          var _a497 = e._snapFeedback.innerSnapElement.querySelectorAll(".top, .bottom, .left, .right, .center");

          for (var _e905 = 0; _e905 < _a497.length; _e905++) {
            -1 < t.indexOf(_a497[_e905].className) || 0 === t.indexOf("all") ? _a497[_e905].setAttribute("show", "") : _a497[_e905].removeAttribute("show");
          }

          e._snapFeedback.innerSnapElement.classList.remove("smart-hidden"), e._dragDetails.hoveredItem.contains(e._snapFeedback.innerSnapElement) || e._dragDetails.hoveredItem.appendChild(e._snapFeedback.innerSnapElement);
        }

        var _a496 = [].slice.call(e._snapFeedback.outherSnapElement.children),
            _n370 = e._dragDetails.selectedTabsWindow;

        var _o266;

        for (var _t775 = 0; _t775 < _a496.length; _t775++) {
          _o266 = _a496[_t775].className.replace("smart-docking-layout-snap ", ""), _a496[_t775].classList.remove("smart-hidden"), -1 < _n370.dropPosition.indexOf("all") || -1 < _n370.dropPosition.indexOf(_o266) ? _a496[_t775].setAttribute("show", "") : _a496[_t775].removeAttribute("show"), e.$.container.appendChild(_a496[_t775]);
        }
      }

      if (!e._snapFeedback._position || 0 > t.indexOf("all") && 0 > t.indexOf(e._snapFeedback._position)) return void (e._snapFeedback._position = e._dragDetails.hoveredTabArea = void 0);
      if ("center" === e._snapFeedback._position && 0 < e._items.filter(function (e) {
        return e.opened;
      }).length && (e._dragDetails.hoveredTabArea = e._dragDetails.hoveredTabsWindow.$.tabsElement.$.tabsHeaderSection), -1 < ["left", "right"].indexOf(e._snapFeedback._position) ? e._snapFeedback.areaHighlighter.style.width = e._dragDetails.windowFeedback.style.width || e._dragDetails.windowFeedback.offsetWidth + "px" : -1 < ["top", "bottom"].indexOf(e._snapFeedback._position) && (e._snapFeedback.areaHighlighter.style.height = e._dragDetails.windowFeedback.style.height || e._dragDetails.windowFeedback.offsetHeight + "px"), e._snapFeedback.areaHighlighter.setAttribute("position", e._snapFeedback._position), "header" === e._snapFeedback._position) e._dragDetails.hoveredTabsWindow.$.tabsElement.$.tabContentSection.appendChild(e._snapFeedback.areaHighlighter);else {
        var _t776 = e._dragDetails.hoveredTabsWindow.closest("smart-splitter").orientation;

        (("left" === e._snapFeedback._position || "right" === e._snapFeedback._position) && "horizontal" === _t776 || ("top" === e._snapFeedback._position || "bottom" === e._snapFeedback._position) && "vertical" === _t776) && (e._snapFeedback._position = "inside-" + e._snapFeedback._position), e._dragDetails.hoveredItem.closest("smart-splitter-item").appendChild(e._snapFeedback.areaHighlighter);
      }
    }
  }, {
    key: "_handleSimpleSnapping",
    value: function _handleSimpleSnapping(e) {
      var t = Math.min;
      var a = this;
      if (!e) return a._dragDetails && (a._dragDetails.hoveredTabsWindow = a._dragDetails.hoveredTabArea = void 0), void (a._snapFeedback && (a._snapFeedback._position = void 0, a._snapFeedback.parentElement && a._snapFeedback.classList.add("smart-visibility-hidden")));
      a._snapFeedback || (a._snapFeedback = document.createElement("div"), a._snapFeedback.addEventListener("transitionend", function () {
        a._snapFeedback.classList.contains("smart-visibility-hidden") && a._snapFeedback.parentElement && a._snapFeedback.parentElement.removeChild(a._snapFeedback);
      }));

      for (var _t777 = 0; _t777 < a._snapFeedback.classList.length; _t777++) {
        -1 < a._snapFeedback.classList[_t777].indexOf("smart-docking-snap-") && a._snapFeedback.classList.remove(a._snapFeedback.classList[_t777]);
      }

      a._snapFeedback._position = e, e = e.replace("inside-", ""), a._snapFeedback.classList.add("smart-docking-snap-" + e + "-feedback"), a._snapFeedback.classList.remove("smart-visibility-hidden");
      var i = 0 === e.indexOf("layout") ? a._dragDetails.selectedTabsWindow.dropPosition : a._dragDetails.hoveredTabsWindow.dropPosition;
      0 === i.length && (i = ["all"]), -1 < i.indexOf("all") || -1 < i.indexOf(e) ? a._snapFeedback.removeAttribute("disabled") : (a._snapFeedback.setAttribute("disabled", ""), a._snapFeedback._position = void 0);
      var n, o, r, l, s;
      var d = a.getBoundingClientRect(),
          c = getComputedStyle(a._dragDetails.hoveredTabsWindow.$.contentSection),
          m = parseFloat(c.getPropertyValue("padding-left") || 0),
          u = parseFloat(c.getPropertyValue("padding-right") || 0),
          p = parseFloat(c.getPropertyValue("padding-top") || 0),
          g = parseFloat(c.getPropertyValue("padding-bottom") || 0),
          h = a.$.verticalHiddenItemsContainer.getElementsByClassName("auto-hide-left")[0],
          _ = a.$.horizontalHiddenItemsContainer.getElementsByClassName("auto-hide-top")[0];

      switch (a._snapFeedback.style.display = "", e) {
        case "header":
          {
            var _e906 = a._getHeaderLabelDimensions();

            n = _e906.width, o = _e906.height, r = _e906.top, l = _e906.left, n && o || (a._snapFeedback.style.display = "none");
            break;
          }

        case "left":
        case "right":
          s = a._dragDetails.hoveredTabArea.getBoundingClientRect(), o = a._dragDetails.hoveredTabArea.offsetHeight, n = a._dragDetails.hoveredTabArea.offsetWidth / 2, r = s.top + window.pageYOffset, l = s.left + ("right" === e ? a._dragDetails.hoveredTabArea.offsetWidth / 2 : 0) + window.pageXOffset;
          break;

        case "top":
        case "bottom":
          s = a._dragDetails.hoveredTabArea.getBoundingClientRect(), o = a._dragDetails.hoveredTabArea.offsetHeight / 2, n = a._dragDetails.hoveredTabArea.offsetWidth, r = s.top + window.pageYOffset + ("bottom" === e ? a._dragDetails.hoveredTabArea.offsetHeight / 2 : 0), l = s.left + window.pageXOffset;
          break;

        case "layout-left":
        case "layout-right":
          {
            a._snapFeedback.parentElement && void 0 === a._snapFeedback.maxWidth && (a._snapFeedback.maxWidth = parseFloat(getComputedStyle(a._snapFeedback).getPropertyValue("max-width")) || 0), n = .07 * a.$.itemsContainer.offsetWidth - (m + u), a._snapFeedback.maxWidth && (n = t(a._snapFeedback.maxWidth, n)), o = a.$.itemsContainer.offsetHeight - (p + g), r = d.top + window.pageYOffset + p + (_ ? _.offsetHeight : 0), l = d.left + window.pageXOffset + ("layout-left" === e ? m : 0) + (h ? h.offsetWidth : 0) + ("layout-right" === e ? a.$.itemsContainer.offsetWidth - n - u : 0);
            break;
          }

        case "layout-top":
        case "layout-bottom":
          a._snapFeedback.parentElement && void 0 === a._snapFeedback.maxHeight && (a._snapFeedback.maxHeight = parseFloat(getComputedStyle(a._snapFeedback).getPropertyValue("max-height")) || 0), o = .07 * a.$.itemsContainer.offsetHeight - (p + g), a._snapFeedback.maxHeight && (o = t(a._snapFeedback.maxHeight, o)), n = a.$.itemsContainer.offsetWidth - (m + u), r = d.top + window.pageYOffset + (_ ? _.offsetHeight : 0) + ("layout-bottom" === e ? a.$.itemsContainer.offsetHeight - o + p : p), l = d.left + window.pageXOffset + m + (h ? h.offsetWidth : 0);
      }

      a._snapFeedback.style.height = o + "px", a._snapFeedback.style.width = n + "px", a._snapFeedback.style.left = l + "px", a._snapFeedback.style.top = r + "px", a._snapFeedback._position || (a._dragDetails.hoveredTabArea = void 0), a._snapFeedback.parentElement || document.body.appendChild(a._snapFeedback);
    }
  }, {
    key: "_handleItemNesting",
    value: function _handleItemNesting() {
      var e = this;
      var t = e._dragDetails.windowFeedback;

      if (t.classList.contains("smart-tabs-window-feedback")) {
        var _i758 = document.createElement("smart-tabs-window");

        var _a498 = e._dragDetails.selectedTabLabel.tab;
        _i758.min = 30, _i758.opened = _i758.pinned = !0, _i758.headerPosition = e._dragDetails.selectedTabsWindow.headerPosition, e._dragDetails.selectedTabsWindow.autoHide ? (_i758.tabTextOrientation = e._dragDetails.selectedTabsWindow._originalTextOrientation || "horizontal", _i758.tabPosition = e._dragDetails.selectedTabsWindow._originalTabPosition || "top") : (_i758.tabPosition = e._dragDetails.selectedTabsWindow.tabPosition, _i758.tabTextOrientation = e._dragDetails.selectedTabsWindow.tabTextOrientation), e.hasAnimation || (_i758.animation = "none"), _i758.size = -1 < e._snapFeedback._position.indexOf("top") || -1 < e._snapFeedback._position.indexOf("bottom") ? parseFloat(t.style.height) || t.offsetHeight : parseFloat(t.style.width) || t.offsetWidth, _i758.label = _a498.label, _i758.id = "", e._dragDetails.windowFeedback.removeChild(_a498), _i758.appendChild(_a498), _i758.style.left = _i758.style.top = "", _i758.draggable = void 0 === _a498.draggable || _a498.draggable, _i758.floatable = void 0 === _a498.floatable || _a498.floatable, t = _i758;
      } else {
        var _i759 = t.context;
        t.context = t, t.windowParent = null, t.context = _i759, t.size = -1 < e._snapFeedback._position.indexOf("top") || -1 < e._snapFeedback._position.indexOf("bottom") ? parseFloat(t.style.height) || t.offsetHeight : parseFloat(t.style.width) || t.offsetWidth, t.style.top = t.style.left = t.style.width = t.style.height = "", t.pinned = !0, t._originalTabPosition || (t._originalTabPosition = t.tabPosition);
      }

      return e._insert(e._items.indexOf(e._dragDetails.hoveredTabsWindow), t, e._snapFeedback._position), t;
    }
  }, {
    key: "_handleWindowOnDrag",
    value: function _handleWindowOnDrag() {
      var e = this;
      if (e._dragDetails.windowFeedback.hasAttribute("dragged")) return;
      var t = e._dragDetails.selectedItem,
          i = e._dragDetails.selectedTabsWindow,
          a = i.closest("smart-splitter");
      if (e._setWindowFeedbackSize(), i === e.$.autoHideWindow && !e._dragDetails._parentInfo) e._dragDetails._parentInfo = {}, 1 < i._tabsWindow.items.length ? (e._dragDetails._parentInfo.closestItem = i._tabsWindow, e._dragDetails._parentInfo.position = e.$.autoHideWindow._tab.index) : (e._dragDetails._parentInfo.closestItem = e.$.itemsContainer, e._dragDetails._parentInfo.position = i._tabsWindow.tabPosition, e._dragDetails.windowFeedback.headerButtons = e.$.autoHideWindow._tabsWindow.headerButtons, e._noStateChangeFiring = !0, e.undock(e._dragDetails.windowFeedback)), e._originalTabIndex = void 0;else {
        if (a && a !== e.$.itemsContainer && 1 === a._items.length) for (; 1 === a._items.length && a !== e.$.itemsContainer;) {
          a = a.parentElement.closest("smart-splitter"), t = t.parentElement.closest("smart-splitter-item");
        }
        if (!e._dragDetails._parentInfo) if (e._dragDetails._parentInfo = {}, i.closest("smart-docking-layout") !== e && e._getClosestDockingLayout(i) !== e) e._dragDetails._parentInfo.position = {
          top: i.offsetTop,
          left: i.offsetLeft
        };else if (i.autoHide) e._dragDetails._parentInfo.closestItem = e.$.itemsContainer, e._dragDetails._parentInfo.position = i.tabPosition, i._originalTabPosition && (i.tabPosition = i._originalTabPosition), i._originalTextOrientation && (i.tabTextOrientation = i._originalTextOrientation);else {
          var _i760 = a._items.indexOf(t),
              _n371 = a._items.length;

          1 === _n371 ? (e._dragDetails._parentInfo.position = "horizontal" === a.orientation ? "top" : "left", e._dragDetails._parentInfo.closestItem = void 0) : (0 === _i760 ? (e._dragDetails._parentInfo.position = "horizontal" === a.orientation ? "top" : "left", e._dragDetails._parentInfo.closestItem = a._items[_i760 + 1].getElementsByTagName("smart-tabs-window")[0]) : (e._dragDetails._parentInfo.position = "horizontal" === a.orientation ? "bottom" : "right", e._dragDetails._parentInfo.closestItem = a._items[_i760 - 1].getElementsByTagName("smart-tabs-window")[0]), e._dragDetails._parentInfo.closestItemSize = e._dragDetails._parentInfo.closestItem[a._measurements.size], a === e._dragDetails._parentInfo.closestItem.closest("smart-splitter") ? 2 === a._items.length && (e._dragDetails._parentInfo.position = "inside-" + e._dragDetails._parentInfo.position) : a === e.$.itemsContainer ? e._dragDetails._parentInfo.position = "layout-" + e._dragDetails._parentInfo.position : e._dragDetails._parentInfo.position = "outside-" + e._dragDetails._parentInfo.position);
        }
      }
      if (a) e._dragDetails.windowFeedback.size = e._dragDetails.windowFeedback[a._measurements.size];else if (i === e.$.autoHideWindow) {
        var _t778 = e.$.autoHideWindow._tabsWindow.tabPosition;
        e._dragDetails.windowFeedback.size = e.$.autoHideWindow["offset" + ("top" === _t778 || "bottom" === _t778 ? "Height" : "Width")];
      }
      e._dragDetails.windowFeedback.setAttribute("dragged", ""), e._dragDetails.windowFeedback.parentElement !== document.body && (e._dragDetails.windowFeedback.windowParent = "body", document.body.appendChild(e._dragDetails.windowFeedback)), ("advanced" !== e.snapMode && "none" === e._dragDetails.windowFeedback.tabPosition || e._dragDetails.windowFeedback.autoHide) && (e._dragDetails.windowFeedback.tabPosition = e._dragDetails.windowFeedback._originalTabPosition || "top"), e._dragDetails.windowFeedback.autoHide = !1, e._dragDetails.windowFeedback.allowToggle = !1;

      var n = e._items.indexOf(e._dragDetails.windowFeedback);

      -1 < n && e._items.splice(n, 1), t && t.parentElement && (0 === e._items.filter(function (e) {
        return e.opened;
      }).length && !e.$.placeholderItem.parentElement && (-1 < e.$.itemsContainer._items[0].className.indexOf("auto-hide") ? e.$.itemsContainer.insert(1, e.$.placeholderItem) : e.$.itemsContainer.insert(0, e.$.placeholderItem)), a ? (a.removeChild(t), e._dragDetails.initialSplitterOrientation = "horizontal" === a.orientation, e._removeUnneccessaryItems(a)) : i === e.$.autoHideWindow && 0 === e.$.autoHideWindow._tabsWindow.items.length && e.$.autoHideWindow._tabsWindow.closest("smart-splitter").removeChild(t), e._setAutoHidePaddings());
    }
  }, {
    key: "_setWindowFeedbackSize",
    value: function _setWindowFeedbackSize() {
      var e = this,
          t = e._dragDetails.selectedTabsWindow;

      if (!e._dragDetails._isWindowFeedbackSizeSet) {
        var _i761, _a499;

        t.autoHide && t._autoHideWindow ? "top" === t.tabPosition || "bottom" === t.tabPosition ? (_i761 = t.offsetWidth + "px", _a499 = t._autoHideWindow.offsetHeight + "px") : (_i761 = t._autoHideWindow.offsetWidth + "px", _a499 = t.offsetHeight + "px") : (_i761 = t.style.width || t.offsetWidth + "px", _a499 = t.style.height || t.offsetHeight + "px"), e._dragDetails.windowFeedback.style.width = _i761, e._dragDetails.windowFeedback.style.height = _a499, e._dragDetails._isWindowFeedbackSizeSet = !0;
      }
    }
  }, {
    key: "_insert",
    value: function _insert(e, t, i) {
      var a = this;
      if ("number" != typeof e) return void a.error(a.localize("invalidIndex", {
        elementType: a.nodeName.toLowerCase(),
        method: arguments[3] || "insert"
      }));
      if ("object" == typeof t && !(t instanceof HTMLElement)) t = a._createTabsWindowFromObject(t);else if ("string" == typeof t) t = a._getItemById(t);else if (t instanceof Smart.TabItem) {
        var _e907 = t.closest("smart-tabs-window");

        if (!_e907 && a.shadowRoot && t.getRootNode() && t.getRootNode().host && (_e907 = t.getRootNode().host.closest("smart-tabs-window")), _e907 && _e907.autoHide) return void a._dock(_e907, i);
        t = a._createTabsWindowFromObject({
          label: t.label,
          items: [{
            label: t.label,
            content: t.content
          }]
        });
      }
      if (!t || !(t instanceof Smart.TabsWindow)) return void a.error(a.localize("invalidNode", {
        elementType: a.nodeName.toLowerCase(),
        method: arguments[3] || "insert"
      }));
      if ((a.shadowRoot || a).contains(t) && t.autoHide) return void a._dock(t, i);

      if (i && -1 < i.indexOf("layout")) {
        var _t779 = a._items.filter(function (e) {
          return e.opened;
        });

        e = 0 < _t779 ? -1 < i.indexOf("left") || -1 < i.indexOf("top") ? 0 : _t779[_t779.length - 1] : 0;
      }

      var n = a._items[e];
      a._items[e] && !a._items[e].opened && (n = a._items.filter(function (e) {
        return e.opened;
      })[0]), 0 === a._items.length && (a.$.itemsContainer.orientation = -1 < i.indexOf("left") || -1 < i.indexOf("right") ? "vertical" : "horizontal"), t.style.top = t.style.left = "", t.style.width = t.style.height = "", t.opened = !0, t.pinned = !0;
      var o = t.closest("smart-splitter-item");

      if (!n) {
        if (a.insertBefore(t, n || null), o) {
          var _e908 = o.closest("smart-splitter");

          !_e908 && a.shadowRoot && o.getRootNode() && o.getRootNode().host && (_e908 = o.getRootNode().host.closest("smart-splitter")), _e908 && _e908.removeChild(o);
        }

        return;
      }

      if (delete t._parentInfo, t.autoHide && (a.$.verticalHiddenItemsContainer.contains(t) ? a.$.verticalHiddenItemsContainer.removeChild(t.closest("smart-splitter-item")) : a.$.horizontalHiddenItemsContainer.contains(t) && a.$.horizontalHiddenItemsContainer.removeChild(t.closest("smart-splitter-item"))), i ? a._handleItemPositionInserting(t, n, i) : a.insertBefore(t, n || null), o) {
        var _e909 = o.closest("smart-splitter");

        _e909 && _e909.removeChild(o);
      }

      if (t.autoHide) a._autoHide(t, i);else {
        var _e910 = document.scrollingElement || document.documentElement,
            _i762 = _e910.scrollLeft,
            _a500 = _e910.scrollTop;

        t.focus(), window.scrollTo(_i762, _a500);
      }
      0 < a._items.filter(function (e) {
        return e.opened;
      }).length && a.$.placeholderItem.parentElement && a.$.itemsContainer.removeChild(a.$.placeholderItem), t.layout = a, t.resizeMode = "none", t.minimized = !1, t.maximized = !1, a._setDockedItemsHeaderButtons(t);
    }
  }, {
    key: "_itemsContainerCloseHandler",
    value: function _itemsContainerCloseHandler(e) {
      var t = this;

      if (e.target instanceof Smart.Tabs) {
        var _i763 = e.target;
        return void (0 === _i763._tabs.length && t.removeChild(_i763.closest("smart-tabs-window")));
      }

      if (e.target instanceof Smart.TabsWindow) {
        var _i764 = e.target.closest("smart-splitter-item"),
            _a501 = _i764.closest("smart-splitter");

        _a501 && (_a501.removeChild(_i764), t._removeUnneccessaryItems(_a501)), e.target.close(), 0 !== t._items.filter(function (e) {
          return e.opened;
        }).length || t.$.placeholderItem.parentElement || t.$.itemsContainer.appendChild(t.$.placeholderItem);
      }
    }
  }, {
    key: "_itemsContainerAutoHideHandler",
    value: function _itemsContainerAutoHideHandler(e) {
      var t = this,
          i = e.detail.button,
          a = i.closest("smart-tabs-window") || i.getRootNode().host;

      if (a) {
        var _e911 = a.closest("smart-splitter-item");

        if (_e911) {
          var _i765 = a.closest("smart-splitter");

          if (_i765) {
            var _n372 = _i765.items,
                _o267 = "horizontal" === _i765.orientation,
                _r168 = _n372.indexOf(_e911) >= _n372.length / 2;

            _o267 ? _r168 ? t.autoHideBottom(a) : t.autoHideTop(a) : _r168 ? t.autoHideRight(a) : t.autoHideLeft(a);
          }
        }
      }
    }
  }, {
    key: "_itemsContainerMenuHandler",
    value: function _itemsContainerMenuHandler(e) {
      var t = this,
          i = t.$.menu,
          a = t.getBoundingClientRect(),
          n = e.detail.button.getBoundingClientRect();
      i.open(n.left - a.left, n.top - a.top), t._menuOpenButton = e.detail.button;
    }
  }, {
    key: "_itemsContainerResizeHandler",
    value: function _itemsContainerResizeHandler() {
      var e = this,
          t = event.target._items ? event.target._items[event.detail.firstItem.index] : void 0;
      e._handleAutoSave(), e.$.fireEvent("stateChange", {
        type: "resize",
        item: t
      });
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this;
      if (!t.disabled && t.hasAttribute("dragged") && t._snapFeedback) if (e.preventDefault(), "Control" !== e.key) "Escape" === e.key && t._cancelDragOperation();else if ("advanced" === t.snapMode) {
        for (var _e912 in t._snapFeedback) {
          if (t._snapFeedback[_e912] instanceof HTMLElement) {
            if ("outherSnapElement" == _e912) {
              var _e913 = t.$.container.children;

              for (var _t780 = 0; _t780 < _e913.length; _t780++) {
                -1 < _e913[_t780].className.indexOf("smart-docking-layout-snap") && _e913[_t780].classList.add("smart-hidden");
              }

              continue;
            }

            t._snapFeedback[_e912].classList.add("smart-hidden");
          }
        }
      } else t._snapFeedback.classList.add("smart-hidden");
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this;
      if (!t.disabled && "Control" === e.key && t.hasAttribute("dragged") && t._snapFeedback) if (e.preventDefault(), "advanced" === t.snapMode) {
        for (var _e914 in t._snapFeedback) {
          if (t._snapFeedback[_e914] instanceof HTMLElement) {
            if ("outherSnapElement" == _e914) {
              var _e915 = t.$.container.children;

              for (var _t781 = 0; _t781 < _e915.length; _t781++) {
                -1 < _e915[_t781].className.indexOf("smart-docking-layout-snap") && _e915[_t781].classList.remove("smart-hidden");
              }

              continue;
            }

            t._snapFeedback[_e914].classList.remove("smart-hidden");
          }
        }

        t._handleSnapping();
      } else t._snapFeedback.classList.remove("smart-hidden");
    }
  }, {
    key: "_loadState",
    value: function _loadState(e) {
      var t = this;

      t._createItemsFromArray(e, !0);
    }
  }, {
    key: "_removeAll",
    value: function _removeAll(e) {
      function t(e) {
        var t = e._items;
        if (t) for (var _a502 = 0; _a502 < t.length; _a502++) {
          t[_a502].$.hasClass("smart-docking-layout-item-holder") || e.removeChild(t[_a502]);
        }
      }

      var i = this;
      i.$.itemsContainer.removeAll(), t(i.$.horizontalHiddenItemsContainer), t(i.$.verticalHiddenItemsContainer), i._items = [], e || i.$.itemsContainer.appendChild(i.$.placeholderItem);
    }
  }, {
    key: "_removeUnneccessaryItems",
    value: function _removeUnneccessaryItems(e) {
      if (e) {
        var _t782 = this;

        for (var _i766; e._items && 0 === e._items.length && e !== _t782.$.itemsContainer;) {
          (_i766 = e.closest("smart-splitter-item")).removeChild(e), e = _i766.closest("smart-splitter"), e.removeChild(_i766);
        }
      }
    }
  }, {
    key: "_returnItemToOrigin",
    value: function _returnItemToOrigin(e) {
      var t = this;

      if (e && t._dragDetails) {
        var _a503 = t._dragDetails._parentInfo;
        if (_a503) if ("number" == typeof _a503.position) {
          var _t783 = [].slice.call(e.items);

          for (var _n373 = 0; _n373 < _t783.length; _n373++) {
            e.removeChild(_t783[_n373]), _a503.closestItem.insert(_a503.position, {
              node: _t783[_n373]
            });
          }
        } else "object" == typeof _a503.position ? (e.style.top = _a503.position.top + "px", e.style.left = _a503.position.left + "px") : _a503.closestItem ? _a503.closestItem === t.$.itemsContainer ? t._autoHide(e, _a503.position) : t._insert(t._items.indexOf(_a503.closestItem), e, _a503.position) : t.appendChild(e);
      }
    }
  }, {
    key: "_setAutoHidePaddings",
    value: function _setAutoHidePaddings() {
      var e = this,
          t = e.$.verticalHiddenItemsContainer.getElementsByClassName("auto-hide-left")[0],
          i = e.$.verticalHiddenItemsContainer.getElementsByClassName("auto-hide-right")[0],
          a = e.$.horizontalHiddenItemsContainer.getElementsByClassName("auto-hide-top")[0],
          n = e.$.horizontalHiddenItemsContainer.getElementsByClassName("auto-hide-bottom")[0];
      a && (a.style.paddingLeft = t ? t.offsetWidth + "px" : "", a.style.paddingRight = i ? i.offsetWidth + "px" : ""), n && (n.style.paddingLeft = t ? t.offsetWidth + "px" : "", n.style.paddingRight = i ? i.offsetWidth + "px" : "");
    }
  }, {
    key: "_setDockedItemsHeaderButtons",
    value: function _setDockedItemsHeaderButtons(e) {
      var t = e.headerButtons,
          i = ["close", "maximize", "minimize"],
          a = t.filter(function (e) {
        return 0 > i.indexOf(e);
      });
      a = 0 === a.length ? ["close", "autoHide"] : t, e.headerButtons = a;
    }
  }, {
    key: "_setFloatingItemsHeaderButtons",
    value: function _setFloatingItemsHeaderButtons(e) {
      var t = ["close", "autoHide"];
      e._originalTabPosition = e.tabPosition;
      var i = e.headerButtons.filter(function (e) {
        return 0 > t.indexOf(e);
      });
      i = 0 === i.length ? ["close", "maximize", "minimize"] : e.headerButtons, e.headerButtons = i;
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;

      if (!e.disabled && !e.unfocusable) {
        var _t784 = 0 < e.tabIndex ? e.tabIndex : 0;

        e.setAttribute("tabindex", _t784);
      } else e.removeAttribute("tabindex");
    }
  }, {
    key: "_setSnappingMarkers",
    value: function _setSnappingMarkers(e, t) {
      var i = Math.max;
      var a = this;
      var n = Smart.Utilities.Core.isMobile ? document.elementFromPoint(e.pageX - window.pageXOffset, e.pageY - window.pageYOffset) : e.originalEvent.target,
          o = n.closest && n.closest("smart-docking-layout");
      if (o || (o = a._getClosestDockingLayout(n)), n.shadowRoot && (n = e.originalEvent.composedPath()[0]), "advanced" === a.snapMode) return e.ctrlKey ? void 0 : (a._dragDetails.hoveredItem = n.closest(".smart-docking-layout-snap") ? n : a._dragDetails.hoveredItem && 0 < a._dragDetails.hoveredItem.getElementsByTagName("smart-splitter").length ? void 0 : a._dragDetails.hoveredItem, a._dragDetails.hoveredTabArea = t ? n.closest(".smart-tab-label-container") || t : a._dragDetails.hoveredTabArea, void a._handleSnapping());
      if (!o || o !== a) return void a._handleSnapping();
      if (!a._dragDetails.hoveredTabsWindow || a._dragDetails.windowFeedback !== a.$.tabsWindowFeedback && a._dragDetails.hoveredTabsWindow === a._dragDetails.selectedTabsWindow) return a._dragDetails.hoveredItem = n.closest(".smart-docking-layout-snap") ? n : a._dragDetails.hoveredItem && 0 < a._dragDetails.hoveredItem.getElementsByTagName("smart-splitter").length ? void 0 : a._dragDetails.hoveredItem, void a._handleSnapping();
      var r = {};

      if (a._dragDetails.hoveredItem) {
        var _e916 = a._dragDetails.hoveredItem.getBoundingClientRect(),
            _t785 = a.$.itemsContainer.getBoundingClientRect();

        r.left = a._dragDetails.hoveredItem ? _e916.left - _t785.left : 0, r.top = a._dragDetails.hoveredItem ? _e916.top - _t785.top : 0;
      } else r.left = r.top = 0;

      var l = a.getBoundingClientRect(),
          s = a.$.itemsContainer.getBoundingClientRect(),
          d = i(0, e.pageX - window.pageXOffset - l.left - (s.left - l.left)),
          c = i(0, e.pageY - window.pageYOffset - l.top - (s.top - l.top));
      if (a._dragDetails.hoveredTabArea === t) a._dragDetails.hoveredTabArea = n.closest(".smart-tab-label-container"), a._handleSnapping("header");else if (!a._dragDetails.hoveredItem || a._dragDetails.hoveredTabsWindow.autoHide) a._handleSnapping();else if (d < .05 * a.$.itemsContainer.offsetWidth && d < .15 * a._dragDetails.hoveredItem.offsetWidth) a._handleSnapping("layout-left", e);else if (d > .95 * a.$.itemsContainer.offsetWidth && d > .85 * a._dragDetails.hoveredItem.offsetWidth + a._dragDetails.hoveredItem.offsetLeft) a._handleSnapping("layout-right");else if (c < .05 * a.$.itemsContainer.offsetHeight) a._handleSnapping("layout-top");else if (c > .95 * a.$.itemsContainer.offsetHeight) a._handleSnapping("layout-bottom");else if (n.closest(".smart-tabs-content-section")) {
        var _e917 = a._dragDetails.hoveredItem.closest("smart-splitter").orientation;

        d < r.left + .3 * a._dragDetails.hoveredTabArea.offsetWidth ? a._handleSnapping("horizontal" === _e917 ? "inside-left" : "left") : d > r.left + .7 * a._dragDetails.hoveredTabArea.offsetWidth ? a._handleSnapping("horizontal" === _e917 ? "inside-right" : "right") : c < r.top + a._dragDetails.hoveredTabArea.offsetTop + .5 * a._dragDetails.hoveredTabArea.offsetHeight + a._dragDetails.hoveredTabsWindow.$.headerSection.offsetHeight ? a._handleSnapping("vertical" === _e917 ? "inside-top" : "top") : a._handleSnapping("vertical" === _e917 ? "inside-bottom" : "bottom");
      } else a._handleSnapping();
    }
  }, {
    key: "_setSplitterBarVisibility",
    value: function _setSplitterBarVisibility() {
      var e = this,
          t = e.$.itemsContainer.getElementsByTagName("smart-splitter-bar");

      for (var _a504 = 0; _a504 < t.length; _a504++) {
        e.hideSplitterBars ? t[_a504].hide() : t[_a504].show();
      }
    }
  }, {
    key: "_validateWindowPosition",
    value: function _validateWindowPosition(e) {
      var t = Math.min,
          i = Math.max;
      e.$.addClass("no-transition", "");
      var a = document.scrollingElement || document.documentElement;
      e.style.top = 0 < a.scrollTop ? (parseFloat(e.style.top) || e.offsetTop) + "px" : i(0, t(parseFloat(e.style.top) || e.offsetTop, document.documentElement.clientHeight - e.offsetHeight)) + "px", e.style.left = 0 < a.scrollLeft ? (parseFloat(e.style.left) || e.offsetLeft) + "px" : i(0, t(parseFloat(e.style.left) || e.offsetLeft, document.documentElement.clientWidth - e.offsetWidth)) + "px", requestAnimationFrame(function () {
        return e.$.removeClass("no-transition");
      });
    }
  }, {
    key: "autoHideItems",
    get: function get() {
      var e = this;
      if (e.isReady) return e.getAutoHideItems();
    }
  }, {
    key: "items",
    get: function get() {
      var e = this;
      if (e.isReady) return e._items.filter(function (e) {
        return e.opened;
      }).concat(e.getAutoHideItems());
    }
  }, {
    key: "closedItems",
    get: function get() {
      var e = this;
      if (e.isReady) return e._items.filter(function (e) {
        return !e.opened;
      });
    }
  }, {
    key: "undockedItems",
    get: function get() {
      var e = this;

      if (e.isReady) {
        var _t786 = document.getElementsByTagName("smart-tabs-window");

        var _a505 = [];

        for (var _n374 = 0; _n374 < _t786.length; _n374++) {
          _t786[_n374].closest("smart-docking-layout") || e._getClosestDockingLayout(_t786[_n374]) || _t786[_n374].layout !== e || (_t786[_n374].undocked = !0, _a505.push(_t786[_n374]));
        }

        return _a505;
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoLoadState: {
          value: !1,
          type: "boolean"
        },
        autoSaveState: {
          value: !1,
          type: "boolean"
        },
        draggable: {
          value: !0,
          type: "boolean"
        },
        floatable: {
          value: !0,
          type: "boolean"
        },
        hideSplitterBars: {
          value: !1,
          type: "boolean"
        },
        layout: {
          value: [],
          type: "array",
          reflectToAttribute: !1
        },
        liveResize: {
          value: !1,
          type: "boolean"
        },
        messages: {
          value: {
            en: {
              invalidNode: "{{elementType}}: \"{{method}}\" method accepts an instance of Smart.TabsWindow",
              invalidNodeRemove: "{{elementType}}: \"{{method}}\" method accepts an instance of Smart.TabsWindow that is a child of the DockingLayout.",
              invalidNodeType: "{{elementType}}: The method \"{{method}}\" requires a \"smart-tabs-window\" element to be passed as an argument.",
              invalidTargetNode: "{{elementType}}: The method \"{{method}}\" requires an index of an item that is not hidden/closed. Only visible items that are part of the Layout are valid.",
              invalidIndex: "{{elementType}}: \"{{method}}\" method accepts an index of type number.",
              noId: "smartDockingLayout requires an id in order to save/load a state."
            }
          },
          type: "object",
          extend: !0
        },
        resizeStep: {
          value: 5,
          type: "number"
        },
        snapMode: {
          value: "advanced",
          allowedValues: ["simple", "advanced"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "autoHideWindow.close": "_autoHideWindowCloseHandler",
        "autoHideWindow.resizeEnd": "_autoHideWindowResizeEndHandler",
        "container.dock": "_dockEventHandler",
        move: "_moveHandler",
        "document.down": "_documentDownHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler",
        "document.selectstart": "_documentSelectStartHandler",
        "document.dragstart": "_documentDragStartHandler",
        "container.tabStripResize": "_containerTabStripResizeHandler",
        "itemsContainer.close": "_itemsContainerCloseHandler",
        "itemsContainer.autoHide": "_itemsContainerAutoHideHandler",
        "itemsContainer.resizeEnd": "_itemsContainerResizeHandler",
        keydown: "_keyDownHandler",
        keyup: "_keyUpHandler",
        mouseleave: "_mouseLeaveHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.dockinglayout.css"];
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.TabsWindow": "smart.window.js",
        "Smart.Splitter": "smart.splitter.js"
      };
    }
  }]);

  return _class81;
}(Smart.ContentElement)), Smart("smart-file-upload",
/*#__PURE__*/
function (_Smart$BaseElement17) {
  "use strict";

  _inherits(_class82, _Smart$BaseElement17);

  function _class82() {
    _classCallCheck(this, _class82);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class82).apply(this, arguments));
  }

  _createClass(_class82, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div id=\"fileUploadHeader\" class=\"smart-file-upload-header\" role=\"presentation\">\n                        <smart-button class=\"smart-browse-button\" id=\"browseButton\" disabled=\"[[disabled]]\" theme=\"[[theme]]\" right-to-left=\"[[rightToLeft]]\"></smart-button>\n                        <input type=\"file\" class=\"smart-browse-input\" id=\"browseInput\" name=\"[[name]]\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" unfocusable=\"[[unfocusable]]\" multiple=\"[[multiple]]\" webkitdirectory=\"[[directory]]\" mozdirectory=\"[[directory]]\" />\n                    </div>\n                    <div id=\"fileUploadContainer\" class=\"smart-file-upload-container\">\n                        <div id=\"dropZone\" class=\"smart-drop-zone\" aria-label=\"Drag files here\"></div>\n                        <div id=\"selectedFiles\" class=\"smart-selected-files\" role=\"list\" aria-label=\"Selected files\"></div>\n                    </div>\n                    <div id=\"totalFiles\" class=\"smart-total-files smart-hidden\" role=\"presentation\">Total flies: 0</div>\n                    <div id=\"fileUploadFooter\" class=\"smart-file-upload-footer smart-hidden\"><smart-button class=\"smart-upload-all-button success\" id=\"uploadAllButton\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" unfocusable=\"[[unfocusable]]\"\" theme=\"[[theme]]\" right-to-left=\"[[rightToLeft]]\"></smart-button><smart-button class=\"smart-cancel-all-button error\" id=\"cancelAllButton\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" unfocusable=\"[[unfocusable]]\" theme=\"[[theme]]\" right-to-left=\"[[rightToLeft]]\"></smart-button><smart-button class=\"smart-pause-all-button primary\" id=\"pauseAllButton\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" unfocusable=\"[[unfocusable]]\" theme=\"[[theme]]\" right-to-left=\"[[rightToLeft]]\"></smart-button></div>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      _get(_getPrototypeOf(_class82.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      "accept" === e ? a.$.browseInput.accept = i : "dropZone" === e || "appendTo" === e ? a._handleContainers() : "messages" === e || "locale" === e ? a._updateTextValues() : "multiple" === e ? (a.$.browseButton.disabled = !!(!a.multiple && 0 < a._selectedFiles.length || a.disabled), !i && 1 < a._selectedFiles.length && (a._selectedFiles.splice(1), a._renderSelectedFiles())) : "itemTemplate" === e ? 0 < a._items.length && (a._renderSelectedFiles(), a._handleComponentsByAvailableHeight()) : "rightToLeft" === e ? (a._items && a._items.forEach(function (e) {
        var t = e.querySelector("smart-progress-bar");
        t && (t.rightToLeft = i), i ? e.setAttribute("right-to-left", "") : e.removeAttribute("right-to-left");
      }), i ? a.$.dropZone.setAttribute("right-to-left", "") : a.$.dropZone.removeAttribute("right-to-left")) : void 0;
    }
  }, {
    key: "attached",
    value: function attached() {
      _get(_getPrototypeOf(_class82.prototype), "attached", this).call(this);

      var e = this;

      e._handleContainers();
    }
  }, {
    key: "detached",
    value: function detached() {
      _get(_getPrototypeOf(_class82.prototype), "detached", this).call(this);

      var e = this;
      e.$.fileUploadContainer.contains(e.$.dropZone) || e.$.fileUploadContainer.insertBefore(e.$.dropZone, e.$.fileUploadContainer.firstChild), e.$.fileUploadContainer.contains(e.$.selectedFiles) || e.$.fileUploadContainer.appendChild(e.$.selectedFiles);
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class82.prototype), "ready", this).call(this);

      var e = this;
      e.$.dropZone.id || (e.$.dropZone.id = e.id + "DropZone"), e.$.selectedFiles.id || (e.$.selectedFiles.id = e.id + "SelectedFiles"), e.$.fileUploadContainer.setAttribute("aria-owns", e.$.dropZone.id + " " + e.$.selectedFiles.id), e.setAttribute("role", "dialog"), e.rightToLeft ? e.$.dropZone.setAttribute("right-to-left", "") : e.$.dropZone.removeAttribute("right-to-left"), e._setInitialValues(), e._updateTextValues(), e._handleContainers(), e._handleComponentsByAvailableHeight();
    }
  }, {
    key: "browse",
    value: function browse() {
      var e = this;
      e.disabled || !e.multiple && 0 < e._selectedFiles.length || e.$.browseInput.click();
    }
  }, {
    key: "cancelAll",
    value: function cancelAll() {
      var e = this;

      if (!(e.disabled || 0 === e._items.length)) {
        for (var _t787 = e._items.length - 1; 0 <= _t787; _t787--) {
          e.cancelFile(e._items[_t787].index);
        }

        e.$.browseButton.disabled = !!(!e.multiple && 0 < e._selectedFiles.length || e.disabled);
      }
    }
  }, {
    key: "cancelFile",
    value: function cancelFile(e) {
      var t = this;

      if (!("number" != typeof e || t.disabled || 0 === t._selectedFiles.length)) {
        var _i767 = t._getFileItem(e, !0);

        if (!_i767) return void t.error(t.localize("wrongItemIndex", {
          elementType: t.nodeName.toLowerCase()
        }));

        var _a506 = t._items.indexOf(_i767);

        t.$.selectedFiles.removeChild(_i767), _i767 && _i767.xhr && _i767.xhr.abort(), t._selectedFiles.splice(_a506, 1), t._items.splice(_a506, 1), t.$.fireEvent("uploadCanceled", {
          filename: _i767.file.name,
          type: _i767.file.type,
          size: _i767.file.size,
          index: _i767.index
        }), t.$.browseButton.disabled = !!(!t.multiple && 0 < t._selectedFiles.length || t.disabled), 0 === t._selectedFiles.length && t.$.fileUploadFooter.classList.add("smart-hidden"), t._handleComponentsByAvailableHeight();
      }
    }
  }, {
    key: "pauseAll",
    value: function pauseAll() {
      var e = this;
      if (!(e.disabled || 0 === e._items.length)) for (var _t788 = e._items.length - 1, _i768; 0 <= _t788; _t788--) {
        _i768 = e._items[_t788], _i768.xhr && _i768.xhr.abort();
      }
    }
  }, {
    key: "pauseFile",
    value: function pauseFile(e) {
      var t = this;

      if (!("number" != typeof e && "string" != typeof e || t.disabled || 0 === t._items.length)) {
        var _i769 = t._getFileItem(e, !0);

        return _i769 ? void (_i769.classList.remove("smart-uploading-start"), _i769 && _i769.xhr && _i769.xhr.abort(), t.$.fireEvent("uploadPaused", {
          filename: _i769.file.name,
          type: _i769.file.type,
          size: _i769.file.size,
          index: _i769.index
        })) : void t.error(t.localize("wrongItemIndex", {
          elementType: t.nodeName.toLowerCase()
        }));
      }
    }
  }, {
    key: "uploadAll",
    value: function uploadAll() {
      var e = this;
      if (!(e.disabled || 0 === e._items.length)) for (var _t789 = e._items.length - 1; 0 <= _t789; _t789--) {
        e._items[_t789].uploading || e.uploadFile(e._items[_t789].index);
      }
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(e) {
      var t = this;
      var i = !1;
      if ("number" != typeof e || t.disabled || 0 === t._selectedFiles.length) return;

      var a = t._getFileItem(e, !0);

      if (!a) return;
      var n = new FormData(),
          o = t.showProgress ? a.getElementsByTagName("smart-progress-bar")[0] : null,
          r = a.file;
      a.classList.remove("smart-pause", "smart-error"), a.classList.add("smart-uploading-start"), n.append("userfile[]", r);
      var l = new XMLHttpRequest();
      l.open("POST", t.uploadUrl), t.setHeaders && "function" == typeof t.setHeaders && t.setHeaders(l, r), t.$.fireEvent("uploadStarted", {
        filename: a.file.name,
        type: a.file.type,
        size: a.file.size,
        index: a.index
      }), l.upload.onprogress = function (e) {
        i || (i = !0, a.classList.remove("smart-uploading-start"), a.classList.add("smart-uploading"), a.uploading = !0, a.xhr = l), o && (o.value = Math.round(100 * (e.loaded / e.total))), a.classList.remove("smart-pause", "smart-error");
      }, l.onabort = function () {
        a.classList.remove("smart-uploading-start", "smart-uploading"), a.classList.add("smart-pause"), a.addEventListener("animationend", function () {
          a.classList.remove("smart-pause", "smart-error");
        });
      }, l.onerror = function () {
        a.classList.remove("smart-uploading-start", "smart-uploading"), a.classList.add("smart-error"), a.addEventListener("animationend", function () {
          a.classList.remove("smart-pause", "smart-error");
        });
      }, l.onload = function () {
        if (i = !1, a.classList.remove("smart-uploading-start", "smart-uploading"), 200 <= l.status && 299 >= l.status) {
          var _e918 = t._items.indexOf(a);

          t.$.selectedFiles.removeChild(a), t._selectedFiles.splice(t._selectedFiles.indexOf(r), 1), t._items.splice(_e918, 1), t.$.browseButton.disabled = !!(!t.multiple && 0 < t._selectedFiles.length || t.disabled), t.$.fireEvent("uploadCompleted", {
            filename: a.file.name,
            type: a.file.type,
            size: a.file.size,
            status: l.status,
            index: a.index
          }), 0 === t._selectedFiles.length && t.$.fileUploadFooter.classList.add("smart-hidden");
        } else a.classList.add("smart-error"), a.classList.remove("smart-uploading"), t.$.fireEvent("uploadError", {
          filename: a.file.name,
          type: a.file.type,
          size: a.file.size,
          status: l.status,
          index: a.index
        });
      }, l.onreadystatechange = function () {
        t.responseHandler && "function" == typeof t.responseHandler && t.responseHandler(l);
      }, l.send(n);
    }
  }, {
    key: "_selectedFilesClickHandler",
    value: function _selectedFilesClickHandler(e) {
      var t = this;

      if (!t.disabled) {
        var _i770 = e.target,
            _a507 = _i770.closest(".smart-item-upload-button"),
            _n375 = _i770.closest(".smart-item-cancel-button"),
            _o268 = _i770.closest(".smart-item-pause-button"),
            _r169 = _i770.closest(".smart-file");

        _a507 ? t.uploadFile(_r169.index) : _n375 ? t.cancelFile(_r169.index) : _o268 && t.pauseFile(_r169.index);
      }
    }
  }, {
    key: "_browseInputChangeHandler",
    value: function _browseInputChangeHandler() {
      var e = this,
          t = e._filterNewFiles(Array.from(e.$.browseInput.files));

      var i = [];
      e.disabled || 0 === t.length || (i = e.validateFile && "function" == typeof e.validateFile ? t.filter(function (t) {
        return !!e.validateFile(t) || (e.$.fireEvent("validationError", {
          filename: t.name,
          type: t.type,
          size: t.size
        }), !1);
      }) : t, e._selectedFiles = e._selectedFiles.concat(i), 0 === e._selectedFiles.length || (e._renderSelectedFiles(i), e.$.browseButton.disabled = !!(!e.multiple && 0 < e._selectedFiles.length || e.disabled), e.$.browseInput.value = "", e.autoUpload && e.uploadAll()));
    }
  }, {
    key: "_defaultItemTemplate",
    value: function _defaultItemTemplate(e, t) {
      var i = this,
          a = i.localize("uploadFile"),
          n = i.localize("cancelFile"),
          o = i.localize("pauseFile"),
          r = i.rightToLeft ? "right-to-left " : "";
      return "<span id=\"".concat(i.id + "File" + t + "Name", "\" class=\"smart-item-name\">").concat(e, "</span>") + "<span class=\"smart-item-upload-button\" title=\"".concat(a, "\" role=\"button\" aria-label=\"").concat(a, "\"></span>") + "<span class=\"smart-item-cancel-button\" title=\"".concat(n, "\" role=\"button\" aria-label=\"").concat(n, "\"></span>") + "<span class=\"smart-item-pause-button\" title=\"".concat(o, "\" role=\"button\" aria-label=\"").concat(o, "\"></span>") + "<smart-progress-bar ".concat(r, "aria-label=\"Upload progress\"></smart-progress-bar>");
    }
  }, {
    key: "_dropZoneHandler",
    value: function _dropZoneHandler(e) {
      var t = this;

      if (e.preventDefault(), e.stopPropagation(), !t.disabled) {
        if ("dragenter" === e.type || "dragleave" === e.type) return void ("dragenter" === e.type ? t.$.dropZone.classList.add("smart-drag-over") : t.$.dropZone.classList.remove("smart-drag-over"));

        if ("drop" === e.type) {
          if (t.$.dropZone.classList.remove("smart-drag-over"), !t.multiple && 0 < t._selectedFiles.length) return;

          if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
            var _i771 = t._filterNewFiles(Array.from(e.dataTransfer.files));

            if (0 === _i771.length) return;
            t.multiple || _i771.splice(1), t._selectedFiles = t._selectedFiles.concat(_i771), t._renderSelectedFiles(_i771);
          }

          t.$.browseButton.disabled = !!(!t.multiple && 0 < t._selectedFiles.length || t.disabled);
        }
      }
    }
  }, {
    key: "_filterNewFiles",
    value: function _filterNewFiles(e) {
      var t = this;
      var a = [];

      for (var _n376 = 0, _i772; _n376 < e.length; _n376++) {
        _i772 = !0;

        for (var _a508 = 0; _a508 < t._selectedFiles.length; _a508++) {
          var _o269 = t._selectedFiles[_a508],
              _r170 = e[_n376];

          if (_r170.name === _o269.name && _r170.size === _o269.size && _r170.type === _o269.type && _r170.lastModified === _o269.lastModified) {
            _i772 = !1;
            break;
          }
        }

        _i772 && a.push(e[_n376]);
      }

      return a;
    }
  }, {
    key: "_getFileItem",
    value: function _getFileItem(e, t) {
      var a = this;
      var n = null;

      if (e && ("string" == typeof e || "number" == typeof e)) {
        if (!a._items || 0 === a._items.length) return null;

        for (var _o270 = 0; _o270 < a._items.length; _o270++) {
          var _i773 = a._items[_o270];
          (t && _i773.index === parseInt(e) || _i773.file.name === e) && (n = _i773);
        }

        return n;
      }
    }
  }, {
    key: "_handleContainers",
    value: function _handleContainers() {
      var e = this,
          t = e._validateDOMElement(e.dropZone),
          i = e._validateDOMElement(e.appendTo);

      t ? t.appendChild(e.$.dropZone) : e.$.fileUploadContainer.insertBefore(e.$.dropZone, e.$.fileUploadContainer.firstChild), i ? i.appendChild(e.$.selectedFiles) : e.$.fileUploadContainer.appendChild(e.$.selectedFiles);
    }
  }, {
    key: "_handleItemTemplate",
    value: function _handleItemTemplate(e, t) {
      var i = this;
      var a = i.itemTemplate;
      if (!("content" in document.createElement("template"))) return void i.error(i.localize("htmlTemplateNotSuported", {
        elementType: i.nodeName.toLowerCase()
      }));
      if (!a) return i._defaultItemTemplate(e, t);
      if ("string" == typeof a && (a = document.getElementById(a)), null === a || !("content" in a)) return void i.error(i.localize("invalidTemplate", {
        elementType: i.nodeName.toLowerCase(),
        property: "template"
      }));
      var n = a.innerHTML,
          o = /{{\w+}}/g;
      return n.replace(o, e);
    }
  }, {
    key: "_renderSelectedFiles",
    value: function _renderSelectedFiles(e) {
      var t = this,
          a = document.createDocumentFragment(),
          n = e || t._selectedFiles;
      e || (t._items = [], t.$.selectedFiles.innerHTML = "");

      for (var _o271 = 0; _o271 < n.length; _o271++) {
        var _e919 = t.directory ? n[_o271].webkitRelativePath : n[_o271].name,
            _i774 = document.createElement("div");

        t._incrementIndex++, _i774.className = "smart-file", _i774.index = t._incrementIndex, _i774.setAttribute("item-id", t._incrementIndex), _i774.innerHTML = t.itemTemplate ? t._handleItemTemplate(_e919, t._incrementIndex) : t._defaultItemTemplate(_e919, t._incrementIndex), _i774.file = n[_o271], _i774.uploading = !1, _i774.xhr = null, _i774.setAttribute("role", "listitem"), _i774.setAttribute("aria-labelledby", t.id + "File" + t._incrementIndex + "Name"), t.rightToLeft && _i774.setAttribute("right-to-left", ""), a.appendChild(_i774), t._items.push(_i774), t.$.fireEvent("fileSelected", {
          filename: n[_o271].name,
          type: n[_o271].type,
          size: n[_o271].size,
          index: _i774.index
        });
      }

      t.$.selectedFiles.appendChild(a), t.$.fileUploadFooter.classList.remove("smart-hidden"), t._handleComponentsByAvailableHeight();
    }
  }, {
    key: "_setInitialValues",
    value: function _setInitialValues() {
      var e = this;
      e.$.browseInput.accept = e.accept, e._selectedFiles = [], e._items = [], e._incrementIndex = 0;
    }
  }, {
    key: "_updateTextValues",
    value: function _updateTextValues() {
      var e = this,
          t = ["browse", "uploadAll", "cancelAll", "pauseAll"];

      for (var _a509 = 0; _a509 < t.length; _a509++) {
        var _i775 = t[_a509];
        e.$[_i775 + "Button"].innerHTML = e.localize(_i775);
      }

      for (var _t790 = 0; _t790 < e._selectedFiles.length; _t790++) {
        var _i776 = e._items[_t790];
        _i776.querySelector(".smart-item-upload-button").title = e.localize("uploadFile"), _i776.querySelector(".smart-item-cancel-button").title = e.localize("cancelFile"), _i776.querySelector(".smart-item-pause-button").title = e.localize("pauseFile");
      }
    }
  }, {
    key: "_validateDOMElement",
    value: function _validateDOMElement(e) {
      if (e) return "string" == typeof e ? document.getElementById(e) : e instanceof HTMLElement ? e : void 0;
    }
  }, {
    key: "_handleComponentsByAvailableHeight",
    value: function _handleComponentsByAvailableHeight() {
      var e = this;
      if (e._calculateAvailableContainerHeight(), !(e._elementsAutoHeight > e.offsetHeight)) "" === e.dropZone && e._elementsAutoHeight < e.offsetHeight && (e.$.container.classList.remove("smart-overflow"), e._containerOverflows = !1);else if (e.$.container.classList.add("smart-overflow"), e._containerOverflows = !0, e._rowHeight) {
        var _t791 = parseInt(e._availableHeight / e._rowHeight);

        for (var _a510 = 0; _a510 < e._items.length; _a510++) {
          var _i777 = e._items[_a510];
          _a510 < _t791 ? _i777.classList.remove("smart-hidden") : _i777.classList.add("smart-hidden");
        }

        e._items.length > _t791 ? (e.$.totalFiles.innerHTML = e.localize("totalFiles") + e._items.length, e.$.totalFiles.classList.remove("smart-hidden")) : e.$.totalFiles.classList.add("smart-hidden");
      }
    }
  }, {
    key: "_calculateAvailableContainerHeight",
    value: function _calculateAvailableContainerHeight() {
      var e = this,
          t = window.getComputedStyle(e.$.fileUploadContainer, null),
          i = parseInt(t.getPropertyValue("margin-top")) + parseInt(t.getPropertyValue("margin-bottom")) + parseInt(t.getPropertyValue("padding-top")) + parseInt(t.getPropertyValue("padding-bottom")),
          a = e.$.container.querySelector(".smart-file"),
          n = e.$.fileUploadHeader.offsetHeight,
          o = e.$.fileUploadFooter.offsetHeight,
          r = e.style.height;
      var l = 0;
      a && (e._rowHeight = a.offsetHeight), e.style.height = "auto", e._containerOverflows && e.$.container.classList.remove("smart-overflow"), e._elementsAutoHeight = e.offsetHeight, e.style.height = r, e._containerOverflows && e.$.container.classList.add("smart-overflow"), e.$.totalFiles.classList.contains("smart-hidden") && (e.$.totalFiles.classList.remove("smart-hidden"), l = e.$.totalFiles.offsetHeight, e.$.totalFiles.classList.add("smart-hidden")), e._availableHeight = e.offsetHeight - (n + o) - i - l;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        accept: {
          value: null,
          type: "string?"
        },
        appendTo: {
          value: null,
          type: "any"
        },
        autoUpload: {
          value: !1,
          type: "boolean"
        },
        directory: {
          value: !1,
          type: "boolean"
        },
        dropZone: {
          value: null,
          type: "any"
        },
        hideFooter: {
          value: !1,
          type: "boolean"
        },
        itemTemplate: {
          value: null,
          type: "any"
        },
        messages: {
          value: {
            en: {
              browse: "Browse",
              uploadFile: "Upload File",
              cancelFile: "Cancel File",
              pauseFile: "Pause File",
              uploadAll: "Upload All",
              cancelAll: "Cancel All",
              pauseAll: "Pause All",
              totalFiles: "Total files: ",
              connectionError: "{{elementType}}: File Upload requires connection to the server.",
              wrongItemIndex: "{{elementType}}: There is no file with such an index in the list of uploaded files.",
              tooLongFileName: "{{elementType}}: File name is too long."
            }
          },
          type: "object",
          extend: !0
        },
        multiple: {
          value: !1,
          type: "boolean"
        },
        name: {
          value: "",
          type: "string"
        },
        responseHandler: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        setHeaders: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        showProgress: {
          value: !1,
          type: "boolean"
        },
        validateFile: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        uploadUrl: {
          value: "",
          type: "string",
          reflectToAttribute: !1
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "browseButton.click": "browse",
        "browseInput.change": "_browseInputChangeHandler",
        "selectedFiles.click": "_selectedFilesClickHandler",
        "uploadAllButton.click": "uploadAll",
        "cancelAllButton.click": "cancelAll",
        "pauseAllButton.click": "pauseAll",
        "dropZone.dragenter": "_dropZoneHandler",
        "dropZone.dragleave": "_dropZoneHandler",
        "dropZone.dragover": "_dropZoneHandler",
        "dropZone.drop": "_dropZoneHandler",
        resize: "_handleComponentsByAvailableHeight"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Button": "smart.button.js",
        "Smart.ProgressBar": "smart.progressbar.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.fileupload.css"];
    }
  }]);

  return _class82;
}(Smart.BaseElement)), Smart("smart-filter-builder",
/*#__PURE__*/
function (_Smart$BaseElement18) {
  "use strict";

  _inherits(_class83, _Smart$BaseElement18);

  function _class83() {
    _classCallCheck(this, _class83);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class83).apply(this, arguments));
  }

  _createClass(_class83, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" title=\"[[hint]]\">\n                    <div id=\"innerContainer\" class =\"smart-inner-container\">\n                            <div id=\"scrollableOuterContainer\" class =\"smart-scrollable-outer-container\">\n                                <smart-scroll-viewer id=\"scrollableContainer\" class =\"smart-scrollable-container\" animation=\"[[animation]]\">\n                                    <div id=\"contentContainer\" class =\"smart-content-container\"></div>\n                                </smart-scroll-viewer>\n                            </div>\n                            <div id=\"editorsContainer\" class =\"smart-editors-container\">\n                                <div id=\"customEditor\" class =\"smart-custom-editor smart-hidden\"></div>\n                            </div>\n                    </div>\n                    <smart-menu id=\"conditionsMenu\" mode=\"dropDown\" class =\"smart-conditions-menu\" theme=\"[[theme]]\" animation=\"[[animation]]\"></smart-menu>\n            </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (_get(_getPrototypeOf(_class83.prototype), "propertyChangedHandler", this).call(this, e, t, i), e) {
        case "animation":
        case "theme":
          ["textBoxEditor", "numericTextBoxEditor", "comboBoxEditor", "dateTimePickerEditor", "checkBoxEditor"].forEach(function (t) {
            return a.$[t] && (a.$[t][e] = i);
          });
          break;

        case "customOperations":
          a._handleCustomOperations(), a._refresh();
          break;

        case "fields":
          a._mapFieldsToMenu(), a._refresh();
          break;

        case "formatStringDate":
        case "formatStringDateTime":
        case "showIcons":
        case "valueFormatFunction":
          a._refresh();

          break;

        case "locale":
        case "messages":
          a._localizeInitialValues(), a._refresh(), a._handleCustomOperations(), a.$.dateTimePickerEditor && (!a.$.dateTimePickerEditor.messages[a.locale] && (a.$.dateTimePickerEditor.messages[a.locale] = {}), a.$.dateTimePickerEditor.messages[a.locale].dateTabLabel = a.localize("dateTabLabel"), a.$.dateTimePickerEditor.messages[a.locale].timeTabLabel = a.localize("timeTabLabel"), "locale" === e ? a.$.dateTimePickerEditor.locale = a.locale : "messages" == e && (a.$.dateTimePickerEditor.$.selectDate.innerHTML = a.$.dateTimePickerEditor.messages[a.locale].dateTabLabel, a.$.dateTimePickerEditor.$.selectTime.innerHTML = a.$.dateTimePickerEditor.messages[a.locale].timeTabLabel));
          break;

        case "maxConditions":
        case "maxConditionsPerGroup":
        case "maxLevel":
        case "value":
          {
            a._totalConditions = 0, a._validateValue(), a._emptyElementsStructure(!0), a._convertValueToFlat(a.value), a._getFieldsFromValue(), a._mapFieldsToMenu(), a._generateHTMLStructureFromFlatValue(), a.$.scrollableContainer.refresh();

            var _e920 = JSON.stringify(a.value);

            a._oldValueAsString !== _e920 && (a._oldValueAsString = _e920, a.$.fireEvent("change", {
              value: JSON.parse(_e920)
            }));
            break;
          }

        case "valuePlaceholder":
          a._updatePlaceholder();

      }
    }
  }, {
    key: "_maxValidator",
    value: function _maxValidator(e, t) {
      return "number" == typeof t ? Math.max(1, t) : t;
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class83.prototype), "ready", this).call(this);

      var e = this;
      e._validateValue(), e._setInitialValues(), e._handleCustomOperations(), e._emptyElementsStructure(!0), e._totalConditions = 0, e._convertValueToFlat(e.value), e._getFieldsFromValue(), e._generateHTMLStructureFromFlatValue(), e.$.conditionsMenu._noAutoFocus = !0, e._oldValueAsString = JSON.stringify(e.value), e.$.scrollableContainer.refresh();
    }
  }, {
    key: "addCondition",
    value: function addCondition(e, t) {
      var i = this;
      i._checkFieldsExistence(), i._addElement("condition", e, t);
    }
  }, {
    key: "addGroup",
    value: function addGroup(e, t) {
      var i = this;

      i._addElement("group", e, t);
    }
  }, {
    key: "removeCondition",
    value: function removeCondition(e) {
      var t = this;
      t._validateNode(e, "removeCondition"), t._deleteElement(e, "condition"), t._refresh();
    }
  }, {
    key: "removeGroup",
    value: function removeGroup(e) {
      var t = this;
      t._validateNode(e, "removeGroup"), t._deleteElement(e, "group"), t._refresh();
    }
  }, {
    key: "toString",
    value: function toString(e) {
      var t = this;
      if (!e) return JSON.stringify(t.value);
      var a = [],
          n = [];

      for (var _n377 = 0; _n377 < t._valueFlat.length; _n377++) {
        var _e921 = t._valueFlat[_n377];
        var _i778 = {};

        if ("condition" === _e921.type) {
          var _a511 = t._getFieldByFieldName(_e921.data[0]),
              _n378 = _a511.dataType,
              _o272 = "[" + (_a511.label || _a511.value) + "]",
              _r171 = t.localize(_e921.data[1]),
              _l119 = -1 === ["boolean", "number"].indexOf(_n378) ? "'" + _e921.data[2] + "'" : _e921.data[2] + "";

          _i778.data = _o272 + " " + _r171 + " " + _l119;
        } else _i778.data = _e921.data;

        _i778.nodeId = _e921.nodeId, _i778.parentId = _e921.parentId, _i778.type = _e921.type, a.push(_i778);
      }

      var _loop32 = function _loop32(_o273) {
        var e = a[_o273];
        var i = {};

        if ("group" === e.type) {
          var _o274 = a.filter(function (t) {
            return t.parentId === e.nodeId && "condition" === t.type;
          });

          if (0 < _o274.length) {
            var _a513 = _o274.map(function (e) {
              return e.data;
            }),
                _r172 = "",
                _l120 = "",
                _s85 = e.data;

            -1 !== ["notand", "notor"].indexOf(_s85) && (_r172 = "Not (", _l120 = ")", _s85 = _s85.substring(3)), i.nodeId = e.nodeId, i.parentId = e.parentId, i.data = e.data, i.structure = _r172 + _a513.join(" " + t.localize(_s85) + " ") + _l120, n.push(i);
          }
        }
      };

      for (var _o273 = 0; _o273 < a.length; _o273++) {
        _loop32(_o273);
      }

      n = n.filter(function (e) {
        return 1 < e.structure.length;
      }), n.sort(function (e, t) {
        return t.nodeId.split(".").length - e.nodeId.split(".").length;
      });

      var _loop33 = function _loop33(_a512) {
        var e = n[_a512],
            i = n.filter(function (t) {
          return t.nodeId === e.parentId;
        })[0];

        if (i && i.structure) {
          var _a514 = i.data;
          -1 === ["notand", "notor"].indexOf(_a514) ? i.structure = i.structure + " " + t.localize(_a514) + " (" + e.structure + ")" : (_a514 = _a514.substring(3), i.structure = i.structure.slice(0, i.structure.length - 1) + " " + t.localize(_a514) + " (" + e.structure + "))");
        }
      };

      for (var _a512 = 0; _a512 < n.length; _a512++) {
        _loop33(_a512);
      }

      return n[n.length - 1].structure;
    }
  }, {
    key: "updateCondition",
    value: function updateCondition(e, t) {
      var i = this,
          a = i._validateNode(e, "updateCondition");

      i._validateUserData(t, !0), a.data = t, i._refresh();
    }
  }, {
    key: "updateGroup",
    value: function updateGroup(e, t) {
      var i = this,
          a = i._validateNode(e, "updateGroup");

      i._validateUserData(t), a.data = t, i._refresh();
    }
  }, {
    key: "_addElement",
    value: function _addElement(e, t, i) {
      t = t || "0";

      var a = this,
          n = a._valueFlat.filter(function (e) {
        return e.nodeId === t && "group" === e.type;
      }),
          o = !!(0 < n.length) && n[0],
          r = a._valueFlat.filter(function (e) {
        return e.parentId === t;
      });

      var l = 0,
          s = "";
      if (o || a.error(a.localize("wrongParentGroupIndex", {
        elementType: a.nodeName.toLowerCase(),
        method: "addGroup/addCondition"
      })), "group" === e) i = i || "or";else {
        if (r.filter(function (e) {
          return "condition" === e.type;
        }).length === a.maxConditionsPerGroup || a._totalConditions === a.maxConditions) return;

        var _e922 = a.fields && 0 < a.fields.length ? a.fields[0].dataField : a._valueFields[0].dataField;

        a._totalConditions++, i = i || [], i[0] = i[0] || _e922, i[1] = i[1] || "=", i[2] = void 0 === typeof i[2] ? null : i[2];
      }

      if (r) {
        var _e923 = r.map(function (e) {
          var t = e.nodeId.split(".");
          return parseInt(t[t.length - 1]);
        });

        _e923 = 0 === _e923.length ? [0] : _e923, l = _e923.reduce(function (e, t) {
          return Math.max(e, t);
        }) + 1;
      }

      t && 0 < t.length && (s = ".");
      var d = t + s + l,
          c = {
        nodeId: d,
        parentId: t,
        type: e,
        data: i,
        htmlNode: null
      };
      a._valueFlat.push(c), a._refresh();
    }
  }, {
    key: "_clearConditionsValue",
    value: function _clearConditionsValue(e, t) {
      var a = this,
          i = (a.shadowRoot || a).querySelector("[node-id=\"" + (e || 0) + "\"]"),
          n = i.querySelector(".smart-value-container");

      for (var _n379 = 0; _n379 < a._valueFlat.length; _n379++) {
        if (a._valueFlat[_n379].nodeId === e) {
          (function () {
            var e = a._valueFlat[_n379],
                i = t ? a.fields.find(function (e) {
              return e.dataField === t;
            }).dataType : a.fields.find(function (t) {
              return t.dataField === e.data[0];
            }).dataType;
            e.data[2] = a._defaultValueByType(i);
          })();
        }
      }

      n.innerHTML = a.valuePlaceholder, n.closest(".smart-filter-value").setAttribute("placeholder", "");
    }
  }, {
    key: "_convertValueToFlat",
    value: function _convertValueToFlat(e, t) {
      var a = this,
          i = /^(and|or|notAnd|notOr)$/i;
      if (!e) return;
      var n = e.filter(function (e) {
        return "string" == typeof e && e.match(i);
      }),
          o = n ? n[0] : null,
          r = e.filter(function (e) {
        return Array.isArray(e) && 3 === e.length && 0 === e.filter(function (e) {
          return "string" == typeof e && e.match(i);
        }).length;
      }),
          l = e.filter(function (e) {
        return !r.includes(e) && e !== o;
      });

      if (n) {
        var _e924 = a._lastProcessedItemInCurrentGroup.parentId ? "." : "",
            _n380 = (a._lastProcessedItemInCurrentGroup.parentId || "") + _e924 + (t || 0);

        if (!a._isMaxLevelExceeded(_n380)) {
          var _e925 = {
            nodeId: _n380,
            parentId: a._lastProcessedItemInCurrentGroup.parentId,
            type: "group",
            data: o,
            htmlNode: null
          };
          a._valueFlat.push(_e925), a._lastProcessedItemInCurrentGroup.position = 0;

          for (var _e926 = 0; _e926 < r.length && !!r[_e926]; _e926++) {
            var _t792 = _n380 + "." + (a._lastProcessedItemInCurrentGroup.position || 0);

            if (a._isMaxLevelExceeded(_t792)) break;
            var _i779 = {
              nodeId: _t792,
              parentId: _n380,
              type: "condition",
              data: r[_e926],
              htmlNode: null
            };
            a._totalConditions++, a._valueFlat.push(_i779), a._lastProcessedItemInCurrentGroup.position++;
          }

          for (var _e927 = 0; _e927 < l.length; _e927++) {
            a._lastProcessedItemInCurrentGroup.parentId = _n380, a._convertValueToFlat(l[_e927], r.length + _e927), a._lastProcessedItemInCurrentGroup.position++;
          }
        }
      }
    }
  }, {
    key: "_isMaxLevelExceeded",
    value: function _isMaxLevelExceeded(e) {
      var t = this,
          a = t._valueFlat;

      if (!(null === t.maxLevel || 1 > a.length)) {
        if (e) return e.split(".").length - 2 >= t.maxLevel;

        for (var _e928 = 0; _e928 < a.length; _e928++) {
          var _i780 = a[_e928];
          if (_i780.nodeId.split(".").length - 2 > t.maxLevel) return !0;
        }
      }
    }
  }, {
    key: "_clickHandler",
    value: function _clickHandler(e) {
      var t = this,
          i = t.shadowRoot || t.isInShadowDOM ? e.composedPath()[0] : e.target,
          a = i ? i.closest(".smart-filter-group-condition") : null,
          n = a ? a.getAttribute("node-id") : null,
          o = i ? i.closest(".smart-filter-group") : null,
          r = o ? o.getAttribute("node-id") : null,
          l = i.closest(".smart-filter-add-btn"),
          s = i.closest(".smart-filter-delete-btn"),
          d = i.closest(".filter-builder-item"),
          c = n || r,
          m = t._getItemById(c);

      var u;

      if (!t.disabled) {
        if ((d || s || l) && (u = d ? d.classList.contains("smart-filter-field-name") ? "fieldButton" : d.classList.contains("smart-filter-operation") ? "operationButton" : d.classList.contains("smart-filter-value") ? "valueButton" : "groupOperationButton" : l ? "addButton" : "deleteButton", t.$.fireEvent("itemClick", {
          id: m.nodeId,
          type: m.type,
          component: u,
          data: m.data
        })), s) {
          var _e930 = i.closest(".smart-filter-group-operator"),
              _a516 = i.closest(".smart-filter-group-condition");

          return void t._clickHandlerDeleteButton(_e930, _a516, o);
        }

        if (l) return t._closeEditor(), t._contextMenuOptions = t._addOptions, void t._handleContextMenu(i);

        if (d) {
          var _e931 = d.classList;
          return void t._clickHandlerFilterButton(_e931, c, i);
        }

        t.$.conditionsMenu.opened && (t.$.fireEvent("menuClosing"), t.$.conditionsMenu.close(), t.$.fireEvent("menuClose"));

        var _e929 = i.closest(".smart-drop-down"),
            _a515 = t._editor && t._editor.contains(i) || _e929 && _e929.ownerElement === t._editor || i.closest(".smart-custom-editor");

        return t._editorIsOpen && t._editor && !_a515 ? t._scrollBarDown ? void delete t._scrollBarDown : void t._closeEditor() : void 0;
      }
    }
  }, {
    key: "_clickHandlerDeleteButton",
    value: function _clickHandlerDeleteButton(e, t, i) {
      var a = this;
      a.$.conditionsMenu.opened && (a.$.fireEvent("menuClosing"), a.$.conditionsMenu.close(), a.$.fireEvent("menuClose")), a._closeEditor(), e ? (a._deleteElement(i, "group"), a._generateValue()) : t && (a._deleteElement(t), a._generateValue()), a.$.scrollableContainer.refresh();
    }
  }, {
    key: "_clickHandlerFilterButton",
    value: function _clickHandlerFilterButton(e, t, i) {
      function a() {
        var e = o.$.conditionsMenu.querySelector(".smart-selected-menu-item");
        e && e.classList.remove("smart-selected-menu-item");
      }

      function n(e, t, i) {
        a(), o._contextMenuOptions = 0 === t.length ? o._defaultFilterOperationDescriptions : t, o._handleContextMenu(e);
        var n = o.$.conditionsMenu.querySelector("smart-menu-item[value=\"" + i + "\"]");
        o.$.conditionsMenu.opened && n && n.classList.add("smart-selected-menu-item");
      }

      var o = this;

      if (!i.closest(".smart-editors-container") && (o._closeEditor(), o._editedItem = o._getItemById(t), e.contains("smart-filter-field-name") || o._editedItem.data && o._editedItem.data.length)) {
        if (e.contains("smart-filter-group-operation")) return void n(i, o._groupOperationDescriptions, o._editedItem.data);
        if (e.contains("smart-filter-add-btn")) n(i, o._groupOperationDescriptions);else {
          if (e.contains("smart-filter-field-name")) return o._fields || o._mapFieldsToMenu(), void n(i, o._fields, o._editedItem.data[0]);

          if (e.contains("smart-filter-operation")) {
            var _e932 = o._getFieldByFieldName(o._editedItem.data[0]);

            if (!_e932) return;

            var _t793 = o._filterOperationDescriptions.slice();

            if (_e932 && _e932.filterOperations) _t793 = o._filterOperationDescriptions.filter(function (t) {
              return -1 < _e932.filterOperations.indexOf(t.value);
            });else {
              var _i781;

              switch (_e932.dataType) {
                case "number":
                  _i781 = ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"];
                  break;

                case "date":
                  _i781 = ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"];
                  break;

                case "dateTime":
                  _i781 = ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"];
                  break;

                case "boolean":
                  _i781 = ["=", "<>", "isblank", "isnotblank"];
                  break;

                case "object":
                  _i781 = ["isblank", "isnotblank"];
                  break;

                case "string":
                  _i781 = ["contains", "notcontains", "startswith", "endswith", "=", "<>", "isblank", "isnotblank"];
                  break;

                default:
                  _i781 = ["contains", "notcontains", "startswith", "endswith", "=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"];
              }

              _t793 = o._filterOperationDescriptions.filter(function (e) {
                return -1 < _i781.indexOf(e.value);
              });
            }
            return o.showIcons && (_t793 = _t793.map(function (e) {
              return e.label = "<div class=\"smart-filter-builder-icon\">" + o.icons[e.value] + "</div><div class=\"smart-filter-builder-menu-item\">" + o.localize(e.value) + "</div>", e;
            })), void n(i, _t793.slice(), o._editedItem.data[1]);
          }

          return void o._openEditor(i);
        }
      }
    }
  }, {
    key: "_closeEditor",
    value: function _closeEditor(e) {
      var t = this;
      var i;

      if (t._editedItem && t._editorIsOpen) {
        if (t._editor === t.$.dateTimePickerEditor) t._editor._inputChangeHandler(), i = t._editor.value, i && (i = i.toDate());else if (t._editor === t.$.checkBoxEditor) i = t._editor.checked;else if (t._editor === t.$.customEditor) i = t._selectedCustomCondition.handleValue(t._editor);else if (t._editor === t.$.numericTextBoxEditor) t._editor._inputBlurHandler(), i = t._editor.value;else {
          var _e933 = t._getFieldByFieldName(t._editedItem.data[0]);

          i = "array" === _e933.dataType ? t._editor.value.split(",") : "object" === _e933.dataType ? JSON.parse(t._editor.value) : t._editor.value;
        }

        var _a517 = t._editedItem,
            _n381 = _a517.htmlNode,
            _o275 = _a517.nodeId,
            _r173 = t._getFieldByFieldName(_a517.data[0]).dataType,
            _l121 = _n381.querySelector(".smart-filter-value"),
            _s86 = _n381.querySelector(".smart-value-container"),
            d = {
          value: i,
          valueType: _r173 || "string",
          editedItem: _a517
        };

        if (t.$.fireEvent("editorClosing", d), t._updateValueInFlatArray(_o275, i, "value", _r173 || "string"), t._generateValue(e), _l121.removeAttribute("edited"), t.$.editorsContainer.removeAttribute("open"), t._editor === t.$.checkBoxEditor) _s86.innerHTML = t._editor.checked ? "true" : "false";else if (t._editor === t.$.customEditor) {
          var _e934 = t._selectedCustomCondition.valueTemplate(t._editor);

          _s86.innerHTML = _e934;
        } else _s86.innerHTML = t._formatValueStringRepresentation(t._editor.value, t._editedItem.data[0]);
        t._editor.classList.add("smart-hidden"), t._editorIsOpen = t._enterIsPressedInEditor = !1, t.$.fireEvent("editorClose", d), t.$.scrollableContainer.refresh();
      }
    }
  }, {
    key: "_defaultValueByType",
    value: function _defaultValueByType(e) {
      var t;

      switch (e) {
        case "number":
          t = 0;
          break;

        case "date":
        case "dateTime":
          {
            t = new Date(), t.setHours(0, 0, 0);
            break;
          }

        case "boolean":
          t = !1;
          break;

        case "object":
          t = null;
          break;

        default:
          t = "";
      }

      return t;
    }
  }, {
    key: "_deleteElement",
    value: function _deleteElement(e, t) {
      function a(e) {
        var t = o._valueFlat.filter(function (t) {
          return e === t.nodeId;
        });

        var i = t ? t[0] : null;
        o._valueFlat.splice(o._valueFlat.indexOf(i), 1), o._totalConditions--;
      }

      function n(e) {
        var t = o._valueFlat.filter(function (t) {
          return e === t.nodeId;
        }),
            i = t ? t[0] : null;

        for (var _t794 = 0; _t794 < o._valueFlat.length; _t794++) {
          var _i782 = o._valueFlat[_t794],
              _r174 = _i782.nodeId;
          _i782.parentId === e && ("group" === _i782.type ? n(_r174) : a(_r174));
        }

        -1 < o._valueFlat.indexOf(i) && o._valueFlat.splice(o._valueFlat.indexOf(i), 1);
      }

      function i(e, t) {
        e.forEach(function (e, a) {
          var n = o._valueFlat.find(function (t) {
            return t.htmlNode === e;
          }),
              r = t + "." + a;

          e.setAttribute("node-id", r), n.parentId = t, n.nodeId = r, e.classList.contains("smart-filter-group") && i(Array.from(e.children[1].children), r);
        });
      }

      var o = this,
          r = e instanceof HTMLElement ? e : o._valueFlat.find(function (t) {
        return t.nodeId === e;
      }).htmlNode,
          l = "string" == typeof e ? e : e.getAttribute("node-id");

      if (l && 1 !== l.length) {
        "group" === t ? n(l) : a(l);

        var _loop34 = function _loop34(_e935) {
          var t = o._valueFlat.filter(function (t) {
            return o._valueFlat[_e935].parentId === t.nodeId;
          });

          0 === t.length && "0" !== o._valueFlat[_e935].nodeId && (o._valueFlat.splice(_e935, 1), o._totalConditions--);
        };

        for (var _e935 = o._valueFlat.length - 1; 0 <= _e935; _e935--) {
          _loop34(_e935);
        }

        o._generateValue(), r.parentElement.removeChild(r), i(Array.from(o.$.contentContainer.firstElementChild.children[1].children), "0");
      }
    }
  }, {
    key: "_documentClickHandler",
    value: function _documentClickHandler(e) {
      var t = this;
      return (t.isInShadowDOM ? e.composedPath()[0] : e.target).closest("smart-filter-builder") ? void t._clickHandler(e) : void (t._editorIsOpen && !t._scrollBarDown && t._closeEditor(), delete t._scrollBarDown);
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;
      (t.shadowRoot || t.isInShadowDOM ? e.composedPath()[0] : e.target).closest("smart-scroll-bar") ? t._scrollBarDown = !0 : delete t._scrollBarDown;
    }
  }, {
    key: "_containerChangeHandler",
    value: function _containerChangeHandler(e) {
      e.stopPropagation();
    }
  }, {
    key: "_emptyElementsStructure",
    value: function _emptyElementsStructure(e) {
      var t = this,
          i = t.$.contentContainer;

      for (; i.firstChild;) {
        i.removeChild(i.firstChild);
      }

      t._valueFlat = e ? [] : t._valueFlat, t._lastProcessedItemInCurrentGroup = {
        parentId: null,
        id: null,
        position: null
      };
    }
  }, {
    key: "_filterGroupRow",
    value: function _filterGroupRow(e) {
      var t = this;
      e = t.localize(e || "or");
      var i = document.createElement("div"),
          a = "<span class =\"smart-filter-delete-btn\"></span>\n                <span class =\"filter-builder-item smart-filter-group-operation\">".concat(e, "</span>\n                <span class =\"smart-filter-add-btn\"></span>");
      return i.className = "smart-filter-group-operator", i.innerHTML = a, i.data = e || "or", i;
    }
  }, {
    key: "_formatValueStringRepresentation",
    value: function _formatValueStringRepresentation(e, t) {
      function i(e) {
        return 0 === e || "number" == typeof e || "string" == typeof e || !0 === e || "" === e || "0" === e || Array.isArray(e) || "object" == typeof e && e.constructor === Date ? new Smart.Utilities.DateTime(e) : e;
      }

      var a = this,
          n = a._getFieldByFieldName(t);

      var o;
      if (!n) return e;
      if ((!e || 0 === e.length) && "boolean" !== n.dataType && "number" === n.dataType && null === e || "string" === n.dataType && (!e || 0 === e.length)) return a.valuePlaceholder;

      switch (n.dataType) {
        case "date":
        case "dateTime":
          e ? (e = i(e), e.calendar.days = a._localizedDays, e.calendar.months = a._localizedMonths, e.calendar.locale = a.locale, Smart.Utilities.DateTime.cache = [], o = e.toString("date" === n.dataType ? a.formatStringDate : a.formatStringDateTime)) : o = a.valuePlaceholder;
          break;

        case "array":
          o = "string" == typeof e ? e.split(",") : e;
          break;

        case "object":
          o = "string" == typeof e ? e : JSON.stringify(e);
          break;

        case "number":
          o = e;
          break;

        case "boolean":
          o = !1 === e ? "false" : "true";
          break;

        default:
          o = e + "";
      }

      return a.valueFormatFunction ? a.valueFormatFunction(o, t, n.dataType || "string") : o;
    }
  }, {
    key: "_generateHTMLStructureFromFlatValue",
    value: function _generateHTMLStructureFromFlatValue() {
      var e = this,
          t = document.createDocumentFragment();

      if (e._valueFlat && 0 !== e._valueFlat.length) {
        var _loop35 = function _loop35(_a518) {
          var i = e._valueFlat[_a518],
              n = !!e.customOperations && e.customOperations.find(function (e) {
            return e.name === i.data[1];
          }),
              o = i.parentId ? (e.shadowRoot || e).querySelector("[node-id=\"" + i.parentId + "\"]").querySelector(".smart-filter-group-condition-container") : e.$.contentContainer;

          if ("group" === i.type) {
            var _n382 = document.createElement("div"),
                _o276 = e._filterGroupRow(i.data),
                _r175 = document.createElement("div");

            _n382.className = "smart-filter-group", _r175.className = "smart-filter-group-condition-container", _n382.appendChild(_o276), _n382.appendChild(_r175), t.appendChild(_n382), _n382.setAttribute("node-id", i.nodeId), e._valueFlat[_a518].htmlNode = _n382, e._isMaxLevelExceeded(i.nodeId + ".0") && _n382.setAttribute("max-level", "");
          } else {
            var _o277 = e._newFilterConditionRow(i.data);

            _o277.setAttribute("node-id", i.nodeId), t.appendChild(_o277), e._valueFlat[_a518].htmlNode = _o277, (-1 !== ["isblank", "isnotblank"].indexOf(i.data[1]) || n && n.hideValue) && _o277.children[3].classList.add("smart-hidden");
          }

          o.appendChild(t);
        };

        for (var _a518 = 0; _a518 < e._valueFlat.length; _a518++) {
          _loop35(_a518);
        }
      }
    }
  }, {
    key: "_generateValue",
    value: function _generateValue() {
      function e(e) {
        for (var _t795 = 0; _t795 < e.length; _t795++) {
          var _i783 = e[_t795];
          var _n383 = {};
          "group" === _i783.type && (_n383.nodeId = _i783.nodeId, _n383.parentId = _i783.parentId, _n383.structure = [_i783.data || "or"], a.push(_n383));
        }

        var _loop36 = function _loop36(_t796) {
          var n = a[_t796],
              o = e.filter(function (e) {
            return e.parentId === n.nodeId && "condition" === e.type;
          });

          for (var _e936 = 0; _e936 < o.length; _e936++) {
            0 == _e936 ? n.structure.unshift(o[_e936].data) : n.structure.push(o[_e936].data);
          }
        };

        for (var _t796 = 0; _t796 < a.length; _t796++) {
          _loop36(_t796);
        }

        a = a.filter(function (e) {
          return 1 < e.structure.length;
        }), a.sort(function (e, t) {
          return t.nodeId.split(".").length - e.nodeId.split(".").length;
        });

        var _loop37 = function _loop37(_t797) {
          var e = a[_t797],
              i = a.filter(function (t) {
            return t.nodeId === e.parentId;
          })[0];
          i && i.structure && i.structure.push(e.structure);
        };

        for (var _t797 = 0; _t797 < a.length; _t797++) {
          _loop37(_t797);
        }
      }

      var t = this;

      var a = [],
          i = t._valueFlat.slice();

      e(i), t.value = 0 < a.length ? 1 < t._valueFlat.length ? a[a.length - 1].structure : a : [t._getItemById("0").data];
      var n = JSON.stringify(t.value);
      t._oldValueAsString !== n && (t._oldValueAsString = n, t.$.fireEvent("change", {
        value: JSON.parse(n)
      }));
    }
  }, {
    key: "_getFieldByFieldName",
    value: function _getFieldByFieldName(e) {
      var t = this,
          i = t.fields ? t.fields.filter(function (t) {
        return t.dataField === e;
      }) : t._valueFields.filter(function (t) {
        return t.dataField === e;
      });
      return i[0] || null;
    }
  }, {
    key: "_getFieldsFromValue",
    value: function _getFieldsFromValue() {
      var e = this,
          t = e._valueFlat,
          a = [],
          i = [];

      for (var _e937 = 0; _e937 < t.length; _e937++) {
        if ("condition" === t[_e937].type) {
          var _n384 = t[_e937].data[0];

          if (-1 === a.indexOf(_n384)) {
            a.push(_n384), i.push({
              label: _n384,
              dataField: _n384,
              dataType: "string",
              format: null
            });
          }
        }
      }

      e._valueFields = i;
    }
  }, {
    key: "_getItemById",
    value: function _getItemById(e, t) {
      var i = this,
          a = i._valueFlat.filter(function (i) {
        return t ? i.parentId === e : i.nodeId === e;
      }),
          n = 0 < a.length ? a[0] : null;

      return n;
    }
  }, {
    key: "_handleContextMenu",
    value: function _handleContextMenu(e) {
      var t = this;

      if (!(t._selectedElement === e && t.$.conditionsMenu.opened)) {
        var _i784 = e.getBoundingClientRect(),
            _a519 = t.getBoundingClientRect(),
            _n385 = _i784.height,
            _o278 = _i784.left + t.$.contentContainer.scrollLeft - _a519.left,
            _r176 = _i784.top + t.$.contentContainer.scrollTop - _a519.top + _n385;

        if (e.closest(".smart-filter-add-btn") && t.restrictedMode) {
          t._checkFieldsExistence();

          var _e938 = t.fields ? t.fields[0] : t._valueFields[0],
              _i785 = _e938.filterOperations && 0 < _e938.filterOperations.length ? _e938.filterOperations[0] : "=";

          return void t._addElement("condition", 0, [_e938.dataField, _i785, t._defaultValueByType(_e938.dataType)]);
        }

        return t._closeEditor(), t.disableContextMenu ? void (t._selectedElement = e) : void (t.$.conditionsMenu.dataSource = t._contextMenuOptions, t.$.conditionsMenu.open(_o278, _r176), t._selectedElement = e, t.$.scrollableContainer.refresh());
      }
    }
  }, {
    key: "_handleCustomOperations",
    value: function _handleCustomOperations() {
      var e = this;
      e._filterOperationDescriptions = e._defaultFilterOperationDescriptions;

      for (var _t798 = 0; _t798 < e.customOperations.length; _t798++) {
        var _i786 = e.customOperations[_t798];

        e._filterOperationDescriptions.push({
          label: _i786.label,
          value: _i786.name,
          custom: !0,
          index: _t798,
          editorTemplate: _i786.editorTemplate,
          valueTemplate: _i786.valueTemplate,
          handleValue: _i786.handleValue
        });
      }
    }
  }, {
    key: "_initializeEditor",
    value: function _initializeEditor(e) {
      var t = this,
          i = "smart-" + Smart.Utilities.Core.toDash(e),
          a = document.createElement(i);
      "numericTextBox" === e ? (a.spinButtons = !0, a.inputFormat = "floatingPoint") : "dateTimePicker" == e && (a.calendarButton = !0, a.dropDownDisplayMode = "auto", a.enableMouseWheelAction = !0, a.locale = t.locale, !a.messages[t.locale] && (a.messages[t.locale] = {}), a.messages[t.locale].dateTabLabel = t.localize("dateTabLabel"), a.messages[t.locale].timeTabLabel = t.localize("timeTabLabel")), a.tabIndex = "1", a.theme = t.theme, a.animation = t.animation, t.$[e + "Editor"] = a, a.$ = Smart.Utilities.Extend(a), a.className = i + "-editor smart-hidden", t.$.editorsContainer.appendChild(a), t["_" + e + "Initialized"] = !0;
    }
  }, {
    key: "_innerContainerKeydownHandler",
    value: function _innerContainerKeydownHandler(e) {
      var t = this;
      ("Escape" === e.key || "Enter" === e.key) && t._editorIsOpen && t._closeEditor();
    }
  }, {
    key: "_inputBlurHandler",
    value: function _inputBlurHandler() {
      var e = this;
      var t;
      if (e._editor === e.$.dateTimePickerEditor) t = e._editor.value, t && (t = t.toDate());else if (e._editor === e.$.checkBoxEditor) t = e._editor.checked;else if (e._editor === e.$.customEditor) t = e._selectedCustomCondition.handleValue(e._editor);else {
        var _i787 = e._getFieldByFieldName(e._editedItem.data[0]);

        t = "array" === _i787.dataType ? e._editor.value.split(",") : "object" === _i787.dataType ? JSON.parse(e._editor.value) : e._editor.value;
      }

      var i = e._editedItem,
          a = i.nodeId,
          n = e._getFieldByFieldName(i.data[0]).dataType;

      e._updateValueInFlatArray(a, t, "value", n || "string"), e._generateValue();
    }
  }, {
    key: "_localizeInitialValues",
    value: function _localizeInitialValues() {
      var e = this,
          t = Smart.Utilities.DateTime.getLocalizedNames(e.locale);
      e._addOptions = [{
        label: e.localize("addCondition"),
        value: "addCondition"
      }, {
        label: e.localize("addGroup"),
        value: "addGroup"
      }], e._groupOperationDescriptions = [{
        label: e.localize("and"),
        value: "and"
      }, {
        label: e.localize("notand"),
        value: "notand"
      }, {
        label: e.localize("or"),
        value: "or"
      }, {
        label: e.localize("notor"),
        value: "notor"
      }], e._defaultFilterOperationDescriptions = e._filterOperationDescriptions = [{
        label: e.localize("="),
        value: "=",
        custom: !1
      }, {
        label: e.localize("<>"),
        value: "<>",
        custom: !1
      }, {
        label: e.localize(">"),
        value: ">",
        custom: !1
      }, {
        label: e.localize(">="),
        value: ">=",
        custom: !1
      }, {
        label: e.localize("<"),
        value: "<",
        custom: !1
      }, {
        label: e.localize("<="),
        value: "<=",
        custom: !1
      }, {
        label: e.localize("startswith"),
        value: "startswith",
        custom: !1
      }, {
        label: e.localize("endswith"),
        value: "endswith",
        custom: !1
      }, {
        label: e.localize("contains"),
        value: "contains",
        custom: !1
      }, {
        label: e.localize("notcontains"),
        value: "notcontains",
        custom: !1
      }, {
        label: e.localize("isblank"),
        value: "isblank",
        custom: !1
      }, {
        label: e.localize("isnotblank"),
        value: "isnotblank",
        custom: !1
      }], e._localizedDays = t.days, e._localizedMonths = t.months;
    }
  }, {
    key: "_mapFieldsToMenu",
    value: function _mapFieldsToMenu() {
      var e = this;
      (e.fields || e._valueFields) && (e._fields = (e.fields || e._valueFields).map(function (e) {
        var t = {
          label: e.label,
          value: e.dataField,
          dataType: e.dataType
        };
        return t;
      }));
    }
  }, {
    key: "_menuItemClickHandler",
    value: function _menuItemClickHandler(e) {
      var t = this,
          a = t._selectedElement.closest(".filter-builder-item"),
          i = e.detail,
          n = i.value,
          o = t.localize(n) || i.label;

      if (a) {
        var _e939 = a.closest(".smart-filter-group-condition"),
            _i788 = a.closest(".smart-filter-group"),
            _r177 = _e939 ? _e939.getAttribute("node-id") : _i788.getAttribute("node-id");

        var _l122 = 2;

        if (a.innerHTML = o, a.value = n, t._editedItem && a.classList.contains("smart-filter-field-name") && t._editedItem.data[0] !== n) {
          var _e940 = a.parentNode.querySelector(".smart-filter-value"),
              _i789 = t.customOperations.map(function (e) {
            if (e.hideValue) return e.name;
          }).filter(function (e) {
            return e;
          }),
              _o279 = _i789.concat(["isblank", "isnotblank"]);

          t._clearConditionsValue(_r177, n), t._setInitialFilterOperation(_r177, n), -1 < _o279.indexOf(n) ? _e940.classList.add("smart-hidden") : _e940.classList.remove("smart-hidden");
        }

        if (a.classList.contains("smart-filter-field-name")) _l122 = 0;else if (a.classList.contains("smart-filter-operation")) {
          var _e941 = a.parentNode.querySelector(".smart-filter-value");

          var _i790;

          if (t.customOperations) {
            var _e942 = t.customOperations.filter(function (e) {
              return e.name === n;
            });

            0 < _e942.length && (_i790 = _e942[0]);
          }

          -1 < ["isblank", "isnotblank"].indexOf(n) || _i790 && _i790.hideValue ? (t._clearConditionsValue(_r177), _e941.classList.add("smart-hidden")) : _e941.classList.remove("smart-hidden"), _l122 = 1;
        } else if (a.classList.contains("smart-filter-group-operation")) {
          for (var _e943 = 0; _e943 < t._valueFlat.length; _e943++) {
            t._valueFlat[_e943].nodeId === _r177 && (t._valueFlat[_e943].data = a.value);
          }

          return t._generateValue(), void t.$.scrollableContainer.refresh();
        }

        for (var _e944 = 0; _e944 < t._valueFlat.length; _e944++) {
          t._valueFlat[_e944].nodeId === _r177 && (t._valueFlat[_e944].data[_l122] = a.value);
        }

        return t._generateValue(), void t.$.scrollableContainer.refresh();
      }

      var r = t._selectedElement.closest(".smart-filter-group"),
          l = r.getAttribute("node-id");

      if (!t._isMaxLevelExceeded(l + ".0")) {
        if ("addCondition" === n && (t.maxConditions && t._totalConditions < t.maxConditions || !t.maxConditions)) {
          t._checkFieldsExistence();

          var _e945 = t.fields ? t.fields[0] : t._valueFields[0],
              _i791 = _e945.filterOperations && 0 < _e945.filterOperations.length ? _e945.filterOperations[0] : "=";

          t._addElement("condition", l, [_e945.dataField, _i791, t._defaultValueByType(_e945.dataType)]);
        } else "addGroup" === n && t._addElement("group", l, "and");

        t.$.scrollableContainer.refresh();
      }
    }
  }, {
    key: "_setInitialFilterOperation",
    value: function _setInitialFilterOperation(e, t) {
      var i = this,
          a = i.fields.find(function (e) {
        return e.dataField === t;
      }),
          n = i._valueFlat.find(function (t) {
        return t.nodeId === e;
      }),
          o = n.htmlNode.getElementsByClassName("smart-filter-operation")[0],
          r = a && a.filterOperations && 0 < a.filterOperations.length ? a.filterOperations[0] : "=";

      var l = i.localize(r);
      l || (l = i.customOperations.find(function (e) {
        return e.name === r;
      }).label), n.data[1] = r, o.innerHTML = l;
    }
  }, {
    key: "_checkFieldsExistence",
    value: function _checkFieldsExistence() {
      var e = this;
      e.fields && 0 !== e.fields.length || e._valueFields && 0 !== e._valueFields.length || e.error(e.localize("missingFields", {
        elementType: e.nodeName.toLowerCase()
      }));
    }
  }, {
    key: "_newFilterConditionRow",
    value: function _newFilterConditionRow(e) {
      e = e || [];

      var t = this,
          i = e[0] ? e[0] : t.fields[0].dataField,
          a = t._formatValueStringRepresentation(e[2], e[0]),
          n = t.fields ? t.fields.filter(function (e) {
        return e.dataField === i;
      }) : t._valueFields.filter(function (e) {
        return e.dataField === i;
      }),
          o = 0 < n.length ? n[0].label : e[0];

      var r = t.localize(e[1]);
      !r && t.customOperations && 0 < t.customOperations.length && (r = t.customOperations.find(function (t) {
        return t.name === e[1];
      }).label);
      var l = document.createElement("div"),
          s = "<span class =\"smart-filter-delete-btn\"></span>\n                <span class =\"filter-builder-item smart-filter-field-name\">".concat(o, "</span>\n                <span class =\"filter-builder-item smart-filter-operation\">").concat(r || "", "</span>\n                <span class =\"filter-builder-item smart-filter-value\"><span class =\"smart-value-container\">").concat(a, "</span></span>");
      return l.className = "smart-filter-group-condition", l.innerHTML = s, l;
    }
  }, {
    key: "_openEditor",
    value: function _openEditor(e) {
      var t = this,
          i = e && e.closest(".smart-filter-group-condition") ? e.closest(".smart-filter-group-condition").getAttribute("node-id") : null,
          a = e.closest(".smart-filter-value"),
          n = t._getItemById(i),
          o = n.data[0] || t.fields[0].dataField || t._valueFields[0].dataField,
          r = t._getFieldByFieldName(o);

      var l;
      if (n ? (l = n.data[2], void 0 === l && (l = "")) : l = "", !r) return;
      t._editorIsOpen && t._closeEditor(), t.$.conditionsMenu.opened && t.$.conditionsMenu.close(), a.setAttribute("edited", ""), t._editedItem = n;

      var s = t.fields || t._valueFields,
          d = s.filter(function (e) {
        return e.dataField === o;
      }),
          c = t._filterOperationDescriptions.filter(function (e) {
        return e.value === n.data[1] && e.custom;
      }),
          m = 0 < d.length ? d[0] : null,
          u = r.lookup && r.lookup.dataSource ? "lookup" : m.dataType;

      0 !== c.length && c[0].editorTemplate ? (t._selectedCustomCondition = c[0], t._openCustomEditor(u, l, r)) : t._openEditorByFieldType(u, l, r), t.$.fireEvent("editorOpening", {
        value: l,
        type: u,
        editedItem: n
      }), setTimeout(function () {
        t._editor.focus(), (t._editor === t.$.numericTextBoxEditor || t._editor === t.$.textBoxEditor) && (t.$.scrollableContainer.scrollLeft = t.$.scrollableContainer.$.scrollViewerContainer.scrollLeft, t.$.scrollableContainer.scrollTop = t.$.scrollableContainer.$.scrollViewerContainer.oldTop, t.$.scrollableContainer.$.scrollViewerContainer.scrollLeft = 0, t.$.scrollableContainer.$.scrollViewerContainer.scrollTop = 0, t._editor.$.input.selectionStart = t._editor.$.input.selectionEnd = t._editor.$.input.value.length), t.$.scrollableContainer.refresh(), t.$.fireEvent("editorOpen", {
          value: l,
          type: u,
          editedItem: n
        });
      }, 0), t._editor.classList.remove("smart-hidden"), t._editorIsOpen = !0, t.$.editorsContainer.setAttribute("open", ""), a.appendChild(t.$.editorsContainer), t.$.scrollableContainer.refresh();
    }
  }, {
    key: "_openEditorByFieldType",
    value: function _openEditorByFieldType(e, t, i) {
      var a = this;
      "lookup" === e ? (a._comboBoxInitialized || a._initializeEditor("comboBox"), a._editor = a.$.comboBoxEditor, a._editor.dataSource = i.lookup.dataSource, a._editor.dropDownAppendTo = a.$.container, a._editor.selectedValues = [t]) : "boolean" === e ? (a._checkBoxInitialized || a._initializeEditor("checkBox"), a._editor = a.$.checkBoxEditor, a._editor.checked = !!t) : "dateTime" === e ? (a._dateTimePickerInitialized || a._initializeEditor("dateTimePicker"), a._editor = a.$.dateTimePickerEditor, a._editor.formatString = a.formatStringDateTime, a._editor.dropDownAppendTo = a.$.container, a._editor.value = t) : "date" === e ? (a._dateTimePickerInitialized || a._initializeEditor("dateTimePicker"), a._editor = a.$.dateTimePickerEditor, a._editor.formatString = a.formatStringDate, a._editor.dropDownAppendTo = a.$.container, a._editor.value = t) : "number" === e ? (a._numericTextBoxInitialized || a._initializeEditor("numericTextBox"), t = t ? t : 0, a._editor = a.$.numericTextBoxEditor, a._editor.value = t) : "array" === e ? (a._textBoxInitialized || a._initializeEditor("textBox"), a._editor = a.$.textBoxEditor, a._editor.value = t.toString()) : "object" === e ? (a._textBoxInitialized || a._initializeEditor("textBox"), t = t ? t : {}, a._editor = a.$.textBoxEditor, a._editor.value = JSON.stringify(t)) : (a._textBoxInitialized || a._initializeEditor("textBox"), a._editor = a.$.textBoxEditor, a._editor.value = t + "");
    }
  }, {
    key: "_openCustomEditor",
    value: function _openCustomEditor(e, t, i) {
      var a = this,
          n = a.customOperations[a._selectedCustomCondition.index].editorTemplate(e, t, i);

      a.$.customEditor.innerHTML = "", n && a.$.customEditor.appendChild(n), a._editor = a.$.customEditor;
    }
  }, {
    key: "_refresh",
    value: function _refresh() {
      var e = this;
      e._generateValue(), e._emptyElementsStructure(), e._generateHTMLStructureFromFlatValue(), e.$.scrollableContainer.refresh();
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      e.$.scrollableContainer.refresh();
    }
  }, {
    key: "_scrollViewerWheelHandler",
    value: function _scrollViewerWheelHandler(e) {
      var t = this;
      "wheel" === e.type && t.$.scrollableContainer.scrollHeight && (e.stopPropagation(), e.preventDefault());
    }
  }, {
    key: "_setInitialValues",
    value: function _setInitialValues() {
      var e = this;
      e._mapFieldsToMenu(), e._localizeInitialValues(), e.$.conditionsMenu.dropDownAppendTo = e.$.container, e.$.conditionsMenu.dataSource = e._groupOperationDescriptions, e._valueFlat = [], e._lastProcessedItemInCurrentGroup = {
        parentId: null,
        id: null,
        position: null
      };
    }
  }, {
    key: "_updatePlaceholder",
    value: function _updatePlaceholder() {
      var e = this;

      for (var _t799 = 0; _t799 < e._valueFlat.length; _t799++) {
        var _i792 = e._valueFlat[_t799];
        "condition" === _i792.type && (null === _i792.data[2] || "" === _i792.data[2]) && (_i792.htmlNode.querySelector(".smart-value-container").innerHTML = e.valuePlaceholder);
      }

      e.$.textBoxEditor && (e.$.textBoxEditor.placeholder = e.valuePlaceholder);
    }
  }, {
    key: "_updateValueInFlatArray",
    value: function _updateValueInFlatArray(e, t, a, i) {
      var n = this;

      if (e && !n.disabled) {
        i = i || "string", a = a || "value", null !== t && ("number" === i ? t = parseFloat(t) : "boolean" === i ? t = !!t : "string" === i ? t += "" : void 0);

        for (var _o280 = 0; _o280 < n._valueFlat.length; _o280++) {
          n._valueFlat[_o280].nodeId === e && ("column" === a ? n._valueFlat[_o280].data[0] = t : "filterCondition" === a ? n._valueFlat[_o280].data[1] = t : "value" === a ? n._valueFlat[_o280].data[2] = t : "groupCondition" === a ? n._valueFlat[_o280].data = t : void 0);
        }
      }
    }
  }, {
    key: "_validateNode",
    value: function _validateNode(e, t) {
      var i = this;
      var a;
      return e instanceof HTMLElement ? a = i._getItemById(e.getAttribute("node-id")) : "string" == typeof e ? a = i._getItemById(e) : i.error(i.localize("wrongElementNode", {
        elementType: i.nodeName.toLowerCase(),
        method: t
      })), a || i.error(i.localize("wrongElementNode", {
        elementType: i.nodeName.toLowerCase(),
        method: t
      })), a;
    }
  }, {
    key: "_validateUserData",
    value: function _validateUserData(e, t) {
      var i = this;
      if (t) (!Array.isArray(e) || 3 > e.length) && i.error(i.localize("invalidDataStructure", {
        elementType: i.nodeName.toLowerCase()
      }));else {
        var _t800 = /^(and|or|notAnd|notOr)$/i;
        "string" == typeof e && e.match(_t800) || i.error(i.localize("invalidDataStructure", {
          elementType: i.nodeName.toLowerCase()
        }));
      }
    }
  }, {
    key: "_validateValue",
    value: function _validateValue() {
      function e(e) {
        return 3 === e.length && "string" == typeof e[0] && "string" == typeof e[1];
      }

      function t(i, l, s) {
        var d = 0;
        i.forEach(function (i) {
          if (!Array.isArray(i)) s.push(i);else if (e(i)) {
            if (null !== a && a === r || null !== n && n === d) return;
            s.push(i), d++, r++;
          } else {
            if (null !== o && o === l + 1) return;
            var _e946 = [];
            s.push(_e946), t(i, l + 1, _e946);
          }
        });
      }

      var i = this,
          a = i.maxConditions,
          n = i.maxConditionsPerGroup,
          o = i.maxLevel;
      var r = 0;

      if (null !== a || null !== n || null !== o) {
        var _e947 = i.value,
            _a520 = [];
        t(_e947, 0, _a520), i.value = _a520;
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        customOperations: {
          value: [],
          type: "array",
          reflectToAttribute: !1
        },
        disableContextMenu: {
          value: !1,
          type: "boolean"
        },
        fields: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        formatStringDate: {
          value: "dd-MMM-yy",
          type: "string"
        },
        formatStringDateTime: {
          value: "dd-MMM-yy HH:mm:ss",
          type: "string"
        },
        hint: {
          value: null,
          type: "string?"
        },
        icons: {
          value: {
            "=": "=",
            "<>": "\u2260",
            ">": ">",
            ">=": "\u2265",
            "<": "<",
            "<=": "\u2264",
            startswith: "a|bc",
            endswith: "ab|c",
            contains: "abc",
            notcontains: "!abc",
            isblank: "\u25CB",
            isnotblank: "\u25CF"
          },
          type: "object",
          reflectToAttribute: !1
        },
        maxConditions: {
          value: null,
          type: "number?",
          validator: "_maxValidator"
        },
        maxConditionsPerGroup: {
          value: null,
          type: "number?",
          validator: "_maxValidator"
        },
        maxLevel: {
          value: null,
          type: "number?",
          validator: "_maxValidator"
        },
        messages: {
          value: {
            en: {
              add: "Add",
              addCondition: "Add Condition",
              addGroup: "Add Group",
              and: "And",
              notand: "Not And",
              or: "Or",
              notor: "Not Or",
              "=": "Equals",
              "<>": "Does not equal",
              ">": "Greater than",
              ">=": "Greater than or equal to",
              "<": "Less than",
              "<=": "Less than or equal to",
              startswith: "Starts with",
              endswith: "Ends with",
              contains: "Contains",
              notcontains: "Does not contain",
              isblank: "Is blank",
              isnotblank: "Is not blank",
              wrongParentGroupIndex: "{{elementType}}: Wrong parent group index in \"{{method}}\" method.",
              missingFields: "{{elementType}}: Fields are required for proper condition's adding. Set \"fields\" source and then conditions will be added as expected.",
              wrongElementNode: "{{elementType}}: Incorect node / node Id in \"{{method}}\" method.",
              invalidDataStructure: "{{elementType}}: Used invalid data structure in updateCondition/updateGroup method.",
              dateTabLabel: "DATE",
              timeTabLabel: "TIME"
            }
          },
          type: "object",
          extend: !0
        },
        restrictedMode: {
          value: !1,
          type: "boolean"
        },
        showIcons: {
          value: !1,
          type: "boolean"
        },
        value: {
          value: ["or"],
          type: "array?",
          reflectToAttribute: !1
        },
        valueFormatFunction: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        valuePlaceholder: {
          value: "&lt;enter a value&gt;",
          type: "string"
        }
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Button": "smart.button.js",
        "Smart.CheckBox": "smart.checkbox.js",
        "Smart.ScrollBar": "smart.scrollbar.js",
        "Smart.ListBox": "smart.listbox.js",
        "Smart.DropDownList": "smart.dropdownlist.js",
        "Smart.ComboBox": "smart.combobox.js",
        "Smart.Calendar": "smart.calendar.js",
        "Smart.TimePicker": "smart.timepicker.js",
        "Smart.Tooltip": "smart.tooltip.js",
        "Smart.Utilities.DateTime": "smart.date.js",
        "Smart.DateTimePicker": "smart.datetimepicker.js",
        "Smart.Menu": "smart.menu.js"
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        down: "_downHandler",
        "document.click": "_documentClickHandler",
        "conditionsMenu.itemClick": "_menuItemClickHandler",
        "container.change": "_containerChangeHandler",
        "scrollableContainer.wheel": "_scrollViewerWheelHandler",
        "scrollableOuterContainer.resize": "_resizeHandler",
        "innerContainer.keydown": "_innerContainerKeydownHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.filterbuilder.css"];
    }
  }]);

  return _class83;
}(Smart.BaseElement)), Smart("smart-query-builder",
/*#__PURE__*/
function (_Smart$BaseElement19) {
  "use strict";

  _inherits(_class84, _Smart$BaseElement19);

  function _class84() {
    _classCallCheck(this, _class84);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class84).apply(this, arguments));
  }

  _createClass(_class84, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <smart-scroll-viewer id=\"scrollableContainer\" class =\"smart-scrollable-container\" animation=\"[[animation]]\" right-to-left=\"[[rightToLeft]]\">\n                        <div id=\"queryLabel\" class=\"smart-query-builder-label smart-unselectable\"></div>\n                        <div id=\"contentContainer\" class =\"smart-content-container\"></div>\n                    </smart-scroll-viewer>\n                    <div id=\"editorsContainer\" class =\"smart-editors-container\">\n                        <div id=\"customEditor\" class =\"smart-custom-editor smart-hidden\"></div>\n                    </div>\n                    <smart-menu id=\"conditionsMenu\" mode=\"dropDown\" class =\"smart-conditions-menu\" theme=\"[[theme]]\" animation=\"[[animation]]\" right-to-left=\"[[rightToLeft]]\"></smart-menu>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class84.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      switch (e) {
        case "animation":
        case "theme":
          ["textBoxEditor", "numericTextBoxEditor", "comboBoxEditor", "dateTimePickerEditor", "checkBoxEditor"].forEach(function (t) {
            return a.$[t] && (a.$[t][e] = i);
          });
          break;

        case "formatStringDate":
        case "formatStringDateTime":
        case "valueFormatFunction":
          a._refresh();

          break;

        case "operatorPlaceholder":
          Array.from((a.shadowRoot || a).querySelectorAll(".smart-filter-operation[placeholder]")).forEach(function (e) {
            return e.firstElementChild.innerHTML = i;
          });
          break;

        case "propertyPlaceholder":
          Array.from((a.shadowRoot || a).querySelectorAll(".smart-filter-field-name[placeholder]")).forEach(function (e) {
            return e.firstElementChild.innerHTML = i;
          });
          break;

        case "showIcons":
          a._closeEditor(), i ? a._filterOperationDescriptions.map(function (e) {
            return e.icon = a.icons[e.value];
          }) : a._filterOperationDescriptions.map(function (e) {
            return delete e.icon;
          });
          break;

        case "customOperations":
        case "fields":
        case "value":
          {
            var _t801 = JSON.stringify(a._validValue);

            "customOperations" === e ? a._handleCustomOperations() : "" == e && a._mapFieldsToMenu(), a._applyValue(), a._oldValueAsString !== _t801 && (a._oldValueAsString = _t801, a.$.fireEvent("change", {
              value: JSON.parse(_t801),
              linq: a._parseQueryToLinq(a._validValue)
            }));
            break;
          }

        case "valuePlaceholder":
          Array.from((a.shadowRoot || a).querySelectorAll(".smart-filter-value[placeholder]")).forEach(function (e) {
            return e.firstElementChild.innerHTML = i;
          });
          break;

        case "locale":
        case "messages":
          a._localizeInitialValues(), a._refresh(), a._handleCustomOperations(), a.$.dateTimePickerEditor && (!a.$.dateTimePickerEditor.messages[a.locale] && (a.$.dateTimePickerEditor.messages[a.locale] = {}), a.$.dateTimePickerEditor.messages[a.locale].dateTabLabel = a.localize("dateTabLabel"), a.$.dateTimePickerEditor.messages[a.locale].timeTabLabel = a.localize("timeTabLabel"), "locale" === e ? a.$.dateTimePickerEditor.locale = a.locale : "messages" == e && (a.$.dateTimePickerEditor.$.selectDate.innerHTML = a.$.dateTimePickerEditor.messages[a.locale].dateTabLabel, a.$.dateTimePickerEditor.$.selectTime.innerHTML = a.$.dateTimePickerEditor.messages[a.locale].timeTabLabel));
          break;

        case "icons":
          a._closeEditor();

      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class84.prototype), "ready", this).call(this);

      var e = this;
      -1 !== navigator.platform.toLowerCase().lastIndexOf("mac") && e.$.contentContainer.classList.add("mac"), e._setInitialValues(), e._handleCustomOperations(), e._applyValue(), Object.defineProperty(e, "value", {
        get: function get() {
          return e.context === e ? e.properties.value.value : e._validValue;
        },
        set: function set(t) {
          e.updateProperty(e, e._properties.value, t);
        }
      });
    }
  }, {
    key: "getLinq",
    value: function getLinq() {
      var e = this;
      return e._validValue ? e._parseQueryToLinq(e._validValue) : void 0;
    }
  }, {
    key: "_setInitialValues",
    value: function _setInitialValues() {
      var e = this;
      e._autoScrollCoefficient = Smart.Utilities.Core.Browser.Firefox ? 4 : Smart.Utilities.Core.Browser.Edge ? 8 : 2, e._isMobile = Smart.Utilities.Core.isMobile, e._manuallyAddedFields = [], e._localizeInitialValues(), e.$.conditionsMenu.dropDownAppendTo = e.$.container, e.$.conditionsMenu.dataSource = e._groupOperationDescriptions, e._valueFlat = [], e._lastProcessedItemInCurrentGroup = {
        parentId: null,
        id: null,
        position: null
      };
    }
  }, {
    key: "_applyValue",
    value: function _applyValue() {
      var e = this;
      e._emptyElementsStructure(!0), e._validateValue(), e._convertValueToFlat(e.value), e._getFieldsFromValue(), e._mapFieldsToMenu(), e._validateValueByType(), e._generateHTMLStructureFromFlatValue(!0), e._restrictNesting(), e._validValue = e._getValidValue(), e._oldValueAsString = JSON.stringify(e._validValue);
    }
  }, {
    key: "_validateValueByType",
    value: function _validateValueByType() {
      var e = this;

      if (e._valueFlat && e._valueFlat.length) {
        var _t802 = e._valueFlat;

        for (var _a521 = 0; _a521 < _t802.length; _a521++) {
          var _i793 = _t802[_a521];
          if ("condition" !== _i793.type) continue;
          var _n386 = _i793.data[0];
          _n386 && !(3 > _i793.data.length) && (_i793.data[2] = e._validateStoredValue(_i793.data[2], _n386));
        }

        e._generateValue(!0);
      }
    }
  }, {
    key: "_setRequiredFields",
    value: function _setRequiredFields() {
      var e = this;

      if (e.requiredFields && e.requiredFields.length) {
        var _t803 = e.value;
        var _i794 = [];

        var _loop38 = function _loop38(_a522) {
          var n = e.requiredFields[_a522],
              o = e.fields.find(function (e) {
            return e.dataField === n;
          });

          if (o) {
            var _e948 = [];
            if (_t803) for (var _a523 = 0; _a523 < _t803.length;) {
              var _i795 = _t803[_a523];
              if (Array.isArray(_i795)) for (var _t804 = 0, _a524; _t804 < _i795.length;) {
                if (_a524 = _i795[_t804], _a524 && _a524[0] === o.dataField) {
                  _e948.push(_a524), _i795.splice(0 < _t804 ? _t804 - 1 : _t804, 2);
                  continue;
                }

                _t804++;
              }

              if (!_i795.length) {
                _t803.splice(_a523, 2);

                continue;
              }

              _a523++;
            }

            for (var _t805 = 0; _t805 < _e948.length; _t805++) {
              _i794.push(_e948[_t805]), _i794.push("and");
            }
          }
        };

        for (var _a522 = 0; _a522 < e.requiredFields.length; _a522++) {
          _loop38(_a522);
        }

        "string" == typeof _i794[_i794.length - 1] && _i794.pop(), e.value.unshift(_i794, "and");
      }
    }
  }, {
    key: "_contentContainerChangeHandler",
    value: function _contentContainerChangeHandler(e) {
      var t = this;

      if (e.stopPropagation(), "immediately" === t.applyMode && t._editorIsOpen && t._editor) {
        var _e949 = t._editor.closest(".filter-builder-item");

        _e949.classList.contains("smart-filter-value") || t._closeEditor();
      }
    }
  }, {
    key: "_mapFieldsToMenu",
    value: function _mapFieldsToMenu() {
      var e = this;
      (e.fields || e._valueFields) && (e._fields = (e.fields || e._valueFields).concat(e._manuallyAddedFields).map(function (e) {
        return {
          label: e.label,
          value: e.dataField,
          dataType: e.dataType,
          filterOperations: e.filterOperations,
          lookup: e.lookup
        };
      }));
    }
  }, {
    key: "_localizeInitialValues",
    value: function _localizeInitialValues() {
      var e = this;
      e.$.queryLabel.innerHTML = e.localize("queryLabel"), e._addOptions = [{
        label: e.localize("addCondition"),
        value: "addCondition"
      }, {
        label: e.localize("addGroup"),
        value: "addGroup"
      }], e._groupOperationDescriptions = [{
        label: e.localize("and"),
        value: "and"
      }, {
        label: e.localize("or"),
        value: "or"
      }], e._defaultFilterOperationDescriptions = e._filterOperationDescriptions = [{
        label: e.localize("="),
        value: "=",
        custom: !1
      }, {
        label: e.localize("<>"),
        value: "<>",
        custom: !1
      }, {
        label: e.localize(">"),
        value: ">",
        custom: !1
      }, {
        label: e.localize(">="),
        value: ">=",
        custom: !1
      }, {
        label: e.localize("<"),
        value: "<",
        custom: !1
      }, {
        label: e.localize("<="),
        value: "<=",
        custom: !1
      }, {
        label: e.localize("startswith"),
        value: "startswith",
        custom: !1
      }, {
        label: e.localize("endswith"),
        value: "endswith",
        custom: !1
      }, {
        label: e.localize("contains"),
        value: "contains",
        custom: !1
      }, {
        label: e.localize("notcontains"),
        value: "notcontains",
        custom: !1
      }, {
        label: e.localize("isblank"),
        value: "isblank",
        custom: !1
      }, {
        label: e.localize("isnotblank"),
        value: "isnotblank",
        custom: !1
      }];
      var t = Smart.Utilities.DateTime.getLocalizedNames(e.locale);
      e._localizedDays = t.days, e._localizedMonths = t.months;
    }
  }, {
    key: "_handleCustomOperations",
    value: function _handleCustomOperations() {
      var e = this;
      e._filterOperationDescriptions = e._defaultFilterOperationDescriptions.slice(0);

      var _loop39 = function _loop39(_t806) {
        var i = e.customOperations[_t806],
            a = e._filterOperationDescriptions.findIndex(function (e) {
          return e.value === i.name;
        }),
            n = {
          label: i.label,
          value: i.name,
          custom: !0,
          index: _t806,
          editorTemplate: i.editorTemplate,
          valueTemplate: i.valueTemplate,
          handleValue: i.handleValue,
          hideValue: i.hideValue
        };

        if (-1 < a) {
          e._filterOperationDescriptions[a] = n;
          return "continue";
        }

        e._filterOperationDescriptions.push(n);
      };

      for (var _t806 = 0; _t806 < e.customOperations.length; _t806++) {
        var _ret12 = _loop39(_t806);

        if (_ret12 === "continue") continue;
      }
    }
  }, {
    key: "_innerContainerKeydownHandler",
    value: function _innerContainerKeydownHandler(e) {
      var t = this;
      t._editorIsOpen && ("Escape" === e.key || "Enter" === e.key) && t._closeEditor();
    }
  }, {
    key: "_documentDownHandler",
    value: function _documentDownHandler(e) {
      var t = this,
          i = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;

      if (!(i.shadowParent && i.shadowParent.closest(".smart-input-drop-down-menu") || i.closest(".smart-input-drop-down-menu") || t.$.conditionsMenu.contains(i))) {
        var _a525 = i.closest(".smart-drop-down");

        return i.getRootNode().host === t || i.closest("smart-query-builder") === t || _a525 && t.contains(_a525.ownerElement) ? void t._clickHandler(e.originalEvent) : void (t._editorIsOpen && !t._scrollBarDown && t._closeEditor(), delete t._scrollBarDown);
      }
    }
  }, {
    key: "_emptyElementsStructure",
    value: function _emptyElementsStructure(e) {
      var t = this,
          i = t.$.contentContainer;

      for (; i.firstChild;) {
        i.removeChild(i.firstChild);
      }

      t._valueFlat = e ? [] : t._valueFlat, t._lastProcessedItemInCurrentGroup = {
        parentId: null,
        id: null,
        position: null
      };
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      this.$.scrollableContainer.refresh();
    }
  }, {
    key: "_getTotalConditions",
    value: function _getTotalConditions() {
      return this.getElementsByClassName("smart-filter-group-condition").length;
    }
  }, {
    key: "_getQueryFromExpression",
    value: function _getQueryFromExpression(e) {
      var t = this;
      var i = [];

      var a = function a(e) {
        var a = t.customOperations.filter(function (e) {
          return e.expressionTemplate;
        });

        for (var _t807 = 0; _t807 < a.length; _t807++) {
          var _n387 = a[_t807],
              _o281 = new RegExp(_n387.expressionTemplate.replace(/\(/gm, "\\(").replace(/\)/gm, "\\)").replace(/\[/gm, "\\[").replace(/\]/gm, "\\]").replace(/"{\d+}"/gm, "\\W*\"([^\"]*)[^a-zA-Z0-9-\\s\\)]+").replace(/{\d+}/gm, "([@|$]*\\w+(?!\\s)*)\\s{0}").replace(/ /gm, "\\s"), "gm");

          if (_o281.test(e)) {
            var _ret13 = function () {
              _o281.lastIndex = 0;

              var t = _o281.exec(e),
                  a = void 0,
                  r = void 0;

              if (t = t.filter(function (e, i) {
                return t.indexOf(e) === i;
              }), _n387.expressionReaderCallback) {
                var _e950 = _n387.expressionReaderCallback(t[0], t.slice(1));

                _e950 && (a = _e950.fieldName, r = _e950.value);
              }

              return {
                v: (void 0 === a && (a = t[1] || ""), void 0 === r && (r = t[2] || ""), i.push({
                  expr: t[0],
                  query: [a, _n387.name, r]
                }), t[0])
              };
            }();

            if (typeof _ret13 === "object") return _ret13.v;
          }
        }
      };

      if (e) {
        for (; e.length;) {
          e && (e = e.trim(), "(" === e[0] && ")" === e[e.length - 1] && (e = e.trim().replace(/^\(|\)$/gm, "")), e = e.replace(/^&{2}|^\|{2}|&{2}$|\|{2}$/gm, "").trim());

          var _t808 = a(e);

          if (!_t808) break;
          e = e.replace(_t808, "").trim();
        }

        return t._constructValueFromQueries(arguments[0], i);
      }
    }
  }, {
    key: "_constructValueFromQueries",
    value: function _constructValueFromQueries(e, t) {
      var a = [];
      t.sort(function (t, i) {
        return e.indexOf(t.expr) - e.indexOf(i.expr);
      });

      for (var _n388 = 0, _i796; _n388 < t.length; _n388++) {
        if (_i796 = t[_n388 - 1], _i796) {
          var _o282 = e.substring(e.indexOf(_i796.expr) + _i796.expr.length, e.indexOf(t[_n388].expr)).trim();

          a.push("||" === _o282 ? "or" : "and");
        }

        t[_n388].outher ? t[_n388].query.forEach(function (e) {
          return a.push(Array.isArray(e) ? [e] : e);
        }) : a.push(t[_n388].query);
      }

      return a;
    }
  }, {
    key: "_parseLinqToValue",
    value: function _parseLinqToValue() {
      var e = this,
          t = e.value;
      var a = 0,
          n = [],
          o;

      for (var _e951 = 0; _e951 < t.length; _e951++) {
        if ("(" === t[_e951]) a++, void 0 == o && (o = _e951);else if (")" === t[_e951] && 0 < a && (a--, 0 == a)) {
          var _i797 = t.substring(o, _e951 + 1).trim();

          _i797.length && (_i797.includes("&&") || _i797.includes("||")) && n.push({
            expr: _i797
          }), o = void 0;
        }
      }

      var r = [],
          i;
      if (n.length) for (var _a526 = 0; _a526 < n.length; _a526++) {
        var _o283 = void 0;

        n[_a526].query = e._getQueryFromExpression(n[_a526].expr), _o283 = i ? t.substring(t.indexOf(i) + i.length, t.indexOf(n[_a526].expr)).trim() : t.substring(0, t.indexOf(n[_a526].expr)).trim(), _o283 && r.push(_o283), i = n[_a526].expr;
      }
      i ? r.push(t.substring(t.indexOf(i) + i.length).trim()) : r.push(t.trim());

      for (var _t809 = 0; _t809 < r.length; _t809++) {
        var _i798 = r[_t809].replace(/^&{2}|^\|{2}|&{2}$|\|{2}$/gm, "").trim();

        _i798.length && n.push({
          expr: _i798,
          query: e._getQueryFromExpression(_i798),
          outher: !0
        });
      }

      e.set("value", e._constructValueFromQueries(t, n));
    }
  }, {
    key: "_getExpressionFromQuery",
    value: function _getExpressionFromQuery(e) {
      var t = this,
          i = e[0],
          a = e[1];
      var n = e[2];
      var o = t.customOperations.find(function (e) {
        return e.name === a;
      });
      return o && o.expressionTemplate ? ("string" == typeof n && n.includes("\"") && o.expressionTemplate.includes("\"") && (n = JSON.stringify(n).slice(1, -1)), o.expressionBuilderCallback ? o.expressionBuilderCallback(i, a, n) : o.expressionTemplate.replace("{0}", i).replace("{1}", n)) : "";
    }
  }, {
    key: "_parseQueryToLinq",
    value: function _parseQueryToLinq(e) {
      var t = this,
          a = {
        and: "&&",
        or: "||"
      };
      var n = "";

      for (var _o284 = 0; _o284 < e.length; _o284++) {
        var _i799 = e[_o284];
        if (!Array.isArray(_i799)) n && (n += " " + a[_i799] + " ");else if (-1 < _i799.indexOf("and") || -1 < _i799.indexOf("or") || 1 === _i799.length && Array.isArray(_i799[0])) {
          var _e952 = t._parseQueryToLinq(_i799);

          _e952 ? n += 1 < _i799.length ? "(" + _e952 + ")" : _e952 : /\s(&|\|){2}\s$/gm.test(n) && (n = n.replace(/\s(&|\|){2}\s$/gm, ""));
        } else n += t._getExpressionFromQuery(_i799) || "";
      }

      return n;
    }
  }, {
    key: "_validateValue",
    value: function _validateValue() {
      var e = this;
      "string" == typeof e.value && e._parseLinqToValue();
      var t = e.value;
      if (!Array.isArray(t) || "" === JSON.stringify(t).replace(/[\[\]]/g, "")) return void (e.value = [[[]]]);

      for (3 === t.length && "string" == typeof t[0] && (e.value = [[t]]), Array.isArray(t[0]) && 3 === t[0].length && "string" == typeof t[0][0] && (e.value = [t]); "string" == typeof t[0];) {
        t.shift();
      }

      for (; "string" == typeof t[t.length - 1];) {
        t.pop();
      }

      e.value.forEach(function (e) {
        Array.isArray(e) && 0 === e.length && e.push([]);
      });
    }
  }, {
    key: "_convertValueToFlat",
    value: function _convertValueToFlat(e) {
      function t(e, l) {
        var s;

        for (var d = 0; d < e.length; d++) {
          var _i800 = e[d],
              c = "string" == typeof _i800 && (-1 < n.indexOf(_i800) || a.customOperators[_i800]);

          var m = {
            htmlNode: null
          };

          if (c) {
            s = (a.customOperators[_i800] || _i800).trim();
            continue;
          }

          if (s = s || "and", Array.isArray(_i800)) {
            var _e953 = a._valueFlat.filter(function (e) {
              return e.parentId + "" == l + "";
            }).length;

            if (!_i800.find(function (e) {
              return Array.isArray(e);
            })) {
              if (a.maxConditions && o >= a.maxConditions || a.maxConditionsPerGroup && _e953 >= a.maxConditionsPerGroup) continue;
              0 != d && (a._valueFlat.push({
                nodeId: l + "." + _e953,
                type: "operator",
                data: s,
                parentId: l + ""
              }), s = "", _e953++), m.nodeId = l + "." + _e953, m.parentId = l + "", m.type = "condition", m.data = _i800, o++, a._valueFlat.push(m);
            } else m.nodeId = (r += 1) + "", m.type = "group", m.data = s, a._valueFlat.push(m), t(_i800, m.nodeId), s = "";
          }
        }
      }

      var a = this,
          n = ["and", "or", "notAnd", "notOr"];
      if (!e) return;
      var o = 0,
          r = 0;
      a._valueFlat = [], t(e, 0), delete a._totalGroups;
    }
  }, {
    key: "_getFieldsFromValue",
    value: function _getFieldsFromValue() {
      function e(e) {
        return "boolean" == typeof e ? "boolean" : e instanceof Date ? 0 < e.getHours() || 0 < e.getMinutes() || 0 < e.getSeconds() ? "dateTime" : "date" : isNaN(e) ? "string" : "number";
      }

      var t = this,
          a = t._valueFlat,
          i = [],
          n = [];

      for (var _t810 = 0; _t810 < a.length; _t810++) {
        var _o285 = a[_t810];

        if ("condition" === _o285.type) {
          var _t811 = _o285.data[0];

          if (_t811 && -1 === i.indexOf(_t811)) {
            var _a527 = {
              label: _t811,
              dataField: _t811,
              dataType: e(_o285.data[2]),
              format: null
            };
            i.push(_t811), n.push(_a527);
          }
        }
      }

      t._valueFields = n;
    }
  }, {
    key: "_addElement",
    value: function _addElement(e, t, i, a) {
      var n = this,
          o = n._valueFlat.filter(function (e) {
        return e.parentId === t;
      });

      var r = 0,
          l = "";

      if (i = i || ("group" === e ? "or" : []), o.length) {
        var _e954 = o.map(function (e) {
          var t = e.nodeId.split(".");
          return parseInt(t[t.length - 1]);
        });

        _e954 = 0 === _e954.length ? [0] : _e954, r = _e954.reduce(function (e, t) {
          return Math.max(e, t);
        }) + 1;
      }

      t && 0 < t.length && (l = ".");
      var s = (t || "") + l + ("group" === e ? n._valueFlat.filter(function (e) {
        return "group" === e.type;
      }).length + 1 : r),
          d = o[0];
      if (o.length) for (var _e955 = 0; _e955 < o.length; _e955++) {
        var _t812 = o[_e955],
            _i801 = _t812.nodeId.split(".").pop();

        parseInt(_i801) > parseInt(d.nodeId.split(".").pop()) && (d = _t812);
      } else d = n._valueFlat.find(function (e) {
        return e.nodeId === t;
      });
      var c = d ? n._valueFlat.indexOf(d) + 1 : n._valueFlat.length;
      "condition" === e && 0 < o.length && (n._valueFlat.splice(c, 0, {
        nodeId: s,
        parentId: t,
        type: "operator",
        data: ["and"],
        htmlNode: null
      }), s = (t || "") + l + (r + 1), c++);
      var m = {
        nodeId: s,
        parentId: t,
        type: e,
        data: i,
        htmlNode: null
      };
      n._valueFlat.splice(c, 0, m), "group" === e && n._addElement("condition", s, [], !0), a || n._refresh();
    }
  }, {
    key: "_deleteElement",
    value: function _deleteElement(e, t) {
      function i(e) {
        var t = o._valueFlat[e];
        if (t && "operator" === t.type) return o._valueFlat.splice(e, 1), t.htmlNode.parentElement.removeChild(t.htmlNode), !0;
      }

      function a(e) {
        var t = 0,
            a = e.split("."),
            n;
        a.pop(), a = a.join(".");

        for (var _r178 = 0; _r178 < o._valueFlat.length; _r178++) {
          var _i802 = o._valueFlat[_r178];

          if ("condition" === _i802.type) {
            if (_i802.nodeId === e) {
              n = _i802;
              break;
            }

            _i802.parentId === a && t++;
          }
        }

        var r = o._valueFlat.indexOf(n);

        o._valueFlat.splice(r, 1), n.htmlNode.parentElement.removeChild(n.htmlNode);
        var l = i(r - 1);
        t || i(r - (l ? 1 : 0));

        var s = o._valueFlat.filter(function (e) {
          return e.nodeId === a;
        })[0].htmlNode;

        0 < s.children[1].childElementCount && s.children[2].hasAttribute("limit-selection") && !s.children[1].lastElementChild.hasAttribute("limit-selection") && s.children[2].removeAttribute("limit-selection");
      }

      function n(e) {
        var t = o._valueFlat.filter(function (t) {
          return e === t.nodeId && "group" === t.type;
        })[0];

        for (var _t813 = 0; _t813 < o._valueFlat.length; _t813++) {
          var _i803 = o._valueFlat[_t813],
              _r179 = _i803.nodeId;
          _i803.parentId === e && ("group" === _i803.type ? n(_r179) : a(_r179));
        }

        -1 < o._valueFlat.indexOf(t) && o._valueFlat.splice(o._valueFlat.indexOf(t), 1), t.htmlNode.parentElement.removeChild(t.htmlNode);
      }

      var o = this,
          r = "string" == typeof e ? e : e.getAttribute("node-id");

      if (r && 1 !== r.length && ("group" === t ? n(r) : a(r), !t || "condition" === t)) {
        var _e956 = r.split(".");

        if (_e956.pop(), _e956 = _e956.join("."), !o._valueFlat.filter(function (t) {
          return t.parentId === _e956;
        }).length && (1 < o._valueFlat.filter(function (e) {
          return "group" === e.type;
        }).length && n(_e956), "0" === _e956)) {
          var _e957 = o._valueFlat.find(function (e) {
            return "group" === e.type;
          }),
              _t814 = _e957.nodeId;

          _e957.nodeId = "0", _e957.htmlNode.setAttribute("node-id", "0");

          var _i804 = o._valueFlat.filter(function (e) {
            return e.parentId === _t814;
          });

          for (var _e958 = 0; _e958 < _i804.length; _e958++) {
            var _t815 = _i804[_e958];
            _t815.parentId = "0", _t815.nodeId = "0." + _e958, _t815.htmlNode.setAttribute("node-id", _t815.nodeId);
          }
        }

        o._generateValue();
      }
    }
  }, {
    key: "_generateHTMLStructureFromFlatValue",
    value: function _generateHTMLStructureFromFlatValue(e) {
      var t = this,
          a = document.createDocumentFragment();

      if (t._valueFlat && 0 !== t._valueFlat.length) {
        var _loop40 = function _loop40(_e959) {
          var i = t._valueFlat[_e959],
              n = !!t.customOperations && t.customOperations.find(function (e) {
            return e.name === i.data[1];
          }),
              o = i.parentId ? (t.shadowRoot || t).querySelector("[node-id=\"" + i.parentId + "\"]").querySelector(".smart-filter-group-condition-container") : t.$.contentContainer;

          if ("group" === i.type) {
            var _n389 = document.createElement("div"),
                _o286 = t.localize(i.data) || "";

            _n389.className = "smart-filter-group", _n389.innerHTML = "<div class=\"smart-filter-group-operator\">" + _o286 + "</div><div class=\"smart-filter-group-condition-container\"></div><div class=\"smart-filter-add-condition-btn\"><div>" + t.localize("add") + "</div></div><div class=\"smart-filter-add-btn\"></div>", _n389.firstElementChild.data = _o286, a.appendChild(_n389), _n389.setAttribute("node-id", i.nodeId), t._valueFlat[_e959].htmlNode = _n389;
          } else if ("condition" === i.type) {
            var _o287 = t._newFilterConditionRow(i.data);

            if (_o287.setAttribute("node-id", i.nodeId), a.appendChild(_o287), t._valueFlat[_e959].htmlNode = _o287, void 0 !== i.data[0] && void 0 === i.data[1]) {
              var _e960 = t._getFilterOperations(t._fields.find(function (e) {
                return e.value === i.data[0];
              }));

              t._handleOnlyOperation(_e960, i.data, _o287);
            } else (-1 !== ["isblank", "isnotblank"].indexOf(i.data[1]) || n && n.hideValue) && (i.data.splice(2, 1), _o287.children[2].classList.add("smart-visibility-hidden"));
          } else {
            var _n390 = document.createElement("div");

            _n390.className = "smart-filter-nested-operator", _n390.setAttribute("node-id", i.nodeId), _n390.innerHTML = t.localize(i.data), a.appendChild(_n390), t._valueFlat[_e959].htmlNode = _n390;
          }

          o.appendChild(a);
        };

        for (var _e959 = 0; _e959 < t._valueFlat.length; _e959++) {
          _loop40(_e959);
        }

        e && t._validateValueAdvanced(), t.$.scrollableContainer.refresh();
      }
    }
  }, {
    key: "_validateValueAdvanced",
    value: function _validateValueAdvanced() {
      var e = this,
          t = e.value;
      var i = !1,
          a = !1,
          n = 0;

      for (var _e961 = 0; _e961 < t.length; _e961++) {
        var _o288 = t[_e961];
        if ("string" != typeof _o288) for (var _e962 = _o288.length - 1, _t816; 0 <= _e962; _e962--) {
          if (_t816 = _o288[_e962], Array.isArray(_t816) && 0 === _t816.length && _e962 != _o288.length - 1) _o288.splice(_e962, 1), 0 == _e962 && _o288.splice(0, 1), i = !0;else if ("string" == typeof _t816) {
            _t816 = _t816.toLowerCase(), n++, (1 < n || "and" !== _t816 && "or" !== _t816) && (a = !0);
            continue;
          }
          n = 0;
        }
      }

      i && (e._emptyElementsStructure(!0), e._convertValueToFlat(e.value), e._generateHTMLStructureFromFlatValue()), a && e._generateValue(!0);
    }
  }, {
    key: "_restrictNesting",
    value: function _restrictNesting() {
      var e = this,
          t = Array.from(e.getElementsByClassName("smart-filter-add-condition-btn"));
      t.forEach(function (e) {
        var t = e.previousElementSibling.lastElementChild;
        t && t.hasAttribute("limit-selection") && e.setAttribute("limit-selection", "");
      });
    }
  }, {
    key: "_clickHandler",
    value: function _clickHandler(e) {
      var t = this,
          i = t.shadowRoot || t.isInShadowDOM ? e.composedPath()[0] : e.target;

      if (!t.disabled && i && i.closest && (t._isMobile || 0 === e.button)) {
        if (t._scrollBarDown) return void delete t._scrollBarDown;

        var _e963 = i.closest(".smart-drop-down"),
            _a528 = t._editor && t._editor.contains(i) || _e963 && (t._editor.contains(_e963.ownerElement) || t._editor === _e963.ownerElement) || i.closest(".smart-custom-editor");

        t._editor && t._editorIsOpen && !_a528 && t._closeEditor();

        var _n391 = i.closest(".smart-filter-group-condition") || i.closest(".smart-filter-nested-operator") || i.closest(".smart-filter-group");

        if (_n391) {
          var _e964 = t._getItemById(_n391.getAttribute("node-id"));

          if (_e964) {
            if (t.$.fireEvent("itemClick", {
              id: _e964.nodeId,
              type: _e964.type,
              data: _e964.data
            }), i.closest(".smart-filter-delete-btn")) return void t._clickHandlerDeleteButton(_e964.htmlNode);

            var _a529 = i.closest(".smart-filter-add-btn") || i.closest(".smart-filter-add-condition-btn");

            if (_a529) {
              var _n393 = _a529.closest(".smart-filter-group").getAttribute("node-id");

              return void (_a529.classList.contains("smart-filter-add-condition-btn") && (t.maxConditions && t._getTotalConditions() < t.maxConditions || !t.maxConditions) ? t._addElement("condition", _n393, []) : t._clickHandlerFilterButton(_a529.classList, _e964.nodeId, i));
            }

            var _n392 = i.closest(".filter-builder-item") || i.closest(".smart-filter-group-operator") || i.closest(".smart-filter-nested-operator");

            if (_n392) {
              var _a530 = _n392.classList;

              t._clickHandlerFilterButton(_a530, _e964.nodeId, i);
            }
          }
        }
      }
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;

      if (e.originalEvent && (t._isMobile || 0 === e.button)) {
        var _i805 = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target,
            _a531 = t.rightToLeft ? e.pageX > _i805.getBoundingClientRect().right : e.pageX < _i805.getBoundingClientRect().left;

        if (t.allowDrag && _i805.classList.contains("smart-filter-group-condition") && _a531) {
          var _a532 = t._valueFlat.filter(function (e) {
            return "condition" === e.type;
          });

          return 1 === _a532.length || 2 === _a532.length && _a532[0].parentId === _a532[1].parentId && _a532[1].htmlNode.hasAttribute("limit-selection") ? void 0 : (t._dragDetails = {
            coords: {
              x: e.pageX,
              y: e.pageY
            },
            item: _i805,
            originalEvent: e
          }, t.$.scrollableContainer._scrollView.disableSwipeScroll = !0, t._hoveredCondition = _i805, void window.getSelection().removeAllRanges());
        }

        this._scrollBarDown = _i805.closest("smart-scroll-bar"), e.stopPropagation(), e.preventDefault();
      }
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = Math.abs;
      var i = this,
          a = i._dragDetails;
      if (!a) return;
      var n = a.item;
      if (!a.feedbackShown) if (5 < t(a.coords.x - e.pageX) || 5 < t(a.coords.y - e.pageY)) {
        var _t817 = i._valueFlat.filter(function (e) {
          return e.htmlNode === n;
        })[0],
            _o289 = i.$.fireEvent("dragStart", {
          data: _t817.data,
          item: n,
          originalEvent: e
        });

        if (_o289.defaultPrevented) return delete i._dragDetails, delete i._hoveredCondition, void (i.$.scrollableContainer._scrollView.disableSwipeScroll = !1);
        a.allConditions = Array.from((i.shadowRoot || i).querySelectorAll(".smart-filter-group-condition")), a.data = _t817, a.feedback = i._addDragFeedback(), a.feedbackShown = !0, n.classList.add("dragged");
      } else return;
      var o = e.clientY;
      var r = i.shadowRoot || i.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target,
          l;

      if (i.$.fireEvent("dragging", {
        data: a.data,
        item: n,
        originalEvent: e
      }), i.setAttribute("dragging", ""), a.feedback.style.left = e.pageX + 10 + "px", a.feedback.style.top = e.pageY + 10 + "px", i._isMobile) {
        var _t818 = i._hoveredCondition;
        _t818 && (_t818.classList.remove("drop-target", "top", "bottom"), delete i._hoveredCondition);

        var _a533 = document.elementFromPoint(e.clientX, o);

        _a533 && (r = _a533);
      }

      var s = r.closest(".smart-filter-group-condition"),
          d;

      if (s) {
        l = s;

        var _e965 = l.getBoundingClientRect(),
            _i806 = t(o - _e965.top),
            _a534 = t(o - _e965.bottom);

        d = _i806 < _a534 ? "top" : "bottom";
      } else {
        var _e966, _i807;

        a.allConditions.forEach(function (a) {
          var n = a.getBoundingClientRect(),
              r = t(o - n.top),
              l = t(o - n.bottom),
              s = Math.min(r, l);
          (void 0 === _i807 || s < _i807) && (_e966 = a, _i807 = s, d = r < l ? "top" : "bottom");
        }), s = _e966;
      }

      if (s !== n && !(s.hasAttribute("limit-selection") && "bottom" === d)) {
        var _e967 = Array.from(s.parentElement.getElementsByClassName("smart-filter-group-condition")),
            _t819 = _e967.indexOf(n);

        -1 !== _t819 && ("top" === d && s === _e967[_t819 + 1] || "bottom" === d && s === _e967[_t819 - 1]) && (s = void 0);
      } else s = void 0;

      if (l = s, a.side = d, clearInterval(i._dragInterval), i._dragInterval = setInterval(function () {
        var t = i.getBoundingClientRect();
        0 < i.$.scrollableContainer.scrollHeight && t.left <= e.clientX && t.left + t.width >= e.clientX ? o >= t.top && o <= t.top + 36 ? i.$.scrollableContainer.scrollTop -= i._autoScrollCoefficient : o >= t.top + t.height - 36 && o <= t.top + t.height ? i.$.scrollableContainer.scrollTop += i._autoScrollCoefficient : clearInterval(i._dragInterval) : clearInterval(i._dragInterval);
      }, 1), l) {
        i._hoveredCondition && l !== i._hoveredCondition && i._hoveredCondition.classList.remove("drop-target", "top", "bottom");

        var _e968 = l.closest(".smart-filter-group");

        if (_e968 && _e968.hasAttribute("restricted")) return void (i._hoveredCondition = void 0);
        i._hoveredCondition = l, l.classList.remove("top", "bottom"), l.classList.add(d, "drop-target");
      } else i._hoveredCondition && (i._hoveredCondition.classList.remove("drop-target", "top", "bottom"), delete i._hoveredCondition);
    }
  }, {
    key: "_addDragFeedback",
    value: function _addDragFeedback() {
      var e = document.createElement("div");
      return this.rightToLeft ? e.setAttribute("right-to-left", "") : e.removeAttribute("right-to-left"), e.className = "smart-query-builder-drag-feedback", document.body.appendChild(e), e;
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = t._dragDetails;
      if (!i) return void (t.$.conditionsMenu.opened && t._selectedElement && !t._selectedElement.classList.contains("smart-filter-add-btn") && t.$.conditionsMenu._hoverViaKeyboard(t.$.conditionsMenu.querySelector("smart-menu-item[value=\"" + t._editedItem.data + "\"]")));
      var a = i.item,
          n = i.data,
          o = t._hoveredCondition;
      if (delete t._dragDetails, delete t._hoveredCondition, t.$.scrollableContainer._scrollView.disableSwipeScroll = !1, !t.hasAttribute("dragging")) return;
      if (clearInterval(t._dragInterval), window.getSelection().removeAllRanges(), t.removeAttribute("dragging"), a.classList.remove("dragged"), document.body.removeChild(i.feedback), !o) return void t.$.fireEvent("dragEnd", {
        data: n.data,
        item: a,
        originalEvent: e,
        target: null,
        targetData: null,
        targetSide: null
      });

      var r = t._valueFlat.filter(function (e) {
        return e.htmlNode === o;
      })[0],
          l = t.$.fireEvent("dragEnd", {
        data: n.data,
        item: a,
        originalEvent: e,
        target: o,
        targetData: r.data,
        targetSide: i.side
      });

      if (o.classList.remove("drop-target", "top", "bottom"), l.defaultPrevented) return;
      var s = t.value,
          d = n.nodeId.split(".").map(function (e) {
        return parseFloat(e);
      }),
          c = s[2 * (d[0] - 1)],
          m = r.nodeId.split(".").map(function (e) {
        return parseFloat(e);
      }),
          u = s[2 * (m[0] - 1)];
      var p = "and";
      1 < c.length && (0 === d[1] ? (p = c[1], c[1] = "!remove!") : (p = c[d[1] - 1], c[d[1] - 1] = "!remove!")), c[d[1]] = "!remove!", "top" === i.side ? u.splice(m[1], 0, n.data, p) : u.splice(m[1] + 1, 0, p, n.data);

      for (var _t820 = 0; _t820 < s.length; _t820++) {
        Array.isArray(s[_t820]) && (s[_t820] = s[_t820].filter(function (e) {
          return "!remove!" !== e;
        }));
      }

      for (var _t821 = s.length - 1; 0 <= _t821; _t821--) {
        Array.isArray(s[_t821]) && 0 === s[_t821].length && (0 == _t821 ? s.splice(0, 2) : (s.splice(_t821 - 1, 2), _t821--));
      }

      t._emptyElementsStructure(!0), t._convertValueToFlat(s), t._generateHTMLStructureFromFlatValue(), t._validValue = t._getValidValue();
      var g = JSON.stringify(t._validValue);
      t._oldValueAsString !== g && (t._oldValueAsString = g, t.$.fireEvent("change", {
        value: JSON.parse(g),
        linq: t._parseQueryToLinq(t._validValue)
      }));
    }
  }, {
    key: "_clickHandlerDeleteButton",
    value: function _clickHandlerDeleteButton(e, t) {
      var i = this;

      if (e && e.classList) {
        if (i._closeEditor(), 1 === i.getElementsByClassName("smart-filter-group-condition").length) {
          var _e969 = i._valueFlat[1].htmlNode.children;
          i.value = [[[]]], i._validValue = i._getValidValue(), i._valueFlat[1].data = [], i._valueFlat[1].htmlNode.setAttribute("limit-selection", ""), _e969[0].setAttribute("placeholder", ""), _e969[1].setAttribute("placeholder", ""), _e969[2].setAttribute("placeholder", ""), _e969[0].firstElementChild.innerHTML = i.propertyPlaceholder, _e969[1].firstElementChild.innerHTML = i.operatorPlaceholder, _e969[2].firstElementChild.innerHTML = i.valuePlaceholder;

          var _t822 = JSON.stringify(i._validValue);

          return void (i._oldValueAsString !== _t822 && (i._oldValueAsString = _t822, i.$.fireEvent("change", {
            value: JSON.parse(_t822),
            linq: i._parseQueryToLinq(i._validValue)
          })));
        }

        if (e.classList.contains("smart-filter-group")) {
          if (t && 0 < i._valueFlat.filter(function (t) {
            return t.parentId === e.getAttribute("node-id");
          }).length) return;

          i._deleteElement(e, "group");
        } else i._deleteElement(e);

        i._generateValue(), i.$.scrollableContainer.refresh(), Array.from(i.$.contentContainer.children).forEach(function (e, t) {
          var a = (t + 1).toString();
          e.setAttribute("node-id", a), i._valueFlat.filter(function (t) {
            return t.htmlNode === e;
          })[0].nodeId = a, Array.from(e.children[1].children).forEach(function (e, t) {
            var n = i._valueFlat.filter(function (t) {
              return t.htmlNode === e;
            })[0],
                o = a + "." + t;

            e.setAttribute("node-id", o), n.parentId = a, n.nodeId = o;
          });
        });
      }
    }
  }, {
    key: "_menuClosingHandler",
    value: function _menuClosingHandler(e) {
      var t = e.detail;
      "interaction" === t.trigger && this._selectedElement === t.target && e.preventDefault();
    }
  }, {
    key: "_menuItemClickHandler",
    value: function _menuItemClickHandler(e) {
      var t = this,
          a = t._selectedElement.closest(".smart-filter-group-operator, .smart-filter-nested-operator"),
          i = e.detail,
          n = i.value;

      var o;

      if (a) {
        a.innerHTML = t.localize(n) || i.label, a.value = n, o = a.classList.contains("smart-filter-nested-operator") ? a.getAttribute("node-id") : a.parentElement.getAttribute("node-id");

        for (var _e970 = 0; _e970 < t._valueFlat.length; _e970++) {
          if (t._valueFlat[_e970].nodeId === o) {
            t._valueFlat[_e970].data = a.value;
            break;
          }
        }

        t._generateValue();
      } else o = t._selectedElement.parentElement.getAttribute("node-id"), t._addElement("group", null, n);

      t.$.scrollableContainer.refresh();
    }
  }, {
    key: "_newFilterConditionRow",
    value: function _newFilterConditionRow() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var t = this,
          i = e[0];

      var a = t._fields.find(function (e) {
        return e.value === i;
      }),
          n = a ? a.label : void 0,
          o;

      if (void 0 === i || !n && "static" === t.fieldsMode) e.length = 0;else {
        n || (a = t._getDynamicFieldInfo(i), n = a.label, e[0] = a.dataField);

        var _r180 = t._getFilterOperations(a);

        o = _r180.find(function (t) {
          return t.value === e[1];
        }), o ? o = o.label : e.splice(1, 2);
      }

      var r = t._formatValueStringRepresentation(e[2], e[0], e[1]);

      var l = document.createElement("div"),
          s = "<div class =\"filter-builder-item smart-filter-field-name\" " + (n ? "><div class =\"smart-value-container\">" + n : "placeholder><div class =\"smart-value-container\">" + t.propertyPlaceholder) + "</div></div><div class =\"filter-builder-item smart-filter-operation\" " + (o ? "><div class =\"smart-value-container\">" + o : "placeholder><div class =\"smart-value-container\">" + t.operatorPlaceholder) + "</div></div><div class =\"filter-builder-item smart-filter-value\" " + (void 0 === e[2] ? "placeholder><div class =\"smart-value-container\">" + t.valuePlaceholder : "><div class =\"smart-value-container\">" + r) + "</div></div><div class =\"smart-filter-delete-btn\"></div>";
      return l.className = "smart-filter-group-condition", l.innerHTML = s, e.length || l.setAttribute("limit-selection", ""), l;
    }
  }, {
    key: "_formatValueStringRepresentation",
    value: function _formatValueStringRepresentation(e, t, i) {
      var a = this,
          n = a._getFieldByFieldName(t);

      var o;
      if (!n) return e;
      if (void 0 === e || null === e) return a.valuePlaceholder;
      if (void 0 !== i && a.customOperations && 0 < a.customOperations.length && (i = a.customOperations.find(function (e) {
        return e.name === i;
      }), i && i.valueTemplate)) return "<span>" + i.valueTemplate(a._editor, e) + "</span>";

      switch (n.dataType) {
        case "date":
        case "dateTime":
          e = e instanceof Date || "string" == typeof e || "number" == typeof e && !isNaN(e) ? new Smart.Utilities.DateTime(e) : e, e.calendar.days = a._localizedDays, e.calendar.months = a._localizedMonths, e.calendar.locale = a.locale, o = e.toString("date" === n.dataType ? a.formatStringDate : a.formatStringDateTime);
          break;

        case "array":
          o = "string" == typeof e ? e.split(",") : e;
          break;

        case "object":
          o = "string" == typeof e ? e : JSON.stringify(e);
          break;

        case "number":
          o = e;
          break;

        case "boolean":
          o = !!e;
          break;

        default:
          o = e + "";
      }

      return a.valueFormatFunction ? "<span>" + a.valueFormatFunction(o, t, n.dataType || "string") + "</span>" : "<span>" + o + "</span>";
    }
  }, {
    key: "_getFieldByFieldName",
    value: function _getFieldByFieldName(e) {
      return Object.assign({}, this._fields.find(function (t) {
        return t.value === e;
      }));
    }
  }, {
    key: "_refresh",
    value: function _refresh() {
      var e = this;
      e._generateValue(), e._emptyElementsStructure(), e._generateHTMLStructureFromFlatValue(), e._restrictNesting();
    }
  }, {
    key: "_generateValue",
    value: function _generateValue(e) {
      var t = this;

      var a = [],
          n = t._valueFlat.slice(0),
          o = [];

      for (var _t823 = 0; _t823 < n.length; _t823++) {
        var _e971 = n[_t823];
        var _i808 = {};
        "group" === _e971.type && (_i808.nodeId = _e971.nodeId, _i808.parentId = _e971.parentId, _i808.data = _e971.data, _i808.structure = [], a.push(_i808));
      }

      for (var _t824 = 0; _t824 < a.length; _t824++) {
        var _e972 = a[_t824];

        for (var _t825 = 0; _t825 < n.length; _t825++) {
          var _i809 = n[_t825];

          if (_i809.parentId === _e972.nodeId && "condition" === _i809.type) {
            var _a535 = n[_t825 - 1];
            _a535 && _a535.parentId === _e972.nodeId && "operator" === _a535.type && _e972.structure.push(_a535.data.toString()), _e972.structure.push(_i809.data);
          }
        }
      }

      a = a.filter(function (e) {
        return 0 < e.structure.length;
      }), a.sort(function (e, t) {
        return t.nodeId.split(".").length - e.nodeId.split(".").length;
      });

      var _loop41 = function _loop41(_t826) {
        var e = a[_t826],
            i = a.filter(function (t) {
          return t.nodeId === e.parentId;
        })[0];

        if (i && i.structure) {
          i.structure.push(e.structure);
          return "continue";
        }

        if ("0" === e.nodeId) {
          o = o.concat(e.structure);
          return "continue";
        }

        e.data && (0 < _t826 && o.push(e.data), o.push(e.structure));
      };

      for (var _t826 = 0; _t826 < a.length; _t826++) {
        var _ret14 = _loop41(_t826);

        if (_ret14 === "continue") continue;
      }

      if (t.value = o, t._validateValue(), t._validValue = t._getValidValue(), !e) {
        var _e973 = JSON.stringify(t._validValue);

        t._oldValueAsString !== _e973 && (t._oldValueAsString = _e973, t.$.fireEvent("change", {
          value: JSON.parse(_e973),
          linq: t._parseQueryToLinq(t._validValue)
        }));
      }
    }
  }, {
    key: "_getItemById",
    value: function _getItemById(e, t) {
      var i = this,
          a = i._valueFlat.filter(function (i) {
        return t ? i.parentId === e : i.nodeId === e;
      }),
          n = 0 < a.length ? a[0] : null;

      return n;
    }
  }, {
    key: "_validateStoredValue",
    value: function _validateStoredValue(e, t) {
      var i = this;
      if (!t && !i._editedItem) return e;
      if (!t && (t = i._editedItem.data[0], !t)) return e;

      switch (i._getFieldByFieldName(t).dataType) {
        case "date":
        case "dateTime":
          e = new Smart.Utilities.DateTime(e).toDate();
          break;

        case "number":
          "number" != typeof e && (e = parseFloat(e));
          break;

        case "boolean":
          "boolean" != typeof e && (e = !!e);
          break;

        case "object":
          "object" != typeof e && (e = {});
          break;

        case "array":
          Array.isArray(e) || (e = [e]);
          break;

        default:
          "string" != typeof e && (e += "");
      }

      return e;
    }
  }, {
    key: "_closeEditor",
    value: function _closeEditor(e) {
      var t = this;
      var i;

      if (t._editedItem && t._editorIsOpen) {
        var _a536 = t._editedItem,
            _n394 = t._editor.closest(".filter-builder-item"),
            _o290 = _n394.querySelector(".smart-value-container"),
            _r181 = _n394.parentElement,
            _l123 = _r181.children[2];

        if (t._editor === t.$.dateTimePickerEditor) t._editor._inputChangeHandler(), i = t._editor.value, i && (i = i.toDate());else if (t._editor === t.$.checkBoxEditor) i = t._editor.checked;else if (t._editor === t.$.customEditor) {
          if (t._editor) {
            var _e974 = Array.from(t._editor.getElementsByTagName("smart-numeric-text-box"));

            _e974.forEach(function (e) {
              return e._inputBlurHandler();
            });
          }

          i = t._validateStoredValue(t._selectedCustomCondition.handleValue(t._editor));
        } else if (t._editor === t.$.numericTextBoxEditor) t._editor._inputBlurHandler(), i = t._editor.value;else if (_n394.classList.contains("smart-filter-value")) {
          var _e975 = t._getFieldByFieldName(t._editedItem.data[0]);

          i = "array" === _e975.dataType ? t._editor.value.split(",") : "object" === _e975.dataType ? JSON.parse(t._editor.value) : t._editor.value;
        } else i = t._editor.value;

        if (_n394.classList.contains("smart-filter-field-name")) {
          if ("" === i.trim()) return void t._hideEditor(_n394, void 0 === _a536.data[0]);
          _r181.hasAttribute("limit-selection") && (_r181.removeAttribute("limit-selection"), _r181.parentElement.nextElementSibling.removeAttribute("limit-selection"));

          var _e976 = t._fields.find(function (e) {
            return e.label === i;
          }),
              _s87 = _a536.data[0];

          if (_e976) _a536.data[0] = _e976.value;else if ("dynamic" === t.fieldsMode) {
            var _e977 = t._getDynamicFieldInfo(i);

            i = _e977.label, _a536.data[0] = _e977.dataField;
          } else return _o290.innerHTML = t._fields.find(function (e) {
            return e.value === _s87;
          }).label, void t._hideEditor(_n394);
          _o290.innerHTML = i, t._handleFieldChange([_s87, _a536.data[0]], [_l123, _a536, _r181]);
        } else _n394.classList.contains("smart-filter-operation") ? t._handleOperationChange([_a536, i, t._editor.$.input.dataValue], [_o290, _l123]) : (_a536.data[2] = i, _o290.innerHTML = t._formatValueStringRepresentation(i, t._editedItem.data[0], t._editedItem.data[1]));

        t._generateValue(e), t._hideEditor(_n394);
      }
    }
  }, {
    key: "_getDynamicFieldInfo",
    value: function _getDynamicFieldInfo(e) {
      var t = this,
          i = {
        label: e,
        dataField: e,
        dataType: "string"
      };

      if (t.getDynamicField) {
        var _a537 = t.getDynamicField(e);

        _a537.label && (i.label = _a537.label), _a537.dataField && (i.dataField = _a537.dataField), _a537.dataType && (i.dataType = _a537.dataType), _a537.filterOperations && Array.isArray(_a537.filterOperations) && 0 < _a537.filterOperations.length && (i.filterOperations = _a537.filterOperations), _a537.lookup && (i.lookup = _a537.lookup);
      }

      return t._manuallyAddedFields.push(i), t._mapFieldsToMenu(), i;
    }
  }, {
    key: "_handleFieldChange",
    value: function _handleFieldChange(e, t) {
      var i = this,
          a = e[0],
          n = t[1],
          o = t[2],
          r = t[0],
          l = i._fields.find(function (t) {
        return t.value === e[1];
      }),
          s = i._getFilterOperations(l),
          d = function d() {
        l.value !== a && i.$.fireEvent("propertySelected", {
          label: l.label,
          value: l.value
        });
      };

      if (!a || void 0 === n.data[1]) return i._handleOnlyOperation(s, n.data, o), void d();

      var c = i._fields.find(function (e) {
        return e.value === a;
      }),
          m = c.dataType,
          u = l.dataType;

      if (l !== c && (u !== m || l.filterOperations || c.filterOperations)) {
        var _e978 = !!s.find(function (e) {
          return e.value === n.data[1];
        });

        return _e978 ? u === m ? void 0 : "date" === u && "dateTime" === m || "dateTime" === u && "date" === m ? (r.firstElementChild.innerHTML = i._formatValueStringRepresentation(n.data[2], n.data[0], n.data[1]), void d()) : (n.data.splice(2, 1), r.setAttribute("placeholder", ""), r.firstElementChild.innerHTML = i.valuePlaceholder, void d()) : void (n.data.splice(1, 2), o.children[1].setAttribute("placeholder", ""), o.children[1].firstElementChild.innerHTML = i.operatorPlaceholder, r.setAttribute("placeholder", ""), r.firstElementChild.innerHTML = i.valuePlaceholder, r.classList.remove("smart-visibility-hidden"), i._handleOnlyOperation(s, n.data, o), d());
      }
    }
  }, {
    key: "_handleOnlyOperation",
    value: function _handleOnlyOperation(e, t, i) {
      if (1 === e.length) {
        var _a538 = e[0];
        t[1] = _a538.value, i.children[1].removeAttribute("placeholder", ""), i.children[1].firstElementChild.innerHTML = e[0].label, ("isblank" === _a538.value || "isnotblank" === _a538.value || _a538.custom && _a538.hideValue) && (t.splice(2, 1), i.children[2].classList.add("smart-visibility-hidden"));
      }
    }
  }, {
    key: "_handleOperationChange",
    value: function _handleOperationChange(e, t) {
      var i = this,
          a = e[0],
          n = e[1],
          o = e[2],
          r = t[0],
          l = t[1],
          s = void 0 === a.data[1] ? void 0 : i._filterOperationDescriptions.find(function (e) {
        return e.value === a.data[1];
      }),
          d = i._filterOperationDescriptions.find(function (e) {
        return e.value === o;
      }),
          c = d.value;

      if (d !== s) {
        var _e979 = a.data[0],
            _t827 = a.data[1],
            _o291 = a.data[2];
        if (a.data[1] = c, r.innerHTML = n, "isblank" === c || "isnotblank" === c || d.custom && d.hideValue) a.data.splice(2, 1), l.classList.add("smart-visibility-hidden");else if (l.classList.contains("smart-visibility-hidden")) l.setAttribute("placeholder", ""), l.classList.remove("smart-visibility-hidden"), l.firstElementChild.innerHTML = i.valuePlaceholder;else if (d.custom) {
          var _a539 = i._getFieldByFieldName(_e979);

          if (d.editorTemplate) {
            var _e980 = d.editorTemplate(_a539.dataType, _t827, _a539);

            _e980 && (i.$.customEditor.innerHTML = "", i.$.customEditor.appendChild(_e980));
          }

          l.firstElementChild.innerHTML = d.valueTemplate ? d.valueTemplate(i.$.customEditor, _o291) : _o291;
        } else void 0 === _o291 ? (a.data.splice(2, 1), l.setAttribute("placeholder", ""), l.firstElementChild.innerHTML = i.valuePlaceholder) : d.custom || (l.firstElementChild.innerHTML = _o291);
      }
    }
  }, {
    key: "_hideEditor",
    value: function _hideEditor(e, t) {
      var i = this;
      t && e.setAttribute("placeholder", ""), e.removeAttribute("edited"), i.$.editorsContainer.removeAttribute("open"), i._editor.close && i._editor.close(), i._editor.classList.add("smart-hidden"), i._editorIsOpen = i._enterIsPressedInEditor = !1, i.$.scrollableContainer.refresh();
    }
  }, {
    key: "_clickHandlerFilterButton",
    value: function _clickHandlerFilterButton(e, t, i) {
      function a(e, t, i) {
        n._contextMenuOptions = 0 === t.length ? n._defaultFilterOperationDescriptions : t, n._handleContextMenu(e), n.$.conditionsMenu.opened && (n.$.conditionsMenu._discardKeyboardHover(), n.$.conditionsMenu._hoverViaKeyboard(n.$.conditionsMenu.querySelector("smart-menu-item[value=\"" + i + "\"]")));
      }

      var n = this;

      if (!i.closest(".smart-editors-container")) {
        if (n._closeEditor(), n._editedItem = n._getItemById(t), e.contains("smart-filter-add-btn")) return void a(i, n._groupOperationDescriptions);
        if (e.contains("smart-filter-field-name") || n._editedItem.data && n._editedItem.data.length) if (e.contains("smart-filter-group-operator") || e.contains("smart-filter-nested-operator")) a(i, n._groupOperationDescriptions, n._editedItem.data);else {
          var _e981 = i.closest(".filter-builder-item");

          _e981.removeAttribute("placeholder"), n._openEditor(i);
        }
      }
    }
  }, {
    key: "_handleContextMenu",
    value: function _handleContextMenu(e) {
      var t = this;
      if (t._selectedElement === e && t.$.conditionsMenu.opened) return void t.$.conditionsMenu.close();
      if (t._closeEditor(), t.disableContextMenu) return void (t._selectedElement = e);
      var i = e.getBoundingClientRect(),
          a = t.getBoundingClientRect(),
          n = i.left + t.$.contentContainer.scrollLeft - a.left,
          o = i.top + t.$.contentContainer.scrollTop - a.top + i.height;
      t.$.conditionsMenu.dataSource = t._contextMenuOptions, t.$.conditionsMenu.open(n, o + 3), t._selectedElement = e, t.$.scrollableContainer.refresh();
    }
  }, {
    key: "_openEditor",
    value: function _openEditor(e) {
      var t = this,
          i = e && e.closest(".smart-filter-group-condition") ? e.closest(".smart-filter-group-condition").getAttribute("node-id") : null,
          a = e.closest(".filter-builder-item"),
          n = t._getItemById(i);

      var o = "";
      n.data[0] === void 0 ? t._fields.length && (o = t._fields[0].value) : o = n.data[0];

      var r = t._getFieldByFieldName(o),
          l = "",
          s,
          d;

      if (a.classList.contains("smart-filter-field-name")) d = 0, t._fields || t._mapFieldsToMenu(), r.lookup = {
        dataSource: t._fields.slice(),
        readonly: !1
      }, l = r.label || "", s = r.value;else if (a.classList.contains("smart-filter-operation")) {
        d = 1;

        var _e982 = t._getFilterOperations(r);

        r.lookup = {
          dataSource: _e982,
          readonly: !0
        };

        var _i810 = _e982.find(function (e) {
          return e.value === n.data[d];
        }) || _e982[0];

        l = _i810.label, s = _i810.value;
      } else d = 2, l = n.data[d], void 0 === l && (l = "");
      t._editorIsOpen && t._closeEditor(), a.setAttribute("edited", ""), t._editedItem = n;

      var c = t._fields,
          m = c.filter(function (e) {
        return e.value === o;
      }),
          u = t._filterOperationDescriptions.filter(function (e) {
        return e.value === n.data[1] && e.custom;
      }),
          p = 0 < m.length ? m[0] : null,
          g = r.lookup && r.lookup.dataSource ? "lookup" : p.dataType;

      2 === d && 0 !== u.length && u[0].editorTemplate ? (t._selectedCustomCondition = u[0], t._openCustomEditor(g, l, r)) : t._openEditorByFieldType(g, l, r, s), t._editor.classList.remove("smart-hidden"), t._editorIsOpen = !0, t.$.editorsContainer.setAttribute("open", ""), a.appendChild(t.$.editorsContainer), t.$.scrollableContainer.refresh(), t._editor.classList.contains("smart-custom-editor") || requestAnimationFrame(function () {
        return t._editor.focus();
      }), r.lookup && r.lookup.readonly && t._editor.open();
    }
  }, {
    key: "_getFilterOperations",
    value: function _getFilterOperations(e) {
      var t = this;

      var i = t._filterOperationDescriptions.slice();

      if (e.filterOperations) i = t._filterOperationDescriptions.filter(function (t) {
        return -1 < e.filterOperations.indexOf(t.value);
      });else {
        var _a540;

        switch (e.dataType) {
          case "date":
          case "dateTime":
          case "number":
            _a540 = ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"];
            break;

          case "boolean":
            _a540 = ["=", "<>", "isblank", "isnotblank"];
            break;

          case "object":
            _a540 = ["isblank", "isnotblank"];
            break;

          case "string":
            _a540 = ["contains", "notcontains", "startswith", "endswith", "=", "<>", "isblank", "isnotblank"];
            break;

          default:
            _a540 = ["contains", "notcontains", "startswith", "endswith", "=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"];
        }

        i = t._filterOperationDescriptions.filter(function (e) {
          return -1 < _a540.indexOf(e.value);
        });
      }
      return t.showIcons && i.map(function (e) {
        return e.icon = t.icons[e.value];
      }), i;
    }
  }, {
    key: "_openCustomEditor",
    value: function _openCustomEditor(e, t, i) {
      var a = this,
          n = a.customOperations[a._selectedCustomCondition.index].editorTemplate(e, t, i);

      a.$.customEditor.innerHTML = "", n && a.$.customEditor.appendChild(n), a._editor = a.$.customEditor;
    }
  }, {
    key: "_openEditorByFieldType",
    value: function _openEditorByFieldType(e, t, i, a) {
      var n = this;

      switch (e) {
        case "boolean":
          n._initializeEditor("checkBox"), n._editor.checked = !!t;
          break;

        case "date":
        case "dateTime":
          n._initializeEditor("dateTimePicker"), n._editor.formatString = "date" === e ? n.formatStringDate : n.formatStringDateTime, n._editor.value = t;
          break;

        case "number":
          n._initializeEditor("numericTextBox"), n._editor.value = t ? t : 0;
          break;

        default:
          if (n._initializeEditor("input"), n._editor.dropDownWidth = n.dropDownWidth, "lookup" === e) {
            var _e983 = i.lookup.minLength;
            n._editor.autoCompleteDelay = i.lookup.autoCompleteDelay || 100, n._editor.dataSource = i.lookup.dataSource, n._editor.dropDownAppendTo = n.$.container, n._editor.dropDownButtonPosition = n.rightToLeft ? "left" : "right", n._editor.minLength = isNaN(_e983) || null === _e983 ? 1 : _e983, n._editor.readonly = !!i.lookup.readonly;
          } else n._editor.dataSource = [], n._editor.dropDownButtonPosition = "none", n._editor.readonly = !1;

          "object" === e ? n._editor.value = JSON.stringify(t ? t : {}) : ("" === t && n._editor.readonly && (t = i.lookup.dataSource[0].label || ""), n._editor.value = t + "", a && (n._editor.$.input.dataValue = a));
      }
    }
  }, {
    key: "_initializeEditor",
    value: function _initializeEditor(e) {
      var t = this;
      if (t.$[e + "Editor"]) return void (t._editor = t.$[e + "Editor"]);
      var i = document.createElement("smart-" + Smart.Utilities.Core.toDash(e));
      "numericTextBox" === e ? (i.spinButtons = !0, i.inputFormat = "floatingPoint") : "dateTimePicker" == e && (i.dropDownAppendTo = t.$.container, i.calendarButton = !0, i.dropDownDisplayMode = "auto", i.enableMouseWheelAction = !0, i.locale = t.locale, !i.messages[t.locale] && (i.messages[t.locale] = {}), i.messages[t.locale].dateTabLabel = t.localize("dateTabLabel"), i.messages[t.locale].timeTabLabel = t.localize("timeTabLabel")), i.rightToLeft = t.rightToLeft, i.theme = t.theme, i.animation = t.animation, i.$.addClass("smart-hidden underlined"), t.$.editorsContainer.appendChild(i), t._editor = t.$[e + "Editor"] = i;
    }
  }, {
    key: "_getValidValue",
    value: function _getValidValue() {
      var e = this,
          t = e.properties.value.value,
          i = [];
      var a = !1;
      return t.forEach(function (t) {
        if (Array.isArray(t)) {
          var _n395 = !1,
              _o292 = !1;

          var _r182 = [];
          t.forEach(function (t) {
            if (Array.isArray(t)) {
              var _i811 = t[0],
                  _a541 = t[1],
                  _l124 = t[2];
              if (void 0 === _i811 || void 0 === _a541) return void (_o292 = !0);
              if (void 0 !== _l124 || "isblank" === _a541 || "isnotblank" === _a541) return _n395 = !0, void _r182.push(t);

              var _s88 = e._filterOperationDescriptions.find(function (e) {
                return e.value === _a541;
              });

              _s88.custom && _s88.hideValue ? (_n395 = !0, _r182.push(t)) : _o292 = !0;
            } else _o292 ? _o292 = !1 : _r182.push(t);
          }), _n395 ? ("string" == typeof _r182[_r182.length - 1] && _r182.pop(), i.push(_r182)) : a = !0;
        } else a ? a = !1 : i.push(t);
      }), "string" == typeof i[i.length - 1] && i.pop(), i;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        allowDrag: {
          value: !1,
          type: "boolean"
        },
        applyMode: {
          allowValues: ["immediately", "change"],
          value: "change",
          type: "string"
        },
        customOperations: {
          value: [],
          type: "array",
          reflectToAttribute: !1
        },
        customOperators: {
          value: {},
          type: "object",
          reflectToAttribute: !1
        },
        dropDownWidth: {
          type: "any",
          value: "100%"
        },
        fields: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        fieldsMode: {
          value: "dynamic",
          allowedValues: ["dynamic", "static"],
          type: "string"
        },
        formatStringDate: {
          value: "dd-MMM-yy",
          type: "string"
        },
        formatStringDateTime: {
          value: "dd-MMM-yy HH:mm:ss",
          type: "string"
        },
        getDynamicField: {
          value: null,
          type: "function?"
        },
        icons: {
          value: {
            "=": "equals",
            "<>": "notequals",
            ">": "greaterthan",
            ">=": "greaterthanorequal",
            "<": "lessthan",
            "<=": "lessthanorequal",
            startswith: "startswith",
            endswith: "endswith",
            contains: "contains",
            notcontains: "notcontains",
            isblank: "isblank",
            isnotblank: "isnotblank"
          },
          type: "object",
          reflectToAttribute: !1
        },
        messages: {
          value: {
            en: {
              add: "Add",
              addCondition: "Add Condition",
              addGroup: "Add Group",
              and: "And",
              notand: "Not And",
              or: "Or",
              notor: "Not Or",
              "=": "Equals",
              "<>": "Does not equal",
              ">": "Greater than",
              ">=": "Greater than or equal to",
              "<": "Less than",
              "<=": "Less than or equal to",
              startswith: "Starts with",
              endswith: "Ends with",
              contains: "Contains",
              notcontains: "Does not contain",
              isblank: "Is blank",
              isnotblank: "Is not blank",
              wrongParentGroupIndex: "{{elementType}}: Wrong parent group index in \"{{method}}\" method.",
              wrongElementNode: "{{elementType}}: Incorect node / node Id in \"{{method}}\" method.",
              invalidDataStructure: "{{elementType}}: Used invalid data structure in updateCondition/updateGroup method.",
              dateTabLabel: "DATE",
              timeTabLabel: "TIME",
              queryLabel: "Query"
            }
          },
          type: "object",
          extend: !0
        },
        operatorPlaceholder: {
          value: "Operator",
          type: "string"
        },
        propertyPlaceholder: {
          value: "Property",
          type: "string"
        },
        showIcons: {
          value: !1,
          type: "boolean"
        },
        value: {
          value: [],
          type: "any",
          reflectToAttribute: !1
        },
        valueFormatFunction: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        valuePlaceholder: {
          value: "Value",
          type: "string"
        }
      };
    }
  }, {
    key: "requires",
    get: function get() {
      var e = {
        "Smart.Button": "smart.button.js",
        "Smart.Calendar": "smart.calendar.js",
        "Smart.CheckBox": "smart.checkbox.js",
        "Smart.DateTimePicker": "smart.datetimepicker.js",
        "Smart.DropDownList": "smart.dropdownlist.js",
        "Smart.Input": "smart.input.js",
        "Smart.ListBox": "smart.listbox.js",
        "Smart.Menu": "smart.menu.js",
        "Smart.NumericTextBox": "smart.numerictextbox.js",
        "Smart.ScrollBar": "smart.scrollbar.js",
        "Smart.TimePicker": "smart.timepicker.js",
        "Smart.Tooltip": "smart.tooltip.js",
        "Smart.Utilities.BigNumber": "smart.math.js",
        "Smart.Utilities.DateTime": "smart.date.js",
        "Smart.Utilities.Draw": "smart.draw.js",
        "Smart.Utilities.NumericProcessor": "smart.numeric.js"
      };
      return window.NIComplex || (e["Smart.Utilities.Complex"] = "smart.complex.js"), e;
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        down: "_downHandler",
        move: "_moveHandler",
        resize: "_resizeHandler",
        "editorsContainer.keydown": "_innerContainerKeydownHandler",
        "conditionsMenu.closing": "_menuClosingHandler",
        "conditionsMenu.itemClick": "_menuItemClickHandler",
        "contentContainer.change": "_contentContainerChangeHandler",
        "document.down": "_documentDownHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.querybuilder.css"];
    }
  }]);

  return _class84;
}(Smart.BaseElement)), Smart("smart-filter-panel",
/*#__PURE__*/
function (_Smart$BaseElement20) {
  "use strict";

  _inherits(_class85, _Smart$BaseElement20);

  function _class85() {
    _classCallCheck(this, _class85);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class85).apply(this, arguments));
  }

  _createClass(_class85, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" class=\"smart-container\">\n                <div id=\"label\" class=\"smart-filter-panel-label\"></div>\n                <div id=\"mainContainer\"></div>\n                <div id=\"buttonContainer\" class=\"smart-filter-panel-button-container\">\n                    <smart-button id=\"filterButton\" class=\"primary\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" unfocusable=\"[[unfocusable]]\"></smart-button>\n                    <smart-button id=\"clearButton\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" unfocusable=\"[[unfocusable]]\"></smart-button>\n                    <smart-button id=\"cancelButton\" animation=\"[[animation]]\" disabled=\"[[disabled]]\" unfocusable=\"[[unfocusable]]\"></smart-button>\n                </div>\n            </div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class85.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this,
          t = e.filterType;
      e._localize(), e._setButtonsVisibility(), e._filterType = t + "Filter", e._filterHandler = new Smart.Utilities[t.slice(0, 1).toUpperCase() + t.slice(1) + "FilterHandler"](e), _get(_getPrototypeOf(_class85.prototype), "render", this).call(this);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var e = this;
      e._filterHandler[e.mode + "Cancel"](), e.$.fireEvent("cancel");
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = this;
      e._filterHandler[e.mode + "Clear"](), e.$.fireEvent("clear");
    }
  }, {
    key: "reset",
    value: function reset() {
      var e = this;
      e.$.clearButton.removeAttribute("hover"), e.$.filterButton.removeAttribute("hover"), e.$.cancelButton.removeAttribute("hover"), e._filterHandler[e.mode + "Clear"](), e._filterHandler.filterObject = new Smart.Utilities.FilterGroup();
    }
  }, {
    key: "getFilter",
    value: function getFilter() {
      if (this._filterHandler) {
        var e = new Smart.Utilities.FilterGroup();

        for (var _t828 in this._filterHandler.filterObject) {
          e[_t828] = this._filterHandler.filterObject[_t828];
        }

        return e;
      }

      return null;
    }
  }, {
    key: "evaluate",
    value: function evaluate(e) {
      try {
        return this._filterHandler.evaluate(e);
      } catch (e) {
        return !1;
      }
    }
  }, {
    key: "filter",
    value: function filter() {
      var e = this;
      e._filterHandler[e.mode + "Filter"](), e.$.fireEvent("filter");
    }
  }, {
    key: "getState",
    value: function getState() {
      return this._filterHandler.cachedFilter;
    }
  }, {
    key: "loadState",
    value: function loadState(e) {
      try {
        var _t829 = this;

        _t829._filterHandler.cachedFilter = e, _t829._filterHandler[_t829.mode + "Cancel"]();
      } catch (e) {}
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      function a() {
        var e = ["cachedFilter", "caseSensitive", "customExcelFilterObjects", "customItems", "dataSource", "defaultListSelection", "defaultListSource", "displayMode", "filterBuilder", "filterBuilderObject", "filterBuilderOperations", "filterObject", "firstInput", "firstList", "operationsMapping", "operatorList", "secondInput", "secondList", "timeOnly", "tree"];
        e.forEach(function (t) {
          delete r[e[t]];
        }), delete o._filterHandler;
      }

      function n() {
        o.$.mainContainer.innerHTML = "", a(), o._filterHandler = new Smart.Utilities[o.filterType.slice(0, 1).toUpperCase() + o.filterType.slice(1) + "FilterHandler"](o);
      }

      _get(_getPrototypeOf(_class85.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var o = this,
          r = o._filterHandler;

      switch (e) {
        case "animation":
        case "disabled":
        case "unfocusable":
          switch (o.mode) {
            case "default":
              [r.firstList, r.firstInput, r.logicalOperatorList, r.secondList, r.secondInput].forEach(function (t) {
                t[e] = i;
              });
              break;

            case "excel":
              r.tree[e] = i;
              break;

            case "filterBuilder":
              r.filterBuilder[e] = i, r.caseSensitive && (r.caseSensitive[e] = i);
          }

          break;

        case "buttons":
          o._setButtonsVisibility();

          break;

        case "data":
        case "dataField":
          "excel" !== o.mode || Array.isArray(o.dataSource) || n();
          break;

        case "dataSource":
          "excel" === o.mode && n();
          break;

        case "filterType":
          o._filterType = i + "Filter", n();
          break;

        case "mode":
          n();
          break;

        case "formatString":
          if ("date" !== o.filterType) return;

          switch (o.mode) {
            case "default":
              r.firstInput.formatString = i, r.secondInput.formatString = i;
              break;

            case "excel":
              n();
              break;

            case "filterBuilder":
              r.filterBuilder.formatStringDate = i, r.filterBuilder.formatStringDateTime = i;
          }

          break;

        case "locale":
        case "messages":
          {
            switch (o._localize(), o.mode) {
              case "default":
                {
                  var _t830 = r.firstList.selectedIndexes,
                      _i812 = r.logicalOperatorList.selectedIndexes,
                      _a542 = r.secondList.selectedIndexes;

                  if (r.setDefaults(), r.firstList.dataSource = r.defaultListSource, r.logicalOperatorList.dataSource = [{
                    value: 0,
                    label: o.localize("and")
                  }, {
                    value: 1,
                    label: o.localize("or")
                  }], r.secondList.dataSource = r.defaultListSource, "date" === o.filterType) {
                    var _t831 = [r.firstInput, r.secondInput];

                    _t831.forEach(function (t) {
                      t.messages[o.locale] || (t.messages[o.locale] = {}), t.messages[o.locale].dateTabLabel = o.localize("dateTabLabel"), t.messages[o.locale].timeTabLabel = o.localize("timeTabLabel"), "locale" === e ? t.locale = o.locale : (t.$.selectDate.innerHTML = t.messages[o.locale].dateTabLabel, t.$.selectTime.innerHTML = t.messages[o.locale].timeTabLabel), "timePicker" === t._dropDownDisplayMode ? (t.placeholder = o.localize("placeholderTime"), t.placeholder = o.localize("placeholderTime")) : (t.placeholder = o.localize("placeholderDate"), t.placeholder = o.localize("placeholderDate"));
                    });
                  }

                  r.firstList.selectedIndexes = _t830, r.logicalOperatorList.selectedIndexes = _i812, r.secondList.selectedIndexes = _a542;
                  break;
                }

              case "excel":
                r.tree.selectAll.label = o.localize("selectAll"), r.tree.blanks && (r.tree.blanks.label = o.localize("blanks"));
                break;

              case "filterBuilder":
                r.localizeFilterBuilder(), "messages" === e && (r.filterBuilder._localizeInitialValues(), r.filterBuilder._refresh()), r.filterBuilder.$.scrollableContainer.refresh();
            }

            break;
          }
      }
    }
  }, {
    key: "_localize",
    value: function _localize() {
      var e = this;
      e.$.label.innerHTML = e.localize("showRows"), e.$.filterButton.innerHTML = e.localize("filter"), e.$.clearButton.innerHTML = e.localize("clear"), e.$.cancelButton.innerHTML = e.localize("cancel");
    }
  }, {
    key: "_setButtonsVisibility",
    value: function _setButtonsVisibility() {
      var e = this,
          t = e.buttons;
      ["cancel", "clear", "filter"].forEach(function (i) {
        -1 === t.indexOf(i) ? e["$" + i + "Button"].addClass("smart-hidden") : e["$" + i + "Button"].removeClass("smart-hidden");
      });
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        buttons: {
          value: ["clear", "filter"],
          type: "array"
        },
        data: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        dataField: {
          value: null,
          type: "string?"
        },
        dataSource: {
          value: null,
          type: "any",
          reflectToAttribute: !1
        },
        evaluateFilterExpression: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        filterType: {
          value: "string",
          allowedValues: ["numeric", "string", "date", "boolean"],
          type: "string"
        },
        formatString: {
          value: "d",
          type: "string"
        },
        messages: {
          value: {
            en: {
              addCondition: "Add Condition",
              addGroup: "Add Group",
              and: "and",
              blanks: "(Blanks)",
              cancel: "Cancel",
              clear: "Clear",
              contains: "contains",
              containsCaseSensitive: "contains (case sensitive)",
              dateTabLabel: "DATE",
              doesNotContain: "does not contain",
              doesNotContainCaseSensitive: "does not contain (case sensitive)",
              empty: "empty",
              endsWith: "ends with",
              endsWithCaseSensitive: "ends with (case sensitive)",
              equal: "equal",
              equalCaseSensitive: "equal (case sensitive)",
              filter: "Filter",
              filterBuilderPlaceholder: "&lt;enter a value&gt;",
              greaterThan: "greater than",
              greaterThanOrEqual: "greater than or equal",
              lessThan: "less than",
              lessThanOrEqual: "less than or equal",
              mismatchedProperties: "smartFilterPanel: The \"filterType\" and the data type of the selected \"dataField\" are mismatched.",
              missingProperty: "smartFilterPanel: When mode is 'excel', either \"data\" and \"dataField\" or \"dataSource\" of type Array have to be set.",
              notEmpty: "not empty",
              notEqual: "not equal",
              notNull: "not null",
              null: "null ",
              or: "or",
              placeholderDate: "Enter date",
              placeholderTime: "Enter time",
              selectAll: "(Select All)",
              showRows: "Show rows where:",
              startsWith: "starts with",
              startsWithCaseSensitive: "starts with (case sensitive)",
              timeTabLabel: "TIME"
            }
          },
          type: "object",
          extend: !0
        },
        mode: {
          value: "default",
          allowedValues: ["default", "excel", "filterBuilder"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "cancelButton.click": "cancel",
        "clearButton.click": "clear",
        "filterButton.click": "filter"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Button": "smart.button.js",
        "Smart.DateTimePicker": "smart.datetimepicker.js",
        "Smart.DropDownList": "smart.dropdownlist.js",
        "Smart.FilterBuilder": "smart.filterbuilder.js",
        "Smart.NumericTextBox": "smart.numerictextbox.js",
        "Smart.Tree": "smart.tree.js",
        "Smart.FilterGroup": "smart.filter.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.grid.css", "smart.dropdownlist.css", "smart.menu.css", "smart.filterpanel.css", "smart.textbox.css"];
    }
  }]);

  return _class85;
}(Smart.BaseElement)), Smart.Utilities.Assign("BaseFilterHandler",
/*#__PURE__*/
function () {
  "use strict";

  function _class86(e) {
    _classCallCheck(this, _class86);

    var t = this;

    if (t.context = e, t.filterObject = new Smart.Utilities.FilterGroup(), t.setDefaults(), "date" === e.filterType) {
      var _i813 = new Smart.Utilities.DateTime(),
          _a543 = e.formatString,
          _n396 = _i813.getParseRegExp(_i813.calendar, _a543.replace(/y+/g, "yyyyy"));

      t.displayMode = Smart.Utilities.DateTime.detectDisplayMode(_i813, _a543, _n396), t.timeOnly = "timePicker" === t.displayMode;
    }

    return "default" === e.mode ? void t.createDefaultHTMLStructure() : void (t.operationsMapping = {
      "=": "EQUAL",
      "<>": "NOT_EQUAL",
      "<": "LESS_THAN",
      ">": "GREATER_THAN",
      "<=": "LESS_THAN_OR_EQUAL",
      ">=": "GREATER_THAN_OR_EQUAL",
      isblank: "EMPTY",
      isnotblank: "NOT_EMPTY",
      contains: "CONTAINS",
      notcontains: "DOES_NOT_CONTAIN",
      startswith: "STARTS_WITH",
      endswith: "ENDS_WITH",
      NULL: "NULL",
      NOT_NULL: "NOT_NULL"
    }, "excel" === e.mode ? t.createExcelHTMLStructure() : "filterBuilder" === e.mode && t.createBuilderHTMLStructure());
  }

  _createClass(_class86, [{
    key: "setDefaults",
    value: function setDefaults() {
      var e = this,
          t = e.context;
      e.defaultListSource = [{
        value: "EQUAL",
        label: t.localize("equal")
      }, {
        value: "NOT_EQUAL",
        label: t.localize("notEqual")
      }, {
        value: "LESS_THAN",
        label: t.localize("lessThan")
      }, {
        value: "LESS_THAN_OR_EQUAL",
        label: t.localize("lessThanOrEqual")
      }, {
        value: "GREATER_THAN",
        label: t.localize("greaterThan")
      }, {
        value: "GREATER_THAN_OR_EQUAL",
        label: t.localize("greaterThanOrEqual")
      }, {
        value: "NULL",
        label: t.localize("null")
      }, {
        value: "NOT_NULL",
        label: t.localize("notNull")
      }], e.filterBuilderOperations = ["<", "=", "<>", "<=", ">", ">=", "NULL", "NOT_NULL"], e.defaultListSelection = 2;
    }
  }, {
    key: "createDefaultHTMLStructure",
    value: function createDefaultHTMLStructure() {
      var e = this,
          t = e.context,
          i = document.createElement("smart-drop-down-list"),
          a = document.createElement("smart-drop-down-list"),
          n = document.createElement("smart-drop-down-list"),
          o = document.createDocumentFragment();
      i.classList.add("smart-filter-panel-list"), i.dataSource = e.defaultListSource, i.selectedIndexes = [e.defaultListSelection], a.classList.add("smart-filter-panel-operator-list"), a.dataSource = [{
        value: 0,
        label: t.localize("and")
      }, {
        value: 1,
        label: t.localize("or")
      }], n.classList.add("smart-filter-panel-list"), n.dataSource = e.defaultListSource, n.selectedIndexes = [e.defaultListSelection], e.firstList = i, e.logicalOperatorList = a, e.secondList = n, e.appendInputs(), e.firstInput.classList.add("smart-filter-panel-input"), e.secondInput.classList.add("smart-filter-panel-input"), a.dropDownHeight = "auto", a.selectedIndexes = [0], [i, e.firstInput, a, n, e.secondInput].forEach(function (e) {
        e.animation = t.animation, e.disabled = t.disabled, e.unfocusable = t.unfocusable, e.dropDownPosition = "bottom", e.dropDownAppendTo = "body", e.dropDownMaxHeight = 200, e.dropDownWidth = "auto", o.appendChild(e);
      }), e.context.$.mainContainer.appendChild(o), e.cacheFilter(e.defaultListSelection, 0, e.defaultListSelection);
    }
  }, {
    key: "cacheFilter",
    value: function cacheFilter(e, t, i) {
      var a = this;
      a.cachedFilter = {
        firstFilterComparison: e,
        firstFilterValue: a.firstInput.value,
        logicalOperator: t,
        secondFilterComparison: i,
        secondFilterValue: a.secondInput.value
      };
    }
  }, {
    key: "defaultFilter",
    value: function defaultFilter() {
      var e = this,
          t = e.context,
          i = e.firstList.selectedValues[0],
          a = e.getFilterInputValue(e.firstInput),
          n = parseFloat(e.logicalOperatorList.selectedValues[0]),
          o = e.secondList.selectedValues[0],
          r = e.getFilterInputValue(e.secondInput),
          l = e.filterObject;

      if (l.clear(), "" !== a || -1 !== ["NULL", "NOT_NULL", "EMPTY", "NOT_EMPTY"].indexOf(i)) {
        var _o293 = l.createFilter(t._filterType, a, i, void 0, t.formatString, t.locale, "timePicker" === e.firstInput._dropDownDisplayMode);

        l.addFilter(n, _o293);
      }

      if ("" !== r || -1 !== ["NULL", "NOT_NULL", "EMPTY", "NOT_EMPTY"].indexOf(o)) {
        var _i814 = l.createFilter(t._filterType, r, o, void 0, t.formatString, t.locale, "timePicker" === e.secondInput._dropDownDisplayMode);

        l.addFilter(n, _i814);
      }

      e.cacheFilter(e.firstList.selectedIndexes[0], e.logicalOperatorList.selectedIndexes[0], e.secondList.selectedIndexes[0]);
    }
  }, {
    key: "getFilterInputValue",
    value: function getFilterInputValue(e) {
      return e.value;
    }
  }, {
    key: "excelFilter",
    value: function excelFilter() {
      var e = this,
          t = e.context;
      if (Array.isArray(t.dataSource)) return void e.customExcelFilter();
      var i = e.tree,
          a = e.filterObject;

      if (a.clear(), e.customItems = [], !i._menuItems[0].selected) {
        var _n397 = i.selectedIndexes;
        _n397.forEach(function (n) {
          var o = i._menuItems[n];

          if (o instanceof Smart.TreeItem) {
            var _i815 = o.value;

            if (o.hasAttribute("default-item")) {
              var _n398 = e.getExcelComparison(_i815),
                  _o294 = a.createFilter(t._filterType, _i815, _n398, void 0, t.formatString, t.locale, e.timeOnly);

              a.addFilter("or", _o294);
            } else e.customItems.push(o);
          }
        }), e.cachedFilter = _n397.slice(0);
      }
    }
  }, {
    key: "customExcelFilter",
    value: function customExcelFilter() {
      var e = this,
          t = e.tree;
      if (delete e.customExcelFilterObjects, t._menuItems[0].selected) return;
      var a = e.context,
          i = [],
          n = t.selectedIndexes;
      n.forEach(function (n) {
        var o = t._menuItems[n];

        if (o instanceof Smart.TreeItem) {
          var _t832 = o.value;
          if (!Array.isArray(_t832)) return;
          Array.isArray(_t832[0]) || (_t832 = [_t832]);

          var _n399 = new Smart.Utilities.FilterGroup();

          for (var _o295 = 0; _o295 < _t832.length; _o295++) {
            var _i816 = _t832[_o295],
                _r183 = e.operationsMapping[_i816[1]],
                _l125 = _n399.createFilter(a._filterType, _i816[2], _r183, void 0, a.formatString, a.locale, e.timeOnly);

            _n399.addFilter("and", _l125);
          }

          i.push(_n399);
        }
      }), e.customExcelFilterObjects = i, e.cachedFilter = n.slice(0);
    }
  }, {
    key: "getExcelComparison",
    value: function getExcelComparison(e) {
      return "" === e ? "NULL" : "EQUAL";
    }
  }, {
    key: "filterBuilderFilter",
    value: function filterBuilderFilter() {
      function e(n, i) {
        var o = new Smart.Utilities.FilterGroup(),
            r = n[1];
        i.logicalOperator = r;

        for (var _l126 = 0; _l126 < n.length; _l126++) {
          if (1 == _l126) continue;
          var _s89 = n[_l126];
          if (Array.isArray(_s89)) if (Array.isArray(_s89[0])) {
            var _t833 = {
              filters: []
            };
            i.filters.push(_t833), e(_s89, _t833);
          } else o.addFilter(r, t.createFilterBuilderFilter(o, _s89, a));
        }

        0 < o.filters.length && i.filters.push(o);
      }

      var t = this,
          i = t.filterBuilder.value,
          a = !("string" !== t.context.filterType) && t.caseSensitive.checked,
          n = {
        filters: []
      };
      e(i, n), t.filterBuilderObject = n, t.cachedFilter = {
        filterBuilder: JSON.parse(JSON.stringify(t.filterBuilder.value), function (e, t) {
          return /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).(\d{3})Z$/.test(t) ? new Date(t) : t;
        }),
        caseSensitive: a
      };
    }
  }, {
    key: "createFilterBuilderFilter",
    value: function createFilterBuilderFilter(e, t, i) {
      var a = this,
          n = a.context;
      var o = a.operationsMapping[t[1]];
      return i && -1 !== ["CONTAINS", "DOES_NOT_CONTAIN", "STARTS_WITH", "ENDS_WITH", "EQUAL"].indexOf(o) && (o += "_CASE_SENSITIVE"), e.createFilter(n._filterType, t[2], o, void 0, n.formatString, n.locale, !1);
    }
  }, {
    key: "defaultClear",
    value: function defaultClear() {
      var e = this;
      e.firstList.selectedIndexes = [e.defaultListSelection], e.firstInput.value = "", e.logicalOperatorList.selectedIndexes = [0], e.secondList.selectedIndexes = [e.defaultListSelection], e.secondInput.value = "", e.filterObject.clear(), e.cacheFilter(e.defaultListSelection, 0, e.defaultListSelection);
    }
  }, {
    key: "excelClear",
    value: function excelClear() {
      var e = this;
      e.tree.select("0"), e.filterObject.clear(), e.cachedFilter = e.tree.selectedIndexes.slice(0);
    }
  }, {
    key: "filterBuilderClear",
    value: function filterBuilderClear() {
      var e = this;
      e.filterBuilder.value = ["and"], "string" === e.context.filterType && (e.caseSensitive.checked = !1), e.cachedFilter = {
        filterBuilder: ["and"],
        caseSensitive: !1
      };
    }
  }, {
    key: "defaultCancel",
    value: function defaultCancel() {
      var e = this;
      e.firstList.selectedIndexes = [e.cachedFilter.firstFilterComparison], e.firstInput.value = e.cachedFilter.firstFilterValue, e.logicalOperatorList.selectedIndexes = [e.cachedFilter.logicalOperator], e.secondList.selectedIndexes = [e.cachedFilter.secondFilterComparison], e.secondInput.value = e.cachedFilter.secondFilterValue;
    }
  }, {
    key: "excelCancel",
    value: function excelCancel() {
      var e = this;
      e.tree.selectedIndexes = e.cachedFilter.slice(0);
    }
  }, {
    key: "filterBuilderCancel",
    value: function filterBuilderCancel() {
      var e = this;
      e.filterBuilder.value = e.cachedFilter.filterBuilder, "string" === e.context.filterType && (e.caseSensitive.checked = e.cachedFilter.caseSensitive);
    }
  }, {
    key: "createExcelHTMLStructure",
    value: function createExcelHTMLStructure() {
      var e = this,
          t = e.context,
          i = document.createElement("smart-tree"),
          a = {
        data: t.data,
        dataField: t.dataField,
        filterType: t._filterType
      };

      if (!t.dataSource || !Array.isArray(t.dataSource)) {
        if (t.data && t.dataField || t.error(t.localize("missingProperty")), "date" === t.filterType) {
          a.formatString = t.formatString, a.displayMode = e.displayMode, e.dataSource = e.filterObject.getUniqueValues(a, t);

          try {
            e.getHierarchicalDataSource(e.displayMode);
          } catch (e) {
            t.error(t.localize("mismatchedProperties"));
          }

          e.timeOnly ? i.classList.add("standard-excel") : i.classList.add("date-excel");
        } else e.dataSource = e.filterObject.getUniqueValues(a, t), i.classList.add("standard-excel");

        "function" == typeof t.dataSource && (e.dataSource = t.dataSource(e.dataSource) || e.dataSource);
      } else e.processCustomDataSource(i);

      i.animation = t.animation, i.disabled = t.disabled, i.unfocusable = t.unfocusable, i.dataSource = [{
        label: t.localize("selectAll"),
        value: "",
        items: e.dataSource,
        expanded: !0,
        selected: !0
      }], i.selectionMode = "checkBox", i.hasThreeStates = !0, i.toggleMode = "arrow", i.addEventListener("collapsing", function (e) {
        1 === e.detail.item.level && e.preventDefault();
      }), i._onCompleted = function () {
        if (e.cachedFilter = i.selectedIndexes.slice(0), i.classList.contains("date-excel")) for (var _e984 in i._menuItems) {
          if ("0" == _e984) continue;
          var _t834 = i._menuItems[_e984];
          _t834.firstElementChild.style.paddingLeft = 20 * (_t834.level - 1) - 10 + "px";
        } else i._menuItems[0].firstElementChild.style.paddingLeft = 0;
        i.selectAll = i._menuItems[0], i.blanks = i.querySelector("[label=\"" + t.localize("blanks") + "\"]");
      }, e.tree = i, t.$.mainContainer.appendChild(i);
    }
  }, {
    key: "processCustomDataSource",
    value: function processCustomDataSource(e) {
      var t = this,
          i = t.context,
          a = i.dataSource;
      e.classList.add("standard-excel"), t.dataSource = a;
    }
  }, {
    key: "createBuilderHTMLStructure",
    value: function createBuilderHTMLStructure() {
      var e = this,
          t = e.context,
          i = document.createElement("smart-filter-builder"),
          a = t.dataField,
          n = "numeric" === t.filterType ? "number" : t.filterType;

      if (e.filterBuilder = i, i.animation = t.animation, i.disabled = t.disabled, i.unfocusable = t.unfocusable, i.value = ["and"], i.fields = [{
        label: a,
        dataField: a,
        dataType: n,
        filterOperations: e.filterBuilderOperations
      }], e.localizeFilterBuilder(), t.$.mainContainer.appendChild(i), "string" === n) {
        var _i817 = document.createElement("smart-check-box");

        _i817.classList.add("case-sensitive"), _i817.innerHTML = "Case sensitive", _i817.animation = t.animation, _i817.disabled = t.disabled, _i817.unfocusable = t.unfocusable, _i817.checked = !1, e.caseSensitive = _i817, t.$.mainContainer.appendChild(_i817);
      }

      e.filterBuilderObject = {
        filters: []
      }, e.cachedFilter = {
        filterBuilder: ["and"],
        caseSensitive: !1
      };
    }
  }, {
    key: "localizeFilterBuilder",
    value: function localizeFilterBuilder() {
      var e = this,
          t = e.context,
          i = e.filterBuilder;
      var a = i.messages[t.locale];
      a || (a = {}, i.messages[t.locale] = a), i.customOperations = [{
        name: "NULL",
        label: t.localize("null"),
        hideValue: !0
      }, {
        name: "NOT_NULL",
        label: t.localize("notNull"),
        hideValue: !0
      }], a.addCondition = t.localize("addCondition"), a.addGroup = t.localize("addGroup"), a["<"] = t.localize("lessThan"), a["<="] = t.localize("lessThanOrEqual"), a["<>"] = t.localize("notEqual"), a["="] = t.localize("equal"), a[">"] = t.localize("greaterThan"), a[">="] = t.localize("greaterThanOrEqual"), a.and = t.localize("and"), a.contains = t.localize("contains"), a.endswith = t.localize("endsWith"), a.isblank = t.localize("empty"), a.isnotblank = t.localize("notEmpty"), a.notcontains = t.localize("doesNotContain"), a.or = t.localize("or"), a.startswith = t.localize("startsWith"), a.dateTabLabel = t.localize("dateTabLabel"), a.timeTabLabel = t.localize("timeTabLabel"), i.formatStringDate = t.formatString, i.formatStringDateTime = t.formatString, i.locale = t.locale, i.valuePlaceholder = t.localize("filterBuilderPlaceholder");
    }
  }, {
    key: "evaluate",
    value: function evaluate(e) {
      function t(a) {
        var n = !("and" !== a.logicalOperator);

        for (var _o296 = 0; _o296 < a.filters.length; _o296++) {
          var _i818 = void 0;

          _i818 = a.filters[_o296] instanceof Smart.Utilities.FilterGroup ? a.filters[_o296].evaluate(e) : t(a.filters[_o296]), n = "and" === a.logicalOperator ? n && _i818 : n || _i818;
        }

        return n;
      }

      var a = this,
          n = a.context;
      if ("default" === n.mode) return a.filterObject.evaluate(e);

      if ("excel" === n.mode) {
        var _t835 = !1;

        if (Array.isArray(n.dataSource)) {
          if (!a.customExcelFilterObjects || 0 === a.customExcelFilterObjects.length) return !0;

          for (var _n400 = 0; _n400 < a.customExcelFilterObjects.length; _n400++) {
            _t835 = _t835 || a.customExcelFilterObjects[_n400].evaluate(e);
          }

          return _t835;
        }

        if (!(a.customItems && 0 < a.customItems.length)) _t835 = a.filterObject.evaluate(e);else if (0 < a.filterObject.filters.length && (_t835 = a.filterObject.evaluate(e)), a.customItems && n.evaluateFilterExpression) for (var _o297 = 0; _o297 < a.customItems.length; _o297++) {
          var _i819 = n.evaluateFilterExpression(e, a.customItems[_o297].value);

          void 0 !== _i819 && (_t835 = _t835 || _i819);
        }
        return _t835;
      }

      return !a.filterBuilderObject.logicalOperator || t(a.filterBuilderObject);
    }
  }]);

  return _class86;
}()), Smart.Utilities.Assign("NumericFilterHandler",
/*#__PURE__*/
function (_Smart$Utilities$Base4) {
  "use strict";

  _inherits(_class87, _Smart$Utilities$Base4);

  function _class87() {
    _classCallCheck(this, _class87);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class87).apply(this, arguments));
  }

  _createClass(_class87, [{
    key: "appendInputs",
    value: function appendInputs() {
      var e = this,
          t = document.createElement("smart-numeric-text-box"),
          i = document.createElement("smart-numeric-text-box");
      t.inputFormat = "floatingPoint", t.nullable = !0, t.spinButtons = !0, t.value = null, i.inputFormat = "floatingPoint", i.nullable = !0, i.spinButtons = !0, i.value = null, e.firstInput = t, e.secondInput = i;
    }
  }, {
    key: "getFilterInputValue",
    value: function getFilterInputValue(e) {
      return null === e.value || "" === e.value ? "" : parseFloat(e.value);
    }
  }]);

  return _class87;
}(Smart.Utilities.BaseFilterHandler)), Smart.Utilities.Assign("StringFilterHandler",
/*#__PURE__*/
function (_Smart$Utilities$Base5) {
  "use strict";

  _inherits(_class88, _Smart$Utilities$Base5);

  function _class88() {
    _classCallCheck(this, _class88);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class88).apply(this, arguments));
  }

  _createClass(_class88, [{
    key: "setDefaults",
    value: function setDefaults() {
      var e = this,
          t = e.context;
      e.defaultListSource = [{
        value: "EMPTY",
        label: t.localize("empty")
      }, {
        value: "NOT_EMPTY",
        label: t.localize("notEmpty")
      }, {
        value: "CONTAINS",
        label: t.localize("contains")
      }, {
        value: "CONTAINS_CASE_SENSITIVE",
        label: t.localize("containsCaseSensitive")
      }, {
        value: "DOES_NOT_CONTAIN",
        label: t.localize("doesNotContain")
      }, {
        value: "DOES_NOT_CONTAIN_CASE_SENSITIVE",
        label: t.localize("doesNotContainCaseSensitive")
      }, {
        value: "STARTS_WITH",
        label: t.localize("startsWith")
      }, {
        value: "STARTS_WITH_CASE_SENSITIVE",
        label: t.localize("startsWithCaseSensitive")
      }, {
        value: "ENDS_WITH",
        label: t.localize("endsWith")
      }, {
        value: "ENDS_WITH_CASE_SENSITIVE",
        label: t.localize("endsWithCaseSensitive")
      }, {
        value: "EQUAL",
        label: t.localize("equal")
      }, {
        value: "EQUAL_CASE_SENSITIVE",
        label: t.localize("equalCaseSensitive")
      }, {
        value: "NULL",
        label: t.localize("null")
      }, {
        value: "NOT_NULL",
        label: t.localize("notNull")
      }], e.filterBuilderOperations = ["contains", "isblank", "isnotblank", "notcontains", "startswith", "endswith", "=", "NULL", "NOT_NULL"], e.defaultListSelection = 2;
    }
  }, {
    key: "appendInputs",
    value: function appendInputs() {
      var e = this,
          t = document.createElement("input"),
          i = document.createElement("input");
      t.classList.add("smart-input"), i.classList.add("smart-input"), e.firstInput = t, e.secondInput = i;
    }
  }, {
    key: "getExcelComparison",
    value: function getExcelComparison(e) {
      return "" === e ? "EMPTY" : "EQUAL_CASE_SENSITIVE";
    }
  }]);

  return _class88;
}(Smart.Utilities.BaseFilterHandler)), Smart.Utilities.Assign("DateFilterHandler",
/*#__PURE__*/
function (_Smart$Utilities$Base6) {
  "use strict";

  _inherits(_class89, _Smart$Utilities$Base6);

  function _class89() {
    _classCallCheck(this, _class89);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class89).apply(this, arguments));
  }

  _createClass(_class89, [{
    key: "appendInputs",
    value: function appendInputs() {
      var e = this,
          t = e.context,
          i = document.createElement("smart-date-time-picker"),
          a = document.createElement("smart-date-time-picker");
      i.calendarButton = !0, i.editMode = "partial", i.formatString = t.formatString, i.dropDownDisplayMode = "auto", i.locale = t.locale, i.messages[t.locale] || (i.messages[t.locale] = {}), i.messages[t.locale].dateTabLabel = t.localize("dateTabLabel"), i.messages[t.locale].timeTabLabel = t.localize("timeTabLabel"), i.nullable = !0, i.value = null, a.calendarButton = !0, a.editMode = "partial", a.formatString = t.formatString, a.dropDownDisplayMode = "auto", a.locale = t.locale, a.messages[t.locale] || (a.messages[t.locale] = {}), a.messages[t.locale].dateTabLabel = t.localize("dateTabLabel"), a.messages[t.locale].timeTabLabel = t.localize("timeTabLabel"), a.nullable = !0, a.value = null, a._onCompleted = function () {
        "timePicker" === a._dropDownDisplayMode ? (i.placeholder = t.localize("placeholderTime"), i.placeholder = t.localize("placeholderTime")) : (i.placeholder = t.localize("placeholderDate"), i.placeholder = t.localize("placeholderDate"));
      }, e.firstInput = i, e.secondInput = a;
    }
  }, {
    key: "getFilterInputValue",
    value: function getFilterInputValue(e) {
      if (null === e.value) return "";
      var t = e.value.toDate();
      return "calendar" === this.displayMode && t.setHours(0, 0, 0), t;
    }
  }, {
    key: "defaultClear",
    value: function defaultClear() {
      var e = this;
      e.firstList.selectedIndexes = [e.defaultListSelection], e.firstInput.value = null, e.logicalOperatorList.selectedIndexes = [0], e.secondList.selectedIndexes = [e.defaultListSelection], e.secondInput.value = null, e.filterObject.clear(), e.cacheFilter(e.defaultListSelection, 0, e.defaultListSelection);
    }
  }, {
    key: "getHierarchicalDataSource",
    value: function getHierarchicalDataSource(e) {
      var t = this,
          i = t.dataSource,
          a = {},
          n = [];
      var o;

      if ("timePicker" !== e) {
        for (var _r184 in "" === i[i.length - 1].value && (o = i[i.length - 1], i.pop()), i.forEach(function (i) {
          var n = i.value,
              o = n.getFullYear(),
              r = new Intl.DateTimeFormat(t.context.locale, {
            month: "long"
          }).format(n),
              l = n.getDate();

          if (a[o] || (a[o] = {}), a[o][r] || (a[o][r] = {}), !a[o][r][l]) {
            if ("calendar" === e) return void (a[o][r][l] = n);
            a[o][r][l] = {};
          }

          if ("calendar" !== e) {
            var _e985 = n.getHours(),
                _t837 = n.getMinutes(),
                _i820 = n.getSeconds();

            a[o][r][l][_e985] || (a[o][r][l][_e985] = {}), a[o][r][l][_e985][_t837] || (a[o][r][l][_e985][_t837] = {}), a[o][r][l][_e985][_t837][_i820] || (a[o][r][l][_e985][_t837][_i820] = n);
          }
        }), a) {
          var _t836 = {
            label: _r184,
            items: [],
            customAttribute: "default-item"
          };

          for (var _i821 in n.push(_t836), a[_r184]) {
            var _n401 = {
              label: _i821,
              items: [],
              customAttribute: "default-item"
            };

            for (var _o298 in _t836.items.push(_n401), a[_r184][_i821]) {
              var _t838 = {
                label: _o298,
                customAttribute: "default-item"
              };

              if (_n401.items.push(_t838), "calendar" === e) {
                _t838.value = a[_r184][_i821][_o298];
                continue;
              }

              for (var _e986 in _t838.items = [], a[_r184][_i821][_o298]) {
                var _n402 = {
                  label: "0".repeat(2 - _e986.length) + _e986,
                  items: [],
                  customAttribute: "default-item"
                };

                for (var _l127 in _t838.items.push(_n402), a[_r184][_i821][_o298][_e986]) {
                  var _t839 = {
                    label: ":" + "0".repeat(2 - _l127.length) + _l127,
                    items: [],
                    customAttribute: "default-item"
                  };

                  for (var _s90 in _n402.items.push(_t839), a[_r184][_i821][_o298][_e986][_l127]) {
                    var _n403 = {
                      label: ":" + "0".repeat(2 - _s90.length) + _s90,
                      value: a[_r184][_i821][_o298][_e986][_l127][_s90],
                      customAttribute: "default-item"
                    };

                    _t839.items.push(_n403);
                  }
                }
              }
            }
          }
        }

        o && n.push(o), t.dataSource = n;
      }
    }
  }]);

  return _class89;
}(Smart.Utilities.BaseFilterHandler)), Smart.Utilities.Assign("BooleanFilterHandler",
/*#__PURE__*/
function (_Smart$Utilities$Base7) {
  "use strict";

  _inherits(_class90, _Smart$Utilities$Base7);

  function _class90() {
    _classCallCheck(this, _class90);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class90).apply(this, arguments));
  }

  _createClass(_class90, [{
    key: "cacheFilter",
    value: function cacheFilter(e, t, i) {
      var a = this;
      a.cachedFilter = {
        firstFilterComparison: e,
        firstFilterValue: a.firstInput.selectedIndexes.slice(0),
        logicalOperator: t,
        secondFilterComparison: i,
        secondFilterValue: a.secondInput.selectedIndexes.slice(0)
      };
    }
  }, {
    key: "setDefaults",
    value: function setDefaults() {
      var e = this,
          t = e.context;
      e.defaultListSource = [{
        value: "EQUAL",
        label: t.localize("equal")
      }, {
        value: "NOT_EQUAL",
        label: t.localize("notEqual")
      }, {
        value: "NULL",
        label: t.localize("null")
      }, {
        value: "NOT_NULL",
        label: t.localize("notNull")
      }], e.filterBuilderOperations = ["=", "<>", "NULL", "NOT_NULL"], e.defaultListSelection = 0;
    }
  }, {
    key: "appendInputs",
    value: function appendInputs() {
      var e = this,
          t = document.createElement("smart-drop-down-list"),
          i = document.createElement("smart-drop-down-list");
      t.dataSource = [{
        value: !0,
        label: "true"
      }, {
        value: !1,
        label: "false"
      }], t.selectedIndexes = [], t.selectionMode = "zeroOrOne", i.dataSource = [{
        value: !0,
        label: "true"
      }, {
        value: !1,
        label: "false"
      }], i.selectedIndexes = [], i.selectionMode = "zeroOrOne", e.firstInput = t, e.secondInput = i;
    }
  }, {
    key: "getFilterInputValue",
    value: function getFilterInputValue(e) {
      return 0 === e.selectedValues.length ? "" : "true" === e.selectedValues[0];
    }
  }, {
    key: "defaultClear",
    value: function defaultClear() {
      var e = this;
      e.firstList.selectedIndexes = [e.defaultListSelection], e.firstInput.selectedIndexes = [], e.logicalOperatorList.selectedIndexes = [0], e.secondList.selectedIndexes = [e.defaultListSelection], e.secondInput.selectedIndexes = [], e.filterObject.clear(), e.cacheFilter(e.defaultListSelection, 0, e.defaultListSelection);
    }
  }, {
    key: "defaultCancel",
    value: function defaultCancel() {
      var e = this;
      e.firstList.selectedIndexes = [e.cachedFilter.firstFilterComparison], e.firstInput.selectedIndexes = e.cachedFilter.firstFilterValue, e.logicalOperatorList.selectedIndexes = [e.cachedFilter.logicalOperator], e.secondList.selectedIndexes = [e.cachedFilter.secondFilterComparison], e.secondInput.selectedIndexes = e.cachedFilter.secondFilterValue;
    }
  }]);

  return _class90;
}(Smart.Utilities.BaseFilterHandler)), Smart("smart-list-item",
/*#__PURE__*/
function (_Smart$ContentElement9) {
  "use strict";

  _inherits(_class91, _Smart$ContentElement9);

  function _class91() {
    _classCallCheck(this, _class91);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class91).apply(this, arguments));
  }

  _createClass(_class91, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                   <span id='itemInput' class='smart-input smart-hidden'></span>\n                    <span class=\"smart-overlay\" id=\"overlay\"></span>\n                    <div id=\"itemContainer\" class=\"smart-content smart-list-item-container\"><span class=\"smart-content-label\" inner-h-t-m-l='[[innerHTML]]' role=\"presentation\"><content></content></span><span inner-h-t-m-l='[[details]]' id=\"details\" class=\"smart-content-details\"></span></div>\n                </div>";
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted || e.classList.contains("smart-ripple")) {
        var _e987 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e987.concat(Array.prototype.slice.call(arguments)));
      }

      t.$.itemContainer.innerHTML = "", e instanceof HTMLElement && t.$.itemContainer.appendChild(e);
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      var i = this;

      if (!i.isCompleted) {
        var _e988 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(i, _e988.concat(Array.prototype.slice.call(arguments)));
      }

      t.parentNode.insertBefore(e, t);
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted || e.classList.contains("smart-ripple")) {
        var _e989 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e989.concat(Array.prototype.slice.call(arguments)));
      }

      e instanceof HTMLElement && t.$.itemContainer.removeChild(e);
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;
      _get(_getPrototypeOf(_class91.prototype), "attached", this).call(this), e.ownerListBox = e.getListBox();
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class91.prototype), "ready", this).call(this);

      var e = this;
      e.setAttribute("role", "option"), "" === e.label ? "" !== e.innerHTML && (e.label = e.innerHTML) : e.innerHTML = e.label, e._setDisplayMode(e.displayMode), e._setItemColor(), e.$.container.noRipple = !0;
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;
      if (_get(_getPrototypeOf(_class91.prototype), "propertyChangedHandler", this).call(this, e, t, i), "hidden" === e) i ? a.$.addClass("smart-hidden") : a.$.removeClass("smart-hidden");else if ("color" === e) a._setItemColor();else if ("displayMode" === e) a._setDisplayMode(i);else if ("label" === e || "value" === e) {
        var _t840 = a.context;
        a.context = document, "label" === e && (a.innerHTML = i);

        var _n404 = a.getListBox();

        _n404._applyTemplate(a), _n404.onItemUpdated(a), a.context = _t840;
      } else if ("details" === e) {
        var _e990 = a.context;
        a.context = document, a.$.details.innerHTML = i;

        var _t841 = a.getListBox();

        _t841.onItemUpdated(a), a.context = _e990;
      } else if ("innerHTML" === e) {
        var _e991 = a.getListBox();

        _e991.onItemUpdated(a);
      } else "selected" === e && (i ? a.setAttribute("aria-selected", !0) : a.readonly || a.disabled || -1 === ["oneOrManyExtended", "zeroOrMany", "oneOrMany", "checkBox"].indexOf(a.getListBox().selectionMode) ? a.removeAttribute("aria-selected") : a.setAttribute("aria-selected", !1));
    }
  }, {
    key: "getListBox",
    value: function getListBox() {
      var e = this;
      var t = e.parentNode;

      for (; !1 == t instanceof Smart.ListBox && null !== t;) {
        t = t.parentNode;
      }

      return !t && Smart.EnableShadowDOM ? e.getRootNode().host : t;
    }
  }, {
    key: "_itemOnMouseEnter",
    value: function _itemOnMouseEnter() {
      var e = this;
      !e.disabled && e.ownerListBox && (Smart.ListBox.DragDrop.Dragging && e.ownerListBox.allowDrop && (Smart.ListBox.DragDrop.DropDetails = {
        item: e,
        position: "bottom"
      }), e.ownerListBox.$.verticalScrollBar.thumbCapture || e.ownerListBox.$.horizontalScrollBar.thumbCapture || e.setAttribute("hover", ""));
    }
  }, {
    key: "_itemOnMouseMove",
    value: function _itemOnMouseMove(e) {
      var t = this;

      if (t.ownerListBox && Smart.ListBox.DragDrop.Dragging && t.ownerListBox.allowDrop && !Smart.Utilities.Core.isMobile) {
        var _a544 = [].slice.call(t.ownerListBox.getElementsByClassName("smart-list-item-bottom-line-feedback"));

        for (var _e992 = 0; _e992 < _a544.length; _e992++) {
          _a544[_e992].$.removeClass("smart-list-item-line-feedback"), _a544[_e992].$.removeClass("smart-list-item-bottom-line-feedback");
        }

        if (Smart.ListBox.DragDrop.DropDetails = {
          item: t,
          position: "top"
        }, !t.ownerListBox._areCSSVarsSupported) {
          if (t.ownerListBox._indexOf(t) === t.ownerListBox._items.length - 1 || t.parentNode.lastElementChild === t) {
            var _i823 = t.getBoundingClientRect();

            e.pageY - window.pageYOffset > _i823.top + _i823.height / 2 - 1 && (Smart.ListBox.DragDrop.DropDetails = {
              item: t,
              position: "bottom"
            });
          }

          return;
        }

        if (t.$.removeClass("smart-list-item-line-feedback"), t.$.removeClass("smart-list-item-bottom-line-feedback"), t.ownerListBox.sorted && t.ownerListBox.autoSort) return;

        var _i822 = t.ownerListBox._items.filter(function (e) {
          return !e.hidden;
        });

        if (_i822.indexOf(t) === _i822.length - 1 || t.parentNode.lastElementChild === t) {
          var _i824 = t.getBoundingClientRect();

          e.pageY - window.pageYOffset > _i824.top + _i824.height / 2 - 1 ? (t.$.addClass("smart-list-item-bottom-line-feedback"), Smart.ListBox.DragDrop.DropDetails = {
            item: t,
            position: "bottom"
          }) : !arguments[1] && t.$.addClass("smart-list-item-line-feedback");
        } else arguments[1] || t.$.addClass("smart-list-item-line-feedback");
      }
    }
  }, {
    key: "_itemOnMouseLeave",
    value: function _itemOnMouseLeave() {
      var e = this;
      e.ownerListBox && (Smart.ListBox.DragDrop.Dragging && (e.$.removeClass("smart-list-item-line-feedback"), e.$.removeClass("smart-list-item-bottom-line-feedback")), e.removeAttribute("hover"));
    }
  }, {
    key: "_setDisplayMode",
    value: function _setDisplayMode(e) {
      var t = this,
          i = t.getListBox();

      if (i) {
        var _a545 = "checkBox" === i.selectionMode || "radioButton" === i.selectionMode ? i.selectionMode : "plain";

        t.displayMode = e = _a545;
      }

      return "plain" === e ? void t.$itemInput.addClass("smart-hidden") : void t.$itemInput.removeClass("smart-hidden");
    }
  }, {
    key: "_setItemColor",
    value: function _setItemColor() {
      var e = this,
          t = e.querySelector(".smart-content-label"),
          i = /(^#[0-9A-F]{3}$)|(^#[0-9A-F]{6}$)|(^#[0-9A-F]{8}$)/i.test(e.color) ? e.color : "";
      t.style.backgroundColor = i, t.style.color = e._getContrastColor(i);
    }
  }, {
    key: "_getContrastColor",
    value: function _getContrastColor(e) {
      if (!e) return "";

      var t = function (t, i, e) {
        return [parseInt(t, 16), parseInt(i, 16), parseInt(e, 16)];
      }(e.slice(1, 3), e.slice(3, 5), e.slice(5, 7)),
          i = (.299 * t[0] + .61 * t[1] + .114 * t[2]) / 255;

      return .65 < parseFloat(i.toFixed(2)) ? "#000000" : "#FFFFFF";
    }
  }, {
    key: "hasStyleObserver",
    get: function get() {
      return !1;
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }, {
    key: "_focused",
    get: function get() {
      var e = this;
      return void 0 === e.__focused && (e.__focused = !1), e.__focused;
    },
    set: function set(e) {
      var t = this;
      t.__focused = e, e ? t.setAttribute("focus", "") : t.removeAttribute("focus");
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        alternationIndex: {
          value: -1,
          type: "int"
        },
        color: {
          value: "",
          type: "string"
        },
        displayMode: {
          allowedValues: ["plain", "checkBox", "radioButton"],
          value: "plain",
          type: "string"
        },
        grouped: {
          value: !1,
          type: "boolean"
        },
        selected: {
          value: !1,
          type: "boolean"
        },
        value: {
          value: "",
          type: "string"
        },
        label: {
          value: "",
          type: "string"
        },
        details: {
          value: "",
          type: "string"
        },
        group: {
          value: "",
          type: "string"
        },
        hidden: {
          value: !1,
          type: "boolean"
        },
        readonly: {
          value: !1,
          type: "boolean"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        mouseenter: "_itemOnMouseEnter",
        mouseleave: "_itemOnMouseLeave"
      };
    }
  }]);

  return _class91;
}(Smart.ContentElement)), Smart("smart-list-items-group",
/*#__PURE__*/
function (_Smart$ContentElement10) {
  "use strict";

  _inherits(_class92, _Smart$ContentElement10);

  function _class92() {
    _classCallCheck(this, _class92);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class92).apply(this, arguments));
  }

  _createClass(_class92, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                 <span id=\"itemsLabel\" class=\"smart-list-items-group-label\">[[label]]</span>\n                 <div id=\"listItemsGroupContainer\" inner-h-t-m-l='[[innerHTML]]' class=\"smart-list-items-group-container\" role=\"presentation\">\n                    <content></content>\n                 </div>\n               </div>";
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e993 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e993.concat(Array.prototype.slice.call(arguments)));
      }

      e instanceof HTMLElement && t.$.listItemsGroupContainer.appendChild(e);
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e994 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e994.concat(Array.prototype.slice.call(arguments)));
      }

      e instanceof HTMLElement && t.$.listItemsGroupContainer.removeChild(e);
    }
  }, {
    key: "getListBox",
    value: function getListBox() {
      var e = this;
      var t = e.parentNode;

      for (; !1 == t instanceof Smart.ListBox && null !== t;) {
        t = t.parentNode;
      }

      return t;
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;
      _get(_getPrototypeOf(_class92.prototype), "attached", this).call(this), e.ownerListBox || (e.ownerListBox = e.getListBox()), e.setAttribute("role", "group"), e.$.itemsLabel.id || (e.$.itemsLabel.id = e.id + "Label"), e.setAttribute("aria-labelledby", e.$.itemsLabel.id);
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        label: {
          value: "",
          type: "string"
        }
      };
    }
  }]);

  return _class92;
}(Smart.ContentElement)), Smart("smart-list-box",
/*#__PURE__*/
function (_Smart$ScrollViewer2) {
  "use strict";

  _inherits(_class93, _Smart$ScrollViewer2);

  function _class93() {
    _classCallCheck(this, _class93);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class93).apply(this, arguments));
  }

  _createClass(_class93, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" class=\"smart-container\" role=\"presentation\">\n                    <div class=\"smart-list-box-filter-input-container smart-hidden\" id=\"filterInputContainer\" role=\"presentation\">\n                        <input id=\"filterInput\" disabled=\"[[disabled]]\" placeholder='[[filterInputPlaceholder]]' role=\"searchbox\" aria-label=\"ListBox filter input\" aria-placeholder=\"[[filterInputPlaceholder]]\">\n                    </div>\n                    <div id=\"itemsContainer\" class=\"smart-list-items-container\" role=\"presentation\">\n                        <div id=\"placeholder\" class=\"smart-placeholder\" role=\"presentation\" aria-hidden=\"true\">[[placeholder]]</div>\n                        <div id=\"itemsInnerContainer\" inner-h-t-m-l='[[innerHTML]]' class=\"smart-list-items-inner-container\" role=\"presentation\">\n                            <content></content>\n                        </div>\n                        <input type=\"text\" id=\"editInput\" class= \"smart-hidden\"/>\n                    </div>\n                    <smart-scroll-bar wait right-to-left=\"[[rightToLeft]]\" id=\"verticalScrollBar\" disabled=\"[[disabled]]\" orientation=\"vertical\"></smart-scroll-bar>\n                    <smart-scroll-bar wait right-to-left=\"[[rightToLeft]]\" id=\"horizontalScrollBar\" disabled=\"[[disabled]]\"></smart-scroll-bar>\n                    <div id=\"loadingIndicatorContainer\" class=\"smart-loader-container\" role=\"presentation\">\n                        <span id=\"loadingIndicator\" class=\"smart-loader\" role=\"img\" aria-label=\"[[loadingIndicatorPlaceholder]]\"></span>\n                        <span id=\"loadingIndicatorPlaceHolder\" class=\"smart-loader-label smart-hidden\">[[loadingIndicatorPlaceholder]]</span>\n                    </div>\n                    <input id=\"hiddenInput\" type=\"hidden\" name=\"[[name]]\">\n                </div>";
    }
  }, {
    key: "_mouseLeaveHandler",
    value: function _mouseLeaveHandler() {
      var e = this,
          t = [].slice.call(e.getElementsByClassName("smart-list-item-bottom-line-feedback"));

      for (var _e995 = 0; _e995 < t.length; _e995++) {
        t[_e995].$.removeClass("smart-list-item-line-feedback"), t[_e995].$.removeClass("smart-list-item-bottom-line-feedback");
      }
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;
      if (t.disabled || t.displayLoadingIndicator || t.readonly) return;
      var i = e.originalEvent.target,
          a = null;
      if (i instanceof Smart.ListItem && !i.disabled && !i.hidden && !(i instanceof Smart.ListItemsGroup)) a = i.dataItem;else for (; i.parentElement;) {
        if (i instanceof Smart.ListItem && !i.disabled && !i.hidden && !(i instanceof Smart.ListItemsGroup)) {
          a = i.dataItem;
          break;
        }

        i = i.parentElement;
      }
      Smart.ListBox.DragDrop.StartTime = new Date(), Smart.ListBox.DragDrop.StartPosition = {
        left: e.pageX,
        top: e.pageY
      };
      a && (e.stopPropagation(), t.hasRippleAnimation && !a.readonly && !a.disabled && Smart.Utilities.Animation.Ripple.animate(i.$.overlay, e.pageX, e.pageY), !Smart.Utilities.Core.isMobile && "press" === t.selectionChangeAction && (t._focus(a), t.select(a)), !Smart.ListBox.DragDrop.Feedback && t.allowDrag && (Smart.ListBox.DragDrop.DraggedFrom = t, Smart.ListBox.DragDrop.Feedback = document.createElement("span"), t.rightToLeft ? Smart.ListBox.DragDrop.Feedback.setAttribute("right-to-left", !0) : Smart.ListBox.DragDrop.Feedback.removeAttribute("right-to-left"), t.dragFeedbackFormatFunction ? Smart.ListBox.DragDrop.Feedback.innerHTML = t.dragFeedbackFormatFunction(a) : Smart.ListBox.DragDrop.Feedback.appendChild(a.offsetHeight ? a.cloneNode(!0) : t._createItem(a)), Smart.ListBox.DragDrop.Item = a, Smart.Utilities.Extend(Smart.ListBox.DragDrop.Feedback).addClass("smart-popup smart-list-item smart-list-item-feedback")));
    }
  }, {
    key: "_dblclickEventHandler",
    value: function _dblclickEventHandler(e) {
      var t = this;

      if (t.editable) {
        var _i825 = e.target.closest("smart-list-item");

        return !(_i825 instanceof Smart.ListItem) || _i825.disabled || _i825.readonly ? void t.$editInput.addClass("smart-hidden") : void (t.$.editInput.dir = t.rightToLeft ? "rtl" : "ltr", t.$.editInput.style.width = t.$.itemsInnerContainer.offsetWidth + "px", t.$.editInput.owner = _i825, t.$.editInput.value = _i825.label, t.$.editInput.style.height = _i825.offsetHeight + "px", t.$.editInput.style.top = _i825.offsetTop + t.$.itemsInnerContainer.offsetTop + "px", t.$editInput.hasClass("smart-hidden") && t.$editInput.removeClass("smart-hidden"), t.$.editInput.focus({
          preventScroll: !0
        }));
      }
    }
  }, {
    key: "_editInputEventHandler",
    value: function _editInputEventHandler(e) {
      var t = this;
      if ("blur" === e.type || "keydown" === e.type && "Escape" === e.key) return t.$editInput.hasClass("smart-hidden") ? void 0 : t.$editInput.addClass("smart-hidden"), void t.focus();

      if (!("keydown" === e.type || t.$editInput.hasClass("smart-hidden"))) {
        var _i826 = e.target;

        if (e.stopPropagation(), _i826.owner.label !== _i826.value && (_i826.owner.label = _i826.value, t.itemTemplate && t._applyTemplate(_i826.owner), t.dataSource)) {
          var _e996 = _i826.owner.dataIndex,
              _a546 = t.dataSource[_e996];
          _a546 && (t.displayMember ? _a546[t.displayMember] = _i826.value : _a546.label = _i826.value);
        }

        t.$editInput.addClass("smart-hidden"), t.$.fireEvent("itemLabelChange", {
          selected: _i826.owner.selected,
          disabled: _i826.owner.disabled,
          index: t._indexOf(_i826.owner),
          label: _i826.owner.label,
          value: _i826.owner.value
        });
      }
    }
  }, {
    key: "_pointerUpHandler",
    value: function _pointerUpHandler(e) {
      var t = this;
      var i = e.originalEvent,
          a = i.target;
      (t.shadowRoot || t.isInShadowDOM) && (a = i.composedPath()[0]);

      var n = function n(i) {
        var n = i.ownerListBox;
        n.disabled || n !== t || n.displayLoadingIndicator || "none" === n.selectionMode || i.grouped || i.readonly || (n._focus(i), n.select(i), e.preventDefault(), Smart.ListBox.DragDrop.StartPosition = null, t.$.fireEvent("itemClick", {
          selected: a.selected,
          disabled: a.disabled,
          index: t._indexOf(a),
          label: a.label,
          value: a.value
        }));
      };

      if (i.target instanceof Smart.ListItem && !i.target.disabled && !(i.target instanceof Smart.ListItemsGroup)) return void n(a.dataItem);

      for (; a.parentElement;) {
        if (a instanceof Smart.ListItem && !a.disabled && !(a instanceof Smart.ListItemsGroup)) return void n(a.dataItem);
        a = a.parentElement;
      }

      if (this.shadowRoot && "shadow" === this.shadowDomMode) {
        var _e997 = i.composedPath();

        for (var _t842 = 0; _t842 < _e997.length; _t842++) {
          var _i827 = _e997[_t842];
          _i827 instanceof Smart.ListItem && !_i827.disabled && n(_i827.dataItem);
        }
      }
    }
  }, {
    key: "_upHandler",
    value: function _upHandler(e) {
      var t = Math.abs;
      var i = this;

      if (!(i.disabled || i.readonly || !Smart.ListBox.DragDrop.StartPosition)) {
        if (Smart.Utilities.Core.isMobile && !Smart.ListBox.DragDrop.Dragging) {
          var _a547 = t(e.pageX - Smart.ListBox.DragDrop.StartPosition.left),
              _n405 = t(e.pageY - Smart.ListBox.DragDrop.StartPosition.top);

          var _o299 = 0 <= _a547 && 3 >= _a547 && 0 <= _n405 && 3 >= _n405;

          if (Smart.Utilities.Core.isMobile && 300 <= new Date() - Smart.ListBox.DragDrop.StartTime && (_o299 = !1, Smart.ListBox.DragDrop.StartTime = null), _o299) {
            var _t843 = e.originalEvent.target.closest("smart-list-box");

            _t843 ? _t843._pointerUpHandler(e) : i._pointerUpHandler(e), Smart.ListBox.DragDrop.StartPosition = null;
          } else {
            var _t844 = e.originalEvent.target;
            if (e.target instanceof Smart.ListItem && !_t844.readonly && !e.target.disabled && !(e.target instanceof Smart.ListItemsGroup)) e.preventDefault(), e.stopPropagation();else for (; _t844.parentElement;) {
              if (_t844 instanceof Smart.ListItem && !_t844.readonly && !_t844.disabled && !(_t844 instanceof Smart.ListItemsGroup)) {
                e.preventDefault(), e.stopPropagation();
                break;
              }

              _t844 = _t844.parentElement;
            }
          }
        } else if (!Smart.Utilities.Core.isMobile && !Smart.ListBox.DragDrop.Dragging && "release" === i.selectionChangeAction) {
          var _t845 = (i.shadowRoot || i.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target).closest("smart-list-box");

          _t845 ? _t845._pointerUpHandler(e) : i._pointerUpHandler(e);
        }

        if (Smart.ListBox.DragDrop.Feedback) {
          Smart.ListBox.DragDrop.Feedback.parentNode && Smart.ListBox.DragDrop.Feedback.parentNode.removeChild(Smart.ListBox.DragDrop.Feedback), Smart.ListBox.DragDrop.Feedback = null;

          var _t846;

          if (Smart.Utilities.Core.isMobile && Smart.ListBox.DragDrop.Dragging) for (var _i828 = 0; _i828 < Smart.ListBox.DragDrop.ListBoxes.length; _i828++) {
            var _a548 = Smart.ListBox.DragDrop.ListBoxes[_i828],
                _n406 = _a548.getBoundingClientRect();

            if (_a548.allowDrop && !_a548.closest(".smart-visibility-hidden") && _n406.left <= e.pageX && e.pageX <= _n406.left + _n406.width && _n406.top <= e.pageY && e.pageY <= _n406.top + _n406.height) {
              _t846 = _a548;

              var _o300 = _a548._items.filter(function (e) {
                return !e.hidden;
              });

              for (var _t847 = 0; _t847 < _o300.length; _t847++) {
                var _i829 = _o300[_t847],
                    _r185 = _i829.getBoundingClientRect();

                if ((_o300.indexOf(_i829) === _o300.length - 1 || _i829.parentNode.lastElementChild === _i829) && e.pageY >= _n406.top + _i829.offsetTop - _a548.scrollTop + _r185.height / 2 && e.pageY <= _n406.top - _a548.scrollTop + _i829.offsetTop + _r185.height) {
                  Smart.ListBox.DragDrop.DropDetails = {
                    item: _i829,
                    position: "bottom"
                  };
                  break;
                }

                if (e.pageY >= _n406.top + _i829.offsetTop - _a548.scrollTop && e.pageY <= _n406.top + _i829.offsetTop + _r185.height - _a548.scrollTop) {
                  Smart.ListBox.DragDrop.DropDetails = {
                    item: _i829,
                    position: "top"
                  };
                  break;
                }
              }
            }
          }

          if (Smart.ListBox.DragDrop.Dragging) {
            if (Smart.ListBox.DragDrop.DropDetails) {
              var _i830 = Smart.ListBox.DragDrop.DropDetails.item,
                  _a549 = Smart.ListBox.DragDrop.Item;
              var _n407 = _a549.ownerListBox;
              if (_t846 = !_t846 && e.originalEvent.target.closest ? e.originalEvent.target.closest("smart-list-box") : _t846, document.body.classList.remove("smart-dragging"), _i830.$.removeClass("smart-list-item-line-feedback"), _i830.$.removeClass("smart-list-item-bottom-line-feedback"), _t846 && _i830.ownerListBox !== _t846 && 0 < _t846.items.length && (_i830 = _t846.items[_t846.items.length - 1]), !(Smart.ListBox.DragDrop.Item !== _i830 && (_t846 === _i830.ownerListBox || Smart.Utilities.Core.isMobile))) _t846 && 0 === _t846._items.length && "none" !== _t846.dropAction && ("move" === _t846.dropAction ? Smart.ListBox.DragDrop.Item.ownerListBox.removeChild(Smart.ListBox.DragDrop.Item) : "copy" === _t846.dropAction && (_a549 = _a549.cloneNode(!0)), _t846.appendChild(_a549));else if ("none" !== _a549.ownerListBox.dropAction) {
                _i830.ownerListBox !== _a549.ownerListBox && "move" === _a549.ownerListBox.dropAction && Smart.ListBox.DragDrop.Item.ownerListBox.removeChild(Smart.ListBox.DragDrop.Item), "copy" === _a549.ownerListBox.dropAction && (_a549 = _a549.cloneNode(!0)), Smart.ListBox.DragDrop.Item.group = _i830.group;
                var _e998 = _i830.ownerListBox;
                "checkBox" !== _e998.selectionMode && "radioButton" !== _e998.selectionMode && _e998.clearSelection(), "top" === Smart.ListBox.DragDrop.DropDetails.position ? _e998.insertBefore(_a549, _i830) : _i830.parentNode.lastElementChild === _i830 ? _e998.appendChild(_a549) : _e998.appendChild(_a549, _i830), _e998.ensureVisible(_a549), "checkBox" === _e998.selectionMode || "radioButton" === _e998.selectionMode ? (_e998._focus(_a549), _e998._refreshSelection()) : (_e998.clearSelection(), _e998.select(_a549));
              }
              _a549.selected && _t846 !== _n407 && _n407._refreshSelection();
              var _o301 = Smart.ListBox.DragDrop.Item,
                  _r186 = _o301.ownerListBox;
              _o301.displayMode = "checkBox" === _r186.selectionMode || "radioButton" === _r186.selectionMode ? _r186.selectionMode : "plain", _r186.$.fireEvent("dragEnd", {
                item: _o301,
                target: _i830,
                data: Smart.ListBox.DragDrop,
                previousContainer: _n407,
                container: _t846,
                originalEvent: e
              }), _r186._focus(_o301);
            } else {
              var _t848 = Smart.ListBox.DragDrop.Item,
                  _i831 = _t848.ownerListBox;
              _t848.displayMode = "checkBox" === _i831.selectionMode || "radioButton" === _i831.selectionMode ? _i831.selectionMode : "plain", _i831.$.fireEvent("dragEnd", {
                item: _t848,
                target: null,
                data: Smart.ListBox.DragDrop,
                previousContainer: _i831,
                container: _i831,
                originalEvent: e
              }), _i831._focus(_t848);
            }

            e.preventDefault();
          }

          delete Smart.ListBox.DragDrop.DraggedFrom, Smart.ListBox.DragDrop.Dragging = !1, Smart.ListBox.DragDrop.Item = null, Smart.ListBox.DragDrop.DropDetails = null;
        }

        for (var _e999 = 0; _e999 < Smart.ListBox.DragDrop.ListBoxes.length; _e999++) {
          var _t849 = Smart.ListBox.DragDrop.ListBoxes[_e999];
          _t849._dragInterval && clearInterval(_t849._dragInterval);
        }
      }
    }
  }, {
    key: "_itemsContainerMoveHandler",
    value: function _itemsContainerMoveHandler(e) {
      var t = this;
      if (Smart.ListBox.DragDrop.Dragging) return t._applyItemFeedback(e), t._moveHandler(e), e.originalEvent.preventDefault(), e.originalEvent.stopPropagation(), !1;
    }
  }, {
    key: "_applyItemFeedback",
    value: function _applyItemFeedback(e) {
      var t = this,
          i = e.originalEvent.target,
          a = i.closest ? i.closest("smart-list-item") : i;
      return Smart.Utilities.Core.isMobile ? void (Smart.ListBox.DragDrop.DropDetails = {
        item: Smart.ListBox.DragDrop.Item,
        position: "bottom"
      }) : 0 === t.items.length ? void 0 : a ? void a._itemOnMouseMove(e) : void t.items[t.items.length - 1]._itemOnMouseMove(e, !0);
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      var t = Math.abs;
      var i = this;

      if (Smart.ListBox.DragDrop.Feedback && Smart.ListBox.DragDrop.DraggedFrom === i) {
        var _a550 = i.dragOffset;

        if (!Smart.ListBox.DragDrop.Dragging) {
          var _i832 = t(e.pageX - Smart.ListBox.DragDrop.StartPosition.left),
              _n408 = t(e.pageY - Smart.ListBox.DragDrop.StartPosition.top),
              _o302 = new Date() - Smart.ListBox.DragDrop.StartTime;

          var _r187 = 5 <= _i832 && 15 >= _i832 || 5 <= _n408 && 15 >= _n408;

          if (Smart.Utilities.Core.isMobile && (300 > _o302 || 1e3 < _o302) && (_r187 = !1), _r187) {
            Smart.ListBox.DragDrop.Dragging = !0, Smart.ListBox.DragDrop.Feedback.style.left = _a550[0] + e.pageX + "px", Smart.ListBox.DragDrop.Feedback.style.top = _a550[1] + e.pageY + "px", document.body.appendChild(Smart.ListBox.DragDrop.Feedback), e.preventDefault(), e.stopPropagation(), e.originalEvent.preventDefault(), e.originalEvent.stopPropagation();
            var _t850 = Smart.ListBox.DragDrop.Item,
                _i833 = _t850.ownerListBox;
            _i833.$.fireEvent("dragStart", {
              item: _t850,
              data: Smart.ListBox.DragDrop,
              container: _i833,
              previousContainer: _i833,
              originalEvent: e.originalEvent
            }), document.body.classList.add("smart-dragging");
          }
        } else {
          Smart.ListBox.DragDrop.Feedback.style.left = _a550[0] + e.pageX + "px", Smart.ListBox.DragDrop.Feedback.style.top = _a550[1] + e.pageY + "px", i.$.fireEvent("dragging", {
            item: Smart.ListBox.DragDrop.Item,
            data: Smart.ListBox.DragDrop,
            originalEvent: e.originalEvent
          });

          var _loop42 = function _loop42(_t851) {
            var i = Smart.ListBox.DragDrop.ListBoxes[_t851];
            i._dragInterval && clearInterval(i._dragInterval), i._dragInterval = setInterval(function () {
              var t = i.getBoundingClientRect();
              t.left <= e.clientX && t.left + t.width >= e.clientX && (e.clientY >= t.top && e.clientY <= t.top + 20 ? i.scrollTop -= 2 : e.clientY >= t.top + t.height - 20 && e.clientY <= t.top + t.height && (i.scrollTop += 2));
            }, 1);
          };

          for (var _t851 = 0; _t851 < Smart.ListBox.DragDrop.ListBoxes.length; _t851++) {
            _loop42(_t851);
          }

          return e.preventDefault(), e.stopPropagation(), e.originalEvent.preventDefault(), e.originalEvent.stopPropagation(), !1;
        }
      }
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler() {
      var e = this;
      e._focused = !0, e.setAttribute("focus", "");
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      var e = this;
      e._focused = !1, e.removeAttribute("focus");
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e1000 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1000.concat(Array.prototype.slice.call(arguments)));
      }

      t.isVirtualized ? (-1 < t._items.indexOf(e) && t._items.splice(t._items.indexOf(e), 1), t._items.push(e)) : (e.dataItem = e, t.shadowRoot && "light" === t.shadowDomMode ? t.appendChild(e) : t.$.itemsInnerContainer.appendChild(e), -1 < t._items.indexOf(e) && t._items.splice(t._items.indexOf(e), 1), t._items.push(e)), t._refreshItems(), t._refreshSelection();
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      var i = this;

      if (!i.isCompleted) {
        var _e1001 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(i, _e1001.concat(Array.prototype.slice.call(arguments)));
      }

      i.isVirtualized ? (-1 < i._items.indexOf(e) && i._items.splice(i._items.indexOf(e), 1), i._items.splice(i._indexOf(t), 0, e)) : (e.dataItem = e, t.parentNode.insertBefore(e, t), -1 < i._items.indexOf(e) && i._items.splice(i._items.indexOf(e), 1), i._items.splice(i._indexOf(t), 0, e)), i._refreshItems(), i._refreshSelection();
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e1002 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e1002.concat(Array.prototype.slice.call(arguments)));
      }

      if (t.isVirtualized) t._items.splice(t._indexOf(e), 1);else if (e.parentNode) {
        var _i834 = t.selectedIndexes.slice(0),
            _a551 = t.selectedValues.slice(0),
            _n409 = _i834.indexOf(e.dataIndex);

        e.parentNode.removeChild(e), -1 < _n409 && (_i834.splice(_n409, 1), _a551.splice(_n409, 1), t.selectedIndexes = _i834, t.selectedValues = _a551);
      }

      t._refreshItems();
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, a) {
      _get(_getPrototypeOf(_class93.prototype), "propertyChangedHandler", this).call(this, e, t, a);

      var n = this;

      switch (e) {
        case "innerHTML":
          n.clearSelection(), n._dataBind(), n.innerHTML = n.content = Smart.Utilities.Core.html(n.$.content);
          break;

        case "dataSource":
        case "valueMember":
        case "groupMember":
        case "displayMember":
          {
            n.clearSelection(), n._dataBind();
            break;
          }

        case "disabled":
        case "unfocusable":
          n._setFocusable();

          break;

        case "displayLoadingIndicator":
          {
            n._setLoadingIndicatorVisibility();

            break;
          }

        case "filterable":
          {
            n._refreshFilter(), n._refreshLayout();
            break;
          }

        case "grouped":
          {
            if (a ? n._group() : n._ungroup(), !("radioButton" === n.selectionMode)) n._refreshSelection();else if (0 < n.selectedValues.length) {
              var _e1003 = n.selectedValues;
              n.clearSelection(), n.select(_e1003[0]);
            }

            n._refreshLayout();

            break;
          }

        case "itemTemplate":
          {
            if (null === a || "" === a) return n._items.map(function (e) {
              return e.innerHTML = e.label;
            }), delete n._bindingDetails, void n._refreshLayout();

            var _e1004 = n.querySelectorAll("smart-list-item"),
                _t852 = function _t852() {
              n._handleItemTemplate(a) && (n._items.map(function (e) {
                return n._applyTemplate(e);
              }), n._refreshLayout()), n.ownerElement && n.ownerElement._setDropDownSize && n.ownerElement._setDropDownSize(), n.$.fireEvent("bindingComplete");
            };

            0 === _e1004.length ? _t852() : n._ensureItemsReady(_e1004, _t852);
            break;
          }

        case "selectedIndexes":
        case "selectedValues":
          {
            var _o303 = n.selectedIndexes.slice(0),
                _i835 = n.selectedValues.slice(0);

            if (!n._items || 0 === n._items.length) return n.selectedIndexes = [], n.selectedValues = [], void (n.$.hiddenInput.value = n.selectedValues.toString());

            if (n._propertyChanging = !0, "selectedIndexes" === e) {
              _o303 = t.slice(0), n.clearSelection();

              for (var _e1005 = 0; _e1005 < a.length; _e1005++) {
                var _t853 = a[_e1005],
                    _i836 = n._items[_t853];
                _i836 && ("oneOrManyExtended" === n.selectionMode || "oneOrMany" === n.selectionMode ? (0 < n.selectedIndexes.length && 0 == _e1005 && n.clearSelection(), n._select(_i836)) : n.select(_i836));
              }
            } else {
              _i835 = t.slice(0), n.selectedValues = [], n.clearSelection();

              for (var _e1006 = 0; _e1006 < a.length; _e1006++) {
                var _t854 = a[_e1006],
                    _i837 = n.getItem(_t854);

                _i837 && ("oneOrManyExtended" === n.selectionMode ? n._select(_i837) : n.select(_i837));
              }
            }

            if (0 < n.selectedIndexes.length && n._focus(n._items[n.selectedIndexes[0]]), n._propertyChanging = !1, JSON.stringify(_i835) !== JSON.stringify(n.selectedValues.slice(0))) {
              var _e1007 = [],
                  _t855 = [];

              for (var _e1008 = 0; _e1008 < _o303.length; _e1008++) {
                0 > n.selectedIndexes.indexOf(_o303[_e1008]) && _t855.push(n._items[_o303[_e1008]]);
              }

              for (var _t856 = 0; _t856 < n.selectedIndexes.length; _t856++) {
                0 > _o303.indexOf(n.selectedIndexes[_t856]) && _e1007.push(n._items[n.selectedIndexes[_t856]]);
              }

              var _i838 = {
                addedItems: _e1007,
                removedItems: _t855
              };

              if (0 < n.selectedIndexes.length) {
                var _e1009 = n._items[n.selectedIndexes[n.selectedIndexes.length - 1]];
                _e1009 !== void 0 && (_i838.selected = _e1009.selected, _i838.disabled = _e1009.disabled, _i838.index = n._indexOf(_e1009), _i838.label = _e1009.label, _i838.value = _e1009.value);
              } else _i838.selected = !1, _i838.disabled = !1, _i838.index = -1, _i838.label = "", _i838.value = "";

              n.$.fireEvent("change", _i838);
            }

            break;
          }

        case "selectionMode":
          {
            var _e1010 = "checkBox" === n.selectionMode || "radioButton" === n.selectionMode ? n.selectionMode : "plain",
                _t857 = n.selectedIndexes.slice(0),
                _i839 = n.selectedValues.slice(0);

            n._propertyChanging = !0;
            var _a552 = n.selectedValues;
            n.selectedValues = [], n.clearSelection();

            for (var _e1011 = 0; _e1011 < _a552.length; _e1011++) {
              var _t858 = _a552[_e1011],
                  _i840 = n.getItem(_t858);

              _i840 && ("oneOrManyExtended" === n.selectionMode ? n._select(_i840) : n.select(_i840));
            }

            if (n._items.forEach(function (t) {
              return t.displayMode = _e1010;
            }), n._recycle(), n._propertyChanging = !1, JSON.stringify(_i839) !== JSON.stringify(n.selectedValues.slice(0))) {
              var _e1012 = [],
                  _a553 = [];

              for (var _e1013 = 0; _e1013 < _t857.length; _e1013++) {
                0 > n.selectedIndexes.indexOf(_t857[_e1013]) && _a553.push(n._items[_t857[_e1013]]);
              }

              for (var _a554 = 0; _a554 < n.selectedIndexes.length; _a554++) {
                0 > _t857.indexOf(n.selectedIndexes[_a554]) && _e1012.push(n._items[n.selectedIndexes[_a554]]);
              }

              var _i841 = {
                addedItems: _e1012,
                removedItems: _a553
              };

              if (0 < _t857.length) {
                var _e1014 = n._items[_t857[_t857.length - 1]];
                _e1014 && (_i841.selected = _e1014.selected, _i841.disabled = _e1014.disabled, _i841.index = n._indexOf(_e1014), _i841.label = _e1014.label, _i841.value = _e1014.value);
              }

              n.$.fireEvent("change", _i841);
            }

            n._applyAriaSelected();

            break;
          }

        case "topVisibleIndex":
          n._setTopVisibleIndex(a);

          break;

        case "autoSort":
          n._canSort = a;
          break;

        case "sortDirection":
        case "sorted":
          {
            n._canSort = !0, a ? n._sort() : n._unsort();
            var _e1015 = n.selectedValues;
            n.selectedValues = [], n._refreshSelection();

            for (var _t859 = 0; _t859 < _e1015.length; _t859++) {
              var _i842 = _e1015[_t859],
                  _a555 = n.getItem(_i842);

              _a555 && ("oneOrManyExtended" === n.selectionMode ? n._select(_a555) : n.select(_a555));
            }

            n._refreshLayout(), n._canSort = n.autoSort;
            break;
          }
      }
    }
  }, {
    key: "_refreshSelection",
    value: function _refreshSelection() {
      var e = this;

      if (e._items && 0 !== e._items.length) {
        var _t860 = e.selectedValues;
        e.selectedIndexes = [], e.selectedValues = [];

        for (var _a556 = 0; _a556 < e._items.length; _a556++) {
          var _i843 = e._items[_a556];
          _i843.selected = !1, -1 < _t860.indexOf(_i843.value) && e.select(_i843);
        }

        e._recycle();
      }
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      var e = this;
      if (!e._items || 0 === e._items.length) return;
      var t = [];

      for (var _a557 = 0; _a557 < e._items.length; _a557++) {
        e._items[_a557].selected && t.push(e._items[_a557]);
      }

      e._items.map(function (e) {
        return e.selected = !1;
      });

      var i = e.selectedValues.slice(0),
          a = e.selectedIndexes.slice(0);

      if (e.selectedIndexes = [], e.selectedValues = [], e.$.hiddenInput.value = e.selectedValues.toString(), e._recycle(), e.context !== e) {
        var _i844 = {
          addedItems: [],
          removedItems: t
        };

        if (0 < a.length) {
          var _t861 = e._items[a[a.length - 1]];
          _t861 && (_i844.selected = _t861.selected, _i844.disabled = _t861.disabled, _i844.index = e._indexOf(_t861), _i844.label = _t861.label, _i844.value = _t861.value);
        }

        e.$.fireEvent("change", _i844);
      }
    }
  }, {
    key: "ensureVisible",
    value: function ensureVisible(e) {
      var t = this;
      if (e) return !("string" == typeof e && (e = t.getItem(e), !e)) && (t.isVirtualized || t.$.itemsContainer.scrollTop === t.scrollTop || (t.scrollTop = t.$.itemsContainer.scrollTop), e.top + e.height >= t.scrollTop + t.offsetHeight && (t.scrollTop += e.height, !t.isVirtualized && (t.$.itemsContainer.scrollTop = t.scrollTop)), (e.top <= t.scrollTop || e.top >= t.scrollTop + t.$.itemsContainer.offsetHeight) && (t.scrollTop = e.top, !t.isVirtualized && (t.$.itemsContainer.scrollTop = t.scrollTop)), 0 === t._indexOf(e) || 1 === t._indexOf(e) && 1 < t._items.length && t._items[0].grouped ? (t.scrollTop = 0, !t.isVirtualized && (t.$.itemsContainer.scrollTop = t.scrollTop)) : t._indexOf(e) === t._items.length - 1 && (t.scrollTop = t.scrollHeight, !t.isVirtualized && (t.$.itemsContainer.scrollTop = t.scrollTop)), !0);
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class93.prototype), "ready", this).call(this);

      var e = this;

      if (e.shadowRoot && "light" === e.shadowDomMode) {
        var _t862 = document.createDocumentFragment();

        [].slice.call(e.$.itemsInnerContainer.children).map(function (e) {
          return _t862.appendChild(e);
        }), e.appendChild(_t862), e.$.itemsInnerContainer.appendChild(document.createElement("slot"));
      }

      e._areCSSVarsSupported = Smart.Utilities.Core.CSSVariablesSupport(), e.isUpdating = 0, e._scrollView && (e._scrollView = new Smart.Utilities.Scroll(e, e.$.horizontalScrollBar, e.$.verticalScrollBar), e._scrollView.hScrollBar.$.addClass("smart-hidden"), e._scrollView.vScrollBar.$.addClass("smart-hidden"));
      var t = e._scrollView.vScrollBar,
          i = e._scrollView.hScrollBar;
      t.hasStyleObserver = !1, i.hasStyleObserver = !1, t.hasResizeObserver = !1, i.hasResizeObserver = !1, t.wait = !1, i.wait = !1, e._setFocusable();
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.setAttribute("role", "listbox"), e.setAttribute("aria-orientation", "vertical"), e.$.verticalScrollBar.setAttribute("aria-controls", e.id), e.$.horizontalScrollBar.setAttribute("aria-controls", e.id), e._keysPressed = {}, e._incrementalSearchQuery = "", e._incrementalSearchItems = [], e._canSort = !0, e._previousEntry = "", e._setLoadingIndicatorVisibility(), e._refreshFilter(), e._initializeInnerHTML(), e._dataBind(), e.enableShadowDOM && HTMLElement.prototype.appendChild.apply(e, [e.$.hiddenInput]), _get(_getPrototypeOf(_class93.prototype), "render", this).call(this);
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;
      _get(_getPrototypeOf(_class93.prototype), "attached", this).call(this), Smart.ListBox.DragDrop || (Smart.ListBox.DragDrop = {
        ListBoxes: []
      }), Smart.ListBox.DragDrop.ListBoxes.push(e), e._scrollView || (e._scrollView = new Smart.Utilities.Scroll(e, e.$.horizontalScrollBar, e.$.verticalScrollBar)), 0 < e.selectedIndexes.length && e._items && e.ensureVisible(e._items[e.selectedIndexes[0]]);
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;

      if (_get(_getPrototypeOf(_class93.prototype), "detached", this).call(this), e._scrollView && (e._scrollView.unlisten(), delete e._scrollView), Smart.ListBox.DragDrop && Smart.ListBox.DragDrop.ListBoxes) {
        var _t863 = Smart.ListBox.DragDrop.ListBoxes.indexOf(e);

        Smart.ListBox.DragDrop.ListBoxes.splice(_t863, 1);
      }
    }
  }, {
    key: "_createItem",
    value: function _createItem(e, t, i) {
      var a = this,
          n = "checkBox" === a.selectionMode || "radioButton" === a.selectionMode ? a.selectionMode : "plain",
          o = i ? {} : document.createElement("smart-list-item");
      o.ownerListBox = a, "number" == typeof e && (e = "" + e);

      var r = function r(t, i) {
        return void 0 === e[t] ? e[i] : "" + e[t];
      };

      var l = "string" == typeof e ? e : r(a.displayMember, "label"),
          s = "string" == typeof e ? e : r(a.valueMember, "value"),
          d = r(a.groupMember, "group");
      return void 0 === l && (void 0 === t ? l = "" : l = "" + t), o.label = o.innerHTML = "" + l, void 0 === s && (void 0 === t ? s = l : s = "" + t), e.color && (o.color = e.color), o.value = "" + s, o.displayMode = n, o.selected = !!e.selected && e.selected, o.disabled = !!e.disabled && e.disabled, o.dataItem = o, void 0 !== t && (o.dataIndex = t), a._alternateItem(o), e.title && (o.title = e.title), d && (o.group = "" + d), o;
    }
  }, {
    key: "_alternateItem",
    value: function _alternateItem(e) {
      var t = this,
          i = t.alternationStart,
          a = 0 < t.alternationEnd ? t.alternationEnd : 1 / 0;
      0 >= t.alternationCount || (t._alternationIndexCounter === void 0 && (t._alternationIndexCounter = 0), e.dataIndex >= i && e.dataIndex <= a && (e.alternationIndex = t._alternationIndexCounter++, t._alternationIndexCounter === t.alternationCount && (t._alternationIndexCounter = 0)));
    }
  }, {
    key: "_beginUpdate",
    value: function _beginUpdate() {
      var e = this;
      e.isUpdating++;
    }
  }, {
    key: "_isUpdating",
    value: function _isUpdating() {
      var e = this;
      return 0 < e.isUpdating;
    }
  }, {
    key: "_endUpdate",
    value: function _endUpdate() {
      var e = this;
      e.isUpdating--;
    }
  }, {
    key: "_initializeRecyclingItems",
    value: function _initializeRecyclingItems() {
      var e = this;
      if (!e.dataSource || e.dataSource && 0 === e.dataSource.length || !e.isVirtualized) return;
      var t = 0,
          a = e.offsetHeight;
      e.$.itemsInnerContainer.innerHTML = "", e._recyclingItems = [];

      var i = function i() {
        for (var _n410 = 0; _n410 < e.dataSource.length; _n410++) {
          var _i845 = e.dataSource[_n410],
              _o304 = e._createItem(_i845);

          if (e.itemHeight && "auto" !== e.itemHeight && (_o304.style.height = e.itemHeight + "px"), e.$.itemsInnerContainer.appendChild(_o304), t += _o304.offsetHeight, _o304.dataItem = e._items[_n410], e._recyclingItems.push(_o304), t > 1.5 * a) break;
        }
      };

      i();

      for (var _e1016 = 0; t < 1.5 * a && 5 > ++_e1016;) {
        i();
      }
    }
  }, {
    key: "_dataBind",
    value: function _dataBind() {
      var e = this;

      if (e._scrollView || (e._scrollView = new Smart.Utilities.Scroll(e, e.$.horizontalScrollBar, e.$.verticalScrollBar)), "function" == typeof e.dataSource && (e._items = []), "string" == typeof e.dataSource && (e.dataSource = JSON.parse(e.dataSource)), null !== e.dataSource && Array.isArray(e.dataSource)) {
        e.isUpdating++;

        var _t864 = function _t864(t) {
          e._items = [], e._groups = [];
          var a = e.dataSource;

          for (var _n411 = 0; _n411 < a.length; _n411++) {
            var _i846 = a[_n411],
                _o305 = e._createItem(_i846, _n411, !t);

            e._items[_n411] = _o305, t && t.appendChild(_o305);
          }
        };

        if (e.isVirtualized) _t864(), e._initializeRecyclingItems();else {
          var _i847 = document.createDocumentFragment();

          e.$.itemsInnerContainer.innerHTML = "", _t864(_i847), e.$.itemsInnerContainer.appendChild(_i847);
        }
        e.isUpdating--;
      }

      var t = e.shadowRoot ? e.shadowRoot.querySelectorAll("smart-list-item") : e.querySelectorAll("smart-list-item"),
          i = function i() {
        e.isUpdating++, e.dataSource || (e._initializeHtmlListItems(), e._initializeHtmlListGroups()), e.grouped && e._group(), e.sorted && e._sort(), e._refreshLayout(), e._initializeSelection(), e.isInitialized = !0, e._canSort = e.autoSort, e.isUpdating--, e.itemTemplate && e._handleItemTemplate(e.itemTemplate) && (e._items.map(function (t) {
          return e._applyTemplate(t);
        }), e._refreshLayout()), e.__onCompleted && (e._onCompleted = e.__onCompleted, e.__onCompleted = null, e._onCompleted()), -1 < e.topVisibleIndex && e._setTopVisibleIndex(e.topVisibleIndex), e.$.fireEvent("bindingComplete"), e._updateTopVisibleIndex(), 0 === e._items.length && e.clearItems(), e._applyAriaSelected();
      };

      0 === t.length ? i() : (e._onCompleted && (e.__onCompleted = e._onCompleted, e._onCompleted = null), e._ensureItemsReady(t, i));
    }
  }, {
    key: "_ensureItemsReady",
    value: function _ensureItemsReady(e, t) {
      var a = this,
          i = function i() {
        var i = function i(t) {
          for (var _a558 = 0; _a558 < e.length; _a558++) {
            e[_a558].context = "node" === t ? e[_a558] : document;
          }
        };

        i("node"), t(), i();
      };

      if (0 === e.length) i();else {
        a._nodesReadyListeners = 0;

        for (var _t865 = 0; _t865 < e.length; _t865++) {
          var _n412 = e[_t865],
              _o306 = function () {
            a._nodesReadyListeners--, 0 === a._nodesReadyListeners && (i(), delete a._nodesReadyListeners);
          }.bind(a);

          _n412.isCompleted || (a._nodesReadyListeners++, _n412._onCompleted = _o306);
        }

        0 === a._nodesReadyListeners && i();
      }
    }
  }, {
    key: "_initializeInnerHTML",
    value: function _initializeInnerHTML() {
      var e = this;
      0 <= e.$.itemsInnerContainer.innerHTML.indexOf("<option") ? e.$.itemsInnerContainer.innerHTML = e.$.itemsInnerContainer.innerHTML.replace(/<optgroup/ig, "<smart-list-items-group").replace(/<\/optgroup/ig, "</smart-list-items-group").replace(/<option/ig, "<smart-list-item").replace(/<\/option/ig, "</smart-list-item") : 0 <= e.$.itemsInnerContainer.innerHTML.indexOf("<ul") && (e.$.itemsInnerContainer.innerHTML = e.$.itemsInnerContainer.innerHTML.replace(/<ul/ig, "<smart-list-items-group").replace(/<\/ul/ig, "</smart-list-items-group").replace(/<li/ig, "<smart-list-item").replace(/<\/li/ig, "</smart-list-item"));
    }
  }, {
    key: "_initializeHtmlListItems",
    value: function _initializeHtmlListItems() {
      var e = this,
          t = e.shadowRoot && "shadow" === e.shadowDomMode ? e.shadowRoot.querySelectorAll("smart-list-item") : e.querySelectorAll("smart-list-item"),
          a = "checkBox" === e.selectionMode || "radioButton" === e.selectionMode ? e.selectionMode : "plain",
          n = function n(e, t, i) {
        return void 0 === e[t] ? e[i] : "" + e[t];
      };

      e._items = [];
      var o = 0;

      for (var _r188 = 0; _r188 < t.length; _r188++) {
        var _i848 = t[_r188];
        _i848.dataIndex = _r188, _i848.label = _i848.innerHTML, _i848.dataItem = _i848, _i848.top || (_i848.top = o), _i848.height || (_i848.height = _i848.offsetHeight), o += _i848.height, _i848.value || (_i848.value = "" + _r188);

        var _l128 = n(_i848, e.displayMember, "label"),
            _s91 = n(_i848, e.valueMember, "value"),
            d = n(_i848, e.groupMember, "group");

        _i848.label !== _l128 && (_i848.label = _l128), _i848.value !== _s91 && (_i848.value = _s91), _i848.group !== d && (_i848.group = d);
        var c = _i848.context;
        _i848.context = document, _i848.displayMode = a, _i848.context = c, e._alternateItem(_i848), _i848.selected && (e.selectedIndexes.push(_r188), e.selectedValues.push(_i848.value)), e._items.push(_i848);
      }

      e.itemTemplate && e._handleItemTemplate(e.itemTemplate) && e._items.map(function (t) {
        return e._applyTemplate(t);
      });
    }
  }, {
    key: "_group",
    value: function _group() {
      var e = this;
      e.isUpdating++;
      var t = [],
          a = [];
      e._canSort && e._unsort();

      for (var _a559 = 0; _a559 < e._items.length; _a559++) {
        var _i849 = e._items[_a559];

        var _n413 = _i849.group ? _i849.group.trim() : _i849.innerHTML.charAt(0) || _i849.label.charAt(0);

        _n413 += " ", t[_n413] ? t[_n413].items.push(_i849) : t[t.length++] = t[_n413] = {
          items: [_i849],
          label: _n413
        };
      }

      if (!e.isVirtualized) {
        for (; e.$.itemsInnerContainer.firstChild;) {
          e.$.itemsInnerContainer.removeChild(e.$.itemsInnerContainer.firstChild);
        }

        var _n414 = document.createDocumentFragment();

        e._groups = [];

        for (var _o307 = 0; _o307 < t.length; _o307++) {
          var _i851 = t[_o307],
              _r189 = document.createElement("smart-list-items-group");

          _r189.label = _i851.label, _r189.dataIndex = _o307;

          for (var _e1017 = 0; _e1017 < t[_o307].items.length; _e1017++) {
            var _t866 = _i851.items[_e1017];
            a.push(_t866), _t866.group = _i851.label, _r189.appendChild(_t866);
          }

          e._groups.push(_r189), _n414.appendChild(_r189);
        }

        e._items = a;

        var _i850 = /Trident|Edge/.test(navigator.userAgent);

        _i850 ? setTimeout(function () {
          e.$.itemsInnerContainer.appendChild(_n414);
        }, 50) : e.$.itemsInnerContainer.appendChild(_n414);
      } else {
        e._groups = [];

        for (var _e1018 = 0; _e1018 < t.length; _e1018++) {
          var _i852 = t[_e1018];
          _i852.dataIndex = _e1018, _i852.grouped = !0, _i852.hidden = !1, _i852.displayMode = "plain", a.push(_i852);

          for (var _n415 = 0; _n415 < t[_e1018].items.length; _n415++) {
            var _e1019 = _i852.items[_n415];
            _e1019.group = _i852, a.push(_e1019);
          }
        }

        e._groups = t, e._items = a;
      }

      e.sorted && e._sort(), e.isUpdating--;
    }
  }, {
    key: "_ungroup",
    value: function _ungroup() {
      var e = this;
      e.isUpdating++, e._groups = [], e._canSort && e._unsort();
      var t = [];

      if (!e.isVirtualized) {
        var _a560 = document.createDocumentFragment();

        for (var _n416 = 0; _n416 < e._items.length; _n416++) {
          var _i853 = e._items[_n416];
          _a560.appendChild(_i853), t.push(_i853);
        }

        0 < t.length && (e.$.itemsInnerContainer.innerHTML = "", e.$.itemsInnerContainer.appendChild(_a560));
      } else for (var _a561 = 0; _a561 < e._items.length; _a561++) {
        var _i854 = e._items[_a561];
        _i854.grouped || t.push(_i854);
      }

      e._items = t, e.sorted && e._sort(), e.isUpdating--;
    }
  }, {
    key: "_initializeHtmlListGroups",
    value: function _initializeHtmlListGroups() {
      var e = this,
          t = e.$.itemsInnerContainer.querySelectorAll("smart-list-items-group");
      e._groups = [];

      for (var _a562 = 0; _a562 < t.length; _a562++) {
        var _i855 = t[_a562];
        _i855.dataIndex = _a562, e._groups.push(_i855);
      }
    }
  }, {
    key: "_initializeSelection",
    value: function _initializeSelection() {
      var e = this,
          t = e.selectedIndexes.slice(0),
          a = e.selectedValues.slice(0);
      e.clearSelection(), "oneOrManyExtended" === e.selectionMode && (e._keysPressed.Control = !0);

      for (var _n417 = 0; _n417 < e._items.length; _n417++) {
        var _i856 = e._items[_n417];
        (0 <= t.indexOf(_n417) || 0 <= a.indexOf(_i856.value || _i856.label)) && (e._focusedItem && (e._focusedItem._focused = !1), e._focusedItem = null, e.select(_i856));
      }

      "oneOrManyExtended" === e.selectionMode && (e._keysPressed.Control = !1);
    }
  }, {
    key: "onItemUpdated",
    value: function onItemUpdated() {
      var e = this;
      !e.isInitialized || e._isUpdating() || (e.isUpdating++, e._refreshLayout(), e.isUpdating--);
    }
  }, {
    key: "_refreshItems",
    value: function _refreshItems() {
      var e = this;

      if (e.isInitialized && !e._isUpdating()) {
        if (e.isUpdating++, e.grouped ? e._ungroup() : e.sorted && e._canSort && e._unsort(), !e.isVirtualized) {
          e._items = [];

          var _t867 = e.shadowRoot ? e.shadowRoot.querySelectorAll("smart-list-item") : e.querySelectorAll("smart-list-item");

          for (var _a563 = 0; _a563 < _t867.length; _a563++) {
            _t867[_a563].dataIndex = _a563, e._alternateItem(_t867[_a563]), e._items.push(_t867[_a563]);
          }
        }

        e.grouped ? e._group() : e.sorted && e._sort(), e._refreshLayout(), e.isUpdating--;
      }
    }
  }, {
    key: "_applyIncrementalSearch",
    value: function _applyIncrementalSearch(e) {
      var t = this;
      if (!(null === t.incrementalSearchDelay || isNaN(t.incrementalSearchDelay))) return -1 < ["Shift", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Control", "Home", "End", "PageUp", "PageDown"].indexOf(e) ? void 0 : (0 !== t._incrementalSearchQuery.indexOf(e) && (t._incrementalSearchQuery += e), t._incrementalSearchTimer && clearTimeout(t._incrementalSearchTimer), t._incrementalSearch(), void (t._incrementalSearchTimer = setTimeout(function () {
        t._incrementalSearchQuery = "";
      }, t.incrementalSearchDelay)));
    }
  }, {
    key: "select",
    value: function select(e) {
      var t = this;

      if (!("string" == typeof e && (e = t.getItem(e), !e)) && !("number" == typeof e && (e = t.getItem(e), !e)) && !(e.grouped || e.readonly)) {
        if ("none" === t.selectionMode) return t.selectedIndexes = [], void (t.selectedValues = []);

        switch (!t._focusedItem !== e && "none" !== t.selectionMode && (t._focusedItem && (t._focusedItem._focused = !1), t._focusedItem = e, e._focused = !0), t.selectionMode) {
          case "one":
            return (1 !== t.selectedIndexes.length || t.selectedIndexes[0] !== t._indexOf(e)) && (t._previouslySelectedIndexes = t.selectedIndexes, 1 <= t.selectedIndexes.length && t.clearSelection(), t._select(e), delete t._previouslySelectedIndexes, !0);

          case "zeroOrOne":
            return 1 === t.selectedIndexes.length && t.selectedIndexes[0] === t._indexOf(e) ? (t.unselect(e), !0) : (t._previouslySelectedIndexes = t.selectedIndexes, 1 <= t.selectedIndexes.length && t.clearSelection(), t._select(e), delete t._previouslySelectedIndexes, !0);

          case "radioButton":
            if (t._previouslySelectedIndexes = t.selectedIndexes, 0 < t.$.itemsInnerContainer.querySelectorAll("smart-list-items-group").length) {
              var _i857 = e.parentNode;

              if (!e.selected) {
                for (var _e1020 in _i857.children) {
                  var _a564 = _i857.children[_e1020];
                  _a564.selected && t.unselect(_a564);
                }

                t._select(e);
              }

              return delete t._previouslySelectedIndexes, !0;
            }

            if (t.isVirtualized && 0 < t._groups.length) {
              var _i858 = e.group;

              if (!e.selected) {
                for (var _e1021 in _i858.items) {
                  var _a565 = _i858.items[_e1021];
                  _a565.selected && t.unselect(_a565);
                }

                t._select(e);
              }

              return delete t._previouslySelectedIndexes, !0;
            }

            return e.selected || (1 <= t.selectedIndexes.length && t.clearSelection(), t._select(e)), delete t._previouslySelectedIndexes, !0;

          case "oneOrMany":
            return e.selected ? 1 < t.selectedIndexes.length && t.unselect(e) : t._select(e), !0;

          case "zeroOrMany":
          case "checkBox":
            return e.selected ? t.unselect(e) : t._select(e), !0;

          case "oneOrManyExtended":
            {
              var _a566 = t.selectedValues;
              if (t._keysPressed.Control) return 1 < t.selectedIndexes.length ? e.selected ? (t.unselect(e), t._focus(t._items[t.selectedIndexes[0]])) : t._select(e) : t._select(e), !0;

              if (t._keysPressed.Shift) {
                var _i859 = t._items[t.selectedIndexes[0]];

                var _n418;

                t.clearSelection();

                var _o308 = 0 <= _a566.indexOf(_i859.value) || _i859.selected;

                if (t._select(_i859, _o308), t._indexOf(_i859) > t._indexOf(e)) for (_n418 = t._indexOf(_i859) - 1; _n418 >= t._indexOf(e);) {
                  var _e1022 = t._items[_n418],
                      _i860 = 0 <= _a566.indexOf(_e1022.value) || _e1022.selected;

                  t._select(_e1022, _i860), _n418--;
                } else for (_n418 = t._indexOf(_i859) + 1; _n418 <= t._indexOf(e);) {
                  var _e1023 = t._items[_n418],
                      _i861 = 0 <= _a566.indexOf(_e1023.value) || _e1023.selected;

                  t._select(_e1023, _i861), _n418++;
                }
                var _r190 = [];

                for (var _e1024 = 0; _e1024 < _a566.length; _e1024++) {
                  _r190.push(t.getItem(_a566[_e1024]));
                }

                if (0 < _r190.length && !t._propertyChanging) {
                  var _n419 = [];

                  for (var _e1025 = 0; _e1025 < t.selectedValues.length; _e1025++) {
                    var _i862 = t.selectedValues[_e1025];
                    0 > _a566.indexOf(_i862) && _n419.push(t.getItem(_i862));
                  }

                  t.$.fireEvent("change", {
                    addedItems: _n419,
                    removedItems: _r190,
                    selected: e.selected,
                    disabled: e.disabled,
                    index: t._indexOf(e),
                    label: e.label,
                    value: e.value
                  });
                }

                return !0;
              }

              for (var _n420 = 0; _n420 < _a566.length; _n420++) {
                var _i863 = _a566[_n420],
                    _o309 = t.getItem(_i863);

                e !== _o309 && t.unselect(_o309);
              }

              return t.clearSelection(), t._select(e, 0 <= _a566.indexOf(e.value)), !0;
            }
        }

        return !1;
      }
    }
  }, {
    key: "_applyTemplate",
    value: function _applyTemplate(e, t) {
      var a = this;
      if (null === a.itemTemplate) return;
      if ("function" == typeof a.itemTemplate) return void a.itemTemplate(e, {
        label: e.label,
        value: e.value,
        index: a._items.indexOf(e)
      });
      if (!a._bindingDetails || 0 === a._bindingDetails.length) return;
      var i = a._bindingDetails.length;
      var n = document.importNode(a._template.content, !0),
          o,
          r;

      for (var _l129 = 0; _l129 < i; _l129++) {
        o = n.childNodes[a._bindingDetails[_l129].childNodeIndex], r = a._bindingDetails[_l129].bindingString.length;

        for (var _t868 = 0; _t868 < r; _t868++) {
          var _i864 = a._bindingDetails[_l129].bindingString[_t868],
              _n421 = 0 <= _i864.indexOf("label") ? e.label : e.value;

          o.innerHTML = o.innerHTML.replace(_i864, _n421);
        }
      }

      e.innerHTML = "";

      for (var _a567 = 0; _a567 < n.childNodes.length; _a567++) {
        n.childNodes[_a567].outerHTML && (e.innerHTML += n.childNodes[_a567].outerHTML);
      }

      !1 === t || (a._scrollHeightTimer && (clearInterval(a._scrollHeightTimer), a._scrollHeightCounter = 0), a._scrollHeightTimer = setInterval(function () {
        (a._lastScrollHeight !== a.$.itemsInnerContainer.scrollHeight || 10 === a._scrollHeightCounter) && (a._refreshLayout(), clearInterval(a._scrollHeightTimer)), a._lastScrollHeight = a.$.itemsInnerContainer.scrollHeight, a._scrollHeightCounter++;
      }, 50));
    }
  }, {
    key: "_filterItems",
    value: function _filterItems(e, t, i) {
      var a = this,
          n = a.$.filterInput.value;
      var o, r;

      var l = function l() {
        if (0 === r.length) return a._filteredItems = [], void (t && t());
        o = a._queryItems(n, a.filterMode);

        for (var _e1026 = 0; _e1026 < r.length; _e1026++) {
          r[_e1026].hidden = !0, r[_e1026].$.addClass("smart-hidden");
        }

        for (var _e1027 = 0; _e1027 < o.length; _e1027++) {
          var _t869 = o[_e1027];
          _t869.hidden = !1, _t869.$.removeClass("smart-hidden");
        }

        if (a.grouped && a.isVirtualized) for (var _e1028 = 0; _e1028 < a._groups.length; _e1028++) {
          var _t870 = a._groups[_e1028],
              _i865 = _t870.items;

          var _n422 = !0;

          for (var _e1029 = 0; _e1029 < _i865.length; _e1029++) {
            _i865[_e1029].hidden || (_n422 = !1);
          }

          _n422 && (_t870.hidden = !0);
        }
        if (a.grouped && !a.isVirtualized) for (var _e1030 = 0; _e1030 < a._groups.length; _e1030++) {
          var _ref;

          var _t871 = a._groups[_e1030],
              _i866 = (_ref = []).concat.apply(_ref, _toConsumableArray(_t871.querySelectorAll("smart-list-item")));

          var _n423 = !0;

          for (var _e1031 = 0; _e1031 < _i866.length; _e1031++) {
            _i866[_e1031].$.hasClass("smart-hidden") || (_n423 = !1);
          }

          _n423 ? _t871.$.addClass("smart-hidden") : _t871.$.removeClass("smart-hidden");
        }
        a._filteredItems = o, a._refreshLayout(), t && t();
        e || a._refreshSelection();
      };

      if ("function" != typeof a.dataSource) {
        if (r = a._items, 0 === r.length) return;
        l();
      } else if (n || i) {
        var _e1032 = a.dataSource(n, function (e) {
          (n || i) && a.isAttached && (a._updateListBoxAfterQuery = function () {
            o = r = a._items, l();
          }, a.clearItems(), a.insert(0, e));
        });

        if (_e1032) {
          if (!n && !i) return;
          a._updateListBoxAfterQuery = function () {
            o = r = a._items, l();
          }, a.clearItems(), a.insert(0, _e1032);
        }
      } else a.clearItems(), o = r = a._items, l();
    }
  }, {
    key: "_getNextItem",
    value: function _getNextItem(e) {
      var t = this,
          i = t._items,
          a = t._items.length;

      for (var _t872 = Math.max(e + 1, 0); _t872 < a;) {
        var _e1033 = i[_t872];
        if (!_e1033.disabled && !_e1033.hidden && !_e1033.grouped && !_e1033.readonly) return _e1033;
        _t872++;
      }

      return i[e];
    }
  }, {
    key: "_getPreviousItem",
    value: function _getPreviousItem(e) {
      var t = this,
          i = t._items;

      for (var _t873 = Math.max(e - 1, 0); -1 < _t873;) {
        var _e1034 = i[_t873];
        if (!_e1034.disabled && !_e1034.hidden && !_e1034.grouped && !_e1034.readonly) return _e1034;
        _t873--;
      }

      return i[e];
    }
  }, {
    key: "update",
    value: function update(e, t) {
      var i = this,
          a = i._items[e];

      if (a) {
        if ("string" == typeof t) a.label = t, void 0 === a.value && (a.value = t);else for (var _e1035 in t) {
          "selected" == _e1035 && a[_e1035] !== t[_e1035] ? i.select(a) : a[_e1035] = t[_e1035], "group" == _e1035 && i._refreshItems();
        }
        (i.sorted || i.grouped || i.isVirtualized) && (i._refreshItems(), i._refreshSelection());
      } else i.error(i.localize("indexOutOfBound", {
        elementType: i.nodeName.toLowerCase(),
        method: "update"
      }));
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var a = this;
      var n = [];

      if (e || (e = 0), Array.isArray(t)) {
        a.isUpdating++;

        for (var _o310 = 0; _o310 < t.length; _o310++) {
          var _i867 = t[_o310],
              _r191 = a._createItem(_i867);

          n.push(_r191), e >= a._items.length || 0 === a._items.length ? a.appendChild(_r191) : a.insertBefore(_r191, a._items[e]);
        }

        a.isUpdating--;
      } else {
        var _i868 = a._createItem(t);

        n.push(_i868), e >= a._items.length || 0 === a._items.length ? a.appendChild(_i868) : a.insertBefore(_i868, a._items[e]);
      }

      0 < n.length ? (n.map(function (e) {
        return a._applyTemplate(e);
      }), a._ensureItemsReady(n, function () {
        a._refreshItems(), 0 === a._items.length || (a._updateListBoxAfterQuery && (a._updateListBoxAfterQuery(), delete a._updateListBoxAfterQuery), a._refreshSelection(), a.$.fireEvent("bindingComplete"));
      })) : a._updateListBoxAfterQuery && (a._updateListBoxAfterQuery(), delete a._updateListBoxAfterQuery);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this,
          i = t._items[e];
      i ? (i.selected && t.unselect(i), t.isVirtualized ? t._items.splice(e, 1) : i.parentNode.removeChild(i), t._refreshItems(), t._refreshSelection(), 0 === t.selectedIndexes.length && 0 < t._items.length && ("oneOrMany" === t.selectionMode || "one" === t.selectionMode || "oneOrManyExtended" === t.selectionMode) && t.select(t._items[0])) : t.error(t.localize("indexOutOfBound", {
        elementType: t.nodeName.toLowerCase(),
        method: "remove"
      }));
    }
  }, {
    key: "_queryItems",
    value: function _queryItems(e, t) {
      var a = this,
          n = [],
          o = function o(i, n) {
        if (i.grouped) return i;

        switch (t) {
          case "startsWith":
            if (0 === i.label.indexOf(n)) return i;
            break;

          case "startsWithIgnoreCase":
            if (0 === i.label.toLowerCase().indexOf(n.toLowerCase())) return i;
            break;

          case "doesNotContain":
            if (0 > i.label.indexOf(n)) return i;
            break;

          case "doesNotContainIgnoreCase":
            if (0 > i.label.toLowerCase().indexOf(n.toLowerCase())) return i;
            break;

          case "contains":
            if (-1 < i.label.indexOf(n)) return i;
            break;

          case "containsIgnoreCase":
            if (-1 < i.label.toLowerCase().indexOf(n.toLowerCase())) return i;
            break;

          case "equals":
            if (0 === i.label.localeCompare(n)) return i;
            break;

          case "equalsIgnoreCase":
            if (0 === i.label.toLowerCase().localeCompare(n.toLowerCase())) return i;
            break;

          case "endsWith":
            if (i.label.endsWith(n)) return i;
            break;

          case "endsWithIgnoreCase":
            if (i.label.toLowerCase().endsWith(n.toLowerCase())) return i;
            break;

          case "custom":
            if (a.filterCallback(i, e)) return i;
        }

        return null;
      };

      if (0 === e.length) return a._items;

      for (var _r192 = 0; _r192 < a._items.length; _r192++) {
        var _t874 = o(a._items[_r192], e);

        _t874 && n.push(_t874);
      }

      return n;
    }
  }, {
    key: "_select",
    value: function _select(e, t) {
      var a = this,
          i = a.selectedIndexes.indexOf(a._indexOf(e)),
          n = a.selectedIndexes.slice(0),
          o = a.selectedValues.slice(0);
      if (e.selected = !0, -1 === i) n.push(a._indexOf(e)), o.push(e.value || e.label);else return a._recycle(), !1;

      if (a.selectedIndexes = n, a.selectedValues = o, a._recycle(), a.$.hiddenInput.value = o.toString(), a.isCompleted && !t && a.isInitialized && !a._propertyChanging) {
        var _t875 = [];

        if (a._previouslySelectedIndexes) {
          for (var _e1036 = 0; _e1036 < a._previouslySelectedIndexes.length; _e1036++) {
            0 > a.selectedIndexes.indexOf(a._previouslySelectedIndexes[_e1036]) && _t875.push(a._items[a._previouslySelectedIndexes[_e1036]]);
          }

          delete a._previouslySelectedIndexes;
        }

        return a.$.fireEvent("change", {
          addedItems: [e],
          removedItems: _t875,
          selected: e.selected,
          disabled: e.disabled,
          index: a._indexOf(e),
          label: e.label,
          value: e.value
        }), !0;
      }
    }
  }, {
    key: "_setTopVisibleIndex",
    value: function _setTopVisibleIndex(e) {
      var t = this;
      return "number" == typeof e && (t.topVisibleIndex = Math.max(0, e), e = t._items[t.topVisibleIndex]), !!e && void (e.top !== t.scrollTop && (t.scrollTop = e.top, !t.isVirtualized && (t.$.itemsContainer.scrollTop = t.scrollTop), t.scrollHeight === t.scrollTop && t._updateTopVisibleIndex()));
    }
  }, {
    key: "_updateTopVisibleIndex",
    value: function _updateTopVisibleIndex() {
      var e = this,
          t = e.scrollTop + e._scrollView.verticalScrollBar.offsetHeight - e.offsetHeight;
      var a;

      if (e.scrollTop < e.scrollHeight / 2) {
        for (var _n424 = 0; _n424 < e._items.length; _n424++) {
          if (e._items[_n424].top > t) {
            a = e._items[_n424];
            break;
          }
        }
      } else for (var _n425 = e._items.length - 1; 0 <= _n425 && !(e._items[_n425].top < t); _n425--) {
        a = e._items[_n425];
      }

      a && (e.topVisibleIndex = a.dataIndex);
    }
  }, {
    key: "unselect",
    value: function unselect(e) {
      var t = this;
      if (!e) return;
      if ("string" == typeof e && (e = t.getItem(e), !e)) return;
      if ("none" === t.selectionMode) return void t.clearSelection();
      var i = t.selectedIndexes.indexOf(t._indexOf(e)),
          a = t.selectedIndexes.slice(0),
          n = t.selectedValues.slice(0);
      if (e.selected = !1, 0 <= i) a.splice(i, 1), n.splice(i, 1);else return !1;
      return (t.selectedIndexes = a, t.selectedValues = n, t.$.hiddenInput.value = n.toString(), t.isCompleted && !t._propertyChanging) ? (t.$.fireEvent("change", {
        addedItems: [],
        removedItems: [e],
        selected: e.selected,
        disabled: e.disabled,
        index: t._indexOf(e),
        label: e.label,
        value: e.value
      }), t._recycle(), !0) : void 0;
    }
  }, {
    key: "_handleItemTemplate",
    value: function _handleItemTemplate(e) {
      if (null === e || !e) return;
      if ("function" == typeof e) return e;
      var t = this;
      if (!("content" in document.createElement("template"))) return t.error(t.localize("htmlTemplateNotSuported", {
        elementType: t.nodeName.toLowerCase()
      })), void (t.itemTemplate = null);
      if (e = document.getElementById(e), null === e || !("content" in e)) return t.error(t.localize("invalidTemplate", {
        elementType: t.nodeName.toLowerCase(),
        property: "itemTemplate"
      })), void (t.itemTemplate = null);
      var a = e.content,
          n = a.childNodes.length,
          o = /{{\w+}}/g;
      var r, l;
      t._bindingDetails = [], t._template = e;

      for (var _s92 = 0; _s92 < n; _s92++) {
        for (l = []; r = o.exec(a.childNodes[_s92].innerHTML);) {
          l.push(r[0]);
        }

        0 < l.length && t._bindingDetails.push({
          childNodeIndex: _s92,
          bindingString: l
        });
      }

      return !0;
    }
  }, {
    key: "_handleKeyStrokes",
    value: function _handleKeyStrokes(e) {
      var t = this,
          i = "radioButton" === t.selectionMode || "checkBox" === t.selectionMode || "zeroOrMany" === t.selectionMode || "oneOrMany" === t.selectionMode || "zeroOrOne" === t.selectionMode;
      var a = t._items;

      if (t.filterable && 0 < t.$.filterInput.value.length && (a = t._filteredItems), !(t.disabled || t.readonly || !a.length)) {
        switch (e) {
          case "ArrowLeft":
          case "ArrowUp":
            t._handleArrowKeys(!0);

            break;

          case "ArrowRight":
          case "ArrowDown":
            t._handleArrowKeys(!1);

            break;

          case " ":
            {
              if (1 > t.selectedIndexes.length && !t._focusedItem) return;

              var _e1037 = t._focusedItem ? t._focusedItem : t._items[t.selectedIndexes[t.selectedIndexes.length - 1]],
                  _i869 = function _i869(e) {
                e.selected && "radioButton" !== t.selectionMode ? t.unselect(e) : t.select(e);
              };

              if ("oneOrMany" === t.selectionMode) return void (_e1037.selected && 1 < t.selectedIndexes.length ? _i869(_e1037) : !_e1037.selected && _i869(_e1037));

              _i869(_e1037);

              break;
            }

          case "Home":
            {
              if (0 === a.length) return;
              i ? t._focus(a[0]) : (!t._keysPressed.Shift && t.clearSelection(), t.select(a[0]), t._focus(a[0])), t.scrollTop = 0;
              break;
            }

          case "End":
            {
              if (0 === a.length) return;
              i ? t._focus(a[a.length - 1]) : (!t._keysPressed.Shift && t.clearSelection(), t.select(a[a.length - 1]), t._focus(a[a.length - 1])), t.scrollTop = t.scrollHeight;
              break;
            }

          case "PageUp":
            {
              t._pageUpKeyHandler(a);

              break;
            }

          case "PageDown":
            {
              t._pageDownKeyHandler(a);

              break;
            }
        }

        t._recycle();
      }
    }
  }, {
    key: "_horizontalScrollbarHandler",
    value: function _horizontalScrollbarHandler(e) {
      var t = this;
      e.stopPropagation(), t.isVirtualized ? t._recycle() : t.$.itemsContainer.scrollLeft = t._getScrollLeft(e.detail.value);
    }
  }, {
    key: "_getScrollLeft",
    value: function _getScrollLeft(e, t) {
      var i = this;
      if (!i.rightToLeft) return e;

      if (Smart.Utilities.Core.Browser.Chrome) {
        if (!t) {
          var _e1038 = 2 * (parseInt(getComputedStyle(i.$.itemsInnerContainer).getPropertyValue("--smart-list-item-horizontal-offset")) || 0);

          t = i._scrollWidth - i.$.itemsContainer.offsetWidth - _e1038;
        }

        e = t - e;
      } else e *= -1;

      return e;
    }
  }, {
    key: "_unsort",
    value: function _unsort() {
      var e = this;
      e.isUpdating++;

      var t = function (_t876) {
        function t(_x16, _x17) {
          return _t876.apply(this, arguments);
        }

        t.toString = function () {
          return _t876.toString();
        };

        return t;
      }(function (e, t) {
        var i = e.dataIndex,
            a = t.dataIndex;
        return i < a ? -1 : i > a ? 1 : 0;
      });

      if (!e.isVirtualized) {
        if (0 < e._groups.length) {
          e._groups.sort(t);

          var _a568 = [];

          for (var _n426 = 0; _n426 < e._groups.length; _n426++) {
            var _ref2;

            var _i870 = e._groups[_n426],
                _o311 = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(_i870.querySelectorAll("smart-list-item")));

            _o311.sort(t), _a568 = _a568.concat(_o311);
          }

          e._items = _a568;
        } else e._items.sort(t);

        e._applySortOrder();
      } else if (0 < e._groups.length) {
        e._groups.sort(t);

        var _a569 = [];

        for (var _n427 = 0; _n427 < e._groups.length; _n427++) {
          var _ref3;

          var _i871 = e._groups[_n427],
              _o312 = (_ref3 = []).concat.apply(_ref3, _toConsumableArray(_i871.items));

          _o312.sort(t), _a569.push(_i871), _a569 = _a569.concat(_o312);
        }

        e._items = _a569;
      } else e._items.sort(t);

      e.isUpdating--;
    }
  }, {
    key: "_applySortOrder",
    value: function _applySortOrder() {
      var e = this,
          t = function t(e) {
        for (var _t877 = 0; _t877 < e.length; _t877++) {
          var _i872 = e[_t877],
              _a570 = _i872.parentNode;
          _a570 && _a570.appendChild(_i872);
        }
      };

      t(e._items), t(e._groups);
    }
  }, {
    key: "_sort",
    value: function _sort() {
      var e = this;

      if (e._canSort) {
        e.isUpdating++;

        var _t878 = function _t878(t, i) {
          var a = t.label,
              n = i.label;

          if ("asc" === e.sortDirection) {
            if (a < n) return -1;
            if (a > n) return 1;
          } else {
            if (a < n) return 1;
            if (a > n) return -1;
          }

          return 0;
        };

        if (e._groups.sort(_t878), !e.isVirtualized) {
          if (0 < e._groups.length) {
            var _a571 = [];

            for (var _n428 = 0; _n428 < e._groups.length; _n428++) {
              var _ref4;

              var _i873 = e._groups[_n428],
                  _o313 = (_ref4 = []).concat.apply(_ref4, _toConsumableArray(_i873.querySelectorAll("smart-list-item")));

              _o313.sort(_t878), _a571 = _a571.concat(_o313);
            }

            e._items = _a571;
          } else e._items.sort(_t878);

          e._applySortOrder();
        } else if (0 < e._groups.length) {
          var _a572 = [];

          for (var _n429 = 0; _n429 < e._groups.length; _n429++) {
            var _ref5;

            var _i874 = e._groups[_n429],
                _o314 = (_ref5 = []).concat.apply(_ref5, _toConsumableArray(_i874.items));

            _a572.push(_i874), _o314.sort(_t878), _a572 = _a572.concat(_o314);
          }

          e._items = _a572;
        } else e._items.sort(_t878);

        e.isUpdating--;
      }
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      var t = this;

      for (var _a573 = 0; _a573 < t._items.length; _a573++) {
        if (t._items[_a573].value === e) return t._items[_a573];
      }

      return null;
    }
  }, {
    key: "_focus",
    value: function _focus(e) {
      var t = this;
      !e || "none" === t.selectionMode || t.disabled || t.readonly || (t._focusedItem && (t._focusedItem._focused = !1), t._focusedItem = e, t._focusedItem._focused = !0);
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this,
          i = (t.shadowRoot || t.getRootNode()).activeElement || document.activeElement;
      var a = e.key;

      if (!(t.disabled || t.readonly) && !(t.filterable && t.$.filterInput === i) && t._focused && !(0 === t._items.length || t.disabled || t.displayLoadingIndicator)) {
        if (t.editable) {
          if ("F2" === a) return void t._dblclickEventHandler({
            target: t._focusedItem
          });
          if (t.$.editInput === i) return;
        }

        if ("none" !== t.selectionMode) {
          if (e.stopPropagation(), "Down" === a || "Right" === a || "Left" === a || "Up" === a ? a = "Arrow" + a : void 0, t.filterable) switch (a) {
            case "ArrowLeft":
            case "ArrowRight":
              return;

            case "ArrowUp":
            case "ArrowDown":
              e.preventDefault();
          }

          if (t._applyIncrementalSearch(a), !(0 > ["Shift", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Control", " ", "Home", "End", "PageUp", "PageDown"].indexOf(a))) {
            if (e.preventDefault(), !t._focusedItem && 0 < t._items.length) return void ("one" === t.selectionMode || "oneOrMany" === t.selectionMode || "oneOrManyExtended" === t.selectionMode ? t.select(t._items[0]) : t._focus(t._items[0]));

            switch (t.selectionMode) {
              case "one":
                if ("Shift" === a || "Control" === a || " " === a) return;

                t._handleKeyStrokes(a);

                break;

              case "oneOrMany":
              case "zeroOrOne":
              case "zeroOrMany":
              case "radioButton":
              case "checkBox":
                if ("Shift" === a || "Control" === a) return;

                t._handleKeyStrokes(a);

                break;

              case "oneOrManyExtended":
                if (" " === a) return;
                t._keysPressed[a] = "keydown" === e.type, t._handleKeyStrokes(a);
            }
          }
        }
      }
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this,
          i = (t.shadowRoot || t.getRootNode()).activeElement || document.activeElement;

      if (!(t.editable && t.$.editInput === i)) {
        if (t.filterable && t.$.filterInput === i) return t._filterTimer && clearTimeout(t._filterTimer), void (t._filterTimer = setTimeout(function () {
          var e = t.context;
          t.context = t, t._filterItems(), t.scrollTop = t.$.itemsContainer.scrollTop = 0, t.scrollLeft = t.$.itemsContainer.scrollLeft = t._getScrollLeft(0), t.context = e;
        }, 300));

        if (t._focused) {
          if (t._focusedItem && t._focusedItem.hidden && 0 < t._filteredItems.length) {
            var _e1039 = t._filteredItems[0];
            _e1039.grouped && 1 < t._filteredItems.length && (_e1039 = t._filteredItems[1]), t._focus(_e1039), t._recycle();
          }

          e.stopPropagation(), e.preventDefault(), t.disabled || 0 > ["Shift", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Control", " ", "PageUp", "PageDown"].indexOf(e.key) || (t._keysPressed[e.key] = !1);
        }
      }
    }
  }, {
    key: "_mouseWheelHandler",
    value: function _mouseWheelHandler(e) {
      var t = this;
      (t.computedHorizontalScrollBarVisibility || t.computedVerticalScrollBarVisibility) && (t.disabled || !t.computedVerticalScrollBarVisibility || (e.stopPropagation(), e.preventDefault(), t.scrollTo(t.scrollTop + t._getScrollCoefficient(e, t.offsetHeight))));
    }
  }, {
    key: "_pageDownKeyHandler",
    value: function _pageDownKeyHandler(e) {
      var t = this;
      if (0 === e.length) return;
      var i = t._items[t.selectedIndexes[t.selectedIndexes.length - 1]];
      ("checkBox" === t.selectionMode || "radioButton" === t.selectionMode || "zeroOrMany" === t.selectionMode || "oneOrMany" === t.selectionMode || "zeroOrOne" === t.selectionMode) && t._focusedItem && (i = t._focusedItem);
      var a;

      var n = t._indexOf(i);

      var o = i.top + t.$.itemsContainer.offsetHeight - i.height;

      for (var _t879 = n; _t879 < e.length; _t879++) {
        if (e[_t879].top >= o) {
          a = e[_t879];
          break;
        }
      }

      a || (a = e[e.length - 1]), "checkBox" === t.selectionMode || "radioButton" === t.selectionMode || "zeroOrMany" === t.selectionMode || "oneOrMany" === t.selectionMode || "zeroOrOne" === t.selectionMode ? t._focus(a) : !a.selected && (!t._keysPressed.Shift && t.clearSelection(), t.select(a), t._focus(a)), (a.height + a.top > t.$.itemsContainer.scrollTop + t.$.itemsContainer.offsetHeight || a.top < t.$.itemsContainer.scrollTop) && (t.scrollTop = a.top - t.$.itemsContainer.offsetHeight + a.height);
    }
  }, {
    key: "_pageUpKeyHandler",
    value: function _pageUpKeyHandler(e) {
      var t = this;
      if (0 === e.length) return;
      var i = t._items[t.selectedIndexes[t.selectedIndexes.length - 1]];
      ("checkBox" === t.selectionMode || "radioButton" === t.selectionMode || "zeroOrMany" === t.selectionMode || "oneOrMany" === t.selectionMode || "zeroOrOne" === t.selectionMode) && t._focusedItem && (i = t._focusedItem);

      var a = i.top - t.$.itemsContainer.offsetHeight,
          n = t._indexOf(i);

      var o;

      for (var _t880 = n; 0 < _t880; _t880--) {
        if (e[_t880].top <= a) {
          o = e[_t880];
          break;
        }
      }

      o || (o = e[0]), "checkBox" === t.selectionMode || "radioButton" === t.selectionMode || "zeroOrMany" === t.selectionMode || "oneOrMany" === t.selectionMode || "zeroOrOne" === t.selectionMode ? t._focus(o) : !o.selected && (!t._keysPressed.Shift && t.clearSelection(), t.select(o), t._focus(o)), t.scrollTop = o.top;

      var r = t._indexOf(o);

      0 === r && (t.scrollTop = 0);
    }
  }, {
    key: "clearItems",
    value: function clearItems() {
      var e = this;
      e.clearSelection(), e.$.itemsInnerContainer.innerHTML = "", e._items = [], e.$placeholder.removeClass("smart-hidden");
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler(e) {
      var t = this;
      e.target !== t || t._isUpdatingScrollBars || (t._isUpdatingScrollBars = !0, t._initializeRecyclingItems(), t._refreshLayout(), t._isUpdatingScrollBars = !1);
    }
  }, {
    key: "_indexOf",
    value: function _indexOf(e) {
      var t = this;
      if (!e) return -1;

      var i = t._items.indexOf(e);

      return -1 === i && (i = t._items.indexOf(t.getItem(e.value))), i;
    }
  }, {
    key: "_incrementalSearch",
    value: function _incrementalSearch() {
      var e = this,
          t = "radioButton" !== e.selectionMode && "checkBox" !== e.selectionMode && "zeroOrMany" !== e.selectionMode && "oneOrMany" !== e.selectionMode && "zeroOrOne" !== e.selectionMode;
      var a = 0,
          n;

      switch (e.incrementalSearchMode) {
        case "containsIgnoreCase":
        case "equalsIgnoreCase":
        case "startsWithIgnoreCase":
        case "endsWithIgnoreCase":
          n = e._incrementalSearchQuery.toLowerCase();
          break;

        default:
          n = e._incrementalSearchQuery;
      }

      var o = function o(i) {
        i.grouped || i.readonly || (t ? (0 < e.selectedIndexes.length && e.clearSelection(), e._focus(i), e.select(i)) : e._focus(i), (i.height + i.top > e.$.itemsContainer.scrollTop + e.$.itemsContainer.offsetHeight || i.top < e.scrollTop) && (e.scrollTop = i.top), 0 === e._indexOf(i) && (e.scrollTop = 0), e._indexOf(i) === e._items.length - 1 && (e.scrollTop = e.scrollHeight));
      };

      0 !== e._previousEntry.localeCompare(n) && (e._incrementalSearchItems = e._queryItems(e._incrementalSearchQuery, e.incrementalSearchMode), delete e._itemPosition), e._previousEntry = n;
      var r = e._incrementalSearchItems.length;

      if (0 !== r) {
        if (1 === r) return void o(e._incrementalSearchItems[0]);

        for (void 0 === e._itemPosition ? t && e.clearSelection() : e._itemPosition < r - 1 ? a = e._itemPosition : (a = 0, t ? (e._incrementalSearchItems[e._itemPosition].selected = !1, e.selectedIndexes = [], e.selectedValues = []) : e._incrementalSearchItems[e._itemPosition]._focused = !1), a; a < r; a++) {
          if (e._incrementalSearchItems[a].selected && t) {
            e._incrementalSearchItems[a].selected = !1, e.selectedIndexes = [], e.selectedValues = [];
            continue;
          }

          if (!t && e._incrementalSearchItems[a]._focused) {
            e._incrementalSearchItems[a]._focused = !1;
            continue;
          }

          return o(e._incrementalSearchItems[a]), void (e._itemPosition = a);
        }
      }
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      var t = this,
          i = (t.shadowRoot || t.getRootNode()).activeElement;
      t.$.filterInput === i || t.$.editInput === i || e.preventDefault();
    }
  }, {
    key: "_handleArrowKeys",
    value: function _handleArrowKeys(e) {
      var t = this,
          i = "radioButton" !== t.selectionMode && "checkBox" !== t.selectionMode && "zeroOrMany" !== t.selectionMode && "oneOrMany" !== t.selectionMode && "zeroOrOne" !== t.selectionMode;
      if (t.disabled || t.readonly) return;
      var a;
      if (t._focusedItem && !t._keysPressed.Shift) a = t._indexOf(t._focusedItem), t._focusedItem._focused = !1;else if (0 !== t.selectedIndexes.length) a = t.selectedIndexes[t.selectedIndexes.length - 1];else return;
      var n = e ? t._getPreviousItem(a) : t._getNextItem(a);
      t._focus(n), i && (t._keysPressed.Shift ? t.select(n) : t._items[a] !== n && (t.clearSelection(), t.select(n))), t.ensureVisible(n);
    }
  }, {
    key: "_refreshFilter",
    value: function _refreshFilter() {
      var e = this;
      return e.filterable ? (e.$.filterInput.disabled = !!(e.disabled || e.displayLoadingIndicator), e.$filterInputContainer.removeClass("smart-hidden"), void e.$itemsContainer.addClass("filter")) : void (e.$.filterInput.disabled = !0, e.$filterInputContainer.addClass("smart-hidden"), e.$itemsContainer.removeClass("filter"));
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void e.removeAttribute("tabindex") : void (e.tabIndex = 0 < e.tabIndex ? e.tabIndex : 0);
    }
  }, {
    key: "_setLoadingIndicatorVisibility",
    value: function _setLoadingIndicatorVisibility() {
      var e = this;
      return e.displayLoadingIndicator ? void (e.$loadingIndicatorContainer.hasClass("smart-visibility-hidden") ? e.$loadingIndicatorContainer.removeClass("smart-visibility-hidden") : e.$loadingIndicatorContainer.removeClass("smart-hidden")) : void (e._areCSSVarsSupported ? e.$loadingIndicatorContainer.addClass("smart-hidden") : e.$loadingIndicatorContainer.addClass("smart-visibility-hidden"));
    }
  }, {
    key: "_refreshLayout",
    value: function _refreshLayout() {
      var e = Math.max;
      var t = this,
          i = t._items;
      if (t.__scrollHeight = null, t.__scrollWidth = null, t._height = null, t._scrollView || (t._scrollView = new Smart.Utilities.Scroll(t, t.$.horizontalScrollBar, t.$.verticalScrollBar)), t.$itemsContainer.removeClass("hscroll"), t.$itemsContainer.removeClass("vscroll"), !i || null === i || 0 === i.length) return t.scrollWidth = 0, t.scrollHeight = 0, t.$filterInputContainer.removeClass("vscroll"), t.$placeholder.removeClass("smart-hidden"), void (t.isVirtualized && t._recycle());
      t.$placeholder.addClass("smart-hidden");
      var a = 2 * (parseInt(getComputedStyle(t.$.itemsInnerContainer).getPropertyValue("--smart-list-item-horizontal-offset")) || 0);
      var n = t._scrollWidth - t.$.itemsContainer.offsetWidth - a,
          o = t._scrollHeight;
      if (t._refreshHorizontalScrollBarVisibility(n), t._refreshVerticalScrollBarVisibility(o), t.$.itemsInnerContainer.style.width = "hidden" === t.horizontalScrollBarVisibility ? t.$.itemsContainer.offsetWidth - a : e(t.$.itemsContainer.offsetWidth - a, -a + t.__scrollWidth) + "px", t.computedVerticalScrollBarVisibility) return n = t._scrollWidth - t.$.itemsContainer.offsetWidth - t._scrollView.vScrollBar.offsetWidth, t._refreshHorizontalScrollBarVisibility(n), "hidden" !== t.horizontalScrollBarVisibility && (t.$.itemsInnerContainer.style.width = e(t.$.itemsContainer.offsetWidth - a, -a + t.__scrollWidth - t._scrollView.vScrollBar.offsetWidth) + "px"), t.computedHorizontalScrollBarVisibility && ("visible" === t.horizontalScrollBarVisibility && 0 === t.scrollWidth ? "visible" === t.horizontalScrollBarVisibility && (t.__scrollHeight += t._scrollView.hScrollBar.offsetHeight) : t.__scrollHeight += t._scrollView.hScrollBar.offsetHeight, t.scrollHeight = t.__scrollHeight), void (t.isVirtualized && t._recycle());
      n = t._scrollWidth - t.$.itemsContainer.offsetWidth - a, t._refreshHorizontalScrollBarVisibility(n), t.computedHorizontalScrollBarVisibility && (t.scrollHeight = t._scrollHeight, t._refreshVerticalScrollBarVisibility(t.scrollHeight), t._scrollView.vScrollBar.$.hasClass("bottom-corner") && t._scrollView.vScrollBar.refresh()), t.isVirtualized && t._recycle();
      var r = /Trident|Edge/.test(navigator.userAgent);
      !t.isRefreshing && r && setTimeout(function () {
        t.isRefreshing = !0, t._refreshLayout(), t.isRefreshing = !1;
      }, 50);
    }
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler() {
      var e = this;

      e._refreshLayout();
    }
  }, {
    key: "_swipeLeftHandler",
    value: function _swipeLeftHandler() {}
  }, {
    key: "_swipeRightHandler",
    value: function _swipeRightHandler() {}
  }, {
    key: "_refreshHorizontalScrollBarVisibility",
    value: function _refreshHorizontalScrollBarVisibility(e) {
      var t = this;
      t.scrollWidth = e, t.computedHorizontalScrollBarVisibility ? (t.scrollLeft = t._getScrollLeft(t.$.itemsContainer.scrollLeft, e), t.$itemsContainer.addClass("hscroll")) : t.$itemsContainer.removeClass("hscroll");
    }
  }, {
    key: "_refreshVerticalScrollBarVisibility",
    value: function _refreshVerticalScrollBarVisibility(e) {
      var t = this;
      t.scrollHeight = e, t.computedVerticalScrollBarVisibility ? (t.$itemsContainer.addClass("vscroll"), t.$filterInputContainer.addClass("vscroll")) : (t.$itemsContainer.removeClass("vscroll"), t.$filterInputContainer.removeClass("vscroll"));
    }
  }, {
    key: "_validateTemplate",
    value: function _validateTemplate(e, t) {
      if (null !== t && t) {
        var _i875 = this;

        return "content" in document.createElement("template") ? (t = document.getElementById(t), null !== t && "content" in t ? t : (_i875.error(_i875.localize("invalidTemplate", {
          elementType: _i875.nodeName.toLowerCase(),
          property: e
        })), void (_i875[e] = null))) : (_i875.error(_i875.localize("htmlTemplateNotSuported", {
          elementType: _i875.nodeName.toLowerCase()
        })), void (_i875[e] = null));
      }
    }
  }, {
    key: "_getItemIndexByPosition",
    value: function _getItemIndexByPosition(e) {
      var t = this,
          i = t.filterable && 0 < t.$.filterInput.value.length ? t._filteredItems : t._items,
          a = function (i) {
        var a = 0,
            n = i.length - 1;
        if (0 >= e) return 0;
        var o = i[i.length - 1];
        if (o.top <= e) return i.length - 1;

        for (; !0;) {
          var _o315 = Math.floor((a + n) / 2),
              _r193 = i[_o315];

          if (t._isItemInPosition(_r193, e)) return _o315;
          _r193.top < e ? a = _o315 + 1 : _r193.top > e && (n = _o315 - 1);
        }
      }(i);

      return a;
    }
  }, {
    key: "_isItemInPosition",
    value: function _isItemInPosition(e, t) {
      var i = e.top,
          a = e.top + e.height;
      return i <= t && a > t;
    }
  }, {
    key: "_recycle",
    value: function _recycle() {
      var e = this;
      if (!e._recyclingItems) return;
      var t = e._height;
      e._height || (t = e._height = e.$.itemsContainer.offsetHeight);
      var a = 0;

      var n = e.scrollTop,
          o = e._getItemIndexByPosition(n),
          r = e.filterable && 0 < e.$.filterInput.value.length ? e._filteredItems : e._items,
          i = r[o];

      var l = i ? i.top : 0;

      if (e.$.itemsInnerContainer.style.left = -e.scrollLeft + "px", e.$.itemsInnerContainer.style.top = -n + l + "px", e.isUpdating++, 0 <= o) {
        var _s93 = r.length;

        for (var d = o; d < _s93; d++) {
          var _i876 = r[d];

          if (0 !== _i876.height) {
            if (l + _i876.height >= n && l <= n + t) {
              var _t881 = e._recyclingItems[a++];
              if (!_t881) break;
              _t881.setAttribute("aria-setsize", _s93), _t881.setAttribute("aria-posinset", d), _t881.context = document, _t881.dataItem = _i876, _t881.label = _i876.label, _t881.value = _i876.value, _t881.selected = _i876.selected, _t881._focused = _i876._focused, _t881.hidden = _i876.hidden, _t881.grouped = _i876.grouped, _t881.readonly = _i876.readonly, _t881.style.height = _i876.height + "px", e._alternateItem(_t881), _t881.title = _i876.title ? _i876.title : "", _t881.displayMode = _i876.grouped ? "plain" : _i876.displayMode, 0 < e.scrollWidth && (_t881.style.width = e.$.itemsInnerContainer.offsetWidth + e.scrollWidth + "px"), e.itemTemplate && e._handleItemTemplate(e.itemTemplate) && e._applyTemplate(_t881, !1);
            } else break;

            l += _i876.height;
          }
        }
      }

      if (a < e._recyclingItems.length) for (var _t882 = a; _t882 < e._recyclingItems.length; _t882++) {
        var _t883 = e._recyclingItems[a++],
            _i877 = _t883.context;
        _t883.context = document, _t883.hidden = !0, _t883.context = _i877;
      }
      e.isUpdating--;
    }
  }, {
    key: "_verticalScrollbarHandler",
    value: function _verticalScrollbarHandler(e) {
      var t = this,
          i = e.detail.value;
      return e.stopPropagation(), t.isVirtualized ? t._recycle() : t.$.itemsContainer.scrollTop = i, t._updateTopVisibleIndex(), e.context.max === e.context.value ? void t.$.fireEvent("scrollBottomReached") : void (e.context.min === e.context.value && t.$.fireEvent("scrollTopReached"));
    }
  }, {
    key: "_applyAriaSelected",
    value: function _applyAriaSelected() {
      var e = this,
          t = e.isVirtualized ? e._recyclingItems : e._items,
          a = e.selectionMode;

      for (var _e1040 = 0; _e1040 < t.length; _e1040++) {
        var _i878 = t[_e1040];
        _i878.selected ? _i878.setAttribute("aria-selected", !0) : _i878.readonly || _i878.disabled || -1 === ["oneOrManyExtended", "zeroOrMany", "oneOrMany", "checkBox"].indexOf(a) ? _i878.removeAttribute("aria-selected") : _i878.setAttribute("aria-selected", !1);
      }
    }
  }, {
    key: "items",
    get: function get() {
      var e = this;
      return e._filteredItems ? e._filteredItems : e._items;
    }
  }, {
    key: "_scrollHeight",
    get: function get() {
      var e = this;
      var t = 0;

      if (e.isVirtualized) {
        if (e.__scrollHeight) return e.__scrollHeight;
        if (0 === e._items.length) return 0;
        e.isUpdating++;

        var _a574 = e._createItem(e.dataSource[0]);

        e.$.itemsInnerContainer.appendChild(_a574);

        for (var _n430 = 0; _n430 < e._items.length; _n430++) {
          var _i879 = e._items[_n430];

          if (_i879.hidden) {
            _i879.height = 0, _i879.top = t;
            continue;
          }

          e.itemHeight ? (32 > e.itemHeight && (e.itemHeight = 32), _i879.height = e.itemHeight) : (_a574.label = _i879.label, _i879.height = _a574.offsetHeight), _i879.top = t, t += _i879.height;
        }

        e.$.itemsInnerContainer.removeChild(_a574), e.__scrollHeight = t - e.$.itemsInnerContainer.offsetHeight, e.filterable && (e.__scrollHeight += e.$.filterInput.offsetHeight), t = e.__scrollHeight, e.isUpdating--;
      } else {
        for (var _a575 = 0; _a575 < e._items.length; _a575++) {
          var _i880 = e._items[_a575];

          if (_i880.hidden) {
            _i880.height = 0, _i880.top = t;
            continue;
          }

          e.itemHeight ? "auto" !== e.itemHeight && (_i880.height = e.itemHeight, _i880.style.height = _i880.height + "px") : _i880.height = _i880.offsetHeight, _i880.top = _i880.offsetTop, t += _i880.height;
        }

        t = e.$.itemsInnerContainer.scrollHeight - e.$.itemsInnerContainer.offsetHeight, e.filterable && 0 < t && (t += e.$.filterInput.offsetHeight), e.__scrollHeight = t;
      }

      return t;
    }
  }, {
    key: "_scrollWidth",
    get: function get() {
      var _this11 = this;

      var e = this,
          t = e._items;
      return e.__scrollWidth ? e.__scrollWidth : (e.__scrollWidth = function () {
        var e = _this11,
            a = e.virtualized;
        var n = "",
            i;

        for (var _e1041 = 0; _e1041 < t.length; _e1041++) {
          if (t[_e1041].hidden) continue;

          var _i881 = void 0;

          _i881 = a ? t[_e1041].label : t[_e1041].textContent.trim(), _i881.length > n.length && (n = _i881);
        }

        var o = e._createItem({
          label: n
        });

        o.style.position = "absolute", e.$.itemsContainer.appendChild(o), o.label = n, o.style.width = "auto", o.isCompleted && (o.$.itemContainer.style.width = "auto");
        var r = getComputedStyle(o),
            l = parseInt(r.paddingLeft) + parseInt(r.paddingRight);
        return i = (o.$.itemContainer || o).offsetWidth + l, o.parentNode.removeChild(o), i;
      }(), e.__scrollWidth);
    }
  }, {
    key: "isVirtualized",
    get: function get() {
      var e = this;
      return e.virtualized && e.dataSource && 0 < e.dataSource.length;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        allowDrag: {
          value: !1,
          type: "boolean"
        },
        allowDrop: {
          value: !1,
          type: "boolean"
        },
        alternationStart: {
          value: 0,
          type: "int"
        },
        alternationEnd: {
          value: 0,
          type: "int"
        },
        alternationCount: {
          value: 0,
          type: "int"
        },
        autoSort: {
          value: !0,
          type: "boolean"
        },
        dataSource: {
          value: null,
          type: "any?",
          reflectToAttribute: !1
        },
        dragFeedbackFormatFunction: {
          value: null,
          type: "function?"
        },
        dragOffset: {
          value: [10, 10],
          type: "array"
        },
        displayLoadingIndicator: {
          value: !1,
          type: "boolean"
        },
        displayMember: {
          value: "",
          type: "string"
        },
        shadowDomMode: {
          allowedValues: ["light", "shadow"],
          value: "shadow",
          type: "string"
        },
        dropAction: {
          value: "move",
          type: "string",
          allowedValues: ["copy", "move", "none"]
        },
        editable: {
          value: !1,
          type: "boolean"
        },
        filterable: {
          value: !1,
          type: "boolean"
        },
        filterCallback: {
          value: null,
          type: "function?"
        },
        filterMode: {
          value: "containsIgnoreCase",
          allowedValues: ["contains", "containsIgnoreCase", "doesNotContain", "doesNotContainIgnoreCase", "equals", "equalsIgnoreCase", "startsWith", "startsWithIgnoreCase", "endsWith", "endsWithIgnoreCase", "custom"],
          type: "string"
        },
        filterInputPlaceholder: {
          value: "",
          type: "string"
        },
        grouped: {
          value: !1,
          type: "boolean"
        },
        groupMember: {
          value: "",
          type: "string"
        },
        itemTemplate: {
          value: null,
          type: "any"
        },
        itemHeight: {
          value: null,
          type: "number?"
        },
        incrementalSearchDelay: {
          value: 700,
          type: "number?"
        },
        incrementalSearchMode: {
          value: "startsWithIgnoreCase",
          allowedValues: ["contains", "containsIgnoreCase", "doesNotContain", "doesNotContainIgnoreCase", "equals", "equalsIgnoreCase", "startsWith", "startsWithIgnoreCase", "endsWith", "endsWithIgnoreCase"],
          type: "string"
        },
        loadingIndicatorPlaceholder: {
          value: "Loading...",
          type: "string"
        },
        loadingIndicatorPosition: {
          value: "center",
          allowedValues: ["bottom", "center", "top"],
          type: "string"
        },
        messages: {
          extend: !0,
          value: {
            en: {
              overridingProperties: "{{elementType}}: Overriding properties {{property1}} and {{property2}} applied. The \"{{property1}}\" property is used by default.",
              invalidIndex: "{{elementType}}: \"{{method}}\" method accepts an index of type number or an Array of numbers.",
              indexOutOfBound: "{{elementType}}: Out of bound index/indexes in \"{{method}}\" method.",
              invalidItem: "{{elementType}}: \"{{method}}\" method accepts an object or an array of objects as it's second parameter.",
              invalidSettings: "{{elementType}}: \"{{method}}\" method accepts a string or an object as it's second parameter."
            }
          },
          type: "object"
        },
        name: {
          value: "",
          type: "string"
        },
        placeholder: {
          value: "No Items",
          type: "string"
        },
        selectedIndexes: {
          value: [],
          type: "array"
        },
        selectedValues: {
          value: [],
          type: "array"
        },
        selectionMode: {
          value: "oneOrManyExtended",
          allowedValues: ["none", "oneOrManyExtended", "zeroOrMany", "oneOrMany", "zeroOrOne", "one", "checkBox", "radioButton"],
          type: "string"
        },
        selectionChangeAction: {
          value: "release",
          allowedValues: ["press", "release"],
          type: "string"
        },
        sorted: {
          value: !1,
          type: "boolean"
        },
        sortDirection: {
          value: "asc",
          type: "string"
        },
        topVisibleIndex: {
          value: -1,
          type: "int"
        },
        type: {
          value: "list",
          type: "string",
          defaultReflectToAttribute: !0,
          readonly: !0
        },
        valueMember: {
          value: "",
          type: "string"
        },
        virtualized: {
          value: !1,
          type: "boolean"
        }
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.ScrollBar": "smart.scrollbar.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.listbox.css", "smart.dropdown.css", "smart.scrollbar.css"];
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        focus: "_focusHandler",
        blur: "_blurHandler",
        "container.wheel": "_mouseWheelHandler",
        "editInput.change": "_editInputEventHandler",
        "editInput.blur": "_editInputEventHandler",
        "editInput.keydown": "_editInputEventHandler",
        "horizontalScrollBar.change": "_horizontalScrollbarHandler",
        "itemsInnerContainer.down": "_downHandler",
        "itemsInnerContainer.dblclick": "_dblclickEventHandler",
        "itemsInnerContainer.move": "_itemsContainerMoveHandler",
        "itemsContainer.mouseleave": "_mouseLeaveHandler",
        "document.up": "_upHandler",
        "document.move": "_moveHandler",
        keydown: "_keyDownHandler",
        keyup: "_keyUpHandler",
        resize: "_resizeHandler",
        selectstart: "_selectStartHandler",
        styleChanged: "_styleChangedHandler",
        swipeleft: "_swipeLeftHandler",
        swiperight: "_swipeRightHandler",
        "verticalScrollBar.change": "_verticalScrollbarHandler"
      };
    }
  }]);

  return _class93;
}(Smart.ScrollViewer)), Smart("smart-card-view",
/*#__PURE__*/
function (_Smart$BaseElement21) {
  "use strict";

  _inherits(_class94, _Smart$BaseElement21);

  function _class94() {
    _classCallCheck(this, _class94);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class94).apply(this, arguments));
  }

  _createClass(_class94, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"header\" class=\"smart-card-view-header smart-hidden\">\n                        <div id=\"customizeCardsButton\" class=\"smart-card-view-header-button smart-card-view-customize-button smart-unselectable\"><div></div></div>\n                        <div id=\"filterButton\" class=\"smart-card-view-header-button smart-card-view-filter-button smart-unselectable\"><div></div></div>\n                        <div id=\"sortButton\" class=\"smart-card-view-header-button smart-card-view-sort-button smart-unselectable\"><div></div></div>\n                        <div id=\"searchButton\" class=\"smart-card-view-header-button smart-card-view-search-button smart-unselectable\"></div>\n                        <div id=\"headerDropDown\" class=\"smart-card-view-header-drop-down smart-visibility-hidden\">\n                            <div id=\"customize\" class=\"smart-hidden\"></div>\n                            <div id=\"filter\" class=\"smart-hidden\"></div>\n                            <div id=\"sort\" class=\"smart-hidden\"></div>\n                            <div id=\"search\" class=\"smart-card-view-search-box smart-hidden\">\n                                <input type=\"text\" id=\"searchInput\" spellcheck=\"false\" />\n                                <div id=\"searchLabel\" class=\"smart-card-view-search-label smart-unselectable\"></div>\n                                <div id=\"searchPrev\" class=\"smart-card-view-search-prev\"></div>\n                                <div id=\"searchNext\" class=\"smart-card-view-search-next\"></div>\n                                <div id=\"searchClose\" class=\"smart-card-view-search-close\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <smart-scroll-viewer id=\"scrollViewer\" animation=\"[[animation]]\" horizontal-scroll-bar-visibility=\"hidden\">\n                        <div id=\"cardContainer\" class=\"smart-card-container\"></div>\n                    </smart-scroll-viewer>\n                    <div id=\"loadingIndicatorContainer\" class=\"smart-loader-container smart-hidden\">\n                        <span id=\"loadingIndicator\" class=\"smart-loader\"></span>\n                    </div>\n                    <div id=\"addNewButton\" class=\"smart-add-new-button\"></div>\n                </div>";
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;
      _get(_getPrototypeOf(_class94.prototype), "attached", this).call(this), e.isCompleted && e._editInfo && (e._addWindowHandlers(), document.body.appendChild(e._editInfo.window));
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;

      if (_get(_getPrototypeOf(_class94.prototype), "detached", this).call(this), !!e._editInfo) {
        var _t884 = e._editInfo.window;
        _t884.removeEventListener("open", e._windowEventHandler), _t884.removeEventListener("closing", e._windowEventHandler), _t884.removeEventListener("close", e._windowEventHandler), _t884.removeEventListener("click", e._windowClickHandler), _t884.removeEventListener("prev", e._prevNextHandler), _t884.removeEventListener("next", e._prevNextHandler), _t884.remove();
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class94.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this,
          t = e.dataSource,
          i = e.scrolling,
          a = getComputedStyle(e);
      Smart.Utilities.NumberRenderer && (e._numericFormatter = new Smart.Utilities.NumberRenderer()), e.shadowRoot && (e.importStyle(Smart.Utilities.Core.getScriptLocation() + Smart.StyleBaseUrl.replace("/scoped/", "/smart.scrollviewer.css")), e.importStyle(Smart.Utilities.Core.getScriptLocation() + Smart.StyleBaseUrl.replace("/scoped/", "/smart.carousel.css")), e.importStyle(Smart.Utilities.Core.getScriptLocation() + Smart.StyleBaseUrl.replace("/scoped/", "/smart.button.css")), e.importStyle(Smart.Utilities.Core.getScriptLocation() + Smart.StyleBaseUrl.replace("/scoped/", "/smart.sortable.css"))), e._gap = parseFloat(a.getPropertyValue("--smart-card-view-gap")), e._verticalOffset = parseFloat(a.getPropertyValue("--smart-card-view-vertical-offset")), e._cards = [], e._collapsed = {}, e._collapsedRows = {}, e._numberOfCollapsedRows = 0, e._cardScrolling = {}, e._cardSelectedCover = {}, e._cardHeight = e.cardHeight, e._autoCardHeight = null === e._cardHeight, e._cachedWidth = e.offsetWidth, e._cachedHeight = e.offsetHeight, e._appliedFiltering = {
        filters: [],
        operator: "and"
      }, e._appliedSorting = {
        dataFields: [],
        dataTypes: [],
        orderBy: []
      }, e._start = {
        view: 0,
        data: 0
      }, e._autoScrollCoefficient = Smart.Utilities.Core.Browser.Firefox ? 8 : Smart.Utilities.Core.Browser.Edge ? 16 : 4, e._isMobile = Smart.Utilities.Core.isMobile, e._normalizeDataSource(), e._getVisibleRecords(), e._normalizeColumns(), e._handleHeaderPosition(), e._localizeHeader(), e._getInnerElementMessages(), "deferred" === i ? e.$.scrollViewer.$.verticalScrollBar.mechanicalAction = "switchWhenReleased" : ("virtual" === i || "infinite" === i) && t && t.onVirtualDataSourceRequested === void 0 && (e.scrolling = "physical"), e._createTemplate(), "infinite" === i ? e._requestInitialCards() : e._createCards(), e.$.scrollViewer._verticalScrollbarHandler = e._onVerticalChange.bind(e), e.$.scrollViewer.hasStyleObserver = !1, e.$.scrollViewer.$.verticalScrollBar.hasStyleObserver = !1, e.$.scrollViewer.$.horizontalScrollBar.hasStyleObserver = !1, _get(_getPrototypeOf(_class94.prototype), "render", this).call(this);
    }
  }, {
    key: "addFilter",
    value: function addFilter(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "and";
      var i = this;
      if (!Array.isArray(e) || 0 < e.length && !Array.isArray(e[0])) return;
      var a;

      if (i.closePanel(), arguments[2] ? a = {
        filters: arguments[2],
        operator: t
      } : (a = {
        filters: [],
        operator: t
      }, e.forEach(function (e) {
        e[1].filters.forEach(function (t) {
          a.filters.push([e[0], t.condition, t.value]);
        });
      })), JSON.stringify(a) !== JSON.stringify(i._appliedFiltering)) {
        var _n431 = a.filters.length;
        i._appliedFiltering = a;

        try {
          i.dataSource._filter(e, t);
        } catch (e) {
          return;
        }

        return i._getVisibleRecords(), i._fullRefresh(), i.$.fireEvent("filter"), 0 === _n431 ? (i.$.filterButton.firstElementChild.innerHTML = i.localize("filter"), void i.$.filterButton.classList.remove("filtered")) : void (i.$.filterButton.firstElementChild.innerHTML = 1 === _n431 ? i.localize("filteredByOne") : i.localize("filteredByMultiple", {
          n: _n431
        }), i.$.filterButton.classList.add("filtered"));
      }
    }
  }, {
    key: "addRecord",
    value: function addRecord(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "last";

      function a() {
        "first" === i ? (r.insert(0, t), r !== o._visibleSource && o._visibleSource.unshift(r[0])) : (i = "last", r.insert(r.length, t), r !== o._visibleSource && o._visibleSource.push(r[r.length - 1])), o._closeSearchPanel(), o._fullRefresh();
      }

      function n(e) {
        e && a();
      }

      var o = this,
          r = o.dataSource,
          l = o.scrolling;

      if ("object" == typeof t) {
        if (0 === o.dataSource.dataFields.length) {
          var _e1042 = [t];
          return o.dataSource = _e1042, void o.propertyChangedHandler("dataSource", null, _e1042);
        }

        var _s94 = r.id;
        return _s94 && (null !== e && void 0 !== e && "" !== e ? t[_s94] = e : void 0 === t[_s94] && (r[0] && !r[0].isEmpty && "number" == typeof r[0].$.id ? t[_s94] = Math.floor(Math.random() * (1e6 - r.length)) + r.length : t[_s94] = Math.random().toString(36).substring(7))), "physical" === l || "deferred" === l ? void a() : void (o.onRecordInserted && o.onRecordInserted(_s94 ? t[_s94] : e, t, i, n));
      }
    }
  }, {
    key: "addSort",
    value: function addSort(e, t) {
      function i(e, i) {
        var o = a.columns.find(function (t) {
          return t.dataField === e;
        });

        if (o) {
          var _a576 = Array.isArray(t) ? t[i] : "string" == typeof t ? t : "ascending";

          r.dataFields.push(e), r.dataTypes.push(n.dataFields.find(function (t) {
            return t.name === e;
          }).dataType), _a576 = -1 === _a576.indexOf("desc") ? "ascending" : "descending", r.orderBy.push(_a576);
        }
      }

      var a = this,
          n = a.dataSource,
          o = JSON.stringify(a._appliedSorting);
      var r;

      if (0 !== arguments.length && n && 0 !== n.length) {
        if (a.closePanel(), 1 === arguments.length && "object" == typeof e) r = e;else if (r = {
          dataFields: [],
          dataTypes: [],
          orderBy: []
        }, Array.isArray(e)) e.forEach(i);else if ("string" == typeof e) i(e, 0);else return;

        if (a.closePanel(), a._appliedSorting = r, o !== JSON.stringify(a._appliedSorting)) {
          var _e1043 = a._appliedSorting.dataFields.length;
          if (n.sortBy(r.dataFields, r.dataTypes, r.orderBy), a._getVisibleRecords(), a._refreshCardContent(), a.$.fireEvent("sort"), 0 === _e1043) return a.$.sortButton.firstElementChild.innerHTML = a.localize("sort"), void a.$.sortButton.classList.remove("sorted");
          a.$.sortButton.firstElementChild.innerHTML = 1 === _e1043 ? a.localize("sortedByOne") : a.localize("sortedByMultiple", {
            n: _e1043
          }), a.$.sortButton.classList.add("sorted");
        }
      }
    }
  }, {
    key: "beginEdit",
    value: function beginEdit(e) {
      var t = this;

      if (t.editable) {
        var _i882 = t._visibleSource.find(function (t) {
          return t.$.id === e;
        });

        if (_i882) {
          var _i883 = t.ensureVisible(e);

          "virtual" === t.scrolling ? t._beginEditOnLoad = e : t._openEditDialog(_i883.dataId);
        }
      }
    }
  }, {
    key: "cancelEdit",
    value: function cancelEdit() {
      var e = this,
          t = e._editInfo;
      t && t.window.opened && t.window.close();
    }
  }, {
    key: "closePanel",
    value: function closePanel() {
      var e = this;
      e.$.headerDropDown.classList.add("smart-visibility-hidden"), e._closeSearchPanel();
    }
  }, {
    key: "endEdit",
    value: function endEdit() {
      var e = this,
          t = e._editInfo;
      t && t.window.opened && (t.ok = !0, t.window.close());
    }
  }, {
    key: "ensureVisible",
    value: function ensureVisible(e) {
      var t = Math.floor;
      var a = this,
          i = a._visibleSource,
          n = i.find(function (t) {
        return t.$.id === e;
      });
      if (!n) return;
      var o = i.indexOf(n),
          r = a._cardsPerRow,
          l = a._cardHeight + a._gap,
          s = a.$.scrollViewer.$.verticalScrollBar,
          d = t(o / r),
          c = Math.max(0, d * r);
      var m = 0,
          u,
          p;

      if (0 < a._numberOfCollapsedRows) {
        var _e1044 = t((i.length - 1) / r) + 1;

        for (var _t885 = 0; _t885 < _e1044; _t885++) {
          var _e1045 = _t885;
          if (_e1045 === d) break;
          m += a._collapsedRows[_e1045] ? l - a._cardContentHeight : l;
        }
      } else m = t(c / r) * l;

      return (m = Math.min(m, s.max), Math.abs(s.value - m) < a.$.scrollViewer.$.scrollViewerContainer.offsetHeight / 50) ? (u = a._cards.filter(function (e) {
        return e.dataId === o && !e.classList.contains("smart-hidden");
      }), p = u[u.length - 1], p) : (s.value = m, a._onVerticalChange({
        detail: {
          value: m
        }
      }), u = a._cards.filter(function (e) {
        return e.dataId === o && !e.classList.contains("smart-hidden");
      }), p = u[u.length - 1], p);
    }
  }, {
    key: "hideColumn",
    value: function hideColumn(e) {
      this._toggleColumn(e, !1);
    }
  }, {
    key: "openCustomizePanel",
    value: function openCustomizePanel() {
      var e = this,
          t = e.dataSource;
      if (!t || 0 === t.length) return;
      var i = e.$.customize,
          a = e.columns.map(function (t) {
        var i = Object.assign({}, t);
        return i.disableToggle = -1 !== [e.coverField, e.titleField].indexOf(i.dataField), i;
      }),
          n = [e.localize("noCoverField")].concat(e.columns.filter(function (e) {
        return e.image;
      }));
      var o, r, l;

      if (e._editInfo && e._editInfo.window.close(), e.$.headerDropDown.classList.add("customize-panel"), e.$.headerDropDown.classList.remove("filter-panel", "sort-panel", "search-panel"), i.classList.remove("smart-hidden"), e.$.filter.classList.add("smart-hidden"), e.$.sort.classList.add("smart-hidden"), e.$.search.classList.add("smart-hidden"), e._closeSearchPanel(), !e._customizePartCreated) {
        var _t886 = document.createDocumentFragment(),
            _i884 = document.createElement("div"),
            _s95 = document.createElement("div"),
            d = document.createElement("div");

        o = document.createElement("smart-switch-button"), r = document.createElement("smart-input"), l = document.createElement("smart-column-panel"), d.innerHTML = e.localize("coverField"), o.setAttribute("crop", e.localize("crop")), o.setAttribute("fit", e.localize("fit")), o.inverted = !0, o.animation = e.animation, o.theme = e.theme, r.dataSource = n, r.dropDownButtonPosition = "right", r.readonly = !0, r.animation = e.animation, r.theme = e.theme, l.animation = e.animation, l.dataSource = a, l.locale = e.locale, l.messages = e._innerElementMessages.columnPanel, l.theme = e.theme, _s95.appendChild(d), _s95.appendChild(o), _i884.classList.add("smart-card-view-customize-top"), _i884.appendChild(_s95), _i884.appendChild(r), _t886.appendChild(_i884), _t886.appendChild(l), e.$.customize.appendChild(_t886), e._customizePartCreated = !0;
      } else o = i.getElementsByTagName("smart-switch-button")[0], r = i.getElementsByTagName("smart-input")[0], r.dataSource = n, delete r.$.input.dataValue, l = i.children[1], l.set("dataSource", a), l.propertyChangedHandler("dataSource", void 0, a);

      o.checked = "fit" === e.coverMode, r.value = e.coverField ? e.columns.find(function (t) {
        return t.dataField === e.coverField;
      }).label : e.localize("noCoverField"), e._changedVisibility = new Map(), e._openHeaderDropDown(e.$.customizeCardsButton);
    }
  }, {
    key: "openFilterPanel",
    value: function openFilterPanel() {
      var e = this,
          t = e.dataSource;
      if (!t || 0 === t.length) return;
      var i = e.columns.map(function (e) {
        var i = Object.assign({}, e);
        return i.dataType = t.dataFields.find(function (e) {
          return e.name === i.dataField;
        }).dataType, i;
      });
      var a;
      e._editInfo && e._editInfo.window.close(), e.$.headerDropDown.classList.add("filter-panel"), e.$.headerDropDown.classList.remove("customize-panel", "sort-panel", "search-panel"), e.$.filter.classList.remove("smart-hidden"), e.$.customize.classList.add("smart-hidden"), e.$.sort.classList.add("smart-hidden"), e.$.search.classList.add("smart-hidden"), e._closeSearchPanel(), e._filterPartCreated ? (a = e.$.filter.firstElementChild, a.set("operator", e._appliedFiltering.operator), a.set("value", e._appliedFiltering.filters), a._applyValue()) : (a = document.createElement("smart-multi-column-filter-panel"), a.animation = e.animation, a.dataSource = i, a.locale = e.locale, a.messages = e._innerElementMessages.multiColumnFilterPanel, a.operator = e._appliedFiltering.operator, a.theme = e.theme, a.value = e._appliedFiltering.filters, e.$.filter.appendChild(a), e._filterPartCreated = !0), e._openHeaderDropDown(e.$.filterButton);
    }
  }, {
    key: "openSortPanel",
    value: function openSortPanel() {
      var e = this,
          t = e.dataSource;
      if (!t || 0 === t.length) return;
      var i = e.columns.map(function (i) {
        var a = Object.assign({}, i),
            n = e._appliedSorting.dataFields.indexOf(a.dataField);

        return a.dataType = t.dataFields.find(function (e) {
          return e.name === a.dataField;
        }).dataType, a.sortIndex = n, -1 !== n && (a.sortDirection = e._appliedSorting.orderBy[n]), a;
      });
      var a;
      e._editInfo && e._editInfo.window.close(), e.$.headerDropDown.classList.add("sort-panel"), e.$.headerDropDown.classList.remove("customize-panel", "filter-panel", "search-panel"), e.$.sort.classList.remove("smart-hidden"), e.$.customize.classList.add("smart-hidden"), e.$.filter.classList.add("smart-hidden"), e.$.search.classList.add("smart-hidden"), e._closeSearchPanel(), e._sortPartCreated ? (a = e.$.sort.firstElementChild, a.set("dataSource", i), a.propertyChangedHandler("dataSource", void 0, i)) : (a = document.createElement("smart-sort-panel"), a.animation = e.animation, a.dataSource = i, a.locale = e.locale, a.messages = e._innerElementMessages.sortPanel, a.theme = e.theme, e.$.sort.appendChild(a), e._sortPartCreated = !0), e._openHeaderDropDown(e.$.sortButton);
    }
  }, {
    key: "removeFilter",
    value: function removeFilter() {
      this.addFilter([]);
    }
  }, {
    key: "removeRecord",
    value: function removeRecord(e) {
      function t() {
        var t = i.dataSource,
            a = t.find(function (t) {
          return t.$.id === e;
        });

        if (a) {
          var _e1046 = t.indexOf(a),
              _n432 = i._visibleSource.indexOf(a);

          if (t.remove(_e1046), t !== i._visibleSource) {
            if (-1 === _n432) return;

            i._visibleSource.splice(_n432, 1);
          }

          i._closeSearchPanel(), i._fullRefresh();
        }
      }

      var i = this,
          a = i.scrolling;
      return "physical" === a || "deferred" === a ? void t() : void (i.onRecordRemoved && i.onRecordRemoved(e, function (e) {
        e && t();
      }));
    }
  }, {
    key: "removeSort",
    value: function removeSort() {
      this.addSort({
        dataFields: [],
        dataTypes: [],
        orderBy: []
      });
    }
  }, {
    key: "showColumn",
    value: function showColumn(e) {
      this._toggleColumn(e, !0);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class94.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      switch (e) {
        case "allowDrag":
        case "coverMode":
        case "onRecordInserted":
        case "onRecordRemoved":
          break;

        case "addNewButton":
          i && 0 === a.dataSource.dataFields.length && (a.addNewButton = !1);
          break;

        case "animation":
        case "theme":
          if (a._cards.forEach(function (t) {
            var a = t.getElementsByTagName("smart-carousel");
            a && (a[e] = i);
          }), a._editInfo) for (var _t887 in a._editInfo.window[e] = i, a._editInfo.editors) {
            a._editInfo.editors[_t887].element[e] = i;
          }
          a._customizePartCreated && (a.$.customize.firstElementChild.firstElementChild.children[1][e] = i, a.$.customize.firstElementChild.children[1][e] = i, a.$.customize.children[1][e] = i), a._filterPartCreated && (a.$.filter.firstElementChild[e] = i), a._sortPartCreated && (a.$.sort.firstElementChild[e] = i);
          break;

        case "disabled":
          a.closePanel(), a._editInfo && (a._editInfo.window.disabled = i);
          break;

        case "cardHeight":
          a._updateCardHeight(i);

          break;

        case "cellOrientation":
        case "collapsible":
          if (!a.dataSource || 0 === a.dataSource.length) return;

          a._fullRefresh();

          break;

        case "columns":
          a._updateColumns();

          break;

        case "coverField":
        case "titleField":
          {
            if (null !== i) {
              var _n433 = a.columns.find(function (e) {
                return e.dataField === i;
              });

              if (!_n433 || "coverField" === e && !_n433.image) return void (a[e] = t);
            }

            if (a._createTemplate(), !a.dataSource || 0 === a.dataSource.length) return;

            a._fullRefresh();

            break;
          }

        case "dataSource":
          a._close(), a._normalizeDataSource(), a._getVisibleRecords(), a._clearFilterAndSortUI(), a._normalizeColumns(), a._createTemplate(), a._fullRefresh(!1);
          break;

        case "editable":
          !i && a._editInfo && a._editInfo.window.close();
          break;

        case "headerPosition":
          a._handleHeaderPosition(), ("none" === i || "none" === t) && a.dataSource && 0 < a.dataSource.length && a._partialRefresh();
          break;

        case "locale":
        case "messages":
          if (a.closePanel(), a._localizeHeader(), a._getInnerElementMessages(), a._editInfo) {
            var _e1047 = a._editInfo.window;
            _e1047.$.buttonsContainer.firstElementChild.title = a.localize("previousRecord"), _e1047.$.buttonsContainer.children[1].title = a.localize("nextRecord"), _e1047.$.footer.firstElementChild.innerHTML = a.localize("ok"), _e1047.$.footer.children[1].innerHTML = a.localize("cancel"), Array.from(_e1047.getElementsByClassName("toggle-visibility")).forEach(function (e) {
              return e.title = a.localize("toggleVisibility");
            }), Array.from(_e1047.querySelectorAll(".smart-card-view-editor.image")).forEach(function (e) {
              Array.from(e.firstElementChild.children).forEach(function (e) {
                return e.title = a.localize("removeImage");
              }), e.children[1].innerHTML = a.localize("imageUrl"), e.children[2].children[1].title = a.localize("addImage");
            }), Array.from(_e1047.getElementsByTagName("smart-date-time-picker")).forEach(function (e) {
              e.messages = a._innerElementMessages.dateTimePicker, e.locale = a.locale;
            });
          }

          if (a._customizePartCreated) {
            var _e1048 = a.$.customize.getElementsByTagName("smart-switch-button")[0];
            a.$.customize.children[1].messages = a._innerElementMessages.columnPanel, a.$.customize.children[1].locale = a.locale, _e1048.setAttribute("crop", a.localize("crop")), _e1048.setAttribute("fit", a.localize("fit"));
          }

          a._filterPartCreated && (a.$.filter.firstElementChild.messages = a._innerElementMessages.multiColumnFilterPanel, a.$.filter.firstElementChild.locale = a.locale), a._sortPartCreated && (a.$.sort.firstElementChild.messages = a._innerElementMessages.sortPanel, a.$.sort.firstElementChild.locale = a.locale);
          break;

        case "scrolling":
          {
            var _e1049 = ["virtual", "infinite"];
            if (-1 !== _e1049.indexOf(i) || -1 !== _e1049.indexOf(t)) return void (a.scrolling = t);
            a.$.scrollViewer.$.verticalScrollBar.mechanicalAction = "deferred" === i ? "switchWhenReleased" : "switchWhileDragging";
            break;
          }
      }
    }
  }, {
    key: "_updateColumns",
    value: function _updateColumns() {
      var e = this;
      e._normalizeColumns(), e._createTemplate(), e._fullRefresh();
    }
  }, {
    key: "_addNewButtonClickHandler",
    value: function _addNewButtonClickHandler() {
      this._openEditDialog();
    }
  }, {
    key: "_clickHandler",
    value: function _clickHandler(e) {
      var t = this,
          i = t.isInShadowDOM || t.shadowRoot ? e.composedPath()[0] : e.target;
      if (t.$.header.contains(i)) return void t._headerClickHandler(e);
      var a = i.closest("smart-card");

      if (!(!a || i.classList.contains("smart-indicator") || t._dragDetails && t._dragDetails.feedbackShown)) {
        if (t._dragDetails && (delete t._dragDetails, t.$.scrollViewer._scrollView.disableSwipeScroll = !1), !i.classList.contains("smart-arrow-up")) return void (t.editable && !t._clickToDrag && t._openEditDialog(a.dataId));
        var _e1050 = a.getElementsByClassName("smart-card-view-content")[0],
            _n434 = t._visibleSource[a.dataId].$.id;
        _e1050.removeEventListener("transitionend", t._transitionendHandlerExpand), _e1050.removeEventListener("transitionend", t._transitionendHandlerCollapse), t._collapsed[_n434] ? (delete t._collapsed[_n434], t._getNumberOfCollapsedRows(), t.hasAnimation ? t._expandDataContainer(_e1050) : (a.classList.remove("collapsed"), i.classList.remove("collapsed"), _e1050.classList.remove("smart-visibility-hidden"), t._partialRefresh()), window.getSelection().removeAllRanges()) : (t._collapsed[_n434] = !0, t._getNumberOfCollapsedRows(), a.classList.add("collapsed"), i.classList.add("collapsed"), t.hasAnimation ? t._collapseDataContainer(_e1050) : (_e1050.classList.add("smart-visibility-hidden"), t._partialRefresh()));
      }
    }
  }, {
    key: "_windowClickHandler",
    value: function _windowClickHandler(e) {
      var t = this,
          i = t.ownerElement,
          a = e.target.shadowRoot ? e.composedPath()[0] : e.target;
      if (a.closest(".ok")) i._editInfo.ok = !0, t.close();else if (a.closest(".cancel")) t.close();else if (a.closest(".add")) {
        var _e1051 = a.closest(".container"),
            _t888 = _e1051.firstElementChild;

        if ("" !== _t888.value.trim()) {
          var _a577 = document.createElement("div");

          _a577.className = "thumbnail", _a577.style.backgroundImage = "url(\"".concat(_t888.value, "\")"), _a577.title = i.localize("removeImage"), _e1051.parentElement.firstElementChild.appendChild(_a577), _t888.value = "";
        }
      } else if (a.classList.contains("thumbnail")) a.parentElement.removeChild(a);else if (a.classList.contains("toggle-visibility")) {
        var _e1052 = i.columns.find(function (e) {
          return a.parentElement.getAttribute("data-field") === e.dataField;
        });

        a.classList.toggle("hidden"), i._changedVisibility.set(_e1052, !a.classList.contains("hidden"));
      }
    }
  }, {
    key: "_expandDataContainer",
    value: function _expandDataContainer(e) {
      var t = this,
          i = e.style.height,
          a = t._cardContentHeight - t._verticalOffset + "px";
      return e.style.height = a, e.classList.remove("smart-visibility-hidden"), e.previousElementSibling.children[1].classList.remove("collapsed"), i !== a && (parseFloat(i) || parseFloat(a)) ? void e.addEventListener("transitionend", t._transitionendHandlerExpand) : void t._transitionendHandlerExpand(t, e);
    }
  }, {
    key: "_transitionendHandlerExpand",
    value: function _transitionendHandlerExpand() {
      var e, t;
      1 === arguments.length ? (t = this, e = e = t.closest("smart-card-view") || (t.getRootNode() && t.getRootNode().host ? t.getRootNode().host.closest("smart-card-view") : void 0)) : (e = arguments[0], t = arguments[1]), t.removeEventListener("transitionend", e._transitionendHandlerExpand), t.style.height = null, t.parentElement.parentElement.parentElement.classList.remove("collapsed"), e._partialRefresh();
    }
  }, {
    key: "_collapseDataContainer",
    value: function _collapseDataContainer(e) {
      var t = this,
          i = t._cardContentHeight - t._verticalOffset + "px";
      e.style.transition = "none", requestAnimationFrame(function () {
        e.style.height = i, e.style.transition = null, requestAnimationFrame(function () {
          e.style.height = "0px", e.classList.add("smart-visibility-hidden"), "0px" == i && t._transitionendHandlerCollapse(t, e);
        });
      }), e.addEventListener("transitionend", t._transitionendHandlerCollapse);
    }
  }, {
    key: "_transitionendHandlerCollapse",
    value: function _transitionendHandlerCollapse() {
      var e, t;
      1 === arguments.length ? (t = this, e = t.closest("smart-card-view") || (t.getRootNode() && t.getRootNode().host ? t.getRootNode().host.closest("smart-card-view") : void 0)) : (e = arguments[0], t = arguments[1]), t.removeEventListener("transitionend", e._transitionendHandlerCollapse), t.style.height = null, e._partialRefresh();
    }
  }, {
    key: "_getNumberOfCollapsedRows",
    value: function _getNumberOfCollapsedRows() {
      var e = this,
          t = e._visibleSource,
          a = e._cardsPerRow,
          i = [],
          n = {};
      var o = 0;

      var _loop43 = function _loop43(_r194) {
        var l = t.findIndex ? t.findIndex(function (e) {
          return e.$.id.toString() === _r194;
        }) : t.boundSource.findIndex(function (e) {
          return e.$.id.toString() === _r194;
        }),
            s = Math.floor(l / a);
        if (-1 !== i.indexOf(s)) return "continue";
        var d = Math.max(0, s * a);
        var c = !0;
        i.push(s);

        for (var _n435 = 0; _n435 < a; _n435++) {
          var _i885 = t[_n435 + d];
          if (!_i885) break;

          if (!e._collapsed[_i885.$.id]) {
            c = !1;
            break;
          }
        }

        c && (n[s] = !0, o++);
      };

      for (var _r194 in e._collapsed) {
        var _ret15 = _loop43(_r194);

        if (_ret15 === "continue") continue;
      }

      e._collapsedRows = n, e._numberOfCollapsedRows = o;
    }
  }, {
    key: "_openEditDialog",
    value: function _openEditDialog(e) {
      var t = this,
          i = t._visibleSource,
          a = i[e],
          n = t.$.fireEvent("opening", {
        record: a
      });
      if (n.defaultPrevented) return;
      if (t.setAttribute("modal", ""), t.closePanel(), t._changedVisibility = new Map(), t._editInfo && !t._editInfo.updateWindowContent) return void t._updateEditedView(e);
      var o = document.createDocumentFragment(),
          r = {};
      if (t.columns.forEach(function (e) {
        var i = e.dataField,
            n = a ? a[i] : "",
            l = document.createElement("div");
        var s;
        if (l.className = "smart-card-view-label".concat(e.icon ? " icon " + e.icon : ""), l.setAttribute("data-field", i), l.innerHTML = "".concat(e.label, "<span class=\"toggle-visibility").concat(!1 === e.visible ? " hidden" : "").concat(i === t.coverField || i === t.titleField ? " smart-hidden" : "", "\" title=\"").concat(t.localize("toggleVisibility"), "\"></span>"), o.appendChild(l), e.image) return s = document.createElement("div"), s.className = "smart-card-view-editor image", s.innerHTML = "<div>".concat(t._updateImgThumbNails(n), "</div>\n<div class=\"label\">").concat(t.localize("imageUrl"), "</div>\n<div class=\"container\">\n    <smart-input></smart-input>\n    <smart-button class=\"add\" title=").concat(t.localize("addImage"), ">+</smart-button>\n</div>"), o.appendChild(s), void (r[i] = {
          element: s,
          type: "image"
        });
        var d = t.dataSource.dataFields.find(function (t) {
          return t.name === e.dataField;
        }).dataType;
        "date" === d ? (s = document.createElement("smart-date-time-picker"), s.calendarButton = !0, s.dropDownAppendTo = "body", s.dropDownDisplayMode = "auto", s.dropDownPosition = "bottom", s.locale = t.locale, s.messages = t._innerElementMessages.dateTimePicker, s.nullable = !0, s.value = n || null, e.formatSettings && e.formatSettings.formatString && (s.formatString = e.formatSettings.formatString)) : "number" === d ? (s = document.createElement("smart-numeric-text-box"), s.inputFormat = "floatingPoint", s.spinButtons = !0, s.nullable = !0, s.value = void 0 !== n && null !== n ? n : null, e.formatSettings && e.formatSettings.formatString && (s.outputFormatString = e.formatSettings.formatString)) : "boolean" === d ? (s = document.createElement("smart-check-box"), s.checked = n || !1) : (s = "string" == typeof n && 50 < n.length ? document.createElement("textarea") : document.createElement("smart-input"), s.value = void 0 !== n && null !== n ? n.toString() : ""), s.className = "smart-card-view-editor", s.animation = t.animation, s.theme = t.theme, o.appendChild(s), r[i] = {
          element: s,
          type: d
        };
      }), t._editInfo && t._editInfo.updateWindowContent) return t._editInfo.window.clear(), t._editInfo.window.appendChild(o), t._openWindow(), t._editInfo.dataId = e, t._editInfo.editors = r, void delete t._editInfo.updateWindowContent;
      var l = document.createElement("smart-window"),
          s = document.createElement("template");
      s.innerHTML = "<smart-button class=\"ok primary\">".concat(t.localize("ok"), "</smart-button><smart-button class=\"cancel\">").concat(t.localize("cancel"), "</smart-button>"), l.classList.add("smart-card-view-window", "smart-visibility-hidden"), l.footerTemplate = s, l.headerButtons = ["close", "next", "prev"], l.label = a ? a[t.titleField] : "", l.animation = t.animation, l.theme = t.theme, l.ownerElement = t, l.appendChild(o), document.body.appendChild(l), t._editInfo = {
        dataId: e,
        editors: r,
        window: l
      }, t._addWindowHandlers(), l.whenRendered(function () {
        l.$.buttonsContainer.firstElementChild.title = t.localize("previousRecord"), l.$.buttonsContainer.children[1].title = t.localize("nextRecord"), t._openWindow();
      });
    }
  }, {
    key: "_openWindow",
    value: function _openWindow() {
      var e = this._editInfo.window,
          t = document.documentElement.clientWidth,
          i = document.documentElement.clientHeight,
          a = window.pageXOffset,
          n = window.pageYOffset;
      e.style.top = (i - e.offsetHeight) / 2 + n + "px", e.style.left = (t - e.offsetWidth) / 2 + a + "px", e.open();
    }
  }, {
    key: "_addWindowHandlers",
    value: function _addWindowHandlers() {
      var e = this,
          t = e._editInfo.window;
      t.addEventListener("open", e._windowEventHandler), t.addEventListener("closing", e._windowEventHandler), t.addEventListener("close", e._windowEventHandler), t.addEventListener("click", e._windowClickHandler), t.addEventListener("prev", e._prevNextHandler), t.addEventListener("next", e._prevNextHandler);
    }
  }, {
    key: "_windowEventHandler",
    value: function _windowEventHandler(e) {
      var t = this.ownerElement,
          i = e.type,
          a = t.context;

      if (e.target === this) {
        if (t.context = t, "open" === i) t.$.fireEvent("open");else if ("closing" === i) {
          var _i886 = t.$.fireEvent("closing");

          _i886.defaultPrevented && e.preventDefault();
        } else "close" === i && (t.$.fireEvent("close"), t._windowCloseHandler(e));
        t.context = a;
      }
    }
  }, {
    key: "_updateEditedView",
    value: function _updateEditedView(e) {
      var t = this,
          i = t._visibleSource[e];
      i && i.isEmpty || (t._editInfo.dataId = e, t.columns.forEach(function (e) {
        var a = e.dataField,
            n = i ? i[a] : "",
            o = t._editInfo.editors[a];
        "image" === o.type ? o.element.firstElementChild.innerHTML = t._updateImgThumbNails(n) : "boolean" === o.type ? o.element.checked = n || !1 : "date" === o.type ? o.element.value = n || null : "number" === o.type ? o.element.value = n !== void 0 && null !== n ? n : null : o.element.value = n !== void 0 && null !== n ? n.toString() : "";
      }), t._editInfo.window.label = i ? i[t.titleField] : "", t._openWindow());
    }
  }, {
    key: "_updateImgThumbNails",
    value: function _updateImgThumbNails(e) {
      var _this12 = this;

      if ("" === e.trim()) return "";
      var t = e.split(",").map(function (e) {
        return e.trim();
      });
      var i = "";
      return t.forEach(function (e) {
        return i += "<div class=\"thumbnail\" style=\"background-image: url('".concat(e, "');\" title=\"").concat(_this12.localize("removeImage"), "\"></div>");
      }), i;
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_prevNextHandler",
    value: function _prevNextHandler(e) {
      var t = this.ownerElement,
          i = t.context,
          a = t._editInfo.dataId,
          n = "prev" === e.type ? a - 1 : a + 1;
      t._visibleSource[n] && !t._visibleSource[n].isEmpty && (t.context = t, t._saveChanges(), t._updateEditedView(n), t.context = i);
    }
  }, {
    key: "_saveChanges",
    value: function _saveChanges() {
      var e = this,
          t = e._editInfo.dataId;
      var i, a;

      if (t !== void 0) {
        var _n436 = e._cards.filter(function (e) {
          return e.dataId === t;
        });

        i = e._visibleSource[t], a = _n436[_n436.length - 1];
      } else i = {};

      e.columns.forEach(function (t) {
        var n = t.dataField,
            o = e._editInfo.editors[n],
            r = o.element;

        if ("image" === o.type) {
          var _t889 = [];
          if (Array.from(o.element.getElementsByClassName("thumbnail")).forEach(function (e) {
            _t889.push(e.style.backgroundImage.replace(/url\(["'](.+)["']\)/g, "$1"));
          }), i[n] = _t889.join(","), a && n === e.coverField) return void (a.firstElementChild.firstElementChild.dataSource = _t889);
        } else i[n] = "boolean" === o.type ? r.checked : "date" === o.type ? r.value ? r.value.toDate() : null : r.value;

        if (a) if (n === e.titleField) a.getElementsByClassName("smart-card-view-title")[0].firstElementChild.innerHTML = e._formatValue(i[n], i, t);else if (t.visible) {
          var _o316 = a.querySelector("[data-field=\"".concat(n, "\"] > .smart-card-view-value"));

          _o316 && (_o316.innerHTML = e._formatValue(i[n], i, t));
        }
      }), t === void 0 && e.addRecord(null, i);
    }
  }, {
    key: "_close",
    value: function _close() {
      var e = this;
      e.closePanel(), e._editInfo && e._editInfo.window.close();
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      e._suppressResizeHandler || e.hasAttribute("empty") || e.hasAttribute("no-matches") || (clearTimeout(e._resizeTimeout), e.$.loadingIndicatorContainer.classList.remove("smart-hidden"), e._resizeTimeout = setTimeout(function () {
        if (e.$.loadingIndicatorContainer.classList.add("smart-hidden"), e._cards.length === e._visibleSource.length) {
          if (e.offsetWidth !== e._cachedWidth) {
            var _t890 = e._cardsPerRow;
            e._getCardsPerRow(), _t890 !== e._cardsPerRow && e._getNumberOfCollapsedRows(), e._cachedWidth = e.offsetWidth;
          } else e._cachedHeight = e.offsetHeight;

          return void (0 < e._cards.length && (e._autoCardHeight && e._updateCardHeight(null), e.$.scrollViewer.refresh()));
        }

        if (e.offsetHeight !== e._cachedHeight && (e._cachedHeight = e.offsetHeight, 20 <= Math.abs(e._refreshedAtDimensions.height - e._cachedHeight) ? (e._dataSourceProcessed = !0, e._partialRefresh(), delete e._dataSourceProcessed) : e.$.scrollViewer.$.verticalScrollBar.max = Math.max(0, e._scrollHeight - e.$.scrollViewer.$.scrollViewerContainer.offsetHeight - e._numberOfCollapsedRows * e._cardContentHeight)), e.offsetWidth !== e._cachedWidth) {
          var _t891 = e._cardsPerRow;
          e._cachedWidth = e.offsetWidth, e._getCardsPerRow(), _t891 !== e._cardsPerRow && (e._dataSourceProcessed = !0, e._partialRefresh(), delete e._dataSourceProcessed);
        }
      }, 75));
    }
  }, {
    key: "_windowCloseHandler",
    value: function _windowCloseHandler() {
      var e = this;
      return e.removeAttribute("modal"), e._editInfo.ok ? (e._updateColumnsVisibility(function () {
        e._saveChanges();
      }), void delete e._editInfo.ok) : void e._changedVisibility.forEach(function (t, i) {
        i.visible !== t && e._editInfo.window.querySelector("[data-field=\"".concat(i.dataField, "\"]")).firstElementChild.classList.toggle("hidden");
      });
    }
  }, {
    key: "_updateColumnsVisibility",
    value: function _updateColumnsVisibility(e, t) {
      var i = this;
      var a = !1;
      i._changedVisibility.forEach(function (n, o) {
        if (!0 !== t && o.visible === n) return;
        var r = o.dataField;
        o.visible = n, n ? (i._cardContent = i._cardContent.replace("class=\"smart-card-view-cell smart-hidden\" data-field=\"".concat(r, "\""), "class=\"smart-card-view-cell\" data-field=\"".concat(r, "\"")), !e && i._editInfo && i._editInfo.window.querySelector("[data-field=\"".concat(r, "\"]")).firstElementChild.classList.remove("hidden")) : (i._cardContent = i._cardContent.replace("class=\"smart-card-view-cell\" data-field=\"".concat(r, "\""), "class=\"smart-card-view-cell smart-hidden\" data-field=\"".concat(r, "\"")), !e && i._editInfo && i._editInfo.window.querySelector("[data-field=\"".concat(r, "\"]")).firstElementChild.classList.add("hidden")), i._cards.forEach(function (e) {
          var t = e.querySelector("[data-field=\"".concat(r, "\"]"));

          if (t.classList.toggle("smart-hidden"), n) {
            var _a578 = i._visibleSource[e.dataId];
            t.children[1].innerHTML = i._formatValue(_a578[r], _a578, o);
          }
        }), a = !0;
      }), e && e(), i._autoCardHeight && a && i._updateCardHeight(null);
    }
  }, {
    key: "_applyHandler",
    value: function _applyHandler(e) {
      var t = this,
          i = e.target,
          a = e.detail,
          n = t.$.customize,
          o = t.columns;

      if (n.contains(i)) {
        var _e1053 = n.getElementsByTagName("smart-switch-button")[0],
            _i887 = n.getElementsByTagName("smart-input")[0],
            _r195 = _e1053.checked ? "fit" : "crop";

        var _l130 = o.find(function (e) {
          return e.label === _i887.value;
        }) || null,
            _s96 = !1;

        _r195 !== t.coverMode && (t.coverMode = _r195), _l130 && (_l130 = _l130.dataField), _l130 !== t.coverField && (t.coverField = _l130, _s96 = !0), _s96 || a.positionChanged ? (a.positionChanged && (t.columns = a.value), t._createTemplate(), t._fullRefresh(), a.positionChanged && t._editInfo && (t._editInfo.updateWindowContent = !0)) : (a.value.forEach(function (e) {
          var i = o.find(function (t) {
            return t.dataField === e.dataField;
          });
          i.visible !== e.visible && t._changedVisibility.set(i, e.visible);
        }), t._updateColumnsVisibility());
      } else t.$.filter.contains(i) ? t.addFilter(a.filters, a.operator, a.value) : t.$.sort.contains(i) && t.addSort(a.sortByInfo);

      t.closePanel();
    }
  }, {
    key: "_fullRefresh",
    value: function _fullRefresh() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var t = this,
          i = t.$.cardContainer;
      var a;

      for (e && (a = t._getFractionOfMax()), t._suppressResizeHandler = !0; i.firstChild;) {
        i.removeChild(i.firstChild);
      }

      t._cards = [], t._createCards(), 0 === t._visibleSource.length && t.$.scrollViewer.refresh(), t._setFractionOfMax(a);
    }
  }, {
    key: "_normalizeDataSource",
    value: function _normalizeDataSource() {
      function e() {
        if (0 === t.columns.length) return t.addNewButton = !1, [];
        var e = [];
        return t.columns.forEach(function (t) {
          try {
            e.push({
              name: t.dataField || t.label || t,
              dataType: "string"
            });
          } catch (e) {}
        }), e;
      }

      var t = this;
      var a = t.dataSource;
      if (a instanceof Smart.DataAdapter) return void (0 === a.dataFields.length && (a.dataFields = e()));
      if (!a) a = [];else if (!Array.isArray(a)) if ("object" == typeof a && 0 < Object.keys(a).length) a = [a];else return void t.error(t.localize("incorrectStructure"));
      var n = [];
      if (0 === a.length) n = e();else {
        var _t892 = 0,
            _i888 = a[_t892],
            _o317 = Object.keys(_i888);

        for (; _i888 && 0 === _o317.length;) {
          _t892++, _i888 = a[_t892], _o317 = Object.keys(_i888);
        }

        0 === _o317.length ? n = e() : _o317.forEach(function (e) {
          var t = _i888[e];
          var a;
          a = t.constructor === Date ? "date" : "boolean" == typeof t ? "boolean" : isNaN(t) || null === t || "" === t ? "string" : "number", n.push("".concat(e, ": ").concat(a));
        });
      }
      t.dataSource = new Smart.DataAdapter({
        dataSource: a,
        dataFields: n
      });
    }
  }, {
    key: "_normalizeColumns",
    value: function _normalizeColumns() {
      var e = this,
          t = e.columns,
          i = e.dataSource.dataFields,
          a = [];
      (Array.isArray(t) || t instanceof Smart.ObservableArray) && (t.forEach(function (t) {
        var n, o, r, l, s, d, c, m;
        "object" == typeof t ? (n = t.dataField, o = t.formatFunction, r = t.formatSettings, l = t.icon, s = t.image || !1, d = t.label || n, c = t.template, m = n === e.titleField || n === e.coverField || !(t.visible !== void 0) || t.visible) : "string" == typeof t && (n = t, s = !1, d = n, m = !0), i.find(function (e) {
          return e.name === n;
        }) && a.push({
          dataField: n,
          formatFunction: o,
          formatSettings: r,
          icon: l,
          image: s,
          label: d,
          template: c,
          visible: m
        });
      }), 0 === a.length && i.forEach(function (e) {
        a.push({
          dataField: e.name,
          image: !1,
          label: e.name,
          visible: !0
        });
      }), !a.find(function (t) {
        return t.dataField === e.titleField;
      }) && (e.titleField = null), !a.find(function (t) {
        return t.dataField === e.coverField && t.image;
      }) && (e.coverField = null), e.columns = new Smart.ObservableArray(a), e.columns.canNotify = !0, e.columns.notify(function (t) {
        if (e.context !== e && t.newValue !== t.oldValue) {
          if (e._close(), "update" === t.action) {
            var _i889 = t.target;

            switch (t.propertyName) {
              case "dataField":
                e._updateColumns();

                break;

              case "formatFunction":
              case "formatSettings":
              case "template":
                e._createTemplate(), e._fullRefresh();
                break;

              case "icon":
              case "label":
                _i889.dataField !== e.coverField && _i889.dataField !== e.titleField && (e._createTemplate(), e._fullRefresh());
                break;

              case "image":
                t.newValue || e.coverField !== _i889.dataField ? (e._createTemplate(), e._fullRefresh()) : (e.coverField = null, e.propertyChangedHandler("coverField", _i889.dataField, null));
                break;

              case "visible":
                {
                  var _a579 = _i889.dataField;
                  if (!t.newValue && (_a579 === e.coverField || _a579 === e.titleField)) return void (_i889.visible = !0);

                  e._toggleColumn(_a579, t.newValue, !0);

                  break;
                }
            }
          } else e._updateColumns();

          e._editInfo && (e._editInfo.updateWindowContent = !0);
        }
      }), e._editInfo && (e._editInfo.updateWindowContent = !0));
    }
  }, {
    key: "_handleHeaderPosition",
    value: function _handleHeaderPosition() {
      var e = this,
          t = e.headerPosition,
          i = e.$.header;
      return "none" === t ? void e.$header.addClass("smart-hidden") : void (e.$header.removeClass("smart-hidden"), "top" === t && i.nextElementSibling !== e.$.scrollViewer ? e.$.container.insertBefore(i, e.$.scrollViewer) : "bottom" === t && i.previousElementSibling !== e.$.scrollViewer && e.$.container.insertBefore(i, e.$.loadingIndicatorContainer));
    }
  }, {
    key: "_localizeHeader",
    value: function _localizeHeader() {
      var e = this;
      e.$.customizeCardsButton.firstElementChild.innerHTML = e.localize("customizeCards"), e.$.filterButton.firstElementChild.innerHTML = 0 === e._appliedFiltering.filters.length ? e.localize("filter") : 1 === e._appliedFiltering.filters.length ? e.localize("filteredByOne") : e.localize("filteredByMultiple", {
        n: e._appliedFiltering.filters.length
      }), e.$.sortButton.firstElementChild.innerHTML = 0 === e._appliedSorting.dataFields.length ? e.localize("sort") : 1 === e._appliedSorting.dataFields.length ? e.localize("sortedByOne") : e.localize("sortedByMultiple", {
        n: e._appliedSorting.dataFields.length
      }), e.$.searchInput.placeholder = e.localize("findInView"), e.$.cardContainer.setAttribute("no-data", e.localize("noData")), e.$.cardContainer.setAttribute("no-matches", e.localize("noMatches"));
    }
  }, {
    key: "_getInnerElementMessages",
    value: function _getInnerElementMessages() {
      var e = this,
          t = e.locale,
          i = {};
      i.columnPanel = {}, i.multiColumnFilterPanel = {}, i.sortPanel = {}, i.dateTimePicker = {}, i.columnPanel[t] = {
        apply: e.localize("apply"),
        cancel: e.localize("cancel"),
        find: e.localize("find"),
        noResults: e.localize("noResults")
      }, i.multiColumnFilterPanel[t] = {
        addFilter: e.localize("addFilter"),
        and: e.localize("and"),
        apply: e.localize("apply"),
        cancel: e.localize("cancel"),
        CONTAINS: e.localize("CONTAINS"),
        CONTAINS_CASE_SENSITIVE: e.localize("CONTAINS_CASE_SENSITIVE"),
        DOES_NOT_CONTAIN: e.localize("DOES_NOT_CONTAIN"),
        DOES_NOT_CONTAIN_CASE_SENSITIVE: e.localize("DOES_NOT_CONTAIN_CASE_SENSITIVE"),
        EMPTY: e.localize("EMPTY"),
        ENDS_WITH: e.localize("ENDS_WITH"),
        ENDS_WITH_CASE_SENSITIVE: e.localize("ENDS_WITH_CASE_SENSITIVE"),
        EQUAL: e.localize("EQUAL"),
        EQUAL_CASE_SENSITIVE: e.localize("EQUAL_CASE_SENSITIVE"),
        GREATER_THAN: e.localize("GREATER_THAN"),
        GREATER_THAN_OR_EQUAL: e.localize("GREATER_THAN_OR_EQUAL"),
        LESS_THAN: e.localize("LESS_THAN"),
        LESS_THAN_OR_EQUAL: e.localize("LESS_THAN_OR_EQUAL"),
        noFilters: e.localize("noFilters"),
        NOT_EMPTY: e.localize("NOT_EMPTY"),
        NOT_EQUAL: e.localize("NOT_EQUAL"),
        NOT_NULL: e.localize("NOT_NULL"),
        NULL: e.localize("NULL"),
        or: e.localize("or"),
        STARTS_WITH: e.localize("STARTS_WITH"),
        STARTS_WITH_CASE_SENSITIVE: e.localize("STARTS_WITH_CASE_SENSITIVE"),
        where: e.localize("where")
      }, i.sortPanel[t] = {
        apply: e.localize("apply"),
        booleanFirst: e.localize("booleanFirst"),
        booleanLast: e.localize("booleanLast"),
        cancel: e.localize("cancel"),
        dateFirst: e.localize("dateFirst"),
        dateLast: e.localize("dateLast"),
        firstBy: e.localize("firstBy"),
        from: e.localize("from"),
        numberFirst: e.localize("numberFirst"),
        numberLast: e.localize("numberLast"),
        noSorting: e.localize("noSorting"),
        pickAnother: e.localize("pickAnother"),
        stringFirst: e.localize("stringFirst"),
        stringLast: e.localize("stringLast"),
        thenBy: e.localize("thenBy")
      }, i.dateTimePicker[t] = {
        now: e.localize("now"),
        dateTabLabel: e.localize("dateTabLabel"),
        timeTabLabel: e.localize("timeTabLabel")
      }, e._innerElementMessages = i;
    }
  }, {
    key: "_headerClickHandler",
    value: function _headerClickHandler(e) {
      function t(e, t) {
        i.$.headerDropDown.classList.contains("smart-visibility-hidden") || e.classList.contains("smart-hidden") ? i[t]() : i.closePanel();
      }

      var i = this,
          a = i.isInShadowDOM || i.shadowRoot ? e.composedPath()[0] : e.target;
      if (i.$.customizeCardsButton.contains(a)) t(i.$.customize, "openCustomizePanel");else if (i.$.filterButton.contains(a)) t(i.$.filter, "openFilterPanel");else if (i.$.sortButton.contains(a)) t(i.$.sort, "openSortPanel");else if (a === i.$.searchButton) t(i.$.search, "_openSearchPanel");else if (a === i.$.searchClose) i.closePanel();else if (a === i.$.searchPrev || a === i.$.searchNext) {
        var _e1054 = i._searchInfo,
            _t893 = _e1054.foundIdsArray,
            _n437 = a === i.$.searchNext,
            _o318 = _t893.length;

        var _r196;

        if (_e1054.highlighted === void 0) _r196 = _n437 ? 0 : _o318 - 1;else if (1 === _t893.length) return;else {
          var _a580 = _t893.indexOf(_e1054.highlighted),
              _l132 = Array.from(i.$.cardContainer.getElementsByClassName("highlighted"));

          _l132.forEach(function (e) {
            return e.classList.remove("highlighted");
          }), _r196 = _n437 ? (_a580 + 1) % _o318 : 0 <= _a580 - 1 ? _a580 - 1 : _o318 - 1;
        }
        _e1054.highlighted = _t893[_r196];

        var _l131 = i.ensureVisible(_e1054.highlighted);

        _l131.classList.add("highlighted"), i.$.searchLabel.innerHTML = i.localize("found", {
          nth: _r196 + 1,
          n: _t893.length
        });
      }
    }
  }, {
    key: "_openSearchPanel",
    value: function _openSearchPanel() {
      var e = this;
      var t;
      if (e.$.headerDropDown.classList.add("search-panel"), e.$.headerDropDown.classList.remove("customize-panel", "filter-panel", "sort-panel"), e.$.search.classList.remove("smart-hidden"), e.$.customize.classList.add("smart-hidden"), e.$.filter.classList.add("smart-hidden"), e.$.sort.classList.add("smart-hidden"), e._openHeaderDropDown(e.$.searchButton), Array.isArray(e._visibleSource)) t = new Smart.DataAdapter({
        dataSource: e._visibleSource,
        dataFields: e.dataSource.dataFields,
        id: "_id"
      });else {
        var _i890 = e._appliedSorting;
        t = new Smart.DataAdapter({
          dataSource: e._visibleSource._dataSource,
          dataFields: e.dataSource.dataFields,
          id: e._visibleSource.id || void 0
        }), 0 < _i890.dataFields.length && t.sortBy(_i890.dataFields, _i890.dataTypes, _i890.orderBy);
      }
      e._searchInfo = {
        source: t,
        stringDataFields: e.dataSource.dataFields.filter(function (t) {
          return "string" === t.dataType && e.columns.find(function (e) {
            return e.dataField === t.name && !e.image;
          });
        }).map(function (e) {
          return e.name;
        })
      }, "" !== e.$.searchInput.value && e._search(e.$.searchInput.value, !1);
    }
  }, {
    key: "_openHeaderDropDown",
    value: function _openHeaderDropDown(e) {
      var t = this,
          i = t.$.headerDropDown;
      "top" === t.headerPosition ? (i.style.bottom = null, i.style.top = "100%") : (i.style.top = null, i.style.bottom = "100%"), i.style.left = e === t.$.searchButton ? e.offsetLeft + e.offsetWidth - i.offsetWidth + "px" : e.offsetLeft + "px", i.classList.remove("smart-visibility-hidden");
    }
  }, {
    key: "_createTemplate",
    value: function _createTemplate() {
      var e = this,
          t = e.titleField;
      var i = "";
      i += t ? "<div class=\"smart-card-view-title\" data-field=\"".concat(t, "\"><div>{{").concat(t, "}}</div><div class=\"smart-arrow-up\"></div></div>") : "<div class=\"smart-card-view-title empty\"><div>&nbsp;</div><div class=\"smart-arrow-up\"></div></div>", i += "<div class=\"smart-card-view-content\">", e.columns.forEach(function (a) {
        var n = a.dataField;
        !1 !== a.visible && (a.visible = !0);
        n === t || n === e.coverField || (i += "<div class=\"smart-card-view-cell".concat(a.visible ? "" : " smart-hidden", "\" data-field=\"").concat(n, "\"><div class=\"smart-card-view-label").concat(a.icon ? " icon " + a.icon : "", "\">").concat(a.label, "</div>\n<div class=\"smart-card-view-value\">{{").concat(n, "}}</div></div>"));
      }), i += "</div>", e._cardContent = i;
    }
  }, {
    key: "_requestInitialCards",
    value: function _requestInitialCards() {
      var e = this;
      e.setAttribute("loading", ""), e.$.loadingIndicatorContainer.classList.remove("smart-hidden"), e.dataSource.onVirtualDataSourceRequested(function () {
        e._createCards(), e.removeAttribute("loading"), e.$.loadingIndicatorContainer.classList.add("smart-hidden");
      }, {
        first: 1 / 0,
        last: 1 / 0,
        sorting: [],
        filtering: [],
        grouping: [],
        action: ""
      });
    }
  }, {
    key: "_createCards",
    value: function _createCards() {
      var e = Math.max;
      var t = this,
          a = t._visibleSource;
      if (!a || 0 === a.length) return;
      var i = t.scrolling,
          n = "virtual" === i,
          o = t.$.scrollViewer.$.scrollViewerContainer.offsetHeight;
      var r = a.length,
          l = 1,
          s = 0,
          d = 0,
          c;
      t._ignoreVerticalChange = !0, t.removeAttribute("empty"), n && t.setAttribute("loading", "");

      for (var _n438 = 0; _n438 < r; _n438++) {
        var _i891 = t._createCard(a[_n438], _n438);

        if (t._cards.push(_i891), t.$.cardContainer.appendChild(_i891), t.$.scrollViewer.refresh(), t._autoCardHeight && (d = e(_i891.offsetHeight, d)), _i891.offsetTop > s && (l++, s = _i891.offsetTop, !c && (t._getCardsPerRow(), c = t._cardsPerRow)), 3 <= l && 0 == t._cards.length % c && t.$.cardContainer.offsetHeight > o + 2 * (t.cardHeight || d) && t._cards.length + 5 < r) break;
      }

      if (c = c || t._cards.length, "infinite" === i) for (; 0 != t._cards.length % c;) {
        t._createEmptyCard();
      }
      t._autoCardHeight && (t._cardHeight = d, t._cards.forEach(function (e) {
        return e.style.height = d + "px";
      })), t._cardContentHeight = t._cards[0].getElementsByClassName("smart-card-view-content")[0].offsetHeight + t._verticalOffset, t._cards.forEach(function (e) {
        return t._toggleCard(e, e.firstElementChild.lastElementChild, t._visibleSource[e.dataId].$.id);
      });
      var m = Math.ceil(r / c),
          u = (t._cardHeight + t._gap) * m - t._gap;
      t.$.scrollViewer.$.scrollViewerContentContainer.style.top = 0, t.$.scrollViewer.$.verticalScrollBar.max = e(0, u - o - t._numberOfCollapsedRows * t._cardContentHeight), t._cardsPerRow = c, t._scrollHeight = u, t._refreshedAtDimensions = {
        width: t._cachedWidth,
        height: t._cachedHeight
      }, t._getNumberOfCollapsedRows(), delete t._ignoreVerticalChange, delete t._suppressResizeHandler, n && (t.$.loadingIndicatorContainer.classList.remove("smart-hidden"), t.dataSource.onVirtualDataSourceRequested(t._virtualDataSourceRequestedCallback.bind(t, 0, 0, !0), {
        first: 0,
        last: t._cards.length,
        sorting: [],
        filtering: [],
        grouping: [],
        action: ""
      }));
    }
  }, {
    key: "_virtualDataSourceRequestedCallback",
    value: function _virtualDataSourceRequestedCallback(e, t, i) {
      var a = this;

      if (a._ignoreVerticalChange = !0, a.$.loadingIndicatorContainer.classList.add("smart-hidden"), a._updateVisibleCards(e, t, i), a.removeAttribute("loading"), delete a._ignoreVerticalChange, a._beginEditOnLoad) {
        var _e1055 = a._cards.filter(function (e) {
          return e.dataId === a._beginEditOnLoad;
        }),
            _t894 = _e1055[_e1055.length - 1];

        _t894 && a._openEditDialog(_t894.dataId), delete a._beginEditOnLoad;
      }
    }
  }, {
    key: "_createCard",
    value: function _createCard() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var i = this,
          a = i.coverField,
          n = document.createElement("smart-card"),
          o = document.createElement("div");

      if (requestAnimationFrame(function () {
        return n.hasStyleObserver = !1;
      }), n.dataId = t, n.whenReady(function () {
        n.firstElementChild.onscroll = function () {
          var e = i._visibleSource[this.parentElement.dataId].$.id;
          i._cardScrolling[e] = this.scrollTop;
        };
      }), i._autoCardHeight || (n.style.height = i._cardHeight + "px"), o.className = "smart-card-data-container", i._applyTemplate(e, o, !0), a) {
        var _t895 = document.createElement("smart-carousel");

        var _o319 = e[a];
        i.shadowRoot && (_t895._isInShadowDOM = !0), _o319 = "string" == typeof _o319 ? _o319.split(",").map(function (e) {
          return e.trim();
        }) : [], _t895.dataSource = _o319, _t895.hideArrows = !0, _t895.unfocusable = !0, _t895.animation = i.animation, _t895.theme = i.theme, _t895.onIndexChange = function (e) {
          i._cardSelectedCover[i._visibleSource[n.dataId].$.id] = e;
        }, _t895.whenReady(function () {
          _t895.hasStyleObserver = !1, _t895.$.arrowLeft.hasStyleObserver = !1, _t895.$.arrowRight.hasStyleObserver = !1;
        }), n.appendChild(_t895);
      }

      return n.appendChild(o), n;
    }
  }, {
    key: "_toggleCard",
    value: function _toggleCard(e, t, i) {
      var a = this;
      e.setAttribute("updating", ""), a._collapsed[i] ? (e.classList.add("collapsed"), t.firstElementChild.children[1].classList.add("collapsed"), t.children[1].classList.add("smart-visibility-hidden")) : (e.classList.remove("collapsed"), t.firstElementChild.children[1].classList.remove("collapsed"), t.children[1].classList.remove("smart-visibility-hidden")), setTimeout(function () {
        e.removeAttribute("updating");
      }, 100);
    }
  }, {
    key: "_createEmptyCard",
    value: function _createEmptyCard() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;

      var t = this,
          i = t._createCard({});

      e && i.classList.add("smart-hidden"), i.style.height = t._cardHeight + "px", t._cards.push(i), t.$.cardContainer.appendChild(i);
    }
  }, {
    key: "_applyTemplate",
    value: function _applyTemplate(e, t, i) {
      var a = this,
          n = a.columns;

      if (i) {
        var _o320 = a._cardContent;

        for (var _t896 = 0; _t896 < n.length; _t896++) {
          var _i892 = n[_t896];
          if (!_i892.visible) continue;

          var _r197 = _i892.dataField,
              _l133 = new RegExp("{{".concat(_r197, "}}"), "g"),
              _s97 = a._formatValue(e[_r197], e, _i892);

          _o320 = _o320.replace(_l133, _s97);
        }

        return void (t.innerHTML = _o320.replace(/{{\w+}}/g, ""));
      }

      var o = a.titleField;

      for (var _r198 = 0; _r198 < n.length; _r198++) {
        var _i893 = n[_r198];
        if (!_i893.visible) continue;

        var _l134 = _i893.dataField,
            _s98 = t.querySelector("[data-field=\"".concat(_l134, "\"]"));

        if (_s98) {
          var _t897 = a._formatValue(e[_l134], e, _i893);

          _l134 === o ? _s98.firstElementChild.innerHTML = _t897 : _s98.children[1].innerHTML = _t897;
        }
      }
    }
  }, {
    key: "_formatValue",
    value: function _formatValue(e, t, i) {
      var a = this;
      if (0 === Object.keys(t).length) return "";
      var n = {
        column: i,
        record: t,
        template: i.template,
        value: e
      };
      if (i.formatFunction && i.formatFunction(n), e = n.value, n.template) return a._applyCellTemplate(n.template, e, t, i);

      if (i.formatSettings) {
        var _t898 = "";
        return i.formatSettings.prefix && (_t898 += i.formatSettings.prefix), i.formatSettings.formatString && void 0 !== e && null !== e && (e.constructor === Date ? e = new Smart.Utilities.DateTime(e).toString(i.formatSettings.formatString) : e instanceof Smart.Utilities.DateTime ? e = e.toString(i.formatSettings.formatString) : !isNaN(e) && a._numericFormatter && (e = a._numericFormatter.formatNumber(e, i.formatSettings.formatString))), _t898 += e, i.formatSettings.sufix && (_t898 += i.formatSettings.sufix), _t898;
      }

      return e;
    }
  }, {
    key: "_applyCellTemplate",
    value: function _applyCellTemplate(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var i = arguments.length > 2 ? arguments[2] : undefined;
      var a = arguments.length > 3 ? arguments[3] : undefined;
      var n = "";

      if ("function" == typeof e) {
        var _n439 = {
          column: a,
          record: i,
          template: null,
          value: t
        };
        if (e(_n439), t = _n439.value, null === _n439.template) return t;
        e = _n439.template;
      }

      if (e.startsWith("#")) {
        var _a581 = document.querySelector(e);

        if (_a581 && _a581 instanceof HTMLTemplateElement) {
          var _e1056 = _a581.content.cloneNode(!0),
              _o321 = document.createElement("div");

          return _o321.appendChild(_e1056), t = t.toString(), t = t.replace(/'/ig, "\\'"), t = t.replace(/"/ig, "\\\""), n = _o321.innerHTML.replace(/{{value}}/ig, t).replace(/{{id}}/ig, i.$.id), 0 <= n.indexOf("{{value=") && (t ? (n = n.substring(0, n.indexOf("{{value=")) + t + n.substring(n.indexOf("}")), n = n.replace(/}/ig, ""), n = n.replace(/{/ig, "")) : (n = n.replace(/{{value=/ig, ""), n = n.replace(/}}/ig, ""))), n;
        }
      }

      return n = e.replace(/{{value}}/ig, t).replace(/{{id}}/ig, i.$.id), n;
    }
  }, {
    key: "_getCardsPerRow",
    value: function _getCardsPerRow() {
      var e = this,
          t = e._cards;
      if (0 === t.length) return void (e._cardsPerRow = 0);
      var a = t[0].offsetTop,
          n = 1;

      for (var _e1057 = 1; _e1057 < t.length && !(t[_e1057].offsetTop > a); _e1057++) {
        n++;
      }

      e._cardsPerRow = n;
    }
  }, {
    key: "_onVerticalChange",
    value: function _onVerticalChange(e) {
      var t = Math.floor;
      var a = this;
      if (a._ignoreVerticalChange) return;
      var n = a._visibleSource,
          i = a.scrolling,
          o = a._cardHeight + a._gap,
          r = a._cardsPerRow;
      var l = e.detail.value;

      if (a._cards.length === n.length) {
        var _e1058 = t(l / o) * r;

        return a._start = {
          view: _e1058,
          data: _e1058
        }, a._dataSourceProcessed && a._refreshCardContent(), a.$.scrollViewer.$.scrollViewerContentContainer.style.top = -l + "px", void ("infinite" === i && a.$.scrollViewer.$.verticalScrollBar.value === a.$.scrollViewer.$.verticalScrollBar.max && a._onScrollBottomReached(_e1058, _e1058));
      }

      var s, d;

      if (clearTimeout(a._scrollingTimeout), 0 < a._numberOfCollapsedRows) {
        var _e1059 = t((n.length - 1) / r) + 1;

        var _c17 = 0,
            _i894;

        s = r;

        for (var _t899 = 0; _t899 < _e1059; _t899++) {
          var _e1060 = _t899,
              _n440 = _c17;

          if (_c17 += a._collapsedRows[_e1060] ? o - a._cardContentHeight : o, null == d && l <= _c17) {
            d = _e1060 * r, _i894 = l - _n440;
            break;
          }
        }

        l = _i894 + o;
      } else {
        for (l = l % (2 * o) + o, l < o && (l += o); l + a.$.scrollViewer.$.scrollViewerContainer.offsetHeight > a.$.cardContainer.offsetHeight;) {
          l -= o;
        }

        s = t(l / o) * r, d = t(e.detail.value / o) * r, 0 > s && (d -= s, s = 0);
      }

      var c = Math.min(d + a._cards.length - s - 1, n.length - 1);

      if ("virtual" === i && (n[d].isEmpty || n[c].isEmpty)) {
        var _e1061 = c - d;

        var _t900, _o322;

        for (var _e1062 = d; _e1062 <= c; _e1062++) {
          if (n[_e1062].isEmpty) {
            _t900 = _e1062, _o322 = _t900;
            break;
          }
        }

        for (; n[_o322 + 1] && n[_o322 + 1].isEmpty && _o322 - _t900 < _e1061;) {
          _o322++;
        }

        return a.setAttribute("loading", ""), a.$.loadingIndicatorContainer.classList.remove("smart-hidden"), a.$.scrollViewer.$.scrollViewerContentContainer.style.top = -l + "px", void (a._scrollingTimeout = setTimeout(function () {
          a.dataSource.onVirtualDataSourceRequested(a._virtualDataSourceRequestedCallback.bind(a, s, d), {
            first: _t900,
            last: _o322,
            sorting: [],
            filtering: [],
            grouping: [],
            action: ""
          });
        }, 300));
      }

      a.$.scrollViewer.$.scrollViewerContentContainer.style.top = -l + "px", a._updateVisibleCards(s, d), "virtual" === i ? (a.removeAttribute("loading"), a.$.loadingIndicatorContainer.classList.add("smart-hidden")) : "infinite" === i && a.$.scrollViewer.$.verticalScrollBar.value === a.$.scrollViewer.$.verticalScrollBar.max && a._onScrollBottomReached(s, d);
    }
  }, {
    key: "_onScrollBottomReached",
    value: function _onScrollBottomReached(e, t) {
      var i = this;
      i.$.loadingIndicatorContainer.classList.remove("smart-hidden"), i.dataSource.onVirtualDataSourceRequested(function () {
        i._updateVisibleCards(e, t);

        var a = Math.ceil(i._visibleSource.length / i._cardsPerRow),
            n = (i._cardHeight + i._gap) * a - i._gap,
            o = i.$.scrollViewer.$.scrollViewerContainer.offsetHeight;
        i.$.scrollViewer.$.verticalScrollBar.max = Math.max(0, n - o - i._numberOfCollapsedRows * i._cardContentHeight), i._scrollHeight = n, i.$.loadingIndicatorContainer.classList.add("smart-hidden");
      }, {
        first: 1 / 0,
        last: 1 / 0,
        sorting: [],
        filtering: [],
        grouping: [],
        action: ""
      });
    }
  }, {
    key: "_updateVisibleCards",
    value: function _updateVisibleCards(e, t, a) {
      var n = this;

      for (var _o323 = e; _o323 < n._cards.length; _o323++) {
        var _i895 = n._cards[_o323],
            _r199 = t - e + _o323;

        _r199 < n._visibleSource.length ? (_i895.classList.remove("smart-hidden"), (_i895.dataId !== _r199 || a || n._dataSourceProcessed) && n._updateVirtualCard(_i895, _r199)) : _i895.classList.add("smart-hidden");
      }

      n._start = {
        view: e,
        data: t
      };
    }
  }, {
    key: "_toggleColumn",
    value: function _toggleColumn(e, t, i) {
      var a = this,
          n = a._visibleSource;

      if (e && "string" == typeof e && e !== a.coverField && e !== a.titleField && n && 0 !== n.length) {
        var _n441 = a.columns.find(function (t) {
          return t.dataField === e;
        });

        _n441 && (a._close(), a._changedVisibility = new Map(), a._changedVisibility.set(_n441, t), a._updateColumnsVisibility(void 0, i));
      }
    }
  }, {
    key: "_updateVirtualCard",
    value: function _updateVirtualCard(e, t) {
      var i = this,
          a = i._visibleSource[t],
          n = a.$.id,
          o = e.firstElementChild.lastElementChild,
          r = i.coverField;

      if (e.dataId = t, i._applyTemplate(a, o), e.firstElementChild.scrollTop = i._cardScrolling[n] || 0, i._dragDetails && (e.dataId === i._dragDetails.index ? e.classList.add("dragged") : e.classList.remove("dragged")), i._searchInfo && (i._searchInfo.foundIdsObject[n] ? (e.classList.add("found"), i._searchInfo.highlighted === n ? e.classList.add("highlighted") : e.classList.remove("highlighted")) : e.classList.remove("found", "highlighted")), i._toggleCard(e, o, n), r) {
        var _t901 = e.firstElementChild.firstElementChild;
        var _o324 = a[r];

        if (_o324 = "string" == typeof _o324 ? _o324.split(",").map(function (e) {
          return e.trim();
        }) : [], _t901.set("dataSource", _o324), 0 < _o324.length) {
          var _e1063 = i._cardSelectedCover[n] || 0;

          _t901._generateIndicators(), _t901._indicators[_e1063].classList.add("smart-active"), _t901._generateItems(), _t901._items[_e1063].classList.add("smart-active"), _t901._currentIndex = _e1063;
        }
      }
    }
  }, {
    key: "_updateCardHeight",
    value: function _updateCardHeight(e) {
      var t = this,
          i = t._cards;

      if (null === e) {
        var _e1064 = 0,
            _a582 = [];
        if (t._autoCardHeight = !0, 0 === t._cards.length) return;
        if (i.forEach(function (e) {
          e.style.height = null, e.classList.contains("collapsed") && (e.setAttribute("updating", ""), e.classList.remove("collapsed"), e.getElementsByClassName("smart-card-view-content")[0].classList.remove("smart-visibility-hidden"), _a582.push(e));
        }), i.forEach(function (t) {
          return _e1064 = Math.max(t.offsetHeight, _e1064);
        }), i.forEach(function (t) {
          return t.style.height = _e1064 + "px";
        }), t._cardContentHeight = t._cards[0].getElementsByClassName("smart-card-view-content")[0].offsetHeight + t._verticalOffset, 0 < _a582.length && (_a582.forEach(function (e) {
          e.classList.add("collapsed"), e.getElementsByClassName("smart-card-view-content")[0].classList.add("smart-visibility-hidden");
        }), setTimeout(function () {
          _a582.forEach(function (e) {
            return e.removeAttribute("updating");
          });
        }, 100)), t._cardHeight === _e1064) return;
        t._cardHeight = _e1064;
      } else {
        var _a583 = t._cards[0];

        var _n442;

        if (t._autoCardHeight = !1, t._cardHeight === e) return;
        if (t._cardHeight = e, !_a583) return;
        i.forEach(function (t) {
          return t.style.height = e + "px";
        }), _a583.classList.contains("collapsed") && (_a583.setAttribute("updating", ""), _a583.classList.remove("collapsed"), _a583.getElementsByClassName("smart-card-view-content")[0].classList.remove("smart-visibility-hidden"), _n442 = !0), t._cardContentHeight = t._cards[0].getElementsByClassName("smart-card-view-content")[0].offsetHeight + t._verticalOffset, _n442 && (_a583.classList.add("collapsed"), _a583.getElementsByClassName("smart-card-view-content")[0].classList.add("smart-visibility-hidden"), setTimeout(function () {
          _a583.removeAttribute("updating");
        }, 100));
      }

      t._partialRefresh();
    }
  }, {
    key: "_partialRefresh",
    value: function _partialRefresh() {
      function e() {
        var e = (i + 2 * a) / a * o;

        for (e = e - e % o + o; 0 < n && e * (a - t._cardContentHeight) < i + 2 * a;) {
          e++;
        }

        for (e = Math.min(e, t._visibleSource.length); t._cards.length < e;) {
          t._createEmptyCard(!1);
        }

        for (; t._cards.length > e;) {
          t._cards[t._cards.length - 1].remove(), t._cards.pop();
        }

        for (; "infinite" === t.scrolling && 0 != t._cards.length % o;) {
          t._createEmptyCard();
        }
      }

      var t = this;
      if (t._refreshedAtDimensions = {
        width: t._cachedWidth,
        height: t._cachedHeight
      }, t._cards.length === t._visibleSource.length) return t._dataSourceProcessed && t._refreshCardContent(), void t.$.scrollViewer.refresh();

      t._getCardsPerRow();

      var i = t.$.scrollViewer.$.scrollViewerContainer.offsetHeight,
          a = t._cardHeight + t._gap,
          n = Object.keys(t._collapsed).length;
      var o = t._cardsPerRow;
      e(), t._getCardsPerRow(), o !== t._cardsPerRow && (o = t._cardsPerRow, e()), t._getNumberOfCollapsedRows();

      var r = t._getFractionOfMax(),
          l = Math.ceil(t._visibleSource.length / t._cardsPerRow),
          s = a * l - t._gap,
          d = Math.max(0, s - i - t._numberOfCollapsedRows * t._cardContentHeight);

      t.$.scrollViewer.$.verticalScrollBar.max = d, t._scrollHeight = s, 0 === d && t.$.scrollViewer.refresh(), t._setFractionOfMax(r);
    }
  }, {
    key: "_getFractionOfMax",
    value: function _getFractionOfMax() {
      var e = this.$.scrollViewer.$.verticalScrollBar,
          t = e.max;
      return 0 === t ? 0 : e.value / e.max;
    }
  }, {
    key: "_setFractionOfMax",
    value: function _setFractionOfMax(e) {
      var t = this,
          i = this.$.scrollViewer.$.verticalScrollBar,
          a = i.max * e;
      i.value = a, t._onVerticalChange({
        detail: {
          value: a
        }
      });
    }
  }, {
    key: "_refreshCardContent",
    value: function _refreshCardContent() {
      var e = this;

      e._updateVisibleCards(e._start.view, e._start.data, !0);
    }
  }, {
    key: "_getVisibleRecords",
    value: function _getVisibleRecords() {
      var e = this,
          t = e.dataSource;
      if (0 === e._appliedFiltering.filters.length) e._visibleSource = t;else {
        e._visibleSource = [];

        for (var _a584 = 0; _a584 < t.length; _a584++) {
          var _t902 = e.dataSource[_a584];
          !1 !== _t902.$.filtered && (e._visibleSource.push(_t902), e._visibleSource[e._visibleSource.length - 1]._id = _t902.$.id);
        }
      }
      t && 0 !== t.length ? (e.removeAttribute("empty"), 0 === e._visibleSource.length ? e.setAttribute("no-matches", "") : e.removeAttribute("no-matches")) : (e.setAttribute("empty", ""), e.removeAttribute("no-matches"));
    }
  }, {
    key: "_clearFilterAndSortUI",
    value: function _clearFilterAndSortUI() {
      var e = this;
      e._appliedFiltering = {
        filters: [],
        operator: "and"
      }, e._appliedSorting = {
        dataFields: [],
        dataTypes: [],
        orderBy: []
      }, e.$.filterButton.classList.remove("filtered"), e.$.sortButton.classList.remove("sorted"), e.$.filterButton.firstElementChild.innerHTML = e.localize("filter"), e.$.sortButton.firstElementChild.innerHTML = e.localize("sort");
    }
  }, {
    key: "_search",
    value: function _search(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = this;
      if (i._searchInfo.query = e, i._cards.forEach(function (e) {
        return e.classList.remove("found", "highlighted");
      }), "" === e) return i.$.search.classList.remove("matches", "no-matches"), delete i._searchInfo.foundIdsArray, delete i._searchInfo.foundIdsObject, void delete i._searchInfo.highlighted;
      var a = i._searchInfo.source,
          n = [],
          o = [],
          r = {};
      i._searchInfo.stringDataFields.forEach(function (t) {
        var i = new Smart.Utilities.FilterGroup(),
            a = i.createFilter("string", e, "CONTAINS");
        i.addFilter("or", a), n.push([t, i]);
      }), a._filter(n, "or");

      for (var _n443 = 0; _n443 < a.length; _n443++) {
        var _e1065 = a[_n443];
        !1 !== _e1065.$.filtered && (o.push(_e1065.$.id), r[_e1065.$.id] = !0);
      }

      var l = o[0];
      return i._searchInfo.foundIdsArray = o, i._searchInfo.foundIdsObject = r, 0 < o.length ? (t && (i._searchInfo.highlighted = l, i.ensureVisible(l)), i._cards.forEach(function (e) {
        var a = i._visibleSource[e.dataId].$.id;
        r[a] && (t && l === a && e.classList.add("highlighted"), e.classList.add("found"));
      }), i.$.search.classList.remove("no-matches"), i.$.search.classList.add("matches"), void (i.$.searchLabel.innerHTML = i.localize("found", {
        nth: t ? 1 : 0,
        n: o.length
      }))) : void (i.$.search.classList.remove("matches"), i.$.search.classList.add("no-matches"), i.$.searchLabel.innerHTML = i.localize("found", {
        nth: 0,
        n: 0
      }));
    }
  }, {
    key: "_closeSearchPanel",
    value: function _closeSearchPanel() {
      var e = this;
      e._searchInfo && (e._cards.forEach(function (e) {
        return e.classList.remove("found", "highlighted");
      }), delete e._searchInfo);
    }
  }, {
    key: "_searchInputKeyupHandler",
    value: function _searchInputKeyupHandler() {
      var e = this;
      clearTimeout(e._searchInputTimeout), e._searchInputTimeout = setTimeout(function () {
        e.$.searchInput.value !== e._searchInfo.query && e._search(e.$.searchInput.value);
      }, 500);
    }
  }, {
    key: "_headerDropDownTransitionendHandler",
    value: function _headerDropDownTransitionendHandler(e) {
      var t = this;
      "visibility" === e.propertyName && t.$.headerDropDown.classList.contains("search-panel") && !t.$.headerDropDown.classList.contains("smart-visibility-hidden") && t.$.searchInput.focus();
    }
  }, {
    key: "_cardContainerDownHandler",
    value: function _cardContainerDownHandler(e) {
      var t = this;

      if (delete t._clickToDrag, t.allowDrag && (t._isMobile || 0 === e.button)) {
        var _i896 = e.originalEvent.target;
        if (_i896.closest(".smart-indicator") || _i896.closest(".smart-arrow-up")) return void (t._isMobile && (t.$.scrollViewer._scrollView.disableSwipeScroll = !0));

        var _a585 = e.originalEvent.target.closest("smart-card");

        _a585 && (t._dragDetails = {
          card: _a585,
          coords: {
            x: e.pageX,
            y: e.pageY
          },
          index: _a585.dataId,
          originalEvent: e,
          record: t._visibleSource[_a585.dataId],
          startTime: new Date()
        }, t.$.scrollViewer._scrollView.disableSwipeScroll = !0, window.getSelection().removeAllRanges());
      }
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = Math.min,
          i = Math.abs,
          a = Math.pow;
      var n = this,
          o = n._dragDetails;
      if (!o) return;

      if (!o.feedbackShown) {
        var _t903 = new Date(),
            _a586 = 500 < _t903.getTime() - o.startTime.getTime(),
            _r200 = 5 < i(o.coords.x - e.pageX) || 5 < i(o.coords.y - e.pageY);

        if (_r200 && (!n._isMobile || n._isMobile && _a586)) {
          var _t904 = n._startDragging(e);

          if (!_t904) return;
        } else return void (n._isMobile && _r200 && !_a586 && (delete n._dragDetails, n.$.scrollViewer._scrollView.disableSwipeScroll = !1));
      }

      var r = o.card,
          l = o.record,
          s = e.clientY,
          d = e.clientX;
      var c = e.originalEvent.target;

      if (n.$.fireEvent("dragging", {
        card: r,
        originalEvent: e,
        record: l
      }), o.feedback.style.left = e.pageX + 10 + "px", o.feedback.style.top = e.pageY + 10 + "px", n._isMobile) {
        var _e1066 = document.elementFromPoint(d, s);

        _e1066 && (c = _e1066);
      }

      clearInterval(n._dragInterval), n._dragInterval = setInterval(function () {
        var e = n.$.scrollViewer.getBoundingClientRect();
        0 < n.$.scrollViewer.scrollHeight && e.left <= d && e.left + e.width >= d ? s >= e.top && s <= e.top + 36 ? n.$.scrollViewer.scrollTop -= n._autoScrollCoefficient : s >= e.top + e.height - 36 && s <= e.top + e.height ? n.$.scrollViewer.scrollTop += n._autoScrollCoefficient : clearInterval(n._dragInterval) : clearInterval(n._dragInterval);
      }, 2);
      var m = c.closest("smart-card"),
          u;

      if (o.hoveredCard && (o.hoveredCard.classList.remove("drop-target", "left", "right"), delete o.hoveredCard), !(m && m.dataId === o.index)) {
        if (m) {
          var _e1067 = m.getBoundingClientRect(),
              _t905 = i(d - _e1067.left),
              _a587 = i(d - _e1067.right);

          u = _t905 < _a587 ? "left" : "right";
        } else if (c === n.$.addNewButton) return;else {
          var _e1068, _r201;

          if (n._cards.forEach(function (n) {
            var o = n.getBoundingClientRect(),
                l = i(s - o.top),
                c = i(s - o.bottom),
                m = t(l, c),
                p = i(d - o.left),
                g = i(d - o.right),
                h = t(p, g),
                _ = Math.sqrt(a(h, 2) + a(m, 2));

            (void 0 === _r201 || _ < _r201) && (_e1068 = n, _r201 = _, u = p < g ? "left" : "right");
          }), m = _e1068, m.dataId === o.index) return;
        }

        m && (m.classList.add(u, "drop-target"), o.hoveredCard = m, o.side = u);
      }
    }
  }, {
    key: "_startDragging",
    value: function _startDragging(e) {
      var t = this,
          i = t._dragDetails,
          a = i.card,
          n = i.record,
          o = t.$.fireEvent("dragStart", {
        card: a,
        originalEvent: e,
        record: n
      });
      return o.defaultPrevented ? (delete t._dragDetails, t.$.scrollViewer._scrollView.disableSwipeScroll = !1, !1) : (i.feedback = t._addDragFeedback(n), i.feedbackShown = !0, t.setAttribute("dragging", ""), a.classList.add("dragged"), t.closePanel(), t._clickToDrag = !0, !0);
    }
  }, {
    key: "_addDragFeedback",
    value: function _addDragFeedback(e) {
      var t = this,
          i = document.createElement("div");
      var a = "";
      return i.className = "smart-card-view-drag-feedback", t.coverField && (a += "<div class=\"drag-feedback-thumbnail\" style=\"background-image: url('".concat(e[t.coverField].split(",")[0].trim(), "');\"></div>")), t.titleField ? a += "<div class=\"drag-feedback-label\">".concat(e[t.titleField], "</div>") : !t.coverField && (a += "<div class=\"drag-feedback-label\">".concat(t.localize("draggedRecord", {
        id: e.$.id
      }), "</div>")), i.innerHTML = a, document.body.appendChild(i), i;
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = t._dragDetails;

      if (t.$.scrollViewer._scrollView.disableSwipeScroll = !1, !i) {
        var _i897 = e.originalEvent.target;
        var _a588 = t.$.header;

        if (t.shadowRoot && _i897 === t && (_i897 = e.originalEvent.composedPath()[0]), "none" !== t.headerPosition && !t.$.headerDropDown.classList.contains("smart-visibility-hidden") && !t.$.headerDropDown.classList.contains("search-panel") && (_i897 === _a588 || !_a588.contains(_i897))) {
          var _e1069 = _i897.closest("smart-scroll-viewer"),
              _n444 = _i897.closest(".smart-drop-down");

          _e1069 && _a588.contains(_e1069.ownerElement) || _n444 && (!_n444.ownerElement || _a588.contains(_n444.ownerElement)) || t.closePanel();
        }

        return;
      }

      var a = i.card,
          n = i.record,
          o = i.hoveredCard;
      if (delete t._dragDetails, !t.hasAttribute("dragging")) return;
      var r = t.$.cardContainer.getElementsByClassName("dragged");
      if (Array.from(r).forEach(function (e) {
        return e.classList.remove("dragged");
      }), t.removeAttribute("dragging"), i.feedback.remove(), clearInterval(t._dragInterval), window.getSelection().removeAllRanges(), !o) return void t.$.fireEvent("dragEnd", {
        card: a,
        originalEvent: e,
        record: n
      });
      var l = t._visibleSource[o.dataId],
          s = t.$.fireEvent("dragEnd", {
        card: a,
        originalEvent: e,
        record: n,
        targetCard: o,
        targetRecord: l,
        targetSide: i.side
      });
      if (o.classList.remove("drop-target", "left", "right"), s.defaultPrevented) return;
      var d = t.dataSource;
      var c, m;

      for (var _t906 = 0; _t906 < d.length; _t906++) {
        var _e1070 = d[_t906];
        if (!_e1070.isEmpty && (_e1070 === n ? c = _t906 : _e1070 === l && (m = _t906), null != c && null != m)) break;
      }

      "right" === i.side && m++, d.move(c, m), t._getVisibleRecords(), t._dataSourceProcessed = !0, t._partialRefresh(), delete t._dataSourceProcessed;
    }
  }, {
    key: "hasStyleObserver",
    get: function get() {
      return !1;
    }
  }, {
    key: "editInfo",
    get: function get() {
      return this._editInfo;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        addNewButton: {
          value: !1,
          type: "boolean"
        },
        allowDrag: {
          value: !1,
          type: "boolean"
        },
        cardHeight: {
          value: null,
          type: "number?"
        },
        cellOrientation: {
          value: "vertical",
          allowedValues: ["horizontal", "vertical"],
          type: "string"
        },
        collapsible: {
          value: !1,
          type: "boolean"
        },
        columns: {
          value: [],
          type: "object",
          reflectToAttribute: !1
        },
        coverField: {
          value: null,
          type: "string?"
        },
        coverMode: {
          value: "crop",
          allowedValues: ["fit", "crop"],
          type: "string"
        },
        dataSource: {
          value: null,
          type: "object?",
          reflectToAttribute: !1
        },
        editable: {
          value: !1,
          type: "boolean"
        },
        headerPosition: {
          value: "none",
          allowedValues: ["none", "top", "bottom"],
          type: "string"
        },
        messages: {
          value: {
            en: {
              addFilter: "+ Add filter",
              addImage: "Add",
              and: "And",
              apply: "Apply",
              booleanFirst: "\u2610",
              booleanLast: "\u2611",
              cancel: "Cancel",
              CONTAINS: "contains",
              CONTAINS_CASE_SENSITIVE: "contains (case sensitive)",
              coverField: "Cover field",
              crop: "Crop",
              customizeCards: "Customize cards",
              dateFirst: "1",
              dateLast: "9",
              dateTabLabel: "DATE",
              DOES_NOT_CONTAIN: "does not contain",
              DOES_NOT_CONTAIN_CASE_SENSITIVE: "does not contain (case sensitive)",
              draggedRecord: "Record {{id}}",
              EMPTY: "empty",
              ENDS_WITH: "ends with",
              ENDS_WITH_CASE_SENSITIVE: "ends with (case sensitive)",
              EQUAL: "equal",
              EQUAL_CASE_SENSITIVE: "equal (case sensitive)",
              filter: "Filter",
              filteredByMultiple: "{{n}} filters",
              filteredByOne: "1 filter",
              find: "Find a field",
              findInView: "Find in view",
              firstBy: "Sort by",
              fit: "Fit",
              found: "{{nth}} of {{n}}",
              from: "from",
              GREATER_THAN: "greater than",
              GREATER_THAN_OR_EQUAL: "greater than or equal",
              imageUrl: "New image URL:",
              incorrectStructure: "\"dataSource\" must be an instance of Smart.DataAdapter or an array of objects with key-value pairs.",
              LESS_THAN: "less than",
              LESS_THAN_OR_EQUAL: "less than or equal",
              nextRecord: "Next record",
              noCoverField: "No cover field",
              noData: "No data to display",
              noFilters: "No filters applied",
              noMatches: "No matched records",
              noSorting: "No sorting applied",
              noResults: "No results",
              NOT_EMPTY: "not empty",
              NOT_EQUAL: "not equal",
              NOT_NULL: "not null",
              now: "Now",
              NULL: "null",
              numberFirst: "1",
              numberLast: "9",
              ok: "OK",
              or: "Or",
              pickAnother: "Pick another field to sort by",
              previousRecord: "Previous record",
              removeImage: "Remove",
              sort: "Sort",
              sortedByMultiple: "Sorted by {{n}} fields",
              sortedByOne: "Sorted by 1 field",
              STARTS_WITH: "starts with",
              STARTS_WITH_CASE_SENSITIVE: "starts with (case sensitive)",
              stringFirst: "A",
              stringLast: "Z",
              thenBy: "then by",
              timeTabLabel: "TIME",
              toggleVisibility: "Toggle field visibility",
              where: "Where"
            }
          }
        },
        onRecordInserted: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        onRecordRemoved: {
          value: null,
          type: "function?",
          reflectToAttribute: !1
        },
        scrolling: {
          value: "physical",
          allowedValues: ["physical", "virtual", "infinite", "deferred"],
          type: "string"
        },
        titleField: {
          value: null,
          type: "string?"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        click: "_clickHandler",
        move: "_moveHandler",
        resize: "_resizeHandler",
        "addNewButton.click": "_addNewButtonClickHandler",
        "cardContainer.down": "_cardContainerDownHandler",
        "header.apply": "_applyHandler",
        "header.cancel": "closePanel",
        "headerDropDown.transitionend": "_headerDropDownTransitionendHandler",
        "searchInput.keyup": "_searchInputKeyupHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Button": "smart.button.js",
        "Smart.Card": "smart.card.js",
        "Smart.Carousel": "smart.carousel.js",
        "Smart.CheckBox": "smart.checkbox.js",
        "Smart.ColumnPanel": "smart.gridpanel.js",
        "Smart.DataAdapter": "smart.data.js",
        "Smart.DateTimePicker": "smart.datetimepicker.js",
        "Smart.Input": "smart.input.js",
        "Smart.NumericTextBox": "smart.numerictextbox.js",
        "Smart.ScrollBar": "smart.scrollbar.js",
        "Smart.SwitchButton": "smart.switchbutton.js",
        "Smart.Window": "smart.window.js",
        "Smart.Utilities.DateTime": "smart.date.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.cardview.css"];
    }
  }]);

  return _class94;
}(Smart.BaseElement)), Smart("smart-numeric-text-box",
/*#__PURE__*/
function (_Smart$BaseElement22) {
  "use strict";

  _inherits(_class95, _Smart$BaseElement22);

  function _class95() {
    _classCallCheck(this, _class95);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class95).apply(this, arguments));
  }

  _createClass(_class95, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" class=\"smart-container\" role=\"presentation\">\n                <span id=\"label\" inner-h-t-m-l=\"[[label]]\" class=\"smart-label\"></span>\n                <div id=\"radixDisplayButton\" class=\"smart-unselectable smart-input-addon smart-numeric-text-box-component smart-numeric-text-box-radix-display\" role=\"button\" aria-haspopup=\"listbox\"></div>\n                <input id=\"input\" type=\"text\" spellcheck=\"false\" class=\"smart-input smart-numeric-text-box-component\" placeholder=\"[[placeholder]]\" readonly=\"[[readonly]]\" disabled=\"[[disabled]]\" name=\"[[name]]\" />\n                <div id=\"unitDisplay\" class=\"smart-unselectable smart-input-addon smart-numeric-text-box-component smart-numeric-text-box-unit-display\" role=\"presentation\"></div>\n                <div id=\"spinButtonsContainer\" class=\"smart-input-addon smart-numeric-text-box-component smart-spin-buttons-container\" role=\"presentation\">\n                    <smart-repeat-button initial-delay=\"[[spinButtonsInitialDelay]]\" delay=\"[[spinButtonsDelay]]\" animation=\"[[animation]]\" unfocusable id=\"upButton\" class=\"smart-spin-button\" aria-label=\"Increment\" right-to-left=\"[[rightToLeft]]\">\n                        <div class=\"smart-arrow smart-arrow-up\" role=\"presentation\" aria-hidden=\"true\"></div>\n                    </smart-repeat-button>\n                    <smart-repeat-button initial-delay=\"[[spinButtonsInitialDelay]]\" delay=\"[[spinButtonsDelay]]\" animation=\"[[animation]]\" unfocusable id=\"downButton\" class=\"smart-spin-button\" aria-label=\"Decrement\" right-to-left=\"[[rightToLeft]]\">\n                        <div class=\"smart-arrow smart-arrow-down\" role=\"presentation\" aria-hidden=\"true\"></div>\n                    </smart-repeat-button>\n                </div>\n                <ul id=\"dropDown\" class=\"smart-visibility-hidden smart-drop-down smart-numeric-text-box-drop-down\" role=\"listbox\">\n                    <li id=\"dropDownItem2\" class=\"smart-list-item\" data-value=\"2\" role=\"option\"></li>\n                    <li id=\"dropDownItem8\" class=\"smart-list-item\" data-value=\"8\" role=\"option\"></li>\n                    <li id=\"dropDownItem10\" class=\"smart-list-item\" data-value=\"10\" role=\"option\"></li>\n                    <li id=\"dropDownItem16\" class=\"smart-list-item\" data-value=\"16\" role=\"option\"></li>\n                </ul>\n                <span id=\"hint\" class=\"smart-hint\" inner-h-t-m-l=\"[[hint]]\"></span>\n            </div>";
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;

      _get(_getPrototypeOf(_class95.prototype), "attached", this).call(this);

      e.isCompleted && (e._positionDetection.dropDownAttached(), e._positionDetection.checkBrowserBounds());
    }
  }, {
    key: "detached",
    value: function detached() {
      var e = this;
      _get(_getPrototypeOf(_class95.prototype), "detached", this).call(this), e.opened && e._closeRadix(), e._positionDetection && e._positionDetection.dropDownDetached();
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class95.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e._numericProcessor = new Smart.Utilities.NumericProcessor(e, "inputFormat"), e._numberRenderer = new Smart.Utilities.NumberRenderer(), e._numberRenderer.localizationObject.decimalseparator = e.decimalSeparator, e._positionDetection = new Smart.Utilities.PositionDetection(e, e.$.dropDown, e.$.container, "_closeRadix"), e._positionDetection.getDropDownParent(!0), e._dropDownListPosition = "bottom", e._setIds(), e.setAttribute("role", "input"), e.setAttribute("aria-describedby", e.$.unitDisplay.id + " " + e.$.hint.id), e.setAttribute("aria-labelledby", e.$.label.id), e.$.radixDisplayButton.setAttribute("aria-owns", e.$.dropDown.id), e.rightToLeft && null !== e.dropDownAppendTo && e.$.dropDown.setAttribute("right-to-left", ""), e._radixPrefixes = {
        10: "d",
        2: "b",
        8: "o",
        16: "x"
      }, e._regex = {
        2: new RegExp(/^[0-1]+$/),
        8: new RegExp(/^[0-7]+$/),
        10: new RegExp(/^[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?$/),
        16: new RegExp(/^[0-9a-f]+$/i)
      }, e._regexSpecial = {
        nan: new RegExp(/^(nan)$/i),
        inf: new RegExp(/^((-?inf(inity)?)|([+\-]?∞))$/i),
        nonNumericValue: new RegExp(/^$|(^((nan)|((-?inf(inity)?)|([+\-]?∞))|(null))$)/i),
        exaValue: new RegExp(/^[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[E][+\-]\d*)?i$/)
      }, e._initialDropDownOptionsSet = !1, "left" === e.spinButtonsPosition && e.$.container.insertBefore(e.$.spinButtonsContainer, e.$.label.nextElementSibling), "right" === e.radixDisplayPosition && e.$.container.insertBefore(e.$.radixDisplayButton, e.$.unitDisplay.nextElementSibling), e._setInitialComponentDisplay(), e._initialAdjustments(), e._refreshShape(), e._initialized = !0, _get(_getPrototypeOf(_class95.prototype), "render", this).call(this);
    }
  }, {
    key: "_setIds",
    value: function _setIds() {
      var e = this;
      e.$.label.id || (e.$.label.id = e.id + "Label"), e.$.radixDisplayButton.id || (e.$.radixDisplayButton.id = e.id + "RadixDisplayButton"), e.$.unitDisplay.id || (e.$.unitDisplay.id = e.id + "UnitDisplay"), e.$.dropDown.id || (e.$.dropDown.id = e.id + "DropDown"), e.$.hint.id || (e.$.hint.id = e.id + "Hint");
    }
  }, {
    key: "_refreshShape",
    value: function _refreshShape() {
      var e = this,
          t = e.$.container.querySelectorAll(".smart-numeric-text-box-component:not(.smart-hidden)");
      Array.from(e.$.container.getElementsByClassName("smart-numeric-text-box-component")).forEach(function (e) {
        return e.classList.remove("smart-numeric-text-box-component-border-left", "smart-numeric-text-box-component-border-right");
      }), 0 < t.length && (t[0].classList.add("smart-numeric-text-box-component-border-left"), t[t.length - 1].classList.add("smart-numeric-text-box-component-border-right"));
    }
  }, {
    key: "val",
    value: function val(e, t) {
      var i = this,
          a = null !== e && "object" == typeof e && 0 === Object.keys(e).length;

      if (void 0 !== e && !1 == a) {
        var _a589 = i.value;
        if (("" === e || null === e) && null === _a589) return null;
        if (null === e) return i._triggerChangeEvent = "strict" === i.validation, i._validate(!1, null), i._triggerChangeEvent = !1, void (i._programmaticValueIsSet = !0);
        if (e = e.toString(), e.toUpperCase() !== _a589.toString().toUpperCase()) void 0 === t ? (i._triggerChangeEvent = "strict" === i.validation, i._validate(!1, e), i._triggerChangeEvent = !1) : i._setValue(e), i._programmaticValueIsSet = !0;else return e;
      } else return i.value;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.$.input.focus();
    }
  }, {
    key: "_updateSpinButtonsStepObject",
    value: function _updateSpinButtonsStepObject() {
      var e = this;
      e._spinButtonsStepObject = e._numericProcessor.createDescriptor(e.spinButtonsStep, !0);
    }
  }, {
    key: "_setInitialComponentDisplay",
    value: function _setInitialComponentDisplay() {
      var e = this;
      !1 === e.spinButtons && e.$spinButtonsContainer.addClass("smart-hidden"), !1 === e.radixDisplay && e.$radixDisplayButton.addClass("smart-hidden"), !1 === e.showUnit && e.$unitDisplay.addClass("smart-hidden");
    }
  }, {
    key: "_initialAdjustments",
    value: function _initialAdjustments() {
      var e = this;
      e._radixNumber = e._getRadix(e.radix), e._wordLengthNumber = e._numericProcessor.getWordLength(e.wordLength), e._validatePropertyCompatibility(), e._numericProcessor.validateMinMax(!0, !0), e._updateSpinButtonsStepObject(), e._validate(!0), e._programmaticValueIsSet = !0, e._cachedInputValue = e.$.input.value, e._editableValue === void 0 && (e._editableValue = e._cachedInputValue), e.$.radixDisplayButton.innerHTML = e._radixPrefixes[e._radixNumber], e.$.unitDisplay.innerHTML = e.unit, e.disabled && (e.$.upButton.disabled = !0, e.$.downButton.disabled = !0), e.opened && (e.dropDownEnabled && !e.disabled && null !== e.value ? e._openRadix() : e.opened = !1), e.$.radixDisplayButton.setAttribute("aria-expanded", e.opened), e._setFocusable();
    }
  }, {
    key: "_validatePropertyCompatibility",
    value: function _validatePropertyCompatibility() {
      var e = this;
      "integer" === e.inputFormat ? null !== e.precisionDigits && e.error(e.localize("noInteger", {
        property: "precisionDigits"
      })) : (10 !== e._radixNumber && e.error(e.localize("integerOnly", {
        property: "radix"
      })), e.radixDisplay && e.error(e.localize("integerOnly", {
        property: "radixDisplay"
      })), e.dropDownEnabled && e.error(e.localize("integerOnly", {
        property: "dropDownEnabled"
      })), "int32" !== e.wordLength && e.error(e.localize("integerOnly", {
        property: "wordLength"
      }))), null === e.significantDigits && null === e.precisionDigits ? e.significantDigits = 8 : null !== e.significantDigits && null !== e.precisionDigits && e.error(e.localize("significantPrecisionDigits"));
    }
  }, {
    key: "_validate",
    value: function _validate(e, t) {
      var i = this;
      var a;
      if (e) a = i.value, void 0 === a && (i.nullable ? a = null : a = "0");else if (void 0 !== t && (null !== t || i.nullable)) a = t;else if (a = i.$.input.value, a === i.value && !0 !== i._programmaticValueIsSet) return void (i.$.input.value = i._cachedInputValue);
      if (i.nullable && (null === a || "" === a)) return i.value = null, i._number = null, i.$.input.value = "", i._cachedInputValue = "", i._editableValue = "", void i._disableComponents();

      var n = i._numericProcessor.prepareForValidation(e, t, a);

      if (void 0 === n) return void i._disableComponents();

      var o = i._numericProcessor.createDescriptor(n.value, !0, !0, !e && t === void 0 || "strict" === i.validation, e || t !== void 0, n.enteredComplexNumber);

      if (e) {
        i._number = o;

        var _e1071 = i._renderValue(o);

        i.value = o.toString(), i.$.input.value = _e1071;
      } else i._updateValue(o);

      i._programmaticValueIsSet = !1, i._disableComponents();
    }
  }, {
    key: "_handleNonNumericValue",
    value: function _handleNonNumericValue(e, t, i) {
      var a = this;

      if ("integer" !== a.inputFormat) {
        if (a._regexSpecial.nan.test(i)) return void a._handleNaN(e);
        if (a._regexSpecial.inf.test(i)) return void a._handleInfinity(e, t, i);
      }

      if (e) {
        var _e1072 = a._numericProcessor.createDescriptor(0);

        a._number = a._validateRange(_e1072);

        var _t907 = a._renderValue(a._number);

        a.value = a._number.toString(), a.$.input.value = _t907;
      } else if (void 0 === t) a.$.input.value = a._cachedInputValue;else {
        var _e1073 = a._number.toString();

        a.value !== _e1073 && (a.value = _e1073);
      }
    }
  }, {
    key: "_handleNaN",
    value: function _handleNaN(e) {
      var t = this;
      if (t.$.input.value = "NaN", e) t.value = NaN, t._number = NaN;else {
        var _e1074 = t.value;
        (null === _e1074 || "NaN" !== _e1074.toString()) && (t.value = NaN, t._number = NaN, t._cachedInputValue = "NaN", t._editableValue = "NaN", t._triggerChangeEvent && t.$.fireEvent("change", {
          value: NaN,
          oldValue: _e1074,
          radix: t._radixNumber
        }));
      }
    }
  }, {
    key: "_handleInfinity",
    value: function _handleInfinity(e, t, i) {
      var a = this;
      var n, o;
      if ("-" === i.charAt(0) ? (n = "\u221E" === i.charAt(1) ? "-\u221E" : "-Inf", o = -Infinity) : (n = -1 === i.indexOf("\u221E") ? "Inf" : "\u221E", o = 1 / 0), (o !== -Infinity || a.min !== -Infinity) && (o !== 1 / 0 || a.max !== 1 / 0) && void 0 === t) o === -Infinity ? a._validate(!1, a.min) : a._validate(!1, a.max);else if (e) a.value = o, a._number = o, a.$.input.value = n;else {
        var _e1075 = a.value;
        i !== n && (a.$.input.value = n), _e1075 !== o && (a.value = o, a._number = o, a._cachedInputValue = n, a._editableValue = n, a._triggerChangeEvent && a.$.fireEvent("change", {
          value: o,
          oldValue: _e1075,
          radix: a._radixNumber
        }));
      }
    }
  }, {
    key: "_validateRange",
    value: function _validateRange(e) {
      var t = this;
      return e = t._numericProcessor.validate(e, t._minObject, t._maxObject), e;
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      function a() {
        !0 === n._initialDropDownOptionsSet && n._setDropDownOptions(), (2 === n._radixNumber || 16 === n._radixNumber) && (n._cachedInputValue = n._number.toString(n._radixNumber, n._wordLengthNumber, n.leadingZeros), n._editableValue = n._cachedInputValue, n.$.input.value = n._cachedInputValue);
      }

      _get(_getPrototypeOf(_class95.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var n = this,
          o = n.$.input;
      if (i != t) switch (e) {
        case "disabled":
          n._setFocusable(), !0 === i ? (n.$.upButton.disabled = !0, n.$.downButton.disabled = !0) : n._disableComponents();
          break;

        case "dropDownAppendTo":
          n._positionDetection.dropDownAppendToChangedHandler(), n.$.dropDown.removeAttribute("right-to-left"), n.rightToLeft && null !== i && n.$.dropDown.setAttribute("right-to-left", "");
          break;

        case "unfocusable":
          n._setFocusable();

          break;

        case "enableMouseWheelAction":
        case "placeholder":
        case "readonly":
        case "spinButtonsDelay":
        case "spinButtonsInitialDelay":
          break;

        case "value":
          {
            if ("" === i && null === t) return;
            if (null === i || "" === i || null === t) return n.value = t, n._triggerChangeEvent = "strict" === n.validation, n._validate(!1, i), n._triggerChangeEvent = !1, void (n._programmaticValueIsSet = !0);

            var _e1076 = i.toString(),
                _a590 = t.toString();

            _a590 !== _e1076 && (_a590.toUpperCase() === _e1076.toUpperCase() && (n.value = t), n.value = t, n._triggerChangeEvent = "strict" === n.validation, n._validate(!1, _e1076), n._triggerChangeEvent = !1, n._programmaticValueIsSet = !0);
            break;
          }

        case "radix":
          "integer" === n.inputFormat ? n._changeRadix(i) : n.error(n.localize("integerOnly", {
            property: "radix"
          }));
          break;

        case "rightToLeft":
          null !== n.dropDownAppendTo && (i ? n.$.dropDown.setAttribute("right-to-left", "") : n.$.dropDown.removeAttribute("right-to-left"));
          break;

        case "leadingZeros":
          "integer" === n.inputFormat && null !== n._number && a();
          break;

        case "min":
        case "max":
          {
            if (null !== i && (n["_".concat(e, "IsNull")] = !1), n._numericProcessor.validateMinMax("min" === e, "max" === e), "strict" === n.validation) n._triggerChangeEvent = !0, n._validate(!1, n.value), n._triggerChangeEvent = !1;else if (!1 === n._regexSpecial.nonNumericValue.test(n.value)) {
              var _e1077 = n._numericProcessor.createDescriptor(n._number),
                  _t908 = n._validateRange(_e1077);

              !0 === n._numericProcessor.compare(n.value, _t908) && (n._programmaticValueIsSet = !0);
            }
            break;
          }

        case "opened":
          i ? n.dropDownEnabled && !n.disabled && null !== n.value ? n._openRadix() : (n.opened = !1, n.$.radixDisplayButton.setAttribute("aria-expanded", !1)) : n._closeRadix();
          break;

        case "outputFormatString":
          i ? (n._cachedInputValue = n._numberRenderer.formatNumber(n._number, i), n.$.input.value = n._cachedInputValue) : (n._cachedInputValue = n._editableValue, n.$.input.value = n._editableValue);
          break;

        case "dropDownEnabled":
          i ? ("integer" !== n.inputFormat && n.error(n.localize("integerOnly", {
            property: "dropDownEnabled"
          })), !0 === n._initialDropDownOptionsSet && n._setDropDownOptions()) : n.opened && n._closeRadix(!0);
          break;

        case "spinButtons":
          i ? n.$spinButtonsContainer.removeClass("smart-hidden") : n.$spinButtonsContainer.addClass("smart-hidden"), n._refreshShape();
          break;

        case "spinButtonsStep":
          n._updateSpinButtonsStepObject();

          break;

        case "significantDigits":
        case "precisionDigits":
          {
            if ("precisionDigits" === e && "integer" === n.inputFormat && n.error(n.localize("noInteger", {
              property: e
            })), "significantDigits" === e && null !== n.precisionDigits ? n.precisionDigits = null : "precisionDigits" == e && null !== n.significantDigits && (n.significantDigits = null), !1 === n._regexSpecial.nonNumericValue.test(n.value)) {
              var _e1078 = n._renderValue(n._number);

              o.value = _e1078;
            }

            break;
          }

        case "decimalSeparator":
          {
            n._numberRenderer.localizationObject.decimalseparator = n.decimalSeparator;

            var _e1079 = n._discardDecimalSeparator(o.value, t),
                _i898 = n._applyDecimalSeparator(_e1079),
                _a591 = n._applyDecimalSeparator(n._discardDecimalSeparator(n._editableValue, t));

            o.value = _i898, n._editableValue = _a591;
            break;
          }

        case "spinButtonsPosition":
          "left" === i ? n.$.container.insertBefore(n.$.spinButtonsContainer, n.$.label.nextElementSibling) : n.$.container.insertBefore(n.$.spinButtonsContainer, n.$.dropDown), n._refreshShape();
          break;

        case "wordLength":
          if (n._wordLengthNumber = n._numericProcessor.getWordLength(i), "integer" === n.inputFormat && (n._numericProcessor.validateMinMax(!0, !0), null !== n._number)) {
            var _e1080 = n._validateRange(new Smart.Utilities.BigNumber(n._number));

            n._updateValue(_e1080), n.leadingZeros && a();
          }

          break;

        case "radixDisplay":
          i ? ("integer" !== n.inputFormat && n.error(n.localize("integerOnly", {
            property: "radixDisplay"
          })), n.$radixDisplayButton.removeClass("smart-hidden")) : n.$radixDisplayButton.addClass("smart-hidden"), n._refreshShape();
          break;

        case "radixDisplayPosition":
          "left" === i ? n.$.container.insertBefore(n.$.radixDisplayButton, n.$.input) : n.$.container.insertBefore(n.$.radixDisplayButton, n.$.unitDisplay.nextElementSibling), n._refreshShape();
          break;

        case "inputFormat":
          n._changeInputFormat(t, i);

          break;

        case "showUnit":
          i ? n.$unitDisplay.removeClass("smart-hidden") : n.$unitDisplay.addClass("smart-hidden"), n._refreshShape();
          break;

        case "unit":
          n.$.unitDisplay.innerHTML = i;
          break;

        case "scientificNotation":
          {
            if (!1 === n._regexSpecial.nonNumericValue.test(n.value)) {
              var _e1081 = n._renderValue(n._number);

              o.value = _e1081;
            }

            break;
          }

        case "locale":
        case "messages":
          n._initialDropDownOptionsSet = !1;
          break;

        case "nullable":
          !0 === t && null === n.value && n._validate(!1, "0");
          break;

        case "validation":
          "strict" === i && (n._triggerChangeEvent = !0, n._validate(!1, n.value), n._triggerChangeEvent = !1);
      } else "string" != typeof i && "string" == typeof t && (n[e] = t);
      n._cachedInputValue = o.value;
    }
  }, {
    key: "_changeInputFormat",
    value: function _changeInputFormat(e, t) {
      var i = this;
      return i._numericProcessor = new Smart.Utilities.NumericProcessor(i, "inputFormat"), "complex" === e ? void i._changeFromComplexInputFormat(t) : void ("integer" === t && "floatingPoint" == e && i._changeFromFloatingPointToIntegerInputFormat(), "floatingPoint" === t && "integer" == e && i._changeFromIntegerToFloatingPointInputFormat(), "complex" === t && i._changeToComplexInputFormat(e), i._updateSpinButtonsStepObject(), null !== i.value && (i._inputFormatChangedFlag = !0, i._validate(void 0, i._number.toString()), i._inputFormatChangedFlag = !1));
    }
  }, {
    key: "_changeFromComplexInputFormat",
    value: function _changeFromComplexInputFormat(e) {
      var t = this;
      t.spinButtonsStep = t._spinButtonsStepObject.realPart, t._updateSpinButtonsStepObject(), "integer" === e ? (t.min = t.min === -Infinity ? null : t._minObject.realPart, t.max = t.max === 1 / 0 ? null : t._maxObject.realPart) : (t.min !== -Infinity && (t.min = t._minObject.realPart), t.max !== 1 / 0 && (t.max = t._maxObject.realPart)), t._numericProcessor.validateMinMax(!0, !0), null !== t.value && (t._inputFormatChangedFlag = !0, t._validate(void 0, t._number.realPart.toString()), t._inputFormatChangedFlag = !1);
    }
  }, {
    key: "_changeFromFloatingPointToIntegerInputFormat",
    value: function _changeFromFloatingPointToIntegerInputFormat() {
      var e = this;
      e.min === -Infinity && (e.min = null), e.max === 1 / 0 && (e.max = null), e._numericProcessor.validateMinMax(!0, !0);
    }
  }, {
    key: "_changeFromIntegerToFloatingPointInputFormat",
    value: function _changeFromIntegerToFloatingPointInputFormat() {
      var e = this;
      e.radixDisplay && (e.radixDisplay = !1, e.$radixDisplayButton.addClass("smart-hidden")), 10 !== e._radixNumber && (e.radix = 10, e._radixNumber = 10), e._minIsNull ? (e.min = -Infinity, e._minObject = -Infinity) : e._minObject = parseFloat(e._minObject.toString()), e._maxIsNull ? (e.max = 1 / 0, e._maxObject = 1 / 0) : e._maxObject = parseFloat(e._maxObject.toString()), e.dropDownEnabled && (e.dropDownEnabled = !1);
    }
  }, {
    key: "_changeToComplexInputFormat",
    value: function _changeToComplexInputFormat(e) {
      var t = this;
      "integer" === e && (t.radixDisplay && (t.radixDisplay = !1, t.$radixDisplayButton.addClass("smart-hidden")), t._minIsNull && (t.min = null), t._maxIsNull && (t.max = null), t.dropDownEnabled && (t.dropDownEnabled = !1)), t._numericProcessor.validateMinMax(t.min !== -Infinity, t.max !== 1 / 0);
    }
  }, {
    key: "_updateValue",
    value: function _updateValue(e) {
      var t = this,
          i = t.$.input.value,
          a = e.toString(t._radixNumber, t._wordLengthNumber, t.leadingZeros);

      if (i !== a || i !== t._cachedInputValue) {
        var _i899 = t._renderValue(e),
            _n445 = t.value,
            _o325 = t._regexSpecial.nonNumericValue.test(a);

        if (t.$.input.value = _i899, t._cachedInputValue = _i899, t._inputFormatChangedFlag || _o325 && _i899 !== _n445 || !1 === _o325 && t._numericProcessor.compare(e, t._number)) {
          t._number = t._numericProcessor.createDescriptor(e);

          var _i900 = t._number.toString();

          t.value = _i900, t._setDropDownOptions(), t._triggerChangeEvent && t.$.fireEvent("change", {
            value: _i900,
            oldValue: _n445,
            radix: t._radixNumber
          });
        }
      } else t.value = t._number.toString();
    }
  }, {
    key: "_setValue",
    value: function _setValue(e) {
      var t = this;
      t.value = e, t.$.input.value = e, t._number = t._numericProcessor.createDescriptor(e, !0), t._setDropDownOptions();
    }
  }, {
    key: "_changeRadix",
    value: function _changeRadix(e) {
      var t = this,
          i = t._getRadix(e),
          a = t.radix;

      if (i === t._radixNumber) return;
      t.radix = e, t._radixNumber = i;
      var n = t.$.input,
          o = n.value;
      var r, l;
      null === t.value ? l = "" : (r = t._number.toString(i, t._wordLengthNumber, t.leadingZeros), l = t._renderValue(r)), n.value = l, t._cachedInputValue = l, t.$.radixDisplayButton.innerHTML = t._radixPrefixes[i], t.$.fireEvent("radixChange", {
        radix: e,
        oldRadix: a,
        displayedValue: l,
        oldDisplayedValue: o
      });
    }
  }, {
    key: "_openRadix",
    value: function _openRadix() {
      var e = this,
          t = e.$.fireEvent("opening");
      if (t.defaultPrevented) return void (e.opened = !1);
      !1 === e._initialDropDownOptionsSet && (e._setDropDownOptions(), e._initialDropDownOptionsSet = !0), null !== e._dropDownParent && (e.$.dropDown.style.width = e.offsetWidth + "px"), e.$radixDisplayButton.addClass("smart-numeric-text-box-pressed-component"), e.$dropDown.removeClass("smart-visibility-hidden"), e.$.dropDown.style.marginTop = null, e.opened = !0, e._positionDetection.positionDropDown();
      var i = 1 === window.devicePixelRatio ? document.documentElement.clientHeight : window.innerHeight,
          a = e.$.dropDown.getBoundingClientRect(),
          n = i - a.top - e.$.dropDown.offsetHeight - parseFloat(getComputedStyle(e.$.dropDown).marginBottom);
      0 > n && (e.$.dropDown.style.marginTop = n + "px"), e.$.fireEvent("open", {
        dropDown: e.$.dropDown
      }), e.$.radixDisplayButton.setAttribute("aria-expanded", !0);
    }
  }, {
    key: "_closeRadix",
    value: function _closeRadix(e) {
      var t = this,
          i = t.$.fireEvent("closing");
      return i.defaultPrevented && !e ? void (t.opened = !0) : void (t.$radixDisplayButton.removeClass("smart-numeric-text-box-pressed-component"), t.$dropDown.addClass("smart-visibility-hidden"), t.opened = !1, t.$.fireEvent("close", {
        dropDown: t.$.dropDown
      }), t.$.radixDisplayButton.setAttribute("aria-expanded", !1));
    }
  }, {
    key: "_isLeftButtonPressed",
    value: function _isLeftButtonPressed(e) {
      var t = 0 === e.buttons || 1 === e.which;
      return 1 === e.detail.buttons || t;
    }
  }, {
    key: "_isIncrementOrDecrementAllowed",
    value: function _isIncrementOrDecrementAllowed() {
      var e = this;
      return !e.disabled && !e.readonly && !1 === e._regexSpecial.nonNumericValue.test(e.$.input.value);
    }
  }, {
    key: "_upButtonClickHandler",
    value: function _upButtonClickHandler(e) {
      var t = this,
          i = t._isLeftButtonPressed(e);

      i && t._isIncrementOrDecrementAllowed() && (!t._up && t.$upButton.addClass("smart-numeric-text-box-pressed-component"), t._incrementOrDecrement("add"));
    }
  }, {
    key: "_downButtonClickHandler",
    value: function _downButtonClickHandler(e) {
      var t = this,
          i = t._isLeftButtonPressed(e);

      i && t._isIncrementOrDecrementAllowed() && (!t._up && t.$downButton.addClass("smart-numeric-text-box-pressed-component"), t._incrementOrDecrement("subtract"));
    }
  }, {
    key: "_documentMousedownHandler",
    value: function _documentMousedownHandler(e) {
      var t = this;
      if (t._up = !1, !t.opened) return;
      var i = e.originalEvent.target;
      (t.shadowRoot || t.isInShadowDOM) && (i = e.originalEvent.composedPath()[0]), (t.shadowRoot || t).contains(i) || t.$.dropDown.contains(i) || t._closeRadix();
    }
  }, {
    key: "_documentMouseupHandler",
    value: function _documentMouseupHandler() {
      var e = this;
      e._up = !0, e.$upButton.removeClass("smart-numeric-text-box-pressed-component"), e.$downButton.removeClass("smart-numeric-text-box-pressed-component");
    }
  }, {
    key: "_radixDisplayButtonClickHandler",
    value: function _radixDisplayButtonClickHandler() {
      var e = this;
      e.dropDownEnabled && !e.disabled && null !== e.value && (e.opened ? e._closeRadix() : e._openRadix());
    }
  }, {
    key: "_dropDownItemClickHandler",
    value: function _dropDownItemClickHandler(e) {
      if (e.target.$.hasClass("smart-list-item")) {
        var _t909 = this;

        var _i901 = e.target.getAttribute("data-value");

        _t909._changeRadix(parseInt(_i901, 10)), _t909._closeRadix();
      }
    }
  }, {
    key: "_mouseenterMouseleaveHandler",
    value: function _mouseenterMouseleaveHandler(e) {
      var t = this;
      e.target === t.$.dropDown || t.disabled || t.readonly || ("mouseenter" === e.type ? e.target.setAttribute("hover", "") : e.target.removeAttribute("hover"));
    }
  }, {
    key: "_inputKeydownHandler",
    value: function _inputKeydownHandler(e) {
      var t = this,
          i = e.charCode ? e.charCode : e.which;
      40 === i && t._isIncrementOrDecrementAllowed() ? t._incrementOrDecrement("subtract") : 38 === i && t._isIncrementOrDecrementAllowed() && t._incrementOrDecrement("add"), t._keydownInfo = {
        value: t.$.input.value,
        specialKey: e.altKey || e.ctrlKey || e.shiftKey
      };
    }
  }, {
    key: "_inputKeyupHandler",
    value: function _inputKeyupHandler(e) {
      var t = this;
      if (13 === e.keyCode) t._suppressBlurEvent = !0, t.$.input.value !== t._cachedInputValue && (t._triggerChangeEvent = !0, t._validate(), t._triggerChangeEvent = !1, t.$.input.blur());else if (27 === e.keyCode) t.$.input.value = t._editableValue;else {
        var _i902 = t.$.input.value;
        "" !== _i902 && t._regex[t._radixNumber].test(_i902) ? (t.$.upButton.disabled = !1, t.$.downButton.disabled = !1) : "" === _i902 && (t.$.upButton.disabled = !0, t.$.downButton.disabled = !0), !t._keydownInfo || t._keydownInfo.value === _i902 || t._keydownInfo.specialKey || e.altKey || e.ctrlKey || e.shiftKey || "Control" === e.key || t.$.fireEvent("changing", {
          currentValue: _i902,
          validValue: t.value,
          radix: t._radixNumber
        });
      }
      e.preventDefault();
    }
  }, {
    key: "_inputBlurHandler",
    value: function _inputBlurHandler() {
      var e = this;
      !0 === e._suppressBlurEvent ? (e._suppressBlurEvent = !1, e._formattedValue && (e._cachedInputValue = e._formattedValue, e.$.input.value = e._formattedValue, delete e._formattedValue)) : e.$.input.value === e._editableValue ? e.$.input.value = e._cachedInputValue : (e._triggerChangeEvent = !0, e._validate(), e._triggerChangeEvent = !1), e.radixDisplay && e.$.radixDisplayButton.removeAttribute("focus"), e.opened && e._closeRadix(), e.spinButtons && e.$.spinButtonsContainer.removeAttribute("focus"), e.showUnit && e.$.unitDisplay.removeAttribute("focus"), e.removeAttribute("focus");
    }
  }, {
    key: "_inputFocusHandler",
    value: function _inputFocusHandler() {
      var e = this;
      e.spinButtons && e.$.spinButtonsContainer.setAttribute("focus", ""), e.radixDisplay && e.$.radixDisplayButton.setAttribute("focus", ""), e.showUnit && e.$.unitDisplay.setAttribute("focus", ""), e.opened && e._closeRadix(), e.setAttribute("focus", ""), e.outputFormatString && (e.$.input.value = e._editableValue);
    }
  }, {
    key: "_inputChangeHandler",
    value: function _inputChangeHandler(e) {
      e.stopPropagation(), e.preventDefault();
    }
  }, {
    key: "_inputPasteHandler",
    value: function _inputPasteHandler() {
      var e = this;
      requestAnimationFrame(function () {
        return e.$.fireEvent("changing", {
          currentValue: e.$.input.value,
          validValue: e.value,
          radix: e._radixNumber
        });
      });
    }
  }, {
    key: "_inputWheelHandler",
    value: function _inputWheelHandler(e) {
      var t = this,
          i = t.shadowRoot ? t.shadowRoot.activeElement || document.activeElement : document.activeElement;
      t.$.input === i && t.enableMouseWheelAction && t._isIncrementOrDecrementAllowed() && (e.stopPropagation(), e.preventDefault(), 0 < e.wheelDelta ? t._incrementOrDecrement("add") : t._incrementOrDecrement("subtract"));
    }
  }, {
    key: "_getRadix",
    value: function _getRadix(e) {
      switch (e.toString()) {
        case "10":
        case "decimal":
          return 10;

        case "2":
        case "binary":
          return 2;

        case "8":
        case "octal":
          return 8;

        case "16":
        case "hexadecimal":
          return 16;
      }
    }
  }, {
    key: "_setDropDownOptions",
    value: function _setDropDownOptions() {
      var e = this;

      if (!1 !== e.dropDownEnabled && null !== e._number) {
        var _t910 = e._wordLengthNumber,
            _i903 = e.leadingZeros;
        e.$.dropDownItem2.innerHTML = "".concat(e._number.toString(2, _t910, _i903), " (").concat(e.localize("binary"), ")"), e.$.dropDownItem8.innerHTML = "".concat(e._number.toString(8, _t910), " (").concat(e.localize("octal"), ")"), e.$.dropDownItem10.innerHTML = "".concat(e._renderValue(e._number.toString(10, _t910), !0), " (").concat(e.localize("decimal"), ")"), e.$.dropDownItem16.innerHTML = "".concat(e._number.toString(16, _t910, _i903), " (").concat(e.localize("hexadecimal"), ")");
      }
    }
  }, {
    key: "_incrementOrDecrement",
    value: function _incrementOrDecrement(e) {
      var t = this,
          i = t.shadowRoot ? t.shadowRoot.activeElement || document.activeElement : document.activeElement;
      var a = t._cachedInputValue;

      if (t.$.input === i && (a = t._editableValue, t._suppressBlurEvent = !0), !((t.$.input.value !== a || t._programmaticValueIsSet && "interaction" === t.validation) && (t._triggerChangeEvent = !0, t._validate(), t._triggerChangeEvent = !1, !1 === t._isIncrementOrDecrementAllowed()))) {
        var _i904 = t._numericProcessor.incrementDecrement(t._number, e, t._spinButtonsStepObject),
            _a592 = t._validateRange(_i904);

        t._triggerChangeEvent = !0, t._updateValue(_a592), t._triggerChangeEvent = !1;
      }
    }
  }, {
    key: "_toBigNumberDecimal",
    value: function _toBigNumberDecimal(e, t) {
      var i = this;
      var a;
      return 10 === t ? a = new Smart.Utilities.BigNumber(e) : i._unsigned || !1 === i._isNegative(e, t) ? 64 > i._wordLengthNumber ? (a = parseInt(e, t), a = new Smart.Utilities.BigNumber(a)) : a = i._getBigNumberFrom64BitBinOctHex(e, t) : (a = i._getNegativeDecimal(e, t), a = new Smart.Utilities.BigNumber(a)), a;
    }
  }, {
    key: "_isNegative",
    value: function _isNegative(e, t) {
      var i = this,
          a = e.length,
          n = e.charAt(0).toLowerCase();
      if (2 === t) return a === i._wordLengthNumber && "1" === n;
      if (8 === t) switch (i._wordLengthNumber) {
        case 8:
          return 3 === a && ("2" === n || "3" === n);

        case 16:
          return 5 === a && "1" === n;

        case 32:
          return 11 === a && ("2" === n || "3" === n);

        case 64:
          return 22 === a && "1" === n;
      } else return a === i._wordLengthNumber / 4 && -1 !== ["8", "9", "a", "b", "c", "d", "e", "f"].indexOf(n);
    }
  }, {
    key: "_getBigNumberFrom64BitBinOctHex",
    value: function _getBigNumberFrom64BitBinOctHex(e, t) {
      var a = new Smart.Utilities.BigNumber(0);

      for (var _n446 = e.length - 1, _i905; 0 <= _n446; _n446--) {
        _i905 = new Smart.Utilities.BigNumber(parseInt(e.charAt(_n446), t)), a = a.add(_i905.multiply(new Smart.Utilities.BigNumber(t).pow(e.length - 1 - _n446)));
      }

      return a;
    }
  }, {
    key: "_getNegativeDecimal",
    value: function _getNegativeDecimal(e, t) {
      var i = this;
      var a = e;

      if (8 === t) {
        var _t911 = [];

        for (var _a593 = 0, _i906; _a593 < e.length; _a593++) {
          for (_i906 = parseInt(e.charAt(_a593), 8).toString(2); 3 !== _i906.length;) {
            _i906 = "0".concat(_i906);
          }

          _t911.push(_i906);
        }

        for (a = _t911.join(""); "0" === a.charAt(0);) {
          a = a.slice(1);
        }
      } else if (16 === t) {
        var _t912 = [];

        for (var _i907 = 0, _a594; _i907 < e.length; _i907++) {
          for (_a594 = parseInt(e.charAt(_i907), 16).toString(2); 4 !== _a594.length;) {
            _a594 = "0".concat(_a594);
          }

          _t912.push(_a594);
        }

        a = _t912.join("");
      }

      var n = a.replace(/0/g, "a");
      return n = n.replace(/1/g, "b"), n = n.replace(/a/g, "1"), n = n.replace(/b/g, "0"), 64 > this._wordLengthNumber ? n = -1 * (parseInt(n, 2) + 1) : (n = i._getBigNumberFrom64BitBinOctHex(n, t), n = n.add(1).negate()), n;
    }
  }, {
    key: "_discardDecimalSeparator",
    value: function _discardDecimalSeparator(e, t) {
      var i = this;

      if (void 0 === t && (t = i.decimalSeparator), "." !== t && e !== 1 / 0 && e !== -Infinity) {
        var _i908 = new RegExp(t, "g");

        return e.replace(_i908, ".");
      }

      return e;
    }
  }, {
    key: "_applyDecimalSeparator",
    value: function _applyDecimalSeparator(e) {
      var t = this;
      return "string" != typeof e && (e = e.toString()), "." !== t.decimalSeparator && (e = e.replace(/\./g, t.decimalSeparator)), e;
    }
  }, {
    key: "_renderValue",
    value: function _renderValue(e, t) {
      var i = this,
          a = e,
          n = 10 === i._radixNumber || !0 === t;

      if (e = i._numericProcessor.render(e, n), "." !== i.decimalSeparator && n && (e = i._applyDecimalSeparator(e)), !0 !== t && (i._editableValue = e, i.outputFormatString && 10 === i._radixNumber)) {
        var _e1082 = (i.shadowRoot || i.getRootNode()).activeElement || document.activeElement,
            _t913 = i._numberRenderer.formatNumber(a, i.outputFormatString);

        if (_e1082 !== i.$.input) return _t913;
        i._formattedValue = _t913;
      }

      return e;
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void (e.$.input.tabIndex = -1) : void e.$.input.removeAttribute("tabindex");
    }
  }, {
    key: "_disableComponents",
    value: function _disableComponents() {
      var e = this;

      if (!e.disabled) {
        var _t914 = e.value;
        null === _t914 || "NaN" === _t914.toString() || Math.abs(_t914) === 1 / 0 ? (e.$.upButton.disabled = !0, e.$.downButton.disabled = !0) : (e.$.upButton.disabled = !1, e.$.downButton.disabled = !1);
      }
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      e.opened && e._closeRadix(!0);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        decimalSeparator: {
          value: ".",
          type: "string"
        },
        dropDownAppendTo: {
          value: null,
          type: "any"
        },
        enableMouseWheelAction: {
          value: !1,
          type: "boolean"
        },
        inputFormat: {
          value: "integer",
          allowedValues: ["integer", "floatingPoint", "complex"],
          type: "string"
        },
        hint: {
          value: "",
          type: "string"
        },
        label: {
          value: "",
          type: "string"
        },
        leadingZeros: {
          value: !1,
          type: "boolean"
        },
        max: {
          value: null,
          type: "any"
        },
        messages: {
          value: {
            en: {
              binary: "BIN",
              octal: "OCT",
              decimal: "DEC",
              hexadecimal: "HEX",
              integerOnly: "smartNumericTextBox: The property {{property}} can only be set when inputFormat is integer.",
              noInteger: "smartNumericTextBox: the property {{property}} cannot be set when inputFormat is integer.",
              significantPrecisionDigits: "smartNumericTextBox: the properties significantDigits and precisionDigits cannot be set at the same time."
            }
          },
          type: "object",
          extend: !0
        },
        min: {
          value: null,
          type: "any"
        },
        name: {
          value: "",
          type: "string"
        },
        nullable: {
          value: !1,
          type: "boolean"
        },
        opened: {
          value: !1,
          type: "boolean"
        },
        outputFormatString: {
          value: null,
          type: "string?"
        },
        placeholder: {
          value: "",
          type: "string"
        },
        dropDownEnabled: {
          value: !1,
          type: "boolean"
        },
        precisionDigits: {
          value: null,
          type: "number?"
        },
        radix: {
          value: 10,
          allowedValues: ["2", "8", "10", "16", 2, 8, 10, 16, "binary", "octal", "decimal", "hexadecimal"],
          type: "any"
        },
        radixDisplay: {
          value: !1,
          type: "boolean"
        },
        radixDisplayPosition: {
          value: "left",
          allowedValues: ["left", "right"],
          type: "string"
        },
        scientificNotation: {
          value: !1,
          type: "boolean"
        },
        showUnit: {
          value: !1,
          type: "boolean"
        },
        significantDigits: {
          value: null,
          type: "number?"
        },
        spinButtons: {
          value: !1,
          type: "boolean"
        },
        spinButtonsDelay: {
          value: 75,
          type: "number"
        },
        spinButtonsInitialDelay: {
          value: 0,
          type: "number"
        },
        spinButtonsPosition: {
          value: "right",
          allowedValues: ["left", "right"],
          type: "string"
        },
        spinButtonsStep: {
          value: "1",
          type: "any"
        },
        type: {
          value: "numeric",
          type: "string",
          defaultReflectToAttribute: !0,
          readonly: !0
        },
        unit: {
          value: "kg",
          type: "string"
        },
        validation: {
          value: "strict",
          allowedValues: ["strict", "interaction"],
          type: "string"
        },
        value: {
          value: "0",
          type: "any?"
        },
        wordLength: {
          value: "int32",
          allowedValues: ["int8", "uint8", "int16", "uint16", "int32", "uint32", "int64", "uint64"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        mouseenter: "_mouseenterMouseleaveHandler",
        mouseleave: "_mouseenterMouseleaveHandler",
        resize: "_resizeHandler",
        "downButton.click": "_downButtonClickHandler",
        "downButton.mouseenter": "_mouseenterMouseleaveHandler",
        "downButton.mouseleave": "_mouseenterMouseleaveHandler",
        "dropDown.click": "_dropDownItemClickHandler",
        "dropDown.mouseout": "_mouseenterMouseleaveHandler",
        "dropDown.mouseover": "_mouseenterMouseleaveHandler",
        "input.blur": "_inputBlurHandler",
        "input.change": "_inputChangeHandler",
        "input.focus": "_inputFocusHandler",
        "input.keydown": "_inputKeydownHandler",
        "input.keyup": "_inputKeyupHandler",
        "input.paste": "_inputPasteHandler",
        "input.wheel": "_inputWheelHandler",
        "radixDisplayButton.click": "_radixDisplayButtonClickHandler",
        "radixDisplayButton.mouseenter": "_mouseenterMouseleaveHandler",
        "radixDisplayButton.mouseleave": "_mouseenterMouseleaveHandler",
        "upButton.click": "_upButtonClickHandler",
        "upButton.mouseenter": "_mouseenterMouseleaveHandler",
        "upButton.mouseleave": "_mouseenterMouseleaveHandler",
        "document.down": "_documentMousedownHandler",
        "document.up": "_documentMouseupHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return window.NIComplex ? {
        "Smart.Button": "smart.button.js",
        "Smart.Utilities.BigNumber": "smart.math.js",
        "Smart.Utilities.NumericProcessor": "smart.numeric.js"
      } : {
        "Smart.Button": "smart.button.js",
        "Smart.Utilities.Complex": "smart.complex.js",
        "Smart.Utilities.BigNumber": "smart.math.js",
        "Smart.Utilities.NumericProcessor": "smart.numeric.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.button.css", "smart.numerictextbox.css"];
    }
  }]);

  return _class95;
}(Smart.BaseElement)), Smart("smart-pager",
/*#__PURE__*/
function (_Smart$BaseElement23) {
  "use strict";

  _inherits(_class96, _Smart$BaseElement23);

  function _class96() {
    _classCallCheck(this, _class96);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class96).apply(this, arguments));
  }

  _createClass(_class96, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div id=\"nearButtonsContainer\" class=\"smart-pager-near-buttons-container\" role=\"presentation\">\n                        <div id=\"firstButton\" class=\"smart-first-button smart-pager-button smart-unselectable\" role=\"button\" aria-label=\"First\"></div>\n                        <div id=\"previousButton\" class=\"smart-previous-page-button smart-pager-button smart-unselectable\" role=\"button\" aria-label=\"Previous\"></div>\n                    </div>\n                    <div id=\"middleButtonsContainer\" class=\"smart-pager-middle-buttons-container\" role=\"presentation\">\n                        <span id=\"previousEllipsisButton\" class=\"smart-previous-ellipsis-button smart-pager-page-index-selector\" role=\"button\" aria-label=\"Previous group of pages\"></span>\n                        <div id=\"pageIndexSelectorsContainer\" tabindex=\"0\" class=\"smart-pager-page-index-selectors-container\" role=\"list\"></div>\n                        <span id=\"nextEllipsisButton\" class=\"smart-next-ellipsis-button smart-pager-page-index-selector\" role=\"button\" aria-label=\"Next group of pages\"</span>\n                    </div>\n                    <div id=\"farButtonsContainer\" class=\"smart-pager-far-buttons-container\" role=\"presentation\">\n                        <div id=\"nextButton\" class=\"smart-next-page-button smart-pager-button smart-unselectable\" role=\"button\" aria-label=\"Next\"></div>\n                        <div id=\"lastButton\" class=\"smart-last-button smart-pager-button smart-unselectable\" role=\"button\" aria-label=\"Last\"></div>\n                    </div>\n                    <div id=\"pagerInputAndLabelContainer\" class=\"smart-pager-input-and-label-container\" role=\"presentation\">\n                        <span id=\"navigateToLabel\" class=\"smart-pager-label\"></span>\n                        <input type=\"text\" id=\"navigateToInput\" class=\"smart-pager-input smart-input\" />\n                    </div>\n                    <div id=\"pagerSizeSelectorAndLabelContainer\" class=\"smart-pager-size-selector-and-label-container\">\n                        <span id=\"pageSizeLabel\" class=\"smart-pager-label\"></span>\n                        <smart-drop-down-list id=\"pageSizeSelector\" class=\"smart-page-size-selector\"\n                                data-source=\"[[pageSizeSelectorDataSource]]\"\n                                right-to-left=\"[[rightToLeft]]\"\n                                drop-down-height=\"auto\"\n                                selection-mode=\"one\"\n                                selected-indexes=[0]\n                                disabled=\"[[disabled]]\">\n                        </smart-drop-down-list>\n                    </div>\n                    <span id=\"pagerSummaryContainer\" class=\"smart-pager-summary-container smart-pager-label\"></span>\n                </div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class96.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.$.navigateToLabel.id || (e.$.navigateToLabel.id = e.id + "NavigateToLabel"), e.$.pageSizeLabel.id || (e.$.pageSizeLabel.id = e.id + "PageSizeLabel"), e.$.pagerSummaryContainer.id || (e.$.pagerSummaryContainer.id = e.id + "SummaryContainer"), e.setAttribute("role", "navigation"), e.setAttribute("aria-labelledby", e.$.pagerSummaryContainer.id), e.$.navigateToInput.setAttribute("aria-labelledby", e.$.navigateToLabel.id), e.$.pageSizeSelector.setAttribute("aria-labelledby", e.$.pageSizeLabel.id), e._render(), _get(_getPrototypeOf(_class96.prototype), "render", this).call(this);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var e = this;

      e._render();
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class96.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      switch (e) {
        case "navigationButtonsPosition":
          return void a._renderButtons();

        case "navigationInputPosition":
        case "pageSizeSelectorPosition":
        case "summaryPosition":
          return void a._renderSettings();
      }

      a._render();
    }
  }, {
    key: "next",
    value: function next() {
      var e = this;
      e.navigateTo(e.pageIndex + 1);
    }
  }, {
    key: "prev",
    value: function prev() {
      var e = this;
      e.navigateTo(e.pageIndex - 1);
    }
  }, {
    key: "beginUpdate",
    value: function beginUpdate() {
      var e = this;
      e._updating = !0;
    }
  }, {
    key: "endUpdate",
    value: function endUpdate() {
      var e = this;
      e._updating = !1, e._render();
    }
  }, {
    key: "_render",
    value: function _render() {
      var e = this;

      if (!e._updating && (e.$.navigateToInput.value = (1 + e.pageIndex).toString(), e._renderButtons(), e._renderPageIndexSelectors(), e._renderSettings(), e._renderVisibility(), e._localize(), e.$.pageSizeSelector && e.showPageSizeSelector)) {
        var _t915 = e.pageSizeSelectorDataSource.indexOf(e.pageSize);

        0 <= _t915 && (e.$.pageSizeSelector.selectedIndexes = [_t915]);
      }
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;

      e._renderVisibility();
    }
  }, {
    key: "_renderVisibility",
    value: function _renderVisibility() {
      var e = this,
          t = e.offsetWidth - 20;
      e._pageIndexSelectorsVisibleCount = e._pageIndexSelectorsCount, e.showSummary ? e.$pagerSummaryContainer.removeClass("smart-hidden") : e.$pagerSummaryContainer.addClass("smart-hidden"), e.showPageIndexSelectors ? e.$middleButtonsContainer.removeClass("smart-hidden") : e.$middleButtonsContainer.addClass("smart-hidden"), e.showNavigationInput ? (e.$navigateToLabel.removeClass("smart-hidden"), e.$navigateToInput.removeClass("smart-hidden")) : (e.$navigateToLabel.addClass("smart-hidden"), e.$navigateToInput.addClass("smart-hidden")), e.showPageSizeSelector ? (e.$pageSizeLabel.removeClass("smart-hidden"), e.$pageSizeSelector.removeClass("smart-hidden")) : (e.$pageSizeLabel.addClass("smart-hidden"), e.$pageSizeSelector.addClass("smart-hidden")), e.showFirstLastNavigationButtons ? (e.$firstButton.removeClass("smart-hidden"), e.$lastButton.removeClass("smart-hidden")) : (e.$firstButton.addClass("smart-hidden"), e.$lastButton.addClass("smart-hidden")), e.showPrevNextNavigationButtons ? (e.$previousButton.removeClass("smart-hidden"), e.$nextButton.removeClass("smart-hidden")) : (e.$previousButton.addClass("smart-hidden"), e.$nextButton.addClass("smart-hidden")), e.$previousEllipsisButton.addClass("smart-hidden"), e.$nextEllipsisButton.addClass("smart-hidden"), "after" !== e.autoEllipsis && "none" !== e.autoEllipsis && e.pageIndex >= e._pageIndexSelectorsCount && e.$previousEllipsisButton.removeClass("smart-hidden"), "before" !== e.autoEllipsis && "none" !== e.autoEllipsis && e.pageIndex < e.pagesCount - e._pageIndexSelectorsCount && e.$nextEllipsisButton.removeClass("smart-hidden");

      for (var _t916 = 0; _t916 < e._pageIndexSelectorsCount && !!e.$.pageIndexSelectorsContainer.children[_t916]; _t916++) {
        e.$.pageIndexSelectorsContainer.children[_t916].classList.remove("smart-hidden");
      }

      var i = e.$.pagerSummaryContainer.offsetWidth ? Math.max(100, e.$.pagerSummaryContainer.offsetWidth) : 0;
      var a = e.$.nearButtonsContainer.offsetWidth + e.$.middleButtonsContainer.offsetWidth + e.$.farButtonsContainer.offsetWidth + i + e.$.pagerInputAndLabelContainer.offsetWidth + e.$.pagerSizeSelectorAndLabelContainer.offsetWidth;

      if (0 < a && a > t && (a -= e.$.pagerSummaryContainer.offsetWidth, e.$pagerSummaryContainer.addClass("smart-hidden"), a > t && (a -= e.$.navigateToLabel.offsetWidth, a -= e.$.navigateToInput.offsetWidth, e.$navigateToLabel.addClass("smart-hidden"), e.$navigateToInput.addClass("smart-hidden"), a > t))) {
        if (a -= e.$.pageSizeLabel.offsetWidth, a -= e.$.pageSizeSelector.offsetWidth, e.$pageSizeLabel.addClass("smart-hidden"), e.$pageSizeSelector.addClass("smart-hidden"), a > t) {
          e.$previousEllipsisButton.addClass("smart-hidden"), e.$nextEllipsisButton.addClass("smart-hidden"), a -= e.$.previousEllipsisButton.offsetWidth, a -= e.$.nextEllipsisButton.offsetWidth;

          for (var _n447 = e._pageIndexSelectorsCount - 1; 0 <= _n447; _n447--) {
            var _i909 = e.$.pageIndexSelectorsContainer.children[_n447];
            if (a < t || !_i909) break;
            (e._pageIndexSelectorsVisibleCount--, a -= _i909.offsetWidth, !_i909.hasAttribute("selected")) && _i909.classList.add("smart-hidden");
          }
        }

        a > t && e.showFirstLastNavigationButtons && (e.$firstButton.addClass("smart-hidden"), e.$lastButton.addClass("smart-hidden"));
      }
    }
  }, {
    key: "_renderSettings",
    value: function _renderSettings() {
      var e = this,
          t = e.pageIndex * e.pageSize,
          i = (e.pageIndex + 1) * e.pageSize,
          a = e.pagesCount * e.pageSize;
      e.$pagerSummaryContainer.removeClass("near"), e.$pagerSizeSelectorAndLabelContainer.removeClass("near"), e.$pagerInputAndLabelContainer.removeClass("near"), "near" === e.summaryPosition && e.$pagerSummaryContainer.addClass("near"), "near" === e.pageSizeSelectorPosition && e.$pagerSizeSelectorAndLabelContainer.addClass("near"), "near" === e.navigationInputPosition && e.$pagerInputAndLabelContainer.addClass("near"), e.$.pagerSummaryContainer.innerHTML = "<span class=\"smart-summary-start\" role=\"presentation\">" + (1 + t) + "</span> <span class=\"smart-summary-hyphen\" role=\"presentation\">-</span> <span class=\"smart-summary-end\" role=\"presentation\">" + i + "</span><span class=\"smart-summary-prefix\" role=\"presentation\">" + e.localize("summaryPrefix") + "</span> <span class=\"smart-summary-total-end\" role=\"presentation\">" + a + "</span> <span class=\"smart-summary-suffix\" role=\"presentation\">" + e.localize("summarySuffix") + "</span>";
    }
  }, {
    key: "_renderPageIndexSelectors",
    value: function _renderPageIndexSelectors() {
      var e = this;
      if (0 > e.pageIndex || e.pageIndex >= e.pagesCount) return void (e.$.pageIndexSelectorsContainer.innerHTML = "");
      e.$.pageIndexSelectorsContainer.innerHTML = "";
      var t = !1;
      Array.isArray(e.pageIndexSelectors) && (t = !0);

      var a = Math.floor(e.pageIndex / e._pageIndexSelectorsCount) * e._pageIndexSelectorsCount,
          n = Math.min(e.pagesCount, a + e._pageIndexSelectorsCount),
          o = 0;

      for (var _r202 = a; _r202 < n; _r202++) {
        var _i910 = document.createElement("span");

        var _a595 = _r202 + 1;

        if (_i910.className = "smart-pager-page-index-selector", t) {
          var _t917 = e.pageIndexSelectors[o++];
          _t917 && (_t917.label ? _a595 = e.pageIndexSelectors[_r202].label : "string" == typeof _t917 && (_a595 = _t917), _t917.value && _i910.setAttribute("value", e.pageIndexSelectors[_r202].value));
        }

        _i910.index = _r202, _i910.innerHTML = _a595, _i910.setAttribute("role", "listitem"), e.$.pageIndexSelectorsContainer.appendChild(_i910), _r202 === e.pageIndex && (_i910.classList.add("smart-selected"), _i910.setAttribute("selected", ""), _i910.setAttribute("aria-current", "page"));
      }
    }
  }, {
    key: "_lastButtonClickHandler",
    value: function _lastButtonClickHandler() {
      var e = this;
      e.last();
    }
  }, {
    key: "last",
    value: function last() {
      var e = this;
      e.navigateTo(e.pagesCount - 1);
    }
  }, {
    key: "_firstButtonClickHandler",
    value: function _firstButtonClickHandler() {
      var e = this;
      e.first();
    }
  }, {
    key: "first",
    value: function first() {
      var e = this;
      e.navigateTo(0);
    }
  }, {
    key: "_renderButtons",
    value: function _renderButtons() {
      var e = this;

      switch (0 === e.pageIndex ? (e.$.firstButton.setAttribute("disabled", ""), e.$.previousButton.setAttribute("disabled", "")) : (e.$.firstButton.removeAttribute("disabled"), e.$.previousButton.removeAttribute("disabled")), e.pageIndex === e.pagesCount - 1 ? (e.$.nextButton.setAttribute("disabled", ""), e.$.lastButton.setAttribute("disabled", "")) : (e.$.nextButton.removeAttribute("disabled"), e.$.lastButton.removeAttribute("disabled")), 0 >= e.pagesCount && (e.$.firstButton.setAttribute("disabled", ""), e.$.previousButton.setAttribute("disabled", ""), e.$.nextButton.setAttribute("disabled", ""), e.$.lastButton.setAttribute("disabled", "")), e.$nearButtonsContainer.removeClass("far"), e.$farButtonsContainer.removeClass("far"), e.$nearButtonsContainer.removeClass("near"), e.$farButtonsContainer.removeClass("near"), e.navigationButtonsPosition) {
        case "near":
          e.$nearButtonsContainer.addClass("near"), e.$farButtonsContainer.addClass("near");
          break;

        case "far":
          e.$nearButtonsContainer.addClass("far"), e.$farButtonsContainer.addClass("far");
          break;

        case "both":
          e.$nearButtonsContainer.addClass("near"), e.$farButtonsContainer.addClass("far");
      }
    }
  }, {
    key: "_navigateToInputChangeHandler",
    value: function _navigateToInputChangeHandler() {
      var e = this;
      var t = parseInt(e.$.navigateToInput.value) - 1;
      isNaN(t) && (e.$.navigateToInput.value = "1", t = parseInt(e.$.navigateToInput.value - 1)), e.navigateTo(t);
    }
  }, {
    key: "_pageIndexSelectorsContainerClickHandler",
    value: function _pageIndexSelectorsContainerClickHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.composedPath()[0].closest(".smart-pager-page-index-selector") : e.target.closest(".smart-pager-page-index-selector");
      !i || i.classList.contains("smart-selected") || t.navigateTo(i.index);
    }
  }, {
    key: "_pageSizeSelectorChangeHandler",
    value: function _pageSizeSelectorChangeHandler(e) {
      var t = this;
      !t.showPageSizeSelector || t.disabled || t._updating || (t.pageSize = parseInt(e.detail.value), t.$.fireEvent("pageSizeChanged", {
        value: parseInt(e.detail.value)
      }));
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this;
      if (!t.disabled && (t.enableShadowDOM ? t.shadowRoot.activeElement || document.activeElement : document.activeElement) !== t.$.navigateToInput && null === t.$.pageSizeSelector.getAttribute("focus")) switch (e.key) {
        case "End":
          t.last(), e.preventDefault();
          break;

        case "Home":
          t.first(), e.preventDefault();
          break;

        case "PageDown":
        case "ArrowDown":
        case "ArrowLeft":
          t.prev(), e.preventDefault();
          break;

        case "PageUp":
        case "ArrowUp":
        case "ArrowRight":
          t.next(), e.preventDefault();
      }
    }
  }, {
    key: "_nextButtonClickHandler",
    value: function _nextButtonClickHandler() {
      var e = this;
      e.next();
    }
  }, {
    key: "_previousButtonClickHandler",
    value: function _previousButtonClickHandler() {
      var e = this;
      e.prev();
    }
  }, {
    key: "navigateTo",
    value: function navigateTo(e) {
      var t = this,
          i = t.pageIndex;
      t.disabled || t.pageIndex === e || 0 > e || e >= t.pagesCount || (t.pageIndex = e, t._render(), t.$.fireEvent("change", {
        oldIndex: i,
        index: e
      }));
    }
  }, {
    key: "_localize",
    value: function _localize() {
      var e = this,
          t = ["firstButton", "lastButton", "previousButton", "nextButton"];

      for (var _a596 = 0; _a596 < t.length; _a596++) {
        var _i911 = e.$[t[_a596]];
        !e.showNavigationButtonLabels && 2 > _a596 ? (_i911.innerHTML = "", 0 == _a596 ? _i911.classList.add("smart-arrow-left-first") : _i911.classList.add("smart-arrow-right-last")) : !e.showNavigationButtonLabels && 2 <= _a596 ? (_i911.innerHTML = "", 2 == _a596 ? _i911.classList.add("smart-arrow-left") : _i911.classList.add("smart-arrow-right")) : (_i911.classList.remove("smart-arrow-left"), _i911.classList.remove("smart-arrow-right"), _i911.classList.remove("smart-arrow-left-first"), _i911.classList.remove("smart-arrow-right-last"), _i911.innerHTML = e.localize(t[_a596]));
      }

      e.$.pageSizeLabel.innerHTML = e.localize("pageSizeLabel"), e.$.navigateToLabel.innerHTML = e.localize("navigateToLabel"), e.$.previousEllipsisButton.innerHTML = e.localize("ellipsis"), e.$.nextEllipsisButton.innerHTML = e.localize("ellipsis"), e.$.navigateToInput.placeholder = e.localize("navigateToInputPlaceholder");
    }
  }, {
    key: "_nextEllipsisButtonClickHandler",
    value: function _nextEllipsisButtonClickHandler() {
      var e = this;
      e.navigateTo(e._pageIndexSelectorsCount + e.pageIndex);
    }
  }, {
    key: "_previousEllipsisButtonClickHandler",
    value: function _previousEllipsisButtonClickHandler() {
      var e = this;
      e.navigateTo(-e._pageIndexSelectorsCount + e.pageIndex);
    }
  }, {
    key: "_navigationButtonsClickHandler",
    value: function _navigationButtonsClickHandler(e) {
      var t = this;

      if (!t.disabled) {
        var _i912 = t.enableShadowDOM ? e.composedPath()[0].closest(".smart-pager-button") : e.target.closest(".smart-pager-button");

        _i912 === t.$.firstButton ? t._firstButtonClickHandler(e) : _i912 === t.$.lastButton ? t._lastButtonClickHandler(e) : _i912 === t.$.previousButton ? t._previousButtonClickHandler(e) : _i912 === t.$.nextButton ? t._nextButtonClickHandler(e) : void 0;
      }
    }
  }, {
    key: "_navigationButtonsDownHandler",
    value: function _navigationButtonsDownHandler(e) {
      var t = this,
          i = t.enableShadowDOM ? e.originalEvent.composedPath()[0].closest(".smart-pager-button") || e.originalEvent.composedPath()[0].closest(".smart-pager-page-index-selector") : e.originalEvent.target.closest(".smart-pager-button") || e.originalEvent.target.closest(".smart-pager-page-index-selector");
      t.disabled || !i || (t.hasRippleAnimation && Smart.Utilities.Animation.Ripple.animate(i, e.pageX, e.pageY), (i === t.$.previousButton || i === t.$.nextButton) && t._startRepeat(e, i));
    }
  }, {
    key: "_updateInBoundsFlag",
    value: function _updateInBoundsFlag(e) {
      var t = this,
          i = t.enableShadowDOM ? e.composedPath()[0] : e.target;
      i._isPointerInBounds = !0, "mouseleave" === e.type && (i._isPointerInBounds = !1);
      var a = "buttons" in e ? e.buttons : e.which;
      1 !== a && t._stopRepeat(e);
    }
  }, {
    key: "_startRepeat",
    value: function _startRepeat(e, t) {
      var i = this;
      i._initialTimer || (i._initialTimer = setTimeout(function () {
        i._repeatTimer = setInterval(function () {
          t._isPointerInBounds && (t === i.$.previousButton ? i._previousButtonClickHandler(e) : i._nextButtonClickHandler(e));
        }, 50);
      }, 150));
    }
  }, {
    key: "_stopRepeat",
    value: function _stopRepeat() {
      var e = this;
      e._repeatTimer && (clearInterval(e._repeatTimer), e._repeatTimer = null), e._initialTimer && (clearTimeout(e._initialTimer), e._initialTimer = null);
    }
  }, {
    key: "_pageIndexSelectorsCount",
    get: function get() {
      var e = this;
      var t = parseInt(e.pageIndexSelectors);
      return Array.isArray(e.pageIndexSelectors) && (t = e.pageIndexSelectors.length), t;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoEllipsis: {
          value: "none",
          type: "string",
          allowedValues: ["none", "before", "after", "both"]
        },
        messages: {
          value: {
            en: {
              firstButton: "First",
              lastButton: "Last",
              previousButton: "Previous",
              nextButton: "Next",
              navigateToLabel: "Go to:",
              pageSizeLabel: "Show:",
              navigateToInputPlaceholder: "",
              ellipsis: "...",
              summaryString: "of",
              summaryPrefix: "of",
              summarySuffix: ""
            }
          },
          type: "object",
          extend: !0
        },
        navigationButtonsPosition: {
          value: "both",
          allowedValues: ["near", "far", "both"],
          type: "string"
        },
        navigationInputPosition: {
          value: "far",
          allowedValues: ["near", "far"],
          type: "string"
        },
        pageIndex: {
          value: 0,
          type: "number"
        },
        pageIndexSelectors: {
          value: 0,
          type: "any"
        },
        pagesCount: {
          value: 100,
          type: "number"
        },
        pageSize: {
          value: 10,
          type: "number"
        },
        pageSizeSelectorPosition: {
          value: "far",
          allowedValues: ["near", "far"],
          type: "string"
        },
        pageSizeSelectorDataSource: {
          value: [10, 25, 50],
          type: "array"
        },
        showPrevNextNavigationButtons: {
          value: !1,
          type: "boolean"
        },
        showFirstLastNavigationButtons: {
          value: !1,
          type: "boolean"
        },
        showNavigationButtonLabels: {
          value: !1,
          type: "boolean"
        },
        showNavigationInput: {
          value: !1,
          type: "boolean"
        },
        showSummary: {
          value: !1,
          type: "boolean"
        },
        showPageSizeSelector: {
          value: !1,
          type: "boolean"
        },
        showPageIndexSelectors: {
          value: !1,
          type: "boolean"
        },
        summaryPosition: {
          value: "far",
          allowedValues: ["near", "far"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        click: "_navigationButtonsClickHandler",
        "nextEllipsisButton.click": "_nextEllipsisButtonClickHandler",
        "previousEllipsisButton.click": "_previousEllipsisButtonClickHandler",
        down: "_navigationButtonsDownHandler",
        "navigateToInput.change": "_navigateToInputChangeHandler",
        "nextButton.mouseenter": "_updateInBoundsFlag",
        "nextButton.mouseleave": "_updateInBoundsFlag",
        "pageIndexSelectorsContainer.click": "_pageIndexSelectorsContainerClickHandler",
        "pageSizeSelector.change": "_pageSizeSelectorChangeHandler",
        "previousButton.mouseenter": "_updateInBoundsFlag",
        "previousButton.mouseleave": "_updateInBoundsFlag",
        keydown: "_keyDownHandler",
        resize: "_resizeHandler",
        "document.up": "_stopRepeat"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.DropDownList": "smart.dropdownlist.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.dropdown.css", "smart.dropdownlist.css", "smart.pager.css"];
    }
  }]);

  return _class96;
}(Smart.BaseElement)), Smart("smart-base-progress-bar",
/*#__PURE__*/
function (_Smart$BaseElement24) {
  "use strict";

  _inherits(_class97, _Smart$BaseElement24);

  function _class97() {
    _classCallCheck(this, _class97);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class97).apply(this, arguments));
  }

  _createClass(_class97, [{
    key: "render",
    value: function render() {
      var e = this;
      e.$.label.id || (e.$.label.id = e.id + "Label"), e.setAttribute("role", "progressbar"), e.setAttribute("aria-labelledby", e.$.label.id), e.setAttribute("aria-valuemin", e.min), e.setAttribute("aria-valuemax", e.max), null === e.value || e.indeterminate || (e.$.value.style.transition = "none"), e._updateProgress(), requestAnimationFrame(function () {
        return e.$.value.style.transition = "";
      }), _get(_getPrototypeOf(_class97.prototype), "render", this).call(this);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class97.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      a._updateProgress(), "value" === e ? a.$.fireEvent("change", {
        value: i,
        oldValue: t,
        changeType: "api"
      }) : ("min" == e || "max" == e) && a.setAttribute("aria-value" + e, i);
    }
  }, {
    key: "_updateProgress",
    value: function _updateProgress() {
      var e = this,
          t = e.value;
      null === t || e.indeterminate ? e.removeAttribute("aria-valuenow") : e.setAttribute("aria-valuenow", t);
    }
  }, {
    key: "_percentageValue",
    get: function get() {
      var e = Math.min,
          t = Math.max;
      var i = this,
          a = t(i.min, i.max),
          n = e(i.min, i.max),
          o = e(a, t(n, i.value));
      return (o - n) / (a - n);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        indeterminate: {
          value: !1,
          type: "boolean"
        },
        inverted: {
          value: !1,
          type: "boolean"
        },
        formatFunction: {
          value: null,
          type: "function"
        },
        max: {
          value: 100,
          type: "number"
        },
        min: {
          value: 0,
          type: "number"
        },
        showProgressValue: {
          value: !1,
          type: "boolean"
        },
        value: {
          value: 0,
          type: "number?"
        }
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.progressbar.css"];
    }
  }]);

  return _class97;
}(Smart.BaseElement)), Smart("smart-circular-progress-bar",
/*#__PURE__*/
function (_Smart$BaseProgressBa) {
  "use strict";

  _inherits(_class98, _Smart$BaseProgressBa);

  function _class98() {
    _classCallCheck(this, _class98);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class98).apply(this, arguments));
  }

  _createClass(_class98, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <svg width=\"100%\" height=\"100%\" viewPort=\"0 0 100 100\" viewBox=\"0 0 100 100\" role=\"presentation\" aria-hidden=\"true\">\n                        <circle id=\"value\" class=\"smart-value-path\" r=\"50\" cx=\"50\" cy=\"50\" transform=\"rotate(270 50 50)\"></circle>\n                        <circle id=\"value\" class=\"smart-value\" r=\"50\" cx=\"50\" cy=\"50\" transform=\"rotate(270 50 50)\"></circle>\n                    </svg>\n                    <div class=\"smart-label-container\" role=\"presentation\">\n                        <content></content>\n                        <span id=\"label\" class=\"smart-label\"></span>\n                    </div>\n                </div>";
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.$.container.style.width = e.$.container.style.height = Math.min(e.offsetWidth, e.offsetHeight) + "px", e.$.hasClass("echo-animation") && (e.value = e.max, e._updateProgress()), _get(_getPrototypeOf(_class98.prototype), "render", this).call(this);
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      e.$.container.style.width = e.$.container.style.height = Math.min(e.offsetWidth, e.offsetHeight) + "px";
    }
  }, {
    key: "_updateProgress",
    value: function _updateProgress() {
      var e = Math.PI;

      _get(_getPrototypeOf(_class98.prototype), "_updateProgress", this).call(this);

      var t = this,
          i = t.indeterminate ? 100 * e : 100 * e - 100 * (t._percentageValue * e),
          a = !!document.documentMode,
          n = !a && !!window.StyleMedia;

      if (t.showProgressValue) {
        var _e1083 = parseInt(100 * t._percentageValue);

        t.$.label.innerHTML = t.formatFunction ? t.formatFunction(_e1083) : _e1083 + "%";
      } else t.$.label.innerHTML = "";

      return a || n ? null === t.value || t.indeterminate ? (t.$.value.style.strokeDashoffset = "", void t.$.value.setAttribute("class", "smart-value smart-value-animation-ms")) : (t.$.value.setAttribute("class", "smart-value"), void (t.$.value.style.strokeDashoffset = t.inverted && !t.rightToLeft || !t.inverted && t.rightToLeft ? -i : i)) : (t.$.value.style.strokeDashoffset = t.inverted && !t.rightToLeft || !t.inverted && t.rightToLeft ? -i : i, null === t.value || t.indeterminate ? void t.$value.addClass("smart-value-animation") : void t.$value.removeClass("smart-value-animation"));
    }
  }], [{
    key: "listeners",
    get: function get() {
      return {
        resize: "_resizeHandler"
      };
    }
  }]);

  return _class98;
}(Smart.BaseProgressBar)), Smart("smart-progress-bar",
/*#__PURE__*/
function (_Smart$BaseProgressBa2) {
  "use strict";

  _inherits(_class99, _Smart$BaseProgressBa2);

  function _class99() {
    _classCallCheck(this, _class99);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class99).apply(this, arguments));
  }

  _createClass(_class99, [{
    key: "template",
    value: function template() {
      return "<div role=\"presentation\">\n                    <div id=\"value\" class=\"smart-value\"></div>\n                    <div id=\"label\" class=\"smart-label\"></div>\n                </div>";
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.setAttribute("aria-orientation", e.orientation), _get(_getPrototypeOf(_class99.prototype), "render", this).call(this);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class99.prototype), "propertyChangedHandler", this).call(this, e, t, i), "orientation" === e && this.setAttribute("aria-orientation", i);
    }
  }, {
    key: "_updateProgress",
    value: function _updateProgress() {
      _get(_getPrototypeOf(_class99.prototype), "_updateProgress", this).call(this);

      var e = this;

      if (e.showProgressValue) {
        var _t918 = parseInt(100 * e._percentageValue);

        e.$.label.innerHTML = e.formatFunction ? e.formatFunction(_t918) : _t918 + "%";
      } else e.$.label.innerHTML = "";

      null === e.value || e.indeterminate ? e.$value.addClass("smart-value-animation") : e.$value.removeClass("smart-value-animation"), e.$.value.style.transform = "horizontal" === e.orientation ? "scaleX(" + e._percentageValue + ")" : "scaleY(" + e._percentageValue + ")";
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        orientation: {
          value: "horizontal",
          allowedValues: ["horizontal", "vertical"],
          type: "string"
        }
      };
    }
  }]);

  return _class99;
}(Smart.BaseProgressBar)), Smart("smart-scroll-bar",
/*#__PURE__*/
function (_Smart$BaseElement25) {
  "use strict";

  _inherits(_class100, _Smart$BaseElement25);

  function _class100() {
    _classCallCheck(this, _class100);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class100).apply(this, arguments));
  }

  _createClass(_class100, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" class=\"smart-container\" role=\"presentation\">\n                    <div id=\"nearButton\" class=\"smart-scroll-button smart-arrow-left\" role=\"presentation\" aria-hidden=\"true\"></div>\n                    <div  id=\"track\" class=\"smart-track\" role=\"presentation\">\n                        <div id=\"thumb\" class=\"smart-thumb\" role=\"presentation\"></div>\n                    </div>\n                    <div id=\"farButton\" class=\"smart-scroll-button smart-arrow-right\" role=\"presentation\" aria-hidden=\"true\"></div>\n            </div>";
    }
  }, {
    key: "_updateInBoundsFlag",
    value: function _updateInBoundsFlag(e) {
      var t = this,
          i = e.target;
      i._isPointerInBounds = !0, "mouseleave" === e.type && (i._isPointerInBounds = !1);
      var a = "buttons" in e ? e.buttons : e.which;
      1 !== a && t._stopRepeat(e);
    }
  }, {
    key: "_startRepeat",
    value: function _startRepeat(e) {
      var t = this;
      if (t.disabled) return;
      var i = e.target;
      i._initialTimer || (i._initialTimer = setTimeout(function () {
        i._repeatTimer = setInterval(function () {
          if (i._isPointerInBounds) {
            var _t919 = "buttons" in e ? e.buttons : e.which;

            i.$.fireEvent("click", {
              buttons: _t919,
              clientX: e.clientX,
              clientY: e.clientY,
              pageX: e.pageX,
              pageY: e.pageY,
              screenX: e.screenX,
              screenY: e.screenY
            });
          }
        }, t.clickRepeatDelay);
      }, 3 * t.clickRepeatDelay));
    }
  }, {
    key: "_stopRepeat",
    value: function _stopRepeat(e) {
      var t = this;

      if (!t.disabled) {
        var _t920 = e.target;
        _t920._repeatTimer && (clearInterval(_t920._repeatTimer), _t920._repeatTimer = null), _t920._initialTimer && (clearTimeout(_t920._initialTimer), _t920._initialTimer = null);
      }
    }
  }, {
    key: "_calculateThumbSize",
    value: function _calculateThumbSize(e) {
      var t = this,
          i = t.max - t.min,
          a = "horizontal" === t.orientation ? 10 < t.$.track.offsetWidth : 10 < t.$.track.offsetHeight;
      var n = 0;
      return 1 <= i && a ? (n = e / (i + e) * e, 0 <= t.$.thumb.className.indexOf("smart-hidden") && t.$thumb.removeClass("smart-hidden")) : t.$thumb.addClass("smart-hidden"), Math.max(10, Math.min(n, e));
    }
  }, {
    key: "_dragStartHandler",
    value: function _dragStartHandler(e) {
      var t = this;
      t.disabled || (t.thumbCapture = !0, t.dragStartX = e.clientX, t.dragStartY = e.clientY, t.dragStartValue = t.value, e.stopPropagation(), e.preventDefault());
    }
  }, {
    key: "_dragHandler",
    value: function _dragHandler(e) {
      var t = this;
      if (!0 !== t.thumbCapture) return;
      t._isThumbDragged = !0;
      var i = (t.max - t.min) / (t.scrollBarSize - t.thumbSize),
          a = "horizontal" === t.orientation ? (e.clientX - t.dragStartX) * i : (e.clientY - t.dragStartY) * i;
      var n = a;
      t.rightToLeft && "horizontal" === t.orientation && (n = -a), t._updateValue(t.dragStartValue + n), e.stopPropagation(), e.preventDefault(), e.originalEvent && (e.originalEvent.stopPropagation(), e.originalEvent.preventDefault());
    }
  }, {
    key: "_dragEndHandler",
    value: function _dragEndHandler(e) {
      var t = this;
      t._trackDownTimer && (clearInterval(t._trackDownTimer), t._trackDownTimer = null);
      t.thumbCapture && (t.thumbCapture = !1, t._isThumbDragged = !1, "switchWhenReleased" === t.mechanicalAction ? t._updateValue(t.dragStartValue, t.value) : "switchUntilReleased" === this.mechanicalAction && t._updateValue(t.dragStartValue), e.preventDefault(), e.stopPropagation(), e.originalEvent.preventDefault(), e.originalEvent.stopPropagation());
    }
  }, {
    key: "_farButtonClickHandler",
    value: function _farButtonClickHandler() {
      var e = this;

      if (!e.disabled) {
        var _t921 = e.value;
        e._updateValue(e.value + ("horizontal" === e.orientation && e.rightToLeft ? -1 : 1) * e.step), "switchUntilReleased" === e.mechanicalAction && e._updateValue(_t921);
      }
    }
  }, {
    key: "_nearButtonClickHandler",
    value: function _nearButtonClickHandler() {
      var e = this;

      if (!e.disabled) {
        var _t922 = e.value;
        e._updateValue(e.value - ("horizontal" === e.orientation && e.rightToLeft ? -1 : 1) * e.step), "switchUntilReleased" === e.mechanicalAction && e._updateValue(_t922);
      }
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class100.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      switch (e) {
        case "min":
        case "max":
        case "orientation":
        case "showButtons":
          {
            a._layout(), "min" === e ? a.setAttribute("aria-valuemin", i) : "max" === e ? a.setAttribute("aria-valuemax", i) : "orientation" == e && a.setAttribute("aria-orientation", i);
            break;
          }

        case "value":
          a._updateValue(t, i);

          break;

        default:
          a._layout();

      }
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.setAttribute("role", "scrollbar"), e.setAttribute("aria-orientation", e.orientation), e.setAttribute("aria-valuemin", e.min), e.setAttribute("aria-valuemax", e.max), e.setAttribute("aria-valuenow", e.value), e._layout(), _get(_getPrototypeOf(_class100.prototype), "render", this).call(this);
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;

      e._layout();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var e = this;

      e._layout();
    }
  }, {
    key: "_layout",
    value: function _layout() {
      var e = this;
      e.scrollBarSize = "horizontal" === e.orientation ? e.$.track.offsetWidth : e.$.track.offsetHeight, e.thumbSize = e._calculateThumbSize(e.scrollBarSize), "horizontal" === e.orientation && e.$.thumb.style.width !== e.thumbSize + "px" ? e.$.thumb.style.width = e.thumbSize + "px" : "vertical" === e.orientation && e.$.thumb.style.height !== e.thumbSize + "px" && (e.$.thumb.style.height = e.thumbSize + "px"), "horizontal" === e.orientation ? (e.$.nearButton.classList.contains("smart-arrow-up") && e.$.nearButton.classList.remove("smart-arrow-up"), e.$.farButton.classList.contains("smart-arrow-down") && e.$.farButton.classList.remove("smart-arrow-down"), !e.$.nearButton.classList.contains("smart-arrow-left") && e.$.nearButton.classList.add("smart-arrow-left"), !e.$.farButton.classList.contains("smart-arrow-right") && e.$.farButton.classList.add("smart-arrow-right")) : (e.$.nearButton.classList.contains("smart-arrow-left") && e.$.nearButton.classList.remove("smart-arrow-left"), e.$.farButton.classList.contains("smart-arrow-right") && e.$.farButton.classList.remove("smart-arrow-right"), !e.$.nearButton.classList.contains("smart-arrow-up") && e.$.nearButton.classList.add("smart-arrow-up"), !e.$.farButton.classList.contains("smart-arrow-down") && e.$.farButton.classList.add("smart-arrow-down")), e._updateThumbPosition(), (e.value > e.max || e.value < e.min) && e._updateValue(e.value, e.value > e.max ? e.max : e.min);
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      var t = this;
      t.thumbCapture && e.preventDefault();
    }
  }, {
    key: "_trackDownHandler",
    value: function _trackDownHandler(e) {
      var t = this;
      e.target === t.$.track && (t._trackDownTimer && clearInterval(t._trackDownTimer), t.thumbCapture || (t._trackDownTimer = setInterval(function () {
        t._trackClickHandler(e);
      }, t.clickRepeatDelay), e.stopPropagation(), e.preventDefault()));
    }
  }, {
    key: "_trackClickHandler",
    value: function _trackClickHandler(e) {
      var t = this;
      if (t.disabled) return;
      if (t._isThumbDragged) return clearInterval(t._trackDownTimer), void (t._trackDownTimer = null);
      var i = t.$.thumb.getBoundingClientRect(),
          a = e.pageX - window.pageXOffset,
          n = e.pageY - window.pageYOffset,
          o = (t.rightToLeft ? -1 : 1) * t.value;
      "horizontal" === t.orientation ? a > (t._isThumbDragged ? t.dragStartX : i.right) ? t._updateValue(t.value + (t.rightToLeft ? -1 : 1) * t.largeStep) : a < (t._isThumbDragged ? t.dragStartX : i.left) && t._updateValue(t.value - (t.rightToLeft ? -1 : 1) * t.largeStep) : n > (t._isThumbDragged ? t.dragStartY : i.bottom) ? t._updateValue(t.value + t.largeStep) : n < (t._isThumbDragged ? t.dragStartY : i.top) && t._updateValue(t.value - t.largeStep), "switchUntilReleased" === t.mechanicalAction && t._updateValue(o);
    }
  }, {
    key: "_trackMoveHandler",
    value: function _trackMoveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_updateValue",
    value: function _updateValue(e, t) {
      var i = this;

      if (1 === arguments.length && (t = e, e = i.value), (void 0 === t || isNaN(t)) && (t = i.min), t > i.max && (t = i.max), t < i.min && (t = i.min), i.value = t, e !== t) {
        if (i.setAttribute("aria-valuenow", t), i._updateThumbPosition(), i.thumbCapture && "switchWhenReleased" === i.mechanicalAction) return;
        if (i.onChange) return void i.onChange({
          value: i.value,
          oldValue: e,
          min: i.min,
          max: i.max
        });
        i.$.fireEvent("change", {
          value: i.value,
          oldValue: e,
          min: i.min,
          max: i.max
        });
      }
    }
  }, {
    key: "_updateThumbPosition",
    value: function _updateThumbPosition() {
      var e = this,
          t = e.$.track.offsetHeight,
          i = e.$.track.offsetWidth,
          a = "horizontal" === e.orientation ? i : t,
          n = e._calculateThumbSize(a),
          o = "horizontal" === e.orientation ? i - n : t - n;

      var r = (a - n) / (e.max - e.min) * (e.value - e.min);
      e.rightToLeft && "horizontal" === e.orientation && (r = (a - n) / (e.max - e.min) * (e.max - e.value - e.min)), r = Math.min(o, Math.max(0, r)), "vertical" === e.orientation && e.$.thumb.style.top !== r + "px" ? e.$.thumb.style.top = r + "px" : "horizontal" === e.orientation && e.$.thumb.style.left !== r + "px" && (e.$.thumb.style.left = r + "px");
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        clickRepeatDelay: {
          type: "integer",
          value: 50
        },
        largeStep: {
          type: "integer",
          value: 100
        },
        min: {
          type: "integer",
          value: 0
        },
        max: {
          type: "integer",
          value: 1e3
        },
        mechanicalAction: {
          value: "switchWhileDragging",
          allowedValues: ["switchUntilReleased", "switchWhenReleased", "switchWhileDragging"],
          type: "string"
        },
        orientation: {
          type: "string",
          value: "horizontal",
          allowedValues: ["horizontal", "vertical"]
        },
        step: {
          type: "integer",
          value: 10
        },
        showButtons: {
          type: "boolean",
          value: !0,
          defaultReflectToAttribute: !0
        },
        value: {
          type: "integer",
          value: 0
        }
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.scrollbar.css"];
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "nearButton.click": "_nearButtonClickHandler",
        "nearButton.mousedown": "_startRepeat",
        "nearButton.mouseup": "_stopRepeat",
        "nearButton.mouseenter": "_updateInBoundsFlag",
        "nearButton.mouseleave": "_updateInBoundsFlag",
        "farButton.click": "_farButtonClickHandler",
        "farButton.mousedown": "_startRepeat",
        "farButton.mouseup": "_stopRepeat",
        "farButton.mouseenter": "_updateInBoundsFlag",
        "farButton.mouseleave": "_updateInBoundsFlag",
        "track.down": "_trackDownHandler",
        "track.click": "_trackClickHandler",
        "track.move": "_trackMoveHandler",
        "thumb.down": "_dragStartHandler",
        "document.move": "_dragHandler",
        "document.up": "_dragEndHandler",
        up: "_dragEndHandler",
        "document.selectstart": "_selectStartHandler",
        resize: "_resizeHandler"
      };
    }
  }]);

  return _class100;
}(Smart.BaseElement)), Smart("smart-splitter-item",
/*#__PURE__*/
function (_Smart$ContentElement11) {
  "use strict";

  _inherits(_class101, _Smart$ContentElement11);

  function _class101() {
    _classCallCheck(this, _class101);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class101).apply(this, arguments));
  }

  _createClass(_class101, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div class=\"smart-content\" id=\"content\" inner-h-t-m-l=\"[[innerHTML]]\" role=\"presentation\">\n                        <content></content>\n                    </div>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "collapsed":
          a._ignorePropertyValue = !0, i ? a.collapse() : a.expand();
          break;

        case "collapsible":
          a._updateNearSplitterBars();

          break;

        case "size":
        case "min":
        case "max":
          a._setSize(e, i);

          break;

        default:
          _get(_getPrototypeOf(_class101.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "attached",
    value: function attached() {
      _get(_getPrototypeOf(_class101.prototype), "attached", this).call(this);

      var e = this;
      e._sizeLimits || (e._sizeLimits = {});
      var t = getComputedStyle(e);
      e.min || (e._sizeLimits.minWidth = parseFloat(t.getPropertyValue("min-width")) || 0, e._sizeLimits.minHeight = parseFloat(t.getPropertyValue("min-height")) || 0), e.max || (e._sizeLimits.maxWidth = parseFloat(t.getPropertyValue("max-width")) || 0, e._sizeLimits.maxHeight = parseFloat(t.getPropertyValue("max-height")) || 0);
    }
  }, {
    key: "detached",
    value: function detached() {
      _get(_getPrototypeOf(_class101.prototype), "detached", this).call(this);

      var e = this;
      e.$.removeClass("animate");
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;
      if (!e) return void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "appendChild",
        node: "node"
      }));

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1084 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1084.concat(Array.prototype.slice.call(arguments)));
      }

      t.$.content.appendChild(e);
    }
  }, {
    key: "collapse",
    value: function collapse(e) {
      var t = this;
      if (!t.collapsible) return void (t.collapsed = !1);

      if (t._ignorePropertyValue || !t.collapsed) {
        var _i913 = t.closest("smart-splitter") || (t.getRootNode() && t.getRootNode().host ? t.getRootNode().host.closest("smart-splitter") : void 0);

        if (!_i913) return;

        var _a597 = _i913._items.indexOf(t);

        _a597 === _i913._items.length - 1 ? e = !0 : 0 === _a597 && (e = !1);

        var _n448 = e ? -1 : 1;

        var _o326 = _a597 + _n448,
            _r203 = _i913._items[_o326];

        for (; _r203 && !!_r203.collapsed;) {
          _o326 += _n448, _r203 = _i913._items[_o326];
        }

        if (!_r203) return void (t.collapsed = !1);
        delete t._ignorePropertyValue, t._sizeBeforeCollapse || (t._sizeBeforeCollapse = t[_i913._measurements.size]), _r203._sizeBeforeCollapse || (_r203._sizeBeforeCollapse = _r203[_i913._measurements.size]);

        var _l135;

        t.previousElementSibling instanceof Smart.SplitterBar ? _l135 = t.previousElementSibling : t.nextElementSibling instanceof Smart.SplitterBar && (_l135 = t.nextElementSibling);

        var _s99 = _r203[_i913._measurements.size] + t[_i913._measurements.size],
            d = _l135 ? _l135[_i913._measurements.size] : t._sizeLimits[_i913._measurements.minDimension];

        if (_s99 && _s99 - d < d) return void (t.collapsed = !1);

        if (t.hasAnimation && !_i913._isInitializing && (t.$.addClass("animate"), _r203.$.addClass("animate"), t.addEventListener("transitionend", t._transitionEndHandler, {
          once: !0
        }), t.addEventListener("transitioncancel", t._transitionEndHandler, {
          once: !0
        }), _r203.addEventListener("transitionend", t._transitionEndHandler, {
          once: !0
        }), _r203.addEventListener("transitioncancel", t._transitionEndHandler, {
          once: !0
        })), !t._paddings) {
          var _e1085 = getComputedStyle(t);

          t._paddings = (parseFloat(_e1085.getPropertyValue("padding-" + _i913._measurements.position)) || 0) + (parseFloat(_e1085.getPropertyValue("padding-" + _i913._measurements.position2)) || 0);
        }

        void 0 !== _r203._sizeBeforeCollapse && (_r203._sizeBeforeCollapse += t._sizeBeforeCollapse), _r203._sizeLimits && _r203._sizeLimits[_i913._measurements.maxDimension] && _s99 > _r203._sizeLimits[_i913._measurements.maxDimension] && (_r203._sizeLimits.ignoreUpdate = !0, _r203.style[_i913._measurements.maxDimension] = _r203._sizeBeforeCollapse ? _r203._sizeBeforeCollapse + "px" : ""), _r203._sizeBeforeCollapse && (_r203.style[_i913._measurements.dimension] = _r203._sizeBeforeCollapse + "px"), t.style[_i913._measurements.dimension] = t.style[_i913._measurements.minDimension] = "0", t.style.padding = "0", t._neighbourItem = _r203, t.collapsed = !0, _i913.$.fireEvent("collapse", {
          itemIndex: _i913._items.indexOf(t)
        }), e ? (t.previousElementSibling.itemCollapsed = !0, t.previousElementSibling.showFarButton = !(t.previousElementSibling.showNearButton = !1)) : (t.nextElementSibling.itemCollapsed = !0, t.nextElementSibling.showNearButton = !(t.nextElementSibling.showFarButton = !1));
      }
    }
  }, {
    key: "expand",
    value: function expand() {
      var e = Math.max;
      var t = this;

      if (t._ignorePropertyValue || t.collapsed) {
        var _i914 = t.closest("smart-splitter") || (t.getRootNode() && t.getRootNode().host ? t.getRootNode().host.closest("smart-splitter") : void 0);

        if (!_i914) return void (t.collapsed = !0);
        if (!t._neighbourItem) return void (t.collapsed = !0);

        if (delete t._ignorePropertyValue, !t._neighbourItem._ignorePropertyValue && t._neighbourItem.collapsed) {
          var _e1086 = _i914._items.indexOf(t._neighbourItem);

          var _a599 = _i914._items.indexOf(t) > _i914._items.indexOf(t._neighbourItem) ? -1 : 1;

          for (t._neighbourItem = _i914._items[_e1086]; t._neighbourItem && !!t._neighbourItem.collapsed;) {
            _e1086 += _a599, t._neighbourItem = _i914._items[_e1086];
          }
        }

        if (!t._neighbourItem) return void (t.collapsed = !0);
        t.min && t._setSize("min", t.min, !0);
        var _a598 = t._neighbourItem._sizeBeforeCollapse,
            _n449 = t._sizeLimits[_i914._measurements.minDimension],
            _o327 = t._neighbourItem._sizeLimits[_i914._measurements.minDimension];
        if (_a598 && _a598 - _n449 < _o327) return void (t.collapsed = !0);

        if (!t._neighbourItem._paddings) {
          var _e1087 = getComputedStyle(t._neighbourItem);

          t._neighbourItem._paddings = (parseFloat(_e1087.getPropertyValue("padding-" + _i914._measurements.position)) || 0) + (parseFloat(_e1087.getPropertyValue("padding-" + _i914._measurements.position2)) || 0);
        }

        if (!t._paddings) {
          var _e1088 = getComputedStyle(t);

          t._paddings = (parseFloat(_e1088.getPropertyValue("padding-" + _i914._measurements.position)) || 0) + (parseFloat(_e1088.getPropertyValue("padding-" + _i914._measurements.position2)) || 0);
        }

        if (-1 < (t.size + "").indexOf("%") && (!t._sizeBeforeCollapse || 0 === t._sizeBeforeCollapse) && t._neighbourItem._sizeBeforeCollapse) {
          var _e1089 = 0;
          _i914._items.map(function (t) {
            return _e1089 += t.collapsed ? 0 : t.style[_i914._measurements.dimension] && -1 > t.style[_i914._measurements.dimension].indexOf("%") && t._sizeBeforeCollapse ? t._sizeBeforeCollapse : t.getBoundingClientRect()[_i914._measurements.dimension];
          }), t._sizeBeforeCollapse = _e1089 * parseFloat(t.size) / 100;
        }

        var _r204 = Math.min(e(_n449, t._sizeBeforeCollapse), _a598 - t._neighbourItem._paddings - t._paddings - _o327);

        if (0 > _r204) return void (t.collapsed = !0);
        t.hasAnimation && !_i914._isInitializing && (t.$.addClass("animate"), t._neighbourItem.$.addClass("animate"), t.addEventListener("transitionend", t._transitionEndHandler, {
          once: !0
        }), t.addEventListener("transitioncancel", t._transitionEndHandler, {
          once: !0
        }), t._neighbourItem.addEventListener("transitionend", t._transitionEndHandler, {
          once: !0
        }), t._neighbourItem.addEventListener("transitioncancel", t._transitionEndHandler, {
          once: !0
        })), t.style.padding = "", t.style[_i914._measurements.minDimension] = t.min ? t._sizeLimits[_i914._measurements.minDimension] + "px" : "", t.style[_i914._measurements.dimension] = (t._sizeBeforeCollapse = _r204) + "px", t._neighbourItem.style[_i914._measurements.dimension] = (t._neighbourItem._sizeBeforeCollapse = e(t._neighbourItem._sizeLimits[_i914._measurements.minDimension], _a598 - _r204)) + "px", t._neighbourItem._sizeLimits[_i914._measurements.maxDimension] && (t._neighbourItem.style[_i914._measurements.maxDimension] = t._neighbourItem._sizeLimits[_i914._measurements.maxDimension] + "px"), t.collapsed = !1, _i914.$.fireEvent("expand", {
          itemIndex: _i914._items.indexOf(t)
        }), _i914._items.indexOf(t) > _i914._items.indexOf(t._neighbourItem) ? (t.previousElementSibling.itemCollapsed = !1, t.previousElementSibling.showNearButton = t._neighbourItem.collapsible) : (t.nextElementSibling.itemCollapsed = !1, t.nextElementSibling.showFarButton = t._neighbourItem.collapsible);

        var _l136 = _i914._items[_i914._items.indexOf(t) - 1],
            _s100 = _i914._items[_i914._items.indexOf(t) + 1];

        if (_l136) {
          var _e1090 = _l136.nextElementSibling;
          _e1090 && _e1090 instanceof Smart.SplitterBar && (_l136.collapsed ? _e1090.showNearButton = t.collapsible : (_e1090.itemCollapsed = !1, _e1090.showNearButton = _l136.collapsible, _e1090.showFarButton = t.collapsible));
        }

        if (_s100) {
          var _e1091 = _s100.previousElementSibling;
          _e1091 && _e1091 instanceof Smart.SplitterBar && (_s100.collapsed ? _e1091.showFarButton = _s100.collapsed : (_e1091.itemCollapsed = !1, _e1091.showNearButton = t.collapsible, _e1091.showFarButton = _s100.collapsible));
        }

        delete t._neighbourItem;
      }
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      var i = this;
      if (!e) return void i.error(i.localize("invalidNode", {
        elementType: i.nodeName.toLowerCase(),
        method: "insertBefore",
        node: "node"
      }));

      if (!i.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1092 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(i, _e1092.concat(Array.prototype.slice.call(arguments)));
      }

      i.$.content.insertBefore(e, t || null);
    }
  }, {
    key: "lock",
    value: function lock() {
      var e = this;
      e.locked = !0;
    }
  }, {
    key: "unlock",
    value: function unlock() {
      var e = this;
      e.locked = !1;
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class101.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this,
          t = e.closest("smart-splitter"),
          i = t && t.isCompleted;
      e.setAttribute("role", "region"), e._sizeLimits = {};
      var a = "string" == typeof e.min && -1 < e.min.indexOf("%");
      var n = isNaN(parseFloat(e.min)) ? 0 : parseFloat(e.min),
          o = isNaN(parseFloat(e.max)) ? 0 : parseFloat(e.max);

      if (e._sizeLimits.minWidth = e._sizeLimits.minHeight = a && i ? n * t[t._measurements.size] / 100 : n, a = "string" == typeof e.max && -1 < e.max.indexOf("%"), e._sizeLimits.maxWidth = e._sizeLimits.maxHeight = a && i ? o * t[t._measurements.size] / 100 : o, e.size) {
        a = "string" == typeof e.size && -1 < e.size.indexOf("%");

        var _n450 = "auto" === e.size ? e.size : isNaN(parseFloat(e.size)) ? 0 : parseFloat(e.size) + (a ? "%" : "px");

        i ? e.style[t._measurements.dimension] = _n450 : e.style.width = e.style.height = _n450;
      }

      e.min && e._setSize("min", e.min), e.max && e._setSize("max", e.max), e._updateNearSplitterBars(), e.checkLicense(), _get(_getPrototypeOf(_class101.prototype), "render", this).call(this);
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;
      if (!e) return void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "removeChild",
        node: "node"
      }));

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1093 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1093.concat(Array.prototype.slice.call(arguments)));
      }

      t.$.content.removeChild(e);
    }
  }, {
    key: "_expand",
    value: function _expand() {
      var e = this;
      if (e._neighbourItem && e._neighbourItem.parentElement) return void e.expand();
      var t = e.closest("smart-splitter");
      t && (delete e._neighbourItem, e.collapsed = !1, t.$.fireEvent("expand", {
        itemIndex: t._items.indexOf(e)
      }), e.style[t._measurements.minDimension] = e.min ? e._sizeLimits[t._measurements.minDimension] + "px" : "", e.style[t._measurements.dimension] = e._sizeBeforeCollapse + "px", 2 > t._items.length || e.previousElementSibling instanceof Smart.SplitterBar && (e.previousElementSibling.itemCollapsed = !1, e.previousElementSibling.showNearButton = t._items[t._items.indexOf(e) - 1].collapsible));
    }
  }, {
    key: "_mouseEventsHandler",
    value: function _mouseEventsHandler(e) {
      var t = this,
          i = t.closest("smart-splitter") || t.getRootNode().host;
      (i && !i.disabled || Smart.Utilities.Core.isMobile) && ("mouseenter" === e.type ? this.setAttribute("hover", "") : this.removeAttribute("hover"));
    }
  }, {
    key: "_propertyValidator",
    value: function _propertyValidator(e, t) {
      return "number" != typeof t && "string" != typeof t ? e : t;
    }
  }, {
    key: "_setSize",
    value: function _setSize(e, t, i) {
      var a = Math.max;
      var n = this;
      if (n.isCompleted && n.locked) return;
      var o = n.closest("smart-splitter");

      if (o) {
        if (!o.isCompleted) return void o.whenReady(function () {
          return n._setSize(e, t);
        });

        var _r205 = "string" == typeof t && -1 < t.indexOf("%"),
            _l137 = function () {
          var e = o.bars;
          var t = 0;

          for (var _i915 = 0; _i915 < e.length; _i915++) {
            t += e[_i915][o._measurements.size];
          }

          return o.$.container[o._measurements.size] - t;
        }();

        switch (t = isNaN(parseFloat(t)) ? "" : parseFloat(t), n._sizeLimits || (n._sizeLimits = {}), e) {
          case "size":
            {
              var _e1094 = n[o._measurements.size];
              "auto" !== arguments[1] && arguments[1] ? _r205 ? (n.style[o._measurements.dimension] = t + "%", n._sizeBeforeCollapse = t * _l137 / 100) : n.style[o._measurements.dimension] = (n._sizeBeforeCollapse = t || 0) + "px" : (n.style[o._measurements.dimension] = arguments[1], n._sizeBeforeCollapse = n[o._measurements.size]);

              var _i916 = _e1094 - n._sizeBeforeCollapse;

              n._originalSize && (n._originalSize = n._sizeBeforeCollapse);
              var _s101 = o._items[o._items.length - 1];

              if (n === _s101) {
                var _e1095 = o._items.find(function (e) {
                  return e !== n && !e.collapsed && !e.locked && !e.size;
                });

                if (!_e1095) for (var _t923 = a(0, o._items.length - 2); 0 <= _t923; _t923--) {
                  if (!o._items[_t923].collapsed && !o._items[_t923].locked && o._items[_t923] !== n) {
                    _e1095 = o._items[_t923];
                    break;
                  }
                }
                _e1095 && (_e1095.style[o._measurements.dimension] = (_e1095._sizeBeforeCollapse = a(0, _e1095[o._measurements.size] + _i916)) + "px");
              }

              break;
            }

          case "min":
            n._sizeLimits.minWidth = n._sizeLimits.minHeight = _r205 ? t * _l137 / 100 : t, n.style[o._measurements.minDimension] = n.collapsed || !t ? "" : t + (_r205 ? "%" : "px"), n.style["min" + o._measurements.restricredDimension] = "", t || o._noNeighbourValidation || o._validateNeighbourSizeLimits(n);
            break;

          case "max":
            n._sizeLimits.maxWidth = n._sizeLimits.maxHeight = _r205 ? t * _l137 / 100 : t, n.style[o._measurements.maxDimension] = t ? t + (_r205 ? "%" : "px") : "", n.style["max" + o._measurements.restricredDimension] = "", t || o._noNeighbourValidation || o._validateNeighbourSizeLimits(n);
        }

        i || o._noItemSizeValidation || o._validateItemSize(!0);
      }
    }
  }, {
    key: "_styleChangedEventHandler",
    value: function _styleChangedEventHandler(e) {
      var t = this;
      if (t.locked) return;
      if (t._sizeLimits.ignoreUpdate) return void delete t._sizeLimits.ignoreUpdate;
      if (t.collapsed) return;
      var i = t.closest("smart-splitter");
      var a;
      e.detail.styleProperties["min-width"] ? (a = e.detail.styleProperties["min-width"][i && "horizontal" === i.orientation ? "oldValue" : "value"], t._sizeLimits.minWidth = (parseFloat(a) || 0) * (a && -1 < a.indexOf("%") ? i[i._measurements.size] / 100 : 1)) : e.detail.styleProperties["max-width"] ? (a = e.detail.styleProperties["max-width"][i && "horizontal" === i.orientation ? "oldValue" : "value"], t._sizeLimits.maxWidth = (parseFloat(a) || 0) * (a && -1 < a.indexOf("%") ? i[i._measurements.size] / 100 : 1)) : e.detail.styleProperties["min-height"] ? (a = e.detail.styleProperties["min-height"][i && "horizontal" === i.orientation ? "value" : "oldValue"], t._sizeLimits.minHeight = (parseFloat(a) || 0) * (a && -1 < a.indexOf("%") ? i[i._measurements.size] / 100 : 1)) : e.detail.styleProperties["max-height"] && (a = e.detail.styleProperties["max-height"][i && "horizontal" === i.orientation ? "value" : "oldValue"], t._sizeLimits.maxHeight = (parseFloat(a) || 0) * (a && -1 < a.indexOf("%") ? i[i._measurements.size] / 100 : 1));
    }
  }, {
    key: "_transitionEndHandler",
    value: function _transitionEndHandler() {
      var e = this;

      if ((e.isCompleted || !e.$.hasClass("animate")) && (e.$.removeClass("animate"), e._neighbourItem && e._neighbourItem.$.hasClass("animate") && e._neighbourItem.$.removeClass("animate"), -1 < (e.size + "").indexOf("%") || e._neighbourItem && -1 < (e._neighbourItem.size + "").indexOf("%"))) {
        var _t924 = (e.shadowRoot && e.getRootNode() ? e.getRootNode().host : null) || e.closest("smart-splitter");

        _t924._validateItemSize();
      }
    }
  }, {
    key: "_updateNearSplitterBars",
    value: function _updateNearSplitterBars() {
      var e = this;
      e.previousElementSibling instanceof Smart.SplitterBar && (e.previousElementSibling.showFarButton = e.collapsible), e.nextElementSibling instanceof Smart.SplitterBar && (e.nextElementSibling.showNearButton = e.collapsible);
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        collapsed: {
          value: !1,
          type: "boolean"
        },
        collapsible: {
          value: !1,
          type: "boolean"
        },
        locked: {
          value: !1,
          type: "boolean"
        },
        max: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        min: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        },
        size: {
          value: "",
          type: "any",
          validator: "_propertyValidator"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        mouseenter: "_mouseEventsHandler",
        mouseleave: "_mouseEventsHandler",
        styleChanged: "_styleChangedEventHandler"
      };
    }
  }]);

  return _class101;
}(Smart.ContentElement)), Smart("smart-splitter-bar",
/*#__PURE__*/
function (_Smart$BaseElement26) {
  "use strict";

  _inherits(_class102, _Smart$BaseElement26);

  function _class102() {
    _classCallCheck(this, _class102);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class102).apply(this, arguments));
  }

  _createClass(_class102, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div class=\"smart-splitter-far-collapse-button\" id=\"farCollapseButton\" role=\"button\" aria-label=\"Collapse next\">\n                        <span id=\"arrowNear\" class=\"smart-arrow\" aria-hidden=\"true\"></span>\n                    </div>\n                    <div class=\"smart-splitter-resize-button\" id=\"resizeButton\" aria-hidden=\"true\">\n                        <span></span>\n                    </div>\n                    <div class=\"smart-splitter-near-collapse-button\" id=\"nearCollapseButton\" role=\"button\" aria-label=\"Collapse previous\">\n                        <span id=\"arrowFar\" class=\"smart-arrow\" aria-hidden=\"true\"></span>\n                    </div>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "unfocusable":
          a._setFocusable();

          break;

        default:
          _get(_getPrototypeOf(_class102.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class102.prototype), "ready", this).call(this);

      var e = this;
      e.setAttribute("role", "separator"), e.setAttribute("aria-label", "Resize"), e._setFocusable();
    }
  }, {
    key: "hide",
    value: function hide() {
      var e = this,
          t = e.closest("smart-splitter");

      if (e.$.addClass("smart-hidden"), t) {
        var _a600 = t.items;

        if (t.hasAnimation) {
          var _t925;

          for (var _n451 = 0; _n451 < _a600.length; _n451++) {
            _a600[_n451].$.hasClass("animate") && (_t925 = !0, _a600[_n451].addEventListener("transitionend", function () {
              e.closest("smart-splitter")._autoFitItems();
            }, {
              once: !0
            }));
          }

          if (_t925) return;
        }

        t._autoFitItems();
      }
    }
  }, {
    key: "show",
    value: function show() {
      var e = this,
          t = e.closest("smart-splitter");

      if (e.$.removeClass("smart-hidden"), t) {
        var _a601 = t.items;

        if (t.hasAnimation) {
          var _t926;

          for (var _n452 = 0; _n452 < _a601.length; _n452++) {
            _a601[_n452].$.hasClass("animate") && (_t926 = !0, _a601[_n452].addEventListener("transitionend", function () {
              e.closest("smart-splitter")._autoFitItems();
            }, {
              once: !0
            }));
          }

          if (_t926) return;
        }

        t._autoFitItems();
      }
    }
  }, {
    key: "lock",
    value: function lock() {
      var e = this;
      e.locked = e.unfocusable = !0;
      e.showNearButton || e.showFarButton || e._setFocusable();
    }
  }, {
    key: "unlock",
    value: function unlock() {
      var e = this;
      e.locked = e.unfocusable = !1, e._setFocusable();
    }
  }, {
    key: "_focusEventHandler",
    value: function _focusEventHandler(e) {
      "focus" === e.type ? this.setAttribute("focus", "") : this.removeAttribute("focus");
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void e.removeAttribute("tabindex") : void (e.tabIndex = 0 < e.tabIndex ? e.tabIndex : 0);
    }
  }, {
    key: "_handleHoveredState",
    value: function _handleHoveredState(e, t) {
      var i = this;

      switch (t) {
        case "mouseenter":
          if (!e._getTargetItem(i, "previousElementSibling") || ("adjacent" === e.resizeMode ? !e._getTargetItem(i, "nextElementSibling") : !e._getTargetItem(i, "previousElementSibling", !0))) return;
          i.setAttribute("hover", "");
          break;

        case "mouseleave":
          {
            i.removeAttribute("hover");
            break;
          }
      }
    }
  }, {
    key: "_mouseEventsHandler",
    value: function _mouseEventsHandler(e) {
      var t = this,
          i = t.closest("smart-splitter") || t.getRootNode().host;
      return i && i.disabled || Smart.Utilities.Core.isMobile ? void 0 : "mouseenter" === e.type || "mouseleave" === e.type ? void t._handleHoveredState(i, e.type) : e.target.closest(".smart-splitter-far-collapse-button") === t.$.farCollapseButton ? void ("mouseover" === e.type ? t.$.farCollapseButton.setAttribute("hover", "") : t.$.farCollapseButton.removeAttribute("hover")) : e.target.closest(".smart-splitter-near-collapse-button") === t.$.nearCollapseButton ? void ("mouseover" === e.type ? t.$.nearCollapseButton.setAttribute("hover", "") : t.$.nearCollapseButton.removeAttribute("hover")) : void (e.target.closest(".smart-splitter-resize-button") === t.$.resizeButton && ("mouseover" === e.type ? t.$.resizeButton.setAttribute("hover", "") : t.$.resizeButton.removeAttribute("hover")));
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        showNearButton: {
          value: !1,
          type: "boolean"
        },
        showFarButton: {
          value: !1,
          type: "boolean"
        },
        itemCollapsed: {
          value: !1,
          type: "boolean"
        },
        locked: {
          value: !1,
          type: "boolean"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        mouseenter: "_mouseEventsHandler",
        mouseleave: "_mouseEventsHandler",
        mouseover: "_mouseEventsHandler",
        mouseout: "_mouseEventsHandler",
        focus: "_focusEventHandler",
        blur: "_focusEventHandler"
      };
    }
  }]);

  return _class102;
}(Smart.BaseElement)), Smart("smart-splitter",
/*#__PURE__*/
function (_Smart$ContentElement12) {
  "use strict";

  _inherits(_class103, _Smart$ContentElement12);

  function _class103() {
    _classCallCheck(this, _class103);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class103).apply(this, arguments));
  }

  _createClass(_class103, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <content></content>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "dataSource":
          a._createLayout();

          break;

        case "resizeMode":
          delete a._dragDetails;
          break;

        case "orientation":
          {
            a.bars.forEach(function (e) {
              return e.setAttribute("aria-orientation", i);
            }), a._setMeasurements(), a.setAttribute("orientation-change", "");

            for (var _e1096 = 0; _e1096 < a._items.length; _e1096++) {
              a._items[_e1096].style[a._measurements.dimension] = a._items[_e1096]["offset" + a._measurements.restricredDimension] + "px", a._items[_e1096].style[a._measurements.restricredDimension.toLowerCase()] = "100%", a._items[_e1096].style["max" + a._measurements.restricredDimension] = "none", a._items[_e1096].style["min" + a._measurements.restricredDimension] = "none", a._items[_e1096].style[a._measurements.maxDimension] = a._items[_e1096].max ? a._items[_e1096]._sizeLimits[a._measurements.maxDimension] + "px" : "", a._items[_e1096].collapsed ? (a._items[_e1096].style.minWidth = a._items[_e1096].style.minHeight = "", a._items[_e1096].style[a._measurements.minDimension] = "0") : a._items[_e1096].style[a._measurements.minDimension] = a._items[_e1096].min ? a._items[_e1096]._sizeLimits[a._measurements.minDimension] + "px" : "";
            }

            a._validateItemSize(), a.removeAttribute("orientation-change");
            break;
          }

        case "unfocusable":
          a._setFocusable();

          break;

        default:
          _get(_getPrototypeOf(_class103.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1097 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1097.concat(Array.prototype.slice.call(arguments)));
      }

      return e && e instanceof Smart.SplitterItem ? void t.insertBefore(e, null) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "appendChild",
        node: "node"
      }));
    }
  }, {
    key: "attached",
    value: function attached() {
      _get(_getPrototypeOf(_class103.prototype), "attached", this).call(this);

      var e = this;
      e.isRendered && e._validateItemSize();
    }
  }, {
    key: "collapse",
    value: function collapse(e, t) {
      var i = this;

      if ("number" == typeof e && (e = i._items[e]), !!e) {
        var _a602 = i.closest("smart-splitter") || (i.getRootNode() && i.getRootNode().host ? i.getRootNode().host.closest("smart-splitter") : void 0);

        return e instanceof Smart.SplitterItem && _a602 === i ? void e.collapse(t) : "number" == typeof e && i._items[e] ? void e.collapse(t) : void i.error(i.localize("invalidIndex", {
          elementType: i.nodeName.toLowerCase(),
          method: "collapse"
        }));
      }
    }
  }, {
    key: "expand",
    value: function expand(e) {
      var t = this;

      if ("number" == typeof e && (e = t._items[e]), !!e) {
        var _i917 = t.closest("smart-splitter") || (t.getRootNode() && t.getRootNode().host ? t.getRootNode().host.closest("smart-splitter") : void 0);

        return e instanceof Smart.SplitterItem && _i917 === t ? void e.expand() : "number" == typeof e && t._items[e] ? void e.expand() : void t.error(t.localize("invalidIndex", {
          elementType: t.nodeName.toLowerCase(),
          method: "expand"
        }));
      }
    }
  }, {
    key: "hideBar",
    value: function hideBar(e) {
      var t = this;
      return "number" == typeof e && (e = t.bars[e]), e instanceof Smart.SplitterBar ? void (e instanceof Smart.SplitterBar && (t.enableShadowDOM ? e.getRootNode().host : e.closest("smart-splitter")) === t && e.hide()) : void t.error(t.localize("indexOutOfBound", {
        elementType: t.nodeName.toLowerCase(),
        method: "hideBar"
      }));
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var i = this;
      if ("string" == typeof t && (t = {
        content: t
      }), !t || "object" != typeof t) return void i.error(i.localize("invalidSettings", {
        elementType: i.nodeName.toLowerCase(),
        method: "insert"
      }));
      if ("number" != typeof e) return void i.error(i.localize("invalidIndex", {
        elementType: i.nodeName.toLowerCase(),
        method: "insert"
      }));
      var a = t instanceof Smart.SplitterItem ? t : i._createItem(t);
      e >= i._items.length || 0 === i._items.length ? i.appendChild(a) : i.insertBefore(a, i._items[e]);
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      function i() {
        var i = function () {
          for (var _t927 = e.previousElementSibling; _t927;) {
            if (_t927 instanceof Smart.SplitterItem) return _t927;
            _t927 = _t927.previousElementSibling;
          }
        }(),
            o = i ? i.locked : void 0;

        i && (i.locked = !1), a._resizeHostItemOnInsert(i, e, n), a._items && a._items.splice(t ? a._items.indexOf(t) : a._items.length, 0, e), i && (i.max && i._setSize("max", i.max, !0), i.min && i._setSize("min", i.min, !0), o && (i.locked = !0)), a._validateItemSize();
      }

      var a = this;

      if (!a.isCompleted) {
        var _e1098 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(a, _e1098.concat(Array.prototype.slice.call(arguments)));
      }

      if (!e || !(e instanceof Smart.SplitterItem)) return void a.error(a.localize("invalidNode", {
        elementType: a.nodeName.toLowerCase(),
        method: "insertBefore",
        node: "newNode/referenceNode"
      }));
      if (t && !(t instanceof Smart.SplitterItem)) return void a.error(a.localize("invalidNode", {
        elementType: a.nodeName.toLowerCase(),
        method: "insertBefore",
        node: "newNode/referenceNode"
      }));

      if (e.style[a._measurements.restricredDimension.toLowerCase()] = "100%", e.size) {
        var _t928 = "string" == typeof e.size && -1 < e.size.indexOf("%") ? "%" : "px";

        e.style[a._measurements.dimension] = "auto" === e.size ? e.size : isNaN(parseFloat(e.size)) ? "" : parseFloat(e.size) + _t928, 1 === a._items.length && (a._items[0].size = "");
      } else e.style[a._measurements.dimension] = "";

      if (e._sizeBeforeCollapse) if (e.size) {
        var _t929 = "string" == typeof e.size && -1 < e.size.indexOf("%") ? "%" : "px";

        e.style[a._measurements.dimension] = "auto" === e.size ? e.size : isNaN(parseFloat(e.size)) ? 0 : parseFloat(e.size) + _t929, e._sizeBeforeCollapse = e[a._measurements.size];
      } else delete e._sizeBeforeCollapse;
      e.style["max" + a._measurements.restricredDimension] = "none", e.style[a._measurements.maxDimension] = e._sizeLimits && e.max ? e._sizeLimits[a._measurements.maxDimension] + "px" : "", e.collapsed ? (e.style.minWidth = e.style.minHeight = "", e.style[a._measurements.minDimension] = e.style[a._measurements.dimension] = "0") : e.style[a._measurements.minDimension] = e._sizeLimits && e.min ? e._sizeLimits[a._measurements.minDimension] + "px" : "";

      for (var _n453 = 0; _n453 < a._items.length; _n453++) {
        a._items[_n453]._sizeBeforeCollapse || (a._items[_n453]._sizeBeforeCollapse = a._items[_n453][a._measurements.size]);
      }

      a.$.container.insertBefore(e, t || null);
      var n;
      var o = a.bars;
      e.previousElementSibling instanceof Smart.SplitterItem ? (n = a._createBar(e, e.previousElementSibling), a.$.container.insertBefore(n, e)) : e.nextElementSibling instanceof Smart.SplitterItem && (n = a._createBar(e, e.nextElementSibling), a.$.container.insertBefore(n, e.nextElementSibling)), n && 0 < o.length && (n.style[a._measurements.restricredDimension.toLowerCase()] = o[0].style[a._measurements.restricredDimension.toLowerCase()]), e.isCompleted ? i() : (e.__onCompleted = e._onCompleted, e._onCompleted = function () {
        e.__onCompleted && (e.__onCompleted(), delete e.__onCompleted), i();
      });
    }
  }, {
    key: "lockItem",
    value: function lockItem(e) {
      var t = this;
      return e instanceof Smart.SplitterItem ? void e.lock() : "number" == typeof e && t._items[e] ? void (e = t._items[e], e && e.lock()) : void t.error(t.localize("invalidIndex", {
        elementType: t.nodeName.toLowerCase(),
        method: "lockItem"
      }));
    }
  }, {
    key: "lockBar",
    value: function lockBar(e) {
      var t = this;
      return e instanceof Smart.SplitterBar ? void e.lock() : "number" == typeof e ? void (e = t.bars[e], e && e.lock()) : void t.error(t.localize("invalidIndex", {
        elementType: t.nodeName.toLowerCase(),
        method: "lockBar"
      }));
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class103.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.setAttribute("role", "group"), e._isInitializing = !0, e._createLayout(), delete e._isInitializing, e._setFocusable(), _get(_getPrototypeOf(_class103.prototype), "render", this).call(this);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this._resizeEventHandler();
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this;
      return e instanceof Smart.SplitterItem && e.closest("smart-splitter") === t ? void t.removeChild(e) : "number" == typeof e ? e > t._items.length || 0 > e ? void t.error(t.localize("indexOutOfBound", {
        elementType: t.nodeName.toLowerCase(),
        method: "remove"
      })) : void t.removeChild(t._items[e]) : void t.error(t.localize("invalidIndex", {
        elementType: t.nodeName.toLowerCase(),
        method: "remove"
      }));
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      var e = this;
      e._items = [], e.$.container.innerHTML = "";
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      function t(e, t, i) {
        var a = e,
            o = n._items[a];

        for (; o && !!o.collapsed;) {
          o = n._items[a += i];
        }

        return o;
      }

      var a = Math.max;
      var n = this;

      if (!n.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1099 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(n, _e1099.concat(Array.prototype.slice.call(arguments)));
      }

      if (!e || !(e instanceof Smart.SplitterItem)) return void n.error(n.localize("invalidNode", {
        elementType: n.nodeName.toLowerCase(),
        method: "removeChild",
        node: "node"
      }));
      if (!n._items) return;

      var o = n._items.indexOf(e);

      e.collapsed ? n.$.container.removeChild(n._items.indexOf(e._neighbourItem) > o ? e.nextElementSibling : e.previousElementSibling) : e.previousElementSibling instanceof Smart.SplitterBar ? n.$.container.removeChild(e.previousElementSibling) : e.nextElementSibling instanceof Smart.SplitterBar && n.$.container.removeChild(e.nextElementSibling), n._items.splice(o, 1), o = a(0, o - 1);
      var r = 0;

      var l = n._items.filter(function (e) {
        return !e.collapsed && !e.locked;
      }),
          s = e._sizeBeforeCollapse || e[n._measurements.size];

      if (l.map(function (e) {
        return r += (e.style[n._measurements.dimension] ? e._sizeBeforeCollapse : 0) || e[n._measurements.size];
      }), n.$.content.removeChild(e), 1 === n._items.length && n._items[0].collapsed || 0 < n._items.length && 0 > n._items.map(function (e) {
        return e.collapsed;
      }).indexOf(!1)) {
        var _e1100 = n._items[n._items.length - 1];
        var _t930 = _e1100.context;
        _e1100.context = _e1100, _e1100._expand(), _e1100.context = _t930;
      }

      for (var _a603 = 0; _a603 < n._items.length; _a603++) {
        if (n._items[_a603].collapsed && n._items[_a603]._neighbourItem === e) {
          var _e1101 = void 0,
              _i918 = void 0;

          n._items[_a603]._neighbourItem = t(o, n._items[_a603], 1), n._items[_a603]._neighbourItem ? (_e1101 = n._items[_a603].nextElementSibling, _e1101 && (_i918 = _e1101.context, _e1101.context = _e1101, _e1101.itemCollapsed = !0, _e1101.showNearButton = !(_e1101.showFarButton = !1), _e1101.context = _i918)) : (n._items[_a603]._neighbourItem = t(o, n._items[_a603], -1), _e1101 = n._items[_a603].previousElementSibling, _e1101 && (_i918 = _e1101.context, _e1101.context = _e1101, _e1101.itemCollapsed = !0, _e1101.showFarButton = !(_e1101.showNearButton = !1), _e1101.context = _i918));
        }
      }

      if ("proportional" === n.autoFitMode) {
        var _e1102, _t931, _o328;

        for (var d = 0; d < l.length; d++) {
          _e1102 = l[d]._sizeBeforeCollapse || l[d][n._measurements.size], _t931 = _e1102 + s * (_e1102 / r), _o328 = l[d]._sizeLimits[n._measurements.minDimension] || 0, l[d].style[n._measurements.dimension] = (l[d]._sizeBeforeCollapse = a(0, _t931)) + "px", _o328 > _e1102 && (l[d][n._measurements.minDimension] = _t931 + "px");
        }
      }

      n._autoFitItems();
    }
  }, {
    key: "showBar",
    value: function showBar(e) {
      var t = this;
      return e instanceof Smart.SplitterBar ? void e.show() : "number" == typeof e ? (e = t.bars[e], e instanceof Smart.SplitterBar ? void e.show() : void t.error(t.localize("indexOutOfBound", {
        elementType: t.nodeName.toLowerCase(),
        method: "showBar"
      }))) : void t.error(t.localize("invalidIndex", {
        elementType: t.nodeName.toLowerCase(),
        method: "showBar"
      }));
    }
  }, {
    key: "unlockItem",
    value: function unlockItem(e) {
      var t = this;
      return e instanceof Smart.SplitterItem ? void e.unlock() : "number" == typeof e && t._items[e] ? void (e = t._items[e], e && e.unlock()) : void t.error(t.localize("invalidIndex", {
        elementType: t.nodeName.toLowerCase(),
        method: "unlockItem"
      }));
    }
  }, {
    key: "unlockBar",
    value: function unlockBar(e) {
      var t = this;
      return e instanceof Smart.SplitterBar ? void e.unlock() : "number" == typeof e ? void (e = t.bars[e], e && e.unlock()) : void t.error(t.localize("invalidIndex", {
        elementType: t.nodeName.toLowerCase(),
        method: "unlockBar"
      }));
    }
  }, {
    key: "update",
    value: function update(e, t) {
      var i = this;
      if ("number" == typeof e && (e = i._items[e], !e)) return void i.error(i.localize("invalidIndex", {
        elementType: i.nodeName.toLowerCase(),
        method: "update"
      }));
      if (e instanceof Smart.SplitterItem && t && (i.enableShadowDOM ? e.getRootNode().host : i.closest("smart-splitter")) === i) for (var _i919 in t) {
        void 0 !== e[_i919] && (e[_i919] = t[_i919]);
      }
    }
  }, {
    key: "_autoFitItems",
    value: function _autoFitItems() {
      var e = this,
          t = e._items.length;
      if (0 === t || "overflow" === e.autoFitMode) return;
      var a = [],
          n = [],
          o = [],
          r;

      for (var _l138 = t - 1; 0 <= _l138; _l138--) {
        e._items[_l138].collapsed ? n.push(e._items[_l138]) : e._items[_l138].locked ? a.push(e._items[_l138]) : r ? e._items[_l138].size || o.push(e._items[_l138]) : r = e._items[_l138];
      }

      r && r.size && 0 < o.length && (r = o.filter(function (t) {
        return !t.max && !t._sizeLimits[e._measurements.maxDimension];
      })[0] || r), n.length === t && (r = n[0], r.expand(), r.unlock()), e._autoFitLastItem(r, n, a);
    }
  }, {
    key: "_autoFitLastItem",
    value: function _autoFitLastItem(e, t, i) {
      var a = this,
          n = a._items.length;
      var o;
      1 === n && a._items[0].locked && (o = a._items[0], o.locked = !1), i.length === n && i[0].unlock(), e || (e = i[0], e.unlock());
      var r = 0,
          l = 0;
      a._items.map(function (e) {
        return r += e.collapsed ? 0 : e.style[a._measurements.dimension] && -1 > e.style[a._measurements.dimension].indexOf("%") && e._sizeBeforeCollapse ? e._sizeBeforeCollapse : e.getBoundingClientRect()[a._measurements.dimension];
      }), a.bars.map(function (e) {
        return l += e[a._measurements.size];
      });

      var s = r + l,
          d = a.$.container.getBoundingClientRect()[a._measurements.dimension];

      if (s !== d) {
        var _t932 = -1 > e.style[a._measurements.dimension].indexOf("%") ? e._sizeBeforeCollapse ? e._sizeBeforeCollapse : e.getBoundingClientRect()[a._measurements.dimension] : e.getBoundingClientRect()[a._measurements.dimension];

        var _i920 = Math.abs(d - s),
            _n454 = s < d ? 1 : -1;

        e.style[a._measurements.dimension] = (e._sizeBeforeCollapse = Math.max(0, _t932 + _n454 * _i920)) + "px", e._sizeLimits[a._measurements.maxDimension] && e._sizeBeforeCollapse > e._sizeLimits[a._measurements.maxDimension] && (e.style[a._measurements.maxDimension] = (e._sizeLimits[a._measurements.maxDimension] = e._sizeBeforeCollapse) + "px");
      }

      o && (o.locked = !0);
    }
  }, {
    key: "_autoFitItemsProportionally",
    value: function _autoFitItemsProportionally(e, t) {
      var a = this,
          n = a._items.filter(function (e) {
        return !e.collapsed;
      });

      var o = e[a._measurements.size],
          r = 0;
      n.map(function (e) {
        return r += e._sizeBeforeCollapse || e[a._measurements.size];
      }), t && (r -= t[a._measurements.size]), e.size && !e.isCompleted && (e._setSize("size", o), o = e._sizeBeforeCollapse), o = Math.min(a.$.container[a._measurements.size] / 2, e[a._measurements.size]), e.style[a._measurements.dimension] = o + "px";
      var l, s, d;

      for (var c = 0; c < n.length; c++) {
        l = n[c]._sizeBeforeCollapse || n[c][a._measurements.size], s = (r - o) * (l / r), d = n[c]._sizeLimits[a._measurements.minDimension] || 0, n[c].style[a._measurements.dimension] = (n[c]._sizeBeforeCollapse = Math.max(d, s)) + "px";
      }
    }
  }, {
    key: "_createLayout",
    value: function _createLayout() {
      var e = this;

      if (e._items = [], "string" == typeof e.dataSource && (e.dataSource = JSON.parse(e.dataSource)), null !== e.dataSource && Array.isArray(e.dataSource)) {
        e.$.container.innerHTML = "";

        var _t933 = document.createDocumentFragment(),
            _a604;

        for (var _n455 = 0; _n455 < e.dataSource.length; _n455++) {
          _a604 = e._createItem(e.dataSource[_n455]), _t933.appendChild(_a604);
        }

        return void e._handleSplitterBars(_t933);
      }

      e._handleSplitterBars(e.$.container);
    }
  }, {
    key: "_createBar",
    value: function _createBar(e, t) {
      var i = this,
          a = document.createElement("smart-splitter-bar");
      return e.collapsed ? (a.itemCollapsed = !0, i._items.indexOf(e) === i._items.length - 1 ? a.showNearButton = !0 : a.showFarButton = !0) : (e.collapsible && (a.showNearButton = !0), t && t instanceof Smart.SplitterItem && t.collapsible && (t === e.nextElementSibling ? a.showFarButton = !0 : a.showNearButton = !0)), a.setAttribute("aria-controls", e.id + (t ? " " + t.id : "")), a.setAttribute("aria-orientation", i.orientation), a;
    }
  }, {
    key: "_createItem",
    value: function _createItem(e) {
      var t = document.createElement("smart-splitter-item");
      return e.id && (t.id = e.id), t.innerHTML = e.content || "", t.collapsible = e.collapsible || !1, t.collapsed = e.collapsed || !1, t.locked = e.locked || !1, e.max && (t.max = e.max), e.min && (t.min = e.min), e.size && (t.size = e.size), t;
    }
  }, {
    key: "_completeResizing",
    value: function _completeResizing(e) {
      var t = this;

      if (t._dragDetails) {
        if (t._splitBarDummy && t._splitBarDummy.parentElement) {
          if (!e) if (t._dragDetails.firstItem.style[t._measurements.dimension] = (t._dragDetails.firstItem._sizeBeforeCollapse = t._dragDetails.firstItem.currentSize + t._dragDetails.firstItem._paddings) + "px", delete t._dragDetails.firstItem._originalSize, "proportional" !== t.resizeMode) t._dragDetails.secondItem.style[t._measurements.dimension] = (t._dragDetails.secondItem._sizeBeforeCollapse = t._dragDetails.splitAreaSize - t._dragDetails.firstItem.currentSize + t._dragDetails.secondItem._paddings) + "px", delete t._dragDetails.secondItem._originalSize;else {
            var _e1103 = t._dragDetails.itemProportions.length;
            if (1 < _e1103) for (var _i921 = 0; _i921 < _e1103; _i921++) {
              t._dragDetails.itemProportions[_i921].item.style[t._measurements.dimension] = (t._dragDetails.itemProportions[_i921].item._sizeBeforeCollapse = t._dragDetails.itemProportions[_i921].currentSize + t._dragDetails.itemProportions[_i921].item._paddings) + "px", delete t._dragDetails.itemProportions[_i921]._originalSize;
            } else t._dragDetails.secondItem[0].style[t._measurements.dimension] = (t._dragDetails.secondItem[0]._sizeBeforeCollapse = Math.floor(t._dragDetails.splitAreaSize - t._dragDetails.firstItem.currentSize + t._dragDetails.firstItem._paddings)) + "px", delete t._dragDetails.secondItem[0]._originalSize;
          }
          t.$.fireEvent("resizeEnd", {
            firstItem: {
              index: t._items.indexOf(t._dragDetails.firstItem),
              oldSize: t._dragDetails.firstItem.originalSize,
              newSize: t._dragDetails.firstItem[t._measurements.size]
            },
            secondItem: Array.isArray(t._dragDetails.secondItem) ? {
              index: t._dragDetails.secondItem.map(function (e) {
                return t._items.indexOf(e);
              }),
              oldSize: t._dragDetails.secondItem.map(function (e) {
                return e.originalSize;
              }),
              newSize: t._dragDetails.secondItem.map(function (e) {
                return e[t._measurements.size];
              })
            } : {
              index: t._items.indexOf(t._dragDetails.secondItem),
              oldSize: t._dragDetails.secondItem.originalSize,
              newSize: t._dragDetails.secondItem[t._measurements.size]
            }
          }), t._splitBarDummy.classList.remove("limit-reached"), t._splitBarDummy.parentElement.removeChild(t._splitBarDummy);
        }

        t.removeAttribute("dragged"), delete t._dragDetails, delete t._keyboardResizing;
      }
    }
  }, {
    key: "_dragStartHandler",
    value: function _dragStartHandler(e) {
      var t = this;
      t._dragDetails && e.preventDefault();
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;
      if (e.stopPropagation(), t.disabled) return;
      if (t._keyboardResizing) return void t._completeResizing();
      var i = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      var a = i.closest("smart-splitter");
      a || (a = i.getRootNode() && i.getRootNode().host ? i.getRootNode().host.closest("smart-splitter") : void 0);
      var n = i && i.closest ? i.closest("smart-splitter-bar") : null;

      if (n && a === t) {
        if (i.closest(".smart-splitter-near-collapse-button") === n.$.nearCollapseButton) return void (t._collapseButtonPressed = {
          splitBar: n,
          item: n.previousElementSibling,
          target: n.$.nearCollapseButton,
          farCollapse: !1
        });
        if (i.closest(".smart-splitter-far-collapse-button") === n.$.farCollapseButton) return void (t._collapseButtonPressed = {
          splitBar: n,
          item: n.nextElementSibling,
          target: n.$.farCollapseButton,
          farCollapse: !0
        });
        n.itemCollapsed || n.locked || "none" === t.resizeMode || t._setDragDetails(n, e);
      }
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler() {
      this.hasAttribute("dragged") && Smart.Utilities.Core.isMobile && event.originalEvent.preventDefault();
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = this;
      t._keyboardResizing || t._resize(e);
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;
      if (t.removeAttribute("dragging-not-allowed"), t.removeAttribute("show-locked-items"), t.disabled) return delete t._dragDetails, void delete t._collapseButtonPressed;
      var i = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      if (t._completeResizing(), t._collapseButtonPressed && i.closest("." + t._collapseButtonPressed.target.classList[0]) === t._collapseButtonPressed.target) return t._collapseButtonPressed.item.collapsed ? t.expand(t._collapseButtonPressed.item) : t.collapse(t._collapseButtonPressed.item, t._collapseButtonPressed.farCollapse), void delete t._collapseButtonPressed;
    }
  }, {
    key: "_ensureItemsReady",
    value: function _ensureItemsReady(e, t) {
      var a = this,
          i = function i() {
        var i = function i(t) {
          for (var _a605 = 0; _a605 < e.length; _a605++) {
            e[_a605].context = "node" === t ? e[_a605] : document;
          }
        };

        i("node"), t(), i();
      };

      if (0 === e.length) i();else {
        a._nodesReadyListeners = 0;

        for (var _t934 = 0; _t934 < e.length; _t934++) {
          var _n456 = e[_t934],
              _o329 = function () {
            a._nodesReadyListeners--, 0 === a._nodesReadyListeners && (i(), delete a._nodesReadyListeners);
          }.bind(a);

          _n456.isCompleted || (a._nodesReadyListeners++, _n456._onCompleted = _o329);
        }

        0 === a._nodesReadyListeners && i();
      }
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler(e) {
      var t = this;
      "focus" === e.type ? t.setAttribute("focus", "") : t.removeAttribute("focus");
    }
  }, {
    key: "_getTargetItem",
    value: function _getTargetItem(e, t, i) {
      var a = this;

      for (var _n457 = i ? a._items[a._items.length - 1] : e[t]; _n457;) {
        if (_n457 instanceof Smart.SplitterItem && !_n457.collapsed) {
          if (!_n457.locked) return _n457;
          a._dragDetails && !a._dragDetails.firstItem && (a._dragDetails.lockedItemsSize += _n457[a._measurements.size] + (_n457.previousElementSibling instanceof Smart.SplitterBar ? _n457.previousElementSibling[a._measurements.size] : 0));
        }

        _n457 = _n457[t];
      }
    }
  }, {
    key: "_handleSplitterBars",
    value: function _handleSplitterBars(e) {
      var t = this;

      if (1 > t._items.length && (t._items = e.parentElement ? t.items : Array.from(e.children)), t._measurements || t._setMeasurements(), 2 > t._items.length) {
        var _a606 = t.bars;

        for (var _t935 = 0; _t935 < _a606.length; _t935++) {
          e.removeChild(_a606[_t935]);
        }
      }

      t._noItemSizeValidation = !0, e.parentElement || e === t.$.container || (t.$.container.appendChild(e), e = t.$.container), t._noItemSizeValidation = !1;
      var a;

      for (var _n458 = 0; _n458 < t._items.length; _n458++) {
        if (a = t._items[_n458], 0 == _n458) for (; e.firstElementChild && e.firstElementChild !== a;) {
          e.removeChild(e.firstElementChild);
        }
        a.style[t._measurements.restricredDimension.toLowerCase()] = "100%", a.style["max" + t._measurements.restricredDimension] = "none", a.size || (a.style[t._measurements.dimension] = a._sizeBeforeCollapse ? a._sizeBeforeCollapse + "px" : "");
        var _i922 = a.min,
            _o330 = a.max;

        if ("string" == typeof _i922 && -1 < _i922.indexOf("%") && a._setSize("min", _i922), "string" == typeof _o330 && -1 < _o330.indexOf("%") && a._setSize("max", _o330), a.style[t._measurements.maxDimension] = a.max ? a._sizeLimits[t._measurements.maxDimension] + "px" : "", a.nextElementSibling) {
          var _e1104 = a.nextElementSibling;
          if (_e1104 instanceof Smart.SplitterItem || "smart-splitter-item" === _e1104.tagName.toLowerCase()) a.parentNode.insertBefore(t._createBar(a, a.nextElementSibling), a.nextElementSibling);else for ((_e1104 instanceof Smart.SplitterBar || "smart-splitter-bar" === _e1104.tagName.toLowerCase()) && (_e1104 = _e1104.nextElementSibling); _e1104 && (!(_e1104 instanceof Smart.SplitterItem) || "smart-splitter-item" !== _e1104.tagName.toLowerCase());) {
            _e1104.parentNode.removeChild(_e1104), _e1104 = _e1104.nextElementSibling;
          }
        }

        if (a.collapsed) {
          var _e1105 = a.collapsible;
          a.style.minWidth = a.style.minHeight = "", a.style[t._measurements.minDimension] = "0", a._ignorePropertyValue = !0, a.collapsible = !0, a.collapse(), a.collapsible = _e1105;
        } else a.style[t._measurements.minDimension] = a._sizeLimits && a.min ? a._sizeLimits[t._measurements.minDimension] + "px" : "";
      }

      if (a) for (; e.lastElementChild !== a;) {
        e.removeChild(e.lastElementChild);
      }

      t._ensureItemsReady(t._items, t._validateItemSize.bind(t));
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this;
      if (t.disabled) return;
      var i = t.enableShadowDOM ? t.shadowRoot.activeElement : document.activeElement;

      if ("w" === e.key && e.altKey) {
        e.preventDefault();

        var _a607 = t.enableShadowDOM ? t.shadowRoot.querySelector("smart-splitter-bar") : t.querySelector("smart-splitter-bar");

        return i !== _a607 && t._completeResizing(!0), void _a607.focus();
      }

      if (!e.ctrlKey && t._splitBarDummy && t._splitBarDummy.parentElement) i = t._splitBarDummy;else if (!(i instanceof Smart.SplitterBar)) return;
      if ((t.enableShadowDOM ? i.getRootNode().host : i.closest("smart-splitter")) === t) switch (e.key) {
        case "ArrowLeft":
        case "ArrowRight":
        case "ArrowUp":
        case "ArrowDown":
          {
            if (("ArrowUp" === e.key || "ArrowDown" === e.key) && "vertical" === t.orientation) return;
            if (("ArrowLeft" === e.key || "ArrowRight" === e.key) && "horizontal" === t.orientation) return;
            e.preventDefault();

            var _a608 = "ArrowLeft" === e.key || "ArrowUp" === e.key ? -1 : 1;

            if (e.ctrlKey) {
              t._completeResizing(!0);

              var _e1106, _n460;

              return 0 > _a608 ? (_n460 = i.previousElementSibling, _e1106 = i.nextElementSibling) : (_e1106 = i.previousElementSibling, _n460 = i.nextElementSibling), void (_e1106.collapsed ? _e1106.expand() : _n460.collapse(0 < _a608));
            }

            if (i.locked) return;
            if ("none" === t.resizeMode) return;
            t._keyboardResizing = !0;

            var _n459;

            t._dragDetails ? _n459 = t._dragDetails.position + _a608 * t.resizeStep : (t._setDragDetails(i), _n459 = i[t._measurements.offset] + _a608 * t.resizeStep), t._resize({
              pageX: _n459,
              pageY: _n459
            });
            break;
          }

        case "Enter":
          t._completeResizing();

          break;

        case "Escape":
        case "Tab":
          t._completeResizing(!0);

      }
    }
  }, {
    key: "_mouseEventsHandler",
    value: function _mouseEventsHandler(e) {
      "mouseenter" !== e.type || Smart.Utilities.Core.isMobile ? this.removeAttribute("hover") : this.setAttribute("hover", "");
    }
  }, {
    key: "_recalcItemSize",
    value: function _recalcItemSize(e, t, i) {
      var a = Math.min,
          n = Math.max;
      var o = this;
      var r, l;
      if (i || (i = t), 0 < e) for (var _a609 = 0; _a609 < t; _a609++) {
        l = o._dragDetails.itemProportions[_a609].item._sizeLimits[o._measurements.minDimension], o._dragDetails.itemProportions[_a609].currentSize > l && (r = o._dragDetails.itemProportions[_a609].currentSize - l < e / i ? o._dragDetails.itemProportions[_a609].currentSize - l : e / i, e -= r, o._dragDetails.itemProportions[_a609].currentSize = n(l, o._dragDetails.itemProportions[_a609].currentSize - r), delete o._dragDetails.itemProportions[_a609]._originalSize), i = n(1, i - 1);
      } else {
        var _l139 = o._dragDetails.splitAreaSize - o._dragDetails.firstItem.currentSize - (1 < t ? o._dragDetails.secondItemTotalMinSize - o._dragDetails.itemProportions[0].item._sizeLimits[o._measurements.minDimension] : 0);

        var _s102;

        for (var d = 0; d < t; d++) {
          _s102 = o._dragDetails.itemProportions[d].item._sizeLimits[o._measurements.maxDimension] ? a(o._dragDetails.itemProportions[d].item._sizeLimits[o._measurements.maxDimension], _l139) : _l139, o._dragDetails.itemProportions[d].currentSize < _s102 && (r = o._dragDetails.itemProportions[d].currentSize - e / i > _s102 ? -1 * (_s102 - o._dragDetails.itemProportions[d].currentSize) : e / i, e -= r, o._dragDetails.itemProportions[d].currentSize = a(_s102, o._dragDetails.itemProportions[d].currentSize - r), delete o._dragDetails.itemProportions[d]._originalSize), i = n(1, i - 1);
        }
      }
      .1 < Math.abs(e) && o._recalcItemSize(e, t, i);
    }
  }, {
    key: "_resize",
    value: function _resize(e) {
      var t = Math.min,
          i = Math.floor,
          a = Math.abs,
          n = Math.max;
      var o = this;
      if (!o._dragDetails) return;
      var r = e[o._measurements.pagePosition] - o._dragDetails.position,
          l;
      var s = Math.sign(r),
          d = o._dragDetails.firstItem._sizeLimits[o._measurements.minDimension],
          c = o._dragDetails.firstItem._sizeLimits[o._measurements.maxDimension];
      var m, u;
      if (o.hasAttribute("dragged") || o.$.fireEvent("resizeStart", {
        firstItem: {
          index: o._items.indexOf(o._dragDetails.firstItem),
          size: o._dragDetails.firstItem[o._measurements.size]
        },
        secondItem: Array.isArray(o._dragDetails.secondItem) ? {
          index: o._dragDetails.secondItem.map(function (e) {
            return o._items.indexOf(e);
          }),
          size: o._dragDetails.secondItem.map(function (e) {
            return e[o._measurements.size];
          })
        } : {
          index: o._items.indexOf(o._dragDetails.secondItem),
          size: o._dragDetails.secondItem[o._measurements.size]
        }
      }), o.setAttribute("dragged", ""), a(r) < o.resizeStep) return;
      var p = n(o.resizeStep, i(a(r) / o.resizeStep) * o.resizeStep);
      var g = r - s * p;

      switch (o.resizeMode) {
        case "adjacent":
        case "end":
          for (0 < s ? (m = o._dragDetails.splitAreaSize - o._dragDetails.firstItem.currentSize, u = function u() {
            return m - o._dragDetails.secondItemTotalMinSize >= p || c && o._dragDetails.firstItem.currentSize + o.resizeStep <= c;
          }, l = function l() {
            return c && o._dragDetails.firstItem.currentSize === c || m - o.resizeStep <= o._dragDetails.secondItemTotalMinSize;
          }) : (m = o._dragDetails.firstItem.currentSize, u = function u() {
            return m - d >= p || o._dragDetails.secondItemTotalMaxSize && o._dragDetails.splitAreaSize - o._dragDetails.firstItem.currentSize + o.resizeStep <= o._dragDetails.secondItemTotalMaxSize;
          }, l = function l() {
            return o._dragDetails.secondItemTotalMaxSize && o._dragDetails.splitAreaSize - o._dragDetails.firstItem.currentSize === o._dragDetails.secondItemTotalMaxSize || m - o.resizeStep <= d;
          }), r = 0; 0 < p;) {
            u() && (r += s * o.resizeStep), p -= o.resizeStep;
          }

          o._resizeItem(e, r, g);

          break;

        case "proportional":
          {
            var _r206 = o._dragDetails.splitAreaSize - o._dragDetails.firstItem.currentSize;

            0 < s ? (m = a(_r206 - o._dragDetails.secondItemTotalMinSize), u = function u() {
              return m >= p || c && o._dragDetails.firstItem.currentSize + o.resizeStep <= c;
            }, l = function l() {
              return c && o._dragDetails.firstItem.currentSize === c || o._dragDetails.splitAreaSize - o._dragDetails.firstItem.currentSize - o.resizeStep < o._dragDetails.secondItemTotalMinSize;
            }) : (m = o._dragDetails.firstItem.currentSize, u = function u() {
              return m - d >= p && (!o._dragDetails.secondItemTotalMaxSize || o._dragDetails.splitAreaSize - o._dragDetails.firstItem.currentSize + o.resizeStep <= o._dragDetails.secondItemTotalMaxSize);
            }, l = function l() {
              return o._dragDetails.secondItemTotalMaxSize && o._dragDetails.splitAreaSize + o.resizeStep - o._dragDetails.firstItem.currentSize >= o._dragDetails.secondItemTotalMaxSize || o._dragDetails.firstItem.currentSize - o.resizeStep < d;
            });

            var h, _;

            for (; 0 < p;) {
              u() && (_ = !0, h = t(c ? t(c, o._dragDetails.splitAreaSize - o._dragDetails.secondItemTotalMinSize) : o._dragDetails.splitAreaSize - o._dragDetails.secondItemTotalMinSize, n(d, o._dragDetails.firstItem.currentSize + s * o.resizeStep)), o._dragDetails.firstItem.currentSize = o._dragDetails.firstItem._sizeBeforeCollapse = i(h)), p -= o.resizeStep;
            }

            if (!_) break;
            var f = o._dragDetails.splitAreaSize - o._dragDetails.firstItem.currentSize,
                b = o._dragDetails.itemProportions.length;
            if (o._recalcItemSize(_r206 - f, b), !o.liveResize) o._splitBarDummy.style[o._measurements.position] = o._dragDetails.firstItem[o._measurements.offset] + o._dragDetails.firstItem.currentSize + o._dragDetails.lockedItemsSize + o._dragDetails.firstItem._paddings + "px";else if (o._dragDetails.firstItem.style[o._measurements.dimension] = o._dragDetails.firstItem.currentSize + o._dragDetails.firstItem._paddings + "px", 1 < b) for (var _e1107 = 0; _e1107 < b; _e1107++) {
              o._dragDetails.itemProportions[_e1107].item.style[o._measurements.dimension] = o._dragDetails.itemProportions[_e1107].item._sizeBeforeCollapse = o._dragDetails.itemProportions[_e1107].currentSize + o._dragDetails.itemProportions[_e1107].item._paddings + "px";
            } else o._dragDetails.secondItem[0].style[o._measurements.dimension] = (o._dragDetails.secondItem[0]._sizeBeforeCollapse = i(f + o._dragDetails.itemProportions[0].item._paddings)) + "px";

            var y = o._dragDetails.firstItem.getBoundingClientRect()["vertical" === o.orientation ? "left" : "top"] + o._dragDetails.splitBarOffset,
                v = c && o._dragDetails.splitAreaSize - c > o._dragDetails.secondItemTotalMinSize ? c : o._dragDetails.splitAreaSize - o._dragDetails.secondItemTotalMinSize;

            o._dragDetails.position = n(y + (o._dragDetails.secondItemTotalMaxSize ? n(o._dragDetails.splitAreaSize - o._dragDetails.secondItemTotalMaxSize, d) : d) + o._dragDetails.lockedItemsSize + o._dragDetails.firstItem._paddings, t(y + v + o._dragDetails.lockedItemsSize + o._dragDetails.firstItem._paddings, e[o._measurements.pagePosition] - g));
            break;
          }
      }

      o.liveResize || (l() ? o._splitBarDummy.classList.add("limit-reached") : o._splitBarDummy.classList.remove("limit-reached")), o._validateBarsSize();
    }
  }, {
    key: "_resizeEventHandler",
    value: function _resizeEventHandler() {
      var e = this;
      e._items && (e._resizeEventFired = !0, e._validateItemSize(), e._resizeEventFired = !1);
    }
  }, {
    key: "_resizeHostItemOnInsert",
    value: function _resizeHostItemOnInsert(e, t, i) {
      var a = this;
      if ("proportional" === a.autoFitMode) return void a._autoFitItemsProportionally(t, i);

      if (e && !e.locked) {
        if (t.size) {
          var _i923 = function () {
            for (var _e1108 = t.previousElementSibling; _e1108;) {
              if (_e1108 instanceof Smart.SplitterItem && !_e1108.size) return _e1108;
              _e1108 = _e1108.previousElementSibling;
            }
          }();

          e = _i923 || e;
        }

        var _n461 = e[a._measurements.size] - t[a._measurements.size] - i[a._measurements.size],
            _o331 = Math.max(e._sizeLimits[a._measurements.minDimension], _n461);

        e.style[a._measurements.maxDimension] = e.max ? isNaN(parseFloat(e.max)) ? "" : "string" == parseFloat(e.max) + typeof e.max && -1 < e.max.indexOf("%") ? "%" : "px" : "";

        var _r207 = e.style[a._measurements.maxDimension] ? parseFloat(e.style[a._measurements.maxDimension]) : 0;

        t.size ? e.style[a._measurements.dimension] = (e._sizeBeforeCollapse = _r207 ? Math.min(_r207, _o331) : _o331) + "px" : (e.style[a._measurements.dimension] = e.size ? "auto" === e.size ? e.size : isNaN(parseFloat(e.size)) ? 0 : parseFloat(e.size) + ("string" == typeof e.size && -1 < e.size.indexOf("%") ? "%" : "px") : "", e._sizeBeforeCollapse = e[a._measurements.size]);
      }
    }
  }, {
    key: "_resizeItem",
    value: function _resizeItem(e, t, i) {
      var a = Math.min,
          n = Math.max;
      var o = this;
      var r = n(o._dragDetails.firstItem._sizeLimits[o._measurements.minDimension], a(o._dragDetails.splitAreaSize - o._dragDetails.secondItem._sizeLimits[o._measurements.minDimension], o._dragDetails.firstItem._sizeLimits[o._measurements.maxDimension] ? a(o._dragDetails.firstItem._sizeLimits[o._measurements.maxDimension], o._dragDetails.firstItem.currentSize + t) : o._dragDetails.firstItem.currentSize + t)),
          l = o._dragDetails.firstItem._sizeLimits[o._measurements.minDimension];
      o._dragDetails.secondItem._sizeLimits[o._measurements.maxDimension] && o._dragDetails.splitAreaSize - r > o._dragDetails.secondItem._sizeLimits[o._measurements.maxDimension] && (l = r = o._dragDetails.splitAreaSize - o._dragDetails.secondItem._sizeLimits[o._measurements.maxDimension]), o._dragDetails.firstItem.currentSize = r, o.liveResize ? (o._dragDetails.firstItem.style[o._measurements.dimension] = (o._dragDetails.firstItem._sizeBeforeCollapse = r + o._dragDetails.firstItem._paddings) + "px", o._dragDetails.secondItem.style[o._measurements.dimension] = (o._dragDetails.secondItem._sizeBeforeCollapse = o._dragDetails.splitAreaSize - r + o._dragDetails.firstItem._paddings) + "px", delete o._dragDetails.firstItem._originalSize, delete o._dragDetails._originalSize) : o._splitBarDummy.style[o._measurements.position] = o._dragDetails.firstItem[o._measurements.offset] + r + o._dragDetails.lockedItemsSize + o._dragDetails.firstItem._paddings + "px";

      var s = o._dragDetails.firstItem.getBoundingClientRect()["vertical" === o.orientation ? "left" : "top"] + o._dragDetails.splitBarOffset;

      o._dragDetails.position = n(s + l + o._dragDetails.firstItem._paddings, a(s + o._dragDetails.splitAreaSize - o._dragDetails.secondItem._sizeLimits[o._measurements.minDimension] + o._dragDetails.lockedItemsSize + o._dragDetails.firstItem._paddings, e[o._measurements.pagePosition] - i)), o._dragDetails.firstItem._sizeLimits[o._measurements.maxDimension] && (o._dragDetails.position = a(s + o._dragDetails.firstItem._sizeLimits[o._measurements.maxDimension], o._dragDetails.position));
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void e.removeAttribute("tabindex") : void (e.tabIndex = 0 < e.tabIndex ? e.tabIndex : 0);
    }
  }, {
    key: "_setDragDetails",
    value: function _setDragDetails(e, t) {
      var i = this;
      if (i._dragDetails = {}, i._measurements || i._setMeasurements(), i._dragDetails.scrollAmount = e.parentElement[i._measurements.scroll], i._dragDetails.lockedItemsSize = 0, i.setAttribute("show-locked-items", ""), !(i._dragDetails.firstItem = i._getTargetItem(e, "previousElementSibling"))) return delete i._dragDetails, void i.setAttribute("dragging-not-allowed", "");
      i._dragDetails.firstItem.set("size", ""), i._dragDetails.firstItem.currentSize = i._dragDetails.firstItem[i._measurements.size], i._dragDetails.firstItem.originalSize = i._dragDetails.firstItem.currentSize;
      var a = getComputedStyle(i._dragDetails.firstItem);
      if (i._dragDetails.firstItem._paddings = (parseFloat(a.getPropertyValue("padding-" + i._measurements.position)) || 0) + (parseFloat(a.getPropertyValue("padding-" + i._measurements.position2)) || 0), i._dragDetails.firstItem.currentSize < i._dragDetails.firstItem._sizeLimits[i._measurements.minDimension]) return void delete i._dragDetails;

      if (i._dragDetails.firstItem.currentSize -= i._dragDetails.firstItem._paddings, i._dragDetails.splitAreaSize = 0, i._dragDetails.secondItemTotalMaxSize = 0, i._dragDetails.secondItemTotalMinSize = 0, "proportional" === i.resizeMode) {
        if (i._setProportionalDetails()) return;
      } else if (i._setAdjacentOrEndDetails(e)) return;

      var n;
      t && "object" == typeof t ? n = e.getBoundingClientRect()[i._measurements.position] : (t = {
        pageX: e[i._measurements.offset],
        pageY: e[i._measurements.offset]
      }, n = e[i._measurements.offset]), i._dragDetails.position = t[i._measurements.pagePosition], i._dragDetails.splitBarOffset = i._dragDetails.position - n, i.liveResize || (!i._splitBarDummy && (i._splitBarDummy = document.createElement("div"), i._splitBarDummy.classList.add("smart-splitter-bar-feedback")), i._splitBarDummy.style.width = e.offsetWidth + "px", i._splitBarDummy.style.height = e.offsetHeight + "px", i._splitBarDummy.style.top = e.offsetTop + "px", i._splitBarDummy.style.left = e.offsetLeft + "px", e.parentElement.appendChild(i._splitBarDummy));
    }
  }, {
    key: "_setAdjacentOrEndDetails",
    value: function _setAdjacentOrEndDetails(e) {
      var t = this;
      if (!(t._dragDetails.secondItem = "adjacent" === t.resizeMode ? t._getTargetItem(e, "nextElementSibling") : t._getTargetItem(e, "previousElementSibling", !0))) return delete t._dragDetails, t.setAttribute("dragging-not-allowed", ""), !0;
      t._dragDetails.secondItem.set("size", ""), t._dragDetails.secondItem.currentSize = t._dragDetails.secondItem[t._measurements.size], t._dragDetails.secondItem.originalSize = t._dragDetails.secondItem.currentSize;
      var i = getComputedStyle(t._dragDetails.secondItem);
      t._dragDetails.secondItem._paddings = (parseFloat(i.getPropertyValue("padding-" + t._measurements.position)) || 0) + (parseFloat(i.getPropertyValue("padding-" + t._measurements.position2)) || 0), t._dragDetails.secondItem.currentSize -= t._dragDetails.secondItem._paddings, t._dragDetails.splitAreaSize = t._dragDetails.firstItem.currentSize + t._dragDetails.secondItem.currentSize, t._dragDetails.secondItemTotalMaxSize = t._dragDetails.secondItem._sizeLimits[t._measurements.maxDimension], t._dragDetails.secondItemTotalMinSize = t._dragDetails.secondItem._sizeLimits[t._measurements.minDimension];
    }
  }, {
    key: "_setMeasurements",
    value: function _setMeasurements() {
      var e = this;
      e._measurements = {}, "horizontal" === e.orientation ? (e._measurements.dimension = "height", e._measurements.minDimension = "minHeight", e._measurements.maxDimension = "maxHeight", e._measurements.restricredDimension = "Width", e._measurements.size = "offsetHeight", e._measurements.offset = "offsetTop", e._measurements.position = "top", e._measurements.position2 = "bottom", e._measurements.pagePosition = "pageY", e._measurements.scroll = "scrollTop") : (e._measurements.dimension = "width", e._measurements.minDimension = "minWidth", e._measurements.maxDimension = "maxWidth", e._measurements.restricredDimension = "Height", e._measurements.size = "offsetWidth", e._measurements.offset = "offsetLeft", e._measurements.position = "left", e._measurements.position2 = "right", e._measurements.pagePosition = "pageX", e._measurements.scroll = "scrollLeft"), e._measurements.overflow = getComputedStyle(e).getPropertyValue("overflow");
    }
  }, {
    key: "_setProportionalDetails",
    value: function _setProportionalDetails() {
      var e = this;
      if (e._dragDetails.secondItem = e._items.slice(e._items.indexOf(e._dragDetails.firstItem) + 1).filter(function (e) {
        return !e.collapsed && !e.locked;
      }), 0 === e._dragDetails.secondItem.length) return delete e._dragDetails, !0;
      e._dragDetails.splitAreaSize += e._dragDetails.firstItem.currentSize, e._dragDetails.itemProportions = [];
      var t;

      for (var _a610 = 0; _a610 < e._dragDetails.secondItem.length; _a610++) {
        e._dragDetails.secondItem[_a610].set("size", ""), e._dragDetails.secondItem[_a610].currentSize = e._dragDetails.secondItem[_a610][e._measurements.size], e._dragDetails.secondItem[_a610].originalSize = e._dragDetails.secondItem[_a610].currentSize;

        var _i924 = getComputedStyle(e._dragDetails.secondItem[_a610]);

        e._dragDetails.secondItem[_a610]._paddings = (parseFloat(_i924.getPropertyValue("padding-" + e._measurements.position)) || 0) + (parseFloat(_i924.getPropertyValue("padding-" + e._measurements.position2)) || 0), e._dragDetails.secondItem[_a610].currentSize -= e._dragDetails.secondItem[_a610]._paddings, e._dragDetails.splitAreaSize += e._dragDetails.secondItem[_a610].currentSize, e._dragDetails.itemProportions.push({
          item: e._dragDetails.secondItem[_a610],
          currentSize: e._dragDetails.secondItem[_a610].currentSize
        }), e._dragDetails.secondItem[_a610]._sizeLimits[e._measurements.maxDimension] || (t = !0), e._dragDetails.secondItemTotalMinSize += e._dragDetails.secondItem[_a610]._sizeLimits[e._measurements.minDimension], e._dragDetails.secondItemTotalMaxSize += e._dragDetails.secondItem[_a610]._sizeLimits[e._measurements.maxDimension];
      }

      t && (e._dragDetails.secondItemTotalMaxSize = 0);
    }
  }, {
    key: "_validateBarsSize",
    value: function _validateBarsSize() {
      var e = this;
      if ("100%" !== (getComputedStyle(e).getPropertyValue("--smart-splitter-bar-fit-size") + "").trim()) return;
      var t = e._items[0];
      var a = "offset" + e._measurements.restricredDimension,
          i = e.bars;

      if (0 !== i.length) {
        for (var _n462 = 0; _n462 < e._items.length; _n462++) {
          e._items[_n462][a] > t[a] && (t = e._items[_n462]);
        }

        t && (t[a] === i[0][a] || i.map(function (i) {
          return i.style[e._measurements.restricredDimension.toLowerCase()] = t[a] + "px";
        }));
      }
    }
  }, {
    key: "_validateItemSize",
    value: function _validateItemSize(e) {
      var t = this;

      if ("overflow" !== t.autoFitMode) {
        if (t.keepProportionsOnResize && t._resizeEventFired) t._keepItemProportionsOnResize();else {
          var _i925 = 0,
              _a611 = 0;
          t._items.map(function (e) {
            return _i925 += e.collapsed ? 0 : e.style[t._measurements.dimension] && -1 > e.style[t._measurements.dimension].indexOf("%") && e._sizeBeforeCollapse ? e._sizeBeforeCollapse : e.getBoundingClientRect()[t._measurements.dimension];
          }), t.bars.map(function (e) {
            return _a611 += e[t._measurements.size];
          });

          var _n463 = _i925 + _a611 - t.$.container.getBoundingClientRect()[t._measurements.dimension];

          0 < _n463 ? t._validateItemsSizeOverflowing(_n463, e) : t._validateItemsSizeUnderflowing(_n463, e);
        }

        if (t._autoFitItems(), t._validateBarsSize(), t._splitterSize = t[t._measurements.size], t.enableShadowDOM) {
          var _e1109 = t.getRootNode().host;
          _e1109 && _e1109.enableShadowDOM && _e1109.isCompleted && _e1109._validateItemSize && _e1109._validateItemSize();
        }
      }
    }
  }, {
    key: "_validateNeighbourSizeLimits",
    value: function _validateNeighbourSizeLimits(e) {
      function t(e) {
        e && (e.min && e._setSize("min", e.min, !0), e.max && e._setSize("max", e.max, !0));
      }

      var i = this;

      if (i._items && i._items.length) {
        i._noNeighbourValidation = !0;

        var _a612 = i._items.indexOf(e);

        t(i._items[_a612 - 1]), t(i._items[_a612 + 1]), delete i._noNeighbourValidation;
      }
    }
  }, {
    key: "_keepItemProportionsOnResize",
    value: function _keepItemProportionsOnResize() {
      var e = this;
      var t = 0,
          a = 0,
          n = [];
      e.bars.map(function (i) {
        return t += i[e._measurements.size];
      });

      for (var _t936 = 0; _t936 < e._items.length; _t936++) {
        e._items[_t936].collapsed || (n.push(e._items[_t936]), a += e._items[_t936]._sizeBeforeCollapse || e._items[_t936][e._measurements.size]);
      }

      e._splitterSize && (a = e._splitterSize);
      var o = e[e._measurements.size];

      for (var _t937 = 0; _t937 < n.length; _t937++) {
        -1 < n[_t937].style[e._measurements.dimension].indexOf("%") || (n[_t937].style[e._measurements.dimension] = (n[_t937]._sizeBeforeCollapse = (n[_t937]._sizeBeforeCollapse || n[_t937][e._measurements.size]) / a * o) + "px");
      }
    }
  }, {
    key: "_validateItemsSizeOverflowing",
    value: function _validateItemsSizeOverflowing(e, t) {
      var a = Math.max;
      var n = this,
          o = n._items.length;
      var r = 0,
          l = [],
          s = n.$.container.getBoundingClientRect(),
          d,
          c,
          m,
          i;

      for (var _a613 = 0; _a613 < n._items.length; _a613++) {
        m = n._items[_a613].style[n._measurements.dimension], c = -1 < m.indexOf("%") ? m : n._items[_a613][n._measurements.size], m || n._items[_a613].size || 0 === n._items[_a613].size || delete n._items[_a613]._originalSize, n._items[_a613]._originalSize = n._items[_a613]._originalSize ? n._items[_a613]._originalSize : c, l.push(n._items[_a613].locked);
      }

      0 > l.indexOf(!1) && (i = n._items[n._items.length - 1], i.locked = !1);

      for (var _l140 = o - 1; 0 <= _l140; _l140--) {
        if (!(n._items[_l140].collapsed || n._items[_l140].locked)) {
          if (-1 < (n._items[_l140]._originalSize + "").indexOf("%")) {
            n._items[_l140].style[n._measurements.dimension] = n._items[_l140]._originalSize, n._items[_l140]._sizeBeforeCollapse = s[n._measurements.dimension] * parseFloat(n._items[_l140]._originalSize) / 100;
            continue;
          }

          0 !== e && (d = n._items[_l140].getBoundingClientRect()[n._measurements.dimension], r = d - e, n._items[_l140].style[n._measurements.dimension] = (n._items[_l140]._sizeBeforeCollapse = a(n._items[_l140]._sizeLimits ? n._items[_l140]._sizeLimits[n._measurements.minDimension] : 0, r)) + "px", e -= d - n._items[_l140]._sizeBeforeCollapse);
        }
      }

      if (0 < e) for (var _l141 = o - 1; 0 <= _l141; _l141--) {
        if (n._items[_l141].collapsed) continue;
        d = n._items[_l141].getBoundingClientRect()[n._measurements.dimension], r = d - e;

        var _i926 = n._items[_l141]._sizeLimits[n._measurements.minDimension] || n._items[_l141].min;

        (_i926 && (_i926 = -1 < (_i926 + "").indexOf("%") ? parseFloat(_i926) / 100 * n._items[_l141].parentElement[n._measurements.size] : parseFloat(_i926), _i926 > r && (n._items[_l141]._sizeLimits.ignoreUpdate = !t, n._items[_l141].style[n._measurements.minDimension] = a(0, r) + "px")), !(n._items[_l141]._originalSize && -1 < (n._items[_l141]._originalSize + "").indexOf("%"))) && (n._items[_l141]._sizeLimits.ignoreUpdate = !t, n._items[_l141].style[n._measurements.dimension] = (n._items[_l141]._sizeBeforeCollapse = a(0, r)) + "px", e -= d - n._items[_l141]._sizeBeforeCollapse);
      }
      i && (i.locked = !0);
    }
  }, {
    key: "_validateItemsSizeUnderflowing",
    value: function _validateItemsSizeUnderflowing(e, t) {
      var a = Math.min,
          n = Math.max;
      var o = this,
          r = o._items.length;
      var l = 0,
          s,
          i;
      e = Math.abs(e), 0 < o._items.length && 0 > o._items.map(function (e) {
        return e.locked;
      }).indexOf(!1) && (i = o._items[o._items.length - 1], i.locked = !1);

      for (var _d33 = 0; _d33 < r && !(!(o._items[_d33].collapsed || o._items[_d33][o._measurements.size] >= (o._items[_d33]._sizeLimits ? o._items[_d33]._sizeLimits[o._measurements.minDimension] : 0)) && (s = o._items[_d33][o._measurements.size], l = o._items[_d33][o._measurements.size] + e, o._items[_d33][o._measurements.size] < o._items[_d33]._sizeLimits[o._measurements.minDimension] && (o._items[_d33]._sizeLimits.ignoreUpdate = !t, o._items[_d33].style[o._measurements.minDimension] = (o._items[_d33]._sizeBeforeCollapse = n(0, a(o._items[_d33]._sizeLimits[o._measurements.minDimension], l))) + "px"), e -= (o._items[_d33]._sizeBeforeCollapse || o._items[_d33][o._measurements.size]) - s, 0 >= e)); _d33++) {
        ;
      }

      var d = o.$.container.getBoundingClientRect()[o._measurements.dimension];

      if (0 < e) for (var _t938 = 0; _t938 < r; _t938++) {
        if (!(o._items[_t938].collapsed || o._items[_t938].locked) && void 0 !== o._items[_t938]._originalSize) {
          if (-1 < (o._items[_t938]._originalSize + "").indexOf("%")) o._items[_t938].style[o._measurements.dimension] = o._items[_t938]._originalSize, o._items[_t938]._sizeBeforeCollapse = parseFloat(o._items[_t938]._originalSize) * d / 100;else if (o._items[_t938][o._measurements.size] >= o._items[_t938]._originalSize) e += o._items[_t938][o._measurements.size] - o._items[_t938]._originalSize, o._items[_t938].style[o._measurements.dimension] = (o._items[_t938]._sizeBeforeCollapse = o._items[_t938]._originalSize) + "px";else {
            l = a(o._items[_t938]._originalSize, o._items[_t938][o._measurements.size] + e);

            var _i927 = l - o._items[_t938][o._measurements.size];

            o._items[_t938][o._measurements.minDimension] < o._items[_t938]._sizeLimits[o._measurements.minDimension] && (o._items[_t938].style[o._measurements.minDimension] = a(o._items[_t938]._sizeLimits[o._measurements.minDimension], l) + "px"), o._items[_t938].style[o._measurements.dimension] = (o._items[_t938]._sizeBeforeCollapse = n(0, a(l, o._items[_t938]._originalSize))) + "px", e -= _i927;
          }
          if (0 >= e) break;
        }
      }
      i && (i.locked = !0);
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      var e = this,
          t = Smart.EnableShadowDOM;
      return e._isInShadowDOM ? !e._isInShadowDOM : e.isCompleted ? null !== e.shadowRoot : t;
    }
  }, {
    key: "items",
    get: function get() {
      var e = this;

      if (e.isReady) {
        var _t939 = e.$.container.children;
        var _a614 = [];

        for (var _e1110 = 0; _e1110 < _t939.length; _e1110++) {
          (_t939[_e1110] instanceof Smart.SplitterItem || "Smart-SPLITTER-ITEM" === _t939[_e1110].tagName) && _a614.push(_t939[_e1110]);
        }

        return _a614;
      }
    }
  }, {
    key: "hasStyleObserver",
    get: function get() {
      return "resize";
    }
  }, {
    key: "bars",
    get: function get() {
      var e = this;

      if (e.isReady) {
        var _t940 = e.$.container.children;
        var _a615 = [];

        for (var _e1111 = 0; _e1111 < _t940.length; _e1111++) {
          (_t940[_e1111] instanceof Smart.SplitterBar || "Smart-SPLITTER-BAR" === _t940[_e1111].tagName) && _a615.push(_t940[_e1111]);
        }

        return _a615;
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoFitMode: {
          allowedValues: ["end", "proportional", "overflow"],
          value: "proportional",
          type: "string"
        },
        dataSource: {
          value: null,
          type: "object?",
          reflectToAttribute: !1
        },
        orientation: {
          allowedValues: ["horizontal", "vertical"],
          value: "vertical",
          type: "string"
        },
        keepProportionsOnResize: {
          value: !1,
          type: "boolean"
        },
        resizeMode: {
          allowedValues: ["none", "adjacent", "end", "proportional"],
          value: "adjacent",
          type: "string"
        },
        resizeStep: {
          value: 5,
          type: "number"
        },
        liveResize: {
          value: !1,
          type: "boolean"
        },
        messages: {
          extend: !0,
          value: {
            en: {
              invalidIndex: "{{elementType}}: \"{{method}}\" method accepts an index of type number.",
              indexOutOfBound: "{{elementType}}: Out of bound index/indexes in \"{{method}}\" method.",
              invalidNode: "{{elementType}}: \"{{method}}\" method accepts an object or an array of objects as it's second parameter.",
              invalidSettings: "{{elementType}}: \"{{method}}\" method accepts a string or an object as it's second parameter.",
              invalidType: "{{elementType}}: \"{{propertyName}}\" must be of type string or number."
            }
          },
          type: "object"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        focus: "_focusHandler",
        blur: "_focusHandler",
        down: "_downHandler",
        move: "_moveHandler",
        "document.dragstart": "_dragStartHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler",
        keydown: "_keyDownHandler",
        resize: "_resizeEventHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.button.css", "smart.splitter.css"];
    }
  }]);

  return _class103;
}(Smart.ContentElement)), Smart("smart-tab-item",
/*#__PURE__*/
function (_Smart$ContentElement13) {
  "use strict";

  _inherits(_class104, _Smart$ContentElement13);

  function _class104() {
    _classCallCheck(this, _class104);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class104).apply(this, arguments));
  }

  _createClass(_class104, [{
    key: "attached",
    value: function attached() {
      var e = this;

      _get(_getPrototypeOf(_class104.prototype), "attached", this).call(this);

      e.isCompleted && (e.$.removeClass("right"), e.$.removeClass("left"), e.$.removeClass("top"), e.$.removeClass("bottom"), e.$.removeClass("animate"));
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class104.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      if (a._preventPropertyChangedHandler) return void delete a._preventPropertyChangedHandler;
      var n = (Smart.EnableShadowDOM && a.parentElement ? a.getRootNode().host || a : a).closest("smart-tabs"),
          o = n && n.shadowRoot ? {
        composed: !0,
        bubbles: !0,
        cancelable: !0
      } : void 0;

      switch (e) {
        case "closeButtonHidden":
          a.$.fireEvent("closeButtonVisibilityChange", {
            hidden: i
          }, o);
          break;

        case "index":
          a.$.fireEvent("indexChange", {
            newIndex: i,
            oldIndex: t,
            tabItem: a
          }, o);
          break;

        case "label":
          break;

        case "labelSize":
          a.$.fireEvent("labelSizeChange", {
            size: i
          }, o);
      }
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e1112 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1112.concat(Array.prototype.slice.call(arguments)));
      }

      t.firstElementChild.appendChild(e);
    }
  }, {
    key: "_setIndex",
    value: function _setIndex(e) {
      var t = this,
          i = t.context;
      t.context = t, t.index = e, t.context = i;
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        closeButtonHidden: {
          value: !1,
          type: "boolean"
        },
        index: {
          value: null,
          type: "number?"
        },
        selected: {
          value: !1,
          type: "boolean"
        },
        label: {
          value: "",
          type: "string"
        },
        labelSize: {
          value: null,
          type: "number?"
        }
      };
    }
  }]);

  return _class104;
}(Smart.ContentElement)), Smart("smart-tab-items-group",
/*#__PURE__*/
function (_Smart$ContentElement14) {
  "use strict";

  _inherits(_class105, _Smart$ContentElement14);

  function _class105() {
    _classCallCheck(this, _class105);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class105).apply(this, arguments));
  }

  _createClass(_class105, [{
    key: "template",
    value: function template() {
      return "";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class105.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      if (a._preventPropertyChangedHandler) return void delete a._preventPropertyChangedHandler;

      switch (e) {
        case "label":
          break;

        case "labelSize":
          this.$.fireEvent("labelSizeChange", {
            size: i
          });
      }
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        label: {
          value: "",
          type: "string"
        },
        labelSize: {
          value: null,
          type: "number?"
        }
      };
    }
  }]);

  return _class105;
}(Smart.ContentElement)), Smart("smart-tabs",
/*#__PURE__*/
function (_Smart$BaseElement27) {
  "use strict";

  _inherits(_class106, _Smart$BaseElement27);

  function _class106() {
    _classCallCheck(this, _class106);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class106).apply(this, arguments));
  }

  _createClass(_class106, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"tabsHeaderSection\" class=\"smart-header smart-tabs-header-section\">\n                        <div id=\"tabsHeaderItems\" class=\"smart-tabs-header-items\">\n                            <smart-repeat-button id=\"scrollButtonNear\" class=\"smart-tabs-scroll-button smart-nav-button smart-spin-button smart-hidden\" animation=\"[[animation]]\" unfocusable>\n                                <div id=\"arrowNear\" class=\"smart-arrow\"></div>\n                            </smart-repeat-button>\n                            <div id=\"tabStrip\" class=\"smart-tab-strip\"></div>\n                            <smart-repeat-button id=\"scrollButtonFar\" class=\"smart-tabs-scroll-button smart-nav-button smart-spin-button smart-hidden\" animation=\"[[animation]]\" unfocusable>\n                                <div id=\"arrowFar\" class=\"smart-arrow\"></div>\n                            </smart-repeat-button>\n                            <div id=\"dropDownButton\" class=\"smart-drop-down-button\">\n                                <div id=\"dropDownButtonArrow\" class=\"smart-drop-down-button-arrow smart-unselectable\"></div>\n                            </div>\n                            <span id=\"tabSelectionBar\" class=\"smart-tabs-selection-bar\"></span>\n                            <div id=\"resizeToken\" class=\"smart-tabs-resize-token smart-hidden\"></div>\n                        </div>\n                        <div id=\"tabHeaderControls\" class=\"smart-tabs-header-controls\"></div>\n                    </div>\n                    <div id=\"tabContentSection\" class=\"smart-tabs-content-section\">\n                       <content></content>\n                    </div>\n                    <div id=\"dropDownButtonDropDown\" class=\"smart-drop-down-button-drop-down smart-hidden\"></div>\n                    <input id=\"hiddenInput\" type=\"hidden\" name=\"[[name]]\">\n                </div>";
    }
  }, {
    key: "attached",
    value: function attached() {
      var e = this;

      _get(_getPrototypeOf(_class106.prototype), "attached", this).call(this);

      e.isCompleted && e.isRendered && e._applyTabOverflow();
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class106.prototype), "ready", this).call(this);

      var e = this;
      e._flexWritingModeNoFullSupport = !0;
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e._createElement(), _get(_getPrototypeOf(_class106.prototype), "render", this).call(this);
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1113 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1113.concat(Array.prototype.slice.call(arguments)));
      }

      e instanceof Smart.TabItem || t.error(t.localize("tabItemRequired", {
        method: "appendChild"
      })), t.isRendered ? t.insert(t._tabs.length, {
        node: e
      }) : t.whenRendered(function () {
        return t.insert(t._tabs.length, {
          node: e
        });
      });
    }
  }, {
    key: "collapse",
    value: function collapse() {
      var e = this;
      !e.collapsible || e.collapsed || (e.collapsed = !0);
    }
  }, {
    key: "ensureVisible",
    value: function ensureVisible(e) {
      var t = Math.round;
      var i = this;

      if (null !== e && "wrap" !== i.tabLayout && "shrink" !== i.tabLayout && "hidden" !== i.tabPosition) {
        i._validateIndex(e, "ensureVisible"), e = Math.max(0, Math.min(e, i._tabs.length - 1));

        var _a616 = i._tabs[e].group,
            _n464 = i.$.tabStrip,
            _o332 = _n464.getBoundingClientRect(),
            _r208 = null === _a616 ? i._tabLabelContainers[e] : i._groupLabels[i._groups.indexOf(_a616)],
            _l142 = _r208.getBoundingClientRect();

        ("top" === i.tabPosition || "bottom" === i.tabPosition) && (_o332.left > _l142.left || _o332.right < _l142.right) ? _n464.scrollLeft += t(_l142.right - _n464.offsetWidth - _o332.left) : ("left" === i.tabPosition || "right" === i.tabPosition) && (_o332.top > _l142.top || _o332.bottom < _l142.bottom) && (_n464.scrollTop += t(_l142.bottom - _n464.offsetHeight - _o332.top)), i._updateScrollButtonVisibility(), i.resize && i._getTabCoordinates();
      }
    }
  }, {
    key: "expand",
    value: function expand() {
      var e = this;
      e.collapsible && e.collapsed && (e.collapsed = !1);
    }
  }, {
    key: "getOffsetFromEdgeOfElement",
    value: function getOffsetFromEdgeOfElement(e) {
      var t = this;
      t._validateIndex(e, "getOffsetFromEdgeOfElement"), e = Math.max(0, Math.min(e, t._tabs.length - 1));
      var i = t._tabs[e],
          a = t.tabPosition;
      return "hidden" === a ? i.getBoundingClientRect().top - t.getBoundingClientRect().top : Math.abs(i.getBoundingClientRect()[a] - t.getBoundingClientRect()[a]);
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      var i = this;
      var a, n;
      if (i._validateIndex(e, "insert"), (void 0 === t || void 0 === t.label && void 0 === t.content && void 0 === t.node) && i.error(i.localize("detailsObjectRequired")), void 0 === t.node) a = t.group, n = document.createElement("smart-tab-item"), n.label = void 0 === t.label ? "" : t.label, n.labelSize = void 0 === t.labelSize ? null : t.labelSize, n.content = t.content;else if (n = t.node, void 0 !== n.index && null !== n.index) {
        var _e1114 = n.context;
        n.context = n, n.index = null, n.context = _e1114;
      }
      n.$.addClass("smart-visibility-hidden"), n.group = null;

      var o = i._addTabLabelContainer(n),
          r = o.tabLabelContainer,
          l = o.dropDownLabelContainer;

      r.tab = n, n.tabLabelContainer = r;
      var s = {
        index: e,
        tab: n,
        tabLabelContainer: r,
        dropDownLabelContainer: l
      };
      if (0 === i._groups.length && void 0 === a) i._insertNoGrouping(s);else if (void 0 !== a && null !== a) {
        s.group = a;

        var _e1115 = i.$.tabContentSection.querySelector("smart-tab-items-group[label=\"" + a + "\"]");

        null === _e1115 ? i._insertIntoNewGroup(s) : (s.smartTabItemsGroup = _e1115, i._insertIntoExistingGroup(s));
      } else i._insertNearAGroup(s);
      i._getReorderItems(), null === i.selectedIndex && !i.allowToggle && i._tabs.length && i._select(0, !0), null !== n.group && null !== n.labelSize && "shrink" !== i.tabLayout && r.style.removeProperty([i._orientationSettings.dimension]), i._applyTabOverflow();
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      var i = this;

      if (!i.isCompleted) {
        var _e1116 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(i, _e1116.concat(Array.prototype.slice.call(arguments)));
      }

      e instanceof Smart.TabItem && (t === void 0 || null === t || t instanceof Smart.TabItem) || i.error(i.localize("tabItemRequired", {
        method: "insertBefore"
      }));
      var a;
      i.contains(e) && (e.selected && (a = !0), i.remove(e.index)), t !== void 0 && null !== t ? (!i.contains(t) && i.error(i.localize("referenceNodeNotChild", {
        argument: "referenceNode"
      })), i.insert(t.index, {
        node: e
      })) : i.insert(i._tabs.length, {
        node: e
      }), a && i._select(e.index, !1);
    }
  }, {
    key: "refreshTabHeader",
    value: function refreshTabHeader() {
      var e = this;
      "scroll" === e.tabLayout && e._checkOverflowScroll(), e._positionTabSelectionBar(e._tabLabelContainers ? e._tabLabelContainers[e.selectedIndex] : void 0, !0);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this,
          i = t._tabs.length;

      if (0 !== i) {
        t._validateIndex(e, "remove"), e = Math.max(0, Math.min(e, i - 1));
        var _a617 = t._tabs[e],
            _n465 = t._tabLabelContainers[e];

        if (_n465._lazyRemove ? _n465.classList.add("smart-hidden") : _n465.parentElement.removeChild(_n465), _a617.parentElement.removeChild(_a617), null !== _a617.group) {
          var _e1117 = t.$.tabContentSection.querySelector("smart-tab-items-group[label=\"" + _a617.group + "\"]");

          if (0 === _e1117.childElementCount) {
            var _i928 = t._groups.indexOf(_a617.group);

            t.$.tabStrip.removeChild(t._groupLabels[_i928]), t._groups.splice(_i928, 1), t.$.container.removeChild(t._groupLabels[0].dropDown), t._groupLabels.splice(_i928, 1), t.$.tabContentSection.removeChild(_e1117);
          }
        }

        1 < i ? e < t.selectedIndex ? t.selectedIndex-- : e === t.selectedIndex && (e === i - 1 ? t._select(e - 1, !1) : (t._select(e + 1, !1), t.selectedIndex--)) : (t.selectedIndex = null, t.$.tabContentSection.innerHTML = ""), t._tabLabelContainers.splice(e, 1), t.$.dropDownButtonDropDown.removeChild(t.$.dropDownButtonDropDown.children[e]), t._tabs.splice(e, 1), t._focusedItem === _a617 && (t._focusedItem = t._tabs[t._focusedItem.index]), t._updateTabIndexes(), t._getReorderItems(), t._applyTabOverflow(), t.ensureVisible(t.selectedIndex), t.$.hiddenInput.value = t.selectedIndex;
      }
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1118 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e1118.concat(Array.prototype.slice.call(arguments)));
      }

      e instanceof Smart.TabItem || t.error(t.localize("tabItemRequired", {
        method: "removeChild"
      })), t.contains(e) || t.error(t.localize("referenceNodeNotChild", {
        argument: "node"
      })), t.remove(e.index);
    }
  }, {
    key: "select",
    value: function select(e) {
      var t = this;
      0 === t._tabs.length || (t._validateIndex(e, "select"), e = Math.max(0, Math.min(e, t._tabs.length - 1)), t.ensureVisible(e), t._select(e, !0));
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      return e.disabled || e.unfocusable ? void e.removeAttribute("tabindex") : void ((null === e.getAttribute("tabindex") || 0 > e.getAttribute("tabindex")) && e.setAttribute("tabindex", 0));
    }
  }, {
    key: "update",
    value: function update(e, t, i) {
      var a = this;

      if (0 !== a._tabs.length) {
        a._validateIndex(e, "update"), e = Math.max(0, Math.min(e, a._tabs.length - 1));
        var _n466 = a._tabs[e];

        if (void 0 !== t && _n466.label !== t) {
          var _i929 = a._tabLabelContainers[e].firstElementChild.children[0],
              _o333 = a.$.dropDownButtonDropDown.children[e];
          _n466.label = t, _i929.innerHTML = "", _o333.innerHTML = "", a._setLabel(t, _i929, _o333), a._applyTabOverflow();
        }

        void 0 !== i && (_n466.content = i);
      }
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.disabled && (e.$.scrollButtonNear.disabled = !0, e.$.scrollButtonFar.disabled = !0), e._handlePosition(e.tabPosition), e._handleScrollButtonsPosition(e.scrollButtonsPosition, "both"), null !== e.dataSource && e._processDataSource(), e._setFocusable(), e.collapsed && !e.collapsible && (e.collapsed = !1), e.collapsible && e.allowToggle && (e.allowToggle = !1), e._processHTML(), null === e.selectedIndex && e.$.tabContentSection.setAttribute("show-placeholder", ""), setTimeout(function () {
        return e.refreshTabHeader();
      }, 300), e.$.hiddenInput.value = e.selectedIndex, e.enableShadowDOM && HTMLElement.prototype.appendChild.apply(e, [e.$.hiddenInput]);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class106.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      switch (e) {
        case "addNewTab":
          i ? a._insertAddNewTab() : (a.$.tabStrip.removeChild(a._addNewTab), delete a._addNewTab), a._applyTabOverflow();
          break;

        case "allowToggle":
          i && a.collapsible ? (a.collapsed && a._toggleCollapsedState(), a.collapsible = !1) : !i && null === a.selectedIndex && (a.ensureVisible(a.selectedIndex = 0), a._select(a.selectedIndex, !0, null));
          break;

        case "closeButtonMode":
          if ("selected" === i) {
            for (var _e1119 = 0; _e1119 < a._tabs.length; _e1119++) {
              a._disableCloseButton(_e1119);
            }

            a._enableCloseButton(a.selectedIndex);
          } else {
            a._disableCloseButton(a.selectedIndex);

            var _e1120 = a._tabLabelContainers;

            for (var _t941 = 0; _t941 < _e1120.length; _t941++) {
              var _i930 = _e1120[_t941];
              _i930.closeButtonEnabled = !0 !== a._tabs[_t941].closeButtonHidden, a._showCloseButton(_i930);
            }
          }

          a._applyTabOverflow();

          break;

        case "closeButtons":
          {
            var _e1121 = a._tabLabelContainers,
                _t942 = i ? a._showCloseButton : a._hideCloseButton;

            for (var _a618 = 0; _a618 < _e1121.length; _a618++) {
              var _i931 = _e1121[_a618];

              _t942(_i931);
            }

            a._applyTabOverflow();

            break;
          }

        case "collapsed":
          if (!a.collapsible && i) return void (a.collapsed = !1);
          break;

        case "collapsible":
          !i && a.collapsed && (a.collapsed = !1), a.allowToggle = !1, a.selectedIndex === void 0 && a.select(a._focusedItem.index);
          break;

        case "dataSource":
          a.selectedIndex = null;

          for (var _e1122 = 0; _e1122 < a._groupLabels.length; _e1122++) {
            a.$.container.removeChild(a._groupLabels[_e1122].dropDown);
          }

          a.$.tabStrip.innerHTML = "", a._processDataSource(), a._processHTML();
          break;

        case "disabled":
          a._setFocusable(), a.$.scrollButtonNear.disabled = i, a.$.scrollButtonFar.disabled = i, i || a._updateScrollButtonVisibility(), a._closeDropDownButtonDropDown();
          break;

        case "messages":
        case "scrollMode":
        case "selectionMode":
        case "readonly":
        case "reorder":
          break;

        case "overflow":
          if ("scroll" !== a.tabLayout) return;
          a.$.tabStrip.scrollLeft = 0, a.$.tabStrip.scrollTop = 0, "hidden" === i ? (a.$tabsHeaderSection.removeClass("scroll-buttons-shown"), a.$scrollButtonNear.addClass("smart-hidden"), a.$scrollButtonFar.addClass("smart-hidden")) : a._checkOverflowScroll(), a._getTabCoordinates();
          break;

        case "tabPosition":
          {
            a.$.tabSelectionBar.style.transition = "none", a._tabPositionChanging = !0, a._closeGroupDropDown(), a._handlePosition(i, t), "shrink" !== a.tabLayout && a._applyLabelSizes("tabPosition"), a._applyTabOverflow(), delete a._tabPositionChanging, requestAnimationFrame(function () {
              a.$.tabSelectionBar.style.transition = null;
            });
            break;
          }

        case "resize":
          i && a._getTabCoordinates();
          break;

        case "scrollButtonsPosition":
          a._handleScrollButtonsPosition(i, t);

          break;

        case "selectedIndex":
          {
            if (isNaN(i) && (a.selectedIndex = i = t), !a.allowToggle && null === i) return void (a.selectedIndex = t);
            var _e1123 = i;
            null !== i && (_e1123 = Math.max(0, Math.min(i, a._tabs.length - 1)), a.ensureVisible(_e1123)), a._select(_e1123, !0, t);
            break;
          }

        case "tabLayout":
          "scroll" === t && (a.$tabsHeaderSection.removeClass("scroll-buttons-shown"), a.$scrollButtonNear.addClass("smart-hidden"), a.$scrollButtonFar.addClass("smart-hidden")), "shrink" === i ? a._applyLabelSizes("shrink", !0) : "shrink" === t && a._applyLabelSizes("shrink", !1), a._applyTabOverflow(), "scroll" === i && a.disabled && (a.$.scrollButtonNear.disabled = !0, a.$.scrollButtonFar.disabled = !0), a.ensureVisible(a.selectedIndex);
          break;

        case "tabTextOrientation":
          a._applyTabOverflow(), a.ensureVisible(a.selectedIndex);
          break;

        case "unfocusable":
          a._setFocusable();

      }
    }
  }, {
    key: "_addGroupContainer",
    value: function _addGroupContainer(e, t) {
      var i = this,
          a = document.createElement("div"),
          n = document.createElement("div"),
          o = document.createElement("div"),
          r = document.createElement("div"),
          l = document.createElement("div");
      return a.className = "smart-tab-group-container smart-unselectable", a.$ = Smart.Utilities.Extend(a), n.className = "smart-tab-label-text-wrapper", null !== t && "shrink" !== i.tabLayout && (a.style[i._orientationSettings.dimension] = parseInt(t, 10) + "px"), o.className = "smart-tab-label-text-container", o.innerHTML = e, r.className = "smart-tab-group-arrow", l.className = "smart-tab-group-drop-down smart-hidden", l.$ = Smart.Utilities.Extend(l), n.appendChild(o), n.appendChild(r), a.appendChild(n), i.$.container.appendChild(l), a.group = e, a.dropDown = l, l.groupContainer = a, {
        label: a,
        dropDown: l
      };
    }
  }, {
    key: "_addGroupElements",
    value: function _addGroupElements(e) {
      var t = this,
          i = e.groups,
          a = e.groupLabels,
          n = e.group,
          o = i.indexOf(n),
          r = e.tabLabelContainer;
      var l;
      if (-1 !== o) l = a[o], l.dropDown.appendChild(r);else {
        i.push(n);

        var _o334 = t._addGroupContainer(n, e.smartTabItemsGroup.labelSize),
            _s103 = _o334.dropDown;

        l = _o334.label, _s103.appendChild(r), _s103.groupContainer = _o334.label, e.documentFragment.appendChild(l), a.push(l);
      }
      t.selectedIndex === e.i && (t._selectedGroup = l, l.$.addClass("smart-tab-group-selected"));
    }
  }, {
    key: "_addNewTabHandler",
    value: function _addNewTabHandler(e, t, i) {
      var a = this;
      a._swiping || (i ? (e.removeAttribute("hover"), a.insert(a._tabs.length, {
        label: "New Tab",
        content: ""
      }), a._select(a._tabs.length - 1, !0)) : !a._reordering && !a._swiping && ("mouseover" === t ? e.setAttribute("hover", "") : "mouseout" == t && e.removeAttribute("hover")));
    }
  }, {
    key: "_addTabLabelContainer",
    value: function _addTabLabelContainer(e, t) {
      var i = this,
          a = document.createElement("div"),
          n = document.createElement("div"),
          o = document.createElement("div"),
          r = document.createElement("div");
      var l;
      return a.className = "smart-tab-label-container smart-unselectable", n.className = "smart-tab-label-text-wrapper", o.className = "smart-tab-label-text-container", r.className = "smart-tab-close-button", void 0 === t ? (i.closeButtons ? "default" === i.closeButtonMode && e.closeButtonHidden || "selected" === i.closeButtonMode && !e.selected ? (r.classList.add("smart-hidden"), a.closeButtonEnabled = !1) : (o.classList.add("smart-close-button-enabled"), a.closeButtonEnabled = !0) : (r.classList.add("smart-hidden"), a.closeButtonEnabled = !0), l = document.createElement("div"), l.className = "smart-tab-label-container smart-unselectable", null === e.group && null !== e.labelSize && "shrink" !== i.tabLayout && (a.style[i._orientationSettings.dimension] = parseInt(e.labelSize, 10) + "px")) : (r.classList.add("smart-hidden"), a.closeButtonEnabled = !1), i._setLabel(e ? e.label : "+", o, l), o.$ = Smart.Utilities.Extend(o), r.$ = Smart.Utilities.Extend(r), n.appendChild(o), n.appendChild(r), a.appendChild(n), a.$ = Smart.Utilities.Extend(a), {
        tabLabelContainer: a,
        dropDownLabelContainer: l
      };
    }
  }, {
    key: "_animateSelection",
    value: function _animateSelection(e, t, i) {
      var a = this;
      var n = "right",
          o = "left";

      if (a._animatedTab = e, a._animatedOldTab = t, a._animatedTab && a._animatedOldTab) {
        ("left" === a.tabPosition || "right" === a.tabPosition) && (n = "top", o = "bottom");

        for (var _e1124 = 0; _e1124 < a._tabs.length; _e1124++) {
          a._tabs[_e1124].$.removeClass(n), a._tabs[_e1124].$.removeClass(o), a._tabs[_e1124].$.removeClass("animate");
        }

        return e === t ? (e.$.hasClass("smart-visibility-hidden") ? e.$.removeClass("smart-visibility-hidden") : e.$.addClass("smart-visibility-hidden"), void (a._animatedOldTab.classToRemove = n)) : void (i ? (e.$.addClass(n), e.$.removeClass("smart-visibility-hidden"), t.$.addClass("animate"), e.$.addClass("animate"), t.$.addClass(o), t.$.addClass("smart-visibility-hidden"), e.$.removeClass(n), a._animatedOldTab.classToRemove = o) : (e.$.addClass(o), e.$.removeClass("smart-visibility-hidden"), t.$.addClass("animate"), e.$.addClass("animate"), t.$.addClass(n), t.$.addClass("smart-visibility-hidden"), e.$.removeClass(o), a._animatedOldTab.classToRemove = n));
      }
    }
  }, {
    key: "_applyConditionalTabOverflow",
    value: function _applyConditionalTabOverflow() {
      var e = this,
          t = "left" === e.tabPosition || "right" === e.tabPosition,
          i = e.$.tabStrip;
      if ("scroll" === e.tabLayout) return void e._checkOverflowScroll();

      if (e._flexWritingModeNoFullSupport && "shrink" === e.tabLayout && t && i.scrollHeight > i.offsetHeight) {
        var _t943 = i.children,
            _a619 = 100 / _t943.length + "%";

        i.$.addClass("shrink-tabs-vertical");

        for (var _e1125 = 0; _e1125 < _t943.length; _e1125++) {
          _t943[_e1125].style.height = _a619, _t943[_e1125].firstElementChild.firstElementChild.classList.add("smart-tab-label-text-container-full-height");
        }

        e._inlineStyleTabStripChildren = !0;
      }
    }
  }, {
    key: "_applyLabelSizes",
    value: function _applyLabelSizes(e, t) {
      var a = this,
          n = a._orientationSettings.dimension,
          o = "width" === n ? "height" : "width";

      for (var _r209 = 0; _r209 < a._reorderItems.length; _r209++) {
        var _i932 = a._reorderItems[_r209],
            _l143 = a._getCorrespondingCustomElement(_i932);

        null !== _l143.labelSize && ("tabPosition" === e && _i932.style.removeProperty(o), t ? _i932.style.removeProperty(n) : _i932.style[n] = parseInt(_l143.labelSize, 10) + "px");
      }
    }
  }, {
    key: "_applyTabOverflow",
    value: function _applyTabOverflow() {
      var e = Math.max;
      var t = this;

      if (t._tabs) {
        if (t._removeInlineStyle(), 0 === t._tabs.length) return void t._toggleNavigationElementsVisibility();

        var _i933 = t.tabLayout,
            _a620 = t.tabPosition,
            _n467 = "left" === _a620 || "right" === _a620,
            _o335 = t.$.tabStrip;

        switch (t._closeDropDownButtonDropDown(), _i933) {
          case "scroll":
          case "dropDown":
            t._flexWritingModeNoFullSupport && "vertical" === t.tabTextOrientation && _n467 && t._fixTabStripNotChrome(_o335);
            break;

          case "wrap":
            if ("vertical" !== t.tabTextOrientation) _n467 && _o335.scrollWidth > _o335.offsetWidth && (_o335.style.width = _o335.scrollWidth + "px", "right" === _a620 && (_o335.style.flexWrap = "wrap-reverse"), t._inlineStyleTabStrip = !0);else if (!t._flexWritingModeNoFullSupport) _n467 || _o335.scrollHeight > _o335.offsetHeight && (_o335.style.height = _o335.scrollHeight + "px", t._inlineStyleTabStrip = !0);else if (_n467) t._fixTabStripNotChrome(_o335);else {
              var _a621 = _o335.children;
              var _n468 = _a621[0].offsetHeight;

              for (var _t944 = 1; _t944 < _a621.length; _t944++) {
                _n468 = e(_n468, _a621[_t944].offsetHeight);
              }

              for (var _e1126 = 1; _e1126 < _a621.length; _e1126++) {
                _a621[_e1126].style.height = _n468 + "px";
              }

              t._inlineStyleTabStripChildren = !0;
            }
            break;

          case "shrink":
            if (!_n467) _o335.scrollWidth > _o335.offsetWidth && _o335.$.addClass("shrink-tabs");else if (t._flexWritingModeNoFullSupport && "vertical" === t.tabTextOrientation) {
              var _a622 = _o335.children,
                  _i934 = window.getComputedStyle(_a622[0].firstElementChild),
                  _n469 = parseInt(_i934.paddingLeft, 10) + parseInt(_i934.paddingRight, 10);

              var _r210 = 0;

              for (var _t945 = 0; _t945 < _a622.length; _t945++) {
                _r210 = e(_r210, _a622[_t945].firstElementChild.firstElementChild.offsetWidth);
              }

              _o335.style.width = _n469 + _r210 + "px", t._inlineStyleTabStrip = !0;
              break;
            }
        }

        t._applyConditionalTabOverflow(), t._getTabCoordinates(), t._fixTabStripFlex(_i933), t._toggleNavigationElementsVisibility(), t._positionTabSelectionBar(t._tabLabelContainers[t.selectedIndex], !0);
      }
    }
  }, {
    key: "_checkOverflowScroll",
    value: function _checkOverflowScroll() {
      var e = Math.round;
      var t = this,
          i = t.$tabsHeaderSection,
          a = t.$.tabStrip,
          n = t.overflow;
      if ("hidden" === n) return;
      var o, r, l;
      "left" === t.tabPosition || "right" === t.tabPosition ? (o = e(a.scrollHeight) > e(a.offsetHeight), r = 0 < e(a.scrollTop), l = e(a.offsetHeight + a.scrollTop) < e(a.scrollHeight)) : (o = e(a.scrollWidth) > e(a.offsetWidth), r = 0 < e(a.scrollLeft), l = e(a.offsetWidth + a.scrollLeft) < e(a.scrollWidth)), "scroll" === n && (i.addClass("scroll-buttons-shown"), t.$scrollButtonNear.removeClass("smart-hidden"), t.$scrollButtonFar.removeClass("smart-hidden")), o ? "auto" === n ? (!i.hasClass("scroll-buttons-shown") && i.addClass("scroll-buttons-shown"), r ? t.$scrollButtonNear.removeClass("smart-hidden") : t.$scrollButtonNear.addClass("smart-hidden"), l ? t.$scrollButtonFar.removeClass("smart-hidden") : t.$scrollButtonFar.addClass("smart-hidden"), !1 === (r && l) ? i.addClass("one-button-shown") : i.removeClass("one-button-shown"), !t.disabled && (t.$.scrollButtonNear.disabled = !1, t.$.scrollButtonFar.disabled = !1)) : (i.removeClass("one-button-shown"), t.disabled ? (t.$.scrollButtonNear.disabled = !0, t.$.scrollButtonFar.disabled = !0) : (t.$.scrollButtonNear.disabled = !r, t.$.scrollButtonFar.disabled = !l)) : !o && "auto" === n && i.hasClass("scroll-buttons-shown") ? (i.removeClass("scroll-buttons-shown"), i.removeClass("one-button-shown"), t.$scrollButtonNear.addClass("smart-hidden"), t.$scrollButtonFar.addClass("smart-hidden")) : !o && "scroll" === n && (t.$.scrollButtonNear.disabled = !0, t.$.scrollButtonFar.disabled = !0);
    }
  }, {
    key: "_closeButtonVisibilityChangeHandler",
    value: function _closeButtonVisibilityChangeHandler(e) {
      var t = this,
          i = (Smart.EnableShadowDOM ? e.composedPath()[0] : e.target).index;
      return "selected" === t.closeButtonMode ? void (t._tabLabelContainers[i].closeButtonEnabled = e.detail.hidden) : void (e.detail.hidden ? t._disableCloseButton(i) : t._enableCloseButton(i));
    }
  }, {
    key: "_closeDropDownButtonDropDown",
    value: function _closeDropDownButtonDropDown() {
      var e = this;
      e._dropDownButtonDropDownOpened && (e.$dropDownButtonDropDown.addClass("smart-hidden"), e._dropDownButtonDropDownOpened = !1);
    }
  }, {
    key: "_closeGroupDropDown",
    value: function _closeGroupDropDown() {
      var e = this;
      e._openDropDown && (e._openDropDown.rippleInProgress ? setTimeout(function () {
        e._openDropDown && (e._openDropDown.$.addClass("smart-hidden"), delete e._openDropDown.rippleInProgress, e._openDropDown = void 0);
      }, 450) : (e._openDropDown.$.addClass("smart-hidden"), e._openDropDown = void 0));
    }
  }, {
    key: "_containerHandler",
    value: function _containerHandler(e) {
      var t = this,
          i = e.type;

      if (!(t.disabled || t.readonly || t._resizing && "mouseout" !== i || ("down" === i || "up" === i) && 1 !== e.which && !Smart.Utilities.Core.isMobile)) {
        var _i935 = t.shadowRoot || t.isInShadowDOM ? (e.originalEvent || e).composedPath()[0] : (e.originalEvent || e).target;

        return t.$.tabContentSection.contains(_i935) ? void 0 : t.$.dropDownButton.contains(_i935) ? void t._dropDownButtonHandler(_i935, e) : t.$.dropDownButtonDropDown.contains(_i935) ? void t._dropDownButtonHandler(_i935, e, !0) : void t._tabStripHandler(_i935, e);
      }
    }
  }, {
    key: "_disableCloseButton",
    value: function _disableCloseButton(e) {
      var t = this,
          i = t._tabLabelContainers[e];
      i.closeButtonEnabled = !1, t.closeButtons && t._hideCloseButton(i);
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = this,
          i = t._orientationSettings;

      if (t._reordering) {
        t._reorderStartThrown || (t._fireDragEvent(e, "dragStart"), t._reorderStartThrown = !0);

        var _a623 = e[i.coordinate],
            _n470 = "wrap" === t.tabLayout ? function (t) {
          return e.pageX >= t.fromX && e.pageX <= t.toX && e.pageY >= t.fromY && e.pageY <= t.toY;
        } : function (e) {
          return _a623 >= e[i.from] && _a623 <= e[i.to];
        };

        var _o336 = !1;

        for (var _e1127 = 0; _e1127 < t._tabCoordinates.length; _e1127++) {
          var _i936 = t._tabCoordinates[_e1127];

          if (_n470(_i936)) {
            _o336 = _e1127;
            break;
          }
        }

        !0 !== t._preventReorder && !1 !== _o336 && _o336 !== t._draggedIndex && (t._reorderTabs(t._draggedIndex, _o336), t._closeGroupDropDown(), t._draggedIndex = _o336, t._getReorderItems(), t._getTabCoordinates());
        var _r211 = t._tabCoordinates[t._draggedIndex];
        t._preventReorder = !!("wrap" !== t.tabLayout && (_a623 < _r211[i.from] || _a623 > _r211[i.to]) || "wrap" === t.tabLayout && (null !== e.originalEvent.target.closest(".smart-tab-label-container") || null !== e.originalEvent.target.closest(".smart-tab-group-container")) && !(e.pageX >= _r211.fromX && e.pageX <= _r211.toX && e.pageY >= _r211.fromY && e.pageY <= _r211.toY));
      } else t._resizing && (t.$.resizeToken.style[i.edge] = e[i.coordinate] - t._tabsHeaderSectionCoordinate + "px", t.$resizeToken.removeClass("smart-hidden"));
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;
      var i = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      t.$.container.contains(i) && t._containerHandler(e), t._endSwiping(e, Date.now()), t._openDropDown && !t._openDropDown.rippleInProgress && (i === document || i.closest(".smart-tab-group-container") !== t._openDropDown.groupContainer) && t._closeGroupDropDown(), t.$.dropDownButton.contains(i) || t._closeDropDownButtonDropDown(), t._endReordering(e, i), t._resize(e), t._tabToResize !== void 0 && (t._tabToResize = void 0);
    }
  }, {
    key: "_dropDownButtonHandler",
    value: function _dropDownButtonHandler(e, t, i) {
      var a = this,
          n = t.type;
      if (i) return void (e.classList.contains("smart-tab-label-container") && ("down" === n ? a._downTarget = e : "mouseout" === n ? e.removeAttribute("hover") : "mouseover" === n ? e.setAttribute("hover", "") : "up" === n ? e === a._downTarget && (a.select(Array.from(a.$.dropDownButtonDropDown.children).indexOf(e)), a._closeDropDownButtonDropDown()) : void 0));
      if ("down" === n) a._downTarget = a.$.dropDownButton;else if ("up" === n && a._downTarget === a.$.dropDownButton) if (!a._dropDownButtonDropDownOpened) {
        var _e1128 = a.tabPosition;

        var _t946, _i937;

        "top" === _e1128 ? (_t946 = a.$.dropDownButton.offsetLeft, _i937 = a.$.tabsHeaderSection.offsetTop + a.$.dropDownButton.offsetHeight) : "bottom" === _e1128 ? (_t946 = a.$.dropDownButton.offsetLeft, _i937 = a.$.tabsHeaderSection.offsetTop) : "left" === _e1128 ? (_t946 = a.$.dropDownButton.offsetWidth, _i937 = a.$.dropDownButton.offsetTop) : "right" === _e1128 ? (_t946 = a.$.tabsHeaderSection.offsetLeft, _i937 = a.$.dropDownButton.offsetTop) : void 0, a.$.dropDownButtonDropDown.style.left = _t946 + "px", a.$.dropDownButtonDropDown.style.top = _i937 + "px", a.$dropDownButtonDropDown.removeClass("smart-hidden"), a._dropDownButtonDropDownOpened = !0;
      } else a._closeDropDownButtonDropDown();
    }
  }, {
    key: "_enableCloseButton",
    value: function _enableCloseButton(e) {
      var t = this,
          i = t._tabLabelContainers[e];
      i.closeButtonEnabled = !0, t.closeButtons && t._showCloseButton(i);
    }
  }, {
    key: "_endReordering",
    value: function _endReordering(e, t) {
      var i = this;
      i._reordering && (i._draggedHoveredTab && (!i._draggedHoveredTab.contains(t) && i._draggedHoveredTab.removeAttribute("hover"), delete i._draggedHoveredTab), i._reorderedIndex = void 0, i._reordering = !1, i._reorderStartThrown = !1, i.removeAttribute("dragged"), e && i._fireDragEvent(e, "dragEnd"));
    }
  }, {
    key: "_endSwiping",
    value: function _endSwiping(e, t) {
      var i = Math.abs;
      var a = this;
      if (!a._dragStartDetails) return;
      var n = a._orientationSettings,
          o = a.$.tabStrip,
          r = i(a._dragStartDetails.startTime - t),
          l = 200 / r,
          s = (a._dragStartDetails[n.startCoordinate] - e[n.coordinate]) * l;
      var d = i(s);

      var c = function c() {
        return !(0 < s && o[n.scrollDirection] === o[n.scrollSize] - o[n.size] || 0 > s && 0 === o[n.scrollDirection]);
      };

      var m = .03 * i(s) * l;

      var u = function u() {
        if (5 < m) {
          var _e1129 = (d - m) / i(s);

          .1 > _e1129 ? m /= 1.25 : .15 > _e1129 ? m /= 1.2 : .2 > _e1129 ? m /= 1.15 : .25 > _e1129 ? m /= 1.1 : .3 > _e1129 && (m /= 1.05);
        }

        m = Math.round(m);
        var e = o[n.scrollDirection];
        o[n.scrollDirection] = 0 < s ? Math.min(e + m, o[n.scrollSize] - o[n.size]) : Math.max(e - m, 0), d -= m, a._updateScrollButtonVisibility(!0);
        var t = c();
        0 < d && t ? a._scrollingAnimationFrame = window.requestAnimationFrame(u) : a._wheelInProgress = !1;
      };

      a._scrollingAnimationFrame && cancelAnimationFrame(a._scrollingAnimationFrame), 500 > r && c() ? a._scrollingAnimationFrame = window.requestAnimationFrame(u) : a._wheelInProgress = !1, delete a._dragStartDetails, a._swiping && delete a._swiping;
    }
  }, {
    key: "_fireDragEvent",
    value: function _fireDragEvent(e, t) {
      var i = this,
          a = i.$.tabStrip.children[i._draggedIndex],
          n = a.tab;
      var o, r, l;
      n ? (o = n.selected, r = n.index, l = n.label) : l = a.group, i.$.fireEvent(t, {
        position: {
          left: e.pageX,
          top: e.pageY
        },
        target: a,
        selected: o,
        index: r,
        label: l
      });
    }
  }, {
    key: "_fixTabStripNotChrome",
    value: function _fixTabStripNotChrome(e) {
      function t() {
        var t = [].slice.call(e.children).filter(function (e) {
          return !e._lazyRemove;
        });
        var a = t[0].getBoundingClientRect(),
            n = a.left,
            o = n + t[0].offsetWidth;

        for (var _e1130 = 1; _e1130 < t.length; _e1130++) {
          a = t[_e1130].getBoundingClientRect(), n = Math.min(n, a.left), o = Math.max(o, a.left + t[_e1130].offsetWidth);
        }

        e.style.width = o - n + "px", i._inlineStyleTabStrip = !0;
      }

      var i = this;
      0 === i._tabs.length || (t(), Smart.Utilities.Core.Browser.Safari && setTimeout(function () {
        e.parentElement.classList.add("smart-hidden"), setTimeout(function () {
          e.parentElement.classList.remove("smart-hidden"), t();
        }, 10);
      }, 10), i.$.fireEvent("tabStripResize"));
    }
  }, {
    key: "_fixTabStripFlex",
    value: function _fixTabStripFlex(e) {
      var t = this;
      t._flexWritingModeNoFullSupport || "vertical" !== t.tabTextOrientation || "left" !== t.tabPosition && "right" !== t.tabPosition || setTimeout(function () {
        t.$tabsHeaderSection.addClass("smart-hidden"), setTimeout(function () {
          t.$tabsHeaderSection.removeClass("smart-hidden"), t._getTabCoordinates(), "scroll" === e && t._checkOverflowScroll();
        }, 10);
      }, 10);
    }
  }, {
    key: "_getCorrespondingCustomElement",
    value: function _getCorrespondingCustomElement(e) {
      return e.$.hasClass("smart-tab-label-container") ? e.tab : this.$.tabContentSection.querySelector("smart-tab-items-group[label=\"" + e.group + "\"]");
    }
  }, {
    key: "_getReorderItems",
    value: function _getReorderItems() {
      var e = this;
      var t;
      0 === e._groups.length ? t = e._tabLabelContainers : (t = Array.from(e.$.tabStrip.children), e.addNewTab && t.pop()), e._reorderItems = t;
    }
  }, {
    key: "_getTabCoordinates",
    value: function _getTabCoordinates() {
      var e = this;

      if ((e.reorder || e.resize) && "hidden" !== e.tabPosition) {
        var _t947 = [],
            _a624 = window.scrollX || window.pageXOffset,
            _n471 = window.scrollY || window.pageYOffset;

        for (var _o337 = 0; _o337 < e._reorderItems.length; _o337++) {
          var _i938 = e._reorderItems[_o337],
              _r212 = _i938.getBoundingClientRect(),
              _l144 = window.getComputedStyle(_i938),
              _s104 = parseFloat(_l144.marginLeft),
              d = parseFloat(_l144.marginRight),
              c = parseFloat(_l144.marginTop),
              m = parseFloat(_l144.marginBottom);

          _t947.push({
            fromX: _r212.left - _s104 + _a624,
            toX: _r212.right + d + _a624,
            fromY: _r212.top - c + _n471,
            toY: _r212.bottom + m + _n471
          });
        }

        e._tabCoordinates = _t947;
      }
    }
  }, {
    key: "_getTabs",
    value: function _getTabs() {
      var e = this;
      var t = e.shadowRoot ? e.shadowRoot.querySelectorAll("smart-tab-item") : e.getElementsByTagName("smart-tab-item");
      null !== e.selectedIndex && (0 === t.length ? e.selectedIndex = null : e.selectedIndex = Math.max(0, Math.min(e.selectedIndex, t.length - 1))), e._tabs = Array.from(t), e.$.hiddenInput.value = e.selectedIndex;
    }
  }, {
    key: "_groupContainerHandler",
    value: function _groupContainerHandler(e, t) {
      var i = this,
          a = e.dropDown;
      if ("down" === t) return i._downTarget = e, void (i.reorder && 1 < i._reorderItems.length && (i._getTabCoordinates(), i._reordering = !0, i.setAttribute("dragged", ""), i._draggedIndex = Array.from(i.$.tabStrip.children).indexOf(e)));
      i._reordering || i._swiping || (a === i._openDropDown || "mouseover" !== t || e.classList.contains("smart-tab-group-selected") ? "mouseout" === t && e.removeAttribute("hover") : e.setAttribute("hover", ""));
      "up" !== t || i._downTarget !== e || void 0 !== i._reorderedIndex || i._swiping || (a === i._openDropDown ? (i._closeGroupDropDown(), !e.classList.contains("smart-tab-group-selected") && e.setAttribute("hover", "")) : i._openGroupDropDown(e));
    }
  }, {
    key: "_handlePosition",
    value: function _handlePosition(e, t) {
      var i = this;
      return -1 !== [void 0, "top", "left", "hidden"].indexOf(t) && ("bottom" === e || "right" === e) ? i.$.container.insertBefore(i.$.tabContentSection, i.$.tabsHeaderSection) : ("bottom" === t || "right" === t) && -1 !== ["top", "left", "hidden"].indexOf(e) && i.$.container.insertBefore(i.$.tabsHeaderSection, i.$.tabContentSection), "hidden" === e ? (i._orientationSettings = {
        coordinate: "pageY",
        dimension: "height",
        edge: "top",
        from: "fromY",
        size: "offsetHeight",
        to: "toY",
        scrollDirection: "scrollTop",
        scrollSize: "scrollHeight",
        startCoordinate: "startY",
        wheelOffset: 35
      }, i.removeAttribute("horizontal"), void i.removeAttribute("vertical")) : void ("top" === e || "bottom" === e ? (i._orientationSettings = {
        coordinate: "pageX",
        dimension: "width",
        edge: "left",
        from: "fromX",
        size: "offsetWidth",
        to: "toX",
        scrollDirection: "scrollLeft",
        scrollSize: "scrollWidth",
        startCoordinate: "startX",
        wheelOffset: 70
      }, i.removeAttribute("vertical"), i.setAttribute("horizontal", ""), i.$arrowNear.removeClass("smart-arrow-up"), i.$arrowNear.addClass("smart-arrow-left"), i.$arrowFar.removeClass("smart-arrow-down"), i.$arrowFar.addClass("smart-arrow-right")) : (i._orientationSettings = {
        coordinate: "pageY",
        dimension: "height",
        edge: "top",
        from: "fromY",
        size: "offsetHeight",
        to: "toY",
        scrollDirection: "scrollTop",
        scrollSize: "scrollHeight",
        startCoordinate: "startY",
        wheelOffset: 35
      }, i.removeAttribute("horizontal"), i.setAttribute("vertical", ""), i.$arrowNear.removeClass("smart-arrow-left"), i.$arrowNear.addClass("smart-arrow-up"), i.$arrowFar.removeClass("smart-arrow-right"), i.$arrowFar.addClass("smart-arrow-down")));
    }
  }, {
    key: "_handleScrollButtonsPosition",
    value: function _handleScrollButtonsPosition(e, t) {
      var i = this,
          a = i.$.tabsHeaderItems;
      e === t || ("both" === e ? "near" === t ? a.insertBefore(i.$.scrollButtonFar, i.$.dropDownButton) : a.insertBefore(i.$.scrollButtonNear, i.$.tabStrip) : "near" === e ? ("far" === t && a.insertBefore(i.$.scrollButtonNear, i.$.tabStrip), a.insertBefore(i.$.scrollButtonFar, i.$.tabStrip)) : ("near" === t && a.insertBefore(i.$.scrollButtonFar, i.$.dropDownButton), a.insertBefore(i.$.scrollButtonNear, i.$.scrollButtonFar)));
    }
  }, {
    key: "_hideCloseButton",
    value: function _hideCloseButton(e) {
      e.firstElementChild.children[0].$.removeClass("smart-close-button-enabled"), e.firstElementChild.children[1].$.addClass("smart-hidden");
    }
  }, {
    key: "_indexChangeHandler",
    value: function _indexChangeHandler(e) {
      var t = this,
          i = e.detail.oldIndex,
          a = Math.max(0, Math.min(e.detail.newIndex, t._tabs.length - 1));

      if (i !== a) {
        if (0 === t._groups.length) t._reorderTabs(i, a);else {
          var _n472 = e.detail.tabItem;
          _n472._setIndex(i), t.remove(i), t.insert(a, {
            node: _n472
          }), t.selectedIndex === i && t._select(a, !1);
        }
        t._reorderedIndex = void 0;
      }
    }
  }, {
    key: "_insertAddNewTab",
    value: function _insertAddNewTab() {
      var e = this,
          t = e._addTabLabelContainer(void 0, !0).tabLabelContainer;

      t.$.addClass("smart-add-new-tab"), e.$.tabStrip.appendChild(t), e._addNewTab = t;
    }
  }, {
    key: "_insertIntoExistingGroup",
    value: function _insertIntoExistingGroup(e) {
      var t = this,
          i = e.smartTabItemsGroup,
          a = e.tab,
          n = e.tabLabelContainer,
          o = e.group,
          r = t._groupLabels[t._groups.indexOf(o)],
          l = r.dropDown;

      var s = e.index;
      s = Math.max(0, Math.min(s, i.childElementCount)), l.insertBefore(n, l.children[s]);
      var d = i.children[s];
      var c;
      c = d ? d.index : i.children[s - 1].index + 1, i.insertBefore(a, d), t._tabLabelContainers.splice(c, 0, n), t.$.dropDownButtonDropDown.insertBefore(e.dropDownLabelContainer, t.$.dropDownButtonDropDown.children[c] || null), t._tabs.splice(c, 0, a), s = c, a.group = o, t._updateIndexes(s);
    }
  }, {
    key: "_insertIntoNewGroup",
    value: function _insertIntoNewGroup(e) {
      var t = this,
          i = e.tab,
          a = e.tabLabelContainer,
          n = e.group,
          o = t._addGroupContainer(n),
          r = o.label,
          l = o.dropDown;

      l.appendChild(a), t._groups.push(n);
      var s = Math.max(0, Math.min(e.index, t.$.tabStrip.childElementCount)),
          d = s;
      t._addNewTab && d === t.$.tabStrip.childElementCount && d--, t.$.tabStrip.insertBefore(r, t.$.tabStrip.children[d] || null), t._groupLabels.push(r);
      var c = document.createElement("smart-tab-items-group");
      c.appendChild(i), t.$.tabContentSection.insertBefore(c, t.$.tabContentSection.children[s]), c.label = n;
      var m = c.previousElementSibling;
      var u = 0;
      m && (m instanceof Smart.TabItem ? u = m.index + 1 : m && (u = m.lastElementChild.index + 1)), t._tabLabelContainers.splice(u, 0, a), t.$.dropDownButtonDropDown.insertBefore(e.dropDownLabelContainer, t.$.dropDownButtonDropDown.children[u] || null), t._tabs.splice(u, 0, i), s = u, i.group = n, t._updateIndexes(s);
    }
  }, {
    key: "_insertNearAGroup",
    value: function _insertNearAGroup(e) {
      var t = this,
          i = e.tab,
          a = e.tabLabelContainer;
      var n = e.index;
      n = Math.max(0, Math.min(n, t._tabs.length));
      var o = t._tabs[n - 1],
          r = t._tabs[n],
          l = r ? r.group : void 0;
      o && null !== o.group && r && null !== l ? (r.tabLabelContainer.parentElement.insertBefore(a, r.tabLabelContainer), r.parentElement.insertBefore(i, r), i.group = l) : r ? null === l ? (t.$.tabStrip.insertBefore(a, r.tabLabelContainer), t.$.tabContentSection.insertBefore(i, r)) : (t.$.tabStrip.insertBefore(a, t._groupLabels[t._groups.indexOf(l)]), t.$.tabContentSection.insertBefore(i, t.$.tabContentSection.querySelector("smart-tab-items-group[label=\"" + l + "\"]"))) : (t.$.tabStrip.insertBefore(a, t._addNewTab || null), t.$.tabContentSection.appendChild(i)), t._tabLabelContainers.splice(n, 0, a), t.$.dropDownButtonDropDown.insertBefore(e.dropDownLabelContainer, t.$.dropDownButtonDropDown.children[n] || null), t._tabs.splice(n, 0, i), t._updateIndexes(n);
    }
  }, {
    key: "_insertNoGrouping",
    value: function _insertNoGrouping(e) {
      var t = this,
          i = Math.max(0, Math.min(e.index, t._tabs.length)),
          a = e.tab,
          n = e.tabLabelContainer;
      t.$.tabStrip.insertBefore(n, t._tabLabelContainers[i] || t._addNewTab || null), t.$.tabContentSection.insertBefore(a, t._tabs[i] || null), t._tabLabelContainers.splice(i, 0, n), t.$.dropDownButtonDropDown.insertBefore(e.dropDownLabelContainer, t.$.dropDownButtonDropDown.children[i] || null), t._tabs.splice(i, 0, a), t._updateIndexes(i);
    }
  }, {
    key: "_keydownHandler",
    value: function _keydownHandler(e) {
      var t = this,
          i = e.key,
          a = t.isInShadowDOM ? t.getRootNode().activeElement : document.activeElement;
      if (a !== t || -1 === ["ArrowLeft", "ArrowDown", "ArrowRight", "ArrowUp", "End", "Home", "Enter", " ", "Escape"].indexOf(i) || t.disabled || t.readonly || "none" === t.selectionMode || !t.allowToggle && null === t.selectedIndex || t._reordering || t._swiping) return;
      e.preventDefault();
      var n = t._tabs.length - 1;
      var o = 0,
          r,
          l;

      switch (i) {
        case "ArrowLeft":
        case "ArrowUp":
          if (t.collapsible && e.ctrlKey) return void ("ArrowLeft" === i ? "right" === t.tabPosition ? t.expand() : "left" === t.tabPosition && t.collapse() : "ArrowUp" === i && ("bottom" === t.tabPosition ? t.expand() : "top" === t.tabPosition && t.collapse()));

          if (o = -1, 0 === t.selectedIndex) {
            l = !0;
            break;
          }

          r = t.selectedIndex + o;
          break;

        case "ArrowRight":
        case "ArrowDown":
          if (t.collapsible && e.ctrlKey) return void ("ArrowRight" === i ? "right" === t.tabPosition ? t.collapse() : "left" === t.tabPosition && t.expand() : "ArrowDown" === i && ("bottom" === t.tabPosition ? t.collapse() : "top" === t.tabPosition && t.expand()));

          if (o = 1, t.selectedIndex === n) {
            l = !0;
            break;
          }

          r = t.selectedIndex + o;
          break;

        case "End":
          if (t.selectedIndex === n) {
            l = !0;
            break;
          }

          r = n;
          break;

        case "Home":
          if (0 === t.selectedIndex) {
            l = !0;
            break;
          }

          r = 0;
          break;

        case "Enter":
        case " ":
          if (!t.allowToggle) return;

          if (t._focusedItem) {
            t.select(t._focusedItem.index);

            var _e1131 = t._focusedItem.tabLabelContainer.closest(".smart-tab-group-drop-down");

            _e1131 && t._openGroupDropDown(_e1131.groupContainer);
          }

          return;

        case "Escape":
          return void (t._openDropDown && t._closeGroupDropDown());
      }

      if (t.allowToggle && 0 < t._tabs.length) {
        t._focusedItem ? t._focusedItem.tabLabelContainer.removeAttribute("focus") : t._focusedItem = t._focusedItem || t._tabs[t.selectedIndex] || t._tabs[0], t._focusedItem = t._tabs[Math.min(Math.max(0, t._focusedItem.index + o), n)], t._focusedItem.tabLabelContainer.setAttribute("focus", ""), t.ensureVisible(t._focusedItem.index);

        var _e1132 = t._focusedItem.tabLabelContainer.closest(".smart-tab-group-drop-down");

        return void (_e1132 && _e1132.groupContainer ? (t._openDropDown && t._openDropDown !== _e1132.dropDown && t._closeGroupDropDown(), t._openGroupDropDown(_e1132.groupContainer)) : t._openDropDown && t._closeGroupDropDown());
      }

      l || t.select(r);
    }
  }, {
    key: "_labelContainerHandler",
    value: function _labelContainerHandler(e, t, i) {
      var a = this,
          n = "up" === i && a._downTarget === e;
      if ("down" === i && (a._downTarget = e, "click" === a.selectionMode && e !== a._addNewTab)) if (Smart.Utilities.Core.isMobile && null === e.tab.group) {
        var _i939 = a.$.tabStrip[a._orientationSettings.scrollDirection];
        setTimeout(function () {
          if (_i939 === a.$.tabStrip[a._orientationSettings.scrollDirection]) {
            var _i940 = a._ripple(t, e);

            _i940 && a._openDropDown && a._openDropDown.contains(e) && (a._openDropDown.rippleInProgress = !0);
          }
        }, 100);
      } else {
        var _i941 = a._ripple(t, e);

        _i941 && a._openDropDown && a._openDropDown.contains(e) && (a._openDropDown.rippleInProgress = !0);
      }
      if (e === a._addNewTab) return void a._addNewTabHandler(e, i, n);
      var o = e.tab.index,
          r = !(a._reordering && a._reorderedIndex !== void 0);
      n && o === a.selectedIndex && (a._closeGroupDropDown(), r && null === e.tab.group && a._toggleCollapsedState()), !a._swiping && (r && "click" === a.selectionMode && n || !a._reordering && (a.selectionMode === i || "mouseenter" === a.selectionMode && "mouseover" === i)) && a._select(o, !0), a._reordering || a._swiping || "click" !== a.selectionMode && "dblclick" !== a.selectionMode || ("mouseover" !== i || e.hasAttribute("selected") ? "mouseout" === i && e.removeAttribute("hover") : e.setAttribute("hover", "")), a.reorder && "down" === i && null === e.tab.group && 1 < a._reorderItems.length && (a._getTabCoordinates(), a._reordering = !0, a.setAttribute("dragged", ""), e.hasAttribute("hover") && (a._draggedHoveredTab = e), a._draggedIndex = 0 === a._groups.length ? e.tab.index : Array.from(a.$.tabStrip.children).indexOf(e));
    }
  }, {
    key: "_labelSizeChangeHandler",
    value: function _labelSizeChangeHandler(e) {
      var t = this,
          i = e.detail.size;
      var a;
      "shrink" === t.tabLayout || (a = e.target instanceof Smart.TabItem ? e.target.tabLabelContainer : t._groupLabels[t._groups.indexOf(e.target.label)], null === i ? a.style.removeProperty(t._orientationSettings.dimension) : a.style[t._orientationSettings.dimension] = parseInt(i, 10) + "px", t._applyTabOverflow());
    }
  }, {
    key: "_openGroupDropDown",
    value: function _openGroupDropDown(e) {
      var t = this;
      e && (t._openDropDown && t._openDropDown.$.addClass("smart-hidden"), e.dropDown.$.removeClass("smart-hidden"), t._positionGroupDropDown(e), t._openDropDown = e.dropDown, e.removeAttribute("hover"));
    }
  }, {
    key: "_orderTabs",
    value: function _orderTabs() {
      var e = this,
          t = e.getElementsByTagName("smart-tab-items-group"),
          a = [],
          n = [];
      var o = !0,
          r = !1;
      if (0 === t.length) for (var _t948 = 0; _t948 < e._tabs.length; _t948++) {
        var _i942 = e._tabs[_t948],
            _l145 = _i942.index;
        if (o && null !== _l145 && (o = !1), -1 !== a.indexOf(_l145 || 0) && (r = !0, null !== _l145)) break;
        a.push(_l145 || 0), n.push({
          tab: _i942,
          index: _l145
        });
      }

      if (!r) {
        var _e1133 = a.slice(0).sort(function (e, t) {
          return e - t;
        });

        JSON.stringify(a) === JSON.stringify(_e1133) && (o = !0);
      }

      if (!o && !r) {
        n.sort(function (e, t) {
          return e.index - t.index;
        });

        for (var _t949 = 0; _t949 < n.length; _t949++) {
          var _i943 = n[_t949].tab;
          _i943._setIndex(_t949), e.$.tabContentSection.removeChild(_i943);
        }

        for (var _t950 = 0; _t950 < n.length; _t950++) {
          var _i944 = n[_t950].tab;
          e.$.tabContentSection.appendChild(_i944), e._tabs[_t950] = _i944;
        }
      } else {
        o || e.warn(e.localize("ambiguousIndexes"));

        for (var _t951 = 0; _t951 < e._tabs.length; _t951++) {
          e._tabs[_t951]._setIndex(_t951);
        }
      }
    }
  }, {
    key: "_populateTabStrip",
    value: function _populateTabStrip() {
      var e = this,
          t = document.createDocumentFragment(),
          a = [],
          n = [],
          o = [];
      var r = null;

      for (var _l146 = 0; _l146 < e._tabs.length; _l146++) {
        var _i945 = e._tabs[_l146],
            _s105 = _i945.parentElement,
            d = _s105 instanceof Smart.TabItemsGroup ? _s105.label : null;
        _i945.group = d;

        var c = e._addTabLabelContainer(_i945),
            m = c.tabLabelContainer,
            u = c.dropDownLabelContainer;

        e.selectedIndex === _l146 && (m.$.addClass("smart-tab-selected"), m.setAttribute("selected", ""), r = m), _i945.tabLabelContainer = m, m.tab = _i945, a.push(m), null === d ? t.appendChild(m) : e._addGroupElements({
          documentFragment: t,
          groups: n,
          groupLabels: o,
          i: _l146,
          group: d,
          tabLabelContainer: m,
          smartTabItemsGroup: _s105
        }), e.$.dropDownButtonDropDown.appendChild(u);
      }

      e.$.tabStrip.appendChild(t), e._tabLabelContainers = a, e._groups = n, e._groupLabels = o, e._positionTabSelectionBar(r, !0);
    }
  }, {
    key: "_positionTabSelectionBar",
    value: function _positionTabSelectionBar(e, t) {
      function i() {
        a.$.tabSelectionBar.style.top = r, a.$.tabSelectionBar.style.height = s, a.$.tabSelectionBar.style.left = o, a.$.tabSelectionBar.style.width = l;
      }

      var a = this;
      if (!e) return;
      var n = a.tabPosition;
      var o, r, l, s;
      t && (a.$.tabSelectionBar.style.transition = "none"), e.tab.group && (e = a._groupLabels[a._groups.indexOf(e.tab.group)]), "top" === n || "bottom" === n ? ("wrap" === a.tabLayout ? (r = e.offsetTop, "top" === n && (r += e.offsetHeight - a.$.tabSelectionBar.offsetHeight), r += "px") : r = null, s = null, o = -a.$.tabStrip.scrollLeft + e.offsetLeft + "px", l = e.offsetWidth + "px") : ("left" === n || "right" === n) && ("wrap" === a.tabLayout ? (o = e.offsetLeft, "left" === n && (o += e.offsetWidth - a.$.tabSelectionBar.offsetWidth), o += "px") : o = null, l = null, r = -a.$.tabStrip.scrollTop + e.offsetTop + "px", s = e.offsetHeight + "px"), Smart.Utilities.Core.isMobile && a.hasAnimation && !t ? requestAnimationFrame(function () {
        requestAnimationFrame(i);
      }) : i(), t && !a._tabPositionChanging && requestAnimationFrame(function () {
        return a.$.tabSelectionBar.style.transition = null;
      });
    }
  }, {
    key: "_positionGroupDropDown",
    value: function _positionGroupDropDown(e) {
      var t = this,
          i = t.tabPosition,
          a = e.dropDown,
          n = window.getComputedStyle(t.$.tabsHeaderSection),
          o = parseFloat(n.paddingLeft),
          r = parseFloat(n.paddingTop);

      if ("top" === i || "bottom" === i) {
        if (a.style.left = e.offsetLeft - t.$.tabStrip.scrollLeft + o + "px", "top" === i) a.style.top = e.offsetTop + e.offsetHeight + r + "px";else {
          var _i946 = e.getBoundingClientRect().top - t.$.container.getBoundingClientRect().top + r;

          !1, a.style.top = _i946 + "px";
        }
      } else a.style.top = e.offsetTop - t.$.tabStrip.scrollTop + r + "px", a.style.left = "left" === i ? e.offsetLeft + e.offsetWidth + o + "px" : e.getBoundingClientRect().left - t.$.container.getBoundingClientRect().left + o + "px";
    }
  }, {
    key: "_processDataSource",
    value: function _processDataSource() {
      function e(t, i) {
        var a;

        if (Array.isArray(t.items) && 0 < t.items.length) {
          a = document.createElement("smart-tab-items-group");

          for (var _n473 = 0; _n473 < t.items.length; _n473++) {
            t.items[_n473].items || e(t.items[_n473], a);
          }
        } else a = document.createElement("smart-tab-item"), !0 === t.closeButtonHidden && (a.closeButtonHidden = !0), void 0 !== t.content && (a.innerHTML = t.content), void 0 !== t.index && (a.index = t.index), !0 === t.selected && (a.selected = t.selected);

        void 0 !== t.label && (a.label = t.label), void 0 !== t.labelSize && (a.labelSize = t.labelSize), i.appendChild(a);
      }

      var t = this,
          a = t.dataSource;
      if (t.$.tabContentSection.innerHTML = "", null !== a) for (var _n474 = 0; _n474 < a.length; _n474++) {
        var _i947 = a[_n474];
        e(_i947, t.$.tabContentSection);
      }
    }
  }, {
    key: "_processHTML",
    value: function _processHTML() {
      var e = this;
      e._getTabs(), e._orderTabs(), e._validateInitialSelection(), e._populateTabStrip(), e.addNewTab && e._insertAddNewTab(), e._getReorderItems(), e._applyTabOverflow(), e.ensureVisible(e.selectedIndex), e.$.hiddenInput.value = e.selectedIndex;
    }
  }, {
    key: "_removeInlineStyle",
    value: function _removeInlineStyle() {
      var e = this,
          t = e.$.tabStrip;

      if (e._inlineStyleTabStripChildren) {
        var _a625 = t.children;

        for (var _e1134 = 0; _e1134 < _a625.length; _e1134++) {
          _a625[_e1134].removeAttribute("style"), _a625[_e1134].firstElementChild.firstElementChild.classList.remove("smart-tab-label-text-container-full-height");
        }

        delete e._inlineStyleTabStripChildren;
      }

      e._inlineStyleTabStrip && (t.removeAttribute("style"), delete e._inlineStyleTabStrip), t.$.removeClass("shrink-tabs"), t.$.removeClass("shrink-tabs-vertical");
    }
  }, {
    key: "_reorderTabs",
    value: function _reorderTabs(e, t) {
      function i(e, t, i) {
        var a = e[t];
        e.splice(t, 1), e.splice(i, 0, a);
      }

      var a = this,
          n = a.$.tabStrip[a._orientationSettings.scrollDirection];

      if (0 === a._groups.length) {
        var _n475 = a._tabs,
            _o338 = a._tabLabelContainers,
            _r213 = e > t ? t : t + 1;

        a.selectedIndex === e ? a.selectedIndex = t : a.selectedIndex <= t && a.selectedIndex > e ? a.selectedIndex-- : a.selectedIndex >= t && a.selectedIndex < e && a.selectedIndex++;

        var _l147;

        _l147 = _o338[_r213] ? _o338[_r213] : a.addNewTab ? a._addNewTab : null, a.$.tabStrip.insertBefore(_o338[e], _l147), a.$.dropDownButtonDropDown.insertBefore(a.$.dropDownButtonDropDown.children[e], a.$.dropDownButtonDropDown.children[_r213] || null), a.$.tabContentSection.insertBefore(_n475[e], _n475[_r213] || null), i(_n475, e, t), i(_o338, e, t), a._updateTabIndexes();
      } else a._reorderTabsGrouping(e, t);

      a.$.tabStrip[a._orientationSettings.scrollDirection] = n, a.$.fireEvent("reorder", {
        newIndex: t,
        originalIndex: e
      }), a._reorderedIndex = t, a._positionTabSelectionBar(a._tabLabelContainers[a.selectedIndex], !0), a.$.hiddenInput.value = a.selectedIndex;
    }
  }, {
    key: "_reorderTabsGrouping",
    value: function _reorderTabsGrouping(e, t) {
      var a = this,
          i = a.$.tabStrip.children,
          n = a.$.tabContentSection.children,
          o = e > t ? t : t + 1,
          r = a._tabs[a.selectedIndex];
      a.$.tabStrip.insertBefore(i[e], i[o] || null), a.$.tabContentSection.insertBefore(n[e], n[o] || null), a._groupLabels = Array.from(a.$.tabStrip.getElementsByClassName("smart-tab-group-container")), a._groups = [];

      for (var _n476 = 0; _n476 < a._groupLabels.length; _n476++) {
        a._groups.push(a._groupLabels[_n476].group);
      }

      a._tabs = Array.from(a.$.tabContentSection.getElementsByTagName("smart-tab-item"));
      var l = document.createDocumentFragment();
      var s = [];

      for (var _n477 = 0; _n477 < a._tabs.length; _n477++) {
        l.appendChild(a.$.dropDownButtonDropDown.children[a._tabs[_n477].index].cloneNode(!0));
      }

      a.$.dropDownButtonDropDown.innerHTML = "", a.$.dropDownButtonDropDown.appendChild(l);

      for (var _n478 = 0; _n478 < a.$.tabStrip.childElementCount; _n478++) {
        var _e1135 = a.$.tabStrip.children[_n478];
        _e1135.$.hasClass("smart-tab-label-container") && _e1135 !== a._addNewTab ? s.push(_e1135) : _e1135.$.hasClass("smart-tab-group-container") && (s = s.concat(Array.from(_e1135.dropDown.children)));
      }

      a._tabLabelContainers = s, a._updateTabIndexes(), r && (a.selectedIndex = r.index);
    }
  }, {
    key: "_resize",
    value: function _resize(e) {
      var t = this;
      if (!t._resizing) return;

      var i = t._orientationSettings,
          a = e[i.coordinate] - t._resizeFrom,
          n = t._getCorrespondingCustomElement(t._tabToResize);

      var o = null === n.labelSize ? t._tabToResize[i.size] : n.labelSize;
      var r = Math.max(10, o + a);
      r !== o && (n._preventPropertyChangedHandler = !0, n.labelSize = r, t._tabToResize.style[i.dimension] = parseInt(r, 10) + "px"), t.$resizeToken.addClass("smart-hidden"), t._applyTabOverflow(), t._resizing = !1, t.removeAttribute("resizing");
    }
  }, {
    key: "_ripple",
    value: function _ripple(e, t) {
      var i = this;

      if (i.hasRippleAnimation) {
        var _i948 = document.createElement("div");

        return _i948.className = "ripple-agent", t.firstElementChild.appendChild(_i948), setTimeout(function () {
          t.firstElementChild.removeChild(_i948);
        }, 1e3), Smart.Utilities.Animation.Ripple.animate(_i948, e.pageX, e.pageY), !0;
      }
    }
  }, {
    key: "_scrollButtonClickHandler",
    value: function _scrollButtonClickHandler(e) {
      var t = this,
          i = t.$.tabStrip;
      var a = e.target.closest("smart-repeat-button") === t.$.scrollButtonNear ? -1 : 1;

      if ("paging" === t.scrollMode) {
        var _n479 = t._orientationSettings,
            _o339 = {};
        return t._dragStartDetails = {
          startX: 0,
          startY: 0,
          pageX: 0,
          pageY: 0,
          startTime: Date.now(),
          target: e.target
        }, t._wheelInProgress = !0, _o339[_n479.coordinate] = -a * (i[_n479.size] / 1.1428571428571428), void t._endSwiping(_o339, t._dragStartDetails.startTime + 175);
      }

      t.hasAttribute("horizontal") ? i.scrollLeft += 10 * a : i.scrollTop += 10 * a, t._updateScrollButtonVisibility(!0);
    }
  }, {
    key: "_select",
    value: function _select(e, t, i) {
      var a = this,
          n = a.hasAnimation;
      if (void 0 === i && (i = a.selectedIndex), e === i && (!a.allowToggle || a.allowToggle && "mouseenter" === a.selectionMode)) return void (a.$.hiddenInput.value = a.selectedIndex);
      var o = a._tabs[e];

      if (a._focusedItem && a._focusedItem.tabLabelContainer.removeAttribute("focus"), null !== i) {
        var _t952 = a._tabs[i];
        n ? a._animateSelection(o, _t952, e > i) : _t952.$.addClass("smart-visibility-hidden"), _t952.selected = !1, a._tabLabelContainers[i].$.removeClass("smart-tab-selected"), a._tabLabelContainers[i].removeAttribute("selected"), a.closeButtons && "selected" === a.closeButtonMode && a._disableCloseButton(i);
      }

      a.allowToggle && (null === e || (void 0 === arguments[2] ? a.selectedIndex : i) === e) ? (a.selectedIndex = null, a.$.tabContentSection.setAttribute("show-placeholder", ""), a.allowToggle && (a._focusedItem = a._tabs[null === e ? i : e], a._focusedItem && a._focusedItem.tabLabelContainer.setAttribute("focus", ""))) : (o.selected = !0, a.$.tabContentSection.removeAttribute("show-placeholder"), (null === i || !n) && o.$.removeClass("smart-visibility-hidden"), a.selectedIndex = e, a._focusedItem = a._tabs[e], a._focusedItem.tabLabelContainer.$.addClass("smart-tab-selected"), a._focusedItem.tabLabelContainer.setAttribute("selected", ""), a._positionTabSelectionBar(a._focusedItem.tabLabelContainer, null === i)), null !== e && (a._tabLabelContainers[e].removeAttribute("hover"), a.closeButtons && "selected" === a.closeButtonMode && a._enableCloseButton(e)), t && (a.$.hiddenInput.value = a.selectedIndex, a.$.fireEvent("change", {
        index: a.selectedIndex,
        oldIndex: i
      })), a._closeGroupDropDown(), o && null !== o.group ? (a._selectedGroup && a._selectedGroup.$.removeClass("smart-tab-group-selected"), null !== a.selectedIndex && (a._selectedGroup = a._groupLabels[a._groups.indexOf(o.group)], a._selectedGroup.$.addClass("smart-tab-group-selected"))) : a._selectedGroup && (a._selectedGroup.$.removeClass("smart-tab-group-selected"), delete a._selectedGroup), a.$.hiddenInput.value = a.selectedIndex;
    }
  }, {
    key: "_selectStartHandler",
    value: function _selectStartHandler(e) {
      var t = this;
      (t._reordering || t._resizing) && e.preventDefault();
    }
  }, {
    key: "_setLabel",
    value: function _setLabel(e, t, i) {
      var a = e ? document.getElementById(e) : null;

      if (null !== a && "template" === a.tagName.toLowerCase()) {
        var _e1136 = document.importNode(a.content, !0);

        if (t.appendChild(_e1136), i) {
          var _e1137 = document.importNode(a.content, !0);

          i.appendChild(_e1137);
        }
      } else "" === e && (e = "&nbsp;"), t.innerHTML = e, i && (i.innerHTML = e);
    }
  }, {
    key: "_showCloseButton",
    value: function _showCloseButton(e) {
      e.closeButtonEnabled && (e.firstElementChild.children[0].$.addClass("smart-close-button-enabled"), e.firstElementChild.children[1].$.removeClass("smart-hidden"));
    }
  }, {
    key: "_tabContentSectionTransitionendHandler",
    value: function _tabContentSectionTransitionendHandler(e) {
      var t = this,
          i = e.target;
      i instanceof Smart.TabItem && (i === t._animatedOldTab ? (i.$.addClass("smart-hidden"), i.$.removeClass("animate"), i.$.removeClass(t._animatedOldTab.classToRemove), i.$.removeClass("smart-hidden"), delete t._animatedOldTab) : i === t._animatedTab && (i.$.removeClass("animate"), delete t._animatedTab), i.classList.remove("left"), i.classList.remove("right"), i.classList.remove("top"), i.classList.remove("bottom"));
    }
  }, {
    key: "_tabsHeaderItemsWheelHandler",
    value: function _tabsHeaderItemsWheelHandler(e) {
      var t = this,
          i = t._orientationSettings;

      if (!(!t.enableMouseWheelAction || t._wheelInProgress || t.disabled || t.$.tabStrip[i.size] === t.$.tabStrip[i.scrollSize])) {
        e.preventDefault(), t._dragStartDetails = {
          startX: e.pageX,
          startY: e.pageY,
          pageX: e.pageX,
          pageY: e.pageY,
          startTime: Date.now(),
          target: e.target
        }, t._wheelInProgress = !0;
        var _a626 = {};
        _a626[i.coordinate] = e[i.coordinate] + (0 < e.deltaY ? -1 : 1) * i.wheelOffset, t._endSwiping(_a626, t._dragStartDetails.startTime + 100);
      }
    }
  }, {
    key: "_tabStripHandler",
    value: function _tabStripHandler(e, t) {
      var i = this,
          a = t.type;
      if ("down" === a && void 0 !== i._tabToResize) return i._resizing = !0, void (i._tabsHeaderSectionCoordinate = i.$.tabsHeaderSection.getBoundingClientRect()[i._orientationSettings.edge]);
      "down" === a && Smart.Utilities.Core.isMobile && (i._dragStartDetails = {
        startX: t.pageX,
        startY: t.pageY,
        pageX: t.pageX,
        pageY: t.pageY,
        startTime: Date.now(),
        originalTime: Date.now(),
        target: t.originalEvent.target
      });
      var n = e.closest("smart-repeat-button");
      if ("up" === a && n) return i.focus(), void (i.resize && i._getTabCoordinates());
      if (e.classList.contains("smart-tab-close-button")) if ("up" !== a) {
        if ("down" === a) return void (i._downTarget = e);
        i._reordering || i._swiping || ("mouseover" === a ? e.setAttribute("hover", "") : "mouseout" === a && e.removeAttribute("hover"));
      } else if (e === i._downTarget) {
        var _t953 = e.parentElement.parentElement.tab.index,
            _a627 = i.$.fireEvent("closing", {
          index: _t953
        });

        return void (_a627.defaultPrevented || (i.remove(_t953), i.$.fireEvent("close", {
          index: _t953
        })));
      }
      var o = e.closest(".smart-tab-label-container");
      if (null !== o) return void i._labelContainerHandler(o, t, a);
      var r = e.closest(".smart-tab-group-container");
      null !== r && i._groupContainerHandler(r, a);
    }
  }, {
    key: "_tabStripMouseleaveHandler",
    value: function _tabStripMouseleaveHandler() {
      var e = this;
      e.resize && !e._resizing && e.hasAttribute("resizing") && e.removeAttribute("resizing");
    }
  }, {
    key: "_tabStripMoveHandler",
    value: function _tabStripMoveHandler(e) {
      var t = Math.abs;
      var a = this;

      if (a._dragStartDetails && !a._dragStartDetails.checked && (500 > Date.now() - a._dragStartDetails.originalTime ? (a._endReordering(void 0, void 0), a._dragStartDetails.checked = !0) : delete a._dragStartDetails), a._dragStartDetails && (5 <= t(a._dragStartDetails.pageX - e.pageX) || 5 <= t(a._dragStartDetails.pageY - e.pageY))) {
        var _t954 = a._orientationSettings,
            _i949 = a._dragStartDetails[_t954.coordinate] - e[_t954.coordinate],
            _n480 = a.$.tabStrip[_t954.scrollDirection];

        return a.$.tabStrip[_t954.scrollDirection] += _i949, _n480 !== a.$.tabStrip[_t954.scrollDirection] && a._updateScrollButtonVisibility(), a._dragStartDetails = {
          startX: a._dragStartDetails.startX,
          startY: a._dragStartDetails.startY,
          pageX: e.pageX,
          pageY: e.pageY,
          startTime: a._dragStartDetails.startTime,
          originalTime: a._dragStartDetails.originalTime,
          target: e.originalEvent.target,
          checked: a._dragStartDetails.checked
        }, void (a._swiping = !0);
      }

      if (!a.resize || a._resizing || a._reordering || "shrink" === a.tabLayout) return;
      var n = a._orientationSettings,
          o = e[n.coordinate],
          r = a._tabCoordinates;
      var l;

      for (var _t955 = 0; _t955 < r.length; _t955++) {
        var _e1138 = r[_t955][n.to];

        if (o >= _e1138 - 4 && o <= _e1138 + 4) {
          l = a._reorderItems[_t955], a._resizeFrom = o;
          break;
        }
      }

      void 0 === l ? (a._tabToResize = void 0, a.removeAttribute("resizing")) : (a._tabToResize = l, a.setAttribute("resizing", ""));
    }
  }, {
    key: "_toggleCollapsedState",
    value: function _toggleCollapsedState() {
      var e = this;
      e.collapsible && (e.collapsed ? e.expand() : e.collapse());
    }
  }, {
    key: "_toggleNavigationElementsVisibility",
    value: function _toggleNavigationElementsVisibility() {
      var e = this,
          t = e._tabs.length;
      var i;
      if (0 === t) i = "addClass";else if (1 === t) i = "removeClass";else return;
      "scroll" === e.tabLayout && "scroll" === e.overflow ? (e.$scrollButtonNear[i]("smart-hidden"), e.$scrollButtonFar[i]("smart-hidden")) : "dropDown" === e.tabLayout && e.$dropDownButton[i]("smart-hidden");
    }
  }, {
    key: "_updateIndexes",
    value: function _updateIndexes(e) {
      var t = this;
      null !== t.selectedIndex && e <= t.selectedIndex && t.selectedIndex++, t._updateTabIndexes();
    }
  }, {
    key: "_updateScrollButtonVisibility",
    value: function _updateScrollButtonVisibility(e) {
      var t = Math.round;
      var i = this;
      if ("scroll" !== i.tabLayout || "hidden" === i.overflow) return void i._positionTabSelectionBar(i._tabLabelContainers[i.selectedIndex], e);
      var a = i.$tabsHeaderSection,
          n = i.$.tabStrip,
          o = i._orientationSettings;
      var r = !0,
          l = !0;

      if (0 === t(n[o.scrollDirection]) && (r = !1), t(n[o.size] + n[o.scrollDirection]) >= t(n[o.scrollSize]) - 1 && (l = !1), "auto" === i.overflow) {
        if (r && l) return i.$scrollButtonNear.removeClass("smart-hidden"), i.$scrollButtonFar.removeClass("smart-hidden"), a.removeClass("one-button-shown"), void (i._tabLabelContainers[i.selectedIndex] && i._positionTabSelectionBar(i._tabLabelContainers[i.selectedIndex], e));
        r ? i.$scrollButtonNear.removeClass("smart-hidden") : i.$scrollButtonNear.addClass("smart-hidden"), l ? i.$scrollButtonFar.removeClass("smart-hidden") : i.$scrollButtonFar.addClass("smart-hidden"), a.addClass("one-button-shown"), i._getTabCoordinates();
      } else "scroll" !== i.overflow || i.disabled || (i.$.scrollButtonNear.disabled = !r, i.$.scrollButtonFar.disabled = !l);

      i._tabLabelContainers[i.selectedIndex] && i._positionTabSelectionBar(i._tabLabelContainers[i.selectedIndex], e);
    }
  }, {
    key: "_updateTabIndexes",
    value: function _updateTabIndexes() {
      var e = this;
      if (0 < e._tabs.length) for (var _t956 = 0; _t956 < e._tabs.length; _t956++) {
        e._tabs[_t956]._setIndex(_t956);
      } else e.selectedIndex = null;
      e.$.hiddenInput.value = e.selectedIndex;
    }
  }, {
    key: "_validateIndex",
    value: function _validateIndex(e, t) {
      if (isNaN(parseInt(e, 10)) || "object" == typeof e) {
        var _e1139 = this;

        _e1139.error(_e1139.localize("invalidIndex", {
          method: t
        }));
      }
    }
  }, {
    key: "_validateInitialSelection",
    value: function _validateInitialSelection() {
      var e = this;
      var t = e.selectedIndex;

      for (var _a628 = 0; _a628 < e._tabs.length; _a628++) {
        var _i950 = e._tabs[_a628];
        t === _a628 ? (_i950.selected = !0, _i950.$.removeClass("smart-visibility-hidden")) : _i950.selected ? null === t ? (t = _a628, _i950.$.removeClass("smart-visibility-hidden")) : (_i950.selected = !1, _i950.$.addClass("smart-visibility-hidden")) : _i950.$.addClass("smart-visibility-hidden");
      }

      0 < e._tabs.length && null === t && !e.allowToggle && (t = 0, e._tabs[0].selected = !0, e._tabs[0].$.removeClass("smart-visibility-hidden")), e.selectedIndex = t, null !== e.selectedIndex && (e._focusedItem = e._tabs[e.selectedIndex]);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        addNewTab: {
          value: !1,
          type: "boolean"
        },
        allowToggle: {
          value: !1,
          type: "boolean"
        },
        closeButtonMode: {
          value: "default",
          allowedValues: ["default", "selected"],
          type: "string"
        },
        closeButtons: {
          value: !1,
          type: "boolean"
        },
        collapsed: {
          value: !1,
          type: "boolean"
        },
        collapsible: {
          value: !1,
          type: "boolean"
        },
        dataSource: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        enableMouseWheelAction: {
          value: !1,
          type: "boolean"
        },
        messages: {
          value: {
            en: {
              ambiguousIndexes: "smart-tabs: Initially set smart-tab-item indexes are ambiguous and are ignored in favour of the HTML structure.",
              detailsObjectRequired: "smart-tabs: The method \"insert\" requires a details Object to be passed as a second argument.",
              invalidIndex: "smart-tabs: \"{{method}}\" method accepts an index of type number.",
              referenceNodeNotChild: "smart-tabs: Passed {{argument}} is not part of this smart-tabs element.",
              tabItemRequired: "smart-tabs: The method \"{{method}}\" requires a \"smart-tab-item\" element to be passed as an argument."
            }
          },
          type: "object",
          extend: !0
        },
        name: {
          value: "",
          type: "string"
        },
        overflow: {
          value: "auto",
          allowedValues: ["auto", "hidden", "scroll"],
          type: "string"
        },
        reorder: {
          value: !1,
          type: "boolean"
        },
        resize: {
          value: !1,
          type: "boolean"
        },
        scrollButtonsPosition: {
          value: "both",
          allowedValues: ["near", "far", "both"],
          type: "string"
        },
        scrollMode: {
          value: "paging",
          allowedValues: ["paging", "continuous"],
          type: "string"
        },
        selectedIndex: {
          value: null,
          type: "number?"
        },
        selectionMode: {
          value: "click",
          allowedValues: ["click", "dblclick", "mouseenter", "none"],
          type: "string"
        },
        tabLayout: {
          value: "scroll",
          allowedValues: ["scroll", "dropDown", "wrap", "shrink"],
          type: "string",
          defaultReflectToAttribute: !0
        },
        tabPosition: {
          value: "top",
          allowedValues: ["top", "bottom", "left", "right", "hidden"],
          type: "string"
        },
        tabTextOrientation: {
          value: "horizontal",
          allowedValues: ["horizontal", "vertical"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        closeButtonVisibilityChange: "_closeButtonVisibilityChangeHandler",
        indexChange: "_indexChangeHandler",
        keydown: "_keydownHandler",
        labelSizeChange: "_labelSizeChangeHandler",
        resize: "_applyTabOverflow",
        styleChanged: "_applyTabOverflow",
        "container.dblclick": "_containerHandler",
        "container.down": "_containerHandler",
        "container.mouseout": "_containerHandler",
        "container.mouseover": "_containerHandler",
        "scrollButtonFar.click": "_scrollButtonClickHandler",
        "scrollButtonNear.click": "_scrollButtonClickHandler",
        "tabContentSection.transitionend": "_tabContentSectionTransitionendHandler",
        "tabsHeaderItems.wheel": "_tabsHeaderItemsWheelHandler",
        "tabStrip.mouseleave": "_tabStripMouseleaveHandler",
        "tabStrip.move": "_tabStripMoveHandler",
        "document.move": "_documentMoveHandler",
        "document.selectstart": "_selectStartHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.RepeatButton": "smart.button.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.tabs.css"];
    }
  }]);

  return _class106;
}(Smart.BaseElement)), Smart("smart-time-picker",
/*#__PURE__*/
function (_Smart$BaseElement28) {
  "use strict";

  _inherits(_class107, _Smart$BaseElement28);

  function _class107() {
    _classCallCheck(this, _class107);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class107).apply(this, arguments));
  }

  _createClass(_class107, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                <div id=\"header\" class=\"smart-header smart-unselectable\" role=\"heading\" aria-level=\"1\">\n                    <div id=\"hourMinuteContainer\" class=\"smart-hour-minute-container\">\n                        <div id=\"hourContainer\" class=\"smart-hour-container\" role=\"button\"></div>\n                        <div role=\"presentation\">:</div>\n                        <div id=\"minuteContainer\" class=\"smart-minute-container\" role=\"button\"></div>\n                    </div>\n                    <div id=\"ampmContainer\" class=\"smart-am-pm-container\" role=\"presentation\">\n                        <div id=\"amContainer\" class=\"smart-am-container\" role=\"button\">AM</div>\n                        <div id=\"pmContainer\" class=\"smart-pm-container\" role=\"button\">PM</div>\n                    </div>\n                </div>\n                <div id=\"main\" class=\"smart-main-container\">\n                    <div id=\"svgContainer\" class=\"smart-svg-container\">\n                        <div id=\"picker\" class=\"smart-svg-picker\" role=\"slider\"></div>\n                    </div>\n                    <div id=\"footer\" class=\"smart-footer\"></div>\n                </div>\n                <input id=\"hiddenInput\" type=\"hidden\" name=\"[[name]]\">\n            </div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class107.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e._createElement(), _get(_getPrototypeOf(_class107.prototype), "render", this).call(this);
    }
  }, {
    key: "setHours",
    value: function setHours(e) {
      var t = this;
      e = 24 === e ? 0 : Math.max(0, Math.min(e, 23)), 12 > e ? t._selectAmPm("am") : t._selectAmPm("pm"), "12-hour" === t.format && (0 === e ? e = 12 : 12 < e && (e -= 12)), t._updateHours(e, arguments[1]), "hour" === t.selection && (t._inInnerCircle = "24-hour" === t.format && (0 === e || 12 < e), t._drawArrow(!0, e, arguments[2]), !t.hasAnimation && (t._inInnerCircle = !1));
    }
  }, {
    key: "setMinutes",
    value: function setMinutes(e) {
      var t = this;
      e = 60 === e ? 0 : Math.max(0, Math.min(e, 59)), t._updateMinutes(e), "minute" === t.selection && t._drawArrow(!0, e, arguments[1]);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class107.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;

      switch (e) {
        case "disabled":
        case "unfocusable":
          a._setFocusable();

          break;

        case "footer":
        case "view":
          a._resizeHandler();

          break;

        case "footerTemplate":
          a._validateFooterTemplate();

          break;

        case "format":
          {
            var _e1140 = a.value.getHours();

            "12-hour" === i ? (a.$ampmContainer.removeClass("smart-hidden"), 12 > a.value.getHours() ? a._selectAmPm("am") : a._selectAmPm("pm"), 0 === _e1140 ? _e1140 = 12 : 12 < _e1140 && (_e1140 -= 12)) : a.$ampmContainer.addClass("smart-hidden"), a.$.hourContainer.innerHTML = _e1140, "hour" === a.selection && (a.$.picker.setAttribute("aria-valuenow", _e1140), a._draw.clear(), a._renderSVG());
            break;
          }

        case "minuteInterval":
          {
            var _e1141 = Math.max(1, Math.min(i, 60));

            _e1141 !== i && (a.minuteInterval = _e1141), "minute" === a.selection && (a.interval = _e1141);
            break;
          }

        case "selection":
          "hour" === i ? a._changeToHourSelection() : a._changeToMinuteSelection();
          break;

        case "value":
          {
            a._oldValue = t, a._validateValue();

            var _e1142 = a.value.getHours() === t.getHours(),
                _i951 = a.value.getMinutes() === t.getMinutes();

            _e1142 && _i951 || (_i951 ? a.setHours(a.value.getHours()) : (!_e1142 && a.setHours(a.value.getHours(), !0), a.setMinutes(a.value.getMinutes()))), delete a._oldValue;
            break;
          }
      }
    }
  }, {
    key: "_applyInitialSettings",
    value: function _applyInitialSettings() {
      var e = this,
          t = e.value;
      var i, a;
      i = t.getHours(), a = t.getMinutes(), "12-hour" === e.format ? 12 > i ? (e._ampm = "am", e.$amContainer.addClass("smart-selected"), 0 === i && (i = 12)) : (e._ampm = "pm", e.$pmContainer.addClass("smart-selected"), 12 < i && (i -= 12)) : e.$ampmContainer.addClass("smart-hidden"), a = a.toString(), 1 === a.length && (a = "0" + a), e.$.hourContainer.innerHTML = i, e.$.minuteContainer.innerHTML = a, "hour" === e.selection ? (e.$hourContainer.addClass("smart-selected"), e.$.picker.setAttribute("aria-valuenow", i)) : (e.$minuteContainer.addClass("smart-selected"), e.$.picker.setAttribute("aria-valuenow", a));
    }
  }, {
    key: "_changeSelection",
    value: function _changeSelection(e, t) {
      var i = Math.pow;

      var a = this,
          n = e.pageX,
          o = e.pageY,
          r = a._getCenterCoordinates(),
          l = Math.sqrt(i(r.x - n, 2) + i(r.y - o, 2));

      if (a._measurements.center = r, "down" === e.type) {
        if (l > a._measurements.radius) return void e.stopPropagation();
        a._dragging = !0;
      }

      a._inInnerCircle = !!("24-hour" === a.format && "hour" === a.selection && l < a._measurements.radius - 50);
      var s = Math.atan2(o - r.y, n - r.x);
      var d = 180 * (-1 * s) / Math.PI;
      0 > d && (d += 360), a._angle = d;

      var c = a._numericProcessor.getValueByAngle(a._angle);

      "hour" === a.selection ? ("24-hour" === a.format ? a._inInnerCircle ? 0 !== c && 12 !== c ? c += 12 : c = 0 : 0 === c && (c = 12) : 0 === c && (c = 12), a._updateHours(c)) : (60 === c && (c = 0), a._updateMinutes(c)), void 0 === a._oldTimePart || (cancelAnimationFrame(a._animationFrameId), delete a._animationFrameId, a._drawArrow(!0, c, t));
    }
  }, {
    key: "_changeToHourSelection",
    value: function _changeToHourSelection() {
      var e = this,
          t = e._centralCircle.parentElement || e._centralCircle.parentNode;
      var i = e.value.getHours();
      cancelAnimationFrame(e._animationFrameId), delete e._animationFrameId, e.interval = 1, e.$hourContainer.addClass("smart-selected"), e.$minuteContainer.removeClass("smart-selected"), t.removeChild(e._centralCircle), t.removeChild(e._arrow), t.removeChild(e._head), e._getMeasurements(), e._numericProcessor.getAngleRangeCoefficient(), e._draw.clear(), t.appendChild(e._centralCircle), t.appendChild(e._arrow), t.appendChild(e._head), e._renderHours(), "24-hour" === e.format && (0 === i || 12 < i) ? e._inInnerCircle = !0 : "12-hour" === e.format && (i %= 12, 0 === i && (i = 12)), e._drawArrow(!0, void 0, !0), e._inInnerCircle = !1, e.$.picker.firstElementChild.setAttribute("aria-hidden", !0), e.$.picker.setAttribute("aria-valuenow", i);
    }
  }, {
    key: "_changeToMinuteSelection",
    value: function _changeToMinuteSelection() {
      var e = this,
          t = e._centralCircle.parentElement || e._centralCircle.parentNode;
      e._inInnerCircle = !1, cancelAnimationFrame(e._animationFrameId), delete e._animationFrameId, e.interval = e.minuteInterval, e.$hourContainer.removeClass("smart-selected"), e.$minuteContainer.addClass("smart-selected"), t.removeChild(e._centralCircle), t.removeChild(e._arrow), t.removeChild(e._head), e._getMeasurements(), e._numericProcessor.getAngleRangeCoefficient(), e._draw.clear(), t.appendChild(e._centralCircle), t.appendChild(e._arrow), t.appendChild(e._head), e._renderMinutes(), e._drawArrow(!0, void 0, !0), e.$.picker.firstElementChild.setAttribute("aria-hidden", !0), e.$.picker.setAttribute("aria-valuenow", e.value.getMinutes());
    }
  }, {
    key: "_computeArrowBodyPoints",
    value: function _computeArrowBodyPoints(e, t, i, a) {
      var n = this,
          o = Math.sin(t),
          r = Math.cos(t),
          l = e - i * r + a * o,
          s = e + i * o + a * r,
          d = e + i * r + a * o,
          c = e - i * o + a * r;
      return n._headCenter = {
        x: (l + d) / 2,
        y: (s + c) / 2
      }, "M " + (e + i * r) + "," + (e - i * o) + " L " + (e - i * r) + "," + (e + i * o) + " L " + l + "," + s + " " + d + "," + c;
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      return e.setAttribute("role", "dialog"), e.coerce = !0, e.min = 0, e._drawMin = "0", e.startAngle = -270, e.endAngle = 90, e._angleDifference = e.endAngle - e.startAngle, e.ticksVisibility = "none", e._tickIntervalHandler = {}, e._tickIntervalHandler.labelsSize = {}, e._distance = {
        majorTickDistance: 0,
        minorTickDistance: 0,
        labelDistance: 10
      }, e._measurements = {}, e._validateInitialPropertyValues(), e._applyInitialSettings(), e._numericProcessor = new Smart.Utilities.DecimalNumericProcessor(e), e._draw = new Smart.Utilities.Draw(e.$.picker), e._isVisible() ? void (e._setPickerSize(), e._getMeasurements(), e._numericProcessor.getAngleRangeCoefficient(), e._renderSVG(), e._setFocusable(), e.$.hiddenInput.value = e.value, e.enableShadowDOM && e.appendChild(e.$.hiddenInput)) : void (e._renderingSuspended = !0);
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = this;
      t._dragging && t._changeSelection(e, !0);
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler() {
      function e() {
        i.$picker.addClass("animate"), setTimeout(function () {
          i.selection = "minute", i._changeToMinuteSelection();
        }, 250), setTimeout(function () {
          i.$picker.removeClass("animate");
        }, 550);
      }

      function t() {
        i._animationFrameId ? requestAnimationFrame(t) : e();
      }

      var i = this;
      i._dragging && (i._inInnerCircle = !1, i._dragging = !1, i.autoSwitchToMinutes && "hour" === i.selection && (i.hasAnimation ? t() : (i.selection = "minute", i._changeToMinuteSelection())));
    }
  }, {
    key: "_drawArrow",
    value: function _drawArrow(e, t, i) {
      function a() {
        l += s, l = parseFloat((l % d).toFixed(1)), 0 > l && (l += d), n._drawArrowSVG(e, l), e = !0, l === t % d ? delete n._animationFrameId : n._animationFrameId = requestAnimationFrame(a);
      }

      var n = this,
          o = "hour" === n.selection,
          r = "12-hour" === n.format;
      var l = n._oldTimePart;
      if (delete n._oldTimePart, void 0 === t && (o ? (t = n.value.getHours(), r && 12 < t && (t -= 12)) : t = n.value.getMinutes()), void 0 === l || i || !n.hasAnimation) return void n._drawArrowSVG(e, t);
      if (o && !r) return void n._animate24HourView(l, t);
      var s, d;
      o ? (s = .2, d = 12, t %= d, l %= d) : (s = 1, d = 60);
      var c = t - l,
          m = l - t;
      0 > c && (c += d), 0 > m && (m += d), m < c && (s *= -1), a();
    }
  }, {
    key: "_animate24HourView",
    value: function _animate24HourView(e, t) {
      function i(o) {
        a._inInnerCircle = o, o ? (e = parseFloat((e + n).toFixed(1)), 0 > e ? e += 24 : 1 > e && (e += 12), (12 === e || 24 === e) && (e = 0)) : (e += n, 12 !== e && (e = parseFloat((e % 12).toFixed(1))), 0 >= e && (e += 12)), a._drawArrowSVG(!0, e), e === t ? (delete a._animationFrameId, a._inInnerCircle = !1) : a._animationFrameId = requestAnimationFrame(function () {
          i(o);
        });
      }

      var a = this;
      var n = .2;
      a._inInnerCircle = !1;
      var o = 0 === e || 12 < e,
          r = 0 === t || 12 < t;
      if (o == r) a._inInnerCircle = r;else if (e = o ? Math.abs(e - 12) : (e + 12) % 24, a._inInnerCircle = r, a._drawArrowSVG(!0, e), e === t) return;
      var l = e,
          s = t;
      a._inInnerCircle && (0 === s && 18 > l ? s = 12 : 0 == l && 18 > s && (l = 12));
      var d = s - l,
          c = l - s;
      0 > d && (d += 12), 0 > c && (c += 12), c < d && (n *= -1), i(a._inInnerCircle);
    }
  }, {
    key: "_drawArrowSVG",
    value: function _drawArrowSVG(e, t) {
      var i = this,
          a = i._measurements,
          n = i._numericProcessor.getAngleByValue(t);

      var o;
      o = i._inInnerCircle ? i._computeArrowBodyPoints(a.radius, n, 1, a.innerRadius - i._largestLabelSize / 2 - 45) : i._computeArrowBodyPoints(a.radius, n, 1, a.innerRadius - i._largestLabelSize / 2), e ? (i._arrow.setAttribute("d", o), i._head.setAttribute("cx", i._headCenter.x), i._head.setAttribute("cy", i._headCenter.y), i._head.setAttribute("r", i._largestLabelSize), i._headRect = i._head.getBoundingClientRect(), 0 == t % 1 && i._highlightLabel(t)) : (i._arrow = i._draw.path(o, {
        class: "smart-needle"
      }), i._head = i._draw.circle(i._headCenter.x, i._headCenter.y, i._largestLabelSize, {
        class: "smart-needle-central-circle"
      }), i._headRect = i._head.getBoundingClientRect());
    }
  }, {
    key: "_drawLabel",
    value: function _drawLabel(e, t, i) {
      var a = Math.round;
      var n = this,
          o = n._measurements,
          l = o.radius,
          r = {
        class: "smart-label smart-unselectable",
        "font-size": o.fontSize,
        "font-family": o.fontFamily,
        "font-weight": o.fontWeight,
        "font-style": o.fontStyle
      };
      "hour" === n.selection ? n._plotInnerCircle ? 0 < t ? t += 12 : t = "00" : 0 === t && (t = 12) : 1 === t.toString().length && (t = "0" + t);

      var s = n._draw.measureText(t, 0, r),
          d = l - i - n._largestLabelSize / 2,
          c = l + d * Math.sin(e),
          m = l + d * Math.cos(e),
          u = n._draw.text(t, a(c) - s.width / 2, a(m) - s.height / 2, s.width, s.height, 0, r);

      u.setAttribute("value", parseFloat(t));
    }
  }, {
    key: "_getCenterCoordinates",
    value: function _getCenterCoordinates() {
      var e = this,
          t = e.$.picker.getBoundingClientRect(),
          i = e._measurements.radius,
          a = document.body.scrollLeft || document.documentElement.scrollLeft,
          n = document.body.scrollTop || document.documentElement.scrollTop;
      return {
        x: t.left + a + i,
        y: t.top + n + i
      };
    }
  }, {
    key: "_getMeasurements",
    value: function _getMeasurements() {
      var e = this,
          t = e._measurements,
          i = document.createElement("div");
      var a, n, o, r, l, s;
      i.className = "smart-label", i.style.position = "absolute", i.style.visibility = "hidden", e.$.svgContainer.appendChild(i), "hour" === e.selection ? (a = "1", n = "23", e.max = 12, e._drawMax = "12", e._range = 12) : (a = "00", n = "55", e.max = 60, e._drawMax = "60", e._range = 60), i.innerHTML = a, o = i.offsetWidth, l = i.offsetHeight, i.innerHTML = n, r = i.offsetWidth, s = i.offsetHeight, e._largestLabelSize = Math.max(o, l, r, s), e._tickIntervalHandler.labelsSize.minLabelSize = l, e._tickIntervalHandler.labelsSize.maxLabelSize = s;
      var d = window.getComputedStyle(i);
      t.fontSize = d.fontSize, t.fontFamily = d.fontFamily, t.fontWeight = d.fontWeight, t.fontStyle = d.fontStyle, e.$.svgContainer.removeChild(i);
    }
  }, {
    key: "_headerClickHandler",
    value: function _headerClickHandler(e) {
      var t = this;
      if (!(t.disabled || t.readonly)) switch (e.target) {
        case t.$.hourContainer:
          "hour" !== t.selection && (t.selection = "hour", t._changeToHourSelection());
          break;

        case t.$.minuteContainer:
          "minute" !== t.selection && (t.selection = "minute", t._changeToMinuteSelection());
          break;

        case t.$.amContainer:
          if (!t.$amContainer.hasClass("smart-selected")) {
            t._selectAmPm("am");

            var _e1143 = new Date(t.value.getTime());

            t.value.setHours(t.value.getHours() - 12), t.$.hiddenInput.value = t.value, t.$.fireEvent("change", {
              value: t.value,
              oldValue: _e1143
            });
          }

          break;

        case t.$.pmContainer:
          if (!t.$pmContainer.hasClass("smart-selected")) {
            t._selectAmPm("pm");

            var _e1144 = new Date(t.value.getTime());

            t.value.setHours(t.value.getHours() + 12), t.$.hiddenInput.value = t.value, t.$.fireEvent("change", {
              value: t.value,
              oldValue: _e1144
            });
          }

      }
    }
  }, {
    key: "_highlightLabel",
    value: function _highlightLabel(e) {
      var t = this;

      if (t._highlightedLabel) {
        if (parseFloat(t._highlightedLabel.getAttribute("value")) === e) return;
        t._highlightedLabel.classList.remove("smart-selected"), t._highlightedLabel = void 0;
      }

      var i;
      "hour" === t.selection ? (e === void 0 && (e = t.value.getHours()), "12-hour" === t.format && (0 === e ? e = 12 : 12 < e && (e -= 12)), i = e) : (e === void 0 && (e = t.value.getMinutes()), i = 5 * Math.round(e / 5), 60 === i && (i = 0));
      var a = t.$.picker.querySelector(".smart-label[value=\"" + i + "\"]");
      a && (i === e || t._overlapsLabel(a)) && (t._highlightedLabel = a, a.classList.add("smart-selected"));
    }
  }, {
    key: "_isVisible",
    value: function _isVisible() {
      var e = this;
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }
  }, {
    key: "_keydownHandler",
    value: function _keydownHandler(e) {
      var t = this;

      if (!t._dragging) {
        var _i952 = (t.shadowRoot || t.getRootNode()).activeElement,
            _a629 = e.key;
        if (t.$.header.contains(_i952) && ("Enter" === _a629 || " " === _a629)) e.preventDefault(), t._headerClickHandler({
          target: _i952
        });else if (_i952 === t.$.picker && !e.altKey) {
          var _i953;

          if ("ArrowRight" === _a629 || "ArrowUp" === _a629 ? _i953 = 1 : ("ArrowLeft" === _a629 || "ArrowDown" === _a629) && (_i953 = -1), _i953) if (e.preventDefault(), "hour" === t.selection) {
            var _e1145 = t.value.getHours();

            0 === _e1145 && -1 === _i953 ? _e1145 = 23 : 23 === _e1145 && 1 === _i953 ? _e1145 = 0 : _e1145 += _i953, "12-hour" === t.format && (12 <= _e1145 && t.$amContainer.hasClass("smart-selected") ? _e1145 -= 12 : 12 > _e1145 && t.$pmContainer.hasClass("smart-selected") && (_e1145 += 12)), t.setHours(_e1145, void 0, !0);
          } else {
            var _e1146 = t.value.getMinutes();

            _i953 *= t.minuteInterval, 60 <= _e1146 + _i953 ? _e1146 = 0 : _e1146 < -1 * _i953 ? 0 == 60 % _i953 ? _e1146 = 60 + _i953 : _e1146 = 60 - 60 % _i953 : _e1146 += _i953, t.setMinutes(_e1146, !0);
          }
        }
      }
    }
  }, {
    key: "_overlapsLabel",
    value: function _overlapsLabel(e) {
      var t = this,
          i = e.getBoundingClientRect();
      var a = t._headRect;
      return 0 === a.height && (a = t._headRect = t._head.getBoundingClientRect()), !(i.right - 10 < a.left || i.left + 10 > a.right || i.bottom - 10 < a.top || i.top + 10 > a.bottom);
    }
  }, {
    key: "_parseDateString",
    value: function _parseDateString(e, t) {
      var i = e.indexOf("Date("),
          a = e.indexOf(")");
      var n = e;

      if (-1 !== i && -1 !== a) {
        if (n = e.slice(i + 5, a), n = n.replace(/'/g, "").replace(/"/g, "").replace(/^\s+|\s+$|\s+(?=\s)/g, ""), "" === n.trim()) return new Date();
        if (new RegExp(/(^(\d+)(\s*,\s*\d+)+$)/g).test(n)) return n = n.replace(/\s/g, ""), n = n.split(","), n.map(function (e, t) {
          n[t] = parseInt(e);
        }), n.unshift(null), n = new (Function.prototype.bind.apply(Date, n))(), n;
      }

      if ("" === n.trim()) return t;
      if (!isNaN(n)) return new Date(parseInt(n, 10));

      try {
        n = new Date(n);
      } catch (e) {
        n = t;
      }

      return isNaN(n.getTime()) ? t : n;
    }
  }, {
    key: "_pickerDownHandler",
    value: function _pickerDownHandler(e) {
      var t = this;
      t.disabled || t.readonly || !Smart.Utilities.Core.isMobile && 1 !== e.which || t._changeSelection(e);
    }
  }, {
    key: "_pickerMoveHandler",
    value: function _pickerMoveHandler(e) {
      "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_renderHours",
    value: function _renderHours() {
      var e = this;
      e._highlightedLabel = void 0, e._majorTicksInterval = 1, e._numericProcessor.addGaugeTicksAndLabels(), "24-hour" === e.format ? (e._plotInnerCircle = !0, e._distance.labelDistance = 55, e._numericProcessor.addGaugeTicksAndLabels(), e._plotInnerCircle = !1, e._distance.labelDistance = 10, e.$.picker.setAttribute("aria-valuemin", 0), e.$.picker.setAttribute("aria-valuemax", 23)) : (e.$.picker.setAttribute("aria-valuemin", 1), e.$.picker.setAttribute("aria-valuemax", 12));
    }
  }, {
    key: "_renderMinutes",
    value: function _renderMinutes() {
      var e = this;
      e._highlightedLabel = void 0, e._majorTicksInterval = 5, e._numericProcessor.addGaugeTicksAndLabels(), e.$.picker.setAttribute("aria-valuemin", 0), e.$.picker.setAttribute("aria-valuemax", 59);
    }
  }, {
    key: "_renderSVG",
    value: function _renderSVG() {
      var e = this;
      if (!e._isVisible() || e._renderingSuspended) return void (e._renderingSuspended = !0);

      if (e._centralCircle = e._draw.circle(e._measurements.radius, e._measurements.radius, 4, {
        class: "smart-needle-central-circle"
      }), "hour" === e.selection && "24-hour" === e.format && (0 === e.value.getHours() || 12 < e.value.getHours()) && (e._inInnerCircle = !0), e._drawArrow(!1), e._inInnerCircle = !1, "hour" === e.selection) {
        e.interval = 1, e._renderHours();

        var _t957 = e.value.getHours();

        "12-hour" === e.format && 12 < _t957 && (_t957 -= 12), e._highlightLabel(_t957);
      } else e.interval = e.minuteInterval, e._renderMinutes(), e._highlightLabel(e.value.getMinutes());

      e.$.picker.firstElementChild.setAttribute("aria-hidden", !0);
    }
  }, {
    key: "_resizeHandler",
    value: function _resizeHandler() {
      var e = this;
      var t = !1;

      if (e.isRendered) {
        if (!e._isVisible()) return void (e._renderingSuspended = !0);
        e._renderingSuspended = !1, t = !0, e._getMeasurements(), e._numericProcessor.getAngleRangeCoefficient(), e._setPickerSize(), e._sizeChanged || t ? (e._draw.clear(), e._renderSVG(), e._sizeChanged = !1) : (e._headRect = e._head.getBoundingClientRect(), e._highlightLabel());
      }
    }
  }, {
    key: "_selectAmPm",
    value: function _selectAmPm(e) {
      var t = this;
      "am" === e ? (t._ampm = "am", t.$pmContainer.removeClass("smart-selected"), t.$amContainer.addClass("smart-selected")) : (t._ampm = "pm", t.$amContainer.removeClass("smart-selected"), t.$pmContainer.addClass("smart-selected"));
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;
      if (e.disabled || e.unfocusable) return e.$.hourContainer.removeAttribute("tabindex"), e.$.minuteContainer.removeAttribute("tabindex"), e.$.amContainer.removeAttribute("tabindex"), e.$.pmContainer.removeAttribute("tabindex"), void e.$.picker.removeAttribute("tabindex");
      var t = 0 < e.tabIndex ? e.tabIndex : 0;
      e.$.hourContainer.tabIndex = t, e.$.minuteContainer.tabIndex = t, e.$.amContainer.tabIndex = t, e.$.pmContainer.tabIndex = t, e.$.picker.tabIndex = t;
    }
  }, {
    key: "_setPickerSize",
    value: function _setPickerSize() {
      var e = this,
          t = e.$.svgContainer.offsetWidth,
          i = e.$.svgContainer.offsetHeight;
      var a = .9 * Math.min(t, i);
      e._sizeChanged = !(void 0 === e._pickerSize || e._pickerSize === a), e._pickerSize = a, e._measurements.radius = a / 2, e._measurements.innerRadius = e._measurements.radius - 10, a += "px", e.$.picker.style.width = a, e.$.picker.style.height = a;
    }
  }, {
    key: "_updateHours",
    value: function _updateHours(e, t) {
      var i = this;
      var a = e;
      "12-hour" === i.format ? "am" === i._ampm ? 12 === a && (a = 0) : 12 > a && (a += 12) : a = e;
      var n = i._oldValue === void 0 ? new Date(i.value.getTime()) : i._oldValue,
          o = n.getHours();
      return a === o ? void delete i._oldTimePart : void (i._oldTimePart = o, i._oldValue === void 0 && i.value.setHours(a), i.$.hourContainer.innerHTML = e, !0 !== t && (i.$.hiddenInput.value = i.value, i.$.fireEvent("change", {
        value: i.value,
        oldValue: n
      })), "hour" === i.selection && i.$.picker.setAttribute("aria-valuenow", e));
    }
  }, {
    key: "_updateMinutes",
    value: function _updateMinutes(e) {
      var t = this,
          i = t._oldValue === void 0 ? new Date(t.value.getTime()) : t._oldValue,
          a = i.getMinutes();
      return e === a ? void delete t._oldTimePart : void (t._oldTimePart = a, t._oldValue === void 0 && t.value.setMinutes(e), "minute" === t.selection && t.$.picker.setAttribute("aria-valuenow", e), e = e.toString(), 1 === e.length && (e = "0" + e), t.$.minuteContainer.innerHTML = e, t.$.hiddenInput.value = t.value, t.$.fireEvent("change", {
        value: t.value,
        oldValue: i
      }));
    }
  }, {
    key: "_validateFooterTemplate",
    value: function _validateFooterTemplate() {
      var e = this,
          t = e.footerTemplate;
      if (null === t) return void (e.$.footer.innerHTML = "");
      var i;
      if (t instanceof HTMLTemplateElement ? i = t : "string" == typeof t && (i = document.getElementById(t), !(i instanceof HTMLTemplateElement) && (i = void 0)), void 0 === i) return e.footerTemplate = null, void (e.$.footer.innerHTML = "");
      var a = document.importNode(i.content, !0);
      return e.enableShadowDOM ? (e.$.footer.innerHTML = "<slot></slot>", void e.appendChild(a)) : void e.$.footer.appendChild(a);
    }
  }, {
    key: "_validateInitialPropertyValues",
    value: function _validateInitialPropertyValues() {
      var e = this;
      e._validateFooterTemplate(), e.minuteInterval = Math.max(1, Math.min(e.minuteInterval, 60)), e._validateValue();
    }
  }, {
    key: "_validateValue",
    value: function _validateValue() {
      var e = this,
          t = e.value,
          i = e._oldValue === void 0 ? new Date() : this._oldValue;
      if (!(t instanceof Date)) if ("string" == typeof t) {
        if (/^\d{1,2}:\d{1,2}$/.test(t)) {
          var _a630 = t.split(":");

          return void (e.value = new Date(i.getFullYear(), i.getMonth(), i.getDate(), parseFloat(_a630[0]), parseFloat(_a630[1])));
        }

        e.value = e._parseDateString(t, i);
      } else e.value = i;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoSwitchToMinutes: {
          value: !1,
          type: "boolean"
        },
        footer: {
          value: !1,
          type: "boolean"
        },
        footerTemplate: {
          value: null,
          type: "any?"
        },
        format: {
          value: "12-hour",
          allowedValues: ["12-hour", "24-hour"],
          type: "string"
        },
        minuteInterval: {
          value: 1,
          type: "number"
        },
        name: {
          value: "",
          type: "string"
        },
        selection: {
          value: "hour",
          allowedValues: ["hour", "minute"],
          type: "string"
        },
        value: {
          value: new Date(),
          type: "any",
          reflectToAttribute: !1
        },
        view: {
          value: "portrait",
          allowedValues: ["landscape", "portrait"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        keydown: "_keydownHandler",
        resize: "_resizeHandler",
        "header.click": "_headerClickHandler",
        "picker.down": "_pickerDownHandler",
        "picker.move": "_pickerMoveHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Utilities.NumericProcessor": "smart.numeric.js",
        "Smart.Utilities.BigNumber": "smart.math.js",
        "Smart.Utilities.Draw": "smart.draw.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.timepicker.css"];
    }
  }]);

  return _class107;
}(Smart.BaseElement)), Smart("smart-toast-item",
/*#__PURE__*/
function (_Smart$ContentElement15) {
  "use strict";

  _inherits(_class108, _Smart$ContentElement15);

  function _class108() {
    _classCallCheck(this, _class108);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class108).apply(this, arguments));
  }

  _createClass(_class108, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div class =\"smart-toast-item-header\">\n                        <span class =\"smart-toast-item-close-button\" role=\"button\" aria-label=\"Close\"></span>\n                    </div>\n                    <div class =\"smart-toast-item-container\" id=\"itemContainer\">\n                        <span class =\"smart-toast-item-icon\" role=\"presentation\" aria-hidden=\"true\"></span>\n                        <span class =\"smart-toast-item-content\" id=\"itemContent\" inner-h-t-m-l=\"[[innerHTML]]\">\n                            <content></content>\n                        </span>\n                    </div>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      switch (e) {
        default:
          _get(_getPrototypeOf(_class108.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "render",
    value: function render() {
      var e = this,
          t = e.iconClass;
      e.setAttribute("role", "alert"), e.itemClass && (e.className += " " + e.itemClass), e.$.itemContainer.firstElementChild.className += " " + (t ? t : "default"), _get(_getPrototypeOf(_class108.prototype), "render", this).call(this);
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;
      if (!e) return void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "appendChild",
        node: "node"
      }));

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1147 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1147.concat(Array.prototype.slice.call(arguments)));
      }

      t.$.itemContent.appendChild(e);
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      var i = this;
      if (!e) return void i.error(i.localize("invalidNode", {
        elementType: i.nodeName.toLowerCase(),
        method: "insertBefore",
        node: "node"
      }));

      if (!i.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1148 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(i, _e1148.concat(Array.prototype.slice.call(arguments)));
      }

      i.$.itemContent.insertBefore(e, t || null);
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;
      if (!e) return void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "removeChild",
        node: "node"
      }));

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1149 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1149.concat(Array.prototype.slice.call(arguments)));
      }

      t.$.itemContent.removeChild(e);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        showCloseButton: {
          value: !1,
          type: "boolean"
        },
        iconClass: {
          value: null,
          type: "string?"
        },
        itemClass: {
          value: null,
          type: "string?"
        },
        opened: {
          value: !1,
          type: "boolean"
        }
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.toast.css"];
    }
  }]);

  return _class108;
}(Smart.ContentElement)), Smart("smart-toast",
/*#__PURE__*/
function (_Smart$ContentElement16) {
  "use strict";

  _inherits(_class109, _Smart$ContentElement16);

  function _class109() {
    _classCallCheck(this, _class109);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class109).apply(this, arguments));
  }

  _createClass(_class109, [{
    key: "template",
    value: function template() {
      return "";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "value":
          {
            var _e1150 = a._instances[a._instances.length - 1];
            _e1150 && (i instanceof HTMLElement ? _e1150.appendChild(i) : (_e1150.shadowRoot ? _e1150.shadowRoot : _e1150).querySelector(".smart-toast-item-content").innerHTML = i);
            break;
          }

        case "appendTo":
        case "modal":
        case "position":
          a._handleContainers();

          break;

        default:
          _get(_getPrototypeOf(_class109.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "attached",
    value: function attached() {
      _get(_getPrototypeOf(_class109.prototype), "attached", this).call(this);

      var e = this,
          t = ["TopLeft", "TopRight", "BottomLeft", "BottomRight", "Custom", "Modal"];

      for (var _a631 = 0; _a631 < t.length; _a631++) {
        var _i954 = e.$["toastContainer" + t[_a631]];
        _i954 && _i954.children.length && ("Custom" === t[_a631] ? e._appendTo.appendChild(e._container) : document.body.appendChild(_i954));
      }
    }
  }, {
    key: "detached",
    value: function detached() {
      _get(_getPrototypeOf(_class109.prototype), "detached", this).call(this);

      var e = this,
          t = ["TopLeft", "TopRight", "BottomLeft", "BottomRight", "Custom", "Modal"];

      for (var _a632 = 0; _a632 < t.length; _a632++) {
        var _i955 = e.$["toastContainer" + t[_a632]];
        _i955 && (e._removeContainerListeners(_i955), _i955.parentElement.removeChild(_i955)), e.closeAll();
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class109.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.value && !(e.value instanceof HTMLElement) ? e.innerHTML = e.value : e.value = e.innerHTML, e._instances = [], e.autoOpen && e.open(), _get(_getPrototypeOf(_class109.prototype), "render", this).call(this);
    }
  }, {
    key: "closeAll",
    value: function closeAll() {
      var e = this;

      for (var t = e._instances.length - 1; -1 < t; t--) {
        e._close(e._instances[t]);
      }
    }
  }, {
    key: "closeItem",
    value: function closeItem(e) {
      var t = this;
      e && 0 !== t._instances.length && ("string" == typeof e ? e = document.getElementById(e) : e instanceof HTMLElement && (e = e.closest("smart-toast-item")), e && -1 !== t._instances.indexOf(e) && t._close(e));
    }
  }, {
    key: "closeLast",
    value: function closeLast() {
      var e = this;
      0 < e._instances.length && e._close(e._instances[e._instances.length - 1]);
    }
  }, {
    key: "open",
    value: function open() {
      var e = this;
      if (e.disabled) return;

      e._handleContainers();

      var t = document.createElement("smart-toast-item");
      t.iconClass = e.iconClass, t.itemClass = e.itemClass, e.value instanceof HTMLElement ? t.appendChild(e.value) : t.innerHTML = e._handleItemTemplate() || e.value, t.animation = e.animation, t.showCloseButton = e.showCloseButton;

      for (var _a633 = 0; _a633 < e.classList.length; _a633++) {
        0 > e.classList[_a633].indexOf("smart-") && t.classList.add(e.classList[_a633]);
      }

      return e.type && t.classList.add(e.type), e._container.appendChild(t), t._parent = e._container, e._instances.push(t), e.$.fireEvent("open", {
        instance: t
      }), setTimeout(function () {
        t.opened = !0;
      }, 10), e.autoClose && (t._autoCloseTimeout = setTimeout(function () {
        e._close(t);
      }, e.autoCloseDelay)), t;
    }
  }, {
    key: "_containerClickHandler",
    value: function _containerClickHandler(e) {
      var t = this,
          i = e.target.shadowRoot ? e.composedPath()[0] : e.target,
          a = i.closest(".smart-toast-item-close-button"),
          n = (i.getRootNode().host || i).closest("smart-toast-item");
      a || n ? (t.$.fireEvent("click", {
        instance: n,
        target: i
      }), a && t._close(n)) : t.modal && t.closeAll();
    }
  }, {
    key: "_close",
    value: function _close(e) {
      var t = this;

      if (-1 < t._instances.indexOf(e)) {
        var _i956 = window.getComputedStyle(e, null).getPropertyValue("transition-duration"),
            _a634 = -1 < _i956.indexOf("ms") ? parseInt(_i956) : 1e3 * parseFloat(_i956);

        e.opened = !1, t._instances.splice(t._instances.indexOf(e), 1), setTimeout(function () {
          clearTimeout(e._autoCloseTimeout), t.$.fireEvent("close", {
            instance: e
          }), e.parentNode && e.parentNode.removeChild(e);
          var i = e._parent;
          i && !i.children.length && i.parentElement && (t._removeContainerListeners(i), i.parentElement.removeChild(i));
        }, _a634);
      }
    }
  }, {
    key: "_handleContainers",
    value: function _handleContainers() {
      var e = this;
      var t;
      return "string" == typeof e.appendTo ? t = document.getElementById(e.appendTo) : e.appendTo instanceof HTMLElement && (t = e.appendTo), e._container = e._getToastContainer(t), t ? (e._appendTo = t, void (e._container.parentElement || (e._addContainerListeners(e._container), e._appendTo.appendChild(e._container)))) : void (!t && e.$.toastContainerCustom && !e.$.toastContainerCustom.children.length && (e._removeContainerListeners(e.$.toastContainerCustom), e.$.toastContainerCustom.parentElement && e.$.toastContainerCustom.parentElement.removeChild(e.$.toastContainerCustom)), !e._container.parentElement && (e._addContainerListeners(e._container), document.body.appendChild(e._container)));
    }
  }, {
    key: "_addContainerListeners",
    value: function _addContainerListeners(e) {
      var t = this;

      if (e) {
        var _i957 = e.getAttribute("smart-id"),
            _a635 = t["$" + _i957];

        _a635 && (_a635.listen("click", t._containerClickHandler.bind(t)), _a635.listen("swipeleft", t._swipeHandler.bind(t)), _a635.listen("swiperight", t._swipeHandler.bind(t)), _a635.listen("swipetop", t._swipeHandler.bind(t)), _a635.listen("swipebottom", t._swipeHandler.bind(t)));
      }
    }
  }, {
    key: "_removeContainerListeners",
    value: function _removeContainerListeners(e) {
      var t = this;

      if (e) {
        var _i958 = e.getAttribute("smart-id"),
            _a636 = t["$" + _i958];

        _a636 && (_a636.unlisten("click"), _a636.unlisten("swipeleft"), _a636.unlisten("swiperight"), _a636.unlisten("swipetop"), _a636.unlisten("swipebottom"));
      }
    }
  }, {
    key: "_getToastContainer",
    value: function _getToastContainer(e) {
      var t = this;
      var i;
      e ? i = "Custom" : t.modal ? i = "Modal" : (i = Smart.Utilities.Core.toCamelCase(t.position), i = i.charAt(0).toUpperCase() + i.slice(1));
      var a = "toastContainer" + i;

      if (!t.$[a]) {
        var _e1151 = document.createElement("div");

        _e1151.setAttribute("smart-id", a), _e1151.classList.add("smart-toast-container"), _e1151.classList.add("smart-toast-container-" + Smart.Utilities.Core.toDash(i)), t.$["toastContainer" + i] = _e1151, t["$toastContainer" + i] = Smart.Utilities.Extend(_e1151);
      }

      return t.$[a];
    }
  }, {
    key: "_handleItemTemplate",
    value: function _handleItemTemplate() {
      var e = this;
      var t = e.itemTemplate;
      if (!("content" in document.createElement("template"))) return void e.error(e.localize("htmlTemplateNotSuported", {
        elementType: e.nodeName.toLowerCase()
      }));
      if (!t) return e.value;
      if (t = document.getElementById(t), null === t || !("content" in t)) return void e.error(e.localize("invalidTemplate", {
        elementType: e.nodeName.toLowerCase(),
        property: "template"
      }));
      var i = t.innerHTML,
          a = /{{\w+}}/g;
      return i.replace(a, e.value);
    }
  }, {
    key: "_swipeHandler",
    value: function _swipeHandler(e) {
      var t = this,
          i = e.originalEvent.target.closest("smart-toast-item");
      e.stopPropagation();
      i && t.$.fireEvent(e.type, {
        instance: i
      });
    }
  }, {
    key: "enableShadowDOM",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        appendTo: {
          value: null,
          type: "any"
        },
        autoClose: {
          value: !1,
          type: "boolean"
        },
        autoCloseDelay: {
          value: 3e3,
          type: "number"
        },
        autoOpen: {
          value: !1,
          type: "boolean"
        },
        iconClass: {
          value: null,
          type: "string?"
        },
        itemClass: {
          value: null,
          type: "string?"
        },
        itemTemplate: {
          value: null,
          type: "string?"
        },
        modal: {
          value: !1,
          type: "boolean"
        },
        position: {
          allowedValues: ["top-left", "top-right", "bottom-left", "bottom-right"],
          value: "top-right",
          type: "string"
        },
        showCloseButton: {
          value: !1,
          type: "boolean"
        },
        type: {
          allowedValues: ["info", "warning", "success", "error", "mail", "time", null],
          value: "info",
          type: "string?"
        },
        value: {
          value: "",
          type: "any"
        }
      };
    }
  }]);

  return _class109;
}(Smart.ContentElement)), Smart("smart-tooltip",
/*#__PURE__*/
function (_Smart$ContentElement17) {
  "use strict";

  _inherits(_class110, _Smart$ContentElement17);

  function _class110() {
    _classCallCheck(this, _class110);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class110).apply(this, arguments));
  }

  _createClass(_class110, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div id=\"content\" class=\"smart-tooltip-content\" inner-h-t-m-l=\"[[innerHTML]]\" role=\"presentation\">\n                        <content></content>\n                    </div>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class110.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      var n;
      "openMode" === e ? (a.close(), a._handleEventListeners(t), a._handleResize()) : "selector" === e ? (a._oldOwnerElement = a._ownerElement, a._handleSelector(i), a._handleEventListeners()) : "tooltipTemplate" === e ? a._handleTemplate(t) : "value" === e ? a.tooltipTemplate ? a._handleTemplate() : a.$.content.innerHTML = a.value : "visible" === e ? (n = i ? "open" : "close", a.$.fireEvent(n, {
        owner: a._ownerElement
      }, a.isInShadowDOM ? {
        composed: !0,
        bubbles: !0,
        cancelable: !0
      } : void 0)) : void 0;

      a._applyPosition();
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      _get(_getPrototypeOf(_class110.prototype), "ready", this).call(this), e.setAttribute("role", "tooltip"), e._isParentPositionStatic = "static" === window.getComputedStyle(e.parentElement || document.querySelector("body")).position, e._handleSelector(e.selector), e.visible && e._applyPosition(), e._handleEventListeners(), e._handleResize(), e.value = e.$.content.innerHTML = e.value ? e.value : e.innerHTML, e._handleTemplate();
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e1152 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1152.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? void (t.$.content.appendChild(e), t._applyPosition()) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "appendChild",
        node: "node"
      }));
    }
  }, {
    key: "close",
    value: function close() {
      var e = this;
      e._isOpening && clearTimeout(e._isOpening);
      e.visible && (e.$.fireEvent("close", {
        owner: e._ownerElement
      }, e.isInShadowDOM ? {
        composed: !0,
        bubbles: !0,
        cancelable: !0
      } : void 0), e.visible = !1);
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      var i = this;

      if (!i.isCompleted) {
        var _e1153 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(i, _e1153.concat(Array.prototype.slice.call(arguments)));
      }

      return e && t ? void (i.$.content.insertBefore(e, t), i._applyPosition()) : void i.error(i.localize("invalidNode", {
        elementType: i.nodeName.toLowerCase(),
        method: "insertBefore",
        node: "newNode/referenceNode"
      }));
    }
  }, {
    key: "open",
    value: function open() {
      var e = this;
      e.disabled || e.readonly || e.visible || (e._isOpening = setTimeout(function () {
        e._applyPosition(), e.$.fireEvent("open", {
          owner: e._ownerElement
        }, e.isInShadowDOM ? {
          composed: !0,
          bubbles: !0,
          cancelable: !0
        } : void 0);
        var t = e.context;
        e.context = e, e.visible = !0, e.context = t;
      }, e.delay));
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e1154 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.insertBefore.apply(t, _e1154.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? void (t.$.content.removeChild(e), t._applyPosition()) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "removeChild",
        node: "node"
      }));
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var e = this;
      e.visible ? e.close() : e.open();
    }
  }, {
    key: "_getDomElementPosition",
    value: function _getDomElementPosition(e) {
      var t = [],
          i = e.parentElement;

      for (; i && "BODY" !== i.nodeName;) {
        if (t.push(i), this.enableShadowDOM && !i.parentElement) {
          i = i.getRootNode().host;
          continue;
        }

        i = i.parentElement;
      }

      return t;
    }
  }, {
    key: "_getElementAndOwnerRelation",
    value: function _getElementAndOwnerRelation(e) {
      var t = this._getDomElementPosition(e || this),
          a = t.length;

      var n = null;

      for (var _o340 = 0, _i959; _o340 < a; _o340++) {
        if (_i959 = window.getComputedStyle(t[_o340]), "static" !== _i959.getPropertyValue("position")) {
          n = t[_o340];
          break;
        }
      }

      return n;
    }
  }, {
    key: "_applyPosition",
    value: function _applyPosition() {
      var e = this;
      if (!e._ownerElement) return;
      if (!e.parentElement) return;
      e._isParentPositionStatic = "static" === window.getComputedStyle(e.parentElement).position;

      var t = e._ownerElement.getBoundingClientRect(),
          i = e.parentElement ? e.parentElement.getBoundingClientRect() : {
        top: 0,
        left: 0
      };

      var a, n;
      e.parentElement && "BODY" === e.parentElement.nodeName.toUpperCase() ? (a = t.top + window.scrollY, n = t.left + window.scrollX) : (a = t.top - i.top, n = t.left - i.left);
      var o = {
        top: t.top,
        left: t.left,
        nonStaticParent: e._getElementAndOwnerRelation()
      },
          r = e.position;
      var l;

      switch (r) {
        case "auto":
        case "bottom":
        case "top":
        case "left":
        case "right":
          {
            var _t958 = e["_position" + r.charAt(0).toUpperCase() + r.slice(1)](n, a, o);

            a = _t958.top, n = _t958.left, l = _t958.translate;
            break;
          }

        case "absolute":
          e.style.top = e.style.left = "", a = n = 0;
      }

      l ? e.$.container.style.setProperty("--smart-tooltip-arrow-translate", l + "px") : e.$.container.style.removeProperty("--smart-tooltip-arrow-translate"), a === void 0 || isNaN(a) || (a += parseInt(e.offset[1]) || 0, e.style.top = a + "px"), n === void 0 || isNaN(n) || (n += parseInt(e.offset[0]) || 0, e.style.left = n + "px");
    }
  }, {
    key: "_positionAuto",
    value: function _positionAuto(e, t, i) {
      var a = Math.min,
          n = Math.max;
      var o = this;
      var r = o.parentElement,
          l;

      for (; r;) {
        if ("hidden" === getComputedStyle(r).getPropertyValue("overflow")) {
          l = r;
          break;
        }

        r = r.parentElement;
      }

      l || (l = document.body);
      var s = l.getBoundingClientRect(),
          d = parseFloat(window.getComputedStyle(o).getPropertyValue("--smart-tooltip-arrow-width")) || 0;

      var c = o._positionTop(e, t, i),
          m = i.nonStaticParent,
          u = o.offsetWidth / 2 - d,
          p = 0,
          g = 0;

      if (m) {
        var _e1155 = m.getBoundingClientRect();

        p = _e1155.top, g = _e1155.left;
      }

      return c.top + p >= s.top ? (t = c.top, e = n(s.left - g, c.left + a(0, s.right - (c.left + g + o.offsetWidth))), {
        left: e,
        top: t,
        translate: n(-u, a(u, c.left - e))
      }) : (c = o._positionBottom(e, t, i), c.top + o.offsetHeight + p <= s.bottom) ? (t = c.top, e = n(s.left - g, c.left + a(0, s.right - (c.left + g + o.offsetWidth))), {
        left: e,
        top: t,
        translate: n(-u, a(u, c.left - e))
      }) : (c = o._positionLeft(e, t, i), t = c.top, u = o.offsetHeight / 2 - d, t = n(s.top - p, c.top + a(0, s.bottom - (c.top + p + o.offsetHeight))), c.left + g >= s.left ? e = c.left : (c = o._positionRight(e, t, i), e = c.left), {
        left: e,
        top: t,
        translate: n(-u, a(u, c.top - t))
      });
    }
  }, {
    key: "_getRelativeParentOffset",
    value: function _getRelativeParentOffset(e) {
      var t = this,
          i = t._ownerElement;

      var a = t._getElementAndOwnerRelation(i),
          n = 0,
          o = 0;

      if (!e) return {
        left: o,
        top: n
      };

      for (; e !== a;) {
        n += a.offsetTop, o += a.offsetLeft, a = t._getElementAndOwnerRelation(a);
      }

      return {
        left: o,
        top: n
      };
    }
  }, {
    key: "_positionTop",
    value: function _positionTop(e, t, i) {
      var a = this,
          n = a._getRelativeParentOffset(i.nonStaticParent);

      if (a.set("arrowDirection", "bottom"), null === i.nonStaticParent) return t = i.top + window.scrollY - a.offsetHeight, e = i.left + window.scrollX - a.offsetWidth / 2 + a._ownerElement.offsetWidth / 2, {
        left: e + n.left,
        top: t + n.top
      };

      if (a._isParentPositionStatic) {
        if (t = a._ownerElement.offsetTop - a.offsetHeight, e = a._ownerElement.offsetLeft - a.offsetWidth / 2 + a._ownerElement.offsetWidth / 2, a._ownerElement instanceof SVGElement) {
          var _i960 = a._ownerElement.getBoundingClientRect(),
              _n481 = a._ownerElement.parentNode.getBoundingClientRect();

          t = _i960.top - _n481.top - a.offsetHeight / 2, e = _i960.left - a.offsetWidth / 2 + _n481.left / 2;
        }

        return {
          left: e + n.left,
          top: t + n.top
        };
      }

      if (a._ownerElement instanceof SVGElement && a._ownerElement.parentElement) {
        var _i961 = a._ownerElement.getBoundingClientRect(),
            _o341 = a._ownerElement.parentNode.getBoundingClientRect();

        return t = _i961.top - _o341.top - a.offsetHeight, e = _i961.left - _o341.left - a.offsetWidth / 2 + _i961.width / 2, {
          left: e + n.left,
          top: t + n.top
        };
      }

      return t -= a.offsetHeight, e = e - a.offsetWidth / 2 + a._ownerElement.offsetWidth / 2, {
        left: e + n.left,
        top: t + n.top
      };
    }
  }, {
    key: "_positionBottom",
    value: function _positionBottom(e, t, i) {
      var a = this,
          n = a._getRelativeParentOffset(i.nonStaticParent);

      return (a.set("arrowDirection", "top"), null === i.nonStaticParent) ? (t = i.top + window.scrollY + a._ownerElement.offsetHeight, e = i.left + window.scrollX - a.offsetWidth / 2 + a._ownerElement.offsetWidth / 2, {
        left: e + n.left,
        top: t + n.top
      }) : a._isParentPositionStatic ? (t = a._ownerElement.offsetTop + a._ownerElement.offsetHeight, e = a._ownerElement.offsetLeft - a.offsetWidth / 2 + a._ownerElement.offsetWidth / 2, {
        left: e + n.left,
        top: t + n.top
      }) : (t += a._ownerElement.offsetHeight, e = e - a.offsetWidth / 2 + a._ownerElement.offsetWidth / 2, {
        left: e + n.left,
        top: t + n.top
      });
    }
  }, {
    key: "_positionLeft",
    value: function _positionLeft(e, t, i) {
      var a = this,
          n = a._getRelativeParentOffset(i.nonStaticParent);

      return (a.set("arrowDirection", "right"), null === i.nonStaticParent) ? (t = i.top + window.scrollY + a._ownerElement.offsetHeight / 2 - a.$.content.offsetHeight / 2, e = i.left + window.scrollX - a.offsetWidth, {
        left: e + n.left,
        top: t + n.top
      }) : a._isParentPositionStatic ? (t = a._ownerElement.offsetTop + a._ownerElement.offsetHeight / 2 - a.$.content.offsetHeight / 2, e = a._ownerElement.offsetLeft - a.offsetWidth, {
        left: e + n.left,
        top: t + n.top
      }) : (t = t + a._ownerElement.offsetHeight / 2 - a.$.content.offsetHeight / 2, e -= a.offsetWidth, {
        left: e + n.left,
        top: t + n.top
      });
    }
  }, {
    key: "_positionRight",
    value: function _positionRight(e, t, i) {
      var a = this,
          n = a._getRelativeParentOffset(i.nonStaticParent);

      return (a.set("arrowDirection", "left"), null === i.nonStaticParent) ? (t = i.top + window.scrollY + a._ownerElement.offsetHeight / 2 - a.$.content.offsetHeight / 2, e = i.left + window.scrollX + a._ownerElement.offsetWidth, {
        left: e + n.left,
        top: t + n.top
      }) : a._isParentPositionStatic ? (t = a._ownerElement.offsetTop + a._ownerElement.offsetHeight / 2 - a.$.content.offsetHeight / 2, e = a._ownerElement.offsetLeft + a._ownerElement.offsetWidth, {
        left: e + n.left,
        top: t + n.top
      }) : (t = t + a._ownerElement.offsetHeight / 2 - a.$.content.offsetHeight / 2, e += a._ownerElement.offsetWidth, {
        left: e + n.left,
        top: t + n.top
      });
    }
  }, {
    key: "_eventsHandler",
    value: function _eventsHandler(e) {
      var t = this;
      return t.disabled || t.readonly ? void 0 : "click" === e.type ? void (t.visible ? this.close() : this.open()) : void ("mouseenter" === e.type || "focus" === e.type ? this.open() : this.close());
    }
  }, {
    key: "_handleEventListeners",
    value: function _handleEventListeners(e) {
      var t = this;

      if (t._oldOwnerElement && "manual" !== t.openMode) {
        var _e1156 = t._oldOwnerElement.getAttribute("aria-describedby");

        _e1156 && (_e1156 === t.id ? t._oldOwnerElement.removeAttribute("aria-describedby") : (_e1156 = _e1156.replace(" " + t.id, ""), _e1156 = _e1156.replace(t.id + " ", ""), t._oldOwnerElement.setAttribute("aria-describedby", _e1156))), t._oldOwnerElement.$.unlisten("mouseenter.tooltip"), t._oldOwnerElement.$.unlisten("mouseleave.tooltip"), t._oldOwnerElement.$.unlisten("focus.tooltip"), t._oldOwnerElement.$.unlisten("blur.tooltip"), t._oldOwnerElement.$.unlisten("click.tooltip"), t._oldOwnerElement = null;
      }

      if (t._ownerElement && (e && ("hover" === e ? (t._ownerElement.$.unlisten("mouseenter.tooltip"), t._ownerElement.$.unlisten("mouseleave.tooltip")) : "focus" === e ? (t._ownerElement.$.unlisten("focus.tooltip"), t._ownerElement.$.unlisten("blur.tooltip")) : "click" === e ? t._ownerElement.$.unlisten("click.tooltip") : void 0), "manual" !== t.openMode)) switch (t._ownerElement instanceof Smart.BaseElement || (t._ownerElement.$ = Smart.Utilities.Extend(t._ownerElement)), t.openMode) {
        case "hover":
          t._ownerElement.$.listen("mouseenter.tooltip", t._eventsHandler.bind(t)), t._ownerElement.$.listen("mouseleave.tooltip", t._eventsHandler.bind(t));
          break;

        case "focus":
          t._ownerElement.$.listen("focus.tooltip", t._eventsHandler.bind(t)), t._ownerElement.$.listen("blur.tooltip", t._eventsHandler.bind(t));
          break;

        case "click":
          t._ownerElement.$.listen("click.tooltip", t._eventsHandler.bind(t));

          break;

        default:
      }
    }
  }, {
    key: "_handleResize",
    value: function _handleResize() {
      function e() {
        t._applyPosition();
      }

      var t = this;
      "click" === t.openMode ? window.addEventListener("resize", e) : window.removeEventListener("resize", e);
    }
  }, {
    key: "_handleSelector",
    value: function _handleSelector(e) {
      var t = this;
      if ("string" == typeof e) t._ownerElement = 0 < e.length ? document.getElementById(e) : void 0;else if (e instanceof HTMLElement || e instanceof SVGElement) t._ownerElement = e;else {
        if (null === e) return void (t._ownerElement = void 0);
        t.error(t.localize("invalidSelector", {
          elementType: t.nodeName.toLowerCase(),
          property: "selector"
        }));
      }

      var i = t._ownerElement.getAttribute("aria-describedby");

      i ? t._ownerElement.setAttribute("aria-describedby", i + " " + t.id) : t._ownerElement.setAttribute("aria-describedby", t.id);
    }
  }, {
    key: "_handleTemplate",
    value: function _handleTemplate(e) {
      var t = this;
      var i = t.tooltipTemplate;
      if (e && (t.$.content.innerHTML = t.value ? t.value : ""), null === i || !i) return;
      if ("function" == typeof t.tooltipTemplate) return void t.tooltipTemplate(t.$.content, {
        value: t.value
      });
      if (!("content" in document.createElement("template"))) return void t.error(t.localize("htmlTemplateNotSuported", {
        elementType: t.nodeName.toLowerCase()
      }));
      if (i = document.getElementById(i), null === i || !("content" in i)) return void t.error(t.localize("invalidTemplate", {
        elementType: t.nodeName.toLowerCase(),
        property: "template"
      }));
      var a = i.content,
          n = a.childNodes.length,
          o = /{{\w+}}/g;
      var r = [],
          l;

      for (var _t959 = 0; _t959 < n; _t959++) {
        for (l = o.exec(a.childNodes[_t959].innerHTML); l;) {
          r.push({
            childNodeIndex: _t959,
            bindingString: l[0]
          }), l = o.exec(a.childNodes[_t959].innerHTML);
        }
      }

      var s = r.length;
      var d = document.importNode(i.content, !0),
          c,
          m;

      for (var _a637 = 0; _a637 < s; _a637++) {
        c = d.childNodes[r[_a637].childNodeIndex], m = r.length;

        for (var _e1157 = 0; _e1157 < m; _e1157++) {
          c.innerHTML = c.innerHTML.replace(r[_a637].bindingString, t.value);
        }
      }

      t.$.content.innerHTML = "";

      for (var _a638 = 0; _a638 < d.childNodes.length; _a638++) {
        d.childNodes[_a638].outerHTML && (t.$.content.innerHTML += d.childNodes[_a638].outerHTML);
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        arrow: {
          value: !1,
          type: "boolean"
        },
        arrowDirection: {
          allowedValues: ["bottom", "top", "left", "right"],
          value: "bottom",
          type: "string"
        },
        delay: {
          value: 0,
          type: "number"
        },
        messages: {
          extend: !0,
          value: {
            en: {
              invalidSelector: "{{elementType}}: \"{{property}}\" must be a String, an HTMLElement or null.",
              htmlTemplateNotSuported: "{{elementType}}: Browser doesn't support HTMLTemplate elements.",
              invalidTemplate: "{{elementType}}: \"{{property}}\" property accepts a string that must match the id of an HTMLTemplate element from the DOM.",
              invalidNode: "{{elementType}}: Invalid parameter \"{{node}}\" when calling {{method}}."
            }
          },
          type: "object"
        },
        offset: {
          value: [],
          type: "array"
        },
        openMode: {
          allowedValues: ["click", "focus", "hover", "manual"],
          value: "hover",
          type: "string"
        },
        position: {
          allowedValues: ["bottom", "top", "left", "right", "absolute", "auto"],
          value: "top",
          type: "string"
        },
        selector: {
          value: null,
          type: "any?"
        },
        tooltipTemplate: {
          value: null,
          type: "any"
        },
        value: {
          value: "",
          type: "string",
          reflectToAttribute: !1
        },
        visible: {
          value: !1,
          type: "boolean"
        }
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.tooltip.css"];
    }
  }]);

  return _class110;
}(Smart.ContentElement)), Smart("smart-tree-item",
/*#__PURE__*/
function (_Smart$MenuItem) {
  "use strict";

  _inherits(_class111, _Smart$MenuItem);

  function _class111() {
    _classCallCheck(this, _class111);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class111).apply(this, arguments));
  }

  _createClass(_class111, [{
    key: "ready",
    value: function ready() {
      Object.defineProperty(this, "hasStyleObserver", {
        get: function get() {
          return !1;
        }
      }), _get(_getPrototypeOf(_class111.prototype), "ready", this).call(this), this.setAttribute("role", "treeitem");
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this,
          n = a.menu;
      if ("level" === e) return void (a.level = t);

      if ("disabled" !== e && "separator" !== e && n) {
        var _o342 = n.context;

        switch (n.context = n, e) {
          case "label":
            {
              var _e1158 = n.sorted && n.autoSort;

              a.firstElementChild.firstElementChild.firstElementChild.innerHTML = i, _e1158 && (n._unsortItems(n.$.mainContainer), n._applyGrouping(n.$.mainContainer)), n._state.filter && n._applyFilter(n._state.filter);
              break;
            }

          case "selected":
            a.selected = t, i ? n.select(a) : n.unselect(a);
            break;

          case "shortcut":
            {
              var _e1159 = a.firstElementChild.children[1];
              _e1159 || (_e1159 = document.createElement("div"), _e1159.className = "smart-tree-item-shortcut", a.firstElementChild.appendChild(_e1159)), _e1159.innerHTML = i;
              break;
            }

          case "value":
            n.sort && n.sorted && n.autoSort && n._refreshSorting();
        }

        n.context = _o342;
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        selected: {
          value: !1,
          type: "boolean"
        }
      };
    }
  }]);

  return _class111;
}(Smart.MenuItem)), Smart("smart-tree-items-group",
/*#__PURE__*/
function (_Smart$MenuItemsGroup) {
  "use strict";

  _inherits(_class112, _Smart$MenuItemsGroup);

  function _class112() {
    _classCallCheck(this, _class112);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class112).apply(this, arguments));
  }

  _createClass(_class112, [{
    key: "ready",
    value: function ready() {
      Object.defineProperty(this, "hasStyleObserver", {
        get: function get() {
          return !1;
        }
      }), _get(_getPrototypeOf(_class112.prototype), "ready", this).call(this);
      var e = this;
      e.setAttribute("role", "treeitem"), e.removeAttribute("aria-haspopup");
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this,
          n = a.menu;
      if ("level" === e) return void (a.level = t);

      if ("disabled" !== e && "separator" !== e && n) {
        var _o343 = n.context;

        switch (n.context = n, e) {
          case "expanded":
            {
              a.expanded = t, i ? n.expandItem(a) : n.collapseItem(a);
              break;
            }

          case "label":
            {
              var _e1160 = n.sorted && n.autoSort;

              a.firstElementChild.firstElementChild.firstElementChild.innerHTML = i, _e1160 && (n._unsortItems(n.$.mainContainer), n._applyGrouping(n.$.mainContainer)), n._state.filter && n._applyFilter(n._state.filter);
              break;
            }

          case "selected":
            a.selected = t, i ? n.select(a) : n.unselect(a);
            break;

          case "value":
            n.sort && n.sorted && n.autoSort && n._refreshSorting();
        }

        n.context = _o343;
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        selected: {
          value: !1,
          type: "boolean"
        }
      };
    }
  }]);

  return _class112;
}(Smart.MenuItemsGroup)), Smart("smart-tree",
/*#__PURE__*/
function (_Smart$Menu2) {
  "use strict";

  _inherits(_class113, _Smart$Menu2);

  function _class113() {
    _classCallCheck(this, _class113);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class113).apply(this, arguments));
  }

  _createClass(_class113, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div class=\"smart-tree-filter-input-container\" role=\"presentation\">\n                        <input id=\"filterInput\" class=\"smart-filter-input\" disabled=\"[[disabled]]\" placeholder=\"[[filterInputPlaceholder]]\" type=\"text\" />\n                    </div>\n                    <smart-repeat-button id=\"scrollButtonNear\" class=\"smart-tree-scroll-button smart-spin-button smart-scroll-button-near smart-hidden\" animation=\"[[animation]]\" unfocusable aria-label=\"Scroll up\">\n                        <div id=\"arrowNear\" class=\"smart-arrow smart-arrow-up\"></div>\n                    </smart-repeat-button>\n                    <smart-scroll-viewer id=\"scrollViewer\" animation=\"[[animation]]\" horizontal-scroll-bar-visibility=\"hidden\" right-to-left=\"[[right-to-left]]\">\n                        <div id=\"mainContainer\" class=\"smart-tree-main-container\" role=\"presentation\">\n                            <content></content>\n                        </div>\n                        <input type=\"text\" id=\"editInput\" class=\"smart-tree-edit-input smart-hidden\" />\n                    </smart-scroll-viewer>\n                    <smart-repeat-button id=\"scrollButtonFar\" class=\"smart-tree-scroll-button smart-spin-button smart-scroll-button-far smart-hidden\" animation=\"[[animation]]\" unfocusable aria-label=\"Scroll down\">\n                        <div id=\"arrowFar\" class=\"smart-arrow smart-arrow-down\"></div>\n                    </smart-repeat-button>\n                    <div id=\"loadingIndicatorContainer\" class=\"smart-loader-container smart-hidden\">\n                        <span id=\"loadingIndicator\" class=\"smart-loader\"></span>\n                        <span id=\"loadingIndicatorPlaceHolder\" class=\"smart-loader-label smart-hidden\">[[loadingIndicatorPlaceholder]]</span>\n                    </div>\n                </div>";
    }
  }, {
    key: "addAfter",
    value: function addAfter(e, t) {
      var i = this;
      t = i.getItem(t);
      void 0 === t || i.addTo(e, t.parentItem, t, !0);
    }
  }, {
    key: "addBefore",
    value: function addBefore(e, t) {
      var i = this;
      t = i.getItem(t);
      void 0 === t || i.addTo(e, t.parentItem, t);
    }
  }, {
    key: "addTo",
    value: function addTo(e, t) {
      var i = this;
      if (!(e instanceof Smart.TreeItem || e instanceof Smart.TreeItemsGroup)) return;
      var a, n;
      if (void 0 === t) t = i.$.mainContainer, a = 1, n = t;else {
        if (t = i.getItem(t), !1 == t instanceof Smart.TreeItemsGroup) return;
        a = t.level + 1, n = t.itemContainer;
      }

      i._createItemHTMLStructure(e, a, t, n.childElementCount, 0);

      var o = i.sorted && i.autoSort,
          r = i._state.filter,
          l = i.selectedIndexes.slice(0);
      o && i._unsortItems(i.$.mainContainer), e instanceof Smart.TreeItemsGroup && i._processHTML(e, a + 1, !1);
      var s = arguments[2];
      s && arguments[3] && (s = s.nextElementSibling), s ? (n.insertBefore(e, s), i._menuItems = {}, i._refreshItemPaths(i.$.mainContainer, !0, void 0, i.sorted && !i.autoSort)) : n.appendChild(e), o && i._applyGrouping(i.$.mainContainer), r && i._applyFilter(r), i._checkOverflow(), i._expandItemsByDefault(), i.selectedIndexes = [], i._applySelection(!0, l);
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      var e = this,
          t = e.selectedIndexes.slice(0);
      e.selectedIndexes = [], e._applySelection(!1, t);
    }
  }, {
    key: "collapseAll",
    value: function collapseAll(e) {
      var t = this,
          i = t.animation,
          a = !1 === e && t.hasAnimation;
      a && (t.animation = "none"), t._collapseAll(!0), a && (t.animation = i);
    }
  }, {
    key: "ensureVisible",
    value: function ensureVisible(e) {
      var t = this;
      if (e = t.getItem(e), void 0 === e || e.hidden) return;
      var i = !1;
      1 < e.level && !t._isBranchExpanded(e) && (_get(_getPrototypeOf(_class113.prototype), "expandItem", this).call(this, e.parentItem, void 0, !1), i = t.hasAnimation, i && (t._ensureVisibleOnTransitionend = e)), i || t._ensureVisible(e);
    }
  }, {
    key: "expandAll",
    value: function expandAll(e) {
      var t = this,
          i = t.animation,
          a = !1 === e && t.hasAnimation;
      var n = 1,
          o = (t.enableShadowDOM ? t.shadowRoot : t).querySelectorAll("smart-tree-items-group[level=\"1\"]");

      for (a && (t.animation = "none"); 0 < o.length;) {
        for (var _e1161 = 0; _e1161 < o.length; _e1161++) {
          var _i962 = o[_e1161];
          _i962.expanded || t._menuItemsGroupSelectionHandler(_i962, {
            target: _i962,
            type: "expand"
          });
        }

        n++, o = (t.enableShadowDOM ? t.shadowRoot : t).querySelectorAll("smart-tree-items-group[level=\"" + n + "\"]");
      }

      a && (t.animation = i);
    }
  }, {
    key: "expandItem",
    value: function expandItem(e, t) {
      var i = this;

      if (e = i.getItem(e), !(void 0 === e || !1 == e instanceof Smart.TreeItemsGroup || i._isContainerOpened(e.container.level, e.container))) {
        var _a639 = !1 === t && i.hasAnimation,
            _n482 = i.animation;

        _a639 && (i.animation = "none"), i._discardKeyboardHover(), i._menuItemsGroupSelectionHandler(e, {
          target: e,
          type: "expand"
        }, arguments[2]), _a639 && (i.animation = _n482);
      }
    }
  }, {
    key: "filter",
    value: function filter(e) {
      var t = this;
      t.filterable && (t._applyFilter(e), t.$.filterInput.value = e);
    }
  }, {
    key: "getState",
    value: function getState() {
      return JSON.parse(JSON.stringify(this._state));
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      function a(e) {
        var t = e[i.itemsMember] || [],
            n = "smart-tree-items-group" === e.tagName || 0 < t.length ? "smart-tree-items-group" : "smart-tree-item",
            o = document.createElement(n);

        if (e.disabled && (o.disabled = !0), e[i.displayMember] && (o.label = e[i.displayMember]), e.separator && (o.separator = !0), e[i.valueMember] && (o.value = e[i.valueMember]), "smart-tree-items-group" == n) {
          e.expanded && (o.expanded = !0);

          for (var _e1162 = 0; _e1162 < t.length; _e1162++) {
            o.appendChild(a(t[_e1162]));
          }
        } else e.shortcut && (o.shortcut = e.shortcut);

        return o;
      }

      var i = this;
      var n;

      if (e instanceof Smart.TreeItem || e instanceof Smart.TreeItemsGroup) {
        if (i.contains(e)) return;
        n = e;
      } else if ("object" == typeof e && e.constructor === Object) n = a(e);else return;

      if (void 0 === t) return void i.addTo(n);
      if ("number" == typeof t) t = t.toString();else if (t instanceof Smart.TreeItem || t instanceof Smart.TreeItemsGroup) {
        if (!i.contains(t)) return;
        t = t.path;
      } else if ("string" != typeof t) return;
      var o = t.split(".");
      var r, l;
      1 === o.length ? (l = i._menuItems[o[0]], l ? i.addBefore(n, l) : i.addTo(n)) : (l = i._menuItems[t], r = i._menuItems[o.slice(0, o.length - 1).join(".")], l ? i.addBefore(n, l) : r && r instanceof Smart.TreeItemsGroup && i.addTo(n, r));
    }
  }, {
    key: "loadState",
    value: function loadState(e) {
      var t = this,
          i = t.selectedIndexes.slice(0),
          a = [];

      if (!e) {
        if (!t.id) return void t.warn(t.localize("noId"));
        e = window.localStorage.getItem("smartTree" + t.id);
      }

      "string" == typeof e && (e = JSON.parse(e)), e.filter && !t.filterable && (e.filter = "");
      var n = e.filter !== t._state.filter,
          o = e.sorted !== t.sorted;
      o ? (t.sorted = e.sorted, t._updateState("sorted", t.sorted), e.sorted ? t._applyGrouping(t.$.mainContainer) : t._unsortItems(t.$.mainContainer), (e.filter || n) && (t._applyFilter(e.filter), t.$.filterInput.value = e.filter)) : n && (t._applyFilter(e.filter), t.$.filterInput.value = e.filter), t._menuItemsGroupsToExpand = [];

      for (var _a640 = 0; _a640 < e.expanded.length; _a640++) {
        var _i963 = t.getItem(e.expanded[_a640]);

        _i963 && t._menuItemsGroupsToExpand.push(_i963);
      }

      t._expandItemsByDefault(!0);

      for (var _n483 = 0; _n483 < e.selected.length; _n483++) {
        var _i964 = t.getItem(e.selected[_n483]);

        _i964 && a.push(_i964.path);
      }

      t.selectedIndexes = a, t._applySelection(!1, i);
    }
  }, {
    key: "moveDown",
    value: function moveDown(e) {
      var t = this;
      e = t.getItem(e);
      var i = e.nextElementSibling;
      void 0 === e || !i || t.sorted || (t._moveTreeItem(e, i, 2, [t]), t.filterable && t._state.filter && t._applyFilter(t._state.filter));
    }
  }, {
    key: "moveUp",
    value: function moveUp(e) {
      var t = this;
      e = t.getItem(e);
      var i = e.previousElementSibling;
      void 0 === e || !i || t.sorted || (t._moveTreeItem(e, i, 0, [t]), t.filterable && t._state.filter && t._applyFilter(t._state.filter));
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this._checkOverflow();
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      var t = this;

      if (e = t.getItem(e), void 0 !== e) {
        if (e instanceof Smart.TreeItemsGroup) {
          var _i966 = e.container;
          t._isContainerOpened(_i966.level, _i966) && t._closeSubContainersTreeMode(_i966.level, _i966);
        }

        var _i965 = t.sorted && t.autoSort;

        _i965 && t._unsortItems(t.$.mainContainer), e.parentElement.removeChild(e), t._menuItems = {}, t._refreshItemPaths(t.$.mainContainer, !0, void 0, t.sorted && !t.autoSort), _i965 && t._applyGrouping(t.$.mainContainer);

        var _a641 = t._state.filter,
            _n484 = t.selectedIndexes.slice(0);

        _a641 && t._applyFilter(_a641), t._checkOverflow(), t.selectedIndexes = [], t._applySelection(!0, _n484);
      }
    }
  }, {
    key: "saveState",
    value: function saveState() {
      var e = this;
      return e.id ? window.localStorage.setItem("smartTree" + e.id, JSON.stringify(e._state)) : e.warn(e.localize("noId")), JSON.parse(JSON.stringify(e._state));
    }
  }, {
    key: "select",
    value: function select(e) {
      var t = this;
      e = t.getItem(e);
      void 0 === e || e.selected || e.templateApplied || t._handleSelection(e, {
        type: "programmatic"
      });
    }
  }, {
    key: "unselect",
    value: function unselect(e) {
      var t = this;
      e = t.getItem(e);
      void 0 === e || !e.selected || e.templateApplied || t._handleSelection(e, {
        type: "programmatic"
      });
    }
  }, {
    key: "updateItem",
    value: function updateItem(e, t) {
      var i = this;

      if (e = i.getItem(e), void 0 !== e && void 0 !== t) {
        var _i967 = e instanceof Smart.TreeItem;

        for (var _a642 in t) {
          if (t.hasOwnProperty(_a642)) {
            if (_i967) {
              if (-1 === ["disabled", "label", "level", "selected", "separator", "shortcut", "value"].indexOf(_a642)) continue;
            } else if (-1 === ["disabled", "expanded", "label", "level", "selected", "separator", "value"].indexOf(_a642)) continue;

            e[_a642] = t[_a642];
          }
        }
      }
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "allowDrag":
        case "allowDrop":
        case "autoLoadState":
        case "autoSort":
        case "editable":
        case "filterInputPlaceholder":
        case "loadingIndicatorPlaceholder":
        case "selectionDisplayMode":
        case "showLines":
        case "showRootLines":
        case "toggleElementPosition":
        case "toggleMode":
          break;

        case "autoHideToggleElement":
          i ? a.$mainContainer.addClass("hidden-arrows") : a.$mainContainer.removeClass("hidden-arrows");
          break;

        case "autoSaveState":
          if (!i) return;
          if (!a.id) return a.warn(a.localize("noId")), void (a.autoSaveState = !1);
          window.localStorage.setItem("smartTree" + a.id, JSON.stringify(a._state));
          break;

        case "dataSource":
          {
            var _e1163 = a.selectedIndexes.slice(0);

            a.selectedIndexes = [], a._menuItems = {}, a._processDataSource(), a._checkOverflow(), a._expandItemsByDefault(), a._applySelection(!0, _e1163);
            var _t960 = a._state.filter;
            _t960 && a._applyFilter(_t960);
            break;
          }

        case "disabled":
          a._setFocusable(), a.$.scrollButtonNear.disabled = i, a.$.scrollButtonFar.disabled = i, i || a._updateScrollButtonVisibility();
          break;

        case "displayLoadingIndicator":
          i ? (a._discardKeyboardHover(!0), a.$loadingIndicatorContainer.removeClass("smart-hidden")) : a.$loadingIndicatorContainer.addClass("smart-hidden");
          break;

        case "filterable":
          !1 === i && (a._applyFilter(""), a.$.filterInput.value = ""), a._checkOverflow();
          break;

        case "filterMode":
          a.filterable && a._state.filter && a._applyFilter(a._state.filter);
          break;

        case "hasThreeStates":
          if ("checkBox" !== a.selectionMode) return;
          if (i) a._applySelection(!1);else {
            var _e1164 = (a.enableShadowDOM ? a.shadowRoot : a).querySelectorAll("[indeterminate]");

            for (var _t961 = 0; _t961 < _e1164.length; _t961++) {
              _e1164[_t961].removeAttribute("indeterminate");
            }
          }
          break;

        case "loadingIndicatorPosition":
          "center" === i ? a.$loadingIndicatorPlaceHolder.addClass("smart-hidden") : a.$loadingIndicatorPlaceHolder.removeClass("smart-hidden");
          break;

        case "overflow":
          if ("scrollbar" === a.scrollMode) return "hidden" === i ? a.$.scrollViewer.$.verticalScrollBar.setAttribute("aria-hidden", !0) : a.$.scrollViewer.$.verticalScrollBar.removeAttribute("aria-hidden"), void (a.$.scrollViewer.verticalScrollBarVisibility = "scroll" === i ? "visible" : "auto");
          a.$.scrollViewer.scrollTop = 0, "hidden" === i ? (a.$scrollViewer.removeClass("scroll-buttons-shown"), a.$scrollButtonNear.addClass("smart-hidden"), a.$scrollButtonFar.addClass("smart-hidden")) : (a.$.scrollButtonNear.disabled = a.disabled, a.$.scrollButtonFar.disabled = a.disabled, "auto" === i ? (a.$scrollButtonNear.addClass("smart-hidden"), a.$scrollButtonFar.addClass("smart-hidden"), a._checkOverflow()) : (a.$scrollViewer.addClass("scroll-buttons-shown"), a.$scrollViewer.removeClass("one-button-shown"), a.$scrollButtonNear.removeClass("smart-hidden"), a.$scrollButtonFar.removeClass("smart-hidden"), a._updateScrollButtonVisibility())), a.$.scrollViewer.refresh();
          break;

        case "rightToLeft":
          {
            var _e1165, _t962;

            for (var _n485 in i ? (_e1165 = "paddingLeft", _t962 = "paddingRight") : (_e1165 = "paddingRight", _t962 = "paddingLeft"), a._menuItems) {
              if (a._menuItems.hasOwnProperty(_n485)) {
                var _i968 = a._menuItems[_n485],
                    _o344 = _i968.firstElementChild;
                _o344.style[_e1165] = "", a._setIndentation(_o344, _i968.level, _t962);
              }
            }

            break;
          }

        case "scrollMode":
          if ("hidden" === a.overflow) return;
          if (a.$.scrollViewer.scrollTop = 0, "scrollButtons" === i) return "scroll" === a.overflow && (a.$scrollViewer.addClass("scroll-buttons-shown"), a.$scrollButtonNear.removeClass("smart-hidden"), a.$scrollButtonFar.removeClass("smart-hidden")), a.$.scrollViewer.$.verticalScrollBar.setAttribute("aria-hidden", !0), a.$.scrollViewer.verticalScrollBarVisibility = "auto", void a._checkOverflow();
          a.$.scrollViewer.$.verticalScrollBar.removeAttribute("aria-hidden"), a.$scrollViewer.removeClass("scroll-buttons-shown"), a.$scrollViewer.removeClass("one-button-shown"), a.$scrollButtonNear.addClass("smart-hidden"), a.$scrollButtonFar.addClass("smart-hidden"), a.$.scrollViewer.verticalScrollBarVisibility = "auto" === a.overflow ? "auto" : "visible";
          break;

        case "selectedIndexes":
          a._applySelection(!1, t);

          break;

        case "selectionMode":
          if (a.setAttribute("aria-multiselectable", -1 !== ["oneOrManyExtended", "zeroOrMany", "oneOrMany", "checkBox", "radioButton"].indexOf(i)), void 0 === a._menuItems[0]) return;
          if ("one" === t && "none" !== i && "checkBox" !== i && "radioButton" !== i || -1 !== t.indexOf("oneOrMany") && -1 !== i.indexOf("oneOrMany") || "none" === t && (-1 !== i.indexOf("zero") || "checkBox" === i) || "zeroOrMany" === i && "checkBox" !== t || "radioButton" === t && -1 !== i.indexOf("Many") || !a.hasThreeStates && ("checkBox" === i || "checkBox" === t && "zeroOrMany" === i)) return a._lastSelectedItem = "one" === i || "oneOrManyExtended" === i ? a._menuItems[a.selectedIndexes[a.selectedIndexes.length - 1]] : void 0, void a._applyAriaSelected();

          if (a.hasThreeStates && "checkBox" === t) {
            var _e1166 = (a.enableShadowDOM ? a.shadowRoot : a).querySelectorAll("[indeterminate]");

            for (var _t963 = 0; _t963 < _e1166.length; _t963++) {
              _e1166[_t963].removeAttribute("indeterminate");
            }
          }

          a._applySelection(!1);

          break;

        case "sort":
          {
            if (!a.sorted) return;

            a._refreshSorting();

            break;
          }

        case "sortDirection":
          a.sorted && !a.sort && (a._unsortItems(a.$.mainContainer), a._applyGrouping(a.$.mainContainer));
          break;

        case "sorted":
          {
            if (!i && !a.autoSort) return a._refreshItemPathsAndSelection(), void a._updateState("sorted", !1);
            i ? a._applyGrouping(a.$.mainContainer) : a._unsortItems(a.$.mainContainer);
            var _e1167 = a._state.filter;
            _e1167 && a._applyFilter(_e1167), a._updateState("sorted", i), a._checkOverflow();
            break;
          }

        case "unfocusable":
          a._setFocusable();

      }
    }
  }, {
    key: "_addDragFeedback",
    value: function _addDragFeedback() {
      var e = this,
          t = document.createElement("div");
      return t.className = "smart-tree-item-feedback", t.setAttribute("parent-tree-id", e.id), e.theme && t.classList.add(e.theme), e.dragFeedbackFormatFunction ? t.innerHTML = e.dragFeedbackFormatFunction(e._dragDetails.Items) : 1 === e._dragDetails.Items.length ? t.innerHTML = e._dragDetails.Item.label : (t.classList.add("multiple"), t.innerHTML = "&#xf0c5;"), document.body.appendChild(t), t;
    }
  }, {
    key: "_applyFilter",
    value: function _applyFilter(e) {
      function t(e, t) {
        e ? (t.hidden && t.$.removeClass("smart-hidden"), t.hidden = !1) : (!t.hidden && t.$.addClass("smart-hidden"), t.hidden = !0);
      }

      function a(i, o) {
        var r = !1,
            l = 0,
            s;
        o = Array.from(o);

        for (var d = 0; d < o.length; d++) {
          var _i969 = o[d];
          _i969 instanceof Smart.TreeItem ? t(n._findItem(_i969, e), _i969) : a(_i969, _i969.itemContainer.children), _i969.hidden || (l++, s = _i969), r = r || !_i969.hidden;
        }

        if (i !== n.$.mainContainer) {
          var _a643 = n._findItem(i, e);

          t(r || _a643, i), r && null === _a643 ? i.$.addClass("filtered-child") : i.$.removeClass("filtered-child"), !r && 0 < o.length ? (i.hiddenChildren = !0, i.$.addClass("hidden-children"), n.collapseItem(i, void 0, !1)) : (i.hiddenChildren = !1, i.$.removeClass("hidden-children"));
        }

        "" !== e && 0 < l && s.$.addClass("last-filtered-child");
      }

      var n = this;

      if ("" !== e || n.hasAttribute("filter-applied")) {
        var _t964 = Array.from(n.$.mainContainer.getElementsByClassName("last-filtered-child"));

        for (var _e1168 = 0; _e1168 < _t964.length; _e1168++) {
          _t964[_e1168].$.removeClass("last-filtered-child");
        }

        a(n.$.mainContainer, n.$.mainContainer.children), "" === e ? n.removeAttribute("filter-applied") : n.setAttribute("filter-applied", ""), n._updateState("filter", e), n._checkOverflow();
      }
    }
  }, {
    key: "_applyHierarchicalSelection",
    value: function _applyHierarchicalSelection(e, t) {
      var a = this,
          n = e !== a.$.mainContainer,
          o = n ? e.itemContainer.children : e.children;
      var r = 0,
          l = 0;

      for (var _s106 = 0; _s106 < o.length; _s106++) {
        var _i970 = o[_s106];
        e.selected && _i970.set("selected", !0), _i970 instanceof Smart.TreeItemsGroup ? a._applyHierarchicalSelection(_i970, t) : _i970.selected && t.push(_i970.path), n && (_i970.selected ? r++ : _i970.hasAttribute("indeterminate") && l++);
      }

      n && (a._setThreeStateCheckbox(e, r, l), e.selected && t.push(e.path));
    }
  }, {
    key: "_applyRadioButtonSelection",
    value: function _applyRadioButtonSelection(e, t, a) {
      var n = this,
          o = e === n.$.mainContainer ? e.children : e.itemContainer.children,
          r = [];
      var i;

      for (var _l148 = 0; _l148 < o.length; _l148++) {
        var _e1169 = o[_l148];
        _e1169 instanceof Smart.TreeItemsGroup && n._applyRadioButtonSelection(_e1169, t, a), _e1169.set("selected", !1), -1 !== t.indexOf(_e1169.path) && r.push(_e1169);
      }

      i = 0 === r.length ? o[0] : r[r.length - 1], i.set("selected", !0), a.push(i.path);
    }
  }, {
    key: "_applySelection",
    value: function _applySelection(e, t) {
      var a = this;
      var n = a.selectedIndexes.slice(0);
      if (void 0 === t && (t = n.slice(0)), void 0 === a._menuItems[0]) return a.selectedIndexes = [], a._lastSelectedItem = void 0, void (a.isRendered && JSON.stringify(t) !== JSON.stringify([]) && a.$.fireEvent("change", {
        selectedIndexes: a.selectedIndexes,
        oldSelectedIndexes: t
      }));
      var i = a.selectionMode,
          o = Array.from((a.shadowRoot || a).querySelectorAll("smart-tree-item[selected], smart-tree-items-group[selected]"));

      for (var _o345 = n.length - 1; 0 <= _o345; _o345--) {
        var _e1170 = a._menuItems[n[_o345]];
        void 0 === _e1170 && n.splice(_o345, 1);
      }

      if (e) for (var _e1171 = 0; _e1171 < o.length; _e1171++) {
        -1 === n.indexOf(o[_e1171].path) && n.push(o[_e1171].path);
      } else {
        for (var _e1172 = 0; _e1172 < o.length; _e1172++) {
          o[_e1172].set("selected", !1);
        }

        o.length = 0;
      }

      switch (a._sortPathCollection(n), i) {
        case "none":
          n.length = 0;

          for (var _e1173 = 0; _e1173 < o.length; _e1173++) {
            o[_e1173].set("selected", !1);
          }

          break;

        case "one":
        case "zeroOrOne":
          "zeroOrOne" !== i && 0 === n.length && n.push("0");

          for (var _e1174 = 0; _e1174 < n.length; _e1174++) {
            var _t965 = a._menuItems[n[_e1174]];

            if (_e1174 == n.length - 1) {
              _t965.set("selected", !0), n = [n[_e1174]];
              break;
            }

            -1 !== o.indexOf(_t965) && _t965.set("selected", !1);
          }

          break;

        case "oneOrMany":
        case "oneOrManyExtended":
          0 === n.length && n.push("0");

          for (var _e1175 = 0; _e1175 < n.length; _e1175++) {
            a._menuItems[n[_e1175]].set("selected", !0);
          }

          break;

        case "zeroOrMany":
        case "checkBox":
          for (var _e1176 = 0; _e1176 < n.length; _e1176++) {
            a._menuItems[n[_e1176]].set("selected", !0);
          }

          if ("checkBox" === i && a.hasThreeStates) {
            var _e1177 = [];
            a._applyHierarchicalSelection(a.$.mainContainer, _e1177), a._sortPathCollection(_e1177), n = _e1177;
          }

          break;

        case "radioButton":
          {
            var _e1178 = [];
            a._applyRadioButtonSelection(a.$.mainContainer, n, _e1178), a._sortPathCollection(_e1178), n = _e1178;
            break;
          }
      }

      a.selectedIndexes = n, a._updateState("selected"), a._lastSelectedItem = "one" === i || "oneOrManyExtended" === i ? a._menuItems[n[n.length - 1]] : void 0, a.isRendered && !1 !== arguments[2] && JSON.stringify(t) !== JSON.stringify(n) && a.$.fireEvent("change", {
        selectedIndexes: a.selectedIndexes,
        oldSelectedIndexes: t
      }), a._applyAriaSelected();
    }
  }, {
    key: "_applyAriaSelected",
    value: function _applyAriaSelected() {
      var e = this,
          t = e.selectionMode;

      for (var _i971 in e._menuItems) {
        var _a644 = e._menuItems[_i971];
        _a644.selected ? _a644.setAttribute("aria-selected", !0) : e._canItemBeSelected(_a644) && -1 !== ["oneOrManyExtended", "zeroOrMany", "oneOrMany", "checkBox", "radioButton"].indexOf(t) ? _a644.setAttribute("aria-selected", !1) : _a644.removeAttribute("aria-selected");
      }
    }
  }, {
    key: "_autoLoadState",
    value: function _autoLoadState(e) {
      var t = this,
          a = [];

      for (var _a645 = 0; _a645 < t._menuItemsGroupsToExpand.length; _a645++) {
        t._menuItemsGroupsToExpand[_a645].set("expanded", !1);
      }

      t._menuItemsGroupsToExpand = [];

      for (var _a646 = 0; _a646 < e.expanded.length; _a646++) {
        var _i972 = t.getItem(e.expanded[_a646]);

        _i972 && t._menuItemsGroupsToExpand.push(_i972);
      }

      t.filterable && e.filter && (t._applyFilter(e.filter), t.$.filterInput.value = e.filter);

      for (var _n486 = 0; _n486 < e.selected.length; _n486++) {
        var _i973 = t.getItem(e.selected[_n486]);

        _i973 && a.push(_i973.path);
      }

      t.selectedIndexes = a;
    }
  }, {
    key: "_blurHandler",
    value: function _blurHandler() {
      this._discardKeyboardHover(!0);
    }
  }, {
    key: "_canItemBeHovered",
    value: function _canItemBeHovered(e) {
      var t = e.level;
      return !1 === e.disabled && !0 !== e.templateApplied && !0 !== e.hidden && (1 === t || 1 < t && this._isContainerOpened(t, e.parentElement.container) && 0 < e.getBoundingClientRect().height);
    }
  }, {
    key: "_canItemBeSelected",
    value: function _canItemBeSelected(e) {
      return !1 === e.disabled && !0 !== e.templateApplied;
    }
  }, {
    key: "_checkOverflow",
    value: function _checkOverflow() {
      var e = Math.round;
      var t = this,
          i = t.$.scrollViewer,
          a = t.overflow;
      if ("scrollbar" === t.scrollMode || "hidden" === a) return void i.refresh();
      var n = i.scrollTop;
      "auto" === a && (i.$.removeClass("scroll-buttons-shown"), i.$.removeClass("one-button-shown"), t.$scrollButtonNear.addClass("smart-hidden"), t.$scrollButtonFar.addClass("smart-hidden"));
      var o = e(i.$.scrollViewerContentContainer.offsetHeight) > e(i.$.scrollViewerContainer.offsetHeight),
          r = 0 < e(i.scrollTop),
          l = e(i.$.scrollViewerContainer.offsetHeight + i.scrollTop) < e(i.$.scrollViewerContentContainer.offsetHeight);
      o ? "auto" === a ? (i.$.addClass("scroll-buttons-shown"), r && t.$scrollButtonNear.removeClass("smart-hidden"), l && t.$scrollButtonFar.removeClass("smart-hidden"), !1 == (r && l) && i.$.addClass("one-button-shown"), !t.disabled && (t.$.scrollButtonNear.disabled = !1, t.$.scrollButtonFar.disabled = !1), i.scrollTop = n) : (t.$scrollButtonNear.removeClass("smart-hidden"), t.$scrollButtonFar.removeClass("smart-hidden"), t.disabled ? (t.$.scrollButtonNear.disabled = !0, t.$.scrollButtonFar.disabled = !0) : (t.$.scrollButtonNear.disabled = !r, t.$.scrollButtonFar.disabled = !l)) : "scroll" === a && (t.$.scrollButtonNear.disabled = !0, t.$.scrollButtonFar.disabled = !0), i.refresh();
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this,
          t = window.getComputedStyle(e.$.scrollViewer);
      e.setAttribute("role", "tree"), e.setAttribute("aria-multiselectable", -1 !== ["oneOrManyExtended", "zeroOrMany", "oneOrMany", "checkBox", "radioButton"].indexOf(e.selectionMode)), e.setAttribute("aria-orientation", "vertical"), e.$.scrollViewer.onVerticalChange = e._verticalScrollbarHandler, Object.defineProperty(e, "dataSource", {
        get: function get() {
          return e.context === e ? e.properties.dataSource.value : e._getDataSource();
        },
        set: function set(t) {
          e.updateProperty(e, e._properties.dataSource, t);
        }
      }), !e.id && (e.autoLoadState || e.autoSaveState) && (e.warn(e.localize("noId")), e.autoLoadState = !1, e.autoSaveState = !1), e.mode = "tree", e._element = "tree", e._isMobile = Smart.Utilities.Core.isMobile, e._edgeMacFF = !1, e._autoScrollCoefficient = Smart.Utilities.Core.Browser.Firefox ? 4 : Smart.Utilities.Core.Browser.Edge ? 8 : 2, e._scrollViewerPadding = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom) || 0, e._state = {
        expanded: [],
        filter: "",
        selected: []
      }, e._dblclickObject = {
        numberOfClicks: 0
      }, e.autoHideToggleElement && e.$mainContainer.addClass("hidden-arrows"), e.disabled && (e.$.scrollButtonNear.disabled = !0, e.$.scrollButtonFar.disabled = !0), "scrollbar" === e.scrollMode && "scroll" === e.overflow && (e.$.scrollViewer.verticalScrollBarVisibility = "visible"), null === e.dataSource && e.$.mainContainer.firstElementChild instanceof HTMLUListElement && e._processUList();

      var i = (e.shadowRoot || e).querySelectorAll("smart-tree-item, smart-tree-items-group"),
          a = function a() {
        var t;
        e.autoLoadState && (t = window.localStorage.getItem("smartTree" + e.id), t && (t = JSON.parse(t), e.sorted = t.sorted)), e._setFocusable(), e._menuItems = {}, null === e.dataSource ? e._processHTML(e.$.mainContainer, 1) : e._processDataSource(), ("scrollButtons" === e.scrollMode || "hidden" === e.overflow) && e.$.scrollViewer.$.verticalScrollBar.setAttribute("aria-hidden", !0), "scrollButtons" === e.scrollMode && "scroll" === e.overflow && (e.$scrollViewer.addClass("scroll-buttons-shown"), e.$scrollButtonNear.removeClass("smart-hidden"), e.$scrollButtonFar.removeClass("smart-hidden"), e._updateScrollButtonVisibility()), e._checkOverflow(), t && e._autoLoadState(t), e._expandItemsByDefault(), e._applySelection(!0), e._updateState("sorted", e.sorted), e.displayLoadingIndicator && e.$loadingIndicatorContainer.removeClass("smart-hidden"), "center" !== e.loadingIndicatorPosition && e.$loadingIndicatorPlaceHolder.removeClass("smart-hidden"), e.__onCompleted && (e._onCompleted = e.__onCompleted, e.__onCompleted = null, e._onCompleted());
      };

      0 === i.length || e.enableShadowDOM || e.isInShadowDOM ? a() : (e._onCompleted && (e.__onCompleted = e._onCompleted, e._onCompleted = null), e._ensureItemsReady(i, a)), e.checkLicense();
    }
  }, {
    key: "_dblclickHandler",
    value: function _dblclickHandler(e, t, i) {
      var a = this;
      "dblclick" !== a.toggleMode || e instanceof Smart.TreeItem || t || a._menuItemsGroupSelectionHandler(e, i);
    }
  }, {
    key: "_discardKeyboardHover",
    value: function _discardKeyboardHover(e, t) {
      var i = this;
      t || !i._hoveredViaKeyboard || !e && i._hoveredViaKeyboard instanceof Smart.MenuItemsGroup && i._isContainerOpened(i._hoveredViaKeyboard.level + 1, i._hoveredViaKeyboard.container) || (i._hoveredViaKeyboard.removeAttribute("focus"), i._hoveredViaKeyboard = void 0);
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = t._downTimeoutInfo;
      i && (clearTimeout(i.timeout), t.$.scrollViewer.scrollTop === i.scrollTop && t._continueSelection(i.target, i.event), delete t._downTimeoutInfo);
      var a = t._downItem,
          n = t.enableShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      if (delete t._downItem, t._editedItem && !t._editInputDown && (!t._isMobile && n !== t.$.editInput || t._isMobile && document.elementFromPoint(e.clientX, e.clientY) !== t.$.editInput)) return void t._endEditing();

      if (delete t._editInputDown, a) {
        var _i974 = n.closest("smart-tree-item") || n.closest("smart-tree-items-group");

        !_i974 || !_i974.selected || _i974 !== a || t._dragDetails && t._dragDetails.FeedbackShown || _i974 instanceof Smart.TreeItemsGroup && (n.closest(".smart-tree-items-group-arrow") || n === _i974.container || n === _i974.container.firstElementChild) || t._handleSelection(_i974, e);
      }

      var o = t._dragDetails;
      if (!o) return;
      var r = Smart.Tree.hoveredTree,
          l = Smart.Tree.hoveredItem;
      if (delete t._dragDetails, delete Smart.Tree.treeItemDragged, delete Smart.Tree.hoveredTree, delete Smart.Tree.hoveredItem, t.$.scrollViewer._scrollView.disableSwipeScroll = !1, !o.FeedbackShown) return;
      var s = r || document.elementFromPoint(e.clientX, e.clientY);
      var d;
      document.body.classList.remove("smart-dragging"), document.body.removeChild(o.Feedback), r && clearInterval(r._dragInterval);
      var c = o.Item,
          m = o.Items,
          u = o.ValidItems;
      if (!s) return;
      if (!l || c.contains(l)) return void t.$.fireEvent("dragEnd", {
        item: c,
        items: m,
        target: s,
        data: o,
        previousContainer: t,
        container: r || s,
        originalEvent: e
      });
      if (!(r && r.allowDrop && !r.disabled)) return;
      var p = [r];
      var g;
      if (l.classList.remove("drop-target"), l.classList.contains("top") ? (l.classList.remove("top"), g = "top", d = 0) : l.classList.contains("bottom") ? (l.classList.remove("bottom"), g = "bottom", d = 2) : (g = "inside", d = 1), o.DropDetails = {
        item: l,
        position: g
      }, r !== t) p.push(t);else if (o.ValidateOnDrop) for (var _e1179 = 0; _e1179 < u.length; _e1179++) {
        if (u[_e1179].contains(l)) return;
      }
      var h = t.$.fireEvent("dragEnd", {
        item: c,
        items: m,
        target: l,
        data: o,
        previousContainer: t,
        container: r,
        originalEvent: e
      });

      if (!h.defaultPrevented) {
        r.sorted && r.autoSort && r._unsortItems(r.$.mainContainer);

        for (var _e1180 = 0; _e1180 < u.length; _e1180++) {
          t._moveTreeItem(u[_e1180], l, d, p);
        }

        r.sorted && r.autoSort && r._applyGrouping(r.$.mainContainer), r !== t && r._state.filter && r._applyFilter(r._state.filter);
      }
    }
  }, {
    key: "_editInputBlurHandler",
    value: function _editInputBlurHandler() {
      this._endEditing();
    }
  }, {
    key: "_endEditing",
    value: function _endEditing(e) {
      var t = this,
          i = t._editedItem;

      if (i && (delete t._editedItem, t.$editInput.addClass("smart-hidden"), t.focus(), !e)) {
        var _e1181 = t.$.editInput.value,
            _a647 = t.sorted && t.autoSort,
            _n487 = t._state.filter;

        _e1181 === i.label || (i.set("label", _e1181), i.firstElementChild.firstElementChild.firstElementChild.innerHTML = _e1181, _a647 && (t._unsortItems(t.$.mainContainer), t._applyGrouping(t.$.mainContainer)), _n487 && t._applyFilter(_n487));
      }
    }
  }, {
    key: "_ensureVisible",
    value: function _ensureVisible(e) {
      var t = this;
      t._ensureVisibleTreeMode(e, e.getBoundingClientRect(), t.$.scrollViewer, t.$.scrollViewer.getBoundingClientRect(), t._scrollViewerPadding), t._ensureVisibleCallback && t._ensureVisibleCallback(e);
    }
  }, {
    key: "_filterInputKeydownHandler",
    value: function _filterInputKeydownHandler(e) {
      if ("PageDown" !== e.key) return void ("PageUp" === e.key && (e.preventDefault(), e.stopPropagation()));
      var t = this;
      var i;

      if (e.preventDefault(), e.stopPropagation(), 0 < t.selectedIndexes.length) {
        var _e1182 = t.selectedIndexes.slice(0);

        i = t._lastSelectedItem || t._menuItems[t.selectedIndexes[t.selectedIndexes.length - 1]], "checkBox" !== t.selectionMode && "radioButton" !== t.selectionMode && (t.selectedIndexes = [i.path], t._applySelection(!1, _e1182)), t.focus();
      } else i = t._getFirstEnabledChild(t.$.mainContainer), t.focus(), i && t._hoverViaKeyboard(i);

      t._ensureVisible(i);
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler() {
      var e = this;
      0 < e.selectedIndexes.length && !e._hoveredViaKeyboard && (e._lastSelectedItem ? e._hoverViaKeyboard(e._lastSelectedItem, !1, void 0, !1) : e._hoverViaKeyboard(e._menuItems[e.selectedIndexes[e.selectedIndexes.length - 1]], !1, void 0, !1));
    }
  }, {
    key: "_getDataSource",
    value: function _getDataSource() {
      function e(t, a) {
        for (var _n488 = 0; _n488 < t.length; _n488++) {
          var _i975 = t[_n488],
              _o346 = {
            label: _i975.label
          };
          _i975.disabled && (_o346.disabled = !0), _i975.selected && (_o346.selected = !0), _i975.separator && (_o346.separator = !0), null !== _i975.value && (_o346.value = _i975.value), _i975 instanceof Smart.TreeItem ? _i975.shortcut && (_o346.shortcut = _i975.shortcut) : (_i975.expanded && (_o346.expanded = !0), _o346.items = [], e(_i975.itemContainer.children, _o346.items)), a.push(_o346);
        }
      }

      var t = this,
          i = [];
      return e(t.$.mainContainer.children, i), i;
    }
  }, {
    key: "_handleHierarchicalSelection",
    value: function _handleHierarchicalSelection(e, t) {
      function a(e, t) {
        var n = e.itemContainer.children;

        for (var _o347 = 0; _o347 < n.length; _o347++) {
          var _e1183 = n[_o347];
          _e1183.set("selected", t), _e1183.setAttribute("aria-selected", t), _e1183.removeAttribute("indeterminate"), _e1183 instanceof Smart.TreeItemsGroup && a(_e1183, t);
        }
      }

      var i = this;
      var n = e;

      for (e.selected ? (e.set("selected", !1), e.setAttribute("aria-selected", !1)) : (e.set("selected", !0), e.setAttribute("aria-selected", !0), e.removeAttribute("indeterminate")); n.parentItem;) {
        var _e1184 = n.parentItem,
            _t966 = _e1184.itemContainer.children;
        var _a648 = 0,
            _o348 = 0;

        for (var _e1185 = 0; _e1185 < _t966.length; _e1185++) {
          _t966[_e1185].selected ? _a648++ : _t966[_e1185].hasAttribute("indeterminate") && _o348++;
        }

        i._setThreeStateCheckbox(_e1184, _a648, _o348), n = _e1184;
      }

      e instanceof Smart.TreeItemsGroup && a(e, e.selected), t.length = 0;
      var o = Array.from((i.enableShadowDOM ? i.shadowRoot : i).querySelectorAll("[selected]"));

      for (var _a649 = 0; _a649 < o.length; _a649++) {
        t.push(o[_a649].path);
      }

      i._sortPathCollection(t);
    }
  }, {
    key: "_handleSelection",
    value: function _handleSelection(e, t) {
      var a = this,
          i = a.selectionMode;
      if ("none" === i || "programmatic" !== t.type && !a._canItemBeSelected(e)) return;
      var n = e.selected;
      if (n && "down" === t.type) return;
      var o = a.selectedIndexes.slice(0);
      var r = o.slice(0);

      switch (i) {
        case "one":
          if (n) return;
          a._menuItems[r[0]].set("selected", !1), a._menuItems[r[0]].removeAttribute("aria-selected"), a.selectedIndexes = [e.path], e.set("selected", !0), e.setAttribute("aria-selected", !0), a._lastSelectedItem = e;
          break;

        case "zeroOrOne":
          n ? (a.selectedIndexes = [], e.set("selected", !1), e.removeAttribute("aria-selected")) : (void 0 !== r[0] && (a._menuItems[r[0]].set("selected", !1), a._menuItems[r[0]].removeAttribute("aria-selected")), a.selectedIndexes = [e.path], e.set("selected", !0), e.setAttribute("aria-selected", !0));
          break;

        case "oneOrMany":
        case "zeroOrMany":
          if (n) {
            if (1 === r.length && "zeroOrMany" !== i) return;
            r.splice(r.indexOf(e.path), 1), e.set("selected", !1), e.setAttribute("aria-selected", !1);
          } else r.push(e.path), a._sortPathCollection(r), e.set("selected", !0), e.setAttribute("aria-selected", !0);

          a.selectedIndexes = r;
          break;

        case "oneOrManyExtended":
          {
            var _i976 = t.ctrlKey,
                _n489 = t.shiftKey;

            if (!_i976 && !_n489 || _n489 && e === a._lastSelectedItem) {
              for (var _e1186 = 0; _e1186 < r.length; _e1186++) {
                a._menuItems[r[_e1186]].set("selected", !1), a._menuItems[r[_e1186]].setAttribute("aria-selected", !1);
              }

              r = [e.path], e.set("selected", !0), e.setAttribute("aria-selected", !0), a._lastSelectedItem = e;
            } else if (_i976) e.selected && 1 < r.length ? (r.splice(r.indexOf(e.path), 1), e.set("selected", !1), e.setAttribute("aria-selected", !1)) : !e.selected && (r.push(e.path), a._sortPathCollection(r), e.set("selected", !0), e.setAttribute("aria-selected", !0), a._lastSelectedItem = e);else if (_n489) {
              for (var _e1187 = 0; _e1187 < r.length; _e1187++) {
                a._menuItems[r[_e1187]].set("selected", !1), a._menuItems[r[_e1187]].setAttribute("aria-selected", !1);
              }

              r = a._selectItemRange(a._lastSelectedItem, e);
            }

            a.selectedIndexes = r;
            break;
          }

        case "checkBox":
          a.hasThreeStates ? a._handleHierarchicalSelection(e, r) : n ? (r.splice(r.indexOf(e.path), 1), e.set("selected", !1), e.setAttribute("aria-selected", !1)) : (r.push(e.path), a._sortPathCollection(r), e.set("selected", !0), e.setAttribute("aria-selected", !0)), a.selectedIndexes = r;
          break;

        case "radioButton":
          {
            if (e.selected) return;

            var _t967;

            for (var _a650 = 0; _a650 < e.parentElement.children.length; _a650++) {
              var _i978 = e.parentElement.children[_a650];

              if (_i978.selected) {
                _t967 = _i978;
                break;
              }
            }

            var _i977 = r.indexOf(_t967.path);

            _t967.set("selected", !1), e.setAttribute("aria-selected", !1), e.set("selected", !0), e.setAttribute("aria-selected", !0), r.splice(_i977, 1), r.push(e.path), a._sortPathCollection(r), a.selectedIndexes = r;
            break;
          }
      }

      if (a._discardKeyboardHover(!0), a._hoverViaKeyboard(e, !1, void 0, !a._treeAnimationInProgress), a._updateState("selected"), JSON.stringify(o) !== JSON.stringify(a.selectedIndexes)) {
        if (a.ownerElement && !a.ownerElement.isRendered) return;
        a.$.fireEvent("change", {
          item: e,
          selectedIndexes: a.selectedIndexes,
          oldSelectedIndexes: o
        });
      }
    }
  }, {
    key: "_hoverViaKeyboard",
    value: function _hoverViaKeyboard(e, t, i, a) {
      if (e) {
        var _n490 = this;

        e.setAttribute("focus", ""), _n490._hoveredViaKeyboard = e, !1 !== a && _n490._ensureVisible(e), t && _n490._handleSelection(e, i), _n490._hoverViaKeyboardCallback && _n490._hoverViaKeyboardCallback(e);
      }
    }
  }, {
    key: "_keydownHandler",
    value: function _keydownHandler(e) {
      function t(t) {
        for (var _a651 = t; _a651 < r.length; _a651++) {
          var _t968 = r[_a651];

          if (n._canItemBeHovered(_t968)) {
            if (s) {
              if (s === _t968) break;
              s.removeAttribute("focus");
            }

            n._hoverViaKeyboard(_t968, l, e);

            break;
          }
        }
      }

      function i(t) {
        for (var _a652 = t; 0 <= _a652; _a652--) {
          var _t969 = r[_a652];

          if (n._canItemBeHovered(_t969)) {
            if (s) {
              if (s === _t969) break;
              s.removeAttribute("focus");
            }

            n._hoverViaKeyboard(_t969, l, e);

            break;
          }
        }
      }

      function a() {
        1 < s.level && n._canItemBeSelected(s.parentItem) && (s.removeAttribute("focus"), n._hoverViaKeyboard(s.parentItem, l, e));
      }

      var n = this,
          o = e.key;
      if (n._editedItem) return void ("Enter" === o ? n._endEditing() : "Escape" === o && n._endEditing(!0));
      if (n.getRootNode().activeElement !== n || -1 === ["ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp", "End", "Enter", "F2", "Home", "PageDown", "PageUp", " "].indexOf(o) || n.disabled || n.displayLoadingIndicator) return;
      e.preventDefault();
      var r = Array.from(n.$.mainContainer.querySelectorAll("smart-tree-item, smart-tree-items-group")),
          l = "one" === n.selectionMode || "oneOrManyExtended" === n.selectionMode && !e.ctrlKey,
          s = n.$.mainContainer.querySelector("[focus]");
      var d;

      switch (o) {
        case "ArrowDown":
          d = s ? r.indexOf(s) + 1 : 0, t(d);
          break;

        case "ArrowLeft":
          if (!s) return;
          if (s instanceof Smart.TreeItem) a();else {
            if (n._isContainerOpened(s.level + 1, s.container)) return void n._closeSubContainersTreeMode(s.level + 1, s.container, !0, !0);
            a();
          }
          break;

        case "ArrowRight":
          if (!s || s instanceof Smart.TreeItem) return;

          if (n._isContainerOpened(s.level + 1, s.container)) {
            var _t970 = n._getFirstEnabledChild(s.itemContainer);

            _t970 && (s.removeAttribute("focus"), n._hoverViaKeyboard(_t970, l, e));
          } else n._menuItemsGroupSelectionHandler(s, {
            target: s,
            type: "keydown"
          });

          break;

        case "ArrowUp":
          d = s ? r.indexOf(s) - 1 : r.length - 1, i(d);
          break;

        case "End":
          i(r.length - 1);
          break;

        case "Enter":
          s && s instanceof Smart.TreeItemsGroup && n._menuItemsGroupSelectionHandler(s, {
            target: s,
            type: "keydown"
          });
          break;

        case "F2":
          n.editable && n._startEditing(s);
          break;

        case "Home":
          t(0);
          break;

        case "PageDown":
          n._pageDownHandler(r, s, l, e);

          break;

        case "PageUp":
          n._pageUpHandler(r, s, l, e);

          break;

        case " ":
          s && n._handleSelection(s, e);
      }
    }
  }, {
    key: "_mainContainerSwipeHandler",
    value: function _mainContainerSwipeHandler(e) {
      Smart.Tree.treeItemDragged && e.stopPropagation();
    }
  }, {
    key: "_menuItemsGroupSelectionHandler",
    value: function _menuItemsGroupSelectionHandler(e, t, i) {
      var a = this,
          n = a.toggleMode,
          o = !!t.originalEvent && t.originalEvent.target.classList.contains("smart-tree-items-group-arrow"),
          r = e.container;

      if (!(a._waitAnimation && a._treeAnimationInProgress === r) && ("down" !== t.type || o || "dblclick" === n && 1 !== a._dblclickObject.numberOfClicks || a._handleSelection(e, t), !("down" === t.type && !o && ("dblclick" === n && 2 !== a._dblclickObject.numberOfClicks || "click" === n && 1 < a._dblclickObject.numberOfClicks || "arrow" === n) || e.hiddenChildren))) {
        var _n491 = r.level;
        var _o349 = a.hasAnimation;
        if ("keydown" === t.type && a._discardKeyboardHover(), a._treeAnimationInProgress && (r.removeEventListener("transitionend", a._transitionendHandlerExpand), r.removeEventListener("transitionend", a._transitionendHandlerCollapse)), a._isContainerOpened(_n491, r)) a._closeSubContainersTreeMode(_n491, r, !0, !1 !== i);else {
          var _l149 = a.$.fireEvent("expanding", {
            item: e,
            label: e.label,
            path: e.path,
            value: e.value,
            children: e.itemContainer.children
          });

          if (_l149.defaultPrevented) return;

          if (_o349 && ("expand" !== t.type && (a._ensureVisibleOnTransitionend = e), a._expandSection(r)), r.$.removeClass("smart-visibility-hidden"), "keydown" === t.type && (e.setAttribute("focus", ""), a._hoveredViaKeyboard = e), e.$.addClass("smart-tree-items-group-opened"), e.$.addClass("smart-tree-items-group-expanded"), a._addOpenedContainer(_n491, r), void 0 === t.type && a._hoverViaKeyboard(a._getFirstEnabledChild(e.itemContainer)), !1 !== i) {
            var _t971 = {
              item: e,
              label: e.label,
              path: e.path,
              value: e.value,
              children: e.itemContainer.children
            };
            a.toggleCallback ? (_t971.type = "expand", a.toggleCallback(_t971)) : a.$.fireEvent("expand", _t971);
          }
        }
        _o349 || (a._checkOverflow(), "expand" !== t.type && a._ensureVisible(e));
      }
    }
  }, {
    key: "_mouseenterHandler",
    value: function _mouseenterHandler() {
      var e = this;
      e.autoHideToggleElement && e.$mainContainer.removeClass("hidden-arrows"), Smart.Tree.treeItemDragged && e.allowDrop && !e.disabled && (Smart.Tree.hoveredTree = e);
    }
  }, {
    key: "_mouseleaveHandler",
    value: function _mouseleaveHandler() {
      var e = this;

      if (e.autoHideToggleElement && e.$mainContainer.addClass("hidden-arrows"), Smart.Tree.treeItemDragged) {
        Smart.Tree.hoveredTree && (clearInterval(Smart.Tree.hoveredTree._dragInterval), delete Smart.Tree.hoveredTree);
        var _e1188 = Smart.Tree.hoveredItem;
        _e1188 && (_e1188.classList.remove("drop-target"), _e1188.classList.remove("top"), _e1188.classList.remove("bottom"), delete Smart.Tree.hoveredItem);
      }
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      var t = Math.abs;
      var i = this,
          a = i._dragDetails;
      if (!a) return;
      if (!a.FeedbackShown) if (5 < t(a.StartPosition.left - e.pageX) || 5 < t(a.StartPosition.top - e.pageY)) {
        var _e1189 = i.$.fireEvent("dragStart", {
          item: a.Item,
          items: a.Items,
          data: a,
          container: i,
          previousContainer: i,
          originalEvent: a.OriginalEvent
        });

        if (_e1189.defaultPrevented) return delete i._dragDetails, delete Smart.Tree.treeItemDragged, delete Smart.Tree.hoveredTree, delete Smart.Tree.hoveredItem, void (i.$.scrollViewer._scrollView.disableSwipeScroll = !1);
        document.body.classList.add("smart-dragging"), a.Feedback = i._addDragFeedback(), a.FeedbackShown = !0;
      } else return;
      var n = i.dragOffset;
      var o, r, l;

      if (i.$.fireEvent("dragging", {
        item: a.Item,
        items: a.Items,
        data: a,
        originalEvent: e
      }), a.Feedback.style.left = e.pageX + n[0] + "px", a.Feedback.style.top = e.pageY + n[1] + "px", i._isMobile) {
        var _t972 = Smart.Tree.hoveredItem;
        _t972 && (_t972.classList.remove("drop-target"), _t972.classList.remove("top"), _t972.classList.remove("bottom"), delete Smart.Tree.hoveredItem);

        var _i979 = document.elementFromPoint(e.clientX, e.clientY);

        Smart.Tree.hoveredTree && (clearInterval(Smart.Tree.hoveredTree._dragInterval), delete Smart.Tree.hoveredTree), _i979 && (o = _i979.closest("smart-tree"), o && o.allowDrop && (Smart.Tree.hoveredTree = o, r = _i979.closest("smart-tree-item") || _i979.closest("smart-tree-items-group"), r ? l = r : r = _i979));
      }

      if (o = Smart.Tree.hoveredTree, !o) return;
      var s = o.filterable ? o.$.filterInput.offsetHeight + 10 : 0;

      if (clearInterval(o._dragInterval), o._dragInterval = setInterval(function () {
        var t = o.getBoundingClientRect();
        0 < o.$.scrollViewer.scrollHeight && t.left <= e.clientX && t.left + t.width >= e.clientX ? e.clientY >= t.top + s && e.clientY <= t.top + 20 + s ? (o.$.scrollViewer.scrollTop -= i._autoScrollCoefficient, "scrollButtons" === o.scrollMode && o._updateScrollButtonVisibility()) : e.clientY >= t.top + t.height - 20 && e.clientY <= t.top + t.height ? (o.$.scrollViewer.scrollTop += i._autoScrollCoefficient, "scrollButtons" === o.scrollMode && o._updateScrollButtonVisibility()) : clearInterval(o._dragInterval) : clearInterval(o._dragInterval);
      }, 1), i._isMobile || (r = e.originalEvent.target, r && r.enableShadowDOM && (r = e.originalEvent.composedPath()[0]), r && r.closest && (l = r.closest("smart-tree-item") || r.closest("smart-tree-items-group"))), l) {
        if (Smart.Tree.hoveredItem && l !== Smart.Tree.hoveredItem && (Smart.Tree.hoveredItem.classList.remove("drop-target"), Smart.Tree.hoveredItem.classList.remove("top"), Smart.Tree.hoveredItem.classList.remove("bottom")), Smart.Tree.hoveredItem = l, a.Item.contains(l)) return;

        var _t973 = l.getBoundingClientRect();

        l instanceof Smart.TreeItem ? e.clientY - _t973.top <= _t973.height / 2 ? (l.classList.remove("bottom"), l.classList.add("top")) : (l.classList.remove("top"), l.classList.add("bottom")) : 10 >= e.clientY - _t973.top ? (l.classList.remove("bottom"), l.classList.add("top")) : !l.expanded && 10 >= _t973.bottom - e.clientY ? (l.classList.remove("top"), l.classList.add("bottom")) : (l.classList.remove("top"), l.classList.remove("bottom")), l.classList.add("drop-target");
      } else if (Smart.Tree.hoveredItem && (Smart.Tree.hoveredItem.classList.remove("drop-target"), Smart.Tree.hoveredItem.classList.remove("top"), Smart.Tree.hoveredItem.classList.remove("bottom")), r !== o.$.scrollViewer.$.scrollViewerContainer) delete Smart.Tree.hoveredItem;else if (o._menuItems[0]) {
        var _e1190 = o.$.mainContainer.lastElementChild,
            _t974 = o.$.mainContainer.childElementCount - 1;

        for (; _e1190.hidden && (_t974--, _e1190 = o.$.mainContainer.children[_t974], !!_e1190);) {
          ;
        }

        _e1190 ? (Smart.Tree.hoveredItem = _e1190, Smart.Tree.hoveredItem.classList.add("bottom")) : Smart.Tree.hoveredItem = o.$.container, Smart.Tree.hoveredItem.classList.add("drop-target");
      } else Smart.Tree.hoveredItem = o.$.container, Smart.Tree.hoveredItem.classList.add("drop-target");
    }
  }, {
    key: "_moveSubItems",
    value: function _moveSubItems(e, t, a) {
      var n = this;

      for (var _o350 = 0; _o350 < e.length; _o350++) {
        var _i980 = e[_o350];
        _i980.menu = t, _i980.set("level", _i980.parentItem.level + 1), _i980.firstElementChild.style.paddingLeft = "", _i980.firstElementChild.style.paddingRight = "", n._setIndentation(_i980.firstElementChild, _i980.level, a), _i980.hidden = !1, _i980.$.removeClass("smart-hidden"), _i980.$.removeClass("filtered-child"), _i980.$.removeClass("last-filtered-child"), _i980 instanceof Smart.TreeItemsGroup && (_i980.$.removeClass("hidden-children"), _i980.container.level = _i980.level + 1, n._moveSubItems(_i980.itemContainer.children, t, a), t !== n && _i980.expanded && (t._menuItemsGroupsToExpand.push(_i980), n._updateState("expanded", _i980.id, !1)));
      }
    }
  }, {
    key: "_moveTreeItem",
    value: function _moveTreeItem(e, t, i, a) {
      var n = this,
          o = e.level;

      if (0 === i) {
        if (t.previousElementSibling === e) return;
        t.parentElement.insertBefore(e, t), e.set("level", t.level);
      } else if (2 === i) {
        if (t.nextElementSibling === e) return;
        t.parentElement.insertBefore(e, t.nextElementSibling || null), e.set("level", t.level);
      } else if (t === a[0].$.container) a[0].$.mainContainer.appendChild(e), e.set("level", 1);else {
        if (t.itemContainer.lastElementChild === e) return;
        t.itemContainer.appendChild(e), e.set("level", t.level + 1);
      }

      var r = a[0].rightToLeft ? "paddingRight" : "paddingLeft";

      if (e.menu = a[0], e.parentItem = e.parentElement.menuItemsGroup, e.firstElementChild.style.paddingLeft = "", e.firstElementChild.style.paddingRight = "", n._setIndentation(e.firstElementChild, e.level, r), e.hidden = !1, e.$.removeClass("smart-hidden"), e.$.removeClass("filtered-child"), e.$.removeClass("last-filtered-child"), e instanceof Smart.TreeItemsGroup && (e.$.removeClass("hidden-children"), e.container.level = e.level + 1, n._moveSubItems(e.itemContainer.children, a[0], r), e.expanded)) {
        var _t975 = n._openedContainers[o + 1].indexOf(e.container);

        -1 !== _t975 && n._openedContainers[o + 1].splice(_t975, 1), a[0]._menuItemsGroupsToExpand.push(e), 2 === a.length && n._updateState("expanded", e.id, !1);
      }

      for (var _n492 = 0; _n492 < a.length; _n492++) {
        var _e1191 = a[_n492],
            _t976 = _e1191.context,
            _i981 = _e1191.selectedIndexes.slice(0);

        _e1191.context = _e1191, _e1191._menuItems = {}, _e1191._refreshItemPaths(_e1191.$.mainContainer, !0, void 0, _e1191.sorted && !_e1191.autoSort), _e1191.selectedIndexes = [], _e1191._applySelection(!0, _i981, !1), _e1191._checkOverflow(), _e1191.context = _t976;
      }

      a[0]._expandItemsByDefault();
    }
  }, {
    key: "_overriddenMenuHandler",
    value: function _overriddenMenuHandler() {}
  }, {
    key: "_pageDownHandler",
    value: function _pageDownHandler(e, t, i, a) {
      function n() {
        for (var _t977 = e.length - 1; 0 <= _t977; _t977--) {
          var _i982 = e[_t977];
          if (o._canItemBeHovered(_i982) && o._getOffsetTop(_i982) + _i982.firstElementChild.offsetHeight <= r.scrollTop + r.$.container.offsetHeight) return _i982;
        }
      }

      var o = this,
          r = o.$.scrollViewer;
      if (!t) return;
      var l = n();
      l && (t === l ? r.scrollTop + r.$.container.offsetHeight !== r.$.scrollViewerContentContainer.offsetHeight && (o.$.scrollViewer.scrollTop += r.$.container.offsetHeight, "scrollButtons" === o.scrollMode && o._updateScrollButtonVisibility(), l = n(), t.removeAttribute("focus"), o._hoverViaKeyboard(l, i, a)) : (t.removeAttribute("focus"), o._hoverViaKeyboard(l, i, a)));
    }
  }, {
    key: "_pageUpHandler",
    value: function _pageUpHandler(e, t, i, a) {
      function n() {
        for (var _t978 = 0; _t978 < e.length; _t978++) {
          var _i983 = e[_t978];
          if (o._canItemBeHovered(_i983) && o._getOffsetTop(_i983) >= r.scrollTop) return _i983;
        }
      }

      var o = this,
          r = o.$.scrollViewer;
      if (!t) return;
      var l = n();
      l && (t === l ? 0 === r.scrollTop ? o.filterable && o.$.filterInput.focus() : (o.$.scrollViewer.scrollTop -= r.$.container.offsetHeight, "scrollButtons" === o.scrollMode && o._updateScrollButtonVisibility(), l = n(), t.removeAttribute("focus"), o._hoverViaKeyboard(l, i, a)) : (t.removeAttribute("focus"), o._hoverViaKeyboard(l, i, a)));
    }
  }, {
    key: "_refreshItemPathsAndSelection",
    value: function _refreshItemPathsAndSelection() {
      var e = this,
          t = e.selectedIndexes.slice(0);
      e._menuItems = {}, e._refreshItemPaths(e.$.mainContainer, !0), e.selectedIndexes = [], e._applySelection(!0, t);
    }
  }, {
    key: "_refreshSorting",
    value: function _refreshSorting() {
      var e = this;
      e._unsortItems(e.$.mainContainer), e._applyGrouping(e.$.mainContainer);
      var t = e._state.filter;
      t && e._applyFilter(t), e._checkOverflow();
    }
  }, {
    key: "_scroll",
    value: function _scroll(e) {
      var t = this;
      t.$.scrollViewer.scrollTop += 10 * e, t._updateScrollButtonVisibility(), t.focus();
    }
  }, {
    key: "_scrollButtonFarClickHandler",
    value: function _scrollButtonFarClickHandler() {
      var e = this;
      e.$.scrollButtonFar.disabled || e._scroll(1);
    }
  }, {
    key: "_scrollButtonNearClickHandler",
    value: function _scrollButtonNearClickHandler() {
      var e = this;
      e.$.scrollButtonNear.disabled || e._scroll(-1);
    }
  }, {
    key: "_scrollViewerDownHandler",
    value: function _scrollViewerDownHandler(e) {
      var t = this;
      if (e.target !== t.$.scrollViewer || t.disabled || t.displayLoadingIndicator || !t._isMobile && 1 !== e.which) return;
      var i = e.originalEvent.target;
      if (i === t.$.editInput) return void (t._editInputDown = !0);

      if (t._isMobile) {
        var _a653 = t.$.scrollViewer.scrollTop,
            _n493 = setTimeout(function () {
          if (t.$.scrollViewer.scrollTop !== _a653) return;else {
            var _a654 = t.context;
            t.context = t, t._continueSelection(i, e), t.context = _a654;
          }
        }, 250);

        t._downTimeoutInfo = {
          target: i,
          event: e,
          scrollTop: _a653,
          timeout: _n493
        };
      } else t._continueSelection(i, e);
    }
  }, {
    key: "_continueSelection",
    value: function _continueSelection(e, t) {
      var i = this,
          a = e.closest("smart-tree-item") || e.closest("smart-tree-items-group");
      if (!(a && a.parentElement && i._canItemBeSelected(a))) return;
      var n = e.closest(".smart-tree-items-group-arrow");
      var o;
      if (a instanceof Smart.TreeItem) o = "_handleSelection";else {
        if (e === a.container || e === a.container.firstElementChild) return;
        o = "_menuItemsGroupSelectionHandler";
      }
      if (clearTimeout(i._dblclickTimeout), a !== i._dblclickObject.target && (i._dblclickObject.numberOfClicks = 0), i._dblclickObject.target = a, i._dblclickObject.numberOfClicks++, i._dblclickTimeout = setTimeout(function () {
        i._dblclickObject.numberOfClicks = 0;
      }, 300), 2 === i._dblclickObject.numberOfClicks) if (!i.editable) i._dblclickHandler(a, n, t), i._dblclickObject.numberOfClicks = 0;else return void i._startEditing(a);
      a.selected && (i._downItem = a), i[o](a, t), i._discardKeyboardHover(!0), i._hoverViaKeyboard(a, !1, void 0, !1), n || i._startDragging(a, t);
    }
  }, {
    key: "_scrollViewerWheelHandler",
    value: function _scrollViewerWheelHandler() {
      var e = this;
      "scrollButtons" === e.scrollMode && "hidden" !== e.overflow && e._updateScrollButtonVisibility();
    }
  }, {
    key: "_selectItemRange",
    value: function _selectItemRange(e, t) {
      var a = this,
          n = Array.from(a.$.mainContainer.querySelectorAll("smart-tree-item, smart-tree-items-group")),
          o = n.indexOf(e),
          r = n.indexOf(t),
          l = [];

      for (var _s107 = Math.min(o, r); _s107 <= Math.max(o, r); _s107++) {
        var _e1192 = n[_s107];
        a._canItemBeHovered(_e1192) && (l.push(_e1192.path), _e1192.set("selected", !0));
      }

      return l;
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      _get(_getPrototypeOf(_class113.prototype), "_setFocusable", this).call(this);

      var e = this;
      return e.disabled || e.unfocusable ? void (e.$.filterInput.tabIndex = -1) : void e.$.filterInput.removeAttribute("tabindex");
    }
  }, {
    key: "_setIndentation",
    value: function _setIndentation(e, t, i) {
      e.style[i] = 20 * t - 10 + "px";
    }
  }, {
    key: "_setThreeStateCheckbox",
    value: function _setThreeStateCheckbox(e, t, i) {
      t === e.itemContainer.childElementCount ? (e.removeAttribute("indeterminate"), e.set("selected", !0), e.setAttribute("aria-selected", !0)) : 0 === t && 0 === i ? (e.removeAttribute("indeterminate"), e.set("selected", !1), e.setAttribute("aria-selected", !1)) : (e.setAttribute("indeterminate", ""), e.set("selected", !1), e.setAttribute("aria-selected", !1));
    }
  }, {
    key: "_sortItems",
    value: function _sortItems(e) {
      var t = this;
      if (!t.sorted) return;
      var a;
      e instanceof Smart.TreeItemsGroup ? a = e.container.firstElementChild : e === t.$.mainContainer && (a = e);
      var n = Array.from(a.children);

      if (t.sort) {
        var _i984 = t.sort(n, e);

        Array.isArray(_i984) && (n = _i984);
      } else "asc" === t.sortDirection ? n.sort(function (e, t) {
        return e.label.localeCompare(t.label);
      }) : n.sort(function (e, t) {
        return t.label.localeCompare(e.label);
      });

      for (var _t979 = n.length - 1; 0 <= _t979; _t979--) {
        a.insertBefore(n[_t979], a.firstElementChild);
      }
    }
  }, {
    key: "_sortPathCollection",
    value: function _sortPathCollection(e) {
      e.sort(function (e, t) {
        var a = e.split("."),
            n = t.split("."),
            o = Math.max(a.length, n.length);

        for (var _r214 = 0; _r214 < o; _r214++) {
          var _e1193 = parseFloat(a[_r214]),
              _t980 = parseFloat(n[_r214]);

          if (isNaN(_e1193)) return -1;
          if (isNaN(_t980)) return 1;
          if (_e1193 < _t980) return -1;
          if (_e1193 > _t980) return 1;
        }
      });
    }
  }, {
    key: "_startDragging",
    value: function _startDragging(e, t) {
      var a = this,
          i = a.selectionMode;
      if (!a.allowDrag || a._editedItem || "none" === i) return;
      var n = [],
          o = [];
      var r;
      if (-1 !== ["one", "zeroOrOne", "checkBox", "radioButton"].indexOf(i)) r = !1, n.push(e), o.push(e);else {
        r = !0;

        for (var _e1194 = 0; _e1194 < a.selectedIndexes.length; _e1194++) {
          n.push(a._menuItems[a.selectedIndexes[_e1194]]), o.push(n[_e1194]);
        }

        for (var _e1195 = 0; _e1195 < n.length; _e1195++) {
          var _t981 = n[_e1195];
          if (-1 !== o.indexOf(_t981)) for (var _e1196 = o.length - 1; 0 <= _e1196; _e1196--) {
            var _i985 = o[_e1196];
            if (_i985 === _t981) break;
            _t981.contains(_i985) && o.splice(_e1196, 1);
          }
        }
      }
      a._dragDetails = {
        StartPosition: {
          left: t.pageX,
          top: t.pageY
        },
        Items: n,
        ValidItems: o,
        Item: e,
        FeedbackShown: !1,
        ValidateOnDrop: r,
        OriginalEvent: t,
        StartTime: new Date(),
        Dragging: !0
      }, Smart.Tree.treeItemDragged = !0, a.$.scrollViewer._scrollView.disableSwipeScroll = !0, a.allowDrop && (Smart.Tree.hoveredTree = a, Smart.Tree.hoveredItem = e);
    }
  }, {
    key: "_startEditing",
    value: function _startEditing(e) {
      var t = this,
          i = t.$.editInput;
      var a, n;
      if (!t._canItemBeSelected(e)) return;
      var o = e.firstElementChild,
          r = o.firstElementChild;
      t.rightToLeft ? (a = function a() {
        return o.offsetWidth - r.offsetLeft - r.offsetWidth;
      }, n = "paddingRight") : (a = function a() {
        return r.offsetLeft + parseFloat(window.getComputedStyle(o).borderLeftWidth);
      }, n = "paddingLeft"), e instanceof Smart.TreeItemsGroup ? (i.style[n] = a() + (t.showLines ? parseFloat(window.getComputedStyle(r.firstElementChild).paddingLeft) : 0) - 1 + "px", i.style.height = o.offsetHeight + "px") : (i.style[n] = e.offsetWidth + parseInt(o.style[n], 10) - o.offsetWidth + parseFloat(window.getComputedStyle(r.firstElementChild).paddingLeft) - 2 + "px", i.style.height = e.offsetHeight + "px"), i.style.top = t._getOffsetTop(e) + "px", t.$editInput.removeClass("smart-hidden"), i.value = e.label, t._editedItem = e, setTimeout(function () {
        i.focus();
      }, 0);
    }
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler(e) {
      e.detail.styleProperties && e.detail.styleProperties["font-size"] && this._checkOverflow();
    }
  }, {
    key: "_updateScrollButtonVisibility",
    value: function _updateScrollButtonVisibility() {
      var e = Math.round;
      var t = this,
          i = t.overflow;
      if ("scrollbar" === t.scrollMode || "hidden" === i) return;
      var a = !0,
          n = !0;

      if (0 === e(t.$.scrollViewer.scrollTop) && (a = !1), e(t.$.scrollViewer.$.scrollViewerContainer.offsetHeight + t.$.scrollViewer.scrollTop) >= e(t.$.scrollViewer.$.scrollViewerContentContainer.offsetHeight) && (n = !1), "auto" === i) {
        if (a && n) return t.$scrollButtonNear.removeClass("smart-hidden"), t.$scrollButtonFar.removeClass("smart-hidden"), t.$scrollViewer.removeClass("one-button-shown"), void t.$.scrollViewer.refresh();
        a ? t.$scrollButtonNear.removeClass("smart-hidden") : t.$scrollButtonNear.addClass("smart-hidden"), n ? t.$scrollButtonFar.removeClass("smart-hidden") : t.$scrollButtonFar.addClass("smart-hidden"), t.$scrollViewer.addClass("one-button-shown"), t.$.scrollViewer.refresh();
      } else "scroll" !== i || t.disabled || (t.$.scrollButtonNear.disabled = !a, t.$.scrollButtonFar.disabled = !n);
    }
  }, {
    key: "_updateState",
    value: function _updateState(e, t, i) {
      var a = this;

      switch (e) {
        case "expanded":
          {
            var _e1197 = a._state.expanded.indexOf(t);

            if (i && -1 === _e1197) a._state.expanded.push(t);else if (!i && -1 !== _e1197) a._state.expanded.splice(_e1197, 1);else return;
            break;
          }

        case "filter":
          a._state.filter = t === void 0 ? a.$.filterInput.value : t;
          break;

        case "selected":
          a._state.selected = [];

          for (var _e1198 = 0; _e1198 < a.selectedIndexes.length; _e1198++) {
            var _t982 = a._menuItems[a.selectedIndexes[_e1198]];

            a._state.selected.push(_t982.id);
          }

          break;

        case "sorted":
          a._state.sorted = t;
      }

      a.autoSaveState && window.localStorage.setItem("smartTree" + a.id, JSON.stringify(a._state));
    }
  }, {
    key: "_verticalScrollbarHandler",
    value: function _verticalScrollbarHandler() {
      var e = this,
          t = e.$.verticalScrollBar,
          i = t.value;
      return e.disabled ? void 0 : t.max === i ? void (e._bottomReached || (e.$.fireEvent("scrollBottomReached"), delete e._topReached, e._bottomReached = !0)) : t.min === i ? void (e._topReached || (e.$.fireEvent("scrollTopReached"), delete e._bottomReached, e._topReached = !0)) : void (delete e._topReached, delete e._bottomReached);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        allowDrag: {
          value: !1,
          type: "boolean"
        },
        allowDrop: {
          value: !1,
          type: "boolean"
        },
        autoHideToggleElement: {
          value: !1,
          type: "boolean"
        },
        autoLoadState: {
          value: !1,
          type: "boolean"
        },
        autoSaveState: {
          value: !1,
          type: "boolean"
        },
        autoSort: {
          value: !0,
          type: "boolean"
        },
        displayLoadingIndicator: {
          value: !1,
          type: "boolean"
        },
        dragFeedbackFormatFunction: {
          value: null,
          type: "function?"
        },
        dragOffset: {
          value: [10, 10],
          type: "array"
        },
        editable: {
          value: !1,
          type: "boolean"
        },
        filterable: {
          value: !1,
          type: "boolean"
        },
        filterInputPlaceholder: {
          value: "",
          type: "string"
        },
        filterMode: {
          value: "containsIgnoreCase",
          allowedValues: ["contains", "containsIgnoreCase", "doesNotContain", "doesNotContainIgnoreCase", "equals", "equalsIgnoreCase", "startsWith", "startsWithIgnoreCase", "endsWith", "endsWithIgnoreCase"],
          type: "string"
        },
        hasThreeStates: {
          value: !1,
          type: "boolean"
        },
        loadingIndicatorPlaceholder: {
          value: "Loading...",
          type: "string"
        },
        loadingIndicatorPosition: {
          value: "center",
          allowedValues: ["bottom", "center", "top"],
          type: "string"
        },
        messages: {
          value: {
            en: {
              noId: "smart-tree: Saving and loading the element's state are not available if the element has no id."
            }
          },
          type: "object",
          extend: !0
        },
        scrollMode: {
          value: "scrollbar",
          allowedValues: ["scrollbar", "scrollButtons"],
          type: "string"
        },
        selectedIndexes: {
          value: [],
          type: "array"
        },
        selectionDisplayMode: {
          value: "row",
          allowedValues: ["row", "label"],
          type: "string"
        },
        selectionMode: {
          value: "one",
          allowedValues: ["none", "oneOrManyExtended", "zeroOrMany", "oneOrMany", "zeroOrOne", "one", "checkBox", "radioButton"],
          type: "string"
        },
        showLines: {
          value: !1,
          type: "boolean"
        },
        showRootLines: {
          value: !1,
          type: "boolean"
        },
        sort: {
          value: null,
          type: "function?"
        },
        sortDirection: {
          value: "asc",
          allowedValues: ["asc", "desc"],
          type: "string"
        },
        sorted: {
          value: !1,
          type: "boolean"
        },
        toggleElementPosition: {
          value: "near",
          allowedValues: ["near", "far"],
          type: "string"
        },
        toggleMode: {
          value: "dblclick",
          allowedValues: ["click", "dblclick", "arrow"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        blur: "_blurHandler",
        focus: "_focusHandler",
        keydown: "_keydownHandler",
        mouseenter: "_mouseenterHandler",
        mouseleave: "_mouseleaveHandler",
        resize: "_checkOverflow",
        styleChanged: "_styleChangedHandler",
        transitionend: "_overriddenMenuHandler",
        "container.click": "_overriddenMenuHandler",
        "container.mouseout": "_overriddenMenuHandler",
        "container.mouseover": "_overriddenMenuHandler",
        "editInput.blur": "_editInputBlurHandler",
        "filterInput.keydown": "_filterInputKeydownHandler",
        "filterInput.keyup": "_filterInputKeyupHandler",
        "mainContainer.click": "_overriddenMenuHandler",
        "mainContainer.mouseleave": "_overriddenMenuHandler",
        "mainContainer.mouseout": "_overriddenMenuHandler",
        "mainContainer.mouseover": "_overriddenMenuHandler",
        "mainContainer.swipeleft": "_mainContainerSwipeHandler",
        "mainContainer.swiperight": "_mainContainerSwipeHandler",
        "scrollButtonFar.click": "_scrollButtonFarClickHandler",
        "scrollButtonNear.click": "_scrollButtonNearClickHandler",
        "scrollViewer.down": "_scrollViewerDownHandler",
        "scrollViewer.kineticScroll": "_scrollViewerWheelHandler",
        "mainContainer.wheel": "_scrollViewerWheelHandler",
        "document.move": "_moveHandler",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.ScrollBar": "smart.scrollbar.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.scrollbar.css", "smart.scrollviewer.css", "smart.tree.css"];
    }
  }]);

  return _class113;
}(Smart.Menu)), Smart("smart-sortable",
/*#__PURE__*/
function (_Smart$ContentElement18) {
  "use strict";

  _inherits(_class114, _Smart$ContentElement18);

  function _class114() {
    _classCallCheck(this, _class114);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class114).apply(this, arguments));
  }

  _createClass(_class114, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" class=\"smart-sortable-container\"><content></content></div>";
    }
  }, {
    key: "move",
    value: function move(e, t) {
      var i = this,
          a = i._items;

      if (!(isNaN(e) || isNaN(t) || e === t || 0 > e || e >= a.length || 0 > t || t >= a.length)) {
        var _n494 = a[e],
            _o351 = a[t];
        e > t ? i._itemsParent.insertBefore(_n494, _o351) : i._itemsParent.insertBefore(_n494, _o351.nextElementSibling), i._getItems(!1);
      }
    }
  }, {
    key: "updateItems",
    value: function updateItems() {
      var e = this;
      e._items.forEach(function (e) {
        return e.classList.remove("smart-sortable-item");
      }), e._getItems();
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      _get(_getPrototypeOf(_class114.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      var a = this;
      "disabled" === e ? (a._originallyDisabled = i, 2 > a._items.length && (a.disabled = !0)) : "items" === e ? (a._itemsParent.classList.remove("smart-sortable-items-parent"), a.updateItems()) : "mode" === e ? a._setSettingsObject() : void 0;
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class114.prototype), "ready", this).call(this);

      var e = this;
      e._originallyDisabled = e.disabled, e._getItems(), e._setSettingsObject();
    }
  }, {
    key: "_getItems",
    value: function _getItems(e) {
      var t = this;
      t._items = null === t.items ? Array.from(t.$.container.children) : Array.from((t.shadowRoot || t).querySelectorAll(".smart-sortable-container " + t.items)), !1 !== e && (t._items.forEach(function (e) {
        return e.classList.add("smart-sortable-item");
      }), t._items.length && (t._itemsParent = t._items[0].parentElement, t._itemsParent.classList.add("smart-sortable-items-parent"), t.disabled = !!(2 > t._items.length) || t._originallyDisabled));
    }
  }, {
    key: "_setSettingsObject",
    value: function _setSettingsObject() {
      var e = this;
      e._settings = "vertical" === e.mode ? {
        coordinateName: "y",
        dimension: "height",
        offsetDimension: "offsetHeight",
        startOffset: "top",
        endOffset: "bottom"
      } : {
        coordinateName: "x",
        dimension: "width",
        offsetDimension: "offsetWidth",
        startOffset: "left",
        endOffset: "right"
      };
    }
  }, {
    key: "_preventDefault",
    value: function _preventDefault(e) {
      this._draggedItem && e.preventDefault();
    }
  }, {
    key: "_containerDownHandler",
    value: function _containerDownHandler(e) {
      var t = this;

      if (!(t.disabled || t._draggedItem)) {
        var _i986 = (t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target).closest(".smart-sortable-item");

        if (_i986) {
          var _a655 = e.pageX - window.scrollX,
              _n495 = e.pageY - window.scrollY,
              _o352 = _i986.getBoundingClientRect(),
              _r215 = getComputedStyle(_i986),
              _l150 = parseFloat(_r215.marginLeft),
              _s108 = parseFloat(_r215.marginTop);

          "handle" === t.dragMode && _a655 >= _o352.left && _a655 <= _o352.right && _n495 >= _o352.top && _n495 <= _o352.bottom || (window.getSelection().removeAllRanges(), t._draggedItem = _i986, t._positionPlaceholder(), t._getPositionedAncestorCoords(), _i986.style.width = _i986.offsetWidth + "px", _i986.style.height = _i986.offsetHeight + "px", _i986.style.left = _o352.left + window.scrollX - _l150 - t._positionedAncestorCoords.x + "px", _i986.style.top = _o352.top + window.scrollY - _s108 - t._positionedAncestorCoords.y + "px", _i986.classList.add("dragged"), t._clickOffset = {
            x: _a655 - _o352.left + _l150,
            y: _n495 - _o352.top + _s108
          }, t._prevCoords = {
            x: _a655,
            y: _n495
          }, t._getItemCoordinates());
        }
      }
    }
  }, {
    key: "_positionPlaceholder",
    value: function _positionPlaceholder() {
      var e = this,
          t = e._draggedItem,
          i = getComputedStyle(t),
          a = document.createElement("div");
      a.className = "smart-sortable-item placeholder smart-visibility-hidden", a.style.width = t.offsetWidth + "px", a.style.height = t.offsetHeight + "px", a.style.minHeight = t.offsetHeight + "px", a.style.marginBottom = i.marginBottom, a.style.marginLeft = i.marginLeft, a.style.marginRight = i.marginRight, a.style.marginTop = i.marginTop, e._itemsParent.insertBefore(a, t.nextElementSibling), e._placeholder = a;
    }
  }, {
    key: "_getPositionedAncestorCoords",
    value: function _getPositionedAncestorCoords() {
      var e = this,
          t = e.offsetParent;

      if (e._positionedAncestorCoords = {
        x: 0,
        y: 0
      }, t !== document.body) {
        var _i987 = t.getBoundingClientRect();

        e._positionedAncestorCoords = {
          x: _i987.left,
          y: _i987.top
        };
      }
    }
  }, {
    key: "_getItemCoordinates",
    value: function _getItemCoordinates() {
      var e = this,
          t = [];
      e._items.forEach(function (e) {
        var i = e.getBoundingClientRect();
        t.push({
          left: i.left,
          top: i.top,
          right: i.right,
          bottom: i.bottom,
          width: i.width,
          height: i.height
        });
      }), e._coordinates = t;
    }
  }, {
    key: "_containerMoveHandler",
    value: function _containerMoveHandler(e) {
      this._draggedItem && "touchmove" === e.originalEvent.type && e.originalEvent.preventDefault();
    }
  }, {
    key: "_containerTransitionendHandler",
    value: function _containerTransitionendHandler(e) {
      var t = this;
      t._draggedItem && e.target.classList.contains("smart-sortable-item") && (e.target.classList.contains("returning") ? t._resolveDragging() : t._getItemCoordinates());
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = this,
          i = t._draggedItem;
      if (!i) return;
      var a = t._settings,
          n = {
        x: e.pageX - window.scrollX,
        y: e.pageY - window.scrollY
      },
          o = n[a.coordinateName];
      var r;
      if (t._prevCoords.x === n.x && t._prevCoords.y === n.y) return;
      t.hasAttribute("dragged") || t.setAttribute("dragged", ""), r = t._prevCoords[a.coordinateName] > o ? "up" : "down", t._prevCoords = n, i.style.top = e.pageY - t._clickOffset.y - t._positionedAncestorCoords.y + "px", i.style.left = e.pageX - t._clickOffset.x - t._positionedAncestorCoords.x + "px";

      var l = t._items.indexOf(i);

      var s;

      for (var _n496 = 0; _n496 < t._coordinates.length; _n496++) {
        var _e1199 = t._coordinates[_n496];
        if (l !== _n496) if ("down" === r && o >= _e1199[a.startOffset] + _e1199[a.dimension] / 2 && o <= _e1199[a.endOffset]) {
          s = t._items[_n496];
          break;
        } else if ("up" === r && o >= _e1199[a.startOffset] && o <= _e1199[a.startOffset] + _e1199[a.dimension] / 2) {
          s = t._items[_n496];
          break;
        }
      }

      if (!s) return void delete t._prevOverItem;

      if (s !== t._prevOverItem) {
        if (t._prevOverItem = s, s[r]) return;

        var _e1200 = t._items.indexOf(s);

        if (t._overItem = s, s.up || s.down) s.style.transform = null, delete s.up, delete s.down;else {
          if ("horizontal" === t.mode && ("up" === r && (!t.rightToLeft && _e1200 > l || t.rightToLeft && _e1200 < l) || "down" === r && (!t.rightToLeft && _e1200 < l || t.rightToLeft && _e1200 > l))) return;
          if ("vertical" === t.mode && ("up" === r && _e1200 > l || "down" === r && _e1200 < l)) return;

          var _i988 = getComputedStyle(s);

          s.style.transform = "translate".concat(a.coordinateName.toUpperCase(), "(").concat(("up" === r ? 1 : -1) * (s[a.offsetDimension] + parseFloat(_i988["margin-" + a.startOffset]) + parseFloat(_i988["margin-" + a.endOffset])), "px)"), s[r] = !0;
        }
      }
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler() {
      var e = this,
          t = e._draggedItem;
      if (!t) return;
      var i = e._overItem;

      if (i) {
        var _a656 = e._items.indexOf(t),
            _n497 = e._items.indexOf(i);

        _a656 < _n497 && i[e.rightToLeft && "horizontal" === e.mode ? "up" : "down"] || _a656 > _n497 && !i.down && !i.up ? (e._insertBefore = i.nextElementSibling, i = e._insertBefore, i && i.nextElementSibling === t && (i = e._placeholder)) : (_a656 > _n497 && i[e.rightToLeft && "horizontal" === e.mode ? "down" : "up"] || _a656 < _n497 && !i.down && !i.up) && (e._insertBefore = i, !(_a656 > _n497 && i[e.rightToLeft && "horizontal" === e.mode ? "down" : "up"]) && (i = i.previousElementSibling || i));
      } else i = e._placeholder;

      e._resolveDragging();
    }
  }, {
    key: "_resolveDragging",
    value: function _resolveDragging() {
      var e = this,
          t = e._draggedItem,
          i = e._items.indexOf(t);

      var a = !1;
      t.classList.remove("dragged", "returning"), e._removeInlineStyle(), e._insertBefore !== void 0 && e._items.indexOf(e._insertBefore) !== i && e._insertBefore !== e._placeholder[e.rightToLeft && "horizontal" === e.mode ? "previousElementSibling" : "nextElementSibling"] && (e._itemsParent.insertBefore(t, e._insertBefore), delete e._insertBefore, a = !0), e._itemsParent.removeChild(e._placeholder), delete e._clickOffset, delete e._draggedItem, delete e._overItem, delete e._placeholder, delete e._prevCoords, e.removeAttribute("dragged"), a && (e._getItems(!1), e.$.fireEvent("dragEnd", {
        oldIndex: i,
        newIndex: e._items.indexOf(t)
      }));
    }
  }, {
    key: "_removeInlineStyle",
    value: function _removeInlineStyle() {
      var e = this;
      e._items.forEach(function (e) {
        e.style = null, e.style.transition = "none", delete e.up, delete e.down;
      }), setTimeout(function () {
        e._items.forEach(function (e) {
          return e.style.transition = null;
        });
      }, 50);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        dragMode: {
          value: "item",
          allowedValues: ["item", "handle"],
          type: "string"
        },
        handlePosition: {
          value: "right",
          allowedValues: ["right", "left", "top", "bottom"],
          type: "string"
        },
        handleVisibility: {
          value: "hover",
          allowedValues: ["hover", "visible"],
          type: "string"
        },
        items: {
          value: null,
          type: "string?"
        },
        mode: {
          value: "vertical",
          allowedValues: ["horizontal", "vertical"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        contextmenu: "_preventDefault",
        "container.down": "_containerDownHandler",
        "container.move": "_containerMoveHandler",
        "container.transitionend": "_containerTransitionendHandler",
        "document.dragstart": "_preventDefault",
        "document.move": "_documentMoveHandler",
        "document.selectstart": "_preventDefault",
        "document.up": "_documentUpHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.sortable.css"];
    }
  }]);

  return _class114;
}(Smart.ContentElement)), Smart("smart-table",
/*#__PURE__*/
function (_Smart$ContentElement19) {
  "use strict";

  _inherits(_class115, _Smart$ContentElement19);

  function _class115() {
    _classCallCheck(this, _class115);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class115).apply(this, arguments));
  }

  _createClass(_class115, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" class=\"smart-container\" role=\"presentation\">\n\t\t\t\t\t   <table id=\"tableContainer\" inner-h-t-m-l='[[innerHTML]]' class =\"smart-table-container\">\n\t\t\t\t\t\t\t<content></content>\n                       </table>              \n                </div>";
    }
  }, {
    key: "ready",
    value: function ready() {
      var e = this;
      e.setAttribute("role", "presentation"), e.dataBind();
    }
  }, {
    key: "_initColumns",
    value: function _initColumns() {
      var e = this;
      e._columns = [], e.columnByDataField = [];

      var _loop44 = function _loop44(_t983, _i990) {
        if (_i990 = e.columns[_t983], "string" == typeof _i990 && e.dataSource.dataFields) {
          var _t984 = e.dataSource.dataFields.find(function (e) {
            if (e.name === _i990) {
              _i989 = _i990;
              return e;
            }
          });

          _i990 = {
            label: _i990,
            dataField: _i990,
            dataType: _t984 ? _t984.dataType || "string" : "string"
          };
        }

        e._columns.push(_i990), e.columnByDataField[_i990.dataField] = _i990;
        _i989 = _i990;
      };

      for (var _t983 = 0, _i989; _t983 < e.columns.length; _t983++) {
        _loop44(_t983, _i989);
      }
    }
  }, {
    key: "_initRows",
    value: function _initRows() {
      var e = this;
      e.rows = [], e.rowById = [];

      var t = function (_t985) {
        function t(_x18, _x19) {
          return _t985.apply(this, arguments);
        }

        t.toString = function () {
          return _t985.toString();
        };

        return t;
      }(function (t, i) {
        var a = {
          data: t,
          boundIndex: i
        };
        e.rowById[a.uid] = a, e.rows.push(a);
      }),
          i = function i() {
        var t = e.rows[e.rows.length - 1];
        delete e.rowById[t.uid], e.rows.pop();
      },
          a = function a(t) {
        var i = e.rows[e.rows.length - 1];
        delete e.rowById[i.uid], e.rows.splice(t, 1);
      };

      for (var _a657 = 0; _a657 < e.dataSource.length; _a657++) {
        var _i991 = e.dataSource[_a657];
        t(_i991, _a657);
      }

      e.dataSource.notify(function (n) {
        if (!e.dataSource._updating) {
          var _o353 = n.data;

          switch (e.rows.canNotify = !1, n.action) {
            case "add":
              if (_o353.length) for (var _a658 = 0; _a658 < _o353.length; _a658++) {
                t(_o353[_a658], e.dataSource.length - _o353.length + _a658);
              } else t(_o353, e.dataSource.length - 1);
              break;

            case "update":
              if (_o353.length) for (var _t986 = 0; _t986 < _o353.length; _t986++) {
                var _i992 = n.index[_t986];
                e.rows[_i992].data = _o353[_t986];
              } else {
                var _t987 = n.index;
                e.rows[_t987].data = _o353;
              }
              break;

            case "insert":
              t(_o353, n.index);

              for (var _t988 = 0; _t988 < e.rows.length; _t988++) {
                var _i993 = e.rows[_t988];
                _i993.dataIndex = _t988;
              }

              break;

            case "remove":
              a(n.index);
              break;

            case "removeLast":
              i();
          }

          e.rows.canNotify = !0, e.refresh();
        }
      }), e.rows = new Smart.ObservableArray(e.rows);

      for (var _t989 = 0; _t989 < e.rows.length; _t989++) {
        var _i994 = e.rows[_t989];

        _i994.propertyChanged = function () {};
      }

      e.rows.notify(function (t) {
        if (e.rows.canNotify && !t.path) {
          e.rows.canNotify = !1;
          var _i995 = t.action;
          e.dataSource && (e.dataSource.canNotify = !1, "add" === _i995 ? e.dataSource.add(e.rows[t.index]) : "update" === _i995 ? e.dataSource.update(t.index, e.rows[t.index]) : "remove" === _i995 ? e.dataSource.remove(t.index) : void 0, e.dataSource.canNotify = !0, e.rows.canNotify = !0, e.refresh());
        }
      });
    }
  }, {
    key: "downHandler",
    value: function downHandler() {}
  }, {
    key: "refresh",
    value: function refresh() {
      var e = this;
      var t = "<thead><tr>",
          a = "<tbody>";

      for (var _a659 = 0; _a659 < e._columns.length; _a659++) {
        var _i996 = e._columns[_a659];
        t += "<th scope=\"col\">" + _i996.label + "</th>";
      }

      t += "</tr></thead>";

      for (var _t990 = 0; _t990 < e.rows.length; _t990++) {
        var _i997 = e.rows[_t990];
        a += "<tr>";

        for (var _t991 = 0; _t991 < e._columns.length; _t991++) {
          var _n498 = e._columns[_t991];
          a += "<td>" + _i997.data[_n498.dataField] + "</td>";
        }

        a += "</tr>";
      }

      a += "</tbody>", e.innerHTML = t + a;
      var n = e.querySelectorAll("th");

      for (var _t992 = 0; _t992 < e._columns.length; _t992++) {
        var _i998 = e._columns[_t992];
        _i998.headerCellElement = n[_t992], _i998.headerCellElement.onclick = function () {
          "none" === e.sortMode || (!this.headerCellElement.sortIconContainerElement && (this.headerCellElement.innerHTML += "<span class=\"sort-by\"></span>", this.headerCellElement.sortIconContainerElement = this.headerCellElement.lastChild), this.headerCellElement.sortIconContainerElement.classList.contains("asc") ? e.sortBy(this.dataField, "desc") : this.headerCellElement.sortIconContainerElement.classList.contains("desc") ? e.sortBy(this.dataField, null) : e.sortBy(this.dataField, "asc"));
        }.bind(_i998);
      }

      if (e._sortColumns && 0 < e._sortColumns.length) for (var _t993 = 0; _t993 < e._sortColumns.length; _t993++) {
        var _i999 = e._sortColumns[_t993],
            _a660 = e.columnByDataField[_i999.dataField];
        _a660.headerCellElement.sortIconContainerElement || (_a660.headerCellElement.innerHTML += "<span class=\"sort-by " + _i999.direction + "\"></span>", _a660.headerCellElement.sortIconContainerElement = _a660.headerCellElement.lastChild);
      }
    }
  }, {
    key: "dataBind",
    value: function dataBind() {
      var e = this;

      if (!e.dataSource) {
        if (!e.columns) {
          e.columns = [], e.dataFields = [];

          var _t995 = document.querySelectorAll("th");

          for (var _a661 = 0; _a661 < _t995.length; _a661++) {
            var _i1001 = _t995[_a661].innerHTML.trim();

            e.columns.push({
              label: _i1001,
              dataField: _i1001,
              dataType: "string"
            }), e.dataFields.push(_i1001);
          }
        }

        var _t994 = [];

        if (!e.rows) {
          var _a662 = document.querySelectorAll("tr");

          for (var _n499 = 0; _n499 < _a662.length; _n499++) {
            var _i1002 = _a662[_n499],
                _o354 = {},
                _r216 = _i1002.querySelectorAll("td");

            if (0 < _r216.length) {
              for (var _t996 = 0; _t996 < e.columns.length; _t996++) {
                var _i1003 = e.columns[_t996];
                _o354[_i1003.dataField] = _r216[_t996].innerHTML.trim();
              }

              _t994.push(_o354);
            }
          }

          e.dataSource = new Smart.DataAdapter({
            dataSource: _t994,
            dataFields: e.dataFields
          });
        }

        var _i1000 = e.querySelectorAll("table");

        1 < _i1000.length && _i1000[_i1000.length - 1].parentNode.removeChild(_i1000[_i1000.length - 1]);
      }

      e._initColumns(), e._initRows(), e.refresh();
    }
  }, {
    key: "sortBy",
    value: function sortBy(e, t) {
      var a = this,
          n = a.columnByDataField[e],
          o = [],
          r = [],
          l = [],
          i = function i(e) {
        e.headerCellElement.sortIconContainerElement || (e.headerCellElement.innerHTML += "<span class=\"sort-by\"></span>", e.headerCellElement.sortIconContainerElement = e.headerCellElement.lastChild);
      },
          s = function s(e) {
        i(e), e.headerCellElement.sortIconContainerElement.classList.remove("desc"), e.headerCellElement.sortIconContainerElement.classList.remove("asc"), e.sortOrder = null;
      },
          d = function d() {
        if (a._sortColumns && 0 < a._sortColumns.length) for (var _e1201 = 0; _e1201 < a._sortColumns.length; _e1201++) {
          var _t997 = a._sortColumns[_e1201],
              _i1004 = a.columnByDataField[_t997.dataField];
          s(_i1004);
        }
        a._sortColumns = [];
      },
          c = function c() {
        a.dataSource._sort(a.dataSource.boundSource, o, r, l);

        for (var _e1202 = 0; _e1202 < a.dataSource.length; _e1202++) {
          var _t998 = a.rows[_e1202],
              _i1005 = a.dataSource[_e1202];
          _t998.data = _i1005, _t998.boundIndex = _i1005.boundIndex;
        }

        a.refresh();
      };

      if (null === n || void 0 === n) return void (a._sortColumns && 0 < a._sortColumns.length && (d(), c()));
      if ("none" === a.sortMode || !a.dataSource) return;
      if (t && n.sortOrder === t) return;
      var m = t || "asc";
      s(n), a._sortColumns || (a._sortColumns = []);
      var u = "string";

      for (var _n500 = 0; _n500 < a.dataSource.dataFields.length; _n500++) {
        var _t999 = a.dataSource.dataFields[_n500];

        if (_t999.name === e) {
          u = _t999.dataType;
          break;
        }
      }

      var p = !0;

      for (var _o355 = 0; _o355 < a._sortColumns.length; _o355++) {
        var _t1000 = a._sortColumns[_o355];
        if (_t1000.dataField === e) if (p = !1, "asc" === _t1000.direction) _t1000.direction = "desc", m = "desc";else if ("desc" === _t1000.direction) {
          a._sortColumns.splice(_o355, 1), s(n), m = null;
          break;
        }
      }

      p && ("one" === a.sortMode && d(), a._sortColumns.push({
        dataField: e,
        direction: m,
        dataType: u
      })), i(n), null === m ? (n.headerCellElement.sortIconContainerElement.classList.remove("asc"), n.headerCellElement.sortIconContainerElement.classList.remove("desc")) : (n.headerCellElement.sortIconContainerElement.classList.remove("asc"), n.headerCellElement.sortIconContainerElement.classList.remove("desc"), n.sortOrder = m, "desc" === m ? n.headerCellElement.sortIconContainerElement.classList.add("desc") : n.headerCellElement.sortIconContainerElement.classList.add("asc"));

      for (var _n501 = 0; _n501 < a._sortColumns.length; _n501++) {
        var _e1203 = a._sortColumns[_n501];
        o.push(_e1203.dataField), r.push(_e1203.direction), l.push(_e1203.dataType);
      }

      c();
    }
  }, {
    key: "clearSort",
    value: function clearSort() {
      this.sortBy(null);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        columns: {
          value: null,
          type: "any?",
          reflectToAttribute: !1
        },
        dataSource: {
          value: null,
          type: "any?",
          reflectToAttribute: !1
        },
        sortMode: {
          value: "none",
          type: "string",
          allowedValues: ["none", "one", "many"]
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "tableContainer.down": "downHandler"
      };
    }
  }]);

  return _class115;
}(Smart.ContentElement)), Smart("smart-color-panel",
/*#__PURE__*/
function (_Smart$BaseElement29) {
  "use strict";

  _inherits(_class116, _Smart$BaseElement29);

  function _class116() {
    _classCallCheck(this, _class116);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class116).apply(this, arguments));
  }

  _createClass(_class116, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <div id=\"gridModeContainer\" class=\"grid-mode-container\" role=\"presentation\"></div>\n                    <div id=\"paletteModeContainer\" class=\"palette-mode-container\" role=\"presentation\">\n                        <div id=\"colorPaletteContainer\" class=\"color-palette-container\" role=\"presentation\">\n                            <div id=\"colorPalette\" class=\"color-palette\" aria-label=\"Color palette\">\n                                <div id=\"colorPaletteThumb\" class=\"color-palette-thumb\" role=\"presentation\"></div>\n                            </div>\n                            <div id=\"hueScale\" class=\"hue-scale\" aria-label=\"Hue scale\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"360\">\n                                <div id=\"hueScaleThumb\" class=\"hue-scale-thumb\" role=\"presentation\"></div>\n                            </div>\n                            <div id=\"colorPaletteRadial\" class=\"color-palette-radial\" aria-label=\"Radial color palette\">\n                                <span class=\"white-radial-gradient\" role=\"presentation\"></span>\n                                <div id=\"colorPaletteRadialThumb\" class=\"color-palette-radial-thumb\" role=\"presentation\"></div>\n                            </div>\n                            <div id=\"colorPaletteHexagonal\" class=\"color-palette-hexagonal\" aria-label=\"Hexagonal color palette\"></div>\n                            <div id=\"brightnessScale\" class=\"brightness-scale\" aria-label=\"Brightness scale\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"1\">\n                                <div id=\"brightnessScaleThumb\" class=\"brightness-scale-thumb\" role=\"presentation\"></div>\n                            </div>\n                            <span id=\"hexModeResizeTrigger\" class=\"color-sample hex-mode-resize-trigger\"></span>\n                            <div id=\"colorControlsContainer\" class=\"color-controls-container\" role=\"presentation\"></div>\n                        </div>\n                        <div id=\"alphaChannelContainer\" class=\"alpha-channel-container\"></div>\n                    </div>\n                    <div id=\"buttonsContainer\" class=\"buttons-container\"></div>\n                    <input id=\"hiddenInput\" type=\"hidden\" name=\"[[name]]\">\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, a) {
      function i() {
        n._generateGridStructures(), n._applyValue(n.value);
      }

      var n = this;

      switch (e) {
        case "applyValueMode":
          "instantly" !== a || n.value || (n._HSV = {
            h: 0,
            s: 0,
            v: 1
          }, n._selectedItem && n._selectedItem.classList.contains("selected") && (n._selectedItem.classList.remove("selected"), n._selectedItem.removeAttribute("aria-current"), n._selectedItem.style.stroke = null)), ("palette" === n.displayMode || "radial" === n.displayMode || "hexagonal" === n.displayMode) && n._handleCancelButtonClick(), "useButtons" === a && n._createApplyValueButtons();
          break;

        case "paletteColors":
          n._customPalette = n._mapDataSourceToPalette(), i(n.displayMode);
          break;

        case "inverted":
          {
            if (-1 === ["hexagonal", "radial", "spectrumGrid"].indexOf(n.displayMode)) return;

            var _e1204 = n.value,
                _t1001 = n.$.hueScaleThumb.offsetHeight,
                _o356 = n._validateInRange(_t1001 / 2, 0, n.$.hueScale.offsetHeight - _t1001) / n.$.brightnessScale.offsetHeight;

            if (isNaN(_o356)) return void n._generateGridStructures();
            a ? (n._HSV.v = n._HSV.s, n._HSV.s = 1 - _o356) : (n._HSV.s = n._HSV.v, n._HSV.v = 1 - _o356), n.value = n._HSVtoRGBA(n._HSV), n.$.colorPaletteRadial.style.setProperty("--smart-color-panel-brightness", n.$.brightnessScaleThumb.s || 0), i(n.displayMode), n.value !== _e1204 && n.$.fireEvent("change", {
              oldValue: _e1204,
              value: n.value
            });
            break;
          }

        case "palette":
          i(n.displayMode), n._updatePreviewContainerValues(n.value);
          break;

        case "displayMode":
        case "gridThemeColors":
        case "gridShadeColors":
        case "gridStandardColors":
          if ("displayMode" === e) {
            var _e1205 = n.value;

            if (-1 < n.$.container.className.indexOf("custom-color-selection") && n._handleCancelButtonClick(), null !== n.value && "palette" !== a && "hexagonal" !== a && "radial" !== a) {
              !n.editAlphaChannel && n.$.alphaChannelThumb && (n.$.alphaChannelThumb.style[n.rightToLeft ? "left" : "right"] = "", n.$.alphaChannelThumb.style[n.rightToLeft ? "right" : "left"] = 0, n.$.alphaChannelThumb.a = n._RGBA.a = 1, n.$.alphaChannelScale.setAttribute("aria-valuenow", 1)), n.value = n._getValue(n.valueFormat), i(), n.$.fireEvent("change", {
                oldValue: _e1205,
                value: n.value
              });
              break;
            }

            if (null === n.value && ("palette" === a || "hexagonal" === a || "radial" === a)) {
              n._RGBA = {
                r: 255,
                g: 255,
                b: 255,
                a: 1
              }, n._HSV = {
                h: 0,
                s: 0,
                v: 1
              }, n.value = n._getValue(n.valueFormat), i(), n.$.fireEvent("change", {
                oldValue: _e1205,
                value: n.value
              });
              break;
            }

            if (n.value = n._getValue(n.valueFormat), Smart.Utilities.Core.Browser.Firefox && "radial" === t) {
              var _e1206 = n.$.colorPaletteRadial.querySelector("canvas");

              _e1206 && _e1206.remove();
            }
          }

          i(n.displayMode);
          break;

        case "locale":
        case "messages":
          n._localizeLabels();

          break;

        case "paletteCustomColors":
          n._userPalette = a || [], (-1 < n.displayMode.toLowerCase().indexOf("grid") || "default" === n.displayMode) && n._generatePaletteUserColorGrid(!0);
          break;

        case "editAlphaChannel":
          {
            if (a || (n._RGBA.a = 1), a && n._createAlphaChannel(), !n.value) return;
            var _e1207 = n.value;
            n.value = n._getValue(n.valueFormat), n.value !== _e1207 && n.$.fireEvent("change", {
              oldValue: _e1207,
              value: n.value
            });
            break;
          }

        case "value":
          {
            if (a = "string" == typeof a ? a.trim() : a, !n._isValidColor(a)) return void n._reset();
            n._applyValue(a), n.value = n._getValue(n.valueFormat), "hexagonal" === n.displayMode && n._generateHoneycomb(n.columnCount, n.inverted ? {
              s: n._HSV.s
            } : {
              v: n._HSV.v
            }), t !== n.value && n.$.fireEvent("change", {
              oldValue: t,
              value: n.value
            });
            break;
          }

        case "columnCount":
          {
            var _e1208 = n.$.container.style;
            null === a || isNaN(a) ? _e1208.removeProperty("--smart-color-panel-grid-mode-column-count") : _e1208.setProperty("--smart-color-panel-grid-mode-column-count", a), n._generatePaletteUserColorGrid(), "spectrumGrid" === n.displayMode ? n._generateSpectrumGrid(parseInt(a)) : "hexagonal" === n.displayMode && n._generateHoneycomb(a, n._HSV);
          }
          break;

        case "valueFormat":
          {
            if (!n.value) return;
            var _e1209 = n.value;
            n.value = n._getValue(a), n.$.fireEvent("change", {
              oldValue: _e1209,
              value: n.value
            });
            break;
          }

        case "tooltipDisplayMode":
          if (!n.$.tooltip) return;
          "none" === a ? (n.$.tooltip.close(), n.$.tooltip.disabled = !0) : n.$.tooltip.disabled = !1;
          break;

        default:
          if (_get(_getPrototypeOf(_class116.prototype), "propertyChangedHandler", this).call(this, e, t, a), "disabled" === e) {
            var _t1002 = n.getElementsByClassName("color-input");

            for (var _n502 = 0; _n502 < _t1002.length; _n502++) {
              _t1002[_n502][e] === a;
            }
          }

          ("disabled" === e || "theme" === e || "animation" === e) && (n.$.buttonOk && (n.$.buttonOk[e] = a), n.$.buttonCancel && (n.$.buttonCancel[e] = a), n.$.buttonCustom && (n.$.buttonCustom[e] = a), n.$.tooltip && (n.$.tooltip[e] = a));
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class116.prototype), "ready", this).call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      e.setAttribute("role", "dialog"), e._initializeBaseVars(), null === e.columnCount || isNaN(e.columnCount) ? e.$.container.style.removeProperty("--smart-color-panel-grid-mode-column-count") : e.$.container.style.setProperty("--smart-color-panel-grid-mode-column-count", e.columnCount), "useButtons" === e.applyValueMode && e._createApplyValueButtons(), e.editAlphaChannel && e._createAlphaChannel(), e._localizeLabels(), e._generateGridStructures(), e.value || "hexagonal" !== e.displayMode && "radial" !== e.displayMode && "palette" !== e.displayMode || (e.value = e._getValue(e.valueFormat)), e._applyValue(e.value), e._hideControlsByPriority(), e.enableShadowDOM && e.appendChild(e.$.hiddenInput), _get(_getPrototypeOf(_class116.prototype), "render", this).call(this);
    }
  }, {
    key: "_createApplyValueButtons",
    value: function _createApplyValueButtons(e) {
      function t(e) {
        var t = document.createElement("smart-button");
        return t.classList.add(e), t.classList.add("primary"), t.rightToLeft = i.rightToLeft, t.disabled = i.disabled, t.theme = i.theme, t.animation = i.animation, i.$.buttonsContainer.appendChild(t), t;
      }

      var i = this;
      !e && "useButtons" !== i.applyValueMode || i.$.buttonsContainer.innerHTML.trim() || (i.$.buttonOk = t("button-ok"), i.$.buttonCancel = t("button-cancel"), i.$.buttonOk.content = i.localize("ok"), i.$.buttonCancel.content = i.localize("cancel"));
    }
  }, {
    key: "_createAlphaChannel",
    value: function _createAlphaChannel() {
      var e = this;

      if (!(!e.editAlphaChannel || e.editAlphaChannel && e.$.alphaChannelContainer.innerHTML.trim())) {
        e.$.alphaChannelContainer.innerHTML = "\n                            <div class=\"alpha-channel-scale\" aria-label=\"Alpha channel scale\" role=\"slider\">\n                                <div class=\"alpha-channel-thumb\" aria-hidden=\"true\"></div>\n                            </div>\n                            <label for=\"".concat(e.id, "aChannelInput\" class=\"a-channel\"></label>\n                            <input type=\"number\" step=\"0.01\" id=\"").concat(e.id, "aChannelInput\" class=\"color-input a-channel\" value=\"1\" min=\"0\" max=\"1\">"), e.$.alphaChannelScale = e.$.alphaChannelContainer.querySelector(".alpha-channel-scale"), e.$.alphaChannelThumb = e.$.alphaChannelContainer.querySelector(".alpha-channel-thumb"), e.$.alphaChannelScale.setAttribute("role", "slider"), e.$.alphaChannelScale.setAttribute("aria-valuemin", 0), e.$.alphaChannelScale.setAttribute("aria-valuemin", 1);

        var _t1003 = e.$.alphaChannelContainer.querySelector("input");

        _t1003.disabled = e.disabled, e._localizeLabels(), e._applyAlphaValue(e._RGBA.a, "alphaScale");
      }
    }
  }, {
    key: "_createGridModeComponents",
    value: function _createGridModeComponents() {
      var e = this,
          t = e.id;
      if (-1 < ["radial", "palette", "hexagonal"].indexOf(e.displayMode)) return !1;

      if (!e.$.gridModeContainer.innerHTML.trim()) {
        var _i1006 = e.$.gridModeContainer;
        _i1006.innerHTML = "\n                        <div id=\"".concat(t, "defaultSamplesContainer\" class=\"default-samples-container\"></div>\n                        <div id=\"").concat(t, "gridSamplesContainer\" class=\"grid-samples-container\"></div>\n                        <div id=\"").concat(t, "materialGridSamplesContainer\" class=\"material-grid-samples-container\" role=\"menu\"></div>\n                        <div id=\"").concat(t, "spectrumGridSamplesContainer\" class=\"spectrum-grid-samples-container\"></div>\n                        <smart-button id=\"").concat(t, "buttonCustom\" class=\"button-custom-color primary\"></smart-button>\n                        <div id=\"").concat(t, "userSamplesContainer\" class=\"user-samples-container\" role=\"menu\" aria-label=\"User colors\"></div>\n                        <smart-tooltip id=\"").concat(t, "tooltip\" arrow position=\"auto\"></smart-tooltip>"), e.$.defaultSamplesContainer = _i1006.querySelector(".default-samples-container"), e.$.gridSamplesContainer = _i1006.querySelector(".grid-samples-container"), e.$.materialGridSamplesContainer = _i1006.querySelector(".material-grid-samples-container"), e.$.materialGridSamplesContainer.$ = Smart.Utilities.Extend(e.$.materialGridSamplesContainer), e.$.spectrumGridSamplesContainer = _i1006.querySelector(".spectrum-grid-samples-container"), e.$.userSamplesContainer = _i1006.querySelector(".user-samples-container"), e.$.buttonCustom = _i1006.querySelector("smart-button"), e.$.tooltip = _i1006.querySelector("smart-tooltip"), e.$.buttonCustom.disabled = e.disabled, e.$.buttonCustom.rightToLeft = e.rightToLeft, e.$.buttonCustom.animation = e.animation, e.$.buttonCustom.theme = e.theme, e.$.buttonCustom.content = e.localize("customColor"), e.$.tooltip.disabled = e.disabled || "none" === e.tooltipDisplayMode, e.$.tooltip.rightToLeft = e.rightToLeft, e.$.tooltip.animation = e.animation, e.$.tooltip.theme = e.theme;
      }
    }
  }, {
    key: "_createColorControls",
    value: function _createColorControls(e) {
      var t = this,
          i = t.id;
      if (!e && 0 > ["radial", "palette", "hexagonal"].indexOf(t.displayMode)) return !1;
      var a = t.$.colorControlsContainer;

      if (!a.innerHTML.trim()) {
        a.innerHTML = "<div id=\"".concat(i, "previewContainer\" class=\"preview-container gradient-background\" aria-label=\"Preview\">") + "<span class=\"preview-container-top\" aria-label=\"Current color\"></span><span class=\"preview-container-bottom\" aria-label=\"New color\"></span></div>" + "<label for=\"".concat(i, "rChannelInput\" id=\"").concat(i, "rChannelLabel\" class=\"r-channel\"></label>") + "<input type=\"number\" min=\"0\" max=\"255\" id=\"".concat(i, "rChannelInput\" class=\"color-input r-channel\" value=\"255\">") + "<label for=\"".concat(i, "gChannelInput\" id=\"").concat(i, "gChannelLabel\" class=\"g-channel\"></label>") + "<input type=\"number\" min=\"0\" max=\"255\" id=\"".concat(i, "gChannelInput\" class=\"color-input g-channel\" value=\"255\">") + "<label for=\"".concat(i, "bChannelInput\" id=\"").concat(i, "bChannelLabel\" class=\"b-channel\"></label>") + "<input type=\"number\" min=\"0\" max=\"255\" id=\"".concat(i, "bChannelInput\" class=\"color-input b-channel\" value=\"255\">") + "<label for=\"".concat(i, "hexInput\" id=\"").concat(i, "hexLabel\" class=\"hex\"></label>") + "<input type=\"text\" id=\"".concat(i, "hexInput\" class=\"color-input hex\" value=\"FFFFFF\" maxlength=\"6\">");

        var _e1210 = a.getElementsByClassName("color-input");

        for (var _a663 = 0; _a663 < _e1210.length; _a663++) {
          _e1210[_a663].disabled = t.disabled;
        }

        t._localizeLabels();
      }
    }
  }, {
    key: "_containerClickHandler",
    value: function _containerClickHandler(e) {
      var t = this;

      if (!(t.disabled || t.readonly || !e.target)) {
        if (e.target.classList.contains("color-sample")) return void t._handleSampleClick(e);

        var _i1007 = e.target.closest("smart-button");

        return _i1007 === t.$.buttonCancel ? void t._handleCancelButtonClick(!0) : _i1007 === t.$.buttonCustom ? (t.$container.addClass("custom-color-selection"), t._createApplyValueButtons(!0), t._createColorControls(!0), t._applyValueInPaletteMode(), t._customColorSelection = !0, void (1 === t._RGBA.a && t.$.alphaChannelThumb && (t.$.alphaChannelThumb.style[t.rightToLeft ? "left" : "right"] = "", t.$.alphaChannelThumb.style[t.rightToLeft ? "right" : "left"] = 0, t.$.alphaChannelThumb.a = t._RGBA.a, t.$.alphaChannelScale.setAttribute("aria-valuenow", t._RGBA.a)))) : _i1007 === t.$.buttonOk ? void t._handleOkButtonClick(!0) : void (e.target === (t.shadowRoot || t).querySelector(".preview-container-top") && "useButtons" === t.applyValueMode && !t.disableUndo && t._applyValue(t.value));
      }
    }
  }, {
    key: "_reset",
    value: function _reset() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.value;
      var t = this;
      t._RGBA = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      }, t._HSV = {
        h: 0,
        s: 0,
        v: 1
      }, t.$.hueScaleThumb.h = 0, t.$.colorPaletteThumb.s = 0, t.$.colorPaletteThumb.v = 1, t.$.colorPaletteRadialThumb.h = 0, t.$.colorPaletteRadialThumb.s = 0, t.$.brightnessScaleThumb.v = 1, t.$.brightnessScaleThumb.s = 0, "hexagonal" !== t.displayMode && "radial" !== t.displayMode && "palette" !== t.displayMode ? (t.value = null, t._selectedItem && t._selectedItem.classList.contains("selected") && (t._selectedItem.classList.remove("selected"), t._selectedItem.removeAttribute("aria-current"), t._selectedItem.style.stroke = null)) : t.value = t._getValue(t.valueFormat), t._applyValue(t.value), t.$.fireEvent("change", {
        oldValue: e,
        value: t.value
      });
    }
  }, {
    key: "_handleColorPaletteDown",
    value: function _handleColorPaletteDown(e) {
      var t = this,
          i = t._getXYcoordinates(e);

      if (i) {
        var _a664 = "palette" === t.displayMode || "grid" === t.displayMode ? t.$.colorPaletteThumb : t.$.colorPaletteRadialThumb;

        if (t._activeComponent = i.container, "palette" === t.displayMode || -1 < t.$.container.className.indexOf("custom-color-selection")) {
          if (_a664.s = t._HSV.s = i.x / i.container.offsetWidth, _a664.v = t._HSV.v = 1 - i.y / i.container.offsetHeight, "grid" === t.displayMode) return t._moveThumbHandler(e, !0), void t._applyValueInPaletteMode(e);
        } else if ("radial" === t.displayMode) {
          var _e1211 = t.$.colorPaletteRadial.offsetWidth,
              _n503 = i.x - _e1211 / 2,
              _o357 = i.y - _e1211 / 2;

          _a664.h = t._HSV.h = 0 > t._calcHueAngle(_n503, _o357) ? 360 + t._calcHueAngle(_n503, _o357) : t._calcHueAngle(_n503, _o357);

          var _r217 = t.$.brightnessScaleThumb,
              _l151 = t.$.brightnessScale,
              _s109 = t._validateInRange(2 * t._calcSatDistance(_n503, _o357) / _e1211, 0, 1),
              d = _l151.offsetHeight - _r217.offsetHeight,
              c = t._validateInRange(_r217.offsetTop, 0, d) / d;

          t.inverted ? (_a664.v = t._HSV.v = _s109, _a664.s = t._HSV.s = 1 - c) : (_a664.s = t._HSV.s = _s109, _a664.v = t._HSV.v = 1 - c);
        }

        t._applyValue(t._HSVtoRGBA(t._HSV), e), t._instantUpdate();
      }
    }
  }, {
    key: "_handleScalesDown",
    value: function _handleScalesDown(e) {
      var t = this,
          i = t._getXYcoordinates(e);

      i && (t._activeComponent = i.container, i.container === t.$.hueScale ? t._updateHueScale(i) : i.container === t.$.brightnessScale ? (t._updateBrightnessScale(i), "hexagonal" === t.displayMode && t._generateHoneycomb(t.columnCount, t._HSV)) : t.$.alphaChannelScale && (t.$.alphaChannelThumb.a = t._RGBA.a = parseFloat(((i.container.offsetWidth - i.x) / i.container.offsetWidth).toFixed(2)), t.rightToLeft && (t.$.alphaChannelThumb.a = t._RGBA.a = (1 - t._RGBA.a).toFixed(2)), t._applyAlphaValue(t._RGBA.a, "alphaScale")), t._applyValue(t._HSVtoRGBA(t._HSV), e), t._instantUpdate());
    }
  }, {
    key: "_updateBrightnessScale",
    value: function _updateBrightnessScale(e) {
      var t = this,
          i = e.y - t.$.brightnessScaleThumb.offsetHeight / 2,
          a = t.$.brightnessScale.offsetHeight - t.$.brightnessScaleThumb.offsetHeight,
          n = Math.min(Math.max(parseFloat(i), 0), parseFloat(a)) / a;
      t.inverted ? t.$.brightnessScaleThumb.s = t._HSV.s = 1 - n : t.$.brightnessScaleThumb.v = t._HSV.v = 1 - n, t.$.brightnessScale.setAttribute("aria-valuenow", t._HSV.v), t.$.brightnessScaleThumb.style.top = a * n + "px", t.$.colorPaletteRadial.style.setProperty("--smart-color-panel-brightness", n);
    }
  }, {
    key: "_updateHueScale",
    value: function _updateHueScale(e) {
      var t = this,
          i = e.y - t.$.hueScaleThumb.offsetHeight / 2,
          a = t.$.hueScale.offsetHeight,
          n = a - t.$.hueScaleThumb.offsetHeight;
      t.$.hueScaleThumb.h = t._HSV.h = 360 * (a - e.y) / a, t.$.hueScale.setAttribute("aria-valuenow", t.$.hueScaleThumb.h), t.$.hueScaleThumb.style.top = n * Math.min(Math.max(parseFloat(i), 0), parseFloat(n)) / n + "px";
    }
  }, {
    key: "_trackMoveHandler",
    value: function _trackMoveHandler(e) {
      var t = this;
      Smart.Utilities.Core.isMobile || e.stopPropagation(), "touchmove" === e.originalEvent.type && t._dragDetails && e.originalEvent.preventDefault();
    }
  }, {
    key: "_moveThumbHandler",
    value: function _moveThumbHandler(e, t) {
      var i = this,
          a = e.pageX - window.pageXOffset,
          n = e.pageY - window.pageYOffset;

      if (!i.disabled && !i.readonly && i._activeComponent && i._dragDetails && (i._dragDetails.x !== a || i._dragDetails.y !== n || t)) {
        var _t1004 = i._getXYcoordinates(e);

        if (_t1004) {
          var _a665 = i._activeComponent.offsetWidth,
              _n504 = i._activeComponent.offsetHeight;

          switch (i._activeComponent) {
            case i.$.colorPalette:
              {
                i.$.colorPaletteThumb.style.left = 100 * _t1004.x / _a665 + "%", i.$.colorPaletteThumb.style.top = 100 * _t1004.y / _n504 + "%", i.$.colorPaletteThumb.s = i._HSV.s = _t1004.x / _a665, i.$.colorPaletteThumb.v = i._HSV.v = 1 - _t1004.y / _n504;
                break;
              }

            case i.$.colorPaletteRadial:
              {
                var _e1212 = _a665,
                    _n505 = _t1004.x - _e1212 / 2,
                    _o358 = _t1004.y - _e1212 / 2;

                i.$.colorPaletteRadialThumb.h = i._HSV.h = 0 > i._calcHueAngle(_n505, _o358) ? 360 + i._calcHueAngle(_n505, _o358) : i._calcHueAngle(_n505, _o358), i.inverted ? i.$.colorPaletteRadialThumb.v = i._HSV.v = i._validateInRange(2 * i._calcSatDistance(_n505, _o358) / _e1212, 0, 1) : i.$.colorPaletteRadialThumb.s = i._HSV.s = i._validateInRange(2 * i._calcSatDistance(_n505, _o358) / _e1212, 0, 1);

                var _r218 = (i.shadowRoot || i).querySelector(".preview-container-bottom");

                _r218 && (_r218.style.backgroundColor = i._HSVtoRGBA());
                break;
              }

            case i.$.hueScale:
              {
                i._updateHueScale(_t1004);

                break;
              }

            case i.$.brightnessScale:
              {
                i._updateBrightnessScale(_t1004), "hexagonal" === i.displayMode && i._generateHoneycomb(i.columnCount, i.inverted ? {
                  s: i._HSV.s
                } : {
                  v: i._HSV.v
                });
                break;
              }

            case i.$.alphaChannelScale:
              {
                i.$.alphaChannelThumb.a = i._RGBA.a = parseFloat(((_a665 - _t1004.x) / _a665).toFixed(2)), i.rightToLeft && (i.$.alphaChannelThumb.a = i._RGBA.a = (1 - i._RGBA.a).toFixed(2));
                break;
              }
          }

          i._applyValue(i._HSVtoRGBA(i._HSV), e), i._instantUpdate();
        }
      }
    }
  }, {
    key: "_releaseThumbUpHandler",
    value: function _releaseThumbUpHandler() {
      var e = this,
          t = !!e._activeComponent;
      e._activeComponent = null;
      e.disabled || e.readonly || !t || e._dragDetails && e._dragDetails.isPalettePressed || e._instantUpdate();
    }
  }, {
    key: "_handleCancelButtonClick",
    value: function _handleCancelButtonClick(e) {
      var t = this,
          i = t.value;

      switch ("palette" !== t.displayMode && "radial" !== t.displayMode && "hexagonal" !== t.displayMode ? (t.value = i, t._HSV = t._getValue("hsv", t.value) || {
        h: 1,
        s: 0,
        v: 1
      }, t._RGBA = t._getValue("HSVtoRGBAarray", t.value)) : (t._HSV = t._getValue("hsv", t.value) || {
        h: 1,
        s: 0,
        v: 1
      }, t._RGBA = t._getValue("HSVtoRGBAarray", t.value), t.value = t._getValue(t.valueFormat)), t._applyValue(t.value), t.displayMode) {
        case "radial":
          t._generateRadialCanvas();

          break;

        case "hexagonal":
          t._generateHoneycomb(t.columnCount, t._HSV);

      }

      if (null === t.value && t._selectedItem && t._selectedItem.classList.contains("selected") && (t._selectedItem.classList.remove("selected"), t._selectedItem.removeAttribute("aria-current")), i !== t.value && t.$.fireEvent("change", {
        oldValue: i,
        value: t.value
      }), -1 < t.$.container.className.indexOf("custom-color-selection") && t._applyValueInPaletteMode(), e && t.$.fireEvent("cancelButtonClick"), !1 === t._customColorSelection) {
        t._updatePreviewContainerValues(t.value);

        var _e1213 = "hexagonal" === t.displayMode ? t.$.colorPaletteHexagonal : t.$.gridModeContainer;

        var _a666 = _e1213.getElementsByClassName("selected");

        for (var _e1214 = 0; _e1214 < _a666.length; _e1214++) {
          !_a666[_e1214] || t.value && t._equalValues(_a666[_e1214].colorCode, t.value) || (_a666[_e1214].style.stroke = null, _a666[_e1214].classList.remove("selected"), _a666[_e1214].removeAttribute("aria-current"));
        }
      } else t.$container.removeClass("custom-color-selection");

      if (t._customColorSelection = !1, t._customTempColor = void 0, "palette" === t.displayMode || "radial" === t.displayMode) {
        var _e1215 = (t.shadowRoot || t).querySelector(".preview-container-top");

        _e1215 && (_e1215.style.backgroundColor = t.value);
      }
    }
  }, {
    key: "_handleOkButtonClick",
    value: function _handleOkButtonClick(e) {
      var t = this,
          i = t.value;

      if (!1 === t._customColorSelection || "undefined" == typeof t._customColorSelection) {
        if (t._customTempColor && (t._userPalette.unshift(t._customTempColor), t._generatePaletteUserColorGrid(), t._generateNewPalette = !1, t._customTempColor = ""), t.value = "palette" === t.displayMode || "radial" === t.displayMode || "hexagonal" === t.displayMode || t._selectedItem && t._selectedItem.classList.contains("selected") ? t._getValue(t.valueFormat) : null, null === t.value) if ("palette" === t.displayMode) t._applyValue(t._HSVtoRGBA(t._HSV), event);else {
          var _e1216 = t.$.gridModeContainer.getElementsByClassName("selected");

          for (var _t1005 = 0; _t1005 < _e1216.length; _t1005++) {
            _e1216[_t1005] && (_e1216[_t1005].classList.remove("selected"), _e1216[_t1005].removeAttribute("aria-current"));
          }
        }
        i !== t.value && t.$.fireEvent("change", {
          oldValue: i,
          value: t.value
        });
      } else {
        var _a667 = t._getValue(t.valueFormat);

        return "useButtons" !== t.applyValueMode && (t.value = _a667), t._userPalette.unshift(_a667), t._generatePaletteUserColorGrid(), t._customColorSelection = !1, i !== t.value && t.$.fireEvent("change", {
          oldValue: i,
          value: t.value
        }), e && t.$.fireEvent("okButtonClick", {}), void t.$container.removeClass("custom-color-selection");
      }

      e && t.$.fireEvent("okButtonClick", {}), t._customColorSelection = !1;
      "useButtons" !== t.applyValueMode || t._equalValues(t.value, t._HSVtoRGBA()) || t._updatePreviewContainerValues(t._getValue("rgba"), !0);
    }
  }, {
    key: "_handleInputChange",
    value: function _handleInputChange(e) {
      var t = Math.min,
          i = Math.max;
      var a = this,
          n = a.value,
          o = e.target;

      if (!(a.disabled || a.readonly)) {
        e.preventDefault(), e.stopPropagation();

        var _r219 = ["r-channel", "g-channel", "b-channel"].find(function (e) {
          return -1 < o.className.indexOf(e);
        }),
            _l152 = o.classList.contains("a-channel");

        if (_r219 || _l152) o.value = _r219 ? t(255, i(0, o.value)) : t(1, i(0, parseFloat(o.value) || 0)), a._RGBA = a._getRGBAFromInputs(), a._HSV = a._getValue("hsv", "rgba(" + a._RGBA.r + ", " + a._RGBA.g + ", " + a._RGBA.b + ", " + a._RGBA.a + ")");else if (o.classList.contains("hex")) {
          var _e1217 = a.value ? a._getValue("hex") : null,
              _t1006 = "#" + o.value;

          a._isHEX(_t1006) ? (a._RGBA.a = 1, a._applyValue(a.editAlphaChannel ? a._toRGBA(_t1006) : a._toHEX(_t1006))) : o.value = _e1217 ? _e1217.substring(1) : "ffffff";
        }
        a._applyValue(a.editAlphaChannel ? a._getValue("rgba") : a._getValue("hex")), "useButtons" === a.applyValueMode || -1 < a.$.container.className.indexOf("custom-color-selection") || (a.value = a._getValue(a.valueFormat), a.$.fireEvent("change", {
          oldValue: n,
          value: a.value
        }));
      }
    }
  }, {
    key: "_applyValue",
    value: function _applyValue(e, t) {
      var i = this;
      return e && null !== e && "rgba(NaN, NaN, NaN, 1)" !== e ? void (i._HSVRGBArefresh(e.trim()), "palette" === i.displayMode || -1 < i.$.container.className.indexOf("custom-color-selection") ? i._applyValueInPaletteMode(t) : "radial" === i.displayMode ? i._applyValueInRadialMode(t) : "hexagonal" === i.displayMode ? i._applyValueInHexagonalMode(t) : i._applyValueInAnyGridMode(e.trim()), i._applyAlphaValue(i._RGBA.a), i.$.hiddenInput.value = i.value) : (i._RGBA = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      }, void (i.$.hiddenInput.value = i.value));
    }
  }, {
    key: "_applyAlphaValue",
    value: function _applyAlphaValue(e, t) {
      var i = this;

      if (e = parseFloat(e), i.$.alphaChannelScale) {
        if ("alphaScale" !== t) {
          var _t1007 = i.$.alphaChannelThumb.offsetWidth,
              _a668 = i.$.alphaChannelScale.offsetWidth,
              _n506 = (1 - e) * _a668 > _t1007 ? (1 - e) * _t1007 : 0;

          i.$.alphaChannelThumb.style[i.rightToLeft ? "left" : "right"] = "", i.$.alphaChannelThumb.style[i.rightToLeft ? "right" : "left"] = (1 - e) * _a668 - _n506 + "px";
        }

        if ("alphaInput" !== t) {
          var _t1008 = i.$.alphaChannelContainer.querySelector("input.a-channel");

          _t1008.value = e;
        }

        i.$.alphaChannelScale.setAttribute("aria-valuenow", e);
      }

      i._RGBA.a = e, i._updatePreviewContainerValues(i._getValue("rgba"));
    }
  }, {
    key: "_applyValueInPaletteMode",
    value: function _applyValueInPaletteMode(e) {
      var t = this,
          i = t._getValue("hex"),
          a = t.$.hueScale.offsetHeight,
          n = t.$.hueScaleThumb.offsetHeight,
          o = t._HSV.h ? a * ((360 - t._HSV.h) / 360) : 0,
          r = (t.shadowRoot || t).querySelector("input.hex");

      if (t._setRGBAToInputs(), r && (r.value = i.substring(1)), t.$.alphaChannelContainer.style.setProperty("--smart-color-panel-alpha-channel-color", t._rgbArrayToHEX([t._RGBA.r, t._RGBA.g, t._RGBA.b, 1])), !t._activeComponent) {
        if (t.$.alphaChannelThumb) {
          var _e1218 = t.$.alphaChannelThumb.offsetWidth,
              _i1008 = t.$.alphaChannelScale.offsetWidth,
              _a669 = (1 - t._RGBA.a) * _i1008 > _e1218 ? (1 - t._RGBA.a) * _e1218 : 0;

          t.$.alphaChannelThumb.style[t.rightToLeft ? "left" : "right"] = "", t.$.alphaChannelThumb.style[t.rightToLeft ? "right" : "left"] = (1 - t._RGBA.a) * _i1008 - _a669 + "px", t.$.alphaChannelScale.setAttribute("aria-valuenow", t._RGBA.a);
        }

        t.$.hueScaleThumb.style.top = Math.max(0, Math.min(a - n, o - n / 2)) + "px", t._setPalettePointerXYPosition();
      }

      t._activeComponent === t.$.hueScale && (t.$.colorPalette.style.backgroundColor = t._rgbaToRGB(t._HSVtoRGBA({
        h: t.$.hueScaleThumb.h,
        s: 1,
        v: 1
      }))), t._activeComponent && t._activeComponent !== t.$.colorPalette || t._setPalettePointerXYPosition(e), t.event ? t._HSV.h = t.$.hueScaleThumb.h : (t.$.hueScaleThumb.h = t._HSV.h, t.$.colorPalette.style.backgroundColor = t._rgbaToRGB(t._HSVtoRGBA({
        h: t._HSV.h,
        s: 1,
        v: 1
      }))), t._updatePreviewContainerValues(t._getValue("rgba")), t.$.hueScale.setAttribute("aria-valuenow", t.$.hueScaleThumb.h);
    }
  }, {
    key: "_applyValueInRadialMode",
    value: function _applyValueInRadialMode(e) {
      var t = this,
          i = t._getValue("hex"),
          a = (t.shadowRoot || t).querySelector("input.hex");

      if (t._setRGBAToInputs(), a && (a.value = i.substring(1)), t.$.alphaChannelContainer.style.setProperty("--smart-color-panel-alpha-channel-color", t._rgbArrayToHEX([t._RGBA.r, t._RGBA.g, t._RGBA.b, 1])), !t._activeComponent) {
        var _e1219 = t.$.brightnessScale.offsetHeight - t.$.brightnessScaleThumb.offsetHeight;

        if (t.$.alphaChannelThumb) {
          var _e1220 = t.$.alphaChannelThumb.offsetWidth,
              _i1010 = t.$.alphaChannelScale.offsetWidth,
              _a670 = (1 - t._RGBA.a) * _i1010 > _e1220 ? (1 - t._RGBA.a) * _e1220 : 0;

          t.$.alphaChannelThumb.style[t.rightToLeft ? "left" : "right"] = "", t.$.alphaChannelThumb.style[t.rightToLeft ? "right" : "left"] = (1 - t._RGBA.a) * _i1010 - _a670 + "px", t.$.alphaChannelScale.setAttribute("aria-valuenow", t._RGBA.a);
        }

        var _i1009 = t.inverted ? t._HSV.v : 1 - t._HSV.v;

        t.$.brightnessScale.setAttribute("aria-valuenow", t._HSV.v), t.$.brightnessScaleThumb.style.top = _e1219 * _i1009 + "px", t.$.colorPaletteRadial.style.setProperty("--smart-color-panel-brightness", _i1009);
      }

      if (t._activeComponent && t._activeComponent !== t.$.colorPaletteRadial || t._setPalettePointerXYPosition(e), t._updatePreviewContainerValues(t._getValue("rgba")), t.inverted) {
        var _e1221 = null === t.value ? "black" : t._HSVtoRGBA({
          h: t._HSV.h,
          s: 1,
          v: t._HSV.v
        });

        t.$.brightnessScale.style.backgroundImage = "linear-gradient(" + _e1221 + ", white)";
      } else {
        var _e1222 = null === t.value ? "white" : t._HSVtoRGBA({
          h: t._HSV.h,
          s: t._HSV.s,
          v: 1
        });

        t.$.brightnessScale.style.backgroundImage = "linear-gradient(" + _e1222 + ", black)";
      }
    }
  }, {
    key: "_applyValueInHexagonalMode",
    value: function _applyValueInHexagonalMode() {
      var e = this,
          t = e._getValue("hex"),
          i = (e.shadowRoot || e).querySelector("input.hex");

      if (e._setRGBAToInputs(), i && (i.value = t ? t.substring(1) : null), e.$.alphaChannelContainer.style.setProperty("--smart-color-panel-alpha-channel-color", e._rgbArrayToHEX([e._RGBA.r, e._RGBA.g, e._RGBA.b, 1])), !e._activeComponent && !e._targetItem) {
        var _t1009 = e.$.brightnessScale.offsetHeight - e.$.brightnessScaleThumb.offsetHeight;

        if (e.$.alphaChannelThumb) {
          var _t1010 = e.$.alphaChannelThumb.offsetWidth,
              _i1012 = e.$.alphaChannelScale.offsetWidth,
              _a671 = (1 - e._RGBA.a) * _i1012 > _t1010 ? (1 - e._RGBA.a) * _t1010 : 0;

          e.$.alphaChannelThumb.style[e.rightToLeft ? "left" : "right"] = "", e.$.alphaChannelThumb.style[e.rightToLeft ? "right" : "left"] = (1 - e._RGBA.a) * _i1012 - _a671 + "px", e.$.alphaChannelScale.setAttribute("aria-valuenow", e._RGBA.a);
        }

        var _i1011 = e.inverted ? e._HSV.v : 1 - e._HSV.v;

        e.$.brightnessScale.setAttribute("aria-valuenow", e._HSV.v), e.$.brightnessScaleThumb.style.top = _t1009 * _i1011 + "px";
      }

      var a = e._getValue("rgba");

      if (e._updatePreviewContainerValues(a ? a : e._getValue("hex")), e.inverted) {
        var _t1011 = e._HSVtoRGBA({
          h: e._HSV.h,
          s: 1,
          v: e._HSV.v
        }, 1);

        e.$.brightnessScale.style.backgroundImage = "linear-gradient(" + _t1011 + ", white)";
      } else {
        var _t1012 = e._HSVtoRGBA({
          h: e._HSV.h,
          s: e._HSV.s,
          v: 1
        }, 1);

        e.$.brightnessScale.style.backgroundImage = "linear-gradient(" + _t1012 + ", black)";
      }

      e._applyValueInAnyGridMode(t, e.$.colorPaletteHexagonal);
    }
  }, {
    key: "_radialThumbPoint",
    value: function _radialThumbPoint(e, t, i, a) {
      var n = Math.round,
          o = Math.PI;
      var r = {
        x: n(Math.cos(i * o / 180) * a * e + e),
        y: n(Math.sin(i * o / 180) * a * e + t)
      };
      return r;
    }
  }, {
    key: "_updatePreviewContainerValues",
    value: function _updatePreviewContainerValues(e, t) {
      var i = this,
          a = (i.shadowRoot || i).querySelector(".preview-container");
      a && (("instantly" === i.applyValueMode || t) && (a.firstElementChild.style.backgroundColor = e), a.lastElementChild.style.backgroundColor = e);
    }
  }, {
    key: "_applyValueInAnyGridMode",
    value: function _applyValueInAnyGridMode(e, t) {
      var a = this;
      if (!e && null !== e) return;
      if (!t) switch (a.displayMode) {
        case "default":
          t = a.$.defaultSamplesContainer;
          break;

        case "grid":
          t = a.$.gridSamplesContainer;
          break;

        case "materialGrid":
          t = a.$.materialGridSamplesContainer;
          break;

        case "spectrumGrid":
          t = a.$.spectrumGridSamplesContainer;
          break;

        default:
          t = a.$.gridModeContainer;
      }
      if (!t) return;
      var n = Array.from(t.getElementsByClassName("color-sample"));
      var o = a._targetItem;
      if (o === void 0 || null === o) for (var _t1013 = 0; _t1013 < n.length; _t1013++) {
        var _i1013 = n[_t1013];

        if (a._equalValues(_i1013.colorCode, e)) {
          o = n[_t1013];
          break;
        }
      }
      -1 < a.$.container.className.indexOf("custom-color-selection") && a._HSV.h && a._applyValueInPaletteMode(), a._changeSampleSelection(o);
    }
  }, {
    key: "_generatePaletteGrid",
    value: function _generatePaletteGrid() {
      var e = this;

      if (e.$.gridSamplesContainer) {
        var _t1014 = e["_" + e.palette + "Palette"];

        var _a672 = document.createDocumentFragment();

        for (var _n507 = 0; _n507 < _t1014.length; _n507++) {
          var _i1014 = document.createElement("span"),
              _o359 = _t1014[_n507];

          _i1014.setAttribute("role", "menuitem"), _i1014.setAttribute("aria-label", _o359), _i1014.className = "color-sample", _i1014.colorCode = _o359, _i1014.style.backgroundColor = _o359, "rgba(255, 255, 255, 0)" === e._toRGBA(_o359) || "#FFFFFF00" === e._toHEX(e._toRGBA(_o359)) || "transparent" === _o359 ? _i1014.setAttribute("transparent", "") : _i1014.removeAttribute("transparent"), _a672.appendChild(_i1014);
        }

        e.$.gridSamplesContainer.setAttribute("role", "menu"), e.$.gridSamplesContainer.innerHTML = "", e.$.gridSamplesContainer.appendChild(_a672);
      }
    }
  }, {
    key: "_generatePaletteUserColorGrid",
    value: function _generatePaletteUserColorGrid(e) {
      var t = this;
      if (!t.$.userSamplesContainer) return;
      if (!t._userPalette || !t._userPalette.length) return void (t.$.userSamplesContainer.innerHTML = "");

      var a = t._userPalette.filter(function (e) {
        return "" !== e;
      }).slice(0, t.columnCount || 1),
          n = document.createDocumentFragment(),
          o;

      a = _toConsumableArray(new Set(a));

      for (var _r220 = 0; _r220 < a.length; _r220++) {
        if (a[_r220]) {
          var _e1223 = t._createColorSample(a[_r220], "user-color");

          n.appendChild(_e1223), o || (o = _e1223);
        }
      }

      t.$.userSamplesContainer.innerHTML = "", t.$.userSamplesContainer.appendChild(n), !e && o && o.colorCode && t._changeSampleSelection(o), t.paletteCustomColors = t._userPalette.slice(0);
    }
  }, {
    key: "_initializeBaseVars",
    value: function _initializeBaseVars() {
      var e = this;
      void 0 !== e._RGBA || (e._RGBA = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      }, e._HSV = {
        h: 0,
        s: 0,
        v: 1
      }, e.$.hueScaleThumb.h = 0, e.$.colorPaletteThumb.s = 0, e.$.colorPaletteThumb.v = 1, e.$.colorPaletteRadialThumb.h = 0, e.$.colorPaletteRadialThumb.s = 0, e._defaultPalette = ["rgba(255, 255, 255, 0)", "rgb(0, 0, 0)", "rgb(153, 51, 0)", "rgb(51, 51, 0)", "rgb(0, 51, 0)", "rgb(0, 51, 102)", "rgb(0, 0, 128)", "rgb(51, 51, 153)", "rgb(51, 51, 51)", "rgb(128, 0, 0)", "rgb(255, 102, 0)", "rgb(128, 128, 0)", "rgb(0, 128, 0)", "rgb(0, 128, 128)", "rgb(0, 0, 255)", "rgb(102, 102, 153)", "rgb(128, 128, 128)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(153, 204, 0)", "rgb(51, 153, 102)", "rgb(51, 204, 204)", "rgb(51, 102, 255)", "rgb(128, 0, 128)", "rgb(153, 153, 153)", "rgb(255, 0, 255)", "rgb(255, 204, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)", "rgb(0, 255, 255)", "rgb(0, 204, 255)", "rgb(153, 51, 102)", "rgb(192, 192, 192)", "rgb(255, 153, 204)", "rgb(255, 204, 153)", "rgb(255, 255, 153)", "rgb(204, 255, 204)", "rgb(204, 255, 255)", "rgb(153, 204, 255)", "rgb(204, 153, 255)", "rgb(255, 255, 255)"], e._grayPalette = e._generateShades(40, "gray"), e._redPalette = e._generateShades(40, "red"), e._greenPalette = e._generateShades(40, "green"), e._bluePalette = e._generateShades(40, "blue"), e._customPalette = e._mapDataSourceToPalette(), e._userPalette = e.paletteCustomColors || [], e._colorPalette = {}, e._cssColorNamesHEX = {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        "indianred ": "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrodyellow: "#fafad2",
        lightgrey: "#d3d3d3",
        lightgreen: "#90ee90",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370d8",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#d87093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
      }, e._defaultModeThemeColors = null === e.gridThemeColors ? ["#FFFFFF", "#000000", "#E6E6E6", "#495469", "#5671C2", "#D48439", "#A5A5A5", "#EEC328", "#7399D3", "#85AA4C"] : e.gridThemeColors, e._defaultModeStandardColors = null === e.gridStandardColors ? ["#A52A0D", "#DB3A15", "#EEC328", "#FEFE33", "#A6CD57", "#62AC54", "#65ADEE", "#3F6FBE", "#10205F", "#64379E"] : e.gridStandardColors, e._defaultModeShadesColors = null === e.gridShadeColors ? ["#F2F2F2", "#808080", "#D0CECE", "#D6DCE4", "#DDEBF7", "#FCE4D6", "#EBEBEB", "#FFF2CC", "#DDE5F7", "#E2EFDA", "#D8D8D8", "#595959", "#AEAAAA", "#ACB9CA", "#BDD7EE", "#F6CAAD", "#DBDBDB", "#FFE699", "#B4C6E7", "#C6E0B4", "#BFBFBF", "#404040", "#757171", "#8497B0", "#9BC2E6", "#F4B084", "#C0C0C0", "#FFD966", "#8EA9DB", "#A9D08E", "#A6A6A6", "#262626", "#312F2F", "#333F4F", "#2F75B5", "#C65911", "#7B7B7B", "#BF8F00", "#305496", "#548235", "#808080", "#0D0D0D", "#161616", "#222B35", "#1F4E78", "#833C0C", "#525252", "#806000", "#203764", "#375623"] : e.gridShadeColors, e._materialColors = {
        Red: {
          50: "rgb(255, 235, 238)",
          100: "rgb(255, 205, 210)",
          200: "rgb(239, 154, 154)",
          300: "rgb(229, 115, 115)",
          400: "rgb(239, 83, 80)",
          500: "rgb(244, 67, 54)",
          600: "rgb(229, 57, 53)",
          700: "rgb(211, 47, 47)",
          800: "rgb(198, 40, 40)",
          900: "rgb(183, 28, 28)",
          "A 100": "rgb(255, 138, 128)",
          "A 200": "rgb(255, 82, 82)",
          "A 400": "rgb(255, 23, 68)",
          "A 700": "rgb(213, 0, 0)"
        },
        Pink: {
          50: "rgb(252, 228, 236)",
          100: "rgb(248, 187, 208)",
          200: "rgb(244, 143, 177)",
          300: "rgb(240, 98, 146)",
          400: "rgb(236, 64, 122)",
          500: "rgb(233, 30, 99)",
          600: "rgb(216, 27, 96)",
          700: "rgb(194, 24, 91)",
          800: "rgb(173, 20, 87)",
          900: "rgb(136, 14, 79)",
          "A 100": "rgb(255, 128, 171)",
          "A 200": "rgb(255, 64, 129)",
          "A 400": "rgb(245, 0, 87)",
          "A 700": "rgb(197, 17, 98)"
        },
        Purple: {
          50: "rgb(243, 229, 245)",
          100: "rgb(225, 190, 231)",
          200: "rgb(206, 147, 216)",
          300: "rgb(186, 104, 200)",
          400: "rgb(171, 71, 188)",
          500: "rgb(156, 39, 176)",
          600: "rgb(142, 36, 170)",
          700: "rgb(123, 31, 162)",
          800: "rgb(106, 27, 154)",
          900: "rgb(74, 20, 140)",
          "A 100": "rgb(234, 128, 252)",
          "A 200": "rgb(224, 64, 251)",
          "A 400": "rgb(213, 0, 249)",
          "A 700": "rgb(170, 0, 255)"
        },
        "Deep Purple": {
          50: "rgb(237, 231, 246)",
          100: "rgb(209, 196, 233)",
          200: "rgb(179, 157, 219)",
          300: "rgb(149, 117, 205)",
          400: "rgb(126, 87, 194)",
          500: "rgb(103, 58, 183)",
          600: "rgb(94, 53, 177)",
          700: "rgb(81, 45, 168)",
          800: "rgb(69, 39, 160)",
          900: "rgb(49, 27, 146)",
          "A 100": "rgb(179, 136, 255)",
          "A 200": "rgb(124, 77, 255)",
          "A 400": "rgb(101, 31, 255)",
          "A 700": "rgb(98, 0, 234)"
        },
        Indigo: {
          50: "rgb(232, 234, 246)",
          100: "rgb(197, 202, 233)",
          200: "rgb(159, 168, 218)",
          300: "rgb(121, 134, 203)",
          400: "rgb(92, 107, 192)",
          500: "rgb(63, 81, 181)",
          600: "rgb(57, 73, 171)",
          700: "rgb(48, 63, 159)",
          800: "rgb(40, 53, 147)",
          900: "rgb(26, 35, 126)",
          "A 100": "rgb(140, 158, 255)",
          "A 200": "rgb(83, 109, 254)",
          "A 400": "rgb(61, 90, 254)",
          "A 700": "rgb(48, 79, 254)"
        },
        Blue: {
          50: "rgb(227, 242, 253)",
          100: "rgb(187, 222, 251)",
          200: "rgb(144, 202, 249)",
          300: "rgb(100, 181, 246)",
          400: "rgb(66, 165, 245)",
          500: "rgb(33, 150, 243)",
          600: "rgb(30, 136, 229)",
          700: "rgb(25, 118, 210)",
          800: "rgb(21, 101, 192)",
          900: "rgb(13, 71, 161)",
          "A 100": "rgb(130, 177, 255)",
          "A 200": "rgb(68, 138, 255)",
          "A 400": "rgb(41, 121, 255)",
          "A 700": "rgb(41, 98, 255)"
        },
        "Light Blue": {
          50: "rgb(225, 245, 254)",
          100: "rgb(179, 229, 252)",
          200: "rgb(129, 212, 250)",
          300: "rgb(79, 195, 247)",
          400: "rgb(41, 182, 246)",
          500: "rgb(3, 169, 244)",
          600: "rgb(3, 155, 229)",
          700: "rgb(2, 136, 209)",
          800: "rgb(2, 119, 189)",
          900: "rgb(1, 87, 155)",
          "A 100": "rgb(128, 216, 255)",
          "A 200": "rgb(64, 196, 255)",
          "A 400": "rgb(0, 176, 255)",
          "A 700": "rgb(0, 145, 234)"
        },
        Cyan: {
          50: "rgb(224, 247, 250)",
          100: "rgb(178, 235, 242)",
          200: "rgb(128, 222, 234)",
          300: "rgb(77, 208, 225)",
          400: "rgb(38, 198, 218)",
          500: "rgb(0, 188, 212)",
          600: "rgb(0, 172, 193)",
          700: "rgb(0, 151, 167)",
          800: "rgb(0, 131, 143)",
          900: "rgb(0, 96, 100)",
          "A 100": "rgb(132, 255, 255)",
          "A 200": "rgb(24, 255, 255)",
          "A 400": "rgb(0, 229, 255)",
          "A 700": "rgb(0, 184, 212)"
        },
        Teal: {
          50: "rgb(224, 242, 241)",
          100: "rgb(178, 223, 219)",
          200: "rgb(128, 203, 196)",
          300: "rgb(77, 182, 172)",
          400: "rgb(38, 166, 154)",
          500: "rgb(0, 150, 136)",
          600: "rgb(0, 137, 123)",
          700: "rgb(0, 121, 107)",
          800: "rgb(0, 105, 92)",
          900: "rgb(0, 77, 64)",
          "A 100": "rgb(167, 255, 235)",
          "A 200": "rgb(100, 255, 218)",
          "A 400": "rgb(29, 233, 182)",
          "A 700": "rgb(0, 191, 165)"
        },
        Green: {
          50: "rgb(232, 245, 233)",
          100: "rgb(200, 230, 201)",
          200: "rgb(165, 214, 167)",
          300: "rgb(129, 199, 132)",
          400: "rgb(102, 187, 106)",
          500: "rgb(76, 175, 80)",
          600: "rgb(67, 160, 71)",
          700: "rgb(56, 142, 60)",
          800: "rgb(46, 125, 50)",
          900: "rgb(27, 94, 32)",
          "A 100": "rgb(185, 246, 202)",
          "A 200": "rgb(105, 240, 174)",
          "A 400": "rgb(0, 230, 118)",
          "A 700": "rgb(0, 200, 83)"
        },
        "Light Green": {
          50: "rgb(241, 248, 233)",
          100: "rgb(220, 237, 200)",
          200: "rgb(197, 225, 165)",
          300: "rgb(174, 213, 129)",
          400: "rgb(156, 204, 101)",
          500: "rgb(139, 195, 74)",
          600: "rgb(124, 179, 66)",
          700: "rgb(104, 159, 56)",
          800: "rgb(85,139,47)",
          900: "rgb(51,105,30)",
          "A 100": "rgb(204,255,144)",
          "A 200": "rgb(178,255,89)",
          "A 400": "rgb(118,255,3)",
          "A 700": "rgb(100, 221, 23)"
        },
        Lime: {
          50: "rgb(249, 251, 231)",
          100: "rgb(255, 249, 196)",
          200: "rgb(255, 245, 157)",
          300: "rgb(255, 241, 118)",
          400: "rgb(255, 238, 88)",
          500: "rgb(255, 235, 59)",
          600: "rgb(253, 216, 53)",
          700: "rgb(251, 192, 45)",
          800: "rgb(249, 168, 37)",
          900: "rgb(245, 127, 23)",
          "A 100": "rgb(244, 255, 129)",
          "A 200": "rgb(238, 255, 65)",
          "A 400": "rgb(198, 255, 0)",
          "A 700": "rgb(174, 234, 0)"
        },
        Yellow: {
          50: "rgb(255, 253, 231)",
          100: "rgb(255, 249, 196)",
          200: "rgb(255, 245, 157)",
          300: "rgb(255, 241, 118)",
          400: "rgb(255, 238, 88)",
          500: "rgb(255, 235, 59)",
          600: "rgb(253, 216, 53)",
          700: "rgb(251, 192, 45)",
          800: "rgb(249, 168, 37)",
          900: "rgb(245, 127, 23)",
          "A 100": "rgb(255, 255, 141)",
          "A 200": "rgb(255, 255, 0)",
          "A 400": "rgb(255, 234, 0)",
          "A 700": "rgb(255, 214, 0)"
        },
        Amber: {
          50: "rgb(255, 248, 225)",
          100: "rgb(255, 236, 179)",
          200: "rgb(255, 224, 130)",
          300: "rgb(255, 213, 79)",
          400: "rgb(255, 202, 40)",
          500: "rgb(255, 193, 7)",
          600: "rgb(255, 179, 0)",
          700: "rgb(255, 160, 0)",
          800: "rgb(255, 143, 0)",
          900: "rgb(255, 111, 0)",
          "A 100": "rgb(255, 229, 127)",
          "A 200": "rgb(255, 215, 64)",
          "A 400": "rgb(255, 196, 0)",
          "A 700": "rgb(255, 171, 0)"
        },
        Orange: {
          50: "rgb(255, 243, 224)",
          100: "rgb(255, 224, 178)",
          200: "rgb(255, 204, 128)",
          300: "rgb(255, 183, 77)",
          400: "rgb(255, 167, 38)",
          500: "rgb(255, 152, 0)",
          600: "rgb(251, 140, 0)",
          700: "rgb(245, 124, 0)",
          800: "rgb(239, 108, 0)",
          900: "rgb(230, 81, 0)",
          "A 100": "rgb(255, 209, 128)",
          "A 200": "rgb(255, 171, 64)",
          "A 400": "rgb(255, 145, 0)",
          "A 700": "rgb(255, 109, 0)"
        },
        "Deep Orange": {
          50: "rgb(251, 233, 231)",
          100: "rgb(255, 204, 188)",
          200: "rgb(255, 171, 145)",
          300: "rgb(255, 138, 101)",
          400: "rgb(255, 112, 67)",
          500: "rgb(255, 87, 34)",
          600: "rgb(244, 81, 30)",
          700: "rgb(230, 74, 25)",
          800: "rgb(216, 67, 21)",
          900: "rgb(191, 54, 12)",
          "A 100": "rgb(255, 158, 128)",
          "A 200": "rgb(255, 110, 64)",
          "A 400": "rgb(255, 61, 0)",
          "A 700": "rgb(221, 44, 0)"
        },
        Brown: {
          50: "rgb(239, 235, 233)",
          100: "rgb(215, 204, 200)",
          200: "rgb(188, 170, 164)",
          300: "rgb(161, 136, 127)",
          400: "rgb(141, 110, 99)",
          500: "rgb(121, 85, 72)",
          600: "rgb(109, 76, 65)",
          700: "rgb(93, 64, 55)",
          800: "rgb(78, 52, 46)",
          900: "rgb(62, 39, 35)",
          "A 100": "",
          "A 200": "",
          "A 400": "",
          "A 700": ""
        },
        Grey: {
          50: "rgb(250, 250, 250)",
          100: "rgb(245, 245, 245)",
          200: "rgb(238, 238, 238)",
          300: "rgb(224, 224, 224)",
          400: "rgb(189, 189, 189)",
          500: "rgb(158, 158, 158)",
          600: "rgb(117, 117, 117)",
          700: "rgb(97, 97, 97)",
          800: "rgb(66, 66, 66)",
          900: "rgb(33, 33, 33)",
          "A 100": "",
          "A 200": "",
          "A 400": "",
          "A 700": ""
        },
        "Blue Grey": {
          50: "rgb(236, 239, 241)",
          100: "rgb(207, 216, 220)",
          200: "rgb(176, 190, 197)",
          300: "rgb(144, 164, 174)",
          400: "rgb(120, 144, 156)",
          500: "rgb(96, 125, 139)",
          600: "rgb(84, 110, 122)",
          700: "rgb(69, 90, 100)",
          800: "rgb(55, 71, 79)",
          900: "rgb(38, 50, 56)",
          "A 100": "",
          "A 200": "",
          "A 400": "",
          "A 700": ""
        }
      });
    }
  }, {
    key: "_mapDataSourceToPalette",
    value: function _mapDataSourceToPalette() {
      var e = this;
      var t = [];
      if (!e.paletteColors || !Array.isArray(e.paletteColors) || 0 === e.paletteColors.length) return [];

      for (var _a673 = 0, _i1015; _a673 < e.paletteColors.length; _a673++) {
        _i1015 = e.paletteColors[_a673], "object" == typeof _i1015 && _i1015[e.valueMember] && "string" == typeof _i1015[e.valueMember] && (_i1015 = _i1015[e.valueMember]), _i1015 += "", e._isValidColor(_i1015) && t.push(_i1015);
      }

      return t;
    }
  }, {
    key: "_handleSampleClick",
    value: function _handleSampleClick(e) {
      var t = this,
          i = e.target,
          a = t.value;
      var n = i.colorCode;
      "hexagonal" === t.displayMode ? (n = t._HSVtoRGBA({
        h: i.h,
        s: i.s,
        v: i.v
      }, t._RGBA.a), -1 < t._hexagonItems.indexOf(i) && (t._HSV.h = i.h, t.inverted ? (t._HSV.s = i.s, t._HSV.v = i.v) : (t._HSV.s = i.s, t._HSV.v = i.v), t._targetItem = i, t._applyValue(t._HSVtoRGBA(t._HSV), e), delete t._targetItem)) : t._changeSampleSelection(i), t._HSVRGBArefresh(i.classList.contains("selected") ? n : null);
      "instantly" !== t.applyValueMode || (t.$.hiddenInput.value = t.value = t._getValue(t.valueFormat, i.classList.contains("selected") ? n : null), t.value !== a && t.$.fireEvent("change", {
        oldValue: a,
        value: t.value
      }));
    }
  }, {
    key: "_changeSampleSelection",
    value: function _changeSampleSelection(e) {
      var t = this;

      if (!(t._selectedItem && "radial" !== t.displayMode && "hexagonal" !== t.displayMode && (!e || t._selectedItem === e && e.classList.contains("selected"))) && e) {
        var _i1016 = t._getContrastColor(t._rgbaToHEX(t._toRGBA(e.colorCode))),
            _a674 = e.closest("svg");

        return Array.from((t.shadowRoot || t).querySelectorAll(".selected")).forEach(function (e) {
          e.classList.remove("selected"), e.removeAttribute("aria-current"), e.style.stroke = null;
        }), e.classList.add("selected"), e.setAttribute("aria-current", !0), t._selectedItem = e, _a674 && (e.style.stroke = _i1016, _a674.appendChild(e)), !0;
      }
    }
  }, {
    key: "_getContrastColor",
    value: function _getContrastColor(e) {
      function t(t, i, e) {
        return [parseInt(t, 16), parseInt(i, 16), parseInt(e, 16)];
      }

      if (void 0 !== e) {
        var _i1017 = t(e.slice(1, 3), e.slice(3, 5), e.slice(5, 7)),
            _a675 = (.299 * _i1017[0] + .61 * _i1017[1] + .114 * _i1017[2]) / 255;

        return .6 < _a675 ? "#000000" : "#FFFFFF";
      }
    }
  }, {
    key: "_getXYcoordinates",
    value: function _getXYcoordinates(e) {
      if (!e) return;
      var t = this,
          i = t._activeComponent || (e.originalEvent || e).target;
      if (!i.closest) return;
      var a = i.closest(".color-palette") || i.closest(".color-palette-radial") || i.closest(".hue-scale") || i.closest(".brightness-scale") || i.closest(".alpha-channel-scale");
      if (!a || t.disabled || t.readonly) return;
      var n = a.getBoundingClientRect();
      var o = e.pageX - window.pageXOffset - n.left,
          r = e.pageY - window.pageYOffset - n.top;
      return 0 > o ? o = 0 : o > a.offsetWidth && (o = a.offsetWidth), 0 > r ? r = 0 : r > a.offsetHeight && (r = a.offsetHeight), {
        x: o,
        y: r,
        container: a
      };
    }
  }, {
    key: "_inputWheelHandler",
    value: function _inputWheelHandler(e) {
      var t = this,
          i = t.value,
          a = e.target;
      if (!(e.target instanceof HTMLInputElement) || e.target.classList.contains("hex")) return;
      e.preventDefault();
      var n;
      return a.classList.contains("a-channel") ? (n = parseFloat(a.value) || 0, n = 0 > e.deltaY ? n + .01 : n - .01, a.value = t._toFixed(t._validateInRange(n, 0, 1)), t._RGBA = t._getRGBAFromInputs(), t._applyAlphaValue(t._RGBA.a, "alphaInput")) : (n = parseInt(a.value) || 0, n = 0 > e.deltaY ? n + 1 : n - 1, a.value = t._validateInRange(n, 0, 255), t._RGBA = t._getRGBAFromInputs(), t._HSV = t._getValue("hsv", "rgba(" + t._RGBA.r + ", " + t._RGBA.g + ", " + t._RGBA.b + ", " + t._RGBA.a + ")")), t._updatePreviewContainerValues(t._getValue(t.valueFormat)), t._setPalettePointerXYPosition(), "useButtons" === t.applyValueMode && ("palette" === t.displayMode ? t._applyValueInPaletteMode() : "radial" === t.displayMode ? t._applyValueInRadialMode() : "hexagonal" === t.displayMode && t._generateHoneycomb(t.columnCount, t._HSV)), -1 < t.$.container.className.indexOf("custom-color-selection") ? void t._applyValue(t._HSVtoRGBA(t._HSV)) : void ("useButtons" === t.applyValueMode || (t.value = t._getValue(t.valueFormat), t._applyValue(t.value, e), t.$.fireEvent("change", {
        oldValue: i,
        value: t.value
      })));
    }
  }, {
    key: "_paletteDownHandler",
    value: function _paletteDownHandler(e) {
      var t = this;

      if (!(!Smart.Utilities.Core.isMobile && 0 !== e.button || t.disabled || t.readonly)) {
        t._dragDetails = {
          x: e.pageX - window.pageXOffset,
          y: e.pageY - window.pageYOffset
        };
        var _i1018 = (e.originalEvent || e).target;
        if (_i1018 && _i1018.closest) return t._dragDetails.target = _i1018.closest(".color-palette") || _i1018.closest(".color-palette-radial"), _i1018.closest(".color-palette") || _i1018.closest(".color-palette-radial") ? (t._handleColorPaletteDown(e.originalEvent), void (t._dragDetails.isPalettePressed = !0)) : void ((_i1018.closest(".hue-scale") || _i1018.closest(".alpha-channel-scale") || _i1018.closest(".brightness-scale")) && t._handleScalesDown(e.originalEvent));
      }
    }
  }, {
    key: "_setPalettePointerXYPosition",
    value: function _setPalettePointerXYPosition(e) {
      var t = Math.min,
          i = Math.round,
          a = Math.PI,
          n = Math.max;
      var o = this;
      var r;
      if ("palette" === o.displayMode || -1 < o.$.container.className.indexOf("custom-color-selection")) r = o._getXYcoordinates(e), o.$.colorPaletteThumb.style.left = e && r && r.x ? 100 * r.x / r.container.offsetWidth + "%" : 100 * o._HSV.s + "%", o.$.colorPaletteThumb.style.top = e && r && r.y ? 100 * r.y / r.container.offsetHeight + "%" : 100 * (1 - o._HSV.v) + "%";else if ("radial" === o.displayMode) if (e) {
        if (r = o._getXYcoordinates(e), !r) return;

        var _l153 = r.container.offsetWidth ? r.container.offsetWidth : o.$.colorPaletteRadial.offsetWidth,
            _s110 = r.container.offsetHeight ? r.container.offsetHeight : o.$.colorPaletteRadial.offsetHeight,
            d = i(Math.cos(o._HSV.h * a / 180) * _l153 / 2 + _l153 / 2),
            c = i(Math.sin(o._HSV.h * a / 180) * _l153 / 2 + _s110 / 2);

        return 5 > Math.abs(_l153 / 2 - r.x) ? (o.$.colorPaletteRadialThumb.style.left = 100 * r.x / o.$.colorPaletteRadial.offsetWidth + "%", void (o.$.colorPaletteRadialThumb.style.top = 100 * r.y / o.$.colorPaletteRadial.offsetHeight + "%")) : (o.$.colorPaletteRadialThumb.style.left = 100 * (r.x < _l153 / 2 ? n(d, r.x) : t(d, r.x)) / _l153 + "%", void (o.$.colorPaletteRadialThumb.style.top = 100 * (r.y < _s110 / 2 ? n(c, r.y) : t(c, r.y)) / _s110 + "%"));
      } else {
        var _e1224 = o._radialThumbPoint(o.$.colorPaletteRadial.offsetWidth / 2, o.$.colorPaletteRadial.offsetHeight / 2, o._HSV.h, o._HSV.s);

        o.$.colorPaletteRadialThumb.style.left = 100 * _e1224.x / o.$.colorPaletteRadial.offsetWidth + "%", o.$.colorPaletteRadialThumb.style.top = 100 * _e1224.y / o.$.colorPaletteRadial.offsetHeight + "%";
      }
    }
  }, {
    key: "_handleGridModeCellHover",
    value: function _handleGridModeCellHover(e) {
      var t = this,
          i = e.target.closest(".color-sample");

      if (!t.disabled && i && "none" !== t.tooltipDisplayMode && t.$.tooltip) {
        if (t.$.tooltip.arrow = "hexagonal" !== t.displayMode, !t._isValidColor(i.colorCode)) return void (t.$.tooltip.disabled = !0);
        t.$.tooltip.disabled = !1, t.$.tooltip.selector = i;

        var _e1225 = i.h && i.s && i.v ? t._HSVtoRGBA({
          h: i.h,
          s: i.s,
          v: i.v
        }, t._RGBA.a) : t._toRGBA(i.colorCode);

        switch (t.tooltipDisplayMode) {
          case "rgba":
            t.$.tooltip.value = _e1225 || "";
            break;

          case "rgb":
            t.$.tooltip.value = t._rgbaToRGB(_e1225) || "";
            break;

          case "hex":
            t.$.tooltip.value = t._rgbaToHEX(_e1225) || "";
        }
      }
    }
  }, {
    key: "_localizeLabels",
    value: function _localizeLabels() {
      var e = this,
          t = (e.shadowRoot || e).querySelector("label.r-channel"),
          i = (e.shadowRoot || e).querySelector("label.g-channel"),
          a = (e.shadowRoot || e).querySelector("label.b-channel"),
          n = (e.shadowRoot || e).querySelector("label.a-channel"),
          o = (e.shadowRoot || e).querySelector("label.hex");

      if (t && (t.innerHTML = e.localize("redPrefix")), i && (i.innerHTML = e.localize("greenPrefix")), a && (a.innerHTML = e.localize("bluePrefix")), n && (n.innerHTML = e.localize("alphaPrefix")), o && (o.innerHTML = e.localize("hexPrefix")), e.$.buttonCustom && (e.$.buttonCustom.content = e.localize("customColor")), e.$.buttonOk && (e.$.buttonOk.content = e.localize("ok")), e.$.buttonCancel && (e.$.buttonCancel.content = e.localize("cancel")), e.$.defaultSamplesContainer) {
        var _t1015 = e.$.defaultSamplesContainer.querySelector(".theme-colors-label"),
            _i1019 = e.$.defaultSamplesContainer.querySelector(".standard-colors-label");

        _t1015 && (_t1015.innerHTML = e.localize("themeColors")), _i1019 && (_i1019.innerHTML = e.localize("standardColors"));
      }
    }
  }, {
    key: "_generateHoneycomb",
    value: function _generateHoneycomb(e, t) {
      var a = this,
          i = parseInt(getComputedStyle(a).getPropertyValue("--smart-color-panel-grid-mode-item-size")) / 4,
          n = Math.sqrt(5 * Math.pow(i, 2)),
          o = 0 == e % 2 ? parseInt(e) + 1 : parseInt(e),
          r = t && t.s !== void 0 ? t.s : 1,
          l = t && t.v !== void 0 ? t.v : 1,
          d = a._calculateHexagonCoords(o, n, 1),
          c = d[Math.floor(d.length / 2)],
          s = a._getHoneycomb30degDimmensions(d.length, n, 1);

      a._draw || (a._draw = new Smart.Utilities.Draw(a.$.colorPaletteHexagonal)), a._draw.clear(), a.$.colorPaletteHexagonal.firstElementChild.setAttribute("role", "presentation"), a.$.colorPaletteHexagonal.firstElementChild.firstElementChild.setAttribute("role", "menu"), a._hexagonItems = [], a.$.materialGridSamplesContainer && a.$.materialGridSamplesContainer.$.addClass("smart-hidden");

      for (var _o360 = 0; _o360 < d.length; _o360++) {
        var _e1226 = d[_o360].x - c.x,
            _t1016 = d[_o360].y - c.y,
            _i1020 = a._validateInRange(a._calcSatDistance(_e1226, _t1016) / c.x, 0, 1);

        var m = 0 > a._calcHueAngle(_e1226, _t1016) ? 360 + a._calcHueAngle(_e1226, _t1016) : a._calcHueAngle(_e1226, _t1016),
            u = void 0,
            _s111 = void 0;

        switch (a.inverted ? (u = r, _s111 = _i1020) : (u = _i1020, _s111 = l), a.palette) {
          case "red":
            m = 0;
            break;

          case "green":
            m = 120;
            break;

          case "blue":
            m = 240;
            break;

          case "gray":
            u = 0, _s111 = a.inverted ? _i1020 : 1 - _i1020;
        }

        var p = {
          offsetX: d[_o360].x,
          offsetY: d[_o360].y,
          style: {
            fill: a._HSVtoRGBA({
              h: m,
              s: u,
              v: _s111
            }, 1),
            class: "color-sample"
          }
        };

        var g = a._hexagon(n, p);

        g.colorCode = a._HSVtoRGBA({
          h: m,
          s: u,
          v: _s111
        }), g.h = m, g.s = u, g.v = _s111, g.setAttribute("role", "menuitem"), g.setAttribute("aria-label", g.colorCode), a._hexagonItems.push(g);
      }

      a._draw.host.style.width = s.width + "px", a._draw.host.style.height = s.height + "px", a.$.container.style.setProperty("--smart-color-panel-palette-width", s.width + "px"), a.$.container.style.setProperty("--smart-color-panel-palette-height", s.height + "px"), a._applyValueInHexagonalMode(), a._hideControlsByPriority();
    }
  }, {
    key: "_hexagon",
    value: function _hexagon(e, t) {
      var i = this,
          a = i._shortStepHexagon(e),
          n = 2 * a,
          o = n + (t.offsetX || 0),
          r = t.offsetY || 0,
          l = o + n,
          s = r + a,
          d = l,
          c = s + e,
          m = d - n,
          u = c + a,
          p = m - n,
          g = u - a,
          h = i._draw.path("M " + o + "," + r + " L " + l + "," + s + " L " + d + "," + c + " L " + m + "," + u + " L " + p + "," + g + " L " + p + "," + (g - e) + " Z", t.style || {
        class: "color-sample"
      });

      return h;
    }
  }, {
    key: "_shortStepHexagon",
    value: function _shortStepHexagon(e) {
      return Math.sqrt(Math.pow(e, 2) / 5);
    }
  }, {
    key: "_getHoneycomb30degDimmensions",
    value: function _getHoneycomb30degDimmensions(e, t, i) {
      var a = this,
          n = .5 * (1 + Math.sqrt(1 - 4 * ((1 - e) / 3))),
          o = a._shortStepHexagon(t);

      return {
        width: (2 * n - 1) * (4 * o) + 2 * (2 * n) * i,
        height: (2 * n - 1) * t + 2 * n * o + 2 * n * i
      };
    }
  }, {
    key: "_generateShades",
    value: function _generateShades(e, t) {
      var a = Math.max;
      var n = this,
          o = t || "gray";
      var r = [],
          l;
      e = a(parseInt(e), 2);
      var s = 255 / (e - 1);

      for (var d = 0, _i1021; d < e; d++) {
        _i1021 = a(parseInt(255 - d * s), 0), n.inverted && (_i1021 = 255 - _i1021), l = "red" === o ? "rgb(" + _i1021 + ", 0, 0)" : "green" === o ? "rgb(0, " + _i1021 + ", 0)" : "blue" === o ? "rgb(0, 0, " + _i1021 + ")" : "rgb(" + _i1021 + ", " + _i1021 + ", " + _i1021 + ")", r.push(l);
      }

      return r;
    }
  }, {
    key: "_generateColorSpectrum",
    value: function _generateColorSpectrum(e) {
      var t = Math.min,
          a = Math.max;
      var n = this;
      var i = [];
      e = a(parseInt(e), 2);
      var o = 360 / (e - 1),
          r = 2 / e;
      var l = 0,
          s = 1,
          d = 1;

      for (var c = 0; c < e; c++) {
        n.inverted ? 0 == c ? s = 1 : c < e / 2 ? s = a(s - r, r / 2) : c < e - 1 ? (d = a(d - r, r / 2), s = t(s + r, 1)) : (d = a(d - r, r / 2), s = t(s + r / 4, 1)) : 0 == c ? d = 1 : c < e / 2 ? d = a(d - r, r / 2) : c < e - 1 ? (s = a(s - r, r / 2), d = t(d + r, 1)) : (s = a(s - r, r / 2), d = t(d + r / 4, 1));

        for (var _t1017 = 0; _t1017 < e; _t1017++) {
          l = parseInt(o * _t1017), l = 360 === l ? 360 - o / 2 : l, i.push(n._HSVtoRGBA({
            h: l,
            s: s,
            v: d
          }, 1));
        }
      }

      return i;
    }
  }, {
    key: "_generateSpectrumGrid",
    value: function _generateSpectrumGrid(e) {
      var t = this;
      if (!t.$.spectrumGridSamplesContainer) return;

      var a = Math.pow(e, 2),
          i = document.createDocumentFragment(),
          n = {},
          o = t._generateShades(e, "gray"),
          r = t._customPalette;

      var l;
      ["grayShadesBox", "spectrumBox", "customColorsBox"].forEach(function (e) {
        var t = document.createElement("div");
        var a = Smart.Utilities.Core.toDash(e).split("-").join(" ");
        n[e] = t, t.className = Smart.Utilities.Core.toDash(e), t.setAttribute("role", "menu"), t.setAttribute("aria-label", a.slice(0, 1).toUpperCase() + a.slice(1)), i.appendChild(t);
      }), l = "default" === t.palette ? t._generateColorSpectrum(e) : -1 < ["gray", "red", "green", "blue"].indexOf(t.palette) ? t._generateShades(a, t.palette) : t._generateColorSpectrum(e);

      for (var _a676 = 0; _a676 < e; _a676++) {
        var _e1227 = t._createColorSample(o[_a676], "gray-shade");

        n.grayShadesBox.appendChild(_e1227);
      }

      for (var _o361 = 0; _o361 < a; _o361++) {
        var _e1228 = t._createColorSample(l[_o361], "spectrum");

        n.spectrumBox.appendChild(_e1228);
      }

      for (var _a677 = 0; _a677 < e; _a677++) {
        var _e1229 = r[_a677];
        if (!_e1229) break;

        var _i1022 = t._createColorSample(_e1229, "custom-color");

        n.customColorsBox.appendChild(_i1022);
      }

      t.$.spectrumGridSamplesContainer.innerHTML = "", t.$.spectrumGridSamplesContainer.appendChild(i);
    }
  }, {
    key: "_generateDefaultGrid",
    value: function _generateDefaultGrid() {
      var e = this;
      if (!e.$.defaultSamplesContainer) return;
      var t = {},
          a = null === e.gridThemeColors ? e._defaultModeThemeColors : e.gridThemeColors,
          n = null === e.gridShadeColors ? e._defaultModeShadesColors : e.gridShadeColors,
          o = null === e.gridStandardColors ? e._defaultModeStandardColors : e.gridStandardColors,
          i = document.createDocumentFragment();
      ["themeColorsLabel", "themeColorsBox", "themeShadesBox", "standardColorsLabel", "standardColorsBox"].forEach(function (a) {
        var n = document.createElement("div");
        t[a] = n, n.className = Smart.Utilities.Core.toDash(a), -1 === a.indexOf("Box") ? -1 !== a.indexOf("Label") && (n.id = e.id + a) : n.setAttribute("role", "menu"), i.appendChild(n);
      }), t.themeColorsLabel.innerHTML = e.localize("themeColors"), "Theme colors", t.standardColorsLabel.innerHTML = e.localize("standardColors"), "Standard colors", t.themeColorsBox.setAttribute("aria-labelledby", e.id + "themeColorsLabel"), t.themeShadesBox.setAttribute("aria-labelledby", e.id + "themeColorsLabel"), t.standardColorsBox.setAttribute("aria-labelledby", e.id + "standardColorsLabel");

      for (var _a678 = 0; _a678 < e._defaultModeShadesColors.length; _a678++) {
        t.themeShadesBox.appendChild(e._createColorSample(n[_a678], "shades-color"));
      }

      for (var _n508 = 0; _n508 < 10; _n508++) {
        t.themeColorsBox.appendChild(e._createColorSample(a[_n508], "theme-color")), t.standardColorsBox.appendChild(e._createColorSample(o[_n508], "standard-color"));
      }

      e.$.defaultSamplesContainer.innerHTML = "", e.$.defaultSamplesContainer.appendChild(i);
    }
  }, {
    key: "_mixColors",
    value: function _mixColors(e, t, i) {
      var a = function a(e) {
        return e.toString(16);
      },
          n = function n(e) {
        return parseInt(e, 16);
      };

      var o = "#",
          r;
      i = "undefined" == typeof i ? .5 : i, e = e.replace(/#/g, ""), t = t.replace(/#/g, "");

      for (var _l154 = 0; 5 >= _l154; _l154 += 2) {
        var _s112 = n(e.substr(_l154, 2)),
            d = n(t.substr(_l154, 2));

        for (r = a(Math.round(d + (_s112 - d) * i)); 2 > r.length;) {
          r = "0" + r;
        }

        o += r;
      }

      return o;
    }
  }, {
    key: "_generateMaterialGrid",
    value: function _generateMaterialGrid() {
      var e = this;
      if (!e.$.materialGridSamplesContainer) return;
      var t = document.createDocumentFragment();
      e.$.materialGridSamplesContainer.$.removeClass("smart-hidden"), t.appendChild(e._createColorSample("rgb(255, 255, 255, 0)", "material-color label-column")), Object.entries(e._materialColors.Red).forEach(function (i) {
        var a = e._createColorSample("rgb(255, 255, 255, 0)", "material-color header");

        a.textContent = i[0], t.appendChild(a);
      }), Object.entries(e._materialColors).forEach(function (i) {
        var a = e._createColorSample("rgb(255, 255, 255, 0)", "material-color label-column");

        a.textContent = i[0], t.appendChild(a), Object.entries(i[1]).forEach(function (i) {
          t.appendChild(e._createColorSample(i[1], "material-color"));
        });
      }), e.$.materialGridSamplesContainer.innerHTML = "", e.$.materialGridSamplesContainer.appendChild(t);
    }
  }, {
    key: "_createColorSample",
    value: function _createColorSample(e, t) {
      var i = document.createElement("div"),
          a = e ? "" : " empty";
      return (e && -1 === t.indexOf("label-column") && -1 === t.indexOf("header") && (i.setAttribute("role", "menuitem"), i.setAttribute("aria-label", e)), i.className = "color-sample " + t + a, -1 < t.indexOf("header") || -1 < t.indexOf("label-column")) ? i : (i.colorCode = e, i.style.backgroundColor = e, i);
    }
  }, {
    key: "_calculateHexagonCoords",
    value: function _calculateHexagonCoords(e, t, a) {
      var i = this,
          n = e,
          o = function (e) {
        return e = 0 == e % 2 ? e + 1 : e, (e + 1) / 2;
      }(e),
          r = i._shortStepHexagon(t),
          l = 2 * r + a,
          s = l * (n - 1) / 2;

      var d = [];

      for (var c = 0; c < n; c++) {
        var _i1023 = c < o ? o + c : e - 1 - (c - o),
            _n509 = c < o ? s - c * l : s - (e - c - 1) * l,
            m = c * (t + r + a);

        for (var _e1230 = 0; _e1230 < _i1023; _e1230++) {
          var _t1018 = _n509 + _e1230 * (4 * r + 2 * a);

          d.push({
            x: _t1018,
            y: m
          });
        }
      }

      return d;
    }
  }, {
    key: "_generateGridStructures",
    value: function _generateGridStructures() {
      function e() {
        switch (i) {
          case "default":
          case "grid":
            t.$.colorPaletteRadial.setAttribute("aria-hidden", !0), t.$.brightnessScale.setAttribute("aria-hidden", !0);
            break;

          case "hexagonal":
            t.$.colorPaletteRadial.setAttribute("aria-hidden", !0), t.$.brightnessScale.removeAttribute("aria-hidden");
            break;

          case "materialGrid":
            t.$.colorPaletteRadial.removeAttribute("aria-hidden"), t.$.brightnessScale.removeAttribute("aria-hidden");
            break;

          case "palette":
            t.$.colorPaletteRadial.removeAttribute("aria-hidden"), t.$.brightnessScale.setAttribute("aria-hidden", !0);
            break;

          case "radial":
          case "spectrumGrid":
        }
      }

      var t = this,
          i = t.displayMode;

      if (!t._initializeOnOpening) {
        if (void 0 === t._createGridModeComponents()) return "spectrumGrid" === i ? t._generateSpectrumGrid(t.columnCount) : "materialGrid" === i ? t._generateMaterialGrid() : "default" === i ? t._generateDefaultGrid() : "grid" === i ? t._generatePaletteGrid() : void 0, t._generatePaletteUserColorGrid(), void e();
        t._createColorControls(), "radial" === i ? t._generateRadialCanvas() : "hexagonal" === i ? t._generateHoneycomb(t.columnCount, t._HSV) : void 0, e();
      }
    }
  }, {
    key: "_generateRadialCanvas",
    value: function _generateRadialCanvas() {
      var e = this;
      if ("radial" !== e.displayMode || "radial" === e.displayMode && !Smart.Utilities.Core.Browser.Firefox) return;
      var t = e.$.colorPaletteRadial.offsetWidth,
          i = t / 2;
      var a = e.$.colorPaletteRadial.querySelector("canvas");
      a || (a = document.createElement("canvas"), a.setAttribute("role", "presentation"));
      var n = a.getContext("2d"),
          o = n.createImageData(t, t),
          l = o.data;
      a.width = a.height = t;

      for (var _t1019 = -i; _t1019 < i; _t1019++) {
        for (var _a679 = -i; _a679 < i; _a679++) {
          var _e$_xy2polar = e._xy2polar(_t1019, _a679),
              _e$_xy2polar2 = _slicedToArray(_e$_xy2polar, 2),
              _n510 = _e$_xy2polar2[0],
              _o362 = _e$_xy2polar2[1];

          if (_n510 > i) continue;

          var _r221 = _t1019 + i,
              _s113 = _a679 + i,
              d = (_r221 + _s113 * (2 * i)) * 4,
              c = e._rad2deg(_o362);

          var _e$_hsv2rgb = e._hsv2rgb(c, 1, 1),
              _e$_hsv2rgb2 = _slicedToArray(_e$_hsv2rgb, 3),
              m = _e$_hsv2rgb2[0],
              u = _e$_hsv2rgb2[1],
              p = _e$_hsv2rgb2[2];

          l[d] = m, l[d + 1] = u, l[d + 2] = p, l[d + 3] = 255;
        }
      }

      n.putImageData(o, 0, 0), e.$.colorPaletteRadial.appendChild(a);
    }
  }, {
    key: "_xy2polar",
    value: function _xy2polar(e, t) {
      var i = Math.sqrt(e * e + t * t),
          a = Math.atan2(t, e);
      return [i, a];
    }
  }, {
    key: "_rad2deg",
    value: function _rad2deg(e) {
      var t = Math.PI;
      return 360 * ((e + t) / (2 * t));
    }
  }, {
    key: "_hsv2rgb",
    value: function _hsv2rgb(e, t, i) {
      var _ref6, _ref7, _ref8, _ref9, _ref10, _ref11;

      var a = i * t,
          n = e / 60,
          o = a * (1 - Math.abs(n % 2 - 1)),
          l,
          s,
          d;
      0 <= n && 1 >= n ? (_ref6 = [a, o, 0], l = _ref6[0], s = _ref6[1], d = _ref6[2], _ref6) : 1 <= n && 2 >= n ? (_ref7 = [o, a, 0], l = _ref7[0], s = _ref7[1], d = _ref7[2], _ref7) : 2 <= n && 3 >= n ? (_ref8 = [0, a, o], l = _ref8[0], s = _ref8[1], d = _ref8[2], _ref8) : 3 <= n && 4 >= n ? (_ref9 = [0, o, a], l = _ref9[0], s = _ref9[1], d = _ref9[2], _ref9) : 4 <= n && 5 >= n ? (_ref10 = [o, 0, a], l = _ref10[0], s = _ref10[1], d = _ref10[2], _ref10) : 5 <= n && 6 >= n && (_ref11 = [a, 0, o], l = _ref11[0], s = _ref11[1], d = _ref11[2], _ref11);
      var c = i - a,
          m = l + c,
          r = s + c,
          u = d + c;
      return [255 * m, 255 * r, 255 * u];
    }
  }, {
    key: "_hideControlsByPriority",
    value: function _hideControlsByPriority() {
      function e(e) {
        var a = t.getElementsByClassName(e);

        for (var _t1020 = 0; _t1020 < a.length; _t1020++) {
          a[_t1020].classList.add("smart-hidden");
        }
      }

      var t = this,
          a = (t.shadowRoot || t).querySelector(".color-controls-container");
      if (!a.innerHTML.trim()) return;
      var n = t.hideContentToFit.slice().reverse(),
          o = ["hex", "r-channel", "g-channel", "b-channel", "a-channel", "preview-container"];
      var r = n.length;

      for (o.forEach(function (e) {
        var i = t.getElementsByClassName(e);

        for (var _t1021 = 0; _t1021 < i.length; _t1021++) {
          i[_t1021].classList.remove("smart-hidden");
        }
      }); a.scrollHeight > a.offsetHeight && 0 < r;) {
        switch (r--, n[r]) {
          case "HEX":
            e(o[0]);
            break;

          case "RGB":
            o.slice(1, 4).forEach(function (t) {
              return e(t);
            });
            break;

          case "previewContainer":
            e(o[5]);
            break;

          case "alpha":
            e(o[4]);
        }
      }

      t._generateRadialCanvas();
    }
  }, {
    key: "_resizeHoneycombItems",
    value: function _resizeHoneycombItems() {
      var e = this;
      "hexagonal" !== e.displayMode || e._generateHoneycomb(e.columnCount, e._HSV);
    }
  }, {
    key: "_getValue",
    value: function _getValue(e, t) {
      var i = this,
          a = i._RGBA;
      var n = null,
          o;

      switch (e) {
        case "hex":
          n = i._rgbArrayToHEX([a.r, a.g, a.b, a.a]);
          break;

        case "rgb":
          n = "rgb(" + a.r + ", " + a.g + ", " + a.b + ")";
          break;

        case "rgba":
          n = null !== a.r && null !== a.g && null !== a.b ? "rgba(" + a.r + ", " + a.g + ", " + a.b + ", " + a.a + ")" : null;
          break;

        case "HSVtoRGBAarray":
          {
            var _e1231 = "hexagonal" === i.displayMode || "radial" === i.displayMode || "palette" === i.displayMode ? i._RGBA.a : 1;

            t && (i._isRGBA(t) && /rgba\((\d*.\d+|\d+),(\d*.\d+|\d+),(\d*.\d+|\d+)\,(\d*.\d+|\d+)\)/gi.test(t.replace(/\s/g, "")) ? _e1231 = /rgba\((\d*.\d+|\d+),(\d*.\d+|\d+),(\d*.\d+|\d+)\,(\d*.\d+|\d+)\)/gi.exec(t.replace(/\s/g, ""))[4] : i._isHEX(t) && /(^#[0-9A-F]{8}$)/gi.test(t.replace(/\s/g, "")) && (_e1231 = parseInt(/(^#[0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2}$)/gi.exec(t.replace(/\s/g, ""))[4], 16) / 255), _e1231 = Math.min(1, Math.max(0, parseFloat(_e1231))), isNaN(_e1231) && (_e1231 = i._RGBA.a)), n = i._HSVtoRGBA(i._HSV, _e1231), o = /rgba\((\d*.\d+|\d+),(\d*.\d+|\d+),(\d*.\d+|\d+)\,(\d*.\d+|\d+)\)/gi.exec(n.replace(/\s/g, "")), n = {
              r: parseInt(o[1]),
              g: parseInt(o[2]),
              b: parseInt(o[3]),
              a: parseFloat(o[4])
            };
            break;
          }

        case "hsv":
          t && i._isValidColor(t) && (n = i._colorToHSV(t));
          break;

        default:
          "radial" === i.displayMode || "hexagonal" === i.displayMode || "palette" === i.displayMode ? (n = "rgba(" + a.r + ", " + a.g + ", " + a.b + ", " + a.a + ")", !i.editAlphaChannel && (n = i._rgbaToRGB(n))) : null === t ? n = null : n = i._rgbArrayToHEX([a.r, a.g, a.b, a.a]);
      }

      return n || null;
    }
  }, {
    key: "_instantUpdate",
    value: function _instantUpdate() {
      var e = this,
          t = e.value;
      "instantly" !== e.applyValueMode || -1 < e.$.container.className.indexOf("custom-color-selection") || (e.value = e._getValue(e.valueFormat), e.$.fireEvent("change", {
        oldValue: t,
        value: e.value
      }));
    }
  }, {
    key: "_equalValues",
    value: function _equalValues(e, t) {
      var i = this;
      if (e === t) return !0;
      return !!(e && t) && i._toRGBA(e, !0) === i._toRGBA(t, !0);
    }
  }, {
    key: "_toHEX",
    value: function _toHEX(e) {
      var t = this;
      return t._isHEX(e) ? e : (t._isRGB(e) && (e = e.toLowerCase().replace("rgb", "rgba"), e = t.editAlphaChannel ? e.replace(")", ", " + (t._RGBA.a || 1) + ")") : e.replace(")", ", 1)")), t._isRGBA(e)) ? t._rgbaToHEX(e) : void 0;
    }
  }, {
    key: "_toRGBA",
    value: function _toRGBA(e, t) {
      function i(e) {
        var i = /^#(.)(.)(.)$/gi.exec(e),
            n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(e),
            o = i ? parseInt(i[1] + i[1], 16) : parseInt(n[1], 16),
            r = i ? parseInt(i[2] + i[2], 16) : parseInt(n[2], 16),
            l = i ? parseInt(i[3] + i[3], 16) : parseInt(n[3], 16),
            s = i ? parseInt(i[4] + i[4], 16) : parseInt(n[4], 16);
        return t ? "rgba(" + o + ", " + r + ", " + l + ", 1)" : "rgba(" + o + ", " + r + ", " + l + ", " + (isNaN(s) ? "1" : s / 255) + ")";
      }

      var a = this;
      var n = a.value;

      if (a._isRGBA(e)) {
        if (t) {
          var _t1022 = e.match(/(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/gi);

          return "rgba(" + _t1022 + ", 1)";
        }

        return e;
      }

      if (a._isValidColorName(e)) n = i(a._cssColorNamesHEX[e.trim().toLowerCase()]);else if (a._isHEX(e)) n = i(e);else if (a._isRGB(e)) n = e.toLowerCase(), n = n.replace("rgb", "rgba"), n = a.editAlphaChannel ? n.replace(")", ", " + (a._RGBA.a || 1) + ")") : n.replace(")", ", 1)");else return !1;
      return n;
    }
  }, {
    key: "_rgbaToRGB",
    value: function _rgbaToRGB(e) {
      var t = /rgba\((\d*.\d+|\d+),(\d*.\d+|\d+),(\d*.\d+|\d+)\,(\d*.\d+|\d+)\)/gi.exec(e.replace(/\s/g, ""));
      return "rgb(" + t[1].trim() + ", " + t[2].trim() + ", " + t[3].trim() + ")";
    }
  }, {
    key: "_rgbaToHEX",
    value: function _rgbaToHEX(e) {
      var t = this,
          i = /rgba\((\d*.\d+|\d+),(\d*.\d+|\d+),(\d*.\d+|\d+)\,(\d*.\d+|\d+)\)/gi.exec(e.replace(/\s/g, ""));
      return t._rgbArrayToHEX([i[1], i[2], i[3], i[4]]);
    }
  }, {
    key: "_rgbArrayToHEX",
    value: function _rgbArrayToHEX(e) {
      var t = "#";
      if (Array.isArray(e) && null === e[0]) return null;

      for (var _a680 = 0, _i1024; 3 > _a680; _a680++) {
        _i1024 = parseInt(e[_a680]).toString(16).toUpperCase(), _i1024 = 1 === _i1024.length ? 0 + _i1024 : _i1024, t += _i1024;
      }

      var i = parseFloat(e[3]);
      return isNaN(i) || (i = parseInt(255 * i).toString(16).toUpperCase(), "FF" !== i && (t = t.slice(0, 7) + (1 === i.length ? 0 + i : i))), t;
    }
  }, {
    key: "_colorToHSV",
    value: function _colorToHSV(e) {
      var t = Math.min,
          i = Math.max;
      var a = this;
      if (!a._isValidColor(e)) return;
      e = a._toRGBA(e).replace(/\s/g, "");
      var n = /rgba\((\d*.\d+|\d+),(\d*.\d+|\d+),(\d*.\d+|\d+)\,(\d*.\d+|\d+)\)/gi.exec(e),
          o = t(255, i(0, parseFloat(n[1]))) / 255,
          r = t(255, i(0, parseFloat(n[2]))) / 255,
          l = t(255, i(0, parseFloat(n[3]))) / 255;
      var s = {
        h: 0,
        s: 0,
        v: 0
      },
          d = 0,
          c = 0;
      if (o >= r && o >= l ? (c = o, d = r > l ? l : r) : r >= l && r >= o ? (c = r, d = o > l ? l : o) : (c = l, d = r > o ? o : r), s.v = c, s.s = c ? (c - d) / c : 0, !s.s) s.h = a._HSV.h ? a._HSV.h : 0;else {
        var _e1232 = c - d;

        s.h = o == c ? (r - l) / _e1232 : r == c ? 2 + (l - o) / _e1232 : 4 + (o - r) / _e1232, s.h *= 60, 0 > s.h && (s.h += 360);
      }
      return s.s = parseFloat(s.s), s.v = parseFloat(s.v), s;
    }
  }, {
    key: "_HSVtoRGBA",
    value: function _HSVtoRGBA(e, t) {
      var _ref12, _ref13, _ref14, _ref15, _ref16, _ref17;

      var i = Math.round;
      e = e || {
        h: 0,
        s: 0,
        v: 0
      };
      var a = this,
          n = e && 0 <= e.h ? e.h : a._HSV.h,
          o = e && 0 <= e.s ? e.s : a._HSV.s,
          l = e && 0 <= e.v ? e.v : a._HSV.v;
      var s = l * o,
          d = n / 60,
          c = s * (1 - Math.abs(d % 2 - 1)),
          u,
          p,
          h;
      0 <= d && 1 >= d ? (_ref12 = [s, c, 0], u = _ref12[0], p = _ref12[1], h = _ref12[2], _ref12) : 1 <= d && 2 >= d ? (_ref13 = [c, s, 0], u = _ref13[0], p = _ref13[1], h = _ref13[2], _ref13) : 2 <= d && 3 >= d ? (_ref14 = [0, s, c], u = _ref14[0], p = _ref14[1], h = _ref14[2], _ref14) : 3 <= d && 4 >= d ? (_ref15 = [0, c, s], u = _ref15[0], p = _ref15[1], h = _ref15[2], _ref15) : 4 <= d && 5 >= d ? (_ref16 = [c, 0, s], u = _ref16[0], p = _ref16[1], h = _ref16[2], _ref16) : 5 <= d && 6 >= d && (_ref17 = [s, 0, c], u = _ref17[0], p = _ref17[1], h = _ref17[2], _ref17);

      var _ = l - s,
          m = i(255 * (u + _)),
          r = i(255 * (p + _)),
          g = i(255 * (h + _));

      return "rgba(" + m + ", " + r + ", " + g + ", " + (t === void 0 ? a._RGBA.a || 0 : t) + ")";
    }
  }, {
    key: "_HSVRGBArefresh",
    value: function _HSVRGBArefresh(e) {
      var t = this;
      t._HSV = t._getValue("hsv", e) || {
        h: 1,
        s: 0,
        v: 1
      }, t._RGBA = t._getValue("HSVtoRGBAarray", e);
    }
  }, {
    key: "_toFixed",
    value: function _toFixed(e, t) {
      return parseFloat(parseFloat(e).toFixed(t || 2));
    }
  }, {
    key: "_validateInRange",
    value: function _validateInRange(e, t, i) {
      return Math.min(Math.max(parseFloat(e), parseFloat(t)), parseFloat(i));
    }
  }, {
    key: "_isHEX",
    value: function _isHEX(e) {
      return /(^#[0-9A-F]{3}$)|(^#[0-9A-F]{6}$)|(^#[0-9A-F]{8}$)/i.test(e);
    }
  }, {
    key: "_isRGB",
    value: function _isRGB(e) {
      return /rgb\((\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\)/i.test(e);
    }
  }, {
    key: "_isRGBA",
    value: function _isRGBA(e) {
      return /rgba\((\d*.\d+|\d+)\s*,\s*(\d*.\d+|\d+)\s*,\s*(\d*.\d+|\d+)\s*,\s*(\d*.\d+|\d+)\)/i.test(e);
    }
  }, {
    key: "_isValidColorName",
    value: function _isValidColorName(e) {
      return !!(e && "undefined" != typeof this._cssColorNamesHEX[e.trim().toLowerCase()]);
    }
  }, {
    key: "_isValidColor",
    value: function _isValidColor(e) {
      return this._isHEX(e) || this._isRGB(e) || this._isRGBA(e) || this._isValidColorName(e);
    }
  }, {
    key: "_getRGBAFromInputs",
    value: function _getRGBAFromInputs() {
      var e = this;
      var t = (e.shadowRoot || e).querySelector("input.r-channel"),
          i = (e.shadowRoot || e).querySelector("input.g-channel"),
          n = (e.shadowRoot || e).querySelector("input.b-channel"),
          o = (e.shadowRoot || e).querySelector("input.a-channel");
      return t = t ? t.value : e._RGBA.r, i = i ? i.value : e._RGBA.g, n = n ? n.value : e._RGBA.b, o = o ? o.value : e._RGBA.a, {
        r: parseInt(t),
        g: parseInt(i),
        b: parseInt(n),
        a: o
      };
    }
  }, {
    key: "_setRGBAToInputs",
    value: function _setRGBAToInputs() {
      var e = this;
      Object.entries(e._RGBA).forEach(function (t) {
        var i = (e.shadowRoot || e).querySelector("input." + t[0] + "-channel");
        i && (i.value = e._RGBA[t[0]]);
      });
    }
  }, {
    key: "_calcHueAngle",
    value: function _calcHueAngle(e, t) {
      return 180 * Math.atan2(t, e) / Math.PI;
    }
  }, {
    key: "_calcSatDistance",
    value: function _calcSatDistance(e, t) {
      var i = Math.pow;
      return Math.sqrt(i(e, 2) + i(t, 2));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        applyValueMode: {
          value: "instantly",
          allowedValues: ["instantly", "useButtons"],
          type: "string"
        },
        columnCount: {
          value: 8,
          type: "number?"
        },
        displayMode: {
          value: "default",
          allowedValues: ["default", "grid", "palette", "radial", "hexagonal", "spectrumGrid", "materialGrid"],
          type: "string"
        },
        disableUndo: {
          value: !1,
          type: "boolean"
        },
        editAlphaChannel: {
          value: !1,
          type: "boolean"
        },
        enableCustomColors: {
          value: !1,
          type: "boolean"
        },
        gridThemeColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        gridShadeColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        gridStandardColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        hideAlphaEditor: {
          value: !1,
          type: "boolean"
        },
        hideContentToFit: {
          value: ["RGB", "HEX", "alpha", "previewContainer"],
          type: "array"
        },
        hideHEXEditor: {
          value: !1,
          type: "boolean"
        },
        hidePreviewContainer: {
          value: !1,
          type: "boolean"
        },
        hideRGBEditor: {
          value: !1,
          type: "boolean"
        },
        inverted: {
          value: !1,
          type: "boolean"
        },
        messages: {
          value: {
            en: {
              redPrefix: "R:",
              greenPrefix: "G:",
              bluePrefix: "B:",
              hexPrefix: "#:",
              alphaPrefix: "Alpha:",
              ok: "OK",
              cancel: "CANCEL",
              customColor: "CUSTOM COLOR",
              standardColors: "Standard colors",
              themeColors: "Theme colors"
            }
          },
          type: "object",
          extend: !0
        },
        name: {
          value: "",
          type: "string"
        },
        palette: {
          value: "default",
          allowedValues: ["default", "gray", "red", "green", "blue", "custom"],
          type: "string"
        },
        paletteColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        paletteCustomColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        tooltipDisplayMode: {
          value: "hex",
          allowedValues: ["none", "rgba", "rgb", "hex"],
          type: "string"
        },
        value: {
          value: null,
          type: "string?"
        },
        valueFormat: {
          value: "default",
          allowedValues: ["rgb", "rgba", "hex", "default"],
          type: "string"
        },
        valueMember: {
          value: "value",
          type: "string?"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "container.click": "_containerClickHandler",
        "container.mouseover": "_handleGridModeCellHover",
        "paletteModeContainer.down": "_paletteDownHandler",
        "container.change": "_handleInputChange",
        "document.move": "_moveThumbHandler",
        "document.up": "_releaseThumbUpHandler",
        "paletteModeContainer.wheel": "_inputWheelHandler",
        resize: "_hideControlsByPriority",
        "hexModeResizeTrigger.resize": "_resizeHoneycombItems",
        "paletteModeContainer.move": "_trackMoveHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Utilities.Draw": "smart.draw.js",
        "Smart.Button": "smart.button.js",
        "Smart.Tooltip": "smart.tooltip.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.button.css", "smart.tooltip.css", "smart.colorpanel.css"];
    }
  }]);

  return _class116;
}(Smart.BaseElement)), Smart("smart-color-picker",
/*#__PURE__*/
function (_Smart$DropDownButton) {
  "use strict";

  _inherits(_class117, _Smart$DropDownButton);

  function _class117() {
    _classCallCheck(this, _class117);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class117).apply(this, arguments));
  }

  _createClass(_class117, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\" role=\"presentation\">\n                    <span class=\"smart-label\" id=\"label\">[[label]]</span>\n                    <div id=\"content\" class=\"smart-content\" role=\"presentation\">\n                        <div id=\"buttonsContainer\" class=\"smart-buttons-container\" role=\"presentation\">\n                            <div id=\"actionButton\" class=\"smart-action-button\">\n                                <div id=\"colorSampleContainer\" class=\"smart-color-box color-picker-sample-container\" role=\"presentation\">\n                                    <div id=\"colorSample\" class=\"color-picker-sample\"></div>\n                                </div>\n                                <input type=\"text\" id=\"input\" class=\"smart-input smart-color-input color-picker-action-input\" placeholder=\"[[placeholder]]\" spellcheck=\"false\" autocomplete=\"off\" aria-label=\"[[placeholder]]\" />\n                            </div>\n                            <span id=\"dropDownButton\" class=\"smart-drop-down-button\">\n                                <span class=\"smart-drop-down-button-icon\" id=\"arrow\" aria-hidden=\"true\"></span>\n                            </span>\n                        </div>\n                        <div id=\"dropDownContainer\" class=\"smart-drop-down smart-drop-down-color-picker smart-drop-down-container smart-visibility-hidden\" role=\"dialog\">\n                            <smart-color-panel id=\"colorPanel\" wait\n                                             animation=\"[[animation]]\"\n                                             apply-value-mode=\"[[applyValueMode]]\"\n                                             column-count=\"[[columnCount]]\"\n                                             disabled=\"[[disabled]]\"\n                                             display-mode=\"[[displayMode]]\"\n                                             edit-alpha-channel=\"[[editAlphaChannel]]\"\n                                             enable-custom-colors=\"[[enableCustomColors]]\"\n                                             grid-theme-colors=\"[[gridThemeColors]]\"\n                                             grid-shade-colors=\"[[gridShadeColors]]\"\n                                             grid-standard-colors=\"[[gridStandardColors]]\"\n                                             hide-content-to-fit=\"[[hideContentToFit]]\"\n                                             hide-preview-container=\"[[hidePreviewContainer]]\"\n                                             hide-r-g-b-editor=\"[[hideRGBEditor]]\"\n                                             hide-h-e-x-editor=\"[[hideHEXEditor]]\"\n                                             hide-alpha-editor=\"[[hideAlphaEditor]]\"\n                                             inverted=\"[[inverted]]\"\n                                             locale=\"[[locale]]\"\n                                             name=\"[[name]]\"\n                                             palette-colors=\"[[paletteColors]]\"\n                                             palette-custom-colors=\"[[paletteCustomColors]]\"\n                                             palette=\"[[palette]]\"\n                                             right-to-left=\"[[rightToLeft]]\"\n                                             theme=\"[[theme]]\"\n                                             tooltip-display-mode=\"[[tooltipDisplayMode]]\"\n                                             value=\"{{value}}\"\n                                             value-format=\"[[valueFormat]]\">\n                            </smart-color-panel>\n                            <div id=\"resizeBar\" class=\"smart-drop-down-resize-bar\" aria-label=\"Resize\">\n                                <div></div>\n                            </div>\n                        </div>\n                    </div>\n                    <span class=\"smart-hint\" id=\"hint\">[[hint]]</span>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "editable":
        case "disabled":
        case "readonly":
          a.$.input.readOnly = a.disabled || a.readonly || !a.editable;
          break;

        case "value":
          a.$.colorPanel._isValidColor(a.value) && a._applyValue(a.value);
          break;

        case "displayMode":
          a._applyValue(a.value);

          break;

        case "dropDownOpenMode":
          _get(_getPrototypeOf(_class117.prototype), "propertyChangedHandler", this).call(this, e, t, i), "dropDownButton" === i ? a.$.actionButton.setAttribute("aria-label", a.value || a.placeholder) : a.$.actionButton.removeAttribute("aria-label");
          break;

        case "resizeMode":
          a.$.dropDownContainer.setAttribute("resize-mode", a.resizeMode);
          break;

        case "valueDisplayMode":
          "none" === i ? a.$.actionButton.setAttribute("role", "presentation") : a.$.actionButton.removeAttribute("role");
          break;

        default:
          _get(_getPrototypeOf(_class117.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }

      "displayMode" === e && a.$.colorPanel._hideControlsByPriority();
    }
  }, {
    key: "open",
    value: function open() {
      var e = this,
          t = document.querySelectorAll("smart-drop-down-button, smart-color-picker");
      e.$.colorPanel._initializeOnOpening && (delete e.$.colorPanel._initializeOnOpening, e.$.colorPanel._generateGridStructures(), e.$.colorPanel._applyValue(e.value), e.$.colorPanel._hideControlsByPriority());

      for (var _a681 = 0; _a681 < t.length; _a681++) {
        t[_a681] !== e && t[_a681].opened && t[_a681].close();
      }

      e.$.colorPanel && e.$.colorPanel.$container.hasClass("custom-color-selection") && e.$.colorPanel._handleCancelButtonClick(), e._open();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.$.input.blur();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.$.input.focus();
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.$.colorPanel._initializeOnOpening = !e.opened, e.$.colorPanel.wait = !1, e.$.colorPanel.setAttribute("role", "presentation"), e.$.input.readOnly = e.disabled || e.readonly || !e.editable, e.editable && (e.dropDownOpenMode = "dropDownButton"), e._setAriaRelations(!0), "none" === e.valueDisplayMode ? e.$.actionButton.setAttribute("role", "presentation") : e.$.actionButton.removeAttribute("role"), e._applyValue(e.$.colorPanel.value), e._setFocusable();
    }
  }, {
    key: "_colorPanelChangeHandler",
    value: function _colorPanelChangeHandler(e) {
      var t = this;
      t._applyValue(e.detail.value), e.stopPropagation(), t.$.fireEvent("change", e.detail);
    }
  }, {
    key: "_cancelButtonHandler",
    value: function _cancelButtonHandler(e) {
      var t = this;
      return e.stopPropagation(), -1 < t.$.colorPanel.$.container.className.indexOf("custom-color-selection") ? void t.$.fireEvent(e.type, e.detail) : void (t.close(), t.$.fireEvent(e.type, e.detail));
    }
  }, {
    key: "_okButtonHandler",
    value: function _okButtonHandler() {
      var e = this;
      return event.stopPropagation(), -1 < e.$.colorPanel.$.container.className.indexOf("custom-color-selection") ? void e.$.fireEvent(event.type, event.detail) : void (e._applyValue(e.$.colorPanel.value), e.close(), e.$.fireEvent(event.type, event.detail));
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;

      if (!e.disabled && !e.unfocusable) {
        var _t1023 = 0 < e.tabIndex ? e.tabIndex : 0;

        return e.$.input.tabIndex = _t1023, void ("dropDownButton" === e.dropDownOpenMode ? e.$.dropDownButton.setAttribute("tabindex", _t1023) : e.$.dropDownButton.removeAttribute("tabindex"));
      }

      e.$.input.tabIndex = -1, e.$.dropDownButton.removeAttribute("tabindex");
    }
  }, {
    key: "_inputChangeHandler",
    value: function _inputChangeHandler(e) {
      var t = this;
      e.preventDefault(), e.stopPropagation(), t.value = t.$.colorPanel.value = t.$.input.value;
    }
  }, {
    key: "_applyValue",
    value: function _applyValue(e) {
      var t = this;
      t.value = t.$.colorPanel.value = t.$.colorSample.style.backgroundColor = t.$.input.value = e, e ? (t.$colorSampleContainer.removeClass("no-color"), t.$.colorSample.setAttribute("aria-label", e)) : (t.$colorSampleContainer.addClass("no-color"), t.$.colorSample.setAttribute("aria-label", "No color")), t.label || t._ariaButton.setAttribute("aria-label", e || t.placeholder), "dropDownButton" === t.dropDownOpenMode && t.$.actionButton.setAttribute("aria-label", e || t.placeholder);
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this,
          i = t.shadowRoot || t.isInShadowDOM ? e.composedPath()[0] : e.target,
          a = (t.shadowRoot || t.getRootNode()).activeElement || document.activeElement;
      if (!(t.disabled || t.readonly || a !== t && a !== t.$.dropDownButton && a !== t.$.input)) switch (e.key) {
        case "Enter":
        case " ":
          i === t.$.input ? "Enter" === e.key && (e.preventDefault(), t.$.colorPanel.value = t.$.input.value) : t.opened && "Enter" === e.key ? (e.preventDefault(), t.close()) : !t.opened && !t.readonly && "none" !== t.dropDownOpenMode && (e.preventDefault(), t.open());
          break;

        case "ArrowUp":
        case "ArrowDown":
          if (e.altKey) return void (t.disabled || t.readonly || "none" === t.dropDownOpenMode || ("ArrowDown" === e.key ? t.open() : t.close()));
          e.preventDefault();
          break;

        case "Escape":
          e.preventDefault(), t.close();
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        applyValueMode: {
          value: "instantly",
          allowedValues: ["instantly", "useButtons"],
          type: "string"
        },
        columnCount: {
          value: 8,
          type: "number"
        },
        gridThemeColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        gridShadeColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        gridStandardColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        paletteColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        paletteCustomColors: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        disableUndo: {
          value: !1,
          type: "boolean"
        },
        displayMode: {
          value: "default",
          allowedValues: ["default", "grid", "palette", "radial", "hexagonal", "spectrumGrid", "materialGrid"],
          type: "string"
        },
        dropDownAppendTo: {
          value: null,
          type: "any"
        },
        dropDownHeight: {
          value: "auto",
          type: "string"
        },
        dropDownWidth: {
          value: "auto",
          type: "string"
        },
        editable: {
          value: !1,
          type: "boolean"
        },
        editAlphaChannel: {
          value: !1,
          type: "boolean"
        },
        enableCustomColors: {
          value: !1,
          type: "boolean"
        },
        hidePreviewContainer: {
          value: !1,
          type: "boolean"
        },
        hideRGBEditor: {
          value: !1,
          type: "boolean"
        },
        hideHEXEditor: {
          value: !1,
          type: "boolean"
        },
        hideAlphaEditor: {
          value: !1,
          type: "boolean"
        },
        messages: {
          value: {
            en: {
              redPrefix: "R:",
              greenPrefix: "G:",
              bluePrefix: "B:",
              hexPrefix: "#:",
              alphaPrefix: "Alpha:",
              ok: "OK",
              cancel: "CANCEL",
              customColor: "CUSTOM COLOR",
              standardColors: "Standard colors",
              themeColors: "Theme colors"
            }
          },
          type: "object",
          extend: !0
        },
        name: {
          value: "",
          type: "string"
        },
        palette: {
          value: "default",
          allowedValues: ["default", "gray", "red", "green", "blue", "custom"],
          type: "string"
        },
        placeholder: {
          value: "Please Select Color",
          type: "string"
        },
        tooltipDisplayMode: {
          value: "hex",
          allowedValues: ["none", "rgba", "rgb", "hex"],
          type: "string"
        },
        value: {
          value: null,
          type: "string?"
        },
        valueDisplayMode: {
          value: "default",
          allowedValues: ["default", "colorBox", "colorCode", "none"],
          type: "string"
        },
        valueFormat: {
          value: "default",
          allowedValues: ["default", "rgb", "rgba", "hex"],
          type: "string"
        },
        inverted: {
          value: !1,
          type: "boolean"
        },
        hideContentToFit: {
          value: ["RGB", "HEX", "alpha", "previewContainer"],
          type: "array"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "input.change": "_inputChangeHandler",
        "input.focus": "_focusEventHandler",
        "input.blur": "_blurEventHandler",
        "colorPanel.cancelButtonClick": "_cancelButtonHandler",
        "colorPanel.okButtonClick": "_okButtonHandler",
        "colorPanel.change": "_colorPanelChangeHandler",
        keydown: "_keyDownHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.ColorPanel": "smart.colorpanel.js",
        "Smart.DropDownButton": "smart.dropdownbutton.js"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.colorpanel.css", "smart.colorpicker.css"];
    }
  }]);

  return _class117;
}(Smart.DropDownButton)), Smart("smart-window",
/*#__PURE__*/
function (_Smart$ContentElement20) {
  "use strict";

  _inherits(_class118, _Smart$ContentElement20);

  function _class118() {
    _classCallCheck(this, _class118);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class118).apply(this, arguments));
  }

  _createClass(_class118, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"headerSection\" class=\"smart-header-section\" role=\"heading\" aria-level=\"1\">\n                        <div id=\"header\" class=\"smart-header\" role=\"presentation\">[[label]]</div>\n                        <div id=\"buttonsContainer\" class=\"smart-buttons-container\" role=\"presentation\">\n                            <smart-button id=\"pinButton\" class=\"smart-pin-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Pin\"></smart-button>\n                            <smart-button id=\"collapseButton\" class=\"smart-collapse-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Collapse\"></smart-button>\n                            <smart-button id=\"minimizeButton\" class=\"smart-minimize-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Minimize\"></smart-button>\n                            <smart-button id=\"maximizeButton\" class=\"smart-maximize-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Maximize\"></smart-button>\n                            <smart-button id=\"closeButton\" class=\"smart-close-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Close\"></smart-button>\n                        </div>\n                    </div>\n                    <div class=\"smart-content\" inner-h-t-m-l=\"[[innerHTML]]\"><content></content></div>\n                    <div id=\"footer\" class=\"smart-footer\"></div>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "collapsed":
          i ? a.collapse(!0) : a.expand(!0);
          break;

        case "disabled":
        case "unfocusable":
          a._setFocusable();

          break;

        case "headerTemplate":
        case "footerTemplate":
          a._applyLayoutTemplate(a.$[e.split(/[T]/)[0]], i);

          break;

        case "headerButtons":
          a._setHeaderButtons();

          break;

        case "headerPosition":
          {
            var _e1233 = a.minimized;
            a._preventEventFiring = !0, a.restore(), delete a._preventEventFiring, _e1233 && a.minimize();
            break;
          }

        case "label":
          a.$.header.innerHTML = a.label;
          break;

        case "maximized":
          i ? a.maximize(!0) : a.restore(e);
          break;

        case "modal":
          a._setModal(), a.setAttribute("aria-modal", i);
          break;

        case "minimized":
          i ? a.minimize(!0) : a.restore(e);
          break;

        case "opened":
          i ? a.open(!0) : a.close(!0);
          break;

        case "resizeMode":
          a.$.container.className = "smart-container";
          break;

        case "windowParent":
          a._setElementParent(i);

          break;

        default:
          _get(_getPrototypeOf(_class118.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "ready",
    value: function ready() {
      _get(_getPrototypeOf(_class118.prototype), "ready", this).call(this);

      var e = this;
      e._windowParent = {
        initialParent: e.parentElement
      };
    }
  }, {
    key: "render",
    value: function render() {
      var e = this,
          t = e.animation;
      e.$.header.id || (e.$.header.id = e.id + "Header"), e.$.content.id || (e.$.content.id = e.id + "Content"), e.opened || (e.animation = "none"), e._windowParent = {
        initialParent: e.parentElement
      }, e.$.addClass("smart-window"), e._createElement(), e._setElementParent(e.windowParent), e._setHeaderButtons(), e.headerTemplate && e._applyLayoutTemplate(e.$.header, e.headerTemplate), e.footerTemplate && e._applyLayoutTemplate(e.$.footer, e.footerTemplate), e.opened ? e.open() : e.close(), e.maximized && e.maximize(!0), e.minimized && e.minimize(!0), e.collapsed && e.collapse(!0), e.pinned ? e.pin() : e.unpin(), e._setFocusable(), e.animation = t, e.setAttribute("aria-modal", e.modal), e.setAttribute("aria-labelledby", e.$.header.id), _get(_getPrototypeOf(_class118.prototype), "render", this).call(this);
    }
  }, {
    key: "_styleChangedHandler",
    value: function _styleChangedHandler() {
      var e = this;
      !e.maximized;
    }
  }, {
    key: "_setFocusable",
    value: function _setFocusable() {
      var e = this;

      if (!e.disabled && !e.unfocusable) {
        var _t1024 = 0 < e.tabIndex ? e.tabIndex : 0;

        e.setAttribute("tabindex", _t1024);
      } else e.removeAttribute("tabindex");
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1234 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1234.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? void t.$.content.appendChild(e) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "appendChild",
        node: "node"
      }));
    }
  }, {
    key: "collapse",
    value: function collapse(e) {
      var t = this;
      !e && t.collapsed || (t.collapsed = !0, t.$.fireEvent("collapse"), "left" === t.headerPosition || "right" === t.headerPosition ? t.style.width = "" : t.style.height = "");
    }
  }, {
    key: "close",
    value: function close(e) {
      var t = this;

      if (e || !t.$.hasClass("smart-visibility-hidden")) {
        if (t.isCompleted) {
          var _e1235 = t.$.fireEvent("closing").defaultPrevented;
          if (_e1235) return;
          t.$.addClass("smart-visibility-hidden"), t.opened = !1, t.isRendered && t.$.fireEvent("close");
        } else t.$.addClass("smart-visibility-hidden"), t.opened = !1;

        t._setModal(), t.removeAttribute("ontop");
      }
    }
  }, {
    key: "attached",
    value: function attached() {
      _get(_getPrototypeOf(_class118.prototype), "attached", this).call(this);

      var e = this;
      !e.isRendered, e._windowParent.parent && e._windowParent.parent !== document.body && e._windowParent.parent.querySelectorAll("smart-window, smart-dialog-window, smart-progress-window, smart-wait-window, smart-alert-window, smart-prompt-window, smart-multiline-prompt-window") && (e._windowParent.parent.style.position = "relative"), e.opened && e._modal && e.parentElement.insertBefore(e._modal, e);
    }
  }, {
    key: "bringToFront",
    value: function bringToFront() {
      var e = this;

      if (e.parentElement) {
        var _t1025 = e.parentElement.closest(".smart-window");

        if (_t1025) return void _t1025.bringToFront();

        var _i1025 = document.body.getElementsByClassName("smart-window");

        for (var _e1236 = 0; _e1236 < _i1025.length; _e1236++) {
          _i1025[_e1236].removeAttribute("ontop");
        }

        1 === _i1025.length && _i1025[0] === e || e.setAttribute("ontop", "");
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = this;
      e.isCompleted && "Smart-WINDOW" === e.nodeName && (e.$.content.innerHTML = "");
    }
  }, {
    key: "detached",
    value: function detached() {
      _get(_getPrototypeOf(_class118.prototype), "detached", this).call(this);

      var e = this;
      e._windowParent.parent && !e._windowParent.parent.querySelectorAll("smart-window, smart-dialog-window, smart-progress-window, smart-wait-window, smart-alert-window, smart-prompt-window, smart-multiline-prompt-window") && (e._windowParent.parent.style.position = ""), e._modal && e._modal.parentElement && e._modal.parentElement.removeChild(e._modal), e._resizeDummy && e._resizeDummy.parentElement && e._handleWindowResizeDummy(), e._refreshMinimizedWindowsPosition();
    }
  }, {
    key: "expand",
    value: function expand(e) {
      var t = Math.max;
      var i = this;
      (e || i.collapsed) && (i.collapsed = !1, i.$.fireEvent("expand"), i.maximized ? "left" === i.headerPosition || "right" === i.headerPosition ? i.style.width = t(i._windowParent.scrollElement.scrollWidth, i._windowParent.element.clientWidth) - i._windowParent.borderWidth + "px" : i.style.height = t(i._windowParent.scrollElement.scrollHeight, i._windowParent.element.clientHeight) - i._windowParent.borderWidth + "px" : "left" === i.headerPosition || "right" === i.headerPosition ? i.style.width = 0 > i.className.indexOf("smart-window-snapped-") && i._dragDetails ? i._dragDetails.width + "px" : "" : i.style.height = 0 > i.className.indexOf("smart-window-snapped-") && i._dragDetails ? i._dragDetails.height + "px" : "");
    }
  }, {
    key: "maximize",
    value: function maximize(e) {
      function t() {
        if (a.maximized && a.hasAnimation) {
          var _e1237 = a._windowParent.scrollElement.scrollHeight,
              _n511 = a._windowParent.element.clientHeight,
              _o363 = i(_e1237, _n511);

          "top" === a.headerPosition || "bottom" === a.headerPosition ? !a.collapsed && (a.style.height = _e1237 > _n511 ? _o363 - a._windowParent.borderWidth + "px" : "100%") : a.style.height = _e1237 > _n511 ? _o363 - a._windowParent.borderWidth + "px" : "100%", a.removeEventListener("transitionend", t);
        }
      }

      var i = Math.max;
      var a = this;

      if (e || !a.maximized) {
        a.minimized && a._restoreFromMinimization(e), a._setDragDetails("minimize"), "none" !== a.resizeMode && (a.$.container.className = "smart-container"), a._snapDummy && a.$.hasClass("smart-window-snapped-" + a._snapDummy._position) && a.classList.remove("smart-window-snapped-" + a._snapDummy._position), a.maximized = !0, a.$.fireEvent("maximize"), a.style.left = a.style.top = 0, a.style.maxWidth = a.style.maxHeight = "none";

        var _n512 = a._windowParent.scrollElement.scrollHeight,
            _o364 = a._windowParent.scrollElement.scrollWidth,
            _r222 = a._windowParent.element.clientHeight,
            _l155 = a._windowParent.element.clientWidth,
            _s114 = i(_n512, _r222),
            d = i(_o364, _l155);

        "top" === a.headerPosition || "bottom" === a.headerPosition ? (a.style.width = _o364 > _l155 ? d - a._windowParent.borderWidth + "px" : "100%", !a.collapsed && (a.style.height = _n512 > _r222 ? _s114 - a._windowParent.borderWidth + "px" : "100%")) : (!a.collapsed && (a.style.width = _o364 > _l155 ? d - a._windowParent.borderWidth + "px" : "100%"), a.style.height = _n512 > _r222 ? _s114 - a._windowParent.borderWidth + "px" : "100%"), "100%" !== a.style.height && a.addEventListener("transitionend", t);
      }
    }
  }, {
    key: "minimize",
    value: function minimize(e) {
      var t = this;

      if (e || !t.minimized) {
        t.maximized && (t._preventEventFiring = !0, t.restore(), delete t._preventEventFiring), t._setDragDetails(), t.minimized = !0, t.$.fireEvent("minimize"), t._snapDummy && t.$.hasClass("smart-window-snapped-" + t._snapDummy._position) && (t.$.removeClass("smart-window-snapped-" + t._snapDummy._position), t.style.right = t.style.top = t.style.left = "");

        var _e1238 = t._getAllMinimizedWindows(t._windowParent.element);

        if (0 < _e1238.length) {
          var _i1026 = _e1238[_e1238.length - 1];
          t.style.left = (_i1026.offsetLeft + _i1026.offsetWidth + t._dragDetails.minWidth + 10 > t._windowParent.element.clientWidth ? _i1026.offsetLeft : _i1026.offsetLeft + _i1026.offsetWidth + 5) + "px", t.style.top = _i1026.offsetTop + "px";
        } else t.style.left = "5px", t.style.top = t._windowParent.element.clientHeight + t._windowParent.scrollElement.scrollTop - t.$.headerSection.offsetHeight - 5 + "px";

        t.style.width = "", t.style.height = t.$.headerSection.offsetHeight + "px";
      }
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      this.setAttribute("role", "dialog");
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted) {
        var _e1239 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e1239.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? void t.$.content.removeChild(e) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "removeChild",
        node: "node"
      }));
    }
  }, {
    key: "restore",
    value: function restore(e) {
      var t = Math.min,
          i = Math.max;
      var a = this;

      if ("maximized" === e || a.maximized ? (a.maximized = !1, a.style.width = a.style.height = a.style.top = a.style.left = "") : ("minimized" === e || a.minimized) && a._restoreFromMinimization(e), a._preventEventFiring || a.$.fireEvent("restore"), a.style.maxWidth = a.style.maxHeight = "", a._dragDetails) {
        if (a.style.left = i(0, t(a._dragDetails.windowX, a._windowParent.element.clientWidth - a._dragDetails.width)) + "px", a.style.top = i(0, t(a._dragDetails.windowY, a._windowParent.scrollElement.scrollHeight - a._dragDetails.height)) + "px", a.collapsed) return void ("top" === a.headerPosition || "bottom" === a.headerPosition ? a.style.width = a._dragDetails.width + "px" : a.style.height = a._dragDetails.height + "px");
        a._dragDetails.resized && (a.style.width = a._dragDetails.width + "px", a.style.height = a._dragDetails.height + "px");
      }
    }
  }, {
    key: "open",
    value: function open(e) {
      function t() {
        i.focus(), i.removeEventListener("transitionend", t);
      }

      var i = this;

      if (e || i.$.hasClass("smart-visibility-hidden")) {
        if (i.isCompleted) {
          var _e1240 = i.$.fireEvent("opening").defaultPrevented;
          if (_e1240) return;
          i.$.removeClass("smart-visibility-hidden"), i.opened = !0, i.$.fireEvent("open");
        } else i.$.removeClass("smart-visibility-hidden"), i.opened = !0;

        i.bringToFront(), i._setModal(), i._handleActiveState(), i.hasAnimation ? i.addEventListener("transitionend", t) : t();
      }
    }
  }, {
    key: "pin",
    value: function pin() {
      this.pinned = !0;
    }
  }, {
    key: "unpin",
    value: function unpin() {
      this.pinned = !1;
    }
  }, {
    key: "_applyLayoutTemplate",
    value: function _applyLayoutTemplate(e, t) {
      var i = this;
      return t ? "content" in document.createElement("template") ? (t instanceof HTMLTemplateElement || (t = document.getElementById(t)), null !== t && "content" in t ? void (e.innerHTML = "", e.appendChild(document.importNode(t.content, !0))) : void i.error(i.localize("invalidTemplate", {
        elementType: i.nodeName.toLowerCase(),
        property: e === i.$.footer ? "footerTemplate" : "headerTemplate"
      }))) : void i.error(i.localize("htmlTemplateNotSuported", {
        elementType: i.nodeName.toLowerCase()
      })) : (e.innerHTML = "", void (e === i.$.header && i.label && (e.innerHTML = i.label)));
    }
  }, {
    key: "_cancelDragging",
    value: function _cancelDragging(e) {
      var t = this;

      if (t._dragDetails && t._dragDetails.started && "drag" === t._dragDetails.type) {
        if (!e) {
          var _i1027 = t.getBoundingClientRect();

          e = {
            pageX: _i1027.left,
            pageY: _i1027.top
          };
        }

        t.$.fireEvent("dragEnd", {
          left: e.pageX,
          top: e.pageY
        }), t.removeAttribute("dragged"), t._dragDetails.started = !1, delete t._mouseManipulation;
      }
    }
  }, {
    key: "_documentFocusInEventHandler",
    value: function _documentFocusInEventHandler(e) {
      var t = this;
      t._changingFocus && (!t.contains(e.target) && t.focus(), delete t._changingFocus);
    }
  }, {
    key: "_downHandler",
    value: function _downHandler(e) {
      var t = this;
      var i = Smart.Utilities.Core.isMobile ? document.elementFromPoint(e.pageX - window.pageXOffset, e.pageY - window.pageYOffset) : e.originalEvent.target;
      if ((t.shadowRoot || t.isInShadowDOM) && (i = e.originalEvent.composedPath()[0]), e.stopPropagation(), t.disabled || !Smart.Utilities.Core.isMobile && 1 !== e.which) return;

      if (t._tabsWindow && (t._tabsWindow._isAutoHideWindowClicked = !0), t.hasAttribute("ontop") || t.bringToFront(), i.closest && i.closest(".smart-buttons-container") === t.$.buttonsContainer) {
        if (t._buttonPressed = i.closest("smart-button"), t._buttonPressed) return;
      } else if (i.getRootNode() && i.getRootNode().host && (t._buttonPressed = i.getRootNode().host, t._buttonPressed.closest(".smart-buttons-container") === t.$.buttonsContainer)) return;

      t._isWindowContentClicked = i.closest(".smart-content");
      var a = t.closest("smart-docking-layout");
      if (t.isInShadowDOM && !a) for (var _e1241 = t.getRootNode().host; _e1241 && (a = _e1241.closest("smart-docking-layout"), !a) && !!_e1241.getRootNode();) {
        _e1241 = _e1241.getRootNode().host;
      }
      return t instanceof Smart.TabsWindow && a && a.disabled ? void 0 : (t._handleActiveState(), t instanceof Smart.TabsWindow && a ? void (t.$.hasClass("smart-docking-layout-auto-hide-window") && (Smart.Utilities.Core.isMobile && t._moveHandler(e), "none" !== t.resizeMode && -1 < t.$.container.className.indexOf("smart-window-resizing") && (t._mouseManipulation = !0, t._setDragDetails("resize", e)))) : i.closest(".smart-header-section") === t.$.headerSection && (void 0 === t._dblClickDetails && (t._dblClickDetails = {
        clicks: 0
      }), clearTimeout(t._dblClickDetails.timeOut), t._dblClickDetails.clicks++, t._dblClickDetails.timeOut = setTimeout(function () {
        t._dblClickDetails && (t._dblClickDetails.clicks = 0);
      }, 300), 2 === t._dblClickDetails.clicks) ? (t._headerDblCickHandler(e), void (t._dblClickDetails.clicks = 0)) : void (t.maximized || (Smart.Utilities.Core.isMobile && t._moveHandler(e), !t.pinned && !t.minimized && 0 > t.$.container.className.indexOf("smart-window-resizing") && (i = i.closest(".smart-header-section"), i && i === t.$.headerSection && (t._mouseManipulation = !0, t._setDragDetails("drag", e))), "none" !== t.resizeMode && -1 < t.$.container.className.indexOf("smart-window-resizing") && (t._mouseManipulation = !0, t._setDragDetails("resize", e)))));
    }
  }, {
    key: "_documentMoveHandler",
    value: function _documentMoveHandler(e) {
      var t = Math.min,
          i = Math.abs,
          a = Math.max;
      var n = this;
      !n._dragDetails || !n._dragDetails.started || n.minimized || !n._mouseManipulation || 5 >= i(e.pageX - n._dragDetails.x) && 5 >= i(e.pageY - n._dragDetails.y) || (!n.hasAttribute("dragged") && !n.hasAttribute("resized") && n.$.fireEvent(n._dragDetails.type + "Start", {
        left: e.pageX,
        top: e.pageY,
        width: n.offsetWidth,
        height: n.offsetHeight
      }), e.stopPropagation(), "drag" !== n._dragDetails.type || n.pinned ? (n._dragDetails.resized = !0, n._resize(n._dragDetails.side, e), n._dragDetails.x = a(n._windowParent.offsetLeft + n._dragDetails.left, t(n._windowParent.offsetLeft + n._dragDetails.left + (-1 < n._dragDetails.side.toLowerCase().indexOf("left") ? 0 : n._dragDetails.newWidth), e.pageX)), n._dragDetails.y = a(n._windowParent.offsetTop + n._dragDetails.top, t(n._windowParent.offsetTop + n._dragDetails.top + (-1 < n._dragDetails.side.toLowerCase().indexOf("top") ? 0 : n._dragDetails.newHeight), e.pageY))) : (n.setAttribute("dragged", ""), n._snapDummy && n.$.hasClass("smart-window-snapped-" + n._snapDummy._position) && (n.$.removeClass("smart-window-snapped-" + n._snapDummy._position), n.style.right = n.style.top = n.style.left = "", !n.collapsed && (n.style.height = n._dragDetails.height + "px", n.style.width = n._dragDetails.width + "px")), n._drag(e, "both"), n._dragDetails.x = a(n._windowParent.offsetLeft + n._dragDetails.offsetX - n._windowParent.scrollElement.scrollLeft, t(n._windowParent.offsetLeft + n._windowParent.element.offsetWidth - (n._windowParent.element.offsetWidth - n.offsetLeft) + n._dragDetails.offsetX, e.pageX)), n._dragDetails.y = a(n._windowParent.offsetTop + n._dragDetails.offsetY - n._windowParent.scrollElement.scrollTop, t(n._windowParent.offsetTop + n._windowParent.element.offsetHeight - (n._windowParent.element.offsetHeight - n.offsetTop) + n._dragDetails.offsetY, e.pageY)), e.pageX >= n._windowParent.offsetLeft + n._windowParent.scrollElement.scrollWidth - 1 ? n._handleSnapping("right") : e.pageY <= n._windowParent.offsetTop ? n._handleSnapping("top") : e.pageX <= n._windowParent.offsetLeft ? n._handleSnapping("left") : n._handleSnapping()));
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this,
          i = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      if (t.disabled) return t.removeAttribute("active"), delete t._buttonPressed, void delete t._isWindowContentClicked;

      if (t._dragDetails && t._dragDetails.started && (t.hasAttribute("resized") && (t.$.fireEvent(t._dragDetails.type + "End", {
        left: e.pageX,
        top: e.pageY,
        width: t._dragDetails.newWidth,
        height: t._dragDetails.newHeight
      }), t.removeAttribute("resized"), t._handleWindowResizeDummy(), t.$.container.className = "smart-container"), setTimeout(function () {
        t.$.removeClass("no-transition");
      }, 20), t.hasAttribute("dragged") && (t.$.fireEvent(t._dragDetails.type + "End", {
        left: e.pageX,
        top: e.pageY
      }), t.removeAttribute("dragged")), t._dragDetails.started = !1, delete t._mouseManipulation), t._snapDummy && !t._snapDummy.classList.contains("smart-visibility-hidden")) {
        switch (t._snapDummy._position) {
          case "left":
          case "top":
            t.style.left = t.style.top = "0", t.style.right = "auto";
            break;

          case "right":
            t.style.left = "auto", t.style.top = t.style.right = "0";
        }

        t.style.width = "top" === t._snapDummy._position ? "100%" : "50%", t.style.height = "100%", t.$.addClass("smart-window-snapped-" + t._snapDummy._position), t._handleSnapping();
      }

      t._modal && i === t._modal && !t._isWindowContentClicked && (t.closeOnMaskClick ? t.close() : t.focus()), t._isWindowButton(i) && t.focus(), delete t._isWindowContentClicked, delete t._buttonPressed;
      var a = t.shadowRoot && t._windowParent.element && t._windowParent.element.getRootNode() ? t._windowParent.element.getRootNode().activeElement : document.activeElement;
      if (!t.hasAttribute("active") || a === t) return;
      if (!i.closest) return;
      var n = i.closest(".smart-window");

      for (; n && n !== t;) {
        n = n.parentElement.closest(".smart-window");
      }

      t.opened && n !== t && t.removeAttribute("active");
    }
  }, {
    key: "_documentSelectStartHandler",
    value: function _documentSelectStartHandler(e) {
      var t = this;
      t._dragDetails && t._dragDetails.started && e.preventDefault();
    }
  }, {
    key: "_drag",
    value: function _drag(e, t) {
      var i = Math.min,
          a = Math.max;
      var n = this;
      if (!e || n.pinned || n.maximized) return;
      var o, r;
      n._dragDetails && n._dragDetails.started || n._setDragDetails("drag", e), n.$.addClass("no-transition"), "object" == typeof e ? (o = e.pageX - n._dragDetails.x, r = e.pageY - n._dragDetails.y) : o = r = e;
      var l = a(n._windowParent.element.clientHeight, n._windowParent.scrollElement.scrollHeight),
          s = a(n._windowParent.element.clientWidth, n._windowParent.scrollElement.scrollWidth);
      "horizontal" === t ? (n._dragDetails.windowX = a(0, i(n._dragDetails.windowX + o, s - n.offsetWidth)), n.style.left = n._dragDetails.windowX + "px") : "vertical" === t ? (n._dragDetails.windowY = a(0, i(n._dragDetails.windowY + r, l - n.offsetHeight)), n.style.top = n._dragDetails.windowY + "px") : "both" === t ? (n._dragDetails.windowX = a(0, i(n._dragDetails.windowX + o, s - n.offsetWidth)), n._dragDetails.windowY = a(0, i(n._dragDetails.windowY + r, l - n.offsetHeight)), n.style.left = n._dragDetails.windowX + "px", n.style.top = n._dragDetails.windowY + "px") : void 0;
      n._dragDetails.top = n.offsetTop, n._dragDetails.left = n.offsetLeft;
    }
  }, {
    key: "_dragStartHandler",
    value: function _dragStartHandler(e) {
      var t = this;
      t._dragDetails && t._dragDetails.started && e.preventDefault();
    }
  }, {
    key: "_focusHandler",
    value: function _focusHandler(e) {
      var t = this;
      "focus" === e.type ? (t.setAttribute("focus", ""), t.bringToFront()) : !t._buttonPressed && (t.removeAttribute("focus"), t._dragDetails && t._dragDetails.started && t._handleWindowResizeDummy());
    }
  }, {
    key: "_getAllMinimizedWindows",
    value: function _getAllMinimizedWindows(e) {
      var t = this;
      var a = [];
      e || (e = t._windowParent.element);
      var n = e.getElementsByTagName("smart-window");

      for (var _o365 = 0; _o365 < n.length; _o365++) {
        n[_o365] !== t && n[_o365].hasAttribute("minimized") && a.push(n[_o365]);
      }

      return a.sort(function (e, t) {
        var i = e.getBoundingClientRect(),
            a = t.getBoundingClientRect();
        return i.right - a.right;
      }), a;
    }
  }, {
    key: "_handleSnapping",
    value: function _handleSnapping(e) {
      var t = this;
      return e ? void (t.disableSnap || t.collapsed || (!t._snapDummy && (t._snapDummy = document.createElement("div"), t._snapDummy.addEventListener("transitionend", function () {
        t._snapDummy.classList.contains("smart-visibility-hidden") && t._snapDummy.parentElement && t._snapDummy.parentElement.removeChild(t._snapDummy);
      })), t._snapDummy.className = "smart-window-snap-" + e + "-feedback", t._snapDummy._position = e, !t._snapDummy.parentElement && t._windowParent.element.appendChild(t._snapDummy))) : void (t._snapDummy && t._snapDummy.parentElement && t._snapDummy.classList.add("smart-visibility-hidden"));
    }
  }, {
    key: "_headerDblCickHandler",
    value: function _headerDblCickHandler(e) {
      var t = this,
          i = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      i !== t.$.headerSection && i !== t.$.header || t.$.maximizeButton && 0 === t.$.maximizeButton.offsetHeight || (t.maximized ? t.restore() : t.maximize());
    }
  }, {
    key: "_isWindowButton",
    value: function _isWindowButton(e) {
      var t = this;

      for (; e;) {
        var _i1028 = e.closest && e.closest(".smart-buttons-container");

        if (_i1028 === t.$.buttonsContainer) break;
        e = e.getRootNode().host;
      }

      if (e) {
        var _i1029 = /smart-(\w+[-]*\w*)-button/ig;
        if (e = e.closest("smart-button"), e && e === t._buttonPressed) return e === t.$.closeButton ? (t.close(), !0) : e === t.$.collapseButton ? (t.collapsed ? t.expand() : t.collapse(), !0) : e === t.$.maximizeButton ? (t.maximized ? t.restore() : t.maximize(), !0) : e === t.$.minimizeButton ? (t.minimized ? t.restore() : t.minimize(), !0) : e === t.$.pinButton ? (t.pinned ? t.unpin() : t.pin(), !0) : _i1029.test(e.className) ? (t.$.fireEvent(Smart.Utilities.Core.toCamelCase(e.className.match(_i1029).toString().replace("smart-", "").replace("-button", "")), {
          button: e
        }), !0) : void 0;
      }
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this;

      if (delete t._changingFocus, !(t.disabled || (t.hasAttribute("dragged") || t.hasAttribute("resized")) && t._mouseManipulation)) {
        e.stopPropagation();

        var _i1030 = "ArrowDown" === e.key || "ArrowRight" === e.key ? 10 : -10,
            _a682 = t.enableShadowDOM && t._windowParent.element.getRootNode() ? t._windowParent.element.getRootNode().activeElement : document.activeElement;

        switch (e.key) {
          case "ArrowUp":
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
            {
              if (t.minimized || _a682 !== t) return;

              var _n513 = -1 < e.key.indexOf("Right") || -1 < e.key.indexOf("Left");

              if (e.preventDefault(), !_n513 && e.altKey) return void ("ArrowUp" === e.key ? t.maximize() : t.restore());
              if (t.maximized) return;
              if (t.$.addClass("no-transition"), e.ctrlKey && "none" !== t.resizeMode && !t.collapsed) return _n513 = -1 === ["horizontal", "vertical", "both"].indexOf(t.resizeMode) ? t.resizeMode : _n513 ? "right" : "bottom", t.hasAttribute("dragged") && t._cancelDragging(e), t.hasAttribute("resized") || t.$.fireEvent("resizeStart", {
                position: {
                  x: e.pageX,
                  y: e.pageY
                }
              }), void t._resize(_n513, _i1030);
              t.pinned || (!t.hasAttribute("dragged") && (t.setAttribute("dragged", ""), t.$.fireEvent("dragStart", {
                left: e.pageX,
                top: e.pageY
              })), t._drag(_i1030, _n513 ? "horizontal" : "vertical")), t.$.removeClass("no-transition");
              break;
            }

          case "Escape":
            -1 < t.headerButtons.indexOf("close") && _a682 === t && t.close();
            break;

          case "p":
            e.altKey && -1 < t.headerButtons.indexOf("pin") && (t.pinned ? t.unpin() : t.pin());
            break;

          case "c":
            e.altKey && -1 < t.headerButtons.indexOf("collapse") && (t.collapsed ? t.expand() : t.collapse());
            break;

          case "m":
            e.altKey && -1 < t.headerButtons.indexOf("minimize") && (t.minimized ? t.restore() : t.minimize());
            break;

          case "Tab":
            t.opened && t.modal && (t._changingFocus = !0);
            break;

          case "Enter":
          case " ":
            {
              var _i1031;

              if (t.shadowRoot || t.isInShadowDOM ? (_i1031 = e.composedPath()[0], t._buttonPressed = _i1031.getRootNode().host) : (_i1031 = e.target.closest && e.target.closest("smart-button"), t._buttonPressed = _i1031), !_i1031) return;
              t._isWindowButton(_i1031), delete t._buttonPressed;
              break;
            }
        }
      }
    }
  }, {
    key: "_keyUpHandler",
    value: function _keyUpHandler(e) {
      var t = this;

      if (e.key) {
        if ("Control" === e.key && t._dragDetails && t.hasAttribute("resized") && !t._mouseManipulation) {
          if (!t._dragDetails.started) return;
          "drag" !== t._dragDetails.type && (t.removeAttribute("resized"), t.$.fireEvent("resizeEnd", {
            left: e.pageX,
            top: e.pageY,
            width: t._dragDetails.newWidth,
            height: t._dragDetails.newHeight
          }), t._handleWindowResizeDummy()), t._dragDetails.started = !1;
        }

        -1 < e.key.indexOf("Arrow") && t.hasAttribute("dragged") && !t._mouseManipulation && t._cancelDragging(e);
      }
    }
  }, {
    key: "_mouseWheelHandler",
    value: function _mouseWheelHandler(e) {
      var t = this;
      return t.disabled || !(t._dragDetails && t._dragDetails.started) ? void 0 : 0 > e.deltaY && 0 >= t._windowParent.scrollElement.scrollTop + e.deltaY ? void (t.style.top = Math.max(0, t._dragDetails.windowY) + "px") : void (0 < e.deltaY && (t._dragDetails.windowY + t.offsetHeight + e.deltaY >= t._windowParent.scrollElement.scrollHeight || t._windowParent.scrollElement.scrollTop + t._windowParent.element.clientHeight === t._windowParent.scrollElement.scrollHeight) || ("drag" === t._dragDetails.type ? (t._dragDetails.windowY += e.deltaY, t.style.top = t._dragDetails.windowY + "px") : (t._dragDetails.height += e.deltaY, t.style.height = t._dragDetails.height + "px")));
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      var t = this;

      if (!(t.disabled || t.collapsed || t.maximized || t.minimized) && (Smart.Utilities.Core.isMobile && !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && t.hasAttribute("dragged") && e.originalEvent.preventDefault(), !t._mouseManipulation) && (-1 < t.$.container.className.indexOf("smart-window-resizing") && (t.$.container.className = "smart-container"), "none" !== t.resizeMode)) {
        var _i1032 = t.getBoundingClientRect(),
            _a683 = !!(e.clientY < _i1032.top + 10),
            _n514 = !!(e.clientY > _i1032.bottom - 10),
            _o366 = !!(e.clientX > _i1032.right - 10),
            _r223 = !!(e.clientX < _i1032.left + 10);

        switch (t.resizeMode) {
          case "none":
            break;

          case "both":
            if (t.resizeIndicator) return void (_n514 && _o366 && t.$.container.classList.add("smart-window-resizing-bottom-right"));
            if (_r223 || _o366) return _a683 ? void (_r223 ? t.$.container.classList.add("smart-window-resizing-top-left") : t.$.container.classList.add("smart-window-resizing-top-right")) : _n514 ? void (_r223 ? t.$.container.classList.add("smart-window-resizing-bottom-left") : t.$.container.classList.add("smart-window-resizing-bottom-right")) : void (_r223 ? t.$.container.classList.add("smart-window-resizing-left") : t.$.container.classList.add("smart-window-resizing-right"));

            if (_a683 || _n514) {
              if (_o366) return void (_a683 ? t.$.container.classList.add("smart-window-resizing-top-right") : t.$.container.classList.add("smart-window-resizing-bottom-right"));
              if (_r223) return void (_a683 ? t.$.container.classList.add("smart-window-resizing-top-left") : t.$.container.classList.add("smart-window-resizing-bottom-left"));
              _a683 ? t.$.container.classList.add("smart-window-resizing-top") : t.$.container.classList.add("smart-window-resizing-bottom");
            }

            break;

          case "horizontal":
            if (t.resizeIndicator) return void (_n514 && _o366 && t.$.container.classList.add("smart-window-resizing-right"));
            if (_r223) return void t.$.container.classList.add("smart-window-resizing-left");
            _o366 && t.$.container.classList.add("smart-window-resizing-right");
            break;

          case "vertical":
            if (t.resizeIndicator) return void (_n514 && _o366 && t.$.container.classList.add("smart-window-resizing-bottom"));
            if (_a683) return void t.$.container.classList.add("smart-window-resizing-top");
            _n514 && t.$.container.classList.add("smart-window-resizing-bottom");
            break;

          case "top":
            if (_a683) {
              if (t.resizeIndicator && !_r223) return;
              t.$.container.classList.add("smart-window-resizing-top");
            }

            break;

          case "bottom":
            if (_n514) {
              if (t.resizeIndicator && !_o366) return;
              t.$.container.classList.add("smart-window-resizing-bottom");
            }

            break;

          case "left":
            if (_r223) {
              if (t.resizeIndicator && !_a683) return;
              t.$.container.classList.add("smart-window-resizing-left");
            }

            break;

          case "right":
            if (_o366) {
              if (t.resizeIndicator && !_n514) return;
              t.$.container.classList.add("smart-window-resizing-right");
            }

        }
      }
    }
  }, {
    key: "_handleActiveState",
    value: function _handleActiveState() {
      var e = this,
          t = document.getElementsByClassName("smart-window");

      for (var _i1033 = 0; _i1033 < t.length; _i1033++) {
        t[_i1033].contains(e) || e.contains(t[_i1033]) || (t[_i1033].removeAttribute("active"), t[_i1033].removeAttribute("focus"));
      }

      e.setAttribute("active", "");
    }
  }, {
    key: "_handleWindowResizeDummy",
    value: function _handleWindowResizeDummy() {
      var e = this;
      return e._resizeDummy || (e._resizeDummy = document.createElement("div"), e._resizeDummy.classList.add("smart-window-resize-feedback")), e.hasAttribute("resized") ? void (e._resizeDummy.parentElement || (e._resizeDummy.style.width = e.offsetWidth + "px", e._resizeDummy.style.height = e.offsetHeight + "px", e._resizeDummy.style.top = e.offsetTop + "px", e._resizeDummy.style.left = e.offsetLeft + "px", e._windowParent.element.appendChild(e._resizeDummy))) : (e._resizeDummy.parentElement && e._resizeDummy.parentElement.removeChild(e._resizeDummy), void (!e.liveResize && "resize" === e._dragDetails.type && e._dragDetails.started && (e.style.top = e._dragDetails.top + "px", e.style.left = e._dragDetails.left + "px", e.style.width = e._dragDetails.newWidth + "px", e.style.height = e._dragDetails.newHeight + "px")));
    }
  }, {
    key: "_resize",
    value: function _resize(e, t) {
      var i = Math.min,
          a = Math.abs,
          n = Math.max;
      var o = this;
      var r;

      if ((!o._dragDetails || o._dragDetails && "drag" === o._dragDetails.type) && o._setDragDetails("resize"), !!o._dragDetails) {
        o._dragDetails.started = !0, o.hasAttribute("resized") || (o.setAttribute("resized", ""), o.hasAnimation && o.$.addClass("no-transition")), o.liveResize || o._handleWindowResizeDummy();

        var _l156 = o._snapDummy && o.$.hasClass("smart-window-snapped-" + o._snapDummy._position) ? "snapWindowWidth" : "width";

        switch (e) {
          case "left":
            {
              r = "object" == typeof t ? t.pageX - o._dragDetails.x : t, r = 0 < r ? i(r, o._dragDetails[_l156] - o._dragDetails.minWidth) : -1 * i(o._dragDetails.maxWidth ? o._dragDetails.maxWidth - o._dragDetails[_l156] : o._dragDetails.left, a(r)), o._dragDetails[_l156] = i(o._dragDetails[_l156] + o._dragDetails.left - o._windowParent.scrollElement.scrollLeft, o._dragDetails[_l156] - r), o._dragDetails.windowX = n(o._windowParent.scrollElement.scrollLeft, o._dragDetails.windowX + r), "object" != typeof t && (o._dragDetails[_l156] = n(o._dragDetails[_l156], o._dragDetails.minWidth)), o._dragDetails[_l156] >= o._dragDetails.minWidth && (o._dragDetails.left = o._dragDetails.windowX, o._dragDetails.newWidth = o._dragDetails[_l156]);
              break;
            }

          case "right":
            {
              var _e1242 = o._windowParent.element.clientWidth === o._windowParent.element.offsetWidth ? 0 : o._windowParent.borderWidth,
                  _a684 = o._snapDummy && o.$.hasClass("smart-window-snapped-" + o._snapDummy._position) ? "snapWindowWidth" : "width";

              r = "object" == typeof t ? t.pageX - o._dragDetails.x : t, 0 < r && o._dragDetails.maxWidth && (r = i(o._dragDetails.maxWidth - o._dragDetails[_a684], r)), o._dragDetails[_a684] = i(o._windowParent.element.clientWidth + o._windowParent.scrollElement.scrollLeft - o._dragDetails.left - _e1242, n(0, o._dragDetails[_a684] + r)), "object" != typeof t && (o._dragDetails[_a684] = n(o._dragDetails[_a684], o._dragDetails.minWidth)), o._dragDetails.left = o.offsetLeft, o._dragDetails.newWidth = n(o._dragDetails.minWidth, o._dragDetails[_a684]);
              break;
            }

          case "top":
            o._snapDummy && o.$.hasClass("smart-window-snapped-" + o._snapDummy._position) && (o._dragDetails.height = o._dragDetails.snapWindowHeight), r = "object" == typeof t ? t.pageY - o._dragDetails.y : t, r = 0 < r ? i(r, o._dragDetails.height - o._dragDetails.minHeight) : -1 * i(o._dragDetails.maxHeight ? o._dragDetails.maxHeight - o._dragDetails.height : o._dragDetails.top, a(r)), o._dragDetails.snapWindowHeight = o._dragDetails.height = i(o._dragDetails.height + o._dragDetails.top - o._windowParent.scrollElement.scrollTop, o._dragDetails.height - r), o._dragDetails.windowY = n(o._windowParent.scrollElement.scrollTop, o._dragDetails.windowY + r), "object" != typeof t && (o._dragDetails.snapWindowHeight = o._dragDetails.height = n(o._dragDetails.height, o._dragDetails.minHeight)), o._dragDetails.height >= o._dragDetails.minHeight && (o._dragDetails.top = o._dragDetails.windowY, o._dragDetails.newHeight = o._dragDetails.height), o._dragDetails.newWidth = n(o._dragDetails[_l156], o._dragDetails.newWidth);
            break;

          case "bottom":
            o._snapDummy && o.$.hasClass("smart-window-snapped-" + o._snapDummy._position) && (o._dragDetails.height = o._dragDetails.snapWindowHeight), r = "object" == typeof t ? t.pageY - o._dragDetails.y : t, 0 < r && o._dragDetails.maxHeight && (r = i(o._dragDetails.maxHeight - o._dragDetails.height, r)), o._dragDetails.snapWindowHeight = o._dragDetails.height = i(o._windowParent.element.clientHeight + o._windowParent.scrollElement.scrollTop - o._dragDetails.top - o._windowParent.borderWidth, n(0, o._dragDetails.height + r)), "object" != typeof t && (o._dragDetails.snapWindowHeight = o._dragDetails.height = n(o._dragDetails.height, o._dragDetails.minHeight)), o._dragDetails.newHeight = n(o._dragDetails.minHeight, o._dragDetails.height), o._dragDetails.newWidth = n(o._dragDetails[_l156], o._dragDetails.newWidth);
            break;

          case "bottomLeftCorner":
            o._resize("bottom", t), o._resize("left", t);
            break;

          case "bottomRightCorner":
            o._resize("bottom", t), o._resize("right", t);
            break;

          case "topLeftCorner":
            o._resize("top", t), o._resize("left", t);
            break;

          case "topRightCorner":
            o._resize("top", t), o._resize("right", t);
        }

        var _s115 = o.liveResize ? o : o._resizeDummy;

        o._dragDetails.newHeight = n(o._dragDetails.snapWindowHeight, o._dragDetails.newHeight), _s115.style.top = o._dragDetails.top + "px", _s115.style.left = o._dragDetails.left + "px", _s115.style.width = o._dragDetails.newWidth + "px", _s115.style.height = o._dragDetails.newHeight + "px";
      }
    }
  }, {
    key: "_restoreFromMinimization",
    value: function _restoreFromMinimization() {
      var e = this;
      e.minimized = !1, e.style.width = e.style.height = e.style.top = e.style.left = "", e._refreshMinimizedWindowsPosition();
    }
  }, {
    key: "_refreshMinimizedWindowsPosition",
    value: function _refreshMinimizedWindowsPosition() {
      var e = this,
          t = e._getAllMinimizedWindows();

      if (0 === t.length) return;
      t[0].style.left = "5px";
      var a;

      for (var _n515 = 1; _n515 < t.length; _n515++) {
        parseFloat(t[_n515 - 1].style.left) + t[_n515 - 1].offsetWidth + t[_n515].offsetWidth + 10 < e._windowParent.element.clientWidth ? (t[_n515].style.left = parseFloat(t[_n515 - 1].style.left) + t[_n515 - 1].offsetWidth + 5 + "px", t[_n515].style.top = t[_n515 - 1].offsetTop + "px", a = t[_n515]) : (t[_n515].style.left = parseFloat(a.style.left) + "px", t[_n515].style.top = a.offsetTop + "px");
      }
    }
  }, {
    key: "_setHeaderButtons",
    value: function _setHeaderButtons() {
      var e = this,
          t = e.headerButtons,
          i = e.$.buttonsContainer.children,
          a = function a(t) {
        var i = e.$.buttonsContainer.getElementsByClassName("smart-" + (t + "").split(/(?=[A-Z])/).join("-").toLowerCase() + "-button")[0];
        return i && i.$.removeClass("smart-hidden"), i;
      };

      for (var _e1243 = 0; _e1243 < i.length; _e1243++) {
        i[_e1243].$.addClass("smart-hidden");
      }

      if (0 < t.length) for (var _n516 = 0, _i1034; _n516 < t.length; _n516++) {
        _i1034 = a(t[_n516]), _i1034 || (_i1034 = document.createElement("smart-button"), _i1034.$.addClass("smart-" + (t[_n516] + "").split(/(?=[A-Z])/).join("-").toLowerCase() + "-button"), _i1034.theme = e.theme), e.$.buttonsContainer.insertBefore(_i1034, e.$.buttonsContainer.firstElementChild);
      }
    }
  }, {
    key: "_setDragDetails",
    value: function _setDragDetails(e, t) {
      var i = this;

      if (i._dragDetails || (i._dragDetails = {}), void 0 === i._dragDetails.minWidth || void 0 === i._dragDetails.minHeight || void 0 === i._dragDetails.maxWidth || void 0 === i._dragDetails.maxHeight) {
        var _e1244 = getComputedStyle(i);

        i._dragDetails.minWidth = parseFloat(_e1244.getPropertyValue("min-width")) || 0, i._dragDetails.minHeight = parseFloat(_e1244.getPropertyValue("min-height")) || 0, i._dragDetails.maxWidth = parseFloat(_e1244.getPropertyValue("max-width")) || 0, i._dragDetails.maxHeight = parseFloat(_e1244.getPropertyValue("max-height")) || 0;
      }

      i._dragDetails.windowX = i.offsetLeft, i._dragDetails.windowY = i.offsetTop;
      var a = i.getBoundingClientRect();

      if (!i._snapDummy || !i.$.hasClass("smart-window-snapped-" + i._snapDummy._position)) {
        var _n517 = i.parentElement === document.body ? document.documentElement.getBoundingClientRect() : i.parentElement.getBoundingClientRect(),
            _o367 = window.scrollX || window.pageXOffset,
            _r224 = window.scrollY || window.pageYOffset;

        i._windowParent.offsetLeft = _n517.left + _o367, i._windowParent.offsetTop = _n517.top + _r224, t && "object" == typeof t && (i._dragDetails.offsetX = t.clientX - a.left, i._dragDetails.offsetY = t.clientY - a.top), i.collapsed || (i.hasAnimation && "minimize" === e ? (i._dragDetails.width = i._dragDetails.width ? i._dragDetails.width : i.offsetWidth, i._dragDetails.height = i._dragDetails.height ? i._dragDetails.height : i.offsetHeight) : (i._dragDetails.width = i.offsetWidth, i._dragDetails.height = i.offsetHeight), (i.style.width || i.style.height) && (i._dragDetails.resized = !0));
      } else "right" === i.headerPosition && i.collapsed && (i._dragDetails.offsetX = a.left + i.offsetWidth - t.clientX);

      if ("minimize" !== e && e && (i._dragDetails.type = e, i._dragDetails.started = !0, i._dragDetails.snapWindowWidth = i.offsetWidth, i._dragDetails.snapWindowHeight = i.offsetHeight, t && "object" == typeof t ? (i._dragDetails.x = t.pageX, i._dragDetails.y = t.pageY) : (i._dragDetails.x = i.offsetLeft, i._dragDetails.y = i.offsetTop), "resize" === e)) {
        if ("none" === i.resizeMode) return void delete i._dragDetails;
        i._dragDetails.top = i.offsetTop, i._dragDetails.left = i.offsetLeft, i._dragDetails.newWidth = i._dragDetails.width, i._dragDetails.newHeight = i._dragDetails.height, i.$container.hasClass("smart-window-resizing-right") ? i._dragDetails.side = "right" : i.$container.hasClass("smart-window-resizing-left") ? i._dragDetails.side = "left" : i.$container.hasClass("smart-window-resizing-top") ? i._dragDetails.side = "top" : i.$container.hasClass("smart-window-resizing-bottom") ? i._dragDetails.side = "bottom" : i.$container.hasClass("smart-window-resizing-top-left") ? i._dragDetails.side = "topLeftCorner" : i.$container.hasClass("smart-window-resizing-bottom-left") ? i._dragDetails.side = "bottomLeftCorner" : i.$container.hasClass("smart-window-resizing-top-right") ? i._dragDetails.side = "topRightCorner" : i.$container.hasClass("smart-window-resizing-bottom-right") && (i._dragDetails.side = "bottomRightCorner");
      }
    }
  }, {
    key: "_setElementParent",
    value: function _setElementParent(e) {
      var t = this;
      if (t._windowParent.element = void 0, t._windowParent.parent && !t._windowParent.parent.querySelectorAll("smart-window, smart-dialog-window, smart-progress-window, smart-wait-window, smart-alert-window, smart-prompt-window, smart-multiline-prompt-window") && (t._windowParent.parent.style.position = ""), e instanceof HTMLElement ? t._windowParent.element = e : "string" == typeof e && (t._windowParent.element = "body" === e ? document.body : document.getElementById(e)), t._windowParent.element || (t._windowParent.element = t._windowParent.initialParent.getRootNode().host || t._windowParent.initialParent.parentElement ? t._windowParent.initialParent : document.body), t.parentElement !== t._windowParent.element && t._windowParent.element.appendChild(t), t._windowParent.element === document.body) t._windowParent.element = document.documentElement, t._windowParent.scrollElement = document.scrollingElement, t._windowParent.parent = document.body, t._windowParent.borderWidth = 0;else {
        if (t.parentElement instanceof Smart.Window && !t.parentElement.isCompleted) return void t.parentElement.whenRendered(function () {
          t.parentElement.appendChild(t), t._setElementParent(t.windowParent);
        });
        t._windowParent.element instanceof Smart.Window && (t._windowParent.element = t._windowParent.element.$.content);

        var _e1245 = getComputedStyle(t.parentElement),
            _i1035 = _e1245.getPropertyValue("position");

        t._windowParent.borderWidth = 2 * parseInt(_e1245.getPropertyValue("border-width") || 0), t._windowParent.parent = t.parentElement, t._windowParent.scrollElement = t._windowParent.element, "relative" !== _i1035 && (t.parentElement.style.position = "relative");
      }
      t._setModal(), t.style.left && t.offsetLeft > t._windowParent.scrollElement.scrollWidth && (t.style.left = t._windowParent.scrollElement.scrollWidth - t.offsetWidth + "px"), t.style.top && t.offsetTop > t._windowParent.scrollElement.scrollHeight && (t.style.top = t._windowParent.scrollElement.scrollHeight - t.offsetHeight + "px");
    }
  }, {
    key: "_setModal",
    value: function _setModal() {
      var e = this;

      if (delete e._changingFocus, !!e._windowParent.element) {
        if (!e.modal) return void (e._modal && e._modal.parentElement && (e._modal.parentElement.removeChild(e._modal), delete e._modal));

        if (e._modal || (e._modal = document.createElement("div"), e._modal.classList.add("smart-modal")), e._windowParent.parent === document.body ? e._modal.removeAttribute("nested-modal") : e._modal.setAttribute("nested-modal", ""), e._modal._window = e, e.opened && !e._modal.parentElement) {
          var _t1026 = parseInt(getComputedStyle(e).getPropertyValue("z-index"));

          isNaN(_t1026) || (e._modal.style.zIndex = _t1026 - 1), e.parentElement.insertBefore(e._modal, e);
        } else e._modal.parentElement && e._modal.parentElement.removeChild(e._modal);
      }
    }
  }, {
    key: "hasStyleObserver",
    get: function get() {
      return !1;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        collapsed: {
          value: !1,
          type: "boolean"
        },
        closeOnMaskClick: {
          value: !1,
          type: "boolean"
        },
        disableSnap: {
          value: !1,
          type: "boolean"
        },
        footerPosition: {
          value: "bottom",
          allowedValues: ["bottom", "none"],
          type: "string"
        },
        footerTemplate: {
          value: null,
          type: "any"
        },
        headerButtons: {
          value: ["close", "maximize", "minimize"],
          type: "array"
        },
        headerPosition: {
          value: "top",
          allowedValues: ["top", "bottom", "left", "right", "none"],
          type: "string"
        },
        headerTemplate: {
          value: null,
          type: "any"
        },
        label: {
          value: "",
          type: "string"
        },
        liveResize: {
          value: !1,
          type: "boolean"
        },
        maximized: {
          value: !1,
          type: "boolean"
        },
        modal: {
          value: !1,
          type: "boolean"
        },
        minimized: {
          value: !1,
          type: "boolean"
        },
        opened: {
          value: !1,
          type: "boolean"
        },
        pinned: {
          value: !1,
          type: "boolean"
        },
        resizeIndicator: {
          value: !1,
          type: "boolean"
        },
        resizeMode: {
          allowedValues: ["none", "horizontal", "vertical", "both", "top", "bottom", "left", "right"],
          value: "none",
          type: "string"
        },
        windowParent: {
          value: null,
          type: "any"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "document.dragstart": "_dragStartHandler",
        "document.focusin": "_documentFocusInEventHandler",
        "document.move": "_documentMoveHandler",
        "document.up": "_documentUpHandler",
        "document.wheel": "_mouseWheelHandler",
        "document.selectstart": "_documentSelectStartHandler",
        down: "_downHandler",
        focus: "_focusHandler",
        blur: "_focusHandler",
        move: "_moveHandler",
        keydown: "_keyDownHandler",
        keyup: "_keyUpHandler",
        stylechanged: "_styleChangedHandler"
      };
    }
  }, {
    key: "styleUrls",
    get: function get() {
      return ["smart.button.css", "smart.window.css"];
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Button": "smart.button.js"
      };
    }
  }]);

  return _class118;
}(Smart.ContentElement)), Smart("smart-dialog-window",
/*#__PURE__*/
function (_Smart$Window) {
  "use strict";

  _inherits(_class119, _Smart$Window);

  function _class119() {
    _classCallCheck(this, _class119);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class119).apply(this, arguments));
  }

  _createClass(_class119, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"headerSection\" class=\"smart-header-section\" role=\"heading\" aria-level=\"1\">\n                        <div id=\"header\" class=\"smart-header\">[[label]]</div>\n                        <div id=\"buttonsContainer\" class=\"smart-buttons-container\">\n                            <smart-button id=\"pinButton\" class=\"smart-pin-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Pin\"></smart-button>\n                            <smart-button id=\"collapseButton\" class=\"smart-collapse-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Collapse\"></smart-button>\n                            <smart-button id=\"minimizeButton\" class=\"smart-minimize-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Minimize\"></smart-button>\n                            <smart-button id=\"maximizeButton\" class=\"smart-maximize-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Maximize\"></smart-button>\n                            <smart-button id=\"closeButton\" class=\"smart-close-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Close\"></smart-button>\n                        </div>\n                    </div>\n                    <div class=\"smart-content\">\n                        <content></content>\n                    </div>\n                    <div id=\"footer\" class=\"smart-footer\">\n                        <smart-button id=\"confirmButton\" class=\"smart-confirm-button\" animation=\"[[animation]]\" theme=\"[[theme]]\">[[confirmLabel]]</smart-button>\n                        <smart-button id=\"cancelButton\" class=\"smart-cancel-button\" animation=\"[[animation]]\" theme=\"[[theme]]\">[[cancelLabel]]</smart-button>\n                    </div>\n                </div>";
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.setAttribute("role", "alertdialog"), e.setAttribute("aria-describedby", e.$.content.id);
    }
  }, {
    key: "_footerClickHandler",
    value: function _footerClickHandler(e) {
      var t = this,
          i = e.target;
      i.closest(".smart-confirm-button") ? t.$.fireEvent("confirm") : i.closest(".smart-cancel-button") && t.$.fireEvent("cancel");
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      var t = this;

      if (delete t._changingFocus, !(t.disabled || (t.hasAttribute("dragged") || t.hasAttribute("resized")) && t._mouseManipulation)) {
        e.stopPropagation();

        var _i1036 = "ArrowDown" === e.key || "ArrowRight" === e.key ? 10 : -10,
            _a685 = t.enableShadowDOM && t._windowParent.element.getRootNode() ? t._windowParent.element.getRootNode().activeElement : document.activeElement;

        switch (e.key) {
          case "ArrowUp":
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
            {
              if (t.minimized || _a685 !== t) return;

              var _n518 = -1 < e.key.indexOf("Right") || -1 < e.key.indexOf("Left");

              if (e.preventDefault(), !_n518 && e.altKey) return void ("ArrowUp" === e.key ? t.maximize() : t.restore());
              if (t.$.addClass("no-transition"), t.maximized) return;
              if (e.ctrlKey && "none" !== t.resizeMode) return t.hasAttribute("dragged") && t._cancelDragging(e), t.hasAttribute("resized") || t.$.fireEvent("resizeStart", {
                position: {
                  x: e.pageX,
                  y: e.pageY
                }
              }), void t._resize(_n518 ? "right" : "bottom", _i1036);
              t.pinned || (!t.hasAttribute("dragged") && (t.setAttribute("dragged", ""), t.$.fireEvent("dragStart", {
                left: e.pageX,
                top: e.pageY
              })), t._drag(_i1036, _n518 ? "horizontal" : "vertical")), t.$.removeClass("no-transition");
              break;
            }

          case "Escape":
            -1 < t.headerButtons.indexOf("close") && _a685 === t && t.close();
            break;

          case "Tab":
            t.opened && t.modal && (t._changingFocus = !0);
            break;

          case "Enter":
          case " ":
            {
              var _i1037;

              if (t.shadowRoot || t.isInShadowDOM ? (_i1037 = e.composedPath()[0], t._buttonPressed = _i1037.getRootNode().host) : (_i1037 = e.target.closest && e.target.closest("smart-button"), t._buttonPressed = _i1037), !_i1037) return;
              t._isWindowButton(_i1037), delete t._buttonPressed;
              break;
            }
        }
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        cancelLabel: {
          value: "Cancel",
          type: "string"
        },
        confirmLabel: {
          value: "Ok",
          type: "string"
        },
        disableSnap: {
          value: !0,
          readOnly: !0,
          type: "boolean"
        },
        headerButtons: {
          value: ["close"],
          type: "array"
        },
        modal: {
          value: !0,
          readOnly: !0,
          type: "boolean",
          defaultReflectToAttribute: !0
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "footer.click": "_footerClickHandler"
      };
    }
  }]);

  return _class119;
}(Smart.Window)), Smart("smart-alert-window",
/*#__PURE__*/
function (_Smart$DialogWindow) {
  "use strict";

  _inherits(_class120, _Smart$DialogWindow);

  function _class120() {
    _classCallCheck(this, _class120);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class120).apply(this, arguments));
  }

  _createClass(_class120, [{
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.setAttribute("role", "alertdialog"), e.setAttribute("aria-describedby", e.$.content.id);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        headerButtons: {
          value: [],
          type: "array"
        }
      };
    }
  }]);

  return _class120;
}(Smart.DialogWindow)), Smart("smart-prompt-window",
/*#__PURE__*/
function (_Smart$DialogWindow2) {
  "use strict";

  _inherits(_class121, _Smart$DialogWindow2);

  function _class121() {
    _classCallCheck(this, _class121);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class121).apply(this, arguments));
  }

  _createClass(_class121, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"headerSection\" class=\"smart-header-section\" role=\"heading\" aria-level=\"1\">\n                        <div id=\"header\" class=\"smart-header\">[[label]]</div>\n                        <div id=\"buttonsContainer\" class=\"smart-buttons-container\">\n                            <smart-button id=\"closeButton\" class=\"smart-close-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Close\"></smart-button>\n                        </div>\n                    </div>\n                    <div class=\"smart-content\">\n                        <content></content>\n                        <smart-text-box id=\"textBox\"\n                            animation=\"[[animation]]\"\n                            auto-complete=\"[[autoComplete]]\"\n                            max-length=\"[[maxLength]]\"\n                            value=\"{{value}}\"\n                            form=\"[[form]]\"\n                            label=\"[[promptLabel]]\"\n                            hint=\"[[hint]]\"\n                            display-mode=\"[[displayMode]]\"\n                            max-length=\"[[maxLength]]\"\n                            placeholder=\"[[placeholder]]\"\n                            required=\"[[required]]\"\n                            required-message=\"[[requiredMessage]]\"\n                            select-all-on-focus=\"[[selectAllOnFocus]]\"\n                            theme=\"[[theme]]\">\n                        </smart-text-box>\n                    </div>\n                    <div id=\"footer\" class=\"smart-footer\">\n                        <smart-button id=\"confirmButton\" class=\"smart-confirm-button flat\" animation=\"[[animation]]\" theme=\"[[theme]]\">[[confirmLabel]]</smart-button>\n                        <smart-button id=\"cancelButton\" class=\"smart-cancel-button flat\" animation=\"[[animation]]\" theme=\"[[theme]]\">[[cancelLabel]]</smart-button>\n                    </div>\n                </div>";
    }
  }, {
    key: "_footerClickHandler",
    value: function _footerClickHandler(e) {
      var t = this,
          i = e.target;
      i.closest(".smart-confirm-button") ? t.$.fireEvent("confirm", {
        value: t.$.textBox.value
      }) : i.closest(".smart-cancel-button") && t.$.fireEvent("cancel", {
        value: t.$.textBox.value
      });
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      function t() {
        i._dragDetails && (i._dragDetails.started = !1), i.$.removeClass("no-transition");
      }

      var i = this;

      if (delete i._changingFocus, !(i.disabled || i._dragDetails && i._dragDetails.started)) {
        e.stopPropagation();

        var _a686 = "ArrowDown" === e.key || "ArrowRight" === e.key ? 10 : -10,
            _n519 = i.enableShadowDOM && i._windowParent.element.getRootNode() ? i._windowParent.element.getRootNode().activeElement : document.activeElement;

        switch (i.$.removeClass("no-transition"), e.key) {
          case "ArrowUp":
          case "ArrowDown":
            if (_n519 !== i) return;
            if (e.preventDefault(), e.altKey) return "ArrowUp" === e.key ? i.maximize() : i.restore(), void t();
            if (i.$.addClass("no-transition"), e.ctrlKey) return i._resize("bottom", _a686), void t();

            i._drag(_a686, "vertical");

            break;

          case "ArrowLeft":
          case "ArrowRight":
            if (_n519 !== i) return;
            if (e.preventDefault(), i.$.addClass("no-transition"), e.ctrlKey) return i._resize("right", _a686), void t();
            i._drag(_a686, "horizontal"), i.$.removeClass("no-transition");
            break;

          case "Escape":
            -1 < i.headerButtons.indexOf("close") && _n519 === i && i.close();
            break;

          case "Tab":
            i.opened && i.modal && (i._changingFocus = !0);
            break;

          case "Enter":
          case " ":
            {
              var _t1027;

              if (i.shadowRoot || i.isInShadowDOM ? (_t1027 = e.composedPath()[0], i._buttonPressed = _t1027.getRootNode().host) : (_t1027 = e.target.closest && e.target.closest("smart-button"), i._buttonPressed = _t1027), !_t1027) return;
              i._isWindowButton(_t1027), delete i._buttonPressed;
              break;
            }
        }

        t();
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoComplete: {
          allowedValues: ["none", "manual", "auto", "inline"],
          type: "string",
          value: "manual"
        },
        confirmLabel: {
          value: "Ok",
          type: "string"
        },
        cancelLabel: {
          value: "Cancel",
          type: "string"
        },
        disableSnap: {
          value: !0,
          readOnly: !0,
          type: "boolean"
        },
        displayMode: {
          value: "default",
          allowedValues: ["default", "escaped"],
          type: "string"
        },
        headerButtons: {
          value: ["close"],
          type: "array"
        },
        form: {
          value: "",
          type: "string"
        },
        hint: {
          value: null,
          type: "any?"
        },
        maxLength: {
          value: null,
          type: "number?"
        },
        minLength: {
          value: 2,
          type: "number"
        },
        messages: {
          extend: !0,
          value: {
            en: {
              missingReference: "{{elementType}}: Missing reference to {{files}}."
            }
          },
          type: "object"
        },
        modal: {
          value: !0,
          readOnly: !0,
          type: "boolean",
          defaultReflectToAttribute: !0
        },
        name: {
          value: "",
          type: "string"
        },
        placeholder: {
          value: "",
          type: "string"
        },
        promptLabel: {
          value: "",
          type: "string?"
        },
        required: {
          value: !1,
          type: "boolean"
        },
        requiredMessage: {
          value: "",
          type: "string"
        },
        selectAllOnFocus: {
          value: !1,
          type: "boolean"
        },
        value: {
          value: "",
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "footer.click": "_footerClickHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.TextBox": "smart.textbox.js"
      };
    }
  }]);

  return _class121;
}(Smart.DialogWindow)), Smart("smart-multiline-prompt-window",
/*#__PURE__*/
function (_Smart$PromptWindow) {
  "use strict";

  _inherits(_class122, _Smart$PromptWindow);

  function _class122() {
    _classCallCheck(this, _class122);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class122).apply(this, arguments));
  }

  _createClass(_class122, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"headerSection\" class=\"smart-header-section\" role=\"heading\" aria-level=\"1\">\n                        <div id=\"header\" class=\"smart-header\">[[label]]</div>\n                        <div id=\"buttonsContainer\" class=\"smart-buttons-container\">\n                            <smart-button id=\"closeButton\" class=\"smart-close-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Close\"></smart-button>\n                        </div>\n                    </div>\n                    <div class=\"smart-content\">\n                        <content></content>\n                       <smart-multiline-text-box id=\"textBox\"\n                            animation=\"[[animation]]\"\n                            horizontal-scroll-bar-visibility= \"[[horizontalScrollBarVisibility]]\"\n                            vertical-scroll-bar-visibility= \"[[verticalScrollBarVisibility]]\"\n                            auto-capitalize=\"[[autoCapitalize]]\"\n                            auto-expand = \"[[autoExpand]]\"\n                            selection-direction= \"[[selectionDirection]]\"\n                            selection-end= \"[[selectionEnd]]\"\n                            selection-start=\"[[selectionStart]]\"\n                            spell-check= \"[[spellCheck]]\"\n                            wrap=\"[[wrap]]\"\n                            max-length=\"[[maxLength]]\"\n                            value=\"{{value}}\"\n                            form=\"[[form]]\"\n                            label=\"[[promptLabel]]\"\n                            hint=\"[[hint]]\"\n                            display-mode=\"[[displayMode]]\"\n                            max-length=\"[[maxLength]]\"\n                            placeholder=\"[[placeholder]]\"\n                            required=\"[[required]]\"\n                            required-message=\"[[requiredMessage]]\"\n                            select-all-on-focus=\"[[selectAllOnFocus]]\"\n                            theme=\"[[theme]]\">\n                       </smart-multiline-text-box>\n                    </div>\n                    <div id=\"footer\" class=\"smart-footer\">\n                        <smart-button id=\"confirmButton\" class=\"smart-confirm-button flat\" animation=\"[[animation]]\" theme=\"[[theme]]\">[[confirmLabel]]</smart-button>\n                        <smart-button id=\"cancelButton\" class=\"smart-cancel-button flat\" animation=\"[[animation]]\" theme=\"[[theme]]\">[[cancelLabel]]</smart-button>\n                    </div>\n                </div>";
    }
  }, {
    key: "_footerClickHandler",
    value: function _footerClickHandler(e) {
      var t = this,
          i = e.target;
      i.closest(".smart-confirm-button") ? t.$.fireEvent("confirm", {
        value: t.$.textBox.value
      }) : i.closest(".smart-cancel-button") && t.$.fireEvent("cancel", {
        value: t.$.textBox.value
      });
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        autoCapitalize: {
          value: "none",
          allowedValues: ["none", "words", "characters"],
          type: "string"
        },
        autoExpand: {
          value: !1,
          type: "boolean"
        },
        headerButtons: {
          value: ["close"],
          type: "array"
        },
        horizontalScrollBarVisibility: {
          type: "string",
          value: "auto",
          allowedValues: ["auto", "disabled", "hidden", "visible"]
        },
        modal: {
          value: !0,
          readOnly: !0,
          type: "boolean",
          defaultReflectToAttribute: !0
        },
        selectionDirection: {
          value: "none",
          allowedValues: ["forward", "backward", "none"],
          type: "string"
        },
        selectionEnd: {
          value: 0,
          reflectToAttribute: !1,
          type: "number"
        },
        selectionStart: {
          value: 0,
          reflectToAttribute: !1,
          type: "number"
        },
        spellCheck: {
          value: !1,
          type: "boolean"
        },
        verticalScrollBarVisibility: {
          type: "string",
          value: "auto",
          allowedValues: ["auto", "disabled", "hidden", "visible"]
        },
        wrap: {
          value: "soft",
          allowedValues: ["hard", "soft", "off"],
          type: "string"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "footer.click": "_footerClickHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.MultilineTextBox": "smart.multilinetextbox.js"
      };
    }
  }]);

  return _class122;
}(Smart.PromptWindow)), Smart("smart-progress-window",
/*#__PURE__*/
function (_Smart$Window2) {
  "use strict";

  _inherits(_class123, _Smart$Window2);

  function _class123() {
    _classCallCheck(this, _class123);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class123).apply(this, arguments));
  }

  _createClass(_class123, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"headerSection\" class=\"smart-header-section\" role=\"heading\" aria-level=\"1\">\n                        <div id=\"header\" class=\"smart-header\">[[label]]</div>\n                        <div id=\"buttonsContainer\" class=\"smart-buttons-container\">\n                            <smart-button id=\"closeButton\" class=\"smart-close-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Close\"></smart-button>\n                        </div>\n                    </div>\n                    <div class=\"smart-content\" inner-h-t-m-l=\"[[innerHTML]]\">\n                        <content></content>\n                    </div>\n                    <div id=\"footer\" class=\"smart-footer\">\n                        <smart-progress-bar id=\"progressBar\"\n                            animation=\"[[animation]]\"\n                            min=\"[[min]]\"\n                            max=\"[[max]]\"\n                            indeterminate=\"[[inditerminate]]\"\n                            inverted=\"[[inverted]]\"\n                            format-function=\"[[formatFunction]]\"\n                            show-progress-value=\"[[showProgressValue]]\"\n                            theme=\"[[theme]]\"\n                            value=\"{{value}}\">\n                        </smart-progress-bar>\n                        <smart-button id=\"completeButton\" class=\"smart-complete-button smart-visibility-hidden\" animation=\"[[animation]]\" theme=\"[[theme]]\">[[completeLabel]]</smart-button>\n                    </div>\n                </div>";
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch (e) {
        case "value":
          a._handleCompletion();

          break;

        default:
          _get(_getPrototypeOf(_class123.prototype), "propertyChangedHandler", this).call(this, e, t, i);

      }
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.setAttribute("role", "dialog"), e._handleCompletion();
    }
  }, {
    key: "_handleCompletion",
    value: function _handleCompletion() {
      var e = this;
      e.$.completeButton && (e.value >= e.max ? (e.$completeButton.removeClass("smart-visibility-hidden"), e.$progressBar.addClass("smart-visibility-hidden")) : (e.$completeButton.addClass("smart-visibility-hidden"), e.$progressBar.removeClass("smart-visibility-hidden")));
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      function t() {
        i._dragDetails && (i._dragDetails.started = !1), i.$.removeClass("no-transition");
      }

      var i = this;

      if (delete i._changingFocus, !(i.disabled || i._dragDetails && i._dragDetails.started)) {
        e.stopPropagation();

        var _a687 = "ArrowDown" === e.key || "ArrowRight" === e.key ? 10 : -10,
            _n520 = i.enableShadowDOM && i._windowParent.element.getRootNode() ? i._windowParent.element.getRootNode().activeElement : document.activeElement;

        switch (i.$.removeClass("no-transition"), e.key) {
          case "ArrowUp":
          case "ArrowDown":
            if (_n520 !== i) return;
            if (e.preventDefault(), e.altKey) return "ArrowUp" === e.key ? i.maximize() : i.restore(), void t();
            if (i.$.addClass("no-transition"), e.ctrlKey) return i._resize("bottom", _a687), void t();
            i._drag(_a687, "vertical"), i.$.removeClass("no-transition");
            break;

          case "ArrowLeft":
          case "ArrowRight":
            if (_n520 !== i) return;
            if (e.preventDefault(), i.$.addClass("no-transition"), e.ctrlKey) return i._resize("right", _a687), void t();
            i._drag(_a687, "horizontal"), i.$.removeClass("no-transition");
            break;

          case "Escape":
            -1 < i.headerButtons.indexOf("close") && _n520 === i && i.close();
            break;

          case "Tab":
            i.opened && i.modal && (i._changingFocus = !0);
            break;

          case "Enter":
          case " ":
            {
              var _t1028;

              if (i.shadowRoot || i.isInShadowDOM ? (_t1028 = e.composedPath()[0], i._buttonPressed = _t1028.getRootNode().host) : (_t1028 = e.target.closest && e.target.closest("smart-button"), i._buttonPressed = _t1028), !_t1028) return;
              i._isWindowButton(_t1028), delete i._buttonPressed;
              break;
            }
        }

        t();
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        completeLabel: {
          value: "Continue",
          type: "string"
        },
        disableSnap: {
          value: !0,
          readOnly: !0,
          type: "boolean"
        },
        headerButtons: {
          value: ["close"],
          type: "array"
        },
        indeterminate: {
          value: !1,
          type: "boolean"
        },
        inverted: {
          value: !1,
          type: "boolean"
        },
        formatFunction: {
          value: null,
          type: "function"
        },
        max: {
          value: 100,
          type: "number"
        },
        modal: {
          value: !0,
          readOnly: !0,
          type: "boolean",
          defaultReflectToAttribute: !0
        },
        min: {
          value: 0,
          type: "number"
        },
        showProgressValue: {
          value: !1,
          type: "boolean"
        },
        value: {
          value: 0,
          type: "number?"
        }
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.ProgressBar": "smart.progressbar.js"
      };
    }
  }]);

  return _class123;
}(Smart.Window)), Smart("smart-tabs-window",
/*#__PURE__*/
function (_Smart$Window3) {
  "use strict";

  _inherits(_class124, _Smart$Window3);

  function _class124() {
    _classCallCheck(this, _class124);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class124).apply(this, arguments));
  }

  _createClass(_class124, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"headerSection\" class=\"smart-header-section\" role=\"heading\" aria-level=\"1\">\n                        <div id=\"header\" class=\"smart-header\">[[label]]</div>\n                        <div id=\"buttonsContainer\" class=\"smart-buttons-container\">\n                            <smart-button id=\"minimizeButton\" class=\"smart-minimize-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Minimize\"></smart-button>\n                            <smart-button id=\"maximizeButton\" class=\"smart-maximize-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Maximize\"></smart-button>\n                            <smart-button id=\"closeButton\" class=\"smart-close-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Close\"></smart-button>\n                        </div>\n                    </div>\n                    <div id=\"contentSection\" class=\"smart-content\">\n                       <smart-tabs id=\"tabsElement\"\n                            animation=\"[[animation]]\"\n                            add-new-tab=\"[[addNewTab]]\"\n                            allow-toggle=\"[[allowToggle]]\"\n                            close-button-mode=\"[[tabCloseButtonMode]]\"\n                            close-buttons=\"[[tabCloseButtons]]\"\n                            disabled=\"[[disabled]]\"\n                            overflow=\"[[tabOverflow]]\"\n                            reorder=\"[[tabReorder]]\"\n                            resize=\"[[tabResize]]\"\n                            scroll-buttons-position=\"[[tabScrollButtonsPosition]]\"\n                            selected-index=\"{{selectedIndex}}\"\n                            selection-mode=\"[[selectionMode]]\"\n                            tab-layout=\"[[tabLayout]]\"\n                            tab-position=\"[[tabPosition]]\"\n                            tab-text-orientation=\"[[tabTextOrientation]]\"\n                            theme=\"[[theme]]\">\n                            <content></content>\n                        </smart-tabs>\n                    </div>\n                    <div id=\"footer\" class=\"smart-footer smart-hidden\"></div>\n                </div>";
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1246 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.appendChild.apply(t, _e1246.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? void (!(e instanceof Smart.TabItem) && t.error(t.localize("tabItemRequired", {
        method: "removeChild"
      })), t.$.tabsElement.appendChild(e)) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "appendChild",
        node: "node"
      }));
    }
  }, {
    key: "insert",
    value: function insert(e, t) {
      this.$.tabsElement.insert(e, t);
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(e, t) {
      this.$.tabsElement.insertBefore(e, t);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      this.$.tabsElement.remove(e);
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this;

      if (!t.isCompleted || e instanceof HTMLElement && e.classList.contains("smart-resize-trigger-container")) {
        var _e1247 = Array.prototype.slice.call(arguments, 2);

        return HTMLElement.prototype.removeChild.apply(t, _e1247.concat(Array.prototype.slice.call(arguments)));
      }

      return e ? void (!(e instanceof Smart.TabItem) && t.error(t.localize("tabItemRequired", {
        method: "removeChild"
      })), !(t.shadowRoot || t).contains(e) && t.error(t.localize("referenceNodeNotChild", {
        argument: "node"
      })), t.$.tabsElement.removeChild(e)) : void t.error(t.localize("invalidNode", {
        elementType: t.nodeName.toLowerCase(),
        method: "removeChild",
        node: "node"
      }));
    }
  }, {
    key: "refreshTabHeader",
    value: function refreshTabHeader() {
      var e = this;
      e.$.tabsElement && e.$.tabsElement.isCompleted && e.$.tabsElement.refreshTabHeader();
    }
  }, {
    key: "refreshTabs",
    value: function refreshTabs() {
      var e = this;
      e.$.tabsElement && e.$.tabsElement.isCompleted && e.$.tabsElement._applyTabOverflow();
    }
  }, {
    key: "select",
    value: function select(e) {
      this.$.tabsElement.select(e);
    }
  }, {
    key: "update",
    value: function update(e, t, i) {
      this.$.tabsElement.update(e, t, i);
    }
  }, {
    key: "propertyChangedHandler",
    value: function propertyChangedHandler(e, t, i) {
      var a = this;

      switch ("collapsed" !== e && _get(_getPrototypeOf(_class124.prototype), "propertyChangedHandler", this).call(this, e, t, i), e) {
        case "theme":
          "" !== t && (a.$.closeButton.classList.remove(t), a.$.collapseButton.classList.remove(t), a.$.maximizeButton.classList.remove(t), a.$.pinButton.classList.remove(t)), a._applyTheme(i);
          break;

        case "autoHideWindow":
          a._handleAutoHideWindow();

          break;

        case "autoHide":
          i || (null !== a.$.tabsElement.selectedIndex && (a.$.tabsElement._tabs[a.$.tabsElement.selectedIndex]._autoHideWindowSize = void 0), a._autoHideWindow && a._autoHideWindow.close());
          break;

        case "dataSource":
          a.$.tabsElement.dataSource = i;
          break;

        case "layout":
          a._handleLayoutProperty();

          break;

        case "collapsible":
        case "collapsed":
        case "locked":
        case "max":
        case "min":
        case "size":
          {
            var _n521 = (a.isInShadowDOM ? a.getRootNode().host : a || a).closest("smart-docking-layout"),
                _o368 = a.closest("smart-splitter-item");

            if (!_n521) return void ("collapsed" === e && _get(_getPrototypeOf(_class124.prototype), "propertyChangedHandler", this).call(this, e, t, i));
            _o368 && (_o368[e] = i);
            break;
          }
      }
    }
  }, {
    key: "_applyTheme",
    value: function _applyTheme(e) {
      var t = this;

      if ("" !== e) {
        var _a688 = t.$.buttonsContainer.children;

        for (var _t1029 = 0; _t1029 < _a688.length; _t1029++) {
          _a688[_t1029].classList.add(e);
        }
      }
    }
  }, {
    key: "_autoHideWindowCloseHandler",
    value: function _autoHideWindowCloseHandler() {
      var e = this;
      e.allowToggle && null !== e.$.tabsElement.selectedIndex && e.$.tabsElement.select(e.$.tabsElement.selectedIndex), e._autoHideWindow && e._moveContent(e._autoHideWindow.items[0], e._autoHideWindow._tab);
    }
  }, {
    key: "_autoHideWindowOpenHandler",
    value: function _autoHideWindowOpenHandler() {
      var e = this;
      e.$.tabsElement.selectedIndex && e._handleAutoHide(e.$.tabsElement.selectedIndex);
    }
  }, {
    key: "_createElement",
    value: function _createElement() {
      var e = this;
      e.setAttribute("role", "dialog"), e.$.tabsElement.$.tabHeaderControls && !e.$.tabsElement.$.tabHeaderControls.innerHTML && e.$.tabsElement.$tabHeaderControls.addClass("smart-hidden"), e.$.tabsElement.dataSource = e.dataSource, e._applyTheme(e.theme), e._handleAutoHideWindow(), e.autoHide && e._handleAutoHide(e.$.tabsElement.selectedIndex), e.allowToggle || e.selectedIndex || null === e.$.tabsElement.selectedIndex || (e.selectedIndex = e.$.tabsElement.selectedIndex, e.$.tabsElement.setAttribute("selected-index", e.selectedIndex)), e._handleLayoutProperty();
      var t = (e.isInShadowDOM ? e.getRootNode().host : e || e).closest("smart-docking-layout"),
          i = e.closest("smart-splitter-item");
      t && i && (i.collapsible = e.collapsible, i.collapsed = e.collapsed, i.min = e.min, i.max = e.max, i.size = e.size, i.locked = e.locked);
    }
  }, {
    key: "_handleLayoutProperty",
    value: function _handleLayoutProperty() {
      var e = this;
      var t = e.closest("smart-docking-layout");

      if (Smart.DockingLayout) {
        if (!e.ownerLayout && e.getRootNode()) for (var _i1038 = e.getRootNode().host; _i1038;) {
          if (!_i1038.closest) return;

          if (_i1038.closest("smart-docking-layout")) {
            t = _i1038.closest("smart-docking-layout");
            break;
          }

          _i1038 = _i1038.getRootNode() ? _i1038.getRootNode().host : void 0;
        }
        return t ? void (e.layout = t) : void (e.layout instanceof Smart.DockingLayout || "string" == typeof e.layout && (e.layout = document.getElementById(e.layout)));
      }
    }
  }, {
    key: "_headerDblCickHandler",
    value: function _headerDblCickHandler(e) {
      var t = this,
          i = t.shadowRoot || t.isInShadowDOM ? e.originalEvent.composedPath()[0] : e.originalEvent.target;
      e.ctrlKey || i !== t.$.headerSection && i !== t.$.header || t.$.maximizeButton && 0 === t.$.maximizeButton.offsetHeight || (t.maximized ? t.restore() : t.maximize());
    }
  }, {
    key: "_documentUpHandler",
    value: function _documentUpHandler(e) {
      var t = this;
      var i = e.originalEvent.target.closest ? e.originalEvent.target.closest(".smart-window") : e.originalEvent.target,
          a = i === t || i === t._autoHideWindow || t._isAutoHideWindowClicked,
          n = t.closest("smart-docking-layout");
      return ((t.shadowRoot || t.isInShadowDOM) && (i = e.originalEvent.composedPath()[0], a = i.getRootNode() === t.shadowRoot || i.closest(".smart-window") === t || i.closest(".smart-window") === t._autoHideWindow || t._isAutoHideWindowClicked), n = ((t.isInShadowDOM ? t.getRootNode().host : t) || t).closest("smart-docking-layout"), n && n.disabled) ? void delete t._isWindowContentClicked : void (_get(_getPrototypeOf(_class124.prototype), "_documentUpHandler", this).call(this, e), delete t._isAutoHideWindowClicked, t.autoHide && t._autoHideWindow && (a && t._autoHideWindow.opened || (t.selectedIndex = null, t._autoHideWindow.parentElement && t._autoHideWindow.parentElement.closest(".smart-window") === t && t._autoHideWindow.close())));
    }
  }, {
    key: "_handleAutoHide",
    value: function _handleAutoHide(e) {
      var t = this;

      if (t.autoHide && null !== e && (t._autoHideWindow || t._handleAutoHideWindow(!0), !!t._autoHideWindow)) {
        t._autoHideWindow._tabsWindow && t._autoHideWindow._tabsWindow !== t && (t._autoHideWindow._tabsWindow.selectedIndex = null);
        var _i1039 = t.$.tabsElement._tabs[e];
        t._autoHideWindow._tab !== _i1039 && t._moveContent(t._autoHideWindow.items[0], t._autoHideWindow._tab), t._autoHideWindow.label = _i1039.label, t._autoHideWindow.draggable = _i1039.draggable, t._autoHideWindow.floatable = _i1039.floatable, t._autoHideWindow._tab = _i1039, t._moveContent(t._autoHideWindow._tab, t._autoHideWindow.items[0]), t._autoHideWindow.bringToFront(), t._setAutoHideWindowSize(e), t._autoHideWindow.open(), t._autoHideWindow._tabsWindow = t;
      }
    }
  }, {
    key: "_moveHandler",
    value: function _moveHandler(e) {
      var t = this,
          i = t.closest("smart-docking-layout");

      if (i) {
        var _e1248 = i.items;
        if (-1 < _e1248.indexOf(t)) return;
      }

      Smart.Utilities.Core.isMobile && !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && t.layout instanceof Smart.DockingLayout && t.layout.hasAttribute("dragged") && e.originalEvent.preventDefault(), _get(_getPrototypeOf(_class124.prototype), "_moveHandler", this).call(this, e);
    }
  }, {
    key: "_setAutoHideWindowSize",
    value: function _setAutoHideWindowSize(e) {
      var t = Math.min;
      var i = this;

      if (i._autoHideWindow) {
        i._autoHideWindow.$.addClass("no-transition"), i._autoHideWindow.style.maxWidth = i._autoHideWindow.style.maxHeight = "";

        var _a689 = i.$.tabsElement._tabs[e],
            _n522 = (i._autoHideWindow.isInShadowDOM ? i._autoHideWindow.getRootNode().host : i._autoHideWindow).closest("smart-docking-layout") || i._autoHideWindow.parentElement,
            _o369 = _n522.getBoundingClientRect(),
            _r225 = i.$.tabsElement.getBoundingClientRect();

        if (_a689) {
          if ("top" === i.tabPosition || "bottom" === i.tabPosition) {
            i._autoHideWindow.resizeMode = "top" === i.tabPosition ? "bottom" : "top", i._autoHideWindow.style.width = i.$.tabsElement.offsetWidth + "px";

            var _e1249 = _a689._autoHideWindowSize ? parseFloat(_a689._autoHideWindowSize) || "" : "";

            Smart.DockingLayout && _n522 instanceof Smart.DockingLayout && (_e1249 && (_e1249 = t(_n522.$.itemsContainer.offsetHeight, _e1249) + "px"), i._autoHideWindow.style.maxHeight = _n522.$.itemsContainer.offsetHeight + "px"), i._autoHideWindow.style.height = _e1249, i._autoHideWindow.style.left = _r225.left - _o369.left + "px", i._autoHideWindow && ("top" === i.tabPosition ? i._autoHideWindow.style.top = _r225.top + -_o369.top + _r225.height + "px" : i._autoHideWindow.style.top = _r225.top - _o369.top - i._autoHideWindow.offsetHeight + "px");
          } else {
            i._autoHideWindow.resizeMode = "left" === i.tabPosition ? "right" : "left", i._autoHideWindow.style.height = i.$.tabsElement.offsetHeight + "px";

            var _e1250 = _a689._autoHideWindowSize ? parseFloat(_a689._autoHideWindowSize) || "" : "";

            _n522 instanceof Smart.DockingLayout && (_e1250 && (_e1250 = t(_n522.$.itemsContainer.offsetWidth, _e1250) + "px"), i._autoHideWindow.style.maxWidth = _n522.$.itemsContainer.offsetWidth + "px"), i._autoHideWindow.style.width = _e1250, i._autoHideWindow.style.top = _r225.top - _o369.top + "px", i._autoHideWindow.style.left = "left" === i.tabPosition ? _r225.left - _o369.left + i.$.tabsElement.offsetWidth + "px" : _r225.left - _o369.left - i._autoHideWindow.offsetWidth + "px";
          }

          i._autoHideWindow._dragDetails && (i._autoHideWindow._dragDetails.maxWidth = void 0), i._autoHideWindow._setDragDetails("resize"), i._autoHideWindow._dragDetails.started = !1, i._autoHideWindow.$.removeClass("no-transition");
        }
      }
    }
  }, {
    key: "_handleAutoHideWindow",
    value: function _handleAutoHideWindow(e) {
      var t = this;

      if (t.autoHideWindow) {
        if (t._autoHideWindow && t._autoHideWindow.parentElement.removeChild(t._autoHideWindow), "string" == typeof t.autoHideWindow) return void (t._autoHideWindow = document.getElementById(t.autoHideWindow));
        if (t.autoHideWindow instanceof Smart.Window) return void (t._autoHideWindow = t.autoHideWindow);
      }

      if (!(!e || t._autoHideWindow || 2 === t.$.contentSection.children.length && t.$.contentSection.children[1] instanceof Smart.Window)) {
        var _e1251 = document.createElement("smart-window");

        _e1251.$ = Smart.Utilities.Extend(_e1251), _e1251.disableSnap = _e1251.pinned = !0, _e1251.headerButtons = ["close"], t.$.contentSection.appendChild(_e1251), t._autoHideWindow = _e1251;
      }
    }
  }, {
    key: "_moveContent",
    value: function _moveContent(e, t) {
      if (e && t) {
        var _a690 = [].slice.call(e.$.content.childNodes);

        for (var _e1252 = 0; _e1252 < _a690.length; _e1252++) {
          t.appendChild(_a690[_e1252]);
        }
      }
    }
  }, {
    key: "_tabsChangeHandler",
    value: function _tabsChangeHandler(e) {
      var t = this;

      if (e.target === t.$.tabsElement && t.autoHide) {
        if (t._autoHideWindow || t._handleAutoHideWindow(!0), null !== e.detail.oldIndex && t._autoHideWindow.opened) {
          var _i1040 = t.$.tabsElement._tabs[e.detail.oldIndex];
          _i1040._autoHideWindowSize = t._autoHideWindow.style["right" === t.$.tabsElement.tabPosition || "left" === t.$.tabsElement.tabPosition ? "width" : "height"];
        }

        return t.autoHide && null !== e.detail.index && void 0 !== e.detail.index ? void t._handleAutoHide(e.detail.index) : (t._autoHideWindow.setAttribute("active", ""), void t._autoHideWindow.close());
      }
    }
  }, {
    key: "_tabsFocusHandler",
    value: function _tabsFocusHandler(e) {
      var t = this;
      "focus" === e.type ? (t.bringToFront(), t.setAttribute("focus", "")) : t.removeAttribute("focus");
    }
  }, {
    key: "items",
    get: function get() {
      var e = this;
      return e.isCompleted && e.$.tabsElement ? this.$.tabsElement._tabs : void 0;
    }
  }, {
    key: "itemLabels",
    get: function get() {
      var e = this;
      return e.$ ? this.$.tabsElement._tabLabelContainers : void 0;
    }
  }, {
    key: "siblings",
    get: function get() {
      var e = this;
      var t = [];
      if (!e.isCompleted) return t;
      var i = e.closest("smart-splitter");
      if (!i || !i.closest("smart-docking-layout")) return t;
      var a = i._items;
      if (!a || !a.length) return t;

      for (var _n523 = 0; _n523 < a.length; _n523++) {
        var _o370 = a[_n523];

        if (_o370 !== e.closest("smart-splitter-item")) {
          var _e1253 = _o370.querySelector("smart-tabs-window");

          _e1253.closest("smart-splitter") === i && t.push(_o370.querySelector("smart-tabs-window"));
        }
      }

      return t;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        disableSnap: {
          value: !0,
          readOnly: !0,
          type: "boolean"
        },
        dropPosition: {
          value: ["all"],
          type: "array"
        },
        addNewTab: {
          value: !1,
          type: "boolean"
        },
        allowToggle: {
          value: !1,
          type: "boolean"
        },
        autoHide: {
          value: !1,
          type: "boolean"
        },
        autoHideWindow: {
          value: null,
          type: "any"
        },
        dataSource: {
          value: null,
          type: "array?",
          reflectToAttribute: !1
        },
        tabCloseButtonMode: {
          value: "default",
          allowedValues: ["default", "selected"],
          type: "string"
        },
        tabCloseButtons: {
          value: !1,
          type: "boolean"
        },
        messages: {
          value: {
            en: {
              ambiguousIndexes: "smart-tabs: Initially set smart-tab-item indexes are ambiguous and are ignored in favour of the HTML structure.",
              detailsObjectRequired: "smart-tabs: The method \"insert\" requires a details Object to be passed as a second argument.",
              invalidIndex: "smart-tabs: \"{{method}}\" method accepts an index of type number.",
              referenceNodeNotChild: "smart-tabs: Passed {{argument}} is not part of this smart-tabs element.",
              tabItemRequired: "smart-tabs: The method \"{{method}}\" requires a \"smart-tab-item\" element to be passed as an argument."
            }
          },
          type: "object",
          extend: !0
        },
        tabOverflow: {
          value: "auto",
          allowedValues: ["auto", "hidden", "scroll"],
          type: "string"
        },
        tabReorder: {
          value: !1,
          type: "boolean"
        },
        tabResize: {
          value: !1,
          type: "boolean"
        },
        tabScrollButtonsPosition: {
          value: "both",
          allowedValues: ["near", "far", "both"],
          type: "string"
        },
        selectedIndex: {
          value: null,
          type: "number?"
        },
        selectionMode: {
          value: "click",
          allowedValues: ["click", "dblclick", "mouseenter", "none"],
          type: "string"
        },
        collapsed: {
          value: !1,
          type: "boolean"
        },
        collapsible: {
          value: !1,
          type: "boolean"
        },
        locked: {
          value: !1,
          type: "boolean"
        },
        max: {
          value: "",
          type: "any"
        },
        min: {
          value: "",
          type: "any"
        },
        size: {
          value: "",
          type: "any"
        },
        tabLayout: {
          value: "scroll",
          allowedValues: ["scroll", "dropdown", "wrap", "shrink"],
          type: "string",
          defaultReflectToAttribute: !0
        },
        tabPosition: {
          value: "top",
          allowedValues: ["top", "bottom", "left", "right", "hidden"],
          type: "string"
        },
        tabTextOrientation: {
          value: "horizontal",
          allowedValues: ["horizontal", "vertical"],
          type: "string"
        },
        layout: {
          value: null,
          type: "any"
        }
      };
    }
  }, {
    key: "listeners",
    get: function get() {
      return {
        "tabsElement.blur": "_tabsFocusHandler",
        "tabsElement.change": "_tabsChangeHandler",
        "tabsElement.focus": "_tabsFocusHandler",
        "autoHideWindow.close": "_autoHideWindowCloseHandler",
        "autoHideWindow.open": "_autoHideWindowOpenHandler"
      };
    }
  }, {
    key: "requires",
    get: function get() {
      return {
        "Smart.Tabs": "smart.tabs.js"
      };
    }
  }]);

  return _class124;
}(Smart.Window)), Smart("smart-wait-window",
/*#__PURE__*/
function (_Smart$ProgressWindow) {
  "use strict";

  _inherits(_class125, _Smart$ProgressWindow);

  function _class125() {
    _classCallCheck(this, _class125);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class125).apply(this, arguments));
  }

  _createClass(_class125, [{
    key: "template",
    value: function template() {
      return "<div id=\"container\">\n                    <div id=\"headerSection\" class=\"smart-header-section\" role=\"heading\" aria-level=\"1\">\n                        <div id=\"header\" class=\"smart-header\">[[label]]</div>\n                        <div id=\"buttonsContainer\" class=\"smart-buttons-container\">\n                            <smart-button id=\"closeButton\" class=\"smart-close-button\" animation=\"[[animation]]\" theme=\"[[theme]]\" aria-label=\"Close\"></smart-button>\n                        </div>\n                    </div>\n                    <div class=\"smart-content\">\n                        <content></content>\n                        <smart-progress-bar id=\"progressBar\" animation=\"[[animation]]\" indeterminate theme=\"[[theme]]\"></smart-progress-bar>\n                    </div>\n                    <div id=\"footer\" class=\"smart-footer\"></div>\n                </div>";
    }
  }, {
    key: "_keyDownHandler",
    value: function _keyDownHandler(e) {
      function t() {
        i._dragDetails && (i._dragDetails.started = !1), i.$.removeClass("no-transition");
      }

      var i = this;

      if (delete i._changingFocus, !(i.disabled || i._dragDetails && i._dragDetails.started)) {
        var _a691 = i.shadowRoot || i._windowParent.element.getRootNode() ? i._windowParent.element.getRootNode().activeElement : document.activeElement;

        e.stopPropagation();

        var _n524 = "ArrowDown" === e.key || "ArrowRight" === e.key ? 10 : -10;

        switch (i.$.removeClass("no-transition"), e.key) {
          case "ArrowUp":
          case "ArrowDown":
            if (_a691 !== i) return;
            if (e.preventDefault(), e.altKey) return "ArrowUp" === e.key ? i.maximize() : i.restore(), void t();
            if (i.$.addClass("no-transition"), e.ctrlKey) return i._resize("bottom", _n524), void t();

            i._drag(_n524, "vertical");

            break;

          case "ArrowLeft":
          case "ArrowRight":
            if (_a691 !== i) return;
            if (e.preventDefault(), i.$.addClass("no-transition"), e.ctrlKey) return i._resize("right", _n524), void t();

            i._drag(_n524, "horizontal");

            break;

          case "Tab":
            i.opened && i.modal && (i._changingFocus = !0);
            break;

          case "Enter":
          case " ":
            {
              var _t1030;

              if (i.shadowRoot || i.isInShadowDOM ? (_t1030 = e.composedPath()[0], i._buttonPressed = _t1030.getRootNode().host) : (_t1030 = e.target.closest && e.target.closest("smart-button"), i._buttonPressed = _t1030), !_t1030) return;
              i._isWindowButton(_t1030), delete i._buttonPressed;
              break;
            }
        }

        t();
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        headerButtons: {
          value: [],
          type: "array"
        },
        disableSnap: {
          value: !0,
          readOnly: !0,
          type: "boolean"
        },
        modal: {
          value: !0,
          readOnly: !0,
          type: "boolean",
          defaultReflectToAttribute: !0
        },
        pinned: {
          value: !0,
          type: "boolean",
          readOnly: !0
        }
      };
    }
  }]);

  return _class125;
}(Smart.ProgressWindow));